
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("kFGm5", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");

var $ee7Ev = parcelRequire("ee7Ev");

var $3zPPS = parcelRequire("3zPPS");

var $4bGgA = parcelRequire("4bGgA");

var $i31gq = parcelRequire("i31gq");

var $8BG5F = parcelRequire("8BG5F");

var $224h2 = parcelRequire("224h2");

var $5YL8y = parcelRequire("5YL8y");
/** Used to compose bitmasks for cloning. */ var $f0c87dd638da6507$var$CLONE_DEEP_FLAG = 1, $f0c87dd638da6507$var$CLONE_FLAT_FLAG = 2, $f0c87dd638da6507$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $f0c87dd638da6507$var$omit = $224h2(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $kJvGp(paths, function(path) {
        path = $4bGgA(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $i31gq(object, $5YL8y(object), result);
    if (isDeep) result = $ee7Ev(result, $f0c87dd638da6507$var$CLONE_DEEP_FLAG | $f0c87dd638da6507$var$CLONE_FLAT_FLAG | $f0c87dd638da6507$var$CLONE_SYMBOLS_FLAG, $8BG5F);
    var length = paths.length;
    while(length--)$3zPPS(result, paths[length]);
    return result;
});
module.exports = $f0c87dd638da6507$var$omit;

});
parcelRegister("3zPPS", function(module, exports) {

var $4bGgA = parcelRequire("4bGgA");

var $iTvqy = parcelRequire("iTvqy");

var $2wKO3 = parcelRequire("2wKO3");

var $cNyDu = parcelRequire("cNyDu");
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $29acd9759e1173c0$var$baseUnset(object, path) {
    path = $4bGgA(path, object);
    object = $2wKO3(object, path);
    return object == null || delete object[$cNyDu($iTvqy(path))];
}
module.exports = $29acd9759e1173c0$var$baseUnset;

});
parcelRegister("2wKO3", function(module, exports) {

var $dS3e6 = parcelRequire("dS3e6");

var $jADKY = parcelRequire("jADKY");
/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $1d72e0aabaa913d7$var$parent(object, path) {
    return path.length < 2 ? object : $dS3e6(object, $jADKY(path, 0, -1));
}
module.exports = $1d72e0aabaa913d7$var$parent;

});


parcelRegister("8BG5F", function(module, exports) {

var $jtsd5 = parcelRequire("jtsd5");
/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $64426db23baa732e$var$customOmitClone(value) {
    return $jtsd5(value) ? undefined : value;
}
module.exports = $64426db23baa732e$var$customOmitClone;

});


parcelRegister("8dloj", function(module, exports) {

var $7Smv0 = parcelRequire("7Smv0");

var $224h2 = parcelRequire("224h2");
/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $5fb02174d73b0468$var$pick = $224h2(function(object, paths) {
    return object == null ? {} : $7Smv0(object, paths);
});
module.exports = $5fb02174d73b0468$var$pick;

});
parcelRegister("7Smv0", function(module, exports) {

var $h5G5y = parcelRequire("h5G5y");

var $cj1vT = parcelRequire("cj1vT");
/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $5bbf076b50457091$var$basePick(object, paths) {
    return $h5G5y(object, paths, function(value, path) {
        return $cj1vT(object, path);
    });
}
module.exports = $5bbf076b50457091$var$basePick;

});


parcelRegister("gpO36", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $bf35cdd4cc1c7094$export$882461b6382ed46c, (v) => $bf35cdd4cc1c7094$export$882461b6382ed46c = v);
var $bf35cdd4cc1c7094$export$882461b6382ed46c;
var $bf35cdd4cc1c7094$export$757ceba2d55c277e;
'use strict';

var $lEfVV = parcelRequire("lEfVV");
var $bf35cdd4cc1c7094$var$i;
$bf35cdd4cc1c7094$export$882461b6382ed46c = $lEfVV.createRoot;
$bf35cdd4cc1c7094$export$757ceba2d55c277e = $lEfVV.hydrateRoot;

});

parcelRegister("9lmTX", function(module, exports) {

$parcel$export(module.exports, "default", () => $a22cac565d88251d$export$2e2bcd8739ae039);

var $3FyZ4 = parcelRequire("3FyZ4");

var $6WXNs = parcelRequire("6WXNs");
var $eIp1n = parcelRequire("eIp1n");
const $a22cac565d88251d$var$transformApplication = (application)=>{
    switch(application){
        case 0, $eIp1n.JIRA_SOFTWARE:
            return 'jira-software';
        case 0, $eIp1n.JIRA_PRODUCT_DISCOVERY:
            return 'jira-product-discovery';
        case 0, $eIp1n.JIRA_CORE:
            return 'jira-core';
        case 0, $eIp1n.JIRA_SERVICE_DESK:
            return 'jira-servicedesk';
        case 0, $eIp1n.JIRA_PORTFOLIO:
            return 'jira-portfolio';
        default:
            return 'unknown';
    }
};
const $a22cac565d88251d$var$transformEdition = (edition)=>{
    switch(edition){
        case 0, $6WXNs.FREE_EDITION:
            return 'jedi';
        case 0, $6WXNs.STANDARD_EDITION:
            return 'standard';
        case 0, $6WXNs.PREMIUM_EDITION:
            return 'premium';
        case 0, $6WXNs.UNLICENSED:
            return 'unlicensed';
        default:
            return 'unknown';
    }
};
const $a22cac565d88251d$var$transformAction = (action, wasExperienceSuccesful)=>{
    if (action !== undefined) return action;
    return wasExperienceSuccesful ? 'taskSuccess' : 'taskFail';
};
const $a22cac565d88251d$var$createAnalyticsEvent = ({ experience: experience, wasExperienceSuccesful: wasExperienceSuccesful, action: action, location: location, field: field, hasEdit: hasEdit, analyticsSource: analyticsSource, application: application, edition: edition, additionalAttributes: additionalAttributes })=>({
        source: 'ui',
        action: $a22cac565d88251d$var$transformAction(action, wasExperienceSuccesful),
        actionSubject: 'ui',
        attributes: {
            ...additionalAttributes,
            task: experience,
            // @ts-expect-error - TS2698 - Spread types may only be created from object types.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ...location ? {
                reason: location
            } : {},
            // @ts-expect-error - TS2698 - Spread types may only be created from object types.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ...field ? {
                field: field
            } : {},
            // @ts-expect-error - TS2698 - Spread types may only be created from object types.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ...typeof hasEdit === 'boolean' ? {
                hasEdit: hasEdit
            } : {},
            analyticsSource: analyticsSource,
            application: $a22cac565d88251d$var$transformApplication(application),
            edition: $a22cac565d88251d$var$transformEdition(edition)
        }
    });
var /**
 * @param {String} experienceDescription.experience
 * @param {Boolean} experienceDescription.wasExperienceSuccesful - Deprecated: Instead set `action` to `taskSuccess` (previously `true`), `taskFail` (previously `false`) or `taskAbort`
 * @param {Action} experienceDescription.action
 * @param {String} experienceDescription.location
 * @param {String} experienceDescription.field
 * @param {String} experienceDescription.hasEdit
 * @param {String} experienceDescription.analyticsSource
 * @param {String} experienceDescription.application
 * @param {Application} experienceDescription.edition
 * @param {ApplicationEdition} experienceDescription.additionalAttributes
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$a22cac565d88251d$export$2e2bcd8739ae039 = (experienceDescription)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        const event = $a22cac565d88251d$var$createAnalyticsEvent(experienceDescription);
        const clientInstance = client.getInstance();
        clientInstance.sendOperationalEvent(event);
    });
};

});

parcelRegister("gXEQH", function(module, exports) {

$parcel$export(module.exports, "routeAnalyticsAttributes", () => $d518287b36cbf350$export$c71778b3a4356b04);

var $keguF = parcelRequire("keguF");

var $77Wva = parcelRequire("77Wva");
const $d518287b36cbf350$export$c71778b3a4356b04 = Object.defineProperties({}, {
    routeName: {
        enumerable: true,
        get: (0, $keguF.getRouteName)
    },
    userLocation: {
        enumerable: true,
        get: (0, $keguF.getUserLocation)
    },
    previousSubProduct: {
        enumerable: true,
        get: (0, $keguF.getPreviousSubProduct)
    },
    isProjectAdmin: {
        enumerable: true,
        get: (0, $77Wva.getIsProjectAdmin)
    }
});

});
parcelRegister("77Wva", function(module, exports) {

$parcel$export(module.exports, "getIsProjectAdmin", () => $6b9122e612958aea$export$34ff06260ad17f2b);
$parcel$export(module.exports, "setIsProjectAdmin", () => $6b9122e612958aea$export$d53e6d79d3fa5f31);
let $6b9122e612958aea$var$projectAdmin = null;
const $6b9122e612958aea$export$34ff06260ad17f2b = ()=>{
    // Initialised as null, this likely means we aren't in a
    // project route and the listener hasn't been rendered
    if ($6b9122e612958aea$var$projectAdmin == null || !$6b9122e612958aea$var$projectAdmin.loading && $6b9122e612958aea$var$projectAdmin.isProjectAdmin == null) return 'UNKNOWN';
    if ($6b9122e612958aea$var$projectAdmin.loading === true) return 'LOADING';
    return Boolean($6b9122e612958aea$var$projectAdmin.isProjectAdmin);
};
const $6b9122e612958aea$export$d53e6d79d3fa5f31 = (projectAdminState)=>{
    $6b9122e612958aea$var$projectAdmin = projectAdminState;
};

});


parcelRegister("80E03", function(module, exports) {

var $fZS6K = parcelRequire("fZS6K");

if (!$parcel$global._IS_JIRA_GLOBAL_SIDE_EFFECT_INIT_) {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    (parcelRequire("kQSGw"));
    const isDevMode = false;
    (0, $fZS6K.default).devtools = isDevMode && (()=>({
            serialize: {
                // @ts-expect-error - TS7006 - Parameter 'key' implicitly has an 'any' type. | TS7006 - Parameter 'value' implicitly has an 'any' type.
                replacer: (key, value)=>value instanceof HTMLElement ? {
                        data: {
                            tagName: value.tagName,
                            className: value.className,
                            id: value.id,
                            __SANITIZED__: true
                        },
                        __serializedType__: 'HTMLElement'
                    } : value
            }
        }));
    (0, $fZS6K.default).batchUpdates = !false;
    Object.freeze((0, $fZS6K.default));
    $parcel$global._IS_JIRA_GLOBAL_SIDE_EFFECT_INIT_ = true;
}

});
parcelRegister("kQSGw", function(module, exports) {
const $f2e3153aecef516a$var$style = document.createElement('style');
$f2e3153aecef516a$var$style.textContent = 'html,body,p,div,h1,h2,h3,h4,h5,h6,ul,ol,dl,img,pre,form,fieldset{margin:0;padding:0}img,fieldset{border:0}body,html{width:100%;height:100%}body{background-color:var(--ds-surface,#fff);color:var(--ds-text,#172b4d);font:var(--ds-font-body,normal 400 14px/1.42857 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);-ms-overflow-style:-ms-autohiding-scrollbar;-webkit-text-decoration-skip-ink:auto;text-decoration-skip-ink:auto}p,ul,ol,dl,h1,h2,h3,h4,h5,h6,blockquote,pre,form,table{margin:var(--ds-space-150,12px)0 0 0}a{color:var(--ds-link,#0052cc);text-decoration:none}a:hover{color:var(--ds-link,#0065ff);text-decoration:underline}a:active{color:var(--ds-link-pressed,#0747a6)}a:focus-visible{outline:var(--ds-border-width-outline,2px)solid var(--ds-border-focused,#2684ff);outline-offset:var(--ds-space-025,2px)}@supports not selector(*:focus-visible){a:focus{outline:var(--ds-border-width-outline,2px)solid var(--ds-border-focused,#4c9aff);outline-offset:var(--ds-space-025,2px)}}h1{font:var(--ds-font-heading-xlarge,600 2.07143em/1.10345 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.01em;color:var(--ds-text);margin-top:var(--ds-space-500)}h2{font:var(--ds-font-heading-large,500 1.71429em/1.16667 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.01em;color:var(--ds-text);margin-top:var(--ds-space-500)}h3{font:var(--ds-font-heading-medium,500 1.42857em/1.2 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.008em;color:var(--ds-text);margin-top:28px}h4{font:var(--ds-font-heading-small,600 1.14286em/1.25 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.006em;color:var(--ds-text);margin-top:var(--ds-space-300)}h5{font:var(--ds-font-heading-xsmall,600 1em/1.14286 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.003em;color:var(--ds-text);margin-top:var(--ds-space-200)}h6{font:var(--ds-font-heading-xxsmall,600 .857143em/1.33333 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-250);text-transform:uppercase}ul,ol,dl{padding-left:var(--ds-space-500,40px)}dd,dd+dt,li+li,ul ul:not(:first-child),ol ul:not(:first-child),ul ol:not(:first-child),ol ol:not(:first-child){margin-top:var(--ds-space-050,4px)}p:first-child,ul:first-child,ol:first-child,dl:first-child,h1:first-child,h2:first-child,h3:first-child,h4:first-child,h5:first-child,h6:first-child,blockquote:first-child,pre:first-child,form:first-child,table:first-child{margin-top:0}blockquote,q{color:inherit}blockquote{padding-left:var(--ds-space-500,40px);border:none}[dir=rtl] blockquote{padding-left:0;padding-right:var(--ds-space-500,40px)}blockquote:before,q:before{content:"\u201C"}blockquote:after,q:after{content:"\u201D"}blockquote:before{float:left;text-align:right;width:1em;margin-left:-1em}[dir=rtl] blockquote:before{float:right;text-align:left;margin-right:-1em}blockquote>:last-child{display:inline-block}small{font-size:.785714em;font-style:inherit;color:var(--ds-text-subtlest,var(--ds-text-subtlest,#6b778c));line-height:1.45455;font-weight:var(--ds-font-weight-bold,700);margin-top:16px;font-weight:400}code,kbd{font-family:var(--ds-font-family-code,"SFMono-Medium","SF Mono","Segoe UI Mono","Roboto Mono","Ubuntu Mono",Menlo,Consolas,Courier,monospace)}var,address,dfn,cite{font-style:italic}abbr{border-bottom:1px var(--ds-border,#ccc)dotted;cursor:help}@supports (color-scheme:dark) and (color-scheme:light){[data-color-mode=light]{--lightningcss-light:initial;--lightningcss-dark: ;color-scheme:light}[data-color-mode=dark]{--lightningcss-light: ;--lightningcss-dark:initial;color-scheme:dark}}table{border-collapse:collapse;width:100%}thead,tbody,tfoot{border-bottom:2px solid var(--ds-border,#dfe1e6)}td,th{padding:var(--ds-space-050,4px)var(--ds-space-100,8px);text-align:left;border:none}th{vertical-align:top}td:first-child,th:first-child{padding-left:0}td:last-child,th:last-child{padding-right:0}caption{font:var(--ds-font-heading-medium,500 1.42857em/1.2 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.008em;color:var(--ds-text);margin-top:28px;margin-bottom:var(--ds-space-100,8px);text-align:left}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section{display:block}@-moz-document url-prefix(){img{font-size:0}img:-moz-broken{font-size:inherit}}button{font-family:inherit}.assistive{clip:rect(1px,1px,1px,1px)!important;white-space:nowrap!important;border:0!important;width:1px!important;height:1px!important;padding:0!important;position:absolute!important;overflow:hidden!important}';
document.querySelector('head').appendChild($f2e3153aecef516a$var$style);

});


parcelRegister("8R80x", function(module, exports) {

$parcel$export(module.exports, "getPlaceholdersFromHTML", () => $c9ae2df088b0cf45$export$9e9f35acc3af3a9a);
$parcel$export(module.exports, "EntryPointPlaceholderContext", () => $c9ae2df088b0cf45$export$b5b377bb81310c48);
$parcel$export(module.exports, "EntryPointPlaceholder", () => $c9ae2df088b0cf45$export$db2828f683d11042);

var $eUqFw = parcelRequire("eUqFw");

var $gGtKh = parcelRequire("gGtKh");
function $c9ae2df088b0cf45$export$9e9f35acc3af3a9a() {
    const placeholders = document.querySelectorAll('[data-ep-placeholder-id]');
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return new Map(Array.from(placeholders, (el)=>[
            el.dataset.epPlaceholderId,
            el.innerHTML
        ]));
}
const $c9ae2df088b0cf45$export$b5b377bb81310c48 = /*#__PURE__*/ (0, $eUqFw.createContext)(new Map());
function $c9ae2df088b0cf45$export$db2828f683d11042({ children: children, entryPoint: entryPoint, fallback: originalFallback, name: name, ...placeholderProps }) {
    const { root: root } = entryPoint;
    const hasMounted = (0, $eUqFw.useRef)(false);
    const placeholders = (0, $eUqFw.useContext)($c9ae2df088b0cf45$export$b5b377bb81310c48);
    const ssrFallback = placeholders.get(name);
    const [fallback, setFallback] = (0, $eUqFw.useState)(!ssrFallback || root.getModuleIfRequired() ? originalFallback : // eslint-disable-next-line react/no-danger
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        dangerouslySetInnerHTML: {
            __html: ssrFallback
        },
        "data-ep-placeholder-id": name
    }));
    const lastOriginalFallback = (0, $eUqFw.useRef)(originalFallback);
    lastOriginalFallback.current = originalFallback;
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (hasMounted.current && placeholders.has(name)) {
            placeholders.delete(name);
            setFallback(lastOriginalFallback.current);
        }
    }, [
        entryPoint,
        name,
        placeholders,
        setFallback
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const onComplete = ()=>{
            if (placeholders.has(name)) placeholders.delete(name);
            setFallback(lastOriginalFallback.current);
        };
        const unsubscribe = root.onComplete(onComplete, onComplete);
        return ()=>{
            unsubscribe();
            onComplete();
        };
    }, [
        name,
        placeholders,
        root
    ]);
    (0, $eUqFw.useEffect)(()=>{
        hasMounted.current = true;
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        fallback: fallback,
        name: name,
        ...placeholderProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-ep-placeholder-id": name
    }, children));
}

});

parcelRegister("eI5EY", function(module, exports) {

$parcel$export(module.exports, "fg", () => $010af7f17578702e$export$b40ec24ac8275656);

var $8tM2T = parcelRequire("8tM2T");

var $9bn72 = parcelRequire("9bn72");

var $3WQZN = parcelRequire("3WQZN");
const $010af7f17578702e$export$b40ec24ac8275656 = (gateName)=>{
    // Handle vendorless scripts use of gates
    (0, $9bn72.UNSAFE_initIfNeeded)();
    const value = (0, $8tM2T.default).checkGate(gateName);
    (0, $3WQZN.addFeatureFlagAccessed)(gateName, value);
    return value;
};

});

parcelRegister("6U1dF", function(module, exports) {

$parcel$export(module.exports, "NonCritical", () => $7c939f739e44c405$export$20fd89b1bf707b1a);
$parcel$export(module.exports, "default", () => $7c939f739e44c405$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $h3mHU = parcelRequire("h3mHU");
const $7c939f739e44c405$export$83d969795398ec56 = ({ children: children, timerThreshold: timerThreshold })=>{
    const [{ isReady: isReady }] = (0, $h3mHU.useSpaStatePageReady)();
    const [isFirstRun, setFirstRun] = (0, $eUqFw.useState)(true);
    const [hasThresholdTimerExpired, setHasThresholdTimerExpired] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (timerThreshold != null) setTimeout(()=>{
            setHasThresholdTimerExpired(true);
        }, timerThreshold);
    }, [
        timerThreshold
    ]);
    if (!isFirstRun || isReady || hasThresholdTimerExpired) {
        isFirstRun && setFirstRun(false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    }
    return null;
};
const $7c939f739e44c405$export$5b2f4b62d18632 = ({ id: id = 'non-critical-with-timer', teamName: teamName, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: id,
        teamName: teamName,
        packageName: "jiraPlatformNonCritical",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7c939f739e44c405$export$83d969795398ec56, props));
/**
 * Delays rendering its children until the page is deemed ready, optimizing for a smoother initial load. Suitable for content that is not immediately necessary.
 */ const $7c939f739e44c405$var$NonCriticalComponent = (props)=>{
    const [{ isReady: isReady }] = (0, $h3mHU.useSpaStatePageReady)();
    const [isFirstRun, setFirstRun] = (0, $eUqFw.useState)(true);
    if (!isFirstRun || isReady) {
        isFirstRun && setFirstRun(false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children);
    }
    return null;
};
const $7c939f739e44c405$export$20fd89b1bf707b1a = ({ id: id = 'non-critical', teamName: teamName, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: id,
        teamName: teamName,
        packageName: "jiraPlatformNonCritical",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7c939f739e44c405$var$NonCriticalComponent, props));
var $7c939f739e44c405$export$2e2bcd8739ae039 = $7c939f739e44c405$var$NonCriticalComponent;

});
parcelRegister("h3mHU", function(module, exports) {

$parcel$export(module.exports, "useSpaStatePageReady", () => $76cb153a8803a558$export$ea2491906b753456);
$parcel$export(module.exports, "SpaStatePageReady", () => $76cb153a8803a558$export$c34439f945fccbdf);
$parcel$export(module.exports, "SpaStatePageReadyOnUpdate", () => $76cb153a8803a558$export$41e70078eeddaddc);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");

var $3viaK = parcelRequire("3viaK");

var $lcJyp = parcelRequire("lcJyp");

var $cfLkw = parcelRequire("cfLkw");
const $76cb153a8803a558$export$e6897aa59ee7aee5 = ({ currentPage: currentPage })=>{
    const { apps: apps } = currentPage;
    const appIds = Object.keys(apps);
    return {
        isReady: appIds.length ? appIds.every((id)=>apps[id].endTime || apps[id].timeoutTime) : false
    };
};
const $76cb153a8803a558$export$ea2491906b753456 = (0, $ggKAj.createHook)((0, $cfLkw.default), {
    selector: $76cb153a8803a558$export$e6897aa59ee7aee5
});
const $76cb153a8803a558$export$c34439f945fccbdf = ()=>/* TODO - this should be using only the actions subscriber not state+actions subscriber */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lcJyp.SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
            op: setAppReady
        }));
const $76cb153a8803a558$export$41e70078eeddaddc = ({ comparer: comparer })=>/* TODO - this should be using only the actions subscriber not state+actions subscriber */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lcJyp.SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
            op: setAppReady,
            args: comparer
        }));

});
parcelRegister("3viaK", function(module, exports) {

$parcel$export(module.exports, "default", () => $114bcd9b637bc682$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");
// eslint-disable-next-line jira/react/no-class-components
class $114bcd9b637bc682$var$OpTrigger extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            args: []
        };
    }
    componentDidMount() {
        this.props.op(...this.props.args);
    }
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(this.props.args, nextProps.args);
    }
    componentDidUpdate() {
        this.props.op(...this.props.args);
    }
    render() {
        return null;
    }
}
var $114bcd9b637bc682$export$2e2bcd8739ae039 = $114bcd9b637bc682$var$OpTrigger;

});

parcelRegister("lcJyp", function(module, exports) {

$parcel$export(module.exports, "SpaStateSubscriber", () => $847fac6342ee5df8$export$fd52daf2a3c1ec68);
$parcel$export(module.exports, "SpaStateActionsSubscriber", () => $847fac6342ee5df8$export$3dfa91988c213fbc);
$parcel$export(module.exports, "useSpaState", () => $847fac6342ee5df8$export$a57865516f6345d1);
$parcel$export(module.exports, "useSpaStateActions", () => $847fac6342ee5df8$export$b134752525935b78);

var $ggKAj = parcelRequire("ggKAj");
var $dYfll = parcelRequire("dYfll");

var $cfLkw = parcelRequire("cfLkw");
const $847fac6342ee5df8$export$fd52daf2a3c1ec68 = (0, $dYfll.createSubscriber)((0, $cfLkw.default));
const $847fac6342ee5df8$export$3dfa91988c213fbc = (0, $dYfll.createSubscriber)((0, $cfLkw.default), {
    selector: null
});
const $847fac6342ee5df8$export$a57865516f6345d1 = (0, $ggKAj.createHook)((0, $cfLkw.default));
const $847fac6342ee5df8$export$b134752525935b78 = (0, $ggKAj.createHook)((0, $cfLkw.default), {
    selector: null
});

});
parcelRegister("cfLkw", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e76bb655f4dbc8c$export$2e2bcd8739ae039);

var $a61MH = parcelRequire("a61MH");

var $hompL = parcelRequire("hompL");

var $a2pDC = parcelRequire("a2pDC");
const $7e76bb655f4dbc8c$export$d4c72bab9d6cc13a = {
    transitionCheckTimestamp: -1,
    currentPage: {
        uuid: false ? '' : (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
        startTime: typeof performance !== 'undefined' && performance.timing !== undefined && performance.timing.navigationStart || 0,
        apps: {},
        userLocation: ''
    },
    visitedPages: [],
    navigation: {
        isCollapsed: false,
        viewId: 'noView',
        viewType: '',
        projectType: null,
        isInitialEventSent: false,
        pageId: null,
        nextViewId: ''
    }
};
const $7e76bb655f4dbc8c$var$store = (0, $a61MH.createStore)({
    name: 'spa-state',
    initialState: $7e76bb655f4dbc8c$export$d4c72bab9d6cc13a,
    actions: $a2pDC
});
var $7e76bb655f4dbc8c$export$2e2bcd8739ae039 = $7e76bb655f4dbc8c$var$store;

});
parcelRegister("a2pDC", function(module, exports) {

$parcel$export(module.exports, "setAppStart", () => (parcelRequire("gKuw7")).setAppStart);
$parcel$export(module.exports, "setAppReady", () => (parcelRequire("gKuw7")).setAppReady);
$parcel$export(module.exports, "setAppStartWithAppId", () => (parcelRequire("gKuw7")).setAppStartWithAppId);
$parcel$export(module.exports, "setAppReadyWithAppId", () => (parcelRequire("gKuw7")).setAppReadyWithAppId);
$parcel$export(module.exports, "setAppErrorReady", () => (parcelRequire("gKuw7")).setAppErrorReady);
$parcel$export(module.exports, "setTimeoutReady", () => (parcelRequire("gKuw7")).setTimeoutReady);
$parcel$export(module.exports, "setTimeoutReadyWithAppId", () => (parcelRequire("gKuw7")).setTimeoutReadyWithAppId);
$parcel$export(module.exports, "resetCurrentPage", () => (parcelRequire("gKuw7")).resetCurrentPage);
$parcel$export(module.exports, "setResourceMetrics", () => (parcelRequire("gKuw7")).setResourceMetrics);

var $gKuw7 = parcelRequire("gKuw7");

});
parcelRegister("gKuw7", function(module, exports) {

$parcel$export(module.exports, "resetCurrentPage", () => $1354b0144a8be88b$export$5639685a1fb81722);
$parcel$export(module.exports, "setTimeoutReadyWithAppId", () => $1354b0144a8be88b$export$8a98548dad2fa97b);
$parcel$export(module.exports, "setTimeoutReady", () => $1354b0144a8be88b$export$b9cc4378ea785421);
$parcel$export(module.exports, "setAppStartWithAppId", () => $1354b0144a8be88b$export$9d528722f2ff2999);
$parcel$export(module.exports, "setAppStart", () => $1354b0144a8be88b$export$71192061050856ad);
$parcel$export(module.exports, "setAppReadyWithAppId", () => $1354b0144a8be88b$export$6a25429a42d30f9a);
$parcel$export(module.exports, "setAppReady", () => $1354b0144a8be88b$export$fc59cc4ed9bba7cd);
$parcel$export(module.exports, "setAppErrorReady", () => $1354b0144a8be88b$export$aff63c1e41443b6a);
$parcel$export(module.exports, "setResourceMetrics", () => $1354b0144a8be88b$export$8ad155d489dcf34d);

var $hompL = parcelRequire("hompL");

var $acbV3 = parcelRequire("acbV3");

var $1ybV0 = parcelRequire("1ybV0");

var $keguF = parcelRequire("keguF");

var $4nnPJ = parcelRequire("4nnPJ");

var $ULuRM = parcelRequire("ULuRM");
const $1354b0144a8be88b$export$7bd623b29ec8e1eb = 10000;
const $1354b0144a8be88b$export$5639685a1fb81722 = (nextRouteUfoName, nextRouteName)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        performance.mark('resetCurrentPage');
        (0, $acbV3.browserMetrics).startPageLoad({
            isInitial: false
        });
        (0, $ULuRM.default)(nextRouteUfoName, nextRouteName);
        if ((0, $1ybV0.ff)('uip.ufo')) {
            (0, $4nnPJ.GlobalPageLoadExperience).abort({
                force: true
            });
            (0, $4nnPJ.GlobalPageLoadExperience).startPageLoad('UNKNOWN', false);
        }
        if (currentPage && currentPage.apps && Object.keys(currentPage.apps).length > 0) setState({
            currentPage: {
                uuid: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
                apps: {},
                startTime: Date.now(),
                userLocation: ''
            },
            visitedPages: [
                ...currentState.visitedPages,
                {
                    ...currentState.currentPage
                }
            ],
            transitionCheckTimestamp: 0
        });
    };
const $1354b0144a8be88b$export$8a98548dad2fa97b = (appId, timeoutTime = Date.now())=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && !(currentPage.apps[appId] && currentPage.apps[appId].timeoutTime)) {
            const apps = {
                ...currentPage.apps
            };
            if (apps[appId] && apps[appId].expectingTimeout) {
                const updatedPage = {
                    ...currentPage,
                    apps: {
                        ...apps,
                        [appId]: {
                            ...apps[appId],
                            timeoutTime: timeoutTime,
                            expectingTimeout: 0
                        }
                    }
                };
                setState({
                    currentPage: updatedPage
                });
            }
        }
    };
const $1354b0144a8be88b$export$b9cc4378ea785421 = (timeoutTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($1354b0144a8be88b$export$8a98548dad2fa97b(appId, timeoutTime));
    };
const $1354b0144a8be88b$export$9d528722f2ff2999 = (appId, startTime = Date.now())=>({ dispatch: dispatch, getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && !(currentPage.apps[appId] && currentPage.apps[appId].startTime)) {
            const timeoutId = setTimeout(()=>{
                dispatch($1354b0144a8be88b$export$8a98548dad2fa97b(appId));
            }, $1354b0144a8be88b$export$7bd623b29ec8e1eb);
            const updatedPage = {
                ...currentPage,
                userLocation: (0, $keguF.getUserLocation)(),
                apps: {
                    ...currentPage.apps,
                    [appId]: {
                        startTime: startTime,
                        expectingTimeout: timeoutId
                    }
                }
            };
            setState({
                // @ts-expect-error - TS2322 - Type '{ userLocation: string; apps: { [x: string]: AppState | { startTime: number; expectingTimeout: NodeJS.Timeout; }; }; uuid: string; startTime: number; resources?: ResourceMetrics[] | undefined; }' is not assignable to type 'PageTiming'.
                currentPage: updatedPage
            });
        }
    };
const $1354b0144a8be88b$export$71192061050856ad = (startTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($1354b0144a8be88b$export$9d528722f2ff2999(appId, startTime));
    };
const $1354b0144a8be88b$export$6a25429a42d30f9a = (appId, endTime = Date.now())=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && currentPage.apps[appId] && currentPage.apps[appId].endTime === undefined) {
            const apps = {
                ...currentPage.apps
            };
            // @ts-expect-error - TS2769 - No overload matches this call.
            clearTimeout(currentPage.apps[appId].expectingTimeout);
            const updatedPage = {
                ...currentPage,
                apps: {
                    ...apps,
                    [appId]: {
                        ...apps[appId],
                        endTime: endTime,
                        expectingTimeout: 0
                    }
                }
            };
            setState({
                currentPage: updatedPage
            });
        }
    };
const $1354b0144a8be88b$export$fc59cc4ed9bba7cd = (endTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($1354b0144a8be88b$export$6a25429a42d30f9a(appId, endTime));
    };
const $1354b0144a8be88b$export$aff63c1e41443b6a = ()=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && currentPage.apps && Object.keys(currentPage.apps).length > 0) {
            const updatedPage = {
                ...currentPage,
                apps: {
                    'error-page': {
                        endTime: Date.now()
                    }
                }
            };
            setState({
                currentPage: updatedPage
            });
        }
    };
const $1354b0144a8be88b$export$8ad155d489dcf34d = (resourceMetrics)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            currentPage: {
                ...currentState.currentPage,
                resources: [
                    ...currentState.currentPage.resources ? currentState.currentPage.resources : [],
                    resourceMetrics
                ]
            }
        });
    };

});






parcelRegister("ibSOG", function(module, exports) {

$parcel$export(module.exports, "PageContainer", () => $ae84b0fa7dce8133$export$5f86df0ee0a255b5);

var $eUqFw = parcelRequire("eUqFw");

var $h97Af = parcelRequire("h97Af");

var $0cdA8 = parcelRequire("0cdA8");

var $bAQOb = parcelRequire("bAQOb");

var $b00xW = parcelRequire("b00xW");
var $cB0s9 = parcelRequire("cB0s9");

var $dWu0t = parcelRequire("dWu0t");

var $1GeZ8 = parcelRequire("1GeZ8");


var $8WuJm = parcelRequire("8WuJm");

var $bQiKj = parcelRequire("bQiKj");

var $2B87Z = parcelRequire("2B87Z");

var $69Ipc = parcelRequire("69Ipc");

var $5Wexj = parcelRequire("5Wexj");

var $jG5np = parcelRequire("jG5np");

var $kqXZB = parcelRequire("kqXZB");

var $l8xBK = parcelRequire("l8xBK");

var $eymfV = parcelRequire("eymfV");

var $4LQUt = parcelRequire("4LQUt");

var $fpQ73 = parcelRequire("fpQ73");

var $1cu0z = parcelRequire("1cu0z");
/* IMPORTANT:
 * When making any changes to the OLD component, please ensure that you also make the same changes to the
 * NEW component. The feature flag used is part of the Navigation Refresh work and we need to ensure that
 * we do not introduce tech debt for the roll-out by only updating the current component that is due to be
 * removed.
 *
 * If you have any concerns or questions please reach out to the #jira-navigation channel. Thanks!
 */ const $ae84b0fa7dce8133$var$PageContainerNew = ({ id: id, locale: locale, baseUrl: baseUrl, children: children, messages: messages, Router: Router, routerLinkComponent: routerLinkComponent })=>{
    const HorizontalNavComponent = (0, $dWu0t.useHorizontalNavComponent)();
    const pageContainerPerformanceTiming = (0, $eUqFw.useCallback)(()=>{
        (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)((0, $7688150c048b38d1$export$898b6208220685b0), (0, $7688150c048b38d1$export$e2bc63118050de32), (0, $7688150c048b38d1$export$59f83d43fe209319), true, false);
    }, []);
    const shouldFixMain = !!HorizontalNavComponent;
    let contentChildren = children;
    if (HorizontalNavComponent != null) contentChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqXZB.HorizontalNavWrapper), {
        navComponent: HorizontalNavComponent
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: (0, $7688150c048b38d1$export$e2bc63118050de32)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1cu0z.ThemeSetter), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jG5np.GlobalContainers), {
        id: id,
        locale: locale,
        baseUrl: baseUrl,
        messages: messages,
        Router: Router,
        routerLinkComponent: routerLinkComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: (0, $7688150c048b38d1$export$59f83d43fe209319),
        onSet: pageContainerPerformanceTiming
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "navigationNext"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1GeZ8.PageLayout), {
        skipLinksLabel: ""
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "banner",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $69Ipc.Banner), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "top-nav",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LQUt.TopNav), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "sidebar",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eymfV.Sidebar), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1GeZ8.Main), {
        isFixed: shouldFixMain
    }, contentChildren), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "right-sidebar",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l8xBK.RightSidebar), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        packageName: "jiraPageContainerV2",
        id: "layout-remote-state-updater",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cB0s9.LayoutRemoteStateUpdater), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5Wexj.GlobalComponents), {
        sharedGlobalComponents: (0, $bQiKj.sharedLayout).globalComponents
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b00xW.GlobalBottomRightCornerContainer), null))));
};
/**
 * Serves as a comprehensive layout manager, orchestrating the assembly of global containers,
 * navigation components, and performance metrics into a cohesive page structure. It enhances user
 * interface by conditionally incorporating additional UI elements and ensures a uniform
 * appearance and behavior across pages through global styling. Moreover, it facilitates
 * performance optimization and analytics integration for improved user experience and
 * insights.
 */ const $ae84b0fa7dce8133$var$PageContainerOld = ({ id: id, locale: locale, baseUrl: baseUrl, children: children, messages: messages, Router: Router, routerLinkComponent: routerLinkComponent })=>{
    const HorizontalNavComponent = (0, $dWu0t.useHorizontalNavComponent)();
    const pageContainerPerformanceTiming = (0, $eUqFw.useCallback)(()=>{
        (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)((0, $7688150c048b38d1$export$898b6208220685b0), (0, $7688150c048b38d1$export$e2bc63118050de32), (0, $7688150c048b38d1$export$59f83d43fe209319), true, false);
    }, []);
    let contentChildren = children;
    if (HorizontalNavComponent != null) contentChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqXZB.HorizontalNavWrapper), {
        navComponent: HorizontalNavComponent
    }, children);
    const panelContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fpQ73.FullHeight), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1GeZ8.PageLayout), {
        skipLinksLabel: ""
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "banner",
        packageName: "page-container",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $69Ipc.Banner), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "top-nav",
        packageName: "page-container",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LQUt.TopNav), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1GeZ8.LeftPanel), {
        width: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1GeZ8.Content), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "sidebar",
        packageName: "page-container",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eymfV.Sidebar), null)), contentChildren, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "right-sidebar",
        packageName: "page-container",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l8xBK.RightSidebar), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        packageName: "page-container",
        id: "layout-remote-state-updater",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cB0s9.LayoutRemoteStateUpdater), null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5Wexj.GlobalComponents), {
        sharedGlobalComponents: (0, $bQiKj.sharedLayout).globalComponents
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b00xW.GlobalBottomRightCornerContainer), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: (0, $7688150c048b38d1$export$e2bc63118050de32)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1cu0z.ThemeSetter), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jG5np.GlobalContainers), {
        id: id,
        locale: locale,
        baseUrl: baseUrl,
        messages: messages,
        Router: Router,
        routerLinkComponent: routerLinkComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: (0, $7688150c048b38d1$export$59f83d43fe209319),
        onSet: pageContainerPerformanceTiming
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "navigationNext"
    }, panelContent)));
};
const $ae84b0fa7dce8133$export$5f86df0ee0a255b5 = (0, $bAQOb.componentWithFF)('platform.atlassian.griffin-new-page-layout', $ae84b0fa7dce8133$var$PageContainerNew, $ae84b0fa7dce8133$var$PageContainerOld);

});
parcelRegister("b00xW", function(module, exports) {

$parcel$export(module.exports, "GlobalBottomRightCornerContainer", () => $50f1861a2ded8c40$export$715c8d5890c054bb);
$parcel$export(module.exports, "GlobalBottomRightCornerContainerProvider", () => $50f1861a2ded8c40$export$1e86e3484191597c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $jK1pm = parcelRequire("jK1pm");

var $bUi2Q = parcelRequire("bUi2Q");
var $71g00 = parcelRequire("71g00");

var $53ucm = parcelRequire("53ucm");
function $50f1861a2ded8c40$export$e112b78171de7a6({ bottomOffset: bottomOffset, rightOffset: rightOffset }) {
    const [{ width: width }] = (0, $53ucm.useDetailPanelWidth)();
    const rightSidebar = (0, $bUi2Q.useActiveRightSidebarState)();
    const { registerBottomRightCornerContainer: registerBottomRightCornerContainer } = (0, $71g00.useBottomRightCornerActions)();
    const isSidebarOpen = rightSidebar && !rightSidebar.isCollapsed && !rightSidebar.isMinimised;
    const rightSidebarWidth = isSidebarOpen ? rightSidebar.width : 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($50f1861a2ded8c40$var$StyledContainer, {
        ref: registerBottomRightCornerContainer,
        "data-testid": "layout-controller.ui.bottom-right-corner.container.styled-container",
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            right: `calc(${width + rightOffset + rightSidebarWidth}px + ${"var(--ds-space-300, 24px)"})`,
            bottom: `calc(${"var(--ds-space-300, 24px)"} + ${bottomOffset}px)`
        }
    });
}
const $50f1861a2ded8c40$export$715c8d5890c054bb = ({ bottomOffset: bottomOffset = 0, rightOffset: rightOffset = 0 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "bottom-right-corner-container",
        packageName: "jira-bottom-right-corner-controller"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($50f1861a2ded8c40$export$e112b78171de7a6, {
        bottomOffset: bottomOffset,
        rightOffset: rightOffset
    }));
const $50f1861a2ded8c40$export$1e86e3484191597c = ({ children: children })=>{
    const container = (0, $71g00.useBottomRightCornerContainer)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "global-bottom-right-corner"
    }, container && children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($50f1861a2ded8c40$export$715c8d5890c054bb, null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $50f1861a2ded8c40$var$StyledContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqsw1n9t _1e0c1txw _1pbyfjpv _1reoewfl _18m9ewfl _4cvresu3 _lcxvglyw",
            __cmplp.className
        ])
    });
});
$50f1861a2ded8c40$var$StyledContainer.displayName = 'StyledContainer';

});
parcelRegister("jK1pm", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6f009785aaee067$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $iWLL0 = parcelRequire("iWLL0");

var $5iuyH = parcelRequire("5iuyH");

var $fVaJL = parcelRequire("fVaJL");

var $232mI = parcelRequire("232mI");
/** A portion of the page we apply measurement to */ function $f6f009785aaee067$var$JiraUFOSegmentWrapper({ children: children }) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const interactionContext = (0, $5iuyH.useInteractionContext)();
    const relayProfilerContext = (0, $eUqFw.useMemo)(()=>({
            getInteractionContext: ()=>interactionContext,
            wrapPrepareQueryResource (cb) {
                return cb();
            },
            retainQuery (info) {
                this.getInteractionContext().retainQuery(info);
            }
        }), [
        interactionContext
    ]);
    const reactLooselyLazyContext = (0, $eUqFw.useMemo)(()=>{
        const moduleLoadingRequests = {};
        return {
            current: {
                getInteractionContext () {
                    return interactionContext;
                },
                onPreload (moduleId, _priority) {
                    this.getInteractionContext().addPreload((0, $fVaJL.extractModuleName)(moduleId), performance.now());
                },
                onLoadStart (info) {
                    const timeoutId = setTimeout(()=>{
                        delete moduleLoadingRequests[info.identifier];
                    }, 30000);
                    const request = {
                        start: performance.now(),
                        timeoutId: timeoutId
                    };
                    moduleLoadingRequests[info.identifier] = request;
                },
                onLoadComplete (info) {
                    const request = moduleLoadingRequests[info.identifier];
                    if (request) {
                        clearTimeout(request.timeoutId);
                        delete moduleLoadingRequests[info.identifier];
                        this.getInteractionContext()?.addLoad((0, $fVaJL.extractModuleName)(info.identifier), request.start, performance.now());
                    }
                },
                placeholderFallBackMounted (id, name, lazyWait) {
                    if (lazyWait) return;
                    this.getInteractionContext().addHoldByID(this.getInteractionContext().labelStack, id, name);
                },
                placeholderFallBackUnmounted (id, name, lazyWait) {
                    if (lazyWait) return;
                    this.getInteractionContext().removeHoldByID(this.getInteractionContext().labelStack, id, name);
                }
            }
        };
    }, [
        interactionContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iWLL0.ProfilerContext).Provider, {
        value: relayProfilerContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rh0R.ProfilerContext).Provider, {
        value: reactLooselyLazyContext
    }, children));
}
function $f6f009785aaee067$export$2e2bcd8739ae039({ name: segmentName, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $232mI.default), {
        name: segmentName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f6f009785aaee067$var$JiraUFOSegmentWrapper, null, children));
}

});

parcelRegister("bUi2Q", function(module, exports) {

$parcel$export(module.exports, "useActiveRightSidebarState", () => $09e77c9f3f7f26ec$export$ba763ab7661c3103);
$parcel$export(module.exports, "useRightSidebarState", () => $09e77c9f3f7f26ec$export$d1828e7f46a4960b);
$parcel$export(module.exports, "useRightSidebarController", () => $09e77c9f3f7f26ec$export$ebe5e907fb0bb63a);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");

var $hqpfO = parcelRequire("hqpfO");

var $53ucm = parcelRequire("53ucm");
const $09e77c9f3f7f26ec$var$useActiveRightSidebar = (0, $ggKAj.createHook)((0, $53ucm.layoutStore), {
    selector: (state)=>{
        const rightSidebarState = (0, $hqpfO.selectCurrentRightSidebar)(state.content.rightSidebar);
        if (!rightSidebarState) return null;
        return {
            ...rightSidebarState,
            shouldRender: !state.isChromeless
        };
    }
});
const $09e77c9f3f7f26ec$export$ba763ab7661c3103 = ()=>{
    const [rightSidebar] = $09e77c9f3f7f26ec$var$useActiveRightSidebar();
    return rightSidebar;
};
const $09e77c9f3f7f26ec$var$useRightSidebar = (0, $ggKAj.createHook)((0, $53ucm.layoutStore), {
    selector: (state)=>state.content.rightSidebar
});
const $09e77c9f3f7f26ec$export$d1828e7f46a4960b = ()=>{
    const [rightSidebarState] = $09e77c9f3f7f26ec$var$useRightSidebar();
    return rightSidebarState;
};
const $09e77c9f3f7f26ec$export$ebe5e907fb0bb63a = ()=>{
    const [, { setRightSidebarState: setRightSidebarState, openRightSidebar: openRightSidebar, closeRightSidebar: closeRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar, closeAllRightSidebar: closeAllRightSidebar, minimiseRightSidebar: minimiseRightSidebar }] = (0, $53ucm.useLayoutStoreActions)();
    return (0, $eUqFw.useMemo)(()=>({
            setRightSidebarState: setRightSidebarState,
            closeRightSidebar: closeRightSidebar,
            openRightSidebar: openRightSidebar,
            closeCurrentRightSidebar: closeCurrentRightSidebar,
            closeAllRightSidebar: closeAllRightSidebar,
            minimiseRightSidebar: minimiseRightSidebar
        }), [
        closeAllRightSidebar,
        closeCurrentRightSidebar,
        closeRightSidebar,
        openRightSidebar,
        setRightSidebarState,
        minimiseRightSidebar
    ]);
};

});
parcelRegister("hqpfO", function(module, exports) {

$parcel$export(module.exports, "selectCurrentRightSidebar", () => $bea3cfbec26c4bd1$export$57758d0cfaeec2c);
$parcel$export(module.exports, "setRightSidebarState", () => $bea3cfbec26c4bd1$export$f5584170a8c1db02);
$parcel$export(module.exports, "closeAllRightSidebar", () => $bea3cfbec26c4bd1$export$d91a6e55d52aa3e9);
$parcel$export(module.exports, "closeCurrentRightSidebar", () => $bea3cfbec26c4bd1$export$a9a5075d3d1b2165);
$parcel$export(module.exports, "closeRightSidebar", () => $bea3cfbec26c4bd1$export$d7149233c76efb32);
$parcel$export(module.exports, "minimiseRightSidebar", () => $bea3cfbec26c4bd1$export$4eedf7fa26a2749a);
$parcel$export(module.exports, "openRightSidebar", () => $bea3cfbec26c4bd1$export$c8dafe074328c4ca);

var $hTLlD = parcelRequire("hTLlD");
const $bea3cfbec26c4bd1$var$arrayMove = (array, oldIndex, newIndex)=>{
    const arrayCopy = [
        ...array
    ];
    const f = arrayCopy.splice(oldIndex, 1)[0];
    arrayCopy.splice(newIndex, 0, f);
    return arrayCopy;
};
const $bea3cfbec26c4bd1$var$dedupe = (stackState = [])=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const visited = {};
    return stackState.filter((item)=>{
        if (visited[item.panelId]) return false;
        visited[item.panelId] = true;
        return true;
    });
};
const $bea3cfbec26c4bd1$export$57758d0cfaeec2c = (state)=>{
    if (state.stackState.length === 1) return state.stackState[0];
    return state.stackState.find((sidebar)=>!sidebar.isCollapsed && !sidebar.isMinimised) || null;
};
const $bea3cfbec26c4bd1$export$f5584170a8c1db02 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: $bea3cfbec26c4bd1$var$dedupe(newState.stackState)
                }
            }
        });
    };
const $bea3cfbec26c4bd1$export$d91a6e55d52aa3e9 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: []
                }
            }
        });
    };
const $bea3cfbec26c4bd1$export$a9a5075d3d1b2165 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        if (!currentStack.length) return;
        const currentRightSidebar = $bea3cfbec26c4bd1$export$57758d0cfaeec2c(content.rightSidebar);
        if (!currentRightSidebar) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: content.rightSidebar.stackState.filter((item)=>item !== currentRightSidebar)
                }
            }
        });
    };
const $bea3cfbec26c4bd1$export$d7149233c76efb32 = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.filter((item)=>item.panelId !== panelId)
                }
            }
        });
    };
const $bea3cfbec26c4bd1$export$4eedf7fa26a2749a = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.map((item)=>{
                        if (item.panelId !== panelId) return item;
                        return {
                            ...item,
                            isMinimised: true
                        };
                    })
                }
            }
        });
    };
const $bea3cfbec26c4bd1$export$c8dafe074328c4ca = (panelId, width, isMinimised = false, toTop = false)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const tempRightSidebarStackStateValue = content.rightSidebar.stackState ? [
            ...content.rightSidebar.stackState.map((item)=>{
                if (item.panelId === panelId) return {
                    ...item,
                    isMinimised: isMinimised,
                    width: width
                };
                return item;
            })
        ] : [];
        const matchedPanelIndex = tempRightSidebarStackStateValue.findIndex((obj)=>obj.panelId === panelId);
        // if there's any matched panel id, we only move it to the top of the stack.
        if (matchedPanelIndex >= 0) {
            const nextIdx = toTop ? 0 : tempRightSidebarStackStateValue.length - 1;
            tempRightSidebarStackStateValue[matchedPanelIndex].isCollapsed = false;
            tempRightSidebarStackStateValue[matchedPanelIndex].isMinimised = isMinimised;
            const newRightSidebarStackStateValue = $bea3cfbec26c4bd1$var$arrayMove(tempRightSidebarStackStateValue, matchedPanelIndex, nextIdx);
            newRightSidebarStackStateValue[nextIdx].width = width;
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: newRightSidebarStackStateValue
                    }
                }
            });
            return;
        }
        const newRightSidebarStackStateValue = toTop ? [
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            },
            ...tempRightSidebarStackStateValue
        ] : [
            ...tempRightSidebarStackStateValue,
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            }
        ];
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(newRightSidebarStackStateValue, content.rightSidebar.stackState)) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: newRightSidebarStackStateValue
                }
            }
        });
    };

});

parcelRegister("53ucm", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_WIDTH", () => $775b7b0f5d2674bd$export$539e68c09584883a);
$parcel$export(module.exports, "layoutStore", () => $775b7b0f5d2674bd$export$b8cdfd44cddaf07);
$parcel$export(module.exports, "useLayoutStoreActions", () => $775b7b0f5d2674bd$export$6136bc3b9858cff4);
$parcel$export(module.exports, "useDetailPanelWidth", () => $775b7b0f5d2674bd$export$95fd7b6da3b9bbb0);
$parcel$export(module.exports, "useDetailPanelActions", () => $775b7b0f5d2674bd$export$99e05a60cac05e86);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $3roBA = parcelRequire("3roBA");
const $775b7b0f5d2674bd$export$539e68c09584883a = 240;
const $775b7b0f5d2674bd$export$b92df8810d2fcd01 = 0;
const $775b7b0f5d2674bd$var$initialState = {
    isChromeless: false,
    banner: {
        height: 0,
        activeBanner: null
    },
    topNavigation: {
        isVisible: true
    },
    leftPanel: {
        isVisible: true,
        width: 0
    },
    rightPanel: {
        isVisible: true,
        width: 0
    },
    bottomRightCorner: {
        container: undefined,
        portals: []
    },
    content: {
        leftSidebar: {
            width: $775b7b0f5d2674bd$export$539e68c09584883a,
            isCollapsed: true,
            isVisible: true,
            isFlyoutOpen: false
        },
        rightSidebar: {
            stackState: []
        }
    }
};
const $775b7b0f5d2674bd$export$b8cdfd44cddaf07 = (0, $a61MH.createStore)({
    initialState: $775b7b0f5d2674bd$var$initialState,
    actions: $3roBA.actions,
    name: 'JiraLayoutStore'
});
const $775b7b0f5d2674bd$export$6136bc3b9858cff4 = (0, $ggKAj.createHook)($775b7b0f5d2674bd$export$b8cdfd44cddaf07, {
    selector: null
});
const $775b7b0f5d2674bd$var$detailPanelWidthStore = (0, $a61MH.createStore)({
    name: 'detailPanelWidth',
    initialState: {
        width: 0
    },
    actions: {
        setWidth: (value)=>({ setState: setState })=>{
                setState({
                    width: value
                });
            }
    }
});
const $775b7b0f5d2674bd$export$95fd7b6da3b9bbb0 = (0, $ggKAj.createHook)($775b7b0f5d2674bd$var$detailPanelWidthStore);
const $775b7b0f5d2674bd$export$99e05a60cac05e86 = (0, $ggKAj.createActionsHook)($775b7b0f5d2674bd$var$detailPanelWidthStore);

});
parcelRegister("3roBA", function(module, exports) {

$parcel$export(module.exports, "actions", () => $7de3ed8fccc77236$export$e324594224ef24da);

var $3OanE = parcelRequire("3OanE");

var $gDr9R = parcelRequire("gDr9R");

var $aoZTG = parcelRequire("aoZTG");

var $f9nrb = parcelRequire("f9nrb");

var $hqpfO = parcelRequire("hqpfO");
const $7de3ed8fccc77236$export$e324594224ef24da = {
    setIsChromeless: // global
    $aoZTG.setIsChromeless,
    showBanner: // banner
    $3OanE.showBanner,
    dismissCurrentBanner: $3OanE.dismissCurrentBanner,
    setLeftSidebarState: // left-sidebar
    $f9nrb.setLeftSidebarState,
    setRightSidebarState: // right-sidebar
    $hqpfO.setRightSidebarState,
    openRightSidebar: $hqpfO.openRightSidebar,
    closeRightSidebar: $hqpfO.closeRightSidebar,
    closeAllRightSidebar: $hqpfO.closeAllRightSidebar,
    closeCurrentRightSidebar: $hqpfO.closeCurrentRightSidebar,
    minimiseRightSidebar: $hqpfO.minimiseRightSidebar,
    registerBottomRightCornerContainer: // bottom-right-corner
    $gDr9R.registerBottomRightCornerContainer,
    insertBottomRightCornerPortal: $gDr9R.insertBottomRightCornerPortal,
    removeBottomRightCornerPortal: $gDr9R.removeBottomRightCornerPortal
};

});
parcelRegister("3OanE", function(module, exports) {

$parcel$export(module.exports, "showBanner", () => $1ca96d140cb009a0$export$f5c0eb035ef26e87);
$parcel$export(module.exports, "dismissCurrentBanner", () => $1ca96d140cb009a0$export$a45bccc0cc9ac424);
const $1ca96d140cb009a0$export$f5c0eb035ef26e87 = (newState)=>({ setState: setState })=>{
        setState({
            banner: newState
        });
    };
const $1ca96d140cb009a0$export$a45bccc0cc9ac424 = ()=>({ dispatch: dispatch })=>{
        dispatch($1ca96d140cb009a0$export$f5c0eb035ef26e87({
            height: 0,
            activeBanner: null
        }));
    };

});

parcelRegister("gDr9R", function(module, exports) {

$parcel$export(module.exports, "registerBottomRightCornerContainer", () => $ce70661c3da7d088$export$2992ecf780497763);
$parcel$export(module.exports, "insertBottomRightCornerPortal", () => $ce70661c3da7d088$export$3ed25a6bee272520);
$parcel$export(module.exports, "removeBottomRightCornerPortal", () => $ce70661c3da7d088$export$928bf7e228ce06d2);
const $ce70661c3da7d088$export$2992ecf780497763 = (ref)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                container: ref ?? undefined
            }
        });
    };
const $ce70661c3da7d088$export$3ed25a6bee272520 = (item)=>// @ts-expect-error - TS2322 - Type '({ setState, getState }: StoreActionApi<LayoutState>) => number' is not assignable to type 'Action<LayoutState, void, void | Promise<void>>'.
    ({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        const sorted = [
            item,
            ...portals
        ].sort((a, b)=>b.orderFromRight - a.orderFromRight);
        const index = sorted.findIndex((portal)=>portal.id === item.id);
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: sorted
            }
        });
        return index;
    };
const $ce70661c3da7d088$export$928bf7e228ce06d2 = (id)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: portals.filter((portal)=>portal.id !== id)
            }
        });
    };

});

parcelRegister("aoZTG", function(module, exports) {

$parcel$export(module.exports, "setIsChromeless", () => $1199e64f89ce3554$export$1998c4816ad37edb);
const $1199e64f89ce3554$export$1998c4816ad37edb = (isChromeless)=>({ setState: setState })=>{
        setState({
            isChromeless: isChromeless
        });
    };

});

parcelRegister("f9nrb", function(module, exports) {

$parcel$export(module.exports, "setLeftSidebarState", () => $a9b20025b1de3529$export$3e0fd2d894ef83c8);
const $a9b20025b1de3529$export$3e0fd2d894ef83c8 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                leftSidebar: {
                    ...content.leftSidebar,
                    ...newState
                }
            }
        });
    };

});




parcelRegister("71g00", function(module, exports) {

$parcel$export(module.exports, "useBottomRightCornerContainer", () => $6c4868bbefcbb619$export$84542488b6b6c309);
$parcel$export(module.exports, "useBottomRightCornerActions", () => $6c4868bbefcbb619$export$de496fd0e0151c81);

var $ggKAj = parcelRequire("ggKAj");

var $53ucm = parcelRequire("53ucm");
const $6c4868bbefcbb619$export$84542488b6b6c309 = (0, $ggKAj.createStateHook)((0, $53ucm.layoutStore), {
    selector: (state)=>state.bottomRightCorner.container
});
const $6c4868bbefcbb619$export$de496fd0e0151c81 = (0, $ggKAj.createActionsHook)((0, $53ucm.layoutStore));

});


parcelRegister("cB0s9", function(module, exports) {

$parcel$export(module.exports, "LayoutRemoteStateUpdater", () => $7eb87e9a268eb6a6$export$b9f3a70460995c32);

var $eUqFw = parcelRequire("eUqFw");

var $48bs8 = parcelRequire("48bs8");

var $guiFP = parcelRequire("guiFP");

var $1GeZ8 = parcelRequire("1GeZ8");

var $3HCkE = parcelRequire("3HCkE");

var $1NIhY = parcelRequire("1NIhY");

var $6vrw7 = parcelRequire("6vrw7");

var $dxcfv = parcelRequire("dxcfv");

var $53ucm = parcelRequire("53ucm");

var $bUi2Q = parcelRequire("bUi2Q");
const $7eb87e9a268eb6a6$export$b9f3a70460995c32 = ()=>{
    // left-sidebar
    const { leftSidebarState: leftSidebarState } = (0, $1GeZ8.usePageLayoutResize)();
    const { isFlyoutOpen: isFlyoutOpen, isLeftSidebarCollapsed: isLeftSidebarCollapsed, leftSidebarWidth: leftSidebarWidth } = leftSidebarState;
    const resolvedLeftSidebarWidth = Math.max(leftSidebarWidth, (0, $53ucm.DEFAULT_LEFT_SIDEBAR_WIDTH));
    const [, { setLeftSidebarState: setLeftSidebarState }] = (0, $53ucm.useLayoutStoreActions)();
    const isCollapsed = leftSidebarState.isLeftSidebarCollapsed;
    // right-sidebar
    const rightSidebarState = (0, $bUi2Q.useRightSidebarState)();
    const accountId = (0, $dxcfv.useAccountId)();
    const baseUrl = (0, $6vrw7.toBaseUrl)('');
    const { data: data, loading: loading, error: error } = (0, $3HCkE.useResource)((0, $1NIhY.navigationUiStateResource));
    const isLayoutStateReady = leftSidebarWidth !== 0 && leftSidebarState.lastLeftSidebarWidth !== 0;
    (0, $eUqFw.useEffect)(()=>{
        if (!isLayoutStateReady) return;
        if (error) return;
        setLeftSidebarState({
            width: resolvedLeftSidebarWidth,
            isCollapsed: isCollapsed,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            isFlyoutOpen: isFlyoutOpen,
            isVisible: true
        });
    }, [
        error,
        isCollapsed,
        isFlyoutOpen,
        isLayoutStateReady,
        resolvedLeftSidebarWidth,
        setLeftSidebarState
    ]);
    const updateData = (0, $eUqFw.useCallback)(async ()=>{
        if (loading) return;
        if (error) return;
        if (!isLayoutStateReady) return;
        const remoteData = {
            ...data,
            leftSidebar: {
                width: resolvedLeftSidebarWidth,
                isCollapsed: isLeftSidebarCollapsed
            },
            rightSidebar: rightSidebarState
        };
        if (accountId) try {
            await (0, $48bs8.setUserProperties)(baseUrl, accountId, (0, $75b7df28d47cff7a$export$3e8fc5ba7287b4a8), JSON.stringify(remoteData));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $guiFP.default)({
                error: e,
                meta: {
                    id: 'updateServerLayoutState',
                    packageName: 'jiraLayoutController',
                    teamName: 'magma'
                }
            });
        }
    }, [
        accountId,
        baseUrl,
        data,
        error,
        isLayoutStateReady,
        isLeftSidebarCollapsed,
        loading,
        resolvedLeftSidebarWidth,
        rightSidebarState
    ]);
    (0, $eUqFw.useEffect)(()=>{
        updateData();
    }, [
        isLeftSidebarCollapsed,
        resolvedLeftSidebarWidth,
        updateData
    ]);
    return null;
};

});
parcelRegister("48bs8", function(module, exports) {

$parcel$export(module.exports, "getUserPropertiesUrl", () => $016bb9e2a17179ab$export$f474e53c8191800a);
$parcel$export(module.exports, "setUserProperties", () => $016bb9e2a17179ab$export$d0e176862bf869b8);
$parcel$export(module.exports, "getUserProperty", () => $016bb9e2a17179ab$export$b3126db2ef6e34ed);

var $axhXb = parcelRequire("axhXb");

var $7EhAs = parcelRequire("7EhAs");
const $016bb9e2a17179ab$export$f474e53c8191800a = (baseUrl, accountId, propertyKey)=>`/rest/api/latest/user/properties/${propertyKey}?accountId=${encodeURIComponent(accountId)}`;
const $016bb9e2a17179ab$export$d0e176862bf869b8 = async (baseUrl, accountId, propertyKey, data)=>fetch($016bb9e2a17179ab$export$f474e53c8191800a(baseUrl, accountId, propertyKey), {
        ...(0, $axhXb.default),
        method: 'PUT',
        body: data
    });
const $016bb9e2a17179ab$export$b3126db2ef6e34ed = (baseUrl, accountId, propertyKey)=>fetch($016bb9e2a17179ab$export$f474e53c8191800a(baseUrl, accountId, propertyKey), (0, $axhXb.default)).then((res)=>{
        if (res.status === 200) return res.json();
        return res.text().then((errResp)=>{
            throw new (0, $7EhAs.default)(res.status, errResp);
        });
    }).then((data)=>data.value);

});
parcelRegister("axhXb", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1543ae6d5c00264$export$2e2bcd8739ae039);
const $d1543ae6d5c00264$var$defaultOptions = {
    credentials: 'same-origin',
    headers: {
        'Content-Type': 'application/json',
        'x-atlassian-force-account-id': 'true',
        // Flow's RequestOptions type doesn't allow an array here, but it works in practice ¯\_(ツ)_/¯
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        Accept: [
            'application/json',
            'text/javascript',
            '*/*'
        ]
    }
};
var $d1543ae6d5c00264$export$2e2bcd8739ae039 = $d1543ae6d5c00264$var$defaultOptions;

});

parcelRegister("7EhAs", function(module, exports) {

$parcel$export(module.exports, "default", () => $d91e30f3a9c559ab$export$2e2bcd8739ae039);

var $7byHA = parcelRequire("7byHA");
var $d91e30f3a9c559ab$export$2e2bcd8739ae039 = (0, $7byHA.default);

});


parcelRegister("1GeZ8", function(module, exports) {

$parcel$export(module.exports, "PageLayout", () => $e83852d7c3641ad5$export$6d1402fb58384e4f);
$parcel$export(module.exports, "Banner", () => $e83852d7c3641ad5$export$3b4e64e77073e307);
$parcel$export(module.exports, "TopNavigation", () => $e83852d7c3641ad5$export$8a421bddecb2bf5b);
$parcel$export(module.exports, "LeftPanel", () => $e83852d7c3641ad5$export$110709f040143804);
$parcel$export(module.exports, "LeftSidebarWithoutResize", () => $e83852d7c3641ad5$export$43ae342508cf8cc9);
$parcel$export(module.exports, "LeftSidebar", () => $e83852d7c3641ad5$export$3cabf771c4f2de);
$parcel$export(module.exports, "Main", () => $e83852d7c3641ad5$export$861edd1ccea2f746);
$parcel$export(module.exports, "Content", () => $e83852d7c3641ad5$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "RightSidebar", () => $e83852d7c3641ad5$export$84d58c19c21f637f);
$parcel$export(module.exports, "useCustomSkipLink", () => $e83852d7c3641ad5$export$ee6b12c2613bdf8e);
$parcel$export(module.exports, "useLeftSidebarFlyoutLock", () => $e83852d7c3641ad5$export$94561f6055639ef7);
$parcel$export(module.exports, "usePageLayoutResize", () => $e83852d7c3641ad5$export$10c7104037a7af62);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_BANNER_HEIGHT", () => $e83852d7c3641ad5$export$991ef8098f87814a);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_PANEL_WIDTH", () => $e83852d7c3641ad5$export$7eaf986ecb4d5cac);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_SIDEBAR_WIDTH", () => $e83852d7c3641ad5$export$e95b388ca8c92019);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_PANEL_WIDTH", () => $e83852d7c3641ad5$export$2ab8b83eed76656c);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_SIDEBAR_WIDTH", () => $e83852d7c3641ad5$export$ac017575d43f5da);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT", () => $e83852d7c3641ad5$export$d697087c06fd5e25);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");

var $ahaFU = parcelRequire("ahaFU");
var $ho1Ek = parcelRequire("ho1Ek");
var $780tS = parcelRequire("780tS");
var $1EvZ6 = parcelRequire("1EvZ6");
var $66hOn = parcelRequire("66hOn");
var $2Lkx0 = parcelRequire("2Lkx0");
var $hNH8O = parcelRequire("hNH8O");
var $4NoTP = parcelRequire("4NoTP");
var $epaF7 = parcelRequire("epaF7");
var $mtJGd = parcelRequire("mtJGd");
var $jnGaC = parcelRequire("jnGaC");
var $ikQZw = parcelRequire("ikQZw");
var $GP1qj = parcelRequire("GP1qj");

var $XHGTv = parcelRequire("XHGTv");

var $b5l09 = parcelRequire("b5l09");

var $6JlSS = parcelRequire("6JlSS");

var $3jdLC = parcelRequire("3jdLC");

var $19w0L = parcelRequire("19w0L");
function $e83852d7c3641ad5$export$6d1402fb58384e4f(props) {
    return (0, $XHGTv.getBooleanFF)('platform.atlassian.griffin-new-page-layout') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5l09.Root), {
        UNSAFE_dangerouslyHoistSlotSizes: true
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4NoTP.default), props);
}
function $e83852d7c3641ad5$export$3b4e64e77073e307(props) {
    return (0, $XHGTv.getBooleanFF)('platform.atlassian.griffin-new-page-layout') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5l09.Banner), {
        UNSAFE_height: props.height
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ahaFU.default), props);
}
function $e83852d7c3641ad5$export$8a421bddecb2bf5b(props) {
    return (0, $XHGTv.getBooleanFF)('platform.atlassian.griffin-new-page-layout') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5l09.TopBar), {
        UNSAFE_height: props.height
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jnGaC.default), props);
}
function $e83852d7c3641ad5$export$110709f040143804(props) {
    // LeftPanel is not supported in new page layout
    return (0, $XHGTv.getBooleanFF)('platform.atlassian.griffin-new-page-layout') ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1EvZ6.default), props);
}
function $e83852d7c3641ad5$export$43ae342508cf8cc9(props) {
    return (0, $XHGTv.getBooleanFF)('platform.atlassian.griffin-new-page-layout') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5l09.SideNav), {
        defaultWidth: props.width
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Lkx0.default), props);
}
function $e83852d7c3641ad5$export$3cabf771c4f2de(props) {
    return (0, $XHGTv.getBooleanFF)('platform.atlassian.griffin-new-page-layout') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5l09.SideNav), {
        defaultWidth: props.width
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $66hOn.default), props);
}
function $e83852d7c3641ad5$export$861edd1ccea2f746(props) {
    return (0, $XHGTv.getBooleanFF)('platform.atlassian.griffin-new-page-layout') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5l09.Main), {
        isFixed: props.isFixed
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hNH8O.default), props);
}
function $e83852d7c3641ad5$export$7c6e2c02157bb7d2(props) {
    return (0, $XHGTv.getBooleanFF)('platform.atlassian.griffin-new-page-layout') ? // There isn't a concept of a `Content` wrapper component in the new page layout
    props.children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $780tS.default), props);
}
function $e83852d7c3641ad5$export$84d58c19c21f637f(props) {
    return (0, $XHGTv.getBooleanFF)('platform.atlassian.griffin-new-page-layout') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5l09.Aside), {
        isFixed: props.isFixed,
        defaultWidth: props.width
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $mtJGd.default), props);
}
function $e83852d7c3641ad5$export$364a989a35814102(props) {
    return (0, $XHGTv.getBooleanFF)('platform.atlassian.griffin-new-page-layout') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5l09.Panel), {
        defaultWidth: props.width
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $epaF7.default), props);
}
const $e83852d7c3641ad5$export$ee6b12c2613bdf8e = (id, title, index)=>(0, $XHGTv.getBooleanFF)('platform.atlassian.griffin-new-page-layout') ? {} : (0, $GP1qj.useCustomSkipLink)(id, title, index);
const $e83852d7c3641ad5$export$94561f6055639ef7 = ()=>(0, $XHGTv.getBooleanFF)('platform.atlassian.griffin-new-page-layout') ? {} : (0, $ikQZw.useLeftSidebarFlyoutLock)();
const $e83852d7c3641ad5$export$f37b9b9b883352cf = ()=>(0, $XHGTv.getBooleanFF)('platform.atlassian.griffin-new-page-layout') ? (0, $5Q9wj.default) : (0, $ikQZw.UNSAFE_useSetLeftSidebarState)();
// A mock value is needed to match the signature of the hook
const $e83852d7c3641ad5$var$mockPageLayoutResize = {
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, $5Q9wj.default),
    collapseLeftSidebar: (0, $5Q9wj.default),
    leftSidebarState: {
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true
    },
    setLeftSidebarState: (0, $5Q9wj.default),
    toggleLeftSidebar: (0, $5Q9wj.default)
};
const $e83852d7c3641ad5$export$10c7104037a7af62 = ()=>(0, $XHGTv.getBooleanFF)('platform.atlassian.griffin-new-page-layout') ? $e83852d7c3641ad5$var$mockPageLayoutResize : (0, $ikQZw.usePageLayoutResize)();
const $e83852d7c3641ad5$export$991ef8098f87814a = (0, $ho1Ek.BANNER_HEIGHT);
const $e83852d7c3641ad5$export$7eaf986ecb4d5cac = (0, $ho1Ek.LEFT_PANEL_WIDTH);
const $e83852d7c3641ad5$export$e95b388ca8c92019 = (0, $ho1Ek.LEFT_SIDEBAR_WIDTH);
const $e83852d7c3641ad5$export$2ab8b83eed76656c = (0, $ho1Ek.RIGHT_PANEL_WIDTH);
const $e83852d7c3641ad5$export$ac017575d43f5da = (0, $ho1Ek.RIGHT_SIDEBAR_WIDTH);
const $e83852d7c3641ad5$export$d697087c06fd5e25 = (0, $ho1Ek.TOP_NAVIGATION_HEIGHT);

});
parcelRegister("ahaFU", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6e67e66af393013$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ho1Ek = parcelRequire("ho1Ek");

var $a353s = parcelRequire("a353s");

var $cXUwP = parcelRequire("cXUwP");
var $6cmgz = parcelRequire("6cmgz");

var $gl6Cr = parcelRequire("gl6Cr");

var $8cbHW = parcelRequire("8cbHW");
const $e6e67e66af393013$var$bannerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $ho1Ek.BANNER_HEIGHT),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $ho1Ek.BANNER)
});
const $e6e67e66af393013$var$bannerFixedStyles = /*#__PURE__*/ (0, $byn9U.css)({
    position: 'fixed',
    zIndex: 2,
    insetBlockStart: 0,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: (0, $ho1Ek.RIGHT_PANEL_WIDTH),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: (0, $ho1Ek.LEFT_PANEL_WIDTH)
});
/**
 * __Banner__
 *
 * Provides a slot for a Banner within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $e6e67e66af393013$var$Banner = (props)=>{
    const { children: children, height: height = (0, $ho1Ek.DEFAULT_BANNER_HEIGHT), isFixed: isFixed = true, shouldPersistHeight: shouldPersistHeight, testId: testId, skipLinkTitle: skipLinkTitle, id: id } = props;
    const bannerHeight = (0, $a353s.resolveDimension)((0, $ho1Ek.VAR_BANNER_HEIGHT), height, shouldPersistHeight);
    (0, $eUqFw.useEffect)(()=>{
        (0, $cXUwP.default)({
            [(0, $ho1Ek.VAR_BANNER_HEIGHT)]: bannerHeight
        });
        return ()=>{
            (0, $cXUwP.default)({
                [(0, $ho1Ek.VAR_BANNER_HEIGHT)]: 0
            });
        };
    }, [
        bannerHeight
    ]);
    (0, $6cmgz.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $gl6Cr.default), null, ({ className: className })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: [
                $e6e67e66af393013$var$bannerStyles,
                isFixed && $e6e67e66af393013$var$bannerFixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $a353s.getPageLayoutSlotSelector)('banner')
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cbHW.default), {
            variableName: (0, $ho1Ek.VAR_BANNER_HEIGHT),
            value: bannerHeight
        }), children));
};
var $e6e67e66af393013$export$2e2bcd8739ae039 = $e6e67e66af393013$var$Banner;

});
parcelRegister("a353s", function(module, exports) {

$parcel$export(module.exports, "mergeGridStateIntoStorage", () => $0a6a711fa684a053$export$f8355a2df0f4a946);
$parcel$export(module.exports, "getGridStateFromStorage", () => $0a6a711fa684a053$export$d95e99d8116d17dc);
$parcel$export(module.exports, "removeFromGridStateInStorage", () => $0a6a711fa684a053$export$17e3760e0b35f1cd);
$parcel$export(module.exports, "resolveDimension", () => $0a6a711fa684a053$export$74732e47915c7839);
$parcel$export(module.exports, "getLeftPanelWidth", () => $0a6a711fa684a053$export$b089e01213f07bd);
$parcel$export(module.exports, "getLeftSidebarPercentage", () => $0a6a711fa684a053$export$2bca58b6ee823bf7);
$parcel$export(module.exports, "getPageLayoutSlotSelector", () => $0a6a711fa684a053$export$e895e3e8b708ae2a);
$parcel$export(module.exports, "getPageLayoutSlotCSSSelector", () => $0a6a711fa684a053$export$218ece2c32b7db0e);

var $ho1Ek = parcelRequire("ho1Ek");

var $5o7nc = parcelRequire("5o7nc");
const $0a6a711fa684a053$export$576dabd404a1ed99 = (0, $ho1Ek.DIMENSIONS).reduce((acc, currentValue)=>({
        ...acc,
        [currentValue]: 0
    }), {});
const $0a6a711fa684a053$export$f8355a2df0f4a946 = (key, value)=>{
    const storageValue = JSON.parse((0, $5o7nc.default)().getItem((0, $ho1Ek.PAGE_LAYOUT_LS_KEY)) || '{}');
    if (value !== null && typeof value === 'object') storageValue[key] = {
        ...storageValue[key],
        ...value
    };
    else storageValue[key] = value;
    (0, $5o7nc.default)().setItem((0, $ho1Ek.PAGE_LAYOUT_LS_KEY), JSON.stringify(storageValue));
};
const $0a6a711fa684a053$export$d95e99d8116d17dc = (key)=>{
    const storageValue = JSON.parse((0, $5o7nc.default)().getItem((0, $ho1Ek.PAGE_LAYOUT_LS_KEY)) || '{}');
    return storageValue[key];
};
const $0a6a711fa684a053$export$17e3760e0b35f1cd = (key, secondKey)=>{
    const storageValue = JSON.parse((0, $5o7nc.default)().getItem((0, $ho1Ek.PAGE_LAYOUT_LS_KEY)) || '{}');
    if (secondKey && storageValue[key]) delete storageValue[key][secondKey];
    else delete storageValue[key];
    (0, $5o7nc.default)().setItem((0, $ho1Ek.PAGE_LAYOUT_LS_KEY), JSON.stringify(storageValue));
};
const $0a6a711fa684a053$export$74732e47915c7839 = (key, dimension = 0, shouldPersist = false)=>{
    if (shouldPersist) {
        const cachedGridState = $0a6a711fa684a053$export$d95e99d8116d17dc('gridState');
        return cachedGridState && Object.keys(cachedGridState).length > 0 && cachedGridState[key] ? cachedGridState[key] : dimension;
    }
    return dimension;
};
const $0a6a711fa684a053$export$b089e01213f07bd = ()=>{
    if (typeof window === 'undefined') return 0;
    return parseInt(window.getComputedStyle(document.documentElement).getPropertyValue(`--${(0, $ho1Ek.LEFT_PANEL_WIDTH)}`), 10) || 0;
};
const $0a6a711fa684a053$export$2bca58b6ee823bf7 = (currentWidth, maxWidth)=>{
    const total = (currentWidth - (0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH)) / (maxWidth - (0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH));
    if (total < 0) return 0;
    if (total > 1) return 100;
    return Math.floor(total * 100);
};
const $0a6a711fa684a053$export$e895e3e8b708ae2a = (slotName)=>({
        [(0, $ho1Ek.PAGE_LAYOUT_SLOT_SELECTOR)]: slotName
    });
const $0a6a711fa684a053$export$218ece2c32b7db0e = (slotName)=>`[${0, $ho1Ek.PAGE_LAYOUT_SLOT_SELECTOR}='${slotName}']`;

});
parcelRegister("5o7nc", function(module, exports) {

$parcel$export(module.exports, "default", () => $d809f573a3653667$export$2e2bcd8739ae039);
// Reliably test against conditions like
// localStorage being full or private mode in Safari being a .
// https://gist.github.com/paulirish/5558557
const $d809f573a3653667$var$isLocalStorageSupported = ()=>{
    try {
        // use an random key to test
        // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
        const testKey = `__test_${Date.now()}__`;
        localStorage.setItem(testKey, testKey);
        localStorage.removeItem(testKey);
        return true;
    } catch (e) {
        return false;
    }
};
const $d809f573a3653667$var$safeLocalStorage = ()=>{
    if ($d809f573a3653667$var$isLocalStorageSupported()) return localStorage;
    // Returning a mock object here in the case that this is run in SSR mode
    if (typeof window === 'undefined') return {
        getItem: (_key)=>null,
        setItem: (_key, _value)=>null,
        removeItem: (_key)=>null,
        clear: ()=>null,
        key: (_index)=>null,
        get length () {
            return 0;
        }
    };
    if (window.__localStorageFallback && Object.keys(window.__localStorageFallback).length !== 0) return window.__localStorageFallback;
    const storageAPI = {
        getItem: (key)=>{
            if (window.__localStorageFallback.hasOwnProperty(key)) return window.__localStorageFallback[key];
            return null;
        },
        setItem: (key, value)=>{
            window.__localStorageFallback[key] = String(value);
        },
        removeItem: (key)=>{
            delete window.__localStorageFallback[key];
        },
        clear: ()=>{
            for(const key in window.__localStorageFallback)if (window.__localStorageFallback.hasOwnProperty(key)) delete window.__localStorageFallback[key];
        },
        get length () {
            if (!window.__localStorageFallback) return 0;
            return Object.keys(window.__localStorageFallback).length;
        }
    };
    window.__localStorageFallback = Object.create(storageAPI);
    return window.__localStorageFallback;
};
var $d809f573a3653667$export$2e2bcd8739ae039 = $d809f573a3653667$var$safeLocalStorage;

});


parcelRegister("cXUwP", function(module, exports) {

$parcel$export(module.exports, "default", () => $06373a48b343ca71$export$2e2bcd8739ae039);

var $a353s = parcelRequire("a353s");
const $06373a48b343ca71$var$publishGridState = (gridState)=>{
    Object.entries(gridState).forEach(([slotName, value])=>{
        if (!value) {
            document.documentElement.style.removeProperty(`--${slotName}`);
            (0, $a353s.removeFromGridStateInStorage)('gridState', slotName);
            return;
        }
        //Update the css variable
        document.documentElement.style.setProperty(`--${slotName}`, `${value}px`);
        // also update state in local storage so that
        // it persists across page refresh, across tabs etc
        (0, $a353s.mergeGridStateIntoStorage)('gridState', {
            [slotName]: value
        });
    });
};
var $06373a48b343ca71$export$2e2bcd8739ae039 = $06373a48b343ca71$var$publishGridState;

});

parcelRegister("6cmgz", function(module, exports) {

$parcel$export(module.exports, "SkipLinksContext", () => $73ff71be83e0ab1c$export$4c5cc3b14c7678a);
$parcel$export(module.exports, "useSkipLinks", () => $73ff71be83e0ab1c$export$c9d9cb2ee9590f87);
$parcel$export(module.exports, "useSkipLink", () => $73ff71be83e0ab1c$export$89d9323301efc7d6);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");
const $73ff71be83e0ab1c$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $eUqFw.createContext)({
    skipLinksData: [],
    registerSkipLink: (0, $5Q9wj.default),
    unregisterSkipLink: (0, $5Q9wj.default)
});
const $73ff71be83e0ab1c$export$c9d9cb2ee9590f87 = ()=>(0, $eUqFw.useContext)($73ff71be83e0ab1c$export$4c5cc3b14c7678a);
const $73ff71be83e0ab1c$export$89d9323301efc7d6 = (id, skipLinkTitle)=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = $73ff71be83e0ab1c$export$c9d9cb2ee9590f87();
    (0, $eUqFw.useEffect)(()=>{
        if (id && skipLinkTitle) registerSkipLink({
            id: id,
            skipLinkTitle: skipLinkTitle
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        skipLinkTitle,
        registerSkipLink,
        unregisterSkipLink
    ]);
};

});

parcelRegister("gl6Cr", function(module, exports) {

$parcel$export(module.exports, "default", () => $769062fa7cdcfd96$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
const $769062fa7cdcfd96$var$focusStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div': {
            boxShadow: `0px 0px 0px 2px inset ${`var(--ds-border-focused, ${(0, $PdmhA.B100)})`}`,
            outline: 'none'
        }
    }
});
/**
 * Sidebars have an outer and inner component,
 * so the nested selector needs to target an extra level deeper.
 */ const $769062fa7cdcfd96$var$sidebarFocusStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div > div': {
            boxShadow: `0px 0px 0px 2px inset ${`var(--ds-border-focused, ${(0, $PdmhA.B100)})`}`,
            outline: 'none'
        }
    }
});
/**
 * We don't use `@atlaskit/focus-ring` here,
 * because we need inset focus styles and:
 *
 * 1. If we set them directly to the layout element,
 *    then any child element's background will cover the shadow.
 * 2. We cannot wrap `children` in `FocusRing`,
 *    because there's no guarantee the passed child takes `className`.
 */ const $769062fa7cdcfd96$var$SlotFocusRing = ({ children: children, isSidebar: isSidebar = false })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $byn9U.ClassNames), null, ({ css: css })=>children({
            className: isSidebar ? css($769062fa7cdcfd96$var$sidebarFocusStyles) : css($769062fa7cdcfd96$var$focusStyles)
        }));
};
var $769062fa7cdcfd96$export$2e2bcd8739ae039 = $769062fa7cdcfd96$var$SlotFocusRing;

});

parcelRegister("8cbHW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5df357f02f294910$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $4Ywu9 = parcelRequire("4Ywu9");
var $5df357f02f294910$export$2e2bcd8739ae039 = ({ variableName: variableName, value: value, mobileValue: mobileValue })=>{
    if ((0, $XHGTv.fg)('platform.remove-newline-in-style-tag-in-platform-page-layout_7gts1')) {
        /**
		 * Note don't put multiple variables in multiple lines. eg
		 * <style>
		 *   {css1}
		 *   {css2}
		 * </style>
		 *
		 * React will insert an empty HTML comment in between the text in SSR.
		 * This is not a valid tag and will break the page.
		 * <style>foo<!-- -->bar</style>
		 */ let style = `:root{--${variableName}:${value}px;}`;
        if (mobileValue) style += ` ${(0, $4Ywu9.UNSAFE_media).below.sm} { :root{--${variableName}:${mobileValue}px;} }`;
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("style", null, style));
    } else return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("style", null, `:root{--${variableName}:${value}px;}`, mobileValue && `${(0, $4Ywu9.UNSAFE_media).below.sm} { :root{--${variableName}:${mobileValue}px;} }`));
};

});


parcelRegister("780tS", function(module, exports) {

$parcel$export(module.exports, "default", () => $1254209de2b99d0a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $ho1Ek = parcelRequire("ho1Ek");
const $1254209de2b99d0a$var$contentStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $ho1Ek.CONTENT)
});
/**
 * __Content__
 *
 * Provides a slot for your application content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $1254209de2b99d0a$var$Content = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        css: $1254209de2b99d0a$var$contentStyles
    }, children);
};
var $1254209de2b99d0a$export$2e2bcd8739ae039 = $1254209de2b99d0a$var$Content;

});

parcelRegister("1EvZ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $cee1fe777273abc5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ho1Ek = parcelRequire("ho1Ek");

var $a353s = parcelRequire("a353s");

var $cXUwP = parcelRequire("cXUwP");
var $6cmgz = parcelRequire("6cmgz");

var $gl6Cr = parcelRequire("gl6Cr");

var $8cbHW = parcelRequire("8cbHW");
const $cee1fe777273abc5$var$leftPanelStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $ho1Ek.LEFT_PANEL)
});
const $cee1fe777273abc5$var$leftPanelFixedStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $ho1Ek.LEFT_PANEL_WIDTH),
    position: 'fixed',
    insetBlockEnd: 0,
    insetBlockStart: 0,
    insetInlineStart: 0
});
/**
 * __Left panel__
 *
 * Provides a slot for a left panel within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $cee1fe777273abc5$var$LeftPanel = (props)=>{
    const { children: children, isFixed: isFixed, width: width = (0, $ho1Ek.DEFAULT_LEFT_PANEL_WIDTH), shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const leftPanelWidth = (0, $a353s.resolveDimension)((0, $ho1Ek.VAR_LEFT_PANEL_WIDTH), width, shouldPersistWidth);
    (0, $eUqFw.useEffect)(()=>{
        (0, $cXUwP.default)({
            [(0, $ho1Ek.VAR_LEFT_PANEL_WIDTH)]: leftPanelWidth
        });
        return ()=>{
            (0, $cXUwP.default)({
                [(0, $ho1Ek.VAR_LEFT_PANEL_WIDTH)]: 0
            });
        };
    }, [
        leftPanelWidth
    ]);
    (0, $6cmgz.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $gl6Cr.default), null, ({ className: className })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: [
                $cee1fe777273abc5$var$leftPanelStyles,
                isFixed && $cee1fe777273abc5$var$leftPanelFixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $a353s.getPageLayoutSlotSelector)('left-panel')
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cbHW.default), {
            variableName: (0, $ho1Ek.VAR_LEFT_PANEL_WIDTH),
            value: leftPanelWidth
        }), children));
};
var $cee1fe777273abc5$export$2e2bcd8739ae039 = $cee1fe777273abc5$var$LeftPanel;

});

parcelRegister("66hOn", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba986c6a8de8190f$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $kVO3J = parcelRequire("kVO3J");


var $eT0WN = parcelRequire("eT0WN");

var $PdmhA = parcelRequire("PdmhA");

var $ho1Ek = parcelRequire("ho1Ek");

var $a353s = parcelRequire("a353s");

var $cXUwP = parcelRequire("cXUwP");
var $ikQZw = parcelRequire("ikQZw");
var $6cmgz = parcelRequire("6cmgz");

var $3QLIJ = parcelRequire("3QLIJ");

var $cJoHg = parcelRequire("cJoHg");

var $c9QmQ = parcelRequire("c9QmQ");

var $bxILY = parcelRequire("bxILY");

var $8cbHW = parcelRequire("8cbHW");
const $ba986c6a8de8190f$var$openBackdropStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: '100%',
    height: '100%',
    position: 'absolute',
    background: `var(--ds-blanket, ${(0, $PdmhA.N100A)})`,
    opacity: 1
});
const $ba986c6a8de8190f$var$hiddenBackdropStyles = /*#__PURE__*/ (0, $byn9U.css)({
    opacity: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `opacity ${(0, $ho1Ek.TRANSITION_DURATION)}ms ${(0, $d58b680a02f4d6a4$export$57636bb43b1ccbb0)} 0s`
});
/**
 * __Left sidebar__
 *
 * Provides a slot for a left sidebar within the PageLayout.
 *
 * On smaller viewports, the left sidebar can no longer be expanded.  Instead, expanding it will
 * put it into our "flyout mode" to lay overtop (which in desktop is explicitly a hover state).
 * This ensures the contents behind do not reflow oddly and allows for a better experience
 * resizing between mobile and desktop.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $ba986c6a8de8190f$var$LeftSidebar = (props)=>{
    const { children: children, width: width, isFixed: isFixed = true, valueTextLabel: valueTextLabel, resizeButtonLabel: resizeButtonLabel, resizeGrabAreaLabel: resizeGrabAreaLabel, overrides: overrides, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, onFlyoutExpand: onFlyoutExpand, onFlyoutCollapse: onFlyoutCollapse, testId: testId, id: id, skipLinkTitle: skipLinkTitle, collapsedState: collapsedState } = props;
    const flyoutTimerRef = (0, $eUqFw.useRef)();
    const mouseOverEventRef = (0, $eUqFw.useRef)();
    const leftSideBarRef = (0, $eUqFw.useRef)(null);
    const { leftSidebarState: leftSidebarState, setLeftSidebarState: setLeftSidebarState } = (0, $eUqFw.useContext)((0, $ikQZw.SidebarResizeContext));
    const { isFlyoutOpen: isFlyoutOpen, isResizing: isResizing, flyoutLockCount: flyoutLockCount, isLeftSidebarCollapsed: isLeftSidebarCollapsed, leftSidebarWidth: leftSidebarWidth, lastLeftSidebarWidth: lastLeftSidebarWidth } = leftSidebarState;
    const isLocked = flyoutLockCount > 0;
    const isLockedRef = (0, $eUqFw.useRef)(isLocked);
    const mouseXRef = (0, $eUqFw.useRef)(0);
    const handlerRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        isLockedRef.current = isLocked;
        // I tried a one-time `mousemove` handler that gets attached
        // when the lock releases. This is not robust because
        // the mouse can stay still after release (e.g. using keyboard)
        // and the sidebar will erroneously stay open.
        //
        // The following solution is likely less performant but more robust.
        if (isLocked && !handlerRef.current) {
            handlerRef.current = (event)=>{
                mouseXRef.current = event.clientX;
            };
            document.addEventListener('mousemove', handlerRef.current);
        }
        if (!isLocked && handlerRef.current) {
            if (mouseXRef.current >= lastLeftSidebarWidth) setLeftSidebarState((current)=>({
                    ...current,
                    isFlyoutOpen: false
                }));
            document.removeEventListener('mousemove', handlerRef.current);
            handlerRef.current = null;
        }
        return ()=>{
            if (handlerRef.current) document.removeEventListener('mousemove', handlerRef.current);
        };
    }, [
        isLocked,
        lastLeftSidebarWidth,
        setLeftSidebarState
    ]);
    const _width = Math.max(width || 0, (0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH));
    const collapsedStateOverrideOpen = collapsedState === 'expanded';
    let leftSidebarWidthOnMount;
    if (collapsedStateOverrideOpen) leftSidebarWidthOnMount = (0, $a353s.resolveDimension)((0, $ho1Ek.VAR_LEFT_SIDEBAR_FLYOUT), _width, !width);
    else if (isLeftSidebarCollapsed || collapsedState === 'collapsed') leftSidebarWidthOnMount = (0, $ho1Ek.COLLAPSED_LEFT_SIDEBAR_WIDTH);
    else leftSidebarWidthOnMount = (0, $a353s.resolveDimension)((0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH), _width, !width || !collapsedStateOverrideOpen && (0, $a353s.getGridStateFromStorage)('isLeftSidebarCollapsed'));
    // Update state from cache on mount
    (0, $eUqFw.useEffect)(()=>{
        const cachedCollapsedState = !collapsedStateOverrideOpen && (collapsedState === 'collapsed' || (0, $a353s.getGridStateFromStorage)('isLeftSidebarCollapsed') || false);
        const cachedGridState = (0, $a353s.getGridStateFromStorage)('gridState') || {};
        let leftSidebarWidth = !width && cachedGridState[0, $ho1Ek.VAR_LEFT_SIDEBAR_FLYOUT] ? Math.max(cachedGridState[0, $ho1Ek.VAR_LEFT_SIDEBAR_FLYOUT], (0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH)) : _width;
        const lastLeftSidebarWidth = !width && cachedGridState[0, $ho1Ek.VAR_LEFT_SIDEBAR_FLYOUT] ? Math.max(cachedGridState[0, $ho1Ek.VAR_LEFT_SIDEBAR_FLYOUT], (0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH)) : _width;
        if (cachedCollapsedState) leftSidebarWidth = (0, $ho1Ek.COLLAPSED_LEFT_SIDEBAR_WIDTH);
        setLeftSidebarState({
            isFlyoutOpen: false,
            isResizing: isResizing,
            isLeftSidebarCollapsed: cachedCollapsedState,
            leftSidebarWidth: leftSidebarWidth,
            lastLeftSidebarWidth: lastLeftSidebarWidth,
            flyoutLockCount: 0,
            isFixed: isFixed
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Every time other than mount,
    // update the local storage and css variables.
    const notFirstRun = (0, $eUqFw.useRef)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (notFirstRun.current) {
            (0, $cXUwP.default)({
                [(0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH)]: leftSidebarWidth || leftSidebarWidthOnMount,
                [(0, $ho1Ek.VAR_LEFT_SIDEBAR_FLYOUT)]: lastLeftSidebarWidth
            });
            (0, $a353s.mergeGridStateIntoStorage)('isLeftSidebarCollapsed', isLeftSidebarCollapsed);
        }
        if (!notFirstRun.current) notFirstRun.current = true;
        return ()=>{
            removeMouseOverListener();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isLeftSidebarCollapsed,
        leftSidebarWidth,
        id
    ]);
    const onMouseOver = (event)=>{
        const isMouseOnResizeButton = event.target.matches(`[${(0, $ho1Ek.RESIZE_BUTTON_SELECTOR)}]`) || event.target.matches(`[${(0, $ho1Ek.RESIZE_BUTTON_SELECTOR)}] *`);
        if (isFlyoutOpen || isMouseOnResizeButton || !isLeftSidebarCollapsed) return;
        event.persist();
        flyoutTimerRef.current && clearTimeout(flyoutTimerRef.current);
        if (!mouseOverEventRef.current) mouseOverEventRef.current = (event)=>{
            const leftSidebar = leftSideBarRef.current;
            if (leftSidebar === null || isLockedRef.current) return;
            if (!leftSidebar.contains(event.target)) {
                flyoutTimerRef.current && clearTimeout(flyoutTimerRef.current);
                onFlyoutCollapse && onFlyoutCollapse();
                setLeftSidebarState((current)=>({
                        ...current,
                        isFlyoutOpen: false
                    }));
                removeMouseOverListener();
            }
        };
        document.addEventListener('mouseover', mouseOverEventRef.current, {
            capture: true,
            passive: true
        });
        flyoutTimerRef.current = setTimeout(()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    isFlyoutOpen: true
                }));
            onFlyoutExpand && onFlyoutExpand();
        }, (0, $ho1Ek.FLYOUT_DELAY));
    };
    const removeMouseOverListener = ()=>{
        mouseOverEventRef.current && document.removeEventListener('mouseover', mouseOverEventRef.current, {
            capture: true,
            passive: true
        });
    };
    (0, $6cmgz.useSkipLink)(id, skipLinkTitle);
    const onMouseLeave = (event)=>{
        const isMouseOnResizeButton = event.target.matches(`[${(0, $ho1Ek.RESIZE_BUTTON_SELECTOR)}]`) || event.target.matches(`[${(0, $ho1Ek.RESIZE_BUTTON_SELECTOR)}] *`);
        if (isMouseOnResizeButton || !isLeftSidebarCollapsed || flyoutLockCount > 0) return;
        onFlyoutCollapse && onFlyoutCollapse();
        setTimeout(()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    isFlyoutOpen: false
                }));
        }, (0, $ho1Ek.FLYOUT_DELAY));
    };
    const mobileMediaQuery = (0, $eT0WN.UNSAFE_useMediaQuery)('below.sm');
    const openMobileFlyout = (0, $eUqFw.useCallback)(()=>{
        if (!mobileMediaQuery?.matches) return;
        setLeftSidebarState((current)=>{
            if (current.isFlyoutOpen) return current;
            return {
                ...current,
                isFlyoutOpen: true
            };
        });
    }, [
        setLeftSidebarState,
        mobileMediaQuery
    ]);
    const closeMobileFlyout = (0, $eUqFw.useCallback)(()=>{
        if (!mobileMediaQuery?.matches) return;
        setLeftSidebarState((current)=>{
            if (!current.isFlyoutOpen) return current;
            return {
                ...current,
                isFlyoutOpen: false
            };
        });
    }, [
        setLeftSidebarState,
        mobileMediaQuery
    ]);
    (0, $eT0WN.UNSAFE_useMediaQuery)('below.sm', (event)=>{
        setLeftSidebarState((current)=>{
            if (event.matches && !current.isLeftSidebarCollapsed) // Sidebar was previously open when resizing downwards, convert the sidebar being open to a flyout being open
            return {
                ...current,
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $ho1Ek.COLLAPSED_LEFT_SIDEBAR_WIDTH),
                lastLeftSidebarWidth: current.leftSidebarWidth,
                isFlyoutOpen: true
            };
            else if (!event.matches && current.isFlyoutOpen) // The user is resizing "upwards", eg. going from mobile to desktop.
            // Flyout was previously open, let's keep it open by moving to the un-collapsed sidebar instead
            return {
                ...current,
                isResizing: false,
                isLeftSidebarCollapsed: false,
                leftSidebarWidth: Math.max(current.lastLeftSidebarWidth, (0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH)),
                isFlyoutOpen: false
            };
            return current;
        });
    });
    // Close the flyout when the "escape" key is pressed.
    (0, $kVO3J.default)({
        onClose: closeMobileFlyout,
        isDisabled: !isFlyoutOpen
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, mobileMediaQuery?.matches && /**
     * On desktop, the `onClick` handlers controls the temporary flyout behavior.
     * This is an intentionally mouse-only experience, it may even be disruptive with keyboard navigation.
     *
     * On mobile, the `onClick` handler controls the toggled flyout behaviour.
     * This is not intended to be how you use this with a keyboard, there is a ResizeButton for this intentionally instead.
     */ // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $ba986c6a8de8190f$var$hiddenBackdropStyles,
            isFlyoutOpen && $ba986c6a8de8190f$var$openBackdropStyles
        ],
        onClick: closeMobileFlyout
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $c9QmQ.default), {
        ref: leftSideBarRef,
        testId: testId,
        onMouseOver: !mobileMediaQuery?.matches ? onMouseOver : undefined,
        onMouseLeave: !mobileMediaQuery?.matches ? onMouseLeave : undefined,
        onClick: mobileMediaQuery?.matches ? openMobileFlyout : undefined,
        id: id,
        isFixed: isFixed
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cbHW.default), {
        variableName: (0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH),
        value: notFirstRun.current ? leftSidebarWidth : leftSidebarWidthOnMount,
        mobileValue: (0, $ho1Ek.MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH)
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $cJoHg.default), {
        isFixed: isFixed,
        isFlyoutOpen: isFlyoutOpen
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $bxILY.default), {
        isFlyoutOpen: isFlyoutOpen,
        isLeftSidebarCollapsed: isLeftSidebarCollapsed,
        hasCollapsedState: !notFirstRun.current && collapsedState === 'collapsed',
        testId: testId && `${testId}-resize-children-wrapper`
    }, children), /*#__PURE__*/ (0, $byn9U.jsx)((0, $3QLIJ.default), {
        testId: testId,
        valueTextLabel: valueTextLabel,
        resizeGrabAreaLabel: resizeGrabAreaLabel,
        resizeButtonLabel: resizeButtonLabel,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        onResizeStart: onResizeStart,
        onResizeEnd: onResizeEnd
    }))));
};
var $ba986c6a8de8190f$export$2e2bcd8739ae039 = $ba986c6a8de8190f$var$LeftSidebar;

});
const $d58b680a02f4d6a4$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $d58b680a02f4d6a4$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $d58b680a02f4d6a4$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';

parcelRegister("ikQZw", function(module, exports) {

$parcel$export(module.exports, "SidebarResizeContext", () => $9a41c619a58ecd93$export$aa5a712eea4c2ae8);
$parcel$export(module.exports, "usePageLayoutResize", () => $9a41c619a58ecd93$export$10c7104037a7af62);
$parcel$export(module.exports, "useLeftSidebarFlyoutLock", () => $9a41c619a58ecd93$export$94561f6055639ef7);
$parcel$export(module.exports, "UNSAFE_useSetLeftSidebarState", () => $9a41c619a58ecd93$export$f37b9b9b883352cf);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");

var $XHGTv = parcelRequire("XHGTv");
const $9a41c619a58ecd93$var$leftSidebarState = {
    isFlyoutOpen: false,
    isResizing: false,
    isLeftSidebarCollapsed: false,
    leftSidebarWidth: 0,
    lastLeftSidebarWidth: 0,
    flyoutLockCount: 0,
    isFixed: true
};
const $9a41c619a58ecd93$export$aa5a712eea4c2ae8 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, $5Q9wj.default),
    collapseLeftSidebar: (0, $5Q9wj.default),
    leftSidebarState: $9a41c619a58ecd93$var$leftSidebarState,
    setLeftSidebarState: (0, $5Q9wj.default),
    toggleLeftSidebar: (0, $5Q9wj.default)
});
const $9a41c619a58ecd93$export$10c7104037a7af62 = ()=>{
    const { setLeftSidebarState: setLeftSidebarState, ...context } = (0, $eUqFw.useContext)($9a41c619a58ecd93$export$aa5a712eea4c2ae8);
    return context;
};
const $9a41c619a58ecd93$export$94561f6055639ef7 = ()=>{
    const { setLeftSidebarState: setLeftSidebarState } = (0, $eUqFw.useContext)($9a41c619a58ecd93$export$aa5a712eea4c2ae8);
    (0, $eUqFw.useEffect)(()=>{
        setLeftSidebarState((current)=>({
                ...current,
                flyoutLockCount: current.flyoutLockCount + 1
            }));
        return ()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    flyoutLockCount: current.flyoutLockCount - 1
                }));
        };
    }, [
        setLeftSidebarState
    ]);
};
const $9a41c619a58ecd93$export$f37b9b9b883352cf = ()=>{
    const { setLeftSidebarState: setLeftSidebarState } = (0, $eUqFw.useContext)($9a41c619a58ecd93$export$aa5a712eea4c2ae8);
    return (0, $XHGTv.getBooleanFF)('platform.atlassian.griffin-navigation-redesign') ? setLeftSidebarState : (0, $5Q9wj.default);
};

});

parcelRegister("3QLIJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cf1435c6e64160e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $74BVL = parcelRequire("74BVL");

var $8yx6O = parcelRequire("8yx6O");

var $eT0WN = parcelRequire("eT0WN");

var $ho1Ek = parcelRequire("ho1Ek");

var $a353s = parcelRequire("a353s");

var $ikQZw = parcelRequire("ikQZw");

var $e1gck = parcelRequire("e1gck");

var $i4a2R = parcelRequire("i4a2R");

var $4xMfW = parcelRequire("4xMfW");
function $2cf1435c6e64160e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2cf1435c6e64160e$var$cssSelector = {
    [(0, $ho1Ek.RESIZE_CONTROL_SELECTOR)]: true
};
const $2cf1435c6e64160e$var$resizeControlStyles = {
    name: "ow3ovp",
    styles: "position:absolute;inset-block-end:0;inset-block-start:0;inset-inline-start:100%;outline:none"
};
const $2cf1435c6e64160e$var$showResizeButtonStyles = {
    name: "1a6byq5",
    styles: "--ds--resize-button--opacity:1"
};
// @ts-expect-error adding `!important` to style rules is currently a type error
const $2cf1435c6e64160e$var$globalResizingStyles = {
    name: "e4avm6",
    styles: "*{cursor:ew-resize !important;user-select:none !important;}iframe{pointer-events:none !important;}"
};
const $2cf1435c6e64160e$var$ResizeControl = ({ testId: testId, overrides: overrides, resizeButtonLabel: resizeButtonLabel = 'Current project sidebar', valueTextLabel: valueTextLabel = 'Width', resizeGrabAreaLabel: resizeGrabAreaLabel = 'Resize Current Project Sidebar', onResizeStart: onResizeStart, onResizeEnd: onResizeEnd })=>{
    const { toggleLeftSidebar: toggleLeftSidebar, collapseLeftSidebar: collapseLeftSidebar, leftSidebarState: leftSidebarState, setLeftSidebarState: setLeftSidebarState } = (0, $eUqFw.useContext)((0, $ikQZw.SidebarResizeContext));
    const { isLeftSidebarCollapsed: isLeftSidebarCollapsed } = leftSidebarState;
    const sidebarWidth = (0, $eUqFw.useRef)(leftSidebarState[0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH]);
    // Distance of mouse from left sidebar onMouseDown
    const offset = (0, $eUqFw.useRef)(0);
    const keyboardEventTimeout = (0, $eUqFw.useRef)();
    const [isGrabAreaFocused, setIsGrabAreaFocused] = (0, $eUqFw.useState)(false);
    const unbindEvents = (0, $eUqFw.useRef)(null);
    const mobileMediaQuery = (0, $eT0WN.UNSAFE_useMediaQuery)('below.sm');
    // Used in some cases to ensure function references don't have to change
    // TODO: more functions could use `stableSidebarState` rather than `leftSidebarState`
    const stableSidebarState = (0, $eUqFw.useRef)(leftSidebarState);
    (0, $eUqFw.useEffect)(()=>{
        stableSidebarState.current = leftSidebarState;
    }, [
        leftSidebarState
    ]);
    const toggleSideBar = (0, $eUqFw.useCallback)((event)=>{
        // don't cascade down to the LeftSidebarOuter
        event?.stopPropagation();
        toggleLeftSidebar();
    }, [
        toggleLeftSidebar
    ]);
    const onMouseDown = (event)=>{
        if (isLeftSidebarCollapsed) return;
        // Only allow left (primary) clicks to trigger resize as we've received
        // bug reports about right click unexpectedly beginning a resize.
        if (event.button !== 0) return;
        // It is possible for a mousedown to fire during a resize
        // Example: the user presses another pointer button while dragging
        if (leftSidebarState.isResizing) // the resize will be cancelled by our global event listeners
        return;
        offset.current = event.clientX - leftSidebarState[0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH] - (0, $a353s.getLeftPanelWidth)();
        unbindEvents.current = (0, $74BVL.bindAll)(window, [
            {
                type: 'mousemove',
                listener: function(event) {
                    onUpdateResize({
                        clientX: event.clientX
                    });
                }
            },
            {
                type: 'mouseup',
                listener: onFinishResizing
            },
            {
                type: 'mousedown',
                // this mousedown event listener is being added in the bubble phase
                // on a higher event target than the resize handle.
                // This means that the original mousedown event that triggers a resize
                // can hit this mousedown handler. To get around that, we only call
                // `onFinishResizing` after an animation frame so we don't pick up the original event
                // Alternatives:
                // 1. Add the window 'mousedown' event listener in the capture phase
                // 👎 A 'mousedown' during a resize would trigger a new resize to start
                // 2. Do 1. and call `event.preventDefault()`, then check for `event.defaultPrevented` inside
                // the grab handle `onMouseDown`
                // 👎 Not ideal to cancel events if we don't have to
                listener: (()=>{
                    let hasFramePassed = false;
                    requestAnimationFrame(()=>{
                        hasFramePassed = true;
                    });
                    return function listener() {
                        if (hasFramePassed) onFinishResizing();
                    };
                })()
            },
            {
                type: 'visibilitychange',
                listener: onFinishResizing
            },
            // A 'click' event should never be hit as the 'mouseup' will come first and cause
            // these event listeners to be unbound. I just added 'click' for extreme safety (paranoia)
            {
                type: 'click',
                listener: onFinishResizing
            },
            {
                type: 'keydown',
                listener: (event)=>{
                    // Can cancel resizing by pressing "Escape"
                    // Will return sidebar to the same size it was before the resizing started
                    if (event.key === 'Escape') {
                        sidebarWidth.current = Math.max(leftSidebarState.lastLeftSidebarWidth, (0, $ho1Ek.COLLAPSED_LEFT_SIDEBAR_WIDTH));
                        document.documentElement.style.setProperty(`--${(0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH)}`, `${sidebarWidth.current}px`);
                        onFinishResizing();
                    }
                }
            }
        ]);
        document.documentElement.setAttribute((0, $ho1Ek.IS_SIDEBAR_DRAGGING), 'true');
        const newLeftbarState = {
            ...leftSidebarState,
            isResizing: true
        };
        setLeftSidebarState(newLeftbarState);
        onResizeStart && onResizeStart(newLeftbarState);
    };
    const onResizeOffLeftOfScreen = ()=>{
        onUpdateResize.cancel();
        unbindEvents.current?.();
        unbindEvents.current = null;
        document.documentElement.removeAttribute((0, $ho1Ek.IS_SIDEBAR_DRAGGING));
        offset.current = 0;
        collapseLeftSidebar(undefined, true);
    };
    // It is important that `onUpdateResize` is a stable function reference, so that:
    // 1. we ensure we are correctly throttling with `requestAnimationFrame`
    // 2. that a `onUpdateResize` will cancel the one and only pending frame
    // To help ensure `onUpdateResize` is stable, we are putting the last state into a ref
    const [onUpdateResize] = (0, $eUqFw.useState)(()=>(0, $8yx6O.default)(({ clientX: clientX })=>{
            // Allow the sidebar to be 50% of the available page width
            const maxWidth = Math.round(window.innerWidth / 2);
            const leftPanelWidth = (0, $a353s.getLeftPanelWidth)();
            const leftSidebarWidth = stableSidebarState.current.leftSidebarWidth;
            const hasResizedOffLeftOfScreen = clientX < 0;
            if (hasResizedOffLeftOfScreen) {
                onResizeOffLeftOfScreen();
                return;
            }
            const delta = Math.max(Math.min(clientX - leftSidebarWidth - leftPanelWidth, maxWidth - leftSidebarWidth - leftPanelWidth), (0, $ho1Ek.COLLAPSED_LEFT_SIDEBAR_WIDTH) - leftSidebarWidth - leftPanelWidth);
            sidebarWidth.current = Math.max(leftSidebarWidth + delta - offset.current, (0, $ho1Ek.COLLAPSED_LEFT_SIDEBAR_WIDTH));
            document.documentElement.style.setProperty(`--${(0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH)}`, `${sidebarWidth.current}px`);
        }));
    const onFinishResizing = ()=>{
        if (isLeftSidebarCollapsed) return;
        document.documentElement.removeAttribute((0, $ho1Ek.IS_SIDEBAR_DRAGGING));
        // TODO: the control flow is pretty strange as the first codepath which calls `collapseLeftSidebar()`
        // does not return an updated state snapshot.
        let updatedLeftSidebarState = null;
        // If it is dragged to below the threshold,
        // collapse the navigation
        if (sidebarWidth.current < (0, $ho1Ek.MIN_LEFT_SIDEBAR_DRAG_THRESHOLD)) {
            // TODO: for this codepath, `onCollapse` occurs before `onResizeEnd` which seems wrong
            document.documentElement.style.setProperty(`--${(0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH)}`, `${(0, $ho1Ek.COLLAPSED_LEFT_SIDEBAR_WIDTH)}px`);
            collapseLeftSidebar(undefined, true);
        } else if (sidebarWidth.current > (0, $ho1Ek.MIN_LEFT_SIDEBAR_DRAG_THRESHOLD) && sidebarWidth.current < (0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH)) {
            document.documentElement.style.setProperty(`--${(0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH)}`, `${(0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH)}px`);
            updatedLeftSidebarState = {
                ...leftSidebarState,
                isResizing: false,
                [(0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH)]: (0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH),
                lastLeftSidebarWidth: (0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH)
            };
            setLeftSidebarState(updatedLeftSidebarState);
        } else {
            // otherwise resize it to the desired width
            updatedLeftSidebarState = {
                ...leftSidebarState,
                isResizing: false,
                [(0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH)]: sidebarWidth.current,
                lastLeftSidebarWidth: sidebarWidth.current
            };
            setLeftSidebarState(updatedLeftSidebarState);
        }
        unbindEvents.current?.();
        unbindEvents.current = null;
        onUpdateResize.cancel();
        sidebarWidth.current = 0;
        offset.current = 0;
        // TODO: no idea why this is in an animation frame
        requestAnimationFrame(()=>{
            setIsGrabAreaFocused(false);
            // Note: the `collapseSidebar` codepath does not return state, so we need to pull it from the ref
            onResizeEnd?.(updatedLeftSidebarState ?? stableSidebarState.current);
        });
    };
    const onKeyDown = (event)=>{
        if (isLeftSidebarCollapsed || !isGrabAreaFocused) return false;
        const { key: key } = event;
        const isLeftOrTopArrow = key === 'ArrowLeft' || key === 'ArrowUp' || key === 'Left' || key === 'Up';
        const isRightOrBottomArrow = key === 'ArrowRight' || key === 'ArrowDown' || key === 'Right' || key === 'Down';
        const isSpaceOrEnter = key === 'Enter' || key === 'Spacebar' || key === ' ';
        if (isSpaceOrEnter) {
            toggleSideBar(event);
            event.preventDefault();
        }
        if (isLeftOrTopArrow || isRightOrBottomArrow) {
            event.preventDefault(); // prevent content scroll
            onResizeStart && onResizeStart(leftSidebarState);
            const step = 10;
            const stepValue = isLeftOrTopArrow ? -step : step;
            const { leftSidebarWidth: leftSidebarWidth } = leftSidebarState;
            const maxWidth = Math.round(window.innerWidth / 2) - (0, $a353s.getLeftPanelWidth)();
            const hasModifierKey = event.metaKey || event.altKey || event.ctrlKey || event.shiftKey;
            let width = leftSidebarWidth + stepValue;
            if (width <= (0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH)) {
                width = (0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH);
                document.documentElement.style.setProperty(`--${(0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH)}`, `${(0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH) - 20}px`);
            } else if (width > maxWidth) {
                width = maxWidth;
                document.documentElement.style.setProperty(`--${(0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH)}`, `${maxWidth + 20}px`);
            } else if (hasModifierKey) width = isRightOrBottomArrow ? maxWidth : (0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH);
            // Nesting the setTimeout within requestAnimationFrame helps
            // the browser schedule the setTimeout call in an efficient manner
            requestAnimationFrame(()=>{
                keyboardEventTimeout.current = window.setTimeout(()=>{
                    keyboardEventTimeout.current && clearTimeout(keyboardEventTimeout.current);
                    document.documentElement.style.setProperty(`--${(0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH)}`, `${width}px`);
                    const updatedLeftSidebarState = {
                        ...leftSidebarState,
                        [(0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH)]: width,
                        lastLeftSidebarWidth: width
                    };
                    setLeftSidebarState(updatedLeftSidebarState);
                    onResizeEnd && onResizeEnd(updatedLeftSidebarState);
                }, 50);
            });
        }
    };
    const onFocus = (0, $eUqFw.useCallback)(()=>{
        setIsGrabAreaFocused(true);
    }, []);
    const onBlur = (0, $eUqFw.useCallback)(()=>{
        setIsGrabAreaFocused(false);
    }, []);
    const resizeButton = {
        render: (Component, props)=>/*#__PURE__*/ (0, $byn9U.jsx)(Component, props),
        ...overrides && overrides.ResizeButton
    };
    // This width is calculated once only on mount.
    // This means resizing the window will cause this value to be incorrect for screen reader users,
    // however this comes with a substantial performance gain and so is considered acceptable.
    const maxAriaWidth = (0, $eUqFw.useMemo)(()=>{
        const innerWidth = typeof window === 'undefined' ? 0 : window.innerWidth;
        return Math.round(innerWidth / 2) - (0, $a353s.getLeftPanelWidth)();
    }, []);
    const leftSidebarPercentageExpanded = (0, $a353s.getLeftSidebarPercentage)(leftSidebarState.leftSidebarWidth, maxAriaWidth);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...$2cf1435c6e64160e$var$cssSelector,
        css: [
            $2cf1435c6e64160e$var$resizeControlStyles,
            (isGrabAreaFocused || isLeftSidebarCollapsed) && $2cf1435c6e64160e$var$showResizeButtonStyles
        ]
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4xMfW.default), {
        testId: testId && `${testId}-shadow`
    }), // Only show the GrabArea if we're not on the mobile viewport
    !mobileMediaQuery?.matches && /*#__PURE__*/ (0, $byn9U.jsx)((0, $e1gck.default), {
        isDisabled: isLeftSidebarCollapsed,
        isLeftSidebarCollapsed: isLeftSidebarCollapsed,
        label: resizeGrabAreaLabel,
        valueTextLabel: valueTextLabel,
        leftSidebarPercentageExpanded: leftSidebarPercentageExpanded,
        onBlur: onBlur,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onMouseDown: onMouseDown,
        testId: testId && `${testId}-grab-area`
    }), resizeButton.render((0, $i4a2R.default), {
        isLeftSidebarCollapsed: mobileMediaQuery?.matches ? !leftSidebarState.isFlyoutOpen : isLeftSidebarCollapsed,
        label: resizeButtonLabel,
        onClick: toggleSideBar,
        testId: testId && `${testId}-resize-button`
    })), leftSidebarState.isResizing ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $byn9U.Global), {
        styles: $2cf1435c6e64160e$var$globalResizingStyles
    }) : null);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2cf1435c6e64160e$export$2e2bcd8739ae039 = $2cf1435c6e64160e$var$ResizeControl;

});
parcelRegister("e1gck", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a25b5d5d6a7f6f0$export$2e2bcd8739ae039);
/* eslint-disable react/react-in-jsx-scope */ /**
                                               * @jsxRuntime classic
                                               */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $PdmhA = parcelRequire("PdmhA");

var $ho1Ek = parcelRequire("ho1Ek");
function $8a25b5d5d6a7f6f0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Determines the color of the grab line.
 *
 * Used on internal leaf node, so naming collisions won't matter.
 */ const $8a25b5d5d6a7f6f0$var$varLineColor = '--ds-line';
const $8a25b5d5d6a7f6f0$var$grabAreaStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: "var(--ds-space-200, 16px)",
    height: '100%',
    padding: 0,
    backgroundColor: 'transparent',
    border: 0,
    cursor: 'ew-resize',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-moz-focus-inner': {
        border: 0
    },
    '&:focus': {
        outline: 0
    },
    '&:enabled:hover, &:enabled:focus, &:enabled:active': {
        [$8a25b5d5d6a7f6f0$var$varLineColor]: `var(--ds-border-selected, ${(0, $PdmhA.B200)})`
    }
});
const $8a25b5d5d6a7f6f0$var$grabAreaReducedHeightStyles = /*#__PURE__*/ (0, $byn9U.css)({
    height: `calc(100% - ${"var(--ds-space-600, 3rem)"} * 2)`,
    position: 'absolute',
    insetBlockEnd: 0
});
const $8a25b5d5d6a7f6f0$var$grabAreaCollapsedStyles = {
    name: "19x2bwh",
    styles: "padding:0;background-color:transparent;border:0;cursor:default"
};
const $8a25b5d5d6a7f6f0$var$lineStyles = {
    name: "w4swnc",
    styles: "display:block;width:var(--ds-border-width-outline, 2px);height:100%;background-color:var(--ds-line);transition:background-color 200ms"
};
const $8a25b5d5d6a7f6f0$var$grabAreaLineSelector = {
    [(0, $ho1Ek.GRAB_AREA_LINE_SELECTOR)]: true
};
const $8a25b5d5d6a7f6f0$var$grabAreaSelector = {
    [(0, $ho1Ek.GRAB_AREA_SELECTOR)]: true
};
const $8a25b5d5d6a7f6f0$var$GrabArea = ({ testId: testId, valueTextLabel: valueTextLabel = 'Width', isDisabled: isDisabled, isLeftSidebarCollapsed: isLeftSidebarCollapsed, label: label, leftSidebarPercentageExpanded: leftSidebarPercentageExpanded, onKeyDown: onKeyDown, onMouseDown: onMouseDown, onBlur: onBlur, onFocus: onFocus, ref: ref, ...rest })=>/*#__PURE__*/ (0, $byn9U.jsx)("button", {
        ...$8a25b5d5d6a7f6f0$var$grabAreaSelector,
        "aria-label": label,
        "data-testid": testId,
        disabled: isDisabled,
        "aria-hidden": isLeftSidebarCollapsed,
        type: "button",
        // The slider role is applied to a button to utilize the native
        // interactive and disabled functionality on the resize slider. While a
        // range input would be more semantically accurate, it does not affect
        // usability.
        role: "slider",
        css: [
            $8a25b5d5d6a7f6f0$var$grabAreaStyles,
            isLeftSidebarCollapsed && $8a25b5d5d6a7f6f0$var$grabAreaCollapsedStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $XHGTv.getBooleanFF)('platform.design-system-team.page-layout-resize-button-fix_u0qxv') && isLeftSidebarCollapsed && $8a25b5d5d6a7f6f0$var$grabAreaReducedHeightStyles
        ],
        "aria-orientation": "vertical",
        "aria-valuenow": leftSidebarPercentageExpanded,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuetext": `${valueTextLabel} ${leftSidebarPercentageExpanded}%`,
        onKeyDown: onKeyDown,
        onMouseDown: onMouseDown,
        onFocus: onFocus,
        onBlur: onBlur,
        ...rest
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $8a25b5d5d6a7f6f0$var$lineStyles,
        ...$8a25b5d5d6a7f6f0$var$grabAreaLineSelector
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8a25b5d5d6a7f6f0$export$2e2bcd8739ae039 = $8a25b5d5d6a7f6f0$var$GrabArea;

});

parcelRegister("i4a2R", function(module, exports) {

$parcel$export(module.exports, "default", () => $2dae62e53e3b7495$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $dtaN9 = parcelRequire("dtaN9");


var $5LHuc = parcelRequire("5LHuc");

var $XHGTv = parcelRequire("XHGTv");

var $4Ywu9 = parcelRequire("4Ywu9");

var $PdmhA = parcelRequire("PdmhA");

var $ho1Ek = parcelRequire("ho1Ek");
function $2dae62e53e3b7495$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2dae62e53e3b7495$var$increaseHitAreaStyles = /*#__PURE__*/ (0, $byn9U.css)({
    position: 'absolute',
    insetBlockEnd: `${"var(--ds-space-negative-100, -8px)"}`,
    insetBlockStart: `${"var(--ds-space-negative-100, -8px)"}`,
    insetInlineEnd: `${"var(--ds-space-negative-150, -12px)"}`,
    insetInlineStart: `${"var(--ds-space-negative-100, -8px)"}`
});
const $2dae62e53e3b7495$var$furtherIncreasedHitAreasStyles = /*#__PURE__*/ (0, $byn9U.css)({
    insetBlockEnd: `${"var(--ds-space-negative-300, -24px)"}`,
    insetBlockStart: `${"var(--ds-space-negative-300, -24px)"}`
});
const $2dae62e53e3b7495$var$mobileStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $4Ywu9.UNSAFE_media).below.sm]: {
        opacity: 1
    }
});
const $2dae62e53e3b7495$var$resizeIconButtonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: 24,
    height: 24,
    padding: "var(--ds-space-0, 0px)",
    position: 'absolute',
    backgroundColor: `var(--ds-surface-overlay, ${(0, $PdmhA.N0)})`,
    border: 0,
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- TODO: https://product-fabric.atlassian.net/browse/DSP-3392; this boxShadow needs further investigation, along with the hover and active background colors.
    boxShadow: `0 0 0 1px ${(0, $PdmhA.N30A)}, 0 2px 4px 1px ${(0, $PdmhA.N30A)}`,
    color: `var(--ds-text-subtle, ${(0, $PdmhA.N200)})`,
    cursor: 'pointer',
    insetBlockStart: "var(--ds-space-400, 32px)",
    insetInlineStart: 0,
    /**
   * The fallback value of 0 ensures that the button is hidden by default,
   * unless some parent (or the button itself) overrides it.
   */ opacity: `var(--ds--resize-button--opacity,0)`,
    outline: 0,
    transform: 'translateX(-50%)',
    transition: `
    background-color ${(0, $5LHuc.smallDurationMs)}ms linear,
    color ${(0, $5LHuc.smallDurationMs)}ms linear,
    opacity ${(0, $5LHuc.mediumDurationMs)}ms ${(0, $d58b680a02f4d6a4$export$57636bb43b1ccbb0)}
  `,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        backgroundColor: `var(--ds-background-selected-bold, ${(0, $PdmhA.B100)})`,
        color: `var(--ds-text-inverse, ${(0, $PdmhA.N0)})`,
        opacity: 1
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':active, :focus': {
        backgroundColor: `var(--ds-background-selected-bold-hovered, ${(0, $PdmhA.B200)})`,
        color: `var(--ds-text-inverse, ${(0, $PdmhA.N0)})`,
        opacity: 1
    }
});
const $2dae62e53e3b7495$var$resizeIconButtonExpandedStyles = {
    name: "1bl2513",
    styles: "transform:rotate(180deg);transform-origin:7px"
};
const $2dae62e53e3b7495$var$preventDefault = (event)=>event.preventDefault();
const $2dae62e53e3b7495$var$cssSelector = {
    [(0, $ho1Ek.RESIZE_BUTTON_SELECTOR)]: true
};
const $2dae62e53e3b7495$var$ResizeButton = ({ isLeftSidebarCollapsed: isLeftSidebarCollapsed, label: label, testId: testId, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)("button", {
        ...$2dae62e53e3b7495$var$cssSelector,
        "aria-expanded": !isLeftSidebarCollapsed,
        "aria-label": label,
        type: "button",
        // The error goes away when we remove the spread ...props
        css: [
            $2dae62e53e3b7495$var$resizeIconButtonStyles,
            $2dae62e53e3b7495$var$mobileStyles,
            !isLeftSidebarCollapsed && $2dae62e53e3b7495$var$resizeIconButtonExpandedStyles
        ],
        "data-testid": testId,
        // Prevents focus staying attached to the button when pressed
        onMouseDown: $2dae62e53e3b7495$var$preventDefault,
        ...props
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
        label: ""
    }), (0, $XHGTv.getBooleanFF)('platform.design-system-team.page-layout-resize-button-fix_u0qxv') ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            $2dae62e53e3b7495$var$increaseHitAreaStyles,
            $2dae62e53e3b7495$var$furtherIncreasedHitAreasStyles
        ]
    }) : /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $2dae62e53e3b7495$var$increaseHitAreaStyles
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2dae62e53e3b7495$export$2e2bcd8739ae039 = $2dae62e53e3b7495$var$ResizeButton;

});

parcelRegister("4xMfW", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f6598dc29fb8ee8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");


var $1RrwL = parcelRequire("1RrwL");
const $6f6598dc29fb8ee8$var$colorStops = `
    rgba(0, 0, 0, 0.2) 0px,
    rgba(0, 0, 0, 0.2) 1px,
    rgba(0, 0, 0, 0.1) 1px,
    rgba(0, 0, 0, 0) 100%
  `;
const $6f6598dc29fb8ee8$var$direction = 'to left';
const $6f6598dc29fb8ee8$var$transitionDuration = '0.22s';
const $6f6598dc29fb8ee8$var$shadowStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: 3,
    position: 'absolute',
    background: `var(--ds-border, ${`linear-gradient(${$6f6598dc29fb8ee8$var$direction}, ${$6f6598dc29fb8ee8$var$colorStops})`})`,
    insetBlockEnd: 0,
    insetBlockStart: 0,
    insetInlineStart: -1,
    opacity: 0.5,
    pointerEvents: 'none',
    transitionDuration: $6f6598dc29fb8ee8$var$transitionDuration,
    transitionProperty: 'left, opacity, width',
    transitionTimingFunction: (0, $d58b680a02f4d6a4$export$57636bb43b1ccbb0)
});
const $6f6598dc29fb8ee8$var$draggingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: 6,
    background: `var(--ds-background-neutral-subtle, ${`linear-gradient(${$6f6598dc29fb8ee8$var$direction}, ${$6f6598dc29fb8ee8$var$colorStops})`})`,
    insetInlineStart: "var(--ds-space-negative-075, -6px)",
    opacity: 0.8
});
const $6f6598dc29fb8ee8$var$Shadow = ({ testId: testId })=>{
    const isDragging = (0, $1RrwL.default)();
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        css: [
            $6f6598dc29fb8ee8$var$shadowStyles,
            isDragging && $6f6598dc29fb8ee8$var$draggingStyles
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6f6598dc29fb8ee8$export$2e2bcd8739ae039 = $6f6598dc29fb8ee8$var$Shadow;

});
parcelRegister("1RrwL", function(module, exports) {

$parcel$export(module.exports, "default", () => $f34927c3d83b90ce$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ho1Ek = parcelRequire("ho1Ek");
const $f34927c3d83b90ce$var$getIsDragging = ()=>{
    // SSR bail-out because document is undefined on the server
    if (typeof document === 'undefined') return false;
    return document.documentElement.getAttribute((0, $ho1Ek.IS_SIDEBAR_DRAGGING)) === 'true';
};
// TODO: I think this should be derived from the sidebar state,
// and not indirectly from observing an attribute change
const $f34927c3d83b90ce$var$useIsSidebarDragging = ()=>{
    const [isDragging, setIsDragging] = (0, $eUqFw.useState)($f34927c3d83b90ce$var$getIsDragging);
    (0, $eUqFw.useEffect)(()=>{
        const observer = new MutationObserver(()=>{
            setIsDragging($f34927c3d83b90ce$var$getIsDragging);
        });
        observer.observe(document.documentElement, {
            attributeFilter: [
                (0, $ho1Ek.IS_SIDEBAR_DRAGGING)
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return isDragging;
};
var $f34927c3d83b90ce$export$2e2bcd8739ae039 = $f34927c3d83b90ce$var$useIsSidebarDragging;

});



parcelRegister("cJoHg", function(module, exports) {

$parcel$export(module.exports, "default", () => $4edc19a03a491edc$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $8YJjX = parcelRequire("8YJjX");

var $4Ywu9 = parcelRequire("4Ywu9");

var $ho1Ek = parcelRequire("ho1Ek");

var $1RrwL = parcelRequire("1RrwL");
function $4edc19a03a491edc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $4edc19a03a491edc$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $byn9U.css)((0, $8YJjX.prefersReducedMotion)());
const $4edc19a03a491edc$var$mobileStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $4Ywu9.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $ho1Ek.MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH)}px`,
        position: 'fixed',
        insetBlockEnd: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        insetBlockStart: `calc(${(0, $ho1Ek.BANNER_HEIGHT)} + ${(0, $ho1Ek.TOP_NAVIGATION_HEIGHT)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        insetInlineStart: `${(0, $ho1Ek.LEFT_PANEL_WIDTH)}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $ho1Ek.TRANSITION_DURATION)}ms ${(0, $d58b680a02f4d6a4$export$57636bb43b1ccbb0)} 0s`
    }
});
const $4edc19a03a491edc$var$mobileInnerFlyoutStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $4Ywu9.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `min(90vw, ${(0, $ho1Ek.MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH)}px)`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: (0, $ho1Ek.MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $ho1Ek.TRANSITION_DURATION)}ms ${(0, $d58b680a02f4d6a4$export$57636bb43b1ccbb0)} 0s, box-shadow ${(0, $ho1Ek.TRANSITION_DURATION)}ms ${(0, $d58b680a02f4d6a4$export$57636bb43b1ccbb0)} 0s`
    }
});
/**
 * This inner wrapper is required to allow the sidebar to be `position: fixed`.
 *
 * If we were to apply `position: fixed` to the outer wrapper, it will be popped
 * out of its flex container and Main would stretch to occupy all the space.
 */ const $4edc19a03a491edc$var$fixedInnerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $ho1Ek.LEFT_SIDEBAR_WIDTH)}`,
    position: 'fixed',
    insetBlockEnd: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: `calc(${(0, $ho1Ek.BANNER_HEIGHT)} + ${(0, $ho1Ek.TOP_NAVIGATION_HEIGHT)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: `${(0, $ho1Ek.LEFT_PANEL_WIDTH)}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width ${(0, $ho1Ek.TRANSITION_DURATION)}ms ${(0, $d58b680a02f4d6a4$export$57636bb43b1ccbb0)} 0s`
});
const $4edc19a03a491edc$var$fixedInnerFlyoutStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $ho1Ek.LEFT_SIDEBAR_FLYOUT_WIDTH)
});
/**
 * Static in the sense of `position: static`.
 *
 * It will expand the page height to fit its content.
 */ const $4edc19a03a491edc$var$staticInnerStyles = {
    name: "13udsys",
    styles: "height:100%"
};
const $4edc19a03a491edc$var$draggingStyles = {
    name: "jlx54q",
    styles: "cursor:ew-resize;transition:none"
};
const $4edc19a03a491edc$var$LeftSidebarInner = ({ children: children, isFixed: isFixed = false, isFlyoutOpen: isFlyoutOpen = false })=>{
    const isDragging = (0, $1RrwL.default)();
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            // mobile viewport styles
            $4edc19a03a491edc$var$mobileStyles,
            isFlyoutOpen && $4edc19a03a491edc$var$mobileInnerFlyoutStyles,
            // generic styles
            !isFixed && $4edc19a03a491edc$var$staticInnerStyles,
            isFixed && $4edc19a03a491edc$var$fixedInnerStyles,
            isFixed && isFlyoutOpen && $4edc19a03a491edc$var$fixedInnerFlyoutStyles,
            isDragging && $4edc19a03a491edc$var$draggingStyles,
            $4edc19a03a491edc$var$prefersReducedMotionStyles
        ]
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4edc19a03a491edc$export$2e2bcd8739ae039 = $4edc19a03a491edc$var$LeftSidebarInner;

});

parcelRegister("c9QmQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a594c1cfdafacace$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8YJjX = parcelRequire("8YJjX");

var $4Ywu9 = parcelRequire("4Ywu9");

var $ho1Ek = parcelRequire("ho1Ek");

var $1RrwL = parcelRequire("1RrwL");

var $a353s = parcelRequire("a353s");

var $ikQZw = parcelRequire("ikQZw");

var $gl6Cr = parcelRequire("gl6Cr");
function $a594c1cfdafacace$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $a594c1cfdafacace$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $byn9U.css)((0, $8YJjX.prefersReducedMotion)());
const $a594c1cfdafacace$var$mobileStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $4Ywu9.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $ho1Ek.MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH),
        cursor: 'pointer',
        opacity: 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $ho1Ek.TRANSITION_DURATION)}ms ${(0, $d58b680a02f4d6a4$export$57636bb43b1ccbb0)} 0s`,
        '&::after': {
            display: 'inline-block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            maxWidth: (0, $ho1Ek.MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH),
            content: "''"
        }
    }
});
const $a594c1cfdafacace$var$mobileFlyoutStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $4Ywu9.UNSAFE_media).below.sm]: {
        cursor: 'revert'
    }
});
const $a594c1cfdafacace$var$outerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $ho1Ek.LEFT_SIDEBAR_WIDTH),
    position: 'relative',
    zIndex: 1,
    marginInlineStart: "var(--ds-space-0, 0px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width ${(0, $ho1Ek.TRANSITION_DURATION)}ms ${(0, $d58b680a02f4d6a4$export$57636bb43b1ccbb0)} 0s`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        '--ds--resize-button--opacity': 1
    }
});
const $a594c1cfdafacace$var$draggingStyles = {
    name: "jlx54q",
    styles: "cursor:ew-resize;transition:none"
};
/**
 * In fixed mode this element's child is taken out of the document flow.
 * It doesn't take up the width as expected,
 * so the pseudo element forces it to take up the necessary width.
 */ const $a594c1cfdafacace$var$fixedStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::after': {
        display: 'inline-block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $ho1Ek.LEFT_SIDEBAR_WIDTH)}`,
        content: "''"
    }
});
const $a594c1cfdafacace$var$flyoutStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $ho1Ek.LEFT_SIDEBAR_FLYOUT_WIDTH)
});
const $a594c1cfdafacace$var$flyoutFixedStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $ho1Ek.COLLAPSED_LEFT_SIDEBAR_WIDTH)
});
const $a594c1cfdafacace$var$selector = (0, $a353s.getPageLayoutSlotSelector)('left-sidebar');
const $a594c1cfdafacace$var$LeftSidebarOuter = ({ children: children, isFixed: isFixed = false, testId: // NOTE: We explicitly require this via props because of `LeftSidebarWithoutResize`
testId, onMouseLeave: onMouseLeave, onMouseOver: onMouseOver, onClick: onClick, id: id }, ref)=>{
    const isDragging = (0, $1RrwL.default)();
    const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen } } = (0, $eUqFw.useContext)((0, $ikQZw.SidebarResizeContext));
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $gl6Cr.default), {
        isSidebar: true
    }, ({ className: className })=>/**
     * On desktop, the `onMouseOver|onMouseLeave` handlers controls the temporary flyout behavior.
     * This is an intentionally mouse-only experience, it may even be disruptive with keyboard navigation.
     *
     * On mobile, the `onClick` handler controls the toggled flyout behaviour.
     * This is not intended to be how you use this with a keyboard, there is a ResizeButton for this intentionally instead.
     */ // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: [
                // mobile viewport styles
                $a594c1cfdafacace$var$mobileStyles,
                isFlyoutOpen && $a594c1cfdafacace$var$mobileFlyoutStyles,
                // generic styles
                $a594c1cfdafacace$var$outerStyles,
                isFixed && $a594c1cfdafacace$var$fixedStyles,
                isFlyoutOpen && $a594c1cfdafacace$var$flyoutStyles,
                isFlyoutOpen && isFixed && $a594c1cfdafacace$var$flyoutFixedStyles,
                isDragging && $a594c1cfdafacace$var$draggingStyles,
                $a594c1cfdafacace$var$prefersReducedMotionStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            // We are adding additional functionality for hover, so this should
            // not have associated key events.
            // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
            onMouseOver: onMouseOver,
            onMouseLeave: onMouseLeave,
            onClick: onClick,
            ref: ref,
            ...$a594c1cfdafacace$var$selector
        }, children));
};
var $a594c1cfdafacace$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.forwardRef)($a594c1cfdafacace$var$LeftSidebarOuter);

});

parcelRegister("bxILY", function(module, exports) {

$parcel$export(module.exports, "default", () => $1473b5175591b507$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $8YJjX = parcelRequire("8YJjX");

var $ho1Ek = parcelRequire("ho1Ek");

var $eeFjl = parcelRequire("eeFjl");
function $1473b5175591b507$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $1473b5175591b507$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $byn9U.css)((0, $8YJjX.prefersReducedMotion)());
/**
 * The transition duration is intentionally set to 0ms.
 *
 * A transition is being used here to delay the setting of
 * opacity and visibility so that it syncs collapsing sidebar.
 */ const $1473b5175591b507$var$hideLeftSidebarContentsStyles = /*#__PURE__*/ (0, $byn9U.css)({
    opacity: 0,
    transition: `opacity 0ms linear, visibility 0ms linear`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transitionDelay: `${(0, $ho1Ek.TRANSITION_DURATION) - 100}ms`,
    visibility: 'hidden'
});
const $1473b5175591b507$var$resizableChildrenWrapperStyles = {
    name: "xz78rr",
    styles: "height:100%;opacity:1;overflow:hidden auto;transition:none;visibility:visible"
};
const $1473b5175591b507$var$fixedChildrenWrapperStyles = {
    name: "ax3w45",
    styles: "min-width:240px;height:100%"
};
const $1473b5175591b507$var$ResizableChildrenWrapper = ({ children: children, isLeftSidebarCollapsed: isLeftSidebarCollapsed = false, hasCollapsedState: hasCollapsedState = false, isFlyoutOpen: isFlyoutOpen = false, testId: testId })=>{
    const isCollapsing = (0, $eeFjl.default)();
    const isCollapsed = isLeftSidebarCollapsed || hasCollapsedState;
    const isHidden = isCollapsing || isCollapsed && !isFlyoutOpen;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $1473b5175591b507$var$resizableChildrenWrapperStyles,
            isHidden && $1473b5175591b507$var$hideLeftSidebarContentsStyles,
            $1473b5175591b507$var$prefersReducedMotionStyles
        ],
        "aria-hidden": isHidden,
        "data-testid": testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $1473b5175591b507$var$fixedChildrenWrapperStyles
    }, children));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1473b5175591b507$export$2e2bcd8739ae039 = $1473b5175591b507$var$ResizableChildrenWrapper;

});
parcelRegister("eeFjl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4c649bebf5f6629$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ho1Ek = parcelRequire("ho1Ek");
const $f4c649bebf5f6629$var$getIsCollapsing = ()=>{
    // SSR bail-out because document is undefined on the server
    if (typeof document === 'undefined') return false;
    return document.documentElement.getAttribute((0, $ho1Ek.IS_SIDEBAR_COLLAPSING)) === 'true';
};
const $f4c649bebf5f6629$var$useIsSidebarCollapsing = ()=>{
    const [isCollapsing, setIsCollapsing] = (0, $eUqFw.useState)($f4c649bebf5f6629$var$getIsCollapsing);
    (0, $eUqFw.useEffect)(()=>{
        const observer = new MutationObserver(()=>{
            setIsCollapsing($f4c649bebf5f6629$var$getIsCollapsing);
        });
        observer.observe(document.documentElement, {
            attributeFilter: [
                (0, $ho1Ek.IS_SIDEBAR_COLLAPSING)
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return isCollapsing;
};
var $f4c649bebf5f6629$export$2e2bcd8739ae039 = $f4c649bebf5f6629$var$useIsSidebarCollapsing;

});



parcelRegister("2Lkx0", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddeb7ceda1832e15$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ho1Ek = parcelRequire("ho1Ek");

var $a353s = parcelRequire("a353s");

var $cXUwP = parcelRequire("cXUwP");
var $6cmgz = parcelRequire("6cmgz");

var $cJoHg = parcelRequire("cJoHg");

var $c9QmQ = parcelRequire("c9QmQ");

var $8cbHW = parcelRequire("8cbHW");
/**
 * __Left sidebar without resize__
 *
 * Provides a slot for a left sidebar without resize within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $ddeb7ceda1832e15$var$LeftSidebarWithoutResize = (props)=>{
    const { children: children, id: id, width: width, isFixed: isFixed, shouldPersistWidth: shouldPersistWidth, testId: testId, skipLinkTitle: skipLinkTitle } = props;
    const leftSidebarWidth = (0, $a353s.resolveDimension)((0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH), width, shouldPersistWidth);
    (0, $eUqFw.useEffect)(()=>{
        (0, $cXUwP.default)({
            [(0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH)]: leftSidebarWidth
        });
        return ()=>{
            (0, $cXUwP.default)({
                [(0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH)]: 0
            });
        };
    }, [
        leftSidebarWidth
    ]);
    (0, $6cmgz.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $c9QmQ.default), {
        id: id,
        testId: testId,
        isFixed: isFixed
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cbHW.default), {
        variableName: (0, $ho1Ek.VAR_LEFT_SIDEBAR_WIDTH),
        value: leftSidebarWidth
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $cJoHg.default), {
        isFixed: isFixed
    }, children));
};
var $ddeb7ceda1832e15$export$2e2bcd8739ae039 = $ddeb7ceda1832e15$var$LeftSidebarWithoutResize;

});

parcelRegister("hNH8O", function(module, exports) {

$parcel$export(module.exports, "default", () => $eaee6b83a63d3216$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8YJjX = parcelRequire("8YJjX");


var $ho1Ek = parcelRequire("ho1Ek");

var $1RrwL = parcelRequire("1RrwL");

var $a353s = parcelRequire("a353s");

var $ikQZw = parcelRequire("ikQZw");
var $6cmgz = parcelRequire("6cmgz");

var $gl6Cr = parcelRequire("gl6Cr");
function $eaee6b83a63d3216$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $eaee6b83a63d3216$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $byn9U.css)((0, $8YJjX.prefersReducedMotion)());
const $eaee6b83a63d3216$var$mainStyles = /*#__PURE__*/ (0, $byn9U.css)({
    minWidth: 0,
    flexGrow: 1,
    marginInlineStart: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `margin-left ${(0, $ho1Ek.TRANSITION_DURATION)}ms ${(0, $d58b680a02f4d6a4$export$57636bb43b1ccbb0)} 0s`
});
const $eaee6b83a63d3216$var$draggingStyles = {
    name: "1wx2bp",
    styles: "transition:none"
};
/**
 * Adds a negative left margin to main,
 * which transitions at the same speed as the left sidebar's width increase.
 * This give an illusion that the flyout is appearing on top of the main content,
 * while main remains in place.
 */ const $eaee6b83a63d3216$var$flyoutStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineStart: `calc(-1 * var(--${(0, $ho1Ek.VAR_LEFT_SIDEBAR_FLYOUT)}, ${(0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_FLYOUT_WIDTH)}px) + ${(0, $ho1Ek.COLLAPSED_LEFT_SIDEBAR_WIDTH)}px)`
});
/**
 * __Main__
 *
 * Provides a slot for main content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $eaee6b83a63d3216$var$Main = (props)=>{
    const { children: children, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    (0, $6cmgz.useSkipLink)(id, skipLinkTitle);
    const isDragging = (0, $1RrwL.default)();
    const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen, isFixed: isFixed } } = (0, $eUqFw.useContext)((0, $ikQZw.SidebarResizeContext));
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $gl6Cr.default), null, ({ className: className })=>/*#__PURE__*/ (0, $byn9U.jsx)("main", {
            "data-testid": testId,
            css: [
                $eaee6b83a63d3216$var$mainStyles,
                isDragging && $eaee6b83a63d3216$var$draggingStyles,
                isFlyoutOpen && !isFixed && $eaee6b83a63d3216$var$flyoutStyles,
                $eaee6b83a63d3216$var$prefersReducedMotionStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            id: id,
            ...(0, $a353s.getPageLayoutSlotSelector)('main')
        }, children));
};
var $eaee6b83a63d3216$export$2e2bcd8739ae039 = $eaee6b83a63d3216$var$Main;

});

parcelRegister("4NoTP", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ecc4fbcc1004c95$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $4Ywu9 = parcelRequire("4Ywu9");

var $ho1Ek = parcelRequire("ho1Ek");

var $lDBEs = parcelRequire("lDBEs");
var $5cR7w = parcelRequire("5cR7w");

var $dFFYu = parcelRequire("dFFYu");
const $5ecc4fbcc1004c95$var$pageLayoutSelector = {
    [(0, $ho1Ek.PAGE_LAYOUT_CONTAINER_SELECTOR)]: true
};
const $5ecc4fbcc1004c95$var$gridTemplateAreasMobile = `
${''}
  "${(0, $ho1Ek.LEFT_PANEL)} ${(0, $ho1Ek.BANNER)}"
  ${''}
  "${(0, $ho1Ek.LEFT_PANEL)} ${(0, $ho1Ek.TOP_NAVIGATION)}"
  ${''}
  "${(0, $ho1Ek.LEFT_PANEL)} ${(0, $ho1Ek.CONTENT)}"
 `;
const $5ecc4fbcc1004c95$var$gridTemplateAreas = `
${''}
  "${(0, $ho1Ek.LEFT_PANEL)} ${(0, $ho1Ek.BANNER)} ${(0, $ho1Ek.RIGHT_PANEL)}"
  ${''}
  "${(0, $ho1Ek.LEFT_PANEL)} ${(0, $ho1Ek.TOP_NAVIGATION)} ${(0, $ho1Ek.RIGHT_PANEL)}"
${''}
  "${(0, $ho1Ek.LEFT_PANEL)} ${(0, $ho1Ek.CONTENT)} ${(0, $ho1Ek.RIGHT_PANEL)}"
 `;
const $5ecc4fbcc1004c95$var$gridStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'grid',
    height: '100%',
    gridTemplateAreas: $5ecc4fbcc1004c95$var$gridTemplateAreas,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateColumns: `${(0, $ho1Ek.LEFT_PANEL_WIDTH)} minmax(0, 1fr) ${(0, $ho1Ek.RIGHT_PANEL_WIDTH)}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateRows: `${(0, $ho1Ek.BANNER_HEIGHT)} ${(0, $ho1Ek.TOP_NAVIGATION_HEIGHT)} auto`,
    outline: 'none'
});
const $5ecc4fbcc1004c95$var$gridStylesMobileStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $4Ywu9.UNSAFE_media).below.sm]: {
        gridTemplateAreas: $5ecc4fbcc1004c95$var$gridTemplateAreasMobile,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        gridTemplateColumns: `${(0, $ho1Ek.LEFT_PANEL_WIDTH)} minmax(0, 1fr)`
    }
});
/**
 * __Page layout__
 *
 * A collection of components which let you compose an application's page layout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $5ecc4fbcc1004c95$var$PageLayout = ({ skipLinksLabel: skipLinksLabel = (0, $ho1Ek.DEFAULT_I18N_PROPS_SKIP_LINKS), children: children, testId: testId, onLeftSidebarExpand: onLeftSidebarExpand, onLeftSidebarCollapse: onLeftSidebarCollapse })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $5cR7w.SkipLinksController), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $dFFYu.SkipLinkWrapper), {
        skipLinksLabel: skipLinksLabel
    }), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...$5ecc4fbcc1004c95$var$pageLayoutSelector,
        "data-testid": testId,
        css: [
            $5ecc4fbcc1004c95$var$gridStyles,
            $5ecc4fbcc1004c95$var$gridStylesMobileStyles
        ],
        tabIndex: -1
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $lDBEs.SidebarResizeController), {
        onLeftSidebarCollapse: onLeftSidebarCollapse,
        onLeftSidebarExpand: onLeftSidebarExpand
    }, children))));
};
var $5ecc4fbcc1004c95$export$2e2bcd8739ae039 = $5ecc4fbcc1004c95$var$PageLayout;

});
parcelRegister("lDBEs", function(module, exports) {

$parcel$export(module.exports, "SidebarResizeController", () => $d470ef5b352c70d4$export$850bd1bba41f1448);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $5Q9wj = parcelRequire("5Q9wj");

var $8YJjX = parcelRequire("8YJjX");

var $eT0WN = parcelRequire("eT0WN");

var $ho1Ek = parcelRequire("ho1Ek");

var $a353s = parcelRequire("a353s");

var $ikQZw = parcelRequire("ikQZw");
const $d470ef5b352c70d4$var$handleDataAttributesAndCb = (callback = (0, $5Q9wj.default), leftSidebarState)=>{
    document.documentElement.removeAttribute((0, $ho1Ek.IS_SIDEBAR_COLLAPSING));
    callback(leftSidebarState);
};
const $d470ef5b352c70d4$var$leftSidebarSelector = (0, $a353s.getPageLayoutSlotCSSSelector)('left-sidebar');
const $d470ef5b352c70d4$export$850bd1bba41f1448 = ({ children: children, onLeftSidebarExpand: onExpand, onLeftSidebarCollapse: onCollapse })=>{
    const [leftSidebarState, setLeftSidebarState] = (0, $eUqFw.useState)({
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true
    });
    const { leftSidebarWidth: leftSidebarWidth, lastLeftSidebarWidth: lastLeftSidebarWidth, isResizing: isResizing, flyoutLockCount: flyoutLockCount, isFixed: isFixed, isLeftSidebarCollapsed: isLeftSidebarCollapsed, isFlyoutOpen: isFlyoutOpen } = leftSidebarState;
    // We put the latest callbacks into a ref so we can always have the latest
    // functions in our transitionend listeners
    const stableRef = (0, $eUqFw.useRef)({
        onExpand: onExpand,
        onCollapse: onCollapse
    });
    (0, $eUqFw.useEffect)(()=>{
        stableRef.current = {
            onExpand: onExpand,
            onCollapse: onCollapse
        };
    }, [
        onExpand,
        onCollapse
    ]);
    const transition = (0, $eUqFw.useRef)(null);
    const mobileMediaQuery = (0, $eT0WN.UNSAFE_useMediaQuery)('below.sm');
    const isOpen = mobileMediaQuery?.matches ? isFlyoutOpen : !isLeftSidebarCollapsed;
    const expandLeftSidebar = (0, $eUqFw.useCallback)(()=>{
        if (isOpen) return;
        // If the user is at a mobile viewport when this runs, we handle it differently
        // We don't expand at mobile widths; instead we use a flyout which is treated the same otherwise
        if (mobileMediaQuery?.matches) {
            const flyoutOpenSidebarState = {
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $ho1Ek.COLLAPSED_LEFT_SIDEBAR_WIDTH),
                lastLeftSidebarWidth: leftSidebarWidth,
                isFlyoutOpen: true,
                flyoutLockCount: 0,
                isFixed: isFixed
            };
            setLeftSidebarState(flyoutOpenSidebarState);
            // Flush the desktop transitions, cleanup, and call the `onExpand` still
            transition.current?.complete();
            $d470ef5b352c70d4$var$handleDataAttributesAndCb(stableRef.current.onExpand, flyoutOpenSidebarState);
            return;
        }
        if (isResizing || !isLeftSidebarCollapsed || // already expanding
        transition.current?.action === 'expand') return;
        // flush existing transition
        transition.current?.complete();
        const width = Math.max(lastLeftSidebarWidth, (0, $ho1Ek.DEFAULT_LEFT_SIDEBAR_WIDTH));
        const updatedLeftSidebarState = {
            isLeftSidebarCollapsed: false,
            isFlyoutOpen: false,
            leftSidebarWidth: width,
            lastLeftSidebarWidth: lastLeftSidebarWidth,
            isResizing: isResizing,
            flyoutLockCount: flyoutLockCount,
            isFixed: isFixed
        };
        setLeftSidebarState(updatedLeftSidebarState);
        function finish() {
            $d470ef5b352c70d4$var$handleDataAttributesAndCb(stableRef.current.onExpand, updatedLeftSidebarState);
        }
        const sidebar = document.querySelector($d470ef5b352c70d4$var$leftSidebarSelector);
        // onTransitionEnd isn't triggered when a user prefers reduced motion
        if ((0, $8YJjX.isReducedMotion)() || !sidebar) {
            finish();
            return;
        }
        const unbindEvent = (0, $74BVL.bind)(sidebar, {
            type: 'transitionend',
            listener (event) {
                if (event.target === sidebar && event.propertyName === 'width') transition.current?.complete();
            }
        });
        const value = {
            action: 'expand',
            complete: ()=>{
                value.abort();
                finish();
            },
            abort: ()=>{
                unbindEvent();
                transition.current = null;
            }
        };
        transition.current = value;
    }, [
        isOpen,
        mobileMediaQuery,
        isResizing,
        isLeftSidebarCollapsed,
        lastLeftSidebarWidth,
        flyoutLockCount,
        isFixed,
        leftSidebarWidth
    ]);
    const collapseLeftSidebar = (0, $eUqFw.useCallback)((event, collapseWithoutTransition)=>{
        if (!isOpen) return;
        // If the user is at a mobile viewport when this runs, we handle it differently
        // We don't collapse at mobile widths; instead we close the flyout.
        if (mobileMediaQuery?.matches) {
            const flyoutCloseSidebarState = {
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $ho1Ek.COLLAPSED_LEFT_SIDEBAR_WIDTH),
                lastLeftSidebarWidth: lastLeftSidebarWidth,
                isFlyoutOpen: false,
                flyoutLockCount: 0,
                isFixed: isFixed
            };
            setLeftSidebarState(flyoutCloseSidebarState);
            // Flush the desktop transitions, cleanup, and call the `onCollapse` still
            transition.current?.complete();
            $d470ef5b352c70d4$var$handleDataAttributesAndCb(stableRef.current.onCollapse, flyoutCloseSidebarState);
            return;
        }
        if (isResizing || isLeftSidebarCollapsed || // already collapsing
        transition.current?.action === 'collapse') return;
        // flush existing transition
        transition.current?.complete();
        // data-attribute is used as a CSS selector to sync the hiding/showing
        // of the nav contents with expand/collapse animation
        document.documentElement.setAttribute((0, $ho1Ek.IS_SIDEBAR_COLLAPSING), 'true');
        const updatedLeftSidebarState = {
            isLeftSidebarCollapsed: true,
            isFlyoutOpen: false,
            leftSidebarWidth: (0, $ho1Ek.COLLAPSED_LEFT_SIDEBAR_WIDTH),
            lastLeftSidebarWidth: leftSidebarWidth,
            isResizing: isResizing,
            flyoutLockCount: flyoutLockCount,
            isFixed: isFixed
        };
        setLeftSidebarState(updatedLeftSidebarState);
        function finish() {
            $d470ef5b352c70d4$var$handleDataAttributesAndCb(stableRef.current.onCollapse, updatedLeftSidebarState);
        }
        const sidebar = document.querySelector($d470ef5b352c70d4$var$leftSidebarSelector);
        // onTransitionEnd isn't triggered when a user prefers reduced motion
        if (collapseWithoutTransition || (0, $8YJjX.isReducedMotion)() || !sidebar) {
            finish();
            return;
        }
        const unbindEvent = (0, $74BVL.bind)(sidebar, {
            type: 'transitionend',
            listener (event) {
                if (sidebar === event.target && event.propertyName === 'width') transition.current?.complete();
            }
        });
        const value = {
            action: 'collapse',
            complete: ()=>{
                value.abort();
                finish();
            },
            abort: ()=>{
                unbindEvent();
                transition.current = null;
            }
        };
        transition.current = value;
    }, [
        isOpen,
        mobileMediaQuery,
        isResizing,
        isLeftSidebarCollapsed,
        leftSidebarWidth,
        flyoutLockCount,
        isFixed,
        lastLeftSidebarWidth
    ]);
    /**
	 * Conditionally toggle the expanding or collapsing the sidebars.
	 * This supports our mobile flyout mode as well.
	 */ const toggleLeftSidebar = (0, $eUqFw.useCallback)((event, collapseWithoutTransition)=>{
        if (isOpen) collapseLeftSidebar(event, collapseWithoutTransition);
        else expandLeftSidebar();
    }, [
        isOpen,
        expandLeftSidebar,
        collapseLeftSidebar
    ]);
    // Make sure we finish any lingering transitions when unmounting
    (0, $eUqFw.useEffect)(function mount() {
        return function unmount() {
            transition.current?.abort();
        };
    }, []);
    const context = (0, $eUqFw.useMemo)(()=>({
            isLeftSidebarCollapsed: !isOpen,
            expandLeftSidebar: expandLeftSidebar,
            collapseLeftSidebar: collapseLeftSidebar,
            leftSidebarState: leftSidebarState,
            setLeftSidebarState: setLeftSidebarState,
            toggleLeftSidebar: toggleLeftSidebar
        }), [
        isOpen,
        expandLeftSidebar,
        collapseLeftSidebar,
        leftSidebarState,
        toggleLeftSidebar
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ikQZw.SidebarResizeContext).Provider, {
        value: context
    }, children);
};

});

parcelRegister("5cR7w", function(module, exports) {

$parcel$export(module.exports, "SkipLinksController", () => $4539942660e627fc$export$da7be99d6a868f3d);

var $eUqFw = parcelRequire("eUqFw");

var $ho1Ek = parcelRequire("ho1Ek");

var $6cmgz = parcelRequire("6cmgz");
const $4539942660e627fc$var$byDOMOrder = (a, b)=>{
    const elems = Array.from(document.querySelectorAll(`[${(0, $ho1Ek.PAGE_LAYOUT_SLOT_SELECTOR)}]`));
    const elemA = document.getElementById(a.id);
    const elemB = document.getElementById(b.id);
    const indexA = a.listIndex ?? elems.indexOf(elemA);
    const indexB = b.listIndex ?? elems.indexOf(elemB);
    /**
	 * If they are tied it is because one (or both) is
	 * a custom skiplink with a set index.
	 *
	 * Give the custom skiplink priority.
	 */ if (indexA === indexB) {
        if (a.listIndex !== undefined) return -1;
        else return 1;
    }
    return indexA - indexB;
};
const $4539942660e627fc$export$da7be99d6a868f3d = ({ children: children })=>{
    const [links, setLinks] = (0, $eUqFw.useState)([]);
    const registerSkipLink = (0, $eUqFw.useRef)((skipLinkData)=>{
        // Don't add duplicate SkipLinks
        setLinks((oldLinks)=>{
            if (oldLinks.some(({ id: id })=>id === skipLinkData.id)) return oldLinks;
            return [
                ...oldLinks,
                skipLinkData
            ].sort($4539942660e627fc$var$byDOMOrder);
        });
    });
    const unregisterSkipLink = (0, $eUqFw.useRef)((id)=>{
        setLinks((links)=>links.filter((link)=>link.id !== id));
    });
    const context = {
        registerSkipLink: registerSkipLink.current,
        skipLinksData: links,
        unregisterSkipLink: unregisterSkipLink.current
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6cmgz.SkipLinksContext).Provider, {
        value: context
    }, children);
};

});

parcelRegister("dFFYu", function(module, exports) {

$parcel$export(module.exports, "SkipLinkWrapper", () => $7927022d7be1354d$export$4241a460557ba901);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /**
                                                                          * @jsxRuntime classic
                                                                          */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $5OdZ3 = parcelRequire("5OdZ3");

var $8YJjX = parcelRequire("8YJjX");

var $PdmhA = parcelRequire("PdmhA");

var $ho1Ek = parcelRequire("ho1Ek");

var $6cmgz = parcelRequire("6cmgz");
function $7927022d7be1354d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $7927022d7be1354d$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $byn9U.css)((0, $8YJjX.prefersReducedMotion)());
const $7927022d7be1354d$var$skipLinkStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: "var(--ds-space-250, 10px)",
    padding: '0.8rem 1rem',
    position: 'fixed',
    zIndex: -1,
    background: "var(--ds-surface-overlay, white)",
    border: 'none',
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $PdmhA.N30A)}, 0 2px 10px ${(0, $PdmhA.N30A)}, 0 0 20px -4px ${(0, $PdmhA.N60A)}`})`,
    insetInlineStart: -999999,
    opacity: 0,
    transform: 'translateY(-50%)',
    transition: `transform 0.3s ${(0, $d58b680a02f4d6a4$export$57636bb43b1ccbb0)}`,
    '&:focus-within': {
        zIndex: 2147483640,
        insetInlineStart: 0,
        opacity: 1,
        transform: 'translateY(0%)'
    }
});
const $7927022d7be1354d$var$skipLinkHeadingStyles = {
    name: "16ceglb",
    styles: "font-weight:600"
};
const $7927022d7be1354d$var$skipLinkListStyles = {
    name: "1xay72g",
    styles: "list-style-position:outside;list-style-type:none;margin-block-start:var(--ds-space-050, 4px);padding-inline-start:0"
};
const $7927022d7be1354d$var$skipLinkListItemStyles = {
    name: "19m435s",
    styles: "margin-block-start:0"
};
const $7927022d7be1354d$var$assignIndex = (num, arr)=>{
    if (!arr.includes(num)) return num;
    return $7927022d7be1354d$var$assignIndex(num + 1, arr);
};
const $7927022d7be1354d$export$4241a460557ba901 = ({ skipLinksLabel: skipLinksLabel })=>{
    const { skipLinksData: skipLinksData } = (0, $6cmgz.useSkipLinks)();
    if (skipLinksData.length === 0) return null;
    const sortSkipLinks = (arr)=>{
        const customLinks = arr.filter((link)=>Number.isInteger(link.listIndex));
        if (customLinks.length === 0) return arr;
        const usedIndexes = customLinks.map((a)=>a.listIndex);
        const regularLinksWithIdx = arr.filter((link)=>link.listIndex === undefined).map((link, idx, currArr)=>{
            const listIndex = $7927022d7be1354d$var$assignIndex(idx, usedIndexes);
            usedIndexes.push(listIndex);
            return {
                ...link,
                listIndex: listIndex
            };
        });
        return [
            ...customLinks,
            ...regularLinksWithIdx
        ].sort((a, b)=>a.listIndex - b.listIndex);
    };
    const escapeHandler = (event)=>{
        if (event.keyCode === 27) {
            const container = document.querySelector(`[${(0, $ho1Ek.PAGE_LAYOUT_CONTAINER_SELECTOR)}="true"]`);
            if (container !== null) container.focus();
        }
    };
    const attachEscHandler = ()=>window.addEventListener('keydown', escapeHandler, false);
    const removeEscHandler = ()=>window.removeEventListener('keydown', escapeHandler, false);
    const emptyLabelOverride = !!skipLinksLabel?.match(/^\s+$/);
    const label = skipLinksLabel || (0, $ho1Ek.DEFAULT_I18N_PROPS_SKIP_LINKS);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        onFocus: attachEscHandler,
        onBlur: removeEscHandler,
        css: [
            $7927022d7be1354d$var$skipLinkStyles,
            $7927022d7be1354d$var$prefersReducedMotionStyles
        ],
        "data-skip-link-wrapper": true
    }, emptyLabelOverride ? null : /*#__PURE__*/ (0, $byn9U.jsx)("p", {
        css: $7927022d7be1354d$var$skipLinkHeadingStyles
    }, label), /*#__PURE__*/ (0, $byn9U.jsx)("ol", {
        css: $7927022d7be1354d$var$skipLinkListStyles
    }, sortSkipLinks(skipLinksData).map(({ id: id, skipLinkTitle: skipLinkTitle })=>/*#__PURE__*/ (0, $byn9U.jsx)($7927022d7be1354d$export$ef95c37428582a65, {
            key: id,
            href: `#${id}`,
            isFocusable: true
        }, skipLinkTitle))));
};
const $7927022d7be1354d$var$handleBlur = (event)=>{
    // @ts-ignore
    event.target.removeAttribute('tabindex');
    // @ts-ignore
    event.target.removeEventListener('blur', $7927022d7be1354d$var$handleBlur);
};
const $7927022d7be1354d$var$focusTargetRef = (href)=>(event)=>{
        event.preventDefault();
        const targetRef = document.querySelector(href);
        // @ts-ignore
        const key = event.which || event.keycode;
        // if it is a keypress and the key is not
        // space or enter, just ignore it.
        if (key && key !== 13 && key !== 32) return;
        if (targetRef) {
            targetRef.setAttribute('tabindex', '-1');
            // @ts-ignore
            targetRef.addEventListener('blur', $7927022d7be1354d$var$handleBlur);
            // @ts-ignore
            targetRef.focus();
            document.activeElement && document.activeElement.scrollIntoView({
                behavior: 'smooth'
            });
            window.scrollTo(0, 0);
        }
        return false;
    };
const $7927022d7be1354d$export$ef95c37428582a65 = ({ href: href, children: children, isFocusable: isFocusable })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("li", {
        css: $7927022d7be1354d$var$skipLinkListItemStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $5OdZ3.default), {
        tabIndex: isFocusable ? 0 : -1,
        href: href,
        onClick: $7927022d7be1354d$var$focusTargetRef(href)
    }, children));
};

});
parcelRegister("5OdZ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9a459d0ad400a9b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /**
 * @jsxRuntime classic
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4kMup = parcelRequire("4kMup");
const $b9a459d0ad400a9b$var$commonLinkStyles = (0, $1ZAYh.xcss)({
    ':visited': {
        color: 'color.link.visited'
    },
    ':visited:hover': {
        color: 'color.link.visited'
    },
    ':visited:active': {
        color: 'color.link.visited.pressed'
    }
});
const $b9a459d0ad400a9b$var$defaultAppearanceStyles = (0, $1ZAYh.xcss)({
    textDecoration: 'underline',
    color: 'color.link',
    ':hover': {
        color: 'color.link',
        textDecoration: 'none'
    },
    ':active': {
        color: 'color.link.pressed'
    }
});
const $b9a459d0ad400a9b$var$subtleAppearanceStyles = (0, $1ZAYh.xcss)({
    textDecoration: 'none',
    color: 'color.text.subtle',
    ':hover': {
        color: 'color.text.subtle',
        textDecoration: 'underline'
    },
    ':active': {
        color: 'color.text'
    }
});
// Prevent the icon from wrapping onto a new line by itself
// Using this technique involving a zero-width space: https://snook.ca/archives/html_and_css/icon-wrap-after-text
const $b9a459d0ad400a9b$var$iconWrapperStyles = (0, $1ZAYh.xcss)({
    display: 'inline',
    whiteSpace: 'nowrap'
});
const $b9a459d0ad400a9b$var$iconStyles = null;
const $b9a459d0ad400a9b$var$LinkWithoutRef = ({ children: children, testId: testId, appearance: appearance = 'default', target: target, // @ts-expect-error
className: preventedClassName, // @ts-expect-error
style: preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ $eUqFw.createElement((0, $4kMup.default), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: [
            $b9a459d0ad400a9b$var$commonLinkStyles,
            appearance === 'default' && $b9a459d0ad400a9b$var$defaultAppearanceStyles,
            appearance === 'subtle' && $b9a459d0ad400a9b$var$subtleAppearanceStyles
        ],
        testId: testId,
        componentName: "Link"
    }, children, target === '_blank' && /*#__PURE__*/ $eUqFw.createElement((0, $b5IAe.default), {
        as: "span",
        xcss: $b9a459d0ad400a9b$var$iconWrapperStyles,
        testId: testId && `${testId}__icon`
    }, "\uFEFF", /*#__PURE__*/ $eUqFw.createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        className: (0, $7JEyt.default)([
            "_1bsb1x4e _4t3i1x4e _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $eUqFw.createElement("path", {
        d: "M17.5715 3.95926L10.7587 10.772C10.5546 10.9692 10.2811 11.0784 9.99723 11.0759C9.71338 11.0734 9.44185 10.9596 9.24113 10.7589C9.04041 10.5581 8.92655 10.2866 8.92409 10.0027C8.92162 9.7189 9.03074 9.44543 9.22794 9.24125L16.0407 2.4285H14.3237C14.0366 2.4285 13.7613 2.31444 13.5582 2.11142C13.3552 1.90839 13.2411 1.63303 13.2411 1.34591C13.2411 1.05879 13.3552 0.783424 13.5582 0.580399C13.7613 0.377373 14.0366 0.263314 14.3237 0.263314H18.4981C18.5509 0.254962 18.6043 0.250507 18.658 0.250041C18.8017 0.248792 18.9443 0.276183 19.0773 0.330617C19.2104 0.385051 19.3313 0.465437 19.4329 0.567084C19.5346 0.668732 19.6149 0.789606 19.6694 0.922652C19.7238 1.0557 19.7512 1.19825 19.75 1.342C19.7495 1.3956 19.7451 1.44896 19.7367 1.50165V5.67628C19.7367 5.9634 19.6227 6.23877 19.4196 6.44179C19.2166 6.64482 18.9412 6.75888 18.6541 6.75888C18.367 6.75888 18.0916 6.64482 17.8886 6.44179C17.6856 6.23877 17.5715 5.9634 17.5715 5.67628V3.95926Z"
    }), /*#__PURE__*/ $eUqFw.createElement("path", {
        d: "M2.41519 17.5848V2.4285H8.91076V0.263314H2.41194C1.22001 0.263314 0.25 1.23007 0.25 2.42201V17.5913C0.250574 18.1638 0.47834 18.7127 0.883283 19.1175C1.28823 19.5222 1.83724 19.7497 2.40978 19.75H17.5769C17.8608 19.7499 18.1418 19.6938 18.404 19.585C18.6662 19.4762 18.9044 19.3168 19.105 19.116C19.3055 18.9151 19.4646 18.6767 19.573 18.4143C19.6814 18.152 19.737 17.8708 19.7367 17.587V11.0893H17.5715V17.5848H2.41519Z"
    }))));
};
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $b9a459d0ad400a9b$var$Link = /*#__PURE__*/ (0, $eUqFw.forwardRef)($b9a459d0ad400a9b$var$LinkWithoutRef);
var $b9a459d0ad400a9b$export$2e2bcd8739ae039 = $b9a459d0ad400a9b$var$Link;

});



parcelRegister("epaF7", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed7898ff788c8bd5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ho1Ek = parcelRequire("ho1Ek");

var $a353s = parcelRequire("a353s");

var $cXUwP = parcelRequire("cXUwP");
var $6cmgz = parcelRequire("6cmgz");

var $gl6Cr = parcelRequire("gl6Cr");

var $8cbHW = parcelRequire("8cbHW");
const $ed7898ff788c8bd5$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $ho1Ek.RIGHT_PANEL)
});
const $ed7898ff788c8bd5$var$fixedStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $ho1Ek.RIGHT_PANEL_WIDTH),
    position: 'fixed',
    insetBlockEnd: 0,
    insetBlockStart: 0,
    insetInlineEnd: 0
});
/**
 * __Right panel__
 *
 * Provides a slot for a right panel within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $ed7898ff788c8bd5$var$RightPanel = (props)=>{
    const { children: children, isFixed: isFixed, width: width = (0, $ho1Ek.DEFAULT_RIGHT_PANEL_WIDTH), shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const rightPanelWidth = (0, $a353s.resolveDimension)((0, $ho1Ek.VAR_RIGHT_PANEL_WIDTH), width, shouldPersistWidth);
    (0, $eUqFw.useEffect)(()=>{
        (0, $cXUwP.default)({
            [(0, $ho1Ek.VAR_RIGHT_PANEL_WIDTH)]: rightPanelWidth
        });
        return ()=>{
            (0, $cXUwP.default)({
                [(0, $ho1Ek.VAR_RIGHT_PANEL_WIDTH)]: 0
            });
        };
    }, [
        rightPanelWidth
    ]);
    (0, $6cmgz.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $gl6Cr.default), null, ({ className: className })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: [
                $ed7898ff788c8bd5$var$baseStyles,
                isFixed && $ed7898ff788c8bd5$var$fixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $a353s.getPageLayoutSlotSelector)('right-panel')
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cbHW.default), {
            variableName: (0, $ho1Ek.VAR_RIGHT_PANEL_WIDTH),
            value: rightPanelWidth
        }), children));
};
var $ed7898ff788c8bd5$export$2e2bcd8739ae039 = $ed7898ff788c8bd5$var$RightPanel;

});

parcelRegister("mtJGd", function(module, exports) {

$parcel$export(module.exports, "default", () => $01bb915aea8f70d5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ho1Ek = parcelRequire("ho1Ek");

var $a353s = parcelRequire("a353s");

var $cXUwP = parcelRequire("cXUwP");
var $6cmgz = parcelRequire("6cmgz");

var $gl6Cr = parcelRequire("gl6Cr");

var $8cbHW = parcelRequire("8cbHW");
function $01bb915aea8f70d5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * This inner wrapper is required to allow the sidebar to be `position: fixed`.
 *
 * If we were to apply `position: fixed` to the outer wrapper, it will be popped
 * out of its flex container and Main would stretch to occupy all the space.
 */ const $01bb915aea8f70d5$var$fixedInnerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $ho1Ek.RIGHT_SIDEBAR_WIDTH),
    position: 'fixed',
    insetBlockEnd: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: `calc(${(0, $ho1Ek.BANNER_HEIGHT)} + ${(0, $ho1Ek.TOP_NAVIGATION_HEIGHT)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: `calc(${(0, $ho1Ek.RIGHT_PANEL_WIDTH)})`
});
const $01bb915aea8f70d5$var$staticInnerStyles = {
    name: "13udsys",
    styles: "height:100%"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $01bb915aea8f70d5$var$outerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: (0, $ho1Ek.RIGHT_SIDEBAR_WIDTH)
});
/**
 * In fixed mode this element's child is taken out of the document flow.
 * It doesn't take up the width as expected,
 * so the pseudo element forces it to take up the necessary width.
 */ const $01bb915aea8f70d5$var$fixedOuterStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&::after': {
        display: 'inline-block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $ho1Ek.RIGHT_SIDEBAR_WIDTH),
        content: "''"
    }
});
/**
 * __Right sidebar__
 *
 * Provides a slot for a right sidebar within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $01bb915aea8f70d5$var$RightSidebar = (props)=>{
    const { children: children, width: width = (0, $ho1Ek.DEFAULT_RIGHT_SIDEBAR_WIDTH), isFixed: isFixed, shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const rightSidebarWidth = (0, $a353s.resolveDimension)((0, $ho1Ek.VAR_RIGHT_SIDEBAR_WIDTH), width, shouldPersistWidth);
    (0, $eUqFw.useEffect)(()=>{
        (0, $cXUwP.default)({
            [(0, $ho1Ek.VAR_RIGHT_SIDEBAR_WIDTH)]: rightSidebarWidth
        });
        return ()=>{
            (0, $cXUwP.default)({
                [(0, $ho1Ek.VAR_RIGHT_SIDEBAR_WIDTH)]: 0
            });
        };
    }, [
        rightSidebarWidth,
        id
    ]);
    (0, $6cmgz.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $gl6Cr.default), {
        isSidebar: true
    }, ({ className: className })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
            "data-testid": testId,
            css: [
                $01bb915aea8f70d5$var$outerStyles,
                isFixed && $01bb915aea8f70d5$var$fixedOuterStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            id: id,
            ...(0, $a353s.getPageLayoutSlotSelector)('right-sidebar')
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cbHW.default), {
            variableName: (0, $ho1Ek.VAR_RIGHT_SIDEBAR_WIDTH),
            value: rightSidebarWidth
        }), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: [
                isFixed && $01bb915aea8f70d5$var$fixedInnerStyles,
                !isFixed && $01bb915aea8f70d5$var$staticInnerStyles
            ]
        }, children)));
};
var $01bb915aea8f70d5$export$2e2bcd8739ae039 = $01bb915aea8f70d5$var$RightSidebar;

});

parcelRegister("jnGaC", function(module, exports) {

$parcel$export(module.exports, "default", () => $0177ccf962ce75b6$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ho1Ek = parcelRequire("ho1Ek");

var $a353s = parcelRequire("a353s");

var $cXUwP = parcelRequire("cXUwP");
var $6cmgz = parcelRequire("6cmgz");

var $gl6Cr = parcelRequire("gl6Cr");

var $8cbHW = parcelRequire("8cbHW");
const $0177ccf962ce75b6$var$topNavigationStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $ho1Ek.TOP_NAVIGATION_HEIGHT),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $ho1Ek.TOP_NAVIGATION)
});
const $0177ccf962ce75b6$var$fixedStyles = /*#__PURE__*/ (0, $byn9U.css)({
    position: 'fixed',
    zIndex: 2,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: (0, $ho1Ek.BANNER_HEIGHT),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: (0, $ho1Ek.RIGHT_PANEL_WIDTH),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: (0, $ho1Ek.LEFT_PANEL_WIDTH)
});
/**
 * __Top navigation__
 *
 * Provides a slot for top navigation within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $0177ccf962ce75b6$var$TopNavigation = (props)=>{
    const { children: children, height: height = (0, $ho1Ek.DEFAULT_TOP_NAVIGATION_HEIGHT), isFixed: isFixed = true, shouldPersistHeight: shouldPersistHeight, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const topNavigationHeight = (0, $a353s.resolveDimension)((0, $ho1Ek.VAR_TOP_NAVIGATION_HEIGHT), height, shouldPersistHeight);
    (0, $eUqFw.useEffect)(()=>{
        (0, $cXUwP.default)({
            [(0, $ho1Ek.VAR_TOP_NAVIGATION_HEIGHT)]: topNavigationHeight
        });
        return ()=>{
            (0, $cXUwP.default)({
                [(0, $ho1Ek.VAR_TOP_NAVIGATION_HEIGHT)]: 0
            });
        };
    }, [
        topNavigationHeight
    ]);
    (0, $6cmgz.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $gl6Cr.default), null, ({ className: className })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: [
                $0177ccf962ce75b6$var$topNavigationStyles,
                isFixed && $0177ccf962ce75b6$var$fixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $a353s.getPageLayoutSlotSelector)('top-navigation')
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cbHW.default), {
            variableName: (0, $ho1Ek.VAR_TOP_NAVIGATION_HEIGHT),
            value: topNavigationHeight
        }), children));
};
var $0177ccf962ce75b6$export$2e2bcd8739ae039 = $0177ccf962ce75b6$var$TopNavigation;

});

parcelRegister("GP1qj", function(module, exports) {

$parcel$export(module.exports, "useCustomSkipLink", () => $40616bd8cab79850$export$ee6b12c2613bdf8e);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $6cmgz = parcelRequire("6cmgz");
const $40616bd8cab79850$export$ee6b12c2613bdf8e = (id, skipLinkTitle, listIndex = 0)=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = (0, $6cmgz.useSkipLinks)();
    (0, $eUqFw.useEffect)(()=>{
        registerSkipLink({
            id: id,
            skipLinkTitle: skipLinkTitle,
            listIndex: listIndex
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        listIndex,
        skipLinkTitle,
        registerSkipLink,
        unregisterSkipLink
    ]);
};

});

parcelRegister("b5l09", function(module, exports) {

$parcel$export(module.exports, "gridRootId", () => $2a40d5d061eb57b6$export$a6d827031bcb31d1);
$parcel$export(module.exports, "SideNavCollapsedContext", () => $2a40d5d061eb57b6$export$626ec72ba238b0ad);
$parcel$export(module.exports, "useSideNavCollapsedState", () => $2a40d5d061eb57b6$export$65f7d5f7bef4a5f3);
$parcel$export(module.exports, "useToggleSideNavCollapsed", () => $2a40d5d061eb57b6$export$4de9f47e746bcfb9);
$parcel$export(module.exports, "Root", () => $2a40d5d061eb57b6$export$be92b6f5f03c0fe9);
$parcel$export(module.exports, "Banner", () => $2a40d5d061eb57b6$export$3b4e64e77073e307);
$parcel$export(module.exports, "TopBar", () => $2a40d5d061eb57b6$export$c4e96258f3b6511);
$parcel$export(module.exports, "Panel", () => $2a40d5d061eb57b6$export$2ddb90ad54e5f587);
$parcel$export(module.exports, "Main", () => $2a40d5d061eb57b6$export$861edd1ccea2f746);
$parcel$export(module.exports, "SideNav", () => $2a40d5d061eb57b6$export$1a35787d6353cf6a);
$parcel$export(module.exports, "Aside", () => $2a40d5d061eb57b6$export$ac3bdfe4cb17f64e);
/* layout.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $j9fWg = parcelRequire("j9fWg");

var $5Q9wj = parcelRequire("5Q9wj");

var $b8123 = parcelRequire("b8123");

var $ek6Yj = parcelRequire("ek6Yj");

var $4Ywu9 = parcelRequire("4Ywu9");

var $59HcT = parcelRequire("59HcT");

var $lWATQ = parcelRequire("lWATQ");
// These are "compressed" to discourage usage.
const $2a40d5d061eb57b6$var$sideNavVar = '--n_sNvw';
const $2a40d5d061eb57b6$var$asideVar = '--n_asDw';
const $2a40d5d061eb57b6$var$panelVar = '--n_pnlW';
const $2a40d5d061eb57b6$var$bannerMountedVar = '--n_bnrM';
const $2a40d5d061eb57b6$var$topBarMountedVar = '--n_tbrM';
// We aren't using template literals here because Compiled can't compiled them in platform ATM.
const $2a40d5d061eb57b6$var$contentHeightWhenFixed = `calc(100vh - var(--n_bnrM, 0px) - var(--n_tbrM, 0px))`;
const $2a40d5d061eb57b6$var$contentInsetBlockStart = `calc(var(--n_bnrM, 0px) + var(--n_tbrM, 0px))`;
// We define variables as they can change their size depending on the viewport width. That isn't needed for
// general grid item slots because, well, they just take up the size of the grid item! In this instance since
// the UNSAFE absolutely positioned sibling isn't on the grid it needs extra layout information.
// Note: THESE ARE THE SAME VALUES AS THE LEGACY PAGE LAYOUT.
// WHEN WE ELIMINATE USAGE OF THOSE VARIABLES THESE CAN BE RENAMED TO BE HASHED.
const $2a40d5d061eb57b6$var$UNSAFE_topBarVar = '--topNavigationHeight';
const $2a40d5d061eb57b6$var$UNSAFE_bannerVar = '--bannerHeight';
const $2a40d5d061eb57b6$var$UNSAFE_sideNavLayoutVar = '--leftSidebarWidth';
const $2a40d5d061eb57b6$var$UNSAFE_asideLayoutVar = '--rightSidebarWidth';
const $2a40d5d061eb57b6$var$UNSAFE_panelLayoutVar = '--rightPanelWidth';
const $2a40d5d061eb57b6$export$6460bd6a2446260 = `calc(var(${$2a40d5d061eb57b6$var$UNSAFE_bannerVar}, 0px) + var(${$2a40d5d061eb57b6$var$UNSAFE_topBarVar}, 0px))`;
const $2a40d5d061eb57b6$export$3055529fab2b4edf = `var(${$2a40d5d061eb57b6$var$UNSAFE_sideNavLayoutVar}, 0px)`;
const $2a40d5d061eb57b6$export$166d8fd766c3eb92 = `calc(var(${$2a40d5d061eb57b6$var$UNSAFE_asideLayoutVar}, 0px) + var(${$2a40d5d061eb57b6$var$UNSAFE_panelLayoutVar}, 0px))`;
const $2a40d5d061eb57b6$var$panelSplitterResizingVar = '--localPanelSplitterResizingWidth';
const $2a40d5d061eb57b6$var$sideNavCollapsedWidth = '56px';
const $2a40d5d061eb57b6$var$sideNavWidthResizeBounds = {
    min: '240px',
    max: '50vw'
};
const $2a40d5d061eb57b6$export$a6d827031bcb31d1 = 'unsafe-design-system-page-layout-root';
/**
 * We define the z-indexes here so each page slot can be locally layered against each other.
 * For globally defined values such as flag, modal, etc, we can continue to
 * rely on accessing them through global means.
 */ const $2a40d5d061eb57b6$var$localSlotLayers = {
    // Panel should be above banner and top bar slos.
    panel: 3,
    // Banner and top bar should be above all other slots.
    banner: 2,
    topBar: 2,
    // Side nav should be above all other content slots.
    sideNav: 1
};
const $2a40d5d061eb57b6$var$styles = {
    root: "_1e0c11p5 _1tke1kxc _1lmcq9em _yv0ei47z _2z0516ab _1ciragmp _12fkuz0r _12qzrxre _1rqt70if _xkmgbaui _jbc7rxre _tyve1jg8",
    banner: "_nd5ldkfm _4t3iutvi _152tidpf _kqsw1if8 _1pbycs5v _1reo15vq _18m915vq",
    topBar: "_bfhkvuon _179rzgxb _vchhusvi _nd5l8cbt _4t3i2mmk _152t1nws _kqsw1if8 _1pbycs5v _1reo15vq _18m915vq",
    sideNav: "_bfhk1bhr _16qs1cd0 _nd5l1b6c _4t3i1run _152t1l7u _kqsw1if8 _1bsb1vuk _1pbykb7n _14b515li _4ap3vuon _p5clzgxb _scbpglyw _qilnk0mc",
    main: "_nd5l1gzg",
    aside: "_nd5lns35 _kqswpfqs _glte12il _ndwch9n0",
    panel: "_bfhk1bhr _16qs1cd0 _nd5l1b6c _10fph9n0 _1bsb1g7f _1pby11wp _1j46vuon _ehorzgxb _1sjdglyw _1dhy1c6w",
    fixedContentArea: "_152t1l7u _1reo1wug _18m91wug _kqsw1if8 _165t1run",
    visibleForSmallViewports: "_1e0c18uv _dm25glyw",
    visibleFromSmallViewports: "_1e0cglyw _dm2518uv"
};
const $2a40d5d061eb57b6$var$DangerouslyHoistSlotSizes = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
const $2a40d5d061eb57b6$export$f1f0392882771341 = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
const $2a40d5d061eb57b6$export$626ec72ba238b0ad = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
const $2a40d5d061eb57b6$var$ToggleSideNavSmallViewportVisibility = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $5Q9wj.default));
const $2a40d5d061eb57b6$var$ToggleSideNavCollapsed = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $5Q9wj.default));
function $2a40d5d061eb57b6$export$65f7d5f7bef4a5f3() {
    return (0, $eUqFw.useContext)($2a40d5d061eb57b6$export$626ec72ba238b0ad);
}
function $2a40d5d061eb57b6$export$4de9f47e746bcfb9() {
    return (0, $eUqFw.useContext)($2a40d5d061eb57b6$var$ToggleSideNavCollapsed);
}
function $2a40d5d061eb57b6$var$toggleReducer(state) {
    return !state;
}
function $2a40d5d061eb57b6$export$be92b6f5f03c0fe9({ children: children, xcss: xcss, UNSAFE_dangerouslyHoistSlotSizes: UNSAFE_dangerouslyHoistSlotSizes = false }) {
    const [sideNavShown, toggleSideNavVisibility] = (0, $eUqFw.useReducer)($2a40d5d061eb57b6$var$toggleReducer, false);
    const ref = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        var child;
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2a40d5d061eb57b6$var$DangerouslyHoistSlotSizes.Provider, {
        value: UNSAFE_dangerouslyHoistSlotSizes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2a40d5d061eb57b6$var$ToggleSideNavSmallViewportVisibility.Provider, {
        value: toggleSideNavVisibility
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2a40d5d061eb57b6$export$f1f0392882771341.Provider, {
        value: sideNavShown
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $7JEyt.default)([
            $2a40d5d061eb57b6$var$styles.root,
            xcss
        ]),
        id: $2a40d5d061eb57b6$export$a6d827031bcb31d1
    }, children))));
}
function $2a40d5d061eb57b6$export$4188957cd63b68ba() {
    const toggleSideNavSmallViewportVisibility = (0, $eUqFw.useContext)($2a40d5d061eb57b6$var$ToggleSideNavSmallViewportVisibility);
    const isSideNavShownOnSmallViewports = (0, $eUqFw.useContext)($2a40d5d061eb57b6$export$f1f0392882771341);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            $2a40d5d061eb57b6$var$styles.visibleForSmallViewports
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        onClick: toggleSideNavSmallViewportVisibility,
        appearance: "subtle",
        shape: "circle",
        label: isSideNavShownOnSmallViewports ? 'Close Side Navigation' : 'Open Side Navigation',
        isSelected: isSideNavShownOnSmallViewports,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($b8123)))
    }));
}
function $2a40d5d061eb57b6$export$59c0e7c157569311() {
    const toggle = (0, $eUqFw.useContext)($2a40d5d061eb57b6$var$ToggleSideNavCollapsed);
    const isSideNavCollapsed = (0, $eUqFw.useContext)($2a40d5d061eb57b6$export$626ec72ba238b0ad);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            $2a40d5d061eb57b6$var$styles.visibleFromSmallViewports
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        onClick: toggle,
        appearance: "subtle",
        shape: "circle",
        label: isSideNavCollapsed ? 'Expand Side Navigation' : 'Collapse Side Navigation',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ek6Yj)))
    }));
}
function $2a40d5d061eb57b6$export$3b4e64e77073e307({ children: children, xcss: xcss, UNSAFE_height: UNSAFE_height = 64 }) {
    const dangerouslyHoistSlotSizes = (0, $eUqFw.useContext)($2a40d5d061eb57b6$var$DangerouslyHoistSlotSizes);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-layout-slot": true,
        className: (0, $7JEyt.default)([
            $2a40d5d061eb57b6$var$styles.banner,
            xcss
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59HcT.HoistCssVarToLocalGrid), {
        variableName: $2a40d5d061eb57b6$var$bannerMountedVar,
        value: UNSAFE_height
    }), dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59HcT.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: $2a40d5d061eb57b6$var$UNSAFE_bannerVar,
        value: UNSAFE_height
    }), children);
}
function $2a40d5d061eb57b6$export$c4e96258f3b6511({ children: children, xcss: xcss, UNSAFE_height: UNSAFE_height = 56 }) {
    const dangerouslyHoistSlotSizes = (0, $eUqFw.useContext)($2a40d5d061eb57b6$var$DangerouslyHoistSlotSizes);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-layout-slot": true,
        className: (0, $7JEyt.default)([
            $2a40d5d061eb57b6$var$styles.topBar,
            xcss
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59HcT.HoistCssVarToLocalGrid), {
        variableName: $2a40d5d061eb57b6$var$topBarMountedVar,
        value: UNSAFE_height
    }), dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59HcT.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: $2a40d5d061eb57b6$var$UNSAFE_topBarVar,
        value: UNSAFE_height
    }), children);
}
function $2a40d5d061eb57b6$export$2ddb90ad54e5f587({ children: children, defaultWidth: defaultWidth = 365 }) {
    const dangerouslyHoistSlotSizes = (0, $eUqFw.useContext)($2a40d5d061eb57b6$var$DangerouslyHoistSlotSizes);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-layout-slot": true,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            [$2a40d5d061eb57b6$var$panelVar]: `${defaultWidth}px`
        },
        className: (0, $7JEyt.default)([
            $2a40d5d061eb57b6$var$styles.panel,
            $2a40d5d061eb57b6$var$styles.fixedContentArea
        ])
    }, dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59HcT.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: $2a40d5d061eb57b6$var$UNSAFE_panelLayoutVar,
        value: "0px",
        mediaQuery: (0, $4Ywu9.media).above.lg,
        responsiveValue: defaultWidth
    }), children);
}
function $2a40d5d061eb57b6$export$861edd1ccea2f746({ children: children, isFixed: isFixed, xcss: xcss }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-layout-slot": true,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $7JEyt.default)([
            $2a40d5d061eb57b6$var$styles.main,
            isFixed && $2a40d5d061eb57b6$var$styles.fixedContentArea,
            xcss
        ]),
        role: "main"
    }, children);
}
function $2a40d5d061eb57b6$export$1a35787d6353cf6a({ children: children, defaultCollapsed: defaultCollapsed = false, label: label = 'main', defaultWidth: defaultWidth = 320 }) {
    const [isSideNavCollapsedByUser, setSideNavCollapsedByUser] = (0, $eUqFw.useState)(defaultCollapsed);
    const [isSideNavForciblyExpanded, setForciblyExpandSideNav] = (0, $eUqFw.useState)(false);
    const dangerouslyHoistSlotSizes = (0, $eUqFw.useContext)($2a40d5d061eb57b6$var$DangerouslyHoistSlotSizes);
    const isSideNavShownOnSmallViewports = (0, $eUqFw.useContext)($2a40d5d061eb57b6$export$f1f0392882771341);
    const isSideNavExpanded = isSideNavForciblyExpanded || !isSideNavCollapsedByUser;
    const panelSplitterParentRef = (0, $eUqFw.useRef)(null);
    const [width, setWidth] = (0, $eUqFw.useState)(defaultWidth);
    const toggleSideNavCollapsedByUser = (0, $eUqFw.useCallback)(()=>setSideNavCollapsedByUser((prev)=>!prev), []);
    (0, $eUqFw.useLayoutEffect)(()=>{
        const mediaQueryList = window.matchMedia('(min-width: 64rem)');
        const callback = ()=>{
            const isSmallViewport = !mediaQueryList.matches;
            if (isSideNavShownOnSmallViewports) {
                // Going from large → small viewport. Temporarily force the side nav to be expanded, while the user is on a small viewport.
                setForciblyExpandSideNav(isSmallViewport);
                // Going from small → large viewport. Make sure it stays expanded, because it was previously shown on the small viewport.
                if (!isSmallViewport) setSideNavCollapsedByUser(false);
            } else if (!isSmallViewport) // Going from small → large viewport. Undo the temporarily forced side nav expansion.
            setForciblyExpandSideNav(false);
        };
        callback();
        // TODO: Move to bind-event-listener
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        mediaQueryList.addEventListener('change', callback);
        return ()=>{
            // TODO: Move to bind-event-listener
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            mediaQueryList.removeEventListener('change', callback);
        };
    }, [
        isSideNavShownOnSmallViewports
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2a40d5d061eb57b6$export$626ec72ba238b0ad.Provider, {
        value: !isSideNavExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2a40d5d061eb57b6$var$ToggleSideNavCollapsed.Provider, {
        value: toggleSideNavCollapsedByUser
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("nav", {
        "data-layout-slot": true,
        "aria-label": label,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$2a40d5d061eb57b6$var$sideNavVar]: isSideNavExpanded ? `clamp(${$2a40d5d061eb57b6$var$sideNavWidthResizeBounds.min}, ${width}px, ${$2a40d5d061eb57b6$var$sideNavWidthResizeBounds.max})` : $2a40d5d061eb57b6$var$sideNavCollapsedWidth
        },
        ref: panelSplitterParentRef,
        "data-testid": "navigation-system.ui.page-layout.side-nav-container",
        className: (0, $7JEyt.default)([
            $2a40d5d061eb57b6$var$styles.sideNav,
            !isSideNavShownOnSmallViewports && $2a40d5d061eb57b6$var$styles.visibleFromSmallViewports
        ])
    }, dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59HcT.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: $2a40d5d061eb57b6$var$UNSAFE_sideNavLayoutVar,
        value: "0px",
        mediaQuery: (0, $4Ywu9.media).above.md,
        responsiveValue: isSideNavExpanded ? `clamp(${$2a40d5d061eb57b6$var$sideNavWidthResizeBounds.min}, ${width}px, ${$2a40d5d061eb57b6$var$sideNavWidthResizeBounds.max})` : $2a40d5d061eb57b6$var$sideNavCollapsedWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lWATQ.PanelSplitterProvider), {
        panelRef: panelSplitterParentRef,
        panelWidth: width,
        onCompleteResize: setWidth,
        resizeBounds: $2a40d5d061eb57b6$var$sideNavWidthResizeBounds,
        resizingCssVar: $2a40d5d061eb57b6$var$panelSplitterResizingVar,
        onClick: toggleSideNavCollapsedByUser,
        isDragDisabled: !isSideNavExpanded
    }, children))));
}
function $2a40d5d061eb57b6$export$ac3bdfe4cb17f64e({ children: children, xcss: xcss, isFixed: isFixed, defaultWidth: defaultWidth = 330 }) {
    const dangerouslyHoistSlotSizes = (0, $eUqFw.useContext)($2a40d5d061eb57b6$var$DangerouslyHoistSlotSizes);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-layout-slot": true,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $7JEyt.default)([
            $2a40d5d061eb57b6$var$styles.aside,
            isFixed && $2a40d5d061eb57b6$var$styles.fixedContentArea,
            xcss
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            [$2a40d5d061eb57b6$var$asideVar]: `${defaultWidth}px`
        }
    }, dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59HcT.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: $2a40d5d061eb57b6$var$UNSAFE_asideLayoutVar,
        value: "0px",
        mediaQuery: (0, $4Ywu9.media).above.md,
        responsiveValue: defaultWidth
    }), children);
}

});
parcelRegister("b8123", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $81a13e0001b9fa39$var$_react = $81a13e0001b9fa39$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $81a13e0001b9fa39$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $81a13e0001b9fa39$var$MenuExpandIcon = (props)=>/*#__PURE__*/ $81a13e0001b9fa39$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M6 12c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 12zm0 4c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 16zm0-8c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 8z" fill="currentColor"/></svg>`
    }, props));
$81a13e0001b9fa39$var$MenuExpandIcon.displayName = 'MenuExpandIcon';
var $81a13e0001b9fa39$var$_default = $81a13e0001b9fa39$var$MenuExpandIcon;
module.exports.default = $81a13e0001b9fa39$var$_default;

});

parcelRegister("ek6Yj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a6d8575f9eb76f83$var$_react = $a6d8575f9eb76f83$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $a6d8575f9eb76f83$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a6d8575f9eb76f83$var$RoomMenuIcon = (props)=>/*#__PURE__*/ $a6d8575f9eb76f83$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M14 17h4V7h-4v10zM12 6.007C12 5.45 12.453 5 12.997 5h6.006c.55 0 .997.45.997 1.007v11.986c0 .556-.453 1.007-.997 1.007h-6.006c-.55 0-.997-.45-.997-1.007V6.007z" fill-rule="nonzero"/><rect x="4" y="5" width="6" height="2" rx="1"/><rect x="4" y="9" width="6" height="2" rx="1"/><rect x="4" y="13" width="6" height="2" rx="1"/><rect x="4" y="17" width="6" height="2" rx="1"/></g></svg>`
    }, props));
$a6d8575f9eb76f83$var$RoomMenuIcon.displayName = 'RoomMenuIcon';
var $a6d8575f9eb76f83$var$_default = $a6d8575f9eb76f83$var$RoomMenuIcon;
module.exports.default = $a6d8575f9eb76f83$var$_default;

});

parcelRegister("59HcT", function(module, exports) {

$parcel$export(module.exports, "HoistCssVarToLocalGrid", () => $71e37afe5eb208b7$export$cfa3cd08d675e56e);
$parcel$export(module.exports, "DangerouslyHoistCssVarToDocumentRoot", () => $71e37afe5eb208b7$export$9f45a1325e3cdfb8);

var $eUqFw = parcelRequire("eUqFw");

var $b5l09 = parcelRequire("b5l09");
const $71e37afe5eb208b7$export$cfa3cd08d675e56e = ({ variableName: variableName, value: value })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("style", null, `#${(0, $b5l09.gridRootId)} { ${variableName}: ${value}px }`);
const $71e37afe5eb208b7$var$getCssStringValue = (value)=>typeof value === 'number' ? `${value}px` : value;
const $71e37afe5eb208b7$export$9f45a1325e3cdfb8 = ({ variableName: variableName, value: value, mediaQuery: mediaQuery, responsiveValue: responsiveValue })=>{
    /**
	 * Note don't put multiple variables in multiple lines. eg
	 * <style>
	 *   {css1}
	 *   {css2}
	 * </style>
	 *
	 * React will insert an empty HTML comment in between the text in SSR.
	 * This is not a valid tag and will break the page.
	 * <style>foo<!-- -->bar</style>
	 */ let style = `:root { ${variableName}: ${$71e37afe5eb208b7$var$getCssStringValue(value)} }`;
    if (mediaQuery && responsiveValue) style += ` ${mediaQuery} { :root { ${variableName}: ${$71e37afe5eb208b7$var$getCssStringValue(responsiveValue)} } }`;
    return(// Using a global style is required for SSR, as we can't use React hooks
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("style", null, style));
};

});

parcelRegister("lWATQ", function(module, exports) {

$parcel$export(module.exports, "PanelSplitterProvider", () => $294fcdaee6e5d8fd$export$f662bfb764348932);
$parcel$export(module.exports, "PanelSplitter", () => $294fcdaee6e5d8fd$export$db67e3f8d3d6da0f);
/* panel-splitter.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lEfVV = parcelRequire("lEfVV");

var $8ynlC = parcelRequire("8ynlC");
parcelRequire("eo9PV");
var $9wCS5 = parcelRequire("9wCS5");
parcelRequire("cbxSN");
var $iYy22 = parcelRequire("iYy22");
parcelRequire("jTs7k");
var $1xLt0 = parcelRequire("1xLt0");

var $4ZL0y = parcelRequire("4ZL0y");

var $lkPEe = parcelRequire("lkPEe");

var $exYPH = parcelRequire("exYPH");

var $gahth = parcelRequire("gahth");
/**
 * Determines the color of the grab line.
 *
 * Used on internal leaf node, so naming collisions won't matter.
 */ const $294fcdaee6e5d8fd$var$lineColorVar = '--panelSplitterLineColor'; // Widening type to string to satisfy @compiled/react typing https://atlassian.slack.com/archives/C017XR8K1RB/p1718071105514759
const $294fcdaee6e5d8fd$var$styles = {
    root: "_1e0cglyw _181n1ule _1rqistnw _11ekidpf _12hoidpf _isaet94y _1qie1r31 _3mkmglyw _1y6k1o36",
    grabArea: "_1bsb7vkz _4t3i1osq _1yt4ze3t _bfhk18uv _19itglyw _kqswstnw _nt751r31 _49pcglyw _1hvw1o36 _d0aluf7j _1lf31fvw _d2p71fvw _15p518hz",
    line: "_1e0c1ule _1bsbjfq9 _4t3i1osq _bfhk17tf _v564z97a",
    panelChildrenWrapper: "_1reo1wug _18m91wug _4t3i1osq",
    buttonContent: "_1bsb1osq _4t3i1osq"
};
const $294fcdaee6e5d8fd$var$PanelSplitterContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $294fcdaee6e5d8fd$export$f662bfb764348932 = ({ panelWidth: panelWidth, onCompleteResize: onCompleteResize, resizeBounds: resizeBounds, resizingCssVar: resizingCssVar, onClick: onClick, isDragDisabled: isDragDisabled, panelRef: panelRef, children: children })=>{
    const portalRef = (0, $eUqFw.useRef)(null);
    return /*#__PURE__*/ $eUqFw.createElement((0, $eUqFw.Fragment), null, /*#__PURE__*/ $eUqFw.createElement($294fcdaee6e5d8fd$var$PanelSplitterContext.Provider, {
        value: {
            panelWidth: panelWidth,
            onCompleteResize: onCompleteResize,
            resizeBounds: resizeBounds,
            portalRef: portalRef,
            resizingCssVar: resizingCssVar,
            onClick: onClick,
            isDragDisabled: isDragDisabled,
            panelRef: panelRef
        }
    }, /*#__PURE__*/ $eUqFw.createElement("div", {
        className: (0, $7JEyt.default)([
            $294fcdaee6e5d8fd$var$styles.panelChildrenWrapper
        ])
    }, children)), /*#__PURE__*/ $eUqFw.createElement("div", {
        ref: portalRef
    }));
};
const $294fcdaee6e5d8fd$var$PortaledPanelSplitter = ({ children: children })=>{
    const splitterRef = (0, $eUqFw.useRef)(null);
    const panelSplitterContext = (0, $eUqFw.useContext)($294fcdaee6e5d8fd$var$PanelSplitterContext);
    (0, $8ynlC.default)(panelSplitterContext, 'Panel splitter context must be set');
    const { panelWidth: panelWidth, onCompleteResize: onCompleteResize, resizeBounds: resizeBounds, panelRef: panelRef, resizingCssVar: resizingCssVar, isDragDisabled: isDragDisabled, portalRef: portalRef } = panelSplitterContext;
    (0, $8ynlC.default)(portalRef.current, 'Portal ref must be set');
    const direction = (0, $exYPH.useTextDirection)(portalRef.current);
    (0, $eUqFw.useEffect)(()=>{
        const splitter = splitterRef.current;
        (0, $8ynlC.default)(splitter, 'Splitter ref must be set');
        return (0, $9wCS5.draggable)({
            element: splitter,
            canDrag: ()=>!isDragDisabled,
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                // We will be moving the line to indicate a drag. We can disable the native drag preview
                (0, $iYy22.disableNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage
                });
                // We don't want any native drop animation for when the user does not drop on a drop target. We want the drag to finish immediately
                (0, $1xLt0.preventUnhandled).start();
            },
            getInitialData () {
                (0, $8ynlC.default)(panelRef.current, 'Panel ref must be set');
                /**
         * The drag calculations require the actual computed width of the element
         * For example, if the panel has loaded with a width of 2000px, but the max bound is 1000px and is visually 1000px (due to the CSS `clamp()`),
         * the drag calculations should use the actual width of 1000px, not the width in state of 2000px.
         */ return {
                    initialWidth: (0, $gahth.getComputedWidth)(panelRef.current)
                };
            },
            onDrag ({ location: location, source: source }) {
                if (typeof source.data.initialWidth !== 'number') return;
                panelRef.current?.style.setProperty(resizingCssVar, `clamp(${resizeBounds.min}, ${(0, $gahth.getWidthFromDragLocation)({
                    initialWidth: source.data.initialWidth,
                    location: location,
                    direction: direction
                })}px, ${resizeBounds.max})`);
            },
            onDrop () {
                (0, $1xLt0.preventUnhandled).stop();
                (0, $8ynlC.default)(panelRef.current, 'Panel ref must be set');
                onCompleteResize((0, $gahth.getComputedWidth)(panelRef.current));
                panelRef.current?.style.removeProperty(resizingCssVar);
            }
        });
    }, [
        isDragDisabled,
        onCompleteResize,
        panelRef,
        resizingCssVar,
        panelWidth,
        resizeBounds,
        direction
    ]);
    return /*#__PURE__*/ (0, $lEfVV.createPortal)(/*#__PURE__*/ $eUqFw.createElement("div", {
        className: (0, $7JEyt.default)([
            $294fcdaee6e5d8fd$var$styles.root
        ])
    }, /*#__PURE__*/ $eUqFw.createElement((0, $4ZL0y.default), {
        ref: splitterRef,
        xcss: $294fcdaee6e5d8fd$var$styles.grabArea,
        onClick: panelSplitterContext.onClick
    }, /*#__PURE__*/ $eUqFw.createElement("div", {
        className: (0, $7JEyt.default)([
            $294fcdaee6e5d8fd$var$styles.buttonContent
        ])
    }, /*#__PURE__*/ $eUqFw.createElement((0, $lkPEe.default), null, children), /*#__PURE__*/ $eUqFw.createElement("span", {
        className: (0, $7JEyt.default)([
            $294fcdaee6e5d8fd$var$styles.line
        ])
    })))), portalRef.current);
};
// Ensures that the component is only rendered on a client. Uses a `useEffect`, which is not run on servers.
const $294fcdaee6e5d8fd$var$ClientOnly = ({ children: children })=>{
    const [hasMounted, setHasMounted] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        setHasMounted(true);
    }, []);
    return /*#__PURE__*/ $eUqFw.createElement((0, $eUqFw.Fragment), null, hasMounted ? children : null);
};
const $294fcdaee6e5d8fd$export$db67e3f8d3d6da0f = ({ children: children })=>/*#__PURE__*/ $eUqFw.createElement($294fcdaee6e5d8fd$var$ClientOnly, null, /*#__PURE__*/ $eUqFw.createElement($294fcdaee6e5d8fd$var$PortaledPanelSplitter, null, children));

});
parcelRegister("eo9PV", function(module, exports) {

$parcel$export(module.exports, "draggable", () => (parcelRequire("9wCS5")).draggable);
$parcel$export(module.exports, "dropTargetForElements", () => (parcelRequire("9wCS5")).dropTargetForElements);
$parcel$export(module.exports, "monitorForElements", () => (parcelRequire("9wCS5")).monitorForElements);

var $9wCS5 = parcelRequire("9wCS5");

});
parcelRegister("9wCS5", function(module, exports) {

$parcel$export(module.exports, "dropTargetForElements", () => $713a693c74f5088c$export$e7140b68045b5036);
$parcel$export(module.exports, "monitorForElements", () => $713a693c74f5088c$export$59a074bac4c54f54);
$parcel$export(module.exports, "draggable", () => $713a693c74f5088c$export$c746a5152d4ba26c);

var $74BVL = parcelRequire("74BVL");

var $cHW1B = parcelRequire("cHW1B");

var $8pyWR = parcelRequire("8pyWR");

var $4PCWk = parcelRequire("4PCWk");

var $jFl9L = parcelRequire("jFl9L");

var $ggbKc = parcelRequire("ggbKc");

var $eDT75 = parcelRequire("eDT75");

var $kb9dc = parcelRequire("kb9dc");



const $713a693c74f5088c$var$draggableRegistry = new WeakMap();
function $713a693c74f5088c$var$addToRegistry(args) {
    $713a693c74f5088c$var$draggableRegistry.set(args.element, args);
    return function cleanup() {
        $713a693c74f5088c$var$draggableRegistry.delete(args.element);
    };
}
const $713a693c74f5088c$var$honeyPotFix = (0, $8pyWR.makeHoneyPotFix)();
const $713a693c74f5088c$var$adapter = (0, $4PCWk.makeAdapter)({
    typeKey: 'element',
    defaultDropEffect: 'move',
    mount (api) {
        /**  Binding event listeners the `document` rather than `window` so that
		 * this adapter always gets preference over the text adapter.
		 * `document` is the first `EventTarget` under `window`
		 * https://twitter.com/alexandereardon/status/1604658588311465985
		 */ return (0, $jFl9L.combine)($713a693c74f5088c$var$honeyPotFix.bindEvents(), (0, $74BVL.bind)(document, {
            type: 'dragstart',
            listener (event) {
                if (!api.canStart(event)) return;
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Technically `dataTransfer` can be `null` according to the types
                // But that behaviour does not seem to appear in the spec.
                // If there is not `dataTransfer`, we can assume something is wrong and not
                // start a drag
                if (!event.dataTransfer) return;
                // the closest parent that is a draggable element will be marked as
                // the `event.target` for the event
                const target = event.target;
                // this source is only for elements
                // Note: only HTMLElements can have the "draggable" attribute
                if (!(target instanceof HTMLElement)) return null;
                // see if the thing being dragged is owned by us
                const entry = $713a693c74f5088c$var$draggableRegistry.get(target);
                // no matching element found
                // → dragging an element with `draggable="true"` that is not controlled by us
                if (!entry) return null;
                const input = (0, $kb9dc.getInput)(event);
                const feedback = {
                    element: entry.element,
                    dragHandle: entry.dragHandle ?? null,
                    input: input
                };
                // Check: does the draggable want to allow dragging?
                if (entry.canDrag && !entry.canDrag(feedback)) {
                    // cancel drag operation if we cannot drag
                    event.preventDefault();
                    return null;
                }
                // Check: is there a drag handle and is the user using it?
                if (entry.dragHandle) {
                    // technically don't need this util, but just being
                    // consistent with how we look up what is under the users
                    // cursor.
                    const over = (0, $cHW1B.getElementFromPointWithoutHoneypot)({
                        x: input.clientX,
                        y: input.clientY
                    });
                    // if we are not dragging from the drag handle (or something inside the drag handle)
                    // then we will cancel the active drag
                    if (!entry.dragHandle.contains(over)) {
                        event.preventDefault();
                        return null;
                    }
                }
                /**
					 *  **Goal**
					 *  Pass information to other applications
					 *
					 * **Approach**
					 *  Put data into the native data store
					 *
					 *  **What about the native adapter?**
					 *  When the element adapter puts native data into the native data store
					 *  the native adapter is not triggered in the current window,
					 *  but a native adapter in an external window _can_ be triggered
					 *
					 *  **Why bake this into core?**
					 *  This functionality could be pulled out and exposed inside of
					 *  `onGenerateDragPreview`. But decided to make it a part of the
					 *  base API as it felt like a common enough use case and ended
					 *  up being a similar amount of code to include this function as
					 *  it was to expose the hook for it
					 */ const nativeData = entry.getInitialDataForExternal?.(feedback) ?? null;
                if (nativeData) for (const [key, data] of Object.entries(nativeData))event.dataTransfer.setData(key, data ?? '');
                /**
					 *  📱 For Android devices, a drag operation will not start unless
					 * "text/plain" or "text/uri-list" data exists in the native data store
					 * https://twitter.com/alexandereardon/status/1732189803754713424
					 *
					 * Tested on:
					 * Device: Google Pixel 5
					 * Android version: 14 (November 5, 2023)
					 * Chrome version: 120.0
					 */ const { types: types } = event.dataTransfer;
                if ((0, $eDT75.isAndroid)() && !types.includes((0, $559dbbdafee2f66d$export$fd3d00026297c0ad)) && !types.includes((0, $63b7ad043dd75799$export$bc594fb6cfea5e58))) event.dataTransfer.setData((0, $559dbbdafee2f66d$export$fd3d00026297c0ad), (0, $eDT75.androidFallbackText));
                /**
					 * 1. Must set any media type for `iOS15` to work
					 * 2. We are also doing adding data so that the native adapter
					 * can know that the element adapter has handled this drag
					 *
					 * We used to wrap this `setData()` in a `try/catch` for Firefox,
					 * but it looks like that was not needed.
					 *
					 * Tested using: https://codesandbox.io/s/checking-firefox-throw-behaviour-on-dragstart-qt8h4f
					 *
					 * - ✅ Firefox@70.0 (Oct 2019) on macOS Sonoma
					 * - ✅ Firefox@70.0 (Oct 2019) on macOS Big Sur
					 * - ✅ Firefox@70.0 (Oct 2019) on Windows 10
					 *
					 * // just checking a few more combinations to be super safe
					 *
					 * - ✅ Chrome@78 (Oct 2019) on macOS Big Sur
					 * - ✅ Chrome@78 (Oct 2019) on Windows 10
					 * - ✅ Safari@14.1 on macOS Big Sur
					 */ event.dataTransfer.setData((0, $4df75fb0870d0fce$export$c9c4cc54e73b125d), '');
                const payload = {
                    element: entry.element,
                    dragHandle: entry.dragHandle ?? null,
                    data: entry.getInitialData?.(feedback) ?? {}
                };
                const dragType = {
                    type: 'element',
                    payload: payload,
                    startedFrom: 'internal'
                };
                api.start({
                    event: event,
                    dragType: dragType
                });
            }
        }));
    },
    dispatchEventToSource: ({ eventName: eventName, payload: payload })=>{
        // During a drag operation, a draggable can be:
        // - remounted with different functions
        // - removed completely
        // So we need to get the latest entry from the registry in order
        // to call the latest event functions
        $713a693c74f5088c$var$draggableRegistry.get(payload.source.element)?.[eventName]?.(// I cannot seem to get the types right here.
        // TS doesn't seem to like that one event can need `nativeSetDragImage`
        // @ts-expect-error
        payload);
    },
    onPostDispatch: $713a693c74f5088c$var$honeyPotFix.getOnPostDispatch()
});
const $713a693c74f5088c$export$e7140b68045b5036 = $713a693c74f5088c$var$adapter.dropTarget;
const $713a693c74f5088c$export$59a074bac4c54f54 = $713a693c74f5088c$var$adapter.monitor;
function $713a693c74f5088c$export$c746a5152d4ba26c(args) {
    return (0, $jFl9L.combine)(// making the draggable register the adapter rather than drop targets
    // this is because you *must* have a draggable element to start a drag
    // but you _might_ not have any drop targets immediately
    // (You might create drop targets async)
    $713a693c74f5088c$var$adapter.registerUsage(), $713a693c74f5088c$var$addToRegistry(args), (0, $ggbKc.addAttribute)(args.element, {
        attribute: 'draggable',
        value: 'true'
    }));
}

});
parcelRegister("cHW1B", function(module, exports) {

$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => $4de7b3023d657aff$export$81d0353f25f5dd);

var $7HOOK = parcelRequire("7HOOK");
function $4de7b3023d657aff$export$81d0353f25f5dd(client) {
    // eslint-disable-next-line no-restricted-syntax
    const [top, second] = document.elementsFromPoint(client.x, client.y);
    if (!top) return null;
    if ((0, $7HOOK.isHoneyPotElement)(top)) return second ?? null;
    return top;
}

});
parcelRegister("7HOOK", function(module, exports) {

$parcel$export(module.exports, "isHoneyPotElement", () => $40cb98f5bdb41c1d$export$821bdcd739a2706b);

function $40cb98f5bdb41c1d$export$821bdcd739a2706b(target) {
    return target instanceof Element && target.hasAttribute((0, $d783bf87f05fb737$export$6eafea55f7947469));
}

});
// pulling this into a separate file so adapter(s) that don't
// need the honey pot can pay as little as possible for it.
const $d783bf87f05fb737$export$6eafea55f7947469 = 'data-pdnd-honey-pot';



parcelRegister("8pyWR", function(module, exports) {

$parcel$export(module.exports, "makeHoneyPotFix", () => $be63984178d64c97$export$8ecad27c959e89e0);

var $74BVL = parcelRequire("74BVL");


const $be63984178d64c97$var$honeyPotSize = 2;
const $be63984178d64c97$var$halfHoneyPotSize = $be63984178d64c97$var$honeyPotSize / 2;
/**
 * `clientX` and `clientY` can be in sub pixels (eg `2.332`)
 * However, browser hitbox testing is commonly do to the closest pixel.
 *
 * → https://issues.chromium.org/issues/40940531
 *
 * To be sure that the honey pot will be over the `client` position,
 * we `.floor()` `clientX` and`clientY` and then make it `2px` in size.
 **/ function $be63984178d64c97$var$floorToClosestPixel(point) {
    return {
        x: Math.floor(point.x),
        y: Math.floor(point.y)
    };
}
/**
 * We want to make sure the honey pot sits around the users position.
 * This seemed to be the most resilient while testing.
 */ function $be63984178d64c97$var$pullBackByHalfHoneyPotSize(point) {
    return {
        x: point.x - $be63984178d64c97$var$halfHoneyPotSize,
        y: point.y - $be63984178d64c97$var$halfHoneyPotSize
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $be63984178d64c97$var$preventGoingBackwardsOffScreen(point) {
    return {
        x: Math.max(point.x, 0),
        y: Math.max(point.y, 0)
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $be63984178d64c97$var$preventGoingForwardsOffScreen(point) {
    return {
        x: Math.min(point.x, window.innerWidth - $be63984178d64c97$var$honeyPotSize),
        y: Math.min(point.y, window.innerHeight - $be63984178d64c97$var$honeyPotSize)
    };
}
/**
 * Create a `2x2` `DOMRect` around the `client` position
 */ function $be63984178d64c97$var$getHoneyPotRectFor({ client: client }) {
    const point = $be63984178d64c97$var$preventGoingForwardsOffScreen($be63984178d64c97$var$preventGoingBackwardsOffScreen($be63984178d64c97$var$pullBackByHalfHoneyPotSize($be63984178d64c97$var$floorToClosestPixel(client))));
    // When debugging, it is helpful to
    // make this element a bit bigger
    return DOMRect.fromRect({
        x: point.x,
        y: point.y,
        width: $be63984178d64c97$var$honeyPotSize,
        height: $be63984178d64c97$var$honeyPotSize
    });
}
function $be63984178d64c97$var$getRectStyles({ clientRect: clientRect }) {
    return {
        left: `${clientRect.left}px`,
        top: `${clientRect.top}px`,
        width: `${clientRect.width}px`,
        height: `${clientRect.height}px`
    };
}
function $be63984178d64c97$var$isWithin({ client: client, clientRect: clientRect }) {
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
/**
 * The honey pot fix is designed to get around a painful bug in all browsers.
 *
 * [Overview](https://www.youtube.com/watch?v=udE9qbFTeQg)
 *
 * **Background**
 *
 * When a drag starts, browsers incorrectly think that the users pointer is
 * still depressed where the drag started. Any element that goes under this position
 * will be entered into, causing `"mouseenter"` events and `":hover"` styles to be applied.
 *
 * _This is a violation of the spec_
 *
 * > "From the moment that the user agent is to initiate the drag-and-drop operation,
 * > until the end 	of the drag-and-drop operation, device input events
 * > (e.g. mouse and keyboard events) must be suppressed."
 * >
 * > - https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
 *
 * _Some impacts_
 *
 * - `":hover"` styles being applied where they shouldn't (looks messy)
 * - components such as tooltips responding to `"mouseenter"` can show during a drag,
 *   and on an element the user isn't even over
 *
 * Bug: https://issues.chromium.org/issues/41129937
 *
 * **Honey pot fix**
 *
 * 1. Create an element where the browser thinks the depressed pointer is
 *    to absorb the incorrect pointer events
 * 2. Remove that element when it is no longer needed
 */ function $be63984178d64c97$var$mountHoneyPot({ initial: initial }) {
    const element = document.createElement('div');
    element.setAttribute((0, $d783bf87f05fb737$export$6eafea55f7947469), 'true');
    // can shift during the drag thanks to Firefox
    let clientRect = $be63984178d64c97$var$getHoneyPotRectFor({
        client: initial
    });
    Object.assign(element.style, {
        // Setting a background color explicitly to avoid any inherited styles.
        // Looks like this could be `opacity: 0`, but worried that _might_
        // cause the element to be ignored on some platforms.
        // When debugging, set backgroundColor to something like "red".
        backgroundColor: 'transparent',
        position: 'fixed',
        // Being explicit to avoid inheriting styles
        padding: 0,
        margin: 0,
        boxSizing: 'border-box',
        ...$be63984178d64c97$var$getRectStyles({
            clientRect: clientRect
        }),
        // We want this element to absorb pointer events,
        // it's kind of the whole point 😉
        pointerEvents: 'auto',
        // Want to make sure the honey pot is top of everything else.
        // Don't need to worry about native drag previews, as they will
        // have been rendered (and removed) before the honey pot is rendered
        zIndex: (0, $3c294e0fb95263f6$export$7d0a15ee70427305)
    });
    document.body.appendChild(element);
    /**
	 *  🦊 In firefox we can get `"pointermove"` events after the drag
	 * has started, which is a spec violation.
	 * The final `"pointermove"` will reveal where the "depressed" position
	 * is for our honey pot fix.
	 */ const unbindPointerMove = (0, $74BVL.bind)(window, {
        type: 'pointermove',
        listener (event) {
            const client = {
                x: event.clientX,
                y: event.clientY
            };
            clientRect = $be63984178d64c97$var$getHoneyPotRectFor({
                client: client
            });
            Object.assign(element.style, $be63984178d64c97$var$getRectStyles({
                clientRect: clientRect
            }));
        },
        // using capture so we are less likely to be impacted by event stopping
        options: {
            capture: true
        }
    });
    return function finish({ current: current }) {
        // Don't need this any more
        unbindPointerMove();
        // If the user is hover the honey pot, we remove it
        // so that the user can continue to interact with the page normally.
        if ($be63984178d64c97$var$isWithin({
            client: current,
            clientRect: clientRect
        })) {
            element.remove();
            return;
        }
        function cleanup() {
            unbindPostDragEvents();
            element.remove();
        }
        const unbindPostDragEvents = (0, $74BVL.bindAll)(window, [
            {
                type: 'pointerdown',
                listener: cleanup
            },
            {
                type: 'pointermove',
                listener: cleanup
            },
            {
                type: 'focusin',
                listener: cleanup
            },
            {
                type: 'focusout',
                listener: cleanup
            },
            // a 'pointerdown' should happen before 'dragstart', but just being super safe
            {
                type: 'dragstart',
                listener: cleanup
            },
            // if the user has dragged something out of the window
            // and then is dragging something back into the window
            // the first events we will see are "dragenter" (and then "dragover").
            // So if we see any of these we need to clear the post drag fix.
            {
                type: 'dragenter',
                listener: cleanup
            },
            {
                type: 'dragover',
                listener: cleanup
            }
        ], {
            // Using `capture` so less likely to be impacted by other code stopping events
            capture: true
        });
    };
}
function $be63984178d64c97$export$8ecad27c959e89e0() {
    let latestPointerMove = null;
    function bindEvents() {
        // For sanity, only collecting this value from when events are first bound.
        // This prevents the case where a super old "pointermove" could be used
        // from a prior interaction.
        latestPointerMove = null;
        return (0, $74BVL.bind)(window, {
            type: 'pointermove',
            listener (event) {
                latestPointerMove = {
                    x: event.clientX,
                    y: event.clientY
                };
            },
            // listening for pointer move in capture phase
            // so we are less likely to be impacted by events being stopped.
            options: {
                capture: true
            }
        });
    }
    function getOnPostDispatch() {
        let finish = null;
        return function onPostEvent({ eventName: eventName, payload: payload }) {
            // We are adding the honey pot `onDragStart` so we don't
            // impact the creation of the native drag preview.
            if (eventName === 'onDragStart') {
                const { input: input } = payload.location.initial;
                // Sometimes there will be no latest "pointermove" (eg iOS).
                // In which case, we use the start position of the drag.
                const initial = latestPointerMove ?? {
                    x: input.clientX,
                    y: input.clientY
                };
                // Don't need to defensively call `finish()` as `onDrop` from
                // one interaction is guaranteed to be called before `onDragStart`
                // of the next.
                finish = $be63984178d64c97$var$mountHoneyPot({
                    initial: initial
                });
            }
            if (eventName === 'onDrop') {
                const { input: input } = payload.location.current;
                finish?.({
                    current: {
                        x: input.clientX,
                        y: input.clientY
                    }
                });
                finish = null;
                // this interaction is finished, we want to use
                // the latest "pointermove" for each interaction
                latestPointerMove = null;
            }
        };
    }
    return {
        bindEvents: bindEvents,
        getOnPostDispatch: getOnPostDispatch
    };
}

});
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
const $3c294e0fb95263f6$export$7d0a15ee70427305 = 2147483647;


parcelRegister("4PCWk", function(module, exports) {

$parcel$export(module.exports, "makeAdapter", () => $e5ed704461f1a07b$export$2aa3a33160990d96);

var $jlxyb = parcelRequire("jlxyb");

var $buJNg = parcelRequire("buJNg");

var $gItnR = parcelRequire("gItnR");

var $j14G1 = parcelRequire("j14G1");
function $e5ed704461f1a07b$export$2aa3a33160990d96({ typeKey: typeKey, mount: mount, dispatchEventToSource: dispatchEventToSource, onPostDispatch: onPostDispatch, defaultDropEffect: defaultDropEffect }) {
    const monitorAPI = (0, $j14G1.makeMonitor)();
    const dropTargetAPI = (0, $gItnR.makeDropTarget)({
        typeKey: typeKey,
        defaultDropEffect: defaultDropEffect
    });
    function dispatchEvent(args) {
        // 1. forward the event to source
        dispatchEventToSource?.(args);
        // 2. forward the event to relevant dropTargets
        dropTargetAPI.dispatchEvent(args);
        // 3. forward event to monitors
        monitorAPI.dispatchEvent(args);
        // 4. post consumer dispatch (used for honey pot fix)
        onPostDispatch?.(args);
    }
    function start({ event: event, dragType: dragType }) {
        (0, $jlxyb.lifecycle).start({
            event: event,
            dragType: dragType,
            getDropTargetsOver: dropTargetAPI.getIsOver,
            dispatchEvent: dispatchEvent
        });
    }
    function registerUsage() {
        function mountAdapter() {
            const api = {
                canStart: (0, $jlxyb.lifecycle).canStart,
                start: start
            };
            return mount(api);
        }
        return (0, $buJNg.register)({
            typeKey: typeKey,
            mount: mountAdapter
        });
    }
    return {
        registerUsage: registerUsage,
        dropTarget: dropTargetAPI.dropTargetForConsumers,
        monitor: monitorAPI.monitorForConsumers
    };
}

});
parcelRegister("jlxyb", function(module, exports) {

$parcel$export(module.exports, "lifecycle", () => $6868b9e56fe4f659$export$3efdceeb8ca25c51);

var $74BVL = parcelRequire("74BVL");

var $cHW1B = parcelRequire("cHW1B");

var $7HOOK = parcelRequire("7HOOK");

var $coJJ5 = parcelRequire("coJJ5");

var $fURjR = parcelRequire("fURjR");

var $kb9dc = parcelRequire("kb9dc");

var $9A5IM = parcelRequire("9A5IM");
const $6868b9e56fe4f659$var$globalState = {
    isActive: false
};
function $6868b9e56fe4f659$var$canStart() {
    return !$6868b9e56fe4f659$var$globalState.isActive;
}
function $6868b9e56fe4f659$var$getNativeSetDragImage(event) {
    if (event.dataTransfer) // need to use `.bind` as `setDragImage` is required
    // to be run with `event.dataTransfer` as the "this" context
    return event.dataTransfer.setDragImage.bind(event.dataTransfer);
    return null;
}
function $6868b9e56fe4f659$var$hasHierarchyChanged({ current: current, next: next }) {
    if (current.length !== next.length) return true;
    // not checking stickiness, data or dropEffect,
    // just whether the hierarchy has changed
    for(let i = 0; i < current.length; i++){
        if (current[i].element !== next[i].element) return true;
    }
    return false;
}
function $6868b9e56fe4f659$var$start({ event: event, dragType: dragType, getDropTargetsOver: getDropTargetsOver, dispatchEvent: dispatchEvent }) {
    if (!$6868b9e56fe4f659$var$canStart()) return;
    const initial = $6868b9e56fe4f659$var$getStartLocation({
        event: event,
        dragType: dragType,
        getDropTargetsOver: getDropTargetsOver
    });
    $6868b9e56fe4f659$var$globalState.isActive = true;
    const state = {
        current: initial
    };
    // Setting initial drop effect for the drag
    $6868b9e56fe4f659$var$setDropEffectOnEvent({
        event: event,
        current: initial.dropTargets
    });
    const dispatch = (0, $9A5IM.makeDispatch)({
        source: dragType.payload,
        dispatchEvent: dispatchEvent,
        initial: initial
    });
    function updateState(next) {
        // only looking at whether hierarchy has changed to determine whether something as 'changed'
        const hasChanged = $6868b9e56fe4f659$var$hasHierarchyChanged({
            current: state.current.dropTargets,
            next: next.dropTargets
        });
        // Always updating the state to include latest data, dropEffect and stickiness
        // Only updating consumers if the hierarchy has changed in some way
        // Consumers can get the latest data by using `onDrag`
        state.current = next;
        if (hasChanged) dispatch.dragUpdate({
            current: state.current
        });
    }
    function onUpdateEvent(event) {
        const input = (0, $kb9dc.getInput)(event);
        // If we are over the honey pot, we need to get the element
        // that the user would have been over if not for the honey pot
        const target = (0, $7HOOK.isHoneyPotElement)(event.target) ? (0, $cHW1B.getElementFromPointWithoutHoneypot)({
            x: input.clientX,
            y: input.clientY
        }) : event.target;
        const nextDropTargets = getDropTargetsOver({
            target: target,
            input: input,
            source: dragType.payload,
            current: state.current.dropTargets
        });
        if (nextDropTargets.length) {
            // 🩸 must call `event.preventDefault()` to allow a browser drop to occur
            event.preventDefault();
            $6868b9e56fe4f659$var$setDropEffectOnEvent({
                event: event,
                current: nextDropTargets
            });
        }
        updateState({
            dropTargets: nextDropTargets,
            input: input
        });
    }
    function cancel() {
        // The spec behaviour is that when a drag is cancelled, or when dropping on no drop targets,
        // a "dragleave" event is fired on the active drop target before a "dragend" event.
        // We are replicating that behaviour in `cancel` if there are any active drop targets to
        // ensure consistent behaviour.
        //
        // Note: When cancelling, or dropping on no drop targets, a "dragleave" event
        // will have already cleared the dropTargets to `[]` (as that particular "dragleave" has a `relatedTarget` of `null`)
        if (state.current.dropTargets.length) updateState({
            dropTargets: [],
            input: state.current.input
        });
        dispatch.drop({
            current: state.current,
            updatedSourcePayload: null
        });
        finish();
    }
    function finish() {
        $6868b9e56fe4f659$var$globalState.isActive = false;
        unbindEvents();
    }
    const unbindEvents = (0, $74BVL.bindAll)(window, [
        {
            // 👋 Note: we are repurposing the `dragover` event as our `drag` event
            // this is because firefox does not publish pointer coordinates during
            // a `drag` event, but does for every other type of drag event
            // `dragover` fires on all elements that are being dragged over
            // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
            // 🦊😤
            type: 'dragover',
            listener (event) {
                // We need to regularly calculate the drop targets in order to allow:
                //  - dynamic `canDrop()` checks
                //  - rapid updating `getData()` calls to attach data in response to user input (eg for edge detection)
                // Sadly we cannot schedule inspecting changes resulting from this event
                // we need to be able to conditionally cancel the event with `event.preventDefault()`
                // to enable the correct native drop experience.
                // 1. check to see if anything has changed
                onUpdateEvent(event);
                // 2. let consumers know a move has occurred
                // This will include the latest 'input' values
                dispatch.drag({
                    current: state.current
                });
            }
        },
        {
            type: 'dragenter',
            listener: onUpdateEvent
        },
        {
            type: 'dragleave',
            listener (event) {
                if (!(0, $coJJ5.isLeavingWindow)({
                    dragLeave: event
                })) return;
                /**
					 * At this point we don't know if a drag is being cancelled,
					 * or if a drag is leaving the `window`.
					 *
					 * Both have:
					 *   1. "dragleave" (with `relatedTarget: null`)
					 *   2. "dragend" (a "dragend" can occur when outside the `window`)
					 *
					 * **Clearing drop targets**
					 *
					 * For either case we are clearing the the drop targets
					 *
					 * - cancelling: we clear drop targets in `"dragend"` anyway
					 * - leaving the `window`: we clear the drop targets (to clear stickiness)
					 *
					 * **Leaving the window and finishing the drag**
					 *
					 * _internal drags_
					 *
					 * - The drag continues when the user is outside the `window`
					 *   and can resume if the user drags back over the `window`,
					 *   or end when the user drops in an external `window`.
					 * - We will get a `"dragend"`, or we can listen for other
					 *   events to determine the drag is finished when the user re-enters the `window`).
					 *
					 * _external drags_
					 *
					 * - We conclude the drag operation.
					 * - We have no idea if the user will drag back over the `window`,
					 *   or if the drag ends elsewhere.
					 * - We will create a new drag if the user re-enters the `window`.
					 *
					 * **Not updating `input`**
					 *
					 * 🐛 Bug[Chrome] the final `"dragleave"` has default input values (eg `clientX == 0`)
					 * Workaround: intentionally not updating `input` in "dragleave"
					 * rather than the users current input values
					 * - [Conversation](https://twitter.com/alexandereardon/status/1642697633864241152)
					 * - [Bug](https://bugs.chromium.org/p/chromium/issues/detail?id=1429937)
					 **/ updateState({
                    input: state.current.input,
                    dropTargets: []
                });
                if (dragType.startedFrom === 'external') cancel();
            }
        },
        {
            // A "drop" can only happen if the browser allowed the drop
            type: 'drop',
            listener (event) {
                // Capture the final input.
                // We are capturing the final `input` for the
                // most accurate honey pot experience
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $kb9dc.getInput)(event)
                };
                /** If there are no drop targets, then we will get
					 * a "drop" event if:
					 * - `preventUnhandled()` is being used
					 * - there is an unmanaged drop target (eg another library)
					 * In these cases, it's up to the consumer
					 * to handle the drop if it's not over one of our drop targets
					 * - `preventUnhandled()` will cancel the "drop"
					 * - unmanaged drop targets can handle the "drop" how they want to
					 * We won't call `event.preventDefault()` in this call path */ if (!state.current.dropTargets.length) {
                    cancel();
                    return;
                }
                event.preventDefault();
                // applying the latest drop effect to the event
                $6868b9e56fe4f659$var$setDropEffectOnEvent({
                    event: event,
                    current: state.current.dropTargets
                });
                dispatch.drop({
                    current: state.current,
                    // When dropping something native, we need to extract the latest
                    // `.items` from the "drop" event as it is now accessible
                    updatedSourcePayload: dragType.type === 'external' ? dragType.getDropPayload(event) : null
                });
                finish();
            }
        },
        {
            // "dragend" fires when on the drag source (eg a draggable element)
            // when the drag is finished.
            // "dragend" will fire after "drop" (if there was a successful drop)
            // "dragend" does not fire if the draggable source has been removed during the drag
            // or for external drag sources (eg files)
            // This "dragend" listener will not fire if there was a successful drop
            // as we will have already removed the event listener
            type: 'dragend',
            listener (event) {
                // In firefox, the position of the "dragend" event can
                // be a bit different to the last "dragover" event.
                // Updating the input so we can get the best possible
                // information for the honey pot.
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $kb9dc.getInput)(event)
                };
                cancel();
            }
        },
        ...(0, $fURjR.getBindingsForBrokenDrags)({
            onDragEnd: cancel
        })
    ], // Once we have started a managed drag operation it is important that we see / own all drag events
    // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
    // all "drop" events in the bubble phase on the `document.body`.
    // This meant that we never saw the "drop" event.
    {
        capture: true
    });
    dispatch.start({
        nativeSetDragImage: $6868b9e56fe4f659$var$getNativeSetDragImage(event)
    });
}
function $6868b9e56fe4f659$var$setDropEffectOnEvent({ event: event, current: current }) {
    // setting the `dropEffect` to be the innerMost drop targets dropEffect
    const innerMost = current[0]?.dropEffect;
    if (innerMost != null && event.dataTransfer) event.dataTransfer.dropEffect = innerMost;
}
function $6868b9e56fe4f659$var$getStartLocation({ event: event, dragType: dragType, getDropTargetsOver: getDropTargetsOver }) {
    const input = (0, $kb9dc.getInput)(event);
    // When dragging from outside of the browser,
    // the drag is not being sourced from any local drop targets
    if (dragType.startedFrom === 'external') return {
        input: input,
        dropTargets: []
    };
    const dropTargets = getDropTargetsOver({
        input: input,
        source: dragType.payload,
        target: event.target,
        current: []
    });
    return {
        input: input,
        dropTargets: dropTargets
    };
}
const $6868b9e56fe4f659$export$3efdceeb8ca25c51 = {
    canStart: $6868b9e56fe4f659$var$canStart,
    start: $6868b9e56fe4f659$var$start
};

});
parcelRegister("coJJ5", function(module, exports) {

$parcel$export(module.exports, "isLeavingWindow", () => $f35fe00a678b780a$export$57d220c74e84a273);

var $enquP = parcelRequire("enquP");

var $Fx8Dp = parcelRequire("Fx8Dp");

var $jivNo = parcelRequire("jivNo");

var $ehWpG = parcelRequire("ehWpG");
function $f35fe00a678b780a$export$57d220c74e84a273({ dragLeave: dragLeave }) {
    const { type: type, relatedTarget: relatedTarget } = dragLeave;
    if (type !== 'dragleave') return false;
    if ((0, $Fx8Dp.isSafari)()) return (0, $jivNo.isLeavingWindowInSafari)({
        dragLeave: dragLeave
    });
    // Standard check: if going to `null` we are leaving the `window`
    if (relatedTarget == null) return true;
    /**
	 * 🦊 Exception: `iframe` in Firefox (`125.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `dragLeave.relatedTarget` is element _inside_ the child `iframe`
	 * (foreign element)
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
	 * (foreign element)
	 */ if ((0, $enquP.isFirefox)()) return (0, $ehWpG.isFromAnotherWindow)(relatedTarget);
    /**
	 * 🌏 Exception: `iframe` in Chrome (`124.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `dragLeave.relatedTarget` is `null` *(standard check)*
	 */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});
parcelRegister("enquP", function(module, exports) {

$parcel$export(module.exports, "isFirefox", () => $e614166849bdfbc2$export$b7d78993b74f766d);

var $KsGIL = parcelRequire("KsGIL");
const $e614166849bdfbc2$export$b7d78993b74f766d = (0, $KsGIL.once)(function isFirefox() {
    return navigator.userAgent.includes('Firefox');
});

});
parcelRegister("KsGIL", function(module, exports) {

$parcel$export(module.exports, "once", () => $60659947ef15ccf3$export$d2de3aaeafa91619);
/** Provide a function that you only ever want to be called a single time */ function $60659947ef15ccf3$export$d2de3aaeafa91619(fn) {
    let cache = null;
    return function wrapped(...args) {
        if (!cache) {
            const result = fn.apply(this, args);
            cache = {
                result: result
            };
        }
        return cache.result;
    };
}

});


parcelRegister("Fx8Dp", function(module, exports) {

$parcel$export(module.exports, "isSafari", () => $4c39b3d87a6f2982$export$95df08bae54cb4df);

var $KsGIL = parcelRequire("KsGIL");
const $4c39b3d87a6f2982$export$95df08bae54cb4df = (0, $KsGIL.once)(function isSafari() {
    const { userAgent: userAgent } = navigator;
    return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
});

});

parcelRegister("jivNo", function(module, exports) {

$parcel$export(module.exports, "isLeavingWindowInSafari", () => $988fa06fa869765d$export$f21837c338005454);

var $74BVL = parcelRequire("74BVL");

var $Fx8Dp = parcelRequire("Fx8Dp");
/* For "dragenter" events, the browser should set `relatedTarget` to the previous element.
 * For external drag operations, our first "dragenter" event should have a `event.relatedTarget` of `null`.
 *
 *  Unfortunately in Safari `event.relatedTarget` is *always* set to `null`
 *  Safari bug: https://bugs.webkit.org/show_bug.cgi?id=242627
 *  To work around this we count "dragenter" and "dragleave" events */ // Using symbols for event properties so we don't clash with
// anything on the `event` object
const $988fa06fa869765d$var$symbols = {
    isLeavingWindow: Symbol('leaving'),
    isEnteringWindow: Symbol('entering')
};
function $988fa06fa869765d$export$de68634bd94ed596({ dragEnter: dragEnter }) {
    if (!(0, $Fx8Dp.isSafari)()) return false;
    return dragEnter.hasOwnProperty($988fa06fa869765d$var$symbols.isEnteringWindow);
}
function $988fa06fa869765d$export$f21837c338005454({ dragLeave: dragLeave }) {
    if (!(0, $Fx8Dp.isSafari)()) return false;
    return dragLeave.hasOwnProperty($988fa06fa869765d$var$symbols.isLeavingWindow);
}
(function fixSafari() {
    // Don't do anything when server side rendering
    if (typeof window === 'undefined') return;
    if (!(0, $Fx8Dp.isSafari)()) return;
    function getInitialState() {
        return {
            enterCount: 0,
            isOverWindow: false
        };
    }
    let state = getInitialState();
    function resetState() {
        state = getInitialState();
    }
    // These event listeners are bound _forever_ and _never_ removed
    // We don't bother cleaning up these event listeners (for now)
    // as this workaround is only for Safari
    // This is how the event count works:
    //
    // lift (+1 enterCount)
    // - dragstart(draggable) [enterCount: 0]
    // - dragenter(draggable) [enterCount: 1]
    // leaving draggable (+0 enterCount)
    // - dragenter(document.body) [enterCount: 2]
    // - dragleave(draggable) [enterCount: 1]
    // leaving window (-1 enterCount)
    // - dragleave(document.body) [enterCount: 0] {leaving the window}
    // Things to note:
    // - dragenter and dragleave bubble
    // - the first dragenter when entering a window might not be on `window`
    //   - it could be on an element that is pressed up against the window
    //   - (so we cannot rely on `event.target` values)
    (0, $74BVL.bindAll)(window, [
        {
            type: 'dragstart',
            listener: ()=>{
                state.enterCount = 0;
                // drag start occurs in the source window
                state.isOverWindow = true;
            // When a drag first starts it will also trigger a "dragenter" on the draggable element
            }
        },
        {
            type: 'drop',
            listener: resetState
        },
        {
            type: 'dragend',
            listener: resetState
        },
        {
            type: 'dragenter',
            listener: (event)=>{
                if (!state.isOverWindow && state.enterCount === 0) // Patching the `event` object
                // The `event` object is shared with all event listeners for the event
                // @ts-expect-error: adding property to the event object
                event[$988fa06fa869765d$var$symbols.isEnteringWindow] = true;
                state.isOverWindow = true;
                state.enterCount++;
            }
        },
        {
            type: 'dragleave',
            listener: (event)=>{
                state.enterCount--;
                if (state.isOverWindow && state.enterCount === 0) {
                    // Patching the `event` object as it is shared with all event listeners
                    // The `event` object is shared with all event listeners for the event
                    // @ts-expect-error: adding property to the event object
                    event[$988fa06fa869765d$var$symbols.isLeavingWindow] = true;
                    state.isOverWindow = false;
                }
            }
        }
    ], // using `capture: true` so that adding event listeners
    // in bubble phase will have the correct symbols
    {
        capture: true
    });
})();

});

parcelRegister("ehWpG", function(module, exports) {

$parcel$export(module.exports, "isFromAnotherWindow", () => $395b6cf20e8aa0ab$export$e46810fef53b5b0e);
/**
 * Does the `EventTarget` look like a `Node` based on "duck typing".
 *
 * Helpful when the `Node` might be outside of the current document
 * so we cannot to an `target instanceof Node` check.
 */ function $395b6cf20e8aa0ab$var$isNodeLike(target) {
    return 'nodeName' in target;
}
function $395b6cf20e8aa0ab$export$e46810fef53b5b0e(eventTarget) {
    return $395b6cf20e8aa0ab$var$isNodeLike(eventTarget) && eventTarget.ownerDocument !== document;
}

});


parcelRegister("fURjR", function(module, exports) {

$parcel$export(module.exports, "getBindingsForBrokenDrags", () => $e1eef5448bb32238$export$ac5e5b0daf997b2);
function $e1eef5448bb32238$export$ac5e5b0daf997b2({ onDragEnd: onDragEnd }) {
    return [
        // ## Detecting drag ending for removed draggables
        //
        // If a draggable element is removed during a drag and the user drops:
        // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
        // 2. if not over a valid drop target (or cancelled): we get nothing
        // The "dragend" event will not fire on the source draggable if it has been
        // removed from the DOM.
        // So we need to figure out if a drag operation has finished by looking at other events
        // We can do this by looking at other events
        // ### First detection: "pointermove" events
        // 1. "pointermove" events cannot fire during a drag and drop operation
        // according to the spec. So if we get a "pointermove" it means that
        // the drag and drop operations has finished. So if we get a "pointermove"
        // we know that the drag is over
        // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
        // other pointer events. However, firefox will allow a few
        // pointer event to get through after a drag starts.
        // The most I've seen is 3
        {
            type: 'pointermove',
            listener: (()=>{
                let callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    onDragEnd();
                };
            })()
        },
        // ### Second detection: "pointerdown" events
        // If we receive this event then we know that a drag operation has finished
        // and potentially another one is about to start.
        // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
        {
            type: 'pointerdown',
            listener: onDragEnd
        }
    ];
}

});

parcelRegister("kb9dc", function(module, exports) {

$parcel$export(module.exports, "getInput", () => $661957bb1ab51692$export$7c112ceec8941e67);
function $661957bb1ab51692$export$7c112ceec8941e67(event) {
    return {
        altKey: event.altKey,
        button: event.button,
        buttons: event.buttons,
        ctrlKey: event.ctrlKey,
        metaKey: event.metaKey,
        shiftKey: event.shiftKey,
        clientX: event.clientX,
        clientY: event.clientY,
        pageX: event.pageX,
        pageY: event.pageY
    };
}

});

parcelRegister("9A5IM", function(module, exports) {

$parcel$export(module.exports, "makeDispatch", () => $6674e392a266d08a$export$9f13ecc44e83d682);

var $8yx6O = parcelRequire("8yx6O");
const $6674e392a266d08a$var$scheduleOnDrag = (0, $8yx6O.default)((fn)=>fn());
const $6674e392a266d08a$var$dragStart = (()=>{
    let scheduled = null;
    function schedule(fn) {
        const frameId = requestAnimationFrame(()=>{
            scheduled = null;
            fn();
        });
        scheduled = {
            frameId: frameId,
            fn: fn
        };
    }
    function flush() {
        if (scheduled) {
            cancelAnimationFrame(scheduled.frameId);
            scheduled.fn();
            scheduled = null;
        }
    }
    return {
        schedule: schedule,
        flush: flush
    };
})();
function $6674e392a266d08a$export$9f13ecc44e83d682({ source: source, initial: initial, dispatchEvent: dispatchEvent }) {
    let previous = {
        dropTargets: []
    };
    function safeDispatch(args) {
        dispatchEvent(args);
        previous = {
            dropTargets: args.payload.location.current.dropTargets
        };
    }
    const dispatch = {
        start ({ nativeSetDragImage: nativeSetDragImage }) {
            // Ensuring that both `onGenerateDragPreview` and `onDragStart` get the same location.
            // We do this so that `previous` is`[]` in `onDragStart` (which is logical)
            const location = {
                current: initial,
                previous: previous,
                initial: initial
            };
            // a `onGenerateDragPreview` does _not_ add another entry for `previous`
            // onDragPreview
            safeDispatch({
                eventName: 'onGenerateDragPreview',
                payload: {
                    source: source,
                    location: location,
                    nativeSetDragImage: nativeSetDragImage
                }
            });
            $6674e392a266d08a$var$dragStart.schedule(()=>{
                safeDispatch({
                    eventName: 'onDragStart',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        dragUpdate ({ current: current }) {
            $6674e392a266d08a$var$dragStart.flush();
            $6674e392a266d08a$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDropTargetChange',
                payload: {
                    source: source,
                    location: {
                        initial: initial,
                        previous: previous,
                        current: current
                    }
                }
            });
        },
        drag ({ current: current }) {
            $6674e392a266d08a$var$scheduleOnDrag(()=>{
                $6674e392a266d08a$var$dragStart.flush();
                const location = {
                    initial: initial,
                    previous: previous,
                    current: current
                };
                safeDispatch({
                    eventName: 'onDrag',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        drop ({ current: current, updatedSourcePayload: updatedSourcePayload }) {
            $6674e392a266d08a$var$dragStart.flush();
            $6674e392a266d08a$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDrop',
                payload: {
                    source: updatedSourcePayload ?? source,
                    location: {
                        current: current,
                        previous: previous,
                        initial: initial
                    }
                }
            });
        }
    };
    return dispatch;
}

});


parcelRegister("buJNg", function(module, exports) {

$parcel$export(module.exports, "register", () => $16255e18a8cdf5a6$export$6503ec6e8aabbaf);
const $16255e18a8cdf5a6$var$ledger = new Map();
function $16255e18a8cdf5a6$var$registerUsage({ typeKey: typeKey, mount: mount }) {
    const entry = $16255e18a8cdf5a6$var$ledger.get(typeKey);
    if (entry) {
        entry.usageCount++;
        return entry;
    }
    const initial = {
        typeKey: typeKey,
        unmount: mount(),
        usageCount: 1
    };
    $16255e18a8cdf5a6$var$ledger.set(typeKey, initial);
    return initial;
}
function $16255e18a8cdf5a6$export$6503ec6e8aabbaf(args) {
    const entry = $16255e18a8cdf5a6$var$registerUsage(args);
    return function unregister() {
        entry.usageCount--;
        if (entry.usageCount > 0) return;
        // Only a single usage left, remove it
        entry.unmount();
        $16255e18a8cdf5a6$var$ledger.delete(args.typeKey);
    };
}

});

parcelRegister("gItnR", function(module, exports) {

$parcel$export(module.exports, "makeDropTarget", () => $4df313649e179712$export$47d10e7bd9c81890);

var $jFl9L = parcelRequire("jFl9L");

var $ggbKc = parcelRequire("ggbKc");
function $4df313649e179712$var$copyReverse(array) {
    return array.slice(0).reverse();
}
function $4df313649e179712$export$47d10e7bd9c81890({ typeKey: typeKey, defaultDropEffect: defaultDropEffect }) {
    const registry = new WeakMap();
    const dropTargetDataAtt = `data-drop-target-for-${typeKey}`;
    const dropTargetSelector = `[${dropTargetDataAtt}]`;
    function addToRegistry(args) {
        registry.set(args.element, args);
        return ()=>registry.delete(args.element);
    }
    function dropTargetForConsumers(args) {
        return (0, $jFl9L.combine)((0, $ggbKc.addAttribute)(args.element, {
            attribute: dropTargetDataAtt,
            value: 'true'
        }), addToRegistry(args));
    }
    function getActualDropTargets({ source: source, target: target, input: input, result: result = [] }) {
        if (target == null) return result;
        if (!(target instanceof Element)) {
            // For "text-selection" drags, the original `target`
            // is not an `Element`, so we need to start looking from
            // the parent element
            if (target instanceof Node) return getActualDropTargets({
                source: source,
                target: target.parentElement,
                input: input,
                result: result
            });
            // not sure what we are working with,
            // so we can exit.
            return result;
        }
        const closest = target.closest(dropTargetSelector);
        // Cannot find anything else
        if (closest == null) return result;
        const args = registry.get(closest);
        // error: something had a dropTargetSelector but we could not
        // find a match. For now, failing silently
        if (args == null) return result;
        const feedback = {
            input: input,
            source: source,
            element: args.element
        };
        // if dropping is not allowed, skip this drop target
        // and continue looking up the DOM tree
        if (args.canDrop && !args.canDrop(feedback)) return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            result: result
        });
        // calculate our new record
        const data = args.getData?.(feedback) ?? {};
        const dropEffect = args.getDropEffect?.(feedback) ?? defaultDropEffect;
        const record = {
            data: data,
            element: args.element,
            dropEffect: dropEffect,
            // we are collecting _actual_ drop targets, so these are
            // being applied _not_ due to stickiness
            isActiveDueToStickiness: false
        };
        return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            // Using bubble ordering. Same ordering as `event.getPath()`
            result: [
                ...result,
                record
            ]
        });
    }
    function notifyCurrent({ eventName: eventName, payload: payload }) {
        for (const record of payload.location.current.dropTargets){
            const entry = registry.get(record.element);
            const args = {
                ...payload,
                self: record
            };
            entry?.[eventName]?.(// I cannot seem to get the types right here.
            // TS doesn't seem to like that one event can need `nativeSetDragImage`
            // @ts-expect-error
            args);
        }
    }
    const actions = {
        onGenerateDragPreview: notifyCurrent,
        onDrag: notifyCurrent,
        onDragStart: notifyCurrent,
        onDrop: notifyCurrent,
        onDropTargetChange: ({ payload: payload })=>{
            const isCurrent = new Set(payload.location.current.dropTargets.map((record)=>record.element));
            const visited = new Set();
            for (const record of payload.location.previous.dropTargets){
                visited.add(record.element);
                const entry = registry.get(record.element);
                const isOver = isCurrent.has(record.element);
                const args = {
                    ...payload,
                    self: record
                };
                entry?.onDropTargetChange?.(args);
                // if we cannot find the drop target in the current array, then it has been left
                if (!isOver) entry?.onDragLeave?.(args);
            }
            for (const record of payload.location.current.dropTargets){
                // already published an update to this drop target
                if (visited.has(record.element)) continue;
                // at this point we have a new drop target that is being entered into
                const args = {
                    ...payload,
                    self: record
                };
                const entry = registry.get(record.element);
                entry?.onDropTargetChange?.(args);
                entry?.onDragEnter?.(args);
            }
        }
    };
    function dispatchEvent(args) {
        actions[args.eventName](args);
    }
    function getIsOver({ source: source, target: target, input: input, current: current }) {
        const actual = getActualDropTargets({
            source: source,
            target: target,
            input: input
        });
        // stickiness is only relevant when we have less
        // drop targets than we did before
        if (actual.length >= current.length) return actual;
        // less 'actual' drop targets than before,
        // we need to see if 'stickiness' applies
        // An old drop target will continue to be dropped on if:
        // 1. it has the same parent
        // 2. nothing exists in it's previous index
        const lastCaptureOrdered = $4df313649e179712$var$copyReverse(current);
        const actualCaptureOrdered = $4df313649e179712$var$copyReverse(actual);
        const resultCaptureOrdered = [];
        for(let index = 0; index < lastCaptureOrdered.length; index++){
            const last = lastCaptureOrdered[index];
            const fresh = actualCaptureOrdered[index];
            // if a record is in the new index -> use that
            // it will have the latest data + dropEffect
            if (fresh != null) {
                resultCaptureOrdered.push(fresh);
                continue;
            }
            // At this point we have no drop target in the old spot
            // Check to see if we can use a previous sticky drop target
            // The "parent" is the one inside of `resultCaptureOrdered`
            // (the parent might be a drop target that was sticky)
            const parent = resultCaptureOrdered[index - 1];
            const lastParent = lastCaptureOrdered[index - 1];
            // Stickiness is based on parent relationships, so if the parent relationship has change
            // then we can stop our search
            if (parent?.element !== lastParent?.element) break;
            // We need to check whether the old drop target can still be dropped on
            const argsForLast = registry.get(last.element);
            // We cannot drop on a drop target that is no longer mounted
            if (!argsForLast) break;
            const feedback = {
                input: input,
                source: source,
                element: argsForLast.element
            };
            // We cannot drop on a drop target that no longer allows being dropped on
            if (argsForLast.canDrop && !argsForLast.canDrop(feedback)) break;
            // We cannot drop on a drop target that is no longer sticky
            if (!argsForLast.getIsSticky?.(feedback)) break;
            // Note: intentionally not recollecting `getData()` or `getDropEffect()`
            // Previous values for `data` and `dropEffect` will be borrowed
            // This is to prevent things like the 'closest edge' changing when
            // no longer over a drop target.
            // We could change our mind on this behaviour in the future
            resultCaptureOrdered.push({
                ...last,
                // making it clear to consumers this drop target is active due to stickiness
                isActiveDueToStickiness: true
            });
        }
        // return bubble ordered result
        return $4df313649e179712$var$copyReverse(resultCaptureOrdered);
    }
    return {
        dropTargetForConsumers: dropTargetForConsumers,
        getIsOver: getIsOver,
        dispatchEvent: dispatchEvent
    };
}

});
parcelRegister("jFl9L", function(module, exports) {

$parcel$export(module.exports, "combine", () => $e825059ee70ef631$export$1be1fc439b849fdf);
function $e825059ee70ef631$export$1be1fc439b849fdf(...fns) {
    return function cleanup() {
        fns.forEach((fn)=>fn());
    };
}

});

parcelRegister("ggbKc", function(module, exports) {

$parcel$export(module.exports, "addAttribute", () => $df9d12eec6804e85$export$5dcb5c23b6ba980a);
function $df9d12eec6804e85$export$5dcb5c23b6ba980a(element, { attribute: attribute, value: value }) {
    element.setAttribute(attribute, value);
    return ()=>element.removeAttribute(attribute);
}

});


parcelRegister("j14G1", function(module, exports) {

$parcel$export(module.exports, "makeMonitor", () => $aec9bd094a175c02$export$5dd4ed888d5b12ca);
function $aec9bd094a175c02$export$5dd4ed888d5b12ca() {
    const registry = new Set();
    let dragging = null;
    function tryAddToActive(monitor) {
        if (!dragging) return;
        // Monitor is allowed to monitor events if:
        // 1. It has no `canMonitor` function (default is that a monitor can listen to everything)
        // 2. `canMonitor` returns true
        if (!monitor.canMonitor || monitor.canMonitor(dragging.canMonitorArgs)) dragging.active.add(monitor);
    }
    function monitorForConsumers(args) {
        // We are giving each `args` a new reference so that you
        // can create multiple monitors with the same `args`.
        const entry = {
            ...args
        };
        registry.add(entry);
        // if there is an active drag we need to see if this new monitor is relevant
        tryAddToActive(entry);
        return function cleanup() {
            registry.delete(entry);
            // We need to stop publishing events during a drag to this monitor!
            if (dragging) dragging.active.delete(entry);
        };
    }
    function dispatchEvent({ eventName: eventName, payload: payload }) {
        if (eventName === 'onGenerateDragPreview') {
            dragging = {
                canMonitorArgs: {
                    initial: payload.location.initial,
                    source: payload.source
                },
                active: new Set()
            };
            for (const monitor of registry)tryAddToActive(monitor);
        }
        // This should never happen.
        if (!dragging) return;
        // Creating an array from the set _before_ iterating
        // This is so that monitors added during the current event will not be called.
        // This behaviour matches native EventTargets where an event listener
        // cannot add another event listener during an active event to the same
        // event target in the same event (for us we have a single global event target)
        const active = Array.from(dragging.active);
        for (const monitor of active)// A monitor can be removed by another monitor during an event.
        // We need to check that the monitor is still registered before calling it
        if (dragging.active.has(monitor)) // @ts-expect-error: I cannot get this type working!
        monitor[eventName]?.(payload);
        if (eventName === 'onDrop') {
            dragging.active.clear();
            dragging = null;
        }
    }
    return {
        dispatchEvent: dispatchEvent,
        monitorForConsumers: monitorForConsumers
    };
}

});


parcelRegister("eDT75", function(module, exports) {

$parcel$export(module.exports, "isAndroid", () => $773300f3a724036a$export$a11b0059900ceec8);
$parcel$export(module.exports, "androidFallbackText", () => $773300f3a724036a$export$aceb3ed8b7f7bd2c);

var $KsGIL = parcelRequire("KsGIL");
const $773300f3a724036a$export$a11b0059900ceec8 = (0, $KsGIL.once)(function isAndroid() {
    return navigator.userAgent.toLocaleLowerCase().includes('android');
});
const $773300f3a724036a$export$aceb3ed8b7f7bd2c = 'pdnd:android-fallback';

});

// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $559dbbdafee2f66d$export$fd3d00026297c0ad = 'text/plain';

// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $63b7ad043dd75799$export$bc594fb6cfea5e58 = 'text/uri-list';

/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */ const $4df75fb0870d0fce$export$c9c4cc54e73b125d = 'application/vnd.pdnd';



parcelRegister("cbxSN", function(module, exports) {

$parcel$export(module.exports, "disableNativeDragPreview", () => (parcelRequire("iYy22")).disableNativeDragPreview);

var $iYy22 = parcelRequire("iYy22");

});
parcelRegister("iYy22", function(module, exports) {

$parcel$export(module.exports, "disableNativeDragPreview", () => $f96526f07b5b7d85$export$c588cb30ff3b876e);
// In order to disable the native drag preview you can
// use `event.dataTransfer.setDragImage()` to set a small
// invisible image as the drag preview.
// There are alternative techniques,
// (eg setting opacity to in onGenerateDragPreview and then 1 in onDragStart)
// but the technique in this file worked best across browsers and platforms
// Here we are preloading the image so that it is ready for the first drag.
// Even though the image is base64 encoded, the browser queues an async task
// to decode the image. The image needs to be decoded before it can be used
const $f96526f07b5b7d85$var$tinyTransparentImage = (()=>{
    // SSR safe
    if (typeof window === 'undefined') return null;
    // Image generated by: https://png-pixel.com/
    // It is a 1x1 transparent gif
    // It is the smallest possible transparent image we could find that works on all platforms
    // Note: using an encoded SVG would be nicer code, but it doesn't work on iOS
    const img = new Image();
    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
    return img;
})();
function $f96526f07b5b7d85$export$c588cb30ff3b876e({ nativeSetDragImage: nativeSetDragImage }) {
    if (nativeSetDragImage && $f96526f07b5b7d85$var$tinyTransparentImage) nativeSetDragImage($f96526f07b5b7d85$var$tinyTransparentImage, 0, 0);
}

});


parcelRegister("jTs7k", function(module, exports) {

$parcel$export(module.exports, "preventUnhandled", () => (parcelRequire("1xLt0")).preventUnhandled);

var $1xLt0 = parcelRequire("1xLt0");

});
parcelRegister("1xLt0", function(module, exports) {

$parcel$export(module.exports, "preventUnhandled", () => $6e73835b1fb5a057$export$453c0582481cc59d);

var $74BVL = parcelRequire("74BVL");

var $fURjR = parcelRequire("fURjR");
function $6e73835b1fb5a057$var$acceptDrop(event) {
    // if the event is already prevented the event we don't need to do anything
    if (event.defaultPrevented) return;
    // Using "move" as the drop effect as that uses the standard
    // cursor. Doing this so the user doesn't think they are dropping
    // on the page
    // Note: using "none" will not allow a "drop" to occur, so we are using "move"
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    // cancel the default browser behaviour
    // doing this will tell the browser that we have handled the drop
    event.preventDefault();
}
let $6e73835b1fb5a057$var$unbindEvents = null;
/**
 * Block drag operations outside of `@atlaskit/pragmatic-drag-and-drop`
 */ function $6e73835b1fb5a057$var$start() {
    $6e73835b1fb5a057$var$cleanup();
    $6e73835b1fb5a057$var$unbindEvents = (0, $74BVL.bindAll)(window, [
        {
            type: 'dragover',
            listener: $6e73835b1fb5a057$var$acceptDrop
        },
        {
            type: 'dragenter',
            listener: $6e73835b1fb5a057$var$acceptDrop
        },
        {
            type: 'drop',
            listener (event) {
                // our lifecycle manager already prevents events, but just being super safe
                event.preventDefault();
                // not setting dropEffect, as `drop.dropEffect` has already been published to the user
                // (lifecycle-manager binds events in the capture phase)
                // we don't need to wait for "dragend", and "dragend" might not even happen,
                // such as when the draggable has been removed during a drag.
                $6e73835b1fb5a057$var$cleanup();
            }
        },
        {
            type: 'dragend',
            listener: $6e73835b1fb5a057$var$cleanup
        },
        ...(0, $fURjR.getBindingsForBrokenDrags)({
            onDragEnd: $6e73835b1fb5a057$var$cleanup
        })
    ], // being clear that these are added in the bubble phase
    {
        capture: false
    });
}
function $6e73835b1fb5a057$var$cleanup() {
    $6e73835b1fb5a057$var$unbindEvents?.();
    $6e73835b1fb5a057$var$unbindEvents = null;
}
/**
 * TODO: for next major, we could look at do the following:
 *
 * ```diff
 * - preventUnhandled.start();
 * - preventUnhandled.stop();
 * + const stop = preventUnhandled();
 * ```
 */ function $6e73835b1fb5a057$var$stop() {
    /**
	 * if `stop()` is called in a `"drop"` event, then `event.preventDefault()` won't be called.
	 * Our `"drop"` listener calls `event.preventDefault()` for handled drop events
	 * ("drop" events caused by dropping over a drop target)
	 * `preventUnhandled()` causes every element to become a drop target (according to the browser)
	 *
	 * To opt out of the default behaviour for a `"drop"` event, we need to make sure
	 * that we cancel it.
	 *
	 * The `"drop"` event listener in core is in the `capture` phase, so people calling
	 * `preventUnhandled.stop()` in `onDrop()` will remove the `"drop"` event listener in this
	 * file before it has the chance to cancel the event.
	 *
	 * Being sneaky and using the `window.event` global to sniff out the current event
	 */ if (window.event?.type === 'drop') window.event?.preventDefault();
    $6e73835b1fb5a057$var$cleanup();
}
const $6e73835b1fb5a057$export$453c0582481cc59d = {
    start: $6e73835b1fb5a057$var$start,
    stop: $6e73835b1fb5a057$var$stop
};

});


parcelRegister("exYPH", function(module, exports) {

$parcel$export(module.exports, "useTextDirection", () => $4d81149f9603ea38$export$cf24a79f32f45545);

var $eUqFw = parcelRequire("eUqFw");
const $4d81149f9603ea38$export$cf24a79f32f45545 = (element)=>(0, $eUqFw.useMemo)(()=>{
        const { direction: direction } = window.getComputedStyle(element);
        return direction === 'rtl' ? 'rtl' : 'ltr';
    }, [
        element
    ]);

});

parcelRegister("gahth", function(module, exports) {

$parcel$export(module.exports, "getWidthFromDragLocation", () => $32dabdf2c83724a8$export$e360234971cb95b8);
$parcel$export(module.exports, "getComputedWidth", () => $32dabdf2c83724a8$export$4b8bb339e24d513f);
const $32dabdf2c83724a8$export$e360234971cb95b8 = ({ initialWidth: initialWidth, location: location, direction: direction })=>{
    const diffX = location.current.input.clientX - location.initial.input.clientX;
    return direction === 'rtl' ? initialWidth - diffX : initialWidth + diffX;
};
const $32dabdf2c83724a8$export$4b8bb339e24d513f = (element)=>{
    const { width: width } = window.getComputedStyle(element);
    return parseInt(width);
};

});




const $75b7df28d47cff7a$export$3e8fc5ba7287b4a8 = 'navigation_next_ui_state';
const $75b7df28d47cff7a$export$c63f561360bafed1 = 'navigation-next.providers.ui-state-cache-provider';

parcelRegister("1NIhY", function(module, exports) {

$parcel$export(module.exports, "navigationUiStateResource", () => $f81bf6691f07ea3e$export$14c178691841b423);
// eslint-disable-next-line jira/import-whitelist

var $5iWql = parcelRequire("5iWql");

var $3HCkE = parcelRequire("3HCkE");

var $jCGD5 = parcelRequire("jCGD5");

const $f81bf6691f07ea3e$var$getNavigationUiStateMemoized = (0, $5iWql.default)((baseUrl, atlassianAccountId)=>(0, $jCGD5.getNavigationUiState)({
        tenantContext: {
            baseUrl: baseUrl,
            atlassianAccountId: atlassianAccountId
        }
    }));
const $f81bf6691f07ea3e$export$14c178691841b423 = (0, $3HCkE.createResource)({
    type: 'RESOURCE_TYPE_NAVIGATION_UI',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: { baseUrl: baseUrl, atlassianAccountId: atlassianAccountId } })=>$f81bf6691f07ea3e$var$getNavigationUiStateMemoized(baseUrl, atlassianAccountId),
    maxAge: Infinity
});

});
parcelRegister("jCGD5", function(module, exports) {

$parcel$export(module.exports, "getNavigationUiState", () => $db77001cbd8f906b$export$29999268b070c9bd);

var $48bs8 = parcelRequire("48bs8");


var $lTttU = parcelRequire("lTttU");
const $db77001cbd8f906b$export$29999268b070c9bd = async ({ tenantContext: tenantContext })=>{
    const { atlassianAccountId: accountId, baseUrl: baseUrl } = tenantContext;
    let uiState = await (0, $lTttU.queryLocalStorage)();
    if (uiState || !accountId) return uiState;
    try {
        uiState = await (0, $48bs8.getUserProperty)(baseUrl, accountId, (0, $75b7df28d47cff7a$export$3e8fc5ba7287b4a8));
        // @ts-expect-error - TS2345 - Argument of type 'UIControllerShape | undefined' is not assignable to parameter of type 'UIControllerShape'.
        (0, $lTttU.updateLocalStorageData)(uiState);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // Don't log the error on purpose. This is very frequent for some reason :(
    }
    return uiState;
};

});
parcelRegister("lTttU", function(module, exports) {

$parcel$export(module.exports, "queryLocalStorage", () => $4239519c11764e08$export$e192dcb908272d5);
$parcel$export(module.exports, "updateLocalStorageData", () => $4239519c11764e08$export$ec13c725e067146a);

var $jG2Eu = parcelRequire("jG2Eu");

var $gUUjF = parcelRequire("gUUjF");

const $4239519c11764e08$export$e7db3fa51c63bc5c = ()=>{
    if (typeof window !== 'undefined' && typeof window.localStorage !== 'undefined') return window.localStorage;
    return {
        setItem: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        getItem: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    };
};
const $4239519c11764e08$var$queryLocalStorageSync = ()=>{
    const localStorage = $4239519c11764e08$export$e7db3fa51c63bc5c();
    const item = localStorage.getItem((0, $75b7df28d47cff7a$export$3e8fc5ba7287b4a8));
    if (!false && item) try {
        return JSON.parse(item);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData((0, $75b7df28d47cff7a$export$c63f561360bafed1), 'Fail to parse sync local storage data', e);
    }
};
const $4239519c11764e08$export$e192dcb908272d5 = ()=>new Promise((resolve)=>{
        const item = $4239519c11764e08$var$queryLocalStorageSync();
        resolve(item);
    });
const $4239519c11764e08$export$ec13c725e067146a = (data)=>{
    const localStorage = $4239519c11764e08$export$e7db3fa51c63bc5c();
    localStorage.setItem((0, $75b7df28d47cff7a$export$3e8fc5ba7287b4a8), JSON.stringify(data));
};

});



parcelRegister("dxcfv", function(module, exports) {

$parcel$export(module.exports, "useAccountId", () => $45cd5aaa8359ff91$export$e72033e0f5baa3e);

var $gd0Sp = parcelRequire("gd0Sp");
const $45cd5aaa8359ff91$export$e72033e0f5baa3e = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.atlassianAccountId || null;
};

});


parcelRegister("dWu0t", function(module, exports) {

$parcel$export(module.exports, "useHorizontalNavComponent", () => $c641efd495101387$export$205771a0e64e4c7c);

var $b3nmi = parcelRequire("b3nmi");

var $7ZZxN = parcelRequire("7ZZxN");

var $1ybV0 = parcelRequire("1ybV0");

var $4u3Wx = parcelRequire("4u3Wx");

var $10fdS = parcelRequire("10fdS");

var $bNe1g = parcelRequire("bNe1g");

var $bEe6y = parcelRequire("bEe6y");

const $c641efd495101387$export$205771a0e64e4c7c = ()=>{
    const route = (0, $10fdS.useCurrentRoute)();
    const { data: projectData } = (0, $bNe1g.useProjectContext)();
    const [isChromeless] = (0, $4u3Wx.useIsChromeless)();
    if (isChromeless) return null;
    if (route.navigation?.horizontal == null) return null;
    if (route.navigation.horizontal === (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)) switch(projectData?.projectType){
        case 0, $7ZZxN.CORE_PROJECT:
            return 0, $b3nmi.AsyncHorizontalProjectNav;
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            if ((0, $1ybV0.ff)('sea-2744-jsw-tabs-nav')) return 0, $bEe6y.AsyncHorizontalSoftwareProjectNav;
            return null;
        default:
            return null;
    }
    if ('horizontalFeatureFlag' in route.navigation) switch(route.navigation.horizontalFeatureFlag){
        // Society: "Use a constant!"
        // Me: no! I was told to inline my feature flags!
        case 'sea-2744-jsw-tabs-nav':
            return (0, $1ybV0.ff)('sea-2744-jsw-tabs-nav') ? route.navigation.horizontal : null;
        case 'jsm-kb-nav-refresh-changes-enabled':
            return (0, $1ybV0.ff)('jsm-kb-nav-refresh-changes-enabled') ? route.navigation.horizontal : null;
        case 'jet-plans-nav-refresh_f9025':
            return (0, $1ybV0.ff)('jet-plans-nav-refresh_f9025') ? route.navigation.horizontal : null; // Society: "Use a constant!"
        default:
            {
                // a little bit of magic to ensure that we handle all feature flags defined in
                // HorizontalFeatureFlags - if the switch statement is missing a case, this line
                // will cause a compile error.
                const exhaustiveCheck = route.navigation.horizontalFeatureFlag;
                return exhaustiveCheck;
            }
    }
    return route.navigation.horizontal;
};

});
parcelRegister("b3nmi", function(module, exports) {

$parcel$export(module.exports, "AsyncHorizontalProjectNav", () => $9702ab3631bfd06d$export$862dd1c0126bb181);
$parcel$export(module.exports, "AsyncHorizontalOverviewNav", () => $9702ab3631bfd06d$export$beabdf5c49f01377);
/* eslint-disable jira/import/webpack-magic-comment-entries */ 
var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $9702ab3631bfd06d$var$LazyHorizontalProjectNav = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("fC5IJ")).then(({ ProjectNavigation: ProjectNavigation })=>ProjectNavigation), {
    moduleId: "./src/packages/business/navigation/horizontal-nav/src/ui/index.tsx"
});
const $9702ab3631bfd06d$export$862dd1c0126bb181 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "horizontal-project-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9702ab3631bfd06d$var$LazyHorizontalProjectNav, null));

const $9702ab3631bfd06d$var$LazyHorizontalOverviewNav = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("fC5IJ")).then(({ OverviewNavigation: OverviewNavigation })=>OverviewNavigation), {
    moduleId: "./src/packages/business/navigation/horizontal-nav/src/ui/index.tsx"
});
const $9702ab3631bfd06d$export$beabdf5c49f01377 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "horizontal-overview-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9702ab3631bfd06d$var$LazyHorizontalOverviewNav, null));

});
parcelRegister("fC5IJ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('2hmUs'),
            load('bCeK4'),
            load('1A5ej')
        ]);
        const value = parcelRequire('9nHXa');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("2hmUs"),
        load("bCeK4"),
        load("1A5ej")
    ]).then(()=>parcelRequire('9nHXa'));
}

});
parcelRegister("chRvw", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    const retry_state = {};
    module.exports = async function(id) {
        if (!globalThis.navigator.onLine) await new Promise((res)=>{
            const callback = ()=>(globalThis.removeEventListener('online', callback), res());
            globalThis.addEventListener('online', callback);
        });
        let bundle_src = (parcelRequire("bjqNS")).resolve(id);
        let src = bundle_src;
        retry_state[bundle_src] = retry_state[bundle_src] || {
            should_retry: false,
            param: undefined
        };
        if (retry_state[bundle_src].should_retry) retry_state[bundle_src].param = Date.now();
        if (retry_state[bundle_src].param) src = src + "?retry=" + retry_state[bundle_src].param;
        try {
            retry_state[bundle_src].should_retry = false;
            return await import(src);
        } catch (error) {
            retry_state[bundle_src].should_retry = true;
            throw error;
        }
    };
} else {
    "use strict";
    function load(id) {
        // eslint-disable-next-line no-undef
        return import((parcelRequire("bjqNS")).resolve(id));
    }
    module.exports = load;
}

});



parcelRegister("4u3Wx", function(module, exports) {

$parcel$export(module.exports, "useIsChromeless", () => $958ecff90d5df897$export$c88b74884f5222ba);

var $ggKAj = parcelRequire("ggKAj");

var $53ucm = parcelRequire("53ucm");
const $958ecff90d5df897$export$c88b74884f5222ba = (0, $ggKAj.createHook)((0, $53ucm.layoutStore), {
    selector: (state)=>state.isChromeless
});

});

parcelRegister("10fdS", function(module, exports) {

$parcel$export(module.exports, "useCurrentRoute", () => $ddc2f4c28203b504$export$c4b7ea2942f2d0e);
$parcel$export(module.exports, "useRouteByName", () => $ddc2f4c28203b504$export$d69a946e2d0a1c12);
$parcel$export(module.exports, "usePreviousRouterState", () => $ddc2f4c28203b504$export$1e5fb68306bd0b92);

var $kJlBc = parcelRequire("kJlBc");

var $keguF = parcelRequire("keguF");
const $ddc2f4c28203b504$export$c4b7ea2942f2d0e = (0, $kJlBc.createRouterSelector)((state)=>state.route);
const $ddc2f4c28203b504$export$d69a946e2d0a1c12 = (0, $kJlBc.createRouterSelector)((state, routeName)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    state.routes.find(({ name: name })=>name === routeName) ?? null);
const $ddc2f4c28203b504$export$94b319d3d90420ae = ({ name: name, path: path, query: query, exact: exact })=>({
        name: name,
        path: path,
        query: query,
        exact: exact
    });
const $ddc2f4c28203b504$export$1e5fb68306bd0b92 = ()=>{
    // Force updates whenever the current route changes
    (0, $kJlBc.useRouter)();
    return (0, $keguF.getPreviousRouterState)();
};

});

parcelRegister("bNe1g", function(module, exports) {

$parcel$export(module.exports, "useProjectContext", () => $a10c8c1f49371370$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useIsSimplifiedProject", () => $a10c8c1f49371370$export$524ef4f6102ed540);
$parcel$export(module.exports, "ProjectContextProvider", () => $a10c8c1f49371370$export$a85f6b5857d2176);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $OUdnA = parcelRequire("OUdnA");

var $dUsMe = parcelRequire("dUsMe");
var $iZJHG = parcelRequire("iZJHG");

var $3HCkE = parcelRequire("3HCkE");

var $ixwgj = parcelRequire("ixwgj");
const $a10c8c1f49371370$var$useProjectContextNew = (customContext)=>{
    // TODO remove useInitFetchResource() wrapper on 'jira.call-useinitfetchresource-from-useresourcewithcustomroutercontext_hiyz0' FF cleanup
    const { data: data, error: error, loading: loading, update: update, key: key } = (0, $dUsMe.useInitFetchResource)((0, $iZJHG.useResourceWithCustomRouterContext)((0, $ixwgj.projectContextResourceWithCache), customContext), !customContext || (0, $1ybV0.ff)('jira.call-useinitfetchresource-from-useresourcewithcustomroutercontext_hiyz0'));
    const updateCache = (0, $eUqFw.useCallback)((d)=>update(()=>d), [
        update
    ]);
    return {
        data: data,
        error: error,
        loading: loading,
        updateCache: updateCache,
        key: key
    };
};
const $a10c8c1f49371370$var$useProjectContextOld = (_)=>{
    const { data: data, error: error, loading: loading, update: update, key: key } = (0, $3HCkE.useResource)((0, $ixwgj.projectContextResourceWithCache));
    const updateCache = (0, $eUqFw.useCallback)((d)=>update(()=>d), [
        update
    ]);
    return {
        data: data,
        error: error,
        loading: loading,
        updateCache: updateCache,
        key: key
    };
};
const $a10c8c1f49371370$export$8f31c2503e1efa93 = (0, $OUdnA.functionWithFF)('passing-projectid-to-useisgettingstartedpageenabled', $a10c8c1f49371370$var$useProjectContextNew, $a10c8c1f49371370$var$useProjectContextOld);
const $a10c8c1f49371370$export$524ef4f6102ed540 = ()=>{
    const { data: data } = $a10c8c1f49371370$export$8f31c2503e1efa93();
    return data?.simplified || false;
};
const $a10c8c1f49371370$export$a85f6b5857d2176 = ({ children: children })=>{
    const projectContext = $a10c8c1f49371370$export$8f31c2503e1efa93();
    return children(projectContext);
};

});
parcelRegister("OUdnA", function(module, exports) {

$parcel$export(module.exports, "functionWithFF", () => $4f946782842d29a3$export$3b8cbae22108d228);

var $1ybV0 = parcelRequire("1ybV0");

var $8LJqN = parcelRequire("8LJqN");
const $4f946782842d29a3$export$3b8cbae22108d228 = (featureFlagName, functionTrue, functionFalse)=>(0, $8LJqN.functionWithCondition)(()=>(0, $1ybV0.ff)(featureFlagName), functionTrue, functionFalse);

});
parcelRegister("8LJqN", function(module, exports) {

$parcel$export(module.exports, "functionWithCondition", () => $96fc75653c9b207d$export$af3c0e82a18fc057);
/**
 * Returns one of functions depending on a boolean condition.
 * Both functions should have the same signature.
 * @see {@link functionUnionWithCondition} for functions with different return types
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $96fc75653c9b207d$export$af3c0e82a18fc057(condition, functionTrue, functionFalse) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const fnWithCondition = (...args)=>condition() ? functionTrue(...args) : functionFalse(...args);
    // Improvement: set name on a function. Requires external helper, not required for production
    return fnWithCondition;
}
function $96fc75653c9b207d$export$c41c28c1d883fcd5(condition, functionTrue, functionFalse) {
    // @ts-expect-error TS2345: Argument of type '(...args: C) => R2' is not assignable to parameter of type '(...args: C) => R1'.
    return $96fc75653c9b207d$export$af3c0e82a18fc057(condition, functionTrue, functionFalse);
}

});


parcelRegister("dUsMe", function(module, exports) {

$parcel$export(module.exports, "useInitFetchResource", () => $e60431eaa4374b0b$export$5b98692301d8680);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");
const $e60431eaa4374b0b$export$5b98692301d8680 = (resource, skipInitFetch = false)=>{
    const { data: data, loading: loading, error: error, refresh: refresh, ...rest } = resource;
    (0, $eUqFw.useEffect)(()=>{
        // skip init fetch resource when ff is off
        if (!(0, $1ybV0.ff)('fission-nav4-fetch-from-router_ma0x8') || skipInitFetch) return;
        if (!data && !loading && !error && refresh) refresh();
    // we only need this to happen only once at initial time. In addition, some resources return `data` = null when user does not have permissions etc., which makes all `data`, `loading` and `error` have falsy values.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        data: data,
        loading: loading,
        error: error,
        refresh: refresh,
        ...rest
    };
};

});

parcelRegister("iZJHG", function(module, exports) {

$parcel$export(module.exports, "useResourceWithCustomRouterContext", () => $8cce526bdc89f636$export$61dad767cf446185);

var $1ybV0 = parcelRequire("1ybV0");

var $kJlBc = parcelRequire("kJlBc");
var $3HCkE = parcelRequire("3HCkE");

var $dUsMe = parcelRequire("dUsMe");
/**
 * DUMMY_ROUTE needs to be used by default, because `route` must not be undefined, it is required/used internally by RRR, e.g. in findRouterContext() on createRouterContext() call.
 * If `route` is undefined, those will throw runtime exceptions.
 * `project-sidebar-navigation-resource/software-cmp-nav-synchronizer/index.tsx` uses dummy route as well.
 *
 * Jfyi, createProjectRouteRouterContext() function in JSW uses dummy route, with :projectKey in its path (that resource fetch function uses)
 */ const $8cce526bdc89f636$var$DUMMY_ROUTE = {
    name: 'DUMMY_ROUTE_NAME',
    path: '/projects/:projectKey/dummyroute'
};
const $8cce526bdc89f636$export$61dad767cf446185 = (resource, customRouterContext)=>{
    let useResourceArgCustomContext;
    if (customRouterContext) {
        // NOTE: `route` must include /.../:paramKey/... in its url for all `matchParams` passed to the `createRouterContext`, otherwise they will be ignored. createRouterContext will throw an error if route is undefined: `route.path` is used in the library code at least.
        const { route: route = $8cce526bdc89f636$var$DUMMY_ROUTE, matchParams: matchParams } = customRouterContext;
        if (matchParams && Object.keys(matchParams).length > 0) useResourceArgCustomContext = {
            routerContext: (0, $kJlBc.createRouterContext)(route, {
                params: matchParams
            })
        };
    }
    const resourceResponse = (0, $3HCkE.useResource)(resource, useResourceArgCustomContext);
    // we must call "fetch data" / refresh() manually, because react-resource-router will not fetch resources which are not defined in the current route's required resources.
    (0, $dUsMe.useInitFetchResource)(resourceResponse, !customRouterContext || !(0, $1ybV0.ff)('jira.call-useinitfetchresource-from-useresourcewithcustomroutercontext_hiyz0'));
    return resourceResponse;
};

});

parcelRegister("ixwgj", function(module, exports) {

$parcel$export(module.exports, "projectContextResource", () => $97b06b2828b1be93$export$27ad0d75c619be68);
$parcel$export(module.exports, "projectContextResourceWithCache", () => $97b06b2828b1be93$export$d75816e37af81473);

var $3HCkE = parcelRequire("3HCkE");

var $9zYls = parcelRequire("9zYls");


const $97b06b2828b1be93$var$getDataLoader = ()=>(parcelRequire("ajizA"));
const $97b06b2828b1be93$export$27ad0d75c619be68 = (0, $3HCkE.createResource)({
    type: (0, $e9754370217fd66e$export$80a60a092d9ab81),
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        return projectKey || projectId;
    },
    getDataLoader: $97b06b2828b1be93$var$getDataLoader,
    maxAge: 1800000
});
const $97b06b2828b1be93$export$d75816e37af81473 = $97b06b2828b1be93$export$27ad0d75c619be68;

});
parcelRegister("9zYls", function(module, exports) {

$parcel$export(module.exports, "getProjectKeyId", () => $5d8459da4a60e5c9$export$1f7213d0f9054f06);
const $5d8459da4a60e5c9$export$1f7213d0f9054f06 = (match, query)=>{
    // handle reports legacy url or project settings details
    const projectId = query.selectedProjectId || query.pid || query.projectId || query['project.id'];
    const projectKey = match.params.projectKey || query.projectKey || query['project.key'] || (match.params.issueKey || '').split('-')[0];
    return {
        projectKey: projectKey,
        projectId: projectId
    };
};

});

const $e9754370217fd66e$export$80a60a092d9ab81 = 'PROJECT_CONTEXT';

parcelRegister("ajizA", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('cLVTX');
        const value = parcelRequire('6oUEv');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("cLVTX").then(()=>parcelRequire('6oUEv'));
}

});



parcelRegister("bEe6y", function(module, exports) {

$parcel$export(module.exports, "AsyncHorizontalSoftwareProjectNav", () => $1f8792707b4b0d16$export$128d5d79815580ca);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $1f8792707b4b0d16$var$LazyHorizontalSoftwareProjectNav = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("jcJDQ")).then(({ HorizontalSoftwareProjectNav: HorizontalSoftwareProjectNav })=>HorizontalSoftwareProjectNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-software/src/ui/index.tsx"
});
const $1f8792707b4b0d16$export$128d5d79815580ca = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "horizontal-software-project-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1f8792707b4b0d16$var$LazyHorizontalSoftwareProjectNav, null));

});
parcelRegister("jcJDQ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('bnyRr')
        ]);
        const value = parcelRequire('kUyw6');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("bnyRr")
    ]).then(()=>parcelRequire('kUyw6'));
}

});


const $afb3b9e0346cd1fd$export$9ab1d1d726b36319 = 'GENERIC_PROJECT_HORIZONTAL_NAV';


const $7688150c048b38d1$export$c9e16a15d65437 = 'navigationNext';
const $7688150c048b38d1$export$b1534bc11f201efd = 'jiraPageContainer';
const $7688150c048b38d1$export$fa4bbc89fd1f1a7 = null;
const $7688150c048b38d1$export$aa6008fe0169b864 = null;
const $7688150c048b38d1$export$39418a21fbb51487 = null;
const $7688150c048b38d1$export$7dfef0177e883b05 = 'entry.jira-spa';
const $7688150c048b38d1$var$PAGE_CONTAINER_MARK = 'jira-spa/spa-shell/page-container';
const $7688150c048b38d1$export$7114284ca03133ee = `_${$7688150c048b38d1$var$PAGE_CONTAINER_MARK}.end`;
const $7688150c048b38d1$export$21473105c510aacc = 'jira-spa/spa-shell/page-layout';
const $7688150c048b38d1$export$898b6208220685b0 = 'jira-spa/spa-shell/global-containers';
const $7688150c048b38d1$export$e2bc63118050de32 = `_${$7688150c048b38d1$export$898b6208220685b0}.start`;
const $7688150c048b38d1$export$59f83d43fe209319 = `_${$7688150c048b38d1$export$898b6208220685b0}.end`;
const $7688150c048b38d1$export$fb9876ab4228d985 = 'jira-spa/spa-shell/global-components';
const $7688150c048b38d1$export$c20831be6f780cb5 = `_${$7688150c048b38d1$export$fb9876ab4228d985}.start`;
const $7688150c048b38d1$export$398df1bca49f9884 = `_${$7688150c048b38d1$export$fb9876ab4228d985}.end`;
const $7688150c048b38d1$export$7048c99f32c60b34 = 'jira-spa/spa-shell/global-containers/app-base';
const $7688150c048b38d1$export$3c2d8af5c7577fe7 = `_${$7688150c048b38d1$export$7048c99f32c60b34}.start`;
const $7688150c048b38d1$export$aac77afee74c49d0 = `_${$7688150c048b38d1$export$7048c99f32c60b34}.end`;
const $7688150c048b38d1$export$4f341d86a3c214 = 'jira-spa/spa-shell/global-containers/router';
const $7688150c048b38d1$export$16e7ead3a8b5c366 = `_${$7688150c048b38d1$export$4f341d86a3c214}.start`;
const $7688150c048b38d1$export$c389f0b50840d5ca = `_${$7688150c048b38d1$export$4f341d86a3c214}.end`;

// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("bQiKj", function(module, exports) {

$parcel$export(module.exports, "sharedLayout", () => $9081c29c094d647d$export$5f4dc7c98070d93e);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $2WOJv = parcelRequire("2WOJv");

var $7ZZxN = parcelRequire("7ZZxN");

var $gMtJP = parcelRequire("gMtJP");

var $d3Jbb = parcelRequire("d3Jbb");

var $69KNw = parcelRequire("69KNw");

var $2RiaW = parcelRequire("2RiaW");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $6xYPC = parcelRequire("6xYPC");

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");

var $dnJL9 = parcelRequire("dnJL9");

var $eI5EY = parcelRequire("eI5EY");

var $j6ken = parcelRequire("j6ken");

var $jxIns = parcelRequire("jxIns");

var $d8a4z = parcelRequire("d8a4z");

var $3eqbP = parcelRequire("3eqbP");

var $cPEpP = parcelRequire("cPEpP");

var $i9XZP = parcelRequire("i9XZP");

var $2m6cd = parcelRequire("2m6cd");
var $hEyt5 = parcelRequire("hEyt5");

var $iOtr0 = parcelRequire("iOtr0");

var $isbb2 = parcelRequire("isbb2");

var $5EZtQ = parcelRequire("5EZtQ");

var $cADdB = parcelRequire("cADdB");

var $dWLk9 = parcelRequire("dWLk9");

var $lFrSS = parcelRequire("lFrSS");

var $cLxEl = parcelRequire("cLxEl");

var $BRKX9 = parcelRequire("BRKX9");

var $1OfKM = parcelRequire("1OfKM");
var $6Q9xY = parcelRequire("6Q9xY");
var $egQj9 = parcelRequire("egQj9");
const $9081c29c094d647d$var$isTrialEndLockScreenExperimentEnabled = ()=>(0, $1ybV0.ff)('jsm-trial-end-lock-screen-experiment_nowmr') || (0, $1ybV0.ff)('jpd-trial-end-lock-screen-experiment') || (0, $eI5EY.fg)('jsw_premium_eot_lock_screen_feature_gate');
const $9081c29c094d647d$var$REMOTE_ACTIONS_OFF = 'OFF';
const $9081c29c094d647d$var$REMOTE_ACTIONS_MEASURE = 'MEASURE';
const $9081c29c094d647d$var$REMOTE_ACTIONS_PERFORM = 'PERFORM';
const $9081c29c094d647d$var$getRemoteActionsRolloutStage = ()=>(0, $1ybV0.getMultivariateFeatureFlag)('jsw.roadmap.remote-actions-rollout', $9081c29c094d647d$var$REMOTE_ACTIONS_OFF, [
        $9081c29c094d647d$var$REMOTE_ACTIONS_OFF,
        $9081c29c094d647d$var$REMOTE_ACTIONS_MEASURE,
        $9081c29c094d647d$var$REMOTE_ACTIONS_PERFORM
    ]);
// +owner:pdhanuka
// eslint-disable-next-line jira/ff/inline-usage
const $9081c29c094d647d$var$isPendoIntegrationEnabled = ()=>(0, $1ybV0.ff)('jira-frontend-pendo-analytics_s6sj5');

// -owner:pdhanuka
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9081c29c094d647d$var$Global = (0, $7rh0R.lazy)(()=>(parcelRequire("aHKm3")), {
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/global/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9081c29c094d647d$var$Navigation = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("eHaUV")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/navigation/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9081c29c094d647d$var$Trackers = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("cBhvG")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/trackers/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9081c29c094d647d$var$RemoteActions = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("lx7fQ")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/remote-actions/index.tsx"
});

// No need for a whole chunk for a single component
/* eslint-disable-next-line jira/import/webpack-magic-comment-entries, jira/deprecations/no-rll-client-async-experiences */ const $9081c29c094d647d$var$AfterPaintIssuePreEval = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("1lcdx")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/after-paint-issue-preeval/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9081c29c094d647d$var$AsyncBrowserStorageControlsInit = (0, $7rh0R.lazy)(()=>(parcelRequire("ac8TH")).then(({ BrowserStorageControlsInit: BrowserStorageControlsInit })=>BrowserStorageControlsInit), {
    moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/browser-storage-controls-init/index.tsx"
});
const $9081c29c094d647d$var$runtimeProps = {};
const $9081c29c094d647d$var$entryPointParams = {};
const $9081c29c094d647d$export$70b554b486395223 = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $cLxEl.upgradeOnboardingExperimentEntryPoint), $9081c29c094d647d$var$entryPointParams);
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "growth.upgradeOnboardingExperiment",
        packageName: "issue-view",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: null,
        runtimeProps: $9081c29c094d647d$var$runtimeProps
    });
};
const $9081c29c094d647d$export$3859d35c5447350b = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $5EZtQ.rovoVideoModalEntryPoint), $9081c29c094d647d$var$entryPointParams);
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "growth.rovoVideoPlayer",
        packageName: "rovo-video-modal",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: null,
        runtimeProps: $9081c29c094d647d$var$runtimeProps
    });
};
const $9081c29c094d647d$export$bb0d8fff645668ce = ()=>{
    const cloudID = (0, $dWLk9.useCloudId)();
    const { data: project } = (0, $cPEpP.useProject)();
    const projectType = (0, $7ZZxN.toProjectType)(project?.type) || null;
    const productKey = (0, $7ZZxN.projectTypeToCanonicalId)(projectType);
    const deferEditionModalEntryPointParams = (0, $eUqFw.useMemo)(()=>({
            cloudId: cloudID,
            productKey: productKey
        }), [
        cloudID,
        productKey
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $2RiaW.jiraDeferEditionModalEntryPoint), deferEditionModalEntryPointParams);
    const onComplete = (0, $eUqFw.useCallback)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $69KNw.AsyncDeferEditionEPCheckWrapper), {
        onComplete: onComplete
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "growth.jiraDeferEditionModal",
        packageName: "jira-defer-edition-modal",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: null,
        runtimeProps: $9081c29c094d647d$var$runtimeProps
    }));
};
const $9081c29c094d647d$var$DeferEditionModal = (0, $dnJL9.componentWithFG)('cross-flow-defer-edition-communication-gate', $9081c29c094d647d$export$bb0d8fff645668ce, ()=>null);
const $9081c29c094d647d$var$DeferRovoVideoModal = (0, $dnJL9.componentWithFG)('rovo_video_player_gate', $9081c29c094d647d$export$3859d35c5447350b, ()=>null);
$9081c29c094d647d$var$DeferEditionModal.displayName = 'DeferEditionModal';
$9081c29c094d647d$var$DeferRovoVideoModal.displayName = 'DeferRovoVideoModal';
const $9081c29c094d647d$var$sharedGlobalComponents = [
    ...false ? [] : [
        (0, $2m6cd.MatchedRouteListener),
        (0, $hEyt5.PreviousRouterStateListener),
        (0, $6Q9xY.LoadingPhaseManager),
        (0, $j6ken.LoadingBarUIController),
        (0, $2WOJv.default),
        (0, $1OfKM.BreadcrumbAdapter),
        (0, $iOtr0.default),
        (0, $i9XZP.PageDwellAnalyticsListener),
        (0, $d8a4z.ImperativeAPI),
        (0, $egQj9.TrackClicksBeforeTTI),
        (0, $cADdB.default),
        (0, $lFrSS.AsyncUpflowIframeComponent),
        (0, $BRKX9.JiraHeritageLoader),
        $9081c29c094d647d$var$AsyncBrowserStorageControlsInit,
        ...$9081c29c094d647d$var$isPendoIntegrationEnabled() ? [
            (0, $gMtJP.AsyncPendoAnalyticsWrapper)
        ] : [],
        (0, $6xYPC.default),
        ...$9081c29c094d647d$var$getRemoteActionsRolloutStage() !== $9081c29c094d647d$var$REMOTE_ACTIONS_OFF ? [
            $9081c29c094d647d$var$RemoteActions
        ] : [],
        ...$9081c29c094d647d$var$isTrialEndLockScreenExperimentEnabled() ? [
            (0, $3eqbP.AsyncLockScreenExperimentSharedWrapper)
        ] : [],
        (0, $9zysr.componentWithCondition)(()=>(0, $eI5EY.fg)('jira_upgrade_onboarding'), $9081c29c094d647d$export$70b554b486395223, ()=>null),
        $9081c29c094d647d$var$DeferEditionModal,
        $9081c29c094d647d$var$DeferRovoVideoModal
    ],
    $9081c29c094d647d$var$Global,
    $9081c29c094d647d$var$Navigation,
    $9081c29c094d647d$var$Trackers,
    $9081c29c094d647d$var$AfterPaintIssuePreEval
];
const $9081c29c094d647d$export$5f4dc7c98070d93e = (0, $isbb2.createLayout)({
    rightSidebars: [
        (0, $jxIns.SafeHelpPanel),
        (0, $d3Jbb.SafeConversationAssistantPanel)
    ],
    globalComponents: $9081c29c094d647d$var$sharedGlobalComponents
});

});
parcelRegister("2WOJv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f61d7eac9e8a3283$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dxcfv = parcelRequire("dxcfv");

var $48k9t = parcelRequire("48k9t");
const $f61d7eac9e8a3283$var$CacheRegistry = ()=>{
    const accountIdLoggedInUser = (0, $dxcfv.useAccountId)();
    (0, $eUqFw.useEffect)(()=>{
        (0, $48k9t.default).set(accountIdLoggedInUser ?? 'anonymous');
    }, [
        accountIdLoggedInUser
    ]);
    return null;
};
var $f61d7eac9e8a3283$export$2e2bcd8739ae039 = $f61d7eac9e8a3283$var$CacheRegistry;

});
parcelRegister("48k9t", function(module, exports) {

$parcel$export(module.exports, "CACHE_PREFIX", () => $619b603377692131$export$69ca515e4489d790);
$parcel$export(module.exports, "scopeGuard", () => $619b603377692131$export$653cd03438bb0386);
$parcel$export(module.exports, "default", () => $619b603377692131$export$2e2bcd8739ae039);

var $aZaPn = parcelRequire("aZaPn");
let $619b603377692131$var$resolveCachePromise;
const $619b603377692131$var$cachePromise = new Promise((resolve)=>{
    $619b603377692131$var$resolveCachePromise = resolve;
});
const $619b603377692131$export$27be962d708928a = '__scope_key__';
const $619b603377692131$export$69ca515e4489d790 = 'cache_prefix';
const $619b603377692131$var$TIMEOUT = 10000;
const $619b603377692131$var$promiseWithMaxExecutionTime = (ms, promise)=>{
    let id;
    const timeout = new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (resolve, reject)=>{
        id = setTimeout(()=>{
            const storage = (0, $aZaPn.createLocalStorageProvider)($619b603377692131$export$69ca515e4489d790);
            storage.clearAll();
            reject(new Error(`Cache scope was not set within ${$619b603377692131$var$TIMEOUT}ms`));
        }, ms);
    });
    return Promise.race([
        promise,
        timeout
    ]).then((result)=>{
        clearTimeout(id);
        return result;
    });
};
const $619b603377692131$export$653cd03438bb0386 = ()=>$619b603377692131$var$promiseWithMaxExecutionTime($619b603377692131$var$TIMEOUT, $619b603377692131$var$cachePromise);
const $619b603377692131$var$config = {
    devTools: false,
    scopes: {
        prev: null,
        current: null
    },
    set (scopeKey) {
        const storage = (0, $aZaPn.createLocalStorageProvider)($619b603377692131$export$69ca515e4489d790);
        const scopeKeyInStorage = storage.get($619b603377692131$export$27be962d708928a);
        // init value
        if (this.scopes.prev === null && this.scopes.current === null) {
            if (scopeKeyInStorage) {
                // @ts-expect-error - TS2540 - Cannot assign to 'prev' because it is a read-only property.
                this.scopes.prev = scopeKeyInStorage;
                // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
                this.scopes.current = scopeKeyInStorage;
            }
        }
        // same account id
        if (this.scopes.current !== scopeKey) {
            // diffrent account id
            if (this.scopes.current !== null) // scope has changed during session
            storage.clearAll();
            // @ts-expect-error - TS2540 - Cannot assign to 'prev' because it is a read-only property.
            this.scopes.prev = this.scopes.current;
            // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
            this.scopes.current = scopeKey;
            storage.set($619b603377692131$export$27be962d708928a, scopeKey);
        }
        // @ts-expect-error - TS7005 - Variable 'resolveCachePromise' implicitly has an 'any' type.
        $619b603377692131$var$resolveCachePromise();
    },
    get () {
        return this.scopes.current;
    }
};
var $619b603377692131$export$2e2bcd8739ae039 = $619b603377692131$var$config;

});
parcelRegister("aZaPn", function(module, exports) {

$parcel$export(module.exports, "createLocalStorageProvider", () => $e83d7abe46867842$export$697e65b1658f821b);
$parcel$export(module.exports, "createLocalExpirableStorageProvider", () => $e83d7abe46867842$export$59acef2b3ab1df90);

var $jqvCZ = parcelRequire("jqvCZ");

var $avHyR = parcelRequire("avHyR");

var $kkXA4 = parcelRequire("kkXA4");
const $e83d7abe46867842$export$697e65b1658f821b = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((appPrefix)=>(0, $avHyR.createStorageProvider)(appPrefix, (0, $kkXA4.makeLocalStore)()));
const $e83d7abe46867842$export$59acef2b3ab1df90 = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((appPrefix)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    const store = (0, $kkXA4.makeLocalExpirableStore)();
    return store.namespace(appPrefix);
});

});
parcelRegister("avHyR", function(module, exports) {

$parcel$export(module.exports, "plugins", () => $e7af9f5944d51b15$export$8b3ca321c77fdea6);
$parcel$export(module.exports, "createStorageProvider", () => $e7af9f5944d51b15$export$8441605555fbd60c);

var $2y3XF = parcelRequire("2y3XF");

var $4b9NC = parcelRequire("4b9NC");
const $e7af9f5944d51b15$export$8b3ca321c77fdea6 = [
    (0, (/*@__PURE__*/$parcel$interopDefault($2y3XF))),
    (0, $4b9NC.default)
];
const $e7af9f5944d51b15$export$8441605555fbd60c = (appPrefix, store)=>store.namespace(appPrefix);

});
parcelRegister("4b9NC", function(module, exports) {

$parcel$export(module.exports, "default", () => $19af1635632d325b$export$2e2bcd8739ae039);

var $guiFP = parcelRequire("guiFP");

var $gjqa4 = parcelRequire("gjqa4");
/**
 * Enhances storage operations with automated cleanup capabilities. This includes tracking
 * item timestamps for age-based cleanup, handling storage limits by removing older items,
 * and providing utility functions for managing storage contents. Designed to ensure
 * efficient use of storage space without manual intervention.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $19af1635632d325b$var$cleanUpPlugin() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    const timestamps = self.createStore(self.storage, null, self._namespacePrefix + (0, $gjqa4.NAMESPACE));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function set(superFn, key, val) {
        try {
            if (!self.hasNamespace((0, $gjqa4.NAMESPACE))) timestamps.set(key, Date.now());
            superFn();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            // storage is full. Relevant only for localStorage
            if (e.code === (0, $gjqa4.LOCAL_STORAGE_FULL_ERROR_CODE) || e.code === (0, $gjqa4.LOCAL_STORAGE_FULL_FF_ERROR_CODE)) {
                // 22 - the correct code most browsers use
                // 1014 - Firefox's code
                (0, $guiFP.default)({
                    meta: {
                        id: 'browserLocalStorageFullError',
                        packageName: 'jiraBrowserStorageProviders',
                        teamName: 'magma'
                    },
                    attributes: {
                        namespace: self._namespacePrefix
                    },
                    error: e
                });
                if (self.cleanWhenFull()) self.set(superFn, key, val);
            } else {
                (0, $guiFP.default)({
                    meta: {
                        id: 'storageCleanupPluginError',
                        packageName: 'jiraBrowserStorageProviders',
                        teamName: 'magma'
                    },
                    attributes: {
                        isLegacyFunction: false
                    },
                    error: e
                });
                throw e;
            }
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function remove(superFn, key) {
        if (!self.hasNamespace((0, $gjqa4.NAMESPACE))) timestamps.remove(key);
        return superFn();
    }
    // quite stupid way of getting totals, but current library supports only this.each()
    function getTotalCount() {
        let count = 0;
        self.each(()=>{
            count += 1;
        });
        return count;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function cleanWhenFull(superFn, minAge = (0, $gjqa4.FOUR_WEEKS)) {
        const currTime = Date.now();
        const numKeysBefore = self.getTotalCount();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        self.each((_value, key)=>{
            // return correct value for current collection
            // and return null for timestamps collection
            const created = !self.hasNamespace((0, $gjqa4.NAMESPACE)) ? timestamps.get(key) : null;
            if (typeof created === 'number' && currTime - created > minAge) self.remove(key);
        });
        const itemsRemovedCount = numKeysBefore - self.getTotalCount();
        if (!itemsRemovedCount && minAge - (0, $gjqa4.ONE_WEEK) >= (0, $gjqa4.ONE_WEEK)) return self.cleanWhenFull(minAge - (0, $gjqa4.ONE_WEEK));
        return itemsRemovedCount === 0;
    }
    return {
        set: set,
        remove: remove,
        cleanWhenFull: cleanWhenFull,
        getTotalCount: getTotalCount
    };
}
var $19af1635632d325b$export$2e2bcd8739ae039 = $19af1635632d325b$var$cleanUpPlugin;

});
parcelRegister("gjqa4", function(module, exports) {

$parcel$export(module.exports, "NAMESPACE", () => $cf4854539b53d7dc$export$6aad947bda0f3f46);
$parcel$export(module.exports, "ONE_WEEK", () => $cf4854539b53d7dc$export$8187f416f1cc43d8);
$parcel$export(module.exports, "FOUR_WEEKS", () => $cf4854539b53d7dc$export$6e952fa7d47190cf);
$parcel$export(module.exports, "LOCAL_STORAGE_FULL_ERROR_CODE", () => $cf4854539b53d7dc$export$da99ebca8f453abd);
$parcel$export(module.exports, "LOCAL_STORAGE_FULL_FF_ERROR_CODE", () => $cf4854539b53d7dc$export$ea28dfd9333cda2d);
const $cf4854539b53d7dc$export$6aad947bda0f3f46 = 'timestamps';
const $cf4854539b53d7dc$export$8187f416f1cc43d8 = 604800000;
const $cf4854539b53d7dc$export$6e952fa7d47190cf = 4 * $cf4854539b53d7dc$export$8187f416f1cc43d8;
const $cf4854539b53d7dc$export$da99ebca8f453abd = 22;
const $cf4854539b53d7dc$export$ea28dfd9333cda2d = 1014;

});



parcelRegister("kkXA4", function(module, exports) {

$parcel$export(module.exports, "makeLocalStore", () => $b4e518dc83f214e8$export$b2631085fe8db7af);
$parcel$export(module.exports, "makeLocalExpirableStore", () => $b4e518dc83f214e8$export$cf816b43e73de947);

var $2y3XF = parcelRequire("2y3XF");

var $gleLd = parcelRequire("gleLd");

var $ZGlKn = parcelRequire("ZGlKn");

var $5rWiD = parcelRequire("5rWiD");

var $gpWeB = parcelRequire("gpWeB");

var $avHyR = parcelRequire("avHyR");
const $b4e518dc83f214e8$export$b2631085fe8db7af = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ZGlKn))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($5rWiD))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gpWeB)))
    ], (0, $avHyR.plugins));
const $b4e518dc83f214e8$export$cf816b43e73de947 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ZGlKn))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($5rWiD))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gpWeB)))
    ], [
        (0, (/*@__PURE__*/$parcel$interopDefault($2y3XF))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gleLd)))
    ]);

});




parcelRegister("gMtJP", function(module, exports) {

$parcel$export(module.exports, "AsyncPendoAnalyticsWrapper", () => $b64a74411af401d0$export$1c388e7c464f3699);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $aR8n6 = parcelRequire("aR8n6");

const $b64a74411af401d0$var$AsyncPendoAnalytics = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("hataJ")).then(({ PendoAnalytics: PendoAnalytics })=>PendoAnalytics), {
    moduleId: "./src/packages/platform/services/pendo-analytics/src/index.tsx"
});
const $b64a74411af401d0$export$1c388e7c464f3699 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "jiraCommonPendoAnalyticsReportErrors",
        packageName: "jiraCommonPendoAnalytics"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
        teamName: "martech",
        id: "jiraCommonPendoAnalyticsReportErrors",
        packageName: "jiraCommonPendoAnalytics"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b64a74411af401d0$var$AsyncPendoAnalytics, null)));

});
parcelRegister("hataJ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('dh7j2');
        const value = parcelRequire('4Sylr');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("dh7j2").then(()=>parcelRequire('4Sylr'));
}

});


parcelRegister("d3Jbb", function(module, exports) {

$parcel$export(module.exports, "SafeConversationAssistantPanel", () => $13a9fb2c9a767804$export$453401d0b697d2db);
$parcel$export(module.exports, "CONVERSATION_ASSISTANT_CONTAINER_ID", () => $3dd2aa1a057580d8$export$dffb4ed44e20ea9a);

var $eUqFw = parcelRequire("eUqFw");

var $6PJBT = parcelRequire("6PJBT");


var $0cdA8 = parcelRequire("0cdA8");

var $bUi2Q = parcelRequire("bUi2Q");

var $bFzGY = parcelRequire("bFzGY");

var $6vpb8 = parcelRequire("6vpb8");
const $13a9fb2c9a767804$var$PanelInLayout = ()=>{
    const rightSidebarCurrentState = (0, $bUi2Q.useActiveRightSidebarState)();
    const [localPanelId, setLocalPanelId] = (0, $eUqFw.useState)();
    const prevPanelIdRef = (0, $eUqFw.useRef)();
    const delayRef = (0, $eUqFw.useRef)(null);
    const { closeCurrentRightSidebar: closeCurrentRightSidebar } = (0, $bUi2Q.useRightSidebarController)();
    const panelId = rightSidebarCurrentState?.panelId;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    /**
	 * This use effect is used to add (when is necessary) a delay
	 * in the panelId => localPanelId syncing
	 */ (0, $eUqFw.useEffect)(()=>{
        // @ts-expect-error - TS2769 - No overload matches this call.
        clearTimeout(delayRef.current);
        if (prevPanelIdRef.current === (0, $3dd2aa1a057580d8$export$dffb4ed44e20ea9a)) {
            /**
			 * The right-sidebar is showing the conversation assistant...
			 */ if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) /**
				 * and is open, not collapsed and we want to show a panel
				 * with an ID !== CONVERSATION_ASSISTANT_CONTAINER_ID
				 */ setLocalPanelId(panelId);
            else /**
				 * and we want to close it
				 */ delayRef.current = setTimeout(()=>{
                setLocalPanelId(panelId);
                createAnalyticsEvent({
                    action: 'closed',
                    actionSubject: 'aiMatePanel',
                    source: 'AIMate',
                    tags: [
                        'atlaskit',
                        'aiMate'
                    ]
                }).fire((0, $6PJBT.FabricChannel).aiMate);
            }, 310);
        } else /**
			 * If the right sidebar is not showing the conversation assistant,
			 * we just keep localPanelId in sync with panelId
			 */ setLocalPanelId(panelId);
        prevPanelIdRef.current = panelId;
        // @ts-expect-error - TS2769 - No overload matches this call.
        return ()=>clearTimeout(delayRef.current);
    }, [
        createAnalyticsEvent,
        panelId,
        rightSidebarCurrentState
    ]);
    if (localPanelId !== (0, $3dd2aa1a057580d8$export$dffb4ed44e20ea9a)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6vpb8.JiraConversationAssistant), {
        onClosePanel: closeCurrentRightSidebar
    });
};
const $13a9fb2c9a767804$export$453401d0b697d2db = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-side-conversation-assistant-panel",
        packageName: "jiraConversationAssistant"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($13a9fb2c9a767804$var$PanelInLayout, null));

});
// Exported through entry point /src/utils.
/**
 * Used as the identifier for container on the consumer side.
 *
 * Example:
 * ```
 * <div id={CONVERSATION_ASSISTANT_CONTAINER_ID}>
 *  <ConversationAssistant />
 * </div>
 * ```
 */ const $3dd2aa1a057580d8$export$dffb4ed44e20ea9a = 'ai-mate-container';
const $3dd2aa1a057580d8$export$64aee74ba59709e5 = 439; // px
const $3dd2aa1a057580d8$export$1c07393c5bb1bc27 = 439; // px
const $3dd2aa1a057580d8$export$aa3478deee7adbeb = 350; // px
const $3dd2aa1a057580d8$export$21e515a86cd1733b = 'Chat';

parcelRegister("6vpb8", function(module, exports) {

$parcel$export(module.exports, "JiraConversationAssistant", () => $477d20553922474c$export$da8473714271a41d);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $b9pGw = parcelRequire("b9pGw");
var $hIc01 = parcelRequire("hIc01");


var $1ybV0 = parcelRequire("1ybV0");

var $6rW04 = parcelRequire("6rW04");

var $bUi2Q = parcelRequire("bUi2Q");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $4rWQe = parcelRequire("4rWQe");
var $dWLk9 = parcelRequire("dWLk9");
const $477d20553922474c$var$SYNTHETIC_HEADER = 'x-issynthetic-traffic';
// TODO: Revisit the X-Product values once we understand AI-access patterns. Using the technically-correct values here results in some subproducts failing to load AI Mate because they can't be enabled with AI, so we're treating everything as "jira" for now
// const getJiraSubProduct = (): ConversationAssistantConfig['product'] => {
// return 'jira';
// const url = window.location.href;
// if (url.includes('/jira/core/')) {
//     return 'jira-core';
// }
// if (url.includes('/jira/servicedesk/')) {
//     return 'jsm';
// }
// if (url.includes('/jira/polaris/')) {
//     return 'jpd';
// }
// if (url.includes('/jira/software/')) {
//     return 'jira-software';
// }
// return 'unknown';
// };
const $477d20553922474c$var$getJiraSubProduct = ()=>'jira';
const $477d20553922474c$export$da8473714271a41d = ({ onClosePanel: onClosePanel })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const activationId = (0, $4rWQe.useActivationId)();
    const { openRightSidebar: openRightSidebar } = (0, $bUi2Q.useRightSidebarController)();
    const isSyntheticTenant = (0, $6rW04.default)('ajs-is-synthetic') === 'true' || (0, $1ybV0.ff)('jsw.pollinator.tenants');
    let baseUrl = '/gateway/api/assist';
    if ((0, $1ybV0.ff)('jira.frontend.ai.mate.route.stargate.to.convo.ai')) baseUrl = '/gateway/api/assist-kotlin';
    else if ((0, $XHGTv.getBooleanFF)('platform.jira.frontend.ai.mate_route_stargate_to_stg_west')) baseUrl = '/gateway/api/assist-tester';
    const config = (0, $eUqFw.useMemo)(()=>({
            displaySubmitFlag: true,
            siteId: cloudId,
            activationId: activationId,
            product: $477d20553922474c$var$getJiraSubProduct(),
            experienceId: 'ai-mate',
            assistanceServiceConfig: {
                // TODO: type `AssistanceServiceConfig` should be decoupled from headers to prevent the need for other required keys which shouldn't need to be defined here (`product` and `experienceId`)
                headers: isSyntheticTenant ? {
                    [$477d20553922474c$var$SYNTHETIC_HEADER]: String(isSyntheticTenant)
                } : {},
                baseUrl: baseUrl
            }
        }), [
        isSyntheticTenant,
        activationId,
        baseUrl,
        cloudId
    ]);
    const handleResizeComplete = (0, $eUqFw.useCallback)((width)=>{
        openRightSidebar((0, $3dd2aa1a057580d8$export$dffb4ed44e20ea9a), width);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'resized',
            actionSubject: 'aiMatePanel'
        }));
    }, [
        openRightSidebar,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hIc01.ResizeWrapper), {
        onResizeComplete: handleResizeComplete
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $477d20553922474c$var$conversationAssistantWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b9pGw.default), {
        testId: "conversation-assistant.ui.conversation-assistant",
        onCloseChat: onClosePanel,
        config: config
    })));
};
const $477d20553922474c$var$conversationAssistantWrapperStyles = (0, $1ZAYh.xcss)({
    width: '100%'
});

});
parcelRegister("4rWQe", function(module, exports) {

$parcel$export(module.exports, "useActivationId", () => $a2ceb1e21dea3b54$export$43686faa787c943);

var $gd0Sp = parcelRequire("gd0Sp");
const $a2ceb1e21dea3b54$export$43686faa787c943 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.activationId;
};

});

parcelRegister("dWLk9", function(module, exports) {

$parcel$export(module.exports, "useCloudId", () => $15ea95bdeaf03a79$export$9da0f7c65f28ed16);

var $gd0Sp = parcelRequire("gd0Sp");
const $15ea95bdeaf03a79$export$9da0f7c65f28ed16 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.cloudId;
};

});



parcelRegister("69KNw", function(module, exports) {

$parcel$export(module.exports, "AsyncDeferEditionEPCheckWrapper", () => $d4f7e79a98bf2d89$export$4fa5b26bccc7e3df);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $aR8n6 = parcelRequire("aR8n6");


const $d4f7e79a98bf2d89$var$AsyncDeferEditionEPCheck = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("Tlf0p")).then(({ EPCheck: EPCheck })=>EPCheck), {
    moduleId: "./src/packages/growth/defer-edition-modal/src/async.tsx"
});
const $d4f7e79a98bf2d89$export$4fa5b26bccc7e3df = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "defer-edition-ep-check-async",
        packageName: (0, $9a060b7ebf877081$export$b8b9d90f9e5bd72b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
        teamName: (0, $9a060b7ebf877081$export$d57b6b390e78d90f),
        id: "defer-edition-ep-check-async",
        packageName: (0, $9a060b7ebf877081$export$b8b9d90f9e5bd72b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d4f7e79a98bf2d89$var$AsyncDeferEditionEPCheck, props)));

});
const $9a060b7ebf877081$export$b8b9d90f9e5bd72b = 'DeferEditionModal';
const $9a060b7ebf877081$export$d57b6b390e78d90f = 'transmuters-growth';
const $9a060b7ebf877081$export$4b374f476a475bef = 'stg-defer-edition-crossflow-jpd';
const $9a060b7ebf877081$export$3fc71bcf4d7deeea = 'stg-defer-edition-crossflow-jsw';
const $9a060b7ebf877081$export$a0f8b0f73985911a = 'stg-defer-edition-crossflow-jwm';
const $9a060b7ebf877081$export$bfaa609ebcf522b6 = 'stg-defer-edition-crossflow-jsm';
const $9a060b7ebf877081$export$58003a8be3bebb14 = 'defer-edition-crossflow-jpd';
const $9a060b7ebf877081$export$475f4ac16b63ff71 = 'defer-edition-crossflow-jsw';
const $9a060b7ebf877081$export$f36bed87d45a98de = 'defer-edition-crossflow-jwm';
const $9a060b7ebf877081$export$b302977ba64b0fa = 'defer-edition-crossflow-jsm';

parcelRegister("Tlf0p", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('gBePI')
        ]);
        const value = parcelRequire('cbtdY');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("gBePI")
    ]).then(()=>parcelRequire('cbtdY'));
}

});


parcelRegister("2RiaW", function(module, exports) {

$parcel$export(module.exports, "jiraDeferEditionModalEntryPoint", () => $4cb205dd87fc0732$export$51f384a783f47807);

var $kKOBp = parcelRequire("kKOBp");

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $4cb205dd87fc0732$export$51f384a783f47807 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(async ()=>(parcelRequire("hIqbr")).then(({ DeferEditionModalComponent: DeferEditionModalComponent })=>DeferEditionModalComponent), {
        moduleId: "fe342c6b"
    }),
    getPreloadProps: ({ cloudId: cloudId, productKey: productKey })=>({
            queries: {
                deferEditionModal: {
                    parameters: (0, $kKOBp.default),
                    variables: {
                        cloudId: cloudId,
                        productKey: productKey
                    }
                }
            }
        })
});

});
parcelRegister("kKOBp", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bb29fd8ceb1ac78$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<538598f02d4274863e69f87ef93afee0>>
 * @relayHash b88a5c8f8a06940641d1109bbd763eff
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5b10c1496eb58e67afa6cdffdf558adb655a89e468a81592e6c039cccddb07ac
const $6bb29fd8ceb1ac78$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "5b10c1496eb58e67afa6cdffdf558adb655a89e468a81592e6c039cccddb07ac",
        "metadata": {},
        "name": "src_DeferEditionModalQuery",
        "operationKind": "query",
        "text": null
    }
};
var $6bb29fd8ceb1ac78$export$2e2bcd8739ae039 = $6bb29fd8ceb1ac78$var$node;

});

parcelRegister("hIqbr", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('d1CGm')
        ]);
        const value = parcelRequire('6TGoA');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("d1CGm")
    ]).then(()=>parcelRequire('6TGoA'));
}

});


parcelRegister("6j4bv", function(module, exports) {

$parcel$export(module.exports, "useEntryPoint", () => $82c08dfbbf99b106$export$338256068bc140fb);

var $eUqFw = parcelRequire("eUqFw");

var $hRw7O = parcelRequire("hRw7O");

var $80LCQ = parcelRequire("80LCQ");

var $fn8UB = parcelRequire("fn8UB");

var $VvIn5 = parcelRequire("VvIn5");
const $82c08dfbbf99b106$export$338256068bc140fb = (entryPoint, entryPointParams, metric, options = (0, $hRw7O.DEFAULT_OPTIONS))=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject, ...loadActions } = (0, $fn8UB.useEntryPointLoadManager)(entryPoint, entryPointParams);
    const { startMetric: startMetric, stopMetric: stopMetric } = (0, $VvIn5.useMetricLogger)(metric);
    const entryPointActions = (0, $80LCQ.useEntryPointActions)(loadActions, options, startMetric);
    return (0, $eUqFw.useMemo)(()=>({
            entryPointActions: entryPointActions,
            entryPointReferenceSubject: entryPointReferenceSubject,
            stopMetric: stopMetric
        }), [
        entryPointActions,
        entryPointReferenceSubject,
        stopMetric
    ]);
};

});
parcelRegister("hRw7O", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_OPTIONS", () => $8aa020919bcd63f9$export$93ca5d3f8675ae4c);
const $8aa020919bcd63f9$export$93ca5d3f8675ae4c = {
    preloadMaxAge: 2000,
    timeToIntent: 200
};

});

parcelRegister("80LCQ", function(module, exports) {

$parcel$export(module.exports, "useEntryPointActions", () => $5764a513c11cf0da$export$90681c8c3a56f09a);

var $eUqFw = parcelRequire("eUqFw");

var $gZ48R = parcelRequire("gZ48R");

var $hRw7O = parcelRequire("hRw7O");
const $5764a513c11cf0da$var$PRELOAD_KILLSWITCH = 'entry_point_preload';
const $5764a513c11cf0da$export$90681c8c3a56f09a = ({ loadEntryPoint: loadEntryPoint, unloadEntryPoint: unloadEntryPoint, commitPreload: commitPreload }, { preloadMaxAge: preloadMaxAge = (0, $hRw7O.DEFAULT_OPTIONS).preloadMaxAge, timeToIntent: timeToIntent = (0, $hRw7O.DEFAULT_OPTIONS).timeToIntent }, startMetric)=>{
    const preloadIntentTimeout = (0, $eUqFw.useRef)();
    const preloadMaxAgeTimeout = (0, $eUqFw.useRef)();
    const preloadLastRequested = (0, $eUqFw.useRef)(0);
    const cancelPreload = (0, $eUqFw.useCallback)(()=>{
        if (!(0, $gZ48R.default)($5764a513c11cf0da$var$PRELOAD_KILLSWITCH)) {
            clearTimeout(preloadIntentTimeout.current);
            clearTimeout(preloadMaxAgeTimeout.current);
        }
    }, []);
    const load = (0, $eUqFw.useCallback)(()=>{
        cancelPreload();
        startMetric(preloadLastRequested.current);
        if (preloadLastRequested.current > 0) commitPreload();
        else loadEntryPoint();
        preloadLastRequested.current = 0;
    }, [
        cancelPreload,
        commitPreload,
        loadEntryPoint,
        startMetric
    ]);
    const preload = (0, $eUqFw.useCallback)(()=>{
        if ((0, $gZ48R.default)($5764a513c11cf0da$var$PRELOAD_KILLSWITCH)) return;
        cancelPreload();
        preloadIntentTimeout.current = setTimeout(()=>{
            preloadLastRequested.current = Date.now();
            loadEntryPoint({
                isPreload: true
            });
            preloadMaxAgeTimeout.current = setTimeout(()=>{
                preloadLastRequested.current = 0;
            }, preloadMaxAge);
        }, timeToIntent);
    }, [
        cancelPreload,
        loadEntryPoint,
        preloadMaxAge,
        timeToIntent
    ]);
    (0, $eUqFw.useEffect)(()=>cancelPreload, [
        cancelPreload
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            cancelPreload: cancelPreload,
            load: load,
            preload: preload,
            unload: unloadEntryPoint
        }), [
        cancelPreload,
        load,
        preload,
        unloadEntryPoint
    ]);
};

});
parcelRegister("gZ48R", function(module, exports) {

$parcel$export(module.exports, "default", () => $08ba5b3185a0b82b$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");
let $08ba5b3185a0b82b$var$cache;
function $08ba5b3185a0b82b$export$2e2bcd8739ae039(name) {
    try {
        if (!$08ba5b3185a0b82b$var$cache) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const config = (0, $1ybV0.getFeatureFlagValue)('killswitch', []);
            $08ba5b3185a0b82b$var$cache = new Set(config.map((d)=>d.toLowerCase()));
        }
        return $08ba5b3185a0b82b$var$cache.has(name.toLowerCase());
    } catch (e) {
        return false;
    }
}

});


parcelRegister("fn8UB", function(module, exports) {

$parcel$export(module.exports, "useEntryPointLoadManager", () => $9075a0262fd7a4a5$export$bfae318f9651db2f);

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $ln3W8 = parcelRequire("ln3W8");

var $boTUp = parcelRequire("boTUp");
const $9075a0262fd7a4a5$export$bfae318f9651db2f = (entryPoint, entryPointParams)=>{
    const environmentProvider = (0, $ln3W8.useJiraRelayEnvironmentProvider)();
    const canLoad = (0, $eUqFw.useRef)(true);
    const timer = (0, $eUqFw.useRef)();
    const entryPointReferenceQueue = (0, $eUqFw.useRef)([]);
    const { getValue: getValue, setEntryPointReference: setEntryPointReference, subscribe: subscribe } = (0, $boTUp.useEntryPointReferenceSubject)();
    const setNextUpdate = (0, $eUqFw.useCallback)((nextEntryPointReference)=>{
        setEntryPointReference(nextEntryPointReference);
        // Delay clean up to prioritise render cycle in case
        // prior queries get used again
        timer.current = setTimeout(()=>{
            const { current: currentQueue } = entryPointReferenceQueue;
            entryPointReferenceQueue.current = nextEntryPointReference === null ? (0, $boTUp.removeAll)(currentQueue) : (0, $boTUp.removeInactiveLoads)(currentQueue);
        }, 0);
    }, [
        setEntryPointReference
    ]);
    const load = (0, $eUqFw.useCallback)(({ isPreload: isPreload } = {
        isPreload: false
    })=>{
        if (canLoad.current) {
            const reference = (0, $iWLL0.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams);
            entryPointReferenceQueue.current.unshift({
                value: reference,
                isPreload: isPreload
            });
            if (isPreload) entryPointReferenceQueue.current = (0, $boTUp.removeRedundantPreloads)(entryPointReferenceQueue.current);
            else setNextUpdate(reference);
        }
    }, [
        entryPoint,
        entryPointParams,
        environmentProvider,
        setNextUpdate
    ]);
    const unload = (0, $eUqFw.useCallback)(()=>{
        setNextUpdate(null);
    }, [
        setNextUpdate
    ]);
    const commitPreload = (0, $eUqFw.useCallback)(()=>{
        const [firstItem] = entryPointReferenceQueue.current;
        if (firstItem?.isPreload) {
            firstItem.isPreload = false;
            setNextUpdate(firstItem.value);
        }
    }, [
        setNextUpdate
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            clearTimeout(timer.current);
            canLoad.current = false;
            entryPointReferenceQueue.current = (0, $boTUp.removeAll)(entryPointReferenceQueue.current);
        }, []);
    return {
        entryPointReferenceSubject: (0, $eUqFw.useMemo)(()=>({
                getValue: getValue,
                subscribe: subscribe
            }), [
            getValue,
            subscribe
        ]),
        loadEntryPoint: load,
        unloadEntryPoint: unload,
        commitPreload: commitPreload
    };
};

});
parcelRegister("ln3W8", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b8bb35ae4ffc3ad$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useJiraRelayEnvironmentProvider", () => $8b8bb35ae4ffc3ad$export$83fb48644dee72f0);

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $amu7D = parcelRequire("amu7D");
function $8b8bb35ae4ffc3ad$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iWLL0.RelayEnvironmentProvider), {
        environment: (0, $amu7D.default)
    }, children);
}
function $8b8bb35ae4ffc3ad$export$83fb48644dee72f0() {
    const environment = (0, $iWLL0.useRelayEnvironment)();
    return (0, $eUqFw.useMemo)(()=>({
            getEnvironment () {
                return environment;
            }
        }), [
        environment
    ]);
}

});
parcelRegister("amu7D", function(module, exports) {

$parcel$export(module.exports, "default", () => $f68576217aea2baf$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/relay-runtime

var $cNy9K = parcelRequire("cNy9K");

var $9GSiX = parcelRequire("9GSiX");
const $f68576217aea2baf$var$environmentConfig = (0, $9GSiX.getRelayEnvironmentConfig)();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f68576217aea2baf$export$2e2bcd8739ae039 = new (0, $cNy9K.Environment)($f68576217aea2baf$var$environmentConfig);

});
parcelRegister("9GSiX", function(module, exports) {

$parcel$export(module.exports, "getRelayEnvironmentConfig", () => $b823b5ac69a7954d$export$a451c85db2d1cda3);

var $9fdRu = parcelRequire("9fdRu");

var $2vvuk = parcelRequire("2vvuk");

var $isMPK = parcelRequire("isMPK");
const $b823b5ac69a7954d$export$a451c85db2d1cda3 = ()=>(0, $isMPK.getDefaultRelayEnvironmentConfig)({
        network: (0, $2vvuk.getNetwork)(),
        log: (0, $9fdRu.default),
        requiredFieldLogger: $9fdRu.requiredFieldLogger
    });

});
parcelRegister("9fdRu", function(module, exports) {

$parcel$export(module.exports, "requiredFieldLogger", () => $c152fc62c06270e5$export$1ab8b98d209afe85);
$parcel$export(module.exports, "default", () => $c152fc62c06270e5$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $gZ48R = parcelRequire("gZ48R");

var $fVaJL = parcelRequire("fVaJL");
const $c152fc62c06270e5$var$RELAY_CLIENT_ID = 'AGG';
const $c152fc62c06270e5$var$LOG_NAMESPACE = `relay.${$c152fc62c06270e5$var$RELAY_CLIENT_ID}.error.graphql`;
const $c152fc62c06270e5$var$requests = {};
const $c152fc62c06270e5$var$queries = {};
const $c152fc62c06270e5$var$resources = {};
const $c152fc62c06270e5$var$executes = {};
const $c152fc62c06270e5$var$CLEANUP_TIMEOUT = 300000; // 5 minutes
const $c152fc62c06270e5$export$1ab8b98d209afe85 = (event)=>{
    (0, $gUUjF.default).safeErrorWithoutCustomerData($c152fc62c06270e5$var$LOG_NAMESPACE, '[relay required field error]', {
        kind: event.kind,
        owner: event.owner,
        fieldPath: event.fieldPath,
        message: event.kind === 'relay_resolver.error' ? event.error?.message : null
    });
};
const $c152fc62c06270e5$var$getResponseSize = (resp)=>{
    if (resp.data === undefined) return 0;
    try {
        return JSON.stringify(resp.data).length;
    } catch (e) {
        return 0;
    }
};
function $c152fc62c06270e5$export$2e2bcd8739ae039(event) {
    if ((0, $gZ48R.default)('relay_log')) return;
    switch(event.name){
        // NETWORK
        case 'network.start':
            {
                const networkStart = performance.now();
                const { networkRequestId: networkRequestId } = event;
                const { name: name } = event.params;
                const requestInfo = $c152fc62c06270e5$var$requests[networkRequestId];
                if (requestInfo == null) {
                    const newRequestInfo = {
                        name: name,
                        flushes: [],
                        start: networkStart,
                        networkStart: networkStart
                    };
                    $c152fc62c06270e5$var$queries[name] = newRequestInfo;
                    $c152fc62c06270e5$var$requests[networkRequestId] = newRequestInfo;
                    setTimeout(()=>{
                        delete $c152fc62c06270e5$var$requests[networkRequestId];
                        delete $c152fc62c06270e5$var$queries[name];
                    }, $c152fc62c06270e5$var$CLEANUP_TIMEOUT);
                } else requestInfo.networkStart = networkStart;
                break;
            }
        case 'network.next':
            {
                const requestInfo = $c152fc62c06270e5$var$requests[event.networkRequestId];
                if (requestInfo != null) {
                    const { response: response } = event;
                    const addFlush = (resp)=>{
                        if (resp.data !== null) {
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            const res = resp;
                            const flush = {
                                label: res.label != null ? res.label : 'root',
                                time: performance.now(),
                                size: $c152fc62c06270e5$var$getResponseSize(res)
                            };
                            requestInfo.flushes?.push(flush);
                        }
                    };
                    Array.isArray(response) ? response.forEach(addFlush) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    addFlush(response);
                }
                break;
            }
        case 'network.error':
            {
                const info = $c152fc62c06270e5$var$requests[event.networkRequestId];
                if (info != null) info.error = event.error;
                break;
            }
        case 'network.info':
            break;
        case 'network.complete':
            {
                const requestInfo = $c152fc62c06270e5$var$requests[event.networkRequestId];
                const networkComplete = performance.now();
                if (requestInfo != null) {
                    const size = requestInfo.flushes.map((f)=>f.size).reduce((p, c)=>p + c, 0);
                    requestInfo.size = size;
                    requestInfo.networkComplete = networkComplete;
                    requestInfo.flushes = [];
                    (0, $fVaJL.addSpanToAll)('relay', requestInfo.name, [
                        {
                            name: 'network'
                        }
                    ], requestInfo.start, requestInfo.networkComplete, size);
                }
                break;
            }
        case 'network.unsubscribe':
            break;
        // SUSPENSE
        case 'suspense.fragment':
            break;
        case 'suspense.query':
            break;
        // QUERY
        case 'queryresource.fetch':
            {
                const { node: node } = event.operation.root;
                const fetchStart = performance.now();
                // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'NormalizationSelectableNode'.
                if (node.name != null) {
                    // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'NormalizationSelectableNode'.
                    const { name: name } = node;
                    const requestInfo = $c152fc62c06270e5$var$queries[name];
                    if (requestInfo != null) {
                        requestInfo.fetchStart = fetchStart;
                        $c152fc62c06270e5$var$resources[event.resourceID] = requestInfo;
                    } else {
                        const newRequestInfo = {
                            name: name,
                            flushes: [],
                            start: fetchStart,
                            fetchStart: fetchStart
                        };
                        $c152fc62c06270e5$var$queries[name] = newRequestInfo;
                        $c152fc62c06270e5$var$resources[event.resourceID] = newRequestInfo;
                        setTimeout(()=>{
                            // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'NormalizationSelectableNode'.
                            delete $c152fc62c06270e5$var$queries[node.name];
                        }, $c152fc62c06270e5$var$CLEANUP_TIMEOUT);
                    }
                    setTimeout(()=>{
                        delete $c152fc62c06270e5$var$resources[event.resourceID];
                    }, $c152fc62c06270e5$var$CLEANUP_TIMEOUT);
                }
                break;
            }
        case 'queryresource.retain':
            {
                const requestInfo = $c152fc62c06270e5$var$resources[event.resourceID];
                if (requestInfo != null && event.profilerContext != null) {
                    requestInfo.end = performance.now();
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    const context = event.profilerContext;
                    context?.retainQuery?.(requestInfo);
                }
                break;
            }
        // EXECUTE
        case 'execute.start':
            $c152fc62c06270e5$var$executes[event.executeId] = {
                name: event.params.name,
                // @ts-expect-error - TS2322 - Type 'string' is not assignable to type '"query" | "mutation" | "subscription"'.
                kind: event.params.operationKind,
                start: performance.now(),
                duration: 0
            };
            break;
        case 'execute.next':
            $c152fc62c06270e5$var$executes[event.executeId].duration += event.duration;
            break;
        case 'execute.async.module':
            break;
        case 'execute.flight.payload_deserialize':
            break;
        case 'execute.error':
            delete $c152fc62c06270e5$var$executes[event.executeId];
            break;
        case 'execute.complete':
            {
                const op = $c152fc62c06270e5$var$executes[event.executeId];
                if (op != null) {
                    op.end = performance.now();
                    delete $c152fc62c06270e5$var$executes[event.executeId];
                }
                break;
            }
        // STORE
        case 'store.publish':
            break;
        case 'store.snapshot':
            break;
        case 'store.restore':
            break;
        case 'store.gc':
            break;
        // FLUSH
        case 'store.notify.start':
            break;
        case 'store.notify.complete':
            break;
        case 'store.notify.subscription':
            break;
        // ENTRYPOINT
        case 'entrypoint.root.consume':
            break;
        default:
            break;
    }
}

});

parcelRegister("2vvuk", function(module, exports) {

$parcel$export(module.exports, "getNetwork", () => $4d8ddda0e7507868$export$7de4970ebfd8206d);

var $cNy9K = parcelRequire("cNy9K");

var $c4LxQ = parcelRequire("c4LxQ");

var $4aLdW = parcelRequire("4aLdW");

var $b3wL2 = parcelRequire("b3wL2");
const $4d8ddda0e7507868$export$7de4970ebfd8206d = ()=>{
    if ((0, $b3wL2.isSSR)()) (0, $cNy9K.Network).create((0, $c4LxQ.fetch));
    return (0, $cNy9K.Network).create((0, $c4LxQ.fetch), (0, $4aLdW.subscribe));
};

});
parcelRegister("c4LxQ", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $1a035cb2d3f2c948$export$e7aa7bc5c1b3cfb3);

var $ldoFd = parcelRequire("ldoFd");

var $2vzCR = parcelRequire("2vzCR");

var $cNy9K = parcelRequire("cNy9K");

var $XHGTv = parcelRequire("XHGTv");

var $bW292 = parcelRequire("bW292");

var $eTIsH = parcelRequire("eTIsH");

var $fVqUX = parcelRequire("fVqUX");

var $lRmyA = parcelRequire("lRmyA");
var $7byHA = parcelRequire("7byHA");
var $3lpdA = parcelRequire("3lpdA");

var $5zSUY = parcelRequire("5zSUY");

var $15ZJO = parcelRequire("15ZJO");

var $7GiRY = parcelRequire("7GiRY");

var $c7ifG = parcelRequire("c7ifG");

var $j7fph = parcelRequire("j7fph");

var $8tomX = parcelRequire("8tomX");

var $2n6bs = parcelRequire("2n6bs");

var $cmqZo = parcelRequire("cmqZo");

var $5udmX = parcelRequire("5udmX");

var $iuC8B = parcelRequire("iuC8B");

var $ixYrr = parcelRequire("ixYrr");
const $1a035cb2d3f2c948$var$redirect = ()=>{
    const identity = (0, $bW292.getATLContextDomain)('id');
    // Hardcoding to Jira as this will be the only adopter of this service for now.
    const redirectUrl = `https://${identity}/login?application=jira&continue=${encodeURIComponent(window.location.href)}`;
    window.location.assign(redirectUrl);
};
// Silence error logs from queries in this list
const $1a035cb2d3f2c948$var$blocklist = [
    'issueAggQuery'
];
const $1a035cb2d3f2c948$export$9dec0f42cc67f6ab = (queryName, operationKind)=>{
    if (operationKind === 'query') return 0, $3lpdA.RETRY_ATTEMPTS_LIMIT;
    return 0;
};
const $1a035cb2d3f2c948$var$getTraceIdFromExtensions = ({ extensions: extensions })=>{
    if (extensions !== undefined && extensions.gateway !== undefined && extensions.gateway !== null && typeof extensions.gateway.request_id === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return extensions.gateway.request_id;
    return undefined;
};
/**
 * Given a set of options, produce a new set of options for consumption which contains
 * a combination of the given set and the default options
 * @param {RequestOptions} options
 * @returns RequestOptions
 */ const $1a035cb2d3f2c948$var$generateOptions = (options = {})=>{
    // the token fetcher returns undefined if no cookie value was found, also in SSR cookies are unavailable
    const csrfToken = !false ? (0, $5zSUY.default)() : undefined;
    // If we don't get a token, there is no point trying to add the csrf header
    const csrfTokenHeader = (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(csrfToken) ? {} : {
        'atl-xsrf-token': csrfToken
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, {
        // We have to provide general options here or the headers we provide will override the default ones found
        // here /src/packages/platform/utils/fetch/src/utils/requests.js due to a shallow merge
        ...(0, $fVqUX.default),
        ...options
    }, {
        headers: {
            'atl-client-name': 'jira-frontend',
            'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
            'X-ExperimentalApi': (0, $7GiRY.default).join(','),
            ...csrfTokenHeader
        }
    });
};
const $1a035cb2d3f2c948$var$checkAuthentication = ()=>{
    if ((0, $XHGTv.getBooleanFF)('platform.mdt-zora.use-heartbeat-singleton_vzod3')) {
        if (!false) {
            const heartbeatService = (0, $eTIsH.getInstance)();
            if (heartbeatService.isInitialized() && !heartbeatService.isAuthenticated()) $1a035cb2d3f2c948$var$redirect();
        }
    }
};
const $1a035cb2d3f2c948$export$7bfea3c3d460ecd8 = (error)=>{
    if (error instanceof (0, $7byHA.default)) return [
        502,
        503,
        504
    ].includes(error.statusCode);
    return false;
};
const $1a035cb2d3f2c948$export$e7aa7bc5c1b3cfb3 = (request, variables, cacheConfig)=>{
    $1a035cb2d3f2c948$var$checkAuthentication();
    const { name: queryName, operationKind: operationKind } = request;
    const earlyScriptPromise = !false && (0, $8tomX.claimEarlyScriptPromise)((0, $8tomX.getEarlyScriptPromiseKey)(request, variables)) || undefined;
    const loggingMetadata = {
        queryName: queryName,
        operationKind: operationKind
    };
    const loggingAndMetrics = (0, $ixYrr.getLoggingAndMetricsHelper)(loggingMetadata);
    return (0, $cNy9K.Observable).create((sink)=>{
        try {
            const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
            const endpoint = (0, $cmqZo.getAggEndpoint)(request, cacheConfig);
            const body = (0, $cmqZo.getRequestBody)(request, variables);
            let ssrCache = null;
            if (!false && requestID != null) ssrCache = (0, $j7fph.QueryResponseCache).get(requestID, variables);
            // On client read cache from window.SPA_STATE if available
            if (!false && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(ssrCache)) {
                sink.next(ssrCache);
                if (requestID != null) (0, $j7fph.QueryResponseCache).delete(requestID, variables);
                sink.complete();
                return;
            }
            const wrappedEarlyScriptPromise = earlyScriptPromise && (0, $3lpdA.retryOnError)(()=>(0, $lRmyA.applyErrorHandling)(earlyScriptPromise), {
                retryFunc: ()=>(0, $lRmyA.performPostRequest)(endpoint, $1a035cb2d3f2c948$var$generateOptions({
                        body: body
                    })),
                retryPredicate: $1a035cb2d3f2c948$export$7bfea3c3d460ecd8,
                retryAttempts: $1a035cb2d3f2c948$export$9dec0f42cc67f6ab(queryName, operationKind),
                onRetry: loggingAndMetrics.logErrorRetry
            });
            // Throws HttpError
            const promise = !false && wrappedEarlyScriptPromise !== undefined ? wrappedEarlyScriptPromise : Promise.resolve((0, $lRmyA.performPostRequestWithRetry)(endpoint, {
                ...$1a035cb2d3f2c948$var$generateOptions({
                    body: body
                }),
                retryPredicate: $1a035cb2d3f2c948$export$7bfea3c3d460ecd8,
                retryAttempts: $1a035cb2d3f2c948$export$9dec0f42cc67f6ab(queryName, operationKind),
                onRetry: (error, attempt)=>{
                    loggingAndMetrics.logErrorRetry(error, attempt);
                }
            }));
            promise.then((response)=>{
                (0, $5udmX.addTraceId)(queryName, $1a035cb2d3f2c948$var$getTraceIdFromExtensions(response));
                (0, $2n6bs.putExtensions)(queryName, response.extensions);
                // @ts-expect-error - TS2339 - Property 'errors' does not exist on type 'GraphQLSingularResponse'.
                const errors = response.errors || undefined;
                if (errors != null) {
                    const requestId = response?.extensions?.gateway?.request_id;
                    if (!$1a035cb2d3f2c948$var$blocklist.includes(queryName)) loggingAndMetrics.logNonBreakingErrors(errors, requestId);
                    (0, $15ZJO.captureErrors)(errors, {
                        operationName: queryName,
                        requestId: requestId
                    });
                    if ((0, $15ZJO.isUnauthenticated)(errors)) {
                        //  Short circuit operation and handle the unauthorized errors.
                        (0, $iuC8B.showUnauthenticatedFlag)(queryName);
                        return;
                    }
                }
                if (response.data && response.data.jira === null) // Enforce non-nullability of the jira namespace. This is an intermediary solution to
                // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
                // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
                // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Data
                response.data = null;
                // cache query response on SSR
                if (false && requestID != null) (0, $j7fph.QueryResponseCache).setWithMetadata(requestID, variables, response, loggingMetadata);
                sink.next(response);
                sink.complete();
            })// We don't await the promise so the catch block below is never
            // triggered so we need an independent catch on the promise
            .catch((error)=>{
                loggingAndMetrics.logError(error);
                sink.error(error);
            });
            if (requestID != null) (0, $c7ifG.QueryPromisesMap).set(requestID, promise);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            loggingAndMetrics.logError(error);
            sink.error(error);
        }
    });
};

});
parcelRegister("lRmyA", function(module, exports) {

$parcel$export(module.exports, "transformValidationErrorFromServer", () => $ec20d578245eedba$export$8e9baed7697e4959);
$parcel$export(module.exports, "applyErrorHandling", () => $ec20d578245eedba$export$e174dc943a170ff);
$parcel$export(module.exports, "performGetRequest", () => $ec20d578245eedba$export$4a53ae1be8ec80c7);
$parcel$export(module.exports, "performPutRequest", () => $ec20d578245eedba$export$9ead1f9103e6de6b);
$parcel$export(module.exports, "performPostRequest", () => $ec20d578245eedba$export$692a4d9808143175);
$parcel$export(module.exports, "performDeleteRequest", () => $ec20d578245eedba$export$8ef51cba9d28f819);
$parcel$export(module.exports, "performPatchRequest", () => $ec20d578245eedba$export$52be6ab13d7e758d);
$parcel$export(module.exports, "performGetRequestWithRetry", () => $ec20d578245eedba$export$659b5ee69e6eb976);
$parcel$export(module.exports, "performPutRequestWithRetry", () => $ec20d578245eedba$export$d7b48b2904a5d812);
$parcel$export(module.exports, "performPostRequestWithRetry", () => $ec20d578245eedba$export$a5717cbee13f28b7);

var $fVqUX = parcelRequire("fVqUX");


var $1ybV0 = parcelRequire("1ybV0");

var $gZ48R = parcelRequire("gZ48R");

var $7byHA = parcelRequire("7byHA");

var $etaBp = parcelRequire("etaBp");

var $3lpdA = parcelRequire("3lpdA");

var $jxATW = parcelRequire("jxATW");
/**
 * Transform object with field errors from JIRA to an array of FieldValidationErrors
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ec20d578245eedba$var$transformFieldErrorsFromServer = (fieldErrors)=>Object.keys(fieldErrors).map((field)=>({
            field: field,
            error: fieldErrors[field]
        }));
const $ec20d578245eedba$export$8e9baed7697e4959 = (json, statusCode, traceId)=>{
    const message = json.errorMessages ? json.errorMessages.join('; ') : 'validation failed';
    const fieldErrorsJson = json.errors ?? json.fieldErrors;
    const fieldErrors = fieldErrorsJson ? $ec20d578245eedba$var$transformFieldErrorsFromServer(fieldErrorsJson) : [];
    return new (0, $7byHA.ValidationError)(message, fieldErrors, statusCode, traceId);
};
const $ec20d578245eedba$var$putOptions = {
    ...(0, $fVqUX.default),
    method: 'PUT'
};
const $ec20d578245eedba$var$postOptions = {
    ...(0, $fVqUX.default),
    method: 'POST'
};
const $ec20d578245eedba$var$deleteOptions = {
    ...(0, $fVqUX.default),
    method: 'DELETE'
};
const $ec20d578245eedba$var$patchOptions = {
    ...(0, $fVqUX.default),
    method: 'PATCH'
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ec20d578245eedba$var$handleNetworkErrors = (err)=>{
    if (err instanceof TypeError) throw new Error('Failed to fetch', {
        cause: err
    });
    throw err;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ec20d578245eedba$var$handleErrors = (response)=>{
    const traceId = (0, $jxATW.getTraceId)(response);
    // CONTENT_TOO_LARGE errorMessage is used for Hard Limits and, we don't want to override the error message
    if ((0, $1c3fbb431a173cc6$export$9de493bcd9b1d977) === response.status || (0, $1ybV0.ff)('issue.details.hard-limits.milestone-1') && (0, $1c3fbb431a173cc6$export$f90ac1df0b60853d) === response.status) return response.json().then((errorContent)=>{
        throw $ec20d578245eedba$export$8e9baed7697e4959(errorContent, response.status, traceId);
    });
    if (!response.ok) {
        if (traceId !== undefined && traceId.length > 0) {
            if ((0, $1ybV0.ff)('enable-returning-the-original-response_xn2bj')) throw new (0, $7byHA.default)(response.status, `Error server response: ${response.status}`, traceId, response);
            else throw new (0, $7byHA.default)(response.status, `Error server response: ${response.status}`, traceId);
        } else {
            // eslint-disable-next-line no-lonely-if
            if ((0, $1ybV0.ff)('enable-returning-the-original-response_xn2bj')) throw new (0, $7byHA.default)(response.status, `Error server response: ${response.status}`, undefined, response);
            else throw new (0, $7byHA.default)(response.status, `Error server response: ${response.status}`);
        }
    }
    return response;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ec20d578245eedba$var$processResponseFromServer = (response)=>{
    if (response.status === (0, $1c3fbb431a173cc6$export$3288b14b6745c572)) return Promise.resolve(null);
    return response.text().then((text)=>text ? JSON.parse(text) : null);
};
const $ec20d578245eedba$export$e174dc943a170ff = (responsePromise)=>responsePromise.then($ec20d578245eedba$var$handleErrors).then($ec20d578245eedba$var$processResponseFromServer).catch($ec20d578245eedba$var$handleNetworkErrors);
const $ec20d578245eedba$export$22411cbfb09a5c5c = (url, options)=>{
    const { retryPredicate: retryPredicate, retryAttempts: retryAttempts, onRetry: onRetry, ...requestOptions } = options;
    const executeRequest = ()=>$ec20d578245eedba$export$e174dc943a170ff(fetch(url, (0, $etaBp.applyObservabilityHeaders)(url, requestOptions)));
    if ((0, $gZ48R.default)('platform_fetch_retries')) return executeRequest();
    return (0, $3lpdA.retryOnError)(executeRequest, {
        retryFunc: executeRequest,
        retryPredicate: retryPredicate,
        retryAttempts: retryAttempts,
        onRetry: onRetry
    });
};
const $ec20d578245eedba$export$4a53ae1be8ec80c7 = (url, options = {})=>fetch(url, (0, $etaBp.applyObservabilityHeaders)(url, {
        ...(0, $fVqUX.default),
        ...options
    })).then($ec20d578245eedba$var$handleErrors).then($ec20d578245eedba$var$processResponseFromServer).catch($ec20d578245eedba$var$handleNetworkErrors);
const $ec20d578245eedba$export$9ead1f9103e6de6b = (url, options = {})=>fetch(url, (0, $etaBp.applyObservabilityHeaders)(url, {
        ...$ec20d578245eedba$var$putOptions,
        ...options
    })).then($ec20d578245eedba$var$handleErrors).then($ec20d578245eedba$var$processResponseFromServer).catch($ec20d578245eedba$var$handleNetworkErrors);
const $ec20d578245eedba$export$692a4d9808143175 = (url, options = {})=>fetch(url, (0, $etaBp.applyObservabilityHeaders)(url, {
        ...$ec20d578245eedba$var$postOptions,
        ...options
    })).then($ec20d578245eedba$var$handleErrors).then($ec20d578245eedba$var$processResponseFromServer).catch($ec20d578245eedba$var$handleNetworkErrors);
const $ec20d578245eedba$export$8ef51cba9d28f819 = (url, options = {})=>fetch(url, (0, $etaBp.applyObservabilityHeaders)(url, {
        ...$ec20d578245eedba$var$deleteOptions,
        ...options
    })).then($ec20d578245eedba$var$handleErrors).then($ec20d578245eedba$var$processResponseFromServer).catch($ec20d578245eedba$var$handleNetworkErrors);
const $ec20d578245eedba$export$52be6ab13d7e758d = (url, options = {})=>fetch(url, (0, $etaBp.applyObservabilityHeaders)(url, {
        ...$ec20d578245eedba$var$patchOptions,
        ...options
    })).then($ec20d578245eedba$var$handleErrors).then($ec20d578245eedba$var$processResponseFromServer).catch($ec20d578245eedba$var$handleNetworkErrors);
const $ec20d578245eedba$export$659b5ee69e6eb976 = (url, options)=>$ec20d578245eedba$export$22411cbfb09a5c5c(url, {
        ...(0, $fVqUX.default),
        ...options
    });
const $ec20d578245eedba$export$d7b48b2904a5d812 = (url, options)=>$ec20d578245eedba$export$22411cbfb09a5c5c(url, {
        ...$ec20d578245eedba$var$putOptions,
        ...options
    });
const $ec20d578245eedba$export$a5717cbee13f28b7 = (url, options)=>$ec20d578245eedba$export$22411cbfb09a5c5c(url, {
        ...$ec20d578245eedba$var$postOptions,
        ...options
    });
const $ec20d578245eedba$export$6d01bf1146815b9b = (url, options)=>$ec20d578245eedba$export$22411cbfb09a5c5c(url, {
        ...$ec20d578245eedba$var$deleteOptions,
        ...options
    });
const $ec20d578245eedba$export$560989ee94ad2a20 = (url, options)=>$ec20d578245eedba$export$22411cbfb09a5c5c(url, {
        ...$ec20d578245eedba$var$patchOptions,
        ...options
    });

});
const $1c3fbb431a173cc6$export$ff39ebd4bb12b718 = 201;
const $1c3fbb431a173cc6$export$3288b14b6745c572 = 204;
const $1c3fbb431a173cc6$export$9de493bcd9b1d977 = 400;
const $1c3fbb431a173cc6$export$67d19e9a991baa07 = 401;
const $1c3fbb431a173cc6$export$a3269a3914b007e3 = 403;
const $1c3fbb431a173cc6$export$8bca792d963eb0ef = 404;
const $1c3fbb431a173cc6$export$4a3cb39801694eee = 407;
const $1c3fbb431a173cc6$export$fa405bbf47d510e2 = 408;
const $1c3fbb431a173cc6$export$c09e7ea0fc79f34f = 409;
const $1c3fbb431a173cc6$export$5244030134e99 = 412;
const $1c3fbb431a173cc6$export$f90ac1df0b60853d = 413;
const $1c3fbb431a173cc6$export$a447d0a965e16776 = 422;
const $1c3fbb431a173cc6$export$3b48aba8957000cd = 426;
const $1c3fbb431a173cc6$export$6763168a631449a2 = 429;
const $1c3fbb431a173cc6$export$e813cd7045fcc98d = 500;
const $1c3fbb431a173cc6$export$2ce38d41a306034e = 502;
const $1c3fbb431a173cc6$export$974c37534b0191b1 = 503;
const $1c3fbb431a173cc6$export$5400e8dddac3fcf3 = 504;

parcelRegister("3lpdA", function(module, exports) {

$parcel$export(module.exports, "RETRY_ATTEMPTS_LIMIT", () => $689a3993c77053c8$export$81189edc9b923717);
$parcel$export(module.exports, "retryOnError", () => $689a3993c77053c8$export$f859c88bfac2cf2c);
const $689a3993c77053c8$export$81189edc9b923717 = 1;
const $689a3993c77053c8$export$f859c88bfac2cf2c = (initialPromiseGetter, { retryFunc: retryFunc, retryPredicate: retryPredicate, retryAttempts: retryAttempts = $689a3993c77053c8$export$81189edc9b923717, onRetry: onRetry })=>{
    // Eventually we might like to make max attempts configurable.
    // To do so, we'll need to support jitter & exponential back-off
    const maxAttempts = retryAttempts > $689a3993c77053c8$export$81189edc9b923717 ? $689a3993c77053c8$export$81189edc9b923717 : retryAttempts;
    const execute = async (getPromise, retryAttempt = 0)=>{
        try {
            return await getPromise();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // If no retry predicate is passed, retry on every error
            const shouldAttemptRetry = retryPredicate ? retryPredicate(error) : true;
            if (retryAttempt < maxAttempts && shouldAttemptRetry) {
                onRetry && onRetry(error, retryAttempt + 1);
                return execute(retryFunc, retryAttempt + 1);
            }
            throw error;
        }
    };
    return execute(initialPromiseGetter);
};

});


parcelRegister("15ZJO", function(module, exports) {

$parcel$export(module.exports, "startCaptureGraphQlErrors", () => $2d32667fee5bd79d$export$c211170518c6d0f6);
$parcel$export(module.exports, "stopCaptureGraphQlErrors", () => $2d32667fee5bd79d$export$e0491a0d974dadfa);
$parcel$export(module.exports, "captureErrors", () => $2d32667fee5bd79d$export$7a973c0ff390eb47);
$parcel$export(module.exports, "isUnauthenticated", () => $2d32667fee5bd79d$export$1724ecfee73c4768);
/**
 * Utility methods to capture GraphQl errors and expose them to the frontend for reporting.
 * ```
 * Sample usage:
 * const id = startErrorCapture();
 * ...
 * const errors = stopErrorCapture(id);
 * ```
 */ 
var $hompL = parcelRequire("hompL");
const $2d32667fee5bd79d$var$errorCollector = new Map();
const $2d32667fee5bd79d$export$da396ad2a542b095 = 120000; // 2min
const $2d32667fee5bd79d$var$scheduleCleanup = (key)=>{
    setTimeout(()=>{
        $2d32667fee5bd79d$var$errorCollector.delete(key);
    }, $2d32667fee5bd79d$export$da396ad2a542b095);
};
const $2d32667fee5bd79d$export$c211170518c6d0f6 = (key = (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4())=>{
    $2d32667fee5bd79d$var$errorCollector.set(key, []);
    $2d32667fee5bd79d$var$scheduleCleanup(key);
    return key;
};
const $2d32667fee5bd79d$export$e0491a0d974dadfa = (key)=>{
    const errors = $2d32667fee5bd79d$var$errorCollector.get(key);
    $2d32667fee5bd79d$var$errorCollector.delete(key);
    return errors || [];
};
const $2d32667fee5bd79d$export$7a973c0ff390eb47 = (errors, meta)=>{
    if (errors) $2d32667fee5bd79d$var$errorCollector.forEach((value, key)=>{
        $2d32667fee5bd79d$var$errorCollector.set(key, [
            ...value,
            {
                errors: errors,
                meta: meta
            }
        ]);
    });
};
const $2d32667fee5bd79d$export$1724ecfee73c4768 = (errors)=>{
    if (errors.length > 0) return errors.some((error)=>error.message.startsWith('Auth category: UNAUTHENTICATED'));
    return false;
};

});

parcelRegister("7GiRY", function(module, exports) {

$parcel$export(module.exports, "default", () => $a04fa54516e5a2d1$export$2e2bcd8739ae039);
// Please add your Experimental API name below
// You do not need to wait for approval to add to this list
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $a04fa54516e5a2d1$export$2e2bcd8739ae039 = [
    'ariGraph',
    'boardCardMove',
    'deleteCard',
    'JiraJqlBuilder',
    'SoftwareCardTypeTransitions',
    'jira-releases-v0',
    'JiraDevOps',
    'JiraDevOpsProviders',
    'createCustomFilter',
    'updateCustomFilter',
    'deleteCustomFilter',
    'customFilters',
    'PermissionScheme',
    'JiraIssue',
    'projectStyle',
    'startSprintPrototype',
    'AddIssuesToFixVersion',
    'JiraVersionResult',
    'JiraIssueConnectionJql',
    'JiraFieldOptionSearching',
    'JiraIssueFieldMutations',
    'JiraIssueDevInfoDetails',
    'JiraIssueDevSummaryCache',
    'JiraVersionWarningConfig',
    'JiraReleaseNotesConfiguration',
    'JiraUpdateReleaseNotesConfiguration',
    'ReleaseNotes',
    'ReleaseNotesOptions',
    'DeploymentsFeaturePrecondition',
    'UpdateVersionWarningConfig',
    'UpdateVersionName',
    'UpdateVersionDescription',
    'UpdateVersionStartDate',
    'UpdateVersionReleaseDate',
    'VersionsForProject',
    'RelatedWork',
    'SuggestedRelatedWorkCategories',
    'setIssueMediaVisibility',
    'toggleBoardFeature',
    'DevOpsProvider',
    'DevOpsSummarisedDeployments',
    'virtual-agent-beta',
    'JiraProject',
    'DevOpsSummarisedEntities',
    'RoadmapsMutation',
    'RoadmapsQuery',
    'JiraApplicationProperties',
    'JiraIssueSearch',
    'JiraFilter',
    'featureGroups',
    'setBoardEstimationType',
    'devOps',
    'softwareBoards',
    'name',
    'AddRelatedWorkToVersion',
    'RemoveRelatedWorkFromVersion',
    'admins',
    'canAdministerBoard',
    'jql',
    'globalCardCreateAdditionalFields',
    'GlobalTimeTrackingSettings',
    'ReleaseNotesOptions',
    'search-experience',
    'MoveOrRemoveIssuesToFixVersion',
    'compass-beta',
    'JiraIssueSearchStatus',
    'Townsquare',
    'JiraNavigationItems',
    'JiraVersionsForProjects',
    'columnConfigs'
];

});

parcelRegister("c7ifG", function(module, exports) {

$parcel$export(module.exports, "QueryPromisesMap", () => $a238ea58a6cce413$export$607b80f5bc6e396d);
const $a238ea58a6cce413$export$607b80f5bc6e396d = new Map();

});

parcelRegister("j7fph", function(module, exports) {

$parcel$export(module.exports, "QueryResponseCache", () => $12adf5474a181883$export$688bd21be71b9e5d);

var $9LXG4 = parcelRequire("9LXG4");

var $illlw = parcelRequire("illlw");

var $cNy9K = parcelRequire("cNy9K");

var $gUUjF = parcelRequire("gUUjF");

var $7EhAs = parcelRequire("7EhAs");

var $9jJAD = parcelRequire("9jJAD");
function $12adf5474a181883$export$611736262b635f8d(queryID, variables) {
    return JSON.stringify((0, $cNy9K.stableCopy)({
        queryID: queryID,
        variables: variables
    }));
}
function $12adf5474a181883$export$1e65e863cf3a0f21(cacheKey) {
    return JSON.parse(cacheKey).queryID;
}
class $12adf5474a181883$export$be21c283b097d175 extends (0, $cNy9K.QueryResponseCache) {
    constructor({ cacheName: cacheName, size: size, ttl: ttl }){
        super({
            size: size,
            ttl: ttl
        });
        const cachedData = false ? {} : window?.SPA_STATE?.[cacheName] || {};
        this.cacheName = cacheName;
        this.requestMetadata = new Map(cachedData.requestMetadata);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        this._responses = new Map(cachedData.responses);
        if (!false) setTimeout(()=>{
            this.logUnusedPayloadErrors();
            // cleanup leftover data to reduce unnecessary memory usage
            this.requestMetadata.clear();
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            this._responses.clear();
        }, 60000 /* 1 minute */ );
    }
    logUnusedPayloadErrors() {
        const loggedQueries = new Set();
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'. | TS7006 - Parameter 'response' implicitly has an 'any' type. | TS7006 - Parameter 'key' implicitly has an 'any' type.
        this._responses.forEach((response, key)=>{
            const queryID = $12adf5474a181883$export$1e65e863cf3a0f21(key);
            const metadata = this.requestMetadata.get(queryID);
            const { queryName: queryName = 'unknown', operationKind: operationKind = 'unknown' } = metadata ?? {
                queryName: 'unknown',
                operationKind: 'unknown'
            };
            if (!loggedQueries.has(queryName)) {
                loggedQueries.add(queryName);
                const error = new (0, $9jJAD.UnusedRelayResponseError)(queryID);
                const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
                    'statusCode'
                ], null);
                const errorType = error instanceof (0, $7EhAs.default) ? 'network' : 'unknown';
                // Log any errors even in SSR
                (0, $gUUjF.default).safeErrorWithoutCustomerData('relay.AGG.error.graphql', `[${errorType} error]`, {
                    message: `[${(0, (/*@__PURE__*/$parcel$interopDefault($9LXG4)))(errorType)} error]: ${error?.message ?? ''}`,
                    errorType: errorType,
                    statusCode: statusCode,
                    queryName: queryName,
                    operationKind: operationKind,
                    errorName: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
                        'name'
                    ], null)
                });
            }
        });
    }
    setWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        this.set(queryID, variables, payload);
    }
    /**
	 * Deletes a request from the store, if found.
	 *
	 * IMPORTANT: Make sure DELETE method always has tests that include get/set
	 * to ensure our `getCacheKey` matches Relay's.
	 *
	 * @returns {boolean} indicating if an entry in the cache was deleted
	 */ delete(queryID, variables) {
        const cacheKey = $12adf5474a181883$export$611736262b635f8d(queryID, variables);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        return this._responses.delete(cacheKey);
    }
    serialize() {
        return {
            [this.cacheName]: {
                // @ts-expect-error - TS2322 - Type '{ [x: string]: { requestMetadata: [string, RequestMetadata][]; responses: unknown[]; }; }' is not assignable to type 'Partial<Record<string, [string, GraphQLResponse][]>>'.
                requestMetadata: Array.from(this.requestMetadata.entries()),
                // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
                responses: Array.from(this._responses.entries())
            }
        };
    }
}
const $12adf5474a181883$export$688bd21be71b9e5d = new $12adf5474a181883$export$be21c283b097d175({
    cacheName: 'relay-cache/v2/AGG',
    size: Infinity,
    ttl: Infinity
});
const $12adf5474a181883$export$94e535e06b7ade61 = ()=>$12adf5474a181883$export$688bd21be71b9e5d.serialize();

});
parcelRegister("9jJAD", function(module, exports) {

$parcel$export(module.exports, "UnusedRelayResponseError", () => $1b0cdf803f3ea26f$export$8431e42d062de453);
class $1b0cdf803f3ea26f$export$8431e42d062de453 extends Error {
    constructor(queryID){
        super(`Relay Query ${queryID} was made during SSR but never used in the browser`);
        this.name = 'UnusedRelayResponseError';
    }
}

});


parcelRegister("8tomX", function(module, exports) {

$parcel$export(module.exports, "getEarlyScriptPromiseKey", () => $da6663b8ee5823ed$export$1102c06c7da91223);
$parcel$export(module.exports, "claimEarlyScriptPromise", () => $da6663b8ee5823ed$export$828ac0325bce4536);
$parcel$export(module.exports, "earlyFetch", () => $da6663b8ee5823ed$export$5b55058781674413);

var $lLasf = parcelRequire("lLasf");

var $cmqZo = parcelRequire("cmqZo");

var $1qnta = parcelRequire("1qnta");
const $da6663b8ee5823ed$export$b5fbc1430cbfd6e1 = (value)=>value;
const $da6663b8ee5823ed$export$6d670d323806bb37 = new Map();
const $da6663b8ee5823ed$export$1102c06c7da91223 = (params, variables)=>{
    const queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
    const serializedVariables = variables != null ? JSON.stringify(variables, Object.keys(variables).sort()) : '';
    return `${params.name}|${String(queryId)}|${serializedVariables}`;
};
const $da6663b8ee5823ed$export$828ac0325bce4536 = (key)=>{
    const result = $da6663b8ee5823ed$export$6d670d323806bb37.get(key);
    if (result != null) $da6663b8ee5823ed$export$6d670d323806bb37.delete(key);
    return result;
};
const $da6663b8ee5823ed$export$e1336d32be02faf4 = (key, promise)=>{
    if (!$da6663b8ee5823ed$export$6d670d323806bb37.has(key)) $da6663b8ee5823ed$export$6d670d323806bb37.set(key, promise);
};
const $da6663b8ee5823ed$export$5b55058781674413 = (compiledQuery, variables, experimentalApis = [])=>{
    (0, $lLasf.setMark)('jira.fe-spa.early-preload:start');
    const endpoint = (0, $cmqZo.getAggEndpoint)(compiledQuery.params);
    const body = (0, $cmqZo.getRequestBody)(compiledQuery.params, variables);
    $da6663b8ee5823ed$export$e1336d32be02faf4($da6663b8ee5823ed$export$1102c06c7da91223(compiledQuery.params, variables), fetch(endpoint, {
        credentials: 'same-origin',
        headers: {
            'atl-client-name': 'jira-frontend',
            'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
            'Content-Type': 'application/json',
            Accept: 'application/json,text/javascript,*/*',
            'X-ExperimentalApi': experimentalApis.join(','),
            ...(0, $1qnta.getActiveTraceHttpRequestHeaders)(endpoint)
        },
        method: 'POST',
        body: body
    }).then((response)=>{
        (0, $lLasf.setMark)('jira.fe-spa.early-preload:end');
        return response;
    }));
};

});
parcelRegister("lLasf", function(module, exports) {

$parcel$export(module.exports, "setMark", () => $bbbf8be69ced3a7f$export$f7a1fb90d8604165);
$parcel$export(module.exports, "getTraceId", () => $bbbf8be69ced3a7f$export$e88cb5bfb57ce9c4);

var $iNkad = parcelRequire("iNkad");
const $bbbf8be69ced3a7f$export$f7a1fb90d8604165 = (mark)=>{
    if (typeof performance !== 'object' || typeof performance.mark !== 'function') return;
    performance.mark(mark);
};
const $bbbf8be69ced3a7f$var$TRACE_ID_HEADER = 'atl-traceid';
const $bbbf8be69ced3a7f$var$TRACE_ID_HEADER_MICROS = 'x-trace-id';
const $bbbf8be69ced3a7f$export$e88cb5bfb57ce9c4 = (response)=>response.headers.get($bbbf8be69ced3a7f$var$TRACE_ID_HEADER) || response.headers.get($bbbf8be69ced3a7f$var$TRACE_ID_HEADER_MICROS);

});
parcelRegister("iNkad", function(module, exports) {

$parcel$export(module.exports, "FetchError", () => $623bd65186ba0714$export$26e841bcf1aeb894);
/* eslint-disable max-classes-per-file */ 
var $1ybV0 = parcelRequire("1ybV0");
class $623bd65186ba0714$var$ExtensibleError extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(message, options){
        super(message, options);
        this.message = message;
        this.name = this.constructor.name;
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        else this.stack = new Error(message).stack;
    }
}
class $623bd65186ba0714$export$26e841bcf1aeb894 extends $623bd65186ba0714$var$ExtensibleError {
    constructor(statusCode, message, traceId){
        super(message == null ? `Fetch call failed with status code: ${statusCode}` : message);
        this.graphQLErrors = [];
        this.name = 'FetchError';
        this.statusCode = statusCode;
        this.networkError = {
            statusCode: statusCode
        };
        if (traceId != null) this.traceId = traceId;
        if ((0, $1ybV0.ff)('jsw.board-backlog.skip-sentry-for-fetch-error')) this.skipSentry = true;
    }
}

});



parcelRegister("iuC8B", function(module, exports) {

$parcel$export(module.exports, "showUnauthenticatedFlag", () => $768eb5f0fcd8b90f$export$758fcc357484571e);

var $k8Qyf = parcelRequire("k8Qyf");

var $3FyZ4 = parcelRequire("3FyZ4");

var $glrJM = parcelRequire("glrJM");
const $768eb5f0fcd8b90f$var$reloadPage = ()=>window.location.reload();
const $768eb5f0fcd8b90f$var$sendAnalyticEvent = (operationName)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        const analyticsClient = client.getInstance();
        if (!analyticsClient) return;
        analyticsClient.sendTrackEvent({
            action: 'showed',
            actionSubject: 'unauthorizedFlag',
            attributes: {
                operation: operationName
            },
            source: 'jiraRelayFetch'
        });
    });
};
const $768eb5f0fcd8b90f$export$758fcc357484571e = (operationName)=>{
    (0, $k8Qyf.showFlag)({
        type: 'error',
        title: (0, $glrJM.default).title,
        description: (0, $glrJM.default).description,
        actions: [
            {
                content: (0, $glrJM.default).login,
                onClick: $768eb5f0fcd8b90f$var$reloadPage
            }
        ]
    });
    $768eb5f0fcd8b90f$var$sendAnalyticEvent(operationName);
};

});
parcelRegister("k8Qyf", function(module, exports) {

$parcel$export(module.exports, "showFlag", () => $eeec0389d5aa91e2$export$e12b2cc6b75b006b);
$parcel$export(module.exports, "dismissFlag", () => $eeec0389d5aa91e2$export$900a08a292ad23cd);
$parcel$export(module.exports, "flagService", () => $eeec0389d5aa91e2$export$dbb055af53fd81a0);
$parcel$export(module.exports, "useFlagsService", () => $eeec0389d5aa91e2$export$eee61a1aafe3884);
$parcel$export(module.exports, "useFlagService", () => $eeec0389d5aa91e2$export$dc4f8132c3090b32);
$parcel$export(module.exports, "isDismissFlag", () => $eeec0389d5aa91e2$export$14b1864d9cf0809f);
$parcel$export(module.exports, "isFlagComponent", () => $eeec0389d5aa91e2$export$d84ce5adcee46025);
$parcel$export(module.exports, "isBatchAction", () => $eeec0389d5aa91e2$export$c126d8b307b8ab86);

var $8vPhU = parcelRequire("8vPhU");

var $bbbyK = parcelRequire("bbbyK");

var $lawuT = parcelRequire("lawuT");

var $eo17r = parcelRequire("eo17r");
const $eeec0389d5aa91e2$export$e12b2cc6b75b006b = (0, $bbbyK.default)((0, $lawuT.store).dispatch);
const $eeec0389d5aa91e2$export$900a08a292ad23cd = (0, $8vPhU.default)((0, $lawuT.store).dispatch);
const $eeec0389d5aa91e2$var$dismissFlagById = (id)=>{
    $eeec0389d5aa91e2$export$900a08a292ad23cd((0, $8vPhU.dismissFlag)(id));
};
const $eeec0389d5aa91e2$var$hasFlag = (id)=>Boolean((0, $lawuT.store).getState().flags.find((flagInstance)=>'id' in flagInstance.flag && flagInstance.flag.id === id));
const $eeec0389d5aa91e2$export$dbb055af53fd81a0 = {
    showFlag: $eeec0389d5aa91e2$export$e12b2cc6b75b006b,
    dismissFlag: $eeec0389d5aa91e2$export$900a08a292ad23cd
};
const $eeec0389d5aa91e2$export$eee61a1aafe3884 = ()=>({
        showFlag: $eeec0389d5aa91e2$export$e12b2cc6b75b006b,
        dismissFlag: $eeec0389d5aa91e2$var$dismissFlagById,
        hasFlag: $eeec0389d5aa91e2$var$hasFlag
    });
const $eeec0389d5aa91e2$export$dc4f8132c3090b32 = ()=>$eeec0389d5aa91e2$export$dbb055af53fd81a0;
const $eeec0389d5aa91e2$export$14b1864d9cf0809f = (flag)=>typeof flag === 'object' && 'command' in flag && flag.command === (0, $eo17r.DISMISS_COMMAND);
const $eeec0389d5aa91e2$export$d84ce5adcee46025 = (flag)=>typeof flag === 'function' && !('type' in flag) && !('render' in flag);
const $eeec0389d5aa91e2$export$cd5f9f2b991b82d9 = (flag)=>typeof flag === 'object' && 'render' in flag && typeof flag.render === 'function';
const $eeec0389d5aa91e2$export$63ffd7d99470afd4 = (flag)=>!$eeec0389d5aa91e2$export$14b1864d9cf0809f(flag) && !$eeec0389d5aa91e2$export$d84ce5adcee46025(flag) && !$eeec0389d5aa91e2$export$cd5f9f2b991b82d9(flag);
const $eeec0389d5aa91e2$export$c126d8b307b8ab86 = (action)=>'meta' in action && action.meta && action.meta.batch && 'payload' in action && Array.isArray(action.payload);

});
parcelRegister("8vPhU", function(module, exports) {

$parcel$export(module.exports, "dismissFlag", () => $39af67031ab9f922$export$900a08a292ad23cd);
$parcel$export(module.exports, "default", () => $39af67031ab9f922$export$2e2bcd8739ae039);

var $bSS3k = parcelRequire("bSS3k");

var $eo17r = parcelRequire("eo17r");
const $39af67031ab9f922$export$900a08a292ad23cd = (flagId)=>({
        command: (0, $eo17r.DISMISS_COMMAND),
        id: flagId
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$39af67031ab9f922$export$2e2bcd8739ae039 = (dispatch)=>(action)=>{
        dispatch((0, $bSS3k.dismissFlagAction)(action.id));
    };

});
parcelRegister("bSS3k", function(module, exports) {

$parcel$export(module.exports, "SHOW", () => $953f8b1833086611$export$9d04158a25ce4cd);
$parcel$export(module.exports, "show", () => $953f8b1833086611$export$57bf213be019eeb0);
$parcel$export(module.exports, "DISMISS_INSTANCE", () => $953f8b1833086611$export$b31a07d2e6382678);
$parcel$export(module.exports, "dismiss", () => $953f8b1833086611$export$abf286bbe7073aba);
$parcel$export(module.exports, "DISMISS_FLAG", () => $953f8b1833086611$export$1eb56620df104bf);
$parcel$export(module.exports, "dismissFlagAction", () => $953f8b1833086611$export$4818b3c52448050d);
$parcel$export(module.exports, "RESET", () => $953f8b1833086611$export$4a991c87e640ef77);
$parcel$export(module.exports, "reset", () => $953f8b1833086611$export$aad8462122ac592b);
const $953f8b1833086611$export$9d04158a25ce4cd = 'state.SHOW';
const $953f8b1833086611$export$57bf213be019eeb0 = (payload)=>({
        type: $953f8b1833086611$export$9d04158a25ce4cd,
        payload: payload
    });
const $953f8b1833086611$export$b31a07d2e6382678 = 'state.DISMISS_INSTANCE';
const $953f8b1833086611$export$abf286bbe7073aba = (payload)=>({
        type: $953f8b1833086611$export$b31a07d2e6382678,
        payload: payload
    });
const $953f8b1833086611$export$1eb56620df104bf = 'state.DISMISS_FLAG';
const $953f8b1833086611$export$4818b3c52448050d = (payload)=>({
        type: $953f8b1833086611$export$1eb56620df104bf,
        payload: payload
    });
const $953f8b1833086611$export$4a991c87e640ef77 = 'state.RESET';
const $953f8b1833086611$export$aad8462122ac592b = ()=>({
        type: $953f8b1833086611$export$4a991c87e640ef77
    });

});

parcelRegister("eo17r", function(module, exports) {

$parcel$export(module.exports, "DISMISS_COMMAND", () => $2e7952269e32b2ae$export$e705274c5e156b93);
$parcel$export(module.exports, "toFlagId", () => $2e7952269e32b2ae$export$8184bc29de2aea90);
$parcel$export(module.exports, "fromFlagId", () => $2e7952269e32b2ae$export$188cdb77b72629d7);
const $2e7952269e32b2ae$export$e705274c5e156b93 = 'DISMISS';
const $2e7952269e32b2ae$export$8184bc29de2aea90 = (flagId)=>new String(flagId);
const $2e7952269e32b2ae$export$188cdb77b72629d7 = (flagId)=>flagId.valueOf();

});


parcelRegister("bbbyK", function(module, exports) {

$parcel$export(module.exports, "default", () => $7364d7b2414b4fa5$export$2e2bcd8739ae039);

var $hompL = parcelRequire("hompL");

var $bSS3k = parcelRequire("bSS3k");

var $eo17r = parcelRequire("eo17r");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7364d7b2414b4fa5$export$2e2bcd8739ae039 = (dispatch)=>(flag)=>{
        // Flag is of type FlagComponent
        if (typeof flag === 'function') {
            dispatch((0, $bSS3k.show)(flag));
            return undefined;
        }
        const flagId = flag.id || (0, $eo17r.toFlagId)((0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4());
        const newFlag = {
            ...flag,
            id: flagId
        };
        dispatch((0, $bSS3k.show)(newFlag));
        return flagId;
    };

});

parcelRegister("lawuT", function(module, exports) {

$parcel$export(module.exports, "store", () => $58565b45d694aa17$export$6f57813fe9f31bf9);

var $l32oR = parcelRequire("l32oR");
const $58565b45d694aa17$export$6f57813fe9f31bf9 = (0, $l32oR.createStore)();

});
parcelRegister("l32oR", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $ecbe96b78b5bbffc$export$f51a9068ac82ea43);

var $8FRHo = parcelRequire("8FRHo");

var $b7i1H = parcelRequire("b7i1H");
const $ecbe96b78b5bbffc$export$f51a9068ac82ea43 = (rootEpic)=>(0, $8FRHo.default)({
        appName: 'flags',
        rootReducer: $b7i1H.default,
        rootEpic: rootEpic
    });

});
parcelRegister("8FRHo", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cb42e111114ce77$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $huRi7 = parcelRequire("huRi7");

var $MYW4e = parcelRequire("MYW4e");

var $bd1K7 = parcelRequire("bd1K7");

var $lfZsG = parcelRequire("lfZsG");

var $czGdf = parcelRequire("czGdf");

var $jQgix = parcelRequire("jQgix");

var /**
 * Initializes a Redux store with configurations for state management and middleware integration.
 * It addresses serialization challenges with non-serializable entities and enhances debugging capabilities.
 * The custom action listener middleware offers additional control over action dispatches.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$9cb42e111114ce77$export$2e2bcd8739ae039 = ({ appName: appName, rootReducer: rootReducer, initialState: initialState, rootEpic: rootEpic, rootEpicDependencies: rootEpicDependencies, middlewares: middlewares = [], enhancers: enhancers = [] })=>{
    const actionListenerMiddleware = new (0, $jQgix.default)();
    middlewares.push(actionListenerMiddleware.perform);
    if ((0, $lfZsG.debugEnabled)('redux-logger')) {
        // include logger only for development environment
        // eslint-disable-next-line @typescript-eslint/no-require-imports, @typescript-eslint/no-var-requires
        const { logger: logger } = (parcelRequire("iFajX"));
        middlewares.push(logger);
    }
    if (rootEpic) middlewares.push((0, $bd1K7.createEpicMiddleware)(rootEpic, rootEpicDependencies ? {
        dependencies: rootEpicDependencies
    } : undefined));
    const store = (0, $huRi7.createStore)((0, $MYW4e.enableBatching)(rootReducer), initialState, (0, $czGdf.default)({
        name: appName,
        // @ts-expect-error - TS2345 - Argument of type '{ name: string; serialize: { replacer: (key: any, value: any) => any; }; }' is not assignable to parameter of type 'DevtoolsConfig'.
        serialize: {
            // Replacer function is necessary to fix redux-devtools because some actions and state are React Elements
            // and the default serialization gets into a loop in a circular dependency somewhere in internal React properties.
            // https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/API/Arguments.md#serialize
            // @ts-expect-error - TS7006 - Parameter 'key' implicitly has an 'any' type. | TS7006 - Parameter 'value' implicitly has an 'any' type.
            replacer: (key, value)=>{
                if (/*#__PURE__*/ (0, $eUqFw.isValidElement)(value)) {
                    // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'string | JSXElementConstructor<any>'.
                    if (value.type && value.type.displayName) // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'string | JSXElementConstructor<any>'.
                    return `React Element <${value.type.displayName}>`;
                    return 'React Element';
                }
                // The benefit of using React + Redux + declarative API is that there is no more need to save DOM elements in store!
                // ... yet we still do. So when that happens, Redux devtools sometimes crashes because it tries to serialize circular DOM structure.
                if (typeof HTMLElement !== 'undefined' && value instanceof HTMLElement) return `HTMLElement<${value.tagName}>`;
                return value;
            }
        }
    })((0, $huRi7.compose)(...enhancers, (0, $huRi7.applyMiddleware)(...middlewares))));
    store.addActionListener = actionListenerMiddleware.add;
    store.removeActionListener = actionListenerMiddleware.remove;
    return store;
};

});
parcelRegister("lfZsG", function(module, exports) {

$parcel$export(module.exports, "debugEnabled", () => $bd927ad8c0ea4245$export$342c99cc1e9bc5c6);
const $bd927ad8c0ea4245$export$342c99cc1e9bc5c6 = (flag)=>''.split(',').includes(flag);

});

parcelRegister("czGdf", function(module, exports) {

$parcel$export(module.exports, "default", () => $22794e51b2572269$export$2e2bcd8739ae039);

var $huRi7 = parcelRequire("huRi7");
var // An extended version of redux's 'compose' method, that
// will use redux devtools chrome extension if available
// https://github.com/zalmoxisus/redux-devtools-extension
//
// The 'devtoolsConfig' parameter is an object adhering to the following API:
// https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/API/Arguments.md
// eslint-disable-next-line jira/import/no-anonymous-default-export
$22794e51b2572269$export$2e2bcd8739ae039 = (devtoolsConfig = {})=>{
    const devtoolsEnhancer = false ? null : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    const config = {
        ...devtoolsConfig
    };
    if (config.name != null && config.instanceId == null) config.instanceId = config.name;
    return 0, $huRi7.compose;
};

});

parcelRegister("jQgix", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7b4a5dd033617f8$export$2e2bcd8739ae039);
class $a7b4a5dd033617f8$export$2e2bcd8739ae039 {
    constructor(){
        this.listeners = [];
        this.add = (listener)=>{
            this.listeners.push(listener);
        };
        this.remove = (listener)=>{
            this.listeners = this.listeners.filter((l)=>l !== listener);
        };
        // @ts-expect-error - TS2315 - Type 'Middleware' is not generic.
        this.perform = (api)=>(next)=>(action)=>{
                    const result = next(action);
                    this.listeners.forEach((listener)=>listener(action, api.getState()));
                    return result;
                };
    }
}

});


parcelRegister("b7i1H", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2bd228b38d69c07$export$2e2bcd8739ae039);

var $bwbFz = parcelRequire("bwbFz");

var $hompL = parcelRequire("hompL");

var $bSS3k = parcelRequire("bSS3k");
const $d2bd228b38d69c07$var$defaultState = {
    flags: []
};
var /**
 * Manages the state transitions of a notification system by handling actions such as showing
 * new notifications, dismissing notifications (either individually or by type), and
 * resetting to the default state. It uniquely prioritizes high-priority notifications,
 * ensuring they are displayed before low-priority ones, enhancing the user's
 * attention to critical alerts.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$d2bd228b38d69c07$export$2e2bcd8739ae039 = (state = $d2bd228b38d69c07$var$defaultState, action)=>{
    switch(action.type){
        case 0, $bSS3k.SHOW:
            {
                // If flag is of type FlagComponent, it is treated as high priority
                const [lowPriorityFlags, highPriorityFlags] = (0, (/*@__PURE__*/$parcel$interopDefault($bwbFz)))([
                    {
                        id: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
                        flag: action.payload
                    },
                    ...state.flags
                ], ({ flag: flag })=>typeof flag !== 'function' && flag?.isLowPriority);
                const flags = [
                    ...highPriorityFlags,
                    ...lowPriorityFlags
                ];
                return {
                    ...state,
                    flags: flags
                };
            }
        case 0, $bSS3k.DISMISS_INSTANCE:
            {
                const id = action.payload;
                return {
                    ...state,
                    flags: state.flags.filter((flagInstance)=>flagInstance.id !== id)
                };
            }
        case 0, $bSS3k.DISMISS_FLAG:
            {
                const id = action.payload;
                return {
                    ...state,
                    flags: state.flags.filter((flagInstance)=>{
                        // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'Flag'.
                        if (flagInstance.flag.id) // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'Flag'.
                        return flagInstance.flag.id !== id;
                        return true;
                    })
                };
            }
        case 0, $bSS3k.RESET:
            return $d2bd228b38d69c07$var$defaultState;
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});




parcelRegister("glrJM", function(module, exports) {

$parcel$export(module.exports, "default", () => $1963f04f48a97eb6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1963f04f48a97eb6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "relay-fetch.services.error-flags.title",
        "defaultMessage": "Something's gone wrong"
    },
    description: {
        "id": "relay-fetch.services.error-flags.description",
        "defaultMessage": "Looks like you've been signed out. Try logging in again. "
    },
    login: {
        "id": "relay-fetch.services.error-flags.login",
        "defaultMessage": "Log in"
    }
});

});


parcelRegister("ixYrr", function(module, exports) {

$parcel$export(module.exports, "getLoggingAndMetricsHelper", () => $39705662ea381df8$export$726e1df8186bb981);

var $9LXG4 = parcelRequire("9LXG4");

var $illlw = parcelRequire("illlw");

var $ldoFd = parcelRequire("ldoFd");

var $gUUjF = parcelRequire("gUUjF");

var $7EhAs = parcelRequire("7EhAs");
const $39705662ea381df8$var$LOG_NAMESPACE = 'relay.AGG.error.graphql';
const $39705662ea381df8$export$726e1df8186bb981 = (graphqlDetails)=>{
    const { queryName: queryName, operationKind: operationKind } = graphqlDetails;
    return {
        logNonBreakingErrors: (errors, requestId)=>{
            if (false || (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(errors) || !Array.isArray(errors)) return;
            errors.forEach((error)=>{
                error && (0, $gUUjF.default).safeErrorWithoutCustomerData($39705662ea381df8$var$LOG_NAMESPACE, '[graphql error]', {
                    queryName: queryName,
                    operationKind: operationKind,
                    errorType: 'graphql',
                    message: error.message,
                    requestId: requestId
                });
            });
        },
        logError: (error)=>{
            const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
                'statusCode'
            ], null);
            const errorType = error instanceof (0, $7EhAs.default) ? 'network' : 'unknown';
            // Log any errors even in SSR
            (0, $gUUjF.default).safeErrorWithoutCustomerData($39705662ea381df8$var$LOG_NAMESPACE, `[${errorType} error]`, {
                message: `[${(0, (/*@__PURE__*/$parcel$interopDefault($9LXG4)))(errorType)} error]: ${error?.message ?? ''}`,
                errorType: errorType,
                statusCode: statusCode,
                queryName: queryName,
                operationKind: operationKind,
                errorName: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
                    'name'
                ], null)
            });
        },
        logErrorRetry: (error, retryAttempt)=>{
            const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
                'statusCode'
            ], null);
            const errorType = error instanceof (0, $7EhAs.default) ? 'network' : 'unknown';
            // Log any errors even in SSR
            (0, $gUUjF.default).safeErrorWithoutCustomerData($39705662ea381df8$var$LOG_NAMESPACE, `[${errorType} error]`, {
                message: `[${(0, (/*@__PURE__*/$parcel$interopDefault($9LXG4)))(errorType)} error]: ${error?.message ?? ''}`,
                errorType: errorType,
                statusCode: statusCode,
                queryName: queryName,
                operationKind: operationKind,
                errorName: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
                    'name'
                ], null),
                retryAttempt: retryAttempt
            });
        }
    };
};

});


parcelRegister("4aLdW", function(module, exports) {

$parcel$export(module.exports, "subscribe", () => $ef96f447a7409c6e$export$ec068583843480e7);

var $cNy9K = parcelRequire("cNy9K");

var $guiFP = parcelRequire("guiFP");

var $dIOaC = parcelRequire("dIOaC");
var $lE8MM = parcelRequire("lE8MM");

var $keguF = parcelRequire("keguF");
const $ef96f447a7409c6e$export$ec068583843480e7 = ({ id: id, name: operationName }, variables)=>(0, $cNy9K.Observable).create((sink)=>{
        const client = (0, $dIOaC.getClient)();
        if (!client) return sink.error(new Error('Unable to create subscription client'));
        const payload = {
            query: '',
            operationName: operationName,
            variables: variables,
            extensions: {
                pq: id
            }
        };
        let requestId;
        return client.subscribe(payload, {
            ...sink,
            next: (value)=>{
                // @ts-expect-error agg prop is missing on generic "extensions" type
                const aggRequestId = value?.extensions?.agg?.request_id;
                requestId = aggRequestId ?? requestId;
                // @ts-expect-error incompatible types between two libraries
                sink.next(value);
            },
            error: (sinkError)=>{
                const errorInfo = (0, $lE8MM.getSinkError)(sinkError);
                const attributes = {
                    operationName: operationName,
                    requestId: requestId,
                    userLocation: (0, $keguF.getUserLocation)()
                };
                sink.error(errorInfo);
                (0, $guiFP.default)({
                    meta: {
                        id: 'subscription',
                        packageName: 'jiraRelaySubscription',
                        teamName: 'uip-graphql'
                    },
                    error: errorInfo,
                    attributes: attributes,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        });
    });

});
parcelRegister("dIOaC", function(module, exports) {

$parcel$export(module.exports, "getClient", () => $176ec127fee3e1b6$export$6bb76d6eba7e258c);

var $9RGox = parcelRequire("9RGox");

var $gZ48R = parcelRequire("gZ48R");

var $7GiRY = parcelRequire("7GiRY");


var $eliQU = parcelRequire("eliQU");
let $176ec127fee3e1b6$var$client;
const $176ec127fee3e1b6$export$6bb76d6eba7e258c = ()=>{
    if ((0, $eliQU.isSSR)() || (0, $gZ48R.default)('graphql_subscriptions')) return null;
    if (!$176ec127fee3e1b6$var$client) $176ec127fee3e1b6$var$client = (0, $9RGox.createClient)({
        url: (0, $eliQU.getAggSubscriptionEndpoint)(),
        lazy: true,
        keepAlive: (0, $12457a63a9fa501a$export$8b012b965402e06a),
        retryAttempts: (0, $12457a63a9fa501a$export$bf6cd96e19b2987f),
        connectionParams: {
            'atl-client-name': 'jira-frontend',
            'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
            'X-ExperimentalApi': (0, $7GiRY.default).join(',')
        }
    });
    return $176ec127fee3e1b6$var$client;
};
const $176ec127fee3e1b6$export$2f0afd443356d36f = ()=>{
    $176ec127fee3e1b6$var$client = null;
};

});
const $12457a63a9fa501a$export$8b012b965402e06a = 580000; // 9m 40 - timeframe needed for UCT token refresh: https://developer.atlassian.com/platform/graphql-gateway/subscriptions/security/#long-lived-user-context-token
const $12457a63a9fa501a$export$bf6cd96e19b2987f = 100;
const $12457a63a9fa501a$export$1ad8434180c5936c = 300000; // 5m

parcelRegister("eliQU", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $dea6d52502362b12$export$48d7c418edadb60c);
$parcel$export(module.exports, "getAggSubscriptionEndpoint", () => $dea6d52502362b12$export$29a72e89601dfc59);
const $dea6d52502362b12$export$48d7c418edadb60c = ()=>false ?? false;
const $dea6d52502362b12$export$29a72e89601dfc59 = ()=>`${window.location.origin.replace('http', 'ws')}/gateway/api/graphql/subscriptions`;

});


parcelRegister("lE8MM", function(module, exports) {

$parcel$export(module.exports, "getSinkError", () => $8f86032d91fec6de$export$ece4736473c28965);
const $8f86032d91fec6de$export$ece4736473c28965 = (error)=>{
    let errorInfo;
    if (Array.isArray(error)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    [errorInfo] = error;
    else if (error instanceof Error) errorInfo = error;
    else if (typeof error === 'object' && 'type' in error && error.type === 'close') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`CloseEvent: ${error.reason}`);
    else if (error instanceof Event) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`Event: ${error.type}`);
    else errorInfo = new Error(`Unknown sink error: ${error}`);
    return errorInfo;
};

});


parcelRegister("b3wL2", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $624029006652488f$export$48d7c418edadb60c);
const $624029006652488f$export$48d7c418edadb60c = ()=>false ?? false;

});





parcelRegister("boTUp", function(module, exports) {

$parcel$export(module.exports, "removeRedundantPreloads", () => $f334fadd26cc659d$export$a5b3b808f05fede2);
$parcel$export(module.exports, "removeInactiveLoads", () => $f334fadd26cc659d$export$ae329fe3ea179cb4);
$parcel$export(module.exports, "removeAll", () => $f334fadd26cc659d$export$1cfc7aad5cb1833b);
$parcel$export(module.exports, "useEntryPointReferenceSubject", () => $f334fadd26cc659d$export$322c8997d351da6a);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");
const $f334fadd26cc659d$export$a5b3b808f05fede2 = (queue)=>{
    const [, ...potentialRedundantItems] = queue;
    potentialRedundantItems.forEach(({ isPreload: isPreload, value: value })=>{
        if (isPreload) value.dispose();
    });
    return queue.filter(({ value: value })=>!value.isDisposed);
};
const $f334fadd26cc659d$export$ae329fe3ea179cb4 = (queue)=>{
    if (queue.length === 0) return [];
    const [activeItem, ...redundantItems] = queue;
    redundantItems.forEach(({ value: value })=>{
        value.dispose();
    });
    return [
        activeItem
    ];
};
const $f334fadd26cc659d$export$1cfc7aad5cb1833b = (queue)=>{
    queue.forEach(({ value: value })=>{
        value.dispose();
    });
    return [];
};
const $f334fadd26cc659d$export$322c8997d351da6a = ()=>{
    const value = (0, $eUqFw.useRef)(null);
    const subscribers = (0, $eUqFw.useRef)();
    const subscribe = (0, $eUqFw.useCallback)((subscriber)=>{
        if (!subscribers.current) subscribers.current = new Set();
        subscribers.current.add(subscriber);
        return ()=>{
            subscribers.current?.delete(subscriber);
        };
    }, []);
    const setEntryPointReference = (0, $eUqFw.useCallback)((entryPointReference)=>{
        value.current = entryPointReference;
        (0, $lEfVV.unstable_batchedUpdates)(()=>{
            if (subscribers.current) Array.from(subscribers.current).forEach((subscriber)=>{
                subscriber(entryPointReference);
            });
        });
    }, []);
    const getValue = (0, $eUqFw.useCallback)(()=>value.current, []);
    (0, $eUqFw.useEffect)(()=>()=>{
            subscribers.current?.clear();
        }, []);
    return {
        getValue: getValue,
        setEntryPointReference: setEntryPointReference,
        subscribe: subscribe
    };
};

});


parcelRegister("VvIn5", function(module, exports) {

$parcel$export(module.exports, "useMetricLogger", () => $df836dfb6cf1aa5a$export$f291ec7cea728e1);

var $eUqFw = parcelRequire("eUqFw");
const $df836dfb6cf1aa5a$export$f291ec7cea728e1 = (metric)=>{
    const preloadStartTime = (0, $eUqFw.useRef)(0);
    const loadStartTime = (0, $eUqFw.useRef)(0);
    const startMetric = (0, $eUqFw.useCallback)((preloadTime = 0)=>{
        if (metric) {
            metric.start();
            preloadStartTime.current = preloadTime;
            loadStartTime.current = Date.now();
        }
    }, [
        metric
    ]);
    const stopMetric = (0, $eUqFw.useCallback)((additionalCustomData)=>{
        if (metric) {
            const preloadData = preloadStartTime.current > 0 ? {
                preloadToStartDuration: loadStartTime.current - preloadStartTime.current
            } : undefined;
            const metricData = preloadData || additionalCustomData ? {
                customData: {
                    ...preloadData,
                    ...additionalCustomData
                }
            } : undefined;
            metric.stop(metricData);
        }
    }, [
        metric
    ]);
    return {
        startMetric: startMetric,
        stopMetric: stopMetric
    };
};

});


parcelRegister("1HzcR", function(module, exports) {

$parcel$export(module.exports, "JiraEntryPointContainer", () => $48716810ae87e4eb$export$ee1e46af8fa2fb93);

var $eUqFw = parcelRequire("eUqFw");

var $P6D7Q = parcelRequire("P6D7Q");

var $ioLN0 = parcelRequire("ioLN0");
const $48716810ae87e4eb$export$ee1e46af8fa2fb93 = ({ entryPointReferenceSubject: entryPointReferenceSubject, ...containerProps })=>{
    const entryPointReference = (0, $P6D7Q.useEntryPointSubscription)(entryPointReferenceSubject);
    return entryPointReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ioLN0.InternalEntryPointContainer), {
        ...containerProps,
        entryPointReference: entryPointReference,
        placeholderName: "jira-entry-point-container"
    }) : null;
};
const $48716810ae87e4eb$export$54db9e88249c9162 = (0, $ioLN0.InternalEntryPointContainer);

});
parcelRegister("P6D7Q", function(module, exports) {

$parcel$export(module.exports, "useEntryPointSubscription", () => $f27db5d96682fc65$export$3cd1c81e13390c49);

var $eUqFw = parcelRequire("eUqFw");
const $f27db5d96682fc65$export$3cd1c81e13390c49 = (subject)=>{
    const [entryPointReference, setEntryPointReference] = (0, $eUqFw.useState)(subject.getValue);
    (0, $eUqFw.useEffect)(()=>{
        const unsubscribe = subject.subscribe(setEntryPointReference);
        setEntryPointReference(subject.getValue());
        return unsubscribe;
    }, [
        subject
    ]);
    return entryPointReference;
};

});

parcelRegister("ioLN0", function(module, exports) {

$parcel$export(module.exports, "InternalEntryPointContainer", () => $d11d0c1bfdfee8c0$export$5d4dc37edd8a3adb);

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $jK1pm = parcelRequire("jK1pm");
const $d11d0c1bfdfee8c0$export$5d4dc37edd8a3adb = ({ entryPointReference: entryPointReference, errorAttributes: errorAttributes, errorFallback: errorFallback, fallback: fallback, id: id, packageName: packageName, placeholderName: placeholderName, runtimeProps: runtimeProps, teamName: teamName })=>/* eslint-disable-next-line jira/ufo/valid-labels */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: id,
        packageName: packageName,
        teamName: teamName,
        attributes: errorAttributes,
        fallback: errorFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: placeholderName ?? packageName ?? 'internal-entry-point-container',
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iWLL0.EntryPointContainer), {
        entryPointReference: entryPointReference,
        props: runtimeProps
    }))));

});


parcelRegister("6xYPC", function(module, exports) {

$parcel$export(module.exports, "stopLowPriorityEventDelay", () => $4b25e5ad6cfac913$export$a928755af449867);
$parcel$export(module.exports, "startLowPriorityEventDelay", () => $4b25e5ad6cfac913$export$8bb8df5a93e9525);
$parcel$export(module.exports, "default", () => $4b25e5ad6cfac913$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ICvxP = parcelRequire("ICvxP");
var $6iz4v = parcelRequire("6iz4v");

var $cbwiM = parcelRequire("cbwiM");

var $3FyZ4 = parcelRequire("3FyZ4");

var $epT40 = parcelRequire("epT40");

var $87isp = parcelRequire("87isp");

const $4b25e5ad6cfac913$var$STOP_DELAY_TIMEOUT = 10000;
let $4b25e5ad6cfac913$var$stopDelayTimeout;
let $4b25e5ad6cfac913$var$lastDelayActionPromise = (0, $3FyZ4.getAnalyticsWebClientPromise)().then((clientWrapper)=>clientWrapper.getInstance());
const $4b25e5ad6cfac913$export$a928755af449867 = ()=>{
    $4b25e5ad6cfac913$var$lastDelayActionPromise = $4b25e5ad6cfac913$var$lastDelayActionPromise.then((client)=>{
        if (!(0, $cbwiM.isEventDelayActive)()) return client;
        clearTimeout($4b25e5ad6cfac913$var$stopDelayTimeout);
        // stopLowPriorityEventDelay performs a flush of the delayed events,
        // so the delayed period needs to be marked as ended _before_ calling that method.
        (0, $6iz4v.setMark)((0, $9f18a423c52d71b6$export$2d91d3eed1108e72));
        (0, $cbwiM.setEventDelayActive)(false);
        client.stopLowPriorityEventDelay();
        return client;
    });
};
const $4b25e5ad6cfac913$export$8bb8df5a93e9525 = ()=>{
    $4b25e5ad6cfac913$var$lastDelayActionPromise = $4b25e5ad6cfac913$var$lastDelayActionPromise.then((client)=>{
        // If startLowPriorityEventDelay is called when it's already active, then we are just extending
        // the delay period, so we don't want to reset any metadata we have captured about the original start.
        if (!(0, $cbwiM.isEventDelayActive)()) {
            (0, $ICvxP.default)((0, $9f18a423c52d71b6$export$358721a9d6125914));
            (0, $6iz4v.setMark)((0, $9f18a423c52d71b6$export$b2122dce85a27912));
        }
        client.startLowPriorityEventDelay();
        (0, $cbwiM.setEventDelayActive)(true);
        clearTimeout($4b25e5ad6cfac913$var$stopDelayTimeout);
        $4b25e5ad6cfac913$var$stopDelayTimeout = setTimeout($4b25e5ad6cfac913$export$a928755af449867, $4b25e5ad6cfac913$var$STOP_DELAY_TIMEOUT);
        return client;
    });
};
const $4b25e5ad6cfac913$export$778ebe2a4fab1ba7 = ()=>$4b25e5ad6cfac913$var$lastDelayActionPromise;
const $4b25e5ad6cfac913$var$EventDelayController = ()=>{
    const [loadedState] = (0, $epT40.default)();
    (0, $eUqFw.useEffect)(()=>{
        /**
		 * The delay mechanism is currently locked so that only automatic exposure events
		 * can leverage it.
		 * We can remove the performance overhead of starting and stopping critical sections when
		 * these events won't be getting fired.
		 */ if (!loadedState.hasLoaded && (0, $87isp.isAutomaticExposureCollectionEnabled)()) $4b25e5ad6cfac913$export$8bb8df5a93e9525();
    }, [
        loadedState.hasLoaded
    ]);
    return null;
};
var $4b25e5ad6cfac913$export$2e2bcd8739ae039 = $4b25e5ad6cfac913$var$EventDelayController;

});
parcelRegister("cbwiM", function(module, exports) {

$parcel$export(module.exports, "setEventDelayActive", () => $00304183c2d9ac4d$export$9a4add6d6ddcc1a);
$parcel$export(module.exports, "isEventDelayActive", () => $00304183c2d9ac4d$export$3536b0184fa98d19);
let $00304183c2d9ac4d$var$eventDelayActive = false;
const $00304183c2d9ac4d$export$9a4add6d6ddcc1a = (isEventDelayActive)=>{
    $00304183c2d9ac4d$var$eventDelayActive = isEventDelayActive;
};
const $00304183c2d9ac4d$export$3536b0184fa98d19 = ()=>$00304183c2d9ac4d$var$eventDelayActive;

});

parcelRegister("epT40", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9158c027ae7ce81$export$2e2bcd8739ae039);

var $ggKAj = parcelRequire("ggKAj");


var $cfLkw = parcelRequire("cfLkw");
const $c9158c027ae7ce81$export$4a361c7505f72f5c = ({ currentPage: currentPage })=>{
    const { apps: apps } = currentPage;
    const appIds = Object.keys(apps);
    const determineHasLoaded = ()=>{
        /*
		 * During a transition, the top navigation is the only app loading. Additionally, legacy pages generally
		 * render a LegacyPage component, analytics, or nothing at all.
		 *
		 * This code ensures that the page is considered loaded when the content has finished loading in the
		 * SPA, or when the top navigation has finished loading for legacy pages.
		 *
		 * Ideally the LegacyPage component should include an app for the content, but the usage of route components
		 * in legacy routes is inconsistent and would need thorough testing. This should be good enough for now.
		 */ if (appIds.length === 1 && appIds[0] === (0, $9c22638d2f17f9db$export$3a54edb6ba4daa82)) return !__SPA__;
        return appIds.length ? appIds.filter((id)=>id !== (0, $9c22638d2f17f9db$export$2ee9e5a3556c1e43)).every((id)=>apps[id].endTime != null || apps[id].timeoutTime) : false;
    };
    const hasLoaded = determineHasLoaded();
    return {
        hasLoaded: hasLoaded
    };
};
const $c9158c027ae7ce81$var$usePageLoadedSubscriber = (0, $ggKAj.createHook)((0, $cfLkw.default), {
    selector: $c9158c027ae7ce81$export$4a361c7505f72f5c
});
var $c9158c027ae7ce81$export$2e2bcd8739ae039 = $c9158c027ae7ce81$var$usePageLoadedSubscriber;

});
const $9c22638d2f17f9db$export$3a54edb6ba4daa82 = 'TOP_NAV';
const $9c22638d2f17f9db$export$2ee9e5a3556c1e43 = 'SIDEBAR';


const $9f18a423c52d71b6$export$358721a9d6125914 = 'event-delay-controller.';
const $9f18a423c52d71b6$export$b2122dce85a27912 = `${$9f18a423c52d71b6$export$358721a9d6125914}start`;
const $9f18a423c52d71b6$export$2d91d3eed1108e72 = `${$9f18a423c52d71b6$export$358721a9d6125914}end`;


parcelRegister("dnJL9", function(module, exports) {

$parcel$export(module.exports, "componentWithFG", () => $dcea2fa8766d9cd0$export$cf56d0f54cfcce4);

var $9zysr = parcelRequire("9zysr");

var $eI5EY = parcelRequire("eI5EY");
const $dcea2fa8766d9cd0$export$cf56d0f54cfcce4 = (gateName, ComponentTrue, ComponentFalse)=>(0, $9zysr.componentWithCondition)(()=>(0, $eI5EY.fg)(gateName), ComponentTrue, ComponentFalse);

});

parcelRegister("j6ken", function(module, exports) {

$parcel$export(module.exports, "LoadingBarUIController", () => $04a03fc02281e1a8$export$39bdf67fc71ce8c8);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $d3ujX = parcelRequire("d3ujX");

var $kJlBc = parcelRequire("kJlBc");

var $epT40 = parcelRequire("epT40");

var $78d1w = parcelRequire("78d1w");

var $1Xxlz = parcelRequire("1Xxlz");

var $cQcOl = parcelRequire("cQcOl");
const $04a03fc02281e1a8$export$54128ad8de32b897 = ({ startLoading: startLoading, resetLoading: resetLoading, finishLoading: finishLoading })=>{
    const [loadedState] = (0, $epT40.default)();
    (0, $eUqFw.useEffect)(()=>{
        startLoading();
        return ()=>{
            resetLoading();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        if (loadedState.hasLoaded) finishLoading();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        loadedState.hasLoaded
    ]);
    return null;
};
/**
 * Sets up the loading bar stylesheet and controller purely in the client
 * This is a fallback if SSR fails
 *
 */ const $04a03fc02281e1a8$var$LoadingBarUI = ({ shouldRender: shouldRender, routeIdentifier: routeIdentifier })=>{
    const [actions, setActions] = (0, $eUqFw.useState)({});
    const sheetRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'HTMLStyleElement | null'.
        const loadingBarActions = (0, $d3ujX.createLoadingBarActionController)(sheetRef.current);
        setActions(loadingBarActions || {});
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("style", {
        // @ts-expect-error - TS2322 - Type 'MutableRefObject<unknown>' is not assignable to type 'LegacyRef<HTMLStyleElement> | undefined'.
        ref: sheetRef,
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `
                    ${(0, $1Xxlz.LOADER_STYLES_CSS_SELECTOR)} {
                        ${(0, $cQcOl.generateLoadingBarStyles)(0, (0, $1Xxlz.getLoadingBarColor)())}
                    }
                `
        }
    }), shouldRender && actions.START && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($04a03fc02281e1a8$export$54128ad8de32b897, {
        key: routeIdentifier,
        // @ts-expect-error - TS2339 - Property 'START' does not exist on type '{}'.
        startLoading: actions.START,
        // @ts-expect-error - TS2339 - Property 'RESET' does not exist on type '{}'.
        resetLoading: actions.RESET,
        // @ts-expect-error - TS2339 - Property 'FINISH' does not exist on type '{}'.
        finishLoading: actions.FINISH
    }));
};
const $04a03fc02281e1a8$export$e068deb20d61b035 = ()=>{
    let currentTransitionsCount = 0;
    let currentRouteIdentifier = '';
    let currentRouteMatch = '';
    let hasTransitioned = false;
    let key = 0;
    return (transitionsCount, routeIdentifier, routeMatch)=>{
        if (transitionsCount !== currentTransitionsCount) {
            currentTransitionsCount = transitionsCount;
            hasTransitioned = true;
        }
        if (routeIdentifier !== null && routeIdentifier !== currentRouteIdentifier || routeIdentifier === currentRouteIdentifier && routeMatch !== currentRouteMatch) {
            currentRouteIdentifier = routeIdentifier;
            currentRouteMatch = routeMatch;
            if (hasTransitioned) {
                hasTransitioned = false;
                key = currentTransitionsCount;
            }
        }
        return key;
    };
};
const $04a03fc02281e1a8$var$getUniqueTransitionKey = $04a03fc02281e1a8$export$e068deb20d61b035();
/**
 * Determines if the <LoadingBarController> should render or re-render
 * Injects dependencies into <LoadingBarController />
 *
 */ const $04a03fc02281e1a8$export$39bdf67fc71ce8c8 = ()=>{
    const [routerState] = (0, $kJlBc.useRouter)();
    const [{ transitionsCount: transitionsCount }] = (0, $78d1w.useSpaStateTransition)();
    const currentRoute = routerState.route && routerState.route.name;
    const loaderFailedInSSR = !window.JIRA_LOADING_BAR;
    const shouldRender = (0, $1Xxlz.getAllowedRoutes)().includes(currentRoute);
    // we generate a unique route identifier each time a transition happens
    // we use this key to force re-render of the <LoadingBarController />
    const routeIdentifier = (0, $eUqFw.useMemo)(()=>$04a03fc02281e1a8$var$getUniqueTransitionKey(transitionsCount, currentRoute, JSON.stringify(routerState.match)), [
        transitionsCount,
        currentRoute,
        routerState.match
    ]);
    // We always expect the loading bar to be initialised in SSR for any route in ALLOWED_ROUTES
    // If this doesn't happen, it means SSR failed or the loading bar code in SSR failed
    (0, $eUqFw.useEffect)(()=>{
        if (shouldRender && loaderFailedInSSR) (0, $gUUjF.default).safeWarnWithoutCustomerData('global-loading-bar', 'Loading bar failed to initialise in SSR. This may be because SSR failed or a bug in the loading bar code.');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        loaderFailedInSSR
    ]);
    // If the loading bar fails to setup in SSR, we set up the action controller AND stylesheet in the client
    // We also do this if SSR renders a page that does not have the loading bar enabled (eg !shouldRender)
    if (loaderFailedInSSR) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($04a03fc02281e1a8$var$LoadingBarUI, {
        shouldRender: shouldRender,
        routeIdentifier: routeIdentifier
    });
    // if the loading bar is succesfully setup in SSR, all the client needs to do is dispatch loading actions
    if (shouldRender && window.JIRA_LOADING_BAR) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($04a03fc02281e1a8$export$54128ad8de32b897, {
        key: routeIdentifier,
        startLoading: window.JIRA_LOADING_BAR.START,
        resetLoading: window.JIRA_LOADING_BAR.RESET,
        finishLoading: window.JIRA_LOADING_BAR.FINISH
    });
    return null;
};

});
parcelRegister("d3ujX", function(module, exports) {

$parcel$export(module.exports, "createLoadingBarActionController", () => $e871469dab215262$export$55d67d61d9d2ad3b);
// BE VERY CAREFUL IMPORTING ANY PACKAGES IN THIS FILE
// THIS CODE IS AN INLINE FRAGMENT AND RUNS BEFORE POLYFILLS AND MAY BREAK IE

var $g0c9Y = parcelRequire("g0c9Y");
const $e871469dab215262$export$53d51cc6d57e44da = 'rgb(76, 154, 255)';
const $e871469dab215262$export$899393f3e23f724b = 15000;
const $e871469dab215262$export$7868b416d8929c55 = 40000;
const $e871469dab215262$var$LOADER_STYLES_CSS_SELECTOR = 'body::before';
const $e871469dab215262$var$EXIT_ANIMATION_SPEED = 300;
const $e871469dab215262$export$99d4e8974a739853 = ()=>(0, $g0c9Y.getMeta)('ajs-lf-navigation-highlightcolour') || $e871469dab215262$export$53d51cc6d57e44da;
const $e871469dab215262$export$4fb8742b05de9693 = (duration)=>`
    ${$e871469dab215262$var$LOADER_STYLES_CSS_SELECTOR} { 
        transform: scaleX(0.99);
        transition-duration: ${duration}ms;
        transition-timing-function: cubic-bezier(0,1,0.5,1);
    }
`;
const $e871469dab215262$export$5a43e0f09174e553 = ()=>`
    ${$e871469dab215262$var$LOADER_STYLES_CSS_SELECTOR} {
        transform: scaleX(1);
        transition-duration: ${$e871469dab215262$var$EXIT_ANIMATION_SPEED}ms;
        animation: none;
        background-image: none;
    }
`;
const $e871469dab215262$export$6beef8c645a63156 = ()=>`
    ${$e871469dab215262$var$LOADER_STYLES_CSS_SELECTOR} {
        transform: scaleX(0);
        transition-duration: 0ms;
        animation: none;
        background-image: none;
    }
`;
const $e871469dab215262$export$610cb442736abf53 = ()=>`
    @keyframes shimmer {
        from {
            left: -80%; 
            width: 80%; 
        }
        
        to {
            left: 110%; 
            width: 10%;
        }
    }
`;
const $e871469dab215262$export$959e9e99fba397f1 = (loadingBarColor)=>`
        ${$e871469dab215262$var$LOADER_STYLES_CSS_SELECTOR} {
            transform: scaleX(1);
            transition-duration: 0ms;
            background: ${loadingBarColor};
            animation: shimmer 2s infinite;
        }
    `;
const $e871469dab215262$var$browserFocusCheck = (action)=>{
    if (document && document.hidden) action();
    else requestAnimationFrame(()=>{
        action();
    });
};
const $e871469dab215262$export$55d67d61d9d2ad3b = (stylesheet)=>{
    const { sheet: sheet } = stylesheet || {};
    if (!sheet) return undefined;
    let isRunning = false;
    let isDelayed = false;
    let exitAnimationTimer;
    let delayedAnimationTimer;
    let timeoutTimer;
    return {
        START: (duration = $e871469dab215262$export$899393f3e23f724b)=>{
            if (isRunning) return;
            isRunning = true;
            // requestAnimationFrame will not run until the browser tab is focused
            // if a user opens a new tab the start animation will not begin until the tab is focused
            // this can cause the loading bar css to be applied in the incorrect order
            // to solve this we remove requestAnimationFrame if the tab is not focused
            $e871469dab215262$var$browserFocusCheck(()=>{
                sheet.insertRule($e871469dab215262$export$4fb8742b05de9693(duration), sheet.cssRules.length);
            });
            // Set a new delayed animation if loader hasn't finished after `${duration}` ms
            delayedAnimationTimer = setTimeout(()=>{
                if (!isRunning) return;
                isDelayed = true;
                $e871469dab215262$var$browserFocusCheck(()=>{
                    sheet.insertRule($e871469dab215262$export$610cb442736abf53(), sheet.cssRules.length);
                    sheet.insertRule($e871469dab215262$export$959e9e99fba397f1($e871469dab215262$export$99d4e8974a739853()), sheet.cssRules.length);
                });
            }, $e871469dab215262$export$899393f3e23f724b);
            // Remove the loader if it hasn't finished after `${TIMEOUT_TIMER}` ms
            timeoutTimer = setTimeout(()=>{
                if (!isRunning) return;
                isRunning = false;
                isDelayed = false;
                $e871469dab215262$var$browserFocusCheck(()=>{
                    sheet.insertRule($e871469dab215262$export$6beef8c645a63156(), sheet.cssRules.length);
                });
                clearTimeout(exitAnimationTimer);
                clearTimeout(delayedAnimationTimer);
                clearTimeout(timeoutTimer);
            }, $e871469dab215262$export$7868b416d8929c55);
        },
        FINISH: ()=>{
            if (!isRunning) return;
            isRunning = false;
            if (isDelayed) {
                isDelayed = false;
                clearTimeout(exitAnimationTimer);
                clearTimeout(timeoutTimer);
                clearTimeout(delayedAnimationTimer);
                $e871469dab215262$var$browserFocusCheck(()=>{
                    sheet.insertRule($e871469dab215262$export$6beef8c645a63156(), sheet.cssRules.length);
                });
                return;
            }
            $e871469dab215262$var$browserFocusCheck(()=>{
                sheet.insertRule($e871469dab215262$export$5a43e0f09174e553(), sheet.cssRules.length);
            });
            exitAnimationTimer = setTimeout(()=>{
                clearTimeout(exitAnimationTimer);
                clearTimeout(timeoutTimer);
                clearTimeout(delayedAnimationTimer);
                $e871469dab215262$var$browserFocusCheck(()=>{
                    sheet.insertRule($e871469dab215262$export$6beef8c645a63156(), sheet.cssRules.length);
                });
            }, $e871469dab215262$var$EXIT_ANIMATION_SPEED + 500);
        },
        RESET: ()=>{
            isRunning = false;
            isDelayed = false;
            clearTimeout(exitAnimationTimer);
            clearTimeout(delayedAnimationTimer);
            clearTimeout(timeoutTimer);
            $e871469dab215262$var$browserFocusCheck(()=>{
                sheet.insertRule($e871469dab215262$export$6beef8c645a63156(), sheet.cssRules.length);
            });
        }
    };
};
const $e871469dab215262$var$setupLoadingBarActionController = ()=>{
    const LOADER_STYLESHEET_ID = 'loaderStylesheet';
    // @ts-expect-error - TS2322 - Type 'HTMLElement | null' is not assignable to type 'HTMLStyleElement | null'.
    const styleSheet = document.getElementById(LOADER_STYLESHEET_ID);
    // SSR will not attach the stylesheet for routes not included in ALLOWED_ROUTES
    if (!styleSheet || !styleSheet.sheet) return;
    window.JIRA_LOADING_BAR = $e871469dab215262$export$55d67d61d9d2ad3b(styleSheet);
    if (window.JIRA_LOADING_BAR && window.JIRA_LOADING_BAR.START) window.JIRA_LOADING_BAR.START();
};
$e871469dab215262$var$setupLoadingBarActionController();

});
parcelRegister("g0c9Y", function(module, exports) {

$parcel$export(module.exports, "getMeta", () => $974e6ffaf05907b7$export$c47913ca32a5c6f7);
const $974e6ffaf05907b7$export$c47913ca32a5c6f7 = (name)=>{
    const node = document.querySelector(`meta[name="${name}"]`);
    const metaValue = node && node.getAttribute('content');
    return metaValue !== undefined ? metaValue : null;
};

});


parcelRegister("78d1w", function(module, exports) {

$parcel$export(module.exports, "useSpaStateTransition", () => $7f5c686fb18f00a1$export$4d1974344641a2c9);
$parcel$export(module.exports, "default", () => $7f5c686fb18f00a1$export$2e2bcd8739ae039);

var $ggKAj = parcelRequire("ggKAj");
var $dYfll = parcelRequire("dYfll");

var $8uNQc = parcelRequire("8uNQc");

var $cfLkw = parcelRequire("cfLkw");
const $7f5c686fb18f00a1$var$getNavigationStart = ()=>{
    // @ts-expect-error - TS2339 - Property 'timing' does not exist on type 'Performance | { now: () => number; mark: (...args: any[]) => void; clearMarks: (...args: any[]) => void; clearResourceTimings: (...args: any[]) => void; getEntriesByType: (type: string) => never[]; getEntriesByName: (name: string) => never[]; }'. | TS2339 - Property 'timing' does not exist on type 'Performance | { now: () => number; mark: (...args: any[]) => void; clearMarks: (...args: any[]) => void; clearResourceTimings: (...args: any[]) => void; getEntriesByType: (type: string) => never[]; getEntriesByName: (name: string) => never[]; }'.
    const timestamp = (0, $8uNQc.default) && (0, $8uNQc.default).timing && (0, $8uNQc.default).timing.navigationStart;
    return timestamp ? new Date(timestamp).toISOString() : undefined;
};
const $7f5c686fb18f00a1$var$getLastTransition = (currentPage, visitedPages)=>{
    if (visitedPages.length === 0) return undefined;
    const collectAppNames = (page)=>Object.keys(page.apps || {}).sort();
    const appNamesToStr = (appNames)=>appNames.join('+') || '?';
    const prevPage = appNamesToStr(collectAppNames(visitedPages.slice(-1)[0]));
    const currPage = appNamesToStr(collectAppNames(currentPage));
    return `${prevPage} > ${currPage}`;
};
const $7f5c686fb18f00a1$var$getLastTransitionStartTime = (currentPage, visitedPages)=>{
    // If there are no previously visited pages the transition didn't have a place
    if (visitedPages.length === 0) return undefined;
    return currentPage.startTime;
};
const $7f5c686fb18f00a1$export$aea217a45095ce11 = ({ visitedPages: visitedPages, currentPage: currentPage })=>({
        isInitialRender: visitedPages.length === 0,
        transitionsCount: visitedPages.length,
        lastTransition: $7f5c686fb18f00a1$var$getLastTransition(currentPage, visitedPages),
        lastTransitionStartTime: $7f5c686fb18f00a1$var$getLastTransitionStartTime(currentPage, visitedPages),
        navigationStart: $7f5c686fb18f00a1$var$getNavigationStart(),
        currentPageId: currentPage.uuid
    });
// @ts-expect-error - TS2322 - Type 'SubscriberComponent<TransitionState, BoundActions<State, typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/controllers/spa-state/src/actions/index")>, Record<...>>' is not assignable to type 'Subscriber'.
const $7f5c686fb18f00a1$var$SpaStateTransitionStateSubscriber = (0, $dYfll.createSubscriber)((0, $cfLkw.default), {
    displayName: 'SpaStateTransitionStateSubscriber',
    selector: $7f5c686fb18f00a1$export$aea217a45095ce11
});
const $7f5c686fb18f00a1$export$4d1974344641a2c9 = (0, $ggKAj.createHook)((0, $cfLkw.default), {
    selector: $7f5c686fb18f00a1$export$aea217a45095ce11
});
var $7f5c686fb18f00a1$export$2e2bcd8739ae039 = $7f5c686fb18f00a1$var$SpaStateTransitionStateSubscriber;

});

parcelRegister("1Xxlz", function(module, exports) {

$parcel$export(module.exports, "LOADER_STYLES_CSS_SELECTOR", () => $687b423c2ce28206$export$2a3dd4ccb7b0a764);
$parcel$export(module.exports, "LOADER_STYLESHEET_ID", () => $687b423c2ce28206$export$79456f717d4431da);
$parcel$export(module.exports, "getAllowedRoutes", () => $687b423c2ce28206$export$c82eb262b97a76f1);
$parcel$export(module.exports, "getLoadingBarColor", () => $687b423c2ce28206$export$cf3a5ed89e041425);

var $5iWql = parcelRequire("5iWql");

var $exb0h = parcelRequire("exb0h");

var $6rW04 = parcelRequire("6rW04");
const $687b423c2ce28206$var$FIRST_RELEASE_ROUTES = [
    (0, $exb0h.ROUTE_NAMES).ISSUE,
    (0, $exb0h.ROUTE_NAMES).ISSUE_EMBED,
    (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_BACKLOG,
    (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_BOARD,
    (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_REPORT,
    (0, $exb0h.ROUTE_NAMES).YOUR_WORK,
    (0, $exb0h.ROUTE_NAMES).PROJECTS_DIRECTORY,
    (0, $exb0h.ROUTE_NAMES).PROJECTS_DIRECTORY_LEGACY_PATH_SPA,
    (0, $exb0h.ROUTE_NAMES).BOARDS_DIRECTORY,
    (0, $exb0h.ROUTE_NAMES).FILTERS_DIRECTORY,
    (0, $exb0h.ROUTE_NAMES).FILTERS_DIRECTORY_SECURE,
    (0, $exb0h.ROUTE_NAMES).DASHBOARDS_DIRECTORY,
    (0, $exb0h.ROUTE_NAMES).DASHBOARDS_DIRECTORY_SECURE,
    (0, $exb0h.ROUTE_NAMES).PROJECT_COMPONENTS,
    (0, $exb0h.ROUTE_NAMES).PROJECT_PAGES,
    (0, $exb0h.ROUTE_NAMES).PROJECT_VERSIONS,
    (0, $exb0h.ROUTE_NAMES).SOFTWARE_BOARDS,
    (0, $exb0h.ROUTE_NAMES).SOFTWARE_BACKLOG,
    (0, $exb0h.ROUTE_NAMES).SOFTWARE_TIMELINE,
    (0, $exb0h.ROUTE_NAMES).SOFTWARE_ROADMAP,
    (0, $exb0h.ROUTE_NAMES).SOFTWARE_ROADMAP_CLASSIC,
    (0, $exb0h.ROUTE_NAMES).SOFTWARE_TIMELINE_CLASSIC,
    (0, $exb0h.ROUTE_NAMES).SOFTWARE_REPORTS,
    (0, $exb0h.ROUTE_NAMES).SOFTWARE_REPORTS_BURNUP,
    (0, $exb0h.ROUTE_NAMES).SOFTWARE_REPORTS_BURNDOWN,
    (0, $exb0h.ROUTE_NAMES).SOFTWARE_REPORTS_CUMULATIVE,
    (0, $exb0h.ROUTE_NAMES).SOFTWARE_REPORTS_VELOCITY,
    (0, $exb0h.ROUTE_NAMES).PROJECT_ISSUE_NAVIGATOR,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_ISSUE_NAVIGATOR,
    (0, $exb0h.ROUTE_NAMES).PROJECT_ISSUE_NAVIGATOR_CLASSIC,
    (0, $exb0h.ROUTE_NAMES).PROJECT_ISSUE_NAVIGATOR_CORE,
    (0, $exb0h.ROUTE_NAMES).SOFTWARE_ISSUE_NAVIGATOR,
    (0, $exb0h.ROUTE_NAMES).SYSTEM_DASHBOARD_EDIT
];
const $687b423c2ce28206$export$2a3dd4ccb7b0a764 = 'body::before';
const $687b423c2ce28206$export$79456f717d4431da = 'loaderStylesheet';
const $687b423c2ce28206$export$53d51cc6d57e44da = 'rgb(76, 154, 255)';
const $687b423c2ce28206$export$c82eb262b97a76f1 = (0, $5iWql.default)(()=>{
    const ALLOWED_ROUTES = $687b423c2ce28206$var$FIRST_RELEASE_ROUTES;
    return ALLOWED_ROUTES;
});
const $687b423c2ce28206$export$cf3a5ed89e041425 = (0, $5iWql.default)(()=>(0, $6rW04.default)('ajs-lf-navigation-highlightcolour') || $687b423c2ce28206$export$53d51cc6d57e44da);

});
parcelRegister("exb0h", function(module, exports) {

$parcel$export(module.exports, "ROUTE_GROUPS", () => $67f07001968fe110$export$9cb628d660b3e224);
$parcel$export(module.exports, "ROUTE_NAMES", () => $67f07001968fe110$export$6c85e878a3c25536);
$parcel$export(module.exports, "JWM_OVERVIEWS_ROUTE_SET", () => $67f07001968fe110$export$a8aac2ba4dc1f57);
$parcel$export(module.exports, "CONNECT_ROUTES_SET", () => $67f07001968fe110$export$c47bf667d3008c53);
/* eslint sort-keys: "error" */ const $67f07001968fe110$export$9cb628d660b3e224 = {
    ARCHIVE_ISSUES: 'archive-issues',
    ARJ_SETTINGS: 'arj-settings',
    CLASSIC_BUSINESS: 'classic-business',
    CLASSIC_SOFTWARE: 'classic-software',
    COMPONENTS: 'components',
    CONNECT: 'connect',
    DASHBOARD: 'dashboard',
    DASHBOARDS: 'dashboards',
    DEVOPS: 'devops',
    DIRECTORIES: 'directories',
    EOC: 'eoc',
    ERRORS: 'errors',
    GLOBAL_SETTINGS: 'global-settings',
    HOME: 'home',
    ISSUE: 'issue',
    ISSUE_NAVIGATOR: 'issue-navigator',
    LEGACY: 'legacy',
    LEGACY_SERVICEDESK_SETTINGS: 'legacy-jsd-settings',
    MARKETPLACE: 'marketplace',
    PEOPLE_PROFILES: 'people-profiles',
    PERSONAL_SETTINGS: 'personal-settings',
    PLAN_SETTINGS: 'plan-settings',
    POLARIS: 'polaris',
    PROFORMA: 'proforma',
    PROJECT_SETTINGS_CLASSIC: 'project-settings-classic',
    PROJECT_SETTINGS_CORE: 'project-settings-core',
    PROJECT_SETTINGS_SERVICEDESK: 'project-settings-servicedesk',
    PROJECT_SETTINGS_SOFTWARE: 'project-settings-software',
    PROJECT_SETTINGS_SOFTWARE_BOARDS: 'project-settings-software-boards',
    REDIRECTS: 'redirects',
    SERVICEDESK: 'servicedesk',
    SERVICES: 'services',
    SOFTWARE: 'software',
    VERSIONS: 'versions'
};
const $67f07001968fe110$export$6c85e878a3c25536 = {
    ARCHIVED_ISSUES_DIRECTORY: 'archived-issues-directory',
    ARCHIVED_PLANS_DIRECTORY: 'archived-plans-directory',
    ARCHIVED_PROJECTS_DIRECTORY: 'archived-projects-directory',
    ARCHIVED_PROJECT_DIRECT_LINK: 'archived-project-direct-link',
    AVP_DASHBOARDS: 'avp-dashboard',
    BOARDS_DIRECTORY: 'boards-directory',
    BROWSE_PROJECT_REDIRECT: 'browse-project-redirect',
    BUSINESS_BOARD: 'next-gen-business-board',
    BUSINESS_CLASSIC_REPORTS: 'business-classic-reports',
    BUSINESS_REPORTS: 'next-gen-business-reports',
    // Jira business routes
    CLASSIC_BUSINESS_OVERVIEW_CALENDAR: `${$67f07001968fe110$export$9cb628d660b3e224.CLASSIC_BUSINESS}-overview-calendar`,
    CLASSIC_BUSINESS_OVERVIEW_REDIRECT: `${$67f07001968fe110$export$9cb628d660b3e224.CLASSIC_BUSINESS}-overview-redirect`,
    CLASSIC_BUSINESS_OVERVIEW_SUMMARY: `${$67f07001968fe110$export$9cb628d660b3e224.CLASSIC_BUSINESS}-overview-summary`,
    CLASSIC_BUSINESS_OVERVIEW_TIMELINE: `${$67f07001968fe110$export$9cb628d660b3e224.CLASSIC_BUSINESS}-overview-timeline`,
    CLASSIC_BUSINESS_PROJECT_APPROVALS: `${$67f07001968fe110$export$9cb628d660b3e224.CLASSIC_BUSINESS}-approvals`,
    CLASSIC_BUSINESS_PROJECT_ATTACHMENTS: `${$67f07001968fe110$export$9cb628d660b3e224.CLASSIC_BUSINESS}-attachments`,
    CLASSIC_BUSINESS_PROJECT_BOARD: `${$67f07001968fe110$export$9cb628d660b3e224.CLASSIC_BUSINESS}-board`,
    CLASSIC_BUSINESS_PROJECT_BOARD_EMBED: `${$67f07001968fe110$export$9cb628d660b3e224.CLASSIC_BUSINESS}-board-embed`,
    CLASSIC_BUSINESS_PROJECT_CALENDAR: `${$67f07001968fe110$export$9cb628d660b3e224.CLASSIC_BUSINESS}-calendar`,
    CLASSIC_BUSINESS_PROJECT_CALENDAR_EMBED: `${$67f07001968fe110$export$9cb628d660b3e224.CLASSIC_BUSINESS}-calendar-embed`,
    CLASSIC_BUSINESS_PROJECT_FILES: `${$67f07001968fe110$export$9cb628d660b3e224.CLASSIC_BUSINESS}-files`,
    CLASSIC_BUSINESS_PROJECT_FORM: `${$67f07001968fe110$export$9cb628d660b3e224.CLASSIC_BUSINESS}-form`,
    CLASSIC_BUSINESS_PROJECT_FORM_BUILDER: `${$67f07001968fe110$export$9cb628d660b3e224.CLASSIC_BUSINESS}-form-builder`,
    CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT: `${$67f07001968fe110$export$9cb628d660b3e224.CLASSIC_BUSINESS}-form-submit`,
    CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT_EMBED: `${$67f07001968fe110$export$9cb628d660b3e224.CLASSIC_BUSINESS}-form-submit-embed`,
    CLASSIC_BUSINESS_PROJECT_LIST: `${$67f07001968fe110$export$9cb628d660b3e224.CLASSIC_BUSINESS}-list`,
    CLASSIC_BUSINESS_PROJECT_LIST_EMBED: `${$67f07001968fe110$export$9cb628d660b3e224.CLASSIC_BUSINESS}-list-embed`,
    CLASSIC_BUSINESS_PROJECT_SAMPLE_ONBOARDING: `${$67f07001968fe110$export$9cb628d660b3e224.CLASSIC_BUSINESS}-sample-onboarding`,
    CLASSIC_BUSINESS_PROJECT_SHORTCUT: `${$67f07001968fe110$export$9cb628d660b3e224.CLASSIC_BUSINESS}-shortcut`,
    CLASSIC_BUSINESS_PROJECT_SUMMARY: `${$67f07001968fe110$export$9cb628d660b3e224.CLASSIC_BUSINESS}-summary`,
    CLASSIC_BUSINESS_PROJECT_SUMMARY_EMBED: `${$67f07001968fe110$export$9cb628d660b3e224.CLASSIC_BUSINESS}-summary-embed`,
    CLASSIC_BUSINESS_PROJECT_TIMELINE: `${$67f07001968fe110$export$9cb628d660b3e224.CLASSIC_BUSINESS}-timeline`,
    CLASSIC_BUSINESS_PROJECT_TIMELINE_EMBED: `${$67f07001968fe110$export$9cb628d660b3e224.CLASSIC_BUSINESS}-timeline-embed`,
    CLASSIC_BUSINESS_REDIRECT: `${$67f07001968fe110$export$9cb628d660b3e224.CLASSIC_BUSINESS}-redirect`,
    CLASSIC_PROJECT_SETTINGS_CODE: `${$67f07001968fe110$export$9cb628d660b3e224.CLASSIC_SOFTWARE}-code`,
    CLASSIC_PROJECT_SETTINGS_CORE_PROFORMA_FORMS: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_CORE}-proforma-project-forms`,
    CLASSIC_PROJECT_SETTINGS_DATA_CLASSIFICATIONS: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_CLASSIC}-data-classifications`,
    CLASSIC_PROJECT_SETTINGS_FEATURES: `${$67f07001968fe110$export$9cb628d660b3e224.CLASSIC_SOFTWARE}-features`,
    CLASSIC_PROJECT_SETTINGS_ISSUE_LAYOUT: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_CLASSIC}-issue-layout`,
    CLASSIC_PROJECT_SETTINGS_NOTIFICATION_EMAIL: `${$67f07001968fe110$export$9cb628d660b3e224.CLASSIC_SOFTWARE}-notifications-notification-email`,
    CLASSIC_PROJECT_SETTINGS_OPSGENIE: `${$67f07001968fe110$export$9cb628d660b3e224.CLASSIC_SOFTWARE}-link-opsgenie`,
    CLASSIC_PROJECT_SETTINGS_SOFTWARE_DETAILS: `${$67f07001968fe110$export$9cb628d660b3e224.CLASSIC_SOFTWARE}-details`,
    CLASSIC_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS: `${$67f07001968fe110$export$9cb628d660b3e224.CLASSIC_SOFTWARE}-notifications`,
    CLASSIC_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS_ISSUE_LOGS: `${$67f07001968fe110$export$9cb628d660b3e224.CLASSIC_SOFTWARE}-notifications-issue-logs`,
    CLASSIC_PROJECT_SETTINGS_SOFTWARE_PROFORMA_EDIT_FORMS: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_SOFTWARE}-proforma-edit-forms`,
    CLASSIC_PROJECT_SETTINGS_SOFTWARE_PROFORMA_FORMS: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_SOFTWARE}-proforma-project-forms`,
    CLASSIC_PROJECT_SETTINGS_TOOLCHAIN: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_SOFTWARE}-toolchain-company-managed`,
    COMPASS_PRODUCT_SETTINGS: 'compass-product-settings',
    CONFLUENCE_PRODUCT_SETTINGS: 'confluence-product-settings',
    CONNECT_GENERAL: 'connect-general',
    CONNECT_GENERAL_INVALID: 'connect-general-invalid',
    CONNECT_GENERAL_SERVICE_DESK_PROJECT: 'connect-general-service-desk-project',
    CONNECT_PROJECT: 'connect-project',
    CREATE_PROJECT: 'create-project',
    CUSTOMER_SERVICE_ACCOUNTS: 'customer-service-accounts',
    DASHBOARD: 'dashboard',
    DASHBOARDS_DIRECTORY: 'dashboards-directory',
    DASHBOARDS_DIRECTORY_SECURE: 'dashboards-directory-secure',
    DASHBOARD_EDIT: 'dashboard-edit',
    DASHBOARD_SELECTED: 'dashboard-selected',
    DASHBOARD_VIEW: 'dashboard-view',
    DASHBOARD_VIEW_EMBED: 'dashboard-view-embed',
    DASHBOARD_WALLBOARD: 'dashboard-wallboard',
    DEVOPS_CONNECTED_PROJECT: 'devops-connected-project',
    EOC_ALERTS: 'eoc-alerts',
    EOC_ALERT_DETAIL: 'eoc-alert-detail',
    EOC_ALERT_ISSUE_SYNCING: 'eoc-alert-issue-syncing',
    EOC_ALERT_ISSUE_SYNCING_CREATE: 'eoc-alert-issue-syncing-create',
    EOC_ALERT_ISSUE_SYNCING_DETAIL: 'eoc-alert-issue-syncing-detail',
    EOC_API_KEY_MANAGEMENT: 'eoc-api-key-management',
    EOC_ASSIGN_CUSTOM_ROLES: 'eoc-assign-custom-roles',
    EOC_AUTOMATIONS: 'eoc-automations',
    EOC_CUSTOM_ROLES: 'eoc-custom-roles',
    EOC_GLOBAL_ALERTS: 'eoc-global-alerts',
    EOC_GLOBAL_ALERT_DETAIL: 'eoc-global-alert-detail',
    EOC_GLOBAL_GROUP_DETAIL: 'eoc-global-group-detail',
    EOC_GLOBAL_MAINTENANCE: 'eoc-global-maintenance',
    EOC_HEARTBEATS: 'eoc-heartbeats',
    EOC_INCOMING_CALL: 'eoc-incoming-call',
    EOC_INCOMING_CALL_DETAIL: 'eoc-incoming-call-detail',
    EOC_INTEGRATIONS: 'eoc-integrations',
    EOC_INTEGRATION_CREATE: 'eoc-integration-create',
    EOC_INTEGRATION_DETAIL: 'eoc-integration-detail',
    EOC_INTEGRATION_LIST: 'eoc-integration-list',
    EOC_INTEGRATION_LOG: 'eoc-integration-log',
    EOC_MAINTENANCE: 'eoc-maintenance',
    EOC_ON_CALL: 'eoc-on-call',
    EOC_OVERVIEW: 'eoc-overview',
    EOC_PERMISSIONS: 'eoc-permissions',
    EOC_POLICIES: 'eoc-policies',
    EOC_REPORTS: 'eoc-reports',
    EOC_REPORTS_TEAM: 'eoc-reports-team',
    EOC_REPORTS_UNSUBSCRIBE: 'eoc-reports-unsubscribe',
    EOC_ROLE_BASED_NOTIFICATIONS: 'eoc-role-based-notifications',
    EOC_ROLE_BASED_NOTIFICATIONS_DETAIL: 'eoc-role-based-notifications-detail',
    EOC_SETTINGS: 'eoc-settings',
    EOC_TEAM_ALERTS: 'eoc-team-alerts',
    EOC_TEAM_ALERT_DETAILS: 'eoc-team-alert-detail',
    EOC_TEAM_ALERT_ISSUE_SYNCING: 'eoc-team-alert-issue-syncing',
    EOC_TEAM_ALERT_ISSUE_SYNCING_CREATE: 'eoc-team-alert-issue-syncing-create',
    EOC_TEAM_ALERT_ISSUE_SYNCING_DETAIL: 'eoc-team-alert-issue-syncing-detail',
    EOC_TEAM_CUSTOMER_LOGS: 'eoc-team-customer-logs',
    EOC_TEAM_CUSTOMER_LOGS_DOWNLOAD: 'eoc-team-customer-logs-download',
    EOC_TEAM_GROUP_DETAIL: 'eoc-team-group-detail',
    EOC_TEAM_INTEGRATIONS: 'eoc-team-integrations',
    EOC_TEAM_INTEGRATION_CREATE: 'eoc-team-integration-create',
    EOC_TEAM_INTEGRATION_DETAIL: 'eoc-team-integration-detail',
    EOC_TEAM_INTEGRATION_LIST: 'eoc-team-integration-list',
    EOC_TEAM_INTEGRATION_LOG: 'eoc-team-integration-log',
    EOC_TEAM_POLICIES: 'eoc-team-policies',
    EOC_UNLOCK_OPERATIONS: 'eoc-unlock-operations',
    EOC_WHO_IS_ON_CALL: 'eoc-who-is-on-call',
    ERRORS_NOT_FOUND: 'errors-not-found',
    EXTERNAL_IMPORT: 'external-import',
    FILTERS_DIRECTORY: 'filters-directory',
    FILTERS_DIRECTORY_SECURE: 'filters-directory-secure',
    FORGE_ADMIN: 'forge-spa-admin',
    FORGE_ADMIN_SETTINGS: 'forge-spa-admin-settings',
    FORGE_FIELD_CONTEXTUAL_CONFIGURATION: 'forge-spa-field-context-config',
    FORGE_GLOBAL: 'forge-spa-global',
    FORGE_PROJECT: 'forge-spa-project',
    FORGE_SERVICEDESK_QUEUE: 'forge-spa-servicedesk-queue',
    GLOBAL_ADMIN_HELPER_EMAIL_NOTIFICATIONS_LOG: 'global-admin-helper-email-notifications-log',
    GLOBAL_ISSUE_NAVIGATOR: 'global-issue-navigator',
    GLOBAL_ISSUE_NAVIGATOR_BROWSE_ISSUE_REDIRECT: 'global-issue-navigator-browse-issue-redirect',
    GLOBAL_MAIL_SETTINGS: 'global-mail-settings',
    GLOBAL_SETTINGS_CONTACT_ADMINISTRATOR: 'global-settings-contact-administrator',
    GLOBAL_SETTINGS_CUSTOM_FIELDS: 'global-settings-issues-custom-fields-view',
    GLOBAL_SETTINGS_EDIT_PERMISSION_SCHEMES: 'global-settings-edit-permissions-schemes',
    GLOBAL_SETTINGS_FIELD_LAYOUTS: 'global-settings-issues-fieldlayouts-view',
    GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES: 'global-settings-issues-fieldlayouts-schemes-view',
    GLOBAL_SETTINGS_FORM_DATA_CONNECTIONS: 'global-settings-form-data-connections',
    GLOBAL_SETTINGS_GLOBAL_PERMISSIONS: 'global-settings-global-permissions',
    GLOBAL_SETTINGS_ISSUES_LINK_TYPES: 'global-settings-issues-linktypes-view',
    GLOBAL_SETTINGS_ISSUES_NEW_ISSUE_SEARCH: 'global-settings-issues-new-issue-search',
    GLOBAL_SETTINGS_ISSUES_NEW_ISSUE_VIEW: 'global-settings-issues-new-issue-view',
    GLOBAL_SETTINGS_ISSUES_NOTIFICATION_VIEW: 'global-settings-issues-notification-view',
    GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES: 'global-settings-issues-permissions-schemes-view',
    GLOBAL_SETTINGS_ISSUES_PRIORITIES: 'global-settings-issues-priorities',
    GLOBAL_SETTINGS_ISSUES_PRIORITY_SCHEMES: 'global-settings-priority-schemes',
    GLOBAL_SETTINGS_ISSUES_RESOLUTIONS: 'global-settings-issues-resolutions',
    GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES: 'global-settings-issues-security-schemes',
    GLOBAL_SETTINGS_ISSUES_STATUSES: 'global-settings-issues-statuses',
    GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES: 'global-settings-issues-field-schemes-view',
    GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS: 'global-settings-issues-field-screens',
    GLOBAL_SETTINGS_ISSUE_HIERARCHY: 'global-settings-issues-hierarchy-view',
    GLOBAL_SETTINGS_ISSUE_HIERARCHY_REDIRECT: 'global-settings-issues-hierarchy-redirect',
    GLOBAL_SETTINGS_ISSUE_SUBTASKS: 'global-settings-issues-subtasks-manage',
    GLOBAL_SETTINGS_ISSUE_TIME_TRACKING: 'global-settings-issues-time-tracking',
    GLOBAL_SETTINGS_ISSUE_TYPES: 'global-settings-issues-types-view',
    GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES: 'global-settings-issues-types-schemes-manage',
    GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES: 'global-settings-issues-types-screen-schemes-view',
    GLOBAL_SETTINGS_ISSUE_WORKFLOW: 'global-settings-issues-workflows-pages',
    GLOBAL_SETTINGS_ISSUE_WORKFLOW_EDIT: 'global-settings-issues-workflow-edit',
    GLOBAL_SETTINGS_ISSUE_WORKFLOW_SCHEMES: 'global-settings-issues-workflows-schemes-view',
    GLOBAL_SETTINGS_MIGRATIONS_DASHBOARD: 'global-settings-migrations-dashboard',
    GLOBAL_SETTINGS_MIGRATIONS_FOCUS_PAGE: 'global-settings-migrations-focus-page',
    GLOBAL_SETTINGS_MIGRATIONS_HOME: 'global-settings-migrations-home',
    GLOBAL_SETTINGS_PERFORMANCE_CUSTOM_FIELD: 'global-settings-performance-custom-field',
    GLOBAL_SETTINGS_PERFORMANCE_ISSUE: 'global-settings-performance-issue',
    // This is an old route that is not used anymore. It is kept here for backward compatibility.
    GLOBAL_SETTINGS_PERFORMANCE_METRIC_DETAIL: 'global-settings-performance-metric-detail',
    GLOBAL_SETTINGS_PERFORMANCE_OVERVIEW: 'global-settings-performance-overview',
    GLOBAL_SETTINGS_PERFORMANCE_PROJECT_CLEANUP: 'global-settings-performance-project-cleanup',
    GLOBAL_SETTINGS_PERFORMANCE_PROJECT_ROLE_ACTOR: 'global-settings-performance-project-role-actor',
    GLOBAL_SETTINGS_PERMISSION_SCHEMES: 'global-settings-permissions-schemes',
    GLOBAL_SETTINGS_PRODUCTS_APPLICATION_LINKS: 'global-settings-products-applinks',
    GLOBAL_SETTINGS_PRODUCTS_DVCS: 'global-settings-products-dvcs',
    GLOBAL_SETTINGS_PRODUCTS_SDMAIL: 'global-settings-products-sdmail',
    GLOBAL_SETTINGS_PRODUCTS_STATUS_PAGE: 'global-settings-products-jsd-status',
    GLOBAL_SETTINGS_PROJECTS_CATEGORIES_VIEW: 'global-settings-projects-categories-view',
    GLOBAL_SETTINGS_SHARED_DASHBOARDS: 'global-settings-system-shared-dashboards',
    GLOBAL_SETTINGS_SYSTEM_ADMIN_NOTIFICATION_HELPER: 'global-settings-system-helper-notification',
    GLOBAL_SETTINGS_SYSTEM_ADMIN_PERMISSION_HELPER: 'global-settings-system-helper-permission',
    GLOBAL_SETTINGS_SYSTEM_ADVANCED_ATTACHMENTS: 'global-settings-system-attachments',
    GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS: 'global-settings-system-events',
    GLOBAL_SETTINGS_SYSTEM_ADVANCED_LEXORANK_MANAGEMENT: 'global-settings-system-lexorank',
    GLOBAL_SETTINGS_SYSTEM_ADVANCED_SERVICES: 'global-settings-system-services',
    GLOBAL_SETTINGS_SYSTEM_ADVANCED_WEBHOOKS: 'global-settings-system-webhooks',
    GLOBAL_SETTINGS_SYSTEM_BULK_MAIL: 'global-settings-system-bulk-mail',
    GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_BACKUP_MANAGER: 'global-settings-system-export',
    GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_CLOUD_OR_SERVER_IMPORT: 'global-settings-system-import-cloud',
    GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT: 'global-settings-system-import-external',
    GLOBAL_SETTINGS_SYSTEM_ISSUE_COLLECTORS: 'global-settings-system-collectors',
    GLOBAL_SETTINGS_SYSTEM_MAIL_GLOBAL_MAIL_SETTINGS: 'global-settings-system-mail-settings',
    GLOBAL_SETTINGS_SYSTEM_MAIL_INCOMING_MAIL: 'global-settings-system-mail-incoming',
    GLOBAL_SETTINGS_SYSTEM_MAIL_OUTGOING_MAIL: 'global-settings-system-mail-outgoing',
    GLOBAL_SETTINGS_SYSTEM_MAIL_SEND_MAIL: 'global-settings-system-mail-send',
    GLOBAL_SETTINGS_SYSTEM_SECURITY_GLOBAL_PERMISSIONS_OLD: 'global-settings-system-permissions',
    GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES: 'global-settings-system-roles-view',
    GLOBAL_SETTINGS_SYSTEM_SHARED_FILTERS: 'global-settings-system-shared-filters',
    GLOBAL_SETTINGS_SYSTEM_TROUBLESHOOTING_AUDIT_LOG: 'global-settings-system-auditing',
    GLOBAL_SETTINGS_SYSTEM_UI_ANNOUNCEMENT_BANNER: 'global-settings-system-ui-announcement-banner',
    GLOBAL_SETTINGS_SYSTEM_UI_LOOK_AND_FEEL: 'global-settings-system-look',
    GLOBAL_SETTINGS_SYSTEM_UI_USER_DEFAULTS: 'global-settings-system-default-settings',
    HOME_ONBOARDING_REDIRECT: 'home-onboarding-redirect',
    HOME_REDIRECT: 'home-redirect',
    ISSUE: 'issue',
    ISSUE_CREATE_EMBED: 'issue-create-embed',
    ISSUE_EMBED: 'issue-embed',
    JIRA_CONFIGURATOR: 'jira-configurator',
    JIRA_SEARCH: 'jira-search',
    KNOWLEDGE_HUB_ALL_ARTICLES: 'knowledge-hub-all-articles',
    KNOWLEDGE_HUB_ARTICLE_EMBED_EDITOR: 'kb-article-embed-editor',
    KNOWLEDGE_HUB_ARTICLE_IN_CATEGORY: 'knowledge-hub-article-in-category',
    KNOWLEDGE_HUB_BROWSE_ALL_ARTICLES: 'knowledge-hub-browse-all-articles',
    KNOWLEDGE_HUB_BROWSE_ALL_CATEGORIES: 'knowledge-hub-browse-all-categories',
    KNOWLEDGE_HUB_BROWSE_VIEW_ARTICLE: 'knowledge-hub-browse-view-article',
    KNOWLEDGE_HUB_CATEGORY: 'knowledge-hub-category',
    KNOWLEDGE_HUB_CATEGORY_PAGE: 'knowledge-hub-category-page',
    KNOWLEDGE_HUB_DRAFTS: 'knowledge-hub-drafts',
    KNOWLEDGE_HUB_LANDING: 'knowledge-hub-landing',
    KNOWLEDGE_HUB_SEARCH: 'knowledge-hub-search',
    KNOWLEDGE_HUB_SEARCH_ARTICLES: 'knowledge-hub-search-articles',
    KNOWLEDGE_HUB_SETUP: 'knowledge-hub-setup',
    KNOWLEDGE_HUB_SUGGESTED_ARTICLES: 'knowledge-hub-suggested-articles',
    LEGACY_ALL_REPORTS: 'legacy-all-reports',
    LEGACY_BACKLOG: 'legacy-backlog',
    LEGACY_BOARD: 'legacy-board',
    LEGACY_CONNECT_GENERAL: 'legacy-connect-general',
    LEGACY_CONNECT_PROJECT: 'legacy-connect-project',
    LEGACY_CORE_REPORTS: 'legacy-core-reports',
    LEGACY_CUSTOM_REPORT: 'legacy-custom-report',
    LEGACY_FALLBACK: 'legacy-fallback',
    LEGACY_GIN: 'legacy-gin',
    LEGACY_GIN_ISSUE: 'legacy-gin-issue',
    LEGACY_GIN_QUICKSEARCH: 'legacy-gin-quicksearch',
    LEGACY_ISSUE: 'legacy-issue',
    LEGACY_JSD_CUSTOMERS: 'legacy-jsd-customers',
    LEGACY_JSD_CUSTOMER_PERMISSIONS: 'legacy-jsd-customer-permissions',
    LEGACY_JSD_GETTING_STARTED: 'legacy-jsd-getting-started',
    LEGACY_JSD_JIRA_AUTOMATION: 'legacy-jsd-jira-automation',
    LEGACY_JSD_KNOWLEDGE: 'legacy-jsd-knowledge',
    LEGACY_JSD_QUEUES: 'legacy-jsd-queues',
    LEGACY_JSD_QUEUES_MANAGE: 'legacy-jsd-queues-manage',
    LEGACY_JSD_REPORTS: 'legacy-jsd-reports',
    LEGACY_JSD_REPORTS_CUSTOM: 'legacy-jsd-reports-custom',
    LEGACY_JSD_SETTINGS_FALLBACK: 'legacy-jsd-settings-fallback',
    LEGACY_JSD_SETTINGS_LANGUAGE: 'legacy-jsd-settings-language',
    LEGACY_JSD_SETTINGS_LANGUAGE_PAGES: 'legacy-jsd-settings-language-pages',
    LEGACY_JSD_SETTINGS_PORTAL: 'legacy-jsd-settings-portal-pages',
    LEGACY_JSD_WIDGETS: 'legacy-jsd-widgets',
    LEGACY_PIN: 'legacy-pin',
    LEGACY_PROJECT_RELEASES: 'legacy-project-releases',
    LEGACY_PROJECT_RELEASES_BAMBOO: 'legacy-project-releases-bamboo',
    LEGACY_PROJECT_RELEASES_NOTE: 'legacy-project-releases-note',
    LEGACY_PROJECT_RELEASES_NOTE_CONFIG: 'legacy-project-releases-note-config',
    LEGACY_PROJECT_SETTINGS_COLLECTORS: 'legacy-project-settings-collectors',
    LEGACY_PROJECT_SETTINGS_CONFIG: 'legacy-project-settings-config',
    LEGACY_PROJECT_SETTINGS_DATA_CLASSIFICATIONS: 'project-settings-classic-data-classifications',
    LEGACY_PROJECT_SETTINGS_DELETE: 'legacy-project-settings-delete',
    LEGACY_PROJECT_SETTINGS_DEV: 'legacy-project-settings-dev',
    LEGACY_PROJECT_SETTINGS_EDIT: 'legacy-project-settings-edit',
    LEGACY_PROJECT_SETTINGS_FIELDS: 'legacy-project-settings-fields',
    LEGACY_PROJECT_SETTINGS_ISSUE_LAYOUT: 'legacy-project-settings-issue-layout',
    LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY: 'legacy-project-settings-issue-security',
    LEGACY_PROJECT_SETTINGS_ISSUE_TYPES: 'legacy-project-settings-issue-types',
    LEGACY_PROJECT_SETTINGS_NOTIFICATIONS: 'legacy-project-settings-notifications',
    LEGACY_PROJECT_SETTINGS_OPSGENIE: 'legacy-project-settings-opsgenie',
    LEGACY_PROJECT_SETTINGS_PEOPLE: 'legacy-project-settings-people',
    LEGACY_PROJECT_SETTINGS_PERMISSIONS: 'legacy-project-settings-permissions',
    LEGACY_PROJECT_SETTINGS_SCREENS: 'legacy-project-settings-screens',
    LEGACY_PROJECT_SETTINGS_SUMMARY: 'legacy-project-settings-summary',
    LEGACY_PROJECT_SETTINGS_WORKFLOWS: 'legacy-project-settings-workflows',
    LEGACY_REDIRECT: 'legacy-redirect',
    LEGACY_REPORTS_AVERAGE_AGE: 'legacy-reports-average-age-report',
    LEGACY_REPORTS_CONFIG: 'legacy-reports-configure',
    LEGACY_REPORTS_CREATED_VS_RESOLVED: 'legacy-reports-created-vs-resolved-report',
    LEGACY_REPORTS_DEVELOPER_WORKLOAD: 'legacy-reports-developer-workload-report',
    LEGACY_REPORTS_PIE: 'legacy-reports-pie-report',
    LEGACY_REPORTS_RECENTLY_CREATED: 'legacy-reports-recently-created-report',
    LEGACY_REPORTS_RESOLUTION_TIME: 'legacy-reports-resolution-time-report',
    LEGACY_REPORTS_SINGLE_LEVEL_GROUP_BY: 'legacy-reports-single-level-group-by-report',
    LEGACY_REPORTS_TIME_SINCE: 'legacy-reports-time-since-report',
    LEGACY_REPORTS_TIME_TRACKING_REPORT: 'legacy-reports-time-tracking-report',
    LEGACY_REPORTS_VERSION_WORKLOAD: 'legacy-reports-version-workload-report',
    LEGACY_REPORTS_WORKLOAD_PIE: 'legacy-reports-workload-pie-report',
    LOGIN_EMBED: 'login-embed',
    MARKETPLACE_ADDONS_EMCEE: 'global-settings-addons-emcee',
    MARKETPLACE_ADDONS_EMCEE_PUBLIC: 'addons-emcee-public',
    MARKETPLACE_APP_REQUESTS: 'marketplace-app-requests',
    MARKETPLACE_INDEX: 'marketplace-index',
    MARKETPLACE_MANAGE_APPS: 'global-settings-addons-upm',
    MARKETPLACE_PROMOTIONS: 'marketplace-promotions',
    NOTIFICATION_LOGS: 'notification-logs',
    OPSGENIE_SCHEDULE: 'opsgenie-schedule',
    PEOPLE_INDEX: 'people-index',
    // legacy personal settings route
    PERSONAL_SETTINGS: 'personal-settings',
    // new personal settings route
    PERSONAL_SETTINGS_GENERAL: 'personal-settings-general',
    PERSONAL_SETTINGS_NOTIFICATIONS: 'personal-settings-notifications',
    PERSONAL_SETTINGS_OPS_NOTIFICATIONS: 'personal-settings-ops-notifications',
    PLANS_DIRECTORY: 'plans-directory',
    POLARIS_COLLECTIONS: 'polaris-collections',
    POLARIS_IDEAS: 'polaris-ideas',
    POLARIS_INSIGHTS: 'polaris-insights',
    POLARIS_ONBOARDING: 'polaris-onboarding',
    POLARIS_PLAYS: 'polaris-plays',
    POLARIS_ROOMS: 'polaris-rooms',
    POLARIS_SETTINGS_ACCESS: 'polaris-settings-access',
    POLARIS_SETTINGS_GLOBAL_FIELDS: 'polaris-settings-global-fields',
    POLARIS_UNLICENSED: 'polaris-unlicensed',
    PRODUCTS_JSM_AUTHENTICATION_SETTINGS: 'products-jsm-authentication-settings',
    PRODUCTS_JSM_CHATOPS_AND_VIDEOS_TOOLS: 'products-jsm-chatops-and-videos-tools',
    PRODUCTS_JSM_COMPLIANCE: 'products-jsm-compliance',
    PRODUCTS_JSM_CONFIGURATION: 'products-jsm-configuration',
    PRODUCTS_JSM_CUSTOMER_ACCESS: 'products-jsm-customer-access',
    PRODUCTS_JSM_EMAIL_REQUESTS: 'products-jsm-email-requests',
    PRODUCTS_JSM_FEATURE_USAGE: 'products-jsm-feature-usage',
    PRODUCTS_JSM_GLOBAL_OPS_REPORTS: 'products-jsm-global-ops-reports',
    PRODUCTS_JSM_INCIDENT_MANAGEMENT_TOOLS: 'products-jsm-incident-management-tools',
    PRODUCTS_JSM_KB_PERMISSIONS: 'products-jsm-kb-permissions',
    PRODUCTS_JSM_ORGANIZATIONS: 'products-jsm-organizations',
    PRODUCTS_JSW_CONFIGURATION: 'products-jsw-configuration',
    PRODUCTS_JSW_STORAGE_MANAGEMENT: 'products-jsw-storage-management',
    PROFORMA_EXPORT: 'proforma-export',
    PROFORMA_ISSUE_FORMS_DIRECT: 'proforma-issue-forms-direct',
    PROFORMA_ISSUE_FORMS_DIRECT_EMBED: 'proforma-issue-forms-direct-embed',
    PROFORMA_ISSUE_FORMS_GENERAL: 'proforma-issue-forms-general',
    PROJECTS_DIRECTORY: 'projects-directory',
    PROJECTS_DIRECTORY_LEGACY_PATH_SPA: 'projects-directory-legacy-path-spa',
    PROJECTS_DIRECTORY_MANAGE: 'projects-directory-manage',
    PROJECTS_REDIRECT: 'projects-redirect',
    PROJECT_COMPONENTS: 'project-components',
    PROJECT_DIRECTORY_REDIRECT: 'project-directory-redirect',
    PROJECT_ISSUE_NAVIGATOR: 'issue-navigator',
    PROJECT_ISSUE_NAVIGATOR_CLASSIC: 'issue-navigator-classic',
    PROJECT_ISSUE_NAVIGATOR_CORE: 'issue-navigator-core',
    PROJECT_PAGES: 'project-pages',
    PROJECT_SETTINGS_AUTOMATION: 'project-settings-automation',
    PROJECT_SETTINGS_COMPONENTS: 'project-settings-components',
    // business project settings routes
    PROJECT_SETTINGS_CORE_ACCESS: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_CORE}-access`,
    PROJECT_SETTINGS_CORE_ACCESS_REDIRECT: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_CORE}-access-redirect`,
    PROJECT_SETTINGS_CORE_APPROVALS: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_CORE}-approvals`,
    PROJECT_SETTINGS_CORE_APPS: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_CORE}-apps`,
    PROJECT_SETTINGS_CORE_APPS_FIELDS: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_CORE}-apps-fields`,
    PROJECT_SETTINGS_CORE_AUTOMATION: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_CORE}-automation`,
    PROJECT_SETTINGS_CORE_DATA_CLASSIFICATIONS: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_CORE}-data-classifications`,
    PROJECT_SETTINGS_CORE_DEFAULT_REDIRECT: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_CORE}-redirect`,
    PROJECT_SETTINGS_CORE_DETAILS: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_CORE}-details`,
    PROJECT_SETTINGS_CORE_FORGE_APPS: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_CORE}-forge-apps`,
    PROJECT_SETTINGS_CORE_ISSUE_TYPES: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_CORE}-issuetypes`,
    PROJECT_SETTINGS_CORE_ISSUE_TYPES_WORKFLOW: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_CORE}-issuetypes-workflow`,
    PROJECT_SETTINGS_CORE_NOTIFICATIONS: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_CORE}-notifications`,
    PROJECT_SETTINGS_CORE_NOTIFICATION_EMAIL: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_CORE}-notifications-notification-email`,
    PROJECT_SETTINGS_CORE_PROFORMA_JIRA_FORM_BUILDER: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_CORE}-proforma-jira-form-builder`,
    PROJECT_SETTINGS_CORE_PROFORMA_PROJECT_FORMS: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_CORE}-proforma-project-forms`,
    // end of business project settings
    PROJECT_SETTINGS_FORGE_APPS: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_SOFTWARE}-forge-apps`,
    // the following name format is required for the correct next-gen App sidebar rendering
    PROJECT_SETTINGS_FORGE_APPS_NEXTGEN: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_SOFTWARE}-apps-forge`,
    // JSM project setings routes
    PROJECT_SETTINGS_SERVICEDESK_CHAT: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_SERVICEDESK}-chat`,
    PROJECT_SETTINGS_SERVICEDESK_CLASSIC_CUSTOMER_NOTIFICATIONS: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_SERVICEDESK}-customer-notifications-classic`,
    PROJECT_SETTINGS_SERVICEDESK_CLASSIC_EMAIL_SETTINGS: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_SERVICEDESK}-email-classic`,
    PROJECT_SETTINGS_SERVICEDESK_DETAILS: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_SERVICEDESK}-details`,
    PROJECT_SETTINGS_SERVICEDESK_FORGE_APPS: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_SERVICEDESK}-forge-apps`,
    PROJECT_SETTINGS_SERVICEDESK_ITSM_REQUEST_TYPES: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_SERVICEDESK}-itsm-ticket-types-config`,
    PROJECT_SETTINGS_SERVICEDESK_ITSM_REQUEST_TYPES_FIELDS: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_SERVICEDESK}-itsm-ticket-type-fields`,
    PROJECT_SETTINGS_SERVICEDESK_NOTIFICATIONS: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_SERVICEDESK}-notifications`,
    PROJECT_SETTINGS_SERVICEDESK_NOTIFICATIONS_NOTIFICATION_EMAIL: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_SERVICEDESK}-notifications-notification-email`,
    PROJECT_SETTINGS_SERVICEDESK_PORTAL_SETTINGS: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_SERVICEDESK}-portal-settings`,
    PROJECT_SETTINGS_SERVICEDESK_REQUEST_TYPES: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_SERVICEDESK}-ticket-types-config`,
    PROJECT_SETTINGS_SERVICEDESK_REQUEST_TYPES_FIELDS: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_SERVICEDESK}-ticket-type-fields`,
    PROJECT_SETTINGS_SERVICEDESK_UNASSIGNED_REQUEST_TYPES: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_SERVICEDESK}-unassigned-ticket-types-config`,
    PROJECT_SETTINGS_SERVICEDESK_UNASSIGNED_REQUEST_TYPES_FIELDS: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_SERVICEDESK}-unassigned-ticket-type-fields`,
    // end of JSM project settings
    PROJECT_SETTINGS_SOFTWARE_ACCESS: 'project-settings-software-access',
    PROJECT_SETTINGS_SOFTWARE_BOARDS_CARD: 'project-settings-software-boards-card',
    PROJECT_SETTINGS_SOFTWARE_BOARDS_CSM: 'project-settings-software-boards-csm',
    PROJECT_SETTINGS_SOFTWARE_BOARDS_CUSTOM_FILTERS: 'project-settings-software-boards-custom-filters',
    PROJECT_SETTINGS_SOFTWARE_BOARDS_DETAILS: 'project-settings-software-boards-details',
    PROJECT_SETTINGS_SOFTWARE_BOARDS_FEATURES: 'project-settings-software-boards-features',
    PROJECT_SETTINGS_SOFTWARE_BOARDS_INSIGHTS: 'project-settings-software-boards-insights',
    PROJECT_SETTINGS_SOFTWARE_BOARDS_REDIRECT: 'project-settings-software-boards-redirect',
    PROJECT_SETTINGS_SOFTWARE_BOARDS_ROADMAP: 'project-settings-software-boards-roadmap',
    PROJECT_SETTINGS_SOFTWARE_BOARDS_SWIMLANES: 'project-settings-software-boards-swimlanes',
    PROJECT_SETTINGS_SOFTWARE_BOARDS_TIMELINE: 'project-settings-software-boards-timeline',
    PROJECT_SETTINGS_SOFTWARE_DETAILS: 'project-settings-software-details',
    PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_SOFTWARE}-notifications`,
    PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS_ISSUE_LOGS: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_SOFTWARE}-notifications-issue-logs`,
    PROJECT_SETTINGS_SOFTWARE_NOTIFICATION_EMAIL: 'project-settings-software-notifications-notification-email',
    PROJECT_SETTINGS_SOFTWARE_OPSGENIE: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_SOFTWARE}-link-opsgenie`,
    PROJECT_SETTINGS_TOOLCHAIN: `${$67f07001968fe110$export$9cb628d660b3e224.PROJECT_SETTINGS_SOFTWARE}-toolchain-team-managed`,
    PROJECT_SETTINGS_VERSIONS: 'project-settings-versions',
    PROJECT_VERSIONS: 'project-versions',
    RAPIDBOARD: 'rapidboard',
    RAPIDBOARD_BACKLOG: 'rapidboard-backlog',
    RAPIDBOARD_BOARD: 'rapidboard-board',
    RAPIDBOARD_BOARD_PRETTY_URL_REDIRECT: 'rapidboard-board-pretty-url-redirect',
    RAPIDBOARD_LAST_VISITED_PROJECT_REDIRECT: 'rapidboard-last-visited-project-redirect',
    RAPIDBOARD_REPORT: 'rapidboard-report',
    RAPIDBOARD_UIF_BACKLOG: 'rapidboard-uif-backlog',
    RAPIDBOARD_USER_BACKLOG: 'rapidboard-user-backlog',
    RAPIDBOARD_USER_BOARD: 'rapidboard-user-board',
    RAPIDBOARD_USER_REPORT: 'rapidboard-user-report',
    SERVICEDESK_ATLASSIAN_ANALYTICS: 'servicedesk-atlassian-analytics',
    SERVICEDESK_BOARDS: 'servicedesk-boards',
    SERVICEDESK_CALENDAR: 'servicedesk-calendar',
    SERVICEDESK_CALENDAR_EAP: 'servicedesk-calendar-eap',
    SERVICEDESK_CHANGE_CALENDAR: 'servicedesk-change-calendar',
    SERVICEDESK_CMDB_ASSETS_CONFIGURE: 'servicedesk-cmdb-configure',
    SERVICEDESK_CMDB_ASSETS_OBJECT: 'servicedesk-cmdb-object',
    SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA: 'servicedesk-cmdb-object-schema',
    SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA_CONFIGURATION: 'servicedesk-cmdb-object-schema-configuration',
    SERVICEDESK_CMDB_ASSETS_OBJECT_TYPE_CONFIGURATION: 'servicedesk-cmdb-object-type-configuration',
    SERVICEDESK_CMDB_ASSETS_REPORTS: 'servicedesk-cmdb-assets-reports',
    SERVICEDESK_CMDB_ASSETS_REPORTS_DEFAULT_REDIRECT: 'servicedesk-cmdb-assets-reports-default-redirect',
    SERVICEDESK_CMDB_ASSETS_REPORTS_UNSUBSCRIBE: 'servicedesk-cmdb-assets-reports-unsubscribe',
    SERVICEDESK_CMDB_INSIGHT: 'servicedesk-cmdb-manage-object-schemas',
    SERVICEDESK_CMDB_INSIGHT_CONFIGURE: 'servicedesk-cmdb-configure',
    SERVICEDESK_CMDB_INSIGHT_LANDING_PAGE: 'servicedesk-cmdb-landing-page',
    SERVICEDESK_CMDB_INSIGHT_OBJECT: 'servicedesk-cmdb-object',
    SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA: 'servicedesk-cmdb-object-schema',
    SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA_CONFIGURATION: 'servicedesk-cmdb-object-schema-configuration',
    SERVICEDESK_CMDB_INSIGHT_OBJECT_TYPE_CONFIGURATION: 'servicedesk-cmdb-object-type-configuration',
    SERVICEDESK_CONNECT_PROJECT: 'servicedesk-connect-project',
    SERVICEDESK_CREATE_PROJECT: 'servicedesk-create-project',
    SERVICEDESK_CUSTOMERS_V2: 'servicedesk-customers-v2',
    SERVICEDESK_CUSTOMER_DETAILS: 'servicedesk-customer-details',
    SERVICEDESK_CUSTOMER_SERVICE_ESCALATIONS: 'servicedesk-customer-service-escalations',
    SERVICEDESK_CUSTOMER_SERVICE_PRODUCTS: 'servicedesk-customer-service-products',
    SERVICEDESK_EARLY_ACCESS_ITSM: 'servicedesk-early-access-itsm',
    SERVICEDESK_GETTING_STARTED_PAGE: 'servicedesk-getting-started-page',
    SERVICEDESK_INCIDENTS: 'servicedesk-incidents',
    SERVICEDESK_INDEX: 'servicedesk-index',
    SERVICEDESK_ISSUE: 'servicedesk-issue',
    SERVICEDESK_ISSUES: 'servicedesk-issues',
    SERVICEDESK_ITSM_SAMPLE_SPACE: 'servicedesk-itsm-sample-space',
    SERVICEDESK_JIRA_AUTOMATION: 'servicedesk-automation',
    SERVICEDESK_KB_REQUESTS_REPORTS: 'servicedesk-kb-requests-reports',
    SERVICEDESK_KB_REQUESTS_REPORTS_ISSUE: 'servicedesk-kb-requests-reports-time-scale-issue',
    SERVICEDESK_KB_REQUESTS_REPORTS_TIME_SCALE: 'servicedesk-kb-requests-reports-time-scale',
    SERVICEDESK_ONCALL_SCHEDULE: 'servicedesk-oncall-schedule',
    SERVICEDESK_ORGANIZATIONS: 'servicedesk-organizations',
    SERVICEDESK_ORGANIZATION_DETAILS: 'servicedesk-organization-details',
    SERVICEDESK_ORGANIZATION_V2: 'servicedesk-organization_v2',
    SERVICEDESK_PRACTICE_CUSTOM_AND_ISSUE: 'servicedesk-practice-custom-and-issue',
    SERVICEDESK_PRACTICE_EDIT: 'servicedesk-practice-edit',
    SERVICEDESK_PRACTICE_ISSUE: 'servicedesk-practice-issue',
    SERVICEDESK_PRACTICE_LANDING: 'servicedesk-practice-landing',
    SERVICEDESK_PRACTICE_MANAGE_VIEW: 'servicedesk-practice-manage-view',
    SERVICEDESK_PRACTICE_NEW: 'servicedesk-practice-new',
    SERVICEDESK_PROJECT_CONVERSION: 'servicedesk-project-conversion',
    SERVICEDESK_QUEUES_ADDON: 'servicedesk-queues-addon',
    SERVICEDESK_QUEUES_CUSTOM_AND_ISSUE: 'servicedesk-queues-custom-and-issue',
    SERVICEDESK_QUEUES_EDIT: 'servicedesk-queues-edit',
    SERVICEDESK_QUEUES_ISSUE: 'servicedesk-queues-issue',
    SERVICEDESK_QUEUES_LANDING: 'servicedesk-queues-landing',
    SERVICEDESK_QUEUES_MANAGE_VIEW: 'servicedesk-queues-manage-view',
    SERVICEDESK_QUEUES_NEW: 'servicedesk-queues-new',
    SERVICEDESK_REDIRECT: 'servicedesk-redirect',
    SERVICEDESK_REPORTS: 'servicedesk-reports',
    SERVICEDESK_REPORTS_CUSTOM: 'servicedesk-reports-custom',
    SERVICEDESK_REPORTS_CUSTOM_CREATE: 'servicedesk-reports-custom-create',
    SERVICEDESK_REPORTS_CUSTOM_EDIT: 'servicedesk-reports-custom-edit',
    SERVICEDESK_REPORTS_CUSTOM_ISSUE: 'servicedesk-reports-custom-time-scale-issue',
    SERVICEDESK_REPORTS_CUSTOM_TIME_SCALE: 'servicedesk-reports-custom-time-scale',
    SERVICEDESK_REPORTS_SATISFACTION: 'servicedesk-reports-satisfaction',
    SERVICEDESK_REPORTS_SATISFACTION_ISSUE: 'servicedesk-reports-satisfaction-time-scale-issue',
    SERVICEDESK_REPORTS_SATISFACTION_TIME_SCALE: 'servicedesk-reports-satisfaction-time-scale',
    SERVICEDESK_REPORTS_SUMMARY: 'servicedesk-reports-summary',
    SERVICEDESK_REPORTS_TYPE: 'servicedesk-reports-type',
    SERVICEDESK_REPORTS_WORKLOAD: 'servicedesk-reports-workload',
    SERVICEDESK_SERVICES: 'servicedesk-services',
    SERVICEDESK_SERVICES_NEW: 'servicedesk-services-new',
    SERVICEDESK_SERVICES_WITHOUT_PROJECT: 'servicedesk-services-without-project',
    SERVICEDESK_SERVICE_DETAILS: 'servicedesk-service-details',
    SERVICEDESK_SERVICE_DETAILS_NEW: 'servicedesk-service-details-new',
    SERVICEDESK_SERVICE_DETAILS_WITHOUT_PROJECT: 'servicedesk-service-details-without-project',
    SERVICEDESK_SERVICE_MODAL_EDIT: 'servicedesk-service-modal-edit',
    SERVICEDESK_SERVICE_MODAL_NEW: 'servicedesk-service-modal-new',
    SERVICEDESK_SLA_SETTINGS: 'servicedesk-sla-settings',
    SERVICE_HUB_SERVICES: 'service-hub-services',
    SERVICE_HUB_SERVICE_DETAILS: 'service-hub-service-details',
    SETTINGS_AUTOMATION: 'global-automation',
    SETTINGS_CMDB_FIELD_CONFIG: 'settings-cmdb-field-config',
    SETTINGS_OAUTH_CREDENTIALS: 'admin-oauth-credentials',
    SETTINGS_RECOMMENDATIONS: 'recommendations',
    SETTINGS_VIEW_CUSTOM_FIELDS: 'view-custom-fields',
    SOFTWARE_ADVANCED_ROADMAPS: 'software-advanced-roadmaps',
    SOFTWARE_ADVANCED_ROADMAPS_GETTING_STARTED_REDIRECT: 'software-advanced-roadmaps-getting-started-redirect',
    SOFTWARE_ADVANCED_ROADMAPS_REDIRECT: 'software-advanced-roadmaps-redirect',
    SOFTWARE_ADVANCED_ROADMAPS_SETUP: 'software-advanced-roadmaps-setup',
    SOFTWARE_ARJ_SETTINGS_DEPENDENCIES: `${$67f07001968fe110$export$9cb628d660b3e224.ARJ_SETTINGS}-dependencies`,
    SOFTWARE_ARJ_SETTINGS_DEPENDENCIES_REDIRECT: `${$67f07001968fe110$export$9cb628d660b3e224.ARJ_SETTINGS}-dependencies-redirect`,
    SOFTWARE_ARJ_SETTINGS_FINANCIAL_YEAR: `${$67f07001968fe110$export$9cb628d660b3e224.ARJ_SETTINGS}-financial-year`,
    SOFTWARE_ARJ_SETTINGS_LOADING_LIMITS: `${$67f07001968fe110$export$9cb628d660b3e224.ARJ_SETTINGS}-loading-limits`,
    SOFTWARE_ARJ_SETTINGS_LOADING_LIMITS_REDIRECT: `${$67f07001968fe110$export$9cb628d660b3e224.ARJ_SETTINGS}-loading-limits-redirect`,
    SOFTWARE_ARJ_SETTINGS_PERMISSIONS: `${$67f07001968fe110$export$9cb628d660b3e224.ARJ_SETTINGS}-permissions`,
    SOFTWARE_ARJ_SETTINGS_PERMISSIONS_REDIRECT: `${$67f07001968fe110$export$9cb628d660b3e224.ARJ_SETTINGS}-permissions-redirect`,
    SOFTWARE_BACKLOG: 'software-backlog',
    SOFTWARE_BOARDS: 'software-boards',
    SOFTWARE_CALENDAR: 'software-calendar',
    SOFTWARE_CALENDAR_CLASSIC: 'software-calendar-classic',
    SOFTWARE_CALENDAR_CLASSIC_EMBED: 'software-calendar-classic-embed',
    SOFTWARE_CALENDAR_EMBED: 'software-calendar-embed',
    SOFTWARE_CLASSIC_PROFORMA_ISSUE_FORMS_DIRECT: `${$67f07001968fe110$export$9cb628d660b3e224.CLASSIC_SOFTWARE}-proforma-issue-forms-direct`,
    SOFTWARE_CLASSIC_PROFORMA_ISSUE_FORMS_DIRECT_EMBED: `${$67f07001968fe110$export$9cb628d660b3e224.CLASSIC_SOFTWARE}-proforma-issue-forms-direct-embed`,
    SOFTWARE_CODE: 'software-code',
    SOFTWARE_CODE_CLASSIC: 'software-code-classic',
    SOFTWARE_DEPLOYMENTS: 'software-deployments',
    SOFTWARE_DEPLOYMENTS_CLASSIC: 'software-deployments-classic',
    SOFTWARE_GOALS: 'software-goals',
    SOFTWARE_GOALS_CLASSIC: 'software-goals-classic',
    SOFTWARE_INCIDENTS: 'software-incidents',
    SOFTWARE_INCIDENTS_CLASSIC: 'software-incidents-classic',
    SOFTWARE_ISSUE_NAVIGATOR: 'software-issue-navigator',
    SOFTWARE_LIST: 'software-list',
    SOFTWARE_LIST_CLASSIC: 'software-list-classic',
    SOFTWARE_LIST_CLASSIC_EMBED: 'software-list-classic-embed',
    SOFTWARE_LIST_EMBED: 'software-list-embed',
    SOFTWARE_NEXTGEN_REDIRECT: 'software-nextgen-redirect',
    SOFTWARE_ONBOARDING: 'software-onboarding',
    SOFTWARE_PERISCOPE: 'software-periscope',
    SOFTWARE_PERISCOPE_CLASSIC: 'software-periscope-classic',
    SOFTWARE_PLAN_CALENDAR: 'software-plan-calendar',
    SOFTWARE_PLAN_DEPENDENCIES: 'software-plan-dependencies',
    SOFTWARE_PLAN_INCREMENT: 'software-plan-increment',
    SOFTWARE_PLAN_INCREMENTS: 'software-plan-increments',
    SOFTWARE_PLAN_RELEASES: 'software-plan-releases',
    SOFTWARE_PLAN_SETTINGS_AUTO_SCHEDULER: `${$67f07001968fe110$export$9cb628d660b3e224.PLAN_SETTINGS}-auto-scheduler`,
    SOFTWARE_PLAN_SETTINGS_CUSTOM_FIELDS: `${$67f07001968fe110$export$9cb628d660b3e224.PLAN_SETTINGS}-custom-fields`,
    SOFTWARE_PLAN_SETTINGS_EXCLUSION_RULES: `${$67f07001968fe110$export$9cb628d660b3e224.PLAN_SETTINGS}-exclusion-rules`,
    SOFTWARE_PLAN_SETTINGS_FIND_YOUR_ISSUE: `${$67f07001968fe110$export$9cb628d660b3e224.PLAN_SETTINGS}-find-your-issue`,
    SOFTWARE_PLAN_SETTINGS_ISSUE_SOURCES: `${$67f07001968fe110$export$9cb628d660b3e224.PLAN_SETTINGS}-issue-sources`,
    SOFTWARE_PLAN_SETTINGS_PERMISSIONS: `${$67f07001968fe110$export$9cb628d660b3e224.PLAN_SETTINGS}-permissions`,
    SOFTWARE_PLAN_SETTINGS_PLAN_INFO: `${$67f07001968fe110$export$9cb628d660b3e224.PLAN_SETTINGS}-plan-info`,
    SOFTWARE_PLAN_SETTINGS_PROGRAM_BOARDS: `${$67f07001968fe110$export$9cb628d660b3e224.PLAN_SETTINGS}-program-boards`,
    SOFTWARE_PLAN_SETTINGS_REMOVED_ISSUES: `${$67f07001968fe110$export$9cb628d660b3e224.PLAN_SETTINGS}-removed-issues`,
    SOFTWARE_PLAN_SETTINGS_SAVED_VIEWS: `${$67f07001968fe110$export$9cb628d660b3e224.PLAN_SETTINGS}-saved-views`,
    SOFTWARE_PLAN_SETTINGS_SCENARIOS: `${$67f07001968fe110$export$9cb628d660b3e224.PLAN_SETTINGS}-scenarios`,
    SOFTWARE_PLAN_SETTINGS_SCHEDULING: `${$67f07001968fe110$export$9cb628d660b3e224.PLAN_SETTINGS}-scheduling`,
    SOFTWARE_PLAN_SUMMARY: 'software-plan-summary',
    SOFTWARE_PLAN_TEAMS: 'software-plan-teams',
    SOFTWARE_PLAN_TIMELINE: 'software-plan-timeline',
    SOFTWARE_PRESENTATION_TOOLKIT_REPORT: 'software-presentation-toolkit-report',
    SOFTWARE_RELEASE_NOTES: 'software-release-notes',
    SOFTWARE_REPORTS: 'software-reports',
    SOFTWARE_REPORTS_BURNDOWN: 'software-reports-burndown',
    SOFTWARE_REPORTS_BURNUP: 'software-reports-burnup',
    SOFTWARE_REPORTS_CUMULATIVE: 'software-reports-cumulative',
    SOFTWARE_REPORTS_CYCLE_TIME: 'software-reports-cycle-time',
    SOFTWARE_REPORTS_CYCLE_TIME_CLASSIC: 'software-reports-cycle-time-classic',
    SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY: 'software-reports-deployment-frequency',
    SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY_CLASSIC: 'software-reports-deployment-frequency-classic',
    SOFTWARE_REPORTS_VELOCITY: 'software-reports-velocity',
    SOFTWARE_REQUESTS: 'software-requests',
    SOFTWARE_REQUESTS_CLASSIC: 'software-requests-classic',
    SOFTWARE_ROADMAP: 'software-roadmap',
    SOFTWARE_ROADMAP_CLASSIC: 'software-roadmap-classic',
    SOFTWARE_ROADMAP_REDIRECT: 'software-roadmap-redirect',
    SOFTWARE_SECURITY: 'software-security',
    SOFTWARE_SECURITY_CLASSIC: 'software-security-classic',
    SOFTWARE_TIMELINE: 'software-timeline',
    SOFTWARE_TIMELINE_CLASSIC: 'software-timeline-classic',
    SOFTWARE_VERSION_DETAIL: 'software-version-detail',
    SOFTWARE_VERSION_DETAIL_LEGACY_REDIRECT: 'software-version-detail-legacy-redirect',
    SOFTWARE_VERSION_DETAIL_NO_TAB_PATH: 'software-version-detail-no-tab-path',
    SYSTEM_CONFIGURATION: 'system-configuration-general',
    SYSTEM_DASHBOARD_EDIT: 'system-dashboard-edit',
    TRASHED_PLAN_DIRECT_LINK: 'trashed-plan-direct-link',
    TRASH_PLANS_DIRECTORY: 'trash-plans-directory',
    TRASH_PROJECTS_DIRECTORY: 'trash-projects-directory',
    YOUR_WORK: 'your-work'
};
const $67f07001968fe110$export$a8aac2ba4dc1f57 = new Set([
    $67f07001968fe110$export$6c85e878a3c25536.CLASSIC_BUSINESS_OVERVIEW_SUMMARY,
    $67f07001968fe110$export$6c85e878a3c25536.CLASSIC_BUSINESS_OVERVIEW_CALENDAR,
    $67f07001968fe110$export$6c85e878a3c25536.CLASSIC_BUSINESS_OVERVIEW_TIMELINE,
    $67f07001968fe110$export$6c85e878a3c25536.CLASSIC_BUSINESS_OVERVIEW_REDIRECT
]);
const $67f07001968fe110$export$c47bf667d3008c53 = new Set([
    $67f07001968fe110$export$6c85e878a3c25536.CONNECT_PROJECT,
    $67f07001968fe110$export$6c85e878a3c25536.CONNECT_GENERAL,
    $67f07001968fe110$export$6c85e878a3c25536.CONNECT_GENERAL_SERVICE_DESK_PROJECT,
    $67f07001968fe110$export$6c85e878a3c25536.LEGACY_CONNECT_PROJECT,
    $67f07001968fe110$export$6c85e878a3c25536.LEGACY_CONNECT_GENERAL
]);

});


parcelRegister("cQcOl", function(module, exports) {

$parcel$export(module.exports, "generateLoadingBarStyles", () => $1e0ebc570d6f522b$export$3036104bc81246b1);

var $c9TLT = parcelRequire("c9TLT");

var $1Xxlz = parcelRequire("1Xxlz");
const $1e0ebc570d6f522b$export$3036104bc81246b1 = (initalProgressValue, loadingBarColor)=>`
    content: '';
    display: block;
    background: ${loadingBarColor};
    height: 3px;
    z-index: ${(0, $c9TLT.layers).navigation + 10};
    width: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    transform: scaleX(${initalProgressValue});
    transform-origin: 0 0;
    will-change: transform;
`;
const $1e0ebc570d6f522b$export$85e33a4b3d661500 = (initialProgressValue = 0.3)=>`
        <style id=${0, $1Xxlz.LOADER_STYLESHEET_ID}>
            ${0, $1Xxlz.LOADER_STYLES_CSS_SELECTOR} {${$1e0ebc570d6f522b$export$3036104bc81246b1(initialProgressValue, (0, $1Xxlz.getLoadingBarColor)())}}
        </style>`;

});
parcelRegister("c9TLT", function(module, exports) {

$parcel$export(module.exports, "gridSize", () => $d7c0be4143e494a4$export$6d8204c2cb2e06b8);
$parcel$export(module.exports, "borderRadius", () => $d7c0be4143e494a4$export$7a57f79000377ca2);
$parcel$export(module.exports, "fontSize", () => $d7c0be4143e494a4$export$85e3c3ca0c6fb93);
$parcel$export(module.exports, "fontFamily", () => $d7c0be4143e494a4$export$a5975749f0374264);
$parcel$export(module.exports, "codeFontFamily", () => $d7c0be4143e494a4$export$356129969ee49c55);
$parcel$export(module.exports, "contentHorizontalSpacing", () => $d7c0be4143e494a4$export$22dec01f2c854397);
$parcel$export(module.exports, "layers", () => $d7c0be4143e494a4$export$7be255094ccdc533);
$parcel$export(module.exports, "layout", () => $d7c0be4143e494a4$export$b3219800bda33a1f);

var $lcnyw = parcelRequire("lcnyw");
const $d7c0be4143e494a4$export$6d8204c2cb2e06b8 = (0, $lcnyw.gridSize)();
const $d7c0be4143e494a4$export$7a57f79000377ca2 = (0, $lcnyw.borderRadius)();
const $d7c0be4143e494a4$export$85e3c3ca0c6fb93 = (0, $lcnyw.fontSize)();
const $d7c0be4143e494a4$export$a5975749f0374264 = (0, $lcnyw.fontFamily)();
const $d7c0be4143e494a4$export$356129969ee49c55 = (0, $lcnyw.codeFontFamily)();
const $d7c0be4143e494a4$export$22dec01f2c854397 = 40;
const $d7c0be4143e494a4$export$dab5ea164c6f81a = 100;
const $d7c0be4143e494a4$export$7be255094ccdc533 = {
    banner: (0, $lcnyw.layers).navigation(),
    card: (0, $lcnyw.layers).card(),
    dialog: (0, $lcnyw.layers).dialog(),
    navigation: (0, $lcnyw.layers).navigation(),
    // left sidebar overrides the bottom shadow of navigation without this
    leftSidebar: (0, $lcnyw.layers).navigation() - 1,
    // right sidebar shows on top of navigation elements without this
    rightSidebar: (0, $lcnyw.layers).navigation() - 1,
    layer: (0, $lcnyw.layers).layer(),
    blanket: (0, $lcnyw.layers).blanket(),
    modal: (0, $lcnyw.layers).modal(),
    flag: (0, $lcnyw.layers).flag(),
    spotlight: (0, $lcnyw.layers).spotlight(),
    tooltip: (0, $lcnyw.layers).tooltip(),
    mobileBanner: $d7c0be4143e494a4$export$dab5ea164c6f81a
};
const $d7c0be4143e494a4$export$b3219800bda33a1f = {
    issueIconSize: $d7c0be4143e494a4$export$6d8204c2cb2e06b8 * 2
};

});



parcelRegister("jxIns", function(module, exports) {

$parcel$export(module.exports, "SafeHelpPanel", () => $3dbb567424a9f7a3$export$cd2ada2fb14048fc);

var $eUqFw = parcelRequire("eUqFw");

var $48bs8 = parcelRequire("48bs8");

var $0cdA8 = parcelRequire("0cdA8");

var $f2Poq = parcelRequire("f2Poq");
var $3xHvd = parcelRequire("3xHvd");

var $antaP = parcelRequire("antaP");
var $1zRTT = parcelRequire("1zRTT");

var $bUi2Q = parcelRequire("bUi2Q");

var $6vrw7 = parcelRequire("6vrw7");

var $dxcfv = parcelRequire("dxcfv");
const $3dbb567424a9f7a3$var$HelpPanel = ()=>{
    const [{ navigationData: navigationData, releaseNotesNotifications: releaseNotesNotifications }, { setNavigationData: setNavigationData, setReleaseNotesNotifications: setReleaseNotesNotifications }] = (0, $1zRTT.useHelpPanel)();
    const { closeRightSidebar: closeRightSidebar } = (0, $bUi2Q.useRightSidebarController)();
    const rightSidebarCurrentState = (0, $bUi2Q.useActiveRightSidebarState)();
    const accountId = (0, $dxcfv.useAccountId)();
    const baseUrl = (0, $6vrw7.toBaseUrl)('');
    (0, $eUqFw.useEffect)(()=>{
        const restoreReleaseNotesNotifications = async ()=>{
            if (accountId) try {
                // @ts-expect-error - Property 'helpPanel' does not exist on type 'unknown'.
                const { helpPanel: userPropertiesHelpPanelValue } = await (0, $48bs8.getUserProperty)(baseUrl, accountId, (0, $119e8efb1068ef73$export$783d7c02e3a0cbf));
                setReleaseNotesNotifications(userPropertiesHelpPanelValue.releaseNotesNotifications);
            } catch (err) {
                /* getUserProperty throws if not found */ setReleaseNotesNotifications(0);
            }
            else setReleaseNotesNotifications(0);
        };
        restoreReleaseNotesNotifications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $antaP.RemoteStateUpdater), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3xHvd.LazyHelpPanel), {
        isOpen: !rightSidebarCurrentState?.isCollapsed,
        navigationData: navigationData,
        releaseNotesNotifications: releaseNotesNotifications,
        setNavigationData: setNavigationData,
        releaseNotesNotificationsSetter: setReleaseNotesNotifications,
        hasBeenRendered: !rightSidebarCurrentState?.isCollapsed,
        onCloseHelpPanel: closeRightSidebar
    }));
};
const $3dbb567424a9f7a3$var$HelpPanelInLayout = ()=>{
    const rightSidebarCurrentState = (0, $bUi2Q.useActiveRightSidebarState)();
    const [localPanelId, setLocalPanelId] = (0, $eUqFw.useState)();
    const prevPanelIdRef = (0, $eUqFw.useRef)();
    const delayRef = (0, $eUqFw.useRef)(null);
    const panelId = rightSidebarCurrentState?.panelId;
    /**
	 * This use effect is used to add (when is necessary) a delay
	 * in the panelId => localPanelId syncing
	 */ (0, $eUqFw.useEffect)(()=>{
        // @ts-expect-error - TS2769 - No overload matches this call.
        clearTimeout(delayRef.current);
        if (prevPanelIdRef.current === (0, $f2Poq.HELP_PANEL_ID)) {
            /**
			 * The right-sidebar is showing the help-panel...
			 */ if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) /**
				 * and is open, not collapsed and we want to show a panel
				 * with an ID !== HELP_PANEL_ID
				 */ setLocalPanelId(panelId);
            else /**
				 * and we want to close it
				 */ delayRef.current = setTimeout(()=>{
                setLocalPanelId(panelId);
            }, 310);
        } else /**
			 * If the right sidebar is not showing the help-panel,
			 * we just keep localPanelId in sync with panelId
			 */ setLocalPanelId(panelId);
        prevPanelIdRef.current = panelId;
        // @ts-expect-error - TS2769 - No overload matches this call.
        return ()=>clearTimeout(delayRef.current);
    }, [
        panelId,
        rightSidebarCurrentState
    ]);
    if (localPanelId !== (0, $f2Poq.HELP_PANEL_ID)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3dbb567424a9f7a3$var$HelpPanel, null);
};
const $3dbb567424a9f7a3$export$cd2ada2fb14048fc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-side-help-panel",
        packageName: "@atlassian/jira-help-panel-right-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3dbb567424a9f7a3$var$HelpPanelInLayout, null));

});
parcelRegister("f2Poq", function(module, exports) {

$parcel$export(module.exports, "HELP_PANEL_VERSION", () => $482b44340b421724$export$c43c7444da662fa1);
$parcel$export(module.exports, "HELP_PANEL_ID", () => $482b44340b421724$export$e99efa3985fa3c26);
$parcel$export(module.exports, "HELP_PANEL_WIDTH", () => $482b44340b421724$export$23aa6670f346c214);
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles

var $c9TLT = parcelRequire("c9TLT");
const $482b44340b421724$export$c43c7444da662fa1 = '1';
const $482b44340b421724$export$e99efa3985fa3c26 = 'helpPanel';
const $482b44340b421724$export$23aa6670f346c214 = (0, $c9TLT.gridSize) * 46;

});

parcelRegister("3xHvd", function(module, exports) {

$parcel$export(module.exports, "LazyHelpPanel", () => $a88134428dafae47$export$51c79455aef7d178);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $aR8n6 = parcelRequire("aR8n6");

var $79xbN = parcelRequire("79xbN");

var $gGtKh = parcelRequire("gGtKh");

var $cWiVr = parcelRequire("cWiVr");

var $8WuJm = parcelRequire("8WuJm");

var $enMj3 = parcelRequire("enMj3");

var $bZhE6 = parcelRequire("bZhE6");
const $a88134428dafae47$export$51c79455aef7d178 = ({ navigationData: { articleId: articleId, history: history }, setNavigationData: setNavigationData, releaseNotesNotifications: releaseNotesNotifications, releaseNotesNotificationsSetter: releaseNotesNotificationsSetter, isOpen: isOpen, onCloseHelpPanel: onCloseHelpPanel, hasBeenRendered: hasBeenRendered, routeGroup: routeGroup, routeName: routeName })=>{
    const user = (0, $cWiVr.useCurrentUser)();
    const IPH_USE_HELP_AGGREGATOR_FLAG = (0, $79xbN.expVal)('20240422_self_help_iph_ms3_expt', 'iph_ms3_experience_display_flag', false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "help-panel",
        packageName: "jiraHelpPanel",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $enMj3.default), {
                loadingArticle: articleId.id !== ''
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
        id: "root",
        packageName: "jiraHelpPanel",
        teamName: "self-help-experiences"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        tags: [
            'iph'
        ],
        sourceName: "jiraHelpPanel",
        sourceType: (0, $41ea3621645e2acc$export$9d2de6eebf7462b5),
        attributes: {
            searchService: IPH_USE_HELP_AGGREGATOR_FLAG ? 'help-aggregator' : 'algolia',
            routeGroup: routeGroup,
            routeName: routeName,
            userId: user?.data?.user?.accountId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rh0R.LazyWait), {
        until: hasBeenRendered
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-lazy-help-panel",
        fallback: isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $enMj3.default), {
            loadingArticle: articleId.id !== ''
        }) : null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bZhE6.AsyncLazyHelpPanel), {
        navigationData: {
            articleId: articleId,
            history: history
        },
        releaseNotesNotificationsSetter: releaseNotesNotificationsSetter,
        releaseNotesNotifications: releaseNotesNotifications,
        setNavigationData: setNavigationData,
        isOpen: isOpen,
        onCloseHelpPanel: onCloseHelpPanel,
        routeGroup: routeGroup,
        routeName: routeName
    }))))));
};

});
parcelRegister("79xbN", function(module, exports) {

$parcel$export(module.exports, "expVal", () => $2783c762502a41a6$export$9db1624a8af791a4);
$parcel$export(module.exports, "expValEquals", () => $2783c762502a41a6$export$45abdb3f977b5b14);
$parcel$export(module.exports, "UNSAFE_noExposureExp", () => $2783c762502a41a6$export$677f9fa2e1ae6fec);

var $8tM2T = parcelRequire("8tM2T");

var $9bn72 = parcelRequire("9bn72");

var $3WQZN = parcelRequire("3WQZN");
function $2783c762502a41a6$export$9db1624a8af791a4(experimentName, param, defaultValue) {
    // Handle vendorless scripts use of gates
    (0, $9bn72.UNSAFE_initIfNeeded)();
    const value = (0, $8tM2T.default).getExperimentValue(experimentName, param, defaultValue);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $3WQZN.addFeatureFlagAccessed)(`${experimentName}:${param}`, value);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return value;
}
function $2783c762502a41a6$export$45abdb3f977b5b14(experimentName, param, comparatorValue) {
    return $2783c762502a41a6$export$9db1624a8af791a4(experimentName, param, null) === comparatorValue;
}
class $2783c762502a41a6$var$ExperimentConfig {
    constructor(experimentName, config){
        this._experimentName = experimentName;
        this._config = config;
    }
    get(key, defaultValue, typeGuard) {
        const value = this._config.get(key, defaultValue, typeGuard);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $3WQZN.addFeatureFlagAccessed)(`${this._experimentName}:${key}`, value);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return value;
    }
}
const $2783c762502a41a6$var$cache = new Map();
function $2783c762502a41a6$export$677f9fa2e1ae6fec(experimentName) {
    let instance = $2783c762502a41a6$var$cache.get(experimentName);
    if (instance == null) {
        // Handle vendorless scripts use of gates
        (0, $9bn72.UNSAFE_initIfNeeded)();
        const config = (0, $8tM2T.default).getExperiment(experimentName, {
            fireExperimentExposure: false
        });
        const fireExposure = ()=>(0, $8tM2T.default).manuallyLogExperimentExposure(experimentName);
        instance = [
            new $2783c762502a41a6$var$ExperimentConfig(experimentName, config),
            fireExposure
        ];
        $2783c762502a41a6$var$cache.set(experimentName, instance);
    }
    return instance;
}

});

parcelRegister("cWiVr", function(module, exports) {

$parcel$export(module.exports, "useCurrentUser", () => $59f9598ada60a2a8$export$3901076af3749fa9);

var $eUqFw = parcelRequire("eUqFw");

var $ao0hp = parcelRequire("ao0hp");

var $gd0Sp = parcelRequire("gd0Sp");

var $lGLse = parcelRequire("lGLse");
const $59f9598ada60a2a8$var$useCurrentUserBasic = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return (0, $eUqFw.useMemo)(()=>({
            data: {
                user: {
                    accountId: tenantContext.atlassianAccountId,
                    isAdmin: tenantContext.isAdmin,
                    isAnonymous: tenantContext.isAnonymous,
                    isSiteAdmin: tenantContext.isSiteAdmin,
                    locale: tenantContext.locale || (0, $ao0hp.defaultLocale),
                    siteAdminStatus: tenantContext.siteAdminStatus,
                    userFullname: tenantContext.userFullname || ''
                }
            },
            loading: false,
            error: null
        }), [
        tenantContext.atlassianAccountId,
        tenantContext.isAdmin,
        tenantContext.isAnonymous,
        tenantContext.isSiteAdmin,
        tenantContext.locale,
        tenantContext.siteAdminStatus,
        tenantContext.userFullname
    ]);
};
const $59f9598ada60a2a8$var$useCurrentUserFull = ()=>{
    const { data: dataBasic } = $59f9598ada60a2a8$var$useCurrentUserBasic();
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const [{ data: data, loading: loading, error: error }, { fetch: fetch }] = (0, $lGLse.useUserSubscriber)();
    (0, $eUqFw.useEffect)(()=>{
        tenantContext.atlassianAccountId && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        fetch({
            params: {
                accountId: tenantContext.atlassianAccountId
            }
        }, false);
    }, [
        fetch,
        tenantContext.atlassianAccountId
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            data: {
                ...dataBasic,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                user: {
                    ...dataBasic.user,
                    ...data
                }
            },
            loading: loading,
            error: error
        }), [
        data,
        dataBasic,
        error,
        loading
    ]);
};
const $59f9598ada60a2a8$export$3901076af3749fa9 = ()=>(0, $gd0Sp.useTenantContext)().isAnonymous ? $59f9598ada60a2a8$var$useCurrentUserBasic() : $59f9598ada60a2a8$var$useCurrentUserFull(); // eslint-disable-line react-hooks/rules-of-hooks
const $59f9598ada60a2a8$export$6414ebbbfff99d4c = ({ children: children })=>{
    const result = $59f9598ada60a2a8$export$3901076af3749fa9();
    return children(result);
};

});
parcelRegister("lGLse", function(module, exports) {

$parcel$export(module.exports, "UserContainer", () => $033cdb69b2583281$export$7ff085589970ee0a);
$parcel$export(module.exports, "useUserSubscriber", () => $033cdb69b2583281$export$4e61bbf568682a96);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $kdNL5 = parcelRequire("kdNL5");
const $033cdb69b2583281$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $033cdb69b2583281$var$Store = (0, $a61MH.createStore)({
    name: 'user',
    initialState: $033cdb69b2583281$var$initialState,
    actions: $kdNL5
});
const $033cdb69b2583281$export$7ff085589970ee0a = (0, $heB5U.createContainer)($033cdb69b2583281$var$Store);
const $033cdb69b2583281$export$4e61bbf568682a96 = (0, $ggKAj.createHook)($033cdb69b2583281$var$Store);

});
parcelRegister("kdNL5", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $dd4efebc20057365$export$e7aa7bc5c1b3cfb3);

var $1TLNE = parcelRequire("1TLNE");
const $dd4efebc20057365$export$e7aa7bc5c1b3cfb3 = ({ params: params, header: header }, forceRefetch = false)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (!params || currentState.loading || currentState.data && !forceRefetch) return;
        setState({
            loading: true
        });
        try {
            const data = await (0, $1TLNE.fetchData)({
                params: params,
                header: header
            });
            setState({
                data: data,
                loading: false,
                error: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err,
                loading: false
            });
        }
    };

});
parcelRegister("1TLNE", function(module, exports) {

$parcel$export(module.exports, "fetchData", () => $7f578fc13a1a3e40$export$8134c072fddab6a5);

var $53ciZ = parcelRequire("53ciZ");

var $lRmyA = parcelRequire("lRmyA");
const $7f578fc13a1a3e40$export$8134c072fddab6a5 = ({ params: params, header: header })=>{
    const queryParams = {
        ...params,
        expand: Object.keys(params.expand || {}).filter((key)=>params.expand && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            params.expand[key])
    };
    const query = (0, $53ciZ.stringify)(queryParams, {
        arrayFormat: 'none'
    });
    const queryString = query ? `?${query}` : '';
    const requestUrl = `/rest/api/2/user${queryString}`;
    // @ts-expect-error - TS2345 - Argument of type '{ headers: HeaderParamForceAccountId; } | {}' is not assignable to parameter of type 'RequestInit | undefined'.
    return (0, $lRmyA.performGetRequest)(requestUrl, header ? {
        headers: header
    } : {});
};

});




parcelRegister("enMj3", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dc15b871bc1035e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $8BCWs = parcelRequire("8BCWs");
const $9dc15b871bc1035e$var$HelpPanelLoading = ({ loadingArticle: loadingArticle = false })=>loadingArticle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BCWs.HelpPanelContainerV2), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$HeaderLoading, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "img",
        "aria-label": "help panel loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentHeight: "var(--ds-space-250, 20px)",
        marginTop: "var(--ds-space-0, 0px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentWidth: "90%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentWidth: "80%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentWidth: "80%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentWidth: "80%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentWidth: "80%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentWidth: "70%"
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BCWs.HelpPanelContainerV2), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$HeaderLoading, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentHeight: "var(--ds-space-500, 40px)",
        marginTop: "var(--ds-space-100, 8px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadignArticleList, {
        role: "img"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadignArticleListItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentHeight: "var(--ds-space-150, 12px)",
        contentWidth: "var(--ds-space-800, 64px)",
        marginTop: "var(--ds-space-0, 0px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-150, 12px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadignArticleListItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentHeight: "var(--ds-space-150, 12px)",
        contentWidth: "var(--ds-space-800, 64px)",
        marginTop: "var(--ds-space-0, 0px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-150, 12px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadignArticleListItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentHeight: "var(--ds-space-150, 12px)",
        contentWidth: "var(--ds-space-800, 64px)",
        marginTop: "var(--ds-space-0, 0px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-150, 12px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
        contentWidth: "100%",
        marginTop: "var(--ds-space-050, 4px)"
    })))));
var $9dc15b871bc1035e$export$2e2bcd8739ae039 = $9dc15b871bc1035e$var$HelpPanelLoading;
/**
 * Header
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9dc15b871bc1035e$var$LoadingContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4pxbi _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $9dc15b871bc1035e$var$HeaderLoading = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3ixncg _bfhk10nm _n7zlxs90 _1bah1yb4 _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $9dc15b871bc1035e$var$shimmer = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9dc15b871bc1035e$var$LoadingRectangle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { contentHeight: contentHeight, marginTop: marginTop, contentWidth: contentWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_l7mdyr": (0, $9t7rW.default)(__cmplp.contentHeight),
            "--_1fj4wta": (0, $9t7rW.default)(__cmplp.marginTop),
            "--_7n1eiw": (0, $9t7rW.default)(__cmplp.contentWidth)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _2rkov77o _5sag126j _1o51q7pw _tip812c5 _j7hq1en8 _1pglp3kn _bfhk134c _1itk15g1 _12vemgnk",
            __cmplp.contentHeight != null ? "_4t3i6c59" : "_4t3ipxbi",
            __cmplp.marginTop != null ? "_19pkmye1" : "_19pku2gc",
            __cmplp.contentWidth != null ? "_1bsbwd3v" : "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $9dc15b871bc1035e$var$LoadignArticleList = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _18s8v0yc _1yt4ze3t _vchhusvi",
            __cmplp.className
        ])
    });
});
const $9dc15b871bc1035e$var$LoadignArticleListItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _1bsb1osq _1yt4u2gc _vchhusvi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8BCWs", function(module, exports) {

$parcel$export(module.exports, "HelpPanelContainer", () => $03325f336784369d$export$37cd645d7678f7d4);
$parcel$export(module.exports, "HelpPanelContainerV2", () => $03325f336784369d$export$1df7e3ebfc4c9b06);
$parcel$export(module.exports, "HelpPanelSectionMessageContainer", () => $03325f336784369d$export$9f6251c714594f23);
$parcel$export(module.exports, "HelpPanelContentContainer", () => $03325f336784369d$export$1cdb922eed7271d1);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $03325f336784369d$export$37cd645d7678f7d4 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vchhusvi _16jlkb7n _1o9zkb7n _i0dlf1ug _1kl71osx _1reo15vq _18m915vq _2lx21bp4 _1bsb1feq _4t3i1osq _kqsw1n9t",
            __cmplp.className
        ])
    });
});
const $03325f336784369d$export$1df7e3ebfc4c9b06 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $03325f336784369d$export$37cd645d7678f7d4, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1i8v _11q71bhr",
            __cmplp.className
        ])
    });
});
const $03325f336784369d$export$9f6251c714594f23 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1yt41rfa _1bsb1osq _vchhusvi",
            __cmplp.className
        ])
    });
});
const $03325f336784369d$export$1cdb922eed7271d1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1tkeidpf _kqswh2mm _18m91wug _1reo15vq _1e0c1txw _2lx21bp4 _1n261q9c _1bah1y6m _ae4v1fhb _4cvr1y6m",
            __cmplp.className
        ])
    });
});

});


parcelRegister("bZhE6", function(module, exports) {

$parcel$export(module.exports, "AsyncLazyHelpPanel", () => $8726324405ab1f9c$export$7ff46d33d0f13518);

var $7rh0R = parcelRequire("7rh0R");

const $8726324405ab1f9c$export$7ff46d33d0f13518 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("1Oqad")).then(({ HelpPanel: HelpPanel })=>HelpPanel), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/help-panel/src/ui/index.tsx"
});

});
parcelRegister("1Oqad", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('2hmUs'),
            load('bCeK4'),
            load('8Av70')
        ]);
        const value = parcelRequire('lwEqL');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("2hmUs"),
        load("bCeK4"),
        load("8Av70")
    ]).then(()=>parcelRequire('lwEqL'));
}

});



const $119e8efb1068ef73$export$783d7c02e3a0cbf = 'help_panel_ui_state';

parcelRegister("antaP", function(module, exports) {

$parcel$export(module.exports, "RemoteStateUpdater", () => $5b20896496afe0c7$export$3db011870dd4330f);

var $eUqFw = parcelRequire("eUqFw");

var $cNGJr = parcelRequire("cNGJr");

var $48bs8 = parcelRequire("48bs8");

var $guiFP = parcelRequire("guiFP");

var $6vrw7 = parcelRequire("6vrw7");

var $dxcfv = parcelRequire("dxcfv");

var $1zRTT = parcelRequire("1zRTT");

const $5b20896496afe0c7$var$DEBOUNCE_TIME = 1000;
const $5b20896496afe0c7$export$3db011870dd4330f = ()=>{
    // right-sidebar
    const [{ releaseNotesNotifications: releaseNotesNotifications }] = (0, $1zRTT.useHelpPanel)();
    const [releaseNotesNotificationsTemp, setReleaseNotesNotificationsTemp] = (0, $eUqFw.useState)(releaseNotesNotifications);
    const accountId = (0, $dxcfv.useAccountId)();
    const [debouncedUpdateData] = (0, $cNGJr.default)(async (newReleaseNotesNotifications)=>{
        const baseUrl = (0, $6vrw7.toBaseUrl)('');
        const remoteData = {
            helpPanel: {
                releaseNotesNotifications: newReleaseNotesNotifications
            }
        };
        if (accountId) try {
            await (0, $48bs8.setUserProperties)(baseUrl, accountId, (0, $119e8efb1068ef73$export$783d7c02e3a0cbf), JSON.stringify(remoteData));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $guiFP.default)({
                error: e,
                meta: {
                    id: 'updateServerHelpPanelState',
                    packageName: 'jiraHelpPanelServices',
                    teamName: 'self-help-experiences'
                }
            });
        }
    }, $5b20896496afe0c7$var$DEBOUNCE_TIME);
    (0, $eUqFw.useEffect)(()=>{
        if (releaseNotesNotificationsTemp !== releaseNotesNotifications) {
            setReleaseNotesNotificationsTemp(releaseNotesNotifications);
            debouncedUpdateData(releaseNotesNotifications);
        }
    }, [
        debouncedUpdateData,
        releaseNotesNotifications,
        releaseNotesNotificationsTemp
    ]);
    return null;
};

});
parcelRegister("cNGJr", function(module, exports) {

$parcel$export(module.exports, "default", () => $951b3551010b091a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $951b3551010b091a$export$2e2bcd8739ae039(callback, delay, options) {
    if (options === void 0) options = {};
    var maxWait = options.maxWait;
    var maxWaitHandler = (0, $eUqFw.useRef)(null);
    var maxWaitArgs = (0, $eUqFw.useRef)([]);
    var leading = options.leading;
    var trailing = options.trailing === undefined ? true : options.trailing;
    var leadingCall = (0, $eUqFw.useRef)(false);
    var functionTimeoutHandler = (0, $eUqFw.useRef)(null);
    var isComponentUnmounted = (0, $eUqFw.useRef)(false);
    var debouncedFunction = (0, $eUqFw.useRef)(callback);
    debouncedFunction.current = callback;
    var cancelDebouncedCallback = (0, $eUqFw.useCallback)(function() {
        clearTimeout(functionTimeoutHandler.current);
        clearTimeout(maxWaitHandler.current);
        maxWaitHandler.current = null;
        maxWaitArgs.current = [];
        functionTimeoutHandler.current = null;
        leadingCall.current = false;
    }, []);
    (0, $eUqFw.useEffect)(function() {
        return function() {
            // we use flag, as we allow to call callPending outside the hook
            isComponentUnmounted.current = true;
        };
    }, []);
    var debouncedCallback = (0, $eUqFw.useCallback)(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        maxWaitArgs.current = args;
        clearTimeout(functionTimeoutHandler.current);
        if (leadingCall.current) leadingCall.current = false;
        if (!functionTimeoutHandler.current && leading && !leadingCall.current) {
            debouncedFunction.current.apply(debouncedFunction, args);
            leadingCall.current = true;
        }
        functionTimeoutHandler.current = setTimeout(function() {
            var shouldCallFunction = true;
            if (leading && leadingCall.current) shouldCallFunction = false;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current && trailing && shouldCallFunction) debouncedFunction.current.apply(debouncedFunction, args);
        }, delay);
        if (maxWait && !maxWaitHandler.current && trailing) maxWaitHandler.current = setTimeout(function() {
            var args = maxWaitArgs.current;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current) debouncedFunction.current.apply(null, args);
        }, maxWait);
    }, [
        maxWait,
        delay,
        cancelDebouncedCallback,
        leading,
        trailing
    ]);
    var callPending = (0, $eUqFw.useCallback)(function() {
        // Call pending callback only if we have anything in our queue
        if (!functionTimeoutHandler.current) return;
        debouncedFunction.current.apply(null, maxWaitArgs.current);
        cancelDebouncedCallback();
    }, [
        cancelDebouncedCallback
    ]);
    // At the moment, we use 3 args array so that we save backward compatibility
    return [
        debouncedCallback,
        cancelDebouncedCallback,
        callPending
    ];
}

});

parcelRegister("1zRTT", function(module, exports) {

$parcel$export(module.exports, "useHelpPanel", () => $6594f144c6f69b94$export$3fe94d66377a53b8);
$parcel$export(module.exports, "useHelpPanelActions", () => $6594f144c6f69b94$export$c61f56f4797e22db);

var $ggKAj = parcelRequire("ggKAj");
var $dYfll = parcelRequire("dYfll");

var $kEkov = parcelRequire("kEkov");
const $6594f144c6f69b94$export$3fe94d66377a53b8 = (0, $ggKAj.createHook)((0, $kEkov.default));
const $6594f144c6f69b94$export$c61f56f4797e22db = (0, $ggKAj.createHook)((0, $kEkov.default), {
    selector: null
});
const $6594f144c6f69b94$export$513717a84f55db1a = (0, $dYfll.createSubscriber)((0, $kEkov.default), {
    displayName: 'HelpPanelSubscriber'
});
const $6594f144c6f69b94$export$5f4de38bd79f4446 = (0, $dYfll.createSubscriber)((0, $kEkov.default), {
    displayName: 'HelpPanelActionsSubscriber',
    selector: null
});

});
parcelRegister("kEkov", function(module, exports) {

$parcel$export(module.exports, "default", () => $4af29a8a37667189$export$2e2bcd8739ae039);

var $a61MH = parcelRequire("a61MH");

var $89bO2 = parcelRequire("89bO2");

var $47e0j = parcelRequire("47e0j");
const $4af29a8a37667189$var$iphStorage = (0, $89bO2.createSessionStorageProvider)('iph');
const $4af29a8a37667189$var$initialState = {
    navigationData: {
        // @ts-expect-error - TS2322 - Type '"HELP_ARTICLE"' is not assignable to type 'ARTICLE_TYPE'.
        articleId: {
            id: '',
            type: 'HELP_ARTICLE'
        },
        history: $4af29a8a37667189$var$iphStorage.get('history') || []
    },
    releaseNotesNotifications: 100
};
var $4af29a8a37667189$export$2e2bcd8739ae039 = (0, $a61MH.createStore)({
    name: 'help-panel',
    initialState: $4af29a8a37667189$var$initialState,
    actions: $47e0j
});

});
parcelRegister("89bO2", function(module, exports) {

$parcel$export(module.exports, "createSessionStorageProvider", () => $eaaf8012779da3f6$export$a922b987e648d2fa);
$parcel$export(module.exports, "createSessionExpirableStorageProvider", () => $eaaf8012779da3f6$export$e0a2e9a062c6a695);

var $jqvCZ = parcelRequire("jqvCZ");

var $avHyR = parcelRequire("avHyR");

var $8zsxt = parcelRequire("8zsxt");
const $eaaf8012779da3f6$export$a922b987e648d2fa = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((appPrefix)=>(0, $avHyR.createStorageProvider)(appPrefix, (0, $8zsxt.makeSessionStore)()));
const $eaaf8012779da3f6$export$e0a2e9a062c6a695 = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((appPrefix)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    const store = (0, $8zsxt.makeSessionExpirableStore)();
    return store.namespace(appPrefix);
});

});
parcelRegister("8zsxt", function(module, exports) {

$parcel$export(module.exports, "makeSessionStore", () => $dffa4c0ba19d0eb7$export$fb690882d627b3b5);
$parcel$export(module.exports, "makeSessionExpirableStore", () => $dffa4c0ba19d0eb7$export$a8f626c8ded9a06c);

var $2y3XF = parcelRequire("2y3XF");

var $gleLd = parcelRequire("gleLd");

var $ZGlKn = parcelRequire("ZGlKn");

var $gpWeB = parcelRequire("gpWeB");

var $lyUHD = parcelRequire("lyUHD");

var $avHyR = parcelRequire("avHyR");
const $dffa4c0ba19d0eb7$export$fb690882d627b3b5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ZGlKn))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($lyUHD))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gpWeB)))
    ], (0, $avHyR.plugins));
const $dffa4c0ba19d0eb7$export$a8f626c8ded9a06c = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ZGlKn))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($lyUHD))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gpWeB)))
    ], [
        (0, (/*@__PURE__*/$parcel$interopDefault($2y3XF))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gleLd)))
    ]);

});


parcelRegister("47e0j", function(module, exports) {

$parcel$export(module.exports, "setNavigationData", () => $a35d570ea28382ca$export$ab1b80f40ca898ed);
$parcel$export(module.exports, "setReleaseNotesNotifications", () => $a35d570ea28382ca$export$cdabe01d01a8da1e);

var $89bO2 = parcelRequire("89bO2");
const $a35d570ea28382ca$var$iphStorage = (0, $89bO2.createSessionStorageProvider)('iph');
const $a35d570ea28382ca$export$ab1b80f40ca898ed = (navigationData)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            navigationData: {
                articleId: navigationData.articleId ? navigationData.articleId : currentState.navigationData.articleId,
                history: navigationData.history ? navigationData.history : currentState.navigationData.history
            }
        });
        $a35d570ea28382ca$var$iphStorage.set('history', []);
    };
const $a35d570ea28382ca$export$cdabe01d01a8da1e = (releaseNotesNotifications)=>({ setState: setState })=>{
        setState({
            releaseNotesNotifications: releaseNotesNotifications
        });
    };

});





parcelRegister("d8a4z", function(module, exports) {

$parcel$export(module.exports, "ImperativeAPI", () => $1e92f89157195fce$export$e2ad0ff52e7f8c84);

var $eUqFw = parcelRequire("eUqFw");

var $6oi2X = parcelRequire("6oi2X");

var $jwtcO = parcelRequire("jwtcO");
const $1e92f89157195fce$export$e2ad0ff52e7f8c84 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6oi2X.Consumer), null, ({ getManager: getManager })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jwtcO.ImperativeAPI), {
            getItemManager: getManager
        }));

});
parcelRegister("6oi2X", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $786b8f2349f4f371$export$2881499e37b75b9a);
$parcel$export(module.exports, "Consumer", () => $786b8f2349f4f371$export$b3bffd4bb7da6b8f);

var $eUqFw = parcelRequire("eUqFw");

var $kFGm5 = parcelRequire("kFGm5");

var $aptld = parcelRequire("aptld");

var $hIu0M = parcelRequire("hIu0M");
const $786b8f2349f4f371$var$Context = (0, $aptld.default)('ItemManagers');
const $786b8f2349f4f371$export$275138de3066e8b3 = 30000;
class $786b8f2349f4f371$export$2881499e37b75b9a extends (0, $eUqFw.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($786b8f2349f4f371$var$Context.Provider, {
            value: this.manager
        }, this.props.children);
    }
    constructor(...args){
        super(...args);
        this.state = {
            managers: {}
        };
        this.getManager = (managerKey)=>{
            const { managers: managers } = this.state;
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
            const manager = managers[managerKey];
            if (manager) return manager;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return new Promise((resolve, reject)=>{
                const message = `Timeout. "${(0, $hIu0M.fromManagerKey)(managerKey)}" wasn't registered after ${$786b8f2349f4f371$export$275138de3066e8b3}ms`;
                const rejectTimeoutId = setTimeout(()=>reject(new Error(message)), $786b8f2349f4f371$export$275138de3066e8b3);
                const { pendingManagers: pendingManagers } = this;
                pendingManagers[managerKey] || (pendingManagers[managerKey] = []);
                pendingManagers[managerKey].push((methods)=>{
                    clearTimeout(rejectTimeoutId);
                    resolve(methods);
                });
            });
        };
        this.registerManager = (managerKey, methods)=>{
            this.setState((previousState)=>{
                if (methods == null) return {
                    managers: (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(previousState.managers, managerKey)
                };
                const managerResolvers = this.pendingManagers[managerKey];
                if (managerResolvers && managerResolvers.length) {
                    managerResolvers.forEach((resolve)=>resolve(methods));
                    managerResolvers.length = 0;
                }
                return {
                    managers: {
                        ...previousState.managers,
                        [managerKey]: Promise.resolve(methods)
                    }
                };
            });
        };
        this.pendingManagers = {};
        this.manager = {
            getManager: this.getManager,
            registerManager: this.registerManager
        };
    }
}
const { Consumer: $786b8f2349f4f371$export$b3bffd4bb7da6b8f } = $786b8f2349f4f371$var$Context;

});
parcelRegister("aptld", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bb544ea99791963$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7bb544ea99791963$export$2e2bcd8739ae039 = (name)=>{
    const contextObjName = name || '';
    const defaultGetter = ()=>{
        throw new Error(`The Consumer for ${contextObjName} Context Object does not have a correct value. Maybe, it needs to be wrapped in its corresponding Provider`);
    };
    const Context = /*#__PURE__*/ (0, $eUqFw.createContext)(defaultGetter);
    const ContextConsumer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Context.Consumer, null, (getValue)=>{
            const value = getValue();
            return props.children(value);
        });
    const ContextProvider = ({ value: value, children: children })=>{
        const getValue = ()=>value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Context.Provider, {
            value: getValue
        }, children);
    };
    ContextProvider.displayName = `${contextObjName}SafeProvider`;
    ContextConsumer.displayName = `${contextObjName}SafeConsumer`;
    // @ts-expect-error - TS2741 - Property '$$typeof' is missing in type '{ ({ value, children }: ProviderProps<T>): JSX.Element; displayName: string; }' but required in type 'ProviderExoticComponent<ProviderProps<T>>'. | TS2741 - Property '$$typeof' is missing in type '{ (props: Props<T>): JSX.Element; displayName: string; }' but required in type 'ExoticComponent<ConsumerProps<T>>'.
    return {
        Provider: ContextProvider,
        Consumer: ContextConsumer
    };
};

});

parcelRegister("hIu0M", function(module, exports) {

$parcel$export(module.exports, "toManagerKey", () => $e9a42c652dd768fc$export$e6ee4c5f89b06a38);
$parcel$export(module.exports, "fromManagerKey", () => $e9a42c652dd768fc$export$fef172a673b3ef47);
const $e9a42c652dd768fc$export$e6ee4c5f89b06a38 = (managerKey)=>managerKey;
const $e9a42c652dd768fc$export$fef172a673b3ef47 = (managerKey)=>String(managerKey);

});


parcelRegister("jwtcO", function(module, exports) {

$parcel$export(module.exports, "ImperativeAPI", () => $cf3dc24e124a7b2d$export$e2ad0ff52e7f8c84);

var $eUqFw = parcelRequire("eUqFw");

var $ds5Im = parcelRequire("ds5Im");

var $gUUjF = parcelRequire("gUUjF");

var $4u2Iz = parcelRequire("4u2Iz");

var $26xrR = parcelRequire("26xrR");

var $kpmC0 = parcelRequire("kpmC0");

var $2futN = parcelRequire("2futN");

var $hbusP = parcelRequire("hbusP");

var $hIu0M = parcelRequire("hIu0M");

var $kJlBc = parcelRequire("kJlBc");

var $3mRDR = parcelRequire("3mRDR");
const $cf3dc24e124a7b2d$var$ERROR_LOCATION = 'legacy.imperative-api';
const $cf3dc24e124a7b2d$export$e2ad0ff52e7f8c84 = ({ getItemManager: getItemManager })=>{
    const { collapseLeftSidebar: collapseLeftSidebar, expandLeftSidebar: expandLeftSidebar } = (0, $kpmC0.useLeftSidebarController)();
    const { refresh: refresh } = (0, $2futN.useProjectSidebarNavigation)();
    const { push: push } = (0, $kJlBc.useRouterActions)();
    const sidebarState = (0, $kpmC0.useLeftSidebarState)();
    const sidebarRef = (0, $eUqFw.useRef)(sidebarState);
    const refreshSidebarRef = (0, $eUqFw.useRef)(refresh);
    const imperativeAPIRef = (0, $eUqFw.useRef)({
        viewIds: $3mRDR.viewIds,
        itemIds: $3mRDR.itemIds,
        expand: expandLeftSidebar,
        collapse: collapseLeftSidebar,
        isCollapsed: ()=>sidebarRef.current.isCollapsed,
        onCollapse: ()=>undefined,
        onCollapseStart: ()=>undefined,
        onCollapseEnd: ()=>undefined,
        onExpand: ()=>undefined,
        onExpandStart: ()=>undefined,
        onExpandEnd: ()=>undefined,
        onItemClick: ()=>undefined,
        setView: ()=>undefined,
        updateActiveView: ()=>undefined,
        setProjectRootView: ()=>undefined,
        getActiveViewItems: ()=>[],
        isInProjectContext: ()=>false,
        updateContext: ()=>undefined,
        updateData: ()=>{
            refreshSidebarRef.current();
        },
        getItemManager: (itemManagerKey)=>getItemManager(itemManagerKey).catch((e)=>{
                (0, $gUUjF.default).safeErrorWithoutCustomerData($cf3dc24e124a7b2d$var$ERROR_LOCATION, `There was a problem getting "${(0, $hIu0M.fromManagerKey)(itemManagerKey)}" item manager`, e);
                throw e;
            }),
        createBoard: ()=>{
            (0, $26xrR.default)();
        },
        modalOpen: ()=>undefined,
        modalClose: ()=>undefined,
        navigate: (url)=>push(url)
    });
    sidebarRef.current = sidebarState;
    refreshSidebarRef.current = refresh;
    (0, $eUqFw.useEffect)(()=>{
        // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $ds5Im.loadBridgeWeak)({
            name: 'jira/navigation/bridge'
        }).then((bridge)=>{
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            bridge(imperativeAPIRef.current);
        });
        (0, $4u2Iz.provideNavigationApi)({
            navigate: push
        });
    }, [
        push
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hbusP.NavigationUIContainer), {
        isGlobal: true
    });
};

});
parcelRegister("ds5Im", function(module, exports) {

$parcel$export(module.exports, "loadBridgeWeak", () => $1b3123f198513ce0$export$3cefda82396756a1);

var $1gau4 = parcelRequire("1gau4");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $1b3123f198513ce0$var$pollingSingleton = null;
const $1b3123f198513ce0$export$3cefda82396756a1 = ({ name: name })=>{
    const getter = $1b3123f198513ce0$var$pollingSingleton ?? (0, $1gau4.createPollingCollection)((v)=>window.require(v), 100);
    $1b3123f198513ce0$var$pollingSingleton = getter;
    return getter(name);
};

});
parcelRegister("1gau4", function(module, exports) {

$parcel$export(module.exports, "createPollingCollection", () => $9f3ee0cd5dcb553b$export$f163446a982a8077);

var $asu8X = parcelRequire("asu8X");

var $eFUPR = parcelRequire("eFUPR");
const $9f3ee0cd5dcb553b$export$f163446a982a8077 = (fn, timeout)=>{
    (0, $asu8X.di)(setTimeout);
    let isPolling = false;
    // Deferred instance is retained for polling
    const deferredMap = new Map();
    // Promise is derived from Deferred and is retained indefinitely
    const promiseMap = new Map();
    // Provided fn will throw until ready, once ready we will resolve and delete the Deferred
    const evaluateForKey = (key)=>{
        let result;
        try {
            result = fn(key);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            return;
        }
        const deferred = deferredMap.get(key);
        if (deferred instanceof (0, $eFUPR.default)) {
            deferred.resolve(result);
            deferredMap.delete(key);
        }
    };
    const maybePoll = ()=>{
        if (!isPolling && deferredMap.size > 0) {
            isPolling = true;
            setTimeout(()=>{
                isPolling = false;
                [
                    ...deferredMap.keys()
                ].forEach(evaluateForKey);
                maybePoll();
            }, timeout);
        }
    };
    const getter = (key)=>{
        if (!promiseMap.has(key)) {
            const deferred = new (0, $eFUPR.default)();
            const promise = deferred.then((v)=>v);
            deferredMap.set(key, deferred);
            promiseMap.set(key, promise);
            evaluateForKey(key);
            maybePoll();
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return promiseMap.get(key);
    };
    return getter;
};

});
parcelRegister("eFUPR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bee8fab77b1b942$export$2e2bcd8739ae039);
// @ts-expect-error - TS2417 - Class static side 'typeof Deferred' incorrectly extends base class static side '{ all<T>(values: Iterable<T | PromiseLike<T>>): Promise<Awaited<T>[]>; all<T extends readonly unknown[] | []>(values: T): Promise<{ -readonly [P in keyof T]: Awaited<T[P]>; }>; ... 5 more ...; readonly [Symbol.species]: PromiseConstructor; }'.
class $8bee8fab77b1b942$export$2e2bcd8739ae039 extends Promise {
    // go/jfe-eslint
    static resolve(v) {
        const instance = new $8bee8fab77b1b942$export$2e2bcd8739ae039();
        instance.resolve(v);
        return instance;
    }
    // go/jfe-eslint
    static reject(e) {
        const instance = new $8bee8fab77b1b942$export$2e2bcd8739ae039();
        instance.reject(e);
        return instance;
    }
    constructor(){
        // Promise.prototype.then() must be able to call new Deferred(fn)
        // @see https://stackoverflow.com/a/48159603
        // by using arguments flow will ensure we cannot instantiate with constructor parameters
        // eslint-disable-next-line prefer-rest-params
        const [fn] = Array.prototype.slice.call(arguments);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const callbacks = [];
        super(fn ?? callbacks.push.bind(callbacks));
        this.#resolve = callbacks[0];
        this.#reject = callbacks[1];
    }
    #resolve;
    #reject;
    resolve(v) {
        this.#resolve?.(v);
    }
    reject(e) {
        this.#reject?.(e);
    }
}

});



parcelRegister("4u2Iz", function(module, exports) {

$parcel$export(module.exports, "provideNavigationApi", () => $c85bf289a3ab5991$export$26d28e8849b2805f);
$parcel$export(module.exports, "isInIframe", () => $c85bf289a3ab5991$export$9f140ed41af5108c);
$parcel$export(module.exports, "canSpaTransition", () => $c85bf289a3ab5991$export$59e771495885068f);
$parcel$export(module.exports, "getContainerApi", () => $c85bf289a3ab5991$export$91ed870fd8df2bcb);
$parcel$export(module.exports, "getNavigationApi", () => $c85bf289a3ab5991$export$da4e5a44286a0dd0);
// Old AMD key: `ac/spa-context`
// TODO: we will improve the type later when we know the code better.
let $c85bf289a3ab5991$var$containerApi = null;
let $c85bf289a3ab5991$var$navigationApi = null;
const $c85bf289a3ab5991$export$3927fb5df700a968 = (api)=>{
    $c85bf289a3ab5991$var$containerApi = api;
};
const $c85bf289a3ab5991$export$26d28e8849b2805f = (api)=>{
    $c85bf289a3ab5991$var$navigationApi = api;
};
const $c85bf289a3ab5991$export$9f140ed41af5108c = ()=>$c85bf289a3ab5991$var$containerApi !== null;
const $c85bf289a3ab5991$export$59e771495885068f = ()=>$c85bf289a3ab5991$var$navigationApi !== null;
const $c85bf289a3ab5991$export$91ed870fd8df2bcb = ()=>$c85bf289a3ab5991$var$containerApi;
const $c85bf289a3ab5991$export$da4e5a44286a0dd0 = ()=>$c85bf289a3ab5991$var$navigationApi;
const $c85bf289a3ab5991$export$6ba42130b045ede1 = ()=>{
    $c85bf289a3ab5991$var$containerApi = null;
    $c85bf289a3ab5991$var$navigationApi = null;
};

});

parcelRegister("26xrR", function(module, exports) {

$parcel$export(module.exports, "default", () => $a46b7497e8a8ccc2$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
const $a46b7497e8a8ccc2$var$amdModuleName = 'jira-agile/sidebar/create-board-adg3';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a46b7497e8a8ccc2$export$2e2bcd8739ae039 = async ()=>{
    // eslint-disable-next-line jira/wrm/no-load-bridge
    const module = await (0, $2BvS3.loadBridge)({
        name: $a46b7497e8a8ccc2$var$amdModuleName
    });
    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    return module.openCreateBoardModal();
};

});
parcelRegister("2BvS3", function(module, exports) {

$parcel$export(module.exports, "loadBridge", () => $95487c8e7b3a155f$export$df8409da353bde5a);
$parcel$export(module.exports, "loadBridgeStrict", () => (parcelRequire("2TjwK")).loadBridgeStrict);

var $2m1eH = parcelRequire("2m1eH");
var $9kx8M = parcelRequire("9kx8M");
var $e1Ms3 = parcelRequire("e1Ms3");
var $2TjwK = parcelRequire("2TjwK");
var $ds5Im = parcelRequire("ds5Im");
var $4DtuZ = parcelRequire("4DtuZ");
var $beITa = parcelRequire("beITa");
var $dPoeR = parcelRequire("dPoeR");
const $95487c8e7b3a155f$export$df8409da353bde5a = ({ name: name, wrmKeys: wrmKeys, tentatives: tentatives = (0, $2m1eH.MAX_RETRIES), timeout: timeout = (0, $2m1eH.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $2m1eH.SHOULD_LOG_ERROR) })=>{
    if (wrmKeys != null) return (0, $2TjwK.loadBridgeStrict)({
        name: name,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        wrmKeys: [].concat(wrmKeys),
        shouldLogError: shouldLogError
    });
    if (tentatives <= 0) return Promise.reject(new Error('Unable to load bridge, zero tentatives never works'));
    if (tentatives <= 1) return (0, $9kx8M.loadBridgeBail)({
        name: name,
        shouldLogError: shouldLogError
    });
    return (0, $e1Ms3.loadBridgeRace)({
        name: name,
        shouldLogError: shouldLogError,
        timeout: (tentatives - 1) * timeout
    });
};

});
parcelRegister("2m1eH", function(module, exports) {

$parcel$export(module.exports, "safeErrorWithoutCustomerData", () => $b8b11bd252d35c6e$export$f19a2d31722e3428);
$parcel$export(module.exports, "MAX_RETRIES", () => $b8b11bd252d35c6e$export$1f86472c1374185a);
$parcel$export(module.exports, "DEFAULT_TIMEOUT", () => $b8b11bd252d35c6e$export$7bd623b29ec8e1eb);
$parcel$export(module.exports, "SHOULD_LOG_ERROR", () => $b8b11bd252d35c6e$export$37f20f0ff732fcd7);

var $gUUjF = parcelRequire("gUUjF");
const { safeErrorWithoutCustomerData: $b8b11bd252d35c6e$export$f19a2d31722e3428, safeInfoWithoutCustomerData: $b8b11bd252d35c6e$export$ea810ce67e3c8eac } = (0, $gUUjF.default);
const $b8b11bd252d35c6e$export$1f86472c1374185a = 40;
const $b8b11bd252d35c6e$export$7bd623b29ec8e1eb = 500;
const $b8b11bd252d35c6e$export$37f20f0ff732fcd7 = true;

});

parcelRegister("9kx8M", function(module, exports) {

$parcel$export(module.exports, "loadBridgeBail", () => $91c93182e2e49d7f$export$a036f92c2465504e);

var $a0ZIR = parcelRequire("a0ZIR");

var $2m1eH = parcelRequire("2m1eH");
const $91c93182e2e49d7f$export$a036f92c2465504e = async ({ name: name, shouldLogError: shouldLogError = (0, $2m1eH.SHOULD_LOG_ERROR) })=>{
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return window.require(name);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $2m1eH.safeErrorWithoutCustomerData)('common.bridge', `Unable to load bridge "${name}". ${(0, $a0ZIR.safeStringify)(error) ?? ''}`, {
            isSpa: __SPA__,
            name: name,
            error: (0, $a0ZIR.safeStringify)(error)
        });
        throw new Error(`Unable to load bridge "${name}"`, {
            cause: error
        });
    }
};

});
parcelRegister("a0ZIR", function(module, exports) {

$parcel$export(module.exports, "safeStringify", () => $6efa0e8ff5a3a43a$export$56831a8b9cb27763);
/**
 * Stringifies a JS object for logging.
 * @param object
 * @returns {string}
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6efa0e8ff5a3a43a$export$56831a8b9cb27763 = (object)=>{
    if (!object) return '';
    if (object instanceof Error) return object.stack || object.message;
    return JSON.stringify(object, Object.getOwnPropertyNames(object));
};

});


parcelRegister("e1Ms3", function(module, exports) {

$parcel$export(module.exports, "loadBridgeRace", () => $7f4fa2d1428c50fa$export$20c32b4579d78b92);

var $9kx8M = parcelRequire("9kx8M");

var $ds5Im = parcelRequire("ds5Im");

var $2m1eH = parcelRequire("2m1eH");
const $7f4fa2d1428c50fa$export$20c32b4579d78b92 = ({ name: name, timeout: timeout = (0, $2m1eH.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $2m1eH.SHOULD_LOG_ERROR) })=>Promise.race([
        (0, $ds5Im.loadBridgeWeak)({
            name: name
        }),
        new Promise((resolve)=>setTimeout(resolve, timeout)).then(()=>(0, $9kx8M.loadBridgeBail)({
                name: name,
                shouldLogError: shouldLogError
            }))
    ]);

});

parcelRegister("2TjwK", function(module, exports) {

$parcel$export(module.exports, "loadBridgeStrict", () => $b1e39bbe8c29913e$export$eba600d28decc4ac);

var $7ho7Q = parcelRequire("7ho7Q");

var $e1Ms3 = parcelRequire("e1Ms3");

var $99I0s = parcelRequire("99I0s");

var $2m1eH = parcelRequire("2m1eH");
const $b1e39bbe8c29913e$export$eba600d28decc4ac = async ({ name: name, wrmKeys: wrmKeys, shouldLogError: shouldLogError = (0, $2m1eH.SHOULD_LOG_ERROR) })=>{
    (0, $7ho7Q.saveStats)(name, wrmKeys);
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return window.require(name);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        await (0, $99I0s.loadWrmResources)({
            wrmKeys: wrmKeys,
            shouldLogError: shouldLogError
        });
        return (0, $e1Ms3.loadBridgeRace)({
            name: name,
            shouldLogError: shouldLogError
        });
    }
};

});
parcelRegister("7ho7Q", function(module, exports) {

$parcel$export(module.exports, "saveStats", () => $4597ad555104d20c$export$9ea3ff7978093559);
const $4597ad555104d20c$var$incrementResourceStats = (resource, stats)=>{
    if (stats[resource] == null) // eslint-disable-next-line no-param-reassign
    stats[resource] = 1;
    else // eslint-disable-next-line no-param-reassign
    stats[resource] += 1;
};
const $4597ad555104d20c$var$getEmptyLoadBridgeStats = ()=>({
        requests: 0,
        amdModules: {},
        wrmKeys: {}
    });
const $4597ad555104d20c$var$initStats = ()=>{
    if (window.__WRM_INTERNAL_STATS__ == null) window.__WRM_INTERNAL_STATS__ = {
        loadBridge: $4597ad555104d20c$var$getEmptyLoadBridgeStats()
    };
    else if (window.__WRM_INTERNAL_STATS__.loadBridge == null) window.__WRM_INTERNAL_STATS__.loadBridge = $4597ad555104d20c$var$getEmptyLoadBridgeStats();
    return window.__WRM_INTERNAL_STATS__.loadBridge;
};
const $4597ad555104d20c$var$isPageInteractive = ()=>window.__WRM_INTERNAL_STATS__?.isPageInteractive;
const $4597ad555104d20c$export$9ea3ff7978093559 = (amdModuleName, wrmKeys)=>{
    try {
        const stats = $4597ad555104d20c$var$initStats();
        // stop accumulating stats at TTI mark
        if ($4597ad555104d20c$var$isPageInteractive()) return;
        stats.requests += 1;
        $4597ad555104d20c$var$incrementResourceStats(amdModuleName, stats.amdModules);
        if (Array.isArray(wrmKeys)) wrmKeys.forEach((wrmKey)=>$4597ad555104d20c$var$incrementResourceStats(wrmKey, stats.wrmKeys));
        else if (wrmKeys != null) $4597ad555104d20c$var$incrementResourceStats(wrmKeys, stats.wrmKeys);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // not critical functionality
    }
};

});

parcelRegister("99I0s", function(module, exports) {

$parcel$export(module.exports, "loadWrmResources", () => $ddc8a5e8a3946ea4$export$6cda16b6eff75f59);

var $a0ZIR = parcelRequire("a0ZIR");

var $6uXwV = parcelRequire("6uXwV");

var $ds5Im = parcelRequire("ds5Im");

var $2m1eH = parcelRequire("2m1eH");
const $ddc8a5e8a3946ea4$export$6cda16b6eff75f59 = async ({ wrmKeys: wrmKeys, shouldLogError: shouldLogError, ...options })=>{
    const isPrefetch = 'batchUrl' in options;
    let newWrmKeys = wrmKeys;
    try {
        const name = isPrefetch ? 'wrm/require-v2' : 'wrm/require';
        const wrmRequireModule = await (0, $ds5Im.loadBridgeWeak)({
            name: name
        });
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const wrmRequire = isPrefetch ? wrmRequireModule.requireWithPrefetch : wrmRequireModule;
        // @ts-expect-error - TS2322 - Type 'string | string[]' is not assignable to type 'string[]'.
        newWrmKeys = (0, $6uXwV.prependSuperBatchDepsOnce)(wrmKeys);
        if (isPrefetch) return await new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys, options.batchUrl)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
        return await new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $2m1eH.safeErrorWithoutCustomerData)('common.bridge.wrm', 'Unable to load wrm resource', {
            isSpa: __SPA__,
            wrmKeys: JSON.stringify(newWrmKeys),
            error: (0, $a0ZIR.safeStringify)(error)
        });
        throw new Error('Unable to load wrm resource', {
            cause: error
        });
    }
};

});
parcelRegister("6uXwV", function(module, exports) {

$parcel$export(module.exports, "prependSuperBatchDepsOnce", () => $94847501863943b7$export$93d9db5fbabad1b0);

var $8loyD = parcelRequire("8loyD");
let $94847501863943b7$var$isSuperBatchDependenciesLoaded = false;
const $94847501863943b7$var$isOnRapidBoardsPage = ()=>{
    const boardsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*[/]?$/;
    const backlogsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*\/backlog[/]?$/;
    const { pathname: pathname } = window.location;
    return boardsRegex.test(pathname) || backlogsRegex.test(pathname) || window.location.href.includes('secure/RapidBoard.jspa');
};
const $94847501863943b7$export$93d9db5fbabad1b0 = (wrmKeys)=>{
    // These usually need injecting before most domain-specific deps but in rapidboards they load a
    // smaller set of the needed deps internally early and delay the rest
    if ($94847501863943b7$var$isSuperBatchDependenciesLoaded || $94847501863943b7$var$isOnRapidBoardsPage()) return wrmKeys;
    $94847501863943b7$var$isSuperBatchDependenciesLoaded = true;
    return (0, $8loyD.jiraSuperBatchDependencies).concat(wrmKeys);
};

});
parcelRegister("8loyD", function(module, exports) {

$parcel$export(module.exports, "jiraSuperBatchDependencies", () => $1708e80b7caf4372$export$f14a6b583ce9e077);
const $1708e80b7caf4372$export$f14a6b583ce9e077 = [
    // SKATE HAS TO COME FIRST OR ELSE THE OTHER MODULES WILL FAIL
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:util-lite',
    'wrc!jira.webresources:util',
    'wrc!jira.webresources:feature-flags',
    'wrc!jira.webresources:dialogs',
    'wrc!jira.webresources:jira-global',
    'wrc!com.atlassian.auiplugin:aui-spinner'
];

});




parcelRegister("4DtuZ", function(module, exports) {

$parcel$export(module.exports, "waitForHeritage", () => $c6610675329f7ce1$export$c61060338d026f78);

var $eFUPR = parcelRequire("eFUPR");
const $c6610675329f7ce1$export$c61060338d026f78 = ()=>{
    if (false) // WRM is not used on server
    // return null because we don't want to ?.then() chain into loadBridge functions
    return null;
    if (!__SPA__) // Heritage remainder is an SPA concept
    // return promise because we want to ?.then() chain into loadBridge functions
    return Promise.resolve();
    if (!window.__WAIT_FOR_HERITAGE__) window.__WAIT_FOR_HERITAGE__ = new (0, $eFUPR.default)();
    return window.__WAIT_FOR_HERITAGE__;
};

});

parcelRegister("beITa", function(module, exports) {

$parcel$export(module.exports, "wrmRequire", () => $fc3a6026d4692cae$export$cc9d8f51375ef66a);

var $99I0s = parcelRequire("99I0s");

var $2m1eH = parcelRequire("2m1eH");
const $fc3a6026d4692cae$export$cc9d8f51375ef66a = async (wrmKeys, shouldLogError = (0, $2m1eH.SHOULD_LOG_ERROR))=>(0, $99I0s.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError
    });

});

parcelRegister("dPoeR", function(module, exports) {

$parcel$export(module.exports, "wrmRequireWithPrefetch", () => $6e9ac89e6d17a22d$export$e53a5db19a39ed2f);

var $99I0s = parcelRequire("99I0s");

var $2m1eH = parcelRequire("2m1eH");
const $6e9ac89e6d17a22d$export$e53a5db19a39ed2f = async (wrmKeys, batchUrl, shouldLogError = (0, $2m1eH.SHOULD_LOG_ERROR))=>(0, $99I0s.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError,
        batchUrl: batchUrl
    });

});



parcelRegister("kpmC0", function(module, exports) {

$parcel$export(module.exports, "useLeftSidebarState", () => $57fa1b4d662f99dc$export$610d81e163a897b3);
$parcel$export(module.exports, "useLeftSidebarController", () => $57fa1b4d662f99dc$export$900f29014a48fb23);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");

var $1GeZ8 = parcelRequire("1GeZ8");

var $53ucm = parcelRequire("53ucm");
const $57fa1b4d662f99dc$var$useSweetStateLeftSidebarState = (0, $ggKAj.createHook)((0, $53ucm.layoutStore), {
    selector: (state)=>({
            ...state.content.leftSidebar,
            shouldRender: !state.isChromeless
        })
});
const $57fa1b4d662f99dc$export$610d81e163a897b3 = ()=>{
    const [leftSidebar] = $57fa1b4d662f99dc$var$useSweetStateLeftSidebarState();
    return leftSidebar;
};
const $57fa1b4d662f99dc$export$900f29014a48fb23 = ()=>{
    const { expandLeftSidebar: expandLeftSidebar, collapseLeftSidebar: collapseLeftSidebar } = (0, $1GeZ8.usePageLayoutResize)();
    return (0, $eUqFw.useMemo)(()=>({
            collapseLeftSidebar: collapseLeftSidebar,
            expandLeftSidebar: expandLeftSidebar
        }), [
        collapseLeftSidebar,
        expandLeftSidebar
    ]);
};

});

parcelRegister("2futN", function(module, exports) {

$parcel$export(module.exports, "useProjectSidebarNavigation", () => $e6824b09c7b48982$export$5a85006c180fb373);
$parcel$export(module.exports, "useProjectSidebarConnectNavigation", () => $e6824b09c7b48982$export$2bed15cd7d167db5);
$parcel$export(module.exports, "useProjectReportsSidebarConnectNavigation", () => $e6824b09c7b48982$export$a9d05fc2c1d94895);
$parcel$export(module.exports, "useProjectSettingsSidebarConnectNavigation", () => $e6824b09c7b48982$export$d48e3c3556894533);
$parcel$export(module.exports, "useJSMProjectConnectQueuesNavigation", () => $e6824b09c7b48982$export$24a781cd863077aa);
$parcel$export(module.exports, "useJiraWorkmanagementProjectNavigation", () => $e6824b09c7b48982$export$e16ecd2512eb0dc7);
$parcel$export(module.exports, "useJiraSoftwareProjectNavigation", () => $e6824b09c7b48982$export$68dc0ecbea8211d2);
$parcel$export(module.exports, "useJiraServiceManagementProjectNavigation", () => $e6824b09c7b48982$export$5cf90b625d0e1248);
$parcel$export(module.exports, "useJiraProductDiscoveryProjectNavigation", () => $e6824b09c7b48982$export$d63d92edebe543d9);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $7wRIc = parcelRequire("7wRIc");
var $kKeF6 = parcelRequire("kKeF6");
var $iivTa = parcelRequire("iivTa");
var $cbmC6 = parcelRequire("cbmC6");
var $kXWpU = parcelRequire("kXWpU");

var $dUsMe = parcelRequire("dUsMe");
var $iZJHG = parcelRequire("iZJHG");

var $3HCkE = parcelRequire("3HCkE");

var $cLNfQ = parcelRequire("cLNfQ");
const $e6824b09c7b48982$export$5a85006c180fb373 = (customContext)=>{
    const { data: navResponse, loading: loading, error: error, refresh: refresh, clearAll: clearAll, ...rest } = (0, $dUsMe.useInitFetchResource)((0, $iZJHG.useResourceWithCustomRouterContext)((0, $kXWpU.staticProjectSidebarNavigationResource), customContext), !customContext || (0, $1ybV0.ff)('jira.call-useinitfetchresource-from-useresourcewithcustomroutercontext_hiyz0'));
    const memoizedResponse = (0, $eUqFw.useMemo)(()=>navResponse, [
        navResponse
    ]);
    (0, $cLNfQ.useJiraSoftwareCMPNavigationSynchronizer)(memoizedResponse);
    return {
        data: memoizedResponse,
        loading: memoizedResponse != null ? false : loading,
        refresh: refresh,
        clearAll: clearAll,
        error: error,
        ...rest
    };
};
const $e6824b09c7b48982$export$2bed15cd7d167db5 = ()=>(0, $3HCkE.useResource)((0, $cbmC6.staticProjectSidebarConnectAddonsNavigationResource));
const $e6824b09c7b48982$export$a9d05fc2c1d94895 = ()=>(0, $3HCkE.useResource)((0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource));
const $e6824b09c7b48982$export$d48e3c3556894533 = ()=>(0, $3HCkE.useResource)((0, $iivTa.staticProjectSettingsSidebarConnectAddonsNavigationResource));
const $e6824b09c7b48982$export$24a781cd863077aa = ()=>(0, $3HCkE.useResource)((0, $7wRIc.staticJSMProjectConnectAddonsNavigationResource));
const $e6824b09c7b48982$export$e16ecd2512eb0dc7 = ()=>{
    const { data: data, ...rest } = $e6824b09c7b48982$export$5a85006c180fb373();
    const response = data?.jiraWorkManagementNavData || null;
    return {
        data: response,
        ...rest
    };
};
const $e6824b09c7b48982$export$68dc0ecbea8211d2 = ()=>{
    const { data: data, ...rest } = $e6824b09c7b48982$export$5a85006c180fb373();
    const response = data?.jiraSoftwareNavData || null;
    return {
        data: response,
        ...rest
    };
};
const $e6824b09c7b48982$export$5cf90b625d0e1248 = (customContext)=>{
    const { data: data, ...rest } = $e6824b09c7b48982$export$5a85006c180fb373(customContext);
    const response = data?.jiraServiceManagementNavData || null;
    return {
        data: response,
        ...rest
    };
};
const $e6824b09c7b48982$export$d63d92edebe543d9 = ()=>{
    const { data: data, ...rest } = $e6824b09c7b48982$export$5a85006c180fb373();
    const response = data?.jiraProductDiscoveryNavData || null;
    return {
        data: response,
        ...rest
    };
};

});
parcelRegister("7wRIc", function(module, exports) {

$parcel$export(module.exports, "staticJSMProjectConnectAddonsNavigationResource", () => $1da568058e8dfab8$export$fab84295e18e9246);
// eslint-disable-next-line jira/restricted/@atlassian/jira-router

var $3HCkE = parcelRequire("3HCkE");

var $9zYls = parcelRequire("9zYls");

var $76v64 = parcelRequire("76v64");
const $1da568058e8dfab8$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $1da568058e8dfab8$export$fab84295e18e9246 = (0, $3HCkE.createResource)({
    type: 'NAVIGATION_SIDEBAR_JSM_PROJECT_CONNECT_ADDONS_QUEUES_RESOURCE',
    getKey: ({ match: match, query: query })=>$1da568058e8dfab8$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $1da568058e8dfab8$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $76v64.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'jsm_queues');
        return navInfo;
    },
    maxAge: 300000
});

});
parcelRegister("76v64", function(module, exports) {

$parcel$export(module.exports, "fetchProjectSidebarConnectNavigationInfo", () => $c603d0485f5d33bd$export$b15f9f5cf6db359e);

var $lRmyA = parcelRequire("lRmyA");
const $c603d0485f5d33bd$export$b15f9f5cf6db359e = (projectKeyOrId, sidebarType)=>{
    if (projectKeyOrId == null) throw new Error('invalid identifier specified');
    return (0, $lRmyA.performGetRequest)(`/rest/navigation/4/sidebar/project/${projectKeyOrId}/addons?type=${sidebarType}`);
};

});


parcelRegister("kKeF6", function(module, exports) {

$parcel$export(module.exports, "staticProjectReportsSidebarConnectAddonsNavigationResource", () => $5a0ad956b22e7be5$export$b662f3f877add30d);
// eslint-disable-next-line jira/restricted/@atlassian/jira-router

var $3HCkE = parcelRequire("3HCkE");

var $9zYls = parcelRequire("9zYls");

var $76v64 = parcelRequire("76v64");
const $5a0ad956b22e7be5$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $5a0ad956b22e7be5$export$b662f3f877add30d = (0, $3HCkE.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_REPORTS_CONNECT_ADDONS_RESOURCE',
    getKey: ({ match: match, query: query })=>$5a0ad956b22e7be5$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $5a0ad956b22e7be5$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $76v64.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'reports');
        return navInfo;
    },
    maxAge: 300000
});

});

parcelRegister("iivTa", function(module, exports) {

$parcel$export(module.exports, "staticProjectSettingsSidebarConnectAddonsNavigationResource", () => $a5660a56dfe8a855$export$e4bf33528101348c);
// eslint-disable-next-line jira/restricted/@atlassian/jira-router

var $3HCkE = parcelRequire("3HCkE");

var $9zYls = parcelRequire("9zYls");

var $76v64 = parcelRequire("76v64");
const $a5660a56dfe8a855$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $a5660a56dfe8a855$export$e4bf33528101348c = (0, $3HCkE.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_SETTINGS_CONNECT_ADDONS_RESOURCE',
    getKey: ({ match: match, query: query })=>$a5660a56dfe8a855$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $a5660a56dfe8a855$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $76v64.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'settings');
        return navInfo;
    },
    maxAge: 300000
});

});

parcelRegister("cbmC6", function(module, exports) {

$parcel$export(module.exports, "staticProjectSidebarConnectAddonsNavigationResource", () => $9d72696b0f8eb1a8$export$b8c6e2666f12f4bb);
// eslint-disable-next-line jira/restricted/@atlassian/jira-router

var $3HCkE = parcelRequire("3HCkE");

var $9zYls = parcelRequire("9zYls");

var $76v64 = parcelRequire("76v64");
const $9d72696b0f8eb1a8$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $9d72696b0f8eb1a8$export$b8c6e2666f12f4bb = (0, $3HCkE.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_CONNECT_ADDONS_RESOURCE',
    getKey: ({ match: match, query: query })=>$9d72696b0f8eb1a8$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $9d72696b0f8eb1a8$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const projectHomeAddonNavInfo = await (0, $76v64.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'home');
        return projectHomeAddonNavInfo;
    },
    maxAge: 300000
});

});

parcelRegister("kXWpU", function(module, exports) {

$parcel$export(module.exports, "getIdentifier", () => $4181ab9f0d3720b7$export$adb27ddab077e944);
$parcel$export(module.exports, "staticProjectSidebarNavigationResource", () => $4181ab9f0d3720b7$export$f2dfc0f7b2d92691);

var $exb0h = parcelRequire("exb0h");

var $kdp9J = parcelRequire("kdp9J");

var $3HCkE = parcelRequire("3HCkE");

var $ElVpH = parcelRequire("ElVpH");
var $9zYls = parcelRequire("9zYls");

var $LWmvk = parcelRequire("LWmvk");
const $4181ab9f0d3720b7$export$adb27ddab077e944 = (routeName, match, query)=>{
    /**
	 * `boardId` as an identifier should not be returned for JSM boards route,
	 * skip boards on `SERVICEDESK_BOARDS` or `SERVICEDESK_CALENDAR` route.
	 */ if (routeName === (0, $exb0h.ROUTE_NAMES).SERVICEDESK_BOARDS || routeName === (0, $exb0h.ROUTE_NAMES).SERVICEDESK_CALENDAR || query['servicedesk.serviceDeskId']) {
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
        return (0, $kdp9J.getScopeIdentifier)({
            projectKey: projectKey,
            projectId: projectId
        });
    }
    const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
    const boardId = (0, $ElVpH.getBoardId)(match, query);
    return (0, $kdp9J.getScopeIdentifier)({
        projectKey: projectKey,
        projectId: projectId,
        boardId: boardId
    });
};
const $4181ab9f0d3720b7$var$getRouterKey = (routeName, match, query)=>{
    const { identifierType: identifierType, identifierValue: identifierValue } = $4181ab9f0d3720b7$export$adb27ddab077e944(routeName, match, query);
    // Next-Gen software projects contain only one board. Hence, using the project key itself
    if (match.url.includes('/software/projects/')) return `projectKey-${match.params.projectKey || ''}`;
    return identifierType == null || identifierValue == null ? 'none' : `${identifierType}-${identifierValue}`;
};
const $4181ab9f0d3720b7$export$f2dfc0f7b2d92691 = (0, $3HCkE.createResource)({
    type: 'NAVIGATION_SIDEBAR_JIRA_PROJECT',
    getKey: ({ match: match, query: query, route: { name: name } })=>$4181ab9f0d3720b7$var$getRouterKey(name, match, query),
    /**
	 * is called on resource's init fetch, or .refresh()
	 */ getData: async ({ match: match, query: query, route: { name: name } })=>{
        const scopeIdentifier = $4181ab9f0d3720b7$export$adb27ddab077e944(name, match, query);
        if (scopeIdentifier.identifierType == null || scopeIdentifier.identifierValue == null) return null;
        const navInfo = await (0, $LWmvk.fetchProjectSidebarNavInfo)(scopeIdentifier);
        return navInfo;
    },
    maxAge: 300000
});

});
parcelRegister("kdp9J", function(module, exports) {

$parcel$export(module.exports, "getScopeIdentifier", () => $004bd39330a8812e$export$68278f7cf66944f9);

const $004bd39330a8812e$export$68278f7cf66944f9 = (scope)=>{
    // We check for identifiers in order of specificity first. A board ID is more specific than a project key and so on
    const identifierValue = scope.boardId || scope.projectKey || scope.projectId;
    let identifierType = null;
    if (scope.boardId) identifierType = (0, $718a877cd35f74b2$export$929d50f83189406c);
    else if (scope.projectKey) identifierType = (0, $718a877cd35f74b2$export$b5a308a17bc991f3);
    else if (scope.projectId) identifierType = (0, $718a877cd35f74b2$export$da6f46390e1a426f);
    return {
        identifierValue: identifierValue,
        identifierType: identifierType
    };
};

});
const $718a877cd35f74b2$export$b5a308a17bc991f3 = 'projectKey';
const $718a877cd35f74b2$export$929d50f83189406c = 'boardId';
const $718a877cd35f74b2$export$da6f46390e1a426f = 'projectId';


parcelRegister("ElVpH", function(module, exports) {

$parcel$export(module.exports, "getBoardId", () => $478ce79be34a38cd$export$557c2f222778cea6);
const $478ce79be34a38cd$export$557c2f222778cea6 = (match, query)=>match.params.boardId || query.rapidView || query['board.id'];

});

parcelRegister("LWmvk", function(module, exports) {

$parcel$export(module.exports, "fetchProjectSidebarNavInfo", () => $586cfcaef75ec717$export$8a51470472777e11);

var $lRmyA = parcelRequire("lRmyA");
const $586cfcaef75ec717$export$8a51470472777e11 = (scopeIdentifier)=>{
    const { identifierType: identifierType, identifierValue: identifierValue } = scopeIdentifier;
    if (identifierType == null || identifierValue == null) throw new Error('invalid identifier specified');
    let queryParam = '';
    switch(identifierType){
        case 'boardId':
            queryParam = `boardId=${identifierValue}`;
            break;
        case 'projectKey':
        case 'projectId':
            queryParam = `projectIdOrKey=${identifierValue}`;
            break;
        default:
            break;
    }
    return (0, $lRmyA.performGetRequest)(`/rest/navigation/4/sidebar?${queryParam}`);
};

});


parcelRegister("cLNfQ", function(module, exports) {

$parcel$export(module.exports, "useJiraSoftwareCMPNavigationSynchronizer", () => $1154a45446083a64$export$780174995da89d60);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $kXWpU = parcelRequire("kXWpU");

var $kXWpU = parcelRequire("kXWpU");

var $kJlBc = parcelRequire("kJlBc");
var $3HCkE = parcelRequire("3HCkE");
const $1154a45446083a64$export$90dbde7e33e6e21 = ()=>null;
const $1154a45446083a64$export$d647718555c2fdd8 = (projectKey)=>projectKey ? (0, $kJlBc.createRouterContext)({
        name: 'software',
        path: '/dummyroute/c/projects/:projectKey/dummyroute',
        component: $1154a45446083a64$export$90dbde7e33e6e21
    }, {
        params: {
            projectKey: projectKey
        }
    }) : undefined;
const $1154a45446083a64$export$19001bab9e4b7f8f = (projectKey)=>{
    const { data: data, update: update } = (0, $3HCkE.useResource)((0, $kXWpU.staticProjectSidebarNavigationResource), {
        routerContext: $1154a45446083a64$export$d647718555c2fdd8(projectKey)
    });
    return {
        data: data,
        update: update
    };
};
const $1154a45446083a64$export$23dc6491016cabdc = (boardId)=>boardId != null ? (0, $kJlBc.createRouterContext)({
        name: 'software',
        path: '/dummyroute/c/projects/boards/:boardId/dummyroute',
        component: $1154a45446083a64$export$90dbde7e33e6e21
    }, {
        params: {
            boardId: `${boardId}`
        }
    }) : undefined;
const $1154a45446083a64$export$e2bb7877e6cec3eb = (boardId)=>{
    const { data: data, update: update } = (0, $3HCkE.useResource)((0, $kXWpU.staticProjectSidebarNavigationResource), {
        routerContext: $1154a45446083a64$export$23dc6491016cabdc(boardId)
    });
    return {
        data: data,
        update: update
    };
};
const $1154a45446083a64$export$780174995da89d60 = (latestNavInfo)=>{
    const [{ match: match, query: query, route: { name: name } }] = (0, $kJlBc.useRouter)();
    const isOnBoardBasedRoute = (0, $kXWpU.getIdentifier)(name, match, query)?.identifierType === 'boardId';
    const isSoftwareCMP = latestNavInfo?.jiraSoftwareNavData?.project?.simplified === false;
    const pKey = isSoftwareCMP && latestNavInfo?.jiraSoftwareNavData?.project?.key || null;
    const boardId = isSoftwareCMP && latestNavInfo?.jiraSoftwareNavData?.boardInfo?.id || null;
    // explicitly get project data by forcing key to be project
    const { data: projectRouteNavInfo, update: updateProjectRoute } = $1154a45446083a64$export$19001bab9e4b7f8f(pKey);
    // explicitly get board data by forcing key to be board
    const { data: boardRouteNavInfo, update: updateBoardRoute } = $1154a45446083a64$export$e2bb7877e6cec3eb(boardId);
    // if software CMP project or board data is not in sync, then force update
    (0, $eUqFw.useEffect)(()=>{
        if (latestNavInfo != null && isSoftwareCMP) {
            if (isOnBoardBasedRoute && !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(latestNavInfo, projectRouteNavInfo)) updateProjectRoute(()=>latestNavInfo);
            else if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(latestNavInfo, boardRouteNavInfo)) updateBoardRoute(()=>latestNavInfo);
        }
    }, [
        isOnBoardBasedRoute,
        latestNavInfo,
        updateProjectRoute,
        updateBoardRoute,
        projectRouteNavInfo,
        boardRouteNavInfo,
        isSoftwareCMP
    ]);
};

});


parcelRegister("hbusP", function(module, exports) {

$parcel$export(module.exports, "NavigationUISubscriber", () => $5256aede416e5446$export$d3dc1c18cfde5ddd);
$parcel$export(module.exports, "NavigationUIContainer", () => $5256aede416e5446$export$339ec9ca159ad81f);

var $heB5U = parcelRequire("heB5U");
var $dYfll = parcelRequire("dYfll");

var $9LrYi = parcelRequire("9LrYi");
const $5256aede416e5446$export$d3dc1c18cfde5ddd = (0, $dYfll.createSubscriber)((0, $9LrYi.default), {
    displayName: 'NavigationUISubscriber',
    selector: null
});
const $5256aede416e5446$export$339ec9ca159ad81f = (0, $heB5U.createContainer)((0, $9LrYi.default));

});
parcelRegister("9LrYi", function(module, exports) {

$parcel$export(module.exports, "default", () => $073edb176276dfc0$export$2e2bcd8739ae039);

var $a61MH = parcelRequire("a61MH");

var $k9kmE = parcelRequire("k9kmE");
const $073edb176276dfc0$var$initialState = {
    collapseStart: new Set(),
    collapseEnd: new Set(),
    expandStart: new Set(),
    expandEnd: new Set()
};
var $073edb176276dfc0$export$2e2bcd8739ae039 = (0, $a61MH.createStore)({
    name: 'navigation-ui',
    initialState: $073edb176276dfc0$var$initialState,
    actions: $k9kmE.default
});

});
parcelRegister("k9kmE", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e9459e5329f7e4e$export$2e2bcd8739ae039);

var $kAdm2 = parcelRequire("kAdm2");
var $d4PbU = parcelRequire("d4PbU");
var $85FUs = parcelRequire("85FUs");
var $20oC5 = parcelRequire("20oC5");
const $0e9459e5329f7e4e$var$actions = {
    collapseStartAdd: (cb)=>({ dispatch: dispatch })=>dispatch($kAdm2.default('collapseStart', cb)),
    collapseStartRemove: (cb)=>({ dispatch: dispatch })=>dispatch($85FUs.default('collapseStart', cb)),
    collapseStartClear: ()=>({ dispatch: dispatch })=>dispatch($d4PbU.default('collapseStart')),
    collapseStartRun: ()=>({ dispatch: dispatch })=>dispatch($20oC5.default('collapseStart')),
    collapseEndAdd: (cb)=>({ dispatch: dispatch })=>dispatch($kAdm2.default('collapseEnd', cb)),
    collapseEndRemove: (cb)=>({ dispatch: dispatch })=>dispatch($85FUs.default('collapseEnd', cb)),
    collapseEndClear: ()=>({ dispatch: dispatch })=>dispatch($d4PbU.default('collapseEnd')),
    // @ts-expect-error - TS2322 - Type '(cb: any) => ({ dispatch }: { dispatch: any; }) => any' is not assignable to type 'ActionRun'.
    collapseEndRun: // @ts-expect-error - TS7006 - Parameter 'cb' implicitly has an 'any' type.
    (cb)=>// @ts-expect-error - TS7031 - Binding element 'dispatch' implicitly has an 'any' type.
        ({ dispatch: dispatch })=>dispatch($20oC5.default('collapseEnd', cb)),
    expandStartAdd: (cb)=>({ dispatch: dispatch })=>dispatch($kAdm2.default('expandStart', cb)),
    expandStartRemove: (cb)=>({ dispatch: dispatch })=>dispatch($85FUs.default('expandStart', cb)),
    expandStartClear: ()=>({ dispatch: dispatch })=>dispatch($d4PbU.default('expandStart')),
    // @ts-expect-error - TS2322 - Type '(cb: any) => ({ dispatch }: { dispatch: any; }) => any' is not assignable to type 'ActionRun'.
    expandStartRun: // @ts-expect-error - TS7006 - Parameter 'cb' implicitly has an 'any' type.
    (cb)=>// @ts-expect-error - TS7031 - Binding element 'dispatch' implicitly has an 'any' type.
        ({ dispatch: dispatch })=>dispatch($20oC5.default('expandStart', cb)),
    expandEndAdd: (cb)=>({ dispatch: dispatch })=>dispatch($kAdm2.default('expandEnd', cb)),
    expandEndRemove: (cb)=>({ dispatch: dispatch })=>dispatch($85FUs.default('expandEnd', cb)),
    expandEndClear: ()=>({ dispatch: dispatch })=>dispatch($d4PbU.default('expandEnd')),
    // @ts-expect-error - TS2322 - Type '(cb: any) => ({ dispatch }: { dispatch: any; }) => any' is not assignable to type 'ActionRun'.
    expandEndRun: // @ts-expect-error - TS7006 - Parameter 'cb' implicitly has an 'any' type.
    (cb)=>// @ts-expect-error - TS7031 - Binding element 'dispatch' implicitly has an 'any' type.
        ({ dispatch: dispatch })=>dispatch($20oC5.default('expandEnd', cb)),
    clearAll: ()=>({ dispatch: dispatch })=>{
            dispatch($0e9459e5329f7e4e$var$actions.collapseStartClear());
            dispatch($0e9459e5329f7e4e$var$actions.collapseEndClear());
            dispatch($0e9459e5329f7e4e$var$actions.expandStartClear());
            dispatch($0e9459e5329f7e4e$var$actions.expandEndClear());
        }
};
var $0e9459e5329f7e4e$export$2e2bcd8739ae039 = $0e9459e5329f7e4e$var$actions;

});
parcelRegister("kAdm2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae4d62e75c39d6ec$export$2e2bcd8739ae039);

var $85FUs = parcelRequire("85FUs");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ae4d62e75c39d6ec$export$2e2bcd8739ae039 = (key, callback)=>// @ts-expect-error - TS2322 - Type '({ setState, getState, dispatch }: StoreActionApi<T>) => () => void' is not assignable to type 'Action<T, void, void | Promise<void>>'.
    ({ setState: setState, getState: getState, dispatch: dispatch })=>{
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Set<unknown>; }' is not assignable to parameter of type 'Partial<T>'.
        setState({
            [key]: new Set(getState()[key]).add(callback)
        });
        return ()=>dispatch((0, $85FUs.default)(key, callback));
    };

});
parcelRegister("85FUs", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3b2c6d695815dbd$export$2e2bcd8739ae039);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b3b2c6d695815dbd$export$2e2bcd8739ae039 = (key, callback)=>({ setState: setState, getState: getState })=>{
        if (!getState()[key]) return;
        const slice = new Set(getState()[key]);
        slice.delete(callback);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Set<unknown>; }' is not assignable to parameter of type 'Partial<T>'.
        setState({
            [key]: slice
        });
    };

});


parcelRegister("d4PbU", function(module, exports) {

$parcel$export(module.exports, "default", () => $912d7a599c33dfa4$export$2e2bcd8739ae039);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$912d7a599c33dfa4$export$2e2bcd8739ae039 = (key)=>({ setState: setState })=>// @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Set<unknown>; }' is not assignable to parameter of type 'Partial<T>'.
        setState({
            [key]: new Set()
        });

});

parcelRegister("20oC5", function(module, exports) {

$parcel$export(module.exports, "default", () => $c664f49a6b0027bd$export$2e2bcd8739ae039);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c664f49a6b0027bd$export$2e2bcd8739ae039 = (key, ...args)=>({ getState: getState })=>// @ts-expect-error - TS2339 - Property 'forEach' does not exist on type 'Set<unknown> | T[string]'. | TS7006 - Parameter 'cb' implicitly has an 'any' type.
        (getState()[key] || new Set()).forEach((cb)=>cb(...args));

});




parcelRegister("3mRDR", function(module, exports) {

$parcel$export(module.exports, "itemIds", () => $8615713aedf1e792$export$443ec49e59de3663);
$parcel$export(module.exports, "viewIds", () => $8615713aedf1e792$export$8ee2fd038785d9dc);

var $dYFw9 = parcelRequire("dYFw9");
const $8615713aedf1e792$var$ROOT = 'root/index';
const $8615713aedf1e792$var$ISSUES = 'root/issues';
const $8615713aedf1e792$var$DASHBOARDS = 'root/dashboards';
const $8615713aedf1e792$var$PORTFOLIO = 'root/portfolio';
const $8615713aedf1e792$var$WORK_SCRUM = 'work-scrum';
const $8615713aedf1e792$var$PLAN_SCRUM = 'plan-scrum';
const $8615713aedf1e792$var$WORK_KANBAN = 'work-kanban';
const $8615713aedf1e792$var$PLAN_KANBAN = 'plan-kanban';
const $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES = 'pin-filter-myopenissues';
const $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES = 'pin-filter-reportedbyme';
const $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES = 'pin-filter-allissues';
const $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES = 'pin-filter-allopenissues';
const $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES = 'pin-filter-doneissues';
const $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES = 'pin-filter-recentlyviewed';
const $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES = 'pin-filter-addedrecently';
const $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES = 'pin-filter-resolvedrecently';
const $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES = 'pin-filter-updatedrecently';
const $8615713aedf1e792$var$AGILITY = 'project/agility/index';
const $8615713aedf1e792$var$BUSINESS = 'project/business/index';
const $8615713aedf1e792$var$OPS = 'project/ops/index';
const $8615713aedf1e792$var$SOFTWARE = 'project/software/index';
const $8615713aedf1e792$var$SOFTWARE_ISSUES = 'project/software/issues';
const $8615713aedf1e792$var$SOFTWARE_REPORTS = 'project/software/reports';
const $8615713aedf1e792$var$USER = 'user/index';
const $8615713aedf1e792$var$USER_REPORTS = 'user/reports';
const $8615713aedf1e792$var$rootProjectViewIds = {
    AGILITY: $8615713aedf1e792$var$AGILITY,
    SERVICE_DESK: $dYFw9.SERVICE_DESK,
    OPS: $8615713aedf1e792$var$OPS,
    BUSINESS: $8615713aedf1e792$var$BUSINESS,
    SOFTWARE: $8615713aedf1e792$var$SOFTWARE
};
const $8615713aedf1e792$var$rootViewIds = {
    ROOT: $8615713aedf1e792$var$ROOT,
    ISSUES: $8615713aedf1e792$var$ISSUES,
    DASHBOARDS: $8615713aedf1e792$var$DASHBOARDS,
    PORTFOLIO: $8615713aedf1e792$var$PORTFOLIO
};
const $8615713aedf1e792$export$443ec49e59de3663 = {
    WORK_SCRUM: $8615713aedf1e792$var$WORK_SCRUM,
    PLAN_SCRUM: $8615713aedf1e792$var$PLAN_SCRUM,
    WORK_KANBAN: $8615713aedf1e792$var$WORK_KANBAN,
    PLAN_KANBAN: $8615713aedf1e792$var$PLAN_KANBAN,
    PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES: $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES: $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES: $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES: $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES: $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES: $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES: $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES: $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES,
    PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES: $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES,
    ...(0, $dYFw9.SERVICE_DESK_ITEMS)
};
const $8615713aedf1e792$export$8ee2fd038785d9dc = {
    ...$8615713aedf1e792$var$rootViewIds,
    ...$8615713aedf1e792$var$rootProjectViewIds,
    SOFTWARE_ISSUES: $8615713aedf1e792$var$SOFTWARE_ISSUES,
    SOFTWARE_REPORTS: $8615713aedf1e792$var$SOFTWARE_REPORTS,
    SERVICE_DESK_ISSUES: $dYFw9.SERVICE_DESK_ISSUES,
    SERVICE_DESK_QUEUES: $dYFw9.SERVICE_DESK_QUEUES,
    SERVICE_DESK_REPORTS: $dYFw9.SERVICE_DESK_REPORTS,
    SERVICE_DESK_SETTINGS: $dYFw9.SERVICE_DESK_SETTINGS,
    SERVICE_DESK_LANGUAGES: $dYFw9.SERVICE_DESK_LANGUAGES,
    SERVICE_DESK_LEGACY_TICKET_TYPES: $dYFw9.SERVICE_DESK_LEGACY_TICKET_TYPES,
    SERVICE_DESK_TRANSLATIONS: $dYFw9.SERVICE_DESK_TRANSLATIONS,
    SERVICE_DESK_AUTOMATION_SUB_NAV: $dYFw9.SERVICE_DESK_AUTOMATION_SUB_NAV,
    SERVICE_DESK_KNOWLEDGE_HUB: $dYFw9.SERVICE_DESK_KNOWLEDGE_HUB,
    USER: $8615713aedf1e792$var$USER,
    USER_REPORTS: $8615713aedf1e792$var$USER_REPORTS
};

});
parcelRegister("dYFw9", function(module, exports) {

$parcel$export(module.exports, "HOME_ITEMS_IDS", () => $890d2e79149b5a80$export$9afbea2cbd37e16d);
$parcel$export(module.exports, "PRACTICES_IDS", () => $890d2e79149b5a80$export$a37f4f7add086a3);
$parcel$export(module.exports, "SERVICE_DESK_ITEMS", () => $890d2e79149b5a80$export$2108a7f32cd0bb12);
$parcel$export(module.exports, "REQUEST_TYPE_PRACTICE_NAV_ONBOARDING", () => $890d2e79149b5a80$export$712b4b205a2bcf1e);
$parcel$export(module.exports, "TEAM_PRIORITY_QUEUE_ADMIN_SPOTLIGHT", () => $890d2e79149b5a80$export$aaffd3035e9d6c2d);
$parcel$export(module.exports, "STARRED_QUEUE_SPOTLIGHT", () => $890d2e79149b5a80$export$e2d46b728fe0a15a);
$parcel$export(module.exports, "SERVICE_DESK", () => $890d2e79149b5a80$export$c8c1c8c3f8ddba61);
$parcel$export(module.exports, "SERVICE_DESK_ISSUES", () => $890d2e79149b5a80$export$51fa1147c138a6ed);
$parcel$export(module.exports, "SERVICE_DESK_QUEUES", () => $890d2e79149b5a80$export$456b3cfbf5e37bd8);
$parcel$export(module.exports, "SERVICE_DESK_KNOWLEDGE_HUB", () => $890d2e79149b5a80$export$9ccc8d85b210b219);
$parcel$export(module.exports, "SERVICE_DESK_REPORTS", () => $890d2e79149b5a80$export$707771f2f7e60575);
$parcel$export(module.exports, "SERVICE_DESK_SETTINGS", () => $890d2e79149b5a80$export$a87fc635598d2d50);
$parcel$export(module.exports, "SERVICE_DESK_LEGACY_TICKET_TYPES", () => $890d2e79149b5a80$export$b6bda26b77269209);
$parcel$export(module.exports, "SERVICE_DESK_LANGUAGES", () => $890d2e79149b5a80$export$776199f9e99c88e2);
$parcel$export(module.exports, "SERVICE_DESK_TRANSLATIONS", () => $890d2e79149b5a80$export$d70ba5c124463035);
$parcel$export(module.exports, "SERVICE_DESK_AUTOMATION_SUB_NAV", () => $890d2e79149b5a80$export$9a6deaa9c1af559f);
const $890d2e79149b5a80$var$HOME_QUEUES = 'queues';
const $890d2e79149b5a80$var$HOME_ALL_ITSM_QUEUES_SPOTLIGHT = 'all-itsm-queues-spotlight';
const $890d2e79149b5a80$var$HOME_ALL_TICKETS_SPOTLIGHT = 'all-tickets-spotlight';
const $890d2e79149b5a80$var$HOME_TICKET_CATEGORIES_SPOTLIGHT = 'ticket-categories-spotlight';
const $890d2e79149b5a80$var$HOME_SERVICE_REQUESTS = 'service-requests';
const $890d2e79149b5a80$var$HOME_INCIDENTS = 'incidents';
const $890d2e79149b5a80$var$HOME_CHANGES = 'changes';
const $890d2e79149b5a80$var$HOME_PROBLEMS = 'problems';
const $890d2e79149b5a80$var$HOME_POST_INCIDENT_REVIEWS = 'post-incident-reviews';
const $890d2e79149b5a80$var$HOME_CUSTOMERS = 'customers';
const $890d2e79149b5a80$var$HOME_REPORTS = 'reports';
const $890d2e79149b5a80$var$HOME_RAISE_REQUEST = 'raise-request';
const $890d2e79149b5a80$var$HOME_ISSUES = 'issues';
const $890d2e79149b5a80$var$HOME_CUSTOMER_CHANNELS = 'customer-channels';
const $890d2e79149b5a80$var$HOME_CUSTOMER_CHANNELS_SPOTLIGHT = 'customer-channels-spotlight';
const $890d2e79149b5a80$var$HOME_JSD_CHANNELS_DIALOG = 'jsd-channels-dialog';
const $890d2e79149b5a80$var$HOME_KNOWLEDGE_BASE = 'knowledge-base';
const $890d2e79149b5a80$var$HOME_KNOWLEDGE_BASE_HUB = 'knowledge-hub';
const $890d2e79149b5a80$var$HOME_KNOWLEDGE_BASE_HUB_NESTED = 'knowledge-hub-nested';
const $890d2e79149b5a80$var$HOME_INVITE_TEAM = 'invite-team';
const $890d2e79149b5a80$var$HOME_GIVE_FEEDBACK = 'give-feedback';
const $890d2e79149b5a80$var$HOME_SERVICES = 'services';
const $890d2e79149b5a80$var$HOME_SERVICES_SPOTLIGHT = 'services-spotlight';
const $890d2e79149b5a80$var$HOME_ALERTS_AND_ON_CALL_SPOTLIGHT = 'alerts-and-on-call-spotlight';
const $890d2e79149b5a80$var$HOME_CHANGE_CALENDAR_SPOTLIGHT = 'change-calendar-spotlight';
const $890d2e79149b5a80$export$1f70a76cb421b107 = {
    REPORTS_CUSTOM: 'sd-reports-custom',
    REPORTS_ADDONS: 'sd-reports-addons',
    REPORTS_NAV_CUSTOM_ACTIONS: 'sd-reports-nav-custom-actions',
    REPORTS_NAV_TEAM: 'sd-reports-nav-team',
    REPORTS_NAV_KB: 'sd-reports-nav-kb'
};
const $890d2e79149b5a80$export$9afbea2cbd37e16d = {
    QUEUES: $890d2e79149b5a80$var$HOME_QUEUES,
    ALL_ITSM_QUEUES_SPOTLIGHT: $890d2e79149b5a80$var$HOME_ALL_ITSM_QUEUES_SPOTLIGHT,
    ALL_TICKETS_SPOTLIGHT: $890d2e79149b5a80$var$HOME_ALL_TICKETS_SPOTLIGHT,
    TICKET_CATEGORIES_SPOTLIGHT: $890d2e79149b5a80$var$HOME_TICKET_CATEGORIES_SPOTLIGHT,
    SERVICE_REQUEST: $890d2e79149b5a80$var$HOME_SERVICE_REQUESTS,
    INCIDENTS: $890d2e79149b5a80$var$HOME_INCIDENTS,
    CHANGES: $890d2e79149b5a80$var$HOME_CHANGES,
    PROBLEMS: $890d2e79149b5a80$var$HOME_PROBLEMS,
    CUSTOMERS: $890d2e79149b5a80$var$HOME_CUSTOMERS,
    POST_INCIDENT_REVIEWS: $890d2e79149b5a80$var$HOME_POST_INCIDENT_REVIEWS,
    REPORTS: $890d2e79149b5a80$var$HOME_REPORTS,
    RAISE_REQUEST: $890d2e79149b5a80$var$HOME_RAISE_REQUEST,
    ISSUES: $890d2e79149b5a80$var$HOME_ISSUES,
    CUSTOMER_CHANNELS: $890d2e79149b5a80$var$HOME_CUSTOMER_CHANNELS,
    CUSTOMER_CHANNELS_SPOTLIGHT: $890d2e79149b5a80$var$HOME_CUSTOMER_CHANNELS_SPOTLIGHT,
    JSD_CHANNELS_DIALOG: $890d2e79149b5a80$var$HOME_JSD_CHANNELS_DIALOG,
    KNOWLEDGE_BASE: $890d2e79149b5a80$var$HOME_KNOWLEDGE_BASE,
    KNOWLEDGE_BASE_HUB: $890d2e79149b5a80$var$HOME_KNOWLEDGE_BASE_HUB,
    KNOWLEDGE_BASE_HUB_NESTED: $890d2e79149b5a80$var$HOME_KNOWLEDGE_BASE_HUB_NESTED,
    INVITE_TEAM: $890d2e79149b5a80$var$HOME_INVITE_TEAM,
    GIVE_FEEDBACK: $890d2e79149b5a80$var$HOME_GIVE_FEEDBACK,
    SERVICES: $890d2e79149b5a80$var$HOME_SERVICES,
    SERVICES_SPOTLIGHT: $890d2e79149b5a80$var$HOME_SERVICES_SPOTLIGHT,
    ALERTS_AND_ON_CALL_SPOTLIGHT: $890d2e79149b5a80$var$HOME_ALERTS_AND_ON_CALL_SPOTLIGHT,
    CHANGE_CALENDAR_SPOTLIGHT: $890d2e79149b5a80$var$HOME_CHANGE_CALENDAR_SPOTLIGHT
};
const $890d2e79149b5a80$export$304aefafb7155b23 = {
    TOP_ACTIONS: 'knowledge-hub-top-actions',
    ALL_ARTICLES: 'knowledge-hub-all-articles',
    CATEGORIES: 'knowledge-hub-categories',
    CATEGORIES_CONTEXT: 'knowledge-hub-categories-context',
    BOTTOM_ACTIONS: 'knowledge-hub-bottom-actions',
    ADD_CATEGORY: 'knowledge-hub-new-category',
    LEAVE_FEEDBACK: 'knowledge-hub-leave-feedback'
};
const $890d2e79149b5a80$export$5fd6685a693e1064 = {
    DETAILS: 'details',
    PEOPLE: 'people',
    ITSM_FEATURES: 'itsm-features',
    SUMMARY: 'summary',
    DELETE_PROJECT: 'delete-project',
    ISSUE_TYPES: 'issue-types',
    FEATURES: 'features',
    REQUEST_TYPES: 'sd-request-types',
    TICKET_TYPES: 'sd-ticket-types',
    CUSTOMER_PERMISSIONS: 'sd-customer-permissions',
    LANGUAGE_SUPPORT: 'sd-language-support',
    PORTAL_SETTINGS: 'sd-portal-settings',
    EMAIL_REQUESTS: 'sd-email-requests',
    CUSTOMER_NOTIFICATIONS: 'sd-customer-notifications',
    PROJECT_WIDGET_ADDON: 'sd-project-widget-addon',
    PROJECT_WIDGET_ADDON_INSTALLER: 'sd-project-widget-addon-installer',
    PROJECT_ASSETS_AD: 'sd-project-assets-ad',
    SATISFACTION_SETTINGS: 'sd-satisfaction-settings',
    KNOWLEDGE_BASE: 'sd-knowledge-base',
    SLAS: 'sd-slas',
    AUTOMATION: 'sd-automation',
    JIRA_AUTOMATION: 'jira-automation',
    AUTOMATION_SUB_NAV: 'sd-automation-sub-nav',
    JSD_APP_DISCOVERY: 'sd-app-discovery',
    JSD_INCIDENT_MANAGEMENT: 'sd-incident-management',
    JSD_CHANGE_MANAGEMENT: 'sd-change-management',
    WORKFLOWS: 'workflows',
    SCREENS: 'screens',
    FIELDS: 'fields',
    VERSIONS: 'versions',
    COMPONENTS: 'components',
    PERMISSIONS: 'permissions',
    ISSUE_SECURITY: 'issue-security',
    NOTIFICATIONS: 'notifications',
    HIPCHAT: 'hipchat',
    ISSUE_COLLECTORS: 'issue-collectors'
};
const $890d2e79149b5a80$export$50b1b8fc419aca98 = {
    QUEUE_NEW: 'queue-new',
    QUEUE_MANAGE: 'queue-manage',
    QUEUES_ADDONS: 'sd-queues-addons',
    QUEUES_CUSTOM_ACTIONS: 'sd-queues-custom-actions',
    SD_QUEUES_CUSTOM: 'sd-queues-custom'
};
const $890d2e79149b5a80$export$a37f4f7add086a3 = {
    ADDITIONAL_ITEMS: 'sd-practices-additional-items',
    CHANGES_QUEUE_TITLE_SPOTLIGHT: 'sd-practices-changes-queue-title-spotlight',
    CHANGES_QUEUE_ITEMS_SPOTLIGHT: 'sd-practices-changes-queue-items-spotlight',
    INCIDENTS_QUEUE_TITLE_SPOTLIGHT: 'sd-practices-incidents-queue-title-spotlight',
    INCIDENTS_QUEUE_ITEMS_SPOTLIGHT: 'sd-practices-incidents-queue-items-spotlight'
};
const $890d2e79149b5a80$export$2108a7f32cd0bb12 = {
    SERVICE_DESK: {
        HOME: $890d2e79149b5a80$export$9afbea2cbd37e16d,
        KNOWLEDGE_BASE: $890d2e79149b5a80$export$304aefafb7155b23,
        SETTINGS: $890d2e79149b5a80$export$5fd6685a693e1064,
        QUEUES: $890d2e79149b5a80$export$50b1b8fc419aca98,
        REPORTS: $890d2e79149b5a80$export$1f70a76cb421b107
    }
};
const $890d2e79149b5a80$export$712b4b205a2bcf1e = {
    PRACTICE_NAV_SPOTLIGHT: 'request-type-practice-nav-spotlight',
    UNASSIGNED_NAV_SPOTLIGHT: 'request-type-unassgined-nav-spotlight'
};
const $890d2e79149b5a80$export$aaffd3035e9d6c2d = 'jsm-team-priority-queue-admin-onboarding';
const $890d2e79149b5a80$export$e2d46b728fe0a15a = 'jsm-team-starred-onboarding';
const $890d2e79149b5a80$export$c8c1c8c3f8ddba61 = 'project/service-desk/index';
const $890d2e79149b5a80$export$51fa1147c138a6ed = 'project/service-desk/issues';
const $890d2e79149b5a80$export$456b3cfbf5e37bd8 = 'project/service-desk/queues';
const $890d2e79149b5a80$export$9ccc8d85b210b219 = 'project/service-desk/knowledge-hub';
const $890d2e79149b5a80$export$707771f2f7e60575 = 'project/service-desk/reports';
const $890d2e79149b5a80$export$a87fc635598d2d50 = 'project/service-desk/settings';
const $890d2e79149b5a80$export$b6bda26b77269209 = 'project/service-desk/legacy-ticket-types';
const $890d2e79149b5a80$export$776199f9e99c88e2 = 'project/service-desk/languages';
const $890d2e79149b5a80$export$d70ba5c124463035 = 'project/service-desk/translations';
const $890d2e79149b5a80$export$9a6deaa9c1af559f = 'project/service-desk/settings/automation-sub-nav';

});




parcelRegister("3eqbP", function(module, exports) {

$parcel$export(module.exports, "AsyncLockScreenExperimentSharedWrapper", () => $cc6580f6fb3ff169$export$129bdc881130bc9);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $aR8n6 = parcelRequire("aR8n6");


const $cc6580f6fb3ff169$var$AsyncLockScreenExperimentShared = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("fBWae")).then(({ LockScreenExperimentShared: LockScreenExperimentShared })=>LockScreenExperimentShared), {
    moduleId: "./src/packages/growth/end-of-trial/lock-screen-experiment-shared/src/index.tsx"
});
const $cc6580f6fb3ff169$export$129bdc881130bc9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "lock-screen-experiment-shared-async",
        packageName: (0, $a733f78220833320$export$b8b9d90f9e5bd72b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
        teamName: (0, $a733f78220833320$export$d57b6b390e78d90f),
        id: "lock-screen-experiment-shared-async",
        packageName: (0, $a733f78220833320$export$b8b9d90f9e5bd72b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cc6580f6fb3ff169$var$AsyncLockScreenExperimentShared, null)));

});
const $a733f78220833320$export$b8b9d90f9e5bd72b = '@atlassian/jira-lock-screen-experiment-shared';
const $a733f78220833320$export$d57b6b390e78d90f = 'transmuters-growth';

parcelRegister("fBWae", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('4aVsP');
        const value = parcelRequire('fm5VO');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("4aVsP").then(()=>parcelRequire('fm5VO'));
}

});


parcelRegister("cPEpP", function(module, exports) {

$parcel$export(module.exports, "useProject", () => $681442ce6e3ade0b$export$51b1383ef8844a7);

var $eUqFw = parcelRequire("eUqFw");

var $eWsAG = parcelRequire("eWsAG");

var $2futN = parcelRequire("2futN");
const $681442ce6e3ade0b$export$51b1383ef8844a7 = (customContext)=>{
    const { data: data, loading: loading, error: error } = (0, $2futN.useProjectSidebarNavigation)(customContext);
    const project = (0, $eUqFw.useMemo)(()=>data && (0, $eWsAG.extractData)(data), [
        data
    ]);
    return {
        data: project,
        loading: loading,
        error: error
    };
};

});
parcelRegister("eWsAG", function(module, exports) {

$parcel$export(module.exports, "getStyle", () => $994f1ddfe6829bdc$export$3d2f074408bd1b82);
$parcel$export(module.exports, "extractData", () => $994f1ddfe6829bdc$export$9df5fa0a366163d2);

var $7ZZxN = parcelRequire("7ZZxN");
const $994f1ddfe6829bdc$export$3d2f074408bd1b82 = (isSimplifiedProject)=>isSimplifiedProject ? (0, $7ZZxN.ProjectStyle).NEXT_GEN : (0, $7ZZxN.ProjectStyle).CLASSIC;
const $994f1ddfe6829bdc$var$getProject = (project)=>({
        avatarUrl: project.avatarUrls['48x48'],
        id: Number(project.id),
        isSimplified: project.simplified,
        key: project.key,
        name: project.name,
        style: $994f1ddfe6829bdc$export$3d2f074408bd1b82(project.simplified),
        type: project.projectTypeKey
    });
const $994f1ddfe6829bdc$export$9df5fa0a366163d2 = (data)=>{
    const { projectType: projectType, jiraWorkManagementNavData: jiraWorkManagementNavData, jiraSoftwareNavData: jiraSoftwareNavData, jiraServiceManagementNavData: jiraServiceManagementNavData, jiraProductDiscoveryNavData: jiraProductDiscoveryNavData } = data || {};
    switch(projectType){
        case 'jira_work_management':
            return jiraWorkManagementNavData?.project ? $994f1ddfe6829bdc$var$getProject(jiraWorkManagementNavData.project) : null;
        case 'jira_software':
            return jiraSoftwareNavData?.project ? $994f1ddfe6829bdc$var$getProject(jiraSoftwareNavData.project) : null;
        case 'jira_service_management':
            return jiraServiceManagementNavData?.project ? $994f1ddfe6829bdc$var$getProject(jiraServiceManagementNavData.project) : null;
        case 'jira_product_discovery':
            return jiraProductDiscoveryNavData?.project ? $994f1ddfe6829bdc$var$getProject(jiraProductDiscoveryNavData.project) : null;
        case null:
        default:
            return null;
    }
};

});


parcelRegister("i9XZP", function(module, exports) {

$parcel$export(module.exports, "PageDwellAnalyticsListener", () => $f3c89b23479724f1$export$6cf89f098b551dad);

var $eUqFw = parcelRequire("eUqFw");

var $kpmC0 = parcelRequire("kpmC0");

var $10fdS = parcelRequire("10fdS");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $bNe1g = parcelRequire("bNe1g");

var $h3mHU = parcelRequire("h3mHU");

var $98uAm = parcelRequire("98uAm");
const $f3c89b23479724f1$var$WAIT_DURATION = 5000;
/**
 * Dispatches AnalyticsEvent for when a user stays on a page for a set period of time
 */ const $f3c89b23479724f1$export$6cf89f098b551dad = ()=>{
    const [hasFired, setHasFired] = (0, $eUqFw.useState)(false);
    const route = (0, $10fdS.useCurrentRoute)();
    const routeName = route.name;
    const [{ isReady: isReady }] = (0, $h3mHU.useSpaStatePageReady)();
    const isVisible = (0, $98uAm.usePageVisibility)();
    const interval = (0, $eUqFw.useRef)(null);
    const { data: projectData } = (0, $bNe1g.useProjectContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { isCollapsed: isLeftSidebarCollapsed } = (0, $kpmC0.useLeftSidebarState)();
    (0, $eUqFw.useEffect)(()=>{
        setHasFired(false);
    }, [
        routeName
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isReady) {
            interval.current = null;
            return;
        }
        // If the page is visible, set the analytics event to run after the specified duration
        if (isVisible && !hasFired) interval.current = setTimeout(()=>{
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'page dwelled', routeName, {
                containerId: projectData?.projectId,
                containerType: projectData?.projectType,
                isLeftSidebarCollapsed: isLeftSidebarCollapsed
            });
            setHasFired(true);
        }, $f3c89b23479724f1$var$WAIT_DURATION);
        return ()=>{
            // @ts-expect-error - TS2769 - No overload matches this call.
            interval.current = clearTimeout(interval.current);
        };
    }, [
        createAnalyticsEvent,
        hasFired,
        isReady,
        isVisible,
        routeName,
        projectData?.projectId,
        projectData?.projectType,
        isLeftSidebarCollapsed
    ]);
    return null;
};

});
parcelRegister("98uAm", function(module, exports) {

$parcel$export(module.exports, "usePageVisibility", () => $628deecc3f05d159$export$6c98eb2f12f4ec61);

var $eUqFw = parcelRequire("eUqFw");

var $fEYK5 = parcelRequire("fEYK5");
const $628deecc3f05d159$export$6c98eb2f12f4ec61 = ()=>{
    const [isVisible, setIsVisible] = (0, $eUqFw.useState)((0, $fEYK5.isPageVisible)());
    (0, $eUqFw.useEffect)(()=>{
        const onVisibilityChange = ()=>setIsVisible((0, $fEYK5.isPageVisible)());
        document.addEventListener('visibilitychange', onVisibilityChange);
        return ()=>{
            document.removeEventListener('visibilitychange', onVisibilityChange);
        };
    }, []);
    return isVisible;
};

});
parcelRegister("fEYK5", function(module, exports) {

$parcel$export(module.exports, "supportedVisiblityEvent", () => $72bec4f04bbd1d44$export$f7132cb36c80dad);
$parcel$export(module.exports, "isPageVisible", () => $72bec4f04bbd1d44$export$ae4f9b990bc70f70);
const $72bec4f04bbd1d44$var$visibilityMap = {
    // document property: event name
    hidden: 'visibilitychange',
    mozHidden: 'mozvisibilitychange',
    msHidden: 'msvisibilitychange',
    webkitHidden: 'webkitvisibilitychange'
};
const $72bec4f04bbd1d44$var$supportedHiddenKey = Object.keys($72bec4f04bbd1d44$var$visibilityMap).find(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Document'.
(key)=>typeof document !== 'undefined' && typeof document[key] !== 'undefined');
const $72bec4f04bbd1d44$export$f7132cb36c80dad = $72bec4f04bbd1d44$var$visibilityMap[$72bec4f04bbd1d44$var$supportedHiddenKey];
const $72bec4f04bbd1d44$export$ae4f9b990bc70f70 = ()=>typeof document !== 'undefined' && !document[$72bec4f04bbd1d44$var$supportedHiddenKey];

});



parcelRegister("2m6cd", function(module, exports) {

$parcel$export(module.exports, "MatchedRouteListener", () => $adf6545c3ff6605a$export$c6d9204abc182c3b);

var $eUqFw = parcelRequire("eUqFw");

var $keguF = parcelRequire("keguF");

var $kJlBc = parcelRequire("kJlBc");
const $adf6545c3ff6605a$export$c6d9204abc182c3b = ()=>{
    const [{ route: route, match: match }] = (0, $kJlBc.useRouter)();
    (0, $eUqFw.useMemo)(()=>(0, $keguF.setMatchedRoute)(route, match), [
        route,
        match
    ]);
    return null;
};

});

parcelRegister("hEyt5", function(module, exports) {

$parcel$export(module.exports, "PreviousRouterStateListener", () => $e9e95a1ddd50ffec$export$49e28489f2124002);

var $eUqFw = parcelRequire("eUqFw");

var $hzcvF = parcelRequire("hzcvF");

var $keguF = parcelRequire("keguF");

var $kJlBc = parcelRequire("kJlBc");
const $e9e95a1ddd50ffec$export$3fd5ddd6b8e9a200 = ({ routerState: routerState })=>{
    const previousRouterState = (0, $hzcvF.usePrevious)(routerState);
    (0, $eUqFw.useEffect)(()=>{
        (0, $keguF.setPreviousRouterState)(previousRouterState ?? null);
    }, [
        previousRouterState
    ]);
    return null;
};
const $e9e95a1ddd50ffec$export$49e28489f2124002 = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.RouterSubscriber), null, (routerState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e9e95a1ddd50ffec$export$3fd5ddd6b8e9a200, {
            routerState: routerState
        })));
$e9e95a1ddd50ffec$export$49e28489f2124002.displayName = 'PreviousRouterStateListener';

});
parcelRegister("hzcvF", function(module, exports) {

$parcel$export(module.exports, "usePrevious", () => $42dfce76254176f5$export$5cae361ad82dce8b);
$parcel$export(module.exports, "usePreviousWithInitial", () => $42dfce76254176f5$export$23fbbb2e62c4a911);

var $eUqFw = parcelRequire("eUqFw");
const $42dfce76254176f5$export$5cae361ad82dce8b = (value)=>{
    const ref = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $42dfce76254176f5$export$23fbbb2e62c4a911 = (value)=>{
    const ref = (0, $eUqFw.useRef)(value);
    (0, $eUqFw.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};

});


parcelRegister("iOtr0", function(module, exports) {

$parcel$export(module.exports, "default", () => $6aa3a3761ea48b01$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $53ciZ = parcelRequire("53ciZ");

var $lgxha = parcelRequire("lgxha");

var $5omJE = parcelRequire("5omJE");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $kJlBc = parcelRequire("kJlBc");

var $js5iW = parcelRequire("js5iW");
/**
 * Defines the component for the `querystring-notifier` module.
 */ const $6aa3a3761ea48b01$var$QueryStringNotifier = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa),
        sourceName: "querystringNotifications"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5omJE.default), null, (flagService)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.RouterSubscriber), null, ({ location: { search: search } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.RouterActions), null, ({ replace: replace })=>{
                const { showFlag: showFlag, ...query } = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(search);
                if (!showFlag) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $js5iW.default)[showFlag] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireOperationalAnalytics), {
                    eventName: "querystringNotification shown",
                    componentName: "flag",
                    attributes: {
                        showFlag: showFlag
                    }
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireOperationalAnalytics), {
                    eventName: "querystringNotification notFound",
                    componentName: "flag",
                    attributes: {
                        showFlag: showFlag
                    }
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
                    op: ()=>{
                        if ((0, $js5iW.default)[showFlag]) flagService.showFlag((0, $js5iW.default)[showFlag]);
                        replace(`?${(0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(query)}`);
                    }
                }));
            }))));
var $6aa3a3761ea48b01$export$2e2bcd8739ae039 = $6aa3a3761ea48b01$var$QueryStringNotifier;

});
parcelRegister("lgxha", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c6fb1eab8416e3f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
// eslint-disable-next-line jira/react/no-class-components
class $7c6fb1eab8416e3f$var$OpTrigger extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            args: []
        };
    }
    componentDidMount() {
        this.props.op(...this.props.args);
    }
    render() {
        return null;
    }
}
var $7c6fb1eab8416e3f$export$2e2bcd8739ae039 = $7c6fb1eab8416e3f$var$OpTrigger;

});

parcelRegister("5omJE", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e16a0c982e8c9d5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $k8Qyf = parcelRequire("k8Qyf");
const $7e16a0c982e8c9d5$var$FlagServiceSubscriber = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children((0, $k8Qyf.flagService)));
var $7e16a0c982e8c9d5$export$2e2bcd8739ae039 = $7e16a0c982e8c9d5$var$FlagServiceSubscriber;

});

parcelRegister("d6f6c", function(module, exports) {

$parcel$export(module.exports, "FireUiAnalytics", () => $6c42ad247d2b6151$export$5a67e7291fd4569e);
$parcel$export(module.exports, "FireTrackAnalytics", () => $6c42ad247d2b6151$export$5f0d7aae8dfa8b86);
$parcel$export(module.exports, "FireOperationalAnalytics", () => $6c42ad247d2b6151$export$b71c3ada5d4ec5da);
$parcel$export(module.exports, "FireScreenAnalytics", () => $6c42ad247d2b6151$export$2ccf161b817b43b);

var $eUqFw = parcelRequire("eUqFw");

var $2jDha = parcelRequire("2jDha");


var $jMP2a = parcelRequire("jMP2a");
// eslint-disable-next-line jira/react/no-class-components
class $6c42ad247d2b6151$var$FireComponent extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { type: type, attributes: attributes, eventName: eventName, componentName: componentName, action: actionProps, actionSubject: actionSubjectProps, actionSubjectId: actionSubjectIdProps } = this.props;
        if (eventName && (actionProps || actionSubjectProps)) throw Error('eventName is an alias for action & actionSubject, provide only one of those');
        if (componentName && actionSubjectIdProps) throw Error('componentName is an alias for actionSubjectId, provide only one of those');
        const eventNameSplit = eventName ? eventName.split(' ') : [];
        const action = actionProps || eventNameSplit[1];
        const actionSubject = actionSubjectProps || eventNameSplit[0];
        if (!action || !actionSubject) throw Error('eventName should exist and be in the format "subject action", i.e. "button clicked", "menu opened", "issue created", etc');
        const actionSubjectId = actionSubjectIdProps || componentName;
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: action
        });
        (0, $jMP2a.fireAnalytics)(analyticsEvent, type, {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
    }
    render() {
        return null;
    }
}
const $6c42ad247d2b6151$export$64eb47d7b94ba089 = (0, $2jDha.default)()($6c42ad247d2b6151$var$FireComponent);
const $6c42ad247d2b6151$export$5a67e7291fd4569e = (props)=>// @ts-expect-error - TS2322 - Type '{ type: "UI"; attributes?: { [key: string]: any; } | undefined; eventName?: string | undefined; componentName?: string | undefined; action?: string | undefined; actionSubject?: string | undefined; actionSubjectId?: string | undefined; }' is not assignable to type 'IntrinsicAttributes & Pick<WithAnalyticsEventsProps, never> & RefAttributes<any>'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c42ad247d2b6151$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $41ea3621645e2acc$export$a1562d08625f5d7e)
    });
const $6c42ad247d2b6151$export$5f0d7aae8dfa8b86 = (props)=>// @ts-expect-error - TS2322 - Type '{ type: "TRACK"; attributes?: { [key: string]: any; } | undefined; eventName?: string | undefined; componentName?: string | undefined; action?: string | undefined; actionSubject?: string | undefined; actionSubjectId?: string | undefined; }' is not assignable to type 'IntrinsicAttributes & Pick<WithAnalyticsEventsProps, never> & RefAttributes<any>'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c42ad247d2b6151$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $41ea3621645e2acc$export$947dac6c72b26f81)
    });
const $6c42ad247d2b6151$export$b71c3ada5d4ec5da = (props)=>// @ts-expect-error - TS2322 - Type '{ type: "OPERATIONAL"; attributes?: { [key: string]: any; } | undefined; eventName?: string | undefined; componentName?: string | undefined; action?: string | undefined; actionSubject?: string | undefined; actionSubjectId?: string | undefined; }' is not assignable to type 'IntrinsicAttributes & Pick<WithAnalyticsEventsProps, never> & RefAttributes<any>'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c42ad247d2b6151$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $41ea3621645e2acc$export$12346a674644c156)
    });
const $6c42ad247d2b6151$export$2ccf161b817b43b = (props)=>// @ts-expect-error - TS2322 - Type '{ type: "SCREEN"; eventName: string; attributes?: { [key: string]: any; } | undefined; componentName?: string | undefined; action?: string | undefined; actionSubject?: string | undefined; actionSubjectId?: string | undefined; }' is not assignable to type 'IntrinsicAttributes & Pick<WithAnalyticsEventsProps, never> & RefAttributes<any>'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c42ad247d2b6151$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $41ea3621645e2acc$export$f1d537d508d2945a),
        eventName: "screen viewed"
    });

});

parcelRegister("js5iW", function(module, exports) {

$parcel$export(module.exports, "default", () => $da00c22705b8222e$export$2e2bcd8739ae039);

var $eo17r = parcelRequire("eo17r");

var $7mirP = parcelRequire("7mirP");
const $da00c22705b8222e$var$notificationMessages = {
    'jsw.board-not-found': {
        id: (0, $eo17r.toFlagId)('jsw.board-not-found'),
        type: 'error',
        title: (0, $7mirP.default).boardNotFound,
        description: (0, $7mirP.default).boardNotFoundDescription
    },
    'jsw.project-not-found': {
        id: (0, $eo17r.toFlagId)('jsw.project-not-found'),
        type: 'error',
        title: (0, $7mirP.default).projectNotFound,
        description: (0, $7mirP.default).projectNotFoundDescription
    }
};
var $da00c22705b8222e$export$2e2bcd8739ae039 = $da00c22705b8222e$var$notificationMessages;

});
parcelRegister("7mirP", function(module, exports) {

$parcel$export(module.exports, "default", () => $fecba56a8f0fa28c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
// Don't confuse Intl messages with `Flag`s
const $fecba56a8f0fa28c$var$messages = (0, $90IgZ.defineMessages)({
    boardNotFound: {
        "id": "query-string-notifier.common.board-not-found",
        "defaultMessage": "Board not found"
    },
    boardNotFoundDescription: {
        "id": "query-string-notifier.common.board-not-found-description",
        "defaultMessage": "You tried to access a board that doesn't exist or that you don't have permission to see."
    },
    projectNotFound: {
        "id": "query-string-notifier.common.project-not-found",
        "defaultMessage": "Project not found"
    },
    projectNotFoundDescription: {
        "id": "query-string-notifier.common.project-not-found-description",
        "defaultMessage": "You tried to access a project that doesn't exist or that you don't have permission to see."
    }
});
var $fecba56a8f0fa28c$export$2e2bcd8739ae039 = $fecba56a8f0fa28c$var$messages;

});



parcelRegister("isbb2", function(module, exports) {

$parcel$export(module.exports, "coalesce", () => $7465cd989816140c$export$6e5538615c060df7);
$parcel$export(module.exports, "renderGlobalComponents", () => $7465cd989816140c$export$fc28c9563350e5b8);
$parcel$export(module.exports, "createLayout", () => $7465cd989816140c$export$3dd437ade36ede40);
$parcel$export(module.exports, "composeLayouts", () => $7465cd989816140c$export$6c041b39c370853f);
$parcel$export(module.exports, "withProjectContext", () => $7465cd989816140c$export$e97a7da67a5b8ce4);

var $eUqFw = parcelRequire("eUqFw");

var $cPEpP = parcelRequire("cPEpP");

var $gGtKh = parcelRequire("gGtKh");

var $jiReJ = parcelRequire("jiReJ");
const $7465cd989816140c$export$6e5538615c060df7 = (maybeString)=>maybeString == null || maybeString === '' ? undefined : maybeString;
const $7465cd989816140c$export$fc28c9563350e5b8 = (components)=>components.map((Component, i)=>{
        const { displayName: displayName, name: name } = Component;
        const key = $7465cd989816140c$export$6e5538615c060df7(displayName) ?? $7465cd989816140c$export$6e5538615c060df7(name) ?? i;
        return(// TODO Only add suspense if lazy component, otherwise add suspense within component array
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: key?.toString(),
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null),
            key: key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, null)));
    });
const $7465cd989816140c$export$3dd437ade36ede40 = ({ globalComponents: globalComponents = [], rightSidebars: rightSidebars = [], isChromeless: isChromeless = false } = {})=>({
        isChromeless: isChromeless,
        globalComponents: Array.from(new Set(globalComponents)),
        rightSidebars: Array.from(new Set(rightSidebars))
    });
const $7465cd989816140c$export$6c041b39c370853f = (...layouts)=>{
    if (layouts.length === 1) return $7465cd989816140c$export$3dd437ade36ede40(layouts[0]);
    const layout = layouts.reduce((l, { globalComponents: globalComponents = [], rightSidebars: rightSidebars = [], isChromeless: isChromeless = false })=>({
            isChromeless: isChromeless,
            globalComponents: [
                ...l.globalComponents,
                ...globalComponents
            ],
            rightSidebars: [
                ...l.rightSidebars,
                ...rightSidebars
            ]
        }), {
        globalComponents: [],
        rightSidebars: [],
        isChromeless: false
    });
    return $7465cd989816140c$export$3dd437ade36ede40(layout);
};
const $7465cd989816140c$var$capitalize = (str)=>`${str.charAt(0).toUpperCase()}${str.slice(1)}`;
const $7465cd989816140c$var$formatPrefix = (style, type)=>{
    if (!style && !type) return 'Empty';
    if (style === 'any' && type === 'any') return 'Any';
    const formattedStyle = $7465cd989816140c$var$capitalize(style === 'next-gen' ? 'nextGen' : style ?? '');
    if (type === 'any') return formattedStyle;
    const formattedType = $7465cd989816140c$var$capitalize(type === 'service_desk' ? 'service' : type ?? '');
    if (style === 'any') return formattedType;
    return `${formattedStyle}${formattedType}`;
};
const $7465cd989816140c$export$e97a7da67a5b8ce4 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
Component, options)=>{
    const { project: expectedProject } = options;
    const ScopedComponent = ()=>{
        const { data: project, loading: loading } = (0, $cPEpP.useProject)();
        if (loading) return null;
        if ((expectedProject?.type === 'any' ? !project : project?.type !== expectedProject?.type) || (expectedProject?.style === 'any' ? !project : project?.style !== expectedProject?.style)) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, null);
    };
    const name = $7465cd989816140c$export$6e5538615c060df7(Component.displayName) ?? $7465cd989816140c$export$6e5538615c060df7(Component.name) ?? 'Component';
    const prefix = $7465cd989816140c$var$formatPrefix(expectedProject?.style, expectedProject?.type);
    ScopedComponent.displayName = `with${prefix}ProjectContext(${name})`;
    return ScopedComponent;
};

});
parcelRegister("jiReJ", function(module, exports) {

$parcel$export(module.exports, "layoutWithCondition", () => $b330a57b19ee3016$export$c5db53e93ba35c0f);
const $b330a57b19ee3016$export$c5db53e93ba35c0f = (conditionGetter, itemTrue, itemFalse)=>({
        get isChromeless () {
            return conditionGetter() ? itemTrue.isChromeless : itemFalse.isChromeless;
        },
        get globalComponents () {
            return conditionGetter() ? itemTrue.globalComponents : itemFalse.globalComponents;
        },
        get rightSidebars () {
            return conditionGetter() ? itemTrue.rightSidebars : itemFalse.rightSidebars;
        }
    });

});


parcelRegister("5EZtQ", function(module, exports) {

$parcel$export(module.exports, "rovoVideoModalEntryPoint", () => $295188a6a3871459$export$2f67fedc6d5555a5);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $295188a6a3871459$export$2f67fedc6d5555a5 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(async ()=>(parcelRequire("10sSh")).then(({ RovoVideoModal: RovoVideoModal })=>RovoVideoModal), {
        moduleId: "3a307b00"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("10sSh", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('aVqgB')
        ]);
        const value = parcelRequire('63tmB');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("aVqgB")
    ]).then(()=>parcelRequire('63tmB'));
}

});


parcelRegister("cADdB", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4a03ce1abcffd5c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $k4nIh = parcelRequire("k4nIh");

var $d6f6c = parcelRequire("d6f6c");

var $kJlBc = parcelRequire("kJlBc");
var $3HCkE = parcelRequire("3HCkE");

var $ixwgj = parcelRequire("ixwgj");
/**
 * Ensures users are redirected to the correct project URL when there's a mismatch in the project key.
 * It preserves query parameters during redirection and logs the event for analytics.
 */ const $e4a03ce1abcffd5c$var$ProjectKeyRedirect = ({ FireOperationalAnalytics: FireOperationalAnalytics = (0, $d6f6c.FireOperationalAnalytics), Redirect: Redirect = (0, $kJlBc.Redirect), useResource: useResource = (0, $3HCkE.useResource), useRouter: useRouter = (0, $kJlBc.useRouter) })=>{
    const [{ location: location, match: { params: params, url: url }, query: query }] = useRouter();
    const projectKey = params.projectKey ?? query.projectKey;
    const { data: projectContext } = useResource((0, $ixwgj.projectContextResource));
    if (!projectKey || !projectContext?.projectKey) return null;
    if (projectKey === projectContext.projectKey) return null;
    const search = {
        ...query,
        ...query.projectKey ? {
            projectKey: projectContext.projectKey
        } : {}
    };
    // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
    const queryString = (0, $k4nIh.qs).stringify(search, Object.entries(search).length > 0);
    // Just a slight risk mitigation - only do the string replace if the match param is there
    const path = params.projectKey != null ? url.replace(projectKey, projectContext.projectKey) : url;
    const to = `${path}${queryString}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FireOperationalAnalytics, {
        eventName: "ProjectKeyRedirect loaded",
        componentName: "ProjectKeyRedirect",
        attributes: {
            location: location,
            projectContext: projectContext
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Redirect, {
        to: to
    }));
};
var $e4a03ce1abcffd5c$export$2e2bcd8739ae039 = $e4a03ce1abcffd5c$var$ProjectKeyRedirect;

});

parcelRegister("lFrSS", function(module, exports) {

$parcel$export(module.exports, "AsyncUpflowIframeComponent", () => $d356d361dffc7fd3$export$7f34679273a30171);

var $7rh0R = parcelRequire("7rh0R");

const $d356d361dffc7fd3$export$7f34679273a30171 = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("87sYz")).then((exportedModule)=>exportedModule.UpflowIframeComponent), {
    ssr: false,
    moduleId: "./src/packages/growth/up-flow/upflow-iframe-plugin/src/main.tsx"
});

});
parcelRegister("87sYz", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('2zJry');
        const value = parcelRequire('7B2m0');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("2zJry").then(()=>parcelRequire('7B2m0'));
}

});


parcelRegister("cLxEl", function(module, exports) {

$parcel$export(module.exports, "upgradeOnboardingExperimentEntryPoint", () => $6d97522dd833edb7$export$94ad1b5fd850909f);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $6d97522dd833edb7$export$94ad1b5fd850909f = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(async ()=>(parcelRequire("6Jlsh")).then(({ UpgradeOnboardingExperiment: UpgradeOnboardingExperiment })=>UpgradeOnboardingExperiment), {
        moduleId: "86e9ce71"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("6Jlsh", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('gOc4U')
        ]);
        const value = parcelRequire('bvwqZ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("gOc4U")
    ]).then(()=>parcelRequire('bvwqZ'));
}

});


parcelRegister("BRKX9", function(module, exports) {

$parcel$export(module.exports, "JiraHeritageLoader", () => $49eb3c5692df3dbe$export$9499deca9933db5b);

var $eUqFw = parcelRequire("eUqFw");

var $4DtuZ = parcelRequire("4DtuZ");

var $8loyD = parcelRequire("8loyD");

var $10fdS = parcelRequire("10fdS");

var $h3mHU = parcelRequire("h3mHU");

var $16kIm = parcelRequire("16kIm");

var $8jPVO = parcelRequire("8jPVO");

var $kQZhv = parcelRequire("kQZhv");
const $49eb3c5692df3dbe$export$9499deca9933db5b = ()=>{
    const route = (0, $10fdS.useCurrentRoute)();
    const [{ isReady: isReady }] = (0, $h3mHU.useSpaStatePageReady)();
    const [hasHeritageDownloaded, setHasHeritageDownloaded] = (0, $eUqFw.useState)(false);
    (0, $kQZhv.useWrmStatsEffects)();
    /* eslint-disable jira/wrm/no-load-bridge */ const loadJiraHeritageDependencies = (0, $eUqFw.useCallback)(()=>{
        setHasHeritageDownloaded(true);
        (0, $16kIm.asyncWrmRequire)([
            ...(0, $8loyD.jiraSuperBatchDependencies),
            ...(0, $8jPVO.getJiraHeritageDependencies)()
        ]).then(()=>(0, $4DtuZ.waitForHeritage)()?.resolve?.());
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        if (isReady && !hasHeritageDownloaded) loadJiraHeritageDependencies();
    }, [
        hasHeritageDownloaded,
        isReady,
        loadJiraHeritageDependencies,
        route
    ]);
    return null;
};
$49eb3c5692df3dbe$export$9499deca9933db5b.displayName = 'JiraHeritageLoader';

});
parcelRegister("16kIm", function(module, exports) {

$parcel$export(module.exports, "asyncWrmRequire", () => $0ab2873dadb9f6da$export$1024fe099ca05f05);
$parcel$export(module.exports, "asyncWrmRequireWithPrefetch", () => $0ab2873dadb9f6da$export$3ca0de203efa570e);
/* eslint-disable jira/wrm/no-load-bridge */ 
var $beITa = parcelRequire("beITa");
var $dPoeR = parcelRequire("dPoeR");
const $0ab2873dadb9f6da$export$1024fe099ca05f05 = (resourcesToRequire)=>(0, $beITa.wrmRequire)(resourcesToRequire);
const $0ab2873dadb9f6da$export$3ca0de203efa570e = (resourcesToRequire, batchUrl)=>(0, $dPoeR.wrmRequireWithPrefetch)(resourcesToRequire, batchUrl);

});

parcelRegister("8jPVO", function(module, exports) {

$parcel$export(module.exports, "getJiraHeritageDependencies", () => $f6b7e29d2a8831d9$export$e8f6d7acd5817fa2);
const $f6b7e29d2a8831d9$export$e8f6d7acd5817fa2 = ()=>[
        // superbatch resources
        // analytics
        'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
        // dependencies from HeaderFooterRendering
        'wrc!jira.webresources:key-commands',
        'wrc!jira.webresources:header',
        // . dialog
        'wrc!com.atlassian.administration.atlassian-admin-quicksearch-jira:admin-quicksearch-webresources',
        // overrides for AUI, styles and bridge apis
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
        'wrc!jira.webresources:global-static',
        // browser metrics
        'wrc!com.atlassian.jira.plugins.jira-browser-metrics:contrib',
        'wrc!com.atlassian.plugins.browser.metrics.browser-metrics-plugin:impl',
        'wrc!com.atlassian.plugins.browser.metrics.browser-metrics-plugin:api',
        // repository shortcuts from navigation
        'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:repository-shortcuts-navigation-next',
        // issue view resources
        'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf-resources-init',
        // create board dialog
        'wrc!com.pyxis.greenhopper.jira:gh-create-board-adg3-no-condition',
        // old analytics library
        'wrc!com.atlassian.analytics.analytics-client:js-events',
        // frontend cache
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:global-cache',
        // impersonation flag (logged as someone)
        'wrc!com.atlassian.crowd.user-provisioning-vertigo-plugin:impersonation-resources',
        // flag displayed when there are too many emails on the instance
        'wrc!jira.webresources:spam-protection-flags',
        // in-product announcements (displayed e.g. if there is an incident)
        'wrc!com.atlassian.pas:pas-everypage-static',
        // Bento resources
        'wrc!com.atlassian.jira.jira-fileviewer-plugin:fileviewer',
        'wrc!com.atlassian.auiplugin:dialog2',
        'wrc!com.atlassian.jira.jira-fileviewer-plugin:atlassian-fileviewer',
        'wrc!com.atlassian.jira.jira-issue-nav-plugin:stylesheets'
    ];

});

parcelRegister("kQZhv", function(module, exports) {

$parcel$export(module.exports, "useWrmStatsEffects", () => $daca76ea3608ba43$export$7ff53723d9d2886d);

var $eUqFw = parcelRequire("eUqFw");

var $h3mHU = parcelRequire("h3mHU");
var $78d1w = parcelRequire("78d1w");
const $daca76ea3608ba43$export$7ff53723d9d2886d = ()=>{
    const [{ isReady: isReady }] = (0, $h3mHU.useSpaStatePageReady)();
    const [{ transitionsCount: transitionsCount }] = (0, $78d1w.useSpaStateTransition)();
    (0, $eUqFw.useEffect)(()=>{
        if (isReady && window.__WRM_INTERNAL_STATS__ && !window.__WRM_INTERNAL_STATS__.isPageInteractive) window.__WRM_INTERNAL_STATS__.isPageInteractive = true;
    }, [
        isReady
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (transitionsCount > 0) // clear stats on transition
        window.__WRM_INTERNAL_STATS__ = {};
    }, [
        transitionsCount
    ]);
};

});


parcelRegister("1OfKM", function(module, exports) {

$parcel$export(module.exports, "BreadcrumbAdapter", () => $f4d7bdf212cdca0f$export$2255367d5c9162b3);

var $eUqFw = parcelRequire("eUqFw");

var $bAoTi = parcelRequire("bAoTi");
const $f4d7bdf212cdca0f$export$2255367d5c9162b3 = ()=>{
    const baseUrl = '';
    // @ts-expect-error - TS2322 - Type '{ baseUrl: string; }' is not assignable to type 'IntrinsicAttributes & Omit<PropsWithDefault, "baseUrl" | keyof InjectedProps>'.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bAoTi.default), {
        baseUrl: baseUrl
    });
};

});
parcelRegister("bAoTi", function(module, exports) {

$parcel$export(module.exports, "default", () => $34d9050e380aaae9$export$2e2bcd8739ae039);

var $knPb9 = parcelRequire("knPb9");

var $3532a = parcelRequire("3532a");

var $7H4Eg = parcelRequire("7H4Eg");

var $8Of3p = parcelRequire("8Of3p");

var $l02Yw = parcelRequire("l02Yw");

var $jU94X = parcelRequire("jU94X");
var $34d9050e380aaae9$export$2e2bcd8739ae039 = (0, $knPb9.default)((0, $3532a.default), {
    LegacyApiBridge: // @ts-expect-error - Type 'FunctionComponent<Omit<PropsWithDefault, keyof AnalyticsEvents>>' is not assignable to type 'ComponentType<Props> | undefined'.
    $7H4Eg.default,
    LegacyBreadcrumbConnector: $8Of3p.default,
    LegacyBreadcrumbState: // @ts-expect-error - TS2322 - Type 'typeof LegacyBreadcrumbState' is not assignable to type 'ComponentType<LegacyBreadcrumbStateProviderProps> | undefined'.
    $jU94X.default,
    LegacyBreadcrumbRenderer: $l02Yw.default
});

});
parcelRegister("knPb9", function(module, exports) {

$parcel$export(module.exports, "getDisplayName", () => $e1b771d5f606c17c$export$be63e0664592e141);
$parcel$export(module.exports, "default", () => $e1b771d5f606c17c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $e1b771d5f606c17c$export$be63e0664592e141 = (WrappedComponent)=>{
    if (WrappedComponent.displayName != null && WrappedComponent.displayName !== '') return WrappedComponent.displayName;
    if (WrappedComponent.name != null && WrappedComponent.name !== '') return WrappedComponent.name;
    return 'Component';
};
/**
 * @deprecated Just pass the props explicitly or create a new component that provides them. Do not use HOCs.
 */ const $e1b771d5f606c17c$var$withInjectedProps = (WrappedComponent, injectedProps)=>{
    const WithInjectedProps = (props)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ...injectedProps,
            ...props
        });
    WithInjectedProps.displayName = `withInjectedProps(${$e1b771d5f606c17c$export$be63e0664592e141(WrappedComponent)})`;
    return WithInjectedProps;
};
var $e1b771d5f606c17c$export$2e2bcd8739ae039 = $e1b771d5f606c17c$var$withInjectedProps;

});

parcelRegister("3532a", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff6ade52479ed891$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hFmdR = parcelRequire("hFmdR");

var $ciZ8Y = parcelRequire("ciZ8Y");

const $ff6ade52479ed891$var$LegacyBreadcrumbAdapter = ({ baseUrl: baseUrl, LegacyBreadcrumbRenderer: LegacyBreadcrumbRenderer, LegacyBreadcrumbState: LegacyBreadcrumbState, LegacyApiBridge: LegacyApiBridge, LegacyBreadcrumbConnector: LegacyBreadcrumbConnector })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(LegacyBreadcrumbState, null, ({ api: api, state: state })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(LegacyApiBridge, {
            onInsertItem: api.insertItem,
            onRemoveItem: api.removeItem,
            onSetRenderTarget: api.setTargetElement
        }), // Only activate the breadcrumb connector if there is a breadcrumb render target
        state.targetElement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
            id: "legacy-breadcrumb-adapter"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(LegacyBreadcrumbConnector, {
            baseUrl: baseUrl,
            legacyTrail: state.trail
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(LegacyBreadcrumbRenderer, {
            targetElement: state.targetElement
        }))));
var $ff6ade52479ed891$export$2e2bcd8739ae039 = (0, $hFmdR.AnalyticsSource)('legacyBreadcrumbs', (0, $41ea3621645e2acc$export$f636b5b56f1d624a))($ff6ade52479ed891$var$LegacyBreadcrumbAdapter);

});
parcelRegister("hFmdR", function(module, exports) {

$parcel$export(module.exports, "AnalyticsSource", () => $3d95c57ea565c569$export$6890652a1aff7d1c);
$parcel$export(module.exports, "AnalyticsSubject", () => $3d95c57ea565c569$export$ec9f54bd4341ceb);

var $1ngde = parcelRequire("1ngde");
const $3d95c57ea565c569$export$6890652a1aff7d1c = (name, type)=>(WrappedComponent)=>(0, $1ngde.default)({
            source: `${name}${type}`
        })(WrappedComponent);
const $3d95c57ea565c569$export$ec9f54bd4341ceb = (name, attributes)=>(WrappedComponent)=>(0, $1ngde.default)({
            actionSubject: name,
            attributes: attributes
        })(WrappedComponent);

});


parcelRegister("7H4Eg", function(module, exports) {

$parcel$export(module.exports, "default", () => $078bdb0aa485f642$export$2e2bcd8739ae039);

var $2Enn0 = parcelRequire("2Enn0");

var $knPb9 = parcelRequire("knPb9");

var $jmX5T = parcelRequire("jmX5T");
const $078bdb0aa485f642$var$analyticsEvents = {
    onInsertItemFired: (analyticsEvent)=>(0, $2Enn0.fireOperationalAnalytics)(analyticsEvent, {
            attributes: {
                method: 'insertItem'
            }
        }),
    onRemoveItemFired: (analyticsEvent)=>(0, $2Enn0.fireOperationalAnalytics)(analyticsEvent, {
            attributes: {
                method: 'removeItem'
            }
        }),
    onSetRenderTargetFired: (analyticsEvent)=>(0, $2Enn0.fireOperationalAnalytics)(analyticsEvent, {
            attributes: {
                method: 'render'
            }
        }),
    onOnBreadCrumbsUpdateFired: (analyticsEvent)=>(0, $2Enn0.fireOperationalAnalytics)(analyticsEvent, {
            attributes: {
                method: 'onBreadCrumbsUpdate'
            }
        })
};
var $078bdb0aa485f642$export$2e2bcd8739ae039 = (0, $knPb9.default)((0, $jmX5T.default), $078bdb0aa485f642$var$analyticsEvents);

});
parcelRegister("2Enn0", function(module, exports) {

$parcel$export(module.exports, "fireOperationalAnalytics", () => $3ee3ca60c3a36803$export$79f423cc3fd39762);

var $3LiTJ = parcelRequire("3LiTJ");

var $guiFP = parcelRequire("guiFP");

var $etqm0 = parcelRequire("etqm0");

var $klunD = parcelRequire("klunD");
// @ts-expect-error - TS7006 - Parameter 'a' implicitly has an 'any' type.
const $3ee3ca60c3a36803$var$isNotUndefined = (a)=>a !== undefined;
const $3ee3ca60c3a36803$var$mapPayload = (payload)=>{
    const context = (0, $klunD.default)(payload);
    const { name: name } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($3LiTJ)))({
        ...context,
        ...context.attributes,
        attributes: undefined,
        name: name
    }, $3ee3ca60c3a36803$var$isNotUndefined);
};
const $3ee3ca60c3a36803$export$79f423cc3fd39762 = (event, payload)=>{
    // Causes issues with mounting the src/packages/confluence/project-pages/src/view/examples.js component in storybook tests.
    // This is due to node_modules/@atlassiansox/analytics-web-client/dist/analytics-web-client.with-deps.js producing a reference error with the normalize function
    // This is possibly due to some scope hoisting issue with jest that is not present in the browser
    try {
        event.update({
            ...$3ee3ca60c3a36803$var$mapPayload(payload),
            analyticsType: (0, $etqm0.OPERATIONAL_EVENT_TYPE)
        }).fire();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $guiFP.default)({
            event: event,
            error: e,
            meta: {
                id: 'fireOperationalAnalytics',
                packageName: 'jiraAnalyticsWebReact',
                teamName: 'legacy-jfp-team-do-not-use'
            }
        });
    }
};

});
parcelRegister("klunD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0af4980e66497eeb$export$2e2bcd8739ae039);

var $kkgbD = parcelRequire("kkgbD");

var $i7Fym = parcelRequire("i7Fym");
var // AnalyticsDataPayload is cast to inexact type so that it can also accept subtypes
// eslint-disable-next-line jira/import/no-anonymous-default-export
$0af4980e66497eeb$export$2e2bcd8739ae039 = (payload)=>{
    const { tags: tags, containerId: containerId, containers: containers, containerType: containerType, objectId: objectId, objectType: objectType, attributes: attributes } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($i7Fym)))({
        tags: tags,
        containerId: containerId,
        containers: containers,
        containerType: containerType,
        objectId: objectId,
        objectType: objectType,
        attributes: attributes
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kkgbD))));
};

});


parcelRegister("jmX5T", function(module, exports) {

$parcel$export(module.exports, "default", () => $c37f23517b903b52$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3JafE = parcelRequire("3JafE");
parcelRequire("8jBvP");

var $eGI9v = parcelRequire("eGI9v");

var $bDtAc = parcelRequire("bDtAc");
// eslint-disable-next-line jira/react/no-class-components
class $c37f23517b903b52$var$LegacyApiBridge extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { onInsertItem: onInsertItem, onRemoveItem: onRemoveItem, onSetRenderTarget: onSetRenderTarget, onBreadCrumbsUpdate: onBreadCrumbsUpdate } = this;
        (0, $bDtAc.default)({
            insertItem: onInsertItem,
            removeItem: onRemoveItem,
            render: onSetRenderTarget,
            onBreadCrumbsUpdate: onBreadCrumbsUpdate
        });
    }
    /* eslint-enable jira/react-no-unneeded-arrow-function-properties */ render() {
        return null;
    }
    constructor(...args){
        super(...args);
        /* eslint-disable jira/react-no-unneeded-arrow-function-properties */ this.onInsertItem = (item)=>{
            const { onInsertItem: onInsertItem, onInsertItemFired: onInsertItemFired } = this.props;
            onInsertItemFired();
            onInsertItem(item);
        };
        this.onRemoveItem = (itemId)=>{
            const { onRemoveItem: onRemoveItem, onRemoveItemFired: onRemoveItemFired } = this.props;
            onRemoveItemFired();
            onRemoveItem(itemId);
        };
        this.onSetRenderTarget = (element)=>{
            const { onSetRenderTarget: onSetRenderTarget, onSetRenderTargetFired: onSetRenderTargetFired } = this.props;
            onSetRenderTargetFired();
            onSetRenderTarget(element);
        };
        this.onBreadCrumbsUpdate = ()=>{
            const { onOnBreadCrumbsUpdateFired: onOnBreadCrumbsUpdateFired } = this.props;
            onOnBreadCrumbsUpdateFired();
            return (0, $3JafE.Observable).empty();
        };
    }
}
var $c37f23517b903b52$export$2e2bcd8739ae039 = (0, $eGI9v.default)('legacyApiBridge', {
    onInsertItemFired: 'apiMethodCalled',
    onRemoveItemFired: 'apiMethodCalled',
    onSetRenderTargetFired: 'apiMethodCalled',
    onOnBreadCrumbsUpdateFired: 'apiMethodCalled'
})($c37f23517b903b52$var$LegacyApiBridge);

});
parcelRegister("eGI9v", function(module, exports) {

$parcel$export(module.exports, "default", () => $9208d82098460921$export$2e2bcd8739ae039);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");
const $9208d82098460921$export$871de8747c9eaa88 = (props)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            ...result,
            [key]: {
                action: props[key]
            }
        }), {});
/**
 * Augments component's callbacks with analytics event as the last attribute, but does fires them
 * @example
 * ```tsx
 * // adds componentName into AnalyticsContext and adds pre-backed 'clicked' event to onClick arguments
 *  const componentWithAnalytics('FooComponent', { onClick: 'clicked' })(Foo)
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9208d82098460921$var$componentWithAnalytics(componentName, eventActions) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(WrappedComponent) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return (0, $1ngde.default)({
            componentName: componentName
        })((0, $2jDha.default)($9208d82098460921$export$871de8747c9eaa88(eventActions))(WrappedComponent));
    };
}
var $9208d82098460921$export$2e2bcd8739ae039 = $9208d82098460921$var$componentWithAnalytics;

});

parcelRegister("bDtAc", function(module, exports) {

$parcel$export(module.exports, "default", () => $801e164601d3872a$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $ds5Im = parcelRequire("ds5Im");

var $gUUjF = parcelRequire("gUUjF");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$801e164601d3872a$export$2e2bcd8739ae039 = (legacyAPI)=>// eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $ds5Im.loadBridgeWeak)({
        name: 'jira/globalnavigator/breadcrumbs/bridge'
    }).then((bridge)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        bridge(legacyAPI);
    }).catch((err)=>(0, $gUUjF.default).safeErrorWithoutCustomerData('breadcrumbs.v2.bridge', err.toString()));

});



parcelRegister("8Of3p", function(module, exports) {

$parcel$export(module.exports, "default", () => $5de6401c7e8172f3$export$2e2bcd8739ae039);

var $knPb9 = parcelRequire("knPb9");

var $kKe2o = parcelRequire("kKe2o");

var $hCPt9 = parcelRequire("hCPt9");

var $dpXKE = parcelRequire("dpXKE");

var $5c2C3 = parcelRequire("5c2C3");

var $1bzuc = parcelRequire("1bzuc");

var $i7f3H = parcelRequire("i7f3H");
var $5de6401c7e8172f3$export$2e2bcd8739ae039 = (0, $knPb9.default)((0, $1bzuc.default), {
    Breadcrumb: $kKe2o.default,
    ProjectBreadcrumb: $dpXKE.default,
    BoardBreadcrumb: // @ts-expect-error - TS2322 - Type '{ ({ baseUrl, children, boardId, boardName, isSimplifiedProject, projectId, }: BoardBreadcrumbProps): JSX.Element; defaultProps: { children: null; isSimplifiedProject: boolean; projectId: undefined; }; }' is not assignable to type 'ComponentType<Partial<BoardBreadcrumbProps>> | undefined'.
    $hCPt9.default,
    UserBreadcrumb: $5c2C3.default,
    ContextProvider: $i7f3H.default
});

});
parcelRegister("kKe2o", function(module, exports) {

$parcel$export(module.exports, "default", () => $62b11cd1f8e73c2f$export$2e2bcd8739ae039);

var $aTgXo = parcelRequire("aTgXo");
var $62b11cd1f8e73c2f$export$2e2bcd8739ae039 = (0, $aTgXo.default);

});
parcelRegister("aTgXo", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd5d72148724b95b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $hompL = parcelRequire("hompL");

var $bfY8R = parcelRequire("bfY8R");
// eslint-disable-next-line jira/react/no-class-components
class $dd5d72148724b95b$var$BreadcrumbOps extends (0, $eUqFw.Component) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(props){
        super(props);
        this.id = '';
        this.id = (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4();
        if (false) this.onPushBreadcrumb();
    }
    componentDidMount() {
        this.onPushBreadcrumb();
    }
    componentDidUpdate(prevProps) {
        const { breadcrumb: prevBreadcrumb } = prevProps;
        const { api: api, breadcrumb: breadcrumb } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(prevBreadcrumb, breadcrumb)) api.updateBreadcrumb({
            id: this.id,
            ...breadcrumb
        });
    }
    componentWillUnmount() {
        const { api: api } = this.props;
        api.popBreadcrumb();
    }
    onPushBreadcrumb() {
        const { api: api, breadcrumb: breadcrumb } = this.props;
        api.pushBreadcrumb({
            id: this.id,
            ...breadcrumb
        });
    }
    render() {
        return null;
    }
}
const $dd5d72148724b95b$var$Breadcrumb = ({ breadcrumb: breadcrumb, children: children })=>// @ts-expect-error - TS2745 - This JSX tag's 'children' prop expects type 'never' which requires multiple children, but only a single child was provided.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bfY8R.BreadcrumbActions), null, (__, actions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dd5d72148724b95b$var$BreadcrumbOps, {
            api: actions,
            breadcrumb: breadcrumb
        }), children));
$dd5d72148724b95b$var$Breadcrumb.defaultProps = {
    children: null
};
var $dd5d72148724b95b$export$2e2bcd8739ae039 = $dd5d72148724b95b$var$Breadcrumb;

});
parcelRegister("bfY8R", function(module, exports) {

$parcel$export(module.exports, "useBreadcrumbs", () => $3e01453c51fda3d9$export$8cefe241bd876ca0);
$parcel$export(module.exports, "BreadcrumbActions", () => $3e01453c51fda3d9$export$9862c338ec0a6884);
$parcel$export(module.exports, "BreadcrumbContainer", () => $3e01453c51fda3d9$export$c7432936d9c50db7);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");
const $3e01453c51fda3d9$var$initialState = {
    trail: []
};
const $3e01453c51fda3d9$export$e324594224ef24da = {
    pushBreadcrumb: (breadcrumb)=>// @ts-expect-error - TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'getState' implicitly has an 'any' type.
        ({ setState: setState, getState: getState })=>{
            setState({
                trail: [
                    ...getState().trail,
                    breadcrumb
                ]
            });
        },
    popBreadcrumb: ()=>// @ts-expect-error - TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'getState' implicitly has an 'any' type.
        ({ setState: setState, getState: getState })=>{
            setState({
                trail: getState().trail.slice(0, -1)
            });
        },
    updateBreadcrumb: (breadcrumb)=>// @ts-expect-error - TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'getState' implicitly has an 'any' type.
        ({ setState: setState, getState: getState })=>{
            // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
            const newTrail = getState().trail.map((item)=>item.id === breadcrumb.id ? breadcrumb : item);
            setState({
                trail: newTrail
            });
        }
};
const $3e01453c51fda3d9$var$Store = (0, $a61MH.createStore)({
    initialState: $3e01453c51fda3d9$var$initialState,
    actions: $3e01453c51fda3d9$export$e324594224ef24da,
    name: 'BreadcrumbSweetState'
});
const $3e01453c51fda3d9$var$_BreadcrumbSubscriber = (0, $dYfll.createSubscriber)($3e01453c51fda3d9$var$Store);
const $3e01453c51fda3d9$export$8cefe241bd876ca0 = (0, $ggKAj.createHook)($3e01453c51fda3d9$var$Store);
const $3e01453c51fda3d9$export$9862c338ec0a6884 = (0, $dYfll.createSubscriber)($3e01453c51fda3d9$var$Store, {
    selector: null
});
const $3e01453c51fda3d9$export$c7432936d9c50db7 = (0, $heB5U.createContainer)($3e01453c51fda3d9$var$Store);

});



parcelRegister("hCPt9", function(module, exports) {

$parcel$export(module.exports, "default", () => $75a50236b83a41ea$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kKe2o = parcelRequire("kKe2o");

var $5IARc = parcelRequire("5IARc");
const $75a50236b83a41ea$var$BoardBreadcrumb = ({ baseUrl: baseUrl, children: children, boardId: boardId, boardName: boardName, isSimplifiedProject: isSimplifiedProject, projectId: projectId })=>{
    const breadcrumb = {
        href: (0, $5IARc.createBoardUrl)(baseUrl, boardId),
        text: boardName,
        type: 'boardName',
        analyticsAttributes: {
            nextGenProject: isSimplifiedProject,
            projectConfig: isSimplifiedProject !== undefined && isSimplifiedProject === true ? 'next-gen' : 'classic'
        },
        analyticsFields: {
            name: 'navigateToSubProject',
            containerId: projectId,
            containerType: 'project'
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKe2o.default), {
        breadcrumb: breadcrumb
    }, children);
};
$75a50236b83a41ea$var$BoardBreadcrumb.defaultProps = {
    children: null,
    isSimplifiedProject: false,
    projectId: undefined
};
var $75a50236b83a41ea$export$2e2bcd8739ae039 = $75a50236b83a41ea$var$BoardBreadcrumb;

});
parcelRegister("5IARc", function(module, exports) {

$parcel$export(module.exports, "createProjectUrl", () => $f5b81aae15d86847$export$1bdb1f038c5a2a90);
$parcel$export(module.exports, "createProjectSettingsUrl", () => $f5b81aae15d86847$export$c435fcb42a65af32);
$parcel$export(module.exports, "createBoardUrl", () => $f5b81aae15d86847$export$7037e05c8c7af6dc);

var $cqJw8 = parcelRequire("cqJw8");
const $f5b81aae15d86847$export$1bdb1f038c5a2a90 = (baseUrl, projectKey)=>`${baseUrl}/browse/${encodeURIComponent(projectKey)}`;
const $f5b81aae15d86847$export$c435fcb42a65af32 = (baseUrl, projectKey, projectType, isSimplified)=>{
    if (isSimplified) return (0, $cqJw8.getNextgenSettingsUrl)(projectType, projectKey);
    return `/projects/${projectKey}/settings`;
};
const $f5b81aae15d86847$export$7037e05c8c7af6dc = (baseUrl, boardId)=>`/secure/RapidBoard.jspa?rapidView=${boardId}`;

});
parcelRegister("cqJw8", function(module, exports) {

$parcel$export(module.exports, "getNextgenSettingsUrl", () => $8bf9744795c994e7$export$26432406821aa7bf);
$parcel$export(module.exports, "getNextgenSettingsIssueTypesUrl", () => $8bf9744795c994e7$export$defee92e506aa306);
$parcel$export(module.exports, "getNextgenSettingsWorkflowUrl", () => $8bf9744795c994e7$export$9133e09a98a043dc);
$parcel$export(module.exports, "getNextgenSettingsJSDAutomationUrl", () => $8bf9744795c994e7$export$b0d20d18e0230e83);
$parcel$export(module.exports, "getClassicJSWSettingsUrl", () => $8bf9744795c994e7$export$ff0a17aa36a000df);
$parcel$export(module.exports, "getProjectSettingsDetailsUrl", () => $8bf9744795c994e7$export$16d52b9357bb73ab);
$parcel$export(module.exports, "getClassicIssueLayoutSettingsUrl", () => $8bf9744795c994e7$export$d531a9788343348f);
$parcel$export(module.exports, "getClassicRequestTypeLayoutSettingsUrl", () => $8bf9744795c994e7$export$dad567762dae162e);

var $7ZZxN = parcelRequire("7ZZxN");

var $6bYiA = parcelRequire("6bYiA");

var $6ZTsa = parcelRequire("6ZTsa");

var $avawr = parcelRequire("avawr");
const $8bf9744795c994e7$export$26432406821aa7bf = (projectType, projectKey)=>{
    const products = {
        [(0, $7ZZxN.CORE_PROJECT)]: 'core',
        [(0, $7ZZxN.SERVICE_DESK_PROJECT)]: 'servicedesk',
        [(0, $7ZZxN.CUSTOMER_SERVICE_PROJECT)]: 'customerservice',
        [(0, $7ZZxN.SOFTWARE_PROJECT)]: 'software',
        [(0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)]: 'polaris'
    };
    const product = products[projectType];
    if (!product) {
        (0, $avawr.logError)((0, $6bYiA.PACKAGE_NAME), (0, $6ZTsa.toErrorId)('urls'), (0, $6ZTsa.toErrorMessage)(`Can't build default project settings url for project type: ${projectType}`), new Error(`Unexpected project type: ${projectType}`));
        // let's return classic url in that case
        return `/projects/${projectKey}/settings`;
    }
    if (projectType === (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)) return `/jira/${product}/projects/${projectKey}/ideas/settings`;
    return `/jira/${product}/projects/${projectKey}/settings`;
};
const $8bf9744795c994e7$var$serializeBackLink = (backLink)=>{
    if (backLink == null) return '';
    const { url: url, title: title } = backLink;
    return `#backLinkUrl=${encodeURIComponent(url)}&backLinkTitle=${encodeURIComponent(title)}`;
};
const $8bf9744795c994e7$export$defee92e506aa306 = (projectType, projectKey, issueTypeId, backLink)=>{
    if (projectType === (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)) return `${$8bf9744795c994e7$export$26432406821aa7bf(projectType, projectKey)}`;
    return `${$8bf9744795c994e7$export$26432406821aa7bf(projectType, projectKey)}/issuetypes${issueTypeId ? `/${issueTypeId}` : ''}${$8bf9744795c994e7$var$serializeBackLink(backLink)}`;
};
const $8bf9744795c994e7$export$9133e09a98a043dc = (projectType, projectKey, issueTypeId)=>{
    if (projectType === (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)) return `${$8bf9744795c994e7$export$26432406821aa7bf(projectType, projectKey)}/workflow`;
    return `${$8bf9744795c994e7$export$26432406821aa7bf(projectType, projectKey)}/issuetypes/${issueTypeId}/workflow`;
};
const $8bf9744795c994e7$export$b0d20d18e0230e83 = (projectKey)=>`${$8bf9744795c994e7$export$26432406821aa7bf((0, $7ZZxN.SERVICE_DESK_PROJECT), projectKey)}/automation`;
const $8bf9744795c994e7$export$ff0a17aa36a000df = (projectKey)=>`/jira/software/c/projects/${projectKey}/settings`;
const $8bf9744795c994e7$export$16d52b9357bb73ab = (projectType, projectKey, isSimplified)=>{
    const urlBase = projectType === (0, $7ZZxN.SOFTWARE_PROJECT) && !isSimplified ? $8bf9744795c994e7$export$ff0a17aa36a000df(projectKey) : $8bf9744795c994e7$export$26432406821aa7bf(projectType, projectKey);
    return `${urlBase}/details`;
};
const $8bf9744795c994e7$export$d531a9788343348f = ({ projectKey: projectKey, viewScreenId: viewScreenId, backLink: backLink })=>`/plugins/servlet/project-config/${projectKey}/issuelayout?screenId=${viewScreenId}${$8bf9744795c994e7$var$serializeBackLink(backLink)}`;
const $8bf9744795c994e7$export$dad567762dae162e = ({ projectKey: projectKey, requestTypeId: requestTypeId, backLink: backLink })=>`/jira/servicedesk/projects/${projectKey}/settings/request-types/request-type/${requestTypeId}${$8bf9744795c994e7$var$serializeBackLink(backLink)}`;

});
parcelRegister("6bYiA", function(module, exports) {

$parcel$export(module.exports, "TASK", () => $b6aeae99b4bfc5a4$export$9355e489ad16f98e);
$parcel$export(module.exports, "BUG", () => $b6aeae99b4bfc5a4$export$bcf558c186108044);
$parcel$export(module.exports, "STORY", () => $b6aeae99b4bfc5a4$export$1ea39a3ae330045);
$parcel$export(module.exports, "EPIC", () => $b6aeae99b4bfc5a4$export$3cb4a99a332e4186);
$parcel$export(module.exports, "SUB_TASK", () => $b6aeae99b4bfc5a4$export$a06f889861f6537d);
$parcel$export(module.exports, "CUSTOM", () => $b6aeae99b4bfc5a4$export$952581bc40160893);
$parcel$export(module.exports, "TEMPLATES_WHITELIST", () => $b6aeae99b4bfc5a4$export$dff1da4a9bab6d3e);
$parcel$export(module.exports, "TEXT_AREA_CF_TYPE", () => $b6aeae99b4bfc5a4$export$39cd48613b53ce2f);
$parcel$export(module.exports, "DESCRIPTION_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$56eae1056efd4899);
$parcel$export(module.exports, "ENVIRONMENT_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$ca61f05d869b2ea3);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_NAME", () => $b6aeae99b4bfc5a4$export$2ec42920a0df6b9a);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_ANALYTIC_TYPE", () => $b6aeae99b4bfc5a4$export$40c10ba35ceb5c6b);
$parcel$export(module.exports, "JIRA_SERVICE_MANAGEMENT_APP_NAME", () => $b6aeae99b4bfc5a4$export$a11dccbf88784c62);
$parcel$export(module.exports, "JIRA_PRODUCT_DISCOVERY_APP_NAME", () => $b6aeae99b4bfc5a4$export$f35dc2e6deb1692e);
$parcel$export(module.exports, "JIRA_APP_NAME", () => $b6aeae99b4bfc5a4$export$ec5d0e43836cb3c7);
$parcel$export(module.exports, "toPackageName", () => $b6aeae99b4bfc5a4$export$f31a652635bd75fe);
$parcel$export(module.exports, "PACKAGE_NAME", () => $b6aeae99b4bfc5a4$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "NEW_FIELD_OPTION_PREFIX", () => $b6aeae99b4bfc5a4$export$a2231d79966e0ccc);
$parcel$export(module.exports, "RADIO_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$28a4bdf7d9b6f9);
$parcel$export(module.exports, "USERPICKER_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$9d758b3e8c6e0ed1);
$parcel$export(module.exports, "MULTIUSERPICKER_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$b0e37d421e006913);
$parcel$export(module.exports, "SELECT_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$d77765147749db6b);
$parcel$export(module.exports, "CASCADINGSELECT_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$42ef68d6bd555a8d);
$parcel$export(module.exports, "MULTISELECT_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$4db6eb15b3c529cf);
$parcel$export(module.exports, "CHECKBOX_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$ee975373b7797e8a);
$parcel$export(module.exports, "TEXT_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$aa99342cc6a8ced5);
$parcel$export(module.exports, "NUMBER_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$6f327bf99e20320);
$parcel$export(module.exports, "DATETIME_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$dc64bdfdf9660a05);
$parcel$export(module.exports, "PROJECTPICKER_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$e6d73ed745b9a04);
$parcel$export(module.exports, "DATE_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$d8b50f59220c7580);
$parcel$export(module.exports, "ASSETSPICKER_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$3a6f0a44478f1d2);
$parcel$export(module.exports, "LABELPICKER_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$68b76ef93df5a880);
$parcel$export(module.exports, "GROUPPICKER_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$e7773fccbeec45e6);
$parcel$export(module.exports, "MULTIGROUPPICKER_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$b45487b145c52a37);
$parcel$export(module.exports, "VERSION_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$48548129a6d117f5);
$parcel$export(module.exports, "MULTIVERSION_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$722c271a9e11cb94);
$parcel$export(module.exports, "TEXTAREA_FIELD_TYPE", () => $b6aeae99b4bfc5a4$export$33dbe2a903610aa1);
$parcel$export(module.exports, "emptyTenantContext", () => $b6aeae99b4bfc5a4$export$ac655f5b3ff7b929);
// Issue Type Templates

var $ao0hp = parcelRequire("ao0hp");

var $lO4Or = parcelRequire("lO4Or");

var $6WXNs = parcelRequire("6WXNs");
var $7HKaW = parcelRequire("7HKaW");
var $38OPi = parcelRequire("38OPi");
var $6vrw7 = parcelRequire("6vrw7");
const $b6aeae99b4bfc5a4$export$9355e489ad16f98e = 'task';
const $b6aeae99b4bfc5a4$export$bcf558c186108044 = 'bug';
const $b6aeae99b4bfc5a4$export$1ea39a3ae330045 = 'story';
const $b6aeae99b4bfc5a4$export$3cb4a99a332e4186 = 'epic';
const $b6aeae99b4bfc5a4$export$a06f889861f6537d = 'subtask';
const $b6aeae99b4bfc5a4$export$952581bc40160893 = 'custom';
const $b6aeae99b4bfc5a4$export$dff1da4a9bab6d3e = [
    $b6aeae99b4bfc5a4$export$9355e489ad16f98e,
    $b6aeae99b4bfc5a4$export$bcf558c186108044,
    $b6aeae99b4bfc5a4$export$1ea39a3ae330045,
    $b6aeae99b4bfc5a4$export$3cb4a99a332e4186
];
const $b6aeae99b4bfc5a4$export$39cd48613b53ce2f = (0, $lO4Or.TEXT_AREA_CF_TYPE);
const $b6aeae99b4bfc5a4$export$56eae1056efd4899 = (0, $lO4Or.DESCRIPTION_TYPE);
const $b6aeae99b4bfc5a4$export$ca61f05d869b2ea3 = (0, $lO4Or.ENVIRONMENT_TYPE);
const $b6aeae99b4bfc5a4$export$2ec42920a0df6b9a = 'Story point estimate';
const $b6aeae99b4bfc5a4$export$40c10ba35ceb5c6b = 'storyPointEstimate';
const $b6aeae99b4bfc5a4$export$a4d3702d4c7481d6 = 44;
const $b6aeae99b4bfc5a4$export$8a6a961f6caf7a8b = [
    $b6aeae99b4bfc5a4$export$56eae1056efd4899,
    $b6aeae99b4bfc5a4$export$39cd48613b53ce2f,
    $b6aeae99b4bfc5a4$export$ca61f05d869b2ea3
];
const $b6aeae99b4bfc5a4$export$e27914436cc13e3c = 'Jira Software';
const $b6aeae99b4bfc5a4$export$a11dccbf88784c62 = 'Jira Service Management';
const $b6aeae99b4bfc5a4$export$9f4aa232cbb6be46 = 'Jira Work Management';
const $b6aeae99b4bfc5a4$export$b3c4739240716eb6 = 'Jira Ops';
const $b6aeae99b4bfc5a4$export$f35dc2e6deb1692e = 'Jira Product Discovery';
const $b6aeae99b4bfc5a4$export$ec5d0e43836cb3c7 = 'Jira';
const $b6aeae99b4bfc5a4$export$f31a652635bd75fe = (packageName)=>packageName;
const $b6aeae99b4bfc5a4$export$b8b9d90f9e5bd72b = $b6aeae99b4bfc5a4$export$f31a652635bd75fe('jiraProjectSettingsAppsCommon');
const $b6aeae99b4bfc5a4$export$a2231d79966e0ccc = 'NEW_';
const $b6aeae99b4bfc5a4$export$13dc44d2a9a248a4 = 'swift_openAddIssueTypeModal';
const $b6aeae99b4bfc5a4$export$28a4bdf7d9b6f9 = 'radio';
const $b6aeae99b4bfc5a4$export$9d758b3e8c6e0ed1 = 'userpicker';
const $b6aeae99b4bfc5a4$export$b0e37d421e006913 = 'multiuserpicker';
const $b6aeae99b4bfc5a4$export$d77765147749db6b = 'select';
const $b6aeae99b4bfc5a4$export$42ef68d6bd555a8d = 'cascadingselect';
const $b6aeae99b4bfc5a4$export$4db6eb15b3c529cf = 'multiselect';
const $b6aeae99b4bfc5a4$export$ee975373b7797e8a = 'checkbox';
const $b6aeae99b4bfc5a4$export$aa99342cc6a8ced5 = 'text';
const $b6aeae99b4bfc5a4$export$6f327bf99e20320 = 'number';
const $b6aeae99b4bfc5a4$export$dc64bdfdf9660a05 = 'datetime';
const $b6aeae99b4bfc5a4$export$e6d73ed745b9a04 = 'projectpicker';
const $b6aeae99b4bfc5a4$export$d8b50f59220c7580 = 'date';
const $b6aeae99b4bfc5a4$export$3a6f0a44478f1d2 = 'assetspicker';
const $b6aeae99b4bfc5a4$export$68b76ef93df5a880 = 'labelpicker';
const $b6aeae99b4bfc5a4$export$e7773fccbeec45e6 = 'grouppicker';
const $b6aeae99b4bfc5a4$export$b45487b145c52a37 = 'multigrouppicker';
const $b6aeae99b4bfc5a4$export$48548129a6d117f5 = 'version';
const $b6aeae99b4bfc5a4$export$722c271a9e11cb94 = 'multiversion';
const $b6aeae99b4bfc5a4$export$33dbe2a903610aa1 = 'textarea';
const $b6aeae99b4bfc5a4$export$ac655f5b3ff7b929 = ()=>({
        appEditions: (0, $6WXNs.populateApplicationEditions)(),
        appPermissions: (0, $38OPi.populateApplicationPermissions)(),
        applicationKey: null,
        areProductSuggestionsEnabled: false,
        atlassianAccountId: null,
        baseUrl: (0, $6vrw7.toBaseUrl)(''),
        cloudId: (0, $6vrw7.toCloudId)(''),
        activationId: (0, $6vrw7.toActivationId)(''),
        cloudName: (0, $6vrw7.toCloudName)(''),
        devopsProjectSignupSource: (0, $6vrw7.toDevopsProjectSignupSource)(''),
        environment: null,
        fabricActivityUrl: null,
        fabricNotificationLogUrl: null,
        fabricPfDirUrl: null,
        firstActivationDateMs: null,
        isAdmin: false,
        isAnonymous: false,
        isDevMode: false,
        isDevopsProjectCreationScenario: false,
        isMarketingOptOut: false,
        isSiteAdmin: false,
        languageTag: null,
        licenseStates: (0, $7HKaW.populateApplicationLicenseStates)(),
        licensedProducts: {},
        locale: (0, $ao0hp.defaultLocale),
        loggedInUser: null,
        productCrossSellConfig: 'unknown',
        productEntitlementDetails: null,
        productPermissionGated: {
            core: false,
            software: false,
            serviceDesk: false,
            productDiscovery: false
        },
        siteAdminStatus: 'unknown',
        userFullname: null,
        xsrfToken: null,
        hasDlpEnabled: false
    });

});
parcelRegister("lO4Or", function(module, exports) {

$parcel$export(module.exports, "ISSUE_LINK_SEARCH", () => $4eac1b8021be0c88$export$b144116dae474c88);
$parcel$export(module.exports, "ISSUE_FIELD_NUMBER_CF_TYPE", () => $4eac1b8021be0c88$export$bc917bc699b25f75);
$parcel$export(module.exports, "ISSUE_FIELD_STRING_CF_TYPE", () => $4eac1b8021be0c88$export$5f26ca419fdffbe7);
$parcel$export(module.exports, "ISSUE_FIELD_DATETIME_CF_TYPE", () => $4eac1b8021be0c88$export$ce9bfd823c7e1a6d);
$parcel$export(module.exports, "ISSUE_FIELD_DATE_CF_TYPE", () => $4eac1b8021be0c88$export$346b72b1f7cd6d5a);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_SELECT_CF_TYPE", () => $4eac1b8021be0c88$export$b20fbcacd7942c2a);
$parcel$export(module.exports, "ISSUE_FIELD_ANY_CF_TYPE", () => $4eac1b8021be0c88$export$a2e8554bffc61ece);
$parcel$export(module.exports, "ISSUE_FIELD_MULTI_SELECT_CF_TYPE", () => $4eac1b8021be0c88$export$f25cd4907cbb25b9);
$parcel$export(module.exports, "ISSUE_FIELD_USER_CF_TYPE", () => $4eac1b8021be0c88$export$5600354b43577e17);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_GROUP_CF_TYPE", () => $4eac1b8021be0c88$export$5dbc9917f72d0d2a);
$parcel$export(module.exports, "ISSUE_FIELD_OBJECT_CF_TYPE", () => $4eac1b8021be0c88$export$253649f07fb55948);
$parcel$export(module.exports, "ISSUE_FIELD_GROUPS_CF_TYPE", () => $4eac1b8021be0c88$export$eb39592ba5247ee7);
$parcel$export(module.exports, "ISSUE_FIELD_STRINGS_CF_TYPE", () => $4eac1b8021be0c88$export$f48a9be226105736);
$parcel$export(module.exports, "ISSUE_FIELD_VERSION_CF_TYPE", () => $4eac1b8021be0c88$export$42e2e93fc721df5d);
$parcel$export(module.exports, "APPROVALS_PANEL_TYPE", () => $4eac1b8021be0c88$export$7773375e72c953ed);
$parcel$export(module.exports, "ISSUE_FIELD_PROJECT_CF_TYPE", () => $4eac1b8021be0c88$export$80ad0037098f3919);
$parcel$export(module.exports, "AFFECTED_SERVICES_GQL_FIELD", () => $4eac1b8021be0c88$export$6875c7efa3a5e380);
$parcel$export(module.exports, "ASSIGNEE_GQL_FIELD", () => $4eac1b8021be0c88$export$7c1a5c7d37b8f968);
$parcel$export(module.exports, "ATLASSIAN_TEAM_GQL_FIELD", () => $4eac1b8021be0c88$export$c5931a5d7dbfb40b);
$parcel$export(module.exports, "BOOLEAN_GQL_FIELD", () => $4eac1b8021be0c88$export$c979d9c548c05133);
$parcel$export(module.exports, "CASCADING_SELECT_GQL_FIELD", () => $4eac1b8021be0c88$export$ff25e7412c4ae9c7);
$parcel$export(module.exports, "CHECKBOX_GQL_FIELD", () => $4eac1b8021be0c88$export$16dbdf57e34e8d63);
$parcel$export(module.exports, "CHILDREN_EXCEEDING_LIMIT_GQL_FIELD", () => $4eac1b8021be0c88$export$1bf8bec92e6e84df);
$parcel$export(module.exports, "CHILDREN_WITHIN_LIMIT_GQL_FIELD", () => $4eac1b8021be0c88$export$c32f5d822fe5ea95);
$parcel$export(module.exports, "CMDB_GQL_FIELD", () => $4eac1b8021be0c88$export$b0deb225eed90fbd);
$parcel$export(module.exports, "COLOR_GQL_FIELD", () => $4eac1b8021be0c88$export$add3775cfea8fde3);
$parcel$export(module.exports, "COMPONENTS_GQL_FIELD", () => $4eac1b8021be0c88$export$9631d4098abab3eb);
$parcel$export(module.exports, "CONNECT_DATE_TIME_GQL_FIELD", () => $4eac1b8021be0c88$export$ee42bc16c09ee564);
$parcel$export(module.exports, "CONNECT_NUMBER_GQL_FIELD", () => $4eac1b8021be0c88$export$fbcebbdce821f712);
$parcel$export(module.exports, "CONNECT_MULTI_SELECT_GQL_FIELD", () => $4eac1b8021be0c88$export$41dd2eb1f33d3042);
$parcel$export(module.exports, "CONNECT_RICH_TEXT_GQL_FIELD", () => $4eac1b8021be0c88$export$f4e3e72a3be84e5b);
$parcel$export(module.exports, "CONNECT_SINGLE_SELECT_GQL_FIELD", () => $4eac1b8021be0c88$export$d6738c8a6d1a735d);
$parcel$export(module.exports, "CONNECT_TEXT_GQL_FIELD", () => $4eac1b8021be0c88$export$79a75502a3f0c4c4);
$parcel$export(module.exports, "DATE_PICKER_GQL_FIELD", () => $4eac1b8021be0c88$export$ed2eabcf0931df31);
$parcel$export(module.exports, "DATE_TIME_GQL_FIELD", () => $4eac1b8021be0c88$export$1f17904e959f2f0b);
$parcel$export(module.exports, "EPIC_LINK_GQL_FIELD", () => $4eac1b8021be0c88$export$6d8da4497234455);
$parcel$export(module.exports, "FLAG_GQL_FIELD", () => $4eac1b8021be0c88$export$9bcfac568e4fa59c);
$parcel$export(module.exports, "ISSUE_RESTRICTION_GQL_FIELD", () => $4eac1b8021be0c88$export$dd84cd6c957c6f5e);
$parcel$export(module.exports, "ISSUE_TYPE_GQL_FIELD", () => $4eac1b8021be0c88$export$5cc7c39d7d1cf6d5);
$parcel$export(module.exports, "LABEL_GQL_FIELD", () => $4eac1b8021be0c88$export$810709f0c5c2e9db);
$parcel$export(module.exports, "MULTI_SELECT_GQL_FIELD", () => $4eac1b8021be0c88$export$82cb6735134c23a2);
$parcel$export(module.exports, "MULTI_USER_PICKER_GQL_FIELD", () => $4eac1b8021be0c88$export$85e04e9a3a81ee1);
$parcel$export(module.exports, "MULTI_VERSION_GQL_FIELD", () => $4eac1b8021be0c88$export$24c916a8a33ed20c);
$parcel$export(module.exports, "MULTI_GROUP_PICKER_GQL_FIELD", () => $4eac1b8021be0c88$export$c049920d930c3b8a);
$parcel$export(module.exports, "NUMBER_GQL_FIELD", () => $4eac1b8021be0c88$export$3b6d7fc1833bf7da);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE_GQL_FIELD", () => $4eac1b8021be0c88$export$bd3e2fe853319c13);
$parcel$export(module.exports, "PARENT_GQL_FIELD", () => $4eac1b8021be0c88$export$6dfd3fc78bc751a0);
$parcel$export(module.exports, "PEOPLE_GQL_FIELD", () => $4eac1b8021be0c88$export$31aea7548807c6b5);
$parcel$export(module.exports, "PRIORITY_GQL_FIELD", () => $4eac1b8021be0c88$export$e89fbbf3983c0219);
$parcel$export(module.exports, "PROFORMA_FORMS_GQL_FIELD", () => $4eac1b8021be0c88$export$f5e2fb1022ff7912);
$parcel$export(module.exports, "PROJECT_GQL_FIELD", () => $4eac1b8021be0c88$export$12f54499c6252188);
$parcel$export(module.exports, "RADIO_GQL_FIELD", () => $4eac1b8021be0c88$export$8e4293d806f435e0);
$parcel$export(module.exports, "REPORTER_GQL_FIELD", () => $4eac1b8021be0c88$export$c69486dd643dfb69);
$parcel$export(module.exports, "RESOLUTION_GQL_FIELD", () => $4eac1b8021be0c88$export$1e4faa0d6dc58a81);
$parcel$export(module.exports, "RICH_TEXT_GQL_FIELD", () => $4eac1b8021be0c88$export$37f4daaa7b409554);
$parcel$export(module.exports, "SECURITY_GQL_FIELD", () => $4eac1b8021be0c88$export$ca57cccd6d7bf97c);
$parcel$export(module.exports, "SINGLE_GROUP_PICKER_GQL_FIELD", () => $4eac1b8021be0c88$export$bea889616fd5bdab);
$parcel$export(module.exports, "SINGLE_SELECT_GQL_FIELD", () => $4eac1b8021be0c88$export$ab5cecc580898d1c);
$parcel$export(module.exports, "SPRINT_GQL_FIELD", () => $4eac1b8021be0c88$export$bb63813d13e8eaf7);
$parcel$export(module.exports, "STATUS_GQL_FIELD", () => $4eac1b8021be0c88$export$e40f819979b3881d);
$parcel$export(module.exports, "TEAM_GQL_FIELD", () => $4eac1b8021be0c88$export$6c243704a22baffe);
$parcel$export(module.exports, "TEAM_VIEW_GQL_FIELD", () => $4eac1b8021be0c88$export$6c32429bac235203);
$parcel$export(module.exports, "TEXT_GQL_FIELD", () => $4eac1b8021be0c88$export$61b514b470cbbf07);
$parcel$export(module.exports, "TIME_TRACKING_GQL_FIELD", () => $4eac1b8021be0c88$export$e4bcb1729da5683);
$parcel$export(module.exports, "URL_GQL_FIELD", () => $4eac1b8021be0c88$export$37ccd11f08a93ccb);
$parcel$export(module.exports, "USER_PICKER_GQL_FIELD", () => $4eac1b8021be0c88$export$abf1bf8c1106ba7d);
$parcel$export(module.exports, "VERSION_GQL_FIELD", () => $4eac1b8021be0c88$export$b55604041ae7179e);
$parcel$export(module.exports, "VOTES_GQL_FIELD", () => $4eac1b8021be0c88$export$c8bf66d62e74cdd2);
$parcel$export(module.exports, "WATCHES_GQL_FIELD", () => $4eac1b8021be0c88$export$aa815aaa741ae18);
$parcel$export(module.exports, "JSM_ASSETS_GQL_FIELD", () => $4eac1b8021be0c88$export$e805f89b15d2abf4);
$parcel$export(module.exports, "JSM_PEOPLE_GQL_FIELD", () => $4eac1b8021be0c88$export$5bfd36acd96f04c2);
$parcel$export(module.exports, "JSM_ORGANIZATION_GQL_FIELD", () => $4eac1b8021be0c88$export$695423a2bc8a9ac4);
$parcel$export(module.exports, "FORGE_STRING_GQL_FIELD", () => $4eac1b8021be0c88$export$d29b0ba0d80bc129);
$parcel$export(module.exports, "FORGE_STRINGS_GQL_FIELD", () => $4eac1b8021be0c88$export$ac6c7b30703608d6);
$parcel$export(module.exports, "FORGE_NUMBER_GQL_FIELD", () => $4eac1b8021be0c88$export$478b546dccd33e1e);
$parcel$export(module.exports, "FORGE_DATETIME_GQL_FIELD", () => $4eac1b8021be0c88$export$f90c042e9eb983e7);
$parcel$export(module.exports, "FORGE_DATE_GQL_FIELD", () => $4eac1b8021be0c88$export$753ca4fb34ff3f2b);
$parcel$export(module.exports, "FORGE_OBJECT_GQL_FIELD", () => $4eac1b8021be0c88$export$b7aed9efb4a9154b);
$parcel$export(module.exports, "FORGE_GROUP_GQL_FIELD", () => $4eac1b8021be0c88$export$1763713d718f7ef0);
$parcel$export(module.exports, "FORGE_USER_GQL_FIELD", () => $4eac1b8021be0c88$export$ebb0caa2a98dcf9e);
$parcel$export(module.exports, "FORGE_GROUPS_GQL_FIELD", () => $4eac1b8021be0c88$export$671131ba12d94144);
$parcel$export(module.exports, "FORGE_USERS_GQL_FIELD", () => $4eac1b8021be0c88$export$c48132adab502d6b);
$parcel$export(module.exports, "JSM_APPROVAL_GQL_FIELD", () => $4eac1b8021be0c88$export$6cd83226f31c7072);
$parcel$export(module.exports, "JSM_USER_APPROVER_PRINCIPAL_FIELD", () => $4eac1b8021be0c88$export$7de726bd6d97a9a7);
$parcel$export(module.exports, "JSM_GROUP_APPROVER_PRINCIPAL_FIELD", () => $4eac1b8021be0c88$export$8e4b538f77340a05);
$parcel$export(module.exports, "JSM_REQUEST_FEEDBACK_GQL_FIELD", () => $4eac1b8021be0c88$export$10ba8c0d74470907);
$parcel$export(module.exports, "JSM_REQUEST_LANGUAGE_GQL_FIELD", () => $4eac1b8021be0c88$export$1756bb4eff1cc3c6);
$parcel$export(module.exports, "JSM_REQUEST_TYPE_GQL_FIELD", () => $4eac1b8021be0c88$export$5876b4be3c4407b);
$parcel$export(module.exports, "JSM_RESPONDERS_GQL_FIELD", () => $4eac1b8021be0c88$export$e7fe49e6f36c7154);
$parcel$export(module.exports, "JSM_USER_RESPONDER_GQL_FIELD", () => $4eac1b8021be0c88$export$aeed3395a6bca18b);
$parcel$export(module.exports, "JSM_ENTITLEMENTS_GQL_FIELD", () => $4eac1b8021be0c88$export$9b725a1eafd02e4f);
$parcel$export(module.exports, "JSM_TEAM_RESPONDER_FIELD", () => $4eac1b8021be0c88$export$f658d5c0f0b5dbc2);
$parcel$export(module.exports, "JSM_MAJOR_INCIDENT_FIELD", () => $4eac1b8021be0c88$export$e469bcb2060000af);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", () => $4eac1b8021be0c88$export$f10e53e8928b61bd);
$parcel$export(module.exports, "GOALS_GQL_FIELD", () => $4eac1b8021be0c88$export$bfcb1a91094f113a);
$parcel$export(module.exports, "DURATION_GQL_FIELD", () => $4eac1b8021be0c88$export$db0bd6c04eb7d04a);
$parcel$export(module.exports, "FORGE_CUSTOM_FIELD_TYPE", () => $4eac1b8021be0c88$export$798d2f5814884447);
$parcel$export(module.exports, "TEAMS_PLATFORM_CF_TYPE", () => $4eac1b8021be0c88$export$269d70c1b1c9fb80);
$parcel$export(module.exports, "APPROVALS_CF_TYPE", () => $4eac1b8021be0c88$export$f0f17ef462331df4);
$parcel$export(module.exports, "CATEGORY_TYPE", () => $4eac1b8021be0c88$export$3c7d8923295a5199);
$parcel$export(module.exports, "PEOPLE_CF_TYPE", () => $4eac1b8021be0c88$export$fb431e758c9252df);
$parcel$export(module.exports, "NUMBER_CF_TYPE", () => $4eac1b8021be0c88$export$c7faa96db185cfc6);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_TYPE", () => $4eac1b8021be0c88$export$492b0fa4fe201a22);
$parcel$export(module.exports, "URL_CF_TYPE", () => $4eac1b8021be0c88$export$60f0bd6e4b582fe6);
$parcel$export(module.exports, "TEXT_CF_TYPE", () => $4eac1b8021be0c88$export$68c7e01d5460d298);
$parcel$export(module.exports, "TEXT_AREA_CF_TYPE", () => $4eac1b8021be0c88$export$39cd48613b53ce2f);
$parcel$export(module.exports, "TEXT_READONLY_CF_TYPE", () => $4eac1b8021be0c88$export$977db5973ce73e44);
$parcel$export(module.exports, "LABELS_CF_TYPE", () => $4eac1b8021be0c88$export$ad4eb83f78528e13);
$parcel$export(module.exports, "DATE_CF_TYPE", () => $4eac1b8021be0c88$export$ff745f432984005d);
$parcel$export(module.exports, "DATETIME_CF_TYPE", () => $4eac1b8021be0c88$export$42d097f7b1622ef1);
$parcel$export(module.exports, "RADIO_BUTTONS_CF_TYPE", () => $4eac1b8021be0c88$export$65524be5675e57e6);
$parcel$export(module.exports, "MULTI_CHECKBOXES_CF_TYPE", () => $4eac1b8021be0c88$export$5280e5501a801dc0);
$parcel$export(module.exports, "MULTI_SELECT_CF_TYPE", () => $4eac1b8021be0c88$export$c5d13ea26562d57a);
$parcel$export(module.exports, "SELECT_CF_TYPE", () => $4eac1b8021be0c88$export$22ac48a51c014e4b);
$parcel$export(module.exports, "EPIC_STATUS_TYPE", () => $4eac1b8021be0c88$export$6769c2c97b828e11);
$parcel$export(module.exports, "MULTI_VERSION_CF_TYPE", () => $4eac1b8021be0c88$export$39866626496bbfc8);
$parcel$export(module.exports, "VERSION_CF_TYPE", () => $4eac1b8021be0c88$export$24382b4e8c58336b);
$parcel$export(module.exports, "GROUP_CF_TYPE", () => $4eac1b8021be0c88$export$b075907882e80160);
$parcel$export(module.exports, "MULTI_GROUP_CF_TYPE", () => $4eac1b8021be0c88$export$b600addfa3355c57);
$parcel$export(module.exports, "USER_CF_TYPE", () => $4eac1b8021be0c88$export$c491a4b98394028e);
$parcel$export(module.exports, "MULTI_USER_CF_TYPE", () => $4eac1b8021be0c88$export$5365f2d3fac5261a);
$parcel$export(module.exports, "PARTICIPANTS_CF_TYPE", () => $4eac1b8021be0c88$export$cc8ffff49170b0f4);
$parcel$export(module.exports, "FLAGGED_CF_TYPE", () => $4eac1b8021be0c88$export$b7178f601d7373f9);
$parcel$export(module.exports, "TEAM_CF_TYPE", () => $4eac1b8021be0c88$export$eb1f1dca13a0f02d);
$parcel$export(module.exports, "PARENT_CF_TYPE", () => $4eac1b8021be0c88$export$3e71e11f80203acb);
$parcel$export(module.exports, "BASELINE_START_CF_TYPE", () => $4eac1b8021be0c88$export$d10d66823a65e688);
$parcel$export(module.exports, "BASELINE_END_CF_TYPE", () => $4eac1b8021be0c88$export$dfc6da4a9963d5dc);
$parcel$export(module.exports, "COLOR_CF_TYPE", () => $4eac1b8021be0c88$export$b4a1fbc1cf0059cf);
$parcel$export(module.exports, "EPIC_COLOR_TYPE", () => $4eac1b8021be0c88$export$4838a8a8d62a64fd);
$parcel$export(module.exports, "ASSETS_CF_TYPE", () => $4eac1b8021be0c88$export$ed2de20ab8b7ad3d);
$parcel$export(module.exports, "SERVICE_ENTITY_CF_TYPE", () => $4eac1b8021be0c88$export$b755e97dbfa92610);
$parcel$export(module.exports, "REQUEST_PARTICIPANTS_CF_TYPE", () => $4eac1b8021be0c88$export$1be1ecd4dfc06fab);
$parcel$export(module.exports, "ORGANIZATIONS_CF_TYPE", () => $4eac1b8021be0c88$export$34317c2d84a93553);
$parcel$export(module.exports, "REQUEST_LANGUAGE_CF_TYPE", () => $4eac1b8021be0c88$export$555b4f35f98a3210);
$parcel$export(module.exports, "REQUEST_FEEDBACK_CF_TYPE", () => $4eac1b8021be0c88$export$1f2859a3ef701a14);
$parcel$export(module.exports, "REQUEST_FEEDBACK_DATE_CF_TYPE", () => $4eac1b8021be0c88$export$68f62eb762e4157f);
$parcel$export(module.exports, "REQUEST_TYPE_CF_TYPE", () => $4eac1b8021be0c88$export$6da975fce1fbd38e);
$parcel$export(module.exports, "APPROVERS_LIST_CF_TYPE", () => $4eac1b8021be0c88$export$c6dd874aae21e51f);
$parcel$export(module.exports, "CASCADING_SELECT_CF_TYPE", () => $4eac1b8021be0c88$export$c3c9f8a8a8dc0b30);
$parcel$export(module.exports, "RANK_CF_TYPE", () => $4eac1b8021be0c88$export$af89c0396aaf23e3);
$parcel$export(module.exports, "CMDB_OBJECT_CF_TYPE", () => $4eac1b8021be0c88$export$3b5a62bb34372404);
$parcel$export(module.exports, "READ_ONLY_CF_TYPE", () => $4eac1b8021be0c88$export$247829aef464243f);
$parcel$export(module.exports, "PROJECT_PICKER_CF_TYPE", () => $4eac1b8021be0c88$export$65a6076c0927d413);
$parcel$export(module.exports, "RESPONDERS_CF_TYPE", () => $4eac1b8021be0c88$export$bcf83e1d934501c9);
$parcel$export(module.exports, "MAJOR_INCIDENT_CF_TYPE", () => $4eac1b8021be0c88$export$ae0eeec12e90a01e);
$parcel$export(module.exports, "ENTITLEMENT_CF_TYPE", () => $4eac1b8021be0c88$export$c23f6b40da18371a);
$parcel$export(module.exports, "SENTIMENT_CF_TYPE", () => $4eac1b8021be0c88$export$c23cfbdf83daa90d);
$parcel$export(module.exports, "MESSAGE_VIEW_CF_TYPE", () => $4eac1b8021be0c88$export$21dda64db57e4883);
$parcel$export(module.exports, "MESSAGE_EDIT_CF_TYPE", () => $4eac1b8021be0c88$export$45700f3bf92a003a);
$parcel$export(module.exports, "LAST_UPDATER_OR_COMMENTER_CF_TYPE", () => $4eac1b8021be0c88$export$2d75b47d12efc812);
$parcel$export(module.exports, "USER_PROPERTY_CF_TYPE", () => $4eac1b8021be0c88$export$7b79405842547ccb);
$parcel$export(module.exports, "FIRST_RESPONSE_DATE_CF_TYPE", () => $4eac1b8021be0c88$export$fc276d6ccf118a14);
$parcel$export(module.exports, "DEV_SUMMARY_CF_TYPE", () => $4eac1b8021be0c88$export$8b0718167d092603);
$parcel$export(module.exports, "CHILDREN_ISSUES_CF_TYPE", () => $4eac1b8021be0c88$export$904b40dd2afd17a2);
$parcel$export(module.exports, "GOALS_CF_TYPE", () => $4eac1b8021be0c88$export$2bbb7f69c97ea279);
$parcel$export(module.exports, "ASSIGNEE_TYPE", () => $4eac1b8021be0c88$export$fba8634fd401ba8b);
$parcel$export(module.exports, "REPORTER_TYPE", () => $4eac1b8021be0c88$export$a91aea2438afcce8);
$parcel$export(module.exports, "DUE_DATE_TYPE", () => $4eac1b8021be0c88$export$b159f8b8f27aae4c);
$parcel$export(module.exports, "PRIORITY_TYPE", () => $4eac1b8021be0c88$export$34740f8d07d23ac0);
$parcel$export(module.exports, "LABELS_TYPE", () => $4eac1b8021be0c88$export$43b6e33ec70f2272);
$parcel$export(module.exports, "CREATED", () => $4eac1b8021be0c88$export$ff39ebd4bb12b718);
$parcel$export(module.exports, "UPDATED", () => $4eac1b8021be0c88$export$cd8e68094cb5c3cb);
$parcel$export(module.exports, "RESOLUTION_DATE", () => $4eac1b8021be0c88$export$6a052efb0b4ec5d2);
$parcel$export(module.exports, "COMPONENTS_TYPE", () => $4eac1b8021be0c88$export$37abf56f13f61ec5);
$parcel$export(module.exports, "SERVICEDESK_APPROVAL_TYPE", () => $4eac1b8021be0c88$export$aef0c22aecd16996);
$parcel$export(module.exports, "SERVICEDESK_PRACTICES_TYPE", () => $4eac1b8021be0c88$export$cff5b6d1e7135679);
$parcel$export(module.exports, "SERVICEDESK_INCIDENT_MANAGEMENT_TYPE", () => $4eac1b8021be0c88$export$791007408faf42f4);
$parcel$export(module.exports, "DEV_SUMMARY_TYPE", () => $4eac1b8021be0c88$export$827a1c600bac12a3);
$parcel$export(module.exports, "RELEASES_TYPE", () => $4eac1b8021be0c88$export$e9ba671d077969f8);
$parcel$export(module.exports, "SPRINT_TYPE", () => $4eac1b8021be0c88$export$3d37701ba6fb68ec);
$parcel$export(module.exports, "STORY_POINTS_TYPE", () => $4eac1b8021be0c88$export$36fd22f47020f37b);
$parcel$export(module.exports, "EPIC_TYPE", () => $4eac1b8021be0c88$export$9f2fedcd916d2a79);
$parcel$export(module.exports, "EPIC_NAME_TYPE", () => $4eac1b8021be0c88$export$dfc63737b8c0150d);
$parcel$export(module.exports, "FIX_VERSIONS_TYPE", () => $4eac1b8021be0c88$export$a5c9f63aadcb220);
$parcel$export(module.exports, "AFFECTS_VERSIONS_TYPE", () => $4eac1b8021be0c88$export$94009605902e4fe5);
$parcel$export(module.exports, "DESCRIPTION_TYPE", () => $4eac1b8021be0c88$export$5e7324042f1d6b31);
$parcel$export(module.exports, "ENVIRONMENT_TYPE", () => $4eac1b8021be0c88$export$113281d03e6830ef);
$parcel$export(module.exports, "WATCHES_TYPE", () => $4eac1b8021be0c88$export$5ff798870a3dffbf);
$parcel$export(module.exports, "SUMMARY_TYPE", () => $4eac1b8021be0c88$export$907219511d14ba3d);
$parcel$export(module.exports, "PROFORMA_FORMS", () => $4eac1b8021be0c88$export$d09aa6a4f3538063);
$parcel$export(module.exports, "RESOLUTION_TYPE", () => $4eac1b8021be0c88$export$3aca8c91b58a42e2);
$parcel$export(module.exports, "TIME_TRACKING_TYPE", () => $4eac1b8021be0c88$export$ccb5ffefbf8b987c);
$parcel$export(module.exports, "TIME_ESTIMATE_TYPE", () => $4eac1b8021be0c88$export$c8bedad98a5e7f5f);
$parcel$export(module.exports, "STATUS_TYPE", () => $4eac1b8021be0c88$export$358267065be1e);
$parcel$export(module.exports, "STATUS_CATEGORY_TYPE", () => $4eac1b8021be0c88$export$dcaa788c7ada56de);
$parcel$export(module.exports, "ISSUE_TYPE", () => $4eac1b8021be0c88$export$ebb48b08205007c5);
$parcel$export(module.exports, "ISSUE_KEY_TYPE", () => $4eac1b8021be0c88$export$5e91047fe9955d0e);
$parcel$export(module.exports, "CHILDREN_ISSUES", () => $4eac1b8021be0c88$export$3b3d0889022c85b3);
$parcel$export(module.exports, "HIERARCHY_LEVEL_BELOW", () => $4eac1b8021be0c88$export$335851d83a79891);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_BELOW", () => $4eac1b8021be0c88$export$7b76bbcb87d41695);
$parcel$export(module.exports, "HIERARCHY_LEVEL_ABOVE", () => $4eac1b8021be0c88$export$297b67ac63f09f72);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_ABOVE", () => $4eac1b8021be0c88$export$ae87161126086be);
$parcel$export(module.exports, "HIERARCHY_LEVEL_SAME_LEVEL", () => $4eac1b8021be0c88$export$6a88420fc2f6901d);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_SAME_LEVEL", () => $4eac1b8021be0c88$export$ef1a0421bd42c0e4);
$parcel$export(module.exports, "CUSTOMER_CONTEXT_TYPE", () => $4eac1b8021be0c88$export$dd695c8c5ab62f9d);
$parcel$export(module.exports, "SLA_PANEL_TYPE", () => $4eac1b8021be0c88$export$7b3d247435a784fa);
$parcel$export(module.exports, "LINKED_ALERTS_TYPE", () => $4eac1b8021be0c88$export$17b7080ed1fe8cfd);
$parcel$export(module.exports, "CHAT_CHANNEL_TYPE", () => $4eac1b8021be0c88$export$29fe745131dad7ba);
$parcel$export(module.exports, "MSTEAMS_CHANNEL_TYPE", () => $4eac1b8021be0c88$export$9c245100c3091ec3);
$parcel$export(module.exports, "ZOOM_MEETING_TYPE", () => $4eac1b8021be0c88$export$51eb15cea47a37ba);
$parcel$export(module.exports, "MANAGE_STAKEHOLDERS_TYPE", () => $4eac1b8021be0c88$export$c7ae0622b0bd5d56);
$parcel$export(module.exports, "CONFERENCE_CALL_TYPE", () => $4eac1b8021be0c88$export$f7dcde9e9e88aff2);
$parcel$export(module.exports, "KNOWLEDGE_BASE_TYPE", () => $4eac1b8021be0c88$export$b5358afda8ff335e);
$parcel$export(module.exports, "ASSET_ONBOARDING_TYPE", () => $4eac1b8021be0c88$export$63cf6f392da16c25);
$parcel$export(module.exports, "SIMILAR_ISSUES_TYPE", () => $4eac1b8021be0c88$export$22f61ccc2730431f);
$parcel$export(module.exports, "SUBTASKS_TYPE", () => $4eac1b8021be0c88$export$8bbb446f57294715);
$parcel$export(module.exports, "VOTES_TYPE", () => $4eac1b8021be0c88$export$34fcd7cb291a1e4d);
$parcel$export(module.exports, "PARENT_TYPE", () => $4eac1b8021be0c88$export$5e93f2a57cc4ca3a);
$parcel$export(module.exports, "PROJECT_TYPE", () => $4eac1b8021be0c88$export$91a9dba2d38d9a6f);
$parcel$export(module.exports, "TIME_SPENT_TYPE", () => $4eac1b8021be0c88$export$ede0a4c20124ec85);
$parcel$export(module.exports, "DATA_CLASSIFICATION_TYPE", () => $4eac1b8021be0c88$export$3eeb79d48fb5f667);
$parcel$export(module.exports, "SENTIMENT_TYPE", () => $4eac1b8021be0c88$export$45e72c9a63ab61ab);
$parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", () => $4eac1b8021be0c88$export$99ad62164189f781);
$parcel$export(module.exports, "FORGE_GLANCE_TYPE", () => $4eac1b8021be0c88$export$7719ef6e9283671);
$parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", () => $4eac1b8021be0c88$export$bfebea5ce2e1887a);
$parcel$export(module.exports, "ISSUE_RESTRICTION_TYPE", () => $4eac1b8021be0c88$export$84e5674890d55030);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE", () => $4eac1b8021be0c88$export$326a5522a485e43d);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE_OVERRIDE", () => $4eac1b8021be0c88$export$c9f3f01e2c535302);
$parcel$export(module.exports, "TEAM_TYPE", () => $4eac1b8021be0c88$export$66519f3bbff1796a);
$parcel$export(module.exports, "ESTIMATE_TYPE", () => $4eac1b8021be0c88$export$a4ee0bca77cc8463);
$parcel$export(module.exports, "DUE_DATE_PORTFOLIO_TYPE", () => $4eac1b8021be0c88$export$fed53408e89e0497);
$parcel$export(module.exports, "TARGET_START_TYPE", () => $4eac1b8021be0c88$export$d53c26f9ce31f56b);
$parcel$export(module.exports, "TARGET_END_TYPE", () => $4eac1b8021be0c88$export$48f82d653f85e459);
$parcel$export(module.exports, "START_DATE_TYPE", () => $4eac1b8021be0c88$export$ea5a888f39f722c7);
$parcel$export(module.exports, "COLOR_TYPE", () => $4eac1b8021be0c88$export$f245bbec12cc0e40);
$parcel$export(module.exports, "ATTACHMENT_TYPE", () => $4eac1b8021be0c88$export$aed630b4b7114a59);
$parcel$export(module.exports, "ISSUE_LINKS_TYPE", () => $4eac1b8021be0c88$export$b50c1a8fef07104);
$parcel$export(module.exports, "TIME_ESTIMATE_CONFIG_TYPE", () => $4eac1b8021be0c88$export$ea3d72f4bb7738ba);
$parcel$export(module.exports, "COMMENT_TYPE", () => $4eac1b8021be0c88$export$a4cab0124760d860);
$parcel$export(module.exports, "WORK_LOG_TYPE", () => $4eac1b8021be0c88$export$734929aef118d7e2);
$parcel$export(module.exports, "PARENT_FIELD_TYPE", () => $4eac1b8021be0c88$export$ffbacacb07c1d46d);
$parcel$export(module.exports, "getLayoutFieldTypes", () => $4eac1b8021be0c88$export$3c3e26aadbfa2c32);

var $5iWql = parcelRequire("5iWql");

var $1ybV0 = parcelRequire("1ybV0");
const $4eac1b8021be0c88$export$b144116dae474c88 = 'issue-link-search';
const $4eac1b8021be0c88$export$bc917bc699b25f75 = 'number';
const $4eac1b8021be0c88$export$5f26ca419fdffbe7 = 'string';
const $4eac1b8021be0c88$export$ce9bfd823c7e1a6d = 'datetime';
const $4eac1b8021be0c88$export$346b72b1f7cd6d5a = 'date';
const $4eac1b8021be0c88$export$b20fbcacd7942c2a = 'option2';
const $4eac1b8021be0c88$export$20737ab0ca5fa93f = 'option'; // graphql currently returns this type
const $4eac1b8021be0c88$export$a2e8554bffc61ece = 'any';
const $4eac1b8021be0c88$export$f25cd4907cbb25b9 = 'array';
const $4eac1b8021be0c88$export$5600354b43577e17 = 'user';
const $4eac1b8021be0c88$export$5dbc9917f72d0d2a = 'group';
const $4eac1b8021be0c88$export$253649f07fb55948 = 'object';
const $4eac1b8021be0c88$export$eb39592ba5247ee7 = 'group-list';
const $4eac1b8021be0c88$export$f48a9be226105736 = 'array-string';
const $4eac1b8021be0c88$export$42e2e93fc721df5d = 'version';
const $4eac1b8021be0c88$export$a603eef6fee2a5f0 = 'parent-issues'; // Remove on FD-30157 clean-up
const $4eac1b8021be0c88$export$7773375e72c953ed = 'approval-panel';
const $4eac1b8021be0c88$export$80ad0037098f3919 = 'project';
const $4eac1b8021be0c88$export$6875c7efa3a5e380 = 'JiraAffectedServicesField';
const $4eac1b8021be0c88$export$7c1a5c7d37b8f968 = 'JiraAssigneeField';
const $4eac1b8021be0c88$export$d74e2f14098ef8f6 = 'JiraAttachmentsField';
const $4eac1b8021be0c88$export$c5931a5d7dbfb40b = 'JiraAtlassianTeamField';
const $4eac1b8021be0c88$export$c979d9c548c05133 = 'JiraBooleanField';
const $4eac1b8021be0c88$export$ff25e7412c4ae9c7 = 'JiraCascadingSelectField';
const $4eac1b8021be0c88$export$16dbdf57e34e8d63 = 'JiraCheckboxesField';
const $4eac1b8021be0c88$export$1bf8bec92e6e84df = 'JiraChildIssuesExceedingLimit';
const $4eac1b8021be0c88$export$c32f5d822fe5ea95 = 'JiraChildIssuesWithinLimit';
const $4eac1b8021be0c88$export$b0deb225eed90fbd = 'JiraCMDBField';
const $4eac1b8021be0c88$export$add3775cfea8fde3 = 'JiraColorField';
const $4eac1b8021be0c88$export$9631d4098abab3eb = 'JiraComponentsField';
const $4eac1b8021be0c88$export$ee42bc16c09ee564 = 'JiraConnectDateTimeField';
const $4eac1b8021be0c88$export$fbcebbdce821f712 = 'JiraConnectNumberField';
const $4eac1b8021be0c88$export$41dd2eb1f33d3042 = 'JiraConnectMultipleSelectField';
const $4eac1b8021be0c88$export$f4e3e72a3be84e5b = 'JiraConnectRichTextField';
const $4eac1b8021be0c88$export$d6738c8a6d1a735d = 'JiraConnectSingleSelectField';
const $4eac1b8021be0c88$export$79a75502a3f0c4c4 = 'JiraConnectTextField';
const $4eac1b8021be0c88$export$ed2eabcf0931df31 = 'JiraDatePickerField';
const $4eac1b8021be0c88$export$1f17904e959f2f0b = 'JiraDateTimePickerField';
const $4eac1b8021be0c88$export$6d8da4497234455 = 'JiraEpicLinkField';
const $4eac1b8021be0c88$export$9bcfac568e4fa59c = 'JiraFlagField';
const $4eac1b8021be0c88$export$ff2e58d499eebe1d = 'JiraIssueLinkField';
const $4eac1b8021be0c88$export$dd84cd6c957c6f5e = 'JiraIssueRestrictionField';
const $4eac1b8021be0c88$export$5cc7c39d7d1cf6d5 = 'JiraIssueTypeField';
const $4eac1b8021be0c88$export$810709f0c5c2e9db = 'JiraLabelsField';
const $4eac1b8021be0c88$export$82cb6735134c23a2 = 'JiraMultipleSelectField';
const $4eac1b8021be0c88$export$85e04e9a3a81ee1 = 'JiraMultipleSelectUserPickerField';
const $4eac1b8021be0c88$export$24c916a8a33ed20c = 'JiraMultipleVersionPickerField';
const $4eac1b8021be0c88$export$c049920d930c3b8a = 'JiraMultipleGroupPickerField';
const $4eac1b8021be0c88$export$3b6d7fc1833bf7da = 'JiraNumberField';
const $4eac1b8021be0c88$export$bd3e2fe853319c13 = 'JiraOriginalTimeEstimateField';
const $4eac1b8021be0c88$export$6dfd3fc78bc751a0 = 'JiraParentIssueField';
const $4eac1b8021be0c88$export$31aea7548807c6b5 = 'JiraPeopleField';
const $4eac1b8021be0c88$export$e89fbbf3983c0219 = 'JiraPriorityField';
const $4eac1b8021be0c88$export$f5e2fb1022ff7912 = 'JiraProformaFormsField';
const $4eac1b8021be0c88$export$12f54499c6252188 = 'JiraProjectField';
const $4eac1b8021be0c88$export$8e4293d806f435e0 = 'JiraRadioSelectField';
const $4eac1b8021be0c88$export$c69486dd643dfb69 = 'JiraReporterField';
const $4eac1b8021be0c88$export$1e18a858257aca2f = 'JiraRequestTypeField';
const $4eac1b8021be0c88$export$1e4faa0d6dc58a81 = 'JiraResolutionField';
const $4eac1b8021be0c88$export$37f4daaa7b409554 = 'JiraRichTextField';
const $4eac1b8021be0c88$export$ca57cccd6d7bf97c = 'JiraSecurityLevelField';
const $4eac1b8021be0c88$export$bea889616fd5bdab = 'JiraSingleGroupPickerField';
const $4eac1b8021be0c88$export$ab5cecc580898d1c = 'JiraSingleSelectField';
const $4eac1b8021be0c88$export$bb63813d13e8eaf7 = 'JiraSprintField';
const $4eac1b8021be0c88$export$e40f819979b3881d = 'JiraStatusField';
const $4eac1b8021be0c88$export$6c243704a22baffe = 'JiraTeamField';
const $4eac1b8021be0c88$export$6c32429bac235203 = 'JiraTeamViewField';
const $4eac1b8021be0c88$export$61b514b470cbbf07 = 'JiraSingleLineTextField';
const $4eac1b8021be0c88$export$e4bcb1729da5683 = 'JiraTimeTrackingField';
const $4eac1b8021be0c88$export$37ccd11f08a93ccb = 'JiraUrlField';
const $4eac1b8021be0c88$export$abf1bf8c1106ba7d = 'JiraSingleSelectUserPickerField';
const $4eac1b8021be0c88$export$b55604041ae7179e = 'JiraSingleVersionPickerField';
const $4eac1b8021be0c88$export$c8bf66d62e74cdd2 = 'JiraVotesField';
const $4eac1b8021be0c88$export$aa815aaa741ae18 = 'JiraWatchesField';
const $4eac1b8021be0c88$export$e805f89b15d2abf4 = 'JiraAssetField';
const $4eac1b8021be0c88$export$5bfd36acd96f04c2 = 'JiraServiceManagementPeopleField';
const $4eac1b8021be0c88$export$695423a2bc8a9ac4 = 'JiraServiceManagementOrganizationField';
const $4eac1b8021be0c88$export$d29b0ba0d80bc129 = 'JiraForgeStringField';
const $4eac1b8021be0c88$export$ac6c7b30703608d6 = 'JiraForgeStringsField';
const $4eac1b8021be0c88$export$478b546dccd33e1e = 'JiraForgeNumberField';
const $4eac1b8021be0c88$export$f90c042e9eb983e7 = 'JiraForgeDatetimeField';
const $4eac1b8021be0c88$export$753ca4fb34ff3f2b = 'JiraForgeDateField';
const $4eac1b8021be0c88$export$b7aed9efb4a9154b = 'JiraForgeObjectField';
const $4eac1b8021be0c88$export$1763713d718f7ef0 = 'JiraForgeGroupField';
const $4eac1b8021be0c88$export$ebb0caa2a98dcf9e = 'JiraForgeUserField';
const $4eac1b8021be0c88$export$671131ba12d94144 = 'JiraForgeGroupsField';
const $4eac1b8021be0c88$export$c48132adab502d6b = 'JiraForgeUsersField';
const $4eac1b8021be0c88$export$6cd83226f31c7072 = 'JiraServiceManagementApprovalField';
const $4eac1b8021be0c88$export$7de726bd6d97a9a7 = 'JiraServiceManagementUserApproverPrincipal';
const $4eac1b8021be0c88$export$8e4b538f77340a05 = 'JiraServiceManagementGroupApproverPrincipal';
const $4eac1b8021be0c88$export$10ba8c0d74470907 = 'JiraServiceManagementRequestFeedbackField';
const $4eac1b8021be0c88$export$1756bb4eff1cc3c6 = 'JiraServiceManagementRequestLanguageField';
const $4eac1b8021be0c88$export$5876b4be3c4407b = 'JiraServiceManagementRequestTypeField';
const $4eac1b8021be0c88$export$e7fe49e6f36c7154 = 'JiraServiceManagementRespondersField';
const $4eac1b8021be0c88$export$aeed3395a6bca18b = 'JiraServiceManagementUserResponder';
const $4eac1b8021be0c88$export$9b725a1eafd02e4f = 'JiraServiceManagementEntitlementField';
const $4eac1b8021be0c88$export$f658d5c0f0b5dbc2 = 'JiraServiceManagementTeamResponder';
const $4eac1b8021be0c88$export$e469bcb2060000af = 'JiraServiceManagementMajorIncidentField';
const $4eac1b8021be0c88$export$f10e53e8928b61bd = 'JiraDataClassificationField';
const $4eac1b8021be0c88$export$bfcb1a91094f113a = 'JiraGoalsField';
const $4eac1b8021be0c88$export$db0bd6c04eb7d04a = 'JiraDurationField';
const $4eac1b8021be0c88$export$798d2f5814884447 = 'forgeCustomField';
const $4eac1b8021be0c88$export$269d70c1b1c9fb80 = 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team';
const $4eac1b8021be0c88$export$f0f17ef462331df4 = 'com.atlassian.servicedesk.approvals-plugin:sd-approvals';
const $4eac1b8021be0c88$export$3c7d8923295a5199 = 'com.atlassian.jira.plugin.system.customfieldtypes:jwm-category';
const $4eac1b8021be0c88$export$fb431e758c9252df = 'com.atlassian.jira.plugin.system.customfieldtypes:people';
const $4eac1b8021be0c88$export$c7faa96db185cfc6 = 'com.atlassian.jira.plugin.system.customfieldtypes:float';
const $4eac1b8021be0c88$export$492b0fa4fe201a22 = 'com.pyxis.greenhopper.jira:jsw-story-points';
const $4eac1b8021be0c88$export$60f0bd6e4b582fe6 = 'com.atlassian.jira.plugin.system.customfieldtypes:url';
const $4eac1b8021be0c88$export$68c7e01d5460d298 = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
const $4eac1b8021be0c88$export$39cd48613b53ce2f = 'com.atlassian.jira.plugin.system.customfieldtypes:textarea';
const $4eac1b8021be0c88$export$977db5973ce73e44 = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $4eac1b8021be0c88$export$ad4eb83f78528e13 = 'com.atlassian.jira.plugin.system.customfieldtypes:labels';
const $4eac1b8021be0c88$export$ff745f432984005d = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
const $4eac1b8021be0c88$export$42d097f7b1622ef1 = 'com.atlassian.jira.plugin.system.customfieldtypes:datetime';
const $4eac1b8021be0c88$export$65524be5675e57e6 = 'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons';
const $4eac1b8021be0c88$export$5280e5501a801dc0 = 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes';
const $4eac1b8021be0c88$export$c5d13ea26562d57a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
const $4eac1b8021be0c88$export$22ac48a51c014e4b = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
const $4eac1b8021be0c88$export$6769c2c97b828e11 = 'com.pyxis.greenhopper.jira:gh-epic-status';
const $4eac1b8021be0c88$export$39866626496bbfc8 = 'com.atlassian.jira.plugin.system.customfieldtypes:multiversion';
const $4eac1b8021be0c88$export$24382b4e8c58336b = 'com.atlassian.jira.plugin.system.customfieldtypes:version';
const $4eac1b8021be0c88$export$b075907882e80160 = 'com.atlassian.jira.plugin.system.customfieldtypes:grouppicker';
const $4eac1b8021be0c88$export$b600addfa3355c57 = 'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker';
const $4eac1b8021be0c88$export$c491a4b98394028e = 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker';
const $4eac1b8021be0c88$export$5365f2d3fac5261a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker';
const $4eac1b8021be0c88$export$cc8ffff49170b0f4 = 'com.atlassian.jira.toolkit:participants';
const $4eac1b8021be0c88$export$b7178f601d7373f9 = 'com.atlassian.jira.plugin.system.customfieldtypes:flagged';
const $4eac1b8021be0c88$export$eb1f1dca13a0f02d = 'com.atlassian.teams:rm-teams-custom-field-team';
const $4eac1b8021be0c88$export$3e71e11f80203acb = 'com.atlassian.jpo:jpo-custom-field-parent';
const $4eac1b8021be0c88$export$9f47a86016048ac3 = 'com.atlassian.graphql:parent-issues';
const $4eac1b8021be0c88$export$d10d66823a65e688 = 'com.atlassian.jpo:jpo-custom-field-baseline-start';
const $4eac1b8021be0c88$export$dfc6da4a9963d5dc = 'com.atlassian.jpo:jpo-custom-field-baseline-end';
const $4eac1b8021be0c88$export$b4a1fbc1cf0059cf = 'com.pyxis.greenhopper.jira:jsw-issue-color';
const $4eac1b8021be0c88$export$4838a8a8d62a64fd = 'com.pyxis.greenhopper.jira:gh-epic-color';
const $4eac1b8021be0c88$export$ed2de20ab8b7ad3d = 'com.atlassian.servicedesk.assets-plugin:assetfield';
const $4eac1b8021be0c88$export$b755e97dbfa92610 = 'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype';
const $4eac1b8021be0c88$export$1be1ecd4dfc06fab = 'com.atlassian.servicedesk:sd-request-participants';
const $4eac1b8021be0c88$export$34317c2d84a93553 = 'com.atlassian.servicedesk:sd-customer-organizations';
const $4eac1b8021be0c88$export$555b4f35f98a3210 = 'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-request-language';
const $4eac1b8021be0c88$export$1f2859a3ef701a14 = 'com.atlassian.servicedesk:sd-request-feedback';
const $4eac1b8021be0c88$export$68f62eb762e4157f = 'com.atlassian.servicedesk:sd-request-feedback-date';
const $4eac1b8021be0c88$export$6da975fce1fbd38e = 'com.atlassian.servicedesk:vp-origin';
const $4eac1b8021be0c88$export$c6dd874aae21e51f = 'com.atlassian.jira.plugin.system.customfieldtypes:servicedesk-approvers-list';
const $4eac1b8021be0c88$export$c3c9f8a8a8dc0b30 = 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect';
const $4eac1b8021be0c88$export$af89c0396aaf23e3 = 'com.pyxis.greenhopper.jira:gh-lexo-rank';
const $4eac1b8021be0c88$export$3b5a62bb34372404 = 'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype';
const $4eac1b8021be0c88$export$247829aef464243f = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $4eac1b8021be0c88$export$65a6076c0927d413 = 'com.atlassian.jira.plugin.system.customfieldtypes:project';
const $4eac1b8021be0c88$export$bcf83e1d934501c9 = 'com.atlassian.jira.modules.servicemanagement.responders-entity:responders-entity-field-cftype';
const $4eac1b8021be0c88$export$ae0eeec12e90a01e = 'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype';
const $4eac1b8021be0c88$export$f94696506ee781f9 = 'com.atlassian.jira.plugins.jim-plugin:bug-importid';
const $4eac1b8021be0c88$export$8ba6ed64df1ce64a = 'com.atlassian.jira.plugin.system.customfieldtypes:importid';
const $4eac1b8021be0c88$export$e90ce947f06b085d = 'com.atlassian.jconnect.jconnect-plugin:uuid';
const $4eac1b8021be0c88$export$c23f6b40da18371a = 'com.atlassian.servicedesk.customer-context:sd-csm-entitlement';
const $4eac1b8021be0c88$export$c23cfbdf83daa90d = 'com.atlassian.servicedesk.sentiment:sd-sentiment';
const $4eac1b8021be0c88$export$21dda64db57e4883 = 'com.atlassian.jira.toolkit:viewmessage';
const $4eac1b8021be0c88$export$45700f3bf92a003a = 'com.atlassian.jira.toolkit:message';
const $4eac1b8021be0c88$export$2d75b47d12efc812 = 'com.atlassian.jira.toolkit:lastupdaterorcommenter';
const $4eac1b8021be0c88$export$36500b2821f7114f = 'com.atlassian.jira.toolkit:attachments';
const $4eac1b8021be0c88$export$37dc91333ba7a96 = 'com.atlassian.jira.toolkit:LastCommentDate';
const $4eac1b8021be0c88$export$7b79405842547ccb = 'com.atlassian.jira.toolkit:userproperty';
const $4eac1b8021be0c88$export$ac9f7d2dfc7c6826 = 'com.atlassian.jira.toolkit:assigneedomain';
const $4eac1b8021be0c88$export$a3d9c149d737aa78 = 'com.atlassian.jira.toolkit:reporterdomain';
const $4eac1b8021be0c88$export$4745e551386233a5 = 'com.atlassian.jira.toolkit:comments';
const $4eac1b8021be0c88$export$5ee213d6fd4c9b2b = 'com.atlassian.jira.toolkit:dayslastcommented';
const $4eac1b8021be0c88$export$fb0b6a2e098e1fe2 = 'com.atlassian.jira.toolkit:lastusercommented';
const $4eac1b8021be0c88$export$fe1291c40f590f35 = 'com.atlassian.servicedesk:sd-sla-field';
const $4eac1b8021be0c88$export$e9c81bef34f2c86c = 'sd-servicelevelagreement';
const $4eac1b8021be0c88$export$96201d0ae03ca323 = 'com.atlassian.jira.ext.charting:timeinstatus';
const $4eac1b8021be0c88$export$fc276d6ccf118a14 = 'com.atlassian.jira.ext.charting:firstresponsedate';
const $4eac1b8021be0c88$export$8b0718167d092603 = 'com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf';
const $4eac1b8021be0c88$export$904b40dd2afd17a2 = 'com.atlassian.graphql:children-issues';
const $4eac1b8021be0c88$export$4063d93c74c89472 = 'com.atlassian.graphql:epic-issues';
const $4eac1b8021be0c88$export$f0eeb5dcfbc42177 = 'com.atlassian.graphql:portfolio-child-issues';
const $4eac1b8021be0c88$export$2bbb7f69c97ea279 = 'com.atlassian.jira.plugin.system.customfieldtypes:goals';
const $4eac1b8021be0c88$export$fba8634fd401ba8b = 'assignee';
const $4eac1b8021be0c88$export$a91aea2438afcce8 = 'reporter';
const $4eac1b8021be0c88$export$b159f8b8f27aae4c = 'duedate';
const $4eac1b8021be0c88$export$34740f8d07d23ac0 = 'priority';
const $4eac1b8021be0c88$export$43b6e33ec70f2272 = 'labels';
const $4eac1b8021be0c88$export$ff39ebd4bb12b718 = 'created';
const $4eac1b8021be0c88$export$cd8e68094cb5c3cb = 'updated';
const $4eac1b8021be0c88$export$6a052efb0b4ec5d2 = 'resolutiondate';
const $4eac1b8021be0c88$export$37abf56f13f61ec5 = 'components';
const $4eac1b8021be0c88$export$aef0c22aecd16996 = 'servicedesk-approvals';
const $4eac1b8021be0c88$export$cff5b6d1e7135679 = 'servicedesk-practices';
const $4eac1b8021be0c88$export$d925edcf818f4885 = 'servicedesk-incident-linking';
const $4eac1b8021be0c88$export$e7c590d96ed1c7fa = 'servicedesk-incident-escalate';
const $4eac1b8021be0c88$export$791007408faf42f4 = 'servicedesk-incident-management';
const $4eac1b8021be0c88$export$827a1c600bac12a3 = 'devSummary';
const $4eac1b8021be0c88$export$e9ba671d077969f8 = 'releases';
const $4eac1b8021be0c88$export$3d37701ba6fb68ec = 'com.pyxis.greenhopper.jira:gh-sprint';
const $4eac1b8021be0c88$export$36fd22f47020f37b = 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint';
const $4eac1b8021be0c88$export$9f2fedcd916d2a79 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $4eac1b8021be0c88$export$dfc63737b8c0150d = 'com.pyxis.greenhopper.jira:gh-epic-label';
const $4eac1b8021be0c88$export$a5c9f63aadcb220 = 'fixVersions';
const $4eac1b8021be0c88$export$94009605902e4fe5 = 'versions';
const $4eac1b8021be0c88$export$5e7324042f1d6b31 = 'description';
const $4eac1b8021be0c88$export$113281d03e6830ef = 'environment';
const $4eac1b8021be0c88$export$5ff798870a3dffbf = 'watches';
const $4eac1b8021be0c88$export$907219511d14ba3d = 'summary';
const $4eac1b8021be0c88$export$d09aa6a4f3538063 = 'proforma-forms';
const $4eac1b8021be0c88$export$3aca8c91b58a42e2 = 'resolution';
const $4eac1b8021be0c88$export$ccb5ffefbf8b987c = 'timetracking';
const $4eac1b8021be0c88$export$c8bedad98a5e7f5f = 'timeoriginalestimate';
const $4eac1b8021be0c88$export$358267065be1e = 'status';
const $4eac1b8021be0c88$export$dcaa788c7ada56de = 'statusCategory';
const $4eac1b8021be0c88$export$ebb48b08205007c5 = 'issuetype';
const $4eac1b8021be0c88$export$5e91047fe9955d0e = 'issuekey';
const $4eac1b8021be0c88$export$3b3d0889022c85b3 = 'children-issues';
const $4eac1b8021be0c88$export$aba22e09a66f6826 = 'portfolio-child-issues';
const $4eac1b8021be0c88$export$8fe3d5be8cb17459 = 'epic-issues';
const $4eac1b8021be0c88$export$335851d83a79891 = 'hierarchy-level-below';
const $4eac1b8021be0c88$export$7b76bbcb87d41695 = 'com.atlassian.graphql:hierarchy-level-below';
const $4eac1b8021be0c88$export$297b67ac63f09f72 = 'hierarchy-level-above';
const $4eac1b8021be0c88$export$ae87161126086be = 'com.atlassian.graphql:hierarchy-level-above';
const $4eac1b8021be0c88$export$6a88420fc2f6901d = 'hierarchy-level-same-level';
const $4eac1b8021be0c88$export$ef1a0421bd42c0e4 = 'com.atlassian.graphql:hierarchy-level-same-level';
const $4eac1b8021be0c88$export$dd695c8c5ab62f9d = 'CUSTOMER_CONTEXT';
const $4eac1b8021be0c88$export$7b3d247435a784fa = 'SLA_PANEL';
const $4eac1b8021be0c88$export$17b7080ed1fe8cfd = 'LINKED_ALERTS';
const $4eac1b8021be0c88$export$29fe745131dad7ba = 'CHAT_CHANNEL';
const $4eac1b8021be0c88$export$9c245100c3091ec3 = 'MSTEAMS_CHANNEL';
const $4eac1b8021be0c88$export$51eb15cea47a37ba = 'ZOOM_MEETING';
const $4eac1b8021be0c88$export$c7ae0622b0bd5d56 = 'MANAGE_STAKEHOLDERS';
const $4eac1b8021be0c88$export$f7dcde9e9e88aff2 = 'CONFERENCE_CALL';
const $4eac1b8021be0c88$export$b5358afda8ff335e = 'KNOWLEDGE_BASE';
const $4eac1b8021be0c88$export$63cf6f392da16c25 = 'ASSET_ONBOARDING';
const $4eac1b8021be0c88$export$22f61ccc2730431f = 'similar-issues';
const $4eac1b8021be0c88$export$8bbb446f57294715 = 'subtasks';
const $4eac1b8021be0c88$export$34fcd7cb291a1e4d = 'votes';
const $4eac1b8021be0c88$export$5e93f2a57cc4ca3a = 'parent';
const $4eac1b8021be0c88$export$be3891c8b47ab821 = 'parent-issue'; // Remove on FD-30157 clean-up
const $4eac1b8021be0c88$export$91a9dba2d38d9a6f = 'project';
const $4eac1b8021be0c88$export$df36fc05622c402 = 'worklog';
const $4eac1b8021be0c88$export$ede0a4c20124ec85 = 'timespent';
const $4eac1b8021be0c88$export$3eeb79d48fb5f667 = 'dataclassification';
const $4eac1b8021be0c88$export$45e72c9a63ab61ab = 'SENTIMENT';
const $4eac1b8021be0c88$export$99ad62164189f781 = 'ecosystemGlance';
const $4eac1b8021be0c88$export$7719ef6e9283671 = 'forgeGlance';
const $4eac1b8021be0c88$export$bfebea5ce2e1887a = 'ecosystemContext';
const $4eac1b8021be0c88$export$be8e68fb1aed253e = 'forgeContext';
const $4eac1b8021be0c88$export$84e5674890d55030 = 'issuerestriction';
const $4eac1b8021be0c88$export$326a5522a485e43d = 'security';
const $4eac1b8021be0c88$export$c9f3f01e2c535302 = 'securitylevel';
const $4eac1b8021be0c88$export$35e5652f764785bd = 'creator';
const $4eac1b8021be0c88$export$66519f3bbff1796a = 'team';
const $4eac1b8021be0c88$export$a4ee0bca77cc8463 = 'estimate';
const $4eac1b8021be0c88$export$fed53408e89e0497 = 'dueDate';
const $4eac1b8021be0c88$export$d53c26f9ce31f56b = 'targetStart';
const $4eac1b8021be0c88$export$48f82d653f85e459 = 'targetEnd';
const $4eac1b8021be0c88$export$ea5a888f39f722c7 = 'startDate';
const $4eac1b8021be0c88$export$f245bbec12cc0e40 = 'color';
const $4eac1b8021be0c88$export$aed630b4b7114a59 = 'attachment';
const $4eac1b8021be0c88$export$b50c1a8fef07104 = 'issuelinks';
const $4eac1b8021be0c88$export$ea3d72f4bb7738ba = 'timeestimate';
const $4eac1b8021be0c88$export$a4cab0124760d860 = 'comment';
const $4eac1b8021be0c88$export$734929aef118d7e2 = 'worklog';
const $4eac1b8021be0c88$export$ffbacacb07c1d46d = 'parent';
const $4eac1b8021be0c88$export$871661506c0a91ea = 'aggregatetimeoriginalestimate';
const $4eac1b8021be0c88$export$278c072e2f9176ab = 'aggregatetimespent';
const $4eac1b8021be0c88$export$4a7ecfe931ab6c07 = 'aggregatetimeestimate';
const $4eac1b8021be0c88$export$fbc5ebe2e580bf8b = 'progress';
const $4eac1b8021be0c88$export$aa3b37e271efd578 = 'aggregateprogress';
const $4eac1b8021be0c88$export$444bffe6526fb5f2 = 'workratio';
/**
 * Fields shown in the issue layout
 *
 * Cannot declare as simple object - in case there is a FF in getLayoutItemMap() (which happens when we add a new field), because we cannot get FF value in SSR.
 * Memoization is needed not to rerender too many times.
 */ const $4eac1b8021be0c88$var$getLayoutFieldTypesNonMemoized = ()=>{
    const types = {
        ASSIGNEE_TYPE: $4eac1b8021be0c88$export$fba8634fd401ba8b,
        DUE_DATE_TYPE: $4eac1b8021be0c88$export$b159f8b8f27aae4c,
        PRIORITY_TYPE: $4eac1b8021be0c88$export$34740f8d07d23ac0,
        REPORTER_TYPE: $4eac1b8021be0c88$export$a91aea2438afcce8,
        DESCRIPTION_TYPE: $4eac1b8021be0c88$export$5e7324042f1d6b31,
        LABELS_TYPE: $4eac1b8021be0c88$export$43b6e33ec70f2272,
        COMPONENTS_TYPE: $4eac1b8021be0c88$export$37abf56f13f61ec5,
        SPRINT_TYPE: $4eac1b8021be0c88$export$3d37701ba6fb68ec,
        STORY_POINTS_TYPE: $4eac1b8021be0c88$export$36fd22f47020f37b,
        TEAMS_PLATFORM_CF_TYPE: $4eac1b8021be0c88$export$269d70c1b1c9fb80,
        EPIC_TYPE: $4eac1b8021be0c88$export$9f2fedcd916d2a79,
        FIX_VERSIONS_TYPE: $4eac1b8021be0c88$export$a5c9f63aadcb220,
        AFFECTS_VERSIONS_TYPE: $4eac1b8021be0c88$export$94009605902e4fe5,
        TIME_ESTIMATE_TYPE: $4eac1b8021be0c88$export$c8bedad98a5e7f5f,
        TIME_TRACKING_TYPE: $4eac1b8021be0c88$export$ccb5ffefbf8b987c,
        ENVIRONMENT_TYPE: $4eac1b8021be0c88$export$113281d03e6830ef,
        DEV_SUMMARY_TYPE: $4eac1b8021be0c88$export$827a1c600bac12a3,
        APPROVALS_PANEL_TYPE: $4eac1b8021be0c88$export$7773375e72c953ed,
        KNOWLEDGE_BASE_TYPE: $4eac1b8021be0c88$export$b5358afda8ff335e,
        SLA_PANEL_TYPE: $4eac1b8021be0c88$export$7b3d247435a784fa,
        LINKED_ALERTS_TYPE: $4eac1b8021be0c88$export$17b7080ed1fe8cfd,
        CHAT_CHANNEL_TYPE: $4eac1b8021be0c88$export$29fe745131dad7ba,
        MSTEAMS_CHANNEL_TYPE: $4eac1b8021be0c88$export$9c245100c3091ec3,
        ZOOM_MEETING_TYPE: $4eac1b8021be0c88$export$51eb15cea47a37ba,
        MANAGE_STAKEHOLDERS_TYPE: $4eac1b8021be0c88$export$c7ae0622b0bd5d56,
        CONFERENCE_CALL_TYPE: $4eac1b8021be0c88$export$f7dcde9e9e88aff2,
        ASSETS_CF_TYPE: $4eac1b8021be0c88$export$ed2de20ab8b7ad3d,
        RESPONDERS_CF_TYPE: $4eac1b8021be0c88$export$bcf83e1d934501c9,
        MAJOR_INCIDENT_CF_TYPE: $4eac1b8021be0c88$export$ae0eeec12e90a01e,
        COLOR_CF_TYPE: $4eac1b8021be0c88$export$b4a1fbc1cf0059cf,
        EPIC_COLOR_TYPE: $4eac1b8021be0c88$export$4838a8a8d62a64fd,
        RELEASES_TYPE: $4eac1b8021be0c88$export$e9ba671d077969f8,
        PARENT_CF_TYPE: $4eac1b8021be0c88$export$3e71e11f80203acb,
        BASELINE_START_CF_TYPE: $4eac1b8021be0c88$export$d10d66823a65e688,
        BASELINE_END_CF_TYPE: $4eac1b8021be0c88$export$dfc6da4a9963d5dc,
        LABELS_CF_TYPE: $4eac1b8021be0c88$export$ad4eb83f78528e13,
        TEXT_CF_TYPE: $4eac1b8021be0c88$export$68c7e01d5460d298,
        MULTI_USER_CF_TYPE: $4eac1b8021be0c88$export$5365f2d3fac5261a,
        PARTICIPANTS_CF_TYPE: $4eac1b8021be0c88$export$cc8ffff49170b0f4,
        URL_CF_TYPE: $4eac1b8021be0c88$export$60f0bd6e4b582fe6,
        NUMBER_CF_TYPE: $4eac1b8021be0c88$export$c7faa96db185cfc6,
        STORY_POINT_ESTIMATE_CF_TYPE: $4eac1b8021be0c88$export$492b0fa4fe201a22,
        SELECT_CF_TYPE: $4eac1b8021be0c88$export$22ac48a51c014e4b,
        EPIC_STATUS_TYPE: $4eac1b8021be0c88$export$6769c2c97b828e11,
        MULTI_SELECT_CF_TYPE: $4eac1b8021be0c88$export$c5d13ea26562d57a,
        ECOSYSTEM_GLANCE_TYPE: $4eac1b8021be0c88$export$99ad62164189f781,
        FORGE_CUSTOM_FIELD_TYPE: $4eac1b8021be0c88$export$798d2f5814884447,
        ISSUE_FIELD_USER_CF_TYPE: $4eac1b8021be0c88$export$5600354b43577e17,
        ISSUE_FIELD_GROUPS_CF_TYPE: $4eac1b8021be0c88$export$eb39592ba5247ee7,
        ISSUE_FIELD_STRINGS_CF_TYPE: $4eac1b8021be0c88$export$f48a9be226105736,
        FORGE_GLANCE_TYPE: $4eac1b8021be0c88$export$7719ef6e9283671,
        TEXT_AREA_CF_TYPE: $4eac1b8021be0c88$export$39cd48613b53ce2f,
        MULTI_VERSION_CF_TYPE: $4eac1b8021be0c88$export$39866626496bbfc8,
        VERSION_CF_TYPE: $4eac1b8021be0c88$export$24382b4e8c58336b,
        DATE_CF_TYPE: $4eac1b8021be0c88$export$ff745f432984005d,
        GROUP_CF_TYPE: $4eac1b8021be0c88$export$b075907882e80160,
        MULTI_GROUP_CF_TYPE: $4eac1b8021be0c88$export$b600addfa3355c57,
        USER_CF_TYPE: $4eac1b8021be0c88$export$c491a4b98394028e,
        DATETIME_CF_TYPE: $4eac1b8021be0c88$export$42d097f7b1622ef1,
        MULTI_CHECKBOXES_CF_TYPE: $4eac1b8021be0c88$export$5280e5501a801dc0,
        RADIO_BUTTONS_CF_TYPE: $4eac1b8021be0c88$export$65524be5675e57e6,
        TEAM_CF_TYPE: $4eac1b8021be0c88$export$eb1f1dca13a0f02d,
        ISSUE_FIELD_NUMBER_CF_TYPE: $4eac1b8021be0c88$export$bc917bc699b25f75,
        ISSUE_FIELD_DATETIME_CF_TYPE: $4eac1b8021be0c88$export$ce9bfd823c7e1a6d,
        ISSUE_FIELD_STRING_CF_TYPE: $4eac1b8021be0c88$export$5f26ca419fdffbe7,
        ISSUE_FIELD_SINGLE_SELECT_CF_TYPE: $4eac1b8021be0c88$export$b20fbcacd7942c2a,
        ISSUE_FIELD_MULTI_SELECT_CF_TYPE: $4eac1b8021be0c88$export$f25cd4907cbb25b9,
        REQUEST_TYPE_CF_TYPE: $4eac1b8021be0c88$export$6da975fce1fbd38e,
        SERVICE_ENTITY_CF_TYPE: $4eac1b8021be0c88$export$b755e97dbfa92610,
        REQUEST_PARTICIPANTS_CF_TYPE: $4eac1b8021be0c88$export$1be1ecd4dfc06fab,
        ORGANIZATIONS_CF_TYPE: $4eac1b8021be0c88$export$34317c2d84a93553,
        REQUEST_FEEDBACK_CF_TYPE: $4eac1b8021be0c88$export$1f2859a3ef701a14,
        PEOPLE_CF_TYPE: $4eac1b8021be0c88$export$fb431e758c9252df,
        REQUEST_LANGUAGE_CF_TYPE: $4eac1b8021be0c88$export$555b4f35f98a3210,
        ASSET_ONBOARDING_TYPE: $4eac1b8021be0c88$export$63cf6f392da16c25,
        APPROVERS_LIST_CF_TYPE: $4eac1b8021be0c88$export$c6dd874aae21e51f,
        CASCADING_SELECT_CF_TYPE: $4eac1b8021be0c88$export$c3c9f8a8a8dc0b30,
        PROJECT_PICKER_CF_TYPE: $4eac1b8021be0c88$export$65a6076c0927d413,
        CMDB_OBJECT_CF_TYPE: $4eac1b8021be0c88$export$3b5a62bb34372404,
        READ_ONLY_CF_TYPE: $4eac1b8021be0c88$export$247829aef464243f,
        MESSAGE_VIEW_CF_TYPE: $4eac1b8021be0c88$export$21dda64db57e4883,
        MESSAGE_EDIT_CF_TYPE: $4eac1b8021be0c88$export$45700f3bf92a003a,
        EPIC_NAME_TYPE: $4eac1b8021be0c88$export$dfc63737b8c0150d,
        ECOSYSTEM_CONTEXT_TYPE: $4eac1b8021be0c88$export$bfebea5ce2e1887a,
        CATEGORY_TYPE: $4eac1b8021be0c88$export$3c7d8923295a5199,
        ENTITLEMENT_CF_TYPE: $4eac1b8021be0c88$export$c23f6b40da18371a
    };
    Object.assign(types, {
        FORGE_CONTEXT_TYPE: $4eac1b8021be0c88$export$be8e68fb1aed253e
    });
    if ((0, $1ybV0.ff)('parent-field-in-issue-view_x4zn4')) Object.assign(types, {
        PARENT_TYPE: $4eac1b8021be0c88$export$5e93f2a57cc4ca3a
    });
    if ((0, $1ybV0.ff)('jsm-sentiment-analysis_1dage')) Object.assign(types, {
        SENTIMENT_TYPE: $4eac1b8021be0c88$export$45e72c9a63ab61ab
    });
    if ((0, $1ybV0.ff)('sentiment-custom-field')) Object.assign(types, {
        SENTIMENT_CF_TYPE: $4eac1b8021be0c88$export$c23cfbdf83daa90d
    });
    return types;
};
const $4eac1b8021be0c88$export$3c3e26aadbfa2c32 = (0, $5iWql.default)($4eac1b8021be0c88$var$getLayoutFieldTypesNonMemoized);

});


parcelRegister("6ZTsa", function(module, exports) {

$parcel$export(module.exports, "toErrorId", () => $36a0a2a2a499297e$export$706bbe4209d93dfe);
$parcel$export(module.exports, "toErrorMessage", () => $36a0a2a2a499297e$export$95506c204c060a3);
// Package name to be used in famaCatchAndLogFetchError and logError utils

var $6bYiA = parcelRequire("6bYiA");
const $36a0a2a2a499297e$export$706bbe4209d93dfe = (id)=>id;
const $36a0a2a2a499297e$export$95506c204c060a3 = (message)=>message;

});

parcelRegister("avawr", function(module, exports) {

$parcel$export(module.exports, "logError", () => $f57ea56200106b95$export$58da9968c3170cb1);

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");
const $f57ea56200106b95$export$58da9968c3170cb1 = (packageName, errorId, message, error, attributes)=>{
    // Send error log to analytics pipeline (i.e. SFX) and Sentry
    (0, $guiFP.default)({
        meta: {
            packageName: packageName,
            id: errorId,
            teamName: 'morphinecake'
        },
        attributes: {
            ...attributes,
            message: message
        },
        error: error
    });
    // Send error log to Splunk
    // We use this instead of `sendToPrivacyUnsafeSplunk` to preserve error message and custom properties
    const location = `${packageName}.${errorId}`;
    (0, $gUUjF.default).unsafeErrorWithCustomerData(location, message, error);
};

});




parcelRegister("dpXKE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e24a038ddb34e953$export$2e2bcd8739ae039);

var $giAhk = parcelRequire("giAhk");

var $cM35R = parcelRequire("cM35R");
var $e24a038ddb34e953$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)((0, $cM35R.default));

});
parcelRegister("giAhk", function(module, exports) {

$parcel$export(module.exports, "injectIntlV2", () => $208f42a3fdc9fe2c$export$440265f0ca78e98e);

var $eUqFw = parcelRequire("eUqFw");

var $lxchL = parcelRequire("lxchL");

var $2qhQi = parcelRequire("2qhQi");

var $1IqwQ = parcelRequire("1IqwQ");
const $208f42a3fdc9fe2c$var$IntlConsumer = (0, $2qhQi.Context).Consumer;
const $208f42a3fdc9fe2c$var$isDisplayableString = (mayBeString)=>typeof mayBeString === 'string' && mayBeString !== '';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $208f42a3fdc9fe2c$var$getDisplayName(Component) {
    if ($208f42a3fdc9fe2c$var$isDisplayableString(Component.displayName)) // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
    return Component.displayName;
    if ($208f42a3fdc9fe2c$var$isDisplayableString(Component.name)) return Component.name;
    return 'Component';
}
const $208f42a3fdc9fe2c$export$440265f0ca78e98e = (WrappedComponent, options)=>{
    const { withRef: withRef = false } = options || {};
    const WithIntl = (props)=>{
        const intlRef = (0, $eUqFw.useRef)(null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($208f42a3fdc9fe2c$var$IntlConsumer, null, (intl)=>{
            if (!intl) throw new Error('REACT_INTL_FACADE: React Intl Could not find required `intl` object');
            if (!intlRef.current) intlRef.current = {
                // Now is deprecated since version 2: https://github.com/formatjs/formatjs/issues/1409
                now: ()=>Date.now(),
                // @ts-expect-error We force v5 messages type on v2 type
                messages: intl.messages,
                locale: intl.locale,
                formats: intl.formats,
                formatDate: intl.formatDate,
                formatMessage: intl.formatMessage,
                formatHTMLMessage: (descriptor, values)=>intl.formatMessage(descriptor, values, {
                        ignoreTag: true
                    }),
                formatNumber: intl.formatNumber,
                formatRelative: (date, opts)=>{
                    const { time: time, unit: unit } = (0, $1IqwQ.getRelativeTimeAndUnit)(date);
                    return intl.formatRelativeTime(time, unit, opts);
                },
                formatPlural: intl.formatPlural,
                formatTime: intl.formatTime
            };
            return(// @ts-expect-error - TS2322 - Type 'Diff<LibraryManagedAttributes<Component, ComponentProps<Component>>, InjectIntlVoidProps> & { ...; } & { ...; }' is not assignable to type 'IntrinsicAttributes & LibraryManagedAttributes<Component, PropsWithChildren<P>>'.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                ...props,
                intl: intlRef.current,
                ref: withRef ? props.forwardedRef : null
            }));
        });
    };
    // Changed this display name to be capital letter to prevent snapshots from failing, here is the original: https://github.com/formatjs/formatjs/blob/main/packages/react-intl/src/components/injectIntl.tsx#L98
    WithIntl.displayName = `InjectIntl(${$208f42a3fdc9fe2c$var$getDisplayName(WrappedComponent)})`;
    WithIntl.WrappedComponent = WrappedComponent;
    if (withRef) // @ts-expect-error - TS2352 - Conversion of type 'ForwardRefExoticComponent<PropsWithoutRef<WithIntlProps<LibraryManagedAttributes<C, ComponentProps<C>>>> & RefAttributes<...>> & NonReactStatics<...>' to type 'ComponentType<WithIntlProps<LibraryManagedAttributes<C, ComponentProps<C>>>>' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, (/*@__PURE__*/$parcel$interopDefault($lxchL)))(/*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WithIntl, {
            ...props,
            forwardedRef: ref
        })), WrappedComponent);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, (/*@__PURE__*/$parcel$interopDefault($lxchL)))(WithIntl, WrappedComponent);
};

});
parcelRegister("1IqwQ", function(module, exports) {

$parcel$export(module.exports, "getRelativeTimeAndUnit", () => $6a7dda3450af4d49$export$307c4b8ee56b97bb);
$parcel$export(module.exports, "FormattedRelativeV2", () => $6a7dda3450af4d49$export$7317ee2f88fd1276);

var $eUqFw = parcelRequire("eUqFw");

var $9KU0P = parcelRequire("9KU0P");

var $8M1qS = parcelRequire("8M1qS");
const $6a7dda3450af4d49$var$getTimeInUnits = (unitValue)=>{
    const seconds = unitValue / 1000;
    const minutes = seconds / 60;
    const hours = minutes / 60;
    const days = hours / 24;
    const weeks = days / 7;
    const months = weeks / 4;
    const years = months / 12;
    return {
        seconds: seconds,
        minutes: minutes,
        hours: hours,
        days: days,
        weeks: weeks,
        months: months,
        years: years
    };
};
const $6a7dda3450af4d49$export$307c4b8ee56b97bb = (value, units)=>{
    const timeInMilliseconds = new Date(value);
    // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
    const delta = timeInMilliseconds - Date.now();
    let valueInUnit;
    if (!units) {
        const { value: time, unit: unit } = (0, $9KU0P.selectUnit)(timeInMilliseconds, new Date());
        return {
            time: time,
            unit: unit
        };
    }
    const { seconds: seconds, minutes: minutes, hours: hours, days: days, weeks: weeks, months: months, years: years } = $6a7dda3450af4d49$var$getTimeInUnits(delta);
    switch(units){
        case 'second':
            valueInUnit = seconds;
            break;
        case 'minute':
            valueInUnit = minutes;
            break;
        case 'hour':
            valueInUnit = hours;
            break;
        case 'day':
            valueInUnit = days;
            break;
        case 'week':
            valueInUnit = weeks;
            break;
        case 'month':
            valueInUnit = months;
            break;
        case 'year':
            valueInUnit = years;
            break;
        default:
            valueInUnit = 0;
            break;
    }
    return {
        time: Math.ceil(valueInUnit),
        unit: units
    };
};
const $6a7dda3450af4d49$export$7317ee2f88fd1276 = ({ value: value, units: units, children: children, style: style, format: format, updateInterval: updateInterval })=>{
    const { time: time, unit: unit } = $6a7dda3450af4d49$export$307c4b8ee56b97bb(value, units);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8M1qS.default), {
        value: time,
        unit: unit,
        numeric: style === 'numeric' ? 'always' : 'auto',
        format: format,
        updateIntervalInSeconds: updateInterval
    }, children);
};
$6a7dda3450af4d49$export$7317ee2f88fd1276.displayName = 'FormattedRelative';

});


parcelRegister("cM35R", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa15d60f2ab7426b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kKe2o = parcelRequire("kKe2o");

var $5IARc = parcelRequire("5IARc");

var $6ulBk = parcelRequire("6ulBk");
const $fa15d60f2ab7426b$var$ProjectBreadcrumb = ({ isSimplifiedProject: isSimplifiedProject, baseUrl: baseUrl, children: children, projectKey: projectKey, projectName: projectName, projectId: projectId, intl: { formatMessage: formatMessage } })=>{
    const breadcrumb = {
        href: (0, $5IARc.createProjectUrl)(baseUrl ?? '', projectKey),
        text: projectName,
        type: 'projectName',
        analyticsAttributes: {
            nextGenProject: isSimplifiedProject,
            projectConfig: isSimplifiedProject !== undefined && isSimplifiedProject === true ? 'next-gen' : 'classic'
        },
        analyticsFields: {
            name: 'navigateToProject',
            containerId: projectId,
            containerType: 'project'
        }
    };
    const ProjectsBreadcrumb = {
        href: '/jira/projects',
        text: formatMessage((0, $6ulBk.default).projectsTitle),
        type: 'projectsDirectory',
        analyticsAttributes: {
            nextGenProject: isSimplifiedProject,
            projectConfig: isSimplifiedProject !== undefined && isSimplifiedProject === true ? 'next-gen' : 'classic'
        },
        analyticsFields: {
            name: 'navigateToProjectsList'
        }
    };
    const ProjectNameBreadcrumb = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKe2o.default), {
        breadcrumb: breadcrumb
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKe2o.default), {
        breadcrumb: ProjectsBreadcrumb
    }, ProjectNameBreadcrumb);
};
$fa15d60f2ab7426b$var$ProjectBreadcrumb.defaultProps = {
    children: null,
    isSimplifiedProject: false,
    projectId: undefined,
    baseUrl: ''
};
var $fa15d60f2ab7426b$export$2e2bcd8739ae039 = $fa15d60f2ab7426b$var$ProjectBreadcrumb;

});
parcelRegister("6ulBk", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cb70b0ebc38fe07$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9cb70b0ebc38fe07$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    projectsTitle: {
        "id": "platform.ui.breadcrumbs.common-breadcrumbs.project.projects-title",
        "defaultMessage": "Projects"
    }
});

});



parcelRegister("5c2C3", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a95e6e6f9b00b47$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kKe2o = parcelRequire("kKe2o");
const $4a95e6e6f9b00b47$var$UserBreadcrumb = ({ children: children, name: name, profileUrl: profileUrl })=>{
    const breadcrumb = {
        href: profileUrl,
        text: name,
        type: 'userName'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKe2o.default), {
        breadcrumb: breadcrumb
    }, children);
};
var $4a95e6e6f9b00b47$export$2e2bcd8739ae039 = $4a95e6e6f9b00b47$var$UserBreadcrumb;

});

parcelRegister("1bzuc", function(module, exports) {

$parcel$export(module.exports, "default", () => $75132222441dd418$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $75132222441dd418$var$toBreadcrumbData = ({ id: id, index: index, ...legacyCrumb })=>({
        ...legacyCrumb,
        legacyId: id,
        type: 'legacy'
    });
const $75132222441dd418$var$ContextBreadcrumbs = ({ ContextProvider: ContextProvider, ProjectBreadcrumb: ProjectBreadcrumb, BoardBreadcrumb: BoardBreadcrumb, UserBreadcrumb: UserBreadcrumb, children: children, baseUrl: baseUrl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ContextProvider, null, ({ data: data })=>{
        if (!data) return children;
        const boardBreadcrumb = data.scope ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(BoardBreadcrumb, {
            baseUrl: baseUrl,
            boardId: data.scope.id,
            boardName: data.scope.name || 'Board'
        }, children) : children;
        return data.contextType === 'user' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(UserBreadcrumb, {
            profileUrl: data.user.profileUrl,
            name: data.user.name
        }, boardBreadcrumb) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ProjectBreadcrumb, {
            baseUrl: baseUrl,
            projectKey: data.project.key,
            projectName: data.project.name,
            projectId: data.project.id,
            isSimplifiedProject: data.project.isSimplified
        }, boardBreadcrumb);
    });
const $75132222441dd418$var$LegacyBreadcrumbConnector = ({ baseUrl: baseUrl, legacyTrail: legacyTrail, Breadcrumb: Breadcrumb, BoardBreadcrumb: BoardBreadcrumb, UserBreadcrumb: UserBreadcrumb, ProjectBreadcrumb: ProjectBreadcrumb, ContextProvider: ContextProvider })=>{
    const accumulateBreadcrumb = (accumulatedCrumbs, currentCrumb)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Breadcrumb, {
            breadcrumb: currentCrumb
        }, accumulatedCrumbs);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($75132222441dd418$var$ContextBreadcrumbs, {
        baseUrl: baseUrl,
        BoardBreadcrumb: BoardBreadcrumb,
        ProjectBreadcrumb: ProjectBreadcrumb,
        UserBreadcrumb: UserBreadcrumb,
        ContextProvider: ContextProvider
    }, legacyTrail.map($75132222441dd418$var$toBreadcrumbData).reverse().reduce(accumulateBreadcrumb, null));
};
var $75132222441dd418$export$2e2bcd8739ae039 = $75132222441dd418$var$LegacyBreadcrumbConnector;

});

parcelRegister("i7f3H", function(module, exports) {

$parcel$export(module.exports, "default", () => $797e4a145a4e40c7$export$2e2bcd8739ae039);

var $kFGm5 = parcelRequire("kFGm5");

var $kJlBc = parcelRequire("kJlBc");

var $SEaoU = parcelRequire("SEaoU");
const $797e4a145a4e40c7$export$9f27bc3417b4524d = ({ children: children })=>{
    const [boardId] = (0, $kJlBc.usePathParam)('boardId');
    const [rapidView] = (0, $kJlBc.useQueryParam)('rapidView');
    const [{ data: ctxData, loading: loading, error: error }] = (0, $SEaoU.useContainerContext)();
    /* Don't provide scope data if boardId does not exist in the URL as
	 * we don't want to show the board breadcrumb in this case since it
	 * indicates that we aren't in a scope context even though one may
	 * exist. */ const data = ctxData == null || boardId != null || rapidView != null ? ctxData : (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(ctxData, 'scope');
    // @ts-expect-error - TS2322 - Type 'Pick<ProjectContext | UserContext, "contextType"> | null' is not assignable to type 'ContainerContext | null'. | TS2322 - Type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to type 'Error | null'.
    return children({
        data: data,
        loading: loading,
        error: error
    });
};
var $797e4a145a4e40c7$export$2e2bcd8739ae039 = $797e4a145a4e40c7$export$9f27bc3417b4524d;

});
parcelRegister("SEaoU", function(module, exports) {

$parcel$export(module.exports, "useContainerContext", () => $753bd1908e635680$export$c7066c2d215990cf);
$parcel$export(module.exports, "ContainerContextSubscriber", () => $753bd1908e635680$export$5b87a78c45d5dd17);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $4MmfV = parcelRequire("4MmfV");
var $kXWpU = parcelRequire("kXWpU");

var $3HCkE = parcelRequire("3HCkE");

var $e8UKN = parcelRequire("e8UKN");
const $753bd1908e635680$var$useProjectContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $3HCkE.useResource)((0, $kXWpU.staticProjectSidebarNavigationResource));
    const projectContext = (0, $eUqFw.useMemo)(()=>data && (0, $e8UKN.getProjectContext)(data), [
        data
    ]);
    return [
        {
            data: projectContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $753bd1908e635680$var$useUserBoardContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $3HCkE.useResource)((0, $4MmfV.staticJSWUserBoardSidebarNavigationResource));
    const userContext = (0, $eUqFw.useMemo)(()=>data && (0, $e8UKN.getUserContext)(data), [
        data
    ]);
    return [
        {
            data: userContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $753bd1908e635680$export$c7066c2d215990cf = ()=>{
    const projectContext = $753bd1908e635680$var$useProjectContext();
    const userBoardContext = $753bd1908e635680$var$useUserBoardContext();
    if (userBoardContext && userBoardContext[0] && userBoardContext[0].data != null) return userBoardContext;
    return projectContext;
};
const $753bd1908e635680$export$5b87a78c45d5dd17 = (props)=>{
    const [data, actions] = $753bd1908e635680$export$c7066c2d215990cf();
    // @ts-expect-error - TS2345 - Argument of type '{ readonly data: ContainerContext | null; readonly error: Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null; readonly loading: boolean; }' is not assignable to parameter of type 'ContainerContextData'.
    return props.children(data, actions);
};
$753bd1908e635680$export$5b87a78c45d5dd17.displayName = 'ContainerContextSubscriber';

});
parcelRegister("4MmfV", function(module, exports) {

$parcel$export(module.exports, "staticJSWUserBoardSidebarNavigationResource", () => $ca35414721fafc7a$export$5839dd8142de842e);

var $gUUjF = parcelRequire("gUUjF");

var $3HCkE = parcelRequire("3HCkE");

var $ElVpH = parcelRequire("ElVpH");

var $9SjeY = parcelRequire("9SjeY");
const $ca35414721fafc7a$export$5839dd8142de842e = (0, $3HCkE.createResource)({
    type: 'JIRA_USER_BOARD_NAVIGATION_RESOURCE',
    getKey: ({ match: match, query: query })=>{
        const boardId = (0, $ElVpH.getBoardId)(match, query);
        return boardId ? `board-${boardId}` : 'none';
    },
    getData: async ({ match: match, query: query })=>{
        const boardId = (0, $ElVpH.getBoardId)(match, query);
        if (boardId == null) return null;
        try {
            const response = await (0, $9SjeY.fetchUserBoardNavigationData)(boardId);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('navigation-apps.resources.static-jsw-userboard-sidebar', 'Fail to fetch user board', e);
            return null;
        }
    },
    maxAge: 300000
});

});
parcelRegister("9SjeY", function(module, exports) {

$parcel$export(module.exports, "fetchUserBoardNavigationData", () => $7d7ff3f2c7ca5c69$export$306fb49fca60b34);

var $lRmyA = parcelRequire("lRmyA");
const $7d7ff3f2c7ca5c69$export$306fb49fca60b34 = (boardId)=>{
    if (boardId == null) throw new Error('invalid boardId');
    return (0, $lRmyA.performGetRequest)(`/rest/navigation/4/sidebar/people/boards/${boardId}`);
};

});


parcelRegister("e8UKN", function(module, exports) {

$parcel$export(module.exports, "getUserContext", () => $4c7bf04e2602d89a$export$114c35c2c23732ab);
$parcel$export(module.exports, "getProjectContext", () => $4c7bf04e2602d89a$export$d17fffd59c7b3c60);

var $7ZZxN = parcelRequire("7ZZxN");

var $eWsAG = parcelRequire("eWsAG");
const $4c7bf04e2602d89a$export$114c35c2c23732ab = (userBoardNavData)=>{
    const { boardInfo: boardInfo, owner: owner } = userBoardNavData;
    return {
        contextType: 'user',
        user: {
            id: owner.id,
            name: owner.name,
            avatarUrl: owner.avatarUrl,
            profileUrl: owner.profileUrl,
            accountId: owner.accountId
        },
        scope: {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        }
    };
};
const $4c7bf04e2602d89a$var$getScope = (projectNavInfo)=>{
    if (projectNavInfo.projectType === 'jira_software' && projectNavInfo?.jiraSoftwareNavData?.boardInfo) {
        const { boardInfo: boardInfo } = projectNavInfo.jiraSoftwareNavData;
        return {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        };
    }
    return undefined;
};
const $4c7bf04e2602d89a$var$getProjectType = (projectType)=>{
    switch(projectType){
        case 'business':
            return 0, $7ZZxN.CORE_PROJECT;
        case 'software':
            return 0, $7ZZxN.SOFTWARE_PROJECT;
        case 'service_desk':
            return 0, $7ZZxN.SERVICE_DESK_PROJECT;
        case 'product_discovery':
            return 0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT;
        default:
            return null;
    }
};
const $4c7bf04e2602d89a$export$d17fffd59c7b3c60 = (projectNavInfo)=>{
    const project = (0, $eWsAG.extractData)(projectNavInfo);
    const scope = $4c7bf04e2602d89a$var$getScope(projectNavInfo);
    if (project) {
        const projectType = $4c7bf04e2602d89a$var$getProjectType(project.type);
        if (projectType) return {
            contextType: 'project',
            project: {
                key: project.key,
                // @ts-expect-error TS2322: Type 'number' is not assignable to type 'string'
                id: project.id,
                name: project.name,
                type: projectType,
                isSimplified: project.isSimplified,
                avatarUrl: project.avatarUrl,
                style: (0, $eWsAG.getStyle)(project.isSimplified)
            },
            scope: scope
        };
    }
    return null;
};

});




parcelRegister("l02Yw", function(module, exports) {

$parcel$export(module.exports, "default", () => $01f727a32ba5bcb5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $gUUjF = parcelRequire("gUUjF");

var $c76ap = parcelRequire("c76ap");
const $01f727a32ba5bcb5$var$LOCATION = 'breadcrumbs.legacy-adapter.legacy-renderer';
class $01f727a32ba5bcb5$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    componentDidCatch(error) {
        /*
            This error boundary is added to adapt to a runtime error caused by createPortal method in IE 11
        */ const { targetElement: targetElement } = this.props;
        const targetId = targetElement ? targetElement.id : 'not-found';
        (0, $gUUjF.default).safeErrorWithoutCustomerData($01f727a32ba5bcb5$var$LOCATION, `Failed to createPortal on ${targetId}`, error);
    }
    render() {
        const { targetElement: targetElement } = this.props;
        return /*#__PURE__*/ (0, $lEfVV.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c76ap.default), null), targetElement);
    }
}

});
parcelRegister("c76ap", function(module, exports) {

$parcel$export(module.exports, "default", () => $157232e24a15a7c6$export$2e2bcd8739ae039);

var $2Enn0 = parcelRequire("2Enn0");

var $knPb9 = parcelRequire("knPb9");

var $gd0Sp = parcelRequire("gd0Sp");

var $7Eg4C = parcelRequire("7Eg4C");
const $157232e24a15a7c6$var$fireAnalytics = (analyticsEvent)=>(0, $2Enn0.fireOperationalAnalytics)(analyticsEvent, {
        name: 'breadcrumbRendererMounted'
    });
var $157232e24a15a7c6$export$2e2bcd8739ae039 = (0, $knPb9.default)((0, $7Eg4C.default), {
    onMount: $157232e24a15a7c6$var$fireAnalytics,
    TenantContextSubscriber: $gd0Sp.TenantContextSubscriber
});

});
parcelRegister("7Eg4C", function(module, exports) {

$parcel$export(module.exports, "default", () => $c269d0ea4cb311cb$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $eGI9v = parcelRequire("eGI9v");

var $6RcYY = parcelRequire("6RcYY");

var $bfY8R = parcelRequire("bfY8R");
// Adapt to prop type from breadcrumbs app
const $c269d0ea4cb311cb$var$mapTrailToBreadcrumbItems = (trail)=>trail.map((crumb)=>({
            ...crumb,
            target: crumb.target || '_self'
        }));
const $c269d0ea4cb311cb$var$BreadcrumbRenderer = ({ onMount: onMount })=>{
    const [{ trail: trail }] = (0, $bfY8R.useBreadcrumbs)();
    const items = (0, $eUqFw.useMemo)(()=>$c269d0ea4cb311cb$var$mapTrailToBreadcrumbItems(trail), [
        trail
    ]);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eUqFw.useEffect)(onMount, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c269d0ea4cb311cb$var$BreadcrumbsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6RcYY.default), {
        isVisible: true,
        items: items
    }));
};
var $c269d0ea4cb311cb$export$2e2bcd8739ae039 = (0, $eGI9v.default)('breadcrumbsRenderer', {
    onMount: 'mounted'
})($c269d0ea4cb311cb$var$BreadcrumbRenderer);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c269d0ea4cb311cb$var$BreadcrumbsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1tke1tcg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6RcYY", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4d601e3e8e4661b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5BRby = parcelRequire("5BRby");

var $5mQsA = parcelRequire("5mQsA");
function $f4d601e3e8e4661b$export$2e2bcd8739ae039(props) {
    const { isVisible: isVisible, items: items } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5mQsA.default), {
        isVisible: isVisible,
        items: items
    }));
}

});
parcelRegister("5mQsA", function(module, exports) {

$parcel$export(module.exports, "default", () => $267add675722c51f$export$2e2bcd8739ae039);

var $hNmmb = parcelRequire("hNmmb");
var $267add675722c51f$export$2e2bcd8739ae039 = (0, $hNmmb.default);

});
parcelRegister("hNmmb", function(module, exports) {

$parcel$export(module.exports, "default", () => $dce70756fb908cd7$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $8blac = parcelRequire("8blac");

var $jG2Eu = parcelRequire("jG2Eu");

var $bm5l8 = parcelRequire("bm5l8");
var $asKFY = parcelRequire("asKFY");

var $kJlBc = parcelRequire("kJlBc");

var $6zYPn = parcelRequire("6zYPn");
const $dce70756fb908cd7$export$67abef37aa2929b0 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Link), {
        ...props,
        ref: ref,
        type: "a"
    }));
function $dce70756fb908cd7$export$2e2bcd8739ae039(props) {
    const { isVisible: isVisible, items: items } = props;
    return isVisible ? // onExpand is required prop in atlaskit's breadcrumbitem component
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $asKFY.default), {
        onExpand: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(items) ? // This is needed in order to render an empty breadcrumb for SSR, to avoid visual jumping when javascript kicks in.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bm5l8.default), {
        text: ""
    }) : items.map((breadcrumb, index)=>{
        const breadcrumbItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zYPn.default), {
            key: index,
            index: index,
            hasSeparator: true,
            text: breadcrumb.text,
            target: __SPA__ ? undefined : breadcrumb.target,
            href: breadcrumb.href,
            component: __SPA__ ? $dce70756fb908cd7$export$67abef37aa2929b0 : undefined,
            legacyId: breadcrumb.legacyId,
            type: breadcrumb.type,
            analyticsAttributes: breadcrumb.analyticsAttributes,
            analyticsFields: breadcrumb.analyticsFields
        });
        return breadcrumbItem;
    }))) : null;
}

});
parcelRegister("bm5l8", function(module, exports) {

$parcel$export(module.exports, "default", () => $6802065d7b1f5207$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $7rh0R = parcelRequire("7rh0R");

var $XHGTv = parcelRequire("XHGTv");

var $8cU5f = parcelRequire("8cU5f");

var $5eukW = parcelRequire("5eukW");

var $fwtof = parcelRequire("fwtof");
function $6802065d7b1f5207$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

const $6802065d7b1f5207$var$AKTooltip = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("18Hlr")), {
    ssr: false,
    moduleId: "../platform/packages/design-system/tooltip/src/index.ts"
});
const $6802065d7b1f5207$var$itemWrapperStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    boxSizing: 'border-box',
    maxWidth: '100%',
    height: `${24 / 14}em`,
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    flexDirection: 'row',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:not(:last-child)::after': {
        width: '8px',
        flexShrink: 0,
        content: '"/"',
        paddingBlock: "var(--ds-space-025, 2px)",
        paddingInline: "var(--ds-space-100, 8px)",
        textAlign: 'center'
    }
});
const $6802065d7b1f5207$var$VAR_STEP_TRUNCATION_WIDTH = '--max-width';
const $6802065d7b1f5207$var$ICON_WIDTH_ESTIMATE = 24;
const $6802065d7b1f5207$var$staticItemStyles = {
    name: "16sxe12",
    styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);padding-block:var(--ds-space-025, 2px)"
};
const $6802065d7b1f5207$var$staticItemWithTruncationStyles = /*#__PURE__*/ (0, $byn9U.css)({
    maxWidth: `var(${$6802065d7b1f5207$var$VAR_STEP_TRUNCATION_WIDTH})`
});
const $6802065d7b1f5207$var$staticItemWithoutTruncationStyles = {
    name: "1t1nv0p",
    styles: "min-width:0;flex-shrink:1"
};
const $6802065d7b1f5207$var$BreadcrumbsItem = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>{
    const buttonRef = (0, $eUqFw.useRef)(null);
    const { truncationWidth: truncationWidth, text: text, onTooltipShown: onTooltipShown, ...restButtonProps } = props;
    // If icons are provided we include their width in the truncation calculation to ensure we're as accurate as possible.
    // Note: this assumes icons are 24px wide which should be almost always.
    // Not really an issue if the icons are smaller, just that truncation occurs slightly earlier than you may want.
    let iconWidthAllowance = 0;
    if (props.iconBefore) iconWidthAllowance += $6802065d7b1f5207$var$ICON_WIDTH_ESTIMATE;
    if (props.iconAfter) iconWidthAllowance += $6802065d7b1f5207$var$ICON_WIDTH_ESTIMATE;
    const [hasOverflow, showTooltip] = (0, $fwtof.default)(truncationWidth, buttonRef.current, iconWidthAllowance);
    const buttonProps = {
        ...restButtonProps,
        ref: buttonRef,
        hasOverflow: hasOverflow
    };
    // Note: cast to `any` is required to type verification - see https://github.com/frenic/csstype#what-should-i-do-when-i-get-type-errors
    const dynamicItemStyles = {
        [$6802065d7b1f5207$var$VAR_STEP_TRUNCATION_WIDTH]: typeof truncationWidth !== 'undefined' && `${truncationWidth}px`
    };
    const step = truncationWidth ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $5eukW.default), {
        ...buttonProps,
        css: [
            $6802065d7b1f5207$var$staticItemStyles,
            $6802065d7b1f5207$var$staticItemWithTruncationStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: dynamicItemStyles
    }, text) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $5eukW.default), {
        ...buttonProps,
        css: [
            $6802065d7b1f5207$var$staticItemStyles,
            $6802065d7b1f5207$var$staticItemWithoutTruncationStyles
        ]
    }, text);
    if ((0, $XHGTv.getBooleanFF)('platform.design-system-team.remove-lazy-loading-of-tooltip-in-breadcrumbs_pki8p')) return /*#__PURE__*/ (0, $byn9U.jsx)("li", {
        css: $6802065d7b1f5207$var$itemWrapperStyles
    }, showTooltip ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cU5f.default), {
        content: text,
        position: "bottom",
        onShow: onTooltipShown
    }, step) : step);
    return /*#__PURE__*/ (0, $byn9U.jsx)("li", {
        css: $6802065d7b1f5207$var$itemWrapperStyles
    }, showTooltip ? /* The div exists because of tooltip */ /*#__PURE__*/ (0, $byn9U.jsx)((0, $7rh0R.LazySuspense), {
        fallback: /*#__PURE__*/ (0, $byn9U.jsx)("div", null, step)
    }, /*#__PURE__*/ (0, $byn9U.jsx)($6802065d7b1f5207$var$AKTooltip, {
        content: text,
        position: "bottom",
        onShow: onTooltipShown
    }, step)) : step);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6802065d7b1f5207$export$2e2bcd8739ae039 = $6802065d7b1f5207$var$BreadcrumbsItem;

});
parcelRegister("5eukW", function(module, exports) {

$parcel$export(module.exports, "default", () => $69c4b1ea675a45cb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lUFyV = parcelRequire("lUFyV");

var $7u4fN = parcelRequire("7u4fN");

var $5Q9wj = parcelRequire("5Q9wj");
const $69c4b1ea675a45cb$var$analyticsAttributes = {
    componentName: 'breadcrumbsItem',
    packageName: undefined,
    packageVersion: undefined
};
const $69c4b1ea675a45cb$var$noop = (0, $5Q9wj.default);
var $69c4b1ea675a45cb$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(({ hasOverflow: hasOverflow = true, href: href = '#', onClick: onClickProvided = $69c4b1ea675a45cb$var$noop, analyticsContext: analyticsContext, iconBefore: iconBefore, iconAfter: iconAfter, ...props }, ref)=>{
    const handleClicked = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onClickProvided,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$69c4b1ea675a45cb$var$analyticsAttributes
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle-link",
        spacing: "none",
        iconAfter: hasOverflow ? undefined : iconAfter,
        iconBefore: hasOverflow ? undefined : iconBefore,
        onClick: handleClicked,
        ref: ref,
        href: href,
        ...props
    });
});

});

parcelRegister("fwtof", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae4167537c909a75$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $ae4167537c909a75$export$2e2bcd8739ae039(truncationWidth, buttonRefCurrent, iconWidthAllowance) {
    // Default to true to match hasOverflow = true default in Step component.
    // This should ensure the icon never appears and then quickly disappears
    const [hasOverflow, setOverflow] = (0, $eUqFw.useState)(true);
    const [showTooltip, setShowTooltip] = (0, $eUqFw.useState)(false);
    // Need to recalculate on every render cycle as text/icons/width changing will change the outcome
    (0, $eUqFw.useEffect)(()=>{
        if (truncationWidth && buttonRefCurrent) {
            // Calculate if the button width will be larger than the truncation width after allowing for icon widths.
            // The button having a width greater than the truncationWidth, with icons, indicates the icons should be hidden to avoid going over the width limit
            const shouldOverflow = buttonRefCurrent.clientWidth + iconWidthAllowance > truncationWidth;
            // The button width can already be equal to the truncationWidth which is an indicator that truncation is occurring and a tooltip should be displayed
            const shouldShowTooltip = buttonRefCurrent.clientWidth + iconWidthAllowance >= truncationWidth;
            setOverflow(shouldOverflow);
            setShowTooltip(shouldShowTooltip);
        } else {
            setOverflow(false);
            setShowTooltip(false);
        }
    }, [
        truncationWidth,
        buttonRefCurrent,
        iconWidthAllowance
    ]);
    return [
        hasOverflow,
        showTooltip
    ];
}

});

parcelRegister("18Hlr", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('d9TBY');
        const value = parcelRequire('fxbL4');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("d9TBY").then(()=>parcelRequire('fxbL4'));
}

});


parcelRegister("asKFY", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fe49be245af1af9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $1lQG9 = parcelRequire("1lQG9");

var $5Q9wj = parcelRequire("5Q9wj");

var $PdmhA = parcelRequire("PdmhA");

var $1xCDT = parcelRequire("1xCDT");

var $f8Yph = parcelRequire("f8Yph");
function $5fe49be245af1af9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5fe49be245af1af9$var$defaultMaxItems = 8;
const $5fe49be245af1af9$var$defaultBreadcrumbsLabel = 'Breadcrumbs';
const $5fe49be245af1af9$var$defaultEllipsisLabel = 'Show more breadcrumbs';
const { toArray: $5fe49be245af1af9$var$toArray } = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children;
const $5fe49be245af1af9$var$analyticsAttributes = {
    componentName: 'breadcrumbs',
    packageName: undefined,
    packageVersion: undefined
};
const $5fe49be245af1af9$var$noop = (0, $5Q9wj.default);
const $5fe49be245af1af9$var$interactiveElementSelector = 'a, button, [tabindex]:not([tabindex="-1"])';
const $5fe49be245af1af9$var$breadcrumbStyles = {
    name: "m6vsls",
    styles: "display:flex;margin:var(--ds-space-0, 0px);padding:var(--ds-space-0, 0px);flex-wrap:wrap"
};
const $5fe49be245af1af9$var$InnerBreadcrumbs = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { defaultExpanded: defaultExpanded = false, isExpanded: isExpanded, isNavigation: isNavigation = true, maxItems: maxItems = $5fe49be245af1af9$var$defaultMaxItems, itemsBeforeCollapse: itemsBeforeCollapse = 1, itemsAfterCollapse: itemsAfterCollapse = 1, children: children = [], testId: testId, onExpand: providedExpanse = $5fe49be245af1af9$var$noop, analyticsContext: analyticsContext, label: label = $5fe49be245af1af9$var$defaultBreadcrumbsLabel, ellipsisLabel: ellipsisLabel = $5fe49be245af1af9$var$defaultEllipsisLabel } = props;
    const [expanded, setExpanse] = (0, $eUqFw.useState)(defaultExpanded);
    const [isClickedBySpace, setExpansionTrigger] = (0, $eUqFw.useState)(false);
    const wrapperRef = (0, $eUqFw.useRef)(null);
    const isControlled = typeof isExpanded !== 'undefined';
    const isExpansionHandled = providedExpanse !== $5fe49be245af1af9$var$noop;
    const shouldExpand = isControlled ? isExpanded : expanded;
    const focusFirstRevealed = ()=>{
        if (wrapperRef.current) {
            const listItems = Array.from(wrapperRef.current.querySelectorAll('li'));
            const interactiveElements = listItems.map((li)=>li.querySelector($5fe49be245af1af9$var$interactiveElementSelector));
            const elementToFocus = interactiveElements[itemsBeforeCollapse];
            const firstInteractiveElement = interactiveElements[0];
            if (elementToFocus) elementToFocus.focus && elementToFocus.focus();
            else if (firstInteractiveElement) firstInteractiveElement.focus && firstInteractiveElement.focus();
            else wrapperRef.current.focus();
        }
        setExpansionTrigger(false);
    };
    (0, $f8Yph.useOnRevealed)(focusFirstRevealed, {
        isExpanded: shouldExpand,
        isDisabled: !isClickedBySpace
    });
    const handleExpansion = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isControlled) setExpanse((expanded)=>!expanded);
            if (isExpansionHandled && isControlled || !isControlled) setExpansionTrigger(event.target === document.activeElement);
            return providedExpanse(event, analyticsEvent);
        },
        action: 'expanded',
        analyticsData: analyticsContext,
        ...$5fe49be245af1af9$var$analyticsAttributes
    });
    const childrenArray = $5fe49be245af1af9$var$toArray(children);
    const breadcrumbsArray = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.map(childrenArray, (child, index)=>{
        //To avoid error if child is a string
        if (typeof child === 'string') return child;
        return childrenArray.length - 1 === index ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(child, {
            'aria-current': 'page'
        }) : child;
    });
    const renderItemsWithEllipsis = ()=>{
        const allItems = breadcrumbsArray;
        // This defends against someone passing weird data, to ensure that if all
        // items would be shown anyway, we just show all items without the EllipsisItem
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        const beforeItems = allItems.slice(0, itemsBeforeCollapse);
        const afterItems = allItems.slice(allItems.length - itemsAfterCollapse, allItems.length);
        return [
            ...beforeItems,
            /*#__PURE__*/ (0, $byn9U.jsx)((0, $1xCDT.default), {
                key: "ellipsis",
                testId: testId && `${testId}--breadcrumb-ellipsis`,
                onClick: handleExpansion,
                label: ellipsisLabel
            }),
            ...afterItems
        ];
    };
    const shouldDisplayItems = shouldExpand || maxItems && breadcrumbsArray.length <= maxItems;
    const breadcrumbsItems = shouldDisplayItems ? breadcrumbsArray : renderItemsWithEllipsis();
    const Component = isNavigation ? 'nav' : 'div';
    return /*#__PURE__*/ (0, $byn9U.jsx)(Component, {
        "aria-label": label,
        ref: (0, $1lQG9.default)([
            ref,
            wrapperRef
        ]),
        tabIndex: -1
    }, /*#__PURE__*/ (0, $byn9U.jsx)("ol", {
        "data-testid": testId,
        css: $5fe49be245af1af9$var$breadcrumbStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            color: `var(--ds-text-subtlest, ${(0, $PdmhA.N200)})`
        }
    }, breadcrumbsItems));
});
const $5fe49be245af1af9$var$Breadcrumbs = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)($5fe49be245af1af9$var$InnerBreadcrumbs, {
        ...props,
        ref: ref
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5fe49be245af1af9$export$2e2bcd8739ae039 = $5fe49be245af1af9$var$Breadcrumbs;

});
parcelRegister("1xCDT", function(module, exports) {

$parcel$export(module.exports, "default", () => $253eb3de3ba0dc58$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $7u4fN = parcelRequire("7u4fN");

var $5Q9wj = parcelRequire("5Q9wj");
function $253eb3de3ba0dc58$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $253eb3de3ba0dc58$var$noop = (0, $5Q9wj.default);
const $253eb3de3ba0dc58$var$itemWrapperStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    boxSizing: 'border-box',
    maxWidth: '100%',
    height: `${24 / 14}em`,
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    flexDirection: 'row',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:not(:last-child)::after': {
        width: "var(--ds-space-100, 8px)",
        flexShrink: 0,
        content: '"/"',
        paddingBlock: "var(--ds-space-025, 2px)",
        paddingInline: "var(--ds-space-100, 8px)",
        textAlign: 'center'
    }
});
const $253eb3de3ba0dc58$var$staticItemStyles = {
    name: "16sxe12",
    styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);padding-block:var(--ds-space-025, 2px)"
};
const $253eb3de3ba0dc58$var$EllipsisItem = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>{
    const { onClick: onClick = $253eb3de3ba0dc58$var$noop, testId: testId, label: label } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("li", {
        css: $253eb3de3ba0dc58$var$itemWrapperStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $7u4fN.default), {
        appearance: "subtle-link",
        spacing: "none",
        testId: testId,
        onClick: onClick,
        "aria-label": label,
        css: $253eb3de3ba0dc58$var$staticItemStyles
    }, "\u2026"));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$253eb3de3ba0dc58$export$2e2bcd8739ae039 = $253eb3de3ba0dc58$var$EllipsisItem;

});

parcelRegister("f8Yph", function(module, exports) {

$parcel$export(module.exports, "useOnRevealed", () => $3d09583e8ce00568$export$e9c4922b2ecf808a);

var $eUqFw = parcelRequire("eUqFw");

var $d7Ieg = parcelRequire("d7Ieg");
function $3d09583e8ce00568$export$e9c4922b2ecf808a(callback, { isExpanded: isExpanded, isDisabled: isDisabled }) {
    const prevExtended = (0, $d7Ieg.default)(isExpanded);
    (0, $eUqFw.useEffect)(()=>{
        const hasBeenRevealed = !prevExtended && isExpanded;
        if (!isDisabled && hasBeenRevealed) callback();
    }, [
        isExpanded,
        isDisabled,
        callback,
        prevExtended
    ]);
}

});


parcelRegister("6zYPn", function(module, exports) {

$parcel$export(module.exports, "default", () => $0627b3ff4acd1074$export$2e2bcd8739ae039);

var $5ivsr = parcelRequire("5ivsr");
var $0627b3ff4acd1074$export$2e2bcd8739ae039 = (0, $5ivsr.default);

});
parcelRegister("5ivsr", function(module, exports) {

$parcel$export(module.exports, "default", () => $a590e2f2ad7c58d3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bm5l8 = parcelRequire("bm5l8");

var $iMMQz = parcelRequire("iMMQz");
class $a590e2f2ad7c58d3$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            href: undefined,
            legacyId: undefined,
            type: 'unspecified',
            analyticsAttributes: {},
            analyticsFields: {}
        };
    }
    render() {
        const { index: index, text: text, target: target, href: href, component: component } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bm5l8.default), {
            key: index,
            text: text,
            // @ts-expect-error - TS2322 - Type '(event: Event, analyticsEvent: UIAnalyticsEventInterface) => void' is not assignable to type '(event: MouseEvent<Element, MouseEvent>) => void'.
            onClick: this.onBreadCrumbClick,
            target: target,
            href: href,
            component: component
        });
    }
    constructor(...args){
        super(...args);
        this.onBreadCrumbClick = (event, analyticsEvent)=>{
            const { legacyId: legacyId, index: index, type: type, analyticsAttributes: analyticsAttributes, analyticsFields: analyticsFields } = this.props;
            (0, $iMMQz.fireUiAnalytics)(analyticsEvent, {
                name: '',
                attributes: {
                    legacyId: legacyId,
                    // change this depth value to be zero based, once Jira home crumb is added
                    depth: index + 1,
                    type: type,
                    ...analyticsAttributes
                },
                ...analyticsFields
            });
        };
    }
}

});
parcelRegister("iMMQz", function(module, exports) {

$parcel$export(module.exports, "fireUiAnalytics", () => $087b448d474fca07$export$4909253b5bf1eed7);

var $3LiTJ = parcelRequire("3LiTJ");

var $etqm0 = parcelRequire("etqm0");

var $klunD = parcelRequire("klunD");
// @ts-expect-error - TS7006 - Parameter 'a' implicitly has an 'any' type.
const $087b448d474fca07$var$isNotUndefined = (a)=>a !== undefined;
const $087b448d474fca07$var$mapPayload = (payload)=>{
    const context = (0, $klunD.default)(payload);
    const { name: name } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($3LiTJ)))({
        ...context,
        ...context.attributes,
        attributes: undefined,
        name: name
    }, $087b448d474fca07$var$isNotUndefined);
};
const $087b448d474fca07$export$4909253b5bf1eed7 = (event, payload)=>{
    event.update({
        ...$087b448d474fca07$var$mapPayload(payload),
        analyticsType: (0, $etqm0.UI_EVENT_TYPE)
    }).fire();
};

});









parcelRegister("jU94X", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fec23ecbb70be91$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $1fec23ecbb70be91$var$compareBreadcrumbs = (a, b)=>a.index - b.index;
const $1fec23ecbb70be91$var$defaultInitialState = {
    trail: [],
    targetElement: null
};
class $1fec23ecbb70be91$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            initialState: $1fec23ecbb70be91$var$defaultInitialState
        };
    }
    constructor(props){
        super(props);
        this.onInsertItem = (item)=>{
            this.setState((state)=>({
                    trail: [
                        ...state.trail,
                        item
                    ].sort($1fec23ecbb70be91$var$compareBreadcrumbs)
                }));
        };
        this.onRemoveItem = (id)=>{
            this.setState((state)=>({
                    trail: state.trail.filter((b)=>b.id !== id)
                }));
        };
        /* eslint-disable react/no-unused-state */ this.onTargetSet = (targetElement)=>{
            this.setState({
                targetElement: targetElement
            });
        };
        /* eslint-enable react/no-unused-state */ this.api = {
            setTargetElement: this.onTargetSet,
            insertItem: this.onInsertItem,
            removeItem: this.onRemoveItem
        };
        this.state = props.initialState;
    }
    render() {
        const { children: children } = this.props;
        return children({
            state: this.state,
            api: this.api
        });
    }
}

});



parcelRegister("6Q9xY", function(module, exports) {

$parcel$export(module.exports, "LoadingPhaseManager", () => $00e2f5c25335239e$export$6e4bfef9e80c7eb0);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $epT40 = parcelRequire("epT40");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $00e2f5c25335239e$export$6e4bfef9e80c7eb0 = ()=>{
    const [{ hasLoaded: hasLoaded }] = (0, $epT40.default)();
    const { resetPhase: resetPhase, startNextPhase: startNextPhase } = (0, $7rh0R.useLazyPhase)();
    (0, $eUqFw.useEffect)(()=>{
        if (hasLoaded) {
            performance.mark('rll-after-paint-phase');
            startNextPhase();
        } else resetPhase();
    }, [
        hasLoaded,
        resetPhase,
        startNextPhase
    ]);
    return null;
};

});

parcelRegister("egQj9", function(module, exports) {

$parcel$export(module.exports, "TrackClicksBeforeTTI", () => $8480cc5e657aa91b$export$2846c12b8c092470);

var $eUqFw = parcelRequire("eUqFw");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $h3mHU = parcelRequire("h3mHU");
const $8480cc5e657aa91b$var$cleanUrl = (pathname)=>{
    let url = pathname.replace(/\/$/, '');
    // /browse redirects or sw classic redirects
    if (/\/browse\/\w+$/.test(url)) url = 'browse';
    // replaces any occurrence of two or more capital letters,
    // or one capital letter followed by a number and also
    // two or more capital letters followed by a dash and any amount of numbers
    // (should catch all project and issue keys)
    if (/[A-Z][A-Z0-9]+(-[\d]+)*/g.test(url)) url = url.replace(/[A-Z][A-Z0-9]+(-[\d]+)*/g, 'XX');
    return url;
};
/**
 * Handles the collection and processing of user interactions that occur before the page becomes fully interactive. This enhances the understanding of user behavior during the initial loading phase.
 */ const $8480cc5e657aa91b$export$2846c12b8c092470 = ()=>{
    const [{ isReady: isReady }] = (0, $h3mHU.useSpaStatePageReady)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        if (!isReady) return;
        try {
            const sessionStorageItems = sessionStorage.getItem('clicks-before-tti');
            if (sessionStorageItems == null || sessionStorageItems === '') return;
            const items = JSON.parse(sessionStorageItems);
            items.forEach((item)=>{
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                let extras = {
                    elementId: item.dataId,
                    currentUrl: $8480cc5e657aa91b$var$cleanUrl(item.currentUrl),
                    bundleId: item.bundleId,
                    time: item.time
                };
                if (item.redirectUrl !== '') extras = {
                    ...extras,
                    redirectUrl: $8480cc5e657aa91b$var$cleanUrl(item.redirectUrl)
                };
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({
                    action: 'clicked'
                }), 'nonInteractiveElement clicked', '', extras);
            });
            sessionStorage.removeItem('clicks-before-tti');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
        }
    }, [
        createAnalyticsEvent,
        isReady
    ]);
    return null;
};

});

parcelRegister("aHKm3", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('hPzOn'),
            load('aCUnj')
        ]);
        const value = parcelRequire('es1Wq');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("hPzOn"),
        load("aCUnj")
    ]).then(()=>parcelRequire('es1Wq'));
}

});

parcelRegister("eHaUV", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('fV06J');
        const value = parcelRequire('ePK6n');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("fV06J").then(()=>parcelRequire('ePK6n'));
}

});

parcelRegister("cBhvG", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hwGR4');
        const value = parcelRequire('l6iDs');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hwGR4").then(()=>parcelRequire('l6iDs'));
}

});

parcelRegister("lx7fQ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('1QTcH');
        const value = parcelRequire('4y252');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("1QTcH").then(()=>parcelRequire('4y252'));
}

});

parcelRegister("1lcdx", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('jZhM1');
        const value = parcelRequire('lG0uN');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("jZhM1").then(()=>parcelRequire('lG0uN'));
}

});

parcelRegister("ac8TH", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('fAZBS');
        const value = parcelRequire('1r7p7');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("fAZBS").then(()=>parcelRequire('1r7p7'));
}

});


parcelRegister("69Ipc", function(module, exports) {

$parcel$export(module.exports, "Banner", () => $bc08f35853510f48$export$3b4e64e77073e307);

var $eUqFw = parcelRequire("eUqFw");

var $c9TLT = parcelRequire("c9TLT");

var $6e8MH = parcelRequire("6e8MH");

var $1ybV0 = parcelRequire("1ybV0");

var $bAQOb = parcelRequire("bAQOb");

var $4IEye = parcelRequire("4IEye");
var $4Txs1 = parcelRequire("4Txs1");

var $1GeZ8 = parcelRequire("1GeZ8");

var $ksulR = parcelRequire("ksulR");

var $7Rdn2 = parcelRequire("7Rdn2");
var $NzrZv = parcelRequire("NzrZv");

var $bFh4f = parcelRequire("bFh4f");
var $imSzy = parcelRequire("imSzy");

var $j3cff = parcelRequire("j3cff");
var $8fKcN = parcelRequire("8fKcN");

var $bBqV2 = parcelRequire("bBqV2");
var $4E80X = parcelRequire("4E80X");

var $jK1pm = parcelRequire("jK1pm");

var $3EdDr = parcelRequire("3EdDr");
const $bc08f35853510f48$export$496ffd8dda3bf451 = ()=>{
    const banner = (0, $ksulR.useBanner)();
    return banner.isEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "banner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1GeZ8.Banner), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bc08f35853510f48$var$BannerContent, {
        bannerName: banner.name
    }))) : null;
};
const $bc08f35853510f48$export$b5cfff585ada92ce = ()=>{
    const banner = (0, $ksulR.useBanner)();
    return banner.isEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "banner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3EdDr.ZIndexWrapper), {
        zIndex: (0, $c9TLT.layers).banner
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1GeZ8.Banner), {
        height: banner.height
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bc08f35853510f48$var$BannerContent, {
        bannerName: banner.name
    })))) : null;
};
const $bc08f35853510f48$var$BannerContent = ({ bannerName: bannerName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, bannerName === (0, $NzrZv.NAME) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Rdn2.BannerAnnouncementAsync), null), bannerName === (0, $4IEye.BANNER_NAME) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Txs1.IPBlocklistingBannerAsync), null), bannerName === (0, $bBqV2.BANNER_NAME) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4E80X.ReturnToMobileBanner), null), (0, $1ybV0.ff)('platform.moonjelly.browser-storage-controls') && bannerName === (0, $539c74e86514eccc$export$41956b146268af93) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6e8MH.CookieConsentBannerAsync), null), (0, $1ybV0.ff)('opsgenie-consolidation-transitioning-state_d7vm9') && bannerName === (0, $bFh4f.BANNER_NAME) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $imSzy.BannerTransitionAsync), null), (0, $1ybV0.ff)('jira-banner-for-incoming-mail-expiry-notification_y2w1w') && bannerName === (0, $j3cff.BANNER_NAME) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fKcN.MailExpiryBannerAsync), null));
const $bc08f35853510f48$export$3b4e64e77073e307 = (0, $bAQOb.componentWithFF)('platform.atlassian.griffin-new-page-layout', $bc08f35853510f48$export$496ffd8dda3bf451, $bc08f35853510f48$export$b5cfff585ada92ce);

});
const $539c74e86514eccc$export$41956b146268af93 = 'COOKIE_CONSENT_BANNER';
const $539c74e86514eccc$export$ed7cc0d417ee89e = 74;
const $539c74e86514eccc$export$ff6e18f7d82b549c = 320;

parcelRegister("6e8MH", function(module, exports) {

$parcel$export(module.exports, "CookieConsentBannerAsync", () => $6ae4df6ce003b8ba$export$f110a9cbbbd3fa3a);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $6ae4df6ce003b8ba$var$LazyCookieConsentBanner = (0, $7rh0R.lazy)(()=>(parcelRequire("kyhwy")).then(({ CookieConsentBanner: CookieConsentBanner })=>CookieConsentBanner), {
    moduleId: "./src/packages/platform/ui/banners/cookie-consent/src/ui/banner/index.tsx"
});
const $6ae4df6ce003b8ba$export$f110a9cbbbd3fa3a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $6ae4df6ce003b8ba$var$boxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-cookie-consent-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ae4df6ce003b8ba$var$LazyCookieConsentBanner, null)));
const $6ae4df6ce003b8ba$var$boxStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'elevation.surface.sunken',
    height: '100%'
});

});
parcelRegister("kyhwy", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('kL0QP')
        ]);
        const value = parcelRequire('lEX9v');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("kL0QP")
    ]).then(()=>parcelRequire('lEX9v'));
}

});


parcelRegister("4IEye", function(module, exports) {

$parcel$export(module.exports, "bannerHeight", () => $fcd3ab7edefdaf4a$export$86047f02632f9f5b);
$parcel$export(module.exports, "BANNER_NAME", () => $fcd3ab7edefdaf4a$export$41956b146268af93);
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles

var $c9TLT = parcelRequire("c9TLT");
const $fcd3ab7edefdaf4a$export$86047f02632f9f5b = (0, $c9TLT.gridSize) * 7;
const $fcd3ab7edefdaf4a$export$41956b146268af93 = 'IP_BLOCK_LISTING_BANNER';

});

parcelRegister("4Txs1", function(module, exports) {

$parcel$export(module.exports, "IPBlocklistingBannerAsync", () => $2ebc627ad20df82b$export$fafc306b802ab39d);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ebc627ad20df82b$var$IPBlocklistingBannerComp = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("bX7bL")).then((m)=>m.IPBlocklistingBanner), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/ip-block-listing-banner/src/main.tsx"
});
const $2ebc627ad20df82b$export$fafc306b802ab39d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-ip-block-listing-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ebc627ad20df82b$var$IPBlocklistingBannerComp, null));

});
parcelRegister("bX7bL", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('dHXbi');
        const value = parcelRequire('4hBj3');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("dHXbi").then(()=>parcelRequire('4hBj3'));
}

});


parcelRegister("ksulR", function(module, exports) {

$parcel$export(module.exports, "useBanner", () => $1c81254a40e33e49$export$de40f69ba30f2376);

var $eUqFw = parcelRequire("eUqFw");

var $N5dQV = parcelRequire("N5dQV");

var $1ybV0 = parcelRequire("1ybV0");

var $dFuN9 = parcelRequire("dFuN9");

var $4u3Wx = parcelRequire("4u3Wx");

var $4kPIV = parcelRequire("4kPIV");

var $itibb = parcelRequire("itibb");

var $9lf1N = parcelRequire("9lf1N");

var $8NAHO = parcelRequire("8NAHO");
const $1c81254a40e33e49$var$noBanner = {
    name: null,
    height: 0,
    isEnabled: false
};
const $1c81254a40e33e49$export$de40f69ba30f2376 = ()=>{
    const [isChromeless] = (0, $4u3Wx.useIsChromeless)();
    const announcement = (0, $4kPIV.useBannerAnnouncement)();
    const transition = (0, $1ybV0.ff)('opsgenie-consolidation-transitioning-state_d7vm9') ? (0, $itibb.useBannerEocTransition)() : undefined;
    const returnToMobile = (0, $8NAHO.useBannerReturnToMobile)();
    const IPBlocklisting = (0, $dFuN9.useBannerIPBlocklisting)();
    const cookieConsent = (0, $1ybV0.ff)('platform.moonjelly.browser-storage-controls') // eslint-disable-next-line react-hooks/rules-of-hooks
     ? (0, $N5dQV.useBannerCookieConsent)() : undefined;
    const mailExpiry = (0, $1ybV0.ff)('jira-banner-for-incoming-mail-expiry-notification_y2w1w') // eslint-disable-next-line react-hooks/rules-of-hooks
     ? (0, $9lf1N.useBannerMailExpiry)() : undefined;
    return (0, $eUqFw.useMemo)(()=>{
        // cookie consent banner has the highest priority
        if (cookieConsent?.isEnabled) return cookieConsent;
        if (isChromeless) return $1c81254a40e33e49$var$noBanner;
        if (IPBlocklisting.isEnabled) return IPBlocklisting;
        if (returnToMobile.isEnabled) return returnToMobile;
        if (announcement.isEnabled) return announcement;
        if (transition?.isEnabled) return transition;
        if (mailExpiry?.isEnabled) return mailExpiry;
        return $1c81254a40e33e49$var$noBanner;
    }, [
        cookieConsent,
        isChromeless,
        IPBlocklisting,
        returnToMobile,
        announcement,
        transition,
        mailExpiry
    ]);
};

});
parcelRegister("N5dQV", function(module, exports) {

$parcel$export(module.exports, "useBannerCookieConsent", () => $42e2ac81d60d8dce$export$c7a51b5ee06f5794);

var $eUqFw = parcelRequire("eUqFw");

var $3cif2 = parcelRequire("3cif2");
var $hM2VL = parcelRequire("hM2VL");

var $aqZcy = parcelRequire("aqZcy");

var $1ybV0 = parcelRequire("1ybV0");

var $8LJqN = parcelRequire("8LJqN");

var $8yXY1 = parcelRequire("8yXY1");


var $4zIA4 = parcelRequire("4zIA4");
const $42e2ac81d60d8dce$export$5503c67b1001ec45 = (data)=>{
    try {
        const shouldShowBannerBit = (0, $aqZcy.getCookie)((0, $3cif2.ATLASSIAN_SHOW_BANNER_COOKIE_KEY));
        const shouldShowBannerBitState = shouldShowBannerBit ? !!Number(shouldShowBannerBit) : false;
        return data && (0, $hM2VL.shouldRenderBannerPrefetched)(data) || shouldShowBannerBitState;
    } catch (e) {
        return true;
    }
};
const $42e2ac81d60d8dce$var$useBannerCookieConsentV2 = ()=>{
    const [{ isDismissed: isDismissed, height: height }, { onShow: onShow }] = (0, $4zIA4.useCookieConsentBannerSettings)();
    const { data: data } = (0, $8yXY1.useConsentBannerUserPreferencesResource)();
    (0, $eUqFw.useEffect)(()=>{
        const shouldRender = $42e2ac81d60d8dce$export$5503c67b1001ec45(data);
        // only show banner if banner should be shown and not in iframe
        if (shouldRender && !(0, $4zIA4.isInIframe)()) onShow();
    }, [
        data,
        onShow
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            isEnabled: !isDismissed,
            name: (0, $539c74e86514eccc$export$41956b146268af93),
            height: height
        }), [
        isDismissed,
        height
    ]);
};
const $42e2ac81d60d8dce$var$useBannerCookieConsentV1 = ()=>{
    const [{ isDismissed: isDismissed, height: height }] = (0, $4zIA4.useCookieConsentBannerSettings)();
    return (0, $eUqFw.useMemo)(()=>({
            isEnabled: !isDismissed,
            name: (0, $539c74e86514eccc$export$41956b146268af93),
            height: height
        }), [
        isDismissed,
        height
    ]);
};
const $42e2ac81d60d8dce$export$c7a51b5ee06f5794 = (0, $8LJqN.functionWithCondition)(()=>(0, $1ybV0.ff)('platform.moonjelly.browser-storage-controls-v2'), $42e2ac81d60d8dce$var$useBannerCookieConsentV2, $42e2ac81d60d8dce$var$useBannerCookieConsentV1);

});
parcelRegister("3cif2", function(module, exports) {

$parcel$export(module.exports, "LEGACY_ATLASSIAN_GDPR_COOKIE_KEY", () => $2540a478abb0fbf1$export$10d7db8e1a856fd8);
$parcel$export(module.exports, "ATLASSIAN_CONSENT_COOKIE_KEY", () => $2540a478abb0fbf1$export$435de28e5b000487);
$parcel$export(module.exports, "ATLASSIAN_SHOW_BANNER_COOKIE_KEY", () => $2540a478abb0fbf1$export$4b17acc0e875ba2a);
$parcel$export(module.exports, "ATLASSIAN_CURRENT_LOCALE_COOKIE_KEY", () => $2540a478abb0fbf1$export$f57af01b64fc97b8);
$parcel$export(module.exports, "ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY", () => $2540a478abb0fbf1$export$23a1e02c3c0b0d08);
$parcel$export(module.exports, "TESTING_LOCALE_OVERRIDE_COOKIE_KEY", () => $2540a478abb0fbf1$export$a31e531c3cdb5df8);
$parcel$export(module.exports, "TESTING_TOKEN_OVERRIDE_COOKIE_KEY", () => $2540a478abb0fbf1$export$37073d560ecebada);
$parcel$export(module.exports, "ACCEPT_ALL_PREFERENCES", () => $2540a478abb0fbf1$export$b28b5d760fe14a21);
$parcel$export(module.exports, "ONLY_NECESSARY_PREFERENCES", () => $2540a478abb0fbf1$export$4a12f9e99971760a);
$parcel$export(module.exports, "DEFAULT_PREFERENCES", () => $2540a478abb0fbf1$export$f0fd1d13ec1d48f2);
$parcel$export(module.exports, "V001_SCHEMA_KEY", () => $2540a478abb0fbf1$export$f95182b7aa141c57);
$parcel$export(module.exports, "V002_SCHEMA_KEY", () => $2540a478abb0fbf1$export$1f25427b34f9c405);

var $3K9DW = parcelRequire("3K9DW");
const $2540a478abb0fbf1$export$10d7db8e1a856fd8 = 'atl-gdpr-consent';
const $2540a478abb0fbf1$export$435de28e5b000487 = 'atl-bsc-consent-token';
const $2540a478abb0fbf1$export$4b17acc0e875ba2a = 'atl-bsc-show-banner';
const $2540a478abb0fbf1$export$f57af01b64fc97b8 = 'atl-bsc-current-locale';
const $2540a478abb0fbf1$export$23a1e02c3c0b0d08 = 'atl-bsc-consent-token-fallback';
const $2540a478abb0fbf1$export$a31e531c3cdb5df8 = 'atl-testing-locale';
const $2540a478abb0fbf1$export$37073d560ecebada = 'atl-testing-consents';
const $2540a478abb0fbf1$export$b28b5d760fe14a21 = {
    [(0, $3K9DW.CookieCategory).StrictlyNecessary]: true,
    [(0, $3K9DW.CookieCategory).Functional]: true,
    [(0, $3K9DW.CookieCategory).Marketing]: true,
    [(0, $3K9DW.CookieCategory).Analytics]: true,
    [(0, $3K9DW.CookieCategory).Unknown]: true // Includes uncategorized cookies
};
const $2540a478abb0fbf1$export$4a12f9e99971760a = {
    [(0, $3K9DW.CookieCategory).StrictlyNecessary]: true,
    [(0, $3K9DW.CookieCategory).Functional]: false,
    [(0, $3K9DW.CookieCategory).Marketing]: false,
    [(0, $3K9DW.CookieCategory).Analytics]: false,
    [(0, $3K9DW.CookieCategory).Unknown]: false
};
const $2540a478abb0fbf1$export$f0fd1d13ec1d48f2 = {
    [(0, $3K9DW.CookieCategory).StrictlyNecessary]: true,
    [(0, $3K9DW.CookieCategory).Functional]: false,
    [(0, $3K9DW.CookieCategory).Marketing]: false,
    [(0, $3K9DW.CookieCategory).Analytics]: false,
    [(0, $3K9DW.CookieCategory).Unknown]: false,
    [(0, $3K9DW.ConsentPreference).ConsentDataUnavailable]: true,
    [(0, $3K9DW.ConsentPreference).ConsentedUnderGDPR]: false,
    [(0, $3K9DW.ConsentPreference).ConsentedUnderCPRA]: false,
    [(0, $3K9DW.ConsentPreference).ConsentedUnderLGPD]: false,
    [(0, $3K9DW.ConsentPreference).ConsentedUnderFADP]: false
};
const $2540a478abb0fbf1$export$f95182b7aa141c57 = '001';
const $2540a478abb0fbf1$export$1f25427b34f9c405 = '002';

});
parcelRegister("3K9DW", function(module, exports) {

$parcel$export(module.exports, "CookieCategory", () => $2b9d25e8678c97bc$export$6c0a9f14755cf0cb);
$parcel$export(module.exports, "ConsentPreference", () => $2b9d25e8678c97bc$export$804b62abbd855306);
$parcel$export(module.exports, "PrefetchedPreferenceState", () => $2b9d25e8678c97bc$export$5d6594a0bba4ab8a);
let $2b9d25e8678c97bc$export$6c0a9f14755cf0cb = /*#__PURE__*/ function(CookieCategory) {
    CookieCategory["StrictlyNecessary"] = "STRICTLY_NECESSARY";
    CookieCategory["Functional"] = "FUNCTIONAL";
    CookieCategory["Marketing"] = "MARKETING";
    CookieCategory["Analytics"] = "ANALYTICS";
    CookieCategory["Unknown"] = "UNKNOWN";
    return CookieCategory;
}({});
let $2b9d25e8678c97bc$export$804b62abbd855306 = /*#__PURE__*/ function(ConsentPreference) {
    ConsentPreference["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    ConsentPreference["ConsentedUnderGDPR"] = "CONSENTS_SAVED_IN_GDPR_LOCALE";
    ConsentPreference["ConsentedUnderCPRA"] = "CONSENTS_SAVED_IN_CPRA_LOCALE";
    ConsentPreference["ConsentedUnderLGPD"] = "CONSENTS_SAVED_IN_LGPD_LOCALE";
    ConsentPreference["ConsentedUnderFADP"] = "CONSENTS_SAVED_IN_FADP_LOCALE";
    return ConsentPreference;
}({});
let $2b9d25e8678c97bc$export$5d6594a0bba4ab8a = /*#__PURE__*/ function(PrefetchedPreferenceState) {
    PrefetchedPreferenceState[PrefetchedPreferenceState["INTERNAL"] = 0] = "INTERNAL";
    return PrefetchedPreferenceState;
}({});

});


parcelRegister("hM2VL", function(module, exports) {

$parcel$export(module.exports, "shouldRenderBannerPrefetched", () => $cf093153155f39d8$export$6406464aa126433e);

var $cRRop = parcelRequire("cRRop");

var $aiuhL = parcelRequire("aiuhL");

var $i4rOz = parcelRequire("i4rOz");
const $cf093153155f39d8$export$6406464aa126433e = (prefetchedPreferencesData)=>{
    if (!prefetchedPreferencesData) // If prefetched prefs are missing (presumably SSR prefetching failed), but are still trying to compute
    // banner state, we have no info to calculate from so, we need to show the banner to be compliant
    return true;
    if ('consentToken' in prefetchedPreferencesData) {
        // We've been given cached cookie data, validate it before use.
        // If invalid, we can't determine anything, show the banner for compliance sake
        const { isValid: isValid } = (0, $aiuhL.checkTokenValidity)(prefetchedPreferencesData.consentToken);
        return isValid ? (0, $i4rOz.getBannerVisibilityByLocale)(prefetchedPreferencesData) : true;
    }
    // We've been given ConsentHub response data, format it appropriately
    const consentPrefsData = (0, $cRRop.buildConsentPreferences)(prefetchedPreferencesData);
    return (0, $i4rOz.getBannerVisibilityByLocale)(consentPrefsData);
};

});
parcelRegister("cRRop", function(module, exports) {

$parcel$export(module.exports, "buildConsentPreferences", () => $95e3d9ee806ee37f$export$bd9f5bcbf9cd947c);
$parcel$export(module.exports, "fetchConsentPreferences", () => $95e3d9ee806ee37f$export$86467566615ab85e);
$parcel$export(module.exports, "saveConsentPreferences", () => $95e3d9ee806ee37f$export$f8422650c3dec8b2);
$parcel$export(module.exports, "fetchCurrentLocale", () => $95e3d9ee806ee37f$export$767ad46933c149a6);

var $8nVWJ = parcelRequire("8nVWJ");

var $jeGRo = parcelRequire("jeGRo");
const $95e3d9ee806ee37f$var$BASE_CONSENTS_URL = '/gateway/api/consenthub/session';
const $95e3d9ee806ee37f$var$POST_CONSENTS_URL = `${$95e3d9ee806ee37f$var$BASE_CONSENTS_URL}/user`;
const $95e3d9ee806ee37f$var$GET_CONSENTS_URL = `${$95e3d9ee806ee37f$var$POST_CONSENTS_URL}/consents/cookies`;
const $95e3d9ee806ee37f$var$GET_CURRENT_LOCALE_URL = `${$95e3d9ee806ee37f$var$BASE_CONSENTS_URL}/form-config`;
const $95e3d9ee806ee37f$export$bd9f5bcbf9cd947c = (consentData)=>{
    if (consentData) {
        const serializedConsents = (0, $jeGRo.serializeConsents)(consentData);
        const consentTimestamp = (0, $jeGRo.getConsentTimestamp)(consentData);
        return {
            consentToken: serializedConsents,
            currentLocale: consentData.currentLocale,
            consentTimestamp: consentTimestamp
        };
    }
    // Without consent data (due to server failure or unauthenticated user), set defaults illustrating that absence
    return {
        consentToken: (0, $jeGRo.serializeConsents)({
            currentLocale: 'UNKNOWN'
        }),
        currentLocale: 'UNKNOWN',
        consentHubInaccessible: true
    };
};
const $95e3d9ee806ee37f$export$86467566615ab85e = async ()=>{
    const { origin: origin } = window.location;
    const getFromConsentHubURL = `${origin}${$95e3d9ee806ee37f$var$GET_CONSENTS_URL}`;
    try {
        const response = await fetch(getFromConsentHubURL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (!response.ok) throw new Error(`Failed to fetch preferences from ConsentHub with status: ${response.status}`);
        const consentData = await response.json();
        return $95e3d9ee806ee37f$export$bd9f5bcbf9cd947c(consentData);
    } catch (err) {
        (0, $8nVWJ.Logger).errorWithOperationalEvent({
            action: 'fetchConsentPreferencesError',
            message: err.message || ''
        });
        return $95e3d9ee806ee37f$export$bd9f5bcbf9cd947c();
    }
};
const $95e3d9ee806ee37f$var$buildConsentRequestBody = (unpackedUserPreferences, displayedTextMap)=>{
    const { origin: origin, pathname: pathname } = window.location;
    const deserializedConsents = (0, $jeGRo.deserializeConsents)(unpackedUserPreferences, displayedTextMap);
    // Type guard here so TS knows we're working with CookiePreferenceV002
    const action = 'CONSENT_DATA_UNAVAILABLE' in unpackedUserPreferences && unpackedUserPreferences.CONSENT_DATA_UNAVAILABLE ? 'FORM_FILL' : 'UPDATE_PREFERENCES';
    const consentRequestBody = {
        action: action,
        // If there are no consents, it's a first time fill, otherwise it's an update action
        consents: deserializedConsents,
        formUrl: `${origin}${pathname}`,
        locale: 'UNKNOWN',
        site: 'atlassian',
        source: 'COOKIE_PREFERENCES'
    };
    return JSON.stringify(consentRequestBody);
};
const $95e3d9ee806ee37f$export$f8422650c3dec8b2 = async (unpackedUserPreferences, displayedTextMap)=>{
    const saveToConsentHubURL = `${window.location.origin}${$95e3d9ee806ee37f$var$POST_CONSENTS_URL}`;
    try {
        const response = await fetch(saveToConsentHubURL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: $95e3d9ee806ee37f$var$buildConsentRequestBody(unpackedUserPreferences, displayedTextMap)
        });
        // Saving is an async API (we don't know if the save succeeds) so returns 202 Accepted.
        if (!response.ok || response.status !== 202 && response.status !== 200) {
            const errMsg = `Failed to save preferences to ConsentHub with status: ${response.status}`;
            const errWithStatusCode = new (0, $jeGRo.StatusCodeError)(errMsg, response.status);
            throw errWithStatusCode;
        }
    } catch (err) {
        (0, $8nVWJ.Logger).errorWithOperationalEvent({
            action: 'saveConsentPreferencesError',
            message: err.message || ''
        });
        // Re-throw to any encapsulating logic, a la `setConsentToken()`
        throw err;
    }
};
const $95e3d9ee806ee37f$export$767ad46933c149a6 = async ()=>{
    const getLocaleURL = `${window.location.origin}${$95e3d9ee806ee37f$var$GET_CURRENT_LOCALE_URL}`;
    try {
        const response = await fetch(getLocaleURL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (!response.ok) throw new Error(`Failed to fetch current locale from ConsentHub with status: ${response.status}`);
        const { locale: locale } = await response.json();
        return locale;
    } catch (err) {
        return 'UNKNOWN';
    }
};

});
parcelRegister("8nVWJ", function(module, exports) {

$parcel$export(module.exports, "Logger", () => $61ad6ba52a9e5843$export$efa9a398d6368992);
/* eslint-disable no-console */ 
var $5mY09 = parcelRequire("5mY09");
const $61ad6ba52a9e5843$var$LOG_PREFIX = '[browser-storage-controls]';
class $61ad6ba52a9e5843$export$efa9a398d6368992 {
    static info(message, metadata) {
        console.log(`${$61ad6ba52a9e5843$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
    static error(message, metadata) {
        console.error(`${$61ad6ba52a9e5843$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
    static errorWithOperationalEvent({ action: action, attributes: attributes = {}, message: message, metadata: metadata }) {
        try {
            (0, $5mY09.sendPackageOperationalEvent)({
                action: action,
                attributes: {
                    error: message,
                    ...attributes
                }
            });
        } catch (e) {
            this.error(`Failed to send operational event on error: ${action}. ${e.message || ''}`);
        }
        this.error(message, metadata ? JSON.stringify(metadata) : '');
    }
    static warn(message, metadata) {
        console.warn(`${$61ad6ba52a9e5843$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
}

});
parcelRegister("5mY09", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsClient", () => $3e8d8cd8a57e154c$export$fde53e78fd93a54d);
$parcel$export(module.exports, "sendPackageOperationalEvent", () => $3e8d8cd8a57e154c$export$5bfe55348e7aebc1);
$parcel$export(module.exports, "sendUIEvent", () => $3e8d8cd8a57e154c$export$1aecf263098db667);
$parcel$export(module.exports, "sendScreenEvent", () => $3e8d8cd8a57e154c$export$22a3b1671f38a193);
$parcel$export(module.exports, "sendTrackEvent", () => $3e8d8cd8a57e154c$export$1ba525b8a711eaac);

var $aYU4Z = parcelRequire("aYU4Z");
var $hRleJ = parcelRequire("hRleJ");

var $XHGTv = parcelRequire("XHGTv");

var $2SDTs = parcelRequire("2SDTs");

var $8nVWJ = parcelRequire("8nVWJ");

var $1Xs0X = parcelRequire("1Xs0X");

var $8iPDg = parcelRequire("8iPDg");
const $3e8d8cd8a57e154c$var$getEnvironment = ()=>{
    const { hostname: hostname } = window.location;
    if (hostname.includes('.dev.') || hostname.includes('.stg.')) return (0, $hRleJ.envType).STAGING;
    if (hostname.includes('localhost') || hostname.includes('ngrok') || hostname.includes('atlastunnel')) return (0, $hRleJ.envType).DEV;
    return (0, $hRleJ.envType).PROD;
};
const $3e8d8cd8a57e154c$export$78d7c0236b4fece9 = (path)=>{
    let subPath = '';
    if (!path) return subPath;
    const checkPath = (match)=>{
        return new RegExp(`^${match}(/|$)`).test(String(path));
    };
    if (checkPath('/wiki')) subPath = '/wiki';
    if (checkPath('/jira')) subPath = '/jira';
    if (checkPath('/compass')) subPath = '/compass';
    if (checkPath('/canvas')) subPath = '/canvas';
    if (checkPath('/servicedesk') || checkPath('/jira/servicedesk')) subPath = '/servicedesk';
    return subPath;
};
const $3e8d8cd8a57e154c$export$fce3dd735e04d566 = ()=>{
    const { origin: origin, pathname: pathname } = window.location;
    const productPath = $3e8d8cd8a57e154c$export$78d7c0236b4fece9(pathname);
    return {
        domain: `${origin}${productPath}`,
        product: productPath.slice(1)
    };
};
const $3e8d8cd8a57e154c$var$decorateEventAttributes = (attributes)=>{
    var _getBscGlobalState$pr, _getBscGlobalState$pr2;
    const { domain: domain, product: product } = $3e8d8cd8a57e154c$export$fce3dd735e04d566();
    return {
        // eslint-disable-next-line @atlaskit/platform/no-invalid-feature-flag-usage
        featureFlagOn: (0, $XHGTv.getBooleanFF)('platform.moonjelly.browser-storage-controls'),
        packageName: $1Xs0X.packageName,
        packageVersion: $1Xs0X.packageVersion,
        domain: domain,
        product: (_getBscGlobalState$pr = (_getBscGlobalState$pr2 = (0, $2SDTs.getBscGlobalState)().product) === null || _getBscGlobalState$pr2 === void 0 ? void 0 : _getBscGlobalState$pr2.toLowerCase()) !== null && _getBscGlobalState$pr !== void 0 ? _getBscGlobalState$pr : product,
        ...attributes && attributes
    };
};
const $3e8d8cd8a57e154c$export$fde53e78fd93a54d = (()=>{
    let instance;
    return ()=>{
        try {
            if (!instance && (0, $2SDTs.getBscGlobalState)().analyticsEnabled) instance = new (0, $aYU4Z.default)({
                env: $3e8d8cd8a57e154c$var$getEnvironment(),
                product: 'atlassianCookies'
            }, {
                // useLegacyUrl tells the analytics client to make calls directly to Global Analytics Service.
                // When set to false, the client will use a stargate proxy for the current URL to send events
                // to GAS. Said another way:
                // true => events are sent to https://api-private.stg.atlassian.com/gasv3/api/v1/batch
                // false => events are sent to <the current domain>/gasv3/api/v1/batch
                //
                // By default, this should be set to false.  If you need to validate that analytics events
                // are being transmitted correctly in local dev, you can temporarily enable it since localhost
                // won't be able to proxy to GAS via stargate.
                useLegacyUrl: false,
                disableCookiePersistence: true
            });
        } catch (e) {
            // Log  errors thrown in constructor initialization for the AnalyticsWebClient
            (0, $8nVWJ.Logger).error(`Failed to initialize AnalyticsWebClient. ${e}`);
        }
        if (!(0, $2SDTs.getBscGlobalState)().analyticsEnabled) return undefined;
        // Return the instance, even if it is undefined
        return instance;
    };
})();
function $3e8d8cd8a57e154c$export$5bfe55348e7aebc1(properties) {
    (0, $8iPDg.withAnalyticsEventSampling)(properties.action, ()=>{
        var _getAnalyticsClient;
        return (_getAnalyticsClient = $3e8d8cd8a57e154c$export$fde53e78fd93a54d()) === null || _getAnalyticsClient === void 0 ? void 0 : _getAnalyticsClient.sendOperationalEvent({
            source: 'package',
            actionSubject: 'package',
            action: properties.action,
            attributes: $3e8d8cd8a57e154c$var$decorateEventAttributes(properties.attributes)
        });
    });
}
function $3e8d8cd8a57e154c$export$1aecf263098db667(properties) {
    var _getAnalyticsClient2;
    (_getAnalyticsClient2 = $3e8d8cd8a57e154c$export$fde53e78fd93a54d()) === null || _getAnalyticsClient2 === void 0 || _getAnalyticsClient2.sendUIEvent({
        ...properties,
        attributes: $3e8d8cd8a57e154c$var$decorateEventAttributes(properties.attributes)
    });
}
function $3e8d8cd8a57e154c$export$22a3b1671f38a193(properties) {
    var _getAnalyticsClient3;
    (_getAnalyticsClient3 = $3e8d8cd8a57e154c$export$fde53e78fd93a54d()) === null || _getAnalyticsClient3 === void 0 || _getAnalyticsClient3.sendScreenEvent({
        ...properties,
        attributes: $3e8d8cd8a57e154c$var$decorateEventAttributes(properties.attributes)
    });
}
function $3e8d8cd8a57e154c$export$1ba525b8a711eaac(properties) {
    var _getAnalyticsClient4;
    (_getAnalyticsClient4 = $3e8d8cd8a57e154c$export$fde53e78fd93a54d()) === null || _getAnalyticsClient4 === void 0 || _getAnalyticsClient4.sendTrackEvent({
        ...properties,
        attributes: $3e8d8cd8a57e154c$var$decorateEventAttributes(properties.attributes)
    });
}

});
parcelRegister("2SDTs", function(module, exports) {

$parcel$export(module.exports, "getBscGlobalState", () => $218f91e81d89a291$export$3b78a1ea01f5ec28);
$parcel$export(module.exports, "initializeGlobalState", () => $218f91e81d89a291$export$882c4530c58781d8);
let $218f91e81d89a291$var$localAnalyticsEnabled;
let $218f91e81d89a291$var$localProduct;
const $218f91e81d89a291$export$3b78a1ea01f5ec28 = ()=>{
    if ($218f91e81d89a291$var$localAnalyticsEnabled == null) $218f91e81d89a291$var$localAnalyticsEnabled = true;
    return {
        analyticsEnabled: $218f91e81d89a291$var$localAnalyticsEnabled,
        product: $218f91e81d89a291$var$localProduct
    };
};
const $218f91e81d89a291$export$882c4530c58781d8 = ({ analyticsEnabled: analyticsEnabled = true, product: product = 'NONE' } = {})=>{
    $218f91e81d89a291$var$localAnalyticsEnabled = analyticsEnabled;
    $218f91e81d89a291$var$localProduct = product;
};
const $218f91e81d89a291$export$ac7c2edd09656c05 = ()=>{
    $218f91e81d89a291$var$localAnalyticsEnabled = undefined;
    $218f91e81d89a291$var$localProduct = undefined;
};

});

parcelRegister("1Xs0X", function(module, exports) {

$parcel$export(module.exports, "packageName", () => $16d10839711d7081$export$9345d7360ffe0722);
$parcel$export(module.exports, "packageVersion", () => $16d10839711d7081$export$91546b032799aa40);
const $16d10839711d7081$export$9345d7360ffe0722 = "@atlassian/browser-storage-controls";
const $16d10839711d7081$export$91546b032799aa40 = "2.8.4";

});

parcelRegister("8iPDg", function(module, exports) {

$parcel$export(module.exports, "withAnalyticsEventSampling", () => $60b80e4377618ef6$export$67b6e87f323cb6ad);

var $d6j3n = parcelRequire("d6j3n");

var $jyzhV = parcelRequire("jyzhV");

var $aynK1 = parcelRequire("aynK1");
const $60b80e4377618ef6$export$1138592b3c099377 = {
    usedGetCookie: 100000,
    usedGetCookieError: 1,
    usedSetCookie: 1000,
    usedSetCookieError: 1,
    usedSetStrictlyNecessaryCookie: 10000,
    usedSetStrictlyNecessaryCookieError: 1,
    usedDeleteCookie: 10,
    usedDeleteCookieError: 1,
    usedCheckThirdParty: 100000,
    checkThirdPartyError: 1,
    usedDocumentCookie: 100,
    usedDocumentCookieError: 1,
    initializeControlsError: 1,
    loadStorageControlsError: 1,
    updatePreferencesError: 1,
    fetchConsentPreferencesError: 1,
    saveConsentPreferencesError: 1
};
// This short-circuits finding a sampling ratio from the remote config. Useful for things like
// `loadStorageControlsError` which itself tries to log an event on error, causing an infinite
// recursion as each lookup fails, logging another event, etc.
const $60b80e4377618ef6$var$localOnlySamplingKeys = [
    'loadStorageControlsError'
];
async function $60b80e4377618ef6$var$loadSamplingConfig() {
    if ((0, $d6j3n.cache).cachedSamplingConfig) return (0, $d6j3n.cache).cachedSamplingConfig;
    if ((0, $jyzhV.isSSR)()) return undefined;
    const controlsData = await (0, $aynK1.loadStorageControlsData)();
    const analyticsSamplingRatioConfigs = controlsData === null || controlsData === void 0 ? void 0 : controlsData.analyticsSamplingRatio;
    (0, $d6j3n.cache).cachedSamplingConfig = analyticsSamplingRatioConfigs;
    return analyticsSamplingRatioConfigs;
}
async function $60b80e4377618ef6$export$b286f5e8716d11ad(analyticsEventKey) {
    if ($60b80e4377618ef6$var$localOnlySamplingKeys.includes(analyticsEventKey)) return $60b80e4377618ef6$export$1138592b3c099377[analyticsEventKey];
    const remoteSamplingConfig = await $60b80e4377618ef6$var$loadSamplingConfig();
    const samplingConfig = remoteSamplingConfig !== null && remoteSamplingConfig !== void 0 ? remoteSamplingConfig : $60b80e4377618ef6$export$1138592b3c099377;
    const samplingRatio = (samplingConfig === null || samplingConfig === void 0 ? void 0 : samplingConfig[analyticsEventKey]) !== undefined ? samplingConfig[analyticsEventKey] : $60b80e4377618ef6$export$1138592b3c099377[analyticsEventKey];
    return samplingRatio;
}
function $60b80e4377618ef6$export$dc2f0946255b3f89(samplingRatio, cb) {
    /* Only run if rolling the samplingRatio-sized die lands on a 0
        ________
       /\       \
      /()\   ()  \
     /    \_______\
     \    /()     /
      \()/   ()  /
       \/_____()/
   */ const shouldRun = !Math.floor(Math.random() * samplingRatio);
    shouldRun && cb();
}
async function $60b80e4377618ef6$export$67b6e87f323cb6ad(analyticsEventKey, cb) {
    const ratio = await $60b80e4377618ef6$export$b286f5e8716d11ad(analyticsEventKey);
    $60b80e4377618ef6$export$dc2f0946255b3f89(ratio, cb);
}

});
parcelRegister("d6j3n", function(module, exports) {

$parcel$export(module.exports, "cache", () => $989a9d835e85a46c$export$69a3209f1a06c04d);

var $b7x1y = parcelRequire("b7x1y");
const $989a9d835e85a46c$export$69a3209f1a06c04d = new (0, $b7x1y.CachedSamplingConfig)();

});
parcelRegister("b7x1y", function(module, exports) {

$parcel$export(module.exports, "CachedSamplingConfig", () => $8189f708c11aed60$export$b886edaf6623554a);
// The categories.json file is already configured to be cached by the browser, but for this sampling
// config, it's even less important to manage stale values. Most BSC API interaction is done on
// application startup.  So we may as well cache this in memory once per app load and not retrieve
// it from local disk for each event emitted.
class $8189f708c11aed60$export$b886edaf6623554a {
    get cachedSamplingConfig() {
        return this.cache;
    }
    set cachedSamplingConfig(value) {
        this.cache = value;
    }
}

});


parcelRegister("jyzhV", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $e3cc90c23182ed8f$export$48d7c418edadb60c);

var $aYU4Z = parcelRequire("aYU4Z");

var $XHGTv = parcelRequire("XHGTv");

var $8nVWJ = parcelRequire("8nVWJ");
const $e3cc90c23182ed8f$export$48d7c418edadb60c = ()=>{
    const isMissingNecessaryBrowserUtils = typeof document === 'undefined' || typeof window === 'undefined' || !Document || !Document.prototype || !Object || !Object.defineProperty;
    const isMissingBooleanFF = !(0, $XHGTv.getBooleanFF);
    const isMissingAnalyticsWebClient = !Boolean((0, $aYU4Z.default));
    // When rendering from the server document/window may not be available
    if (isMissingNecessaryBrowserUtils) (0, $8nVWJ.Logger).warn('Browser context is not available.');
    if (isMissingBooleanFF) (0, $8nVWJ.Logger).warn('Platform Feature Flag library is not available');
    if (!(0, $aYU4Z.default)) (0, $8nVWJ.Logger).warn('analytics-web-client is not available');
    if (isMissingNecessaryBrowserUtils || isMissingBooleanFF || isMissingAnalyticsWebClient) return true;
    else return false;
};

});

parcelRegister("aynK1", function(module, exports) {

$parcel$export(module.exports, "loadStorageControlsData", () => $7aef7ee2a0c69006$export$4dbb842f063ffea4);

var $8nVWJ = parcelRequire("8nVWJ");
const $7aef7ee2a0c69006$export$ab0619f627170401 = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories.json';
/**
 * Cache variable for storing categorized cookies cache
 */ let $7aef7ee2a0c69006$var$localResponseCache;
/**
 * Cache variable for storing a promise that's been fired by a different invocation of loadStorageControls
 *
 * Allows for many invocations to happen simultaneously, and for only one fetch to go out
 */ let $7aef7ee2a0c69006$var$localResponsePromiseCache;
/**
 * Cache variable for storing the promise returned from the response object's json method
 *
 * Ensures we don't invoke response.json multiple times
 */ let $7aef7ee2a0c69006$var$localResponseJsonPromiseCache;
const $7aef7ee2a0c69006$export$19bc72f5ccd901a6 = ()=>{
    $7aef7ee2a0c69006$var$localResponseCache = undefined;
    $7aef7ee2a0c69006$var$localResponsePromiseCache = undefined;
    $7aef7ee2a0c69006$var$localResponseJsonPromiseCache = undefined;
};
/**
 * Unpacks the response promise from the categories CDN
 *
 * errors if that request was unsuccessful, returns the categories data otherwise
 *
 */ const $7aef7ee2a0c69006$var$handleCategoriesResponse = async (responsePromise)=>{
    if (!responsePromise) throw new Error(`Failed to fetch Cookies Cache! Cached promise was undefined`);
    const response = await responsePromise;
    if (!response.ok) throw new Error(`Failed to fetch Cookies Cache! status: ${response.status}`);
    // Checks if we've already fired the response.json() promise
    $7aef7ee2a0c69006$var$localResponseJsonPromiseCache = $7aef7ee2a0c69006$var$localResponseJsonPromiseCache || (response === null || response === void 0 ? void 0 : response.json());
    return $7aef7ee2a0c69006$var$localResponseJsonPromiseCache;
};
const $7aef7ee2a0c69006$export$4dbb842f063ffea4 = async ()=>{
    if ($7aef7ee2a0c69006$var$localResponseCache) return $7aef7ee2a0c69006$var$localResponseCache;
    else // Always use Prod CDN for prod/local/dev/staging environments, but stub the route for automation tests
    try {
        if (!$7aef7ee2a0c69006$var$localResponsePromiseCache) // invoke CDN and cache the promise
        $7aef7ee2a0c69006$var$localResponsePromiseCache = fetch($7aef7ee2a0c69006$export$ab0619f627170401);
        // unpack response
        $7aef7ee2a0c69006$var$localResponseCache = await $7aef7ee2a0c69006$var$handleCategoriesResponse($7aef7ee2a0c69006$var$localResponsePromiseCache);
        return $7aef7ee2a0c69006$var$localResponseCache;
    } catch (e) {
        (0, $8nVWJ.Logger).errorWithOperationalEvent({
            action: 'loadStorageControlsError',
            message: e.message || ''
        });
        $7aef7ee2a0c69006$export$19bc72f5ccd901a6();
    }
};

});




parcelRegister("jeGRo", function(module, exports) {

$parcel$export(module.exports, "isLocaleCoveredByTier1Policies", () => $e010923ef8ffa7b3$export$e14d7ef1af2ce472);
$parcel$export(module.exports, "isLocaleCoveredByTier2Policies", () => $e010923ef8ffa7b3$export$70f9bbd1301d2d0b);
$parcel$export(module.exports, "getConsentedUnderPrivacyActPrefs", () => $e010923ef8ffa7b3$export$f1b32615319b598a);
$parcel$export(module.exports, "isLocaleCoveredByAnyPrivacyActs", () => $e010923ef8ffa7b3$export$acd046180e7e5957);
$parcel$export(module.exports, "checkIfTokenIsDefault", () => $e010923ef8ffa7b3$export$497a647f0eb30ef4);
$parcel$export(module.exports, "getDefaultPrefs", () => $e010923ef8ffa7b3$export$9dfcf7030b9898f5);
$parcel$export(module.exports, "serializeConsents", () => $e010923ef8ffa7b3$export$92ba0b2fe50f90df);
$parcel$export(module.exports, "deserializeConsents", () => $e010923ef8ffa7b3$export$bfa0c91662787fb0);
$parcel$export(module.exports, "getConsentTimestamp", () => $e010923ef8ffa7b3$export$13e4cff933f26b03);
$parcel$export(module.exports, "checkIfConsentsAreStale", () => $e010923ef8ffa7b3$export$3387347b75450ae1);
$parcel$export(module.exports, "checkIfTokenHasAConsentLocale", () => $e010923ef8ffa7b3$export$bace3da029b192a4);
$parcel$export(module.exports, "StatusCodeError", () => $e010923ef8ffa7b3$export$a79c0ea3d7c2444a);

var $fpgay = parcelRequire("fpgay");

var $3cif2 = parcelRequire("3cif2");

var $k4bKv = parcelRequire("k4bKv");

var $3K9DW = parcelRequire("3K9DW");

var $a1QAn = parcelRequire("a1QAn");

var $eHbAt = parcelRequire("eHbAt");
const $e010923ef8ffa7b3$export$e14d7ef1af2ce472 = (localeToCheck)=>{
    // Locale formatted as <CountryCode>-<SubdivisionCode>
    const localeCountryCode = localeToCheck.split('-')[0];
    return (0, $a1QAn.TIER_1_PROTECTED_LOCALES).includes(localeCountryCode);
};
const $e010923ef8ffa7b3$export$70f9bbd1301d2d0b = (localeToCheck)=>{
    // As Tier 2 is only US states currently, grabbing the country code here would be irrelevant
    return (0, $a1QAn.TIER_2_PROTECTED_LOCALES).includes(localeToCheck);
};
const $e010923ef8ffa7b3$export$a65c33bd5ae53d79 = (localeToCheck)=>{
    const localeCountryCode = localeToCheck.split('-')[0];
    return (0, $a1QAn.COUNTRIES_PROTECTED_BY_GDPR).includes(localeCountryCode);
};
const $e010923ef8ffa7b3$export$fa2fd91e262721dc = (localeToCheck)=>{
    const localeCountryCode = localeToCheck.split('-')[0];
    return (0, $a1QAn.COUNTRIES_PROTECTED_BY_LGPD).includes(localeCountryCode);
};
const $e010923ef8ffa7b3$export$35d6e76cfe4de16 = (localeToCheck)=>{
    const localeCountryCode = localeToCheck.split('-')[0];
    return (0, $a1QAn.COUNTRIES_PROTECTED_BY_FADP).includes(localeCountryCode);
};
const $e010923ef8ffa7b3$export$6d5f6ea619192a08 = (localeToCheck)=>{
    return (0, $a1QAn.US_STATES_PROTECTED_BY_CPRA).includes(localeToCheck);
};
const $e010923ef8ffa7b3$export$f1b32615319b598a = (localeToCheck)=>{
    const isTier2Locale = $e010923ef8ffa7b3$export$70f9bbd1301d2d0b(localeToCheck);
    const coveredByGDPR = $e010923ef8ffa7b3$export$a65c33bd5ae53d79(localeToCheck);
    const coveredByCPRA = $e010923ef8ffa7b3$export$6d5f6ea619192a08(localeToCheck);
    const coveredByLGPD = $e010923ef8ffa7b3$export$fa2fd91e262721dc(localeToCheck);
    const coveredByFADP = $e010923ef8ffa7b3$export$35d6e76cfe4de16(localeToCheck);
    // To maintain token granularity, if a locale is covered by Tier 1 policies but not by LGPD or FADP, we'll treat it as GDPR
    const isTier1LocaleWithoutRegionalLaws = $e010923ef8ffa7b3$export$e14d7ef1af2ce472(localeToCheck) && !coveredByLGPD && !coveredByFADP;
    return {
        [(0, $3K9DW.ConsentPreference).ConsentedUnderGDPR]: coveredByGDPR || isTier1LocaleWithoutRegionalLaws,
        [(0, $3K9DW.ConsentPreference).ConsentedUnderCPRA]: coveredByCPRA || isTier2Locale,
        [(0, $3K9DW.ConsentPreference).ConsentedUnderLGPD]: coveredByLGPD,
        [(0, $3K9DW.ConsentPreference).ConsentedUnderFADP]: coveredByFADP
    };
};
const $e010923ef8ffa7b3$export$acd046180e7e5957 = (localeToCheck)=>{
    // 'UNKNOWN' means locale can't be determined by GeoIP/service, so be extra compliant and Fail Closed/block by default
    return $e010923ef8ffa7b3$export$e14d7ef1af2ce472(localeToCheck) || $e010923ef8ffa7b3$export$70f9bbd1301d2d0b(localeToCheck) || localeToCheck === 'UNKNOWN';
};
const $e010923ef8ffa7b3$export$497a647f0eb30ef4 = (consentToken)=>{
    const consentsUnavailable = (0, $fpgay.getBoolFromBitValue)(consentToken[7]);
    const defaultPrefsWithProtections = $e010923ef8ffa7b3$export$c42e1a74e60f4d73((0, $a1QAn.TIER_1_PROTECTED_LOCALES)[0], consentsUnavailable);
    const defaultPrefsWithoutProtections = $e010923ef8ffa7b3$export$c42e1a74e60f4d73((0, $a1QAn.TIER_3_UNPROTECTED_LOCALES)[0], consentsUnavailable);
    return consentToken === defaultPrefsWithProtections || consentToken === defaultPrefsWithoutProtections;
};
const $e010923ef8ffa7b3$export$9dfcf7030b9898f5 = (currentLocale)=>{
    // User is in a locale that's covered by regional protection laws (e.g. US-CA) — Fail Closed by default until we have consents
    // User is in a locale that doesn't care (e.g. US-NY) — Fail Open by default as we'll never get consents
    const localeIsCoveredByRegionalProtectionLaws = $e010923ef8ffa7b3$export$acd046180e7e5957(currentLocale);
    return {
        ...(0, $3cif2.DEFAULT_PREFERENCES),
        ...localeIsCoveredByRegionalProtectionLaws ? (0, $3cif2.ONLY_NECESSARY_PREFERENCES) : (0, $3cif2.ACCEPT_ALL_PREFERENCES)
    };
};
const $e010923ef8ffa7b3$export$c42e1a74e60f4d73 = (currentLocale, consentsUnavailable)=>{
    const version = (0, $3cif2.V002_SCHEMA_KEY);
    const defaultPrefs = $e010923ef8ffa7b3$export$9dfcf7030b9898f5(currentLocale);
    const serializedBits = Object.entries(defaultPrefs).reduce((acc, [key, val])=>{
        // Skip the STRICTLY_NECESSARY as it's always allowed
        if (key === (0, $3K9DW.CookieCategory).StrictlyNecessary) return acc;
        if (key === (0, $3K9DW.ConsentPreference).ConsentDataUnavailable) // If consents are unavailable (unauthenticated), pack that data into the consent token bits
        return acc + (0, $fpgay.getBitValueFromBool)(!!consentsUnavailable);
        return acc + (0, $fpgay.getBitValueFromBool)(val);
    }, '');
    return `${version}${serializedBits}`;
};
const $e010923ef8ffa7b3$export$42a0b3fb1e53e7b9 = (consents, localeWhenConsented)=>{
    var _consents$find, _consents$find2, _consents$find3, _consents$find4;
    const version = (0, $3cif2.V002_SCHEMA_KEY);
    // As 'strictlyNecessaryConsent' would always be allowed, we don't store it in the cookie or use ConsentHub
    const functionalConsent = (0, $fpgay.getBitValueFromBool)(!!((_consents$find = consents.find((key)=>key.key === (0, $eHbAt.ConsentHubKey).Functional)) !== null && _consents$find !== void 0 && _consents$find.granted));
    const analyticsConsent = (0, $fpgay.getBitValueFromBool)(!!((_consents$find2 = consents.find((key)=>key.key === (0, $eHbAt.ConsentHubKey).Analytics)) !== null && _consents$find2 !== void 0 && _consents$find2.granted));
    const marketingConsent = (0, $fpgay.getBitValueFromBool)(!!((_consents$find3 = consents.find((key)=>key.key === (0, $eHbAt.ConsentHubKey).Marketing)) !== null && _consents$find3 !== void 0 && _consents$find3.granted));
    const unknownConsent = (0, $fpgay.getBitValueFromBool)(!!((_consents$find4 = consents.find((key)=>key.key === (0, $eHbAt.ConsentHubKey).Unknown)) !== null && _consents$find4 !== void 0 && _consents$find4.granted));
    const consentHubDataUnavailable = 0; // If we got here, we've hit ConsentHub for data, thus available
    const previouslyConsentedUnderGDPR = $e010923ef8ffa7b3$export$a65c33bd5ae53d79(localeWhenConsented);
    const previouslyConsentedUnderCPRA = $e010923ef8ffa7b3$export$6d5f6ea619192a08(localeWhenConsented);
    const previouslyConsentedUnderLGPD = $e010923ef8ffa7b3$export$fa2fd91e262721dc(localeWhenConsented);
    const previouslyConsentedUnderFADP = $e010923ef8ffa7b3$export$35d6e76cfe4de16(localeWhenConsented);
    // We have not yet confirmed if we want to treat individual countries with their own protection laws
    // differently from GDPR, but don't want to lose the granularity of the consentToken if we choose to do so in the future
    // so Atlassian will serve GDPR consents to all Tier 1 locales until then, but keep the individual country consents if present
    const consentedUnderTier1WithoutRegionalLaws = $e010923ef8ffa7b3$export$e14d7ef1af2ce472(localeWhenConsented) && !previouslyConsentedUnderLGPD && !previouslyConsentedUnderFADP;
    // Similarly, we don't want to lose the granularity of the consentToken if we choose to treat Tier 2 locales differently
    // in the future, so Atlassian will serve CPRA consents to all Tier 2 locales until then.
    const consentedUnderTier2WithoutRegionalLaws = $e010923ef8ffa7b3$export$70f9bbd1301d2d0b(localeWhenConsented) && !previouslyConsentedUnderCPRA;
    const consentedUnderGDPR = (0, $fpgay.getBitValueFromBool)(previouslyConsentedUnderGDPR || consentedUnderTier1WithoutRegionalLaws);
    const consentedUnderCPRA = (0, $fpgay.getBitValueFromBool)(previouslyConsentedUnderCPRA || consentedUnderTier2WithoutRegionalLaws);
    const consentedUnderLGPD = (0, $fpgay.getBitValueFromBool)(previouslyConsentedUnderLGPD);
    const consentedUnderFADP = (0, $fpgay.getBitValueFromBool)(previouslyConsentedUnderFADP);
    return [
        version,
        functionalConsent,
        analyticsConsent,
        marketingConsent,
        unknownConsent,
        consentHubDataUnavailable,
        consentedUnderGDPR,
        consentedUnderCPRA,
        consentedUnderLGPD,
        consentedUnderFADP
    ].join('');
};
const $e010923ef8ffa7b3$export$92ba0b2fe50f90df = ({ consents: consents, localeWhenConsented: localeWhenConsented, currentLocale: currentLocale })=>{
    if (!consents) {
        // When generating consents for an unauthenticated user, use the fallback token if it exists
        // This circumvents us setting defaults for them if their token has expired, but they have consented previously
        const existingFallbackToken = (0, $k4bKv.getCookie)((0, $3cif2.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
        if (existingFallbackToken) return existingFallbackToken;
        // User is unauthed, will only use local consenting, thus consent data is unavailable
        return $e010923ef8ffa7b3$export$c42e1a74e60f4d73(currentLocale, true); // e.g. 002000010000 | 002111110000
    } else if (consents.length === 0) // User is authed but has no consents in the system, so use defaults in the interim, but consentData WILL be available
    return $e010923ef8ffa7b3$export$c42e1a74e60f4d73(currentLocale); // e.g. 002000000000 | 002111100000
    else // User is authed and has consents in the system, which means they also have localeWhenConsented
    return $e010923ef8ffa7b3$export$42a0b3fb1e53e7b9(consents, localeWhenConsented);
};
const $e010923ef8ffa7b3$export$bfa0c91662787fb0 = (unpackedUserPreferences, displayedTextMap)=>{
    const validConsentHubCookieConsents = [
        (0, $3K9DW.CookieCategory).StrictlyNecessary,
        (0, $3K9DW.CookieCategory).Functional,
        (0, $3K9DW.CookieCategory).Analytics,
        (0, $3K9DW.CookieCategory).Marketing,
        (0, $3K9DW.CookieCategory).Unknown
    ];
    const consentKeyMap = {
        [(0, $3K9DW.CookieCategory).StrictlyNecessary]: (0, $eHbAt.ConsentHubKey).StrictlyNecessary,
        [(0, $3K9DW.CookieCategory).Functional]: (0, $eHbAt.ConsentHubKey).Functional,
        [(0, $3K9DW.CookieCategory).Analytics]: (0, $eHbAt.ConsentHubKey).Analytics,
        [(0, $3K9DW.CookieCategory).Marketing]: (0, $eHbAt.ConsentHubKey).Marketing,
        [(0, $3K9DW.CookieCategory).Unknown]: (0, $eHbAt.ConsentHubKey).Unknown
    };
    const consentRecords = validConsentHubCookieConsents.map((consentKey)=>{
        const key = consentKeyMap[consentKey];
        return {
            key: key,
            granted: !!unpackedUserPreferences[consentKey],
            gatheredTs: new Date().toISOString(),
            displayedText: displayedTextMap[consentKey]
        };
    });
    return consentRecords;
};
const $e010923ef8ffa7b3$export$13e4cff933f26b03 = ({ consents: consents })=>{
    if (consents && consents.length) {
        // As consents can be updated individually, we need to find the most recent timestamp to use as "most recent consent"
        const timestamps = consents.map((consent)=>{
            return new Date(consent.updatedTs).getTime();
        });
        const maxTimestamp = Math.max(...timestamps);
        const mostRecentConsentTimestamp = new Date(maxTimestamp).toISOString();
        return mostRecentConsentTimestamp;
    }
};
const $e010923ef8ffa7b3$export$3387347b75450ae1 = (consentTimestamp)=>{
    // Privacy has determined that we should re-prompt users for consent if they haven't
    // consented in over a year regardless, because they're legally stale/expired
    let consentedOverAYearAgo = false;
    if (consentTimestamp) {
        const oneYearAgo = new Date();
        oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
        consentedOverAYearAgo = new Date(consentTimestamp) < oneYearAgo;
    }
    return consentedOverAYearAgo;
};
const $e010923ef8ffa7b3$export$bace3da029b192a4 = (consentToken)=>{
    const consentedUnderGDPR = (0, $fpgay.getBoolFromBitValue)(consentToken[8]);
    const consentedUnderCPRA = (0, $fpgay.getBoolFromBitValue)(consentToken[9]);
    const consentedUnderLGPD = (0, $fpgay.getBoolFromBitValue)(consentToken[10]);
    const consentedUnderFADP = (0, $fpgay.getBoolFromBitValue)(consentToken[11]);
    return !!(consentedUnderGDPR || consentedUnderCPRA || consentedUnderLGPD || consentedUnderFADP);
};
class $e010923ef8ffa7b3$export$a79c0ea3d7c2444a extends Error {
    constructor(message, status){
        super(message);
        this.status = status;
        Object.setPrototypeOf(this, $e010923ef8ffa7b3$export$a79c0ea3d7c2444a.prototype);
        // Captures the stack trace (for environments that support it)
        if (Error.captureStackTrace) Error.captureStackTrace(this, $e010923ef8ffa7b3$export$a79c0ea3d7c2444a);
        this.name = 'StatusCodeError';
    }
}

});
parcelRegister("fpgay", function(module, exports) {

$parcel$export(module.exports, "getBitValueFromBool", () => $b375bbafcb145913$export$929f1500428a1fc8);
$parcel$export(module.exports, "getBoolFromBitValue", () => $b375bbafcb145913$export$27647458f3cf29d2);
const $b375bbafcb145913$export$929f1500428a1fc8 = (value)=>{
    return Number(value).toString();
};
const $b375bbafcb145913$export$27647458f3cf29d2 = (bitValue)=>{
    if (bitValue) return !!Number(bitValue);
};

});

parcelRegister("k4bKv", function(module, exports) {

$parcel$export(module.exports, "getCookie", () => $e9bd4b7e86b1280b$export$4be65e66cfa2648a);

var $M2DFp = parcelRequire("M2DFp");

var $XHGTv = parcelRequire("XHGTv");

var $5mY09 = parcelRequire("5mY09");

var $8nVWJ = parcelRequire("8nVWJ");
function $e9bd4b7e86b1280b$export$4be65e66cfa2648a(key) {
    try {
        if ((0, $XHGTv.getBooleanFF)('platform.moonjelly.browser-storage-controls')) (0, $5mY09.sendPackageOperationalEvent)({
            action: 'usedGetCookie',
            attributes: {
                cookieKey: key
            }
        });
        return key ? (0, (/*@__PURE__*/$parcel$interopDefault($M2DFp))).get(key) : (0, (/*@__PURE__*/$parcel$interopDefault($M2DFp))).get();
    } catch (e) {
        (0, $8nVWJ.Logger).errorWithOperationalEvent({
            action: 'usedGetCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use get cookie. ${e.message || ''}`
        });
    }
}

});

parcelRegister("a1QAn", function(module, exports) {

$parcel$export(module.exports, "CONSENT_DISPLAYED_TEXT_ITEMS", () => $74d2c9cd0f8fe719$export$99df83ca0f45bd54);
$parcel$export(module.exports, "COUNTRIES_PROTECTED_BY_GDPR", () => $74d2c9cd0f8fe719$export$e6e9bd4336c0a932);
$parcel$export(module.exports, "US_STATES_PROTECTED_BY_CPRA", () => $74d2c9cd0f8fe719$export$52bb595c6ed63b54);
$parcel$export(module.exports, "COUNTRIES_PROTECTED_BY_LGPD", () => $74d2c9cd0f8fe719$export$620512942d67b17);
$parcel$export(module.exports, "COUNTRIES_PROTECTED_BY_FADP", () => $74d2c9cd0f8fe719$export$aed198cf76987899);
$parcel$export(module.exports, "TIER_1_PROTECTED_LOCALES", () => $74d2c9cd0f8fe719$export$50718cdfb561e8f4);
$parcel$export(module.exports, "TIER_2_PROTECTED_LOCALES", () => $74d2c9cd0f8fe719$export$7192f4eed07dca14);
$parcel$export(module.exports, "TIER_3_UNPROTECTED_LOCALES", () => $74d2c9cd0f8fe719$export$1847f7a458b8f108);

var $3K9DW = parcelRequire("3K9DW");
const $74d2c9cd0f8fe719$export$99df83ca0f45bd54 = [
    (0, $3K9DW.CookieCategory).Analytics,
    (0, $3K9DW.CookieCategory).Functional,
    (0, $3K9DW.CookieCategory).Marketing,
    (0, $3K9DW.CookieCategory).StrictlyNecessary,
    (0, $3K9DW.CookieCategory).Unknown
];
const $74d2c9cd0f8fe719$var$COUNTRIES_WITHIN_EU = [
    'AT',
    // Austria
    'BE',
    // Belgium
    'BG',
    // Bulgaria
    'CY',
    // Republic of Cyprus
    'CZ',
    // Czech Republic
    'DE',
    // Germany
    'DK',
    // Denmark
    'EE',
    // Estonia
    'ES',
    // Spain
    'FI',
    // Finland
    'FR',
    // France
    'GR',
    // Greece
    'HR',
    // Croatia
    'HU',
    // Hungary
    'IE',
    // Ireland
    'IT',
    // Italy
    'LT',
    // Lithuania
    'LU',
    // Luxembourg
    'LV',
    // Latvia
    'MT',
    // Malta
    'NL',
    // Netherlands
    'PL',
    // Poland
    'PT',
    // Portugal
    'RO',
    // Romania
    'SE',
    // Sweden
    'SI',
    // Slovenia
    'SK' // Slovakia
];
const $74d2c9cd0f8fe719$var$COUNTRIES_WITHIN_EEA = [
    'IS',
    // Iceland
    'LI',
    // Liechtenstein
    'NO' // Norway
];
const $74d2c9cd0f8fe719$var$COUNTRIES_FORMERLY_IN_EU = [
    'UK',
    // United Kingdom
    'GB' // United Kingdom (Great Britain)
];
const $74d2c9cd0f8fe719$export$e6e9bd4336c0a932 = [
    ...$74d2c9cd0f8fe719$var$COUNTRIES_WITHIN_EU,
    ...$74d2c9cd0f8fe719$var$COUNTRIES_FORMERLY_IN_EU,
    ...$74d2c9cd0f8fe719$var$COUNTRIES_WITHIN_EEA
];
const $74d2c9cd0f8fe719$export$9925f0088a4d842c = [
    'CA',
    // Canada
    'CN',
    // China
    'IL',
    // Israel
    'JP',
    // Japan
    'QA',
    // Qatar
    'SG',
    // Singapore
    'ZA',
    // South Africa
    'KR',
    // South Korea - cited as Korea (the Republic of)
    'TR',
    // Turkey
    'TW',
    // Taiwan (Province of China)
    'HK' // Hong Kong
];
const $74d2c9cd0f8fe719$export$52bb595c6ed63b54 = [
    'US-CA' // California
];
const $74d2c9cd0f8fe719$export$620512942d67b17 = [
    'BR' // Brazil
];
const $74d2c9cd0f8fe719$export$aed198cf76987899 = [
    'CH' // Switzerland
];
const $74d2c9cd0f8fe719$export$3715da5d4fbe65b7 = [
    'US-CO',
    // Colorado
    'US-CT',
    // Connecticut
    'US-MT',
    // Montana
    'US-OR',
    // Oregon
    'US-TX',
    // Texas
    'US-UT',
    // Utah
    'US-VA' // Virginia
];
const $74d2c9cd0f8fe719$export$50718cdfb561e8f4 = [
    ...$74d2c9cd0f8fe719$export$9925f0088a4d842c,
    ...$74d2c9cd0f8fe719$export$e6e9bd4336c0a932,
    ...$74d2c9cd0f8fe719$export$620512942d67b17,
    ...$74d2c9cd0f8fe719$export$aed198cf76987899
];
const $74d2c9cd0f8fe719$export$7192f4eed07dca14 = [
    ...$74d2c9cd0f8fe719$export$52bb595c6ed63b54,
    ...$74d2c9cd0f8fe719$export$3715da5d4fbe65b7
];
const $74d2c9cd0f8fe719$export$1847f7a458b8f108 = [
    'AQ' // Antarctica
];

});

parcelRegister("eHbAt", function(module, exports) {

$parcel$export(module.exports, "ConsentHubKey", () => $ab2e11dae8c3acb7$export$31140359b1e505cf);
// If consents are present and populated, the user is authenticated and has recorded preferences.
// If consents are present but empty, the user is authenticated and has no preferences in the system.
// If consents are not present in the DB, the user is unauthenticated and has no preferences in the system.
// currentLocale will always be present if available ("UNKNOWN" if not), regardless of auth status
// localeWhenConsented will never be relevant for unauthenticated users
// Locale format: <countryCode>-<subdivisionCode> e.g. 'FR-ARA' for France, or 'US-VA' for Virginia
// SSR teams can look at the cached cookie result and pre-load that rather than fetching from CH
// SSR teams can look at the cached cookie result and pre-load that rather than fetching from CH
let $ab2e11dae8c3acb7$export$31140359b1e505cf = /*#__PURE__*/ function(ConsentHubKey) {
    ConsentHubKey["StrictlyNecessary"] = "strictlyNecessaryCookies";
    ConsentHubKey["Functional"] = "functionalCookies";
    ConsentHubKey["Analytics"] = "performanceCookies";
    ConsentHubKey["Marketing"] = "targetingCookies";
    ConsentHubKey["Unknown"] = "unknownCookies";
    return ConsentHubKey;
}({});

});



parcelRegister("aiuhL", function(module, exports) {

$parcel$export(module.exports, "checkTokenValidity", () => $77f313df9adbbb1f$export$f554752e765bc641);
$parcel$export(module.exports, "packUserPreferences", () => $77f313df9adbbb1f$export$3199823fec979bd1);
$parcel$export(module.exports, "unpackUserPreferencesCookie", () => $77f313df9adbbb1f$export$8d213cb390bab4fa);
$parcel$export(module.exports, "initialPreferencesAreMissing", () => $77f313df9adbbb1f$export$67f70eb55341bd29);
$parcel$export(module.exports, "handleInitialPreferencesData", () => $77f313df9adbbb1f$export$9dbe8b0fdea9edf3);

var $XHGTv = parcelRequire("XHGTv");

var $fpgay = parcelRequire("fpgay");

var $3cif2 = parcelRequire("3cif2");

var $jeGRo = parcelRequire("jeGRo");

var $3K9DW = parcelRequire("3K9DW");

var $kRieG = parcelRequire("kRieG");
const $77f313df9adbbb1f$export$f554752e765bc641 = (consentToken)=>{
    if (consentToken.length < 3) // Wrong format, no version
    return {
        isValid: false,
        isV001: false,
        isV002: false
    };
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV001 = version === (0, $3cif2.V001_SCHEMA_KEY) && consentToken.length === 7;
    const isV002 = version === (0, $3cif2.V002_SCHEMA_KEY) && consentToken.length === 12;
    // We support version 001 and 002 only
    const isSupportedVersion = [
        (0, $3cif2.V001_SCHEMA_KEY),
        (0, $3cif2.V002_SCHEMA_KEY)
    ].includes(version);
    const isValid = isSupportedVersion && (isV001 || isV002);
    return {
        isValid: isValid,
        isV001: isV001,
        isV002: isV002
    };
};
/* Schema Version 001:
---------------------------------------------------
  - Format 0000000
  - 001 (schema version 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies disabled/enabled)
*/ const $77f313df9adbbb1f$var$packPrefsVersion001 = (userPreferences)=>{
    const version = (0, $3cif2.V001_SCHEMA_KEY);
    return [
        version,
        (0, $fpgay.getBitValueFromBool)(userPreferences.FUNCTIONAL),
        (0, $fpgay.getBitValueFromBool)(userPreferences.ANALYTICS),
        (0, $fpgay.getBitValueFromBool)(userPreferences.MARKETING),
        (0, $fpgay.getBitValueFromBool)(userPreferences.UNKNOWN)
    ].join('');
};
const $77f313df9adbbb1f$var$unpackPrefsVersion001 = (userPreferencesCookie)=>{
    if (userPreferencesCookie.length !== 7) // Wrong length for version 001
    return;
    return {
        [(0, $3K9DW.CookieCategory).StrictlyNecessary]: true,
        // always allowed
        [(0, $3K9DW.CookieCategory).Functional]: userPreferencesCookie[3] === '1',
        [(0, $3K9DW.CookieCategory).Analytics]: userPreferencesCookie[4] === '1',
        [(0, $3K9DW.CookieCategory).Marketing]: userPreferencesCookie[5] === '1',
        [(0, $3K9DW.CookieCategory).Unknown]: userPreferencesCookie[6] === '1'
    };
};
/* Schema Version 002:
---------------------------------------------------
  - Format 000000000000
  - 002 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, consent records are unavailable from ConsentHub (logged out) - yes/no)
  - 0/1 (1 digit, consents saved while in GDPR locale (Europe) - yes/no)
  - 0/1 (1 digit, consents saved while in CPRA locale (CPRA will act as 'all USA' bucket) - yes/no)
  - 0/1 (1 digit, consents saved while in LGPD locale (Brazil) - yes/no)
  - 0/1 (1 digit, consents saved while in FADP locale (Switzerland) - yes/no)
*/ const $77f313df9adbbb1f$var$packPrefsVersion002 = (userPreferences)=>{
    const version = (0, $3cif2.V002_SCHEMA_KEY);
    return [
        version,
        (0, $fpgay.getBitValueFromBool)(userPreferences[(0, $3K9DW.CookieCategory).Functional]),
        (0, $fpgay.getBitValueFromBool)(userPreferences[(0, $3K9DW.CookieCategory).Analytics]),
        (0, $fpgay.getBitValueFromBool)(userPreferences[(0, $3K9DW.CookieCategory).Marketing]),
        (0, $fpgay.getBitValueFromBool)(userPreferences[(0, $3K9DW.CookieCategory).Unknown]),
        (0, $fpgay.getBitValueFromBool)(userPreferences[(0, $3K9DW.ConsentPreference).ConsentDataUnavailable]),
        (0, $fpgay.getBitValueFromBool)(userPreferences[(0, $3K9DW.ConsentPreference).ConsentedUnderGDPR]),
        (0, $fpgay.getBitValueFromBool)(userPreferences[(0, $3K9DW.ConsentPreference).ConsentedUnderCPRA]),
        (0, $fpgay.getBitValueFromBool)(userPreferences[(0, $3K9DW.ConsentPreference).ConsentedUnderLGPD]),
        (0, $fpgay.getBitValueFromBool)(userPreferences[(0, $3K9DW.ConsentPreference).ConsentedUnderFADP])
    ].join('');
};
const $77f313df9adbbb1f$var$unpackPrefsVersion002 = (userPreferencesCookie)=>{
    return {
        [(0, $3K9DW.CookieCategory).StrictlyNecessary]: true,
        // always allowed
        [(0, $3K9DW.CookieCategory).Functional]: userPreferencesCookie[3] === '1',
        [(0, $3K9DW.CookieCategory).Analytics]: userPreferencesCookie[4] === '1',
        [(0, $3K9DW.CookieCategory).Marketing]: userPreferencesCookie[5] === '1',
        [(0, $3K9DW.CookieCategory).Unknown]: userPreferencesCookie[6] === '1',
        [(0, $3K9DW.ConsentPreference).ConsentDataUnavailable]: userPreferencesCookie[7] === '1',
        [(0, $3K9DW.ConsentPreference).ConsentedUnderGDPR]: userPreferencesCookie[8] === '1',
        [(0, $3K9DW.ConsentPreference).ConsentedUnderCPRA]: userPreferencesCookie[9] === '1',
        [(0, $3K9DW.ConsentPreference).ConsentedUnderLGPD]: userPreferencesCookie[10] === '1',
        [(0, $3K9DW.ConsentPreference).ConsentedUnderFADP]: userPreferencesCookie[11] === '1'
    };
};
const $77f313df9adbbb1f$var$V002SpecificBitKeys = [
    (0, $3K9DW.ConsentPreference).ConsentDataUnavailable,
    (0, $3K9DW.ConsentPreference).ConsentedUnderGDPR,
    (0, $3K9DW.ConsentPreference).ConsentedUnderCPRA,
    (0, $3K9DW.ConsentPreference).ConsentedUnderLGPD,
    (0, $3K9DW.ConsentPreference).ConsentedUnderFADP
];
function $77f313df9adbbb1f$export$3199823fec979bd1(userPreferences) {
    if (!(0, $XHGTv.getBooleanFF)('platform.moonjelly.browser-storage-controls-v2')) return $77f313df9adbbb1f$var$packPrefsVersion001(userPreferences);
    const isV002 = $77f313df9adbbb1f$var$V002SpecificBitKeys.every((key)=>key in userPreferences);
    if (isV002) return $77f313df9adbbb1f$var$packPrefsVersion002(userPreferences);
    // Fallback to V001
    return $77f313df9adbbb1f$var$packPrefsVersion001(userPreferences);
}
function $77f313df9adbbb1f$export$8d213cb390bab4fa(userPreferencesCookie) {
    if (!(0, $XHGTv.getBooleanFF)('platform.moonjelly.browser-storage-controls-v2')) {
        if (userPreferencesCookie.length < 3) // Wrong format, no version
        return;
        const version = userPreferencesCookie[0] + userPreferencesCookie[1] + userPreferencesCookie[2];
        if (version === (0, $3cif2.V001_SCHEMA_KEY)) return $77f313df9adbbb1f$var$unpackPrefsVersion001(userPreferencesCookie);
        return;
    }
    const { isValid: isValid, isV001: isV001, isV002: isV002 } = $77f313df9adbbb1f$export$f554752e765bc641(userPreferencesCookie);
    if (!isValid) // We support version 001 and 002 only
    return;
    if (isV001) return $77f313df9adbbb1f$var$unpackPrefsVersion001(userPreferencesCookie);
    if (isV002) return $77f313df9adbbb1f$var$unpackPrefsVersion002(userPreferencesCookie);
}
const $77f313df9adbbb1f$export$67f70eb55341bd29 = (initialPreferences)=>{
    if (!initialPreferences) return true;
    const prefExistButAreEmpty = Object.keys(initialPreferences).length === 0;
    return prefExistButAreEmpty;
};
const $77f313df9adbbb1f$export$9dbe8b0fdea9edf3 = (initialPreferences)=>{
    if (initialPreferences !== (0, $3K9DW.PrefetchedPreferenceState).INTERNAL) {
        var _initialPreferences$c;
        if ($77f313df9adbbb1f$export$67f70eb55341bd29(initialPreferences)) // Failsafe handling: Consumer failed to provide data even though they have prefetched, so we need to fetch again
        // This may occur if a consumer's prefetch requests fails, or if they fail to implement the system correctly
        return (0, $3K9DW.PrefetchedPreferenceState).INTERNAL;
        // If initialPreferences is not INTERNAL on first render, we have been provided a pre-fetched
        // value, which means we don't need to make a fetch to storage or ConsentHub to get it.
        // If that preference is defined, we persist it to our local cookie set
        // If the data is a ConsentHubResponse/PrefetchedConsentCookieData, we'll need to transform it properly before consumption
        const consentToken = initialPreferences === null || initialPreferences === void 0 ? void 0 : initialPreferences.consentToken;
        const prefetchedLocale = (_initialPreferences$c = initialPreferences === null || initialPreferences === void 0 ? void 0 : initialPreferences.currentLocale) !== null && _initialPreferences$c !== void 0 ? _initialPreferences$c : 'UNKNOWN';
        // If this data comes from prefetching, we'll have no way to capture the existing locale if we don't set here
        (0, $kRieG.setCurrentLocaleCookie)(prefetchedLocale);
        if (consentToken) {
            // We already have a consent cookie that was passed in, let's not override it by setting it again
            const unpackedExistingPrefs = $77f313df9adbbb1f$export$8d213cb390bab4fa(consentToken);
            return unpackedExistingPrefs !== null && unpackedExistingPrefs !== void 0 ? unpackedExistingPrefs : (0, $3K9DW.PrefetchedPreferenceState).INTERNAL;
        }
        const serializedPrefetchedConsentToken = (0, $jeGRo.serializeConsents)(initialPreferences);
        const unpackedPrefetchedPrefs = $77f313df9adbbb1f$export$8d213cb390bab4fa(serializedPrefetchedConsentToken);
        return unpackedPrefetchedPrefs || (0, $3K9DW.PrefetchedPreferenceState).INTERNAL;
    }
    // If we've fallen into this, EMPTY implies we have no data at all
    // INTERNAL implies we still need to fetch new data, so trigger a refetch
    return initialPreferences;
};

});
parcelRegister("kRieG", function(module, exports) {

$parcel$export(module.exports, "setCurrentLocaleCookie", () => $f2f6e7222e4aba72$export$400bc9125a950b71);
$parcel$export(module.exports, "setConsentTokenCookie", () => $f2f6e7222e4aba72$export$8e560d0760f733a2);
$parcel$export(module.exports, "setConsentTokenFallbackCookie", () => $f2f6e7222e4aba72$export$133cd762b0f705a2);
$parcel$export(module.exports, "setShouldShowBannerCookie", () => $f2f6e7222e4aba72$export$99ecece88c58d938);
$parcel$export(module.exports, "setRequiredConsentCookies", () => $f2f6e7222e4aba72$export$b3365240280cb3c3);

var $fpgay = parcelRequire("fpgay");

var $3cif2 = parcelRequire("3cif2");

var $i4rOz = parcelRequire("i4rOz");

var $fT6gI = parcelRequire("fT6gI");
const $f2f6e7222e4aba72$export$400bc9125a950b71 = (locale)=>{
    const inTenMinutes = new Date();
    inTenMinutes.setTime(inTenMinutes.getTime() + 600000);
    (0, $fT6gI.setStrictlyNecessaryCookie)((0, $3cif2.ATLASSIAN_CURRENT_LOCALE_COOKIE_KEY), locale, {
        expires: inTenMinutes,
        path: '/'
    });
};
const $f2f6e7222e4aba72$export$8e560d0760f733a2 = (consentToken)=>{
    const inTenMinutes = new Date();
    inTenMinutes.setTime(inTenMinutes.getTime() + 600000);
    (0, $fT6gI.setStrictlyNecessaryCookie)((0, $3cif2.ATLASSIAN_CONSENT_COOKIE_KEY), consentToken, {
        expires: inTenMinutes,
        path: '/'
    });
};
const $f2f6e7222e4aba72$export$133cd762b0f705a2 = (consentToken)=>{
    const inOneYear = new Date();
    inOneYear.setFullYear(inOneYear.getFullYear() + 1);
    (0, $fT6gI.setStrictlyNecessaryCookie)((0, $3cif2.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY), consentToken, {
        expires: inOneYear,
        path: '/'
    });
};
const $f2f6e7222e4aba72$export$99ecece88c58d938 = (consentToken, currentLocale, consentTimestamp)=>{
    // Since we have no good way to reference this as a global state object, we want to precomute and store the
    // banner visibility in a temporary, session-scope cookie (same eexpiry as the other cookies), which we can
    // lookup in the UI as needed
    const bannerVisibility = (0, $i4rOz.getBannerVisibilityByLocale)({
        consentToken: consentToken,
        currentLocale: currentLocale,
        consentTimestamp: consentTimestamp
    });
    const shouldShowBanner = (0, $fpgay.getBitValueFromBool)(!!bannerVisibility);
    const inTenMinutes = new Date();
    inTenMinutes.setTime(inTenMinutes.getTime() + 600000);
    (0, $fT6gI.setStrictlyNecessaryCookie)((0, $3cif2.ATLASSIAN_SHOW_BANNER_COOKIE_KEY), shouldShowBanner, {
        expires: inTenMinutes,
        path: '/'
    });
};
const $f2f6e7222e4aba72$export$b3365240280cb3c3 = (consentToken, currentLocale, consentTimestamps)=>{
    $f2f6e7222e4aba72$export$400bc9125a950b71(currentLocale);
    $f2f6e7222e4aba72$export$8e560d0760f733a2(consentToken);
    $f2f6e7222e4aba72$export$99ecece88c58d938(consentToken, currentLocale, consentTimestamps);
};

});
parcelRegister("i4rOz", function(module, exports) {

$parcel$export(module.exports, "getBannerVisibilityByLocale", () => $d27e2d26e9d68045$export$7fa400e2bdf2a07b);

var $fpgay = parcelRequire("fpgay");

var $3cif2 = parcelRequire("3cif2");

var $jeGRo = parcelRequire("jeGRo");

var $k4bKv = parcelRequire("k4bKv");
const $d27e2d26e9d68045$export$353f4b896c7c60ec = ({ consentToken: consentToken, currentLocale: currentLocale })=>{
    if (!currentLocale || currentLocale === 'UNKNOWN') return true; // If we don't know the locale, we should show the banner, so consider it stronger
    const consentedUnderGDPR = !!Number(consentToken[8]);
    const consentedUnderCPRA = !!Number(consentToken[9]);
    const consentedUnderLGPD = !!Number(consentToken[10]);
    const consentedUnderFADP = !!Number(consentToken[11]);
    const userConsentedInTier1 = consentedUnderGDPR || consentedUnderLGPD || consentedUnderFADP;
    const userConsentedInTier2 = consentedUnderCPRA;
    const currentLocaleInTier1 = (0, $jeGRo.isLocaleCoveredByTier1Policies)(currentLocale);
    const currentLocaleInTier2 = (0, $jeGRo.isLocaleCoveredByTier2Policies)(currentLocale);
    // Tier 1, strong privacy regulations
    if (currentLocaleInTier1) {
        // If user is within Tier 1 locale, but hasn't consented in Tier 1, then currentLocale must be stronger
        // If they have consented in Tier 1, currentLocale is equivalent (don't show banner)
        const currentLocaleStronger = !userConsentedInTier1;
        return currentLocaleStronger;
    }
    // Tier 2, weaker privacy regulations
    if (currentLocaleInTier2) {
        if (!userConsentedInTier2) {
            // If they haven't consented in this tier, but consentedInT1, currentLocale is weaker. consentedInT3, it's stronger
            const currentLocaleStronger = !userConsentedInTier1;
            return currentLocaleStronger;
        }
        // If the user has consented in Tier 2, currentLocale is equivalent (don't show banner)
        return false;
    }
    // Tier 3, weakest privacy regulations
    // If we're not in any other tier, we must be in a region with no privacy regulations
    const consentedInStrongerTier = userConsentedInTier1 || userConsentedInTier2;
    if (consentedInStrongerTier) // If user has made consents somewhere (with laws), but are currently outside of any regional protection laws
    // therefore, the currentLocale must be weaker (don't show banner)
    return false;
    // If they've never consented under any regional protection laws (in any tier), they're either default or somehow consented outside of protection laws
    // The currentLocale doesn't have any protections, so we should hide the banner anyway, e.g. consider currentLocale weaker
    return false;
};
const $d27e2d26e9d68045$export$7fa400e2bdf2a07b = ({ consentToken: consentToken, currentLocale: currentLocale, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsentToken })=>{
    // Best effort to populate all these values if they're missing
    const fallbackConsents = fallbackConsentToken || (0, $k4bKv.getCookie)((0, $3cif2.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    const locale = currentLocale || (0, $k4bKv.getCookie)((0, $3cif2.ATLASSIAN_CURRENT_LOCALE_COOKIE_KEY));
    const localeIsValid = locale && locale !== 'UNKNOWN';
    if (localeIsValid) {
        // We have consent token. Consents are either default, or legitimate (local only or persisted).
        const consentDataUnavailableBit = consentToken[7]; // Logged out users will have this bit set to 1
        const isLoggedOutConsent = (0, $fpgay.getBoolFromBitValue)(consentDataUnavailableBit);
        const userConsentedUnderPrivacyProtections = (0, $jeGRo.checkIfTokenHasAConsentLocale)(consentToken);
        // If user has consented somewhere, but can't save to ConsentHub (unavailable bit), this is a local-only user
        const localOnlyConsent = isLoggedOutConsent && userConsentedUnderPrivacyProtections;
        // If user hasn't consented with privacy laws, and they're logged in, this is a default consent
        const isDefaultAuthenticatedConsent = !isLoggedOutConsent && !userConsentedUnderPrivacyProtections;
        // If user hasn't consented with privacy laws, and they're logged out, this is a default consent
        const isDefaultUnauthenticatedConsent = isLoggedOutConsent && !userConsentedUnderPrivacyProtections;
        const localeWarrantsBanner = (0, $jeGRo.isLocaleCoveredByAnyPrivacyActs)(locale);
        // Unauthed/logged out user flow
        if (isDefaultUnauthenticatedConsent) {
            // If it's a default, unauthed, set of consents, lacking a fallback
            // we should hide/show depending on locale, as we know they've never consented in the past year
            // However, if we defaults + fallback, then we may have a discrepancy where ConsentHub is unavailable or they're logged out
            // but we have consented previously (which is the only way to save to the fallback)
            if (fallbackConsents) {
                const fallbackUnavailableBit = fallbackConsents[7];
                const isUnauthenticatedFallbackConsent = (0, $fpgay.getBoolFromBitValue)(fallbackUnavailableBit);
                const fallbackConsentedSomewhere = (0, $jeGRo.checkIfTokenHasAConsentLocale)(fallbackConsents);
                // Check if the fallback is from a logged out consent (localOnlyConsent)—
                // if so, they're logged out and saved while logged out, only show if they're in a stronger region than when they consented
                const localOnlyConsent = isUnauthenticatedFallbackConsent && fallbackConsentedSomewhere;
                if (localOnlyConsent) {
                    const showBannerIfCurrentLocaleIsStronger = $d27e2d26e9d68045$export$353f4b896c7c60ec({
                        consentToken: fallbackConsents,
                        currentLocale: locale
                    });
                    return showBannerIfCurrentLocaleIsStronger;
                }
                // Or if it is from a logged in consent, and they've consented somewhere (they must have)
                const loggedOutUserPreviouslyConsentedWhileLoggedIn = !isUnauthenticatedFallbackConsent && fallbackConsentedSomewhere;
                if (loggedOutUserPreviouslyConsentedWhileLoggedIn) {
                    const showBannerIfCurrentLocaleIsStronger = $d27e2d26e9d68045$export$353f4b896c7c60ec({
                        consentToken: fallbackConsents,
                        currentLocale: locale
                    });
                    return showBannerIfCurrentLocaleIsStronger;
                }
            }
            return localeWarrantsBanner;
        }
        // Authed/logged in user flow
        if (isDefaultAuthenticatedConsent) {
            // If it's a default, authed, set of consents, lacking a fallback
            // we should hide/show depending on locale, as we know they've never consented in the past year
            // However, if we defaults + fallback, defer to locale requirements because we can actually compare against locales
            if (fallbackConsents) {
                const fallbackUnavailableBit = fallbackConsents[7];
                const isUnauthenticatedFallbackConsent = (0, $fpgay.getBoolFromBitValue)(fallbackUnavailableBit);
                const fallbackConsentedSomewhere = (0, $jeGRo.checkIfTokenHasAConsentLocale)(fallbackConsents);
                const loggedInUserPreviouslyConsentedWhileLoggedOut = isUnauthenticatedFallbackConsent && fallbackConsentedSomewhere;
                if (loggedInUserPreviouslyConsentedWhileLoggedOut) {
                    // They've saved a fallback while logged out (fallback bit is 1), then fetched from CH,
                    // which sets authed consent defaults (bit 0)
                    // However, we don't want to use defaults here, because they've consented in the past year
                    // and we don't want to inadvertently show them a banner again. Instead, lets run the strength check with the fallback
                    const showBannerIfCurrentLocaleIsStronger = $d27e2d26e9d68045$export$353f4b896c7c60ec({
                        consentToken: fallbackConsents,
                        currentLocale: locale
                    });
                    return showBannerIfCurrentLocaleIsStronger;
                }
            }
            return localeWarrantsBanner;
        }
        const showBannerIfCurrentLocaleIsStronger = $d27e2d26e9d68045$export$353f4b896c7c60ec({
            consentToken: consentToken,
            currentLocale: locale
        });
        if (localOnlyConsent) {
            // User has consented previously, compare regional strength, and then check if the fallback exists (consented within a year)
            // to determine if we should show the banner
            if (!showBannerIfCurrentLocaleIsStronger) // If they're a localOnly user, they will not have a timestamp to validate against
            // So if fallback cookie exists, they've consented in the past year, do not show
            // If it does not exist, we should show the banner, because they're stale
            return fallbackConsents ? false : true;
            // Forcibly show the banner because we're in a stronger locale
            return true;
        }
        // If we're a logged in user (!isLoggedOutConsent && userConsentedUnderPrivacyProtections;)
        // We're not default or local-only, so we should be running normal logic as these are legitimate consents
        // If currentLocale is stronger (>>) than consentedLocale, we would show the banner
        // even if the timestamp is within a year
        // If currentLocale is weaker (<<) than consentedLocale or equivalent, we would not show the banner
        // Unless the timestamp is over a year old, e.g. consents are stale
        if (!showBannerIfCurrentLocaleIsStronger) {
            // If we don't, we can check the existence of the fallback (1yr) cookie
            if (!consentTimestamp) // We could assume since they've consented recently, we don't have to show the banner if this is missing but, to be safe we should
            return fallbackConsents ? false : true;
            // If we have a timestamp to check against, do it, ensure it's not stale. Show banner if it is.
            return (0, $jeGRo.checkIfConsentsAreStale)(consentTimestamp);
        }
        // Forcibly show the banner because we're in a stronger locale
        return true;
    }
    // If we're here, we cant find a locale to compare with, or it's here and UNKNOWN
    // To be as compliant as possible, we should show the banner regardless of if they've consented or not
    // The risk here is somebody who does not need to consent gets show the banner inadvertently.
    return true;
};

});

parcelRegister("fT6gI", function(module, exports) {

$parcel$export(module.exports, "setStrictlyNecessaryCookie", () => $b910dae8829db4f5$export$93509ff9a62ee022);

var $M2DFp = parcelRequire("M2DFp");

var $XHGTv = parcelRequire("XHGTv");

var $5mY09 = parcelRequire("5mY09");

var $8nVWJ = parcelRequire("8nVWJ");
const $b910dae8829db4f5$export$93509ff9a62ee022 = (key, value, attributes)=>{
    try {
        if ((0, $XHGTv.getBooleanFF)('platform.moonjelly.browser-storage-controls')) (0, $5mY09.sendPackageOperationalEvent)({
            action: 'usedSetStrictlyNecessaryCookie',
            attributes: {
                cookieKey: key
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($M2DFp))).set(key, value, {
            ...attributes,
            'atl-set-cookie': true
        });
    } catch (e) {
        (0, $8nVWJ.Logger).errorWithOperationalEvent({
            action: 'usedSetStrictlyNecessaryCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use set strictly necessary cookie. ${e.message || ''}`
        });
    }
};

});




parcelRegister("aqZcy", function(module, exports) {

$parcel$export(module.exports, "getCookie", () => $5345d14aecffdbc4$export$4be65e66cfa2648a);

var $k4bKv = parcelRequire("k4bKv");
function $5345d14aecffdbc4$export$4be65e66cfa2648a(key) {
    return key ? (0, $k4bKv.getCookie)(key) : (0, $k4bKv.getCookie)();
}

});

parcelRegister("8yXY1", function(module, exports) {

$parcel$export(module.exports, "consentBannerUserPreferencesResource", () => $9d378f53ff5588a3$export$785c22104b6f2285);
$parcel$export(module.exports, "useConsentBannerUserPreferencesResource", () => $9d378f53ff5588a3$export$5bc7e83e85567fb4);
// eslint-disable-next-line jira/import-whitelist

var $3cif2 = parcelRequire("3cif2");

var $aqZcy = parcelRequire("aqZcy");

var $lRmyA = parcelRequire("lRmyA");

var $3HCkE = parcelRequire("3HCkE");

const $9d378f53ff5588a3$export$785c22104b6f2285 = (0, $3HCkE.createResource)({
    type: (0, $915023b8afa83aa8$export$c5397b7748ed6c7b),
    getKey: ()=>(0, $915023b8afa83aa8$export$4a9dd42dbc707155),
    getData: async ()=>{
        const consentToken = (0, $aqZcy.getCookie)((0, $3cif2.ATLASSIAN_CONSENT_COOKIE_KEY));
        const currentLocale = (0, $aqZcy.getCookie)((0, $3cif2.ATLASSIAN_CURRENT_LOCALE_COOKIE_KEY));
        const fallbackConsentToken = (0, $aqZcy.getCookie)((0, $3cif2.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
        // If we have cached cookie data, bundle it up, with a potential fallback token
        if (consentToken && currentLocale) return {
            consentToken: consentToken,
            currentLocale: currentLocale,
            fallbackConsentToken: fallbackConsentToken
        };
        const data = await (0, $lRmyA.performGetRequest)('/gateway/api/consenthub/session/user/consents/cookies');
        return data;
    },
    maxAge: 900000,
    isBrowserOnly: true
});
const $9d378f53ff5588a3$export$5bc7e83e85567fb4 = ()=>(0, $3HCkE.useResource)($9d378f53ff5588a3$export$785c22104b6f2285);

});
const $915023b8afa83aa8$export$c5397b7748ed6c7b = 'CONSENT_BANNER_USER_PREFERENCES';
const $915023b8afa83aa8$export$4a9dd42dbc707155 = 'CONSENT_BANNER_USER_PREFERENCES_KEY';


parcelRegister("4zIA4", function(module, exports) {

$parcel$export(module.exports, "isInIframe", () => $1e803e8843969244$export$9f140ed41af5108c);
$parcel$export(module.exports, "useCookieConsentBannerSettings", () => $1e803e8843969244$export$ae97931560f092a4);
$parcel$export(module.exports, "useCookieConsentBannerSettingsActions", () => $1e803e8843969244$export$ecbab4dc5f9ad844);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $k4bKv = parcelRequire("k4bKv");
var $3cif2 = parcelRequire("3cif2");

var $1ybV0 = parcelRequire("1ybV0");
function $1e803e8843969244$export$8d213cb390bab4fa(userPreferencesCookie) {
    // Format 0000000
    // 000 (schema version 3 digits)
    // 0/1 (1 digit, FUNCTIONAL cookies disabled/enabled)
    // 0/1 (1 digit, ANALYTICS cookies disabled/enabled)
    // 0/1 (1 digit, MARKETING cookies disabled/enabled)
    // 0/1 (1 digit, UNKNOWN cookies disabled/enabled)
    if (userPreferencesCookie.length < 3) // Wrong format, no version
    return;
    const version = userPreferencesCookie[0] + userPreferencesCookie[1] + userPreferencesCookie[2];
    if (version !== '001') // We support version 001 only
    return;
    if (userPreferencesCookie.length !== 7) // Wrong length for version 001
    return;
    return {
        STRICTLY_NECESSARY: true,
        FUNCTIONAL: userPreferencesCookie[3] === '1',
        ANALYTICS: userPreferencesCookie[4] === '1',
        MARKETING: userPreferencesCookie[5] === '1',
        UNKNOWN: userPreferencesCookie[6] === '1'
    };
}
const $1e803e8843969244$export$1de6a888ae076ff8 = ()=>{
    if (false) return undefined;
    const packedPrefs = (0, $k4bKv.getCookie)((0, $3cif2.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY));
    if (!packedPrefs) return undefined;
    return $1e803e8843969244$export$8d213cb390bab4fa(packedPrefs);
};
const $1e803e8843969244$export$9f140ed41af5108c = ()=>{
    if (false) return false;
    return window !== window.top;
};
const $1e803e8843969244$export$aa1483cc2e197f6e = ()=>{
    if (false) return false;
    if ((0, $1ybV0.ff)('platform.moonjelly.browser-storage-controls-v2')) return true;
    return $1e803e8843969244$export$1de6a888ae076ff8() !== undefined || $1e803e8843969244$export$9f140ed41af5108c();
};
const $1e803e8843969244$export$d4c72bab9d6cc13a = {
    isDismissed: $1e803e8843969244$export$aa1483cc2e197f6e(),
    height: 0
};
const $1e803e8843969244$export$e324594224ef24da = {
    onShow: ()=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                isDismissed: false
            });
        },
    onDismiss: ()=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                isDismissed: true
            });
        },
    setHeight: (height)=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                height: height
            });
        }
};
const $1e803e8843969244$var$Store = (0, $a61MH.createStore)({
    name: 'cookie-consent-banner',
    initialState: $1e803e8843969244$export$d4c72bab9d6cc13a,
    actions: $1e803e8843969244$export$e324594224ef24da
});
const $1e803e8843969244$export$ae97931560f092a4 = (0, $ggKAj.createHook)($1e803e8843969244$var$Store);
const $1e803e8843969244$export$ecbab4dc5f9ad844 = (0, $ggKAj.createActionsHook)($1e803e8843969244$var$Store);

});


parcelRegister("dFuN9", function(module, exports) {

$parcel$export(module.exports, "useBannerIPBlocklisting", () => $819d943e99d1c80d$export$564412c1d9cd4ccc);

var $eUqFw = parcelRequire("eUqFw");

var $ds5Im = parcelRequire("ds5Im");

var $4IEye = parcelRequire("4IEye");
const $819d943e99d1c80d$export$564412c1d9cd4ccc = ()=>{
    const [shouldShowBanner, setBannerState] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $ds5Im.loadBridgeWeak)({
            name: 'jira/global-components/ipblocklisting/bridge'
        }).then((bridge)=>{
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            bridge({
                showIPBlocklistBanner: ()=>setBannerState(true),
                hideIPBlocklistBanner: ()=>setBannerState(false)
            });
        });
    }, []);
    return (0, $eUqFw.useMemo)(()=>({
            isEnabled: shouldShowBanner,
            name: (0, $4IEye.BANNER_NAME),
            height: (0, $4IEye.bannerHeight)
        }), [
        shouldShowBanner
    ]);
};

});

parcelRegister("4kPIV", function(module, exports) {

$parcel$export(module.exports, "useBannerAnnouncement", () => $3578e31f85c09ba1$export$1e775b1ab04f2888);

var $eUqFw = parcelRequire("eUqFw");

var $a5Lgz = parcelRequire("a5Lgz");

var $1ybV0 = parcelRequire("1ybV0");

var $6yplV = parcelRequire("6yplV");

var $NzrZv = parcelRequire("NzrZv");
const $3578e31f85c09ba1$export$1e775b1ab04f2888 = ()=>{
    const { data: data } = (0, $1ybV0.ff)('gravity.announcement-banner.enable-adf_33eic') ? (0, $a5Lgz.useAnnouncementBannerSettingsV4Resource)() : (0, $a5Lgz.useAnnouncementBannerSettingsResource)();
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    return (0, $eUqFw.useMemo)(()=>({
            isEnabled: Boolean(data?.isEnabled) && !data?.isDismissed && (data?.visibility === 'private' && !isAnonymous || data?.visibility === 'public'),
            name: (0, $NzrZv.NAME),
            height: (0, $NzrZv.HEIGHT)
        }), [
        data?.isDismissed,
        data?.isEnabled,
        data?.visibility,
        isAnonymous
    ]);
};

});
parcelRegister("a5Lgz", function(module, exports) {

$parcel$export(module.exports, "announcementBannerSettingsResource", () => $7a3ce10da4ecebac$export$2a421cd16fa9a95a);
$parcel$export(module.exports, "announcementBannerSettingsV4Resource", () => $7a3ce10da4ecebac$export$8fbe7f8de07afffd);
$parcel$export(module.exports, "useAnnouncementBannerSettingsResource", () => $7a3ce10da4ecebac$export$43d4950a3e443fd3);
$parcel$export(module.exports, "useAnnouncementBannerSettingsV4Resource", () => $7a3ce10da4ecebac$export$6fb72f4a0c177494);
// eslint-disable-next-line jira/restricted/@atlassian/jira-router

var $3HCkE = parcelRequire("3HCkE");

var $jF6Sk = parcelRequire("jF6Sk");
var $iXfYO = parcelRequire("iXfYO");
var $6abiR = parcelRequire("6abiR");
const $7a3ce10da4ecebac$export$2a421cd16fa9a95a = (0, $3HCkE.createResource)({
    type: 'ANNOUNCEMENT_BANNER_SETTINGS',
    getKey: ()=>'settings',
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>{
        const [settings, hashIdLastDimissed] = await Promise.all([
            (0, $jF6Sk.get)(),
            (0, $6abiR.get)(atlassianAccountId)
        ]);
        return {
            ...settings,
            isDismissable: isAnonymous ? false : settings?.isDismissable,
            isDismissed: isAnonymous ? false : settings?.hashId === hashIdLastDimissed
        };
    },
    maxAge: 900000
});
const $7a3ce10da4ecebac$export$8fbe7f8de07afffd = (0, $3HCkE.createResource)({
    type: 'ANNOUNCEMENT_BANNER_SETTINGS_V4',
    getKey: ()=>'settings',
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>{
        const [settings, hashIdLastDimissed] = await Promise.all([
            (0, $iXfYO.get)(),
            (0, $6abiR.get)(atlassianAccountId)
        ]);
        return {
            ...settings,
            isDismissable: isAnonymous ? false : settings?.isDismissable,
            isDismissed: isAnonymous ? false : settings?.hashId === hashIdLastDimissed
        };
    },
    maxAge: 900000
});
const $7a3ce10da4ecebac$export$43d4950a3e443fd3 = ()=>(0, $3HCkE.useResource)($7a3ce10da4ecebac$export$2a421cd16fa9a95a);
const $7a3ce10da4ecebac$export$6fb72f4a0c177494 = ()=>(0, $3HCkE.useResource)($7a3ce10da4ecebac$export$8fbe7f8de07afffd);

});
parcelRegister("jF6Sk", function(module, exports) {

$parcel$export(module.exports, "get", () => $baaff1b2e6f1885b$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $baaff1b2e6f1885b$export$adaa4cf7ef1b65be);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

const $baaff1b2e6f1885b$export$3988ae62b71be9a3 = async ()=>{
    try {
        return await (0, $lRmyA.performGetRequest)('/rest/internal/3/announcement-banner');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 403 - banner is set to private and user is anonymous
        if (error.statusCode === 403) return {
            message: '',
            isEnabled: false,
            isDismissable: false,
            visibility: 'private',
            hashId: ''
        };
        (0, $guiFP.trackFetchErrors)({
            error: error,
            id: 'settingsGet',
            packageName: (0, $6015420733166380$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};
const $baaff1b2e6f1885b$export$adaa4cf7ef1b65be = async (body)=>{
    try {
        return await (0, $lRmyA.performPostRequest)('/rest/internal/3/announcement-banner', {
            body: JSON.stringify(body)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.trackFetchErrors)({
            error: error,
            id: 'settingsSet',
            packageName: (0, $6015420733166380$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};

});
const $6015420733166380$export$b8b9d90f9e5bd72b = '@atlassian/jira-admin-pages-system-ui-announcement-banner-resources';
const $6015420733166380$export$5e0c0e8c940630f8 = 'private';
const $6015420733166380$export$1d5a5b6462188eb3 = 'public';


parcelRegister("iXfYO", function(module, exports) {

$parcel$export(module.exports, "get", () => $58a9dca49db86568$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $58a9dca49db86568$export$adaa4cf7ef1b65be);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $58a9dca49db86568$export$3988ae62b71be9a3 = async ()=>{
    try {
        return await (0, $lRmyA.performGetRequest)('/rest/internal/4/announcement-banner');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 403 - banner is set to private and user is anonymous
        if (error.statusCode === 403) return {
            content: '',
            bgColor: 'grey',
            isEnabled: false,
            isDismissable: false,
            visibility: 'private',
            hashId: ''
        };
        (0, $guiFP.default)({
            meta: {
                id: 'settingsV4Get',
                packageName: 'jiraAdminPagesSystemUiAnnouncementBannerResources',
                teamName: 'jira-cosmos'
            },
            error: error
        });
        throw error;
    }
};
const $58a9dca49db86568$export$adaa4cf7ef1b65be = async (body)=>{
    try {
        return await (0, $lRmyA.performPostRequest)('/rest/internal/4/announcement-banner', {
            body: JSON.stringify(body)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'settingsV4Set',
                packageName: 'jiraAdminPagesSystemUiAnnouncementBannerResources',
                teamName: 'jira-cosmos'
            },
            error: error
        });
        throw error;
    }
};

});

parcelRegister("6abiR", function(module, exports) {

$parcel$export(module.exports, "get", () => $5e6a63cc908ec028$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $5e6a63cc908ec028$export$adaa4cf7ef1b65be);

var $48bs8 = parcelRequire("48bs8");

var $guiFP = parcelRequire("guiFP");

var $6vrw7 = parcelRequire("6vrw7");

const $5e6a63cc908ec028$var$key = 'announcementBannerDismissedLast';
const $5e6a63cc908ec028$export$3988ae62b71be9a3 = async (accoundId)=>{
    try {
        return accoundId != null ? (await (0, $48bs8.getUserProperty)((0, $6vrw7.toBaseUrl)(''), accoundId, $5e6a63cc908ec028$var$key)).hashId : null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 404 - property has not been previously set
        if (error.statusCode === 404) return null;
        (0, $guiFP.trackFetchErrors)({
            error: error,
            id: 'userDismissGet',
            packageName: (0, $6015420733166380$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};
const $5e6a63cc908ec028$export$adaa4cf7ef1b65be = async (accoundId, hashId)=>{
    try {
        return await (0, $48bs8.setUserProperties)((0, $6vrw7.toBaseUrl)(''), accoundId, $5e6a63cc908ec028$var$key, JSON.stringify({
            hashId: hashId
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.trackFetchErrors)({
            error: error,
            id: 'userDismissSet',
            packageName: (0, $6015420733166380$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};

});


parcelRegister("6yplV", function(module, exports) {

$parcel$export(module.exports, "useIsAnonymous", () => $650b84b1a3eacbd8$export$bf7b5d502f6d6d3b);

var $gd0Sp = parcelRequire("gd0Sp");
const $650b84b1a3eacbd8$export$bf7b5d502f6d6d3b = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.isAnonymous;
};

});

parcelRegister("NzrZv", function(module, exports) {

$parcel$export(module.exports, "HEIGHT", () => $ed164e6dadc08c71$export$809d2b099693a9a8);
$parcel$export(module.exports, "NAME", () => $ed164e6dadc08c71$export$3c5e605ca7ade9f2);
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles

var $c9TLT = parcelRequire("c9TLT");
const $ed164e6dadc08c71$export$809d2b099693a9a8 = (0, $c9TLT.gridSize) * 8;
const $ed164e6dadc08c71$export$3c5e605ca7ade9f2 = 'ANNOUNCEMENT';

});


parcelRegister("itibb", function(module, exports) {

$parcel$export(module.exports, "useBannerEocTransition", () => $60fbf3301c9b1d1e$export$b6539a8209f95b48);

var $eUqFw = parcelRequire("eUqFw");

var $9z07y = parcelRequire("9z07y");
var $hhjRL = parcelRequire("hhjRL");

var $h4Fhh = parcelRequire("h4Fhh");

var $c7H0g = parcelRequire("c7H0g");
var $1R3n5 = parcelRequire("1R3n5");

var $bFh4f = parcelRequire("bFh4f");
const $60fbf3301c9b1d1e$export$b6539a8209f95b48 = ()=>{
    const { data: data, error: error } = (0, $hhjRL.useOgConsolidationUserState)();
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const { isTransitionEligible: isTransitionEligible, error: tenantInfoError } = (0, $h4Fhh.useOgTenantInfo)();
    const isEnabled = Boolean((isAdmin || isSiteAdmin) && // Tenant info
    !tenantInfoError && isTransitionEligible && // User state
    !error && data && (!data.isTransitionBannerDismissed || (0, $9z07y.shouldRenderBenefitModal)({
        bannerDismissedAt: data.transitionBannerDismissedAt,
        isDismissed: data.isBenefitModalDismissed
    })));
    return (0, $eUqFw.useMemo)(()=>({
            isEnabled: isEnabled,
            name: (0, $bFh4f.BANNER_NAME),
            height: data && (0, $9z07y.shouldRenderBenefitModal)({
                bannerDismissedAt: data.transitionBannerDismissedAt
            }) ? 0 : (0, $bFh4f.HEIGHT)
        }), [
        data,
        isEnabled
    ]);
};

});
parcelRegister("9z07y", function(module, exports) {

$parcel$export(module.exports, "shouldRenderBenefitModal", () => $6567c5fc28457e2a$export$25a52eb2dc74e2f9);
const $6567c5fc28457e2a$export$25a52eb2dc74e2f9 = ({ isDismissed: isDismissed, bannerDismissedAt: bannerDismissedAt })=>{
    if (!bannerDismissedAt || isDismissed) return false;
    return Math.ceil((new Date().getTime() - bannerDismissedAt) / 1000 / 60 / 60 / 24) >= 14;
};

});

parcelRegister("hhjRL", function(module, exports) {

$parcel$export(module.exports, "useOgConsolidationUserState", () => $372e7078171e8517$export$c35632c02599163f);

var $eUqFw = parcelRequire("eUqFw");

var $48bs8 = parcelRequire("48bs8");

var $guiFP = parcelRequire("guiFP");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3HCkE = parcelRequire("3HCkE");

var $hlO97 = parcelRequire("hlO97");
var $9EQcI = parcelRequire("9EQcI");

var $gd0Sp = parcelRequire("gd0Sp");

var $3bkB6 = parcelRequire("3bkB6");
const $372e7078171e8517$export$c35632c02599163f = ()=>{
    const errorRef = (0, $eUqFw.useRef)();
    const loadingRef = (0, $eUqFw.useRef)(false);
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { data: data, update: updateTransitionResource, error: transitionResourceError } = (0, $3HCkE.useResource)((0, $hlO97.consolidationUserStateResource));
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [userPropertiesError, setUserPropertiesError] = (0, $eUqFw.useState)();
    errorRef.current = userPropertiesError || transitionResourceError;
    const { atlassianAccountId: accountId } = (0, $gd0Sp.useTenantContext)();
    const update = (0, $eUqFw.useCallback)((newState)=>{
        if (errorRef.current) // If there is an error on resource or update, we don't want to update the state
        return Promise.reject(errorRef.current);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        let updatedData = {};
        updateTransitionResource((oldState)=>{
            updatedData = {
                ...oldState,
                ...newState
            };
            return updatedData;
        });
        if (accountId) {
            if (loadingRef.current) {
                const err = new Error('User properties is loading');
                (0, $guiFP.default)({
                    meta: {
                        id: 'useOgConsolidationUserPreference-update',
                        packageName: 'jiraEocChangeboarding',
                        teamName: 'alexstrasza'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
                setUserPropertiesError(err);
                return Promise.reject(err);
            }
            loadingRef.current = true;
            return (0, $48bs8.setUserProperties)('', accountId, (0, $9EQcI.OG_CONSOLIDATION_USER_STATE_STORAGE_KEY), JSON.stringify(updatedData)).catch((err)=>{
                setUserPropertiesError(new Error('Error occured while setting user properties'));
                showFlag({
                    type: 'error',
                    isAutoDismiss: true,
                    title: formatMessage((0, $3bkB6.default).errorFlagTitle)
                });
                (0, $guiFP.default)({
                    meta: {
                        id: 'useOgConsolidationUserPreference-update',
                        packageName: 'jiraEocChangeboarding',
                        teamName: 'alexstrasza'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
            }).finally(()=>{
                loadingRef.current = false;
            });
        }
        return Promise.resolve();
    }, [
        updateTransitionResource,
        accountId,
        formatMessage,
        showFlag
    ]);
    const reopenTransitionLozenge = (0, $eUqFw.useCallback)(()=>{
        update({
            isTransitionHomeHidden: false
        });
    }, [
        update
    ]);
    return {
        data: data,
        update: update,
        error: errorRef.current,
        reopenTransitionLozenge: reopenTransitionLozenge
    };
};

});
parcelRegister("hlO97", function(module, exports) {

$parcel$export(module.exports, "consolidationUserStateResource", () => $df22f4299975551a$export$4b870505c49999ef);

var $guiFP = parcelRequire("guiFP");

var $3HCkE = parcelRequire("3HCkE");

var $e70K7 = parcelRequire("e70K7");

var $9EQcI = parcelRequire("9EQcI");
const $df22f4299975551a$var$RESOURCE_KEY = 'RESOURCE_TYPE_EOC_OG_CONSOLIDATION_USER_STATE';
const $df22f4299975551a$export$4b870505c49999ef = (0, $3HCkE.createResource)({
    type: $df22f4299975551a$var$RESOURCE_KEY,
    getKey: ()=>$df22f4299975551a$var$RESOURCE_KEY,
    getData: (_, { tenantContext: { atlassianAccountId: accountId } })=>(0, $e70K7.getOgConsolidationUserState)(accountId).catch((error)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'consolidationUserStateResource',
                    packageName: 'jiraRouterResourcesEocOgConsolidationUserState',
                    teamName: 'alexstrasza'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }),
    maxAge: Infinity
});

});
parcelRegister("e70K7", function(module, exports) {

$parcel$export(module.exports, "getOgConsolidationUserState", () => $f1438afaaf09dc03$export$df7594d56c9ebe57);

var $48bs8 = parcelRequire("48bs8");

var $guiFP = parcelRequire("guiFP");

var $7byHA = parcelRequire("7byHA");

var $9EQcI = parcelRequire("9EQcI");
const $f1438afaaf09dc03$export$df7594d56c9ebe57 = (accountId)=>{
    if (!accountId) {
        const error = new Error('No accountId from tenant context, this should not happen.');
        error.skipSentry = true;
        throw error;
    }
    return (0, $48bs8.getUserProperty)('', accountId, (0, $9EQcI.OG_CONSOLIDATION_USER_STATE_STORAGE_KEY)).then((val)=>{
        if (!val || typeof val !== 'object') {
            (0, $guiFP.default)({
                meta: {
                    id: 'getUserProperty',
                    packageName: 'jiraRouterResourcesEocOgConsolidationUserState',
                    teamName: 'alexstrasza'
                },
                error: new (0, $7byHA.ValidationError)('User property is not an object. It must be changed outside of the automated flow.'),
                sendToPrivacyUnsafeSplunk: true
            });
            return 0, $9EQcI.DEFAULT_CONSOLIDATION_USER_STATE;
        }
        if (!Object.keys(val).every((key)=>Object.prototype.hasOwnProperty.call((0, $9EQcI.DEFAULT_CONSOLIDATION_USER_STATE), key))) return {
            ...(0, $9EQcI.DEFAULT_CONSOLIDATION_USER_STATE),
            ...Object.fromEntries(Object.entries(val).filter(([key])=>Object.prototype.hasOwnProperty.call((0, $9EQcI.DEFAULT_CONSOLIDATION_USER_STATE), key)))
        };
        if (!Object.keys((0, $9EQcI.DEFAULT_CONSOLIDATION_USER_STATE)).every((key)=>Object.prototype.hasOwnProperty.call(val, key))) // Missing properties will happen when adding new properties to the type,
        // we are making sure they are filled in from the defaults
        return {
            ...(0, $9EQcI.DEFAULT_CONSOLIDATION_USER_STATE),
            ...val
        };
        return val;
    }).catch((error)=>{
        // Property not saved yet, so we return the default values
        if (error instanceof (0, $7byHA.default) && error.statusCode === 404) return 0, $9EQcI.DEFAULT_CONSOLIDATION_USER_STATE;
        throw error;
    });
};

});
parcelRegister("9EQcI", function(module, exports) {

$parcel$export(module.exports, "OG_CONSOLIDATION_USER_STATE_STORAGE_KEY", () => $ede4833892459008$export$1980758e2622af02);
$parcel$export(module.exports, "DEFAULT_CONSOLIDATION_USER_STATE", () => $ede4833892459008$export$51d9907e9d716d);
const $ede4833892459008$export$1980758e2622af02 = 'eoc_consolidation_user_state';
const $ede4833892459008$export$51d9907e9d716d = {
    isPromotionBannerDismissed: false,
    isWelcomeModalDisplayed: false,
    isTransitionHomeHidden: false,
    isTransitionBannerDismissed: false,
    isBroadcastWidgetDismissed: false,
    transitionBannerDismissedAt: null,
    isBenefitModalDismissed: false
};

});



parcelRegister("3bkB6", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd71b9db670388a5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $cd71b9db670388a5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorFlagTitle: {
        "id": "eoc-changeboarding.controllers.use-og-consolidation-user-state.error-flag-title",
        "defaultMessage": "Something went wrong while updating user properties."
    }
});

});


parcelRegister("h4Fhh", function(module, exports) {

$parcel$export(module.exports, "useOgTenantInfo", () => $15a83583aeb31ef0$export$990ea9ff15ca04f7);

var $1ybV0 = parcelRequire("1ybV0");

var $3HCkE = parcelRequire("3HCkE");

var $dAKwA = parcelRequire("dAKwA");

var $fz8wa = parcelRequire("fz8wa");

var $jf8p7 = parcelRequire("jf8p7");
const $15a83583aeb31ef0$export$990ea9ff15ca04f7 = ()=>{
    const tenantInfoResource = (0, $3HCkE.useResource)((0, $dAKwA.getConsolidationStateResource)());
    const applicationPermissions = (0, $fz8wa.useApplicationPermissions)();
    if (tenantInfoResource.data === null && tenantInfoResource.loading === false && tenantInfoResource.error === null) tenantInfoResource.refresh();
    return {
        loading: tenantInfoResource.loading,
        error: tenantInfoResource.error,
        shouldUseJSM: (0, $jf8p7.checkShouldUseJSM)(tenantInfoResource.data),
        isConsolidated: (0, $jf8p7.checkIsConsolidated)(tenantInfoResource.data),
        isTransitioning: (0, $1ybV0.ff)('opsgenie-consolidation-transitioning-state_d7vm9') && (0, $jf8p7.checkIsTransitioning)(tenantInfoResource.data),
        isTransitioned: (0, $1ybV0.ff)('opsgenie-consolidation-transitioning-state_d7vm9') && (0, $jf8p7.checkIsTransitioned)(tenantInfoResource.data),
        isTransitionEligible: (0, $1ybV0.ff)('opsgenie-consolidation-transitioning-state_d7vm9') && applicationPermissions.hasServiceDeskAccess && (0, $jf8p7.checkIsTransitionEligible)(tenantInfoResource.data),
        shouldAccessUnlockOperations: (0, $1ybV0.ff)('opsgenie-consolidation-transitioning-state_d7vm9') && applicationPermissions.hasServiceDeskAccess && (0, $jf8p7.checkShouldAccessUnlockOperations)(tenantInfoResource.data),
        cohort: typeof tenantInfoResource.data === 'string' ? undefined : tenantInfoResource.data?.cohortInfo
    };
};

});
parcelRegister("dAKwA", function(module, exports) {

$parcel$export(module.exports, "getConsolidationStateResource", () => $59d64f3d4fc6187b$export$a6cf5054d4f9f5dd);
// eoc-fetch is already being used in eoc resources, so there is no reason not
// to override the whitelist here.
// eslint-disable-next-line jira/import-whitelist

var $kRdYM = parcelRequire("kRdYM");

var $1ybV0 = parcelRequire("1ybV0");

var $3HCkE = parcelRequire("3HCkE");

var $lPDOE = parcelRequire("lPDOE");

const $59d64f3d4fc6187b$export$de6c19ae237c1eb9 = (cloudId, appPermissions)=>{
    let url = '/internal/v1/customers/tenant-info';
    if (cloudId) url = `${url}/${cloudId}`;
    else throw new Error('No tenant info exists.');
    let promise;
    if (appPermissions && appPermissions.hasServiceDeskAccess === false) {
        promise = new Promise((resolve)=>{
            resolve({
                consolidationState: (0, $lPDOE.ConsolidationState).NOT_CONSOLIDATED
            });
        });
        return promise;
    }
    if (false) promise = (0, $kRdYM.eocFetch)(url, {
        exactUrl: true,
        headers: {
            'x-ssr-service-name': 'og-apigw-atlassian-gw'
        }
    });
    else promise = (0, $kRdYM.eocFetch)('/v1/customers/tenant-info').then(({ data: data })=>data);
    if ((0, $1ybV0.ff)('eoc-tenant-info-hook_dq6ke')) return promise;
    return promise.then((response)=>response.consolidationState);
};
const $59d64f3d4fc6187b$export$a6cf5054d4f9f5dd = (forceBrowser = false)=>(0, $3HCkE.createResource)({
        type: (0, $02315c431173f662$export$25ee35b01de9d734),
        getKey: ()=>'tenantInformation',
        getData: (_, { tenantContext: { cloudId: cloudId, appPermissions: appPermissions } })=>$59d64f3d4fc6187b$export$de6c19ae237c1eb9(cloudId, appPermissions),
        maxAge: Infinity,
        isBrowserOnly: forceBrowser
    });

});
parcelRegister("kRdYM", function(module, exports) {

$parcel$export(module.exports, "eocFetch", () => $7775a32a91a5ec92$export$212b9c60150b5a0a);

var $XHGTv = parcelRequire("XHGTv");

var $7JEKn = parcelRequire("7JEKn");

var $fVaJL = parcelRequire("fVaJL");

var $3lxlO = parcelRequire("3lxlO");
const $7775a32a91a5ec92$export$212b9c60150b5a0a = (input, init)=>{
    let headers = init?.headers ?? {};
    let body = init?.body;
    // If there is no Content-Type we should add application/json
    // and if the body is not in the BodyInit format we should stringify it
    // Native fetch accepts headers as [['key1','value1'],['key2', 'value2']] so we don't want to modify header or body in this case
    if (!(window.Blob && body instanceof Blob || window.Int8Array && body instanceof Int8Array || window.Uint8Array && body instanceof Uint8Array || window.Uint8ClampedArray && body instanceof Uint8ClampedArray || window.Int16Array && body instanceof Int16Array || window.Uint16Array && body instanceof Uint16Array || window.Int32Array && body instanceof Int32Array || window.Uint32Array && body instanceof Uint32Array || window.Float32Array && body instanceof Float32Array || window.Float64Array && body instanceof Float64Array || window.ArrayBuffer && body instanceof ArrayBuffer || window.BigInt64Array && body instanceof BigInt64Array || window.BigUint64Array && body instanceof BigUint64Array || window.FormData && body instanceof FormData || window.URLSearchParams && body instanceof URLSearchParams || window.ReadableStream && body instanceof ReadableStream || window.Array && headers instanceof Array || typeof body === 'string') && headers['Content-Type'] === undefined && headers['content-type'] === undefined) {
        body = JSON.stringify(body);
        headers['Content-Type'] = 'application/json';
    }
    if (typeof input === 'string') input = (0, $3lxlO.withPrefix)(input, init);
    else input = {
        ...input,
        url: (0, $3lxlO.withPrefix)(input.url, init)
    };
    const errorTransformer = init?.errorTransformer ?? (0, $3lxlO.defaultErrorTransformer);
    const startTime = performance.now();
    return fetch(input, {
        headers: headers,
        ...init,
        body: body
    }).catch((error)=>{
        throw new (0, $7JEKn.NetworkError)(error.name, error);
    }).then((response)=>{
        if (!response.ok) throw new (0, $7JEKn.HTTPError)(response);
        if ((0, $XHGTv.getBooleanFF)('platform.send-eoc-fetch-metrics-to-performance-portal_1u3l0')) {
            const sanitizedUrl = (0, $3lxlO.sanitizeUrlString)((0, $3lxlO.getRequestUrl)(input));
            (0, $fVaJL.addSpanToAll)('fetch', sanitizedUrl, [
                {
                    name: 'network'
                }
            ], startTime, performance.now());
        }
        switch(init?.responseType){
            case undefined:
            case 'json':
                return response.json();
            case 'blob':
                return response.blob();
            case 'text':
                return response.text();
            case 'headers':
                return response;
        }
    }).catch((error)=>{
        if ((0, $7JEKn.isNetworkError)(error)) {
            // Put it through the transformer and throw it when ready. Note that
            // it is still safe to throw in the transformer, it will just chain up
            // on the following handlers as usual.
            const transformerResult = errorTransformer(error);
            if (transformerResult instanceof Promise) return transformerResult.then((finalError)=>{
                throw finalError;
            });
            else throw transformerResult;
        }
        throw error;
    });
};

});
parcelRegister("7JEKn", function(module, exports) {

$parcel$export(module.exports, "NetworkError", () => $d68e2f12e365276a$export$bae979e68e4dc802);
$parcel$export(module.exports, "HTTPError", () => $d68e2f12e365276a$export$aa9d629c530f62a7);
$parcel$export(module.exports, "StreamedHTTPError", () => $d68e2f12e365276a$export$c30b5b02747d791c);
$parcel$export(module.exports, "isHTTPError", () => $d68e2f12e365276a$export$6b7a49ce9c98a2f);
$parcel$export(module.exports, "isNetworkError", () => $d68e2f12e365276a$export$476aa014e2fd89d5);
$parcel$export(module.exports, "isStreamedHTTPError", () => $d68e2f12e365276a$export$4f52fcea95c8f97d);

var $bSKtU = parcelRequire("bSKtU");
class $d68e2f12e365276a$export$bae979e68e4dc802 extends Error {
    constructor(name, cause){
        super('Network Error!');
        this.name = name;
        this.cause = cause;
    }
}
class $d68e2f12e365276a$export$aa9d629c530f62a7 extends $d68e2f12e365276a$export$bae979e68e4dc802 {
    constructor(response){
        // It is important to note that this can be shown to the user if the
        // default transformer is not used for some reason and the thrown error's
        // message is left as is.
        super((0, $bSKtU.ERROR_NAMES).HTTPError);
        this.message = `HTTP Status Error: ${response.status} ${response.statusText}`;
        this.response = response;
    }
}
class $d68e2f12e365276a$export$c30b5b02747d791c extends $d68e2f12e365276a$export$aa9d629c530f62a7 {
    constructor(cause, data, message){
        super(cause.response);
        this.cause = cause;
        this.data = data;
        this.message = message;
        this.message = message;
        this.name = (0, $bSKtU.ERROR_NAMES).StreamedHTTPError;
    }
}
const $d68e2f12e365276a$export$6b7a49ce9c98a2f = (candidate)=>candidate instanceof $d68e2f12e365276a$export$aa9d629c530f62a7 || [
        (0, $bSKtU.ERROR_NAMES).HTTPError,
        (0, $bSKtU.ERROR_NAMES).StreamedHTTPError
    ].includes(candidate.name);
const $d68e2f12e365276a$export$476aa014e2fd89d5 = (candidate)=>candidate instanceof $d68e2f12e365276a$export$bae979e68e4dc802 || [
        (0, $bSKtU.ERROR_NAMES).NetworkError,
        (0, $bSKtU.ERROR_NAMES).HTTPError,
        (0, $bSKtU.ERROR_NAMES).StreamedHTTPError
    ].includes(candidate.name);
const $d68e2f12e365276a$export$4f52fcea95c8f97d = (candidate)=>candidate instanceof $d68e2f12e365276a$export$c30b5b02747d791c || candidate?.name === (0, $bSKtU.ERROR_NAMES).StreamedHTTPError;

});
parcelRegister("bSKtU", function(module, exports) {

$parcel$export(module.exports, "ERROR_NAMES", () => $2ded0429e5da1da0$export$daceac3b97803ce1);
var $2ded0429e5da1da0$export$daceac3b97803ce1;
(function(ERROR_NAMES) {
    ERROR_NAMES["HTTPError"] = "HTTPError";
    ERROR_NAMES["StreamedHTTPError"] = "StreamedHTTPError";
    ERROR_NAMES["NetworkError"] = "NetworkError";
})($2ded0429e5da1da0$export$daceac3b97803ce1 || ($2ded0429e5da1da0$export$daceac3b97803ce1 = {}));

});


parcelRegister("3lxlO", function(module, exports) {

$parcel$export(module.exports, "getMeta", () => $757b9ebe01720e4f$export$c47913ca32a5c6f7);
$parcel$export(module.exports, "withPrefix", () => $757b9ebe01720e4f$export$44188c5f179c4553);
$parcel$export(module.exports, "defaultErrorTransformer", () => $757b9ebe01720e4f$export$270fcc0e5df09fdd);
$parcel$export(module.exports, "jsmErrorTransformer", () => $757b9ebe01720e4f$export$994cc82144d28ded);
$parcel$export(module.exports, "getRequestUrl", () => $757b9ebe01720e4f$export$14619c0eed01a470);
$parcel$export(module.exports, "sanitizeUrlString", () => $757b9ebe01720e4f$export$ceb09b958e605eff);

var $8ji9h = parcelRequire("8ji9h");

var $7JEKn = parcelRequire("7JEKn");

let $757b9ebe01720e4f$var$metaCloudId;
let $757b9ebe01720e4f$var$isJSMAvailable = true;
function $757b9ebe01720e4f$export$c47913ca32a5c6f7(name) {
    const globalVariable = window ?? $parcel$global;
    if ((0, $8ji9h.isServer)() && globalVariable.ssr__metadata) return globalVariable.ssr__metadata[name];
    if ($757b9ebe01720e4f$var$metaCloudId) return $757b9ebe01720e4f$var$metaCloudId;
    if ($757b9ebe01720e4f$var$isJSMAvailable) {
        const element = document.querySelector(`meta[name="${name}"]`);
        $757b9ebe01720e4f$var$metaCloudId = element?.getAttribute('content') ?? undefined;
        $757b9ebe01720e4f$var$isJSMAvailable = !!$757b9ebe01720e4f$var$metaCloudId;
    }
    return $757b9ebe01720e4f$var$metaCloudId;
}
function $757b9ebe01720e4f$export$5a75f4aeb58ba80f(id) {
    $757b9ebe01720e4f$var$metaCloudId = id;
}
function $757b9ebe01720e4f$export$44188c5f179c4553(input, init) {
    if (init?.exactUrl) return input;
    // If current env is not opsgenie, we will add cloud id to base url of request.
    if (window.__OG__) return '/webapi' + input;
    const cloudId = $757b9ebe01720e4f$export$c47913ca32a5c6f7('ajs-cloud-id');
    if (cloudId) return (0, $875484804ad28aca$export$3414665826fa030e) + cloudId + input;
    return input;
}
// https://www.rfc-editor.org/rfc/rfc9110.html#section-8.3
// This is not a full implementation, but should skip any unknown parameters
// and match the charset if it exists. In case there are multiple (which shouldn't) we still
// match the first occurence. If only application/json is returned, utf-8 is
// assumed as we will try to parse it as utf-8 json. This is probably our best
// guess without too much effort here.
const $757b9ebe01720e4f$var$mediaTypeRegex = /(^application\/json$)|(^application\/json([\s\t]?;.+?)*([\s\t]?;[\s\t]?charset=(("utf-8")|(utf-8))))/i;
const $757b9ebe01720e4f$export$270fcc0e5df09fdd = (e)=>{
    if (e instanceof (0, $7JEKn.HTTPError)) {
        const contentType = e.response.headers.get('Content-Type');
        // The content type is application/json, and it is highly likely utf-8 encoded
        if (contentType && $757b9ebe01720e4f$var$mediaTypeRegex.test(contentType)) return e.response.json().then((data)=>new (0, $7JEKn.StreamedHTTPError)(e, data, data.errorMessage ?? data.message));
        // For anything else, try to interpret it as utf8 text as best effort.
        return e.response.text().then((message)=>new (0, $7JEKn.StreamedHTTPError)(e, message, message));
    }
    return e;
};
const $757b9ebe01720e4f$export$994cc82144d28ded = (error)=>{
    if (error instanceof (0, $7JEKn.HTTPError)) {
        const contentType = error.response.headers.get('Content-Type');
        if (contentType && $757b9ebe01720e4f$var$mediaTypeRegex.test(contentType)) return error.response.json().then((data)=>new (0, $7JEKn.StreamedHTTPError)(error, data, data.errorMessages.join(',')));
        return error.response.text().then((message)=>new (0, $7JEKn.StreamedHTTPError)(error, message, message));
    }
    return error;
};
const $757b9ebe01720e4f$export$14619c0eed01a470 = (fetchInput)=>typeof fetchInput === 'string' ? fetchInput : fetchInput instanceof URL ? fetchInput.href : fetchInput.url;
const $757b9ebe01720e4f$export$ceb09b958e605eff = (url)=>{
    const urlWithoutQueryParams = url.replace(/\?.*$/, '');
    const urlWithoutUUIDs = urlWithoutQueryParams.replace(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(-[0-9a-f]{13})?/gi, '<uuid>');
    return urlWithoutUUIDs;
};

});
parcelRegister("8ji9h", function(module, exports) {

$parcel$export(module.exports, "isServer", () => $a0acbe87ddc44949$export$6acf61af03e62db);
const $a0acbe87ddc44949$export$6acf61af03e62db = ()=>{
    try {
        //@ts-ignore: It defined from webpack on the Jira
        return false;
    } catch (error) {
        return globalThis.false ?? false;
    }
};

});

const $875484804ad28aca$export$3414665826fa030e = '/gateway/api/jsm/ops/web/';



parcelRegister("lPDOE", function(module, exports) {

$parcel$export(module.exports, "ConsolidationState", () => $1d60cf44e0c38c08$export$9ef498b0a11fd37d);
const $1d60cf44e0c38c08$export$9ef498b0a11fd37d = {
    NOT_CONSOLIDATED: 'NOT_CONSOLIDATED',
    TRANSITIONING: 'TRANSITIONING',
    TRANSITIONED: 'TRANSITIONED',
    CONSOLIDATED: 'CONSOLIDATED'
};

});

const $02315c431173f662$export$25ee35b01de9d734 = 'EOC_TENANT';


parcelRegister("fz8wa", function(module, exports) {

$parcel$export(module.exports, "ApplicationPermissionsSubscriber", () => $d53bf78e5b3b7ada$export$d8c76f7e52d0a856);
$parcel$export(module.exports, "useApplicationPermissions", () => $d53bf78e5b3b7ada$export$4d9cadb4042acc1b);

var $df4Sl = parcelRequire("df4Sl");

var $dYfll = parcelRequire("dYfll");

var $k4yit = parcelRequire("k4yit");

var $gd0Sp = parcelRequire("gd0Sp");
const $d53bf78e5b3b7ada$var$selector = (0, $df4Sl.createSelector)((state)=>state.tenantContext.appPermissions, (applicationPermissions)=>({
        data: {
            applicationPermissions: applicationPermissions
        }
    }));
const $d53bf78e5b3b7ada$export$d8c76f7e52d0a856 = (0, $dYfll.createSubscriber)((0, $k4yit.default), {
    displayName: 'ApplicationPermissionsSubscriber',
    selector: $d53bf78e5b3b7ada$var$selector
});
const $d53bf78e5b3b7ada$export$4d9cadb4042acc1b = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.appPermissions;
};

});

parcelRegister("jf8p7", function(module, exports) {

$parcel$export(module.exports, "checkShouldUseJSM", () => $77654e10ad778a08$export$5e0f3a0d8463fa21);
$parcel$export(module.exports, "checkIsTransitioning", () => $77654e10ad778a08$export$d2f281fd4bf10855);
$parcel$export(module.exports, "checkIsConsolidated", () => $77654e10ad778a08$export$57f75aebff17dd1e);
$parcel$export(module.exports, "checkIsTransitioned", () => $77654e10ad778a08$export$b6461b23ee0e1471);
$parcel$export(module.exports, "checkIsTransitionEligible", () => $77654e10ad778a08$export$24040115cac5fdc3);
$parcel$export(module.exports, "checkShouldAccessUnlockOperations", () => $77654e10ad778a08$export$cd227238525e8d57);

var $lPDOE = parcelRequire("lPDOE");

const $77654e10ad778a08$export$5e0f3a0d8463fa21 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    // remove string check after ff is cleanuped 'eoc-tenant-info-hook_dq6ke'
    return typeof tenantInfo === 'string' ? tenantInfo !== (0, $lPDOE.ConsolidationState).NOT_CONSOLIDATED : tenantInfo.consolidationState !== (0, $lPDOE.ConsolidationState).NOT_CONSOLIDATED;
};
const $77654e10ad778a08$export$d2f281fd4bf10855 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    // remove string check after ff is cleanuped 'eoc-tenant-info-hook_dq6ke'
    return typeof tenantInfo === 'string' ? tenantInfo === (0, $lPDOE.ConsolidationState).TRANSITIONING : tenantInfo.consolidationState === (0, $lPDOE.ConsolidationState).TRANSITIONING;
};
const $77654e10ad778a08$export$57f75aebff17dd1e = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return typeof tenantInfo === 'string' ? tenantInfo === (0, $lPDOE.ConsolidationState).CONSOLIDATED : tenantInfo.consolidationState === (0, $lPDOE.ConsolidationState).CONSOLIDATED;
};
const $77654e10ad778a08$export$b6461b23ee0e1471 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    // remove string check after ff is cleanuped 'eoc-tenant-info-hook_dq6ke'
    return typeof tenantInfo === 'string' ? tenantInfo === (0, $lPDOE.ConsolidationState).TRANSITIONED : tenantInfo.consolidationState === (0, $lPDOE.ConsolidationState).TRANSITIONED;
};
const $77654e10ad778a08$export$24040115cac5fdc3 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    // remove string check after ff is cleanuped 'eoc-tenant-info-hook_dq6ke'
    // even though FF is rolled out 100% if the tenantInfo is string it means we don't know the cohort info
    return typeof tenantInfo === 'string' ? false : tenantInfo.consolidationState === (0, $lPDOE.ConsolidationState).NOT_CONSOLIDATED && tenantInfo.cohortInfo === (0, $9e5329fbcc13ca2e$export$650f6934db1290c1);
};
const $77654e10ad778a08$export$cd227238525e8d57 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    // remove string check after ff is cleanuped 'eoc-tenant-info-hook_dq6ke'
    // even though FF is rolled out 100% if the tenantInfo is string it means we don't know the cohort info
    return typeof tenantInfo === 'string' ? false : tenantInfo.consolidationState !== (0, $lPDOE.ConsolidationState).CONSOLIDATED && (tenantInfo.cohortInfo === (0, $9e5329fbcc13ca2e$export$650f6934db1290c1) || tenantInfo.cohortInfo === (0, $9e5329fbcc13ca2e$export$a101f3562b5f0742));
};

});
const $9e5329fbcc13ca2e$export$650f6934db1290c1 = 'cohort3';
const $9e5329fbcc13ca2e$export$a101f3562b5f0742 = 'cohort3.5';



parcelRegister("c7H0g", function(module, exports) {

$parcel$export(module.exports, "useIsAdmin", () => $b4b4ffdc2519fb85$export$99a5e4bc80d231ca);

var $gd0Sp = parcelRequire("gd0Sp");
const $b4b4ffdc2519fb85$export$99a5e4bc80d231ca = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.isAdmin || false;
};

});

parcelRegister("1R3n5", function(module, exports) {

$parcel$export(module.exports, "useIsSiteAdmin", () => $ae5c0c470cafb895$export$f9f8a5cdb0c565ef);

var $gd0Sp = parcelRequire("gd0Sp");
const $ae5c0c470cafb895$export$f9f8a5cdb0c565ef = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.isSiteAdmin || false;
};

});

parcelRegister("bFh4f", function(module, exports) {

$parcel$export(module.exports, "HEIGHT", () => $9b35bda76dc8f581$export$809d2b099693a9a8);
$parcel$export(module.exports, "BANNER_NAME", () => $9b35bda76dc8f581$export$41956b146268af93);
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles

var $c9TLT = parcelRequire("c9TLT");
const $9b35bda76dc8f581$export$809d2b099693a9a8 = (0, $c9TLT.gridSize) * 6;
const $9b35bda76dc8f581$export$41956b146268af93 = 'EOC_TRANSITION';

});


parcelRegister("9lf1N", function(module, exports) {

$parcel$export(module.exports, "useBannerMailExpiry", () => $459c8882dc5ea0c1$export$3906461ac9b87d2);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $8Osbm = parcelRequire("8Osbm");

var $j3cff = parcelRequire("j3cff");

var $hNg3b = parcelRequire("hNg3b");
const $459c8882dc5ea0c1$export$3906461ac9b87d2 = ()=>{
    const { responseStatus: responseStatus, state: state } = (0, $8Osbm.useIncomingMailExpiryStatus)();
    const { onStateFetch: onStateFetch } = (0, $hNg3b.useBannerActions)();
    const { isBannerShown: isBannerShown } = (0, $hNg3b.useBannerState)();
    (0, $eUqFw.useEffect)(()=>{
        if (!(0, $1ybV0.ff)('jira-banner-for-incoming-mail-expiry-notification_y2w1w')) {
            onStateFetch({
                isAdmin: false,
                showBanner: false,
                OauthTypes: [
                    'GMAIL_OAUTH'
                ]
            });
            return;
        }
        if (responseStatus === 'error') {
            onStateFetch((0, $8Osbm.DEFAULT_RESPONSE));
            return;
        }
        if (responseStatus === 'success') onStateFetch(state);
    }, [
        onStateFetch,
        responseStatus,
        state
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            isEnabled: isBannerShown,
            name: (0, $j3cff.BANNER_NAME),
            height: (0, $j3cff.HEIGHT)
        }), [
        isBannerShown
    ]);
};

});
parcelRegister("8Osbm", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_RESPONSE", () => $c9c7ef93c34099a4$export$32d9db53927095d3);
$parcel$export(module.exports, "incomingMailServerExpiryStatusResource", () => $c9c7ef93c34099a4$export$369caf52ed1ad2b1);
$parcel$export(module.exports, "useIncomingMailExpiryStatus", () => $c9c7ef93c34099a4$export$283aa034b7d4e2a0);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $lRmyA = parcelRequire("lRmyA");

var $3HCkE = parcelRequire("3HCkE");

const $c9c7ef93c34099a4$var$fetchGetIncomingMailServerExpiryStatus = async ()=>(0, $lRmyA.performGetRequest)((0, $6a195a4b7e83469e$export$5bf8eb915287f5f4));
const $c9c7ef93c34099a4$export$32d9db53927095d3 = {
    isAdmin: false,
    showBanner: true,
    OauthTypes: [
        'GMAIL_OAUTH'
    ]
};
const $c9c7ef93c34099a4$export$369caf52ed1ad2b1 = (0, $3HCkE.createResource)({
    type: (0, $6a195a4b7e83469e$export$3b9494e0dfc4de09),
    getKey: ()=>(0, $6a195a4b7e83469e$export$f2f2f265ccc09f82),
    getData: async ()=>{
        if (!(0, $1ybV0.ff)('jira-banner-for-incoming-mail-expiry-notification_y2w1w')) return {
            incomingMailServerExpiryStatus: {
                ...$c9c7ef93c34099a4$export$32d9db53927095d3,
                showBanner: false
            }
        };
        let incomingMailServerExpiryStatus = null;
        try {
            incomingMailServerExpiryStatus = await $c9c7ef93c34099a4$var$fetchGetIncomingMailServerExpiryStatus();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === 404) (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'incomingMailServerExpiryStatus',
                    packageName: 'jiraRouterResourcesIncomingMailExpiryStatus',
                    teamName: 'maverick'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            incomingMailServerExpiryStatus: incomingMailServerExpiryStatus ?? $c9c7ef93c34099a4$export$32d9db53927095d3
        };
    },
    maxAge: 3600000
});
const $c9c7ef93c34099a4$export$283aa034b7d4e2a0 = ()=>{
    const { data: data, loading: loadingGetResource, error: errorGetResource } = (0, $3HCkE.useResource)($c9c7ef93c34099a4$export$369caf52ed1ad2b1);
    const [incomingMailServerExpiryStatus, setIncomingMailServerExpiryStatus] = (0, $eUqFw.useState)(()=>{
        if (data?.incomingMailServerExpiryStatus) return data.incomingMailServerExpiryStatus;
        return $c9c7ef93c34099a4$export$32d9db53927095d3;
    });
    const [responseStatusGet, setResponseStatusGet] = (0, $eUqFw.useState)('not started');
    (0, $eUqFw.useEffect)(()=>{
        if (loadingGetResource) {
            setResponseStatusGet('loading');
            return;
        }
        if (errorGetResource) {
            setResponseStatusGet('error');
            return;
        }
        if (data?.incomingMailServerExpiryStatus) {
            setResponseStatusGet('success');
            setIncomingMailServerExpiryStatus(data.incomingMailServerExpiryStatus);
        }
    }, [
        loadingGetResource,
        errorGetResource,
        data?.incomingMailServerExpiryStatus
    ]);
    return {
        responseStatus: responseStatusGet,
        state: incomingMailServerExpiryStatus
    };
};

});
const $6a195a4b7e83469e$export$3b9494e0dfc4de09 = 'mail_server_expiring';
const $6a195a4b7e83469e$export$f2f2f265ccc09f82 = 'is_oauth_mail_server_expiring';
const $6a195a4b7e83469e$export$5bf8eb915287f5f4 = '/rest/internal/3/incomingMailServers/isOauthMailServersExpiring';


parcelRegister("j3cff", function(module, exports) {

$parcel$export(module.exports, "HEIGHT", () => $9b9b396a0fb8763d$export$809d2b099693a9a8);
$parcel$export(module.exports, "BANNER_NAME", () => $9b9b396a0fb8763d$export$41956b146268af93);
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles

var $c9TLT = parcelRequire("c9TLT");
const $9b9b396a0fb8763d$export$809d2b099693a9a8 = (0, $c9TLT.gridSize) * 6;
const $9b9b396a0fb8763d$export$41956b146268af93 = 'MAIL_EXPIRY_REMINDER';

});

parcelRegister("hNg3b", function(module, exports) {

$parcel$export(module.exports, "useBannerActions", () => $8ca9b6dc949a6871$export$664f3e2467f0f5af);
$parcel$export(module.exports, "useBannerState", () => $8ca9b6dc949a6871$export$fa4ffa872ee90bd0);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $8ca9b6dc949a6871$export$d4c72bab9d6cc13a = {
    isBannerShown: false,
    isAdmin: false,
    OauthTypes: [
        'GMAIL_OAUTH'
    ]
};
const $8ca9b6dc949a6871$export$e324594224ef24da = {
    onDismiss: ()=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                isBannerShown: false
            });
        },
    onStateFetch: ({ showBanner: showBanner, isAdmin: isAdmin, OauthTypes: OauthTypes = [
        'GMAIL_OAUTH'
    ] })=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                isBannerShown: showBanner && isAdmin,
                isAdmin: isAdmin,
                OauthTypes: OauthTypes
            });
        }
};
const $8ca9b6dc949a6871$var$Store = (0, $a61MH.createStore)({
    name: 'mail-expiry-banner',
    initialState: $8ca9b6dc949a6871$export$d4c72bab9d6cc13a,
    actions: $8ca9b6dc949a6871$export$e324594224ef24da
});
const $8ca9b6dc949a6871$export$664f3e2467f0f5af = (0, $ggKAj.createActionsHook)($8ca9b6dc949a6871$var$Store);
const $8ca9b6dc949a6871$export$fa4ffa872ee90bd0 = (0, $ggKAj.createStateHook)($8ca9b6dc949a6871$var$Store);

});


parcelRegister("8NAHO", function(module, exports) {

$parcel$export(module.exports, "useBannerReturnToMobileState", () => $b273a992a16fb1c6$export$571311559507e90);
$parcel$export(module.exports, "useBannerReturnToMobile", () => $b273a992a16fb1c6$export$a898dd7b7ec9917a);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $8q0kG = parcelRequire("8q0kG");

var $bBqV2 = parcelRequire("bBqV2");
const $b273a992a16fb1c6$var$initialState = {
    isEnabled: (0, $8q0kG.shouldShowReturnToMobileBanner)()
};
const $b273a992a16fb1c6$var$actions = {
    disable: ()=>({ setState: setState })=>{
            setState({
                isEnabled: false
            });
        }
};
const $b273a992a16fb1c6$var$store = (0, $a61MH.createStore)({
    initialState: $b273a992a16fb1c6$var$initialState,
    actions: $b273a992a16fb1c6$var$actions
});
const $b273a992a16fb1c6$export$571311559507e90 = (0, $ggKAj.createHook)($b273a992a16fb1c6$var$store);
const $b273a992a16fb1c6$export$a898dd7b7ec9917a = ()=>{
    const [{ isEnabled: isEnabled }] = $b273a992a16fb1c6$export$571311559507e90();
    return (0, $eUqFw.useMemo)(()=>({
            isEnabled: isEnabled,
            name: (0, $bBqV2.BANNER_NAME),
            height: (0, $bBqV2.mobileBannerHeight)
        }), [
        isEnabled
    ]);
};

});
parcelRegister("8q0kG", function(module, exports) {

$parcel$export(module.exports, "isSupportedUserAgent", () => $6d434a87228f5691$export$2b0f0a801c573b06);
$parcel$export(module.exports, "isAndroidUserAgent", () => $6d434a87228f5691$export$6053d3a1e6477e0f);
$parcel$export(module.exports, "isTabletUserAgent", () => $6d434a87228f5691$export$a33e336659bb3eb6);
$parcel$export(module.exports, "shouldShowReturnToMobileBanner", () => $6d434a87228f5691$export$604401c0b63e5273);
$parcel$export(module.exports, "shouldShowDismissButton", () => $6d434a87228f5691$export$5ad7f0440f4fd036);
$parcel$export(module.exports, "determineOperatingSystemAttribute", () => $6d434a87228f5691$export$d9f2497f8d710783);
$parcel$export(module.exports, "default", () => $6d434a87228f5691$export$2e2bcd8739ae039);

var $aqZcy = parcelRequire("aqZcy");
/*
This logic was ported from MobileUtils class from jira monolith to 
provide the same conditions for checking whether the user agent is mobile or not.
*/ const $6d434a87228f5691$var$DESKTOP_SWITCH_COOKIE_KEY = 'jira.mobile.desktop.switch';
const $6d434a87228f5691$var$ANDROID_CHROME_USER_AGENT = new RegExp('Chrome/[.\\d]* Mobile');
const $6d434a87228f5691$var$OLD_ANDROID_USER_AGENT = new RegExp('Linux;(?: U;)? Android (?:[23]\\.\\d|4\\.0\\.[12])');
const $6d434a87228f5691$var$MOBILE_USER_AGENT = new RegExp('(iPhone;|iPhone Simulator;|iPad;|iPod;|iPod touch;|Linux;(?: U;)? Android)');
const $6d434a87228f5691$var$MOBILE_STRING_IN_USER_AGENT = new RegExp('Mobile');
const $6d434a87228f5691$var$IPAD_USER_AGENT = new RegExp('iPad;');
const $6d434a87228f5691$var$IOS_USER_AGENT = new RegExp('(iPhone;|iPad;|iPod;)');
const $6d434a87228f5691$export$2b0f0a801c573b06 = ()=>{
    if (false) return false;
    if (!navigator || !navigator.userAgent || !navigator.userAgent.length) return false;
    return $6d434a87228f5691$var$ANDROID_CHROME_USER_AGENT.test(navigator.userAgent) || $6d434a87228f5691$var$MOBILE_USER_AGENT.test(navigator.userAgent) && !$6d434a87228f5691$var$OLD_ANDROID_USER_AGENT.test(navigator.userAgent);
};
const $6d434a87228f5691$export$6053d3a1e6477e0f = ()=>$6d434a87228f5691$var$ANDROID_CHROME_USER_AGENT.test(navigator.userAgent) || $6d434a87228f5691$var$OLD_ANDROID_USER_AGENT.test(navigator.userAgent);
const $6d434a87228f5691$export$b4161aa2f4036482 = ()=>$6d434a87228f5691$var$IOS_USER_AGENT.test(navigator.userAgent);
const $6d434a87228f5691$export$a33e336659bb3eb6 = ()=>{
    if (!navigator || !navigator.userAgent || !navigator.userAgent.length) return false;
    return $6d434a87228f5691$var$IPAD_USER_AGENT.test(navigator.userAgent) || $6d434a87228f5691$export$6053d3a1e6477e0f() && !$6d434a87228f5691$var$MOBILE_STRING_IN_USER_AGENT.test(navigator.userAgent);
};
const $6d434a87228f5691$var$isDesktopSwitchEnabled = ()=>(0, $aqZcy.getCookie)($6d434a87228f5691$var$DESKTOP_SWITCH_COOKIE_KEY) === 'true';
const $6d434a87228f5691$var$isMobileUserAgent = ()=>$6d434a87228f5691$export$2b0f0a801c573b06() && !$6d434a87228f5691$var$isDesktopSwitchEnabled();
const $6d434a87228f5691$export$604401c0b63e5273 = ()=>$6d434a87228f5691$export$2b0f0a801c573b06();
const $6d434a87228f5691$export$5ad7f0440f4fd036 = ()=>$6d434a87228f5691$export$604401c0b63e5273() && $6d434a87228f5691$export$a33e336659bb3eb6();
const $6d434a87228f5691$export$d9f2497f8d710783 = ()=>{
    if ($6d434a87228f5691$export$b4161aa2f4036482()) return 'ios';
    if ($6d434a87228f5691$export$6053d3a1e6477e0f()) return 'android';
    return 'other';
};
var $6d434a87228f5691$export$2e2bcd8739ae039 = $6d434a87228f5691$var$isMobileUserAgent;

});

parcelRegister("bBqV2", function(module, exports) {

$parcel$export(module.exports, "mobileBannerHeight", () => $0bcd02d2e3eab317$export$aa875602f5712b77);
$parcel$export(module.exports, "BANNER_NAME", () => $0bcd02d2e3eab317$export$41956b146268af93);
$parcel$export(module.exports, "ENCODED_APPLE_APP_STORE_URL", () => $0bcd02d2e3eab317$export$698c82a2c8445300);
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles

var $c9TLT = parcelRequire("c9TLT");
const $0bcd02d2e3eab317$export$aa875602f5712b77 = (0, $c9TLT.gridSize) * 6;
const $0bcd02d2e3eab317$export$41956b146268af93 = 'RETURN_TO_MOBILE_BANNER';
const $0bcd02d2e3eab317$export$698c82a2c8445300 = encodeURIComponent('https://itunes.apple.com/app/apple-store/id1006972087');

});



parcelRegister("7Rdn2", function(module, exports) {

$parcel$export(module.exports, "BannerAnnouncementAsync", () => $3bcbd6a43f5bed00$export$aa03f7909e0828ec);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $bAQOb = parcelRequire("bAQOb");

var $gGtKh = parcelRequire("gGtKh");

const $3bcbd6a43f5bed00$var$BannerAnnouncementOld = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("crJuA")).then((module)=>module.BannerAnnouncement), {
    ssr: true,
    moduleId: "./src/packages/platform/ui/banners/announcement/src/ui/banner/index.tsx"
});

// TODO: migrate RLL to entrypoints
const $3bcbd6a43f5bed00$var$BannerAnnouncementNew = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("hR7EC")).then((module)=>module.BannerAnnouncement), {
    ssr: true,
    moduleId: "./src/packages/platform/ui/banners/announcement/src/ui/banner-v2/index.tsx"
});
const $3bcbd6a43f5bed00$var$BannerAnnouncement = (0, $bAQOb.componentWithFF)('gravity.announcement-banner.enable-adf_33eic', $3bcbd6a43f5bed00$var$BannerAnnouncementNew, $3bcbd6a43f5bed00$var$BannerAnnouncementOld);
const $3bcbd6a43f5bed00$export$aa03f7909e0828ec = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-platform-ui-banners-announcement",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3bcbd6a43f5bed00$var$BannerAnnouncement, null));

});
parcelRegister("crJuA", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('jRWru');
        const value = parcelRequire('1Pfro');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("jRWru").then(()=>parcelRequire('1Pfro'));
}

});

parcelRegister("hR7EC", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('5okUl')
        ]);
        const value = parcelRequire('2JP8d');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("5okUl")
    ]).then(()=>parcelRequire('2JP8d'));
}

});


parcelRegister("imSzy", function(module, exports) {

$parcel$export(module.exports, "BannerTransitionAsync", () => $9423afe095590d92$export$8bf182764b9d2eb8);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $9423afe095590d92$var$BannerTransition = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("khljL")).then((module)=>module.BannerTransition), {
    moduleId: "./src/packages/platform/ui/banners/eoc-transition/src/ui/banner/index.tsx"
});
const $9423afe095590d92$export$8bf182764b9d2eb8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-banner-eoc-transition",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9423afe095590d92$var$BannerTransition, null));

});
parcelRegister("khljL", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('fqvm5');
        const value = parcelRequire('gIqiW');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("fqvm5").then(()=>parcelRequire('gIqiW'));
}

});


parcelRegister("8fKcN", function(module, exports) {

$parcel$export(module.exports, "MailExpiryBannerAsync", () => $964736e7e618d7bf$export$11a26ffa2d1b48ed);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

const $964736e7e618d7bf$var$LazyMailExpiryBanner = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("2Tuwd")).then(({ MailExpiryReminder: MailExpiryReminder })=>MailExpiryReminder), {
    moduleId: "./src/packages/platform/ui/banners/mail-expiry-reminder/src/ui/view.tsx"
});
const $964736e7e618d7bf$export$11a26ffa2d1b48ed = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-mail-expiry-banner",
        packageName: "jiraPlatformUiMailExpiryReminder",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-mail-expiry-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($964736e7e618d7bf$var$LazyMailExpiryBanner, null)));

});
parcelRegister("2Tuwd", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('9GC8O');
        const value = parcelRequire('8U4NP');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("9GC8O").then(()=>parcelRequire('8U4NP'));
}

});


parcelRegister("4E80X", function(module, exports) {

$parcel$export(module.exports, "ReturnToMobileBanner", () => $07b98091c81653c4$export$81c4f1e869d5a87);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $07b98091c81653c4$var$LazyReturnToMobileBanner = (0, $7rh0R.lazy)(()=>(parcelRequire("by7Gp")).then(({ ReturnToMobileBanner: ReturnToMobileBanner })=>ReturnToMobileBanner), {
    moduleId: "./src/packages/platform/ui/return-to-mobile-banner/src/main.tsx"
});
const $07b98091c81653c4$export$81c4f1e869d5a87 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-return-to-mobile-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($07b98091c81653c4$var$LazyReturnToMobileBanner, null));

});
parcelRegister("by7Gp", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('1RB2w');
        const value = parcelRequire('KEN32');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("1RB2w").then(()=>parcelRequire('KEN32'));
}

});


parcelRegister("3EdDr", function(module, exports) {

$parcel$export(module.exports, "ZIndexWrapper", () => $30c13a56fc17fb62$export$6bdda512681a5774);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $30c13a56fc17fb62$export$6bdda512681a5774 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { zIndex: zIndex, top: top, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_w6mvmh": (0, $9t7rW.default)(__cmplp.zIndex),
            "--_1vj9tq": (0, $9t7rW.default)(__cmplp.top)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1pby1fcb _kqswh2mm _154i1ter",
            __cmplp.className
        ])
    });
});

});


parcelRegister("5Wexj", function(module, exports) {

$parcel$export(module.exports, "GlobalComponents", () => $3828c60179ae7edc$export$461c2ed3163c74ff);

var $eUqFw = parcelRequire("eUqFw");

var $h97Af = parcelRequire("h97Af");

var $0cdA8 = parcelRequire("0cdA8");


var $10fdS = parcelRequire("10fdS");

var $isbb2 = parcelRequire("isbb2");

var $2B87Z = parcelRequire("2B87Z");

var $idiDE = parcelRequire("idiDE");
const $3828c60179ae7edc$var$routeComponents = [];
const $3828c60179ae7edc$var$RouteGlobalComponents = ()=>{
    const route = (0, $10fdS.useCurrentRoute)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $isbb2.renderGlobalComponents)(route.layout?.globalComponents || $3828c60179ae7edc$var$routeComponents));
};
// This component is necessary to ensure that the error boundary picks up errors in the renderGlobalComponents function
const $3828c60179ae7edc$var$SharedGlobalComponents = ({ sharedGlobalComponents: sharedGlobalComponents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $isbb2.renderGlobalComponents)(sharedGlobalComponents));
const $3828c60179ae7edc$export$461c2ed3163c74ff = ({ sharedGlobalComponents: sharedGlobalComponents })=>{
    const globalComponentsPerformanceTiming = (0, $eUqFw.useCallback)(()=>{
        (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)((0, $7688150c048b38d1$export$fb9876ab4228d985), (0, $7688150c048b38d1$export$c20831be6f780cb5), (0, $7688150c048b38d1$export$398df1bca49f9884), true, true);
    }, []);
    /**
	 * !!! DO NOT ADD INDIVIDUAL COMPONENTS TO THIS FILE !!!
	 *
	 * They should be defined as part of the `sharedGlobalComponents` constant, or defined on the route
	 * definition `layout` key.
	 *
	 * @see https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/jira/src/packages/platform/ui/layouts/jira-shared-layout/README.md
	 * @see https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/jira/src/packages/platform/ui/layouts/README.md
	 */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: (0, $7688150c048b38d1$export$c20831be6f780cb5)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: "unmount",
        id: "shared-global-components",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $idiDE.default), {
        name: "shared-global-components"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3828c60179ae7edc$var$SharedGlobalComponents, {
        sharedGlobalComponents: sharedGlobalComponents
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: "unmount",
        id: "route-global-components",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $idiDE.default), {
        name: "route-global-components"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3828c60179ae7edc$var$RouteGlobalComponents, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: (0, $7688150c048b38d1$export$398df1bca49f9884),
        onSet: globalComponentsPerformanceTiming
    }));
};

});
parcelRegister("idiDE", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8ff5844edbd42f4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $iWLL0 = parcelRequire("iWLL0");

var $5iuyH = parcelRequire("5iuyH");

var $adEL3 = parcelRequire("adEL3");
const $b8ff5844edbd42f4$var$newContextWithUfoContext = (context, interactionContext)=>context && interactionContext && {
        ...context,
        getInteractionContext: ()=>interactionContext
    };
const $b8ff5844edbd42f4$var$flowRight = (functionList)=>(arg)=>functionList.reduceRight((acc, fn)=>fn(acc), arg);
const $b8ff5844edbd42f4$var$renderContextProviderIfNonNull = (Context, contextValue)=>(node)=>contextValue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Context.Provider, {
            value: contextValue
        }, node) : node;
function $b8ff5844edbd42f4$var$JiraUFOLabelWrapper({ children: children }) {
    const context = (0, $5iuyH.useInteractionContext)();
    const rllProfilerContext = (0, $eUqFw.useContext)((0, $7rh0R.ProfilerContext));
    const relayProfilerContext = (0, $eUqFw.useContext)((0, $iWLL0.ProfilerContext));
    const newRllProfilerContext = (0, $eUqFw.useMemo)(()=>({
            current: $b8ff5844edbd42f4$var$newContextWithUfoContext(rllProfilerContext?.current, context)
        }), [
        context,
        rllProfilerContext
    ]);
    const newRelayProfilerContext = (0, $eUqFw.useMemo)(()=>$b8ff5844edbd42f4$var$newContextWithUfoContext(relayProfilerContext, context), [
        context,
        relayProfilerContext
    ]);
    // Produces the following but only renders a provider if its context is not null
    // <RelayProfilerContext.Provider ...>
    //   <RLLProfilerContext.Provider ...>
    //     {children}
    //   </...etc
    return $b8ff5844edbd42f4$var$flowRight([
        $b8ff5844edbd42f4$var$renderContextProviderIfNonNull((0, $iWLL0.ProfilerContext), newRelayProfilerContext),
        $b8ff5844edbd42f4$var$renderContextProviderIfNonNull((0, $7rh0R.ProfilerContext), newRllProfilerContext)
    ])(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children));
}
function $b8ff5844edbd42f4$export$2e2bcd8739ae039({ name: name, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $adEL3.default), {
        name: name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b8ff5844edbd42f4$var$JiraUFOLabelWrapper, null, children));
}

});
parcelRegister("adEL3", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecd8165bfe78bf8d$export$2e2bcd8739ae039);

var $jL1z3 = parcelRequire("jL1z3");
var $ecd8165bfe78bf8d$export$2e2bcd8739ae039 = (0, $jL1z3.default);

});
parcelRegister("jL1z3", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9c1936ffc5634d4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5iuyH = parcelRequire("5iuyH");
function $f9c1936ffc5634d4$export$2e2bcd8739ae039({ name: name, children: children }) {
    const context = (0, $5iuyH.useInteractionContext)();
    const newContext = (0, $eUqFw.useMemo)(()=>{
        if (context) return {
            ...context,
            labelStack: context.labelStack == null ? [
                {
                    name: name
                }
            ] : [
                ...context.labelStack,
                {
                    name: name
                }
            ]
        };
        else return context;
    }, [
        context,
        name
    ]);
    return context ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5iuyH.default).Provider, {
        value: newContext
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
}

});




parcelRegister("jG5np", function(module, exports) {

$parcel$export(module.exports, "GlobalContainers", () => $00841c043dae2742$export$3b677a7048d7ae0);

var $eUqFw = parcelRequire("eUqFw");

var $hfxON = parcelRequire("hfxON");

var $3fQGY = parcelRequire("3fQGY");

var $5BRby = parcelRequire("5BRby");

var $9EHc8 = parcelRequire("9EHc8");

var $h97Af = parcelRequire("h97Af");

var $fb5Sn = parcelRequire("fb5Sn");

var $6rW04 = parcelRequire("6rW04");


var $gXEQH = parcelRequire("gXEQH");

var $ln3W8 = parcelRequire("ln3W8");

var $jD3pk = parcelRequire("jD3pk");

var $2B87Z = parcelRequire("2B87Z");

var $gd0Sp = parcelRequire("gd0Sp");

var $hzkQm = parcelRequire("hzkQm");

var $emTse = parcelRequire("emTse");

var $zyR9K = parcelRequire("zyR9K");

var $6mtpk = parcelRequire("6mtpk");

var $agGRi = parcelRequire("agGRi");

var $hK0Sb = parcelRequire("hK0Sb");

var $f9UOp = parcelRequire("f9UOp");
const $00841c043dae2742$export$3b677a7048d7ae0 = ({ id: id, children: children, baseUrl: baseUrl, locale: locale, messages: messages, Router: Router, routerLinkComponent: routerLinkComponent })=>{
    const globalContainersPerformanceTiming = (0, $eUqFw.useCallback)(()=>{
        (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)((0, $7688150c048b38d1$export$4f341d86a3c214), (0, $7688150c048b38d1$export$16e7ead3a8b5c366), (0, $7688150c048b38d1$export$c389f0b50840d5ca), true, true);
        (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)((0, $7688150c048b38d1$export$7048c99f32c60b34), (0, $7688150c048b38d1$export$3c2d8af5c7577fe7), (0, $7688150c048b38d1$export$aac77afee74c49d0), true, true);
    }, []);
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    // Unstable components cause bugs and performance problems - please fix this! go/unstable-components
    // eslint-disable-next-line react/no-unstable-nested-components
    const MonolithStyleOverride = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("style", {
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: {
                __html: `
                        body#jira {
                            overflow-x: hidden;
                            overflow-y: auto;
                        }

                        #jira-frontend {
                            background: ${"var(--ds-surface, white)"};
                        }

                        #jira_request_timing_info {
                            margin: 0;
                        }
                    `
            }
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $emTse.IntlProviders), {
        messages: messages,
        locale: locale
    }, __SPA__ && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MonolithStyleOverride, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextContainer), {
        isGlobal: true,
        getMeta: (0, $6rW04.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3fQGY.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fb5Sn.default), {
        orgId: orgId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9EHc8.ViewExperienceTrackingProvider), {
        analyticsSource: (0, $7688150c048b38d1$export$c9e16a15d65437),
        experience: (0, $7688150c048b38d1$export$b1534bc11f201efd),
        experienceId: (0, $7688150c048b38d1$export$fa4bbc89fd1f1a7),
        application: (0, $7688150c048b38d1$export$aa6008fe0169b864),
        edition: (0, $7688150c048b38d1$export$39418a21fbb51487),
        additionalAttributes: (0, $gXEQH.routeAnalyticsAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hzkQm.ErrorBoundary), {
        id: id,
        withExperienceTracker: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: (0, $7688150c048b38d1$export$16e7ead3a8b5c366)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Router, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hfxON.default), {
        UNSAFE_isThemingDisabled: true,
        routerLinkComponent: routerLinkComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: (0, $7688150c048b38d1$export$c389f0b50840d5ca)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $agGRi.PageConfigContainers), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $zyR9K.MetricsContainers), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ln3W8.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6mtpk.NavigationContainers), {
        baseUrl: baseUrl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f9UOp.UserContainers), {
        baseUrl: baseUrl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hK0Sb.UiManagers), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: (0, $7688150c048b38d1$export$3c2d8af5c7577fe7)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), {
        id: "page-container-v2.nav-v3.app-base",
        hasErrorBoundary: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: (0, $7688150c048b38d1$export$aac77afee74c49d0),
        onSet: globalContainersPerformanceTiming
    }), children)))))))))))))));
};

});
parcelRegister("hfxON", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fca7a4faed4f95d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1SoQa = parcelRequire("1SoQa");

var $kk8oa = parcelRequire("kk8oa");
const $0fca7a4faed4f95d$var$InsideAppProviderContext = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
function $0fca7a4faed4f95d$export$c7dacf3845253dcf({ children: children, defaultColorMode: defaultColorMode = 'light', defaultTheme: defaultTheme, routerLinkComponent: routerLinkComponent, UNSAFE_isThemingDisabled: UNSAFE_isThemingDisabled }) {
    const isInsideAppProvider = (0, $eUqFw.useContext)($0fca7a4faed4f95d$var$InsideAppProviderContext);
    if (isInsideAppProvider) throw new Error('App provider should not be nested within another app provider.');
    const routerLinkProvider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1SoQa.default), {
        routerLinkComponent: routerLinkComponent
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0fca7a4faed4f95d$var$InsideAppProviderContext.Provider, {
        value: true
    }, UNSAFE_isThemingDisabled ? routerLinkProvider : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kk8oa.default), {
        defaultColorMode: defaultColorMode,
        defaultTheme: defaultTheme
    }, routerLinkProvider));
}
var $0fca7a4faed4f95d$export$2e2bcd8739ae039 = $0fca7a4faed4f95d$export$c7dacf3845253dcf;

});

parcelRegister("9EHc8", function(module, exports) {

$parcel$export(module.exports, "ViewExperienceTrackingProvider", () => $617962e6a5e395d0$export$a5efa46877be148f);
$parcel$export(module.exports, "SubExperienceTrackingProvider", () => $617962e6a5e395d0$export$e0241c84ce5db240);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $1YJkI = parcelRequire("1YJkI");

var $8yne0 = parcelRequire("8yne0");

var $8nLP2 = parcelRequire("8nLP2");
const $617962e6a5e395d0$export$a5efa46877be148f = ({ isExperienceReady: isExperienceReady, experience: experience, experienceId: experienceId, analyticsSource: analyticsSource, application: application, edition: edition, additionalAttributes: additionalAttributes, children: children })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8nLP2.default), {
        isExperienceReady: isExperienceReady,
        experience: experience,
        experienceId: experienceId,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        additionalAttributes: additionalAttributes
    }, children);
$617962e6a5e395d0$export$a5efa46877be148f.defaultProps = {
    isExperienceReady: true,
    experienceId: null,
    additionalAttributes: {}
};
var $617962e6a5e395d0$export$2e2bcd8739ae039 = $617962e6a5e395d0$export$a5efa46877be148f;
const $617962e6a5e395d0$export$e0241c84ce5db240 = ({ children: children, location: location, parentProviders: parentProviders })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : // DO NOT use `useContext` or `static contextType = ...` to consume this context
    // as the tree walker used in SSR does not support hooks
    // and SSR does not support `static contextType` setting
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1YJkI.default).Consumer, null, (context)=>{
        if (context == null) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('experience-sub-provider.missing-provider', 'Experience sub-provider rendered without a parent provider');
            return children;
        }
        const { experienceId: experienceId } = context;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8yne0.ExperienceTracker), {
            location: location,
            parentProviders: parentProviders
        }, (trackerCallbacks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8nLP2.default), {
                parentTrackerCallbacks: trackerCallbacks,
                experience: location,
                experienceId: experienceId,
                analyticsSource: null,
                application: null,
                edition: null,
                isExperienceReady: true
            }, children));
    });
$617962e6a5e395d0$export$e0241c84ce5db240.defaultProps = {
    parentProviders: null
};

});
parcelRegister("8nLP2", function(module, exports) {

$parcel$export(module.exports, "default", () => $392c2e4759c6c8b5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9lmTX = parcelRequire("9lmTX");


var $1YJkI = parcelRequire("1YJkI");
class $392c2e4759c6c8b5$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            parentTrackerCallbacks: null,
            additionalAttributes: {}
        };
    }
    constructor(props){
        super(props);
        this.onPending = ()=>{
            this.pendingCount += 1;
            this.shouldTrackExperience = true;
            this.checkAndStartTimer();
        };
        this.onSuccess = ()=>{
            this.pendingCount -= 1;
            this.checkAndStartTimer();
        };
        this.onFailure = (location, additionalAttributes)=>{
            // We need to track failure *immediately*, otherwise this component may
            // be unmounted and we'd miss our chance.
            this.trackExperience({
                wasExperienceSuccesful: false,
                location: location,
                additionalAttributes: additionalAttributes
            });
        };
        this.onAbort = (location, additionalAttributes)=>{
            this.trackExperience({
                wasExperienceSuccesful: false,
                action: (0, $99e7a4e4cbcb5db0$export$aeeb00d0845d24d8),
                location: location,
                additionalAttributes: additionalAttributes
            });
        };
        this.resetExperience();
    }
    componentDidMount() {
        this.checkAndStartTimer();
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.isExperienceReady && this.props.isExperienceReady) this.checkAndStartTimer();
    }
    componentDidCatch(error) {
        // This catches any errors that bubble up to the Provider that
        // may not be caught by any ExperienceTrackers
        this.trackExperience({
            wasExperienceSuccesful: false,
            location: 'error-reached-provider',
            additionalAttributes: {
                errorMessage: error.message,
                errorName: error.name
            }
        });
        // We're deliberately rethrowing the error here because we don't want to interfere with
        // any error handling the container app may have in place.
        throw error;
    }
    componentWillUnmount() {
        clearTimeout(this.timerId);
    }
    checkAndStartTimer() {
        if (this.shouldTrackExperience && this.props.isExperienceReady) this.startTimer();
    }
    startTimer() {
        clearTimeout(this.timerId);
        // @ts-expect-error - TS2322 - Type 'Timeout' is not assignable to type 'number'.
        this.timerId = setTimeout(()=>{
            if (this.pendingCount === 0) this.trackExperience({
                wasExperienceSuccesful: true
            });
        }, 1000);
    }
    // Resetting must not call setState since this can be executed in the render phase
    resetExperience() {
        clearTimeout(this.timerId);
        this.timerId = undefined;
        this.shouldTrackExperience = false;
        this.hasTrackedExperience = false;
        this.pendingCount = 0;
        this.memoizedContext = {
            consumerCallbacks: {
                onPending: this.onPending,
                onSuccess: this.onSuccess,
                onFailure: this.onFailure,
                onAbort: this.onAbort
            },
            experienceId: this.props.experienceId,
            experience: this.props.experience
        };
    }
    trackExperience({ wasExperienceSuccesful: wasExperienceSuccesful, action: action, location: location, additionalAttributes: additionalAttributes }) {
        if (this.hasTrackedExperience) // We only ever want to send a single success/failure event for an experience
        return;
        this.hasTrackedExperience = true;
        const { parentTrackerCallbacks: parentTrackerCallbacks, additionalAttributes: additionalAttributesFromProps } = this.props;
        if (parentTrackerCallbacks) {
            if (wasExperienceSuccesful) parentTrackerCallbacks.onExperienceSuccess();
            else parentTrackerCallbacks.onExperienceFailure(location, {
                ...additionalAttributesFromProps,
                ...additionalAttributes
            });
        } else {
            const { experience: experience } = this.memoizedContext;
            const { analyticsSource: analyticsSource, application: application, edition: edition } = this.props;
            analyticsSource && (0, $9lmTX.default)({
                experience: experience,
                action: action,
                wasExperienceSuccesful: wasExperienceSuccesful,
                location: location,
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                additionalAttributes: {
                    ...additionalAttributesFromProps,
                    ...additionalAttributes
                }
            });
        }
    }
    // Check every render to reset the experience state instance variables
    checkExperienceIdForExperienceReset() {
        if (this.memoizedContext.experienceId !== this.props.experienceId) this.resetExperience();
    }
    render() {
        this.checkExperienceIdForExperienceReset();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1YJkI.default).Provider, {
            value: this.memoizedContext
        }, this.props.children);
    }
}

});
const $99e7a4e4cbcb5db0$export$627ef4c1ed2d7a9a = 'taskSuccess';
const $99e7a4e4cbcb5db0$export$b48b3d1872522384 = 'taskFail';
const $99e7a4e4cbcb5db0$export$aeeb00d0845d24d8 = 'taskAbort';



parcelRegister("hzkQm", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $ab1cafd93f3f60c8$export$e926676385687eaf);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $ciZ8Y = parcelRequire("ciZ8Y");
const $ab1cafd93f3f60c8$export$e926676385687eaf = ({ children: children, id: id, withExperienceTracker: withExperienceTracker })=>{
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: id
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: id,
        packageName: "jiraEntry",
        fallback: "page",
        withExperienceTracker: withExperienceTracker
    }, children);
};

});

parcelRegister("emTse", function(module, exports) {

$parcel$export(module.exports, "IntlProviders", () => $16e82b5829d91fbb$export$c9d8cd4516cc55a8);

var $eUqFw = parcelRequire("eUqFw");

var $ao0hp = parcelRequire("ao0hp");

var $7LFzI = parcelRequire("7LFzI");
const $16e82b5829d91fbb$export$c9d8cd4516cc55a8 = ({ children: children, locale: locale, messages: messages })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7LFzI.IntlProvider), {
        messages: messages,
        locale: (0, $ao0hp.standardizeLocale)(locale)
    }, children);

});
parcelRegister("7LFzI", function(module, exports) {

$parcel$export(module.exports, "IntlProvider", () => $deabbabd1db0af3b$export$480518999dfc4151);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $3dpxL = parcelRequire("3dpxL");
const $deabbabd1db0af3b$export$480518999dfc4151 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
        ...props,
        defaultLocale: props.locale
    }, children);

});


parcelRegister("zyR9K", function(module, exports) {

$parcel$export(module.exports, "MetricsContainers", () => $d84d4b40df0a6094$export$2d1617bc0040e5d9);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $eX2O4 = parcelRequire("eX2O4");

var $gXEQH = parcelRequire("gXEQH");

var $8WuJm = parcelRequire("8WuJm");

var $1RPrZ = parcelRequire("1RPrZ");
const $d84d4b40df0a6094$export$2d1617bc0040e5d9 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: (0, $gXEQH.routeAnalyticsAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eX2O4.ExperienceTrackerProvider), null, !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: "unmount",
        id: "metrics-containers-subproduct-updater",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1RPrZ.SubProductUpdater), null)), children));

});
parcelRegister("eX2O4", function(module, exports) {

$parcel$export(module.exports, "ExperienceTrackerProvider", () => $ac9adb88a32f4483$export$6f49c95a810d59fa);

var $eUqFw = parcelRequire("eUqFw");

var $hUYqC = parcelRequire("hUYqC");
var $1xrmr = parcelRequire("1xrmr");

var $Xah93 = parcelRequire("Xah93");
const $ac9adb88a32f4483$var$useUnmount = (callback)=>(0, $eUqFw.useEffect)(()=>callback, [
        callback
    ]);
const $ac9adb88a32f4483$export$6f49c95a810d59fa = ({ children: children })=>{
    const [experienceTracker] = (0, $eUqFw.useState)(new (0, $hUYqC.ExperienceTracker)());
    const [cleanupSliSub] = (0, $eUqFw.useState)(()=>experienceTracker.subscribe((0, $Xah93.sliSubscriber)));
    const cleanup = (0, $eUqFw.useCallback)(()=>{
        cleanupSliSub();
    }, [
        cleanupSliSub
    ]);
    $ac9adb88a32f4483$var$useUnmount(cleanup);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1xrmr.ExperienceTrackerContext).Provider, {
        value: experienceTracker
    }, children);
};

});
parcelRegister("Xah93", function(module, exports) {

$parcel$export(module.exports, "sliSubscriber", () => $29a12df906341fa5$export$db0b99fe17114899);

var $3FyZ4 = parcelRequire("3FyZ4");

var $6WXNs = parcelRequire("6WXNs");
var $eIp1n = parcelRequire("eIp1n");

const $29a12df906341fa5$var$transformApplication = (application)=>{
    switch(application){
        case 0, $eIp1n.JIRA_SOFTWARE:
            return 'jira-software';
        case 0, $eIp1n.JIRA_PRODUCT_DISCOVERY:
            return 'jira-product-discovery';
        case 0, $eIp1n.JIRA_CORE:
            return 'jira-core';
        case 0, $eIp1n.JIRA_SERVICE_DESK:
            return 'jira-servicedesk';
        case 0, $eIp1n.JIRA_PORTFOLIO:
            return 'jira-portfolio';
        default:
            return 'unknown';
    }
};
const $29a12df906341fa5$var$transformEdition = (edition)=>{
    switch(edition){
        case 0, $6WXNs.FREE_EDITION:
            return 'jedi';
        case 0, $6WXNs.STANDARD_EDITION:
            return 'standard';
        case 0, $6WXNs.PREMIUM_EDITION:
            return 'premium';
        case 0, $6WXNs.UNLICENSED:
            return 'unlicensed';
        default:
            return 'unknown';
    }
};
const $29a12df906341fa5$var$createAnalyticsEvent = ({ experience: experience, action: action, location: location, analyticsSource: analyticsSource, application: application, edition: edition, errorMessage: errorMessage, additionalAttributes: additionalAttributes })=>({
        source: 'ui',
        action: action,
        actionSubject: 'ui',
        attributes: {
            ...additionalAttributes,
            // any attribute on top of this is overridable by any tracker
            task: experience,
            reason: location,
            analyticsSource: analyticsSource,
            application: $29a12df906341fa5$var$transformApplication(application),
            edition: $29a12df906341fa5$var$transformEdition(edition),
            ...errorMessage && {
                errorMessage: errorMessage
            }
        }
    });
const $29a12df906341fa5$var$reportSli = (experienceDescription)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        const event = $29a12df906341fa5$var$createAnalyticsEvent(experienceDescription);
        const clientInstance = client.getInstance();
        clientInstance.sendOperationalEvent(event);
    });
};
const $29a12df906341fa5$export$db0b99fe17114899 = (event)=>{
    const { name: name, action: action } = event;
    // @ts-expect-error - TS2339 - Property 'disableSli' does not exist on type '{}'. | TS2339 - Property 'analyticsSource' does not exist on type '{}'. | TS2339 - Property 'application' does not exist on type '{}'. | TS2339 - Property 'edition' does not exist on type '{}'. | TS2339 - Property 'location' does not exist on type '{}'.
    const { disableSli: disableSli, analyticsSource: analyticsSource, application: application, edition: edition, location: location, ...additionalAttributes } = event.attributes || {};
    if (disableSli) return;
    switch(action){
        case 0, $99e7a4e4cbcb5db0$export$627ef4c1ed2d7a9a:
            $29a12df906341fa5$var$reportSli({
                experience: name,
                action: (0, $99e7a4e4cbcb5db0$export$627ef4c1ed2d7a9a),
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                additionalAttributes: additionalAttributes
            });
            break;
        case 0, $99e7a4e4cbcb5db0$export$b48b3d1872522384:
            $29a12df906341fa5$var$reportSli({
                experience: name,
                action: (0, $99e7a4e4cbcb5db0$export$b48b3d1872522384),
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                location: location,
                ...event.error && {
                    errorMessage: String(event.error)
                },
                additionalAttributes: additionalAttributes
            });
            break;
        case 0, $99e7a4e4cbcb5db0$export$aeeb00d0845d24d8:
            $29a12df906341fa5$var$reportSli({
                experience: name,
                action: (0, $99e7a4e4cbcb5db0$export$aeeb00d0845d24d8),
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                location: location,
                additionalAttributes: additionalAttributes
            });
            break;
        default:
    }
};

});


parcelRegister("1RPrZ", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $570251e3e96e8c6c$export$eb40d3df56aa5c53);

var $eUqFw = parcelRequire("eUqFw");

var $keguF = parcelRequire("keguF");

var $dWlsy = parcelRequire("dWlsy");
const $570251e3e96e8c6c$export$eb40d3df56aa5c53 = ()=>{
    const subProduct = (0, $dWlsy.useSubProduct)();
    (0, $eUqFw.useEffect)(()=>{
        (0, $keguF.setSubProduct)(subProduct);
    }, [
        subProduct
    ]);
    return null;
};

});
parcelRegister("dWlsy", function(module, exports) {

$parcel$export(module.exports, "useSubProduct", () => $04e11956b03ab7c2$export$16aa2ad52cd8992a);

var $SEaoU = parcelRequire("SEaoU");

var $6QL9v = parcelRequire("6QL9v");
const $04e11956b03ab7c2$export$16aa2ad52cd8992a = ()=>{
    const [{ data: data }] = (0, $SEaoU.useContainerContext)();
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    if (!data?.project) return null;
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    return (0, $6QL9v.subProductFromProjectType)(data.project.type);
};

});
parcelRegister("6QL9v", function(module, exports) {

$parcel$export(module.exports, "subProductFromProjectType", () => $c2784746c0813b99$export$246e1e2a5c86a633);
const $c2784746c0813b99$export$246e1e2a5c86a633 = (projectType)=>{
    switch(projectType){
        case 'business':
            return 'core';
        case 'product_discovery':
        case 'software':
            return 'software';
        case 'service_desk':
            return 'serviceDesk';
        default:
            // prettier-ignore
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            projectType;
            return 'unknown';
    }
};

});




parcelRegister("6mtpk", function(module, exports) {

$parcel$export(module.exports, "NavigationContainers", () => $8e55b2de8860aa3e$export$36f9ed697cae18ae);
/* eslint-disable jira/react-magnetic-di/no-unneeded */ 
var $eUqFw = parcelRequire("eUqFw");

var $asu8X = parcelRequire("asu8X");

var $aZ9Tb = parcelRequire("aZ9Tb");
let $8e55b2de8860aa3e$var$Containers = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
if (!false) $8e55b2de8860aa3e$var$Containers = (0, $aZ9Tb.ClientOnlyNavigationContainers);
const $8e55b2de8860aa3e$export$36f9ed697cae18ae = ({ baseUrl: baseUrl, children: children })=>{
    (0, $asu8X.di)($8e55b2de8860aa3e$var$Containers);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8e55b2de8860aa3e$var$Containers, {
        baseUrl: baseUrl
    }, children);
};

});
parcelRegister("aZ9Tb", function(module, exports) {

$parcel$export(module.exports, "ClientOnlyNavigationContainers", () => $6d5f905fa11e966d$export$68d7c1e44acfd599);

var $eUqFw = parcelRequire("eUqFw");

var $6oi2X = parcelRequire("6oi2X");
const $6d5f905fa11e966d$export$68d7c1e44acfd599 = ({ children: children })=>{
    if (!false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6oi2X.Provider), null, children);
    return null;
};

});


parcelRegister("agGRi", function(module, exports) {

$parcel$export(module.exports, "PageConfigContainers", () => $56522c3977944126$export$9c661932489b4130);

var $eUqFw = parcelRequire("eUqFw");

var $7fSR6 = parcelRequire("7fSR6");

var $6rW04 = parcelRequire("6rW04");

var $1TtYL = parcelRequire("1TtYL");
var $3fq1f = parcelRequire("3fq1f");
const $56522c3977944126$export$9c661932489b4130 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7fSR6.ThemeContainer), {
        isGlobal: true,
        getMeta: (0, $6rW04.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1TtYL.DocumentTitleContainer), {
        titleSuffix: (0, $3fq1f.ripTitleTemplateFromMeta)((0, $6rW04.default))
    }, children));

});
parcelRegister("7fSR6", function(module, exports) {

$parcel$export(module.exports, "useTheme", () => $d3617e68561cf32c$export$93d4e7f90805808f);
$parcel$export(module.exports, "ThemeContainer", () => $d3617e68561cf32c$export$11eb671888ed6e7d);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");

var $g1FfP = parcelRequire("g1FfP");
const $d3617e68561cf32c$var$initialState = {
    navigationTheme: {
        shouldShowTitle: false,
        logoUrl: '',
        usesCustomColours: false,
        backgroundColor: '',
        highlightColor: ''
    }
};
const $d3617e68561cf32c$var$Store = (0, $a61MH.createStore)({
    name: 'theme',
    initialState: $d3617e68561cf32c$var$initialState,
    actions: $g1FfP
});
const $d3617e68561cf32c$export$74e6aa5aeff5e82e = (0, $dYfll.createSubscriber)($d3617e68561cf32c$var$Store);
const $d3617e68561cf32c$export$93d4e7f90805808f = (0, $ggKAj.createHook)($d3617e68561cf32c$var$Store);
const $d3617e68561cf32c$export$11eb671888ed6e7d = (0, $heB5U.createContainer)($d3617e68561cf32c$var$Store, {
    onInit: $g1FfP.bootstrap
});

});
parcelRegister("g1FfP", function(module, exports) {

$parcel$export(module.exports, "bootstrap", () => $74d45e3f7106acfe$export$36aff1fbb4f5dfc6);
$parcel$export(module.exports, "update", () => $74d45e3f7106acfe$export$722fbec263ad908a);

var $PdmhA = parcelRequire("PdmhA");
const $74d45e3f7106acfe$export$36aff1fbb4f5dfc6 = ()=>({ setState: setState }, { getMeta: getMeta })=>{
        const ajsBackgroundColor = getMeta('ajs-lf-navigation-bgcolour');
        const ajsHighlightColor = getMeta('ajs-lf-navigation-highlightcolour');
        // we need to use color code directly here to compare it with hex code in meta tags
        const hasNavv3CustomColors = ajsBackgroundColor != null && ajsHighlightColor != null && (ajsBackgroundColor !== (0, $PdmhA).N0 || ajsHighlightColor !== (0, $PdmhA).B400);
        const navigationTheme = {
            shouldShowTitle: getMeta('ajs-lf-top-adg3-shouldshowtitle') === 'true',
            logoUrl: getMeta('ajs-lf-top-adg3-logourl') || '',
            usesCustomColours: getMeta('ajs-lf-top-adg3-hascustomcolours') === 'true',
            backgroundColor: ajsBackgroundColor || `var(--ds-background-inverse-subtle, ${(0, $PdmhA).N0})`,
            highlightColor: ajsHighlightColor || `var(--ds-text-brand, ${(0, $PdmhA).B400})`
        };
        if (hasNavv3CustomColors) navigationTheme.usesCustomColours = true;
        setState({
            navigationTheme: navigationTheme
        });
    };
const $74d45e3f7106acfe$export$722fbec263ad908a = (item)=>({ setState: setState, getState: getState })=>{
        const navigationTheme = {
            ...getState().navigationTheme,
            ...item
        };
        setState({
            navigationTheme: navigationTheme
        });
    };

});


parcelRegister("1TtYL", function(module, exports) {

$parcel$export(module.exports, "useDocumentTitleActions", () => $d28b8ffe196ad843$export$57c0fda036e12d67);
$parcel$export(module.exports, "DocumentTitleContainer", () => $d28b8ffe196ad843$export$1aad43993172f16f);
$parcel$export(module.exports, "DocumentTitleSubscriber", () => $d28b8ffe196ad843$export$b88d5abf3e0bec8c);
$parcel$export(module.exports, "DocumentTitleHelper", () => $d28b8ffe196ad843$export$573bf8d2ae7d60dc);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");

var $98Lej = parcelRequire("98Lej");

var $3fq1f = parcelRequire("3fq1f");
const $d28b8ffe196ad843$var$initialState = {
    title: '',
    defaultTitle: '',
    contextArray: []
};
const $d28b8ffe196ad843$var$Store = (0, $a61MH.createStore)({
    name: 'document-title',
    initialState: $d28b8ffe196ad843$var$initialState,
    actions: $98Lej
});
const $d28b8ffe196ad843$export$57c0fda036e12d67 = (0, $ggKAj.createActionsHook)($d28b8ffe196ad843$var$Store);
const $d28b8ffe196ad843$export$1aad43993172f16f = (0, $heB5U.createContainer)($d28b8ffe196ad843$var$Store, {
    displayName: 'DocumentTitleContainer'
});
const $d28b8ffe196ad843$export$b88d5abf3e0bec8c = (0, $dYfll.createSubscriber)($d28b8ffe196ad843$var$Store, {
    displayName: 'DocumentTitleSubscriber'
});
class $d28b8ffe196ad843$export$573bf8d2ae7d60dc extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.myself = Symbol('document title identifier');
        this.props.addDocumentTitle(this.myself);
    }
    componentDidMount() {
        this.updateTitle();
    }
    componentDidUpdate() {
        this.updateTitle();
    }
    componentWillUnmount() {
        this.props.removeDocumentTitle(this.myself);
        this.updateTitle();
    }
    updateTitle() {
        if ((0, $3fq1f.checkDocumentTitle)(this.myself, this.props.contextArray)) this.props.setTitle(this.props.title);
    }
    render() {
        return null;
    }
}

});
parcelRegister("98Lej", function(module, exports) {

$parcel$export(module.exports, "setTitle", () => (parcelRequire("hzX2Z")).default);
$parcel$export(module.exports, "addDocumentTitle", () => (parcelRequire("aIEib")).addDocumentTitle);
$parcel$export(module.exports, "removeDocumentTitle", () => (parcelRequire("h3oaR")).removeDocumentTitle);

var $hzX2Z = parcelRequire("hzX2Z");

var $aIEib = parcelRequire("aIEib");

var $h3oaR = parcelRequire("h3oaR");

});
parcelRegister("hzX2Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $badd7a809fe968ef$export$2e2bcd8739ae039);

var $3fq1f = parcelRequire("3fq1f");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$badd7a809fe968ef$export$2e2bcd8739ae039 = (title)=>({ setState: setState, getState: getState }, { titleSuffix: titleSuffix })=>{
        const state = getState();
        const titleTemplate = titleSuffix ? `%s - ${titleSuffix}` : '%s - Jira';
        const newTitle = (0, $3fq1f.createTitleFromTemplate)(title, titleTemplate);
        document.title = newTitle;
        setState({
            ...state,
            title: newTitle
        });
    };

});
parcelRegister("3fq1f", function(module, exports) {

$parcel$export(module.exports, "createTitleFromTemplate", () => $5992d599a50ec92a$export$3795256dd54a9c9d);
$parcel$export(module.exports, "ripTitleTemplateFromMeta", () => $5992d599a50ec92a$export$b7d18105f80195c);
$parcel$export(module.exports, "checkDocumentTitle", () => $5992d599a50ec92a$export$7f8be70a0bed1bae);
const $5992d599a50ec92a$export$3795256dd54a9c9d = (title, template)=>template.replace(/%s/, title);
const $5992d599a50ec92a$export$b7d18105f80195c = (getMeta)=>getMeta('ajs-app-title');
const $5992d599a50ec92a$export$7f8be70a0bed1bae = (title, contextArray)=>{
    if (contextArray[contextArray.length - 1] === title) return true;
    return false;
};

});


parcelRegister("aIEib", function(module, exports) {

$parcel$export(module.exports, "addDocumentTitle", () => $65d14c1ffc455bbb$export$a0c188c0ea474bb8);
const $65d14c1ffc455bbb$export$a0c188c0ea474bb8 = (title)=>({ setState: setState, getState: getState })=>{
        const { contextArray: contextArray } = getState();
        contextArray.push(title);
        setState({
            contextArray: contextArray
        });
    };

});

parcelRegister("h3oaR", function(module, exports) {

$parcel$export(module.exports, "removeDocumentTitle", () => $06c2c915252a36d1$export$e844009b77f80a72);
const $06c2c915252a36d1$export$e844009b77f80a72 = (title)=>({ setState: setState, getState: getState })=>{
        const { contextArray: contextArray } = getState();
        setState({
            contextArray: contextArray.filter((symbol)=>symbol !== title)
        });
    };

});




parcelRegister("hK0Sb", function(module, exports) {

$parcel$export(module.exports, "UiManagers", () => $9e6e4a1178661ec4$export$41286c339a88ca24);
/* eslint-disable jira/react-magnetic-di/no-unneeded */ 
var $eUqFw = parcelRequire("eUqFw");

var $asu8X = parcelRequire("asu8X");

var $7ehAr = parcelRequire("7ehAr");

var $e20LE = parcelRequire("e20LE");

var $8e3ho = parcelRequire("8e3ho");
let $9e6e4a1178661ec4$var$ClientUiManagers = (0, $eUqFw.Fragment);
if (!false) // @ts-expect-error - TS2741 - Property '$$typeof' is missing in type '({ children }: ClientUiManagersProps) => JSX.Element' but required in type 'ExoticComponent<{ children?: ReactNode; }>'.
$9e6e4a1178661ec4$var$ClientUiManagers = (0, $8e3ho.ClientUiManagers);
const $9e6e4a1178661ec4$export$41286c339a88ca24 = ({ children: children })=>{
    (0, $asu8X.di)($9e6e4a1178661ec4$var$ClientUiManagers);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e20LE.LayoutManager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ehAr.BreadcrumbManager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9e6e4a1178661ec4$var$ClientUiManagers, null, children)));
};

});
parcelRegister("7ehAr", function(module, exports) {

$parcel$export(module.exports, "BreadcrumbManager", () => $fb73611fabb3f59f$export$cd5073909dd92c28);

var $eUqFw = parcelRequire("eUqFw");

var $bfY8R = parcelRequire("bfY8R");
const $fb73611fabb3f59f$export$cd5073909dd92c28 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bfY8R.BreadcrumbContainer), null, children);

});

parcelRegister("e20LE", function(module, exports) {

$parcel$export(module.exports, "LayoutManager", () => $631e215ae14481e0$export$4a04ad01c410b415);

var $eUqFw = parcelRequire("eUqFw");

var $heB5U = parcelRequire("heB5U");

var $kJlBc = parcelRequire("kJlBc");
var $3HCkE = parcelRequire("3HCkE");

var $1NIhY = parcelRequire("1NIhY");

var $3roBA = parcelRequire("3roBA");

var $53ucm = parcelRequire("53ucm");
const $631e215ae14481e0$var$LayoutContainer = (0, $heB5U.createContainer)((0, $53ucm.layoutStore), {
    displayName: 'JiraLayoutContainer',
    onInit: ()=>({ dispatch: dispatch }, { leftSidebar: leftSidebar, rightSidebar: rightSidebar, isChromeless: isChromeless })=>{
            dispatch((0, $3roBA.actions).setIsChromeless(isChromeless));
            dispatch((0, $3roBA.actions).setLeftSidebarState(leftSidebar));
            dispatch((0, $3roBA.actions).setRightSidebarState(rightSidebar));
        },
    onUpdate: ()=>({ dispatch: dispatch }, { isChromeless: isChromeless })=>{
            dispatch((0, $3roBA.actions).setIsChromeless(isChromeless));
        }
});
const $631e215ae14481e0$var$DEFFAULT_RIGHT_SIDEBAR_STATE = {
    stackState: []
};
const $631e215ae14481e0$var$useIsChromeless = (0, $kJlBc.createRouterSelector)((state)=>state.route.layout?.isChromeless === true || state.route.entryPoint?.()?.toString() === 'ChromelessEntryPoint');
const $631e215ae14481e0$export$4a04ad01c410b415 = ({ children: children })=>{
    const { data: data } = (0, $3HCkE.useResource)((0, $1NIhY.navigationUiStateResource));
    const isChromeless = $631e215ae14481e0$var$useIsChromeless();
    const isLeftSidebarCollapsed = data?.leftSidebar?.isCollapsed ?? false;
    const leftSidebarWidth = data?.leftSidebar?.width ?? (0, $53ucm.DEFAULT_LEFT_SIDEBAR_WIDTH);
    const leftSidebar = (0, $eUqFw.useMemo)(()=>({
            isVisible: true,
            isCollapsed: isLeftSidebarCollapsed,
            width: leftSidebarWidth,
            isFlyoutOpen: false
        }), [
        isLeftSidebarCollapsed,
        leftSidebarWidth
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($631e215ae14481e0$var$LayoutContainer, {
        isGlobal: true,
        isChromeless: isChromeless,
        leftSidebar: leftSidebar,
        rightSidebar: $631e215ae14481e0$var$DEFFAULT_RIGHT_SIDEBAR_STATE
    }, children);
};

});

parcelRegister("8e3ho", function(module, exports) {

$parcel$export(module.exports, "ClientUiManagers", () => $3490141dc4535941$export$d1db6ae5bf84e489);

var $eUqFw = parcelRequire("eUqFw");

var $aOINP = parcelRequire("aOINP");

var $plbOU = parcelRequire("plbOU");

var $dQZ5c = parcelRequire("dQZ5c");

var $k8Qyf = parcelRequire("k8Qyf");

var $jvfW6 = parcelRequire("jvfW6");

var $lbttE = parcelRequire("lbttE");
const $3490141dc4535941$export$d1db6ae5bf84e489 = ({ children: children })=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $plbOU.CrossFlowProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lbttE.ProjectCreateDrawerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dQZ5c.FavouriteChangeProvider), {
        onShowFlag: showFlag
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOINP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jvfW6.ModalContextProvider), null, children)))));
};

});
parcelRegister("plbOU", function(module, exports) {

$parcel$export(module.exports, "CrossFlowProvider", () => $cd07cb8d277928e5$export$d900e4062895cd7c);

var $eUqFw = parcelRequire("eUqFw");

var $gl6u1 = parcelRequire("gl6u1");

var $3FyZ4 = parcelRequire("3FyZ4");

var $gd0Sp = parcelRequire("gd0Sp");

var $4Vji8 = parcelRequire("4Vji8");
var $iPzab = parcelRequire("iPzab");
// DELOR-412 Remove explicit mock once we make analytics a no-op in SSR
const $cd07cb8d277928e5$var$getAnalyticsInstance = ()=>false ? Promise.resolve({
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        sendUIEvent: ()=>{},
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        sendOperationalEvent: ()=>{},
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        sendTrackEvent: ()=>{},
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        sendScreenEvent: ()=>{}
    }) : (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>client.getInstance());
const $cd07cb8d277928e5$export$d900e4062895cd7c = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: { cloudId: cloudId, locale: locale } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gl6u1.default), {
            cloudId: cloudId,
            // @ts-expect-error - TS2322 - Type 'Promise<typeof AnalyticsWebClient> | Promise<{ sendUIEvent: () => void; sendOperationalEvent: () => void; sendTrackEvent: () => void; sendScreenEvent: () => void; }>' is not assignable to type 'MaybePromise<AnalyticsWebClientInterface>'.
            analyticsClient: $cd07cb8d277928e5$var$getAnalyticsInstance(),
            locale: locale,
            plugins: [
                (0, $4Vji8.getContainersPlugin),
                (0, $iPzab.getUsersPlugin)
            ]
        }, children));

});
parcelRegister("gl6u1", function(module, exports) {

$parcel$export(module.exports, "default", () => $0611a94f424d0efe$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6HgZc = parcelRequire("6HgZc");

var $fbeIa = parcelRequire("fbeIa");
const $0611a94f424d0efe$var$JiraProvider = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6HgZc.CrossFlowProvider), {
        ...props,
        originProduct: "jira"
    });
};
var $0611a94f424d0efe$export$2e2bcd8739ae039 = $0611a94f424d0efe$var$JiraProvider;

});
parcelRegister("6HgZc", function(module, exports) {

$parcel$export(module.exports, "CrossFlowProvider", () => $5e25fa3d562685b2$export$d900e4062895cd7c);

var $eUqFw = parcelRequire("eUqFw");

var $hXPzA = parcelRequire("hXPzA");

var $juktg = parcelRequire("juktg");

var $8tM2T = parcelRequire("8tM2T");

var $2E0s4 = parcelRequire("2E0s4");

var $bUJ3s = parcelRequire("bUJ3s");

var $l1XvG = parcelRequire("l1XvG");

var $11Onj = parcelRequire("11Onj");

var $d2Lyf = parcelRequire("d2Lyf");

var $ijZC5 = parcelRequire("ijZC5");

var $hiWux = parcelRequire("hiWux");

const $5e25fa3d562685b2$var$IntegrationView = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).lazy(()=>(parcelRequire("8dJhh")));
const $5e25fa3d562685b2$export$79d79d8dd8574306 = (IntegrationView)=>(props)=>{
        const { children: children, analyticsClient: analyticsClient, originProduct: originProduct, redirectToWac: redirectToWac, env: env, plugins: plugins = [], globalExperimentalOptions: globalExperimentalOptions, onError: onError, ...baseProviderProps } = props;
        // TBLZ-852: Product Store - Personal Use Case
        // go/trailblazerexperiments
        const tblz852ExperimentCohort = (0, $8tM2T.default).getExperimentValue('product_store_personal_use_case', 'cohort', 'not-enrolled', {
            fireExperimentExposure: false
        });
        const isInTblz852ExperimentCohort = tblz852ExperimentCohort === 'variation';
        // TBLZ-852
        const onCloseResolver = (0, $eUqFw.useRef)();
        const [firstHandshakeReceived, setFirstHandshakeReceived] = (0, $eUqFw.useState)(false);
        const fireEvent = (0, $eUqFw.useMemo)(()=>(0, $2E0s4.analyticsWrapper)(analyticsClient), [
            analyticsClient
        ]);
        const [requestOptions, setRequestOptions] = (0, $eUqFw.useState)();
        const onAnalyticsEvent = (0, $eUqFw.useCallback)((payload)=>{
            const gasV3Event = (0, $bUJ3s.transformEvent)(payload);
            if (gasV3Event) {
                const enrichedEvent = (0, $ijZC5.enrichWithRequestOptions)((0, $d2Lyf.enrichWithPackageDetails)(gasV3Event), requestOptions);
                fireEvent(enrichedEvent);
            }
        }, [
            fireEvent,
            requestOptions
        ]);
        const onHandShake = (0, $eUqFw.useCallback)((appName)=>{
            if (!firstHandshakeReceived) {
                onAnalyticsEvent({
                    payload: {
                        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
                        action: (0, $hiWux.uiInitialized),
                        actionSubject: (0, $hiWux.crossFlowActionSubject),
                        attributes: {
                            appName: appName
                        }
                    },
                    context: [
                        {
                            source: $hiWux.source
                        }
                    ]
                });
                setFirstHandshakeReceived(true);
            }
        }, [
            firstHandshakeReceived,
            onAnalyticsEvent
        ]);
        const onOpen = (0, $eUqFw.useCallback)((options)=>{
            /**
     * Reset first handshake state to ensure 1:1 value of open invoked and handshake received
     * Caveat that if open api is invoked while cross flow support UI is already mounted there will be mismatch of openInvoked events to uiInitialized events
     */ setFirstHandshakeReceived(false);
            const analyticsEvent = {
                // setRequestOptions does not update the state right away (updates on the next render) so for the openInvoked event we need to manually append the sourceComponent and sourceContext
                payload: (0, $ijZC5.enrichWithRequestOptions)({
                    eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
                    action: (0, $hiWux.openInvoked),
                    actionSubject: (0, $hiWux.crossFlowActionSubject)
                }, options),
                context: [
                    {
                        source: $hiWux.source
                    }
                ]
            };
            onAnalyticsEvent(analyticsEvent);
            // Short circuit requestOptions for WAC expansions
            if (options.journey === (0, $hXPzA.Journeys).GET_STARTED && redirectToWac) {
                (0, $l1XvG.setProductSignUpLocation)(options.targetProduct, env, options.sourceComponent, options.sourceContext);
                const completionStatus = {};
                return Promise.resolve(completionStatus);
            }
            const updatedExperimentalOptions = {
                ...globalExperimentalOptions || {},
                // "globalExperimentalOptions" will be injected to EVERY crossFlow invoke
                ...options.experimentalOptions || {} // "options.experimentalOptions" takes care of passing experimentalOptions to ONE specific crossFlow invoke
            };
            options.experimentalOptions = updatedExperimentalOptions;
            setRequestOptions(options);
            return new Promise((resolve)=>{
                onCloseResolver.current = resolve;
            });
        }, [
            onAnalyticsEvent,
            env,
            redirectToWac,
            globalExperimentalOptions
        ]);
        const onClose = (0, $eUqFw.useCallback)((completionStatus)=>{
            setFirstHandshakeReceived(false);
            setRequestOptions(undefined);
            onCloseResolver.current && onCloseResolver.current(completionStatus);
        }, []);
        const { colorMode: colorMode } = (0, $juktg.default)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hXPzA.BaseCrossFlowApiProvider), {
            onOpen: onOpen
        }, children, requestOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $11Onj.ErrorBoundary), {
            onAnalyticsEvent: onAnalyticsEvent,
            onError: onError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IntegrationView, {
            ...baseProviderProps,
            ...requestOptions,
            onAnalyticsEvent: onAnalyticsEvent,
            originProduct: originProduct,
            theme: colorMode,
            onClose: onClose,
            onHandShake: onHandShake,
            plugins: plugins,
            env: env,
            redirectToWac: redirectToWac,
            isInTblz852ExperimentCohort: isInTblz852ExperimentCohort,
            zIndex: requestOptions.zIndex ?? 1000
        }))));
    };
const $5e25fa3d562685b2$export$d900e4062895cd7c = $5e25fa3d562685b2$export$79d79d8dd8574306($5e25fa3d562685b2$var$IntegrationView);

});
parcelRegister("2E0s4", function(module, exports) {

$parcel$export(module.exports, "analyticsWrapper", () => $1695ae3f05391a1c$export$91b4dd3bfc301325);

const $1695ae3f05391a1c$export$91b4dd3bfc301325 = (analyticsClient)=>{
    return (event)=>{
        return Promise.resolve(analyticsClient).then((client)=>{
            switch(event.eventType){
                case 0, $662e33bb7444ae33$export$a1562d08625f5d7e:
                    client.sendUIEvent(event);
                    break;
                case 0, $662e33bb7444ae33$export$947dac6c72b26f81:
                    client.sendTrackEvent(event);
                    break;
                case 0, $662e33bb7444ae33$export$12346a674644c156:
                    client.sendOperationalEvent(event);
                    break;
                case 0, $662e33bb7444ae33$export$f1d537d508d2945a:
                    client.sendScreenEvent(event);
                    break;
            }
        });
    };
};

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $662e33bb7444ae33$export$a1562d08625f5d7e = 'ui';
const $662e33bb7444ae33$export$947dac6c72b26f81 = 'track';
const $662e33bb7444ae33$export$f1d537d508d2945a = 'screen';
const $662e33bb7444ae33$export$12346a674644c156 = 'operational';
const $662e33bb7444ae33$export$b055de0e665cb20c = 'unknown';


parcelRegister("bUJ3s", function(module, exports) {

$parcel$export(module.exports, "transformEvent", () => $86a18706a692bb1d$export$3f40e8c44448be30);
// Copied from xflow-ui. We post raw analytics events (context and payload only) from xflow-ui to consumer (CFE), transform on consumer and post to gasv3.

const $86a18706a692bb1d$var$GROWTH_TAG = 'growth';
const $86a18706a692bb1d$var$extractFromEventContext = (propertyNames, context)=>context.reduce((acc, contextItem)=>{
        propertyNames.forEach((propertyName)=>{
            const navContextProp = contextItem ? contextItem[propertyName] : null;
            acc.push(navContextProp || contextItem[propertyName]);
        });
        return acc;
    }, []).filter(Boolean);
const $86a18706a692bb1d$var$getSources = (context)=>$86a18706a692bb1d$var$extractFromEventContext([
        'source'
    ], context);
const $86a18706a692bb1d$var$getExtraAttributes = (context)=>context.reduce((ans, { attributes: attributes, ...contextProps })=>{
        const newAttributes = {
            ...ans,
            ...contextProps
        };
        return attributes ? {
            ...newAttributes,
            ...attributes
        } : newAttributes;
    }, {});
const $86a18706a692bb1d$var$getPackageInfo = (context)=>context.map((contextItem)=>({
            packageName: contextItem.packageName,
            packageVersion: contextItem.packageVersion
        })).filter((p)=>p.packageName);
const $86a18706a692bb1d$var$last = (values)=>values[values.length - 1];
const $86a18706a692bb1d$export$3f40e8c44448be30 = (event)=>{
    const { context: context, payload: payload } = event;
    if (!payload) return null;
    const sources = $86a18706a692bb1d$var$getSources(context);
    const source = $86a18706a692bb1d$var$last(sources) || (0, $662e33bb7444ae33$export$b055de0e665cb20c);
    const extraAttributes = $86a18706a692bb1d$var$getExtraAttributes(context);
    const { packageName: packageName, packageVersion: packageVersion } = $86a18706a692bb1d$var$last($86a18706a692bb1d$var$getPackageInfo(context)) || {};
    const { eventType: eventType = (0, $662e33bb7444ae33$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = payload;
    const attributes = {
        packageName: packageName,
        packageVersion: packageVersion,
        ...extraAttributes,
        ...payloadAttributes
    };
    const tags = payload.tags || [];
    tags.push($86a18706a692bb1d$var$GROWTH_TAG);
    switch(eventType){
        case 0, $662e33bb7444ae33$export$a1562d08625f5d7e:
        case 0, $662e33bb7444ae33$export$12346a674644c156:
        case 0, $662e33bb7444ae33$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: tags.slice(0)
            };
        case 0, $662e33bb7444ae33$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                source: source,
                tags: tags.slice(0)
            };
        default:
            break;
    }
    return null;
};

});

parcelRegister("l1XvG", function(module, exports) {

$parcel$export(module.exports, "setProductSignUpLocation", () => $08ab6814e0b91ccb$export$2827e2473cb9a346);

var $8a0ZO = parcelRequire("8a0ZO");


var $cWAJB = parcelRequire("cWAJB");
const $08ab6814e0b91ccb$var$utmCampaignMap = {
    'atlassian-switcher': (0, $cWAJB.UtmCampaign)['atlassian-switcher']
};
const $08ab6814e0b91ccb$var$isBundledProduct = (productKey)=>{
    return [
        (0, $8a0ZO.Targets).JIRA_SOFTWARE,
        (0, $8a0ZO.Targets).JIRA_SERVICE_DESK,
        (0, $8a0ZO.Targets).JIRA_CORE,
        (0, $8a0ZO.Targets).CONFLUENCE
    ].includes(productKey);
};
const $08ab6814e0b91ccb$var$getBundleSignUpParams = (productKey)=>{
    const bundles = {
        [(0, $8a0ZO.Targets).JIRA_SOFTWARE]: 'jira-software',
        [(0, $8a0ZO.Targets).JIRA_SERVICE_DESK]: 'jira-service-desk',
        [(0, $8a0ZO.Targets).JIRA_CORE]: 'jira-core',
        [(0, $8a0ZO.Targets).CONFLUENCE]: 'confluence'
    };
    // Bundles default to free
    return `bundle=${bundles[productKey]}&edition=free`;
};
const $08ab6814e0b91ccb$var$isProductWithCustomSignUpPath = (productKey)=>{
    return [
        (0, $8a0ZO.Targets).OPSGENIE
    ].includes(productKey);
};
const $08ab6814e0b91ccb$var$getProductCustomSignUpPath = (productKey)=>{
    // Only Opsgenie. Trello, Bitbucket and Statuspage are handled by Product Store directly.
    const links = {
        [(0, $8a0ZO.Targets).OPSGENIE]: (0, $45dad2c59b5aaad6$export$fb1e43fdafe12e9b)
    };
    return links[productKey];
};
const $08ab6814e0b91ccb$var$isSourceComponentWithUtmParams = (sourceComponent)=>{
    return Boolean($08ab6814e0b91ccb$var$utmCampaignMap[sourceComponent]);
};
const $08ab6814e0b91ccb$var$getUtmParams = (sourceComponent, sourceContext)=>{
    let utmParams = '';
    if (sourceComponent && $08ab6814e0b91ccb$var$isSourceComponentWithUtmParams(sourceComponent)) {
        utmParams = utmParams + `utm_campaign=${$08ab6814e0b91ccb$var$utmCampaignMap[sourceComponent]}&utm_medium=in_product_ad`;
        if (sourceContext) utmParams = utmParams + `&utm_source=${sourceContext}`;
    }
    return utmParams;
};
const $08ab6814e0b91ccb$export$39eab502fc96327d = (productKey, env, sourceComponent, sourceContext)=>{
    const wacUrl = env === 'staging' ? (0, $45dad2c59b5aaad6$export$c37558e5c67d2b01) : (0, $45dad2c59b5aaad6$export$f199baf8dfc7621e);
    const utmParams = $08ab6814e0b91ccb$var$getUtmParams(sourceComponent, sourceContext);
    let queryParams = '';
    let bundleParams = '';
    let path = (0, $45dad2c59b5aaad6$export$2a45a00073911255);
    if ($08ab6814e0b91ccb$var$isBundledProduct(productKey)) {
        path = (0, $45dad2c59b5aaad6$export$e6c04a1dd86d1c14);
        bundleParams = $08ab6814e0b91ccb$var$getBundleSignUpParams(productKey);
    } else if ($08ab6814e0b91ccb$var$isProductWithCustomSignUpPath(productKey)) path = $08ab6814e0b91ccb$var$getProductCustomSignUpPath(productKey);
    if (!!bundleParams) queryParams = queryParams + `?${bundleParams}`;
    if (!!utmParams) queryParams = queryParams + (!!queryParams ? '&' : '?') + utmParams;
    return wacUrl + path + queryParams;
};
const $08ab6814e0b91ccb$export$2827e2473cb9a346 = (productKey, env = 'production', sourceComponent, sourceContext)=>{
    const url = $08ab6814e0b91ccb$export$39eab502fc96327d(productKey, env, sourceComponent, sourceContext);
    window.open(url, '_blank');
};

});
const $45dad2c59b5aaad6$export$c37558e5c67d2b01 = 'https://qa-wac.internal.atlassian.com';
const $45dad2c59b5aaad6$export$f199baf8dfc7621e = 'https://www.atlassian.com';
const $45dad2c59b5aaad6$export$fb1e43fdafe12e9b = '/software/opsgenie/try';
const $45dad2c59b5aaad6$export$e6c04a1dd86d1c14 = '/try/cloud/signup';
const $45dad2c59b5aaad6$export$2a45a00073911255 = '/software';

parcelRegister("cWAJB", function(module, exports) {

$parcel$export(module.exports, "UtmCampaign", () => $7d339faa65117a6e$export$fc604aa353a97e10);
var $7d339faa65117a6e$export$fc604aa353a97e10;
(function(UtmCampaign) {
    UtmCampaign["atlassian-switcher"] = "atlassian_switcher";
})($7d339faa65117a6e$export$fc604aa353a97e10 || ($7d339faa65117a6e$export$fc604aa353a97e10 = {}));

});


parcelRegister("11Onj", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $cd98b27b730d7cfb$export$e926676385687eaf);

var $eUqFw = parcelRequire("eUqFw");

var $hiWux = parcelRequire("hiWux");
const $cd98b27b730d7cfb$var$name = undefined;
const $cd98b27b730d7cfb$var$version = undefined;
const $cd98b27b730d7cfb$var$payload = {
    eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
    action: (0, $hiWux.errorBoundaryAction),
    actionSubject: (0, $hiWux.errorBoundaryActionSubject)
};
const $cd98b27b730d7cfb$var$context = [
    {
        source: $hiWux.source
    },
    {
        packageName: $cd98b27b730d7cfb$var$name,
        packageVersion: $cd98b27b730d7cfb$var$version
    }
];
class $cd98b27b730d7cfb$export$e926676385687eaf extends (0, $eUqFw.Component) {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    componentDidCatch(error) {
        this.props.onAnalyticsEvent({
            payload: $cd98b27b730d7cfb$var$payload,
            context: $cd98b27b730d7cfb$var$context
        });
        if (this.props.onError) this.props.onError(error);
    }
    render() {
        if (this.state.hasError) return null;
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            hasError: false
        };
    }
}

});
parcelRegister("hiWux", function(module, exports) {

$parcel$export(module.exports, "source", () => $c053ac2f81500e34$export$b4d5da5f34fb77ad);
$parcel$export(module.exports, "errorBoundaryAction", () => $c053ac2f81500e34$export$9d8252a268f4fa72);
$parcel$export(module.exports, "errorBoundaryActionSubject", () => $c053ac2f81500e34$export$1045419caf49b395);
$parcel$export(module.exports, "crossFlowActionSubject", () => $c053ac2f81500e34$export$d54c183f56e39aa5);
$parcel$export(module.exports, "uiInitialized", () => $c053ac2f81500e34$export$e5c2c058fa8068a6);
$parcel$export(module.exports, "openInvoked", () => $c053ac2f81500e34$export$e67cdcb8867a3bd0);
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", () => $662e33bb7444ae33$export$12346a674644c156);

const $c053ac2f81500e34$export$b4d5da5f34fb77ad = 'crossFlowProvider';
const $c053ac2f81500e34$export$9d8252a268f4fa72 = 'errorCaught';
const $c053ac2f81500e34$export$1045419caf49b395 = 'errorBoundary';
const $c053ac2f81500e34$export$d54c183f56e39aa5 = 'crossFlowSupport';
const $c053ac2f81500e34$export$e5c2c058fa8068a6 = 'uiInitialized';
const $c053ac2f81500e34$export$e67cdcb8867a3bd0 = 'openInvoked';

});


parcelRegister("d2Lyf", function(module, exports) {

$parcel$export(module.exports, "enrichWithPackageDetails", () => $fb667082deecfda1$export$59518efab336a8b5);
const $fb667082deecfda1$var$version = undefined;
const $fb667082deecfda1$export$84f9cf7ef89d4c26 = {
    version: $fb667082deecfda1$var$version
};
const $fb667082deecfda1$export$59518efab336a8b5 = (event)=>{
    const attributes = {
        ...event.attributes || {},
        crossFlowSupport: $fb667082deecfda1$export$84f9cf7ef89d4c26
    };
    return {
        ...event,
        attributes: attributes
    };
};

});

parcelRegister("ijZC5", function(module, exports) {

$parcel$export(module.exports, "enrichWithRequestOptions", () => $8d9438e2156101c5$export$a5a156dc5df42f0);
const $8d9438e2156101c5$export$a5a156dc5df42f0 = (event, requestOptions)=>{
    if (!requestOptions) return event;
    const attributes = {
        // Spread the extra analytics attributes first, because we don't want consumers to override any event attributes below
        ...requestOptions.extraAnalyticsAttributes || {},
        ...event.attributes || {},
        sourceComponent: requestOptions.sourceComponent,
        sourceContext: requestOptions.sourceContext
    };
    return {
        ...event,
        attributes: attributes
    };
};

});

parcelRegister("8dJhh", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('7cPkN')
        ]);
        const value = parcelRequire('8uMPq');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("7cPkN")
    ]).then(()=>parcelRequire('8uMPq'));
}

});



parcelRegister("4Vji8", function(module, exports) {

$parcel$export(module.exports, "getContainersPlugin", () => $d5a247609f17a49b$export$81d1d40061d190bc);
parcelRequire("fYNkJ");
var $lJsOu = parcelRequire("lJsOu");
var $fYNkJ = parcelRequire("fYNkJ");

var $e91YZ = parcelRequire("e91YZ");
const $d5a247609f17a49b$var$getCloudId = async ()=>{
    const { cloudName: cloudName, cloudId: cloudId } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const containers = [
        {
            id: cloudId,
            displayName: cloudName,
            type: (0, $lJsOu.ContainerTypes).ATLASSIAN_CLOUD_ID
        }
    ];
    return {
        type: (0, $lJsOu.ContainerTypes).ATLASSIAN_CLOUD_ID,
        containers: containers
    };
};
const $d5a247609f17a49b$export$81d1d40061d190bc = (0, $fYNkJ.createGetContainersPlugin)($d5a247609f17a49b$var$getCloudId);

});
parcelRegister("fYNkJ", function(module, exports) {

$parcel$export(module.exports, "createGetContainersPlugin", () => $edac63653776ab1d$export$76378b0f825c024c);
$parcel$export(module.exports, "createGetUsersPlugin", () => $edac63653776ab1d$export$8feb7eae83cf8cd5);
$parcel$export(module.exports, "ContainerTypes", () => (parcelRequire("lJsOu")).ContainerTypes);
$parcel$export(module.exports, "UserIdTypes", () => (parcelRequire("lJsOu")).UserIdTypes);

var $lJsOu = parcelRequire("lJsOu");
const $edac63653776ab1d$export$76378b0f825c024c = (fetch)=>{
    return [
        (0, $lJsOu.PluginTypes).GetContainers,
        fetch
    ];
};
const $edac63653776ab1d$export$8feb7eae83cf8cd5 = (fetch)=>{
    return [
        (0, $lJsOu.PluginTypes).GetUsers,
        fetch
    ];
};
const $edac63653776ab1d$export$21d120847be2aff4 = (fetch)=>{
    return [
        (0, $lJsOu.PluginTypes).GetSuggestedSiteNames,
        fetch
    ];
};
const $edac63653776ab1d$export$d7c1699c6a2ca18a = (fetch)=>{
    return [
        (0, $lJsOu.PluginTypes).GetAvailableSites,
        fetch
    ];
};

});
parcelRegister("lJsOu", function(module, exports) {

$parcel$export(module.exports, "PluginTypes", () => $5cc146ce6a3f537d$export$a235a73f7b906dce);
$parcel$export(module.exports, "ContainerTypes", () => $5cc146ce6a3f537d$export$6e383182a26455ff);
$parcel$export(module.exports, "UserIdTypes", () => $5cc146ce6a3f537d$export$e391bab95adb8396);
// Data Plugin definition and utility types
const $5cc146ce6a3f537d$export$a235a73f7b906dce = {
    GetContainers: 'GetContainers',
    GetUsers: 'GetUsers',
    GetSuggestedSiteNames: 'GetSuggestedSiteNames',
    GetAvailableSites: 'GetAvailableSites'
};
const $5cc146ce6a3f537d$export$6e383182a26455ff = {
    BITBUCKET_WORKSPACE: 'bitbucket-workspace',
    ATLASSIAN_CLOUD_ID: 'ATLASSIAN_CLOUD_ID',
    JIRA_SOFTWARE_PROJECT: 'JIRA_SOFTWARE_PROJECT'
};
const $5cc146ce6a3f537d$export$e391bab95adb8396 = {
    ATLASSIAN_ACCOUNT_ID: 'ATLASSIAN_ACCOUNT_ID',
    TRELLO_ID: 'TRELLO_ID'
};
const $5cc146ce6a3f537d$export$4f378ba35c571906 = {
    JIRA_BUSINESS: 'JIRA_BUSINESS',
    JIRA_SERVICE_DESK: 'JIRA_SERVICE_DESK',
    JIRA_SOFTWARE: 'JIRA_SOFTWARE',
    CONFLUENCE: 'CONFLUENCE',
    OPSGENIE: 'OPSGENIE',
    BITBUCKET: 'BITBUCKET',
    STATUSPAGE: 'STATUSPAGE',
    TRELLO: 'TRELLO',
    COMPASS: 'COMPASS'
};

});



parcelRegister("iPzab", function(module, exports) {

$parcel$export(module.exports, "getUsersPlugin", () => $f595b9c40464a5a8$export$7c44908d2777db01);

var $fYNkJ = parcelRequire("fYNkJ");
var $lJsOu = parcelRequire("lJsOu");
const $f595b9c40464a5a8$var$getUsers = async (containerId)=>{
    const getUsersUrl = `/gateway/api/xflow/${containerId}/fetch-instance-users`;
    try {
        const response = await fetch(getUsersUrl, {
            credentials: 'same-origin'
        });
        if (response.ok) {
            const data = await response.json();
            return data.map((value)=>({
                    id: value.id,
                    idType: (0, $lJsOu.UserIdTypes).ATLASSIAN_ACCOUNT_ID,
                    displayName: value.displayName
                }));
        }
        throw new Error(`Unexpected response from ${getUsersUrl} ${response.status} ${response.statusText}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw new Error(`Unable to fetch ${getUsersUrl} ${error.message}`);
    }
};
const $f595b9c40464a5a8$export$7c44908d2777db01 = (0, $fYNkJ.createGetUsersPlugin)($f595b9c40464a5a8$var$getUsers);

});


parcelRegister("dQZ5c", function(module, exports) {

$parcel$export(module.exports, "FavouriteChangeContext", () => $5cd604b288cea09a$export$f4b82b57923ca30e);
$parcel$export(module.exports, "FavouriteChangeProvider", () => $5cd604b288cea09a$export$bda08f0693c12637);
$parcel$export(module.exports, "FavouriteChangeConsumer", () => $5cd604b288cea09a$export$2d027011594c72e1);
$parcel$export(module.exports, "useChangeFavourite", () => $5cd604b288cea09a$export$5619d506724e6a05);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $iWLL0 = parcelRequire("iWLL0");

var $cNy9K = parcelRequire("cNy9K");

var $huI7r = parcelRequire("huI7r");

var $jMP2a = parcelRequire("jMP2a");

var $dWLk9 = parcelRequire("dWLk9");

var $4Tdfn = parcelRequire("4Tdfn");

var $jrdvV = parcelRequire("jrdvV");

var $eZWIs = parcelRequire("eZWIs");

var $duxfp = parcelRequire("duxfp");
const $5cd604b288cea09a$export$4fe337ef5f0ceb74 = (item)=>(state)=>({
            ...state,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [item.type]: {
                ...state[item.type],
                [item.id]: item
            }
        });
const $5cd604b288cea09a$export$72b8c6d38aa6195b = (item)=>(state)=>({
            ...state,
            items: {
                ...state.items,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [item.type]: {
                    ...state.items[item.type],
                    [item.id]: item
                }
            }
        });
const $5cd604b288cea09a$export$b212ddc707077772 = {
    items: {
        boards: {},
        filters: {},
        issues: {},
        dashboards: {},
        projects: {},
        queues: {},
        plans: {}
    },
    changeFavourite: ()=>new Promise((0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))),
    updateFavouriteState: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
const $5cd604b288cea09a$export$f4b82b57923ca30e = /*#__PURE__*/ (0, $eUqFw.createContext)($5cd604b288cea09a$export$b212ddc707077772);
// supports project types only for now
const $5cd604b288cea09a$var$useRelayFavouriteUpdate = ()=>{
    const environment = (0, $iWLL0.useRelayEnvironment)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const commitUpdate = (0, $eUqFw.useCallback)(({ id: id, type: type, value: value })=>{
        if (type === (0, $jrdvV.PROJECTS_ITEM_TYPE)) (0, $cNy9K.commitLocalUpdate)(environment, (store)=>{
            const ari = (0, $huI7r.createAri)({
                resourceOwner: 'jira',
                resourceType: 'project',
                resourceId: id,
                cloudId: cloudId
            });
            const projectRecordId = (0, $4Tdfn.default)({
                id: ari
            }, 'JiraProject');
            if (projectRecordId) {
                const projectRecord = store.get(projectRecordId);
                const favouriteRecord = projectRecord?.getLinkedRecord('favouriteValue');
                favouriteRecord?.setValue(value, 'isFavourite');
            }
        });
    }, [
        cloudId,
        environment
    ]);
    return {
        commitUpdate: commitUpdate
    };
};
const $5cd604b288cea09a$export$bda08f0693c12637 = ({ onShowFlag: onShowFlag, children: children })=>{
    const { commitUpdate: commitUpdate } = $5cd604b288cea09a$var$useRelayFavouriteUpdate();
    const [items, setItems] = (0, $eUqFw.useState)({
        boards: {},
        filters: {},
        dashboards: {},
        issues: {},
        projects: {},
        queues: {},
        plans: {}
    });
    const changeFavourite = (0, $eUqFw.useCallback)((item, analyticsEvent)=>{
        const performChange = async ()=>{
            setItems($5cd604b288cea09a$export$4fe337ef5f0ceb74({
                ...item,
                pending: true
            }));
            try {
                commitUpdate({
                    type: item.type,
                    id: item.id,
                    value: item.value
                });
                await (0, $eZWIs.default)(item);
                setItems($5cd604b288cea09a$export$4fe337ef5f0ceb74({
                    ...item,
                    pending: false
                }));
                if (analyticsEvent) (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, // removing last letter to make item.type singular tense (i.e. boards => board)
                `${item.type.slice(0, item.type.length - 1)} ${item.value ? 'starred' : 'unstarred'}`, `${item.id}`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                commitUpdate({
                    type: item.type,
                    id: item.id,
                    value: !item.value
                });
                setItems($5cd604b288cea09a$export$4fe337ef5f0ceb74({
                    ...item,
                    value: !item.value,
                    pending: false
                }));
                if (onShowFlag) onShowFlag((0, $duxfp.errorFlag)());
            }
        };
        return performChange();
    }, [
        onShowFlag,
        commitUpdate
    ]);
    const updateFavouriteState = (0, $eUqFw.useCallback)((item)=>{
        setItems($5cd604b288cea09a$export$4fe337ef5f0ceb74({
            ...item,
            pending: false
        }));
    }, []);
    const providerValue = (0, $eUqFw.useMemo)(()=>({
            items: items,
            changeFavourite: changeFavourite,
            updateFavouriteState: updateFavouriteState
        }), [
        items,
        changeFavourite,
        updateFavouriteState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5cd604b288cea09a$export$f4b82b57923ca30e.Provider, {
        value: providerValue
    }, children);
};
const $5cd604b288cea09a$export$2d027011594c72e1 = $5cd604b288cea09a$export$f4b82b57923ca30e.Consumer;
const $5cd604b288cea09a$export$51e54aab6602cac7 = (WrappedComponent)=>{
    const WithFavouriteChangeConsumer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5cd604b288cea09a$export$2d027011594c72e1, null, (favouriteChangeContext)=>// @ts-expect-error - TS2322 - Type 'P & { favouriteChangeContext: FavouriteChangeContextType; }' is not assignable to type 'IntrinsicAttributes & W & { children?: ReactNode; }'.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                ...props,
                favouriteChangeContext: favouriteChangeContext
            }));
    const wrappedDisplayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    WithFavouriteChangeConsumer.displayName = `WithFavouriteChangeConsumer(${wrappedDisplayName})`;
    return WithFavouriteChangeConsumer;
};
const $5cd604b288cea09a$export$5619d506724e6a05 = ()=>(0, $eUqFw.useContext)($5cd604b288cea09a$export$f4b82b57923ca30e);

});
parcelRegister("huI7r", function(module, exports) {

$parcel$export(module.exports, "isAri", () => $c148d923211ffae9$export$8e68286aef4c3a8b);
$parcel$export(module.exports, "createAri", () => $c148d923211ffae9$export$594d18a0ad2e0e57);
$parcel$export(module.exports, "toAri", () => $c148d923211ffae9$export$24b47820a324e614);
$parcel$export(module.exports, "toAriOrDefault", () => $c148d923211ffae9$export$e2789192113e8b07);
$parcel$export(module.exports, "parseAri", () => $c148d923211ffae9$export$f8e7d14b19dc8ba5);
$parcel$export(module.exports, "getAriConfig", () => $c148d923211ffae9$export$3d8d7031a11613fd);
/**
 * Module to work with Atlassian Resource Identifier (ARI)
 * More info in go/aris
 */ const $c148d923211ffae9$var$ARI_REG_EXP = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/(?<resourceId>[\w.~_-]+)$/;
const $c148d923211ffae9$var$ARI_REG_EXP_ACTIVATION = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<resourceId>[\w.~_-]+)$/;
const $c148d923211ffae9$var$ARI_REG_EXP_WORKSPACE = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>.{0}):(?<resourceType>[a-z.-]+)(\/(?<workspaceId>[\w.~_-]+)?)\/(?<resourceId>[\w.~_-]+)$/;
const $c148d923211ffae9$var$ARI_REG_EXP_PROVIDER_CONTAINER = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<providerAppId>[\w.~_-]+)\/(?<resourceId>[\w.~_/-]+)$/;
const $c148d923211ffae9$export$8e68286aef4c3a8b = (ari)=>$c148d923211ffae9$var$ARI_REG_EXP.test(ari) || $c148d923211ffae9$var$ARI_REG_EXP_WORKSPACE.test(ari) || $c148d923211ffae9$var$ARI_REG_EXP_ACTIVATION.test(ari) || $c148d923211ffae9$var$ARI_REG_EXP_PROVIDER_CONTAINER.test(ari);
const $c148d923211ffae9$export$594d18a0ad2e0e57 = ({ resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId })=>{
    if (workspaceId != null) return `ari:cloud:${resourceOwner}::${resourceType}/${workspaceId}/${resourceId}`;
    if (activationId != null) return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/${resourceId}`;
};
const $c148d923211ffae9$export$24b47820a324e614 = (ari)=>{
    if ($c148d923211ffae9$export$8e68286aef4c3a8b(ari)) return ari;
    return undefined;
};
const $c148d923211ffae9$export$e2789192113e8b07 = (ari, defaultValue = '')=>$c148d923211ffae9$export$24b47820a324e614(ari) ?? defaultValue;
const $c148d923211ffae9$export$f8e7d14b19dc8ba5 = (ari)=>{
    if ($c148d923211ffae9$export$8e68286aef4c3a8b(ari)) {
        const parts = $c148d923211ffae9$var$ARI_REG_EXP.exec(ari) || $c148d923211ffae9$var$ARI_REG_EXP_WORKSPACE.exec(ari) || $c148d923211ffae9$var$ARI_REG_EXP_ACTIVATION.exec(ari) || $c148d923211ffae9$var$ARI_REG_EXP_PROVIDER_CONTAINER.exec(ari);
        if (parts?.groups) {
            // reconstructing an object just to avoid flow error (otherwise says inexact object type of parts.groups is incompatible with exact AriConfig type)
            const { resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId } = parts.groups;
            return {
                resourceOwner: resourceOwner,
                cloudId: cloudId,
                resourceType: resourceType,
                workspaceId: workspaceId,
                resourceId: resourceId,
                activationId: activationId
            };
        }
    }
    return undefined;
};
const $c148d923211ffae9$export$3d8d7031a11613fd = (ari)=>{
    const config = $c148d923211ffae9$export$f8e7d14b19dc8ba5(ari);
    if (config === undefined) throw Error('Invalid ARI - this should only be possible if there is a bug in `toAri`');
    return config;
};

});

parcelRegister("jrdvV", function(module, exports) {

$parcel$export(module.exports, "BOARDS_ITEM_TYPE", () => $0f4349785a7b5234$export$aade82542e73ffc8);
$parcel$export(module.exports, "FILTERS_ITEM_TYPE", () => $0f4349785a7b5234$export$a448ebfa10cebc74);
$parcel$export(module.exports, "DASHBOARDS_ITEM_TYPE", () => $0f4349785a7b5234$export$f8099f229527572c);
$parcel$export(module.exports, "ISSUES_ITEM_TYPE", () => $0f4349785a7b5234$export$8e58083dcbb878d);
$parcel$export(module.exports, "PLANS_ITEM_TYPE", () => $0f4349785a7b5234$export$2fd44a6cb58b66cb);
$parcel$export(module.exports, "PROJECTS_ITEM_TYPE", () => $0f4349785a7b5234$export$8e2cd98172988d7e);
$parcel$export(module.exports, "QUEUES_ITEM_TYPE", () => $0f4349785a7b5234$export$6b0c8e47d2c7f1d9);
$parcel$export(module.exports, "VALID_ITEM_TYPES", () => $0f4349785a7b5234$export$9c8cfad65800ddfb);
const $0f4349785a7b5234$export$aade82542e73ffc8 = 'boards';
const $0f4349785a7b5234$export$a448ebfa10cebc74 = 'filters';
const $0f4349785a7b5234$export$f8099f229527572c = 'dashboards';
const $0f4349785a7b5234$export$8e58083dcbb878d = 'issues';
const $0f4349785a7b5234$export$2fd44a6cb58b66cb = 'plans';
const $0f4349785a7b5234$export$8e2cd98172988d7e = 'projects';
const $0f4349785a7b5234$export$6b0c8e47d2c7f1d9 = 'queues';
const $0f4349785a7b5234$export$9c8cfad65800ddfb = [
    $0f4349785a7b5234$export$aade82542e73ffc8,
    $0f4349785a7b5234$export$f8099f229527572c,
    $0f4349785a7b5234$export$a448ebfa10cebc74,
    $0f4349785a7b5234$export$8e58083dcbb878d,
    $0f4349785a7b5234$export$2fd44a6cb58b66cb,
    $0f4349785a7b5234$export$8e2cd98172988d7e,
    $0f4349785a7b5234$export$6b0c8e47d2c7f1d9
];

});

parcelRegister("eZWIs", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ba51d1acd2ac333$export$2e2bcd8739ae039);

var $bTuoX = parcelRequire("bTuoX");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4ba51d1acd2ac333$export$2e2bcd8739ae039 = async (request)=>(0, $bTuoX.updateFavourite)(request);

});
parcelRegister("bTuoX", function(module, exports) {

$parcel$export(module.exports, "updateFavourite", () => $7eaa8c7b4405eae0$export$c3c67dbb1f3a5ce5);

var $lRmyA = parcelRequire("lRmyA");
const $7eaa8c7b4405eae0$export$c3c67dbb1f3a5ce5 = async (request)=>{
    if (request.value) return (0, $lRmyA.performPostRequest)('/rest/internal/2/favourites', {
        body: JSON.stringify({
            entity: {
                id: request.id,
                type: request.type
            },
            beforeEntityPosition: request.beforeEntity || null
        })
    });
    return (0, $lRmyA.performDeleteRequest)(`/rest/internal/2/favourites/${request.type}/${request.id}`);
};

});


parcelRegister("duxfp", function(module, exports) {

$parcel$export(module.exports, "errorFlag", () => $bec77f1a045d66e4$export$b9a7f1ebeaa76953);

var $jsurv = parcelRequire("jsurv");
const $bec77f1a045d66e4$export$b9a7f1ebeaa76953 = ()=>({
        type: 'error',
        ...(0, $jsurv.default)
    });

});
parcelRegister("jsurv", function(module, exports) {

$parcel$export(module.exports, "default", () => $973c51bdbf11215e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $973c51bdbf11215e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.title",
        "defaultMessage": "Something\u2019s gone wrong"
    },
    description: {
        "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.description",
        "defaultMessage": "You cannot star items right now due to an error."
    }
});

});



parcelRegister("jvfW6", function(module, exports) {

$parcel$export(module.exports, "ModalContextProvider", () => $3b08d5b0f7ce801d$export$7c9538f5f3c365e9);

var $eUqFw = parcelRequire("eUqFw");

var $dxopF = parcelRequire("dxopF");

var $3qf87 = parcelRequire("3qf87");
function $3b08d5b0f7ce801d$export$7c9538f5f3c365e9({ children: children }) {
    const id = (0, $eUqFw.useRef)(1);
    const [modals, setModals] = (0, $eUqFw.useState)([]);
    const modalContext = (0, $eUqFw.useMemo)(()=>({
            openModal: (component)=>{
                const key = String(id.current++);
                const close = ()=>{
                    setModals((mdls)=>mdls.filter((d)=>d.key !== key));
                };
                setModals((mdls)=>[
                        ...mdls,
                        {
                            close: close,
                            component: component,
                            key: key
                        }
                    ]);
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3qf87.ModalContext).Provider, {
        value: modalContext
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, modals.map((modal)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(modal.component, {
            key: modal.key,
            onClose: modal.close
        }))));
}

});
parcelRegister("3qf87", function(module, exports) {

$parcel$export(module.exports, "ModalContext", () => $454708699096dc24$export$ab57792b9b6974a6);

var $eUqFw = parcelRequire("eUqFw");
const $454708699096dc24$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    openModal: ()=>{}
});

});


parcelRegister("lbttE", function(module, exports) {

$parcel$export(module.exports, "ProjectCreateDrawerProvider", () => $3fbad164cde8fff4$export$9a1c5dbd93c42bca);
$parcel$export(module.exports, "ProjectCreateDrawerConsumer", () => $3fbad164cde8fff4$export$9a8662cd60931de1);
$parcel$export(module.exports, "useProjectCreateDrawer", () => $3fbad164cde8fff4$export$8172ff4ed0f75a1e);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $9CmwD = parcelRequire("9CmwD");

var $kJlBc = parcelRequire("kJlBc");

var $9EFi5 = parcelRequire("9EFi5");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $3fbad164cde8fff4$var$Context = /*#__PURE__*/ (0, $eUqFw.createContext)({
    data: {
        shouldRenderDrawer: false,
        isOpen: false,
        isNextGen: false,
        showExperienceSelection: true,
        recommendedTemplate: undefined,
        defaultSelectedTemplateKey: '',
        source: '',
        isTemplatePickerOpenInitially: false,
        isImportProjectOpenInitially: false,
        selectedProjectType: null,
        recommendationSessionId: undefined
    },
    methods: {
        open: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        close: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onCreateStarted: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        setOnCloseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        clearOnCloseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    }
});
const $3fbad164cde8fff4$export$839a70d8fbc9d356 = class ProjectCreateDrawerProvider extends (0, $eUqFw.Component) {
    render() {
        const { children: children } = this.props;
        const { isOpen: isOpen, isNextGen: isNextGen, source: source, showExperienceSelection: showExperienceSelection, shouldRenderDrawer: shouldRenderDrawer, recommendedTemplate: recommendedTemplate, defaultSelectedTemplateKey: defaultSelectedTemplateKey, isTemplatePickerOpenInitially: isTemplatePickerOpenInitially, isImportProjectOpenInitially: isImportProjectOpenInitially, selectedProjectType: selectedProjectType, recommendationSessionId: recommendationSessionId } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3fbad164cde8fff4$var$Context.Provider, {
            value: {
                data: {
                    isOpen: isOpen,
                    isNextGen: isNextGen,
                    source: source,
                    showExperienceSelection: showExperienceSelection,
                    shouldRenderDrawer: shouldRenderDrawer,
                    recommendedTemplate: recommendedTemplate,
                    defaultSelectedTemplateKey: defaultSelectedTemplateKey,
                    isTemplatePickerOpenInitially: isTemplatePickerOpenInitially,
                    isImportProjectOpenInitially: isImportProjectOpenInitially,
                    selectedProjectType: selectedProjectType,
                    recommendationSessionId: recommendationSessionId
                },
                methods: {
                    open: this.open,
                    close: this.close,
                    onSuccess: this.onSuccess,
                    onCreateStarted: this.onCreateStarted,
                    setOnCloseCallback: this.setOnCloseCallback,
                    clearOnCloseCallback: this.clearOnCloseCallback
                }
            }
        }, children);
    }
    constructor(...args){
        super(...args);
        this.state = {
            isOpen: false,
            shouldRenderDrawer: false,
            isNextGen: false,
            showExperienceSelection: true,
            recommendedTemplate: undefined,
            defaultSelectedTemplateKey: '',
            source: '',
            isTemplatePickerOpenInitially: false,
            isImportProjectOpenInitially: false,
            selectedProjectType: null,
            recommendationSessionId: undefined,
            onCloseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onSuccess = (projectKey)=>{
            if (projectKey) {
                this.props.setLocation(projectKey.returnUrl);
                this.close(true);
            } else this.close(false);
        };
        // Callback that is called once when the drawer is closed.
        this.setOnCloseCallback = (callback)=>{
            this.setState({
                onCloseCallback: callback
            });
        };
        this.clearOnCloseCallback = ()=>{
            this.setState({
                onCloseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
            });
        };
        this.open = (attributes = {})=>{
            // @ts-expect-error - TS2345 - Argument of type '{ isNextGen?: boolean | undefined; showExperienceSelection?: boolean | undefined; recommendedTemplate?: { templateKey: string; isSimplified: boolean; } | undefined; defaultSelectedTemplateKey?: string | undefined; ... 4 more ...; shouldRenderDrawer: true; }' is not assignable to parameter of type 'State | ((prevState: Readonly<State>, props: Readonly<Props>) => State | Pick<State, "source" | "isOpen" | "isNextGen" | ... 5 more ... | "isTemplatePickerOpenInitially"> | null) | Pick<...> | null'.
            this.setState({
                isOpen: true,
                shouldRenderDrawer: true,
                ...attributes
            });
        };
        this.close = (projectCreated)=>{
            const callOnCloseCallBack = this.state.source === 'navigationNext' || !projectCreated;
            this.setState({
                isOpen: false,
                isNextGen: false,
                showExperienceSelection: true,
                recommendedTemplate: undefined,
                defaultSelectedTemplateKey: '',
                source: '',
                isTemplatePickerOpenInitially: false,
                isImportProjectOpenInitially: false,
                selectedProjectType: null,
                recommendationSessionId: undefined
            });
            if (callOnCloseCallBack) // Call the added callback
            this.state.onCloseCallback();
        };
        this.closeOld = ()=>{
            this.setState({
                isOpen: false,
                isNextGen: false,
                showExperienceSelection: true,
                recommendedTemplate: undefined,
                defaultSelectedTemplateKey: '',
                source: '',
                isTemplatePickerOpenInitially: false,
                selectedProjectType: null,
                recommendationSessionId: undefined
            });
            this.state.onCloseCallback();
        };
        this.onCreateStarted = (_projectKey, templateKey)=>{
            if ((0, $9CmwD.getIsJsmBlankProjectTemplate)(templateKey)) (0, $9EFi5.LazyComponent).preload();
        };
    }
};
const $3fbad164cde8fff4$export$9a1c5dbd93c42bca = (props)=>{
    const { push: push } = (0, $kJlBc.useRouterActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3fbad164cde8fff4$export$839a70d8fbc9d356, {
        ...props,
        setLocation: push
    });
};
const { Consumer: $3fbad164cde8fff4$export$9a8662cd60931de1 } = $3fbad164cde8fff4$var$Context;
$3fbad164cde8fff4$var$Context.displayName = 'ProjectCreateDrawerConsumer';
const $3fbad164cde8fff4$export$8172ff4ed0f75a1e = ()=>{
    const projectCreateDrawer = (0, $eUqFw.useContext)($3fbad164cde8fff4$var$Context);
    if (!projectCreateDrawer) throw new Error('useProjectCreateDrawer must be used within a ProjectCreateDrawerProvider');
    return projectCreateDrawer;
};

});
parcelRegister("9CmwD", function(module, exports) {

$parcel$export(module.exports, "KANBAN_TEAM_MANAGED_KEY", () => $9672b8899ab98e98$export$f40a08fc76eb112d);
$parcel$export(module.exports, "KANBAN_COMPANY_MANAGED_KEY", () => $9672b8899ab98e98$export$e3844688f2693533);
$parcel$export(module.exports, "SCRUM_TEAM_MANAGED_KEY", () => $9672b8899ab98e98$export$e3cec071fcb2fbd3);
$parcel$export(module.exports, "SCRUM_COMPANY_MANAGED_KEY", () => $9672b8899ab98e98$export$21783d461e3ef6d);
$parcel$export(module.exports, "BUG_TRACKING_COMPANY_MANAGED_KEY", () => $9672b8899ab98e98$export$6cd1c1b2ba0f6e2d);
$parcel$export(module.exports, "CROSS_TEAM_MANAGED_KEY", () => $9672b8899ab98e98$export$57d877f2e01e0029);
$parcel$export(module.exports, "CROSS_TEAM_PLANNING_COMPANY_MANAGED_KEY", () => $9672b8899ab98e98$export$6f4213a3addc3fdb);
$parcel$export(module.exports, "PROJECT_MANAGEMENT_COMPANY_MANAGED_KEY", () => $9672b8899ab98e98$export$7d9a4e0ef5194fe1);
$parcel$export(module.exports, "PROJECT_MANAGEMENT_TEAM_MANAGED_KEY", () => $9672b8899ab98e98$export$477ca3550da12e43);
$parcel$export(module.exports, "BLANK_TEMPLATE_TEAM_MANAGED_KEY", () => $9672b8899ab98e98$export$b5ab111fb8825075);
$parcel$export(module.exports, "CAMPAIGN_MANAGEMENT_COMPANY_MANAGED_KEY", () => $9672b8899ab98e98$export$14139f0ec41d437e);
$parcel$export(module.exports, "CAMPAIGN_MANAGEMENT_TEAM_MANAGED_KEY", () => $9672b8899ab98e98$export$ebf7af45376deb8b);
$parcel$export(module.exports, "CONTENT_MANAGEMENT_COMPANY_MANAGED_KEY", () => $9672b8899ab98e98$export$7b6945581ccdab4a);
$parcel$export(module.exports, "CONTENT_MANAGEMENT_TEAM_MANAGED_KEY", () => $9672b8899ab98e98$export$310a9ac5c28d65f6);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY", () => $9672b8899ab98e98$export$4d29ee0c00eb5df4);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_TEAM_MANAGED_KEY", () => $9672b8899ab98e98$export$6278b41164dbde6c);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY", () => $9672b8899ab98e98$export$e8df553a3f519284);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY", () => $9672b8899ab98e98$export$97fc32bd703bb4d1);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY", () => $9672b8899ab98e98$export$8eecdf6acea9494);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY", () => $9672b8899ab98e98$export$ff16be7794ed4222);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY", () => $9672b8899ab98e98$export$9917830b560a2f4);
$parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_COMPANY_MANAGED_KEY", () => $9672b8899ab98e98$export$b0928b02ffab3875);
$parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_FOR_IT_COMPANY_MANAGED_KEY", () => $9672b8899ab98e98$export$fd75f6abc7861439);
$parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_FOR_IT_TEAM_MANAGED_KEY", () => $9672b8899ab98e98$export$fb658bddae7f81bb);
$parcel$export(module.exports, "EXTERNAL_SERVICE_PROJECT_COMPANY_MANAGED_KEY", () => $9672b8899ab98e98$export$bc3e0c6bccecee38);
$parcel$export(module.exports, "INITIAL_PROJECT_TEMPLATE_PROJECT_PROPERTY_KEY", () => $9672b8899ab98e98$export$87a8fff98b5bc81);
$parcel$export(module.exports, "PRODUCT_DISCOVERY_TEAM_MANAGED_KEY", () => $9672b8899ab98e98$export$7c567eb725bd36f);
$parcel$export(module.exports, "getIsJsmBlankProjectTemplate", () => $9672b8899ab98e98$export$73fd025e86012868);
$parcel$export(module.exports, "getGeneralITOrBusinessProjectTemplateMap", () => $9672b8899ab98e98$export$a062badd78c9993);
// Project template type keys are used to create projects.
// TODO: KURO-1818 consolidate keys from `project-template-keys` in this file.
// Software template keys
const $9672b8899ab98e98$export$f40a08fc76eb112d = 'com.pyxis.greenhopper.jira:gh-simplified-agility-kanban';
const $9672b8899ab98e98$export$e3844688f2693533 = 'com.pyxis.greenhopper.jira:gh-simplified-kanban-classic';
const $9672b8899ab98e98$export$e3cec071fcb2fbd3 = 'com.pyxis.greenhopper.jira:gh-simplified-agility-scrum';
const $9672b8899ab98e98$export$21783d461e3ef6d = 'com.pyxis.greenhopper.jira:gh-simplified-scrum-classic';
const $9672b8899ab98e98$export$6cd1c1b2ba0f6e2d = 'com.pyxis.greenhopper.jira:gh-simplified-basic';
const $9672b8899ab98e98$export$57d877f2e01e0029 = 'com.pyxis.greenhopper.jira:gh-cross-team-template';
const $9672b8899ab98e98$export$6f4213a3addc3fdb = 'com.pyxis.greenhopper.jira:gh-cross-team-planning-template';
const $9672b8899ab98e98$export$7492b6cc3ef89883 = 'com.atlassian.jira-core-project-templates';
const $9672b8899ab98e98$export$7d9a4e0ef5194fe1 = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-core-simplified-project-management`;
const $9672b8899ab98e98$export$477ca3550da12e43 = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-work-management-project-management-team-managed`;
const $9672b8899ab98e98$export$7c0307155b744916 = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-work-management-blank-project`;
const $9672b8899ab98e98$export$b5ab111fb8825075 = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-work-management-blank-project-team-managed`;
const $9672b8899ab98e98$export$14139f0ec41d437e = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-work-management-campaign-management`;
const $9672b8899ab98e98$export$ebf7af45376deb8b = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-work-management-campaign-management-team-managed`;
const $9672b8899ab98e98$export$7b6945581ccdab4a = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-core-simplified-content-management`;
const $9672b8899ab98e98$export$310a9ac5c28d65f6 = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-work-management-content-management-team-managed`;
const $9672b8899ab98e98$export$4d29ee0c00eb5df4 = 'com.atlassian.servicedesk:simplified-it-service-management';
const $9672b8899ab98e98$export$6278b41164dbde6c = 'com.atlassian.servicedesk:next-gen-it-service-desk';
const $9672b8899ab98e98$export$e8df553a3f519284 = 'jsm.blank-project-business-cmp-only';
const $9672b8899ab98e98$export$97fc32bd703bb4d1 = 'com.atlassian.servicedesk:simplified-blank-project-it';
const $9672b8899ab98e98$export$8eecdf6acea9494 = 'jsm.blank-project-it-cmp-only';
const $9672b8899ab98e98$export$ff16be7794ed4222 = 'com.atlassian.servicedesk:simplified-blank-project-business';
const $9672b8899ab98e98$export$9e38ad41d19608ee = 'jsm.blank-service-management';
const $9672b8899ab98e98$export$9917830b560a2f4 = 'com.atlassian.servicedesk:company-managed-blank-service-project';
const $9672b8899ab98e98$export$b95641716115e7f9 = 'com.atlassian.servicedesk:team-managed-blank-service-project';
const $9672b8899ab98e98$export$e87297d5e9fa3d43 = 'com.atlassian.servicedesk:simplified-legal-service-desk';
const $9672b8899ab98e98$export$3f1f11fb5d08da21 = 'com.atlassian.servicedesk:next-gen-legal-service-desk';
const $9672b8899ab98e98$export$2b90912656e0b76b = 'com.atlassian.servicedesk:simplified-general-service-desk';
const $9672b8899ab98e98$export$e8fdad132bc6d342 = 'com.atlassian.servicedesk:next-gen-general-service-desk';
const $9672b8899ab98e98$export$b0928b02ffab3875 = 'com.atlassian.servicedesk:company-managed-general-service-project';
const $9672b8899ab98e98$export$50478ee5ecbf7a4d = 'com.atlassian.servicedesk:team-managed-general-service-project';
const $9672b8899ab98e98$export$fd75f6abc7861439 = 'com.atlassian.servicedesk:simplified-general-service-desk-it';
const $9672b8899ab98e98$export$fb658bddae7f81bb = 'com.atlassian.servicedesk:next-gen-general-it-service-desk';
const $9672b8899ab98e98$export$e82092c4fb277f9b = 'com.atlassian.servicedesk:simplified-general-service-desk-business';
const $9672b8899ab98e98$export$5eddf3b31dd1858f = 'com.atlassian.servicedesk:next-gen-general-business-service-desk';
const $9672b8899ab98e98$export$bc3e0c6bccecee38 = 'com.atlassian.servicedesk:simplified-external-service-desk';
const $9672b8899ab98e98$export$feb6dd6f9d18a640 = 'com.atlassian.servicedesk:next-gen-external-service-desk';
const $9672b8899ab98e98$export$f3c5f5a180797f04 = 'com.atlassian.servicedesk:simplified-hr-service-desk';
const $9672b8899ab98e98$export$2bc7db2da3df8313 = 'com.atlassian.servicedesk:next-gen-hr-service-desk';
const $9672b8899ab98e98$export$a1a1f02e9f561918 = 'com.atlassian.servicedesk:simplified-facilities-service-desk';
const $9672b8899ab98e98$export$17a955064ab71480 = 'com.atlassian.servicedesk:next-gen-facilities-service-desk';
const $9672b8899ab98e98$export$d66326f3f6b558b = 'com.atlassian.servicedesk:simplified-analytics-service-desk';
const $9672b8899ab98e98$export$6c5416b0177f2ef3 = 'com.atlassian.servicedesk:next-gen-analytics-service-desk';
const $9672b8899ab98e98$export$ea36fb35725fc554 = 'com.atlassian.servicedesk:simplified-finance-service-desk';
const $9672b8899ab98e98$export$e7038c17e9311de9 = 'com.atlassian.servicedesk:next-gen-finance-service-desk';
const $9672b8899ab98e98$export$38d7bc62a093e5a3 = 'com.atlassian.servicedesk:simplified-marketing-service-desk';
const $9672b8899ab98e98$export$fa06d276537993ce = 'com.atlassian.servicedesk:next-gen-marketing-service-desk';
const $9672b8899ab98e98$export$9801b8ec713d3079 = 'com.atlassian.servicedesk:simplified-sales-service-desk';
const $9672b8899ab98e98$export$a9f0e6470e3b6147 = 'com.atlassian.servicedesk:next-gen-sales-service-desk';
const $9672b8899ab98e98$export$aeedd4330ac1268c = 'com.atlassian.servicedesk:simplified-design-service-desk';
const $9672b8899ab98e98$export$c0e4ffe74102f756 = 'com.atlassian.servicedesk:next-gen-design-service-desk';
const $9672b8899ab98e98$export$87a8fff98b5bc81 = 'initial.project.template.name';
const $9672b8899ab98e98$export$7c567eb725bd36f = 'jira.polaris:discovery';
const $9672b8899ab98e98$export$b0eec2c6558182ca = 'jira.polaris:blank-project';
const $9672b8899ab98e98$export$f9776303073903dd = 'jira.polaris:roadmap';
const $9672b8899ab98e98$export$73fd025e86012868 = (T4JTemplateKey)=>T4JTemplateKey === $9672b8899ab98e98$export$e8df553a3f519284 || T4JTemplateKey === $9672b8899ab98e98$export$8eecdf6acea9494 || T4JTemplateKey === $9672b8899ab98e98$export$9e38ad41d19608ee;
const $9672b8899ab98e98$export$a062badd78c9993 = {
    [$9672b8899ab98e98$export$e82092c4fb277f9b]: $9672b8899ab98e98$export$b0928b02ffab3875,
    [$9672b8899ab98e98$export$fd75f6abc7861439]: $9672b8899ab98e98$export$b0928b02ffab3875,
    [$9672b8899ab98e98$export$5eddf3b31dd1858f]: $9672b8899ab98e98$export$50478ee5ecbf7a4d,
    [$9672b8899ab98e98$export$fb658bddae7f81bb]: $9672b8899ab98e98$export$50478ee5ecbf7a4d
};

});

parcelRegister("9EFi5", function(module, exports) {

$parcel$export(module.exports, "LazyComponent", () => $6ae11cc3f6e45a93$export$31f1740ae531af94);
$parcel$export(module.exports, "AsyncProjectBuilderDrawer", () => $6ae11cc3f6e45a93$export$54a4eade9eae9473);
$parcel$export(module.exports, "canUseProjectBuilder", () => $6ae11cc3f6e45a93$export$ff317c5d87147a19);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $iVSJI = parcelRequire("iVSJI");

const $6ae11cc3f6e45a93$export$31f1740ae531af94 = (0, $7rh0R.lazy)(()=>(parcelRequire("2vI6z")), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/project-builder/src/index.tsx"
});
const $6ae11cc3f6e45a93$export$54a4eade9eae9473 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "bundle-async-project-builder",
        packageName: "jira-servicedesk-project-builder",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        fallback: null,
        name: "jsm-project-builder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iVSJI.ServiceDeskAnalyticsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ae11cc3f6e45a93$export$31f1740ae531af94, {
        isOpenInitial: !!props.isOpenInitial,
        ...props
    }))));
const $6ae11cc3f6e45a93$export$ff317c5d87147a19 = (isAdmin)=>isAdmin;

});
parcelRegister("iVSJI", function(module, exports) {

$parcel$export(module.exports, "ServiceDeskAnalyticsContext", () => $98f32c00711ff158$export$ac31f8f3368d6881);

var $eUqFw = parcelRequire("eUqFw");

var $8WuJm = parcelRequire("8WuJm");

var $SEaoU = parcelRequire("SEaoU");

var $kJ81T = parcelRequire("kJ81T");
const $98f32c00711ff158$export$ac31f8f3368d6881 = ({ useContainerContext: useContainerContext, useServiceDeskAnalyticsContext: useServiceDeskAnalyticsContext, children: children, forceRenderWhileLoading: forceRenderWhileLoading })=>{
    const [{ data: containerContextData, loading: containerContextLoading }] = useContainerContext();
    const { data: analyticsContextAttributes, error: analyticsContextError, loading: analyticsContextLoading } = useServiceDeskAnalyticsContext();
    if ((0, $eUqFw.Children).count(children) > 0) {
        const loading = containerContextLoading || analyticsContextLoading;
        const shouldRenderChildren = !loading || loading && forceRenderWhileLoading || !!analyticsContextError;
        if (!shouldRenderChildren) return null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const context = {};
        // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
        if (containerContextData && containerContextData.project) {
            // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
            const { id: id, type: type } = containerContextData.project;
            // containerType and containerId are obsolete - See https://developer.atlassian.com/platform/analytics-pipeline/getting-started/event-types/#glossary-of-terms
            // Also these dont work with screen events. See sendScreenEvent in: https://bitbucket.org/atlassian/analytics-web-client/src/master/src/analyticsWebClient.js
            // However they are kept here to not break any existing usages.
            context.containerType = 'project';
            context.containerId = `${id}`;
            // This is the preferred way to send container data for analytics
            context.containers = {
                project: {
                    id: `${id}`,
                    type: type
                }
            };
            if (analyticsContextAttributes && !analyticsContextError) context.attributes = analyticsContextAttributes;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), context, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
};
$98f32c00711ff158$export$ac31f8f3368d6881.defaultProps = {
    forceRenderWhileLoading: false,
    useServiceDeskAnalyticsContext: (0, $kJ81T.useServiceDeskAnalyticsContext),
    useContainerContext: (0, $SEaoU.useContainerContext)
};

});
parcelRegister("kJ81T", function(module, exports) {

$parcel$export(module.exports, "serviceDeskAnalyticsContextResource", () => $f5a87dd3d6d3f919$export$d6f4f0483916919f);
$parcel$export(module.exports, "useServiceDeskAnalyticsContext", () => $f5a87dd3d6d3f919$export$bc2de1c42df30b10);

var $eUqFw = parcelRequire("eUqFw");

var $3HCkE = parcelRequire("3HCkE");

var $8hg3R = parcelRequire("8hg3R");


const $f5a87dd3d6d3f919$var$getDataLoader = ()=>(parcelRequire("bA2Tc"));
const $f5a87dd3d6d3f919$var$ONE_DAY_IN_MILLIS = 86400000;
const $f5a87dd3d6d3f919$export$d6f4f0483916919f = (0, $3HCkE.createResource)({
    type: (0, $76d1e4a47c4d6ee4$export$285b47583a5bdd0f),
    getKey: ({ match: match })=>(0, $8hg3R.getProjectKeyOrId)(match),
    getDataLoader: $f5a87dd3d6d3f919$var$getDataLoader,
    maxAge: $f5a87dd3d6d3f919$var$ONE_DAY_IN_MILLIS
});
const $f5a87dd3d6d3f919$export$bc2de1c42df30b10 = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $3HCkE.useResource)($f5a87dd3d6d3f919$export$d6f4f0483916919f);
    (0, $eUqFw.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        error,
        refresh
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            data: data,
            loading: loading,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error
        }), [
        data,
        loading,
        error
    ]);
};

});
parcelRegister("8hg3R", function(module, exports) {

$parcel$export(module.exports, "getProjectKeyOrId", () => $07950346cbbaf790$export$43cde151f667c69e);
$parcel$export(module.exports, "getProjectKeyOrIdFromMatchAndQuery", () => $07950346cbbaf790$export$b87af5b274141bd6);

var $9zYls = parcelRequire("9zYls");
const $07950346cbbaf790$export$43cde151f667c69e = (match)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, match.query);
    return projectKey || projectId || '';
};
const $07950346cbbaf790$export$b87af5b274141bd6 = ({ match: match, query: query })=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
    return projectKey || projectId;
};

});

const $76d1e4a47c4d6ee4$export$285b47583a5bdd0f = 'SERVICEDESK_ANALYTICS_CONTEXT';

parcelRegister("bA2Tc", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('6G5Ft');
        const value = parcelRequire('eUv3W');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("6G5Ft").then(()=>parcelRequire('eUv3W'));
}

});



parcelRegister("2vI6z", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('dsiAd'),
            load('ekVbM'),
            load('92sUi'),
            load('i5RRW'),
            load('561Jq'),
            load('1QYl5'),
            load('2hmUs'),
            load('bCeK4'),
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('iYygF')
        ]);
        const value = parcelRequire('8Zm1o');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("dsiAd"),
        load("ekVbM"),
        load("92sUi"),
        load("i5RRW"),
        load("561Jq"),
        load("1QYl5"),
        load("2hmUs"),
        load("bCeK4"),
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("iYygF")
    ]).then(()=>parcelRequire('8Zm1o'));
}

});





parcelRegister("f9UOp", function(module, exports) {

$parcel$export(module.exports, "UserContainers", () => $8d4848b02de0c2ee$export$c1b371eec908681a);

var $eUqFw = parcelRequire("eUqFw");

var $6L2se = parcelRequire("6L2se");

var $lGLse = parcelRequire("lGLse");
const $8d4848b02de0c2ee$export$c1b371eec908681a = ({ baseUrl: baseUrl, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lGLse.UserContainer), {
        isGlobal: true,
        baseUrl: baseUrl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6L2se.UserPreferencesContainer), {
        isGlobal: true
    }, children));

});
parcelRegister("6L2se", function(module, exports) {

$parcel$export(module.exports, "UserPreferencesContainer", () => $39c7f00c5ab3f451$export$aa278641ded1adf);

var $heB5U = parcelRequire("heB5U");
var $dYfll = parcelRequire("dYfll");

var $dsC4d = parcelRequire("dsC4d");
const $39c7f00c5ab3f451$export$be74e04eaea4530 = (0, $dYfll.createSubscriber)((0, $dsC4d.default), {
    displayName: 'UserPreferencesSubscriber'
});
const $39c7f00c5ab3f451$export$aa278641ded1adf = (0, $heB5U.createContainer)((0, $dsC4d.default));

});
parcelRegister("dsC4d", function(module, exports) {

$parcel$export(module.exports, "default", () => $961f40ab8b3e4548$export$2e2bcd8739ae039);

var $a61MH = parcelRequire("a61MH");

var $9z14H = parcelRequire("9z14H");
const $961f40ab8b3e4548$var$initialState = {
    'issue-view-experiment': {
        data: {
            value: false
        },
        loading: false,
        error: null
    }
};
var // @ts-expect-error - TS2344 - Type 'typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/services/user-preferences/src/actions/index")' does not satisfy the constraint 'Record<string, ActionThunk<State, typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/services/user-preferences/src/actions/index")>>'.
$961f40ab8b3e4548$export$2e2bcd8739ae039 = (0, $a61MH.createStore)({
    name: 'user-preference',
    initialState: $961f40ab8b3e4548$var$initialState,
    actions: $9z14H
});

});
parcelRegister("9z14H", function(module, exports) {

$parcel$export(module.exports, "fetch", () => (parcelRequire("h9epI")).default);
$parcel$export(module.exports, "fetchIssueCreate", () => (parcelRequire("7Pq3h")).default);
$parcel$export(module.exports, "updateExperiment", () => (parcelRequire("bZIav")).default);

var $h9epI = parcelRequire("h9epI");

var $7Pq3h = parcelRequire("7Pq3h");

var $bZIav = parcelRequire("bZIav");

});
parcelRegister("h9epI", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fe76d2a970114ff$export$2e2bcd8739ae039);

var $h5sT2 = parcelRequire("h5sT2");
var /**
 * Initiates data retrieval for a user preference, ensuring no duplicate requests are made.
 * Updates the application state with retrieved data or an error, accordingly.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$3fe76d2a970114ff$export$2e2bcd8739ae039 = (preferenceKey)=>async ({ setState: setState, getState: getState }, { baseUrl: baseUrl })=>{
        const currentState = getState();
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Readonly<State>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Readonly<State>'.
        if (currentState[preferenceKey] && currentState[preferenceKey].loading) return;
        setState({
            [preferenceKey]: {
                data: currentState.data,
                loading: true,
                error: null
            }
        });
        try {
            const data = await (0, $h5sT2.default)({
                baseUrl: baseUrl,
                preferenceKey: preferenceKey
            });
            setState({
                [preferenceKey]: {
                    data: data,
                    loading: false,
                    error: null
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                [preferenceKey]: {
                    data: getState().data,
                    loading: false,
                    error: err
                }
            });
        }
    };

});
parcelRegister("h5sT2", function(module, exports) {

$parcel$export(module.exports, "default", () => $63687d4b54057aad$export$2e2bcd8739ae039);

var $9CiFV = parcelRequire("9CiFV");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$63687d4b54057aad$export$2e2bcd8739ae039 = async ({ baseUrl: baseUrl, preferenceKey: preferenceKey })=>{
    try {
        const result = await (0, $9CiFV.default)(baseUrl, preferenceKey);
        return {
            value: result
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        if (e.statusCode === 404) return {
            value: undefined
        };
        throw e;
    }
};

});
parcelRegister("9CiFV", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca4afe9581c5212d$export$2e2bcd8739ae039);

var $lRmyA = parcelRequire("lRmyA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ca4afe9581c5212d$export$2e2bcd8739ae039 = (baseUrl, key)=>{
    const requestUrl = `${baseUrl}/rest/api/3/mypreferences?key=${key}`;
    return (0, $lRmyA.performGetRequest)(requestUrl);
};

});



parcelRegister("7Pq3h", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5c5efcd31332e13$export$2e2bcd8739ae039);

var $h9epI = parcelRequire("h9epI");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f5c5efcd31332e13$export$2e2bcd8739ae039 = ()=>(0, $h9epI.default)('issue-create');

});

parcelRegister("bZIav", function(module, exports) {

$parcel$export(module.exports, "default", () => $1122b82eba9b9cfc$export$2e2bcd8739ae039);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1122b82eba9b9cfc$export$2e2bcd8739ae039 = (experimentKey, value)=>({ setState: setState })=>{
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: { data: { value: boolean; }; loading: false; error: null; }; }' is not assignable to parameter of type 'Partial<State>'.
        setState({
            [experimentKey]: {
                data: {
                    value: value
                },
                loading: false,
                error: null
            }
        });
    };

});






parcelRegister("kqXZB", function(module, exports) {

$parcel$export(module.exports, "HorizontalNavWrapper", () => $cf6ef4bc9cecc99d$export$8798384053a023ae);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $1ybV0 = parcelRequire("1ybV0");

var $bAQOb = parcelRequire("bAQOb");

var $dJOhP = parcelRequire("dJOhP");

var $ghXjN = parcelRequire("ghXjN");
const $cf6ef4bc9cecc99d$var$NavErrorBoundaryFallback = ()=>// null = equivalent of "unmount"
    // We should do more graceful degradation.
    // Let's review this after dogfooding:
    // Tracked https://hello.jira.atlassian.cloud/browse/SEA-3059
    null;
const $cf6ef4bc9cecc99d$var$HorizontalNavWrapperOld = ({ children: children, navComponent: HorizontalNavComponent })=>{
    const isJwmStorageUpgradeMainEnabled = (0, $1ybV0.ff)('jwm.storage-upgrade-main');
    return /*#__PURE__*/ $eUqFw.createElement($cf6ef4bc9cecc99d$var$ThemedContainer, {
        isOverflowHidden: isJwmStorageUpgradeMainEnabled
    }, /*#__PURE__*/ $eUqFw.createElement((0, $dJOhP.NavErrorBoundary), {
        packageName: "page-container",
        id: "spa-horizontal-nav",
        fallback: $cf6ef4bc9cecc99d$var$NavErrorBoundaryFallback
    }, /*#__PURE__*/ $eUqFw.createElement((0, $dJOhP.NavErrorBoundary), {
        packageName: "page-container",
        id: "projectNavigationSkipLink",
        fallback: "unmount"
    }, /*#__PURE__*/ $eUqFw.createElement((0, $ghXjN.ProjectViewNavigationSkipLink), null)), /*#__PURE__*/ $eUqFw.createElement(HorizontalNavComponent, null)), children);
};
const $cf6ef4bc9cecc99d$var$wrapperStyles = {
    root: "_11q71o10 _11q31r52 _4t3i1osq _1e0c1txw _2lx21bp4",
    preventOverflow: "_1reo15vq _18m915vq"
};
const $cf6ef4bc9cecc99d$var$HorizontalNavWrapperNew = ({ children: children, navComponent: HorizontalNavComponent })=>{
    const isJwmStorageUpgradeMainEnabled = (0, $1ybV0.ff)('jwm.storage-upgrade-main');
    return /*#__PURE__*/ $eUqFw.createElement("div", {
        className: (0, $7JEyt.default)([
            $cf6ef4bc9cecc99d$var$wrapperStyles.root,
            isJwmStorageUpgradeMainEnabled && $cf6ef4bc9cecc99d$var$wrapperStyles.preventOverflow
        ])
    }, /*#__PURE__*/ $eUqFw.createElement((0, $dJOhP.NavErrorBoundary), {
        packageName: "page-container",
        id: "spa-horizontal-nav",
        fallback: $cf6ef4bc9cecc99d$var$NavErrorBoundaryFallback
    }, /*#__PURE__*/ $eUqFw.createElement((0, $dJOhP.NavErrorBoundary), {
        packageName: "page-container",
        id: "projectNavigationSkipLink",
        fallback: "unmount"
    }, /*#__PURE__*/ $eUqFw.createElement((0, $ghXjN.ProjectViewNavigationSkipLink), null)), /*#__PURE__*/ $eUqFw.createElement(HorizontalNavComponent, null)), children);
};
const $cf6ef4bc9cecc99d$export$8798384053a023ae = (0, $bAQOb.componentWithFF)('platform.atlassian.griffin-new-page-layout', $cf6ef4bc9cecc99d$var$HorizontalNavWrapperNew, $cf6ef4bc9cecc99d$var$HorizontalNavWrapperOld);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cf6ef4bc9cecc99d$var$ThemedContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isOverflowHidden: isOverflowHidden, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11q71o10 _11q31r52",
            __cmplp.isOverflowHidden && "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dJOhP", function(module, exports) {

$parcel$export(module.exports, "NavErrorBoundary", () => $fc92a101a1384c46$export$afc779e659fd533f);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $bAQOb = parcelRequire("bAQOb");
function $fc92a101a1384c46$export$35c1e8d8e59e87e7() {
    return [
        [
            'jira.nav4.top-nav',
            (0, $1ybV0.ff)('jira.nav4.top-nav')
        ],
        [
            'jsm-kb-nav-refresh-changes-enabled',
            (0, $1ybV0.ff)('jsm-kb-nav-refresh-changes-enabled')
        ],
        [
            'platform.atlassian.griffin-navigation-redesign',
            (0, $1ybV0.ff)('platform.atlassian.griffin-navigation-redesign')
        ],
        [
            'platform.atlassian.griffin-new-page-layout',
            (0, $1ybV0.ff)('platform.atlassian.griffin-new-page-layout')
        ],
        [
            'sea-2744-jsw-tabs-nav',
            (0, $1ybV0.ff)('sea-2744-jsw-tabs-nav')
        ]
    ];
}
// errors = client generated = unsafe
// also hackers are drowning us with probes
function $fc92a101a1384c46$var$getSafeStringifiedProp(obj, prop) {
    // @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
    const raw = String(obj?.[prop]);
    return raw.length > 100 ? `${raw.slice(0, 100)}\u{2702}` : raw;
}
const $fc92a101a1384c46$export$1d1321d2b374d697 = ()=>{
    if (typeof window !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+)$/.test(window?.BUILD_KEY);
    if (typeof globalThis !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+)$/.test(globalThis.BUILD_KEY);
    return false;
};
function $fc92a101a1384c46$var$inferNavRevision() {
    // This is brittle since we have several FFs https://hello.atlassian.net/wiki/spaces/SEA/pages/3841892327/Jira+Nav+v4+Feature+Flags
    // if possible, try to pass the revision explicitly as a prop
    return (0, $1ybV0.ff)('sea-2744-jsw-tabs-nav') ? 'v4' : 'v3';
}
function $fc92a101a1384c46$var$getExtraAttributes(error) {
    const attributes = {
        ffs: $fc92a101a1384c46$export$35c1e8d8e59e87e7().filter(([, value])=>value).map(([key])=>key).join(),
        rev: $fc92a101a1384c46$var$inferNavRevision(),
        ...(0, $1ybV0.ff)('atlassian-dogfooding-only') && {
            // PII & UGC = OK since it's dogfooding only (internal Atlassian)
            errClass: $fc92a101a1384c46$var$getSafeStringifiedProp(error, 'name'),
            // error message is already sent as part of fireErrorAnalytics()
            hostname: window.location.hostname,
            pathname: window.location.pathname
        }
    };
    return attributes;
}
function $fc92a101a1384c46$var$getAnalyticsPayload(error, meta, navRevision) {
    const payload = {
        error: error,
        meta: {
            // intentionally fixed metas
            // so that we generate a unique event signature
            // so that we can register it in the analytics portal: https://data-portal.internal.atlassian.com/analytics/registry/67955
            // so that we get the attributes to show up in Splunk: https://splunk.paas-inf.net/en-GB/app/search/2024_sea2744_jira_nav_v4_container_navigation
            id: 'logic',
            packageName: 'JiraNav'
        },
        attributes: {
            ...$fc92a101a1384c46$var$getExtraAttributes(error),
            // forward the original meta as attributes to identify the location
            pkg: meta.packageName,
            id: meta.id,
            // if explicitly passed, override the rev
            ...navRevision && {
                rev: navRevision
            }
        },
        skipSentry: true
    };
    return payload;
}
const $fc92a101a1384c46$export$5ac21f1e947e70d6 = (props)=>{
    const { id: id, packageName: packageName, navRevision: navRevision } = props;
    const onError = (0, $eUqFw.useMemo)(()=>{
        const meta = {
            id: id,
            packageName: packageName
        };
        const _onError = (...args)=>{
            if ($fc92a101a1384c46$export$1d1321d2b374d697()) // this is a local test environment, don't send anything
            return;
            const [_, error] = args;
            (0, $guiFP.default)($fc92a101a1384c46$var$getAnalyticsPayload(error, meta, navRevision));
        };
        return _onError;
    }, [
        id,
        packageName,
        navRevision
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        ...props,
        onError: onError
    });
};
const $fc92a101a1384c46$export$afc779e659fd533f = (0, $bAQOb.componentWithFF)('sea-2744-jsw-tabs-nav', (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fc92a101a1384c46$export$5ac21f1e947e70d6, props), (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), props));

});

parcelRegister("ghXjN", function(module, exports) {

$parcel$export(module.exports, "TopNavigationSkipLink", () => $e6fff404e2b2ee46$export$47de2191d46337b7);
$parcel$export(module.exports, "LeftSidebarSkipLink", () => $e6fff404e2b2ee46$export$46697df0d7c5e8be);
$parcel$export(module.exports, "ProjectViewNavigationSkipLink", () => $e6fff404e2b2ee46$export$2e2fc9c237996c06);
$parcel$export(module.exports, "MainContentSkipLink", () => $e6fff404e2b2ee46$export$b1498dd122ea3284);

var $5JgJ2 = parcelRequire("5JgJ2");

var $1GeZ8 = parcelRequire("1GeZ8");

var $16pq9 = parcelRequire("16pq9");
const $e6fff404e2b2ee46$export$47de2191d46337b7 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    (0, $1GeZ8.useCustomSkipLink)('ak-jira-navigation', formatMessage((0, $16pq9.default).skipToJiraNavigation), 0);
    return null;
};
const $e6fff404e2b2ee46$export$46697df0d7c5e8be = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    (0, $1GeZ8.useCustomSkipLink)('ak-side-navigation', formatMessage((0, $16pq9.default).skipToSideNavigation), 1);
    return null;
};
const $e6fff404e2b2ee46$export$2e2fc9c237996c06 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    (0, $1GeZ8.useCustomSkipLink)('ak-project-view-navigation', formatMessage((0, $16pq9.default).skipToProjectViewNavigation), 2);
    return null;
};
const $e6fff404e2b2ee46$export$b1498dd122ea3284 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    (0, $1GeZ8.useCustomSkipLink)('ak-main-content', formatMessage((0, $16pq9.default).skipToMainContent), 3);
    return null;
};

});
parcelRegister("16pq9", function(module, exports) {

$parcel$export(module.exports, "default", () => $28122dc87949ce0e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $28122dc87949ce0e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    skipToJiraNavigation: {
        "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-jira-navigation",
        "defaultMessage": "Skip to Jira Navigation"
    },
    skipToSideNavigation: {
        "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-side-navigation",
        "defaultMessage": "Skip to Side Navigation"
    },
    skipToProjectViewNavigation: {
        "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-project-view-navigation",
        "defaultMessage": "Skip to View Navigation"
    },
    skipToMainContent: {
        "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-main-content",
        "defaultMessage": "Skip to Main Content"
    }
});

});



parcelRegister("l8xBK", function(module, exports) {

$parcel$export(module.exports, "RightSidebar", () => $e236e5cdaab70156$export$84d58c19c21f637f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $0cdA8 = parcelRequire("0cdA8");

var $bAQOb = parcelRequire("bAQOb");

var $bUi2Q = parcelRequire("bUi2Q");

var $1GeZ8 = parcelRequire("1GeZ8");

var $10fdS = parcelRequire("10fdS");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $isbb2 = parcelRequire("isbb2");

var $bQiKj = parcelRequire("bQiKj");

var $jK1pm = parcelRequire("jK1pm");
/* IMPORTANT:
 * When making any changes to the OLD component, please ensure that you also make the same changes to the
 * NEW component. The feature flag used is part of the Navigation Refresh work and we need to ensure that
 * we do not introduce tech debt for the roll-out by only updating the current component that is due to be
 * removed.
 *
 * If you have any concerns or questions please reach out to the #jira-navigation channel. Thanks!
 */ const $e236e5cdaab70156$var$routeComponents = [];
const $e236e5cdaab70156$var$SharedRightSidebars = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $isbb2.renderGlobalComponents)((0, $bQiKj.sharedLayout).rightSidebars));
const $e236e5cdaab70156$var$RightSidebarRouteComponents = ()=>{
    const route = (0, $10fdS.useCurrentRoute)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $isbb2.renderGlobalComponents)(route.layout?.rightSidebars || $e236e5cdaab70156$var$routeComponents));
};
const $e236e5cdaab70156$var$NewRightSidebar = ()=>{
    const lastPanelIdRef = (0, $eUqFw.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const rightSidebarCurrentState = (0, $bUi2Q.useActiveRightSidebarState)();
    (0, $eUqFw.useEffect)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'rightSidebar change', {
            panelId: rightSidebarCurrentState?.panelId || lastPanelIdRef.current,
            isClosed: rightSidebarCurrentState?.panelId == null,
            isMinimised: !!rightSidebarCurrentState?.isMinimised,
            isCollapsed: !!rightSidebarCurrentState?.isCollapsed
        });
        lastPanelIdRef.current = rightSidebarCurrentState?.panelId;
    }, [
        createAnalyticsEvent,
        rightSidebarCurrentState?.panelId,
        rightSidebarCurrentState?.isMinimised,
        rightSidebarCurrentState?.isCollapsed
    ]);
    if (rightSidebarCurrentState && !rightSidebarCurrentState.shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "right-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1GeZ8.RightSidebar), {
        width: rightSidebarCurrentState && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised ? rightSidebarCurrentState.width : 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: "unmount",
        id: "shared-right-sidebars",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e236e5cdaab70156$var$SharedRightSidebars, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-sidebar-route-components",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e236e5cdaab70156$var$RightSidebarRouteComponents, null)))));
};
/**
 * Manages visibility and behavior of the right sidebar in the user interface, adapting to user interactions and system events. It enhances user experience by providing dynamic control over the sidebar's presentation, including features for collapsing and minimizing, alongside tracking user interactions for analytical purposes.
 */ const $e236e5cdaab70156$var$OldRightSidebar = ()=>{
    const lastPanelIdRef = (0, $eUqFw.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const rightSidebarCurrentState = (0, $bUi2Q.useActiveRightSidebarState)();
    (0, $eUqFw.useEffect)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'rightSidebar change', {
            panelId: rightSidebarCurrentState?.panelId || lastPanelIdRef.current,
            isClosed: rightSidebarCurrentState?.panelId == null,
            isMinimised: !!rightSidebarCurrentState?.isMinimised,
            isCollapsed: !!rightSidebarCurrentState?.isCollapsed
        });
        lastPanelIdRef.current = rightSidebarCurrentState?.panelId;
    }, [
        createAnalyticsEvent,
        rightSidebarCurrentState?.panelId,
        rightSidebarCurrentState?.isMinimised,
        rightSidebarCurrentState?.isCollapsed
    ]);
    if (rightSidebarCurrentState && !rightSidebarCurrentState.shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "right-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e236e5cdaab70156$var$RightSidebarPanelWrapper, {
        id: "right-sidebar-panel-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1GeZ8.RightSidebar), {
        width: rightSidebarCurrentState && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised ? rightSidebarCurrentState.width : 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: "unmount",
        id: "shared-right-sidebars",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e236e5cdaab70156$var$SharedRightSidebars, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-sidebar-route-components",
        packageName: "page-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e236e5cdaab70156$var$RightSidebarRouteComponents, null))))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e236e5cdaab70156$var$RightSidebarPanelWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1bgi _1ej2b4wl _iu1g1fl4",
            __cmplp.className
        ])
    });
});
const $e236e5cdaab70156$export$84d58c19c21f637f = (0, $bAQOb.componentWithFF)('platform.atlassian.griffin-new-page-layout', $e236e5cdaab70156$var$NewRightSidebar, $e236e5cdaab70156$var$OldRightSidebar);

});

parcelRegister("eymfV", function(module, exports) {

$parcel$export(module.exports, "Sidebar", () => $fa1d85c5358105db$export$1ba59dacbcbf90fe);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $hTLlD = parcelRequire("hTLlD");
parcelRequire("8fxTv");
var $7webZ = parcelRequire("7webZ");
var $8fxTv = parcelRequire("8fxTv");

var $c9TLT = parcelRequire("c9TLT");

var $0cdA8 = parcelRequire("0cdA8");

var $bAQOb = parcelRequire("bAQOb");

var $4ksts = parcelRequire("4ksts");

var $kpmC0 = parcelRequire("kpmC0");

var $u0mbR = parcelRequire("u0mbR");

var $bdfGI = parcelRequire("bdfGI");

var $4QXXR = parcelRequire("4QXXR");

var $1GeZ8 = parcelRequire("1GeZ8");

var $gGtKh = parcelRequire("gGtKh");

var $10fdS = parcelRequire("10fdS");

var $inC6u = parcelRequire("inC6u");

var $jK1pm = parcelRequire("jK1pm");

var $ghXjN = parcelRequire("ghXjN");

var $2D8YV = parcelRequire("2D8YV");

var $j6voN = parcelRequire("j6voN");
const $fa1d85c5358105db$var$SIDEBAR_TEST_ID = 'ContextualNavigation';
const $fa1d85c5358105db$var$SIDEBAR_TRACE_KEY = 'sidebar';
const $fa1d85c5358105db$var$sidebarOverrides = {
    ResizeButton: {
        render: (Component, props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
                id: "sidebar-resize-tooltip",
                packageName: "page-container",
                fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, props)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
                name: "side_bar_button",
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, props)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j6voN.AsyncResizeButtonTooltip), {
                isLeftSidebarCollapsed: props.isLeftSidebarCollapsed
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, props))))
    }
};
const $fa1d85c5358105db$var$SidebarInternal = ({ sidebar: sidebar })=>{
    const { width: width, isCollapsed: isCollapsed } = (0, $kpmC0.useLeftSidebarState)();
    const route = (0, $10fdS.useCurrentRoute)();
    const intl = (0, $4ksts.useIntlV2)();
    const shouldNotRenderSidebarInServerSide = false && isCollapsed;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "left-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fa1d85c5358105db$var$SidebarStyleOverrides, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "leftSidebarSkipLink",
        packageName: "jiraPageContainer",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ghXjN.LeftSidebarSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1GeZ8.LeftSidebar), {
        isFixed: true,
        width: width,
        testId: $fa1d85c5358105db$var$SIDEBAR_TEST_ID,
        resizeButtonLabel: intl.formatMessage((0, $2D8YV.messages).sidebarNavigation),
        collapsedState: isCollapsed ? 'collapsed' : 'expanded',
        overrides: $fa1d85c5358105db$var$sidebarOverrides,
        id: "ak-side-navigation"
    }, !shouldNotRenderSidebarInServerSide && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, route !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $u0mbR.SidebarStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $inC6u.RenderTracerMark), {
        type: "start",
        traceKey: $fa1d85c5358105db$var$SIDEBAR_TRACE_KEY
    })), sidebar, route !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fxTv.NavSidebarSSRPerformanceMark), {
        metricKey: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $inC6u.RenderTracerMark), {
        type: "end",
        traceKey: $fa1d85c5358105db$var$SIDEBAR_TRACE_KEY
    }))))));
};
const $fa1d85c5358105db$var$SidebarInternalMemo = /*#__PURE__*/ (0, $eUqFw.memo)($fa1d85c5358105db$var$SidebarInternal, (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))); // moved children as function outside the `Sidebar` so that the function is not re-created every time `Sidebar` is re-rendered.
const $fa1d85c5358105db$var$renderChildren = (sidebar)=>sidebar !== null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fa1d85c5358105db$var$SidebarInternalMemo, {
        sidebar: sidebar
    }) : null;
const $fa1d85c5358105db$var$SidebarCurrent = ()=>{
    const { shouldRender: shouldRender } = (0, $kpmC0.useLeftSidebarState)();
    const route = (0, $10fdS.useCurrentRoute)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4QXXR.SidebarSelectorProvider), {
        sidebar: route.navigation?.sidebar ?? null
    }, $fa1d85c5358105db$var$renderChildren);
};
const $fa1d85c5358105db$export$1ba59dacbcbf90fe = (0, $bAQOb.componentWithFF)('platform.atlassian.griffin-navigation-redesign', (0, $bdfGI.SidebarSelector), $fa1d85c5358105db$var$SidebarCurrent); /**
                                                                                                                            * In the @atlaskit/page-layout, resize control uses button for
                                                                                                                            * the grab area. At the same time, legacy batch.css reset all
                                                                                                                            * the button to have a box-shadow when focused. So when user
                                                                                                                            * resizing the sidebar, they will see two blue lines around
                                                                                                                            * the grab area.
                                                                                                                            */ 
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fa1d85c5358105db$var$SidebarStyleOverrides = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1d7w7yr": (0, $9t7rW.default)((0, $c9TLT.layers).leftSidebar)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1pbyg9ti _14c1glyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8fxTv", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_TOP_DROPDOWN_MARKS", () => $0e0908bb9731ec35$export$8df02628d98cae7e);
$parcel$export(module.exports, "pageSegmentStore", () => $0e0908bb9731ec35$export$26cadbe0bcaabcde);
$parcel$export(module.exports, "useNavPerformanceMetrics", () => $0e0908bb9731ec35$export$906025848d54198d);
$parcel$export(module.exports, "NavTopPerformanceMark", () => $0e0908bb9731ec35$export$b7f4caa65b0906fc);
$parcel$export(module.exports, "NavTopSSRPerformanceMark", () => $0e0908bb9731ec35$export$2c4a101f2cde4fc2);
$parcel$export(module.exports, "NavTopPerformanceReport", () => $0e0908bb9731ec35$export$c64b31449a6177d);
$parcel$export(module.exports, "NavSidebarPerformanceMark", () => $0e0908bb9731ec35$export$35b2aeea5cbc963e);
$parcel$export(module.exports, "NavSidebarSSRPerformanceMark", () => $0e0908bb9731ec35$export$14f711a2cb6a655a);
$parcel$export(module.exports, "NavSidebarPerformanceReport", () => $0e0908bb9731ec35$export$a018e347341b3640);
$parcel$export(module.exports, "NAVIGATION_SIDEBAR_SEGMENT_NAME", () => (parcelRequire("7webZ")).NAVIGATION_SIDEBAR_SEGMENT_NAME);
$parcel$export(module.exports, "NAVIGATION_TOP_MARKS", () => (parcelRequire("7webZ")).NAVIGATION_TOP_MARKS);
$parcel$export(module.exports, "NAVIGATION_SIDEBAR_MARKS", () => (parcelRequire("7webZ")).NAVIGATION_SIDEBAR_MARKS);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $lNfG4 = parcelRequire("lNfG4");

var $keguF = parcelRequire("keguF");

var $inC6u = parcelRequire("inC6u");

var $7webZ = parcelRequire("7webZ");
const $0e0908bb9731ec35$var$createTopNavPageSegment = ()=>(0, $lNfG4.metrics).pageSegmentLoad({
        key: (0, $7webZ.NAVIGATION_TOP_SEGMENT_NAME),
        timings: [
            {
                key: 'ttic',
                startMark: (0, $7webZ.NAVIGATION_TOP_MARKS).renderStart,
                endMark: (0, $7webZ.NAVIGATION_TOP_MARKS).renderEnd
            },
            {
                key: 'tti',
                endMark: (0, $7webZ.NAVIGATION_TOP_MARKS).renderEnd
            },
            {
                key: 'ttr',
                endMark: (0, $7webZ.NAVIGATION_TOP_MARKS).renderSsrEnd
            },
            {
                key: 'ttrc',
                startMark: (0, $7webZ.NAVIGATION_TOP_MARKS).renderSsrStart,
                endMark: (0, $7webZ.NAVIGATION_TOP_MARKS).renderSsrEnd
            },
            {
                key: 'bundle-load',
                startMark: (0, $7webZ.NAVIGATION_TOP_MARKS).bundleLoadStart,
                endMark: (0, $7webZ.NAVIGATION_TOP_MARKS).renderStart
            }
        ],
        histogram: {
            initial: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '4000_4500_5000_6000_7000_8000_9000'
            },
            transition: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '2500_3000_3500_4000_5000_6000'
            }
        }
    });
const $0e0908bb9731ec35$export$8df02628d98cae7e = {
    ADDONS: (0, $lNfG4.metrics).interaction({
        key: 'navigation-top.addons-dropdown-opened'
    })
};
const $0e0908bb9731ec35$var$createSidebarPageSegment = ()=>(0, $lNfG4.metrics).pageSegmentLoad({
        key: (0, $7webZ.NAVIGATION_SIDEBAR_SEGMENT_NAME),
        timings: [
            {
                key: 'renderAttempt',
                startMark: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderAttempt,
                endMark: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderAttempt
            },
            {
                key: 'ttic',
                startMark: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderStart,
                endMark: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderEnd
            },
            {
                key: 'tti',
                endMark: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderEnd
            },
            {
                key: 'ttr',
                endMark: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
            },
            {
                key: 'ttrc',
                startMark: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderSsrStart,
                endMark: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
            },
            {
                key: 'load',
                startMark: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).loadStart,
                endMark: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).loadEnd
            }
        ],
        histogram: {
            initial: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '4000_4500_5000_6000_7000_8000_9000'
            },
            transition: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '2500_3000_3500_4000_5000_6000'
            }
        }
    });
const $0e0908bb9731ec35$export$26cadbe0bcaabcde = (()=>{
    const segmentConstructors = {
        [(0, $7webZ.NAVIGATION_TOP_SEGMENT_NAME)]: $0e0908bb9731ec35$var$createTopNavPageSegment,
        [(0, $7webZ.NAVIGATION_SIDEBAR_SEGMENT_NAME)]: $0e0908bb9731ec35$var$createSidebarPageSegment
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const segments = {};
    return {
        getSegment: (key)=>{
            if (!segments[key]) {
                if (!segmentConstructors[key]) throw new Error(`Segment constructor for ${key} is not defined.`);
                segments[key] = segmentConstructors[key]();
            }
            return segments[key];
        }
    };
})();
const $0e0908bb9731ec35$export$906025848d54198d = (segmentKey = (0, $7webZ.NAVIGATION_TOP_SEGMENT_NAME))=>{
    const startedRef = (0, $eUqFw.useRef)(false);
    const segment = (0, $eUqFw.useRef)($0e0908bb9731ec35$export$26cadbe0bcaabcde.getSegment(segmentKey)).current;
    if (!false && !startedRef.current) {
        segment && segment.startFromPageLoad();
        startedRef.current = true;
    }
    return (0, $eUqFw.useMemo)(()=>// object assign here to extend origianl segment object and save prototypes
        Object.assign(segment, {
            markSSR: (metricKey)=>{
                const tmpSsrMetricKey = `${(0, $7webZ.NAVIGATION_SSR_MARK_PREFIX)}.${metricKey}`;
                if (window.SPA_STATE) {
                    // @ts-expect-error - TS2339 - Property 'startTime' does not exist on type 'unknown'. | TS2339 - Property 'duration' does not exist on type 'unknown'.
                    const { startTime: startTime = 0, duration: duration = 0 } = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))((0, $inC6u.getRenderTraceFromSSRGlobal)(), [
                        'traces',
                        `render/${tmpSsrMetricKey}`
                    ]) || {};
                    const markTime = startTime + duration;
                    markTime && markTime > 0 && segment.mark(metricKey, markTime);
                }
            }
        }), [
        segment
    ]);
};
const $0e0908bb9731ec35$var$NavigationPerformanceMark = ({ segmentKey: segmentKey, metricKey: metricKey })=>{
    const navSegment = $0e0908bb9731ec35$export$906025848d54198d(segmentKey);
    (0, $eUqFw.useEffect)(()=>navSegment.mark(metricKey), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return null;
};
const $0e0908bb9731ec35$var$NavigationSSRPerformanceMark = ({ segmentKey: segmentKey, metricKey: metricKey })=>{
    const tmpSsrMetricKey = `${(0, $7webZ.NAVIGATION_SSR_MARK_PREFIX)}.${metricKey}`;
    const navSegment = $0e0908bb9731ec35$export$906025848d54198d(segmentKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eUqFw.useEffect)(()=>navSegment.markSSR(metricKey), []);
    return false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $inC6u.RenderTracerMark), {
        type: "end",
        traceKey: tmpSsrMetricKey
    }) : null;
};
const $0e0908bb9731ec35$var$NavigationPerformanceReport = ({ segmentKey: segmentKey, customData: customData })=>{
    const navSegment = $0e0908bb9731ec35$export$906025848d54198d(segmentKey);
    (0, $eUqFw.useEffect)(()=>{
        navSegment.stop({
            customData: {
                ...customData,
                userLocation: (0, $keguF.getUserLocation)()
            }
        });
        navSegment.clear();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
const $0e0908bb9731ec35$export$b7f4caa65b0906fc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0e0908bb9731ec35$var$NavigationPerformanceMark, {
        ...props,
        segmentKey: (0, $7webZ.NAVIGATION_TOP_SEGMENT_NAME)
    });
const $0e0908bb9731ec35$export$2c4a101f2cde4fc2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0e0908bb9731ec35$var$NavigationSSRPerformanceMark, {
        ...props,
        segmentKey: (0, $7webZ.NAVIGATION_TOP_SEGMENT_NAME)
    });
const $0e0908bb9731ec35$export$c64b31449a6177d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0e0908bb9731ec35$var$NavigationPerformanceReport, {
        ...props,
        segmentKey: (0, $7webZ.NAVIGATION_TOP_SEGMENT_NAME)
    });
const $0e0908bb9731ec35$export$35b2aeea5cbc963e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0e0908bb9731ec35$var$NavigationPerformanceMark, {
        ...props,
        segmentKey: (0, $7webZ.NAVIGATION_SIDEBAR_SEGMENT_NAME)
    });
const $0e0908bb9731ec35$export$14f711a2cb6a655a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0e0908bb9731ec35$var$NavigationSSRPerformanceMark, {
        ...props,
        segmentKey: (0, $7webZ.NAVIGATION_SIDEBAR_SEGMENT_NAME)
    });
const $0e0908bb9731ec35$export$a018e347341b3640 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0e0908bb9731ec35$var$NavigationPerformanceReport, {
        ...props,
        segmentKey: (0, $7webZ.NAVIGATION_SIDEBAR_SEGMENT_NAME)
    });

});
parcelRegister("inC6u", function(module, exports) {

$parcel$export(module.exports, "RenderTracerMark", () => $eba039e5967c438d$export$54c89059bb435049);
$parcel$export(module.exports, "getRenderTraceFromSSRGlobal", () => $eba039e5967c438d$export$345f21b0287f67e5);

var $eUqFw = parcelRequire("eUqFw");

var $aeTOI = parcelRequire("aeTOI");

var $illlw = parcelRequire("illlw");

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");

var $9I5Lq = parcelRequire("9I5Lq");

const $eba039e5967c438d$var$initialState = {
    start: undefined,
    traces: {}
};
let $eba039e5967c438d$var$currentTraces = {};
const $eba039e5967c438d$export$2365ecd8218e21c7 = ()=>$eba039e5967c438d$var$currentTraces;
const $eba039e5967c438d$export$5c757eaa1990d0d7 = (key)=>{
    if ($eba039e5967c438d$var$currentTraces[key]) return;
    $eba039e5967c438d$var$currentTraces[key] = {
        startTime: (0, $9I5Lq.performance).now()
    };
};
const $eba039e5967c438d$export$16854dc18f8d976 = (key)=>{
    if (!$eba039e5967c438d$var$currentTraces[key] || $eba039e5967c438d$var$currentTraces[key].duration != null) return;
    $eba039e5967c438d$var$currentTraces[key].duration = (0, $9I5Lq.performance).now() - $eba039e5967c438d$var$currentTraces[key].startTime;
};
const $eba039e5967c438d$var$actions = {
    startTrace: (name, time)=>({ setState: setState, getState: getState }, { startKey: startKey })=>{
            const { start: start, traces: traces } = getState();
            // If <RenderTracerContainer /> has not been setup with a startKey and startTime, return
            if (start === undefined) return;
            const key = name === startKey ? name : `${startKey}/${name}`;
            if (traces[key]) return;
            setState({
                traces: (0, (/*@__PURE__*/$parcel$interopDefault($aeTOI)))({}, traces, {
                    [key]: {
                        startTime: time
                    }
                })
            });
        },
    endTrace: (name, time)=>({ setState: setState, getState: getState }, { startKey: startKey })=>{
            const { start: start, traces: traces } = getState();
            if (start === undefined) return;
            const key = name === startKey ? name : `${startKey}/${name}`;
            const trace = traces[key] || {
                startTime: 0
            };
            setState({
                traces: (0, (/*@__PURE__*/$parcel$interopDefault($aeTOI)))({}, traces, {
                    [key]: {
                        ...trace,
                        duration: time - trace.startTime
                    }
                })
            });
            $eba039e5967c438d$var$currentTraces = Object.assign($eba039e5967c438d$var$currentTraces, getState().traces);
        }
};
const $eba039e5967c438d$var$Store = (0, $a61MH.createStore)({
    name: 'jira-render-tracer',
    initialState: $eba039e5967c438d$var$initialState,
    actions: $eba039e5967c438d$var$actions
});
const $eba039e5967c438d$var$RenderTracerActions = (0, $dYfll.createSubscriber)($eba039e5967c438d$var$Store, {
    selector: null
});
const $eba039e5967c438d$export$719a95758870be58 = (0, $ggKAj.createHook)($eba039e5967c438d$var$Store, {
    selector: null
});
const $eba039e5967c438d$var$RenderTracerContainerBase = (0, $heB5U.createContainer)($eba039e5967c438d$var$Store, {
    onInit: ()=>({ setState: setState }, { startKey: startKey, startTime: startTime })=>{
            setState({
                start: startTime,
                traces: {
                    [startKey]: {
                        startTime: (0, $9I5Lq.performance).now()
                    }
                }
            });
        }
});
const $eba039e5967c438d$export$37d31bee41ca1401 = ({ children: children, startKey: startKey, startTime: startTime })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eba039e5967c438d$var$RenderTracerContainerBase, {
        startKey: startKey,
        startTime: startTime
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eba039e5967c438d$export$54c89059bb435049, {
        traceKey: startKey,
        type: "end"
    }));
const $eba039e5967c438d$export$54c89059bb435049 = ({ traceKey: traceKey, type: type })=>// @ts-expect-error - TS2745 - This JSX tag's 'children' prop expects type 'never' which requires multiple children, but only a single child was provided.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eba039e5967c438d$var$RenderTracerActions, null, (_, { startTrace: startTrace, endTrace: endTrace })=>{
        if (type === 'start') startTrace(traceKey, (0, $9I5Lq.performance).now());
        else if (type === 'end') endTrace(traceKey, (0, $9I5Lq.performance).now());
        return null;
    });
const $eba039e5967c438d$export$cba8addc8743389c = (appName = 'unknown', traces = $eba039e5967c438d$var$currentTraces)=>({
        [(0, $98d270000c5bb498$export$3c96fa14fb694e11)]: {
            data: {
                traces: traces,
                routeName: appName
            }
        }
    });
const $eba039e5967c438d$export$345f21b0287f67e5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(window.SPA_STATE || window.SKELETON_NAVIGATION || {}, [
        (0, $98d270000c5bb498$export$3c96fa14fb694e11),
        'data'
    ], {});

});
parcelRegister("9I5Lq", function(module, exports) {

$parcel$export(module.exports, "performance", () => $cb19fd4c8632f94b$export$f2d2284f5fec51f8);
const $cb19fd4c8632f94b$var$now = ()=>false ? Date.now() : $parcel$global.performance.now();
class $cb19fd4c8632f94b$export$9a0dbed22cbf63be {
    start() {
        if (false) this.startAt = $cb19fd4c8632f94b$var$now();
    }
    now() {
        if (false) return $cb19fd4c8632f94b$var$now() - this.startAt;
        return $cb19fd4c8632f94b$var$now();
    }
    constructor(){
        this.startAt = $cb19fd4c8632f94b$var$now();
    }
}
const $cb19fd4c8632f94b$export$f2d2284f5fec51f8 = new $cb19fd4c8632f94b$export$9a0dbed22cbf63be();

});

const $98d270000c5bb498$export$3c96fa14fb694e11 = 'ssr/detail_render_trace';


parcelRegister("7webZ", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_TOP_SEGMENT_NAME", () => $ba1c37c8f1f8f79b$export$6635720e40ea7a7a);
$parcel$export(module.exports, "NAVIGATION_SIDEBAR_SEGMENT_NAME", () => $ba1c37c8f1f8f79b$export$1d3c3cb357af0e86);
$parcel$export(module.exports, "NAVIGATION_SSR_MARK_PREFIX", () => $ba1c37c8f1f8f79b$export$e7a14fa81b3c6488);
$parcel$export(module.exports, "NAVIGATION_TOP_MARKS", () => $ba1c37c8f1f8f79b$export$ad760bb9734bf93f);
$parcel$export(module.exports, "NAVIGATION_SIDEBAR_MARKS", () => $ba1c37c8f1f8f79b$export$1d10ee0c85c3cb21);
const $ba1c37c8f1f8f79b$export$6635720e40ea7a7a = 'navigation.top';
const $ba1c37c8f1f8f79b$export$1d3c3cb357af0e86 = 'navigation.sidebar';
const $ba1c37c8f1f8f79b$export$e7a14fa81b3c6488 = 'nav-ssr-mark';
const $ba1c37c8f1f8f79b$export$ad760bb9734bf93f = {
    renderStart: 'navigation-top.render.start',
    renderEnd: 'navigation-top.render.end',
    renderSsrStart: 'navigation-top.render.ssr.start',
    renderSsrEnd: 'navigation-top.render.ssr.end',
    bundleLoadStart: 'navigation-top.bundle-load.start'
};
const $ba1c37c8f1f8f79b$export$1d10ee0c85c3cb21 = {
    renderAttempt: 'navigation-sidebar.render.attempt',
    renderStart: 'navigation-sidebar.render.start',
    renderEnd: 'navigation-sidebar.render.end',
    renderSsrStart: 'navigation-sidebar.render.ssr.start',
    renderSsrEnd: 'navigation-sidebar.render.ssr.end',
    loadStart: 'navigation-sidebar.load.start',
    loadEnd: 'navigation-sidebar.load.end'
};

});


parcelRegister("4ksts", function(module, exports) {

$parcel$export(module.exports, "useIntlV2", () => $32efc9cfc8f5c011$export$d82607073b68786);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1IqwQ = parcelRequire("1IqwQ");
const $32efc9cfc8f5c011$export$d82607073b68786 = ()=>{
    const { messages: messages, locale: locale, formats: formats, formatDate: formatDate, formatMessage: formatMessage, formatRelativeTime: formatRelativeTime, formatNumber: formatNumber, formatPlural: formatPlural, formatTime: formatTime } = (0, $5JgJ2.default)();
    // Only recreate intl object if reference to originral intl changes.
    const memoisedIntl = (0, $eUqFw.useMemo)(()=>{
        const modifiedIntl = {
            // Now is deprecated since version 2: https://github.com/formatjs/formatjs/issues/1409
            now: ()=>Date.now(),
            messages: // @ts-expect-error - TS2322 - Type 'Record<string, string> | Record<string, MessageFormatElement[]>' is not assignable to type '{ [id: string]: string; }'.
            messages,
            locale: locale,
            formats: formats,
            formatDate: formatDate,
            formatMessage: formatMessage,
            formatHTMLMessage: (descriptor, values)=>formatMessage(descriptor, values, {
                    ignoreTag: true
                }),
            formatNumber: formatNumber,
            formatRelative: (date, opts)=>{
                const { time: time, unit: unit } = (0, $1IqwQ.getRelativeTimeAndUnit)(date);
                return formatRelativeTime(time, unit, opts);
            },
            formatPlural: formatPlural,
            formatTime: formatTime
        };
        return modifiedIntl;
    }, [
        formatDate,
        formatMessage,
        formatPlural,
        formatRelativeTime,
        formatTime,
        formatNumber,
        formats,
        locale,
        messages
    ]);
    return memoisedIntl;
};

});

parcelRegister("u0mbR", function(module, exports) {

$parcel$export(module.exports, "SidebarStart", () => $b1949a81125e9848$export$6738d1299dc79710);
$parcel$export(module.exports, "SidebarRenderStart", () => $b1949a81125e9848$export$ba19e3624956e66);
$parcel$export(module.exports, "SidebarReady", () => $b1949a81125e9848$export$a06ecbbe5820282);
$parcel$export(module.exports, "useSidebarFail", () => $b1949a81125e9848$export$661ed14c8f75da9f);
$parcel$export(module.exports, "useSidebarSuccess", () => $b1949a81125e9848$export$ddb17534fdfb7dc6);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("8fxTv");
var $7webZ = parcelRequire("7webZ");
var $8fxTv = parcelRequire("8fxTv");

var $4qhD6 = parcelRequire("4qhD6");
var $bDhRl = parcelRequire("bDhRl");
var $fDZ6r = parcelRequire("fDZ6r");

var $jmt32 = parcelRequire("jmt32");

var $10fdS = parcelRequire("10fdS");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");

var $3O0Td = parcelRequire("3O0Td");

var $bgNoL = parcelRequire("bgNoL");
// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
const { useValue: $b1949a81125e9848$var$useSidebarId } = (0, $jmt32.createValueController)('sidebar-id');
const $b1949a81125e9848$var$EXPERIENCE_SUCCESS_ATTRIBUTES = {
    experience: (0, $bgNoL.SIDEBAR_EXPERIENCE),
    attributes: {
        sidebar: 'v3'
    }
};
const $b1949a81125e9848$export$6738d1299dc79710 = ()=>{
    const [{ route: route, match: match }] = (0, $kJlBc.useRouter)();
    const pageId = (0, $3O0Td.usePageId)();
    const startRef = (0, $eUqFw.useRef)(Date.now());
    const onStartExperience = (0, $bDhRl.useExperienceStart)({
        experienceId: pageId,
        experience: (0, $bgNoL.SIDEBAR_EXPERIENCE),
        analyticsSource: 'Sidebar'
    });
    (0, $eUqFw.useMemo)(()=>{
        if (route.isRedirect ?? false) return;
        onStartExperience();
        startRef.current = Date.now();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route,
        match
    ]);
    return null;
};
const $b1949a81125e9848$export$ba19e3624956e66 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fxTv.NavSidebarPerformanceMark), {
        metricKey: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderStart
    });
const $b1949a81125e9848$export$a06ecbbe5820282 = ({ id: id })=>{
    const [, setSidebarId] = $b1949a81125e9848$var$useSidebarId();
    const route = (0, $10fdS.useCurrentRoute)();
    const routeName = route.name ?? route.group ?? 'UNKNOWN';
    const onSuccess = (0, $fDZ6r.useExperienceSuccess)($b1949a81125e9848$var$EXPERIENCE_SUCCESS_ATTRIBUTES);
    (0, $eUqFw.useEffect)(()=>{
        setSidebarId(id);
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
        return ()=>setSidebarId();
    }, [
        setSidebarId,
        id
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (route.isRedirect ?? false) return;
        onSuccess();
    }, [
        onSuccess,
        route
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        // Why are we injecting the route name into the global window state?
        // We currently don't have any way to get the route name when the sidenav is rendered OUTSIDE of the SPA
        window.__POLLINATOR__ = {
            ...window.__POLLINATOR__,
            routeName: routeName
        };
        const event = createAnalyticsEvent({
            action: 'ready',
            actionSubject: 'sidebar',
            meta: {
                teamName: 'endeavour'
            }
        });
        (0, $jMP2a.fireUIAnalytics)(event, 'Sidebar Ready', {
            route: routeName
        });
    }, [
        createAnalyticsEvent,
        routeName
    ]);
    const customData = (0, $eUqFw.useMemo)(()=>({
            route: routeName,
            sidebarId: id
        }), [
        routeName,
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fxTv.NavSidebarPerformanceMark), {
        metricKey: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderEnd
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fxTv.NavSidebarPerformanceReport), {
        customData: customData
    }));
};
const $b1949a81125e9848$export$661ed14c8f75da9f = ()=>{
    const onFail = (0, $4qhD6.useExperienceFail)({
        experience: (0, $bgNoL.SIDEBAR_EXPERIENCE)
    });
    return (0, $eUqFw.useCallback)((location, error)=>{
        onFail(location, error);
    }, [
        onFail
    ]);
};
const $b1949a81125e9848$export$ddb17534fdfb7dc6 = ()=>(0, $fDZ6r.useExperienceSuccess)($b1949a81125e9848$var$EXPERIENCE_SUCCESS_ATTRIBUTES);

});
parcelRegister("4qhD6", function(module, exports) {

$parcel$export(module.exports, "useExperienceFail", () => $2f159cb06c119de7$export$606da7704d8eaf06);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $JRB5w = parcelRequire("JRB5w");

var $gtrMw = parcelRequire("gtrMw");
const $2f159cb06c119de7$export$606da7704d8eaf06 = ({ experience: experience, attributes: attributes })=>{
    const experienceTracker = (0, $gtrMw.useExperienceContext)();
    const self = (0, $eUqFw.useRef)({
        name: experience,
        attributes: attributes,
        experienceTracker: experienceTracker
    });
    self.current.name = experience;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    return (0, $eUqFw.useCallback)((location, error, extraAttributes = {})=>{
        const { current: current } = self;
        // ignore client side errors from impacting experience metrics
        if ((0, $7rh0R.isLoaderError)(error) && error.name === 'ChunkLoadError' || (0, $JRB5w.isClientFetchError)(error)) return;
        current.experienceTracker.fail({
            name: current.name,
            error: error,
            attributes: {
                ...current.attributes,
                ...extraAttributes,
                location: location
            }
        });
    }, [
        self
    ]);
};

});
parcelRegister("gtrMw", function(module, exports) {

$parcel$export(module.exports, "useExperienceContext", () => $b35642cd91fe7353$export$be8ec22ac9208049);

var $eUqFw = parcelRequire("eUqFw");

var $1xrmr = parcelRequire("1xrmr");
const $b35642cd91fe7353$export$be8ec22ac9208049 = ()=>{
    const context = (0, $eUqFw.useContext)((0, $1xrmr.ExperienceTrackerContext));
    return context;
};

});


parcelRegister("bDhRl", function(module, exports) {

$parcel$export(module.exports, "useExperienceStart", () => $61606509e9879b1e$export$675e0d25df38d426);
$parcel$export(module.exports, "ExperienceStart", () => $61606509e9879b1e$export$f20b867e738a222c);

var $eUqFw = parcelRequire("eUqFw");

var $10fdS = parcelRequire("10fdS");

var $gtrMw = parcelRequire("gtrMw");
const $61606509e9879b1e$export$675e0d25df38d426 = ({ experienceId: experienceId, experience: experience, timeout: timeout, analyticsSource: analyticsSource, application: application, edition: edition, disableSli: disableSli = false, collect: collect = ()=>undefined })=>{
    const route = (0, $10fdS.useCurrentRoute)();
    const experienceTracker = (0, $gtrMw.useExperienceContext)();
    const userLocation = `${route.group ?? 'unknown'}:${route.name}`;
    const self = (0, $eUqFw.useRef)({
        experienceId: experienceId,
        experience: experience,
        timeout: timeout,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        experienceTracker: experienceTracker,
        disableSli: disableSli,
        userLocation: userLocation,
        collect: collect
    });
    self.current.experienceId = experienceId;
    self.current.experience = experience;
    self.current.timeout = timeout;
    self.current.analyticsSource = analyticsSource;
    self.current.application = application;
    self.current.edition = edition;
    self.current.experienceTracker = experienceTracker;
    self.current.userLocation = userLocation;
    self.current.collect = collect;
    return (0, $eUqFw.useCallback)(()=>{
        const { current: current } = self;
        current.experienceTracker.start({
            // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string'.
            id: current.experienceId,
            name: current.experience,
            timeout: current.timeout,
            attributes: {
                analyticsSource: current.analyticsSource,
                experience: current.experience,
                experienceId: current.experienceId,
                application: current.application,
                edition: current.edition,
                disableSli: current.disableSli,
                userLocation: current.userLocation
            },
            collect: current.collect,
            onSuccess: ()=>undefined
        });
    }, [
        self
    ]);
};
const $61606509e9879b1e$export$f20b867e738a222c = ({ experienceId: experienceId, experience: experience, timeout: timeout, analyticsSource: analyticsSource, application: application, edition: edition, disableSli: disableSli = false, collect: collect })=>{
    const onStart = $61606509e9879b1e$export$675e0d25df38d426({
        experienceId: experienceId,
        experience: experience,
        timeout: timeout,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        disableSli: disableSli,
        collect: collect
    });
    (0, $eUqFw.useMemo)(()=>{
        onStart();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onStart,
        experienceId,
        experience,
        timeout,
        analyticsSource,
        application,
        edition,
        disableSli,
        collect
    ]);
    return null;
};

});

parcelRegister("fDZ6r", function(module, exports) {

$parcel$export(module.exports, "useExperienceSuccess", () => $62a77bba99475ca2$export$e94f0da4fc0603c6);
$parcel$export(module.exports, "ExperienceSuccess", () => $62a77bba99475ca2$export$4962f3898bd5c829);

var $eUqFw = parcelRequire("eUqFw");

var $10fdS = parcelRequire("10fdS");

var $gtrMw = parcelRequire("gtrMw");
const $62a77bba99475ca2$var$STABLE_EMPTY_OBJECT = {};
const $62a77bba99475ca2$export$e94f0da4fc0603c6 = ({ experience: experience, attributes: attributes = $62a77bba99475ca2$var$STABLE_EMPTY_OBJECT })=>{
    const experienceTracker = (0, $gtrMw.useExperienceContext)();
    const route = (0, $10fdS.useCurrentRoute)();
    const self = (0, $eUqFw.useRef)({
        experience: experience,
        attributes: attributes,
        experienceTracker: experienceTracker,
        route: route
    });
    self.current.route = route;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    self.current.experience = experience;
    return (0, $eUqFw.useCallback)((extraAttributes = {})=>{
        const { current: current } = self;
        if (current.route && current.route.isRedirect === true) return;
        current.experienceTracker.succeed({
            name: current.experience,
            attributes: {
                ...current.attributes,
                ...extraAttributes
            }
        });
    }, [
        self
    ]);
};
const $62a77bba99475ca2$export$4962f3898bd5c829 = ({ experience: experience, attributes: attributes = $62a77bba99475ca2$var$STABLE_EMPTY_OBJECT })=>{
    const onExperienceSuccess = $62a77bba99475ca2$export$e94f0da4fc0603c6({
        experience: experience,
        attributes: attributes
    });
    (0, $eUqFw.useEffect)(()=>{
        onExperienceSuccess();
    }, [
        attributes,
        onExperienceSuccess
    ]);
    (0, $eUqFw.useMemo)(()=>{
        if (false) onExperienceSuccess();
    }, [
        onExperienceSuccess
    ]);
    return null;
};

});

parcelRegister("jmt32", function(module, exports) {

$parcel$export(module.exports, "createValueController", () => $23eae1bf65d6e5ee$export$ff0ab9dd4ceb4a93);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $23eae1bf65d6e5ee$export$ff0ab9dd4ceb4a93 = (name, defaultValue)=>{
    const actions = {
        setValue: (value)=>({ setState: setState })=>setState({
                    value: value
                })
    };
    const initialState = {
        value: defaultValue
    };
    const store = (0, $a61MH.createStore)({
        name: name,
        initialState: initialState,
        actions: actions
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const ValueContainer = (0, $heB5U.createContainer)(store);
    const selector = (state)=>state.value;
    const useValueInternal = (0, $ggKAj.createHook)(store, {
        selector: selector
    });
    const useValue = ()=>{
        const [value, { setValue: setValue }] = useValueInternal();
        return [
            value,
            setValue
        ];
    };
    return {
        ValueContainer: ValueContainer,
        useValue: useValue
    };
};

});

parcelRegister("3O0Td", function(module, exports) {

$parcel$export(module.exports, "usePageId", () => $8b00509e9968a84b$export$3434ba5eadb360dc);

var $ggKAj = parcelRequire("ggKAj");

var $cfLkw = parcelRequire("cfLkw");
const $8b00509e9968a84b$var$useSweetStatePageId = (0, $ggKAj.createHook)((0, $cfLkw.default), {
    selector: (state)=>state.currentPage.uuid
});
const $8b00509e9968a84b$export$3434ba5eadb360dc = ()=>{
    const [pageId] = $8b00509e9968a84b$var$useSweetStatePageId();
    return pageId;
};

});

parcelRegister("bgNoL", function(module, exports) {

$parcel$export(module.exports, "REPO_TYPE", () => $425fbadb5891ec48$export$399c7e6858236b4);
$parcel$export(module.exports, "LINK_TYPE", () => $425fbadb5891ec48$export$58125ce2bb1c3378);
$parcel$export(module.exports, "EMOJI_REGEX", () => $425fbadb5891ec48$export$c79ed2783644934c);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES", () => $425fbadb5891ec48$export$25ae65041c800c9);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES", () => $425fbadb5891ec48$export$e03c9beea817d44b);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES", () => $425fbadb5891ec48$export$3d575bdf28c0d17c);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES", () => $425fbadb5891ec48$export$af84baced6970a17);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES", () => $425fbadb5891ec48$export$c767f253046b1ea7);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES", () => $425fbadb5891ec48$export$265b9384cc2dfbd4);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES", () => $425fbadb5891ec48$export$2de77b357e71c7a7);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES", () => $425fbadb5891ec48$export$7de7abb92169d6c);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES", () => $425fbadb5891ec48$export$fd7df8bd7600c65c);
$parcel$export(module.exports, "REPORTS_IDS", () => $425fbadb5891ec48$export$1f70a76cb421b107);
$parcel$export(module.exports, "SIDEBAR_EXPERIENCE", () => $425fbadb5891ec48$export$71aaf2625ee54d10);
$parcel$export(module.exports, "staticLegacyIds", () => $425fbadb5891ec48$export$f57650e6e7be03dc);
const $425fbadb5891ec48$export$399c7e6858236b4 = 'source.code.link';
const $425fbadb5891ec48$export$58125ce2bb1c3378 = 'project.shortcut.default.link';
const $425fbadb5891ec48$export$c79ed2783644934c = /^(?:[\u2600-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?)*/;
const $425fbadb5891ec48$export$25ae65041c800c9 = 'pin-filter-myopenissues';
const $425fbadb5891ec48$export$e03c9beea817d44b = 'pin-filter-reportedbyme';
const $425fbadb5891ec48$export$3d575bdf28c0d17c = 'pin-filter-allissues';
const $425fbadb5891ec48$export$af84baced6970a17 = 'pin-filter-allopenissues';
const $425fbadb5891ec48$export$c767f253046b1ea7 = 'pin-filter-doneissues';
const $425fbadb5891ec48$export$265b9384cc2dfbd4 = 'pin-filter-recentlyviewed';
const $425fbadb5891ec48$export$2de77b357e71c7a7 = 'pin-filter-addedrecently';
const $425fbadb5891ec48$export$7de7abb92169d6c = 'pin-filter-resolvedrecently';
const $425fbadb5891ec48$export$fd7df8bd7600c65c = 'pin-filter-updatedrecently';
const $425fbadb5891ec48$export$1f70a76cb421b107 = {
    REPORTS_ADDONS: 'sd-reports-addons'
};
const $425fbadb5891ec48$export$83016cff6318a5dd = Object.freeze({
    CODE_TAB: 'CODE_TAB',
    ONCALL_TAB: 'ONCALL_TAB',
    PAGES_TAB: 'PAGES_TAB'
});
const $425fbadb5891ec48$export$f371b4c263b142af = {
    [$425fbadb5891ec48$export$83016cff6318a5dd.CODE_TAB]: 'code',
    [$425fbadb5891ec48$export$83016cff6318a5dd.ONCALL_TAB]: 'opsgenie',
    [$425fbadb5891ec48$export$83016cff6318a5dd.PAGES_TAB]: 'pages'
};
const $425fbadb5891ec48$export$b66c40cadee12a0b = 'project/agility/index';
const $425fbadb5891ec48$export$6f454e69bce3a691 = 'project/business/index';
const $425fbadb5891ec48$export$3a0f7f7a8a0b306b = 'project/ops/index';
const $425fbadb5891ec48$export$1346c9aa3cbb477d = 'project/software/index';
const $425fbadb5891ec48$export$4598dd67943205cf = 'project/software/issues';
const $425fbadb5891ec48$export$8f36e85c5afae5 = 'project/software/reports';
const $425fbadb5891ec48$export$8151e5564c0016a1 = 'attachments';
const $425fbadb5891ec48$export$4acd0d06a25e56b5 = 'eventtypes';
const $425fbadb5891ec48$export$211ab01804585e09 = 'webhooks-admin';
const $425fbadb5891ec48$export$294b9ab8545a9f36 = 'services';
const $425fbadb5891ec48$export$665efe695022359b = 'greenhopper-lexorank-manage';
const $425fbadb5891ec48$export$47fbefc73055eb9d = 'admin-helper-admin-section';
const $425fbadb5891ec48$export$76e6bd729450de52 = 'advanced_section';
const $425fbadb5891ec48$export$ac928a90c0d3daa8 = 'collectors';
const $425fbadb5891ec48$export$309ac0136b7d5dfa = 'dark_features';
const $425fbadb5891ec48$export$998f1706a6ca29b = 'general_configuration';
const $425fbadb5891ec48$export$e9af81a594543847 = 'import_export_section';
const $425fbadb5891ec48$export$bbf19cc23216c6b = 'mail_section';
const $425fbadb5891ec48$export$693dd06b18660b78 = 'security_section';
const $425fbadb5891ec48$export$c6d1221ea0bce75e = 'shared_section';
const $425fbadb5891ec48$export$c7d7c0d436dd54b1 = 'troubleshooting_and_support';
const $425fbadb5891ec48$export$af156d8e27fc5458 = 'user_interface';
const $425fbadb5891ec48$export$71aaf2625ee54d10 = 'viewSidebarNavigation';
const $425fbadb5891ec48$export$f57650e6e7be03dc = [
    // Global Settings Static Legacy Ids
    'general_configuration',
    'dark_features',
    'troubleshooting_and_support',
    'view_auditing',
    'pluginViewer',
    'pluginViewer',
    'system_info',
    'integrity_checker',
    'logging_profiling',
    'scheduler_details',
    'security_section',
    'project_role_browser',
    'global_permissions',
    'collectors',
    'user_interface',
    'user_defaults',
    'edit_default_dashboard',
    'lookandfeel',
    'com.atlassian.pas:pas-admin-link-jira',
    'import_export_section',
    'vertigo_export',
    'external_import',
    'vertigo_import',
    'vertigo_import_jira_cloud',
    'vertigo_import_jira_server',
    'mail_section',
    'global_mail_settings',
    'outgoing_mail',
    'incoming_mail',
    'send_email',
    'admin-helper-admin-section',
    'permissionhelper-admin-page',
    'notificationhelper-admin-page',
    'shared_section',
    'shared_filters',
    'shared_dashboards',
    'advanced_section',
    'attachments',
    'eventtypes',
    'webhooks-admin',
    'services',
    'manage_dashboards',
    'manage_filters',
    'greenhopper-lexorank-manage',
    // Project Settings Static Legacy Ids
    'jira.webfragments.view.project.operations:edit_project',
    'com.atlassian.jira.jira-project-config-plugin:users-and-roles',
    'com.atlassian.jira.jira-project-config-plugin:view_project_summary',
    'com.atlassian.jira.jira-project-config-plugin:view_delete_project',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuetypes',
    'com.atlassian.jira.jira-project-config-plugin:view_project_workflows',
    'com.atlassian.jira.jira-project-config-plugin:view_project_screens',
    'com.atlassian.jira.jira-project-config-plugin:view_project_fields',
    'com.atlassian.jira.jira-projects-plugin:administer_project_versions',
    'com.atlassian.jira.jira-projects-plugin:administer_project_components',
    'com.atlassian.jira.jira-project-config-plugin:view_project_permissions',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuesecurity',
    'com.atlassian.jira.jira-project-config-plugin:view_project_notifications',
    'com.atlassian.jira.jira-project-config-plugin:project-opsgenie-association',
    'com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:view_issue_collectors',
    'com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-admin-page-link',
    'com.atlassian.plugins.atlassian-connect-plugin:com.codebarrel.addons.automation__cb-automation-project-config',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuelayout',
    'com.atlassian.jira.jira-projects-plugin:administer_project_code',
    'com.atlassian.jira.jira-projects-plugin:administer_project_deployments',
    'com.atlassian.servicedesk.project-ui:sd-project-change-management-item',
    'com.atlassian.servicedesk.project-ui:sd-project-features-item',
    'com.atlassian.servicedesk.project-ui:sd-project-request-types-item',
    'com.atlassian.servicedesk.project-ui:sd-project-customer-permissions-item',
    'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-project-language-support-settings-item-adg3',
    'com.atlassian.servicedesk.project-ui:sd-project-portal-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-email-settings-item',
    'com.atlassian.servicedesk.servicedesk-notifications-plugin:sd-project-outgoing-email-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-widget-addon-installer-item',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded__settings',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded-dev__settings',
    'com.atlassian.servicedesk.project-ui:sd-project-assets-ad-item',
    'com.atlassian.servicedesk.project-ui:sd-project-feedback-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-confluence-kb-item',
    'com.atlassian.servicedesk.project-ui:sd-project-sla-item',
    'com.atlassian.servicedesk.project-ui:sd-project-automation-item',
    'com.atlassian.servicedesk.project-ui:sd-project-app-discovery-item',
    'com.atlassian.servicedesk.project-ui:sd-project-incident-management-item',
    'com.atlassian.servicedesk.project-ui:sd-project-itsm-features-item',
    'com.atlassian.servicedesk.project-ui:sd-project-external-links-item',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.atlas.jira__goals-project-page',
    // Automation connect item
    'com.codebarrel.addons.automation__cb-automation'
];

});


parcelRegister("bdfGI", function(module, exports) {

$parcel$export(module.exports, "SidebarSelector", () => $33aa06698882b6b7$export$7937e2d32a777fcb);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $exb0h = parcelRequire("exb0h");

var $cPEpP = parcelRequire("cPEpP");

var $30nBW = parcelRequire("30nBW");

var $iVoJB = parcelRequire("iVoJB");
var $cNUtn = parcelRequire("cNUtn");

var $6uTFc = parcelRequire("6uTFc");
var $8BmAi = parcelRequire("8BmAi");

var $jUSZE = parcelRequire("jUSZE");

var $b1smH = parcelRequire("b1smH");
var $egWoV = parcelRequire("egWoV");

var $dK8ba = parcelRequire("dK8ba");
var $j49Zn = parcelRequire("j49Zn");

var $6DM93 = parcelRequire("6DM93");
var $hTzlz = parcelRequire("hTzlz");

var $415Xh = parcelRequire("415Xh");

var $lWmpu = parcelRequire("lWmpu");

var $i2U8X = parcelRequire("i2U8X");

var $cCJ93 = parcelRequire("cCJ93");

var $74xkZ = parcelRequire("74xkZ");

var $jn4gC = parcelRequire("jn4gC");

var $10fdS = parcelRequire("10fdS");
var $kJlBc = parcelRequire("kJlBc");

var $k3rbG = parcelRequire("k3rbG");
const $33aa06698882b6b7$var$ProjectSettingsSidebarSelector = ()=>{
    const { data: project, loading: loading, error: error } = (0, $cPEpP.useProject)();
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lWmpu.Skeleton), null);
    if (project?.type === (0, $7ZZxN.CORE_PROJECT)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $415Xh.default), null);
    if (project?.type === (0, $7ZZxN.SOFTWARE_PROJECT)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $74xkZ.default), null);
    if (project?.type === (0, $7ZZxN.SERVICE_DESK_PROJECT)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k3rbG.JsmProjectSettingsSidebarSelector), {
        project: project
    });
    if (error) throw error;
    throw new Error(`No project settings sidebar found for the project type: ${project?.type}`);
};
const $33aa06698882b6b7$var$InternalSidebarSelector = ()=>{
    const route = (0, $10fdS.useCurrentRoute)();
    const [section] = (0, $kJlBc.usePathParam)('section');
    const { saveCurrentRoute: saveCurrentRoute } = (0, $30nBW.useNavigateBack)();
    // Project settings sidebars
    if (route.group === (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $74xkZ.default), null);
    if (route.group === (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_CORE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $415Xh.default), null);
    if (route.name === (0, $exb0h.ROUTE_NAMES).POLARIS_IDEAS && section === 'settings') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cCJ93.default), null);
    if ((0, $i2U8X.PROJECT_SETTINGS_ROUTE_NAMES).has(route.name) || route.group === (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($33aa06698882b6b7$var$ProjectSettingsSidebarSelector, null);
    // Global settings sidebars
    if ((0, $egWoV.PROJECTS_SETTINGS_ROUTE_NAMES).has(route.name)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b1smH.default), null);
    if ((0, $8BmAi.ISSUES_SETTINGS_ROUTE_NAMES).has(route.name)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6uTFc.default), null);
    if ((0, $iVoJB.APPS_SETTINGS_ROUTE_NAMES).has(route.name)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cNUtn.default), null);
    if (route.name === (0, $exb0h.ROUTE_NAMES).PRODUCTS_JSW_CONFIGURATION) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jUSZE.default), null);
    if ((0, $j49Zn.SYSTEM_SETTINGS_ROUTE_NAMES).has(route.name)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dK8ba.default), null);
    // Plan settings sidebars
    if ((0, $hTzlz.PLAN_SETTINGS_ROUTE_NAMES).has(route.name)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6DM93.default), null);
    // Default sidebar
    // the route to navigate back to will be whichever route was last displayed
    // with the default sidebar on
    saveCurrentRoute();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jn4gC.default), null);
};
const $33aa06698882b6b7$export$7937e2d32a777fcb = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $30nBW.NavigateBackProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($33aa06698882b6b7$var$InternalSidebarSelector, null));

});
parcelRegister("30nBW", function(module, exports) {

$parcel$export(module.exports, "useNavigateBack", () => $ae320a76d30e50fc$export$7ce1f551d78f9130);
$parcel$export(module.exports, "NavigateBackProvider", () => $ae320a76d30e50fc$export$e1e76f4ee7f8174d);

var $eUqFw = parcelRequire("eUqFw");

var $kJlBc = parcelRequire("kJlBc");

var $g08Zs = parcelRequire("g08Zs");

var $cBhRY = parcelRequire("cBhRY");
const $ae320a76d30e50fc$var$STORAGE_KEY = 'back-button-url';
const $ae320a76d30e50fc$var$NavigateBackContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $ae320a76d30e50fc$export$7ce1f551d78f9130 = ()=>{
    const context = (0, $eUqFw.useContext)($ae320a76d30e50fc$var$NavigateBackContext);
    if (!context) throw new Error('useNavigateBack must be used within a NavigateBackProvider');
    return context;
};
const $ae320a76d30e50fc$export$e1e76f4ee7f8174d = ({ children: children })=>{
    const { push: push } = (0, $kJlBc.useRouterActions)();
    const [previousUrl, setPreviousUrl] = (0, $eUqFw.useState)(()=>(0, $cBhRY.storageProvider).get($ae320a76d30e50fc$var$STORAGE_KEY));
    const saveCurrentRoute = (0, $eUqFw.useCallback)(()=>{
        const url = `${window.location.pathname}${window.location.search}${window.location.hash}`;
        setPreviousUrl(url);
        (0, $cBhRY.storageProvider).set($ae320a76d30e50fc$var$STORAGE_KEY, url);
    }, []);
    const goBack = (0, $eUqFw.useCallback)(()=>push(previousUrl ?? (0, $g08Zs.jiraHomeRoute).path), [
        previousUrl,
        push
    ]);
    const value = (0, $eUqFw.useMemo)(()=>({
            saveCurrentRoute: saveCurrentRoute,
            goBack: goBack
        }), [
        saveCurrentRoute,
        goBack
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ae320a76d30e50fc$var$NavigateBackContext.Provider, {
        value: value
    }, children);
};

});
parcelRegister("g08Zs", function(module, exports) {

$parcel$export(module.exports, "jiraHomeRoute", () => $6e7a6dff76357b07$export$11ebbd6d4e57759c);

var $exb0h = parcelRequire("exb0h");
const $6e7a6dff76357b07$export$11ebbd6d4e57759c = {
    group: (0, $exb0h.ROUTE_GROUPS).HOME,
    name: (0, $exb0h.ROUTE_NAMES).YOUR_WORK,
    path: '/jira/your-work'
};

});

parcelRegister("cBhRY", function(module, exports) {

$parcel$export(module.exports, "storageProvider", () => $3d5ff13f6c0455c4$export$ce7751641b93537d);

var $89bO2 = parcelRequire("89bO2");
const $3d5ff13f6c0455c4$export$ce7751641b93537d = (0, $89bO2.createSessionStorageProvider)('sidebar-navigation');

});


parcelRegister("iVoJB", function(module, exports) {

$parcel$export(module.exports, "APPS_SETTINGS_ROUTE_NAMES", () => $ec7b14633b58bde4$export$69643c84bff497c);

var $exb0h = parcelRequire("exb0h");
const $ec7b14633b58bde4$export$69643c84bff497c = new Set([
    (0, $exb0h.ROUTE_NAMES).MARKETPLACE_INDEX,
    (0, $exb0h.ROUTE_NAMES).MARKETPLACE_ADDONS_EMCEE,
    (0, $exb0h.ROUTE_NAMES).MARKETPLACE_ADDONS_EMCEE_PUBLIC,
    (0, $exb0h.ROUTE_NAMES).MARKETPLACE_MANAGE_APPS,
    (0, $exb0h.ROUTE_NAMES).SETTINGS_OAUTH_CREDENTIALS
]);

});

parcelRegister("cNUtn", function(module, exports) {

$parcel$export(module.exports, "default", () => $450d8f5a1058d6df$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $48TMA = parcelRequire("48TMA");

var $kmqH4 = parcelRequire("kmqH4");

var $gGtKh = parcelRequire("gGtKh");

var $jK1pm = parcelRequire("jK1pm");

const $450d8f5a1058d6df$var$LazySidebarContent = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("8ewiU")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/global-settings/apps-settings/src/ui/main.tsx"
});
const $450d8f5a1058d6df$var$AsyncSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "nav4.sidebar.global-settings.apps-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsAppsSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "nav4.sidebar.global-settings.apps-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $48TMA.SidebarContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "nav4.sidebar.global-settings.apps-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kmqH4.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($450d8f5a1058d6df$var$LazySidebarContent, null)))));
var $450d8f5a1058d6df$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($450d8f5a1058d6df$var$AsyncSidebar);

});
parcelRegister("48TMA", function(module, exports) {

$parcel$export(module.exports, "SidebarContainer", () => $0f2d4b2633604022$export$f39f3f768bc98e3d);

var $eUqFw = parcelRequire("eUqFw");

var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $1GeZ8 = parcelRequire("1GeZ8");

var $b5l09 = parcelRequire("b5l09");
const $0f2d4b2633604022$export$f39f3f768bc98e3d = ({ children: children })=>{
    const collapsedState = (0, $b5l09.useSideNavCollapsedState)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1GeZ8.LeftSidebar), {
        collapsedState: collapsedState ? 'collapsed' : 'expanded'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200",
        xcss: $0f2d4b2633604022$var$containerStyles
    }, children));
};
const $0f2d4b2633604022$var$containerStyles = (0, $1ZAYh.xcss)({
    height: '100%',
    padding: 'space.200'
});

});

parcelRegister("kmqH4", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $83460c41da3aeb0c$export$8f31e4c4a37b8e9c);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");
const $83460c41da3aeb0c$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $83460c41da3aeb0c$var$backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $83460c41da3aeb0c$var$headingSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $83460c41da3aeb0c$var$sectionHeading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $83460c41da3aeb0c$var$menuItem
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $83460c41da3aeb0c$var$sectionHeading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $83460c41da3aeb0c$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $83460c41da3aeb0c$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $83460c41da3aeb0c$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $83460c41da3aeb0c$var$sectionHeading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $83460c41da3aeb0c$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $83460c41da3aeb0c$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $83460c41da3aeb0c$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $83460c41da3aeb0c$var$menuItem
    })));
const $83460c41da3aeb0c$var$backButton = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100'
});
const $83460c41da3aeb0c$var$headingSkeleton = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100',
    flex: 1
});
const $83460c41da3aeb0c$var$sectionHeading = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.skeleton',
    width: '50%',
    height: "var(--ds-space-200, 16px)",
    borderRadius: 'border.radius.100',
    marginTop: 'space.100'
});
const $83460c41da3aeb0c$var$menuItem = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100'
});

});

parcelRegister("8ewiU", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('9N2jq')
        ]);
        const value = parcelRequire('lwpyX');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("9N2jq")
    ]).then(()=>parcelRequire('lwpyX'));
}

});


parcelRegister("6uTFc", function(module, exports) {

$parcel$export(module.exports, "default", () => $037bec648f190a6a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $48TMA = parcelRequire("48TMA");

var $kmqH4 = parcelRequire("kmqH4");

var $gGtKh = parcelRequire("gGtKh");

var $jK1pm = parcelRequire("jK1pm");

const $037bec648f190a6a$var$LazySidebarContent = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("8MomE")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/global-settings/issues-settings/src/ui/main.tsx"
});
const $037bec648f190a6a$var$AsyncSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "nav4.sidebar.global-settings.issues-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsIssuesSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "nav4.sidebar.global-settings.issues-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $48TMA.SidebarContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "nav4.sidebar.global-settings.issues-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kmqH4.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($037bec648f190a6a$var$LazySidebarContent, null)))));
var $037bec648f190a6a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($037bec648f190a6a$var$AsyncSidebar);

});
parcelRegister("8MomE", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('cIULD')
        ]);
        const value = parcelRequire('1bDxg');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("cIULD")
    ]).then(()=>parcelRequire('1bDxg'));
}

});


parcelRegister("8BmAi", function(module, exports) {

$parcel$export(module.exports, "ISSUES_SETTINGS_ROUTE_NAMES", () => $8405601363650e5c$export$79152b616c3d5876);

var $exb0h = parcelRequire("exb0h");
const $8405601363650e5c$export$79152b616c3d5876 = new Set([
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_CUSTOM_FIELDS,
    (0, $exb0h.ROUTE_NAMES).SETTINGS_CMDB_FIELD_CONFIG,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_FIELD_LAYOUTS,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_FORM_DATA_CONNECTIONS,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_ISSUES_STATUSES,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_ISSUES_RESOLUTIONS,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_ISSUES_PRIORITIES,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_ISSUES_NOTIFICATION_VIEW,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_ISSUE_TIME_TRACKING,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_ISSUES_LINK_TYPES,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_ISSUE_HIERARCHY,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_ISSUE_TYPES,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_ISSUE_SUBTASKS,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_ISSUES_NEW_ISSUE_SEARCH,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_ISSUES_PRIORITIES,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_ISSUES_PRIORITY_SCHEMES,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_ISSUE_WORKFLOW,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_ISSUE_WORKFLOW_SCHEMES
]);

});

parcelRegister("jUSZE", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bdd11dab0008ead$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $48TMA = parcelRequire("48TMA");

var $kmqH4 = parcelRequire("kmqH4");

var $gGtKh = parcelRequire("gGtKh");

var $jK1pm = parcelRequire("jK1pm");

const $3bdd11dab0008ead$var$LazySidebarContent = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("l6fQ3")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/global-settings/products-settings/src/ui/main.tsx"
});
const $3bdd11dab0008ead$var$AsyncSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "nav4.sidebar.global-settings.products-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsProductsSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "nav4.sidebar.global-settings.products-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $48TMA.SidebarContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "nav4.sidebar.global-settings.products-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kmqH4.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3bdd11dab0008ead$var$LazySidebarContent, null)))));
var $3bdd11dab0008ead$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($3bdd11dab0008ead$var$AsyncSidebar);

});
parcelRegister("l6fQ3", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('6532w')
        ]);
        const value = parcelRequire('6RXDk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("6532w")
    ]).then(()=>parcelRequire('6RXDk'));
}

});


parcelRegister("b1smH", function(module, exports) {

$parcel$export(module.exports, "default", () => $14a260a654d0c9c3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $48TMA = parcelRequire("48TMA");

var $kmqH4 = parcelRequire("kmqH4");

var $gGtKh = parcelRequire("gGtKh");

var $jK1pm = parcelRequire("jK1pm");

const $14a260a654d0c9c3$var$LazySidebarContent = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("lajZV")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/global-settings/projects-settings/src/ui/main.tsx"
});
const $14a260a654d0c9c3$var$AsyncSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "nav4.sidebar.global-settings.projects-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsProjectsSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "nav4.sidebar.global-settings.projects-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $48TMA.SidebarContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "nav4.sidebar.global-settings.projects-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kmqH4.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($14a260a654d0c9c3$var$LazySidebarContent, null)))));
var $14a260a654d0c9c3$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($14a260a654d0c9c3$var$AsyncSidebar);

});
parcelRegister("lajZV", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('koxSA')
        ]);
        const value = parcelRequire('hsoFI');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("koxSA")
    ]).then(()=>parcelRequire('hsoFI'));
}

});


parcelRegister("egWoV", function(module, exports) {

$parcel$export(module.exports, "PROJECTS_SETTINGS_ROUTE_NAMES", () => $06cd39bc0a93671f$export$23fb8921290234cc);

var $exb0h = parcelRequire("exb0h");
const $06cd39bc0a93671f$export$23fb8921290234cc = new Set([
    (0, $exb0h.ROUTE_NAMES).ARCHIVED_PROJECTS_DIRECTORY,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_PROJECTS_CATEGORIES_VIEW,
    (0, $exb0h.ROUTE_NAMES).PROJECTS_DIRECTORY_LEGACY_PATH_SPA,
    (0, $exb0h.ROUTE_NAMES).PROJECTS_DIRECTORY_MANAGE,
    (0, $exb0h.ROUTE_NAMES).TRASH_PROJECTS_DIRECTORY
]);

});

parcelRegister("dK8ba", function(module, exports) {

$parcel$export(module.exports, "default", () => $b09c93d97b4536ca$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $48TMA = parcelRequire("48TMA");

var $kmqH4 = parcelRequire("kmqH4");

var $gGtKh = parcelRequire("gGtKh");

var $jK1pm = parcelRequire("jK1pm");

const $b09c93d97b4536ca$var$LazySidebarContent = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("6JDQ5")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/global-settings/system-settings/src/ui/main.tsx"
});
const $b09c93d97b4536ca$var$AsyncSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "nav4.sidebar.global-settings.system-settings",
        packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsSystemSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "nav4.sidebar.global-settings.system-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $48TMA.SidebarContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "nav4.sidebar.global-settings.system-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kmqH4.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b09c93d97b4536ca$var$LazySidebarContent, null)))));
var $b09c93d97b4536ca$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($b09c93d97b4536ca$var$AsyncSidebar);

});
parcelRegister("6JDQ5", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('iRX6Y')
        ]);
        const value = parcelRequire('cgx95');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("iRX6Y")
    ]).then(()=>parcelRequire('cgx95'));
}

});


parcelRegister("j49Zn", function(module, exports) {

$parcel$export(module.exports, "SYSTEM_SETTINGS_ROUTE_NAMES", () => $b069704b3b05315e$export$d8a263d730154c3f);

var $exb0h = parcelRequire("exb0h");
const $b069704b3b05315e$export$d8a263d730154c3f = new Set([
    (0, $exb0h.ROUTE_NAMES).EXTERNAL_IMPORT,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_ADMIN_HELPER_EMAIL_NOTIFICATIONS_LOG,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_GLOBAL_PERMISSIONS,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_MIGRATIONS_DASHBOARD,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_MIGRATIONS_HOME,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_PERFORMANCE_METRIC_DETAIL,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_SHARED_DASHBOARDS,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_SYSTEM_ADMIN_PERMISSION_HELPER,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_SYSTEM_ADMIN_NOTIFICATION_HELPER,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_SYSTEM_ADVANCED_ATTACHMENTS,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_SYSTEM_ADVANCED_LEXORANK_MANAGEMENT,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_SYSTEM_ADVANCED_SERVICES,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_SYSTEM_ADVANCED_WEBHOOKS,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_BACKUP_MANAGER,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_CLOUD_OR_SERVER_IMPORT,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_SYSTEM_ISSUE_COLLECTORS,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_SYSTEM_MAIL_GLOBAL_MAIL_SETTINGS,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_SYSTEM_MAIL_INCOMING_MAIL,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_SYSTEM_MAIL_OUTGOING_MAIL,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_SYSTEM_MAIL_SEND_MAIL,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_SYSTEM_SECURITY_GLOBAL_PERMISSIONS_OLD,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_SYSTEM_SHARED_FILTERS,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_SYSTEM_TROUBLESHOOTING_AUDIT_LOG,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_SYSTEM_UI_ANNOUNCEMENT_BANNER,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_SYSTEM_UI_LOOK_AND_FEEL,
    (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_SYSTEM_UI_USER_DEFAULTS,
    (0, $exb0h.ROUTE_NAMES).SETTINGS_AUTOMATION,
    (0, $exb0h.ROUTE_NAMES).SYSTEM_CONFIGURATION,
    (0, $exb0h.ROUTE_NAMES).SYSTEM_DASHBOARD_EDIT
]);

});

parcelRegister("6DM93", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b6bf3c085c37346$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $48TMA = parcelRequire("48TMA");

var $kmqH4 = parcelRequire("kmqH4");

var $gGtKh = parcelRequire("gGtKh");

const $9b6bf3c085c37346$var$LazyPlanSettingsSidebar = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("5k9N5")).then(({ PlanSettingsSidebar: PlanSettingsSidebar })=>PlanSettingsSidebar), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/plan-settings/src/ui/main.tsx"
});
const $9b6bf3c085c37346$var$AsyncSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "asyncSidebarPlanSettings",
        packageName: "jiraNavigationAppsSidebarNav4PlanSettings",
        teamName: "otter"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $48TMA.SidebarContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "asyncSidebarPlanSettings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kmqH4.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9b6bf3c085c37346$var$LazyPlanSettingsSidebar, null))));
var $9b6bf3c085c37346$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($9b6bf3c085c37346$var$AsyncSidebar);

});
parcelRegister("5k9N5", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('i5Fwo')
        ]);
        const value = parcelRequire('6JPBu');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("i5Fwo")
    ]).then(()=>parcelRequire('6JPBu'));
}

});


parcelRegister("hTzlz", function(module, exports) {

$parcel$export(module.exports, "PLAN_SETTINGS_ROUTE_NAMES", () => $6bdb888d33b785c8$export$ecc96e9604060082);

var $exb0h = parcelRequire("exb0h");
const $6bdb888d33b785c8$export$ecc96e9604060082 = new Set([
    (0, $exb0h.ROUTE_NAMES).SOFTWARE_PLAN_SETTINGS_AUTO_SCHEDULER,
    (0, $exb0h.ROUTE_NAMES).SOFTWARE_PLAN_SETTINGS_CUSTOM_FIELDS,
    (0, $exb0h.ROUTE_NAMES).SOFTWARE_PLAN_SETTINGS_EXCLUSION_RULES,
    (0, $exb0h.ROUTE_NAMES).SOFTWARE_PLAN_SETTINGS_FIND_YOUR_ISSUE,
    (0, $exb0h.ROUTE_NAMES).SOFTWARE_PLAN_SETTINGS_ISSUE_SOURCES,
    (0, $exb0h.ROUTE_NAMES).SOFTWARE_PLAN_SETTINGS_PERMISSIONS,
    (0, $exb0h.ROUTE_NAMES).SOFTWARE_PLAN_SETTINGS_PLAN_INFO,
    (0, $exb0h.ROUTE_NAMES).SOFTWARE_PLAN_SETTINGS_PROGRAM_BOARDS,
    (0, $exb0h.ROUTE_NAMES).SOFTWARE_PLAN_SETTINGS_REMOVED_ISSUES,
    (0, $exb0h.ROUTE_NAMES).SOFTWARE_PLAN_SETTINGS_SAVED_VIEWS,
    (0, $exb0h.ROUTE_NAMES).SOFTWARE_PLAN_SETTINGS_SCENARIOS,
    (0, $exb0h.ROUTE_NAMES).SOFTWARE_PLAN_SETTINGS_SCHEDULING
]);

});

parcelRegister("415Xh", function(module, exports) {

$parcel$export(module.exports, "default", () => $f312bfcce4cb8481$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $48TMA = parcelRequire("48TMA");

var $lWmpu = parcelRequire("lWmpu");

var $gGtKh = parcelRequire("gGtKh");

var $jK1pm = parcelRequire("jK1pm");

const $f312bfcce4cb8481$var$LazySidebarContent = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("9ozzb")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/project-settings/business-project-settings/src/ui/main.tsx"
});
const $f312bfcce4cb8481$var$AsyncSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "nav4.sidebar.project-settings.business-settings",
        packageName: "jiraNavigationAppsSidebarNav4ProjectSettingsBusinessSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "nav4.sidebar.project-settings.business-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $48TMA.SidebarContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "nav4.sidebar.project-settings.business-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lWmpu.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f312bfcce4cb8481$var$LazySidebarContent, null)))));
var $f312bfcce4cb8481$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($f312bfcce4cb8481$var$AsyncSidebar);

});
parcelRegister("lWmpu", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $654b8fa168689c64$export$8f31e4c4a37b8e9c);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $27KYr = parcelRequire("27KYr");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");
const $654b8fa168689c64$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27KYr.default), {
        columnGap: "space.100",
        rowGap: "space.050",
        alignItems: "center",
        templateAreas: [
            'avatar name',
            'avatar type'
        ],
        templateColumns: "min-content 1fr",
        xcss: $654b8fa168689c64$var$projectHeading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $654b8fa168689c64$var$projectAvatar,
        style: {
            gridArea: 'avatar'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $654b8fa168689c64$var$projectName,
        style: {
            gridArea: 'name'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $654b8fa168689c64$var$projectType,
        style: {
            gridArea: 'type'
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $654b8fa168689c64$var$backButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $654b8fa168689c64$var$headingSkeleton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100",
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $654b8fa168689c64$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $654b8fa168689c64$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $654b8fa168689c64$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $654b8fa168689c64$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $654b8fa168689c64$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $654b8fa168689c64$var$menuItem
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $654b8fa168689c64$var$menuItem
    })));
const $654b8fa168689c64$var$backButton = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100'
});
const $654b8fa168689c64$var$headingSkeleton = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100',
    flex: 1
});
const $654b8fa168689c64$var$projectHeading = (0, $1ZAYh.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.100'
});
const $654b8fa168689c64$var$projectAvatar = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.skeleton',
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.100'
});
const $654b8fa168689c64$var$projectName = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-200, 16px)",
    borderRadius: 'border.radius.100'
});
const $654b8fa168689c64$var$projectType = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-100, 8px)",
    borderRadius: 'border.radius.100'
});
const $654b8fa168689c64$var$menuItem = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100'
});

});

parcelRegister("9ozzb", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('bzXk1')
        ]);
        const value = parcelRequire('6RwBj');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("bzXk1")
    ]).then(()=>parcelRequire('6RwBj'));
}

});


parcelRegister("i2U8X", function(module, exports) {

$parcel$export(module.exports, "PROJECT_SETTINGS_ROUTE_NAMES", () => $4bf27e77e236c402$export$283c898452978749);

var $exb0h = parcelRequire("exb0h");
const $4bf27e77e236c402$export$283c898452978749 = new Set([
    (0, $exb0h.ROUTE_NAMES).CLASSIC_PROJECT_SETTINGS_CORE_PROFORMA_FORMS,
    (0, $exb0h.ROUTE_NAMES).CLASSIC_PROJECT_SETTINGS_ISSUE_LAYOUT,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_EDIT,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_CONFIG,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_DATA_CLASSIFICATIONS,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_FIELDS,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_ISSUE_LAYOUT,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_ISSUE_TYPES,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_NOTIFICATIONS,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_OPSGENIE,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_PERMISSIONS,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_SCREENS,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_SUMMARY,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_WORKFLOWS,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_COLLECTORS,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_PEOPLE,
    (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_AUTOMATION,
    (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_VERSIONS,
    (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_COMPONENTS,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_DEV
]);

});

parcelRegister("cCJ93", function(module, exports) {

$parcel$export(module.exports, "default", () => $b388d90f39d47d5b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $48TMA = parcelRequire("48TMA");

var $lWmpu = parcelRequire("lWmpu");

var $gGtKh = parcelRequire("gGtKh");

var $jK1pm = parcelRequire("jK1pm");

const $b388d90f39d47d5b$var$LazySidebarContent = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("5dCLa")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/project-settings/jpd-project-settings/src/ui/main.tsx"
});
const $b388d90f39d47d5b$var$AsyncSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "nav4.sidebar.project-settings.jpd-settings",
        packageName: "jiraNavigationAppsSidebarNav4ProjectSettingsJpdSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "nav4.sidebar.project-settings.jpd-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $48TMA.SidebarContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "nav4.sidebar.project-settings.jpd-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lWmpu.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b388d90f39d47d5b$var$LazySidebarContent, null)))));
var $b388d90f39d47d5b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($b388d90f39d47d5b$var$AsyncSidebar);

});
parcelRegister("5dCLa", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('56kiA')
        ]);
        const value = parcelRequire('38cRp');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("56kiA")
    ]).then(()=>parcelRequire('38cRp'));
}

});


parcelRegister("74xkZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d434e364eeb5a664$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $48TMA = parcelRequire("48TMA");

var $lWmpu = parcelRequire("lWmpu");

var $gGtKh = parcelRequire("gGtKh");

var $jK1pm = parcelRequire("jK1pm");

const $d434e364eeb5a664$var$LazySidebarContent = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("gwX6E")), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/project-settings/software-project-settings/src/ui/main.tsx"
});
const $d434e364eeb5a664$var$AsyncSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "nav4.sidebar.project-settings.software-settings",
        packageName: "jiraNavigationAppsSidebarNav4ProjectSettingsSoftwareSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "nav4.sidebar.project-settings.software-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $48TMA.SidebarContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "nav4.sidebar.project-settings.software-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lWmpu.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d434e364eeb5a664$var$LazySidebarContent, null)))));
var $d434e364eeb5a664$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($d434e364eeb5a664$var$AsyncSidebar);

});
parcelRegister("gwX6E", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('5VeXO')
        ]);
        const value = parcelRequire('4LBhk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("5VeXO")
    ]).then(()=>parcelRequire('4LBhk'));
}

});


parcelRegister("jn4gC", function(module, exports) {

$parcel$export(module.exports, "default", () => $09e9e174d830d213$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

const $09e9e174d830d213$var$LazySidebarContent = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("dWalW")).then(({ SidebarContent: SidebarContent })=>SidebarContent), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebar-content/src/index.tsx"
});
const $09e9e174d830d213$var$AsyncSidebarContent = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "asyncSidebarContent",
        packageName: "jiraNavigationAppsSidebarNav4SidebarContent",
        teamName: "jira-cosmos"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "lazySidebarContent"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($09e9e174d830d213$var$LazySidebarContent, null))));
$09e9e174d830d213$var$AsyncSidebarContent.displayName = 'AsyncSidebarContent';
var // Used in jira/src/packages/page-container-v2/src/common/ui/sidebar
$09e9e174d830d213$export$2e2bcd8739ae039 = $09e9e174d830d213$var$AsyncSidebarContent;

});
parcelRegister("dWalW", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('5TdXG')
        ]);
        const value = parcelRequire('7gn5w');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("5TdXG")
    ]).then(()=>parcelRequire('7gn5w'));
}

});


parcelRegister("k3rbG", function(module, exports) {

$parcel$export(module.exports, "JsmProjectSettingsSidebarSelector", () => $f6665f0d03c81ab0$export$2bf593de65cce014);

var $eUqFw = parcelRequire("eUqFw");

var $6cv5X = parcelRequire("6cv5X");

var $fGNgi = parcelRequire("fGNgi");
const $f6665f0d03c81ab0$export$2bf593de65cce014 = ({ project: project })=>project.isSimplified ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fGNgi.AsyncJsmTmpProjectSettingsSidebar), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6cv5X.AsyncJsmCmpProjectSettingsSidebar), null);

});
parcelRegister("6cv5X", function(module, exports) {

$parcel$export(module.exports, "AsyncJsmCmpProjectSettingsSidebar", () => $3d1f0cda58e163e2$export$2ce6ad449436c545);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $48TMA = parcelRequire("48TMA");

var $lWmpu = parcelRequire("lWmpu");

var $gGtKh = parcelRequire("gGtKh");

var $jK1pm = parcelRequire("jK1pm");

const $3d1f0cda58e163e2$var$LazySidebarContent = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("fci42")).then(({ JSMCmpProjectSettingsSidebar: JSMCmpProjectSettingsSidebar })=>JSMCmpProjectSettingsSidebar), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/project-settings/jsm-cmp-project-settings/src/main.tsx"
});
const $3d1f0cda58e163e2$export$2ce6ad449436c545 = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "nav4.sidebar.jsm-cmp-project-settings",
        packageName: "jiraNavigationAppsSidebarNav4JsmCmpProjectSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "nav4.sidebar.jsm-cmp-project-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $48TMA.SidebarContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "nav4.sidebar.jsm-cmp-project-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lWmpu.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3d1f0cda58e163e2$var$LazySidebarContent, null))))));

});
parcelRegister("fci42", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('3ZXB6')
        ]);
        const value = parcelRequire('lMLib');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("3ZXB6")
    ]).then(()=>parcelRequire('lMLib'));
}

});


parcelRegister("fGNgi", function(module, exports) {

$parcel$export(module.exports, "AsyncJsmTmpProjectSettingsSidebar", () => $5767d2f1363a3d66$export$dadf0f8c840cb26d);

var $eUqFw = parcelRequire("eUqFw");
const $5767d2f1363a3d66$export$dadf0f8c840cb26d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, "Placeholder: JSM TMP project settings menu Content");

});



parcelRegister("4QXXR", function(module, exports) {

$parcel$export(module.exports, "SidebarSelectorProvider", () => $2fdc1a9dd738acc8$export$6af584355cfb32c6);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $7ZZxN = parcelRequire("7ZZxN");

var $cPEpP = parcelRequire("cPEpP");

var $7Fu43 = parcelRequire("7Fu43");

var $hTlnZ = parcelRequire("hTlnZ");
var $jGUct = parcelRequire("jGUct");
var $1ykEC = parcelRequire("1ykEC");
var $h2JwC = parcelRequire("h2JwC");
var $2jFgb = parcelRequire("2jFgb");
var $fpWGf = parcelRequire("fpWGf");
var $2RJCt = parcelRequire("2RJCt");

var $497qU = parcelRequire("497qU");

var $h2JwC = parcelRequire("h2JwC");

var $buaC1 = parcelRequire("buaC1");

var $6cIOm = parcelRequire("6cIOm");

var $jAMQL = parcelRequire("jAMQL");

var $5w4hM = parcelRequire("5w4hM");

var $hUM03 = parcelRequire("hUM03");

var $bt7QT = parcelRequire("bt7QT");

var $lWODs = parcelRequire("lWODs");

var $iOOlt = parcelRequire("iOOlt");

var $29Nmz = parcelRequire("29Nmz");

var $bSRyW = parcelRequire("bSRyW");

var $iTYGl = parcelRequire("iTYGl");

var $2Fzrk = parcelRequire("2Fzrk");

var $8rBPw = parcelRequire("8rBPw");

var $3HCkE = parcelRequire("3HCkE");

var $aoOGZ = parcelRequire("aoOGZ");
const $2fdc1a9dd738acc8$var$renderProjectSidebar = ({ data: project, loading: loading })=>{
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Fu43.Skeleton), {
        isFull: true
    });
    if (!project) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8rBPw.default), null);
    switch(project.type){
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iTYGl.default), null);
        case 0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bSRyW.default), null);
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            if (project.isSimplified) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iOOlt.default), null);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Fzrk.default), null);
        case 0, $7ZZxN.CORE_PROJECT:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $buaC1.default), null);
        default:
            // TODO: render error
            return null;
    }
};
// Since argument of `renderProjectSidebar` is similar to `props` object of a React component
// so we can convert normal function to functional component
const $2fdc1a9dd738acc8$var$ProjectSidebar = /*#__PURE__*/ (0, $eUqFw.memo)($2fdc1a9dd738acc8$var$renderProjectSidebar, (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD))));
const $2fdc1a9dd738acc8$export$6af584355cfb32c6 = ({ sidebar: sidebar, children: children })=>{
    const projectState = (0, $cPEpP.useProject)();
    const isInsightMenuSelected = (0, $h2JwC.useInsight)();
    const shouldRenderInsightObjectSchemaSidebar = (0, $h2JwC.useInsightObjectSchemaSidebar)();
    const { selected: pSelected, loading: pLoading } = (0, $2jFgb.useProjectConnectItems)();
    const { selected: prSelected, loading: prLoading } = (0, $fpWGf.useProjectReportsConnectItems)();
    const { selected: psSelected, loading: psLoading } = (0, $2RJCt.useProjectSettingsConnectItems)();
    const { selected: gSelected, loading: gLoading } = (0, $hTlnZ.useGlobalConnectItems)();
    const { selected: gsSelected, loading: gsLoading } = (0, $jGUct.useGlobalSettingsConnectItems)();
    const { selected: gssSelected, loading: gssLoading } = (0, $1ykEC.useGlobalSettingsSystemConnectItems)();
    const { data: gresData, loading: gresLoading } = (0, $3HCkE.useResource)((0, $aoOGZ.connectGeneralResources));
    const { sections: fgSections, loading: fgLoading } = (0, $jAMQL.useForgeGlobalPageItems)();
    // CHOOK-247 - move to 'servicedesk-cmdb-object-schema' route in packages/routes/src/ui/spa/servicedesk/cmdb/index.js
    // once new page is rolled out. Hard-coded here since it isn't possible to have the Route navigation.sidebar
    // property change dynamically at runtime.
    if (shouldRenderInsightObjectSchemaSidebar) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lWODs.default), null));
    if (isInsightMenuSelected) // fullscreen connect with no sidebar
    return null;
    if (sidebar === (0, $29Nmz.default)) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29Nmz.default), null));
    if (sidebar === (0, $6cIOm.default)) {
        if (fgLoading) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Fu43.Skeleton), {
            isFull: true
        }));
        if (fgSections?.length) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6cIOm.default), null));
        return children(null);
    }
    if (!Array.isArray(sidebar)) {
        const Sidebar = sidebar;
        return children(Sidebar != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Sidebar, null) : null);
    }
    if (sidebar === (0, $5w4hM.genericConnectSidebars)) {
        const foundInProject = pSelected || prSelected || psSelected || [
            'jiraProjectAdminTabPanels'
        ].includes(gresData?.moduleType);
        const foundSomewhere = foundInProject || gSelected || gsSelected || gssSelected;
        const stillLoading = pLoading || prLoading || psLoading || gLoading || gsLoading || gssLoading || gresLoading;
        if (stillLoading && !foundSomewhere) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Fu43.Skeleton), {
            isFull: true
        }));
        if (foundInProject) {
            const projectSidebar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2fdc1a9dd738acc8$var$ProjectSidebar, projectState);
            return children(projectSidebar);
        }
        if (gSelected) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $497qU.default), null));
        if (gsSelected || [
            'configurePage',
            'postInstallPage'
        ].includes(gresData?.moduleType)) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hUM03.default), null));
        if (gssSelected || [
            'adminPages'
        ].includes(gresData?.moduleType)) return children(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bt7QT.default), null));
        // not found, assume fullscreen connect with no sidebar
        return children(null);
    }
    const projectSidebar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2fdc1a9dd738acc8$var$ProjectSidebar, projectState);
    return children(projectSidebar);
};

});
parcelRegister("7Fu43", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $64b74158f6952660$export$8f31e4c4a37b8e9c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7eyVf = parcelRequire("7eyVf");
var $gLn5u = parcelRequire("gLn5u");

var $84CBi = parcelRequire("84CBi");
const $64b74158f6952660$export$8f31e4c4a37b8e9c = ({ isFull: isFull = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $84CBi.default), {
        name: "sidebar-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64b74158f6952660$var$BackgroundedWrapper, null, isFull && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64b74158f6952660$var$HeadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), {
        hasIcon: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), {
        hasIcon: isFull
    }))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $64b74158f6952660$var$BackgroundedWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1tem _1yt4s5g3",
            __cmplp.className
        ])
    });
});
const $64b74158f6952660$var$HeadingWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41k9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7eyVf", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1046e4bd7e18e79$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8BKky = parcelRequire("8BKky");

var $jvM56 = parcelRequire("jvM56");

var $cgrgx = parcelRequire("cgrgx");
// Type needed on props to extract types with extract react types.
/**
 * __Section__
 *
 * Used to separate items into sections. Using the title prop makes a section
 * implicitly group the items for screen readers with no additional work required.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#section)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $c1046e4bd7e18e79$var$Section = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { shouldRender: shouldRender } = (0, $cgrgx.useShouldNestedElementRender)();
    if (!shouldRender) return props.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        ...props,
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis, @repo/internal/react/no-unsafe-overrides
        overrides: {
            HeadingItem: {
                cssFn: (0, $jvM56.sectionHeaderSpacingStyles)
            }
        }
    });
});
var $c1046e4bd7e18e79$export$2e2bcd8739ae039 = $c1046e4bd7e18e79$var$Section;

});
parcelRegister("jvM56", function(module, exports) {

$parcel$export(module.exports, "overrideStyleFunction", () => $451539d16e759684$export$505cedac1a39aacf);
$parcel$export(module.exports, "baseSideNavItemStyle", () => $451539d16e759684$export$aed216a85ec468ac);
$parcel$export(module.exports, "sectionHeaderSpacingStyles", () => $451539d16e759684$export$a5c27bed78cfecb9);

var $PdmhA = parcelRequire("PdmhA");
const $451539d16e759684$export$505cedac1a39aacf = (baseStyle, newStyle = ()=>({}))=>{
    return (state)=>{
        return [
            baseStyle(state),
            newStyle(state)
        ];
    };
};
const $451539d16e759684$var$defaultStyles = {
    '&:hover': {
        color: `var(--ds-text-subtle, ${(0, $PdmhA.N500)})`,
        backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${(0, $PdmhA.N30)})`
    },
    '&:active': {
        color: `var(--ds-text-subtle, ${(0, $PdmhA.B400)})`,
        backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $PdmhA.B50)})`
    }
};
const $451539d16e759684$var$selectedStyles = {
    backgroundColor: `var(--ds-background-selected, ${(0, $PdmhA.N30)})`,
    color: `var(--ds-text-selected, ${(0, $PdmhA.B400)})`,
    ':visited': {
        color: `var(--ds-text-selected, ${(0, $PdmhA.B400)})`
    },
    '&:hover': {
        backgroundColor: `var(--ds-background-selected-hovered, ${(0, $PdmhA.N30)})`,
        color: `var(--ds-text-selected, ${(0, $PdmhA.N500)})`
    },
    '&:active': {
        backgroundColor: `var(--ds-background-selected-pressed, ${(0, $PdmhA.B50)})`,
        color: `var(--ds-text-selected, ${(0, $PdmhA.B400)})`
    }
};
const $451539d16e759684$export$aed216a85ec468ac = ({ isSelected: isSelected, isDisabled: isDisabled })=>{
    return {
        // This padding is set to ensure that the center of the left icon
        // is approximately center aligned with the horizontal app switcher.
        paddingBlock: "var(--ds-space-100, 8px)",
        paddingInline: "var(--ds-space-100, 8px)",
        borderRadius: "var(--ds-border-radius, 3px)",
        // -- TODO: DELETE THESE COLOR OVERRIDES WHEN CLEANING UP FALLBACK THEMING --
        // Menu and side navigation are now color aligned so they do not need this!
        // See: https://product-fabric.atlassian.net/browse/DSP-1684
        backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
        ...!isDisabled && !isSelected && $451539d16e759684$var$defaultStyles,
        ...!isDisabled && isSelected && $451539d16e759684$var$selectedStyles,
        // -- END TODO --------------------------------------------------------------
        ['& [data-item-elem-before]']: {
            height: '1.5rem',
            width: '1.5rem'
        }
    };
};
const $451539d16e759684$export$a5c27bed78cfecb9 = ()=>{
    return {
        paddingInline: "var(--ds-space-100, 8px)"
    };
};

});

parcelRegister("cgrgx", function(module, exports) {

$parcel$export(module.exports, "NestedContext", () => $859a6debe363fd1f$export$46b2c2071c8c725a);
$parcel$export(module.exports, "useNestedContext", () => $859a6debe363fd1f$export$f24166abe9ed712b);
$parcel$export(module.exports, "useShouldNestedElementRender", () => $859a6debe363fd1f$export$37e8646a1abfc3e6);

var $eUqFw = parcelRequire("eUqFw");
const $859a6debe363fd1f$export$46b2c2071c8c725a = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $859a6debe363fd1f$export$f24166abe9ed712b = ()=>{
    const context = (0, $eUqFw.useContext)($859a6debe363fd1f$export$46b2c2071c8c725a);
    if (!context) {
        let error = '';
        throw new Error(error);
    }
    return context;
};
const $859a6debe363fd1f$export$37e8646a1abfc3e6 = ()=>{
    const context = (0, $eUqFw.useContext)($859a6debe363fd1f$export$46b2c2071c8c725a);
    if (!context) return {
        shouldRender: true
    };
    return {
        shouldRender: context.currentStackId === context.parentId
    };
};

});


parcelRegister("gLn5u", function(module, exports) {

$parcel$export(module.exports, "default", () => $a96e6894a019ef04$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aVkzK = parcelRequire("aVkzK");

var $jvM56 = parcelRequire("jvM56");

var $cgrgx = parcelRequire("cgrgx");
/**
 * __Skeleton item__
 *
 * A skeleton item can be used to reduce the perceived loading time.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#loading)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $a96e6894a019ef04$var$SkeletonItem = (props)=>{
    const { shouldRender: shouldRender } = (0, $cgrgx.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), {
        // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis, @repo/internal/react/no-unsafe-overrides
        cssFn: ()=>({
                ...(0, $jvM56.sectionHeaderSpacingStyles)(),
                // This doubles up & to get a higher specificity as well as to not overwite the base styles.
                '&&::before': {
                    height: '1.5rem',
                    marginRight: "var(--ds-space-200, 16px)",
                    width: '1.5rem'
                }
            }),
        ...props
    });
};
var $a96e6894a019ef04$export$2e2bcd8739ae039 = $a96e6894a019ef04$var$SkeletonItem;

});


parcelRegister("hTlnZ", function(module, exports) {

$parcel$export(module.exports, "useGlobalConnectItems", () => $c8e671af8fdbb6ce$export$ee355b2e42d6462b);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $1ybV0 = parcelRequire("1ybV0");

var $2z5XU = parcelRequire("2z5XU");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");

var $9I91h = parcelRequire("9I91h");
var $g9Ou9 = parcelRequire("g9Ou9");
var $kNXHh = parcelRequire("kNXHh");
// use memoised functions per hook to avoid re-computation between same hooks
const $c8e671af8fdbb6ce$var$getItemsMemo = (0, $5iWql.default)((d)=>(0, $g9Ou9.getLinks)(d, [
        'global-navigation-product'
    ]).map((0, $kNXHh.transformLink)).filter((item)=>item != null && item.items));
const $c8e671af8fdbb6ce$var$findItemAndStackMemo = (0, $5iWql.default)((0, $9I91h.findItemAndStack));
const $c8e671af8fdbb6ce$export$ee355b2e42d6462b = ()=>{
    const [{ route: route, location: location }] = (0, $kJlBc.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $2z5XU.useNavigationGlobalResource)();
    const sidebars = (0, $eUqFw.useMemo)(()=>data && $c8e671af8fdbb6ce$var$getItemsMemo(data), [
        data
    ]);
    if ((0, $1ybV0.ff)('small-temporary-analytic-for-new-nav_ws39b')) {
        // FF hooks as recommended in https://hello.atlassian.net/wiki/spaces/TGR/pages/3178472787/OPEN+FOR+FEEDBACK+Feature+flagging+hooks#Option-4%3A-Official-Tangerine-guidance-to-use-eslint-disable
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $eUqFw.useMemo)(()=>$c8e671af8fdbb6ce$var$reportConnectAppsMaxDepth(sidebars, createAnalyticsEvent), [
            sidebars,
            createAnalyticsEvent
        ]);
    }
    const searchResult = (0, $eUqFw.useMemo)(()=>{
        let result = {
            stack: [],
            selected: null,
            title: null,
            data: null
        };
        if (sidebars != null) sidebars.some((sidebar)=>{
            const { items: items } = sidebar || {};
            if (!sidebar || !route || items == null) return false;
            const found = $c8e671af8fdbb6ce$var$findItemAndStackMemo(items, route.name, location);
            if (found) {
                // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'null'. | TS2322 - Type 'ConnectDataItem[]' is not assignable to type 'null'.
                result = {
                    ...found,
                    title: sidebar.name,
                    data: items
                };
                return true;
            }
            return false;
        });
        return result;
    }, [
        sidebars,
        route,
        location
    ]);
    return {
        ...searchResult,
        loading: loading,
        error: error
    };
};
function $c8e671af8fdbb6ce$var$getMaxConnectDataItemsDepth(item, encounteredItems) {
    try {
        if (!item) return 0;
        if (encounteredItems.has(item)) // loop detected
        return 0;
        if (encounteredItems.size >= 42) // 42 = arbitrary limit
        // either huge size OR loop
        // = most likely we don't understand how the data is structured...
        return 0;
        encounteredItems.add(item);
        const childItems = item.items || [];
        return 1 + childItems.reduce((acc, childItem)=>{
            const subDepth = $c8e671af8fdbb6ce$var$getMaxConnectDataItemsDepth(childItem, encounteredItems);
            return subDepth > acc ? subDepth : acc;
        }, 0);
    } catch (err) {
        // should never happen, we will investigate if it happens
        return -1;
    }
}
function $c8e671af8fdbb6ce$var$getConnectAppId(encounteredItems) {
    try {
        return Array.from(encounteredItems).reduce((acc, item)=>{
            if (acc) return acc; // id already found
            if (!item?.id) return acc;
            let candidateId = item.id; // seen ids:
            // com.atlassian.plugins.atlassian-connect-plugin:catlassian__catlassian-dropdown
            // catlassian__catlassian-section-nested-top
            if (candidateId.includes(':')) // so we drop the prefix if any
            candidateId = candidateId.split(':')[1];
            if (candidateId.includes('__')) // drop the suffix if any
            candidateId = candidateId.split('__')[0];
            return candidateId;
        }, '') || '???';
    } catch (err) {
        // should never happen, we will investigate if it happens
        return 'ERROR';
    }
}
function $c8e671af8fdbb6ce$var$reportConnectAppsMaxDepth(sidebars, createAnalyticsEvent) {
    if (!sidebars) return;
    const encounteredItems = new Set();
    const maxDepth = $c8e671af8fdbb6ce$var$getMaxConnectDataItemsDepth({
        items: sidebars
    }, encounteredItems);
    if (encounteredItems.size === 0) // no sidebar items, no need to report
    return;
    const id = $c8e671af8fdbb6ce$var$getConnectAppId(encounteredItems);
    (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'connectAppSidebar rendered', {
        maxDepth: maxDepth,
        encounteredCount: encounteredItems.size,
        id: id
    });
}

});
parcelRegister("2z5XU", function(module, exports) {

$parcel$export(module.exports, "useNavigationGlobalResource", () => $c76604c890e3e940$export$1e1c317ed5b99faa);

var $eUqFw = parcelRequire("eUqFw");

var $3HCkE = parcelRequire("3HCkE");

var $9CFDS = parcelRequire("9CFDS");
const $c76604c890e3e940$export$1e1c317ed5b99faa = ()=>{
    const { data: data, loading: loading, error: error } = (0, $3HCkE.useResource)((0, $9CFDS.navigationSidebarGlobalResource));
    const response = (0, $eUqFw.useMemo)(()=>data && data.response, [
        data
    ]);
    return {
        data: response,
        loading: loading,
        error: error
    };
};

});
parcelRegister("9CFDS", function(module, exports) {

$parcel$export(module.exports, "navigationSidebarGlobalResource", () => $979e04dcc1e8ef35$export$44e7ad3c66a3f25f);

var $3HCkE = parcelRequire("3HCkE");

var $hdKL9 = parcelRequire("hdKL9");
var $9zYls = parcelRequire("9zYls");

const $979e04dcc1e8ef35$export$44e7ad3c66a3f25f = (0, $3HCkE.createResource)({
    type: (0, $892a51daa0b1294e$export$fa5743fc6a1da5d8),
    getKey: ({ match: match, query: query })=>{
        // Refresh the data if the project key or id changes
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
        return projectKey || projectId || '__state';
    },
    getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const { baseUrl: baseUrl } = tenantContext;
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
        const scope = {
            projectKey: projectKey,
            projectId: projectId
        };
        const response = await (0, $hdKL9.fetchSidebarConfig)(baseUrl, scope, false);
        return {
            response: response,
            scope: scope
        };
    },
    maxAge: 300000
});

});
parcelRegister("hdKL9", function(module, exports) {

$parcel$export(module.exports, "fetchSidebarConfig", () => $7f8c4b071371acc8$export$d1d13c4b972a22f1);

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $2OdyW = parcelRequire("2OdyW");
const $7f8c4b071371acc8$var$LOGGER_LOCATION = 'navigation-next.baskets.navigation.utils';

const $7f8c4b071371acc8$var$fetchUsingProtobuf = async (url)=>{
    try {
        const fetchProtobuf = await (parcelRequire("8l1yi"));
        if (!fetchProtobuf) (0, $gUUjF.default).safeErrorWithoutCustomerData($7f8c4b071371acc8$var$LOGGER_LOCATION, 'Error dynamically loading protobuf fetch function');
        return fetchProtobuf.default(url);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData($7f8c4b071371acc8$var$LOGGER_LOCATION, 'Error fetching Sidebar Configuration protocol buffer message', err);
        throw err;
    }
};
const $7f8c4b071371acc8$export$94e808b2557f52e = (baseUrl, requestQuery, version = '2', queryParams)=>{
    const { pageType: pageType, identifierValue: identifierValue, identifierType: identifierType, exclude: exclude } = requestQuery || {};
    const params = {
        exclude: [
            'webItems.reports',
            'webItems.home',
            'webItems.gin',
            exclude
        ].filter(Boolean).join(',')
    };
    let path = '';
    if (pageType && identifierValue != null) path = `${pageType}/${identifierValue}`;
    else if (identifierType === 'boardId' && identifierValue != null) path = `board/${identifierValue}`;
    else if (identifierValue != null) path = `project/${identifierValue}`;
    else {
        path = 'product';
        const { projectId: projectId, projectKey: projectKey } = requestQuery || {};
        // Connect apps rely on project context even for the global/product scoped webItems
        const projectIdOrKey = projectId || projectKey;
        if (projectIdOrKey) params.projectIdOrKey = projectIdOrKey;
    }
    const queryString = [
        new URLSearchParams(params).toString(),
        queryParams
    ].filter(Boolean).join('&');
    return `${baseUrl}/rest/navigation/${version}/${path}?${queryString}`;
};
const $7f8c4b071371acc8$export$d1d13c4b972a22f1 = async (baseUrl, requestQuery, isServer, queryParams)=>{
    const isServerWithProtobuf = isServer && (0, $1ybV0.ff)('fe.platform.ssr.navigation.sidebar-configuration.protobuf');
    if (isServerWithProtobuf) {
        const protoUrl = $7f8c4b071371acc8$export$94e808b2557f52e(baseUrl, requestQuery, '2.1', queryParams);
        return $7f8c4b071371acc8$var$fetchUsingProtobuf(protoUrl);
    }
    const sidebarUrl = $7f8c4b071371acc8$export$94e808b2557f52e(baseUrl, requestQuery, undefined, queryParams);
    return (0, $2OdyW.default)(sidebarUrl);
};

});
parcelRegister("8l1yi", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('ioYkw');
        const value = parcelRequire('bHKJS');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("ioYkw").then(()=>parcelRequire('bHKJS'));
}

});


const $892a51daa0b1294e$export$fa5743fc6a1da5d8 = 'NAVIGATION_SIDEBAR_GLOBAL';



parcelRegister("9I91h", function(module, exports) {

$parcel$export(module.exports, "findItemAndStack", () => $d193dad52b41fe54$export$751e2e6237002565);

var $hTLlD = parcelRequire("hTLlD");

var $exb0h = parcelRequire("exb0h");
// JSPA-1062 remove qs items that might not always be there
const $d193dad52b41fe54$var$splitRelevantQs = (s)=>s.replace('?', '').split('&').filter((v)=>v && !/^(ac\.|project|board|user|servicedesk)/.test(v));
// match query strings, but allow case where query param "s" is present in the menu item, but not the window url
const $d193dad52b41fe54$var$isSameQuery = (locationQuery, itemQuery)=>(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(locationQuery, itemQuery) || !locationQuery.some((q)=>q.startsWith('s=')) && (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(itemQuery.filter((q)=>!q.startsWith('s=')), locationQuery);
const $d193dad52b41fe54$export$751e2e6237002565 = (items, routeName, location, parentStack = [])=>{
    let found = null;
    if (!(0, $exb0h.CONNECT_ROUTES_SET).has(routeName)) return found;
    const locationQuery = $d193dad52b41fe54$var$splitRelevantQs(location.search);
    items.some((item)=>{
        const [itemPath, itemQs = ''] = (item.url || '').split('#')[0].split('?');
        const itemQuery = $d193dad52b41fe54$var$splitRelevantQs(itemQs);
        const sameQuery = $d193dad52b41fe54$var$isSameQuery(locationQuery, itemQuery);
        if (item.section !== true && itemPath === location.pathname && sameQuery) {
            found = {
                stack: parentStack,
                selected: item
            };
            return true;
        }
        if (item.items) {
            const stack = item.section === true ? parentStack : parentStack.concat(item.id);
            found = $d193dad52b41fe54$export$751e2e6237002565(item.items, routeName, location, stack);
        }
        return Boolean(found);
    });
    return found;
};

});

parcelRegister("g9Ou9", function(module, exports) {

$parcel$export(module.exports, "getLinks", () => $bab768b8bde7a570$export$8054dcb2b42da45c);

var $lDq4g = parcelRequire("lDq4g");

var $WYbts = parcelRequire("WYbts");
const $bab768b8bde7a570$export$8054dcb2b42da45c = (sidebarConfig, locations, { skipFilter: skipFilter, omitSections: omitSections } = {})=>{
    const acc = [];
    locations.forEach((location)=>{
        const links = (0, $lDq4g.getLinksFromSidebar)(sidebarConfig, location);
        if (omitSections === true) {
            // merge 2 arrays in good performance way
            Array.prototype.push.apply(acc, links.flatMap((item)=>item && item.section === true ? item.links || [] : item));
            return;
        }
        // merge 2 arrays in good performance way
        Array.prototype.push.apply(acc, links);
    });
    return acc.filter((item)=>{
        if (!item) return false;
        if (skipFilter === true) return true;
        const hasConnectPrefix = item.id && item.id.includes((0, $WYbts.connectPrefix));
        if (hasConnectPrefix) return true;
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"sd-reports-addons" | "sd-queues-addons" | "com.atlassian.jira.jira-projects-plugin:tab-panel-link-parent"'.
        const isConnectSection = (0, $WYbts.connectSections).includes(item.id);
        if (isConnectSection) return true;
        const isJsdConnectSection = item.id && item.id.includes((0, $WYbts.jsdConnectPrefix));
        if (isJsdConnectSection) return true;
        return false;
    });
};

});
parcelRegister("lDq4g", function(module, exports) {

$parcel$export(module.exports, "hasItemInSidebar", () => $7cfca2f550cf53a3$export$57dd40eec4c64521);
$parcel$export(module.exports, "getLinksFromSidebar", () => $7cfca2f550cf53a3$export$9b7e0e4dd8bfade8);
const $7cfca2f550cf53a3$var$findLink = (arrayOfLinks, legacyId, partialMatch = false)=>{
    if (!Array.isArray(arrayOfLinks)) return undefined;
    for(let i = 0; i < arrayOfLinks.length; i += 1){
        const link = arrayOfLinks[i];
        if (partialMatch && link.id.indexOf(legacyId) === 0) return link;
        if (link.id === legacyId) return link;
        if (link.links) {
            const linkFound = $7cfca2f550cf53a3$var$findLink(link.links, legacyId, partialMatch);
            if (linkFound) return linkFound;
        }
    }
    return undefined;
};
const $7cfca2f550cf53a3$export$f62346e9b1894488 = (sidebarConfig, legacyId, partialMatch = false)=>sidebarConfig && sidebarConfig.product && $7cfca2f550cf53a3$var$findLink(sidebarConfig.product.links, legacyId, partialMatch) || undefined;
const $7cfca2f550cf53a3$export$57dd40eec4c64521 = (sidebarConfig, legacyId, partialMatch)=>Boolean($7cfca2f550cf53a3$export$f62346e9b1894488(sidebarConfig, legacyId, partialMatch));
const $7cfca2f550cf53a3$var$findChildLinks = (arrayOfLinks, legacyId)=>arrayOfLinks && arrayOfLinks.map((item)=>{
        if (item.id === legacyId) return item.links;
        return item.links && $7cfca2f550cf53a3$var$findChildLinks(item.links, legacyId);
    }).find(Boolean);
const $7cfca2f550cf53a3$export$9b7e0e4dd8bfade8 = (sidebarConfig, legacyId)=>{
    const links = legacyId != null ? $7cfca2f550cf53a3$var$findChildLinks(sidebarConfig.product && sidebarConfig.product.links, legacyId) : sidebarConfig.product && sidebarConfig.product.links;
    return links || [];
};

});

parcelRegister("WYbts", function(module, exports) {

$parcel$export(module.exports, "connectPrefix", () => $43407c27ba6284fa$export$196d83ebd873fb40);
$parcel$export(module.exports, "jsdConnectPrefix", () => $43407c27ba6284fa$export$7fac8f726f52d70);
$parcel$export(module.exports, "connectSections", () => $43407c27ba6284fa$export$b1c2c1fc5d10280);

var $bgNoL = parcelRequire("bgNoL");
const $43407c27ba6284fa$export$196d83ebd873fb40 = 'com.atlassian.plugins.atlassian-connect-plugin:';
const $43407c27ba6284fa$export$7fac8f726f52d70 = 'com.atlassian.servicedesk.connect';
const $43407c27ba6284fa$var$legacyAddonPanelLinkId = 'com.atlassian.jira.jira-projects-plugin:tab-panel-link-parent';
const $43407c27ba6284fa$var$jsdQueuesConnectSection = 'sd-queues-addons';
const $43407c27ba6284fa$export$b1c2c1fc5d10280 = [
    $43407c27ba6284fa$var$legacyAddonPanelLinkId,
    (0, $bgNoL.REPORTS_IDS).REPORTS_ADDONS,
    $43407c27ba6284fa$var$jsdQueuesConnectSection
];

});


parcelRegister("kNXHh", function(module, exports) {

$parcel$export(module.exports, "transformLink", () => $2d642e9f9a6a4f93$export$5a32dc366b1d641f);
$parcel$export(module.exports, "transformLinkV4", () => $2d642e9f9a6a4f93$export$27267b6b6650eaa5);
const $2d642e9f9a6a4f93$export$5a32dc366b1d641f = (link)=>{
    const items = link.links && link.links.length ? link.links.map($2d642e9f9a6a4f93$export$5a32dc366b1d641f).filter(Boolean) : undefined;
    // section item
    if (link.section === true) {
        // sometimes sections might be empty, is so remove them
        if (!items || !items.length) return null;
        // avoid nested groups with multiple headings
        if (items.length === 1 && items[0]?.section === true) return {
            ...items[0],
            name: items[0].name || String(link.name)
        };
        return {
            id: link.id,
            name: String(link.name),
            section: !!link.section,
            items: items
        };
    }
    // normal item (plain or with nest)
    return {
        id: link.id,
        name: String(link.name),
        url: link.url,
        iconUrl: link.iconUrl || '',
        styleClass: link.styleClass || '',
        items: items
    };
};
const $2d642e9f9a6a4f93$export$27267b6b6650eaa5 = (data)=>{
    const items = data.links && data.links.length ? data.links.map($2d642e9f9a6a4f93$export$27267b6b6650eaa5).filter(Boolean) : undefined;
    // section item
    if (data.section === true) {
        // sometimes sections might be empty, is so remove them
        if (!items || !items.length) return null;
        // avoid nested groups with multiple headings
        if (items.length === 1 && items[0]?.section === true) return {
            ...items[0],
            name: items[0].name || String(data.name)
        };
        return {
            id: data.id,
            name: String(data.name),
            section: !!data.section,
            items: items
        };
    }
    // normal item (plain or with nest)
    return {
        id: data.id,
        name: String(data.name),
        url: data.url,
        iconUrl: data.iconUrl || '',
        styleClass: data.styleClass || '',
        items: items
    };
};

});


parcelRegister("jGUct", function(module, exports) {

$parcel$export(module.exports, "useGlobalSettingsConnectItems", () => $6494416747689c30$export$f0785b98c99d344c);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $2z5XU = parcelRequire("2z5XU");

var $kJlBc = parcelRequire("kJlBc");

var $9I91h = parcelRequire("9I91h");
var $g9Ou9 = parcelRequire("g9Ou9");
var $kNXHh = parcelRequire("kNXHh");
// use memoised functions per hook to avoid re-computation between same hooks
const $6494416747689c30$var$getItemsMemo = (0, $5iWql.default)((d)=>(0, $g9Ou9.getLinks)(d, [
        'admin_plugins_menu'
    ], {
        skipFilter: true
    })// remove sections also statically defined
    .filter((v)=>![
            'upm_section',
            'jpo-ws-admin'
        ].includes(v.id)).map((0, $kNXHh.transformLink)).filter(Boolean));
const $6494416747689c30$var$findItemAndStackMemo = (0, $5iWql.default)((0, $9I91h.findItemAndStack));
const $6494416747689c30$export$f0785b98c99d344c = ()=>{
    const [{ route: route, location: location }] = (0, $kJlBc.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $2z5XU.useNavigationGlobalResource)();
    const items = (0, $eUqFw.useMemo)(()=>data && $6494416747689c30$var$getItemsMemo(data), [
        data
    ]);
    const found = (0, $eUqFw.useMemo)(()=>route && items && $6494416747689c30$var$findItemAndStackMemo(items, route.name, location), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        loading: loading,
        error: error,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});

parcelRegister("1ykEC", function(module, exports) {

$parcel$export(module.exports, "useGlobalSettingsSystemConnectItems", () => $9751bf35bdfd526e$export$f601efaceb0636f4);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $2z5XU = parcelRequire("2z5XU");

var $kJlBc = parcelRequire("kJlBc");

var $9I91h = parcelRequire("9I91h");
var $g9Ou9 = parcelRequire("g9Ou9");
var $kNXHh = parcelRequire("kNXHh");
// use memoised functions per hook to avoid re-computation between same hooks
const $9751bf35bdfd526e$var$getItemsMemo = (0, $5iWql.default)((d)=>(0, $g9Ou9.getLinks)(d, [
        'admin_system_menu'
    ], {
        skipFilter: true
    }).map((0, $kNXHh.transformLink)).filter(Boolean));
const $9751bf35bdfd526e$var$findItemAndStackMemo = (0, $5iWql.default)((0, $9I91h.findItemAndStack));
const $9751bf35bdfd526e$export$f601efaceb0636f4 = ()=>{
    const [{ route: route, location: location }] = (0, $kJlBc.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $2z5XU.useNavigationGlobalResource)();
    const items = (0, $eUqFw.useMemo)(()=>data && $9751bf35bdfd526e$var$getItemsMemo(data), [
        data
    ]);
    const found = (0, $eUqFw.useMemo)(()=>route && items && $9751bf35bdfd526e$var$findItemAndStackMemo(items, route.name, location), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        loading: loading,
        error: error,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});

parcelRegister("h2JwC", function(module, exports) {

$parcel$export(module.exports, "useInsight", () => $051bcb4b32f93938$export$e24dad0705701755);
$parcel$export(module.exports, "useInsightObjectSchemaSidebar", () => $051bcb4b32f93938$export$1f0bd21403710fc);

var $bKxX9 = parcelRequire("bKxX9");

var $10fdS = parcelRequire("10fdS");
const $051bcb4b32f93938$export$e24dad0705701755 = ()=>{
    const route = (0, $10fdS.useCurrentRoute)();
    if (route.navigation) return route.navigation.menuId === 'INSIGHT';
    return false;
};
const $051bcb4b32f93938$export$1f0bd21403710fc = ()=>{
    const route = (0, $10fdS.useCurrentRoute)();
    if ((0, $bKxX9.ff)('jsm-nav-refresh-assets_dkzd9')) return false;
    return route.name === 'servicedesk-cmdb-object-schema';
};

});

parcelRegister("2jFgb", function(module, exports) {

$parcel$export(module.exports, "useProjectConnectItems", () => $5f83aec5eda9bdea$export$f23d0c24c77d7608);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $2futN = parcelRequire("2futN");

var $kJlBc = parcelRequire("kJlBc");

var $9I91h = parcelRequire("9I91h");
var $kNXHh = parcelRequire("kNXHh");
const $5f83aec5eda9bdea$var$findItemAndStackMemo = (0, $5iWql.default)((0, $9I91h.findItemAndStack));
const $5f83aec5eda9bdea$export$f23d0c24c77d7608 = ()=>{
    const [{ route: route, location: location }] = (0, $kJlBc.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $2futN.useProjectSidebarConnectNavigation)();
    const items = (0, $eUqFw.useMemo)(()=>data && data.map((0, $kNXHh.transformLinkV4)).filter(Boolean), [
        data
    ]);
    const found = (0, $eUqFw.useMemo)(()=>route && items && $5f83aec5eda9bdea$var$findItemAndStackMemo(items, route.name, location), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        loading: loading,
        error: error,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});

parcelRegister("fpWGf", function(module, exports) {

$parcel$export(module.exports, "useProjectReportsConnectItems", () => $45778cdd51b28ac7$export$a1c75c386c088992);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $2futN = parcelRequire("2futN");

var $kJlBc = parcelRequire("kJlBc");

var $9I91h = parcelRequire("9I91h");
var $kNXHh = parcelRequire("kNXHh");
const $45778cdd51b28ac7$var$findItemAndStackMemo = (0, $5iWql.default)((0, $9I91h.findItemAndStack));
const $45778cdd51b28ac7$export$a1c75c386c088992 = ()=>{
    const [{ route: route, location: location }] = (0, $kJlBc.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $2futN.useProjectReportsSidebarConnectNavigation)();
    const items = (0, $eUqFw.useMemo)(()=>data != null ? data.map((0, $kNXHh.transformLinkV4)).filter(Boolean) : [], [
        data
    ]);
    const found = (0, $eUqFw.useMemo)(()=>route && items && $45778cdd51b28ac7$var$findItemAndStackMemo(items, route.name, location, [
            'reports'
        ]), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        error: error,
        loading: loading,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});

parcelRegister("2RJCt", function(module, exports) {

$parcel$export(module.exports, "useProjectSettingsConnectItems", () => $06b43f573ecea160$export$41a50100db18b578);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $2futN = parcelRequire("2futN");

var $kJlBc = parcelRequire("kJlBc");

var $9I91h = parcelRequire("9I91h");
var $kNXHh = parcelRequire("kNXHh");
// use memoised functions per hook to avoid re-computation between same hooks
const $06b43f573ecea160$var$findItemAndStackMemo = (0, $5iWql.default)((0, $9I91h.findItemAndStack));
const $06b43f573ecea160$export$41a50100db18b578 = ()=>{
    const [{ route: route, location: location }] = (0, $kJlBc.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $2futN.useProjectSettingsSidebarConnectNavigation)();
    const items = (0, $eUqFw.useMemo)(()=>data && data.map((0, $kNXHh.transformLinkV4)).filter(Boolean), [
        data
    ]);
    const found = (0, $eUqFw.useMemo)(()=>route && items && $06b43f573ecea160$var$findItemAndStackMemo(items, route.name, location, [
            'settings'
        ]), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        loading: loading,
        error: error,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});

parcelRegister("497qU", function(module, exports) {

$parcel$export(module.exports, "default", () => $113f60a6a5bc48c3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $av9ef = parcelRequire("av9ef");

var $9RvDp = parcelRequire("9RvDp");

const $113f60a6a5bc48c3$var$LazyConnectSidebar = (0, $7rh0R.lazyAfterPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("gqNdG")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/connect/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $113f60a6a5bc48c3$var$ConnectSidebar = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "connect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($113f60a6a5bc48c3$var$LazyConnectSidebar, null)));
$113f60a6a5bc48c3$var$ConnectSidebar.displayName = 'ConnectSidebar';
var $113f60a6a5bc48c3$export$2e2bcd8739ae039 = $113f60a6a5bc48c3$var$ConnectSidebar;

});
parcelRegister("av9ef", function(module, exports) {

$parcel$export(module.exports, "setPerformanceMarkLoadStart", () => $f6954eb5e712c16f$export$4166241bf9111f66);
$parcel$export(module.exports, "setPerformanceMarkLoadEnd", () => $f6954eb5e712c16f$export$edbd543f308bbef5);
parcelRequire("8fxTv");
var $7webZ = parcelRequire("7webZ");
var $8fxTv = parcelRequire("8fxTv");
const $f6954eb5e712c16f$export$4166241bf9111f66 = ()=>{
    const sideBarSegment = (0, $8fxTv.pageSegmentStore).getSegment((0, $7webZ.NAVIGATION_SIDEBAR_SEGMENT_NAME));
    sideBarSegment.mark((0, $7webZ.NAVIGATION_SIDEBAR_MARKS).loadStart);
};
const $f6954eb5e712c16f$export$edbd543f308bbef5 = ()=>{
    const sideBarSegment = (0, $8fxTv.pageSegmentStore).getSegment((0, $7webZ.NAVIGATION_SIDEBAR_SEGMENT_NAME));
    sideBarSegment.mark((0, $7webZ.NAVIGATION_SIDEBAR_MARKS).loadEnd);
};

});

parcelRegister("9RvDp", function(module, exports) {

$parcel$export(module.exports, "SidebarBoundary", () => $a0579ef23379c6d1$export$1edc778464f08256);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("8fxTv");
var $7webZ = parcelRequire("7webZ");
var $8fxTv = parcelRequire("8fxTv");

var $gGtKh = parcelRequire("gGtKh");

var $4C6RK = parcelRequire("4C6RK");

var $u0mbR = parcelRequire("u0mbR");

var $7Fu43 = parcelRequire("7Fu43");
const $a0579ef23379c6d1$export$1edc778464f08256 = ({ children: children, id: id })=>{
    const onFail = (0, $u0mbR.useSidebarFail)();
    const onSuccess = (0, $u0mbR.useSidebarSuccess)();
    const onError = (0, $eUqFw.useCallback)((location, error)=>{
        // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error'.
        const { statusCode: statusCode } = error;
        if (statusCode != null && statusCode >= 400 && statusCode < 500) onSuccess();
        else onFail(location, error);
    }, [
        onFail,
        onSuccess
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4C6RK.SidebarErrorBoundary), {
        id: id,
        packageName: "jiraSpaAppsSidebarCommon",
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fxTv.NavSidebarPerformanceMark), {
        metricKey: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderAttempt
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fxTv.NavSidebarSSRPerformanceMark), {
        metricKey: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderSsrStart
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "nav-sidebar",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Fu43.Skeleton), {
            isFull: true
        })
    }, children));
};

});
parcelRegister("4C6RK", function(module, exports) {

$parcel$export(module.exports, "SidebarErrorBoundary", () => $5b97a95fb0135b37$export$62853c5766dad0c4);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $keguF = parcelRequire("keguF");

var $gq8Ge = parcelRequire("gq8Ge");
const $5b97a95fb0135b37$export$62853c5766dad0c4 = (props)=>{
    const userLocation = (0, $keguF.getUserLocation)();
    const extraEventData = (0, $eUqFw.useMemo)(()=>({
            ...props.extraEventData,
            userLocation: userLocation
        }), [
        props.extraEventData,
        userLocation
    ]);
    // @ts-expect-error - TS7031 - Binding element 'error' implicitly has an 'any' type.
    const fallback = (0, $eUqFw.useCallback)(({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gq8Ge.Fallback), {
            error: error
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        ...props,
        extraEventData: extraEventData,
        fallback: fallback
    });
};

});
parcelRegister("gq8Ge", function(module, exports) {

$parcel$export(module.exports, "Fallback", () => $ca78cb141c4c2211$export$fb8d7f40caaeea67);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hI5oG = parcelRequire("hI5oG");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $iH6c1 = parcelRequire("iH6c1");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5vk3U = parcelRequire("5vk3U");

var $gnvfi = parcelRequire("gnvfi");
const $ca78cb141c4c2211$export$fb8d7f40caaeea67 = (props)=>{
    const { error: error } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        xcss: $ca78cb141c4c2211$var$WrapperStyles,
        alignInline: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ca78cb141c4c2211$var$ImgWrapper, {
        alt: "",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5vk3U)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xsmall"
    }, formatMessage((0, $gnvfi.default).errorHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatMessage((0, $gnvfi.default).errorBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $ca78cb141c4c2211$var$ErrorStyles,
        as: "code",
        paddingBlock: "space.025",
        paddingInline: "space.050"
    }, "ERROR: ", (0, $iH6c1.getErrorHash)(error)));
};
const $ca78cb141c4c2211$var$WrapperStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.background.neutral',
    color: 'color.text.subtle',
    padding: 'space.200',
    textAlign: 'center'
});
const $ca78cb141c4c2211$var$ErrorStyles = (0, $1ZAYh.xcss)({
    borderRadius: 'border.radius.050',
    fontSize: '0.7em',
    color: 'color.text.subtlest',
    backgroundColor: 'color.background.accent.gray.subtler'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ca78cb141c4c2211$var$ImgWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i12am",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5vk3U", function(module, exports) {
module.exports = new URL("generic-error.76ff7c6a.svg", import.meta.url).toString();

});

parcelRegister("gnvfi", function(module, exports) {

$parcel$export(module.exports, "default", () => $525f5b24291fe557$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $525f5b24291fe557$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorHeading: {
        "id": "spa-apps-sidebar-common.common.error-boundary.fallback.error-heading",
        "defaultMessage": "Something went wrong"
    },
    errorBody: {
        "id": "spa-apps-sidebar-common.common.error-boundary.fallback.error-body",
        "defaultMessage": "Try refreshing or navigating to another page."
    }
});

});




parcelRegister("gqNdG", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('8ciKp')
        ]);
        const value = parcelRequire('jSzUd');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("8ciKp")
    ]).then(()=>parcelRequire('jSzUd'));
}

});


parcelRegister("buaC1", function(module, exports) {

$parcel$export(module.exports, "default", () => $c95c2ed1c1661f63$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $av9ef = parcelRequire("av9ef");

var $9RvDp = parcelRequire("9RvDp");

const $c95c2ed1c1661f63$var$LazyCoreProjectSidebar = (0, $7rh0R.lazyForPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("7fkFd")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/business/navigation/sidebar/src/index.tsx"
});
const $c95c2ed1c1661f63$var$CoreProjectSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "coreProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c95c2ed1c1661f63$var$LazyCoreProjectSidebar, null));
var $c95c2ed1c1661f63$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($c95c2ed1c1661f63$var$CoreProjectSidebar);

});
parcelRegister("7fkFd", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('aj3eE')
        ]);
        const value = parcelRequire('N0fDW');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("aj3eE")
    ]).then(()=>parcelRequire('N0fDW'));
}

});


parcelRegister("6cIOm", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffa0ed116b82264e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $av9ef = parcelRequire("av9ef");

var $9RvDp = parcelRequire("9RvDp");

const $ffa0ed116b82264e$var$LazyForPaintForgeGlobalPageSidebar = (0, $7rh0R.lazyForPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("kc2lm")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/forge-global-page/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ffa0ed116b82264e$var$ForgeGlobalPageSidebar = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "forgeGlobalPage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ffa0ed116b82264e$var$LazyForPaintForgeGlobalPageSidebar, null)));
$ffa0ed116b82264e$var$ForgeGlobalPageSidebar.displayName = 'ForgeGlobalPageSidebar';
var $ffa0ed116b82264e$export$2e2bcd8739ae039 = $ffa0ed116b82264e$var$ForgeGlobalPageSidebar;

});
parcelRegister("kc2lm", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('jeOcw')
        ]);
        const value = parcelRequire('hBhU1');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("jeOcw")
    ]).then(()=>parcelRequire('hBhU1'));
}

});


parcelRegister("jAMQL", function(module, exports) {

$parcel$export(module.exports, "useForgeGlobalPageItems", () => $9f797773fe916c88$export$ff333fd2f0bf5254);

var $eUqFw = parcelRequire("eUqFw");

var $k9Roh = parcelRequire("k9Roh");

var $jMYeN = parcelRequire("jMYeN");

var $kJlBc = parcelRequire("kJlBc");

var $eOutC = parcelRequire("eOutC");
const $9f797773fe916c88$export$ff333fd2f0bf5254 = ()=>{
    const [{ match: match }] = (0, $kJlBc.useRouter)();
    const { data: modules, loading: loading, error: error } = (0, $k9Roh.useGlobalForgeApps)();
    const extension = (0, $eOutC.useMatchedExtension)({
        modules: modules,
        match: match
    });
    const sections = (0, $eUqFw.useMemo)(()=>extension && (0, $jMYeN.toSections)(extension), [
        extension
    ]);
    return {
        extension: extension,
        sections: sections,
        loading: loading,
        error: error
    };
};

});
parcelRegister("k9Roh", function(module, exports) {

$parcel$export(module.exports, "getItemHref", () => $9b956edc956601cb$export$ed6342e0e28465a6);
$parcel$export(module.exports, "useGlobalForgeApps", () => $9b956edc956601cb$export$f834c14187f80532);

var $eUqFw = parcelRequire("eUqFw");

var $fTsDx = parcelRequire("fTsDx");

var $70ON1 = parcelRequire("70ON1");

var $l90Gp = parcelRequire("l90Gp");

var $3HCkE = parcelRequire("3HCkE");
const $9b956edc956601cb$export$ed6342e0e28465a6 = (extension)=>{
    const { appId: appId, envId: envId } = (0, $70ON1.parseExtensionId)(extension.id);
    return `/jira/apps/${appId}/${envId}`;
};
const $9b956edc956601cb$export$f834c14187f80532 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $3HCkE.useResource)((0, $l90Gp.forgeGlobalModuleResource));
    const globalPageData = (0, $eUqFw.useMemo)(()=>data?.extensions || null, [
        data
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            data: globalPageData ? globalPageData.filter((extension)=>(0, $fTsDx.doesExtensionMeetConditions)(extension, {})) : null,
            loading: loading,
            error: error
        }), [
        globalPageData,
        loading,
        error
    ]);
};

});
parcelRegister("fTsDx", function(module, exports) {

$parcel$export(module.exports, "doesExtensionMeetConditions", () => $f49523f1e6c1d89f$export$b1e4ed7044e85aa3);

var $iPaeE = parcelRequire("iPaeE");

var $e91YZ = parcelRequire("e91YZ");
const $f49523f1e6c1d89f$export$b1e4ed7044e85aa3 = (extension, extraContext)=>{
    const { displayConditions: displayConditions } = extension.properties;
    const { appPermissions: { hasSoftwareAccess: hasSoftwareAccess, hasServiceDeskAccess: hasServiceDeskAccess, hasCoreAccess: hasCoreAccess }, isAdmin: isAdmin, isAnonymous: isAnonymous, isSiteAdmin: isSiteAdmin } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const context = {
        // Whatever extension needs
        ...extraContext,
        isAdmin: // User info
        isAdmin,
        isLoggedIn: !isAnonymous,
        isSiteAdmin: isSiteAdmin,
        hasSoftwareAccess: // App permissions
        hasSoftwareAccess,
        hasServiceManagementAccess: hasServiceDeskAccess,
        hasCoreAccess: hasCoreAccess
    };
    return displayConditions ? (0, $iPaeE.doesMeetConditions)(displayConditions, context) : true;
};

});

parcelRegister("70ON1", function(module, exports) {

$parcel$export(module.exports, "parseExtensionId", () => $46692d02f47d8a1d$export$bae42cbaf7fa3e1b);
$parcel$export(module.exports, "getSameEnvAppIdFromExtensionId", () => $46692d02f47d8a1d$export$a92b17288693d366);
const $46692d02f47d8a1d$export$bae42cbaf7fa3e1b = (extensionId)=>{
    const [, appId, envId] = extensionId.split('/');
    return {
        appId: appId,
        envId: envId
    };
};
const $46692d02f47d8a1d$export$a92b17288693d366 = (extensionId)=>extensionId.split('/').slice(1, 3).join('/');

});

parcelRegister("l90Gp", function(module, exports) {

$parcel$export(module.exports, "forgeAdminModuleResource", () => $a5dfafe975dbf279$export$b9489d8c5c5e3626);
$parcel$export(module.exports, "forgeProjectModuleResource", () => $a5dfafe975dbf279$export$72db683c2914a65e);
$parcel$export(module.exports, "forgeProjectSettingsModuleResource", () => $a5dfafe975dbf279$export$7a928d209faf75f);
$parcel$export(module.exports, "forgeGlobalModuleResource", () => $a5dfafe975dbf279$export$97b0827022fdafe3);
$parcel$export(module.exports, "forgeCustomFieldTypeResource", () => $a5dfafe975dbf279$export$e6be2f0ca0849869);
$parcel$export(module.exports, "forgeServiceDeskQueueModuleResource", () => $a5dfafe975dbf279$export$ebf5369e4dcfad00);
$parcel$export(module.exports, "getNavigationSidebarGlobalSettingsResources", () => $a5dfafe975dbf279$export$dcc98f4b36ce9223);

var $1ybV0 = parcelRequire("1ybV0");

var $2Rqjr = parcelRequire("2Rqjr");

var $arKaN = parcelRequire("arKaN");

var $3HCkE = parcelRequire("3HCkE");

var $8hg3R = parcelRequire("8hg3R");

var $fSEqj = parcelRequire("fSEqj");
const $a5dfafe975dbf279$export$eb46cc3d7c1a6649 = (params, moduleName)=>{
    const isModuleWithAccessNarrowing = [
        (0, $2Rqjr.SERVICEDESK_QUEUE_PAGE_MODULE),
        (0, $2Rqjr.PROJECT_PAGE_MODULE),
        (0, $2Rqjr.PROJECT_SETTINGS_PAGE_MODULE)
    ] // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .includes(moduleName);
    const projectIdOrKey = (0, $8hg3R.getProjectKeyOrId)(params);
    if (typeof projectIdOrKey === 'string' && projectIdOrKey !== '' && isModuleWithAccessNarrowing) return {
        projectIdOrKey: projectIdOrKey
    };
    return null;
};
const $a5dfafe975dbf279$var$createDataGetter = (moduleName, shouldReturnANExtensions = false, createContextIds)=>(route, { tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        const { match: params } = route;
        const dataClassification = $a5dfafe975dbf279$export$eb46cc3d7c1a6649(params, moduleName);
        // isNonJSDModule variable to be removed with arken-1053-jira-forge-extension-changes-for-aegis_aws9x FF cleanup. It's been added to keep JSD and non-JSD modules
        // independent during rollout/rollback of the FFs
        const isNonJSDModule = moduleName !== (0, $2Rqjr.SERVICEDESK_QUEUE_PAGE_MODULE);
        let contextIds;
        if (isNonJSDModule && (0, $1ybV0.ff)('arken-1053-jira-forge-extension-changes-for-aegis_aws9x')) contextIds = typeof createContextIds === 'function' && createContextIds({
            cloudId: cloudId,
            activationId: activationId
        }) || undefined;
        else if (!isNonJSDModule) contextIds = typeof createContextIds === 'function' && createContextIds({
            cloudId: cloudId,
            activationId: activationId
        }) || undefined;
        return (0, $fSEqj.fetchForgeModule)({
            cloudId: cloudId,
            moduleName: moduleName,
            dataClassification: dataClassification,
            shouldReturnANExtensions: shouldReturnANExtensions,
            contextIds: contextIds
        });
    };
const $a5dfafe975dbf279$var$createContextIds = ({ cloudId: cloudId, activationId: activationId })=>[
        `ari:cloud:jira:${cloudId}:workspace/${activationId}`
    ];
const $a5dfafe975dbf279$export$b9489d8c5c5e3626 = (0, $3HCkE.createResource)({
    type: 'FORGE_ADMIN_MODULE',
    getKey: ()=>'extensions',
    getData: $a5dfafe975dbf279$var$createDataGetter((0, $2Rqjr.ADMIN_PAGE_MODULE), false, $a5dfafe975dbf279$var$createContextIds),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $a5dfafe975dbf279$export$72db683c2914a65e = (0, $3HCkE.createResource)({
    type: 'FORGE_PROJECT_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $8hg3R.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: $a5dfafe975dbf279$var$createDataGetter((0, $2Rqjr.PROJECT_PAGE_MODULE), true, $a5dfafe975dbf279$var$createContextIds),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $a5dfafe975dbf279$export$7a928d209faf75f = (0, $3HCkE.createResource)({
    type: 'FORGE_PROJECT_SETTINGS_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $8hg3R.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: $a5dfafe975dbf279$var$createDataGetter((0, $2Rqjr.PROJECT_SETTINGS_PAGE_MODULE), true, $a5dfafe975dbf279$var$createContextIds),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $a5dfafe975dbf279$export$97b0827022fdafe3 = (0, $3HCkE.createResource)({
    type: 'FORGE_GLOBAL_MODULE',
    getKey: ()=>'extensions',
    getData: $a5dfafe975dbf279$var$createDataGetter((0, $2Rqjr.GLOBAL_PAGE_MODULE), false, $a5dfafe975dbf279$var$createContextIds),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $a5dfafe975dbf279$export$e6be2f0ca0849869 = (0, $3HCkE.createResource)({
    type: 'FORGE_CUSTOM_FIELD_TYPE_MODULE',
    getKey: ()=>'extensions',
    getData: (_route, { tenantContext: { cloudId: cloudId, activationId: activationId } })=>(0, $arKaN.default)(cloudId, [
            (0, $2Rqjr.CUSTOM_FIELD_TYPE_MODULE)
        ], null, undefined, (0, $2Rqjr.SOURCE_NAVIGATION), (0, $1ybV0.ff)('arken-1053-jira-forge-extension-changes-for-aegis_aws9x') && $a5dfafe975dbf279$var$createContextIds({
            cloudId: cloudId,
            activationId: activationId
        }) || undefined) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        .then((modules)=>modules.extensions.jiraCustomFieldType),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $a5dfafe975dbf279$export$ebf5369e4dcfad00 = (0, $3HCkE.createResource)({
    type: 'FORGE_SERVICEDESK_QUEUE_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $8hg3R.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: $a5dfafe975dbf279$var$createDataGetter((0, $2Rqjr.SERVICEDESK_QUEUE_PAGE_MODULE), true, $a5dfafe975dbf279$var$createContextIds),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $a5dfafe975dbf279$export$dcc98f4b36ce9223 = ()=>[
        $a5dfafe975dbf279$export$b9489d8c5c5e3626
    ];

});
parcelRegister("2Rqjr", function(module, exports) {

$parcel$export(module.exports, "PRODUCTION_ENVIRONMENT", () => $24e2ca1817bcdc8d$export$9af0088c49bdedb);
$parcel$export(module.exports, "STAGING_ENVIRONMENT", () => $24e2ca1817bcdc8d$export$71acbd662c478c42);
$parcel$export(module.exports, "DEVELOPMENT_ENVIRONMENT", () => $24e2ca1817bcdc8d$export$978072fd3fd149);
$parcel$export(module.exports, "DEFAULT_ENVIRONMENT_KEY", () => $24e2ca1817bcdc8d$export$ebc15d9cebfd6063);
$parcel$export(module.exports, "ISSUE_ACTION_MODULE", () => $24e2ca1817bcdc8d$export$fcc4a18f46f80f16);
$parcel$export(module.exports, "ISSUE_GLANCE_MODULE", () => $24e2ca1817bcdc8d$export$259bab989b0129d0);
$parcel$export(module.exports, "ISSUE_CONTEXT_MODULE", () => $24e2ca1817bcdc8d$export$75f224942f595e13);
$parcel$export(module.exports, "ISSUE_PANEL_MODULE", () => $24e2ca1817bcdc8d$export$ba0968f9752844);
$parcel$export(module.exports, "ISSUE_ACTIVITY_MODULE", () => $24e2ca1817bcdc8d$export$cc20a5638825fbb0);
$parcel$export(module.exports, "ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE", () => $24e2ca1817bcdc8d$export$9069d4b945c3d532);
$parcel$export(module.exports, "UI_MODIFICATIONS_MODULE", () => $24e2ca1817bcdc8d$export$811b7f067a43b422);
$parcel$export(module.exports, "CUSTOM_FIELD_MODULE", () => $24e2ca1817bcdc8d$export$e3887d6bafe8a17);
$parcel$export(module.exports, "CUSTOM_FIELD_TYPE_MODULE", () => $24e2ca1817bcdc8d$export$7b7866c04a2ad947);
$parcel$export(module.exports, "ADMIN_PAGE_MODULE", () => $24e2ca1817bcdc8d$export$52e4945e96bd2aa0);
$parcel$export(module.exports, "PROJECT_PAGE_MODULE", () => $24e2ca1817bcdc8d$export$151b03356f566603);
$parcel$export(module.exports, "PROJECT_SETTINGS_PAGE_MODULE", () => $24e2ca1817bcdc8d$export$ea0d6ac082b0d636);
$parcel$export(module.exports, "GLOBAL_PAGE_MODULE", () => $24e2ca1817bcdc8d$export$31ac745ab2add7cc);
$parcel$export(module.exports, "DASHBOARD_BACKGROUND_SCRIPT_MODULE", () => $24e2ca1817bcdc8d$export$353acf28daa75c79);
$parcel$export(module.exports, "DASHBOARD_GADGET_MODULE", () => $24e2ca1817bcdc8d$export$25627f012b21b0b9);
$parcel$export(module.exports, "WORKFLOW_VALIDATOR_MODULE", () => $24e2ca1817bcdc8d$export$42d6a8740fd42e58);
$parcel$export(module.exports, "WORKFLOW_CONDITION_MODULE", () => $24e2ca1817bcdc8d$export$a7186e5a73395db4);
$parcel$export(module.exports, "WORKFLOW_POST_FUNCTION_MODULE", () => $24e2ca1817bcdc8d$export$8fbcfe84dc845d17);
$parcel$export(module.exports, "SERVICEDESK_QUEUE_PAGE_MODULE", () => $24e2ca1817bcdc8d$export$8af4cb794979f60d);
$parcel$export(module.exports, "SERVICEDESK_ORGANIZATION_PANEL_MODULE", () => $24e2ca1817bcdc8d$export$5592ab836d562168);
$parcel$export(module.exports, "SERVICEDESK_ASSETS_IMPORT_TYPE_MODULE", () => $24e2ca1817bcdc8d$export$842eb4236828ac9);
$parcel$export(module.exports, "SUPPORTED_MODULES", () => $24e2ca1817bcdc8d$export$9b1a91242ce2a1b7);
$parcel$export(module.exports, "ENTRY_POINT_EDIT", () => $24e2ca1817bcdc8d$export$2b8aeda236486576);
$parcel$export(module.exports, "ENTRY_POINT_VIEW", () => $24e2ca1817bcdc8d$export$c41ce1ec1ea6e73d);
$parcel$export(module.exports, "ENTRY_POINT_CREATE", () => $24e2ca1817bcdc8d$export$b37d58c3ed77c139);
$parcel$export(module.exports, "ENTRY_POINT_CONTEXT_CONFIG", () => $24e2ca1817bcdc8d$export$ab94dbd1d02ac251);
$parcel$export(module.exports, "NONE_PANEL_INSTANCE_ID", () => $24e2ca1817bcdc8d$export$b6a67a3131c6c48d);
$parcel$export(module.exports, "ISSUE_PANEL_MULTIPLE_LIMIT", () => $24e2ca1817bcdc8d$export$b75dc2bfd20898fe);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_NATIVE", () => $24e2ca1817bcdc8d$export$8e96118a698216cb);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_BASIC", () => $24e2ca1817bcdc8d$export$9b72a8e9b92658fb);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_BLANK", () => $24e2ca1817bcdc8d$export$2d6539e7d0553ae7);
$parcel$export(module.exports, "SOURCE_UNKNOWN", () => $24e2ca1817bcdc8d$export$ecbd7135d66cb322);
$parcel$export(module.exports, "SOURCE_GLOBAL_ISSUE_CREATE", () => $24e2ca1817bcdc8d$export$61d882aa7aba51c);
$parcel$export(module.exports, "SOURCE_ISSUE_VIEW", () => $24e2ca1817bcdc8d$export$46cb92762d68a048);
$parcel$export(module.exports, "SOURCE_NAVIGATION", () => $24e2ca1817bcdc8d$export$fe90e46aea58e30b);
$parcel$export(module.exports, "SOURCE_FULL_PAGE_APP", () => $24e2ca1817bcdc8d$export$c5ccbdb9893f2a6a);
$parcel$export(module.exports, "SOURCE_ROUTER", () => $24e2ca1817bcdc8d$export$eae46a3c13473a8d);
$parcel$export(module.exports, "SOURCE_LEGACY", () => $24e2ca1817bcdc8d$export$ac11ee191d09688f);
$parcel$export(module.exports, "SOURCE_ORGANIZATION_PANEL", () => $24e2ca1817bcdc8d$export$4346e4e240c84319);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_JIRA", () => $24e2ca1817bcdc8d$export$4b6228758e800433);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_JSM", () => $24e2ca1817bcdc8d$export$70495c8cc141a7a4);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_CMDB", () => $24e2ca1817bcdc8d$export$bc3d408418fdf9d2);
$parcel$export(module.exports, "EMPTY_EXTENSIONS_OBJECT", () => $24e2ca1817bcdc8d$export$a48dade1864725a);
$parcel$export(module.exports, "getEmptyExtensionsObject", () => $24e2ca1817bcdc8d$export$218a328f66b86f7d);
$parcel$export(module.exports, "FORGE_FIELD_TYPE_PREFIX", () => $24e2ca1817bcdc8d$export$3193d714ab54ee26);
$parcel$export(module.exports, "PARTIAL_LEGACY_FORGE_FIELD_TYPE_PREFIX", () => $24e2ca1817bcdc8d$export$df7774a415710cce);
$parcel$export(module.exports, "LEGACY_FORGE_FIELD_TYPE_PREFIX", () => $24e2ca1817bcdc8d$export$51ab2784839ce348);
const $24e2ca1817bcdc8d$export$9af0088c49bdedb = 'PRODUCTION';
const $24e2ca1817bcdc8d$export$71acbd662c478c42 = 'STAGING';
const $24e2ca1817bcdc8d$export$978072fd3fd149 = 'DEVELOPMENT';
const $24e2ca1817bcdc8d$export$ebc15d9cebfd6063 = 'default';
const $24e2ca1817bcdc8d$export$fcc4a18f46f80f16 = 'jira:issueAction';
const $24e2ca1817bcdc8d$export$259bab989b0129d0 = 'jira:issueGlance';
const $24e2ca1817bcdc8d$export$75f224942f595e13 = 'jira:issueContext';
const $24e2ca1817bcdc8d$export$ba0968f9752844 = 'jira:issuePanel';
const $24e2ca1817bcdc8d$export$cc20a5638825fbb0 = 'jira:issueActivity';
const $24e2ca1817bcdc8d$export$9069d4b945c3d532 = 'jira:issueViewBackgroundScript';
const $24e2ca1817bcdc8d$export$811b7f067a43b422 = 'jira:uiModifications';
const $24e2ca1817bcdc8d$export$e3887d6bafe8a17 = 'jira:customField';
const $24e2ca1817bcdc8d$export$7b7866c04a2ad947 = 'jira:customFieldType';
const $24e2ca1817bcdc8d$export$52e4945e96bd2aa0 = 'jira:adminPage';
const $24e2ca1817bcdc8d$export$151b03356f566603 = 'jira:projectPage';
const $24e2ca1817bcdc8d$export$ea0d6ac082b0d636 = 'jira:projectSettingsPage';
const $24e2ca1817bcdc8d$export$31ac745ab2add7cc = 'jira:globalPage';
const $24e2ca1817bcdc8d$export$353acf28daa75c79 = 'jira:dashboardBackgroundScript';
const $24e2ca1817bcdc8d$export$25627f012b21b0b9 = 'jira:dashboardGadget';
const $24e2ca1817bcdc8d$export$42d6a8740fd42e58 = 'jira:workflowValidator';
const $24e2ca1817bcdc8d$export$a7186e5a73395db4 = 'jira:workflowCondition';
const $24e2ca1817bcdc8d$export$8fbcfe84dc845d17 = 'jira:workflowPostFunction';
const $24e2ca1817bcdc8d$export$8af4cb794979f60d = 'jiraServiceManagement:queuePage';
const $24e2ca1817bcdc8d$export$5592ab836d562168 = 'jiraServiceManagement:organizationPanel';
const $24e2ca1817bcdc8d$export$842eb4236828ac9 = 'jiraServiceManagement:assetsImportType';
const $24e2ca1817bcdc8d$export$9b1a91242ce2a1b7 = [
    $24e2ca1817bcdc8d$export$fcc4a18f46f80f16,
    $24e2ca1817bcdc8d$export$259bab989b0129d0,
    $24e2ca1817bcdc8d$export$75f224942f595e13,
    $24e2ca1817bcdc8d$export$ba0968f9752844,
    $24e2ca1817bcdc8d$export$cc20a5638825fbb0,
    $24e2ca1817bcdc8d$export$9069d4b945c3d532,
    $24e2ca1817bcdc8d$export$811b7f067a43b422,
    $24e2ca1817bcdc8d$export$e3887d6bafe8a17,
    $24e2ca1817bcdc8d$export$7b7866c04a2ad947,
    $24e2ca1817bcdc8d$export$52e4945e96bd2aa0,
    $24e2ca1817bcdc8d$export$151b03356f566603,
    $24e2ca1817bcdc8d$export$ea0d6ac082b0d636,
    $24e2ca1817bcdc8d$export$31ac745ab2add7cc,
    $24e2ca1817bcdc8d$export$353acf28daa75c79,
    $24e2ca1817bcdc8d$export$25627f012b21b0b9,
    $24e2ca1817bcdc8d$export$8af4cb794979f60d,
    $24e2ca1817bcdc8d$export$5592ab836d562168,
    $24e2ca1817bcdc8d$export$842eb4236828ac9,
    $24e2ca1817bcdc8d$export$42d6a8740fd42e58,
    $24e2ca1817bcdc8d$export$a7186e5a73395db4,
    $24e2ca1817bcdc8d$export$8fbcfe84dc845d17
];
const $24e2ca1817bcdc8d$export$2b8aeda236486576 = 'edit';
const $24e2ca1817bcdc8d$export$c41ce1ec1ea6e73d = 'view';
const $24e2ca1817bcdc8d$export$b37d58c3ed77c139 = 'create';
const $24e2ca1817bcdc8d$export$ab94dbd1d02ac251 = 'contextConfig';
const $24e2ca1817bcdc8d$export$b6a67a3131c6c48d = 'none';
const $24e2ca1817bcdc8d$export$b75dc2bfd20898fe = 5;
const $24e2ca1817bcdc8d$export$8e96118a698216cb = 'native';
const $24e2ca1817bcdc8d$export$9b72a8e9b92658fb = 'basic';
const $24e2ca1817bcdc8d$export$2d6539e7d0553ae7 = 'blank';
const $24e2ca1817bcdc8d$export$ecbd7135d66cb322 = 'unknownSource';
const $24e2ca1817bcdc8d$export$61d882aa7aba51c = 'global-issue-create';
const $24e2ca1817bcdc8d$export$46cb92762d68a048 = 'issue-view';
const $24e2ca1817bcdc8d$export$fe90e46aea58e30b = 'navigation';
const $24e2ca1817bcdc8d$export$c5ccbdb9893f2a6a = 'full-page-app';
const $24e2ca1817bcdc8d$export$eae46a3c13473a8d = 'router';
const $24e2ca1817bcdc8d$export$ac11ee191d09688f = 'legacy';
const $24e2ca1817bcdc8d$export$6d00582aa947900f = 'workflow-list';
const $24e2ca1817bcdc8d$export$4346e4e240c84319 = 'organization-panel';
const $24e2ca1817bcdc8d$export$4b6228758e800433 = 'jira';
const $24e2ca1817bcdc8d$export$70495c8cc141a7a4 = 'jsm';
const $24e2ca1817bcdc8d$export$bc3d408418fdf9d2 = 'cmdb';
const $24e2ca1817bcdc8d$export$a48dade1864725a = {
    jiraIssueAction: [],
    jiraIssueContext: [],
    jiraIssueGlance: [],
    jiraIssuePanel: [],
    jiraIssueActivity: [],
    jiraIssueViewBackgroundScript: [],
    jiraCustomField: [],
    jiraCustomFieldType: [],
    jiraUiModifications: [],
    jiraAdminPage: [],
    jiraGlobalPage: [],
    jiraProjectPage: [],
    jiraProjectSettingsPage: [],
    jiraDashboardBackgroundScript: [],
    jiraDashboardGadget: [],
    jiraServiceManagementQueuePage: [],
    jiraServiceManagementOrganizationPanel: [],
    jiraServiceManagementAssetsImportType: [],
    jiraWorkflowValidator: [],
    jiraWorkflowCondition: [],
    jiraWorkflowPostFunction: []
};
/**
 * The above EMPTY_EXTENSIONS_OBJECT sometimes is mutated.
 * @see getEmptyExtensionsObject
 */ const $24e2ca1817bcdc8d$var$STABLE_EMPTY_EXTENSIONS_OBJECT = {
    ...$24e2ca1817bcdc8d$export$a48dade1864725a
};
const $24e2ca1817bcdc8d$export$218a328f66b86f7d = ()=>({
        ...$24e2ca1817bcdc8d$var$STABLE_EMPTY_EXTENSIONS_OBJECT
    });
const $24e2ca1817bcdc8d$export$3193d714ab54ee26 = 'ari:cloud:ecosystem::extension/';
const $24e2ca1817bcdc8d$export$df7774a415710cce = 'com.atlassian.forge:';
const $24e2ca1817bcdc8d$export$51ab2784839ce348 = `${$24e2ca1817bcdc8d$export$df7774a415710cce}${$24e2ca1817bcdc8d$export$3193d714ab54ee26}`;

});

parcelRegister("arKaN", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cf6fc741e8eb3f0$export$2e2bcd8739ae039);

var $jh2R9 = parcelRequire("jh2R9");

var $fcWBJ = parcelRequire("fcWBJ");

var $cnRoI = parcelRequire("cnRoI");

var $2vzCR = parcelRequire("2vzCR");

var $lRmyA = parcelRequire("lRmyA");

var $eTZsp = parcelRequire("eTZsp");

var $eTZsp = parcelRequire("eTZsp");

var $cHWHh = parcelRequire("cHWHh");

var $hRcYT = parcelRequire("hRcYT");

var $ibWQr = parcelRequire("ibWQr");

var $2Rqjr = parcelRequire("2Rqjr");

var $2NB1f = parcelRequire("2NB1f");

var $02sMi = parcelRequire("02sMi");

var $lcqkg = parcelRequire("lcqkg");

var $aK1Xv = parcelRequire("aK1Xv");

var $h4b1Y = parcelRequire("h4b1Y");

var $dHbiB = parcelRequire("dHbiB");
const $3cf6fc741e8eb3f0$var$moduleToVariableKey = (module)=>(0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(module);
const $3cf6fc741e8eb3f0$export$3361e9be8093ddcc = (extensions)=>{
    const groupedExtensions = (0, (/*@__PURE__*/$parcel$interopDefault($fcWBJ)))(extensions, 'type');
    const groupedExtensionsWithMappedKeys = (0, (/*@__PURE__*/$parcel$interopDefault($cnRoI)))(groupedExtensions, (_, key)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        $3cf6fc741e8eb3f0$var$moduleToVariableKey(key));
    return (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(groupedExtensionsWithMappedKeys, (0, $2Rqjr.getEmptyExtensionsObject)());
};
const $3cf6fc741e8eb3f0$export$44097e02a91cd11a = (extensions)=>{
    const groupedExtensions = (0, (/*@__PURE__*/$parcel$interopDefault($fcWBJ)))(extensions, 'type');
    const groupedExtensionsWithMappedKeys = (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, (/*@__PURE__*/$parcel$interopDefault($cnRoI)))(groupedExtensions, (_, key)=>$3cf6fc741e8eb3f0$var$moduleToVariableKey(key)), (0, $2Rqjr.getEmptyExtensionsObject)());
    const filteredOutDuplicatedExtensions = (0, $02sMi.filterOutDuplicatedExtensions)(groupedExtensionsWithMappedKeys);
    const allowedExtensions = (0, $2Rqjr.getEmptyExtensionsObject)();
    const accessNarrowedExtensions = (0, $2Rqjr.getEmptyExtensionsObject)();
    Object.entries(filteredOutDuplicatedExtensions).forEach(([key, module])=>{
        const allowedExtensionsMap = new Map();
        const accessNarrowedExtensionsMap = new Map();
        module.forEach((moduleItem)=>{
            if (moduleItem?.dataClassificationPolicyDecision?.status === 'BLOCKED') accessNarrowedExtensionsMap.set(moduleItem.id, moduleItem);
            else allowedExtensionsMap.set(moduleItem.id, moduleItem);
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        allowedExtensions[key] = [
            ...allowedExtensionsMap.values()
        ];
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        accessNarrowedExtensions[key] = [
            ...accessNarrowedExtensionsMap.values()
        ];
    });
    return {
        extensions: allowedExtensions,
        accessNarrowedExtensions: accessNarrowedExtensions
    };
};
const $3cf6fc741e8eb3f0$var$EXCLUDED_ERROR_TYPES = [
    (0, $eTZsp.FAILED_TO_FETCH),
    (0, $eTZsp.AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS),
    (0, $eTZsp.DATA_CLASSIFICATION_NO_ACCESS)
];
const $3cf6fc741e8eb3f0$var$fetchModulesWithTraceId = async (cloudId, modules, dataClassification, extras, contextIds, source)=>{
    if (modules.length === 0) throw new Error('No modules to fetch provided');
    const dataClassificationTags = await (0, $lcqkg.getDataClassification)(dataClassification, source);
    const includeConfig = extras?.include || {};
    const query = (0, $dHbiB.buildForgeQuery)(includeConfig);
    const variables = {
        contextIds: contextIds || [
            `ari:cloud:jira::site/${cloudId}`
        ],
        extensionsFilter: [
            {
                type: 'EXTENSION_TYPE',
                value: modules
            }
        ],
        dataClassificationTags: dataClassificationTags.map((id)=>`ari:cloud:platform::classification-tag/${id}`)
    };
    const { data: data, errors: errors, extensions: extensions } = await (0, $cHWHh.measureExecutionTimeMetrics)((0, $hRcYT.PERFORMANCE_KEYS).FORGE_MODULES.FETCH_TIME, ()=>(0, $lRmyA.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: variables
            }),
            method: 'POST'
        }));
    const traceId = (0, $h4b1Y.getTraceIdFromExtensions)({
        extensions: extensions
    });
    if (errors) throw new (0, $aK1Xv.ForgeFetchError)(`Response ended with an error message: ${errors[0].message}`, traceId, errors);
    if (!data) throw new (0, $aK1Xv.ForgeFetchError)('No data returned', traceId, errors);
    if (data.extensionContexts.length < 1) throw new (0, $aK1Xv.ForgeFetchError)('No extensionContext returned', traceId, errors);
    return {
        data: data,
        traceId: traceId
    };
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3cf6fc741e8eb3f0$export$2e2bcd8739ae039 = async (cloudId, modules, dataClassification, extras, source = (0, $2Rqjr.SOURCE_UNKNOWN), contextIds)=>{
    try {
        // Just in case something goes very much wrong we don't want to call the XIS
        if (!(0, $2NB1f.canFetchForgeModules)()) return {
            extensions: (0, $2Rqjr.getEmptyExtensionsObject)(),
            accessNarrowedExtensions: (0, $2Rqjr.getEmptyExtensionsObject)()
        };
        const { data: data, traceId: traceId } = await $3cf6fc741e8eb3f0$var$fetchModulesWithTraceId(cloudId, modules, dataClassification, extras, contextIds, source);
        if (Math.random() * 100 < (0, $hRcYT.FORGE_SAMPLING_RATE)) (0, $ibWQr.fireInitializationFetchFinishedEvent)(source, {
            traceId: traceId
        });
        return $3cf6fc741e8eb3f0$export$44097e02a91cd11a(data.extensionContexts[0].extensions);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const errorType = (0, $eTZsp.getErrorType)(error);
        const traceId = (0, $h4b1Y.getTraceIdFromError)(error);
        (0, $ibWQr.fireInitializationFetchFailedEvent)(source, {
            isSSR: false,
            errorType: errorType,
            error: error,
            traceId: traceId
        });
        if ($3cf6fc741e8eb3f0$var$EXCLUDED_ERROR_TYPES.includes(errorType)) return {
            extensions: (0, $2Rqjr.getEmptyExtensionsObject)(),
            accessNarrowedExtensions: (0, $2Rqjr.getEmptyExtensionsObject)()
        };
        throw error;
    }
};

});
parcelRegister("eTZsp", function(module, exports) {

$parcel$export(module.exports, "DATA_CLASSIFICATION_NO_ACCESS", () => $11a471eb077355bb$export$23de3198bfe70090);
$parcel$export(module.exports, "FAILED_TO_FETCH", () => $11a471eb077355bb$export$f52aa41ccd776f01);
$parcel$export(module.exports, "AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS", () => $11a471eb077355bb$export$31d2ab0be67934f0);
$parcel$export(module.exports, "RATE_LIMITING", () => $11a471eb077355bb$export$7a1bd8c001e7e9c);
$parcel$export(module.exports, "INVOKE_VALUE_FUNCTION_FAILED", () => $11a471eb077355bb$export$89a175d4190df42e);
$parcel$export(module.exports, "userConsentErrorRegex", () => $11a471eb077355bb$export$dddade71b333c01d);
$parcel$export(module.exports, "getErrorType", () => $11a471eb077355bb$export$e19f9f08a6d79fd2);

var $7rh0R = parcelRequire("7rh0R");


var $JRB5w = parcelRequire("JRB5w");
const $11a471eb077355bb$var$commonErrors = {
    MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
    OPERATION_ABORTED: 'The operation was aborted. ',
    CANCELLED: 'cancelled',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    TIMEOUT: 'The request timed out.',
    AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
    GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504',
    GADGET_PREFERENCES: 'failed to put gadget preference: Error server response: 429'
};
const $11a471eb077355bb$export$23de3198bfe70090 = 'DATA_CLASSIFICATION_NO_ACCESS';
const $11a471eb077355bb$export$f52aa41ccd776f01 = 'FAILED_TO_FETCH';
const $11a471eb077355bb$export$31d2ab0be67934f0 = 'AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS';
const $11a471eb077355bb$export$7a1bd8c001e7e9c = 'RATE_LIMITING';
const $11a471eb077355bb$export$89a175d4190df42e = 'Invoke value functions failed:';
const $11a471eb077355bb$export$dddade71b333c01d = new RegExp('The user did not consent to use the app', 'i');
const $11a471eb077355bb$export$8a5d666d6e5b82fc = (error)=>{
    // React loosely lazy chunk load error type
    if ((0, $7rh0R.isLoaderError)(error) || typeof error === 'object' && error.name === 'ChunkLoadError') return true;
    // Other chunk load error types
    // In theory it should be handled by a common isClientFetchError, but it ignores TypeError error types
    const KNOWN_NETWORK_ERRORS = [
        'Failed to fetch dynamically imported module',
        'error loading dynamically imported module',
        'Importing a module script failed'
    ];
    const isClientFetchErrorMessage = (message)=>Boolean(message) && !!KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
            // are sometimes wrapped to provide additional context, e.g.
            // "Something went wrong: ${error.message}"
            message.includes(networkErrorMessage));
    return Boolean(error) && typeof error === 'object' && (isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && error.cause && 'message' in error.cause && isClientFetchErrorMessage(String(error.cause.message)));
};
const $11a471eb077355bb$export$e19f9f08a6d79fd2 = (error)=>{
    if (error == null) return 'NULL_OR_UNDEFINED';
    const message = String(error instanceof Error ? error.message : error).trim();
    const isTimeoutError = (timedOutResource)=>Boolean(typeof error === 'object' && error.name === 'TimeoutError' && error.stack?.includes(timedOutResource));
    const circuitBreakerErrorRegex = new RegExp("We couldn't show this extension", 'i');
    if (circuitBreakerErrorRegex.test(message)) return 'CIRCUIT_BREAKER_ERROR';
    const rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
    const rateLimitingDataClassificationRegex = new RegExp('Data classification request failed: Error server response: 429');
    if (rateLimitingRegex.test(message) || rateLimitingDataClassificationRegex.test(message)) return $11a471eb077355bb$export$7a1bd8c001e7e9c;
    const serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
    if (serverErrorRegex.test(message)) {
        const match = message.match(serverErrorRegex);
        const statusCode = match ? match[1] : 'NO_STATUS_CODE';
        return `ERROR_SERVER_RESPONSE_${statusCode}`;
    }
    const dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
    const dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
    if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) return $11a471eb077355bb$export$23de3198bfe70090;
    const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
    if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
    if ($11a471eb077355bb$export$dddade71b333c01d.test(message)) return 'USER_DIDNT_CONSENT_ERROR';
    const appValueFunction = new RegExp("The app's value function failed", 'i');
    const serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
    const invokeValueFunctionFailed = new RegExp($11a471eb077355bb$export$89a175d4190df42e, 'i');
    /**
   * In case when we get bad request(400) from the BE it should be treated as an app error as there
   * are many ways to fail the value function
   */ const valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === (0, $1c3fbb431a173cc6$export$9de493bcd9b1d977);
    /**
   * In case when we get request timeout(408) from the XIS invocation it should be treated as an app error.
   * Error occurs when invocation exceeds 25s threshold e.g.too long time to execute request to external API
   */ const valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === (0, $1c3fbb431a173cc6$export$fa405bbf47d510e2);
    if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) return 'VALUE_FUNCTION_APP_ERROR';
    // The full message states:
    // Extension "extension name" does not exist, the app may have changed or no longer be installed in this context
    const extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
    if (extensionDoesntExistRegex.test(message)) return 'EXTENSION_DOESNT_EXIST';
    // In case of React error message:
    // Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.
    const removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
    if (removeChildOnNodeRegex.test(message)) return 'REMOVE_CHILD_ERROR';
    if ($11a471eb077355bb$export$8a5d666d6e5b82fc(error)) return 'CHUNK_LOAD';
    if (isTimeoutError('FORGE_PROJECT_MODULE')) return 'TIMEOUT_PROJECT_MODULE';
    if (isTimeoutError('FORGE_PROJECT_SETTINGS_MODULE')) return 'TIMEOUT_PROJECT_SETTINGS_MODULE';
    if (isTimeoutError('PROJECT_CONTEXT')) return 'TIMEOUT_PROJECT_CONTEXT';
    const entry = Object.entries($11a471eb077355bb$var$commonErrors).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    if (entry) return entry[0];
    if ((0, $JRB5w.isClientFetchError)(error)) return $11a471eb077355bb$export$f52aa41ccd776f01;
    return 'OTHER';
};

});

parcelRegister("cHWHh", function(module, exports) {

$parcel$export(module.exports, "measureExecutionTimeMetrics", () => $69ad25e8e60753eb$export$a859f6866f4653e0);

var $1ybV0 = parcelRequire("1ybV0");

var $hRcYT = parcelRequire("hRcYT");

var $d6g7g = parcelRequire("d6g7g");
const $69ad25e8e60753eb$export$a859f6866f4653e0 = async (key, action)=>{
    const shouldSendTimeMetric = !(0, $1ybV0.ff)('fetch-forge-modules-sampling_1e415') || Math.random() * 100 < (0, $hRcYT.FORGE_SAMPLING_RATE);
    try {
        if (shouldSendTimeMetric) (0, $d6g7g.forgeModulesFetchTime).start({
            startTime: performance.now()
        });
        const result = await action();
        if (shouldSendTimeMetric) (0, $d6g7g.forgeModulesFetchTime).stop({
            stopTime: performance.now()
        });
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldSendTimeMetric) (0, $d6g7g.forgeModulesFetchTime).cancel();
        throw error;
    }
};

});
parcelRegister("hRcYT", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME_GASV3", () => $7ddaf55383536638$export$f892f621fb508154);
$parcel$export(module.exports, "MODULE_TYPE_TRIGGER", () => $7ddaf55383536638$export$ed63b053e04e26df);
$parcel$export(module.exports, "MODULE_TYPE_EXTENSION", () => $7ddaf55383536638$export$725bacc669333eef);
$parcel$export(module.exports, "FORGE_SAMPLING_RATE", () => $7ddaf55383536638$export$d920cee73ec094d0);
$parcel$export(module.exports, "PERFORMANCE_KEYS", () => $7ddaf55383536638$export$f048d91ccaf92408);
$parcel$export(module.exports, "UI_ACTIONS", () => $7ddaf55383536638$export$2b7367f125154866);
$parcel$export(module.exports, "OPERATIONAL_ACTIONS", () => $7ddaf55383536638$export$42bcca5cae2ce90b);
$parcel$export(module.exports, "TRACK_ACTIONS", () => $7ddaf55383536638$export$2af0438304d7c4b2);
// TODO ARKEN-359: uniformise GASv3/BM3 keys to use kebab lowercase
const $7ddaf55383536638$export$f892f621fb508154 = 'jiraForgeUi';
const $7ddaf55383536638$export$273f5980517336e2 = 'jiraforgeui';
const $7ddaf55383536638$export$ed63b053e04e26df = 'trigger';
const $7ddaf55383536638$export$725bacc669333eef = 'extension';
const $7ddaf55383536638$export$d920cee73ec094d0 = 10;
const $7ddaf55383536638$export$f048d91ccaf92408 = {
    FORGE_MODULES: {
        FETCH_TIME: `${$7ddaf55383536638$export$273f5980517336e2}.forge-modules.fetch-time`,
        LOAD_TIME: `${$7ddaf55383536638$export$273f5980517336e2}.forge-modules.load-time`
    },
    REAL_TIME_ISSUE_EVENTS: {
        INVOKE_TIME: `${$7ddaf55383536638$export$273f5980517336e2}.real-time-issue-events.invoke-time`
    },
    MARKS: {
        TTI_START: 'ECOSYSTEM_FORGE_MODULE_TTI_BEGIN_MARK',
        TTI_END: 'ECOSYSTEM_FORGE_MODULE_TTI_END_MARK',
        ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END',
        ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END',
        ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END',
        ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END'
    }
};
const $7ddaf55383536638$export$2b7367f125154866 = {
    CLICKED: 'clicked',
    SELECTED: 'selected',
    CANCELED: 'canceled',
    ACTION_CLICKED: 'action clicked',
    COLLAPSE_EXPAND_CLICKED: 'collapse-expand clicked',
    REMOVE_CLICKED: 'remove clicked'
};
const $7ddaf55383536638$export$42bcca5cae2ce90b = {
    FAILED: 'failed',
    INITIALIZED: 'initialized',
    EDIT_FAILED: 'edit failed',
    ACTION_FAILED: 'action failed',
    SAVE_FAILED: 'save failed',
    REMOVE_FAILED: 'remove failed',
    UPDATE_FAILED: 'update failed'
};
const $7ddaf55383536638$export$2af0438304d7c4b2 = {
    EDITED: 'edited',
    SAVED: 'saved',
    REMOVED: 'removed',
    ACTION_SUCCEED: 'action succeed',
    UPDATE_SUCCEED: 'update succeed'
};

});

parcelRegister("d6g7g", function(module, exports) {

$parcel$export(module.exports, "forgeModulesFetchTime", () => $2f54a22cce56cf6f$export$cd129f3639657eae);
$parcel$export(module.exports, "forgeModulesLoadTime", () => $2f54a22cce56cf6f$export$12a4984e133f471e);
$parcel$export(module.exports, "forgeModulesConcurrentLoadTime", () => $2f54a22cce56cf6f$export$292f3b557281044f);
$parcel$export(module.exports, "realTimeIssueEventInvokeTime", () => $2f54a22cce56cf6f$export$89ace7e2bb7d7685);
$parcel$export(module.exports, "measureInitialPageLoadAsyncResourcesTiming", () => $2f54a22cce56cf6f$export$94f65f3b2556df23);
$parcel$export(module.exports, "markAdditionalTimingsFromWindowPerformance", () => $2f54a22cce56cf6f$export$116d5e25caf0018d);
$parcel$export(module.exports, "customFieldPageSegmentLoadMetric", () => $2f54a22cce56cf6f$export$3bd38623c2543fc0);
$parcel$export(module.exports, "customFieldInteractionMetric", () => $2f54a22cce56cf6f$export$a318f99472db73c8);

var $lNfG4 = parcelRequire("lNfG4");

var $8uNQc = parcelRequire("8uNQc");

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");

var $hRcYT = parcelRequire("hRcYT");
const $2f54a22cce56cf6f$export$cd129f3639657eae = (0, $lNfG4.metrics).custom({
    key: (0, $hRcYT.PERFORMANCE_KEYS).FORGE_MODULES.FETCH_TIME
});
const $2f54a22cce56cf6f$export$12a4984e133f471e = (0, $lNfG4.metrics).custom({
    key: (0, $hRcYT.PERFORMANCE_KEYS).FORGE_MODULES.LOAD_TIME
});
const $2f54a22cce56cf6f$export$292f3b557281044f = (0, $lNfG4.metrics).concurrent.custom({
    key: (0, $hRcYT.PERFORMANCE_KEYS).FORGE_MODULES.LOAD_TIME
});
const $2f54a22cce56cf6f$export$89ace7e2bb7d7685 = new (0, $kDfSL.UFOExperience)((0, $hRcYT.PERFORMANCE_KEYS).REAL_TIME_ISSUE_EVENTS.INVOKE_TIME, {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult
});
async function $2f54a22cce56cf6f$export$94f65f3b2556df23(startMark, endMark, fn) {
    if (false || (0, $8uNQc.default).getEntriesByName(startMark).length > 0 || (0, $8uNQc.default).getEntriesByName(endMark).length > 0) return fn();
    (0, $8uNQc.default).mark(startMark);
    const result = await fn();
    (0, $8uNQc.default).mark(endMark);
    return result;
}
const $2f54a22cce56cf6f$export$116d5e25caf0018d = (metric, additionalTimings)=>{
    additionalTimings.flatMap(({ startMark: startMark, endMark: endMark, cleanStart: cleanStart, cleanEnd: cleanEnd })=>[
            ...(0, $8uNQc.default).getEntriesByName(startMark).map((entry)=>({
                    name: entry.name,
                    startTime: entry.startTime,
                    cleanStart: cleanStart,
                    cleanEnd: undefined
                })),
            ...(0, $8uNQc.default).getEntriesByName(endMark).map((entry)=>({
                    name: entry.name,
                    startTime: entry.startTime,
                    cleanStart: undefined,
                    cleanEnd: cleanEnd
                }))
        ]).forEach(({ name: name, startTime: startTime, cleanStart: cleanStart, cleanEnd: cleanEnd })=>{
        metric.mark(name, startTime);
        if (cleanStart || cleanEnd) (0, $8uNQc.default).clearMarks(name);
    });
};
const $2f54a22cce56cf6f$export$3bd38623c2543fc0 = (additionalTimings = [])=>(0, $lNfG4.metrics).pageSegmentLoad({
        key: 'forge-custom-field',
        timings: [
            ...additionalTimings,
            {
                key: 'tti',
                startMark: (0, $hRcYT.PERFORMANCE_KEYS).MARKS.TTI_START,
                endMark: (0, $hRcYT.PERFORMANCE_KEYS).MARKS.TTI_END
            }
        ]
    });
const $2f54a22cce56cf6f$export$a318f99472db73c8 = (additionalTimings = [])=>(0, $lNfG4.metrics).interaction({
        key: 'forge-custom-field',
        timings: [
            ...additionalTimings
        ]
    });

});


parcelRegister("ibWQr", function(module, exports) {

$parcel$export(module.exports, "fireInitializationFetchFinishedEvent", () => $2c36a22053951caa$export$132ca822850e455f);
$parcel$export(module.exports, "fireInitializationFetchFailedEvent", () => $2c36a22053951caa$export$b5ca88b1053f1ad0);
$parcel$export(module.exports, "fireInitializationIssueViewFinishedEvent", () => $2c36a22053951caa$export$e914f7df1e4ad79b);
$parcel$export(module.exports, "fireInitializationIssueViewFailedEvent", () => $2c36a22053951caa$export$b274c658390b491b);

var $TrUS5 = parcelRequire("TrUS5");

var $cYWDh = parcelRequire("cYWDh");
const $2c36a22053951caa$var$INITIALIZATION_ACTIONS = {
    STARTED: 'started',
    FINISHED: 'finished',
    FAILED: 'failed'
};
const $2c36a22053951caa$export$917d0643b0111a02 = (0, $TrUS5.toEventId)('issueViewInitialization');
const $2c36a22053951caa$export$43e875fd63e64525 = (0, $TrUS5.toEventId)('fetchModulesInitialization');
const $2c36a22053951caa$export$132ca822850e455f = (source, attributes)=>(0, $cYWDh.fireInitializationEvent)($2c36a22053951caa$var$INITIALIZATION_ACTIONS.FINISHED, {
        id: $2c36a22053951caa$export$43e875fd63e64525,
        source: source,
        attributes: attributes
    });
const $2c36a22053951caa$export$b5ca88b1053f1ad0 = (source, attributes)=>(0, $cYWDh.fireInitializationEvent)($2c36a22053951caa$var$INITIALIZATION_ACTIONS.FAILED, {
        id: $2c36a22053951caa$export$43e875fd63e64525,
        source: source,
        attributes: attributes
    });
const $2c36a22053951caa$export$e914f7df1e4ad79b = (source, attributes)=>(0, $cYWDh.fireInitializationEvent)($2c36a22053951caa$var$INITIALIZATION_ACTIONS.FINISHED, {
        id: $2c36a22053951caa$export$917d0643b0111a02,
        source: source,
        attributes: attributes
    });
const $2c36a22053951caa$export$b274c658390b491b = (source, attributes)=>(0, $cYWDh.fireInitializationEvent)($2c36a22053951caa$var$INITIALIZATION_ACTIONS.FAILED, {
        id: $2c36a22053951caa$export$917d0643b0111a02,
        source: source,
        attributes: attributes
    });

});
parcelRegister("TrUS5", function(module, exports) {

$parcel$export(module.exports, "toEventId", () => $157b5a46da0774f4$export$75e84ef5a3771f9a);
const $157b5a46da0774f4$export$75e84ef5a3771f9a = (value)=>value;

});

parcelRegister("cYWDh", function(module, exports) {

$parcel$export(module.exports, "fireOperationalEvent", () => $6b16192b91ad756a$export$a1fb57756f0de62b);
$parcel$export(module.exports, "fireUiEvent", () => $6b16192b91ad756a$export$bed7f228c94e5f2a);
$parcel$export(module.exports, "fireTrackEvent", () => $6b16192b91ad756a$export$574d2f19a52d67ca);
$parcel$export(module.exports, "fireInitializationEvent", () => $6b16192b91ad756a$export$390a62413962e4f0);

var $3FyZ4 = parcelRequire("3FyZ4");

var $hRcYT = parcelRequire("hRcYT");

var $bBGpO = parcelRequire("bBGpO");

var $7ALvE = parcelRequire("7ALvE");

var $29pIG = parcelRequire("29pIG");
const $6b16192b91ad756a$var$createAnalyticsProps = ({ id: id, source: // Since source is required in sendOperationalEvent and sendUIEvent we need to pass here a fallback
// in case source is not provided
source = 'unknownSource', action: action, attributes: attributes })=>({
        actionSubject: `${0, $hRcYT.PACKAGE_NAME_GASV3}.${id}`,
        attributes: (0, $bBGpO.createAttributes)(attributes),
        source: source,
        action: action
    });
const $6b16192b91ad756a$var$getAnalyticsClient = async ()=>(await (0, $3FyZ4.getAnalyticsWebClientPromise)()).getInstance();
const $6b16192b91ad756a$var$sendOperationalEvent = async (props)=>(await $6b16192b91ad756a$var$getAnalyticsClient()).sendOperationalEvent($6b16192b91ad756a$var$createAnalyticsProps(props));
const $6b16192b91ad756a$var$sendUiEvent = async (props)=>(await $6b16192b91ad756a$var$getAnalyticsClient()).sendUIEvent($6b16192b91ad756a$var$createAnalyticsProps(props));
const $6b16192b91ad756a$var$sendTrackEvent = async (props)=>(await $6b16192b91ad756a$var$getAnalyticsClient()).sendTrackEvent($6b16192b91ad756a$var$createAnalyticsProps(props));
const $6b16192b91ad756a$export$a1fb57756f0de62b = async (action, { source: source, ...eventProps })=>$6b16192b91ad756a$var$sendOperationalEvent({
        ...eventProps,
        source: (0, $bBGpO.parseSource)(source),
        action: action
    });
const $6b16192b91ad756a$export$bed7f228c94e5f2a = async (action, { source: source, ...eventProps })=>$6b16192b91ad756a$var$sendUiEvent({
        ...eventProps,
        source: (0, $bBGpO.parseSource)(source),
        action: action
    });
const $6b16192b91ad756a$export$574d2f19a52d67ca = async (action, { source: source, ...eventProps })=>$6b16192b91ad756a$var$sendTrackEvent({
        ...eventProps,
        source: (0, $bBGpO.parseSource)(source),
        action: action
    });
const $6b16192b91ad756a$export$390a62413962e4f0 = async (action, { id: id, attributes: attributes, source: source })=>Promise.all([
        $6b16192b91ad756a$export$a1fb57756f0de62b(action, {
            id: id,
            attributes: attributes,
            source: source
        }),
        attributes?.error && (0, $7ALvE.logError)((0, $7ALvE.ANALYTICS_UTIL), `Something went wrong with Forge initialization, isSynthetic=${(0, $29pIG.isSynthetic)().toString()}, id=${id}, source=${(0, $bBGpO.parseSource)(source)}, action=${action}`, attributes.error) || Promise.resolve()
    ]);

});
parcelRegister("bBGpO", function(module, exports) {

$parcel$export(module.exports, "parseSource", () => $c13c8af67eb85442$export$e98201ef9a88ba70);
$parcel$export(module.exports, "createAttributes", () => $c13c8af67eb85442$export$c7c9603a6b1fd815);

var $7PHyj = parcelRequire("7PHyj");

var $f4SFV = parcelRequire("f4SFV");

var $eTZsp = parcelRequire("eTZsp");

var $29pIG = parcelRequire("29pIG");
const $c13c8af67eb85442$export$e98201ef9a88ba70 = (source)=>source != null ? source.toString() : 'unknownSource';
const $c13c8af67eb85442$export$78c6267359db7e73 = (error)=>({
        ...error,
        stack: error.stack,
        message: error?.message
    });
const $c13c8af67eb85442$export$c7c9603a6b1fd815 = (rawAttributes)=>{
    const attributes = {
        isSynthetic: (0, $29pIG.isSynthetic)(),
        isOverridingFragments: (0, $f4SFV.isOverridingFragments)(),
        isSSR: false
    };
    if (rawAttributes) {
        const { source: source, error: error, hasForgeAccess: hasForgeAccess } = rawAttributes;
        if (source) attributes.source = $c13c8af67eb85442$export$e98201ef9a88ba70(source);
        if (error) {
            attributes.error = $c13c8af67eb85442$export$78c6267359db7e73(error);
            attributes.errorType = (0, $eTZsp.getErrorType)(error);
        }
        if ((0, (/*@__PURE__*/$parcel$interopDefault($7PHyj)))(hasForgeAccess)) attributes.hasForgeAccess = hasForgeAccess;
    }
    return {
        ...rawAttributes,
        ...attributes
    };
};

});
parcelRegister("f4SFV", function(module, exports) {

$parcel$export(module.exports, "isOverridingFragments", () => $131b22271a46e6fc$export$1d1321d2b374d697);
const $131b22271a46e6fc$export$1d1321d2b374d697 = ()=>{
    if (typeof window !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+)$/.test(window?.BUILD_KEY);
    if (typeof globalThis !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+)$/.test(globalThis.BUILD_KEY);
    return false;
};

});

parcelRegister("29pIG", function(module, exports) {

$parcel$export(module.exports, "isSynthetic", () => $4e7b61ea3e7b237b$export$947749d756ccb0a);

var $1ybV0 = parcelRequire("1ybV0");

var $6rW04 = parcelRequire("6rW04");
const $4e7b61ea3e7b237b$export$947749d756ccb0a = ()=>// Filter out synthetic tests using all known ways
    (0, $6rW04.default)('ajs-is-synthetic') === 'true' || (0, $1ybV0.ff)('issue.details.forge-ui-synthetic-check');

});


parcelRegister("7ALvE", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_UTIL", () => $d44e65d0fc9da8f1$export$d1e4f308040bb0d5);
$parcel$export(module.exports, "CUSTOM_FIELD_OBJECT_TYPE", () => $d44e65d0fc9da8f1$export$36f315a5c6daf40b);
$parcel$export(module.exports, "logError", () => $d44e65d0fc9da8f1$export$58da9968c3170cb1);

var $gUUjF = parcelRequire("gUUjF");

var $hRcYT = parcelRequire("hRcYT");
const $d44e65d0fc9da8f1$export$e31edcd35abe3bb1 = 'environment-mapping';
const $d44e65d0fc9da8f1$export$d1e4f308040bb0d5 = 'analytics';
const $d44e65d0fc9da8f1$export$36f315a5c6daf40b = 'custom-field-object-type';
const $d44e65d0fc9da8f1$export$6ee8198f29fffdb4 = {
    [$d44e65d0fc9da8f1$export$d1e4f308040bb0d5]: `${(0, $hRcYT.PACKAGE_NAME_GASV3)}.error.utils.analytics`,
    [$d44e65d0fc9da8f1$export$e31edcd35abe3bb1]: `${(0, $hRcYT.PACKAGE_NAME_GASV3)}.error.utils.environment-mapping`,
    [$d44e65d0fc9da8f1$export$36f315a5c6daf40b]: `${(0, $hRcYT.PACKAGE_NAME_GASV3)}.error.custom-field.object-type`
};
const $d44e65d0fc9da8f1$export$58da9968c3170cb1 = (key, message, event)=>{
    (0, $gUUjF.default).safeErrorWithoutCustomerData($d44e65d0fc9da8f1$export$6ee8198f29fffdb4[key], message, event);
};

});



parcelRegister("2NB1f", function(module, exports) {

$parcel$export(module.exports, "canFetchForgeModules", () => $54017b90132e06f5$export$bb3a4a3b8e654c08);
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-legacy

var $e91YZ = parcelRequire("e91YZ");
const $54017b90132e06f5$export$bb3a4a3b8e654c08 = ()=>{
    const { isAnonymous: isAnonymous, cloudId: cloudId } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    /**
	 * SMT-1142
	 * A tenant named `bob` is most likely a local/ci instance started with `./jmake run ci`.
	 * It wasn't possible to find the hostname in a reasonable timeframe so this is the most feasible solution.
	 * In case more tenants like this spawn in the future we'd need to mark these instances instead and block here.
	 */ if (String(cloudId) === 'bob') return false;
    // There is no anonymous access for now
    return !isAnonymous;
};

});

parcelRegister("02sMi", function(module, exports) {

$parcel$export(module.exports, "filterOutDuplicatedExtensions", () => $e5793a48e1add67f$export$e0393e97f15a28a5);

var $fUTZC = parcelRequire("fUTZC");

var $2Rqjr = parcelRequire("2Rqjr");
const $e5793a48e1add67f$export$e0393e97f15a28a5 = (modules)=>{
    const filteredModules = (0, $2Rqjr.getEmptyExtensionsObject)();
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(modules, (module, propName)=>{
        const moduleExtensions = new Map();
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(module, (moduleItem)=>{
            const moduleExtension = moduleExtensions.get(moduleItem.id);
            const appVersion = moduleItem?.appVersion || '0.0.0';
            const moduleAppVersion = moduleExtension?.appVersion || '0.0.0';
            if (!moduleExtension || moduleExtension && appVersion >= moduleAppVersion) moduleExtensions.set(moduleItem.id, moduleItem);
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        filteredModules[propName] = [
            ...moduleExtensions.values()
        ];
    });
    return filteredModules;
};

});

parcelRegister("lcqkg", function(module, exports) {

$parcel$export(module.exports, "getDataClassification", () => $7179ddf7ab2ecdfc$export$1635afa94064952c);

var $lRmyA = parcelRequire("lRmyA");

var $eTZsp = parcelRequire("eTZsp");

var $eTZsp = parcelRequire("eTZsp");

var $ibWQr = parcelRequire("ibWQr");

var $7i1xd = parcelRequire("7i1xd");

var $bNd3G = parcelRequire("bNd3G");
const $7179ddf7ab2ecdfc$var$handleError = (err, source)=>{
    const errorMessage = err instanceof Error ? err.message : String(err);
    const error = Error(`Data classification request failed: ${errorMessage}`);
    const errorType = (0, $eTZsp.getErrorType)(error);
    // prevent fetching extensions in case of no access
    if (errorType === (0, $eTZsp.DATA_CLASSIFICATION_NO_ACCESS)) throw error;
    (0, $ibWQr.fireInitializationFetchFailedEvent)(source, {
        isSSR: false,
        errorType: errorType,
        error: error
    });
    // otherwise, optimistically fetch the extensions
    return [];
};
async function $7179ddf7ab2ecdfc$var$getDataClassificationIssue(props, source) {
    try {
        const now = Date.now();
        const cachedResult = (0, $bNd3G.DataClassificationTagsCache).get(`${(0, $bNd3G.issueKeyPrefix)}-${props.issueKey}`);
        const isCacheResultTimePassed = Boolean(cachedResult && (0, $bNd3G.TTL) < now - cachedResult.timestamp);
        if (isCacheResultTimePassed || !cachedResult) {
            const data = await (0, $lRmyA.performGetRequest)(`/rest/internal/3/data-classification/resource/issue/${props.issueKey}`);
            (0, $bNd3G.DataClassificationTagsCache).set(`${(0, $bNd3G.issueKeyPrefix)}-${props.issueKey}`, {
                tags: data.tags,
                timestamp: now
            });
            return data.tags;
        }
        return cachedResult.tags;
    } catch (err) {
        return $7179ddf7ab2ecdfc$var$handleError(err, source);
    }
}
async function $7179ddf7ab2ecdfc$var$getDataClassificationProject(props, source) {
    try {
        const now = Date.now();
        const cachedResult = (0, $bNd3G.DataClassificationTagsCache).get(`${(0, $bNd3G.projectKeyPrefix)}-${props.projectIdOrKey}`);
        const isCacheResultTimePassed = Boolean(cachedResult && (0, $bNd3G.TTL) < now - cachedResult.timestamp);
        if (isCacheResultTimePassed || !cachedResult) {
            const data = await (0, $lRmyA.performGetRequest)(`/rest/internal/3/data-classification/resource/container/${props.projectIdOrKey}`);
            (0, $bNd3G.DataClassificationTagsCache).set(`${(0, $bNd3G.projectKeyPrefix)}-${props.projectIdOrKey}`, {
                tags: data.tags,
                timestamp: now
            });
            return data.tags;
        }
        return cachedResult.tags;
    } catch (err) {
        return $7179ddf7ab2ecdfc$var$handleError(err, source);
    }
}
const $7179ddf7ab2ecdfc$export$1635afa94064952c = async (props, source)=>{
    if (props !== null) {
        if ((0, $7i1xd.hasPrefetchedData)(props)) return props.tags;
        if ((0, $7i1xd.hasProjectIdOrKey)(props)) {
            const tags = await $7179ddf7ab2ecdfc$var$getDataClassificationProject(props, source);
            return tags;
        }
        if ((0, $7i1xd.hasIssueKey)(props)) {
            const tags = await $7179ddf7ab2ecdfc$var$getDataClassificationIssue(props, source);
            return tags;
        }
    }
    return [];
};

});
parcelRegister("7i1xd", function(module, exports) {

$parcel$export(module.exports, "hasPrefetchedData", () => $f4d16f0e4c0cff8e$export$c19d255b92c7c2da);
$parcel$export(module.exports, "hasProjectIdOrKey", () => $f4d16f0e4c0cff8e$export$494434246e5dea0d);
$parcel$export(module.exports, "hasIssueKey", () => $f4d16f0e4c0cff8e$export$b1490cfc7a90c75b);

var $1c8hB = parcelRequire("1c8hB");
const $f4d16f0e4c0cff8e$export$c19d255b92c7c2da = (props)=>props !== null && 'tags' in props && (0, (/*@__PURE__*/$parcel$interopDefault($1c8hB)))(props.tags);
const $f4d16f0e4c0cff8e$export$494434246e5dea0d = (props)=>props !== null && 'projectIdOrKey' in props;
const $f4d16f0e4c0cff8e$export$b1490cfc7a90c75b = (props)=>props !== null && 'issueKey' in props;

});

parcelRegister("bNd3G", function(module, exports) {

$parcel$export(module.exports, "TTL", () => $eb16233a4e558eb3$export$6ebb1381174e92a7);
$parcel$export(module.exports, "issueKeyPrefix", () => $eb16233a4e558eb3$export$a040db2850f159b0);
$parcel$export(module.exports, "projectKeyPrefix", () => $eb16233a4e558eb3$export$df256a06d24ff906);
$parcel$export(module.exports, "DataClassificationTagsCache", () => $eb16233a4e558eb3$export$b7adc37405b5ff0d);
const $eb16233a4e558eb3$export$6ebb1381174e92a7 = 60000;
const $eb16233a4e558eb3$export$a040db2850f159b0 = 'issue';
const $eb16233a4e558eb3$export$df256a06d24ff906 = 'project';
const $eb16233a4e558eb3$export$b7adc37405b5ff0d = new Map();

});


parcelRegister("aK1Xv", function(module, exports) {

$parcel$export(module.exports, "ForgeFetchError", () => $15fba2ae14b689a6$export$2e3b53e53bafa);
class $15fba2ae14b689a6$export$2e3b53e53bafa extends Error {
    constructor(message, traceId, errors){
        super(message);
        this.name = $15fba2ae14b689a6$export$2e3b53e53bafa.name;
        this.traceId = traceId;
        this.statusCodes = errors?.map((graphQLError)=>graphQLError?.extensions?.statusCode).filter((x)=>x != null);
        if (Error.captureStackTrace) Error.captureStackTrace(this, $15fba2ae14b689a6$export$2e3b53e53bafa);
    }
}

});

parcelRegister("h4b1Y", function(module, exports) {

$parcel$export(module.exports, "getTraceIdFromExtensions", () => $7f43992f867249de$export$eefb7f54c3b07211);
$parcel$export(module.exports, "getTraceIdFromError", () => $7f43992f867249de$export$9955d05ba83067ba);

var $7byHA = parcelRequire("7byHA");

var $aK1Xv = parcelRequire("aK1Xv");
const $7f43992f867249de$export$eefb7f54c3b07211 = ({ extensions: extensions })=>{
    const traceId = extensions?.gateway?.request_id;
    if (traceId && typeof traceId === 'string') return traceId;
    return undefined;
};
const $7f43992f867249de$export$9955d05ba83067ba = (error)=>{
    if (error instanceof (0, $aK1Xv.ForgeFetchError) || error instanceof (0, $7byHA.default)) return error.traceId;
    return undefined;
};

});

parcelRegister("dHbiB", function(module, exports) {

$parcel$export(module.exports, "buildForgeQuery", () => $adcc945170c9b90f$export$497b2dc04db7bd76);
const $adcc945170c9b90f$export$497b2dc04db7bd76 = (include)=>{
    const consentFields = `
    consentUrl
    currentUserConsent {
        user {
            aaid
        }
        appEnvironmentVersion {
            id
        }
        consentedAt
    }
    requiresUserConsent`;
    const scopesField = include.scopes === true ? 'scopes' : '';
    const licenseFields = `
    license {
        active
        type
        supportEntitlementNumber
        trialEndDate
        subscriptionEndDate
        isEvaluation
        billingPeriod
        ccpEntitlementId
        ccpEntitlementSlug
    }`;
    return `query jira_forge_frontendModules($contextIds: [ID!]! $extensionsFilter: [ExtensionContextsFilter!]! $dataClassificationTags: [ID!]!) {
        extensionContexts(contextIds: $contextIds) @optIn(to: "Access-Narrowing") {
            extensions(filter: $extensionsFilter) {
                id
                appVersion
                installationId
                environmentId
                environmentType
                environmentKey
                properties
                ${licenseFields}
                ${scopesField}
                type
                __typename
                ${consentFields}
                egress {
                    type
                    addresses
                }
                dataClassificationPolicyDecision(input: {
                    dataClassificationTags: $dataClassificationTags
                }) {
                    status
                }   
            }
        }
    }`;
};

});


parcelRegister("fSEqj", function(module, exports) {

$parcel$export(module.exports, "fetchForgeModule", () => $8729e3f9c8f23451$export$e1683e15cedb5f17);

var $jh2R9 = parcelRequire("jh2R9");

var $h1xZf = parcelRequire("h1xZf");

var $2Rqjr = parcelRequire("2Rqjr");

var $arKaN = parcelRequire("arKaN");

var $6vrw7 = parcelRequire("6vrw7");

var $4MOAS = parcelRequire("4MOAS");
const $8729e3f9c8f23451$var$dataClassificatedModulesConfig = {
    names: new Set(),
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    request: Promise.resolve({})
};
const $8729e3f9c8f23451$export$e1683e15cedb5f17 = async ({ cloudId: cloudId, moduleName: moduleName, dataClassification: dataClassification, shouldReturnANExtensions: shouldReturnANExtensions = false, contextIds: contextIds })=>{
    $8729e3f9c8f23451$var$dataClassificatedModulesConfig.names.add(moduleName);
    // simulate next tick so other resources could register their modules to fetch
    await new Promise((resolve)=>setTimeout(resolve, 0));
    const moduleNamesToFetch = Array.from($8729e3f9c8f23451$var$dataClassificatedModulesConfig.names);
    let extensions = [];
    let accessNarrowedExtensions = [];
    // If the fetch is not already handled
    if (moduleNamesToFetch.length > 0) {
        $8729e3f9c8f23451$var$dataClassificatedModulesConfig.names = new Set();
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        $8729e3f9c8f23451$var$dataClassificatedModulesConfig.request = (0, $arKaN.default)((0, $6vrw7.toCloudId)(cloudId), moduleNamesToFetch, dataClassification, undefined, (0, $2Rqjr.SOURCE_FULL_PAGE_APP), contextIds).then((extensionsMap)=>extensionsMap);
    }
    const result = await $8729e3f9c8f23451$var$dataClassificatedModulesConfig.request;
    extensions = result.extensions[(0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(moduleName)];
    if (shouldReturnANExtensions) accessNarrowedExtensions = result.accessNarrowedExtensions[(0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(moduleName)];
    const getExtensionsFilter = (fullPageModuleName)=>{
        switch(fullPageModuleName){
            case 0, $2Rqjr.ADMIN_PAGE_MODULE:
                return 0, $4MOAS.adminPageFilter;
            default:
                // filtered, as we allow only one extension per module
                return 0, $4MOAS.uniqueExtensionsFilter;
        }
    };
    return {
        extensions: getExtensionsFilter(moduleName)(extensions).sort((a, b)=>(0, $h1xZf.alphabeticalSort)(a.properties.title, b.properties.title)),
        accessNarrowedExtensions: getExtensionsFilter(moduleName)(accessNarrowedExtensions).sort((a, b)=>(0, $h1xZf.alphabeticalSort)(a.properties.title, b.properties.title))
    };
};

});
parcelRegister("h1xZf", function(module, exports) {

$parcel$export(module.exports, "alphabeticalSort", () => $cb5adf4a5b6d2436$export$89a1f01f2a7cb2a1);

var $gUUjF = parcelRequire("gUUjF");
const $cb5adf4a5b6d2436$export$89a1f01f2a7cb2a1 = (a, b)=>{
    // @ts-expect-error This condition will always return true since this function is always defined. Did you mean to call it instead?ts(2774)
    if (a && b && a.localeCompare && b.localeCompare) return a.localeCompare(b, 'en', {
        numeric: true,
        caseFirst: 'upper'
    });
    const typeOfA = a === null ? 'null' : typeof a;
    const typeOfB = b === null ? 'null' : typeof b;
    const error = new Error(`type of a: ${typeOfA}. type of b: ${typeOfB}`);
    (0, $gUUjF.default).safeErrorWithoutCustomerData('software.board.filter', 'localeCompare is not a function', error);
    return 1;
};

});

parcelRegister("4MOAS", function(module, exports) {

$parcel$export(module.exports, "uniqueExtensionsFilter", () => $7eebe06f4aced941$export$2b91ba95eded67f6);
$parcel$export(module.exports, "adminPageFilter", () => $7eebe06f4aced941$export$1eefd1d9cde49fd5);

var $lyOYo = parcelRequire("lyOYo");

var $70ON1 = parcelRequire("70ON1");
const $7eebe06f4aced941$export$2b91ba95eded67f6 = (extensions)=>(0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))(extensions, (extension)=>{
        const { appId: appId, envId: envId } = (0, $70ON1.parseExtensionId)(extension.id);
        return `${appId}_${envId}`;
    });
const $7eebe06f4aced941$export$1eefd1d9cde49fd5 = (extensions)=>{
    const configPageFilter = (extension)=>extension.properties.useAsConfig;
    const getStartedPageFilter = (extension)=>extension.properties.useAsGetStarted;
    const mainPageFilter = (extension)=>!configPageFilter(extension) && !getStartedPageFilter(extension);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const adminExtensions = extensions;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return [
        ...$7eebe06f4aced941$export$2b91ba95eded67f6(adminExtensions.filter(mainPageFilter)),
        ...$7eebe06f4aced941$export$2b91ba95eded67f6(adminExtensions.filter(configPageFilter)),
        ...$7eebe06f4aced941$export$2b91ba95eded67f6(adminExtensions.filter(getStartedPageFilter))
    ];
};

});




parcelRegister("jMYeN", function(module, exports) {

$parcel$export(module.exports, "toSections", () => $eb609126a990fbb2$export$29678d1e04c0e8c4);

var $5iWql = parcelRequire("5iWql");
/**
 * Just in case someone passes a broken object we don't want to blow up the sidebar
 */ const $eb609126a990fbb2$var$normalizeSection = (section)=>({
        header: section?.header,
        pages: Array.isArray(section?.pages) ? section.pages.map((page)=>({
                icon: page?.icon,
                route: page?.route,
                title: page?.title
            })) : []
    });
const $eb609126a990fbb2$export$29678d1e04c0e8c4 = (0, $5iWql.default)((extension)=>{
    const { properties: properties } = extension;
    // Only Custom UI supports subpages
    if (typeof properties.resource !== 'string') return [];
    // @ts-expect-error - TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'. | TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    if (typeof properties.pages !== 'undefined' && properties.pages?.length) // @ts-expect-error - TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    return [
        {
            pages: properties.pages
        }
    ].map($eb609126a990fbb2$var$normalizeSection);
    // @ts-expect-error - TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'. | TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    if (typeof properties.sections !== 'undefined' && properties.sections?.length) // @ts-expect-error - TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    return properties.sections.map($eb609126a990fbb2$var$normalizeSection);
    return [];
});

});

parcelRegister("eOutC", function(module, exports) {

$parcel$export(module.exports, "useMatchedExtension", () => $503fa4d7a9769196$export$13375c0abccaf6f6);
$parcel$export(module.exports, "useExtensionBasePath", () => $503fa4d7a9769196$export$25abed85383f0fbb);

var $eUqFw = parcelRequire("eUqFw");

var $70ON1 = parcelRequire("70ON1");
const $503fa4d7a9769196$export$13375c0abccaf6f6 = ({ modules: modules, match: match })=>(0, $eUqFw.useMemo)(()=>(modules || []).find((app)=>{
            const parsedExtensionId = (0, $70ON1.parseExtensionId)(app.id);
            return parsedExtensionId.appId === match.params.appId && parsedExtensionId.envId === match.params.envId;
        }), [
        modules,
        match.params.appId,
        match.params.envId
    ]);
const $503fa4d7a9769196$export$25abed85383f0fbb = (baseUrl, route)=>route !== undefined ? baseUrl.replace(/\/?$/, '').slice(0, -route.length - 1) : baseUrl.replace(/\/?$/, '');

});


parcelRegister("5w4hM", function(module, exports) {

$parcel$export(module.exports, "genericProjectSidebars", () => $541e179b5fa9e509$export$d88d2d25355bc89a);
$parcel$export(module.exports, "classicBoardSidebars", () => $541e179b5fa9e509$export$c04daf123cec1f1e);
$parcel$export(module.exports, "genericConnectSidebars", () => $541e179b5fa9e509$export$844d342b575ead35);

var $497qU = parcelRequire("497qU");

var $buaC1 = parcelRequire("buaC1");

var $hUM03 = parcelRequire("hUM03");

var $bt7QT = parcelRequire("bt7QT");

var $iOOlt = parcelRequire("iOOlt");

var $iTYGl = parcelRequire("iTYGl");

var $2Fzrk = parcelRequire("2Fzrk");

var $8rBPw = parcelRequire("8rBPw");
const $541e179b5fa9e509$export$d88d2d25355bc89a = [
    (0, $buaC1.default),
    (0, $iOOlt.default),
    (0, $iTYGl.default),
    (0, $2Fzrk.default),
    (0, $8rBPw.default)
];
const $541e179b5fa9e509$export$c04daf123cec1f1e = [
    (0, $2Fzrk.default),
    (0, $8rBPw.default)
];
const $541e179b5fa9e509$export$844d342b575ead35 = [
    ...$541e179b5fa9e509$export$d88d2d25355bc89a,
    (0, $497qU.default),
    (0, $hUM03.default),
    (0, $bt7QT.default)
];

});
parcelRegister("hUM03", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea1b194caac4ce1a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $av9ef = parcelRequire("av9ef");

var $9RvDp = parcelRequire("9RvDp");

const $ea1b194caac4ce1a$var$LazyGlobalAppsSettingsSidebar = (0, $7rh0R.lazyAfterPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("6OQOw")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-apps/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ea1b194caac4ce1a$var$GlobalAppsSettingsSidebar = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "globalAppsSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ea1b194caac4ce1a$var$LazyGlobalAppsSettingsSidebar, null)));
$ea1b194caac4ce1a$var$GlobalAppsSettingsSidebar.displayName = 'GlobalAppsSettingsSidebar';
var $ea1b194caac4ce1a$export$2e2bcd8739ae039 = $ea1b194caac4ce1a$var$GlobalAppsSettingsSidebar;

});
parcelRegister("6OQOw", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('iyqJ7')
        ]);
        const value = parcelRequire('60IuX');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("iyqJ7")
    ]).then(()=>parcelRequire('60IuX'));
}

});


parcelRegister("bt7QT", function(module, exports) {

$parcel$export(module.exports, "default", () => $93a98b92e63b4efb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $av9ef = parcelRequire("av9ef");

var $9RvDp = parcelRequire("9RvDp");

const $93a98b92e63b4efb$var$LazyGlobalSystemSettingsSidebar = (0, $7rh0R.lazyAfterPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("1DSRL")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-system/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $93a98b92e63b4efb$var$GlobalSystemSettingsSidebar = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "globalSystemSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($93a98b92e63b4efb$var$LazyGlobalSystemSettingsSidebar, null)));
$93a98b92e63b4efb$var$GlobalSystemSettingsSidebar.displayName = 'GlobalSystemSettingsSidebar';
var $93a98b92e63b4efb$export$2e2bcd8739ae039 = $93a98b92e63b4efb$var$GlobalSystemSettingsSidebar;

});
parcelRegister("1DSRL", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('SBVRB')
        ]);
        const value = parcelRequire('l15zb');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("SBVRB")
    ]).then(()=>parcelRequire('l15zb'));
}

});


parcelRegister("iOOlt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9c5b483f80318f8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $av9ef = parcelRequire("av9ef");

var $9RvDp = parcelRequire("9RvDp");

const $a9c5b483f80318f8$var$LazyClassicSoftwareProjectSidebar = (0, $7rh0R.lazyAfterPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("gR0lI")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/next-gen/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a9c5b483f80318f8$var$SoftwareProjectSidebar = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "softwareProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a9c5b483f80318f8$var$LazyClassicSoftwareProjectSidebar, null)));
$a9c5b483f80318f8$var$SoftwareProjectSidebar.displayName = 'SoftwareProjectSidebar';
var $a9c5b483f80318f8$export$2e2bcd8739ae039 = $a9c5b483f80318f8$var$SoftwareProjectSidebar;

});
parcelRegister("gR0lI", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('dsiAd'),
            load('2hmUs'),
            load('bCeK4'),
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('bqmoa')
        ]);
        const value = parcelRequire('dSgKD');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("dsiAd"),
        load("2hmUs"),
        load("bCeK4"),
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("bqmoa")
    ]).then(()=>parcelRequire('dSgKD'));
}

});


parcelRegister("iTYGl", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f67fc1f904f75a4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $av9ef = parcelRequire("av9ef");

var $9RvDp = parcelRequire("9RvDp");

const $2f67fc1f904f75a4$export$5b9febabdab63fba = (0, $7rh0R.lazyAfterPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("g5AdQ")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/servicedesk/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2f67fc1f904f75a4$var$ServicedeskSidebar = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "servicedeskProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2f67fc1f904f75a4$export$5b9febabdab63fba, null)));
$2f67fc1f904f75a4$var$ServicedeskSidebar.displayName = 'ServicedeskSidebar';
var $2f67fc1f904f75a4$export$2e2bcd8739ae039 = $2f67fc1f904f75a4$var$ServicedeskSidebar;

});
parcelRegister("g5AdQ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('ekVbM'),
            load('dsiAd'),
            load('2hmUs'),
            load('bCeK4'),
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('4673m')
        ]);
        const value = parcelRequire('2osKk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("ekVbM"),
        load("dsiAd"),
        load("2hmUs"),
        load("bCeK4"),
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("4673m")
    ]).then(()=>parcelRequire('2osKk'));
}

});


parcelRegister("2Fzrk", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9bc2c6e90de3714$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $av9ef = parcelRequire("av9ef");

var $9RvDp = parcelRequire("9RvDp");

const $d9bc2c6e90de3714$var$LazyClassicSoftwareProjectSidebar = (0, $7rh0R.lazyAfterPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("aFM47")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/software-classic/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d9bc2c6e90de3714$var$ClassicSoftwareProjectSidebar = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "classicSoftwareProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d9bc2c6e90de3714$var$LazyClassicSoftwareProjectSidebar, null)));
$d9bc2c6e90de3714$var$ClassicSoftwareProjectSidebar.displayName = 'ClassicSoftwareProjectSidebar';
var $d9bc2c6e90de3714$export$2e2bcd8739ae039 = $d9bc2c6e90de3714$var$ClassicSoftwareProjectSidebar;

});
parcelRegister("aFM47", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('dsiAd'),
            load('2hmUs'),
            load('bCeK4'),
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('iN4Tu')
        ]);
        const value = parcelRequire('7bWFF');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("dsiAd"),
        load("2hmUs"),
        load("bCeK4"),
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("iN4Tu")
    ]).then(()=>parcelRequire('7bWFF'));
}

});


parcelRegister("8rBPw", function(module, exports) {

$parcel$export(module.exports, "default", () => $d50106f0c2df90e8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $av9ef = parcelRequire("av9ef");

var $9RvDp = parcelRequire("9RvDp");

const $d50106f0c2df90e8$var$LazyUserSidebar = (0, $7rh0R.lazyAfterPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("4rDX8")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/user/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d50106f0c2df90e8$var$UserSidebar = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "user"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d50106f0c2df90e8$var$LazyUserSidebar, null)));
$d50106f0c2df90e8$var$UserSidebar.displayName = 'UserSidebar';
var $d50106f0c2df90e8$export$2e2bcd8739ae039 = $d50106f0c2df90e8$var$UserSidebar;

});
parcelRegister("4rDX8", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('dsiAd'),
            load('2hmUs'),
            load('bCeK4'),
            load('kmOrn')
        ]);
        const value = parcelRequire('fPz94');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("dsiAd"),
        load("2hmUs"),
        load("bCeK4"),
        load("kmOrn")
    ]).then(()=>parcelRequire('fPz94'));
}

});



parcelRegister("lWODs", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a283bb034822426$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $av9ef = parcelRequire("av9ef");

var $9RvDp = parcelRequire("9RvDp");

const $3a283bb034822426$var$LazyInsightObjectSchemaSidebar = (0, $7rh0R.lazyForPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("hhPKi")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/insight-object-schema/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3a283bb034822426$var$InsightObjectSchemaSidebar = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "insight-object-schema-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3a283bb034822426$var$LazyInsightObjectSchemaSidebar, null)));
$3a283bb034822426$var$InsightObjectSchemaSidebar.displayName = 'InsightObjectSchemaSidebar';
var $3a283bb034822426$export$2e2bcd8739ae039 = $3a283bb034822426$var$InsightObjectSchemaSidebar;

});
parcelRegister("hhPKi", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('92sUi'),
            load('i5RRW'),
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('c2mHX')
        ]);
        const value = parcelRequire('7JPCs');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("92sUi"),
        load("i5RRW"),
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("c2mHX")
    ]).then(()=>parcelRequire('7JPCs'));
}

});


parcelRegister("29Nmz", function(module, exports) {

$parcel$export(module.exports, "default", () => $884186ee0b4383e1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $av9ef = parcelRequire("av9ef");

var $9RvDp = parcelRequire("9RvDp");

const $884186ee0b4383e1$var$LazyPlanSidebar = (0, $7rh0R.lazyForPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("7xc3n")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/plan/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $884186ee0b4383e1$var$PlanSidebar = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "Plan"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($884186ee0b4383e1$var$LazyPlanSidebar, null)));
$884186ee0b4383e1$var$PlanSidebar.displayName = 'PlanSidebar';
var $884186ee0b4383e1$export$2e2bcd8739ae039 = $884186ee0b4383e1$var$PlanSidebar;

});
parcelRegister("7xc3n", function(module, exports) {






if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("kzUYN")),
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('4I2Cp')
        ]);
        const value = parcelRequire('k3Z6q');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("kzUYN")),
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("4I2Cp")
    ]).then(()=>parcelRequire('k3Z6q'));
}

});
parcelRegister("e5kw4", function(module, exports) {
"use strict";

var $9LbCl = parcelRequire("9LbCl");
module.exports = $9LbCl(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if ([].concat(existingLinks).some(function isCurrentBundle(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("9LbCl", function(module, exports) {
"use strict";
var $71b183d713ffdc67$var$cachedBundles = {};
var $71b183d713ffdc67$var$cachedPreloads = {};
var $71b183d713ffdc67$var$cachedPrefetches = {};
function $71b183d713ffdc67$var$getCache(type) {
    switch(type){
        case 'preload':
            return $71b183d713ffdc67$var$cachedPreloads;
        case 'prefetch':
            return $71b183d713ffdc67$var$cachedPrefetches;
        default:
            return $71b183d713ffdc67$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $71b183d713ffdc67$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});




parcelRegister("bSRyW", function(module, exports) {

$parcel$export(module.exports, "default", () => $67512e4ded0c1d23$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $av9ef = parcelRequire("av9ef");

var $9RvDp = parcelRequire("9RvDp");

const $67512e4ded0c1d23$var$LazyPolarisProjectSidebar = (0, $7rh0R.lazyAfterPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("7BQXR")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/polaris/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $67512e4ded0c1d23$var$PolarisProjectSidebar = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "polarisProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($67512e4ded0c1d23$var$LazyPolarisProjectSidebar, null)));
$67512e4ded0c1d23$var$PolarisProjectSidebar.displayName = 'PolarisProjectSidebar';
var $67512e4ded0c1d23$export$2e2bcd8739ae039 = $67512e4ded0c1d23$var$PolarisProjectSidebar;

});
parcelRegister("7BQXR", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2jChg')
        ]);
        const value = parcelRequire('51gNq');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2jChg")
    ]).then(()=>parcelRequire('51gNq'));
}

});


parcelRegister("aoOGZ", function(module, exports) {

$parcel$export(module.exports, "connectGeneralResources", () => $64e1806c7cddf26f$export$f34ab0d904621847);

var $3HCkE = parcelRequire("3HCkE");


const $64e1806c7cddf26f$export$f34ab0d904621847 = (0, $3HCkE.createResource)({
    type: (0, $4bb561a7936efe46$export$d5eed449bb62d4c1),
    getKey: ({ match: { params: { addonKey: addonKey, moduleKey: moduleKey } } })=>{
        // spa-router/src/common/types.js:
        /** TODO we are supporting `undefined` here because we are currently using both
		 * this version of the `Match` type, and react-routers version (which allows for `undefined`)
		 * To fix this we should move `matchPath` to our own util so we can apply our own types, then
		 * decide if we want to support undefined types.
		 */ if (addonKey !== null && addonKey !== undefined && moduleKey !== null && moduleKey !== undefined) return `${addonKey}-${moduleKey}`;
        return 'state';
    },
    getDataLoader: ()=>(parcelRequire("hk8sZ"))
});

});
const $4bb561a7936efe46$export$d5eed449bb62d4c1 = 'CONNECT_GENERAL';

parcelRegister("hk8sZ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('5H5no');
        const value = parcelRequire('aSOAb');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("5H5no").then(()=>parcelRequire('aSOAb'));
}

});



parcelRegister("2D8YV", function(module, exports) {

$parcel$export(module.exports, "messages", () => $be3f30c8885e888c$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $be3f30c8885e888c$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    sidebarNavigation: {
        "id": "page-container-v2.common.sidebar.sidebar-navigation",
        "defaultMessage": "Sidebar navigation"
    }
});

});

parcelRegister("j6voN", function(module, exports) {

$parcel$export(module.exports, "AsyncResizeButtonTooltip", () => $e7092259f8fc51fc$export$e12f5b3a390577de);

var $7rh0R = parcelRequire("7rh0R");

const $e7092259f8fc51fc$export$e12f5b3a390577de = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("Of5ul")), {
    ssr: false,
    moduleId: "./src/packages/page-container-v2/src/common/ui/sidebar/resize-button-tooltip/main.tsx"
});

});
parcelRegister("Of5ul", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('lm6kY');
        const value = parcelRequire('eNPes');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("lm6kY").then(()=>parcelRequire('eNPes'));
}

});



parcelRegister("4LQUt", function(module, exports) {

$parcel$export(module.exports, "TopNav", () => $2934d73e9d5f196a$export$41d0d88a6b0e456f);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("8fxTv");
var $7webZ = parcelRequire("7webZ");
var $8fxTv = parcelRequire("8fxTv");

var $5kDtB = parcelRequire("5kDtB");

var $iBTyI = parcelRequire("iBTyI");

var $eDbLL = parcelRequire("eDbLL");

var $aYtGv = parcelRequire("aYtGv");

var $c9TLT = parcelRequire("c9TLT");

var $0cdA8 = parcelRequire("0cdA8");

var $4qhD6 = parcelRequire("4qhD6");

var $bAQOb = parcelRequire("bAQOb");

var $eQbJ4 = parcelRequire("eQbJ4");

var $6VKSg = parcelRequire("6VKSg");

var $1GeZ8 = parcelRequire("1GeZ8");

var $gGtKh = parcelRequire("gGtKh");

var $inC6u = parcelRequire("inC6u");

var $jK1pm = parcelRequire("jK1pm");

var $ghXjN = parcelRequire("ghXjN");

var $3EdDr = parcelRequire("3EdDr");

var $7xu2f = parcelRequire("7xu2f");
/* IMPORTANT:
 * When making any changes to the OLD component, please ensure that you also make the same changes to the
 * NEW component. The feature flag used is part of the Navigation Refresh work and we need to ensure that
 * we do not introduce tech debt for the roll-out by only updating the current component that is due to be
 * removed.
 *
 * If you have any concerns or questions please reach out to the #jira-navigation channel. Thanks!
 */ const $2934d73e9d5f196a$var$APP_NAVIGATION_TRACE_KEY = 'app_navigation';
const $2934d73e9d5f196a$var$LegacyPageNavigationStyles = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("style", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `
                    #page-body { width: 100vw; max-width: 100%; }
                    #cloneissueprogressform { margin-top: ${(0, $c9TLT.gridSize) * 3}px; }
                    [data-testid="Content"] {margin-top: calc(${(0, $aYtGv.PAGE_LAYOUT_OFFSET_TOP)})!important;}
                    #view-projects-content { margin-top: calc(-1 * ${(0, $aYtGv.PAGE_LAYOUT_OFFSET_TOP)}); } /* admin project dir hack */
                `
        }
    });
const $2934d73e9d5f196a$var$NewTopNav = ()=>{
    const fullscreenRef = (0, $eUqFw.useRef)(null);
    const { isFullscreen: isFullscreen } = (0, $eQbJ4.useIsFullscreen)(fullscreenRef.current);
    const { shouldRender: shouldRender } = (0, $6VKSg.useTopNavState)();
    const onFail = (0, $4qhD6.useExperienceFail)({
        experience: (0, $5kDtB.EXPERIENCE_NAVIGATION_TOP_MAIN)
    });
    const height = isFullscreen ? 0 : (0, $aYtGv.HORIZONTAL_GLOBAL_NAV_HEIGHT);
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "top-navigation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "topNavigationSkipLink",
        packageName: "jiraPageContainerV2",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ghXjN.TopNavigationSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2934d73e9d5f196a$var$LegacyPageNavigationStyles, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1GeZ8.TopNavigation), {
        isFixed: true,
        height: height,
        id: "ak-jira-navigation"
    }, !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iBTyI.AtlassianNavigationStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "navigation.atlassian-navigation",
        packageName: "jiraPageContainerV2",
        fallback: "flag",
        onError: onFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "top_navigation_skeleton",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eDbLL.JiraAtlassianNavigationSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fxTv.NavTopPerformanceMark), {
        metricKey: (0, $7webZ.NAVIGATION_TOP_MARKS).bundleLoadStart
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fxTv.NavTopSSRPerformanceMark), {
        metricKey: (0, $7webZ.NAVIGATION_TOP_MARKS).renderSsrStart
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $inC6u.RenderTracerMark), {
        type: "start",
        traceKey: $2934d73e9d5f196a$var$APP_NAVIGATION_TRACE_KEY
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7xu2f.AsyncAtlassianNavigation), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $inC6u.RenderTracerMark), {
        type: "end",
        traceKey: $2934d73e9d5f196a$var$APP_NAVIGATION_TRACE_KEY
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fxTv.NavTopSSRPerformanceMark), {
        metricKey: (0, $7webZ.NAVIGATION_TOP_MARKS).renderSsrEnd
    })))));
};
/**
 * Implements a responsive top navigation bar that adjusts for fullscreen view and renders
 * based on application state. It ensures seamless navigation experience across different
 * sections of the application while handling errors gracefully and tracking performance.
 */ const $2934d73e9d5f196a$var$OldTopNav = ()=>{
    const fullscreenRef = (0, $eUqFw.useRef)(null);
    const { isFullscreen: isFullscreen } = (0, $eQbJ4.useIsFullscreen)(fullscreenRef.current);
    const { shouldRender: shouldRender } = (0, $6VKSg.useTopNavState)();
    const onFail = (0, $4qhD6.useExperienceFail)({
        experience: (0, $5kDtB.EXPERIENCE_NAVIGATION_TOP_MAIN)
    });
    const height = isFullscreen ? 0 : (0, $aYtGv.HORIZONTAL_GLOBAL_NAV_HEIGHT);
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "top-navigation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "topNavigationSkipLink",
        packageName: "jiraPageContainer",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ghXjN.TopNavigationSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2934d73e9d5f196a$var$LegacyPageNavigationStyles, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3EdDr.ZIndexWrapper), {
        zIndex: (0, $c9TLT.layers).navigation,
        // @ts-expect-error - TS2322 - Type '{ children: Element; zIndex: 200; top: string; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<Component<ThemedOuterStyledProps<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, any>, any, any>> & Readonly<...> & Readonly<...>'.
        top: (0, $1GeZ8.UNSAFE_DO_NOT_USE_BANNER_HEIGHT),
        "data-fullscreen-id": "fullscreen.page-container-v2.topnav",
        ref: fullscreenRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1GeZ8.TopNavigation), {
        isFixed: true,
        height: height,
        id: "ak-jira-navigation"
    }, !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iBTyI.AtlassianNavigationStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "navigation.atlassian-navigation",
        packageName: "jiraPageContainer",
        fallback: "flag",
        onError: onFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "top_navigation_skeleton",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eDbLL.JiraAtlassianNavigationSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fxTv.NavTopPerformanceMark), {
        metricKey: (0, $7webZ.NAVIGATION_TOP_MARKS).bundleLoadStart
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fxTv.NavTopSSRPerformanceMark), {
        metricKey: (0, $7webZ.NAVIGATION_TOP_MARKS).renderSsrStart
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $inC6u.RenderTracerMark), {
        type: "start",
        traceKey: $2934d73e9d5f196a$var$APP_NAVIGATION_TRACE_KEY
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7xu2f.AsyncAtlassianNavigation), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $inC6u.RenderTracerMark), {
        type: "end",
        traceKey: $2934d73e9d5f196a$var$APP_NAVIGATION_TRACE_KEY
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fxTv.NavTopSSRPerformanceMark), {
        metricKey: (0, $7webZ.NAVIGATION_TOP_MARKS).renderSsrEnd
    }))))));
};
const $2934d73e9d5f196a$export$41d0d88a6b0e456f = (0, $bAQOb.componentWithFF)('platform.atlassian.griffin-new-page-layout', $2934d73e9d5f196a$var$NewTopNav, $2934d73e9d5f196a$var$OldTopNav);

});
parcelRegister("5kDtB", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $e27f7da44da2e940$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "DEFAULT_LOAD_COUNT_FAV", () => $e27f7da44da2e940$export$ea341e6cc435ed40);
$parcel$export(module.exports, "DEFAULT_LOAD_COUNT_VIEWED", () => $e27f7da44da2e940$export$cb66c02d110b1531);
$parcel$export(module.exports, "DEFAULT_LOAD_COUNT_RECENT", () => $e27f7da44da2e940$export$22ea57e66775a6b2);
$parcel$export(module.exports, "TOP_LEVEL_ERROR_BOUNDARY_ID", () => $e27f7da44da2e940$export$4766f0c4b6fe35dc);
$parcel$export(module.exports, "NAVIGATION_ITEM_ID", () => $e27f7da44da2e940$export$1a9b265c626e9d44);
$parcel$export(module.exports, "MODAL_ID", () => $e27f7da44da2e940$export$ebdd5a8e5b1c2de5);
$parcel$export(module.exports, "PROFILE_SPOTLIGHT_KEY", () => $e27f7da44da2e940$export$6037915bf3452cf3);
$parcel$export(module.exports, "HELP_SPOTLIGHT_KEY", () => $e27f7da44da2e940$export$286c2faa2103eb9c);
$parcel$export(module.exports, "SEARCH_SPOTLIGHT_KEY", () => $e27f7da44da2e940$export$c0d6ac131d4391b9);
$parcel$export(module.exports, "PROJECTS_SPOTLIGHT_KEY", () => $e27f7da44da2e940$export$8d9442dfaec4086f);
$parcel$export(module.exports, "EXPERIENCE_NAVIGATION_TOP_MAIN", () => $e27f7da44da2e940$export$3014c5ec440d8824);
$parcel$export(module.exports, "EXPERIENCE_NAVIGATION_TOP_MENU", () => $e27f7da44da2e940$export$69cbedccc0df48);
$parcel$export(module.exports, "YOUR_WORK_DROPDOWN_TAB_ID", () => $e27f7da44da2e940$export$1935aad1d702494c);
$parcel$export(module.exports, "JSW_TMP_BACKLOG_BOARD_REGEXP", () => $e27f7da44da2e940$export$cc578bc72d7a7308);
const $e27f7da44da2e940$export$b8b9d90f9e5bd72b = '@atlassian/jira-atlassian-navigation';
const $e27f7da44da2e940$export$ea341e6cc435ed40 = 15;
const $e27f7da44da2e940$export$8666f31c8873bff = 10;
const $e27f7da44da2e940$export$cb66c02d110b1531 = 10;
const $e27f7da44da2e940$export$22ea57e66775a6b2 = 5;
const $e27f7da44da2e940$export$4766f0c4b6fe35dc = 'TOP_LEVEL';
const $e27f7da44da2e940$export$1a9b265c626e9d44 = {
    ADDONS: 'apps',
    CREATE: 'createIssue',
    APP_SWITCHER: 'atlassianSwitcher',
    DASHBOARDS: 'dashboards',
    FILTERS: 'filters',
    HELP: 'help',
    HELP_BADGE: 'helpBadge',
    HOME: 'home',
    INSIGHT: 'insight',
    LOGO: 'productLogo',
    NOTIFICATIONS: 'notifications',
    PEOPLE: 'people',
    PLANS: 'plans',
    PROFILE: 'profile',
    PROJECTS: 'projects',
    SEARCH: 'search',
    SERVICE_HUB: 'services',
    SETTINGS: 'settings',
    SIGN_IN: 'signIn',
    YOUR_WORK_DROPDOWN: 'yourWorkDropdown',
    CONVERSATION_ASSISTANT: 'conversationAssistant'
};
const $e27f7da44da2e940$export$ebdd5a8e5b1c2de5 = {
    DASHBOARD_CREATE: 'DASHBOARD_CREATE',
    KEYBOARD_SHORTCUTS: 'keyboard-shortcuts',
    PROJECT_CREATE: 'PROJECT_CREATE'
};
const $e27f7da44da2e940$export$6037915bf3452cf3 = 'profile-spotlight';
const $e27f7da44da2e940$export$286c2faa2103eb9c = 'help-spotlight';
const $e27f7da44da2e940$export$c0d6ac131d4391b9 = 'search-spotlight';
const $e27f7da44da2e940$export$8d9442dfaec4086f = 'projects-spotlight';
const $e27f7da44da2e940$export$3014c5ec440d8824 = 'viewAtlassianNavigation';
const $e27f7da44da2e940$export$69cbedccc0df48 = 'viewAtlassianNavigationMenu';
const $e27f7da44da2e940$export$1935aad1d702494c = {
    RECENT: 'RECENT',
    BOARDS: 'BOARDS',
    QUEUES: 'QUEUES',
    ASSIGNED_TO_ME: 'ASSIGNED_TO_ME',
    ADD_FILTER: 'ADD_FILTER',
    ALERTS: 'ALERTS'
};
const $e27f7da44da2e940$export$bbaa49b5be375ff3 = 3;
const $e27f7da44da2e940$export$cc578bc72d7a7308 = /jira\/software\/projects\/[a-zA-Z0-9]+\/boards\/\d+(\/backlog)?/;
const $e27f7da44da2e940$export$9b8f5a607ecb9c5c = 'com.atlassian.jira.slack';

});

parcelRegister("iBTyI", function(module, exports) {

$parcel$export(module.exports, "AtlassianNavigationStart", () => $27c6c05e2b688f95$export$831e6a6e875b5ef8);

var $eUqFw = parcelRequire("eUqFw");

var $bDhRl = parcelRequire("bDhRl");

var $kJlBc = parcelRequire("kJlBc");

var $3O0Td = parcelRequire("3O0Td");
var $lcJyp = parcelRequire("lcJyp");

var $5kDtB = parcelRequire("5kDtB");
const $27c6c05e2b688f95$export$831e6a6e875b5ef8 = ()=>{
    const [{ location: location }] = (0, $kJlBc.useRouter)();
    const [, { setAppStartWithAppId: setAppStartWithAppId }] = (0, $lcJyp.useSpaStateActions)();
    const pageId = (0, $3O0Td.usePageId)();
    const startRef = (0, $eUqFw.useRef)({
        location: location,
        startTime: Date.now()
    });
    (0, $eUqFw.useMemo)(()=>{
        if (location !== startRef.current.location) startRef.current = {
            location: location,
            startTime: Date.now()
        };
    }, [
        location
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        setAppStartWithAppId((0, $9c22638d2f17f9db$export$3a54edb6ba4daa82), startRef.current.startTime);
    }, [
        location,
        setAppStartWithAppId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bDhRl.ExperienceStart), {
        experience: (0, $5kDtB.EXPERIENCE_NAVIGATION_TOP_MAIN),
        analyticsSource: "atlassian-navigation",
        experienceId: pageId
    });
};

});

parcelRegister("eDbLL", function(module, exports) {

$parcel$export(module.exports, "JiraAtlassianNavigationSkeleton", () => $dcd9958c5ab18a6d$export$38e532bc6b824200);

var $eUqFw = parcelRequire("eUqFw");

var $3g3mg = parcelRequire("3g3mg");

var $84CBi = parcelRequire("84CBi");

var $lStiz = parcelRequire("lStiz");
const $dcd9958c5ab18a6d$export$38e532bc6b824200 = ()=>{
    const theme = (0, $lStiz.useTheme)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $84CBi.default), {
        name: "top-navigation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3g3mg.NavigationSkeleton), {
        theme: theme
    }));
};

});
parcelRegister("3g3mg", function(module, exports) {

$parcel$export(module.exports, "NavigationSkeleton", () => $eff777ab229b562f$export$ad5e8e6ace98cc2);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");


var $iMTf6 = parcelRequire("iMTf6");
var $g668r = parcelRequire("g668r");

var $84HFD = parcelRequire("84HFD");

var $46eNd = parcelRequire("46eNd");

var $kAgsw = parcelRequire("kAgsw");

var $gHwzO = parcelRequire("gHwzO");

var $6gCu1 = parcelRequire("6gCu1");
function $eff777ab229b562f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $eff777ab229b562f$var$containerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $cbe92d4f348ad4dd$export$30fa7cc5f2690a43),
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
    borderBlockEnd: `1px solid ${`var(--ds-border, ${(0, $PdmhA.N30)})`}`,
    paddingInlineEnd: "var(--ds-space-150, 12px)",
    paddingInlineStart: "var(--ds-space-150, 12px)"
});
const $eff777ab229b562f$var$leftStyles = {
    name: "vtikxo",
    styles: "display:flex;min-width:0;height:inherit;align-items:center;flex-grow:1;& > *{flex-shrink:0;}"
};
const $eff777ab229b562f$var$rightStyles = {
    name: "1mwlrd6",
    styles: "display:flex;align-items:center;flex-shrink:0;& > *{flex-shrink:0;margin-inline-end:var(--ds-space-050, 4px);}"
};
const $eff777ab229b562f$export$ad5e8e6ace98cc2 = ({ primaryItemsCount: primaryItemsCount = 4, secondaryItemsCount: secondaryItemsCount = 4, theme: theme = (0, $iMTf6.defaultTheme), showSiteName: showSiteName = false, shouldShowSearch: shouldShowSearch = true, testId: testId })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $g668r.ThemeProvider), {
        value: theme
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.navigation,
        css: $eff777ab229b562f$var$containerStyles,
        "data-testid": testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $eff777ab229b562f$var$leftStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $84HFD.IconButtonSkeleton), {
        marginLeft: 0,
        marginRight: 5,
        size: 26
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $kAgsw.ProductHomeSkeleton), {
        showSiteName: showSiteName
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $46eNd.PrimaryItemsContainerSkeleton), {
        count: primaryItemsCount
    })), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $eff777ab229b562f$var$rightStyles
    }, shouldShowSearch && /*#__PURE__*/ (0, $byn9U.jsx)((0, $6gCu1.SearchSkeleton), null), Array.from({
        length: secondaryItemsCount
    }, (_, index)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $84HFD.IconButtonSkeleton), {
            key: index,
            marginLeft: 0,
            marginRight: 4,
            size: 26
        })), /*#__PURE__*/ (0, $byn9U.jsx)((0, $gHwzO.ProfileSkeleton), null))));
};
var $eff777ab229b562f$export$2e2bcd8739ae039 = $eff777ab229b562f$export$ad5e8e6ace98cc2;

});
const $cbe92d4f348ad4dd$export$30fa7cc5f2690a43 = 56;
const $cbe92d4f348ad4dd$export$4033a111ca79977d = 1280;
const $cbe92d4f348ad4dd$export$24ec62cee78b7042 = 1130;
const $cbe92d4f348ad4dd$export$d8bde68ac946124f = '--ds--ans--fbc';
const $cbe92d4f348ad4dd$export$73e44f54603a0964 = '--ds--ans--hbgc';
const $cbe92d4f348ad4dd$export$13f8aa8f663f4c99 = '--ds--ans--bgc';
const $cbe92d4f348ad4dd$export$d81606c1fc5119bc = '--ds--ans--c';
const $cbe92d4f348ad4dd$export$65f656ad520ea71 = '--ds--ans--bc';

parcelRegister("84HFD", function(module, exports) {

$parcel$export(module.exports, "IconButtonSkeleton", () => $24ac6b86ea6f5c27$export$7a24471cb6f25433);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $9JmWF = parcelRequire("9JmWF");
function $24ac6b86ea6f5c27$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $24ac6b86ea6f5c27$var$buttonHeight = "var(--ds-space-400, 32px)";
const $24ac6b86ea6f5c27$var$skeletonStyles = {
    name: "28gj0e",
    styles: "border-radius:var(--ds-border-radius-circle, 50%);opacity:0.15"
};
const $24ac6b86ea6f5c27$export$7a24471cb6f25433 = ({ className: className, marginLeft: marginLeft, marginRight: marginRight, size: size })=>{
    const theme = (0, $9JmWF.useTheme)();
    const dynamicStyles = {
        marginLeft: typeof marginLeft === 'number' ? marginLeft : "var(--ds-space-050, 4px)",
        marginRight: typeof marginRight === 'number' ? marginRight : 0,
        width: typeof size === 'number' ? size : $24ac6b86ea6f5c27$var$buttonHeight,
        height: typeof size === 'number' ? size : $24ac6b86ea6f5c27$var$buttonHeight,
        ...theme.mode.skeleton
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: dynamicStyles,
        css: $24ac6b86ea6f5c27$var$skeletonStyles
    });
};

});

parcelRegister("46eNd", function(module, exports) {

$parcel$export(module.exports, "PrimaryItemsContainerSkeleton", () => $7ae8a743368be220$export$fdfc48d2117b79a8);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $cX3lo = parcelRequire("cX3lo");
function $7ae8a743368be220$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7ae8a743368be220$var$primaryButtonSkeletonStyles = {
    name: "yn5kop",
    styles: "margin-inline-end:var(--ds-space-150, 12px);margin-inline-start:var(--ds-space-150, 12px)"
};
const $7ae8a743368be220$export$fdfc48d2117b79a8 = /*#__PURE__*/ (0, $eUqFw.memo)(({ count: count })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, Array.from({
        length: count
    }, (_, index)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $cX3lo.PrimaryButtonSkeleton), {
            key: index,
            css: $7ae8a743368be220$var$primaryButtonSkeletonStyles
        }))));

});
parcelRegister("cX3lo", function(module, exports) {

$parcel$export(module.exports, "PrimaryButtonSkeleton", () => $f9fcff453893d63e$export$4bc51fe36728414d);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $9JmWF = parcelRequire("9JmWF");
const $f9fcff453893d63e$var$paddingAll = 4;
const $f9fcff453893d63e$var$buttonHeight = 32;
const $f9fcff453893d63e$var$skeletonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-flex',
    width: '68px',
    height: `${$f9fcff453893d63e$var$buttonHeight - $f9fcff453893d63e$var$paddingAll * 2.5}px`,
    borderRadius: "var(--ds-border-radius, 4px)",
    opacity: 0.15
});
const $f9fcff453893d63e$export$4bc51fe36728414d = (props)=>{
    const theme = (0, $9JmWF.useTheme)();
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.skeleton,
        css: $f9fcff453893d63e$var$skeletonStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className
    });
};

});


parcelRegister("kAgsw", function(module, exports) {

$parcel$export(module.exports, "ProductHomeSkeleton", () => $6448d18649d80c24$export$3e79e535d76cce4b);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");


var $9JmWF = parcelRequire("9JmWF");

var $jvgG9 = parcelRequire("jvgG9");
const $6448d18649d80c24$var$VAR_PRODUCT_HOME_COLOR_ACTIVE = '--product-home-color-active';
const $6448d18649d80c24$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE = '--product-home-bg-color-active';
const $6448d18649d80c24$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE = '--product-home-box-shadow-active';
const $6448d18649d80c24$var$VAR_PRODUCT_HOME_COLOR_FOCUS = '--product-home-color-focus';
const $6448d18649d80c24$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS = '--product-home-bg-color-focus';
const $6448d18649d80c24$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS = '--product-home-box-shadow-focus';
const $6448d18649d80c24$var$VAR_PRODUCT_HOME_COLOR_HOVER = '--product-home-color-hover';
const $6448d18649d80c24$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER = '--product-home-bg-color-hover';
const $6448d18649d80c24$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER = '--product-home-box-shadow-hover';
const $6448d18649d80c24$var$VAR_SITE_TITLE_BG_COLOR_AFTER = '--site-title-bg-color-after';
const $6448d18649d80c24$var$productHomeButtonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    padding: "var(--ds-space-050, 4px)",
    alignItems: 'center',
    background: 'none',
    border: 0,
    borderRadius: "var(--ds-border-radius, 3px)",
    color: 'inherit',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-moz-focus-inner': {
        border: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:first-of-type': {
        marginInlineStart: 0
    },
    '&:active': {
        backgroundColor: `var(${$6448d18649d80c24$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE})`,
        boxShadow: `var(${$6448d18649d80c24$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE})`,
        color: `var(${$6448d18649d80c24$var$VAR_PRODUCT_HOME_COLOR_ACTIVE})`
    },
    '&:focus': {
        backgroundColor: `var(${$6448d18649d80c24$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS})`,
        boxShadow: `var(${$6448d18649d80c24$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS})`,
        color: `var(${$6448d18649d80c24$var$VAR_PRODUCT_HOME_COLOR_FOCUS})`,
        outline: 0
    },
    '&:hover': {
        backgroundColor: `var(${$6448d18649d80c24$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER})`,
        boxShadow: `var(${$6448d18649d80c24$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER})`,
        color: `var(${$6448d18649d80c24$var$VAR_PRODUCT_HOME_COLOR_HOVER})`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'div&': {
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $cbe92d4f348ad4dd$export$4033a111ca79977d) - 0.1}px)`]: {
        margin: `0 ${"var(--ds-space-100, 8px)"}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $cbe92d4f348ad4dd$export$4033a111ca79977d}px)`]: {
        margin: `0 ${"var(--ds-space-200, 16px)"}`
    }
});
const $6448d18649d80c24$var$productLogoStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    width: 120,
    maxWidth: 120,
    height: 24,
    maxHeight: 28,
    opacity: 0.15,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        maxHeight: 24
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $cbe92d4f348ad4dd$export$4033a111ca79977d) - 0.1}px)`]: {
        display: 'none'
    }
});
const $6448d18649d80c24$var$productIconStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    width: 28,
    height: 28,
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    opacity: 0.15,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        maxHeight: 24
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $cbe92d4f348ad4dd$export$4033a111ca79977d}px)`]: {
        display: 'none'
    }
});
const $6448d18649d80c24$var$siteTitleStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    width: "var(--ds-space-500, 40px)",
    alignItems: 'center',
    backgroundColor: 'transparent',
    marginInlineEnd: "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-050, 4px)",
    paddingInlineEnd: "var(--ds-space-200, 16px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        width: '100%',
        height: 14,
        backgroundColor: `var(${$6448d18649d80c24$var$VAR_SITE_TITLE_BG_COLOR_AFTER})`,
        borderRadius: "var(--ds-border-radius, 4px)",
        content: '""'
    }
});
const $6448d18649d80c24$export$3e79e535d76cce4b = ({ showSiteName: showSiteName })=>{
    const theme = (0, $9JmWF.useTheme)();
    const primaryButton = theme.mode.primaryButton;
    const productHomeButtonDynamicStyles = (0, $jvgG9.stripEmptyProperties)({
        [$6448d18649d80c24$var$VAR_PRODUCT_HOME_COLOR_ACTIVE]: primaryButton.active.color,
        [$6448d18649d80c24$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE]: primaryButton.active.backgroundColor,
        [$6448d18649d80c24$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE]: primaryButton.active.boxShadow,
        [$6448d18649d80c24$var$VAR_PRODUCT_HOME_COLOR_FOCUS]: primaryButton.focus.color,
        [$6448d18649d80c24$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS]: primaryButton.focus.backgroundColor,
        [$6448d18649d80c24$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS]: primaryButton.focus.boxShadow,
        [$6448d18649d80c24$var$VAR_PRODUCT_HOME_COLOR_HOVER]: primaryButton.hover.color,
        [$6448d18649d80c24$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER]: primaryButton.hover.backgroundColor,
        [$6448d18649d80c24$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER]: primaryButton.hover.boxShadow,
        [$6448d18649d80c24$var$VAR_SITE_TITLE_BG_COLOR_AFTER]: theme.mode.skeleton.backgroundColor
    });
    const siteTitleDynamicStyles = {
        borderRight: theme.mode.productHome.borderRight,
        opacity: theme.mode.skeleton.opacity,
        [$6448d18649d80c24$var$VAR_SITE_TITLE_BG_COLOR_AFTER]: theme.mode.skeleton.backgroundColor
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: productHomeButtonDynamicStyles,
        css: $6448d18649d80c24$var$productHomeButtonStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.skeleton,
        css: $6448d18649d80c24$var$productLogoStyles
    }), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.skeleton,
        css: $6448d18649d80c24$var$productIconStyles
    })), showSiteName && /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: siteTitleDynamicStyles,
        css: $6448d18649d80c24$var$siteTitleStyles
    }));
};

});

parcelRegister("gHwzO", function(module, exports) {

$parcel$export(module.exports, "ProfileSkeleton", () => $0a17d43c9a73388e$export$2bab43fd33adda3b);

var $eUqFw = parcelRequire("eUqFw");

var $84HFD = parcelRequire("84HFD");
const $0a17d43c9a73388e$export$2bab43fd33adda3b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $84HFD.IconButtonSkeleton), {
        marginLeft: 6,
        marginRight: 6,
        size: 26
    });

});

parcelRegister("6gCu1", function(module, exports) {

$parcel$export(module.exports, "SearchSkeleton", () => $5cabc7fd981f681f$export$d8fbade3e5bbb8e0);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");


var $9JmWF = parcelRequire("9JmWF");

var $84HFD = parcelRequire("84HFD");
const $5cabc7fd981f681f$var$searchInputContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    marginRight: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    marginLeft: "var(--ds-space-250, 20px)",
    position: 'relative',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $cbe92d4f348ad4dd$export$24ec62cee78b7042) - 1}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        display: 'none !important'
    }
});
const $5cabc7fd981f681f$var$searchInputSkeletonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    boxSizing: 'border-box',
    width: '220px',
    height: "var(--ds-space-400, 32px)",
    padding: `0 ${"var(--ds-space-100, 8px)"} 0 ${"var(--ds-space-500, 40px)"}`,
    borderRadius: "var(--ds-border-radius-200, 6px)",
    opacity: 0.15
});
const $5cabc7fd981f681f$var$searchIconStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $cbe92d4f348ad4dd$export$24ec62cee78b7042}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        display: 'none !important'
    }
});
const $5cabc7fd981f681f$export$d8fbade3e5bbb8e0 = ()=>{
    const theme = (0, $9JmWF.useTheme)();
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $5cabc7fd981f681f$var$searchInputContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.skeleton,
        css: $5cabc7fd981f681f$var$searchInputSkeletonStyles
    })), /*#__PURE__*/ (0, $byn9U.jsx)((0, $84HFD.IconButtonSkeleton), {
        css: $5cabc7fd981f681f$var$searchIconStyles,
        marginRight: 5,
        size: 26
    }));
};

});


parcelRegister("lStiz", function(module, exports) {

$parcel$export(module.exports, "useTheme", () => $d56434d06e6d3c92$export$93d4e7f90805808f);

var $eUqFw = parcelRequire("eUqFw");

var $7slJv = parcelRequire("7slJv");

var $iX87Q = parcelRequire("iX87Q");
var $4q38b = parcelRequire("4q38b");

var $7fSR6 = parcelRequire("7fSR6");

var $3MEW8 = parcelRequire("3MEW8");

var $hS368 = parcelRequire("hS368");

var $3jHKg = parcelRequire("3jHKg");
const $d56434d06e6d3c92$var$caseInsensitiveEquals = (one, two)=>one.toLowerCase() === two.toLowerCase();
const $d56434d06e6d3c92$var$calculateBackground = (backgroundColor, isDarkMode)=>{
    // White is a proxy for 'default' when setting accent colours, we really want to default to 'elevation.surface'
    if ($d56434d06e6d3c92$var$caseInsensitiveEquals(backgroundColor, '#ffffff')) {
        // getTokenValue doesn't work in SSR thus hardcode, fix in: https://product-fabric.atlassian.net/browse/DSP-9781
        const fallback = isDarkMode ? '#1d2125' : '#ffffff';
        // Can't be getToken() as AK Nav needs a hex string. It parses it to determine the correct text color
        return (0, $iX87Q.default)('elevation.surface', fallback);
    }
    return isDarkMode ? (0, $3jHKg.capLightness)(backgroundColor, 35) : backgroundColor;
};
const $d56434d06e6d3c92$var$useIsDarkThemeResolver = ()=>{
    // The best source of theme info. But doesn't work in SSR, fix in: https://product-fabric.atlassian.net/browse/DSP-9781
    const { colorMode: colorMode } = (0, $4q38b.default)();
    // This works in SSR, but we need the browser to resolve 'auto', so we are wrong in SSR if 'auto' resolves to 'dark'
    const { theme: preference } = (0, $3MEW8.useThemePreference)();
    return false ? preference === 'dark' : colorMode === 'dark';
};
const $d56434d06e6d3c92$export$93d4e7f90805808f = ()=>{
    const [{ navigationTheme: { usesCustomColours: usesCustomColours, backgroundColor: backgroundColor, highlightColor: highlightColor } }] = (0, $7fSR6.useTheme)();
    const isDarkMode = $d56434d06e6d3c92$var$useIsDarkThemeResolver();
    const bg = (0, $eUqFw.useMemo)(()=>$d56434d06e6d3c92$var$calculateBackground(backgroundColor, isDarkMode), [
        backgroundColor,
        isDarkMode
    ]);
    (0, $eUqFw.useEffect)(()=>{
        (0, $hS368.addThemeColor)(bg);
    }, [
        bg
    ]);
    if (!usesCustomColours) return undefined;
    return (0, $7slJv.generateTheme)({
        name: 'jira',
        backgroundColor: bg,
        highlightColor: highlightColor
    });
};

});
parcelRegister("3MEW8", function(module, exports) {

$parcel$export(module.exports, "themePreferenceResource", () => $aa9979c4bb771fd9$export$e5a423d1eb1cf1d0);
$parcel$export(module.exports, "useThemePreference", () => $aa9979c4bb771fd9$export$3416635c8aeb5bab);

var $eUqFw = parcelRequire("eUqFw");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $3HCkE = parcelRequire("3HCkE");


var $YWIXh = parcelRequire("YWIXh");

const $aa9979c4bb771fd9$var$getDataLoader = ()=>(parcelRequire("5f5aD"));
const $aa9979c4bb771fd9$export$e5a423d1eb1cf1d0 = (0, $3HCkE.createResource)({
    type: 'RESOURCE_THEME_PREFERENCE',
    getKey: ()=>'state',
    getDataLoader: $aa9979c4bb771fd9$var$getDataLoader,
    maxAge: 300000
});
const $aa9979c4bb771fd9$export$3416635c8aeb5bab = ()=>{
    const { data: data, update: updateThemePreferenceResource } = (0, $3HCkE.useResource)($aa9979c4bb771fd9$export$e5a423d1eb1cf1d0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fireThemeAnalytics = (0, $eUqFw.useCallback)((current, next)=>{
        const OStheme = window?.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        const analyticsEvent = createAnalyticsEvent({
            action: (0, $6f1b3f4a1b1409cf$export$89c5cf64ad15c3ea),
            actionSubject: (0, $6f1b3f4a1b1409cf$export$9e2cc65718a61846)
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
            newPreference: next,
            oldPreference: current,
            OStheme: OStheme
        });
    }, [
        createAnalyticsEvent
    ]);
    const setTheme = (0, $eUqFw.useCallback)(async (theme)=>{
        updateThemePreferenceResource(()=>({
                theme: theme
            }));
        if (data?.theme !== theme) {
            fireThemeAnalytics(data?.theme, theme);
            await (0, $YWIXh.setThemePreference)(theme);
        }
    }, [
        data?.theme,
        updateThemePreferenceResource,
        fireThemeAnalytics
    ]);
    return {
        theme: data?.theme,
        setTheme: setTheme
    };
};

});
const $6f1b3f4a1b1409cf$export$40bd77e1c9f49c27 = 'jira.user.theme.preference';
const $6f1b3f4a1b1409cf$export$9e2cc65718a61846 = 'themePreference';
const $6f1b3f4a1b1409cf$export$89c5cf64ad15c3ea = 'changed';

parcelRegister("YWIXh", function(module, exports) {

$parcel$export(module.exports, "setThemePreference", () => $31ba3788a5049b63$export$a6b84eebd33787e2);
$parcel$export(module.exports, "getThemePreference", () => $31ba3788a5049b63$export$2f7a12048d96237);

var $eM3G3 = parcelRequire("eM3G3");

var $guiFP = parcelRequire("guiFP");

var $cm5m0 = parcelRequire("cm5m0");

const $31ba3788a5049b63$export$a6b84eebd33787e2 = (theme)=>{
    const promise = (0, $cm5m0.userPreferenceAPI).set((0, $6f1b3f4a1b1409cf$export$40bd77e1c9f49c27), theme);
    promise.catch((error)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: error,
            attributes: {
                op: 'put',
                errName: String(error.name),
                statusCode: error.statusCode,
                param: `to:${theme}`
            }
        });
    });
    return promise;
};
const $31ba3788a5049b63$export$2f7a12048d96237 = async ()=>{
    const promise = (0, $cm5m0.userPreferenceAPI).get((0, $6f1b3f4a1b1409cf$export$40bd77e1c9f49c27));
    promise.catch((error)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: error,
            attributes: {
                op: 'get',
                errName: String(error.name),
                statusCode: error.statusCode
            }
        });
    });
    promise.then((theme)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if (theme && !(0, $eM3G3.ThemeOptions).includes(theme)) // very unlikely but…
        (0, $guiFP.default)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: new Error('Unrecognized theme!'),
            attributes: {
                op: 'get',
                theme: theme,
                errName: 'unrecognized value!'
            }
        });
    });
    const theme = await promise;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return theme && (0, $eM3G3.ThemeOptions).includes(theme) ? theme : undefined;
};

});
parcelRegister("eM3G3", function(module, exports) {

$parcel$export(module.exports, "ThemeOptions", () => $65da877bf2b17a02$export$abe7936539cefefe);
$parcel$export(module.exports, "DEFAULT_THEME", () => $65da877bf2b17a02$export$2faeed762aac6741);
const $65da877bf2b17a02$export$abe7936539cefefe = [
    'light',
    'dark',
    'auto'
];
const $65da877bf2b17a02$export$2faeed762aac6741 = 'light';

});

parcelRegister("cm5m0", function(module, exports) {

$parcel$export(module.exports, "userPreferenceAPI", () => $65cd88220f00e257$export$4f7929ca6b50a436);


var $lRmyA = parcelRequire("lRmyA");
const $65cd88220f00e257$var$url = (key)=>`/rest/api/3/mypreferences?key=${key}`;
const $65cd88220f00e257$var$get = async (key)=>{
    try {
        const result = await (0, $lRmyA.performGetRequest)($65cd88220f00e257$var$url(key));
        return result?.value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode === (0, $1c3fbb431a173cc6$export$8bca792d963eb0ef)) return null;
        throw error;
    }
};
const $65cd88220f00e257$var$set = (key, value)=>(0, $lRmyA.performPutRequest)($65cd88220f00e257$var$url(key), {
        body: JSON.stringify({
            value: value
        })
    });
const $65cd88220f00e257$var$remove = (key)=>(0, $lRmyA.performDeleteRequest)($65cd88220f00e257$var$url(key));
const $65cd88220f00e257$export$4f7929ca6b50a436 = {
    get: $65cd88220f00e257$var$get,
    set: $65cd88220f00e257$var$set,
    remove: $65cd88220f00e257$var$remove
};

});


parcelRegister("5f5aD", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('8mnLk')
        ]);
        const value = parcelRequire('foRwS');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("8mnLk")
    ]).then(()=>parcelRequire('foRwS'));
}

});


parcelRegister("hS368", function(module, exports) {

$parcel$export(module.exports, "addThemeColor", () => $d4990bb3ca3a777b$export$7b20d133831b2b0f);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d4990bb3ca3a777b$var$getMetaNode = (name)=>document.querySelector(`meta[name="${name}"]`);
const $d4990bb3ca3a777b$var$getHead = ()=>document.head || document.querySelector('head');
const $d4990bb3ca3a777b$export$7b20d133831b2b0f = (content)=>{
    if (!content || typeof document === 'undefined' || false) return;
    const existingMeta = $d4990bb3ca3a777b$var$getMetaNode('theme-color');
    const meta = document.createElement('meta');
    meta.name = 'theme-color';
    meta.content = content;
    if (existingMeta) existingMeta.replaceWith?.(meta);
    else {
        const head = $d4990bb3ca3a777b$var$getHead();
        if (head) head.appendChild?.(meta);
    }
};

});

parcelRegister("3jHKg", function(module, exports) {

$parcel$export(module.exports, "capLightness", () => $a436962de231d459$export$8b5544bab97b10dd);
const $a436962de231d459$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
const $a436962de231d459$var$expandShorthandHex = (input)=>input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b)=>r + r + g + g + b + b);
const $a436962de231d459$var$rgbFromHex = (input)=>{
    const fullHex = $a436962de231d459$var$expandShorthandHex(input);
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
const $a436962de231d459$var$rgbToHex = ({ r: r, g: g, b: b })=>{
    const convertComponent = (c)=>{
        const cBase16 = c.toString(16);
        return cBase16.length === 1 ? `0${cBase16}` : cBase16;
    };
    return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
};
const $a436962de231d459$var$rgbToXyz = (rgb)=>{
    const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    const r = convertRgbComponent(rgb.r / 255);
    const g = convertRgbComponent(rgb.g / 255);
    const b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
const $a436962de231d459$var$xyzToLab = ({ x: x, y: y, z: z })=>({
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    });
const $a436962de231d459$var$labToLch = ({ l: l, a: a, b: b })=>{
    let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
const $a436962de231d459$var$lchToLab = ({ l: l, c: c, h: h })=>{
    const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
const $a436962de231d459$var$labToXyz = ({ l: l, a: a, b: b })=>{
    const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    const y = (l + 16) / 116;
    const x = a / 500 + y;
    const z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
const $a436962de231d459$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
    const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    return {
        r: $a436962de231d459$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $a436962de231d459$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $a436962de231d459$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
const $a436962de231d459$var$rgbToLch = (rgb)=>$a436962de231d459$var$labToLch($a436962de231d459$var$xyzToLab($a436962de231d459$var$rgbToXyz(rgb)));
const $a436962de231d459$var$lchToRgb = (lch)=>$a436962de231d459$var$xyzToRgb($a436962de231d459$var$labToXyz($a436962de231d459$var$lchToLab(lch)));
const $a436962de231d459$export$8b5544bab97b10dd = (color, capPercent)=>{
    const rgb = $a436962de231d459$var$rgbFromHex(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = $a436962de231d459$var$rgbToLch(rgb);
    if (lch.l > capPercent) lch.l = $a436962de231d459$var$clamp(capPercent, 0, 100);
    return $a436962de231d459$var$rgbToHex($a436962de231d459$var$lchToRgb(lch));
};

});



parcelRegister("aYtGv", function(module, exports) {

$parcel$export(module.exports, "PAGE_LAYOUT_OFFSET_TOP", () => $479507d87baa6502$export$d60454526e2281af);
$parcel$export(module.exports, "HORIZONTAL_GLOBAL_NAV_HEIGHT", () => $479507d87baa6502$export$30fa7cc5f2690a43);
// This doesn't use @atlassian/jira-navigation-system as it results in a hard-to-debug cycle.
// We need to move away from using these variables directly as it results in a brittle hard to evolve system.
// eslint-disable-next-line jira/restricted/@atlaskit+page-layout

var $ho1Ek = parcelRequire("ho1Ek");
const $479507d87baa6502$export$d60454526e2281af = `(${(0, $ho1Ek.TOP_NAVIGATION_HEIGHT)} + ${(0, $ho1Ek.BANNER_HEIGHT)})`;
const $479507d87baa6502$export$30fa7cc5f2690a43 = 56;

});

parcelRegister("eQbJ4", function(module, exports) {

$parcel$export(module.exports, "useIsFullscreen", () => $1ce3a272474e08c0$export$d397eccea5f37b0a);

var $eUqFw = parcelRequire("eUqFw");
const $1ce3a272474e08c0$var$fullscreenClassnameExists = (target)=>target?.classList.contains('fullscreen') ?? false;
const $1ce3a272474e08c0$export$d397eccea5f37b0a = (target)=>{
    const [isFullscreen, setIsFullscreen] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        const handleFullscreen = ()=>{
            setIsFullscreen($1ce3a272474e08c0$var$fullscreenClassnameExists(target));
        };
        const mutationObserver = new MutationObserver(handleFullscreen);
        if (target) mutationObserver.observe(target, {
            attributes: true
        });
        return ()=>mutationObserver.disconnect();
    }, [
        target
    ]);
    return {
        isFullscreen: isFullscreen
    };
};

});

parcelRegister("6VKSg", function(module, exports) {

$parcel$export(module.exports, "useTopNavState", () => $f37199ef443364d1$export$bccbd45ab793bd09);

var $ggKAj = parcelRequire("ggKAj");

var $53ucm = parcelRequire("53ucm");
const $f37199ef443364d1$var$useTopNav = (0, $ggKAj.createHook)((0, $53ucm.layoutStore), {
    selector: (state)=>({
            ...state.topNavigation,
            shouldRender: !state.isChromeless
        })
});
const $f37199ef443364d1$export$bccbd45ab793bd09 = ()=>{
    const [state] = $f37199ef443364d1$var$useTopNav();
    return state;
};

});

parcelRegister("7xu2f", function(module, exports) {

$parcel$export(module.exports, "AsyncAtlassianNavigation", () => $050373c2603582df$export$932edb7b1b20d079);

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $gC7XG = parcelRequire("gC7XG");

var $cernH = parcelRequire("cernH");

var $eDbLL = parcelRequire("eDbLL");

var $hknOo = parcelRequire("hknOo");

var $1FAd1 = parcelRequire("1FAd1");


var $8R80x = parcelRequire("8R80x");

var $10fdS = parcelRequire("10fdS");

var $2B87Z = parcelRequire("2B87Z");
const $050373c2603582df$export$932edb7b1b20d079 = ()=>{
    const isUsingEntryPoint = Boolean((0, $10fdS.useCurrentRoute)().entryPoint?.());
    const topNavEntryPointReference = (0, $1FAd1.usePageLayoutEntryPoint)((0, $d619e185f38e9ae8$export$bec6dca2e63de4ae));
    (0, $eUqFw.useState)(()=>{
        if (!false && isUsingEntryPoint) /* @ts-expect-error - TS2339 - We're using JSResourceReference from @atlassian/react-async. */ (0, $gC7XG.topNavigationEntryPoint).root.onComplete(()=>{
            (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.bundle-ready', 'jira-spa.js:eval-stop');
            const resources = performance.getEntriesByType('mark');
            for(let i = resources.length - 1; i >= 0; i -= 1)if ((resources[i].name.startsWith('async-navigation') || resources[i].name.startsWith('async-atlassian-navigation')) && resources[i].name.endsWith((0, $hknOo.JS_EVAL_START))) {
                (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.eval', resources[i].name);
                break;
            }
        });
        return undefined;
    });
    return isUsingEntryPoint ? // There is already a Placeholder in parent
    // remove this one when EntryPointPlaceholder merges with Placeholder
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8R80x.EntryPointPlaceholder), {
        name: "top_navigation_skeleton",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eDbLL.JiraAtlassianNavigationSkeleton), null),
        /* @ts-expect-error - TS2322 - We're using JSResourceReference from @atlassian/react-async. */ entryPoint: (0, $gC7XG.topNavigationEntryPoint)
    }, topNavEntryPointReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iWLL0.EntryPointContainer), {
        entryPointReference: topNavEntryPointReference,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        props: {}
    }) : null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cernH.LazyAtlassianNavigation), null);
};

});
parcelRegister("gC7XG", function(module, exports) {

$parcel$export(module.exports, "topNavigationEntryPoint", () => $cb57489a3376471c$export$f780be9e138f456f);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $cb57489a3376471c$export$f780be9e138f456f = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("3nloY")), {
        moduleId: "1f1265b4"
    }),
    getPreloadProps: (extraProps)=>({
            extraProps: extraProps
        })
});

});
parcelRegister("3nloY", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('h49zL')
        ]);
        const value = parcelRequire('krHYB');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("h49zL")
    ]).then(()=>parcelRequire('krHYB'));
}

});


parcelRegister("cernH", function(module, exports) {

$parcel$export(module.exports, "LazyAtlassianNavigation", () => $d0ff8bb7dfb6147e$export$4caed23aa0274abb);

var $7rh0R = parcelRequire("7rh0R");

var $hknOo = parcelRequire("hknOo");

var $2B87Z = parcelRequire("2B87Z");

const $d0ff8bb7dfb6147e$export$4caed23aa0274abb = (0, $7rh0R.lazyForPaint)(()=>{
    const bundleReady = (parcelRequire("hz5Pw"));
    if (!false) bundleReady.then(()=>{
        (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.bundle-ready', 'jira-spa.js:eval-stop');
        const resources = performance.getEntriesByType('mark');
        for(let i = resources.length - 1; i >= 0; i -= 1)if ((resources[i].name.startsWith('async-navigation') || resources[i].name.startsWith('async-atlassian-navigation')) && resources[i].name.endsWith((0, $hknOo.JS_EVAL_START))) {
            (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.eval', resources[i].name);
            break;
        }
    });
    return bundleReady;
}, {
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/index.tsx"
});

});
parcelRegister("hz5Pw", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('BfK1C')
        ]);
        const value = parcelRequire('6OKpM');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("BfK1C")
    ]).then(()=>parcelRequire('6OKpM'));
}

});


parcelRegister("1FAd1", function(module, exports) {

$parcel$export(module.exports, "usePageLayoutEntryPoint", () => $569433a5f969d51a$export$fe1c839e8baf4110);

var $399tN = parcelRequire("399tN");

var $10fdS = parcelRequire("10fdS");
const $569433a5f969d51a$export$fe1c839e8baf4110 = (layoutField)=>{
    const route = (0, $10fdS.useCurrentRoute)();
    const entryPointReference = (0, $399tN.useRouteEntryPoint)({
        route: route
    });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return entryPointReference?.entryPoints[layoutField];
};

});
parcelRegister("399tN", function(module, exports) {

$parcel$export(module.exports, "useRouteEntryPoint", () => $94d21b8ebec2d194$export$c96377f800cdddb4);

var $gglAH = parcelRequire("gglAH");
const $94d21b8ebec2d194$export$c96377f800cdddb4 = ({ route: route })=>{
    const [lastLoadedRoute] = (0, $gglAH.useLastLoadedRoute)();
    // route.entryPoint is already loaded
    if (lastLoadedRoute && lastLoadedRoute.entryPointReference && lastLoadedRoute.route === route) return lastLoadedRoute.entryPointReference;
    return null;
};

});
parcelRegister("gglAH", function(module, exports) {

$parcel$export(module.exports, "useLastLoadedRoute", () => $200515d1f24b1bb9$export$895238443fc3eae4);
$parcel$export(module.exports, "getEntryPointsStore", () => $200515d1f24b1bb9$export$fe654a734624d17f);
$parcel$export(module.exports, "getLastLoadedRoute", () => $200515d1f24b1bb9$export$5763b2305b3056df);
$parcel$export(module.exports, "getPrefetchingRoute", () => $200515d1f24b1bb9$export$7e18f3e3cbd04326);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $gasA1 = parcelRequire("gasA1");
const $200515d1f24b1bb9$export$1cec83a23d40a9fa = ({ route: route, entryPointReference: entryPointReference })=>({ setState: setState })=>{
        setState({
            lastLoadedRoute: {
                route: route,
                entryPointReference: entryPointReference
            }
        });
    };
const $200515d1f24b1bb9$export$bb3dc9c55f78173e = ({ routerContext: routerContext, entryPointReference: entryPointReference, expiresAt: expiresAt })=>({ setState: setState })=>{
        setState({
            prefetchingRoute: {
                routerContext: routerContext,
                expiresAt: expiresAt,
                entryPointReference: entryPointReference
            }
        });
    };
const $200515d1f24b1bb9$var$actions = {
    setLastLoadedRoute: $200515d1f24b1bb9$export$1cec83a23d40a9fa,
    setPrefetchingRoute: $200515d1f24b1bb9$export$bb3dc9c55f78173e
};
const $200515d1f24b1bb9$var$EntryPointsStore = (0, $a61MH.createStore)({
    initialState: {
        lastLoadedRoute: null,
        prefetchingRoute: null
    },
    actions: $200515d1f24b1bb9$var$actions,
    name: 'react-resource-router/entry-points'
});
const $200515d1f24b1bb9$export$895238443fc3eae4 = (0, $ggKAj.createHook)($200515d1f24b1bb9$var$EntryPointsStore, {
    selector: (state)=>state.lastLoadedRoute
});
const $200515d1f24b1bb9$export$fe654a734624d17f = ()=>(0, $gasA1.defaultRegistry).getStore($200515d1f24b1bb9$var$EntryPointsStore);
const $200515d1f24b1bb9$export$b28ecd0e4705f6b7 = ()=>$200515d1f24b1bb9$export$fe654a734624d17f().storeState.getState();
const $200515d1f24b1bb9$export$5763b2305b3056df = ()=>$200515d1f24b1bb9$export$b28ecd0e4705f6b7().lastLoadedRoute;
const $200515d1f24b1bb9$export$7e18f3e3cbd04326 = ()=>$200515d1f24b1bb9$export$b28ecd0e4705f6b7().prefetchingRoute;

});



const $d619e185f38e9ae8$export$948d4d345566aed3 = '__pageLayoutHorizontalNavigation';
const $d619e185f38e9ae8$export$50ea883ba6f28ff5 = '__pageLayoutLeftSidebar';
const $d619e185f38e9ae8$export$900ddb492c628f48 = '__pageLayoutMainContent';
const $d619e185f38e9ae8$export$bec6dca2e63de4ae = '__pageLayoutTopNavigation';



parcelRegister("fpQ73", function(module, exports) {

$parcel$export(module.exports, "FullHeight", () => $634ce2a022efa5f0$export$33e617ec5e4e4f76);

var $eUqFw = parcelRequire("eUqFw");
const $634ce2a022efa5f0$var$styleFullHeight = {
    height: '100vh'
};
const $634ce2a022efa5f0$export$33e617ec5e4e4f76 = ({ children: children })=>// eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: $634ce2a022efa5f0$var$styleFullHeight
    }, children);

});

parcelRegister("1cu0z", function(module, exports) {

$parcel$export(module.exports, "ThemeSetter", () => $d6a0f9f1b975c5d3$export$ce1303eaa27a0d3a);

var $eUqFw = parcelRequire("eUqFw");

var $hPGUE = parcelRequire("hPGUE");
var $4q38b = parcelRequire("4q38b");

var $gpo0r = parcelRequire("gpo0r");

var $3FyZ4 = parcelRequire("3FyZ4");

var $3HCkE = parcelRequire("3HCkE");

var $3MEW8 = parcelRequire("3MEW8");
const $d6a0f9f1b975c5d3$var$darkThemeMediaMatchQuery = window?.matchMedia && window.matchMedia('(prefers-color-scheme: dark)');

const $d6a0f9f1b975c5d3$var$GlobalThemeSetter = ()=>{
    const { data: data, loading: loading, error: error } = (0, $3HCkE.useResource)((0, $3MEW8.themePreferenceResource));
    const { colorMode: colorMode } = (0, $4q38b.default)();
    const [isThemeStylesInHead, setIsThemeStylesInHead] = (0, $eUqFw.useState)(false);
    const setThemeWithToken = (0, $eUqFw.useCallback)(async (theme)=>{
        if (theme !== colorMode) {
            const { loadThemeTokens: loadThemeTokens } = await (parcelRequire("fkND2"));
            loadThemeTokens(theme);
        }
    }, [
        colorMode
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (loading || error || !data) return undefined;
        // Combine the themes 'dark', 'light' and 'auto' after @atlaskit/tokens@1.0.0
        // https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/27634
        if (data?.theme === 'auto') {
            setThemeWithToken($d6a0f9f1b975c5d3$var$darkThemeMediaMatchQuery?.matches ? 'dark' : 'light');
            const handler = (e)=>{
                setThemeWithToken(e.matches ? 'dark' : 'light');
            };
            $d6a0f9f1b975c5d3$var$darkThemeMediaMatchQuery?.addEventListener('change', handler);
            return ()=>{
                $d6a0f9f1b975c5d3$var$darkThemeMediaMatchQuery?.removeEventListener('change', handler);
            };
        }
        if (data?.theme === 'dark' || data?.theme === 'light') setThemeWithToken(data?.theme);
        if (!data?.theme) {
            document.documentElement.removeAttribute('data-theme');
            document.documentElement.removeAttribute('data-color-mode');
        }
        return undefined;
    }, [
        data,
        loading,
        error,
        setThemeWithToken
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (loading || error || !data) return;
        (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
            if (data?.theme) client.setUIViewedAttributes({
                theme: data.theme
            });
            else client.removeUIViewedAttribute('theme');
        });
    }, [
        data,
        loading,
        error
    ]);
    (0, $eUqFw.useEffect)(()=>{
        (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
            client.setUIViewedAttributes({
                OStheme: $d6a0f9f1b975c5d3$var$darkThemeMediaMatchQuery?.matches ? 'dark' : 'light'
            });
        });
    }, []);
    // @atlaskit/tokens expects the theme styles to be in the <head /> but they're
    // initally rendered in the "jira-ssr" container in the <body /> and then moved to the
    // <head />. The following prevents the styles from being re-rendered in the <body />.
    (0, $eUqFw.useEffect)(()=>{
        if (document.head.querySelector('style[data-theme]')) setIsThemeStylesInHead(true);
    }, []);
    if (!data?.theme || !data?.attrs || !data?.styles) return null;
    const ssrAutoScript = (0, $hPGUE.default)(data.theme);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, !isThemeStylesInHead ? data.styles.map((theme)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("style", {
            key: theme.id,
            ...theme.attrs,
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: {
                __html: theme.css
            }
        })) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("script", {
        "data-defer-skip": true,
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: data.styles.map((theme)=>`document.head.appendChild(document.body.querySelector('style[data-theme="${theme.id}"]'));`).join('\n')
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("script", {
        "data-defer-skip": true,
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: Object.entries(data.attrs).map(([key, val])=>{
                if (key === 'data-color-mode' && ssrAutoScript) return '';
                return `document.documentElement.setAttribute("${key}", "${val}");`;
            }).join('\n')
        }
    }), ssrAutoScript ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("script", {
        "data-defer-skip": true,
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: ssrAutoScript
        }
    }) : null);
};
const $d6a0f9f1b975c5d3$export$ce1303eaa27a0d3a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6a0f9f1b975c5d3$var$GlobalThemeSetter, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gpo0r.ThemeSetter), null));

});
parcelRegister("hPGUE", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef76e53ed4c3c344$export$2e2bcd8739ae039);

var $XHGTv = parcelRequire("XHGTv");

var $kyri3 = parcelRequire("kyri3");

var $2Mf9s = parcelRequire("2Mf9s");
/**
 * Provides a script that, when executed before paint, sets the `data-color-mode` attribute based on the current system theme,
 * to enable SSR support for automatic theme switching, avoid a flash of un-themed content on first paint.
 *
 * @param {string} colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 *
 * @returns {string} A string to be added to the innerHTML of a script tag in the document head
 */ const $ef76e53ed4c3c344$var$getSSRAutoScript = (colorMode, // TODO: This should be marked as required once safe to roll out.
contrastMode)=>{
    if (colorMode !== 'auto' && contrastMode !== 'auto') return undefined;
    const setColorMode = colorMode === 'auto' ? `\n  try {
    const darkModeMql = window.matchMedia('${0, $2Mf9s.darkModeMediaQuery}');
    const colorMode = darkModeMql.matches ? 'dark' : 'light';
    document.documentElement.setAttribute('${0, $kyri3.COLOR_MODE_ATTRIBUTE}', colorMode);
  } catch (e) {}` : '';
    const setContrastMode = (0, $XHGTv.getBooleanFF)('platform.design-system-team.increased-contrast-themes') && contrastMode === 'auto' ? `\n  try {
    const contrastModeMql = window.matchMedia('${0, $2Mf9s.moreContrastMediaQuery}');
    const contrastMode = contrastModeMql.matches ? 'more' : 'no-preference';
    document.documentElement.setAttribute('${0, $kyri3.CONTRAST_MODE_ATTRIBUTE}', contrastMode);
  } catch (e) {}` : '';
    return `(() => {${setColorMode}${setContrastMode}})()`;
};
var $ef76e53ed4c3c344$export$2e2bcd8739ae039 = $ef76e53ed4c3c344$var$getSSRAutoScript;

});

parcelRegister("gpo0r", function(module, exports) {

$parcel$export(module.exports, "ThemeSetter", () => $76ce003e44f43d6d$export$ce1303eaa27a0d3a);

var $eUqFw = parcelRequire("eUqFw");

var $3K2Fs = parcelRequire("3K2Fs");

var $4EvIi = parcelRequire("4EvIi");

var $4e72F = parcelRequire("4e72F");

var $bcnRH = parcelRequire("bcnRH");

var $exb0h = parcelRequire("exb0h");

var $1ybV0 = parcelRequire("1ybV0");

var $10fdS = parcelRequire("10fdS");
const $76ce003e44f43d6d$export$ce1303eaa27a0d3a = ()=>{
    const projectTheme = (0, $4EvIi.useProjectTheme)();
    const overviewTheme = (0, $3K2Fs.useOverviewTheme)();
    const route = (0, $10fdS.useCurrentRoute)();
    const entityTheme = (0, $eUqFw.useMemo)(()=>{
        let result = projectTheme ?? overviewTheme;
        if (result != null) {
            const isFormSubmitView = route.name === (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT || route.name === (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT_EMBED;
            // the form submit view doesn't use the project theme colors
            // since it is accessed externally to the project
            if (isFormSubmitView) result = {
                ...result,
                themeSetting: null
            };
        }
        return result;
    }, [
        projectTheme,
        overviewTheme,
        route.name
    ]);
    if ((0, $1ybV0.ff)('sea-2744-jsw-tabs-nav')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bcnRH.ThemeContainer), {
        isGlobal: true,
        entityTheme: entityTheme
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4e72F.ThemeTokensSetter), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, entityTheme != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bcnRH.ThemeContainerOld), {
        isGlobal: true,
        ...entityTheme
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4e72F.ThemeTokensSetter), null));
};

});
parcelRegister("3K2Fs", function(module, exports) {

$parcel$export(module.exports, "useOverviewTheme", () => $88bfa969a9a43feb$export$a55763fd17eab357);

var $kar7l = parcelRequire("kar7l");

var $fzymf = parcelRequire("fzymf");
const $88bfa969a9a43feb$export$a55763fd17eab357 = ()=>{
    const { data: data } = (0, $fzymf.useOverview)();
    if (data != null) return {
        themeSetting: {
            type: 'color',
            value: data.theme ?? (0, $kar7l.DEFAULT_BACKGROUND_CONFIG).name
        },
        entityId: `overview/${data.id}`
    };
    return null;
};

});
parcelRegister("kar7l", function(module, exports) {

$parcel$export(module.exports, "STAR_ICON_COLOR", () => $15099970f99feec5$export$9e0962e0cb41695d);
$parcel$export(module.exports, "Variables", () => $15099970f99feec5$export$8bb9d79ea938efc9);
$parcel$export(module.exports, "Tokens", () => $15099970f99feec5$export$8e1e81ac145e31be);
$parcel$export(module.exports, "BASE_THEME", () => $15099970f99feec5$export$8a6e9b3370a0f87a);
$parcel$export(module.exports, "HIGH_BRIGHTNESS_THEME", () => $15099970f99feec5$export$f286efa6bd1e8f9d);
$parcel$export(module.exports, "LOW_BRIGHTNESS_THEME", () => $15099970f99feec5$export$97cb21c6432e07e8);
$parcel$export(module.exports, "GRADIENT_THEME", () => $15099970f99feec5$export$b124f62a6aab972);
$parcel$export(module.exports, "IMAGE_BACKGROUND_CONFIG", () => $15099970f99feec5$export$9441e0d8f766c59a);
$parcel$export(module.exports, "NO_BACKGROUND_CONFIG", () => $15099970f99feec5$export$4c351ec1dc290344);
$parcel$export(module.exports, "BACKGROUND_CONFIGS_OLD", () => $15099970f99feec5$export$34373eced7ee212e);
$parcel$export(module.exports, "BACKGROUND_COLOR_CONFIGS", () => $15099970f99feec5$export$5ddfadab7b1e12c1);
$parcel$export(module.exports, "SOLID_COLOR_BACKGROUND_CONFIGS", () => $15099970f99feec5$export$349e5dbeac874253);
$parcel$export(module.exports, "GRADIENT_BACKGROUND_CONFIGS", () => $15099970f99feec5$export$242b2d2213fedf27);
$parcel$export(module.exports, "OLD_TO_NEW_BACKGROUND_CONFIG_MAP", () => $15099970f99feec5$export$fe05a238062e2c3d);
$parcel$export(module.exports, "DEFAULT_BACKGROUND_CONFIG", () => $15099970f99feec5$export$cab9d853866386f2);
$parcel$export(module.exports, "BANNER_HEIGHT", () => $15099970f99feec5$export$ed7cc0d417ee89e);
$parcel$export(module.exports, "HORIZONTAL_NAV_HEIGHT", () => $15099970f99feec5$export$baaf8255c30ea280);
$parcel$export(module.exports, "BUSINESS_WRAPPER_PADDING", () => $15099970f99feec5$export$8e357501548afe78);
$parcel$export(module.exports, "BUSINESS_NAV_HEIGHT", () => $15099970f99feec5$export$d9035bc768f8226d);
$parcel$export(module.exports, "BUSINESS_WRAPPER_HEIGHT", () => $15099970f99feec5$export$4810531e30462f89);
$parcel$export(module.exports, "BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT", () => $15099970f99feec5$export$1c0b806722927549);
$parcel$export(module.exports, "BUSINESS_WRAPPER_WIDTH", () => $15099970f99feec5$export$77cdace62a821419);
$parcel$export(module.exports, "BUSINESS_WRAPPER_WITH_BACKGROUND_WIDTH", () => $15099970f99feec5$export$3efe68325dd9dc02);
// This doesn't use @atlassian/jira-navigation-system as it results in a hard-to-debug cycle.
// We need to move away from using these variables directly as it results in a brittle hard to evolve system.
// eslint-disable-next-line jira/restricted/@atlaskit+page-layout

var $ho1Ek = parcelRequire("ho1Ek");

var $PdmhA = parcelRequire("PdmhA");

var $aYtGv = parcelRequire("aYtGv");
const $15099970f99feec5$export$b8b9d90f9e5bd72b = 'jiraBusinessThemeConstants';
const $15099970f99feec5$export$9e0962e0cb41695d = '#FFAB00';
const $15099970f99feec5$export$8bb9d79ea938efc9 = {
    BACKDROP_FILTER: '--jwm-backdrop-filter',
    COLOR_BACKGROUND_BRAND_BOLD: '--jwm-color-background-brand-bold',
    COLOR_BACKGROUND_BRAND_BOLD_HOVERED: '--jwm-color-background-brand-bold-hovered',
    COLOR_BACKGROUND_BRAND_BOLD_PRESSED: '--jwm-color-background-brand-bold-pressed',
    COLOR_BACKGROUND_DISABLED: '--jwm-color-background-disabled',
    COLOR_BACKGROUND_INPUT: '--jwm-background-input',
    COLOR_BACKGROUND_NEUTRAL: '--jwm-background-neutral',
    COLOR_BACKGROUND_NEUTRAL_HOVERED: '--jwm-background-neutral-hovered',
    COLOR_BACKGROUND_NEUTRAL_PRESSED: '--jwm-background-neutral-pressed',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED: '--jwm-background-neutral-subtle-hovered',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED: '--jwm-background-neutral-subtle-pressed',
    COLOR_BACKGROUND_SELECTED: '--jwm-background-selected',
    COLOR_BORDER: '--jwm-color-border',
    COLOR_BORDER_INPUT: '--jwm-color-border-input',
    COLOR_BORDER_INVERSE: '--jwm-color-border-inverse',
    COLOR_BORDER_SELECTED: '--jwm-color-border-selected',
    COLOR_ELEVATION_SURFACE: '--jwm-color-elevation-surface',
    COLOR_ICON_DANGER: '--jwm-color-icon-danger',
    COLOR_ICON_INFORMATION: '--jwm-color-icon-information',
    COLOR_ICON_SUCCESS: '--jwm-color-icon-success',
    COLOR_ICON_WARNING: '--jwm-color-icon-warning',
    COLOR_LINK: '--jwm-color-link',
    COLOR_LINK_PRESSED: '--jwm-color-link-pressed',
    COLOR_SKELETON: '--jwm-skeleton',
    COLOR_TEXT: '--jwm-color-text',
    COLOR_TEXT_DISABLED: '--jwm-color-text-disabled',
    COLOR_TEXT_INVERSE: '--jwm-color-text-inverse',
    COLOR_TEXT_SELECTED: '--jwm-color-text-selected',
    COLOR_TEXT_SUBTLE: '--jwm-color-text-subtle',
    COLOR_TEXT_SUBTLEST: '--jwm-color-text-subtlest',
    CONTENT_HEIGHT: '--jwm-content-height',
    CONTENT_WIDTH: '--jwm-content-width',
    ELEVATION_SURFACE: '--jwm-elevation-surface',
    ELEVATION_SURFACE_CONTRAST: '--jwm-elevation-surface-contrast',
    ELEVATION_SURFACE_CONTRAST_BOLDER: '--jwm-elevation-surface-contrast-bolder',
    WRAPPER_BACKGROUND: '--jwm-wrapper-background',
    WRAPPER_BORDER_RADIUS: '--jwm-wrapper-border-radius',
    WRAPPER_HEIGHT: '--jwm-wrapper-height',
    WRAPPER_PADDING: '--jwm-wrapper-padding',
    WRAPPER_WIDTH: '--jwm-wrapper-width'
};
const $15099970f99feec5$export$8e1e81ac145e31be = {
    BACKDROP_FILTER: 'var(--jwm-backdrop-filter)',
    COLOR_BACKGROUND_BRAND_BOLD: 'var(--jwm-color-background-brand-bold)',
    COLOR_BACKGROUND_BRAND_BOLD_HOVERED: 'var(--jwm-color-background-brand-bold-hovered)',
    COLOR_BACKGROUND_BRAND_BOLD_PRESSED: 'var(--jwm-color-background-brand-bold-pressed)',
    COLOR_BACKGROUND_DISABLED: 'var(--jwm-color-background-disabled)',
    COLOR_BACKGROUND_INPUT: 'var(--jwm-background-input)',
    COLOR_BACKGROUND_NEUTRAL: 'var(--jwm-background-neutral)',
    COLOR_BACKGROUND_NEUTRAL_HOVERED: 'var(--jwm-background-neutral-hovered)',
    COLOR_BACKGROUND_NEUTRAL_PRESSED: 'var(--jwm-background-neutral-pressed)',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED: 'var(--jwm-background-neutral-subtle-hovered)',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED: 'var(--jwm-background-neutral-subtle-pressed)',
    COLOR_BACKGROUND_SELECTED: 'var(--jwm-background-selected)',
    COLOR_BORDER: 'var(--jwm-color-border)',
    COLOR_BORDER_INPUT: 'var(--jwm-color-border-input)',
    COLOR_BORDER_INVERSE: 'var(--jwm-color-border-inverse)',
    COLOR_BORDER_SELECTED: 'var(--jwm-color-border-selected)',
    COLOR_ELEVATION_SURFACE: 'var(--jwm-color-elevation-surface)',
    COLOR_ICON_DANGER: 'var(--jwm-color-icon-danger)',
    COLOR_ICON_INFORMATION: 'var(--jwm-color-icon-information)',
    COLOR_ICON_SUCCESS: 'var(--jwm-color-icon-success)',
    COLOR_ICON_WARNING: 'var(--jwm-color-icon-warning)',
    COLOR_LINK: 'var(--jwm-color-link)',
    COLOR_LINK_PRESSED: 'var(--jwm-color-link-pressed)',
    COLOR_SKELETON: 'var(--jwm-skeleton)',
    COLOR_TEXT: 'var(--jwm-color-text)',
    COLOR_TEXT_DISABLED: 'var(--jwm-color-text-disabled)',
    COLOR_TEXT_INVERSE: 'var(--jwm-color-text-inverse)',
    COLOR_TEXT_SELECTED: 'var(--jwm-color-text-selected)',
    COLOR_TEXT_SUBTLE: 'var(--jwm-color-text-subtle)',
    COLOR_TEXT_SUBTLEST: 'var(--jwm-color-text-subtlest)',
    CONTENT_HEIGHT: 'var(--jwm-content-height)',
    CONTENT_WIDTH: 'var(--jwm-content-width)',
    ELEVATION_SURFACE: 'var(--jwm-elevation-surface)',
    ELEVATION_SURFACE_CONTRAST: 'var(--jwm-elevation-surface-contrast)',
    ELEVATION_SURFACE_CONTRAST_BOLDER: 'var(--jwm-elevation-surface-contrast-bolder)',
    WRAPPER_BACKGROUND: 'var(--jwm-wrapper-background)',
    WRAPPER_BORDER_RADIUS: 'var(--jwm-wrapper-border-radius)',
    WRAPPER_HEIGHT: 'var(--jwm-wrapper-height)',
    WRAPPER_PADDING: 'var(--jwm-wrapper-padding)',
    WRAPPER_WIDTH: 'var(--jwm-wrapper-width)'
};
const $15099970f99feec5$export$8a6e9b3370a0f87a = {
    'color.background.brand.bold': "var(--ds-background-brand-bold, #09326C)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0C66E4)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #09326C)",
    'color.background.disabled': "var(--ds-background-disabled, #091E4208)",
    'color.background.input': `var(--ds-background-input, ${(0, $PdmhA).N0})`,
    'color.background.neutral': `var(--ds-background-neutral, ${(0, $PdmhA).N30A})`,
    'color.background.neutral.hovered': `var(--ds-background-neutral-hovered, ${(0, $PdmhA).N40A})`,
    'color.background.neutral.pressed': `var(--ds-background-neutral-pressed, ${(0, $PdmhA).N50A})`,
    'color.background.neutral.subtle.hovered': `var(--ds-background-neutral-subtle-hovered, ${(0, $PdmhA).N40A})`,
    'color.background.neutral.subtle.pressed': `var(--ds-background-neutral-subtle-pressed, ${(0, $PdmhA).N50A})`,
    'color.background.selected': `var(--ds-background-selected, ${(0, $PdmhA).B400})`,
    'color.elevation.surface': `var(--ds-surface, ${(0, $PdmhA).N0})`,
    'color.border': `var(--ds-border, ${(0, $PdmhA).N40A})`,
    'color.border.input': "var(--ds-border-input, #091E4224)",
    'color.border.inverse': `var(--ds-border-inverse, ${(0, $PdmhA).N0})`,
    'color.border.selected': `var(--ds-border-selected, ${(0, $PdmhA).B400})`,
    'color.icon.danger': `var(--ds-icon-danger, ${(0, $PdmhA).R200})`,
    'color.icon.information': `var(--ds-icon-information, ${(0, $PdmhA).B200})`,
    'color.icon.success': `var(--ds-icon-success, ${(0, $PdmhA).G200})`,
    'color.icon.warning': `var(--ds-icon-warning, ${(0, $PdmhA).Y200})`,
    'color.link': "var(--ds-link, #0c66e4)",
    'color.link.pressed': "var(--ds-link-pressed, #0055cc)",
    'color.skeleton': `var(--ds-background-neutral, ${(0, $PdmhA).N20A})`,
    'color.text': `var(--ds-text, ${(0, $PdmhA).N800})`,
    'color.text.disabled': "var(--ds-text-disabled, #091E424F)",
    'color.text.inverse': `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    'color.text.selected': `var(--ds-text-selected, ${(0, $PdmhA).B400})`,
    'color.text.subtle': `var(--ds-text-subtle, ${(0, $PdmhA).N500})`,
    'color.text.subtlest': "var(--ds-text-subtlest, #626f86)",
    'elevation.surface.contrast': 'transparent',
    'elevation.surface.contrast.bolder': 'transparent'
};
const $15099970f99feec5$export$f286efa6bd1e8f9d = {
    'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #626F86)",
    'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
    'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
    'color.background.disabled': "var(--ds-background-neutral, #091E420F)",
    'color.background.input': 'rgba(255, 255, 255, 0.8)',
    'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
    'color.text.selected': `var(--ds-text-inverse, ${(0, $PdmhA).N0})`
};
const $15099970f99feec5$export$97cb21c6432e07e8 = {
    'color.background.brand.bold': 'rgba(255, 255, 255, 0.8)',
    'color.background.brand.bold.hovered': 'rgba(255, 255, 255, 0.6)',
    'color.background.brand.bold.pressed': 'rgba(255, 255, 255, 0.4)',
    'color.background.disabled': 'rgba(255, 255, 255, 0.08)',
    'color.background.input': 'rgba(255, 255, 255, 0.08)',
    'color.background.neutral': 'rgba(255, 255, 255, 0.08)',
    'color.background.neutral.hovered': 'rgba(255, 255, 255, 0.16)',
    'color.background.neutral.pressed': 'rgba(255, 255, 255, 0.28)',
    'color.background.neutral.subtle.hovered': 'rgba(255, 255, 255, 0.08)',
    'color.background.neutral.subtle.pressed': 'rgba(255, 255, 255, 0.16)',
    'color.background.selected': 'rgba(255, 255, 255, 0.6)',
    'color.elevation.surface': '#172b4d',
    'color.border': 'rgba(255, 255, 255, 0.14)',
    'color.border.input': 'rgba(255, 255, 255, 0.3)',
    'color.border.inverse': 'rgba(255, 255, 255, 0.3)',
    'color.border.selected': (0, $PdmhA).N0,
    'color.icon.danger': (0, $PdmhA).N0,
    'color.icon.information': (0, $PdmhA).N0,
    'color.icon.success': (0, $PdmhA).N0,
    'color.icon.warning': (0, $PdmhA).N0,
    'color.skeleton': 'rgba(255,255,255,0.08)',
    'color.text': (0, $PdmhA).N0,
    'color.text.disabled': 'rgba(255, 255, 255, 0.6)',
    'color.text.inverse': '#172B4D',
    // Neutral 1000
    'color.text.selected': '#172B4D',
    // Neutral 1000
    'color.text.subtle': 'rgba(255, 255, 255, 0.8)',
    'color.text.subtlest': 'rgba(255, 255, 255, 0.8)'
};
const $15099970f99feec5$export$b124f62a6aab972 = {
    'color.link': '#CCE0FF',
    // Blue 200
    'color.link.pressed': '#E9F2FF' // Blue 100
};
const $15099970f99feec5$export$9441e0d8f766c59a = {
    name: 'image',
    brightness: 'high',
    theme: {
        light: {
            'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #626F86)",
            'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
            'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
            'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
            'color.link': "var(--ds-text-accent-blue-bolder, #09326C)",
            'color.link.pressed': "var(--ds-text-accent-blue, #0055CC)",
            'color.text.selected': `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
            'elevation.surface.contrast': 'rgba(255,255,255,0.82)',
            'elevation.surface.contrast.bolder': `var(--ds-surface, ${(0, $PdmhA).N0})`
        },
        dark: {
            'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #8C9BAB)",
            'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #9FADBC)",
            'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #B6C2CF)",
            'color.background.input': 'rgba(34, 39, 43, 0.8)',
            'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #B6C2CF)",
            'color.elevation.surface': '#172b4d',
            'color.border': 'rgba(255, 255, 255, 0.14)',
            'color.border.input': 'rgba(255, 255, 255, 0.3)',
            'color.border.inverse': 'rgba(255, 255, 255, 0.3)',
            'color.icon.danger': (0, $PdmhA).N0,
            'color.icon.information': (0, $PdmhA).N0,
            'color.icon.success': (0, $PdmhA).N0,
            'color.icon.warning': (0, $PdmhA).N0,
            'color.link': "var(--ds-text-accent-blue-bolder, #CCE0FF)",
            'color.link.pressed': "var(--ds-text-accent-blue, #85B8FF)",
            'color.skeleton': 'rgba(255,255,255,0.8)',
            'color.text': (0, $PdmhA).N0,
            'color.text.selected': "var(--ds-text-inverse, #1D2125)",
            'elevation.surface.contrast': 'rgba(29, 33, 37, 0.82)',
            'elevation.surface.contrast.bolder': "var(--ds-surface, #1D2125)"
        }
    }
};
// Old Colors
const $15099970f99feec5$var$WHITE_BACKGROUND_CONFIG = {
    name: 'white'
};
const $15099970f99feec5$var$LIGHT_PURPLE_BACKGROUND_CONFIG = {
    name: 'light-purple'
};
const $15099970f99feec5$var$LIGHT_BLUE_BACKGROUND_CONFIG = {
    name: 'light-blue'
};
const $15099970f99feec5$var$LIGHT_TEAL_BACKGROUND_CONFIG = {
    name: 'light-teal'
};
const $15099970f99feec5$var$LIGHT_GREEN_BACKGROUND_CONFIG = {
    name: 'light-green'
};
const $15099970f99feec5$var$LIGHT_YELLOW_BACKGROUND_CONFIG = {
    name: 'light-yellow'
};
const $15099970f99feec5$var$LIGHT_RED_BACKGROUND_CONFIG = {
    name: 'light-red'
};
const $15099970f99feec5$var$LIGHT_MAGENTA_BACKGROUND_CONFIG = {
    name: 'light-magenta'
};
const $15099970f99feec5$var$LIGHT_ORANGE_BACKGROUND_CONFIG = {
    name: 'light-orange'
};
const $15099970f99feec5$var$DARK_BACKGROUND_CONFIG = {
    name: 'dark'
};
const $15099970f99feec5$var$PURPLE_BACKGROUND_CONFIG = {
    name: 'purple'
};
const $15099970f99feec5$var$BLUE_BACKGROUND_CONFIG = {
    name: 'blue'
};
const $15099970f99feec5$var$TEAL_BACKGROUND_CONFIG = {
    name: 'teal'
};
const $15099970f99feec5$var$GREEN_BACKGROUND_CONFIG = {
    name: 'green'
};
const $15099970f99feec5$var$YELLOW_BACKGROUND_CONFIG = {
    name: 'yellow'
};
const $15099970f99feec5$var$RED_BACKGROUND_CONFIG = {
    name: 'red'
};
const $15099970f99feec5$var$MAGENTA_BACKGROUND_CONFIG = {
    name: 'magenta'
};
const $15099970f99feec5$var$ORANGE_BACKGROUND_CONFIG = {
    name: 'orange'
};
// New Colors
const $15099970f99feec5$var$DARKER_GRAY_BACKGROUND_CONFIG = {
    name: 'darker-gray',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $15099970f99feec5$var$DARKER_PURPLE_BACKGROUND_CONFIG = {
    name: 'darker-purple',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#5E4DB2',
            // Purple 800
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        },
        dark: {
            'color.elevation.surface': '#5E4DB2',
            // Purple 800
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $15099970f99feec5$var$DARKER_BLUE_BACKGROUND_CONFIG = {
    name: 'darker-blue',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#0055CC',
            // Blue 800
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        },
        dark: {
            'color.elevation.surface': '#0055CC',
            // Blue 800
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $15099970f99feec5$var$DARKER_TEAL_BACKGROUND_CONFIG = {
    name: 'darker-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#206A83',
            // Teal 800
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        },
        dark: {
            'color.elevation.surface': '#206A83',
            // Teal 800
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $15099970f99feec5$var$DARKER_GREEN_BACKGROUND_CONFIG = {
    name: 'darker-green',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#216E4E',
            // Green 800
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        },
        dark: {
            'color.elevation.surface': '#216E4E',
            // Green 800
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $15099970f99feec5$var$DARKER_LIME_BACKGROUND_CONFIG = {
    name: 'darker-lime',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#4C6B1F',
            // Lime 800
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        },
        dark: {
            'color.elevation.surface': '#4C6B1F',
            // Lime 800
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $15099970f99feec5$var$DARKER_YELLOW_BACKGROUND_CONFIG = {
    name: 'darker-yellow',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#7F5F01',
            // Yellow 800
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        },
        dark: {
            'color.elevation.surface': '#7F5F01',
            // Yellow 800
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $15099970f99feec5$var$DARKER_ORANGE_BACKGROUND_CONFIG = {
    name: 'darker-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#A54800',
            // Orange 800
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        },
        dark: {
            'color.elevation.surface': '#A54800',
            // Orange 800
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $15099970f99feec5$var$DARKER_RED_BACKGROUND_CONFIG = {
    name: 'darker-red',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#AE2E24',
            // Red 800
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        },
        dark: {
            'color.elevation.surface': '#AE2E24',
            // Red 800
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $15099970f99feec5$var$DARKER_MAGENTA_BACKGROUND_CONFIG = {
    name: 'darker-magenta',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#943D73',
            // Magenta 800
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        },
        dark: {
            'color.elevation.surface': '#943D73',
            // Magenta 800
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $15099970f99feec5$var$DARKEST_GRAY_BACKGROUND_CONFIG = {
    name: 'darkest-gray',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#172B4D',
            // Neutral 1000
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        },
        dark: {
            'color.elevation.surface': '#172B4D',
            // Neutral 1000
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $15099970f99feec5$var$DARKEST_PURPLE_BACKGROUND_CONFIG = {
    name: 'darkest-purple',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#352C63',
            // Purple 900
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        },
        dark: {
            'color.elevation.surface': '#352C63',
            // Purple 900
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $15099970f99feec5$var$DARKEST_BLUE_BACKGROUND_CONFIG = {
    name: 'darkest-blue',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#09326C',
            // Blue 900
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        },
        dark: {
            'color.elevation.surface': '#09326C',
            // Blue 900
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $15099970f99feec5$var$DARKEST_TEAL_BACKGROUND_CONFIG = {
    name: 'darkest-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#164555',
            // Teal 900
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        },
        dark: {
            'color.elevation.surface': '#164555',
            // Teal 900
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $15099970f99feec5$var$DARKEST_GREEN_BACKGROUND_CONFIG = {
    name: 'darkest-green',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#164B35',
            // Green 900
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        },
        dark: {
            'color.elevation.surface': '#164B35',
            // Green 900
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $15099970f99feec5$var$DARKEST_LIME_BACKGROUND_CONFIG = {
    name: 'darkest-lime',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#37471F',
            // Lime 900
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        },
        dark: {
            'color.elevation.surface': '#37471F',
            // Lime 900
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $15099970f99feec5$var$DARKEST_YELLOW_BACKGROUND_CONFIG = {
    name: 'darkest-yellow',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#533F04',
            // Yellow 900
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        },
        dark: {
            'color.elevation.surface': '#533F04',
            // Yellow 900
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $15099970f99feec5$var$DARKEST_ORANGE_BACKGROUND_CONFIG = {
    name: 'darkest-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#702E00',
            // Orange 900
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        },
        dark: {
            'color.elevation.surface': '#702E00',
            // Orange 900
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $15099970f99feec5$var$DARKEST_RED_BACKGROUND_CONFIG = {
    name: 'darkest-red',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#5D1F1A',
            // Red 900
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        },
        dark: {
            'color.elevation.surface': '#5D1F1A',
            // Red 900
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $15099970f99feec5$var$DARKEST_MAGENTA_BACKGROUND_CONFIG = {
    name: 'darkest-magenta',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#50253F',
            // Magenta 900
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        },
        dark: {
            'color.elevation.surface': '#50253F',
            // Magenta 900
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $15099970f99feec5$var$LIGHTEST_GRAY_BACKGROUND_CONFIG = {
    name: 'lightest-gray',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#F1F2F4',
            // Neutral 200
            'color.link': '#44546F',
            // Neutral 800
            'color.link.pressed': '#091E42' // Neutral 1100
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $15099970f99feec5$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG = {
    name: 'lightest-purple',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#F3F0FF',
            // Purple 100
            'color.link': '#5E4DB2',
            // Purple 800
            'color.link.pressed': '#352C63' // Purple 900
        },
        dark: {
            'color.elevation.surface': '#5E4DB2',
            // Purple 800
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $15099970f99feec5$var$LIGHTEST_BLUE_BACKGROUND_CONFIG = {
    name: 'lightest-blue',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#E9F2FF',
            // Blue 100
            'color.link': '#0055CC',
            // Blue 800
            'color.link.pressed': '#09326C' // Blue 900
        },
        dark: {
            'color.elevation.surface': '#0055CC',
            // Blue 800
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $15099970f99feec5$var$LIGHTEST_TEAL_BACKGROUND_CONFIG = {
    name: 'lightest-teal',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#E7F9FF',
            // Teal 100
            'color.link': '#206A83',
            // Teal 800
            'color.link.pressed': '#164555' // Teal 900
        },
        dark: {
            'color.elevation.surface': '#206A83',
            // Teal 800
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $15099970f99feec5$var$LIGHTEST_GREEN_BACKGROUND_CONFIG = {
    name: 'lightest-green',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#DCFFF1',
            // Green 100
            'color.link': '#216E4E',
            // Green 800
            'color.link.pressed': '#164B35' // Green 900
        },
        dark: {
            'color.elevation.surface': '#216E4E',
            // Green 800
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $15099970f99feec5$var$LIGHTEST_LIME_BACKGROUND_CONFIG = {
    name: 'lightest-lime',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#EFFFD6',
            // Lime 100
            'color.link': '#4C6B1F',
            // Lime 800
            'color.link.pressed': '#37471F' // Lime 900
        },
        dark: {
            'color.elevation.surface': '#4C6B1F',
            // Lime 800
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $15099970f99feec5$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG = {
    name: 'lightest-yellow',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFF7D6',
            // Yellow 100
            'color.link': '#7F5F01',
            // Yellow 800
            'color.link.pressed': '#533F04' // Yellow 900
        },
        dark: {
            'color.elevation.surface': '#7F5F01',
            // Yellow 800
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $15099970f99feec5$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG = {
    name: 'lightest-orange',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFF3EB',
            // Orange 100
            'color.link': '#A54800',
            // Orange 800
            'color.link.pressed': '#702E00' // Orange 900
        },
        dark: {
            'color.elevation.surface': '#A54800',
            // Orange 800
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $15099970f99feec5$var$LIGHTEST_RED_BACKGROUND_CONFIG = {
    name: 'lightest-red',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFECEB',
            // Red 100
            'color.link': '#AE2E24',
            // Red 800
            'color.link.pressed': '#5D1F1A' // Red 900
        },
        dark: {
            'color.elevation.surface': '#AE2E24',
            // Red 800
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $15099970f99feec5$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG = {
    name: 'lightest-magenta',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFECF8',
            // Magenta 100
            'color.link': '#943D73',
            // Magenta 800
            'color.link.pressed': '#50253F' // Magenta 900
        },
        dark: {
            'color.elevation.surface': '#943D73',
            // Magenta 800
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $15099970f99feec5$var$LIGHTER_GRAY_BACKGROUND_CONFIG = {
    name: 'lighter-gray',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#DCDFE4',
            // Neutral 200
            'color.link': '#44546F',
            // Neutral 800
            'color.link.pressed': '#091E42' // Neutral 1100
        },
        dark: {
            'color.elevation.surface': '#172B4D',
            // Neutral 1000
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $15099970f99feec5$var$LIGHTER_PURPLE_BACKGROUND_CONFIG = {
    name: 'lighter-purple',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#DFD8FD',
            // Purple 200
            'color.link': '#5E4DB2',
            // Purple 800
            'color.link.pressed': '#352C63' // Purple 900
        },
        dark: {
            'color.elevation.surface': '#352C63',
            // Purple 900
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $15099970f99feec5$var$LIGHTER_BLUE_BACKGROUND_CONFIG = {
    name: 'lighter-blue',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#CCE0FF',
            // Blue 200
            'color.link': '#0055CC',
            // Blue 800
            'color.link.pressed': '#09326C' // Blue 900
        },
        dark: {
            'color.elevation.surface': '#09326C',
            // Blue 900
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $15099970f99feec5$var$LIGHTER_TEAL_BACKGROUND_CONFIG = {
    name: 'lighter-teal',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#C6EDFB',
            // Teal 200
            'color.link': '#206A83',
            // Teal 800
            'color.link.pressed': '#164555' // Teal 900
        },
        dark: {
            'color.elevation.surface': '#164555',
            // Teal 900
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $15099970f99feec5$var$LIGHTER_GREEN_BACKGROUND_CONFIG = {
    name: 'lighter-green',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#BAF3DB',
            // Green 200
            'color.link': '#216E4E',
            // Green 800
            'color.link.pressed': '#164B35' // Green 900
        },
        dark: {
            'color.elevation.surface': '#164B35',
            // Green 900
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $15099970f99feec5$var$LIGHTER_LIME_BACKGROUND_CONFIG = {
    name: 'lighter-lime',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#D3F1A7',
            // Lime 200
            'color.link': '#4C6B1F',
            // Lime 800
            'color.link.pressed': '#37471F' // Lime 900
        },
        dark: {
            'color.elevation.surface': '#37471F',
            // Lime 900
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $15099970f99feec5$var$LIGHTER_YELLOW_BACKGROUND_CONFIG = {
    name: 'lighter-yellow',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#F8E6A0',
            // Yellow 200
            'color.link': '#7F5F01',
            // Yellow 800
            'color.link.pressed': '#533F04' // Yellow 900
        },
        dark: {
            'color.elevation.surface': '#533F04',
            // Yellow 900
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $15099970f99feec5$var$LIGHTER_ORANGE_BACKGROUND_CONFIG = {
    name: 'lighter-orange',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FEDEC8',
            // Orange 200
            'color.link': '#A54800',
            // Orange 800
            'color.link.pressed': '#702E00' // Orange 900
        },
        dark: {
            'color.elevation.surface': '#702E00',
            // Orange 900
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $15099970f99feec5$var$LIGHTER_RED_BACKGROUND_CONFIG = {
    name: 'lighter-red',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFD5D2',
            // Red 200
            'color.link': '#AE2E24',
            // Red 800
            'color.link.pressed': '#5D1F1A' // Red 900
        },
        dark: {
            'color.elevation.surface': '#5D1F1A',
            // Red 900
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $15099970f99feec5$var$LIGHTER_MAGENTA_BACKGROUND_CONFIG = {
    name: 'lighter-magenta',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FDD0EC',
            // Magenta 200
            'color.link': '#943D73',
            // Magenta 800
            'color.link.pressed': '#50253F' // Magenta 900
        },
        dark: {
            'color.elevation.surface': '#50253F',
            // Magenta 900
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $15099970f99feec5$export$4c351ec1dc290344 = {
    name: 'no-background',
    brightness: 'high',
    theme: {
        light: $15099970f99feec5$export$8a6e9b3370a0f87a,
        dark: $15099970f99feec5$export$8a6e9b3370a0f87a
    }
};
// Gradients
const $15099970f99feec5$var$GRADIENT_GRAY_TO_BLACK_META = {
    name: 'gradient-gray-to-black',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #0B1D3A 0%, #505F79 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #0B1D3A 0%, #505F79 100%)'
        }
    }
};
const $15099970f99feec5$var$GRADIENT_DARK_TO_MEDIUM_PURPLE_META = {
    name: 'gradient-dark-to-medium-purple',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #002D6D 0%, #61013C 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #002D6D 0%, #61013C 100%)'
        }
    }
};
const $15099970f99feec5$var$GRADIENT_LIGHT_TO_DARK_BLUE_META = {
    name: 'gradient-light-to-dark-blue',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #001F4A 0%, #0033B7 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #001F4A 0%, #0033B7 100%)'
        }
    }
};
const $15099970f99feec5$var$GRADIENT_BLUE_TO_TEAL_META = {
    name: 'gradient-blue-to-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #000D81 0%, #1492A3 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #000D81 0%, #1492A3 100%)'
        }
    }
};
const $15099970f99feec5$var$GRADIENT_PURPLE_TO_MAGENTA_META = {
    name: 'gradient-purple-to-magenta',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #13006F 0%, #CD519D 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #13006F 0%, #CD519D 100%)'
        }
    }
};
const $15099970f99feec5$var$GRADIENT_MAGENTA_TO_ORANGE_META = {
    name: 'gradient-magenta-to-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #7D004B 28.5%, #BF3900 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #7D004B 28.5%, #BF3900 100%)'
        }
    }
};
const $15099970f99feec5$var$GRADIENT_DARK_TO_LIGHT_RED_META = {
    name: 'gradient-dark-to-light-red',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #150000 0%, #CA0000 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #150000 0%, #CA0000 100%)'
        }
    }
};
const $15099970f99feec5$var$GRADIENT_DARK_TO_LIGHT_ORANGE_META = {
    name: 'gradient-dark-to-light-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #650101 0%, #C75300 99.75%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #650101 0%, #C75300 99.75%)'
        }
    }
};
const $15099970f99feec5$var$GRADIENT_DARK_GREEN_TO_LIME_META = {
    name: 'gradient-dark-green-to-lime',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #072C14 0%, #457200 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #072C14 0%, #457200 100%)'
        }
    }
};
const $15099970f99feec5$var$GRADIENT_DARK_TO_MEDIUM_TEAL_META = {
    name: 'gradient-dark-to-medium-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #00152D 0%, #02607E 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #00152D 0%, #02607E 100%)'
        }
    }
};
const $15099970f99feec5$export$34373eced7ee212e = [
    $15099970f99feec5$var$WHITE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHT_PURPLE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHT_BLUE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHT_TEAL_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHT_GREEN_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHT_YELLOW_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHT_ORANGE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHT_RED_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHT_MAGENTA_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARK_BACKGROUND_CONFIG,
    $15099970f99feec5$var$PURPLE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$BLUE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$TEAL_BACKGROUND_CONFIG,
    $15099970f99feec5$var$GREEN_BACKGROUND_CONFIG,
    $15099970f99feec5$var$YELLOW_BACKGROUND_CONFIG,
    $15099970f99feec5$var$ORANGE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$RED_BACKGROUND_CONFIG,
    $15099970f99feec5$var$MAGENTA_BACKGROUND_CONFIG
];
const $15099970f99feec5$export$5ddfadab7b1e12c1 = [
    $15099970f99feec5$var$LIGHTEST_GRAY_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTEST_BLUE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTEST_TEAL_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTEST_GREEN_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTEST_LIME_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTEST_RED_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTER_GRAY_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTER_PURPLE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTER_BLUE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTER_TEAL_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTER_GREEN_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTER_LIME_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTER_YELLOW_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTER_ORANGE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTER_RED_BACKGROUND_CONFIG,
    $15099970f99feec5$var$LIGHTER_MAGENTA_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKER_GRAY_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKER_PURPLE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKER_BLUE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKER_TEAL_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKER_GREEN_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKER_LIME_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKER_YELLOW_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKER_ORANGE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKER_RED_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKER_MAGENTA_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKEST_GRAY_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKEST_PURPLE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKEST_BLUE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKEST_TEAL_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKEST_GREEN_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKEST_LIME_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKEST_YELLOW_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKEST_ORANGE_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKEST_RED_BACKGROUND_CONFIG,
    $15099970f99feec5$var$DARKEST_MAGENTA_BACKGROUND_CONFIG
];
const $15099970f99feec5$export$349e5dbeac874253 = [
    ...$15099970f99feec5$export$5ddfadab7b1e12c1,
    $15099970f99feec5$export$4c351ec1dc290344
];
const $15099970f99feec5$export$242b2d2213fedf27 = [
    $15099970f99feec5$var$GRADIENT_DARK_TO_LIGHT_RED_META,
    $15099970f99feec5$var$GRADIENT_MAGENTA_TO_ORANGE_META,
    $15099970f99feec5$var$GRADIENT_DARK_TO_LIGHT_ORANGE_META,
    $15099970f99feec5$var$GRADIENT_DARK_GREEN_TO_LIME_META,
    $15099970f99feec5$var$GRADIENT_BLUE_TO_TEAL_META,
    $15099970f99feec5$var$GRADIENT_DARK_TO_MEDIUM_TEAL_META,
    $15099970f99feec5$var$GRADIENT_LIGHT_TO_DARK_BLUE_META,
    $15099970f99feec5$var$GRADIENT_DARK_TO_MEDIUM_PURPLE_META,
    $15099970f99feec5$var$GRADIENT_PURPLE_TO_MAGENTA_META,
    $15099970f99feec5$var$GRADIENT_GRAY_TO_BLACK_META
];
const $15099970f99feec5$export$8f118a95a310853a = [
    ...$15099970f99feec5$export$242b2d2213fedf27,
    ...$15099970f99feec5$export$349e5dbeac874253
];
const $15099970f99feec5$export$fe05a238062e2c3d = {
    white: $15099970f99feec5$export$4c351ec1dc290344,
    'light-purple': $15099970f99feec5$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG,
    'light-blue': $15099970f99feec5$var$LIGHTEST_BLUE_BACKGROUND_CONFIG,
    'light-teal': $15099970f99feec5$var$LIGHTEST_TEAL_BACKGROUND_CONFIG,
    'light-green': $15099970f99feec5$var$LIGHTEST_GREEN_BACKGROUND_CONFIG,
    'light-yellow': $15099970f99feec5$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG,
    'light-orange': $15099970f99feec5$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG,
    'light-red': $15099970f99feec5$var$LIGHTEST_RED_BACKGROUND_CONFIG,
    'light-magenta': $15099970f99feec5$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG,
    dark: $15099970f99feec5$var$DARKEST_GRAY_BACKGROUND_CONFIG,
    purple: $15099970f99feec5$var$DARKER_PURPLE_BACKGROUND_CONFIG,
    blue: $15099970f99feec5$var$DARKER_BLUE_BACKGROUND_CONFIG,
    teal: $15099970f99feec5$var$DARKER_TEAL_BACKGROUND_CONFIG,
    green: $15099970f99feec5$var$DARKER_GREEN_BACKGROUND_CONFIG,
    yellow: $15099970f99feec5$var$DARKER_YELLOW_BACKGROUND_CONFIG,
    orange: $15099970f99feec5$var$DARKER_ORANGE_BACKGROUND_CONFIG,
    red: $15099970f99feec5$var$DARKER_RED_BACKGROUND_CONFIG,
    magenta: $15099970f99feec5$var$DARKER_MAGENTA_BACKGROUND_CONFIG
};
const $15099970f99feec5$export$cab9d853866386f2 = $15099970f99feec5$export$4c351ec1dc290344;
const $15099970f99feec5$export$ed7cc0d417ee89e = '--jwm-banner-height';
const $15099970f99feec5$export$7009ab5fba189797 = `var(${$15099970f99feec5$export$ed7cc0d417ee89e}, 0px)`;
const $15099970f99feec5$export$baaf8255c30ea280 = 95;
const $15099970f99feec5$export$8e357501548afe78 = 24;
const $15099970f99feec5$export$d9035bc768f8226d = `calc(${$15099970f99feec5$export$baaf8255c30ea280}px + ${$15099970f99feec5$export$7009ab5fba189797})`;
const $15099970f99feec5$export$4810531e30462f89 = `calc(100vh - ${(0, $aYtGv.PAGE_LAYOUT_OFFSET_TOP)} - ${$15099970f99feec5$export$d9035bc768f8226d})`;
const $15099970f99feec5$export$1c0b806722927549 = `calc(100vh - ${(0, $aYtGv.PAGE_LAYOUT_OFFSET_TOP)} - ${$15099970f99feec5$export$d9035bc768f8226d} - ${$15099970f99feec5$export$8e357501548afe78 * 2}px)`;
const $15099970f99feec5$export$77cdace62a821419 = `calc(100vw - ${(0, $ho1Ek.LEFT_PANEL_WIDTH)} - ${(0, $ho1Ek.LEFT_SIDEBAR_WIDTH)} - ${(0, $ho1Ek.RIGHT_PANEL_WIDTH)} - ${(0, $ho1Ek.RIGHT_SIDEBAR_WIDTH)}) !important`;
const $15099970f99feec5$export$3efe68325dd9dc02 = `calc(100vw - ${(0, $ho1Ek.LEFT_PANEL_WIDTH)} - ${(0, $ho1Ek.LEFT_SIDEBAR_WIDTH)} - ${(0, $ho1Ek.RIGHT_PANEL_WIDTH)} - ${(0, $ho1Ek.RIGHT_SIDEBAR_WIDTH)} - ${$15099970f99feec5$export$8e357501548afe78 * 2}px) !important`;

});

parcelRegister("fzymf", function(module, exports) {

$parcel$export(module.exports, "overviewDetailsResource", () => $a5200a1419c8dbcb$export$cd57aa046b167312);
$parcel$export(module.exports, "useOverview", () => $a5200a1419c8dbcb$export$626541a5c6f2cfa1);

var $3HCkE = parcelRequire("3HCkE");

var $wLx84 = parcelRequire("wLx84");
const $a5200a1419c8dbcb$var$RESOURCE_TYPE_KEY = 'BUSINESS_OVERVIEW_DETAILS';
const $a5200a1419c8dbcb$export$cd57aa046b167312 = (0, $3HCkE.createResource)({
    type: $a5200a1419c8dbcb$var$RESOURCE_TYPE_KEY,
    getKey: ({ match: match })=>`${$a5200a1419c8dbcb$var$RESOURCE_TYPE_KEY}_${match.params.overviewId}`,
    getData: async ({ match: match }, { tenantContext: { cloudId: cloudId, activationId: activationId } })=>(0, $wLx84.fetchOverviewDetails)(cloudId, activationId, match.params.overviewId),
    maxAge: 3600000
});
const $a5200a1419c8dbcb$export$626541a5c6f2cfa1 = ()=>(0, $3HCkE.useResource)($a5200a1419c8dbcb$export$cd57aa046b167312);

});
parcelRegister("wLx84", function(module, exports) {

$parcel$export(module.exports, "fetchOverviewDetails", () => $218a2f4d5429f49f$export$f0395142dbdd6c61);

var $hhcsA = parcelRequire("hhcsA");

var $dlVOn = parcelRequire("dlVOn");

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $lRmyA = parcelRequire("lRmyA");

var $huI7r = parcelRequire("huI7r");

var $3UEL2 = parcelRequire("3UEL2");

const $218a2f4d5429f49f$export$f0395142dbdd6c61 = async (cloudId, activationId, overviewId)=>{
    if (!overviewId) return null;
    try {
        const response = await (0, $lRmyA.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $3UEL2.QUERY),
                variables: {
                    id: (0, $huI7r.createAri)({
                        resourceOwner: 'jira',
                        cloudId: cloudId,
                        resourceType: 'project-overview',
                        resourceId: overviewId,
                        activationId: activationId
                    })
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'projectStyle'
            }
        });
        if (response?.data?.jira?.overview?.__typename === (0, $555b6ab3251d313a$export$62a5da7e3fa5ff88)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return (0, $hhcsA.mapOverviewFragment)(response.data.jira.overview);
        throw new (0, $dlVOn.GraphQLErrors)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        response?.data?.jira?.overview ?? response.errors);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 410 means that overviews have been migrated to plans and
        // we will show a different message on the not found page.
        if ((0, $1ybV0.ff)('ploverview_overviews_to_plans_migration') && error?.statusCode === 410) throw error;
        (0, $gUUjF.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessOverviewDetails', 'Something went wrong while fetching business overview details');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) {
            (0, $guiFP.default)({
                meta: {
                    id: 'overviewDetailsResource',
                    packageName: 'jiraRouterResourcesBusinessOverviewDetails',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
    return null;
};

});
parcelRegister("hhcsA", function(module, exports) {

$parcel$export(module.exports, "mapOverviewFragment", () => $bc15f4b08a142f23$export$e79bf238de33eabb);
const $bc15f4b08a142f23$var$SIMPLIFIED_PROJECT_STYLE = 'TEAM_MANAGED_PROJECT';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bc15f4b08a142f23$var$mapProjectsNode = (edges)=>edges.map((edge)=>{
        const { node: node } = edge || {};
        if (node == null) return null;
        return {
            key: node.key,
            id: Number(node.projectId),
            avatarUrl: node.avatar?.large ?? '',
            name: node.name,
            type: node.projectType.toLowerCase(),
            isSimplified: node.projectStyle === $bc15f4b08a142f23$var$SIMPLIFIED_PROJECT_STYLE,
            isFavorite: node.isFavourite === true,
            permissions: {
                administerProject: node.administerProject.canPerform,
                createIssues: node.createIssues.canPerform,
                deleteIssues: node.deleteIssues.canPerform,
                editIssues: node.editIssues.canPerform,
                linkIssues: node.linkIssues.canPerform,
                scheduleIssues: node.scheduleIssues.canPerform,
                // remove optional chaining when jwm-use-updated-graphql-querymutation-for-overview is cleaned up
                transitionIssues: node.transitionIssues?.canPerform === true,
                viewIssues: node.viewIssues.canPerform
            }
        };
    }).filter((project)=>project);
const $bc15f4b08a142f23$export$e79bf238de33eabb = (overview)=>{
    const { id: id, name: name, theme: theme, projects: projectsData } = overview;
    const projects = $bc15f4b08a142f23$var$mapProjectsNode(projectsData.edges);
    const unreachableProjectsCount = projectsData.edges.length - projects.length;
    return {
        id: id,
        name: name,
        theme: theme,
        projects: projects,
        unreachableProjectsCount: unreachableProjectsCount
    };
};

});

parcelRegister("dlVOn", function(module, exports) {

$parcel$export(module.exports, "GraphQLErrors", () => $c8c10c82db3c32ef$export$89c202e66b2de2b6);

var $hbMki = parcelRequire("hbMki");

var $1c8hB = parcelRequire("1c8hB");
// Sets the error message on this error according to the
// the GraphQL errors that are present.
const $c8c10c82db3c32ef$var$generateErrorMessage = (err)=>{
    let message = '';
    // If we have GraphQL errors present, add that to the error message.
    if ((0, (/*@__PURE__*/$parcel$interopDefault($1c8hB)))(err.graphQLErrors) && err.graphQLErrors.length > 0) err.graphQLErrors.forEach((graphQLError)=>{
        const errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += `${errorMessage}\n`;
    });
    // strip newline from the end of the message
    message = message.replace(/\n$/, '');
    return message;
};
class $c8c10c82db3c32ef$export$89c202e66b2de2b6 extends Error {
    constructor(graphQLErrors){
        super();
        this.graphQLErrors = graphQLErrors != null ? (0, (/*@__PURE__*/$parcel$interopDefault($hbMki)))(graphQLErrors) : [];
        this.message = $c8c10c82db3c32ef$var$generateErrorMessage(this);
        this.cause = this.graphQLErrors?.[0];
        this.statusCode = this.cause?.extensions?.statusCode ?? this.cause?.extensions?.[0]?.statusCode ?? -1;
        this.errorType = this.cause?.extensions?.errorType ?? this.cause?.extensions?.[0]?.errorType ?? null;
    }
}

});
parcelRegister("hbMki", function(module, exports) {

var $1c8hB = parcelRequire("1c8hB");
/**
 * Casts `value` as an array if it's not one.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Lang
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast array.
 * @example
 *
 * _.castArray(1);
 * // => [1]
 *
 * _.castArray({ 'a': 1 });
 * // => [{ 'a': 1 }]
 *
 * _.castArray('abc');
 * // => ['abc']
 *
 * _.castArray(null);
 * // => [null]
 *
 * _.castArray(undefined);
 * // => [undefined]
 *
 * _.castArray();
 * // => []
 *
 * var array = [1, 2, 3];
 * console.log(_.castArray(array) === array);
 * // => true
 */ function $c838f35dc30c870d$var$castArray() {
    if (!arguments.length) return [];
    var value = arguments[0];
    return $1c8hB(value) ? value : [
        value
    ];
}
module.exports = $c838f35dc30c870d$var$castArray;

});


parcelRegister("3UEL2", function(module, exports) {

$parcel$export(module.exports, "QUERY", () => $286b893702b0066e$export$2b91517d6d5b4365);

const $286b893702b0066e$export$2b91517d6d5b4365 = `
    query JwmOverviewDetails($id:ID!) {
      jira {
        overview: jwmOverview(id: $id) {
          __typename
          ... on JiraWorkManagementGiraOverview {
            ...OverviewGiraFragment
          }
          ... on QueryError {
            message
            extensions {
              errorType
              statusCode
            }
          }
        }
      }
    }
    ${(0, $fd066e0e866fe0bc$export$6f4bda7ea1dcf892)}
`;

});
const $fd066e0e866fe0bc$export$6f4bda7ea1dcf892 = `
fragment OverviewGiraFragment on JiraWorkManagementGiraOverview {
  id
  name
  theme
  projects {
    edges {
      node {
        key
        projectId
        avatar {
          large
        }
        name
        projectType
        projectStyle
        isFavourite
        administerProject: action(type: EDIT_PROJECT_CONFIG) {
          canPerform
        }
        createIssues: action(type: CREATE_ISSUES) {
          canPerform
        }
        deleteIssues: action(type: DELETE_ISSUES) {
          canPerform
        }
        editIssues: action(type: EDIT_ISSUES) {
          canPerform
        }
        linkIssues: action(type: LINK_ISSUES) {
          canPerform
        }
        scheduleIssues: action(type: SCHEDULE_ISSUES) {
          canPerform
        }
        transitionIssues: action(type: TRANSITION_ISSUES) {
          canPerform
        }
        viewIssues: action(type: VIEW_ISSUES) {
          canPerform
        }
      }
    }
  }
}
`;


const $555b6ab3251d313a$export$62a5da7e3fa5ff88 = 'JiraWorkManagementGiraOverview';




parcelRegister("4EvIi", function(module, exports) {

$parcel$export(module.exports, "useProjectTheme", () => $1782e76953ed5a6c$export$18084206b9430153);

var $eUqFw = parcelRequire("eUqFw");

var $kar7l = parcelRequire("kar7l");

var $3HCkE = parcelRequire("3HCkE");

var $aeIT6 = parcelRequire("aeIT6");
const $1782e76953ed5a6c$export$18084206b9430153 = ()=>{
    const { data: data } = (0, $3HCkE.useResource)((0, $aeIT6.projectDetailsResource));
    return (0, $eUqFw.useMemo)(()=>{
        if (data != null) {
            const entityId = `project/${data.currentProject?.id}`;
            const themeSetting = data.themeSetting ?? {
                type: 'color',
                value: (0, $kar7l.DEFAULT_BACKGROUND_CONFIG).name
            };
            return {
                themeSetting: themeSetting,
                entityId: entityId
            };
        }
        return null;
    }, [
        data
    ]);
};

});
parcelRegister("aeIT6", function(module, exports) {

$parcel$export(module.exports, "projectDetailsResource", () => $d8cccda868228b81$export$e541d9eb202b4972);
$parcel$export(module.exports, "useProject", () => $d8cccda868228b81$export$51b1383ef8844a7);
$parcel$export(module.exports, "useMediaConfiguration", () => $d8cccda868228b81$export$ab5cf8327e07f046);

var $3HCkE = parcelRequire("3HCkE");

var $9zYls = parcelRequire("9zYls");

var $Qqb3l = parcelRequire("Qqb3l");
const $d8cccda868228b81$var$RESOURCE_TYPE_KEY = 'RESOURCE_TYPE_BUSINESS_PROJECT_DETAILS';
const $d8cccda868228b81$export$e541d9eb202b4972 = (0, $3HCkE.createResource)({
    type: $d8cccda868228b81$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        const projectIdOrKey = projectKey || projectId;
        return `${$d8cccda868228b81$var$RESOURCE_TYPE_KEY}_${projectIdOrKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
        return (0, $Qqb3l.fetchProjectDetails)(cloudId, projectKey, projectId);
    },
    maxAge: 3600000
});
const $d8cccda868228b81$export$51b1383ef8844a7 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $3HCkE.useResource)($d8cccda868228b81$export$e541d9eb202b4972);
    return {
        data: data?.currentProject ?? null,
        loading: loading,
        error: error
    };
};
const $d8cccda868228b81$export$ab5cf8327e07f046 = ()=>{
    const { data: data } = (0, $3HCkE.useResource)($d8cccda868228b81$export$e541d9eb202b4972);
    return data?.media ?? null;
};

});
parcelRegister("Qqb3l", function(module, exports) {

$parcel$export(module.exports, "fetchProjectDetails", () => $b6d7f500e2b72f80$export$78aa221476efa1c6);

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $huI7r = parcelRequire("huI7r");


var $9RmFy = parcelRequire("9RmFy");
const $b6d7f500e2b72f80$var$EMPTY_VALUE = {
    themeSetting: null,
    media: null
};
const $b6d7f500e2b72f80$export$78aa221476efa1c6 = async (cloudId, projectKey, projectId)=>{
    const projectIdOrKey = projectId || projectKey;
    if (!projectIdOrKey) return null;
    try {
        const response = await (0, $lRmyA.performPostRequest)('/rest/gira/1/?operation=JiraBusinessProjectDetails', {
            body: JSON.stringify({
                query: (0, $561d2537991d9a5d$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId,
                    projectIdOrKey: projectIdOrKey,
                    usingProjectKey: projectId == null,
                    projectId: projectId != null ? (0, $huI7r.createAri)({
                        resourceOwner: 'jira',
                        cloudId: cloudId,
                        resourceType: 'project',
                        resourceId: projectId
                    }) : ''
                }
            })
        });
        return (0, $9RmFy.transformData)(response.data, projectIdOrKey);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessProjectDetails', 'Something went wrong while fetching business project details');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) {
            (0, $guiFP.default)({
                meta: {
                    id: 'projectDetailsResource',
                    packageName: 'jiraRouterResourcesBusinessProjectDetails',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
    return $b6d7f500e2b72f80$var$EMPTY_VALUE;
};

});
const $561d2537991d9a5d$var$PROJECT_FRAGMENT = `
fragment ProjectFragment on JiraProject {
  key
  projectId
  avatar {
    large
  }
  name
  projectType
  status
  simplified
  favorite
  administerProject: action(type: EDIT_PROJECT_CONFIG) {
    canPerform
  }
  createIssues: action(type: CREATE_ISSUES) {
    canPerform
  }
  deleteIssues: action(type: DELETE_ISSUES) {
    canPerform
  }
  editIssues: action(type: EDIT_ISSUES) {
    canPerform
  }
  linkIssues: action(type: LINK_ISSUES) {
    canPerform
  }
  scheduleIssues: action(type: SCHEDULE_ISSUES) {
    canPerform
  }
  transitionIssues: action(type: TRANSITION_ISSUES) {
    canPerform
  }
  viewIssues: action(type: VIEW_ISSUES) {
    canPerform
  }
}
`;
const $561d2537991d9a5d$export$2b91517d6d5b4365 = `
query JiraBusinessProjectDetails($cloudId: ID!, $projectIdOrKey: String!, $usingProjectKey: Boolean!, $projectId: ID!) {
  jira {
    mediaClientId(cloudId: $cloudId)
    mediaExternalEndpointUrl(cloudId: $cloudId)
  }
  jwmSidebar(cloudId: $cloudId, projectIdOrKey: $projectIdOrKey) {
    jiraProjectByKey(cloudId: $cloudId, key: $projectIdOrKey) @include(if: $usingProjectKey) {
      ...ProjectFragment
    }
    jiraProjectById(id: $projectId) @skip(if: $usingProjectKey) {
      ...ProjectFragment
    }
    theme: jwmActiveBackgroundByProject(projectIdOrKey: $projectIdOrKey) {
      __typename
      ... on QueryError {
        identifier
        message
        extensions {
          statusCode
          errorType
        }
      }
      ... on JiraWorkManagementBackground {
        ... on JiraWorkManagementColorBackground {
          colorValue
        }
        ... on JiraWorkManagementGradientBackground {
          gradientValue
        }
        ... on JiraWorkManagementMediaBackground {
          customBackground {
            id
            mediaApiFileId
            mediaReadToken (durationInSeconds: 600)
            sourceType
            sourceIdentifier
            altText
          }
        }
      }
    }
  }
}
${$561d2537991d9a5d$var$PROJECT_FRAGMENT}
`;

parcelRegister("9RmFy", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $402e94b0015519f9$export$3ceb62baab058c6b);
const $402e94b0015519f9$var$mapProjectNode = (node)=>{
    if (node == null) return null;
    return {
        key: node.key,
        id: Number(node.projectId),
        avatarUrl: node.avatar?.large ?? '',
        name: node.name,
        type: node.projectType.toLowerCase(),
        status: node.status,
        isSimplified: node.simplified,
        isFavorite: node.favorite === true,
        permissions: {
            administerProject: node.administerProject.canPerform,
            createIssues: node.createIssues.canPerform,
            deleteIssues: node.deleteIssues.canPerform,
            editIssues: node.editIssues.canPerform,
            linkIssues: node.linkIssues.canPerform,
            scheduleIssues: node.scheduleIssues.canPerform,
            transitionIssues: node.transitionIssues.canPerform,
            viewIssues: node.viewIssues.canPerform
        }
    };
};
const $402e94b0015519f9$var$parseThemeSetting = (data)=>{
    const theme = data?.jwmSidebar?.theme;
    if (theme?.__typename === 'JiraWorkManagementColorBackground') return {
        type: 'color',
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        value: theme.colorValue
    };
    if (theme?.__typename === 'JiraWorkManagementGradientBackground') return {
        type: 'color',
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        value: theme.gradientValue
    };
    if (theme?.__typename === 'JiraWorkManagementMediaBackground') {
        const { customBackground: customBackground } = theme;
        const { id: id, mediaApiFileId: mediaApiFileId, mediaReadToken: mediaReadToken, sourceType: sourceType, sourceIdentifier: sourceIdentifier, altText: altText } = customBackground;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return {
            type: 'image',
            value: 'image',
            id: id,
            mediaApiFileId: mediaApiFileId,
            mediaReadToken: mediaReadToken,
            sourceType: sourceType,
            sourceIdentifier: sourceIdentifier,
            altText: altText
        };
    }
    return null;
};
const $402e94b0015519f9$var$parseMediaConfiguration = (data)=>{
    const clientId = data?.jira?.mediaClientId;
    const externalEndpointUrl = data?.jira?.mediaExternalEndpointUrl;
    if (clientId == null || externalEndpointUrl == null) return null;
    return {
        clientId: clientId,
        externalEndpointUrl: externalEndpointUrl
    };
};
const $402e94b0015519f9$export$3ceb62baab058c6b = (data, projectIdOrKey)=>({
        themeSetting: $402e94b0015519f9$var$parseThemeSetting(data),
        currentProject: $402e94b0015519f9$var$mapProjectNode(data?.jwmSidebar?.jiraProjectByKey) ?? $402e94b0015519f9$var$mapProjectNode(data?.jwmSidebar?.jiraProjectById) ?? null,
        projectIdOrKey: projectIdOrKey,
        media: $402e94b0015519f9$var$parseMediaConfiguration(data)
    });

});




parcelRegister("4e72F", function(module, exports) {

$parcel$export(module.exports, "ThemeTokensSetter", () => $7fcf00ff916ea46e$export$41f41c7ff10d45cd);

var $eUqFw = parcelRequire("eUqFw");

var $2vzCR = parcelRequire("2vzCR");

var $PdmhA = parcelRequire("PdmhA");

var $bcnRH = parcelRequire("bcnRH");

var $c9TLT = parcelRequire("c9TLT");

var $kar7l = parcelRequire("kar7l");
var $bOA3Q = parcelRequire("bOA3Q");

var $gDxeq = parcelRequire("gDxeq");
/**
 * Will merge multiple themes together, with the last theme taking precedence.
 * The first argument is the base theme, and the rest are partial themes that
 * will be merged into the base theme.
 */ function $7fcf00ff916ea46e$var$mergeThemes(theme, ...partialThemes) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, theme, ...partialThemes);
}
const $7fcf00ff916ea46e$var$buildThemeVariables = (config, backgroundImageUrl, isDarkMode)=>{
    const applicationColorMode = isDarkMode ? 'dark' : 'light';
    const brightnessOverrides = config.brightness === 'high' && !isDarkMode ? (0, $kar7l.HIGH_BRIGHTNESS_THEME) : (0, $kar7l.LOW_BRIGHTNESS_THEME);
    const isImageConfig = config.name === 'image';
    const isGradientConfig = (0, $bOA3Q.themeManager).isGradientTheme(config.name);
    /**
   * The base theme and the custom theme get merged here, with the custom theme taking precedence.
   * If you want to override configurations globally, then you should make modifications to the
   * BASE_THEME, while if you want to customize a specific theme, then you should make modifications
   * in the theme's themselves.
   */ const theme = $7fcf00ff916ea46e$var$mergeThemes(// the base theme for the application
    (0, $kar7l.BASE_THEME), // the brightness overrides
    isImageConfig ? {} : brightnessOverrides, // gradient specific overrides
    isGradientConfig ? (0, $kar7l.GRADIENT_THEME) : {}, // The custom background configuration
    config.theme[applicationColorMode]);
    let elevationSurface = theme['elevation.surface'] ?? theme['color.elevation.surface'];
    if (backgroundImageUrl) // in dark mode, the image will be darkened by blending with a black transparent background
    elevationSurface = `url(${backgroundImageUrl}) center center / cover no-repeat${isDarkMode ? ' #0000004d' : ''}`;
    else if (applicationColorMode === 'dark') {
        if ((0, $kar7l.NO_BACKGROUND_CONFIG).name !== config.name && !isGradientConfig) /**
       * Add a gradient to the elevation surface for any themes in dark mode. This could be done in the
       * meta configuration but it's easier to do bulk edits here.
       */ elevationSurface = `linear-gradient(180deg, ${theme['color.elevation.surface']} 0%, ${"var(--ds-surface, #1D2125)"} 400px)`;
    }
    // Wrapper configuration
    const withWrapper = config.name !== (0, $kar7l.DEFAULT_BACKGROUND_CONFIG).name;
    const wrapperBackground = withWrapper ? `var(--ds-surface, ${0, $PdmhA.N0})` : 'unset';
    const wrapperBorderRadius = withWrapper ? `${0, $c9TLT.gridSize}px` : '0';
    const wrapperHeight = withWrapper ? (0, $kar7l.BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT) : (0, $kar7l.BUSINESS_WRAPPER_HEIGHT);
    const wrapperPadding = withWrapper ? `${0, $kar7l.BUSINESS_WRAPPER_PADDING}px` : '0';
    const wrapperWidth = withWrapper ? (0, $kar7l.BUSINESS_WRAPPER_WITH_BACKGROUND_WIDTH) : (0, $kar7l.BUSINESS_WRAPPER_WIDTH);
    return `
${(0, $kar7l.Variables).BACKDROP_FILTER}: ${isImageConfig ? 'blur(8px)' : 'none'};
${(0, $kar7l.Variables).COLOR_BACKGROUND_BRAND_BOLD}: ${theme['color.background.brand.bold']};
${(0, $kar7l.Variables).COLOR_BACKGROUND_BRAND_BOLD_HOVERED}: ${theme['color.background.brand.bold.hovered']};
${(0, $kar7l.Variables).COLOR_BACKGROUND_BRAND_BOLD_PRESSED}: ${theme['color.background.brand.bold.pressed']};
${(0, $kar7l.Variables).COLOR_BACKGROUND_DISABLED}: ${theme['color.background.disabled']};
${(0, $kar7l.Variables).COLOR_BACKGROUND_INPUT}: ${theme['color.background.input']};
${(0, $kar7l.Variables).COLOR_BACKGROUND_NEUTRAL}: ${theme['color.background.neutral']};
${(0, $kar7l.Variables).COLOR_BACKGROUND_NEUTRAL_HOVERED}: ${theme['color.background.neutral.hovered']};
${(0, $kar7l.Variables).COLOR_BACKGROUND_NEUTRAL_PRESSED}: ${theme['color.background.neutral.pressed']};
${(0, $kar7l.Variables).COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED}: ${theme['color.background.neutral.subtle.hovered']};
${(0, $kar7l.Variables).COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED}: ${theme['color.background.neutral.subtle.pressed']};
${(0, $kar7l.Variables).COLOR_BACKGROUND_SELECTED}: ${theme['color.background.selected']};
${(0, $kar7l.Variables).COLOR_BORDER}: ${theme['color.border']};
${(0, $kar7l.Variables).COLOR_BORDER_INPUT}: ${theme['color.border.input']};
${(0, $kar7l.Variables).COLOR_BORDER_INVERSE}: ${theme['color.border.inverse']};
${(0, $kar7l.Variables).COLOR_BORDER_SELECTED}: ${theme['color.border.selected']};
${(0, $kar7l.Variables).COLOR_ELEVATION_SURFACE}: ${theme['color.elevation.surface']};
${(0, $kar7l.Variables).COLOR_ICON_DANGER}: ${theme['color.icon.danger']};
${(0, $kar7l.Variables).COLOR_ICON_INFORMATION}: ${theme['color.icon.information']};
${(0, $kar7l.Variables).COLOR_ICON_SUCCESS}: ${theme['color.icon.success']};
${(0, $kar7l.Variables).COLOR_ICON_WARNING}: ${theme['color.icon.warning']};
${(0, $kar7l.Variables).COLOR_LINK}: ${theme['color.link']};
${(0, $kar7l.Variables).COLOR_LINK_PRESSED}: ${theme['color.link.pressed']};
${(0, $kar7l.Variables).COLOR_SKELETON}: ${theme['color.skeleton']};
${(0, $kar7l.Variables).COLOR_TEXT}: ${theme['color.text']};
${(0, $kar7l.Variables).COLOR_TEXT_DISABLED}: ${theme['color.text.disabled']};
${(0, $kar7l.Variables).COLOR_TEXT_INVERSE}: ${theme['color.text.inverse']};
${(0, $kar7l.Variables).COLOR_TEXT_SELECTED}: ${theme['color.text.selected']};
${(0, $kar7l.Variables).COLOR_TEXT_SUBTLE}: ${theme['color.text.subtle']};
${(0, $kar7l.Variables).COLOR_TEXT_SUBTLEST}: ${theme['color.text.subtlest']};
${(0, $kar7l.Variables).CONTENT_HEIGHT}: ${0, $kar7l.BUSINESS_WRAPPER_HEIGHT};
${(0, $kar7l.Variables).CONTENT_WIDTH}: ${0, $kar7l.BUSINESS_WRAPPER_WIDTH};
${(0, $kar7l.Variables).ELEVATION_SURFACE}: ${elevationSurface};
${(0, $kar7l.Variables).ELEVATION_SURFACE_CONTRAST}: ${theme['elevation.surface.contrast']};
${(0, $kar7l.Variables).ELEVATION_SURFACE_CONTRAST_BOLDER}: ${theme['elevation.surface.contrast.bolder']};
${(0, $kar7l.Variables).WRAPPER_BACKGROUND}: ${wrapperBackground};
${(0, $kar7l.Variables).WRAPPER_BORDER_RADIUS}: ${wrapperBorderRadius};
${(0, $kar7l.Variables).WRAPPER_HEIGHT}: ${wrapperHeight};
${(0, $kar7l.Variables).WRAPPER_PADDING}: ${wrapperPadding};
${(0, $kar7l.Variables).WRAPPER_WIDTH}: ${wrapperWidth};
`;
};
const $7fcf00ff916ea46e$export$41f41c7ff10d45cd = /*#__PURE__*/ (0, $eUqFw.memo)(()=>{
    const [{ themeSetting: themeSetting }] = (0, $bcnRH.useThemeHook)();
    const backgroundConfig = (0, $bOA3Q.themeManager).get({
        themeSetting: themeSetting,
        enableImages: true
    });
    const backgroundImageUrl = (0, $gDxeq.useBackgroundImageUrl)(themeSetting);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("style", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `:root{ ${$7fcf00ff916ea46e$var$buildThemeVariables(backgroundConfig, backgroundImageUrl, false)} }
        [data-color-mode=dark]{ ${$7fcf00ff916ea46e$var$buildThemeVariables(backgroundConfig, backgroundImageUrl, true)} }`
        }
    }));
});

});
parcelRegister("bcnRH", function(module, exports) {

$parcel$export(module.exports, "ThemeContainerOld", () => $0f9ed0aa218118d3$export$c6e50a832af54243);
$parcel$export(module.exports, "ThemeContainer", () => $0f9ed0aa218118d3$export$11eb671888ed6e7d);
$parcel$export(module.exports, "useThemeHook", () => $0f9ed0aa218118d3$export$b95ba2c6b597cfbb);
$parcel$export(module.exports, "useThemeSetting", () => $0f9ed0aa218118d3$export$87d26f94ea053d38);
$parcel$export(module.exports, "useSelectedThemeSetting", () => $0f9ed0aa218118d3$export$4ba6f9d407e18961);

var $hTLlD = parcelRequire("hTLlD");

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $bj4JM = parcelRequire("bj4JM");
var $a61MH = parcelRequire("a61MH");

var $bOA3Q = parcelRequire("bOA3Q");
const $0f9ed0aa218118d3$var$setTheme = (newTheme)=>({ getState: getState, setState: setState })=>{
        const { entityId: entityId, themeSetting: themeSetting, selectedThemeSetting: selectedThemeSetting } = getState();
        if ((0, $bOA3Q.themeManager).isValidTheme(newTheme) && !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(themeSetting?.value, newTheme?.value)) setState({
            entityId: entityId,
            selectedThemeSetting: selectedThemeSetting,
            themeSetting: newTheme
        });
    };
const $0f9ed0aa218118d3$var$setSelectedThemeSetting = (newTheme)=>({ getState: getState, setState: setState })=>{
        const { entityId: entityId, themeSetting: themeSetting, selectedThemeSetting: selectedThemeSetting } = getState();
        if (newTheme === null || (0, $bOA3Q.themeManager).isValidTheme(newTheme) && !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(selectedThemeSetting?.type === 'image' ? selectedThemeSetting?.id : selectedThemeSetting?.value, newTheme?.type === 'image' ? newTheme?.id : newTheme?.value)) setState({
            entityId: entityId,
            themeSetting: themeSetting,
            selectedThemeSetting: newTheme
        });
    };
const $0f9ed0aa218118d3$var$actions = {
    setTheme: $0f9ed0aa218118d3$var$setTheme,
    setSelectedThemeSetting: $0f9ed0aa218118d3$var$setSelectedThemeSetting
};
const $0f9ed0aa218118d3$var$initialState = {
    themeSetting: null,
    selectedThemeSetting: null,
    entityId: ''
};
const $0f9ed0aa218118d3$var$Store = (0, $a61MH.createStore)({
    initialState: $0f9ed0aa218118d3$var$initialState,
    actions: $0f9ed0aa218118d3$var$actions,
    name: 'BusinessTheme'
});
const $0f9ed0aa218118d3$export$c6e50a832af54243 = (0, $heB5U.createContainer)($0f9ed0aa218118d3$var$Store, {
    onInit: ()=>({ setState: setState }, entityTheme)=>setState(entityTheme),
    onUpdate: ()=>({ setState: setState }, entityTheme)=>setState(entityTheme)
});
const $0f9ed0aa218118d3$export$11eb671888ed6e7d = (0, $heB5U.createContainer)($0f9ed0aa218118d3$var$Store, {
    onInit: ()=>({ setState: setState }, { entityTheme: entityTheme })=>{
            setState(entityTheme ?? $0f9ed0aa218118d3$var$initialState);
        },
    onUpdate: ()=>({ setState: setState }, { entityTheme: entityTheme })=>{
            setState(entityTheme ?? $0f9ed0aa218118d3$var$initialState);
        }
});
const $0f9ed0aa218118d3$export$b95ba2c6b597cfbb = (0, $ggKAj.createHook)($0f9ed0aa218118d3$var$Store);
const $0f9ed0aa218118d3$var$getThemeSetting = (0, $bj4JM.createSelector)((state)=>state.themeSetting, (themeSetting)=>themeSetting);
const $0f9ed0aa218118d3$export$87d26f94ea053d38 = (0, $ggKAj.createHook)($0f9ed0aa218118d3$var$Store, {
    selector: $0f9ed0aa218118d3$var$getThemeSetting
});
const $0f9ed0aa218118d3$var$getSelectedThemeSetting = (0, $bj4JM.createSelector)((state)=>state.selectedThemeSetting, (selectedThemeSetting)=>selectedThemeSetting);
const $0f9ed0aa218118d3$export$4ba6f9d407e18961 = (0, $ggKAj.createHook)($0f9ed0aa218118d3$var$Store, {
    selector: $0f9ed0aa218118d3$var$getSelectedThemeSetting
});

});
parcelRegister("bOA3Q", function(module, exports) {

$parcel$export(module.exports, "themeManager", () => $24bff9bf7f80d721$export$aba92a7f3273f617);
$parcel$export(module.exports, "generateMediaImageUrl", () => $24bff9bf7f80d721$export$fe2402bbc6ac3125);

var $kar7l = parcelRequire("kar7l");
/**
 * This is a temporary class that will be used to transition between the old
 * and new theme systems. Once the old theme system is removed, this class
 * will be removed as well.
 */ class $24bff9bf7f80d721$var$ThemeManager {
    init() {
        (0, $kar7l.GRADIENT_BACKGROUND_CONFIGS).forEach((theme)=>{
            this.gradients.set(theme.name, theme);
            this.gradientNames.add(theme.name);
        });
        (0, $kar7l.SOLID_COLOR_BACKGROUND_CONFIGS).forEach((theme)=>{
            this.colors.set(theme.name, theme);
            this.colorNames.add(theme.name);
        });
        (0, $kar7l.BACKGROUND_CONFIGS_OLD).forEach((theme)=>{
            this.oldColorNames.add(theme.name);
        });
    }
    isColorTheme(themeName) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return this.colorNames.has(themeName);
    }
    isOldColorTheme(themeName) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return this.oldColorNames.has(themeName);
    }
    isGradientTheme(themeName) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return this.gradientNames.has(themeName);
    }
    isImageTheme(themeSetting) {
        return themeSetting.type === 'image';
    }
    getGradient(themeName) {
        return this.gradients.get(themeName);
    }
    getColor(themeName) {
        return this.colors.get(themeName);
    }
    /**
	 * Gets the theme meta for the given theme setting and version.
	 * This is used because we want to handle cases where users get flag
	 * variations during rollout that change what background is allowed.
	 * For example, if you have a new background color, but the flag is off,
	 * we want to revert back to the default background color instead.
	 * @param themeSetting the name setting with its type and value.
	 * @param enableImages determines if image backgrounds are enabled.
	 * @returns the meta information for the theme.
	 */ get({ themeSetting: themeSetting, enableImages: enableImages }) {
        if (!themeSetting) return 0, $kar7l.DEFAULT_BACKGROUND_CONFIG;
        if (enableImages && themeSetting.type === 'image') return 0, $kar7l.IMAGE_BACKGROUND_CONFIG;
        if (this.isGradientTheme(themeSetting.value)) return this.getGradient(themeSetting.value) ?? (0, $kar7l.DEFAULT_BACKGROUND_CONFIG);
        if (this.isColorTheme(themeSetting.value)) return this.getColor(themeSetting.value) ?? (0, $kar7l.DEFAULT_BACKGROUND_CONFIG);
        // we have an old color on the image version
        return(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $kar7l.OLD_TO_NEW_BACKGROUND_CONFIG_MAP)[themeSetting.value] ?? (0, $kar7l.DEFAULT_BACKGROUND_CONFIG));
    }
    constructor(){
        this.gradients = new Map();
        this.gradientNames = new Set();
        this.colors = new Map();
        this.colorNames = new Set();
        this.oldColorNames = new Set();
        this.isValidTheme = (themeSetting)=>this.isColorTheme(themeSetting.value) || this.isOldColorTheme(themeSetting.value) || this.isGradientTheme(themeSetting.value) || this.isImageTheme(themeSetting);
    }
}
const $24bff9bf7f80d721$export$aba92a7f3273f617 = new $24bff9bf7f80d721$var$ThemeManager();
$24bff9bf7f80d721$export$aba92a7f3273f617.init();
function $24bff9bf7f80d721$export$fe2402bbc6ac3125({ mediaApiFileId: mediaApiFileId, mediaClientId: mediaClientId, mediaExternalEndpointUrl: mediaExternalEndpointUrl, mediaEndpoint: mediaEndpoint, ...queryParams }) {
    const url = new URL(`${mediaExternalEndpointUrl}/file/${mediaApiFileId}/${mediaEndpoint}`);
    url.searchParams.append('client', mediaClientId);
    Object.entries(queryParams).forEach(([param, value])=>url.searchParams.append(param, String(value)));
    return url.toString();
}

});


parcelRegister("gDxeq", function(module, exports) {

$parcel$export(module.exports, "useBackgroundImageUrl", () => $1b8d41c84ad2c647$export$16f28a2a10ece447);

var $eUqFw = parcelRequire("eUqFw");

var $asu8X = parcelRequire("asu8X");

var $ifH0n = parcelRequire("ifH0n");

var $bOA3Q = parcelRequire("bOA3Q");

var $guiFP = parcelRequire("guiFP");

var $JRB5w = parcelRequire("JRB5w");

var $aeIT6 = parcelRequire("aeIT6");
const $1b8d41c84ad2c647$export$16f28a2a10ece447 = (themeSetting)=>{
    (0, $asu8X.di)(URL, fetch);
    const media = (0, $aeIT6.useMediaConfiguration)();
    const lowResUrl = (0, $eUqFw.useMemo)(()=>media && themeSetting?.type === 'image' ? (0, $bOA3Q.generateMediaImageUrl)({
            mediaClientId: media.clientId,
            mediaExternalEndpointUrl: media.externalEndpointUrl,
            mediaApiFileId: themeSetting.mediaApiFileId,
            token: themeSetting.mediaReadToken,
            mediaEndpoint: 'image',
            width: 1000,
            'max-age': Number.MAX_SAFE_INTEGER
        }) : null, [
        media,
        themeSetting
    ]);
    const [imageUrl, setImageUrl] = (0, $eUqFw.useState)(lowResUrl);
    const currentThemeId = (0, $eUqFw.useRef)(null);
    currentThemeId.current = themeSetting?.type === 'image' ? themeSetting.id : null;
    (0, $eUqFw.useEffect)(()=>{
        setImageUrl(lowResUrl);
        // if we don't have an image theme, do nothing
        if (!media || themeSetting?.type !== 'image') return;
        // build a new URL to the /binary path
        const binaryUrl = (0, $bOA3Q.generateMediaImageUrl)({
            mediaClientId: media.clientId,
            mediaExternalEndpointUrl: media.externalEndpointUrl,
            mediaApiFileId: themeSetting.mediaApiFileId,
            mediaEndpoint: 'binary',
            'max-age': Number.MAX_SAFE_INTEGER
        });
        // send a request to fetch the image with the binary URL with bearer token authentication
        fetch(binaryUrl.toString(), {
            headers: {
                Authorization: `Bearer ${themeSetting.mediaReadToken}`
            }
        }).then((response)=>response.blob()).then((blob)=>{
            const objectUrl = URL.createObjectURL(blob);
            if (currentThemeId.current === themeSetting.id) {
                setImageUrl(objectUrl);
                // send viewing analytics to Unsplash for Unsplash images
                if (themeSetting.sourceType === 'UNSPLASH' && themeSetting.sourceIdentifier) (0, $ifH0n.unsplashTracker).trackImage(themeSetting.sourceIdentifier);
            }
        }).catch((error)=>{
            // only fire error analytics if the error is not a client fetch error (e.g. network error, aborted)
            if (!(0, $JRB5w.isClientFetchError)(error)) (0, $guiFP.default)({
                meta: {
                    id: 'fetchBinaryBackgroundImage',
                    packageName: 'jiraBusinessThemeComponents',
                    teamName: 'work-management-frontier'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        });
    }, [
        themeSetting,
        media,
        lowResUrl
    ]);
    return imageUrl;
};

});
parcelRegister("ifH0n", function(module, exports) {

$parcel$export(module.exports, "unsplashTracker", () => $8eb46b17b2c5777f$export$1869e04dbed4c16c);

var $aYAw7 = parcelRequire("aYAw7");

var $dxIU5 = parcelRequire("dxIU5");
const $8eb46b17b2c5777f$var$APP_ID = '7066';
const $8eb46b17b2c5777f$export$ca6dda5263526f75 = `https://views.unsplash.com/v?app_id=${$8eb46b17b2c5777f$var$APP_ID}`;
const $8eb46b17b2c5777f$var$MAX_URL_LENGTH = 2083; // the maximum length of a URL in most browsers
const $8eb46b17b2c5777f$var$ID_LENGTH = 12; // the length of an unsplash image id
const $8eb46b17b2c5777f$export$28219189b23a0628 = Math.floor($8eb46b17b2c5777f$var$MAX_URL_LENGTH / $8eb46b17b2c5777f$var$ID_LENGTH);
/**
 * This class is responsible for tracking unsplash images that are displayed in the app.
 * This is needed for legal reasons to comply with the Unsplash API terms of service.
 * It will track the image when it is displayed and then track it again every 10 minutes.
 */ class $8eb46b17b2c5777f$var$UnsplashTracker {
    /**
	 * Send a request to the Unsplash API to track the image views.
	 * This will send a request for all the images in the queue.
	 * If the request fails, the images will be added back to the queue.
	 */ send() {
        if (this.queue.size === 0) return;
        const imageIds = Array.from(this.queue);
        this.queue.clear();
        (0, (/*@__PURE__*/$parcel$interopDefault($aYAw7)))(imageIds, $8eb46b17b2c5777f$export$28219189b23a0628).forEach((chunkIds)=>{
            const url = `${$8eb46b17b2c5777f$export$ca6dda5263526f75}&photoId=${chunkIds.join(',')}`;
            const now = new Date();
            imageIds.forEach((imageId)=>{
                this.trackedImages.set(imageId, now);
            });
            const handleFailure = ()=>{
                // if the request fails, add the image ids back to the queue
                imageIds.forEach((imageId)=>{
                    this.queue.add(imageId);
                    this.trackedImages.delete(imageId);
                });
            };
            fetch(url).then((response)=>{
                if (!response.ok) handleFailure();
            }).catch(()=>handleFailure());
        });
    }
    /**
	 * Track an image view. This will add the image to the queue to be tracked.
	 * If the image was tracked less than 10 minutes ago, it will not be added to the queue.
	 * @param sourceIdentifier The Unsplash photo id to track. Usually formatted as `photo-<something>-<id>`
	 * @returns void
	 */ trackImage(sourceIdentifier) {
        const imageId = sourceIdentifier.split('-').pop(); // photo-1696144706485-ff7825ec8481 -> ff7825ec8481
        if (!imageId) return;
        const lastTracked = this.trackedImages.get(imageId);
        if (lastTracked && Date.now() - lastTracked.getTime() < this.trackingInterval) return;
        this.queue.add(imageId);
        this.sendDebounced();
    }
    /**
	 * Track an image view while it is in the viewport. This will track the image when it is displayed
	 * and then track it again every 10 minutes.
	 * @param element The element that contains the image
	 * @param sourceIdentifier The Unsplash photo id to track. Usually formatted as `photo-<something>-<id>`
	 * @returns A function to stop tracking the image
	 */ trackWhileInViewport(element, sourceIdentifier) {
        let trackIntervalId = null;
        const observer = new IntersectionObserver((entry)=>{
            if (entry[0].isIntersecting && !trackIntervalId) {
                $8eb46b17b2c5777f$export$1869e04dbed4c16c.trackImage(sourceIdentifier);
                trackIntervalId = window.setInterval(()=>{
                    $8eb46b17b2c5777f$export$1869e04dbed4c16c.trackImage(sourceIdentifier);
                }, this.trackingInterval + 10); // extra 10ms to ensure the interval is always greater than 10 minutes
            } else if (trackIntervalId) window.clearInterval(trackIntervalId);
        }, {
            rootMargin: '0px',
            threshold: 1.0
        });
        observer.observe(element);
        return ()=>{
            observer.disconnect();
            if (trackIntervalId) window.clearInterval(trackIntervalId);
        };
    }
    static getInstance() {
        if (!$8eb46b17b2c5777f$var$UnsplashTracker.instance) $8eb46b17b2c5777f$var$UnsplashTracker.instance = new $8eb46b17b2c5777f$var$UnsplashTracker();
        return $8eb46b17b2c5777f$var$UnsplashTracker.instance;
    }
    constructor(){
        this.trackedImages = new Map();
        this.trackingInterval = 600000 // 10 minutes
        ;
        this.queue = new Set();
        this.sendDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(this.send, 1000);
    }
}
const $8eb46b17b2c5777f$export$1869e04dbed4c16c = $8eb46b17b2c5777f$var$UnsplashTracker.getInstance();

});
parcelRegister("aYAw7", function(module, exports) {

var $jADKY = parcelRequire("jADKY");

var $3P7i5 = parcelRequire("3P7i5");

var $hNahz = parcelRequire("hNahz");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7fdbd58793adf3d8$var$nativeCeil = Math.ceil, $7fdbd58793adf3d8$var$nativeMax = Math.max;
/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */ function $7fdbd58793adf3d8$var$chunk(array, size, guard) {
    if (guard ? $3P7i5(array, size, guard) : size === undefined) size = 1;
    else size = $7fdbd58793adf3d8$var$nativeMax($hNahz(size), 0);
    var length = array == null ? 0 : array.length;
    if (!length || size < 1) return [];
    var index = 0, resIndex = 0, result = Array($7fdbd58793adf3d8$var$nativeCeil(length / size));
    while(index < length)result[resIndex++] = $jADKY(array, index, index += size);
    return result;
}
module.exports = $7fdbd58793adf3d8$var$chunk;

});





parcelRegister("fkND2", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('2etjo');
        const value = parcelRequire('eAAlI');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("2etjo").then(()=>parcelRequire('eAAlI'));
}

});



parcelRegister("cEX90", function(module, exports) {

$parcel$export(module.exports, "ThemedContentLayout", () => $82d01d0a73f3012e$export$c2c3c7c0b13a1f9d);
$parcel$export(module.exports, "BusinessWrapper", () => $82d01d0a73f3012e$export$17220b5b22a6586);
/* BusinessWrapper.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $3zjRf = parcelRequire("3zjRf");
const $82d01d0a73f3012e$var$styles = {
    root: "_kqswh2mm",
    fullHeight: "_1tkeidpf _4t3i1osq",
    insetRoot: "_1yt4y22u",
    insetContainer: "_2rkolsi6 _bfhk8q8z"
};
const $82d01d0a73f3012e$export$c2c3c7c0b13a1f9d = ({ children: children, appearance: appearance })=>/*#__PURE__*/ $eUqFw.createElement("div", {
        className: (0, $7JEyt.default)([
            $82d01d0a73f3012e$var$styles.root,
            $82d01d0a73f3012e$var$styles.fullHeight,
            appearance === 'inset' && $82d01d0a73f3012e$var$styles.insetRoot
        ])
    }, /*#__PURE__*/ $eUqFw.createElement("div", {
        className: (0, $7JEyt.default)([
            $82d01d0a73f3012e$var$styles.fullHeight,
            appearance === 'inset' && $82d01d0a73f3012e$var$styles.insetContainer
        ])
    }, children));
const $82d01d0a73f3012e$export$17220b5b22a6586 = ({ withWhiteBackground: withWhiteBackground, children: children })=>{
    if (withWhiteBackground) return /*#__PURE__*/ $eUqFw.createElement((0, $3zjRf.OuterWrapperWithBackground), null, /*#__PURE__*/ $eUqFw.createElement((0, $3zjRf.InnerWrapperWithBackground), null, children));
    return /*#__PURE__*/ $eUqFw.createElement((0, $3zjRf.OuterWrapper), null, /*#__PURE__*/ $eUqFw.createElement((0, $3zjRf.InnerWrapper), null, children));
};

});
parcelRegister("3zjRf", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $d2afd9eae3f40ab2$export$edaaad985a878983);
$parcel$export(module.exports, "OuterWrapperWithBackground", () => $d2afd9eae3f40ab2$export$69c6ec128d3729c9);
$parcel$export(module.exports, "InnerWrapper", () => $d2afd9eae3f40ab2$export$f185744748c379a7);
$parcel$export(module.exports, "InnerWrapperWithBackground", () => $d2afd9eae3f40ab2$export$2e149d12a18af14b);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $d2afd9eae3f40ab2$export$edaaad985a878983 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _154i1jzz",
            __cmplp.className
        ])
    });
});
const $d2afd9eae3f40ab2$export$69c6ec128d3729c9 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $d2afd9eae3f40ab2$export$edaaad985a878983, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4y22u",
            __cmplp.className
        ])
    });
});
const $d2afd9eae3f40ab2$export$f185744748c379a7 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2d3f1oc1 _japi1mcq _iu1g1fl4 _fok81wug _q7c11wug",
            __cmplp.className
        ])
    });
});
const $d2afd9eae3f40ab2$export$2e149d12a18af14b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $d2afd9eae3f40ab2$export$f185744748c379a7, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rkolsi6 _bfhk8q8z _2d3f1yz2 _japi1e8k",
            __cmplp.className
        ])
    });
});

});


parcelRegister("6WwlF", function(module, exports) {

$parcel$export(module.exports, "useBusinessLookAndFeel", () => $7836b6e7c7b98ca3$export$ad3385faee9e435a);

var $b3nmi = parcelRequire("b3nmi");

var $exb0h = parcelRequire("exb0h");

var $kLSws = parcelRequire("kLSws");

var $dWu0t = parcelRequire("dWu0t");

var $10fdS = parcelRequire("10fdS");

var $bEe6y = parcelRequire("bEe6y");
const $7836b6e7c7b98ca3$export$ad3385faee9e435a = ()=>{
    const route = (0, $10fdS.useCurrentRoute)();
    const HorizontalNavComponent = (0, $dWu0t.useHorizontalNavComponent)();
    const isBusinessRouteGroup = route.group === (0, $exb0h.ROUTE_GROUPS).CLASSIC_BUSINESS;
    const showProjectViewNavigation = HorizontalNavComponent === (0, $b3nmi.AsyncHorizontalProjectNav) || HorizontalNavComponent === (0, $b3nmi.AsyncHorizontalOverviewNav) || HorizontalNavComponent === (0, $bEe6y.AsyncHorizontalSoftwareProjectNav) || HorizontalNavComponent === (0, $kLSws.AsyncHorizontalNavPlans);
    // Shared business routes are:
    // - all routes with the project view navigation
    // - except for the routes with business group (as they already cater for the theme)
    const isSharedBusinessRoute = showProjectViewNavigation && !isBusinessRouteGroup;
    return {
        isSharedBusinessRoute: isSharedBusinessRoute,
        showProjectViewNavigation: showProjectViewNavigation
    };
};

});
parcelRegister("kLSws", function(module, exports) {

$parcel$export(module.exports, "AsyncHorizontalNavPlans", () => $245a320c345a7203$export$84e1a5f003939496);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $245a320c345a7203$var$LazyHorizontalPlansNav = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("8FuWh")).then(({ HorizontalPlansNav: HorizontalPlansNav })=>HorizontalPlansNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-plans/src/ui/index.tsx"
});
const $245a320c345a7203$export$84e1a5f003939496 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "horizontal-software-plans-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($245a320c345a7203$var$LazyHorizontalPlansNav, null));

});
parcelRegister("8FuWh", function(module, exports) {






if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("2k0t5")),
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('2hmUs'),
            load('bCeK4'),
            load('69IeS')
        ]);
        const value = parcelRequire('jwhxa');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("2k0t5")),
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("2hmUs"),
        load("bCeK4"),
        load("69IeS")
    ]).then(()=>parcelRequire('jwhxa'));
}

});



parcelRegister("7Ps9l", function(module, exports) {

$parcel$export(module.exports, "useIsKBRouteWithHorizontalNav", () => $4fc30228358de0c4$export$49e43abdbfaa6622);

var $exb0h = parcelRequire("exb0h");

var $1ybV0 = parcelRequire("1ybV0");

var $1yEMG = parcelRequire("1yEMG");

var $dWu0t = parcelRequire("dWu0t");

var $10fdS = parcelRequire("10fdS");
const $4fc30228358de0c4$export$49e43abdbfaa6622 = ()=>{
    const route = (0, $10fdS.useCurrentRoute)();
    const HorizontalNavComponent = (0, $dWu0t.useHorizontalNavComponent)();
    return (0, $1ybV0.ff)('jsm-kb-nav-refresh-changes-enabled') && route.group === (0, $exb0h.ROUTE_GROUPS).SERVICEDESK && HorizontalNavComponent === (0, $1yEMG.AsyncKbNav);
};

});
parcelRegister("1yEMG", function(module, exports) {

$parcel$export(module.exports, "AsyncKbNav", () => $6e677bdb585357fa$export$223f755b7799fe02);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $6e677bdb585357fa$var$LazyKbNav = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("eF9SJ")).then(({ KnowledgeBaseNav: KnowledgeBaseNav })=>KnowledgeBaseNav), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/knowledge-base/src/ui/index.tsx"
});
const $6e677bdb585357fa$export$223f755b7799fe02 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "horizontal-jsm-kb-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e677bdb585357fa$var$LazyKbNav, null));

});
parcelRegister("eF9SJ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('9kegF')
        ]);
        const value = parcelRequire('crjTG');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("9kegF")
    ]).then(()=>parcelRequire('crjTG'));
}

});



parcelRegister("1n0H8", function(module, exports) {

$parcel$export(module.exports, "addLeadingSlash", () => $0ff87a68793148e2$export$5b4913142e03bca8, (v) => $0ff87a68793148e2$export$5b4913142e03bca8 = v);
$parcel$export(module.exports, "hasBasename", () => $0ff87a68793148e2$export$10497c7ce66fcb84, (v) => $0ff87a68793148e2$export$10497c7ce66fcb84 = v);
$parcel$export(module.exports, "stripBasename", () => $0ff87a68793148e2$export$b69e3301ce081aa3, (v) => $0ff87a68793148e2$export$b69e3301ce081aa3 = v);
$parcel$export(module.exports, "stripTrailingSlash", () => $0ff87a68793148e2$export$d95b4586d238a081, (v) => $0ff87a68793148e2$export$d95b4586d238a081 = v);
$parcel$export(module.exports, "parsePath", () => $0ff87a68793148e2$export$8ccf933b0513f8d0, (v) => $0ff87a68793148e2$export$8ccf933b0513f8d0 = v);
$parcel$export(module.exports, "createPath", () => $0ff87a68793148e2$export$fe53371bee54353d, (v) => $0ff87a68793148e2$export$fe53371bee54353d = v);
var $0ff87a68793148e2$export$1e511d4a378977f5;
var $0ff87a68793148e2$export$5b4913142e03bca8;
var $0ff87a68793148e2$export$79c5b1569e3be9e6;
var $0ff87a68793148e2$export$10497c7ce66fcb84;
var $0ff87a68793148e2$export$b69e3301ce081aa3;
var $0ff87a68793148e2$export$d95b4586d238a081;
var $0ff87a68793148e2$export$8ccf933b0513f8d0;
var $0ff87a68793148e2$export$fe53371bee54353d;
'use strict';
$0ff87a68793148e2$export$1e511d4a378977f5 = true;
var $0ff87a68793148e2$var$addLeadingSlash = $0ff87a68793148e2$export$5b4913142e03bca8 = function addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
};
var $0ff87a68793148e2$var$stripLeadingSlash = $0ff87a68793148e2$export$79c5b1569e3be9e6 = function stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
};
var $0ff87a68793148e2$var$hasBasename = $0ff87a68793148e2$export$10497c7ce66fcb84 = function hasBasename(path, prefix) {
    return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};
var $0ff87a68793148e2$var$stripBasename = $0ff87a68793148e2$export$b69e3301ce081aa3 = function stripBasename(path, prefix) {
    return $0ff87a68793148e2$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};
var $0ff87a68793148e2$var$stripTrailingSlash = $0ff87a68793148e2$export$d95b4586d238a081 = function stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};
var $0ff87a68793148e2$var$parsePath = $0ff87a68793148e2$export$8ccf933b0513f8d0 = function parsePath(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
};
var $0ff87a68793148e2$var$createPath = $0ff87a68793148e2$export$fe53371bee54353d = function createPath(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
    return path;
};

});

parcelRegister("3oscM", function(module, exports) {

$parcel$export(module.exports, "calcRapidBoardResetState", () => $c71ed4be82b11f4e$export$2350ed3ff6c1a082);
$parcel$export(module.exports, "getApdexMatchObject", () => $c71ed4be82b11f4e$export$47e434f08768932b);
$parcel$export(module.exports, "calcRapidBoardResetStateV2", () => $c71ed4be82b11f4e$export$dbd9185166d0d04c);
$parcel$export(module.exports, "isValidRoute", () => $c71ed4be82b11f4e$export$9f3e656a7f6a3adc);

var $exb0h = parcelRequire("exb0h");
const $c71ed4be82b11f4e$export$2350ed3ff6c1a082 = (boardPaths, routeName, useStoredSettings)=>{
    let rapidBoardPaths = [
        ...boardPaths
    ];
    let resetDone = false;
    switch(routeName){
        case (0, $exb0h.ROUTE_NAMES).BROWSE_PROJECT_REDIRECT:
            rapidBoardPaths = [
                (0, $exb0h.ROUTE_NAMES).BROWSE_PROJECT_REDIRECT
            ];
            resetDone = true;
            break;
        case (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_BOARD:
        case (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_BACKLOG:
        case (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_REPORT:
            if (useStoredSettings) {
                rapidBoardPaths = [
                    ...rapidBoardPaths,
                    'useStoredSettings'
                ];
                resetDone = false;
                break;
            }
            if (!useStoredSettings && rapidBoardPaths.indexOf((0, $exb0h.ROUTE_NAMES).BROWSE_PROJECT_REDIRECT) > -1 && rapidBoardPaths.indexOf('useStoredSettings') > -1 || rapidBoardPaths.indexOf('useStoredSettings') > -1) resetDone = true;
            rapidBoardPaths = [];
            break;
        default:
            resetDone = false;
    }
    return [
        rapidBoardPaths,
        resetDone
    ];
};
const $c71ed4be82b11f4e$export$47e434f08768932b = (match, route)=>{
    let cleanMatch = {
        ...match,
        params: {
            ...match.params
        },
        query: {
            ...match.query
        }
    };
    if (route.apdexIgnoreParams && route.apdexIgnoreParams.length > 0) route.apdexIgnoreParams.forEach((apdexIgnoreParam)=>{
        const { params: params, query: query } = match;
        const paramKeys = params && Object.keys(params);
        const queryKeys = query && Object.keys(query);
        const isIgnoreInParams = paramKeys && paramKeys.length > 0 && paramKeys.indexOf(apdexIgnoreParam) >= 0;
        const isIgnoreInQuery = queryKeys && queryKeys.length > 0 && queryKeys.indexOf(apdexIgnoreParam) >= 0;
        if (isIgnoreInParams) cleanMatch.params[apdexIgnoreParam] = apdexIgnoreParam;
        if (isIgnoreInQuery) cleanMatch.query[apdexIgnoreParam] = apdexIgnoreParam;
    });
    if (match.query && match.query.view && match.query.view === 'detail') // @ts-expect-error - TS2322 - Type 'undefined' is not assignable to type 'string'.
    cleanMatch.query.view = undefined;
    if (match.query && match.query.view && match.query.view === 'planning.nodetail') cleanMatch.query.view = 'planning';
    cleanMatch = {
        ...cleanMatch,
        url: ''
    };
    return cleanMatch;
};
const $c71ed4be82b11f4e$export$dbd9185166d0d04c = (boardPaths, routeName, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
useStoredSettings)=>{
    let rapidBoardPaths = [
        ...boardPaths
    ];
    let resetDone = false;
    switch(routeName){
        case (0, $exb0h.ROUTE_NAMES).BROWSE_PROJECT_REDIRECT:
            rapidBoardPaths = [];
            resetDone = true;
            break;
        case (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_BACKLOG:
        case (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_BOARD:
        case (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_REPORT:
            // use search to navigate to board
            if (rapidBoardPaths.includes((0, $exb0h.ROUTE_NAMES).BROWSE_PROJECT_REDIRECT) || rapidBoardPaths.includes('useStoredSettings')) {
                resetDone = true;
                rapidBoardPaths = [];
                break;
            } else if (useStoredSettings) {
                rapidBoardPaths = [
                    ...rapidBoardPaths,
                    'useStoredSettings'
                ];
                break;
            } else {
                rapidBoardPaths = [];
                break;
            }
        default:
            if (rapidBoardPaths.includes((0, $exb0h.ROUTE_NAMES).BROWSE_PROJECT_REDIRECT)) {
                resetDone = true;
                rapidBoardPaths = [];
            }
    }
    return [
        rapidBoardPaths,
        resetDone
    ];
};
const $c71ed4be82b11f4e$export$d5eae90e177f1bdd = (appId, state, searchDepth = 0)=>{
    if (state) {
        const { currentPage: currentPage, visitedPages: visitedPages } = state;
        const visitedPageLength = visitedPages.length;
        if (currentPage && currentPage.apps[appId]) return true;
        if (visitedPageLength === 0 || searchDepth <= 0) return false;
        for(let i = 1; i <= Math.min(searchDepth, visitedPageLength); i += 1){
            if (visitedPages[visitedPageLength - i].apps[appId]) return true;
        }
    }
    return false;
};
const $c71ed4be82b11f4e$export$9f3e656a7f6a3adc = (routeToCheck)=>{
    switch(routeToCheck.name){
        case (0, $exb0h.ROUTE_NAMES).ISSUE:
        case (0, $exb0h.ROUTE_NAMES).ISSUE_EMBED:
        case (0, $exb0h.ROUTE_NAMES).PROJECT_ISSUE_NAVIGATOR:
        case (0, $exb0h.ROUTE_NAMES).PROJECT_ISSUE_NAVIGATOR_CLASSIC:
        case (0, $exb0h.ROUTE_NAMES).PROJECT_ISSUE_NAVIGATOR_CORE:
        case (0, $exb0h.ROUTE_NAMES).SERVICEDESK_ISSUES:
            return true;
        default:
            return false;
    }
};

});

parcelRegister("gdW04", function(module, exports) {

$parcel$export(module.exports, "RemoteActionsContainer", () => $9cc563ab6643b6b8$export$28c2e4c663a86266);
$parcel$export(module.exports, "useRemoteActions", () => $9cc563ab6643b6b8$export$333357b3de3e67a0);
$parcel$export(module.exports, "useRemoteActionsData", () => $9cc563ab6643b6b8$export$3cc006661ae2a759);
$parcel$export(module.exports, "useMeta", () => $9cc563ab6643b6b8$export$3fb9275d3845bd5a);
$parcel$export(module.exports, "useRemoteActionsStoreActions", () => $9cc563ab6643b6b8$export$3fd21eaf97df4718);

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");
var $fZS6K = parcelRequire("fZS6K");

var $cqV4U = parcelRequire("cqV4U");
// jira freezes the global defaults object
if (!Object.isFrozen((0, $fZS6K.default))) (0, $fZS6K.default).devtools = false;
const $9cc563ab6643b6b8$var$Store = (0, $a61MH.createStore)({
    initialState: {
        meta: {},
        remoteActions: {},
        lastUpdatedAt: 0,
        isLoaded: false,
        product: undefined
    },
    actions: $cqV4U.actions,
    name: 'remoteActionsStore'
});
const $9cc563ab6643b6b8$export$28c2e4c663a86266 = (0, $heB5U.createContainer)($9cc563ab6643b6b8$var$Store, {
    onInit: ()=>({ dispatch: dispatch })=>{
            dispatch((0, $cqV4U.actions).initStore());
        }
});
const $9cc563ab6643b6b8$export$333357b3de3e67a0 = (selector)=>(0, $ggKAj.createHook)($9cc563ab6643b6b8$var$Store, {
        selector: selector
    })();
const $9cc563ab6643b6b8$export$3cc006661ae2a759 = (0, $ggKAj.createStateHook)($9cc563ab6643b6b8$var$Store, {
    selector: (state)=>state.remoteActions
});
const $9cc563ab6643b6b8$export$3fb9275d3845bd5a = (0, $ggKAj.createStateHook)($9cc563ab6643b6b8$var$Store, {
    selector: (state)=>state.meta
});
const $9cc563ab6643b6b8$export$3fd21eaf97df4718 = (0, $ggKAj.createActionsHook)($9cc563ab6643b6b8$var$Store);

});
parcelRegister("cqV4U", function(module, exports) {

$parcel$export(module.exports, "actions", () => $cd3fa27215f8b638$export$e324594224ef24da);

var $dnvcc = parcelRequire("dnvcc");

var $4t7Nl = parcelRequire("4t7Nl");

var $51DAc = parcelRequire("51DAc");

var $1xne4 = parcelRequire("1xne4");
const $cd3fa27215f8b638$export$e324594224ef24da = {
    processRemoteActions: $51DAc.processRemoteActions,
    saveActionPerformedAttempt: $1xne4.saveActionPerformedAttempt,
    initStore: $4t7Nl.initStore,
    clearActionId: $dnvcc.clearActionId
};

});
parcelRegister("dnvcc", function(module, exports) {

$parcel$export(module.exports, "clearActionId", () => $7b090ca5222c318b$export$8d8b492eefa9efba);

var $fLzjp = parcelRequire("fLzjp");
const $7b090ca5222c318b$export$8d8b492eefa9efba = (actionId)=>({ getState: getState, setState: setState }, { product: product })=>{
        const { meta: meta } = getState();
        const newMeta = {
            ...meta
        };
        delete newMeta[actionId];
        setState({
            meta: newMeta
        });
        (0, $fLzjp.writeRemoteActionsMetasToLocalStorage)(product, meta);
    };

});
parcelRegister("fLzjp", function(module, exports) {

$parcel$export(module.exports, "readRemoteActionsMetasFromLocalStorage", () => $6e7cfc6bf9421aef$export$a221266a05084986);
$parcel$export(module.exports, "writeRemoteActionsMetasToLocalStorage", () => $6e7cfc6bf9421aef$export$7228aaade919a8b6);
const $6e7cfc6bf9421aef$export$b9e25d3c75cffd71 = 'atlassian-remote-actions';
const $6e7cfc6bf9421aef$export$a221266a05084986 = (product)=>{
    try {
        return JSON.parse(localStorage.getItem(`${$6e7cfc6bf9421aef$export$b9e25d3c75cffd71}.${product}`) || '{}');
    } catch (e) {
        console.warn('Could not load from localStorage', e);
        return {};
    }
};
const $6e7cfc6bf9421aef$export$7228aaade919a8b6 = (product, remoteActionsMetas)=>{
    try {
        localStorage.setItem(`${$6e7cfc6bf9421aef$export$b9e25d3c75cffd71}.${product}`, JSON.stringify(remoteActionsMetas));
    } catch (e) {
        console.warn('Could not load from localStorage', e);
    }
};

});


parcelRegister("4t7Nl", function(module, exports) {

$parcel$export(module.exports, "initStore", () => $1e87662f3b55ae48$export$41f27b3823a442c6);

var $fLzjp = parcelRequire("fLzjp");
const $1e87662f3b55ae48$export$41f27b3823a442c6 = ()=>({ setState: setState }, { product: product })=>{
        // TODO Async read from Localstorage.
        setState({
            meta: (0, $fLzjp.readRemoteActionsMetasFromLocalStorage)(product),
            isLoaded: true,
            product: product
        });
    };

});

parcelRegister("51DAc", function(module, exports) {

$parcel$export(module.exports, "processRemoteActions", () => $134be2d45ea963a7$export$15e69d1dd38ccaa3);

var $ibqTf = parcelRequire("ibqTf");
const $134be2d45ea963a7$export$15e69d1dd38ccaa3 = (productData, remoteActionsResponse)=>({ getState: getState, setState: setState })=>{
        const { lastUpdatedAt: lastUpdatedAt, meta: meta } = getState();
        if (remoteActionsResponse.lastUpdatedAt <= lastUpdatedAt) // data has not been updated, nothing to do
        return;
        const remoteActions = remoteActionsResponse.remoteActions.reduce((updatedRemoteActions, remoteAction)=>{
            if ((0, $ibqTf.shouldProcessRemoteAction)(remoteAction)) {
                const shouldAddAction = remoteAction.conditions.every((condition)=>(0, $ibqTf.isActionConditionSatisfied)(productData, condition));
                if (shouldAddAction) updatedRemoteActions[remoteAction.id] = remoteAction;
            }
            // no updates
            return updatedRemoteActions;
        }, {});
        setState({
            meta: Object.keys(remoteActions).reduce((newMeta, id)=>{
                newMeta[id] = meta[id];
                return newMeta;
            }, {}),
            remoteActions: remoteActions,
            lastUpdatedAt: Date.now()
        });
    };

});
parcelRegister("ibqTf", function(module, exports) {

$parcel$export(module.exports, "isActionConditionSatisfied", () => $cca0479d0b04fa6d$export$9262d8191a70c677);
$parcel$export(module.exports, "shouldProcessRemoteAction", () => $cca0479d0b04fa6d$export$c7cc93192d09a3d7);

var $XHGTv = parcelRequire("XHGTv");

var $fLduT = parcelRequire("fLduT");
const $cca0479d0b04fa6d$var$isFeatureFlagConditionSatisfied = (getFeatureFlagValue, condition)=>condition.affectedFeatureFlagValue === getFeatureFlagValue(condition.featureFlagKey);
const $cca0479d0b04fa6d$var$isFeatureGateConditionSatisfied = (getFeatureGateValue, condition)=>getFeatureGateValue && condition.affectedFeatureGateValue === getFeatureGateValue(condition.featureGateKey);
const $cca0479d0b04fa6d$var$isBuildInAffectedRange = (getBuildKey, getBuildNumberFromKey, condition)=>{
    try {
        const currentBuildNumber = getBuildNumberFromKey(getBuildKey());
        const firstAffectedBuildNumber = getBuildNumberFromKey(condition.buildRange[0]);
        const lastAffectedBuildNumber = getBuildNumberFromKey(condition.buildRange[1]);
        if (firstAffectedBuildNumber <= currentBuildNumber && currentBuildNumber <= lastAffectedBuildNumber) return true;
    } catch (error) {
        console.warn('error while parsing a build key', error);
    }
    return false;
};
const $cca0479d0b04fa6d$var$isBuildInAffectedRangeV2 = (getBuildKey, getBuildInfoFromKey, condition)=>{
    try {
        const { buildNumber: currentBuildNumber, buildType: currentBuildType } = getBuildInfoFromKey(getBuildKey());
        const { buildNumber: firstAffectedBuildNumber, buildType: firstAffectedBuildType } = getBuildInfoFromKey(condition.buildRange[0]);
        const { buildNumber: lastAffectedBuildNumber, buildType: lastAffectedBuildType } = getBuildInfoFromKey(condition.buildRange[1]);
        if (firstAffectedBuildType !== currentBuildType || lastAffectedBuildType !== currentBuildType) return false;
        if (firstAffectedBuildNumber <= currentBuildNumber && currentBuildNumber <= lastAffectedBuildNumber) return true;
    } catch (error) {
        console.warn('error while parsing a build key', error);
    }
    return false;
};
const $cca0479d0b04fa6d$export$9262d8191a70c677 = (productData, condition)=>{
    switch(condition.type){
        case (0, $fLduT.ConditionType).buildRange:
            return (0, $XHGTv.getBooleanFF)('platform.remote-actions-improved-features_7ft0n_rlw3z') && productData.getBuildInfoFromKey ? $cca0479d0b04fa6d$var$isBuildInAffectedRangeV2(productData.getBuildKey, productData.getBuildInfoFromKey, condition) : $cca0479d0b04fa6d$var$isBuildInAffectedRange(productData.getBuildKey, productData.getBuildNumberFromKey, condition);
        case (0, $fLduT.ConditionType).featureFlag:
            return $cca0479d0b04fa6d$var$isFeatureFlagConditionSatisfied(productData.getFeatureFlagValue, condition);
        case (0, $fLduT.ConditionType).featureGate:
            return (0, $XHGTv.getBooleanFF)('platform.remote-actions-improved-features_7ft0n_rlw3z') && $cca0479d0b04fa6d$var$isFeatureGateConditionSatisfied(productData.getFeatureGateValue, condition);
        default:
            return false;
    }
};
const $cca0479d0b04fa6d$export$c7cc93192d09a3d7 = (remoteAction)=>remoteAction.enabled;

});
parcelRegister("fLduT", function(module, exports) {

$parcel$export(module.exports, "ConditionType", () => $fe90e03a6e8a0345$export$748d1c753cdf4bfd);
var $fe90e03a6e8a0345$export$748d1c753cdf4bfd;
(function(ConditionType) {
    ConditionType["featureFlag"] = "featureFlag";
    ConditionType["featureGate"] = "featureGate";
    ConditionType["buildRange"] = "buildRange";
})($fe90e03a6e8a0345$export$748d1c753cdf4bfd || ($fe90e03a6e8a0345$export$748d1c753cdf4bfd = {}));

});



parcelRegister("1xne4", function(module, exports) {

$parcel$export(module.exports, "saveActionPerformedAttempt", () => $4d7f44cfab8f48a4$export$e3144a2e886e0e77);

var $fLzjp = parcelRequire("fLzjp");
const $4d7f44cfab8f48a4$export$e3144a2e886e0e77 = (actionId)=>({ getState: getState, setState: setState })=>{
        const { meta: meta, product: product } = getState();
        const currentAttemptCount = meta[actionId]?.attemptCounts || 0;
        const updatedMetas = {
            ...meta,
            [actionId]: {
                lastPerformAttemptedAt: Date.now(),
                attemptCounts: currentAttemptCount + 1
            }
        };
        setState({
            meta: updatedMetas
        });
        // Can not happen.
        if (!product) throw new Error('Product is not defined.');
        (0, $fLzjp.writeRemoteActionsMetasToLocalStorage)(product, updatedMetas);
    };

});



parcelRegister("3dxBh", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b1c4436e864f401$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ICvxP = parcelRequire("ICvxP");
var $6iz4v = parcelRequire("6iz4v");

var $3viaK = parcelRequire("3viaK");

var $6xYPC = parcelRequire("6xYPC");

var $87isp = parcelRequire("87isp");


var $0S0fK = parcelRequire("0S0fK");

var $1cNJ6 = parcelRequire("1cNJ6");
class $8b1c4436e864f401$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        const { children: children, pageId: pageId } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0S0fK.default).Provider, {
            // @ts-expect-error - TS2322 - Type '{ pageId: string; onReady: (metricKeyForInitialRender: string, metricKeyForTransition: string, extra: { [key: string]: string | number | boolean; } | undefined, metric: BM3Metric) => void; onCustomMark: (markName: string) => void; }' is not assignable to type 'string'.
            value: {
                pageId: pageId,
                onReady: this.onReady,
                onCustomMark: this.onCustomMark
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
            op: this.onStart,
            args: [
                pageId
            ]
        }), children));
    }
    constructor(...args){
        super(...args);
        this.customMarks = [];
        this.onStart = ()=>{
            (0, $ICvxP.default)((0, $37f655a4e4d5690e$export$56940a9488e85199));
            (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$45c4b6bf7935c69a));
        };
        this.onCustomMark = (markName)=>{
            (0, $6iz4v.setMark)((0, $1cNJ6.getPrefixedMarkName)(markName));
            // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
            this.customMarks.push(markName);
        };
        this.onReady = (metricKeyForInitialRender, metricKeyForTransition, extra = {}, metric)=>{
            metric.stop({
                customData: extra
            });
            if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.stopLowPriorityEventDelay)();
        };
    }
}

});
const $37f655a4e4d5690e$export$56940a9488e85199 = 'jira.fe.spa-';
const $37f655a4e4d5690e$export$45c4b6bf7935c69a = `${$37f655a4e4d5690e$export$56940a9488e85199}start`;
const $37f655a4e4d5690e$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $37f655a4e4d5690e$export$ff834eccc35b9089 = 'appBundleReady';
const $37f655a4e4d5690e$export$86b05e34d462ead8 = 'prefetchApiReady';
const $37f655a4e4d5690e$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $37f655a4e4d5690e$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $37f655a4e4d5690e$export$3ae43cc1782d058f = 'jswRenderStart';
const $37f655a4e4d5690e$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $37f655a4e4d5690e$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $37f655a4e4d5690e$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $37f655a4e4d5690e$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $37f655a4e4d5690e$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $37f655a4e4d5690e$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $37f655a4e4d5690e$export$99c08ec92759c71c = 'tti-raf-mark';
const $37f655a4e4d5690e$export$48552baa9db8ce1d = 'tti-raf';

parcelRegister("0S0fK", function(module, exports) {

$parcel$export(module.exports, "default", () => $f943d45ee0ecaf49$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $f943d45ee0ecaf49$var$contextName = 'SpaApdexAnalytics';
var $f943d45ee0ecaf49$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.createContext)($f943d45ee0ecaf49$var$contextName);

});

parcelRegister("1cNJ6", function(module, exports) {

$parcel$export(module.exports, "getPrefixedMarkName", () => $c844db40c28c8d19$export$c8f0e9837e7e9425);

const $c844db40c28c8d19$export$c8f0e9837e7e9425 = (name)=>`${0, $37f655a4e4d5690e$export$56940a9488e85199}${name}`;

});


parcelRegister("iJHZm", function(module, exports) {

$parcel$export(module.exports, "SpaStateContainer", () => $a6f32366b1daf5c0$export$e9a92b877fe80e80);
$parcel$export(module.exports, "SpaStateAppStart", () => $a6f32366b1daf5c0$export$d18dd27183a635c);
$parcel$export(module.exports, "SpaStateAppStartWithMatchCheck", () => $a6f32366b1daf5c0$export$95a2912d76fb5433);
$parcel$export(module.exports, "SpaStatePageReady", () => $a6f32366b1daf5c0$export$c34439f945fccbdf);
$parcel$export(module.exports, "SpaStatePageReadyOnUpdate", () => $a6f32366b1daf5c0$export$41e70078eeddaddc);
$parcel$export(module.exports, "SpaStatePageErrorReady", () => $a6f32366b1daf5c0$export$2583aa269898885c);
$parcel$export(module.exports, "getSpaStateLastUserLocation", () => $a6f32366b1daf5c0$export$6e9ab893e97cccef);

var $eUqFw = parcelRequire("eUqFw");

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $gasA1 = parcelRequire("gasA1");

var $3viaK = parcelRequire("3viaK");

var $kJlBc = parcelRequire("kJlBc");

var $lcJyp = parcelRequire("lcJyp");

var $cfLkw = parcelRequire("cfLkw");
const $a6f32366b1daf5c0$export$e9a92b877fe80e80 = (0, $heB5U.createContainer)((0, $cfLkw.default));
const $a6f32366b1daf5c0$export$d18dd27183a635c = ()=>{
    const startRef = (0, $eUqFw.useRef)(Date.now());
    const [{ visitedPages: visitedPages }, { setAppStart: setAppStart }] = (0, $lcJyp.useSpaState)();
    (0, $eUqFw.useMemo)(()=>{
        startRef.current = Date.now();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        visitedPages
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        setAppStart(startRef.current);
    }, [
        setAppStart,
        visitedPages
    ]);
    return null;
};
const $a6f32366b1daf5c0$var$useRouterMatchSelector = (0, $kJlBc.createRouterSelector)((state)=>state.match);
const $a6f32366b1daf5c0$var$useSpaStatePagesCount = (0, $ggKAj.createHook)((0, $cfLkw.default), {
    selector: ({ visitedPages: visitedPages })=>visitedPages.length
});
const $a6f32366b1daf5c0$export$95a2912d76fb5433 = ()=>{
    const match = $a6f32366b1daf5c0$var$useRouterMatchSelector();
    const [count, { setAppStart: setAppStart }] = $a6f32366b1daf5c0$var$useSpaStatePagesCount();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a6f32366b1daf5c0$export$ada7e0ec445851a2, {
        visitedPagesLength: count,
        onSetAppStart: setAppStart,
        match: match
    });
};
const $a6f32366b1daf5c0$export$c34439f945fccbdf = ()=>/* TODO - this should be using only the actions subscriber not state+actions subscriber */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lcJyp.SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
            op: setAppReady
        }));
const $a6f32366b1daf5c0$export$41e70078eeddaddc = ({ comparer: comparer } /* TODO - this should be using only the actions subscriber not state+actions subscriber */ )=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lcJyp.SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
            op: setAppReady,
            args: comparer
        }));
const $a6f32366b1daf5c0$export$2583aa269898885c = ()=>/* TODO - this should be using only the actions subscriber not state+actions subscriber */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lcJyp.SpaStateSubscriber), null, (_, { setAppErrorReady: setAppErrorReady })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
            op: setAppErrorReady
        }));
class $a6f32366b1daf5c0$export$ada7e0ec445851a2 extends (0, $eUqFw.Component) {
    static getDerivedStateFromProps(props, state) {
        const visitedPageLengthHasChanged = props.visitedPagesLength !== state.visitedPagesLength;
        const matchHasChanged = props.match !== state.match;
        const setAppStart = !state.started || visitedPageLengthHasChanged && matchHasChanged;
        if (setAppStart) props.onSetAppStart(Date.now());
        // On transition visitedPageLength will always change before match, the only exception is when there is page
        // ids (e.g. issue types). When redirecting, the length doesn't change while the match changes (from issuetype to issuetype/xxxxx).
        // so if match changed without visitedPageLength changing, cache the new match and wait for both to update.
        if (setAppStart || !visitedPageLengthHasChanged) return {
            started: true,
            visitedPagesLength: props.visitedPagesLength,
            match: props.match
        };
        // if visitedPageLength changed, ignore and wait for update in match (which will trigger setAppStart next)
        return state;
    }
    render() {
        return null;
    }
    constructor(...args){
        super(...args);
        /** so the challenge we are facing is that, we need to reset page when there's a visitedPagesLength change and a route change,
	 * but they don't always happen at the the same time during the current spa router situation. The following code does this:
	 *
	 * if first render: set app start
	 *
	 * if subsequently render with only visitedPagesLength change, ignore this updates, cache the old visitedPagesLength,
	 * wait for incoming match change
	 *
	 * if subsequently render with only match change, ignore this updates, cache the old match, wait for incoming
	 * visitedPagesLength change
	 *
	 *  if incoming changes contain both route and length change, we update state and start app
	 *
	 */ this.state = {
            visitedPagesLength: 0,
            started: false,
            match: null
        };
    }
}
const $a6f32366b1daf5c0$export$6e9ab893e97cccef = ()=>{
    const { visitedPages: visitedPages } = (0, $gasA1.defaultRegistry).getStore((0, $cfLkw.default)).storeState.getState();
    return visitedPages.length ? visitedPages[visitedPages.length - 1].userLocation : '';
};

});

parcelRegister("geFaw", function(module, exports) {

$parcel$export(module.exports, "StrictMode", () => $5551fe9c9ab4b7c0$export$5f8d39834fd61797);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");
const $5551fe9c9ab4b7c0$export$5f8d39834fd61797 = ({ children: children })=>{
    // otherwise if the feature flag is enabled/or force opt-in, use React.StrictMode
    return (0, $1ybV0.ff)('jfp.magma.enable-strict-mode') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).StrictMode, null, children) : children;
};

});

parcelRegister("e9XeX", function(module, exports) {

$parcel$export(module.exports, "JiraRouter", () => $8c383d1533c295db$export$db9defc4f1e702e4);

var $eUqFw = parcelRequire("eUqFw");

var $kJlBc = parcelRequire("kJlBc");

var $3HCkE = parcelRequire("3HCkE");

var $eoTRo = parcelRequire("eoTRo");

var $amu7D = parcelRequire("amu7D");

var $gd0Sp = parcelRequire("gd0Sp");
const $8c383d1533c295db$var$usePlugins = ({ resourceContext: resourceContext, resourceData: resourceData })=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    // make sure "plugins" are created only once, ignore prop change/rerender
    const [pluginsWithOverride] = (0, $eUqFw.useState)(()=>{
        const jiraPlugins = [];
        const resourcesPlugin = (0, $3HCkE.createResourcesPlugin)({
            context: resourceContext,
            resourceData: resourceData
        });
        jiraPlugins.push(resourcesPlugin);
        jiraPlugins.push((0, $eoTRo.createEntryPointsPlugin)({
            environment: (0, $amu7D.default),
            entryPointParams: {
                tenantContext: tenantContext
            }
        }));
        return jiraPlugins;
    });
    return pluginsWithOverride;
};
const $8c383d1533c295db$export$db9defc4f1e702e4 = ({ children: children, ...props })=>{
    const pluginsWithOverride = $8c383d1533c295db$var$usePlugins({
        resourceContext: props.resourceContext,
        resourceData: props.resourceData
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Router), {
        plugins: pluginsWithOverride,
        ...props
    }, children);
};
const $8c383d1533c295db$export$df53844eb6c820cb = ({ children: children, resourceData: resourceData, resourceContext: resourceContext, ...props })=>{
    const pluginsWithOverride = $8c383d1533c295db$var$usePlugins({
        resourceContext: resourceContext,
        resourceData: resourceData
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.MemoryRouter), {
        plugins: pluginsWithOverride,
        ...props
    }, children);
};

});
parcelRegister("eoTRo", function(module, exports) {

$parcel$export(module.exports, "createEntryPointsPlugin", () => $8908df19809cff0a$export$33586718f82f356f);

var $iWLL0 = parcelRequire("iWLL0");

var $4Wbcp = parcelRequire("4Wbcp");

var $gglAH = parcelRequire("gglAH");

var $kP52E = parcelRequire("kP52E");
const $8908df19809cff0a$export$33586718f82f356f = ({ environment: environment, entryPointParams: entryPointParams })=>({
        id: 'entry-points-plugin',
        routeLoad: ({ context: context })=>{
            const entryPoint = context.route.entryPoint?.();
            const prefetchingRoute = (0, $gglAH.getPrefetchingRoute)();
            let entryPointReference = null;
            if (entryPoint) {
                // check if route EntryPoint is already prefethed right before being loaded
                if (prefetchingRoute && (0, $4Wbcp.isSameRouteMatch)({
                    prevContextMatch: prefetchingRoute.routerContext.match,
                    nextContextMatch: context.match
                }) && !(0, $4Wbcp.isExpired)(prefetchingRoute.expiresAt)) entryPointReference = prefetchingRoute.entryPointReference;
                else entryPointReference = (0, $iWLL0.loadEntryPoint)({
                    getEnvironment: ()=>environment
                }, entryPoint, {
                    context: context,
                    ...entryPointParams
                });
            }
            // saving entryPointReference helps to prevent cases when same EntryPoint is fetched multiple times
            // important when fetchPolicy=network-only is used
            (0, $gglAH.getEntryPointsStore)().actions.setLastLoadedRoute({
                route: context.route,
                entryPointReference: entryPointReference
            });
            return {
                entryPoint: entryPointReference
            };
        },
        routePrefetch: ({ nextContext: nextContext })=>{
            const entryPoint = nextContext.route.entryPoint?.();
            if (entryPoint) {
                const prevPrefetchingRoute = (0, $gglAH.getPrefetchingRoute)();
                // check if EntryPoint is already prefetched and not expired
                if (prevPrefetchingRoute && (0, $4Wbcp.isSameRouteMatch)({
                    prevContextMatch: prevPrefetchingRoute.routerContext.match,
                    nextContextMatch: nextContext.match
                }) && !(0, $4Wbcp.isExpired)(prevPrefetchingRoute.expiresAt)) return;
                const entryPointReference = (0, $iWLL0.loadEntryPoint)({
                    getEnvironment: ()=>environment
                }, entryPoint, {
                    context: nextContext,
                    ...entryPointParams
                });
                (0, $gglAH.getEntryPointsStore)().actions.setPrefetchingRoute({
                    routerContext: nextContext,
                    expiresAt: (0, $4Wbcp.getExpiresAt)(),
                    entryPointReference: entryPointReference
                });
            } else (0, $gglAH.getEntryPointsStore)().actions.setPrefetchingRoute({
                routerContext: nextContext,
                expiresAt: 0,
                entryPointReference: null
            });
        },
        waitForEntryPoint: ()=>{
            const lastLoadedRoute = (0, $gglAH.getLastLoadedRoute)();
            const entryPointReference = lastLoadedRoute?.entryPointReference ?? null;
            if (entryPointReference) return (0, $kP52E.waitForEntryPoint)(entryPointReference);
            return Promise.resolve();
        }
    });

});
parcelRegister("4Wbcp", function(module, exports) {

$parcel$export(module.exports, "getExpiresAt", () => $7b677faf33f0c24f$export$b65d7ba7fbf150f1);
$parcel$export(module.exports, "isExpired", () => $7b677faf33f0c24f$export$57947cfd429801a2);
$parcel$export(module.exports, "isSameRouteMatch", () => $7b677faf33f0c24f$export$5997e70fc4543270);
const $7b677faf33f0c24f$export$37d3126be6549b13 = 10000;
const $7b677faf33f0c24f$export$b65d7ba7fbf150f1 = ()=>$7b677faf33f0c24f$export$37d3126be6549b13 + Date.now();
const $7b677faf33f0c24f$export$57947cfd429801a2 = (expiresAt)=>expiresAt < Date.now();
const $7b677faf33f0c24f$var$isShallowEqual = (o1, o2)=>{
    const objKeys1 = Object.keys(o1);
    const objKeys2 = Object.keys(o2);
    if (objKeys1.length !== objKeys2.length) return false;
    return objKeys1.every((key)=>o1[key] === o2[key]);
};
const $7b677faf33f0c24f$export$5997e70fc4543270 = ({ prevContextMatch: prevContextMatch, nextContextMatch: nextContextMatch })=>prevContextMatch.path === nextContextMatch.path && $7b677faf33f0c24f$var$isShallowEqual(prevContextMatch.query, nextContextMatch.query) && $7b677faf33f0c24f$var$isShallowEqual(prevContextMatch.params, nextContextMatch.params);

});

parcelRegister("kP52E", function(module, exports) {

$parcel$export(module.exports, "waitForEntryPoint", () => $865808bba2ff8fa0$export$944f853f194e5dd5);

var $c7ifG = parcelRequire("c7ifG");
const $865808bba2ff8fa0$export$944f853f194e5dd5 = (entryPointConfig)=>{
    const promises = [];
    try {
        entryPointConfig.getComponent();
    } catch (err) {
        if (err instanceof Promise) promises.push(err);
        else throw err;
    }
    const { queries: queries, entryPoints: entryPoints } = entryPointConfig;
    if (queries) Object.keys(queries).forEach((key)=>{
        if (queries[key].id) {
            const queryPromise = (0, $c7ifG.QueryPromisesMap).get(String(queries[key].id));
            if (queryPromise) promises.push(queryPromise);
        }
    });
    if (entryPoints) Object.keys(entryPoints).forEach((key)=>{
        const nestedEntryPointPromise = $865808bba2ff8fa0$export$944f853f194e5dd5(entryPoints[key]);
        promises.push(nestedEntryPointPromise);
    });
    return Promise.allSettled(promises);
};

});



parcelRegister("MIkHq", function(module, exports) {

$parcel$export(module.exports, "JiraRouterLinkConfiguration", () => $db5b0181da01ab54$export$a580704a2f3cfca);

var $eUqFw = parcelRequire("eUqFw");

var $kJlBc = parcelRequire("kJlBc");
const $db5b0181da01ab54$export$a580704a2f3cfca = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ href: href, children: children, ...rest }, ref)=>{
    if (// Links can be initially rendered with `href` not defined in some cases
    !href || typeof href === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Link), {
        ref: ref,
        href: href || '#',
        ...rest
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Link), {
        ref: ref,
        href: href.href,
        to: href.to,
        replace: href.replace,
        params: href.params,
        query: href.query,
        prefetch: href.prefetch,
        ...rest
    }, children);
});

});

parcelRegister("efFTI", function(module, exports) {

$parcel$export(module.exports, "globalSettingsLayout", () => $f4bfbc079ef4e42a$export$e6aef6083548e882);

var $dVvIP = parcelRequire("dVvIP");

var $isbb2 = parcelRequire("isbb2");
const $f4bfbc079ef4e42a$export$e6aef6083548e882 = (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout));

});
parcelRegister("dVvIP", function(module, exports) {

$parcel$export(module.exports, "globalLayout", () => $d3e020a4d042f679$export$929cb72e7acb7fd9);

var $isbb2 = parcelRequire("isbb2");
const $d3e020a4d042f679$var$rightSidebars = ()=>[];
const $d3e020a4d042f679$export$929cb72e7acb7fd9 = (0, $isbb2.createLayout)({
    rightSidebars: $d3e020a4d042f679$var$rightSidebars()
});

});


parcelRegister("7vTKl", function(module, exports) {

$parcel$export(module.exports, "ADDON_ID", () => $d4390c4ef90a66f3$export$6c4866a933650d1d);
$parcel$export(module.exports, "MENU_ID", () => $d4390c4ef90a66f3$export$d4cd258d01c03112);
const $d4390c4ef90a66f3$export$6c4866a933650d1d = {
    DISCOVER: 'com.atlassian.jira.emcee__enduser-discover'
};
const $d4390c4ef90a66f3$export$d4cd258d01c03112 = {
    ADDONS: 'ADDONS',
    APP_SWITCHER: 'APP_SWITCHER',
    DASHBOARDS: 'DASHBOARDS',
    FILTERS: 'FILTERS',
    HELP: 'HELP',
    HOME: 'HOME',
    INSIGHT: 'INSIGHT',
    NOTIFICATIONS: 'NOTIFICATIONS',
    PEOPLE: 'PEOPLE',
    PLANS: 'PLANS',
    PROFILE: 'PROFILE',
    PROJECTS: 'PROJECTS',
    SEARCH: 'SEARCH',
    SERVICE_HUB: 'SERVICE_HUB',
    SETTINGS: 'SETTINGS'
};

});

parcelRegister("apqRF", function(module, exports) {

$parcel$export(module.exports, "createEntry", () => $cb7e2e6e0ee2e430$export$344b9c9ab5e66c9a);
const $cb7e2e6e0ee2e430$export$344b9c9ab5e66c9a = (baseRoute, opts)=>Object.assign(baseRoute, opts);

});

parcelRegister("hHrVM", function(module, exports) {

$parcel$export(module.exports, "getModernIssueTransitionResources", () => $c6a3d716ac1fee91$export$e1afa08027b1e44b);
$parcel$export(module.exports, "getNavigationResources", () => $c6a3d716ac1fee91$export$75cffd1aaecf4a2c);
$parcel$export(module.exports, "getUserBoardNavigationResources", () => $c6a3d716ac1fee91$export$c57dc1ea7f76f91f);
$parcel$export(module.exports, "getNavigationSidebarProjectResource", () => $c6a3d716ac1fee91$export$c4cf7264f95bae78);
$parcel$export(module.exports, "getNavigationSidebarPlanResources", () => $c6a3d716ac1fee91$export$af2259a87f79645d);
$parcel$export(module.exports, "getNavigationSidebarProductsSettingResource", () => $c6a3d716ac1fee91$export$a103e99ad51f7bc3);
$parcel$export(module.exports, "getNavigationSidebarProjectSettingsResource", () => $c6a3d716ac1fee91$export$808691f5a412afa3);
// eslint-disable-next-line jira/import-whitelist

var $a5Lgz = parcelRequire("a5Lgz");

var $1ybV0 = parcelRequire("1ybV0");

var $l90Gp = parcelRequire("l90Gp");
var $7zhpa = parcelRequire("7zhpa");
var $4MmfV = parcelRequire("4MmfV");
var $I0t4m = parcelRequire("I0t4m");
var $iivTa = parcelRequire("iivTa");
var $cbmC6 = parcelRequire("cbmC6");
var $kXWpU = parcelRequire("kXWpU");
var $eJCK9 = parcelRequire("eJCK9");
var $6OTFM = parcelRequire("6OTFM");

var $hawmT = parcelRequire("hawmT");

var $8mP0X = parcelRequire("8mP0X");

var $8yXY1 = parcelRequire("8yXY1");

var $cpkr0 = parcelRequire("cpkr0");

var $hlO97 = parcelRequire("hlO97");

var $dAKwA = parcelRequire("dAKwA");

var $jlBE2 = parcelRequire("jlBE2");

var $ellXt = parcelRequire("ellXt");

var $8Osbm = parcelRequire("8Osbm");

var $h0Ytu = parcelRequire("h0Ytu");

var $6XOSh = parcelRequire("6XOSh");

var $jD3pk = parcelRequire("jD3pk");

var $l6RYU = parcelRequire("l6RYU");

var $9CFDS = parcelRequire("9CFDS");

var $1NIhY = parcelRequire("1NIhY");

var $gF5SK = parcelRequire("gF5SK");

var $fKYF0 = parcelRequire("fKYF0");

var $ixwgj = parcelRequire("ixwgj");

var $grsJA = parcelRequire("grsJA");

var $3vlQh = parcelRequire("3vlQh");

var $3MEW8 = parcelRequire("3MEW8");

var $4uxD3 = parcelRequire("4uxD3");

var $jwzNs = parcelRequire("jwzNs");
const $c6a3d716ac1fee91$var$getNewIssueTransitionExperienceInJiraLabsVariation = ()=>(0, $1ybV0.getMultivariateFeatureFlag)('jira-issue-transition-screen-modernisation-toggle', 'OFF', [
        'OFF',
        'BY_DEFAULT_USER_OPT_IN',
        'BY_DEFAULT_USER_OPT_OUT'
    ]);
const $c6a3d716ac1fee91$var$isModernIssueTransitionSettingEnabled = ()=>{
    const variation = $c6a3d716ac1fee91$var$getNewIssueTransitionExperienceInJiraLabsVariation();
    return variation !== 'OFF';
};
const $c6a3d716ac1fee91$var$OFF = 'Off';
const $c6a3d716ac1fee91$var$EAP = 'EAP';
const $c6a3d716ac1fee91$var$GA = 'GA';
const $c6a3d716ac1fee91$var$getPlanSidebarNavigationJiraLabsVariation = ()=>(0, $1ybV0.getMultivariateFeatureFlag)('com.atlassian.rm.jpo.sidebar-navigation-jira-labs-variations', $c6a3d716ac1fee91$var$OFF, [
        $c6a3d716ac1fee91$var$OFF,
        $c6a3d716ac1fee91$var$EAP,
        $c6a3d716ac1fee91$var$GA
    ]);
const $c6a3d716ac1fee91$var$isPlanSidebarNavigationEnabled = ()=>{
    const variation = $c6a3d716ac1fee91$var$getPlanSidebarNavigationJiraLabsVariation();
    return variation === $c6a3d716ac1fee91$var$EAP || variation === $c6a3d716ac1fee91$var$GA;
};
const $c6a3d716ac1fee91$var$conditionalGicOptInStatusResource = (0, $jwzNs.resourceWithCondition)(()=>(0, $1ybV0.ff)('project.config.pce.modern.global-issue-create'), (0, $ellXt.gicOptInStatusResources));
const $c6a3d716ac1fee91$var$conditionalPlanNavigationSidebarOptInStatusResource = (0, $jwzNs.resourceWithCondition)($c6a3d716ac1fee91$var$isPlanSidebarNavigationEnabled, (0, $8mP0X.planSidebarNavigationOptInStatusResources));
const $c6a3d716ac1fee91$var$conditionalIssueTransitionOptInStatusResource = (0, $jwzNs.resourceWithCondition)($c6a3d716ac1fee91$var$isModernIssueTransitionSettingEnabled, (0, $6XOSh.issueTransitionOptInStatusResource));
const $c6a3d716ac1fee91$var$conditionalAnnouncementBannerSettingsResource = (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('gravity.announcement-banner.enable-adf_33eic'), (0, $a5Lgz.announcementBannerSettingsV4Resource), (0, $a5Lgz.announcementBannerSettingsResource));
const $c6a3d716ac1fee91$var$conditionalGicSmartFieldsOptoutResource = (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('gic-smart-fields-jira-labs_8uwvr'), (0, $jlBE2.gicSmartFieldsFeatureResource));
const $c6a3d716ac1fee91$var$conditionalConsentBannerUserPreferencesResource = (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('platform.moonjelly.browser-storage-controls-v2'), (0, $8yXY1.consentBannerUserPreferencesResource));
const $c6a3d716ac1fee91$var$conditionalIncomingMailServerExpiryStatusResource = (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('jira-banner-for-incoming-mail-expiry-notification_y2w1w'), (0, $8Osbm.incomingMailServerExpiryStatusResource));
const $c6a3d716ac1fee91$export$e1afa08027b1e44b = ()=>[
        $c6a3d716ac1fee91$var$conditionalIssueTransitionOptInStatusResource,
        (0, $h0Ytu.issueTransitionChangeboardingPreferencesResource)
    ];
// There is a best effort duplicate removal in the `getRoutes` function but it
// only works if the resources have the same instance. b/c resourceWithCondition2
// will create a new reference each time it is run, by keeping this outside the
// route factory, we can ensure that the duplicate removal works when it is used
// in multiple places.
const $c6a3d716ac1fee91$var$dedupableConditionalResources = [
    (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('opsgenie-consolidation-transitioning-state_d7vm9'), (0, $hlO97.consolidationUserStateResource)),
    (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('platform.atlassian.griffin-navigation-redesign'), (0, $7zhpa.sidebarNav4Resource))
];
const $c6a3d716ac1fee91$export$75cffd1aaecf4a2c = ()=>[
        (0, $1NIhY.navigationUiStateResource),
        (0, $hawmT.navigationPlansVisibilityResource),
        (0, $4uxD3.userHomepageResource),
        $c6a3d716ac1fee91$var$conditionalGicOptInStatusResource,
        $c6a3d716ac1fee91$var$conditionalAnnouncementBannerSettingsResource,
        $c6a3d716ac1fee91$var$conditionalConsentBannerUserPreferencesResource,
        ...$c6a3d716ac1fee91$var$dedupableConditionalResources,
        (0, $jD3pk.organizationIdResource),
        (0, $3MEW8.themePreferenceResource),
        ...$c6a3d716ac1fee91$export$e1afa08027b1e44b(),
        $c6a3d716ac1fee91$var$conditionalPlanNavigationSidebarOptInStatusResource,
        (0, $fKYF0.persistentIssueCreateModalViewResource),
        $c6a3d716ac1fee91$var$conditionalGicSmartFieldsOptoutResource,
        $c6a3d716ac1fee91$var$conditionalIncomingMailServerExpiryStatusResource,
        (0, $grsJA.rovoEntitlementResource)
    ];
const $c6a3d716ac1fee91$export$c57dc1ea7f76f91f = ()=>[
        (0, $4MmfV.staticJSWUserBoardSidebarNavigationResource)
    ];
const $c6a3d716ac1fee91$export$c4cf7264f95bae78 = ()=>[
        (0, $3vlQh.incidentExperimentTraitResource),
        (0, $ixwgj.projectContextResource),
        (0, $l90Gp.forgeProjectModuleResource),
        (0, $eJCK9.staticSidebarShortcutsResource),
        (0, $kXWpU.staticProjectSidebarNavigationResource),
        (0, $cbmC6.staticProjectSidebarConnectAddonsNavigationResource),
        (0, $6OTFM.staticSoftwareProjectHorizontalNavResource)
    ];
const $c6a3d716ac1fee91$export$af2259a87f79645d = ()=>[
        (0, $jwzNs.resourceWithCondition2)($c6a3d716ac1fee91$var$isPlanSidebarNavigationEnabled, (0, $I0t4m.staticPlanSidebarNavigationResource))
    ];
const $c6a3d716ac1fee91$export$a103e99ad51f7bc3 = ()=>[
        (0, $9CFDS.navigationSidebarGlobalResource),
        (0, $dAKwA.getConsolidationStateResource)(),
        (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('eoc-api-key-management-feature-jira_8ox4z'), (0, $cpkr0.checkApiKeyManagementKeysResource)())
    ];
const $c6a3d716ac1fee91$export$808691f5a412afa3 = ()=>[
        (0, $gF5SK.newIssueViewTransitionLockInStatusResource),
        (0, $l6RYU.navigationSidebarAutomationLegacyEnabledResource),
        (0, $ixwgj.projectContextResourceWithCache),
        (0, $l90Gp.forgeProjectSettingsModuleResource),
        (0, $iivTa.staticProjectSettingsSidebarConnectAddonsNavigationResource)
    ];

});
parcelRegister("7zhpa", function(module, exports) {

$parcel$export(module.exports, "sidebarNav4Resource", () => $57db5858a67a5074$export$7648dc6f76f4f83d);

var $5SKG5 = parcelRequire("5SKG5");
var $20jcc = parcelRequire("20jcc");
var $dyb0v = parcelRequire("dyb0v");

var $buJlM = parcelRequire("buJlM");

var $hkmE9 = parcelRequire("hkmE9");
const $57db5858a67a5074$var$RESOURCE_TYPE_SIDEBAR_V2_RELAY = 'SIDEBAR_V2_RELAY';
const $57db5858a67a5074$export$7648dc6f76f4f83d = (0, $buJlM.createRelayResource)({
    type: `${(0, $buJlM.RELAY_RESOURCE_TYPE)}_${$57db5858a67a5074$var$RESOURCE_TYPE_SIDEBAR_V2_RELAY}`,
    getQuery: (routerContext, { tenantContext: { cloudId: cloudId } })=>({
            parameters: (0, $hkmE9.default),
            variables: {
                cloudId: cloudId,
                isProjectsExpanded: (0, $dyb0v.isProjectRoute)(routerContext),
                isPlansExpanded: (0, $20jcc.isPlanRoute)(routerContext),
                isAppsExpanded: (0, $5SKG5.isAppRoute)(routerContext)
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("5SKG5", function(module, exports) {

$parcel$export(module.exports, "useIsAppRoute", () => $fc40d4bf81ecddad$export$600a168800733dd9);
$parcel$export(module.exports, "isAppRoute", () => $fc40d4bf81ecddad$export$dbf3dc265bd510c3);

var $exb0h = parcelRequire("exb0h");

var $kJlBc = parcelRequire("kJlBc");
const $fc40d4bf81ecddad$var$GLOBAL_APP_ROUTES = [
    // Connect apps
    (0, $exb0h.ROUTE_NAMES).CONNECT_GENERAL,
    (0, $exb0h.ROUTE_NAMES).CONNECT_GENERAL_INVALID,
    (0, $exb0h.ROUTE_NAMES).LEGACY_CONNECT_GENERAL,
    // Forge apps
    (0, $exb0h.ROUTE_NAMES).FORGE_GLOBAL
];
function $fc40d4bf81ecddad$export$600a168800733dd9() {
    const [routerContext] = (0, $kJlBc.useRouter)();
    return $fc40d4bf81ecddad$export$dbf3dc265bd510c3(routerContext);
}
function $fc40d4bf81ecddad$export$dbf3dc265bd510c3(routerContext) {
    const { route: route } = routerContext;
    return $fc40d4bf81ecddad$var$GLOBAL_APP_ROUTES.some((name)=>name === route.name);
}

});

parcelRegister("20jcc", function(module, exports) {

$parcel$export(module.exports, "useIsPlanUrl", () => $3d824212db695c8f$export$c892a721bc19437f);
$parcel$export(module.exports, "isPlanRoute", () => $3d824212db695c8f$export$a7cfc620f2f80f6);

var $kJlBc = parcelRequire("kJlBc");
function $3d824212db695c8f$export$c892a721bc19437f() {
    const [{ location: location }] = (0, $kJlBc.useRouter)();
    const [planId] = (0, $kJlBc.usePathParam)('planId');
    return $3d824212db695c8f$var$isPlanUrl(location.pathname, planId);
}
function $3d824212db695c8f$export$a7cfc620f2f80f6(routerContext) {
    const { match: match } = routerContext;
    const planId = match.params.planId;
    return $3d824212db695c8f$var$isPlanUrl(match.path, planId);
}
function $3d824212db695c8f$var$isPlanUrl(path, planId) {
    if (planId) return true;
    // TODO: Support other miscellaneous plan urls, such as reports
    return Boolean(path === '/jira/plans');
}

});

parcelRegister("dyb0v", function(module, exports) {

$parcel$export(module.exports, "useIsProjectUrl", () => $e3b361506892b7ef$export$1f48bebb58d471a4);
$parcel$export(module.exports, "isProjectRoute", () => $e3b361506892b7ef$export$39a9146ec16e228);

var $kJlBc = parcelRequire("kJlBc");

var $8hg3R = parcelRequire("8hg3R");
function $e3b361506892b7ef$export$1f48bebb58d471a4() {
    const [{ location: location }] = (0, $kJlBc.useRouter)();
    const [projectKey] = (0, $kJlBc.usePathParam)('projectKey');
    return $e3b361506892b7ef$var$isProjectURL(location.pathname, projectKey);
}
function $e3b361506892b7ef$export$39a9146ec16e228(routerContext) {
    const { match: match } = routerContext;
    const projectKeyOrId = (0, $8hg3R.getProjectKeyOrId)(match);
    return $e3b361506892b7ef$var$isProjectURL(match.path, projectKeyOrId);
}
function $e3b361506892b7ef$var$isProjectURL(path, projectKeyOrId) {
    if (projectKeyOrId) return true;
    return Boolean(path === '/jira/projects');
}

});

parcelRegister("buJlM", function(module, exports) {

$parcel$export(module.exports, "RELAY_RESOURCE_TYPE", () => $485f6c69495cf127$export$c6c8c12c0f1d8e54);
$parcel$export(module.exports, "createRelayResource", () => $485f6c69495cf127$export$1cc887c62079ea32);
$parcel$export(module.exports, "useRelayResource", () => $485f6c69495cf127$export$42ca7b248c7aaee);

var $iWLL0 = parcelRequire("iWLL0");

var $cNy9K = parcelRequire("cNy9K");

var $6iz4v = parcelRequire("6iz4v");

var $amu7D = parcelRequire("amu7D");

var $15ZJO = parcelRequire("15ZJO");

var $c7ifG = parcelRequire("c7ifG");

var $3HCkE = parcelRequire("3HCkE");

var $5udmX = parcelRequire("5udmX");
const $485f6c69495cf127$export$c6c8c12c0f1d8e54 = 'RELAY_RESOURCE_TYPE';
const $485f6c69495cf127$var$createRelayResourceImpl = ({ type: type, isBrowserOnly: isBrowserOnly, getQuery: getQuery, loadParameters: loadParameters, captureErrors: captureErrors = false, captureTraceIds: captureTraceIds = false })=>(0, $3HCkE.createResource)({
        type: `${$485f6c69495cf127$export$c6c8c12c0f1d8e54}_${type}`,
        getKey: (routerContext, customContext)=>{
            const { parameters: preloadableRequest, variables: variables } = getQuery(routerContext, customContext);
            // When providing an async query via `loadParameters` instead of getQuery's config, the query ID is not known upfront and so cannot be contributed to the resource key
            if (!preloadableRequest) return JSON.stringify(variables || {});
            let queryId;
            let params;
            // sources: https://github.com/facebook/relay/blob/4b78c7dd27b286f9ee8f5b993ccb160163956999/packages/react-relay/relay-hooks/loadQuery.js#L273
            // @ts-expect-error - TS2339 - Property 'kind' does not exist on type 'GraphQLTaggedNode | PreloadableConcreteRequest<TQuery>'.
            if (preloadableRequest.kind === 'PreloadableConcreteRequest') {
                const preloadableConcreteRequest = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                preloadableRequest;
                ({ params: params } = preloadableConcreteRequest);
                ({ id: queryId } = params);
            } else {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                const graphQlTaggedNode = preloadableRequest;
                const request = (0, $cNy9K.getRequest)(graphQlTaggedNode);
                params = request.params;
                queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
            }
            return `${String(queryId)}${JSON.stringify(variables || {})}`;
        },
        getData: async (routerContext, customContext)=>{
            const measureName = `relay_resource_get_data:${type}`;
            const startMark = `relay_resource_get_data:${type}:start`;
            const endMark = `relay_resource_get_data:${type}:end`;
            (0, $6iz4v.setMark)(startMark);
            const { parameters: parameters, variables: variables, options: options } = getQuery(routerContext, customContext);
            // We either have a sync query or an async one from loadParameters. Never neither
            // This is enforced by 2 aliases of this method having different types, but Typescript cannot infer that neatly, so we cast away the nullable case.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const query = parameters ?? await loadParameters?.();
            // loadQuery returns not a Promise, but Observable.
            // Resource waits until query Observable is completed and returns a queryReference
            // later queryReference could be used by usePreloadedQuery
            const queryReference = (0, $6iz4v.measureFunc)(`relay_resource_load_query:${type}`, ()=>(0, $iWLL0.loadQuery)((0, $amu7D.default), query, variables || {}, options));
            if (false && queryReference.id != null) await (0, $c7ifG.QueryPromisesMap).get(queryReference.id);
            if (queryReference.id != null) (0, $c7ifG.QueryPromisesMap).get(queryReference.id)?.then(()=>{
                (0, $6iz4v.setMark)(endMark);
                (0, $6iz4v.setMeasure)(measureName, startMark, endMark);
            });
            /**
			 * We want to store HTTP codes from fetch response so that we can use it to report SLA correctly.
			 * (Unfortunately errors thrown by relay client validation doesn't include HTTP codes at the moment, so we have to store it ourselves)
			 * Starting to capture errors here ensures we capture errors for the early fetch of the query on initial page load,
			 * as well as subsequent fetches made by route transitions between spa-apps.
			 */ if (captureErrors) (0, $15ZJO.startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
            if (captureTraceIds) (0, $5udmX.startCapturingTraceIds)(queryReference.name);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return queryReference;
        },
        maxAge: 0,
        isBrowserOnly: isBrowserOnly
    });
const $485f6c69495cf127$export$1cc887c62079ea32 = $485f6c69495cf127$var$createRelayResourceImpl;
const $485f6c69495cf127$export$bbe949b85c06f763 = $485f6c69495cf127$var$createRelayResourceImpl;
const $485f6c69495cf127$export$42ca7b248c7aaee = (resource, options)=>{
    const { data: queryReference, loading: loading, promise: promise } = (0, $3HCkE.useResource)(resource);
    if (options?.suspendWhenLoading && loading) throw promise;
    return {
        queryReference: queryReference
    };
};

});

parcelRegister("hkmE9", function(module, exports) {

$parcel$export(module.exports, "default", () => $85ac2903ab7cc20b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<080192960e061f89098b18bf83162403>>
 * @relayHash 74050166d454b6d9ce9f7ed4035511fc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 33f5ecab3cdc817eb5f9adab300a034ff8d925bd997f473939a440277277f204
const $85ac2903ab7cc20b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isAppsExpanded"
    }, v2 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isPlansExpanded"
    }, v3 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isProjectsExpanded"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            v4 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v8 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v6 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "alias": "projectKey",
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "small"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "projectType"
                        },
                        {
                            "kind": "LinkedField",
                            "name": "navigationMetadata",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "boardId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isSimpleBoard"
                                        },
                                        v4 /*: any*/ 
                                    ],
                                    "type": "JiraSoftwareProjectNavigationMetadata"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isFavourite"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "projectStyle"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "projectUrl"
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "EDIT_PROJECT_CONFIG"
                                }
                            ],
                            "concreteType": "JiraProjectAction",
                            "kind": "LinkedField",
                            "name": "action",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "canPerform"
                                }
                            ],
                            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                        }
                    ],
                    "type": "JiraProject"
                },
                v7 /*: any*/ 
            ]
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "label"
    }, v10 = {
        "kind": "ScalarField",
        "name": "url"
    }, v11 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v12 = {
        "kind": "ScalarField",
        "name": "styleClass"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "L1MenuItemsQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ConfigurableMenu"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "L1MenuItemsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudID",
                                    "variableName": "cloudId"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "navKey",
                                    "value": "NAV_SIDEBAR"
                                }
                            ],
                            "concreteType": "JiraUserNavigationConfiguration",
                            "kind": "LinkedField",
                            "name": "userNavigationConfiguration",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraConfigurableNavigationItem",
                                    "kind": "LinkedField",
                                    "name": "navItems",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "menuId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isVisible"
                                        }
                                    ]
                                },
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isProjectsExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "type": "PROJECT"
                                            }
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 15
                                        }
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v8 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "args": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 20
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "PROJECT"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSearchableEntityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v8 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "canCreateProject",
                            "args": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "CREATE_PROJECT"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "canPerform"
                        },
                        {
                            "condition": "isAppsExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "boardId",
                                            "value": "ari:cloud:jira-software:1ea8bfb6-3dc1-48bb-9045-73a412f2941c:board/85"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "projectIdOrKey",
                                            "value": "CS"
                                        }
                                    ],
                                    "concreteType": "JiraNavigationItemConnection",
                                    "kind": "LinkedField",
                                    "name": "jiraSoftwareNavigationItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNavigationItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "appType"
                                                                },
                                                                v10 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "appId"
                                                                },
                                                                v11 /*: any*/ ,
                                                                v12 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraAppSection",
                                                                    "kind": "LinkedField",
                                                                    "name": "sections",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v9 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraAppNavigationItemNestedLink",
                                                                            "kind": "LinkedField",
                                                                            "name": "links",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v9 /*: any*/ ,
                                                                                v10 /*: any*/ ,
                                                                                v11 /*: any*/ ,
                                                                                v12 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "envLabel"
                                                                }
                                                            ],
                                                            "type": "JiraAppNavigationItem"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "jiraSoftwareNavigationItems(boardId:\"ari:cloud:jira-software:1ea8bfb6-3dc1-48bb-9045-73a412f2941c:board/85\",projectIdOrKey:\"CS\")"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isPlansExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "planFavourites",
                                    "args": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "type": "PLAN"
                                            }
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 10
                                        }
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "planId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "title"
                                                                }
                                                            ],
                                                            "type": "JiraPlan"
                                                        },
                                                        v7 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "33f5ecab3cdc817eb5f9adab300a034ff8d925bd997f473939a440277277f204",
            "metadata": {},
            "name": "L1MenuItemsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$85ac2903ab7cc20b$var$node.hash = "53e41716e008b4db9fa63e32f653d4bd";
var $85ac2903ab7cc20b$export$2e2bcd8739ae039 = $85ac2903ab7cc20b$var$node;

});


parcelRegister("I0t4m", function(module, exports) {

$parcel$export(module.exports, "staticPlanSidebarNavigationResource", () => $481e4ad580b3240b$export$e7e6c1b9d8d5ea7);
// eslint-disable-next-line jira/restricted/@atlassian/jira-router

var $3HCkE = parcelRequire("3HCkE");

var $kZ7vG = parcelRequire("kZ7vG");
const $481e4ad580b3240b$var$getRouterKey = (match)=>{
    if (match.url.includes('/plans/')) return `planId-${match.params.planId || ''}-scenarioId-${match.params.scenarioId || ''}`;
    return 'none';
};
const $481e4ad580b3240b$export$e7e6c1b9d8d5ea7 = (0, $3HCkE.createResource)({
    type: 'NAVIGATION_SIDEBAR_JIRA_PLAN',
    getKey: ({ match: match })=>$481e4ad580b3240b$var$getRouterKey(match),
    getData: async ({ match: { params: { planId: planId, scenarioId: scenarioId } } })=>{
        if (planId == null || scenarioId == null) return null;
        return (0, $kZ7vG.fetchPlanSidebarNavInfo)(planId, scenarioId);
    },
    maxAge: 300000
});

});
parcelRegister("kZ7vG", function(module, exports) {

$parcel$export(module.exports, "fetchPlanSidebarNavInfo", () => $ffd9df53dda0b988$export$a49729698cfc5310);

var $lRmyA = parcelRequire("lRmyA");
const $ffd9df53dda0b988$var$requestSideBarInfo = (planId, scenarioId)=>(0, $lRmyA.performGetRequest)(`/rest/jpo/1.0/navigation/plans/${planId}/scenarios/${scenarioId}`);
const $ffd9df53dda0b988$export$a49729698cfc5310 = (planId, scenarioId)=>{
    if (planId == null || planId.trim() === '') throw new Error('Plan cannot be loaded without a planId');
    if (scenarioId == null || scenarioId.trim() === '') throw new Error('Plan cannot be loaded without a scenarioId');
    return $ffd9df53dda0b988$var$requestSideBarInfo(planId, scenarioId);
};

});


parcelRegister("eJCK9", function(module, exports) {

$parcel$export(module.exports, "staticSidebarShortcutsResource", () => $9e1e6b174c3d84b9$export$4847c29b4786b3b4);
// eslint-disable-next-line jira/restricted/@atlassian/jira-router

var $3HCkE = parcelRequire("3HCkE");

var $9zYls = parcelRequire("9zYls");

var $iVoS5 = parcelRequire("iVoS5");
const $9e1e6b174c3d84b9$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $9e1e6b174c3d84b9$export$4847c29b4786b3b4 = (0, $3HCkE.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_SHORTCUTS',
    getKey: ({ match: match, query: query })=>$9e1e6b174c3d84b9$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $9e1e6b174c3d84b9$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const shortcuts = await (0, $iVoS5.fetchShortcuts)(projectKeyOrId);
        return shortcuts;
    },
    maxAge: 300000
});

});
parcelRegister("iVoS5", function(module, exports) {

$parcel$export(module.exports, "fetchShortcuts", () => $72b9eb1ede36e333$export$49d696bf2525d700);

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");
const $72b9eb1ede36e333$export$49d696bf2525d700 = (projectKeyOrId)=>{
    try {
        return (0, $2OdyW.default)(`/rest/projects/1.0/project/${projectKeyOrId}/shortcut`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.trackFetchErrors)({
            error: error,
            id: 'fetchProjectShortcuts',
            packageName: 'jiraNavigationAppsResources'
        });
        throw error;
    }
};

});


parcelRegister("6OTFM", function(module, exports) {

$parcel$export(module.exports, "staticSoftwareProjectHorizontalNavResource", () => $e315884b683b3230$export$c5680a2101ae5345);

var $jDNSq = parcelRequire("jDNSq");

var $kdp9J = parcelRequire("kdp9J");

var $1ybV0 = parcelRequire("1ybV0");

var $buJlM = parcelRequire("buJlM");

var $djXuz = parcelRequire("djXuz");

var $ElVpH = parcelRequire("ElVpH");
var $9zYls = parcelRequire("9zYls");
var $jwzNs = parcelRequire("jwzNs");
const $e315884b683b3230$export$71eec30d9db46a56 = ({ match: match, query: query }, { tenantContext: tenantContext })=>{
    let scope;
    const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
    const boardId = (0, $ElVpH.getBoardId)(match, query);
    const isTMPBoardRoute = boardId ? match.url.includes('/software/projects/') : false;
    if (isTMPBoardRoute) // TMP software projects always use projectKey even on board routes because they only have one board
    scope = (0, $kdp9J.getScopeIdentifier)({
        projectKey: projectKey,
        projectId: projectId
    });
    else scope = (0, $kdp9J.getScopeIdentifier)({
        projectKey: projectKey,
        projectId: projectId,
        boardId: boardId
    });
    return {
        parameters: (0, $djXuz.default),
        variables: {
            cloudId: tenantContext.cloudId,
            projectKey: projectKey,
            boardId: scope.identifierType === 'boardId' ? (0, $jDNSq.JiraSoftwareBoardAri).create({
                siteId: tenantContext.cloudId,
                boardId: String(match.params.boardId)
            }).toString() : undefined
        },
        options: {
            fetchPolicy: 'store-and-network'
        }
    };
};
const $e315884b683b3230$export$c5680a2101ae5345 = (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('sea-2744-jsw-tabs-nav'), (0, $buJlM.createRelayResource)({
    type: 'HORIZONTAL_NAVIGATION_PROJECT_QUERY',
    getQuery: $e315884b683b3230$export$71eec30d9db46a56
}));

});
parcelRegister("jDNSq", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwareBoardAri", () => $359ff269acabe1de$export$fcd404066e55a7a8);

var $kkRql = parcelRequire("kkRql");

var $v8cEo = parcelRequire("v8cEo");

var $hkoEN = parcelRequire("hkoEN");
// src/jira-software/board/manifest.ts
var $359ff269acabe1de$var$jiraSoftwareBoardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9-]+$"),
    resourceOwner: (0, $kkRql.JiraSoftwareBoardAriResourceOwner),
    resourceType: (0, $kkRql.JiraSoftwareBoardAriResourceType),
    resourceIdSlug: "{boardId}",
    resourceIdSegmentFormats: {
        boardId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
    }
};
// src/jira-software/board/index.ts
var $359ff269acabe1de$export$fcd404066e55a7a8 = class _JiraSoftwareBoardAri extends (0, $v8cEo.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._boardId = opts.resourceIdSegmentValues.boardId;
    }
    get siteId() {
        return this._siteId;
    }
    get boardId() {
        return this._boardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $359ff269acabe1de$var$jiraSoftwareBoardAriStaticOpts.qualifier,
            platformQualifier: $359ff269acabe1de$var$jiraSoftwareBoardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $359ff269acabe1de$var$jiraSoftwareBoardAriStaticOpts.resourceOwner,
            resourceType: $359ff269acabe1de$var$jiraSoftwareBoardAriStaticOpts.resourceType,
            resourceId: `${opts.boardId}`,
            resourceIdSegmentValues: {
                boardId: opts.boardId
            }
        }, ariOpts = (0, $hkoEN.AriParser).fromOpts(derivedOpts, $359ff269acabe1de$var$jiraSoftwareBoardAriStaticOpts);
        return new _JiraSoftwareBoardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hkoEN.AriParser).fromString(maybeAri, $359ff269acabe1de$var$jiraSoftwareBoardAriStaticOpts);
        return new _JiraSoftwareBoardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            boardId: this.boardId
        };
    }
};

});
parcelRegister("kkRql", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwareBoardAriResourceOwner", () => $64a01189673ac62a$export$d716ba4f5572ec86);
$parcel$export(module.exports, "JiraSoftwareBoardAriResourceType", () => $64a01189673ac62a$export$d4b70c04cf2221a5);
// src/jira-software/board/types.ts
var $64a01189673ac62a$export$d716ba4f5572ec86 = "jira-software", $64a01189673ac62a$export$d4b70c04cf2221a5 = "board";

});

parcelRegister("v8cEo", function(module, exports) {

$parcel$export(module.exports, "RegisteredAri", () => $81a8d536c343a20d$export$579ee78b1dcf0a11);

var $dCoVL = parcelRequire("dCoVL");
// src/core/registered-ari.ts
var $81a8d536c343a20d$export$579ee78b1dcf0a11 = class extends (0, $dCoVL.Ari) {
    static check(maybeAri) {
        try {
            return this.parse(maybeAri.toString()), !0;
        } catch (err) {
            return !1;
        }
    }
    asAnyAri() {
        return (0, $dCoVL.AnyAri).parse(this.toString());
    }
};

});


parcelRegister("djXuz", function(module, exports) {

$parcel$export(module.exports, "default", () => $70d6cbbebfbb8fd5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<033c33b860b06a04afad0197fda04fcd>>
 * @relayHash b470c1956ad4ca6a6e341d12168838ba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c960bd8cf3492301fd3f2194a21c7f8f53a76e97acda92b88a402039e5fc4020
const $70d6cbbebfbb8fd5$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "boardId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v3 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v4 = [
        v3 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v5 = {
        "args": [
            {
                "kind": "Literal",
                "name": "type",
                "value": "EDIT_PROJECT_CONFIG"
            }
        ],
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ],
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        },
        v3 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "projectIdOrKey",
            "variableName": "projectKey"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "label"
    }, v9 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v10 = {
        "kind": "ScalarField",
        "name": "url"
    }, v11 = {
        "kind": "ScalarField",
        "name": "styleClass"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "uiHorizontalSoftwareProjectNavQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v4 /*: any*/ ,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProjectByKey",
                                "plural": false,
                                "selections": [
                                    v5 /*: any*/ 
                                ]
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "JiraNavigationItemConnection",
                                    "kind": "LinkedField",
                                    "name": "jiraSoftwareNavigationItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ui_navigationKitTabList_TabList"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraSoftwareNavigationItems"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "uiHorizontalSoftwareProjectNavQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v7 /*: any*/ 
                            ]
                        },
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "JiraNavigationItemConnection",
                            "kind": "LinkedField",
                            "name": "jiraSoftwareNavigationItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraNavigationItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isDefault"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "typeKey"
                                                },
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isJiraNavigationItem"
                                                },
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canRemove"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canSetAsDefault"
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraAppSection",
                                                            "kind": "LinkedField",
                                                            "name": "sections",
                                                            "plural": true,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraAppNavigationItemNestedLink",
                                                                    "kind": "LinkedField",
                                                                    "name": "links",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v8 /*: any*/ ,
                                                                        v9 /*: any*/ ,
                                                                        v10 /*: any*/ ,
                                                                        v11 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v10 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "appType"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "envLabel"
                                                        }
                                                    ],
                                                    "type": "JiraAppNavigationItem"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c960bd8cf3492301fd3f2194a21c7f8f53a76e97acda92b88a402039e5fc4020",
            "metadata": {},
            "name": "uiHorizontalSoftwareProjectNavQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$70d6cbbebfbb8fd5$var$node.hash = "cc12d798a25264ec9d04143058744a65";
var $70d6cbbebfbb8fd5$export$2e2bcd8739ae039 = $70d6cbbebfbb8fd5$var$node;

});

parcelRegister("jwzNs", function(module, exports) {

$parcel$export(module.exports, "resourceWithCondition", () => $55f07a7915bec73f$export$cac04afc5a06c544);
$parcel$export(module.exports, "resourceWithCondition2", () => $55f07a7915bec73f$export$78488a529a07cd46);
$parcel$export(module.exports, "browserOnlyResourceWithCondition", () => $55f07a7915bec73f$export$5284559c6d2f1a7b);

var $6qExu = parcelRequire("6qExu");
const $55f07a7915bec73f$export$cac04afc5a06c544 = (conditionGetter, resourceTrue)=>resourceTrue && {
        get type () {
            return conditionGetter() ? resourceTrue.type : (0, $6qExu.RESOURCE_TYPE_NOOP);
        },
        getKey: resourceTrue.getKey,
        get maxAge () {
            return conditionGetter() ? resourceTrue.maxAge : Number.MAX_SAFE_INTEGER;
        },
        getData: (routerContext, customContext)=>conditionGetter() ? resourceTrue.getData(routerContext, customContext) : Promise.resolve(null),
        maxCache: resourceTrue.maxCache,
        get isBrowserOnly () {
            return resourceTrue.isBrowserOnly;
        },
        get depends () {
            return resourceTrue.depends;
        }
    };
const $55f07a7915bec73f$export$fbf6681b373be4c4 = (resource, amendments = {})=>// @ts-expect-error - TS2322 - Type 'Partial<RouteResource<any>>' is not assignable to type 'RouteResource<any>'.
    resource && // IMPORTANT - resources can be falsy in SSR "routes" build
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.defineProperties({}, {
        ...Object.getOwnPropertyDescriptors(resource),
        ...Object.getOwnPropertyDescriptors(amendments)
    });
const $55f07a7915bec73f$export$78488a529a07cd46 = (conditionGetter, itemTrue, itemFalse = $55f07a7915bec73f$export$fbf6681b373be4c4(itemTrue, {
    getKey: ()=>'DEGENERATE_KEY',
    getData: ()=>null,
    maxAge: Number.MAX_SAFE_INTEGER
}))=>// @ts-expect-error - TS2740 - Type '{}' is missing the following properties from type 'RouteResource<any>': type, getKey, maxAge, getData, and 3 more.
    itemTrue && // IMPORTANT - resources can be falsy in SSR "routes" build
    Object.defineProperties({}, Object.fromEntries([
        ...Object.keys(itemTrue),
        ...Object.keys(itemFalse)
    ].filter((v, i, a)=>a.indexOf(v) === i).map((key)=>[
            key,
            {
                configurable: false,
                enumerable: true,
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'RouteResource<any>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'RouteResource<any>'.
                get: ()=>conditionGetter() ? itemTrue[key] : itemFalse[key]
            }
        ])));
const $55f07a7915bec73f$export$5284559c6d2f1a7b = (conditionGetter, resource)=>resource && {
        ...resource,
        get isBrowserOnly () {
            return !!conditionGetter();
        }
    };

});
parcelRegister("6qExu", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_NOOP", () => $d6fba9243db8a331$export$eb37f5d331ea4de4);
$parcel$export(module.exports, "MIN_MAX_AGE", () => $d6fba9243db8a331$export$5664a170ac5a9781);
const $d6fba9243db8a331$export$eb37f5d331ea4de4 = 'NOOP';
const $d6fba9243db8a331$export$5664a170ac5a9781 = 5000;

});



parcelRegister("hawmT", function(module, exports) {

$parcel$export(module.exports, "navigationPlansVisibilityResource", () => $a93019de4376d1a2$export$fa475a9581133779);
$parcel$export(module.exports, "useNavigationPlansVisibility", () => $a93019de4376d1a2$export$4524245d4e74edb2);
$parcel$export(module.exports, "useNavigationViewPlansPermission", () => $a93019de4376d1a2$export$98eef08fd4586a4);
$parcel$export(module.exports, "useNavigationEditPlansPermission", () => $a93019de4376d1a2$export$525db876ed776e0d);
$parcel$export(module.exports, "useIsAdvancedRoadmapsTrial", () => $a93019de4376d1a2$export$54805a2120a31ad0);

var $gUUjF = parcelRequire("gUUjF");

var $79xbN = parcelRequire("79xbN");

var $2OdyW = parcelRequire("2OdyW");

var $3HCkE = parcelRequire("3HCkE");

var $6WXNs = parcelRequire("6WXNs");
var $eIp1n = parcelRequire("eIp1n");

var $ab6rA = parcelRequire("ab6rA");

const $a93019de4376d1a2$export$fa475a9581133779 = (0, $3HCkE.createResource)({
    type: (0, $b5f6b10e2be29709$export$9260ddb6dfeafd7b),
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        try {
            if (tenantContext.isAnonymous) return false;
            const response = await (0, $2OdyW.default)(`${tenantContext.baseUrl}/rest/jpo/1.0/navigation/simple`);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData((0, $b5f6b10e2be29709$export$87d0ca22edb7493a), 'Error while fetching plans visibility', error);
        }
        return false;
    },
    maxAge: Infinity
});
const $a93019de4376d1a2$export$4524245d4e74edb2 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $3HCkE.useResource)($a93019de4376d1a2$export$fa475a9581133779);
    const appEditions = (0, $ab6rA.useAppEditions)();
    const jswEdition = (0, $6WXNs.getEdition)((0, $eIp1n.JIRA_SOFTWARE), appEditions);
    let isVisible = false;
    if (!error && !loading && data !== null && typeof data === 'object') isVisible = data.isVisible;
    if (isVisible && jswEdition === (0, $6WXNs.FREE_EDITION)) {
        const shouldHidePlans = (0, $79xbN.expVal)('hide_plans_tab_for_jira_free', 'shouldHidePlansTab', false);
        return [
            !shouldHidePlans
        ];
    }
    return [
        isVisible
    ];
};
const $a93019de4376d1a2$export$98eef08fd4586a4 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $3HCkE.useResource)($a93019de4376d1a2$export$fa475a9581133779);
    let hasEditOrViewPermissions = false;
    if (!error && !loading && data !== null && typeof data === 'object') hasEditOrViewPermissions = data.hasEditOrViewPermissions;
    return [
        hasEditOrViewPermissions
    ];
};
const $a93019de4376d1a2$export$525db876ed776e0d = ()=>{
    const { data: data, loading: loading, error: error } = (0, $3HCkE.useResource)($a93019de4376d1a2$export$fa475a9581133779);
    let canEditPlans = false;
    if (!error && !loading && data !== null && typeof data === 'object') canEditPlans = data.hasEditPermissions || false;
    return canEditPlans;
};
const $a93019de4376d1a2$export$54805a2120a31ad0 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $3HCkE.useResource)($a93019de4376d1a2$export$fa475a9581133779);
    let isAdvancedRoadmapsTrial = false;
    if (!error && !loading && data !== null && typeof data === 'object') isAdvancedRoadmapsTrial = data.isAdvancedRoadmapsTrial || false;
    return isAdvancedRoadmapsTrial;
};

});
parcelRegister("ab6rA", function(module, exports) {

$parcel$export(module.exports, "useAppEditions", () => $75e408c194026ea5$export$92ed15881fc090d7);

var $gd0Sp = parcelRequire("gd0Sp");
const $75e408c194026ea5$export$92ed15881fc090d7 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.appEditions;
};

});

const $b5f6b10e2be29709$export$9260ddb6dfeafd7b = 'NAVIGATION_PLANS_VISIBILITY';
const $b5f6b10e2be29709$export$87d0ca22edb7493a = 'portfolio.services.plan-item-visibility';


parcelRegister("8mP0X", function(module, exports) {

$parcel$export(module.exports, "planSidebarNavigationOptInStatusResources", () => $25d62fa85243192d$export$80a694316ccf7408);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");

var $3HCkE = parcelRequire("3HCkE");

const $25d62fa85243192d$export$80a694316ccf7408 = (0, $3HCkE.createResource)({
    type: (0, $af778776d0774f93$export$469e0f3dfa0992d7),
    getKey: ()=>'plan_sidebar_navigation_optin_status',
    getData: async ()=>{
        let planSidebarNavigationOptInStatus = null;
        try {
            planSidebarNavigationOptInStatus = await (0, $lRmyA.performGetRequest)('/rest/api/3/mypreferences?key=arj-navigation-sidebar');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            // Error 404 is acceptable as on the first call the key does not exist in the user profile
            if (e.statusCode === 404) return {
                planSidebarNavigationOptInStatus: {
                    isEnabled: false
                }
            };
            (0, $gUUjF.default).safeErrorWithoutCustomerData('spa.router.resources.navigation.detectPlanSidebarNavigationVisibility', 'getDetectPlanSidebarNavigationVisibility', e);
        }
        return {
            planSidebarNavigationOptInStatus: planSidebarNavigationOptInStatus ?? {
                isEnabled: false
            }
        };
    },
    maxAge: Number.MAX_VALUE
});

});
const $af778776d0774f93$export$469e0f3dfa0992d7 = 'RESOURCE_TYPE_PLAN_SIDEBAR_NAVIGATION_OPTIN_STATUS';


parcelRegister("cpkr0", function(module, exports) {

$parcel$export(module.exports, "checkApiKeyManagementKeysResource", () => $0913ae43ba61e45d$export$b16eaa5246afc9b6);
// eoc-fetch is already being used in eoc resources, so there is no reason not
// to override the whitelist here.
// eslint-disable-next-line jira/import-whitelist

var $kRdYM = parcelRequire("kRdYM");

var $jf8p7 = parcelRequire("jf8p7");

var $bKxX9 = parcelRequire("bKxX9");

var $3HCkE = parcelRequire("3HCkE");


const $0913ae43ba61e45d$var$fetchCheckApiKeyManagementKeys = async (accountId, isSiteAdmin, isTransitioning, appPermissions)=>{
    if (!(0, $bKxX9.ff)('eoc-api-key-management-feature-jira_8ox4z') || !isTransitioning || !isSiteAdmin || appPermissions && appPermissions.hasServiceDeskAccess === false) return Promise.resolve(false);
    return (0, $kRdYM.eocFetch)(`/api-keys/web/check?accountId=${accountId}`).then(({ data: data })=>data);
};
const $0913ae43ba61e45d$export$b16eaa5246afc9b6 = ()=>(0, $3HCkE.createResource)({
        type: (0, $be0f36e5e3d53287$export$5879151f0d972f18),
        getKey: ()=>'check-api-key-management-keys',
        getData: async ({ dependencies: dependencies }, { tenantContext: { atlassianAccountId: atlassianAccountId, appPermissions: appPermissions, isSiteAdmin: isSiteAdmin } })=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const tenantInfo = await dependencies[0, $02315c431173f662$export$25ee35b01de9d734]?.promise;
            const isTransitioning = (0, $jf8p7.checkIsTransitioning)(tenantInfo);
            return $0913ae43ba61e45d$var$fetchCheckApiKeyManagementKeys(atlassianAccountId, isSiteAdmin, isTransitioning, appPermissions);
        },
        maxAge: Infinity,
        isBrowserOnly: true,
        depends: [
            (0, $02315c431173f662$export$25ee35b01de9d734)
        ]
    });

});
const $be0f36e5e3d53287$export$5879151f0d972f18 = 'EOC_CHECK_API_KEY';


parcelRegister("jlBE2", function(module, exports) {

$parcel$export(module.exports, "gicSmartFieldsFeatureResource", () => $4ec33ba6cfdbce95$export$ee94bb1f59b07e35);
$parcel$export(module.exports, "useIsSmartFieldsOptIn", () => $4ec33ba6cfdbce95$export$3870b1ff1b155c73);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $3HCkE = parcelRequire("3HCkE");

var $cm5m0 = parcelRequire("cm5m0");

const $4ec33ba6cfdbce95$export$ee94bb1f59b07e35 = (0, $3HCkE.createResource)({
    type: (0, $af92d8ab297d74d2$export$6f0555de4f60e84e),
    getKey: ()=>(0, $af92d8ab297d74d2$export$7e7d7930e22ba39f),
    getData: async ()=>{
        try {
            const data = await (0, $cm5m0.userPreferenceAPI).get((0, $af92d8ab297d74d2$export$b94951a11282ae6a));
            if (!data) return {
                hasUserOptedOut: false,
                hasUserDismissedReadMore: false
            };
            return data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // If value has never been set, we expect a 404
            if (error.statusCode === 404) return {
                hasUserOptedOut: false,
                hasUserDismissedReadMore: false
            };
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'gicSmartFieldsFeatureResource',
                    packageName: (0, $af92d8ab297d74d2$export$b8b9d90f9e5bd72b),
                    teamName: 'deliveroo'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            hasUserOptedOut: false,
            hasUserDismissedReadMore: false
        };
    },
    maxAge: Number.MAX_VALUE
});
const $4ec33ba6cfdbce95$export$3870b1ff1b155c73 = ()=>{
    const { data: data, update: update, loading: loading } = (0, $3HCkE.useResource)($4ec33ba6cfdbce95$export$ee94bb1f59b07e35);
    const currentOptInStatus = typeof data?.hasUserOptedOut === 'boolean' ? !data.hasUserOptedOut : true;
    const currentDismissedReadMore = typeof data?.hasUserDismissedReadMore === 'boolean' ? data.hasUserDismissedReadMore : false;
    const dismissReadMore = (0, $eUqFw.useCallback)(()=>{
        update((previousData)=>({
                ...previousData?.hasUserOptedOut ? {
                    hasUserOptedOut: previousData.hasUserOptedOut
                } : {
                    hasUserOptedOut: false
                },
                hasUserDismissedReadMore: true
            }));
    }, [
        update
    ]);
    return {
        isSmartFieldsOptIn: loading ? null : currentOptInStatus,
        isSmartFieldDismissedReadMore: loading ? null : currentDismissedReadMore,
        dismissReadMore: dismissReadMore,
        loading: loading
    };
};

});
const $af92d8ab297d74d2$export$6f0555de4f60e84e = 'RESOURCE_TYPE_GIC_SMART_FIELDS';
const $af92d8ab297d74d2$export$7e7d7930e22ba39f = 'gsf-opt-out-resource-key'; // value is global for user
const $af92d8ab297d74d2$export$b94951a11282ae6a = 'gic-smart-fields-feature';
const $af92d8ab297d74d2$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesGicSmartFields';


parcelRegister("ellXt", function(module, exports) {

$parcel$export(module.exports, "gicOptInStatusResources", () => $d1ab65e118ce0b83$export$14c89b6b6a261524);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");

var $3HCkE = parcelRequire("3HCkE");

const $d1ab65e118ce0b83$export$14c89b6b6a261524 = (0, $3HCkE.createResource)({
    type: (0, $937f75d7d64d5d05$export$fe522736b61f6709),
    getKey: ()=>'gic_optin_status',
    getData: async ()=>{
        let gicOptInStatus = null;
        try {
            gicOptInStatus = await (0, $lRmyA.performGetRequest)('/rest/greenhopper/1.0/profile/labs-panel/modern-gic-visibility');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e.statusCode !== 404) (0, $gUUjF.default).safeErrorWithoutCustomerData('spa.router.resources.navigation.gicVisibility', 'getGICVisibility', e);
        }
        return {
            gicOptInStatus: gicOptInStatus ?? {
                isEnabled: false
            }
        };
    },
    maxAge: Number.MAX_VALUE
});

});
const $937f75d7d64d5d05$export$fe522736b61f6709 = 'RESOURCE_TYPE_GIC_OPTIN_STATUS';


parcelRegister("h0Ytu", function(module, exports) {

$parcel$export(module.exports, "issueTransitionChangeboardingPreferencesResource", () => $a8290ca1941fd80d$export$1b6468a6eb7d9b09);
$parcel$export(module.exports, "useIssueTransitionChangeboardingPreferences", () => $a8290ca1941fd80d$export$e21c345b2538e96e);

var $eUqFw = parcelRequire("eUqFw");

var $6G5mG = parcelRequire("6G5mG");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $3HCkE = parcelRequire("3HCkE");

var $058mG = parcelRequire("058mG");
const $a8290ca1941fd80d$export$1b6468a6eb7d9b09 = (0, $3HCkE.createResource)({
    type: (0, $058mG.RESOURCE_TYPE_ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES),
    getKey: ()=>(0, $058mG.ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_STATUS_RESOURCE_KEY),
    getData: async ()=>{
        let modalViewCount = (0, $058mG.USER_SEEN_CARDINALITY_UNKNOWN);
        try {
            const apiResult = await (0, $lRmyA.performGetRequest)((0, $058mG.ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API));
            if (typeof apiResult !== 'object' || !(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(apiResult, 'value')) {
                const error = new Error('Invalid preference value');
                (0, $guiFP.default)({
                    meta: {
                        id: 'issueTransitionChangeboardingPreferencesResource',
                        packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            } else {
                modalViewCount = Number(apiResult.value);
                return {
                    numberOfTimesUserHasSeenChangeboarding: modalViewCount
                };
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === 404) return {
                numberOfTimesUserHasSeenChangeboarding: 0
            };
            (0, $guiFP.default)({
                meta: {
                    id: 'issueTransitionChangeboardingPreferencesResource',
                    packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            numberOfTimesUserHasSeenChangeboarding: modalViewCount
        };
    }
});
const $a8290ca1941fd80d$export$e21c345b2538e96e = ()=>{
    const { data: data, loading: loadingGetResource, error: errorGetResource, update: update } = (0, $3HCkE.useResource)($a8290ca1941fd80d$export$1b6468a6eb7d9b09);
    const [issueTransitionChangeboardingPreference, setIssueTransitionChangeboardingPreference] = (0, $eUqFw.useState)(()=>{
        if (typeof data?.numberOfTimesUserHasSeenChangeboarding === 'number') return data.numberOfTimesUserHasSeenChangeboarding;
        return 0, $058mG.USER_SEEN_CARDINALITY_UNKNOWN;
    });
    const [responseStatusGet, setResponseStatusGet] = (0, $eUqFw.useState)('not started');
    const [responseStatusPut, setResponseStatusPut] = (0, $eUqFw.useState)('not started');
    const updateIssueTranstitionChangeboardingPreferences = (0, $eUqFw.useCallback)(async (updates)=>{
        let response = 'loading';
        setResponseStatusPut('loading');
        try {
            await (0, $lRmyA.performPutRequest)((0, $058mG.ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API), {
                body: JSON.stringify({
                    value: updates
                })
            });
            setResponseStatusPut('success');
            update(()=>({
                    numberOfTimesUserHasSeenChangeboarding: updates
                }));
            response = 'success';
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'issueTransitionChangeboardingPreferencesUpdate',
                    packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            setResponseStatusPut('error');
            response = 'error';
        }
        return response;
    }, [
        update
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (loadingGetResource) {
            setResponseStatusGet('loading');
            return;
        }
        if (errorGetResource) {
            setResponseStatusGet('error');
            return;
        }
        if (typeof data?.numberOfTimesUserHasSeenChangeboarding === 'number') {
            setResponseStatusGet('success');
            setIssueTransitionChangeboardingPreference(data?.numberOfTimesUserHasSeenChangeboarding);
        }
    }, [
        loadingGetResource,
        errorGetResource,
        data?.numberOfTimesUserHasSeenChangeboarding
    ]);
    return {
        stateGet: {
            responseStatus: responseStatusGet,
            state: issueTransitionChangeboardingPreference
        },
        stateUpdate: {
            responseStatus: responseStatusPut,
            setState: updateIssueTranstitionChangeboardingPreferences
        }
    };
};

});
parcelRegister("6G5mG", function(module, exports) {

var $8uRtH = parcelRequire("8uRtH");

var $85YVZ = parcelRequire("85YVZ");
/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */ function $4dcad3b0f5b12e6f$var$has(object, path) {
    return object != null && $85YVZ(object, path, $8uRtH);
}
module.exports = $4dcad3b0f5b12e6f$var$has;

});
parcelRegister("8uRtH", function(module, exports) {
/** Used for built-in method references. */ var $62fa9bac23574fbd$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $62fa9bac23574fbd$var$hasOwnProperty = $62fa9bac23574fbd$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $62fa9bac23574fbd$var$baseHas(object, key) {
    return object != null && $62fa9bac23574fbd$var$hasOwnProperty.call(object, key);
}
module.exports = $62fa9bac23574fbd$var$baseHas;

});


parcelRegister("058mG", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES", () => $0ce11008f44b5e39$export$d66d4b761db3d20f);
$parcel$export(module.exports, "ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_STATUS_RESOURCE_KEY", () => $0ce11008f44b5e39$export$79fd70b908f71ddd);
$parcel$export(module.exports, "ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API", () => $0ce11008f44b5e39$export$e5007258addba8aa);
$parcel$export(module.exports, "USER_SEEN_CARDINALITY_UNKNOWN", () => $0ce11008f44b5e39$export$91880069e7e73b18);
const $0ce11008f44b5e39$export$d66d4b761db3d20f = 'issue_transition_changeboarding_preferences';
const $0ce11008f44b5e39$export$79fd70b908f71ddd = 'issue_transition_changeboarding_preferences_status';
const $0ce11008f44b5e39$export$e5007258addba8aa = '/rest/api/3/mypreferences?key=jira.its.changeboarding.preferences';
const $0ce11008f44b5e39$export$91880069e7e73b18 = -1;

});


parcelRegister("6XOSh", function(module, exports) {

$parcel$export(module.exports, "issueTransitionOptInStatusResource", () => $839ddb0b122518f6$export$5fbcf4d7a6d9c477);
$parcel$export(module.exports, "useIssueTransitionLabsOptIn", () => $839ddb0b122518f6$export$bc11d4816053db5c);

var $eUqFw = parcelRequire("eUqFw");

var $dfBCt = parcelRequire("dfBCt");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $lRmyA = parcelRequire("lRmyA");

var $3HCkE = parcelRequire("3HCkE");


var $ZKxj9 = parcelRequire("ZKxj9");
/*
 * API Contract: https://hello.atlassian.net/wiki/spaces/JIE/pages/2983777277/Issue+Transition+Jira+Labs+Toggle+for+Legacy+Experience+Backend+API#API-Contract
 */ const $839ddb0b122518f6$var$fetchGetIssueTransitionOptInState = async ()=>(0, $lRmyA.performGetRequest)((0, $62811791007d8b59$export$466b1c60da56c8ca));
const $839ddb0b122518f6$export$5fbcf4d7a6d9c477 = (0, $3HCkE.createResource)({
    type: (0, $62811791007d8b59$export$eb01e12fc3db65c0),
    getKey: ()=>(0, $62811791007d8b59$export$a964df7bc15d81e),
    getData: async ()=>{
        let issueTransitionOptInStatus = null;
        const isModernIssueTransitionSRBCohort = (0, $1ybV0.ff)('issue-transition-customisation-for-srb_0eyvc') || (0, $dfBCt.isFedRamp)();
        const isModernITSRenderEnabled = (0, $1ybV0.ff)('render-modern-issue-transition_cxt0z') || (0, $dfBCt.isFedRamp)();
        if (!isModernITSRenderEnabled) return {
            issueTransitionOptInStatus: {
                isEnabled: false,
                expiryTime: -1
            }
        };
        if (isModernIssueTransitionSRBCohort) return {
            issueTransitionOptInStatus: {
                isEnabled: true
            }
        };
        try {
            issueTransitionOptInStatus = await $839ddb0b122518f6$var$fetchGetIssueTransitionOptInState();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === 404) (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'issueTransitionOptInStatusResource',
                    packageName: 'jiraRouterResourcesIssueTransitionLabsOptIn',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            issueTransitionOptInStatus: issueTransitionOptInStatus ?? (0, $ZKxj9.default)()
        };
    },
    maxAge: Number.MAX_VALUE
});
const $839ddb0b122518f6$var$fetchModifyIssueTransitionOptInState = async (payload)=>(0, $lRmyA.performPutRequest)((0, $62811791007d8b59$export$466b1c60da56c8ca), {
        body: JSON.stringify(payload)
    });
const $839ddb0b122518f6$export$bc11d4816053db5c = ()=>{
    const { data: data, loading: loadingGetResource, error: errorGetResource, update: update } = (0, $3HCkE.useResource)($839ddb0b122518f6$export$5fbcf4d7a6d9c477);
    const [issueTransitionLabsOptInState, setIssueTransitionOptInState] = (0, $eUqFw.useState)(()=>{
        if (data?.issueTransitionOptInStatus) return data.issueTransitionOptInStatus;
        return (0, $ZKxj9.default)();
    });
    const [responseStatusGet, setResponseStatusGet] = (0, $eUqFw.useState)('not started');
    const [responseStatusPut, setResponseStatusPut] = (0, $eUqFw.useState)('not started');
    const updateIssueTransitionOptInStatus = (0, $eUqFw.useCallback)(async (updates)=>{
        let response = 'loading';
        setResponseStatusPut('loading');
        try {
            const updatedPreferences = await $839ddb0b122518f6$var$fetchModifyIssueTransitionOptInState(updates);
            setResponseStatusPut('success');
            update(()=>({
                    issueTransitionOptInStatus: updatedPreferences
                }));
            response = 'success';
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $guiFP.default)({
                error: err,
                meta: {
                    id: 'issueTransitionOptInStatusUpdate',
                    packageName: 'jiraRouterResourcesIssueTransitionLabsOptIn',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            setResponseStatusPut('error');
            response = 'error';
        }
        return response;
    }, [
        update
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (loadingGetResource) {
            setResponseStatusGet('loading');
            return;
        }
        if (errorGetResource) {
            setResponseStatusGet('error');
            return;
        }
        if (data?.issueTransitionOptInStatus) {
            setResponseStatusGet('success');
            setIssueTransitionOptInState(data.issueTransitionOptInStatus);
        }
    }, [
        loadingGetResource,
        errorGetResource,
        data?.issueTransitionOptInStatus
    ]);
    return {
        stateGet: {
            responseStatus: responseStatusGet,
            state: issueTransitionLabsOptInState
        },
        stateUpdate: {
            responseStatus: responseStatusPut,
            setState: updateIssueTransitionOptInStatus
        }
    };
};

});
const $62811791007d8b59$export$eb01e12fc3db65c0 = 'issue_transition_opt_in';
const $62811791007d8b59$export$a964df7bc15d81e = 'issue_transition_labs_opt_in_status';
const $62811791007d8b59$export$466b1c60da56c8ca = '/rest/greenhopper/1.0/profile/labs-panel/modern-its-visibility';
const $62811791007d8b59$export$880a78695d76498e = 8;

parcelRegister("ZKxj9", function(module, exports) {

$parcel$export(module.exports, "default", () => $99072b8c90c9105d$export$2e2bcd8739ae039);

var $dfBCt = parcelRequire("dfBCt");

var $1ybV0 = parcelRequire("1ybV0");
const $99072b8c90c9105d$var$FF_POSSIBLE_VALUES = [
    'OFF',
    'BY_DEFAULT_USER_OPT_IN',
    'BY_DEFAULT_USER_OPT_OUT'
];
const $99072b8c90c9105d$var$getDefaultIssueTransitionLabsOptInState = ()=>{
    const isModernITSRenderEnabled = (0, $1ybV0.ff)('render-modern-issue-transition_cxt0z') || (0, $dfBCt.isFedRamp)();
    if (!isModernITSRenderEnabled) return {
        isEnabled: false,
        expiryTime: -1
    };
    const isModernIssueTransitionSRBCohort = (0, $1ybV0.ff)('issue-transition-customisation-for-srb_0eyvc') || (0, $dfBCt.isFedRamp)();
    if (isModernIssueTransitionSRBCohort) return {
        isEnabled: true
    };
    const isExplicitlyUseTurnedOff = (0, $1ybV0.getMultivariateFeatureFlag)('jira-issue-transition-screen-modernisation-toggle', 'OFF', $99072b8c90c9105d$var$FF_POSSIBLE_VALUES) === 'BY_DEFAULT_USER_OPT_OUT';
    return isExplicitlyUseTurnedOff ? {
        isEnabled: false,
        expiryTime: -1
    } : {
        isEnabled: true
    };
};
var $99072b8c90c9105d$export$2e2bcd8739ae039 = $99072b8c90c9105d$var$getDefaultIssueTransitionLabsOptInState;

});


parcelRegister("l6RYU", function(module, exports) {

$parcel$export(module.exports, "navigationSidebarAutomationLegacyEnabledResource", () => $694329614259616a$export$fa191d7d71460a98);

var $e91YZ = parcelRequire("e91YZ");

var $lRmyA = parcelRequire("lRmyA");

var $3HCkE = parcelRequire("3HCkE");

const $694329614259616a$export$fa191d7d71460a98 = (0, $3HCkE.createResource)({
    type: (0, $05abdcb8189088ad$export$fd4fc70ec71927d1),
    getKey: ({ query: query })=>`jsm-legacy-automation-enabled-${query.projectKey}`,
    getData: async (_, { tenantContext: { licensedProducts: licensedProducts } })=>{
        const defaultValue = {
            enabled: true
        };
        if (!licensedProducts || !licensedProducts[(0, $e91YZ.LICENSED_PRODUCTS).JIRA_SERVICEDESK]) return defaultValue;
        const { enabled: enabled } = await (0, $lRmyA.performGetRequest)('/rest/servicedesk/automation/1/legacy/state');
        return {
            enabled: enabled
        };
    },
    maxAge: Infinity
});

});
const $05abdcb8189088ad$export$fd4fc70ec71927d1 = 'AUTOMATION_IS_LEGACY_ENABLED';


parcelRegister("gF5SK", function(module, exports) {

$parcel$export(module.exports, "newIssueViewTransitionLockInStatusResource", () => $43a0964905230dcb$export$babbf5bfbc4d268c);
$parcel$export(module.exports, "DEFAULT_TO_OLD_ISSUE_VIEW", () => $43a0964905230dcb$export$f269c0bf10ad77e2);
$parcel$export(module.exports, "useNewIssueViewLockedInStatus", () => $43a0964905230dcb$export$3b09097f2a423abd);

var $3HCkE = parcelRequire("3HCkE");


const $43a0964905230dcb$export$babbf5bfbc4d268c = (0, $3HCkE.createResource)({
    type: (0, $bf1b1f026fde1439$export$fdb92aeacda42553),
    getKey: ()=>'newIssueViewTransitionLockingStatus',
    getDataLoader: ()=>(parcelRequire("lh5Fx")),
    maxAge: Number.MAX_VALUE
});
const $43a0964905230dcb$export$7a0204710d322de6 = 'LOCK_IN_NEW_ISSUE_VIEW';
const $43a0964905230dcb$export$83f9ac2d887bd06a = 'DEFAULT_TO_NEW_ISSUE_VIEW';
const $43a0964905230dcb$export$f269c0bf10ad77e2 = 'DEFAULT_TO_OLD_ISSUE_VIEW';
const $43a0964905230dcb$export$3b09097f2a423abd = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $3HCkE.useResource)($43a0964905230dcb$export$babbf5bfbc4d268c);

});
const $bf1b1f026fde1439$export$fdb92aeacda42553 = 'NEW_ISSUE_VIEW_LOCK_IN_STATUS';

parcelRegister("lh5Fx", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('4VHyJ');
        const value = parcelRequire('e1dkv');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("4VHyJ").then(()=>parcelRequire('e1dkv'));
}

});


parcelRegister("fKYF0", function(module, exports) {

$parcel$export(module.exports, "persistentIssueCreateModalViewResource", () => $9179d1c8af5062b2$export$266a039a005e8314);

var $3HCkE = parcelRequire("3HCkE");


const $9179d1c8af5062b2$export$266a039a005e8314 = (0, $3HCkE.createResource)({
    type: (0, $9cf0ecd2babadcc5$export$f658cfd591eb583e),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("bu4do")),
    maxAge: Number.MAX_VALUE
});

});
const $9cf0ecd2babadcc5$export$15187a597cef02df = 'jira.user.gic.persistent.modal.view.state';
const $9cf0ecd2babadcc5$export$8977f91a75d8d265 = 'jira.user.gic.mini.modal.discoverability';
const $9cf0ecd2babadcc5$export$f658cfd591eb583e = 'RESOURCE_PERSISTENT_ISSUE_CREATE_MODAL_VIEW';

parcelRegister("bu4do", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('8V0MZ');
        const value = parcelRequire('9HgCP');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("8V0MZ").then(()=>parcelRequire('9HgCP'));
}

});


parcelRegister("grsJA", function(module, exports) {

$parcel$export(module.exports, "rovoEntitlementResource", () => $75c646b84cc2b8ad$export$a0974cf24d16bc5d);
$parcel$export(module.exports, "useRovoEntitlementResource", () => $75c646b84cc2b8ad$export$b9cee3799212b85a);

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $lRmyA = parcelRequire("lRmyA");

var $3HCkE = parcelRequire("3HCkE");

var $jwzNs = parcelRequire("jwzNs");

const $75c646b84cc2b8ad$var$RESOURCE_TYPE_ROVO_ENTITLEMENT = 'ROVO_ENTITLEMENT';
const $75c646b84cc2b8ad$var$fetchRovoEntitlement = async (cloudId)=>{
    try {
        const response = await (0, $lRmyA.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $3fb9e0f992806b04$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId
                }
            }),
            headers: {
                'content-type': 'application/json'
            }
        });
        // handle GraphQL errors
        if (response.errors) (0, $guiFP.default)({
            meta: {
                id: 'navigationResource',
                packageName: 'jiraRouterResourcesRovoEntitlement',
                teamName: 'ai-mate'
            },
            error: new Error(`RovoEntitlement Error. ${response.errors.map((error)=>error.message).join('; ')}; IsDataEmpty=${response.data?.jira === null || response.data?.jira === undefined}`),
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            isRovoEnabled: response.data?.jira?.isRovoEnabled ?? null
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'navigationResource',
                packageName: 'jiraRouterResourcesRovoEntitlement',
                teamName: 'ai-mate'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return {
        isRovoEnabled: null
    };
};
const $75c646b84cc2b8ad$export$a0974cf24d16bc5d = (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('jira.frontend.enable-rovo-entitlement-resource-router'), (0, $3HCkE.createResource)({
    type: $75c646b84cc2b8ad$var$RESOURCE_TYPE_ROVO_ENTITLEMENT,
    getKey: ()=>$75c646b84cc2b8ad$var$RESOURCE_TYPE_ROVO_ENTITLEMENT,
    getData: (_, { tenantContext: { cloudId: cloudId } })=>$75c646b84cc2b8ad$var$fetchRovoEntitlement(cloudId),
    maxAge: Infinity
}));
const $75c646b84cc2b8ad$export$b9cee3799212b85a = ()=>(0, $3HCkE.useResource)($75c646b84cc2b8ad$export$a0974cf24d16bc5d);

});
const $3fb9e0f992806b04$export$2b91517d6d5b4365 = `
query isRovoEnabledQuery($cloudId: ID!) {
  jira {
    isRovoEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence")
  }
}
`;


parcelRegister("3vlQh", function(module, exports) {

$parcel$export(module.exports, "incidentsInitialPageChecksResource", () => $51abc3777a1ecce4$export$b2b94ce8ba590cc8);
$parcel$export(module.exports, "incidentsCustomFieldIdResource", () => $51abc3777a1ecce4$export$e81d7afef87ae597);
$parcel$export(module.exports, "incidentExperimentTraitResource", () => $51abc3777a1ecce4$export$31c6945718067be3);

var $3HCkE = parcelRequire("3HCkE");


const $51abc3777a1ecce4$export$b2b94ce8ba590cc8 = (0, $3HCkE.createResource)({
    type: (0, $8c440df88740d3a4$export$9018fdf9116edd9b),
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("7S3F7"))
});

const $51abc3777a1ecce4$export$e81d7afef87ae597 = (0, $3HCkE.createResource)({
    type: (0, $8c440df88740d3a4$export$508a7d8e5c6b1bf),
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("lQxZQ"))
});

const $51abc3777a1ecce4$export$31c6945718067be3 = (0, $3HCkE.createResource)({
    type: (0, $8c440df88740d3a4$export$1d954e05e596a51e),
    getKey: ()=>'incident_experiment_traits',
    getDataLoader: ()=>(parcelRequire("1N8ub")),
    maxAge: Number.MAX_SAFE_INTEGER
});

});
const $8c440df88740d3a4$export$9018fdf9116edd9b = 'INCIDENTS_PAGE_INITIAL_CHECKS';
const $8c440df88740d3a4$export$508a7d8e5c6b1bf = 'INCIDENTS_PAGE_CUSTOM_FIELD_ID';
const $8c440df88740d3a4$export$1d954e05e596a51e = 'INCIDENT_EXPERIMENT_TRAITS';

parcelRegister("7S3F7", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('a5Zg4');
        const value = parcelRequire('dJRnz');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("a5Zg4").then(()=>parcelRequire('dJRnz'));
}

});

parcelRegister("lQxZQ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('kb1Sj');
        const value = parcelRequire('gZWJg');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("kb1Sj").then(()=>parcelRequire('gZWJg'));
}

});

parcelRegister("1N8ub", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('8856W');
        const value = parcelRequire('8XkTQ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("8856W").then(()=>parcelRequire('8XkTQ'));
}

});


parcelRegister("4uxD3", function(module, exports) {

$parcel$export(module.exports, "userHomepageResource", () => $08039d73d4df766b$export$16320dd0d1e6c145);

var $lRmyA = parcelRequire("lRmyA");

var $3HCkE = parcelRequire("3HCkE");

const $08039d73d4df766b$export$16320dd0d1e6c145 = (0, $3HCkE.createResource)({
    type: (0, $1af1518206a530c1$export$2026a6db44b15de7),
    getKey: ()=>'state',
    getData: async (_, { tenantContext: { baseUrl: baseUrl } })=>{
        const { homepagePreference: homepagePreference } = await (0, $lRmyA.performGetRequest)(`${baseUrl}/rest/internal/3/homepage/`);
        return {
            homepagePreference: homepagePreference
        };
    },
    maxAge: Infinity
});

});
const $1af1518206a530c1$export$2026a6db44b15de7 = 'USER_HOMEPAGE';



parcelRegister("8H1MT", function(module, exports) {

$parcel$export(module.exports, "markAsProductBundleReady", () => $ded70d904ebbb134$export$ff83c57004505abd);

var $2B87Z = parcelRequire("2B87Z");
const $ded70d904ebbb134$export$ff83c57004505abd = (importedBundle)=>{
    if (!false) importedBundle.then(()=>{
        (0, $2B87Z.setProductBundleReadyForInitialRender)();
    });
    return importedBundle;
};

});

parcelRegister("59o4i", function(module, exports) {

$parcel$export(module.exports, "LazyPage", () => $c08c786619b91fbf$export$a18c9c3dd309b8e6);

var $eUqFw = parcelRequire("eUqFw");

var $ae4LH = parcelRequire("ae4LH");

var $gUUjF = parcelRequire("gUUjF");

var $gGtKh = parcelRequire("gGtKh");

var $10fdS = parcelRequire("10fdS");

var $3dxBh = parcelRequire("3dxBh");

var $iJHZm = parcelRequire("iJHZm");
const $c08c786619b91fbf$var$LOCATION = 'lazy-page';
const $c08c786619b91fbf$export$fb85bbdbfb3e6869 = ()=>null;
const $c08c786619b91fbf$export$a18c9c3dd309b8e6 = ({ pageId: pageId, Page: Page, shouldShowSpinner: shouldShowSpinner = true })=>{
    const route = (0, $10fdS.useCurrentRoute)();
    const Skeleton = route.skeleton || (shouldShowSpinner ? (0, $ae4LH.default) : $c08c786619b91fbf$export$fb85bbdbfb3e6869);
    (0, $eUqFw.useEffect)(()=>{
        if (route.isRedirect) (0, $gUUjF.default).safeWarnWithoutCustomerData($c08c786619b91fbf$var$LOCATION, `LazyPage was used inside a redirect component: ${route.name}`);
    }, [
        route.isRedirect,
        route.name
    ]);
    return route.isRedirect ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "lazy_page_redirect",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Skeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Page, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dxBh.default), {
        pageId: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStateContainer), {
        isGlobal: true,
        appId: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStateAppStartWithMatchCheck), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "lazy_page",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Skeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Page, null))));
};

});
parcelRegister("ae4LH", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8ec192146c9348c$export$2e2bcd8739ae039);

var $foc4i = parcelRequire("foc4i");
var $d8ec192146c9348c$export$2e2bcd8739ae039 = (0, $foc4i.default);

});
parcelRegister("foc4i", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1a5746f64449d35$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4Bees = parcelRequire("4Bees");

var $84CBi = parcelRequire("84CBi");
function $e1a5746f64449d35$export$2e2bcd8739ae039({ testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $84CBi.default), {
        name: "legacy-spinner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e1a5746f64449d35$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e1a5746f64449d35$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "large",
        testId: testId
    }))));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e1a5746f64449d35$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _ae4v1h6o _4t3i1osq",
            __cmplp.className
        ])
    });
});
const $e1a5746f64449d35$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wpz1h6o",
            __cmplp.className
        ])
    });
});

});



parcelRegister("l8Yj1", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('godxh')
        ]);
        const value = parcelRequire('aaWUF');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("godxh")
    ]).then(()=>parcelRequire('aaWUF'));
}

});

parcelRegister("41B23", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('9GJax')
        ]);
        const value = parcelRequire('c2Xkt');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("9GJax")
    ]).then(()=>parcelRequire('c2Xkt'));
}

});

parcelRegister("5tL16", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('bdzSn')
        ]);
        const value = parcelRequire('k4ELZ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("bdzSn")
    ]).then(()=>parcelRequire('k4ELZ'));
}

});

parcelRegister("5irXx", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('8ODSr');
        const value = parcelRequire('i7Ah9');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("8ODSr").then(()=>parcelRequire('i7Ah9'));
}

});

parcelRegister("drCAA", function(module, exports) {

$parcel$export(module.exports, "advancedRoadmapsReduxStoreStateResource", () => $262a5ef8a7385098$export$6ca262338f199e4b);
$parcel$export(module.exports, "advancedRoadmapsScenarioIdResource", () => $262a5ef8a7385098$export$aec847b4ce72891);
$parcel$export(module.exports, "advancedRoadmapsPlanPageInitialChecksResource", () => $262a5ef8a7385098$export$7431e46c7ad56c3d);
$parcel$export(module.exports, "advancedRoadmapsPlanReportPageInitialChecksResource", () => $262a5ef8a7385098$export$bf0c5395c73cc255);
$parcel$export(module.exports, "advancedRoadmapsLastVisitedProgramBoardIdResource", () => $262a5ef8a7385098$export$f5b159e1fb19e04e);

var $lRmyA = parcelRequire("lRmyA");

var $3HCkE = parcelRequire("3HCkE");

const $262a5ef8a7385098$export$6ca262338f199e4b = (0, $3HCkE.createResource)({
    type: 'ADVANCED_ROADMAPS_REDUX_STORE_STATE',
    getKey: ({ match: match })=>{
        const { params: params, query: query } = match;
        if (params.planId != null && params.scenarioId != null) return `${params.planId}:${params.scenarioId}`;
        if (params.reportId != null) return params.reportId;
        if (query.r != null) return query.r;
        throw new Error('Unable to get resource key for ADVANCED_ROADMAPS_REDUX_STORE_STATE.');
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getData: async ()=>undefined,
    isBrowserOnly: true,
    // Invalidation is implemented here: src/packages/platform/ui/layouts/jira-plan-layout/src/ui/resources-invalidate/index.tsx
    maxAge: Infinity
});
const $262a5ef8a7385098$export$aec847b4ce72891 = (0, $3HCkE.createResource)({
    type: (0, $cf932f69308616f2$export$a0893d695ebee984),
    getKey: ({ query: query })=>`scenarioId_${query.id}`,
    getData: async ({ query: query })=>{
        const planId = query.id;
        const { id: id } = await (0, $lRmyA.performGetRequest)(`/rest/jpo/1.0/scenarios/${planId}`);
        return {
            scenarioId: id
        };
    },
    maxAge: 0
});
const $262a5ef8a7385098$export$7431e46c7ad56c3d = (0, $3HCkE.createResource)({
    type: (0, $cf932f69308616f2$export$68390102872336b6),
    getKey: ({ match: match })=>{
        const { planId: planId, scenarioId: scenarioId } = match.params;
        return `planPageInitialChecks_${planId != null ? planId : ''}_${scenarioId != null ? scenarioId : ''}`;
    },
    getData: async ({ match: match })=>{
        const { planId: planId, scenarioId: scenarioId } = match.params;
        // @ts-expect-error - TS2367 - This condition will always return 'false' since the types '"null"' and '"undefined"' have no overlap.
        if (planId == null || planId === 'null' && planId === 'undefined' && planId === '') throw new Error('Plan cannot be loaded without a planId');
        let url = `/rest/jpo/1.0/plans/${planId}/checks`;
        if (scenarioId != null && scenarioId !== 'null' && scenarioId !== 'undefined' && scenarioId !== '') url = `${url}?sid=${scenarioId}`;
        const response = await (0, $lRmyA.performGetRequest)(url);
        return response;
    },
    // Invalidation is implemented here: src/packages/platform/ui/layouts/jira-plan-layout/src/ui/resources-invalidate/index.tsx
    maxAge: Infinity
});
const $262a5ef8a7385098$export$bf0c5395c73cc255 = (0, $3HCkE.createResource)({
    type: (0, $cf932f69308616f2$export$a00e869cafd63140),
    getKey: ({ match: match })=>`planReportPageInitialChecks_${match.params.reportId == null ? '' : match.params.reportId}`,
    getData: async ({ match: match })=>{
        const initialPlanChecksPromise = window.__ARJ_INITIAL_PLAN_REPORT_CHECKS_PROMISE__;
        delete window.__ARJ_INITIAL_PLAN_REPORT_CHECKS_PROMISE__;
        if (initialPlanChecksPromise) {
            const response = await initialPlanChecksPromise;
            return response;
        }
        const { reportId: reportId } = match.params;
        const response = await (0, $lRmyA.performGetRequest)(`/rest/jpo/1.0/reportinfo/generic/${reportId == null ? '' : reportId}/checks`);
        return response;
    },
    // Invalidation is implemented here: src/packages/platform/ui/layouts/jira-plan-layout/src/ui/resources-invalidate/index.tsx
    maxAge: Infinity
});
const $262a5ef8a7385098$export$f5b159e1fb19e04e = (0, $3HCkE.createResource)({
    type: (0, $cf932f69308616f2$export$179a0d35e95a4d61),
    getKey: ({ query: query })=>`lastVisitedProgramBoardId_${query.id}`,
    getData: async ({ match: match })=>{
        const planId = match.params.planId;
        const defaultBoardIdResponse = await (0, $lRmyA.performGetRequest)(`/rest/jpo/2.0/plans/${planId}/increments/default`);
        if (defaultBoardIdResponse === null) return {
            boardId: null
        };
        const { id: id } = defaultBoardIdResponse;
        return {
            boardId: id
        };
    },
    maxAge: Infinity
});

});
const $cf932f69308616f2$export$68390102872336b6 = 'ADVANCED_ROADMAPS_PLAN_INITIAL_CHECKS';
const $cf932f69308616f2$export$a00e869cafd63140 = 'ADVANCED_ROADMAPS_REPORT_INITIAL_CHECKS';
const $cf932f69308616f2$export$a0893d695ebee984 = 'ADVANCED_ROADMAPS_SCENARIO_ID';
const $cf932f69308616f2$export$179a0d35e95a4d61 = 'ADVANCED_ROADMAPS_LAST_VISITED_PROGRAM_BOARD_ID';


parcelRegister("gkTS0", function(module, exports) {

$parcel$export(module.exports, "useAdvancedRoadmapsSummaryDataResource", () => $4e7b9fd5e056a541$export$263a4c831540778e);
$parcel$export(module.exports, "advancedRoadmapsSummaryDataResource", () => (parcelRequire("2nflD")).advancedRoadmapsSummaryDataResource);

var $3HCkE = parcelRequire("3HCkE");

var $2nflD = parcelRequire("2nflD");

var $lWLQU = parcelRequire("lWLQU");

var $1a561 = parcelRequire("1a561");
const $4e7b9fd5e056a541$export$263a4c831540778e = ()=>(0, $3HCkE.useResource)((0, $2nflD.advancedRoadmapsSummaryDataResource));

});
parcelRegister("2nflD", function(module, exports) {

$parcel$export(module.exports, "advancedRoadmapsSummaryDataResource", () => $931c853fe15a57ee$export$f9061628830b5175);
$parcel$export(module.exports, "fetchAdvancedRoadmapsSummaryData", () => $931c853fe15a57ee$export$2dfe99460dae6bc6);

var $2OdyW = parcelRequire("2OdyW");

var $3HCkE = parcelRequire("3HCkE");

var $lWLQU = parcelRequire("lWLQU");
// we have to use location.search as we want to get params dynamically and rrr doesn't support it
// more info: https://atlassian-labs.github.io/react-resource-router/#/resources/usage?id=accessing-resource-state-for-another-route-or-url
const $931c853fe15a57ee$var$getQueryParams = (routerQuery)=>{
    if (typeof window !== 'undefined') return Object.fromEntries(new URLSearchParams(window.location.search));
    return routerQuery;
};
const $931c853fe15a57ee$export$f9061628830b5175 = (0, $3HCkE.createResource)({
    type: 'ADVANCED_ROADMAPS_SUMMARY_DATA',
    getKey: ({ match: match })=>{
        const { params: params } = match;
        if (params.planId != null && params.scenarioId != null) return `${params.planId}:${params.scenarioId}`;
        // Just return fallback string if on a page that doesn't have a planId or scenarioId
        return 'none';
    },
    getData: async ({ match: match, query: query })=>{
        if (window.__ARJ_SUMMARY_PAGE_PROMISE__) {
            const response = window.__ARJ_SUMMARY_PAGE_PROMISE__;
            window.__ARJ_SUMMARY_PAGE_PROMISE__ = null;
            return response;
        }
        const { params: params } = match;
        return $931c853fe15a57ee$export$2dfe99460dae6bc6(params, query, (0, $lWLQU.AVAILABLE_CHARTS));
    },
    maxAge: Infinity,
    isBrowserOnly: true
});
const $931c853fe15a57ee$export$2dfe99460dae6bc6 = async (params, query, chartTypes)=>{
    if (params.planId == null) throw new Error('Unable to get fetch data for ADVANCED_ROADMAPS_SUMMARY_DATA. planId is not defined');
    const { startDate: startDate, endDate: endDate } = $931c853fe15a57ee$var$getQueryParams(query);
    const customDateRangeParams = startDate && endDate ? {
        startDate: startDate,
        endDate: endDate
    } : {};
    const data = await (0, $2OdyW.default)('/rest/jpo/1.0/summary/data', {
        method: 'POST',
        body: JSON.stringify({
            planId: params.planId,
            scenarioId: params.scenarioId,
            chartTypes: chartTypes,
            ...customDateRangeParams
        })
    });
    return data;
};

});
parcelRegister("lWLQU", function(module, exports) {

$parcel$export(module.exports, "CHART_TYPES", () => $a9c3b544ebce997d$export$3251435144ca69e2);
$parcel$export(module.exports, "AVAILABLE_CHARTS", () => $a9c3b544ebce997d$export$79cf9c14f738d70b);
$parcel$export(module.exports, "SCHEDULING_MODES", () => $a9c3b544ebce997d$export$92daf59e30346cd2);
$parcel$export(module.exports, "CAPACITY_UNIT", () => $a9c3b544ebce997d$export$494e761f17fc60a9);
$parcel$export(module.exports, "SPRINT_STATE", () => $a9c3b544ebce997d$export$38e437924c2adbda);
const $a9c3b544ebce997d$export$3251435144ca69e2 = {
    statusCategory: 'STATUS_CATEGORY',
    issueProgress: 'ISSUE_PROGRESS',
    teamProgress: 'TEAM_PROGRESS',
    teamCapacity: 'TEAM_CAPACITY',
    blockers: 'BLOCKERS',
    highestPriority: 'HIGHEST_PRIORITY',
    unassignedIssues: 'UNASSIGNED_ISSUES',
    overlappingBlockers: 'OVERLAPPING_BLOCKERS',
    overdue: 'OVERDUE'
};
const $a9c3b544ebce997d$export$79cf9c14f738d70b = [
    $a9c3b544ebce997d$export$3251435144ca69e2.statusCategory,
    $a9c3b544ebce997d$export$3251435144ca69e2.issueProgress,
    $a9c3b544ebce997d$export$3251435144ca69e2.teamProgress,
    $a9c3b544ebce997d$export$3251435144ca69e2.teamCapacity,
    $a9c3b544ebce997d$export$3251435144ca69e2.blockers,
    $a9c3b544ebce997d$export$3251435144ca69e2.highestPriority,
    $a9c3b544ebce997d$export$3251435144ca69e2.unassignedIssues,
    $a9c3b544ebce997d$export$3251435144ca69e2.overlappingBlockers,
    $a9c3b544ebce997d$export$3251435144ca69e2.overdue
];
const $a9c3b544ebce997d$export$92daf59e30346cd2 = {
    SCRUM: 'Scrum',
    KANBAN: 'Kanban'
};
const $a9c3b544ebce997d$export$494e761f17fc60a9 = {
    HOURS: 'HOURS',
    POINTS: 'STORY_POINTS',
    DAYS: 'DAYS'
};
const $a9c3b544ebce997d$export$38e437924c2adbda = {
    CLOSED: 'CLOSED',
    ACTIVE: 'ACTIVE',
    FUTURE: 'FUTURE'
};

});


parcelRegister("1a561", function(module, exports) {

$parcel$export(module.exports, "IssueStatus", () => $678e60d282defedb$export$559eb15a98685419);
$parcel$export(module.exports, "BlockType", () => $678e60d282defedb$export$48808c686fe495c4);
const $678e60d282defedb$export$559eb15a98685419 = {
    TODO: 'TODO',
    IN_PROGRESS: 'IN_PROGRESS',
    DONE: 'DONE'
};
const $678e60d282defedb$export$de194318c6dccbc1 = {
    INITIATIVE: 'INITIATIVE',
    EPIC: 'EPIC'
};
const $678e60d282defedb$export$48808c686fe495c4 = {
    DELAY_WORK: 'DELAY_WORK',
    CRITICAL_PATH: 'CRITICAL_PATH',
    BLOCK_WORK: 'BLOCK_WORK'
};

});


parcelRegister("atRHQ", function(module, exports) {

$parcel$export(module.exports, "ScreenRedirect", () => $8157686ea09e4eda$export$fdd3e60cd227c2f7);

var $eUqFw = parcelRequire("eUqFw");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");

var $78d1w = parcelRequire("78d1w");
const $8157686ea09e4eda$export$fdd3e60cd227c2f7 = ({ to: to, persistSearchParams: persistSearchParams = true })=>{
    const [{ route: route, location: location, query: query }] = (0, $kJlBc.useRouter)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [{ isInitialRender: isInitial }] = (0, $78d1w.useSpaStateTransition)();
    const eventRef = (0, $eUqFw.useRef)(createAnalyticsEvent({}));
    (0, $eUqFw.useEffect)(()=>{
        if (!route || !eventRef.current) return;
        (0, $jMP2a.fireUIAnalytics)(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        route,
        isInitial
    ]);
    if (Array.isArray(persistSearchParams)) {
        const persistParams = Object.keys(query) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((result, currentKey)=>{
            const shouldPersist = persistSearchParams.some((persistKey)=>currentKey.includes(persistKey));
            if (shouldPersist) result.push(`${currentKey}=${query[currentKey]}`);
            return result;
        }, []).join('&');
        if (persistParams !== '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
            to: `${to}?${persistParams}`
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
            to: to
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
        to: `${to}${persistSearchParams ? location.search : ''}`
    });
};

});

parcelRegister("7u7sK", function(module, exports) {

$parcel$export(module.exports, "CalendarSkeleton", () => $4857ea87a5142e4b$export$ebc7c47cc535837e);
$parcel$export(module.exports, "CalendarEmbedSkeleton", () => $4857ea87a5142e4b$export$bf543fe31d33292e);
$parcel$export(module.exports, "CalendarNoHeaderSkeleton", () => $4857ea87a5142e4b$export$504e7b05f3c54bf2);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");

var $4ZEZX = parcelRequire("4ZEZX");

var $btvOd = parcelRequire("btvOd");

var $kIc9G = parcelRequire("kIc9G");
const $4857ea87a5142e4b$var$customCssStyles = null;
const $4857ea87a5142e4b$export$ebc7c47cc535837e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4ZEZX)))
    });
const $4857ea87a5142e4b$export$bf543fe31d33292e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($btvOd)))
    });
const $4857ea87a5142e4b$export$504e7b05f3c54bf2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kIc9G))),
        className: (0, $7JEyt.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("8ICxF", function(module, exports) {

$parcel$export(module.exports, "AppSkeletonImage", () => $f467e6485d9792e8$export$45b107c5dc7b51a5);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /* eslint-disable jira/react/no-classname-attribute */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");


var $5JgJ2 = parcelRequire("5JgJ2");

var $84CBi = parcelRequire("84CBi");

var $h1hCM = parcelRequire("h1hCM");
const $f467e6485d9792e8$var$skeletonImageStyles = null;
const $f467e6485d9792e8$export$45b107c5dc7b51a5 = ({ src: src, className: className, containerStyles: containerStyles })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $84CBi.default), {
        name: "app-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f467e6485d9792e8$var$SkeletonWrapper // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    , {
        style: containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        src: src,
        alt: `${formatMessage((0, $h1hCM.default).loading)}...`,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _vchhusvi _1bsb1osq _1dqonqa1 _1h6d3acm _t6vd1ylp _hr4j1ylp _l82tgktf _j7o0gktf",
            className
        ])
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f467e6485d9792e8$var$SkeletonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bsb1osq _4t3i1osq _yksp1ssb _1b421ssb _s8ks18ws _u1wz1nty",
            __cmplp.className
        ])
    });
});

});
parcelRegister("h1hCM", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b5b2a6284984f9f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0b5b2a6284984f9f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    loading: {
        "id": "skeletons.common.loading",
        "defaultMessage": "Loading"
    }
});

});


parcelRegister("4ZEZX", function(module, exports) {
module.exports = new URL("calendar-app-skeleton.tpl.77b09222.svg", import.meta.url).toString();

});

parcelRegister("btvOd", function(module, exports) {
module.exports = new URL("calendar-embed-app-skeleton.tpl.29c9a641.svg", import.meta.url).toString();

});

parcelRegister("kIc9G", function(module, exports) {
module.exports = new URL("calendar-no-header-skeleton.tpl.d6779107.svg", import.meta.url).toString();

});


parcelRegister("kY36r", function(module, exports) {

$parcel$export(module.exports, "ErrorScreen", () => $220a22efab60ac1e$export$42f84e610f279c31);

var $eUqFw = parcelRequire("eUqFw");

var $iPDOm = parcelRequire("iPDOm");


var $gJ90Q = parcelRequire("gJ90Q");

var $j7WTV = parcelRequire("j7WTV");

var $56LD8 = parcelRequire("56LD8");
const $220a22efab60ac1e$export$42f84e610f279c31 = ({ errorMessage: errorMessage, isEmbedded: isEmbedded = false, planId: planId })=>{
    /**
	 * Clearing the early-preload promises here otherwise they get carried on to the following plan loads.
	 *
	 * The SPA app renders the ErrorScreen instead of the PlanApp when the validation fails,
	 * hence the early-preload promises did not get cleaned up.
	 */ delete window.__ARJ_BACKLOG_PROMISE__;
    delete window.__ARJ_INFO_METADATA_PROMISE__;
    switch(errorMessage){
        case 0, $8d03d4da5621444c$export$aa64437890e7b596:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iPDOm.RedirectToLoginPage), null);
        case 0, $8d03d4da5621444c$export$3fe2400c9d24940d:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gJ90Q.AsyncLicenseViolationErrorPage), {
                isEmbedded: isEmbedded
            });
        case 0, $8d03d4da5621444c$export$4589763db20bfd7f:
        case 0, $8d03d4da5621444c$export$7e6358a0c21dff8c:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $56LD8.AsyncNotFoundErrorPage), {
                entity: (0, $8d03d4da5621444c$export$c303e491e026ebc6),
                isEmbedded: isEmbedded
            });
        case 0, $8d03d4da5621444c$export$6519152a5f0e081:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $56LD8.AsyncNotFoundErrorPage), {
                entity: (0, $8d03d4da5621444c$export$9b928fc5e710e864),
                isEmbedded: isEmbedded,
                planId: planId
            });
        case 0, $8d03d4da5621444c$export$6128dc888243fa0a:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j7WTV.AsyncNoPlanPermissionErrorPage), {
                isEmbedded: isEmbedded
            });
        default:
            return null;
    }
};

});
parcelRegister("iPDOm", function(module, exports) {

$parcel$export(module.exports, "RedirectToLoginPage", () => $24cf6e57d181201a$export$938182bd3fddc3a8);

var $eUqFw = parcelRequire("eUqFw");

var $kJlBc = parcelRequire("kJlBc");
const $24cf6e57d181201a$export$3da29de62ed7a388 = ({ to: to })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("script", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `window.location.assign("${to}")`
        }
    });
$24cf6e57d181201a$export$3da29de62ed7a388.displayName = 'InlineRedirect';
const $24cf6e57d181201a$export$938182bd3fddc3a8 = ()=>{
    const [{ location: { pathname: pathname, search: search } }] = (0, $kJlBc.useRouter)();
    const redirectUrl = pathname + search;
    const encodedRedirectUrl = encodeURIComponent(redirectUrl);
    let path = `/login.jsp?os_destination=${encodedRedirectUrl}`;
    const parentProductQueryName = 'parentProduct';
    const [parentProduct] = (0, $kJlBc.useQueryParam)(parentProductQueryName);
    if (pathname.endsWith('/embed')) {
        const searchParams = new URLSearchParams(search);
        // We need to remove parentProduct param as it is only used in embed urls
        searchParams.delete(parentProductQueryName);
        /**
		 * encodedLink is the link to the non embedded version of the embed url.
		 * So, we strip out the /embed suffix from path
		 */ let encodedLink = encodeURIComponent(`${pathname.slice(0, -6)}?${searchParams}`);
        /**
		 * this is the specific case for create issue embed, where we need to redirect
		 * user to your-work page with create issue as true to open GIC by default.
		 * We will remove this when we FPIC exp implemented for GIC
		 */ if (pathname.includes('/issues/create')) encodedLink = encodeURIComponent('/jira/your-work?createissue=true');
        const encodedParentProduct = encodeURIComponent(parentProduct || '');
        path = `/jira-login/embed?destination=${encodedRedirectUrl}&link=${encodedLink}&parentProduct=${encodedParentProduct}`;
    }
    return false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($24cf6e57d181201a$export$3da29de62ed7a388, {
        to: path
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
        to: path
    });
};

});

const $8d03d4da5621444c$export$aa64437890e7b596 = 'permission-violation';
const $8d03d4da5621444c$export$3fe2400c9d24940d = 'license-violation';
const $8d03d4da5621444c$export$4589763db20bfd7f = 'plan-not-found';
const $8d03d4da5621444c$export$6519152a5f0e081 = 'scenario-not-found';
const $8d03d4da5621444c$export$7e6358a0c21dff8c = 'report-not-found';
const $8d03d4da5621444c$export$6128dc888243fa0a = 'no-plan-permission';
const $8d03d4da5621444c$export$c303e491e026ebc6 = 'PLAN';
const $8d03d4da5621444c$export$9b928fc5e710e864 = 'SCENARIO';

parcelRegister("gJ90Q", function(module, exports) {

$parcel$export(module.exports, "AsyncLicenseViolationErrorPage", () => $8f5ef6322d0898d5$export$f5d9764f07badc4d);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ae4LH = parcelRequire("ae4LH");

var $gGtKh = parcelRequire("gGtKh");

const $8f5ef6322d0898d5$var$LazyLicenseViolationErrorPage = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("71Qj2N")), {
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/error-screens/license-violation/index.tsx"
});
const $8f5ef6322d0898d5$export$f5d9764f07badc4d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "arj-license-violation-page",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ae4LH.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8f5ef6322d0898d5$var$LazyLicenseViolationErrorPage, props));

});
parcelRegister("71Qj2N", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('k7a6k');
        const value = parcelRequire('3sYfH');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("k7a6k").then(()=>parcelRequire('3sYfH'));
}

});


parcelRegister("j7WTV", function(module, exports) {

$parcel$export(module.exports, "AsyncNoPlanPermissionErrorPage", () => $6292c7684217b71b$export$e595d2c5dfcb1d5a);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ae4LH = parcelRequire("ae4LH");

var $gGtKh = parcelRequire("gGtKh");

const $6292c7684217b71b$var$LazyNoPlanPermissionErrorPage = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("4yijb")), {
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/error-screens/no-plan-permission/index.tsx"
});
const $6292c7684217b71b$export$e595d2c5dfcb1d5a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "arj-no-plan-permission",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ae4LH.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6292c7684217b71b$var$LazyNoPlanPermissionErrorPage, props));

});
parcelRegister("4yijb", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('g3qA9');
        const value = parcelRequire('ej61u');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("g3qA9").then(()=>parcelRequire('ej61u'));
}

});


parcelRegister("56LD8", function(module, exports) {

$parcel$export(module.exports, "AsyncNotFoundErrorPage", () => $4b17eba9ce2cb43d$export$8f6c907860218fdc);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ae4LH = parcelRequire("ae4LH");

var $gGtKh = parcelRequire("gGtKh");

const $4b17eba9ce2cb43d$var$LazyNotFoundErrorPage = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("6N8bY")), {
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/error-screens/not-found/index.tsx"
});
const $4b17eba9ce2cb43d$export$8f6c907860218fdc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "arj-not-found-page",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ae4LH.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4b17eba9ce2cb43d$var$LazyNotFoundErrorPage, props));

});
parcelRegister("6N8bY", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('8gIej');
        const value = parcelRequire('jgj8N');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("8gIej").then(()=>parcelRequire('jgj8N'));
}

});



parcelRegister("7okz2", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0717b3ae49c7e5d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $av9ef = parcelRequire("av9ef");

var $9RvDp = parcelRequire("9RvDp");

const $f0717b3ae49c7e5d$var$LazyGlobalProductsSettingsSidebar = (0, $7rh0R.lazyAfterPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("6qdWI")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-products/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f0717b3ae49c7e5d$var$GlobalProductsSettingsSidebar = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "globalProductsSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f0717b3ae49c7e5d$var$LazyGlobalProductsSettingsSidebar, null)));
$f0717b3ae49c7e5d$var$GlobalProductsSettingsSidebar.displayName = 'GlobalProductsSettingsSidebar';
var $f0717b3ae49c7e5d$export$2e2bcd8739ae039 = $f0717b3ae49c7e5d$var$GlobalProductsSettingsSidebar;

});
parcelRegister("6qdWI", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('2YKQC')
        ]);
        const value = parcelRequire('gla7s');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("2YKQC")
    ]).then(()=>parcelRequire('gla7s'));
}

});


parcelRegister("2hHs5", function(module, exports) {

$parcel$export(module.exports, "issueLinkInformationResource", () => $9d58ed9c9b378fc4$export$8d8544ca08d98837);

var $lRmyA = parcelRequire("lRmyA");

var $3HCkE = parcelRequire("3HCkE");
const $9d58ed9c9b378fc4$var$body = {
    providers: [
        'issueLinks',
        'dependencySettings'
    ]
};
const $9d58ed9c9b378fc4$var$url = '/rest/jpo/1.0/info/query';
const $9d58ed9c9b378fc4$var$fetchIssueLinkInformation = ()=>(0, $lRmyA.performPostRequest)($9d58ed9c9b378fc4$var$url, {
        body: JSON.stringify($9d58ed9c9b378fc4$var$body)
    });
const $9d58ed9c9b378fc4$export$8d8544ca08d98837 = (0, $3HCkE.createResource)({
    type: 'ISSUE_LINK_INFORMATION',
    getKey: ()=>'issue-link-information',
    getData: async ()=>$9d58ed9c9b378fc4$var$fetchIssueLinkInformation(),
    maxAge: 0
});

});

parcelRegister("7XGBt", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('8nU3l')
        ]);
        const value = parcelRequire('lLYDp');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("8nU3l")
    ]).then(()=>parcelRequire('lLYDp'));
}

});

parcelRegister("gubiX", function(module, exports) {

$parcel$export(module.exports, "arjSettingsLoadingLimitsResource", () => $68a24dd0c5af1f99$export$c9e47fa9b57975f5);

var $2OdyW = parcelRequire("2OdyW");

var $3HCkE = parcelRequire("3HCkE");

const $68a24dd0c5af1f99$export$c9e47fa9b57975f5 = (0, $3HCkE.createResource)({
    type: (0, $7f69e5697ecce36f$export$cd7bb91dd2e30684),
    getKey: ()=>'loading-limits-information',
    getData: async ()=>(0, $2OdyW.default)('/rest/jpo/1.0/configuration'),
    maxAge: 0
});

});
const $7f69e5697ecce36f$export$cd7bb91dd2e30684 = 'RESOURCE_TYPE_ARJ_SETTINGS_LOADING_LIMITS';


parcelRegister("2kw2s", function(module, exports) {






if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("1BO4o")),
            load('h2MrD'),
            load('bYT2S'),
            load('1ROi0')
        ]);
        const value = parcelRequire('94dCk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("1BO4o")),
        load("h2MrD"),
        load("bYT2S"),
        load("1ROi0")
    ]).then(()=>parcelRequire('94dCk'));
}

});

parcelRegister("bFKDs", function(module, exports) {

$parcel$export(module.exports, "grantedPermissionsResource", () => $6719c1a3cb6e3b84$export$aa3daf3280e2a2d7);
$parcel$export(module.exports, "permissionGroupsResource", () => $6719c1a3cb6e3b84$export$950060d83722e3bd);
$parcel$export(module.exports, "getGlobalPermissionPageResources", () => $6719c1a3cb6e3b84$export$a09a91246a866817);

var $lRmyA = parcelRequire("lRmyA");

var $3HCkE = parcelRequire("3HCkE");
const $6719c1a3cb6e3b84$var$fetchGrantedPermissions = ()=>(0, $lRmyA.performPostRequest)('/rest/roadmaps/1.0/info/query', {
        body: JSON.stringify({
            providers: [
                'permissions'
            ]
        })
    });
const $6719c1a3cb6e3b84$var$fetchPermissionGroups = ()=>(0, $lRmyA.performPostRequest)('/rest/jpo/1.0/groupsandusers', {
        body: JSON.stringify({
            includeUsers: false,
            excludedGroups: [],
            excludedUsers: [],
            query: ''
        })
    });
const $6719c1a3cb6e3b84$export$aa3daf3280e2a2d7 = (0, $3HCkE.createResource)({
    type: 'ARJ_GLOBAL_PERMISSIONS_GRANTED',
    getKey: ()=>'arj-granted-permissions',
    getData: async ()=>$6719c1a3cb6e3b84$var$fetchGrantedPermissions(),
    maxAge: 0
});
const $6719c1a3cb6e3b84$export$950060d83722e3bd = (0, $3HCkE.createResource)({
    type: 'ARJ_GLOBAL_PERMISSIONS_GROUPS',
    getKey: ()=>'arj-permission-groups',
    getData: async ()=>$6719c1a3cb6e3b84$var$fetchPermissionGroups(),
    maxAge: 0
});
const $6719c1a3cb6e3b84$export$a09a91246a866817 = ()=>[
        $6719c1a3cb6e3b84$export$aa3daf3280e2a2d7,
        $6719c1a3cb6e3b84$export$950060d83722e3bd
    ];

});

parcelRegister("77CB1", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('9iacf')
        ]);
        const value = parcelRequire('7cRws');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("9iacf")
    ]).then(()=>parcelRequire('7cRws'));
}

});

parcelRegister("1IXLY", function(module, exports) {

$parcel$export(module.exports, "arjSettingsFinancialYearResource", () => $0a4ae8dde0bbec27$export$da45020eede4a793);

var $2OdyW = parcelRequire("2OdyW");

var $3HCkE = parcelRequire("3HCkE");

const $0a4ae8dde0bbec27$export$da45020eede4a793 = (0, $3HCkE.createResource)({
    type: (0, $24ee3162ec5c4e32$export$e8e0384e95388aa3),
    getKey: ()=>'financial-year-information',
    getData: async ()=>(0, $2OdyW.default)('/rest/jpo/1.0/fiscalYear'),
    maxAge: 0
});

});
const $24ee3162ec5c4e32$export$e8e0384e95388aa3 = 'RESOURCE_TYPE_ARJ_SETTINGS_FINANCIAL_YEAR';


parcelRegister("fgcXI", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('bvf7s')
        ]);
        const value = parcelRequire('2O1O3');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("bvf7s")
    ]).then(()=>parcelRequire('2O1O3'));
}

});

parcelRegister("5jZUn", function(module, exports) {










if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
            load('hPzOn'),
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("8vJAP")),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('3uPZc')
        ]);
        const value = parcelRequire('7pkjG');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
        load("hPzOn"),
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("8vJAP")),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("3uPZc")
    ]).then(()=>parcelRequire('7pkjG'));
}

});

parcelRegister("jgO4O", function(module, exports) {










if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
            load('hPzOn'),
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("evO9a")),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('PsLDL')
        ]);
        const value = parcelRequire('aPJLZ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
        load("hPzOn"),
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("evO9a")),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("PsLDL")
    ]).then(()=>parcelRequire('aPJLZ'));
}

});

parcelRegister("ksN5x", function(module, exports) {






if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('45cDo')
        ]);
        const value = parcelRequire('7xALK');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("45cDo")
    ]).then(()=>parcelRequire('7xALK'));
}

});

parcelRegister("6oPFD", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('j1ukD')
        ]);
        const value = parcelRequire('6kwuy');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("j1ukD")
    ]).then(()=>parcelRequire('6kwuy'));
}

});

parcelRegister("hgBVx", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('6TPFB')
        ]);
        const value = parcelRequire('75pp3');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("6TPFB")
    ]).then(()=>parcelRequire('75pp3'));
}

});

parcelRegister("6ooLx", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('kfclh');
        const value = parcelRequire('eU9Vv');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("kfclh").then(()=>parcelRequire('eU9Vv'));
}

});

parcelRegister("9XeW0", function(module, exports) {

$parcel$export(module.exports, "usePlan", () => $158ef0a3b70c837e$export$6734677f23034ac5);
$parcel$export(module.exports, "useSidebarVisibility", () => $158ef0a3b70c837e$export$332ba301dbc47d7d);

var $1ybV0 = parcelRequire("1ybV0");

var $I0t4m = parcelRequire("I0t4m");

var $3HCkE = parcelRequire("3HCkE");

var $8mP0X = parcelRequire("8mP0X");
const $158ef0a3b70c837e$var$OFF = 'Off';
const $158ef0a3b70c837e$var$EAP = 'EAP';
const $158ef0a3b70c837e$var$GA = 'GA';
const $158ef0a3b70c837e$var$getPlanSidebarNavigationJiraLabsVariation = ()=>(0, $1ybV0.getMultivariateFeatureFlag)('com.atlassian.rm.jpo.sidebar-navigation-jira-labs-variations', $158ef0a3b70c837e$var$OFF, [
        $158ef0a3b70c837e$var$OFF,
        $158ef0a3b70c837e$var$EAP,
        $158ef0a3b70c837e$var$GA
    ]);
const $158ef0a3b70c837e$var$isPlanSidebarNavigationEAPEnabled = ()=>{
    const variation = $158ef0a3b70c837e$var$getPlanSidebarNavigationJiraLabsVariation();
    return variation === $158ef0a3b70c837e$var$EAP;
};
const $158ef0a3b70c837e$var$isPlanSidebarNavigationGAEnabled = ()=>{
    const variation = $158ef0a3b70c837e$var$getPlanSidebarNavigationJiraLabsVariation();
    return variation === $158ef0a3b70c837e$var$GA;
};
const $158ef0a3b70c837e$export$6734677f23034ac5 = ()=>(0, $3HCkE.useResource)((0, $I0t4m.staticPlanSidebarNavigationResource));
const $158ef0a3b70c837e$export$332ba301dbc47d7d = ()=>{
    const { data: data } = (0, $3HCkE.useResource)((0, $8mP0X.planSidebarNavigationOptInStatusResources));
    return {
        isSidebarVisible: ($158ef0a3b70c837e$var$isPlanSidebarNavigationEAPEnabled() && data?.planSidebarNavigationOptInStatus?.isEnabled || $158ef0a3b70c837e$var$isPlanSidebarNavigationGAEnabled()) ?? false
    };
};

});

parcelRegister("bgHcd", function(module, exports) {










if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
            load('hPzOn'),
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("8ePcQ")),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('gnIGE')
        ]);
        const value = parcelRequire('2l3mS');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
        load("hPzOn"),
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("8ePcQ")),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("gnIGE")
    ]).then(()=>parcelRequire('2l3mS'));
}

});

parcelRegister("5t5Yk", function(module, exports) {










if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
            load('hPzOn'),
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("bwmRk")),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('pYL3A')
        ]);
        const value = parcelRequire('h6tmI');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
        load("hPzOn"),
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("bwmRk")),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("pYL3A")
    ]).then(()=>parcelRequire('h6tmI'));
}

});

parcelRegister("jxxS2", function(module, exports) {














if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("2Umqd")),
            load('hPzOn'),
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("ePvPQ")),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('hYLEn')
        ]);
        const value = parcelRequire('lPX3R');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("2Umqd")),
        load("hPzOn"),
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("ePvPQ")),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("hYLEn")
    ]).then(()=>parcelRequire('lPX3R'));
}

});

parcelRegister("iWCsF", function(module, exports) {














if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("2mb6O")),
            load('hPzOn'),
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("1lGLx")),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('dJ72D')
        ]);
        const value = parcelRequire('aoHrD');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("2mb6O")),
        load("hPzOn"),
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("1lGLx")),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("dJ72D")
    ]).then(()=>parcelRequire('aoHrD'));
}

});

parcelRegister("6E8OP", function(module, exports) {






if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('jU5cl')
        ]);
        const value = parcelRequire('4PQoa');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("jU5cl")
    ]).then(()=>parcelRequire('4PQoa'));
}

});

parcelRegister("G0uWI", function(module, exports) {










if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
            load('hPzOn'),
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("kh1bM")),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('ptZGV')
        ]);
        const value = parcelRequire('8jLuY');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
        load("hPzOn"),
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("kh1bM")),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("ptZGV")
    ]).then(()=>parcelRequire('8jLuY'));
}

});

parcelRegister("bEwnA", function(module, exports) {










if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
            load('hPzOn'),
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("7oP8I")),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('7UeDc')
        ]);
        const value = parcelRequire('2r517');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
        load("hPzOn"),
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("7oP8I")),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("7UeDc")
    ]).then(()=>parcelRequire('2r517'));
}

});

parcelRegister("bwqq9", function(module, exports) {










if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
            load('hPzOn'),
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("5WtaL")),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('hY7fE')
        ]);
        const value = parcelRequire('8cXcl');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
        load("hPzOn"),
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("5WtaL")),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("hY7fE")
    ]).then(()=>parcelRequire('8cXcl'));
}

});

parcelRegister("6fMSz", function(module, exports) {










if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
            load('hPzOn'),
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("4oETm")),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('kXYR5')
        ]);
        const value = parcelRequire('9EF5X');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
        load("hPzOn"),
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("4oETm")),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("kXYR5")
    ]).then(()=>parcelRequire('9EF5X'));
}

});

parcelRegister("56upb", function(module, exports) {






if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('c2493')
        ]);
        const value = parcelRequire('iHcu1');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("c2493")
    ]).then(()=>parcelRequire('iHcu1'));
}

});

parcelRegister("3TT6a", function(module, exports) {










if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
            load('hPzOn'),
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("4Djtf")),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('hgVla')
        ]);
        const value = parcelRequire('4QFbC');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
        load("hPzOn"),
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("4Djtf")),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("hgVla")
    ]).then(()=>parcelRequire('4QFbC'));
}

});

parcelRegister("lwLYs", function(module, exports) {










if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
            load('hPzOn'),
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("1W2DI")),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('2SvhN')
        ]);
        const value = parcelRequire('glloL');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
        load("hPzOn"),
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("1W2DI")),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("2SvhN")
    ]).then(()=>parcelRequire('glloL'));
}

});

parcelRegister("9gTeT", function(module, exports) {










if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
            load('hPzOn'),
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("hoJwf")),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('99Oli')
        ]);
        const value = parcelRequire('geFkB');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
        load("hPzOn"),
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("hoJwf")),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("99Oli")
    ]).then(()=>parcelRequire('geFkB'));
}

});

parcelRegister("b8yEP", function(module, exports) {






if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('dGIzi')
        ]);
        const value = parcelRequire('hDxMY');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("dGIzi")
    ]).then(()=>parcelRequire('hDxMY'));
}

});

parcelRegister("1gTbW", function(module, exports) {










if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
            load('hPzOn'),
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("eb0fg")),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('gEJuJ')
        ]);
        const value = parcelRequire('bjynb');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
        load("hPzOn"),
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("eb0fg")),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("gEJuJ")
    ]).then(()=>parcelRequire('bjynb'));
}

});

parcelRegister("ddqVC", function(module, exports) {










if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
            load('hPzOn'),
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("dRDIs")),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('Ct84v')
        ]);
        const value = parcelRequire('lv2HB');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
        load("hPzOn"),
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("dRDIs")),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("Ct84v")
    ]).then(()=>parcelRequire('lv2HB'));
}

});

parcelRegister("dZ2N4", function(module, exports) {










if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
            load('hPzOn'),
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("lb5Ks")),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('8CrLw')
        ]);
        const value = parcelRequire('a9v6r');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
        load("hPzOn"),
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("lb5Ks")),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("8CrLw")
    ]).then(()=>parcelRequire('a9v6r'));
}

});

parcelRegister("1NAsW", function(module, exports) {










if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
            load('hPzOn'),
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("4DgQX")),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('02sgc')
        ]);
        const value = parcelRequire('2r58p');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
        load("hPzOn"),
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("4DgQX")),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("02sgc")
    ]).then(()=>parcelRequire('2r58p'));
}

});

parcelRegister("5lrtf", function(module, exports) {






if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('8F6wY')
        ]);
        const value = parcelRequire('aRFns');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("8F6wY")
    ]).then(()=>parcelRequire('aRFns'));
}

});

parcelRegister("9wxkI", function(module, exports) {














if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("1qTqU")),
            load('hPzOn'),
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("8dfFH")),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('eza3I')
        ]);
        const value = parcelRequire('hGGgn');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("1qTqU")),
        load("hPzOn"),
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("8dfFH")),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("eza3I")
    ]).then(()=>parcelRequire('hGGgn'));
}

});

parcelRegister("lMn31", function(module, exports) {










if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
            load('hPzOn'),
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("dxwAW")),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('as1Nk')
        ]);
        const value = parcelRequire('khSpT');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("cdg8w")),
        load("hPzOn"),
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("dxwAW")),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("as1Nk")
    ]).then(()=>parcelRequire('khSpT'));
}

});

parcelRegister("84X8A", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('l2PoJ')
        ]);
        const value = parcelRequire('l4WNO');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("l2PoJ")
    ]).then(()=>parcelRequire('l4WNO'));
}

});

parcelRegister("g3V3V", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('dwAE9');
        const value = parcelRequire('dpU8X');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("dwAE9").then(()=>parcelRequire('dpU8X'));
}

});

parcelRegister("7hF3Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $707f9bf31c05907b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $av9ef = parcelRequire("av9ef");

var $9RvDp = parcelRequire("9RvDp");

const $707f9bf31c05907b$var$LazyGlobalProjectsSettingsSidebar = (0, $7rh0R.lazyAfterPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("fFnZx")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-projects/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $707f9bf31c05907b$var$GlobalProjectsSettingsSidebar = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "globalProjectsSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($707f9bf31c05907b$var$LazyGlobalProjectsSettingsSidebar, null)));
$707f9bf31c05907b$var$GlobalProjectsSettingsSidebar.displayName = 'GlobalProjectsSettingsSidebar';
var $707f9bf31c05907b$export$2e2bcd8739ae039 = $707f9bf31c05907b$var$GlobalProjectsSettingsSidebar;

});
parcelRegister("fFnZx", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('kWP1Y')
        ]);
        const value = parcelRequire('a6QRE');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("kWP1Y")
    ]).then(()=>parcelRequire('a6QRE'));
}

});


parcelRegister("fvgG5", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('bn05E')
        ]);
        const value = parcelRequire('bP5Jr');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("bn05E")
    ]).then(()=>parcelRequire('bP5Jr'));
}

});

parcelRegister("d1szd", function(module, exports) {

$parcel$export(module.exports, "genericProjectLayout", () => $4949b32bbf913e83$export$85dad8e9886563f6);

var $iZnNg = parcelRequire("iZnNg");

var $isbb2 = parcelRequire("isbb2");

var $csLgO = parcelRequire("csLgO");

var $soOXK = parcelRequire("soOXK");

var $7xFdb = parcelRequire("7xFdb");
const $4949b32bbf913e83$export$85dad8e9886563f6 = (0, $isbb2.composeLayouts)((0, $soOXK.classicSoftwareProjectLayout), (0, $iZnNg.coreProjectLayout), (0, $csLgO.serviceProjectLayout), (0, $soOXK.softwareProjectLayout), (0, $7xFdb.userBoardLayout));

});
parcelRegister("iZnNg", function(module, exports) {

$parcel$export(module.exports, "coreProjectLayout", () => $de69fcae9527d9e6$export$3c06ced9943ca671);

var $8QAGR = parcelRequire("8QAGR");

var $isbb2 = parcelRequire("isbb2");
const $de69fcae9527d9e6$export$3c06ced9943ca671 = (0, $isbb2.composeLayouts)((0, $8QAGR.projectLayout));

});
parcelRegister("8QAGR", function(module, exports) {

$parcel$export(module.exports, "projectLayout", () => $07993258fcc80491$export$204149bac601d20c);

var $7rh0R = parcelRequire("7rh0R");

var $i49Tf = parcelRequire("i49Tf");

var $isbb2 = parcelRequire("isbb2");

var $9dASl = parcelRequire("9dASl");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $07993258fcc80491$var$withAnyProjectContext = (Component)=>(0, $isbb2.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: 'any'
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $07993258fcc80491$var$ProjectTrackers = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("fqkKC")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/project-layout/src/ui/trackers/index.tsx"
});
const $07993258fcc80491$var$ProjectFavicon = ()=>{
    (0, $9dASl.useProjectFavicon)();
    return null;
};
const $07993258fcc80491$var$rightSidebars = ()=>[];
const $07993258fcc80491$var$globalComponents = [
    $07993258fcc80491$var$withAnyProjectContext($07993258fcc80491$var$ProjectFavicon),
    $07993258fcc80491$var$withAnyProjectContext($07993258fcc80491$var$ProjectTrackers),
    $07993258fcc80491$var$withAnyProjectContext((0, $i49Tf.ProjectRouteListener))
];
const $07993258fcc80491$export$204149bac601d20c = (0, $isbb2.createLayout)({
    globalComponents: $07993258fcc80491$var$globalComponents,
    rightSidebars: $07993258fcc80491$var$rightSidebars()
});

});
parcelRegister("i49Tf", function(module, exports) {

$parcel$export(module.exports, "ProjectRouteListener", () => $badefa8fb2c95856$export$159f09d701320911);

var $eUqFw = parcelRequire("eUqFw");

var $3HCkE = parcelRequire("3HCkE");

var $ixwgj = parcelRequire("ixwgj");

var $c7H0g = parcelRequire("c7H0g");

var $77Wva = parcelRequire("77Wva");
const $badefa8fb2c95856$export$159f09d701320911 = ()=>{
    const isSiteAdmin = (0, $c7H0g.useIsAdmin)();
    const { data: data, loading: loading } = (0, $3HCkE.useResource)((0, $ixwgj.projectContextResource));
    (0, $eUqFw.useEffect)(()=>{
        if (isSiteAdmin) (0, $77Wva.setIsProjectAdmin)({
            loading: false,
            isProjectAdmin: true
        });
        else if (data != null) (0, $77Wva.setIsProjectAdmin)({
            loading: false,
            isProjectAdmin: data.isProjectAdmin
        });
        else (0, $77Wva.setIsProjectAdmin)({
            loading: loading,
            isProjectAdmin: null
        });
    }, [
        data,
        loading,
        isSiteAdmin
    ]);
    // Cleanup when component is unmounted. This means we are no longer in a project route
    (0, $eUqFw.useEffect)(()=>()=>(0, $77Wva.setIsProjectAdmin)({
                loading: false,
                isProjectAdmin: null
            }), []);
    return null;
};

});

parcelRegister("9dASl", function(module, exports) {

$parcel$export(module.exports, "useProjectFavicon", () => $ccc7b3b9e5ce6616$export$32abcb1f939de016);

var $eUqFw = parcelRequire("eUqFw");

var $6rW04 = parcelRequire("6rW04");

var $cPEpP = parcelRequire("cPEpP");
const $ccc7b3b9e5ce6616$export$32abcb1f939de016 = false ? ()=>undefined : ()=>{
    const { data: project } = (0, $cPEpP.useProject)();
    const iconEle = document.querySelector("link[rel='shortcut icon']");
    // Keep a copy of the default favicon
    const defaultFavicon = (0, $eUqFw.useMemo)(()=>iconEle instanceof HTMLLinkElement ? iconEle.href : '', [
        iconEle
    ]);
    const enabled = (0, $eUqFw.useMemo)(()=>(0, $6rW04.default)('ajs-favicon-use-projecticon') === 'true', []);
    (0, $eUqFw.useEffect)(()=>{
        const favicon = project ? project.avatarUrl : defaultFavicon;
        if (enabled && iconEle instanceof HTMLLinkElement) iconEle.href = favicon;
        // Switch back to default favicon
        return ()=>{
            if (enabled && iconEle instanceof HTMLLinkElement) iconEle.href = defaultFavicon;
        };
    }, [
        project,
        iconEle,
        defaultFavicon,
        enabled
    ]);
};

});

parcelRegister("fqkKC", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('f2iFO')
        ]);
        const value = parcelRequire('hbMGV');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("f2iFO")
    ]).then(()=>parcelRequire('hbMGV'));
}

});



parcelRegister("csLgO", function(module, exports) {

$parcel$export(module.exports, "serviceProjectLayout", () => $89d8cdf72602f901$export$e321cb31c875d1ba);
$parcel$export(module.exports, "rightSidebarsLayout", () => $89d8cdf72602f901$export$820f9bb834280408);

var $7rh0R = parcelRequire("7rh0R");

var $7ZZxN = parcelRequire("7ZZxN");

var $dVvIP = parcelRequire("dVvIP");

var $fBmd6 = parcelRequire("fBmd6");

var $8QAGR = parcelRequire("8QAGR");

var $isbb2 = parcelRequire("isbb2");

var $2QkFp = parcelRequire("2QkFp");
// TODO Remove this whenever all service project route paths are no longer ambiguous
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $89d8cdf72602f901$var$withServiceProjectContext = (Component)=>(0, $isbb2.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $7ZZxN.SERVICE_DESK_PROJECT)
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $89d8cdf72602f901$var$ProjectBuilder = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("cKhIq")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/project-builder/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $89d8cdf72602f901$var$Onboarding = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("ebtTs")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/onboarding/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $89d8cdf72602f901$var$RightSidebars = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("92u2e")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/right-sidebars/index.tsx"
});
const $89d8cdf72602f901$export$e321cb31c875d1ba = (0, $isbb2.composeLayouts)((0, $8QAGR.projectLayout), {
    globalComponents: [
        $89d8cdf72602f901$var$withServiceProjectContext($89d8cdf72602f901$var$Onboarding),
        ...(0, $2QkFp.serviceProjectFirstImpressionsLayout).globalComponents.map($89d8cdf72602f901$var$withServiceProjectContext),
        $89d8cdf72602f901$var$withServiceProjectContext((0, $fBmd6.AsyncJsmCustomDomainChangeBoardingFlag)),
        $89d8cdf72602f901$var$ProjectBuilder
    ],
    rightSidebars: [
        $89d8cdf72602f901$var$withServiceProjectContext($89d8cdf72602f901$var$RightSidebars),
        ...(0, $2QkFp.serviceProjectFirstImpressionsLayout).rightSidebars.map($89d8cdf72602f901$var$withServiceProjectContext)
    ]
});
const $89d8cdf72602f901$export$820f9bb834280408 = (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), {
    rightSidebars: [
        $89d8cdf72602f901$var$RightSidebars
    ]
});

});
parcelRegister("fBmd6", function(module, exports) {

$parcel$export(module.exports, "AsyncJsmCustomDomainChangeBoardingFlag", () => $2c9f26ce5a28ec28$export$b1ef5e3da6e1959d);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2c9f26ce5a28ec28$var$LazyJsmCustomDomainChangeBoardingFlag = (0, $7rh0R.lazy)(()=>(parcelRequire("iOj8a")), {
    moduleId: "./src/packages/servicedesk/custom-domain-change-boarding/src/ui/index.tsx"
});
const $2c9f26ce5a28ec28$export$b1ef5e3da6e1959d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-jsm-custom-domain-change-boarding-flag",
        packageName: "jira-help-center-custom-domain-change-boarding"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-custom-domain-change-boarding-flag",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2c9f26ce5a28ec28$var$LazyJsmCustomDomainChangeBoardingFlag, null)));

});
parcelRegister("iOj8a", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('d3MCA')
        ]);
        const value = parcelRequire('j5Ut0');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("d3MCA")
    ]).then(()=>parcelRequire('j5Ut0'));
}

});


parcelRegister("2QkFp", function(module, exports) {

$parcel$export(module.exports, "serviceProjectFirstImpressionsLayout", () => $28742565404e52e1$export$2562b2d784eadc10);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $1WU96 = parcelRequire("1WU96");

var $isbb2 = parcelRequire("isbb2");
const $28742565404e52e1$var$withServiceProjectAccess = (Component)=>{
    const ScopedComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1WU96.default), {
            hasServiceDeskAccess: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, null));
    const name = (0, $isbb2.coalesce)(Component.displayName) ?? (0, $isbb2.coalesce)(Component.name) ?? 'Component';
    ScopedComponent.displayName = `withServiceProjectAccess(${name})`;
    return ScopedComponent;
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $28742565404e52e1$var$Onboarding = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("aBZU7")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-first-impressions-layout/src/ui/onboarding/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $28742565404e52e1$var$RightSidebars = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("j7orj")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-first-impressions-layout/src/ui/right-sidebars/index.tsx"
});
const $28742565404e52e1$export$2562b2d784eadc10 = (0, $isbb2.createLayout)({
    globalComponents: [
        $28742565404e52e1$var$withServiceProjectAccess($28742565404e52e1$var$Onboarding)
    ],
    rightSidebars: [
        $28742565404e52e1$var$withServiceProjectAccess($28742565404e52e1$var$RightSidebars)
    ]
});

});
parcelRegister("1WU96", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f8966d75f9e18f8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gd0Sp = parcelRequire("gd0Sp");

var $3ndxD = parcelRequire("3ndxD");
/**
 * Manages the visibility of child components based on user permissions within a multi-tenant environment.
 * It leverages the application's permission settings to determine access rights, ensuring components are only accessible to users with the appropriate permissions.
 * In development environments, it issues a warning when no access-related properties are provided, aiding in debug and development processes.
 */ const $4f8966d75f9e18f8$var$AppPermissionsCheck = (props)=>{
    const { appPermissions: appPermissions } = (0, $gd0Sp.useTenantContext)();
    if (props.hasServiceDeskAccess !== undefined && appPermissions.hasServiceDeskAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children);
    if (props.hasCoreAccess !== undefined && appPermissions.hasCoreAccess === props.hasCoreAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children);
    if (props.hasSoftwareAccess !== undefined && appPermissions.hasSoftwareAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children);
    if (props.hasServiceDeskAccess === undefined && props.hasCoreAccess === undefined && props.hasSoftwareAccess === undefined) {
        if ((0, $3ndxD.isDevelopmentEnv)()) // eslint-disable-next-line no-console
        console.warn('AppPermissionsCheck should have defined at least one of access prop');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children);
    }
    return null;
};
$4f8966d75f9e18f8$var$AppPermissionsCheck.defaultProps = {
    hasCoreAccess: undefined,
    hasSoftwareAccess: undefined,
    hasServiceDeskAccess: undefined
};
var $4f8966d75f9e18f8$export$2e2bcd8739ae039 = $4f8966d75f9e18f8$var$AppPermissionsCheck;

});
parcelRegister("3ndxD", function(module, exports) {

$parcel$export(module.exports, "isDevelopmentEnv", () => $4cb60d7dfaed0e5c$export$48e5fb80244b95c5);
const $4cb60d7dfaed0e5c$export$48e5fb80244b95c5 = ()=>false;

});


parcelRegister("aBZU7", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('lSjLj')
        ]);
        const value = parcelRequire('fopgZ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("lSjLj")
    ]).then(()=>parcelRequire('fopgZ'));
}

});

parcelRegister("j7orj", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('6HOXP')
        ]);
        const value = parcelRequire('9iDpZ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("6HOXP")
    ]).then(()=>parcelRequire('9iDpZ'));
}

});


parcelRegister("cKhIq", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('12gwi');
        const value = parcelRequire('UsO9m');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("12gwi").then(()=>parcelRequire('UsO9m'));
}

});

parcelRegister("ebtTs", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hIGOt');
        const value = parcelRequire('jAlsY');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hIGOt").then(()=>parcelRequire('jAlsY'));
}

});

parcelRegister("92u2e", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('1xZoV')
        ]);
        const value = parcelRequire('lFtmC');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("1xZoV")
    ]).then(()=>parcelRequire('lFtmC'));
}

});


parcelRegister("soOXK", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareProjectLayout", () => $da080439a4ecc697$export$3791efdd32024063);
$parcel$export(module.exports, "softwareProjectLayout", () => $da080439a4ecc697$export$9a918616afa3328c);
$parcel$export(module.exports, "softwareProjectLayoutNoOnboarding", () => $da080439a4ecc697$export$ada52b1309832862);
$parcel$export(module.exports, "classicSoftwareProjectLayoutNoOnboarding", () => $da080439a4ecc697$export$6c1958653c44ba37);
$parcel$export(module.exports, "softwareProjectLayoutCode", () => $da080439a4ecc697$export$ab7e607e8441dc61);

var $7rh0R = parcelRequire("7rh0R");

var $7ZZxN = parcelRequire("7ZZxN");

var $8QAGR = parcelRequire("8QAGR");

var $isbb2 = parcelRequire("isbb2");
// TODO Remove this whenever all software project route paths are no longer ambiguous
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $da080439a4ecc697$var$withAnySoftwareProjectContext = (Component)=>(0, $isbb2.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $7ZZxN.SOFTWARE_PROJECT)
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $da080439a4ecc697$var$Onboarding = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("3KxoY")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/onboarding/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $da080439a4ecc697$var$OnboardingCode = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("vzNIX")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/onboarding-code/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $da080439a4ecc697$var$RightSidebars = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("76Vwl")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/right-sidebars/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $da080439a4ecc697$var$RightSidebarsCode = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("h8wio")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/right-sidebars-code/index.tsx"
});
const $da080439a4ecc697$var$SoftWareOnboarding = $da080439a4ecc697$var$withAnySoftwareProjectContext($da080439a4ecc697$var$Onboarding);
const $da080439a4ecc697$var$SoftWareOnboardingCode = $da080439a4ecc697$var$withAnySoftwareProjectContext($da080439a4ecc697$var$OnboardingCode);
const $da080439a4ecc697$var$nonSettingsRightSidebars = [
    $da080439a4ecc697$var$withAnySoftwareProjectContext($da080439a4ecc697$var$RightSidebars)
];
const $da080439a4ecc697$var$nonSettingsRightSidebarsCode = [
    $da080439a4ecc697$var$withAnySoftwareProjectContext($da080439a4ecc697$var$RightSidebarsCode)
];
const $da080439a4ecc697$var$sharedSoftwareProjectLayout = (0, $isbb2.composeLayouts)((0, $8QAGR.projectLayout), {});
const $da080439a4ecc697$export$3791efdd32024063 = (0, $isbb2.composeLayouts)($da080439a4ecc697$var$sharedSoftwareProjectLayout, {
    rightSidebars: $da080439a4ecc697$var$nonSettingsRightSidebars,
    globalComponents: [
        $da080439a4ecc697$var$SoftWareOnboarding
    ]
});
const $da080439a4ecc697$export$9a918616afa3328c = (0, $isbb2.composeLayouts)($da080439a4ecc697$var$sharedSoftwareProjectLayout, {
    rightSidebars: $da080439a4ecc697$var$nonSettingsRightSidebars,
    globalComponents: [
        $da080439a4ecc697$var$SoftWareOnboarding
    ]
});
const $da080439a4ecc697$export$ada52b1309832862 = (0, $isbb2.composeLayouts)($da080439a4ecc697$var$sharedSoftwareProjectLayout);
const $da080439a4ecc697$export$6c1958653c44ba37 = (0, $isbb2.composeLayouts)($da080439a4ecc697$var$sharedSoftwareProjectLayout);
const $da080439a4ecc697$export$ab7e607e8441dc61 = (0, $isbb2.composeLayouts)($da080439a4ecc697$var$sharedSoftwareProjectLayout, {
    rightSidebars: $da080439a4ecc697$var$nonSettingsRightSidebarsCode,
    globalComponents: [
        $da080439a4ecc697$var$SoftWareOnboardingCode
    ]
});

});
parcelRegister("3KxoY", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('2QXYY');
        const value = parcelRequire('5nRWZ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("2QXYY").then(()=>parcelRequire('5nRWZ'));
}

});

parcelRegister("vzNIX", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('4FTjM');
        const value = parcelRequire('1KEra');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("4FTjM").then(()=>parcelRequire('1KEra'));
}

});

parcelRegister("76Vwl", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hsl5M');
        const value = parcelRequire('epLsj');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hsl5M").then(()=>parcelRequire('epLsj'));
}

});

parcelRegister("h8wio", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('9LoaN');
        const value = parcelRequire('ddLdL');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("9LoaN").then(()=>parcelRequire('ddLdL'));
}

});


parcelRegister("7xFdb", function(module, exports) {

$parcel$export(module.exports, "userBoardLayout", () => $104be0934152e131$export$7092b4ee86ae0b71);

var $isbb2 = parcelRequire("isbb2");
const $104be0934152e131$export$7092b4ee86ae0b71 = (0, $isbb2.createLayout)();

});


parcelRegister("dgH3j", function(module, exports) {

$parcel$export(module.exports, "LazyNotFoundErrorPage", () => $a19888271aae3277$export$57c5c0b5a0cdb5b7);
$parcel$export(module.exports, "default", () => $a19888271aae3277$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $a19888271aae3277$export$57c5c0b5a0cdb5b7 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("5uAtw")), {
    moduleId: "./src/packages/spa-apps/error-pages/not-found/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a19888271aae3277$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $a19888271aae3277$export$57c5c0b5a0cdb5b7,
        pageId: "errors-404",
        shouldShowSpinner: false
    });

});
parcelRegister("5uAtw", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('92sUi'),
            load('i5RRW'),
            load('2hmUs'),
            load('bCeK4'),
            load('hPzOn'),
            load('fNhrE')
        ]);
        const value = parcelRequire('a7YYz');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("92sUi"),
        load("i5RRW"),
        load("2hmUs"),
        load("bCeK4"),
        load("hPzOn"),
        load("fNhrE")
    ]).then(()=>parcelRequire('a7YYz'));
}

});


parcelRegister("ElQSF", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('hmZTB')
        ]);
        const value = parcelRequire('3c0Jo');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("hmZTB")
    ]).then(()=>parcelRequire('3c0Jo'));
}

});

parcelRegister("4qvmP", function(module, exports) {

$parcel$export(module.exports, "getBusinessProjectResources", () => $539284efb9551a13$export$20e8c2951e444b08);
$parcel$export(module.exports, "getProjectViewResources", () => $539284efb9551a13$export$fcbe882e18ee4a35);
$parcel$export(module.exports, "getOverviewViewResources", () => $539284efb9551a13$export$21c5527b459d56fe);

var $fD1Hq = parcelRequire("fD1Hq");

var $kMmsu = parcelRequire("kMmsu");

var $f26dB = parcelRequire("f26dB");

var $fIi7o = parcelRequire("fIi7o");

var $fzymf = parcelRequire("fzymf");

var $aeIT6 = parcelRequire("aeIT6");

var $91fCW = parcelRequire("91fCW");

var $hHrVM = parcelRequire("hHrVM");

var $2JncP = parcelRequire("2JncP");
const $539284efb9551a13$var$commonResources = [
    (0, $2JncP.projectCreatePermissionsResource),
    (0, $f26dB.navigationResource)
];
const $539284efb9551a13$export$20e8c2951e444b08 = ()=>[
        ...$539284efb9551a13$var$commonResources,
        (0, $aeIT6.projectDetailsResource),
        (0, $91fCW.storageDetailsResourceWithCondition),
        (0, $fIi7o.navigationItemsWithConditionResource)
    ];
const $539284efb9551a13$export$46471673e66df5c1 = ()=>[
        ...$539284efb9551a13$var$commonResources,
        (0, $fzymf.overviewDetailsResource)
    ];
const $539284efb9551a13$export$fcbe882e18ee4a35 = ()=>[
        ...$539284efb9551a13$export$20e8c2951e444b08(),
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $fD1Hq.configurationResource),
        (0, $kMmsu.fieldsResource)
    ];
const $539284efb9551a13$export$21c5527b459d56fe = ()=>[
        ...$539284efb9551a13$export$46471673e66df5c1(),
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $fD1Hq.configurationResource),
        (0, $kMmsu.fieldsResource)
    ];

});
parcelRegister("fD1Hq", function(module, exports) {

$parcel$export(module.exports, "configurationResource", () => $b3265d3008765031$export$5c4ad441346dc154);
$parcel$export(module.exports, "useRankField", () => $b3265d3008765031$export$fffa1172af8de100);
$parcel$export(module.exports, "useStartDateField", () => $b3265d3008765031$export$bf78b0881400efef);
$parcel$export(module.exports, "useIsLinkingEnabled", () => $b3265d3008765031$export$76fc5a1eecec5a35);
$parcel$export(module.exports, "useIsSubtasksEnabled", () => $b3265d3008765031$export$dca58a051cb58f03);
$parcel$export(module.exports, "useApprovalsFieldId", () => $b3265d3008765031$export$cd2cec53c09a90dc);

var $3HCkE = parcelRequire("3HCkE");

var $7WqaN = parcelRequire("7WqaN");
const $b3265d3008765031$var$RESOURCE_KEY = 'BUSINESS_CONFIGURATION';
const $b3265d3008765031$export$5c4ad441346dc154 = (0, $3HCkE.createResource)({
    type: $b3265d3008765031$var$RESOURCE_KEY,
    getKey: ()=>$b3265d3008765031$var$RESOURCE_KEY,
    getData: (_, { tenantContext: { cloudId: cloudId } })=>(0, $7WqaN.fetchConfiguration)(cloudId),
    maxAge: Infinity
});
const $b3265d3008765031$export$b629b793d58e3884 = ()=>(0, $3HCkE.useResource)($b3265d3008765031$export$5c4ad441346dc154);
const $b3265d3008765031$export$fffa1172af8de100 = ()=>{
    const { data: data, loading: loading, error: error } = $b3265d3008765031$export$b629b793d58e3884();
    return {
        data: data?.rankField ?? null,
        loading: loading,
        error: error
    };
};
const $b3265d3008765031$export$bf78b0881400efef = ()=>{
    const { data: data, loading: loading, error: error } = $b3265d3008765031$export$b629b793d58e3884();
    return {
        data: data?.startDateField ?? null,
        loading: loading,
        error: error
    };
};
const $b3265d3008765031$export$76fc5a1eecec5a35 = ()=>{
    const { data: data } = $b3265d3008765031$export$b629b793d58e3884();
    return data?.isLinkingEnabled ?? false;
};
const $b3265d3008765031$export$dca58a051cb58f03 = ()=>{
    const { data: data } = $b3265d3008765031$export$b629b793d58e3884();
    return data?.isSubtasksEnabled ?? false;
};
const $b3265d3008765031$export$cd2cec53c09a90dc = ()=>{
    const { data: data, loading: loading } = $b3265d3008765031$export$b629b793d58e3884();
    return {
        approvalsFieldId: data?.approvalsFieldId ?? null,
        loading: loading
    };
};

});
parcelRegister("7WqaN", function(module, exports) {

$parcel$export(module.exports, "fetchConfiguration", () => $6d233c0f1331d9ce$export$9911e92fcb5c83c0);

var $dlVOn = parcelRequire("dlVOn");

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $lRmyA = parcelRequire("lRmyA");


var $6xUhC = parcelRequire("6xUhC");
const $6d233c0f1331d9ce$export$9911e92fcb5c83c0 = async (cloudId)=>{
    try {
        const response = await (0, $lRmyA.performPostRequest)('/rest/gira/1/?operation=JiraBusinessConfiguration', {
            body: JSON.stringify({
                query: (0, $4e521ecd804aed88$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId,
                    isFixTranslatedApprovalsFieldEnabled: (0, $1ybV0.ff)('jwm.fix-translated-approvals-field_6j6zr')
                }
            })
        });
        if (response.data == null) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
        return (0, $6xUhC.transformData)(response);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessConfiguration', 'Something went wrong while fetching business configuration');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) (0, $guiFP.default)({
            meta: {
                id: 'configurationResource',
                packageName: 'jiraRouterResourcesBusinessConfiguration',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return null;
};

});
const $4e521ecd804aed88$export$2b91517d6d5b4365 = `
query JiraBusinessConfiguration($cloudId: ID!, $isFixTranslatedApprovalsFieldEnabled: Boolean!) {
  jira {
    rankField: jwmAliasFieldConfig(cloudId: $cloudId, aliasFieldOption: RANK) {
      fieldId
      name
    }
    startDateField: jwmAliasFieldConfig(cloudId: $cloudId, aliasFieldOption: START_DATE) {
      fieldId
      name
    }
    issueLinkTypes(cloudId: $cloudId) {
      totalCount
    }
    isSubtasksEnabled(cloudId: $cloudId)
    approvalsField: jwmAliasFieldConfig(cloudId: $cloudId, aliasFieldOption: APPROVALS) @include(if: $isFixTranslatedApprovalsFieldEnabled) {
      fieldId
    }
  }
}
`;

parcelRegister("6xUhC", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $14956d34a7bd03ca$export$3ceb62baab058c6b);

var $1ybV0 = parcelRequire("1ybV0");
const $14956d34a7bd03ca$export$3ceb62baab058c6b = (response)=>{
    let rankField = null;
    const rankFieldNode = response.data?.jira?.rankField;
    if (rankFieldNode != null) rankField = {
        id: rankFieldNode.fieldId,
        name: rankFieldNode.name
    };
    let startDateField = null;
    const startDateFieldNode = response.data?.jira?.startDateField;
    if (startDateFieldNode != null) startDateField = {
        id: startDateFieldNode.fieldId,
        name: startDateFieldNode.name
    };
    const isLinkingEnabled = (response.data?.jira?.issueLinkTypes?.totalCount ?? 0) !== 0;
    const isSubtasksEnabled = response.data?.jira?.isSubtasksEnabled ?? false;
    const approvalsFieldId = (0, $1ybV0.ff)('jwm.fix-translated-approvals-field_6j6zr') && response.data?.jira?.approvalsField?.fieldId ? response.data?.jira?.approvalsField?.fieldId : null;
    return {
        rankField: rankField,
        startDateField: startDateField,
        isLinkingEnabled: isLinkingEnabled,
        isSubtasksEnabled: isSubtasksEnabled,
        approvalsFieldId: approvalsFieldId
    };
};

});



parcelRegister("kMmsu", function(module, exports) {

$parcel$export(module.exports, "fieldsResource", () => $1a45b925639aee3d$export$8bca6c1954ae9308);
$parcel$export(module.exports, "useFieldsResource", () => $1a45b925639aee3d$export$c0cd85886917fe89);

var $dlVOn = parcelRequire("dlVOn");

var $huI7r = parcelRequire("huI7r");

var $3HCkE = parcelRequire("3HCkE");

var $9zYls = parcelRequire("9zYls");

var $eKlti = parcelRequire("eKlti");


var $3hBy0 = parcelRequire("3hBy0");
const $1a45b925639aee3d$var$RESOURCE_TYPE_KEY = 'BUSINESS_FIELDS';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1a45b925639aee3d$var$handleProjectResponse = async (promise)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const response = await promise;
    if (response.data?.jira?.jqlBuilder?.fields?.edges == null) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
    return (0, $3hBy0.transformData)(response.data?.jira?.jqlBuilder?.fields?.edges);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1a45b925639aee3d$var$handleOverviewResponse = async (promise)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const response = await promise;
    if (response.data?.jira?.jwmOverview?.fields?.edges == null) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
    return (0, $3hBy0.transformData)(response.data?.jira?.jwmOverview?.fields?.edges);
};
const $1a45b925639aee3d$export$8bca6c1954ae9308 = (0, $3HCkE.createResource)({
    type: $1a45b925639aee3d$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        if (matchedRoute.match.params.overviewId) return `${$1a45b925639aee3d$var$RESOURCE_TYPE_KEY}_overview_${matchedRoute.match.params.overviewId}`;
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        const projectIdOrKey = projectKey || projectId;
        return `${$1a45b925639aee3d$var$RESOURCE_TYPE_KEY}_project_${projectIdOrKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        if (match.params.overviewId) return (0, $eKlti.fetchFields)((0, $26aeff854ea788a9$export$c378ca4a0e2c9fec), $1a45b925639aee3d$var$handleOverviewResponse, {
            overviewAri: (0, $huI7r.createAri)({
                resourceOwner: 'jira',
                cloudId: cloudId,
                resourceType: 'project-overview',
                resourceId: match.params.overviewId,
                activationId: activationId
            })
        });
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
        const projectIdOrKey = projectKey || projectId;
        return (0, $eKlti.fetchFields)((0, $26aeff854ea788a9$export$4d41378da3f70f0f), $1a45b925639aee3d$var$handleProjectResponse, {
            cloudId: cloudId,
            jqlContext: `project = '${projectIdOrKey}'`
        });
    },
    maxAge: 3600000
});
const $1a45b925639aee3d$export$c0cd85886917fe89 = ()=>(0, $3HCkE.useResource)($1a45b925639aee3d$export$8bca6c1954ae9308);

});
parcelRegister("eKlti", function(module, exports) {

$parcel$export(module.exports, "fetchFields", () => $7876ddb9df2017cc$export$f3ddd735c360919);

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $7876ddb9df2017cc$var$PAGE_SIZE = 100;
const $7876ddb9df2017cc$export$f3ddd735c360919 = async (query, handler, params)=>{
    try {
        const promise = (0, $lRmyA.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: {
                    first: $7876ddb9df2017cc$var$PAGE_SIZE,
                    ...params
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'JiraJqlBuilder'
            }
        });
        return await handler(promise);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessFields', 'Something went wrong while fetching fields');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) (0, $guiFP.default)({
            meta: {
                id: 'fieldsResource',
                packageName: 'jiraRouterResourcesBusinessFields',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return null;
};

});

const $26aeff854ea788a9$export$4d41378da3f70f0f = `
query JWMProjectFields($cloudId: ID!, $jqlContext: String!, $first: Int) {
  jira {
    jqlBuilder(cloudId: $cloudId) {
      fields (jqlContext: $jqlContext, forClause: WHERE, viewContext: JWM, first: $first) {
        ... on JiraJqlFieldConnection {
          edges {
            node {
              jqlTerm
              type
              displayName,
            }
          }
        }
      }
    }
  }
}`;
const $26aeff854ea788a9$export$c378ca4a0e2c9fec = `
query JWMOverviewFields($overviewAri: ID!, $first: Int) {
  jira {
    jwmOverview(id: $overviewAri) {
      ... on JiraWorkManagementGiraOverview {
        fields (first: $first) {
          ... on JiraJqlFieldConnection {
            edges {
              node {
                jqlTerm
                type
                displayName,
              }
            }
          }
        }
      }
    }
  }
}`;

parcelRegister("3hBy0", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $e766e365dbeb1f01$export$3ceb62baab058c6b);
const $e766e365dbeb1f01$export$3ceb62baab058c6b = (data)=>data.map((edge)=>edge.node);

});


parcelRegister("f26dB", function(module, exports) {

$parcel$export(module.exports, "navigationResource", () => $2dec1e8aa31afb0b$export$62940941ee574cdc);
$parcel$export(module.exports, "useNavigationResource", () => $2dec1e8aa31afb0b$export$c17011c09e042a31);
$parcel$export(module.exports, "useIsPremiumUserSeat", () => $2dec1e8aa31afb0b$export$90749419e9042370);
$parcel$export(module.exports, "useTriggerOverviewChangeboarding", () => $2dec1e8aa31afb0b$export$30f6f0b00bf4f2f8);

var $8blac = parcelRequire("8blac");

var $1ybV0 = parcelRequire("1ybV0");

var $huI7r = parcelRequire("huI7r");

var $3HCkE = parcelRequire("3HCkE");

var $9zYls = parcelRequire("9zYls");

var $gQNVa = parcelRequire("gQNVa");


const $2dec1e8aa31afb0b$export$62940941ee574cdc = (0, $3HCkE.createResource)({
    type: 'BUSINESS_NAVIGATION',
    getKey: ()=>'BUSINESS_NAVIGATION',
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
        // do not fetch the resource for anonymous access
        if (isAnonymous) return null;
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
        const isPloverviewMigrationEnabled = (0, $1ybV0.ff)('ploverview_overviews_to_plans_migration');
        const isCustomProjectNavEnabled = (0, $1ybV0.ff)('jwm.custom-project-navigation');
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(projectKey)) return (0, $gQNVa.fetchNavigation)((0, $dac6815921c324c6$export$a40c5d12b8a53ba2), {
            cloudId: cloudId,
            projectKey: projectKey,
            isPloverviewMigrationEnabled: isPloverviewMigrationEnabled,
            isCustomProjectNavEnabled: isCustomProjectNavEnabled
        });
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(projectId)) return (0, $gQNVa.fetchNavigation)((0, $dac6815921c324c6$export$7c9197b656229b53), {
            cloudId: cloudId,
            projectId: (0, $huI7r.createAri)({
                resourceOwner: 'jira',
                cloudId: cloudId,
                resourceType: 'project',
                resourceId: projectId
            }),
            isPloverviewMigrationEnabled: isPloverviewMigrationEnabled,
            isCustomProjectNavEnabled: isCustomProjectNavEnabled
        });
        return (0, $gQNVa.fetchNavigation)((0, $dac6815921c324c6$export$c378ca4a0e2c9fec), {
            cloudId: cloudId,
            isPloverviewMigrationEnabled: isPloverviewMigrationEnabled,
            isCustomProjectNavEnabled: isCustomProjectNavEnabled
        });
    },
    maxAge: Infinity
});
const $2dec1e8aa31afb0b$export$c17011c09e042a31 = ()=>(0, $3HCkE.useResource)($2dec1e8aa31afb0b$export$62940941ee574cdc);
const $2dec1e8aa31afb0b$export$90749419e9042370 = ()=>{
    const { data: data } = $2dec1e8aa31afb0b$export$c17011c09e042a31();
    if (data === 'NOT_APPLICABLE') return false;
    return Boolean(data?.isPremiumUserSeat);
};
const $2dec1e8aa31afb0b$export$30f6f0b00bf4f2f8 = ()=>{
    const { data: data } = $2dec1e8aa31afb0b$export$c17011c09e042a31();
    if (data === 'NOT_APPLICABLE') return false;
    return Boolean(data?.showPlansOnboarding);
};

});
parcelRegister("gQNVa", function(module, exports) {

$parcel$export(module.exports, "fetchNavigation", () => $83fda10f52c953b2$export$1fc5fff73d9a570c);

var $dlVOn = parcelRequire("dlVOn");

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $lRmyA = parcelRequire("lRmyA");


var $2Y7Cf = parcelRequire("2Y7Cf");
const $83fda10f52c953b2$var$EMPTY_RESPONSE = {
    recents: [],
    favorites: [],
    hasMoreFavorite: false,
    overviews: [],
    overviewsError: null,
    isPremiumUserSeat: false,
    showPlansOnboarding: false,
    shouldHideOverviews: false
};
const $83fda10f52c953b2$export$1fc5fff73d9a570c = async (query, params)=>{
    try {
        const response = await (0, $lRmyA.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: {
                    first: (0, $02a4cc31089f6443$export$3349219a88ac77cd),
                    ...params
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'projectStyle'
            }
        });
        // checking only for undefined, as null is a valid value (not applicable)
        if (response.data?.jira?.navigation === undefined) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
        let areOverviewsGone = false;
        if ((0, $1ybV0.ff)('ploverview_overviews_to_plans_migration') && Array.isArray(response.errors)) // Overviews have been migrated to plans and should no longer be shown to the user
        areOverviewsGone = response.errors.some((error)=>error.extensions?.statusCode === 410);
        return (0, $2Y7Cf.transformData)(response.data.jira.navigation, areOverviewsGone);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessNavigation', 'Something went wrong while fetching the navigation items');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) (0, $guiFP.default)({
            meta: {
                id: 'navigationResource',
                packageName: 'jiraRouterResourcesBusinessNavigation',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return $83fda10f52c953b2$var$EMPTY_RESPONSE;
};

});
const $02a4cc31089f6443$export$3349219a88ac77cd = 10;
const $02a4cc31089f6443$export$e8958a6508ec5b71 = 'NOT_APPLICABLE';

parcelRegister("2Y7Cf", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $e5db137f9c283ecc$export$3ceb62baab058c6b);

var $kar7l = parcelRequire("kar7l");

var $1ybV0 = parcelRequire("1ybV0");


var $vsTb8 = parcelRequire("vsTb8");
const $e5db137f9c283ecc$var$SIMPLIFIED_PROJECT_STYLE = 'TEAM_MANAGED_PROJECT';
const $e5db137f9c283ecc$var$PREMIUM = 'PREMIUM';
const $e5db137f9c283ecc$var$mapProjectNode = (node)=>({
        key: node.key,
        id: Number(node.projectId),
        avatarUrl: node.avatar?.large ?? '',
        name: node.name,
        type: node.projectType.toLowerCase(),
        isSimplified: node.projectStyle === $e5db137f9c283ecc$var$SIMPLIFIED_PROJECT_STYLE,
        isFavorite: node.isFavourite,
        permissions: {
            viewIssues: node.viewIssues.canPerform
        },
        defaultView: node.defaultView?.typeKey?.toLowerCase()
    });
const $e5db137f9c283ecc$var$mapOverviewNode = (node)=>({
        id: node.id,
        name: node.name,
        theme: node?.theme ?? (0, $kar7l.DEFAULT_BACKGROUND_CONFIG).name
    });
const $e5db137f9c283ecc$export$3ceb62baab058c6b = (navigation, areOverviewsGone)=>{
    if (navigation == null) // not a JWM context
    return 0, $02a4cc31089f6443$export$e8958a6508ec5b71;
    let overviews = [];
    let overviewsError = null;
    const isPremiumUserSeat = navigation.jwmLicensing?.currentUserSeatEdition === $e5db137f9c283ecc$var$PREMIUM;
    if (isPremiumUserSeat) {
        if (navigation.overviews?.__typename === (0, $vsTb8.OVERVIEWS_SUCCESS_RESPONSE_TYPE)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        overviews = navigation.overviews.edges.map((edge)=>$e5db137f9c283ecc$var$mapOverviewNode(edge.node));
        else overviewsError = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        navigation.overviews ?? new Error('Unknown overviews error');
    }
    let recents = navigation.recentProjects?.edges?.map((edge)=>$e5db137f9c283ecc$var$mapProjectNode(edge.node)) ?? [];
    const favorites = navigation.favoriteProjects?.edges?.map((edge)=>$e5db137f9c283ecc$var$mapProjectNode(edge.node)) ?? [];
    // Remove favorited projects from the recent projects list
    recents = recents.filter((recentProject)=>!favorites.some((favProject)=>favProject.id === recentProject.id));
    const showPlansOnboarding = Boolean(navigation.jwmOverviewPlanMigrationState?.changeboardingActive);
    const shouldHideOverviews = (0, $1ybV0.ff)('ploverview_overviews_to_plans_migration') && areOverviewsGone && !showPlansOnboarding;
    return {
        recents: recents,
        favorites: favorites,
        hasMoreFavorite: navigation.favoriteProjects?.pageInfo?.hasNextPage ?? false,
        overviews: overviews,
        overviewsError: overviewsError,
        isPremiumUserSeat: isPremiumUserSeat,
        showPlansOnboarding: showPlansOnboarding,
        shouldHideOverviews: shouldHideOverviews
    };
};

});
parcelRegister("vsTb8", function(module, exports) {

$parcel$export(module.exports, "OVERVIEWS_SUCCESS_RESPONSE_TYPE", () => $8f89cb3175071b7f$export$ddf2fc82885279d);
const $8f89cb3175071b7f$export$ddf2fc82885279d = 'JiraWorkManagementGiraOverviewConnection';
const $8f89cb3175071b7f$export$39284f7325536558 = {
    ServiceDesk: 'SERVICE_DESK',
    Business: 'BUSINESS',
    Software: 'SOFTWARE'
};
const $8f89cb3175071b7f$export$1f66f9f05afa05a8 = {
    TeamManagedProject: 'TEAM_MANAGED_PROJECT',
    CompanyManagedProject: 'COMPANY_MANAGED_PROJECT'
};

});



const $dac6815921c324c6$var$ProjectFragment = `
fragment ProjectFragment on JiraProject {
  key
  projectId
  avatar {
    large
  }
  name
  projectStyle
  projectType
  isFavourite
  viewIssues: action(type: VIEW_ISSUES) {
    canPerform
  }
  defaultView: jwmDefaultSavedView @include(if: $isCustomProjectNavEnabled) {
    ... on JiraNavigationItem {
      typeKey
    }
  }
}
`;
const $dac6815921c324c6$var$ProjectConnectionFragment = `
fragment ProjectConnectionFragment on JiraProjectConnection {
  pageInfo {
    hasNextPage
  }
  edges {
    node {
      ...ProjectFragment
    }
  }
}
`;
const $dac6815921c324c6$var$OverviewFragment = `
fragment OverviewFragment on JiraWorkManagementGiraOverview {
  id
  name
  theme
}
`;
const $dac6815921c324c6$var$OverviewConnectionFragment = `
fragment OverviewConnectionFragment on JiraWorkManagementGiraOverviewConnection {
  pageInfo {
    hasNextPage
  }
  edges {
    node {
      ...OverviewFragment
    }
  }
}
`;
const $dac6815921c324c6$var$NavigationDataFragment = `
fragment NavigationFragment on JiraWorkManagementNavigation {
  jwmLicensing {
    currentUserSeatEdition
  }
  recentProjects(first: $first) {
    ...ProjectConnectionFragment
  }
  favoriteProjects(first: $first) {
    ...ProjectConnectionFragment
  }
  overviews: jwmOverviews(cloudId: $cloudId, first: $first) @optIn(to: "JiraWorkManagementGiraOverviews") {
    __typename
    ... on JiraWorkManagementGiraOverviewConnection {
      ...OverviewConnectionFragment
    }
  }
  jwmOverviewPlanMigrationState @include(if: $isPloverviewMigrationEnabled) {
    ... on JiraOverviewPlanMigrationState {
      changeboardingActive
    }
  }
}
`;
const $dac6815921c324c6$export$7c9197b656229b53 = `
query JiraBusinessProjectNavigation($cloudId: ID!, $projectId: ID!, $first: Int!, $isPloverviewMigrationEnabled: Boolean!, $isCustomProjectNavEnabled: Boolean!) {
  jira {
    navigation: jwmNavigationByProjectId(projectId: $projectId) {
      ...NavigationFragment
    }
  }
}
${$dac6815921c324c6$var$ProjectFragment}
${$dac6815921c324c6$var$ProjectConnectionFragment}
${$dac6815921c324c6$var$NavigationDataFragment}
${$dac6815921c324c6$var$OverviewFragment}
${$dac6815921c324c6$var$OverviewConnectionFragment}
`;
const $dac6815921c324c6$export$a40c5d12b8a53ba2 = `
query JiraBusinessProjectNavigation($cloudId: ID!, $projectKey: String!, $first: Int!, $isPloverviewMigrationEnabled: Boolean!, $isCustomProjectNavEnabled: Boolean!) {
  jira {
    navigation: jwmNavigationByProjectKey(cloudId: $cloudId, projectKey: $projectKey) {
      ...NavigationFragment
    }
  }
}
${$dac6815921c324c6$var$ProjectFragment}
${$dac6815921c324c6$var$ProjectConnectionFragment}
${$dac6815921c324c6$var$NavigationDataFragment}
${$dac6815921c324c6$var$OverviewFragment}
${$dac6815921c324c6$var$OverviewConnectionFragment}
`;
const $dac6815921c324c6$export$c378ca4a0e2c9fec = `
query JiraBusinessOverviewNavigation($cloudId: ID!, $first: Int!, $isPloverviewMigrationEnabled: Boolean!, $isCustomProjectNavEnabled: Boolean!) {
  jira {
    navigation: jwmNavigation(cloudId: $cloudId) {
      ...NavigationFragment
    }
  }
}
${$dac6815921c324c6$var$ProjectFragment}
${$dac6815921c324c6$var$ProjectConnectionFragment}
${$dac6815921c324c6$var$NavigationDataFragment}
${$dac6815921c324c6$var$OverviewFragment}
${$dac6815921c324c6$var$OverviewConnectionFragment}
`;


parcelRegister("fIi7o", function(module, exports) {

$parcel$export(module.exports, "navigationItemsResource", () => $e864d999bb4bb8a0$export$8446b129b5aba359);
$parcel$export(module.exports, "navigationItemsWithConditionResource", () => $e864d999bb4bb8a0$export$c96e4b009fd75f5a);

var $1ybV0 = parcelRequire("1ybV0");

var $buJlM = parcelRequire("buJlM");

var $lJT4T = parcelRequire("lJT4T");

var $9zYls = parcelRequire("9zYls");
var $jwzNs = parcelRequire("jwzNs");
const $e864d999bb4bb8a0$var$RESOURCE_TYPE_KEY = 'RESOURCE_TYPE_BUSINESS_NAVIGATION_ITEMS';
const $e864d999bb4bb8a0$export$8446b129b5aba359 = (0, $buJlM.createRelayResource)({
    type: $e864d999bb4bb8a0$var$RESOURCE_TYPE_KEY,
    getQuery: ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
        const { cloudId: cloudId } = tenantContext;
        const projectIdOrKey = projectKey || projectId;
        return {
            parameters: (0, $lJT4T.default),
            variables: {
                cloudId: cloudId,
                projectIdOrKey: projectIdOrKey,
                first: 50
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    }
});
const $e864d999bb4bb8a0$export$c96e4b009fd75f5a = (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('jwm.custom-project-navigation'), $e864d999bb4bb8a0$export$8446b129b5aba359);

});
parcelRegister("lJT4T", function(module, exports) {

$parcel$export(module.exports, "default", () => $26f0e92c1c9a14da$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f9ac0796c9cf79b73049c0b4fb6468aa>>
 * @relayHash 8ecba969439d16d294ced36ddd9addd7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 74c63e963e34a5e0af800ad1ad0509e907e61d19edf4b1a0dc3ba6ffc26e18c5
const $26f0e92c1c9a14da$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectIdOrKey"
    }, v3 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v4 = {
        "kind": "Variable",
        "name": "projectIdOrKey",
        "variableName": "projectIdOrKey"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v7 = {
        "kind": "ScalarField",
        "name": "message"
    }, v8 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v9 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v10 = [
        v3 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v4 /*: any*/ 
    ], v11 = {
        "kind": "ScalarField",
        "name": "label"
    }, v12 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v13 = {
        "kind": "ScalarField",
        "name": "url"
    }, v14 = {
        "kind": "ScalarField",
        "name": "styleClass"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "tabs_jwmNavigationItemsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "navigationItems",
                                    "args": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ],
                                    "concreteType": "JiraNavigationItemConnection",
                                    "kind": "LinkedField",
                                    "name": "__tabs_jiraNavigation__navigationItems_connection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ui_navigationKitTabList_TabList"
                                        },
                                        {
                                            "concreteType": "JiraNavigationItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "QueryError",
                                            "kind": "LinkedField",
                                            "name": "errors",
                                            "plural": true,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v9 /*: any*/ 
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.navigationItems"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "tabs_jwmNavigationItemsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "navigationItems",
                            "args": v10 /*: any*/ ,
                            "concreteType": "JiraNavigationItemConnection",
                            "kind": "LinkedField",
                            "name": "jwmSavedViewsByProject",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraNavigationItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isDefault"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "typeKey"
                                                },
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isJiraNavigationItem"
                                                },
                                                v11 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canRemove"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canSetAsDefault"
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraAppSection",
                                                            "kind": "LinkedField",
                                                            "name": "sections",
                                                            "plural": true,
                                                            "selections": [
                                                                v11 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraAppNavigationItemNestedLink",
                                                                    "kind": "LinkedField",
                                                                    "name": "links",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v11 /*: any*/ ,
                                                                        v12 /*: any*/ ,
                                                                        v13 /*: any*/ ,
                                                                        v14 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v13 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "appType"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "envLabel"
                                                        }
                                                    ],
                                                    "type": "JiraAppNavigationItem"
                                                }
                                            ]
                                        },
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "QueryError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v9 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "navigationItems",
                            "args": v10 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "projectIdOrKey"
                            ],
                            "handle": "connection",
                            "key": "tabs_jiraNavigation__navigationItems",
                            "kind": "LinkedHandle",
                            "name": "jwmSavedViewsByProject"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "74c63e963e34a5e0af800ad1ad0509e907e61d19edf4b1a0dc3ba6ffc26e18c5",
            "metadata": {
                "connection": [
                    {
                        "count": "first",
                        "cursor": null,
                        "direction": "forward",
                        "path": [
                            "jira",
                            "navigationItems"
                        ]
                    }
                ]
            },
            "name": "tabs_jwmNavigationItemsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$26f0e92c1c9a14da$var$node.hash = "2d84b9ec639958d8e958f01bde5a1fea";
var $26f0e92c1c9a14da$export$2e2bcd8739ae039 = $26f0e92c1c9a14da$var$node;

});


parcelRegister("91fCW", function(module, exports) {

$parcel$export(module.exports, "storageDetailsResourceWithCondition", () => $24b210595251f2b8$export$8697c3175d46bd51);
$parcel$export(module.exports, "useStorageDetails", () => $24b210595251f2b8$export$8c295c187914aac1);

var $1ybV0 = parcelRequire("1ybV0");

var $3HCkE = parcelRequire("3HCkE");

var $jwzNs = parcelRequire("jwzNs");

var $gs6RW = parcelRequire("gs6RW");
const $24b210595251f2b8$var$RESOURCE_TYPE_KEY = 'RESOURCE_TYPE_BUSINESS_INSTANCE_STORAGE';
const $24b210595251f2b8$export$76c871115d0c70a1 = (0, $3HCkE.createResource)({
    type: $24b210595251f2b8$var$RESOURCE_TYPE_KEY,
    getKey: ()=>$24b210595251f2b8$var$RESOURCE_TYPE_KEY,
    getData: async (_, { tenantContext: { appEditions: appEditions } })=>(0, $gs6RW.fetchStorageDetails)(appEditions),
    maxAge: Infinity,
    isBrowserOnly: true
});
const $24b210595251f2b8$export$8697c3175d46bd51 = (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('jwm.storage-upgrade-main'), $24b210595251f2b8$export$76c871115d0c70a1);
const $24b210595251f2b8$export$8c295c187914aac1 = ()=>(0, $3HCkE.useResource)($24b210595251f2b8$export$76c871115d0c70a1);

});
parcelRegister("gs6RW", function(module, exports) {

$parcel$export(module.exports, "fetchStorageDetails", () => $f8699ff0bc3b5274$export$576d1c3de6af9760);

var $dlVOn = parcelRequire("dlVOn");

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $6WXNs = parcelRequire("6WXNs");

const $f8699ff0bc3b5274$export$576d1c3de6af9760 = async (appEditions)=>{
    try {
        if (appEditions?.core !== (0, $6WXNs.FREE_EDITION)) return null;
        const response = await (0, $lRmyA.performPostRequest)('/rest/gira/latest?query', {
            body: JSON.stringify({
                query: (0, $c9625ef7268a5b88$export$2b91517d6d5b4365),
                variables: {
                    productKey: 'jira-core'
                }
            }),
            headers: {
                'content-type': 'application/json'
            }
        });
        if (response.errors != null) {
            const error = response.errors?.[0];
            const isClientError = error?.extensions?.statusCode >= 400 && error?.extensions?.statusCode < 500;
            if (!isClientError) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
        }
        const usageLimit = response?.data?.attachmentStorage;
        if (usageLimit && usageLimit?.allowed) {
            const percentageUsed = Math.round(usageLimit?.used / usageLimit.allowed * 100);
            return percentageUsed;
        }
        return null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('getStorageAmountService', 'Something went wrong while fetching storage amount');
        (0, $guiFP.default)({
            meta: {
                id: 'getStorageAmountService',
                packageName: 'jiraRouterResourcesBusinessStorageDetails',
                teamName: 'jira-warepil'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});
const $c9625ef7268a5b88$export$2b91517d6d5b4365 = `
query Storage($productKey: String!) {
  attachmentStorage(productKey: $productKey) {
    used
    allowed
    isUnlimited
  }
}`;



parcelRegister("2JncP", function(module, exports) {

$parcel$export(module.exports, "projectCreatePermissionsResource", () => $76240f0f6e8ab8e1$export$f6c05eaea53ab4ae);
$parcel$export(module.exports, "useProjectCreatePermissionsResource", () => $76240f0f6e8ab8e1$export$2bd0d3b374549a68);

var $3HCkE = parcelRequire("3HCkE");


const $76240f0f6e8ab8e1$var$getDataLoader = ()=>(parcelRequire("7sFD4"));
const $76240f0f6e8ab8e1$export$f6c05eaea53ab4ae = (0, $3HCkE.createResource)({
    type: (0, $3eff975f98a7cc60$export$8bc44dee8c6d28f),
    getKey: ()=>'state',
    getDataLoader: $76240f0f6e8ab8e1$var$getDataLoader,
    maxAge: Infinity
});
const $76240f0f6e8ab8e1$export$2bd0d3b374549a68 = ()=>(0, $3HCkE.useResource)($76240f0f6e8ab8e1$export$f6c05eaea53ab4ae);

});
const $3eff975f98a7cc60$export$8bc44dee8c6d28f = 'RESOURCE_TYPE_PROJECT_PERMISSIONS';

parcelRegister("7sFD4", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('8avE4');
        const value = parcelRequire('45aM7');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("8avE4").then(()=>parcelRequire('45aM7'));
}

});



parcelRegister("hRe6W", function(module, exports) {

$parcel$export(module.exports, "queuesNavigationItems", () => $e1c5e34342843ed0$export$4fed8be571897bef);
$parcel$export(module.exports, "priorityGroupResource", () => $e1c5e34342843ed0$export$1f9ab301771fe42e);

var $illlw = parcelRequire("illlw");

var $3HCkE = parcelRequire("3HCkE");

var $9zYls = parcelRequire("9zYls");

var $2Vm6a = parcelRequire("2Vm6a");

const $e1c5e34342843ed0$var$getDataLoader = ()=>(parcelRequire("d4UWi"));

const $e1c5e34342843ed0$var$getPriorityGroupDataLoader = ()=>(parcelRequire("4rV5n"));
const $e1c5e34342843ed0$export$4fed8be571897bef = (0, $3HCkE.createResource)({
    type: (0, $2Vm6a.RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS),
    getKey: ({ match: match, query: query })=>// projectKey from url path/query or browse/{issueKey}
        (0, $9zYls.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(match, 'params.issueKey', '').split('-')[0],
    getDataLoader: $e1c5e34342843ed0$var$getDataLoader,
    maxAge: (0, $2Vm6a.ONE_DAY_IN_MILLIS)
});
const $e1c5e34342843ed0$export$1f9ab301771fe42e = (0, $3HCkE.createResource)({
    type: (0, $2Vm6a.RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS),
    getKey: ({ match: match, query: query })=>// projectKey from url path or browse/{issueKey}
        (0, $9zYls.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(match, 'params.issueKey', '').split('-')[0],
    getDataLoader: $e1c5e34342843ed0$var$getPriorityGroupDataLoader,
    maxAge: (0, $2Vm6a.ONE_DAY_IN_MILLIS),
    isBrowserOnly: true
});

});
parcelRegister("2Vm6a", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS", () => $447a57e3617be5c6$export$a401e6d6b205c72b);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS", () => $447a57e3617be5c6$export$2064262c540606ba);
$parcel$export(module.exports, "ONE_DAY_IN_MILLIS", () => $447a57e3617be5c6$export$5a00268156ea5027);
const $447a57e3617be5c6$export$a401e6d6b205c72b = 'SERVICEDESK_QUEUES_NAVIGATION_ITEMS';
const $447a57e3617be5c6$export$2064262c540606ba = 'SERVICEDESK_QUEUES_PRIORITY_GROUPS';
const $447a57e3617be5c6$export$5a00268156ea5027 = 86400000;

});

parcelRegister("d4UWi", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('886YZ');
        const value = parcelRequire('hgRsr');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("886YZ").then(()=>parcelRequire('hgRsr'));
}

});

parcelRegister("4rV5n", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('d9Mq1');
        const value = parcelRequire('ioDaq');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("d9Mq1").then(()=>parcelRequire('ioDaq'));
}

});


parcelRegister("fXKgc", function(module, exports) {

$parcel$export(module.exports, "browseProjectRedirectRoute", () => $d7a8c211966f4d11$export$f9cac37753487f39);

var $exb0h = parcelRequire("exb0h");
const $d7a8c211966f4d11$export$f9cac37753487f39 = {
    group: (0, $exb0h.ROUTE_GROUPS).REDIRECTS,
    name: (0, $exb0h.ROUTE_NAMES).BROWSE_PROJECT_REDIRECT,
    path: '/browse/:projectKey([^-/]+)',
    exact: true,
    isRedirect: true
};

});

parcelRegister("4mBNF", function(module, exports) {

$parcel$export(module.exports, "RedirectToLastVisitedProjectPage", () => $ee5751782ee689e5$export$86041af020f4c959);

var $eUqFw = parcelRequire("eUqFw");

var $95ztp = parcelRequire("95ztp");
const $ee5751782ee689e5$export$86041af020f4c959 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $95ztp.default), null);

});
parcelRegister("95ztp", function(module, exports) {

$parcel$export(module.exports, "default", () => $79f4696870f01fd9$export$2e2bcd8739ae039);

var $kJlBc = parcelRequire("kJlBc");

var $fNXJ9 = parcelRequire("fNXJ9");
var $79f4696870f01fd9$export$2e2bcd8739ae039 = (0, $kJlBc.withRouter)((0, $fNXJ9.default));

});
parcelRegister("fNXJ9", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c87fe0adf992b9c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $53ciZ = parcelRequire("53ciZ");

var $hknOo = parcelRequire("hknOo");

var $ICvxP = parcelRequire("ICvxP");

var $e91YZ = parcelRequire("e91YZ");

var $gUUjF = parcelRequire("gUUjF");

var $2OdyW = parcelRequire("2OdyW");

var $84CBi = parcelRequire("84CBi");


var $7zXhs = parcelRequire("7zXhs");
const $8c87fe0adf992b9c$var$buildEndpoint = (projectKey, initialRedirect)=>`/rest/internal/2/projectlandingpage/${projectKey}${initialRedirect ? '?initialRedirect=true' : ''}`;
const $8c87fe0adf992b9c$var$allowListedSearchParams = [
    (0, $4f7acf20e25b7dd7$export$29d3926e3d72cfb),
    (0, $4f7acf20e25b7dd7$export$b3233b76460c1e7c)
];
const $8c87fe0adf992b9c$var$redirectForAnonymousUser = (projectKey, history, startTime)=>{
    const destination = `/projects/${projectKey}/issues/?filter=allissues`;
    history.replace(destination);
    // Log success
    (0, $gUUjF.default).safeInfoWithoutCustomerData((0, $4f7acf20e25b7dd7$export$25a759e49d5049db), 'History replace correctly triggered for anonymous user', {
        requestTime: (0, $7zXhs.getNow)() - startTime,
        destination: destination
    });
};
const $8c87fe0adf992b9c$export$c79af62ad7a1fe8a = (query)=>Object.fromEntries(Object.entries(query).filter(([key])=>$8c87fe0adf992b9c$var$allowListedSearchParams.some((allowedParam)=>key === allowedParam) || key.includes((0, $4f7acf20e25b7dd7$export$29d3926e3d72cfb))));
const $8c87fe0adf992b9c$export$283f1587d7a5369f = (searchQuery, queryInitializer)=>{
    const queryKeys = new URLSearchParams(searchQuery).toString();
    return queryKeys.length > 0 ? `${queryInitializer}${queryKeys}` : '';
};
class $8c87fe0adf992b9c$export$bf8d1fdc3b47a835 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { history: history, location: location, query: query, match: { params: params } } = this.props;
        // First time a project is created
        const { initial: initial } = query;
        // Clear the SSR Ready Mark if present
        (0, $ICvxP.default)((0, $hknOo.SPA_SSR_RENDERED_MARK));
        const startTime = (0, $7zXhs.getNow)();
        const projectKey = // @ts-expect-error - TS2345 - Argument of type 'string | {}' is not assignable to parameter of type 'string'.
        params.projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse((0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(location, 'search', {})).projectKey;
        if (!params.projectKey) (0, $gUUjF.default).safeInfoWithoutCustomerData((0, $4f7acf20e25b7dd7$export$25a759e49d5049db), 'queryString', {
            duration: (0, $7zXhs.getNow)() - startTime
        });
        if (projectKey) (0, $2OdyW.default)($8c87fe0adf992b9c$var$buildEndpoint(projectKey, !!initial)).then((response)=>{
            const endTime = (0, $7zXhs.getNow)();
            let searchQueryParams = '';
            const searchQuery = $8c87fe0adf992b9c$export$c79af62ad7a1fe8a(query);
            const queryInitializer = response.data.url.includes('?') ? '&' : '?';
            searchQueryParams = $8c87fe0adf992b9c$export$283f1587d7a5369f(searchQuery, queryInitializer);
            const destination = response.data.url + searchQueryParams;
            history.replace(destination);
            // Log success
            (0, $gUUjF.default).safeInfoWithoutCustomerData((0, $4f7acf20e25b7dd7$export$25a759e49d5049db), 'History replace correctly triggered', {
                requestTime: endTime - startTime,
                destination: destination
            });
        }, (error)=>{
            const endTime = (0, $7zXhs.getNow)();
            if ((0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)().isAnonymous) $8c87fe0adf992b9c$var$redirectForAnonymousUser(projectKey, history, startTime);
            else // Log failures
            (0, $gUUjF.default).safeErrorWithoutCustomerData((0, $4f7acf20e25b7dd7$export$25a759e49d5049db), `Error on request. Request time: ${endTime - startTime}`, error);
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $84CBi.default), {
            name: "last-visited-project-page-redirect"
        });
    }
}
var $8c87fe0adf992b9c$export$2e2bcd8739ae039 = $8c87fe0adf992b9c$export$bf8d1fdc3b47a835;

});
const $4f7acf20e25b7dd7$export$25a759e49d5049db = 'spa-apps.common.redirect.last-visited-project-page';
const $4f7acf20e25b7dd7$export$29d3926e3d72cfb = 'search';
const $4f7acf20e25b7dd7$export$b3233b76460c1e7c = 'showProjectBuilder';

parcelRegister("7zXhs", function(module, exports) {

$parcel$export(module.exports, "getNow", () => $fc9902cea8bd7934$export$3991332aae1fc754);
const $fc9902cea8bd7934$export$3991332aae1fc754 = ()=>Date.now();

});




parcelRegister("8xpnS", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('geef3');
        const value = parcelRequire('bMsJH');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("geef3").then(()=>parcelRequire('bMsJH'));
}

});

parcelRegister("cHLvR", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('5nuyL');
        const value = parcelRequire('gMrqM');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("5nuyL").then(()=>parcelRequire('gMrqM'));
}

});

parcelRegister("7IBv4", function(module, exports) {

$parcel$export(module.exports, "ThemedLazySkeleton", () => $3cae0559b4ea3966$export$ddeb5d943c4f17e3);
/* ThemedLazySkeleton.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $84CBi = parcelRequire("84CBi");

var $90G8g = parcelRequire("90G8g");
const $3cae0559b4ea3966$export$ddeb5d943c4f17e3 = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3cae0559b4ea3966$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $84CBi.default), {
        name: "themed-spinner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $90G8g.ThemedSpinner), null))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3cae0559b4ea3966$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1osq _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("90G8g", function(module, exports) {

$parcel$export(module.exports, "ThemedSpinner", () => $3714b0c4b26abbc6$export$271c7b154ad6c401);
/* ThemedSpinner.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4Bees = parcelRequire("4Bees");
const $3714b0c4b26abbc6$export$271c7b154ad6c401 = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3714b0c4b26abbc6$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "large",
        ...props,
        testId: "business-theme-components.ui.themed-spinner"
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3714b0c4b26abbc6$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1xjgkwex",
            __cmplp.className
        ])
    });
});

});


parcelRegister("cOkcY", function(module, exports) {

$parcel$export(module.exports, "workflowIssuesResourceWithCondition", () => $8b908badba650023$export$62e53efa0dfbaeac);
$parcel$export(module.exports, "workflowIssuesResourceEarlyFetchWithCondition", () => $8b908badba650023$export$a7997c929b5bf6b6);
$parcel$export(module.exports, "useWorkflowIssues", () => $8b908badba650023$export$86b7de71bf71360d);

var $499dl = parcelRequire("499dl");

var $1ybV0 = parcelRequire("1ybV0");

var $3HCkE = parcelRequire("3HCkE");

var $9zYls = parcelRequire("9zYls");
var $jwzNs = parcelRequire("jwzNs");

var $g5IQt = parcelRequire("g5IQt");
const $8b908badba650023$var$RESOURCE_TYPE_KEY = 'BUSINESS_WORKFLOW_ISSUES';
const $8b908badba650023$var$RESOURCE_TYPE_KEY_EARLY_FETCH = 'BUSINESS_WORKFLOW_ISSUES_EARLY_FETCH';
const $8b908badba650023$var$EMPTY_DATA = {
    workflows: [],
    lastChangedTime: null
};
const $8b908badba650023$export$49027035af709702 = (0, $3HCkE.createResource)({
    type: $8b908badba650023$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey } = (0, $9zYls.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        return `${$8b908badba650023$var$RESOURCE_TYPE_KEY}_${projectKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: { isAnonymous: isAnonymous } })=>{
        // do not fetch the resource for anonymous access
        if (isAnonymous) return $8b908badba650023$var$EMPTY_DATA;
        const { projectKey: projectKey } = (0, $9zYls.getProjectKeyId)(match, query);
        return (0, $499dl.fetchWorkflowIssues)(projectKey);
    },
    maxAge: 1000,
    isBrowserOnly: true
});
const $8b908badba650023$export$62e53efa0dfbaeac = (0, $jwzNs.resourceWithCondition2)(()=>!(0, $1ybV0.ff)('jwm-early-fetch-board-issues_hxayf'), $8b908badba650023$export$49027035af709702);

const $8b908badba650023$export$7ba0ca409f751eb = (0, $3HCkE.createResource)({
    type: $8b908badba650023$var$RESOURCE_TYPE_KEY_EARLY_FETCH,
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey } = (0, $9zYls.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        return `${$8b908badba650023$var$RESOURCE_TYPE_KEY_EARLY_FETCH}_${projectKey}`;
    },
    getDataLoader: ()=>Promise.resolve((parcelRequire("g5IQt"))),
    getData: (0, $g5IQt.default),
    maxAge: 1000,
    isBrowserOnly: true
});
const $8b908badba650023$export$a7997c929b5bf6b6 = (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('jwm-early-fetch-board-issues_hxayf'), $8b908badba650023$export$7ba0ca409f751eb);
const $8b908badba650023$export$86b7de71bf71360d = ()=>{
    if ((0, $1ybV0.ff)('jwm-early-fetch-board-issues_hxayf')) // eslint-disable-next-line react-hooks/rules-of-hooks, @typescript-eslint/consistent-type-assertions
    return (0, $3HCkE.useResource)($8b908badba650023$export$a7997c929b5bf6b6);
    // forcing the return type due to react-resource-router's weird error types
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, react-hooks/rules-of-hooks
    return (0, $3HCkE.useResource)($8b908badba650023$export$49027035af709702);
};

});
parcelRegister("499dl", function(module, exports) {

$parcel$export(module.exports, "Unchanged", () => $2a0a0dafb1214e48$export$eccd6db33b8f6a89);
$parcel$export(module.exports, "fetchWorkflowIssues", () => $2a0a0dafb1214e48$export$17e2e8212d93f58d);

var $asu8X = parcelRequire("asu8X");

var $ZvXTS = parcelRequire("ZvXTS");

var $fVqUX = parcelRequire("fVqUX");

var $1ybV0 = parcelRequire("1ybV0");

var $7byHA = parcelRequire("7byHA");
class $2a0a0dafb1214e48$export$eccd6db33b8f6a89 extends Error {
}
const $2a0a0dafb1214e48$export$17e2e8212d93f58d = async (projectKey, ifChangedSince)=>{
    (0, $asu8X.di)(fetch);
    try {
        (0, $ZvXTS.markViewMetric)('jwm-board', (0, $78bb8734d7176028$export$23e322eb7c526958));
        const url = `/rest/board-api/1/board/${projectKey}/workflows?excludeLabels=true`;
        const response = await fetch(url, {
            ...(0, $fVqUX.default),
            headers: ifChangedSince ? {
                'x-aif-changed-since': ifChangedSince
            } : undefined
        });
        if (!response.ok) {
            if (response.status === 304) throw new $2a0a0dafb1214e48$export$eccd6db33b8f6a89('Workflow issues have not changed since the last request');
            throw new (0, $7byHA.default)(response.status);
        }
        const lastChangedTime = response.headers.get('x-alast-changed-time');
        const workflows = await response.json();
        let cleanedWorkflows;
        // As part of BAE-304 the workflows endpoint will return issueTypes for each workflow.
        // This is a breaking change for the board, so we need to make sure that we only return the
        // data that the board is expecting. The new board implementation handles the issueTypes
        if (!(0, $1ybV0.ff)('jwm.board-awesome-enhancements')) // @ts-expect-error TODO fix when BAE is cleaned up
        cleanedWorkflows = workflows.data.map((workflow)=>{
            const { issueTypes: issueTypes, ...cleanedWorkflow } = workflow;
            return cleanedWorkflow;
        });
        else cleanedWorkflows = workflows.data;
        return {
            workflows: cleanedWorkflows,
            lastChangedTime: lastChangedTime
        };
    } finally{
        (0, $ZvXTS.markViewMetric)('jwm-board', (0, $78bb8734d7176028$export$83ca21a50372ea3b));
    }
};

});
parcelRegister("ZvXTS", function(module, exports) {

$parcel$export(module.exports, "pageLoadMetrics", () => $1ace7e3b95066345$export$2878bf482e539059);
$parcel$export(module.exports, "markViewMetric", () => $1ace7e3b95066345$export$8d15b4fb25f90514);

var $lNfG4 = parcelRequire("lNfG4");

const $1ace7e3b95066345$var$slo = {
    fmp: {
        initial: {
            threshold: (0, $78bb8734d7176028$export$747aad128920134d)
        },
        transition: {
            threshold: (0, $78bb8734d7176028$export$747aad128920134d)
        }
    },
    tti: {
        initial: {
            threshold: (0, $78bb8734d7176028$export$e4f8d353742c04ac)
        },
        transition: {
            threshold: (0, $78bb8734d7176028$export$e4f8d353742c04ac)
        }
    }
};
const $1ace7e3b95066345$var$timings = [
    {
        key: (0, $78bb8734d7176028$export$540ffd289e5e0562),
        startMark: (0, $78bb8734d7176028$export$23e322eb7c526958),
        endMark: (0, $78bb8734d7176028$export$83ca21a50372ea3b)
    },
    {
        key: (0, $78bb8734d7176028$export$821ca6ff41f300ec),
        startMark: (0, $78bb8734d7176028$export$7b887ee35f2b465e),
        endMark: (0, $78bb8734d7176028$export$ac953882305d6102)
    },
    {
        key: (0, $78bb8734d7176028$export$7f7f60b5526c5ee3),
        startMark: (0, $78bb8734d7176028$export$b78f0bbf209e5f4),
        endMark: (0, $78bb8734d7176028$export$88ea1e280513690f)
    }
];
const $1ace7e3b95066345$export$2878bf482e539059 = {
    'approvals-view': (0, $lNfG4.metrics).pageLoad({
        key: 'jwm.approvals-view',
        slo: $1ace7e3b95066345$var$slo,
        timings: $1ace7e3b95066345$var$timings
    }),
    summary: (0, $lNfG4.metrics).pageLoad({
        key: 'jwm.summary-view',
        slo: $1ace7e3b95066345$var$slo,
        timings: $1ace7e3b95066345$var$timings
    }),
    'summary-embed': (0, $lNfG4.metrics).pageLoad({
        key: 'jwm.summary-view-embed',
        slo: $1ace7e3b95066345$var$slo,
        timings: $1ace7e3b95066345$var$timings
    }),
    list: (0, $lNfG4.metrics).pageLoad({
        key: 'jwm.list-view',
        slo: $1ace7e3b95066345$var$slo,
        timings: $1ace7e3b95066345$var$timings
    }),
    'list-embed': (0, $lNfG4.metrics).pageLoad({
        key: 'jwm.list-embed-view',
        slo: $1ace7e3b95066345$var$slo,
        timings: $1ace7e3b95066345$var$timings
    }),
    'software-list': (0, $lNfG4.metrics).pageLoad({
        key: 'jsw.list-view',
        slo: $1ace7e3b95066345$var$slo,
        timings: $1ace7e3b95066345$var$timings
    }),
    'software-list-embed': (0, $lNfG4.metrics).pageLoad({
        key: 'jsw.list-view-embed',
        slo: $1ace7e3b95066345$var$slo,
        timings: $1ace7e3b95066345$var$timings
    }),
    timeline: (0, $lNfG4.metrics).pageLoad({
        key: 'jwm.timeline-view',
        slo: $1ace7e3b95066345$var$slo,
        timings: $1ace7e3b95066345$var$timings
    }),
    'timeline-embed': (0, $lNfG4.metrics).pageLoad({
        key: 'jwm.timeline-embed-view',
        slo: $1ace7e3b95066345$var$slo,
        timings: $1ace7e3b95066345$var$timings
    }),
    calendar: (0, $lNfG4.metrics).pageLoad({
        key: 'jwm.calendar-view',
        slo: $1ace7e3b95066345$var$slo,
        timings: $1ace7e3b95066345$var$timings
    }),
    'calendar-embed': (0, $lNfG4.metrics).pageLoad({
        key: 'jwm.calendar-embed-view',
        slo: $1ace7e3b95066345$var$slo,
        timings: $1ace7e3b95066345$var$timings
    }),
    form: (0, $lNfG4.metrics).pageLoad({
        key: 'jwm.form-view',
        slo: $1ace7e3b95066345$var$slo,
        timings: $1ace7e3b95066345$var$timings
    }),
    'form-submit': (0, $lNfG4.metrics).pageLoad({
        key: 'jwm.form-submit-view',
        slo: $1ace7e3b95066345$var$slo,
        timings: $1ace7e3b95066345$var$timings
    }),
    'form-submit-embed': (0, $lNfG4.metrics).pageLoad({
        key: 'jwm.form-submit-embed-view',
        slo: $1ace7e3b95066345$var$slo,
        timings: $1ace7e3b95066345$var$timings
    }),
    'form-directory': (0, $lNfG4.metrics).pageLoad({
        key: 'jwm.form-directory-view',
        slo: $1ace7e3b95066345$var$slo,
        timings: $1ace7e3b95066345$var$timings
    }),
    board: (0, $lNfG4.metrics).pageLoad({
        key: 'jwm.board-view',
        slo: $1ace7e3b95066345$var$slo,
        timings: $1ace7e3b95066345$var$timings
    }),
    'jwm-board': (0, $lNfG4.metrics).pageLoad({
        key: 'jwm.jwm-board',
        slo: $1ace7e3b95066345$var$slo,
        timings: $1ace7e3b95066345$var$timings
    }),
    'jwm-board-embed': (0, $lNfG4.metrics).pageLoad({
        key: 'jwm.jwm-board-embed',
        slo: $1ace7e3b95066345$var$slo,
        timings: $1ace7e3b95066345$var$timings
    }),
    'jwm-pages': (0, $lNfG4.metrics).pageLoad({
        key: 'jwm.jwm-pages',
        slo: $1ace7e3b95066345$var$slo,
        timings: $1ace7e3b95066345$var$timings
    }),
    // TODO: will be removed with sploverview-decouple-calendar-perf-metrics
    'software-plan-calendar': (0, $lNfG4.metrics).pageLoad({
        key: 'jsw.plan-calendar-view',
        slo: $1ace7e3b95066345$var$slo,
        timings: $1ace7e3b95066345$var$timings
    })
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1ace7e3b95066345$var$startedMarks = {};
const $1ace7e3b95066345$export$8d15b4fb25f90514 = (view, mark)=>{
    const markKey = `${view}-${mark}`;
    // prevent overriding marks when markViewMetric() is called many times with the same param
    if ($1ace7e3b95066345$var$startedMarks[markKey]) return;
    $1ace7e3b95066345$var$startedMarks[markKey] = true;
    const metric = $1ace7e3b95066345$export$2878bf482e539059[view];
    metric?.mark(mark);
};

});
const $78bb8734d7176028$export$747aad128920134d = 3000;
const $78bb8734d7176028$export$e4f8d353742c04ac = 4000;
const $78bb8734d7176028$export$540ffd289e5e0562 = 'timeWaitingForBackendData';
const $78bb8734d7176028$export$23e322eb7c526958 = 'REQUEST_START';
const $78bb8734d7176028$export$83ca21a50372ea3b = 'REQUEST_END';
const $78bb8734d7176028$export$821ca6ff41f300ec = 'jwm-availableFieldsQuery';
const $78bb8734d7176028$export$7b887ee35f2b465e = 'AVAILABLE_FIELDS_QUERY_START';
const $78bb8734d7176028$export$ac953882305d6102 = 'AVAILABLE_FIELDS_QUERY_END';
const $78bb8734d7176028$export$7f7f60b5526c5ee3 = 'jwm-ui-render-time';
const $78bb8734d7176028$export$b78f0bbf209e5f4 = 'UI_RENDER_START';
const $78bb8734d7176028$export$88ea1e280513690f = 'UI_RENDER_END';



parcelRegister("g5IQt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e23c65cca34122d1$export$2e2bcd8739ae039);

var $499dl = parcelRequire("499dl");

var $6iz4v = parcelRequire("6iz4v");

var $1ybV0 = parcelRequire("1ybV0");

var $7byHA = parcelRequire("7byHA");

var $5yh8X = parcelRequire("5yh8X");

var $1aPBP = parcelRequire("1aPBP");
const $e23c65cca34122d1$var$EMPTY_DATA = {
    workflows: [],
    lastChangedTime: null
};
function $e23c65cca34122d1$var$transformWorkflows(workflows) {
    // As part of BAE-304 the workflows endpoint will return issueTypes for each workflow.
    // This is a breaking change for the board, so we need to make sure that we only return the
    // data that the board is expecting. The new board implementation handles the issueTypes
    if (!(0, $1ybV0.ff)('jwm.board-awesome-enhancements')) // @ts-expect-error TODO fix when BAE is cleaned up
    return workflows.map((workflow)=>{
        const { issueTypes: issueTypes, ...cleanedWorkflow } = workflow;
        return cleanedWorkflow;
    });
    return workflows;
}
function $e23c65cca34122d1$var$getEarlyPreload() {
    if (window.__JIRA_BUSINESS_BOARD_WORKFLOWS_DATA_PROMISE__) {
        const earlyPreloadPromise = window.__JIRA_BUSINESS_BOARD_WORKFLOWS_DATA_PROMISE__;
        window.__JIRA_BUSINESS_BOARD_WORKFLOWS_DATA_PROMISE__ = null;
        return earlyPreloadPromise.then((response)=>{
            if (!response.success) {
                if (response.error.status === 304) throw new (0, $499dl.Unchanged)('Workflow issues have not changed since the last request');
                throw new (0, $7byHA.default)(response.error.status);
            }
            return {
                workflows: $e23c65cca34122d1$var$transformWorkflows(response.workflows),
                lastChangedTime: null
            };
        });
    }
    return null;
}
function $e23c65cca34122d1$var$fetchData(projectKey) {
    const earlyPreload = $e23c65cca34122d1$var$getEarlyPreload();
    if (earlyPreload !== null) return earlyPreload;
    return (0, $499dl.fetchWorkflowIssues)(projectKey);
}
async function $e23c65cca34122d1$export$2e2bcd8739ae039({ match: match }, { tenantContext: tenantContext }) {
    const { isAnonymous: isAnonymous } = tenantContext;
    if (isAnonymous) return $e23c65cca34122d1$var$EMPTY_DATA;
    try {
        (0, $6iz4v.setMark)((0, $5yh8X.prefetchApiStartMark));
        const workflows = await $e23c65cca34122d1$var$fetchData(match.params.projectKey ?? '');
        (0, $6iz4v.setMark)((0, $5yh8X.prefetchApiReadyMark));
        return workflows;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $1aPBP.createResourceError)({
            component: 'spa.view.routes.business.board-workflows.getData',
            message: 'An error was thrown while prefetching board data',
            name: 'ResourceError'
        }, error);
    }
}

});
parcelRegister("5yh8X", function(module, exports) {

$parcel$export(module.exports, "appBundleReadyMark", () => $b15a1f5ef3252a04$export$7e50945a65dd40e);
$parcel$export(module.exports, "prefetchApiReadyMark", () => $b15a1f5ef3252a04$export$17cbe723d23101d8);
$parcel$export(module.exports, "prefetchApiStartMark", () => $b15a1f5ef3252a04$export$887fadb22e7c7735);
$parcel$export(module.exports, "jswRenderStartMark", () => $b15a1f5ef3252a04$export$bd099c0a906f4b3f);
$parcel$export(module.exports, "jswCreateReduxStoreStartMark", () => $b15a1f5ef3252a04$export$d23ef9e7633e30e7);
$parcel$export(module.exports, "jswCreateReduxStoreEndMark", () => $b15a1f5ef3252a04$export$319da6d901948a6d);
$parcel$export(module.exports, "jswTransformCriticalDataStartMark", () => $b15a1f5ef3252a04$export$f0b6622cdc5c7e4f);
$parcel$export(module.exports, "jswTransformCriticalDataEndMark", () => $b15a1f5ef3252a04$export$37e82663aa1e79a8);
$parcel$export(module.exports, "jswReduxSoftwareAppLoadedStartMark", () => $b15a1f5ef3252a04$export$21146514eacceb12);
$parcel$export(module.exports, "jswReduxSoftwareAppLoadedEndMark", () => $b15a1f5ef3252a04$export$4eb8d44ddb14424a);


var $1cNJ6 = parcelRequire("1cNJ6");
const $b15a1f5ef3252a04$export$7e50945a65dd40e = (0, $1cNJ6.getPrefixedMarkName)((0, $37f655a4e4d5690e$export$ff834eccc35b9089));
const $b15a1f5ef3252a04$export$17cbe723d23101d8 = (0, $1cNJ6.getPrefixedMarkName)((0, $37f655a4e4d5690e$export$86b05e34d462ead8));
const $b15a1f5ef3252a04$export$887fadb22e7c7735 = (0, $1cNJ6.getPrefixedMarkName)((0, $37f655a4e4d5690e$export$d6a604a7d9a390fb));
const $b15a1f5ef3252a04$export$bd099c0a906f4b3f = (0, $1cNJ6.getPrefixedMarkName)((0, $37f655a4e4d5690e$export$3ae43cc1782d058f));
const $b15a1f5ef3252a04$export$d23ef9e7633e30e7 = (0, $1cNJ6.getPrefixedMarkName)((0, $37f655a4e4d5690e$export$363f6703ffa600be));
const $b15a1f5ef3252a04$export$319da6d901948a6d = (0, $1cNJ6.getPrefixedMarkName)((0, $37f655a4e4d5690e$export$e87b74567b79c8));
const $b15a1f5ef3252a04$export$f0b6622cdc5c7e4f = (0, $1cNJ6.getPrefixedMarkName)((0, $37f655a4e4d5690e$export$99fe642459a8b02));
const $b15a1f5ef3252a04$export$37e82663aa1e79a8 = (0, $1cNJ6.getPrefixedMarkName)((0, $37f655a4e4d5690e$export$ab1f5705fc8e0571));
const $b15a1f5ef3252a04$export$21146514eacceb12 = (0, $1cNJ6.getPrefixedMarkName)((0, $37f655a4e4d5690e$export$8c3a9046da692c35));
const $b15a1f5ef3252a04$export$4eb8d44ddb14424a = (0, $1cNJ6.getPrefixedMarkName)((0, $37f655a4e4d5690e$export$5aa497d1efdcc5bf));

});

parcelRegister("1aPBP", function(module, exports) {

$parcel$export(module.exports, "createResourceError", () => $ab2f50dfea4673ae$export$13487d18466bc8a5);

var $gUUjF = parcelRequire("gUUjF");
class $ab2f50dfea4673ae$var$ResourceErrorClass extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(message, options){
        super(message);
        this.name = options.name || 'ResourceError';
        this.skipSentry = options.skipSentry;
    }
}
const $ab2f50dfea4673ae$export$13487d18466bc8a5 = ({ name: name = 'ResourceError', message: message = '', component: component = '', skipSentry: skipSentry = false }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
errorOverride)=>{
    (0, $gUUjF.default).safeErrorWithoutCustomerData(component, message, errorOverride);
    if (errorOverride) return errorOverride;
    return new $ab2f50dfea4673ae$var$ResourceErrorClass(message, {
        name: name,
        skipSentry: skipSentry
    });
};

});



parcelRegister("XJw0F", function(module, exports) {

$parcel$export(module.exports, "activityFeedResource", () => $9c7afa82c81731f6$export$928ea152e5c5de54);
$parcel$export(module.exports, "useActivityFeed", () => $9c7afa82c81731f6$export$ee1fe267047f502f);

var $1Y3Jh = parcelRequire("1Y3Jh");

var $3HCkE = parcelRequire("3HCkE");

var $9zYls = parcelRequire("9zYls");
const $9c7afa82c81731f6$var$RESOURCE_TYPE_KEY = 'BUSINESS_ACTIVITY_FEED';
const $9c7afa82c81731f6$var$EMPTY_DATA = {
    data: [],
    pageInfo: {
        hasNextPage: false,
        endCursor: ''
    }
};
const $9c7afa82c81731f6$export$928ea152e5c5de54 = (0, $3HCkE.createResource)({
    type: $9c7afa82c81731f6$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey } = (0, $9zYls.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        return `${$9c7afa82c81731f6$var$RESOURCE_TYPE_KEY}_${projectKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: { isAnonymous: isAnonymous } })=>{
        // do not fetch the resource for anonymous access
        if (isAnonymous) return $9c7afa82c81731f6$var$EMPTY_DATA;
        const { projectKey: projectKey } = (0, $9zYls.getProjectKeyId)(match, query);
        return (0, $1Y3Jh.fetchActivityFeed)(null, projectKey);
    },
    maxAge: 5000,
    isBrowserOnly: true
});
const $9c7afa82c81731f6$export$ee1fe267047f502f = ()=>// forcing the return type due to react-resource-router's weird error types
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $3HCkE.useResource)($9c7afa82c81731f6$export$928ea152e5c5de54);

});
parcelRegister("1Y3Jh", function(module, exports) {

$parcel$export(module.exports, "fetchActivityFeed", () => $d46a68c0a8135af1$export$967c92ed76f908b6);

var $asu8X = parcelRequire("asu8X");

var $7byHA = parcelRequire("7byHA");

var $fUPTl = parcelRequire("fUPTl");
const $d46a68c0a8135af1$var$PAGE_SIZE = 10;
const $d46a68c0a8135af1$var$CONTENT_TYPE = 'application/atom+xml; charset=UTF-8';
const $d46a68c0a8135af1$var$STREAM_PROVIDERS = 'thirdparty issues';
const $d46a68c0a8135af1$export$967c92ed76f908b6 = (after, projectKey)=>{
    (0, $asu8X.di)(fetch);
    const firstIndex = after != null ? Number(after) : 0;
    const maxResults = firstIndex + $d46a68c0a8135af1$var$PAGE_SIZE;
    return fetch(// @ts-expect-error - TS2345: Types of property 'maxResults' are incompatible. Type 'number' is not assignable to type 'string'.
    `/plugins/servlet/streams?${new URLSearchParams({
        maxResults: maxResults,
        relativeLinks: true,
        streams: `key IS ${projectKey}`,
        providers: $d46a68c0a8135af1$var$STREAM_PROVIDERS
    }).toString()}`, {
        headers: {
            'content-type': $d46a68c0a8135af1$var$CONTENT_TYPE
        }
    }).then((response)=>{
        if (!response.ok) throw new (0, $7byHA.default)(response.status, `Error server response: ${response.status}`);
        return response.text();
    }).then((rawResponse)=>{
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(rawResponse, 'application/xml');
        const entries = (0, $fUPTl.transformData)(xmlDoc);
        return {
            data: entries,
            pageInfo: {
                hasNextPage: entries.length >= maxResults,
                endCursor: String(entries.length)
            }
        };
    });
};

});
parcelRegister("fUPTl", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $e2838ca29310a45c$export$3ceb62baab058c6b);
const $e2838ca29310a45c$export$3ceb62baab058c6b = (xmlDoc)=>{
    // @ts-expect-error - TS2304 - Cannot find name 'ActivityFeedItem'.
    const result = [];
    // Typecheck with project references identifies this as error but existing typecheck is not so doesnt allow ts-expect-error, so used ts-ignore
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - Type 'NodeListOf<Element>' must have a '[Symbol.iterator]()' method that returns an iterator.
    for (const entry of xmlDoc.querySelectorAll('entry')){
        const id = entry.querySelector('id')?.textContent ?? '';
        const published = entry.querySelector('published')?.textContent ?? '';
        const name = entry.querySelector('author > name')?.textContent ?? '';
        const title = entry.querySelector('title')?.textContent ?? '';
        const iconUrl = entry.querySelector('[rel="http://streams.atlassian.com/syndication/icon"]')?.getAttribute('href') ?? '';
        const content = entry.querySelector('content')?.textContent;
        const feedItem = {
            id: id,
            author: {
                name: name,
                avatarUrl: ''
            },
            published: published,
            title: title,
            iconUrl: iconUrl,
            content: content
        };
        entry.querySelectorAll('author > link[rel=photo]').forEach((link)=>{
            if (link.getAttribute('media:height') === '48') feedItem.author.avatarUrl = link.getAttribute('href') ?? '';
        });
        result.push(feedItem);
    }
    return result;
};

});



parcelRegister("dIJG1", function(module, exports) {

$parcel$export(module.exports, "summaryDataResource", () => $7c3b553078399e73$export$cdfee963587c1ea4);
$parcel$export(module.exports, "useSummaryData", () => $7c3b553078399e73$export$c82acf736eaa253c);

var $dEAew = parcelRequire("dEAew");

var $3HCkE = parcelRequire("3HCkE");

var $1aPBP = parcelRequire("1aPBP");
var $9zYls = parcelRequire("9zYls");
const $7c3b553078399e73$var$RESOURCE_TYPE_KEY = 'BUSINESS_SUMMARY_DATA';
const $7c3b553078399e73$var$EMPTY_DATA = {
    overviewItems: null,
    issuesByStatus: null,
    issuesByPriority: null,
    issuesByAssignee: null,
    issuesByType: null
};
const $7c3b553078399e73$export$cdfee963587c1ea4 = (0, $3HCkE.createResource)({
    type: $7c3b553078399e73$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey } = (0, $9zYls.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        return `${$7c3b553078399e73$var$RESOURCE_TYPE_KEY}_${projectKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
        // do not fetch the resource for anonymous access
        if (isAnonymous) return $7c3b553078399e73$var$EMPTY_DATA;
        const { projectKey: projectKey } = (0, $9zYls.getProjectKeyId)(match, query);
        const jqlContext = `project = "${projectKey}"`;
        try {
            return await (0, $dEAew.fetchSummaryPageData)({
                cloudId: cloudId,
                jqlContext: jqlContext
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
            throw (0, $1aPBP.createResourceError)({
                component: 'spa.view.routes.business.summary-data.getData',
                message: `An error was thrown while prefetching the summary data. Status code: ${error?.statusCode}. Message: ${error?.message}`,
                name: 'ResourceError',
                skipSentry: isClientError
            });
        }
    },
    maxAge: 5000,
    isBrowserOnly: true
});
const $7c3b553078399e73$export$c82acf736eaa253c = ()=>// forcing the return type due to react-resource-router's weird error types
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $3HCkE.useResource)($7c3b553078399e73$export$cdfee963587c1ea4);

});
parcelRegister("dEAew", function(module, exports) {

$parcel$export(module.exports, "fetchSummaryPageData", () => $171e35a2047094d8$export$a3fa5b61d6f8cf86);

var $dlVOn = parcelRequire("dlVOn");

var $lRmyA = parcelRequire("lRmyA");


var $bQjFZ = parcelRequire("bQjFZ");

var $1l5Ta = parcelRequire("1l5Ta");
const $171e35a2047094d8$var$QUERY_NAME = 'SummaryPageData';
const $171e35a2047094d8$export$a3fa5b61d6f8cf86 = async ({ cloudId: cloudId, jqlContext: jqlContext })=>{
    const response = await (0, $lRmyA.performPostRequest)(`/rest/gira/1/?operation=${$171e35a2047094d8$var$QUERY_NAME}`, {
        body: JSON.stringify({
            query: (0, $bQjFZ.SUMMARY_PAGE_DATA_QUERY),
            variables: {
                cloudId: cloudId,
                jqlContext: jqlContext,
                doneThisWeekJql: `${jqlContext} AND ${(0, $41d3054f19febaab$export$d5aac1de7fafa2b0)}`,
                updatedThisWeekJql: `${jqlContext} AND ${(0, $41d3054f19febaab$export$b10a33c38cc20983)}`,
                createdThisWeekJql: `${jqlContext} AND ${(0, $41d3054f19febaab$export$48eb4b4c930c6378)}`,
                dueThisWeekJql: `${jqlContext} AND ${(0, $41d3054f19febaab$export$2573f5b8014b4068)}`,
                issuesByStatusJql: `${jqlContext} AND ${(0, $41d3054f19febaab$export$8cca17e1017ba894)}`,
                issuesByPriorityJql: `${jqlContext} AND ${(0, $41d3054f19febaab$export$c49e48bfa75ab23c)}`,
                issuesByAssigneeJql: `${jqlContext} AND ${(0, $41d3054f19febaab$export$c49e48bfa75ab23c)}`,
                issuesByTypeJql: `${jqlContext} AND ${(0, $41d3054f19febaab$export$c49e48bfa75ab23c)}`,
                pagedDataPageSize: (0, $41d3054f19febaab$export$c0ecd9bd08a86184)
            }
        })
    });
    if (response.errors != null) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
    if (response.data == null) throw new Error('GraphQL response has no data');
    return (0, $1l5Ta.transformData)(response.data);
};

});
const $41d3054f19febaab$export$d5aac1de7fafa2b0 = 'statusCategory = Done AND statusCategoryChangedDate >= -1w';
const $41d3054f19febaab$export$b10a33c38cc20983 = 'updatedDate >= -1w';
const $41d3054f19febaab$export$48eb4b4c930c6378 = 'createdDate >= -1w';
const $41d3054f19febaab$export$2573f5b8014b4068 = 'statusCategory != Done AND (duedate >= 0d AND duedate < 1w)';
const $41d3054f19febaab$export$8cca17e1017ba894 = '(statusCategory != Done OR (statusCategory = Done AND statusCategoryChangedDate >= -2w))';
const $41d3054f19febaab$export$c49e48bfa75ab23c = 'statusCategory != Done';
const $41d3054f19febaab$export$c0ecd9bd08a86184 = 8;
const $41d3054f19febaab$export$27f4fb65edc908d0 = `
  fragment IssuesByAssigneeFragment on JWMItemGroupConnection {
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      field {
        ... on UserField {
          userValue {
            accountId,
            avatarUrl,
            displayName
          }
        }
      }
      id,
      totalCount
    }
  }
`;
const $41d3054f19febaab$export$5b2a5373659a0414 = `
  fragment IssuesByTypeFragment on JWMItemGroupConnection {
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      field {
        ... on IssueTypeField {
              id
              name
              iconUrl
        }
      }
      id,
      totalCount
    }
  }
`;

parcelRegister("bQjFZ", function(module, exports) {

$parcel$export(module.exports, "SUMMARY_PAGE_DATA_QUERY", () => $438d71e3f7358cc6$export$7ea8f81ff5bf6361);

const $438d71e3f7358cc6$export$7ea8f81ff5bf6361 = `
  query JiraBusinessSummaryPageData($cloudId: ID!, $jqlContext: String!, $doneThisWeekJql: String!, $updatedThisWeekJql: String!, $createdThisWeekJql: String!, $dueThisWeekJql: String!, $issuesByStatusJql: String!, $issuesByPriorityJql: String!, $issuesByAssigneeJql: String!, $issuesByTypeJql: String!, $pagedDataPageSize: Int!) {
    jira {
      jqlBuilder(cloudId: $cloudId) {
        status: fieldValues(
          jqlTerm: "status"
          jqlContext: $jqlContext
          viewContext: JWM
        ) {
          edges {
            node {
              jqlTerm
              displayName
            }
          }
        }
      }
      doneThisWeek: jwmViewItems(cloudId: $cloudId, jql: $doneThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      updatedThisWeek: jwmViewItems(cloudId: $cloudId, jql: $updatedThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      createdThisWeek: jwmViewItems(cloudId: $cloudId, jql: $createdThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      dueThisWeek: jwmViewItems(cloudId: $cloudId, jql: $dueThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      totalUnresolvedIssues: jwmViewItems(cloudId: $cloudId, jql: $issuesByAssigneeJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
    }
    issuesByStatus: jwmItemGroups(jql: $issuesByStatusJql, groupByFieldId: "status", fieldIds: [], first: 50) {
      nodes {
        id
        field {
          ...on StatusField {
              name
              category {
                key
              }
          }
        }
        totalCount
      }
    }
    issuesByPriority: jwmItemGroups(jql: $issuesByPriorityJql, groupByFieldId: "priority", fieldIds: [], first: 50) {
      nodes {
        id
        field {
          ...on PriorityField {
            iconUrl
            name
          }
        }
        totalCount
      }
    }
    issuesByAssignee: jwmItemGroups(jql: $issuesByAssigneeJql, first: $pagedDataPageSize, fieldIds: [], groupByFieldId: "assignee", sortBy: {field: GROUP_COUNT, direction: DESC}) {
      ...IssuesByAssigneeFragment
    }
    issuesByType: jwmItemGroups(jql: $issuesByTypeJql, first: $pagedDataPageSize, fieldIds: [], groupByFieldId: "issuetype", sortBy: {field: GROUP_COUNT, direction: DESC}) {
      ...IssuesByTypeFragment
    }
  }

  ${(0, $41d3054f19febaab$export$27f4fb65edc908d0)}
  ${(0, $41d3054f19febaab$export$5b2a5373659a0414)}
`;

});

parcelRegister("1l5Ta", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $584624ffc9ba9478$export$3ceb62baab058c6b);

var $c2uS5 = parcelRequire("c2uS5");
const $584624ffc9ba9478$export$3ceb62baab058c6b = (data)=>({
        overviewItems: {
            doneThisWeek: data.jira.doneThisWeek?.totalCount ?? 0,
            updatedThisWeek: data.jira.updatedThisWeek?.totalCount ?? 0,
            createdThisWeek: data.jira.createdThisWeek?.totalCount ?? 0,
            dueThisWeek: data.jira.dueThisWeek?.totalCount ?? 0
        },
        issuesByStatus: // eslint-disable-next-line @typescript-eslint/no-explicit-any
        data.issuesByStatus?.nodes.map((node)=>({
                id: node.id,
                count: node.totalCount,
                status: {
                    name: node.field.name,
                    jqlTerm: data.jira.jqlBuilder?.status.edges.find((status)=>status.node.displayName === node.field.name)?.node.jqlTerm,
                    category: {
                        key: node.field.category.key
                    }
                }
            })) ?? null,
        issuesByPriority: // eslint-disable-next-line @typescript-eslint/no-explicit-any
        data.issuesByPriority?.nodes.map((node)=>({
                id: node.id,
                count: node.totalCount,
                priority: {
                    name: node.field.name,
                    iconUrl: node.field.iconUrl
                }
            })) ?? null,
        issuesByAssignee: data.issuesByAssignee ? {
            ...(0, $c2uS5.transformIssuesByAssigneeData)(data.issuesByAssignee),
            totalUnresolvedIssues: data.jira.totalUnresolvedIssues?.totalCount ?? 0
        } : null,
        issuesByType: data.issuesByType ? {
            ...(0, $c2uS5.transformIssuesByTypeData)(data.issuesByType),
            totalUnresolvedIssues: data.jira.totalUnresolvedIssues?.totalCount ?? 0
        } : null
    });

});
parcelRegister("c2uS5", function(module, exports) {

$parcel$export(module.exports, "transformIssuesByAssigneeData", () => $c3955638fae38514$export$cef1c6c4edf3287b);
$parcel$export(module.exports, "transformIssuesByTypeData", () => $c3955638fae38514$export$bc7f7d59cba70a26);
const $c3955638fae38514$export$cef1c6c4edf3287b = (data)=>({
        pageInfo: {
            hasNextPage: data.pageInfo.hasNextPage,
            endCursor: data.pageInfo.endCursor
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        data: data.nodes.map((node)=>({
                id: node.id,
                user: node.field.userValue ? {
                    avatarUrl: node.field.userValue.avatarUrl ?? '',
                    displayName: node.field.userValue.displayName,
                    accountId: node.field.userValue.accountId
                } : null,
                count: node.totalCount
            }))
    });
const $c3955638fae38514$export$bc7f7d59cba70a26 = (data)=>({
        pageInfo: {
            hasNextPage: data.pageInfo.hasNextPage,
            endCursor: data.pageInfo.endCursor
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        data: data.nodes.map((node)=>({
                id: node.id,
                issueType: node.field ? {
                    iconUrl: node.field.iconUrl,
                    name: node.field.name,
                    id: node.field.id
                } : null,
                count: node.totalCount
            }))
    });

});




parcelRegister("6NwXI", function(module, exports) {

var $5NFsb = parcelRequire("5NFsb");

var $8vD9V = parcelRequire("8vD9V");

var $kUey6 = parcelRequire("kUey6");

var $l0o5X = parcelRequire("l0o5X");
function $4f30e344cc062c5b$var$_slicedToArray(arr, i) {
    return $5NFsb(arr) || $8vD9V(arr, i) || $kUey6(arr, i) || $l0o5X();
}
module.exports = $4f30e344cc062c5b$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5NFsb", function(module, exports) {
function $4391af25e6bad157$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
module.exports = $4391af25e6bad157$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8vD9V", function(module, exports) {
function $631f982cfb04bc75$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $631f982cfb04bc75$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("l0o5X", function(module, exports) {
function $f4ac49d6fbb0d78c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $f4ac49d6fbb0d78c$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("dY715", function(module, exports) {

$parcel$export(module.exports, "markAsBentoBundleReady", () => $badbd94d97d705a8$export$d9ff0b3329728986);

var $hknOo = parcelRequire("hknOo");

var $2B87Z = parcelRequire("2B87Z");
let $badbd94d97d705a8$var$reportedBentoBundleReady = false;
const $badbd94d97d705a8$export$d9ff0b3329728986 = (importedBundle)=>{
    if (!false) importedBundle.then(()=>{
        // Mutex for reporter
        if ($badbd94d97d705a8$var$reportedBentoBundleReady) return;
        $badbd94d97d705a8$var$reportedBentoBundleReady = true;
        (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('bento.bundle-ready', 'jira-spa.js:eval-stop');
        const resources = performance.getEntriesByType('mark');
        for(let i = resources.length - 1; i >= 0; i -= 1)if (resources[i].name.startsWith('async-issue-app') && resources[i].name.endsWith((0, $hknOo.JS_EVAL_START))) {
            (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('bento.eval', resources[i].name);
            break;
        }
    });
    return importedBundle;
};

});

parcelRegister("kpDPI", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('dsiAd'),
            load('ekVbM'),
            load('92sUi'),
            load('i5RRW'),
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('2hmUs'),
            load('bCeK4'),
            load('4l5Cw')
        ]);
        const value = parcelRequire('gDUp5');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("dsiAd"),
        load("ekVbM"),
        load("92sUi"),
        load("i5RRW"),
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("2hmUs"),
        load("bCeK4"),
        load("4l5Cw")
    ]).then(()=>parcelRequire('gDUp5'));
}

});

parcelRegister("f4xMV", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('ekVbM'),
            load('92sUi'),
            load('i5RRW'),
            load('dsiAd'),
            load('2hmUs'),
            load('bCeK4'),
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('kMAKK')
        ]);
        const value = parcelRequire('9zAkH');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("ekVbM"),
        load("92sUi"),
        load("i5RRW"),
        load("dsiAd"),
        load("2hmUs"),
        load("bCeK4"),
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("kMAKK")
    ]).then(()=>parcelRequire('9zAkH'));
}

});

parcelRegister("lDWhn", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('iztF8');
        const value = parcelRequire('81i9P');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("iztF8").then(()=>parcelRequire('81i9P'));
}

});

parcelRegister("iVTCY", function(module, exports) {






if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("7jaFm")),
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('jc5Tv')
        ]);
        const value = parcelRequire('4KsXv');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("7jaFm")),
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("jc5Tv")
    ]).then(()=>parcelRequire('4KsXv'));
}

});

parcelRegister("6wsEw", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessProjectRedirectRoute", () => $5fcf01b1512d8afb$export$73b60789ceb8e1eb);
$parcel$export(module.exports, "jiraBusinessOverviewRedirectRoute", () => $5fcf01b1512d8afb$export$5ab0e07528c31349);

var $exb0h = parcelRequire("exb0h");
const $5fcf01b1512d8afb$export$73b60789ceb8e1eb = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_BUSINESS,
    name: (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_REDIRECT,
    path: '/jira/core/projects/:projectKey',
    exact: true,
    isRedirect: true
};
const $5fcf01b1512d8afb$export$5ab0e07528c31349 = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_BUSINESS,
    name: (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_OVERVIEW_REDIRECT,
    path: '/jira/core/overviews/:overviewId',
    exact: true,
    isRedirect: true
};

});

parcelRegister("aK25G", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('8bcjs')
        ]);
        const value = parcelRequire('3xdch');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("8bcjs")
    ]).then(()=>parcelRequire('3xdch'));
}

});

parcelRegister("hI8Vl", function(module, exports) {

$parcel$export(module.exports, "default", () => $95e02a014bb15cef$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c8feb3e3b230e016b49ff241789196d4>>
 * @relayHash 446ffd2991ac0a50e0a16f4f22e9d529
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ca82ea6b5cf3f717151a9cf554cb7b366e70357c10a0104135bb4a2c3357c642

var $cNy9K = parcelRequire("cNy9K");
const $95e02a014bb15cef$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "attachmentCount"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "count"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "durationInSeconds"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filters"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isAttachmentsM2Enabled"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "maxTokenLength"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v9 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v10 = [
        v9 /*: any*/ 
    ], v11 = {
        "kind": "Variable",
        "name": "attachmentCount",
        "variableName": "attachmentCount"
    }, v12 = {
        "kind": "Variable",
        "name": "durationInSeconds",
        "variableName": "durationInSeconds"
    }, v13 = {
        "kind": "Variable",
        "name": "issueSearchInput",
        "variableName": "issueSearchInput"
    }, v14 = {
        "kind": "Variable",
        "name": "maxTokenLength",
        "variableName": "maxTokenLength"
    }, v15 = {
        "kind": "Variable",
        "name": "filters",
        "variableName": "filters"
    }, v16 = [
        {
            "args": v10 /*: any*/ ,
            "kind": "ScalarField",
            "name": "mediaClientId"
        },
        {
            "args": v10 /*: any*/ ,
            "kind": "ScalarField",
            "name": "mediaExternalEndpointUrl"
        }
    ], v17 = [
        v9 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
        },
        v13 /*: any*/ 
    ], v18 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v19 = {
        "kind": "ScalarField",
        "name": "message"
    }, v20 = [
        v19 /*: any*/ 
    ], v21 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "attachmentCount"
    }, v22 = {
        "kind": "ScalarField",
        "name": "id"
    }, v23 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "fileName"
            },
            {
                "kind": "ScalarField",
                "name": "mediaApiFileId"
            },
            {
                "kind": "ScalarField",
                "name": "attachmentId"
            },
            {
                "args": [
                    v12 /*: any*/ ,
                    v14 /*: any*/ 
                ],
                "kind": "ScalarField",
                "name": "mediaReadToken"
            },
            {
                "kind": "ScalarField",
                "name": "parentName"
            },
            v22 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                    v18 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v22 /*: any*/ 
                ]
            },
            {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isJiraAttachment"
            }
        ],
        "type": "JiraPlatformAttachment"
    }, v24 = {
        "kind": "InlineFragment",
        "selections": [
            v22 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v25 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "key"
    }, v27 = {
        "alias": "fields",
        "args": [
            {
                "kind": "Literal",
                "name": "ids",
                "value": [
                    "summary",
                    "issuetype"
                ]
            }
        ],
        "concreteType": "JiraIssueFieldConnection",
        "kind": "LinkedField",
        "name": "fieldsById",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueFieldEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v18 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "fieldId"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "text"
                                    }
                                ],
                                "type": "JiraSingleLineTextField"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueType",
                                        "kind": "LinkedField",
                                        "name": "issueType",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "name"
                                            },
                                            {
                                                "concreteType": "JiraAvatar",
                                                "kind": "LinkedField",
                                                "name": "avatar",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "xsmall"
                                                    }
                                                ]
                                            },
                                            v22 /*: any*/ 
                                        ]
                                    }
                                ],
                                "type": "JiraIssueTypeField"
                            },
                            v22 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\"])"
    }, v28 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v29 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v30 = [
        v9 /*: any*/ ,
        v15 /*: any*/ ,
        v21 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "projectKeys",
            "variableName": "projectKey"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "uiJWMAttachmentsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "condition": "isAttachmentsM2Enabled",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "args": v10 /*: any*/ ,
                                        "kind": "FragmentSpread",
                                        "name": "grid_businessAttachments_GridJiraIssue_jiraQuery"
                                    }
                                ]
                            },
                            {
                                "condition": "isAttachmentsM2Enabled",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "args": v10 /*: any*/ ,
                                        "kind": "FragmentSpread",
                                        "name": "grid_businessAttachments_GridAttachment_jiraQuery"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                },
                {
                    "condition": "isAttachmentsM2Enabled",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": [
                                v11 /*: any*/ ,
                                v9 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "count",
                                    "variableName": "count"
                                },
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ 
                            ],
                            "kind": "FragmentSpread",
                            "name": "grid_businessAttachments_GridJiraIssue_query"
                        }
                    ]
                },
                {
                    "condition": "isAttachmentsM2Enabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                v11 /*: any*/ ,
                                v9 /*: any*/ ,
                                v12 /*: any*/ ,
                                v15 /*: any*/ ,
                                v14 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "projectKey",
                                    "variableName": "projectKey"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "grid_businessAttachments_GridAttachment_query"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v6 /*: any*/ ,
                v3 /*: any*/ ,
                v7 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v8 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "uiJWMAttachmentsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isAttachmentsM2Enabled",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": v16 /*: any*/ 
                        },
                        {
                            "condition": "isAttachmentsM2Enabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": v16 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "isAttachmentsM2Enabled",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "issues",
                                    "args": v17 /*: any*/ ,
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issueSearchStable",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "issueSearchError",
                                            "plural": false,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "messages"
                                                        }
                                                    ],
                                                    "type": "JiraInvalidJqlError"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v20 /*: any*/ ,
                                                    "type": "JiraInvalidSyntaxError"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v20 /*: any*/ ,
                                                    "type": "JiraServerError"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                v21 /*: any*/ 
                                                            ],
                                                            "concreteType": "JiraAttachmentConnection",
                                                            "kind": "LinkedField",
                                                            "name": "attachments",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAttachmentEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v18 /*: any*/ ,
                                                                                v23 /*: any*/ ,
                                                                                v24 /*: any*/ ,
                                                                                v25 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v26 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v27 /*: any*/ ,
                                                        v18 /*: any*/ 
                                                    ]
                                                },
                                                v28 /*: any*/ 
                                            ]
                                        },
                                        v29 /*: any*/ ,
                                        v25 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "issues",
                                    "args": v17 /*: any*/ ,
                                    "filters": [
                                        "cloudId",
                                        "issueSearchInput"
                                    ],
                                    "handle": "connection",
                                    "key": "JiraIssuesFragment_issues",
                                    "kind": "LinkedHandle",
                                    "name": "issueSearchStable"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isAttachmentsM2Enabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v30 /*: any*/ ,
                                    "concreteType": "JiraAttachmentConnection",
                                    "kind": "LinkedField",
                                    "name": "attachmentSearch",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraAttachmentEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v18 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssue",
                                                            "kind": "LinkedField",
                                                            "name": "issue",
                                                            "plural": false,
                                                            "selections": [
                                                                v26 /*: any*/ ,
                                                                v22 /*: any*/ ,
                                                                v27 /*: any*/ 
                                                            ]
                                                        },
                                                        v23 /*: any*/ ,
                                                        v24 /*: any*/ ,
                                                        v25 /*: any*/ 
                                                    ]
                                                },
                                                v28 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "QueryError",
                                            "kind": "LinkedField",
                                            "name": "errors",
                                            "plural": true,
                                            "selections": [
                                                v19 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        v18 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "errorType"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "statusCode"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v29 /*: any*/ ,
                                        v25 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v30 /*: any*/ ,
                                    "filters": [
                                        "cloudId",
                                        "projectKeys",
                                        "filters"
                                    ],
                                    "handle": "connection",
                                    "key": "JiraAttachmentsFragment_attachmentSearch",
                                    "kind": "LinkedHandle",
                                    "name": "attachmentSearch"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ca82ea6b5cf3f717151a9cf554cb7b366e70357c10a0104135bb4a2c3357c642",
            "metadata": {},
            "name": "uiJWMAttachmentsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$95e02a014bb15cef$var$node.hash = "a616ae3680f58253e9f34b7d827defa9";
(0, $cNy9K.PreloadableQueryRegistry).set($95e02a014bb15cef$var$node.params.id, $95e02a014bb15cef$var$node);
var $95e02a014bb15cef$export$2e2bcd8739ae039 = $95e02a014bb15cef$var$node;

});

parcelRegister("btM71", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('73849')
        ]);
        const value = parcelRequire('hNMkR');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("73849")
    ]).then(()=>parcelRequire('hNMkR'));
}

});

parcelRegister("kI9SR", function(module, exports) {






if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("ggpPc")),
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('aqaOl')
        ]);
        const value = parcelRequire('eDUuW');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("ggpPc")),
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("aqaOl")
    ]).then(()=>parcelRequire('eDUuW'));
}

});

parcelRegister("aziM1", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('2BIYA')
        ]);
        const value = parcelRequire('9SpZi');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("2BIYA")
    ]).then(()=>parcelRequire('9SpZi'));
}

});

parcelRegister("jj3FZ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('7owPW')
        ]);
        const value = parcelRequire('1jI4V');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("7owPW")
    ]).then(()=>parcelRequire('1jI4V'));
}

});

parcelRegister("28Vhs", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('erpOc')
        ]);
        const value = parcelRequire('10aZy');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("erpOc")
    ]).then(()=>parcelRequire('10aZy'));
}

});

parcelRegister("9H20x", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('9pv5E');
        const value = parcelRequire('aSD11');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("9pv5E").then(()=>parcelRequire('aSD11'));
}

});

parcelRegister("03eMy", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('12nv9')
        ]);
        const value = parcelRequire('5xcCk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("12nv9")
    ]).then(()=>parcelRequire('5xcCk'));
}

});

parcelRegister("lBxZN", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('4KJB9')
        ]);
        const value = parcelRequire('fq00b');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("4KJB9")
    ]).then(()=>parcelRequire('fq00b'));
}

});

parcelRegister("vHoGQ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('aoz7O')
        ]);
        const value = parcelRequire('gEf2h');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("aoz7O")
    ]).then(()=>parcelRequire('gEf2h'));
}

});

parcelRegister("4N0Mz", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('58UdU')
        ]);
        const value = parcelRequire('36FLn');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("58UdU")
    ]).then(()=>parcelRequire('36FLn'));
}

});

parcelRegister("ks5p8", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('jw4LJ')
        ]);
        const value = parcelRequire('a3nYN');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("jw4LJ")
    ]).then(()=>parcelRequire('a3nYN'));
}

});

parcelRegister("8mEC5", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('29gzI')
        ]);
        const value = parcelRequire('30ifj');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("29gzI")
    ]).then(()=>parcelRequire('30ifj'));
}

});

parcelRegister("2VCTb", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('6hbVD')
        ]);
        const value = parcelRequire('e6kDB');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("6hbVD")
    ]).then(()=>parcelRequire('e6kDB'));
}

});

parcelRegister("h1FS4", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('lMO6f')
        ]);
        const value = parcelRequire('gFMRr');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("lMO6f")
    ]).then(()=>parcelRequire('gFMRr'));
}

});

parcelRegister("hZKR7", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('gDG2i')
        ]);
        const value = parcelRequire('32q0E');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("gDG2i")
    ]).then(()=>parcelRequire('32q0E'));
}

});

parcelRegister("hUgt3", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('aEruT')
        ]);
        const value = parcelRequire('9kgc9');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("aEruT")
    ]).then(()=>parcelRequire('9kgc9'));
}

});

parcelRegister("a5x9l", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('1FMdw')
        ]);
        const value = parcelRequire('4LoSq');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("1FMdw")
    ]).then(()=>parcelRequire('4LoSq'));
}

});

parcelRegister("intl4", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('6wB8z')
        ]);
        const value = parcelRequire('YEraZ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("6wB8z")
    ]).then(()=>parcelRequire('YEraZ'));
}

});

parcelRegister("7iHNh", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('hX8k8')
        ]);
        const value = parcelRequire('aEWvJ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("hX8k8")
    ]).then(()=>parcelRequire('aEWvJ'));
}

});

parcelRegister("bFA4H", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('2EBPP')
        ]);
        const value = parcelRequire('lUiUI');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("2EBPP")
    ]).then(()=>parcelRequire('lUiUI'));
}

});

parcelRegister("5jdjj", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('2p284')
        ]);
        const value = parcelRequire('2aG5K');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("2p284")
    ]).then(()=>parcelRequire('2aG5K'));
}

});

parcelRegister("kSdpO", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('bc0KZ')
        ]);
        const value = parcelRequire('eQMpF');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("bc0KZ")
    ]).then(()=>parcelRequire('eQMpF'));
}

});

parcelRegister("aK8GH", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('bL7Bw')
        ]);
        const value = parcelRequire('3XEFg');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("bL7Bw")
    ]).then(()=>parcelRequire('3XEFg'));
}

});

parcelRegister("bmKiO", function(module, exports) {

$parcel$export(module.exports, "NORMAL_EARLY_ASSET_STRATEGY", () => $3e02e9822ae54785$export$137d6d169f402a59);
$parcel$export(module.exports, "AGGRESSIVE_EARLY_ASSET_STRATEGY", () => $3e02e9822ae54785$export$ad16a91905cefb0a);
const $3e02e9822ae54785$var$COMMON_ASSET_REGEX = /.*\/commons(-entry|~[0-9a-z]*)?(\.[0-9a-z]*)?(\.[0-9])?\.js/;
const $3e02e9822ae54785$var$VENDOR_ASSET_REGEX = /.*\/vendor(-entry|~[0-9a-z]*)?(\.[0-9a-z]*)?(\.[0-9])?\.js/;
const $3e02e9822ae54785$var$PARCEL_COMMON_ASSET_REGEX = /.*\/shared~commons(~ar)?(\.[0-9a-z]*)\.js/;
const $3e02e9822ae54785$var$PARCEL_VENDOR_ASSET_REGEX = /.*\/shared~vendor(~ar)?(\.[0-9a-z]*)\.js/;
const $3e02e9822ae54785$export$137d6d169f402a59 = [
    $3e02e9822ae54785$var$VENDOR_ASSET_REGEX,
    $3e02e9822ae54785$var$PARCEL_VENDOR_ASSET_REGEX
];
const $3e02e9822ae54785$export$ad16a91905cefb0a = [
    $3e02e9822ae54785$var$VENDOR_ASSET_REGEX,
    $3e02e9822ae54785$var$COMMON_ASSET_REGEX,
    $3e02e9822ae54785$var$PARCEL_VENDOR_ASSET_REGEX,
    $3e02e9822ae54785$var$PARCEL_COMMON_ASSET_REGEX
];

});

parcelRegister("a5edq", function(module, exports) {

$parcel$export(module.exports, "shouldLoadUIFBoardResources", () => $6535e46035956c28$export$d8d4641986a9ac7f);
$parcel$export(module.exports, "getRapidboardResources", () => $6535e46035956c28$export$3a5e56bd5231a56b);
$parcel$export(module.exports, "getRapidBoardDataResource", () => $6535e46035956c28$export$1c63de7f548f965f);
$parcel$export(module.exports, "getUIFBacklogDataResource", () => $6535e46035956c28$export$ee826506b3baa13a);

var $1ybV0 = parcelRequire("1ybV0");

var $gFGRe = parcelRequire("gFGRe");

var $jwzNs = parcelRequire("jwzNs");

var $693rf = parcelRequire("693rf");

var $j5J5y = parcelRequire("j5J5y");

var $9fHn9 = parcelRequire("9fHn9");

var $idF17 = parcelRequire("idF17");

var $10v3r = parcelRequire("10v3r");

var $azMNr = parcelRequire("azMNr");
const $6535e46035956c28$export$d8d4641986a9ac7f = ()=>!false;
const $6535e46035956c28$export$462ca08d6ce67848 = ()=>!$6535e46035956c28$export$d8d4641986a9ac7f();
const $6535e46035956c28$export$3a5e56bd5231a56b = ()=>[
        (0, $azMNr.wrmBundleResource),
        (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('jsw.classic.board.api-calls.modern-frontend'), (0, $j5J5y.boardConfigApiResource), (0, $693rf.boardConfigResource)),
        (0, $jwzNs.resourceWithCondition2)($6535e46035956c28$export$462ca08d6ce67848, (0, $10v3r.rapidboardResource))
    ];
const $6535e46035956c28$export$1c63de7f548f965f = ()=>(0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('jsw.classic.board.api-calls.modern-frontend'), (0, $9fHn9.boardDataResource), (0, $idF17.initialAllDataResource));
const $6535e46035956c28$export$ee826506b3baa13a = ()=>[
        (0, $jwzNs.resourceWithCondition2)(()=>$6535e46035956c28$export$d8d4641986a9ac7f() && !(0, $1ybV0.ff)('jsw.perf.enable-indexeddb-caching-for-backlog'), (0, $gFGRe.uifBacklogResourceOld)),
        (0, $jwzNs.resourceWithCondition2)(()=>$6535e46035956c28$export$d8d4641986a9ac7f() && (0, $1ybV0.ff)('jsw.perf.enable-indexeddb-caching-for-backlog'), (0, $gFGRe.uifBacklogResource))
    ];

});
parcelRegister("gFGRe", function(module, exports) {

$parcel$export(module.exports, "uifBacklogResourceOld", () => $1c49d4c5a02eb71e$export$db83ef0443397b85);
$parcel$export(module.exports, "uifBacklogResource", () => $1c49d4c5a02eb71e$export$c182dffb98985208);

var $3HCkE = parcelRequire("3HCkE");


const $1c49d4c5a02eb71e$export$db83ef0443397b85 = (0, $3HCkE.createResource)({
    type: (0, $d05ef78e80305237$export$8f9824ba4409b537),
    getKey: ({ match: { params: { boardId: boardId } }, query: { config: config } })=>/*
            When navigating to and from the board settings page we need
            the data to get reloaded. So we are updating the key to force a refresh
        */ [
            'uif-backlog-data'
        ].concat(boardId ?? '').concat(config ? `config-${config}` : '').filter(Boolean).join('-'),
    getDataLoader: ()=>(parcelRequire("ctaLg")),
    // Setting mexAge to 0 so it will get the data again after coming back from a config page
    maxAge: 0
});

const $1c49d4c5a02eb71e$export$c182dffb98985208 = (0, $3HCkE.createResource)({
    type: (0, $d05ef78e80305237$export$d15ce4feabd76ea),
    getKey: ({ match: { params: { boardId: boardId } }, query: { config: config } })=>/*
            When navigating to and from the board settings page we need
            the data to get reloaded. So we are updating the key to force a refresh
        */ [
            'uif-backlog-data'
        ].concat(boardId ?? '').concat(config ? `config-${config}` : '').filter(Boolean).join('-'),
    getDataLoader: ()=>(parcelRequire("6XY9n")),
    // Setting mexAge to 0 so it will get the data again after coming back from a config page
    maxAge: 0
});

});
const $d05ef78e80305237$export$d15ce4feabd76ea = 'NEXTGEN_BACKLOG_REST';
const $d05ef78e80305237$export$8f9824ba4409b537 = 'NEXTGEN_BACKLOG_REST_OLD';

parcelRegister("ctaLg", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hsO3U');
        const value = parcelRequire('ktOjl');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hsO3U").then(()=>parcelRequire('ktOjl'));
}

});

parcelRegister("6XY9n", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('fy9iE');
        const value = parcelRequire('5hldr');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("fy9iE").then(()=>parcelRequire('5hldr'));
}

});


parcelRegister("693rf", function(module, exports) {

$parcel$export(module.exports, "boardConfigResource", () => $686ce37c65523aa4$export$5d16d5f1340da88f);

var $3HCkE = parcelRequire("3HCkE");

var $4abw7 = parcelRequire("4abw7");

const $686ce37c65523aa4$export$5d16d5f1340da88f = (0, $3HCkE.createResource)({
    type: (0, $4abw7.RESOURCE_TYPE_RAPIDBOARDS_BOARD_CONFIG),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("iTuaP")),
    maxAge: Number.MAX_VALUE,
    isBrowserOnly: true
});

});
parcelRegister("4abw7", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_BOARD_CONFIG", () => $8d7bb0de0f14cf1f$export$88e2a0b89be042c1);
$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA", () => $8d7bb0de0f14cf1f$export$ba075d0985968d1c);
$parcel$export(module.exports, "RESOURCE_TYPE_PROJECT_NEW_ISSUE_VIEW_LOCK_IN_STATUS", () => $8d7bb0de0f14cf1f$export$395f77888d07f2e0);
$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_RESOURCE", () => $8d7bb0de0f14cf1f$export$4f7c4e3508fd2a07);
$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_WRM_BUNDLE", () => $8d7bb0de0f14cf1f$export$3328c8e71fda97bb);
$parcel$export(module.exports, "WRM_RESOURCES_ARRAY", () => $8d7bb0de0f14cf1f$export$ef21257df3d71188);
$parcel$export(module.exports, "WRM_HERITAGE_RESOURCES_FHD_ARRAY", () => $8d7bb0de0f14cf1f$export$ccd0929652c235de);
$parcel$export(module.exports, "WRM_BOARD_RESOURCES_FHD_ARRAY", () => $8d7bb0de0f14cf1f$export$1d16bdcc94a40107);
$parcel$export(module.exports, "WRM_BACKLOG_RESOURCES_FHD_ARRAY", () => $8d7bb0de0f14cf1f$export$1f599d2eef0a7281);
const $8d7bb0de0f14cf1f$export$88e2a0b89be042c1 = 'RESOURCE_RAPIDBOARDS_BOARD_CONFIG';
const $8d7bb0de0f14cf1f$export$ba075d0985968d1c = 'RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA';
const $8d7bb0de0f14cf1f$export$395f77888d07f2e0 = 'PROJECT_NEW_ISSUE_VIEW_LOCK_IN_STATUS';
const $8d7bb0de0f14cf1f$export$4f7c4e3508fd2a07 = 'RESOURCE_TYPE_RAPIDBOARDS_RESOURCE';
const $8d7bb0de0f14cf1f$export$75dfa03544a19422 = 'ROADMAP';
const $8d7bb0de0f14cf1f$export$3328c8e71fda97bb = 'RESOURCE_RAPIDBOARDS_WRM_BUNDLE';
const $8d7bb0de0f14cf1f$export$ef21257df3d71188 = [
    '_super',
    'wrc!greenhopper-rapid-non-gadget',
    'wrc!gh-rapid',
    'wrc!jira.global',
    'wrc!jira.general',
    'wrc!atl.global',
    // Required to prevent an error on initial loading of reports
    'wrc!jira.webresources:header',
    // Required for Control Chart report page
    'wrc!jira.webresources:calendar',
    'wrc!jira.webresources:calendar-en',
    'wrc!jira.webresources:jira.webresources:calendar-localisation-moment',
    // Required for explicit usage of jQuery
    'wrc!com.atlassian.jira.project-templates-plugin:project-templates-plugin-resources',
    // Required for the styles of the toggle button when transitioning from reports to board settings
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-aui-toggle',
    // Required for the profile card in board settings, that doesn't really render because it has wrong
    // parameters and it has been broken for ages, but at least prevents noisy errors
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:profilecard',
    'wrc!gh-rapid-config',
    'wrc!gh-rapid-analytics',
    'wrc!gh-rapid-charts',
    'wrc!jira.webresources:mentions-feature',
    'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-dialog-resources-ctx'
];
const $8d7bb0de0f14cf1f$export$ccd0929652c235de = [];
const $8d7bb0de0f14cf1f$export$1d16bdcc94a40107 = [
    'wrc!gh-rapid-lwf-board-fhd',
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:feature-flags',
    'wrc!com.atlassian.auiplugin:aui-spinner',
    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
    'wrc!com.atlassian.analytics.analytics-client:js-events'
];
const $8d7bb0de0f14cf1f$export$1f599d2eef0a7281 = [
    'wrc!gh-rapid-backlog-fhd',
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:header',
    'wrc!jira.webresources:feature-flags',
    'wrc!com.atlassian.auiplugin:aui-spinner',
    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
    'wrc!com.atlassian.analytics.analytics-client:js-events'
];

});

parcelRegister("iTuaP", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('4uY6S');
        const value = parcelRequire('efMpc');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("4uY6S").then(()=>parcelRequire('efMpc'));
}

});


parcelRegister("j5J5y", function(module, exports) {

$parcel$export(module.exports, "boardConfigApiResource", () => $a885dc4b32424c7f$export$dd9dec064acb0c4e);

var $1ybV0 = parcelRequire("1ybV0");

var $3HCkE = parcelRequire("3HCkE");

var $4abw7 = parcelRequire("4abw7");
const $a885dc4b32424c7f$var$configResourceCacheTime = ()=>(0, $1ybV0.getFeatureFlagValue)('jsw.classic.board.api-calls.config-cache-time', 0);

const $a885dc4b32424c7f$export$dd9dec064acb0c4e = (0, $3HCkE.createResource)({
    type: (0, $4abw7.RESOURCE_TYPE_RAPIDBOARDS_BOARD_CONFIG),
    getKey: ({ match: match, query: query })=>{
        const boardId = match.params.boardId != null ? match.params.boardId : query.rapidView;
        return `rapidViewConfig-${boardId}`; // Should Also have a mode but for now lets use only id
    },
    getDataLoader: ()=>(parcelRequire("2NVpl")),
    maxAge: false ? 0 : $a885dc4b32424c7f$var$configResourceCacheTime() * 1000,
    isBrowserOnly: true
});

});
parcelRegister("2NVpl", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('k7Uvh');
        const value = parcelRequire('2WyND');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("k7Uvh").then(()=>parcelRequire('2WyND'));
}

});


parcelRegister("9fHn9", function(module, exports) {

$parcel$export(module.exports, "boardDataResource", () => $2e783f8e2beaf754$export$138fa635416978f7);

var $3HCkE = parcelRequire("3HCkE");

var $4abw7 = parcelRequire("4abw7");

var $iG24k = parcelRequire("iG24k");

const $2e783f8e2beaf754$export$138fa635416978f7 = (0, $3HCkE.createResource)({
    type: (0, $4abw7.RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA),
    getKey: ({ match: match, query: query, route: route })=>{
        const { name: name = '' } = route || {};
        const boardId = match.params.boardId != null ? match.params.boardId : query.rapidView;
        const { config: config } = query;
        const hasConfig = Boolean(config);
        let key = 'rapidBoardData';
        if ((0, $iG24k.isBoardRoute)(name)) key = `boardData-${boardId}::hasConfig=${hasConfig}`;
        else if ((0, $iG24k.isBacklogRoute)(name)) key = `backlogData-${boardId}::hasConfig=${hasConfig}`;
        return key;
    },
    getDataLoader: ()=>(parcelRequire("bozaw")),
    maxAge: 0,
    isBrowserOnly: true
});

});
parcelRegister("iG24k", function(module, exports) {

$parcel$export(module.exports, "isBoardRoute", () => $f15ca5b1ef6eee74$export$437d4d6e25681588);
$parcel$export(module.exports, "isBacklogRoute", () => $f15ca5b1ef6eee74$export$bcb853db5e3e8054);

var $exb0h = parcelRequire("exb0h");
const $f15ca5b1ef6eee74$export$437d4d6e25681588 = (routeName)=>routeName === (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_BOARD || routeName === (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_USER_BOARD || routeName === (0, $exb0h.ROUTE_NAMES).SERVICEDESK_BOARDS;
const $f15ca5b1ef6eee74$export$bcb853db5e3e8054 = (routeName)=>routeName === (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_BACKLOG || routeName === (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_USER_BACKLOG;

});

parcelRegister("bozaw", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('52qFn');
        const value = parcelRequire('9HiUl');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("52qFn").then(()=>parcelRequire('9HiUl'));
}

});


parcelRegister("idF17", function(module, exports) {

$parcel$export(module.exports, "initialAllDataResource", () => $462b644b46c9bc09$export$4680aabd39eb6d1c);

var $3HCkE = parcelRequire("3HCkE");

var $4abw7 = parcelRequire("4abw7");

const $462b644b46c9bc09$export$4680aabd39eb6d1c = (0, $3HCkE.createResource)({
    type: (0, $4abw7.RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("hLefw")),
    maxAge: Number.MAX_VALUE,
    isBrowserOnly: true
});

});
parcelRegister("hLefw", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('fQHEB');
        const value = parcelRequire('i6uNI');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("fQHEB").then(()=>parcelRequire('i6uNI'));
}

});


parcelRegister("10v3r", function(module, exports) {

$parcel$export(module.exports, "rapidboardResource", () => $d0fec4ac46f6b7e1$export$d0f42a55e7c5752c);

var $3HCkE = parcelRequire("3HCkE");

var $4abw7 = parcelRequire("4abw7");

const $d0fec4ac46f6b7e1$export$d0f42a55e7c5752c = (0, $3HCkE.createResource)({
    type: (0, $4abw7.RESOURCE_TYPE_RAPIDBOARDS_RESOURCE),
    getKey: ({ match: match })=>match.query.rapidView || '',
    getDataLoader: ()=>(parcelRequire("jM9sA")),
    maxAge: Number.MAX_VALUE,
    isBrowserOnly: true
});

});
parcelRegister("jM9sA", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('bD5eW');
        const value = parcelRequire('738Zn');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("bD5eW").then(()=>parcelRequire('738Zn'));
}

});


parcelRegister("azMNr", function(module, exports) {

$parcel$export(module.exports, "wrmBundleResource", () => $9ba6db74de8b9314$export$f199d15b7cd18df1);

var $3HCkE = parcelRequire("3HCkE");

var $4abw7 = parcelRequire("4abw7");

const $9ba6db74de8b9314$export$f199d15b7cd18df1 = (0, $3HCkE.createResource)({
    type: (0, $4abw7.RESOURCE_TYPE_RAPIDBOARDS_WRM_BUNDLE),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("hW8vP")),
    maxAge: Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});

});
parcelRegister("hW8vP", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('kSleR');
        const value = parcelRequire('kzWWa');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("kSleR").then(()=>parcelRequire('kzWWa'));
}

});



parcelRegister("gar3N", function(module, exports) {

$parcel$export(module.exports, "devOpsProviderResource", () => $36496188b1d77e1d$export$19e58e21b24ae0d8);

var $3HCkE = parcelRequire("3HCkE");


const $36496188b1d77e1d$export$19e58e21b24ae0d8 = (0, $3HCkE.createResource)({
    type: (0, $c5a874dd03237b43$export$5f92e516f4b78544),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("2UQCY")),
    maxAge: 60000
});
const $36496188b1d77e1d$export$b80f5852c41a5ca8 = ()=>(0, $3HCkE.useResource)($36496188b1d77e1d$export$19e58e21b24ae0d8);

});
const $c5a874dd03237b43$export$5f92e516f4b78544 = 'SOFTWARE_DEVOPS_PROVIDERS';
const $c5a874dd03237b43$export$d7f081d6dd0e72fc = 'bitbucket';
const $c5a874dd03237b43$export$832d1d859726f915 = 'kRiZ7boFApjBINFF1L7wPrCa4iF8O6R9';
const $c5a874dd03237b43$export$5007979ef33118fc = 'cOwtZiBfejjJAryJH0WPb1otsa4HrI1N';

parcelRegister("2UQCY", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('lHWCq');
        const value = parcelRequire('fWjqT');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("lHWCq").then(()=>parcelRequire('fWjqT'));
}

});


parcelRegister("lY9wZ", function(module, exports) {

$parcel$export(module.exports, "classicRoadmapResource", () => $3a45f64c9dac7291$export$e755913caca1ab8e);

var $3HCkE = parcelRequire("3HCkE");


const $3a45f64c9dac7291$export$e755913caca1ab8e = (0, $3HCkE.createResource)({
    type: (0, $1eef2c9e2260305d$export$75dfa03544a19422),
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>(parcelRequire("91YgQ")),
    isBrowserOnly: true
});

});
const $1eef2c9e2260305d$export$75dfa03544a19422 = 'ROADMAP';
const $1eef2c9e2260305d$export$e905b9170ecbb599 = 'BOARD_CONTEXT_ROADMAP_SETTINGS';

parcelRegister("91YgQ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('f3A1F');
        const value = parcelRequire('fDh5k');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("f3A1F").then(()=>parcelRequire('fDh5k'));
}

});


parcelRegister("5GEOG", function(module, exports) {

$parcel$export(module.exports, "codePageResource", () => $3e86f6d6f0d16a33$export$642ce64cf3689406);

var $exb0h = parcelRequire("exb0h");

var $buJlM = parcelRequire("buJlM");

var $9FLN2 = parcelRequire("9FLN2");

var $fUxTD = parcelRequire("fUxTD");

let $3e86f6d6f0d16a33$var$numPullRequestsToFetch = 0;
const $3e86f6d6f0d16a33$export$642ce64cf3689406 = (0, $buJlM.createRelayResource)({
    type: (0, $c019edc395b43b54$export$94a43d2ac55ac375),
    getQuery ({ match: { params: params }, query: query, route: { name: name } }, { tenantContext: { cloudId: cloudId } }) {
        const isCodeRoute = name === (0, $exb0h.ROUTE_NAMES).SOFTWARE_CODE || name === (0, $exb0h.ROUTE_NAMES).SOFTWARE_CODE_CLASSIC;
        // Set numPullRequestsToFetch on initial call only and not on every query param change
        if (!$3e86f6d6f0d16a33$var$numPullRequestsToFetch && isCodeRoute) $3e86f6d6f0d16a33$var$numPullRequestsToFetch = (0, $fUxTD.getNumPullRequestsToFetch)(query);
        // Reset numPullRequestsToFetch when navigating away from the code page
        if (!isCodeRoute) $3e86f6d6f0d16a33$var$numPullRequestsToFetch = 0;
        return {
            parameters: (0, $9FLN2.default),
            options: {
                fetchPolicy: 'store-and-network'
            },
            variables: {
                cloudId: cloudId,
                projectKey: params.projectKey ?? '',
                pullRequestsUpdatedFrom: (0, $fUxTD.getPullRequestsUpdatedFromDate)(),
                numPullRequestsToFetch: $3e86f6d6f0d16a33$var$numPullRequestsToFetch,
                siteAri: `ari:cloud:jira::site/${cloudId}`
            }
        };
    }
});

});
parcelRegister("9FLN2", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ffdcfe594d87f38$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9c20dcd86ecb5ac51f5f6c0b8fbf431d>>
 * @relayHash 695c2b22fe167397fcfb6ec2770df291
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8f044e4d82c7b5756dcdc5851f7e1d4efd36a20d83dd2cf0afa668ecd08a2994
const $3ffdcfe594d87f38$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "numPullRequestsToFetch"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pullRequestsUpdatedFrom"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "siteAri"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "siteAri"
        },
        {
            "kind": "Literal",
            "name": "providerTypes",
            "value": [
                "DEV_INFO"
            ]
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v9 = [
        v8 /*: any*/ 
    ], v10 = [
        v7 /*: any*/ 
    ], v11 = [
        {
            "kind": "Literal",
            "name": "appId",
            "value": "bitbucket"
        },
        v8 /*: any*/ 
    ], v12 = {
        "kind": "ScalarField",
        "name": "status"
    }, v13 = {
        "concreteType": "JiraConfigStateConnection",
        "kind": "LinkedField",
        "name": "config",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraConfigState",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "appId"
                    },
                    v12 /*: any*/ 
                ]
            }
        ]
    }, v14 = [
        v8 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v15 = [
        {
            "kind": "Literal",
            "name": "sort",
            "value": {
                "lastModified": {
                    "direction": "DESC",
                    "priority": 1
                }
            }
        }
    ], v16 = {
        "kind": "ScalarField",
        "name": "name"
    }, v17 = {
        "kind": "ScalarField",
        "name": "lastUpdated"
    }, v18 = {
        "kind": "ScalarField",
        "name": "url"
    }, v19 = [
        v7 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "accountId"
        },
        v16 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "picture"
        },
        v6 /*: any*/ 
    ], v20 = [
        v6 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainCodeInJiraUpdatedQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "DevOps",
                        "kind": "LinkedField",
                        "name": "devOps",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "DevOpsProviders",
                                    "kind": "LinkedField",
                                    "name": "providers",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "DevOpsDevInfoProvider",
                                            "kind": "LinkedField",
                                            "name": "devInfoProviders",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "devOps.providers"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "devOps"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v9 /*: any*/ ,
                        "concreteType": "CodeInJira",
                        "kind": "LinkedField",
                        "name": "codeInJira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "CodeInJiraUserConfiguration",
                                    "kind": "LinkedField",
                                    "name": "userConfiguration",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "CodeInJiraBitbucketWorkspace",
                                                "kind": "LinkedField",
                                                "name": "ownedBitbucketWorkspaces",
                                                "plural": true,
                                                "selections": v10 /*: any*/ 
                                            },
                                            "action": "THROW",
                                            "path": "codeInJira.userConfiguration.ownedBitbucketWorkspaces"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "codeInJira.userConfiguration"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "codeInJira"
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraDevOpsQuery",
                            "kind": "LinkedField",
                            "name": "devOps",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v11 /*: any*/ ,
                                    "concreteType": "JiraAppConfigState",
                                    "kind": "LinkedField",
                                    "name": "configState",
                                    "plural": false,
                                    "selections": [
                                        v13 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v14 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v15 /*: any*/ ,
                                    "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoConnection",
                                    "kind": "LinkedField",
                                    "name": "repositories",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v10 /*: any*/ 
                                        }
                                    ],
                                    "storageKey": "repositories(sort:{\"lastModified\":{\"direction\":\"DESC\",\"priority\":1}})"
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "FragmentSpread",
                    "name": "main_softwareCodePage_MainPage"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "main_softwareCodePage_Header"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "main_softwareCodePage_ConnectionPage"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainCodeInJiraUpdatedQuery",
            "selections": [
                {
                    "concreteType": "DevOps",
                    "kind": "LinkedField",
                    "name": "devOps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "DevOpsProviders",
                            "kind": "LinkedField",
                            "name": "providers",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "DevOpsDevInfoProvider",
                                    "kind": "LinkedField",
                                    "name": "devInfoProviders",
                                    "plural": true,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "homeUrl"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "namespace"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v9 /*: any*/ ,
                    "concreteType": "CodeInJira",
                    "kind": "LinkedField",
                    "name": "codeInJira",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "CodeInJiraUserConfiguration",
                            "kind": "LinkedField",
                            "name": "userConfiguration",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CodeInJiraBitbucketWorkspace",
                                    "kind": "LinkedField",
                                    "name": "ownedBitbucketWorkspaces",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "uuid"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "slug"
                                        },
                                        v16 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraDevOpsQuery",
                            "kind": "LinkedField",
                            "name": "devOps",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v11 /*: any*/ ,
                                    "concreteType": "JiraAppConfigState",
                                    "kind": "LinkedField",
                                    "name": "configState",
                                    "plural": false,
                                    "selections": [
                                        v13 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v14 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v15 /*: any*/ ,
                                    "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoConnection",
                                    "kind": "LinkedField",
                                    "name": "repositories",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "providerId"
                                                                },
                                                                v16 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "avatarUrl"
                                                                },
                                                                v18 /*: any*/ 
                                                            ],
                                                            "type": "DevOpsRepository"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "repositories(sort:{\"lastModified\":{\"direction\":\"DESC\",\"priority\":1}})"
                                },
                                v6 /*: any*/ ,
                                {
                                    "args": [
                                        {
                                            "fields": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "updatedFrom",
                                                    "variableName": "pullRequestsUpdatedFrom"
                                                }
                                            ],
                                            "kind": "ObjectValue",
                                            "name": "filter"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "first",
                                            "variableName": "numPullRequestsToFetch"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "sort",
                                            "value": {
                                                "lastUpdatedSortDirection": "DESC"
                                            }
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "project-associated-pr"
                                        }
                                    ],
                                    "concreteType": "AriGraphRelationshipConnection",
                                    "kind": "LinkedField",
                                    "name": "devOpsEntityRelationships",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "AriGraphRelationshipEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "AriGraphRelationship",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AriGraphRelationshipNode",
                                                            "kind": "LinkedField",
                                                            "name": "to",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v12 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "repositoryName"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "repositoryId"
                                                                                },
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "author",
                                                                                    "plural": false,
                                                                                    "selections": v19 /*: any*/ 
                                                                                },
                                                                                {
                                                                                    "concreteType": "DevOpsReviewer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "reviewers",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "user",
                                                                                            "plural": false,
                                                                                            "selections": v19 /*: any*/ 
                                                                                        },
                                                                                        v7 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "approvalStatus"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "userId"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "title"
                                                                                },
                                                                                v6 /*: any*/ ,
                                                                                v17 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "commentCount"
                                                                                },
                                                                                v18 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "DevOpsBranchInfo",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "destinationBranch",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v16 /*: any*/ ,
                                                                                        v18 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "pullRequestInternalId"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "repositoryUrl"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "authorId"
                                                                                }
                                                                            ],
                                                                            "type": "DevOpsPullRequestDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v20 /*: any*/ ,
                                                                            "type": "Node",
                                                                            "abstractKey": "__isNode"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v20 /*: any*/ ,
                                                                            "type": "ConfluencePage"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v20 /*: any*/ ,
                                                                            "type": "ConfluenceSpace"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v20 /*: any*/ ,
                                                                            "type": "DevOpsFeatureFlag"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v20 /*: any*/ ,
                                                                            "type": "DevOpsOperationsComponentDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v20 /*: any*/ ,
                                                                            "type": "DevOpsOperationsIncidentDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v20 /*: any*/ ,
                                                                            "type": "DevOpsOperationsPostIncidentReviewDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v20 /*: any*/ ,
                                                                            "type": "DevOpsRepository"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v20 /*: any*/ ,
                                                                            "type": "DevOpsSecurityVulnerabilityDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v20 /*: any*/ ,
                                                                            "type": "JiraConfluenceRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v20 /*: any*/ ,
                                                                            "type": "JiraCustomRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v20 /*: any*/ ,
                                                                            "type": "JiraIssueRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v20 /*: any*/ ,
                                                                            "type": "JiraWebRemoteIssueLink"
                                                                        }
                                                                    ]
                                                                },
                                                                v6 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8f044e4d82c7b5756dcdc5851f7e1d4efd36a20d83dd2cf0afa668ecd08a2994",
            "metadata": {},
            "name": "mainCodeInJiraUpdatedQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3ffdcfe594d87f38$var$node.hash = "5fe6a9999df0586a9eb6e71b8ef3c8a7";
var $3ffdcfe594d87f38$export$2e2bcd8739ae039 = $3ffdcfe594d87f38$var$node;

});

parcelRegister("fUxTD", function(module, exports) {

$parcel$export(module.exports, "isBitbucketProvider", () => $4b6f21ae9f331ee2$export$1f508885be28c4e);
$parcel$export(module.exports, "codeErrorBoundaryAttributes", () => $4b6f21ae9f331ee2$export$ea10bb8bdf2072e5);
$parcel$export(module.exports, "toSanitizedUrl", () => $4b6f21ae9f331ee2$export$36fdccbdcd093523);
$parcel$export(module.exports, "useIsOverflowWidth", () => $4b6f21ae9f331ee2$export$2dcd60313c8d761b);
$parcel$export(module.exports, "getPullRequestsUpdatedFromDate", () => $4b6f21ae9f331ee2$export$3784bdf6b4807521);
$parcel$export(module.exports, "getNumPullRequestsToFetch", () => $4b6f21ae9f331ee2$export$a837c7c9c7670570);

var $eUqFw = parcelRequire("eUqFw");

var $licsn = parcelRequire("licsn");

var $3jYzf = parcelRequire("3jYzf");
var $fiOXn = parcelRequire("fiOXn");

var $k4dvS = parcelRequire("k4dvS");

var $2H4pK = parcelRequire("2H4pK");
const $4b6f21ae9f331ee2$export$36ebc9cd52c6b517 = (repository)=>repository === (0, $2H4pK.RepositoryTypes).REPO_BITBUCKET;
const $4b6f21ae9f331ee2$export$1f508885be28c4e = (providerId)=>providerId === (0, $k4dvS.VcsProviderIds).BITBUCKET || providerId === (0, $k4dvS.DataDepotProviderIds).BITBUCKET_PROD || providerId === (0, $k4dvS.DataDepotProviderIds).BITBUCKET_STG;
const $4b6f21ae9f331ee2$var$shouldCountToReliability = (error)=>{
    const okayErrors = [
        ...(0, $k4dvS.nonCriticalGqlErrors),
        ...(0, $k4dvS.nonReliabilityCriticalErrors)
    ];
    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"HTTP status [403] while retrieving Bitbucket repository." | "HTTP status [404] while retrieving Bitbucket repository." | "Failed to retrieve Bitbucket repository because the user wasn't authorized." | "HTTP status [429] while retrieving Bitbucket repository." | "The user does not have 'View Development Tools' permi...'.
    return !okayErrors.includes(error.message);
};
const $4b6f21ae9f331ee2$export$ea10bb8bdf2072e5 = (error)=>{
    if (error instanceof Error) return {
        countToReliability: $4b6f21ae9f331ee2$var$shouldCountToReliability(error)
    };
    return {
        countToReliability: true
    };
};
const $4b6f21ae9f331ee2$export$36fdccbdcd093523 = (url)=>(0, $licsn.sanitizeUrl)(url);
const $4b6f21ae9f331ee2$export$2dcd60313c8d761b = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
ref, callback)=>{
    const [isOverflow, setIsOverflow] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useLayoutEffect)(()=>{
        const { current: current } = ref;
        const trigger = ()=>{
            const hasOverflow = current.scrollWidth > current.clientWidth;
            setIsOverflow(hasOverflow);
            if (callback) callback(hasOverflow);
        };
        if (current) {
            if ('ResizeObserver' in window) new ResizeObserver(trigger).observe(current);
            trigger();
        }
    }, [
        callback,
        ref
    ]);
    return isOverflow;
};
const $4b6f21ae9f331ee2$export$3784bdf6b4807521 = ()=>(0, $3jYzf.default)((0, $fiOXn.default)(new Date(), {
        days: (0, $k4dvS.PULL_REQUESTS_UPDATED_FROM_NUMBER_OF_DAYS)
    })).toISOString();
const $4b6f21ae9f331ee2$export$a837c7c9c7670570 = (queryParams)=>{
    const hasFilterOrSortQueryParam = Object.entries(queryParams).some(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ([key, value])=>(0, $k4dvS.queryParamsToWatch).includes(key) && value !== '');
    return hasFilterOrSortQueryParam ? (0, $k4dvS.MAX_NUMBER_OF_PULL_REQUESTS_TO_QUERY) : (0, $k4dvS.PULL_REQUESTS_TABLE_PAGE_SIZE);
};

});
parcelRegister("licsn", function(module, exports) {
'use strict';
var $f804f10f7485c34b$var$invalidPrototcolRegex = /^(%20|\s)*(javascript|data)/im;
var $f804f10f7485c34b$var$ctrlCharactersRegex = /[^\x20-\x7E]/gmi;
var $f804f10f7485c34b$var$urlSchemeRegex = /^([^:]+):/gm;
var $f804f10f7485c34b$var$relativeFirstCharacters = [
    '.',
    '/'
];
function $f804f10f7485c34b$var$isRelativeUrl(url) {
    return $f804f10f7485c34b$var$relativeFirstCharacters.indexOf(url[0]) > -1;
}
function $f804f10f7485c34b$var$sanitizeUrl(url) {
    if (!url) return 'about:blank';
    var urlScheme, urlSchemeParseResults;
    var sanitizedUrl = url.replace($f804f10f7485c34b$var$ctrlCharactersRegex, '');
    if ($f804f10f7485c34b$var$isRelativeUrl(sanitizedUrl)) return sanitizedUrl;
    urlSchemeParseResults = sanitizedUrl.match($f804f10f7485c34b$var$urlSchemeRegex);
    if (!urlSchemeParseResults) return 'about:blank';
    urlScheme = urlSchemeParseResults[0];
    if ($f804f10f7485c34b$var$invalidPrototcolRegex.test(urlScheme)) return 'about:blank';
    return sanitizedUrl;
}
module.exports = {
    sanitizeUrl: $f804f10f7485c34b$var$sanitizeUrl
};

});

parcelRegister("k4dvS", function(module, exports) {

$parcel$export(module.exports, "nonCriticalGqlErrors", () => $ed47b00d0c38c75b$export$4b1abe4db5ed7515);
$parcel$export(module.exports, "nonReliabilityCriticalErrors", () => $ed47b00d0c38c75b$export$687544614e0812da);
$parcel$export(module.exports, "cardBoxShadow", () => $ed47b00d0c38c75b$export$7527a73da794030d);
$parcel$export(module.exports, "cardBoxHoverShadow", () => $ed47b00d0c38c75b$export$2ecfdc24b216c295);
$parcel$export(module.exports, "MAX_NUMBER_OF_PULL_REQUESTS_TO_QUERY", () => $ed47b00d0c38c75b$export$f84c6b6609a3dd30);
$parcel$export(module.exports, "PULL_REQUESTS_TABLE_PAGE_SIZE", () => $ed47b00d0c38c75b$export$ea15b38f3901f518);
$parcel$export(module.exports, "PULL_REQUESTS_UPDATED_FROM_NUMBER_OF_DAYS", () => $ed47b00d0c38c75b$export$2b8b0a4489f9147b);
$parcel$export(module.exports, "COLLAPSIBLE_REGION_ID", () => $ed47b00d0c38c75b$export$3b8f88133d28aaa6);
$parcel$export(module.exports, "REPOSITORIES_HEADER_ID", () => $ed47b00d0c38c75b$export$256a9f141103f328);
$parcel$export(module.exports, "COLLAPSIBLE_REGION_DESCRIPTION_ID", () => $ed47b00d0c38c75b$export$b0d4e90e40369b80);
$parcel$export(module.exports, "featureIdToHelpMap", () => $ed47b00d0c38c75b$export$1de4eaccc23a8747);
$parcel$export(module.exports, "FILTER_CONTAINER_TEST_ID", () => $ed47b00d0c38c75b$export$5c00a6bedc2037c8);
$parcel$export(module.exports, "NO_RESULTS_CLEAR_FILTERS_BUTTON_TEST_ID", () => $ed47b00d0c38c75b$export$f70ce14ba902adcb);
$parcel$export(module.exports, "PULL_REQUESTS_TABLE_TEST_ID", () => $ed47b00d0c38c75b$export$19381ed4387aa05b);
$parcel$export(module.exports, "PULL_REQUESTS_DYNAMIC_TABLE_TEST_ID", () => $ed47b00d0c38c75b$export$f3e116f999d4c5c1);
$parcel$export(module.exports, "PULL_REQUESTS_EMPTY_STATE_TEST_ID", () => $ed47b00d0c38c75b$export$c28f1cd40ae0394c);
$parcel$export(module.exports, "SUMMARY_CELL_TEST_ID", () => $ed47b00d0c38c75b$export$f69d7aa9c5e17d55);
$parcel$export(module.exports, "SUMMARY_CELL_TITLE_LINK_TEST_ID", () => $ed47b00d0c38c75b$export$4ed9a8a7faf641f);
$parcel$export(module.exports, "SUMMARY_CELL_TARGET_BRANCH_LINK_TEST_ID", () => $ed47b00d0c38c75b$export$c5322e755fd1028d);
$parcel$export(module.exports, "SUMMARY_CELL_REPOSITORY_LINK_TEST_ID", () => $ed47b00d0c38c75b$export$72fcd104fde041d6);
$parcel$export(module.exports, "REVIEWERS_CELL_TEST_ID", () => $ed47b00d0c38c75b$export$d8f600a480a9c2d4);
$parcel$export(module.exports, "STATUS_CELL_TEST_ID", () => $ed47b00d0c38c75b$export$9d9ab707c4e446cc);
$parcel$export(module.exports, "COMMENTS_CELL_TEST_ID", () => $ed47b00d0c38c75b$export$4da3056fdbfaf111);
$parcel$export(module.exports, "LAST_UPDATED_CELL_TEST_ID", () => $ed47b00d0c38c75b$export$e1134688b6a1032);
$parcel$export(module.exports, "PULL_REQUESTS_ERROR_STATE_TEST_ID", () => $ed47b00d0c38c75b$export$143249aa50321d51);
$parcel$export(module.exports, "REPOSITORIES_ERROR_STATE_TEST_ID", () => $ed47b00d0c38c75b$export$a46febdd3fe90de0);
$parcel$export(module.exports, "REPOSITORIES_FILTER_BUTTON_TEST_ID", () => $ed47b00d0c38c75b$export$4939c117ba49bc9e);
$parcel$export(module.exports, "AUTHOR_FILTER_BUTTON_TEST_ID", () => $ed47b00d0c38c75b$export$5a92d7579dac6294);
$parcel$export(module.exports, "REVIEWERS_FILTER_BUTTON_TEST_ID", () => $ed47b00d0c38c75b$export$a77ea162c15f0290);
$parcel$export(module.exports, "STATUS_FILTER_BUTTON_TEST_ID", () => $ed47b00d0c38c75b$export$b7477204cae64b46);
$parcel$export(module.exports, "QUERY_PARAM_SUMMARY", () => $ed47b00d0c38c75b$export$39983b6fb040a5eb);
$parcel$export(module.exports, "QUERY_PARAM_AUTHORS", () => $ed47b00d0c38c75b$export$3d96f5f9ccd35be6);
$parcel$export(module.exports, "QUERY_PARAM_REVIEWERS", () => $ed47b00d0c38c75b$export$8a8927c29ab32b10);
$parcel$export(module.exports, "QUERY_PARAM_STATUS", () => $ed47b00d0c38c75b$export$3e8168848b996f7);
$parcel$export(module.exports, "QUERY_PARAM_REPOSITORIES", () => $ed47b00d0c38c75b$export$4adc519ba40b72a6);
$parcel$export(module.exports, "QUERY_PARAM_SORT_KEY", () => $ed47b00d0c38c75b$export$6da773286c35ef41);
$parcel$export(module.exports, "QUERY_PARAM_SORT_ORDER", () => $ed47b00d0c38c75b$export$810a1f7ed2facfcb);
$parcel$export(module.exports, "queryParamsToWatch", () => $ed47b00d0c38c75b$export$ba75fb5089c0eb0b);
$parcel$export(module.exports, "VcsProviderIds", () => $ed47b00d0c38c75b$export$7d5c3d28df5f438a);
$parcel$export(module.exports, "DataDepotProviderIds", () => $ed47b00d0c38c75b$export$7912a169c18abe9d);
const $ed47b00d0c38c75b$export$4b1abe4db5ed7515 = [
    'HTTP status [403] while retrieving Bitbucket repository.',
    'HTTP status [404] while retrieving Bitbucket repository.',
    "Failed to retrieve Bitbucket repository because the user wasn't authorized."
];
const $ed47b00d0c38c75b$export$687544614e0812da = [
    'HTTP status [429] while retrieving Bitbucket repository.',
    "The user does not have 'View Development Tools' permission for the Jira project or the project does not exist",
    'The user does not have admin permission for the site, Jira, project or the project does not exist.',
    'Unable to get providers when contacting Jira due to 401 Unauthorized'
];
const $ed47b00d0c38c75b$export$7527a73da794030d = "var(--ds-shadow-overflow, 0 1px 1px rgb(9 30 66 / 25%), 0 0 1px 1px rgb(9 30 66 / 13%))";
const $ed47b00d0c38c75b$export$2ecfdc24b216c295 = "var(--ds-shadow-overflow, rgba(9, 30, 66, 0.31) 0px 0px 1px 0px, rgba(9, 30, 66, 0.25) 0px 8px 16px -6px)"; // we use  in package.json file, so box-shadow here must be a value, cannot use elevation
const $ed47b00d0c38c75b$export$f84c6b6609a3dd30 = 1000;
const $ed47b00d0c38c75b$export$ea15b38f3901f518 = 12;
const $ed47b00d0c38c75b$export$2b8b0a4489f9147b = 30;
const $ed47b00d0c38c75b$export$3b8f88133d28aaa6 = 'collapsible-repository-list';
const $ed47b00d0c38c75b$export$256a9f141103f328 = 'repository-list-header';
const $ed47b00d0c38c75b$export$b0d4e90e40369b80 = 'repository-list-description';
const $ed47b00d0c38c75b$export$1de4eaccc23a8747 = {
    'repository-list.pull-requests.empty-state': {
        helpArticleId: '5WUm7jlQnN9aiw9KOp1Ks1',
        href: 'https://support.atlassian.com/jira-software-cloud/docs/view-development-information-for-an-issue/'
    },
    'repository-list.pull-requests.description': {
        helpArticleId: '5WUm7jlQnN9aiw9KOp1Ks1',
        href: 'https://support.atlassian.com/jira-software-cloud/docs/view-development-information-for-an-issue/'
    }
};
const $ed47b00d0c38c75b$export$5c00a6bedc2037c8 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.filter-container';
const $ed47b00d0c38c75b$export$f70ce14ba902adcb = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filtered-table.pull-request-table.no-results.clearfiltersbutton';
const $ed47b00d0c38c75b$export$19381ed4387aa05b = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.pull-requests-table';
const $ed47b00d0c38c75b$export$f3e116f999d4c5c1 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.pull-requests-table.dynamic-table';
const $ed47b00d0c38c75b$export$c28f1cd40ae0394c = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.pull-requests-empty-state';
const $ed47b00d0c38c75b$export$f69d7aa9c5e17d55 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filtered-table.pull-request-table.summary-cell';
const $ed47b00d0c38c75b$export$4ed9a8a7faf641f = `${$ed47b00d0c38c75b$export$f69d7aa9c5e17d55}.title-link`;
const $ed47b00d0c38c75b$export$c5322e755fd1028d = `${$ed47b00d0c38c75b$export$f69d7aa9c5e17d55}.target-branch-link`;
const $ed47b00d0c38c75b$export$72fcd104fde041d6 = `${$ed47b00d0c38c75b$export$f69d7aa9c5e17d55}.repository-link`;
const $ed47b00d0c38c75b$export$d8f600a480a9c2d4 = 'software-code-page.ui.pages.repository-list.pull-requests.filtered-table.pull-request-table.reviewers-cell';
const $ed47b00d0c38c75b$export$9d9ab707c4e446cc = 'software-code-page.ui.pages.repository-list.pull-requests.filtered-table.pull-request-table.status-cell';
const $ed47b00d0c38c75b$export$4da3056fdbfaf111 = 'software-code-page.ui.pages.repository-list.pull-requests.filtered-table.pull-request-table.comments-cell';
const $ed47b00d0c38c75b$export$e1134688b6a1032 = 'software-code-page.ui.pages.repository-list.pull-requests.filtered-table.pull-request-table.last-updated-cell';
const $ed47b00d0c38c75b$export$143249aa50321d51 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-error-state';
const $ed47b00d0c38c75b$export$a46febdd3fe90de0 = 'software-code-page.ui.pages.main-page.repositories.repository-error-state';
const $ed47b00d0c38c75b$export$4939c117ba49bc9e = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.repository-filter.filter-button';
const $ed47b00d0c38c75b$export$5a92d7579dac6294 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.author-filter.filter-button';
const $ed47b00d0c38c75b$export$a77ea162c15f0290 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.reviewers-filter.filter-button';
const $ed47b00d0c38c75b$export$b7477204cae64b46 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.status-filter.filter-button';
const $ed47b00d0c38c75b$export$39983b6fb040a5eb = 'summaryFilter';
const $ed47b00d0c38c75b$export$3d96f5f9ccd35be6 = 'authorsFilter';
const $ed47b00d0c38c75b$export$8a8927c29ab32b10 = 'reviewersFilter';
const $ed47b00d0c38c75b$export$3e8168848b996f7 = 'statusFilter';
const $ed47b00d0c38c75b$export$4adc519ba40b72a6 = 'repositoriesFilter';
const $ed47b00d0c38c75b$export$6da773286c35ef41 = 'sortKey';
const $ed47b00d0c38c75b$export$810a1f7ed2facfcb = 'sortOrder';
const $ed47b00d0c38c75b$export$ba75fb5089c0eb0b = [
    $ed47b00d0c38c75b$export$39983b6fb040a5eb,
    $ed47b00d0c38c75b$export$3d96f5f9ccd35be6,
    $ed47b00d0c38c75b$export$8a8927c29ab32b10,
    $ed47b00d0c38c75b$export$3e8168848b996f7,
    $ed47b00d0c38c75b$export$4adc519ba40b72a6,
    $ed47b00d0c38c75b$export$6da773286c35ef41,
    $ed47b00d0c38c75b$export$810a1f7ed2facfcb
];
const $ed47b00d0c38c75b$export$7d5c3d28df5f438a = {
    BITBUCKET: 'bitbucket'
};
const $ed47b00d0c38c75b$export$7912a169c18abe9d = {
    BITBUCKET_PROD: 'kRiZ7boFApjBINFF1L7wPrCa4iF8O6R9',
    BITBUCKET_STG: 'cOwtZiBfejjJAryJH0WPb1otsa4HrI1N'
};

});

parcelRegister("2H4pK", function(module, exports) {

$parcel$export(module.exports, "numberToTimestamp", () => $764cbee5e2f48f11$export$9a7be8324d19a048);
$parcel$export(module.exports, "toProjectAri", () => $764cbee5e2f48f11$export$9429718a5f74f761);
$parcel$export(module.exports, "RepositoryTypes", () => $764cbee5e2f48f11$export$b5ab924fb433d9ea);
/**
 * Opaque types
 */ const $764cbee5e2f48f11$export$9a7be8324d19a048 = (time)=>{
    if (time < 0) throw new Error(`Trying to case invalid number(${time}) to Timestamp opaque type`);
    return time;
};
const $764cbee5e2f48f11$export$9429718a5f74f761 = (cloudId, projectId)=>`ari:cloud:jira:${cloudId}:project/${projectId}`;
const $764cbee5e2f48f11$export$b5ab924fb433d9ea = {
    REPO_BITBUCKET: 'REPO_BITBUCKET',
    REPO_GITHUB: 'REPO_GITHUB',
    REPO_GITLAB: 'REPO_GITLAB'
};
const $764cbee5e2f48f11$export$60dabe06d83cf844 = {
    CLASSIC: 'classic',
    OAUTH: 'oauth',
    BITBUCKET: 'bitbucket'
};

});


const $c019edc395b43b54$export$94a43d2ac55ac375 = 'SOFTWARE_CODE';


parcelRegister("1hTYf", function(module, exports) {

$parcel$export(module.exports, "IncidentsPageSkeleton", () => $05b91b3e5d90dad0$export$3105d59d9ca899bd);
$parcel$export(module.exports, "IncidentsTableSkeleton", () => $05b91b3e5d90dad0$export$7092b8ea63ebf9be);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");

var $k6hK9 = parcelRequire("k6hK9");

var $jVSv6 = parcelRequire("jVSv6");
const $05b91b3e5d90dad0$var$incidentsPageSkeletonStyles = null;
const $05b91b3e5d90dad0$var$incidentsTableSkeletonStyles = null;
const $05b91b3e5d90dad0$export$3105d59d9ca899bd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "skeletons.ui.incidents-page.app-skeleton-image-incidents-page",
        className: (0, $7JEyt.default)([
            "_1bsb1x27 _4t3i1osq _ca0q1ejb _19bv1jfw _u5f31jfw _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($k6hK9)))
    }));
const $05b91b3e5d90dad0$export$7092b8ea63ebf9be = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "skeletons.ui.incidents-page.app-skeleton-image-incidents-table",
        className: (0, $7JEyt.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jVSv6)))
    }));

});
parcelRegister("k6hK9", function(module, exports) {
module.exports = new URL("incidents-page-app-skeleton.tpl.5b656159.svg", import.meta.url).toString();

});

parcelRegister("jVSv6", function(module, exports) {
module.exports = new URL("incidents-page-table-skeleton.tpl.e8f337f1.svg", import.meta.url).toString();

});


parcelRegister("dy6xq", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('eNmuD'),
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('hnCla')
        ]);
        const value = parcelRequire('51qvE');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("eNmuD"),
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("hnCla")
    ]).then(()=>parcelRequire('51qvE'));
}

});

parcelRegister("awSy7", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('cGBOS')
        ]);
        const value = parcelRequire('dBngL');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("cGBOS")
    ]).then(()=>parcelRequire('dBngL'));
}

});

parcelRegister("ioEMP", function(module, exports) {

$parcel$export(module.exports, "uifBoardResource", () => $56fa80c31203146f$export$b65bcbbccad354ac);

var $3HCkE = parcelRequire("3HCkE");


const $56fa80c31203146f$export$b65bcbbccad354ac = (0, $3HCkE.createResource)({
    type: (0, $3c069a4b56559612$export$cfae566ecf2855f8),
    getKey: ({ match: { params: { boardId: boardId } }, route: { name: routeName }, query: { config: config } })=>{
        if (config) return `uif-board::${routeName}::config`;
        if (boardId == null) return `uif-board::${routeName}::not-found`;
        return `uif-board::${routeName}::${boardId}`;
    },
    getDataLoader: ()=>(parcelRequire("1RPAv")),
    maxAge: 0
});

});
const $3c069a4b56559612$export$cfae566ecf2855f8 = 'UIF_BOARD';

parcelRegister("1RPAv", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hOBob');
        const value = parcelRequire('kWTXq');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hOBob").then(()=>parcelRequire('kWTXq'));
}

});


parcelRegister("gyys9", function(module, exports) {

$parcel$export(module.exports, "nextBestTaskFeatureResource", () => $73c842e85172a066$export$5d472f7d515300ca);

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $lRmyA = parcelRequire("lRmyA");

var $3HCkE = parcelRequire("3HCkE");

const $73c842e85172a066$export$5d472f7d515300ca = (0, $3HCkE.createResource)({
    type: (0, $74042257b0cd863d$export$6f0555de4f60e84e),
    getKey: ()=>(0, $74042257b0cd863d$export$7e7d7930e22ba39f),
    getData: async ()=>{
        try {
            return await (0, $lRmyA.performGetRequest)(`/rest/api/3/mypreferences?key=${(0, $74042257b0cd863d$export$b94951a11282ae6a)}`);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const initialValueNeverSet = error.statusCode === 404;
            if (initialValueNeverSet) /**
				 * If the user has never set the preference, we auto enroll them and set the initial value to true.
				 */ return {
                hasUserOptedIn: (0, $1ybV0.ff)('jsw-work-suggestions-auto-opt-in_mpxg5') ? true : null
            };
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: (0, $74042257b0cd863d$export$7f111648ca05f056),
                    packageName: (0, $74042257b0cd863d$export$b8b9d90f9e5bd72b)
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        /* on error return false,
		 * this ensures if user is in the experiment cohort but later opted out, they don't revert to having the feature enabled */ return {
            hasUserOptedIn: false
        };
    },
    maxAge: Number.MAX_VALUE
});

});
const $74042257b0cd863d$export$6f0555de4f60e84e = 'RESOURCE_TYPE_NEXT_BEST_TASK_FEATURE';
const $74042257b0cd863d$export$7e7d7930e22ba39f = 'nbt-opt-in-resource-key'; // value is global for user
const $74042257b0cd863d$export$b94951a11282ae6a = 'next-best-task-feature';
const $74042257b0cd863d$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesNextBestTask';
const $74042257b0cd863d$export$7f111648ca05f056 = 'useResource.fetchNextBestTaskOptInPreference';


parcelRegister("4PVYj", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardRoute", () => $9f593306e01ca1b5$export$131d51ca54849e97);

var $exb0h = parcelRequire("exb0h");
const $9f593306e01ca1b5$export$131d51ca54849e97 = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_BOARD,
    path: '/jira/software/c/projects/:projectKey/boards/:boardId',
    ufoName: 'classic-board'
};

});

parcelRegister("ddT06", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_METRICS_HISTOGRAM", () => $12a3433d60ba6dc8$export$128e24da52662cdd);
$parcel$export(module.exports, "BOARD_SETTINGS_ARTICLE_ID_CONFIG_DISABLE_SECTION", () => $12a3433d60ba6dc8$export$efdecbe4c9f1cd2c);
$parcel$export(module.exports, "BOARD_SETTINGS_ARTICLE_ID_CONFIG_DISABLE_SECTION_ANALYTICS_ID", () => $12a3433d60ba6dc8$export$7cadd2a48a9ff918);
$parcel$export(module.exports, "DEFAULT_LEVEL_ONE_NAME", () => $12a3433d60ba6dc8$export$a546b6d48878ce6f);
$parcel$export(module.exports, "boardSettingsQueryConfigParamValues", () => $12a3433d60ba6dc8$export$a9ebdab56bd9c0c3);
$parcel$export(module.exports, "EDIT_BOARD_CONFIG", () => $12a3433d60ba6dc8$export$b893894941c14e43);
$parcel$export(module.exports, "ADMINISTER_PARENT_PROJECT", () => $12a3433d60ba6dc8$export$d14d5a7c294329c5);
$parcel$export(module.exports, "BACKLOG_FEATURE_KEY", () => $12a3433d60ba6dc8$export$e1671d3447ddd5ad);
$parcel$export(module.exports, "SPRINTS_FEATURE_KEY", () => $12a3433d60ba6dc8$export$46efc2c8d8106cff);
$parcel$export(module.exports, "USER_PICKER_PROJECT_PERMISSION_KEY", () => $12a3433d60ba6dc8$export$1e63b013f0e45de0);
$parcel$export(module.exports, "ADMINISTER_PROJECT_PERMISSION_KEY", () => $12a3433d60ba6dc8$export$68030ac1ea4abd4c);
$parcel$export(module.exports, "FEATURE_ENABLED_STATUS", () => $12a3433d60ba6dc8$export$a1046f102eae498);
const $12a3433d60ba6dc8$export$128e24da52662cdd = '1000_1500_2000_2500_3000_4000';
const $12a3433d60ba6dc8$export$efdecbe4c9f1cd2c = '2QE2xWf0TpDbYpk4oY9aQr';
const $12a3433d60ba6dc8$export$7cadd2a48a9ff918 = `${$12a3433d60ba6dc8$export$efdecbe4c9f1cd2c}.config-disabled-section.article.analytics`;
const $12a3433d60ba6dc8$export$a546b6d48878ce6f = 'Epic';
const $12a3433d60ba6dc8$export$a9ebdab56bd9c0c3 = {
    cardColors: 'cardColors',
    cardLayout: 'cardLayout',
    columns: 'columns',
    estimation: 'estimation',
    general: 'filter',
    swimlanes: 'swimlanes',
    workingDays: 'time',
    timeline: 'timelineConfig',
    quickFilters: 'quickFilters',
    insights: 'insightsConfig'
};
const $12a3433d60ba6dc8$export$773ca4f5fb67778b = 60000;
const $12a3433d60ba6dc8$export$b893894941c14e43 = 'EDIT_BOARD_CONFIG';
const $12a3433d60ba6dc8$export$d14d5a7c294329c5 = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
'ADMINISTER_PARENT_PROJECT';
const $12a3433d60ba6dc8$export$e1671d3447ddd5ad = 'BACKLOG';
const $12a3433d60ba6dc8$export$46efc2c8d8106cff = 'SPRINTS';
const $12a3433d60ba6dc8$export$1e63b013f0e45de0 = 'USER_PICKER';
const $12a3433d60ba6dc8$export$68030ac1ea4abd4c = 'ADMINISTER';
const $12a3433d60ba6dc8$export$a1046f102eae498 = 'ENABLED';
const $12a3433d60ba6dc8$export$450e5ddc9f1ff901 = 'DISABLED';

});

parcelRegister("ck59k", function(module, exports) {

$parcel$export(module.exports, "useIsUserLocatedBoard", () => $d1fbcf4b1fc59ff0$export$374923c4a1431d8c);

var $eUqFw = parcelRequire("eUqFw");

var $exb0h = parcelRequire("exb0h");

var $10fdS = parcelRequire("10fdS");
const $d1fbcf4b1fc59ff0$export$374923c4a1431d8c = ()=>{
    const { name: name } = (0, $10fdS.useCurrentRoute)();
    return (0, $eUqFw.useMemo)(()=>name === (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_USER_BOARD || name === (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_USER_BACKLOG, [
        name
    ]);
};

});

parcelRegister("7agTL", function(module, exports) {

$parcel$export(module.exports, "useBoardId", () => $c40a93df9046ed42$export$b49754504c41149f);

var $kJlBc = parcelRequire("kJlBc");
const $c40a93df9046ed42$export$b49754504c41149f = ()=>{
    const [{ match: { params: params } }] = (0, $kJlBc.useRouter)();
    return Number(params.boardId) || null;
};

});

parcelRegister("11mDi", function(module, exports) {

$parcel$export(module.exports, "BoardSettingsQuickFiltersSkeleton", () => $6e4e03dac37f7133$export$19405c6b234d3355);
$parcel$export(module.exports, "BoardSettingsEstimatesSkeleton", () => $6e4e03dac37f7133$export$82d514eb7cbc86e9);
$parcel$export(module.exports, "BoardSettingsSwimlanesSkeleton", () => $6e4e03dac37f7133$export$7102e9b2e24c5fb8);
$parcel$export(module.exports, "BoardSettingsTimelineSkeleton", () => $6e4e03dac37f7133$export$11659454ee8ccaae);
$parcel$export(module.exports, "BoardSettingsCardColorsSkeleton", () => $6e4e03dac37f7133$export$d5b7d43024290176);
$parcel$export(module.exports, "BoardSettingsCardLayoutSkeleton", () => $6e4e03dac37f7133$export$c360c76165518ec2);
$parcel$export(module.exports, "BoardSettingsGeneralSettingsSkeleton", () => $6e4e03dac37f7133$export$e8fa8b349e1b6ae);
$parcel$export(module.exports, "BoardSettingsItemListSkeleton", () => $6e4e03dac37f7133$export$d50fb944d9db65fa);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");

var $b7CaG = parcelRequire("b7CaG");

var $8HBu7 = parcelRequire("8HBu7");

var $56tlW = parcelRequire("56tlW");

var $1JIY3 = parcelRequire("1JIY3");

var $lwuzS = parcelRequire("lwuzS");

var $hN5Rd = parcelRequire("hN5Rd");

var $5RsfU = parcelRequire("5RsfU");

var $2zTtb = parcelRequire("2zTtb");
const $6e4e03dac37f7133$var$customCssStyles = null;
const $6e4e03dac37f7133$export$19405c6b234d3355 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hN5Rd)))
    });
const $6e4e03dac37f7133$export$82d514eb7cbc86e9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($56tlW)))
    });
const $6e4e03dac37f7133$export$7102e9b2e24c5fb8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5RsfU)))
    });
const $6e4e03dac37f7133$export$11659454ee8ccaae = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2zTtb)))
    });
const $6e4e03dac37f7133$export$d5b7d43024290176 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($b7CaG)))
    });
const $6e4e03dac37f7133$export$c360c76165518ec2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8HBu7)))
    });
const $6e4e03dac37f7133$export$e8fa8b349e1b6ae = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1JIY3)))
    });
const $6e4e03dac37f7133$export$d50fb944d9db65fa = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($lwuzS))),
        containerStyles: {
            height: '240px'
        },
        className: (0, $7JEyt.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("b7CaG", function(module, exports) {
module.exports = new URL("card-colors-app-skeleton.tpl.8b0bbc0d.svg", import.meta.url).toString();

});

parcelRegister("8HBu7", function(module, exports) {
module.exports = new URL("card-layout-app-skeleton.tpl.6c555b33.svg", import.meta.url).toString();

});

parcelRegister("56tlW", function(module, exports) {
module.exports = new URL("estimates-app-skeleton.tpl.440d8209.svg", import.meta.url).toString();

});

parcelRegister("1JIY3", function(module, exports) {
module.exports = new URL("general-settings-app-skeleton.tpl.b9bd2bdd.svg", import.meta.url).toString();

});

parcelRegister("lwuzS", function(module, exports) {
module.exports = new URL("item-list-app-skeleton.tpl.303599a3.svg", import.meta.url).toString();

});

parcelRegister("hN5Rd", function(module, exports) {
module.exports = new URL("quick-filters-app-skeleton.tpl.2d23d208.svg", import.meta.url).toString();

});

parcelRegister("5RsfU", function(module, exports) {
module.exports = new URL("swimlanes-app-skeleton.tpl.6fa567f0.svg", import.meta.url).toString();

});

parcelRegister("2zTtb", function(module, exports) {
module.exports = new URL("timeline-app-skeleton.tpl.f6ad6dde.svg", import.meta.url).toString();

});


parcelRegister("5oh7s", function(module, exports) {

$parcel$export(module.exports, "default", () => $39d3e518e0472147$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7f83f450dfcc9fbf52cf578680f81723>>
 * @relayHash 8ba289969fdfef4cfb9de7089b35e65e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5feaa54c4f48255ec0ebfffdd1953e451f632233b0c2f24fffcf59ba8bb7dc5c
const $39d3e518e0472147$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        },
        {
            "kind": "Literal",
            "name": "isCMP",
            "value": true
        }
    ], v2 = {
        "concreteType": "CurrentUser",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "permissions"
            }
        ]
    }, v3 = {
        "kind": "ScalarField",
        "name": "cardColorStrategy"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "canEdit"
    }, v6 = {
        "kind": "ScalarField",
        "name": "strategy"
    }, v7 = {
        "kind": "ScalarField",
        "name": "value"
    }, v8 = {
        "kind": "ScalarField",
        "name": "displayValue"
    }, v9 = {
        "kind": "ScalarField",
        "name": "color"
    }, v10 = {
        "kind": "ScalarField",
        "name": "isUsed"
    }, v11 = {
        "kind": "ScalarField",
        "name": "isGlobalColor"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "cardColorsSettingsPageQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            v2 /*: any*/ ,
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "JswCardColorConfig",
                                    "kind": "LinkedField",
                                    "name": "cardColorConfig",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v3 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.cardColorConfig.cardColorStrategy"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JswCardColorStrategy",
                                                "kind": "LinkedField",
                                                "name": "cardColorStrategies",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v4 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.cardColorConfig.cardColorStrategies.id"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v5 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.cardColorConfig.cardColorStrategies.canEdit"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JswCardColorConnection",
                                                            "kind": "LinkedField",
                                                            "name": "cardColors",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "JswCardColorEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": {
                                                                                    "concreteType": "JswCardColor",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "RequiredField",
                                                                                            "field": v4 /*: any*/ ,
                                                                                            "action": "THROW",
                                                                                            "path": "boardScope.cardColorConfig.cardColorStrategies.cardColors.edges.node.id"
                                                                                        },
                                                                                        {
                                                                                            "kind": "RequiredField",
                                                                                            "field": v6 /*: any*/ ,
                                                                                            "action": "THROW",
                                                                                            "path": "boardScope.cardColorConfig.cardColorStrategies.cardColors.edges.node.strategy"
                                                                                        },
                                                                                        {
                                                                                            "kind": "RequiredField",
                                                                                            "field": v7 /*: any*/ ,
                                                                                            "action": "THROW",
                                                                                            "path": "boardScope.cardColorConfig.cardColorStrategies.cardColors.edges.node.value"
                                                                                        },
                                                                                        {
                                                                                            "kind": "RequiredField",
                                                                                            "field": v8 /*: any*/ ,
                                                                                            "action": "THROW",
                                                                                            "path": "boardScope.cardColorConfig.cardColorStrategies.cardColors.edges.node.displayValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "RequiredField",
                                                                                            "field": v9 /*: any*/ ,
                                                                                            "action": "THROW",
                                                                                            "path": "boardScope.cardColorConfig.cardColorStrategies.cardColors.edges.node.color"
                                                                                        },
                                                                                        {
                                                                                            "kind": "RequiredField",
                                                                                            "field": v10 /*: any*/ ,
                                                                                            "action": "THROW",
                                                                                            "path": "boardScope.cardColorConfig.cardColorStrategies.cardColors.edges.node.isUsed"
                                                                                        },
                                                                                        v11 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                "action": "THROW",
                                                                                "path": "boardScope.cardColorConfig.cardColorStrategies.cardColors.edges.node"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "boardScope.cardColorConfig.cardColorStrategies.cardColors.edges"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "boardScope.cardColorConfig.cardColorStrategies.cardColors"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.cardColorConfig.cardColorStrategies"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.cardColorConfig"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "boardScope"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "cardColorsSettingsPageQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "JswCardColorConfig",
                            "kind": "LinkedField",
                            "name": "cardColorConfig",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JswCardColorStrategy",
                                    "kind": "LinkedField",
                                    "name": "cardColorStrategies",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "concreteType": "JswCardColorConnection",
                                            "kind": "LinkedField",
                                            "name": "cardColors",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JswCardColorEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JswCardColor",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                v8 /*: any*/ ,
                                                                v9 /*: any*/ ,
                                                                v10 /*: any*/ ,
                                                                v11 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v4 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "5feaa54c4f48255ec0ebfffdd1953e451f632233b0c2f24fffcf59ba8bb7dc5c",
            "metadata": {},
            "name": "cardColorsSettingsPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$39d3e518e0472147$var$node.hash = "5e4787dfed088870f48db1ecbe159e44";
var $39d3e518e0472147$export$2e2bcd8739ae039 = $39d3e518e0472147$var$node;

});

parcelRegister("72rNe", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('kgFdO')
        ]);
        const value = parcelRequire('2YOZ0');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("kgFdO")
    ]).then(()=>parcelRequire('2YOZ0'));
}

});

parcelRegister("1C4oQ", function(module, exports) {

$parcel$export(module.exports, "SettingsContainer", () => $1148c3477b67a7c2$export$8376625f8bb18347);

var $eUqFw = parcelRequire("eUqFw");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $3pFh0 = parcelRequire("3pFh0");
const $1148c3477b67a7c2$export$8376625f8bb18347 = ({ children: children, packageId: packageId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: packageId,
        packageName: packageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3pFh0.default), null, children));

});
parcelRegister("3pFh0", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c8a24473f13b5fd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $ck59k = parcelRequire("ck59k");

var $iPduV = parcelRequire("iPduV");

var $19MhU = parcelRequire("19MhU");

var $auHR2 = parcelRequire("auHR2");

var $4jd0g = parcelRequire("4jd0g");
const $1c8a24473f13b5fd$var$SettingsContainerContent = ({ children: children })=>{
    const isJsm = (0, $iPduV.useIsJSMBoard)();
    const isUserLocatedBoard = (0, $ck59k.useIsUserLocatedBoard)();
    const [configQuery, setConfigParam] = (0, $4jd0g.useConfigQuery)();
    const navigateSettings = (0, $eUqFw.useCallback)((configParam)=>{
        setConfigParam(configParam);
    }, [
        setConfigParam
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingInline: "space.500"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $19MhU.Header), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $auHR2.default), {
        isJsm: isJsm,
        isUserLocatedBoard: isUserLocatedBoard,
        currentConfigQuery: configQuery,
        onNavigate: navigateSettings
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingBlockStart: "space.300",
        paddingBlockEnd: "space.250",
        xcss: $1c8a24473f13b5fd$var$pageStyles
    }, children)));
};
const $1c8a24473f13b5fd$var$pageStyles = (0, $1ZAYh.xcss)({
    flexGrow: 1
});
var $1c8a24473f13b5fd$export$2e2bcd8739ae039 = $1c8a24473f13b5fd$var$SettingsContainerContent;

});
parcelRegister("iPduV", function(module, exports) {

$parcel$export(module.exports, "useIsJSMBoard", () => $e46ce7d40f5e2ae1$export$caf439d171aab0ca);

var $eUqFw = parcelRequire("eUqFw");

var $exb0h = parcelRequire("exb0h");

var $10fdS = parcelRequire("10fdS");
const $e46ce7d40f5e2ae1$export$caf439d171aab0ca = ()=>{
    const { name: name } = (0, $10fdS.useCurrentRoute)();
    return (0, $eUqFw.useMemo)(()=>name === (0, $exb0h.ROUTE_NAMES).SERVICEDESK_BOARDS, [
        name
    ]);
};

});

parcelRegister("19MhU", function(module, exports) {

$parcel$export(module.exports, "Header", () => $e0de63d0867efa3e$export$8b251419efc915eb);

var $eUqFw = parcelRequire("eUqFw");

var $fI650 = parcelRequire("fI650");

var $gpZWO = parcelRequire("gpZWO");

var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $c76ap = parcelRequire("c76ap");

var $3a8wJ = parcelRequire("3a8wJ");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kJlBc = parcelRequire("kJlBc");

var $c1Huc = parcelRequire("c1Huc");
var $qsrU2 = parcelRequire("qsrU2");

var $erwI8 = parcelRequire("erwI8");

var $caCDM = parcelRequire("caCDM");
const $e0de63d0867efa3e$export$8b251419efc915eb = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ location: location }] = (0, $kJlBc.useRouter)();
    const { board: board } = (0, $c1Huc.useBoardAndLocationContext)();
    const { boardName: boardName } = (0, $qsrU2.useSettingsContainerContext)();
    const breadcrumbs = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c76ap.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $erwI8.SettingsContainerBreadcrumbs), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3a8wJ.default), {
        breadcrumbs: breadcrumbs,
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fI650.default), {
            href: location.pathname,
            appearance: "subtle"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            xcss: $e0de63d0867efa3e$var$buttonTextStyles,
            alignBlock: "center",
            as: "span"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gpZWO))), {
            size: "small",
            label: ""
        }), formatMessage((0, $caCDM.default).backToBoard)))
    }, formatMessage((0, $caCDM.default).boardSettingsTitle, {
        boardName: boardName ?? board?.name ?? ''
    }));
};
const $e0de63d0867efa3e$var$buttonTextStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.subtle',
    fontWeight: "var(--ds-font-weight-regular, 400)"
});

});
parcelRegister("gpZWO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bf3f089e16becc19$var$_react = $bf3f089e16becc19$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $bf3f089e16becc19$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $bf3f089e16becc19$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $bf3f089e16becc19$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.207 5.793a1 1 0 010 1.414L8.414 11H18a1 1 0 110 2H8.414l3.793 3.793a1 1 0 11-1.415 1.414l-5.499-5.5A.997.997 0 015 12.028v-.057a.996.996 0 01.293-.678l5.499-5.5a1 1 0 011.415 0z" fill="currentColor"/></svg>`
    }, props));
$bf3f089e16becc19$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $bf3f089e16becc19$var$_default = $bf3f089e16becc19$var$ArrowLeftIcon;
module.exports.default = $bf3f089e16becc19$var$_default;

});

parcelRegister("3a8wJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2992b0d4d3fe9569$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /* This is a wrapper around @atlaskit/page-header to patch a bug where text alignment
 in actions is incorrect. This common component is no longer necessary when
 https://ecosystem.atlassian.net/browse/AK-6385 is resolved.
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hFGUl = parcelRequire("hFGUl");
/* eslint-enable */ const $2992b0d4d3fe9569$var$PageHeader = ({ actions: actions, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFGUl.default), {
        ...props,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>> | undefined'.
        actions: actions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2992b0d4d3fe9569$var$ActionsWrapper, null, actions) : null
    });
var $2992b0d4d3fe9569$export$2e2bcd8739ae039 = $2992b0d4d3fe9569$var$PageHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2992b0d4d3fe9569$var$ActionsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hFGUl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0ce2fac4b2f156d$export$2e2bcd8739ae039);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $eUqFw = parcelRequire("eUqFw");

var $5ubTM = parcelRequire("5ubTM");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $f0ce2fac4b2f156d$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.OuterWrapper), null, breadcrumbs, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.TitleWrapper), {
        truncateTitle: truncateTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.TitleContainer), {
        truncateTitle: truncateTitle
    }, disableTitleStyles ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.StyledTitleWrapper), {
        ref: innerRef,
        truncateTitle: truncateTitle,
        id: id
    }, children)), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.ActionsWrapper), null, actions)), bottomBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.BottomBarWrapper), null, " ", bottomBar, " "));
};
var $f0ce2fac4b2f156d$export$2e2bcd8739ae039 = $f0ce2fac4b2f156d$var$PageHeader;

});
parcelRegister("5ubTM", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $fce98fdc5842132f$export$edaaad985a878983);
$parcel$export(module.exports, "StyledTitleWrapper", () => $fce98fdc5842132f$export$284be1ee64a3465c);
$parcel$export(module.exports, "TitleWrapper", () => $fce98fdc5842132f$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleContainer", () => $fce98fdc5842132f$export$35e09ba17cc51c69);
$parcel$export(module.exports, "ActionsWrapper", () => $fce98fdc5842132f$export$c8223871eecc8f3a);
$parcel$export(module.exports, "BottomBarWrapper", () => $fce98fdc5842132f$export$6330225854c30dc);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ /**
                                                                          * @jsxRuntime classic
                                                                          */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4lTFP = parcelRequire("4lTFP");
function $fce98fdc5842132f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fce98fdc5842132f$var$truncateStyles = {
    name: "n3ut7m",
    styles: "overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $fce98fdc5842132f$var$outerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-200, 16px)"} 0`
});
const $fce98fdc5842132f$var$titleStyles = {
    name: "1o56te0",
    styles: "color:var(--ds-text, #172B4D);font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);letter-spacing:normal;margin-block-start:0;outline:none"
};
const $fce98fdc5842132f$var$styledTitleStyles = {
    name: "1n9ug5o",
    styles: "line-height:var(--ds-font-lineHeight-500, 32px);margin-block-start:0;outline:none"
};
const $fce98fdc5842132f$var$titleWrapperStyles = {
    name: "1wb76vg",
    styles: "display:flex;align-items:flex-start;flex-wrap:wrap"
};
const $fce98fdc5842132f$var$titleWrapperTruncateStyles = {
    name: "14gl6v0",
    styles: "flex-wrap:nowrap"
};
const $fce98fdc5842132f$var$titleContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    minWidth: 0,
    maxWidth: '100%',
    flex: '1 0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    flexShrink: undefined,
    marginBlockEnd: "var(--ds-space-100, 8px)"
});
const $fce98fdc5842132f$var$actionStyles = {
    name: "1ianfu6",
    styles: "max-width:100%;flex:0 0 auto;margin-block-end:var(--ds-space-100, 8px);margin-inline-start:auto;padding-inline-start:var(--ds-space-400, 32px);white-space:nowrap;>{text-align:right;}"
};
const $fce98fdc5842132f$var$titleContainerTruncateStyles = {
    name: "s2a4s9",
    styles: "flex-shrink:1"
};
const $fce98fdc5842132f$var$bottomBarStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.200'
});
const $fce98fdc5842132f$export$edaaad985a878983 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $fce98fdc5842132f$var$outerStyles
    }, children);
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $fce98fdc5842132f$var$h700Styles = /*#__PURE__*/ (0, $byn9U.css)((0, $4lTFP.h700)());
const $fce98fdc5842132f$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("h1", {
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            ...(0, $XHGTv.getBooleanFF)('platform.design-system-team.page-header-tokenised-typography-styles_lj1ix') ? [
                $fce98fdc5842132f$var$titleStyles
            ] : [
                $fce98fdc5842132f$var$h700Styles,
                $fce98fdc5842132f$var$styledTitleStyles
            ],
            truncateTitle && $fce98fdc5842132f$var$truncateStyles
        ],
        ref: ref,
        tabIndex: -1,
        id: id
    }, children);
});
const $fce98fdc5842132f$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fce98fdc5842132f$var$titleWrapperStyles,
            truncateTitle && $fce98fdc5842132f$var$titleWrapperTruncateStyles
        ]
    }, children);
};
const $fce98fdc5842132f$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fce98fdc5842132f$var$titleContainerStyles,
            truncateTitle && $fce98fdc5842132f$var$titleContainerTruncateStyles
        ]
    }, children);
};
const $fce98fdc5842132f$export$c8223871eecc8f3a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $fce98fdc5842132f$var$actionStyles
    }, children);
};
const $fce98fdc5842132f$export$6330225854c30dc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $fce98fdc5842132f$var$bottomBarStyles
    }, children);
};

});



parcelRegister("c1Huc", function(module, exports) {

$parcel$export(module.exports, "useBoardAndLocationContext", () => $3f5db920467c3248$export$d2a945b4dfcaff34);

var $2futN = parcelRequire("2futN");
var $fZLkL = parcelRequire("fZLkL");

var $ck59k = parcelRequire("ck59k");
const $3f5db920467c3248$export$d2a945b4dfcaff34 = ()=>{
    const isUserLocated = (0, $ck59k.useIsUserLocatedBoard)();
    // This hook returns project data + board info for project-located boards
    const { data: projectData, error: projectError } = (0, $2futN.useJiraSoftwareProjectNavigation)();
    // This hook returns user-located board data
    const { data: userData, error: userError } = (0, $fZLkL.useJiraUserBoardNavigationResource)();
    return {
        project: projectData?.project,
        user: userData?.owner,
        board: isUserLocated ? userData?.boardInfo : projectData?.boardInfo,
        error: isUserLocated ? userError : projectError
    };
};

});
parcelRegister("fZLkL", function(module, exports) {

$parcel$export(module.exports, "useJiraUserBoardNavigationResource", () => $5532da2351a35010$export$517acde8347261e3);

var $4MmfV = parcelRequire("4MmfV");

var $3HCkE = parcelRequire("3HCkE");
const $5532da2351a35010$export$517acde8347261e3 = ()=>(0, $3HCkE.useResource)((0, $4MmfV.staticJSWUserBoardSidebarNavigationResource));

});


parcelRegister("qsrU2", function(module, exports) {

$parcel$export(module.exports, "useSettingsContainerContext", () => $7de1194e6cfdc3b6$export$c5c6fce7d59c4789);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $7de1194e6cfdc3b6$var$INITIAL_STATE = {
    boardName: null
};
const $7de1194e6cfdc3b6$var$actions = {
    updateBoardName: (name)=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                boardName: name
            });
        }
};
const $7de1194e6cfdc3b6$var$Store = (0, $a61MH.createStore)({
    initialState: $7de1194e6cfdc3b6$var$INITIAL_STATE,
    actions: $7de1194e6cfdc3b6$var$actions,
    name: 'SettingsContainerState'
});
const $7de1194e6cfdc3b6$var$useStore = (0, $ggKAj.createHook)($7de1194e6cfdc3b6$var$Store);
const $7de1194e6cfdc3b6$export$c5c6fce7d59c4789 = ()=>{
    const [state, allActions] = $7de1194e6cfdc3b6$var$useStore();
    return {
        ...state,
        ...allActions
    };
};

});

parcelRegister("erwI8", function(module, exports) {

$parcel$export(module.exports, "SettingsContainerBreadcrumbs", () => $981413f339ff28c1$export$9f5f61e17edbced6);

var $eUqFw = parcelRequire("eUqFw");

var $kKe2o = parcelRequire("kKe2o");
var $dpXKE = parcelRequire("dpXKE");
var $5c2C3 = parcelRequire("5c2C3");

var $kJlBc = parcelRequire("kJlBc");

var $c1Huc = parcelRequire("c1Huc");
var $ck59k = parcelRequire("ck59k");
var $qsrU2 = parcelRequire("qsrU2");
const $981413f339ff28c1$export$38f8c59e2af08a87 = ({ project: project, board: board })=>{
    const { boardName: nextBoardName } = (0, $qsrU2.useSettingsContainerContext)();
    const { key: projectKey, name: projectName, id: projectId, simplified: simplified } = project;
    const { name: boardName, id: boardId } = board;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dpXKE.default), {
        projectKey: projectKey,
        projectName: projectName,
        projectId: projectId,
        isSimplifiedProject: simplified
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKe2o.default), {
        breadcrumb: {
            text: nextBoardName ?? boardName,
            href: `/jira/software/c/projects/${projectKey}/boards/${boardId}`,
            type: 'boardName',
            analyticsAttributes: {
                nextGenProject: simplified,
                projectConfig: simplified ? 'next-gen' : 'classic'
            },
            analyticsFields: {
                name: 'navigateToSubProject',
                containerId: projectId,
                containerType: 'project'
            }
        }
    }));
};
const $981413f339ff28c1$export$74fdd5a0187b08ef = ({ user: user, board: board })=>{
    const [{ query: query }] = (0, $kJlBc.useRouter)();
    const { boardName: nextBoardName } = (0, $qsrU2.useSettingsContainerContext)();
    const { profileUrl: profileUrl, name: userName, accountId: accountId } = user;
    const { name: boardName, id: boardId } = board;
    const isLocationless = !!query.locationless;
    if (isLocationless) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5c2C3.default), {
        profileUrl: profileUrl,
        name: userName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKe2o.default), {
        breadcrumb: {
            text: nextBoardName ?? boardName,
            href: `/secure/RapidBoard.jspa?rapidView=${boardId}&locationless=true`,
            type: 'boardName'
        }
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5c2C3.default), {
        profileUrl: profileUrl,
        name: userName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKe2o.default), {
        breadcrumb: {
            text: nextBoardName ?? boardName,
            href: `/jira/people/${accountId}/boards/${boardId}`,
            type: 'boardName'
        }
    }));
};
const $981413f339ff28c1$export$9f5f61e17edbced6 = ()=>{
    const isUserLocated = (0, $ck59k.useIsUserLocatedBoard)();
    const { project: project, user: user, board: board, error: error } = (0, $c1Huc.useBoardAndLocationContext)();
    if (error || !board) return null;
    if (isUserLocated && user) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($981413f339ff28c1$export$74fdd5a0187b08ef, {
        user: user,
        board: board
    });
    if (project) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($981413f339ff28c1$export$38f8c59e2af08a87, {
        project: project,
        board: board
    });
    return null;
};

});

parcelRegister("caCDM", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ae139945d8f0b2c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6ae139945d8f0b2c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    boardSettingsTitle: {
        "id": "software-board-settings-rapidboard-config-common.settings-container.header.board-settings-title.non-final",
        "defaultMessage": "Settings for {boardName}"
    },
    backToBoard: {
        "id": "software-board-settings-rapidboard-config-common.settings-container.header.back-to-board.non-final",
        "defaultMessage": "Back to board"
    }
});

});


parcelRegister("auHR2", function(module, exports) {

$parcel$export(module.exports, "default", () => $51b3b3de3b4fb846$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");

var $1fF9e = parcelRequire("1fF9e");

var $aHid6 = parcelRequire("aHid6");

var $34a7o = parcelRequire("34a7o");
const $51b3b3de3b4fb846$var$Menu = ({ isJsm: isJsm, isUserLocatedBoard: isUserLocatedBoard, currentConfigQuery: currentConfigQuery, onNavigate: onNavigate })=>{
    const { setSelectedConfigTab: setSelectedConfigTab } = (0, $1fF9e.useSelectedConfigTab)();
    const menuItems = (0, $34a7o.useMenuItems)(isJsm, isUserLocatedBoard);
    const options = (0, $eUqFw.useMemo)(()=>menuItems.map(({ id: id, name: name, configQuery: configQuery })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aHid6.MenuItem), {
                key: id,
                name: name,
                isSelected: currentConfigQuery === configQuery,
                onClick: ()=>{
                    setSelectedConfigTab(configQuery);
                    onNavigate(configQuery);
                }
            })), [
        menuItems,
        currentConfigQuery,
        setSelectedConfigTab,
        onNavigate
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingInlineEnd: "space.500",
        paddingBlockStart: "space.250",
        paddingBlockEnd: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("ul", {
        className: (0, $7JEyt.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
        ])
    }, options));
};
const $51b3b3de3b4fb846$var$listStyles = null;
var $51b3b3de3b4fb846$export$2e2bcd8739ae039 = $51b3b3de3b4fb846$var$Menu;

});
parcelRegister("1fF9e", function(module, exports) {

$parcel$export(module.exports, "useSelectedConfigTab", () => $7f7e09d62164e8b6$export$9b386f1a3e61b385);
const $7f7e09d62164e8b6$export$9b386f1a3e61b385 = ()=>{
    const SELECTED_CONFIG_TAB_KEY = 'selectedConfigTab';
    const getSelectedConfigTab = ()=>localStorage.getItem(SELECTED_CONFIG_TAB_KEY) || '';
    const setSelectedConfigTab = (newConfigTab)=>localStorage.setItem(SELECTED_CONFIG_TAB_KEY, `"${newConfigTab}"`);
    return {
        getSelectedConfigTab: getSelectedConfigTab,
        setSelectedConfigTab: setSelectedConfigTab
    };
};

});

parcelRegister("aHid6", function(module, exports) {

$parcel$export(module.exports, "MenuItem", () => $5fc8da587a0975b8$export$2ce376c2cc3355c8);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");
const $5fc8da587a0975b8$export$2ce376c2cc3355c8 = ({ name: name, isSelected: isSelected, onClick: onClick })=>{
    const onButtonClick = (0, $eUqFw.useCallback)(()=>{
        if (isSelected) return;
        onClick();
    }, [
        onClick,
        isSelected
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", {
        className: (0, $7JEyt.default)([
            "_2mzuglyw _1e0c1ule _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
        role: "link",
        onClick: onButtonClick,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _1yt41bs6 _19itglyw _o5721q9c _2rko1b66 _y3gn1e5h _nt751r31 _49pcglyw _1hvw1o36 _7ehiq5pt _d0altlke _1q5t1r31 _1ohyglyw _1r9x1o36 _180dq5pt",
            isSelected ? "_bfhkfg4m _syazaqb7 _k48p1pd9 _kqswh2mm _1mp41b66 _1cs8stnw _1auku2gc _19wou2gc _qnecidpf _1rusaqb7 _rfx36lav _1kt9b3bt" : "_bfhk1j9a _syaz1fxt _irr3fg4m _30l3aqb7"
        ])
    }, name));
};
const $5fc8da587a0975b8$var$baseStyles = null;
const $5fc8da587a0975b8$var$notSelectedStyle = null;
const $5fc8da587a0975b8$var$selectedStyle = null;
const $5fc8da587a0975b8$var$listItemStyles = null;

});

parcelRegister("34a7o", function(module, exports) {

$parcel$export(module.exports, "useMenuItems", () => $0ee8573825e75806$export$aad046bd9909db8f);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kvtEB = parcelRequire("kvtEB");
const $0ee8573825e75806$export$aad046bd9909db8f = (isJsm, isUserLocatedBoard)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return (0, $eUqFw.useMemo)(()=>(0, $kvtEB.MENU_ITEMS).flatMap((item)=>(item.jsmAllowed || !isJsm) && (item.userLocatedBoardAllowed || !isUserLocatedBoard) ? [
                {
                    ...item,
                    name: formatMessage(item.name)
                }
            ] : []), [
        formatMessage,
        isJsm,
        isUserLocatedBoard
    ]);
};

});
parcelRegister("kvtEB", function(module, exports) {

$parcel$export(module.exports, "MENU_ITEMS", () => $26cf00a7018c8356$export$de8e43e9355dd4b1);

var $ddT06 = parcelRequire("ddT06");

var $bD7HI = parcelRequire("bD7HI");
const $26cf00a7018c8356$export$de8e43e9355dd4b1 = [
    {
        id: 'general',
        configQuery: (0, $ddT06.boardSettingsQueryConfigParamValues).general,
        name: (0, $bD7HI.default).generalMenuItemLabelNonFinal,
        jsmAllowed: true,
        userLocatedBoardAllowed: true
    },
    {
        id: 'columns',
        configQuery: (0, $ddT06.boardSettingsQueryConfigParamValues).columns,
        name: (0, $bD7HI.default).columnsMenuItemLabelNonFinal,
        jsmAllowed: true,
        userLocatedBoardAllowed: true
    },
    {
        id: 'swimlanes',
        configQuery: (0, $ddT06.boardSettingsQueryConfigParamValues).swimlanes,
        name: (0, $bD7HI.default).swimlanesMenuItemLabelNonFinal,
        jsmAllowed: true,
        userLocatedBoardAllowed: true
    },
    {
        id: 'quickFilters',
        configQuery: (0, $ddT06.boardSettingsQueryConfigParamValues).quickFilters,
        name: (0, $bD7HI.default).quickFiltersMenuItemLabelNonFinal,
        jsmAllowed: true,
        userLocatedBoardAllowed: true
    },
    {
        id: 'cardColors',
        configQuery: (0, $ddT06.boardSettingsQueryConfigParamValues).cardColors,
        name: (0, $bD7HI.default).cardColoursMenuItemLabelNonFinal,
        jsmAllowed: true,
        userLocatedBoardAllowed: true
    },
    {
        id: 'cardLayout',
        configQuery: (0, $ddT06.boardSettingsQueryConfigParamValues).cardLayout,
        name: (0, $bD7HI.default).cardLayoutMenuItemLabelNonFinal,
        jsmAllowed: true,
        userLocatedBoardAllowed: true
    },
    {
        id: 'estimation',
        configQuery: (0, $ddT06.boardSettingsQueryConfigParamValues).estimation,
        name: (0, $bD7HI.default).estimationMenuItemLabelNonFinal,
        jsmAllowed: false,
        userLocatedBoardAllowed: true
    },
    {
        id: 'time',
        configQuery: (0, $ddT06.boardSettingsQueryConfigParamValues).workingDays,
        name: (0, $bD7HI.default).workingDaysMenuItemLabelNonFinal,
        jsmAllowed: false,
        userLocatedBoardAllowed: true
    },
    {
        id: 'timeline',
        configQuery: (0, $ddT06.boardSettingsQueryConfigParamValues).timeline,
        name: (0, $bD7HI.default).timelineMenuItemLabelNonFinal,
        jsmAllowed: false,
        userLocatedBoardAllowed: false
    },
    {
        id: 'insights',
        configQuery: (0, $ddT06.boardSettingsQueryConfigParamValues).insights,
        name: (0, $bD7HI.default).insightsMenuItemLabelNonFinal,
        jsmAllowed: false,
        userLocatedBoardAllowed: false
    }
];

});
parcelRegister("bD7HI", function(module, exports) {

$parcel$export(module.exports, "default", () => $682ad66a2f093f9c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $682ad66a2f093f9c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    generalMenuItemLabelNonFinal: {
        "id": "software-board-settings-rapidboard-config-common.settings-container.menu.general-menu-item-label-non-final",
        "defaultMessage": "General"
    },
    columnsMenuItemLabelNonFinal: {
        "id": "software-board-settings-rapidboard-config-common.settings-container.menu.columns-menu-item-label-non-final",
        "defaultMessage": "Columns"
    },
    swimlanesMenuItemLabelNonFinal: {
        "id": "software-board-settings-rapidboard-config-common.settings-container.menu.swimlanes-menu-item-label-non-final",
        "defaultMessage": "Swimlanes"
    },
    quickFiltersMenuItemLabelNonFinal: {
        "id": "software-board-settings-rapidboard-config-common.settings-container.menu.quick-filters-menu-item-label-non-final",
        "defaultMessage": "Quick filters"
    },
    cardColoursMenuItemLabelNonFinal: {
        "id": "software-board-settings-rapidboard-config-common.settings-container.menu.card-colours-menu-item-label-non-final",
        "defaultMessage": "Card colors"
    },
    cardLayoutMenuItemLabelNonFinal: {
        "id": "software-board-settings-rapidboard-config-common.settings-container.menu.card-layout-menu-item-label-non-final",
        "defaultMessage": "Card layout"
    },
    estimationMenuItemLabelNonFinal: {
        "id": "software-board-settings-rapidboard-config-common.settings-container.menu.estimation-menu-item-label-non-final",
        "defaultMessage": "Estimation"
    },
    workingDaysMenuItemLabelNonFinal: {
        "id": "software-board-settings-rapidboard-config-common.settings-container.menu.working-days-menu-item-label-non-final",
        "defaultMessage": "Working Days"
    },
    timelineMenuItemLabelNonFinal: {
        "id": "software-board-settings-rapidboard-config-common.settings-container.menu.timeline-menu-item-label-non-final",
        "defaultMessage": "Timeline"
    },
    insightsMenuItemLabelNonFinal: {
        "id": "software-board-settings-rapidboard-config-common.settings-container.menu.insights-menu-item-label-non-final",
        "defaultMessage": "Insights"
    }
});

});




parcelRegister("4jd0g", function(module, exports) {

$parcel$export(module.exports, "useConfigQuery", () => $95f63335cdd94066$export$a8f49489fd1f338f);

var $kJlBc = parcelRequire("kJlBc");
const $95f63335cdd94066$export$a8f49489fd1f338f = ()=>{
    const [configQuery, setConfigParam] = (0, $kJlBc.useQueryParam)('config');
    if (!configQuery) throw new Error('No config param found');
    return [
        configQuery,
        setConfigParam
    ];
};

});



parcelRegister("dMKsY", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d784409d283c519$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e3a93b22bb858cfc8ff898e31a471c97>>
 * @relayHash b2a410eebdb751b4e55925d6116a5a10
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e2d9f64dbab3e3e369272ea7348936a3914de7cdea424ac9f623dc73e7a8b2ff
const $8d784409d283c519$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        },
        {
            "kind": "Literal",
            "name": "isCMP",
            "value": true
        }
    ], v2 = {
        "concreteType": "CurrentUser",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "permissions"
            }
        ]
    }, v3 = {
        "kind": "ScalarField",
        "name": "key"
    }, v4 = {
        "kind": "ScalarField",
        "name": "status"
    }, v5 = {
        "kind": "ScalarField",
        "name": "showDaysInColumn"
    }, v6 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "cardLayoutId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "name"
    }, v9 = {
        "kind": "ScalarField",
        "name": "isValid"
    }, v10 = {
        "kind": "ScalarField",
        "name": "id"
    }, v11 = [
        {
            "concreteType": "JswCurrentCardLayoutField",
            "kind": "LinkedField",
            "name": "fields",
            "plural": true,
            "selections": [
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ 
            ]
        },
        {
            "concreteType": "JswAvailableCardLayoutFieldConnection",
            "kind": "LinkedField",
            "name": "availableFields",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JswAvailableCardLayoutFieldEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JswAvailableCardLayoutField",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                v6 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "cardLayoutSettingsPageQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            v2 /*: any*/ ,
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "BoardFeature",
                                    "kind": "LinkedField",
                                    "name": "features",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v3 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.features.key"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v4 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.features.status"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.features"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "SoftwareBoard",
                                    "kind": "LinkedField",
                                    "name": "board",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v5 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.board.showDaysInColumn"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.board"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "JswCardLayoutConfig",
                                    "kind": "LinkedField",
                                    "name": "cardLayoutConfig",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JswCardLayoutContainer",
                                                "kind": "LinkedField",
                                                "name": "backlog",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JswCurrentCardLayoutField",
                                                            "kind": "LinkedField",
                                                            "name": "fields",
                                                            "plural": true,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v8 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.cardLayoutConfig.backlog.fields.name"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v9 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.cardLayoutConfig.backlog.fields.isValid"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "boardScope.cardLayoutConfig.backlog.fields"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JswAvailableCardLayoutFieldConnection",
                                                            "kind": "LinkedField",
                                                            "name": "availableFields",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "JswAvailableCardLayoutFieldEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": {
                                                                                    "concreteType": "JswAvailableCardLayoutField",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "RequiredField",
                                                                                            "field": v8 /*: any*/ ,
                                                                                            "action": "THROW",
                                                                                            "path": "boardScope.cardLayoutConfig.backlog.availableFields.edges.node.name"
                                                                                        },
                                                                                        v6 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "RequiredField",
                                                                                            "field": v9 /*: any*/ ,
                                                                                            "action": "THROW",
                                                                                            "path": "boardScope.cardLayoutConfig.backlog.availableFields.edges.node.isValid"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                "action": "THROW",
                                                                                "path": "boardScope.cardLayoutConfig.backlog.availableFields.edges.node"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "boardScope.cardLayoutConfig.backlog.availableFields.edges"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "boardScope.cardLayoutConfig.backlog.availableFields"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.cardLayoutConfig.backlog"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JswCardLayoutContainer",
                                                "kind": "LinkedField",
                                                "name": "board",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JswCurrentCardLayoutField",
                                                            "kind": "LinkedField",
                                                            "name": "fields",
                                                            "plural": true,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v8 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.cardLayoutConfig.board.fields.name"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v9 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.cardLayoutConfig.board.fields.isValid"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "boardScope.cardLayoutConfig.board.fields"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JswAvailableCardLayoutFieldConnection",
                                                            "kind": "LinkedField",
                                                            "name": "availableFields",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "JswAvailableCardLayoutFieldEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": {
                                                                                    "concreteType": "JswAvailableCardLayoutField",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "RequiredField",
                                                                                            "field": v8 /*: any*/ ,
                                                                                            "action": "THROW",
                                                                                            "path": "boardScope.cardLayoutConfig.board.availableFields.edges.node.name"
                                                                                        },
                                                                                        v6 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "RequiredField",
                                                                                            "field": v9 /*: any*/ ,
                                                                                            "action": "THROW",
                                                                                            "path": "boardScope.cardLayoutConfig.board.availableFields.edges.node.isValid"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                "action": "THROW",
                                                                                "path": "boardScope.cardLayoutConfig.board.availableFields.edges.node"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "boardScope.cardLayoutConfig.board.availableFields.edges"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "boardScope.cardLayoutConfig.board.availableFields"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.cardLayoutConfig.board"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.cardLayoutConfig"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "boardScope"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "cardLayoutSettingsPageQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "BoardFeature",
                            "kind": "LinkedField",
                            "name": "features",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "SoftwareBoard",
                            "kind": "LinkedField",
                            "name": "board",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v10 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "JswCardLayoutConfig",
                            "kind": "LinkedField",
                            "name": "cardLayoutConfig",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JswCardLayoutContainer",
                                    "kind": "LinkedField",
                                    "name": "backlog",
                                    "plural": false,
                                    "selections": v11 /*: any*/ 
                                },
                                {
                                    "concreteType": "JswCardLayoutContainer",
                                    "kind": "LinkedField",
                                    "name": "board",
                                    "plural": false,
                                    "selections": v11 /*: any*/ 
                                }
                            ]
                        },
                        v10 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "e2d9f64dbab3e3e369272ea7348936a3914de7cdea424ac9f623dc73e7a8b2ff",
            "metadata": {},
            "name": "cardLayoutSettingsPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8d784409d283c519$var$node.hash = "a7fa209482d066e6ba737c91ffa3c807";
var $8d784409d283c519$export$2e2bcd8739ae039 = $8d784409d283c519$var$node;

});

parcelRegister("8lR27", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('62Ysh')
        ]);
        const value = parcelRequire('5jiE3');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("62Ysh")
    ]).then(()=>parcelRequire('5jiE3'));
}

});

parcelRegister("d6l6w", function(module, exports) {

$parcel$export(module.exports, "default", () => $c12a322d5ff07c8a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<549e1f0a46b2dfa2e529db9c482789e9>>
 * @relayHash 1bd700e083cfed2923539d531d1e0629
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 32bf3498da11d3e13a7038bac090d548c6748a6700b484202a64e0ffef5b23c4
const $c12a322d5ff07c8a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "level"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        },
        {
            "kind": "Literal",
            "name": "isCMP",
            "value": true
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "permissions"
    }, v7 = {
        "kind": "ScalarField",
        "name": "key"
    }, v8 = {
        "kind": "ScalarField",
        "name": "status"
    }, v9 = {
        "kind": "ScalarField",
        "name": "showEpicAsPanel"
    }, v10 = {
        "kind": "ScalarField",
        "name": "isKanPlanColumn"
    }, v11 = {
        "kind": "ScalarField",
        "name": "maxCardCount"
    }, v12 = {
        "kind": "ScalarField",
        "name": "minCardCount"
    }, v13 = {
        "kind": "ScalarField",
        "name": "category"
    }, v14 = {
        "kind": "ScalarField",
        "name": "issueCount"
    }, v15 = {
        "kind": "ScalarField",
        "name": "isPresentInWorkflow"
    }, v16 = {
        "kind": "ScalarField",
        "name": "isResolutionDone"
    }, v17 = {
        "kind": "ScalarField",
        "name": "usingSimplifiedWorkflow"
    }, v18 = {
        "kind": "ScalarField",
        "name": "isProjectAdminOfSimplifiedWorkflow"
    }, v19 = {
        "kind": "ScalarField",
        "name": "canSimplifyWorkflow"
    }, v20 = {
        "kind": "ScalarField",
        "name": "userCanSimplifyWorkflow"
    }, v21 = {
        "kind": "ScalarField",
        "name": "currentId"
    }, v22 = {
        "kind": "ScalarField",
        "name": "avatarURI"
    }, v23 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v24 = {
        "kind": "ScalarField",
        "name": "projectTypeKey"
    }, v25 = {
        "kind": "ScalarField",
        "name": "userLocationId"
    }, v26 = [
        v5 /*: any*/ ,
        v3 /*: any*/ ,
        v13 /*: any*/ ,
        {
            "concreteType": "JswCardStatusIssueMetaData",
            "kind": "LinkedField",
            "name": "issueMetaData",
            "plural": false,
            "selections": [
                v14 /*: any*/ 
            ]
        },
        v15 /*: any*/ ,
        v16 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "columnsSettingsPageQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraIssueHierarchyConfigurationQuery",
                                    "kind": "LinkedField",
                                    "name": "issueHierarchyConfig",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraIssueHierarchyConfigData",
                                                "kind": "LinkedField",
                                                "name": "data",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraIssueTypeHierarchyLevel",
                                                            "kind": "LinkedField",
                                                            "name": "hierarchyLevel",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v2 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira.issueHierarchyConfig.data.hierarchyLevel.level"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v3 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira.issueHierarchyConfig.data.hierarchyLevel.name"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "jira.issueHierarchyConfig.data.hierarchyLevel"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.issueHierarchyConfig.data"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.issueHierarchyConfig"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v4 /*: any*/ ,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v5 /*: any*/ ,
                                "action": "THROW",
                                "path": "boardScope.id"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "CurrentUser",
                                    "kind": "LinkedField",
                                    "name": "currentUser",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v6 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.currentUser.permissions"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.currentUser"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "BoardFeature",
                                    "kind": "LinkedField",
                                    "name": "features",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v7 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.features.key"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v8 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.features.status"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.features"
                            },
                            {
                                "kind": "RequiredField",
                                "field": v9 /*: any*/ ,
                                "action": "THROW",
                                "path": "boardScope.showEpicAsPanel"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "SoftwareBoard",
                                    "kind": "LinkedField",
                                    "name": "board",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "Column",
                                                "kind": "LinkedField",
                                                "name": "columns",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v5 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.columns.id"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v10 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.columns.isKanPlanColumn"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v3 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.columns.name"
                                                    },
                                                    v11 /*: any*/ ,
                                                    v12 /*: any*/ ,
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "ColumnStatus",
                                                            "kind": "LinkedField",
                                                            "name": "columnStatus",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "CardStatus",
                                                                        "kind": "LinkedField",
                                                                        "name": "status",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v5 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.columnStatus.status.id"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v3 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.columnStatus.status.name"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v13 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.columnStatus.status.category"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": {
                                                                                    "concreteType": "JswCardStatusIssueMetaData",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issueMetaData",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "RequiredField",
                                                                                            "field": v14 /*: any*/ ,
                                                                                            "action": "THROW",
                                                                                            "path": "boardScope.board.columns.columnStatus.status.issueMetaData.issueCount"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.columnStatus.status.issueMetaData"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v15 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.columnStatus.status.isPresentInWorkflow"
                                                                            },
                                                                            v16 /*: any*/ 
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.columns.columnStatus.status"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "boardScope.board.columns.columnStatus"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.board.columns"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "CardStatus",
                                                "kind": "LinkedField",
                                                "name": "unmappedStatuses",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v5 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.unmappedStatuses.id"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v3 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.unmappedStatuses.name"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v13 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.unmappedStatuses.category"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JswCardStatusIssueMetaData",
                                                            "kind": "LinkedField",
                                                            "name": "issueMetaData",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v14 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.unmappedStatuses.issueMetaData.issueCount"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "boardScope.board.unmappedStatuses.issueMetaData"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v15 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.unmappedStatuses.isPresentInWorkflow"
                                                    },
                                                    v16 /*: any*/ 
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.board.unmappedStatuses"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "ColumnsConfig",
                                                "kind": "LinkedField",
                                                "name": "columnConfigs",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "ColumnWorkflowConfig",
                                                            "kind": "LinkedField",
                                                            "name": "workflow",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v17 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.columnConfigs.workflow.usingSimplifiedWorkflow"
                                                                },
                                                                v18 /*: any*/ ,
                                                                v19 /*: any*/ ,
                                                                v20 /*: any*/ 
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "boardScope.board.columnConfigs.workflow"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "ColumnConstraintStatisticConfig",
                                                            "kind": "LinkedField",
                                                            "name": "constraintsStatisticsField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v21 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.columnConfigs.constraintsStatisticsField.currentId"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "AvailableColumnConstraintStatistics",
                                                                        "kind": "LinkedField",
                                                                        "name": "availableConstraints",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v5 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columnConfigs.constraintsStatisticsField.availableConstraints.id"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v3 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columnConfigs.constraintsStatisticsField.availableConstraints.name"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.columnConfigs.constraintsStatisticsField.availableConstraints"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "boardScope.board.columnConfigs.constraintsStatisticsField"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.board.columnConfigs"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.board"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "JswBoardLocationModel",
                                    "kind": "LinkedField",
                                    "name": "boardLocationModel",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v22 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.boardLocationModel.avatarURI"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v3 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.boardLocationModel.name"
                                        },
                                        v23 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v25 /*: any*/ 
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.boardLocationModel"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "boardScope"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "columnsSettingsPageQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssueHierarchyConfigurationQuery",
                            "kind": "LinkedField",
                            "name": "issueHierarchyConfig",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueHierarchyConfigData",
                                    "kind": "LinkedField",
                                    "name": "data",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueTypeHierarchyLevel",
                                            "kind": "LinkedField",
                                            "name": "hierarchyLevel",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "concreteType": "CurrentUser",
                            "kind": "LinkedField",
                            "name": "currentUser",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "BoardFeature",
                            "kind": "LinkedField",
                            "name": "features",
                            "plural": true,
                            "selections": [
                                v7 /*: any*/ ,
                                v8 /*: any*/ 
                            ]
                        },
                        v9 /*: any*/ ,
                        {
                            "concreteType": "SoftwareBoard",
                            "kind": "LinkedField",
                            "name": "board",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "Column",
                                    "kind": "LinkedField",
                                    "name": "columns",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        {
                                            "concreteType": "ColumnStatus",
                                            "kind": "LinkedField",
                                            "name": "columnStatus",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "CardStatus",
                                                    "kind": "LinkedField",
                                                    "name": "status",
                                                    "plural": false,
                                                    "selections": v26 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "CardStatus",
                                    "kind": "LinkedField",
                                    "name": "unmappedStatuses",
                                    "plural": true,
                                    "selections": v26 /*: any*/ 
                                },
                                {
                                    "concreteType": "ColumnsConfig",
                                    "kind": "LinkedField",
                                    "name": "columnConfigs",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ColumnWorkflowConfig",
                                            "kind": "LinkedField",
                                            "name": "workflow",
                                            "plural": false,
                                            "selections": [
                                                v17 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                v20 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "ColumnConstraintStatisticConfig",
                                            "kind": "LinkedField",
                                            "name": "constraintsStatisticsField",
                                            "plural": false,
                                            "selections": [
                                                v21 /*: any*/ ,
                                                {
                                                    "concreteType": "AvailableColumnConstraintStatistics",
                                                    "kind": "LinkedField",
                                                    "name": "availableConstraints",
                                                    "plural": true,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v3 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "JswBoardLocationModel",
                            "kind": "LinkedField",
                            "name": "boardLocationModel",
                            "plural": false,
                            "selections": [
                                v22 /*: any*/ ,
                                v3 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "32bf3498da11d3e13a7038bac090d548c6748a6700b484202a64e0ffef5b23c4",
            "metadata": {},
            "name": "columnsSettingsPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c12a322d5ff07c8a$var$node.hash = "a1225b7872720d609f0fdb3ae669ad67";
var $c12a322d5ff07c8a$export$2e2bcd8739ae039 = $c12a322d5ff07c8a$var$node;

});

parcelRegister("dT5Tp", function(module, exports) {






if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("dlJ5e")),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('1QXwG')
        ]);
        const value = parcelRequire('lHVXi');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("dlJ5e")),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("1QXwG")
    ]).then(()=>parcelRequire('lHVXi'));
}

});

parcelRegister("e3kq2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddb006a3a2bcda5c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<805d153f812ce535aec22842874a72b5>>
 * @relayHash 21e7cc18134b2ea082e0d4054b8f4adf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ead03414f4dfad56635e9d6f9d0bc45713fa41cffa7c52f2ab56e8c98a02b3c2
const $ddb006a3a2bcda5c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "isJiraConfiguredTimeTrackingEnabled"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        },
        {
            "kind": "Literal",
            "name": "isCMP",
            "value": true
        }
    ], v4 = {
        "concreteType": "CurrentUser",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "permissions"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "statisticFieldId"
    }, v6 = {
        "concreteType": "AvailableEstimations",
        "kind": "LinkedField",
        "name": "available",
        "plural": true,
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "isEnabled"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "estimationSettingsPageQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraTimeTrackingSettings",
                                    "kind": "LinkedField",
                                    "name": "globalTimeTrackingSettings",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v2 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.globalTimeTrackingSettings.isJiraConfiguredTimeTrackingEnabled"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.globalTimeTrackingSettings"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v3 /*: any*/ ,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            v4 /*: any*/ ,
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "EstimationConfig",
                                    "kind": "LinkedField",
                                    "name": "estimation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "CurrentEstimation",
                                                "kind": "LinkedField",
                                                "name": "current",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v5 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.estimation.current.statisticFieldId"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.estimation.current"
                                        },
                                        v6 /*: any*/ 
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.estimation"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "JswTrackingStatistic",
                                    "kind": "LinkedField",
                                    "name": "trackingStatistic",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v5 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.trackingStatistic.statisticFieldId"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v7 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.trackingStatistic.isEnabled"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.trackingStatistic"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "boardScope"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "estimationSettingsPageQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraTimeTrackingSettings",
                            "kind": "LinkedField",
                            "name": "globalTimeTrackingSettings",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "concreteType": "EstimationConfig",
                            "kind": "LinkedField",
                            "name": "estimation",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CurrentEstimation",
                                    "kind": "LinkedField",
                                    "name": "current",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ 
                                    ]
                                },
                                v6 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "JswTrackingStatistic",
                            "kind": "LinkedField",
                            "name": "trackingStatistic",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v7 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ead03414f4dfad56635e9d6f9d0bc45713fa41cffa7c52f2ab56e8c98a02b3c2",
            "metadata": {},
            "name": "estimationSettingsPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ddb006a3a2bcda5c$var$node.hash = "5e75122ed346f8792c17c8a728c8da36";
var $ddb006a3a2bcda5c$export$2e2bcd8739ae039 = $ddb006a3a2bcda5c$var$node;

});

parcelRegister("049Kc", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('jlbwd')
        ]);
        const value = parcelRequire('iPCNW');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("jlbwd")
    ]).then(()=>parcelRequire('iPCNW'));
}

});

parcelRegister("aaUCg", function(module, exports) {

$parcel$export(module.exports, "default", () => $c292e268952b314c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<746e668827cb8cc1af0d80bfd1d819fc>>
 * @relayHash 330887d1a91a28f008f08fb8707c78e9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e959cd2c577ba3e1b2956c5256ac6adf3a7b437a31b330460ad5280ebb92fa0c
const $c292e268952b314c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "key"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        },
        {
            "kind": "Literal",
            "name": "isCMP",
            "value": true
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "kind": "ScalarField",
        "name": "permissions"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "canEdit"
    }, v8 = {
        "kind": "ScalarField",
        "name": "query"
    }, v9 = {
        "kind": "ScalarField",
        "name": "description"
    }, v10 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v11 = {
        "kind": "ScalarField",
        "name": "avatarUrl"
    }, v12 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v13 = {
        "kind": "ScalarField",
        "name": "type"
    }, v14 = [
        v4 /*: any*/ ,
        v6 /*: any*/ 
    ], v15 = {
        "concreteType": "JswSavedFilterSharePermissionValue",
        "kind": "LinkedField",
        "name": "group",
        "plural": false,
        "selections": v14 /*: any*/ 
    }, v16 = {
        "kind": "ScalarField",
        "name": "isOrderedByRank"
    }, v17 = {
        "kind": "ScalarField",
        "name": "canEditProject"
    }, v18 = {
        "kind": "ScalarField",
        "name": "isProjectsUnboundedInFilter"
    }, v19 = {
        "kind": "ScalarField",
        "name": "isMaxSupportShowingProjectsReached"
    }, v20 = {
        "kind": "ScalarField",
        "name": "projectsCount"
    }, v21 = {
        "kind": "ScalarField",
        "name": "oldDoneIssuesCutoff"
    }, v22 = {
        "kind": "ScalarField",
        "name": "label"
    }, v23 = {
        "kind": "ScalarField",
        "name": "value"
    }, v24 = {
        "kind": "ScalarField",
        "name": "status"
    }, v25 = {
        "kind": "ScalarField",
        "name": "avatarURI"
    }, v26 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v27 = {
        "kind": "ScalarField",
        "name": "projectTypeKey"
    }, v28 = {
        "kind": "ScalarField",
        "name": "userLocationId"
    }, v29 = [
        v13 /*: any*/ ,
        v15 /*: any*/ ,
        {
            "concreteType": "JswSavedFilterSharePermissionProjectValue",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
                v6 /*: any*/ ,
                v4 /*: any*/ ,
                v11 /*: any*/ 
            ]
        },
        {
            "concreteType": "JswSavedFilterSharePermissionValue",
            "kind": "LinkedField",
            "name": "role",
            "plural": false,
            "selections": v14 /*: any*/ 
        },
        {
            "concreteType": "JswSavedFilterSharePermissionUserValue",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                v12 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ 
            ]
        }
    ], v30 = [
        v2 /*: any*/ ,
        v10 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "generalSettingsPageQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "getGlobalPermissionsAndGrants",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "JiraGlobalPermissionGrants",
                                                        "kind": "LinkedField",
                                                        "name": "globalPermissionGrants",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": {
                                                                    "concreteType": "JiraGlobalPermission",
                                                                    "kind": "LinkedField",
                                                                    "name": "permission",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v2 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "jira.getGlobalPermissionsAndGrants.globalPermissionGrants.permission.key"
                                                                        }
                                                                    ]
                                                                },
                                                                "action": "THROW",
                                                                "path": "jira.getGlobalPermissionsAndGrants.globalPermissionGrants.permission"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "jira.getGlobalPermissionsAndGrants.globalPermissionGrants"
                                                }
                                            ],
                                            "type": "JiraGlobalPermissionGrantsList"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.getGlobalPermissionsAndGrants"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v3 /*: any*/ ,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "SoftwareBoard",
                                    "kind": "LinkedField",
                                    "name": "board",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v4 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.board.name"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.board"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "CurrentUser",
                                    "kind": "LinkedField",
                                    "name": "currentUser",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v5 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.currentUser.permissions"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.currentUser"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "JswSavedFilterConfig",
                                    "kind": "LinkedField",
                                    "name": "savedFilterConfig",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v6 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.savedFilterConfig.id"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v7 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.savedFilterConfig.canEdit"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v8 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.savedFilterConfig.query"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v4 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.savedFilterConfig.name"
                                        },
                                        v9 /*: any*/ ,
                                        {
                                            "concreteType": "JswSavedFilterOwner",
                                            "kind": "LinkedField",
                                            "name": "owner",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v10 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.savedFilterConfig.owner.displayName"
                                                },
                                                v11 /*: any*/ ,
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v12 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.savedFilterConfig.owner.accountId"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JswSavedFilterSharePermissionEntry",
                                                "kind": "LinkedField",
                                                "name": "editPermissionEntries",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v13 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.savedFilterConfig.editPermissionEntries.type"
                                                    },
                                                    v15 /*: any*/ ,
                                                    {
                                                        "concreteType": "JswSavedFilterSharePermissionProjectValue",
                                                        "kind": "LinkedField",
                                                        "name": "project",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v6 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.savedFilterConfig.editPermissionEntries.project.id"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v4 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.savedFilterConfig.editPermissionEntries.project.name"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v11 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.savedFilterConfig.editPermissionEntries.project.avatarUrl"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "JswSavedFilterSharePermissionValue",
                                                        "kind": "LinkedField",
                                                        "name": "role",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v4 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.savedFilterConfig.editPermissionEntries.role.name"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v6 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.savedFilterConfig.editPermissionEntries.role.id"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "JswSavedFilterSharePermissionUserValue",
                                                        "kind": "LinkedField",
                                                        "name": "user",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v12 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.savedFilterConfig.editPermissionEntries.user.accountId"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v10 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.savedFilterConfig.editPermissionEntries.user.displayName"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v11 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.savedFilterConfig.editPermissionEntries.user.avatarUrl"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.savedFilterConfig.editPermissionEntries"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JswSavedFilterSharePermissionEntry",
                                                "kind": "LinkedField",
                                                "name": "sharePermissionEntries",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v13 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.savedFilterConfig.sharePermissionEntries.type"
                                                    },
                                                    v15 /*: any*/ ,
                                                    {
                                                        "concreteType": "JswSavedFilterSharePermissionProjectValue",
                                                        "kind": "LinkedField",
                                                        "name": "project",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v6 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.savedFilterConfig.sharePermissionEntries.project.id"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v4 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.savedFilterConfig.sharePermissionEntries.project.name"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v11 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.savedFilterConfig.sharePermissionEntries.project.avatarUrl"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "JswSavedFilterSharePermissionValue",
                                                        "kind": "LinkedField",
                                                        "name": "role",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v4 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.savedFilterConfig.sharePermissionEntries.role.name"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v6 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.savedFilterConfig.sharePermissionEntries.role.id"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "JswSavedFilterSharePermissionUserValue",
                                                        "kind": "LinkedField",
                                                        "name": "user",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v12 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.savedFilterConfig.sharePermissionEntries.user.accountId"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v10 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.savedFilterConfig.sharePermissionEntries.user.displayName"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v11 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.savedFilterConfig.sharePermissionEntries.user.avatarUrl"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.savedFilterConfig.sharePermissionEntries"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v16 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.savedFilterConfig.isOrderedByRank"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JswSavedFilterQueryProjects",
                                                "kind": "LinkedField",
                                                "name": "queryProjects",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JswSavedFilterQueryProjectEntry",
                                                        "kind": "LinkedField",
                                                        "name": "projects",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v6 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.savedFilterConfig.queryProjects.projects.id"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v4 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.savedFilterConfig.queryProjects.projects.name"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v2 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.savedFilterConfig.queryProjects.projects.key"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v17 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.savedFilterConfig.queryProjects.projects.canEditProject"
                                                            }
                                                        ]
                                                    },
                                                    v18 /*: any*/ ,
                                                    v19 /*: any*/ ,
                                                    v20 /*: any*/ 
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.savedFilterConfig.queryProjects"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.savedFilterConfig"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "JswOldDoneIssuesCutOffConfig",
                                    "kind": "LinkedField",
                                    "name": "oldDoneIssuesCutOffConfig",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v21 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.oldDoneIssuesCutOffConfig.oldDoneIssuesCutoff"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JswOldDoneIssuesCutoffOption",
                                                "kind": "LinkedField",
                                                "name": "options",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v22 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.oldDoneIssuesCutOffConfig.options.label"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v23 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.oldDoneIssuesCutOffConfig.options.value"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.oldDoneIssuesCutOffConfig.options"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.oldDoneIssuesCutOffConfig"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "JswBoardAdmins",
                                    "kind": "LinkedField",
                                    "name": "boardAdmins",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JswBoardAdmin",
                                                "kind": "LinkedField",
                                                "name": "userKeys",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v2 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.boardAdmins.userKeys.key"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v10 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.boardAdmins.userKeys.displayName"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.boardAdmins.userKeys"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JswBoardAdmin",
                                                "kind": "LinkedField",
                                                "name": "groupKeys",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v2 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.boardAdmins.groupKeys.key"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v10 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.boardAdmins.groupKeys.displayName"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.boardAdmins.groupKeys"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.boardAdmins"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "BoardFeature",
                                    "kind": "LinkedField",
                                    "name": "features",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v2 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.features.key"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v24 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.features.status"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.features"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "JswSubqueryConfig",
                                    "kind": "LinkedField",
                                    "name": "subqueryConfig",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JswSubqueryEntry",
                                                "kind": "LinkedField",
                                                "name": "subqueries",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v6 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.subqueryConfig.subqueries.id"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v8 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.subqueryConfig.subqueries.query"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.subqueryConfig.subqueries"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.subqueryConfig"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "JswBoardLocationModel",
                                    "kind": "LinkedField",
                                    "name": "boardLocationModel",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v25 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.boardLocationModel.avatarURI"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v4 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.boardLocationModel.name"
                                        },
                                        v26 /*: any*/ ,
                                        v27 /*: any*/ ,
                                        v28 /*: any*/ 
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.boardLocationModel"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "boardScope"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "generalSettingsPageQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "getGlobalPermissionsAndGrants",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "JiraGlobalPermissionGrants",
                                            "kind": "LinkedField",
                                            "name": "globalPermissionGrants",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraGlobalPermission",
                                                    "kind": "LinkedField",
                                                    "name": "permission",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraGlobalPermissionGrantsList"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SoftwareBoard",
                            "kind": "LinkedField",
                            "name": "board",
                            "plural": false,
                            "selections": v14 /*: any*/ 
                        },
                        {
                            "concreteType": "CurrentUser",
                            "kind": "LinkedField",
                            "name": "currentUser",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "JswSavedFilterConfig",
                            "kind": "LinkedField",
                            "name": "savedFilterConfig",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v4 /*: any*/ ,
                                v9 /*: any*/ ,
                                {
                                    "concreteType": "JswSavedFilterOwner",
                                    "kind": "LinkedField",
                                    "name": "owner",
                                    "plural": false,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "JswSavedFilterSharePermissionEntry",
                                    "kind": "LinkedField",
                                    "name": "editPermissionEntries",
                                    "plural": true,
                                    "selections": v29 /*: any*/ 
                                },
                                {
                                    "concreteType": "JswSavedFilterSharePermissionEntry",
                                    "kind": "LinkedField",
                                    "name": "sharePermissionEntries",
                                    "plural": true,
                                    "selections": v29 /*: any*/ 
                                },
                                v16 /*: any*/ ,
                                {
                                    "concreteType": "JswSavedFilterQueryProjects",
                                    "kind": "LinkedField",
                                    "name": "queryProjects",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JswSavedFilterQueryProjectEntry",
                                            "kind": "LinkedField",
                                            "name": "projects",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v2 /*: any*/ ,
                                                v17 /*: any*/ 
                                            ]
                                        },
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "JswOldDoneIssuesCutOffConfig",
                            "kind": "LinkedField",
                            "name": "oldDoneIssuesCutOffConfig",
                            "plural": false,
                            "selections": [
                                v21 /*: any*/ ,
                                {
                                    "concreteType": "JswOldDoneIssuesCutoffOption",
                                    "kind": "LinkedField",
                                    "name": "options",
                                    "plural": true,
                                    "selections": [
                                        v22 /*: any*/ ,
                                        v23 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "JswBoardAdmins",
                            "kind": "LinkedField",
                            "name": "boardAdmins",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JswBoardAdmin",
                                    "kind": "LinkedField",
                                    "name": "userKeys",
                                    "plural": true,
                                    "selections": v30 /*: any*/ 
                                },
                                {
                                    "concreteType": "JswBoardAdmin",
                                    "kind": "LinkedField",
                                    "name": "groupKeys",
                                    "plural": true,
                                    "selections": v30 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "concreteType": "BoardFeature",
                            "kind": "LinkedField",
                            "name": "features",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v24 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "JswSubqueryConfig",
                            "kind": "LinkedField",
                            "name": "subqueryConfig",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JswSubqueryEntry",
                                    "kind": "LinkedField",
                                    "name": "subqueries",
                                    "plural": true,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "JswBoardLocationModel",
                            "kind": "LinkedField",
                            "name": "boardLocationModel",
                            "plural": false,
                            "selections": [
                                v25 /*: any*/ ,
                                v4 /*: any*/ ,
                                v26 /*: any*/ ,
                                v27 /*: any*/ ,
                                v28 /*: any*/ 
                            ]
                        },
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "e959cd2c577ba3e1b2956c5256ac6adf3a7b437a31b330460ad5280ebb92fa0c",
            "metadata": {},
            "name": "generalSettingsPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c292e268952b314c$var$node.hash = "ff5b989765c72ded76cdce38415273ba";
var $c292e268952b314c$export$2e2bcd8739ae039 = $c292e268952b314c$var$node;

});

parcelRegister("1tNLY", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('6AB4j')
        ]);
        const value = parcelRequire('eIBzQ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("6AB4j")
    ]).then(()=>parcelRequire('eIBzQ'));
}

});

parcelRegister("hsUE5", function(module, exports) {

$parcel$export(module.exports, "default", () => $628abed7ecc6ee89$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<11418aed40268df6a178f2eb1ac3ed9c>>
 * @relayHash da636d53dfab36377f32f6566e2d1fcd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 225ecf28165b03c12f0a9df2da762878464f4e900d5ad2b50a868275aa357175
const $628abed7ecc6ee89$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isCMP"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        },
        {
            "kind": "Variable",
            "name": "isCMP",
            "variableName": "isCMP"
        }
    ], v2 = {
        "concreteType": "CurrentUser",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "permissions"
            }
        ]
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "concreteType": "CustomFilter",
        "kind": "LinkedField",
        "name": "customFilters",
        "plural": true,
        "selections": [
            v3 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "concreteType": "FilterQuery",
                "kind": "LinkedField",
                "name": "filterQuery",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "sanitisedJql"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "description"
            }
        ]
    }, v5 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "quickFilters_Spa_Query",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "quickFilters_Spa_Query",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v4 /*: any*/ ,
                        v3 /*: any*/ ,
                        v5 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "225ecf28165b03c12f0a9df2da762878464f4e900d5ad2b50a868275aa357175",
            "metadata": {},
            "name": "quickFilters_Spa_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$628abed7ecc6ee89$var$node.hash = "7f04ccfd7774bcd93acab4ef8eb3c927";
var $628abed7ecc6ee89$export$2e2bcd8739ae039 = $628abed7ecc6ee89$var$node;

});

parcelRegister("epkFs", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('e2Plq')
        ]);
        const value = parcelRequire('9fl4N');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("e2Plq")
    ]).then(()=>parcelRequire('9fl4N'));
}

});

parcelRegister("evb1S", function(module, exports) {

$parcel$export(module.exports, "default", () => $75c48436fd182072$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fb9a9c2e5831f29a3067cd258c2a86ec>>
 * @relayHash d4612deeee8027f3d08b69df2f02c901
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a05648719b45f795c4bc2d1fa9e62ffd0055d29250116e9c2e9bd29d349e4066
const $75c48436fd182072$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "level"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        },
        {
            "kind": "Literal",
            "name": "isCMP",
            "value": true
        }
    ], v5 = {
        "concreteType": "CurrentUser",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "permissions"
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "boardSwimlaneStrategy"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "description"
    }, v9 = {
        "kind": "ScalarField",
        "name": "isDefault"
    }, v10 = {
        "kind": "ScalarField",
        "name": "query"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "swimlanesSettingsPageQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraIssueHierarchyConfigurationQuery",
                                    "kind": "LinkedField",
                                    "name": "issueHierarchyConfig",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraIssueHierarchyConfigData",
                                                "kind": "LinkedField",
                                                "name": "data",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraIssueTypeHierarchyLevel",
                                                            "kind": "LinkedField",
                                                            "name": "hierarchyLevel",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v2 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira.issueHierarchyConfig.data.hierarchyLevel.level"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v3 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira.issueHierarchyConfig.data.hierarchyLevel.name"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "jira.issueHierarchyConfig.data.hierarchyLevel"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.issueHierarchyConfig.data"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.issueHierarchyConfig"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v4 /*: any*/ ,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            v5 /*: any*/ ,
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "SoftwareBoard",
                                    "kind": "LinkedField",
                                    "name": "board",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v6 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.board.boardSwimlaneStrategy"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JswCustomSwimlaneConnection",
                                                "kind": "LinkedField",
                                                "name": "customSwimlaneConfig",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JswCustomSwimlaneEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "JswCustomSwimlane",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v7 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.customSwimlaneConfig.edges.node.id"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v3 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.customSwimlaneConfig.edges.node.name"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v8 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.customSwimlaneConfig.edges.node.description"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v9 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.customSwimlaneConfig.edges.node.isDefault"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v10 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.customSwimlaneConfig.edges.node.query"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.customSwimlaneConfig.edges.node"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "boardScope.board.customSwimlaneConfig.edges"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.board.customSwimlaneConfig"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.board"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "boardScope"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "swimlanesSettingsPageQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssueHierarchyConfigurationQuery",
                            "kind": "LinkedField",
                            "name": "issueHierarchyConfig",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueHierarchyConfigData",
                                    "kind": "LinkedField",
                                    "name": "data",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueTypeHierarchyLevel",
                                            "kind": "LinkedField",
                                            "name": "hierarchyLevel",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "concreteType": "SoftwareBoard",
                            "kind": "LinkedField",
                            "name": "board",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "JswCustomSwimlaneConnection",
                                    "kind": "LinkedField",
                                    "name": "customSwimlaneConfig",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JswCustomSwimlaneEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JswCustomSwimlane",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v7 /*: any*/ 
                            ]
                        },
                        v7 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "a05648719b45f795c4bc2d1fa9e62ffd0055d29250116e9c2e9bd29d349e4066",
            "metadata": {},
            "name": "swimlanesSettingsPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$75c48436fd182072$var$node.hash = "ce2e7dadaeddbee5fdbeabe2bf6be528";
var $75c48436fd182072$export$2e2bcd8739ae039 = $75c48436fd182072$var$node;

});

parcelRegister("9vxg7", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('ilDnJ')
        ]);
        const value = parcelRequire('AOOpl');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("ilDnJ")
    ]).then(()=>parcelRequire('AOOpl'));
}

});

parcelRegister("c6GI1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0082eaa19cb2290$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<467546bfa0fef36340787865e6452ec9>>
 * @relayHash 246bee51270797b0a373bc67a4d2a833
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d9dbc29bacdaf73fdba54ab77f64c6743dd54fcff5d37dfee039b4545ced1e9b
const $e0082eaa19cb2290$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        },
        {
            "kind": "Literal",
            "name": "isCMP",
            "value": true
        }
    ], v2 = {
        "concreteType": "CurrentUser",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "permissions"
            }
        ]
    }, v3 = {
        "kind": "ScalarField",
        "name": "key"
    }, v4 = {
        "kind": "ScalarField",
        "name": "status"
    }, v5 = {
        "kind": "ScalarField",
        "name": "isCrossProject"
    }, v6 = {
        "kind": "ScalarField",
        "name": "isRoadmapEnabled"
    }, v7 = {
        "kind": "ScalarField",
        "name": "isChildIssuePlanningEnabled"
    }, v8 = {
        "kind": "ScalarField",
        "name": "prefersChildIssueDatePlanning"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "timelineSettingsPageQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            v2 /*: any*/ ,
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "BoardFeature",
                                    "kind": "LinkedField",
                                    "name": "features",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v3 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.features.key"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v4 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.features.status"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.features"
                            },
                            {
                                "kind": "RequiredField",
                                "field": v5 /*: any*/ ,
                                "action": "THROW",
                                "path": "boardScope.isCrossProject"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "JswBoardScopeRoadmapConfig",
                                    "kind": "LinkedField",
                                    "name": "roadmapConfig",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v6 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.roadmapConfig.isRoadmapEnabled"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v7 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.roadmapConfig.isChildIssuePlanningEnabled"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v8 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.roadmapConfig.prefersChildIssueDatePlanning"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.roadmapConfig"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "JswBoardLocationModel",
                                    "kind": "LinkedField",
                                    "name": "boardLocationModel",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v9 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.boardLocationModel.name"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.boardLocationModel"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "JswSavedFilterConfig",
                                    "kind": "LinkedField",
                                    "name": "savedFilterConfig",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v10 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.savedFilterConfig.id"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.savedFilterConfig"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "boardScope"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "timelineSettingsPageQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "BoardFeature",
                            "kind": "LinkedField",
                            "name": "features",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ 
                            ]
                        },
                        v5 /*: any*/ ,
                        {
                            "concreteType": "JswBoardScopeRoadmapConfig",
                            "kind": "LinkedField",
                            "name": "roadmapConfig",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "JswBoardLocationModel",
                            "kind": "LinkedField",
                            "name": "boardLocationModel",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "JswSavedFilterConfig",
                            "kind": "LinkedField",
                            "name": "savedFilterConfig",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ 
                            ]
                        },
                        v10 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "d9dbc29bacdaf73fdba54ab77f64c6743dd54fcff5d37dfee039b4545ced1e9b",
            "metadata": {},
            "name": "timelineSettingsPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e0082eaa19cb2290$var$node.hash = "ac9d889671ab2fe077cae5a734759f47";
var $e0082eaa19cb2290$export$2e2bcd8739ae039 = $e0082eaa19cb2290$var$node;

});

parcelRegister("ebWbd", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('3u1dj')
        ]);
        const value = parcelRequire('81pzj');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("3u1dj")
    ]).then(()=>parcelRequire('81pzj'));
}

});

parcelRegister("dIfyy", function(module, exports) {

$parcel$export(module.exports, "default", () => $58609e01b7ef8f3b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7281c4a5014f727f790af6f68bb85107>>
 * @relayHash 84a983abcd553c93e68d1ffd91ddc4cf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4f6e258bd486bfbba34de66af25424837bbc200a316a2a9134c9ba8cc10b7c51
const $58609e01b7ef8f3b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        },
        {
            "kind": "Literal",
            "name": "isCMP",
            "value": true
        }
    ], v2 = {
        "concreteType": "CurrentUser",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "permissions"
            }
        ]
    }, v3 = {
        "kind": "ScalarField",
        "name": "monday"
    }, v4 = {
        "kind": "ScalarField",
        "name": "tuesday"
    }, v5 = {
        "kind": "ScalarField",
        "name": "wednesday"
    }, v6 = {
        "kind": "ScalarField",
        "name": "thursday"
    }, v7 = {
        "kind": "ScalarField",
        "name": "friday"
    }, v8 = {
        "kind": "ScalarField",
        "name": "saturday"
    }, v9 = {
        "kind": "ScalarField",
        "name": "sunday"
    }, v10 = {
        "kind": "ScalarField",
        "name": "date"
    }, v11 = {
        "kind": "ScalarField",
        "name": "currentTimeZoneId"
    }, v12 = {
        "kind": "ScalarField",
        "name": "id"
    }, v13 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v14 = {
        "kind": "ScalarField",
        "name": "gmtOffset"
    }, v15 = {
        "kind": "ScalarField",
        "name": "city"
    }, v16 = {
        "kind": "ScalarField",
        "name": "regionKey"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "workingDaysSettingsPageQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "JswWorkingDaysConfig",
                                "kind": "LinkedField",
                                "name": "workingDaysConfig",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "JswWeekDaysConfig",
                                            "kind": "LinkedField",
                                            "name": "weekDays",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v3 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.workingDaysConfig.weekDays.monday"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v4 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.workingDaysConfig.weekDays.tuesday"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v5 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.workingDaysConfig.weekDays.wednesday"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v6 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.workingDaysConfig.weekDays.thursday"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v7 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.workingDaysConfig.weekDays.friday"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v8 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.workingDaysConfig.weekDays.saturday"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v9 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.workingDaysConfig.weekDays.sunday"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "boardScope.workingDaysConfig.weekDays"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "JswNonWorkingDayConfig",
                                            "kind": "LinkedField",
                                            "name": "nonWorkingDays",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v10 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.workingDaysConfig.nonWorkingDays.date"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "boardScope.workingDaysConfig.nonWorkingDays"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "JswTimeZoneEditModel",
                                            "kind": "LinkedField",
                                            "name": "timeZoneEditModel",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v11 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.workingDaysConfig.timeZoneEditModel.currentTimeZoneId"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "JswRegionConnection",
                                                        "kind": "LinkedField",
                                                        "name": "regions",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": {
                                                                    "concreteType": "JswRegionEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": {
                                                                                "concreteType": "JswRegion",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v12 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "boardScope.workingDaysConfig.timeZoneEditModel.regions.edges.node.id"
                                                                                    },
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v13 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "boardScope.workingDaysConfig.timeZoneEditModel.regions.edges.node.displayName"
                                                                                    }
                                                                                ]
                                                                            },
                                                                            "action": "THROW",
                                                                            "path": "boardScope.workingDaysConfig.timeZoneEditModel.regions.edges.node"
                                                                        }
                                                                    ]
                                                                },
                                                                "action": "THROW",
                                                                "path": "boardScope.workingDaysConfig.timeZoneEditModel.regions.edges"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "boardScope.workingDaysConfig.timeZoneEditModel.regions"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "JswTimeZoneConnection",
                                                        "kind": "LinkedField",
                                                        "name": "timeZones",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": {
                                                                    "concreteType": "JswTimeZoneEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": {
                                                                                "concreteType": "JswTimeZone",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v12 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "boardScope.workingDaysConfig.timeZoneEditModel.timeZones.edges.node.id"
                                                                                    },
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v13 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "boardScope.workingDaysConfig.timeZoneEditModel.timeZones.edges.node.displayName"
                                                                                    },
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v14 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "boardScope.workingDaysConfig.timeZoneEditModel.timeZones.edges.node.gmtOffset"
                                                                                    },
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v15 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "boardScope.workingDaysConfig.timeZoneEditModel.timeZones.edges.node.city"
                                                                                    },
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v16 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "boardScope.workingDaysConfig.timeZoneEditModel.timeZones.edges.node.regionKey"
                                                                                    }
                                                                                ]
                                                                            },
                                                                            "action": "THROW",
                                                                            "path": "boardScope.workingDaysConfig.timeZoneEditModel.timeZones.edges.node"
                                                                        }
                                                                    ]
                                                                },
                                                                "action": "THROW",
                                                                "path": "boardScope.workingDaysConfig.timeZoneEditModel.timeZones.edges"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "boardScope.workingDaysConfig.timeZoneEditModel.timeZones"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "boardScope.workingDaysConfig.timeZoneEditModel"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "boardScope.workingDaysConfig"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "workingDaysSettingsPageQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "JswWorkingDaysConfig",
                            "kind": "LinkedField",
                            "name": "workingDaysConfig",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JswWeekDaysConfig",
                                    "kind": "LinkedField",
                                    "name": "weekDays",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "JswNonWorkingDayConfig",
                                    "kind": "LinkedField",
                                    "name": "nonWorkingDays",
                                    "plural": true,
                                    "selections": [
                                        v10 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "JswTimeZoneEditModel",
                                    "kind": "LinkedField",
                                    "name": "timeZoneEditModel",
                                    "plural": false,
                                    "selections": [
                                        v11 /*: any*/ ,
                                        {
                                            "concreteType": "JswRegionConnection",
                                            "kind": "LinkedField",
                                            "name": "regions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JswRegionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JswRegion",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v12 /*: any*/ ,
                                                                v13 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JswTimeZoneConnection",
                                            "kind": "LinkedField",
                                            "name": "timeZones",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JswTimeZoneEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JswTimeZone",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v12 /*: any*/ ,
                                                                v13 /*: any*/ ,
                                                                v14 /*: any*/ ,
                                                                v15 /*: any*/ ,
                                                                v16 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v12 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "4f6e258bd486bfbba34de66af25424837bbc200a316a2a9134c9ba8cc10b7c51",
            "metadata": {},
            "name": "workingDaysSettingsPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$58609e01b7ef8f3b$var$node.hash = "979e14cda50c569eede46af5ada044eb";
var $58609e01b7ef8f3b$export$2e2bcd8739ae039 = $58609e01b7ef8f3b$var$node;

});

parcelRegister("eLoQ8", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('1tYUZ')
        ]);
        const value = parcelRequire('l8Z2r');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("1tYUZ")
    ]).then(()=>parcelRequire('l8Z2r'));
}

});

parcelRegister("cPcEF", function(module, exports) {






if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("lpjx9")),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('5zl0P')
        ]);
        const value = parcelRequire('khBdF');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("lpjx9")),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("5zl0P")
    ]).then(()=>parcelRequire('khBdF'));
}

});

parcelRegister("1F5sC", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('fZnjh')
        ]);
        const value = parcelRequire('ezFY9');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("fZnjh")
    ]).then(()=>parcelRequire('ezFY9'));
}

});

parcelRegister("4DUTj", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('44rJT')
        ]);
        const value = parcelRequire('aXtv3');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("44rJT")
    ]).then(()=>parcelRequire('aXtv3'));
}

});

parcelRegister("6jZVr", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('5CHNc');
        const value = parcelRequire('lJSys');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("5CHNc").then(()=>parcelRequire('lJSys'));
}

});

parcelRegister("k4wVH", function(module, exports) {

$parcel$export(module.exports, "issueHierarchyPageResource", () => $0ca359a96c43522b$export$98d50a2e19509817);
$parcel$export(module.exports, "transformIssueHierarchyResponse", () => $0ca359a96c43522b$export$e46e78e646760d43);
$parcel$export(module.exports, "pageLoadMetrics", () => $0ca359a96c43522b$export$2878bf482e539059);
$parcel$export(module.exports, "useRelaxedInterval", () => $0ca359a96c43522b$export$6957e3d10d5b6fa8);

var $eUqFw = parcelRequire("eUqFw");

var $iVIEg = parcelRequire("iVIEg");

var $98pzY = parcelRequire("98pzY");

var $fFT4s = parcelRequire("fFT4s");

var $2L86F = parcelRequire("2L86F");

var $lNfG4 = parcelRequire("lNfG4");

var $buJlM = parcelRequire("buJlM");

var $6ovLb = parcelRequire("6ovLb");

var $7fZ6q = parcelRequire("7fZ6q");
const $0ca359a96c43522b$export$98d50a2e19509817 = (0, $buJlM.createRelayResource)({
    type: 'RESOURCE1',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $6ovLb.default),
            variables: {
                cloudId: tenantContext.cloudId
            }
        })
});
// Defaults for issue type
const $0ca359a96c43522b$var$DEFAULT_ISSUE_TYPE = {
    description: '',
    type: '',
    iconUrl: '',
    relatedSchemes: []
};
const $0ca359a96c43522b$var$transformUpdateTaskStatus = (issueHierarchyResponse)=>{
    const taskProgress = issueHierarchyResponse.jira?.issueHierarchyConfigUpdateTask?.taskProgress;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($98pzY)))(taskProgress) || (0, (/*@__PURE__*/$parcel$interopDefault($fFT4s)))(taskProgress)) return (0, $7fZ6q.UPDATE_HIERARCHY_TASK_STATUS).NULL;
    switch(taskProgress.status){
        case (0, $7fZ6q.JIRA_LONG_RUNNING_TASK_STATUS).COMPLETE:
            return (0, $7fZ6q.UPDATE_HIERARCHY_TASK_STATUS).COMPLETED;
        case (0, $7fZ6q.JIRA_LONG_RUNNING_TASK_STATUS).FAILED:
        case (0, $7fZ6q.JIRA_LONG_RUNNING_TASK_STATUS).DEAD:
            return (0, $7fZ6q.UPDATE_HIERARCHY_TASK_STATUS).FAILED;
        case (0, $7fZ6q.JIRA_LONG_RUNNING_TASK_STATUS).ENQUEUED:
        case (0, $7fZ6q.JIRA_LONG_RUNNING_TASK_STATUS).RUNNING:
        case (0, $7fZ6q.JIRA_LONG_RUNNING_TASK_STATUS).CANCEL_REQUESTED:
            return (0, $7fZ6q.UPDATE_HIERARCHY_TASK_STATUS).RUNNING;
        default:
            throw new Error(`No supported task status for IPA removal  ${taskProgress.status}`);
    }
};
const $0ca359a96c43522b$export$e46e78e646760d43 = (issueHierarchyResponse)=>{
    const { jira: jira } = issueHierarchyResponse;
    const updateHierarchyTaskStatus = $0ca359a96c43522b$var$transformUpdateTaskStatus(issueHierarchyResponse);
    const issueHierarchyLimitsData = jira?.issueHierarchyLimits;
    const lockedIssueTypeIds = jira?.lockedIssueTypeIds || [];
    const useDataFromUpdateTask = updateHierarchyTaskStatus !== (0, $7fZ6q.UPDATE_HIERARCHY_TASK_STATUS).NULL && updateHierarchyTaskStatus !== (0, $7fZ6q.UPDATE_HIERARCHY_TASK_STATUS).COMPLETED;
    const issueHierarchyConfigData = (useDataFromUpdateTask ? issueHierarchyResponse.jira?.issueHierarchyConfigUpdateTask?.issueHierarchyConfig : jira?.issueHierarchyConfig?.data) || [];
    if (!issueHierarchyLimitsData) throw new Error('Issue hierarchy response is invalid');
    const { nameLength: nameLength, maxLevels: maxLevels } = issueHierarchyLimitsData;
    return {
        // @ts-expect-error - TS2322 - Type '({ level: number; name: string; issueTypes: ({ description: ""; type: ""; iconUrl: ""; relatedSchemes: readonly []; } | null)[]; } | null)[]' is not assignable to type 'IssueHierarchyConfig'.
        issueHierarchyConfig: issueHierarchyConfigData.map((level)=>{
            // Makes no sense to continue if there is no level
            if (level.hierarchyLevel?.level == null || level.hierarchyLevel?.name == null) return null;
            const levelNumber = level.hierarchyLevel.level;
            const levelName = level.hierarchyLevel.name;
            const issueTypes = level.cmpIssueTypes?.edges?.map((issueTypeNode)=>{
                const hasId = issueTypeNode?.node?.id != null;
                // If the issue type doesn't have an id we can't continue
                if (issueTypeNode?.node?.issueTypeId == null || !hasId) return null;
                const { name: name, avatar: avatar, issueTypeId: issueTypeId, description: description } = issueTypeNode.node;
                const issueType = {
                    id: issueTypeId,
                    name: name,
                    hierarchyLevel: levelNumber,
                    iconUrl: avatar?.small,
                    type: issueTypeId,
                    description: description
                };
                return {
                    ...$0ca359a96c43522b$var$DEFAULT_ISSUE_TYPE,
                    ...(0, (/*@__PURE__*/$parcel$interopDefault($2L86F)))((0, (/*@__PURE__*/$parcel$interopDefault($98pzY))), issueType)
                };
            }).filter(Boolean);
            // We want empty array for ignored levels or if issueTypes is null (invalid data from gql)
            const maybeIssueTypeLevel = (0, $7fZ6q.HIERARCHY_LEVELS_TO_IGNORE_ISSUE_TYPES).includes(levelNumber) || !issueTypes ? [] : issueTypes;
            return {
                level: levelNumber,
                name: levelName,
                issueTypes: maybeIssueTypeLevel
            };
        }).filter(Boolean),
        issueHierarchyLimits: {
            nameLength: nameLength,
            maxLevels: maxLevels
        },
        lockedIssueTypeIds: lockedIssueTypeIds,
        updateHierarchyTaskStatus: updateHierarchyTaskStatus
    };
};
const $0ca359a96c43522b$export$2878bf482e539059 = (0, $lNfG4.metrics).pageLoad({
    key: (0, $7fZ6q.METRICS_PAGE_ID),
    ssr: {
        doneAsFmp: true
    }
});
const $0ca359a96c43522b$export$eca0c51555076f68 = (prevConfig, newConfig)=>prevConfig.some(({ level: level, issueTypes: issueTypes })=>{
        if (!issueTypes || issueTypes.length === 0) return false;
        // if a level from the prev hierarchy config doesn't exist in current hierarchy config
        const levelInNewConfig = newConfig && newConfig.find((newLevelData)=>newLevelData.level === level);
        if (!levelInNewConfig) return true;
        // or an issueType has been removed from a hierarchy level
        // (this can be explicit via issueType removal, or implicit via level re-ordering)
        const currentIssueTypeIdsForLevel = issueTypes.map(({ id: id })=>id);
        const issueTypeRemoved = (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(currentIssueTypeIdsForLevel, levelInNewConfig.issueTypes || []);
        if (issueTypeRemoved.length > 0) return true;
        // or an issueType has been added to a hierarchy level
        // (all issues are story-level (0) by default, so adding them to any level above 0 could break parent associations)
        const issueTypeAdded = (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(levelInNewConfig.issueTypes || [], currentIssueTypeIdsForLevel);
        if (issueTypeAdded.length > 0) return true;
        return false;
    });
function $0ca359a96c43522b$export$6957e3d10d5b6fa8(callback, delay) {
    const savedCallback = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, $eUqFw.useEffect)(()=>{
        let running = false;
        let savedTimeout = null;
        const tick = async ()=>{
            if (running && !(0, (/*@__PURE__*/$parcel$interopDefault($fFT4s)))(savedCallback.current)) await savedCallback.current();
            if (running && !(0, (/*@__PURE__*/$parcel$interopDefault($98pzY)))(delay)) savedTimeout = setTimeout(tick, delay);
        };
        const stop = ()=>{
            running = false;
            const timeout = savedTimeout;
            if (timeout !== null) clearTimeout(timeout);
        };
        if (delay !== null) {
            running = true;
            savedTimeout = setTimeout(tick, delay);
            return stop;
        }
    }, [
        delay
    ]);
}

});
parcelRegister("iVIEg", function(module, exports) {

var $fa0Ox = parcelRequire("fa0Ox");

var $hKE3p = parcelRequire("hKE3p");

var $9eFtX = parcelRequire("9eFtX");

var $cRpul = parcelRequire("cRpul");
/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */ var $dc802f203e524f15$var$difference = $9eFtX(function(array, values) {
    return $cRpul(array) ? $fa0Ox(array, $hKE3p(values, 1, $cRpul, true)) : [];
});
module.exports = $dc802f203e524f15$var$difference;

});
parcelRegister("fa0Ox", function(module, exports) {

var $lYFvJ = parcelRequire("lYFvJ");

var $lqZWH = parcelRequire("lqZWH");

var $6v6uu = parcelRequire("6v6uu");

var $kJvGp = parcelRequire("kJvGp");

var $74vSq = parcelRequire("74vSq");

var $8AO5Q = parcelRequire("8AO5Q");
/** Used as the size to enable large array optimizations. */ var $b0986bd506ee8a3d$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function $b0986bd506ee8a3d$var$baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = $lqZWH, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = $kJvGp(values, $74vSq(iteratee));
    if (comparator) {
        includes = $6v6uu;
        isCommon = false;
    } else if (values.length >= $b0986bd506ee8a3d$var$LARGE_ARRAY_SIZE) {
        includes = $8AO5Q;
        isCommon = false;
        values = new $lYFvJ(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
module.exports = $b0986bd506ee8a3d$var$baseDifference;

});


parcelRegister("98pzY", function(module, exports) {

var $jFIrw = parcelRequire("jFIrw");


var $6a68b3eba685cca2$var$func = $jFIrw('isNull', (parcelRequire("f222W")), (parcelRequire("jKGa6")));

$6a68b3eba685cca2$var$func.placeholder = (parcelRequire("l6Yg9"));
module.exports = $6a68b3eba685cca2$var$func;

});
parcelRegister("jFIrw", function(module, exports) {

var $imppR = parcelRequire("imppR");

var $a02m0 = parcelRequire("a02m0");
/**
 * Converts `func` of `name` to an immutable auto-curried iteratee-first data-last
 * version with conversion `options` applied. If `name` is an object its methods
 * will be converted.
 *
 * @param {string} name The name of the function to wrap.
 * @param {Function} [func] The function to wrap.
 * @param {Object} [options] The options object. See `baseConvert` for more details.
 * @returns {Function|Object} Returns the converted function or object.
 */ function $e524521dc9be9d0c$var$convert(name, func, options) {
    return $imppR($a02m0, name, func, options);
}
module.exports = $e524521dc9be9d0c$var$convert;

});
parcelRegister("imppR", function(module, exports) {

var $89eBv = parcelRequire("89eBv");

var $l6Yg9 = parcelRequire("l6Yg9");
/** Built-in value reference. */ var $d5ddff315914c7cb$var$push = Array.prototype.push;
/**
 * Creates a function, with an arity of `n`, that invokes `func` with the
 * arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} n The arity of the new function.
 * @returns {Function} Returns the new function.
 */ function $d5ddff315914c7cb$var$baseArity(func, n) {
    return n == 2 ? function(a, b) {
        return func.apply(undefined, arguments);
    } : function(a) {
        return func.apply(undefined, arguments);
    };
}
/**
 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
 * any additional arguments.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @param {number} n The arity cap.
 * @returns {Function} Returns the new function.
 */ function $d5ddff315914c7cb$var$baseAry(func, n) {
    return n == 2 ? function(a, b) {
        return func(a, b);
    } : function(a) {
        return func(a);
    };
}
/**
 * Creates a clone of `array`.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the cloned array.
 */ function $d5ddff315914c7cb$var$cloneArray(array) {
    var length = array ? array.length : 0, result = Array(length);
    while(length--)result[length] = array[length];
    return result;
}
/**
 * Creates a function that clones a given object using the assignment `func`.
 *
 * @private
 * @param {Function} func The assignment function.
 * @returns {Function} Returns the new cloner function.
 */ function $d5ddff315914c7cb$var$createCloner(func) {
    return function(object) {
        return func({}, object);
    };
}
/**
 * A specialized version of `_.spread` which flattens the spread array into
 * the arguments of the invoked `func`.
 *
 * @private
 * @param {Function} func The function to spread arguments over.
 * @param {number} start The start position of the spread.
 * @returns {Function} Returns the new function.
 */ function $d5ddff315914c7cb$var$flatSpread(func, start) {
    return function() {
        var length = arguments.length, lastIndex = length - 1, args = Array(length);
        while(length--)args[length] = arguments[length];
        var array = args[start], otherArgs = args.slice(0, start);
        if (array) $d5ddff315914c7cb$var$push.apply(otherArgs, array);
        if (start != lastIndex) $d5ddff315914c7cb$var$push.apply(otherArgs, args.slice(start + 1));
        return func.apply(this, otherArgs);
    };
}
/**
 * Creates a function that wraps `func` and uses `cloner` to clone the first
 * argument it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} cloner The function to clone arguments.
 * @returns {Function} Returns the new immutable function.
 */ function $d5ddff315914c7cb$var$wrapImmutable(func, cloner) {
    return function() {
        var length = arguments.length;
        if (!length) return;
        var args = Array(length);
        while(length--)args[length] = arguments[length];
        var result = args[0] = cloner.apply(undefined, args);
        func.apply(undefined, args);
        return result;
    };
}
/**
 * The base implementation of `convert` which accepts a `util` object of methods
 * required to perform conversions.
 *
 * @param {Object} util The util object.
 * @param {string} name The name of the function to convert.
 * @param {Function} func The function to convert.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
 * @param {boolean} [options.curry=true] Specify currying.
 * @param {boolean} [options.fixed=true] Specify fixed arity.
 * @param {boolean} [options.immutable=true] Specify immutable operations.
 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
 * @returns {Function|Object} Returns the converted function or object.
 */ function $d5ddff315914c7cb$var$baseConvert(util, name, func, options) {
    var isLib = typeof name == 'function', isObj = name === Object(name);
    if (isObj) {
        options = func;
        func = name;
        name = undefined;
    }
    if (func == null) throw new TypeError;
    options || (options = {});
    var config = {
        'cap': 'cap' in options ? options.cap : true,
        'curry': 'curry' in options ? options.curry : true,
        'fixed': 'fixed' in options ? options.fixed : true,
        'immutable': 'immutable' in options ? options.immutable : true,
        'rearg': 'rearg' in options ? options.rearg : true
    };
    var defaultHolder = isLib ? func : $l6Yg9, forceCurry = 'curry' in options && options.curry, forceFixed = 'fixed' in options && options.fixed, forceRearg = 'rearg' in options && options.rearg, pristine = isLib ? func.runInContext() : undefined;
    var helpers = isLib ? func : {
        'ary': util.ary,
        'assign': util.assign,
        'clone': util.clone,
        'curry': util.curry,
        'forEach': util.forEach,
        'isArray': util.isArray,
        'isError': util.isError,
        'isFunction': util.isFunction,
        'isWeakMap': util.isWeakMap,
        'iteratee': util.iteratee,
        'keys': util.keys,
        'rearg': util.rearg,
        'toInteger': util.toInteger,
        'toPath': util.toPath
    };
    var ary = helpers.ary, assign = helpers.assign, clone = helpers.clone, curry = helpers.curry, each = helpers.forEach, isArray = helpers.isArray, isError = helpers.isError, isFunction = helpers.isFunction, isWeakMap = helpers.isWeakMap, keys = helpers.keys, rearg = helpers.rearg, toInteger = helpers.toInteger, toPath = helpers.toPath;
    var aryMethodKeys = keys($89eBv.aryMethod);
    var wrappers = {
        'castArray': function(castArray) {
            return function() {
                var value = arguments[0];
                return isArray(value) ? castArray($d5ddff315914c7cb$var$cloneArray(value)) : castArray.apply(undefined, arguments);
            };
        },
        'iteratee': function(iteratee) {
            return function() {
                var func = arguments[0], arity = arguments[1], result = iteratee(func, arity), length = result.length;
                if (config.cap && typeof arity == 'number') {
                    arity = arity > 2 ? arity - 2 : 1;
                    return length && length <= arity ? result : $d5ddff315914c7cb$var$baseAry(result, arity);
                }
                return result;
            };
        },
        'mixin': function(mixin) {
            return function(source) {
                var func = this;
                if (!isFunction(func)) return mixin(func, Object(source));
                var pairs = [];
                each(keys(source), function(key) {
                    if (isFunction(source[key])) pairs.push([
                        key,
                        func.prototype[key]
                    ]);
                });
                mixin(func, Object(source));
                each(pairs, function(pair) {
                    var value = pair[1];
                    if (isFunction(value)) func.prototype[pair[0]] = value;
                    else delete func.prototype[pair[0]];
                });
                return func;
            };
        },
        'nthArg': function(nthArg) {
            return function(n) {
                var arity = n < 0 ? 1 : toInteger(n) + 1;
                return curry(nthArg(n), arity);
            };
        },
        'rearg': function(rearg) {
            return function(func, indexes) {
                var arity = indexes ? indexes.length : 0;
                return curry(rearg(func, indexes), arity);
            };
        },
        'runInContext': function(runInContext) {
            return function(context) {
                return $d5ddff315914c7cb$var$baseConvert(util, runInContext(context), options);
            };
        }
    };
    /*--------------------------------------------------------------------------*/ /**
   * Casts `func` to a function with an arity capped iteratee if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @returns {Function} Returns the cast function.
   */ function castCap(name, func) {
        if (config.cap) {
            var indexes = $89eBv.iterateeRearg[name];
            if (indexes) return iterateeRearg(func, indexes);
            var n = !isLib && $89eBv.iterateeAry[name];
            if (n) return iterateeAry(func, n);
        }
        return func;
    }
    /**
   * Casts `func` to a curried function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */ function castCurry(name, func, n) {
        return forceCurry || config.curry && n > 1 ? curry(func, n) : func;
    }
    /**
   * Casts `func` to a fixed arity function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the cast function.
   */ function castFixed(name, func, n) {
        if (config.fixed && (forceFixed || !$89eBv.skipFixed[name])) {
            var data = $89eBv.methodSpread[name], start = data && data.start;
            return start === undefined ? ary(func, n) : $d5ddff315914c7cb$var$flatSpread(func, start);
        }
        return func;
    }
    /**
   * Casts `func` to an rearged function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */ function castRearg(name, func, n) {
        return config.rearg && n > 1 && (forceRearg || !$89eBv.skipRearg[name]) ? rearg(func, $89eBv.methodRearg[name] || $89eBv.aryRearg[n]) : func;
    }
    /**
   * Creates a clone of `object` by `path`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {Array|string} path The path to clone by.
   * @returns {Object} Returns the cloned object.
   */ function cloneByPath(object, path) {
        path = toPath(path);
        var index = -1, length = path.length, lastIndex = length - 1, result = clone(Object(object)), nested = result;
        while(nested != null && ++index < length){
            var key = path[index], value = nested[key];
            if (value != null && !(isFunction(value) || isError(value) || isWeakMap(value))) nested[key] = clone(index == lastIndex ? value : Object(value));
            nested = nested[key];
        }
        return result;
    }
    /**
   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
   * version with conversion `options` applied.
   *
   * @param {Object} [options] The options object. See `baseConvert` for more details.
   * @returns {Function} Returns the converted `lodash`.
   */ function convertLib(options) {
        return _.runInContext.convert(options)(undefined);
    }
    /**
   * Create a converter function for `func` of `name`.
   *
   * @param {string} name The name of the function to convert.
   * @param {Function} func The function to convert.
   * @returns {Function} Returns the new converter function.
   */ function createConverter(name, func) {
        var realName = $89eBv.aliasToReal[name] || name, methodName = $89eBv.remap[realName] || realName, oldOptions = options;
        return function(options) {
            var newUtil = isLib ? pristine : helpers, newFunc = isLib ? pristine[methodName] : func, newOptions = assign(assign({}, oldOptions), options);
            return $d5ddff315914c7cb$var$baseConvert(newUtil, realName, newFunc, newOptions);
        };
    }
    /**
   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
   * arguments, ignoring any additional arguments.
   *
   * @private
   * @param {Function} func The function to cap iteratee arguments for.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the new function.
   */ function iterateeAry(func, n) {
        return overArg(func, function(func) {
            return typeof func == 'function' ? $d5ddff315914c7cb$var$baseAry(func, n) : func;
        });
    }
    /**
   * Creates a function that wraps `func` to invoke its iteratee with arguments
   * arranged according to the specified `indexes` where the argument value at
   * the first index is provided as the first argument, the argument value at
   * the second index is provided as the second argument, and so on.
   *
   * @private
   * @param {Function} func The function to rearrange iteratee arguments for.
   * @param {number[]} indexes The arranged argument indexes.
   * @returns {Function} Returns the new function.
   */ function iterateeRearg(func, indexes) {
        return overArg(func, function(func) {
            var n = indexes.length;
            return $d5ddff315914c7cb$var$baseArity(rearg($d5ddff315914c7cb$var$baseAry(func, n), indexes), n);
        });
    }
    /**
   * Creates a function that invokes `func` with its first argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function() {
            var length = arguments.length;
            if (!length) return func();
            var args = Array(length);
            while(length--)args[length] = arguments[length];
            var index = config.rearg ? 0 : length - 1;
            args[index] = transform(args[index]);
            return func.apply(undefined, args);
        };
    }
    /**
   * Creates a function that wraps `func` and applys the conversions
   * rules by `name`.
   *
   * @private
   * @param {string} name The name of the function to wrap.
   * @param {Function} func The function to wrap.
   * @returns {Function} Returns the converted function.
   */ function wrap(name, func, placeholder) {
        var result, realName = $89eBv.aliasToReal[name] || name, wrapped = func, wrapper = wrappers[realName];
        if (wrapper) wrapped = wrapper(func);
        else if (config.immutable) {
            if ($89eBv.mutate.array[realName]) wrapped = $d5ddff315914c7cb$var$wrapImmutable(func, $d5ddff315914c7cb$var$cloneArray);
            else if ($89eBv.mutate.object[realName]) wrapped = $d5ddff315914c7cb$var$wrapImmutable(func, $d5ddff315914c7cb$var$createCloner(func));
            else if ($89eBv.mutate.set[realName]) wrapped = $d5ddff315914c7cb$var$wrapImmutable(func, cloneByPath);
        }
        each(aryMethodKeys, function(aryKey) {
            each($89eBv.aryMethod[aryKey], function(otherName) {
                if (realName == otherName) {
                    var data = $89eBv.methodSpread[realName], afterRearg = data && data.afterRearg;
                    result = afterRearg ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey) : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);
                    result = castCap(realName, result);
                    result = castCurry(realName, result, aryKey);
                    return false;
                }
            });
            return !result;
        });
        result || (result = wrapped);
        if (result == func) result = forceCurry ? curry(result, 1) : function() {
            return func.apply(this, arguments);
        };
        result.convert = createConverter(realName, func);
        result.placeholder = func.placeholder = placeholder;
        return result;
    }
    /*--------------------------------------------------------------------------*/ if (!isObj) return wrap(name, func, defaultHolder);
    var _ = func;
    // Convert methods by ary cap.
    var pairs = [];
    each(aryMethodKeys, function(aryKey) {
        each($89eBv.aryMethod[aryKey], function(key) {
            var func = _[$89eBv.remap[key] || key];
            if (func) pairs.push([
                key,
                wrap(key, func, _)
            ]);
        });
    });
    // Convert remaining methods.
    each(keys(_), function(key) {
        var func = _[key];
        if (typeof func == 'function') {
            var length = pairs.length;
            while(length--){
                if (pairs[length][0] == key) return;
            }
            func.convert = createConverter(key, func);
            pairs.push([
                key,
                func
            ]);
        }
    });
    // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
    each(pairs, function(pair) {
        _[pair[0]] = pair[1];
    });
    _.convert = convertLib;
    _.placeholder = _;
    // Assign aliases.
    each(keys(_), function(key) {
        each($89eBv.realToAlias[key] || [], function(alias) {
            _[alias] = _[key];
        });
    });
    return _;
}
module.exports = $d5ddff315914c7cb$var$baseConvert;

});
parcelRegister("89eBv", function(module, exports) {

$parcel$export(module.exports, "aliasToReal", () => $5eea7e08a1db1590$export$bd0f5e6e44efa6b4, (v) => $5eea7e08a1db1590$export$bd0f5e6e44efa6b4 = v);
$parcel$export(module.exports, "aryMethod", () => $5eea7e08a1db1590$export$85c665b4d7da9cb4, (v) => $5eea7e08a1db1590$export$85c665b4d7da9cb4 = v);
$parcel$export(module.exports, "aryRearg", () => $5eea7e08a1db1590$export$42564e045b285e32, (v) => $5eea7e08a1db1590$export$42564e045b285e32 = v);
$parcel$export(module.exports, "iterateeAry", () => $5eea7e08a1db1590$export$81e17196e6a22b07, (v) => $5eea7e08a1db1590$export$81e17196e6a22b07 = v);
$parcel$export(module.exports, "iterateeRearg", () => $5eea7e08a1db1590$export$30975ceb42167ebd, (v) => $5eea7e08a1db1590$export$30975ceb42167ebd = v);
$parcel$export(module.exports, "methodRearg", () => $5eea7e08a1db1590$export$8ceb0ad7e94d3801, (v) => $5eea7e08a1db1590$export$8ceb0ad7e94d3801 = v);
$parcel$export(module.exports, "methodSpread", () => $5eea7e08a1db1590$export$fbaeb3f87df3cf26, (v) => $5eea7e08a1db1590$export$fbaeb3f87df3cf26 = v);
$parcel$export(module.exports, "mutate", () => $5eea7e08a1db1590$export$57e795267c26e600, (v) => $5eea7e08a1db1590$export$57e795267c26e600 = v);
$parcel$export(module.exports, "realToAlias", () => $5eea7e08a1db1590$export$1eb71a7e27943e71, (v) => $5eea7e08a1db1590$export$1eb71a7e27943e71 = v);
$parcel$export(module.exports, "remap", () => $5eea7e08a1db1590$export$aee1dbae5de2db9d, (v) => $5eea7e08a1db1590$export$aee1dbae5de2db9d = v);
$parcel$export(module.exports, "skipFixed", () => $5eea7e08a1db1590$export$87ffbe4821a5d5e0, (v) => $5eea7e08a1db1590$export$87ffbe4821a5d5e0 = v);
$parcel$export(module.exports, "skipRearg", () => $5eea7e08a1db1590$export$b4d07413ce528c90, (v) => $5eea7e08a1db1590$export$b4d07413ce528c90 = v);
/** Used to map aliases to their real names. */ var $5eea7e08a1db1590$export$bd0f5e6e44efa6b4;
/** Used to map ary to method names. */ var $5eea7e08a1db1590$export$85c665b4d7da9cb4;
/** Used to map ary to rearg configs. */ var $5eea7e08a1db1590$export$42564e045b285e32;
/** Used to map method names to their iteratee ary. */ var $5eea7e08a1db1590$export$81e17196e6a22b07;
/** Used to map method names to iteratee rearg configs. */ var $5eea7e08a1db1590$export$30975ceb42167ebd;
/** Used to map method names to rearg configs. */ var $5eea7e08a1db1590$export$8ceb0ad7e94d3801;
/** Used to map method names to spread configs. */ var $5eea7e08a1db1590$export$fbaeb3f87df3cf26;
/** Used to identify methods which mutate arrays or objects. */ var $5eea7e08a1db1590$export$57e795267c26e600;
/** Used to map real names to their aliases. */ var $5eea7e08a1db1590$export$1eb71a7e27943e71;
/** Used to map method names to other names. */ var $5eea7e08a1db1590$export$aee1dbae5de2db9d;
/** Used to track methods that skip fixing their arity. */ var $5eea7e08a1db1590$export$87ffbe4821a5d5e0;
/** Used to track methods that skip rearranging arguments. */ var $5eea7e08a1db1590$export$b4d07413ce528c90;
$5eea7e08a1db1590$export$bd0f5e6e44efa6b4 = {
    // Lodash aliases.
    'each': 'forEach',
    'eachRight': 'forEachRight',
    'entries': 'toPairs',
    'entriesIn': 'toPairsIn',
    'extend': 'assignIn',
    'extendAll': 'assignInAll',
    'extendAllWith': 'assignInAllWith',
    'extendWith': 'assignInWith',
    'first': 'head',
    // Methods that are curried variants of others.
    'conforms': 'conformsTo',
    'matches': 'isMatch',
    'property': 'get',
    // Ramda aliases.
    '__': 'placeholder',
    'F': 'stubFalse',
    'T': 'stubTrue',
    'all': 'every',
    'allPass': 'overEvery',
    'always': 'constant',
    'any': 'some',
    'anyPass': 'overSome',
    'apply': 'spread',
    'assoc': 'set',
    'assocPath': 'set',
    'complement': 'negate',
    'compose': 'flowRight',
    'contains': 'includes',
    'dissoc': 'unset',
    'dissocPath': 'unset',
    'dropLast': 'dropRight',
    'dropLastWhile': 'dropRightWhile',
    'equals': 'isEqual',
    'identical': 'eq',
    'indexBy': 'keyBy',
    'init': 'initial',
    'invertObj': 'invert',
    'juxt': 'over',
    'omitAll': 'omit',
    'nAry': 'ary',
    'path': 'get',
    'pathEq': 'matchesProperty',
    'pathOr': 'getOr',
    'paths': 'at',
    'pickAll': 'pick',
    'pipe': 'flow',
    'pluck': 'map',
    'prop': 'get',
    'propEq': 'matchesProperty',
    'propOr': 'getOr',
    'props': 'at',
    'symmetricDifference': 'xor',
    'symmetricDifferenceBy': 'xorBy',
    'symmetricDifferenceWith': 'xorWith',
    'takeLast': 'takeRight',
    'takeLastWhile': 'takeRightWhile',
    'unapply': 'rest',
    'unnest': 'flatten',
    'useWith': 'overArgs',
    'where': 'conformsTo',
    'whereEq': 'isMatch',
    'zipObj': 'zipObject'
};
$5eea7e08a1db1590$export$85c665b4d7da9cb4 = {
    '1': [
        'assignAll',
        'assignInAll',
        'attempt',
        'castArray',
        'ceil',
        'create',
        'curry',
        'curryRight',
        'defaultsAll',
        'defaultsDeepAll',
        'floor',
        'flow',
        'flowRight',
        'fromPairs',
        'invert',
        'iteratee',
        'memoize',
        'method',
        'mergeAll',
        'methodOf',
        'mixin',
        'nthArg',
        'over',
        'overEvery',
        'overSome',
        'rest',
        'reverse',
        'round',
        'runInContext',
        'spread',
        'template',
        'trim',
        'trimEnd',
        'trimStart',
        'uniqueId',
        'words',
        'zipAll'
    ],
    '2': [
        'add',
        'after',
        'ary',
        'assign',
        'assignAllWith',
        'assignIn',
        'assignInAllWith',
        'at',
        'before',
        'bind',
        'bindAll',
        'bindKey',
        'chunk',
        'cloneDeepWith',
        'cloneWith',
        'concat',
        'conformsTo',
        'countBy',
        'curryN',
        'curryRightN',
        'debounce',
        'defaults',
        'defaultsDeep',
        'defaultTo',
        'delay',
        'difference',
        'divide',
        'drop',
        'dropRight',
        'dropRightWhile',
        'dropWhile',
        'endsWith',
        'eq',
        'every',
        'filter',
        'find',
        'findIndex',
        'findKey',
        'findLast',
        'findLastIndex',
        'findLastKey',
        'flatMap',
        'flatMapDeep',
        'flattenDepth',
        'forEach',
        'forEachRight',
        'forIn',
        'forInRight',
        'forOwn',
        'forOwnRight',
        'get',
        'groupBy',
        'gt',
        'gte',
        'has',
        'hasIn',
        'includes',
        'indexOf',
        'intersection',
        'invertBy',
        'invoke',
        'invokeMap',
        'isEqual',
        'isMatch',
        'join',
        'keyBy',
        'lastIndexOf',
        'lt',
        'lte',
        'map',
        'mapKeys',
        'mapValues',
        'matchesProperty',
        'maxBy',
        'meanBy',
        'merge',
        'mergeAllWith',
        'minBy',
        'multiply',
        'nth',
        'omit',
        'omitBy',
        'overArgs',
        'pad',
        'padEnd',
        'padStart',
        'parseInt',
        'partial',
        'partialRight',
        'partition',
        'pick',
        'pickBy',
        'propertyOf',
        'pull',
        'pullAll',
        'pullAt',
        'random',
        'range',
        'rangeRight',
        'rearg',
        'reject',
        'remove',
        'repeat',
        'restFrom',
        'result',
        'sampleSize',
        'some',
        'sortBy',
        'sortedIndex',
        'sortedIndexOf',
        'sortedLastIndex',
        'sortedLastIndexOf',
        'sortedUniqBy',
        'split',
        'spreadFrom',
        'startsWith',
        'subtract',
        'sumBy',
        'take',
        'takeRight',
        'takeRightWhile',
        'takeWhile',
        'tap',
        'throttle',
        'thru',
        'times',
        'trimChars',
        'trimCharsEnd',
        'trimCharsStart',
        'truncate',
        'union',
        'uniqBy',
        'uniqWith',
        'unset',
        'unzipWith',
        'without',
        'wrap',
        'xor',
        'zip',
        'zipObject',
        'zipObjectDeep'
    ],
    '3': [
        'assignInWith',
        'assignWith',
        'clamp',
        'differenceBy',
        'differenceWith',
        'findFrom',
        'findIndexFrom',
        'findLastFrom',
        'findLastIndexFrom',
        'getOr',
        'includesFrom',
        'indexOfFrom',
        'inRange',
        'intersectionBy',
        'intersectionWith',
        'invokeArgs',
        'invokeArgsMap',
        'isEqualWith',
        'isMatchWith',
        'flatMapDepth',
        'lastIndexOfFrom',
        'mergeWith',
        'orderBy',
        'padChars',
        'padCharsEnd',
        'padCharsStart',
        'pullAllBy',
        'pullAllWith',
        'rangeStep',
        'rangeStepRight',
        'reduce',
        'reduceRight',
        'replace',
        'set',
        'slice',
        'sortedIndexBy',
        'sortedLastIndexBy',
        'transform',
        'unionBy',
        'unionWith',
        'update',
        'xorBy',
        'xorWith',
        'zipWith'
    ],
    '4': [
        'fill',
        'setWith',
        'updateWith'
    ]
};
$5eea7e08a1db1590$export$42564e045b285e32 = {
    '2': [
        1,
        0
    ],
    '3': [
        2,
        0,
        1
    ],
    '4': [
        3,
        2,
        0,
        1
    ]
};
$5eea7e08a1db1590$export$81e17196e6a22b07 = {
    'dropRightWhile': 1,
    'dropWhile': 1,
    'every': 1,
    'filter': 1,
    'find': 1,
    'findFrom': 1,
    'findIndex': 1,
    'findIndexFrom': 1,
    'findKey': 1,
    'findLast': 1,
    'findLastFrom': 1,
    'findLastIndex': 1,
    'findLastIndexFrom': 1,
    'findLastKey': 1,
    'flatMap': 1,
    'flatMapDeep': 1,
    'flatMapDepth': 1,
    'forEach': 1,
    'forEachRight': 1,
    'forIn': 1,
    'forInRight': 1,
    'forOwn': 1,
    'forOwnRight': 1,
    'map': 1,
    'mapKeys': 1,
    'mapValues': 1,
    'partition': 1,
    'reduce': 2,
    'reduceRight': 2,
    'reject': 1,
    'remove': 1,
    'some': 1,
    'takeRightWhile': 1,
    'takeWhile': 1,
    'times': 1,
    'transform': 2
};
$5eea7e08a1db1590$export$30975ceb42167ebd = {
    'mapKeys': [
        1
    ],
    'reduceRight': [
        1,
        0
    ]
};
$5eea7e08a1db1590$export$8ceb0ad7e94d3801 = {
    'assignInAllWith': [
        1,
        0
    ],
    'assignInWith': [
        1,
        2,
        0
    ],
    'assignAllWith': [
        1,
        0
    ],
    'assignWith': [
        1,
        2,
        0
    ],
    'differenceBy': [
        1,
        2,
        0
    ],
    'differenceWith': [
        1,
        2,
        0
    ],
    'getOr': [
        2,
        1,
        0
    ],
    'intersectionBy': [
        1,
        2,
        0
    ],
    'intersectionWith': [
        1,
        2,
        0
    ],
    'isEqualWith': [
        1,
        2,
        0
    ],
    'isMatchWith': [
        2,
        1,
        0
    ],
    'mergeAllWith': [
        1,
        0
    ],
    'mergeWith': [
        1,
        2,
        0
    ],
    'padChars': [
        2,
        1,
        0
    ],
    'padCharsEnd': [
        2,
        1,
        0
    ],
    'padCharsStart': [
        2,
        1,
        0
    ],
    'pullAllBy': [
        2,
        1,
        0
    ],
    'pullAllWith': [
        2,
        1,
        0
    ],
    'rangeStep': [
        1,
        2,
        0
    ],
    'rangeStepRight': [
        1,
        2,
        0
    ],
    'setWith': [
        3,
        1,
        2,
        0
    ],
    'sortedIndexBy': [
        2,
        1,
        0
    ],
    'sortedLastIndexBy': [
        2,
        1,
        0
    ],
    'unionBy': [
        1,
        2,
        0
    ],
    'unionWith': [
        1,
        2,
        0
    ],
    'updateWith': [
        3,
        1,
        2,
        0
    ],
    'xorBy': [
        1,
        2,
        0
    ],
    'xorWith': [
        1,
        2,
        0
    ],
    'zipWith': [
        1,
        2,
        0
    ]
};
$5eea7e08a1db1590$export$fbaeb3f87df3cf26 = {
    'assignAll': {
        'start': 0
    },
    'assignAllWith': {
        'start': 0
    },
    'assignInAll': {
        'start': 0
    },
    'assignInAllWith': {
        'start': 0
    },
    'defaultsAll': {
        'start': 0
    },
    'defaultsDeepAll': {
        'start': 0
    },
    'invokeArgs': {
        'start': 2
    },
    'invokeArgsMap': {
        'start': 2
    },
    'mergeAll': {
        'start': 0
    },
    'mergeAllWith': {
        'start': 0
    },
    'partial': {
        'start': 1
    },
    'partialRight': {
        'start': 1
    },
    'without': {
        'start': 1
    },
    'zipAll': {
        'start': 0
    }
};
$5eea7e08a1db1590$export$57e795267c26e600 = {
    'array': {
        'fill': true,
        'pull': true,
        'pullAll': true,
        'pullAllBy': true,
        'pullAllWith': true,
        'pullAt': true,
        'remove': true,
        'reverse': true
    },
    'object': {
        'assign': true,
        'assignAll': true,
        'assignAllWith': true,
        'assignIn': true,
        'assignInAll': true,
        'assignInAllWith': true,
        'assignInWith': true,
        'assignWith': true,
        'defaults': true,
        'defaultsAll': true,
        'defaultsDeep': true,
        'defaultsDeepAll': true,
        'merge': true,
        'mergeAll': true,
        'mergeAllWith': true,
        'mergeWith': true
    },
    'set': {
        'set': true,
        'setWith': true,
        'unset': true,
        'update': true,
        'updateWith': true
    }
};
$5eea7e08a1db1590$export$1eb71a7e27943e71 = function() {
    var hasOwnProperty = Object.prototype.hasOwnProperty, object = $5eea7e08a1db1590$export$bd0f5e6e44efa6b4, result = {};
    for(var key in object){
        var value = object[key];
        if (hasOwnProperty.call(result, value)) result[value].push(key);
        else result[value] = [
            key
        ];
    }
    return result;
}();
$5eea7e08a1db1590$export$aee1dbae5de2db9d = {
    'assignAll': 'assign',
    'assignAllWith': 'assignWith',
    'assignInAll': 'assignIn',
    'assignInAllWith': 'assignInWith',
    'curryN': 'curry',
    'curryRightN': 'curryRight',
    'defaultsAll': 'defaults',
    'defaultsDeepAll': 'defaultsDeep',
    'findFrom': 'find',
    'findIndexFrom': 'findIndex',
    'findLastFrom': 'findLast',
    'findLastIndexFrom': 'findLastIndex',
    'getOr': 'get',
    'includesFrom': 'includes',
    'indexOfFrom': 'indexOf',
    'invokeArgs': 'invoke',
    'invokeArgsMap': 'invokeMap',
    'lastIndexOfFrom': 'lastIndexOf',
    'mergeAll': 'merge',
    'mergeAllWith': 'mergeWith',
    'padChars': 'pad',
    'padCharsEnd': 'padEnd',
    'padCharsStart': 'padStart',
    'propertyOf': 'get',
    'rangeStep': 'range',
    'rangeStepRight': 'rangeRight',
    'restFrom': 'rest',
    'spreadFrom': 'spread',
    'trimChars': 'trim',
    'trimCharsEnd': 'trimEnd',
    'trimCharsStart': 'trimStart',
    'zipAll': 'zip'
};
$5eea7e08a1db1590$export$87ffbe4821a5d5e0 = {
    'castArray': true,
    'flow': true,
    'flowRight': true,
    'iteratee': true,
    'mixin': true,
    'rearg': true,
    'runInContext': true
};
$5eea7e08a1db1590$export$b4d07413ce528c90 = {
    'add': true,
    'assign': true,
    'assignIn': true,
    'bind': true,
    'bindKey': true,
    'concat': true,
    'difference': true,
    'divide': true,
    'eq': true,
    'gt': true,
    'gte': true,
    'isEqual': true,
    'lt': true,
    'lte': true,
    'matchesProperty': true,
    'merge': true,
    'multiply': true,
    'overArgs': true,
    'partial': true,
    'partialRight': true,
    'propertyOf': true,
    'random': true,
    'range': true,
    'rangeRight': true,
    'subtract': true,
    'zip': true,
    'zipObject': true,
    'zipObjectDeep': true
};

});

parcelRegister("l6Yg9", function(module, exports) {
/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */ module.exports = {};

});


parcelRegister("a02m0", function(module, exports) {














module.exports = {
    'ary': (parcelRequire("iX5mF")),
    'assign': (parcelRequire("k1JQY")),
    'clone': (parcelRequire("E0NNP")),
    'curry': (parcelRequire("cleLA")),
    'forEach': (parcelRequire("9Kzih")),
    'isArray': (parcelRequire("1c8hB")),
    'isError': (parcelRequire("dbogu")),
    'isFunction': (parcelRequire("eoCgY")),
    'isWeakMap': (parcelRequire("a1CHL")),
    'iteratee': (parcelRequire("akHxB")),
    'keys': (parcelRequire("fCpZe")),
    'rearg': (parcelRequire("k5dRT")),
    'toInteger': (parcelRequire("hNahz")),
    'toPath': (parcelRequire("d0KBl"))
};

});
parcelRegister("iX5mF", function(module, exports) {

var $xQ3hV = parcelRequire("xQ3hV");
/** Used to compose bitmasks for function metadata. */ var $dcc1e600da485164$var$WRAP_ARY_FLAG = 128;
/**
 * Creates a function that invokes `func`, with up to `n` arguments,
 * ignoring any additional arguments.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @param {number} [n=func.length] The arity cap.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
 * // => [6, 8, 10]
 */ function $dcc1e600da485164$var$ary(func, n, guard) {
    n = guard ? undefined : n;
    n = func && n == null ? func.length : n;
    return $xQ3hV(func, $dcc1e600da485164$var$WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
}
module.exports = $dcc1e600da485164$var$ary;

});
parcelRegister("xQ3hV", function(module, exports) {

var $2n5KA = parcelRequire("2n5KA");

var $ajgvA = parcelRequire("ajgvA");

var $4sFI9 = parcelRequire("4sFI9");

var $dJxZV = parcelRequire("dJxZV");

var $3slGh = parcelRequire("3slGh");

var $6bTTb = parcelRequire("6bTTb");

var $fHM5F = parcelRequire("fHM5F");

var $bV9co = parcelRequire("bV9co");

var $3mXyn = parcelRequire("3mXyn");

var $hNahz = parcelRequire("hNahz");
/** Error message constants. */ var $065b75a1a2ef24b3$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used to compose bitmasks for function metadata. */ var $065b75a1a2ef24b3$var$WRAP_BIND_FLAG = 1, $065b75a1a2ef24b3$var$WRAP_BIND_KEY_FLAG = 2, $065b75a1a2ef24b3$var$WRAP_CURRY_FLAG = 8, $065b75a1a2ef24b3$var$WRAP_CURRY_RIGHT_FLAG = 16, $065b75a1a2ef24b3$var$WRAP_PARTIAL_FLAG = 32, $065b75a1a2ef24b3$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $065b75a1a2ef24b3$var$nativeMax = Math.max;
/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $065b75a1a2ef24b3$var$createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
    var isBindKey = bitmask & $065b75a1a2ef24b3$var$WRAP_BIND_KEY_FLAG;
    if (!isBindKey && typeof func != 'function') throw new TypeError($065b75a1a2ef24b3$var$FUNC_ERROR_TEXT);
    var length = partials ? partials.length : 0;
    if (!length) {
        bitmask &= ~($065b75a1a2ef24b3$var$WRAP_PARTIAL_FLAG | $065b75a1a2ef24b3$var$WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
    }
    ary = ary === undefined ? ary : $065b75a1a2ef24b3$var$nativeMax($hNahz(ary), 0);
    arity = arity === undefined ? arity : $hNahz(arity);
    length -= holders ? holders.length : 0;
    if (bitmask & $065b75a1a2ef24b3$var$WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials, holdersRight = holders;
        partials = holders = undefined;
    }
    var data = isBindKey ? undefined : $6bTTb(func);
    var newData = [
        func,
        bitmask,
        thisArg,
        partials,
        holders,
        partialsRight,
        holdersRight,
        argPos,
        ary,
        arity
    ];
    if (data) $fHM5F(newData, data);
    func = newData[0];
    bitmask = newData[1];
    thisArg = newData[2];
    partials = newData[3];
    holders = newData[4];
    arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : $065b75a1a2ef24b3$var$nativeMax(newData[9] - length, 0);
    if (!arity && bitmask & ($065b75a1a2ef24b3$var$WRAP_CURRY_FLAG | $065b75a1a2ef24b3$var$WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~($065b75a1a2ef24b3$var$WRAP_CURRY_FLAG | $065b75a1a2ef24b3$var$WRAP_CURRY_RIGHT_FLAG);
    if (!bitmask || bitmask == $065b75a1a2ef24b3$var$WRAP_BIND_FLAG) var result = $ajgvA(func, bitmask, thisArg);
    else if (bitmask == $065b75a1a2ef24b3$var$WRAP_CURRY_FLAG || bitmask == $065b75a1a2ef24b3$var$WRAP_CURRY_RIGHT_FLAG) result = $4sFI9(func, bitmask, arity);
    else if ((bitmask == $065b75a1a2ef24b3$var$WRAP_PARTIAL_FLAG || bitmask == ($065b75a1a2ef24b3$var$WRAP_BIND_FLAG | $065b75a1a2ef24b3$var$WRAP_PARTIAL_FLAG)) && !holders.length) result = $3slGh(func, bitmask, thisArg, partials);
    else result = $dJxZV.apply(undefined, newData);
    var setter = data ? $2n5KA : $bV9co;
    return $3mXyn(setter(result, newData), func, bitmask);
}
module.exports = $065b75a1a2ef24b3$var$createWrap;

});
parcelRegister("2n5KA", function(module, exports) {

var $3QMTK = parcelRequire("3QMTK");

var $beYtW = parcelRequire("beYtW");
/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var $1ba230a38b363991$var$baseSetData = !$beYtW ? $3QMTK : function(func, data) {
    $beYtW.set(func, data);
    return func;
};
module.exports = $1ba230a38b363991$var$baseSetData;

});

parcelRegister("ajgvA", function(module, exports) {

var $4ptXN = parcelRequire("4ptXN");

var $c1MCs = parcelRequire("c1MCs");
/** Used to compose bitmasks for function metadata. */ var $78187bf3ce07aa33$var$WRAP_BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $78187bf3ce07aa33$var$createBind(func, bitmask, thisArg) {
    var isBind = bitmask & $78187bf3ce07aa33$var$WRAP_BIND_FLAG, Ctor = $4ptXN(func);
    function wrapper() {
        var fn = this && this !== $c1MCs && this instanceof wrapper ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
    }
    return wrapper;
}
module.exports = $78187bf3ce07aa33$var$createBind;

});
parcelRegister("4ptXN", function(module, exports) {

var $9F9XB = parcelRequire("9F9XB");

var $feGjZ = parcelRequire("feGjZ");
/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */ function $3360bd57e2c33b86$var$createCtor(Ctor) {
    return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch(args.length){
            case 0:
                return new Ctor;
            case 1:
                return new Ctor(args[0]);
            case 2:
                return new Ctor(args[0], args[1]);
            case 3:
                return new Ctor(args[0], args[1], args[2]);
            case 4:
                return new Ctor(args[0], args[1], args[2], args[3]);
            case 5:
                return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
            case 7:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = $9F9XB(Ctor.prototype), result = Ctor.apply(thisBinding, args);
        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return $feGjZ(result) ? result : thisBinding;
    };
}
module.exports = $3360bd57e2c33b86$var$createCtor;

});


parcelRegister("4sFI9", function(module, exports) {

var $5VdlS = parcelRequire("5VdlS");

var $4ptXN = parcelRequire("4ptXN");

var $dJxZV = parcelRequire("dJxZV");

var $lOKcz = parcelRequire("lOKcz");

var $9xQzO = parcelRequire("9xQzO");

var $kBgrU = parcelRequire("kBgrU");

var $c1MCs = parcelRequire("c1MCs");
/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $33fa21eee8bcca6f$var$createCurry(func, bitmask, arity) {
    var Ctor = $4ptXN(func);
    function wrapper() {
        var length = arguments.length, args = Array(length), index = length, placeholder = $9xQzO(wrapper);
        while(index--)args[index] = arguments[index];
        var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : $kBgrU(args, placeholder);
        length -= holders.length;
        if (length < arity) return $lOKcz(func, bitmask, $dJxZV, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
        var fn = this && this !== $c1MCs && this instanceof wrapper ? Ctor : func;
        return $5VdlS(fn, this, args);
    }
    return wrapper;
}
module.exports = $33fa21eee8bcca6f$var$createCurry;

});
parcelRegister("dJxZV", function(module, exports) {

var $98OfC = parcelRequire("98OfC");

var $aoNSM = parcelRequire("aoNSM");

var $24kQN = parcelRequire("24kQN");

var $4ptXN = parcelRequire("4ptXN");

var $lOKcz = parcelRequire("lOKcz");

var $9xQzO = parcelRequire("9xQzO");

var $jtjhF = parcelRequire("jtjhF");

var $kBgrU = parcelRequire("kBgrU");

var $c1MCs = parcelRequire("c1MCs");
/** Used to compose bitmasks for function metadata. */ var $9ff9d999ee3e5b26$var$WRAP_BIND_FLAG = 1, $9ff9d999ee3e5b26$var$WRAP_BIND_KEY_FLAG = 2, $9ff9d999ee3e5b26$var$WRAP_CURRY_FLAG = 8, $9ff9d999ee3e5b26$var$WRAP_CURRY_RIGHT_FLAG = 16, $9ff9d999ee3e5b26$var$WRAP_ARY_FLAG = 128, $9ff9d999ee3e5b26$var$WRAP_FLIP_FLAG = 512;
/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $9ff9d999ee3e5b26$var$createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
    var isAry = bitmask & $9ff9d999ee3e5b26$var$WRAP_ARY_FLAG, isBind = bitmask & $9ff9d999ee3e5b26$var$WRAP_BIND_FLAG, isBindKey = bitmask & $9ff9d999ee3e5b26$var$WRAP_BIND_KEY_FLAG, isCurried = bitmask & ($9ff9d999ee3e5b26$var$WRAP_CURRY_FLAG | $9ff9d999ee3e5b26$var$WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & $9ff9d999ee3e5b26$var$WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : $4ptXN(func);
    function wrapper() {
        var length = arguments.length, args = Array(length), index = length;
        while(index--)args[index] = arguments[index];
        if (isCurried) var placeholder = $9xQzO(wrapper), holdersCount = $24kQN(args, placeholder);
        if (partials) args = $98OfC(args, partials, holders, isCurried);
        if (partialsRight) args = $aoNSM(args, partialsRight, holdersRight, isCurried);
        length -= holdersCount;
        if (isCurried && length < arity) {
            var newHolders = $kBgrU(args, placeholder);
            return $lOKcz(func, bitmask, $9ff9d999ee3e5b26$var$createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
        }
        var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
        length = args.length;
        if (argPos) args = $jtjhF(args, argPos);
        else if (isFlip && length > 1) args.reverse();
        if (isAry && ary < length) args.length = ary;
        if (this && this !== $c1MCs && this instanceof wrapper) fn = Ctor || $4ptXN(fn);
        return fn.apply(thisBinding, args);
    }
    return wrapper;
}
module.exports = $9ff9d999ee3e5b26$var$createHybrid;

});
parcelRegister("98OfC", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6a7bd72e71453dbc$var$nativeMax = Math.max;
/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function $6a7bd72e71453dbc$var$composeArgs(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = $6a7bd72e71453dbc$var$nativeMax(argsLength - holdersLength, 0), result = Array(leftLength + rangeLength), isUncurried = !isCurried;
    while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
    while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
    while(rangeLength--)result[leftIndex++] = args[argsIndex++];
    return result;
}
module.exports = $6a7bd72e71453dbc$var$composeArgs;

});

parcelRegister("aoNSM", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7922d6e81726c41f$var$nativeMax = Math.max;
/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function $7922d6e81726c41f$var$composeArgsRight(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = $7922d6e81726c41f$var$nativeMax(argsLength - holdersLength, 0), result = Array(rangeLength + rightLength), isUncurried = !isCurried;
    while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
    var offset = argsIndex;
    while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
    while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
    return result;
}
module.exports = $7922d6e81726c41f$var$composeArgsRight;

});

parcelRegister("24kQN", function(module, exports) {
/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */ function $181c20ffe0a73f5e$var$countHolders(array, placeholder) {
    var length = array.length, result = 0;
    while(length--)if (array[length] === placeholder) ++result;
    return result;
}
module.exports = $181c20ffe0a73f5e$var$countHolders;

});

parcelRegister("lOKcz", function(module, exports) {

var $cp9gS = parcelRequire("cp9gS");

var $bV9co = parcelRequire("bV9co");

var $3mXyn = parcelRequire("3mXyn");
/** Used to compose bitmasks for function metadata. */ var $fe221b32db6745a2$var$WRAP_BIND_FLAG = 1, $fe221b32db6745a2$var$WRAP_BIND_KEY_FLAG = 2, $fe221b32db6745a2$var$WRAP_CURRY_BOUND_FLAG = 4, $fe221b32db6745a2$var$WRAP_CURRY_FLAG = 8, $fe221b32db6745a2$var$WRAP_PARTIAL_FLAG = 32, $fe221b32db6745a2$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $fe221b32db6745a2$var$createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
    var isCurry = bitmask & $fe221b32db6745a2$var$WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
    bitmask |= isCurry ? $fe221b32db6745a2$var$WRAP_PARTIAL_FLAG : $fe221b32db6745a2$var$WRAP_PARTIAL_RIGHT_FLAG;
    bitmask &= ~(isCurry ? $fe221b32db6745a2$var$WRAP_PARTIAL_RIGHT_FLAG : $fe221b32db6745a2$var$WRAP_PARTIAL_FLAG);
    if (!(bitmask & $fe221b32db6745a2$var$WRAP_CURRY_BOUND_FLAG)) bitmask &= ~($fe221b32db6745a2$var$WRAP_BIND_FLAG | $fe221b32db6745a2$var$WRAP_BIND_KEY_FLAG);
    var newData = [
        func,
        bitmask,
        thisArg,
        newPartials,
        newHolders,
        newPartialsRight,
        newHoldersRight,
        argPos,
        ary,
        arity
    ];
    var result = wrapFunc.apply(undefined, newData);
    if ($cp9gS(func)) $bV9co(result, newData);
    result.placeholder = placeholder;
    return $3mXyn(result, func, bitmask);
}
module.exports = $fe221b32db6745a2$var$createRecurry;

});
parcelRegister("bV9co", function(module, exports) {

var $2n5KA = parcelRequire("2n5KA");

var $d1V3m = parcelRequire("d1V3m");
/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var $8adc2746a2aa5eeb$var$setData = $d1V3m($2n5KA);
module.exports = $8adc2746a2aa5eeb$var$setData;

});

parcelRegister("3mXyn", function(module, exports) {

var $4pgZb = parcelRequire("4pgZb");

var $1k0ou = parcelRequire("1k0ou");

var $ly0Gc = parcelRequire("ly0Gc");

var $7YePn = parcelRequire("7YePn");
/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */ function $27419f3ed4dc5d4c$var$setWrapToString(wrapper, reference, bitmask) {
    var source = reference + '';
    return $ly0Gc(wrapper, $1k0ou(source, $7YePn($4pgZb(source), bitmask)));
}
module.exports = $27419f3ed4dc5d4c$var$setWrapToString;

});
parcelRegister("4pgZb", function(module, exports) {
/** Used to match wrap detail comments. */ var $3356ac43c54e635f$var$reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, $3356ac43c54e635f$var$reSplitDetails = /,? & /;
/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */ function $3356ac43c54e635f$var$getWrapDetails(source) {
    var match = source.match($3356ac43c54e635f$var$reWrapDetails);
    return match ? match[1].split($3356ac43c54e635f$var$reSplitDetails) : [];
}
module.exports = $3356ac43c54e635f$var$getWrapDetails;

});

parcelRegister("1k0ou", function(module, exports) {
/** Used to match wrap detail comments. */ var $0f67f6f702bebdca$var$reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */ function $0f67f6f702bebdca$var$insertWrapDetails(source, details) {
    var length = details.length;
    if (!length) return source;
    var lastIndex = length - 1;
    details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
    details = details.join(length > 2 ? ', ' : ' ');
    return source.replace($0f67f6f702bebdca$var$reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}
module.exports = $0f67f6f702bebdca$var$insertWrapDetails;

});

parcelRegister("7YePn", function(module, exports) {

var $9Kzih = parcelRequire("9Kzih");

var $lqZWH = parcelRequire("lqZWH");
/** Used to compose bitmasks for function metadata. */ var $5cd9a37742eb8774$var$WRAP_BIND_FLAG = 1, $5cd9a37742eb8774$var$WRAP_BIND_KEY_FLAG = 2, $5cd9a37742eb8774$var$WRAP_CURRY_FLAG = 8, $5cd9a37742eb8774$var$WRAP_CURRY_RIGHT_FLAG = 16, $5cd9a37742eb8774$var$WRAP_PARTIAL_FLAG = 32, $5cd9a37742eb8774$var$WRAP_PARTIAL_RIGHT_FLAG = 64, $5cd9a37742eb8774$var$WRAP_ARY_FLAG = 128, $5cd9a37742eb8774$var$WRAP_REARG_FLAG = 256, $5cd9a37742eb8774$var$WRAP_FLIP_FLAG = 512;
/** Used to associate wrap methods with their bit flags. */ var $5cd9a37742eb8774$var$wrapFlags = [
    [
        'ary',
        $5cd9a37742eb8774$var$WRAP_ARY_FLAG
    ],
    [
        'bind',
        $5cd9a37742eb8774$var$WRAP_BIND_FLAG
    ],
    [
        'bindKey',
        $5cd9a37742eb8774$var$WRAP_BIND_KEY_FLAG
    ],
    [
        'curry',
        $5cd9a37742eb8774$var$WRAP_CURRY_FLAG
    ],
    [
        'curryRight',
        $5cd9a37742eb8774$var$WRAP_CURRY_RIGHT_FLAG
    ],
    [
        'flip',
        $5cd9a37742eb8774$var$WRAP_FLIP_FLAG
    ],
    [
        'partial',
        $5cd9a37742eb8774$var$WRAP_PARTIAL_FLAG
    ],
    [
        'partialRight',
        $5cd9a37742eb8774$var$WRAP_PARTIAL_RIGHT_FLAG
    ],
    [
        'rearg',
        $5cd9a37742eb8774$var$WRAP_REARG_FLAG
    ]
];
/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */ function $5cd9a37742eb8774$var$updateWrapDetails(details, bitmask) {
    $9Kzih($5cd9a37742eb8774$var$wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if (bitmask & pair[1] && !$lqZWH(details, value)) details.push(value);
    });
    return details.sort();
}
module.exports = $5cd9a37742eb8774$var$updateWrapDetails;

});



parcelRegister("9xQzO", function(module, exports) {
/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */ function $6f2ffabf17208972$var$getHolder(func) {
    var object = func;
    return object.placeholder;
}
module.exports = $6f2ffabf17208972$var$getHolder;

});

parcelRegister("jtjhF", function(module, exports) {

var $b69Sx = parcelRequire("b69Sx");

var $3hFfZ = parcelRequire("3hFfZ");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $e2cfaf2379d6eef4$var$nativeMin = Math.min;
/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */ function $e2cfaf2379d6eef4$var$reorder(array, indexes) {
    var arrLength = array.length, length = $e2cfaf2379d6eef4$var$nativeMin(indexes.length, arrLength), oldArray = $b69Sx(array);
    while(length--){
        var index = indexes[length];
        array[length] = $3hFfZ(index, arrLength) ? oldArray[index] : undefined;
    }
    return array;
}
module.exports = $e2cfaf2379d6eef4$var$reorder;

});

parcelRegister("kBgrU", function(module, exports) {
/** Used as the internal argument placeholder. */ var $eff405cccdf3a041$var$PLACEHOLDER = '__lodash_placeholder__';
/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */ function $eff405cccdf3a041$var$replaceHolders(array, placeholder) {
    var index = -1, length = array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (value === placeholder || value === $eff405cccdf3a041$var$PLACEHOLDER) {
            array[index] = $eff405cccdf3a041$var$PLACEHOLDER;
            result[resIndex++] = index;
        }
    }
    return result;
}
module.exports = $eff405cccdf3a041$var$replaceHolders;

});



parcelRegister("3slGh", function(module, exports) {

var $5VdlS = parcelRequire("5VdlS");

var $4ptXN = parcelRequire("4ptXN");

var $c1MCs = parcelRequire("c1MCs");
/** Used to compose bitmasks for function metadata. */ var $2844ce06b6725f7d$var$WRAP_BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */ function $2844ce06b6725f7d$var$createPartial(func, bitmask, thisArg, partials) {
    var isBind = bitmask & $2844ce06b6725f7d$var$WRAP_BIND_FLAG, Ctor = $4ptXN(func);
    function wrapper() {
        var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array(leftLength + argsLength), fn = this && this !== $c1MCs && this instanceof wrapper ? Ctor : func;
        while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
        while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
        return $5VdlS(fn, isBind ? thisArg : this, args);
    }
    return wrapper;
}
module.exports = $2844ce06b6725f7d$var$createPartial;

});

parcelRegister("fHM5F", function(module, exports) {

var $98OfC = parcelRequire("98OfC");

var $aoNSM = parcelRequire("aoNSM");

var $kBgrU = parcelRequire("kBgrU");
/** Used as the internal argument placeholder. */ var $b6f02cf0a655a19e$var$PLACEHOLDER = '__lodash_placeholder__';
/** Used to compose bitmasks for function metadata. */ var $b6f02cf0a655a19e$var$WRAP_BIND_FLAG = 1, $b6f02cf0a655a19e$var$WRAP_BIND_KEY_FLAG = 2, $b6f02cf0a655a19e$var$WRAP_CURRY_BOUND_FLAG = 4, $b6f02cf0a655a19e$var$WRAP_CURRY_FLAG = 8, $b6f02cf0a655a19e$var$WRAP_ARY_FLAG = 128, $b6f02cf0a655a19e$var$WRAP_REARG_FLAG = 256;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b6f02cf0a655a19e$var$nativeMin = Math.min;
/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */ function $b6f02cf0a655a19e$var$mergeData(data, source) {
    var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < ($b6f02cf0a655a19e$var$WRAP_BIND_FLAG | $b6f02cf0a655a19e$var$WRAP_BIND_KEY_FLAG | $b6f02cf0a655a19e$var$WRAP_ARY_FLAG);
    var isCombo = srcBitmask == $b6f02cf0a655a19e$var$WRAP_ARY_FLAG && bitmask == $b6f02cf0a655a19e$var$WRAP_CURRY_FLAG || srcBitmask == $b6f02cf0a655a19e$var$WRAP_ARY_FLAG && bitmask == $b6f02cf0a655a19e$var$WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == ($b6f02cf0a655a19e$var$WRAP_ARY_FLAG | $b6f02cf0a655a19e$var$WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == $b6f02cf0a655a19e$var$WRAP_CURRY_FLAG;
    // Exit early if metadata can't be merged.
    if (!(isCommon || isCombo)) return data;
    // Use source `thisArg` if available.
    if (srcBitmask & $b6f02cf0a655a19e$var$WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & $b6f02cf0a655a19e$var$WRAP_BIND_FLAG ? 0 : $b6f02cf0a655a19e$var$WRAP_CURRY_BOUND_FLAG;
    }
    // Compose partial arguments.
    var value = source[3];
    if (value) {
        var partials = data[3];
        data[3] = partials ? $98OfC(partials, value, source[4]) : value;
        data[4] = partials ? $kBgrU(data[3], $b6f02cf0a655a19e$var$PLACEHOLDER) : source[4];
    }
    // Compose partial right arguments.
    value = source[5];
    if (value) {
        partials = data[5];
        data[5] = partials ? $aoNSM(partials, value, source[6]) : value;
        data[6] = partials ? $kBgrU(data[5], $b6f02cf0a655a19e$var$PLACEHOLDER) : source[6];
    }
    // Use source `argPos` if available.
    value = source[7];
    if (value) data[7] = value;
    // Use source `ary` if it's smaller.
    if (srcBitmask & $b6f02cf0a655a19e$var$WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : $b6f02cf0a655a19e$var$nativeMin(data[8], source[8]);
    // Use source `arity` if one is not provided.
    if (data[9] == null) data[9] = source[9];
    // Use source `func` and merge bitmasks.
    data[0] = source[0];
    data[1] = newBitmask;
    return data;
}
module.exports = $b6f02cf0a655a19e$var$mergeData;

});



parcelRegister("E0NNP", function(module, exports) {

var $ee7Ev = parcelRequire("ee7Ev");
/** Used to compose bitmasks for cloning. */ var $07845bdb18fff27f$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $07845bdb18fff27f$var$clone(value) {
    return $ee7Ev(value, $07845bdb18fff27f$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $07845bdb18fff27f$var$clone;

});

parcelRegister("cleLA", function(module, exports) {

var $xQ3hV = parcelRequire("xQ3hV");
/** Used to compose bitmasks for function metadata. */ var $8fc2e687045586ce$var$WRAP_CURRY_FLAG = 8;
/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */ function $8fc2e687045586ce$var$curry(func, arity, guard) {
    arity = guard ? undefined : arity;
    var result = $xQ3hV(func, $8fc2e687045586ce$var$WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
    result.placeholder = $8fc2e687045586ce$var$curry.placeholder;
    return result;
}
// Assign default placeholders.
$8fc2e687045586ce$var$curry.placeholder = {};
module.exports = $8fc2e687045586ce$var$curry;

});

parcelRegister("dbogu", function(module, exports) {

var $2OY5s = parcelRequire("2OY5s");

var $hYEMs = parcelRequire("hYEMs");

var $jtsd5 = parcelRequire("jtsd5");
/** `Object#toString` result references. */ var $998f1ff604abccc1$var$domExcTag = '[object DOMException]', $998f1ff604abccc1$var$errorTag = '[object Error]';
/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */ function $998f1ff604abccc1$var$isError(value) {
    if (!$hYEMs(value)) return false;
    var tag = $2OY5s(value);
    return tag == $998f1ff604abccc1$var$errorTag || tag == $998f1ff604abccc1$var$domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !$jtsd5(value);
}
module.exports = $998f1ff604abccc1$var$isError;

});

parcelRegister("a1CHL", function(module, exports) {

var $fjnSB = parcelRequire("fjnSB");

var $hYEMs = parcelRequire("hYEMs");
/** `Object#toString` result references. */ var $74c80559f18c75f2$var$weakMapTag = '[object WeakMap]';
/**
 * Checks if `value` is classified as a `WeakMap` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
 * @example
 *
 * _.isWeakMap(new WeakMap);
 * // => true
 *
 * _.isWeakMap(new Map);
 * // => false
 */ function $74c80559f18c75f2$var$isWeakMap(value) {
    return $hYEMs(value) && $fjnSB(value) == $74c80559f18c75f2$var$weakMapTag;
}
module.exports = $74c80559f18c75f2$var$isWeakMap;

});

parcelRegister("akHxB", function(module, exports) {

var $ee7Ev = parcelRequire("ee7Ev");

var $7qARj = parcelRequire("7qARj");
/** Used to compose bitmasks for cloning. */ var $785d8bf9eb54b1a7$var$CLONE_DEEP_FLAG = 1;
/**
 * Creates a function that invokes `func` with the arguments of the created
 * function. If `func` is a property name, the created function returns the
 * property value for a given element. If `func` is an array or object, the
 * created function returns `true` for elements that contain the equivalent
 * source properties, otherwise it returns `false`.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Util
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @returns {Function} Returns the callback.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, _.iteratee(['user', 'fred']));
 * // => [{ 'user': 'fred', 'age': 40 }]
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, _.iteratee('user'));
 * // => ['barney', 'fred']
 *
 * // Create custom iteratee shorthands.
 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
 *     return func.test(string);
 *   };
 * });
 *
 * _.filter(['abc', 'def'], /ef/);
 * // => ['def']
 */ function $785d8bf9eb54b1a7$var$iteratee(func) {
    return $7qARj(typeof func == 'function' ? func : $ee7Ev(func, $785d8bf9eb54b1a7$var$CLONE_DEEP_FLAG));
}
module.exports = $785d8bf9eb54b1a7$var$iteratee;

});

parcelRegister("k5dRT", function(module, exports) {

var $xQ3hV = parcelRequire("xQ3hV");

var $224h2 = parcelRequire("224h2");
/** Used to compose bitmasks for function metadata. */ var $e9ef0836fe6d24f1$var$WRAP_REARG_FLAG = 256;
/**
 * Creates a function that invokes `func` with arguments arranged according
 * to the specified `indexes` where the argument value at the first index is
 * provided as the first argument, the argument value at the second index is
 * provided as the second argument, and so on.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to rearrange arguments for.
 * @param {...(number|number[])} indexes The arranged argument indexes.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var rearged = _.rearg(function(a, b, c) {
 *   return [a, b, c];
 * }, [2, 0, 1]);
 *
 * rearged('b', 'c', 'a')
 * // => ['a', 'b', 'c']
 */ var $e9ef0836fe6d24f1$var$rearg = $224h2(function(func, indexes) {
    return $xQ3hV(func, $e9ef0836fe6d24f1$var$WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
});
module.exports = $e9ef0836fe6d24f1$var$rearg;

});

parcelRegister("d0KBl", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");

var $b69Sx = parcelRequire("b69Sx");

var $1c8hB = parcelRequire("1c8hB");

var $8aco7 = parcelRequire("8aco7");

var $1xzs7 = parcelRequire("1xzs7");

var $cNyDu = parcelRequire("cNyDu");

var $1uqnh = parcelRequire("1uqnh");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $978f6c7ba8ca5ebf$var$toPath(value) {
    if ($1c8hB(value)) return $kJvGp(value, $cNyDu);
    return $8aco7(value) ? [
        value
    ] : $b69Sx($1xzs7($1uqnh(value)));
}
module.exports = $978f6c7ba8ca5ebf$var$toPath;

});



parcelRegister("f222W", function(module, exports) {
/**
 * Checks if `value` is `null`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
 * @example
 *
 * _.isNull(null);
 * // => true
 *
 * _.isNull(void 0);
 * // => false
 */ function $af18a14b43d56cd0$var$isNull(value) {
    return value === null;
}
module.exports = $af18a14b43d56cd0$var$isNull;

});

parcelRegister("jKGa6", function(module, exports) {
module.exports = {
    'cap': false,
    'curry': false,
    'fixed': false,
    'immutable': false,
    'rearg': false
};

});


parcelRegister("fFT4s", function(module, exports) {

var $jFIrw = parcelRequire("jFIrw");


var $b695674d0ca53c11$var$func = $jFIrw('isUndefined', (parcelRequire("kkgbD")), (parcelRequire("jKGa6")));

$b695674d0ca53c11$var$func.placeholder = (parcelRequire("l6Yg9"));
module.exports = $b695674d0ca53c11$var$func;

});

parcelRegister("2L86F", function(module, exports) {

var $jFIrw = parcelRequire("jFIrw");

var $20264253e5b57993$var$func = $jFIrw('omitBy', (parcelRequire("i7Fym")));

$20264253e5b57993$var$func.placeholder = (parcelRequire("l6Yg9"));
module.exports = $20264253e5b57993$var$func;

});

parcelRegister("6ovLb", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae1a7f5af5d51b13$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8302ec971b0cf37e40bca801469af6c9>>
 * @relayHash 6acb7af1e94f5345e9b36a8cd44c4bee
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b990d47758e2cd9b24e5dbee104f873a7f1b2aead336e44568500c9564afe54b
const $ae1a7f5af5d51b13$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "level"
    }, v4 = [
        {
            "concreteType": "JiraIssueTypeHierarchyLevel",
            "kind": "LinkedField",
            "name": "hierarchyLevel",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ]
        },
        {
            "concreteType": "JiraIssueTypeConnection",
            "kind": "LinkedField",
            "name": "cmpIssueTypes",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "issueTypeId"
                                },
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "description"
                                },
                                {
                                    "concreteType": "JiraIssueTypeHierarchyLevel",
                                    "kind": "LinkedField",
                                    "name": "hierarchy",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "small"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ], v5 = {
        "concreteType": "JiraHierarchyConfigError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "code"
            },
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v6 = {
        "args": v1 /*: any*/ ,
        "concreteType": "JiraIssueHierarchyConfigurationQuery",
        "kind": "LinkedField",
        "name": "issueHierarchyConfig",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueHierarchyConfigData",
                "kind": "LinkedField",
                "name": "data",
                "plural": true,
                "selections": v4 /*: any*/ 
            },
            {
                "kind": "ScalarField",
                "name": "success"
            },
            v5 /*: any*/ 
        ]
    }, v7 = {
        "args": v1 /*: any*/ ,
        "concreteType": "JiraIssueHierarchyLimits",
        "kind": "LinkedField",
        "name": "issueHierarchyLimits",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "maxLevels"
            },
            {
                "kind": "ScalarField",
                "name": "nameLength"
            }
        ]
    }, v8 = {
        "args": v1 /*: any*/ ,
        "kind": "ScalarField",
        "name": "lockedIssueTypeIds"
    }, v9 = {
        "concreteType": "JiraIssueHierarchyConfigData",
        "kind": "LinkedField",
        "name": "issueHierarchyConfig",
        "plural": true,
        "selections": v4 /*: any*/ 
    }, v10 = {
        "concreteType": "JiraLongRunningTaskProgress",
        "kind": "LinkedField",
        "name": "taskProgress",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "status"
            },
            {
                "kind": "ScalarField",
                "name": "progress"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "mainIssueHierarchyQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraHierarchyConfigTask",
                            "kind": "LinkedField",
                            "name": "issueHierarchyConfigUpdateTask",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "kind": "FragmentSpread",
                                    "name": "saveButton_adminPagesIssueHierarchyDirectory"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "saveDialog_adminPagesIssueHierarchyDirectory"
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "mainIssueHierarchyQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraHierarchyConfigTask",
                            "kind": "LinkedField",
                            "name": "issueHierarchyConfigUpdateTask",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b990d47758e2cd9b24e5dbee104f873a7f1b2aead336e44568500c9564afe54b",
            "metadata": {},
            "name": "mainIssueHierarchyQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ae1a7f5af5d51b13$var$node.hash = "e780e64aedcd2278004df68a042f1343";
var $ae1a7f5af5d51b13$export$2e2bcd8739ae039 = $ae1a7f5af5d51b13$var$node;

});

parcelRegister("7fZ6q", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $947201448b669da2$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $947201448b669da2$export$d57b6b390e78d90f);
$parcel$export(module.exports, "METRICS_PAGE_ID", () => $947201448b669da2$export$5721fd5d6ba543ca);
$parcel$export(module.exports, "MAX_HIERARCHY_LEVEL_STANDARD_USER_CAN_ADD_ISSUE_TYPE", () => $947201448b669da2$export$59eb53550732bd4f);
$parcel$export(module.exports, "MAX_HIERARCHY_LEVEL_STANDARD_USER_RENAMABLE", () => $947201448b669da2$export$f89af6bd965ff8e6);
$parcel$export(module.exports, "MAX_HIERARCHY_LEVEL_STANDARD_USER_REMOVABLE", () => $947201448b669da2$export$a2a86cf5bc573cc4);
$parcel$export(module.exports, "HIERARCHY_LEVELS_TO_IGNORE_ISSUE_TYPES", () => $947201448b669da2$export$f4a8211cd0cf37d5);
$parcel$export(module.exports, "LOWEST_LEVEL", () => $947201448b669da2$export$f78e1d0563dcad7a);
$parcel$export(module.exports, "STATIC_LEVELS", () => $947201448b669da2$export$d0ba381719ed6634);
$parcel$export(module.exports, "NUM_STATIC_LEVELS", () => $947201448b669da2$export$d22241613c362659);
$parcel$export(module.exports, "JIRA_LONG_RUNNING_TASK_STATUS", () => $947201448b669da2$export$dcdcca93eb62dcc8);
$parcel$export(module.exports, "UPDATE_HIERARCHY_TASK_STATUS", () => $947201448b669da2$export$67b2124589a168a0);
$parcel$export(module.exports, "DOC_LINKS", () => $947201448b669da2$export$f8975d2c25cd8c82);
const $947201448b669da2$export$b8b9d90f9e5bd72b = 'jira-admin-pages-issue-hierarchy-directory';
const $947201448b669da2$export$d57b6b390e78d90f = 'advanced-roadmaps';
const $947201448b669da2$export$5721fd5d6ba543ca = 'global-admin.issues.issue-hierarchy-config';
const $947201448b669da2$export$59eb53550732bd4f = 0;
const $947201448b669da2$export$f89af6bd965ff8e6 = 1;
const $947201448b669da2$export$a2a86cf5bc573cc4 = 1;
const $947201448b669da2$export$f4a8211cd0cf37d5 = [
    -1,
    0
];
const $947201448b669da2$export$f78e1d0563dcad7a = -1;
const $947201448b669da2$export$d0ba381719ed6634 = Object.freeze({
    from: $947201448b669da2$export$f78e1d0563dcad7a,
    to: $947201448b669da2$export$a2a86cf5bc573cc4
});
const $947201448b669da2$export$d22241613c362659 = 1 + $947201448b669da2$export$d0ba381719ed6634.to - $947201448b669da2$export$d0ba381719ed6634.from;
const $947201448b669da2$export$dcdcca93eb62dcc8 = {
    RUNNING: 'RUNNING',
    ENQUEUED: 'ENQUEUED',
    FAILED: 'FAILED',
    DEAD: 'DEAD',
    COMPLETE: 'COMPLETE',
    CANCELLED: 'CANCELLED',
    CANCEL_REQUESTED: 'CANCEL_REQUESTED'
};
const $947201448b669da2$export$67b2124589a168a0 = {
    RUNNING: 'RUNNING',
    FAILED: 'FAILED',
    COMPLETED: 'COMPLETED',
    NULL: 'NULL'
};
const $947201448b669da2$export$f8975d2c25cd8c82 = {
    LEARN_MORE: 'https://support.atlassian.com/jira-cloud-administration/docs/configure-the-issue-type-hierarchy/',
    CONTACT_SUPPORT: 'https://support.atlassian.com/contact',
    CONFIGURE_ISSUE_TYPE_HIERARCHY: 'https://support.atlassian.com/jira-cloud-administration/docs/configure-the-issue-type-hierarchy/'
};

});


parcelRegister("dCvLw", function(module, exports) {

$parcel$export(module.exports, "insightsBoardSettingsResource", () => $96e234735db19e83$export$527e75c8918894d5);

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $7byHA = parcelRequire("7byHA");
var $JRB5w = parcelRequire("JRB5w");

var $7OWi6 = parcelRequire("7OWi6");

var $D8uHu = parcelRequire("D8uHu");
var $1qlgb = parcelRequire("1qlgb");

var $4fN5I = parcelRequire("4fN5I");

var $aND76 = parcelRequire("aND76");

var $3FyZ4 = parcelRequire("3FyZ4");

var $3HCkE = parcelRequire("3HCkE");

var $1hcN5 = parcelRequire("1hcN5");
const $96e234735db19e83$export$527e75c8918894d5 = (0, $3HCkE.createResource)({
    type: (0, $1hcN5.RESOURCE_TYPE),
    maxAge: (0, $1hcN5.FIVE_MINS_IN_MILLS),
    getKey: ({ match: match })=>`${0, $1hcN5.KEY_PREFIX}-${String(match.params.boardId)}`,
    getData: async ({ match: match })=>{
        const boardId = Number(match.params.boardId);
        if (!Number.isInteger(boardId)) // eslint-disable-next-line @typescript-eslint/no-empty-function
        return new Promise(()=>{});
        const webAnalyticsClient = await (0, $3FyZ4.getAnalyticsWebClientPromise)();
        const actionSubject = `${(0, $1hcN5.insightsSettingsLoaderAnalytics).ACTION_SUBJECT}.${(0, $1hcN5.insightsSettingsLoaderAnalytics).ACTION_SUBJECT_ID}`;
        const analyticsClient = webAnalyticsClient.getInstance();
        if (!analyticsClient) return (0, $aND76.fetchInsightsSettings)({
            boardId: boardId
        }).then((data)=>(0, $4fN5I.withDefaults)(data.context.board.settings));
        analyticsClient.sendOperationalEvent({
            action: 'dataFetch',
            actionSubject: actionSubject,
            source: (0, $1hcN5.ANALYTICS_SOURCE),
            attributes: {
                status: (0, $D8uHu.analyticsStatuses).STARTED,
                boardId: boardId
            }
        });
        const metricsTracker = (0, $7OWi6.trackBrowserMetricsForJira)({
            browserMetricsKey: actionSubject
        });
        try {
            metricsTracker.start();
            const data = await (0, $aND76.fetchInsightsSettings)({
                boardId: boardId
            });
            analyticsClient.sendOperationalEvent({
                action: 'dataFetch',
                actionSubject: actionSubject,
                source: (0, $1hcN5.ANALYTICS_SOURCE),
                attributes: {
                    statusCodeGroup: '2xx',
                    status: (0, $D8uHu.analyticsStatuses).SUCCEEDED,
                    boardId: boardId
                }
            });
            metricsTracker.end();
            return Promise.resolve((0, $4fN5I.withDefaults)(data.context.board.settings));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            metricsTracker.cancel();
            if (!(0, $JRB5w.isClientFetchError)(error)) {
                analyticsClient.sendOperationalEvent({
                    action: 'dataFetch',
                    actionSubject: actionSubject,
                    source: (0, $1hcN5.ANALYTICS_SOURCE),
                    attributes: {
                        statusCodeGroup: (0, $1qlgb.getStatusCodeGroup)(error instanceof (0, $7byHA.default) ? error.statusCode : -1),
                        status: (0, $D8uHu.analyticsStatuses).FAILED,
                        boardId: boardId
                    }
                });
                (0, $gUUjF.default).safeErrorWithoutCustomerData(actionSubject, 'Error fetching insights settings data', error);
                throw error;
            }
            (0, $guiFP.default)({
                meta: {
                    id: actionSubject
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
});

});
parcelRegister("7OWi6", function(module, exports) {

$parcel$export(module.exports, "trackBrowserMetricsForJira", () => $11ad959b7c456982$export$d8b2320f7d41dc1d);

var $lNfG4 = parcelRequire("lNfG4");

var $isy2b = parcelRequire("isy2b");
const $11ad959b7c456982$export$d8b2320f7d41dc1d = ({ browserMetricsKey: browserMetricsKey, attributes: attributes, histogram: // Define bucket sizes for histogram. e.g.: '100_500_1000_2500_5000_10000'. Default to '500_1000_1500_4000_7000'.
histogram })=>{
    if (browserMetricsKey === null || browserMetricsKey === undefined) return {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        start: ()=>{},
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        end: ()=>{},
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        cancel: ()=>{}
    };
    const bm3MetricsTracker = (0, $lNfG4.metrics).interaction({
        key: browserMetricsKey,
        // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string | undefined; }' but required in type 'InteractionHistogramConfig'.
        histogram: {
            result: histogram || (0, $isy2b.DEFAULT_HISTOGRAM_BUCKETS)
        }
    });
    const startHandler = ()=>{
        bm3MetricsTracker.start();
    };
    const endHandler = ()=>{
        bm3MetricsTracker.stop({
            customData: attributes
        });
    };
    const cancelHandler = ()=>{
        bm3MetricsTracker.cancel();
    };
    return {
        start: startHandler,
        end: endHandler,
        cancel: cancelHandler
    };
};

});
parcelRegister("isy2b", function(module, exports) {

$parcel$export(module.exports, "STORE_NAME", () => $f085a1c4ef5efebe$export$cd79d01fb3d2f506);
$parcel$export(module.exports, "experiences", () => $f085a1c4ef5efebe$export$9848ee2a7d21002f);
$parcel$export(module.exports, "TIMEOUT_IN_MS", () => $f085a1c4ef5efebe$export$9ebf97d10ce21f3b);
$parcel$export(module.exports, "DEFAULT_HISTOGRAM_BUCKETS", () => $f085a1c4ef5efebe$export$e3b77a602bc4d0e6);

const $f085a1c4ef5efebe$export$cd79d01fb3d2f506 = `${(0, $3523ef16f82a4788$export$d3996f57ffa8448f)}.experience-tracker-store`;
const $f085a1c4ef5efebe$export$9848ee2a7d21002f = {
    RENDER: 'render'
};
const $f085a1c4ef5efebe$export$9ebf97d10ce21f3b = 7000;
const $f085a1c4ef5efebe$export$e3b77a602bc4d0e6 = '500_1000_1500_4000_7000';

});
const $3523ef16f82a4788$export$d3996f57ffa8448f = 'jira.insights';
const $3523ef16f82a4788$export$c9290acd1ba498ff = `${$3523ef16f82a4788$export$d3996f57ffa8448f}.board`;
const $3523ef16f82a4788$export$2fd6d7f902b01d67 = `${$3523ef16f82a4788$export$d3996f57ffa8448f}.backlog`;
const $3523ef16f82a4788$export$8e66b21ec141a0bd = `${$3523ef16f82a4788$export$d3996f57ffa8448f}.board-simplified`;
const $3523ef16f82a4788$export$75eb9639a5b0ba25 = `${$3523ef16f82a4788$export$d3996f57ffa8448f}.backlog-simplified`;
const $3523ef16f82a4788$export$1269ea4f2b198811 = `${$3523ef16f82a4788$export$d3996f57ffa8448f}.error-boundary`;



parcelRegister("D8uHu", function(module, exports) {

$parcel$export(module.exports, "statusCodeGroups", () => $0d21864ed8a1de20$export$fddea1bcaead87d5);
$parcel$export(module.exports, "analyticsStatuses", () => $0d21864ed8a1de20$export$f0fa81eb65b496a1);
const $0d21864ed8a1de20$export$fddea1bcaead87d5 = {
    INFORMATIONAL_RESPONSES: '1xx',
    SUCCESS_RESPONSES: '2xx',
    REDIRECTS: '3xx',
    CLIENT_ERRORS: '4xx',
    SERVER_ERRORS: '5xx',
    UNKNOWN: 'unknown'
};
const $0d21864ed8a1de20$export$f0fa81eb65b496a1 = {
    SUCCEEDED: 'succeeded',
    FAILED: 'failed',
    ABORTED: 'aborted',
    STARTED: 'started'
};

});

parcelRegister("1qlgb", function(module, exports) {

$parcel$export(module.exports, "getStatusCodeGroup", () => $1a861f837db6f751$export$d14e9b22afc87cb3);
$parcel$export(module.exports, "trackDataFetchAnalytics", () => $1a861f837db6f751$export$bc65acfb4b442c00);

var $guiFP = parcelRequire("guiFP");

var $7byHA = parcelRequire("7byHA");
var $JRB5w = parcelRequire("JRB5w");

var $jMP2a = parcelRequire("jMP2a");

var $D8uHu = parcelRequire("D8uHu");
const $1a861f837db6f751$export$d14e9b22afc87cb3 = (statusCode)=>{
    if (statusCode === null) return (0, $D8uHu.statusCodeGroups).UNKNOWN;
    if (statusCode >= 100 && statusCode <= 199) return (0, $D8uHu.statusCodeGroups).INFORMATIONAL_RESPONSES;
    if (statusCode >= 200 && statusCode <= 299) return (0, $D8uHu.statusCodeGroups).SUCCESS_RESPONSES;
    if (statusCode >= 300 && statusCode <= 399) return (0, $D8uHu.statusCodeGroups).REDIRECTS;
    if (statusCode >= 400 && statusCode <= 499) return (0, $D8uHu.statusCodeGroups).CLIENT_ERRORS;
    if (statusCode >= 500 && statusCode <= 599) return (0, $D8uHu.statusCodeGroups).SERVER_ERRORS;
    return (0, $D8uHu.statusCodeGroups).UNKNOWN;
};
const $1a861f837db6f751$var$includeSample = (sampleRate)=>Math.random() <= 1 / sampleRate;
const $1a861f837db6f751$var$noopAnalytics = Object.freeze({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    start: ()=>{},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    succeeded: ()=>{},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    failed: ()=>{},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    aborted: ()=>{}
});
const $1a861f837db6f751$export$bc65acfb4b442c00 = ({ action: action = 'dataFetch', actionSubject: actionSubject, packageName: packageName, createAnalyticsEvent: createAnalyticsEvent, sampleRate: sampleRate })=>{
    if (actionSubject == null) return $1a861f837db6f751$var$noopAnalytics;
    if (sampleRate != null && !$1a861f837db6f751$var$includeSample(sampleRate)) return $1a861f837db6f751$var$noopAnalytics;
    // Note: Operational analytics do NOT use actionSubjectId!
    const actionSubjectAndAction = `${actionSubject} ${action}`;
    return Object.freeze({
        start: ()=>{
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), actionSubjectAndAction, {
                status: (0, $D8uHu.analyticsStatuses).STARTED,
                packageName: packageName
            });
        },
        succeeded: ()=>{
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), actionSubjectAndAction, {
                statusCodeGroup: '2xx',
                status: (0, $D8uHu.analyticsStatuses).SUCCEEDED,
                packageName: packageName
            });
        },
        failed: (e)=>{
            const error = e !== null && e !== undefined ? e : new Error('Unknown error, e should be present');
            if (!(0, $JRB5w.isClientFetchError)(e)) {
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), actionSubjectAndAction, {
                    statusCodeGroup: $1a861f837db6f751$export$d14e9b22afc87cb3(error instanceof (0, $7byHA.default) ? error.statusCode : -1),
                    status: (0, $D8uHu.analyticsStatuses).FAILED,
                    packageName: packageName
                });
                return;
            }
            // No network connection error
            (0, $guiFP.default)({
                meta: {
                    id: actionSubject,
                    packageName: packageName
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        },
        aborted: ()=>{
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), actionSubjectAndAction, {
                status: (0, $D8uHu.analyticsStatuses).ABORTED,
                packageName: packageName
            });
        }
    });
};

});

parcelRegister("4fN5I", function(module, exports) {

$parcel$export(module.exports, "withDefaults", () => $076c5cff5d9f9d8b$export$4df9c0969a9e0160);

var $2pKbZ = parcelRequire("2pKbZ");
const $076c5cff5d9f9d8b$var$insightsSettingsDefaultsKeys = Object.keys((0, $2pKbZ.insightsSettingsDefaults));
const $076c5cff5d9f9d8b$export$4df9c0969a9e0160 = (settings)=>{
    const insightKeys = [
        ...Object.keys(settings),
        ...$076c5cff5d9f9d8b$var$insightsSettingsDefaultsKeys
    ];
    const uniqueKeys = [
        ...new Set(insightKeys)
    ];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const merged = uniqueKeys.reduce((result, key)=>{
        /* eslint-disable no-param-reassign */ // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'BoardInsightsSettingsResponse | Partial<Diff<BoardInsightsSettings, Record<any, any>>>'.
        result[key] = {
            ...(0, $2pKbZ.insightsSettingsDefaults)[key],
            ...settings[key]
        };
        /* eslint-enable no-param-reassign */ return result;
    }, {});
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return merged;
};

});
parcelRegister("2pKbZ", function(module, exports) {

$parcel$export(module.exports, "INSIGHTS_SETTINGS_ANALYTICS", () => $69396c33c096e9cc$export$c9b681bb814b8d21);
$parcel$export(module.exports, "INSIGHTS_SETTINGS_UPDATE_SUCCESS_FLAG_ID", () => $69396c33c096e9cc$export$f9fa93046ad61876);
$parcel$export(module.exports, "INSIGHTS_SETTINGS_UPDATE_ERROR_FLAG_ID", () => $69396c33c096e9cc$export$b9dc3d9b5ea30bf1);
$parcel$export(module.exports, "insightsSettingsLoaderAnalytics", () => $69396c33c096e9cc$export$4cefda6d846a04d4);
$parcel$export(module.exports, "insightsSettingsDefaults", () => $69396c33c096e9cc$export$a4afea03fa81b43c);
$parcel$export(module.exports, "BACKLOG_LOCATION", () => $69396c33c096e9cc$export$bdfa779dd9b3cf14);
$parcel$export(module.exports, "BOARD_LOCATION", () => $69396c33c096e9cc$export$d0dc0955ed2af099);
$parcel$export(module.exports, "hasBoardAdminPermissionAnalytics", () => $69396c33c096e9cc$export$e441e25a172c7483);
$parcel$export(module.exports, "GET_SETTINGS_ENDPOINT_TIMEOUT_WHEN_INSIGHTS_LOADING", () => $69396c33c096e9cc$export$3176caa73e046722);

var $fjTax = parcelRequire("fjTax");
var $52hWf = parcelRequire("52hWf");
var $jCgYJ = parcelRequire("jCgYJ");
var $1keuD = parcelRequire("1keuD");
var $dS37D = parcelRequire("dS37D");
var $ftkhh = parcelRequire("ftkhh");

const $69396c33c096e9cc$export$c9b681bb814b8d21 = `${(0, $3523ef16f82a4788$export$d3996f57ffa8448f)}.settings`;
const $69396c33c096e9cc$export$f9fa93046ad61876 = `${(0, $3523ef16f82a4788$export$d3996f57ffa8448f)}.settings.update-flag.success`;
const $69396c33c096e9cc$export$b9dc3d9b5ea30bf1 = `${(0, $3523ef16f82a4788$export$d3996f57ffa8448f)}.settings.update-flag.error`;
const $69396c33c096e9cc$export$4cefda6d846a04d4 = {
    ACTION_SUBJECT: $69396c33c096e9cc$export$c9b681bb814b8d21,
    ACTION_SUBJECT_ID: 'get-settings'
};
const $69396c33c096e9cc$export$a4afea03fa81b43c = {
    [(0, $dS37D.SPRINT_COMMITMENT_BEACON_ID)]: (0, $dS37D.SPRINT_COMMITMENT_SETTINGS_DEFAULTS),
    [(0, $jCgYJ.ISSUE_TYPE_WORKLOAD_BEACON_ID)]: (0, $jCgYJ.ISSUE_TYPE_WORKLOAD_SETTINGS_DEFAULTS),
    [(0, $fjTax.BURNDOWN_BEACON_ID)]: (0, $fjTax.BURNDOWN_SETTINGS_DEFAULTS),
    [(0, $ftkhh.SPRINT_PROGRESS_BEACON_ID)]: (0, $ftkhh.SPRINT_PROGRESS_SETTINGS_DEFAULTS),
    [(0, $52hWf.EPIC_PROGRESS_BEACON_ID)]: (0, $52hWf.EPIC_PROGRESS_SETTINGS_DEFAULTS),
    [(0, $1keuD.ISSUES_FOR_ATTENTION_BEACON_ID)]: (0, $1keuD.ISSUES_FOR_ATTENTION_SETTINGS_DEFAULTS)
};
const $69396c33c096e9cc$export$bdfa779dd9b3cf14 = 'backlog';
const $69396c33c096e9cc$export$d0dc0955ed2af099 = 'board';
const $69396c33c096e9cc$export$e441e25a172c7483 = {
    ACTION_SUBJECT: $69396c33c096e9cc$export$c9b681bb814b8d21,
    ACTION_SUBJECT_ID: 'board-admin'
};
const $69396c33c096e9cc$export$3176caa73e046722 = 10000;

});
parcelRegister("fjTax", function(module, exports) {

$parcel$export(module.exports, "BURNDOWN_BEACON_ID", () => $7876d445ed2891c7$export$b2ed7cef94c6827a);
$parcel$export(module.exports, "BURNDOWN_SETTINGS_DEFAULTS", () => $7876d445ed2891c7$export$5d0b256a08333f73);
const $7876d445ed2891c7$export$b2ed7cef94c6827a = 'burndown';
const $7876d445ed2891c7$export$5d0b256a08333f73 = {
    hidden: false
};

});

parcelRegister("52hWf", function(module, exports) {

$parcel$export(module.exports, "EPIC_PROGRESS_BEACON_ID", () => $81493a83752aa6c6$export$afa5ec1deda5d045);
$parcel$export(module.exports, "EPIC_PROGRESS_SETTINGS_DEFAULTS", () => $81493a83752aa6c6$export$bd0bec9335b40176);
const $81493a83752aa6c6$export$afa5ec1deda5d045 = 'epic-progress';
const $81493a83752aa6c6$export$bd0bec9335b40176 = {
    hidden: false
};

});

parcelRegister("jCgYJ", function(module, exports) {

$parcel$export(module.exports, "ISSUE_TYPE_WORKLOAD_BEACON_ID", () => $a6a0cbb5163f250a$export$d09e320e96d42c8);
$parcel$export(module.exports, "ISSUE_TYPE_WORKLOAD_SETTINGS_DEFAULTS", () => $a6a0cbb5163f250a$export$efccdab5672702c8);
const $a6a0cbb5163f250a$export$d09e320e96d42c8 = 'issue-type-workload';
const $a6a0cbb5163f250a$export$efccdab5672702c8 = {
    hidden: false
};

});

parcelRegister("1keuD", function(module, exports) {

$parcel$export(module.exports, "ISSUES_FOR_ATTENTION_BEACON_ID", () => $4545d5bbd9df0ef8$export$520574b6e5f9d64a);
$parcel$export(module.exports, "ISSUES_FOR_ATTENTION_SETTINGS_DEFAULTS", () => $4545d5bbd9df0ef8$export$36b8eb4d5050cbb6);
const $4545d5bbd9df0ef8$export$520574b6e5f9d64a = 'issues-for-attention';
const $4545d5bbd9df0ef8$export$36b8eb4d5050cbb6 = {
    hidden: false
};

});

parcelRegister("dS37D", function(module, exports) {

$parcel$export(module.exports, "SPRINT_COMMITMENT_BEACON_ID", () => $dd3561373673102b$export$d52c62a328b63990);
$parcel$export(module.exports, "SPRINT_COMMITMENT_SETTINGS_DEFAULTS", () => $dd3561373673102b$export$b361fc55b75ed5af);
const $dd3561373673102b$export$d52c62a328b63990 = 'sprint-commitment';
const $dd3561373673102b$export$b361fc55b75ed5af = {
    hidden: false
};

});

parcelRegister("ftkhh", function(module, exports) {

$parcel$export(module.exports, "SPRINT_PROGRESS_BEACON_ID", () => $d690dd124fce9824$export$ac6fe62b1e8a0a52);
$parcel$export(module.exports, "SPRINT_PROGRESS_SETTINGS_DEFAULTS", () => $d690dd124fce9824$export$9f1a147e443d188);
const $d690dd124fce9824$export$ac6fe62b1e8a0a52 = 'sprint-progress';
const $d690dd124fce9824$export$9f1a147e443d188 = {
    hidden: false
};

});



parcelRegister("aND76", function(module, exports) {

$parcel$export(module.exports, "fetchInsightsSettings", () => $a9eed9dd911a5eb8$export$1b3686b537bacb54);

var $8gjGw = parcelRequire("8gjGw");
const $a9eed9dd911a5eb8$export$1b3686b537bacb54 = async ({ boardId: boardId }, options)=>(0, $8gjGw.fetchJson)(`/gateway/api/jira-insights/settings/board/${boardId}`, options);

});
parcelRegister("8gjGw", function(module, exports) {

$parcel$export(module.exports, "fetchJson", () => $63986de7e8960fb5$export$6d71b655afe1638d);

var $2OdyW = parcelRequire("2OdyW");

var $2otYT = parcelRequire("2otYT");
const $63986de7e8960fb5$export$6d71b655afe1638d = async (url, options = {})=>(0, $2OdyW.default)(url, options).catch((error)=>{
        throw new (0, $2otYT.FetchUrlError)(url, error);
    });

});
parcelRegister("2otYT", function(module, exports) {

$parcel$export(module.exports, "FetchUrlError", () => $b1b20faaa84f8ec8$export$5cdfc90b27d7ab6c);

var $7byHA = parcelRequire("7byHA");
var $JRB5w = parcelRequire("JRB5w");

var $7byHA = parcelRequire("7byHA");

var $9Anw5 = parcelRequire("9Anw5");

var $7L7ae = parcelRequire("7L7ae");
const $b1b20faaa84f8ec8$var$getStatusCodeGroup = (statusCode)=>{
    if (statusCode === null) return (0, $7L7ae.statusCodeGroups).UNKNOWN;
    if (statusCode >= 100 && statusCode <= 199) return (0, $7L7ae.statusCodeGroups).INFORMATIONAL_RESPONSES;
    if (statusCode >= 200 && statusCode <= 299) return (0, $7L7ae.statusCodeGroups).SUCCESS_RESPONSES;
    if (statusCode >= 300 && statusCode <= 399) return (0, $7L7ae.statusCodeGroups).REDIRECTS;
    if (statusCode >= 400 && statusCode <= 499) return (0, $7L7ae.statusCodeGroups).CLIENT_ERRORS;
    if (statusCode >= 500 && statusCode <= 599) return (0, $7L7ae.statusCodeGroups).SERVER_ERRORS;
    return (0, $7L7ae.statusCodeGroups).UNKNOWN;
};
const $b1b20faaa84f8ec8$var$stringifySafe = (obj)=>{
    try {
        return JSON.stringify(obj);
    } catch  {
        return null;
    }
};
class $b1b20faaa84f8ec8$export$5cdfc90b27d7ab6c extends (0, $7byHA.default) {
    constructor(url, fetchError){
        if (fetchError instanceof (0, $7byHA.default)) super(fetchError.statusCode, fetchError.message, fetchError.traceId);
        else super(-1, fetchError.message);
        this.name = 'FetchUrlError';
        this.url = (0, $9Anw5.default)(url);
        this.aborted = fetchError.name === (0, $7byHA.ABORT_ERROR_NAME);
        this.isClientError = (0, $JRB5w.isClientFetchError)(fetchError) || this.statusCode === -1;
        this.statusCodeGroup = $b1b20faaa84f8ec8$var$getStatusCodeGroup(fetchError instanceof (0, $7byHA.default) ? fetchError.statusCode : null);
        // NOTE: logging does not support nested objects!
        this.cause = $b1b20faaa84f8ec8$var$stringifySafe(fetchError);
    }
}

});
parcelRegister("7L7ae", function(module, exports) {

$parcel$export(module.exports, "statusCodeGroups", () => $71f26b6747cd60d2$export$fddea1bcaead87d5);
const $71f26b6747cd60d2$export$fddea1bcaead87d5 = {
    INFORMATIONAL_RESPONSES: '1xx',
    SUCCESS_RESPONSES: '2xx',
    REDIRECTS: '3xx',
    CLIENT_ERRORS: '4xx',
    SERVER_ERRORS: '5xx',
    UNKNOWN: 'unknown'
};

});




parcelRegister("1hcN5", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE", () => $29545433a695bd7a$export$6f0555de4f60e84e);
$parcel$export(module.exports, "KEY_PREFIX", () => $29545433a695bd7a$export$711117ad6ad27992);
$parcel$export(module.exports, "insightsSettingsLoaderAnalytics", () => $29545433a695bd7a$export$4cefda6d846a04d4);
$parcel$export(module.exports, "ANALYTICS_SOURCE", () => $29545433a695bd7a$export$f7109619a5e9e0d6);
$parcel$export(module.exports, "FIVE_MINS_IN_MILLS", () => $29545433a695bd7a$export$9f0c88673545153a);

var $2pKbZ = parcelRequire("2pKbZ");
const $29545433a695bd7a$export$6f0555de4f60e84e = 'INSIGHT_SETTINGS_RESOURCE_TYPE';
const $29545433a695bd7a$export$711117ad6ad27992 = 'INSIGHT_SETTINGS_BOARD';
const $29545433a695bd7a$export$4cefda6d846a04d4 = {
    ACTION_SUBJECT: (0, $2pKbZ.INSIGHTS_SETTINGS_ANALYTICS),
    ACTION_SUBJECT_ID: 'get-settings'
};
const $29545433a695bd7a$export$f7109619a5e9e0d6 = 'insightsBoardSettingsScreen';
const $29545433a695bd7a$export$9f0c88673545153a = 300000;

});


parcelRegister("7msR2", function(module, exports) {

$parcel$export(module.exports, "NextGenBacklogSkeleton", () => $6f15cd0ce78d5d9a$export$33cd465913cf178f);

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");

var $auCHw = parcelRequire("auCHw");
const $6f15cd0ce78d5d9a$export$33cd465913cf178f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($auCHw)))
    });

});
parcelRegister("auCHw", function(module, exports) {
module.exports = new URL("next-gen-backlog-app-skeleton.tpl.28e29051.svg", import.meta.url).toString();

});


parcelRegister("kth1i", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('bqk09')
        ]);
        const value = parcelRequire('gSV7c');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("bqk09")
    ]).then(()=>parcelRequire('gSV7c'));
}

});

parcelRegister("ezjOd", function(module, exports) {

$parcel$export(module.exports, "deploymentPreconditionRelayResource", () => $2cde8cce0318a4d6$export$50e4eedb9e6127c8);

var $buJlM = parcelRequire("buJlM");

var $eqwtX = parcelRequire("eqwtX");

var $3HCkE = parcelRequire("3HCkE");


const $2cde8cce0318a4d6$export$a1c09d7f7318f85c = (0, $3HCkE.createResource)({
    type: (0, $234d9f72f46eb994$export$2171160371fac588),
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("6X8W9")),
    maxAge: 60000
});
const $2cde8cce0318a4d6$export$50e4eedb9e6127c8 = (0, $buJlM.createRelayResource)({
    type: (0, $234d9f72f46eb994$export$a969d0487e348031),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $eqwtX.default),
            variables: {
                cloudId: tenantContext.cloudId,
                projectKey: String(match.params.projectKey)
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("eqwtX", function(module, exports) {

$parcel$export(module.exports, "default", () => $886e04029501ef9c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<946bfee09c64f3e6ddd3c9cbab07a461>>
 * @relayHash ea273678a5c985c0053babf0f185662a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0b497951b118068d82bb77e253f1fcb758c4dde1aa7f8eb01bf559f5961522f2
const $886e04029501ef9c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }
    ], v1 = {
        "args": [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "projectKey",
                "variableName": "projectKey"
            }
        ],
        "kind": "ScalarField",
        "name": "deploymentsFeaturePreconditionByProjectKey"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "uiDeploymentsFeaturePreconditionQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v1 /*: any*/ ,
                                "action": "THROW",
                                "path": "jira.deploymentsFeaturePreconditionByProjectKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "uiDeploymentsFeaturePreconditionQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "0b497951b118068d82bb77e253f1fcb758c4dde1aa7f8eb01bf559f5961522f2",
            "metadata": {},
            "name": "uiDeploymentsFeaturePreconditionQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$886e04029501ef9c$var$node.hash = "3337e3d6b76da02b643c63aacd15b239";
var $886e04029501ef9c$export$2e2bcd8739ae039 = $886e04029501ef9c$var$node;

});

const $234d9f72f46eb994$export$2171160371fac588 = 'SOFTWARE_DEPLOYMENTS_PRECONDITION';
const $234d9f72f46eb994$export$a969d0487e348031 = 'SOFTWARE_DEPLOYMENTS_PRECONDITION_RELAY';

parcelRegister("6X8W9", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('aQcUz');
        const value = parcelRequire('7Qtbv');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("aQcUz").then(()=>parcelRequire('7Qtbv'));
}

});


parcelRegister("yyqSx", function(module, exports) {

$parcel$export(module.exports, "isDevopsFeatureDisabledInFedRamp", () => $d7ad054dfd872773$export$18bfef4995ec57b7);

var $dfBCt = parcelRequire("dfBCt");

var $6goyu = parcelRequire("6goyu");
const $d7ad054dfd872773$export$18bfef4995ec57b7 = ()=>(0, $6goyu.isDisableDevopsFeaturesInFedRampEnvEnabled)() && (0, $dfBCt.isFedRamp)();

});
parcelRegister("6goyu", function(module, exports) {

$parcel$export(module.exports, "isDisableDevopsFeaturesInFedRampEnvEnabled", () => $0bb8681ee65fdabd$export$a803c452d83c73b6);
/**
 * Feature flags convention: go/frontend-feature-flags
 */ 
var $1ybV0 = parcelRequire("1ybV0");
const $0bb8681ee65fdabd$export$a803c452d83c73b6 = ()=>(0, $1ybV0.ff)('core-x-fedramp-m1-disable-devops-features_ag5zy');

});


parcelRegister("gA4Ar", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('go06p')
        ]);
        const value = parcelRequire('actEI');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("go06p")
    ]).then(()=>parcelRequire('actEI'));
}

});

parcelRegister("iHeQd", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $c0131ee3b9f66913$export$8f31e4c4a37b8e9c);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hdmGS = parcelRequire("hdmGS");

var $f1zAm = parcelRequire("f1zAm");
const $c0131ee3b9f66913$export$8f31e4c4a37b8e9c = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $c0131ee3b9f66913$var$SpinnerContainerStyles,
        "data-testId": "software-periscope-periscope-page.ui.loading",
        "aria-label": formatMessage((0, $f1zAm.default).labelNonFinal),
        padding: "space.500"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hdmGS.PeriscopePageSkeleton), null));
};
const $c0131ee3b9f66913$var$SpinnerContainerStyles = (0, $1ZAYh.xcss)({
    width: '100%',
    height: '100%',
    boxSizing: 'border-box'
});

});
parcelRegister("hdmGS", function(module, exports) {

$parcel$export(module.exports, "PeriscopePageSkeleton", () => $5cfbc0a039f0309c$export$4aecc030c4d69f74);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");

var $dzNVZ = parcelRequire("dzNVZ");
const $5cfbc0a039f0309c$var$PeriscopePageSkeletonStyles = null;
const $5cfbc0a039f0309c$export$4aecc030c4d69f74 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "skeletons.ui.periscope-page.app-skeleton-image-periscope-page",
        className: (0, $7JEyt.default)([
            "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dzNVZ)))
    }));

});
parcelRegister("dzNVZ", function(module, exports) {
module.exports = new URL("periscope-page.tpl.96086563.svg", import.meta.url).toString();

});


parcelRegister("f1zAm", function(module, exports) {

$parcel$export(module.exports, "default", () => $93521ef7c0ce60b1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $93521ef7c0ce60b1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    labelNonFinal: {
        "id": "periscope.skeleton.label-non-final",
        "defaultMessage": "Loading"
    }
});

});


parcelRegister("98h24", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('LV3yE');
        const value = parcelRequire('iIPAF');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("LV3yE").then(()=>parcelRequire('iIPAF'));
}

});

parcelRegister("2ijRB", function(module, exports) {

$parcel$export(module.exports, "default", () => $63c0d8b469289537$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var /**
 * @deprecated this does not support useRef and is being moved into a new package.
 * Use @atlassian/jira-feature-flagging-utils and componentWithCondition instead.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$63c0d8b469289537$export$2e2bcd8739ae039 = (conditionGetter, ComponentTrue, ComponentFalse)=>{
    const ComponentWithCondition = (props)=>// @ts-expect-error - TS2322 - Type 'P' is not assignable to type 'IntrinsicAttributes & PropsWithoutRef<P> & RefAttributes<any> & { children?: ReactNode; }'. | TS2322 - Type 'P' is not assignable to type 'IntrinsicAttributes & PropsWithoutRef<P> & RefAttributes<any> & { children?: ReactNode; }'.
        conditionGetter() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComponentTrue, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComponentFalse, props);
    if (conditionGetter.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${conditionGetter.name}]`;
    // @ts-expect-error - TS2322 - Type '{ (props: P): JSX.Element; displayName: string; }' is not assignable to type 'AbstractComponent<P, any>'.
    return ComponentWithCondition;
};

});

parcelRegister("drG7D", function(module, exports) {

$parcel$export(module.exports, "securityPageResource", () => $53fc164e796e61ca$export$2c5e3c161b8fe98);

var $exb0h = parcelRequire("exb0h");

var $1ybV0 = parcelRequire("1ybV0");

var $huI7r = parcelRequire("huI7r");

var $buJlM = parcelRequire("buJlM");

var $FkKOk = parcelRequire("FkKOk");

var $fb9lE = parcelRequire("fb9lE");

const $53fc164e796e61ca$var$getNumberOfVulnerabilitiesToFetch = ()=>Number((0, $1ybV0.getFeatureFlagValue)('open-toolchain-core-x-isotopes-security-in-jira-vulnerabilities-count', 100));
const $53fc164e796e61ca$var$getNumberOfSecurityContainersToFetch = ()=>Number((0, $1ybV0.getFeatureFlagValue)('otc-core-x-isotopes-security-in-jira-max-container-count', 100));
let $53fc164e796e61ca$var$filters;
const $53fc164e796e61ca$export$2c5e3c161b8fe98 = (0, $buJlM.createRelayResource)({
    type: (0, $17300ee0074ba903$export$f24db22c3c834cb1),
    getQuery ({ match: { params: params }, query: query, route: { name: name } }, { tenantContext: { cloudId: cloudId, activationId: activationId } }) {
        const isSecRoute = name === (0, $exb0h.ROUTE_NAMES).SOFTWARE_SECURITY || name === (0, $exb0h.ROUTE_NAMES).SOFTWARE_SECURITY_CLASSIC;
        // Set filters on initial call only and not on every query param change
        if (!$53fc164e796e61ca$var$filters && isSecRoute) {
            const connectionAri = (0, $huI7r.createAri)({
                resourceOwner: 'jira',
                resourceType: 'security-container',
                cloudId: cloudId,
                activationId: activationId,
                resourceId: ''
            });
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            $53fc164e796e61ca$var$filters = (0, $fb9lE.getGqlFiltersFromQueryParams)(query, connectionAri);
        }
        // Reset filters when navigating away from the security page
        if (!isSecRoute) $53fc164e796e61ca$var$filters = undefined;
        return {
            parameters: (0, $FkKOk.default),
            options: {
                fetchPolicy: 'store-and-network'
            },
            variables: {
                cloudAri: (0, $huI7r.createAri)({
                    resourceOwner: 'jira',
                    resourceType: 'site',
                    resourceId: cloudId
                }),
                cloudId: cloudId,
                projectKey: params.projectKey ?? '',
                numberOfVulnsToFetch: $53fc164e796e61ca$var$getNumberOfVulnerabilitiesToFetch(),
                getContainers: false,
                numberOfContainersToFetch: $53fc164e796e61ca$var$getNumberOfSecurityContainersToFetch(),
                filter: $53fc164e796e61ca$var$filters
            }
        };
    }
});

});
parcelRegister("FkKOk", function(module, exports) {

$parcel$export(module.exports, "default", () => $897a53634fdc58c5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3b35e503bbc323d2d3ecfbb74bbd289d>>
 * @relayHash 2827aa231cab3e49f67ea40510e452a3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a1a80f3ccfe8934408165144c558b877d997fe187322dd28b0da2044aa214fed
const $897a53634fdc58c5$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "getContainers"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "numberOfContainersToFetch"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "numberOfVulnsToFetch"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v8 = {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
    }, v9 = {
        "kind": "ScalarField",
        "name": "totalLinkedSecurityContainerCount"
    }, v10 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "numberOfContainersToFetch"
        }
    ], v11 = {
        "kind": "ScalarField",
        "name": "providerId"
    }, v12 = [
        v11 /*: any*/ 
    ], v13 = {
        "kind": "InlineFragment",
        "selections": v12 /*: any*/ ,
        "type": "ThirdPartySecurityContainer"
    }, v14 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v15 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "numberOfVulnsToFetch"
    }, v16 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": {
                "and": {
                    "lastUpdated": {
                        "sort": {
                            "order": "ASC",
                            "priority": 1
                        }
                    }
                }
            }
        },
        v15 /*: any*/ 
    ], v17 = {
        "kind": "ScalarField",
        "name": "id"
    }, v18 = {
        "kind": "ScalarField",
        "name": "name"
    }, v19 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v20 = {
        "concreteType": "DevOps",
        "kind": "LinkedField",
        "name": "devOps",
        "plural": false,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "id",
                        "variableName": "cloudAri"
                    },
                    {
                        "kind": "Literal",
                        "name": "providerTypes",
                        "value": [
                            "SECURITY"
                        ]
                    }
                ],
                "concreteType": "DevOpsProviders",
                "kind": "LinkedField",
                "name": "providers",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "DevOpsSecurityProvider",
                        "kind": "LinkedField",
                        "name": "securityProviders",
                        "plural": true,
                        "selections": [
                            v17 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "appInstallationId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "logoUrl"
                            },
                            v18 /*: any*/ ,
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 100
                                    }
                                ],
                                "concreteType": "AriGraphRelationshipConnection",
                                "kind": "LinkedField",
                                "name": "linkedWorkspaces",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "AriGraphRelationship",
                                        "kind": "LinkedField",
                                        "name": "nodes",
                                        "plural": true,
                                        "selections": [
                                            v19 /*: any*/ 
                                        ]
                                    }
                                ],
                                "storageKey": "linkedWorkspaces(first:100)"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v21 = [
        v17 /*: any*/ 
    ], v22 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v23 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "ConfluencePage"
    }, v24 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "ConfluenceSpace"
    }, v25 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsFeatureFlag"
    }, v26 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsOperationsComponentDetails"
    }, v27 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsOperationsIncidentDetails"
    }, v28 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsOperationsPostIncidentReviewDetails"
    }, v29 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsPullRequestDetails"
    }, v30 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsRepository"
    }, v31 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "DevOpsSecurityVulnerabilityDetails"
    }, v32 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "JiraConfluenceRemoteIssueLink"
    }, v33 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "JiraCustomRemoteIssueLink"
    }, v34 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "JiraIssueRemoteIssueLink"
    }, v35 = {
        "kind": "InlineFragment",
        "selections": v21 /*: any*/ ,
        "type": "JiraWebRemoteIssueLink"
    }, v36 = [
        v8 /*: any*/ ,
        v15 /*: any*/ 
    ], v37 = {
        "kind": "ScalarField",
        "name": "url"
    }, v38 = {
        "kind": "ScalarField",
        "name": "key"
    }, v39 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v40 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainSecurityInJiraQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v7 /*: any*/ ,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProjectByKey",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": [
                                            v8 /*: any*/ ,
                                            {
                                                "kind": "Variable",
                                                "name": "getContainers",
                                                "variableName": "getContainers"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "numberOfContainersToFetch",
                                                "variableName": "numberOfContainersToFetch"
                                            }
                                        ],
                                        "kind": "FragmentSpread",
                                        "name": "main_softwareSecurityPage_MainPage"
                                    },
                                    v9 /*: any*/ ,
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v10 /*: any*/ ,
                                            "concreteType": "AriGraphRelationshipConnection",
                                            "kind": "LinkedField",
                                            "name": "linkedSecurityContainers",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "AriGraphRelationshipEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AriGraphRelationship",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "AriGraphRelationshipNode",
                                                                    "kind": "LinkedField",
                                                                    "name": "to",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "condition": "getContainers",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "data",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v13 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v14 /*: any*/ 
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.jiraProjectByKey.linkedSecurityContainers"
                                    },
                                    {
                                        "alias": "linkedVulnsForAnalytics",
                                        "args": v16 /*: any*/ ,
                                        "concreteType": "GraphJiraVulnerabilityConnection",
                                        "kind": "LinkedField",
                                        "name": "linkedSecurityVulnerabilitiesByProject",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "GraphJiraVulnerabilityEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "GraphJiraVulnerability",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "condition": "getContainers",
                                                                "kind": "Condition",
                                                                "passingValue": true,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                                        "kind": "LinkedField",
                                                                        "name": "vulnerability",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "ThirdPartySecurityContainer",
                                                                                "kind": "LinkedField",
                                                                                "name": "securityContainer",
                                                                                "plural": false,
                                                                                "selections": v12 /*: any*/ 
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.jiraProjectByKey"
                        }
                    ]
                },
                v20 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v6 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainSecurityInJiraQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                v17 /*: any*/ ,
                                {
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "AriGraphRelationshipConnection",
                                    "kind": "LinkedField",
                                    "name": "linkedSecurityContainers",
                                    "plural": false,
                                    "selections": [
                                        v14 /*: any*/ ,
                                        {
                                            "concreteType": "AriGraphRelationshipEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "AriGraphRelationship",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AriGraphRelationshipNode",
                                                            "kind": "LinkedField",
                                                            "name": "to",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "condition": "getContainers",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "data",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v19 /*: any*/ ,
                                                                                v13 /*: any*/ ,
                                                                                v22 /*: any*/ ,
                                                                                v23 /*: any*/ ,
                                                                                v24 /*: any*/ ,
                                                                                v25 /*: any*/ ,
                                                                                v26 /*: any*/ ,
                                                                                v27 /*: any*/ ,
                                                                                v28 /*: any*/ ,
                                                                                v29 /*: any*/ ,
                                                                                v30 /*: any*/ ,
                                                                                v31 /*: any*/ ,
                                                                                v32 /*: any*/ ,
                                                                                v33 /*: any*/ ,
                                                                                v34 /*: any*/ ,
                                                                                v35 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v17 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": [
                                        v8 /*: any*/ 
                                    ],
                                    "kind": "ScalarField",
                                    "name": "totalLinkedSecurityVulnerabilityCount"
                                },
                                {
                                    "args": v36 /*: any*/ ,
                                    "concreteType": "GraphJiraVulnerabilityConnection",
                                    "kind": "LinkedField",
                                    "name": "linkedSecurityVulnerabilitiesByProject",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphJiraVulnerabilityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "GraphJiraVulnerability",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                            "kind": "LinkedField",
                                                            "name": "vulnerability",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "title"
                                                                },
                                                                {
                                                                    "condition": "getContainers",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ThirdPartySecurityContainer",
                                                                            "kind": "LinkedField",
                                                                            "name": "securityContainer",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v17 /*: any*/ ,
                                                                                v18 /*: any*/ ,
                                                                                v37 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "DevOpsSecurityVulnerabilityIdentifier",
                                                                    "kind": "LinkedField",
                                                                    "name": "identifiers",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "displayName"
                                                                        },
                                                                        v37 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "DevOpsSecurityVulnerabilityAdditionalInfo",
                                                                    "kind": "LinkedField",
                                                                    "name": "additionalInfo",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "content"
                                                                        },
                                                                        v37 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "status"
                                                                },
                                                                {
                                                                    "concreteType": "AriGraphRelationshipConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "linkedJiraIssues",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "AriGraphRelationship",
                                                                            "kind": "LinkedField",
                                                                            "name": "nodes",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "AriGraphRelationshipNode",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "to",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v17 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "data",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v19 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": [
                                                                                                                {
                                                                                                                    "kind": "Literal",
                                                                                                                    "name": "idsOrAliases",
                                                                                                                    "value": [
                                                                                                                        "summary",
                                                                                                                        "assignee",
                                                                                                                        "status",
                                                                                                                        "issuetype"
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fieldsByIdOrAlias",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                v19 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraStatus",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "status",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                v17 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "statusCategory",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v38 /*: any*/ ,
                                                                                                                                        v17 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraStatusField"
                                                                                                                },
                                                                                                                v17 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "fieldId"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "text"
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "user",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v19 /*: any*/ ,
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "picture"
                                                                                                                                },
                                                                                                                                v17 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueType",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraAvatar",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "avatar",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "small"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v17 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraIssueTypeField"
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "issueId"
                                                                                                        },
                                                                                                        v38 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "webUrl"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssue"
                                                                                                },
                                                                                                v22 /*: any*/ ,
                                                                                                v23 /*: any*/ ,
                                                                                                v24 /*: any*/ ,
                                                                                                v25 /*: any*/ ,
                                                                                                v26 /*: any*/ ,
                                                                                                v27 /*: any*/ ,
                                                                                                v28 /*: any*/ ,
                                                                                                v29 /*: any*/ ,
                                                                                                v30 /*: any*/ ,
                                                                                                v31 /*: any*/ ,
                                                                                                v32 /*: any*/ ,
                                                                                                v33 /*: any*/ ,
                                                                                                v34 /*: any*/ ,
                                                                                                v35 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v14 /*: any*/ 
                                                                    ]
                                                                },
                                                                v17 /*: any*/ ,
                                                                v37 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "introducedDate"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "providerVulnerabilityId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "securityContainerId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "severity"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "description"
                                                                }
                                                            ]
                                                        },
                                                        v17 /*: any*/ ,
                                                        v19 /*: any*/ 
                                                    ]
                                                },
                                                v39 /*: any*/ 
                                            ]
                                        },
                                        v40 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v36 /*: any*/ ,
                                    "filters": [
                                        "filter"
                                    ],
                                    "handle": "connection",
                                    "key": "security__linkedSecurityVulnerabilitiesByProject",
                                    "kind": "LinkedHandle",
                                    "name": "linkedSecurityVulnerabilitiesByProject"
                                },
                                {
                                    "alias": "projectHaveVulnerabilityCheck",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 1
                                        }
                                    ],
                                    "concreteType": "GraphJiraVulnerabilityConnection",
                                    "kind": "LinkedField",
                                    "name": "linkedSecurityVulnerabilitiesByProject",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphJiraVulnerabilityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "GraphJiraVulnerability",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                            "kind": "LinkedField",
                                                            "name": "vulnerability",
                                                            "plural": false,
                                                            "selections": [
                                                                v19 /*: any*/ ,
                                                                v17 /*: any*/ 
                                                            ]
                                                        },
                                                        v17 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "linkedSecurityVulnerabilitiesByProject(first:1)"
                                },
                                {
                                    "alias": "linkedVulnsForAnalytics",
                                    "args": v16 /*: any*/ ,
                                    "concreteType": "GraphJiraVulnerabilityConnection",
                                    "kind": "LinkedField",
                                    "name": "linkedSecurityVulnerabilitiesByProject",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphJiraVulnerabilityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "GraphJiraVulnerability",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "condition": "getContainers",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                                    "kind": "LinkedField",
                                                                    "name": "vulnerability",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ThirdPartySecurityContainer",
                                                                            "kind": "LinkedField",
                                                                            "name": "securityContainer",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v11 /*: any*/ ,
                                                                                v17 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v17 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v17 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "getContainers",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": v10 /*: any*/ ,
                                            "concreteType": "AriGraphRelationshipConnection",
                                            "kind": "LinkedField",
                                            "name": "linkedSecurityContainers",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "AriGraphRelationshipEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AriGraphRelationship",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "AriGraphRelationshipNode",
                                                                    "kind": "LinkedField",
                                                                    "name": "to",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "data",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v19 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v18 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "icon"
                                                                                        },
                                                                                        v37 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "providerName"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "lastUpdated"
                                                                                        },
                                                                                        v14 /*: any*/ ,
                                                                                        v17 /*: any*/ 
                                                                                    ],
                                                                                    "type": "ThirdPartySecurityContainer"
                                                                                },
                                                                                v22 /*: any*/ ,
                                                                                v23 /*: any*/ ,
                                                                                v24 /*: any*/ ,
                                                                                v25 /*: any*/ ,
                                                                                v26 /*: any*/ ,
                                                                                v27 /*: any*/ ,
                                                                                v28 /*: any*/ ,
                                                                                v29 /*: any*/ ,
                                                                                v30 /*: any*/ ,
                                                                                v31 /*: any*/ ,
                                                                                v32 /*: any*/ ,
                                                                                v33 /*: any*/ ,
                                                                                v34 /*: any*/ ,
                                                                                v35 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v19 /*: any*/ 
                                                            ]
                                                        },
                                                        v39 /*: any*/ 
                                                    ]
                                                },
                                                v40 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": v10 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "security__linkedSecurityContainers",
                                            "kind": "LinkedHandle",
                                            "name": "linkedSecurityContainers"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v20 /*: any*/ 
            ]
        },
        "params": {
            "id": "a1a80f3ccfe8934408165144c558b877d997fe187322dd28b0da2044aa214fed",
            "metadata": {},
            "name": "mainSecurityInJiraQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$897a53634fdc58c5$var$node.hash = "e0029e5d1d9e6e62c9b62d69cc3a9f72";
var $897a53634fdc58c5$export$2e2bcd8739ae039 = $897a53634fdc58c5$var$node;

});

parcelRegister("fb9lE", function(module, exports) {

$parcel$export(module.exports, "getGqlFiltersFromQueryParams", () => $3db5dd4b8613bcf1$export$2af359d48d48e5f1);

var $InKsA = parcelRequire("InKsA");

var $aXpp4 = parcelRequire("aXpp4");

var $erRnF = parcelRequire("erRnF");
const $3db5dd4b8613bcf1$var$getFilterValue = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
values, fieldStortKey, sortKey = (0, $aXpp4.initialVulnerabilityTableOptions).sortKey, sortOrder = (0, $aXpp4.initialVulnerabilityTableOptions).sortOrder)=>({
        ...values.length > 0 ? {
            values: values
        } : {},
        ...sortKey === fieldStortKey && {
            sort: {
                priority: 2,
                order: (0, $erRnF.parseSortDirection)(sortOrder, (0, $InKsA.AriGraphSortOrderInput).DESC)
            }
        }
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3db5dd4b8613bcf1$var$getOrDefault = (input, defaultArray)=>input.length ? input : defaultArray;
const $3db5dd4b8613bcf1$export$2af359d48d48e5f1 = (queryParams, connectionAri)=>{
    const containerValues = $3db5dd4b8613bcf1$var$getOrDefault((0, $erRnF.connectionQueryParamToFilter)(queryParams[0, $aXpp4.QUERY_PARAM_CONTAINER], connectionAri).filter(Boolean), (0, $aXpp4.initialVulnerabilityTableOptions).connectionFilter);
    const statusQueryParams = (0, $erRnF.arrayQueryParamToFilter)(queryParams[0, $aXpp4.QUERY_PARAM_VULN_STATUS]);
    return {
        and: [
            {
                lastUpdated: {
                    sort: {
                        priority: 1,
                        order: (0, $InKsA.AriGraphSortOrderInput).DESC
                    }
                },
                to_severity: $3db5dd4b8613bcf1$var$getFilterValue($3db5dd4b8613bcf1$var$getOrDefault((0, $erRnF.arrayQueryParamToFilter)(queryParams[0, $aXpp4.QUERY_PARAM_SEVERITY]).map((0, $erRnF.parseSeverity)).filter(Boolean), (0, $aXpp4.initialVulnerabilityTableOptions).severityFilter), 'severity', queryParams[0, $aXpp4.QUERY_PARAM_SORT_KEY], queryParams[0, $aXpp4.QUERY_PARAM_SORT_ORDER]),
                to_status: $3db5dd4b8613bcf1$var$getFilterValue(statusQueryParams.includes((0, $aXpp4.NO_FILTER_VULN_STATUS)) ? [] : $3db5dd4b8613bcf1$var$getOrDefault(statusQueryParams.map((0, $erRnF.parseStatus)).filter(Boolean), (0, $aXpp4.initialVulnerabilityTableOptions).statusFilter), 'status', queryParams[0, $aXpp4.QUERY_PARAM_SORT_KEY], queryParams[0, $aXpp4.QUERY_PARAM_SORT_ORDER]),
                createdAt: {
                    ...queryParams[0, $aXpp4.QUERY_PARAM_SORT_KEY] === 'introduced' && {
                        sort: {
                            priority: 2,
                            order: (0, $erRnF.parseSortDirection)(queryParams[0, $aXpp4.QUERY_PARAM_SORT_ORDER], (0, $InKsA.AriGraphSortOrderInput).DESC)
                        }
                    }
                },
                to_container: {
                    containerAri: {
                        value: {
                            ...containerValues.length > 0 ? {
                                values: containerValues
                            } : {}
                        }
                    }
                }
            }
        ]
    };
};

});
parcelRegister("InKsA", function(module, exports) {

$parcel$export(module.exports, "AriGraphSortOrderInput", () => $a96cc5854e779a88$export$3b69903df4cd6048);
const $a96cc5854e779a88$export$3b69903df4cd6048 = {
    ASC: 'ASC',
    DESC: 'DESC'
};

});

parcelRegister("aXpp4", function(module, exports) {

$parcel$export(module.exports, "QUERY_PARAM_SEARCH", () => $974dd4d6bcf6c002$export$a181206198b7f50c);
$parcel$export(module.exports, "QUERY_PARAM_CONTAINER", () => $974dd4d6bcf6c002$export$3873b20ffa21b004);
$parcel$export(module.exports, "QUERY_PARAM_SEVERITY", () => $974dd4d6bcf6c002$export$af01a3d59250f3d3);
$parcel$export(module.exports, "QUERY_PARAM_VULN_STATUS", () => $974dd4d6bcf6c002$export$c315695f017955dc);
$parcel$export(module.exports, "QUERY_PARAM_ISSUE_STATUS", () => $974dd4d6bcf6c002$export$2e69a24fe65d4109);
$parcel$export(module.exports, "QUERY_PARAM_SORT_KEY", () => $974dd4d6bcf6c002$export$6da773286c35ef41);
$parcel$export(module.exports, "QUERY_PARAM_SORT_ORDER", () => $974dd4d6bcf6c002$export$810a1f7ed2facfcb);
$parcel$export(module.exports, "NO_FILTER_VULN_STATUS", () => $974dd4d6bcf6c002$export$d8115099d465de4c);
$parcel$export(module.exports, "initialVulnerabilityTableOptions", () => $974dd4d6bcf6c002$export$e9b4ea84d666c490);
const $974dd4d6bcf6c002$export$a181206198b7f50c = 'search';
const $974dd4d6bcf6c002$export$3873b20ffa21b004 = 'container';
const $974dd4d6bcf6c002$export$af01a3d59250f3d3 = 'severity';
const $974dd4d6bcf6c002$export$c315695f017955dc = 'vulnerabilityStatus';
const $974dd4d6bcf6c002$export$2e69a24fe65d4109 = 'issueStatus';
const $974dd4d6bcf6c002$export$6da773286c35ef41 = 'sortKey';
const $974dd4d6bcf6c002$export$810a1f7ed2facfcb = 'sortOrder';
const $974dd4d6bcf6c002$export$d8115099d465de4c = 'NO-FILTERS';
const $974dd4d6bcf6c002$export$afbc65bcea0cf17e = {
    searchFilter: '',
    connectionFilter: [],
    severityFilter: [],
    statusFilter: [
        'OPEN'
    ],
    jiraIssueStatusFilter: []
};
const $974dd4d6bcf6c002$export$e9b4ea84d666c490 = {
    sortKey: 'severity',
    sortOrder: 'DESC',
    ...$974dd4d6bcf6c002$export$afbc65bcea0cf17e
};

});

parcelRegister("erRnF", function(module, exports) {

$parcel$export(module.exports, "arrayQueryParamToFilter", () => $896d2028fc8f9365$export$7500862c6689a767);
$parcel$export(module.exports, "arrayFilterToQueryParam", () => $896d2028fc8f9365$export$b0dee3c5bfc7249e);
$parcel$export(module.exports, "connectionFilterToQueryParam", () => $896d2028fc8f9365$export$a6950ca4fdc8498f);
$parcel$export(module.exports, "connectionQueryParamToFilter", () => $896d2028fc8f9365$export$1040034504af5b41);
$parcel$export(module.exports, "parseSeverity", () => $896d2028fc8f9365$export$3551b8a2cbdb5162);
$parcel$export(module.exports, "parseStatus", () => $896d2028fc8f9365$export$2188844eb84f7f06);
$parcel$export(module.exports, "parseSortDirection", () => $896d2028fc8f9365$export$85cf5c73b48a482e);

var $9OdO2 = parcelRequire("9OdO2");

var $eo8NR = parcelRequire("eo8NR");

var $InKsA = parcelRequire("InKsA");

var $94l3m = parcelRequire("94l3m");
const $896d2028fc8f9365$var$DELIMITER = ',';
const $896d2028fc8f9365$var$ENCODED_DELIMITER = encodeURIComponent($896d2028fc8f9365$var$DELIMITER);
// We encode the delimiter to protect the values from containing
// the same character that delimits the list.
// e.g.
// env names = ["prod,east", "prod,west"] -> "prod,east,prod,west"
const $896d2028fc8f9365$var$encodeDelimiter = (input)=>{
    const regex = new RegExp($896d2028fc8f9365$var$DELIMITER, 'g');
    return input.replace(regex, $896d2028fc8f9365$var$ENCODED_DELIMITER);
};
const $896d2028fc8f9365$var$decodeDelimiter = (input)=>{
    const regex = new RegExp($896d2028fc8f9365$var$ENCODED_DELIMITER, 'g');
    return input.replace(regex, $896d2028fc8f9365$var$DELIMITER);
};
const $896d2028fc8f9365$export$7500862c6689a767 = (queryParamString)=>queryParamString?.split($896d2028fc8f9365$var$DELIMITER)?.map($896d2028fc8f9365$var$decodeDelimiter) ?? [];
const $896d2028fc8f9365$export$b0dee3c5bfc7249e = (filterArray)=>{
    if (filterArray.length === 0) return undefined;
    return filterArray.map((entity)=>$896d2028fc8f9365$var$encodeDelimiter(entity)).join($896d2028fc8f9365$var$DELIMITER);
};
const $896d2028fc8f9365$export$a6950ca4fdc8498f = (connectionArray)=>{
    if (connectionArray.length === 0) return undefined;
    const groupedConnectionsByAppKey = connectionArray.reduce((acc, connection)=>{
        const [, , , , securityParts] = connection.split(':');
        const [, , , appKey, ...containerId] = securityParts.split('/');
        if (!acc[appKey]) acc[appKey] = [];
        acc[appKey].push(containerId.join('/'));
        return acc;
    }, {});
    return JSON.stringify(groupedConnectionsByAppKey);
};
const $896d2028fc8f9365$export$1040034504af5b41 = (queryParamString, connectionAri)=>{
    if (!queryParamString) return [];
    const groupedConnectionsByAppKey = JSON.parse(queryParamString);
    return (0, (/*@__PURE__*/$parcel$interopDefault($9OdO2)))(groupedConnectionsByAppKey, (containerIds, appKey)=>(0, (/*@__PURE__*/$parcel$interopDefault($eo8NR)))(containerIds, (containerId)=>`${connectionAri}${appKey}/${containerId}`));
};
const $896d2028fc8f9365$export$3551b8a2cbdb5162 = (maybeSeverity)=>{
    switch(maybeSeverity?.toUpperCase()){
        case (0, $94l3m.VulnerabilitySeverityEnums).CRITICAL.toUpperCase():
            return (0, $94l3m.VulnerabilitySeverityEnums).CRITICAL;
        case (0, $94l3m.VulnerabilitySeverityEnums).HIGH.toUpperCase():
            return (0, $94l3m.VulnerabilitySeverityEnums).HIGH;
        case (0, $94l3m.VulnerabilitySeverityEnums).LOW.toUpperCase():
            return (0, $94l3m.VulnerabilitySeverityEnums).LOW;
        case (0, $94l3m.VulnerabilitySeverityEnums).MEDIUM.toUpperCase():
            return (0, $94l3m.VulnerabilitySeverityEnums).MEDIUM;
        case (0, $94l3m.VulnerabilitySeverityEnums).UNKNOWN.toUpperCase():
            return (0, $94l3m.VulnerabilitySeverityEnums).UNKNOWN;
        default:
            return undefined;
    }
};
const $896d2028fc8f9365$export$2188844eb84f7f06 = (maybeStatus)=>{
    switch(maybeStatus?.toUpperCase()){
        case (0, $94l3m.VulnerabilityStatusEnums).OPEN.toUpperCase():
            return (0, $94l3m.VulnerabilityStatusEnums).OPEN;
        case (0, $94l3m.VulnerabilityStatusEnums).UNKNOWN.toUpperCase():
            return (0, $94l3m.VulnerabilityStatusEnums).UNKNOWN;
        case (0, $94l3m.VulnerabilityStatusEnums).CLOSED.toUpperCase():
            return (0, $94l3m.VulnerabilityStatusEnums).CLOSED;
        case (0, $94l3m.VulnerabilityStatusEnums).IGNORED.toUpperCase():
            return (0, $94l3m.VulnerabilityStatusEnums).IGNORED;
        default:
            return undefined;
    }
};
const $896d2028fc8f9365$export$85cf5c73b48a482e = (maybeDirection, defaultValue)=>{
    switch(maybeDirection?.toUpperCase()){
        case (0, $InKsA.AriGraphSortOrderInput).ASC.toUpperCase():
            return (0, $InKsA.AriGraphSortOrderInput).ASC;
        case (0, $InKsA.AriGraphSortOrderInput).DESC.toUpperCase():
            return (0, $InKsA.AriGraphSortOrderInput).DESC;
        default:
            return defaultValue;
    }
};

});
parcelRegister("9OdO2", function(module, exports) {

var $hKE3p = parcelRequire("hKE3p");

var $eo8NR = parcelRequire("eo8NR");
/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $72437e2c2a373df9$var$flatMap(collection, iteratee) {
    return $hKE3p($eo8NR(collection, iteratee), 1);
}
module.exports = $72437e2c2a373df9$var$flatMap;

});
parcelRegister("eo8NR", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");

var $7qARj = parcelRequire("7qARj");

var $iA1h1 = parcelRequire("iA1h1");

var $1c8hB = parcelRequire("1c8hB");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $a79a22b5b4895d6c$var$map(collection, iteratee) {
    var func = $1c8hB(collection) ? $kJvGp : $iA1h1;
    return func(collection, $7qARj(iteratee, 3));
}
module.exports = $a79a22b5b4895d6c$var$map;

});


parcelRegister("94l3m", function(module, exports) {

$parcel$export(module.exports, "VulnerabilitySeverityEnums", () => $2702828faf38eb9a$export$c1a102938d8dc10);
$parcel$export(module.exports, "VulnerabilityStatusEnums", () => $2702828faf38eb9a$export$2d6749bded378262);
const $2702828faf38eb9a$export$c1a102938d8dc10 = {
    CRITICAL: 'CRITICAL',
    HIGH: 'HIGH',
    LOW: 'LOW',
    MEDIUM: 'MEDIUM',
    UNKNOWN: 'UNKNOWN'
};
const $2702828faf38eb9a$export$2d6749bded378262 = {
    CLOSED: 'CLOSED',
    IGNORED: 'IGNORED',
    OPEN: 'OPEN',
    UNKNOWN: 'UNKNOWN'
};
const $2702828faf38eb9a$export$abf926511a2b65de = {
    DAST: 'DAST',
    SAST: 'SAST',
    SCA: 'SCA',
    UNKNOWN: 'UNKNOWN'
};

});



const $17300ee0074ba903$export$f24db22c3c834cb1 = 'SOFTWARE_SECURITY';


parcelRegister("lX3B2", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('eNmuD'),
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('eYSBU')
        ]);
        const value = parcelRequire('9D3yn');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("eNmuD"),
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("eYSBU")
    ]).then(()=>parcelRequire('9D3yn'));
}

});

parcelRegister("eaP1H", function(module, exports) {

$parcel$export(module.exports, "userBoardRoute", () => $f203bcc70ddc17af$export$57a2a0fe739f16);

var $exb0h = parcelRequire("exb0h");

var $bmKiO = parcelRequire("bmKiO");
const $f203bcc70ddc17af$export$57a2a0fe739f16 = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_USER_BOARD,
    path: '/jira/people/:accountId/boards/:boardId',
    preloadOptions: {
        earlyChunks: [
            'rapidboard-early-entry'
        ]
    },
    earlyAssets: (0, $bmKiO.AGGRESSIVE_EARLY_ASSET_STRATEGY)
};

});

parcelRegister("841Zr", function(module, exports) {

$parcel$export(module.exports, "RoadmapSkeleton", () => $258037d50c2153f1$export$66a1e8bb48359566);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $8ICxF = parcelRequire("8ICxF");

var $kNTxJ = parcelRequire("kNTxJ");

var $hKmIx = parcelRequire("hKmIx");
const $258037d50c2153f1$var$customCssStyles = null;
const $258037d50c2153f1$export$66a1e8bb48359566 = ()=>(0, $1ybV0.ff)('sea-2744-jsw-tabs-nav') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kNTxJ))),
        className: (0, $7JEyt.default)([
            "_2zz1idpf"
        ])
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hKmIx))),
        className: (0, $7JEyt.default)([
            "_2zz1idpf"
        ])
    });

});
parcelRegister("kNTxJ", function(module, exports) {
module.exports = new URL("roadmap-app-skeleton-nav-refresh.tpl.ce6eb42e.svg", import.meta.url).toString();

});

parcelRegister("hKmIx", function(module, exports) {
module.exports = new URL("roadmap-app-skeleton.tpl.a54a882d.svg", import.meta.url).toString();

});


parcelRegister("GuBa2", function(module, exports) {

$parcel$export(module.exports, "staticSidebarJSWReportsResource", () => $3644fec504a7091d$export$5910307042ab3f6f);
// eslint-disable-next-line jira/restricted/@atlassian/jira-router

var $3HCkE = parcelRequire("3HCkE");

var $ElVpH = parcelRequire("ElVpH");

var $b1r4M = parcelRequire("b1r4M");
const $3644fec504a7091d$export$5910307042ab3f6f = (0, $3HCkE.createResource)({
    type: 'JIRA_SOFTWARE_REPORTS',
    getKey: ({ match: match, query: query })=>{
        const boardId = (0, $ElVpH.getBoardId)(match, query);
        return boardId ? `board-${boardId}` : 'none';
    },
    getData: async ({ match: match, query: query })=>{
        const boardId = (0, $ElVpH.getBoardId)(match, query);
        if (boardId == null) return null;
        const response = await (0, $b1r4M.fetchJSWReports)(boardId);
        return response?.reports;
    },
    maxAge: 300000
});

});
parcelRegister("b1r4M", function(module, exports) {

$parcel$export(module.exports, "fetchJSWReports", () => $35f5e30d07c84550$export$a93a577d6971da2c);

var $lRmyA = parcelRequire("lRmyA");
const $35f5e30d07c84550$export$a93a577d6971da2c = (boardId)=>{
    if (boardId == null) throw new Error('invalid boardId');
    return (0, $lRmyA.performGetRequest)(`/rest/agile/latest/board/${boardId}/reports`);
};

});


parcelRegister("5fOZm", function(module, exports) {

$parcel$export(module.exports, "devOpsReportPreconditionResource", () => $be1b037470026e68$export$96cb0eae1b3413f4);
$parcel$export(module.exports, "useDevOpsReportPreconditionResource", () => $be1b037470026e68$export$e9adc6103e9ed514);

var $3HCkE = parcelRequire("3HCkE");


const $be1b037470026e68$export$96cb0eae1b3413f4 = (0, $3HCkE.createResource)({
    type: (0, $c1b3a83229b530dd$export$14c5ce449424c281),
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("iZSm3")),
    maxAge: 60000
});
const $be1b037470026e68$export$e9adc6103e9ed514 = ()=>(0, $3HCkE.useResource)($be1b037470026e68$export$96cb0eae1b3413f4);

});
const $c1b3a83229b530dd$export$14c5ce449424c281 = 'SOFTWARE_CYCLE_TIME_REPORT_PRECONDITION';
const $c1b3a83229b530dd$export$28dc7a217425f1a9 = 'VIEW_DEV_TOOLS';
const $c1b3a83229b530dd$export$a03e1c9d464f9477 = 'VIEW_AGGREGATED_DATA';

parcelRegister("iZSm3", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('fvJyP');
        const value = parcelRequire('kQVpx');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("fvJyP").then(()=>parcelRequire('kQVpx'));
}

});


parcelRegister("ghn1W", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('kfzOE');
        const value = parcelRequire('hlq5E');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("kfzOE").then(()=>parcelRequire('hlq5E'));
}

});

parcelRegister("uFfwG", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('jpSQC')
        ]);
        const value = parcelRequire('aYTYW');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("jpSQC")
    ]).then(()=>parcelRequire('aYTYW'));
}

});

parcelRegister("dFSQC", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('73KJ4')
        ]);
        const value = parcelRequire('bCKh9');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("73KJ4")
    ]).then(()=>parcelRequire('bCKh9'));
}

});

parcelRegister("hMw1o", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('1exKx')
        ]);
        const value = parcelRequire('f36yg');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("1exKx")
    ]).then(()=>parcelRequire('f36yg'));
}

});

parcelRegister("8be6R", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('3dblI')
        ]);
        const value = parcelRequire('2JCOg');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("3dblI")
    ]).then(()=>parcelRequire('2JCOg'));
}

});

parcelRegister("cZ7T2", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('j4QrN')
        ]);
        const value = parcelRequire('hN2hf');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("j4QrN")
    ]).then(()=>parcelRequire('hN2hf'));
}

});

parcelRegister("bLPIE", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('LFund')
        ]);
        const value = parcelRequire('3sQZZ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("LFund")
    ]).then(()=>parcelRequire('3sQZZ'));
}

});

parcelRegister("f0z5c", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('bXxlB')
        ]);
        const value = parcelRequire('6lJS5');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("bXxlB")
    ]).then(()=>parcelRequire('6lJS5'));
}

});

parcelRegister("glXm4", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('gAtlm')
        ]);
        const value = parcelRequire('1HgoJ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("gAtlm")
    ]).then(()=>parcelRequire('1HgoJ'));
}

});

parcelRegister("heI8s", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('koXa2')
        ]);
        const value = parcelRequire('772Yc');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("koXa2")
    ]).then(()=>parcelRequire('772Yc'));
}

});

parcelRegister("dr1qL", function(module, exports) {

$parcel$export(module.exports, "compassProductSettingsResource", () => $3c15fc909617c154$export$d18ff068d6c25455);
$parcel$export(module.exports, "useCompassProductSettingsResource", () => $3c15fc909617c154$export$6cbcbd11d26ae36f);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $3HCkE = parcelRequire("3HCkE");

const $3c15fc909617c154$export$d18ff068d6c25455 = (0, $3HCkE.createResource)({
    type: (0, $aefa2beed38f2caa$export$6f0555de4f60e84e),
    getKey: ()=>'state',
    getData: async ()=>{
        try {
            const isCompassEnabledForNewProjects = await (0, $lRmyA.performGetRequest)(`/rest/api/3/application-properties?key=${(0, $aefa2beed38f2caa$export$5685d70c20140008)}`).then(({ value: value })=>value.toLowerCase().trim() === 'true');
            return {
                isCompassEnabledForNewProjects: isCompassEnabledForNewProjects
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error?.statusCode === 404) return {
                isCompassEnabledForNewProjects: true
            };
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'compassProductSettingsResource',
                    packageName: 'jiraRouterResourcesCompassProductSettings',
                    teamName: 'compass-lodestone'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
});
const $3c15fc909617c154$export$6cbcbd11d26ae36f = ()=>(0, $3HCkE.useResource)($3c15fc909617c154$export$d18ff068d6c25455);

});
const $aefa2beed38f2caa$export$6f0555de4f60e84e = 'RESOURCE_TYPE_COMPASS_PRODUCT_SETTINGS';
const $aefa2beed38f2caa$export$5685d70c20140008 = 'jira.admin.compass.is-enabled-for-new-project';


parcelRegister("iUVLT", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('2lK0b')
        ]);
        const value = parcelRequire('hiLt4');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("2lK0b")
    ]).then(()=>parcelRequire('hiLt4'));
}

});

parcelRegister("aPd1D", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('lQZOk')
        ]);
        const value = parcelRequire('l3y9L');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("lQZOk")
    ]).then(()=>parcelRequire('l3y9L'));
}

});

parcelRegister("bzNVg", function(module, exports) {

$parcel$export(module.exports, "connectProjectResources", () => $6b6ae9e1cac63317$export$7d2d082a4b91a6c7);
// eslint-disable-next-line jira/import-whitelist

var $2fEPO = parcelRequire("2fEPO");

var $kXWpU = parcelRequire("kXWpU");

var $3HCkE = parcelRequire("3HCkE");


const $6b6ae9e1cac63317$export$7d2d082a4b91a6c7 = (0, $3HCkE.createResource)({
    type: (0, $0ac1940034966a81$export$da32d27651782c3),
    getKey: ({ query: query })=>{
        const { addonKey: addonKey, moduleKey: moduleKey } = (0, $2fEPO.transformUrlToAddonAndModuleKeys)(query);
        if (addonKey !== '' && moduleKey !== '') return `${addonKey}-${moduleKey}`;
        return 'state';
    },
    depends: [
        (0, $kXWpU.staticProjectSidebarNavigationResource).type
    ],
    getDataLoader: ()=>(parcelRequire("jRnYX"))
});

});
parcelRegister("2fEPO", function(module, exports) {

$parcel$export(module.exports, "transformResponse", () => $4720f3e3fd1eb764$export$3361e9be8093ddcc);
$parcel$export(module.exports, "extractContext", () => $4720f3e3fd1eb764$export$efdbd45f3e77a161);
$parcel$export(module.exports, "transformQueryParams", () => $4720f3e3fd1eb764$export$9e3c3f47fc3ab3d0);
$parcel$export(module.exports, "transformUrlToAddonAndModuleKeys", () => $4720f3e3fd1eb764$export$752ef5ab3d7ab15f);

var $gUUjF = parcelRequire("gUUjF");

var $9T0Tw = parcelRequire("9T0Tw");

var $eWsAG = parcelRequire("eWsAG");
const $4720f3e3fd1eb764$export$3361e9be8093ddcc = (response)=>{
    try {
        const productContext = response.productCtx ? JSON.parse(response.productCtx) : {};
        const structuredContext = response.structuredContext ? JSON.parse(response.structuredContext) : {};
        const context = {
            productContext: productContext,
            structuredContext: structuredContext,
            productCtx: productContext
        };
        return {
            ...response,
            ...context,
            isFullPage: response.general === '1',
            user: {
                timeZone: response.timeZone,
                uid: response.uid || undefined,
                ukey: response.ukey || undefined,
                fullName: response.fullName || undefined
            },
            targets: {
                env: {
                    resize: 'both'
                }
            },
            history: {
                state: ''
            },
            autoresize: true,
            ns: response.uniqueKey,
            containerId: `embedded-${response.uniqueKey}`,
            contextPath: response.cp,
            width: response.w || response.width,
            height: response.h || response.height
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const location = 'connect-iframe.transformer';
        (0, $gUUjF.default).safeErrorWithoutCustomerData(location, 'Failed to transform response', error);
        return {
            autoresize: true,
            productCtx: undefined,
            structuredContext: undefined,
            isFullPage: true,
            history: {
                state: ''
            },
            targets: {
                env: {
                    resize: 'both'
                }
            }
        };
    }
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4720f3e3fd1eb764$var$checkValueAndMapToNewName = (object, oldName, newName)=>{
    const newValue = object !== null && object[oldName] ? String(object[oldName]) : null;
    return newValue !== null ? {
        [newName]: newValue
    } : null;
};
const $4720f3e3fd1eb764$export$1f8eea5a5a32169f = (contextData)=>{
    const scope = contextData && contextData.scope || null;
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    const project = contextData && contextData.project || null;
    const projectId = $4720f3e3fd1eb764$var$checkValueAndMapToNewName(project, 'id', 'project.id');
    const projectKey = $4720f3e3fd1eb764$var$checkValueAndMapToNewName(project, 'key', 'project.key');
    const boardType = $4720f3e3fd1eb764$var$checkValueAndMapToNewName(scope, 'type', 'board.type');
    const boardId = $4720f3e3fd1eb764$var$checkValueAndMapToNewName(scope, 'id', 'board.id');
    return {
        ...projectId,
        ...projectKey,
        ...boardType,
        ...boardId
    };
};
const $4720f3e3fd1eb764$export$efdbd45f3e77a161 = (projectSidebarNavInfo)=>{
    const project = projectSidebarNavInfo && (0, $eWsAG.extractData)(projectSidebarNavInfo) || null;
    const board = projectSidebarNavInfo?.jiraSoftwareNavData && (0, $9T0Tw.extractData)(projectSidebarNavInfo.jiraSoftwareNavData) || null;
    const projectId = $4720f3e3fd1eb764$var$checkValueAndMapToNewName(project, 'id', 'project.id');
    const projectKey = $4720f3e3fd1eb764$var$checkValueAndMapToNewName(project, 'key', 'project.key');
    const boardType = $4720f3e3fd1eb764$var$checkValueAndMapToNewName(board, 'type', 'board.type');
    const boardId = $4720f3e3fd1eb764$var$checkValueAndMapToNewName(board, 'id', 'board.id');
    return {
        ...projectId,
        ...projectKey,
        ...boardType,
        ...boardId
    };
};
const $4720f3e3fd1eb764$export$9e3c3f47fc3ab3d0 = (contextData, query)=>{
    const context = $4720f3e3fd1eb764$export$1f8eea5a5a32169f(contextData);
    return {
        ...query,
        ...context
    };
};
const $4720f3e3fd1eb764$export$752ef5ab3d7ab15f = (query)=>{
    const { selectedItem: selectedItem } = query;
    let addonKey = '';
    let moduleKey = '';
    if (selectedItem) {
        const urlPattern = selectedItem.includes('%3A') ? 'com.atlassian.plugins.atlassian-connect-plugin%3A' : 'com.atlassian.plugins.atlassian-connect-plugin:';
        [addonKey, moduleKey] = selectedItem.replace(urlPattern, '').split('__');
    }
    return {
        addonKey: addonKey,
        moduleKey: moduleKey
    };
};

});
parcelRegister("9T0Tw", function(module, exports) {

$parcel$export(module.exports, "extractData", () => $1203c12364555614$export$9df5fa0a366163d2);
$parcel$export(module.exports, "extractUserBoard", () => $1203c12364555614$export$67db9e2d1b6ed865);
const $1203c12364555614$export$9df5fa0a366163d2 = (jiraSoftwareNavData)=>{
    if (jiraSoftwareNavData.boardInfo == null) return null;
    const { boardInfo: { id: id, type: type = 'scrum', name: name } } = jiraSoftwareNavData;
    return {
        id: id,
        type: type,
        name: name,
        isProjectBoard: true
    };
};
const $1203c12364555614$export$67db9e2d1b6ed865 = (userBoardNavData)=>{
    const { boardInfo: { id: id, type: type = 'scrum', name: name } } = userBoardNavData;
    return {
        id: id,
        type: type,
        name: name,
        isProjectBoard: false
    };
};

});


const $0ac1940034966a81$export$da32d27651782c3 = 'CONNECT_PROJECT';

parcelRegister("jRnYX", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('4OWud');
        const value = parcelRequire('eps5Q');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("4OWud").then(()=>parcelRequire('eps5Q'));
}

});


parcelRegister("kbHFR", function(module, exports) {

$parcel$export(module.exports, "getServiceDeskNavigationResources", () => $d0dacb3ad4515336$export$bc0bd65e6da57c1f);
$parcel$export(module.exports, "getServiceDeskNavigationSingleResources", () => $d0dacb3ad4515336$export$41a9145ddbba28e5);
$parcel$export(module.exports, "getServiceDeskSharedNavigationSingleResources", () => $d0dacb3ad4515336$export$2c543d6accc1eb9b);
$parcel$export(module.exports, "getServiceDeskSettingsResources", () => $d0dacb3ad4515336$export$7bb3c4a2f6b127fb);
$parcel$export(module.exports, "getServicedeskPageContextResources", () => $d0dacb3ad4515336$export$a8b852f03a310dc0);
$parcel$export(module.exports, "getQueuesResources", () => $d0dacb3ad4515336$export$70b97995f4d5ef9f);
$parcel$export(module.exports, "getKnowledgeBaseResources", () => $d0dacb3ad4515336$export$ed87d3b71544c4ef);
$parcel$export(module.exports, "getInsightResources", () => $d0dacb3ad4515336$export$9e0cf1fab0581096);

var $dfBCt = parcelRequire("dfBCt");

var $1ybV0 = parcelRequire("1ybV0");

var $l90Gp = parcelRequire("l90Gp");
var $7wRIc = parcelRequire("7wRIc");
var $kKeF6 = parcelRequire("kKeF6");
var $2R6ft = parcelRequire("2R6ft");

var $bbvOQ = parcelRequire("bbvOQ");

var $hHrVM = parcelRequire("hHrVM");

var $ixwgj = parcelRequire("ixwgj");

var $kJ81T = parcelRequire("kJ81T");

var $ct0sQ = parcelRequire("ct0sQ");

var $6bQqb = parcelRequire("6bQqb");

var $hRe6W = parcelRequire("hRe6W");

var $gxqFh = parcelRequire("gxqFh");

var $k1AKH = parcelRequire("k1AKH");

var $jwzNs = parcelRequire("jwzNs");

var $cV47S = parcelRequire("cV47S");
const $d0dacb3ad4515336$export$bc0bd65e6da57c1f = ()=>[
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...$d0dacb3ad4515336$export$41a9145ddbba28e5()
    ];
const $d0dacb3ad4515336$export$41a9145ddbba28e5 = ()=>[
        ...$d0dacb3ad4515336$export$9c1c5e389bd00e56(),
        ...$d0dacb3ad4515336$export$2c543d6accc1eb9b()
    ];
const $d0dacb3ad4515336$export$9c1c5e389bd00e56 = ()=>[
        (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('jsm.queues.sectional.healing'), (0, $hRe6W.priorityGroupResource)),
        (0, $k1AKH.featuresResource),
        (0, $2R6ft.staticSidebarJsmReportsResource)
    ];
const $d0dacb3ad4515336$export$2c543d6accc1eb9b = ()=>[
        (0, $hRe6W.queuesNavigationItems),
        (0, $l90Gp.forgeServiceDeskQueueModuleResource),
        (0, $7wRIc.staticJSMProjectConnectAddonsNavigationResource),
        (0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $d0dacb3ad4515336$export$7bb3c4a2f6b127fb = ()=>[
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $6bQqb.servicedeskPracticesResource),
        (0, $ct0sQ.serviceDeskContextResource),
        (0, $kJ81T.serviceDeskAnalyticsContextResource),
        (0, $jwzNs.resourceWithCondition2)(()=>!(0, $dfBCt.isFedRamp)(), (0, $gxqFh.virtualAgentOnboardingResource))
    ];
const $d0dacb3ad4515336$export$a8b852f03a310dc0 = ()=>[
        (0, $ixwgj.projectContextResourceWithCache),
        (0, $ct0sQ.serviceDeskContextResource),
        (0, $kJ81T.serviceDeskAnalyticsContextResource)
    ];
const $d0dacb3ad4515336$export$70b97995f4d5ef9f = ()=>[
        ...$d0dacb3ad4515336$export$a8b852f03a310dc0(),
        ...$d0dacb3ad4515336$export$bc0bd65e6da57c1f()
    ];
const $d0dacb3ad4515336$export$ed87d3b71544c4ef = ()=>[
        (0, $bbvOQ.kbConfluenceContextResource)
    ];
const $d0dacb3ad4515336$export$9e0cf1fab0581096 = ()=>[
        (0, $cV47S.workspaceResource)
    ];

});
parcelRegister("2R6ft", function(module, exports) {

$parcel$export(module.exports, "staticSidebarJsmReportsResource", () => $2e9be7a412e29907$export$ec28065a31cce4ce);
// eslint-disable-next-line jira/restricted/@atlassian/jira-router

var $3HCkE = parcelRequire("3HCkE");

var $9zYls = parcelRequire("9zYls");

var $e3vCY = parcelRequire("e3vCY");
const $2e9be7a412e29907$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $2e9be7a412e29907$export$ec28065a31cce4ce = (0, $3HCkE.createResource)({
    type: 'NAVIGATION_SIDEBAR_JIRA_SERVICE_MANAGEMENT_REPORTS',
    getKey: ({ match: match, query: query })=>$2e9be7a412e29907$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $2e9be7a412e29907$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        return (0, $e3vCY.fetchJsmReportsSidebarNavInfo)(projectKeyOrId);
    },
    maxAge: 300000
});

});
parcelRegister("e3vCY", function(module, exports) {

$parcel$export(module.exports, "fetchJsmReportsSidebarNavInfo", () => $069786dfe22ba4b1$export$c1dd51127051647d);

var $lRmyA = parcelRequire("lRmyA");
const $069786dfe22ba4b1$export$c1dd51127051647d = (projectIdOrKey)=>{
    if (projectIdOrKey == null) throw new Error('invalid project id or key');
    return (0, $lRmyA.performGetRequest)(`/rest/navigation/4/servicedesk/project/${projectIdOrKey}/reports`);
};

});


parcelRegister("bbvOQ", function(module, exports) {

$parcel$export(module.exports, "kbConfluenceContextResource", () => $e70a415f97febed5$export$8b58be1423986d17);

var $3HCkE = parcelRequire("3HCkE");


const $e70a415f97febed5$var$getDataLoader = ()=>(parcelRequire("DaWgb"));
const $e70a415f97febed5$export$8b58be1423986d17 = (0, $3HCkE.createResource)({
    type: (0, $fa79a46718d41206$export$54b5a0d1e8c78de6),
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: $e70a415f97febed5$var$getDataLoader,
    maxAge: Infinity
});

});
const $fa79a46718d41206$export$54b5a0d1e8c78de6 = 'KB_CONFLUENCE_CONTEXT';

parcelRegister("DaWgb", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('cNb0V');
        const value = parcelRequire('2H0aU');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("cNb0V").then(()=>parcelRequire('2H0aU'));
}

});


parcelRegister("ct0sQ", function(module, exports) {

$parcel$export(module.exports, "serviceDeskContextResource", () => $21cb155d8c71cb90$export$5eaaf465969a9171);

var $3HCkE = parcelRequire("3HCkE");

var $8hg3R = parcelRequire("8hg3R");


const $21cb155d8c71cb90$var$getDataLoader = ()=>(parcelRequire("dBIav"));
const $21cb155d8c71cb90$export$5eaaf465969a9171 = (0, $3HCkE.createResource)({
    type: (0, $826e69ec760c3796$export$ac01662d5287bc5c),
    getKey: ({ match: match, query: query })=>(0, $8hg3R.getProjectKeyOrIdFromMatchAndQuery)({
            match: match,
            query: query
        }),
    getDataLoader: $21cb155d8c71cb90$var$getDataLoader,
    maxAge: Infinity
});

});
const $826e69ec760c3796$export$ac01662d5287bc5c = 'SERVICEDESK_CONTEXT';

parcelRegister("dBIav", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('jNeZh');
        const value = parcelRequire('kuXhx');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("jNeZh").then(()=>parcelRequire('kuXhx'));
}

});


parcelRegister("6bQqb", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticesResource", () => $b386ee585ab532da$export$2ae319305481e7de);
$parcel$export(module.exports, "useWorkCategoriesQueueSupported", () => $b386ee585ab532da$export$a86ac771006f14b3);
$parcel$export(module.exports, "useWorkCategoriesAllSupported", () => $b386ee585ab532da$export$fe081b1a59d3c818);
$parcel$export(module.exports, "useWorkCategoriesAllSupportedWithForceRefreshOnMount", () => $b386ee585ab532da$export$4d46346ef0bdc6b9);

var $eUqFw = parcelRequire("eUqFw");

var $3HCkE = parcelRequire("3HCkE");

var $8hg3R = parcelRequire("8hg3R");

var $f1lMr = parcelRequire("f1lMr");


const $b386ee585ab532da$var$getDataLoader = ()=>(parcelRequire("2EUOa"));
const $b386ee585ab532da$var$ONE_DAY_IN_MILLIS = 86400000;
const $b386ee585ab532da$export$2ae319305481e7de = (0, $3HCkE.createResource)({
    type: (0, $73bf87f5cdbfcccc$export$45919c8f50bb1db5),
    getKey: ({ match: match })=>(0, $8hg3R.getProjectKeyOrId)(match),
    getDataLoader: $b386ee585ab532da$var$getDataLoader,
    maxAge: $b386ee585ab532da$var$ONE_DAY_IN_MILLIS
});
const $b386ee585ab532da$var$queuesOrder = [
    (0, $f1lMr.SERVICE_REQUEST),
    (0, $f1lMr.INCIDENTS),
    (0, $f1lMr.PROBLEMS),
    (0, $f1lMr.CHANGES),
    (0, $f1lMr.POST_INCIDENT_REVIEWS)
];
const $b386ee585ab532da$var$workCategoryOrder = [
    ...$b386ee585ab532da$var$queuesOrder,
    (0, $f1lMr.DEVELOPER_ESCALATION)
];
const $b386ee585ab532da$var$transformItsmPracticesList = (data)=>{
    if (!data?.practices) return null;
    return $b386ee585ab532da$var$queuesOrder.filter((practice)=>data.practices.some((practiceInData)=>practiceInData.key === practice));
};
const $b386ee585ab532da$var$transformServiceDeskPracticesList = (data)=>{
    if (!data?.practices) return null;
    return $b386ee585ab532da$var$workCategoryOrder.filter((practice)=>data.practices.some((practiceInData)=>practiceInData.key === practice));
};
const $b386ee585ab532da$export$a86ac771006f14b3 = ()=>{
    const { data: data, loading: loading, ...resource } = (0, $3HCkE.useResource)($b386ee585ab532da$export$2ae319305481e7de);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = resource.error;
    return (0, $eUqFw.useMemo)(()=>({
            data: $b386ee585ab532da$var$transformItsmPracticesList(data),
            loading: loading,
            error: error
        }), [
        data,
        error,
        loading
    ]);
};
const $b386ee585ab532da$export$fe081b1a59d3c818 = ()=>{
    const { data: data, loading: loading, ...resource } = (0, $3HCkE.useResource)($b386ee585ab532da$export$2ae319305481e7de);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = resource.error;
    return (0, $eUqFw.useMemo)(()=>({
            data: $b386ee585ab532da$var$transformServiceDeskPracticesList(data),
            loading: loading,
            error: error
        }), [
        data,
        error,
        loading
    ]);
};
const $b386ee585ab532da$export$4d46346ef0bdc6b9 = ()=>{
    const { data: data, loading: loading, refresh: refreshPractices, ...resource } = (0, $3HCkE.useResource)($b386ee585ab532da$export$2ae319305481e7de);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = resource.error;
    (0, $eUqFw.useEffect)(()=>{
        if (!loading && !data && !error) refreshPractices();
    }, [
        data,
        error,
        loading,
        refreshPractices
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            data: $b386ee585ab532da$var$transformServiceDeskPracticesList(data),
            loading: loading,
            error: error
        }), [
        data,
        error,
        loading
    ]);
};

});
parcelRegister("f1lMr", function(module, exports) {

$parcel$export(module.exports, "CHANGES", () => $d4363a603a2b1168$export$8598196f74460271);
$parcel$export(module.exports, "INCIDENTS", () => $d4363a603a2b1168$export$a50b49a533b5f7bc);
$parcel$export(module.exports, "PROBLEMS", () => $d4363a603a2b1168$export$ceba70db1edb1def);
$parcel$export(module.exports, "SERVICE_REQUEST", () => $d4363a603a2b1168$export$3d1cda9bd50505e8);
$parcel$export(module.exports, "POST_INCIDENT_REVIEWS", () => $d4363a603a2b1168$export$6ebf7b6bf1c580f);
$parcel$export(module.exports, "DEVELOPER_ESCALATION", () => $d4363a603a2b1168$export$81e62964cc725098);
$parcel$export(module.exports, "NO_CATEGORY", () => $d4363a603a2b1168$export$485b1216c42d8d4);
$parcel$export(module.exports, "NO_PRACTICE", () => $d4363a603a2b1168$export$52bf3f16b7812704);
$parcel$export(module.exports, "SHORT_FORM_CHANGES", () => $d4363a603a2b1168$export$a50185c8e9fb007e);
$parcel$export(module.exports, "SHORT_FORM_INCIDENTS", () => $d4363a603a2b1168$export$a54a30a3c3cce634);
$parcel$export(module.exports, "SHORT_FORM_PROBLEMS", () => $d4363a603a2b1168$export$354f3a4c6ac0c903);
$parcel$export(module.exports, "SHORT_FORM_SERVICE_REQUEST", () => $d4363a603a2b1168$export$335d3ac0c367f03f);
$parcel$export(module.exports, "SHORT_FORM_POST_INCIDENT_REVIEWS", () => $d4363a603a2b1168$export$7ffd7f2c2ae96b6f);
$parcel$export(module.exports, "SHORT_FORM_DEVELOPER_ESCALATION", () => $d4363a603a2b1168$export$cb41b99ca54e6bd);
$parcel$export(module.exports, "CHANGES_JQL_NAME", () => $d4363a603a2b1168$export$6c24c440228eac9c);
$parcel$export(module.exports, "INCIDENTS_JQL_NAME", () => $d4363a603a2b1168$export$5b65d27ec2d28d18);
$parcel$export(module.exports, "DEVELOPER_ESCALATION_JQL_NAME", () => $d4363a603a2b1168$export$3f757c5e00588ffd);
$parcel$export(module.exports, "practiceKeyJqlNameMapping", () => $d4363a603a2b1168$export$b78213db77524b5b);
$parcel$export(module.exports, "PRACTICE_LABEL_MAP", () => $d4363a603a2b1168$export$fbf0dfd01228e38d);
$parcel$export(module.exports, "PRACTICE_LABEL_MAP_NEW", () => $d4363a603a2b1168$export$91058e4cd637c2c2);
$parcel$export(module.exports, "PRACTICE_LABEL_MAP_LOWER_CASE", () => $d4363a603a2b1168$export$45ba5f49e9509c4d);
$parcel$export(module.exports, "PRACTICE_LABEL_MAP_LOWER_CASE_NEW", () => $d4363a603a2b1168$export$b5fa39e9cb62e552);

var $edAb7 = parcelRequire("edAb7");
const $d4363a603a2b1168$export$8598196f74460271 = 'change-management';
const $d4363a603a2b1168$export$a50b49a533b5f7bc = 'incident-management';
const $d4363a603a2b1168$export$ceba70db1edb1def = 'problem-management';
const $d4363a603a2b1168$export$3d1cda9bd50505e8 = 'service-request';
const $d4363a603a2b1168$export$6ebf7b6bf1c580f = 'post-incident-review';
const $d4363a603a2b1168$export$81e62964cc725098 = 'developer-escalation';
const $d4363a603a2b1168$export$a613d808168c7b25 = [
    $d4363a603a2b1168$export$8598196f74460271,
    $d4363a603a2b1168$export$a50b49a533b5f7bc,
    $d4363a603a2b1168$export$ceba70db1edb1def,
    $d4363a603a2b1168$export$3d1cda9bd50505e8,
    $d4363a603a2b1168$export$6ebf7b6bf1c580f,
    $d4363a603a2b1168$export$81e62964cc725098
]; // /!\ defines WorkCategoryApiResource type
const $d4363a603a2b1168$export$a2b1f8f055150f02 = [
    $d4363a603a2b1168$export$8598196f74460271,
    $d4363a603a2b1168$export$a50b49a533b5f7bc,
    $d4363a603a2b1168$export$ceba70db1edb1def,
    $d4363a603a2b1168$export$3d1cda9bd50505e8,
    $d4363a603a2b1168$export$6ebf7b6bf1c580f
]; // /!\ defines WorkCategoryQueueSupported type
const $d4363a603a2b1168$export$485b1216c42d8d4 = 'no-category';
const $d4363a603a2b1168$export$f929a394dd190451 = 'no-category-new';
const $d4363a603a2b1168$export$52bf3f16b7812704 = 'no-practice'; // BERRY-1358 should consolidate into NO_CATEGORY
const $d4363a603a2b1168$export$a50185c8e9fb007e = 'changes';
const $d4363a603a2b1168$export$a54a30a3c3cce634 = 'incidents';
const $d4363a603a2b1168$export$354f3a4c6ac0c903 = 'problems';
const $d4363a603a2b1168$export$335d3ac0c367f03f = 'service-requests';
const $d4363a603a2b1168$export$7ffd7f2c2ae96b6f = 'post-incident-reviews';
const $d4363a603a2b1168$export$cb41b99ca54e6bd = 'developer-escalations';
const $d4363a603a2b1168$export$f1b813cd23817ade = [
    $d4363a603a2b1168$export$a50185c8e9fb007e,
    $d4363a603a2b1168$export$a54a30a3c3cce634,
    $d4363a603a2b1168$export$354f3a4c6ac0c903,
    $d4363a603a2b1168$export$335d3ac0c367f03f,
    $d4363a603a2b1168$export$7ffd7f2c2ae96b6f,
    $d4363a603a2b1168$export$cb41b99ca54e6bd
]; // /!\ defines WorkCategoryShortForm type
const $d4363a603a2b1168$export$6c24c440228eac9c = 'Changes';
const $d4363a603a2b1168$export$5b65d27ec2d28d18 = 'Incidents';
const $d4363a603a2b1168$export$51618dc8334072b = 'Problems';
const $d4363a603a2b1168$export$a34586940ac9c374 = 'Service requests';
const $d4363a603a2b1168$export$5497b62b513b7853 = 'Post-incident reviews';
const $d4363a603a2b1168$export$3f757c5e00588ffd = 'Developer escalation';
const $d4363a603a2b1168$export$b78213db77524b5b = {
    [$d4363a603a2b1168$export$8598196f74460271]: $d4363a603a2b1168$export$6c24c440228eac9c,
    [$d4363a603a2b1168$export$a50b49a533b5f7bc]: $d4363a603a2b1168$export$5b65d27ec2d28d18,
    [$d4363a603a2b1168$export$ceba70db1edb1def]: $d4363a603a2b1168$export$51618dc8334072b,
    [$d4363a603a2b1168$export$3d1cda9bd50505e8]: $d4363a603a2b1168$export$a34586940ac9c374,
    [$d4363a603a2b1168$export$6ebf7b6bf1c580f]: $d4363a603a2b1168$export$5497b62b513b7853,
    [$d4363a603a2b1168$export$81e62964cc725098]: $d4363a603a2b1168$export$3f757c5e00588ffd
};
const $d4363a603a2b1168$export$fbf0dfd01228e38d = {
    [$d4363a603a2b1168$export$8598196f74460271]: (0, $edAb7.default).changes,
    [$d4363a603a2b1168$export$3d1cda9bd50505e8]: (0, $edAb7.default).serviceRequests,
    [$d4363a603a2b1168$export$ceba70db1edb1def]: (0, $edAb7.default).problems,
    [$d4363a603a2b1168$export$a50b49a533b5f7bc]: (0, $edAb7.default).incidents,
    [$d4363a603a2b1168$export$6ebf7b6bf1c580f]: (0, $edAb7.default).postIncidentReviews,
    [$d4363a603a2b1168$export$485b1216c42d8d4]: (0, $edAb7.default).allTickets,
    [$d4363a603a2b1168$export$81e62964cc725098]: (0, $edAb7.default).developerEscalation,
    [$d4363a603a2b1168$export$52bf3f16b7812704]: (0, $edAb7.default).noCategory
};
const $d4363a603a2b1168$export$91058e4cd637c2c2 = {
    [$d4363a603a2b1168$export$8598196f74460271]: (0, $edAb7.default).changes,
    [$d4363a603a2b1168$export$3d1cda9bd50505e8]: (0, $edAb7.default).serviceRequests,
    [$d4363a603a2b1168$export$ceba70db1edb1def]: (0, $edAb7.default).problems,
    [$d4363a603a2b1168$export$a50b49a533b5f7bc]: (0, $edAb7.default).incidents,
    [$d4363a603a2b1168$export$6ebf7b6bf1c580f]: (0, $edAb7.default).postIncidentReviews,
    [$d4363a603a2b1168$export$485b1216c42d8d4]: (0, $edAb7.default).queues,
    [$d4363a603a2b1168$export$81e62964cc725098]: (0, $edAb7.default).developerEscalation,
    [$d4363a603a2b1168$export$52bf3f16b7812704]: (0, $edAb7.default).noCategory
};
const $d4363a603a2b1168$export$45ba5f49e9509c4d = {
    [$d4363a603a2b1168$export$8598196f74460271]: (0, $edAb7.default).changesLower,
    [$d4363a603a2b1168$export$3d1cda9bd50505e8]: (0, $edAb7.default).serviceRequestsLower,
    [$d4363a603a2b1168$export$ceba70db1edb1def]: (0, $edAb7.default).problemsLower,
    [$d4363a603a2b1168$export$a50b49a533b5f7bc]: (0, $edAb7.default).incidentsLower,
    [$d4363a603a2b1168$export$6ebf7b6bf1c580f]: (0, $edAb7.default).postIncidentReviewsLower,
    [$d4363a603a2b1168$export$485b1216c42d8d4]: (0, $edAb7.default).allTicketsLower,
    [$d4363a603a2b1168$export$81e62964cc725098]: (0, $edAb7.default).developerEscalationLower,
    [$d4363a603a2b1168$export$52bf3f16b7812704]: (0, $edAb7.default).noCategoryLower
};
const $d4363a603a2b1168$export$b5fa39e9cb62e552 = {
    [$d4363a603a2b1168$export$8598196f74460271]: (0, $edAb7.default).changesLower,
    [$d4363a603a2b1168$export$3d1cda9bd50505e8]: (0, $edAb7.default).serviceRequestsLower,
    [$d4363a603a2b1168$export$ceba70db1edb1def]: (0, $edAb7.default).problemsLower,
    [$d4363a603a2b1168$export$a50b49a533b5f7bc]: (0, $edAb7.default).incidentsLower,
    [$d4363a603a2b1168$export$6ebf7b6bf1c580f]: (0, $edAb7.default).postIncidentReviewsLower,
    [$d4363a603a2b1168$export$485b1216c42d8d4]: (0, $edAb7.default).queuesLower,
    [$d4363a603a2b1168$export$81e62964cc725098]: (0, $edAb7.default).developerEscalationLower,
    [$d4363a603a2b1168$export$52bf3f16b7812704]: (0, $edAb7.default).noCategoryLower
};

});
parcelRegister("edAb7", function(module, exports) {

$parcel$export(module.exports, "default", () => $716d4f665940f429$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $716d4f665940f429$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    allTickets: {
        "id": "work-category.common.all-tickets",
        "defaultMessage": "All tickets"
    },
    queues: {
        "id": "work-category.common.queues",
        "defaultMessage": "Queues"
    },
    serviceRequests: {
        "id": "work-category.common.service-requests",
        "defaultMessage": "Service requests"
    },
    incidents: {
        "id": "work-category.common.incidents",
        "defaultMessage": "Incidents"
    },
    changes: {
        "id": "work-category.common.changes",
        "defaultMessage": "Changes"
    },
    problems: {
        "id": "work-category.common.problems",
        "defaultMessage": "Problems"
    },
    postIncidentReviews: {
        "id": "work-category.common.post-incident-reviews",
        "defaultMessage": "Post-incident reviews"
    },
    noCategory: {
        "id": "work-category.common.no-category",
        "defaultMessage": "General"
    },
    allTicketsLower: {
        "id": "work-category.common.all-tickets-lower",
        "defaultMessage": "all tickets"
    },
    queuesLower: {
        "id": "work-category.common.queues-lower",
        "defaultMessage": "queues"
    },
    serviceRequestsLower: {
        "id": "work-category.common.service-requests-lower",
        "defaultMessage": "service requests"
    },
    incidentsLower: {
        "id": "work-category.common.incidents-lower",
        "defaultMessage": "incidents"
    },
    changesLower: {
        "id": "work-category.common.changes-lower",
        "defaultMessage": "changes"
    },
    problemsLower: {
        "id": "work-category.common.problems-lower",
        "defaultMessage": "problems"
    },
    postIncidentReviewsLower: {
        "id": "work-category.common.post-incident-reviews-lower",
        "defaultMessage": "post-incident reviews"
    },
    noCategoryLower: {
        "id": "work-category.common.no-category-lower",
        "defaultMessage": "general"
    },
    developerEscalation: {
        "id": "work-category.common.developer-escalation",
        "defaultMessage": "Developer escalations"
    },
    developerEscalationLower: {
        "id": "work-category.common.developer-escalation-lower",
        "defaultMessage": "developer escalations"
    }
});

});


const $73bf87f5cdbfcccc$export$45919c8f50bb1db5 = 'SERVICEDESK_PRACTICES';

parcelRegister("2EUOa", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hVKSK');
        const value = parcelRequire('j7FZq');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hVKSK").then(()=>parcelRequire('j7FZq'));
}

});


parcelRegister("gxqFh", function(module, exports) {

$parcel$export(module.exports, "virtualAgentOnboardingResource", () => $32eefe0f93fd5c41$export$d39827c053fda3aa);

var $1ybV0 = parcelRequire("1ybV0");

var $buJlM = parcelRequire("buJlM");

var $87JeY = parcelRequire("87JeY");

const $32eefe0f93fd5c41$export$d39827c053fda3aa = (0, $buJlM.createRelayResource)({
    type: (0, $e4fa9fac26d877ab$export$fd83c0990413fc3),
    isBrowserOnly: true,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $87JeY.default),
            variables: {
                cloudId: tenantContext.cloudId,
                key: match.params.projectKey || '',
                checkForAiEnabledFF: (0, $1ybV0.ff)('check-for-ai-enabling-in-get-premium-banner_oxh6r')
            }
        })
});

});
parcelRegister("87JeY", function(module, exports) {

$parcel$export(module.exports, "default", () => $89bbbef2e4c2edaf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f0a9478a723942cf36c5e60e64982ad8>>
 * @relayHash 9459c0218f4aabda777b263e43d6af57
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a0cbbb33f77ce77f01e2fbb6dc96c89baf132394dc74242534a2543aea933dda
const $89bbbef2e4c2edaf$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "checkForAiEnabledFF"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "key"
    }, v3 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v4 = [
        v3 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "key"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = [
        v3 /*: any*/ 
    ], v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = [
        v7 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainVirtualAgentSidebarQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "virtualAgentConfiguration",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "VirtualAgentQueryApi",
                    "kind": "LinkedField",
                    "name": "virtualAgent",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "VirtualAgentFeatures",
                            "kind": "LinkedField",
                            "name": "virtualAgentEntitlements",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "checkForAiEnabledFF",
                                            "variableName": "checkForAiEnabledFF"
                                        }
                                    ],
                                    "kind": "FragmentSpread",
                                    "name": "nestedNav_navigationAppsSidebarServicedesk_VirtualAgentNestedNav"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainVirtualAgentSidebarQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "virtualAgentConfiguration",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v8 /*: any*/ ,
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v8 /*: any*/ ,
                                            "type": "VirtualAgentQueryError"
                                        }
                                    ]
                                },
                                v7 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "VirtualAgentQueryApi",
                    "kind": "LinkedField",
                    "name": "virtualAgent",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "VirtualAgentFeatures",
                            "kind": "LinkedField",
                            "name": "virtualAgentEntitlements",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isVirtualAgentAvailable"
                                },
                                {
                                    "condition": "checkForAiEnabledFF",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isAiEnabledInAdminHub"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a0cbbb33f77ce77f01e2fbb6dc96c89baf132394dc74242534a2543aea933dda",
            "metadata": {},
            "name": "mainVirtualAgentSidebarQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$89bbbef2e4c2edaf$var$node.hash = "ce0647263636d90a60ad14fa8f8cecad";
var $89bbbef2e4c2edaf$export$2e2bcd8739ae039 = $89bbbef2e4c2edaf$var$node;

});

const $e4fa9fac26d877ab$export$fd83c0990413fc3 = 'SERVICEDESK_VIRTUAL_AGENT_ONBOARDING';


parcelRegister("k1AKH", function(module, exports) {

$parcel$export(module.exports, "featuresResource", () => $fc9160f01d8d9975$export$16f81cc9da2c6c47);

var $illlw = parcelRequire("illlw");

var $3HCkE = parcelRequire("3HCkE");

var $9zYls = parcelRequire("9zYls");


const $fc9160f01d8d9975$var$getDataLoader = ()=>(parcelRequire("eOibt"));
const $fc9160f01d8d9975$var$ONE_DAY_IN_MILLIS = 86400000;
const $fc9160f01d8d9975$export$16f81cc9da2c6c47 = (0, $3HCkE.createResource)({
    type: (0, $ab0f134d1db7b683$export$3441b129810f29ed),
    getKey: ({ match: match, query: query })=>// projectKey from url path or browse/{issueKey}
        (0, $9zYls.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(match, 'params.issueKey', '').split('-')[0],
    getDataLoader: $fc9160f01d8d9975$var$getDataLoader,
    maxAge: $fc9160f01d8d9975$var$ONE_DAY_IN_MILLIS
});

});
const $ab0f134d1db7b683$export$3441b129810f29ed = 'SERVICEDESK_FEATURES';

parcelRegister("eOibt", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('4Oonc');
        const value = parcelRequire('4Kk02');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("4Oonc").then(()=>parcelRequire('4Kk02'));
}

});


parcelRegister("cV47S", function(module, exports) {

$parcel$export(module.exports, "workspaceResource", () => $dac86f6ff29c4c91$export$2f02c3f971168d17);
// eslint-disable-next-line jira/restricted/@atlassian/jira-router

var $3HCkE = parcelRequire("3HCkE");

var $aeCba = parcelRequire("aeCba");
const $dac86f6ff29c4c91$export$9b3a4d71d46e5ee7 = 'JSM_INSIGHT_WORKSPACE_CONTEXT';
const $dac86f6ff29c4c91$export$2f02c3f971168d17 = (0, $3HCkE.createResource)({
    type: $dac86f6ff29c4c91$export$9b3a4d71d46e5ee7,
    getKey: ()=>'state',
    getData: async (_, routerContext)=>{
        const workspaceId = await (0, $aeCba.default)(_, routerContext);
        return workspaceId;
    },
    maxAge: Infinity
});

});
parcelRegister("aeCba", function(module, exports) {

$parcel$export(module.exports, "isPremiumInstance", () => $5d91810a3f6a3a0a$export$abb609d3bcbb74f6);
$parcel$export(module.exports, "isLicensedPremiumUser", () => $5d91810a3f6a3a0a$export$d7b4c32773b1c643);
$parcel$export(module.exports, "default", () => $5d91810a3f6a3a0a$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");

var $8PehF = parcelRequire("8PehF");

var $aSJew = parcelRequire("aSJew");

var $6WXNs = parcelRequire("6WXNs");
const $5d91810a3f6a3a0a$export$530f260cc76f04ff = (baseUrl)=>`${baseUrl}/rest/servicedesk/cmdb/latest/workspace`;
const $5d91810a3f6a3a0a$export$abb609d3bcbb74f6 = (tenantContext)=>{
    const { appEditions: { serviceDesk: serviceDeskAppEdition } } = tenantContext;
    const isPremium = serviceDeskAppEdition === (0, $6WXNs.PREMIUM_EDITION);
    return isPremium;
};
const $5d91810a3f6a3a0a$export$d7b4c32773b1c643 = (tenantContext)=>{
    const { appPermissions: appPermissions } = tenantContext;
    const isPremium = $5d91810a3f6a3a0a$export$abb609d3bcbb74f6(tenantContext);
    const isLicensedUser = appPermissions && appPermissions.hasServiceDeskAccess;
    return isPremium && isLicensedUser;
};
const $5d91810a3f6a3a0a$var$transformResponse = (response)=>{
    const ids = response.results ?? [];
    return ids.length ? (0, $aSJew.toWorkspaceId)(ids[0].id) : null;
};
const $5d91810a3f6a3a0a$export$e1d718dfe6dad973 = (routerContext, { tenantContext: tenantContext })=>{
    const { baseUrl: baseUrl } = tenantContext;
    if ($5d91810a3f6a3a0a$export$d7b4c32773b1c643(tenantContext) === false || !(0, $8PehF.isCMDBEnabledInEnvironment)()) return null;
    return (0, $lRmyA.performGetRequest)($5d91810a3f6a3a0a$export$530f260cc76f04ff(baseUrl)).then($5d91810a3f6a3a0a$var$transformResponse).catch((error)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('spa.view.routes.servicedesk.workspace-id', 'Error while fetching servicedesk Insight workspace id', error);
        return null;
    });
};
var $5d91810a3f6a3a0a$export$2e2bcd8739ae039 = $5d91810a3f6a3a0a$export$e1d718dfe6dad973;

});
parcelRegister("8PehF", function(module, exports) {

$parcel$export(module.exports, "isCMDBEnabledInEnvironment", () => $65623e3f6693c25d$export$6dbfb62369f79a64);

var $dfBCt = parcelRequire("dfBCt");
const $65623e3f6693c25d$export$6dbfb62369f79a64 = ()=>!(0, $dfBCt.isFedRamp)();

});

parcelRegister("aSJew", function(module, exports) {

$parcel$export(module.exports, "toSchemaId", () => $53b5a9a3e106b32f$export$d577b7f3b832f656);
$parcel$export(module.exports, "toCmdbObjectId", () => $53b5a9a3e106b32f$export$1ba342595bc7be13);
$parcel$export(module.exports, "toCmdbObjectTypeId", () => $53b5a9a3e106b32f$export$b46e25afa2bab6a);
$parcel$export(module.exports, "toObjectCommentId", () => $53b5a9a3e106b32f$export$ece2917434bb0a8c);
$parcel$export(module.exports, "toWorkspaceId", () => $53b5a9a3e106b32f$export$d002b8d7821b6b59);
$parcel$export(module.exports, "toAttributeId", () => $53b5a9a3e106b32f$export$753b5cb76981c41d);
$parcel$export(module.exports, "toObjectTypeAttributeId", () => $53b5a9a3e106b32f$export$cfd92c18cee8add7);
const $53b5a9a3e106b32f$export$d577b7f3b832f656 = (id)=>id;
const $53b5a9a3e106b32f$export$1ba342595bc7be13 = (id)=>id;
const $53b5a9a3e106b32f$export$b46e25afa2bab6a = (id)=>id;
const $53b5a9a3e106b32f$export$ece2917434bb0a8c = (id)=>id;
const $53b5a9a3e106b32f$export$d002b8d7821b6b59 = (id)=>id;
const $53b5a9a3e106b32f$export$753b5cb76981c41d = (id)=>id;
const $53b5a9a3e106b32f$export$cfd92c18cee8add7 = (id)=>id;

});




parcelRegister("iuR14", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('rX8u0');
        const value = parcelRequire('aFS9O');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("rX8u0").then(()=>parcelRequire('aFS9O'));
}

});

parcelRegister("eFDDo", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('jSEbY');
        const value = parcelRequire('f1UkV');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("jSEbY").then(()=>parcelRequire('f1UkV'));
}

});

parcelRegister("jdmp1", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('7rppT');
        const value = parcelRequire('24R0F');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("7rppT").then(()=>parcelRequire('24R0F'));
}

});

parcelRegister("eDgQi", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('kPRh8');
        const value = parcelRequire('6t3Wv');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("kPRh8").then(()=>parcelRequire('6t3Wv'));
}

});

parcelRegister("7M10U", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('7a0Et')
        ]);
        const value = parcelRequire('22lcC');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("7a0Et")
    ]).then(()=>parcelRequire('22lcC'));
}

});

parcelRegister("01Qi5", function(module, exports) {

$parcel$export(module.exports, "dashboardConfigAndWRMResource", () => $217791efaf6ffd9f$export$2853c0e656e89346);
$parcel$export(module.exports, "useDashboardResource", () => $217791efaf6ffd9f$export$e5e5b3f462d6a4cb);
$parcel$export(module.exports, "useMultiDashboardsResource", () => $217791efaf6ffd9f$export$6a46406b05d8d13c);
$parcel$export(module.exports, "dashboardAMDModulesResource", () => $217791efaf6ffd9f$export$ef3fa55626812fa4);
$parcel$export(module.exports, "useDashboardAMDModulesResource", () => $217791efaf6ffd9f$export$efe0eb9a44e08d38);
$parcel$export(module.exports, "dashboardReactGadgetsResource", () => $217791efaf6ffd9f$export$39804ce8cc42cd04);
$parcel$export(module.exports, "useDashboardReactGadgetsResource", () => $217791efaf6ffd9f$export$31b430e01a1caab5);
$parcel$export(module.exports, "dashboardForgeResource", () => $217791efaf6ffd9f$export$4e0719e53da01e93);
$parcel$export(module.exports, "gadgetDirectoryResource", () => $217791efaf6ffd9f$export$36c9632be21fbb06);
$parcel$export(module.exports, "useGadgetDirectoryResource", () => $217791efaf6ffd9f$export$27f4c12e781b4572);
$parcel$export(module.exports, "useDashboardForgeResource", () => $217791efaf6ffd9f$export$75ca1b431898fd09);
$parcel$export(module.exports, "avpDashboardResource", () => $217791efaf6ffd9f$export$8a440775c439970b);
// eslint-disable-next-line jira/import-whitelist

var $dCWAV = parcelRequire("dCWAV");

var $1ybV0 = parcelRequire("1ybV0");

var $2Rqjr = parcelRequire("2Rqjr");

var $arKaN = parcelRequire("arKaN");

var $3HCkE = parcelRequire("3HCkE");

var $8b1AQ = parcelRequire("8b1AQ");

var $iVB6J = parcelRequire("iVB6J");


var $2P6WI = parcelRequire("2P6WI");

var $gKtDv = parcelRequire("gKtDv");

var $6wpNP = parcelRequire("6wpNP");

var $dnvBi = parcelRequire("dnvBi");

var $g8TlX = parcelRequire("g8TlX");
const $217791efaf6ffd9f$export$2853c0e656e89346 = (0, $3HCkE.createResource)({
    type: (0, $b44e2c11e9a5fc89$export$ca03ff6cc792cc16),
    getKey: $iVB6J.getKey,
    getData: (0, $gKtDv.default),
    maxAge: Infinity
});
// the type signature of promise and update is different on the useDashboardResource and useMultiDashboardsResource hook
const $217791efaf6ffd9f$var$extractFirstPromise = (promise)=>promise ? promise.then((configs)=>configs && configs[0]) : null;
const $217791efaf6ffd9f$export$e5e5b3f462d6a4cb = ()=>{
    // the response will have different signature on update, promise and clear etc
    const resourceResponse = $217791efaf6ffd9f$export$6a46406b05d8d13c();
    const { loading: loading, error: error, data: data, promise: promiseOfMultiConfigs, ...rest } = resourceResponse;
    const extractFirstUpdate = (getNewData)=>resourceResponse.update(([a])=>[
                getNewData(a)
            ]);
    // RouteResourceResponseLoading type
    if (loading) return {
        ...rest,
        error: null,
        data: null,
        promise: $217791efaf6ffd9f$var$extractFirstPromise(promiseOfMultiConfigs),
        loading: true,
        update: extractFirstUpdate
    };
    // RouteResourceResponseError type
    if (error) return {
        ...rest,
        error: error,
        data: null,
        promise: $217791efaf6ffd9f$var$extractFirstPromise(promiseOfMultiConfigs),
        loading: false,
        update: extractFirstUpdate
    };
    // RouteResourceResponseLoaded type
    if (data && !error) return {
        ...rest,
        loading: false,
        update: extractFirstUpdate,
        data: data[0],
        error: null,
        promise: $217791efaf6ffd9f$var$extractFirstPromise(promiseOfMultiConfigs)
    };
    // RouteResourceResponseInitial type
    return {
        ...rest,
        loading: false,
        error: error,
        data: null,
        promise: null,
        update: extractFirstUpdate
    };
};
const $217791efaf6ffd9f$export$6a46406b05d8d13c = ()=>(0, $3HCkE.useResource)($217791efaf6ffd9f$export$2853c0e656e89346);
const $217791efaf6ffd9f$export$ef3fa55626812fa4 = (0, $8b1AQ.createDependentResource)({
    type: (0, $b44e2c11e9a5fc89$export$e239393fd4e2bc85),
    getKey: $iVB6J.getKey,
    depends: [
        (0, $b44e2c11e9a5fc89$export$ca03ff6cc792cc16)
    ],
    mapToSharedValue: (0, $8b1AQ.withEitherDataOrError)((data)=>{
        const { gadgets: gadgets, preloadedModuleNames: preloadedModuleNames } = data.reduce((prev, curr)=>({
                gadgets: prev.gadgets.concat(curr.gadgets),
                preloadedModuleNames: prev.preloadedModuleNames.concat(curr.preloadedModuleNames)
            }), {
            gadgets: [],
            preloadedModuleNames: []
        });
        const moduleNames = (0, $g8TlX.gadgetsToUniqueSortedAmdModules)(gadgets);
        const isPreloaded = moduleNames.every((name)=>preloadedModuleNames.includes(name));
        return {
            moduleNames: moduleNames,
            isPreloaded: isPreloaded
        };
    }, (x)=>x),
    shouldUpdate: ({ sharedValue: a, amdModules: amdModules }, b)=>(0, $8b1AQ.withEitherDataOrError)((prev, next)=>next.moduleNames.length > prev.moduleNames.length || next.moduleNames.some((name)=>amdModules?.[name] == null), ()=>true)(a, b),
    getData: (0, $2P6WI.default),
    maxAge: Infinity,
    isBrowserOnly: true
});
const $217791efaf6ffd9f$export$efe0eb9a44e08d38 = ()=>(0, $3HCkE.useResource)($217791efaf6ffd9f$export$ef3fa55626812fa4);
const $217791efaf6ffd9f$export$39804ce8cc42cd04 = (0, $8b1AQ.createDependentResource)({
    type: (0, $b44e2c11e9a5fc89$export$9e5db01432b13b67),
    getKey: $iVB6J.getKey,
    depends: [
        (0, $b44e2c11e9a5fc89$export$ca03ff6cc792cc16)
    ],
    mapToSharedValue: (0, $8b1AQ.withEitherDataOrError)((data)=>{
        const gadgets = data.flatMap((dashboard)=>dashboard.gadgets);
        return {
            reactGadgets: (0, $g8TlX.gadgetsToSortedReactGadgets)(gadgets)
        };
    }, (x)=>x),
    shouldUpdate: ({ sharedValue: a, reactGadgetsState: reactGadgetsState }, b)=>(0, $8b1AQ.withEitherDataOrError)((prev, next)=>JSON.stringify(next.reactGadgets) !== JSON.stringify(prev.reactGadgets) || reactGadgetsState != null && Object.values(reactGadgetsState).some((v)=>!v), ()=>true)(a, b),
    getData: (0, $dnvBi.default),
    maxAge: Infinity,
    isBrowserOnly: true
});
const $217791efaf6ffd9f$export$31b430e01a1caab5 = ()=>(0, $3HCkE.useResource)($217791efaf6ffd9f$export$39804ce8cc42cd04);
const $217791efaf6ffd9f$export$4e0719e53da01e93 = (0, $3HCkE.createResource)({
    type: (0, $b44e2c11e9a5fc89$export$bce41807cc929d0f),
    getKey: $iVB6J.getKey,
    getData: async (_, { tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        const contextIds = (0, $1ybV0.ff)('arken-1053-jira-forge-extension-changes-for-aegis_aws9x') ? [
            `ari:cloud:jira:${cloudId}:workspace/${activationId}`
        ] : undefined;
        const { extensions: extensions } = await (0, $arKaN.default)(cloudId, [
            (0, $2Rqjr.DASHBOARD_GADGET_MODULE),
            (0, $2Rqjr.DASHBOARD_BACKGROUND_SCRIPT_MODULE)
        ], null, undefined, (0, $2Rqjr.SOURCE_ROUTER), contextIds);
        return {
            gadgets: extensions.jiraDashboardGadget,
            backgroundScripts: extensions.jiraDashboardBackgroundScript
        };
    },
    maxAge: Infinity
});
const $217791efaf6ffd9f$export$36c9632be21fbb06 = (0, $3HCkE.createResource)({
    type: (0, $b44e2c11e9a5fc89$export$c07a25ebb6af1e84),
    getKey: ()=>'gadgetDirectoryItems',
    getData: (0, $6wpNP.default),
    maxAge: Infinity,
    isBrowserOnly: true
});
const $217791efaf6ffd9f$export$27f4c12e781b4572 = ()=>(0, $3HCkE.useResource)($217791efaf6ffd9f$export$36c9632be21fbb06);
const $217791efaf6ffd9f$export$75ca1b431898fd09 = ()=>(0, $3HCkE.useResource)($217791efaf6ffd9f$export$4e0719e53da01e93);
const $217791efaf6ffd9f$export$8a440775c439970b = (0, $3HCkE.createResource)({
    type: (0, $b44e2c11e9a5fc89$export$58e1e8808435e4be),
    getKey: (routerContext)=>routerContext.match.params.dashboardId ?? '',
    getData: async (routerContext)=>(0, $dCWAV.fetchAVPDashboard)(routerContext.match.params.dashboardId || undefined),
    isBrowserOnly: true
});

});
parcelRegister("dCWAV", function(module, exports) {

$parcel$export(module.exports, "fetchAVPDashboard", () => $5e6b53ba99dd503d$export$bb199af7bdde568);

var $2OdyW = parcelRequire("2OdyW");

var $bH1to = parcelRequire("bH1to");
const $5e6b53ba99dd503d$export$bb199af7bdde568 = (dashboardId = '')=>{
    const workspace = (0, $bH1to.getAVPWorkspaceId)();
    return (0, $2OdyW.default)(`/gateway/api/avp/workspaceId/${workspace}/api/organizations/${workspace}/dashboards/${dashboardId}`);
};

});
parcelRegister("bH1to", function(module, exports) {

$parcel$export(module.exports, "getAVPWorkspaceId", () => $7edf780192e7d648$export$7cc27f669524fe53);
/**
 * Returns the workspace id of the jira avp instance.
 *
 * @returns the workspace id.
 */ const $7edf780192e7d648$export$7cc27f669524fe53 = ()=>'1d6b5eef-c56f-4a73-bf9e-758cf7eeb7e8';

});


parcelRegister("8b1AQ", function(module, exports) {

$parcel$export(module.exports, "withEitherDataOrError", () => $8a3f6d6901b27150$export$54e973088fdd59a1);
$parcel$export(module.exports, "createDependentResource", () => $8a3f6d6901b27150$export$7f8dd41bdfd85a47);
$parcel$export(module.exports, "SharedValueAggregateError", () => $8a3f6d6901b27150$export$36d5102d613df7c6);

var $3HCkE = parcelRequire("3HCkE");
const $8a3f6d6901b27150$export$54e973088fdd59a1 = (dataFn, errorFn)=>(...args)=>{
        const invalidArgs = args.filter((v)=>v == null || v instanceof Error);
        return invalidArgs.length ? errorFn(invalidArgs[0]) : dataFn(...args);
    };
const $8a3f6d6901b27150$export$fcdc85dfc621ec7a = (dependencies, type)=>{
    // the standard in react-resource-router is to fail getData() for dependency errors
    const { [type]: resourceSlice } = dependencies;
    if (!resourceSlice) throw new (0, $3HCkE.ResourceDependencyError)(`Cannot decode dependency "${type}", it may be missing from resource depends field`);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return resourceSlice.data;
};
const $8a3f6d6901b27150$export$bee6a631bfb54474 = (dependencies, type)=>{
    // the standard in react-resource-router is to fail getData() for dependency errors
    const { [type]: resourceSlice } = dependencies;
    if (!resourceSlice) throw new Error(`Cannot decode dependency: "${type}" must be included in the resource depends field`);
    // prefer previous value rather than error
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { loading: loading, data: data, promise: promise, error: error } = resourceSlice;
    return loading && promise ? promise.then((v)=>v, (e)=>data ?? e) : data ?? error;
};
const $8a3f6d6901b27150$export$7f8dd41bdfd85a47 = ({ type: type, depends: depends, mapToSharedValue: mapToSharedValue, shouldUpdate: shouldUpdate, getData: getData, ...rest })=>(0, $3HCkE.createResource)({
        ...rest,
        type: type,
        depends: [
            ...depends,
            type
        ],
        getData: (dataContext, storeContext)=>{
            const { dependencies: dependencies } = dataContext;
            const prevValue = $8a3f6d6901b27150$export$fcdc85dfc621ec7a(dependencies, type);
            const valuesOrPromises = depends.map((d)=>$8a3f6d6901b27150$export$bee6a631bfb54474(dependencies, d));
            const implementation = (depDataOrErrorOrNull)=>{
                const newShared = mapToSharedValue(...depDataOrErrorOrNull);
                return prevValue == null || prevValue instanceof Error || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                shouldUpdate(prevValue, newShared) ? getData(prevValue, newShared)(dataContext, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                storeContext) : prevValue;
            };
            return valuesOrPromises.some((v)=>v instanceof Promise) ? Promise.allSettled(valuesOrPromises).then((arr)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                arr.map((v)=>v.status === 'fulfilled' ? v.value : v.reason)).then(implementation) : implementation(valuesOrPromises);
        }
    });
class $8a3f6d6901b27150$export$36d5102d613df7c6 extends Error {
    constructor({ name: name, isPrefetch: isPrefetch, sharedValue: sharedValue }){
        super(`${name} is missing dependency, prefetch [${isPrefetch}] sharedValue [${sharedValue}]`);
        this.skipSentry = true;
    }
}

});

parcelRegister("iVB6J", function(module, exports) {

$parcel$export(module.exports, "getKey", () => $4e1b21534c9736b6$export$a47fb462a08de82f);

var $exb0h = parcelRequire("exb0h");

var $kEBPk = parcelRequire("kEBPk");
const $4e1b21534c9736b6$export$a47fb462a08de82f = ({ route: route, query: query, match: { params: params } })=>{
    if (route.name === (0, $exb0h.ROUTE_NAMES).SYSTEM_DASHBOARD_EDIT) return 0, $kEBPk.SYSTEM_DASHBOARD_ID;
    if (route.name === (0, $exb0h.ROUTE_NAMES).DASHBOARD_WALLBOARD) // NOTE - Currently we will only load the first dashboard in the list
    return query.dashboardId?.split(',')[0];
    return params.dashboardId?.replace('last-visited', 'lastVisited') ?? query.selectPageId ?? 'lastVisited';
};

});
parcelRegister("kEBPk", function(module, exports) {

$parcel$export(module.exports, "GADGET_DISPLAY", () => $e4f2a654a0481d70$export$d7e1dfcefcde2410);
$parcel$export(module.exports, "MAXIMIZED_PARAM", () => $e4f2a654a0481d70$export$86eaa19ea940a4f5);
$parcel$export(module.exports, "CONNECT_ITEM_AMD_MODULE", () => $e4f2a654a0481d70$export$a1baea8b97610fd);
$parcel$export(module.exports, "WEB_RESOURCE_MAP", () => $e4f2a654a0481d70$export$c6d360a8456d120a);
$parcel$export(module.exports, "PRELOADED_GADGET_DATA_KEY", () => $e4f2a654a0481d70$export$30b970d16c2f5e0a);
$parcel$export(module.exports, "SYSTEM_DASHBOARD_ID", () => $e4f2a654a0481d70$export$50eac80bcbebc737);
$parcel$export(module.exports, "DASHBOARD_HEADER_HEIGHT", () => $e4f2a654a0481d70$export$e11ffd0409aa6522);
$parcel$export(module.exports, "FOOTER_MARGIN", () => $e4f2a654a0481d70$export$4d708f4c16ae3a73);
$parcel$export(module.exports, "GADGET_LOCAL_STORAGE_NAME", () => $e4f2a654a0481d70$export$255117c9adec50a5);
$parcel$export(module.exports, "DASHBOARD_LOCAL_STORAGE_KEY_NAME", () => $e4f2a654a0481d70$export$e281465c09f561d4);
$parcel$export(module.exports, "GADGET_DEFAULT_HEIGHT", () => $e4f2a654a0481d70$export$46dd0168a7875b47);
$parcel$export(module.exports, "COLOR_MAP", () => $e4f2a654a0481d70$export$1468aefba37090f9);
$parcel$export(module.exports, "COLOR_NAME_MAP", () => $e4f2a654a0481d70$export$5d9e688e192a63ae);
$parcel$export(module.exports, "COLOR_CHECKMARK_MAP", () => $e4f2a654a0481d70$export$6906a4beef307ac4);
$parcel$export(module.exports, "MODAL_ID", () => $e4f2a654a0481d70$export$ebdd5a8e5b1c2de5);
$parcel$export(module.exports, "LAYOUTS", () => $e4f2a654a0481d70$export$87e50aced9c52ebb);
$parcel$export(module.exports, "GADGET_HEIGHT_UPDATE_WAIT_TIME", () => $e4f2a654a0481d70$export$b0234a47b1a4a515);
$parcel$export(module.exports, "GADGET_DRAG_CONTAINER_HEIGHT", () => $e4f2a654a0481d70$export$9674cd14c20d1c89);
$parcel$export(module.exports, "GADGET_METRICS_TYPE", () => $e4f2a654a0481d70$export$46b6c8eb53069613);
$parcel$export(module.exports, "PAGE_READY_METRIC_KEY", () => $e4f2a654a0481d70$export$464d2a6bcb398791);
$parcel$export(module.exports, "DELETE_DASHBOARD_EXPERIENCE", () => $e4f2a654a0481d70$export$4f74f1f13671c49d);
$parcel$export(module.exports, "COPY_DASHBOARD_EXPERIENCE", () => $e4f2a654a0481d70$export$3853fce65645c557);
$parcel$export(module.exports, "DASHBOARD_AUTOMATIC_REFRESH_EXPERIENCE", () => $e4f2a654a0481d70$export$c8c77659771c38b9);
$parcel$export(module.exports, "RENAME_OR_SHARE_DASHBOARD_EXPERIENCE", () => $e4f2a654a0481d70$export$707702c47e5b9648);
$parcel$export(module.exports, "CREATE_DASHBOARD_EXPERIENCE", () => $e4f2a654a0481d70$export$efbab4efa7252143);
$parcel$export(module.exports, "VIEW_DASHBOARD_EDITABLE_EXPERIENCE", () => $e4f2a654a0481d70$export$7b6f3ec1189de156);
$parcel$export(module.exports, "VIEW_DASHBOARD_READONLY_EXPERIENCE", () => $e4f2a654a0481d70$export$f0e105144716a420);
$parcel$export(module.exports, "VIEW_DASHBOARD_READONLY_EMBED_EXPERIENCE", () => $e4f2a654a0481d70$export$5ba84cd082269cd5);
$parcel$export(module.exports, "VIEW_DASHBOARD_WALLBOARD_READONLY_EXPERIENCE", () => $e4f2a654a0481d70$export$6c84c6099fed3c23);
$parcel$export(module.exports, "VIEW_AVP_DASHBOARD_READONLY_EXPERIENCE", () => $e4f2a654a0481d70$export$405a15b278cb4397);
$parcel$export(module.exports, "ADD_GADGET_EXPERIENCE", () => $e4f2a654a0481d70$export$3b17b4f7f722b1ae);
$parcel$export(module.exports, "SAVE_AMD_GADGET_CONFIG_PREFERENCES", () => $e4f2a654a0481d70$export$c8900d7e874d42ca);
$parcel$export(module.exports, "SAVE_FORGE_GADGET_CONFIG_PREFERENCES", () => $e4f2a654a0481d70$export$bac5a3e9d008da59);
$parcel$export(module.exports, "SAVE_CUSTOM_GADGET_TITLE_PREFERENCES", () => $e4f2a654a0481d70$export$18b54b2c53cf6acd);
$parcel$export(module.exports, "VIEW_WRM_GADGET_EXPERIENCE", () => $e4f2a654a0481d70$export$a3d5b76ea0c8f4ca);
$parcel$export(module.exports, "CHANGE_LAYOUT_EXPERIENCE", () => $e4f2a654a0481d70$export$7254246f25b4cbc8);
$parcel$export(module.exports, "DELETE_GADGET_EXPERIENCE", () => $e4f2a654a0481d70$export$40c4d345e57fce2d);
$parcel$export(module.exports, "VIEW_REACT_GADGET_EXPERIENCE", () => $e4f2a654a0481d70$export$43fb10a4d8374f1a);
$parcel$export(module.exports, "DASHBOARD_VIEW_SOURCENAME", () => $e4f2a654a0481d70$export$2f961c74af6d8735);
$parcel$export(module.exports, "DASHBOARD_VIEW_EMBED_SOURCENAME", () => $e4f2a654a0481d70$export$dab1096b356df1cc);
$parcel$export(module.exports, "DASHBOARD_AVP_VIEW_SOURCENAME", () => $e4f2a654a0481d70$export$2e059160a491e01e);
$parcel$export(module.exports, "DASHBOARD_EDIT_SOURCENAME", () => $e4f2a654a0481d70$export$32f0edca4eebb9c7);
$parcel$export(module.exports, "DASHBOARD_WALLBOARD_VIEW_SOURCENAME", () => $e4f2a654a0481d70$export$791f7067c41dc5b1);
$parcel$export(module.exports, "SYSTEM_DASHBOARD_EDIT_SOURCENAME", () => $e4f2a654a0481d70$export$eba1a497984af3ae);
$parcel$export(module.exports, "COPY_DASHBOARD", () => $e4f2a654a0481d70$export$3578044b625436f9);
$parcel$export(module.exports, "DASHBOARD_AUTOMATIC_REFRESH", () => $e4f2a654a0481d70$export$48bb59a846d62ea0);
$parcel$export(module.exports, "DELETE_DASHBOARD", () => $e4f2a654a0481d70$export$e7dfbcf33cf2b19a);
$parcel$export(module.exports, "DUPLICATE_GADGET_EXPERIENCE", () => $e4f2a654a0481d70$export$fabf79b25b44377f);
$parcel$export(module.exports, "RENAME_OR_SHARE_DASHBOARD", () => $e4f2a654a0481d70$export$abba919f32a1a776);
$parcel$export(module.exports, "GADGET_ERROR_TYPE", () => $e4f2a654a0481d70$export$768dad6811159849);
$parcel$export(module.exports, "MAX_ALLOWED_GADGETS_COUNT", () => $e4f2a654a0481d70$export$e11360046219e002);
$parcel$export(module.exports, "DASHBOARD_REFRESH_LOAD_BUFFER_MS", () => $e4f2a654a0481d70$export$ada294d471e7dfc3);
$parcel$export(module.exports, "MAX_GADGETS_COUNT_INCLUDE_IGNORED_GADGETS", () => $e4f2a654a0481d70$export$2ea683536c2351db);
$parcel$export(module.exports, "IGNORED_GADGETS_FROM_COUNT_MAP", () => $e4f2a654a0481d70$export$7f4c0fee173151d3);
$parcel$export(module.exports, "REFRESH_LABEL_UPDATE_INTERVAL", () => $e4f2a654a0481d70$export$f4280aaeba4d1d08);
$parcel$export(module.exports, "CONNECT_GADGET_REFRESH_REQUEST_EVENT", () => $e4f2a654a0481d70$export$685171fdf5112bc4);
$parcel$export(module.exports, "FORGE_JIRA_DASHBOARD_GADGET_REFRESH_EVENT", () => $e4f2a654a0481d70$export$4d8c12b9aaeac619);
$parcel$export(module.exports, "ISSUE_SEARCH_DEFAULT_COLUMNS", () => $e4f2a654a0481d70$export$f07dac7b8de3bda);

var $PdmhA = parcelRequire("PdmhA");

var $c9TLT = parcelRequire("c9TLT");

var $e1itL = parcelRequire("e1itL");
const $e4f2a654a0481d70$export$d7e1dfcefcde2410 = {
    MAXIMIZED: 'maximized',
    NORMAL: 'normal',
    HIDDEN: 'hidden'
};
const $e4f2a654a0481d70$export$86eaa19ea940a4f5 = 'maximized';
const $e4f2a654a0481d70$export$a1baea8b97610fd = 'atlassian-connect/connect-dashboard-item';
const $e4f2a654a0481d70$export$c6d360a8456d120a = {
    'jira-dashboard-items/assigned-to-me': 'com.atlassian.jira.gadgets:assigned-to-me-dashboard-item-resources',
    'jira-dashboard-items/filter-results': 'com.atlassian.jira.gadgets:filter-results-dashboard-item-resources',
    'jira-dashboard-items/createdvsresolved': 'com.atlassian.jira.gadgets:createdvsresolved-dashboard-item-resources',
    'jira-dashboard-items/favourite-filters': 'com.atlassian.jira.gadgets:favourite-filters-dashboard-item-resources',
    'jira-dashboard-items/in-progress': 'com.atlassian.jira.gadgets:in-progress-dashboard-item-resources',
    'jira-dashboard-items/stats': 'com.atlassian.jira.gadgets:stats-dashboard-item-resources',
    'jira-dashboard-items/watched': 'com.atlassian.jira.gadgets:watched-dashboard-item-resources',
    'jira-dashboard-items/labels': 'com.atlassian.jira.gadgets:labels-dashboard-item-resources',
    'jira-dashboard-items/bubble-chart-dashboard-item': 'com.atlassian.jira.gadgets:bubble-chart-dashboard-item-resources',
    'jira-dashboard-items/piechart': 'com.atlassian.jira.gadgets:piechart-dashboard-item-resources',
    'jira-dashboard-items/voted': 'com.atlassian.jira.gadgets:voted-dashboard-item-resources',
    'jira-dashboard-items/two-dimensional-stats': 'com.atlassian.jira.gadgets:two-dimensional-stats-dashboard-item-resources',
    'jira-dashboard-items/sprint-health': 'com.pyxis.greenhopper.jira:greenhopper-sprint-health-dashboard-item-resources',
    'jira-dashboard-items/sprint-days-remaining': 'com.pyxis.greenhopper.jira:greenhopper-days-remaining-dashboard-item-resources',
    'servicedesk/internal/dashboard-items/filter/filter-dashboard-item': 'com.atlassian.servicedesk.dashboard-items-plugin:spa-filter-dashboard-item-resources',
    'servicedesk/internal/reports/feature/custom-report-dashboard-item/custom-report-dashboard-item': 'com.atlassian.servicedesk.servicedesk-reports-plugin:custom-report-dashboard-item-resources-spa',
    'jira-dashboard-items/projects': 'com.atlassian.jira.gadgets:projects-dashboard-item-resources',
    'jira-dashboard-items/issuescalendar': 'com.atlassian.jira.ext.calendar:issues-calendar-dashboard-item-resources',
    'jira-dashboard-items/activitystream': 'com.atlassian.streams.streams-jira-plugin:activitystream-dashboard-item-resources',
    'jira-dashboard-items/recently-created': 'com.atlassian.jira.gadgets:recently-created-chart-dashboard-item-resources',
    'jira-dashboard-items/resolution-time': 'com.atlassian.jira.gadgets:resolution-time-dashboard-item-resources',
    'jira-dashboard-items/timesince': 'com.atlassian.jira.gadgets:timesince-dashboard-item-resources',
    'jira-dashboard-items/spacer': 'com.atlassian.jira.gadgets:spacer-dashboard-item-resources',
    'jira-dashboard-items/sprint-burndown': 'com.pyxis.greenhopper.jira:greenhopper-sprint-burndown-dashboard-item-resources',
    'jira-dashboard-items/workload-pie-chart': 'com.atlassian.jira.gadgets:workload-pie-chart-dashboard-item-resources',
    'jira-dashboard-items/roadmap': 'com.atlassian.jira.gadgets:roadmap-dashboard-item-resources',
    'jira-dashboard-items/average-age-chart': 'com.atlassian.jira.gadgets:average-age-chart-dashboard-item-resources',
    'jira-dashboard-items/average-time-in-status-chart': 'com.atlassian.jira.gadgets:average-time-in-status-chart-dashboard-item-resources',
    'jira-dashboard-items/average-number-of-times-in-status-chart': 'com.atlassian.jira.gadgets:average-number-of-times-in-status-chart-dashboard-item-resources',
    'jira-dashboard-items/heat-map': 'com.atlassian.jira.gadgets:heat-map-dashboard-item-resources',
    'jira-dashboard-items/time-to-first-response': 'com.atlassian.jira.gadgets:time-to-first-response-dashboard-item-resources',
    'jira-dashboard-items/rapid-view': 'com.pyxis.greenhopper.jira:greenhopper-rapid-view-dashboard-item-resources',
    'jira-dashboard-items/version-report': 'com.pyxis.greenhopper.jira:greenhopper-version-report-dashboard-item-resources'
};
const $e4f2a654a0481d70$export$30b970d16c2f5e0a = 'DASHBOARD_GADGET_PRELOADED_DATA';
const $e4f2a654a0481d70$export$50eac80bcbebc737 = '10000';
const $e4f2a654a0481d70$export$e11ffd0409aa6522 = (0, $c9TLT.gridSize) * 10;
const $e4f2a654a0481d70$export$4d708f4c16ae3a73 = (0, $c9TLT.gridSize) * 2;
const $e4f2a654a0481d70$export$504bf5c8f7d402e9 = (0, $c9TLT.gridSize) * 3;
const $e4f2a654a0481d70$export$255117c9adec50a5 = 'AG.congolmerate.cookie';
const $e4f2a654a0481d70$export$e281465c09f561d4 = 'dashboard-data';
const $e4f2a654a0481d70$export$46dd0168a7875b47 = 160;
const $e4f2a654a0481d70$var$COLOR_BLUE = '#2684ff';
const $e4f2a654a0481d70$var$COLOR_RED = '#ff5630';
const $e4f2a654a0481d70$var$COLOR_YELLOW = '#ffab00';
const $e4f2a654a0481d70$var$COLOR_GREEN = '#36b37e';
const $e4f2a654a0481d70$var$COLOR_TEAL = '#00b8d9';
const $e4f2a654a0481d70$var$COLOR_PURPLE = '#6554c0';
const $e4f2a654a0481d70$var$COLOR_GRAY = '#97a0af';
const $e4f2a654a0481d70$var$COLOR_WHITE = '#ffffff';
const $e4f2a654a0481d70$export$1468aefba37090f9 = {
    color1: $e4f2a654a0481d70$var$COLOR_BLUE,
    color2: $e4f2a654a0481d70$var$COLOR_RED,
    color3: $e4f2a654a0481d70$var$COLOR_YELLOW,
    color4: $e4f2a654a0481d70$var$COLOR_GREEN,
    color5: $e4f2a654a0481d70$var$COLOR_TEAL,
    color6: $e4f2a654a0481d70$var$COLOR_PURPLE,
    color7: $e4f2a654a0481d70$var$COLOR_GRAY,
    color8: $e4f2a654a0481d70$var$COLOR_WHITE
};
const $e4f2a654a0481d70$export$5d9e688e192a63ae = {
    [$e4f2a654a0481d70$var$COLOR_BLUE]: (0, $e1itL.default).blue,
    [$e4f2a654a0481d70$var$COLOR_RED]: (0, $e1itL.default).red,
    [$e4f2a654a0481d70$var$COLOR_YELLOW]: (0, $e1itL.default).yellow,
    [$e4f2a654a0481d70$var$COLOR_GREEN]: (0, $e1itL.default).green,
    [$e4f2a654a0481d70$var$COLOR_TEAL]: (0, $e1itL.default).teal,
    [$e4f2a654a0481d70$var$COLOR_PURPLE]: (0, $e1itL.default).purple,
    [$e4f2a654a0481d70$var$COLOR_GRAY]: (0, $e1itL.default).gray,
    [$e4f2a654a0481d70$var$COLOR_WHITE]: (0, $e1itL.default).white
};
const $e4f2a654a0481d70$export$6906a4beef307ac4 = {
    color1: (0, $PdmhA).N10,
    color2: (0, $PdmhA).N10,
    color3: (0, $PdmhA).N500,
    color4: (0, $PdmhA).N10,
    color5: (0, $PdmhA).N500,
    color6: (0, $PdmhA).N10,
    color7: (0, $PdmhA).N10,
    color8: (0, $PdmhA).N500
};
const $e4f2a654a0481d70$export$ebdd5a8e5b1c2de5 = {
    EDIT_LAYOUT: 'edit-layout',
    DASHBOARD_COPY: 'dashboard-copy',
    AUTOMATIC_REFRESH: 'dashboard-automatic-refresh',
    DASHBOARD_RENAME_OR_SHARE: 'dashboard-rename-or-share',
    DASHBOARD_DELETE: 'dashboard-delete',
    CONFIGURE_WALLBOARD: 'configure-wallboard',
    DASHBOARD_CREATE: 'dashboard-create-on-dashboard-page'
};
const $e4f2a654a0481d70$export$87e50aced9c52ebb = [
    'A',
    'AA',
    'AAA',
    'BA',
    'AB'
];
const $e4f2a654a0481d70$export$b0234a47b1a4a515 = 350;
const $e4f2a654a0481d70$export$9674cd14c20d1c89 = 250;
const $e4f2a654a0481d70$export$46b6c8eb53069613 = {
    REPORT: 'REPORT_GADGET_METRICS',
    TIMEOUT: 'TIMEOUT_GADGET_METRICS'
};
const $e4f2a654a0481d70$export$464d2a6bcb398791 = 'JIRA_SPA_PAGE_READY';
const $e4f2a654a0481d70$export$4f74f1f13671c49d = 'delete-dashboard';
const $e4f2a654a0481d70$export$3853fce65645c557 = 'copy-dashboard';
const $e4f2a654a0481d70$export$c8c77659771c38b9 = 'dashboard-automatic-refresh';
const $e4f2a654a0481d70$export$707702c47e5b9648 = 'rename-or-share-dashboard';
const $e4f2a654a0481d70$export$efbab4efa7252143 = 'create-dashboard';
const $e4f2a654a0481d70$export$7b6f3ec1189de156 = 'view-dashboard-editable';
const $e4f2a654a0481d70$export$f0e105144716a420 = 'view-dashboard-readonly';
const $e4f2a654a0481d70$export$5ba84cd082269cd5 = 'view-dashboard-readonly-embed';
const $e4f2a654a0481d70$export$6c84c6099fed3c23 = 'view-dashboard-wallboard-readonly';
const $e4f2a654a0481d70$export$405a15b278cb4397 = 'view-avp-dashboard-readonly';
const $e4f2a654a0481d70$export$3b17b4f7f722b1ae = 'add-gadget';
const $e4f2a654a0481d70$export$c8900d7e874d42ca = 'save-amd-gadget-config';
const $e4f2a654a0481d70$export$bac5a3e9d008da59 = 'save-forge-gadget-config';
const $e4f2a654a0481d70$export$18b54b2c53cf6acd = 'save-custom-gadget-title-config';
const $e4f2a654a0481d70$export$a3d5b76ea0c8f4ca = 'view-wrm-gadget';
const $e4f2a654a0481d70$export$7254246f25b4cbc8 = 'change-layout';
const $e4f2a654a0481d70$export$40c4d345e57fce2d = 'delete-gadget';
const $e4f2a654a0481d70$export$43fb10a4d8374f1a = 'view-react-gadget';
const $e4f2a654a0481d70$export$2f961c74af6d8735 = 'dashboardView';
const $e4f2a654a0481d70$export$dab1096b356df1cc = 'dashboardViewEmbed';
const $e4f2a654a0481d70$export$2e059160a491e01e = 'dashboardAvpView';
const $e4f2a654a0481d70$export$32f0edca4eebb9c7 = 'dashboardEdit';
const $e4f2a654a0481d70$export$791f7067c41dc5b1 = 'dashboardWallboardView';
const $e4f2a654a0481d70$export$eba1a497984af3ae = 'systemDashboardEdit';
const $e4f2a654a0481d70$export$3578044b625436f9 = 'copyDashboard';
const $e4f2a654a0481d70$export$48bb59a846d62ea0 = 'automaticRefresh';
const $e4f2a654a0481d70$export$e7dfbcf33cf2b19a = 'deleteDashboard';
const $e4f2a654a0481d70$export$fabf79b25b44377f = 'duplicateGadget';
const $e4f2a654a0481d70$export$abba919f32a1a776 = 'renameOrShareDashboard';
const $e4f2a654a0481d70$export$768dad6811159849 = {
    VIEW_ERROR: 'viewError',
    EDIT_ERROR: 'editError',
    CONFIG_ERROR: 'configError',
    NOT_SUPPORTED_ERROR: 'notSupportedError'
};
const $e4f2a654a0481d70$export$f8e04d62c0b5d07e = /^endeavour\.(spa|dashboard|gadget)\.[\w-]+$/;
const $e4f2a654a0481d70$export$e11360046219e002 = 20;
const $e4f2a654a0481d70$export$ada294d471e7dfc3 = 1000;
const $e4f2a654a0481d70$export$2ea683536c2351db = 50;
const $e4f2a654a0481d70$export$7f4c0fee173151d3 = {
    'rest/gadgets/1.0/g/com.atlassian.jira.atlassian-wallboard-plugin:spacer-gadget/gadgets/spacerGadget.xml': 'jira-dashboard-items/spacer'
};
const $e4f2a654a0481d70$export$f4280aaeba4d1d08 = 30000;
const $e4f2a654a0481d70$export$685171fdf5112bc4 = 'jira_dashboard_item_refresh';
const $e4f2a654a0481d70$export$4d8c12b9aaeac619 = 'JIRA_DASHBOARD_GADGET_REFRESH';
const $e4f2a654a0481d70$export$f07dac7b8de3bda = [
    'issuetype',
    'issuekey',
    'summary',
    'priority'
];

});
parcelRegister("e1itL", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb4a8cfceb6e56fe$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $bb4a8cfceb6e56fe$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    blue: {
        "id": "dashboard-common.blue",
        "defaultMessage": "Blue"
    },
    red: {
        "id": "dashboard-common.red",
        "defaultMessage": "Red"
    },
    yellow: {
        "id": "dashboard-common.yellow",
        "defaultMessage": "Yellow"
    },
    green: {
        "id": "dashboard-common.green",
        "defaultMessage": "Green"
    },
    teal: {
        "id": "dashboard-common.teal",
        "defaultMessage": "Teal"
    },
    purple: {
        "id": "dashboard-common.purple",
        "defaultMessage": "Purple"
    },
    gray: {
        "id": "dashboard-common.gray",
        "defaultMessage": "Gray"
    },
    white: {
        "id": "dashboard-common.white",
        "defaultMessage": "White"
    }
});

});



const $b44e2c11e9a5fc89$export$ca03ff6cc792cc16 = 'DASHBOARD_CONFIG_AND_WRM';
const $b44e2c11e9a5fc89$export$e239393fd4e2bc85 = 'DASHBOARD_AMD_MODULES';
const $b44e2c11e9a5fc89$export$9e5db01432b13b67 = 'DASHBOARD_REACT_GADGETS';
const $b44e2c11e9a5fc89$export$dd4bac16c565acb1 = 'DASHBOARD_FORGE_GADGETS';
const $b44e2c11e9a5fc89$export$bce41807cc929d0f = 'DASHBOARD_FORGE';
const $b44e2c11e9a5fc89$export$c07a25ebb6af1e84 = 'DASHBOARD_GADGET_DIRECTORY';
const $b44e2c11e9a5fc89$export$58e1e8808435e4be = 'AVP_DASHBOARD';

parcelRegister("2P6WI", function(module, exports) {

$parcel$export(module.exports, "default", () => $3befe6799fde3b06$export$2e2bcd8739ae039);

var $16kIm = parcelRequire("16kIm");

var $8b1AQ = parcelRequire("8b1AQ");

var $3G0rV = parcelRequire("3G0rV");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3befe6799fde3b06$export$2e2bcd8739ae039 = (_maybePrevData, sharedValue)=>({ isPrefetch: isPrefetch })=>{
        if (!sharedValue || sharedValue instanceof Error) throw new (0, $8b1AQ.SharedValueAggregateError)({
            sharedValue: sharedValue,
            isPrefetch: isPrefetch,
            name: 'AMD modules resource'
        });
        return (async ()=>{
            const { moduleNames: moduleNames, isPreloaded: isPreloaded } = sharedValue;
            const maybePromiseAmdModules = isPreloaded || await (0, $3G0rV.loadAmdModules)((0, $16kIm.asyncWrmRequire), moduleNames) ? (0, $3G0rV.evalAmdModules)(moduleNames) : null;
            const amdModules = maybePromiseAmdModules instanceof Promise ? await maybePromiseAmdModules : maybePromiseAmdModules;
            return {
                sharedValue: sharedValue,
                amdModules: amdModules
            };
        })();
    };

});
parcelRegister("3G0rV", function(module, exports) {

$parcel$export(module.exports, "loadAmdModules", () => $bdb0cde0ec4f6018$export$2c79895bd69a8d54);
$parcel$export(module.exports, "evalAmdModules", () => $bdb0cde0ec4f6018$export$d74eab33af9baaea);

var $gUUjF = parcelRequire("gUUjF");

var $kEBPk = parcelRequire("kEBPk");
/**
 * Dummy implementation for a Connect gadget, as rendering and editing are
 * managed externally.
 */ class $bdb0cde0ec4f6018$var$ConnectDashboardItem {
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    render() {}
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    renderEdit() {}
}
const $bdb0cde0ec4f6018$export$3bf37adbbdcafcc8 = (moduleName, retries = 5)=>{
    try {
        if (typeof window.require !== 'function') throw new TypeError('window.require is not a function');
        return window.require(moduleName);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // amd module could throw a non-Error
        if (error instanceof Error && /^No \S+$|^\S+ missing \S+$/.test(error.message)) {
            // some AMD modules have define() inside a require() block in which case the module is not immediately ready to be window.require()'d
            // this is due to the 4ms timeout in requirejs' require(), we need a retry logic here to make sure the module is loaded.
            // see the comment section for https://jdog.jira-dev.com/browse/WRM-71
            if (retries > 0) return new Promise((r)=>setTimeout(r, 100)).then(()=>$bdb0cde0ec4f6018$export$3bf37adbbdcafcc8(moduleName, retries - 1));
        }
        throw error;
    }
};
const $bdb0cde0ec4f6018$export$2c79895bd69a8d54 = async (wrmRequire, moduleNames)=>{
    if (moduleNames.length === 0) return false;
    const prefixedAmdResources = moduleNames.map((amdModule)=>(0, $kEBPk.WEB_RESOURCE_MAP)[amdModule]).map((resourceName)=>`wrc!${resourceName}`);
    try {
        // no result from the promise only the side effect of having loaded the AMD module via WRM
        await wrmRequire(prefixedAmdResources);
        return true;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.resource', `Failed to load web resources [${prefixedAmdResources.join(',')}]`, error);
        return false;
    }
};
const $bdb0cde0ec4f6018$var$getSortedModuleNamesFromTuples = (tuples)=>tuples.map(([moduleName])=>moduleName).sort((a, b)=>a.localeCompare(b)).join(',');
const $bdb0cde0ec4f6018$export$d74eab33af9baaea = (amdModuleNames)=>{
    const tuplesOrPromises = amdModuleNames.map((amdModuleName)=>{
        try {
            const module = amdModuleName === (0, $kEBPk.CONNECT_ITEM_AMD_MODULE) ? $bdb0cde0ec4f6018$var$ConnectDashboardItem : $bdb0cde0ec4f6018$export$3bf37adbbdcafcc8(amdModuleName);
            return module instanceof Promise ? module.then((v)=>[
                    amdModuleName,
                    v
                ]) : [
                amdModuleName,
                module
            ];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            return Promise.reject(error);
        }
    });
    const hasPromise = tuplesOrPromises.some((entry)=>entry instanceof Promise);
    if (!hasPromise) {
        (0, $gUUjF.default).safeInfoWithoutCustomerData('spa-apps.dashboard.resource', 'Successful synchronous bulk eval AMD modules');
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Object.fromEntries(tuplesOrPromises);
    }
    return Promise.allSettled(tuplesOrPromises).then((results)=>{
        const tuples = results.map((result, i)=>{
            if (result.status === 'fulfilled') return result.value;
            const { reason: error } = result;
            const amdModuleName = amdModuleNames[i];
            const message = error instanceof Error ? error.message : String(error);
            (0, $gUUjF.default).safeErrorWithoutCustomerData('spa-apps.dashboard.resource', `Failed bulk eval AMD module [${amdModuleName}] with error [${message}]`, error);
            return [
                amdModuleName,
                null
            ];
        });
        const failedTuples = tuples.filter((module)=>module[1] === null);
        failedTuples.length > 0 ? (0, $gUUjF.default).safeErrorWithoutCustomerData('spa-apps.dashboard.resource', `Failed bulk eval AMD modules [${$bdb0cde0ec4f6018$var$getSortedModuleNamesFromTuples(failedTuples)}]`) : (0, $gUUjF.default).safeInfoWithoutCustomerData('spa-apps.dashboard.resource', 'Successful asynchronous bulk eval AMD modules');
        return Object.fromEntries(tuples);
    });
};

});


parcelRegister("gKtDv", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ba5531603412124$export$2e2bcd8739ae039);

var $exb0h = parcelRequire("exb0h");

var $b32xd = parcelRequire("b32xd");

var $2VeIs = parcelRequire("2VeIs");

var $gUvw9 = parcelRequire("gUvw9");

var $2OLBQ = parcelRequire("2OLBQ");

var $hPXQA = parcelRequire("hPXQA");

var $iVB6J = parcelRequire("iVB6J");

var $g8TlX = parcelRequire("g8TlX");
const $3ba5531603412124$var$generateScriptTagAndPreloadedModuleNames = async (configs)=>{
    const gadgets = configs.flatMap((config)=>config.gadgets);
    const preloadedModuleNames = (0, $g8TlX.gadgetsToUniqueSortedAmdModules)(gadgets);
    const wrmBundleDescriptor = await (0, $gUvw9.default)(preloadedModuleNames);
    return configs.map((config)=>{
        const scriptTags = [
            wrmBundleDescriptor ? (0, $hPXQA.default)(wrmBundleDescriptor) : null,
            (0, $2OLBQ.default)(config)
        ].filter(Boolean).join('\n') || null;
        return {
            ...config,
            scriptTags: scriptTags,
            preloadedModuleNames: preloadedModuleNames
        };
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3ba5531603412124$export$2e2bcd8739ae039 = async (context)=>{
    // this is either for single dashboard/wallboard or wallboard slide show with multiple dashboards
    const { route: route, query: query } = context;
    const originalConfigs = route.name === (0, $exb0h.ROUTE_NAMES).DASHBOARD_WALLBOARD ? await (0, $2VeIs.getDashboardsConfig)(query.dashboardId) : [
        await (0, $2VeIs.default)((0, $iVB6J.getKey)(context))
    ];
    const configs = originalConfigs.map((config)=>({
            ...config,
            gadgets: (0, $b32xd.mapToReactGadgets)(config.gadgets)
        }));
    if (!false) return configs.map((config)=>({
            ...config,
            preloadedModuleNames: []
        }));
    return $3ba5531603412124$var$generateScriptTagAndPreloadedModuleNames(configs);
};

});
parcelRegister("b32xd", function(module, exports) {

$parcel$export(module.exports, "mapToReactGadgets", () => $8925989550454392$export$c90615c5eb218d50);

var $1ybV0 = parcelRequire("1ybV0");
const $8925989550454392$export$c90615c5eb218d50 = (gadgets)=>{
    const gadgetMapping = {
        ...(0, $1ybV0.ff)('endeavour.gadget.nin-filter-results-gadget') ? {
            'jira-dashboard-items/filter-results': 'react/filter-results'
        } : {},
        'servicedesk/internal/reports/feature/custom-report-dashboard-item/custom-report-dashboard-item': 'react/custom-report',
        ...(0, $1ybV0.ff)('endeavour.gadget.nin-assigned-to-me-gadget') ? {
            'jira-dashboard-items/assigned-to-me': 'react/assigned-to-me'
        } : {},
        ...(0, $1ybV0.ff)('endeavour.gadget.nin-issues-in-progress-gadget') ? {
            'jira-dashboard-items/in-progress': 'react/issues-in-progress'
        } : {},
        ...(0, $1ybV0.ff)('endeavour.gadget.nin-voted-issues-gadget') ? {
            'jira-dashboard-items/voted': 'react/voted-issues'
        } : {},
        ...(0, $1ybV0.ff)('endeavour.gadget.nin-watched-issues-gadget') ? {
            'jira-dashboard-items/watched': 'react/watched-issues'
        } : {}
    }; // satisfies Record<string, ReactKey>; SSR image build Thread Loader doesn't understand 'satisfies'
    const isMapped = (module)=>module !== undefined && module in gadgetMapping;
    return gadgets.map((gadget)=>{
        if (isMapped(gadget.amdModule)) return {
            ...gadget,
            reactKey: gadgetMapping[gadget.amdModule],
            amdModule: undefined,
            configurable: false,
            inlineHtml: undefined
        };
        return gadget;
    });
};

});

parcelRegister("2VeIs", function(module, exports) {

$parcel$export(module.exports, "default", () => $99fd60763f19d998$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getDashboardsConfig", () => $99fd60763f19d998$export$1264b6af3adf5084);

var $2OdyW = parcelRequire("2OdyW");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$99fd60763f19d998$export$2e2bcd8739ae039 = (id)=>(0, $2OdyW.default)(`/rest/dashboards/1.0/${id}.json`);
const $99fd60763f19d998$export$1264b6af3adf5084 = (idsCsv)=>(0, $2OdyW.default)(`/rest/dashboards/1.0?dashboardId=${idsCsv}`);

});

parcelRegister("gUvw9", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1fab7a3f6b4bae2$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $kEBPk = parcelRequire("kEBPk");

var $2OdyW = parcelRequire("2OdyW");
const $b1fab7a3f6b4bae2$var$CRITICAL_DEPENDENCIES = [
    'jira.webresources:util',
    'jira.webresources:feature-flags',
    'com.atlassian.jira.jira-atlaskit-plugin:overrides-general'
];
const $b1fab7a3f6b4bae2$var$JIRA_HERITAGE_CRITICAL_BATCH = 'jira.heritage.critical';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b1fab7a3f6b4bae2$export$2e2bcd8739ae039 = async (moduleNames)=>{
    if (moduleNames.length === 0) return Promise.resolve(null);
    const contextsToRequire = moduleNames.map((amdModule)=>(0, $kEBPk.WEB_RESOURCE_MAP)[amdModule]);
    const payload = {
        r: [],
        c: [
            ...$b1fab7a3f6b4bae2$var$CRITICAL_DEPENDENCIES,
            ...contextsToRequire
        ],
        xc: [
            $b1fab7a3f6b4bae2$var$JIRA_HERITAGE_CRITICAL_BATCH
        ],
        xr: []
    };
    return (0, $2OdyW.default)('/rest/webResources/1.0/resources', {
        method: 'POST',
        body: JSON.stringify(payload)
    });
};

});

parcelRegister("2OLBQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3d435382503897c$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $829dv = parcelRequire("829dv");
var $kEBPk = parcelRequire("kEBPk");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f3d435382503897c$export$2e2bcd8739ae039 = (dashboardConfig)=>{
    if (dashboardConfig.gadgets.length === 0) return null;
    const prefetches = (0, $829dv.getPrefetches)(dashboardConfig);
    const preloadLinks = prefetches.map((prefetch)=>`<link rel="preload" as="fetch" href="${prefetch.url}" crossorigin="anonymous" />`).join('\n') || null;
    const syncPrefetchUrls = prefetches.filter((prefetch)=>prefetch.isSyncLoadingSupported()).map((prefetch)=>prefetch.url);
    if (preloadLinks != null && syncPrefetchUrls.length > 0) {
        const fetchScript = `
            <script type="text/javascript" data-defer-skip>
                const preloadUrls = ${JSON.stringify(syncPrefetchUrls)};
                window['${(0, $kEBPk.PRELOADED_GADGET_DATA_KEY)}'] = {};

                preloadUrls.forEach((preloadUrl) => {
                    fetch(preloadUrl)
                        .then(res => res.json())
                        .then(data => {
                            window['${(0, $kEBPk.PRELOADED_GADGET_DATA_KEY)}'][preloadUrl] = data;
                        });
                });
            </script>
        `;
        return preloadLinks + fetchScript;
    }
    return preloadLinks;
};

});
parcelRegister("829dv", function(module, exports) {

$parcel$export(module.exports, "getPrefetches", () => $e72a0f3939c6d5ed$export$3144db3718ad5e57);

var $cUxyt = parcelRequire("cUxyt");
const $e72a0f3939c6d5ed$export$3144db3718ad5e57 = ({ gadgets: gadgets })=>{
    const lookup = (0, $cUxyt.getPrefetchDict)();
    return gadgets.flatMap((gadget)=>{
        const identifier = gadget.amdModule;
        const prefechProp = identifier != null ? lookup[identifier] : undefined;
        if (!prefechProp || !prefechProp.enabled) return [];
        const { func: func, priority: priority, isSyncLoadingSupported: isSyncLoadingSupported } = prefechProp;
        return func(gadget).map((url)=>({
                url: url,
                priority: priority,
                isSyncLoadingSupported: isSyncLoadingSupported
            }));
    });
};

});
parcelRegister("cUxyt", function(module, exports) {

$parcel$export(module.exports, "getPrefetchDict", () => $5288b615002d4c5f$export$244cea94cab19e07);

var $1ybV0 = parcelRequire("1ybV0");

var $lD4Kg = parcelRequire("lD4Kg");

var $4BzVP = parcelRequire("4BzVP");
var $6jPL6 = parcelRequire("6jPL6");
const $5288b615002d4c5f$export$244cea94cab19e07 = ()=>({
        'jira-dashboard-items/activitystream': {
            func: (0, $4BzVP.getActivityStreamPrefetchLink),
            priority: (0, $lD4Kg.LOADING_PRIORITY).HIGH,
            enabled: true,
            isSyncLoadingSupported: ()=>false
        },
        'jira-dashboard-items/filter-results': {
            func: (0, $6jPL6.getFilterResultsPrefetchLink),
            priority: (0, $lD4Kg.LOADING_PRIORITY).LOW,
            enabled: !(0, $1ybV0.ff)('endeavour.gadget.nin-filter-results-gadget'),
            isSyncLoadingSupported: ()=>true
        }
    });

});
parcelRegister("lD4Kg", function(module, exports) {

$parcel$export(module.exports, "LOADING_PRIORITY", () => $bfb7cfda6fc0971f$export$cb9b1f2232733c1b);
const $bfb7cfda6fc0971f$export$cb9b1f2232733c1b = {
    HIGH: 'preload',
    LOW: 'prefetch'
};

});

parcelRegister("4BzVP", function(module, exports) {

$parcel$export(module.exports, "getActivityStreamPrefetchLink", () => $b07607e1011a103f$export$360928f5bf059a9e);

var $53ciZ = parcelRequire("53ciZ");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b07607e1011a103f$var$replacer = (match, part1)=>String.fromCharCode(part1);
// IMPORTANT - The below code is copied from monolith streams plugin and modified to fit linting rules
// so any changes in here have to be synced with the monolith code as well.
// https://stash.atlassian.com/projects/jiracloud/repos/jira/browse/jira-components/jira-plugins/streams/streams-jira-plugin/src/main/resources/streams-jira-plugin/dashboarditem/activity-stream/js/activity-stream.js?at=64cdcf2e1660c3afeaf26d8795e8cb737286efe9#63-81
// @ts-expect-error - TS7006 - Parameter 'operatorLower' implicitly has an 'any' type.
const $b07607e1011a103f$var$getDateValue = (dateValue, operatorLower)=>{
    // make sure we're dealing with a string so we can use indexOf and split without errors
    const dateStr = `${dateValue}`;
    const operator = operatorLower.toUpperCase();
    let dateArr;
    if (dateStr.indexOf(' ') !== -1) dateArr = dateStr.split(' ');
    else if (operator === 'BETWEEN') dateArr = [
        dateValue,
        dateValue
    ];
    else dateArr = [
        dateValue
    ];
    return dateArr.map((date, index)=>{
        // make sure we're adding numbers and not concatenating strings
        const dateInt = parseInt(date, 10);
        if (operator === 'AFTER' || operator === 'BETWEEN' && index === 1) return dateInt + 86400000 - 1; // Add 23 hours, 59 minutes, 59 seconds to get to end of day
        return dateInt;
    }).join(' ');
};
// IMPORTANT - The below code is copied from monolith streams plugin and modified to fit linting rules
// so any changes in here have to be synced with the monolith code as well.
// https://stash.atlassian.com/projects/jiracloud/repos/jira/browse/jira-components/jira-plugins/streams/streams-jira-plugin/src/main/resources/streams-jira-plugin/dashboarditem/activity-stream/js/activity-stream.js?at=64cdcf2e1660c3afeaf26d8795e8cb737286efe9#20
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b07607e1011a103f$var$handleSpecialCases = (rule)=>{
    let { value: value, operator: operator } = rule;
    const { type: type } = rule;
    if (Array.isArray(value)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const encodedValues = [];
        value.forEach((val)=>{
            // additional level of encoding for spaces because otherwise the spaces
            // will be mistaken for value delimiters (STRM-1857); escape space as "_"
            // and escape any existing "_" as "\_"
            encodedValues.push(val.replace(/_/g, '\\_').replace(/ /g, '_'));
        });
        value = encodedValues.join(' ');
    }
    if (type === 'date') {
        if (operator === 'is') // back end doesn't support "IS", we have to turn it into a between
        operator = 'between';
        value = $b07607e1011a103f$var$getDateValue(value, operator);
        // We had some problems getting the date values
        // Return empty rule so it won't be included
        if (value.indexOf('NaN') !== -1) return {};
    } else if (type === 'list' || type === 'user') {
        // allow comma-separated values (in addition to space separated) for issue keys and usernames
        value = value.replace(/,/g, ' ');
        // escape underscores as "\_" (because "_" is used to escape spaces in lists)
        value = value.replace(/_/g, '\\_');
    }
    return {
        value: value,
        operator: operator
    };
};
// IMPORTANT - The below code is copied from monolith streams plugin and modified to fit linting rules
// so any changes in here have to be synced with the monolith code as well.
// https://stash.atlassian.com/projects/jiracloud/repos/jira/browse/jira-components/jira-plugins/streams/streams-jira-plugin/src/main/resources/streams-jira-plugin/dashboarditem/activity-stream/js/activity-stream.js?at=64cdcf2e1660c3afeaf26d8795e8cb737286efe9#651-683
const $b07607e1011a103f$var$getParamsFromRules = (rules)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const params = {};
    const providers = JSON.parse(decodeURIComponent(rules.replace(/&#([0-9]+);/g, $b07607e1011a103f$var$replacer)))?.providers || [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const enabledProviders = [];
    // @ts-expect-error - TS7006 - Parameter 'provider' implicitly has an 'any' type.
    providers.forEach((provider)=>{
        const providerKey = provider.provider;
        const { rules: providerRules } = provider;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const stringifiedRules = [];
        if (!provider.disabled) {
            if (providerKey !== 'streams') enabledProviders.push(providerKey);
            // @ts-expect-error - TS7006 - Parameter 'rule' implicitly has an 'any' type.
            providerRules.forEach((rule)=>{
                const modifiedRuleObj = $b07607e1011a103f$var$handleSpecialCases(rule);
                const { operator: operator, value: value } = modifiedRuleObj;
                if (operator && value) stringifiedRules.push([
                    rule.rule,
                    operator.toUpperCase(),
                    value
                ].join(' '));
            });
            params[providerKey] = stringifiedRules;
        }
    });
    if (enabledProviders.length < providers.length - 1) params.providers = enabledProviders.join(' ');
    return params;
};
const $b07607e1011a103f$export$3d7deb7cf8a9de04 = (gadget)=>{
    const prefs = Object.fromEntries(gadget.userPrefs?.fields.map((field)=>[
            field.name,
            field.value
        ]) ?? []);
    const params = {
        maxResults: prefs.numofentries ?? 25,
        relativeLinks: true,
        ...prefs.rules ? $b07607e1011a103f$var$getParamsFromRules(prefs.rules) : {}
    };
    // Gadget encodes spaces as '+', rather than '%20'.  Need to replace here to match URL exactly.
    return (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(params).replace(/%20/g, '+');
};
const $b07607e1011a103f$var$ACTIVITY_STREAM_REST_URL = 'plugins/servlet/streams';
const $b07607e1011a103f$export$360928f5bf059a9e = (gadgetData)=>{
    const paramStr = $b07607e1011a103f$export$3d7deb7cf8a9de04(gadgetData);
    return [
        `/${$b07607e1011a103f$var$ACTIVITY_STREAM_REST_URL}?${paramStr}`
    ];
};

});

parcelRegister("6jPL6", function(module, exports) {

$parcel$export(module.exports, "getFilterResultsPrefetchLink", () => $7db50436578c14e4$export$947cd90004054337);

var $53ciZ = parcelRequire("53ciZ");
const $7db50436578c14e4$var$FILTER_RESULTS_REST_URL = 'rest/gadget/1.0/issueTable';
const $7db50436578c14e4$export$947cd90004054337 = (gadgetData)=>{
    const { properties: properties } = gadgetData.context.dashboardItem;
    const data = {
        num: properties.num,
        tableContext: 'jira.table.cols.dashboard',
        addDefault: false,
        columnNames: typeof properties.columnNames === 'string' ? properties.columnNames.split('|') : undefined,
        enableSorting: true,
        paging: true,
        showActions: true,
        filterId: undefined,
        jql: undefined,
        sortBy: String(properties.sortBy && properties.sortBy !== '' ? properties.sortBy : null),
        startIndex: properties.startIndex ? properties.startIndex : 0
    };
    let queryType = '';
    if (properties.filterId) {
        queryType = 'filter';
        Object.assign(data, {
            filterId: properties.filterId
        });
    } else if (properties.jql) {
        queryType = 'jql';
        Object.assign(data, {
            jql: properties.jql
        });
    }
    // IMPORTANT - type definitions are incorrect, sort is definitely an option
    // @see https://www.npmjs.com/package/query-string/v/5.1.0
    // @ts-expect-error - TS2345 - Argument of type '{ sort: boolean; }' is not assignable to parameter of type 'StringifyOptions'.
    const paramStr = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(data, {
        sort: false
    }).replace(/%20/g, '+');
    const preloadUrl = `/${$7db50436578c14e4$var$FILTER_RESULTS_REST_URL}/${queryType}?${paramStr}`;
    return [
        preloadUrl
    ];
};

});




parcelRegister("hPXQA", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb5155fc87e6d561$export$2e2bcd8739ae039);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bb5155fc87e6d561$export$2e2bcd8739ae039 = (response)=>{
    let resourceHtml = `
        <script type="text/javascript" data-defer-skip>
            window.WRM=window.WRM||{};window.WRM._unparsedData=window.WRM._unparsedData||{};window.WRM._unparsedErrors=window.WRM._unparsedErrors||{};
            WRM._unparsedData = Object.assign({}, WRM._unparsedData, JSON.parse(${JSON.stringify(JSON.stringify(response.unparsedData))}));
            WRM._unparsedErrors = Object.assign({}, WRM._unparsedErrors, JSON.parse(${JSON.stringify(JSON.stringify(response.unparsedErrors))}));
            if(window.WRM._dataArrived)window.WRM._dataArrived();
        </script>
    `;
    response.resources.forEach((resource)=>{
        const { url: url, resourceType: resourceType, key: key } = resource;
        if (resourceType === 'CSS') {
            const cssResource = `<link
                href=${url}
                type="text/css"
                rel="stylesheet"
                media="all"
                data-wrm-key=${key}
                data-wrm-batch-type="context"
            />`;
            resourceHtml += cssResource;
        } else {
            const jsResource = `<div>
                <script
                    type="text/javascript"
                    data-initially-rendered
                    data-defer-skip
                    src=${url}
                    data-wrm-key=${key}
                    data-wrm-batch-type="context"
                ></script>
            </div>`;
            resourceHtml += jsResource;
        }
    });
    return resourceHtml;
};

});

parcelRegister("g8TlX", function(module, exports) {

$parcel$export(module.exports, "gadgetsToUniqueSortedAmdModules", () => $e7764e486e4d14ca$export$598e0ea2a7525181);
$parcel$export(module.exports, "gadgetsToSortedReactGadgets", () => $e7764e486e4d14ca$export$f98787198c197952);
// eslint-disable-next-line jira/import-whitelist

var $kEBPk = parcelRequire("kEBPk");

var $iFHrw = parcelRequire("iFHrw");
const $e7764e486e4d14ca$export$598e0ea2a7525181 = (gadgets)=>gadgets // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .map(({ amdModule: amdModule })=>amdModule) // validated below
    .filter(Boolean).filter((amdModule)=>amdModule in (0, $kEBPk.WEB_RESOURCE_MAP)).filter((v, i, a)=>a.indexOf(v) === i).sort() ?? [];
const $e7764e486e4d14ca$export$f98787198c197952 = (gadgets)=>gadgets.reduce((gadgetsAccumulator, gadget)=>{
        if (!(0, $iFHrw.isReactKey)(gadget.reactKey)) return gadgetsAccumulator;
        gadgetsAccumulator.push({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            reactKey: gadget.reactKey,
            id: gadget.id,
            userPrefs: gadget.userPrefs
        });
        return gadgetsAccumulator;
    }, []).sort((a, b)=>a.id.localeCompare(b.id));

});
parcelRegister("iFHrw", function(module, exports) {

$parcel$export(module.exports, "isReactKey", () => $3b605fb0be8c3f62$export$6acd06c99f745b49);
$parcel$export(module.exports, "default", () => $3b605fb0be8c3f62$export$2e2bcd8739ae039);

var $9aBQb = parcelRequire("9aBQb");

var $9DipY = parcelRequire("9DipY");

var $c4zGv = parcelRequire("c4zGv");

var $5GpvS = parcelRequire("5GpvS");

var $4j3xD = parcelRequire("4j3xD");
/** This is a gadgets definition file.  */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3b605fb0be8c3f62$var$GADGETS_DEFINITION = {
    [(0, $4j3xD.REACT_KEY).PROJECTS]: (0, $5GpvS.default),
    [(0, $4j3xD.REACT_KEY).HEATMAP]: (0, $9DipY.default),
    [(0, $4j3xD.REACT_KEY).FILTER_RESULTS]: (0, $c4zGv.FILTER_RESULTS_DEFINITION),
    [(0, $4j3xD.REACT_KEY).ASSIGNED_TO_ME]: (0, $c4zGv.ASSIGNED_TO_ME_DEFINITION),
    [(0, $4j3xD.REACT_KEY).ISSUES_IN_PROGRESS]: (0, $c4zGv.ISSUES_IN_PROGRESS_DEFINITION),
    [(0, $4j3xD.REACT_KEY).VOTED_ISSUES]: (0, $c4zGv.VOTED_ISSUES_DEFINITION),
    [(0, $4j3xD.REACT_KEY).WATCHED_ISSUES]: (0, $c4zGv.WATCHED_ISSUES_DEFINITION),
    [(0, $4j3xD.REACT_KEY).CUSTOM_REPORT]: (0, $9aBQb.default)
};
function $3b605fb0be8c3f62$export$6acd06c99f745b49(key) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return !!(key && Object.values((0, $4j3xD.REACT_KEY)).includes(key));
}
var $3b605fb0be8c3f62$export$2e2bcd8739ae039 = $3b605fb0be8c3f62$var$GADGETS_DEFINITION;

});
parcelRegister("9aBQb", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fc73a205ebc62f2$export$2e2bcd8739ae039);

var $9lS1T = parcelRequire("9lS1T");
var $kfew2 = parcelRequire("kfew2");

var $3tTwM = parcelRequire("3tTwM");
const $9fc73a205ebc62f2$var$CUSTOM_REPORT_DEFINITION = {
    componentView: (0, $kfew2.LazyCustomReportGadgetView),
    componentEdit: (0, $9lS1T.LazyCustomReportGadgetEdit),
    getInitialState: $3tTwM.default,
    preload: $kfew2.preload
};
var $9fc73a205ebc62f2$export$2e2bcd8739ae039 = $9fc73a205ebc62f2$var$CUSTOM_REPORT_DEFINITION;

});
parcelRegister("9lS1T", function(module, exports) {

$parcel$export(module.exports, "LazyCustomReportGadgetEdit", () => $1c5d73db0512d5f4$export$475e4a6fb8f40116);

var $7rh0R = parcelRequire("7rh0R");

const $1c5d73db0512d5f4$export$475e4a6fb8f40116 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("b7nvy")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/custom-report-gadget/src/ui/edit/main.tsx"
});

});
parcelRegister("b7nvy", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('hOeaP')
        ]);
        const value = parcelRequire('anx4a');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("hOeaP")
    ]).then(()=>parcelRequire('anx4a'));
}

});


parcelRegister("kfew2", function(module, exports) {

$parcel$export(module.exports, "LazyCustomReportGadgetView", () => $67f7de289ccacfb7$export$27df795d4f3ff173);
$parcel$export(module.exports, "preload", () => $67f7de289ccacfb7$export$513ccb98c53b8039);

var $7rh0R = parcelRequire("7rh0R");

const $67f7de289ccacfb7$export$27df795d4f3ff173 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("dKlRA")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/custom-report-gadget/src/ui/view/main.tsx"
});
const { preload: $67f7de289ccacfb7$export$513ccb98c53b8039 } = $67f7de289ccacfb7$export$27df795d4f3ff173;

});
parcelRegister("dKlRA", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('kgy4b');
        const value = parcelRequire('dOaCr');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("kgy4b").then(()=>parcelRequire('dOaCr'));
}

});


parcelRegister("3tTwM", function(module, exports) {

$parcel$export(module.exports, "default", () => $53772c7af9239b80$export$2e2bcd8739ae039);
const $53772c7af9239b80$var$getInitialState = ()=>Promise.resolve({
        intervalValue: '1',
        isCustom: 'false',
        projectValue: '0',
        refresh: 'false',
        reportValue: '0',
        gadgetContentTitle: ''
    });
var $53772c7af9239b80$export$2e2bcd8739ae039 = $53772c7af9239b80$var$getInitialState;

});


parcelRegister("9DipY", function(module, exports) {

$parcel$export(module.exports, "default", () => $016b742aafaf576e$export$2e2bcd8739ae039);

var $7zjSM = parcelRequire("7zjSM");
var $TdPK0 = parcelRequire("TdPK0");

var $8jYNA = parcelRequire("8jYNA");
const $016b742aafaf576e$var$HEATMAP_DEFINITION = {
    componentView: (0, $TdPK0.LazyHeatmapGadgetView),
    componentEdit: (0, $7zjSM.LazyHeatmapGadgetEdit),
    getInitialState: $8jYNA.default,
    preload: $TdPK0.preload
};
var $016b742aafaf576e$export$2e2bcd8739ae039 = $016b742aafaf576e$var$HEATMAP_DEFINITION;

});
parcelRegister("7zjSM", function(module, exports) {

$parcel$export(module.exports, "LazyHeatmapGadgetEdit", () => $c872a94f3381b28e$export$6f30e8e9e0864df4);

var $7rh0R = parcelRequire("7rh0R");

const $c872a94f3381b28e$export$6f30e8e9e0864df4 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("03Nha")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/heatmap-gadget/src/ui/edit/main.tsx"
});

});
parcelRegister("03Nha", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('3XROj');
        const value = parcelRequire('gtjAK');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("3XROj").then(()=>parcelRequire('gtjAK'));
}

});


parcelRegister("TdPK0", function(module, exports) {

$parcel$export(module.exports, "LazyHeatmapGadgetView", () => $39a332d06f033905$export$5ac0932b7fdc2e33);
$parcel$export(module.exports, "preload", () => $39a332d06f033905$export$513ccb98c53b8039);

var $7rh0R = parcelRequire("7rh0R");

const $39a332d06f033905$export$5ac0932b7fdc2e33 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("A7zt5")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/heatmap-gadget/src/ui/view/main.tsx"
});
const { preload: $39a332d06f033905$export$513ccb98c53b8039 } = $39a332d06f033905$export$5ac0932b7fdc2e33;

});
parcelRegister("A7zt5", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('j20mp');
        const value = parcelRequire('8qR7v');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("j20mp").then(()=>parcelRequire('8qR7v'));
}

});


parcelRegister("8jYNA", function(module, exports) {

$parcel$export(module.exports, "default", () => $22c72ae60ada11c7$export$2e2bcd8739ae039);
const $22c72ae60ada11c7$var$getInitialState = ()=>Promise.resolve({});
var $22c72ae60ada11c7$export$2e2bcd8739ae039 = $22c72ae60ada11c7$var$getInitialState;

});


parcelRegister("c4zGv", function(module, exports) {

$parcel$export(module.exports, "FILTER_RESULTS_DEFINITION", () => $fe8974f560fb24c4$export$3581891d04da6bb8);
$parcel$export(module.exports, "ASSIGNED_TO_ME_DEFINITION", () => $fe8974f560fb24c4$export$652d5a9cc2c18d2e);
$parcel$export(module.exports, "ISSUES_IN_PROGRESS_DEFINITION", () => $fe8974f560fb24c4$export$54b46348d1ed5d22);
$parcel$export(module.exports, "VOTED_ISSUES_DEFINITION", () => $fe8974f560fb24c4$export$ea96ce30d34ce354);
$parcel$export(module.exports, "WATCHED_ISSUES_DEFINITION", () => $fe8974f560fb24c4$export$5109728db227eae);

var $eUqFw = parcelRequire("eUqFw");

var $89od6 = parcelRequire("89od6");
var $dEBc2 = parcelRequire("dEBc2");
var $39pd1 = parcelRequire("39pd1");
var $7bxc3 = parcelRequire("7bxc3");
var $5t0mU = parcelRequire("5t0mU");
var $1LSbo = parcelRequire("1LSbo");

var $a5B6h = parcelRequire("a5B6h");
const $fe8974f560fb24c4$var$componentViewWithAdditionalState = (Component, additionalStateProps)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
            ...props,
            state: props.state ? {
                ...props.state,
                ...additionalStateProps
            } : null
        });
const $fe8974f560fb24c4$var$componentEditWithAdditionalState = (Component, additionalStateProps)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
            ...props,
            state: props.state ? {
                ...props.state,
                ...additionalStateProps
            } : null
        });
const $fe8974f560fb24c4$var$FILTER_RESULTS_CONFIG = {
    testId: 'react-issue-table-gadgets.filter-results.view'
};
const $fe8974f560fb24c4$export$3581891d04da6bb8 = {
    componentView: $fe8974f560fb24c4$var$componentViewWithAdditionalState((0, $7bxc3.IssueTableGadgetView), $fe8974f560fb24c4$var$FILTER_RESULTS_CONFIG),
    componentEdit: (0, $dEBc2.FilterResultsGadgetEdit),
    getInitialState: (0, $a5B6h.default)($fe8974f560fb24c4$var$FILTER_RESULTS_CONFIG),
    preload: (0, $7bxc3.preload)
};
const $fe8974f560fb24c4$var$ASSIGNED_TO_ME_CONFIG = {
    predeterminedJql: 'assignee = currentUser() AND statusCategory != 3 ORDER BY priority DESC, created ASC',
    defaultSortPrefs: {
        field: 'priority',
        direction: 'DESC'
    },
    testId: 'react-issue-table-gadgets.assigned-to-me.view'
};
const $fe8974f560fb24c4$export$652d5a9cc2c18d2e = {
    componentView: $fe8974f560fb24c4$var$componentViewWithAdditionalState((0, $7bxc3.IssueTableGadgetView), $fe8974f560fb24c4$var$ASSIGNED_TO_ME_CONFIG),
    componentEdit: $fe8974f560fb24c4$var$componentEditWithAdditionalState((0, $89od6.AssignedToMeGadgetEdit), $fe8974f560fb24c4$var$ASSIGNED_TO_ME_CONFIG),
    getInitialState: (0, $a5B6h.default)($fe8974f560fb24c4$var$ASSIGNED_TO_ME_CONFIG),
    preload: (0, $7bxc3.preload)
};
const $fe8974f560fb24c4$var$ISSUES_IN_PROGRESS_CONFIG = {
    predeterminedJql: 'status = "In Progress" AND statusCategory != Done AND assignee = currentUser() ORDER BY priority DESC, created ASC',
    defaultSortPrefs: {
        field: 'priority',
        direction: 'DESC'
    },
    testId: 'react-issue-table-gadgets.issues-in-progress.view'
};
const $fe8974f560fb24c4$export$54b46348d1ed5d22 = {
    componentView: $fe8974f560fb24c4$var$componentViewWithAdditionalState((0, $7bxc3.IssueTableGadgetView), $fe8974f560fb24c4$var$ISSUES_IN_PROGRESS_CONFIG),
    componentEdit: $fe8974f560fb24c4$var$componentEditWithAdditionalState((0, $39pd1.IssuesInProgressGadgetEdit), $fe8974f560fb24c4$var$ISSUES_IN_PROGRESS_CONFIG),
    getInitialState: (0, $a5B6h.default)($fe8974f560fb24c4$var$ISSUES_IN_PROGRESS_CONFIG),
    preload: (0, $7bxc3.preload)
};
const $fe8974f560fb24c4$var$VOTED_ISSUES_CONFIG = {
    predeterminedJql: 'issue in votedIssues() AND statusCategory != Done ORDER BY votes DESC',
    predeterminedJqlIncludeResolved: 'issue in votedIssues() ORDER BY votes DESC',
    defaultSortPrefs: {
        field: 'votes',
        direction: 'DESC'
    },
    testId: 'react-issue-table-gadgets.voted-issues.view'
};
const $fe8974f560fb24c4$export$ea96ce30d34ce354 = {
    componentView: $fe8974f560fb24c4$var$componentViewWithAdditionalState((0, $7bxc3.IssueTableGadgetView), $fe8974f560fb24c4$var$VOTED_ISSUES_CONFIG),
    componentEdit: $fe8974f560fb24c4$var$componentEditWithAdditionalState((0, $5t0mU.VotedIssuesGadgetEdit), $fe8974f560fb24c4$var$VOTED_ISSUES_CONFIG),
    getInitialState: (0, $a5B6h.default)($fe8974f560fb24c4$var$VOTED_ISSUES_CONFIG),
    preload: (0, $7bxc3.preload)
};
const $fe8974f560fb24c4$var$WATCHED_ISSUES_CONFIG = {
    predeterminedJql: 'issue in watchedIssues() AND statusCategory != Done ORDER BY watchers DESC',
    predeterminedJqlIncludeResolved: 'issue in watchedIssues() ORDER BY watchers DESC',
    defaultSortPrefs: {
        field: 'watchers',
        direction: 'DESC'
    },
    testId: 'react-issue-table-gadgets.watched-issues.view'
};
const $fe8974f560fb24c4$export$5109728db227eae = {
    componentView: $fe8974f560fb24c4$var$componentViewWithAdditionalState((0, $7bxc3.IssueTableGadgetView), $fe8974f560fb24c4$var$WATCHED_ISSUES_CONFIG),
    componentEdit: $fe8974f560fb24c4$var$componentEditWithAdditionalState((0, $1LSbo.WatchedIssuesGadgetEdit), $fe8974f560fb24c4$var$WATCHED_ISSUES_CONFIG),
    getInitialState: (0, $a5B6h.default)($fe8974f560fb24c4$var$WATCHED_ISSUES_CONFIG),
    preload: (0, $7bxc3.preload)
};

});
parcelRegister("89od6", function(module, exports) {

$parcel$export(module.exports, "AssignedToMeGadgetEdit", () => $721813e04c285890$export$3ae3568d16dc8f35);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $qZD11 = parcelRequire("qZD11");

const $721813e04c285890$var$LazyAssignedToMeGadgetEdit = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("aYjWR")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/assigned-to-me/edit/main.tsx"
});
const $721813e04c285890$export$3ae3568d16dc8f35 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "assigned-to-me-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $qZD11.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($721813e04c285890$var$LazyAssignedToMeGadgetEdit, props));
const { preload: $721813e04c285890$export$513ccb98c53b8039 } = $721813e04c285890$var$LazyAssignedToMeGadgetEdit;

});
parcelRegister("qZD11", function(module, exports) {

$parcel$export(module.exports, "FilterResultsEditSkeleton", () => $0b5156980e63e31e$export$e10d91ce257e7374);
/* filter-results-edit.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");

var $bf8cD = parcelRequire("bf8cD");
const $0b5156980e63e31e$var$customCssStyles = null;
const $0b5156980e63e31e$var$FILTER_RESULTS_EDIT_ESTIMATED_HEIGHT = '698px';
const $0b5156980e63e31e$export$e10d91ce257e7374 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bf8cD))),
        containerStyles: {
            height: $0b5156980e63e31e$var$FILTER_RESULTS_EDIT_ESTIMATED_HEIGHT
        },
        className: (0, $7JEyt.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("bf8cD", function(module, exports) {
module.exports = new URL("filter-results-edit-skeleton.tpl.783fb7b7.svg", import.meta.url).toString();

});


parcelRegister("aYjWR", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('lul3e')
        ]);
        const value = parcelRequire('kQk64');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("lul3e")
    ]).then(()=>parcelRequire('kQk64'));
}

});


parcelRegister("dEBc2", function(module, exports) {

$parcel$export(module.exports, "FilterResultsGadgetEdit", () => $b5f40a0f18e4302a$export$6dfceca003c43832);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $qZD11 = parcelRequire("qZD11");

const $b5f40a0f18e4302a$var$LazyFilterResultsGadgetEdit = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("6wGUy")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/filter-results/edit/main.tsx"
});
const $b5f40a0f18e4302a$export$6dfceca003c43832 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "filter-results-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $qZD11.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b5f40a0f18e4302a$var$LazyFilterResultsGadgetEdit, props));
const { preload: $b5f40a0f18e4302a$export$513ccb98c53b8039 } = $b5f40a0f18e4302a$var$LazyFilterResultsGadgetEdit;

});
parcelRegister("6wGUy", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('l7OFb')
        ]);
        const value = parcelRequire('3LebM');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("l7OFb")
    ]).then(()=>parcelRequire('3LebM'));
}

});


parcelRegister("39pd1", function(module, exports) {

$parcel$export(module.exports, "IssuesInProgressGadgetEdit", () => $8fd8607cd190e208$export$199fec410a0f70a2);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $qZD11 = parcelRequire("qZD11");

const $8fd8607cd190e208$var$LazyIssuesInProgressGadgetEdit = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("iZSIN")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/issues-in-progress/edit/main.tsx"
});
const $8fd8607cd190e208$export$199fec410a0f70a2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issues-in-progress-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $qZD11.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8fd8607cd190e208$var$LazyIssuesInProgressGadgetEdit, props));
const { preload: $8fd8607cd190e208$export$513ccb98c53b8039 } = $8fd8607cd190e208$var$LazyIssuesInProgressGadgetEdit;

});
parcelRegister("iZSIN", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('dRapt')
        ]);
        const value = parcelRequire('4DUDi');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("dRapt")
    ]).then(()=>parcelRequire('4DUDi'));
}

});


parcelRegister("7bxc3", function(module, exports) {

$parcel$export(module.exports, "IssueTableGadgetView", () => $206dcc7b0a4c31d4$export$da0765a3c10e16a3);
$parcel$export(module.exports, "preload", () => $206dcc7b0a4c31d4$export$513ccb98c53b8039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $kEBPk = parcelRequire("kEBPk");

var $gGtKh = parcelRequire("gGtKh");

var $fuBtH = parcelRequire("fuBtH");

const $206dcc7b0a4c31d4$var$LazyIssueTableGadgetView = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("87qip")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/view/main.tsx"
});
const $206dcc7b0a4c31d4$export$da0765a3c10e16a3 = ({ customSkeletonHeightInPx: customSkeletonHeightInPx, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "filter-results-gadget-view",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fuBtH.FilterResultsIssueTableSkeleton), {
            height: `${customSkeletonHeightInPx ?? (0, $kEBPk.GADGET_DEFAULT_HEIGHT)}px`
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($206dcc7b0a4c31d4$var$LazyIssueTableGadgetView, {
        customSkeletonHeightInPx: customSkeletonHeightInPx,
        ...props
    }));
const { preload: $206dcc7b0a4c31d4$export$513ccb98c53b8039 } = $206dcc7b0a4c31d4$var$LazyIssueTableGadgetView;

});
parcelRegister("fuBtH", function(module, exports) {

$parcel$export(module.exports, "FilterResultsIssueTableSkeleton", () => $431e2d429e482a98$export$35d754053deeac73);
/* filter-results-issue-table.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");

var $3ojrk = parcelRequire("3ojrk");
const $431e2d429e482a98$var$customCssStyles = null;
const $431e2d429e482a98$export$35d754053deeac73 = ({ height: height })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3ojrk))),
        containerStyles: {
            height: height
        },
        className: (0, $7JEyt.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("3ojrk", function(module, exports) {
module.exports = new URL("filter-results-issue-table-skeleton.tpl.a502204a.svg", import.meta.url).toString();

});


parcelRegister("87qip", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('lSuz7')
        ]);
        const value = parcelRequire('f8xvH');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("lSuz7")
    ]).then(()=>parcelRequire('f8xvH'));
}

});


parcelRegister("5t0mU", function(module, exports) {

$parcel$export(module.exports, "VotedIssuesGadgetEdit", () => $714a6d6a762522de$export$7650b85a7a54914);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $qZD11 = parcelRequire("qZD11");

const $714a6d6a762522de$var$LazyVotedIssuesGadgetEdit = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("8cbT5")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/voted-issues/edit/main.tsx"
});
const $714a6d6a762522de$export$7650b85a7a54914 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "voted-issues-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $qZD11.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($714a6d6a762522de$var$LazyVotedIssuesGadgetEdit, props));
const { preload: $714a6d6a762522de$export$513ccb98c53b8039 } = $714a6d6a762522de$var$LazyVotedIssuesGadgetEdit;

});
parcelRegister("8cbT5", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('98s5n')
        ]);
        const value = parcelRequire('ggY4A');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("98s5n")
    ]).then(()=>parcelRequire('ggY4A'));
}

});


parcelRegister("1LSbo", function(module, exports) {

$parcel$export(module.exports, "WatchedIssuesGadgetEdit", () => $bee6a000695cf051$export$a53864bd0bf8a85f);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $qZD11 = parcelRequire("qZD11");

const $bee6a000695cf051$var$LazyWatchedIssuesGadgetEdit = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("dwbdN")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/watched-issues/edit/main.tsx"
});
const $bee6a000695cf051$export$a53864bd0bf8a85f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "watched-issues-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $qZD11.FilterResultsEditSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bee6a000695cf051$var$LazyWatchedIssuesGadgetEdit, props));
const { preload: $bee6a000695cf051$export$513ccb98c53b8039 } = $bee6a000695cf051$var$LazyWatchedIssuesGadgetEdit;

});
parcelRegister("dwbdN", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('3sjfY')
        ]);
        const value = parcelRequire('2wBw8');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("3sjfY")
    ]).then(()=>parcelRequire('2wBw8'));
}

});


parcelRegister("a5B6h", function(module, exports) {

$parcel$export(module.exports, "default", () => $233a220e67ded364$export$2e2bcd8739ae039);

var $crAWe = parcelRequire("crAWe");

var $5eBoI = parcelRequire("5eBoI");

var $hZVoZ = parcelRequire("hZVoZ");

var $hZVoZ = parcelRequire("hZVoZ");
const $233a220e67ded364$var$createGetInitialState = ({ predeterminedJql: predeterminedJql, predeterminedJqlIncludeResolved: predeterminedJqlIncludeResolved, defaultSortPrefs: defaultSortPrefs, testId: testId })=>async (resourceContext, userPrefs)=>{
        if (resourceContext?.tenantContext == null) throw new Error('Tenant context is not available');
        const { cloudId: cloudId, activationId: activationId } = resourceContext.tenantContext;
        const validUserPrefs = (0, $hZVoZ.transformToValidUserPrefs)((0, $crAWe.decodeUserPreferences)(userPrefs));
        if (validUserPrefs.filterId === undefined && predeterminedJql === undefined && predeterminedJqlIncludeResolved === undefined) throw new Error('FilterId or JQL has to be available to be able to load the gadget initial state');
        const sortPrefs = (()=>{
            if (validUserPrefs.sortField) return {
                sortField: validUserPrefs.sortField,
                sortDirection: validUserPrefs.sortDirection
            };
            if (defaultSortPrefs) return {
                sortField: defaultSortPrefs.field,
                sortDirection: defaultSortPrefs.direction
            };
        })();
        const includeResolved = validUserPrefs.showResolved;
        const jql = includeResolved ? predeterminedJqlIncludeResolved : predeterminedJql;
        const queryReference = await (0, $hZVoZ.loadQueryWithUserPrefs)({
            ...validUserPrefs,
            ...sortPrefs
        }, (0, $5eBoI.default), cloudId, activationId, 'store-and-network', jql);
        return {
            queryReference: queryReference,
            predeterminedJql: predeterminedJql,
            defaultSortPrefs: defaultSortPrefs,
            testId: testId
        };
    };
var $233a220e67ded364$export$2e2bcd8739ae039 = $233a220e67ded364$var$createGetInitialState;

});
parcelRegister("crAWe", function(module, exports) {

$parcel$export(module.exports, "getUserPreferences", () => $080e9776d65a8494$export$ae3f5fa351e2f57a);
$parcel$export(module.exports, "decodeUserPreferences", () => $080e9776d65a8494$export$ebdfc6c2778ef8e2);

var $2OdyW = parcelRequire("2OdyW");
const $080e9776d65a8494$var$isBooleanString = (str)=>[
        'true',
        'false'
    ].includes(str.toLowerCase().trim());
const $080e9776d65a8494$var$stringToBoolean = (str)=>str.toLowerCase().trim() === 'true';
const $080e9776d65a8494$export$ae3f5fa351e2f57a = (action)=>(0, $2OdyW.default)(action);
const $080e9776d65a8494$export$ebdfc6c2778ef8e2 = (userPreferences = [])=>userPreferences.reduce((output, { value: value, name: name })=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...output,
            [name]: $080e9776d65a8494$var$isBooleanString(value) ? $080e9776d65a8494$var$stringToBoolean(value) : value
        }), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});

});

parcelRegister("5eBoI", function(module, exports) {

$parcel$export(module.exports, "default", () => $06ce214e6711bffc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7fabd528dfe5a3e33e6d03ea01cbed73>>
 * @relayHash a1497b44bc4abcfdd6299774116a38b1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5dc885eba68f917efbdf9509e8ab7409f21b2b2ffb3a473aa7fc5c4a7ef790c8

var $dbXJb = parcelRequire("dbXJb");

var $kpHqV = parcelRequire("kpHqV");

var $fY4Nv = parcelRequire("fY4Nv");
const $06ce214e6711bffc$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterAri"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterId"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isNotFilterFetch"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryFieldSetsById"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v12 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v13 = {
        "kind": "ScalarField",
        "name": "key"
    }, v14 = {
        "kind": "ScalarField",
        "name": "id"
    }, v15 = {
        "kind": "Variable",
        "name": "fieldSetIds",
        "variableName": "fieldSetIds"
    }, v16 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "amountOfColumns"
    }, v17 = {
        "kind": "ScalarField",
        "name": "type"
    }, v18 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v19 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v20 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v21 = {
        "kind": "ScalarField",
        "name": "name"
    }, v22 = [
        v21 /*: any*/ ,
        v14 /*: any*/ 
    ], v23 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v24 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "lazyIsEditableInIssueView"
            }
        ]
    }, v25 = {
        "kind": "ScalarField",
        "name": "text"
    }, v26 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v27 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v26 /*: any*/ ,
            v14 /*: any*/ 
        ]
    }, v28 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v29 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v30 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "small"
                            }
                        ]
                    },
                    v21 /*: any*/ ,
                    v14 /*: any*/ 
                ]
            }
        ],
        "type": "JiraIssueTypeField"
    }, v31 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v25 /*: any*/ ,
            v14 /*: any*/ 
        ]
    }, v32 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v33 = [
        {
            "concreteType": "JiraIssueFieldSetEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssueFieldSet",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v17 /*: any*/ ,
                        v18 /*: any*/ ,
                        {
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fields",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v19 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isJiraIssueField"
                                                },
                                                v14 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraAffectedServiceConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedAffectedServicesConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAffectedServiceEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraAffectedService",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "serviceId"
                                                                                },
                                                                                v21 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraAffectedServicesField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraCmdbObjectConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedCmdbObjectsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraCmdbObjectEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraCmdbObject",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "objectId"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "label"
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraCmdbAvatar",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "avatar",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "url48"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "QueryError",
                                                                    "kind": "LinkedField",
                                                                    "name": "errors",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "message"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraCMDBField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraComponentConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedComponentsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraComponentEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraComponent",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": v22 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraComponentsField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "date"
                                                        },
                                                        v21 /*: any*/ ,
                                                        v23 /*: any*/ ,
                                                        v24 /*: any*/ 
                                                    ],
                                                    "type": "JiraDatePickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "dateTime"
                                                        }
                                                    ],
                                                    "type": "JiraDateTimePickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraEpic",
                                                            "kind": "LinkedField",
                                                            "name": "epic",
                                                            "plural": false,
                                                            "selections": [
                                                                v13 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "summary"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "color"
                                                                },
                                                                v14 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraEpicLinkField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "renderedFieldHtml"
                                                        }
                                                    ],
                                                    "type": "JiraFallbackField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v25 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v24 /*: any*/ 
                                                    ],
                                                    "type": "JiraSingleLineTextField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraStatusCategory",
                                                            "kind": "LinkedField",
                                                            "name": "statusCategory",
                                                            "plural": false,
                                                            "selections": [
                                                                v21 /*: any*/ ,
                                                                v26 /*: any*/ ,
                                                                v14 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraStatusCategoryField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": [
                                                                v21 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "statusId"
                                                                },
                                                                v27 /*: any*/ ,
                                                                v14 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraStatusField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v28 /*: any*/ ,
                                                            "concreteType": "JiraLabelConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedLabelsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraLabelEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraLabel",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v21 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v29 /*: any*/ 
                                                            ],
                                                            "storageKey": "selectedLabelsConnection(first:1000)"
                                                        },
                                                        v21 /*: any*/ ,
                                                        v24 /*: any*/ 
                                                    ],
                                                    "type": "JiraLabelsField"
                                                },
                                                v30 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssue",
                                                            "kind": "LinkedField",
                                                            "name": "parentIssue",
                                                            "plural": false,
                                                            "selections": [
                                                                v13 /*: any*/ ,
                                                                {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcparentfromissueviewrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        v31 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcparentfromissueviewrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": false,
                                                                    "selections": [
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "ids",
                                                                                    "value": [
                                                                                        "issuetype",
                                                                                        "summary"
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldsById",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v19 /*: any*/ ,
                                                                                                v20 /*: any*/ ,
                                                                                                v30 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                },
                                                                                                v14 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "fieldsById(ids:[\"issuetype\",\"summary\"])"
                                                                        }
                                                                    ]
                                                                },
                                                                v14 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcparentfromissueviewrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentIssue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraColorField",
                                                                            "kind": "LinkedField",
                                                                            "name": "issueColorField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraColor",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "color",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "colorKey"
                                                                                        },
                                                                                        v14 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v14 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraIssueTypeField",
                                                                            "kind": "LinkedField",
                                                                            "name": "issueTypeField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueType",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issueType",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v32 /*: any*/ ,
                                                                                        v21 /*: any*/ ,
                                                                                        v14 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v14 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v31 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraParentIssueField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraPriority",
                                                            "kind": "LinkedField",
                                                            "name": "priority",
                                                            "plural": false,
                                                            "selections": [
                                                                v21 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "iconUrl"
                                                                },
                                                                v14 /*: any*/ 
                                                            ]
                                                        },
                                                        v21 /*: any*/ ,
                                                        v24 /*: any*/ 
                                                    ],
                                                    "type": "JiraPriorityField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraProject",
                                                            "kind": "LinkedField",
                                                            "name": "project",
                                                            "plural": false,
                                                            "selections": [
                                                                v21 /*: any*/ ,
                                                                v13 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraAvatar",
                                                                    "kind": "LinkedField",
                                                                    "name": "avatar",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "large"
                                                                        }
                                                                    ]
                                                                },
                                                                v14 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraProjectField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraResolution",
                                                            "kind": "LinkedField",
                                                            "name": "resolution",
                                                            "plural": false,
                                                            "selections": v22 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "JiraResolutionField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraSprintConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedSprintsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSprintEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraSprint",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v14 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "sprintId"
                                                                                },
                                                                                v21 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "state"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "endDate"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v21 /*: any*/ ,
                                                        v24 /*: any*/ 
                                                    ],
                                                    "type": "JiraSprintField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "user",
                                                            "plural": false,
                                                            "selections": [
                                                                v19 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "accountId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "picture"
                                                                },
                                                                v21 /*: any*/ ,
                                                                v14 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "accountStatus"
                                                                }
                                                            ]
                                                        },
                                                        v21 /*: any*/ ,
                                                        v23 /*: any*/ ,
                                                        v24 /*: any*/ 
                                                    ],
                                                    "type": "JiraSingleSelectUserPickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v21 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraVersionConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedVersionsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraVersionEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraVersion",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": v22 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraMultipleVersionPickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraRichText",
                                                            "kind": "LinkedField",
                                                            "name": "richText",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraADF",
                                                                    "kind": "LinkedField",
                                                                    "name": "adfValue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraAdfToConvertedPlainText",
                                                                            "kind": "LinkedField",
                                                                            "name": "convertedPlainText",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "plainText"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraRichTextField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraServiceManagementRequestType",
                                                            "kind": "LinkedField",
                                                            "name": "requestType",
                                                            "plural": false,
                                                            "selections": [
                                                                v21 /*: any*/ ,
                                                                v32 /*: any*/ ,
                                                                v14 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraServiceManagementRequestTypeField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v28 /*: any*/ ,
                                                            "concreteType": "JiraIssueLinkConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issueLinkConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "PageInfo",
                                                                    "kind": "LinkedField",
                                                                    "name": "pageInfo",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "hasNextPage"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraIssueLinkEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueLink",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssue",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issue",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "webUrl"
                                                                                        },
                                                                                        v13 /*: any*/ ,
                                                                                        {
                                                                                            "args": [
                                                                                                {
                                                                                                    "kind": "Literal",
                                                                                                    "name": "ids",
                                                                                                    "value": [
                                                                                                        "statusCategory"
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "fieldsById",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v19 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v27 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                                },
                                                                                                                v14 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                        },
                                                                                        v14 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "relationName"
                                                                                },
                                                                                v14 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "issueLinkConnection(first:1000)"
                                                        }
                                                    ],
                                                    "type": "JiraIssueLinkField"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ], v34 = [
        {
            "kind": "ScalarField",
            "name": "cursor"
        },
        {
            "kind": "ScalarField",
            "name": "pageNumber"
        },
        {
            "kind": "ScalarField",
            "name": "isCurrent"
        }
    ], v35 = {
        "kind": "ScalarField",
        "name": "displayName"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issueTableViewQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "issueTableView_reactIssueTableGadgets"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v11 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v10 /*: any*/ ,
                v0 /*: any*/ ,
                v6 /*: any*/ ,
                v4 /*: any*/ ,
                v7 /*: any*/ ,
                v5 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcstatusinlineeditrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcparentfromissueviewrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "issueTableViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "after",
                                    "variableName": "after"
                                },
                                v12 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "first",
                                    "variableName": "first"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "issueSearchInput",
                                    "variableName": "issueSearchInput"
                                }
                            ],
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearchStable",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v13 /*: any*/ ,
                                                v14 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "issueId"
                                                },
                                                {
                                                    "condition": "shouldQueryFieldSetsById",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                v15 /*: any*/ ,
                                                                v16 /*: any*/ 
                                                            ],
                                                            "concreteType": "JiraIssueFieldSetConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldSetsById",
                                                            "plural": false,
                                                            "selections": v33 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "shouldQueryFieldSetsById",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Variable",
                                                                    "name": "filterId",
                                                                    "variableName": "filterId"
                                                                },
                                                                v16 /*: any*/ ,
                                                                {
                                                                    "kind": "Variable",
                                                                    "name": "namespace",
                                                                    "variableName": "namespace"
                                                                },
                                                                {
                                                                    "kind": "Variable",
                                                                    "name": "viewId",
                                                                    "variableName": "viewId"
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueFieldSetConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldSetsForIssueSearchView",
                                                            "plural": false,
                                                            "selections": v33 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "childIssues",
                                                            "plural": false,
                                                            "selections": [
                                                                v19 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "activeProjectsOnly",
                                                                                    "value": true
                                                                                },
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "first",
                                                                                    "value": 10
                                                                                }
                                                                            ],
                                                                            "concreteType": "JiraIssueConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "issues",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v29 /*: any*/ 
                                                                            ],
                                                                            "storageKey": "issues(activeProjectsOnly:true,first:10)"
                                                                        }
                                                                    ],
                                                                    "type": "JiraChildIssuesWithinLimit"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v19 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "totalIssueSearchResultCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isCappingIssueSearchResult"
                                },
                                {
                                    "concreteType": "JiraIssueNavigatorPageInfo",
                                    "kind": "LinkedField",
                                    "name": "issueNavigatorPageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "firstIssuePosition"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "lastIssuePosition"
                                        }
                                    ]
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "maxCursors",
                                            "value": 7
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "pageSize",
                                            "variableName": "first"
                                        }
                                    ],
                                    "concreteType": "JiraPageCursors",
                                    "kind": "LinkedField",
                                    "name": "pageCursors",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "first",
                                            "plural": false,
                                            "selections": v34 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "around",
                                            "plural": true,
                                            "selections": v34 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "last",
                                            "plural": false,
                                            "selections": v34 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "kind": "ClientExtension",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__id"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": [
                                v12 /*: any*/ ,
                                v15 /*: any*/ 
                            ],
                            "concreteType": "JiraIssueSearchFieldSetConnection",
                            "kind": "LinkedField",
                            "name": "fieldSetsById",
                            "plural": false,
                            "selections": [
                                v29 /*: any*/ ,
                                {
                                    "concreteType": "JiraIssueSearchFieldSetEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueSearchFieldSet",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                v35 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "jqlTerm"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isSortable"
                                                },
                                                {
                                                    "concreteType": "JiraFieldType",
                                                    "kind": "LinkedField",
                                                    "name": "fieldType",
                                                    "plural": false,
                                                    "selections": [
                                                        v35 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isNotFilterFetch",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "filterAri"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        v19 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        },
                                        v14 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5dc885eba68f917efbdf9509e8ab7409f21b2b2ffb3a473aa7fc5c4a7ef790c8",
            "metadata": {},
            "name": "issueTableViewQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider": (0, $dbXJb.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcstatusinlineeditrelayprovider": (0, $fY4Nv.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcparentfromissueviewrelayprovider": (0, $kpHqV.default)
            }
        }
    };
}();
$06ce214e6711bffc$var$node.hash = "b26a3728781eb5ba9292ce7929ffbbd3";
var $06ce214e6711bffc$export$2e2bcd8739ae039 = $06ce214e6711bffc$var$node;

});
parcelRegister("dbXJb", function(module, exports) {

$parcel$export(module.exports, "default", () => $97fcddf57bcced87$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$97fcddf57bcced87$export$2e2bcd8739ae039 = {
    get () {
        return (0, $1ybV0.ff)('child-issues-total-count-performance-experiment_mt1zj');
    }
};

});

parcelRegister("kpHqV", function(module, exports) {

$parcel$export(module.exports, "default", () => $42eb06e33900abe2$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$42eb06e33900abe2$export$2e2bcd8739ae039 = {
    get () {
        return (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf');
    }
};

});

parcelRegister("fY4Nv", function(module, exports) {

$parcel$export(module.exports, "default", () => $06f51cd3cb5fdd9e$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$06f51cd3cb5fdd9e$export$2e2bcd8739ae039 = {
    get () {
        return (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf');
    }
};

});


parcelRegister("hZVoZ", function(module, exports) {

$parcel$export(module.exports, "transformToValidUserPrefs", () => $eb1425c029f76ab4$export$e9345b021afd3cc3);
$parcel$export(module.exports, "transformToVariables", () => $eb1425c029f76ab4$export$a5cefa50115212b3);
$parcel$export(module.exports, "loadQueryWithUserPrefs", () => $eb1425c029f76ab4$export$700e212b8b5c678f);

var $jBj36 = parcelRequire("jBj36");

var $iWLL0 = parcelRequire("iWLL0");

var $3zsgO = parcelRequire("3zsgO");

var $kEBPk = parcelRequire("kEBPk");

var $bT7m3 = parcelRequire("bT7m3");
var $71TnQ = parcelRequire("71TnQ");
var $9kcYg = parcelRequire("9kcYg");

var $a4IeB = parcelRequire("a4IeB");

var $amu7D = parcelRequire("amu7D");

var $c7ifG = parcelRequire("c7ifG");

var $kUSK3 = parcelRequire("kUSK3");

var $23KAk = parcelRequire("23KAk");

var $c4HBH = parcelRequire("c4HBH");
const $eb1425c029f76ab4$export$23be85030bd58047 = (value)=>value !== undefined && /^-?\d+$/.test(value);
const $eb1425c029f76ab4$export$e9345b021afd3cc3 = (rawUserPrefs)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const pageSize = parseInt(rawUserPrefs.num, 10);
    const columnNames = typeof rawUserPrefs.columnNames === 'string' ? rawUserPrefs.columnNames.split('|') : [];
    const fieldSetIds = columnNames[0] === '--Default--' ? (0, $kEBPk.ISSUE_SEARCH_DEFAULT_COLUMNS) : columnNames;
    const stringifiedFilterId = `${rawUserPrefs.filterId}`;
    const { sortDirection: sortDirection, sortField: sortField } = (0, $c4HBH.getSortFieldAndDirection)(rawUserPrefs.sortBy);
    const showResolved = !!rawUserPrefs.showResolved;
    return {
        filterId: $eb1425c029f76ab4$export$23be85030bd58047(stringifiedFilterId) ? stringifiedFilterId : undefined,
        columnNames: fieldSetIds,
        num: !Number.isNaN(pageSize) ? pageSize : 10,
        sortDirection: sortDirection,
        sortField: sortField,
        showResolved: showResolved
    };
};
const $eb1425c029f76ab4$export$a5cefa50115212b3 = async ({ userPrefs: userPrefs, cloudId: cloudId, activationId: activationId, jql: jql })=>{
    const { filterId: filterId, columnNames: columnNames, num: num, sortField: sortField, sortDirection: sortDirection, showResolved: showResolved } = userPrefs;
    const filterAri = !jql && filterId ? (0, $3zsgO.JiraFilterAri).create({
        filterId: filterId,
        siteId: cloudId,
        activationId: activationId
    }).toString() : '';
    const variables = {
        cloudId: cloudId,
        issueSearchInput: {
            ...jql ? {
                jql: jql
            } : {
                filterId: filterId
            }
        },
        after: null,
        first: num,
        fieldSetIds: columnNames,
        amountOfColumns: (0, $a4IeB.MAX_COLUMNS),
        shouldQueryFieldSetsById: true,
        isNotFilterFetch: !filterAri,
        filterAri: filterAri
    };
    const fieldToJqlTermMap = new Map();
    if (!sortField || !sortDirection || ![
        'ASC',
        'DESC'
    ].includes(sortDirection)) return {
        variables: variables,
        fieldToJqlTermMap: fieldToJqlTermMap
    };
    let jqlToModify = jql;
    if (!jqlToModify && filterAri) {
        const result = await (0, $iWLL0.fetchQuery)((0, $amu7D.default), (0, $jBj36.default), {
            filterAri: filterAri,
            fieldSetIds: variables.fieldSetIds,
            cloudId: variables.cloudId
        }, {
            fetchPolicy: 'store-or-network'
        }).toPromise();
        jqlToModify = result?.jira.filter.jql;
        if (result?.jira.fieldSetsById.edges) result.jira.fieldSetsById.edges.forEach((edge)=>{
            const node = edge?.node;
            if (node && node.isSortable) {
                fieldToJqlTermMap.set(node.fieldSetId, node.jqlTerm);
                node.aliases?.forEach((alias)=>{
                    fieldToJqlTermMap.set(alias, node.jqlTerm);
                });
            }
        });
    }
    if (!jqlToModify) return {
        variables: variables,
        fieldToJqlTermMap: fieldToJqlTermMap
    };
    const jqlUtils = new (0, $71TnQ.JqlUtils)();
    const currentSortField = (0, $kUSK3.convertFieldToJqlTerm)(sortField);
    const jqlTermForSortField = fieldToJqlTermMap.get(currentSortField) ?? currentSortField;
    const modifiedJql = jqlUtils.jql(jqlToModify);
    const oldPrimarySortField = modifiedJql.getPrimarySortField();
    if (oldPrimarySortField) {
        // if the sort field in original filter jql is using alias, we need to pass all possible aliases in
        // so that jqlUtils knows to replace it instead of append it as a new field
        const aliases = (0, $23KAk.getAliasesForField)(jqlTermForSortField, fieldToJqlTermMap);
        modifiedJql.setPrimarySortField(jqlTermForSortField, sortDirection, aliases);
    } else modifiedJql.setPrimarySortField(jqlTermForSortField, sortDirection, []);
    let finalJql = modifiedJql.jqlString;
    if (showResolved) {
        const jast = modifiedJql.jast;
        if (jast) {
            const statusClause = (0, $bT7m3.default)(jast, 'statusCategory');
            if (statusClause) finalJql = (0, $9kcYg.default)(jast, statusClause);
        }
    }
    return {
        variables: {
            ...variables,
            issueSearchInput: {
                jql: finalJql
            }
        },
        fieldToJqlTermMap: fieldToJqlTermMap
    };
};
async function $eb1425c029f76ab4$export$700e212b8b5c678f({ filterId: filterId, columnNames: columnNames, num: num, sortField: sortField, sortDirection: sortDirection }, query, cloudId, activationId, fetchPolicy = 'store-or-network', jql) {
    const { variables: variables } = await $eb1425c029f76ab4$export$a5cefa50115212b3({
        userPrefs: {
            filterId: filterId,
            columnNames: columnNames,
            num: num,
            sortField: sortField,
            sortDirection: sortDirection
        },
        cloudId: cloudId,
        activationId: activationId,
        jql: jql
    });
    const queryReference = (0, $iWLL0.loadQuery)((0, $amu7D.default), query, variables, {
        fetchPolicy: fetchPolicy
    });
    if (false && queryReference.id != null) await (0, $c7ifG.QueryPromisesMap).get(queryReference.id);
    return queryReference;
}

});
parcelRegister("jBj36", function(module, exports) {

$parcel$export(module.exports, "default", () => $f448092d78e73f8c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<aec196cf7a9a909d19b50fc0d02f15fe>>
 * @relayHash 1b12beab40605fc485cec603e72de636
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 42b08194cc944453aac09f65fbd15b91bf5352ae38433b498436ba84bbdf72b6
const $f448092d78e73f8c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterAri"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "filterAri"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "fieldSetIds",
            "variableName": "fieldSetIds"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v8 = {
        "kind": "ScalarField",
        "name": "aliases"
    }, v9 = {
        "kind": "ScalarField",
        "name": "isSortable"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "loadQueryWithUserPrefs_filterResultFilterQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v3 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ 
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.filter"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "JiraIssueSearchFieldSetConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldSetsById",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraIssueSearchFieldSetEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraIssueSearchFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v6 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira.fieldSetsById.edges.node.fieldSetId"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v7 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira.fieldSetsById.edges.node.jqlTerm"
                                                                },
                                                                v8 /*: any*/ ,
                                                                v9 /*: any*/ 
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "jira.fieldSetsById.edges.node"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.fieldSetsById.edges"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.fieldSetsById"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "loadQueryWithUserPrefs_filterResultFilterQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "filter",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v4 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        },
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraIssueSearchFieldSetConnection",
                            "kind": "LinkedField",
                            "name": "fieldSetsById",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueSearchFieldSetEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueSearchFieldSet",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "42b08194cc944453aac09f65fbd15b91bf5352ae38433b498436ba84bbdf72b6",
            "metadata": {},
            "name": "loadQueryWithUserPrefs_filterResultFilterQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f448092d78e73f8c$var$node.hash = "fb2bc07f25e53dc423fbb95184f83cf2";
var $f448092d78e73f8c$export$2e2bcd8739ae039 = $f448092d78e73f8c$var$node;

});

parcelRegister("3zsgO", function(module, exports) {

$parcel$export(module.exports, "JiraFilterAri", () => $0990a7c412d6e11d$export$3cfb6cc809e835bd);

var $lEGF7 = parcelRequire("lEGF7");

var $v8cEo = parcelRequire("v8cEo");

var $hkoEN = parcelRequire("hkoEN");
// src/jira/filter/manifest.ts
var $0990a7c412d6e11d$var$jiraFilterAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9-]+$"),
    resourceOwner: (0, $lEGF7.JiraFilterAriResourceOwner),
    resourceType: (0, $lEGF7.JiraFilterAriResourceType),
    resourceIdSlug: "activation/{activationId}/{filterId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        filterId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
    }
};
// src/jira/filter/index.ts
var $0990a7c412d6e11d$export$3cfb6cc809e835bd = class _JiraFilterAri extends (0, $v8cEo.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._filterId = opts.resourceIdSegmentValues.filterId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get filterId() {
        return this._filterId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $0990a7c412d6e11d$var$jiraFilterAriStaticOpts.qualifier,
            platformQualifier: $0990a7c412d6e11d$var$jiraFilterAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $0990a7c412d6e11d$var$jiraFilterAriStaticOpts.resourceOwner,
            resourceType: $0990a7c412d6e11d$var$jiraFilterAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.filterId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                filterId: opts.filterId
            }
        }, ariOpts = (0, $hkoEN.AriParser).fromOpts(derivedOpts, $0990a7c412d6e11d$var$jiraFilterAriStaticOpts);
        return new _JiraFilterAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hkoEN.AriParser).fromString(maybeAri, $0990a7c412d6e11d$var$jiraFilterAriStaticOpts);
        return new _JiraFilterAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            filterId: this.filterId
        };
    }
};

});
parcelRegister("lEGF7", function(module, exports) {

$parcel$export(module.exports, "JiraFilterAriResourceOwner", () => $7663f750b905e6dc$export$e6199848f52f1119);
$parcel$export(module.exports, "JiraFilterAriResourceType", () => $7663f750b905e6dc$export$3c64de4ae038e3ae);
// src/jira/filter/types.ts
var $7663f750b905e6dc$export$e6199848f52f1119 = "jira", $7663f750b905e6dc$export$3c64de4ae038e3ae = "filter";

});


parcelRegister("bT7m3", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c725fc32c3eb061$export$2e2bcd8739ae039);

const $5c725fc32c3eb061$var$findClauseInAst = (ast, field)=>{
    const where = ast.query?.where;
    if (where) {
        if (where.clauseType === (0, $35634e4e5a46f5ae$export$7a58b23488ea076b)) {
            const { clauses: clauses } = where;
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return clauses.find((c)=>c.clauseType === (0, $35634e4e5a46f5ae$export$ae56b4ef248a2b6a) && c.field.value === field);
        }
        if (where.clauseType === (0, $35634e4e5a46f5ae$export$ae56b4ef248a2b6a) && where.field.value === field) return where;
    }
    return undefined;
};
var $5c725fc32c3eb061$export$2e2bcd8739ae039 = $5c725fc32c3eb061$var$findClauseInAst;

});
const $35634e4e5a46f5ae$export$7a58b23488ea076b = 'compound';
const $35634e4e5a46f5ae$export$ae56b4ef248a2b6a = 'terminal';
const $35634e4e5a46f5ae$export$e356b89f8c8d2fcb = 'not';


parcelRegister("71TnQ", function(module, exports) {

$parcel$export(module.exports, "JqlUtils", () => $35a19a50570b83c0$export$2837dbdb4d803576);

var $bXcc5 = parcelRequire("bXcc5");

var $lNvVH = parcelRequire("lNvVH");
var $Z76ZO = parcelRequire("Z76ZO");
var $37dsC = parcelRequire("37dsC");
var $9Ye3T = parcelRequire("9Ye3T");
var $2yQ0D = parcelRequire("2yQ0D");
class $35a19a50570b83c0$export$2837dbdb4d803576 {
    jql(newJqlString) {
        const newJast = new (0, $bXcc5.JastBuilder)().build(newJqlString);
        if (newJast.errors.length && this.jast) return this;
        this.jast = newJast;
        this.jqlString = newJqlString;
        return this;
    }
    ast(ast) {
        this.jast = ast;
        this.jqlString = ast.represents;
        return this;
    }
    setPrimarySortField(sortField, sortDirection, aliases) {
        if (!this.jast) return this;
        return this.jql((0, $2yQ0D.setPrimarySortField)(this.jast, sortField, sortDirection, aliases));
    }
    setPrimarySortDirection(sortOrder) {
        if (!this.jast) return this;
        return this.jql((0, $9Ye3T.setPrimarySortDirection)(sortOrder, this.jast));
    }
    getPrimarySortField() {
        if (!this.jast) return undefined;
        return (0, $37dsC.getPrimarySortField)(this.jast);
    }
    getPrimarySortDirection() {
        if (!this.jast) return undefined;
        return (0, $Z76ZO.getPrimarySortDirection)(this.jast);
    }
    getOrderBy() {
        if (!this.jast) return undefined;
        return (0, $lNvVH.getOrderBy)(this.jast);
    }
    toJql() {
        return this.jqlString;
    }
    constructor(){
        this.jast = undefined;
        this.jqlString = undefined;
    }
}

});
parcelRegister("bXcc5", function(module, exports) {

$parcel$export(module.exports, "JastBuilder", () => $eca1e117b7087a1d$export$99cae18a5a6ba8cf);

var $9pfFs = parcelRequire("9pfFs");

var $5iWql = parcelRequire("5iWql");

var $8YcxO = parcelRequire("8YcxO");
var $c35D3 = parcelRequire("c35D3");

var $ehDeP = parcelRequire("ehDeP");

var $9I5Iz = parcelRequire("9I5Iz");
var $16oBX = parcelRequire("16oBX");

var $icZEp = parcelRequire("icZEp");
class $eca1e117b7087a1d$export$99cae18a5a6ba8cf {
    setErrorHandler(errorHandler) {
        this.errorHandler = errorHandler;
        return this;
    }
    setErrorListeners(errorListeners) {
        this.errorListeners = this.errorListeners.concat(errorListeners);
        return this;
    }
    build(value) {
        const tokens = this.getTokens(value);
        const parser = this.getParser(tokens);
        const astErrorListener = new (0, $9I5Iz.JastBuilderErrorListener)();
        parser.removeErrorListeners();
        parser.addErrorListener(astErrorListener);
        this.errorListeners.forEach((errorListener)=>parser.addErrorListener(errorListener));
        if (this.errorHandler) {
            parser.errorHandler = this.errorHandler;
            this.errorHandler.reset(parser);
        }
        const visitor = new (0, $icZEp.QueryVisitor)(tokens);
        try {
            const parseTree = parser.jqlQuery();
            const query = parseTree.accept(visitor);
            return (0, $ehDeP.default).jast(query, value, astErrorListener.errors);
        } catch (error) {
            return (0, $ehDeP.default).jast(undefined, value, [
                new (0, $16oBX.JQLParseError)(error.message, error)
            ]);
        }
    }
    constructor(){
        this.errorListeners = [];
        this.errorHandler = undefined;
        this.getTokens = (0, $5iWql.default)((value)=>{
            const chars = (0, $9pfFs.CharStreams).fromString(value);
            const lexer = new (0, $8YcxO.JQLLexer)(chars);
            return new (0, $9pfFs.CommonTokenStream)(lexer);
        });
        this.getParser = (0, $5iWql.default)((tokens)=>new (0, $c35D3.JQLParser)(tokens));
    }
}

});
parcelRegister("9pfFs", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $6d929a23f22266a3$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6d929a23f22266a3$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6d929a23f22266a3$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$6d929a23f22266a3$var$__exportStar((parcelRequire("5oG2w")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("gO8Xw")), module.exports);

// export * from "./ANTLRFileStream";
$6d929a23f22266a3$var$__exportStar((parcelRequire("eZYsJ")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("csTA1")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("doEv1")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("aUhGF")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("8tY30")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("cNEtm")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("1EXcP")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("exlin")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("9hrXh")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("eCP5Y")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("eEgBk")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("3HZil")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("9xPUt")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("67k7F")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("2quiJ")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("5jZSY")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("jo2Zj")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("ldi9e")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("h7Q3L")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("hVliW")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("l3IpB")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("c8NTK")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("iAlWg")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("c9Sjf")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("5n08Y")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("8rZl7")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("2pDMz")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("3Wiwr")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("jdbdJ")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("b7PPe")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("dwftT")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("1xO0Q")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("atcwe")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("3d5Fu")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("hHHux")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("eKXi4")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("lL3Js")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("03lZa")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("b3QEj")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("hwMU6")), module.exports);

// export * from "./UnbufferedCharStream";
// export * from "./UnbufferedTokenStream";
$6d929a23f22266a3$var$__exportStar((parcelRequire("2YAkU")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("hBnE1")), module.exports);

$6d929a23f22266a3$var$__exportStar((parcelRequire("edl4x")), module.exports);

});
parcelRegister("5oG2w", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("gO8Xw", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("eZYsJ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ // ConvertTo-TS run at 2016-10-04T11:26:49.0828748-07:00
var $aeb5a9c9d3e1e2dc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ANTLRInputStream = void 0;

var $fomfP = parcelRequire("fomfP");

var $aN41m = parcelRequire("aN41m");

var $ldi9e = parcelRequire("ldi9e");
const $aeb5a9c9d3e1e2dc$var$READ_BUFFER_SIZE = 1024;
const $aeb5a9c9d3e1e2dc$var$INITIAL_BUFFER_SIZE = 1024;
/**
 * Vacuum all input from a {@link Reader}/{@link InputStream} and then treat it
 * like a `char[]` buffer. Can also pass in a {@link String} or
 * `char[]` to use.
 *
 * If you need encoding, pass in stream/reader with correct encoding.
 *
 * @deprecated as of 4.7, please use `CharStreams` interface.
 */ class $aeb5a9c9d3e1e2dc$var$ANTLRInputStream {
    /** Copy data in string to a local char array */ constructor(input){
        /** 0..n-1 index into string of next char */ this.p = 0;
        this.data = input;
        this.n = input.length;
    }
    /** Reset the stream so that it's in the same state it was
     *  when the object was created *except* the data array is not
     *  touched.
     */ reset() {
        this.p = 0;
    }
    consume() {
        if (this.p >= this.n) {
            $fomfP(this.LA(1) === $ldi9e.IntStream.EOF);
            throw new Error("cannot consume EOF");
        }
        //System.out.println("prev p="+p+", c="+(char)data[p]);
        if (this.p < this.n) this.p++;
    }
    LA(i) {
        if (i === 0) return 0; // undefined
        if (i < 0) {
            i++; // e.g., translate LA(-1) to use offset i=0; then data[p+0-1]
            if (this.p + i - 1 < 0) return $ldi9e.IntStream.EOF; // invalid; no char before first char
        }
        if (this.p + i - 1 >= this.n) //System.out.println("char LA("+i+")=EOF; p="+p);
        return $ldi9e.IntStream.EOF;
        //System.out.println("char LA("+i+")="+(char)data[p+i-1]+"; p="+p);
        //System.out.println("LA("+i+"); p="+p+" n="+n+" data.length="+data.length);
        return this.data.charCodeAt(this.p + i - 1);
    }
    LT(i) {
        return this.LA(i);
    }
    /** Return the current input symbol index 0..n where n indicates the
     *  last symbol has been read.  The index is the index of char to
     *  be returned from LA(1).
     */ get index() {
        return this.p;
    }
    get size() {
        return this.n;
    }
    /** mark/release do nothing; we have entire buffer */ mark() {
        return -1;
    }
    release(marker) {
    // No default implementation since this stream buffers the entire input
    }
    /** consume() ahead until p==index; can't just set p=index as we must
     *  update line and charPositionInLine. If we seek backwards, just set p
     */ seek(index) {
        if (index <= this.p) {
            this.p = index; // just jump; don't update stream state (line, ...)
            return;
        }
        // seek forward, consume until p hits index or n (whichever comes first)
        index = Math.min(index, this.n);
        while(this.p < index)this.consume();
    }
    getText(interval) {
        let start = interval.a;
        let stop = interval.b;
        if (stop >= this.n) stop = this.n - 1;
        let count = stop - start + 1;
        if (start >= this.n) return "";
        // System.err.println("data: "+Arrays.toString(data)+", n="+n+
        // 				   ", start="+start+
        // 				   ", stop="+stop);
        return this.data.substr(start, count);
    }
    get sourceName() {
        if (!this.name) return $ldi9e.IntStream.UNKNOWN_SOURCE_NAME;
        return this.name;
    }
    toString() {
        return this.data;
    }
}
$aeb5a9c9d3e1e2dc$var$__decorate([
    $aN41m.Override
], $aeb5a9c9d3e1e2dc$var$ANTLRInputStream.prototype, "consume", null);
$aeb5a9c9d3e1e2dc$var$__decorate([
    $aN41m.Override
], $aeb5a9c9d3e1e2dc$var$ANTLRInputStream.prototype, "LA", null);
$aeb5a9c9d3e1e2dc$var$__decorate([
    $aN41m.Override
], $aeb5a9c9d3e1e2dc$var$ANTLRInputStream.prototype, "index", null);
$aeb5a9c9d3e1e2dc$var$__decorate([
    $aN41m.Override
], $aeb5a9c9d3e1e2dc$var$ANTLRInputStream.prototype, "size", null);
$aeb5a9c9d3e1e2dc$var$__decorate([
    $aN41m.Override
], $aeb5a9c9d3e1e2dc$var$ANTLRInputStream.prototype, "mark", null);
$aeb5a9c9d3e1e2dc$var$__decorate([
    $aN41m.Override
], $aeb5a9c9d3e1e2dc$var$ANTLRInputStream.prototype, "release", null);
$aeb5a9c9d3e1e2dc$var$__decorate([
    $aN41m.Override
], $aeb5a9c9d3e1e2dc$var$ANTLRInputStream.prototype, "seek", null);
$aeb5a9c9d3e1e2dc$var$__decorate([
    $aN41m.Override
], $aeb5a9c9d3e1e2dc$var$ANTLRInputStream.prototype, "getText", null);
$aeb5a9c9d3e1e2dc$var$__decorate([
    $aN41m.Override
], $aeb5a9c9d3e1e2dc$var$ANTLRInputStream.prototype, "sourceName", null);
$aeb5a9c9d3e1e2dc$var$__decorate([
    $aN41m.Override
], $aeb5a9c9d3e1e2dc$var$ANTLRInputStream.prototype, "toString", null);
module.exports.ANTLRInputStream = $aeb5a9c9d3e1e2dc$var$ANTLRInputStream;

});
parcelRegister("fomfP", function(module, exports) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var $2fFJv = parcelRequire("2fFJv");
'use strict';
function $b34a5c254ce73537$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $b34a5c254ce73537$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $b34a5c254ce73537$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $b34a5c254ce73537$var$_typeof(obj);
}
function $b34a5c254ce73537$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $5xQQM = parcelRequire("5xQQM");
var $b34a5c254ce73537$var$_require$codes = $5xQQM.codes, $b34a5c254ce73537$var$ERR_AMBIGUOUS_ARGUMENT = $b34a5c254ce73537$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $b34a5c254ce73537$var$ERR_INVALID_ARG_TYPE = $b34a5c254ce73537$var$_require$codes.ERR_INVALID_ARG_TYPE, $b34a5c254ce73537$var$ERR_INVALID_ARG_VALUE = $b34a5c254ce73537$var$_require$codes.ERR_INVALID_ARG_VALUE, $b34a5c254ce73537$var$ERR_INVALID_RETURN_VALUE = $b34a5c254ce73537$var$_require$codes.ERR_INVALID_RETURN_VALUE, $b34a5c254ce73537$var$ERR_MISSING_ARGS = $b34a5c254ce73537$var$_require$codes.ERR_MISSING_ARGS;

var $4ZhvB = parcelRequire("4ZhvB");

var $ibOwR = parcelRequire("ibOwR");
var $b34a5c254ce73537$var$inspect = $ibOwR.inspect;

var $ibOwR = parcelRequire("ibOwR");
var $b34a5c254ce73537$require$_require$types = $ibOwR.types;
var $b34a5c254ce73537$var$isPromise = $b34a5c254ce73537$require$_require$types.isPromise, $b34a5c254ce73537$var$isRegExp = $b34a5c254ce73537$require$_require$types.isRegExp;

var $b34a5c254ce73537$var$objectAssign = Object.assign ? Object.assign : (parcelRequire("hQCs4")).assign;

var $b34a5c254ce73537$var$objectIs = Object.is ? Object.is : (parcelRequire("4BFNJ"));
var $b34a5c254ce73537$var$errorCache = new Map();
var $b34a5c254ce73537$var$isDeepEqual;
var $b34a5c254ce73537$var$isDeepStrictEqual;
var $b34a5c254ce73537$var$parseExpressionAt;
var $b34a5c254ce73537$var$findNodeAround;
var $b34a5c254ce73537$var$decoder;

function $b34a5c254ce73537$var$lazyLoadComparison() {
    var comparison = (parcelRequire("55ouo"));
    $b34a5c254ce73537$var$isDeepEqual = comparison.isDeepEqual;
    $b34a5c254ce73537$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
} // Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var $b34a5c254ce73537$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var $b34a5c254ce73537$var$meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    '\\b',
    '',
    '',
    "\\u000b",
    '\\f',
    '',
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var $b34a5c254ce73537$var$escapeFn = function escapeFn(str) {
    return $b34a5c254ce73537$var$meta[str.charCodeAt(0)];
};
var $b34a5c254ce73537$var$warned = false; // The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var $b34a5c254ce73537$var$assert = module.exports = $b34a5c254ce73537$var$ok;
var $b34a5c254ce73537$var$NO_EXCEPTION_SENTINEL = {}; // All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function $b34a5c254ce73537$var$innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new $4ZhvB(obj);
}
function $b34a5c254ce73537$var$fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = 'Failed';
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if ($b34a5c254ce73537$var$warned === false) {
            $b34a5c254ce73537$var$warned = true;
            var warn = $2fFJv.emitWarning ? $2fFJv.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", 'DeprecationWarning', 'DEP0094');
        }
        if (argsLen === 2) operator = '!=';
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? 'fail' : operator,
        stackStartFn: stackStartFn || $b34a5c254ce73537$var$fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new $4ZhvB(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
$b34a5c254ce73537$var$assert.fail = $b34a5c254ce73537$var$fail; // The AssertionError is defined in internal/error.
$b34a5c254ce73537$var$assert.AssertionError = $4ZhvB;
function $b34a5c254ce73537$var$innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = 'No value argument passed to `assert.ok()`';
        } else if (message instanceof Error) throw message;
        var err = new $4ZhvB({
            actual: value,
            expected: true,
            message: message,
            operator: '==',
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
} // Pure assertion tests whether a value is truthy, as determined
// by !!value.
function $b34a5c254ce73537$var$ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $b34a5c254ce73537$var$innerOk.apply(void 0, [
        $b34a5c254ce73537$var$ok,
        args.length
    ].concat(args));
}
$b34a5c254ce73537$var$assert.ok = $b34a5c254ce73537$var$ok; // The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ $b34a5c254ce73537$var$assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new $b34a5c254ce73537$var$ERR_MISSING_ARGS('actual', 'expected');
     // eslint-disable-next-line eqeqeq
    if (actual != expected) $b34a5c254ce73537$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '==',
        stackStartFn: equal
    });
}; // The non-equality assertion tests for whether two objects are not
// equal with !=.
$b34a5c254ce73537$var$assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $b34a5c254ce73537$var$ERR_MISSING_ARGS('actual', 'expected');
     // eslint-disable-next-line eqeqeq
    if (actual == expected) $b34a5c254ce73537$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '!=',
        stackStartFn: notEqual
    });
}; // The equivalence assertion tests a deep equality relation.
$b34a5c254ce73537$var$assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $b34a5c254ce73537$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($b34a5c254ce73537$var$isDeepEqual === undefined) $b34a5c254ce73537$var$lazyLoadComparison();
    if (!$b34a5c254ce73537$var$isDeepEqual(actual, expected)) $b34a5c254ce73537$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepEqual',
        stackStartFn: deepEqual
    });
}; // The non-equivalence assertion tests for any deep inequality.
$b34a5c254ce73537$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $b34a5c254ce73537$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($b34a5c254ce73537$var$isDeepEqual === undefined) $b34a5c254ce73537$var$lazyLoadComparison();
    if ($b34a5c254ce73537$var$isDeepEqual(actual, expected)) $b34a5c254ce73537$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepEqual',
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ $b34a5c254ce73537$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $b34a5c254ce73537$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($b34a5c254ce73537$var$isDeepEqual === undefined) $b34a5c254ce73537$var$lazyLoadComparison();
    if (!$b34a5c254ce73537$var$isDeepStrictEqual(actual, expected)) $b34a5c254ce73537$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepStrictEqual',
        stackStartFn: deepStrictEqual
    });
};
$b34a5c254ce73537$var$assert.notDeepStrictEqual = $b34a5c254ce73537$var$notDeepStrictEqual;
function $b34a5c254ce73537$var$notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $b34a5c254ce73537$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($b34a5c254ce73537$var$isDeepEqual === undefined) $b34a5c254ce73537$var$lazyLoadComparison();
    if ($b34a5c254ce73537$var$isDeepStrictEqual(actual, expected)) $b34a5c254ce73537$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepStrictEqual',
        stackStartFn: $b34a5c254ce73537$var$notDeepStrictEqual
    });
}
$b34a5c254ce73537$var$assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $b34a5c254ce73537$var$ERR_MISSING_ARGS('actual', 'expected');
    if (!$b34a5c254ce73537$var$objectIs(actual, expected)) $b34a5c254ce73537$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'strictEqual',
        stackStartFn: strictEqual
    });
};
$b34a5c254ce73537$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $b34a5c254ce73537$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($b34a5c254ce73537$var$objectIs(actual, expected)) $b34a5c254ce73537$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notStrictEqual',
        stackStartFn: notStrictEqual
    });
};
var $b34a5c254ce73537$var$Comparison = function Comparison(obj, keys, actual) {
    var _this = this;
    $b34a5c254ce73537$var$_classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === 'string' && $b34a5c254ce73537$var$isRegExp(obj[key]) && obj[key].test(actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
};
function $b34a5c254ce73537$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !$b34a5c254ce73537$var$isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new $b34a5c254ce73537$var$Comparison(actual, keys);
            var b = new $b34a5c254ce73537$var$Comparison(expected, keys, actual);
            var err = new $4ZhvB({
                actual: a,
                expected: b,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        $b34a5c254ce73537$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function $b34a5c254ce73537$var$expectedException(actual, expected, msg, fn) {
    if (typeof expected !== 'function') {
        if ($b34a5c254ce73537$var$isRegExp(expected)) return expected.test(actual); // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new $b34a5c254ce73537$var$ERR_INVALID_ARG_TYPE('expected', [
            'Function',
            'RegExp'
        ], expected);
         // Handle primitives properly.
        if ($b34a5c254ce73537$var$_typeof(actual) !== 'object' || actual === null) {
            var err = new $4ZhvB({
                actual: actual,
                expected: expected,
                message: msg,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected); // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push('name', 'message');
        else if (keys.length === 0) throw new $b34a5c254ce73537$var$ERR_INVALID_ARG_VALUE('error', expected, 'may not be an empty object');
        if ($b34a5c254ce73537$var$isDeepEqual === undefined) $b34a5c254ce73537$var$lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === 'string' && $b34a5c254ce73537$var$isRegExp(expected[key]) && expected[key].test(actual[key])) return;
            $b34a5c254ce73537$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    } // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function $b34a5c254ce73537$var$getActual(fn) {
    if (typeof fn !== 'function') throw new $b34a5c254ce73537$var$ERR_INVALID_ARG_TYPE('fn', 'Function', fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return $b34a5c254ce73537$var$NO_EXCEPTION_SENTINEL;
}
function $b34a5c254ce73537$var$checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return $b34a5c254ce73537$var$isPromise(obj) || obj !== null && $b34a5c254ce73537$var$_typeof(obj) === 'object' && typeof obj.then === 'function' && typeof obj.catch === 'function';
}
function $b34a5c254ce73537$var$waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === 'function') {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn(); // Fail in case no promise is returned.
            if (!$b34a5c254ce73537$var$checkIsPromise(resultPromise)) throw new $b34a5c254ce73537$var$ERR_INVALID_RETURN_VALUE('instance of Promise', 'promiseFn', resultPromise);
        } else if ($b34a5c254ce73537$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new $b34a5c254ce73537$var$ERR_INVALID_ARG_TYPE('promiseFn', [
            'Function',
            'Promise'
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return $b34a5c254ce73537$var$NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function $b34a5c254ce73537$var$expectsError(stackStartFn, actual, error, message) {
    if (typeof error === 'string') {
        if (arguments.length === 4) throw new $b34a5c254ce73537$var$ERR_INVALID_ARG_TYPE('error', [
            'Object',
            'Error',
            'Function',
            'RegExp'
        ], error);
        if ($b34a5c254ce73537$var$_typeof(actual) === 'object' && actual !== null) {
            if (actual.message === error) throw new $b34a5c254ce73537$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error message \"".concat(actual.message, "\" is identical to the message."));
        } else if (actual === error) throw new $b34a5c254ce73537$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error \"".concat(actual, "\" is identical to the message."));
        message = error;
        error = undefined;
    } else if (error != null && $b34a5c254ce73537$var$_typeof(error) !== 'object' && typeof error !== 'function') throw new $b34a5c254ce73537$var$ERR_INVALID_ARG_TYPE('error', [
        'Object',
        'Error',
        'Function',
        'RegExp'
    ], error);
    if (actual === $b34a5c254ce73537$var$NO_EXCEPTION_SENTINEL) {
        var details = '';
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'rejects' ? 'rejection' : 'exception';
        $b34a5c254ce73537$var$innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !$b34a5c254ce73537$var$expectedException(actual, error, message, stackStartFn)) throw actual;
}
function $b34a5c254ce73537$var$expectsNoError(stackStartFn, actual, error, message) {
    if (actual === $b34a5c254ce73537$var$NO_EXCEPTION_SENTINEL) return;
    if (typeof error === 'string') {
        message = error;
        error = undefined;
    }
    if (!error || $b34a5c254ce73537$var$expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'doesNotReject' ? 'rejection' : 'exception';
        $b34a5c254ce73537$var$innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + "Actual message: \"".concat(actual && actual.message, "\""),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
$b34a5c254ce73537$var$assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    $b34a5c254ce73537$var$expectsError.apply(void 0, [
        throws,
        $b34a5c254ce73537$var$getActual(promiseFn)
    ].concat(args));
};
$b34a5c254ce73537$var$assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $b34a5c254ce73537$var$waitForActual(promiseFn).then(function(result) {
        return $b34a5c254ce73537$var$expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
$b34a5c254ce73537$var$assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    $b34a5c254ce73537$var$expectsNoError.apply(void 0, [
        doesNotThrow,
        $b34a5c254ce73537$var$getActual(fn)
    ].concat(args));
};
$b34a5c254ce73537$var$assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $b34a5c254ce73537$var$waitForActual(fn).then(function(result) {
        return $b34a5c254ce73537$var$expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
$b34a5c254ce73537$var$assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = 'ifError got unwanted exception: ';
        if ($b34a5c254ce73537$var$_typeof(err) === 'object' && typeof err.message === 'string') {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += $b34a5c254ce73537$var$inspect(err);
        var newErr = new $4ZhvB({
            actual: err,
            expected: null,
            operator: 'ifError',
            message: message,
            stackStartFn: ifError
        }); // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === 'string') {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split('\n');
            tmp2.shift(); // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split('\n');
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join('\n'), "\n").concat(tmp2.join('\n'));
        }
        throw newErr;
    }
}; // Expose a strict only variant of assert
function $b34a5c254ce73537$var$strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    $b34a5c254ce73537$var$innerOk.apply(void 0, [
        $b34a5c254ce73537$var$strict,
        args.length
    ].concat(args));
}
$b34a5c254ce73537$var$assert.strict = $b34a5c254ce73537$var$objectAssign($b34a5c254ce73537$var$strict, $b34a5c254ce73537$var$assert, {
    equal: $b34a5c254ce73537$var$assert.strictEqual,
    deepEqual: $b34a5c254ce73537$var$assert.deepStrictEqual,
    notEqual: $b34a5c254ce73537$var$assert.notStrictEqual,
    notDeepEqual: $b34a5c254ce73537$var$assert.notDeepStrictEqual
});
$b34a5c254ce73537$var$assert.strict.strict = $b34a5c254ce73537$var$assert.strict;

});
parcelRegister("5xQQM", function(module, exports) {

$parcel$export(module.exports, "codes", () => $409907ccfa1a83e8$export$e45cb6485273080e, (v) => $409907ccfa1a83e8$export$e45cb6485273080e = v);
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ var $409907ccfa1a83e8$export$e45cb6485273080e;
'use strict'; // The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function $409907ccfa1a83e8$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $409907ccfa1a83e8$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $409907ccfa1a83e8$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $409907ccfa1a83e8$var$_typeof(obj);
}
function $409907ccfa1a83e8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $409907ccfa1a83e8$var$_possibleConstructorReturn(self, call) {
    if (call && ($409907ccfa1a83e8$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $409907ccfa1a83e8$var$_assertThisInitialized(self);
}
function $409907ccfa1a83e8$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $409907ccfa1a83e8$var$_getPrototypeOf(o) {
    $409907ccfa1a83e8$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $409907ccfa1a83e8$var$_getPrototypeOf(o);
}
function $409907ccfa1a83e8$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $409907ccfa1a83e8$var$_setPrototypeOf(subClass, superClass);
}
function $409907ccfa1a83e8$var$_setPrototypeOf(o, p) {
    $409907ccfa1a83e8$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $409907ccfa1a83e8$var$_setPrototypeOf(o, p);
}
var $409907ccfa1a83e8$var$codes = {}; // Lazy loaded
var $409907ccfa1a83e8$var$assert;
var $409907ccfa1a83e8$var$util;
function $409907ccfa1a83e8$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $409907ccfa1a83e8$var$_inherits(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            $409907ccfa1a83e8$var$_classCallCheck(this, NodeError);
            _this = $409907ccfa1a83e8$var$_possibleConstructorReturn(this, $409907ccfa1a83e8$var$_getPrototypeOf(NodeError).call(this, getMessage(arg1, arg2, arg3)));
            _this.code = code;
            return _this;
        }
        return NodeError;
    }(Base);
    $409907ccfa1a83e8$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $409907ccfa1a83e8$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $409907ccfa1a83e8$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $409907ccfa1a83e8$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $409907ccfa1a83e8$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$409907ccfa1a83e8$var$createErrorType('ERR_AMBIGUOUS_ARGUMENT', 'The "%s" argument is ambiguous. %s', TypeError);

$409907ccfa1a83e8$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    if ($409907ccfa1a83e8$var$assert === undefined) $409907ccfa1a83e8$var$assert = (parcelRequire("fomfP"));
    $409907ccfa1a83e8$var$assert(typeof name === 'string', "'name' must be a string"); // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $409907ccfa1a83e8$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($409907ccfa1a83e8$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($409907ccfa1a83e8$var$oneOf(expected, 'type'));
    else {
        var type = $409907ccfa1a83e8$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($409907ccfa1a83e8$var$oneOf(expected, 'type'));
    } // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat($409907ccfa1a83e8$var$_typeof(actual));
    return msg;
}, TypeError);

$409907ccfa1a83e8$var$createErrorType('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'is invalid';
    if ($409907ccfa1a83e8$var$util === undefined) $409907ccfa1a83e8$var$util = (parcelRequire("ibOwR"));
    var inspected = $409907ccfa1a83e8$var$util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
$409907ccfa1a83e8$var$createErrorType('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat($409907ccfa1a83e8$var$_typeof(value));
    return "Expected ".concat(input, " to be returned from the \"").concat(name, "\"") + " function but got ".concat(type, ".");
}, TypeError);

$409907ccfa1a83e8$var$createErrorType('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if ($409907ccfa1a83e8$var$assert === undefined) $409907ccfa1a83e8$var$assert = (parcelRequire("fomfP"));
    $409907ccfa1a83e8$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg = 'The ';
    var len = args.length;
    args = args.map(function(a) {
        return "\"".concat(a, "\"");
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(', ');
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$409907ccfa1a83e8$export$e45cb6485273080e = $409907ccfa1a83e8$var$codes;

});
parcelRegister("ibOwR", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $2fFJv = parcelRequire("2fFJv");
var $d3e0731ae145e11c$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $d3e0731ae145e11c$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$d3e0731ae145e11c$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($d3e0731ae145e11c$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($d3e0731ae145e11c$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($d3e0731ae145e11c$var$isNull(x) || !$d3e0731ae145e11c$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $d3e0731ae145e11c$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    if (typeof $2fFJv !== 'undefined' && $2fFJv.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof $2fFJv === 'undefined') return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($2fFJv.throwDeprecation) throw new Error(msg);
            else if ($2fFJv.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var $d3e0731ae145e11c$var$debugs = {};
var $d3e0731ae145e11c$var$debugEnvRegex = /^$/;
var $d3e0731ae145e11c$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$d3e0731ae145e11c$var$debugs[set]) {
        if ($d3e0731ae145e11c$var$debugEnvRegex.test(set)) {
            var pid = $2fFJv.pid;
            $d3e0731ae145e11c$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $d3e0731ae145e11c$var$debugs[set] = function() {};
    }
    return $d3e0731ae145e11c$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $d3e0731ae145e11c$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $d3e0731ae145e11c$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($d3e0731ae145e11c$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($d3e0731ae145e11c$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($d3e0731ae145e11c$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($d3e0731ae145e11c$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($d3e0731ae145e11c$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $d3e0731ae145e11c$var$stylizeWithColor;
    return $d3e0731ae145e11c$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $d3e0731ae145e11c$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$d3e0731ae145e11c$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$d3e0731ae145e11c$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $d3e0731ae145e11c$var$stylizeWithColor(str, styleType) {
    var style = $d3e0731ae145e11c$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $d3e0731ae145e11c$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $d3e0731ae145e11c$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $d3e0731ae145e11c$var$stylizeNoColor(str, styleType) {
    return str;
}
function $d3e0731ae145e11c$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $d3e0731ae145e11c$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $d3e0731ae145e11c$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$d3e0731ae145e11c$var$isString(ret)) ret = $d3e0731ae145e11c$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $d3e0731ae145e11c$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $d3e0731ae145e11c$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($d3e0731ae145e11c$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $d3e0731ae145e11c$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($d3e0731ae145e11c$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($d3e0731ae145e11c$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($d3e0731ae145e11c$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($d3e0731ae145e11c$var$isError(value)) return $d3e0731ae145e11c$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($d3e0731ae145e11c$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($d3e0731ae145e11c$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($d3e0731ae145e11c$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($d3e0731ae145e11c$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($d3e0731ae145e11c$var$isError(value)) base = ' ' + $d3e0731ae145e11c$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($d3e0731ae145e11c$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $d3e0731ae145e11c$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $d3e0731ae145e11c$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $d3e0731ae145e11c$var$reduceToSingleString(output, base, braces);
}
function $d3e0731ae145e11c$var$formatPrimitive(ctx, value) {
    if ($d3e0731ae145e11c$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($d3e0731ae145e11c$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($d3e0731ae145e11c$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($d3e0731ae145e11c$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($d3e0731ae145e11c$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $d3e0731ae145e11c$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $d3e0731ae145e11c$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($d3e0731ae145e11c$var$hasOwnProperty(value, String(i))) output.push($d3e0731ae145e11c$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($d3e0731ae145e11c$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $d3e0731ae145e11c$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$d3e0731ae145e11c$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($d3e0731ae145e11c$var$isNull(recurseTimes)) str = $d3e0731ae145e11c$var$formatValue(ctx, desc.value, null);
            else str = $d3e0731ae145e11c$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($d3e0731ae145e11c$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $d3e0731ae145e11c$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("jpjK2"));
function $d3e0731ae145e11c$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $d3e0731ae145e11c$var$isArray;
function $d3e0731ae145e11c$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $d3e0731ae145e11c$var$isBoolean;
function $d3e0731ae145e11c$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $d3e0731ae145e11c$var$isNull;
function $d3e0731ae145e11c$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $d3e0731ae145e11c$var$isNullOrUndefined;
function $d3e0731ae145e11c$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $d3e0731ae145e11c$var$isNumber;
function $d3e0731ae145e11c$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $d3e0731ae145e11c$var$isString;
function $d3e0731ae145e11c$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
module.exports.isSymbol = $d3e0731ae145e11c$var$isSymbol;
function $d3e0731ae145e11c$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $d3e0731ae145e11c$var$isUndefined;
function $d3e0731ae145e11c$var$isRegExp(re) {
    return $d3e0731ae145e11c$var$isObject(re) && $d3e0731ae145e11c$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $d3e0731ae145e11c$var$isRegExp;
module.exports.types.isRegExp = $d3e0731ae145e11c$var$isRegExp;
function $d3e0731ae145e11c$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
module.exports.isObject = $d3e0731ae145e11c$var$isObject;
function $d3e0731ae145e11c$var$isDate(d) {
    return $d3e0731ae145e11c$var$isObject(d) && $d3e0731ae145e11c$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $d3e0731ae145e11c$var$isDate;
module.exports.types.isDate = $d3e0731ae145e11c$var$isDate;
function $d3e0731ae145e11c$var$isError(e) {
    return $d3e0731ae145e11c$var$isObject(e) && ($d3e0731ae145e11c$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $d3e0731ae145e11c$var$isError;
module.exports.types.isNativeError = $d3e0731ae145e11c$var$isError;
function $d3e0731ae145e11c$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $d3e0731ae145e11c$var$isFunction;
function $d3e0731ae145e11c$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $d3e0731ae145e11c$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("fDPIL"));
function $d3e0731ae145e11c$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $d3e0731ae145e11c$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $d3e0731ae145e11c$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $d3e0731ae145e11c$var$timestamp() {
    var d = new Date();
    var time = [
        $d3e0731ae145e11c$var$pad(d.getHours()),
        $d3e0731ae145e11c$var$pad(d.getMinutes()),
        $d3e0731ae145e11c$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $d3e0731ae145e11c$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $d3e0731ae145e11c$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("lyUaN"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$d3e0731ae145e11c$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $d3e0731ae145e11c$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $d3e0731ae145e11c$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($d3e0731ae145e11c$var$kCustomPromisifiedSymbol && original[$d3e0731ae145e11c$var$kCustomPromisifiedSymbol]) {
        var fn = original[$d3e0731ae145e11c$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $d3e0731ae145e11c$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($d3e0731ae145e11c$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $d3e0731ae145e11c$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $d3e0731ae145e11c$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $d3e0731ae145e11c$var$kCustomPromisifiedSymbol;
function $d3e0731ae145e11c$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $d3e0731ae145e11c$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $2fFJv.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $2fFJv.nextTick($d3e0731ae145e11c$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $d3e0731ae145e11c$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $d3e0731ae145e11c$var$callbackify;

});
parcelRegister("jpjK2", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $9fDHT = parcelRequire("9fDHT");

var $e77t3 = parcelRequire("e77t3");

var $btMNR = parcelRequire("btMNR");

var $kQIcs = parcelRequire("kQIcs");
function $e20faa668af53337$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $e20faa668af53337$var$BigIntSupported = typeof BigInt !== 'undefined';
var $e20faa668af53337$var$SymbolSupported = typeof Symbol !== 'undefined';
var $e20faa668af53337$var$ObjectToString = $e20faa668af53337$var$uncurryThis(Object.prototype.toString);
var $e20faa668af53337$var$numberValue = $e20faa668af53337$var$uncurryThis(Number.prototype.valueOf);
var $e20faa668af53337$var$stringValue = $e20faa668af53337$var$uncurryThis(String.prototype.valueOf);
var $e20faa668af53337$var$booleanValue = $e20faa668af53337$var$uncurryThis(Boolean.prototype.valueOf);
if ($e20faa668af53337$var$BigIntSupported) var $e20faa668af53337$var$bigIntValue = $e20faa668af53337$var$uncurryThis(BigInt.prototype.valueOf);
if ($e20faa668af53337$var$SymbolSupported) var $e20faa668af53337$var$symbolValue = $e20faa668af53337$var$uncurryThis(Symbol.prototype.valueOf);
function $e20faa668af53337$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $9fDHT;
module.exports.isGeneratorFunction = $e77t3;
module.exports.isTypedArray = $kQIcs;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $e20faa668af53337$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $e20faa668af53337$var$isPromise;
function $e20faa668af53337$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $kQIcs(value) || $e20faa668af53337$var$isDataView(value);
}
module.exports.isArrayBufferView = $e20faa668af53337$var$isArrayBufferView;
function $e20faa668af53337$var$isUint8Array(value) {
    return $btMNR(value) === 'Uint8Array';
}
module.exports.isUint8Array = $e20faa668af53337$var$isUint8Array;
function $e20faa668af53337$var$isUint8ClampedArray(value) {
    return $btMNR(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $e20faa668af53337$var$isUint8ClampedArray;
function $e20faa668af53337$var$isUint16Array(value) {
    return $btMNR(value) === 'Uint16Array';
}
module.exports.isUint16Array = $e20faa668af53337$var$isUint16Array;
function $e20faa668af53337$var$isUint32Array(value) {
    return $btMNR(value) === 'Uint32Array';
}
module.exports.isUint32Array = $e20faa668af53337$var$isUint32Array;
function $e20faa668af53337$var$isInt8Array(value) {
    return $btMNR(value) === 'Int8Array';
}
module.exports.isInt8Array = $e20faa668af53337$var$isInt8Array;
function $e20faa668af53337$var$isInt16Array(value) {
    return $btMNR(value) === 'Int16Array';
}
module.exports.isInt16Array = $e20faa668af53337$var$isInt16Array;
function $e20faa668af53337$var$isInt32Array(value) {
    return $btMNR(value) === 'Int32Array';
}
module.exports.isInt32Array = $e20faa668af53337$var$isInt32Array;
function $e20faa668af53337$var$isFloat32Array(value) {
    return $btMNR(value) === 'Float32Array';
}
module.exports.isFloat32Array = $e20faa668af53337$var$isFloat32Array;
function $e20faa668af53337$var$isFloat64Array(value) {
    return $btMNR(value) === 'Float64Array';
}
module.exports.isFloat64Array = $e20faa668af53337$var$isFloat64Array;
function $e20faa668af53337$var$isBigInt64Array(value) {
    return $btMNR(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $e20faa668af53337$var$isBigInt64Array;
function $e20faa668af53337$var$isBigUint64Array(value) {
    return $btMNR(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $e20faa668af53337$var$isBigUint64Array;
function $e20faa668af53337$var$isMapToString(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object Map]';
}
$e20faa668af53337$var$isMapToString.working = typeof Map !== 'undefined' && $e20faa668af53337$var$isMapToString(new Map());
function $e20faa668af53337$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $e20faa668af53337$var$isMapToString.working ? $e20faa668af53337$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $e20faa668af53337$var$isMap;
function $e20faa668af53337$var$isSetToString(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object Set]';
}
$e20faa668af53337$var$isSetToString.working = typeof Set !== 'undefined' && $e20faa668af53337$var$isSetToString(new Set());
function $e20faa668af53337$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $e20faa668af53337$var$isSetToString.working ? $e20faa668af53337$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $e20faa668af53337$var$isSet;
function $e20faa668af53337$var$isWeakMapToString(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object WeakMap]';
}
$e20faa668af53337$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $e20faa668af53337$var$isWeakMapToString(new WeakMap());
function $e20faa668af53337$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $e20faa668af53337$var$isWeakMapToString.working ? $e20faa668af53337$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $e20faa668af53337$var$isWeakMap;
function $e20faa668af53337$var$isWeakSetToString(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object WeakSet]';
}
$e20faa668af53337$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $e20faa668af53337$var$isWeakSetToString(new WeakSet());
function $e20faa668af53337$var$isWeakSet(value) {
    return $e20faa668af53337$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $e20faa668af53337$var$isWeakSet;
function $e20faa668af53337$var$isArrayBufferToString(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$e20faa668af53337$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $e20faa668af53337$var$isArrayBufferToString(new ArrayBuffer());
function $e20faa668af53337$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $e20faa668af53337$var$isArrayBufferToString.working ? $e20faa668af53337$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $e20faa668af53337$var$isArrayBuffer;
function $e20faa668af53337$var$isDataViewToString(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object DataView]';
}
$e20faa668af53337$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $e20faa668af53337$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $e20faa668af53337$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $e20faa668af53337$var$isDataViewToString.working ? $e20faa668af53337$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $e20faa668af53337$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $e20faa668af53337$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $e20faa668af53337$var$isSharedArrayBufferToString(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $e20faa668af53337$var$isSharedArrayBuffer(value) {
    if (typeof $e20faa668af53337$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $e20faa668af53337$var$isSharedArrayBufferToString.working === 'undefined') $e20faa668af53337$var$isSharedArrayBufferToString.working = $e20faa668af53337$var$isSharedArrayBufferToString(new $e20faa668af53337$var$SharedArrayBufferCopy());
    return $e20faa668af53337$var$isSharedArrayBufferToString.working ? $e20faa668af53337$var$isSharedArrayBufferToString(value) : value instanceof $e20faa668af53337$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $e20faa668af53337$var$isSharedArrayBuffer;
function $e20faa668af53337$var$isAsyncFunction(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $e20faa668af53337$var$isAsyncFunction;
function $e20faa668af53337$var$isMapIterator(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $e20faa668af53337$var$isMapIterator;
function $e20faa668af53337$var$isSetIterator(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $e20faa668af53337$var$isSetIterator;
function $e20faa668af53337$var$isGeneratorObject(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $e20faa668af53337$var$isGeneratorObject;
function $e20faa668af53337$var$isWebAssemblyCompiledModule(value) {
    return $e20faa668af53337$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $e20faa668af53337$var$isWebAssemblyCompiledModule;
function $e20faa668af53337$var$isNumberObject(value) {
    return $e20faa668af53337$var$checkBoxedPrimitive(value, $e20faa668af53337$var$numberValue);
}
module.exports.isNumberObject = $e20faa668af53337$var$isNumberObject;
function $e20faa668af53337$var$isStringObject(value) {
    return $e20faa668af53337$var$checkBoxedPrimitive(value, $e20faa668af53337$var$stringValue);
}
module.exports.isStringObject = $e20faa668af53337$var$isStringObject;
function $e20faa668af53337$var$isBooleanObject(value) {
    return $e20faa668af53337$var$checkBoxedPrimitive(value, $e20faa668af53337$var$booleanValue);
}
module.exports.isBooleanObject = $e20faa668af53337$var$isBooleanObject;
function $e20faa668af53337$var$isBigIntObject(value) {
    return $e20faa668af53337$var$BigIntSupported && $e20faa668af53337$var$checkBoxedPrimitive(value, $e20faa668af53337$var$bigIntValue);
}
module.exports.isBigIntObject = $e20faa668af53337$var$isBigIntObject;
function $e20faa668af53337$var$isSymbolObject(value) {
    return $e20faa668af53337$var$SymbolSupported && $e20faa668af53337$var$checkBoxedPrimitive(value, $e20faa668af53337$var$symbolValue);
}
module.exports.isSymbolObject = $e20faa668af53337$var$isSymbolObject;
function $e20faa668af53337$var$isBoxedPrimitive(value) {
    return $e20faa668af53337$var$isNumberObject(value) || $e20faa668af53337$var$isStringObject(value) || $e20faa668af53337$var$isBooleanObject(value) || $e20faa668af53337$var$isBigIntObject(value) || $e20faa668af53337$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $e20faa668af53337$var$isBoxedPrimitive;
function $e20faa668af53337$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($e20faa668af53337$var$isArrayBuffer(value) || $e20faa668af53337$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $e20faa668af53337$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});
parcelRegister("9fDHT", function(module, exports) {
'use strict';

var $6bc450c4a7d545b1$var$hasToStringTag = (parcelRequire("6jtVY"))();

var $g94P8 = parcelRequire("g94P8");
var $6bc450c4a7d545b1$var$$toString = $g94P8('Object.prototype.toString');
var $6bc450c4a7d545b1$var$isStandardArguments = function isArguments(value) {
    if ($6bc450c4a7d545b1$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $6bc450c4a7d545b1$var$$toString(value) === '[object Arguments]';
};
var $6bc450c4a7d545b1$var$isLegacyArguments = function isArguments(value) {
    if ($6bc450c4a7d545b1$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $6bc450c4a7d545b1$var$$toString(value) !== '[object Array]' && $6bc450c4a7d545b1$var$$toString(value.callee) === '[object Function]';
};
var $6bc450c4a7d545b1$var$supportsStandardArguments = function() {
    return $6bc450c4a7d545b1$var$isStandardArguments(arguments);
}();
$6bc450c4a7d545b1$var$isStandardArguments.isLegacyArguments = $6bc450c4a7d545b1$var$isLegacyArguments; // for tests
module.exports = $6bc450c4a7d545b1$var$supportsStandardArguments ? $6bc450c4a7d545b1$var$isStandardArguments : $6bc450c4a7d545b1$var$isLegacyArguments;

});
parcelRegister("6jtVY", function(module, exports) {
'use strict';

var $3e6zG = parcelRequire("3e6zG");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $3e6zG() && !!Symbol.toStringTag;
};

});
parcelRegister("3e6zG", function(module, exports) {
'use strict';
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("g94P8", function(module, exports) {
'use strict';

var $1weDt = parcelRequire("1weDt");

var $eitbu = parcelRequire("eitbu");
var $bc113a7ded0692de$var$$indexOf = $eitbu($1weDt('String.prototype.indexOf'));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $1weDt(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $bc113a7ded0692de$var$$indexOf(name, '.prototype.') > -1) return $eitbu(intrinsic);
    return intrinsic;
};

});
parcelRegister("1weDt", function(module, exports) {
'use strict';
var $11b421f1a315cdc3$var$undefined1;

var $isZAy = parcelRequire("isZAy");

var $hKBjS = parcelRequire("hKBjS");

var $3HHGH = parcelRequire("3HHGH");

var $2Eg3J = parcelRequire("2Eg3J");

var $2L4Ry = parcelRequire("2L4Ry");

var $jKgyW = parcelRequire("jKgyW");

var $49b0v = parcelRequire("49b0v");
var $11b421f1a315cdc3$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $11b421f1a315cdc3$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $11b421f1a315cdc3$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};
var $11b421f1a315cdc3$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($11b421f1a315cdc3$var$$gOPD) try {
    $11b421f1a315cdc3$var$$gOPD({}, '');
} catch (e) {
    $11b421f1a315cdc3$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $11b421f1a315cdc3$var$throwTypeError = function() {
    throw new $jKgyW();
};
var $11b421f1a315cdc3$var$ThrowTypeError = $11b421f1a315cdc3$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $11b421f1a315cdc3$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $11b421f1a315cdc3$var$$gOPD(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $11b421f1a315cdc3$var$throwTypeError;
        }
    }
}() : $11b421f1a315cdc3$var$throwTypeError;

var $11b421f1a315cdc3$var$hasSymbols = (parcelRequire("fZcmW"))();

var $11b421f1a315cdc3$var$hasProto = (parcelRequire("17SE1"))();
var $11b421f1a315cdc3$var$getProto = Object.getPrototypeOf || ($11b421f1a315cdc3$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $11b421f1a315cdc3$var$needsEval = {};
var $11b421f1a315cdc3$var$TypedArray = typeof Uint8Array === 'undefined' || !$11b421f1a315cdc3$var$getProto ? undefined : $11b421f1a315cdc3$var$getProto(Uint8Array);
var $11b421f1a315cdc3$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $11b421f1a315cdc3$var$hasSymbols && $11b421f1a315cdc3$var$getProto ? $11b421f1a315cdc3$var$getProto([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $11b421f1a315cdc3$var$needsEval,
    '%AsyncGenerator%': $11b421f1a315cdc3$var$needsEval,
    '%AsyncGeneratorFunction%': $11b421f1a315cdc3$var$needsEval,
    '%AsyncIteratorPrototype%': $11b421f1a315cdc3$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $isZAy,
    '%eval%': eval,
    '%EvalError%': $hKBjS,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $11b421f1a315cdc3$var$$Function,
    '%GeneratorFunction%': $11b421f1a315cdc3$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $11b421f1a315cdc3$var$hasSymbols && $11b421f1a315cdc3$var$getProto ? $11b421f1a315cdc3$var$getProto($11b421f1a315cdc3$var$getProto([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$11b421f1a315cdc3$var$hasSymbols || !$11b421f1a315cdc3$var$getProto ? undefined : $11b421f1a315cdc3$var$getProto(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': Object,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $3HHGH,
    '%ReferenceError%': $2Eg3J,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$11b421f1a315cdc3$var$hasSymbols || !$11b421f1a315cdc3$var$getProto ? undefined : $11b421f1a315cdc3$var$getProto(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $11b421f1a315cdc3$var$hasSymbols && $11b421f1a315cdc3$var$getProto ? $11b421f1a315cdc3$var$getProto(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $11b421f1a315cdc3$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $2L4Ry,
    '%ThrowTypeError%': $11b421f1a315cdc3$var$ThrowTypeError,
    '%TypedArray%': $11b421f1a315cdc3$var$TypedArray,
    '%TypeError%': $jKgyW,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $49b0v,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};
if ($11b421f1a315cdc3$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $11b421f1a315cdc3$var$errorProto = $11b421f1a315cdc3$var$getProto($11b421f1a315cdc3$var$getProto(e));
    $11b421f1a315cdc3$var$INTRINSICS['%Error.prototype%'] = $11b421f1a315cdc3$var$errorProto;
}
var $11b421f1a315cdc3$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $11b421f1a315cdc3$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $11b421f1a315cdc3$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $11b421f1a315cdc3$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $11b421f1a315cdc3$var$getProto) value = $11b421f1a315cdc3$var$getProto(gen.prototype);
    }
    $11b421f1a315cdc3$var$INTRINSICS[name] = value;
    return value;
};
var $11b421f1a315cdc3$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $ehjvj = parcelRequire("ehjvj");

var $kHkNK = parcelRequire("kHkNK");
var $11b421f1a315cdc3$var$$concat = $ehjvj.call(Function.call, Array.prototype.concat);
var $11b421f1a315cdc3$var$$spliceApply = $ehjvj.call(Function.apply, Array.prototype.splice);
var $11b421f1a315cdc3$var$$replace = $ehjvj.call(Function.call, String.prototype.replace);
var $11b421f1a315cdc3$var$$strSlice = $ehjvj.call(Function.call, String.prototype.slice);
var $11b421f1a315cdc3$var$$exec = $ehjvj.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $11b421f1a315cdc3$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $11b421f1a315cdc3$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $11b421f1a315cdc3$var$stringToPath = function stringToPath(string) {
    var first = $11b421f1a315cdc3$var$$strSlice(string, 0, 1);
    var last = $11b421f1a315cdc3$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $2L4Ry('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $2L4Ry('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $11b421f1a315cdc3$var$$replace(string, $11b421f1a315cdc3$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $11b421f1a315cdc3$var$$replace(subString, $11b421f1a315cdc3$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $11b421f1a315cdc3$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($kHkNK($11b421f1a315cdc3$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $11b421f1a315cdc3$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($kHkNK($11b421f1a315cdc3$var$INTRINSICS, intrinsicName)) {
        var value = $11b421f1a315cdc3$var$INTRINSICS[intrinsicName];
        if (value === $11b421f1a315cdc3$var$needsEval) value = $11b421f1a315cdc3$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $jKgyW('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $2L4Ry('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $jKgyW('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $jKgyW('"allowMissing" argument must be a boolean');
    if ($11b421f1a315cdc3$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $2L4Ry('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $11b421f1a315cdc3$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $11b421f1a315cdc3$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $11b421f1a315cdc3$var$$spliceApply(parts, $11b421f1a315cdc3$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $11b421f1a315cdc3$var$$strSlice(part, 0, 1);
        var last = $11b421f1a315cdc3$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $2L4Ry('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($kHkNK($11b421f1a315cdc3$var$INTRINSICS, intrinsicRealName)) value = $11b421f1a315cdc3$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $jKgyW('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($11b421f1a315cdc3$var$$gOPD && i + 1 >= parts.length) {
                var desc = $11b421f1a315cdc3$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $kHkNK(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $11b421f1a315cdc3$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("isZAy", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("hKBjS", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("3HHGH", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("2Eg3J", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("2L4Ry", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("jKgyW", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("49b0v", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("fZcmW", function(module, exports) {
'use strict';
var $ba3625c5ae4adbe4$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $3e6zG = parcelRequire("3e6zG");
module.exports = function hasNativeSymbols() {
    if (typeof $ba3625c5ae4adbe4$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $ba3625c5ae4adbe4$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $3e6zG();
};

});

parcelRegister("17SE1", function(module, exports) {
'use strict';
var $0d20d523845f1db6$var$test = {
    __proto__: null,
    foo: {}
};
var $0d20d523845f1db6$var$$Object = Object;
/** @type {import('.')} */ module.exports = function hasProto() {
    // @ts-expect-error: TS errors on an inherited property for some reason
    return ({
        __proto__: $0d20d523845f1db6$var$test
    }).foo === $0d20d523845f1db6$var$test.foo && !($0d20d523845f1db6$var$test instanceof $0d20d523845f1db6$var$$Object);
};

});

parcelRegister("ehjvj", function(module, exports) {
'use strict';

var $kw7GN = parcelRequire("kw7GN");
module.exports = Function.prototype.bind || $kw7GN;

});
parcelRegister("kw7GN", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $eefcc2b686d85c77$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $eefcc2b686d85c77$var$toStr = Object.prototype.toString;
var $eefcc2b686d85c77$var$max = Math.max;
var $eefcc2b686d85c77$var$funcType = '[object Function]';
var $eefcc2b686d85c77$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $eefcc2b686d85c77$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $eefcc2b686d85c77$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $eefcc2b686d85c77$var$toStr.apply(target) !== $eefcc2b686d85c77$var$funcType) throw new TypeError($eefcc2b686d85c77$var$ERROR_MESSAGE + target);
    var args = $eefcc2b686d85c77$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $eefcc2b686d85c77$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $eefcc2b686d85c77$var$concatty(args, arguments));
    };
    var boundLength = $eefcc2b686d85c77$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $eefcc2b686d85c77$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("kHkNK", function(module, exports) {
'use strict';
var $f117f58260d3a487$var$call = Function.prototype.call;
var $f117f58260d3a487$var$$hasOwn = Object.prototype.hasOwnProperty;

var $ehjvj = parcelRequire("ehjvj");
/** @type {import('.')} */ module.exports = $ehjvj.call($f117f58260d3a487$var$call, $f117f58260d3a487$var$$hasOwn);

});


parcelRegister("eitbu", function(module, exports) {
'use strict';

var $ehjvj = parcelRequire("ehjvj");

var $1weDt = parcelRequire("1weDt");

var $gIATW = parcelRequire("gIATW");

var $jKgyW = parcelRequire("jKgyW");
var $a689628365f65073$var$$apply = $1weDt('%Function.prototype.apply%');
var $a689628365f65073$var$$call = $1weDt('%Function.prototype.call%');
var $a689628365f65073$var$$reflectApply = $1weDt('%Reflect.apply%', true) || $ehjvj.call($a689628365f65073$var$$call, $a689628365f65073$var$$apply);

var $jrCgl = parcelRequire("jrCgl");
var $a689628365f65073$var$$max = $1weDt('%Math.max%');
module.exports = function callBind(originalFunction) {
    if (typeof originalFunction !== 'function') throw new $jKgyW('a function is required');
    var func = $a689628365f65073$var$$reflectApply($ehjvj, $a689628365f65073$var$$call, arguments);
    return $gIATW(func, 1 + $a689628365f65073$var$$max(0, originalFunction.length - (arguments.length - 1)), true);
};
var $a689628365f65073$var$applyBind = function applyBind() {
    return $a689628365f65073$var$$reflectApply($ehjvj, $a689628365f65073$var$$apply, arguments);
};
if ($jrCgl) $jrCgl(module.exports, 'apply', {
    value: $a689628365f65073$var$applyBind
});
else module.exports.apply = $a689628365f65073$var$applyBind;

});
parcelRegister("gIATW", function(module, exports) {
'use strict';

var $1weDt = parcelRequire("1weDt");

var $cCdl2 = parcelRequire("cCdl2");

var $c2bd6135d127f933$var$hasDescriptors = (parcelRequire("kjsHT"))();

var $aBzvk = parcelRequire("aBzvk");

var $jKgyW = parcelRequire("jKgyW");
var $c2bd6135d127f933$var$$floor = $1weDt('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $jKgyW('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $c2bd6135d127f933$var$$floor(length) !== length) throw new $jKgyW('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $aBzvk) {
        var desc = $aBzvk(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($c2bd6135d127f933$var$hasDescriptors) $cCdl2(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $cCdl2(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("cCdl2", function(module, exports) {
'use strict';

var $jrCgl = parcelRequire("jrCgl");

var $2L4Ry = parcelRequire("2L4Ry");

var $jKgyW = parcelRequire("jKgyW");

var $aBzvk = parcelRequire("aBzvk");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $jKgyW('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $jKgyW('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $jKgyW('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $jKgyW('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $jKgyW('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $jKgyW('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$aBzvk && $aBzvk(obj, property);
    if ($jrCgl) $jrCgl(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $2L4Ry('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});
parcelRegister("jrCgl", function(module, exports) {
'use strict';

var $1weDt = parcelRequire("1weDt");
/** @type {import('.')} */ var $e27e381f6cb45191$var$$defineProperty = $1weDt('%Object.defineProperty%', true) || false;
if ($e27e381f6cb45191$var$$defineProperty) try {
    $e27e381f6cb45191$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $e27e381f6cb45191$var$$defineProperty = false;
}
module.exports = $e27e381f6cb45191$var$$defineProperty;

});

parcelRegister("aBzvk", function(module, exports) {
'use strict';

var $1weDt = parcelRequire("1weDt");
var $7b88e67ec805ca25$var$$gOPD = $1weDt('%Object.getOwnPropertyDescriptor%', true);
if ($7b88e67ec805ca25$var$$gOPD) try {
    $7b88e67ec805ca25$var$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $7b88e67ec805ca25$var$$gOPD = null;
}
module.exports = $7b88e67ec805ca25$var$$gOPD;

});


parcelRegister("kjsHT", function(module, exports) {
'use strict';

var $jrCgl = parcelRequire("jrCgl");
var $ec9bd99a0f456a55$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$jrCgl;
};
$ec9bd99a0f456a55$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$jrCgl) return null;
    try {
        return $jrCgl([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $ec9bd99a0f456a55$var$hasPropertyDescriptors;

});





parcelRegister("e77t3", function(module, exports) {
'use strict';
var $a4678312b9f54a56$var$toStr = Object.prototype.toString;
var $a4678312b9f54a56$var$fnToStr = Function.prototype.toString;
var $a4678312b9f54a56$var$isFnRegex = /^\s*(?:function)?\*/;

var $a4678312b9f54a56$var$hasToStringTag = (parcelRequire("6jtVY"))();
var $a4678312b9f54a56$var$getProto = Object.getPrototypeOf;
var $a4678312b9f54a56$var$getGeneratorFunc = function() {
    if (!$a4678312b9f54a56$var$hasToStringTag) return false;
    try {
        return Function('return function*() {}')();
    } catch (e) {}
};
var $a4678312b9f54a56$var$GeneratorFunction;
module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($a4678312b9f54a56$var$isFnRegex.test($a4678312b9f54a56$var$fnToStr.call(fn))) return true;
    if (!$a4678312b9f54a56$var$hasToStringTag) {
        var str = $a4678312b9f54a56$var$toStr.call(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$a4678312b9f54a56$var$getProto) return false;
    if (typeof $a4678312b9f54a56$var$GeneratorFunction === 'undefined') {
        var generatorFunc = $a4678312b9f54a56$var$getGeneratorFunc();
        $a4678312b9f54a56$var$GeneratorFunction = generatorFunc ? $a4678312b9f54a56$var$getProto(generatorFunc) : false;
    }
    return $a4678312b9f54a56$var$getProto(fn) === $a4678312b9f54a56$var$GeneratorFunction;
};

});

parcelRegister("btMNR", function(module, exports) {
'use strict';

var $lUcp2 = parcelRequire("lUcp2");

var $isVN0 = parcelRequire("isVN0");

var $eitbu = parcelRequire("eitbu");

var $g94P8 = parcelRequire("g94P8");

var $aBzvk = parcelRequire("aBzvk");
/** @type {(O: object) => string} */ var $85b8426f3d620737$var$$toString = $g94P8('Object.prototype.toString');

var $85b8426f3d620737$var$hasToStringTag = (parcelRequire("6jtVY"))();
var $85b8426f3d620737$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $85b8426f3d620737$var$typedArrays = $isVN0();
var $85b8426f3d620737$var$$slice = $g94P8('String.prototype.slice');
var $85b8426f3d620737$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $85b8426f3d620737$var$$indexOf = $g94P8('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {(receiver: import('.').TypedArray) => string | typeof Uint8Array.prototype.slice.call | typeof Uint8Array.prototype.set.call} Getter */ /** @type {{ [k in `\$${import('.').TypedArrayName}`]?: Getter } & { __proto__: null }} */ var $85b8426f3d620737$var$cache = {
    __proto__: null
};
if ($85b8426f3d620737$var$hasToStringTag && $aBzvk && $85b8426f3d620737$var$getPrototypeOf) $lUcp2($85b8426f3d620737$var$typedArrays, function(typedArray) {
    var arr = new $85b8426f3d620737$var$g[typedArray]();
    if (Symbol.toStringTag in arr) {
        var proto = $85b8426f3d620737$var$getPrototypeOf(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $aBzvk(proto, Symbol.toStringTag);
        if (!descriptor) {
            var superProto = $85b8426f3d620737$var$getPrototypeOf(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $aBzvk(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        $85b8426f3d620737$var$cache['$' + typedArray] = $eitbu(descriptor.get);
    }
});
else $lUcp2($85b8426f3d620737$var$typedArrays, function(typedArray) {
    var arr = new $85b8426f3d620737$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) // @ts-expect-error TODO: fix
    $85b8426f3d620737$var$cache['$' + typedArray] = $eitbu(fn);
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $85b8426f3d620737$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $lUcp2(// eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */ /** @type {any} */ $85b8426f3d620737$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error TODO: fix
            if ('$' + getter(value) === typedArray) found = $85b8426f3d620737$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $85b8426f3d620737$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $lUcp2(// eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */ /** @type {any} */ $85b8426f3d620737$var$cache, /** @type {(getter: typeof cache, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error TODO: fix
            getter(value);
            found = $85b8426f3d620737$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$85b8426f3d620737$var$hasToStringTag) {
        /** @type {string} */ var tag = $85b8426f3d620737$var$$slice($85b8426f3d620737$var$$toString(value), 8, -1);
        if ($85b8426f3d620737$var$$indexOf($85b8426f3d620737$var$typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $85b8426f3d620737$var$trySlices(value);
    }
    if (!$aBzvk) return null;
     // unknown engine
    return $85b8426f3d620737$var$tryTypedArrays(value);
};

});
parcelRegister("lUcp2", function(module, exports) {
'use strict';

var $2GDa0 = parcelRequire("2GDa0");
var $ff2872e50ec13c73$var$toStr = Object.prototype.toString;
var $ff2872e50ec13c73$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $ff2872e50ec13c73$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($ff2872e50ec13c73$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
var $ff2872e50ec13c73$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
var $ff2872e50ec13c73$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($ff2872e50ec13c73$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
var $ff2872e50ec13c73$var$forEach = function forEach(list, iterator, thisArg) {
    if (!$2GDa0(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($ff2872e50ec13c73$var$toStr.call(list) === '[object Array]') $ff2872e50ec13c73$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $ff2872e50ec13c73$var$forEachString(list, iterator, receiver);
    else $ff2872e50ec13c73$var$forEachObject(list, iterator, receiver);
};
module.exports = $ff2872e50ec13c73$var$forEach;

});
parcelRegister("2GDa0", function(module, exports) {
'use strict';
var $1f4de171721c0f5b$var$fnToStr = Function.prototype.toString;
var $1f4de171721c0f5b$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $1f4de171721c0f5b$var$badArrayLike;
var $1f4de171721c0f5b$var$isCallableMarker;
if (typeof $1f4de171721c0f5b$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $1f4de171721c0f5b$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $1f4de171721c0f5b$var$isCallableMarker;
        }
    });
    $1f4de171721c0f5b$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $1f4de171721c0f5b$var$reflectApply(function() {
        throw 42;
    }, null, $1f4de171721c0f5b$var$badArrayLike);
} catch (_) {
    if (_ !== $1f4de171721c0f5b$var$isCallableMarker) $1f4de171721c0f5b$var$reflectApply = null;
}
else $1f4de171721c0f5b$var$reflectApply = null;
var $1f4de171721c0f5b$var$constructorRegex = /^\s*class\b/;
var $1f4de171721c0f5b$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $1f4de171721c0f5b$var$fnToStr.call(value);
        return $1f4de171721c0f5b$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $1f4de171721c0f5b$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($1f4de171721c0f5b$var$isES6ClassFn(value)) return false;
        $1f4de171721c0f5b$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $1f4de171721c0f5b$var$toStr = Object.prototype.toString;
var $1f4de171721c0f5b$var$objectClass = '[object Object]';
var $1f4de171721c0f5b$var$fnClass = '[object Function]';
var $1f4de171721c0f5b$var$genClass = '[object GeneratorFunction]';
var $1f4de171721c0f5b$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $1f4de171721c0f5b$var$ddaClass2 = '[object HTML document.all class]';
var $1f4de171721c0f5b$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $1f4de171721c0f5b$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $1f4de171721c0f5b$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $1f4de171721c0f5b$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $1f4de171721c0f5b$var$all = document.all;
    if ($1f4de171721c0f5b$var$toStr.call($1f4de171721c0f5b$var$all) === $1f4de171721c0f5b$var$toStr.call(document.all)) $1f4de171721c0f5b$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($1f4de171721c0f5b$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $1f4de171721c0f5b$var$toStr.call(value);
            return (str === $1f4de171721c0f5b$var$ddaClass || str === $1f4de171721c0f5b$var$ddaClass2 || str === $1f4de171721c0f5b$var$ddaClass3 // opera 12.16
             || str === $1f4de171721c0f5b$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $1f4de171721c0f5b$var$reflectApply ? function isCallable(value) {
    if ($1f4de171721c0f5b$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $1f4de171721c0f5b$var$reflectApply(value, null, $1f4de171721c0f5b$var$badArrayLike);
    } catch (e) {
        if (e !== $1f4de171721c0f5b$var$isCallableMarker) return false;
    }
    return !$1f4de171721c0f5b$var$isES6ClassFn(value) && $1f4de171721c0f5b$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($1f4de171721c0f5b$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($1f4de171721c0f5b$var$hasToStringTag) return $1f4de171721c0f5b$var$tryFunctionObject(value);
    if ($1f4de171721c0f5b$var$isES6ClassFn(value)) return false;
    var strClass = $1f4de171721c0f5b$var$toStr.call(value);
    if (strClass !== $1f4de171721c0f5b$var$fnClass && strClass !== $1f4de171721c0f5b$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $1f4de171721c0f5b$var$tryFunctionObject(value);
};

});


parcelRegister("isVN0", function(module, exports) {
'use strict';

var $3LhLu = parcelRequire("3LhLu");
var $d717ab4641bd380c$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $3LhLu.length; i++)if (typeof $d717ab4641bd380c$var$g[$3LhLu[i]] === 'function') // @ts-expect-error
    out[out.length] = $3LhLu[i];
    return out;
};

});
parcelRegister("3LhLu", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});



parcelRegister("kQIcs", function(module, exports) {
'use strict';

var $btMNR = parcelRequire("btMNR");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$btMNR(value);
};

});


parcelRegister("fDPIL", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});

parcelRegister("lyUaN", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});



parcelRegister("4ZhvB", function(module, exports) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c

var $2fFJv = parcelRequire("2fFJv");
'use strict';
function $3a1a70c979998564$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $3a1a70c979998564$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $3a1a70c979998564$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3a1a70c979998564$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3a1a70c979998564$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3a1a70c979998564$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3a1a70c979998564$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3a1a70c979998564$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $3a1a70c979998564$var$_possibleConstructorReturn(self, call) {
    if (call && ($3a1a70c979998564$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $3a1a70c979998564$var$_assertThisInitialized(self);
}
function $3a1a70c979998564$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $3a1a70c979998564$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $3a1a70c979998564$var$_setPrototypeOf(subClass, superClass);
}
function $3a1a70c979998564$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $3a1a70c979998564$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$3a1a70c979998564$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $3a1a70c979998564$var$_construct(Class, arguments, $3a1a70c979998564$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $3a1a70c979998564$var$_setPrototypeOf(Wrapper, Class);
    };
    return $3a1a70c979998564$var$_wrapNativeSuper(Class);
}
function $3a1a70c979998564$var$isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $3a1a70c979998564$var$_construct(Parent, args, Class) {
    if ($3a1a70c979998564$var$isNativeReflectConstruct()) $3a1a70c979998564$var$_construct = Reflect.construct;
    else $3a1a70c979998564$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $3a1a70c979998564$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $3a1a70c979998564$var$_construct.apply(null, arguments);
}
function $3a1a70c979998564$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $3a1a70c979998564$var$_setPrototypeOf(o, p) {
    $3a1a70c979998564$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3a1a70c979998564$var$_setPrototypeOf(o, p);
}
function $3a1a70c979998564$var$_getPrototypeOf(o) {
    $3a1a70c979998564$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $3a1a70c979998564$var$_getPrototypeOf(o);
}
function $3a1a70c979998564$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $3a1a70c979998564$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $3a1a70c979998564$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $3a1a70c979998564$var$_typeof(obj);
}

var $ibOwR = parcelRequire("ibOwR");
var $3a1a70c979998564$var$inspect = $ibOwR.inspect;

var $5xQQM = parcelRequire("5xQQM");
var $3a1a70c979998564$var$ERR_INVALID_ARG_TYPE = $5xQQM.codes.ERR_INVALID_ARG_TYPE; // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $3a1a70c979998564$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function $3a1a70c979998564$var$repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return '';
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var $3a1a70c979998564$var$blue = '';
var $3a1a70c979998564$var$green = '';
var $3a1a70c979998564$var$red = '';
var $3a1a70c979998564$var$white = '';
var $3a1a70c979998564$var$kReadableOperator = {
    deepStrictEqual: 'Expected values to be strictly deep-equal:',
    strictEqual: 'Expected values to be strictly equal:',
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: 'Expected values to be loosely deep-equal:',
    equal: 'Expected values to be loosely equal:',
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: 'Values identical but not reference-equal:'
}; // Comparing short primitives should just show === / !== instead of using the
// diff.
var $3a1a70c979998564$var$kMaxShortLength = 10;
function $3a1a70c979998564$var$copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, 'message', {
        value: source.message
    });
    return target;
}
function $3a1a70c979998564$var$inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return $3a1a70c979998564$var$inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function $3a1a70c979998564$var$createErrDiff(actual, expected, operator) {
    var other = '';
    var res = '';
    var lastPos = 0;
    var end = '';
    var skipped = false;
    var actualInspected = $3a1a70c979998564$var$inspectValue(actual);
    var actualLines = actualInspected.split('\n');
    var expectedLines = $3a1a70c979998564$var$inspectValue(expected).split('\n');
    var i = 0;
    var indicator = ''; // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === 'strictEqual' && $3a1a70c979998564$var$_typeof(actual) === 'object' && $3a1a70c979998564$var$_typeof(expected) === 'object' && actual !== null && expected !== null) operator = 'strictEqualObject';
     // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length; // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= $3a1a70c979998564$var$kMaxShortLength) {
            if (($3a1a70c979998564$var$_typeof(actual) !== 'object' || actual === null) && ($3a1a70c979998564$var$_typeof(expected) !== 'object' || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat($3a1a70c979998564$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== 'strictEqualObject') {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = $2fFJv.stderr && $2fFJv.stderr.isTTY ? $2fFJv.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                 // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat($3a1a70c979998564$var$repeat(' ', i), "^");
                    i = 0;
                }
            }
        }
    } // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length); // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split('\n'); // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat($3a1a70c979998564$var$blue, "...").concat($3a1a70c979998564$var$white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat($3a1a70c979998564$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join('\n'), "\n");
    }
    if (i > 3) {
        end = "\n".concat($3a1a70c979998564$var$blue, "...").concat($3a1a70c979998564$var$white).concat(end);
        skipped = true;
    }
    if (other !== '') {
        end = "\n  ".concat(other).concat(end);
        other = '';
    }
    var printedLines = 0;
    var msg = $3a1a70c979998564$var$kReadableOperator[operator] + "\n".concat($3a1a70c979998564$var$green, "+ actual").concat($3a1a70c979998564$var$white, " ").concat($3a1a70c979998564$var$red, "- expected").concat($3a1a70c979998564$var$white);
    var skippedMsg = " ".concat($3a1a70c979998564$var$blue, "...").concat($3a1a70c979998564$var$white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($3a1a70c979998564$var$blue, "...").concat($3a1a70c979998564$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            } // Mark the current line as the last diverging one.
            lastPos = i; // Add the expected line to the cache.
            other += "\n".concat($3a1a70c979998564$var$red, "-").concat($3a1a70c979998564$var$white, " ").concat(expectedLines[i]);
            printedLines++; // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($3a1a70c979998564$var$blue, "...").concat($3a1a70c979998564$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            } // Mark the current line as the last diverging one.
            lastPos = i; // Add the actual line to the result.
            res += "\n".concat($3a1a70c979998564$var$green, "+").concat($3a1a70c979998564$var$white, " ").concat(actualLines[i]);
            printedLines++; // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i]; // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!$3a1a70c979998564$var$endsWith(actualLine, ',') || actualLine.slice(0, -1) !== expectedLine); // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && $3a1a70c979998564$var$endsWith(expectedLine, ',') && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ',';
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($3a1a70c979998564$var$blue, "...").concat($3a1a70c979998564$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                } // Mark the current line as the last diverging one.
                lastPos = i; // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat($3a1a70c979998564$var$green, "+").concat($3a1a70c979998564$var$white, " ").concat(actualLine);
                other += "\n".concat($3a1a70c979998564$var$red, "-").concat($3a1a70c979998564$var$white, " ").concat(expectedLine);
                printedLines += 2; // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = ''; // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        } // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($3a1a70c979998564$var$blue, "...").concat($3a1a70c979998564$var$white).concat(other, "\n") + "".concat($3a1a70c979998564$var$blue, "...").concat($3a1a70c979998564$var$white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : '', "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var $3a1a70c979998564$var$AssertionError = /*#__PURE__*/ function(_Error) {
    $3a1a70c979998564$var$_inherits(AssertionError, _Error);
    function AssertionError(options) {
        var _this;
        $3a1a70c979998564$var$_classCallCheck(this, AssertionError);
        if ($3a1a70c979998564$var$_typeof(options) !== 'object' || options === null) throw new $3a1a70c979998564$var$ERR_INVALID_ARG_TYPE('options', 'Object', options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = $3a1a70c979998564$var$_possibleConstructorReturn(this, $3a1a70c979998564$var$_getPrototypeOf(AssertionError).call(this, String(message)));
        else {
            if ($2fFJv.stderr && $2fFJv.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if ($2fFJv.stderr && $2fFJv.stderr.getColorDepth && $2fFJv.stderr.getColorDepth() !== 1) {
                    $3a1a70c979998564$var$blue = "\x1B[34m";
                    $3a1a70c979998564$var$green = "\x1B[32m";
                    $3a1a70c979998564$var$white = "\x1B[39m";
                    $3a1a70c979998564$var$red = "\x1B[31m";
                } else {
                    $3a1a70c979998564$var$blue = '';
                    $3a1a70c979998564$var$green = '';
                    $3a1a70c979998564$var$white = '';
                    $3a1a70c979998564$var$red = '';
                }
            } // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if ($3a1a70c979998564$var$_typeof(actual) === 'object' && actual !== null && $3a1a70c979998564$var$_typeof(expected) === 'object' && expected !== null && 'stack' in actual && actual instanceof Error && 'stack' in expected && expected instanceof Error) {
                actual = $3a1a70c979998564$var$copyError(actual);
                expected = $3a1a70c979998564$var$copyError(expected);
            }
            if (operator === 'deepStrictEqual' || operator === 'strictEqual') _this = $3a1a70c979998564$var$_possibleConstructorReturn(this, $3a1a70c979998564$var$_getPrototypeOf(AssertionError).call(this, $3a1a70c979998564$var$createErrDiff(actual, expected, operator)));
            else if (operator === 'notDeepStrictEqual' || operator === 'notStrictEqual') {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = $3a1a70c979998564$var$kReadableOperator[operator];
                var res = $3a1a70c979998564$var$inspectValue(actual).split('\n'); // In case "actual" is an object, it should not be reference equal.
                if (operator === 'notStrictEqual' && $3a1a70c979998564$var$_typeof(actual) === 'object' && actual !== null) base = $3a1a70c979998564$var$kReadableOperator.notStrictEqualObject;
                 // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat($3a1a70c979998564$var$blue, "...").concat($3a1a70c979998564$var$white);
                    while(res.length > 27)res.pop();
                } // Only print a single input.
                if (res.length === 1) _this = $3a1a70c979998564$var$_possibleConstructorReturn(this, $3a1a70c979998564$var$_getPrototypeOf(AssertionError).call(this, "".concat(base, " ").concat(res[0])));
                else _this = $3a1a70c979998564$var$_possibleConstructorReturn(this, $3a1a70c979998564$var$_getPrototypeOf(AssertionError).call(this, "".concat(base, "\n\n").concat(res.join('\n'), "\n")));
            } else {
                var _res = $3a1a70c979998564$var$inspectValue(actual);
                var other = '';
                var knownOperators = $3a1a70c979998564$var$kReadableOperator[operator];
                if (operator === 'notDeepEqual' || operator === 'notEqual') {
                    _res = "".concat($3a1a70c979998564$var$kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat($3a1a70c979998564$var$inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === 'deepEqual' || operator === 'equal') _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = $3a1a70c979998564$var$_possibleConstructorReturn(this, $3a1a70c979998564$var$_getPrototypeOf(AssertionError).call(this, "".concat(_res).concat(other)));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty($3a1a70c979998564$var$_assertThisInitialized(_this), 'name', {
            value: 'AssertionError [ERR_ASSERTION]',
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = 'ERR_ASSERTION';
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace($3a1a70c979998564$var$_assertThisInitialized(_this), stackStartFn);
         // Create error message including the error code in the name.
        _this.stack; // Reset the name.
        _this.name = 'AssertionError';
        return $3a1a70c979998564$var$_possibleConstructorReturn(_this);
    }
    $3a1a70c979998564$var$_createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: $3a1a70c979998564$var$inspect.custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return $3a1a70c979998564$var$inspect(this, $3a1a70c979998564$var$_objectSpread({}, ctx, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}($3a1a70c979998564$var$_wrapNativeSuper(Error));
module.exports = $3a1a70c979998564$var$AssertionError;

});

parcelRegister("hQCs4", function(module, exports) {
/**
 * Code refactored from Mozilla Developer Network:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 */ 'use strict';
function $cfe51eb9750f915c$var$assign(target, firstSource) {
    if (target === undefined || target === null) throw new TypeError('Cannot convert first argument to object');
    var to = Object(target);
    for(var i = 1; i < arguments.length; i++){
        var nextSource = arguments[i];
        if (nextSource === undefined || nextSource === null) continue;
        var keysArray = Object.keys(Object(nextSource));
        for(var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++){
            var nextKey = keysArray[nextIndex];
            var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
            if (desc !== undefined && desc.enumerable) to[nextKey] = nextSource[nextKey];
        }
    }
    return to;
}
function $cfe51eb9750f915c$var$polyfill() {
    if (!Object.assign) Object.defineProperty(Object, 'assign', {
        enumerable: false,
        configurable: true,
        writable: true,
        value: $cfe51eb9750f915c$var$assign
    });
}
module.exports = {
    assign: $cfe51eb9750f915c$var$assign,
    polyfill: $cfe51eb9750f915c$var$polyfill
};

});

parcelRegister("4BFNJ", function(module, exports) {
'use strict';

var $7DUGk = parcelRequire("7DUGk");

var $eitbu = parcelRequire("eitbu");

var $dAjEz = parcelRequire("dAjEz");

var $c4ycW = parcelRequire("c4ycW");

var $29zXl = parcelRequire("29zXl");
var $35ab0af6f8ad58df$var$polyfill = $eitbu($c4ycW(), Object);
$7DUGk($35ab0af6f8ad58df$var$polyfill, {
    getPolyfill: $c4ycW,
    implementation: $dAjEz,
    shim: $29zXl
});
module.exports = $35ab0af6f8ad58df$var$polyfill;

});
parcelRegister("7DUGk", function(module, exports) {
'use strict';

var $4jDQV = parcelRequire("4jDQV");
var $590824c046b6e009$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var $590824c046b6e009$var$toStr = Object.prototype.toString;
var $590824c046b6e009$var$concat = Array.prototype.concat;

var $cCdl2 = parcelRequire("cCdl2");
var $590824c046b6e009$var$isFunction = function(fn) {
    return typeof fn === 'function' && $590824c046b6e009$var$toStr.call(fn) === '[object Function]';
};

var $590824c046b6e009$var$supportsDescriptors = (parcelRequire("kjsHT"))();
var $590824c046b6e009$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$590824c046b6e009$var$isFunction(predicate) || !predicate()) return;
    }
    if ($590824c046b6e009$var$supportsDescriptors) $cCdl2(object, name, value, true);
    else $cCdl2(object, name, value);
};
var $590824c046b6e009$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $4jDQV(map);
    if ($590824c046b6e009$var$hasSymbols) props = $590824c046b6e009$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$590824c046b6e009$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$590824c046b6e009$var$defineProperties.supportsDescriptors = !!$590824c046b6e009$var$supportsDescriptors;
module.exports = $590824c046b6e009$var$defineProperties;

});
parcelRegister("4jDQV", function(module, exports) {
'use strict';
var $3247d9b061104208$var$slice = Array.prototype.slice;

var $96nTn = parcelRequire("96nTn");
var $3247d9b061104208$var$origKeys = Object.keys;

var $3247d9b061104208$var$keysShim = $3247d9b061104208$var$origKeys ? function keys(o) {
    return $3247d9b061104208$var$origKeys(o);
} : (parcelRequire("a7WlO"));
var $3247d9b061104208$var$originalKeys = Object.keys;
$3247d9b061104208$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($96nTn(object)) return $3247d9b061104208$var$originalKeys($3247d9b061104208$var$slice.call(object));
            return $3247d9b061104208$var$originalKeys(object);
        };
    } else Object.keys = $3247d9b061104208$var$keysShim;
    return Object.keys || $3247d9b061104208$var$keysShim;
};
module.exports = $3247d9b061104208$var$keysShim;

});
parcelRegister("96nTn", function(module, exports) {
'use strict';
var $6a0735185fec05e3$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $6a0735185fec05e3$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $6a0735185fec05e3$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

});

parcelRegister("a7WlO", function(module, exports) {
'use strict';
var $75f7d21b7a735a78$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $75f7d21b7a735a78$var$has = Object.prototype.hasOwnProperty;
    var $75f7d21b7a735a78$var$toStr = Object.prototype.toString;
    var $75f7d21b7a735a78$var$isArgs = (parcelRequire("96nTn")); // eslint-disable-line global-require
    var $75f7d21b7a735a78$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $75f7d21b7a735a78$var$hasDontEnumBug = !$75f7d21b7a735a78$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $75f7d21b7a735a78$var$hasProtoEnumBug = $75f7d21b7a735a78$var$isEnumerable.call(function() {}, 'prototype');
    var $75f7d21b7a735a78$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $75f7d21b7a735a78$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $75f7d21b7a735a78$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $75f7d21b7a735a78$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$75f7d21b7a735a78$var$excludedKeys['$' + k] && $75f7d21b7a735a78$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $75f7d21b7a735a78$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $75f7d21b7a735a78$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !$75f7d21b7a735a78$var$hasAutomationEqualityBug) return $75f7d21b7a735a78$var$equalsConstructorPrototype(o);
        try {
            return $75f7d21b7a735a78$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $75f7d21b7a735a78$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $75f7d21b7a735a78$var$toStr.call(object) === '[object Function]';
        var isArguments = $75f7d21b7a735a78$var$isArgs(object);
        var isString = isObject && $75f7d21b7a735a78$var$toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $75f7d21b7a735a78$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$75f7d21b7a735a78$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $75f7d21b7a735a78$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($75f7d21b7a735a78$var$hasDontEnumBug) {
            var skipConstructor = $75f7d21b7a735a78$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $75f7d21b7a735a78$var$dontEnums.length; ++k)if (!(skipConstructor && $75f7d21b7a735a78$var$dontEnums[k] === 'constructor') && $75f7d21b7a735a78$var$has.call(object, $75f7d21b7a735a78$var$dontEnums[k])) theKeys.push($75f7d21b7a735a78$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $75f7d21b7a735a78$var$keysShim;

});



parcelRegister("dAjEz", function(module, exports) {
'use strict';
var $9e3de1e5d12e41fc$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($9e3de1e5d12e41fc$var$numberIsNaN(a) && $9e3de1e5d12e41fc$var$numberIsNaN(b)) return true;
    return false;
};

});

parcelRegister("c4ycW", function(module, exports) {
'use strict';

var $dAjEz = parcelRequire("dAjEz");
module.exports = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : $dAjEz;
};

});

parcelRegister("29zXl", function(module, exports) {
'use strict';

var $c4ycW = parcelRequire("c4ycW");

var $7DUGk = parcelRequire("7DUGk");
module.exports = function shimObjectIs() {
    var polyfill = $c4ycW();
    $7DUGk(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRegister("55ouo", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';
function $3b406a6c1a6d91fb$var$_slicedToArray(arr, i) {
    return $3b406a6c1a6d91fb$var$_arrayWithHoles(arr) || $3b406a6c1a6d91fb$var$_iterableToArrayLimit(arr, i) || $3b406a6c1a6d91fb$var$_nonIterableRest();
}
function $3b406a6c1a6d91fb$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function $3b406a6c1a6d91fb$var$_iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $3b406a6c1a6d91fb$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $3b406a6c1a6d91fb$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $3b406a6c1a6d91fb$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $3b406a6c1a6d91fb$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $3b406a6c1a6d91fb$var$_typeof(obj);
}
var $3b406a6c1a6d91fb$var$regexFlagsSupported = /a/g.flags !== undefined;
var $3b406a6c1a6d91fb$var$arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var $3b406a6c1a6d91fb$var$arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};

var $3b406a6c1a6d91fb$var$objectIs = Object.is ? Object.is : (parcelRequire("4BFNJ"));
var $3b406a6c1a6d91fb$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};

var $3b406a6c1a6d91fb$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("djuuL"));
function $3b406a6c1a6d91fb$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $3b406a6c1a6d91fb$var$hasOwnProperty = $3b406a6c1a6d91fb$var$uncurryThis(Object.prototype.hasOwnProperty);
var $3b406a6c1a6d91fb$var$propertyIsEnumerable = $3b406a6c1a6d91fb$var$uncurryThis(Object.prototype.propertyIsEnumerable);
var $3b406a6c1a6d91fb$var$objectToString = $3b406a6c1a6d91fb$var$uncurryThis(Object.prototype.toString);

var $ibOwR = parcelRequire("ibOwR");
var $3b406a6c1a6d91fb$require$_require$types = $ibOwR.types;
var $3b406a6c1a6d91fb$var$isAnyArrayBuffer = $3b406a6c1a6d91fb$require$_require$types.isAnyArrayBuffer, $3b406a6c1a6d91fb$var$isArrayBufferView = $3b406a6c1a6d91fb$require$_require$types.isArrayBufferView, $3b406a6c1a6d91fb$var$isDate = $3b406a6c1a6d91fb$require$_require$types.isDate, $3b406a6c1a6d91fb$var$isMap = $3b406a6c1a6d91fb$require$_require$types.isMap, $3b406a6c1a6d91fb$var$isRegExp = $3b406a6c1a6d91fb$require$_require$types.isRegExp, $3b406a6c1a6d91fb$var$isSet = $3b406a6c1a6d91fb$require$_require$types.isSet, $3b406a6c1a6d91fb$var$isNativeError = $3b406a6c1a6d91fb$require$_require$types.isNativeError, $3b406a6c1a6d91fb$var$isBoxedPrimitive = $3b406a6c1a6d91fb$require$_require$types.isBoxedPrimitive, $3b406a6c1a6d91fb$var$isNumberObject = $3b406a6c1a6d91fb$require$_require$types.isNumberObject, $3b406a6c1a6d91fb$var$isStringObject = $3b406a6c1a6d91fb$require$_require$types.isStringObject, $3b406a6c1a6d91fb$var$isBooleanObject = $3b406a6c1a6d91fb$require$_require$types.isBooleanObject, $3b406a6c1a6d91fb$var$isBigIntObject = $3b406a6c1a6d91fb$require$_require$types.isBigIntObject, $3b406a6c1a6d91fb$var$isSymbolObject = $3b406a6c1a6d91fb$require$_require$types.isSymbolObject, $3b406a6c1a6d91fb$var$isFloat32Array = $3b406a6c1a6d91fb$require$_require$types.isFloat32Array, $3b406a6c1a6d91fb$var$isFloat64Array = $3b406a6c1a6d91fb$require$_require$types.isFloat64Array;
function $3b406a6c1a6d91fb$var$isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    } // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function $3b406a6c1a6d91fb$var$getOwnNonIndexProperties(value) {
    return Object.keys(value).filter($3b406a6c1a6d91fb$var$isNonIndex).concat($3b406a6c1a6d91fb$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
} // Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function $3b406a6c1a6d91fb$var$compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var $3b406a6c1a6d91fb$var$ONLY_ENUMERABLE = undefined;
var $3b406a6c1a6d91fb$var$kStrict = true;
var $3b406a6c1a6d91fb$var$kLoose = false;
var $3b406a6c1a6d91fb$var$kNoIterator = 0;
var $3b406a6c1a6d91fb$var$kIsArray = 1;
var $3b406a6c1a6d91fb$var$kIsSet = 2;
var $3b406a6c1a6d91fb$var$kIsMap = 3; // Check if they have the same source and flags
function $3b406a6c1a6d91fb$var$areSimilarRegExps(a, b) {
    return $3b406a6c1a6d91fb$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function $3b406a6c1a6d91fb$var$areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function $3b406a6c1a6d91fb$var$areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $3b406a6c1a6d91fb$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function $3b406a6c1a6d91fb$var$areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && $3b406a6c1a6d91fb$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function $3b406a6c1a6d91fb$var$isEqualBoxedPrimitive(val1, val2) {
    if ($3b406a6c1a6d91fb$var$isNumberObject(val1)) return $3b406a6c1a6d91fb$var$isNumberObject(val2) && $3b406a6c1a6d91fb$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if ($3b406a6c1a6d91fb$var$isStringObject(val1)) return $3b406a6c1a6d91fb$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if ($3b406a6c1a6d91fb$var$isBooleanObject(val1)) return $3b406a6c1a6d91fb$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if ($3b406a6c1a6d91fb$var$isBigIntObject(val1)) return $3b406a6c1a6d91fb$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return $3b406a6c1a6d91fb$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
} // Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function $3b406a6c1a6d91fb$var$innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? $3b406a6c1a6d91fb$var$objectIs(val1, val2) : true;
    } // Check more closely if val1 and val2 are equal.
    if (strict) {
        if ($3b406a6c1a6d91fb$var$_typeof(val1) !== 'object') return typeof val1 === 'number' && $3b406a6c1a6d91fb$var$numberIsNaN(val1) && $3b406a6c1a6d91fb$var$numberIsNaN(val2);
        if ($3b406a6c1a6d91fb$var$_typeof(val2) !== 'object' || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || $3b406a6c1a6d91fb$var$_typeof(val1) !== 'object') {
            if (val2 === null || $3b406a6c1a6d91fb$var$_typeof(val2) !== 'object') // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || $3b406a6c1a6d91fb$var$_typeof(val2) !== 'object') return false;
    }
    var val1Tag = $3b406a6c1a6d91fb$var$objectToString(val1);
    var val2Tag = $3b406a6c1a6d91fb$var$objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = $3b406a6c1a6d91fb$var$getOwnNonIndexProperties(val1, $3b406a6c1a6d91fb$var$ONLY_ENUMERABLE);
        var keys2 = $3b406a6c1a6d91fb$var$getOwnNonIndexProperties(val2, $3b406a6c1a6d91fb$var$ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return $3b406a6c1a6d91fb$var$keyCheck(val1, val2, strict, memos, $3b406a6c1a6d91fb$var$kIsArray, keys1);
    } // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === '[object Object]') {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!$3b406a6c1a6d91fb$var$isMap(val1) && $3b406a6c1a6d91fb$var$isMap(val2) || !$3b406a6c1a6d91fb$var$isSet(val1) && $3b406a6c1a6d91fb$var$isSet(val2)) return false;
    }
    if ($3b406a6c1a6d91fb$var$isDate(val1)) {
        if (!$3b406a6c1a6d91fb$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if ($3b406a6c1a6d91fb$var$isRegExp(val1)) {
        if (!$3b406a6c1a6d91fb$var$isRegExp(val2) || !$3b406a6c1a6d91fb$var$areSimilarRegExps(val1, val2)) return false;
    } else if ($3b406a6c1a6d91fb$var$isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if ($3b406a6c1a6d91fb$var$isArrayBufferView(val1)) {
        if (!strict && ($3b406a6c1a6d91fb$var$isFloat32Array(val1) || $3b406a6c1a6d91fb$var$isFloat64Array(val1))) {
            if (!$3b406a6c1a6d91fb$var$areSimilarFloatArrays(val1, val2)) return false;
        } else if (!$3b406a6c1a6d91fb$var$areSimilarTypedArrays(val1, val2)) return false;
         // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = $3b406a6c1a6d91fb$var$getOwnNonIndexProperties(val1, $3b406a6c1a6d91fb$var$ONLY_ENUMERABLE);
        var _keys2 = $3b406a6c1a6d91fb$var$getOwnNonIndexProperties(val2, $3b406a6c1a6d91fb$var$ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return $3b406a6c1a6d91fb$var$keyCheck(val1, val2, strict, memos, $3b406a6c1a6d91fb$var$kNoIterator, _keys);
    } else if ($3b406a6c1a6d91fb$var$isSet(val1)) {
        if (!$3b406a6c1a6d91fb$var$isSet(val2) || val1.size !== val2.size) return false;
        return $3b406a6c1a6d91fb$var$keyCheck(val1, val2, strict, memos, $3b406a6c1a6d91fb$var$kIsSet);
    } else if ($3b406a6c1a6d91fb$var$isMap(val1)) {
        if (!$3b406a6c1a6d91fb$var$isMap(val2) || val1.size !== val2.size) return false;
        return $3b406a6c1a6d91fb$var$keyCheck(val1, val2, strict, memos, $3b406a6c1a6d91fb$var$kIsMap);
    } else if ($3b406a6c1a6d91fb$var$isAnyArrayBuffer(val1)) {
        if (!$3b406a6c1a6d91fb$var$areEqualArrayBuffers(val1, val2)) return false;
    } else if ($3b406a6c1a6d91fb$var$isBoxedPrimitive(val1) && !$3b406a6c1a6d91fb$var$isEqualBoxedPrimitive(val1, val2)) return false;
    return $3b406a6c1a6d91fb$var$keyCheck(val1, val2, strict, memos, $3b406a6c1a6d91fb$var$kNoIterator);
}
function $3b406a6c1a6d91fb$var$getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return $3b406a6c1a6d91fb$var$propertyIsEnumerable(val, k);
    });
}
function $3b406a6c1a6d91fb$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2); // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    } // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!$3b406a6c1a6d91fb$var$hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = $3b406a6c1a6d91fb$var$objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if ($3b406a6c1a6d91fb$var$propertyIsEnumerable(val1, key)) {
                    if (!$3b406a6c1a6d91fb$var$propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if ($3b406a6c1a6d91fb$var$propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = $3b406a6c1a6d91fb$var$objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && $3b406a6c1a6d91fb$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = $3b406a6c1a6d91fb$var$objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && $3b406a6c1a6d91fb$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === $3b406a6c1a6d91fb$var$kNoIterator || iterationType === $3b406a6c1a6d91fb$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
     // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = $3b406a6c1a6d91fb$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function $3b406a6c1a6d91fb$var$setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = $3b406a6c1a6d91fb$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if ($3b406a6c1a6d91fb$var$innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
} // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function $3b406a6c1a6d91fb$var$findLooseMatchingPrimitives(prim) {
    switch($3b406a6c1a6d91fb$var$_typeof(prim)){
        case 'undefined':
            return null;
        case 'object':
            // Only pass in null as object!
            return undefined;
        case 'symbol':
            return false;
        case 'string':
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case 'number':
            if ($3b406a6c1a6d91fb$var$numberIsNaN(prim)) return false;
    }
    return true;
}
function $3b406a6c1a6d91fb$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $3b406a6c1a6d91fb$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function $3b406a6c1a6d91fb$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = $3b406a6c1a6d91fb$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !$3b406a6c1a6d91fb$var$innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && $3b406a6c1a6d91fb$var$innerDeepEqual(item, curB, false, memo);
}
function $3b406a6c1a6d91fb$var$setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = $3b406a6c1a6d91fb$var$arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i]; // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if ($3b406a6c1a6d91fb$var$_typeof(val) === 'object' && val !== null) {
            if (set === null) set = new Set();
             // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false; // Fast path to detect missing string, symbol, undefined and null values.
            if (!$3b406a6c1a6d91fb$var$setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = $3b406a6c1a6d91fb$var$arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i]; // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if ($3b406a6c1a6d91fb$var$_typeof(_val) === 'object' && _val !== null) {
                if (!$3b406a6c1a6d91fb$var$setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !$3b406a6c1a6d91fb$var$setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $3b406a6c1a6d91fb$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = $3b406a6c1a6d91fb$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if ($3b406a6c1a6d91fb$var$innerDeepEqual(key1, key2, strict, memo) && $3b406a6c1a6d91fb$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function $3b406a6c1a6d91fb$var$mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = $3b406a6c1a6d91fb$var$arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = $3b406a6c1a6d91fb$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if ($3b406a6c1a6d91fb$var$_typeof(key) === 'object' && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !$3b406a6c1a6d91fb$var$innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false; // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!$3b406a6c1a6d91fb$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = $3b406a6c1a6d91fb$var$arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = $3b406a6c1a6d91fb$var$_slicedToArray(bEntries[_i2], 2), key = _bEntries$_i[0], item = _bEntries$_i[1];
            if ($3b406a6c1a6d91fb$var$_typeof(key) === 'object' && key !== null) {
                if (!$3b406a6c1a6d91fb$var$mapHasEqualEntry(set, a, key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(key) || !$3b406a6c1a6d91fb$var$innerDeepEqual(a.get(key), item, false, memo)) && !$3b406a6c1a6d91fb$var$mapHasEqualEntry(set, a, key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $3b406a6c1a6d91fb$var$objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === $3b406a6c1a6d91fb$var$kIsSet) {
        if (!$3b406a6c1a6d91fb$var$setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $3b406a6c1a6d91fb$var$kIsMap) {
        if (!$3b406a6c1a6d91fb$var$mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $3b406a6c1a6d91fb$var$kIsArray) for(; i < a.length; i++){
        if ($3b406a6c1a6d91fb$var$hasOwnProperty(a, i)) {
            if (!$3b406a6c1a6d91fb$var$hasOwnProperty(b, i) || !$3b406a6c1a6d91fb$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if ($3b406a6c1a6d91fb$var$hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!$3b406a6c1a6d91fb$var$hasOwnProperty(b, key) || !$3b406a6c1a6d91fb$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
     // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key = keys[i];
        if (!$3b406a6c1a6d91fb$var$innerDeepEqual(a[_key], b[_key], strict, memos)) return false;
    }
    return true;
}
function $3b406a6c1a6d91fb$var$isDeepEqual(val1, val2) {
    return $3b406a6c1a6d91fb$var$innerDeepEqual(val1, val2, $3b406a6c1a6d91fb$var$kLoose);
}
function $3b406a6c1a6d91fb$var$isDeepStrictEqual(val1, val2) {
    return $3b406a6c1a6d91fb$var$innerDeepEqual(val1, val2, $3b406a6c1a6d91fb$var$kStrict);
}
module.exports = {
    isDeepEqual: $3b406a6c1a6d91fb$var$isDeepEqual,
    isDeepStrictEqual: $3b406a6c1a6d91fb$var$isDeepStrictEqual
};

});
parcelRegister("djuuL", function(module, exports) {
'use strict';

var $eitbu = parcelRequire("eitbu");

var $7DUGk = parcelRequire("7DUGk");

var $9NVyy = parcelRequire("9NVyy");

var $klO7B = parcelRequire("klO7B");

var $4dQLh = parcelRequire("4dQLh");
var $9b14b4694a770524$var$polyfill = $eitbu($klO7B(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ $7DUGk($9b14b4694a770524$var$polyfill, {
    getPolyfill: $klO7B,
    implementation: $9NVyy,
    shim: $4dQLh
});
module.exports = $9b14b4694a770524$var$polyfill;

});
parcelRegister("9NVyy", function(module, exports) {
'use strict';
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

});

parcelRegister("klO7B", function(module, exports) {
'use strict';

var $9NVyy = parcelRequire("9NVyy");
module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) return Number.isNaN;
    return $9NVyy;
};

});

parcelRegister("4dQLh", function(module, exports) {
'use strict';

var $7DUGk = parcelRequire("7DUGk");

var $klO7B = parcelRequire("klO7B");
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = $klO7B();
    $7DUGk(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

});




parcelRegister("aN41m", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SuppressWarnings = module.exports.Override = module.exports.Nullable = module.exports.NotNull = void 0;
function $7db19978462a2871$var$NotNull(target, propertyKey, propertyDescriptor) {
// intentionally empty
}
module.exports.NotNull = $7db19978462a2871$var$NotNull;
function $7db19978462a2871$var$Nullable(target, propertyKey, propertyDescriptor) {
// intentionally empty
}
module.exports.Nullable = $7db19978462a2871$var$Nullable;
function $7db19978462a2871$var$Override(target, propertyKey, propertyDescriptor) {
// do something with 'target' ...
}
module.exports.Override = $7db19978462a2871$var$Override;
function $7db19978462a2871$var$SuppressWarnings(options) {
    return (target, propertyKey, descriptor)=>{
    // intentionally empty
    };
}
module.exports.SuppressWarnings = $7db19978462a2871$var$SuppressWarnings;

});

parcelRegister("ldi9e", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntStream = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:51.6934376-07:00
var $f718e3b116f54f2a$var$IntStream;
(function(IntStream) {
    /**
     * The value returned by {@link #LA LA()} when the end of the stream is
     * reached.
     */ IntStream.EOF = -1;
    /**
     * The value returned by {@link #getSourceName} when the actual name of the
     * underlying source is not known.
     */ IntStream.UNKNOWN_SOURCE_NAME = "<unknown>";
})($f718e3b116f54f2a$var$IntStream = module.exports.IntStream || (module.exports.IntStream = {}));

});


parcelRegister("csTA1", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9133369c31e91133$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BailErrorStrategy = void 0;

var $3HZil = parcelRequire("3HZil");

var $5jZSY = parcelRequire("5jZSY");

var $aN41m = parcelRequire("aN41m");

var $hXb5J = parcelRequire("hXb5J");
/**
 * This implementation of {@link ANTLRErrorStrategy} responds to syntax errors
 * by immediately canceling the parse operation with a
 * {@link ParseCancellationException}. The implementation ensures that the
 * {@link ParserRuleContext#exception} field is set for all parse tree nodes
 * that were not completed prior to encountering the error.
 *
 * This error strategy is useful in the following scenarios.
 *
 * * **Two-stage parsing:** This error strategy allows the first
 *   stage of two-stage parsing to immediately terminate if an error is
 *   encountered, and immediately fall back to the second stage. In addition to
 *   avoiding wasted work by attempting to recover from errors here, the empty
 *   implementation of {@link BailErrorStrategy#sync} improves the performance of
 *   the first stage.
 * * **Silent validation:** When syntax errors are not being
 *   reported or logged, and the parse result is simply ignored if errors occur,
 *   the {@link BailErrorStrategy} avoids wasting work on recovering from errors
 *   when the result will be ignored either way.
 *
 * ```
 * myparser.errorHandler = new BailErrorStrategy();
 * ```
 *
 * @see Parser.errorHandler
 */ class $9133369c31e91133$var$BailErrorStrategy extends $3HZil.DefaultErrorStrategy {
    /** Instead of recovering from exception `e`, re-throw it wrapped
     *  in a {@link ParseCancellationException} so it is not caught by the
     *  rule function catches.  Use {@link Exception#getCause()} to get the
     *  original {@link RecognitionException}.
     */ recover(recognizer, e) {
        for(let context = recognizer.context; context; context = context.parent)context.exception = e;
        throw new $hXb5J.ParseCancellationException(e);
    }
    /** Make sure we don't attempt to recover inline; if the parser
     *  successfully recovers, it won't throw an exception.
     */ recoverInline(recognizer) {
        let e = new $5jZSY.InputMismatchException(recognizer);
        for(let context = recognizer.context; context; context = context.parent)context.exception = e;
        throw new $hXb5J.ParseCancellationException(e);
    }
    /** Make sure we don't attempt to recover from problems in subrules. */ sync(recognizer) {
    // intentionally empty
    }
}
$9133369c31e91133$var$__decorate([
    $aN41m.Override
], $9133369c31e91133$var$BailErrorStrategy.prototype, "recover", null);
$9133369c31e91133$var$__decorate([
    $aN41m.Override
], $9133369c31e91133$var$BailErrorStrategy.prototype, "recoverInline", null);
$9133369c31e91133$var$__decorate([
    $aN41m.Override
], $9133369c31e91133$var$BailErrorStrategy.prototype, "sync", null);
module.exports.BailErrorStrategy = $9133369c31e91133$var$BailErrorStrategy;

});
parcelRegister("3HZil", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $2b34ef24d781854a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $2b34ef24d781854a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultErrorStrategy = void 0;

var $dv9vN = parcelRequire("dv9vN");

var $fZESB = parcelRequire("fZESB");

var $2quiJ = parcelRequire("2quiJ");

var $5jZSY = parcelRequire("5jZSY");

var $6kdz0 = parcelRequire("6kdz0");

var $iAlWg = parcelRequire("iAlWg");

var $jaUCz = parcelRequire("jaUCz");

var $eKXi4 = parcelRequire("eKXi4");

var $aN41m = parcelRequire("aN41m");
/**
 * This is the default implementation of {@link ANTLRErrorStrategy} used for
 * error reporting and recovery in ANTLR parsers.
 */ class $2b34ef24d781854a$var$DefaultErrorStrategy {
    constructor(){
        /**
         * Indicates whether the error strategy is currently "recovering from an
         * error". This is used to suppress reporting multiple error messages while
         * attempting to recover from a detected syntax error.
         *
         * @see #inErrorRecoveryMode
         */ this.errorRecoveryMode = false;
        /** The index into the input stream where the last error occurred.
         * 	This is used to prevent infinite loops where an error is found
         *  but no token is consumed during recovery...another error is found,
         *  ad nauseum.  This is a failsafe mechanism to guarantee that at least
         *  one token/tree node is consumed for two errors.
         */ this.lastErrorIndex = -1;
        /**
         * @see #nextTokensContext
         */ this.nextTokensState = $dv9vN.ATNState.INVALID_STATE_NUMBER;
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation simply calls {@link #endErrorCondition} to
     * ensure that the handler is not in error recovery mode.
     */ reset(recognizer) {
        this.endErrorCondition(recognizer);
    }
    /**
     * This method is called to enter error recovery mode when a recognition
     * exception is reported.
     *
     * @param recognizer the parser instance
     */ beginErrorCondition(recognizer) {
        this.errorRecoveryMode = true;
    }
    /**
     * {@inheritDoc}
     */ inErrorRecoveryMode(recognizer) {
        return this.errorRecoveryMode;
    }
    /**
     * This method is called to leave error recovery mode after recovering from
     * a recognition exception.
     *
     * @param recognizer
     */ endErrorCondition(recognizer) {
        this.errorRecoveryMode = false;
        this.lastErrorStates = undefined;
        this.lastErrorIndex = -1;
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation simply calls {@link #endErrorCondition}.
     */ reportMatch(recognizer) {
        this.endErrorCondition(recognizer);
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation returns immediately if the handler is already
     * in error recovery mode. Otherwise, it calls {@link #beginErrorCondition}
     * and dispatches the reporting task based on the runtime type of `e`
     * according to the following table.
     *
     * * {@link NoViableAltException}: Dispatches the call to
     *   {@link #reportNoViableAlternative}
     * * {@link InputMismatchException}: Dispatches the call to
     *   {@link #reportInputMismatch}
     * * {@link FailedPredicateException}: Dispatches the call to
     *   {@link #reportFailedPredicate}
     * * All other types: calls {@link Parser#notifyErrorListeners} to report
     *   the exception
     */ reportError(recognizer, e) {
        // if we've already reported an error and have not matched a token
        // yet successfully, don't report any errors.
        if (this.inErrorRecoveryMode(recognizer)) //			System.err.print("[SPURIOUS] ");
        return; // don't report spurious errors
        this.beginErrorCondition(recognizer);
        if (e instanceof $iAlWg.NoViableAltException) this.reportNoViableAlternative(recognizer, e);
        else if (e instanceof $5jZSY.InputMismatchException) this.reportInputMismatch(recognizer, e);
        else if (e instanceof $2quiJ.FailedPredicateException) this.reportFailedPredicate(recognizer, e);
        else {
            console.error(`unknown recognition error type: ${e}`);
            this.notifyErrorListeners(recognizer, e.toString(), e);
        }
    }
    notifyErrorListeners(recognizer, message, e) {
        let offendingToken = e.getOffendingToken(recognizer);
        if (offendingToken === undefined) // Pass null to notifyErrorListeners so it in turn calls the error listeners with undefined as the offending
        // token. If we passed undefined, it would instead call the listeners with currentToken from the parser.
        offendingToken = null;
        recognizer.notifyErrorListeners(message, offendingToken, e);
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation resynchronizes the parser by consuming tokens
     * until we find one in the resynchronization set--loosely the set of tokens
     * that can follow the current rule.
     */ recover(recognizer, e) {
        //		System.out.println("recover in "+recognizer.getRuleInvocationStack()+
        //						   " index="+recognizer.inputStream.index+
        //						   ", lastErrorIndex="+
        //						   lastErrorIndex+
        //						   ", states="+lastErrorStates);
        if (this.lastErrorIndex === recognizer.inputStream.index && this.lastErrorStates && this.lastErrorStates.contains(recognizer.state)) // uh oh, another error at same token index and previously-visited
        // state in ATN; must be a case where LT(1) is in the recovery
        // token set so nothing got consumed. Consume a single token
        // at least to prevent an infinite loop; this is a failsafe.
        //			System.err.println("seen error condition before index="+
        //							   lastErrorIndex+", states="+lastErrorStates);
        //			System.err.println("FAILSAFE consumes "+recognizer.getTokenNames()[recognizer.inputStream.LA(1)]);
        recognizer.consume();
        this.lastErrorIndex = recognizer.inputStream.index;
        if (!this.lastErrorStates) this.lastErrorStates = new $6kdz0.IntervalSet();
        this.lastErrorStates.add(recognizer.state);
        let followSet = this.getErrorRecoverySet(recognizer);
        this.consumeUntil(recognizer, followSet);
    }
    /**
     * The default implementation of {@link ANTLRErrorStrategy#sync} makes sure
     * that the current lookahead symbol is consistent with what were expecting
     * at this point in the ATN. You can call this anytime but ANTLR only
     * generates code to check before subrules/loops and each iteration.
     *
     * Implements Jim Idle's magic sync mechanism in closures and optional
     * subrules. E.g.,
     *
     * ```antlr
     * a : sync ( stuff sync )* ;
     * sync : {consume to what can follow sync} ;
     * ```
     *
     * At the start of a sub rule upon error, {@link #sync} performs single
     * token deletion, if possible. If it can't do that, it bails on the current
     * rule and uses the default error recovery, which consumes until the
     * resynchronization set of the current rule.
     *
     * If the sub rule is optional (`(...)?`, `(...)*`, or block
     * with an empty alternative), then the expected set includes what follows
     * the subrule.
     *
     * During loop iteration, it consumes until it sees a token that can start a
     * sub rule or what follows loop. Yes, that is pretty aggressive. We opt to
     * stay in the loop as long as possible.
     *
     * **ORIGINS**
     *
     * Previous versions of ANTLR did a poor job of their recovery within loops.
     * A single mismatch token or missing token would force the parser to bail
     * out of the entire rules surrounding the loop. So, for rule
     *
     * ```antlr
     * classDef : 'class' ID '{' member* '}'
     * ```
     *
     * input with an extra token between members would force the parser to
     * consume until it found the next class definition rather than the next
     * member definition of the current class.
     *
     * This functionality cost a little bit of effort because the parser has to
     * compare token set at the start of the loop and at each iteration. If for
     * some reason speed is suffering for you, you can turn off this
     * functionality by simply overriding this method as a blank { }.
     */ sync(recognizer) {
        let s = recognizer.interpreter.atn.states[recognizer.state];
        //		System.err.println("sync @ "+s.stateNumber+"="+s.getClass().getSimpleName());
        // If already recovering, don't try to sync
        if (this.inErrorRecoveryMode(recognizer)) return;
        let tokens = recognizer.inputStream;
        let la = tokens.LA(1);
        // try cheaper subset first; might get lucky. seems to shave a wee bit off
        let nextTokens = recognizer.atn.nextTokens(s);
        if (nextTokens.contains(la)) {
            // We are sure the token matches
            this.nextTokensContext = undefined;
            this.nextTokensState = $dv9vN.ATNState.INVALID_STATE_NUMBER;
            return;
        }
        if (nextTokens.contains($eKXi4.Token.EPSILON)) {
            if (this.nextTokensContext === undefined) {
                // It's possible the next token won't match; information tracked
                // by sync is restricted for performance.
                this.nextTokensContext = recognizer.context;
                this.nextTokensState = recognizer.state;
            }
            return;
        }
        switch(s.stateType){
            case $fZESB.ATNStateType.BLOCK_START:
            case $fZESB.ATNStateType.STAR_BLOCK_START:
            case $fZESB.ATNStateType.PLUS_BLOCK_START:
            case $fZESB.ATNStateType.STAR_LOOP_ENTRY:
                // report error and recover if possible
                if (this.singleTokenDeletion(recognizer)) return;
                throw new $5jZSY.InputMismatchException(recognizer);
            case $fZESB.ATNStateType.PLUS_LOOP_BACK:
            case $fZESB.ATNStateType.STAR_LOOP_BACK:
                //			System.err.println("at loop back: "+s.getClass().getSimpleName());
                this.reportUnwantedToken(recognizer);
                let expecting = recognizer.getExpectedTokens();
                let whatFollowsLoopIterationOrRule = expecting.or(this.getErrorRecoverySet(recognizer));
                this.consumeUntil(recognizer, whatFollowsLoopIterationOrRule);
                break;
            default:
                break;
        }
    }
    /**
     * This is called by {@link #reportError} when the exception is a
     * {@link NoViableAltException}.
     *
     * @see #reportError
     *
     * @param recognizer the parser instance
     * @param e the recognition exception
     */ reportNoViableAlternative(recognizer, e) {
        let tokens = recognizer.inputStream;
        let input;
        if (tokens) {
            if (e.startToken.type === $eKXi4.Token.EOF) input = "<EOF>";
            else input = tokens.getTextFromRange(e.startToken, e.getOffendingToken());
        } else input = "<unknown input>";
        let msg = "no viable alternative at input " + this.escapeWSAndQuote(input);
        this.notifyErrorListeners(recognizer, msg, e);
    }
    /**
     * This is called by {@link #reportError} when the exception is an
     * {@link InputMismatchException}.
     *
     * @see #reportError
     *
     * @param recognizer the parser instance
     * @param e the recognition exception
     */ reportInputMismatch(recognizer, e) {
        let expected = e.expectedTokens;
        let expectedString = expected ? expected.toStringVocabulary(recognizer.vocabulary) : "";
        let msg = "mismatched input " + this.getTokenErrorDisplay(e.getOffendingToken(recognizer)) + " expecting " + expectedString;
        this.notifyErrorListeners(recognizer, msg, e);
    }
    /**
     * This is called by {@link #reportError} when the exception is a
     * {@link FailedPredicateException}.
     *
     * @see #reportError
     *
     * @param recognizer the parser instance
     * @param e the recognition exception
     */ reportFailedPredicate(recognizer, e) {
        let ruleName = recognizer.ruleNames[recognizer.context.ruleIndex];
        let msg = "rule " + ruleName + " " + e.message;
        this.notifyErrorListeners(recognizer, msg, e);
    }
    /**
     * This method is called to report a syntax error which requires the removal
     * of a token from the input stream. At the time this method is called, the
     * erroneous symbol is current `LT(1)` symbol and has not yet been
     * removed from the input stream. When this method returns,
     * `recognizer` is in error recovery mode.
     *
     * This method is called when {@link #singleTokenDeletion} identifies
     * single-token deletion as a viable recovery strategy for a mismatched
     * input error.
     *
     * The default implementation simply returns if the handler is already in
     * error recovery mode. Otherwise, it calls {@link #beginErrorCondition} to
     * enter error recovery mode, followed by calling
     * {@link Parser#notifyErrorListeners}.
     *
     * @param recognizer the parser instance
     */ reportUnwantedToken(recognizer) {
        if (this.inErrorRecoveryMode(recognizer)) return;
        this.beginErrorCondition(recognizer);
        let t = recognizer.currentToken;
        let tokenName = this.getTokenErrorDisplay(t);
        let expecting = this.getExpectedTokens(recognizer);
        let msg = "extraneous input " + tokenName + " expecting " + expecting.toStringVocabulary(recognizer.vocabulary);
        recognizer.notifyErrorListeners(msg, t, undefined);
    }
    /**
     * This method is called to report a syntax error which requires the
     * insertion of a missing token into the input stream. At the time this
     * method is called, the missing token has not yet been inserted. When this
     * method returns, `recognizer` is in error recovery mode.
     *
     * This method is called when {@link #singleTokenInsertion} identifies
     * single-token insertion as a viable recovery strategy for a mismatched
     * input error.
     *
     * The default implementation simply returns if the handler is already in
     * error recovery mode. Otherwise, it calls {@link #beginErrorCondition} to
     * enter error recovery mode, followed by calling
     * {@link Parser#notifyErrorListeners}.
     *
     * @param recognizer the parser instance
     */ reportMissingToken(recognizer) {
        if (this.inErrorRecoveryMode(recognizer)) return;
        this.beginErrorCondition(recognizer);
        let t = recognizer.currentToken;
        let expecting = this.getExpectedTokens(recognizer);
        let msg = "missing " + expecting.toStringVocabulary(recognizer.vocabulary) + " at " + this.getTokenErrorDisplay(t);
        recognizer.notifyErrorListeners(msg, t, undefined);
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation attempts to recover from the mismatched input
     * by using single token insertion and deletion as described below. If the
     * recovery attempt fails, this method
     * {@link InputMismatchException}.
     *
     * **EXTRA TOKEN** (single token deletion)
     *
     * `LA(1)` is not what we are looking for. If `LA(2)` has the
     * right token, however, then assume `LA(1)` is some extra spurious
     * token and delete it. Then consume and return the next token (which was
     * the `LA(2)` token) as the successful result of the match operation.
     *
     * This recovery strategy is implemented by {@link #singleTokenDeletion}.
     *
     * **MISSING TOKEN** (single token insertion)
     *
     * If current token (at `LA(1)`) is consistent with what could come
     * after the expected `LA(1)` token, then assume the token is missing
     * and use the parser's {@link TokenFactory} to create it on the fly. The
     * "insertion" is performed by returning the created token as the successful
     * result of the match operation.
     *
     * This recovery strategy is implemented by {@link #singleTokenInsertion}.
     *
     * **EXAMPLE**
     *
     * For example, Input `i=(3;` is clearly missing the `')'`. When
     * the parser returns from the nested call to `expr`, it will have
     * call chain:
     *
     * ```
     * stat → expr → atom
     * ```
     *
     * and it will be trying to match the `')'` at this point in the
     * derivation:
     *
     * ```
     * => ID '=' '(' INT ')' ('+' atom)* ';'
     *                    ^
     * ```
     *
     * The attempt to match `')'` will fail when it sees `';'` and
     * call {@link #recoverInline}. To recover, it sees that `LA(1)==';'`
     * is in the set of tokens that can follow the `')'` token reference
     * in rule `atom`. It can assume that you forgot the `')'`.
     */ recoverInline(recognizer) {
        // SINGLE TOKEN DELETION
        let matchedSymbol = this.singleTokenDeletion(recognizer);
        if (matchedSymbol) {
            // we have deleted the extra token.
            // now, move past ttype token as if all were ok
            recognizer.consume();
            return matchedSymbol;
        }
        // SINGLE TOKEN INSERTION
        if (this.singleTokenInsertion(recognizer)) return this.getMissingSymbol(recognizer);
        // even that didn't work; must throw the exception
        if (this.nextTokensContext === undefined) throw new $5jZSY.InputMismatchException(recognizer);
        else throw new $5jZSY.InputMismatchException(recognizer, this.nextTokensState, this.nextTokensContext);
    }
    /**
     * This method implements the single-token insertion inline error recovery
     * strategy. It is called by {@link #recoverInline} if the single-token
     * deletion strategy fails to recover from the mismatched input. If this
     * method returns `true`, `recognizer` will be in error recovery
     * mode.
     *
     * This method determines whether or not single-token insertion is viable by
     * checking if the `LA(1)` input symbol could be successfully matched
     * if it were instead the `LA(2)` symbol. If this method returns
     * `true`, the caller is responsible for creating and inserting a
     * token with the correct type to produce this behavior.
     *
     * @param recognizer the parser instance
     * @returns `true` if single-token insertion is a viable recovery
     * strategy for the current mismatched input, otherwise `false`
     */ singleTokenInsertion(recognizer) {
        let currentSymbolType = recognizer.inputStream.LA(1);
        // if current token is consistent with what could come after current
        // ATN state, then we know we're missing a token; error recovery
        // is free to conjure up and insert the missing token
        let currentState = recognizer.interpreter.atn.states[recognizer.state];
        let next = currentState.transition(0).target;
        let atn = recognizer.interpreter.atn;
        let expectingAtLL2 = atn.nextTokens(next, $jaUCz.PredictionContext.fromRuleContext(atn, recognizer.context));
        //		console.warn("LT(2) set="+expectingAtLL2.toString(recognizer.getTokenNames()));
        if (expectingAtLL2.contains(currentSymbolType)) {
            this.reportMissingToken(recognizer);
            return true;
        }
        return false;
    }
    /**
     * This method implements the single-token deletion inline error recovery
     * strategy. It is called by {@link #recoverInline} to attempt to recover
     * from mismatched input. If this method returns `undefined`, the parser and error
     * handler state will not have changed. If this method returns non-`undefined`,
     * `recognizer` will *not* be in error recovery mode since the
     * returned token was a successful match.
     *
     * If the single-token deletion is successful, this method calls
     * {@link #reportUnwantedToken} to report the error, followed by
     * {@link Parser#consume} to actually "delete" the extraneous token. Then,
     * before returning {@link #reportMatch} is called to signal a successful
     * match.
     *
     * @param recognizer the parser instance
     * @returns the successfully matched {@link Token} instance if single-token
     * deletion successfully recovers from the mismatched input, otherwise
     * `undefined`
     */ singleTokenDeletion(recognizer) {
        let nextTokenType = recognizer.inputStream.LA(2);
        let expecting = this.getExpectedTokens(recognizer);
        if (expecting.contains(nextTokenType)) {
            this.reportUnwantedToken(recognizer);
            /*
            System.err.println("recoverFromMismatchedToken deleting "+
                               ((TokenStream)recognizer.inputStream).LT(1)+
                               " since "+((TokenStream)recognizer.inputStream).LT(2)+
                               " is what we want");
            */ recognizer.consume(); // simply delete extra token
            // we want to return the token we're actually matching
            let matchedSymbol = recognizer.currentToken;
            this.reportMatch(recognizer); // we know current token is correct
            return matchedSymbol;
        }
        return undefined;
    }
    /** Conjure up a missing token during error recovery.
     *
     *  The recognizer attempts to recover from single missing
     *  symbols. But, actions might refer to that missing symbol.
     *  For example, x=ID {f($x);}. The action clearly assumes
     *  that there has been an identifier matched previously and that
     *  $x points at that token. If that token is missing, but
     *  the next token in the stream is what we want we assume that
     *  this token is missing and we keep going. Because we
     *  have to return some token to replace the missing token,
     *  we have to conjure one up. This method gives the user control
     *  over the tokens returned for missing tokens. Mostly,
     *  you will want to create something special for identifier
     *  tokens. For literals such as '{' and ',', the default
     *  action in the parser or tree parser works. It simply creates
     *  a CommonToken of the appropriate type. The text will be the token.
     *  If you change what tokens must be created by the lexer,
     *  override this method to create the appropriate tokens.
     */ getMissingSymbol(recognizer) {
        let currentSymbol = recognizer.currentToken;
        let expecting = this.getExpectedTokens(recognizer);
        let expectedTokenType = $eKXi4.Token.INVALID_TYPE;
        if (!expecting.isNil) // get any element
        expectedTokenType = expecting.minElement;
        let tokenText;
        if (expectedTokenType === $eKXi4.Token.EOF) tokenText = "<missing EOF>";
        else tokenText = "<missing " + recognizer.vocabulary.getDisplayName(expectedTokenType) + ">";
        let current = currentSymbol;
        let lookback = recognizer.inputStream.tryLT(-1);
        if (current.type === $eKXi4.Token.EOF && lookback != null) current = lookback;
        return this.constructToken(recognizer.inputStream.tokenSource, expectedTokenType, tokenText, current);
    }
    constructToken(tokenSource, expectedTokenType, tokenText, current) {
        let factory = tokenSource.tokenFactory;
        let x = current.tokenSource;
        let stream = x ? x.inputStream : undefined;
        return factory.create({
            source: tokenSource,
            stream: stream
        }, expectedTokenType, tokenText, $eKXi4.Token.DEFAULT_CHANNEL, -1, -1, current.line, current.charPositionInLine);
    }
    getExpectedTokens(recognizer) {
        return recognizer.getExpectedTokens();
    }
    /** How should a token be displayed in an error message? The default
     *  is to display just the text, but during development you might
     *  want to have a lot of information spit out.  Override in that case
     *  to use t.toString() (which, for CommonToken, dumps everything about
     *  the token). This is better than forcing you to override a method in
     *  your token objects because you don't have to go modify your lexer
     *  so that it creates a new Java type.
     */ getTokenErrorDisplay(t) {
        if (!t) return "<no token>";
        let s = this.getSymbolText(t);
        if (!s) {
            if (this.getSymbolType(t) === $eKXi4.Token.EOF) s = "<EOF>";
            else s = `<${this.getSymbolType(t)}>`;
        }
        return this.escapeWSAndQuote(s);
    }
    getSymbolText(symbol) {
        return symbol.text;
    }
    getSymbolType(symbol) {
        return symbol.type;
    }
    escapeWSAndQuote(s) {
        //		if ( s==null ) return s;
        s = s.replace("\n", "\\n");
        s = s.replace("\r", "\\r");
        s = s.replace("\t", "\\t");
        return "'" + s + "'";
    }
    /*  Compute the error recovery set for the current rule.  During
     *  rule invocation, the parser pushes the set of tokens that can
     *  follow that rule reference on the stack; this amounts to
     *  computing FIRST of what follows the rule reference in the
     *  enclosing rule. See LinearApproximator.FIRST().
     *  This local follow set only includes tokens
     *  from within the rule; i.e., the FIRST computation done by
     *  ANTLR stops at the end of a rule.
     *
     *  EXAMPLE
     *
     *  When you find a "no viable alt exception", the input is not
     *  consistent with any of the alternatives for rule r.  The best
     *  thing to do is to consume tokens until you see something that
     *  can legally follow a call to r *or* any rule that called r.
     *  You don't want the exact set of viable next tokens because the
     *  input might just be missing a token--you might consume the
     *  rest of the input looking for one of the missing tokens.
     *
     *  Consider grammar:
     *
     *  a : '[' b ']'
     *    | '(' b ')'
     *    ;
     *  b : c '^' INT ;
     *  c : ID
     *    | INT
     *    ;
     *
     *  At each rule invocation, the set of tokens that could follow
     *  that rule is pushed on a stack.  Here are the various
     *  context-sensitive follow sets:
     *
     *  FOLLOW(b1_in_a) = FIRST(']') = ']'
     *  FOLLOW(b2_in_a) = FIRST(')') = ')'
     *  FOLLOW(c_in_b) = FIRST('^') = '^'
     *
     *  Upon erroneous input "[]", the call chain is
     *
     *  a -> b -> c
     *
     *  and, hence, the follow context stack is:
     *
     *  depth     follow set       start of rule execution
     *    0         <EOF>                    a (from main())
     *    1          ']'                     b
     *    2          '^'                     c
     *
     *  Notice that ')' is not included, because b would have to have
     *  been called from a different context in rule a for ')' to be
     *  included.
     *
     *  For error recovery, we cannot consider FOLLOW(c)
     *  (context-sensitive or otherwise).  We need the combined set of
     *  all context-sensitive FOLLOW sets--the set of all tokens that
     *  could follow any reference in the call chain.  We need to
     *  resync to one of those tokens.  Note that FOLLOW(c)='^' and if
     *  we resync'd to that token, we'd consume until EOF.  We need to
     *  sync to context-sensitive FOLLOWs for a, b, and c: {']','^'}.
     *  In this case, for input "[]", LA(1) is ']' and in the set, so we would
     *  not consume anything. After printing an error, rule c would
     *  return normally.  Rule b would not find the required '^' though.
     *  At this point, it gets a mismatched token error and
     *  exception (since LA(1) is not in the viable following token
     *  set).  The rule exception handler tries to recover, but finds
     *  the same recovery set and doesn't consume anything.  Rule b
     *  exits normally returning to rule a.  Now it finds the ']' (and
     *  with the successful match exits errorRecovery mode).
     *
     *  So, you can see that the parser walks up the call chain looking
     *  for the token that was a member of the recovery set.
     *
     *  Errors are not generated in errorRecovery mode.
     *
     *  ANTLR's error recovery mechanism is based upon original ideas:
     *
     *  "Algorithms + Data Structures = Programs" by Niklaus Wirth
     *
     *  and
     *
     *  "A note on error recovery in recursive descent parsers":
     *  http://portal.acm.org/citation.cfm?id=947902.947905
     *
     *  Later, Josef Grosch had some good ideas:
     *
     *  "Efficient and Comfortable Error Recovery in Recursive Descent
     *  Parsers":
     *  ftp://www.cocolab.com/products/cocktail/doca4.ps/ell.ps.zip
     *
     *  Like Grosch I implement context-sensitive FOLLOW sets that are combined
     *  at run-time upon error to avoid overhead during parsing.
     */ getErrorRecoverySet(recognizer) {
        let atn = recognizer.interpreter.atn;
        let ctx = recognizer.context;
        let recoverSet = new $6kdz0.IntervalSet();
        while(ctx && ctx.invokingState >= 0){
            // compute what follows who invoked us
            let invokingState = atn.states[ctx.invokingState];
            let rt = invokingState.transition(0);
            let follow = atn.nextTokens(rt.followState);
            recoverSet.addAll(follow);
            ctx = ctx._parent;
        }
        recoverSet.remove($eKXi4.Token.EPSILON);
        //		System.out.println("recover set "+recoverSet.toString(recognizer.getTokenNames()));
        return recoverSet;
    }
    /** Consume tokens until one matches the given token set. */ consumeUntil(recognizer, set) {
        //		System.err.println("consumeUntil("+set.toString(recognizer.getTokenNames())+")");
        let ttype = recognizer.inputStream.LA(1);
        while(ttype !== $eKXi4.Token.EOF && !set.contains(ttype)){
            //System.out.println("consume during recover LA(1)="+getTokenNames()[input.LA(1)]);
            //			recognizer.inputStream.consume();
            recognizer.consume();
            ttype = recognizer.inputStream.LA(1);
        }
    }
}
$2b34ef24d781854a$var$__decorate([
    $aN41m.Override
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "reset", null);
$2b34ef24d781854a$var$__decorate([
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "beginErrorCondition", null);
$2b34ef24d781854a$var$__decorate([
    $aN41m.Override
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "inErrorRecoveryMode", null);
$2b34ef24d781854a$var$__decorate([
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "endErrorCondition", null);
$2b34ef24d781854a$var$__decorate([
    $aN41m.Override
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "reportMatch", null);
$2b34ef24d781854a$var$__decorate([
    $aN41m.Override
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "reportError", null);
$2b34ef24d781854a$var$__decorate([
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "notifyErrorListeners", null);
$2b34ef24d781854a$var$__decorate([
    $aN41m.Override
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "recover", null);
$2b34ef24d781854a$var$__decorate([
    $aN41m.Override
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "sync", null);
$2b34ef24d781854a$var$__decorate([
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull),
    $2b34ef24d781854a$var$__param(1, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "reportNoViableAlternative", null);
$2b34ef24d781854a$var$__decorate([
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull),
    $2b34ef24d781854a$var$__param(1, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "reportInputMismatch", null);
$2b34ef24d781854a$var$__decorate([
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull),
    $2b34ef24d781854a$var$__param(1, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "reportFailedPredicate", null);
$2b34ef24d781854a$var$__decorate([
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "reportUnwantedToken", null);
$2b34ef24d781854a$var$__decorate([
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "reportMissingToken", null);
$2b34ef24d781854a$var$__decorate([
    $aN41m.Override
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "recoverInline", null);
$2b34ef24d781854a$var$__decorate([
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "singleTokenInsertion", null);
$2b34ef24d781854a$var$__decorate([
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "singleTokenDeletion", null);
$2b34ef24d781854a$var$__decorate([
    $aN41m.NotNull,
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "getMissingSymbol", null);
$2b34ef24d781854a$var$__decorate([
    $aN41m.NotNull,
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "getExpectedTokens", null);
$2b34ef24d781854a$var$__decorate([
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "getSymbolText", null);
$2b34ef24d781854a$var$__decorate([
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "getSymbolType", null);
$2b34ef24d781854a$var$__decorate([
    $aN41m.NotNull,
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "escapeWSAndQuote", null);
$2b34ef24d781854a$var$__decorate([
    $aN41m.NotNull,
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "getErrorRecoverySet", null);
$2b34ef24d781854a$var$__decorate([
    $2b34ef24d781854a$var$__param(0, $aN41m.NotNull),
    $2b34ef24d781854a$var$__param(1, $aN41m.NotNull)
], $2b34ef24d781854a$var$DefaultErrorStrategy.prototype, "consumeUntil", null);
module.exports.DefaultErrorStrategy = $2b34ef24d781854a$var$DefaultErrorStrategy;

});
parcelRegister("dv9vN", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9d458c7a5aa2e8f5$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNState = void 0;

var $aN41m = parcelRequire("aN41m");
const $9d458c7a5aa2e8f5$var$INITIAL_NUM_TRANSITIONS = 4;
/**
 * The following images show the relation of states and
 * {@link ATNState#transitions} for various grammar constructs.
 *
 * * Solid edges marked with an &#0949; indicate a required
 *   {@link EpsilonTransition}.
 *
 * * Dashed edges indicate locations where any transition derived from
 *   {@link Transition} might appear.
 *
 * * Dashed nodes are place holders for either a sequence of linked
 *   {@link BasicState} states or the inclusion of a block representing a nested
 *   construct in one of the forms below.
 *
 * * Nodes showing multiple outgoing alternatives with a `...` support
 *   any number of alternatives (one or more). Nodes without the `...` only
 *   support the exact number of alternatives shown in the diagram.
 *
 * <h2>Basic Blocks</h2>
 *
 * <h3>Rule</h3>
 *
 * <embed src="images/Rule.svg" type="image/svg+xml"/>
 *
 * <h3>Block of 1 or more alternatives</h3>
 *
 * <embed src="images/Block.svg" type="image/svg+xml"/>
 *
 * <h2>Greedy Loops</h2>
 *
 * <h3>Greedy Closure: `(...)*`</h3>
 *
 * <embed src="images/ClosureGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Greedy Positive Closure: `(...)+`</h3>
 *
 * <embed src="images/PositiveClosureGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Greedy Optional: `(...)?`</h3>
 *
 * <embed src="images/OptionalGreedy.svg" type="image/svg+xml"/>
 *
 * <h2>Non-Greedy Loops</h2>
 *
 * <h3>Non-Greedy Closure: `(...)*?`</h3>
 *
 * <embed src="images/ClosureNonGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Non-Greedy Positive Closure: `(...)+?`</h3>
 *
 * <embed src="images/PositiveClosureNonGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Non-Greedy Optional: `(...)??`</h3>
 *
 * <embed src="images/OptionalNonGreedy.svg" type="image/svg+xml"/>
 */ class $9d458c7a5aa2e8f5$var$ATNState {
    constructor(){
        this.stateNumber = $9d458c7a5aa2e8f5$var$ATNState.INVALID_STATE_NUMBER;
        this.ruleIndex = 0; // at runtime, we don't have Rule objects
        this.epsilonOnlyTransitions = false;
        /** Track the transitions emanating from this ATN state. */ this.transitions = [];
        this.optimizedTransitions = this.transitions;
    }
    /**
     * Gets the state number.
     *
     * @returns the state number
     */ getStateNumber() {
        return this.stateNumber;
    }
    /**
     * For all states except {@link RuleStopState}, this returns the state
     * number. Returns -1 for stop states.
     *
     * @returns -1 for {@link RuleStopState}, otherwise the state number
     */ get nonStopStateNumber() {
        return this.getStateNumber();
    }
    hashCode() {
        return this.stateNumber;
    }
    equals(o) {
        // are these states same object?
        if (o instanceof $9d458c7a5aa2e8f5$var$ATNState) return this.stateNumber === o.stateNumber;
        return false;
    }
    get isNonGreedyExitState() {
        return false;
    }
    toString() {
        return String(this.stateNumber);
    }
    getTransitions() {
        return this.transitions.slice(0);
    }
    get numberOfTransitions() {
        return this.transitions.length;
    }
    addTransition(e, index) {
        if (this.transitions.length === 0) this.epsilonOnlyTransitions = e.isEpsilon;
        else if (this.epsilonOnlyTransitions !== e.isEpsilon) {
            this.epsilonOnlyTransitions = false;
            throw new Error("ATN state " + this.stateNumber + " has both epsilon and non-epsilon transitions.");
        }
        this.transitions.splice(index !== undefined ? index : this.transitions.length, 0, e);
    }
    transition(i) {
        return this.transitions[i];
    }
    setTransition(i, e) {
        this.transitions[i] = e;
    }
    removeTransition(index) {
        return this.transitions.splice(index, 1)[0];
    }
    get onlyHasEpsilonTransitions() {
        return this.epsilonOnlyTransitions;
    }
    setRuleIndex(ruleIndex) {
        this.ruleIndex = ruleIndex;
    }
    get isOptimized() {
        return this.optimizedTransitions !== this.transitions;
    }
    get numberOfOptimizedTransitions() {
        return this.optimizedTransitions.length;
    }
    getOptimizedTransition(i) {
        return this.optimizedTransitions[i];
    }
    addOptimizedTransition(e) {
        if (!this.isOptimized) this.optimizedTransitions = new Array();
        this.optimizedTransitions.push(e);
    }
    setOptimizedTransition(i, e) {
        if (!this.isOptimized) throw new Error("This ATNState is not optimized.");
        this.optimizedTransitions[i] = e;
    }
    removeOptimizedTransition(i) {
        if (!this.isOptimized) throw new Error("This ATNState is not optimized.");
        this.optimizedTransitions.splice(i, 1);
    }
}
$9d458c7a5aa2e8f5$var$__decorate([
    $aN41m.Override
], $9d458c7a5aa2e8f5$var$ATNState.prototype, "hashCode", null);
$9d458c7a5aa2e8f5$var$__decorate([
    $aN41m.Override
], $9d458c7a5aa2e8f5$var$ATNState.prototype, "equals", null);
$9d458c7a5aa2e8f5$var$__decorate([
    $aN41m.Override
], $9d458c7a5aa2e8f5$var$ATNState.prototype, "toString", null);
module.exports.ATNState = $9d458c7a5aa2e8f5$var$ATNState;
(function(ATNState) {
    ATNState.INVALID_STATE_NUMBER = -1;
})($9d458c7a5aa2e8f5$var$ATNState = module.exports.ATNState || (module.exports.ATNState = {}));

});

parcelRegister("fZESB", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNStateType = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:27.4734328-07:00
var $ba4c43613bc5a0e0$var$ATNStateType;
(function(ATNStateType) {
    ATNStateType[ATNStateType["INVALID_TYPE"] = 0] = "INVALID_TYPE";
    ATNStateType[ATNStateType["BASIC"] = 1] = "BASIC";
    ATNStateType[ATNStateType["RULE_START"] = 2] = "RULE_START";
    ATNStateType[ATNStateType["BLOCK_START"] = 3] = "BLOCK_START";
    ATNStateType[ATNStateType["PLUS_BLOCK_START"] = 4] = "PLUS_BLOCK_START";
    ATNStateType[ATNStateType["STAR_BLOCK_START"] = 5] = "STAR_BLOCK_START";
    ATNStateType[ATNStateType["TOKEN_START"] = 6] = "TOKEN_START";
    ATNStateType[ATNStateType["RULE_STOP"] = 7] = "RULE_STOP";
    ATNStateType[ATNStateType["BLOCK_END"] = 8] = "BLOCK_END";
    ATNStateType[ATNStateType["STAR_LOOP_BACK"] = 9] = "STAR_LOOP_BACK";
    ATNStateType[ATNStateType["STAR_LOOP_ENTRY"] = 10] = "STAR_LOOP_ENTRY";
    ATNStateType[ATNStateType["PLUS_LOOP_BACK"] = 11] = "PLUS_LOOP_BACK";
    ATNStateType[ATNStateType["LOOP_END"] = 12] = "LOOP_END";
})($ba4c43613bc5a0e0$var$ATNStateType = module.exports.ATNStateType || (module.exports.ATNStateType = {}));

});

parcelRegister("2quiJ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $1c4583a876daf8fc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $1c4583a876daf8fc$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FailedPredicateException = void 0;

var $b7PPe = parcelRequire("b7PPe");

var $aN41m = parcelRequire("aN41m");

var $j3Sey = parcelRequire("j3Sey");
/** A semantic predicate failed during validation.  Validation of predicates
 *  occurs when normally parsing the alternative just like matching a token.
 *  Disambiguating predicate evaluation occurs when we test a predicate during
 *  prediction.
 */ let $1c4583a876daf8fc$var$FailedPredicateException = class FailedPredicateException extends $b7PPe.RecognitionException {
    constructor(recognizer, predicate, message){
        super(recognizer, recognizer.inputStream, recognizer.context, FailedPredicateException.formatMessage(predicate, message));
        let s = recognizer.interpreter.atn.states[recognizer.state];
        let trans = s.transition(0);
        if (trans instanceof $j3Sey.PredicateTransition) {
            this._ruleIndex = trans.ruleIndex;
            this._predicateIndex = trans.predIndex;
        } else {
            this._ruleIndex = 0;
            this._predicateIndex = 0;
        }
        this._predicate = predicate;
        super.setOffendingToken(recognizer, recognizer.currentToken);
    }
    get ruleIndex() {
        return this._ruleIndex;
    }
    get predicateIndex() {
        return this._predicateIndex;
    }
    get predicate() {
        return this._predicate;
    }
    static formatMessage(predicate, message) {
        if (message) return message;
        return `failed predicate: {${predicate}}?`;
    }
};
$1c4583a876daf8fc$var$__decorate([
    $aN41m.NotNull
], $1c4583a876daf8fc$var$FailedPredicateException, "formatMessage", null);
$1c4583a876daf8fc$var$FailedPredicateException = $1c4583a876daf8fc$var$__decorate([
    $1c4583a876daf8fc$var$__param(0, $aN41m.NotNull)
], $1c4583a876daf8fc$var$FailedPredicateException);
module.exports.FailedPredicateException = $1c4583a876daf8fc$var$FailedPredicateException;

});
parcelRegister("b7PPe", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RecognitionException = void 0;
/** The root of the ANTLR exception hierarchy. In general, ANTLR tracks just
 *  3 kinds of errors: prediction errors, failed predicate errors, and
 *  mismatched input errors. In each case, the parser knows where it is
 *  in the input, where it is in the ATN, the rule invocation stack,
 *  and what kind of problem occurred.
 */ class $81988c99cb6b26c7$var$RecognitionException extends Error {
    constructor(recognizer, input, ctx, message){
        super(message);
        this._offendingState = -1;
        this._recognizer = recognizer;
        this.input = input;
        this.ctx = ctx;
        if (recognizer) this._offendingState = recognizer.state;
    }
    /**
     * Get the ATN state number the parser was in at the time the error
     * occurred. For {@link NoViableAltException} and
     * {@link LexerNoViableAltException} exceptions, this is the
     * {@link DecisionState} number. For others, it is the state whose outgoing
     * edge we couldn't match.
     *
     * If the state number is not known, this method returns -1.
     */ get offendingState() {
        return this._offendingState;
    }
    setOffendingState(offendingState) {
        this._offendingState = offendingState;
    }
    /**
     * Gets the set of input symbols which could potentially follow the
     * previously matched symbol at the time this exception was thrown.
     *
     * If the set of expected tokens is not known and could not be computed,
     * this method returns `undefined`.
     *
     * @returns The set of token types that could potentially follow the current
     * state in the ATN, or `undefined` if the information is not available.
     */ get expectedTokens() {
        if (this._recognizer) return this._recognizer.atn.getExpectedTokens(this._offendingState, this.ctx);
        return undefined;
    }
    /**
     * Gets the {@link RuleContext} at the time this exception was thrown.
     *
     * If the context is not available, this method returns `undefined`.
     *
     * @returns The {@link RuleContext} at the time this exception was thrown.
     * If the context is not available, this method returns `undefined`.
     */ get context() {
        return this.ctx;
    }
    /**
     * Gets the input stream which is the symbol source for the recognizer where
     * this exception was thrown.
     *
     * If the input stream is not available, this method returns `undefined`.
     *
     * @returns The input stream which is the symbol source for the recognizer
     * where this exception was thrown, or `undefined` if the stream is not
     * available.
     */ get inputStream() {
        return this.input;
    }
    getOffendingToken(recognizer) {
        if (recognizer && recognizer !== this._recognizer) return undefined;
        return this.offendingToken;
    }
    setOffendingToken(recognizer, offendingToken) {
        if (recognizer === this._recognizer) this.offendingToken = offendingToken;
    }
    /**
     * Gets the {@link Recognizer} where this exception occurred.
     *
     * If the recognizer is not available, this method returns `undefined`.
     *
     * @returns The recognizer where this exception occurred, or `undefined` if
     * the recognizer is not available.
     */ get recognizer() {
        return this._recognizer;
    }
}
module.exports.RecognitionException = $81988c99cb6b26c7$var$RecognitionException;

});

parcelRegister("j3Sey", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $de085dd8bf5f9774$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $de085dd8bf5f9774$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PredicateTransition = void 0;

var $kvmNv = parcelRequire("kvmNv");

var $aN41m = parcelRequire("aN41m");

var $3JS45 = parcelRequire("3JS45");
/** TODO: this is old comment:
 *  A tree of semantic predicates from the grammar AST if label==SEMPRED.
 *  In the ATN, labels will always be exactly one predicate, but the DFA
 *  may have to combine a bunch of them as it collects predicates from
 *  multiple ATN configurations into a single DFA state.
 */ let $de085dd8bf5f9774$var$PredicateTransition = class PredicateTransition extends $kvmNv.AbstractPredicateTransition {
    constructor(target, ruleIndex, predIndex, isCtxDependent){
        super(target);
        this.ruleIndex = ruleIndex;
        this.predIndex = predIndex;
        this.isCtxDependent = isCtxDependent;
    }
    get serializationType() {
        return 4 /* PREDICATE */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    get predicate() {
        return new $3JS45.SemanticContext.Predicate(this.ruleIndex, this.predIndex, this.isCtxDependent);
    }
    toString() {
        return "pred_" + this.ruleIndex + ":" + this.predIndex;
    }
};
$de085dd8bf5f9774$var$__decorate([
    $aN41m.Override
], $de085dd8bf5f9774$var$PredicateTransition.prototype, "serializationType", null);
$de085dd8bf5f9774$var$__decorate([
    $aN41m.Override
], $de085dd8bf5f9774$var$PredicateTransition.prototype, "isEpsilon", null);
$de085dd8bf5f9774$var$__decorate([
    $aN41m.Override
], $de085dd8bf5f9774$var$PredicateTransition.prototype, "matches", null);
$de085dd8bf5f9774$var$__decorate([
    $aN41m.Override,
    $aN41m.NotNull
], $de085dd8bf5f9774$var$PredicateTransition.prototype, "toString", null);
$de085dd8bf5f9774$var$PredicateTransition = $de085dd8bf5f9774$var$__decorate([
    $de085dd8bf5f9774$var$__param(0, $aN41m.NotNull)
], $de085dd8bf5f9774$var$PredicateTransition);
module.exports.PredicateTransition = $de085dd8bf5f9774$var$PredicateTransition;

});
parcelRegister("kvmNv", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AbstractPredicateTransition = void 0;

var $5NWCj = parcelRequire("5NWCj");
/**
 *
 * @author Sam Harwell
 */ class $eed8630418e17dbe$var$AbstractPredicateTransition extends $5NWCj.Transition {
    constructor(target){
        super(target);
    }
}
module.exports.AbstractPredicateTransition = $eed8630418e17dbe$var$AbstractPredicateTransition;

});
parcelRegister("5NWCj", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $439eff7922051987$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $439eff7922051987$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Transition = void 0;

var $aN41m = parcelRequire("aN41m");
/** An ATN transition between any two ATN states.  Subclasses define
 *  atom, set, epsilon, action, predicate, rule transitions.
 *
 *  This is a one way link.  It emanates from a state (usually via a list of
 *  transitions) and has a target state.
 *
 *  Since we never have to change the ATN transitions once we construct it,
 *  we can fix these transitions as specific classes. The DFA transitions
 *  on the other hand need to update the labels as it adds transitions to
 *  the states. We'll use the term Edge for the DFA to distinguish them from
 *  ATN transitions.
 */ let $439eff7922051987$var$Transition = class Transition {
    constructor(target){
        if (target == null) throw new Error("target cannot be null.");
        this.target = target;
    }
    /**
     * Determines if the transition is an "epsilon" transition.
     *
     * The default implementation returns `false`.
     *
     * @returns `true` if traversing this transition in the ATN does not
     * consume an input symbol; otherwise, `false` if traversing this
     * transition consumes (matches) an input symbol.
     */ get isEpsilon() {
        return false;
    }
    get label() {
        return undefined;
    }
};
$439eff7922051987$var$Transition.serializationNames = [
    "INVALID",
    "EPSILON",
    "RANGE",
    "RULE",
    "PREDICATE",
    "ATOM",
    "ACTION",
    "SET",
    "NOT_SET",
    "WILDCARD",
    "PRECEDENCE"
];
$439eff7922051987$var$__decorate([
    $aN41m.NotNull
], $439eff7922051987$var$Transition.prototype, "target", void 0);
$439eff7922051987$var$Transition = $439eff7922051987$var$__decorate([
    $439eff7922051987$var$__param(0, $aN41m.NotNull)
], $439eff7922051987$var$Transition);
module.exports.Transition = $439eff7922051987$var$Transition;

});


parcelRegister("3JS45", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $2b8f833777da73eb$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $2b8f833777da73eb$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SemanticContext = void 0;

var $fsqYw = parcelRequire("fsqYw");

var $6iIjF = parcelRequire("6iIjF");

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");

var $9eW9B = parcelRequire("9eW9B");

var $62Uvn = parcelRequire("62Uvn");
function $2b8f833777da73eb$var$max(items) {
    let result;
    for (let current of items){
        if (result === undefined) {
            result = current;
            continue;
        }
        let comparison = result.compareTo(current);
        if (comparison < 0) result = current;
    }
    return result;
}
function $2b8f833777da73eb$var$min(items) {
    let result;
    for (let current of items){
        if (result === undefined) {
            result = current;
            continue;
        }
        let comparison = result.compareTo(current);
        if (comparison > 0) result = current;
    }
    return result;
}
/** A tree structure used to record the semantic context in which
 *  an ATN configuration is valid.  It's either a single predicate,
 *  a conjunction `p1&&p2`, or a sum of products `p1||p2`.
 *
 *  I have scoped the {@link AND}, {@link OR}, and {@link Predicate} subclasses of
 *  {@link SemanticContext} within the scope of this outer class.
 */ class $2b8f833777da73eb$var$SemanticContext {
    /**
     * The default {@link SemanticContext}, which is semantically equivalent to
     * a predicate of the form `{true}?`.
     */ static get NONE() {
        if ($2b8f833777da73eb$var$SemanticContext._NONE === undefined) $2b8f833777da73eb$var$SemanticContext._NONE = new $2b8f833777da73eb$var$SemanticContext.Predicate();
        return $2b8f833777da73eb$var$SemanticContext._NONE;
    }
    /**
     * Evaluate the precedence predicates for the context and reduce the result.
     *
     * @param parser The parser instance.
     * @param parserCallStack
     * @returns The simplified semantic context after precedence predicates are
     * evaluated, which will be one of the following values.
     *
     * * {@link #NONE}: if the predicate simplifies to `true` after
     *   precedence predicates are evaluated.
     * * `undefined`: if the predicate simplifies to `false` after
     *   precedence predicates are evaluated.
     * * `this`: if the semantic context is not changed as a result of
     *   precedence predicate evaluation.
     * * A non-`undefined` {@link SemanticContext}: the new simplified
     *   semantic context after precedence predicates are evaluated.
     */ evalPrecedence(parser, parserCallStack) {
        return this;
    }
    static and(a, b) {
        if (!a || a === $2b8f833777da73eb$var$SemanticContext.NONE) return b;
        if (b === $2b8f833777da73eb$var$SemanticContext.NONE) return a;
        let result = new $2b8f833777da73eb$var$SemanticContext.AND(a, b);
        if (result.opnds.length === 1) return result.opnds[0];
        return result;
    }
    /**
     *
     *  @see ParserATNSimulator#getPredsForAmbigAlts
     */ static or(a, b) {
        if (!a) return b;
        if (a === $2b8f833777da73eb$var$SemanticContext.NONE || b === $2b8f833777da73eb$var$SemanticContext.NONE) return $2b8f833777da73eb$var$SemanticContext.NONE;
        let result = new $2b8f833777da73eb$var$SemanticContext.OR(a, b);
        if (result.opnds.length === 1) return result.opnds[0];
        return result;
    }
}
module.exports.SemanticContext = $2b8f833777da73eb$var$SemanticContext;
(function(SemanticContext) {
    /**
     * This random 30-bit prime represents the value of `AND.class.hashCode()`.
     */ const AND_HASHCODE = 40363613;
    /**
     * This random 30-bit prime represents the value of `OR.class.hashCode()`.
     */ const OR_HASHCODE = 486279973;
    function filterPrecedencePredicates(collection) {
        let result = [];
        for(let i = 0; i < collection.length; i++){
            let context = collection[i];
            if (context instanceof SemanticContext.PrecedencePredicate) {
                result.push(context);
                // Remove the item from 'collection' and move i back so we look at the same index again
                collection.splice(i, 1);
                i--;
            }
        }
        return result;
    }
    class Predicate extends SemanticContext {
        constructor(ruleIndex = -1, predIndex = -1, isCtxDependent = false){
            super();
            this.ruleIndex = ruleIndex;
            this.predIndex = predIndex;
            this.isCtxDependent = isCtxDependent;
        }
        eval(parser, parserCallStack) {
            let localctx = this.isCtxDependent ? parserCallStack : undefined;
            return parser.sempred(localctx, this.ruleIndex, this.predIndex);
        }
        hashCode() {
            let hashCode = $amQx9.MurmurHash.initialize();
            hashCode = $amQx9.MurmurHash.update(hashCode, this.ruleIndex);
            hashCode = $amQx9.MurmurHash.update(hashCode, this.predIndex);
            hashCode = $amQx9.MurmurHash.update(hashCode, this.isCtxDependent ? 1 : 0);
            hashCode = $amQx9.MurmurHash.finish(hashCode, 3);
            return hashCode;
        }
        equals(obj) {
            if (!(obj instanceof Predicate)) return false;
            if (this === obj) return true;
            return this.ruleIndex === obj.ruleIndex && this.predIndex === obj.predIndex && this.isCtxDependent === obj.isCtxDependent;
        }
        toString() {
            return "{" + this.ruleIndex + ":" + this.predIndex + "}?";
        }
    }
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], Predicate.prototype, "eval", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], Predicate.prototype, "hashCode", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], Predicate.prototype, "equals", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], Predicate.prototype, "toString", null);
    SemanticContext.Predicate = Predicate;
    class PrecedencePredicate extends SemanticContext {
        constructor(precedence){
            super();
            this.precedence = precedence;
        }
        eval(parser, parserCallStack) {
            return parser.precpred(parserCallStack, this.precedence);
        }
        evalPrecedence(parser, parserCallStack) {
            if (parser.precpred(parserCallStack, this.precedence)) return SemanticContext.NONE;
            else return undefined;
        }
        compareTo(o) {
            return this.precedence - o.precedence;
        }
        hashCode() {
            let hashCode = 1;
            hashCode = 31 * hashCode + this.precedence;
            return hashCode;
        }
        equals(obj) {
            if (!(obj instanceof PrecedencePredicate)) return false;
            if (this === obj) return true;
            return this.precedence === obj.precedence;
        }
        toString() {
            return "{" + this.precedence + ">=prec}?";
        }
    }
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], PrecedencePredicate.prototype, "eval", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], PrecedencePredicate.prototype, "evalPrecedence", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], PrecedencePredicate.prototype, "compareTo", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], PrecedencePredicate.prototype, "hashCode", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], PrecedencePredicate.prototype, "equals", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], PrecedencePredicate.prototype, "toString", null);
    SemanticContext.PrecedencePredicate = PrecedencePredicate;
    /**
     * This is the base class for semantic context "operators", which operate on
     * a collection of semantic context "operands".
     *
     * @since 4.3
     */ class Operator extends SemanticContext {
    }
    SemanticContext.Operator = Operator;
    /**
     * A semantic context which is true whenever none of the contained contexts
     * is false.
     */ let AND = class AND extends Operator {
        constructor(a, b){
            super();
            let operands = new $fsqYw.Array2DHashSet($9eW9B.ObjectEqualityComparator.INSTANCE);
            if (a instanceof AND) operands.addAll(a.opnds);
            else operands.add(a);
            if (b instanceof AND) operands.addAll(b.opnds);
            else operands.add(b);
            this.opnds = operands.toArray();
            let precedencePredicates = filterPrecedencePredicates(this.opnds);
            // interested in the transition with the lowest precedence
            let reduced = $2b8f833777da73eb$var$min(precedencePredicates);
            if (reduced) this.opnds.push(reduced);
        }
        get operands() {
            return this.opnds;
        }
        equals(obj) {
            if (this === obj) return true;
            if (!(obj instanceof AND)) return false;
            return $6iIjF.ArrayEqualityComparator.INSTANCE.equals(this.opnds, obj.opnds);
        }
        hashCode() {
            return $amQx9.MurmurHash.hashCode(this.opnds, AND_HASHCODE);
        }
        /**
         * {@inheritDoc}
         *
         * The evaluation of predicates by this context is short-circuiting, but
         * unordered.
         */ eval(parser, parserCallStack) {
            for (let opnd of this.opnds){
                if (!opnd.eval(parser, parserCallStack)) return false;
            }
            return true;
        }
        evalPrecedence(parser, parserCallStack) {
            let differs = false;
            let operands = [];
            for (let context of this.opnds){
                let evaluated = context.evalPrecedence(parser, parserCallStack);
                differs = differs || evaluated !== context;
                if (evaluated == null) // The AND context is false if any element is false
                return undefined;
                else if (evaluated !== SemanticContext.NONE) // Reduce the result by skipping true elements
                operands.push(evaluated);
            }
            if (!differs) return this;
            if (operands.length === 0) // all elements were true, so the AND context is true
            return SemanticContext.NONE;
            let result = operands[0];
            for(let i = 1; i < operands.length; i++)result = SemanticContext.and(result, operands[i]);
            return result;
        }
        toString() {
            return $62Uvn.join(this.opnds, "&&");
        }
    };
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], AND.prototype, "operands", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], AND.prototype, "equals", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], AND.prototype, "hashCode", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], AND.prototype, "eval", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], AND.prototype, "evalPrecedence", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], AND.prototype, "toString", null);
    AND = $2b8f833777da73eb$var$__decorate([
        $2b8f833777da73eb$var$__param(0, $aN41m.NotNull),
        $2b8f833777da73eb$var$__param(1, $aN41m.NotNull)
    ], AND);
    SemanticContext.AND = AND;
    /**
     * A semantic context which is true whenever at least one of the contained
     * contexts is true.
     */ let OR = class OR extends Operator {
        constructor(a, b){
            super();
            let operands = new $fsqYw.Array2DHashSet($9eW9B.ObjectEqualityComparator.INSTANCE);
            if (a instanceof OR) operands.addAll(a.opnds);
            else operands.add(a);
            if (b instanceof OR) operands.addAll(b.opnds);
            else operands.add(b);
            this.opnds = operands.toArray();
            let precedencePredicates = filterPrecedencePredicates(this.opnds);
            // interested in the transition with the highest precedence
            let reduced = $2b8f833777da73eb$var$max(precedencePredicates);
            if (reduced) this.opnds.push(reduced);
        }
        get operands() {
            return this.opnds;
        }
        equals(obj) {
            if (this === obj) return true;
            if (!(obj instanceof OR)) return false;
            return $6iIjF.ArrayEqualityComparator.INSTANCE.equals(this.opnds, obj.opnds);
        }
        hashCode() {
            return $amQx9.MurmurHash.hashCode(this.opnds, OR_HASHCODE);
        }
        /**
         * {@inheritDoc}
         *
         * The evaluation of predicates by this context is short-circuiting, but
         * unordered.
         */ eval(parser, parserCallStack) {
            for (let opnd of this.opnds){
                if (opnd.eval(parser, parserCallStack)) return true;
            }
            return false;
        }
        evalPrecedence(parser, parserCallStack) {
            let differs = false;
            let operands = [];
            for (let context of this.opnds){
                let evaluated = context.evalPrecedence(parser, parserCallStack);
                differs = differs || evaluated !== context;
                if (evaluated === SemanticContext.NONE) // The OR context is true if any element is true
                return SemanticContext.NONE;
                else if (evaluated) // Reduce the result by skipping false elements
                operands.push(evaluated);
            }
            if (!differs) return this;
            if (operands.length === 0) // all elements were false, so the OR context is false
            return undefined;
            let result = operands[0];
            for(let i = 1; i < operands.length; i++)result = SemanticContext.or(result, operands[i]);
            return result;
        }
        toString() {
            return $62Uvn.join(this.opnds, "||");
        }
    };
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], OR.prototype, "operands", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], OR.prototype, "equals", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], OR.prototype, "hashCode", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], OR.prototype, "eval", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], OR.prototype, "evalPrecedence", null);
    $2b8f833777da73eb$var$__decorate([
        $aN41m.Override
    ], OR.prototype, "toString", null);
    OR = $2b8f833777da73eb$var$__decorate([
        $2b8f833777da73eb$var$__param(0, $aN41m.NotNull),
        $2b8f833777da73eb$var$__param(1, $aN41m.NotNull)
    ], OR);
    SemanticContext.OR = OR;
})($2b8f833777da73eb$var$SemanticContext = module.exports.SemanticContext || (module.exports.SemanticContext = {}));

});
parcelRegister("fsqYw", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $b40e65386248425a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $b40e65386248425a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Array2DHashSet = void 0;

var $fomfP = parcelRequire("fomfP");

var $aGZuj = parcelRequire("aGZuj");

var $aN41m = parcelRequire("aN41m");

var $amQx9 = parcelRequire("amQx9");
/** {@link Set} implementation with closed hashing (open addressing). */ // NOTE:  JavaScript's Set interface has on significant different diffrence from Java's:
// 		  e.g. the return type of add() differs!
//        For this reason I've commented tweaked the implements clause
const $b40e65386248425a$var$INITAL_CAPACITY = 16; // must be power of 2
const $b40e65386248425a$var$LOAD_FACTOR = 0.75;
class $b40e65386248425a$var$Array2DHashSet {
    constructor(comparatorOrSet, initialCapacity = $b40e65386248425a$var$INITAL_CAPACITY){
        /** How many elements in set */ this.n = 0;
        this.threshold = Math.floor($b40e65386248425a$var$INITAL_CAPACITY * $b40e65386248425a$var$LOAD_FACTOR); // when to expand
        if (comparatorOrSet instanceof $b40e65386248425a$var$Array2DHashSet) {
            this.comparator = comparatorOrSet.comparator;
            this.buckets = comparatorOrSet.buckets.slice(0);
            for(let i = 0; i < this.buckets.length; i++){
                let bucket = this.buckets[i];
                if (bucket) this.buckets[i] = bucket.slice(0);
            }
            this.n = comparatorOrSet.n;
            this.threshold = comparatorOrSet.threshold;
        } else {
            this.comparator = comparatorOrSet || $aGZuj.DefaultEqualityComparator.INSTANCE;
            this.buckets = this.createBuckets(initialCapacity);
        }
    }
    /**
     * Add `o` to set if not there; return existing value if already
     * there. This method performs the same operation as {@link #add} aside from
     * the return value.
     */ getOrAdd(o) {
        if (this.n > this.threshold) this.expand();
        return this.getOrAddImpl(o);
    }
    getOrAddImpl(o) {
        let b = this.getBucket(o);
        let bucket = this.buckets[b];
        // NEW BUCKET
        if (!bucket) {
            bucket = [
                o
            ];
            this.buckets[b] = bucket;
            this.n++;
            return o;
        }
        // LOOK FOR IT IN BUCKET
        for (let existing of bucket){
            if (this.comparator.equals(existing, o)) return existing; // found existing, quit
        }
        // FULL BUCKET, expand and add to end
        bucket.push(o);
        this.n++;
        return o;
    }
    get(o) {
        if (o == null) return o;
        let b = this.getBucket(o);
        let bucket = this.buckets[b];
        if (!bucket) // no bucket
        return undefined;
        for (let e of bucket){
            if (this.comparator.equals(e, o)) return e;
        }
        return undefined;
    }
    getBucket(o) {
        let hash = this.comparator.hashCode(o);
        let b = hash & this.buckets.length - 1; // assumes len is power of 2
        return b;
    }
    hashCode() {
        let hash = $amQx9.MurmurHash.initialize();
        for (let bucket of this.buckets){
            if (bucket == null) continue;
            for (let o of bucket){
                if (o == null) break;
                hash = $amQx9.MurmurHash.update(hash, this.comparator.hashCode(o));
            }
        }
        hash = $amQx9.MurmurHash.finish(hash, this.size);
        return hash;
    }
    equals(o) {
        if (o === this) return true;
        if (!(o instanceof $b40e65386248425a$var$Array2DHashSet)) return false;
        if (o.size !== this.size) return false;
        let same = this.containsAll(o);
        return same;
    }
    expand() {
        let old = this.buckets;
        let newCapacity = this.buckets.length * 2;
        let newTable = this.createBuckets(newCapacity);
        this.buckets = newTable;
        this.threshold = Math.floor(newCapacity * $b40e65386248425a$var$LOAD_FACTOR);
        //		System.out.println("new size="+newCapacity+", thres="+threshold);
        // rehash all existing entries
        let oldSize = this.size;
        for (let bucket of old){
            if (!bucket) continue;
            for (let o of bucket){
                let b = this.getBucket(o);
                let newBucket = this.buckets[b];
                if (!newBucket) {
                    newBucket = [];
                    this.buckets[b] = newBucket;
                }
                newBucket.push(o);
            }
        }
        $fomfP(this.n === oldSize);
    }
    add(t) {
        let existing = this.getOrAdd(t);
        return existing === t;
    }
    get size() {
        return this.n;
    }
    get isEmpty() {
        return this.n === 0;
    }
    contains(o) {
        return this.containsFast(this.asElementType(o));
    }
    containsFast(obj) {
        if (obj == null) return false;
        return this.get(obj) != null;
    }
    *[Symbol.iterator]() {
        yield* this.toArray();
    }
    toArray() {
        const a = new Array(this.size);
        // Copy elements from the nested arrays into the destination array
        let i = 0; // Position within destination array
        for (let bucket of this.buckets){
            if (bucket == null) continue;
            for (let o of bucket){
                if (o == null) break;
                a[i++] = o;
            }
        }
        return a;
    }
    containsAll(collection) {
        if (collection instanceof $b40e65386248425a$var$Array2DHashSet) {
            let s = collection;
            for (let bucket of s.buckets){
                if (bucket == null) continue;
                for (let o of bucket){
                    if (o == null) break;
                    if (!this.containsFast(this.asElementType(o))) return false;
                }
            }
        } else for (let o of collection){
            if (!this.containsFast(this.asElementType(o))) return false;
        }
        return true;
    }
    addAll(c) {
        let changed = false;
        for (let o of c){
            let existing = this.getOrAdd(o);
            if (existing !== o) changed = true;
        }
        return changed;
    }
    clear() {
        this.buckets = this.createBuckets($b40e65386248425a$var$INITAL_CAPACITY);
        this.n = 0;
        this.threshold = Math.floor($b40e65386248425a$var$INITAL_CAPACITY * $b40e65386248425a$var$LOAD_FACTOR);
    }
    toString() {
        if (this.size === 0) return "{}";
        let buf = "{";
        let first = true;
        for (let bucket of this.buckets){
            if (bucket == null) continue;
            for (let o of bucket){
                if (o == null) break;
                if (first) first = false;
                else buf += ", ";
                buf += o.toString();
            }
        }
        buf += "}";
        return buf;
    }
    toTableString() {
        let buf = "";
        for (let bucket of this.buckets){
            if (bucket == null) {
                buf += "null\n";
                continue;
            }
            buf += "[";
            let first = true;
            for (let o of bucket){
                if (first) first = false;
                else buf += " ";
                if (o == null) buf += "_";
                else buf += o.toString();
            }
            buf += "]\n";
        }
        return buf;
    }
    /**
     * Return `o` as an instance of the element type `T`. If
     * `o` is non-undefined but known to not be an instance of `T`, this
     * method returns `undefined`. The base implementation does not perform any
     * type checks; override this method to provide strong type checks for the
     * {@link #contains} and {@link #remove} methods to ensure the arguments to
     * the {@link EqualityComparator} for the set always have the expected
     * types.
     *
     * @param o the object to try and cast to the element type of the set
     * @returns `o` if it could be an instance of `T`, otherwise
     * `undefined`.
     */ asElementType(o) {
        return o;
    }
    /**
     * Return an array of `T[]` with length `capacity`.
     *
     * @param capacity the length of the array to return
     * @returns the newly constructed array
     */ createBuckets(capacity) {
        return new Array(capacity);
    }
}
$b40e65386248425a$var$__decorate([
    $aN41m.NotNull
], $b40e65386248425a$var$Array2DHashSet.prototype, "comparator", void 0);
$b40e65386248425a$var$__decorate([
    $aN41m.Override
], $b40e65386248425a$var$Array2DHashSet.prototype, "hashCode", null);
$b40e65386248425a$var$__decorate([
    $aN41m.Override
], $b40e65386248425a$var$Array2DHashSet.prototype, "equals", null);
$b40e65386248425a$var$__decorate([
    $aN41m.Override
], $b40e65386248425a$var$Array2DHashSet.prototype, "add", null);
$b40e65386248425a$var$__decorate([
    $aN41m.Override
], $b40e65386248425a$var$Array2DHashSet.prototype, "size", null);
$b40e65386248425a$var$__decorate([
    $aN41m.Override
], $b40e65386248425a$var$Array2DHashSet.prototype, "isEmpty", null);
$b40e65386248425a$var$__decorate([
    $aN41m.Override
], $b40e65386248425a$var$Array2DHashSet.prototype, "contains", null);
$b40e65386248425a$var$__decorate([
    $b40e65386248425a$var$__param(0, $aN41m.Nullable)
], $b40e65386248425a$var$Array2DHashSet.prototype, "containsFast", null);
$b40e65386248425a$var$__decorate([
    $aN41m.Override
], $b40e65386248425a$var$Array2DHashSet.prototype, Symbol.iterator, null);
$b40e65386248425a$var$__decorate([
    $aN41m.Override
], $b40e65386248425a$var$Array2DHashSet.prototype, "toArray", null);
$b40e65386248425a$var$__decorate([
    $aN41m.Override
], $b40e65386248425a$var$Array2DHashSet.prototype, "containsAll", null);
$b40e65386248425a$var$__decorate([
    $aN41m.Override
], $b40e65386248425a$var$Array2DHashSet.prototype, "addAll", null);
$b40e65386248425a$var$__decorate([
    $aN41m.Override
], $b40e65386248425a$var$Array2DHashSet.prototype, "clear", null);
$b40e65386248425a$var$__decorate([
    $aN41m.Override
], $b40e65386248425a$var$Array2DHashSet.prototype, "toString", null);
$b40e65386248425a$var$__decorate([
    $aN41m.SuppressWarnings("unchecked")
], $b40e65386248425a$var$Array2DHashSet.prototype, "asElementType", null);
$b40e65386248425a$var$__decorate([
    $aN41m.SuppressWarnings("unchecked")
], $b40e65386248425a$var$Array2DHashSet.prototype, "createBuckets", null);
module.exports.Array2DHashSet = $b40e65386248425a$var$Array2DHashSet;

});
parcelRegister("aGZuj", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $7c8d85d29b04f35b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultEqualityComparator = void 0;

var $aN41m = parcelRequire("aN41m");

var $amQx9 = parcelRequire("amQx9");

var $9eW9B = parcelRequire("9eW9B");
/**
 * This default implementation of {@link EqualityComparator} uses object equality
 * for comparisons by calling {@link Object#hashCode} and {@link Object#equals}.
 *
 * @author Sam Harwell
 */ class $7c8d85d29b04f35b$var$DefaultEqualityComparator {
    /**
     * {@inheritDoc}
     *
     * This implementation returns
     * `obj.`{@link Object#hashCode hashCode()}.
     */ hashCode(obj) {
        if (obj == null) return 0;
        else if (typeof obj === "string" || typeof obj === "number") return $amQx9.MurmurHash.hashCode([
            obj
        ]);
        else return $9eW9B.ObjectEqualityComparator.INSTANCE.hashCode(obj);
    }
    /**
     * {@inheritDoc}
     *
     * This implementation relies on object equality. If both objects are
     * `undefined` or `null`, this method returns `true`. Otherwise if only
     * `a` is `undefined` or `null`, this method returns `false`. Otherwise,
     * this method returns the result of
     * `a.`{@link Object#equals equals}`(b)`.
     */ equals(a, b) {
        if (a == null) return b == null;
        else if (typeof a === "string" || typeof a === "number") return a === b;
        else return $9eW9B.ObjectEqualityComparator.INSTANCE.equals(a, b);
    }
}
$7c8d85d29b04f35b$var$DefaultEqualityComparator.INSTANCE = new $7c8d85d29b04f35b$var$DefaultEqualityComparator();
$7c8d85d29b04f35b$var$__decorate([
    $aN41m.Override
], $7c8d85d29b04f35b$var$DefaultEqualityComparator.prototype, "hashCode", null);
$7c8d85d29b04f35b$var$__decorate([
    $aN41m.Override
], $7c8d85d29b04f35b$var$DefaultEqualityComparator.prototype, "equals", null);
module.exports.DefaultEqualityComparator = $7c8d85d29b04f35b$var$DefaultEqualityComparator;

});
parcelRegister("amQx9", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MurmurHash = void 0;
/**
 *
 * @author Sam Harwell
 */ var $78c4b58c32e2212f$var$MurmurHash;
(function(MurmurHash) {
    const DEFAULT_SEED = 0;
    /**
     * Initialize the hash using the specified `seed`.
     *
     * @param seed the seed (optional)
     * @returns the intermediate hash value
     */ function initialize(seed = DEFAULT_SEED) {
        return seed;
    }
    MurmurHash.initialize = initialize;
    /**
     * Update the intermediate hash value for the next input `value`.
     *
     * @param hash the intermediate hash value
     * @param value the value to add to the current hash
     * @returns the updated intermediate hash value
     */ function update(hash, value) {
        const c1 = 0xCC9E2D51;
        const c2 = 0x1B873593;
        const r1 = 15;
        const r2 = 13;
        const m = 5;
        const n = 0xE6546B64;
        if (value == null) value = 0;
        else if (typeof value === "string") value = hashString(value);
        else if (typeof value === "object") value = value.hashCode();
        let k = value;
        k = Math.imul(k, c1);
        k = k << r1 | k >>> 32 - r1;
        k = Math.imul(k, c2);
        hash = hash ^ k;
        hash = hash << r2 | hash >>> 32 - r2;
        hash = Math.imul(hash, m) + n;
        return hash & 0xFFFFFFFF;
    }
    MurmurHash.update = update;
    /**
     * Apply the final computation steps to the intermediate value `hash`
     * to form the final result of the MurmurHash 3 hash function.
     *
     * @param hash the intermediate hash value
     * @param numberOfWords the number of integer values added to the hash
     * @returns the final hash result
     */ function finish(hash, numberOfWords) {
        hash = hash ^ numberOfWords * 4;
        hash = hash ^ hash >>> 16;
        hash = Math.imul(hash, 0x85EBCA6B);
        hash = hash ^ hash >>> 13;
        hash = Math.imul(hash, 0xC2B2AE35);
        hash = hash ^ hash >>> 16;
        return hash;
    }
    MurmurHash.finish = finish;
    /**
     * Utility function to compute the hash code of an array using the
     * MurmurHash algorithm.
     *
     * @param <T> the array element type
     * @param data the array data
     * @param seed the seed for the MurmurHash algorithm
     * @returns the hash code of the data
     */ function hashCode(data, seed = DEFAULT_SEED) {
        let hash = initialize(seed);
        let length = 0;
        for (let value of data){
            hash = update(hash, value);
            length++;
        }
        hash = finish(hash, length);
        return hash;
    }
    MurmurHash.hashCode = hashCode;
    /**
     * Function to hash a string. Based on the implementation found here:
     * http://stackoverflow.com/a/7616484
     */ function hashString(str) {
        let len = str.length;
        if (len === 0) return 0;
        let hash = 0;
        for(let i = 0; i < len; i++){
            let c = str.charCodeAt(i);
            hash = (hash << 5 >>> 0) - hash + c;
            hash |= 0;
        }
        return hash;
    }
})($78c4b58c32e2212f$var$MurmurHash = module.exports.MurmurHash || (module.exports.MurmurHash = {}));

});

parcelRegister("9eW9B", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $6ba288078a70e293$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ObjectEqualityComparator = void 0;

var $aN41m = parcelRequire("aN41m");
/**
 * This default implementation of {@link EqualityComparator} uses object equality
 * for comparisons by calling {@link Object#hashCode} and {@link Object#equals}.
 *
 * @author Sam Harwell
 */ class $6ba288078a70e293$var$ObjectEqualityComparator {
    /**
     * {@inheritDoc}
     *
     * This implementation returns
     * `obj.`{@link Object#hashCode hashCode()}.
     */ hashCode(obj) {
        if (obj == null) return 0;
        return obj.hashCode();
    }
    /**
     * {@inheritDoc}
     *
     * This implementation relies on object equality. If both objects are
     * `undefined` or `null`, this method returns `true`. Otherwise if only
     * `a` is `undefined` or `null`, this method returns `false`. Otherwise,
     * this method returns the result of
     * `a.`{@link Object#equals equals}`(b)`.
     */ equals(a, b) {
        if (a == null) return b == null;
        return a.equals(b);
    }
}
$6ba288078a70e293$var$ObjectEqualityComparator.INSTANCE = new $6ba288078a70e293$var$ObjectEqualityComparator();
$6ba288078a70e293$var$__decorate([
    $aN41m.Override
], $6ba288078a70e293$var$ObjectEqualityComparator.prototype, "hashCode", null);
$6ba288078a70e293$var$__decorate([
    $aN41m.Override
], $6ba288078a70e293$var$ObjectEqualityComparator.prototype, "equals", null);
module.exports.ObjectEqualityComparator = $6ba288078a70e293$var$ObjectEqualityComparator;

});



parcelRegister("6iIjF", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $4966cccca723aa26$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ArrayEqualityComparator = void 0;

var $aN41m = parcelRequire("aN41m");

var $amQx9 = parcelRequire("amQx9");

var $9eW9B = parcelRequire("9eW9B");
/**
 * This default implementation of {@link EqualityComparator} uses object equality
 * for comparisons by calling {@link Object#hashCode} and {@link Object#equals}.
 *
 * @author Sam Harwell
 */ class $4966cccca723aa26$var$ArrayEqualityComparator {
    /**
     * {@inheritDoc}
     *
     * This implementation returns
     * `obj.`{@link Object#hashCode hashCode()}.
     */ hashCode(obj) {
        if (obj == null) return 0;
        return $amQx9.MurmurHash.hashCode(obj, 0);
    }
    /**
     * {@inheritDoc}
     *
     * This implementation relies on object equality. If both objects are
     * `undefined`, this method returns `true`. Otherwise if only
     * `a` is `undefined`, this method returns `false`. Otherwise,
     * this method returns the result of
     * `a.`{@link Object#equals equals}`(b)`.
     */ equals(a, b) {
        if (a == null) return b == null;
        else if (b == null) return false;
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (!$9eW9B.ObjectEqualityComparator.INSTANCE.equals(a[i], b[i])) return false;
        }
        return true;
    }
}
$4966cccca723aa26$var$ArrayEqualityComparator.INSTANCE = new $4966cccca723aa26$var$ArrayEqualityComparator();
$4966cccca723aa26$var$__decorate([
    $aN41m.Override
], $4966cccca723aa26$var$ArrayEqualityComparator.prototype, "hashCode", null);
$4966cccca723aa26$var$__decorate([
    $aN41m.Override
], $4966cccca723aa26$var$ArrayEqualityComparator.prototype, "equals", null);
module.exports.ArrayEqualityComparator = $4966cccca723aa26$var$ArrayEqualityComparator;

});

parcelRegister("62Uvn", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toCharArray = module.exports.toMap = module.exports.equals = module.exports.join = module.exports.escapeWhitespace = void 0;
function $466ec2b4a094d7df$var$escapeWhitespace(s, escapeSpaces) {
    return escapeSpaces ? s.replace(/ /, "\u00B7") : s.replace(/\t/, "\\t").replace(/\n/, "\\n").replace(/\r/, "\\r");
}
module.exports.escapeWhitespace = $466ec2b4a094d7df$var$escapeWhitespace;
// Seriously: why isn't this built in to java? ugh!
function $466ec2b4a094d7df$var$join(collection, separator) {
    let buf = "";
    let first = true;
    for (let current of collection){
        if (first) first = false;
        else buf += separator;
        buf += current;
    }
    return buf;
}
module.exports.join = $466ec2b4a094d7df$var$join;
function $466ec2b4a094d7df$var$equals(x, y) {
    if (x === y) return true;
    if (x === undefined || y === undefined) return false;
    return x.equals(y);
}
module.exports.equals = $466ec2b4a094d7df$var$equals;
// export function numNonnull(data: any[]): number {
// 	let n: number =  0;
// 	if ( data == null ) return n;
// 	for (let o of data) {
// 		if ( o!=null ) n++;
// 	}
// 	return n;
// }
// export function removeAllElements<T>(data: Collection<T>, value: T): void {
// 	if ( data==null ) return;
// 	while ( data.contains(value) ) data.remove(value);
// }
// export function writeFile(@NotNull file: File, @NotNull content: Uint8Array): void {
// 	let fos: FileOutputStream = new FileOutputStream(file);
// 	try {
// 		fos.write(content);
// 	} finally {
// 		fos.close();
// 	}
// }
// export function writeFile(@NotNull fileName: string, @NotNull content: string): void {
// 	writeFile(fileName, content, null);
// }
// export function writeFile(@NotNull fileName: string, @NotNull content: string, @Nullable encoding: string): void {
// 	let f: File =  new File(fileName);
// 	let fos: FileOutputStream =  new FileOutputStream(f);
// 	let osw: OutputStreamWriter;
// 	if (encoding != null) {
// 		osw = new OutputStreamWriter(fos, encoding);
// 	}
// 	else {
// 		osw = new OutputStreamWriter(fos);
// 	}
// 	try {
// 		osw.write(content);
// 	}
// 	finally {
// 		osw.close();
// 	}
// }
// @NotNull
// export function readFile(@NotNull fileName: string): char[] {
// 	return readFile(fileName, null);
// }
// @NotNull
// export function readFile(@NotNull fileName: string, @Nullable encoding: string): char[] {
// 	let f: File =  new File(fileName);
// 	let size: number =  (int)f.length();
// 	let isr: InputStreamReader;
// 	let fis: FileInputStream =  new FileInputStream(fileName);
// 	if ( encoding!=null ) {
// 		isr = new InputStreamReader(fis, encoding);
// 	}
// 	else {
// 		isr = new InputStreamReader(fis);
// 	}
// 	let data: char[] =  null;
// 	try {
// 		data = new char[size];
// 		let n: number =  isr.read(data);
// 		if (n < data.length) {
// 			data = Arrays.copyOf(data, n);
// 		}
// 	}
// 	finally {
// 		isr.close();
// 	}
// 	return data;
// }
// export function removeAll<T>(@NotNull predicate: List<T> list,@NotNull Predicate<? super T>): void {
// 	let j: number =  0;
// 	for (let i = 0; i < list.size; i++) {
// 		let item: T =  list.get(i);
// 		if (!predicate.eval(item)) {
// 			if (j != i) {
// 				list.set(j, item);
// 			}
// 			j++;
// 		}
// 	}
// 	if (j < list.size) {
// 		list.subList(j, list.size).clear();
// 	}
// }
// export function removeAll<T>(@NotNull predicate: Iterable<T> iterable,@NotNull Predicate<? super T>): void {
// 	if (iterable instanceof List<?>) {
// 		removeAll((List<T>)iterable, predicate);
// 		return;
// 	}
// 	for (Iterator<T> iterator = iterable.iterator(); iterator.hasNext(); ) {
// 		let item: T =  iterator.next();
// 		if (predicate.eval(item)) {
// 			iterator.remove();
// 		}
// 	}
// }
/** Convert array of strings to string&rarr;index map. Useful for
 *  converting rulenames to name&rarr;ruleindex map.
 */ function $466ec2b4a094d7df$var$toMap(keys) {
    let m = new Map();
    for(let i = 0; i < keys.length; i++)m.set(keys[i], i);
    return m;
}
module.exports.toMap = $466ec2b4a094d7df$var$toMap;
function $466ec2b4a094d7df$var$toCharArray(str) {
    if (typeof str === "string") {
        let result = new Uint16Array(str.length);
        for(let i = 0; i < str.length; i++)result[i] = str.charCodeAt(i);
        return result;
    } else return str.toCharArray();
}
module.exports.toCharArray = $466ec2b4a094d7df$var$toCharArray; // /**
 // 	* @since 4.5
 // 	*/
 // @NotNull
 // export function toSet(@NotNull bits: BitSet): IntervalSet {
 // 	let s: IntervalSet =  new IntervalSet();
 // 	let i: number =  bits.nextSetBit(0);
 // 	while ( i >= 0 ) {
 // 		s.add(i);
 // 		i = bits.nextSetBit(i+1);
 // 	}
 // 	return s;
 // }

});




parcelRegister("5jZSY", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $3dfebb51130d9868$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $3dfebb51130d9868$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InputMismatchException = void 0;

var $b7PPe = parcelRequire("b7PPe");

var $aN41m = parcelRequire("aN41m");
/** This signifies any kind of mismatched input exceptions such as
 *  when the current input does not match the expected token.
 */ let $3dfebb51130d9868$var$InputMismatchException = class InputMismatchException extends $b7PPe.RecognitionException {
    constructor(recognizer, state, context){
        if (context === undefined) context = recognizer.context;
        super(recognizer, recognizer.inputStream, context);
        if (state !== undefined) this.setOffendingState(state);
        this.setOffendingToken(recognizer, recognizer.currentToken);
    }
};
$3dfebb51130d9868$var$InputMismatchException = $3dfebb51130d9868$var$__decorate([
    $3dfebb51130d9868$var$__param(0, $aN41m.NotNull)
], $3dfebb51130d9868$var$InputMismatchException);
module.exports.InputMismatchException = $3dfebb51130d9868$var$InputMismatchException;

});

parcelRegister("6kdz0", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $49af21c6dd39b813$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $49af21c6dd39b813$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntervalSet = void 0;

var $6iIjF = parcelRequire("6iIjF");

var $eRSlM = parcelRequire("eRSlM");

var $l8y5T = parcelRequire("l8y5T");

var $h7Q3L = parcelRequire("h7Q3L");

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");

var $eKXi4 = parcelRequire("eKXi4");
/**
 * This class implements the {@link IntSet} backed by a sorted array of
 * non-overlapping intervals. It is particularly efficient for representing
 * large collections of numbers, where the majority of elements appear as part
 * of a sequential range of numbers that are all part of the set. For example,
 * the set { 1, 2, 3, 4, 7, 8 } may be represented as { [1, 4], [7, 8] }.
 *
 * This class is able to represent sets containing any combination of values in
 * the range {@link Integer#MIN_VALUE} to {@link Integer#MAX_VALUE}
 * (inclusive).
 */ class $49af21c6dd39b813$var$IntervalSet {
    constructor(intervals){
        this.readonly = false;
        if (intervals != null) this._intervals = intervals.slice(0);
        else this._intervals = [];
    }
    static get COMPLETE_CHAR_SET() {
        if ($49af21c6dd39b813$var$IntervalSet._COMPLETE_CHAR_SET === undefined) {
            $49af21c6dd39b813$var$IntervalSet._COMPLETE_CHAR_SET = $49af21c6dd39b813$var$IntervalSet.of($h7Q3L.Lexer.MIN_CHAR_VALUE, $h7Q3L.Lexer.MAX_CHAR_VALUE);
            $49af21c6dd39b813$var$IntervalSet._COMPLETE_CHAR_SET.setReadonly(true);
        }
        return $49af21c6dd39b813$var$IntervalSet._COMPLETE_CHAR_SET;
    }
    static get EMPTY_SET() {
        if ($49af21c6dd39b813$var$IntervalSet._EMPTY_SET == null) {
            $49af21c6dd39b813$var$IntervalSet._EMPTY_SET = new $49af21c6dd39b813$var$IntervalSet();
            $49af21c6dd39b813$var$IntervalSet._EMPTY_SET.setReadonly(true);
        }
        return $49af21c6dd39b813$var$IntervalSet._EMPTY_SET;
    }
    /**
     * Create a set with all ints within range [a..b] (inclusive). If b is omitted, the set contains the single element
     * a.
     */ static of(a, b = a) {
        let s = new $49af21c6dd39b813$var$IntervalSet();
        s.add(a, b);
        return s;
    }
    clear() {
        if (this.readonly) throw new Error("can't alter readonly IntervalSet");
        this._intervals.length = 0;
    }
    /** Add interval; i.e., add all integers from a to b to set.
     *  If b&lt;a, do nothing.
     *  Keep list in sorted order (by left range value).
     *  If overlap, combine ranges.  For example,
     *  If this is {1..5, 10..20}, adding 6..7 yields
     *  {1..5, 6..7, 10..20}.  Adding 4..8 yields {1..8, 10..20}.
     */ add(a, b = a) {
        this.addRange($l8y5T.Interval.of(a, b));
    }
    // copy on write so we can cache a..a intervals and sets of that
    addRange(addition) {
        if (this.readonly) throw new Error("can't alter readonly IntervalSet");
        //System.out.println("add "+addition+" to "+intervals.toString());
        if (addition.b < addition.a) return;
        // find position in list
        // Use iterators as we modify list in place
        for(let i = 0; i < this._intervals.length; i++){
            let r = this._intervals[i];
            if (addition.equals(r)) return;
            if (addition.adjacent(r) || !addition.disjoint(r)) {
                // next to each other, make a single larger interval
                let bigger = addition.union(r);
                this._intervals[i] = bigger;
                // make sure we didn't just create an interval that
                // should be merged with next interval in list
                while(i < this._intervals.length - 1){
                    i++;
                    let next = this._intervals[i];
                    if (!bigger.adjacent(next) && bigger.disjoint(next)) break;
                    // if we bump up against or overlap next, merge
                    // remove this one
                    this._intervals.splice(i, 1);
                    i--;
                    // move backwards to what we just set
                    this._intervals[i] = bigger.union(next);
                // set to 3 merged ones
                }
                // first call to next after previous duplicates the result
                return;
            }
            if (addition.startsBeforeDisjoint(r)) {
                // insert before r
                this._intervals.splice(i, 0, addition);
                return;
            }
        // if disjoint and after r, a future iteration will handle it
        }
        // ok, must be after last interval (and disjoint from last interval)
        // just add it
        this._intervals.push(addition);
    }
    /** combine all sets in the array returned the or'd value */ static or(sets) {
        let r = new $49af21c6dd39b813$var$IntervalSet();
        for (let s of sets)r.addAll(s);
        return r;
    }
    addAll(set) {
        if (set == null) return this;
        if (set instanceof $49af21c6dd39b813$var$IntervalSet) {
            let other = set;
            // walk set and add each interval
            let n = other._intervals.length;
            for(let i = 0; i < n; i++){
                let I = other._intervals[i];
                this.add(I.a, I.b);
            }
        } else for (let value of set.toArray())this.add(value);
        return this;
    }
    complementRange(minElement, maxElement) {
        return this.complement($49af21c6dd39b813$var$IntervalSet.of(minElement, maxElement));
    }
    /** {@inheritDoc} */ complement(vocabulary) {
        if (vocabulary.isNil) // nothing in common with null set
        return $49af21c6dd39b813$var$IntervalSet.EMPTY_SET;
        let vocabularyIS;
        if (vocabulary instanceof $49af21c6dd39b813$var$IntervalSet) vocabularyIS = vocabulary;
        else {
            vocabularyIS = new $49af21c6dd39b813$var$IntervalSet();
            vocabularyIS.addAll(vocabulary);
        }
        return vocabularyIS.subtract(this);
    }
    subtract(a) {
        if (a == null || a.isNil) return new $49af21c6dd39b813$var$IntervalSet(this._intervals);
        if (a instanceof $49af21c6dd39b813$var$IntervalSet) return $49af21c6dd39b813$var$IntervalSet.subtract(this, a);
        let other = new $49af21c6dd39b813$var$IntervalSet();
        other.addAll(a);
        return $49af21c6dd39b813$var$IntervalSet.subtract(this, other);
    }
    /**
     * Compute the set difference between two interval sets. The specific
     * operation is `left - right`.
     */ static subtract(left, right) {
        if (left.isNil) return new $49af21c6dd39b813$var$IntervalSet();
        let result = new $49af21c6dd39b813$var$IntervalSet(left._intervals);
        if (right.isNil) // right set has no elements; just return the copy of the current set
        return result;
        let resultI = 0;
        let rightI = 0;
        while(resultI < result._intervals.length && rightI < right._intervals.length){
            let resultInterval = result._intervals[resultI];
            let rightInterval = right._intervals[rightI];
            // operation: (resultInterval - rightInterval) and update indexes
            if (rightInterval.b < resultInterval.a) {
                rightI++;
                continue;
            }
            if (rightInterval.a > resultInterval.b) {
                resultI++;
                continue;
            }
            let beforeCurrent;
            let afterCurrent;
            if (rightInterval.a > resultInterval.a) beforeCurrent = new $l8y5T.Interval(resultInterval.a, rightInterval.a - 1);
            if (rightInterval.b < resultInterval.b) afterCurrent = new $l8y5T.Interval(rightInterval.b + 1, resultInterval.b);
            if (beforeCurrent) {
                if (afterCurrent) {
                    // split the current interval into two
                    result._intervals[resultI] = beforeCurrent;
                    result._intervals.splice(resultI + 1, 0, afterCurrent);
                    resultI++;
                    rightI++;
                    continue;
                } else {
                    // replace the current interval
                    result._intervals[resultI] = beforeCurrent;
                    resultI++;
                    continue;
                }
            } else if (afterCurrent) {
                // replace the current interval
                result._intervals[resultI] = afterCurrent;
                rightI++;
                continue;
            } else {
                // remove the current interval (thus no need to increment resultI)
                result._intervals.splice(resultI, 1);
                continue;
            }
        }
        // If rightI reached right.intervals.size, no more intervals to subtract from result.
        // If resultI reached result.intervals.size, we would be subtracting from an empty set.
        // Either way, we are done.
        return result;
    }
    or(a) {
        let o = new $49af21c6dd39b813$var$IntervalSet();
        o.addAll(this);
        o.addAll(a);
        return o;
    }
    /** {@inheritDoc} */ and(other) {
        if (other.isNil) // nothing in common with null set
        return new $49af21c6dd39b813$var$IntervalSet();
        let myIntervals = this._intervals;
        let theirIntervals = other._intervals;
        let intersection;
        let mySize = myIntervals.length;
        let theirSize = theirIntervals.length;
        let i = 0;
        let j = 0;
        // iterate down both interval lists looking for nondisjoint intervals
        while(i < mySize && j < theirSize){
            let mine = myIntervals[i];
            let theirs = theirIntervals[j];
            //System.out.println("mine="+mine+" and theirs="+theirs);
            if (mine.startsBeforeDisjoint(theirs)) // move this iterator looking for interval that might overlap
            i++;
            else if (theirs.startsBeforeDisjoint(mine)) // move other iterator looking for interval that might overlap
            j++;
            else if (mine.properlyContains(theirs)) {
                // overlap, add intersection, get next theirs
                if (!intersection) intersection = new $49af21c6dd39b813$var$IntervalSet();
                intersection.addRange(mine.intersection(theirs));
                j++;
            } else if (theirs.properlyContains(mine)) {
                // overlap, add intersection, get next mine
                if (!intersection) intersection = new $49af21c6dd39b813$var$IntervalSet();
                intersection.addRange(mine.intersection(theirs));
                i++;
            } else if (!mine.disjoint(theirs)) {
                // overlap, add intersection
                if (!intersection) intersection = new $49af21c6dd39b813$var$IntervalSet();
                intersection.addRange(mine.intersection(theirs));
                // Move the iterator of lower range [a..b], but not
                // the upper range as it may contain elements that will collide
                // with the next iterator. So, if mine=[0..115] and
                // theirs=[115..200], then intersection is 115 and move mine
                // but not theirs as theirs may collide with the next range
                // in thisIter.
                // move both iterators to next ranges
                if (mine.startsAfterNonDisjoint(theirs)) j++;
                else if (theirs.startsAfterNonDisjoint(mine)) i++;
            }
        }
        if (!intersection) return new $49af21c6dd39b813$var$IntervalSet();
        return intersection;
    }
    /** {@inheritDoc} */ contains(el) {
        let n = this._intervals.length;
        let l = 0;
        let r = n - 1;
        // Binary search for the element in the (sorted, disjoint) array of intervals.
        while(l <= r){
            let m = l + r >> 1;
            let I = this._intervals[m];
            let a = I.a;
            let b = I.b;
            if (b < el) l = m + 1;
            else if (a > el) r = m - 1;
            else // el >= a && el <= b
            return true;
        }
        return false;
    }
    /** {@inheritDoc} */ get isNil() {
        return this._intervals == null || this._intervals.length === 0;
    }
    /**
     * Returns the maximum value contained in the set if not isNil.
     *
     * @return the maximum value contained in the set.
     * @throws RangeError if set is empty
     */ get maxElement() {
        if (this.isNil) throw new RangeError("set is empty");
        let last = this._intervals[this._intervals.length - 1];
        return last.b;
    }
    /**
     * Returns the minimum value contained in the set if not isNil.
     *
     * @return the minimum value contained in the set.
     * @throws RangeError if set is empty
     */ get minElement() {
        if (this.isNil) throw new RangeError("set is empty");
        return this._intervals[0].a;
    }
    /** Return a list of Interval objects. */ get intervals() {
        return this._intervals;
    }
    hashCode() {
        let hash = $amQx9.MurmurHash.initialize();
        for (let I of this._intervals){
            hash = $amQx9.MurmurHash.update(hash, I.a);
            hash = $amQx9.MurmurHash.update(hash, I.b);
        }
        hash = $amQx9.MurmurHash.finish(hash, this._intervals.length * 2);
        return hash;
    }
    /** Are two IntervalSets equal?  Because all intervals are sorted
     *  and disjoint, equals is a simple linear walk over both lists
     *  to make sure they are the same.  Interval.equals() is used
     *  by the List.equals() method to check the ranges.
     */ equals(o) {
        if (o == null || !(o instanceof $49af21c6dd39b813$var$IntervalSet)) return false;
        return $6iIjF.ArrayEqualityComparator.INSTANCE.equals(this._intervals, o._intervals);
    }
    toString(elemAreChar = false) {
        let buf = "";
        if (this._intervals == null || this._intervals.length === 0) return "{}";
        if (this.size > 1) buf += "{";
        let first = true;
        for (let I of this._intervals){
            if (first) first = false;
            else buf += ", ";
            let a = I.a;
            let b = I.b;
            if (a === b) {
                if (a === $eKXi4.Token.EOF) buf += "<EOF>";
                else if (elemAreChar) buf += "'" + String.fromCodePoint(a) + "'";
                else buf += a;
            } else if (elemAreChar) buf += "'" + String.fromCodePoint(a) + "'..'" + String.fromCodePoint(b) + "'";
            else buf += a + ".." + b;
        }
        if (this.size > 1) buf += "}";
        return buf;
    }
    toStringVocabulary(vocabulary) {
        if (this._intervals == null || this._intervals.length === 0) return "{}";
        let buf = "";
        if (this.size > 1) buf += "{";
        let first = true;
        for (let I of this._intervals){
            if (first) first = false;
            else buf += ", ";
            let a = I.a;
            let b = I.b;
            if (a === b) buf += this.elementName(vocabulary, a);
            else for(let i = a; i <= b; i++){
                if (i > a) buf += ", ";
                buf += this.elementName(vocabulary, i);
            }
        }
        if (this.size > 1) buf += "}";
        return buf;
    }
    elementName(vocabulary, a) {
        if (a === $eKXi4.Token.EOF) return "<EOF>";
        else if (a === $eKXi4.Token.EPSILON) return "<EPSILON>";
        else return vocabulary.getDisplayName(a);
    }
    get size() {
        let n = 0;
        let numIntervals = this._intervals.length;
        if (numIntervals === 1) {
            let firstInterval = this._intervals[0];
            return firstInterval.b - firstInterval.a + 1;
        }
        for(let i = 0; i < numIntervals; i++){
            let I = this._intervals[i];
            n += I.b - I.a + 1;
        }
        return n;
    }
    toIntegerList() {
        let values = new $eRSlM.IntegerList(this.size);
        let n = this._intervals.length;
        for(let i = 0; i < n; i++){
            let I = this._intervals[i];
            let a = I.a;
            let b = I.b;
            for(let v = a; v <= b; v++)values.add(v);
        }
        return values;
    }
    toSet() {
        let s = new Set();
        for (let I of this._intervals){
            let a = I.a;
            let b = I.b;
            for(let v = a; v <= b; v++)s.add(v);
        }
        return s;
    }
    toArray() {
        let values = new Array();
        let n = this._intervals.length;
        for(let i = 0; i < n; i++){
            let I = this._intervals[i];
            let a = I.a;
            let b = I.b;
            for(let v = a; v <= b; v++)values.push(v);
        }
        return values;
    }
    remove(el) {
        if (this.readonly) throw new Error("can't alter readonly IntervalSet");
        let n = this._intervals.length;
        for(let i = 0; i < n; i++){
            let I = this._intervals[i];
            let a = I.a;
            let b = I.b;
            if (el < a) break; // list is sorted and el is before this interval; not here
            // if whole interval x..x, rm
            if (el === a && el === b) {
                this._intervals.splice(i, 1);
                break;
            }
            // if on left edge x..b, adjust left
            if (el === a) {
                this._intervals[i] = $l8y5T.Interval.of(I.a + 1, I.b);
                break;
            }
            // if on right edge a..x, adjust right
            if (el === b) {
                this._intervals[i] = $l8y5T.Interval.of(I.a, I.b - 1);
                break;
            }
            // if in middle a..x..b, split interval
            if (el > a && el < b) {
                let oldb = I.b;
                this._intervals[i] = $l8y5T.Interval.of(I.a, el - 1); // [a..x-1]
                this.add(el + 1, oldb); // add [x+1..b]
            }
        }
    }
    get isReadonly() {
        return this.readonly;
    }
    setReadonly(readonly) {
        if (this.readonly && !readonly) throw new Error("can't alter readonly IntervalSet");
        this.readonly = readonly;
    }
}
$49af21c6dd39b813$var$__decorate([
    $aN41m.Override
], $49af21c6dd39b813$var$IntervalSet.prototype, "addAll", null);
$49af21c6dd39b813$var$__decorate([
    $aN41m.Override
], $49af21c6dd39b813$var$IntervalSet.prototype, "complement", null);
$49af21c6dd39b813$var$__decorate([
    $aN41m.Override
], $49af21c6dd39b813$var$IntervalSet.prototype, "subtract", null);
$49af21c6dd39b813$var$__decorate([
    $aN41m.Override
], $49af21c6dd39b813$var$IntervalSet.prototype, "or", null);
$49af21c6dd39b813$var$__decorate([
    $aN41m.Override
], $49af21c6dd39b813$var$IntervalSet.prototype, "and", null);
$49af21c6dd39b813$var$__decorate([
    $aN41m.Override
], $49af21c6dd39b813$var$IntervalSet.prototype, "contains", null);
$49af21c6dd39b813$var$__decorate([
    $aN41m.Override
], $49af21c6dd39b813$var$IntervalSet.prototype, "isNil", null);
$49af21c6dd39b813$var$__decorate([
    $aN41m.Override
], $49af21c6dd39b813$var$IntervalSet.prototype, "hashCode", null);
$49af21c6dd39b813$var$__decorate([
    $aN41m.Override
], $49af21c6dd39b813$var$IntervalSet.prototype, "equals", null);
$49af21c6dd39b813$var$__decorate([
    $49af21c6dd39b813$var$__param(0, $aN41m.NotNull)
], $49af21c6dd39b813$var$IntervalSet.prototype, "toStringVocabulary", null);
$49af21c6dd39b813$var$__decorate([
    $aN41m.NotNull,
    $49af21c6dd39b813$var$__param(0, $aN41m.NotNull)
], $49af21c6dd39b813$var$IntervalSet.prototype, "elementName", null);
$49af21c6dd39b813$var$__decorate([
    $aN41m.Override
], $49af21c6dd39b813$var$IntervalSet.prototype, "size", null);
$49af21c6dd39b813$var$__decorate([
    $aN41m.Override
], $49af21c6dd39b813$var$IntervalSet.prototype, "remove", null);
$49af21c6dd39b813$var$__decorate([
    $aN41m.NotNull
], $49af21c6dd39b813$var$IntervalSet, "of", null);
$49af21c6dd39b813$var$__decorate([
    $aN41m.NotNull
], $49af21c6dd39b813$var$IntervalSet, "subtract", null);
module.exports.IntervalSet = $49af21c6dd39b813$var$IntervalSet;

});
parcelRegister("eRSlM", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $ad302cc069821a02$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntegerList = void 0;

var $4dKou = parcelRequire("4dKou");

var $aN41m = parcelRequire("aN41m");
const $ad302cc069821a02$var$EMPTY_DATA = new Int32Array(0);
const $ad302cc069821a02$var$INITIAL_SIZE = 4;
const $ad302cc069821a02$var$MAX_ARRAY_SIZE = 2147483639;
/**
 *
 * @author Sam Harwell
 */ class $ad302cc069821a02$var$IntegerList {
    constructor(arg){
        if (!arg) {
            this._data = $ad302cc069821a02$var$EMPTY_DATA;
            this._size = 0;
        } else if (arg instanceof $ad302cc069821a02$var$IntegerList) {
            this._data = arg._data.slice(0);
            this._size = arg._size;
        } else if (typeof arg === "number") {
            if (arg === 0) {
                this._data = $ad302cc069821a02$var$EMPTY_DATA;
                this._size = 0;
            } else {
                this._data = new Int32Array(arg);
                this._size = 0;
            }
        } else {
            // arg is Iterable<number>
            this._data = $ad302cc069821a02$var$EMPTY_DATA;
            this._size = 0;
            for (let value of arg)this.add(value);
        }
    }
    add(value) {
        if (this._data.length === this._size) this.ensureCapacity(this._size + 1);
        this._data[this._size] = value;
        this._size++;
    }
    addAll(list) {
        if (Array.isArray(list)) {
            this.ensureCapacity(this._size + list.length);
            this._data.subarray(this._size, this._size + list.length).set(list);
            this._size += list.length;
        } else if (list instanceof $ad302cc069821a02$var$IntegerList) {
            this.ensureCapacity(this._size + list._size);
            this._data.subarray(this._size, this._size + list.size).set(list._data);
            this._size += list._size;
        } else {
            // list is JavaCollection<number>
            this.ensureCapacity(this._size + list.size);
            let current = 0;
            for (let xi of list){
                this._data[this._size + current] = xi;
                current++;
            }
            this._size += list.size;
        }
    }
    get(index) {
        if (index < 0 || index >= this._size) throw RangeError();
        return this._data[index];
    }
    contains(value) {
        for(let i = 0; i < this._size; i++){
            if (this._data[i] === value) return true;
        }
        return false;
    }
    set(index, value) {
        if (index < 0 || index >= this._size) throw RangeError();
        let previous = this._data[index];
        this._data[index] = value;
        return previous;
    }
    removeAt(index) {
        let value = this.get(index);
        this._data.copyWithin(index, index + 1, this._size);
        this._data[this._size - 1] = 0;
        this._size--;
        return value;
    }
    removeRange(fromIndex, toIndex) {
        if (fromIndex < 0 || toIndex < 0 || fromIndex > this._size || toIndex > this._size) throw RangeError();
        if (fromIndex > toIndex) throw RangeError();
        this._data.copyWithin(toIndex, fromIndex, this._size);
        this._data.fill(0, this._size - (toIndex - fromIndex), this._size);
        this._size -= toIndex - fromIndex;
    }
    get isEmpty() {
        return this._size === 0;
    }
    get size() {
        return this._size;
    }
    trimToSize() {
        if (this._data.length === this._size) return;
        this._data = this._data.slice(0, this._size);
    }
    clear() {
        this._data.fill(0, 0, this._size);
        this._size = 0;
    }
    toArray() {
        if (this._size === 0) return [];
        return Array.from(this._data.subarray(0, this._size));
    }
    sort() {
        this._data.subarray(0, this._size).sort();
    }
    /**
     * Compares the specified object with this list for equality.  Returns
     * `true` if and only if the specified object is also an {@link IntegerList},
     * both lists have the same size, and all corresponding pairs of elements in
     * the two lists are equal.  In other words, two lists are defined to be
     * equal if they contain the same elements in the same order.
     *
     * This implementation first checks if the specified object is this
     * list. If so, it returns `true`; if not, it checks if the
     * specified object is an {@link IntegerList}. If not, it returns `false`;
     * if so, it checks the size of both lists. If the lists are not the same size,
     * it returns `false`; otherwise it iterates over both lists, comparing
     * corresponding pairs of elements.  If any comparison returns `false`,
     * this method returns `false`.
     *
     * @param o the object to be compared for equality with this list
     * @returns `true` if the specified object is equal to this list
     */ equals(o) {
        if (o === this) return true;
        if (!(o instanceof $ad302cc069821a02$var$IntegerList)) return false;
        if (this._size !== o._size) return false;
        for(let i = 0; i < this._size; i++){
            if (this._data[i] !== o._data[i]) return false;
        }
        return true;
    }
    /**
     * Returns the hash code value for this list.
     *
     * This implementation uses exactly the code that is used to define the
     * list hash function in the documentation for the {@link List#hashCode}
     * method.
     *
     * @returns the hash code value for this list
     */ hashCode() {
        let hashCode = 1;
        for(let i = 0; i < this._size; i++)hashCode = 31 * hashCode + this._data[i];
        return hashCode;
    }
    /**
     * Returns a string representation of this list.
     */ toString() {
        return this._data.toString();
    }
    binarySearch(key, fromIndex, toIndex) {
        if (fromIndex === undefined) fromIndex = 0;
        if (toIndex === undefined) toIndex = this._size;
        if (fromIndex < 0 || toIndex < 0 || fromIndex > this._size || toIndex > this._size) throw new RangeError();
        if (fromIndex > toIndex) throw new RangeError();
        return $4dKou.Arrays.binarySearch(this._data, key, fromIndex, toIndex);
    }
    ensureCapacity(capacity) {
        if (capacity < 0 || capacity > $ad302cc069821a02$var$MAX_ARRAY_SIZE) throw new RangeError();
        let newLength;
        if (this._data.length === 0) newLength = $ad302cc069821a02$var$INITIAL_SIZE;
        else newLength = this._data.length;
        while(newLength < capacity){
            newLength = newLength * 2;
            if (newLength < 0 || newLength > $ad302cc069821a02$var$MAX_ARRAY_SIZE) newLength = $ad302cc069821a02$var$MAX_ARRAY_SIZE;
        }
        let tmp = new Int32Array(newLength);
        tmp.set(this._data);
        this._data = tmp;
    }
    /** Convert the list to a UTF-16 encoded char array. If all values are less
     *  than the 0xFFFF 16-bit code point limit then this is just a char array
     *  of 16-bit char as usual. For values in the supplementary range, encode
     * them as two UTF-16 code units.
     */ toCharArray() {
        // Optimize for the common case (all data values are < 0xFFFF) to avoid an extra scan
        let resultArray = new Uint16Array(this._size);
        let resultIdx = 0;
        let calculatedPreciseResultSize = false;
        for(let i = 0; i < this._size; i++){
            let codePoint = this._data[i];
            if (codePoint >= 0 && codePoint < 0x10000) {
                resultArray[resultIdx] = codePoint;
                resultIdx++;
                continue;
            }
            // Calculate the precise result size if we encounter a code point > 0xFFFF
            if (!calculatedPreciseResultSize) {
                let newResultArray = new Uint16Array(this.charArraySize());
                newResultArray.set(resultArray, 0);
                resultArray = newResultArray;
                calculatedPreciseResultSize = true;
            }
            // This will throw RangeError if the code point is not a valid Unicode code point
            let pair = String.fromCodePoint(codePoint);
            resultArray[resultIdx] = pair.charCodeAt(0);
            resultArray[resultIdx + 1] = pair.charCodeAt(1);
            resultIdx += 2;
        }
        return resultArray;
    }
    charArraySize() {
        let result = 0;
        for(let i = 0; i < this._size; i++)result += this._data[i] >= 0x10000 ? 2 : 1;
        return result;
    }
}
$ad302cc069821a02$var$__decorate([
    $aN41m.NotNull
], $ad302cc069821a02$var$IntegerList.prototype, "_data", void 0);
$ad302cc069821a02$var$__decorate([
    $aN41m.Override
], $ad302cc069821a02$var$IntegerList.prototype, "equals", null);
$ad302cc069821a02$var$__decorate([
    $aN41m.Override
], $ad302cc069821a02$var$IntegerList.prototype, "hashCode", null);
$ad302cc069821a02$var$__decorate([
    $aN41m.Override
], $ad302cc069821a02$var$IntegerList.prototype, "toString", null);
module.exports.IntegerList = $ad302cc069821a02$var$IntegerList;

});
parcelRegister("4dKou", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Arrays = void 0;
var $312c5d30775d92ef$var$Arrays;
(function(Arrays) {
    /**
     * Searches the specified array of numbers for the specified value using the binary search algorithm. The array must
     * be sorted prior to making this call. If it is not sorted, the results are unspecified. If the array contains
     * multiple elements with the specified value, there is no guarantee which one will be found.
     *
     * @returns index of the search key, if it is contained in the array; otherwise, (-(insertion point) - 1). The
     * insertion point is defined as the point at which the key would be inserted into the array: the index of the first
     * element greater than the key, or array.length if all elements in the array are less than the specified key. Note
     * that this guarantees that the return value will be >= 0 if and only if the key is found.
     */ function binarySearch(array, key, fromIndex, toIndex) {
        return binarySearch0(array, fromIndex !== undefined ? fromIndex : 0, toIndex !== undefined ? toIndex : array.length, key);
    }
    Arrays.binarySearch = binarySearch;
    function binarySearch0(array, fromIndex, toIndex, key) {
        let low = fromIndex;
        let high = toIndex - 1;
        while(low <= high){
            let mid = low + high >>> 1;
            let midVal = array[mid];
            if (midVal < key) low = mid + 1;
            else if (midVal > key) high = mid - 1;
            else // key found
            return mid;
        }
        // key not found.
        return -(low + 1);
    }
    function toString(array) {
        let result = "[";
        let first = true;
        for (let element of array){
            if (first) first = false;
            else result += ", ";
            if (element === null) result += "null";
            else if (element === undefined) result += "undefined";
            else result += element;
        }
        result += "]";
        return result;
    }
    Arrays.toString = toString;
})($312c5d30775d92ef$var$Arrays = module.exports.Arrays || (module.exports.Arrays = {}));

});


parcelRegister("l8y5T", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f634cab1d0696c5f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Interval = void 0;

var $aN41m = parcelRequire("aN41m");
const $f634cab1d0696c5f$var$INTERVAL_POOL_MAX_VALUE = 1000;
/** An immutable inclusive interval a..b */ class $f634cab1d0696c5f$var$Interval {
    /**
     * @param a The start of the interval
     * @param b The end of the interval (inclusive)
     */ constructor(a, b){
        this.a = a;
        this.b = b;
    }
    static get INVALID() {
        return $f634cab1d0696c5f$var$Interval._INVALID;
    }
    /** Interval objects are used readonly so share all with the
     *  same single value a==b up to some max size.  Use an array as a perfect hash.
     *  Return shared object for 0..INTERVAL_POOL_MAX_VALUE or a new
     *  Interval object with a..a in it.  On Java.g4, 218623 IntervalSets
     *  have a..a (set with 1 element).
     */ static of(a, b) {
        // cache just a..a
        if (a !== b || a < 0 || a > $f634cab1d0696c5f$var$INTERVAL_POOL_MAX_VALUE) return new $f634cab1d0696c5f$var$Interval(a, b);
        if ($f634cab1d0696c5f$var$Interval.cache[a] == null) $f634cab1d0696c5f$var$Interval.cache[a] = new $f634cab1d0696c5f$var$Interval(a, a);
        return $f634cab1d0696c5f$var$Interval.cache[a];
    }
    /** return number of elements between a and b inclusively. x..x is length 1.
     *  if b &lt; a, then length is 0.  9..10 has length 2.
     */ get length() {
        if (this.b < this.a) return 0;
        return this.b - this.a + 1;
    }
    equals(o) {
        if (o === this) return true;
        else if (!(o instanceof $f634cab1d0696c5f$var$Interval)) return false;
        return this.a === o.a && this.b === o.b;
    }
    hashCode() {
        let hash = 23;
        hash = hash * 31 + this.a;
        hash = hash * 31 + this.b;
        return hash;
    }
    /** Does this start completely before other? Disjoint */ startsBeforeDisjoint(other) {
        return this.a < other.a && this.b < other.a;
    }
    /** Does this start at or before other? Nondisjoint */ startsBeforeNonDisjoint(other) {
        return this.a <= other.a && this.b >= other.a;
    }
    /** Does this.a start after other.b? May or may not be disjoint */ startsAfter(other) {
        return this.a > other.a;
    }
    /** Does this start completely after other? Disjoint */ startsAfterDisjoint(other) {
        return this.a > other.b;
    }
    /** Does this start after other? NonDisjoint */ startsAfterNonDisjoint(other) {
        return this.a > other.a && this.a <= other.b; // this.b>=other.b implied
    }
    /** Are both ranges disjoint? I.e., no overlap? */ disjoint(other) {
        return this.startsBeforeDisjoint(other) || this.startsAfterDisjoint(other);
    }
    /** Are two intervals adjacent such as 0..41 and 42..42? */ adjacent(other) {
        return this.a === other.b + 1 || this.b === other.a - 1;
    }
    properlyContains(other) {
        return other.a >= this.a && other.b <= this.b;
    }
    /** Return the interval computed from combining this and other */ union(other) {
        return $f634cab1d0696c5f$var$Interval.of(Math.min(this.a, other.a), Math.max(this.b, other.b));
    }
    /** Return the interval in common between this and o */ intersection(other) {
        return $f634cab1d0696c5f$var$Interval.of(Math.max(this.a, other.a), Math.min(this.b, other.b));
    }
    /** Return the interval with elements from `this` not in `other`;
     *  `other` must not be totally enclosed (properly contained)
     *  within `this`, which would result in two disjoint intervals
     *  instead of the single one returned by this method.
     */ differenceNotProperlyContained(other) {
        let diff;
        if (other.startsBeforeNonDisjoint(this)) // other.a to left of this.a (or same)
        diff = $f634cab1d0696c5f$var$Interval.of(Math.max(this.a, other.b + 1), this.b);
        else if (other.startsAfterNonDisjoint(this)) // other.a to right of this.a
        diff = $f634cab1d0696c5f$var$Interval.of(this.a, other.a - 1);
        return diff;
    }
    toString() {
        return this.a + ".." + this.b;
    }
}
$f634cab1d0696c5f$var$Interval._INVALID = new $f634cab1d0696c5f$var$Interval(-1, -2);
$f634cab1d0696c5f$var$Interval.cache = new Array($f634cab1d0696c5f$var$INTERVAL_POOL_MAX_VALUE + 1);
$f634cab1d0696c5f$var$__decorate([
    $aN41m.Override
], $f634cab1d0696c5f$var$Interval.prototype, "equals", null);
$f634cab1d0696c5f$var$__decorate([
    $aN41m.Override
], $f634cab1d0696c5f$var$Interval.prototype, "hashCode", null);
$f634cab1d0696c5f$var$__decorate([
    $aN41m.Override
], $f634cab1d0696c5f$var$Interval.prototype, "toString", null);
module.exports.Interval = $f634cab1d0696c5f$var$Interval;

});

parcelRegister("h7Q3L", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c77b7912a6658aa1$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Lexer = void 0;

var $9hrXh = parcelRequire("9hrXh");

var $jB0DW = parcelRequire("jB0DW");

var $l8y5T = parcelRequire("l8y5T");

var $ldi9e = parcelRequire("ldi9e");

var $2160U = parcelRequire("2160U");

var $l3IpB = parcelRequire("l3IpB");

var $aN41m = parcelRequire("aN41m");

var $dwftT = parcelRequire("dwftT");

var $eKXi4 = parcelRequire("eKXi4");
/** A lexer is recognizer that draws input symbols from a character stream.
 *  lexer grammars result in a subclass of this object. A Lexer object
 *  uses simplified match() and error recovery mechanisms in the interest
 *  of speed.
 */ class $c77b7912a6658aa1$var$Lexer extends $dwftT.Recognizer {
    constructor(input){
        super();
        /** How to create token objects */ this._factory = $9hrXh.CommonTokenFactory.DEFAULT;
        /** What character index in the stream did the current token start at?
         *  Needed, for example, to get the text for current token.  Set at
         *  the start of nextToken.
         */ this._tokenStartCharIndex = -1;
        /** The line on which the first character of the token resides */ this._tokenStartLine = 0;
        /** The character position of first character within the line */ this._tokenStartCharPositionInLine = 0;
        /** Once we see EOF on char stream, next token will be EOF.
         *  If you have DONE : EOF ; then you see DONE EOF.
         */ this._hitEOF = false;
        /** The channel number for the current token */ this._channel = 0;
        /** The token type for the current token */ this._type = 0;
        this._modeStack = new $jB0DW.IntegerStack();
        this._mode = $c77b7912a6658aa1$var$Lexer.DEFAULT_MODE;
        this._input = input;
        this._tokenFactorySourcePair = {
            source: this,
            stream: input
        };
    }
    static get DEFAULT_TOKEN_CHANNEL() {
        return $eKXi4.Token.DEFAULT_CHANNEL;
    }
    static get HIDDEN() {
        return $eKXi4.Token.HIDDEN_CHANNEL;
    }
    reset(resetInput) {
        // wack Lexer state variables
        if (resetInput === undefined || resetInput) this._input.seek(0); // rewind the input
        this._token = undefined;
        this._type = $eKXi4.Token.INVALID_TYPE;
        this._channel = $eKXi4.Token.DEFAULT_CHANNEL;
        this._tokenStartCharIndex = -1;
        this._tokenStartCharPositionInLine = -1;
        this._tokenStartLine = -1;
        this._text = undefined;
        this._hitEOF = false;
        this._mode = $c77b7912a6658aa1$var$Lexer.DEFAULT_MODE;
        this._modeStack.clear();
        this.interpreter.reset();
    }
    /** Return a token from this source; i.e., match a token on the char
     *  stream.
     */ nextToken() {
        if (this._input == null) throw new Error("nextToken requires a non-null input stream.");
        // Mark start location in char stream so unbuffered streams are
        // guaranteed at least have text of current token
        let tokenStartMarker = this._input.mark();
        try {
            outer: while(true){
                if (this._hitEOF) return this.emitEOF();
                this._token = undefined;
                this._channel = $eKXi4.Token.DEFAULT_CHANNEL;
                this._tokenStartCharIndex = this._input.index;
                this._tokenStartCharPositionInLine = this.interpreter.charPositionInLine;
                this._tokenStartLine = this.interpreter.line;
                this._text = undefined;
                do {
                    this._type = $eKXi4.Token.INVALID_TYPE;
                    //				System.out.println("nextToken line "+tokenStartLine+" at "+((char)input.LA(1))+
                    //								   " in mode "+mode+
                    //								   " at index "+input.index);
                    let ttype;
                    try {
                        ttype = this.interpreter.match(this._input, this._mode);
                    } catch (e) {
                        if (e instanceof $l3IpB.LexerNoViableAltException) {
                            this.notifyListeners(e); // report error
                            this.recover(e);
                            ttype = $c77b7912a6658aa1$var$Lexer.SKIP;
                        } else throw e;
                    }
                    if (this._input.LA(1) === $ldi9e.IntStream.EOF) this._hitEOF = true;
                    if (this._type === $eKXi4.Token.INVALID_TYPE) this._type = ttype;
                    if (this._type === $c77b7912a6658aa1$var$Lexer.SKIP) continue outer;
                }while (this._type === $c77b7912a6658aa1$var$Lexer.MORE);
                if (this._token == null) return this.emit();
                return this._token;
            }
        } finally{
            // make sure we release marker after match or
            // unbuffered char stream will keep buffering
            this._input.release(tokenStartMarker);
        }
    }
    /** Instruct the lexer to skip creating a token for current lexer rule
     *  and look for another token.  nextToken() knows to keep looking when
     *  a lexer rule finishes with token set to SKIP_TOKEN.  Recall that
     *  if token==undefined at end of any token rule, it creates one for you
     *  and emits it.
     */ skip() {
        this._type = $c77b7912a6658aa1$var$Lexer.SKIP;
    }
    more() {
        this._type = $c77b7912a6658aa1$var$Lexer.MORE;
    }
    mode(m) {
        this._mode = m;
    }
    pushMode(m) {
        if ($2160U.LexerATNSimulator.debug) console.log("pushMode " + m);
        this._modeStack.push(this._mode);
        this.mode(m);
    }
    popMode() {
        if (this._modeStack.isEmpty) throw new Error("EmptyStackException");
        if ($2160U.LexerATNSimulator.debug) console.log("popMode back to " + this._modeStack.peek());
        this.mode(this._modeStack.pop());
        return this._mode;
    }
    get tokenFactory() {
        return this._factory;
    }
    // @Override
    set tokenFactory(factory) {
        this._factory = factory;
    }
    get inputStream() {
        return this._input;
    }
    /** Set the char stream and reset the lexer */ set inputStream(input) {
        this.reset(false);
        this._input = input;
        this._tokenFactorySourcePair = {
            source: this,
            stream: this._input
        };
    }
    get sourceName() {
        return this._input.sourceName;
    }
    emit(token) {
        if (!token) token = this._factory.create(this._tokenFactorySourcePair, this._type, this._text, this._channel, this._tokenStartCharIndex, this.charIndex - 1, this._tokenStartLine, this._tokenStartCharPositionInLine);
        this._token = token;
        return token;
    }
    emitEOF() {
        let cpos = this.charPositionInLine;
        let line = this.line;
        let eof = this._factory.create(this._tokenFactorySourcePair, $eKXi4.Token.EOF, undefined, $eKXi4.Token.DEFAULT_CHANNEL, this._input.index, this._input.index - 1, line, cpos);
        this.emit(eof);
        return eof;
    }
    get line() {
        return this.interpreter.line;
    }
    set line(line) {
        this.interpreter.line = line;
    }
    get charPositionInLine() {
        return this.interpreter.charPositionInLine;
    }
    set charPositionInLine(charPositionInLine) {
        this.interpreter.charPositionInLine = charPositionInLine;
    }
    /** What is the index of the current character of lookahead? */ get charIndex() {
        return this._input.index;
    }
    /** Return the text matched so far for the current token or any
     *  text override.
     */ get text() {
        if (this._text != null) return this._text;
        return this.interpreter.getText(this._input);
    }
    /** Set the complete text of this token; it wipes any previous
     *  changes to the text.
     */ set text(text) {
        this._text = text;
    }
    /** Override if emitting multiple tokens. */ get token() {
        return this._token;
    }
    set token(_token) {
        this._token = _token;
    }
    set type(ttype) {
        this._type = ttype;
    }
    get type() {
        return this._type;
    }
    set channel(channel) {
        this._channel = channel;
    }
    get channel() {
        return this._channel;
    }
    /** Return a list of all Token objects in input char stream.
     *  Forces load of all tokens. Does not include EOF token.
     */ getAllTokens() {
        let tokens = [];
        let t = this.nextToken();
        while(t.type !== $eKXi4.Token.EOF){
            tokens.push(t);
            t = this.nextToken();
        }
        return tokens;
    }
    notifyListeners(e) {
        let text = this._input.getText($l8y5T.Interval.of(this._tokenStartCharIndex, this._input.index));
        let msg = "token recognition error at: '" + this.getErrorDisplay(text) + "'";
        let listener = this.getErrorListenerDispatch();
        if (listener.syntaxError) listener.syntaxError(this, undefined, this._tokenStartLine, this._tokenStartCharPositionInLine, msg, e);
    }
    getErrorDisplay(s) {
        if (typeof s === "number") {
            switch(s){
                case $eKXi4.Token.EOF:
                    return "<EOF>";
                case 0x0a:
                    return "\\n";
                case 0x09:
                    return "\\t";
                case 0x0d:
                    return "\\r";
            }
            return String.fromCharCode(s);
        }
        return s.replace(/\n/g, "\\n").replace(/\t/g, "\\t").replace(/\r/g, "\\r");
    }
    getCharErrorDisplay(c) {
        let s = this.getErrorDisplay(c);
        return "'" + s + "'";
    }
    recover(re) {
        if (re instanceof $l3IpB.LexerNoViableAltException) {
            if (this._input.LA(1) !== $ldi9e.IntStream.EOF) // skip a char and try again
            this.interpreter.consume(this._input);
        } else //System.out.println("consuming char "+(char)input.LA(1)+" during recovery");
        //re.printStackTrace();
        // TODO: Do we lose character or line position information?
        this._input.consume();
    }
}
$c77b7912a6658aa1$var$Lexer.DEFAULT_MODE = 0;
$c77b7912a6658aa1$var$Lexer.MORE = -2;
$c77b7912a6658aa1$var$Lexer.SKIP = -3;
$c77b7912a6658aa1$var$Lexer.MIN_CHAR_VALUE = 0x0000;
$c77b7912a6658aa1$var$Lexer.MAX_CHAR_VALUE = 0x10FFFF;
$c77b7912a6658aa1$var$__decorate([
    $aN41m.Override
], $c77b7912a6658aa1$var$Lexer.prototype, "nextToken", null);
$c77b7912a6658aa1$var$__decorate([
    $aN41m.Override
], $c77b7912a6658aa1$var$Lexer.prototype, "tokenFactory", null);
$c77b7912a6658aa1$var$__decorate([
    $aN41m.Override
], $c77b7912a6658aa1$var$Lexer.prototype, "inputStream", null);
$c77b7912a6658aa1$var$__decorate([
    $aN41m.Override
], $c77b7912a6658aa1$var$Lexer.prototype, "sourceName", null);
$c77b7912a6658aa1$var$__decorate([
    $aN41m.Override
], $c77b7912a6658aa1$var$Lexer.prototype, "line", null);
$c77b7912a6658aa1$var$__decorate([
    $aN41m.Override
], $c77b7912a6658aa1$var$Lexer.prototype, "charPositionInLine", null);
module.exports.Lexer = $c77b7912a6658aa1$var$Lexer;

});
parcelRegister("9hrXh", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $6c1b62e47790a82a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommonTokenFactory = void 0;

var $exlin = parcelRequire("exlin");

var $l8y5T = parcelRequire("l8y5T");

var $aN41m = parcelRequire("aN41m");
/**
 * This default implementation of {@link TokenFactory} creates
 * {@link CommonToken} objects.
 */ class $6c1b62e47790a82a$var$CommonTokenFactory {
    /**
     * Constructs a {@link CommonTokenFactory} with the specified value for
     * {@link #copyText}.
     *
     * When `copyText` is `false`, the {@link #DEFAULT} instance
     * should be used instead of constructing a new instance.
     *
     * @param copyText The value for {@link #copyText}.
     */ constructor(copyText = false){
        this.copyText = copyText;
    }
    create(source, type, text, channel, start, stop, line, charPositionInLine) {
        let t = new $exlin.CommonToken(type, text, source, channel, start, stop);
        t.line = line;
        t.charPositionInLine = charPositionInLine;
        if (text == null && this.copyText && source.stream != null) t.text = source.stream.getText($l8y5T.Interval.of(start, stop));
        return t;
    }
    createSimple(type, text) {
        return new $exlin.CommonToken(type, text);
    }
}
$6c1b62e47790a82a$var$__decorate([
    $aN41m.Override
], $6c1b62e47790a82a$var$CommonTokenFactory.prototype, "create", null);
$6c1b62e47790a82a$var$__decorate([
    $aN41m.Override
], $6c1b62e47790a82a$var$CommonTokenFactory.prototype, "createSimple", null);
module.exports.CommonTokenFactory = $6c1b62e47790a82a$var$CommonTokenFactory;
(function(CommonTokenFactory) {
    /**
     * The default {@link CommonTokenFactory} instance.
     *
     * This token factory does not explicitly copy token text when constructing
     * tokens.
     */ CommonTokenFactory.DEFAULT = new CommonTokenFactory();
})($6c1b62e47790a82a$var$CommonTokenFactory = module.exports.CommonTokenFactory || (module.exports.CommonTokenFactory = {}));

});
parcelRegister("exlin", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a954aa91d3b92162$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a954aa91d3b92162$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommonToken = void 0;

var $l8y5T = parcelRequire("l8y5T");

var $aN41m = parcelRequire("aN41m");

var $eKXi4 = parcelRequire("eKXi4");
let $a954aa91d3b92162$var$CommonToken = class CommonToken {
    constructor(type, text, source = CommonToken.EMPTY_SOURCE, channel = $eKXi4.Token.DEFAULT_CHANNEL, start = 0, stop = 0){
        /**
         * This is the backing field for {@link #getLine} and {@link #setLine}.
         */ this._line = 0;
        /**
         * This is the backing field for {@link #getCharPositionInLine} and
         * {@link #setCharPositionInLine}.
         */ this._charPositionInLine = -1; // set to invalid position
        /**
         * This is the backing field for {@link #getChannel} and
         * {@link #setChannel}.
         */ this._channel = $eKXi4.Token.DEFAULT_CHANNEL;
        /**
         * This is the backing field for `tokenIndex`.
         */ this.index = -1;
        this._text = text;
        this._type = type;
        this.source = source;
        this._channel = channel;
        this.start = start;
        this.stop = stop;
        if (source.source != null) {
            this._line = source.source.line;
            this._charPositionInLine = source.source.charPositionInLine;
        }
    }
    /**
     * Constructs a new {@link CommonToken} as a copy of another {@link Token}.
     *
     * If `oldToken` is also a {@link CommonToken} instance, the newly
     * constructed token will share a reference to the {@link #text} field and
     * the {@link Tuple2} stored in {@link #source}. Otherwise, {@link #text} will
     * be assigned the result of calling {@link #getText}, and {@link #source}
     * will be constructed from the result of {@link Token#getTokenSource} and
     * {@link Token#getInputStream}.
     *
     * @param oldToken The token to copy.
     */ static fromToken(oldToken) {
        let result = new CommonToken(oldToken.type, undefined, CommonToken.EMPTY_SOURCE, oldToken.channel, oldToken.startIndex, oldToken.stopIndex);
        result._line = oldToken.line;
        result.index = oldToken.tokenIndex;
        result._charPositionInLine = oldToken.charPositionInLine;
        if (oldToken instanceof CommonToken) {
            result._text = oldToken._text;
            result.source = oldToken.source;
        } else {
            result._text = oldToken.text;
            result.source = {
                source: oldToken.tokenSource,
                stream: oldToken.inputStream
            };
        }
        return result;
    }
    get type() {
        return this._type;
    }
    // @Override
    set type(type) {
        this._type = type;
    }
    get line() {
        return this._line;
    }
    // @Override
    set line(line) {
        this._line = line;
    }
    get text() {
        if (this._text != null) return this._text;
        let input = this.inputStream;
        if (input == null) return undefined;
        let n = input.size;
        if (this.start < n && this.stop < n) return input.getText($l8y5T.Interval.of(this.start, this.stop));
        else return "<EOF>";
    }
    /**
     * Explicitly set the text for this token. If {code text} is not
     * `undefined`, then {@link #getText} will return this value rather than
     * extracting the text from the input.
     *
     * @param text The explicit text of the token, or `undefined` if the text
     * should be obtained from the input along with the start and stop indexes
     * of the token.
     */ // @Override
    set text(text) {
        this._text = text;
    }
    get charPositionInLine() {
        return this._charPositionInLine;
    }
    // @Override
    set charPositionInLine(charPositionInLine) {
        this._charPositionInLine = charPositionInLine;
    }
    get channel() {
        return this._channel;
    }
    // @Override
    set channel(channel) {
        this._channel = channel;
    }
    get startIndex() {
        return this.start;
    }
    set startIndex(start) {
        this.start = start;
    }
    get stopIndex() {
        return this.stop;
    }
    set stopIndex(stop) {
        this.stop = stop;
    }
    get tokenIndex() {
        return this.index;
    }
    // @Override
    set tokenIndex(index) {
        this.index = index;
    }
    get tokenSource() {
        return this.source.source;
    }
    get inputStream() {
        return this.source.stream;
    }
    toString(recognizer) {
        let channelStr = "";
        if (this._channel > 0) channelStr = ",channel=" + this._channel;
        let txt = this.text;
        if (txt != null) {
            txt = txt.replace(/\n/g, "\\n");
            txt = txt.replace(/\r/g, "\\r");
            txt = txt.replace(/\t/g, "\\t");
        } else txt = "<no text>";
        let typeString = String(this._type);
        if (recognizer) typeString = recognizer.vocabulary.getDisplayName(this._type);
        return "[@" + this.tokenIndex + "," + this.start + ":" + this.stop + "='" + txt + "',<" + typeString + ">" + channelStr + "," + this._line + ":" + this.charPositionInLine + "]";
    }
};
/**
 * An empty {@link Tuple2} which is used as the default value of
 * {@link #source} for tokens that do not have a source.
 */ $a954aa91d3b92162$var$CommonToken.EMPTY_SOURCE = {
    source: undefined,
    stream: undefined
};
$a954aa91d3b92162$var$__decorate([
    $aN41m.NotNull
], $a954aa91d3b92162$var$CommonToken.prototype, "source", void 0);
$a954aa91d3b92162$var$__decorate([
    $aN41m.Override
], $a954aa91d3b92162$var$CommonToken.prototype, "type", null);
$a954aa91d3b92162$var$__decorate([
    $aN41m.Override
], $a954aa91d3b92162$var$CommonToken.prototype, "line", null);
$a954aa91d3b92162$var$__decorate([
    $aN41m.Override
], $a954aa91d3b92162$var$CommonToken.prototype, "text", null);
$a954aa91d3b92162$var$__decorate([
    $aN41m.Override
], $a954aa91d3b92162$var$CommonToken.prototype, "charPositionInLine", null);
$a954aa91d3b92162$var$__decorate([
    $aN41m.Override
], $a954aa91d3b92162$var$CommonToken.prototype, "channel", null);
$a954aa91d3b92162$var$__decorate([
    $aN41m.Override
], $a954aa91d3b92162$var$CommonToken.prototype, "startIndex", null);
$a954aa91d3b92162$var$__decorate([
    $aN41m.Override
], $a954aa91d3b92162$var$CommonToken.prototype, "stopIndex", null);
$a954aa91d3b92162$var$__decorate([
    $aN41m.Override
], $a954aa91d3b92162$var$CommonToken.prototype, "tokenIndex", null);
$a954aa91d3b92162$var$__decorate([
    $aN41m.Override
], $a954aa91d3b92162$var$CommonToken.prototype, "tokenSource", null);
$a954aa91d3b92162$var$__decorate([
    $aN41m.Override
], $a954aa91d3b92162$var$CommonToken.prototype, "inputStream", null);
$a954aa91d3b92162$var$__decorate([
    $aN41m.Override
], $a954aa91d3b92162$var$CommonToken.prototype, "toString", null);
$a954aa91d3b92162$var$__decorate([
    $a954aa91d3b92162$var$__param(0, $aN41m.NotNull)
], $a954aa91d3b92162$var$CommonToken, "fromToken", null);
$a954aa91d3b92162$var$CommonToken = $a954aa91d3b92162$var$__decorate([
    $a954aa91d3b92162$var$__param(2, $aN41m.NotNull)
], $a954aa91d3b92162$var$CommonToken);
module.exports.CommonToken = $a954aa91d3b92162$var$CommonToken;

});
parcelRegister("eKXi4", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Token = void 0;

var $ldi9e = parcelRequire("ldi9e");
var $abe35a6f47a957ff$var$Token;
(function(Token) {
    Token.INVALID_TYPE = 0;
    /** During lookahead operations, this "token" signifies we hit rule end ATN state
     *  and did not follow it despite needing to.
     */ Token.EPSILON = -2;
    Token.MIN_USER_TOKEN_TYPE = 1;
    Token.EOF = $ldi9e.IntStream.EOF;
    /** All tokens go to the parser (unless skip() is called in that rule)
     *  on a particular "channel".  The parser tunes to a particular channel
     *  so that whitespace etc... can go to the parser on a "hidden" channel.
     */ Token.DEFAULT_CHANNEL = 0;
    /** Anything on different channel than DEFAULT_CHANNEL is not parsed
     *  by parser.
     */ Token.HIDDEN_CHANNEL = 1;
    /**
     * This is the minimum constant value which can be assigned to a
     * user-defined token channel.
     *
     * The non-negative numbers less than {@link #MIN_USER_CHANNEL_VALUE} are
     * assigned to the predefined channels {@link #DEFAULT_CHANNEL} and
     * {@link #HIDDEN_CHANNEL}.
     *
     * @see `Token.channel`
     */ Token.MIN_USER_CHANNEL_VALUE = 2;
})($abe35a6f47a957ff$var$Token = module.exports.Token || (module.exports.Token = {}));

});



parcelRegister("jB0DW", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntegerStack = void 0;

var $eRSlM = parcelRequire("eRSlM");
/**
 *
 * @author Sam Harwell
 */ class $e441f8bbaf193f9f$var$IntegerStack extends $eRSlM.IntegerList {
    constructor(arg){
        super(arg);
    }
    push(value) {
        this.add(value);
    }
    pop() {
        return this.removeAt(this.size - 1);
    }
    peek() {
        return this.get(this.size - 1);
    }
}
module.exports.IntegerStack = $e441f8bbaf193f9f$var$IntegerStack;

});

parcelRegister("2160U", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $178056f04e0087b5$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $178056f04e0087b5$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerATNSimulator = void 0;

var $hu8W9 = parcelRequire("hu8W9");

var $eeOLb = parcelRequire("eeOLb");

var $hdFz0 = parcelRequire("hdFz0");

var $2SGHL = parcelRequire("2SGHL");

var $ceQRA = parcelRequire("ceQRA");

var $6P9ap = parcelRequire("6P9ap");

var $l8y5T = parcelRequire("l8y5T");

var $ldi9e = parcelRequire("ldi9e");

var $h7Q3L = parcelRequire("h7Q3L");

var $i6TH4 = parcelRequire("i6TH4");

var $l3IpB = parcelRequire("l3IpB");

var $aN41m = parcelRequire("aN41m");

var $9O0ze = parcelRequire("9O0ze");

var $jaUCz = parcelRequire("jaUCz");

var $jWsYN = parcelRequire("jWsYN");

var $eKXi4 = parcelRequire("eKXi4");

var $fomfP = parcelRequire("fomfP");
/** "dup" of ParserInterpreter */ let $178056f04e0087b5$var$LexerATNSimulator = class LexerATNSimulator extends $ceQRA.ATNSimulator {
    constructor(atn, recog){
        super(atn);
        this.optimize_tail_calls = true;
        /** The current token's starting index into the character stream.
         *  Shared across DFA to ATN simulation in case the ATN fails and the
         *  DFA did not have a previous accept state. In this case, we use the
         *  ATN-generated exception object.
         */ this.startIndex = -1;
        /** line number 1..n within the input */ this._line = 1;
        /** The index of the character relative to the beginning of the line 0..n-1 */ this._charPositionInLine = 0;
        this.mode = $h7Q3L.Lexer.DEFAULT_MODE;
        /** Used during DFA/ATN exec to record the most recent accept configuration info */ this.prevAccept = new LexerATNSimulator.SimState();
        this.recog = recog;
    }
    copyState(simulator) {
        this._charPositionInLine = simulator.charPositionInLine;
        this._line = simulator._line;
        this.mode = simulator.mode;
        this.startIndex = simulator.startIndex;
    }
    match(input, mode) {
        this.mode = mode;
        let mark = input.mark();
        try {
            this.startIndex = input.index;
            this.prevAccept.reset();
            let s0 = this.atn.modeToDFA[mode].s0;
            if (s0 == null) return this.matchATN(input);
            else return this.execATN(input, s0);
        } finally{
            input.release(mark);
        }
    }
    reset() {
        this.prevAccept.reset();
        this.startIndex = -1;
        this._line = 1;
        this._charPositionInLine = 0;
        this.mode = $h7Q3L.Lexer.DEFAULT_MODE;
    }
    matchATN(input) {
        let startState = this.atn.modeToStartState[this.mode];
        if (LexerATNSimulator.debug) console.log(`matchATN mode ${this.mode} start: ${startState}`);
        let old_mode = this.mode;
        let s0_closure = this.computeStartState(input, startState);
        let suppressEdge = s0_closure.hasSemanticContext;
        if (suppressEdge) s0_closure.hasSemanticContext = false;
        let next = this.addDFAState(s0_closure);
        if (!suppressEdge) {
            let dfa = this.atn.modeToDFA[this.mode];
            if (!dfa.s0) dfa.s0 = next;
            else next = dfa.s0;
        }
        let predict = this.execATN(input, next);
        if (LexerATNSimulator.debug) console.log(`DFA after matchATN: ${this.atn.modeToDFA[old_mode].toLexerString()}`);
        return predict;
    }
    execATN(input, ds0) {
        // console.log("enter exec index "+input.index+" from "+ds0.configs);
        if (LexerATNSimulator.debug) console.log(`start state closure=${ds0.configs}`);
        if (ds0.isAcceptState) // allow zero-length tokens
        this.captureSimState(this.prevAccept, input, ds0);
        let t = input.LA(1);
        // @NotNull
        let s = ds0; // s is current/from DFA state
        while(true){
            if (LexerATNSimulator.debug) console.log(`execATN loop starting closure: ${s.configs}`);
            // As we move src->trg, src->trg, we keep track of the previous trg to
            // avoid looking up the DFA state again, which is expensive.
            // If the previous target was already part of the DFA, we might
            // be able to avoid doing a reach operation upon t. If s!=null,
            // it means that semantic predicates didn't prevent us from
            // creating a DFA state. Once we know s!=null, we check to see if
            // the DFA state has an edge already for t. If so, we can just reuse
            // it's configuration set; there's no point in re-computing it.
            // This is kind of like doing DFA simulation within the ATN
            // simulation because DFA simulation is really just a way to avoid
            // computing reach/closure sets. Technically, once we know that
            // we have a previously added DFA state, we could jump over to
            // the DFA simulator. But, that would mean popping back and forth
            // a lot and making things more complicated algorithmically.
            // This optimization makes a lot of sense for loops within DFA.
            // A character will take us back to an existing DFA state
            // that already has lots of edges out of it. e.g., .* in comments.
            let target = this.getExistingTargetState(s, t);
            if (target == null) target = this.computeTargetState(input, s, t);
            if (target === $ceQRA.ATNSimulator.ERROR) break;
            // If this is a consumable input element, make sure to consume before
            // capturing the accept state so the input index, line, and char
            // position accurately reflect the state of the interpreter at the
            // end of the token.
            if (t !== $ldi9e.IntStream.EOF) this.consume(input);
            if (target.isAcceptState) {
                this.captureSimState(this.prevAccept, input, target);
                if (t === $ldi9e.IntStream.EOF) break;
            }
            t = input.LA(1);
            s = target; // flip; current DFA target becomes new src/from state
        }
        return this.failOrAccept(this.prevAccept, input, s.configs, t);
    }
    /**
     * Get an existing target state for an edge in the DFA. If the target state
     * for the edge has not yet been computed or is otherwise not available,
     * this method returns `undefined`.
     *
     * @param s The current DFA state
     * @param t The next input symbol
     * @returns The existing target DFA state for the given input symbol
     * `t`, or `undefined` if the target state for this edge is not
     * already cached
     */ getExistingTargetState(s, t) {
        let target = s.getTarget(t);
        if (LexerATNSimulator.debug && target != null) console.log("reuse state " + s.stateNumber + " edge to " + target.stateNumber);
        return target;
    }
    /**
     * Compute a target state for an edge in the DFA, and attempt to add the
     * computed state and corresponding edge to the DFA.
     *
     * @param input The input stream
     * @param s The current DFA state
     * @param t The next input symbol
     *
     * @returns The computed target DFA state for the given input symbol
     * `t`. If `t` does not lead to a valid DFA state, this method
     * returns {@link #ERROR}.
     */ computeTargetState(input, s, t) {
        let reach = new $9O0ze.OrderedATNConfigSet();
        // if we don't find an existing DFA state
        // Fill reach starting from closure, following t transitions
        this.getReachableConfigSet(input, s.configs, reach, t);
        if (reach.isEmpty) {
            if (!reach.hasSemanticContext) // we got nowhere on t, don't throw out this knowledge; it'd
            // cause a failover from DFA later.
            this.addDFAEdge(s, t, $ceQRA.ATNSimulator.ERROR);
            // stop when we can't match any more char
            return $ceQRA.ATNSimulator.ERROR;
        }
        // Add an edge from s to target DFA found/created for reach
        return this.addDFAEdge(s, t, reach);
    }
    failOrAccept(prevAccept, input, reach, t) {
        if (prevAccept.dfaState != null) {
            let lexerActionExecutor = prevAccept.dfaState.lexerActionExecutor;
            this.accept(input, lexerActionExecutor, this.startIndex, prevAccept.index, prevAccept.line, prevAccept.charPos);
            return prevAccept.dfaState.prediction;
        } else {
            // if no accept and EOF is first char, return EOF
            if (t === $ldi9e.IntStream.EOF && input.index === this.startIndex) return $eKXi4.Token.EOF;
            throw new $l3IpB.LexerNoViableAltException(this.recog, input, this.startIndex, reach);
        }
    }
    /** Given a starting configuration set, figure out all ATN configurations
     *  we can reach upon input `t`. Parameter `reach` is a return
     *  parameter.
     */ getReachableConfigSet(input, closure, reach, t) {
        // this is used to skip processing for configs which have a lower priority
        // than a config that already reached an accept state for the same rule
        let skipAlt = $eeOLb.ATN.INVALID_ALT_NUMBER;
        for (let c of closure){
            let currentAltReachedAcceptState = c.alt === skipAlt;
            if (currentAltReachedAcceptState && c.hasPassedThroughNonGreedyDecision) continue;
            if (LexerATNSimulator.debug) console.log(`testing ${this.getTokenName(t)} at ${c.toString(this.recog, true)}`);
            let n = c.state.numberOfOptimizedTransitions;
            for(let ti = 0; ti < n; ti++){
                let trans = c.state.getOptimizedTransition(ti);
                let target = this.getReachableTarget(trans, t);
                if (target != null) {
                    let lexerActionExecutor = c.lexerActionExecutor;
                    let config;
                    if (lexerActionExecutor != null) {
                        lexerActionExecutor = lexerActionExecutor.fixOffsetBeforeMatch(input.index - this.startIndex);
                        config = c.transform(target, true, lexerActionExecutor);
                    } else {
                        $fomfP(c.lexerActionExecutor == null);
                        config = c.transform(target, true);
                    }
                    let treatEofAsEpsilon = t === $ldi9e.IntStream.EOF;
                    if (this.closure(input, config, reach, currentAltReachedAcceptState, true, treatEofAsEpsilon)) {
                        // any remaining configs for this alt have a lower priority than
                        // the one that just reached an accept state.
                        skipAlt = c.alt;
                        break;
                    }
                }
            }
        }
    }
    accept(input, lexerActionExecutor, startIndex, index, line, charPos) {
        if (LexerATNSimulator.debug) console.log(`ACTION ${lexerActionExecutor}`);
        // seek to after last char in token
        input.seek(index);
        this._line = line;
        this._charPositionInLine = charPos;
        if (lexerActionExecutor != null && this.recog != null) lexerActionExecutor.execute(this.recog, input, startIndex);
    }
    getReachableTarget(trans, t) {
        if (trans.matches(t, $h7Q3L.Lexer.MIN_CHAR_VALUE, $h7Q3L.Lexer.MAX_CHAR_VALUE)) return trans.target;
        return undefined;
    }
    computeStartState(input, p) {
        let initialContext = $jaUCz.PredictionContext.EMPTY_FULL;
        let configs = new $9O0ze.OrderedATNConfigSet();
        for(let i = 0; i < p.numberOfTransitions; i++){
            let target = p.transition(i).target;
            let c = $hdFz0.ATNConfig.create(target, i + 1, initialContext);
            this.closure(input, c, configs, false, false, false);
        }
        return configs;
    }
    /**
     * Since the alternatives within any lexer decision are ordered by
     * preference, this method stops pursuing the closure as soon as an accept
     * state is reached. After the first accept state is reached by depth-first
     * search from `config`, all other (potentially reachable) states for
     * this rule would have a lower priority.
     *
     * @returns `true` if an accept state is reached, otherwise
     * `false`.
     */ closure(input, config, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon) {
        if (LexerATNSimulator.debug) console.log("closure(" + config.toString(this.recog, true) + ")");
        if (config.state instanceof $jWsYN.RuleStopState) {
            if (LexerATNSimulator.debug) {
                if (this.recog != null) console.log(`closure at ${this.recog.ruleNames[config.state.ruleIndex]} rule stop ${config}`);
                else console.log(`closure at rule stop ${config}`);
            }
            let context = config.context;
            if (context.isEmpty) {
                configs.add(config);
                return true;
            } else if (context.hasEmpty) {
                configs.add(config.transform(config.state, true, $jaUCz.PredictionContext.EMPTY_FULL));
                currentAltReachedAcceptState = true;
            }
            for(let i = 0; i < context.size; i++){
                let returnStateNumber = context.getReturnState(i);
                if (returnStateNumber === $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY) continue;
                let newContext = context.getParent(i); // "pop" return state
                let returnState = this.atn.states[returnStateNumber];
                let c = config.transform(returnState, false, newContext);
                currentAltReachedAcceptState = this.closure(input, c, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon);
            }
            return currentAltReachedAcceptState;
        }
        // optimization
        if (!config.state.onlyHasEpsilonTransitions) {
            if (!currentAltReachedAcceptState || !config.hasPassedThroughNonGreedyDecision) configs.add(config);
        }
        let p = config.state;
        for(let i = 0; i < p.numberOfOptimizedTransitions; i++){
            let t = p.getOptimizedTransition(i);
            let c = this.getEpsilonTarget(input, config, t, configs, speculative, treatEofAsEpsilon);
            if (c != null) currentAltReachedAcceptState = this.closure(input, c, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon);
        }
        return currentAltReachedAcceptState;
    }
    // side-effect: can alter configs.hasSemanticContext
    getEpsilonTarget(input, config, t, configs, speculative, treatEofAsEpsilon) {
        let c;
        switch(t.serializationType){
            case 3 /* RULE */ :
                let ruleTransition = t;
                if (this.optimize_tail_calls && ruleTransition.optimizedTailCall && !config.context.hasEmpty) c = config.transform(t.target, true);
                else {
                    let newContext = config.context.getChild(ruleTransition.followState.stateNumber);
                    c = config.transform(t.target, true, newContext);
                }
                break;
            case 10 /* PRECEDENCE */ :
                throw new Error("Precedence predicates are not supported in lexers.");
            case 4 /* PREDICATE */ :
                /*  Track traversing semantic predicates. If we traverse,
                    we cannot add a DFA state for this "reach" computation
                    because the DFA would not test the predicate again in the
                    future. Rather than creating collections of semantic predicates
                    like v3 and testing them on prediction, v4 will test them on the
                    fly all the time using the ATN not the DFA. This is slower but
                    semantically it's not used that often. One of the key elements to
                    this predicate mechanism is not adding DFA states that see
                    predicates immediately afterwards in the ATN. For example,
    
                    a : ID {p1}? | ID {p2}? ;
    
                    should create the start state for rule 'a' (to save start state
                    competition), but should not create target of ID state. The
                    collection of ATN states the following ID references includes
                    states reached by traversing predicates. Since this is when we
                    test them, we cannot cash the DFA state target of ID.
                */ let pt = t;
                if (LexerATNSimulator.debug) console.log("EVAL rule " + pt.ruleIndex + ":" + pt.predIndex);
                configs.hasSemanticContext = true;
                if (this.evaluatePredicate(input, pt.ruleIndex, pt.predIndex, speculative)) c = config.transform(t.target, true);
                else c = undefined;
                break;
            case 6 /* ACTION */ :
                if (config.context.hasEmpty) {
                    // execute actions anywhere in the start rule for a token.
                    //
                    // TODO: if the entry rule is invoked recursively, some
                    // actions may be executed during the recursive call. The
                    // problem can appear when hasEmpty is true but
                    // isEmpty is false. In this case, the config needs to be
                    // split into two contexts - one with just the empty path
                    // and another with everything but the empty path.
                    // Unfortunately, the current algorithm does not allow
                    // getEpsilonTarget to return two configurations, so
                    // additional modifications are needed before we can support
                    // the split operation.
                    let lexerActionExecutor = $i6TH4.LexerActionExecutor.append(config.lexerActionExecutor, this.atn.lexerActions[t.actionIndex]);
                    c = config.transform(t.target, true, lexerActionExecutor);
                    break;
                } else {
                    // ignore actions in referenced rules
                    c = config.transform(t.target, true);
                    break;
                }
            case 1 /* EPSILON */ :
                c = config.transform(t.target, true);
                break;
            case 5 /* ATOM */ :
            case 2 /* RANGE */ :
            case 7 /* SET */ :
                if (treatEofAsEpsilon) {
                    if (t.matches($ldi9e.IntStream.EOF, $h7Q3L.Lexer.MIN_CHAR_VALUE, $h7Q3L.Lexer.MAX_CHAR_VALUE)) {
                        c = config.transform(t.target, false);
                        break;
                    }
                }
                c = undefined;
                break;
            default:
                c = undefined;
                break;
        }
        return c;
    }
    /**
     * Evaluate a predicate specified in the lexer.
     *
     * If `speculative` is `true`, this method was called before
     * {@link #consume} for the matched character. This method should call
     * {@link #consume} before evaluating the predicate to ensure position
     * sensitive values, including {@link Lexer#getText}, {@link Lexer#getLine},
     * and {@link Lexer#getCharPositionInLine}, properly reflect the current
     * lexer state. This method should restore `input` and the simulator
     * to the original state before returning (i.e. undo the actions made by the
     * call to {@link #consume}.
     *
     * @param input The input stream.
     * @param ruleIndex The rule containing the predicate.
     * @param predIndex The index of the predicate within the rule.
     * @param speculative `true` if the current index in `input` is
     * one character before the predicate's location.
     *
     * @returns `true` if the specified predicate evaluates to
     * `true`.
     */ evaluatePredicate(input, ruleIndex, predIndex, speculative) {
        // assume true if no recognizer was provided
        if (this.recog == null) return true;
        if (!speculative) return this.recog.sempred(undefined, ruleIndex, predIndex);
        let savedCharPositionInLine = this._charPositionInLine;
        let savedLine = this._line;
        let index = input.index;
        let marker = input.mark();
        try {
            this.consume(input);
            return this.recog.sempred(undefined, ruleIndex, predIndex);
        } finally{
            this._charPositionInLine = savedCharPositionInLine;
            this._line = savedLine;
            input.seek(index);
            input.release(marker);
        }
    }
    captureSimState(settings, input, dfaState) {
        settings.index = input.index;
        settings.line = this._line;
        settings.charPos = this._charPositionInLine;
        settings.dfaState = dfaState;
    }
    addDFAEdge(p, t, q) {
        if (q instanceof $2SGHL.ATNConfigSet) {
            /* leading to this call, ATNConfigSet.hasSemanticContext is used as a
            * marker indicating dynamic predicate evaluation makes this edge
            * dependent on the specific input sequence, so the static edge in the
            * DFA should be omitted. The target DFAState is still created since
            * execATN has the ability to resynchronize with the DFA state cache
            * following the predicate evaluation step.
            *
            * TJP notes: next time through the DFA, we see a pred again and eval.
            * If that gets us to a previously created (but dangling) DFA
            * state, we can continue in pure DFA mode from there.
            */ let suppressEdge = q.hasSemanticContext;
            if (suppressEdge) q.hasSemanticContext = false;
            // @NotNull
            let to = this.addDFAState(q);
            if (suppressEdge) return to;
            this.addDFAEdge(p, t, to);
            return to;
        } else {
            if (LexerATNSimulator.debug) console.log("EDGE " + p + " -> " + q + " upon " + String.fromCharCode(t));
            if (p != null) p.setTarget(t, q);
        }
    }
    /** Add a new DFA state if there isn't one with this set of
     * 	configurations already. This method also detects the first
     * 	configuration containing an ATN rule stop state. Later, when
     * 	traversing the DFA, we will know which rule to accept.
     */ addDFAState(configs) {
        /* the lexer evaluates predicates on-the-fly; by this point configs
         * should not contain any configurations with unevaluated predicates.
         */ $fomfP(!configs.hasSemanticContext);
        let proposed = new $6P9ap.DFAState(configs);
        let existing = this.atn.modeToDFA[this.mode].states.get(proposed);
        if (existing != null) return existing;
        configs.optimizeConfigs(this);
        let newState = new $6P9ap.DFAState(configs.clone(true));
        let firstConfigWithRuleStopState;
        for (let c of configs)if (c.state instanceof $jWsYN.RuleStopState) {
            firstConfigWithRuleStopState = c;
            break;
        }
        if (firstConfigWithRuleStopState != null) {
            let prediction = this.atn.ruleToTokenType[firstConfigWithRuleStopState.state.ruleIndex];
            let lexerActionExecutor = firstConfigWithRuleStopState.lexerActionExecutor;
            newState.acceptStateInfo = new $hu8W9.AcceptStateInfo(prediction, lexerActionExecutor);
        }
        return this.atn.modeToDFA[this.mode].addState(newState);
    }
    getDFA(mode) {
        return this.atn.modeToDFA[mode];
    }
    /** Get the text matched so far for the current token.
     */ getText(input) {
        // index is first lookahead char, don't include.
        return input.getText($l8y5T.Interval.of(this.startIndex, input.index - 1));
    }
    get line() {
        return this._line;
    }
    set line(line) {
        this._line = line;
    }
    get charPositionInLine() {
        return this._charPositionInLine;
    }
    set charPositionInLine(charPositionInLine) {
        this._charPositionInLine = charPositionInLine;
    }
    consume(input) {
        let curChar = input.LA(1);
        if (curChar === "\n".charCodeAt(0)) {
            this._line++;
            this._charPositionInLine = 0;
        } else this._charPositionInLine++;
        input.consume();
    }
    getTokenName(t) {
        if (t === -1) return "EOF";
        //if ( atn.g!=null ) return atn.g.getTokenDisplayName(t);
        return "'" + String.fromCharCode(t) + "'";
    }
};
$178056f04e0087b5$var$__decorate([
    $aN41m.NotNull
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "prevAccept", void 0);
$178056f04e0087b5$var$__decorate([
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "copyState", null);
$178056f04e0087b5$var$__decorate([
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "match", null);
$178056f04e0087b5$var$__decorate([
    $aN41m.Override
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "reset", null);
$178056f04e0087b5$var$__decorate([
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "matchATN", null);
$178056f04e0087b5$var$__decorate([
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull),
    $178056f04e0087b5$var$__param(1, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "execATN", null);
$178056f04e0087b5$var$__decorate([
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "getExistingTargetState", null);
$178056f04e0087b5$var$__decorate([
    $aN41m.NotNull,
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull),
    $178056f04e0087b5$var$__param(1, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "computeTargetState", null);
$178056f04e0087b5$var$__decorate([
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull),
    $178056f04e0087b5$var$__param(1, $aN41m.NotNull),
    $178056f04e0087b5$var$__param(2, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "getReachableConfigSet", null);
$178056f04e0087b5$var$__decorate([
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "accept", null);
$178056f04e0087b5$var$__decorate([
    $aN41m.NotNull,
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull),
    $178056f04e0087b5$var$__param(1, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "computeStartState", null);
$178056f04e0087b5$var$__decorate([
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull),
    $178056f04e0087b5$var$__param(1, $aN41m.NotNull),
    $178056f04e0087b5$var$__param(2, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "closure", null);
$178056f04e0087b5$var$__decorate([
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull),
    $178056f04e0087b5$var$__param(1, $aN41m.NotNull),
    $178056f04e0087b5$var$__param(2, $aN41m.NotNull),
    $178056f04e0087b5$var$__param(3, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "getEpsilonTarget", null);
$178056f04e0087b5$var$__decorate([
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "evaluatePredicate", null);
$178056f04e0087b5$var$__decorate([
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull),
    $178056f04e0087b5$var$__param(1, $aN41m.NotNull),
    $178056f04e0087b5$var$__param(2, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "captureSimState", null);
$178056f04e0087b5$var$__decorate([
    $aN41m.NotNull,
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "addDFAState", null);
$178056f04e0087b5$var$__decorate([
    $aN41m.NotNull
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "getDFA", null);
$178056f04e0087b5$var$__decorate([
    $aN41m.NotNull,
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "getText", null);
$178056f04e0087b5$var$__decorate([
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "consume", null);
$178056f04e0087b5$var$__decorate([
    $aN41m.NotNull
], $178056f04e0087b5$var$LexerATNSimulator.prototype, "getTokenName", null);
$178056f04e0087b5$var$LexerATNSimulator = $178056f04e0087b5$var$__decorate([
    $178056f04e0087b5$var$__param(0, $aN41m.NotNull)
], $178056f04e0087b5$var$LexerATNSimulator);
module.exports.LexerATNSimulator = $178056f04e0087b5$var$LexerATNSimulator;
(function(LexerATNSimulator) {
    LexerATNSimulator.debug = false;
    LexerATNSimulator.dfa_debug = false;
    /** When we hit an accept state in either the DFA or the ATN, we
     *  have to notify the character stream to start buffering characters
     *  via {@link IntStream#mark} and record the current state. The current sim state
     *  includes the current index into the input, the current line,
     *  and current character position in that line. Note that the Lexer is
     *  tracking the starting line and characterization of the token. These
     *  variables track the "state" of the simulator when it hits an accept state.
     *
     *  We track these variables separately for the DFA and ATN simulation
     *  because the DFA simulation often has to fail over to the ATN
     *  simulation. If the ATN simulation fails, we need the DFA to fall
     *  back to its previously accepted state, if any. If the ATN succeeds,
     *  then the ATN does the accept and the DFA simulator that invoked it
     *  can simply return the predicted token type.
     */ class SimState {
        constructor(){
            this.index = -1;
            this.line = 0;
            this.charPos = -1;
        }
        reset() {
            this.index = -1;
            this.line = 0;
            this.charPos = -1;
            this.dfaState = undefined;
        }
    }
    LexerATNSimulator.SimState = SimState;
})($178056f04e0087b5$var$LexerATNSimulator = module.exports.LexerATNSimulator || (module.exports.LexerATNSimulator = {}));
module.exports.LexerATNSimulator = $178056f04e0087b5$var$LexerATNSimulator;

});
parcelRegister("hu8W9", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AcceptStateInfo = void 0;
/**
 * Stores information about a {@link DFAState} which is an accept state under
 * some condition. Certain settings, such as
 * {@link ParserATNSimulator#getPredictionMode()}, may be used in addition to
 * this information to determine whether or not a particular state is an accept
 * state.
 *
 * @author Sam Harwell
 */ class $cbac2bb2f6962aae$var$AcceptStateInfo {
    constructor(prediction, lexerActionExecutor){
        this._prediction = prediction;
        this._lexerActionExecutor = lexerActionExecutor;
    }
    /**
     * Gets the prediction made by this accept state. Note that this value
     * assumes the predicates, if any, in the {@link DFAState} evaluate to
     * `true`. If predicate evaluation is enabled, the final prediction of
     * the accept state will be determined by the result of predicate
     * evaluation.
     */ get prediction() {
        return this._prediction;
    }
    /**
     * Gets the {@link LexerActionExecutor} which can be used to execute actions
     * and/or commands after the lexer matches a token.
     */ get lexerActionExecutor() {
        return this._lexerActionExecutor;
    }
}
module.exports.AcceptStateInfo = $cbac2bb2f6962aae$var$AcceptStateInfo;

});

parcelRegister("eeOLb", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a5d9bf5b15739a51$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a5d9bf5b15739a51$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATN = void 0;

var $jRlcM = parcelRequire("jRlcM");

var $1Cdmr = parcelRequire("1Cdmr");

var $6kdz0 = parcelRequire("6kdz0");

var $8ii30 = parcelRequire("8ii30");

var $kUmff = parcelRequire("kUmff");

var $aN41m = parcelRequire("aN41m");

var $9eW9B = parcelRequire("9eW9B");

var $jaUCz = parcelRequire("jaUCz");

var $eKXi4 = parcelRequire("eKXi4");

var $fomfP = parcelRequire("fomfP");
/** */ let $a5d9bf5b15739a51$var$ATN = class ATN {
    /** Used for runtime deserialization of ATNs from strings */ constructor(grammarType, maxTokenType){
        this.states = [];
        /** Each subrule/rule is a decision point and we must track them so we
         *  can go back later and build DFA predictors for them.  This includes
         *  all the rules, subrules, optional blocks, ()+, ()* etc...
         */ this.decisionToState = [];
        this.modeNameToStartState = new Map();
        this.modeToStartState = [];
        this.contextCache = new $jRlcM.Array2DHashMap($9eW9B.ObjectEqualityComparator.INSTANCE);
        this.decisionToDFA = [];
        this.modeToDFA = [];
        this.LL1Table = new Map();
        this.grammarType = grammarType;
        this.maxTokenType = maxTokenType;
    }
    clearDFA() {
        this.decisionToDFA = new Array(this.decisionToState.length);
        for(let i = 0; i < this.decisionToDFA.length; i++)this.decisionToDFA[i] = new $1Cdmr.DFA(this.decisionToState[i], i);
        this.modeToDFA = new Array(this.modeToStartState.length);
        for(let i = 0; i < this.modeToDFA.length; i++)this.modeToDFA[i] = new $1Cdmr.DFA(this.modeToStartState[i]);
        this.contextCache.clear();
        this.LL1Table.clear();
    }
    get contextCacheSize() {
        return this.contextCache.size;
    }
    getCachedContext(context) {
        return $jaUCz.PredictionContext.getCachedContext(context, this.contextCache, new $jaUCz.PredictionContext.IdentityHashMap());
    }
    getDecisionToDFA() {
        $fomfP(this.decisionToDFA != null && this.decisionToDFA.length === this.decisionToState.length);
        return this.decisionToDFA;
    }
    nextTokens(s, ctx) {
        if (ctx) {
            let anal = new $kUmff.LL1Analyzer(this);
            let next = anal.LOOK(s, ctx);
            return next;
        } else {
            if (s.nextTokenWithinRule) return s.nextTokenWithinRule;
            s.nextTokenWithinRule = this.nextTokens(s, $jaUCz.PredictionContext.EMPTY_LOCAL);
            s.nextTokenWithinRule.setReadonly(true);
            return s.nextTokenWithinRule;
        }
    }
    addState(state) {
        state.atn = this;
        state.stateNumber = this.states.length;
        this.states.push(state);
    }
    removeState(state) {
        // just replace the state, don't shift states in list
        let invalidState = new $8ii30.InvalidState();
        invalidState.atn = this;
        invalidState.stateNumber = state.stateNumber;
        this.states[state.stateNumber] = invalidState;
    }
    defineMode(name, s) {
        this.modeNameToStartState.set(name, s);
        this.modeToStartState.push(s);
        this.modeToDFA.push(new $1Cdmr.DFA(s));
        this.defineDecisionState(s);
    }
    defineDecisionState(s) {
        this.decisionToState.push(s);
        s.decision = this.decisionToState.length - 1;
        this.decisionToDFA.push(new $1Cdmr.DFA(s, s.decision));
        return s.decision;
    }
    getDecisionState(decision) {
        if (this.decisionToState.length > 0) return this.decisionToState[decision];
        return undefined;
    }
    get numberOfDecisions() {
        return this.decisionToState.length;
    }
    /**
     * Computes the set of input symbols which could follow ATN state number
     * `stateNumber` in the specified full `context`. This method
     * considers the complete parser context, but does not evaluate semantic
     * predicates (i.e. all predicates encountered during the calculation are
     * assumed true). If a path in the ATN exists from the starting state to the
     * {@link RuleStopState} of the outermost context without matching any
     * symbols, {@link Token#EOF} is added to the returned set.
     *
     * If `context` is `undefined`, it is treated as
     * {@link ParserRuleContext#EMPTY}.
     *
     * Note that this does NOT give you the set of all tokens that could
     * appear at a given token position in the input phrase.  In other words, it
     * does not answer:
     *
     * > Given a specific partial input phrase, return the set of all
     * > tokens that can follow the last token in the input phrase.
     *
     * The big difference is that with just the input, the parser could land
     * right in the middle of a lookahead decision. Getting all
     * *possible* tokens given a partial input stream is a separate
     * computation. See https://github.com/antlr/antlr4/issues/1428
     *
     * For this function, we are specifying an ATN state and call stack to
     * compute what token(s) can come next and specifically: outside of a
     * lookahead decision. That is what you want for error reporting and
     * recovery upon parse error.
     *
     * @param stateNumber the ATN state number
     * @param context the full parse context
     * @returns The set of potentially valid input symbols which could follow the
     * specified state in the specified context.
     * @ if the ATN does not contain a state with
     * number `stateNumber`
     */ getExpectedTokens(stateNumber, context) {
        if (stateNumber < 0 || stateNumber >= this.states.length) throw new RangeError("Invalid state number.");
        let ctx = context;
        let s = this.states[stateNumber];
        let following = this.nextTokens(s);
        if (!following.contains($eKXi4.Token.EPSILON)) return following;
        let expected = new $6kdz0.IntervalSet();
        expected.addAll(following);
        expected.remove($eKXi4.Token.EPSILON);
        while(ctx != null && ctx.invokingState >= 0 && following.contains($eKXi4.Token.EPSILON)){
            let invokingState = this.states[ctx.invokingState];
            let rt = invokingState.transition(0);
            following = this.nextTokens(rt.followState);
            expected.addAll(following);
            expected.remove($eKXi4.Token.EPSILON);
            ctx = ctx._parent;
        }
        if (following.contains($eKXi4.Token.EPSILON)) expected.add($eKXi4.Token.EOF);
        return expected;
    }
};
$a5d9bf5b15739a51$var$__decorate([
    $aN41m.NotNull
], $a5d9bf5b15739a51$var$ATN.prototype, "states", void 0);
$a5d9bf5b15739a51$var$__decorate([
    $aN41m.NotNull
], $a5d9bf5b15739a51$var$ATN.prototype, "decisionToState", void 0);
$a5d9bf5b15739a51$var$__decorate([
    $aN41m.NotNull
], $a5d9bf5b15739a51$var$ATN.prototype, "modeNameToStartState", void 0);
$a5d9bf5b15739a51$var$__decorate([
    $aN41m.NotNull
], $a5d9bf5b15739a51$var$ATN.prototype, "modeToStartState", void 0);
$a5d9bf5b15739a51$var$__decorate([
    $aN41m.NotNull
], $a5d9bf5b15739a51$var$ATN.prototype, "decisionToDFA", void 0);
$a5d9bf5b15739a51$var$__decorate([
    $aN41m.NotNull
], $a5d9bf5b15739a51$var$ATN.prototype, "modeToDFA", void 0);
$a5d9bf5b15739a51$var$__decorate([
    $aN41m.NotNull
], $a5d9bf5b15739a51$var$ATN.prototype, "nextTokens", null);
$a5d9bf5b15739a51$var$__decorate([
    $a5d9bf5b15739a51$var$__param(0, $aN41m.NotNull)
], $a5d9bf5b15739a51$var$ATN.prototype, "removeState", null);
$a5d9bf5b15739a51$var$__decorate([
    $a5d9bf5b15739a51$var$__param(0, $aN41m.NotNull),
    $a5d9bf5b15739a51$var$__param(1, $aN41m.NotNull)
], $a5d9bf5b15739a51$var$ATN.prototype, "defineMode", null);
$a5d9bf5b15739a51$var$__decorate([
    $a5d9bf5b15739a51$var$__param(0, $aN41m.NotNull)
], $a5d9bf5b15739a51$var$ATN.prototype, "defineDecisionState", null);
$a5d9bf5b15739a51$var$__decorate([
    $aN41m.NotNull
], $a5d9bf5b15739a51$var$ATN.prototype, "getExpectedTokens", null);
$a5d9bf5b15739a51$var$ATN = $a5d9bf5b15739a51$var$__decorate([
    $a5d9bf5b15739a51$var$__param(0, $aN41m.NotNull)
], $a5d9bf5b15739a51$var$ATN);
module.exports.ATN = $a5d9bf5b15739a51$var$ATN;
(function(ATN) {
    ATN.INVALID_ALT_NUMBER = 0;
})($a5d9bf5b15739a51$var$ATN = module.exports.ATN || (module.exports.ATN = {}));
module.exports.ATN = $a5d9bf5b15739a51$var$ATN;

});
parcelRegister("jRlcM", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Array2DHashMap = void 0;

var $fsqYw = parcelRequire("fsqYw");
class $e7536a7825c78fd8$var$MapKeyEqualityComparator {
    constructor(keyComparator){
        this.keyComparator = keyComparator;
    }
    hashCode(obj) {
        return this.keyComparator.hashCode(obj.key);
    }
    equals(a, b) {
        return this.keyComparator.equals(a.key, b.key);
    }
}
class $e7536a7825c78fd8$var$Array2DHashMap {
    constructor(keyComparer){
        if (keyComparer instanceof $e7536a7825c78fd8$var$Array2DHashMap) this.backingStore = new $fsqYw.Array2DHashSet(keyComparer.backingStore);
        else this.backingStore = new $fsqYw.Array2DHashSet(new $e7536a7825c78fd8$var$MapKeyEqualityComparator(keyComparer));
    }
    clear() {
        this.backingStore.clear();
    }
    containsKey(key) {
        return this.backingStore.contains({
            key: key
        });
    }
    get(key) {
        let bucket = this.backingStore.get({
            key: key
        });
        if (!bucket) return undefined;
        return bucket.value;
    }
    get isEmpty() {
        return this.backingStore.isEmpty;
    }
    put(key, value) {
        let element = this.backingStore.get({
            key: key,
            value: value
        });
        let result;
        if (!element) this.backingStore.add({
            key: key,
            value: value
        });
        else {
            result = element.value;
            element.value = value;
        }
        return result;
    }
    putIfAbsent(key, value) {
        let element = this.backingStore.get({
            key: key,
            value: value
        });
        let result;
        if (!element) this.backingStore.add({
            key: key,
            value: value
        });
        else result = element.value;
        return result;
    }
    get size() {
        return this.backingStore.size;
    }
    hashCode() {
        return this.backingStore.hashCode();
    }
    equals(o) {
        if (!(o instanceof $e7536a7825c78fd8$var$Array2DHashMap)) return false;
        return this.backingStore.equals(o.backingStore);
    }
}
module.exports.Array2DHashMap = $e7536a7825c78fd8$var$Array2DHashMap;

});

parcelRegister("1Cdmr", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $12d3b4406c1292f5$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $12d3b4406c1292f5$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DFA = void 0;

var $fsqYw = parcelRequire("fsqYw");

var $2SGHL = parcelRequire("2SGHL");

var $aVeml = parcelRequire("aVeml");

var $6P9ap = parcelRequire("6P9ap");

var $gwhAV = parcelRequire("gwhAV");

var $aN41m = parcelRequire("aN41m");

var $9eW9B = parcelRequire("9eW9B");

var $e0pjt = parcelRequire("e0pjt");

var $hBnE1 = parcelRequire("hBnE1");
let $12d3b4406c1292f5$var$DFA = class DFA {
    constructor(atnStartState, decision = 0){
        /**
         * A set of all states in the `DFA`.
         *
         * Note that this collection of states holds the DFA states for both SLL and LL prediction. Only the start state
         * needs to be differentiated for these cases, which is tracked by the `s0` and `s0full` fields.
         */ this.states = new $fsqYw.Array2DHashSet($9eW9B.ObjectEqualityComparator.INSTANCE);
        this.nextStateNumber = 0;
        if (!atnStartState.atn) throw new Error("The ATNState must be associated with an ATN");
        this.atnStartState = atnStartState;
        this.atn = atnStartState.atn;
        this.decision = decision;
        // Precedence DFAs are associated with the special precedence decision created for left-recursive rules which
        // evaluate their alternatives using a precedence hierarchy. When such a decision is encountered, we mark this
        // DFA instance as a precedence DFA and initialize the initial states s0 and s0full to special DFAState
        // instances which use outgoing edges to link to the actual start state used for each precedence level.
        let isPrecedenceDfa = false;
        if (atnStartState instanceof $e0pjt.StarLoopEntryState) {
            if (atnStartState.precedenceRuleDecision) {
                isPrecedenceDfa = true;
                this.s0 = new $6P9ap.DFAState(new $2SGHL.ATNConfigSet());
                this.s0full = new $6P9ap.DFAState(new $2SGHL.ATNConfigSet());
            }
        }
        this.precedenceDfa = isPrecedenceDfa;
    }
    /**
     * Gets whether this DFA is a precedence DFA. Precedence DFAs use a special
     * start state {@link #s0} which is not stored in {@link #states}. The
     * {@link DFAState#edges} array for this start state contains outgoing edges
     * supplying individual start states corresponding to specific precedence
     * values.
     *
     * @returns `true` if this is a precedence DFA; otherwise,
     * `false`.
     * @see Parser.precedence
     */ get isPrecedenceDfa() {
        return this.precedenceDfa;
    }
    /**
     * Get the start state for a specific precedence value.
     *
     * @param precedence The current precedence.
     * @returns The start state corresponding to the specified precedence, or
     * `undefined` if no start state exists for the specified precedence.
     *
     * @ if this is not a precedence DFA.
     * @see `isPrecedenceDfa`
     */ getPrecedenceStartState(precedence, fullContext) {
        if (!this.isPrecedenceDfa) throw new Error("Only precedence DFAs may contain a precedence start state.");
        // s0 and s0full are never null for a precedence DFA
        if (fullContext) return this.s0full.getTarget(precedence);
        else return this.s0.getTarget(precedence);
    }
    /**
     * Set the start state for a specific precedence value.
     *
     * @param precedence The current precedence.
     * @param startState The start state corresponding to the specified
     * precedence.
     *
     * @ if this is not a precedence DFA.
     * @see `isPrecedenceDfa`
     */ setPrecedenceStartState(precedence, fullContext, startState) {
        if (!this.isPrecedenceDfa) throw new Error("Only precedence DFAs may contain a precedence start state.");
        if (precedence < 0) return;
        if (fullContext) // s0full is never null for a precedence DFA
        this.s0full.setTarget(precedence, startState);
        else // s0 is never null for a precedence DFA
        this.s0.setTarget(precedence, startState);
    }
    get isEmpty() {
        if (this.isPrecedenceDfa) // s0 and s0full are never null for a precedence DFA
        return this.s0.getEdgeMap().size === 0 && this.s0full.getEdgeMap().size === 0;
        return this.s0 == null && this.s0full == null;
    }
    get isContextSensitive() {
        if (this.isPrecedenceDfa) // s0full is never null for a precedence DFA
        return this.s0full.getEdgeMap().size > 0;
        return this.s0full != null;
    }
    addState(state) {
        state.stateNumber = this.nextStateNumber++;
        return this.states.getOrAdd(state);
    }
    toString(vocabulary, ruleNames) {
        if (!vocabulary) vocabulary = $hBnE1.VocabularyImpl.EMPTY_VOCABULARY;
        if (!this.s0) return "";
        let serializer;
        if (ruleNames) serializer = new $aVeml.DFASerializer(this, vocabulary, ruleNames, this.atnStartState.atn);
        else serializer = new $aVeml.DFASerializer(this, vocabulary);
        return serializer.toString();
    }
    toLexerString() {
        if (!this.s0) return "";
        let serializer = new $gwhAV.LexerDFASerializer(this);
        return serializer.toString();
    }
};
$12d3b4406c1292f5$var$__decorate([
    $aN41m.NotNull
], $12d3b4406c1292f5$var$DFA.prototype, "states", void 0);
$12d3b4406c1292f5$var$__decorate([
    $aN41m.NotNull
], $12d3b4406c1292f5$var$DFA.prototype, "atnStartState", void 0);
$12d3b4406c1292f5$var$__decorate([
    $aN41m.NotNull
], $12d3b4406c1292f5$var$DFA.prototype, "atn", void 0);
$12d3b4406c1292f5$var$DFA = $12d3b4406c1292f5$var$__decorate([
    $12d3b4406c1292f5$var$__param(0, $aN41m.NotNull)
], $12d3b4406c1292f5$var$DFA);
module.exports.DFA = $12d3b4406c1292f5$var$DFA;

});
parcelRegister("2SGHL", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $2191c0313d388677$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNConfigSet = void 0;

var $jRlcM = parcelRequire("jRlcM");

var $fsqYw = parcelRequire("fsqYw");

var $6iIjF = parcelRequire("6iIjF");

var $eeOLb = parcelRequire("eeOLb");

var $hdFz0 = parcelRequire("hdFz0");

var $8WIez = parcelRequire("8WIez");

var $aN41m = parcelRequire("aN41m");

var $9eW9B = parcelRequire("9eW9B");

var $jaUCz = parcelRequire("jaUCz");

var $4BvNW = parcelRequire("4BvNW");

var $3JS45 = parcelRequire("3JS45");

var $fomfP = parcelRequire("fomfP");

var $62Uvn = parcelRequire("62Uvn");
class $2191c0313d388677$var$KeyTypeEqualityComparer {
    hashCode(key) {
        return key.state ^ key.alt;
    }
    equals(a, b) {
        return a.state === b.state && a.alt === b.alt;
    }
}
$2191c0313d388677$var$KeyTypeEqualityComparer.INSTANCE = new $2191c0313d388677$var$KeyTypeEqualityComparer();
function $2191c0313d388677$var$NewKeyedConfigMap(map) {
    if (map) return new $jRlcM.Array2DHashMap(map);
    else return new $jRlcM.Array2DHashMap($2191c0313d388677$var$KeyTypeEqualityComparer.INSTANCE);
}
/**
 * Represents a set of ATN configurations (see `ATNConfig`). As configurations are added to the set, they are merged
 * with other `ATNConfig` instances already in the set when possible using the graph-structured stack.
 *
 * An instance of this class represents the complete set of positions (with context) in an ATN which would be associated
 * with a single DFA state. Its internal representation is more complex than traditional state used for NFA to DFA
 * conversion due to performance requirements (both improving speed and reducing memory overhead) as well as supporting
 * features such as semantic predicates and non-greedy operators in a form to support ANTLR's prediction algorithm.
 *
 * @author Sam Harwell
 */ class $2191c0313d388677$var$ATNConfigSet {
    constructor(set, readonly){
        this._uniqueAlt = 0;
        // Used in parser and lexer. In lexer, it indicates we hit a pred
        // while computing a closure operation.  Don't make a DFA state from this.
        this._hasSemanticContext = false;
        this._dipsIntoOuterContext = false;
        /**
         * When `true`, this config set represents configurations where the entire
         * outer context has been consumed by the ATN interpreter. This prevents the
         * {@link ParserATNSimulator#closure} from pursuing the global FOLLOW when a
         * rule stop state is reached with an empty prediction context.
         *
         * Note: `outermostConfigSet` and {@link #dipsIntoOuterContext} should never
         * be true at the same time.
         */ this.outermostConfigSet = false;
        this.cachedHashCode = -1;
        if (!set) {
            this.mergedConfigs = $2191c0313d388677$var$NewKeyedConfigMap();
            this.unmerged = [];
            this.configs = [];
            this._uniqueAlt = $eeOLb.ATN.INVALID_ALT_NUMBER;
        } else {
            if (readonly) {
                this.mergedConfigs = undefined;
                this.unmerged = undefined;
            } else if (!set.isReadOnly) {
                this.mergedConfigs = $2191c0313d388677$var$NewKeyedConfigMap(set.mergedConfigs);
                this.unmerged = set.unmerged.slice(0);
            } else {
                this.mergedConfigs = $2191c0313d388677$var$NewKeyedConfigMap();
                this.unmerged = [];
            }
            this.configs = set.configs.slice(0);
            this._dipsIntoOuterContext = set._dipsIntoOuterContext;
            this._hasSemanticContext = set._hasSemanticContext;
            this.outermostConfigSet = set.outermostConfigSet;
            if (readonly || !set.isReadOnly) {
                this._uniqueAlt = set._uniqueAlt;
                this._conflictInfo = set._conflictInfo;
            }
        // if (!readonly && set.isReadOnly) -> addAll is called from clone()
        }
    }
    /**
     * Get the set of all alternatives represented by configurations in this
     * set.
     */ getRepresentedAlternatives() {
        if (this._conflictInfo != null) return this._conflictInfo.conflictedAlts.clone();
        let alts = new $8WIez.BitSet();
        for (let config of this)alts.set(config.alt);
        return alts;
    }
    get isReadOnly() {
        return this.mergedConfigs == null;
    }
    get isOutermostConfigSet() {
        return this.outermostConfigSet;
    }
    set isOutermostConfigSet(outermostConfigSet) {
        if (this.outermostConfigSet && !outermostConfigSet) throw new Error("IllegalStateException");
        $fomfP(!outermostConfigSet || !this._dipsIntoOuterContext);
        this.outermostConfigSet = outermostConfigSet;
    }
    getStates() {
        let states = new $fsqYw.Array2DHashSet($9eW9B.ObjectEqualityComparator.INSTANCE);
        for (let c of this.configs)states.add(c.state);
        return states;
    }
    optimizeConfigs(interpreter) {
        if (this.configs.length === 0) return;
        for (let config of this.configs)config.context = interpreter.atn.getCachedContext(config.context);
    }
    clone(readonly) {
        let copy = new $2191c0313d388677$var$ATNConfigSet(this, readonly);
        if (!readonly && this.isReadOnly) copy.addAll(this.configs);
        return copy;
    }
    get size() {
        return this.configs.length;
    }
    get isEmpty() {
        return this.configs.length === 0;
    }
    contains(o) {
        if (!(o instanceof $hdFz0.ATNConfig)) return false;
        if (this.mergedConfigs && this.unmerged) {
            let config = o;
            let configKey = this.getKey(config);
            let mergedConfig = this.mergedConfigs.get(configKey);
            if (mergedConfig != null && this.canMerge(config, configKey, mergedConfig)) return mergedConfig.contains(config);
            for (let c of this.unmerged){
                if (c.contains(o)) return true;
            }
        } else for (let c of this.configs){
            if (c.contains(o)) return true;
        }
        return false;
    }
    *[Symbol.iterator]() {
        yield* this.configs;
    }
    toArray() {
        return this.configs;
    }
    add(e, contextCache) {
        this.ensureWritable();
        if (!this.mergedConfigs || !this.unmerged) throw new Error("Covered by ensureWritable but duplicated here for strict null check limitation");
        $fomfP(!this.outermostConfigSet || !e.reachesIntoOuterContext);
        if (contextCache == null) contextCache = $4BvNW.PredictionContextCache.UNCACHED;
        let addKey;
        let key = this.getKey(e);
        let mergedConfig = this.mergedConfigs.get(key);
        addKey = mergedConfig == null;
        if (mergedConfig != null && this.canMerge(e, key, mergedConfig)) {
            mergedConfig.outerContextDepth = Math.max(mergedConfig.outerContextDepth, e.outerContextDepth);
            if (e.isPrecedenceFilterSuppressed) mergedConfig.isPrecedenceFilterSuppressed = true;
            let joined = $jaUCz.PredictionContext.join(mergedConfig.context, e.context, contextCache);
            this.updatePropertiesForMergedConfig(e);
            if (mergedConfig.context === joined) return false;
            mergedConfig.context = joined;
            return true;
        }
        for(let i = 0; i < this.unmerged.length; i++){
            let unmergedConfig = this.unmerged[i];
            if (this.canMerge(e, key, unmergedConfig)) {
                unmergedConfig.outerContextDepth = Math.max(unmergedConfig.outerContextDepth, e.outerContextDepth);
                if (e.isPrecedenceFilterSuppressed) unmergedConfig.isPrecedenceFilterSuppressed = true;
                let joined = $jaUCz.PredictionContext.join(unmergedConfig.context, e.context, contextCache);
                this.updatePropertiesForMergedConfig(e);
                if (unmergedConfig.context === joined) return false;
                unmergedConfig.context = joined;
                if (addKey) {
                    this.mergedConfigs.put(key, unmergedConfig);
                    this.unmerged.splice(i, 1);
                }
                return true;
            }
        }
        this.configs.push(e);
        if (addKey) this.mergedConfigs.put(key, e);
        else this.unmerged.push(e);
        this.updatePropertiesForAddedConfig(e);
        return true;
    }
    updatePropertiesForMergedConfig(config) {
        // merged configs can't change the alt or semantic context
        this._dipsIntoOuterContext = this._dipsIntoOuterContext || config.reachesIntoOuterContext;
        $fomfP(!this.outermostConfigSet || !this._dipsIntoOuterContext);
    }
    updatePropertiesForAddedConfig(config) {
        if (this.configs.length === 1) this._uniqueAlt = config.alt;
        else if (this._uniqueAlt !== config.alt) this._uniqueAlt = $eeOLb.ATN.INVALID_ALT_NUMBER;
        this._hasSemanticContext = this._hasSemanticContext || !$3JS45.SemanticContext.NONE.equals(config.semanticContext);
        this._dipsIntoOuterContext = this._dipsIntoOuterContext || config.reachesIntoOuterContext;
        $fomfP(!this.outermostConfigSet || !this._dipsIntoOuterContext);
    }
    canMerge(left, leftKey, right) {
        if (left.state.stateNumber !== right.state.stateNumber) return false;
        if (leftKey.alt !== right.alt) return false;
        return left.semanticContext.equals(right.semanticContext);
    }
    getKey(e) {
        return {
            state: e.state.stateNumber,
            alt: e.alt
        };
    }
    containsAll(c) {
        for (let o of c){
            if (!(o instanceof $hdFz0.ATNConfig)) return false;
            if (!this.contains(o)) return false;
        }
        return true;
    }
    addAll(c, contextCache) {
        this.ensureWritable();
        let changed = false;
        for (let group of c)if (this.add(group, contextCache)) changed = true;
        return changed;
    }
    clear() {
        this.ensureWritable();
        if (!this.mergedConfigs || !this.unmerged) throw new Error("Covered by ensureWritable but duplicated here for strict null check limitation");
        this.mergedConfigs.clear();
        this.unmerged.length = 0;
        this.configs.length = 0;
        this._dipsIntoOuterContext = false;
        this._hasSemanticContext = false;
        this._uniqueAlt = $eeOLb.ATN.INVALID_ALT_NUMBER;
        this._conflictInfo = undefined;
    }
    equals(obj) {
        if (this === obj) return true;
        if (!(obj instanceof $2191c0313d388677$var$ATNConfigSet)) return false;
        return this.outermostConfigSet === obj.outermostConfigSet && $62Uvn.equals(this._conflictInfo, obj._conflictInfo) && $6iIjF.ArrayEqualityComparator.INSTANCE.equals(this.configs, obj.configs);
    }
    hashCode() {
        if (this.isReadOnly && this.cachedHashCode !== -1) return this.cachedHashCode;
        let hashCode = 1;
        hashCode = 5 * hashCode ^ (this.outermostConfigSet ? 1 : 0);
        hashCode = 5 * hashCode ^ $6iIjF.ArrayEqualityComparator.INSTANCE.hashCode(this.configs);
        if (this.isReadOnly) this.cachedHashCode = hashCode;
        return hashCode;
    }
    toString(showContext) {
        if (showContext == null) showContext = false;
        let buf = "";
        let sortedConfigs = this.configs.slice(0);
        sortedConfigs.sort((o1, o2)=>{
            if (o1.alt !== o2.alt) return o1.alt - o2.alt;
            else if (o1.state.stateNumber !== o2.state.stateNumber) return o1.state.stateNumber - o2.state.stateNumber;
            else return o1.semanticContext.toString().localeCompare(o2.semanticContext.toString());
        });
        buf += "[";
        for(let i = 0; i < sortedConfigs.length; i++){
            if (i > 0) buf += ", ";
            buf += sortedConfigs[i].toString(undefined, true, showContext);
        }
        buf += "]";
        if (this._hasSemanticContext) buf += ",hasSemanticContext=" + this._hasSemanticContext;
        if (this._uniqueAlt !== $eeOLb.ATN.INVALID_ALT_NUMBER) buf += ",uniqueAlt=" + this._uniqueAlt;
        if (this._conflictInfo != null) {
            buf += ",conflictingAlts=" + this._conflictInfo.conflictedAlts;
            if (!this._conflictInfo.isExact) buf += "*";
        }
        if (this._dipsIntoOuterContext) buf += ",dipsIntoOuterContext";
        return buf.toString();
    }
    get uniqueAlt() {
        return this._uniqueAlt;
    }
    get hasSemanticContext() {
        return this._hasSemanticContext;
    }
    set hasSemanticContext(value) {
        this.ensureWritable();
        this._hasSemanticContext = value;
    }
    get conflictInfo() {
        return this._conflictInfo;
    }
    set conflictInfo(conflictInfo) {
        this.ensureWritable();
        this._conflictInfo = conflictInfo;
    }
    get conflictingAlts() {
        if (this._conflictInfo == null) return undefined;
        return this._conflictInfo.conflictedAlts;
    }
    get isExactConflict() {
        if (this._conflictInfo == null) return false;
        return this._conflictInfo.isExact;
    }
    get dipsIntoOuterContext() {
        return this._dipsIntoOuterContext;
    }
    get(index) {
        return this.configs[index];
    }
    ensureWritable() {
        if (this.isReadOnly) throw new Error("This ATNConfigSet is read only.");
    }
}
$2191c0313d388677$var$__decorate([
    $aN41m.NotNull
], $2191c0313d388677$var$ATNConfigSet.prototype, "getRepresentedAlternatives", null);
$2191c0313d388677$var$__decorate([
    $aN41m.Override
], $2191c0313d388677$var$ATNConfigSet.prototype, "size", null);
$2191c0313d388677$var$__decorate([
    $aN41m.Override
], $2191c0313d388677$var$ATNConfigSet.prototype, "isEmpty", null);
$2191c0313d388677$var$__decorate([
    $aN41m.Override
], $2191c0313d388677$var$ATNConfigSet.prototype, "contains", null);
$2191c0313d388677$var$__decorate([
    $aN41m.Override
], $2191c0313d388677$var$ATNConfigSet.prototype, Symbol.iterator, null);
$2191c0313d388677$var$__decorate([
    $aN41m.Override
], $2191c0313d388677$var$ATNConfigSet.prototype, "toArray", null);
$2191c0313d388677$var$__decorate([
    $aN41m.Override
], $2191c0313d388677$var$ATNConfigSet.prototype, "containsAll", null);
$2191c0313d388677$var$__decorate([
    $aN41m.Override
], $2191c0313d388677$var$ATNConfigSet.prototype, "clear", null);
$2191c0313d388677$var$__decorate([
    $aN41m.Override
], $2191c0313d388677$var$ATNConfigSet.prototype, "equals", null);
$2191c0313d388677$var$__decorate([
    $aN41m.Override
], $2191c0313d388677$var$ATNConfigSet.prototype, "hashCode", null);
module.exports.ATNConfigSet = $2191c0313d388677$var$ATNConfigSet;

});
parcelRegister("hdFz0", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c893e436b255fe4f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $c893e436b255fe4f$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNConfig = void 0;

var $jRlcM = parcelRequire("jRlcM");

var $42ptv = parcelRequire("42ptv");

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");

var $9eW9B = parcelRequire("9eW9B");

var $jaUCz = parcelRequire("jaUCz");

var $3JS45 = parcelRequire("3JS45");

var $fomfP = parcelRequire("fomfP");
/**
 * This field stores the bit mask for implementing the
 * {@link #isPrecedenceFilterSuppressed} property as a bit within the
 * existing {@link #altAndOuterContextDepth} field.
 */ const $c893e436b255fe4f$var$SUPPRESS_PRECEDENCE_FILTER = 0x80000000;
/**
 * Represents a location with context in an ATN. The location is identified by the following values:
 *
 * * The current ATN state
 * * The predicted alternative
 * * The semantic context which must be true for this configuration to be enabled
 * * The syntactic context, which is represented as a graph-structured stack whose path(s) lead to the root of the rule
 *   invocations leading to this state
 *
 * In addition to these values, `ATNConfig` stores several properties about paths taken to get to the location which
 * were added over time to help with performance, correctness, and/or debugging.
 *
 * * `reachesIntoOuterContext`:: Used to ensure semantic predicates are not evaluated in the wrong context.
 * * `hasPassedThroughNonGreedyDecision`: Used for enabling first-match-wins instead of longest-match-wins after
 *   crossing a non-greedy decision.
 * * `lexerActionExecutor`: Used for tracking the lexer action(s) to execute should this instance be selected during
 *   lexing.
 * * `isPrecedenceFilterSuppressed`: A state variable for one of the dynamic disambiguation strategies employed by
 *   `ParserATNSimulator.applyPrecedenceFilter`.
 *
 * Due to the use of a graph-structured stack, a single `ATNConfig` is capable of representing many individual ATN
 * configurations which reached the same location in an ATN by following different paths.
 *
 * PERF: To conserve memory, `ATNConfig` is split into several different concrete types. `ATNConfig` itself stores the
 * minimum amount of information typically used to define an `ATNConfig` instance. Various derived types provide
 * additional storage space for cases where a non-default value is used for some of the object properties. The
 * `ATNConfig.create` and `ATNConfig.transform` methods automatically select the smallest concrete type capable of
 * representing the unique information for any given `ATNConfig`.
 */ let $c893e436b255fe4f$var$ATNConfig = class ATNConfig {
    constructor(state, altOrConfig, context){
        if (typeof altOrConfig === "number") {
            $fomfP((altOrConfig & 0xFFFFFF) === altOrConfig);
            this._state = state;
            this.altAndOuterContextDepth = altOrConfig;
            this._context = context;
        } else {
            this._state = state;
            this.altAndOuterContextDepth = altOrConfig.altAndOuterContextDepth;
            this._context = context;
        }
    }
    static create(state, alt, context, semanticContext = $3JS45.SemanticContext.NONE, lexerActionExecutor) {
        if (semanticContext !== $3JS45.SemanticContext.NONE) {
            if (lexerActionExecutor != null) return new $c893e436b255fe4f$var$ActionSemanticContextATNConfig(lexerActionExecutor, semanticContext, state, alt, context, false);
            else return new $c893e436b255fe4f$var$SemanticContextATNConfig(semanticContext, state, alt, context);
        } else if (lexerActionExecutor != null) return new $c893e436b255fe4f$var$ActionATNConfig(lexerActionExecutor, state, alt, context, false);
        else return new ATNConfig(state, alt, context);
    }
    /** Gets the ATN state associated with this configuration */ get state() {
        return this._state;
    }
    /** What alt (or lexer rule) is predicted by this configuration */ get alt() {
        return this.altAndOuterContextDepth & 0x00FFFFFF;
    }
    get context() {
        return this._context;
    }
    set context(context) {
        this._context = context;
    }
    get reachesIntoOuterContext() {
        return this.outerContextDepth !== 0;
    }
    /**
     * We cannot execute predicates dependent upon local context unless
     * we know for sure we are in the correct context. Because there is
     * no way to do this efficiently, we simply cannot evaluate
     * dependent predicates unless we are in the rule that initially
     * invokes the ATN simulator.
     *
     * closure() tracks the depth of how far we dip into the outer context:
     * depth &gt; 0.  Note that it may not be totally accurate depth since I
     * don't ever decrement. TODO: make it a boolean then
     */ get outerContextDepth() {
        return this.altAndOuterContextDepth >>> 24 & 0x7F;
    }
    set outerContextDepth(outerContextDepth) {
        $fomfP(outerContextDepth >= 0);
        // saturate at 0x7F - everything but zero/positive is only used for debug information anyway
        outerContextDepth = Math.min(outerContextDepth, 0x7F);
        this.altAndOuterContextDepth = outerContextDepth << 24 | (this.altAndOuterContextDepth & -2130706433) >>> 0;
    }
    get lexerActionExecutor() {
        return undefined;
    }
    get semanticContext() {
        return $3JS45.SemanticContext.NONE;
    }
    get hasPassedThroughNonGreedyDecision() {
        return false;
    }
    clone() {
        return this.transform(this.state, false);
    }
    transform(/*@NotNull*/ state, checkNonGreedy, arg2) {
        if (arg2 == null) return this.transformImpl(state, this._context, this.semanticContext, checkNonGreedy, this.lexerActionExecutor);
        else if (arg2 instanceof $jaUCz.PredictionContext) return this.transformImpl(state, arg2, this.semanticContext, checkNonGreedy, this.lexerActionExecutor);
        else if (arg2 instanceof $3JS45.SemanticContext) return this.transformImpl(state, this._context, arg2, checkNonGreedy, this.lexerActionExecutor);
        else return this.transformImpl(state, this._context, this.semanticContext, checkNonGreedy, arg2);
    }
    transformImpl(state, context, semanticContext, checkNonGreedy, lexerActionExecutor) {
        let passedThroughNonGreedy = checkNonGreedy && ATNConfig.checkNonGreedyDecision(this, state);
        if (semanticContext !== $3JS45.SemanticContext.NONE) {
            if (lexerActionExecutor != null || passedThroughNonGreedy) return new $c893e436b255fe4f$var$ActionSemanticContextATNConfig(lexerActionExecutor, semanticContext, state, this, context, passedThroughNonGreedy);
            else return new $c893e436b255fe4f$var$SemanticContextATNConfig(semanticContext, state, this, context);
        } else if (lexerActionExecutor != null || passedThroughNonGreedy) return new $c893e436b255fe4f$var$ActionATNConfig(lexerActionExecutor, state, this, context, passedThroughNonGreedy);
        else return new ATNConfig(state, this, context);
    }
    static checkNonGreedyDecision(source, target) {
        return source.hasPassedThroughNonGreedyDecision || target instanceof $42ptv.DecisionState && target.nonGreedy;
    }
    appendContext(context, contextCache) {
        if (typeof context === "number") {
            let appendedContext = this.context.appendSingleContext(context, contextCache);
            let result = this.transform(this.state, false, appendedContext);
            return result;
        } else {
            let appendedContext = this.context.appendContext(context, contextCache);
            let result = this.transform(this.state, false, appendedContext);
            return result;
        }
    }
    /**
     * Determines if this `ATNConfig` fully contains another `ATNConfig`.
     *
     * An ATN configuration represents a position (including context) in an ATN during parsing. Since `ATNConfig` stores
     * the context as a graph, a single `ATNConfig` instance is capable of representing many ATN configurations which
     * are all in the same "location" but have different contexts. These `ATNConfig` instances are again merged when
     * they are added to an `ATNConfigSet`. This method supports `ATNConfigSet.contains` by evaluating whether a
     * particular `ATNConfig` contains all of the ATN configurations represented by another `ATNConfig`.
     *
     * An `ATNConfig` _a_ contains another `ATNConfig` _b_ if all of the following conditions are met:
     *
     * * The configurations are in the same state (`state`)
     * * The configurations predict the same alternative (`alt`)
     * * The semantic context of _a_ implies the semantic context of _b_ (this method performs a weaker equality check)
     * * Joining the prediction contexts of _a_ and _b_ results in the prediction context of _a_
     *
     * This method implements a conservative approximation of containment. As a result, when this method returns `true`
     * it is known that parsing from `subconfig` can only recognize a subset of the inputs which can be recognized
     * starting at the current `ATNConfig`. However, due to the imprecise evaluation of implication for the semantic
     * contexts, no assumptions can be made about the relationship between the configurations when this method returns
     * `false`.
     *
     * @param subconfig The sub configuration.
     * @returns `true` if this configuration contains `subconfig`; otherwise, `false`.
     */ contains(subconfig) {
        if (this.state.stateNumber !== subconfig.state.stateNumber || this.alt !== subconfig.alt || !this.semanticContext.equals(subconfig.semanticContext)) return false;
        let leftWorkList = [];
        let rightWorkList = [];
        leftWorkList.push(this.context);
        rightWorkList.push(subconfig.context);
        while(true){
            let left = leftWorkList.pop();
            let right = rightWorkList.pop();
            if (!left || !right) break;
            if (left === right) return true;
            if (left.size < right.size) return false;
            if (right.isEmpty) return left.hasEmpty;
            else for(let i = 0; i < right.size; i++){
                let index = left.findReturnState(right.getReturnState(i));
                if (index < 0) // assumes invokingStates has no duplicate entries
                return false;
                leftWorkList.push(left.getParent(index));
                rightWorkList.push(right.getParent(i));
            }
        }
        return false;
    }
    get isPrecedenceFilterSuppressed() {
        return (this.altAndOuterContextDepth & $c893e436b255fe4f$var$SUPPRESS_PRECEDENCE_FILTER) !== 0;
    }
    set isPrecedenceFilterSuppressed(value) {
        if (value) this.altAndOuterContextDepth |= $c893e436b255fe4f$var$SUPPRESS_PRECEDENCE_FILTER;
        else this.altAndOuterContextDepth &= ~$c893e436b255fe4f$var$SUPPRESS_PRECEDENCE_FILTER;
    }
    /** An ATN configuration is equal to another if both have
     *  the same state, they predict the same alternative, and
     *  syntactic/semantic contexts are the same.
     */ equals(o) {
        if (this === o) return true;
        else if (!(o instanceof ATNConfig)) return false;
        return this.state.stateNumber === o.state.stateNumber && this.alt === o.alt && this.reachesIntoOuterContext === o.reachesIntoOuterContext && this.context.equals(o.context) && this.semanticContext.equals(o.semanticContext) && this.isPrecedenceFilterSuppressed === o.isPrecedenceFilterSuppressed && this.hasPassedThroughNonGreedyDecision === o.hasPassedThroughNonGreedyDecision && $9eW9B.ObjectEqualityComparator.INSTANCE.equals(this.lexerActionExecutor, o.lexerActionExecutor);
    }
    hashCode() {
        let hashCode = $amQx9.MurmurHash.initialize(7);
        hashCode = $amQx9.MurmurHash.update(hashCode, this.state.stateNumber);
        hashCode = $amQx9.MurmurHash.update(hashCode, this.alt);
        hashCode = $amQx9.MurmurHash.update(hashCode, this.reachesIntoOuterContext ? 1 : 0);
        hashCode = $amQx9.MurmurHash.update(hashCode, this.context);
        hashCode = $amQx9.MurmurHash.update(hashCode, this.semanticContext);
        hashCode = $amQx9.MurmurHash.update(hashCode, this.hasPassedThroughNonGreedyDecision ? 1 : 0);
        hashCode = $amQx9.MurmurHash.update(hashCode, this.lexerActionExecutor);
        hashCode = $amQx9.MurmurHash.finish(hashCode, 7);
        return hashCode;
    }
    /**
     * Returns a graphical representation of the current `ATNConfig` in Graphviz format. The graph can be stored to a
     * **.dot** file and then rendered to an image using Graphviz.
     *
     * @returns A Graphviz graph representing the current `ATNConfig`.
     *
     * @see http://www.graphviz.org/
     */ toDotString() {
        let builder = "";
        builder += "digraph G {\n";
        builder += "rankdir=LR;\n";
        let visited = new $jRlcM.Array2DHashMap($jaUCz.PredictionContext.IdentityEqualityComparator.INSTANCE);
        let workList = [];
        function getOrAddContext(context) {
            let newNumber = visited.size;
            let result = visited.putIfAbsent(context, newNumber);
            if (result != null) // Already saw this context
            return result;
            workList.push(context);
            return newNumber;
        }
        workList.push(this.context);
        visited.put(this.context, 0);
        while(true){
            let current = workList.pop();
            if (!current) break;
            for(let i = 0; i < current.size; i++){
                builder += "  s" + getOrAddContext(current);
                builder += "->";
                builder += "s" + getOrAddContext(current.getParent(i));
                builder += "[label=\"" + current.getReturnState(i) + "\"];\n";
            }
        }
        builder += "}\n";
        return builder.toString();
    }
    toString(recog, showAlt, showContext) {
        // Must check showContext before showAlt to preserve original overload behavior
        if (showContext == null) showContext = showAlt != null;
        if (showAlt == null) showAlt = true;
        let buf = "";
        // if (this.state.ruleIndex >= 0) {
        // 	if (recog != null) {
        // 		buf += (recog.ruleNames[this.state.ruleIndex] + ":");
        // 	} else {
        // 		buf += (this.state.ruleIndex + ":");
        // 	}
        // }
        let contexts;
        if (showContext) contexts = this.context.toStrings(recog, this.state.stateNumber);
        else contexts = [
            "?"
        ];
        let first = true;
        for (let contextDesc of contexts){
            if (first) first = false;
            else buf += ", ";
            buf += "(";
            buf += this.state;
            if (showAlt) {
                buf += ",";
                buf += this.alt;
            }
            if (this.context) {
                buf += ",";
                buf += contextDesc;
            }
            if (this.semanticContext !== $3JS45.SemanticContext.NONE) {
                buf += ",";
                buf += this.semanticContext;
            }
            if (this.reachesIntoOuterContext) buf += ",up=" + this.outerContextDepth;
            buf += ")";
        }
        return buf.toString();
    }
};
$c893e436b255fe4f$var$__decorate([
    $aN41m.NotNull
], $c893e436b255fe4f$var$ATNConfig.prototype, "_state", void 0);
$c893e436b255fe4f$var$__decorate([
    $aN41m.NotNull
], $c893e436b255fe4f$var$ATNConfig.prototype, "_context", void 0);
$c893e436b255fe4f$var$__decorate([
    $aN41m.NotNull
], $c893e436b255fe4f$var$ATNConfig.prototype, "state", null);
$c893e436b255fe4f$var$__decorate([
    $aN41m.NotNull,
    $c893e436b255fe4f$var$__param(0, $aN41m.NotNull)
], $c893e436b255fe4f$var$ATNConfig.prototype, "context", null);
$c893e436b255fe4f$var$__decorate([
    $aN41m.NotNull
], $c893e436b255fe4f$var$ATNConfig.prototype, "semanticContext", null);
$c893e436b255fe4f$var$__decorate([
    $aN41m.Override
], $c893e436b255fe4f$var$ATNConfig.prototype, "clone", null);
$c893e436b255fe4f$var$__decorate([
    $c893e436b255fe4f$var$__param(0, $aN41m.NotNull),
    $c893e436b255fe4f$var$__param(2, $aN41m.NotNull)
], $c893e436b255fe4f$var$ATNConfig.prototype, "transformImpl", null);
$c893e436b255fe4f$var$__decorate([
    $aN41m.Override
], $c893e436b255fe4f$var$ATNConfig.prototype, "equals", null);
$c893e436b255fe4f$var$__decorate([
    $aN41m.Override
], $c893e436b255fe4f$var$ATNConfig.prototype, "hashCode", null);
$c893e436b255fe4f$var$__decorate([
    $c893e436b255fe4f$var$__param(0, $aN41m.NotNull),
    $c893e436b255fe4f$var$__param(3, $aN41m.NotNull)
], $c893e436b255fe4f$var$ATNConfig, "create", null);
$c893e436b255fe4f$var$ATNConfig = $c893e436b255fe4f$var$__decorate([
    $c893e436b255fe4f$var$__param(0, $aN41m.NotNull),
    $c893e436b255fe4f$var$__param(2, $aN41m.NotNull)
], $c893e436b255fe4f$var$ATNConfig);
module.exports.ATNConfig = $c893e436b255fe4f$var$ATNConfig;
/**
 * This class was derived from `ATNConfig` purely as a memory optimization. It allows for the creation of an `ATNConfig`
 * with a non-default semantic context.
 *
 * See the `ATNConfig` documentation for more information about conserving memory through the use of several concrete
 * types.
 */ let $c893e436b255fe4f$var$SemanticContextATNConfig = class SemanticContextATNConfig extends $c893e436b255fe4f$var$ATNConfig {
    constructor(semanticContext, state, altOrConfig, context){
        if (typeof altOrConfig === "number") super(state, altOrConfig, context);
        else super(state, altOrConfig, context);
        this._semanticContext = semanticContext;
    }
    get semanticContext() {
        return this._semanticContext;
    }
};
$c893e436b255fe4f$var$__decorate([
    $aN41m.NotNull
], $c893e436b255fe4f$var$SemanticContextATNConfig.prototype, "_semanticContext", void 0);
$c893e436b255fe4f$var$__decorate([
    $aN41m.Override
], $c893e436b255fe4f$var$SemanticContextATNConfig.prototype, "semanticContext", null);
$c893e436b255fe4f$var$SemanticContextATNConfig = $c893e436b255fe4f$var$__decorate([
    $c893e436b255fe4f$var$__param(1, $aN41m.NotNull),
    $c893e436b255fe4f$var$__param(2, $aN41m.NotNull)
], $c893e436b255fe4f$var$SemanticContextATNConfig);
/**
 * This class was derived from `ATNConfig` purely as a memory optimization. It allows for the creation of an `ATNConfig`
 * with a lexer action.
 *
 * See the `ATNConfig` documentation for more information about conserving memory through the use of several concrete
 * types.
 */ let $c893e436b255fe4f$var$ActionATNConfig = class ActionATNConfig extends $c893e436b255fe4f$var$ATNConfig {
    constructor(lexerActionExecutor, state, altOrConfig, context, passedThroughNonGreedyDecision){
        if (typeof altOrConfig === "number") super(state, altOrConfig, context);
        else {
            super(state, altOrConfig, context);
            if (altOrConfig.semanticContext !== $3JS45.SemanticContext.NONE) throw new Error("Not supported");
        }
        this._lexerActionExecutor = lexerActionExecutor;
        this.passedThroughNonGreedyDecision = passedThroughNonGreedyDecision;
    }
    get lexerActionExecutor() {
        return this._lexerActionExecutor;
    }
    get hasPassedThroughNonGreedyDecision() {
        return this.passedThroughNonGreedyDecision;
    }
};
$c893e436b255fe4f$var$__decorate([
    $aN41m.Override
], $c893e436b255fe4f$var$ActionATNConfig.prototype, "lexerActionExecutor", null);
$c893e436b255fe4f$var$__decorate([
    $aN41m.Override
], $c893e436b255fe4f$var$ActionATNConfig.prototype, "hasPassedThroughNonGreedyDecision", null);
$c893e436b255fe4f$var$ActionATNConfig = $c893e436b255fe4f$var$__decorate([
    $c893e436b255fe4f$var$__param(1, $aN41m.NotNull),
    $c893e436b255fe4f$var$__param(2, $aN41m.NotNull)
], $c893e436b255fe4f$var$ActionATNConfig);
/**
 * This class was derived from `SemanticContextATNConfig` purely as a memory optimization. It allows for the creation of
 * an `ATNConfig` with both a lexer action and a non-default semantic context.
 *
 * See the `ATNConfig` documentation for more information about conserving memory through the use of several concrete
 * types.
 */ let $c893e436b255fe4f$var$ActionSemanticContextATNConfig = class ActionSemanticContextATNConfig extends $c893e436b255fe4f$var$SemanticContextATNConfig {
    constructor(lexerActionExecutor, semanticContext, state, altOrConfig, context, passedThroughNonGreedyDecision){
        if (typeof altOrConfig === "number") super(semanticContext, state, altOrConfig, context);
        else super(semanticContext, state, altOrConfig, context);
        this._lexerActionExecutor = lexerActionExecutor;
        this.passedThroughNonGreedyDecision = passedThroughNonGreedyDecision;
    }
    get lexerActionExecutor() {
        return this._lexerActionExecutor;
    }
    get hasPassedThroughNonGreedyDecision() {
        return this.passedThroughNonGreedyDecision;
    }
};
$c893e436b255fe4f$var$__decorate([
    $aN41m.Override
], $c893e436b255fe4f$var$ActionSemanticContextATNConfig.prototype, "lexerActionExecutor", null);
$c893e436b255fe4f$var$__decorate([
    $aN41m.Override
], $c893e436b255fe4f$var$ActionSemanticContextATNConfig.prototype, "hasPassedThroughNonGreedyDecision", null);
$c893e436b255fe4f$var$ActionSemanticContextATNConfig = $c893e436b255fe4f$var$__decorate([
    $c893e436b255fe4f$var$__param(1, $aN41m.NotNull),
    $c893e436b255fe4f$var$__param(2, $aN41m.NotNull)
], $c893e436b255fe4f$var$ActionSemanticContextATNConfig);

});
parcelRegister("42ptv", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DecisionState = void 0;

var $dv9vN = parcelRequire("dv9vN");
class $2f0b1c18dfdc93d3$var$DecisionState extends $dv9vN.ATNState {
    constructor(){
        super(...arguments);
        this.decision = -1;
        this.nonGreedy = false;
        this.sll = false;
    }
}
module.exports.DecisionState = $2f0b1c18dfdc93d3$var$DecisionState;

});

parcelRegister("jaUCz", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $df5adf3eeab6304c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $df5adf3eeab6304c$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SingletonPredictionContext = module.exports.PredictionContext = void 0;

var $jRlcM = parcelRequire("jRlcM");

var $fsqYw = parcelRequire("fsqYw");

var $4dKou = parcelRequire("4dKou");

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");

var $4BvNW = parcelRequire("4BvNW");

var $fomfP = parcelRequire("fomfP");
const $df5adf3eeab6304c$var$INITIAL_HASH = 1;
class $df5adf3eeab6304c$var$PredictionContext {
    constructor(cachedHashCode){
        this.cachedHashCode = cachedHashCode;
    }
    static calculateEmptyHashCode() {
        let hash = $amQx9.MurmurHash.initialize($df5adf3eeab6304c$var$INITIAL_HASH);
        hash = $amQx9.MurmurHash.finish(hash, 0);
        return hash;
    }
    static calculateSingleHashCode(parent, returnState) {
        let hash = $amQx9.MurmurHash.initialize($df5adf3eeab6304c$var$INITIAL_HASH);
        hash = $amQx9.MurmurHash.update(hash, parent);
        hash = $amQx9.MurmurHash.update(hash, returnState);
        hash = $amQx9.MurmurHash.finish(hash, 2);
        return hash;
    }
    static calculateHashCode(parents, returnStates) {
        let hash = $amQx9.MurmurHash.initialize($df5adf3eeab6304c$var$INITIAL_HASH);
        for (let parent of parents)hash = $amQx9.MurmurHash.update(hash, parent);
        for (let returnState of returnStates)hash = $amQx9.MurmurHash.update(hash, returnState);
        hash = $amQx9.MurmurHash.finish(hash, 2 * parents.length);
        return hash;
    }
    static fromRuleContext(atn, outerContext, fullContext = true) {
        if (outerContext.isEmpty) return fullContext ? $df5adf3eeab6304c$var$PredictionContext.EMPTY_FULL : $df5adf3eeab6304c$var$PredictionContext.EMPTY_LOCAL;
        let parent;
        if (outerContext._parent) parent = $df5adf3eeab6304c$var$PredictionContext.fromRuleContext(atn, outerContext._parent, fullContext);
        else parent = fullContext ? $df5adf3eeab6304c$var$PredictionContext.EMPTY_FULL : $df5adf3eeab6304c$var$PredictionContext.EMPTY_LOCAL;
        let state = atn.states[outerContext.invokingState];
        let transition = state.transition(0);
        return parent.getChild(transition.followState.stateNumber);
    }
    static addEmptyContext(context) {
        return context.addEmptyContext();
    }
    static removeEmptyContext(context) {
        return context.removeEmptyContext();
    }
    static join(context0, context1, contextCache = $4BvNW.PredictionContextCache.UNCACHED) {
        if (context0 === context1) return context0;
        if (context0.isEmpty) return $df5adf3eeab6304c$var$PredictionContext.isEmptyLocal(context0) ? context0 : $df5adf3eeab6304c$var$PredictionContext.addEmptyContext(context1);
        else if (context1.isEmpty) return $df5adf3eeab6304c$var$PredictionContext.isEmptyLocal(context1) ? context1 : $df5adf3eeab6304c$var$PredictionContext.addEmptyContext(context0);
        let context0size = context0.size;
        let context1size = context1.size;
        if (context0size === 1 && context1size === 1 && context0.getReturnState(0) === context1.getReturnState(0)) {
            let merged = contextCache.join(context0.getParent(0), context1.getParent(0));
            if (merged === context0.getParent(0)) return context0;
            else if (merged === context1.getParent(0)) return context1;
            else return merged.getChild(context0.getReturnState(0));
        }
        let count = 0;
        let parentsList = new Array(context0size + context1size);
        let returnStatesList = new Array(parentsList.length);
        let leftIndex = 0;
        let rightIndex = 0;
        let canReturnLeft = true;
        let canReturnRight = true;
        while(leftIndex < context0size && rightIndex < context1size){
            if (context0.getReturnState(leftIndex) === context1.getReturnState(rightIndex)) {
                parentsList[count] = contextCache.join(context0.getParent(leftIndex), context1.getParent(rightIndex));
                returnStatesList[count] = context0.getReturnState(leftIndex);
                canReturnLeft = canReturnLeft && parentsList[count] === context0.getParent(leftIndex);
                canReturnRight = canReturnRight && parentsList[count] === context1.getParent(rightIndex);
                leftIndex++;
                rightIndex++;
            } else if (context0.getReturnState(leftIndex) < context1.getReturnState(rightIndex)) {
                parentsList[count] = context0.getParent(leftIndex);
                returnStatesList[count] = context0.getReturnState(leftIndex);
                canReturnRight = false;
                leftIndex++;
            } else {
                $fomfP(context1.getReturnState(rightIndex) < context0.getReturnState(leftIndex));
                parentsList[count] = context1.getParent(rightIndex);
                returnStatesList[count] = context1.getReturnState(rightIndex);
                canReturnLeft = false;
                rightIndex++;
            }
            count++;
        }
        while(leftIndex < context0size){
            parentsList[count] = context0.getParent(leftIndex);
            returnStatesList[count] = context0.getReturnState(leftIndex);
            leftIndex++;
            canReturnRight = false;
            count++;
        }
        while(rightIndex < context1size){
            parentsList[count] = context1.getParent(rightIndex);
            returnStatesList[count] = context1.getReturnState(rightIndex);
            rightIndex++;
            canReturnLeft = false;
            count++;
        }
        if (canReturnLeft) return context0;
        else if (canReturnRight) return context1;
        if (count < parentsList.length) {
            parentsList = parentsList.slice(0, count);
            returnStatesList = returnStatesList.slice(0, count);
        }
        if (parentsList.length === 0) // if one of them was EMPTY_LOCAL, it would be empty and handled at the beginning of the method
        return $df5adf3eeab6304c$var$PredictionContext.EMPTY_FULL;
        else if (parentsList.length === 1) return new $df5adf3eeab6304c$var$SingletonPredictionContext(parentsList[0], returnStatesList[0]);
        else return new $df5adf3eeab6304c$var$ArrayPredictionContext(parentsList, returnStatesList);
    }
    static isEmptyLocal(context) {
        return context === $df5adf3eeab6304c$var$PredictionContext.EMPTY_LOCAL;
    }
    static getCachedContext(context, contextCache, visited) {
        if (context.isEmpty) return context;
        let existing = visited.get(context);
        if (existing) return existing;
        existing = contextCache.get(context);
        if (existing) {
            visited.put(context, existing);
            return existing;
        }
        let changed = false;
        let parents = new Array(context.size);
        for(let i = 0; i < parents.length; i++){
            let parent = $df5adf3eeab6304c$var$PredictionContext.getCachedContext(context.getParent(i), contextCache, visited);
            if (changed || parent !== context.getParent(i)) {
                if (!changed) {
                    parents = new Array(context.size);
                    for(let j = 0; j < context.size; j++)parents[j] = context.getParent(j);
                    changed = true;
                }
                parents[i] = parent;
            }
        }
        if (!changed) {
            existing = contextCache.putIfAbsent(context, context);
            visited.put(context, existing != null ? existing : context);
            return context;
        }
        // We know parents.length>0 because context.isEmpty is checked at the beginning of the method.
        let updated;
        if (parents.length === 1) updated = new $df5adf3eeab6304c$var$SingletonPredictionContext(parents[0], context.getReturnState(0));
        else {
            let returnStates = new Array(context.size);
            for(let i = 0; i < context.size; i++)returnStates[i] = context.getReturnState(i);
            updated = new $df5adf3eeab6304c$var$ArrayPredictionContext(parents, returnStates, context.hashCode());
        }
        existing = contextCache.putIfAbsent(updated, updated);
        visited.put(updated, existing || updated);
        visited.put(context, existing || updated);
        return updated;
    }
    appendSingleContext(returnContext, contextCache) {
        return this.appendContext($df5adf3eeab6304c$var$PredictionContext.EMPTY_FULL.getChild(returnContext), contextCache);
    }
    getChild(returnState) {
        return new $df5adf3eeab6304c$var$SingletonPredictionContext(this, returnState);
    }
    hashCode() {
        return this.cachedHashCode;
    }
    toStrings(recognizer, currentState, stop = $df5adf3eeab6304c$var$PredictionContext.EMPTY_FULL) {
        let result = [];
        outer: for(let perm = 0;; perm++){
            let offset = 0;
            let last = true;
            let p = this;
            let stateNumber = currentState;
            let localBuffer = "";
            localBuffer += "[";
            while(!p.isEmpty && p !== stop){
                let index = 0;
                if (p.size > 0) {
                    let bits = 1;
                    while(1 << bits >>> 0 < p.size)bits++;
                    let mask = (1 << bits >>> 0) - 1;
                    index = perm >> offset & mask;
                    last = last && index >= p.size - 1;
                    if (index >= p.size) continue outer;
                    offset += bits;
                }
                if (recognizer) {
                    if (localBuffer.length > 1) // first char is '[', if more than that this isn't the first rule
                    localBuffer += " ";
                    let atn = recognizer.atn;
                    let s = atn.states[stateNumber];
                    let ruleName = recognizer.ruleNames[s.ruleIndex];
                    localBuffer += ruleName;
                } else if (p.getReturnState(index) !== $df5adf3eeab6304c$var$PredictionContext.EMPTY_FULL_STATE_KEY) {
                    if (!p.isEmpty) {
                        if (localBuffer.length > 1) // first char is '[', if more than that this isn't the first rule
                        localBuffer += " ";
                        localBuffer += p.getReturnState(index);
                    }
                }
                stateNumber = p.getReturnState(index);
                p = p.getParent(index);
            }
            localBuffer += "]";
            result.push(localBuffer);
            if (last) break;
        }
        return result;
    }
}
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$PredictionContext.prototype, "hashCode", null);
$df5adf3eeab6304c$var$__decorate([
    $df5adf3eeab6304c$var$__param(0, $aN41m.NotNull),
    $df5adf3eeab6304c$var$__param(1, $aN41m.NotNull),
    $df5adf3eeab6304c$var$__param(2, $aN41m.NotNull)
], $df5adf3eeab6304c$var$PredictionContext, "join", null);
$df5adf3eeab6304c$var$__decorate([
    $df5adf3eeab6304c$var$__param(0, $aN41m.NotNull),
    $df5adf3eeab6304c$var$__param(1, $aN41m.NotNull),
    $df5adf3eeab6304c$var$__param(2, $aN41m.NotNull)
], $df5adf3eeab6304c$var$PredictionContext, "getCachedContext", null);
module.exports.PredictionContext = $df5adf3eeab6304c$var$PredictionContext;
class $df5adf3eeab6304c$var$EmptyPredictionContext extends $df5adf3eeab6304c$var$PredictionContext {
    constructor(fullContext){
        super($df5adf3eeab6304c$var$PredictionContext.calculateEmptyHashCode());
        this.fullContext = fullContext;
    }
    get isFullContext() {
        return this.fullContext;
    }
    addEmptyContext() {
        return this;
    }
    removeEmptyContext() {
        throw new Error("Cannot remove the empty context from itself.");
    }
    getParent(index) {
        throw new Error("index out of bounds");
    }
    getReturnState(index) {
        throw new Error("index out of bounds");
    }
    findReturnState(returnState) {
        return -1;
    }
    get size() {
        return 0;
    }
    appendSingleContext(returnContext, contextCache) {
        return contextCache.getChild(this, returnContext);
    }
    appendContext(suffix, contextCache) {
        return suffix;
    }
    get isEmpty() {
        return true;
    }
    get hasEmpty() {
        return true;
    }
    equals(o) {
        return this === o;
    }
    toStrings(recognizer, currentState, stop) {
        return [
            "[]"
        ];
    }
}
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$EmptyPredictionContext.prototype, "addEmptyContext", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$EmptyPredictionContext.prototype, "removeEmptyContext", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$EmptyPredictionContext.prototype, "getParent", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$EmptyPredictionContext.prototype, "getReturnState", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$EmptyPredictionContext.prototype, "findReturnState", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$EmptyPredictionContext.prototype, "size", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$EmptyPredictionContext.prototype, "appendSingleContext", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$EmptyPredictionContext.prototype, "appendContext", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$EmptyPredictionContext.prototype, "isEmpty", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$EmptyPredictionContext.prototype, "hasEmpty", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$EmptyPredictionContext.prototype, "equals", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$EmptyPredictionContext.prototype, "toStrings", null);
let $df5adf3eeab6304c$var$ArrayPredictionContext = class ArrayPredictionContext extends $df5adf3eeab6304c$var$PredictionContext {
    constructor(parents, returnStates, hashCode){
        super(hashCode || $df5adf3eeab6304c$var$PredictionContext.calculateHashCode(parents, returnStates));
        $fomfP(parents.length === returnStates.length);
        $fomfP(returnStates.length > 1 || returnStates[0] !== $df5adf3eeab6304c$var$PredictionContext.EMPTY_FULL_STATE_KEY, "Should be using PredictionContext.EMPTY instead.");
        this.parents = parents;
        this.returnStates = returnStates;
    }
    getParent(index) {
        return this.parents[index];
    }
    getReturnState(index) {
        return this.returnStates[index];
    }
    findReturnState(returnState) {
        return $4dKou.Arrays.binarySearch(this.returnStates, returnState);
    }
    get size() {
        return this.returnStates.length;
    }
    get isEmpty() {
        return false;
    }
    get hasEmpty() {
        return this.returnStates[this.returnStates.length - 1] === $df5adf3eeab6304c$var$PredictionContext.EMPTY_FULL_STATE_KEY;
    }
    addEmptyContext() {
        if (this.hasEmpty) return this;
        let parents2 = this.parents.slice(0);
        let returnStates2 = this.returnStates.slice(0);
        parents2.push($df5adf3eeab6304c$var$PredictionContext.EMPTY_FULL);
        returnStates2.push($df5adf3eeab6304c$var$PredictionContext.EMPTY_FULL_STATE_KEY);
        return new ArrayPredictionContext(parents2, returnStates2);
    }
    removeEmptyContext() {
        if (!this.hasEmpty) return this;
        if (this.returnStates.length === 2) return new $df5adf3eeab6304c$var$SingletonPredictionContext(this.parents[0], this.returnStates[0]);
        else {
            let parents2 = this.parents.slice(0, this.parents.length - 1);
            let returnStates2 = this.returnStates.slice(0, this.returnStates.length - 1);
            return new ArrayPredictionContext(parents2, returnStates2);
        }
    }
    appendContext(suffix, contextCache) {
        return ArrayPredictionContext.appendContextImpl(this, suffix, new $df5adf3eeab6304c$var$PredictionContext.IdentityHashMap());
    }
    static appendContextImpl(context, suffix, visited) {
        if (suffix.isEmpty) {
            if ($df5adf3eeab6304c$var$PredictionContext.isEmptyLocal(suffix)) {
                if (context.hasEmpty) return $df5adf3eeab6304c$var$PredictionContext.EMPTY_LOCAL;
                throw new Error("what to do here?");
            }
            return context;
        }
        if (suffix.size !== 1) throw new Error("Appending a tree suffix is not yet supported.");
        let result = visited.get(context);
        if (!result) {
            if (context.isEmpty) result = suffix;
            else {
                let parentCount = context.size;
                if (context.hasEmpty) parentCount--;
                let updatedParents = new Array(parentCount);
                let updatedReturnStates = new Array(parentCount);
                for(let i = 0; i < parentCount; i++)updatedReturnStates[i] = context.getReturnState(i);
                for(let i = 0; i < parentCount; i++)updatedParents[i] = ArrayPredictionContext.appendContextImpl(context.getParent(i), suffix, visited);
                if (updatedParents.length === 1) result = new $df5adf3eeab6304c$var$SingletonPredictionContext(updatedParents[0], updatedReturnStates[0]);
                else {
                    $fomfP(updatedParents.length > 1);
                    result = new ArrayPredictionContext(updatedParents, updatedReturnStates);
                }
                if (context.hasEmpty) result = $df5adf3eeab6304c$var$PredictionContext.join(result, suffix);
            }
            visited.put(context, result);
        }
        return result;
    }
    equals(o) {
        if (this === o) return true;
        else if (!(o instanceof ArrayPredictionContext)) return false;
        if (this.hashCode() !== o.hashCode()) // can't be same if hash is different
        return false;
        let other = o;
        return this.equalsImpl(other, new $fsqYw.Array2DHashSet());
    }
    equalsImpl(other, visited) {
        let selfWorkList = [];
        let otherWorkList = [];
        selfWorkList.push(this);
        otherWorkList.push(other);
        while(true){
            let currentSelf = selfWorkList.pop();
            let currentOther = otherWorkList.pop();
            if (!currentSelf || !currentOther) break;
            let operands = new $4BvNW.PredictionContextCache.IdentityCommutativePredictionContextOperands(currentSelf, currentOther);
            if (!visited.add(operands)) continue;
            let selfSize = operands.x.size;
            if (selfSize === 0) {
                if (!operands.x.equals(operands.y)) return false;
                continue;
            }
            let otherSize = operands.y.size;
            if (selfSize !== otherSize) return false;
            for(let i = 0; i < selfSize; i++){
                if (operands.x.getReturnState(i) !== operands.y.getReturnState(i)) return false;
                let selfParent = operands.x.getParent(i);
                let otherParent = operands.y.getParent(i);
                if (selfParent.hashCode() !== otherParent.hashCode()) return false;
                if (selfParent !== otherParent) {
                    selfWorkList.push(selfParent);
                    otherWorkList.push(otherParent);
                }
            }
        }
        return true;
    }
};
$df5adf3eeab6304c$var$__decorate([
    $aN41m.NotNull
], $df5adf3eeab6304c$var$ArrayPredictionContext.prototype, "parents", void 0);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.NotNull
], $df5adf3eeab6304c$var$ArrayPredictionContext.prototype, "returnStates", void 0);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$ArrayPredictionContext.prototype, "getParent", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$ArrayPredictionContext.prototype, "getReturnState", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$ArrayPredictionContext.prototype, "findReturnState", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$ArrayPredictionContext.prototype, "size", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$ArrayPredictionContext.prototype, "isEmpty", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$ArrayPredictionContext.prototype, "hasEmpty", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$ArrayPredictionContext.prototype, "addEmptyContext", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$ArrayPredictionContext.prototype, "removeEmptyContext", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$ArrayPredictionContext.prototype, "appendContext", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$ArrayPredictionContext.prototype, "equals", null);
$df5adf3eeab6304c$var$ArrayPredictionContext = $df5adf3eeab6304c$var$__decorate([
    $df5adf3eeab6304c$var$__param(0, $aN41m.NotNull)
], $df5adf3eeab6304c$var$ArrayPredictionContext);
let $df5adf3eeab6304c$var$SingletonPredictionContext = class SingletonPredictionContext extends $df5adf3eeab6304c$var$PredictionContext {
    constructor(parent, returnState){
        super($df5adf3eeab6304c$var$PredictionContext.calculateSingleHashCode(parent, returnState));
        // assert(returnState != PredictionContext.EMPTY_FULL_STATE_KEY && returnState != PredictionContext.EMPTY_LOCAL_STATE_KEY);
        this.parent = parent;
        this.returnState = returnState;
    }
    getParent(index) {
        // assert(index == 0);
        return this.parent;
    }
    getReturnState(index) {
        // assert(index == 0);
        return this.returnState;
    }
    findReturnState(returnState) {
        return this.returnState === returnState ? 0 : -1;
    }
    get size() {
        return 1;
    }
    get isEmpty() {
        return false;
    }
    get hasEmpty() {
        return false;
    }
    appendContext(suffix, contextCache) {
        return contextCache.getChild(this.parent.appendContext(suffix, contextCache), this.returnState);
    }
    addEmptyContext() {
        let parents = [
            this.parent,
            $df5adf3eeab6304c$var$PredictionContext.EMPTY_FULL
        ];
        let returnStates = [
            this.returnState,
            $df5adf3eeab6304c$var$PredictionContext.EMPTY_FULL_STATE_KEY
        ];
        return new $df5adf3eeab6304c$var$ArrayPredictionContext(parents, returnStates);
    }
    removeEmptyContext() {
        return this;
    }
    equals(o) {
        if (o === this) return true;
        else if (!(o instanceof SingletonPredictionContext)) return false;
        let other = o;
        if (this.hashCode() !== other.hashCode()) return false;
        return this.returnState === other.returnState && this.parent.equals(other.parent);
    }
};
$df5adf3eeab6304c$var$__decorate([
    $aN41m.NotNull
], $df5adf3eeab6304c$var$SingletonPredictionContext.prototype, "parent", void 0);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$SingletonPredictionContext.prototype, "getParent", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$SingletonPredictionContext.prototype, "getReturnState", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$SingletonPredictionContext.prototype, "findReturnState", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$SingletonPredictionContext.prototype, "size", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$SingletonPredictionContext.prototype, "isEmpty", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$SingletonPredictionContext.prototype, "hasEmpty", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$SingletonPredictionContext.prototype, "appendContext", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$SingletonPredictionContext.prototype, "addEmptyContext", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$SingletonPredictionContext.prototype, "removeEmptyContext", null);
$df5adf3eeab6304c$var$__decorate([
    $aN41m.Override
], $df5adf3eeab6304c$var$SingletonPredictionContext.prototype, "equals", null);
$df5adf3eeab6304c$var$SingletonPredictionContext = $df5adf3eeab6304c$var$__decorate([
    $df5adf3eeab6304c$var$__param(0, $aN41m.NotNull)
], $df5adf3eeab6304c$var$SingletonPredictionContext);
module.exports.SingletonPredictionContext = $df5adf3eeab6304c$var$SingletonPredictionContext;
(function(PredictionContext) {
    PredictionContext.EMPTY_LOCAL = new $df5adf3eeab6304c$var$EmptyPredictionContext(false);
    PredictionContext.EMPTY_FULL = new $df5adf3eeab6304c$var$EmptyPredictionContext(true);
    PredictionContext.EMPTY_LOCAL_STATE_KEY = -2147483648;
    PredictionContext.EMPTY_FULL_STATE_KEY = 2147483647;
    class IdentityHashMap extends $jRlcM.Array2DHashMap {
        constructor(){
            super(IdentityEqualityComparator.INSTANCE);
        }
    }
    PredictionContext.IdentityHashMap = IdentityHashMap;
    class IdentityEqualityComparator {
        IdentityEqualityComparator() {
        // intentionally empty
        }
        hashCode(obj) {
            return obj.hashCode();
        }
        equals(a, b) {
            return a === b;
        }
    }
    IdentityEqualityComparator.INSTANCE = new IdentityEqualityComparator();
    $df5adf3eeab6304c$var$__decorate([
        $aN41m.Override
    ], IdentityEqualityComparator.prototype, "hashCode", null);
    $df5adf3eeab6304c$var$__decorate([
        $aN41m.Override
    ], IdentityEqualityComparator.prototype, "equals", null);
    PredictionContext.IdentityEqualityComparator = IdentityEqualityComparator;
})($df5adf3eeab6304c$var$PredictionContext = module.exports.PredictionContext || (module.exports.PredictionContext = {}));

});
parcelRegister("4BvNW", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $35a349d4d8246799$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PredictionContextCache = void 0;

var $jRlcM = parcelRequire("jRlcM");

var $aN41m = parcelRequire("aN41m");

var $9eW9B = parcelRequire("9eW9B");

var $jaUCz = parcelRequire("jaUCz");

var $fomfP = parcelRequire("fomfP");
/** Used to cache {@link PredictionContext} objects. Its used for the shared
 *  context cash associated with contexts in DFA states. This cache
 *  can be used for both lexers and parsers.
 *
 * @author Sam Harwell
 */ class $35a349d4d8246799$var$PredictionContextCache {
    constructor(enableCache = true){
        this.contexts = new $jRlcM.Array2DHashMap($9eW9B.ObjectEqualityComparator.INSTANCE);
        this.childContexts = new $jRlcM.Array2DHashMap($9eW9B.ObjectEqualityComparator.INSTANCE);
        this.joinContexts = new $jRlcM.Array2DHashMap($9eW9B.ObjectEqualityComparator.INSTANCE);
        this.enableCache = enableCache;
    }
    getAsCached(context) {
        if (!this.enableCache) return context;
        let result = this.contexts.get(context);
        if (!result) {
            result = context;
            this.contexts.put(context, context);
        }
        return result;
    }
    getChild(context, invokingState) {
        if (!this.enableCache) return context.getChild(invokingState);
        let operands = new $35a349d4d8246799$var$PredictionContextCache.PredictionContextAndInt(context, invokingState);
        let result = this.childContexts.get(operands);
        if (!result) {
            result = context.getChild(invokingState);
            result = this.getAsCached(result);
            this.childContexts.put(operands, result);
        }
        return result;
    }
    join(x, y) {
        if (!this.enableCache) return $jaUCz.PredictionContext.join(x, y, this);
        let operands = new $35a349d4d8246799$var$PredictionContextCache.IdentityCommutativePredictionContextOperands(x, y);
        let result = this.joinContexts.get(operands);
        if (result) return result;
        result = $jaUCz.PredictionContext.join(x, y, this);
        result = this.getAsCached(result);
        this.joinContexts.put(operands, result);
        return result;
    }
}
module.exports.PredictionContextCache = $35a349d4d8246799$var$PredictionContextCache;
$35a349d4d8246799$var$PredictionContextCache.UNCACHED = new $35a349d4d8246799$var$PredictionContextCache(false);
(function(PredictionContextCache) {
    class PredictionContextAndInt {
        constructor(obj, value){
            this.obj = obj;
            this.value = value;
        }
        equals(obj) {
            if (!(obj instanceof PredictionContextAndInt)) return false;
            else if (obj === this) return true;
            let other = obj;
            return this.value === other.value && (this.obj === other.obj || this.obj != null && this.obj.equals(other.obj));
        }
        hashCode() {
            let hashCode = 5;
            hashCode = 7 * hashCode + (this.obj != null ? this.obj.hashCode() : 0);
            hashCode = 7 * hashCode + this.value;
            return hashCode;
        }
    }
    $35a349d4d8246799$var$__decorate([
        $aN41m.Override
    ], PredictionContextAndInt.prototype, "equals", null);
    $35a349d4d8246799$var$__decorate([
        $aN41m.Override
    ], PredictionContextAndInt.prototype, "hashCode", null);
    PredictionContextCache.PredictionContextAndInt = PredictionContextAndInt;
    class IdentityCommutativePredictionContextOperands {
        constructor(x, y){
            $fomfP(x != null);
            $fomfP(y != null);
            this._x = x;
            this._y = y;
        }
        get x() {
            return this._x;
        }
        get y() {
            return this._y;
        }
        equals(o) {
            if (!(o instanceof IdentityCommutativePredictionContextOperands)) return false;
            else if (this === o) return true;
            let other = o;
            return this._x === other._x && this._y === other._y || this._x === other._y && this._y === other._x;
        }
        hashCode() {
            return this._x.hashCode() ^ this._y.hashCode();
        }
    }
    $35a349d4d8246799$var$__decorate([
        $aN41m.Override
    ], IdentityCommutativePredictionContextOperands.prototype, "equals", null);
    $35a349d4d8246799$var$__decorate([
        $aN41m.Override
    ], IdentityCommutativePredictionContextOperands.prototype, "hashCode", null);
    PredictionContextCache.IdentityCommutativePredictionContextOperands = IdentityCommutativePredictionContextOperands;
})($35a349d4d8246799$var$PredictionContextCache = module.exports.PredictionContextCache || (module.exports.PredictionContextCache = {}));

});



parcelRegister("8WIez", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BitSet = void 0;

var $ibOwR = parcelRequire("ibOwR");

var $amQx9 = parcelRequire("amQx9");
/**
 * Private empty array used to construct empty BitSets
 */ const $68360d7390f2502b$var$EMPTY_DATA = new Uint16Array(0);
/**
 * Gets the word index of the `UInt16` element in `BitSet.data` containing the bit with the specified index.
 */ function $68360d7390f2502b$var$getIndex(bitNumber) {
    return bitNumber >>> 4;
}
/**
 * Convert a word index into the bit index of the LSB of that word
 */ function $68360d7390f2502b$var$unIndex(n) {
    return n * 16;
}
/**
 * Get's the bit number of the least signficant bit set LSB which is set in a word non-zero word;
 * Bit numbers run from LSB to MSB starting with 0.
 */ function $68360d7390f2502b$var$findLSBSet(word) {
    let bit = 1;
    for(let i = 0; i < 16; i++){
        if ((word & bit) !== 0) return i;
        bit = bit << 1 >>> 0;
    }
    throw new RangeError("No specified bit found");
}
function $68360d7390f2502b$var$findMSBSet(word) {
    let bit = 32768;
    for(let i = 15; i >= 0; i--){
        if ((word & bit) !== 0) return i;
        bit = bit >>> 1;
    }
    throw new RangeError("No specified bit found");
}
/**
 * Gets a 16-bit mask with bit numbers fromBit to toBit (inclusive) set.
 * Bit numbers run from LSB to MSB starting with 0.
 */ function $68360d7390f2502b$var$bitsFor(fromBit, toBit) {
    fromBit &= 0xF;
    toBit &= 0xF;
    if (fromBit === toBit) return 1 << fromBit >>> 0;
    return 0xFFFF >>> 15 - toBit ^ 0xFFFF >>> 16 - fromBit;
}
/**
 * A lookup table for number of set bits in a 16-bit integer.   This is used to quickly count the cardinality (number of unique elements) of a BitSet.
 */ const $68360d7390f2502b$var$POP_CNT = new Uint8Array(65536);
for(let i = 0; i < 16; i++){
    const stride = 1 << i >>> 0;
    let index = 0;
    while(index < $68360d7390f2502b$var$POP_CNT.length){
        // skip the numbers where the bit isn't set
        index += stride;
        // increment the ones where the bit is set
        for(let j = 0; j < stride; j++){
            $68360d7390f2502b$var$POP_CNT[index]++;
            index++;
        }
    }
}
class $68360d7390f2502b$var$BitSet {
    /*
    ** constructor implementation
    */ constructor(arg){
        if (!arg) // covering the case of unspecified and nbits===0
        this.data = $68360d7390f2502b$var$EMPTY_DATA;
        else if (typeof arg === "number") {
            if (arg < 0) throw new RangeError("nbits cannot be negative");
            else this.data = new Uint16Array($68360d7390f2502b$var$getIndex(arg - 1) + 1);
        } else if (arg instanceof $68360d7390f2502b$var$BitSet) this.data = arg.data.slice(0); // Clone the data
        else {
            let max = -1;
            for (let v of arg)if (max < v) max = v;
            this.data = new Uint16Array($68360d7390f2502b$var$getIndex(max - 1) + 1);
            for (let v of arg)this.set(v);
        }
    }
    /**
     * Performs a logical **AND** of this target bit set with the argument bit set. This bit set is modified so that
     * each bit in it has the value `true` if and only if it both initially had the value `true` and the corresponding
     * bit in the bit set argument also had the value `true`.
     */ and(set) {
        const data = this.data;
        const other = set.data;
        const words = Math.min(data.length, other.length);
        let lastWord = -1; // Keep track of index of last non-zero word
        for(let i = 0; i < words; i++){
            let value = data[i] &= other[i];
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $68360d7390f2502b$var$EMPTY_DATA;
        if (lastWord < data.length - 1) this.data = data.slice(0, lastWord + 1);
    }
    /**
     * Clears all of the bits in this `BitSet` whose corresponding bit is set in the specified `BitSet`.
     */ andNot(set) {
        const data = this.data;
        const other = set.data;
        const words = Math.min(data.length, other.length);
        let lastWord = -1; // Keep track of index of last non-zero word
        for(let i = 0; i < words; i++){
            let value = data[i] &= other[i] ^ 0xFFFF;
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $68360d7390f2502b$var$EMPTY_DATA;
        if (lastWord < data.length - 1) this.data = data.slice(0, lastWord + 1);
    }
    /**
     * Returns the number of bits set to `true` in this `BitSet`.
     */ cardinality() {
        if (this.isEmpty) return 0;
        const data = this.data;
        const length = data.length;
        let result = 0;
        for(let i = 0; i < length; i++)result += $68360d7390f2502b$var$POP_CNT[data[i]];
        return result;
    }
    clear(fromIndex, toIndex) {
        if (fromIndex == null) this.data.fill(0);
        else if (toIndex == null) this.set(fromIndex, false);
        else this.set(fromIndex, toIndex, false);
    }
    flip(fromIndex, toIndex) {
        if (toIndex == null) toIndex = fromIndex;
        if (fromIndex < 0 || toIndex < fromIndex) throw new RangeError();
        let word = $68360d7390f2502b$var$getIndex(fromIndex);
        const lastWord = $68360d7390f2502b$var$getIndex(toIndex);
        if (word === lastWord) this.data[word] ^= $68360d7390f2502b$var$bitsFor(fromIndex, toIndex);
        else {
            this.data[word++] ^= $68360d7390f2502b$var$bitsFor(fromIndex, 15);
            while(word < lastWord)this.data[word++] ^= 0xFFFF;
            this.data[word++] ^= $68360d7390f2502b$var$bitsFor(0, toIndex);
        }
    }
    get(fromIndex, toIndex) {
        if (toIndex === undefined) return !!(this.data[$68360d7390f2502b$var$getIndex(fromIndex)] & $68360d7390f2502b$var$bitsFor(fromIndex, fromIndex));
        else {
            // return a BitSet
            let result = new $68360d7390f2502b$var$BitSet(toIndex + 1);
            for(let i = fromIndex; i <= toIndex; i++)result.set(i, this.get(i));
            return result;
        }
    }
    /**
     * Returns true if the specified `BitSet` has any bits set to `true` that are also set to `true` in this `BitSet`.
     *
     * @param set `BitSet` to intersect with
     */ intersects(set) {
        let smallerLength = Math.min(this.length(), set.length());
        if (smallerLength === 0) return false;
        let bound = $68360d7390f2502b$var$getIndex(smallerLength - 1);
        for(let i = 0; i <= bound; i++){
            if ((this.data[i] & set.data[i]) !== 0) return true;
        }
        return false;
    }
    /**
     * Returns true if this `BitSet` contains no bits that are set to `true`.
     */ get isEmpty() {
        return this.length() === 0;
    }
    /**
     * Returns the "logical size" of this `BitSet`: the index of the highest set bit in the `BitSet` plus one. Returns
     * zero if the `BitSet` contains no set bits.
     */ length() {
        if (!this.data.length) return 0;
        return this.previousSetBit($68360d7390f2502b$var$unIndex(this.data.length) - 1) + 1;
    }
    /**
     * Returns the index of the first bit that is set to `false` that occurs on or after the specified starting index,
     * If no such bit exists then `-1` is returned.
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is negative
     */ nextClearBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $68360d7390f2502b$var$getIndex(fromIndex);
        if (word > length) return -1;
        let ignore = 0xFFFF ^ $68360d7390f2502b$var$bitsFor(fromIndex, 15);
        if ((data[word] | ignore) === 0xFFFF) {
            word++;
            ignore = 0;
            for(; word < length; word++){
                if (data[word] !== 0xFFFF) break;
            }
            if (word === length) // Hit the end
            return -1;
        }
        return $68360d7390f2502b$var$unIndex(word) + $68360d7390f2502b$var$findLSBSet((data[word] | ignore) ^ 0xFFFF);
    }
    /**
     * Returns the index of the first bit that is set to `true` that occurs on or after the specified starting index.
     * If no such bit exists then `-1` is returned.
     *
     * To iterate over the `true` bits in a `BitSet`, use the following loop:
     *
     * ```
     * for (let i = bs.nextSetBit(0); i >= 0; i = bs.nextSetBit(i + 1)) {
     *   // operate on index i here
     * }
     * ```
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is negative
     */ nextSetBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $68360d7390f2502b$var$getIndex(fromIndex);
        if (word > length) return -1;
        let mask = $68360d7390f2502b$var$bitsFor(fromIndex, 15);
        if ((data[word] & mask) === 0) {
            word++;
            mask = 0xFFFF;
            for(; word < length; word++){
                if (data[word] !== 0) break;
            }
            if (word >= length) return -1;
        }
        return $68360d7390f2502b$var$unIndex(word) + $68360d7390f2502b$var$findLSBSet(data[word] & mask);
    }
    /**
     * Performs a logical **OR** of this bit set with the bit set argument. This bit set is modified so that a bit in it
     * has the value `true` if and only if it either already had the value `true` or the corresponding bit in the bit
     * set argument has the value `true`.
     */ or(set) {
        const data = this.data;
        const other = set.data;
        const minWords = Math.min(data.length, other.length);
        const words = Math.max(data.length, other.length);
        const dest = data.length === words ? data : new Uint16Array(words);
        let lastWord = -1;
        // Or those words both sets have in common
        for(let i = 0; i < minWords; i++){
            let value = dest[i] = data[i] | other[i];
            if (value !== 0) lastWord = i;
        }
        // Copy words from larger set (if there is one)
        const longer = data.length > other.length ? data : other;
        for(let i = minWords; i < words; i++){
            let value = dest[i] = longer[i];
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $68360d7390f2502b$var$EMPTY_DATA;
        else if (dest.length === lastWord + 1) this.data = dest;
        else this.data = dest.slice(0, lastWord);
    }
    /**
     * Returns the index of the nearest bit that is set to `false` that occurs on or before the specified starting
     * index. If no such bit exists, or if `-1` is given as the starting index, then `-1` is returned.
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is less than `-1`
     */ previousClearBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $68360d7390f2502b$var$getIndex(fromIndex);
        if (word >= length) word = length - 1;
        let ignore = 0xFFFF ^ $68360d7390f2502b$var$bitsFor(0, fromIndex);
        if ((data[word] | ignore) === 0xFFFF) {
            ignore = 0;
            word--;
            for(; word >= 0; word--){
                if (data[word] !== 0xFFFF) break;
            }
            if (word < 0) // Hit the end
            return -1;
        }
        return $68360d7390f2502b$var$unIndex(word) + $68360d7390f2502b$var$findMSBSet((data[word] | ignore) ^ 0xFFFF);
    }
    /**
     * Returns the index of the nearest bit that is set to `true` that occurs on or before the specified starting index.
     * If no such bit exists, or if `-1` is given as the starting index, then `-1` is returned.
     *
     * To iterate over the `true` bits in a `BitSet`, use the following loop:
     *
     * ```
     * for (let i = bs.length(); (i = bs.previousSetBit(i-1)) >= 0; ) {
     *   // operate on index i here
     * }
     * ```
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is less than `-1`
     */ previousSetBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $68360d7390f2502b$var$getIndex(fromIndex);
        if (word >= length) word = length - 1;
        let mask = $68360d7390f2502b$var$bitsFor(0, fromIndex);
        if ((data[word] & mask) === 0) {
            word--;
            mask = 0xFFFF;
            for(; word >= 0; word--){
                if (data[word] !== 0) break;
            }
            if (word < 0) return -1;
        }
        return $68360d7390f2502b$var$unIndex(word) + $68360d7390f2502b$var$findMSBSet(data[word] & mask);
    }
    set(fromIndex, toIndex, value) {
        if (toIndex === undefined) {
            toIndex = fromIndex;
            value = true;
        } else if (typeof toIndex === "boolean") {
            value = toIndex;
            toIndex = fromIndex;
        }
        if (value === undefined) value = true;
        if (fromIndex < 0 || fromIndex > toIndex) throw new RangeError();
        let word = $68360d7390f2502b$var$getIndex(fromIndex);
        let lastWord = $68360d7390f2502b$var$getIndex(toIndex);
        if (value && lastWord >= this.data.length) {
            // Grow array "just enough" for bits we need to set
            let temp = new Uint16Array(lastWord + 1);
            this.data.forEach((value, index)=>temp[index] = value);
            this.data = temp;
        } else if (!value) {
            // But there is no need to grow array to clear bits.
            if (word >= this.data.length) // Early exit
            return;
            if (lastWord >= this.data.length) {
                // Adjust work to fit array
                lastWord = this.data.length - 1;
                toIndex = this.data.length * 16 - 1;
            }
        }
        if (word === lastWord) this._setBits(word, value, $68360d7390f2502b$var$bitsFor(fromIndex, toIndex));
        else {
            this._setBits(word++, value, $68360d7390f2502b$var$bitsFor(fromIndex, 15));
            while(word < lastWord)this.data[word++] = value ? 0xFFFF : 0;
            this._setBits(word, value, $68360d7390f2502b$var$bitsFor(0, toIndex));
        }
    }
    _setBits(word, value, mask) {
        if (value) this.data[word] |= mask;
        else this.data[word] &= 0xFFFF ^ mask;
    }
    /**
     * Returns the number of bits of space actually in use by this `BitSet` to represent bit values. The maximum element
     * in the set is the size - 1st element.
     */ get size() {
        return this.data.byteLength * 8;
    }
    /**
     * Returns a new byte array containing all the bits in this bit set.
     *
     * More precisely, if
     * `let bytes = s.toByteArray();`
     * then `bytes.length === (s.length()+7)/8` and `s.get(n) === ((bytes[n/8] & (1<<(n%8))) != 0)` for all
     * `n < 8 * bytes.length`.
     */ // toByteArray(): Int8Array {
    // 	throw new Error("NOT IMPLEMENTED");
    // }
    /**
     * Returns a new integer array containing all the bits in this bit set.
     *
     * More precisely, if
     * `let integers = s.toIntegerArray();`
     * then `integers.length === (s.length()+31)/32` and `s.get(n) === ((integers[n/32] & (1<<(n%32))) != 0)` for all
     * `n < 32 * integers.length`.
     */ // toIntegerArray(): Int32Array {
    // 	throw new Error("NOT IMPLEMENTED");
    // }
    hashCode() {
        return $amQx9.MurmurHash.hashCode(this.data, 22);
    }
    /**
     * Compares this object against the specified object. The result is `true` if and only if the argument is not
     * `undefined` and is a `Bitset` object that has exactly the same set of bits set to `true` as this bit set. That
     * is, for every nonnegative index `k`,
     *
     * ```
     * ((BitSet)obj).get(k) == this.get(k)
     * ```
     *
     * must be true. The current sizes of the two bit sets are not compared.
     */ equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $68360d7390f2502b$var$BitSet)) return false;
        const len = this.length();
        if (len !== obj.length()) return false;
        if (len === 0) return true;
        let bound = $68360d7390f2502b$var$getIndex(len - 1);
        for(let i = 0; i <= bound; i++){
            if (this.data[i] !== obj.data[i]) return false;
        }
        return true;
    }
    /**
     * Returns a string representation of this bit set. For every index for which this `BitSet` contains a bit in the
     * set state, the decimal representation of that index is included in the result. Such indices are listed in order
     * from lowest to highest, separated by ", " (a comma and a space) and surrounded by braces, resulting in the usual
     * mathematical notation for a set of integers.
     *
     * Example:
     *
     *     BitSet drPepper = new BitSet();
     *
     * Now `drPepper.toString()` returns `"{}"`.
     *
     *     drPepper.set(2);
     *
     * Now `drPepper.toString()` returns `"{2}"`.
     *
     *     drPepper.set(4);
     *     drPepper.set(10);
     *
     * Now `drPepper.toString()` returns `"{2, 4, 10}"`.
     */ toString() {
        let result = "{";
        let first = true;
        for(let i = this.nextSetBit(0); i >= 0; i = this.nextSetBit(i + 1)){
            if (first) first = false;
            else result += ", ";
            result += i;
        }
        result += "}";
        return result;
    }
    // static valueOf(bytes: Int8Array): BitSet;
    // static valueOf(buffer: ArrayBuffer): BitSet;
    // static valueOf(integers: Int32Array): BitSet;
    // static valueOf(data: Int8Array | Int32Array | ArrayBuffer): BitSet {
    // 	throw new Error("NOT IMPLEMENTED");
    // }
    /**
     * Performs a logical **XOR** of this bit set with the bit set argument. This bit set is modified so that a bit in
     * it has the value `true` if and only if one of the following statements holds:
     *
     * * The bit initially has the value `true`, and the corresponding bit in the argument has the value `false`.
     * * The bit initially has the value `false`, and the corresponding bit in the argument has the value `true`.
     */ xor(set) {
        const data = this.data;
        const other = set.data;
        const minWords = Math.min(data.length, other.length);
        const words = Math.max(data.length, other.length);
        const dest = data.length === words ? data : new Uint16Array(words);
        let lastWord = -1;
        // Xor those words both sets have in common
        for(let i = 0; i < minWords; i++){
            let value = dest[i] = data[i] ^ other[i];
            if (value !== 0) lastWord = i;
        }
        // Copy words from larger set (if there is one)
        const longer = data.length > other.length ? data : other;
        for(let i = minWords; i < words; i++){
            let value = dest[i] = longer[i];
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $68360d7390f2502b$var$EMPTY_DATA;
        else if (dest.length === lastWord + 1) this.data = dest;
        else this.data = dest.slice(0, lastWord + 1);
    }
    clone() {
        return new $68360d7390f2502b$var$BitSet(this);
    }
    [Symbol.iterator]() {
        return new $68360d7390f2502b$var$BitSetIterator(this.data);
    }
    // Overrides formatting for nodejs assert etc.
    [$ibOwR.inspect.custom]() {
        return "BitSet " + this.toString();
    }
}
module.exports.BitSet = $68360d7390f2502b$var$BitSet;
class $68360d7390f2502b$var$BitSetIterator {
    constructor(data){
        this.data = data;
        this.index = 0;
        this.mask = 0xFFFF;
    }
    next() {
        while(this.index < this.data.length){
            const bits = this.data[this.index] & this.mask;
            if (bits !== 0) {
                const bitNumber = $68360d7390f2502b$var$unIndex(this.index) + $68360d7390f2502b$var$findLSBSet(bits);
                this.mask = $68360d7390f2502b$var$bitsFor(bitNumber + 1, 15);
                return {
                    done: false,
                    value: bitNumber
                };
            }
            this.index++;
            this.mask = 0xFFFF;
        }
        return {
            done: true,
            value: -1
        };
    }
    [Symbol.iterator]() {
        return this;
    }
}

});


parcelRegister("aVeml", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $7f3a5dbd36c0ece1$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DFASerializer = void 0;

var $ceQRA = parcelRequire("ceQRA");

var $aN41m = parcelRequire("aN41m");

var $jaUCz = parcelRequire("jaUCz");

var $dwftT = parcelRequire("dwftT");

var $hBnE1 = parcelRequire("hBnE1");
/** A DFA walker that knows how to dump them to serialized strings. */ class $7f3a5dbd36c0ece1$var$DFASerializer {
    constructor(dfa, vocabulary, ruleNames, atn){
        if (vocabulary instanceof $dwftT.Recognizer) {
            ruleNames = vocabulary.ruleNames;
            atn = vocabulary.atn;
            vocabulary = vocabulary.vocabulary;
        } else if (!vocabulary) vocabulary = $hBnE1.VocabularyImpl.EMPTY_VOCABULARY;
        this.dfa = dfa;
        this.vocabulary = vocabulary;
        this.ruleNames = ruleNames;
        this.atn = atn;
    }
    toString() {
        if (!this.dfa.s0) return "";
        let buf = "";
        if (this.dfa.states) {
            let states = new Array(...this.dfa.states.toArray());
            states.sort((o1, o2)=>o1.stateNumber - o2.stateNumber);
            for (let s of states){
                let edges = s.getEdgeMap();
                let edgeKeys = [
                    ...edges.keys()
                ].sort((a, b)=>a - b);
                let contextEdges = s.getContextEdgeMap();
                let contextEdgeKeys = [
                    ...contextEdges.keys()
                ].sort((a, b)=>a - b);
                for (let entry of edgeKeys){
                    let value = edges.get(entry);
                    if ((value == null || value === $ceQRA.ATNSimulator.ERROR) && !s.isContextSymbol(entry)) continue;
                    let contextSymbol = false;
                    buf += this.getStateString(s) + "-" + this.getEdgeLabel(entry) + "->";
                    if (s.isContextSymbol(entry)) {
                        buf += "!";
                        contextSymbol = true;
                    }
                    let t = value;
                    if (t && t.stateNumber !== $ceQRA.ATNSimulator.ERROR.stateNumber) buf += this.getStateString(t) + "\n";
                    else if (contextSymbol) buf += "ctx\n";
                }
                if (s.isContextSensitive) for (let entry of contextEdgeKeys)buf += this.getStateString(s) + "-" + this.getContextLabel(entry) + "->" + this.getStateString(contextEdges.get(entry)) + "\n";
            }
        }
        let output = buf;
        if (output.length === 0) return "";
        //return Utils.sortLinesInString(output);
        return output;
    }
    getContextLabel(i) {
        if (i === $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY) return "ctx:EMPTY_FULL";
        else if (i === $jaUCz.PredictionContext.EMPTY_LOCAL_STATE_KEY) return "ctx:EMPTY_LOCAL";
        if (this.atn && i > 0 && i <= this.atn.states.length) {
            let state = this.atn.states[i];
            let ruleIndex = state.ruleIndex;
            if (this.ruleNames && ruleIndex >= 0 && ruleIndex < this.ruleNames.length) return "ctx:" + String(i) + "(" + this.ruleNames[ruleIndex] + ")";
        }
        return "ctx:" + String(i);
    }
    getEdgeLabel(i) {
        return this.vocabulary.getDisplayName(i);
    }
    getStateString(s) {
        if (s === $ceQRA.ATNSimulator.ERROR) return "ERROR";
        let n = s.stateNumber;
        let stateStr = "s" + n;
        if (s.isAcceptState) {
            if (s.predicates) stateStr = ":s" + n + "=>" + s.predicates;
            else stateStr = ":s" + n + "=>" + s.prediction;
        }
        if (s.isContextSensitive) {
            stateStr += "*";
            for (let config of s.configs)if (config.reachesIntoOuterContext) {
                stateStr += "*";
                break;
            }
        }
        return stateStr;
    }
}
$7f3a5dbd36c0ece1$var$__decorate([
    $aN41m.NotNull
], $7f3a5dbd36c0ece1$var$DFASerializer.prototype, "dfa", void 0);
$7f3a5dbd36c0ece1$var$__decorate([
    $aN41m.NotNull
], $7f3a5dbd36c0ece1$var$DFASerializer.prototype, "vocabulary", void 0);
$7f3a5dbd36c0ece1$var$__decorate([
    $aN41m.Override
], $7f3a5dbd36c0ece1$var$DFASerializer.prototype, "toString", null);
module.exports.DFASerializer = $7f3a5dbd36c0ece1$var$DFASerializer;

});
parcelRegister("ceQRA", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $8e8fcc5f6dae8ba8$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $8e8fcc5f6dae8ba8$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNSimulator = void 0;

var $2SGHL = parcelRequire("2SGHL");

var $6P9ap = parcelRequire("6P9ap");

var $aN41m = parcelRequire("aN41m");

var $jaUCz = parcelRequire("jaUCz");
let $8e8fcc5f6dae8ba8$var$ATNSimulator = class ATNSimulator {
    constructor(atn){
        this.atn = atn;
    }
    static get ERROR() {
        if (!ATNSimulator._ERROR) {
            ATNSimulator._ERROR = new $6P9ap.DFAState(new $2SGHL.ATNConfigSet());
            ATNSimulator._ERROR.stateNumber = $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY;
        }
        return ATNSimulator._ERROR;
    }
    /**
     * Clear the DFA cache used by the current instance. Since the DFA cache may
     * be shared by multiple ATN simulators, this method may affect the
     * performance (but not accuracy) of other parsers which are being used
     * concurrently.
     *
     * @ if the current instance does not
     * support clearing the DFA.
     *
     * @since 4.3
     */ clearDFA() {
        this.atn.clearDFA();
    }
};
$8e8fcc5f6dae8ba8$var$__decorate([
    $aN41m.NotNull
], $8e8fcc5f6dae8ba8$var$ATNSimulator.prototype, "atn", void 0);
$8e8fcc5f6dae8ba8$var$__decorate([
    $aN41m.NotNull
], $8e8fcc5f6dae8ba8$var$ATNSimulator, "ERROR", null);
$8e8fcc5f6dae8ba8$var$ATNSimulator = $8e8fcc5f6dae8ba8$var$__decorate([
    $8e8fcc5f6dae8ba8$var$__param(0, $aN41m.NotNull)
], $8e8fcc5f6dae8ba8$var$ATNSimulator);
module.exports.ATNSimulator = $8e8fcc5f6dae8ba8$var$ATNSimulator;
(function(ATNSimulator) {
    const RULE_VARIANT_DELIMITER = "$";
    const RULE_LF_VARIANT_MARKER = "$lf$";
    const RULE_NOLF_VARIANT_MARKER = "$nolf$";
})($8e8fcc5f6dae8ba8$var$ATNSimulator = module.exports.ATNSimulator || (module.exports.ATNSimulator = {}));
module.exports.ATNSimulator = $8e8fcc5f6dae8ba8$var$ATNSimulator;

});
parcelRegister("6P9ap", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $4f7e9dd79d87c511$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $4f7e9dd79d87c511$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DFAState = void 0;

var $eeOLb = parcelRequire("eeOLb");

var $8WIez = parcelRequire("8WIez");

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");

var $jaUCz = parcelRequire("jaUCz");

var $fomfP = parcelRequire("fomfP");
/** A DFA state represents a set of possible ATN configurations.
 *  As Aho, Sethi, Ullman p. 117 says "The DFA uses its state
 *  to keep track of all possible states the ATN can be in after
 *  reading each input symbol.  That is to say, after reading
 *  input a1a2..an, the DFA is in a state that represents the
 *  subset T of the states of the ATN that are reachable from the
 *  ATN's start state along some path labeled a1a2..an."
 *  In conventional NFA&rarr;DFA conversion, therefore, the subset T
 *  would be a bitset representing the set of states the
 *  ATN could be in.  We need to track the alt predicted by each
 *  state as well, however.  More importantly, we need to maintain
 *  a stack of states, tracking the closure operations as they
 *  jump from rule to rule, emulating rule invocations (method calls).
 *  I have to add a stack to simulate the proper lookahead sequences for
 *  the underlying LL grammar from which the ATN was derived.
 *
 *  I use a set of ATNConfig objects not simple states.  An ATNConfig
 *  is both a state (ala normal conversion) and a RuleContext describing
 *  the chain of rules (if any) followed to arrive at that state.
 *
 *  A DFA state may have multiple references to a particular state,
 *  but with different ATN contexts (with same or different alts)
 *  meaning that state was reached via a different set of rule invocations.
 */ class $4f7e9dd79d87c511$var$DFAState {
    /**
     * Constructs a new `DFAState`.
     *
     * @param configs The set of ATN configurations defining this state.
     */ constructor(configs){
        this.stateNumber = -1;
        this.configs = configs;
        this.edges = new Map();
        this.contextEdges = new Map();
    }
    get isContextSensitive() {
        return !!this.contextSymbols;
    }
    isContextSymbol(symbol) {
        if (!this.isContextSensitive) return false;
        return this.contextSymbols.get(symbol);
    }
    setContextSymbol(symbol) {
        $fomfP(this.isContextSensitive);
        this.contextSymbols.set(symbol);
    }
    setContextSensitive(atn) {
        $fomfP(!this.configs.isOutermostConfigSet);
        if (this.isContextSensitive) return;
        if (!this.contextSymbols) this.contextSymbols = new $8WIez.BitSet();
    }
    get acceptStateInfo() {
        return this._acceptStateInfo;
    }
    set acceptStateInfo(acceptStateInfo) {
        this._acceptStateInfo = acceptStateInfo;
    }
    get isAcceptState() {
        return !!this._acceptStateInfo;
    }
    get prediction() {
        if (!this._acceptStateInfo) return $eeOLb.ATN.INVALID_ALT_NUMBER;
        return this._acceptStateInfo.prediction;
    }
    get lexerActionExecutor() {
        if (!this._acceptStateInfo) return undefined;
        return this._acceptStateInfo.lexerActionExecutor;
    }
    getTarget(symbol) {
        return this.edges.get(symbol);
    }
    setTarget(symbol, target) {
        this.edges.set(symbol, target);
    }
    getEdgeMap() {
        return this.edges;
    }
    getContextTarget(invokingState) {
        if (invokingState === $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY) invokingState = -1;
        return this.contextEdges.get(invokingState);
    }
    setContextTarget(invokingState, target) {
        if (!this.isContextSensitive) throw new Error("The state is not context sensitive.");
        if (invokingState === $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY) invokingState = -1;
        this.contextEdges.set(invokingState, target);
    }
    getContextEdgeMap() {
        let map = new Map(this.contextEdges);
        let existing = map.get(-1);
        if (existing !== undefined) {
            if (map.size === 1) {
                let result = new Map();
                result.set($jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY, existing);
                return result;
            } else {
                map.delete(-1);
                map.set($jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY, existing);
            }
        }
        return map;
    }
    hashCode() {
        let hash = $amQx9.MurmurHash.initialize(7);
        hash = $amQx9.MurmurHash.update(hash, this.configs.hashCode());
        hash = $amQx9.MurmurHash.finish(hash, 1);
        return hash;
    }
    /**
     * Two {@link DFAState} instances are equal if their ATN configuration sets
     * are the same. This method is used to see if a state already exists.
     *
     * Because the number of alternatives and number of ATN configurations are
     * finite, there is a finite number of DFA states that can be processed.
     * This is necessary to show that the algorithm terminates.
     *
     * Cannot test the DFA state numbers here because in
     * {@link ParserATNSimulator#addDFAState} we need to know if any other state
     * exists that has this exact set of ATN configurations. The
     * {@link #stateNumber} is irrelevant.
     */ equals(o) {
        // compare set of ATN configurations in this set with other
        if (this === o) return true;
        if (!(o instanceof $4f7e9dd79d87c511$var$DFAState)) return false;
        let other = o;
        let sameSet = this.configs.equals(other.configs);
        //		System.out.println("DFAState.equals: "+configs+(sameSet?"==":"!=")+other.configs);
        return sameSet;
    }
    toString() {
        let buf = "";
        buf += this.stateNumber + ":" + this.configs;
        if (this.isAcceptState) {
            buf += "=>";
            if (this.predicates) buf += this.predicates;
            else buf += this.prediction;
        }
        return buf.toString();
    }
}
$4f7e9dd79d87c511$var$__decorate([
    $aN41m.NotNull
], $4f7e9dd79d87c511$var$DFAState.prototype, "configs", void 0);
$4f7e9dd79d87c511$var$__decorate([
    $aN41m.NotNull
], $4f7e9dd79d87c511$var$DFAState.prototype, "edges", void 0);
$4f7e9dd79d87c511$var$__decorate([
    $aN41m.NotNull
], $4f7e9dd79d87c511$var$DFAState.prototype, "contextEdges", void 0);
$4f7e9dd79d87c511$var$__decorate([
    $aN41m.Override
], $4f7e9dd79d87c511$var$DFAState.prototype, "hashCode", null);
$4f7e9dd79d87c511$var$__decorate([
    $aN41m.Override
], $4f7e9dd79d87c511$var$DFAState.prototype, "equals", null);
$4f7e9dd79d87c511$var$__decorate([
    $aN41m.Override
], $4f7e9dd79d87c511$var$DFAState.prototype, "toString", null);
module.exports.DFAState = $4f7e9dd79d87c511$var$DFAState;
(function(DFAState) {
    /** Map a predicate to a predicted alternative. */ let PredPrediction = class PredPrediction {
        constructor(pred, alt){
            this.alt = alt;
            this.pred = pred;
        }
        toString() {
            return "(" + this.pred + ", " + this.alt + ")";
        }
    };
    $4f7e9dd79d87c511$var$__decorate([
        $aN41m.NotNull
    ], PredPrediction.prototype, "pred", void 0);
    $4f7e9dd79d87c511$var$__decorate([
        $aN41m.Override
    ], PredPrediction.prototype, "toString", null);
    PredPrediction = $4f7e9dd79d87c511$var$__decorate([
        $4f7e9dd79d87c511$var$__param(0, $aN41m.NotNull)
    ], PredPrediction);
    DFAState.PredPrediction = PredPrediction;
})($4f7e9dd79d87c511$var$DFAState = module.exports.DFAState || (module.exports.DFAState = {}));

});


parcelRegister("dwftT", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9d7a45bfa60542a5$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $9d7a45bfa60542a5$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Recognizer = void 0;

var $eEgBk = parcelRequire("eEgBk");

var $3Wiwr = parcelRequire("3Wiwr");

var $aN41m = parcelRequire("aN41m");

var $eKXi4 = parcelRequire("eKXi4");

var $62Uvn = parcelRequire("62Uvn");
class $9d7a45bfa60542a5$var$Recognizer {
    constructor(){
        this._listeners = [
            $eEgBk.ConsoleErrorListener.INSTANCE
        ];
        this._stateNumber = -1;
    }
    /**
     * Get a map from token names to token types.
     *
     * Used for XPath and tree pattern compilation.
     */ getTokenTypeMap() {
        let vocabulary = this.vocabulary;
        let result = $9d7a45bfa60542a5$var$Recognizer.tokenTypeMapCache.get(vocabulary);
        if (result == null) {
            let intermediateResult = new Map();
            for(let i = 0; i <= this.atn.maxTokenType; i++){
                let literalName = vocabulary.getLiteralName(i);
                if (literalName != null) intermediateResult.set(literalName, i);
                let symbolicName = vocabulary.getSymbolicName(i);
                if (symbolicName != null) intermediateResult.set(symbolicName, i);
            }
            intermediateResult.set("EOF", $eKXi4.Token.EOF);
            result = intermediateResult;
            $9d7a45bfa60542a5$var$Recognizer.tokenTypeMapCache.set(vocabulary, result);
        }
        return result;
    }
    /**
     * Get a map from rule names to rule indexes.
     *
     * Used for XPath and tree pattern compilation.
     */ getRuleIndexMap() {
        let ruleNames = this.ruleNames;
        if (ruleNames == null) throw new Error("The current recognizer does not provide a list of rule names.");
        let result = $9d7a45bfa60542a5$var$Recognizer.ruleIndexMapCache.get(ruleNames);
        if (result == null) {
            result = $62Uvn.toMap(ruleNames);
            $9d7a45bfa60542a5$var$Recognizer.ruleIndexMapCache.set(ruleNames, result);
        }
        return result;
    }
    getTokenType(tokenName) {
        let ttype = this.getTokenTypeMap().get(tokenName);
        if (ttype != null) return ttype;
        return $eKXi4.Token.INVALID_TYPE;
    }
    /**
     * If this recognizer was generated, it will have a serialized ATN
     * representation of the grammar.
     *
     * For interpreters, we don't know their serialized ATN despite having
     * created the interpreter from it.
     */ get serializedATN() {
        throw new Error("there is no serialized ATN");
    }
    /**
     * Get the {@link ATN} used by the recognizer for prediction.
     *
     * @returns The {@link ATN} used by the recognizer for prediction.
     */ get atn() {
        return this._interp.atn;
    }
    /**
     * Get the ATN interpreter used by the recognizer for prediction.
     *
     * @returns The ATN interpreter used by the recognizer for prediction.
     */ get interpreter() {
        return this._interp;
    }
    /**
     * Set the ATN interpreter used by the recognizer for prediction.
     *
     * @param interpreter The ATN interpreter used by the recognizer for
     * prediction.
     */ set interpreter(interpreter) {
        this._interp = interpreter;
    }
    /** If profiling during the parse/lex, this will return DecisionInfo records
     *  for each decision in recognizer in a ParseInfo object.
     *
     * @since 4.3
     */ get parseInfo() {
        return Promise.resolve(undefined);
    }
    /** What is the error header, normally line/character position information? */ getErrorHeader(e) {
        let token = e.getOffendingToken();
        if (!token) return "";
        let line = token.line;
        let charPositionInLine = token.charPositionInLine;
        return "line " + line + ":" + charPositionInLine;
    }
    /**
     * @exception NullPointerException if `listener` is `undefined`.
     */ addErrorListener(listener) {
        if (!listener) throw new TypeError("listener must not be null");
        this._listeners.push(listener);
    }
    removeErrorListener(listener) {
        let position = this._listeners.indexOf(listener);
        if (position !== -1) this._listeners.splice(position, 1);
    }
    removeErrorListeners() {
        this._listeners.length = 0;
    }
    getErrorListeners() {
        return this._listeners.slice(0);
    }
    getErrorListenerDispatch() {
        return new $3Wiwr.ProxyErrorListener(this.getErrorListeners());
    }
    // subclass needs to override these if there are sempreds or actions
    // that the ATN interp needs to execute
    sempred(_localctx, ruleIndex, actionIndex) {
        return true;
    }
    precpred(localctx, precedence) {
        return true;
    }
    action(_localctx, ruleIndex, actionIndex) {
    // intentionally empty
    }
    get state() {
        return this._stateNumber;
    }
    /** Indicate that the recognizer has changed internal state that is
     *  consistent with the ATN state passed in.  This way we always know
     *  where we are in the ATN as the parser goes along. The rule
     *  context objects form a stack that lets us see the stack of
     *  invoking rules. Combine this and we have complete ATN
     *  configuration information.
     */ set state(atnState) {
        //		System.err.println("setState "+atnState);
        this._stateNumber = atnState;
    //		if ( traceATNStates ) _ctx.trace(atnState);
    }
}
$9d7a45bfa60542a5$var$Recognizer.EOF = -1;
$9d7a45bfa60542a5$var$Recognizer.tokenTypeMapCache = new WeakMap();
$9d7a45bfa60542a5$var$Recognizer.ruleIndexMapCache = new WeakMap();
$9d7a45bfa60542a5$var$__decorate([
    $aN41m.SuppressWarnings("serial"),
    $aN41m.NotNull
], $9d7a45bfa60542a5$var$Recognizer.prototype, "_listeners", void 0);
$9d7a45bfa60542a5$var$__decorate([
    $aN41m.NotNull
], $9d7a45bfa60542a5$var$Recognizer.prototype, "getTokenTypeMap", null);
$9d7a45bfa60542a5$var$__decorate([
    $aN41m.NotNull
], $9d7a45bfa60542a5$var$Recognizer.prototype, "getRuleIndexMap", null);
$9d7a45bfa60542a5$var$__decorate([
    $aN41m.NotNull
], $9d7a45bfa60542a5$var$Recognizer.prototype, "serializedATN", null);
$9d7a45bfa60542a5$var$__decorate([
    $aN41m.NotNull
], $9d7a45bfa60542a5$var$Recognizer.prototype, "atn", null);
$9d7a45bfa60542a5$var$__decorate([
    $aN41m.NotNull,
    $9d7a45bfa60542a5$var$__param(0, $aN41m.NotNull)
], $9d7a45bfa60542a5$var$Recognizer.prototype, "interpreter", null);
$9d7a45bfa60542a5$var$__decorate([
    $aN41m.NotNull,
    $9d7a45bfa60542a5$var$__param(0, $aN41m.NotNull)
], $9d7a45bfa60542a5$var$Recognizer.prototype, "getErrorHeader", null);
$9d7a45bfa60542a5$var$__decorate([
    $9d7a45bfa60542a5$var$__param(0, $aN41m.NotNull)
], $9d7a45bfa60542a5$var$Recognizer.prototype, "addErrorListener", null);
$9d7a45bfa60542a5$var$__decorate([
    $9d7a45bfa60542a5$var$__param(0, $aN41m.NotNull)
], $9d7a45bfa60542a5$var$Recognizer.prototype, "removeErrorListener", null);
$9d7a45bfa60542a5$var$__decorate([
    $aN41m.NotNull
], $9d7a45bfa60542a5$var$Recognizer.prototype, "getErrorListeners", null);
module.exports.Recognizer = $9d7a45bfa60542a5$var$Recognizer;

});
parcelRegister("eEgBk", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConsoleErrorListener = void 0;
/**
 *
 * @author Sam Harwell
 */ class $aaa1adc002ecda3b$var$ConsoleErrorListener {
    /**
     * {@inheritDoc}
     *
     * This implementation prints messages to {@link System#err} containing the
     * values of `line`, `charPositionInLine`, and `msg` using
     * the following format.
     *
     * <pre>
     * line *line*:*charPositionInLine* *msg*
     * </pre>
     */ syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e) {
        console.error(`line ${line}:${charPositionInLine} ${msg}`);
    }
}
module.exports.ConsoleErrorListener = $aaa1adc002ecda3b$var$ConsoleErrorListener;
/**
 * Provides a default instance of {@link ConsoleErrorListener}.
 */ $aaa1adc002ecda3b$var$ConsoleErrorListener.INSTANCE = new $aaa1adc002ecda3b$var$ConsoleErrorListener();

});

parcelRegister("3Wiwr", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $2de528078ef3db4e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $2de528078ef3db4e$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProxyErrorListener = void 0;

var $aN41m = parcelRequire("aN41m");
/**
 * This implementation of {@link ANTLRErrorListener} dispatches all calls to a
 * collection of delegate listeners. This reduces the effort required to support multiple
 * listeners.
 *
 * @author Sam Harwell
 */ class $2de528078ef3db4e$var$ProxyErrorListener {
    constructor(delegates){
        this.delegates = delegates;
        if (!delegates) throw new Error("Invalid delegates");
    }
    getDelegates() {
        return this.delegates;
    }
    syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e) {
        this.delegates.forEach((listener)=>{
            if (listener.syntaxError) listener.syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e);
        });
    }
}
$2de528078ef3db4e$var$__decorate([
    $aN41m.Override,
    $2de528078ef3db4e$var$__param(0, $aN41m.NotNull),
    $2de528078ef3db4e$var$__param(4, $aN41m.NotNull)
], $2de528078ef3db4e$var$ProxyErrorListener.prototype, "syntaxError", null);
module.exports.ProxyErrorListener = $2de528078ef3db4e$var$ProxyErrorListener;

});


parcelRegister("hBnE1", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $cd083bb3193af652$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VocabularyImpl = void 0;

var $aN41m = parcelRequire("aN41m");

var $eKXi4 = parcelRequire("eKXi4");
/**
 * This class provides a default implementation of the {@link Vocabulary}
 * interface.
 *
 * @author Sam Harwell
 */ class $cd083bb3193af652$var$VocabularyImpl {
    /**
     * Constructs a new instance of {@link VocabularyImpl} from the specified
     * literal, symbolic, and display token names.
     *
     * @param literalNames The literal names assigned to tokens, or an empty array
     * if no literal names are assigned.
     * @param symbolicNames The symbolic names assigned to tokens, or
     * an empty array if no symbolic names are assigned.
     * @param displayNames The display names assigned to tokens, or an empty array
     * to use the values in `literalNames` and `symbolicNames` as
     * the source of display names, as described in
     * {@link #getDisplayName(int)}.
     *
     * @see #getLiteralName(int)
     * @see #getSymbolicName(int)
     * @see #getDisplayName(int)
     */ constructor(literalNames, symbolicNames, displayNames){
        this.literalNames = literalNames;
        this.symbolicNames = symbolicNames;
        this.displayNames = displayNames;
        // See note here on -1 part: https://github.com/antlr/antlr4/pull/1146
        this._maxTokenType = Math.max(this.displayNames.length, Math.max(this.literalNames.length, this.symbolicNames.length)) - 1;
    }
    get maxTokenType() {
        return this._maxTokenType;
    }
    getLiteralName(tokenType) {
        if (tokenType >= 0 && tokenType < this.literalNames.length) return this.literalNames[tokenType];
        return undefined;
    }
    getSymbolicName(tokenType) {
        if (tokenType >= 0 && tokenType < this.symbolicNames.length) return this.symbolicNames[tokenType];
        if (tokenType === $eKXi4.Token.EOF) return "EOF";
        return undefined;
    }
    getDisplayName(tokenType) {
        if (tokenType >= 0 && tokenType < this.displayNames.length) {
            let displayName = this.displayNames[tokenType];
            if (displayName) return displayName;
        }
        let literalName = this.getLiteralName(tokenType);
        if (literalName) return literalName;
        let symbolicName = this.getSymbolicName(tokenType);
        if (symbolicName) return symbolicName;
        return String(tokenType);
    }
}
/**
 * Gets an empty {@link Vocabulary} instance.
 *
 * No literal or symbol names are assigned to token types, so
 * {@link #getDisplayName(int)} returns the numeric value for all tokens
 * except {@link Token#EOF}.
 */ $cd083bb3193af652$var$VocabularyImpl.EMPTY_VOCABULARY = new $cd083bb3193af652$var$VocabularyImpl([], [], []);
$cd083bb3193af652$var$__decorate([
    $aN41m.NotNull
], $cd083bb3193af652$var$VocabularyImpl.prototype, "literalNames", void 0);
$cd083bb3193af652$var$__decorate([
    $aN41m.NotNull
], $cd083bb3193af652$var$VocabularyImpl.prototype, "symbolicNames", void 0);
$cd083bb3193af652$var$__decorate([
    $aN41m.NotNull
], $cd083bb3193af652$var$VocabularyImpl.prototype, "displayNames", void 0);
$cd083bb3193af652$var$__decorate([
    $aN41m.Override
], $cd083bb3193af652$var$VocabularyImpl.prototype, "maxTokenType", null);
$cd083bb3193af652$var$__decorate([
    $aN41m.Override
], $cd083bb3193af652$var$VocabularyImpl.prototype, "getLiteralName", null);
$cd083bb3193af652$var$__decorate([
    $aN41m.Override
], $cd083bb3193af652$var$VocabularyImpl.prototype, "getSymbolicName", null);
$cd083bb3193af652$var$__decorate([
    $aN41m.Override,
    $aN41m.NotNull
], $cd083bb3193af652$var$VocabularyImpl.prototype, "getDisplayName", null);
$cd083bb3193af652$var$__decorate([
    $aN41m.NotNull
], $cd083bb3193af652$var$VocabularyImpl, "EMPTY_VOCABULARY", void 0);
module.exports.VocabularyImpl = $cd083bb3193af652$var$VocabularyImpl;

});


parcelRegister("gwhAV", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c06d486e830ea671$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $c06d486e830ea671$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerDFASerializer = void 0;

var $aVeml = parcelRequire("aVeml");

var $aN41m = parcelRequire("aN41m");

var $hBnE1 = parcelRequire("hBnE1");
let $c06d486e830ea671$var$LexerDFASerializer = class LexerDFASerializer extends $aVeml.DFASerializer {
    constructor(dfa){
        super(dfa, $hBnE1.VocabularyImpl.EMPTY_VOCABULARY);
    }
    getEdgeLabel(i) {
        return "'" + String.fromCodePoint(i) + "'";
    }
};
$c06d486e830ea671$var$__decorate([
    $aN41m.Override,
    $aN41m.NotNull
], $c06d486e830ea671$var$LexerDFASerializer.prototype, "getEdgeLabel", null);
$c06d486e830ea671$var$LexerDFASerializer = $c06d486e830ea671$var$__decorate([
    $c06d486e830ea671$var$__param(0, $aN41m.NotNull)
], $c06d486e830ea671$var$LexerDFASerializer);
module.exports.LexerDFASerializer = $c06d486e830ea671$var$LexerDFASerializer;

});

parcelRegister("e0pjt", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a324b36ed5e65ddb$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StarLoopEntryState = void 0;

var $fZESB = parcelRequire("fZESB");

var $8WIez = parcelRequire("8WIez");

var $42ptv = parcelRequire("42ptv");

var $aN41m = parcelRequire("aN41m");
class $a324b36ed5e65ddb$var$StarLoopEntryState extends $42ptv.DecisionState {
    constructor(){
        super(...arguments);
        /**
         * Indicates whether this state can benefit from a precedence DFA during SLL
         * decision making.
         *
         * This is a computed property that is calculated during ATN deserialization
         * and stored for use in {@link ParserATNSimulator} and
         * {@link ParserInterpreter}.
         *
         * @see `DFA.isPrecedenceDfa`
         */ this.precedenceRuleDecision = false;
        /**
         * For precedence decisions, this set marks states *S* which have all
         * of the following characteristics:
         *
         * * One or more invocation sites of the current rule returns to
         *   *S*.
         * * The closure from *S* includes the current decision without
         *   passing through any rule invocations or stepping out of the current
         *   rule.
         *
         * This field is not used when {@link #precedenceRuleDecision} is
         * `false`.
         */ this.precedenceLoopbackStates = new $8WIez.BitSet();
    }
    get stateType() {
        return $fZESB.ATNStateType.STAR_LOOP_ENTRY;
    }
}
$a324b36ed5e65ddb$var$__decorate([
    $aN41m.Override
], $a324b36ed5e65ddb$var$StarLoopEntryState.prototype, "stateType", null);
module.exports.StarLoopEntryState = $a324b36ed5e65ddb$var$StarLoopEntryState;

});


parcelRegister("8ii30", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $609e010be7b51ab4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidState = void 0;

var $fZESB = parcelRequire("fZESB");

var $3XAPg = parcelRequire("3XAPg");

var $aN41m = parcelRequire("aN41m");
/**
 *
 * @author Sam Harwell
 */ class $609e010be7b51ab4$var$InvalidState extends $3XAPg.BasicState {
    get stateType() {
        return $fZESB.ATNStateType.INVALID_TYPE;
    }
}
$609e010be7b51ab4$var$__decorate([
    $aN41m.Override
], $609e010be7b51ab4$var$InvalidState.prototype, "stateType", null);
module.exports.InvalidState = $609e010be7b51ab4$var$InvalidState;

});
parcelRegister("3XAPg", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $2e2372a25da2f9ab$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BasicState = void 0;

var $dv9vN = parcelRequire("dv9vN");

var $fZESB = parcelRequire("fZESB");

var $aN41m = parcelRequire("aN41m");
/**
 *
 * @author Sam Harwell
 */ class $2e2372a25da2f9ab$var$BasicState extends $dv9vN.ATNState {
    get stateType() {
        return $fZESB.ATNStateType.BASIC;
    }
}
$2e2372a25da2f9ab$var$__decorate([
    $aN41m.Override
], $2e2372a25da2f9ab$var$BasicState.prototype, "stateType", null);
module.exports.BasicState = $2e2372a25da2f9ab$var$BasicState;

});


parcelRegister("kUmff", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f38a4b008fb55a2e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f38a4b008fb55a2e$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LL1Analyzer = void 0;

var $kvmNv = parcelRequire("kvmNv");

var $fsqYw = parcelRequire("fsqYw");

var $hdFz0 = parcelRequire("hdFz0");

var $8WIez = parcelRequire("8WIez");

var $6kdz0 = parcelRequire("6kdz0");

var $aN41m = parcelRequire("aN41m");

var $gFTdY = parcelRequire("gFTdY");

var $9eW9B = parcelRequire("9eW9B");

var $jaUCz = parcelRequire("jaUCz");

var $jWsYN = parcelRequire("jWsYN");

var $lmhna = parcelRequire("lmhna");

var $eKXi4 = parcelRequire("eKXi4");

var $69uaV = parcelRequire("69uaV");
let $f38a4b008fb55a2e$var$LL1Analyzer = class LL1Analyzer {
    constructor(atn){
        this.atn = atn;
    }
    /**
     * Calculates the SLL(1) expected lookahead set for each outgoing transition
     * of an {@link ATNState}. The returned array has one element for each
     * outgoing transition in `s`. If the closure from transition
     * *i* leads to a semantic predicate before matching a symbol, the
     * element at index *i* of the result will be `undefined`.
     *
     * @param s the ATN state
     * @returns the expected symbols for each outgoing transition of `s`.
     */ getDecisionLookahead(s) {
        //		System.out.println("LOOK("+s.stateNumber+")");
        if (s == null) return undefined;
        let look = new Array(s.numberOfTransitions);
        for(let alt = 0; alt < s.numberOfTransitions; alt++){
            let current = new $6kdz0.IntervalSet();
            look[alt] = current;
            let lookBusy = new $fsqYw.Array2DHashSet($9eW9B.ObjectEqualityComparator.INSTANCE);
            let seeThruPreds = false; // fail to get lookahead upon pred
            this._LOOK(s.transition(alt).target, undefined, $jaUCz.PredictionContext.EMPTY_LOCAL, current, lookBusy, new $8WIez.BitSet(), seeThruPreds, false);
            // Wipe out lookahead for this alternative if we found nothing
            // or we had a predicate when we !seeThruPreds
            if (current.size === 0 || current.contains(LL1Analyzer.HIT_PRED)) {
                current = undefined;
                look[alt] = current;
            }
        }
        return look;
    }
    LOOK(s, ctx, stopState) {
        if (stopState === undefined) {
            if (s.atn == null) throw new Error("Illegal state");
            stopState = s.atn.ruleToStopState[s.ruleIndex];
        } else if (stopState === null) // This is an explicit request to pass undefined as the stopState to _LOOK. Used to distinguish an overload
        // from the method which simply omits the stopState parameter.
        stopState = undefined;
        let r = new $6kdz0.IntervalSet();
        let seeThruPreds = true; // ignore preds; get all lookahead
        let addEOF = true;
        this._LOOK(s, stopState, ctx, r, new $fsqYw.Array2DHashSet(), new $8WIez.BitSet(), seeThruPreds, addEOF);
        return r;
    }
    /**
     * Compute set of tokens that can follow `s` in the ATN in the
     * specified `ctx`.
     * <p/>
     * If `ctx` is {@link PredictionContext#EMPTY_LOCAL} and
     * `stopState` or the end of the rule containing `s` is reached,
     * {@link Token#EPSILON} is added to the result set. If `ctx` is not
     * {@link PredictionContext#EMPTY_LOCAL} and `addEOF` is `true`
     * and `stopState` or the end of the outermost rule is reached,
     * {@link Token#EOF} is added to the result set.
     *
     * @param s the ATN state.
     * @param stopState the ATN state to stop at. This can be a
     * {@link BlockEndState} to detect epsilon paths through a closure.
     * @param ctx The outer context, or {@link PredictionContext#EMPTY_LOCAL} if
     * the outer context should not be used.
     * @param look The result lookahead set.
     * @param lookBusy A set used for preventing epsilon closures in the ATN
     * from causing a stack overflow. Outside code should pass
     * `new HashSet<ATNConfig>` for this argument.
     * @param calledRuleStack A set used for preventing left recursion in the
     * ATN from causing a stack overflow. Outside code should pass
     * `new BitSet()` for this argument.
     * @param seeThruPreds `true` to true semantic predicates as
     * implicitly `true` and "see through them", otherwise `false`
     * to treat semantic predicates as opaque and add {@link #HIT_PRED} to the
     * result if one is encountered.
     * @param addEOF Add {@link Token#EOF} to the result if the end of the
     * outermost context is reached. This parameter has no effect if `ctx`
     * is {@link PredictionContext#EMPTY_LOCAL}.
     */ _LOOK(s, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF) {
        //		System.out.println("_LOOK("+s.stateNumber+", ctx="+ctx);
        let c = $hdFz0.ATNConfig.create(s, 0, ctx);
        if (!lookBusy.add(c)) return;
        if (s === stopState) {
            if ($jaUCz.PredictionContext.isEmptyLocal(ctx)) {
                look.add($eKXi4.Token.EPSILON);
                return;
            } else if (ctx.isEmpty) {
                if (addEOF) look.add($eKXi4.Token.EOF);
                return;
            }
        }
        if (s instanceof $jWsYN.RuleStopState) {
            if (ctx.isEmpty && !$jaUCz.PredictionContext.isEmptyLocal(ctx)) {
                if (addEOF) look.add($eKXi4.Token.EOF);
                return;
            }
            let removed = calledRuleStack.get(s.ruleIndex);
            try {
                calledRuleStack.clear(s.ruleIndex);
                for(let i = 0; i < ctx.size; i++){
                    if (ctx.getReturnState(i) === $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY) continue;
                    let returnState = this.atn.states[ctx.getReturnState(i)];
                    //					System.out.println("popping back to "+retState);
                    this._LOOK(returnState, stopState, ctx.getParent(i), look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                }
            } finally{
                if (removed) calledRuleStack.set(s.ruleIndex);
            }
        }
        let n = s.numberOfTransitions;
        for(let i = 0; i < n; i++){
            let t = s.transition(i);
            if (t instanceof $lmhna.RuleTransition) {
                if (calledRuleStack.get(t.ruleIndex)) continue;
                let newContext = ctx.getChild(t.followState.stateNumber);
                try {
                    calledRuleStack.set(t.ruleIndex);
                    this._LOOK(t.target, stopState, newContext, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                } finally{
                    calledRuleStack.clear(t.ruleIndex);
                }
            } else if (t instanceof $kvmNv.AbstractPredicateTransition) {
                if (seeThruPreds) this._LOOK(t.target, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                else look.add(LL1Analyzer.HIT_PRED);
            } else if (t.isEpsilon) this._LOOK(t.target, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
            else if (t instanceof $69uaV.WildcardTransition) look.addAll($6kdz0.IntervalSet.of($eKXi4.Token.MIN_USER_TOKEN_TYPE, this.atn.maxTokenType));
            else {
                //				System.out.println("adding "+ t);
                let set = t.label;
                if (set != null) {
                    if (t instanceof $gFTdY.NotSetTransition) set = set.complement($6kdz0.IntervalSet.of($eKXi4.Token.MIN_USER_TOKEN_TYPE, this.atn.maxTokenType));
                    look.addAll(set);
                }
            }
        }
    }
};
/** Special value added to the lookahead sets to indicate that we hit
 *  a predicate during analysis if `seeThruPreds==false`.
 */ $f38a4b008fb55a2e$var$LL1Analyzer.HIT_PRED = $eKXi4.Token.INVALID_TYPE;
$f38a4b008fb55a2e$var$__decorate([
    $aN41m.NotNull
], $f38a4b008fb55a2e$var$LL1Analyzer.prototype, "atn", void 0);
$f38a4b008fb55a2e$var$__decorate([
    $aN41m.NotNull,
    $f38a4b008fb55a2e$var$__param(0, $aN41m.NotNull),
    $f38a4b008fb55a2e$var$__param(1, $aN41m.NotNull)
], $f38a4b008fb55a2e$var$LL1Analyzer.prototype, "LOOK", null);
$f38a4b008fb55a2e$var$__decorate([
    $f38a4b008fb55a2e$var$__param(0, $aN41m.NotNull),
    $f38a4b008fb55a2e$var$__param(2, $aN41m.NotNull),
    $f38a4b008fb55a2e$var$__param(3, $aN41m.NotNull),
    $f38a4b008fb55a2e$var$__param(4, $aN41m.NotNull),
    $f38a4b008fb55a2e$var$__param(5, $aN41m.NotNull)
], $f38a4b008fb55a2e$var$LL1Analyzer.prototype, "_LOOK", null);
$f38a4b008fb55a2e$var$LL1Analyzer = $f38a4b008fb55a2e$var$__decorate([
    $f38a4b008fb55a2e$var$__param(0, $aN41m.NotNull)
], $f38a4b008fb55a2e$var$LL1Analyzer);
module.exports.LL1Analyzer = $f38a4b008fb55a2e$var$LL1Analyzer;

});
parcelRegister("gFTdY", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c23b501a5502a14e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $c23b501a5502a14e$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NotSetTransition = void 0;

var $aN41m = parcelRequire("aN41m");

var $5EcBU = parcelRequire("5EcBU");
let $c23b501a5502a14e$var$NotSetTransition = class NotSetTransition extends $5EcBU.SetTransition {
    constructor(target, set){
        super(target, set);
    }
    get serializationType() {
        return 8 /* NOT_SET */ ;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return symbol >= minVocabSymbol && symbol <= maxVocabSymbol && !super.matches(symbol, minVocabSymbol, maxVocabSymbol);
    }
    toString() {
        return "~" + super.toString();
    }
};
$c23b501a5502a14e$var$__decorate([
    $aN41m.Override
], $c23b501a5502a14e$var$NotSetTransition.prototype, "serializationType", null);
$c23b501a5502a14e$var$__decorate([
    $aN41m.Override
], $c23b501a5502a14e$var$NotSetTransition.prototype, "matches", null);
$c23b501a5502a14e$var$__decorate([
    $aN41m.Override
], $c23b501a5502a14e$var$NotSetTransition.prototype, "toString", null);
$c23b501a5502a14e$var$NotSetTransition = $c23b501a5502a14e$var$__decorate([
    $c23b501a5502a14e$var$__param(0, $aN41m.NotNull),
    $c23b501a5502a14e$var$__param(1, $aN41m.Nullable)
], $c23b501a5502a14e$var$NotSetTransition);
module.exports.NotSetTransition = $c23b501a5502a14e$var$NotSetTransition;

});
parcelRegister("5EcBU", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $41ca785f4c67a19a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $41ca785f4c67a19a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SetTransition = void 0;

var $6kdz0 = parcelRequire("6kdz0");

var $aN41m = parcelRequire("aN41m");

var $eKXi4 = parcelRequire("eKXi4");

var $5NWCj = parcelRequire("5NWCj");
/** A transition containing a set of values. */ let $41ca785f4c67a19a$var$SetTransition = class SetTransition extends $5NWCj.Transition {
    // TODO (sam): should we really allow undefined here?
    constructor(target, set){
        super(target);
        if (set == null) set = $6kdz0.IntervalSet.of($eKXi4.Token.INVALID_TYPE);
        this.set = set;
    }
    get serializationType() {
        return 7 /* SET */ ;
    }
    get label() {
        return this.set;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return this.set.contains(symbol);
    }
    toString() {
        return this.set.toString();
    }
};
$41ca785f4c67a19a$var$__decorate([
    $aN41m.NotNull
], $41ca785f4c67a19a$var$SetTransition.prototype, "set", void 0);
$41ca785f4c67a19a$var$__decorate([
    $aN41m.Override
], $41ca785f4c67a19a$var$SetTransition.prototype, "serializationType", null);
$41ca785f4c67a19a$var$__decorate([
    $aN41m.Override,
    $aN41m.NotNull
], $41ca785f4c67a19a$var$SetTransition.prototype, "label", null);
$41ca785f4c67a19a$var$__decorate([
    $aN41m.Override
], $41ca785f4c67a19a$var$SetTransition.prototype, "matches", null);
$41ca785f4c67a19a$var$__decorate([
    $aN41m.Override,
    $aN41m.NotNull
], $41ca785f4c67a19a$var$SetTransition.prototype, "toString", null);
$41ca785f4c67a19a$var$SetTransition = $41ca785f4c67a19a$var$__decorate([
    $41ca785f4c67a19a$var$__param(0, $aN41m.NotNull),
    $41ca785f4c67a19a$var$__param(1, $aN41m.Nullable)
], $41ca785f4c67a19a$var$SetTransition);
module.exports.SetTransition = $41ca785f4c67a19a$var$SetTransition;

});


parcelRegister("jWsYN", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $e849e9dccd4b044f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleStopState = void 0;

var $dv9vN = parcelRequire("dv9vN");

var $fZESB = parcelRequire("fZESB");

var $aN41m = parcelRequire("aN41m");
/** The last node in the ATN for a rule, unless that rule is the start symbol.
 *  In that case, there is one transition to EOF. Later, we might encode
 *  references to all calls to this rule to compute FOLLOW sets for
 *  error handling.
 */ class $e849e9dccd4b044f$var$RuleStopState extends $dv9vN.ATNState {
    get nonStopStateNumber() {
        return -1;
    }
    get stateType() {
        return $fZESB.ATNStateType.RULE_STOP;
    }
}
$e849e9dccd4b044f$var$__decorate([
    $aN41m.Override
], $e849e9dccd4b044f$var$RuleStopState.prototype, "nonStopStateNumber", null);
$e849e9dccd4b044f$var$__decorate([
    $aN41m.Override
], $e849e9dccd4b044f$var$RuleStopState.prototype, "stateType", null);
module.exports.RuleStopState = $e849e9dccd4b044f$var$RuleStopState;

});

parcelRegister("lmhna", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f8c920e267cf5afe$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f8c920e267cf5afe$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleTransition = void 0;

var $aN41m = parcelRequire("aN41m");

var $5NWCj = parcelRequire("5NWCj");
/** */ let $f8c920e267cf5afe$var$RuleTransition = class RuleTransition extends $5NWCj.Transition {
    constructor(ruleStart, ruleIndex, precedence, followState){
        super(ruleStart);
        this.tailCall = false;
        this.optimizedTailCall = false;
        this.ruleIndex = ruleIndex;
        this.precedence = precedence;
        this.followState = followState;
    }
    get serializationType() {
        return 3 /* RULE */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
};
$f8c920e267cf5afe$var$__decorate([
    $aN41m.NotNull
], $f8c920e267cf5afe$var$RuleTransition.prototype, "followState", void 0);
$f8c920e267cf5afe$var$__decorate([
    $aN41m.Override
], $f8c920e267cf5afe$var$RuleTransition.prototype, "serializationType", null);
$f8c920e267cf5afe$var$__decorate([
    $aN41m.Override
], $f8c920e267cf5afe$var$RuleTransition.prototype, "isEpsilon", null);
$f8c920e267cf5afe$var$__decorate([
    $aN41m.Override
], $f8c920e267cf5afe$var$RuleTransition.prototype, "matches", null);
$f8c920e267cf5afe$var$RuleTransition = $f8c920e267cf5afe$var$__decorate([
    $f8c920e267cf5afe$var$__param(0, $aN41m.NotNull),
    $f8c920e267cf5afe$var$__param(3, $aN41m.NotNull)
], $f8c920e267cf5afe$var$RuleTransition);
module.exports.RuleTransition = $f8c920e267cf5afe$var$RuleTransition;

});

parcelRegister("69uaV", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $0127eb50794c99a9$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $0127eb50794c99a9$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WildcardTransition = void 0;

var $aN41m = parcelRequire("aN41m");

var $5NWCj = parcelRequire("5NWCj");
let $0127eb50794c99a9$var$WildcardTransition = class WildcardTransition extends $5NWCj.Transition {
    constructor(target){
        super(target);
    }
    get serializationType() {
        return 9 /* WILDCARD */ ;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return symbol >= minVocabSymbol && symbol <= maxVocabSymbol;
    }
    toString() {
        return ".";
    }
};
$0127eb50794c99a9$var$__decorate([
    $aN41m.Override
], $0127eb50794c99a9$var$WildcardTransition.prototype, "serializationType", null);
$0127eb50794c99a9$var$__decorate([
    $aN41m.Override
], $0127eb50794c99a9$var$WildcardTransition.prototype, "matches", null);
$0127eb50794c99a9$var$__decorate([
    $aN41m.Override,
    $aN41m.NotNull
], $0127eb50794c99a9$var$WildcardTransition.prototype, "toString", null);
$0127eb50794c99a9$var$WildcardTransition = $0127eb50794c99a9$var$__decorate([
    $0127eb50794c99a9$var$__param(0, $aN41m.NotNull)
], $0127eb50794c99a9$var$WildcardTransition);
module.exports.WildcardTransition = $0127eb50794c99a9$var$WildcardTransition;

});



parcelRegister("i6TH4", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d2f3fd2991f6cfe3$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d2f3fd2991f6cfe3$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerActionExecutor = void 0;

var $6iIjF = parcelRequire("6iIjF");

var $jKxtl = parcelRequire("jKxtl");

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");
/**
 * Represents an executor for a sequence of lexer actions which traversed during
 * the matching operation of a lexer rule (token).
 *
 * The executor tracks position information for position-dependent lexer actions
 * efficiently, ensuring that actions appearing only at the end of the rule do
 * not cause bloating of the {@link DFA} created for the lexer.
 *
 * @author Sam Harwell
 * @since 4.2
 */ let $d2f3fd2991f6cfe3$var$LexerActionExecutor = class LexerActionExecutor {
    /**
     * Constructs an executor for a sequence of {@link LexerAction} actions.
     * @param lexerActions The lexer actions to execute.
     */ constructor(lexerActions){
        this._lexerActions = lexerActions;
        let hash = $amQx9.MurmurHash.initialize();
        for (let lexerAction of lexerActions)hash = $amQx9.MurmurHash.update(hash, lexerAction);
        this.cachedHashCode = $amQx9.MurmurHash.finish(hash, lexerActions.length);
    }
    /**
     * Creates a {@link LexerActionExecutor} which executes the actions for
     * the input `lexerActionExecutor` followed by a specified
     * `lexerAction`.
     *
     * @param lexerActionExecutor The executor for actions already traversed by
     * the lexer while matching a token within a particular
     * {@link ATNConfig}. If this is `undefined`, the method behaves as though
     * it were an empty executor.
     * @param lexerAction The lexer action to execute after the actions
     * specified in `lexerActionExecutor`.
     *
     * @returns A {@link LexerActionExecutor} for executing the combine actions
     * of `lexerActionExecutor` and `lexerAction`.
     */ static append(lexerActionExecutor, lexerAction) {
        if (!lexerActionExecutor) return new LexerActionExecutor([
            lexerAction
        ]);
        let lexerActions = lexerActionExecutor._lexerActions.slice(0);
        lexerActions.push(lexerAction);
        return new LexerActionExecutor(lexerActions);
    }
    /**
     * Creates a {@link LexerActionExecutor} which encodes the current offset
     * for position-dependent lexer actions.
     *
     * Normally, when the executor encounters lexer actions where
     * {@link LexerAction#isPositionDependent} returns `true`, it calls
     * {@link IntStream#seek} on the input {@link CharStream} to set the input
     * position to the *end* of the current token. This behavior provides
     * for efficient DFA representation of lexer actions which appear at the end
     * of a lexer rule, even when the lexer rule matches a variable number of
     * characters.
     *
     * Prior to traversing a match transition in the ATN, the current offset
     * from the token start index is assigned to all position-dependent lexer
     * actions which have not already been assigned a fixed offset. By storing
     * the offsets relative to the token start index, the DFA representation of
     * lexer actions which appear in the middle of tokens remains efficient due
     * to sharing among tokens of the same length, regardless of their absolute
     * position in the input stream.
     *
     * If the current executor already has offsets assigned to all
     * position-dependent lexer actions, the method returns `this`.
     *
     * @param offset The current offset to assign to all position-dependent
     * lexer actions which do not already have offsets assigned.
     *
     * @returns A {@link LexerActionExecutor} which stores input stream offsets
     * for all position-dependent lexer actions.
     */ fixOffsetBeforeMatch(offset) {
        let updatedLexerActions;
        for(let i = 0; i < this._lexerActions.length; i++)if (this._lexerActions[i].isPositionDependent && !(this._lexerActions[i] instanceof $jKxtl.LexerIndexedCustomAction)) {
            if (!updatedLexerActions) updatedLexerActions = this._lexerActions.slice(0);
            updatedLexerActions[i] = new $jKxtl.LexerIndexedCustomAction(offset, this._lexerActions[i]);
        }
        if (!updatedLexerActions) return this;
        return new LexerActionExecutor(updatedLexerActions);
    }
    /**
     * Gets the lexer actions to be executed by this executor.
     * @returns The lexer actions to be executed by this executor.
     */ get lexerActions() {
        return this._lexerActions;
    }
    /**
     * Execute the actions encapsulated by this executor within the context of a
     * particular {@link Lexer}.
     *
     * This method calls {@link IntStream#seek} to set the position of the
     * `input` {@link CharStream} prior to calling
     * {@link LexerAction#execute} on a position-dependent action. Before the
     * method returns, the input position will be restored to the same position
     * it was in when the method was invoked.
     *
     * @param lexer The lexer instance.
     * @param input The input stream which is the source for the current token.
     * When this method is called, the current {@link IntStream#index} for
     * `input` should be the start of the following token, i.e. 1
     * character past the end of the current token.
     * @param startIndex The token start index. This value may be passed to
     * {@link IntStream#seek} to set the `input` position to the beginning
     * of the token.
     */ execute(lexer, input, startIndex) {
        let requiresSeek = false;
        let stopIndex = input.index;
        try {
            for (let lexerAction of this._lexerActions){
                if (lexerAction instanceof $jKxtl.LexerIndexedCustomAction) {
                    let offset = lexerAction.offset;
                    input.seek(startIndex + offset);
                    lexerAction = lexerAction.action;
                    requiresSeek = startIndex + offset !== stopIndex;
                } else if (lexerAction.isPositionDependent) {
                    input.seek(stopIndex);
                    requiresSeek = false;
                }
                lexerAction.execute(lexer);
            }
        } finally{
            if (requiresSeek) input.seek(stopIndex);
        }
    }
    hashCode() {
        return this.cachedHashCode;
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof LexerActionExecutor)) return false;
        return this.cachedHashCode === obj.cachedHashCode && $6iIjF.ArrayEqualityComparator.INSTANCE.equals(this._lexerActions, obj._lexerActions);
    }
};
$d2f3fd2991f6cfe3$var$__decorate([
    $aN41m.NotNull
], $d2f3fd2991f6cfe3$var$LexerActionExecutor.prototype, "_lexerActions", void 0);
$d2f3fd2991f6cfe3$var$__decorate([
    $aN41m.NotNull
], $d2f3fd2991f6cfe3$var$LexerActionExecutor.prototype, "lexerActions", null);
$d2f3fd2991f6cfe3$var$__decorate([
    $d2f3fd2991f6cfe3$var$__param(0, $aN41m.NotNull)
], $d2f3fd2991f6cfe3$var$LexerActionExecutor.prototype, "execute", null);
$d2f3fd2991f6cfe3$var$__decorate([
    $aN41m.Override
], $d2f3fd2991f6cfe3$var$LexerActionExecutor.prototype, "hashCode", null);
$d2f3fd2991f6cfe3$var$__decorate([
    $aN41m.Override
], $d2f3fd2991f6cfe3$var$LexerActionExecutor.prototype, "equals", null);
$d2f3fd2991f6cfe3$var$__decorate([
    $aN41m.NotNull,
    $d2f3fd2991f6cfe3$var$__param(1, $aN41m.NotNull)
], $d2f3fd2991f6cfe3$var$LexerActionExecutor, "append", null);
$d2f3fd2991f6cfe3$var$LexerActionExecutor = $d2f3fd2991f6cfe3$var$__decorate([
    $d2f3fd2991f6cfe3$var$__param(0, $aN41m.NotNull)
], $d2f3fd2991f6cfe3$var$LexerActionExecutor);
module.exports.LexerActionExecutor = $d2f3fd2991f6cfe3$var$LexerActionExecutor;

});
parcelRegister("jKxtl", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $e60c471ba1c7e661$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $e60c471ba1c7e661$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerIndexedCustomAction = void 0;

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");
/**
 * This implementation of {@link LexerAction} is used for tracking input offsets
 * for position-dependent actions within a {@link LexerActionExecutor}.
 *
 * This action is not serialized as part of the ATN, and is only required for
 * position-dependent lexer actions which appear at a location other than the
 * end of a rule. For more information about DFA optimizations employed for
 * lexer actions, see {@link LexerActionExecutor#append} and
 * {@link LexerActionExecutor#fixOffsetBeforeMatch}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ let $e60c471ba1c7e661$var$LexerIndexedCustomAction = class LexerIndexedCustomAction {
    /**
     * Constructs a new indexed custom action by associating a character offset
     * with a {@link LexerAction}.
     *
     * Note: This class is only required for lexer actions for which
     * {@link LexerAction#isPositionDependent} returns `true`.
     *
     * @param offset The offset into the input {@link CharStream}, relative to
     * the token start index, at which the specified lexer action should be
     * executed.
     * @param action The lexer action to execute at a particular offset in the
     * input {@link CharStream}.
     */ constructor(offset, action){
        this._offset = offset;
        this._action = action;
    }
    /**
     * Gets the location in the input {@link CharStream} at which the lexer
     * action should be executed. The value is interpreted as an offset relative
     * to the token start index.
     *
     * @returns The location in the input {@link CharStream} at which the lexer
     * action should be executed.
     */ get offset() {
        return this._offset;
    }
    /**
     * Gets the lexer action to execute.
     *
     * @returns A {@link LexerAction} object which executes the lexer action.
     */ get action() {
        return this._action;
    }
    /**
     * {@inheritDoc}
     *
     * @returns This method returns the result of calling {@link #getActionType}
     * on the {@link LexerAction} returned by {@link #getAction}.
     */ get actionType() {
        return this._action.actionType;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `true`.
     */ get isPositionDependent() {
        return true;
    }
    /**
     * {@inheritDoc}
     *
     * This method calls {@link #execute} on the result of {@link #getAction}
     * using the provided `lexer`.
     */ execute(lexer) {
        // assume the input stream position was properly set by the calling code
        this._action.execute(lexer);
    }
    hashCode() {
        let hash = $amQx9.MurmurHash.initialize();
        hash = $amQx9.MurmurHash.update(hash, this._offset);
        hash = $amQx9.MurmurHash.update(hash, this._action);
        return $amQx9.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof LexerIndexedCustomAction)) return false;
        return this._offset === obj._offset && this._action.equals(obj._action);
    }
};
$e60c471ba1c7e661$var$__decorate([
    $aN41m.NotNull
], $e60c471ba1c7e661$var$LexerIndexedCustomAction.prototype, "action", null);
$e60c471ba1c7e661$var$__decorate([
    $aN41m.Override
], $e60c471ba1c7e661$var$LexerIndexedCustomAction.prototype, "actionType", null);
$e60c471ba1c7e661$var$__decorate([
    $aN41m.Override
], $e60c471ba1c7e661$var$LexerIndexedCustomAction.prototype, "isPositionDependent", null);
$e60c471ba1c7e661$var$__decorate([
    $aN41m.Override
], $e60c471ba1c7e661$var$LexerIndexedCustomAction.prototype, "execute", null);
$e60c471ba1c7e661$var$__decorate([
    $aN41m.Override
], $e60c471ba1c7e661$var$LexerIndexedCustomAction.prototype, "hashCode", null);
$e60c471ba1c7e661$var$__decorate([
    $aN41m.Override
], $e60c471ba1c7e661$var$LexerIndexedCustomAction.prototype, "equals", null);
$e60c471ba1c7e661$var$LexerIndexedCustomAction = $e60c471ba1c7e661$var$__decorate([
    $e60c471ba1c7e661$var$__param(1, $aN41m.NotNull)
], $e60c471ba1c7e661$var$LexerIndexedCustomAction);
module.exports.LexerIndexedCustomAction = $e60c471ba1c7e661$var$LexerIndexedCustomAction;

});


parcelRegister("l3IpB", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f54c54195bb1f77d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f54c54195bb1f77d$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerNoViableAltException = void 0;

var $b7PPe = parcelRequire("b7PPe");

var $aN41m = parcelRequire("aN41m");

var $l8y5T = parcelRequire("l8y5T");

var $62Uvn = parcelRequire("62Uvn");
let $f54c54195bb1f77d$var$LexerNoViableAltException = class LexerNoViableAltException extends $b7PPe.RecognitionException {
    constructor(lexer, input, startIndex, deadEndConfigs){
        super(lexer, input);
        this._startIndex = startIndex;
        this._deadEndConfigs = deadEndConfigs;
    }
    get startIndex() {
        return this._startIndex;
    }
    get deadEndConfigs() {
        return this._deadEndConfigs;
    }
    get inputStream() {
        return super.inputStream;
    }
    toString() {
        let symbol = "";
        if (this._startIndex >= 0 && this._startIndex < this.inputStream.size) {
            symbol = this.inputStream.getText($l8y5T.Interval.of(this._startIndex, this._startIndex));
            symbol = $62Uvn.escapeWhitespace(symbol, false);
        }
        // return String.format(Locale.getDefault(), "%s('%s')", LexerNoViableAltException.class.getSimpleName(), symbol);
        return `LexerNoViableAltException('${symbol}')`;
    }
};
$f54c54195bb1f77d$var$__decorate([
    $aN41m.Override
], $f54c54195bb1f77d$var$LexerNoViableAltException.prototype, "inputStream", null);
$f54c54195bb1f77d$var$__decorate([
    $aN41m.Override
], $f54c54195bb1f77d$var$LexerNoViableAltException.prototype, "toString", null);
$f54c54195bb1f77d$var$LexerNoViableAltException = $f54c54195bb1f77d$var$__decorate([
    $f54c54195bb1f77d$var$__param(1, $aN41m.NotNull)
], $f54c54195bb1f77d$var$LexerNoViableAltException);
module.exports.LexerNoViableAltException = $f54c54195bb1f77d$var$LexerNoViableAltException;

});

parcelRegister("9O0ze", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $7239393757aed774$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OrderedATNConfigSet = void 0;

var $2SGHL = parcelRequire("2SGHL");

var $aN41m = parcelRequire("aN41m");
/**
 *
 * @author Sam Harwell
 */ class $7239393757aed774$var$OrderedATNConfigSet extends $2SGHL.ATNConfigSet {
    constructor(set, readonly){
        if (set != null && readonly != null) super(set, readonly);
        else super();
    }
    clone(readonly) {
        let copy = new $7239393757aed774$var$OrderedATNConfigSet(this, readonly);
        if (!readonly && this.isReadOnly) copy.addAll(this);
        return copy;
    }
    getKey(e) {
        // This is a specially crafted key to ensure configurations are only merged if they are equal
        return {
            state: 0,
            alt: e.hashCode()
        };
    }
    canMerge(left, leftKey, right) {
        return left.equals(right);
    }
}
$7239393757aed774$var$__decorate([
    $aN41m.Override
], $7239393757aed774$var$OrderedATNConfigSet.prototype, "clone", null);
$7239393757aed774$var$__decorate([
    $aN41m.Override
], $7239393757aed774$var$OrderedATNConfigSet.prototype, "getKey", null);
$7239393757aed774$var$__decorate([
    $aN41m.Override
], $7239393757aed774$var$OrderedATNConfigSet.prototype, "canMerge", null);
module.exports.OrderedATNConfigSet = $7239393757aed774$var$OrderedATNConfigSet;

});




parcelRegister("iAlWg", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d87c9b6083957611$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NoViableAltException = void 0;

var $c9Sjf = parcelRequire("c9Sjf");

var $b7PPe = parcelRequire("b7PPe");

var $aN41m = parcelRequire("aN41m");
/** Indicates that the parser could not decide which of two or more paths
 *  to take based upon the remaining input. It tracks the starting token
 *  of the offending input and also knows where the parser was
 *  in the various paths when the error. Reported by reportNoViableAlternative()
 */ class $d87c9b6083957611$var$NoViableAltException extends $b7PPe.RecognitionException {
    constructor(recognizer, input, startToken, offendingToken, deadEndConfigs, ctx){
        if (recognizer instanceof $c9Sjf.Parser) {
            if (input === undefined) input = recognizer.inputStream;
            if (startToken === undefined) startToken = recognizer.currentToken;
            if (offendingToken === undefined) offendingToken = recognizer.currentToken;
            if (ctx === undefined) ctx = recognizer.context;
        }
        super(recognizer, input, ctx);
        this._deadEndConfigs = deadEndConfigs;
        this._startToken = startToken;
        this.setOffendingToken(recognizer, offendingToken);
    }
    get startToken() {
        return this._startToken;
    }
    get deadEndConfigs() {
        return this._deadEndConfigs;
    }
}
$d87c9b6083957611$var$__decorate([
    $aN41m.NotNull
], $d87c9b6083957611$var$NoViableAltException.prototype, "_startToken", void 0);
module.exports.NoViableAltException = $d87c9b6083957611$var$NoViableAltException;

});
parcelRegister("c9Sjf", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $8da07405e42e2bc1$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $8da07405e42e2bc1$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var $8da07405e42e2bc1$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Parser = void 0;

var $62Uvn = parcelRequire("62Uvn");

var $3VQ9j = parcelRequire("3VQ9j");

var $1ztRl = parcelRequire("1ztRl");

var $3HZil = parcelRequire("3HZil");

var $co9Xk = parcelRequire("co9Xk");

var $jB0DW = parcelRequire("jB0DW");

var $h7Q3L = parcelRequire("h7Q3L");

var $aN41m = parcelRequire("aN41m");

var $8EOCV = parcelRequire("8EOCV");

var $gzbPK = parcelRequire("gzbPK");

var $jdbdJ = parcelRequire("jdbdJ");

var $dwftT = parcelRequire("dwftT");

var $2IN61 = parcelRequire("2IN61");

var $eKXi4 = parcelRequire("eKXi4");
class $8da07405e42e2bc1$var$TraceListener {
    constructor(ruleNames, tokenStream){
        this.ruleNames = ruleNames;
        this.tokenStream = tokenStream;
    }
    enterEveryRule(ctx) {
        console.log("enter   " + this.ruleNames[ctx.ruleIndex] + ", LT(1)=" + this.tokenStream.LT(1).text);
    }
    exitEveryRule(ctx) {
        console.log("exit    " + this.ruleNames[ctx.ruleIndex] + ", LT(1)=" + this.tokenStream.LT(1).text);
    }
    visitErrorNode(node) {
    // intentionally empty
    }
    visitTerminal(node) {
        let parent = node.parent.ruleContext;
        let token = node.symbol;
        console.log("consume " + token + " rule " + this.ruleNames[parent.ruleIndex]);
    }
}
$8da07405e42e2bc1$var$__decorate([
    $aN41m.Override
], $8da07405e42e2bc1$var$TraceListener.prototype, "enterEveryRule", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.Override
], $8da07405e42e2bc1$var$TraceListener.prototype, "exitEveryRule", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.Override
], $8da07405e42e2bc1$var$TraceListener.prototype, "visitErrorNode", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.Override
], $8da07405e42e2bc1$var$TraceListener.prototype, "visitTerminal", null);



/** This is all the parsing support code essentially; most of it is error recovery stuff. */ class $8da07405e42e2bc1$var$Parser extends $dwftT.Recognizer {
    constructor(input){
        super();
        /**
         * The error handling strategy for the parser. The default value is a new
         * instance of {@link DefaultErrorStrategy}.
         *
         * @see #getErrorHandler
         * @see #setErrorHandler
         */ this._errHandler = new $3HZil.DefaultErrorStrategy();
        this._precedenceStack = new $jB0DW.IntegerStack();
        /**
         * Specifies whether or not the parser should construct a parse tree during
         * the parsing process. The default value is `true`.
         *
         * @see `buildParseTree`
         */ this._buildParseTrees = true;
        /**
         * The list of {@link ParseTreeListener} listeners registered to receive
         * events during the parse.
         *
         * @see #addParseListener
         */ this._parseListeners = [];
        /**
         * The number of syntax errors reported during parsing. This value is
         * incremented each time {@link #notifyErrorListeners} is called.
         */ this._syntaxErrors = 0;
        /** Indicates parser has match()ed EOF token. See {@link #exitRule()}. */ this.matchedEOF = false;
        this._precedenceStack.push(0);
        this.inputStream = input;
    }
    reset(resetInput) {
        // Note: this method executes when not parsing, so _ctx can be undefined
        if (resetInput === undefined || resetInput) this.inputStream.seek(0);
        this._errHandler.reset(this);
        this._ctx = undefined;
        this._syntaxErrors = 0;
        this.matchedEOF = false;
        this.isTrace = false;
        this._precedenceStack.clear();
        this._precedenceStack.push(0);
        let interpreter = this.interpreter;
        if (interpreter != null) interpreter.reset();
    }
    /**
     * Match current input symbol against `ttype`. If the symbol type
     * matches, {@link ANTLRErrorStrategy#reportMatch} and {@link #consume} are
     * called to complete the match process.
     *
     * If the symbol type does not match,
     * {@link ANTLRErrorStrategy#recoverInline} is called on the current error
     * strategy to attempt recovery. If {@link #getBuildParseTree} is
     * `true` and the token index of the symbol returned by
     * {@link ANTLRErrorStrategy#recoverInline} is -1, the symbol is added to
     * the parse tree by calling {@link #createErrorNode(ParserRuleContext, Token)} then
     * {@link ParserRuleContext#addErrorNode(ErrorNode)}.
     *
     * @param ttype the token type to match
     * @returns the matched symbol
     * @ if the current input symbol did not match
     * `ttype` and the error strategy could not recover from the
     * mismatched symbol
     */ match(ttype) {
        let t = this.currentToken;
        if (t.type === ttype) {
            if (ttype === $eKXi4.Token.EOF) this.matchedEOF = true;
            this._errHandler.reportMatch(this);
            this.consume();
        } else {
            t = this._errHandler.recoverInline(this);
            if (this._buildParseTrees && t.tokenIndex === -1) // we must have conjured up a new token during single token insertion
            // if it's not the current symbol
            this._ctx.addErrorNode(this.createErrorNode(this._ctx, t));
        }
        return t;
    }
    /**
     * Match current input symbol as a wildcard. If the symbol type matches
     * (i.e. has a value greater than 0), {@link ANTLRErrorStrategy#reportMatch}
     * and {@link #consume} are called to complete the match process.
     *
     * If the symbol type does not match,
     * {@link ANTLRErrorStrategy#recoverInline} is called on the current error
     * strategy to attempt recovery. If {@link #getBuildParseTree} is
     * `true` and the token index of the symbol returned by
     * {@link ANTLRErrorStrategy#recoverInline} is -1, the symbol is added to
     * the parse tree by calling {@link Parser#createErrorNode(ParserRuleContext, Token)} then
     * {@link ParserRuleContext#addErrorNode(ErrorNode)}.
     *
     * @returns the matched symbol
     * @ if the current input symbol did not match
     * a wildcard and the error strategy could not recover from the mismatched
     * symbol
     */ matchWildcard() {
        let t = this.currentToken;
        if (t.type > 0) {
            this._errHandler.reportMatch(this);
            this.consume();
        } else {
            t = this._errHandler.recoverInline(this);
            if (this._buildParseTrees && t.tokenIndex === -1) // we must have conjured up a new token during single token insertion
            // if it's not the current symbol
            this._ctx.addErrorNode(this.createErrorNode(this._ctx, t));
        }
        return t;
    }
    /**
     * Track the {@link ParserRuleContext} objects during the parse and hook
     * them up using the {@link ParserRuleContext#children} list so that it
     * forms a parse tree. The {@link ParserRuleContext} returned from the start
     * rule represents the root of the parse tree.
     *
     * Note that if we are not building parse trees, rule contexts only point
     * upwards. When a rule exits, it returns the context but that gets garbage
     * collected if nobody holds a reference. It points upwards but nobody
     * points at it.
     *
     * When we build parse trees, we are adding all of these contexts to
     * {@link ParserRuleContext#children} list. Contexts are then not candidates
     * for garbage collection.
     */ set buildParseTree(buildParseTrees) {
        this._buildParseTrees = buildParseTrees;
    }
    /**
     * Gets whether or not a complete parse tree will be constructed while
     * parsing. This property is `true` for a newly constructed parser.
     *
     * @returns `true` if a complete parse tree will be constructed while
     * parsing, otherwise `false`
     */ get buildParseTree() {
        return this._buildParseTrees;
    }
    getParseListeners() {
        return this._parseListeners;
    }
    /**
     * Registers `listener` to receive events during the parsing process.
     *
     * To support output-preserving grammar transformations (including but not
     * limited to left-recursion removal, automated left-factoring, and
     * optimized code generation), calls to listener methods during the parse
     * may differ substantially from calls made by
     * {@link ParseTreeWalker#DEFAULT} used after the parse is complete. In
     * particular, rule entry and exit events may occur in a different order
     * during the parse than after the parser. In addition, calls to certain
     * rule entry methods may be omitted.
     *
     * With the following specific exceptions, calls to listener events are
     * *deterministic*, i.e. for identical input the calls to listener
     * methods will be the same.
     *
     * * Alterations to the grammar used to generate code may change the
     *   behavior of the listener calls.
     * * Alterations to the command line options passed to ANTLR 4 when
     *   generating the parser may change the behavior of the listener calls.
     * * Changing the version of the ANTLR Tool used to generate the parser
     *   may change the behavior of the listener calls.
     *
     * @param listener the listener to add
     *
     * @throws {@link TypeError} if `listener` is `undefined`
     */ addParseListener(listener) {
        if (listener == null) throw new TypeError("listener cannot be null");
        this._parseListeners.push(listener);
    }
    /**
     * Remove `listener` from the list of parse listeners.
     *
     * If `listener` is `undefined` or has not been added as a parse
     * listener, this method does nothing.
     *
     * @see #addParseListener
     *
     * @param listener the listener to remove
     */ removeParseListener(listener) {
        let index = this._parseListeners.findIndex((l)=>l === listener);
        if (index !== -1) this._parseListeners.splice(index, 1);
    }
    /**
     * Remove all parse listeners.
     *
     * @see #addParseListener
     */ removeParseListeners() {
        this._parseListeners.length = 0;
    }
    /**
     * Notify any parse listeners of an enter rule event.
     *
     * @see #addParseListener
     */ triggerEnterRuleEvent() {
        for (let listener of this._parseListeners){
            if (listener.enterEveryRule) listener.enterEveryRule(this._ctx);
            this._ctx.enterRule(listener);
        }
    }
    /**
     * Notify any parse listeners of an exit rule event.
     *
     * @see #addParseListener
     */ triggerExitRuleEvent() {
        // reverse order walk of listeners
        for(let i = this._parseListeners.length - 1; i >= 0; i--){
            let listener = this._parseListeners[i];
            this._ctx.exitRule(listener);
            if (listener.exitEveryRule) listener.exitEveryRule(this._ctx);
        }
    }
    /**
     * Gets the number of syntax errors reported during parsing. This value is
     * incremented each time {@link #notifyErrorListeners} is called.
     *
     * @see #notifyErrorListeners
     */ get numberOfSyntaxErrors() {
        return this._syntaxErrors;
    }
    get tokenFactory() {
        return this._input.tokenSource.tokenFactory;
    }
    /**
     * The ATN with bypass alternatives is expensive to create so we create it
     * lazily.
     *
     * @ if the current parser does not
     * implement the `serializedATN` property.
     */ getATNWithBypassAlts() {
        let serializedAtn = this.serializedATN;
        if (serializedAtn == null) throw new Error("The current parser does not support an ATN with bypass alternatives.");
        let result = $8da07405e42e2bc1$var$Parser.bypassAltsAtnCache.get(serializedAtn);
        if (result == null) {
            let deserializationOptions = new $3VQ9j.ATNDeserializationOptions();
            deserializationOptions.isGenerateRuleBypassTransitions = true;
            result = new $1ztRl.ATNDeserializer(deserializationOptions).deserialize($62Uvn.toCharArray(serializedAtn));
            $8da07405e42e2bc1$var$Parser.bypassAltsAtnCache.set(serializedAtn, result);
        }
        return result;
    }
    compileParseTreePattern(pattern, patternRuleIndex, lexer) {
        return $8da07405e42e2bc1$var$__awaiter(this, void 0, void 0, function*() {
            if (!lexer) {
                if (this.inputStream) {
                    let tokenSource = this.inputStream.tokenSource;
                    if (tokenSource instanceof $h7Q3L.Lexer) lexer = tokenSource;
                }
                if (!lexer) throw new Error("Parser can't discover a lexer to use");
            }
            let currentLexer = lexer;
            let m = yield Promise.resolve().then(()=>(parcelRequire("3O23h")));
            let matcher = new m.ParseTreePatternMatcher(currentLexer, this);
            return matcher.compile(pattern, patternRuleIndex);
        });
    }
    get errorHandler() {
        return this._errHandler;
    }
    set errorHandler(handler) {
        this._errHandler = handler;
    }
    get inputStream() {
        return this._input;
    }
    /** Set the token stream and reset the parser. */ set inputStream(input) {
        this.reset(false);
        this._input = input;
    }
    /** Match needs to return the current input symbol, which gets put
     *  into the label for the associated token ref; e.g., x=ID.
     */ get currentToken() {
        return this._input.LT(1);
    }
    notifyErrorListeners(msg, offendingToken, e) {
        if (offendingToken === undefined) offendingToken = this.currentToken;
        else if (offendingToken === null) offendingToken = undefined;
        this._syntaxErrors++;
        let line = -1;
        let charPositionInLine = -1;
        if (offendingToken != null) {
            line = offendingToken.line;
            charPositionInLine = offendingToken.charPositionInLine;
        }
        let listener = this.getErrorListenerDispatch();
        if (listener.syntaxError) listener.syntaxError(this, offendingToken, line, charPositionInLine, msg, e);
    }
    /**
     * Consume and return the [current symbol](`currentToken`).
     *
     * E.g., given the following input with `A` being the current
     * lookahead symbol, this function moves the cursor to `B` and returns
     * `A`.
     *
     * ```
     * A B
     * ^
     * ```
     *
     * If the parser is not in error recovery mode, the consumed symbol is added
     * to the parse tree using {@link ParserRuleContext#addChild(TerminalNode)}, and
     * {@link ParseTreeListener#visitTerminal} is called on any parse listeners.
     * If the parser *is* in error recovery mode, the consumed symbol is
     * added to the parse tree using {@link #createErrorNode(ParserRuleContext, Token)} then
     * {@link ParserRuleContext#addErrorNode(ErrorNode)} and
     * {@link ParseTreeListener#visitErrorNode} is called on any parse
     * listeners.
     */ consume() {
        let o = this.currentToken;
        if (o.type !== $8da07405e42e2bc1$var$Parser.EOF) this.inputStream.consume();
        let hasListener = this._parseListeners.length !== 0;
        if (this._buildParseTrees || hasListener) {
            if (this._errHandler.inErrorRecoveryMode(this)) {
                let node = this._ctx.addErrorNode(this.createErrorNode(this._ctx, o));
                if (hasListener) {
                    for (let listener of this._parseListeners)if (listener.visitErrorNode) listener.visitErrorNode(node);
                }
            } else {
                let node = this.createTerminalNode(this._ctx, o);
                this._ctx.addChild(node);
                if (hasListener) {
                    for (let listener of this._parseListeners)if (listener.visitTerminal) listener.visitTerminal(node);
                }
            }
        }
        return o;
    }
    /**
     * How to create a token leaf node associated with a parent.
     * Typically, the terminal node to create is not a function of the parent.
     *
     * @since 4.7
     */ createTerminalNode(parent, t) {
        return new $2IN61.TerminalNode(t);
    }
    /**
     * How to create an error node, given a token, associated with a parent.
     * Typically, the error node to create is not a function of the parent.
     *
     * @since 4.7
     */ createErrorNode(parent, t) {
        return new $co9Xk.ErrorNode(t);
    }
    addContextToParseTree() {
        let parent = this._ctx._parent;
        // add current context to parent if we have a parent
        if (parent != null) parent.addChild(this._ctx);
    }
    /**
     * Always called by generated parsers upon entry to a rule. Access field
     * {@link #_ctx} get the current context.
     */ enterRule(localctx, state, ruleIndex) {
        this.state = state;
        this._ctx = localctx;
        this._ctx._start = this._input.LT(1);
        if (this._buildParseTrees) this.addContextToParseTree();
        this.triggerEnterRuleEvent();
    }
    enterLeftFactoredRule(localctx, state, ruleIndex) {
        this.state = state;
        if (this._buildParseTrees) {
            let factoredContext = this._ctx.getChild(this._ctx.childCount - 1);
            this._ctx.removeLastChild();
            factoredContext._parent = localctx;
            localctx.addChild(factoredContext);
        }
        this._ctx = localctx;
        this._ctx._start = this._input.LT(1);
        if (this._buildParseTrees) this.addContextToParseTree();
        this.triggerEnterRuleEvent();
    }
    exitRule() {
        if (this.matchedEOF) // if we have matched EOF, it cannot consume past EOF so we use LT(1) here
        this._ctx._stop = this._input.LT(1); // LT(1) will be end of file
        else this._ctx._stop = this._input.tryLT(-1); // stop node is what we just matched
        // trigger event on _ctx, before it reverts to parent
        this.triggerExitRuleEvent();
        this.state = this._ctx.invokingState;
        this._ctx = this._ctx._parent;
    }
    enterOuterAlt(localctx, altNum) {
        localctx.altNumber = altNum;
        // if we have new localctx, make sure we replace existing ctx
        // that is previous child of parse tree
        if (this._buildParseTrees && this._ctx !== localctx) {
            let parent = this._ctx._parent;
            if (parent != null) {
                parent.removeLastChild();
                parent.addChild(localctx);
            }
        }
        this._ctx = localctx;
    }
    /**
     * Get the precedence level for the top-most precedence rule.
     *
     * @returns The precedence level for the top-most precedence rule, or -1 if
     * the parser context is not nested within a precedence rule.
     */ get precedence() {
        if (this._precedenceStack.isEmpty) return -1;
        return this._precedenceStack.peek();
    }
    enterRecursionRule(localctx, state, ruleIndex, precedence) {
        this.state = state;
        this._precedenceStack.push(precedence);
        this._ctx = localctx;
        this._ctx._start = this._input.LT(1);
        this.triggerEnterRuleEvent(); // simulates rule entry for left-recursive rules
    }
    /** Like {@link #enterRule} but for recursive rules.
     *  Make the current context the child of the incoming localctx.
     */ pushNewRecursionContext(localctx, state, ruleIndex) {
        let previous = this._ctx;
        previous._parent = localctx;
        previous.invokingState = state;
        previous._stop = this._input.tryLT(-1);
        this._ctx = localctx;
        this._ctx._start = previous._start;
        if (this._buildParseTrees) this._ctx.addChild(previous);
        this.triggerEnterRuleEvent(); // simulates rule entry for left-recursive rules
    }
    unrollRecursionContexts(_parentctx) {
        this._precedenceStack.pop();
        this._ctx._stop = this._input.tryLT(-1);
        let retctx = this._ctx; // save current ctx (return value)
        // unroll so _ctx is as it was before call to recursive method
        if (this._parseListeners.length > 0) while(this._ctx !== _parentctx){
            this.triggerExitRuleEvent();
            this._ctx = this._ctx._parent;
        }
        else this._ctx = _parentctx;
        // hook into tree
        retctx._parent = _parentctx;
        if (this._buildParseTrees && _parentctx != null) // add return ctx into invoking rule's tree
        _parentctx.addChild(retctx);
    }
    getInvokingContext(ruleIndex) {
        let p = this._ctx;
        while(p && p.ruleIndex !== ruleIndex)p = p._parent;
        return p;
    }
    get context() {
        return this._ctx;
    }
    set context(ctx) {
        this._ctx = ctx;
    }
    precpred(localctx, precedence) {
        return precedence >= this._precedenceStack.peek();
    }
    getErrorListenerDispatch() {
        return new $jdbdJ.ProxyParserErrorListener(this.getErrorListeners());
    }
    inContext(context) {
        // TODO: useful in parser?
        return false;
    }
    /**
     * Checks whether or not `symbol` can follow the current state in the
     * ATN. The behavior of this method is equivalent to the following, but is
     * implemented such that the complete context-sensitive follow set does not
     * need to be explicitly constructed.
     *
     * ```
     * return getExpectedTokens().contains(symbol);
     * ```
     *
     * @param symbol the symbol type to check
     * @returns `true` if `symbol` can follow the current state in
     * the ATN, otherwise `false`.
     */ isExpectedToken(symbol) {
        //   		return interpreter.atn.nextTokens(_ctx);
        let atn = this.interpreter.atn;
        let ctx = this._ctx;
        let s = atn.states[this.state];
        let following = atn.nextTokens(s);
        if (following.contains(symbol)) return true;
        //        System.out.println("following "+s+"="+following);
        if (!following.contains($eKXi4.Token.EPSILON)) return false;
        while(ctx != null && ctx.invokingState >= 0 && following.contains($eKXi4.Token.EPSILON)){
            let invokingState = atn.states[ctx.invokingState];
            let rt = invokingState.transition(0);
            following = atn.nextTokens(rt.followState);
            if (following.contains(symbol)) return true;
            ctx = ctx._parent;
        }
        if (following.contains($eKXi4.Token.EPSILON) && symbol === $eKXi4.Token.EOF) return true;
        return false;
    }
    get isMatchedEOF() {
        return this.matchedEOF;
    }
    /**
     * Computes the set of input symbols which could follow the current parser
     * state and context, as given by {@link #getState} and {@link #getContext},
     * respectively.
     *
     * @see ATN#getExpectedTokens(int, RuleContext)
     */ getExpectedTokens() {
        return this.atn.getExpectedTokens(this.state, this.context);
    }
    getExpectedTokensWithinCurrentRule() {
        let atn = this.interpreter.atn;
        let s = atn.states[this.state];
        return atn.nextTokens(s);
    }
    /** Get a rule's index (i.e., `RULE_ruleName` field) or -1 if not found. */ getRuleIndex(ruleName) {
        let ruleIndex = this.getRuleIndexMap().get(ruleName);
        if (ruleIndex != null) return ruleIndex;
        return -1;
    }
    get ruleContext() {
        return this._ctx;
    }
    /** Return List&lt;String&gt; of the rule names in your parser instance
     *  leading up to a call to the current rule.  You could override if
     *  you want more details such as the file/line info of where
     *  in the ATN a rule is invoked.
     *
     *  This is very useful for error messages.
     */ getRuleInvocationStack(ctx = this._ctx) {
        let p = ctx; // Workaround for Microsoft/TypeScript#14487
        let ruleNames = this.ruleNames;
        let stack = [];
        while(p != null){
            // compute what follows who invoked us
            let ruleIndex = p.ruleIndex;
            if (ruleIndex < 0) stack.push("n/a");
            else stack.push(ruleNames[ruleIndex]);
            p = p._parent;
        }
        return stack;
    }
    /** For debugging and other purposes. */ getDFAStrings() {
        let s = [];
        for (let dfa of this._interp.atn.decisionToDFA)s.push(dfa.toString(this.vocabulary, this.ruleNames));
        return s;
    }
    /** For debugging and other purposes. */ dumpDFA() {
        let seenOne = false;
        for (let dfa of this._interp.atn.decisionToDFA)if (!dfa.isEmpty) {
            if (seenOne) console.log();
            console.log("Decision " + dfa.decision + ":");
            $2fFJv.stdout.write(dfa.toString(this.vocabulary, this.ruleNames));
            seenOne = true;
        }
    }
    get sourceName() {
        return this._input.sourceName;
    }
    get parseInfo() {
        return Promise.resolve().then(()=>(parcelRequire("fEJhT"))).then((m)=>{
            let interp = this.interpreter;
            if (interp instanceof m.ProfilingATNSimulator) return new $8EOCV.ParseInfo(interp);
            return undefined;
        });
    }
    /**
     * @since 4.3
     */ setProfile(profile) {
        return $8da07405e42e2bc1$var$__awaiter(this, void 0, void 0, function*() {
            let m = yield Promise.resolve().then(()=>(parcelRequire("fEJhT")));
            let interp = this.interpreter;
            if (profile) {
                if (!(interp instanceof m.ProfilingATNSimulator)) this.interpreter = new m.ProfilingATNSimulator(this);
            } else if (interp instanceof m.ProfilingATNSimulator) this.interpreter = new $gzbPK.ParserATNSimulator(this.atn, this);
            this.interpreter.setPredictionMode(interp.getPredictionMode());
        });
    }
    /** During a parse is sometimes useful to listen in on the rule entry and exit
     *  events as well as token matches. This is for quick and dirty debugging.
     */ set isTrace(trace) {
        if (!trace) {
            if (this._tracer) {
                this.removeParseListener(this._tracer);
                this._tracer = undefined;
            }
        } else {
            if (this._tracer) this.removeParseListener(this._tracer);
            else this._tracer = new $8da07405e42e2bc1$var$TraceListener(this.ruleNames, this._input);
            this.addParseListener(this._tracer);
        }
    }
    /**
     * Gets whether a {@link TraceListener} is registered as a parse listener
     * for the parser.
     */ get isTrace() {
        return this._tracer != null;
    }
}
/**
 * This field maps from the serialized ATN string to the deserialized {@link ATN} with
 * bypass alternatives.
 *
 * @see ATNDeserializationOptions.isGenerateRuleBypassTransitions
 */ $8da07405e42e2bc1$var$Parser.bypassAltsAtnCache = new Map();
$8da07405e42e2bc1$var$__decorate([
    $aN41m.NotNull
], $8da07405e42e2bc1$var$Parser.prototype, "_errHandler", void 0);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.NotNull
], $8da07405e42e2bc1$var$Parser.prototype, "match", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.NotNull
], $8da07405e42e2bc1$var$Parser.prototype, "matchWildcard", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.NotNull
], $8da07405e42e2bc1$var$Parser.prototype, "getParseListeners", null);
$8da07405e42e2bc1$var$__decorate([
    $8da07405e42e2bc1$var$__param(0, $aN41m.NotNull)
], $8da07405e42e2bc1$var$Parser.prototype, "addParseListener", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.NotNull
], $8da07405e42e2bc1$var$Parser.prototype, "getATNWithBypassAlts", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.NotNull,
    $8da07405e42e2bc1$var$__param(0, $aN41m.NotNull)
], $8da07405e42e2bc1$var$Parser.prototype, "errorHandler", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.Override
], $8da07405e42e2bc1$var$Parser.prototype, "inputStream", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.NotNull
], $8da07405e42e2bc1$var$Parser.prototype, "currentToken", null);
$8da07405e42e2bc1$var$__decorate([
    $8da07405e42e2bc1$var$__param(0, $aN41m.NotNull)
], $8da07405e42e2bc1$var$Parser.prototype, "enterRule", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.Override,
    $8da07405e42e2bc1$var$__param(0, $aN41m.Nullable)
], $8da07405e42e2bc1$var$Parser.prototype, "precpred", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.Override
], $8da07405e42e2bc1$var$Parser.prototype, "getErrorListenerDispatch", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.NotNull
], $8da07405e42e2bc1$var$Parser.prototype, "getExpectedTokens", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.NotNull
], $8da07405e42e2bc1$var$Parser.prototype, "getExpectedTokensWithinCurrentRule", null);
$8da07405e42e2bc1$var$__decorate([
    $aN41m.Override
], $8da07405e42e2bc1$var$Parser.prototype, "parseInfo", null);
module.exports.Parser = $8da07405e42e2bc1$var$Parser;

});
parcelRegister("3VQ9j", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $2dcf25b78652d5b7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNDeserializationOptions = void 0;

var $aN41m = parcelRequire("aN41m");
/**
 *
 * @author Sam Harwell
 */ class $2dcf25b78652d5b7$var$ATNDeserializationOptions {
    constructor(options){
        this.readOnly = false;
        if (options) {
            this.verifyATN = options.verifyATN;
            this.generateRuleBypassTransitions = options.generateRuleBypassTransitions;
            this.optimize = options.optimize;
        } else {
            this.verifyATN = true;
            this.generateRuleBypassTransitions = false;
            this.optimize = true;
        }
    }
    static get defaultOptions() {
        if ($2dcf25b78652d5b7$var$ATNDeserializationOptions._defaultOptions == null) {
            $2dcf25b78652d5b7$var$ATNDeserializationOptions._defaultOptions = new $2dcf25b78652d5b7$var$ATNDeserializationOptions();
            $2dcf25b78652d5b7$var$ATNDeserializationOptions._defaultOptions.makeReadOnly();
        }
        return $2dcf25b78652d5b7$var$ATNDeserializationOptions._defaultOptions;
    }
    get isReadOnly() {
        return this.readOnly;
    }
    makeReadOnly() {
        this.readOnly = true;
    }
    get isVerifyATN() {
        return this.verifyATN;
    }
    set isVerifyATN(verifyATN) {
        this.throwIfReadOnly();
        this.verifyATN = verifyATN;
    }
    get isGenerateRuleBypassTransitions() {
        return this.generateRuleBypassTransitions;
    }
    set isGenerateRuleBypassTransitions(generateRuleBypassTransitions) {
        this.throwIfReadOnly();
        this.generateRuleBypassTransitions = generateRuleBypassTransitions;
    }
    get isOptimize() {
        return this.optimize;
    }
    set isOptimize(optimize) {
        this.throwIfReadOnly();
        this.optimize = optimize;
    }
    throwIfReadOnly() {
        if (this.isReadOnly) throw new Error("The object is read only.");
    }
}
$2dcf25b78652d5b7$var$__decorate([
    $aN41m.NotNull
], $2dcf25b78652d5b7$var$ATNDeserializationOptions, "defaultOptions", null);
module.exports.ATNDeserializationOptions = $2dcf25b78652d5b7$var$ATNDeserializationOptions;

});

parcelRegister("1ztRl", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $125038c9196d1598$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $125038c9196d1598$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNDeserializer = void 0;

var $dNkDA = parcelRequire("dNkDA");

var $fsqYw = parcelRequire("fsqYw");

var $eeOLb = parcelRequire("eeOLb");

var $3VQ9j = parcelRequire("3VQ9j");

var $fZESB = parcelRequire("fZESB");

var $kXmw5 = parcelRequire("kXmw5");

var $exhhk = parcelRequire("exhhk");

var $3XAPg = parcelRequire("3XAPg");

var $8WIez = parcelRequire("8WIez");

var $jDuoI = parcelRequire("jDuoI");

var $jizfq = parcelRequire("jizfq");

var $42ptv = parcelRequire("42ptv");

var $1Cdmr = parcelRequire("1Cdmr");

var $7Ey8M = parcelRequire("7Ey8M");

var $6kdz0 = parcelRequire("6kdz0");

var $8ii30 = parcelRequire("8ii30");

var $96Can = parcelRequire("96Can");

var $8Nhul = parcelRequire("8Nhul");

var $Sqz9e = parcelRequire("Sqz9e");

var $a52hA = parcelRequire("a52hA");

var $etfit = parcelRequire("etfit");

var $en1aY = parcelRequire("en1aY");

var $jH58C = parcelRequire("jH58C");

var $345c1 = parcelRequire("345c1");

var $fFNPu = parcelRequire("fFNPu");

var $aN41m = parcelRequire("aN41m");

var $gFTdY = parcelRequire("gFTdY");

var $gzbPK = parcelRequire("gzbPK");

var $pC9Ki = parcelRequire("pC9Ki");

var $a84wo = parcelRequire("a84wo");

var $kIrC4 = parcelRequire("kIrC4");

var $j3Sey = parcelRequire("j3Sey");

var $6WqDl = parcelRequire("6WqDl");

var $UvARH = parcelRequire("UvARH");

var $jWsYN = parcelRequire("jWsYN");

var $lmhna = parcelRequire("lmhna");

var $5EcBU = parcelRequire("5EcBU");

var $ferBg = parcelRequire("ferBg");

var $9kZdU = parcelRequire("9kZdU");

var $e0pjt = parcelRequire("e0pjt");

var $eKXi4 = parcelRequire("eKXi4");

var $J9RdB = parcelRequire("J9RdB");

var $f0PQ3 = parcelRequire("f0PQ3");

var $69uaV = parcelRequire("69uaV");
var $125038c9196d1598$var$UnicodeDeserializingMode;
(function(UnicodeDeserializingMode) {
    UnicodeDeserializingMode[UnicodeDeserializingMode["UNICODE_BMP"] = 0] = "UNICODE_BMP";
    UnicodeDeserializingMode[UnicodeDeserializingMode["UNICODE_SMP"] = 1] = "UNICODE_SMP";
})($125038c9196d1598$var$UnicodeDeserializingMode || ($125038c9196d1598$var$UnicodeDeserializingMode = {}));
/**
 *
 * @author Sam Harwell
 */ class $125038c9196d1598$var$ATNDeserializer {
    constructor(deserializationOptions){
        if (deserializationOptions === undefined) deserializationOptions = $3VQ9j.ATNDeserializationOptions.defaultOptions;
        this.deserializationOptions = deserializationOptions;
    }
    static get SERIALIZED_VERSION() {
        /* This value should never change. Updates following this version are
         * reflected as change in the unique ID SERIALIZED_UUID.
         */ return 3;
    }
    /**
     * Determines if a particular serialized representation of an ATN supports
     * a particular feature, identified by the {@link UUID} used for serializing
     * the ATN at the time the feature was first introduced.
     *
     * @param feature The {@link UUID} marking the first time the feature was
     * supported in the serialized ATN.
     * @param actualUuid The {@link UUID} of the actual serialized ATN which is
     * currently being deserialized.
     * @returns `true` if the `actualUuid` value represents a
     * serialized ATN at or after the feature identified by `feature` was
     * introduced; otherwise, `false`.
     */ static isFeatureSupported(feature, actualUuid) {
        let featureIndex = $125038c9196d1598$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(feature));
        if (featureIndex < 0) return false;
        return $125038c9196d1598$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(actualUuid)) >= featureIndex;
    }
    static getUnicodeDeserializer(mode) {
        if (mode === 0 /* UNICODE_BMP */ ) return {
            readUnicode: (data, p)=>{
                return $125038c9196d1598$var$ATNDeserializer.toInt(data[p]);
            },
            size: 1
        };
        else return {
            readUnicode: (data, p)=>{
                return $125038c9196d1598$var$ATNDeserializer.toInt32(data, p);
            },
            size: 2
        };
    }
    deserialize(data) {
        data = data.slice(0);
        // Each Uint16 value in data is shifted by +2 at the entry to this method. This is an encoding optimization
        // targeting the serialized values 0 and -1 (serialized to 0xFFFF), each of which are very common in the
        // serialized form of the ATN. In the modified UTF-8 that Java uses for compiled string literals, these two
        // character values have multi-byte forms. By shifting each value by +2, they become characters 2 and 1 prior to
        // writing the string, each of which have single-byte representations. Since the shift occurs in the tool during
        // ATN serialization, each target is responsible for adjusting the values during deserialization.
        //
        // As a special case, note that the first element of data is not adjusted because it contains the major version
        // number of the serialized ATN, which was fixed at 3 at the time the value shifting was implemented.
        for(let i = 1; i < data.length; i++)data[i] = data[i] - 2 & 0xFFFF;
        let p = 0;
        let version = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
        if (version !== $125038c9196d1598$var$ATNDeserializer.SERIALIZED_VERSION) {
            let reason = `Could not deserialize ATN with version ${version} (expected ${$125038c9196d1598$var$ATNDeserializer.SERIALIZED_VERSION}).`;
            throw new Error(reason);
        }
        let uuid = $125038c9196d1598$var$ATNDeserializer.toUUID(data, p);
        p += 8;
        if ($125038c9196d1598$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(uuid)) < 0) {
            let reason = `Could not deserialize ATN with UUID ${uuid} (expected ${$125038c9196d1598$var$ATNDeserializer.SERIALIZED_UUID} or a legacy UUID).`;
            throw new Error(reason);
        }
        let supportsLexerActions = $125038c9196d1598$var$ATNDeserializer.isFeatureSupported($125038c9196d1598$var$ATNDeserializer.ADDED_LEXER_ACTIONS, uuid);
        let grammarType = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
        let maxTokenType = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
        let atn = new $eeOLb.ATN(grammarType, maxTokenType);
        //
        // STATES
        //
        let loopBackStateNumbers = [];
        let endStateNumbers = [];
        let nstates = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nstates; i++){
            let stype = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
            // ignore bad type of states
            if (stype === $fZESB.ATNStateType.INVALID_TYPE) {
                atn.addState(new $8ii30.InvalidState());
                continue;
            }
            let ruleIndex = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
            if (ruleIndex === 0xFFFF) ruleIndex = -1;
            let s = this.stateFactory(stype, ruleIndex);
            if (stype === $fZESB.ATNStateType.LOOP_END) {
                let loopBackStateNumber = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
                loopBackStateNumbers.push([
                    s,
                    loopBackStateNumber
                ]);
            } else if (s instanceof $jizfq.BlockStartState) {
                let endStateNumber = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
                endStateNumbers.push([
                    s,
                    endStateNumber
                ]);
            }
            atn.addState(s);
        }
        // delay the assignment of loop back and end states until we know all the state instances have been initialized
        for (let pair of loopBackStateNumbers)pair[0].loopBackState = atn.states[pair[1]];
        for (let pair of endStateNumbers)pair[0].endState = atn.states[pair[1]];
        let numNonGreedyStates = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < numNonGreedyStates; i++){
            let stateNumber = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
            atn.states[stateNumber].nonGreedy = true;
        }
        let numSllDecisions = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < numSllDecisions; i++){
            let stateNumber = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
            atn.states[stateNumber].sll = true;
        }
        let numPrecedenceStates = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < numPrecedenceStates; i++){
            let stateNumber = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
            atn.states[stateNumber].isPrecedenceRule = true;
        }
        //
        // RULES
        //
        let nrules = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
        if (atn.grammarType === 0 /* LEXER */ ) atn.ruleToTokenType = new Int32Array(nrules);
        atn.ruleToStartState = new Array(nrules);
        for(let i = 0; i < nrules; i++){
            let s = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
            let startState = atn.states[s];
            startState.leftFactored = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]) !== 0;
            atn.ruleToStartState[i] = startState;
            if (atn.grammarType === 0 /* LEXER */ ) {
                let tokenType = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
                if (tokenType === 0xFFFF) tokenType = $eKXi4.Token.EOF;
                atn.ruleToTokenType[i] = tokenType;
                if (!$125038c9196d1598$var$ATNDeserializer.isFeatureSupported($125038c9196d1598$var$ATNDeserializer.ADDED_LEXER_ACTIONS, uuid)) {
                    // this piece of unused metadata was serialized prior to the
                    // addition of LexerAction
                    let actionIndexIgnored = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
                    if (actionIndexIgnored === 0xFFFF) actionIndexIgnored = -1;
                }
            }
        }
        atn.ruleToStopState = new Array(nrules);
        for (let state of atn.states){
            if (!(state instanceof $jWsYN.RuleStopState)) continue;
            atn.ruleToStopState[state.ruleIndex] = state;
            atn.ruleToStartState[state.ruleIndex].stopState = state;
        }
        //
        // MODES
        //
        let nmodes = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nmodes; i++){
            let s = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
            atn.modeToStartState.push(atn.states[s]);
        }
        atn.modeToDFA = new Array(nmodes);
        for(let i = 0; i < nmodes; i++)atn.modeToDFA[i] = new $1Cdmr.DFA(atn.modeToStartState[i]);
        //
        // SETS
        //
        let sets = [];
        // First, read all sets with 16-bit Unicode code points <= U+FFFF.
        p = this.deserializeSets(data, p, sets, $125038c9196d1598$var$ATNDeserializer.getUnicodeDeserializer(0 /* UNICODE_BMP */ ));
        // Next, if the ATN was serialized with the Unicode SMP feature,
        // deserialize sets with 32-bit arguments <= U+10FFFF.
        if ($125038c9196d1598$var$ATNDeserializer.isFeatureSupported($125038c9196d1598$var$ATNDeserializer.ADDED_UNICODE_SMP, uuid)) p = this.deserializeSets(data, p, sets, $125038c9196d1598$var$ATNDeserializer.getUnicodeDeserializer(1 /* UNICODE_SMP */ ));
        //
        // EDGES
        //
        let nedges = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nedges; i++){
            let src = $125038c9196d1598$var$ATNDeserializer.toInt(data[p]);
            let trg = $125038c9196d1598$var$ATNDeserializer.toInt(data[p + 1]);
            let ttype = $125038c9196d1598$var$ATNDeserializer.toInt(data[p + 2]);
            let arg1 = $125038c9196d1598$var$ATNDeserializer.toInt(data[p + 3]);
            let arg2 = $125038c9196d1598$var$ATNDeserializer.toInt(data[p + 4]);
            let arg3 = $125038c9196d1598$var$ATNDeserializer.toInt(data[p + 5]);
            let trans = this.edgeFactory(atn, ttype, src, trg, arg1, arg2, arg3, sets);
            // console.log(`EDGE ${trans.constructor.name} ${src}->${trg} ${Transition.serializationNames[ttype]} ${arg1},${arg2},${arg3}`);
            let srcState = atn.states[src];
            srcState.addTransition(trans);
            p += 6;
        }
        let returnTransitionsSet = new $fsqYw.Array2DHashSet({
            hashCode: (o)=>o.stopState ^ o.returnState ^ o.outermostPrecedenceReturn,
            equals: (a, b)=>{
                return a.stopState === b.stopState && a.returnState === b.returnState && a.outermostPrecedenceReturn === b.outermostPrecedenceReturn;
            }
        });
        let returnTransitions = [];
        for (let state of atn.states){
            let returningToLeftFactored = state.ruleIndex >= 0 && atn.ruleToStartState[state.ruleIndex].leftFactored;
            for(let i = 0; i < state.numberOfTransitions; i++){
                let t = state.transition(i);
                if (!(t instanceof $lmhna.RuleTransition)) continue;
                let ruleTransition = t;
                let returningFromLeftFactored = atn.ruleToStartState[ruleTransition.target.ruleIndex].leftFactored;
                if (!returningFromLeftFactored && returningToLeftFactored) continue;
                let outermostPrecedenceReturn = -1;
                if (atn.ruleToStartState[ruleTransition.target.ruleIndex].isPrecedenceRule) {
                    if (ruleTransition.precedence === 0) outermostPrecedenceReturn = ruleTransition.target.ruleIndex;
                }
                let current = {
                    stopState: ruleTransition.target.ruleIndex,
                    returnState: ruleTransition.followState.stateNumber,
                    outermostPrecedenceReturn: outermostPrecedenceReturn
                };
                if (returnTransitionsSet.add(current)) returnTransitions.push(current);
            }
        }
        // Add all elements from returnTransitions to the ATN
        for (let returnTransition of returnTransitions){
            let transition = new $7Ey8M.EpsilonTransition(atn.states[returnTransition.returnState], returnTransition.outermostPrecedenceReturn);
            atn.ruleToStopState[returnTransition.stopState].addTransition(transition);
        }
        for (let state of atn.states){
            if (state instanceof $jizfq.BlockStartState) {
                // we need to know the end state to set its start state
                if (state.endState === undefined) throw new Error("IllegalStateException");
                // block end states can only be associated to a single block start state
                if (state.endState.startState !== undefined) throw new Error("IllegalStateException");
                state.endState.startState = state;
            }
            if (state instanceof $a84wo.PlusLoopbackState) {
                let loopbackState = state;
                for(let i = 0; i < loopbackState.numberOfTransitions; i++){
                    let target = loopbackState.transition(i).target;
                    if (target instanceof $pC9Ki.PlusBlockStartState) target.loopBackState = loopbackState;
                }
            } else if (state instanceof $9kZdU.StarLoopbackState) {
                let loopbackState = state;
                for(let i = 0; i < loopbackState.numberOfTransitions; i++){
                    let target = loopbackState.transition(i).target;
                    if (target instanceof $e0pjt.StarLoopEntryState) target.loopBackState = loopbackState;
                }
            }
        }
        //
        // DECISIONS
        //
        let ndecisions = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 1; i <= ndecisions; i++){
            let s = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
            let decState = atn.states[s];
            atn.decisionToState.push(decState);
            decState.decision = i - 1;
        }
        //
        // LEXER ACTIONS
        //
        if (atn.grammarType === 0 /* LEXER */ ) {
            if (supportsLexerActions) {
                atn.lexerActions = new Array($125038c9196d1598$var$ATNDeserializer.toInt(data[p++]));
                for(let i = 0; i < atn.lexerActions.length; i++){
                    let actionType = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
                    let data1 = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
                    if (data1 === 0xFFFF) data1 = -1;
                    let data2 = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
                    if (data2 === 0xFFFF) data2 = -1;
                    let lexerAction = this.lexerActionFactory(actionType, data1, data2);
                    atn.lexerActions[i] = lexerAction;
                }
            } else {
                // for compatibility with older serialized ATNs, convert the old
                // serialized action index for action transitions to the new
                // form, which is the index of a LexerCustomAction
                let legacyLexerActions = [];
                for (let state of atn.states)for(let i = 0; i < state.numberOfTransitions; i++){
                    let transition = state.transition(i);
                    if (!(transition instanceof $dNkDA.ActionTransition)) continue;
                    let ruleIndex = transition.ruleIndex;
                    let actionIndex = transition.actionIndex;
                    let lexerAction = new $8Nhul.LexerCustomAction(ruleIndex, actionIndex);
                    state.setTransition(i, new $dNkDA.ActionTransition(transition.target, ruleIndex, legacyLexerActions.length, false));
                    legacyLexerActions.push(lexerAction);
                }
                atn.lexerActions = legacyLexerActions;
            }
        }
        this.markPrecedenceDecisions(atn);
        atn.decisionToDFA = new Array(ndecisions);
        for(let i = 0; i < ndecisions; i++)atn.decisionToDFA[i] = new $1Cdmr.DFA(atn.decisionToState[i], i);
        if (this.deserializationOptions.isVerifyATN) this.verifyATN(atn);
        if (this.deserializationOptions.isGenerateRuleBypassTransitions && atn.grammarType === 1 /* PARSER */ ) {
            atn.ruleToTokenType = new Int32Array(atn.ruleToStartState.length);
            for(let i = 0; i < atn.ruleToStartState.length; i++)atn.ruleToTokenType[i] = atn.maxTokenType + i + 1;
            for(let i = 0; i < atn.ruleToStartState.length; i++){
                let bypassStart = new $exhhk.BasicBlockStartState();
                bypassStart.ruleIndex = i;
                atn.addState(bypassStart);
                let bypassStop = new $jDuoI.BlockEndState();
                bypassStop.ruleIndex = i;
                atn.addState(bypassStop);
                bypassStart.endState = bypassStop;
                atn.defineDecisionState(bypassStart);
                bypassStop.startState = bypassStart;
                let endState;
                let excludeTransition;
                if (atn.ruleToStartState[i].isPrecedenceRule) {
                    // wrap from the beginning of the rule to the StarLoopEntryState
                    endState = undefined;
                    for (let state of atn.states){
                        if (state.ruleIndex !== i) continue;
                        if (!(state instanceof $e0pjt.StarLoopEntryState)) continue;
                        let maybeLoopEndState = state.transition(state.numberOfTransitions - 1).target;
                        if (!(maybeLoopEndState instanceof $fFNPu.LoopEndState)) continue;
                        if (maybeLoopEndState.epsilonOnlyTransitions && maybeLoopEndState.transition(0).target instanceof $jWsYN.RuleStopState) {
                            endState = state;
                            break;
                        }
                    }
                    if (!endState) throw new Error("Couldn't identify final state of the precedence rule prefix section.");
                    excludeTransition = endState.loopBackState.transition(0);
                } else endState = atn.ruleToStopState[i];
                // all non-excluded transitions that currently target end state need to target blockEnd instead
                for (let state of atn.states)for(let i = 0; i < state.numberOfTransitions; i++){
                    let transition = state.transition(i);
                    if (transition === excludeTransition) continue;
                    if (transition.target === endState) transition.target = bypassStop;
                }
                // all transitions leaving the rule start state need to leave blockStart instead
                while(atn.ruleToStartState[i].numberOfTransitions > 0){
                    let transition = atn.ruleToStartState[i].removeTransition(atn.ruleToStartState[i].numberOfTransitions - 1);
                    bypassStart.addTransition(transition);
                }
                // link the new states
                atn.ruleToStartState[i].addTransition(new $7Ey8M.EpsilonTransition(bypassStart));
                bypassStop.addTransition(new $7Ey8M.EpsilonTransition(endState));
                let matchState = new $3XAPg.BasicState();
                atn.addState(matchState);
                matchState.addTransition(new $kXmw5.AtomTransition(bypassStop, atn.ruleToTokenType[i]));
                bypassStart.addTransition(new $7Ey8M.EpsilonTransition(matchState));
            }
            if (this.deserializationOptions.isVerifyATN) // reverify after modification
            this.verifyATN(atn);
        }
        if (this.deserializationOptions.isOptimize) {
            while(true){
                let optimizationCount = 0;
                optimizationCount += $125038c9196d1598$var$ATNDeserializer.inlineSetRules(atn);
                optimizationCount += $125038c9196d1598$var$ATNDeserializer.combineChainedEpsilons(atn);
                let preserveOrder = atn.grammarType === 0 /* LEXER */ ;
                optimizationCount += $125038c9196d1598$var$ATNDeserializer.optimizeSets(atn, preserveOrder);
                if (optimizationCount === 0) break;
            }
            if (this.deserializationOptions.isVerifyATN) // reverify after modification
            this.verifyATN(atn);
        }
        $125038c9196d1598$var$ATNDeserializer.identifyTailCalls(atn);
        return atn;
    }
    deserializeSets(data, p, sets, unicodeDeserializer) {
        let nsets = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nsets; i++){
            let nintervals = $125038c9196d1598$var$ATNDeserializer.toInt(data[p]);
            p++;
            let set = new $6kdz0.IntervalSet();
            sets.push(set);
            let containsEof = $125038c9196d1598$var$ATNDeserializer.toInt(data[p++]) !== 0;
            if (containsEof) set.add(-1);
            for(let j = 0; j < nintervals; j++){
                let a = unicodeDeserializer.readUnicode(data, p);
                p += unicodeDeserializer.size;
                let b = unicodeDeserializer.readUnicode(data, p);
                p += unicodeDeserializer.size;
                set.add(a, b);
            }
        }
        return p;
    }
    /**
     * Analyze the {@link StarLoopEntryState} states in the specified ATN to set
     * the {@link StarLoopEntryState#precedenceRuleDecision} field to the
     * correct value.
     *
     * @param atn The ATN.
     */ markPrecedenceDecisions(atn) {
        // Map rule index -> precedence decision for that rule
        let rulePrecedenceDecisions = new Map();
        for (let state of atn.states){
            if (!(state instanceof $e0pjt.StarLoopEntryState)) continue;
            /* We analyze the ATN to determine if this ATN decision state is the
             * decision for the closure block that determines whether a
             * precedence rule should continue or complete.
             */ if (atn.ruleToStartState[state.ruleIndex].isPrecedenceRule) {
                let maybeLoopEndState = state.transition(state.numberOfTransitions - 1).target;
                if (maybeLoopEndState instanceof $fFNPu.LoopEndState) {
                    if (maybeLoopEndState.epsilonOnlyTransitions && maybeLoopEndState.transition(0).target instanceof $jWsYN.RuleStopState) {
                        rulePrecedenceDecisions.set(state.ruleIndex, state);
                        state.precedenceRuleDecision = true;
                        state.precedenceLoopbackStates = new $8WIez.BitSet(atn.states.length);
                    }
                }
            }
        }
        // After marking precedence decisions, we go back through and fill in
        // StarLoopEntryState.precedenceLoopbackStates.
        for (let precedenceDecision of rulePrecedenceDecisions)for (let transition of atn.ruleToStopState[precedenceDecision[0]].getTransitions()){
            if (transition.serializationType !== 1 /* EPSILON */ ) continue;
            let epsilonTransition = transition;
            if (epsilonTransition.outermostPrecedenceReturn !== -1) continue;
            precedenceDecision[1].precedenceLoopbackStates.set(transition.target.stateNumber);
        }
    }
    verifyATN(atn) {
        // verify assumptions
        for (let state of atn.states){
            this.checkCondition(state !== undefined, "ATN states should not be undefined.");
            if (state.stateType === $fZESB.ATNStateType.INVALID_TYPE) continue;
            this.checkCondition(state.onlyHasEpsilonTransitions || state.numberOfTransitions <= 1);
            if (state instanceof $pC9Ki.PlusBlockStartState) this.checkCondition(state.loopBackState !== undefined);
            if (state instanceof $e0pjt.StarLoopEntryState) {
                let starLoopEntryState = state;
                this.checkCondition(starLoopEntryState.loopBackState !== undefined);
                this.checkCondition(starLoopEntryState.numberOfTransitions === 2);
                if (starLoopEntryState.transition(0).target instanceof $ferBg.StarBlockStartState) {
                    this.checkCondition(starLoopEntryState.transition(1).target instanceof $fFNPu.LoopEndState);
                    this.checkCondition(!starLoopEntryState.nonGreedy);
                } else if (starLoopEntryState.transition(0).target instanceof $fFNPu.LoopEndState) {
                    this.checkCondition(starLoopEntryState.transition(1).target instanceof $ferBg.StarBlockStartState);
                    this.checkCondition(starLoopEntryState.nonGreedy);
                } else throw new Error("IllegalStateException");
            }
            if (state instanceof $9kZdU.StarLoopbackState) {
                this.checkCondition(state.numberOfTransitions === 1);
                this.checkCondition(state.transition(0).target instanceof $e0pjt.StarLoopEntryState);
            }
            if (state instanceof $fFNPu.LoopEndState) this.checkCondition(state.loopBackState !== undefined);
            if (state instanceof $UvARH.RuleStartState) this.checkCondition(state.stopState !== undefined);
            if (state instanceof $jizfq.BlockStartState) this.checkCondition(state.endState !== undefined);
            if (state instanceof $jDuoI.BlockEndState) this.checkCondition(state.startState !== undefined);
            if (state instanceof $42ptv.DecisionState) {
                let decisionState = state;
                this.checkCondition(decisionState.numberOfTransitions <= 1 || decisionState.decision >= 0);
            } else this.checkCondition(state.numberOfTransitions <= 1 || state instanceof $jWsYN.RuleStopState);
        }
    }
    checkCondition(condition, message) {
        if (!condition) throw new Error("IllegalStateException: " + message);
    }
    static inlineSetRules(atn) {
        let inlinedCalls = 0;
        let ruleToInlineTransition = new Array(atn.ruleToStartState.length);
        for(let i = 0; i < atn.ruleToStartState.length; i++){
            let startState = atn.ruleToStartState[i];
            let middleState = startState;
            while(middleState.onlyHasEpsilonTransitions && middleState.numberOfOptimizedTransitions === 1 && middleState.getOptimizedTransition(0).serializationType === 1 /* EPSILON */ )middleState = middleState.getOptimizedTransition(0).target;
            if (middleState.numberOfOptimizedTransitions !== 1) continue;
            let matchTransition = middleState.getOptimizedTransition(0);
            let matchTarget = matchTransition.target;
            if (matchTransition.isEpsilon || !matchTarget.onlyHasEpsilonTransitions || matchTarget.numberOfOptimizedTransitions !== 1 || !(matchTarget.getOptimizedTransition(0).target instanceof $jWsYN.RuleStopState)) continue;
            switch(matchTransition.serializationType){
                case 5 /* ATOM */ :
                case 2 /* RANGE */ :
                case 7 /* SET */ :
                    ruleToInlineTransition[i] = matchTransition;
                    break;
                case 8 /* NOT_SET */ :
                case 9 /* WILDCARD */ :
                    continue;
                default:
                    continue;
            }
        }
        for (let state of atn.states){
            if (state.ruleIndex < 0) continue;
            let optimizedTransitions;
            for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                let transition = state.getOptimizedTransition(i);
                if (!(transition instanceof $lmhna.RuleTransition)) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue;
                }
                let ruleTransition = transition;
                let effective = ruleToInlineTransition[ruleTransition.target.ruleIndex];
                if (effective === undefined) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue;
                }
                if (optimizedTransitions === undefined) {
                    optimizedTransitions = [];
                    for(let j = 0; j < i; j++)optimizedTransitions.push(state.getOptimizedTransition(i));
                }
                inlinedCalls++;
                let target = ruleTransition.followState;
                let intermediateState = new $3XAPg.BasicState();
                intermediateState.setRuleIndex(target.ruleIndex);
                atn.addState(intermediateState);
                optimizedTransitions.push(new $7Ey8M.EpsilonTransition(intermediateState));
                switch(effective.serializationType){
                    case 5 /* ATOM */ :
                        intermediateState.addTransition(new $kXmw5.AtomTransition(target, effective._label));
                        break;
                    case 2 /* RANGE */ :
                        intermediateState.addTransition(new $6WqDl.RangeTransition(target, effective.from, effective.to));
                        break;
                    case 7 /* SET */ :
                        intermediateState.addTransition(new $5EcBU.SetTransition(target, effective.label));
                        break;
                    default:
                        throw new Error("UnsupportedOperationException");
                }
            }
            if (optimizedTransitions !== undefined) {
                if (state.isOptimized) while(state.numberOfOptimizedTransitions > 0)state.removeOptimizedTransition(state.numberOfOptimizedTransitions - 1);
                for (let transition of optimizedTransitions)state.addOptimizedTransition(transition);
            }
        }
        if ($gzbPK.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + inlinedCalls + " rule invocations by inlining sets.");
        return inlinedCalls;
    }
    static combineChainedEpsilons(atn) {
        let removedEdges = 0;
        for (let state of atn.states){
            if (!state.onlyHasEpsilonTransitions || state instanceof $jWsYN.RuleStopState) continue;
            let optimizedTransitions;
            nextTransition: for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                let transition = state.getOptimizedTransition(i);
                let intermediate = transition.target;
                if (transition.serializationType !== 1 /* EPSILON */  || transition.outermostPrecedenceReturn !== -1 || intermediate.stateType !== $fZESB.ATNStateType.BASIC || !intermediate.onlyHasEpsilonTransitions) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue nextTransition;
                }
                for(let j = 0; j < intermediate.numberOfOptimizedTransitions; j++)if (intermediate.getOptimizedTransition(j).serializationType !== 1 /* EPSILON */  || intermediate.getOptimizedTransition(j).outermostPrecedenceReturn !== -1) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue nextTransition;
                }
                removedEdges++;
                if (optimizedTransitions === undefined) {
                    optimizedTransitions = [];
                    for(let j = 0; j < i; j++)optimizedTransitions.push(state.getOptimizedTransition(j));
                }
                for(let j = 0; j < intermediate.numberOfOptimizedTransitions; j++){
                    let target = intermediate.getOptimizedTransition(j).target;
                    optimizedTransitions.push(new $7Ey8M.EpsilonTransition(target));
                }
            }
            if (optimizedTransitions !== undefined) {
                if (state.isOptimized) while(state.numberOfOptimizedTransitions > 0)state.removeOptimizedTransition(state.numberOfOptimizedTransitions - 1);
                for (let transition of optimizedTransitions)state.addOptimizedTransition(transition);
            }
        }
        if ($gzbPK.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + removedEdges + " transitions by combining chained epsilon transitions.");
        return removedEdges;
    }
    static optimizeSets(atn, preserveOrder) {
        if (preserveOrder) // this optimization currently doesn't preserve edge order.
        return 0;
        let removedPaths = 0;
        let decisions = atn.decisionToState;
        for (let decision of decisions){
            let setTransitions = new $6kdz0.IntervalSet();
            for(let i = 0; i < decision.numberOfOptimizedTransitions; i++){
                let epsTransition = decision.getOptimizedTransition(i);
                if (!(epsTransition instanceof $7Ey8M.EpsilonTransition)) continue;
                if (epsTransition.target.numberOfOptimizedTransitions !== 1) continue;
                let transition = epsTransition.target.getOptimizedTransition(0);
                if (!(transition.target instanceof $jDuoI.BlockEndState)) continue;
                if (transition instanceof $gFTdY.NotSetTransition) continue;
                if (transition instanceof $kXmw5.AtomTransition || transition instanceof $6WqDl.RangeTransition || transition instanceof $5EcBU.SetTransition) setTransitions.add(i);
            }
            if (setTransitions.size <= 1) continue;
            let optimizedTransitions = [];
            for(let i = 0; i < decision.numberOfOptimizedTransitions; i++)if (!setTransitions.contains(i)) optimizedTransitions.push(decision.getOptimizedTransition(i));
            let blockEndState = decision.getOptimizedTransition(setTransitions.minElement).target.getOptimizedTransition(0).target;
            let matchSet = new $6kdz0.IntervalSet();
            for (let interval of setTransitions.intervals)for(let j = interval.a; j <= interval.b; j++){
                let matchTransition = decision.getOptimizedTransition(j).target.getOptimizedTransition(0);
                if (matchTransition instanceof $gFTdY.NotSetTransition) throw new Error("Not yet implemented.");
                else matchSet.addAll(matchTransition.label);
            }
            let newTransition;
            if (matchSet.intervals.length === 1) {
                if (matchSet.size === 1) newTransition = new $kXmw5.AtomTransition(blockEndState, matchSet.minElement);
                else {
                    let matchInterval = matchSet.intervals[0];
                    newTransition = new $6WqDl.RangeTransition(blockEndState, matchInterval.a, matchInterval.b);
                }
            } else newTransition = new $5EcBU.SetTransition(blockEndState, matchSet);
            let setOptimizedState = new $3XAPg.BasicState();
            setOptimizedState.setRuleIndex(decision.ruleIndex);
            atn.addState(setOptimizedState);
            setOptimizedState.addTransition(newTransition);
            optimizedTransitions.push(new $7Ey8M.EpsilonTransition(setOptimizedState));
            removedPaths += decision.numberOfOptimizedTransitions - optimizedTransitions.length;
            if (decision.isOptimized) while(decision.numberOfOptimizedTransitions > 0)decision.removeOptimizedTransition(decision.numberOfOptimizedTransitions - 1);
            for (let transition of optimizedTransitions)decision.addOptimizedTransition(transition);
        }
        if ($gzbPK.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + removedPaths + " paths by collapsing sets.");
        return removedPaths;
    }
    static identifyTailCalls(atn) {
        for (let state of atn.states){
            for(let i = 0; i < state.numberOfTransitions; i++){
                let transition = state.transition(i);
                if (!(transition instanceof $lmhna.RuleTransition)) continue;
                transition.tailCall = this.testTailCall(atn, transition, false);
                transition.optimizedTailCall = this.testTailCall(atn, transition, true);
            }
            if (!state.isOptimized) continue;
            for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                let transition = state.getOptimizedTransition(i);
                if (!(transition instanceof $lmhna.RuleTransition)) continue;
                transition.tailCall = this.testTailCall(atn, transition, false);
                transition.optimizedTailCall = this.testTailCall(atn, transition, true);
            }
        }
    }
    static testTailCall(atn, transition, optimizedPath) {
        if (!optimizedPath && transition.tailCall) return true;
        if (optimizedPath && transition.optimizedTailCall) return true;
        let reachable = new $8WIez.BitSet(atn.states.length);
        let worklist = [];
        worklist.push(transition.followState);
        while(true){
            let state = worklist.pop();
            if (!state) break;
            if (reachable.get(state.stateNumber)) continue;
            if (state instanceof $jWsYN.RuleStopState) continue;
            if (!state.onlyHasEpsilonTransitions) return false;
            let transitionCount = optimizedPath ? state.numberOfOptimizedTransitions : state.numberOfTransitions;
            for(let i = 0; i < transitionCount; i++){
                let t = optimizedPath ? state.getOptimizedTransition(i) : state.transition(i);
                if (t.serializationType !== 1 /* EPSILON */ ) return false;
                worklist.push(t.target);
            }
        }
        return true;
    }
    static toInt(c) {
        return c;
    }
    static toInt32(data, offset) {
        return (data[offset] | data[offset + 1] << 16) >>> 0;
    }
    static toUUID(data, offset) {
        let leastSigBits = $125038c9196d1598$var$ATNDeserializer.toInt32(data, offset);
        let lessSigBits = $125038c9196d1598$var$ATNDeserializer.toInt32(data, offset + 2);
        let moreSigBits = $125038c9196d1598$var$ATNDeserializer.toInt32(data, offset + 4);
        let mostSigBits = $125038c9196d1598$var$ATNDeserializer.toInt32(data, offset + 6);
        return new $f0PQ3.UUID(mostSigBits, moreSigBits, lessSigBits, leastSigBits);
    }
    edgeFactory(atn, type, src, trg, arg1, arg2, arg3, sets) {
        let target = atn.states[trg];
        switch(type){
            case 1 /* EPSILON */ :
                return new $7Ey8M.EpsilonTransition(target);
            case 2 /* RANGE */ :
                if (arg3 !== 0) return new $6WqDl.RangeTransition(target, $eKXi4.Token.EOF, arg2);
                else return new $6WqDl.RangeTransition(target, arg1, arg2);
            case 3 /* RULE */ :
                let rt = new $lmhna.RuleTransition(atn.states[arg1], arg2, arg3, target);
                return rt;
            case 4 /* PREDICATE */ :
                let pt = new $j3Sey.PredicateTransition(target, arg1, arg2, arg3 !== 0);
                return pt;
            case 10 /* PRECEDENCE */ :
                return new $kIrC4.PrecedencePredicateTransition(target, arg1);
            case 5 /* ATOM */ :
                if (arg3 !== 0) return new $kXmw5.AtomTransition(target, $eKXi4.Token.EOF);
                else return new $kXmw5.AtomTransition(target, arg1);
            case 6 /* ACTION */ :
                let a = new $dNkDA.ActionTransition(target, arg1, arg2, arg3 !== 0);
                return a;
            case 7 /* SET */ :
                return new $5EcBU.SetTransition(target, sets[arg1]);
            case 8 /* NOT_SET */ :
                return new $gFTdY.NotSetTransition(target, sets[arg1]);
            case 9 /* WILDCARD */ :
                return new $69uaV.WildcardTransition(target);
        }
        throw new Error("The specified transition type is not valid.");
    }
    stateFactory(type, ruleIndex) {
        let s;
        switch(type){
            case $fZESB.ATNStateType.INVALID_TYPE:
                return new $8ii30.InvalidState();
            case $fZESB.ATNStateType.BASIC:
                s = new $3XAPg.BasicState();
                break;
            case $fZESB.ATNStateType.RULE_START:
                s = new $UvARH.RuleStartState();
                break;
            case $fZESB.ATNStateType.BLOCK_START:
                s = new $exhhk.BasicBlockStartState();
                break;
            case $fZESB.ATNStateType.PLUS_BLOCK_START:
                s = new $pC9Ki.PlusBlockStartState();
                break;
            case $fZESB.ATNStateType.STAR_BLOCK_START:
                s = new $ferBg.StarBlockStartState();
                break;
            case $fZESB.ATNStateType.TOKEN_START:
                s = new $J9RdB.TokensStartState();
                break;
            case $fZESB.ATNStateType.RULE_STOP:
                s = new $jWsYN.RuleStopState();
                break;
            case $fZESB.ATNStateType.BLOCK_END:
                s = new $jDuoI.BlockEndState();
                break;
            case $fZESB.ATNStateType.STAR_LOOP_BACK:
                s = new $9kZdU.StarLoopbackState();
                break;
            case $fZESB.ATNStateType.STAR_LOOP_ENTRY:
                s = new $e0pjt.StarLoopEntryState();
                break;
            case $fZESB.ATNStateType.PLUS_LOOP_BACK:
                s = new $a84wo.PlusLoopbackState();
                break;
            case $fZESB.ATNStateType.LOOP_END:
                s = new $fFNPu.LoopEndState();
                break;
            default:
                let message = `The specified state type ${type} is not valid.`;
                throw new Error(message);
        }
        s.ruleIndex = ruleIndex;
        return s;
    }
    lexerActionFactory(type, data1, data2) {
        switch(type){
            case 0 /* CHANNEL */ :
                return new $96Can.LexerChannelAction(data1);
            case 1 /* CUSTOM */ :
                return new $8Nhul.LexerCustomAction(data1, data2);
            case 2 /* MODE */ :
                return new $Sqz9e.LexerModeAction(data1);
            case 3 /* MORE */ :
                return $a52hA.LexerMoreAction.INSTANCE;
            case 4 /* POP_MODE */ :
                return $etfit.LexerPopModeAction.INSTANCE;
            case 5 /* PUSH_MODE */ :
                return new $en1aY.LexerPushModeAction(data1);
            case 6 /* SKIP */ :
                return $jH58C.LexerSkipAction.INSTANCE;
            case 7 /* TYPE */ :
                return new $345c1.LexerTypeAction(data1);
            default:
                let message = `The specified lexer action type ${type} is not valid.`;
                throw new Error(message);
        }
    }
}
/* WARNING: DO NOT MERGE THESE LINES. If UUIDs differ during a merge,
 * resolve the conflict by generating a new ID!
 */ /**
 * This is the earliest supported serialized UUID.
 */ $125038c9196d1598$var$ATNDeserializer.BASE_SERIALIZED_UUID = $f0PQ3.UUID.fromString("E4178468-DF95-44D0-AD87-F22A5D5FB6D3");
/**
 * This UUID indicates an extension of {@link #ADDED_PRECEDENCE_TRANSITIONS}
 * for the addition of lexer actions encoded as a sequence of
 * {@link LexerAction} instances.
 */ $125038c9196d1598$var$ATNDeserializer.ADDED_LEXER_ACTIONS = $f0PQ3.UUID.fromString("AB35191A-1603-487E-B75A-479B831EAF6D");
/**
 * This UUID indicates the serialized ATN contains two sets of
 * IntervalSets, where the second set's values are encoded as
 * 32-bit integers to support the full Unicode SMP range up to U+10FFFF.
 */ $125038c9196d1598$var$ATNDeserializer.ADDED_UNICODE_SMP = $f0PQ3.UUID.fromString("C23FEA89-0605-4f51-AFB8-058BCAB8C91B");
/**
 * This list contains all of the currently supported UUIDs, ordered by when
 * the feature first appeared in this branch.
 */ $125038c9196d1598$var$ATNDeserializer.SUPPORTED_UUIDS = [
    $125038c9196d1598$var$ATNDeserializer.BASE_SERIALIZED_UUID,
    $125038c9196d1598$var$ATNDeserializer.ADDED_LEXER_ACTIONS,
    $125038c9196d1598$var$ATNDeserializer.ADDED_UNICODE_SMP
];
/**
 * This is the current serialized UUID.
 */ $125038c9196d1598$var$ATNDeserializer.SERIALIZED_UUID = $125038c9196d1598$var$ATNDeserializer.ADDED_UNICODE_SMP;
$125038c9196d1598$var$__decorate([
    $aN41m.NotNull
], $125038c9196d1598$var$ATNDeserializer.prototype, "deserializationOptions", void 0);
$125038c9196d1598$var$__decorate([
    $125038c9196d1598$var$__param(0, $aN41m.NotNull)
], $125038c9196d1598$var$ATNDeserializer.prototype, "deserialize", null);
$125038c9196d1598$var$__decorate([
    $125038c9196d1598$var$__param(0, $aN41m.NotNull)
], $125038c9196d1598$var$ATNDeserializer.prototype, "markPrecedenceDecisions", null);
$125038c9196d1598$var$__decorate([
    $aN41m.NotNull,
    $125038c9196d1598$var$__param(0, $aN41m.NotNull)
], $125038c9196d1598$var$ATNDeserializer.prototype, "edgeFactory", null);
module.exports.ATNDeserializer = $125038c9196d1598$var$ATNDeserializer;

});
parcelRegister("dNkDA", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a0afdc24220f1b76$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a0afdc24220f1b76$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActionTransition = void 0;

var $aN41m = parcelRequire("aN41m");

var $5NWCj = parcelRequire("5NWCj");
let $a0afdc24220f1b76$var$ActionTransition = class ActionTransition extends $5NWCj.Transition {
    constructor(target, ruleIndex, actionIndex = -1, isCtxDependent = false){
        super(target);
        this.ruleIndex = ruleIndex;
        this.actionIndex = actionIndex;
        this.isCtxDependent = isCtxDependent;
    }
    get serializationType() {
        return 6 /* ACTION */ ;
    }
    get isEpsilon() {
        return true; // we are to be ignored by analysis 'cept for predicates
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    toString() {
        return "action_" + this.ruleIndex + ":" + this.actionIndex;
    }
};
$a0afdc24220f1b76$var$__decorate([
    $aN41m.Override
], $a0afdc24220f1b76$var$ActionTransition.prototype, "serializationType", null);
$a0afdc24220f1b76$var$__decorate([
    $aN41m.Override
], $a0afdc24220f1b76$var$ActionTransition.prototype, "isEpsilon", null);
$a0afdc24220f1b76$var$__decorate([
    $aN41m.Override
], $a0afdc24220f1b76$var$ActionTransition.prototype, "matches", null);
$a0afdc24220f1b76$var$__decorate([
    $aN41m.Override
], $a0afdc24220f1b76$var$ActionTransition.prototype, "toString", null);
$a0afdc24220f1b76$var$ActionTransition = $a0afdc24220f1b76$var$__decorate([
    $a0afdc24220f1b76$var$__param(0, $aN41m.NotNull)
], $a0afdc24220f1b76$var$ActionTransition);
module.exports.ActionTransition = $a0afdc24220f1b76$var$ActionTransition;

});

parcelRegister("kXmw5", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f41ac8aa56432c28$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f41ac8aa56432c28$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AtomTransition = void 0;

var $6kdz0 = parcelRequire("6kdz0");

var $aN41m = parcelRequire("aN41m");

var $5NWCj = parcelRequire("5NWCj");
/** TODO: make all transitions sets? no, should remove set edges */ let $f41ac8aa56432c28$var$AtomTransition = class AtomTransition extends $5NWCj.Transition {
    constructor(target, label){
        super(target);
        this._label = label;
    }
    get serializationType() {
        return 5 /* ATOM */ ;
    }
    get label() {
        return $6kdz0.IntervalSet.of(this._label);
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return this._label === symbol;
    }
    toString() {
        return String(this.label);
    }
};
$f41ac8aa56432c28$var$__decorate([
    $aN41m.Override
], $f41ac8aa56432c28$var$AtomTransition.prototype, "serializationType", null);
$f41ac8aa56432c28$var$__decorate([
    $aN41m.Override,
    $aN41m.NotNull
], $f41ac8aa56432c28$var$AtomTransition.prototype, "label", null);
$f41ac8aa56432c28$var$__decorate([
    $aN41m.Override
], $f41ac8aa56432c28$var$AtomTransition.prototype, "matches", null);
$f41ac8aa56432c28$var$__decorate([
    $aN41m.Override,
    $aN41m.NotNull
], $f41ac8aa56432c28$var$AtomTransition.prototype, "toString", null);
$f41ac8aa56432c28$var$AtomTransition = $f41ac8aa56432c28$var$__decorate([
    $f41ac8aa56432c28$var$__param(0, $aN41m.NotNull)
], $f41ac8aa56432c28$var$AtomTransition);
module.exports.AtomTransition = $f41ac8aa56432c28$var$AtomTransition;

});

parcelRegister("exhhk", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a9518ce3013a5e52$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BasicBlockStartState = void 0;

var $fZESB = parcelRequire("fZESB");

var $jizfq = parcelRequire("jizfq");

var $aN41m = parcelRequire("aN41m");
/**
 *
 * @author Sam Harwell
 */ class $a9518ce3013a5e52$var$BasicBlockStartState extends $jizfq.BlockStartState {
    get stateType() {
        return $fZESB.ATNStateType.BLOCK_START;
    }
}
$a9518ce3013a5e52$var$__decorate([
    $aN41m.Override
], $a9518ce3013a5e52$var$BasicBlockStartState.prototype, "stateType", null);
module.exports.BasicBlockStartState = $a9518ce3013a5e52$var$BasicBlockStartState;

});
parcelRegister("jizfq", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlockStartState = void 0;

var $42ptv = parcelRequire("42ptv");
/**  The start of a regular `(...)` block. */ class $e0cb0a3899ef814e$var$BlockStartState extends $42ptv.DecisionState {
}
module.exports.BlockStartState = $e0cb0a3899ef814e$var$BlockStartState;

});


parcelRegister("jDuoI", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $e4b93d2d29e74e89$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlockEndState = void 0;

var $dv9vN = parcelRequire("dv9vN");

var $fZESB = parcelRequire("fZESB");

var $aN41m = parcelRequire("aN41m");
/** Terminal node of a simple `(a|b|c)` block. */ class $e4b93d2d29e74e89$var$BlockEndState extends $dv9vN.ATNState {
    get stateType() {
        return $fZESB.ATNStateType.BLOCK_END;
    }
}
$e4b93d2d29e74e89$var$__decorate([
    $aN41m.Override
], $e4b93d2d29e74e89$var$BlockEndState.prototype, "stateType", null);
module.exports.BlockEndState = $e4b93d2d29e74e89$var$BlockEndState;

});

parcelRegister("7Ey8M", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $5926c077d80a870b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $5926c077d80a870b$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EpsilonTransition = void 0;

var $aN41m = parcelRequire("aN41m");

var $5NWCj = parcelRequire("5NWCj");
let $5926c077d80a870b$var$EpsilonTransition = class EpsilonTransition extends $5NWCj.Transition {
    constructor(target, outermostPrecedenceReturn = -1){
        super(target);
        this._outermostPrecedenceReturn = outermostPrecedenceReturn;
    }
    /**
     * @returns the rule index of a precedence rule for which this transition is
     * returning from, where the precedence value is 0; otherwise, -1.
     *
     * @see ATNConfig.isPrecedenceFilterSuppressed
     * @see ParserATNSimulator#applyPrecedenceFilter(ATNConfigSet, ParserRuleContext, PredictionContextCache)
     * @since 4.4.1
     */ get outermostPrecedenceReturn() {
        return this._outermostPrecedenceReturn;
    }
    get serializationType() {
        return 1 /* EPSILON */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    toString() {
        return "epsilon";
    }
};
$5926c077d80a870b$var$__decorate([
    $aN41m.Override
], $5926c077d80a870b$var$EpsilonTransition.prototype, "serializationType", null);
$5926c077d80a870b$var$__decorate([
    $aN41m.Override
], $5926c077d80a870b$var$EpsilonTransition.prototype, "isEpsilon", null);
$5926c077d80a870b$var$__decorate([
    $aN41m.Override
], $5926c077d80a870b$var$EpsilonTransition.prototype, "matches", null);
$5926c077d80a870b$var$__decorate([
    $aN41m.Override,
    $aN41m.NotNull
], $5926c077d80a870b$var$EpsilonTransition.prototype, "toString", null);
$5926c077d80a870b$var$EpsilonTransition = $5926c077d80a870b$var$__decorate([
    $5926c077d80a870b$var$__param(0, $aN41m.NotNull)
], $5926c077d80a870b$var$EpsilonTransition);
module.exports.EpsilonTransition = $5926c077d80a870b$var$EpsilonTransition;

});

parcelRegister("96Can", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $6a1247a4f2c7624c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $6a1247a4f2c7624c$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerChannelAction = void 0;

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");
/**
 * Implements the `channel` lexer action by calling
 * {@link Lexer#setChannel} with the assigned channel.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $6a1247a4f2c7624c$var$LexerChannelAction {
    /**
     * Constructs a new `channel` action with the specified channel value.
     * @param channel The channel value to pass to {@link Lexer#setChannel}.
     */ constructor(channel){
        this._channel = channel;
    }
    /**
     * Gets the channel to use for the {@link Token} created by the lexer.
     *
     * @returns The channel to use for the {@link Token} created by the lexer.
     */ get channel() {
        return this._channel;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#CHANNEL}.
     */ get actionType() {
        return 0 /* CHANNEL */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#setChannel} with the
     * value provided by {@link #getChannel}.
     */ execute(lexer) {
        lexer.channel = this._channel;
    }
    hashCode() {
        let hash = $amQx9.MurmurHash.initialize();
        hash = $amQx9.MurmurHash.update(hash, this.actionType);
        hash = $amQx9.MurmurHash.update(hash, this._channel);
        return $amQx9.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $6a1247a4f2c7624c$var$LexerChannelAction)) return false;
        return this._channel === obj._channel;
    }
    toString() {
        return `channel(${this._channel})`;
    }
}
$6a1247a4f2c7624c$var$__decorate([
    $aN41m.Override
], $6a1247a4f2c7624c$var$LexerChannelAction.prototype, "actionType", null);
$6a1247a4f2c7624c$var$__decorate([
    $aN41m.Override
], $6a1247a4f2c7624c$var$LexerChannelAction.prototype, "isPositionDependent", null);
$6a1247a4f2c7624c$var$__decorate([
    $aN41m.Override,
    $6a1247a4f2c7624c$var$__param(0, $aN41m.NotNull)
], $6a1247a4f2c7624c$var$LexerChannelAction.prototype, "execute", null);
$6a1247a4f2c7624c$var$__decorate([
    $aN41m.Override
], $6a1247a4f2c7624c$var$LexerChannelAction.prototype, "hashCode", null);
$6a1247a4f2c7624c$var$__decorate([
    $aN41m.Override
], $6a1247a4f2c7624c$var$LexerChannelAction.prototype, "equals", null);
$6a1247a4f2c7624c$var$__decorate([
    $aN41m.Override
], $6a1247a4f2c7624c$var$LexerChannelAction.prototype, "toString", null);
module.exports.LexerChannelAction = $6a1247a4f2c7624c$var$LexerChannelAction;

});

parcelRegister("8Nhul", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $66707726ebb084aa$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $66707726ebb084aa$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerCustomAction = void 0;

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");
/**
 * Executes a custom lexer action by calling {@link Recognizer#action} with the
 * rule and action indexes assigned to the custom action. The implementation of
 * a custom action is added to the generated code for the lexer in an override
 * of {@link Recognizer#action} when the grammar is compiled.
 *
 * This class may represent embedded actions created with the `{...}`
 * syntax in ANTLR 4, as well as actions created for lexer commands where the
 * command argument could not be evaluated when the grammar was compiled.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $66707726ebb084aa$var$LexerCustomAction {
    /**
     * Constructs a custom lexer action with the specified rule and action
     * indexes.
     *
     * @param ruleIndex The rule index to use for calls to
     * {@link Recognizer#action}.
     * @param actionIndex The action index to use for calls to
     * {@link Recognizer#action}.
     */ constructor(ruleIndex, actionIndex){
        this._ruleIndex = ruleIndex;
        this._actionIndex = actionIndex;
    }
    /**
     * Gets the rule index to use for calls to {@link Recognizer#action}.
     *
     * @returns The rule index for the custom action.
     */ get ruleIndex() {
        return this._ruleIndex;
    }
    /**
     * Gets the action index to use for calls to {@link Recognizer#action}.
     *
     * @returns The action index for the custom action.
     */ get actionIndex() {
        return this._actionIndex;
    }
    /**
     * {@inheritDoc}
     *
     * @returns This method returns {@link LexerActionType#CUSTOM}.
     */ get actionType() {
        return 1 /* CUSTOM */ ;
    }
    /**
     * Gets whether the lexer action is position-dependent. Position-dependent
     * actions may have different semantics depending on the {@link CharStream}
     * index at the time the action is executed.
     *
     * Custom actions are position-dependent since they may represent a
     * user-defined embedded action which makes calls to methods like
     * {@link Lexer#getText}.
     *
     * @returns This method returns `true`.
     */ get isPositionDependent() {
        return true;
    }
    /**
     * {@inheritDoc}
     *
     * Custom actions are implemented by calling {@link Lexer#action} with the
     * appropriate rule and action indexes.
     */ execute(lexer) {
        lexer.action(undefined, this._ruleIndex, this._actionIndex);
    }
    hashCode() {
        let hash = $amQx9.MurmurHash.initialize();
        hash = $amQx9.MurmurHash.update(hash, this.actionType);
        hash = $amQx9.MurmurHash.update(hash, this._ruleIndex);
        hash = $amQx9.MurmurHash.update(hash, this._actionIndex);
        return $amQx9.MurmurHash.finish(hash, 3);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $66707726ebb084aa$var$LexerCustomAction)) return false;
        return this._ruleIndex === obj._ruleIndex && this._actionIndex === obj._actionIndex;
    }
}
$66707726ebb084aa$var$__decorate([
    $aN41m.Override
], $66707726ebb084aa$var$LexerCustomAction.prototype, "actionType", null);
$66707726ebb084aa$var$__decorate([
    $aN41m.Override
], $66707726ebb084aa$var$LexerCustomAction.prototype, "isPositionDependent", null);
$66707726ebb084aa$var$__decorate([
    $aN41m.Override,
    $66707726ebb084aa$var$__param(0, $aN41m.NotNull)
], $66707726ebb084aa$var$LexerCustomAction.prototype, "execute", null);
$66707726ebb084aa$var$__decorate([
    $aN41m.Override
], $66707726ebb084aa$var$LexerCustomAction.prototype, "hashCode", null);
$66707726ebb084aa$var$__decorate([
    $aN41m.Override
], $66707726ebb084aa$var$LexerCustomAction.prototype, "equals", null);
module.exports.LexerCustomAction = $66707726ebb084aa$var$LexerCustomAction;

});

parcelRegister("Sqz9e", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $0a39a6b1f9fd5776$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $0a39a6b1f9fd5776$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerModeAction = void 0;

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");
/**
 * Implements the `mode` lexer action by calling {@link Lexer#mode} with
 * the assigned mode.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $0a39a6b1f9fd5776$var$LexerModeAction {
    /**
     * Constructs a new `mode` action with the specified mode value.
     * @param mode The mode value to pass to {@link Lexer#mode}.
     */ constructor(mode){
        this._mode = mode;
    }
    /**
     * Get the lexer mode this action should transition the lexer to.
     *
     * @returns The lexer mode for this `mode` command.
     */ get mode() {
        return this._mode;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#MODE}.
     */ get actionType() {
        return 2 /* MODE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#mode} with the
     * value provided by {@link #getMode}.
     */ execute(lexer) {
        lexer.mode(this._mode);
    }
    hashCode() {
        let hash = $amQx9.MurmurHash.initialize();
        hash = $amQx9.MurmurHash.update(hash, this.actionType);
        hash = $amQx9.MurmurHash.update(hash, this._mode);
        return $amQx9.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $0a39a6b1f9fd5776$var$LexerModeAction)) return false;
        return this._mode === obj._mode;
    }
    toString() {
        return `mode(${this._mode})`;
    }
}
$0a39a6b1f9fd5776$var$__decorate([
    $aN41m.Override
], $0a39a6b1f9fd5776$var$LexerModeAction.prototype, "actionType", null);
$0a39a6b1f9fd5776$var$__decorate([
    $aN41m.Override
], $0a39a6b1f9fd5776$var$LexerModeAction.prototype, "isPositionDependent", null);
$0a39a6b1f9fd5776$var$__decorate([
    $aN41m.Override,
    $0a39a6b1f9fd5776$var$__param(0, $aN41m.NotNull)
], $0a39a6b1f9fd5776$var$LexerModeAction.prototype, "execute", null);
$0a39a6b1f9fd5776$var$__decorate([
    $aN41m.Override
], $0a39a6b1f9fd5776$var$LexerModeAction.prototype, "hashCode", null);
$0a39a6b1f9fd5776$var$__decorate([
    $aN41m.Override
], $0a39a6b1f9fd5776$var$LexerModeAction.prototype, "equals", null);
$0a39a6b1f9fd5776$var$__decorate([
    $aN41m.Override
], $0a39a6b1f9fd5776$var$LexerModeAction.prototype, "toString", null);
module.exports.LexerModeAction = $0a39a6b1f9fd5776$var$LexerModeAction;

});

parcelRegister("a52hA", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $756c244b6a2751b3$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $756c244b6a2751b3$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerMoreAction = void 0;

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");
/**
 * Implements the `more` lexer action by calling {@link Lexer#more}.
 *
 * The `more` command does not have any parameters, so this action is
 * implemented as a singleton instance exposed by {@link #INSTANCE}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $756c244b6a2751b3$var$LexerMoreAction {
    /**
     * Constructs the singleton instance of the lexer `more` command.
     */ constructor(){
    // intentionally empty
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#MORE}.
     */ get actionType() {
        return 3 /* MORE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#more}.
     */ execute(lexer) {
        lexer.more();
    }
    hashCode() {
        let hash = $amQx9.MurmurHash.initialize();
        hash = $amQx9.MurmurHash.update(hash, this.actionType);
        return $amQx9.MurmurHash.finish(hash, 1);
    }
    equals(obj) {
        return obj === this;
    }
    toString() {
        return "more";
    }
}
$756c244b6a2751b3$var$__decorate([
    $aN41m.Override
], $756c244b6a2751b3$var$LexerMoreAction.prototype, "actionType", null);
$756c244b6a2751b3$var$__decorate([
    $aN41m.Override
], $756c244b6a2751b3$var$LexerMoreAction.prototype, "isPositionDependent", null);
$756c244b6a2751b3$var$__decorate([
    $aN41m.Override,
    $756c244b6a2751b3$var$__param(0, $aN41m.NotNull)
], $756c244b6a2751b3$var$LexerMoreAction.prototype, "execute", null);
$756c244b6a2751b3$var$__decorate([
    $aN41m.Override
], $756c244b6a2751b3$var$LexerMoreAction.prototype, "hashCode", null);
$756c244b6a2751b3$var$__decorate([
    $aN41m.Override
], $756c244b6a2751b3$var$LexerMoreAction.prototype, "equals", null);
$756c244b6a2751b3$var$__decorate([
    $aN41m.Override
], $756c244b6a2751b3$var$LexerMoreAction.prototype, "toString", null);
module.exports.LexerMoreAction = $756c244b6a2751b3$var$LexerMoreAction;
(function(LexerMoreAction) {
    /**
     * Provides a singleton instance of this parameterless lexer action.
     */ LexerMoreAction.INSTANCE = new LexerMoreAction();
})($756c244b6a2751b3$var$LexerMoreAction = module.exports.LexerMoreAction || (module.exports.LexerMoreAction = {}));

});

parcelRegister("etfit", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a88fa3c89bb51f5a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a88fa3c89bb51f5a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerPopModeAction = void 0;

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");
/**
 * Implements the `popMode` lexer action by calling {@link Lexer#popMode}.
 *
 * The `popMode` command does not have any parameters, so this action is
 * implemented as a singleton instance exposed by {@link #INSTANCE}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $a88fa3c89bb51f5a$var$LexerPopModeAction {
    /**
     * Constructs the singleton instance of the lexer `popMode` command.
     */ constructor(){
    // intentionally empty
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#POP_MODE}.
     */ get actionType() {
        return 4 /* POP_MODE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#popMode}.
     */ execute(lexer) {
        lexer.popMode();
    }
    hashCode() {
        let hash = $amQx9.MurmurHash.initialize();
        hash = $amQx9.MurmurHash.update(hash, this.actionType);
        return $amQx9.MurmurHash.finish(hash, 1);
    }
    equals(obj) {
        return obj === this;
    }
    toString() {
        return "popMode";
    }
}
$a88fa3c89bb51f5a$var$__decorate([
    $aN41m.Override
], $a88fa3c89bb51f5a$var$LexerPopModeAction.prototype, "actionType", null);
$a88fa3c89bb51f5a$var$__decorate([
    $aN41m.Override
], $a88fa3c89bb51f5a$var$LexerPopModeAction.prototype, "isPositionDependent", null);
$a88fa3c89bb51f5a$var$__decorate([
    $aN41m.Override,
    $a88fa3c89bb51f5a$var$__param(0, $aN41m.NotNull)
], $a88fa3c89bb51f5a$var$LexerPopModeAction.prototype, "execute", null);
$a88fa3c89bb51f5a$var$__decorate([
    $aN41m.Override
], $a88fa3c89bb51f5a$var$LexerPopModeAction.prototype, "hashCode", null);
$a88fa3c89bb51f5a$var$__decorate([
    $aN41m.Override
], $a88fa3c89bb51f5a$var$LexerPopModeAction.prototype, "equals", null);
$a88fa3c89bb51f5a$var$__decorate([
    $aN41m.Override
], $a88fa3c89bb51f5a$var$LexerPopModeAction.prototype, "toString", null);
module.exports.LexerPopModeAction = $a88fa3c89bb51f5a$var$LexerPopModeAction;
(function(LexerPopModeAction) {
    /**
     * Provides a singleton instance of this parameterless lexer action.
     */ LexerPopModeAction.INSTANCE = new LexerPopModeAction();
})($a88fa3c89bb51f5a$var$LexerPopModeAction = module.exports.LexerPopModeAction || (module.exports.LexerPopModeAction = {}));

});

parcelRegister("en1aY", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a764202e107f6da8$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a764202e107f6da8$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerPushModeAction = void 0;

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");
/**
 * Implements the `pushMode` lexer action by calling
 * {@link Lexer#pushMode} with the assigned mode.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $a764202e107f6da8$var$LexerPushModeAction {
    /**
     * Constructs a new `pushMode` action with the specified mode value.
     * @param mode The mode value to pass to {@link Lexer#pushMode}.
     */ constructor(mode){
        this._mode = mode;
    }
    /**
     * Get the lexer mode this action should transition the lexer to.
     *
     * @returns The lexer mode for this `pushMode` command.
     */ get mode() {
        return this._mode;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#PUSH_MODE}.
     */ get actionType() {
        return 5 /* PUSH_MODE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#pushMode} with the
     * value provided by {@link #getMode}.
     */ execute(lexer) {
        lexer.pushMode(this._mode);
    }
    hashCode() {
        let hash = $amQx9.MurmurHash.initialize();
        hash = $amQx9.MurmurHash.update(hash, this.actionType);
        hash = $amQx9.MurmurHash.update(hash, this._mode);
        return $amQx9.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $a764202e107f6da8$var$LexerPushModeAction)) return false;
        return this._mode === obj._mode;
    }
    toString() {
        return `pushMode(${this._mode})`;
    }
}
$a764202e107f6da8$var$__decorate([
    $aN41m.Override
], $a764202e107f6da8$var$LexerPushModeAction.prototype, "actionType", null);
$a764202e107f6da8$var$__decorate([
    $aN41m.Override
], $a764202e107f6da8$var$LexerPushModeAction.prototype, "isPositionDependent", null);
$a764202e107f6da8$var$__decorate([
    $aN41m.Override,
    $a764202e107f6da8$var$__param(0, $aN41m.NotNull)
], $a764202e107f6da8$var$LexerPushModeAction.prototype, "execute", null);
$a764202e107f6da8$var$__decorate([
    $aN41m.Override
], $a764202e107f6da8$var$LexerPushModeAction.prototype, "hashCode", null);
$a764202e107f6da8$var$__decorate([
    $aN41m.Override
], $a764202e107f6da8$var$LexerPushModeAction.prototype, "equals", null);
$a764202e107f6da8$var$__decorate([
    $aN41m.Override
], $a764202e107f6da8$var$LexerPushModeAction.prototype, "toString", null);
module.exports.LexerPushModeAction = $a764202e107f6da8$var$LexerPushModeAction;

});

parcelRegister("jH58C", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $e56604c1d2a640c8$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $e56604c1d2a640c8$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerSkipAction = void 0;

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");
/**
 * Implements the `skip` lexer action by calling {@link Lexer#skip}.
 *
 * The `skip` command does not have any parameters, so this action is
 * implemented as a singleton instance exposed by {@link #INSTANCE}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $e56604c1d2a640c8$var$LexerSkipAction {
    /**
     * Constructs the singleton instance of the lexer `skip` command.
     */ constructor(){
    // intentionally empty
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#SKIP}.
     */ get actionType() {
        return 6 /* SKIP */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#skip}.
     */ execute(lexer) {
        lexer.skip();
    }
    hashCode() {
        let hash = $amQx9.MurmurHash.initialize();
        hash = $amQx9.MurmurHash.update(hash, this.actionType);
        return $amQx9.MurmurHash.finish(hash, 1);
    }
    equals(obj) {
        return obj === this;
    }
    toString() {
        return "skip";
    }
}
$e56604c1d2a640c8$var$__decorate([
    $aN41m.Override
], $e56604c1d2a640c8$var$LexerSkipAction.prototype, "actionType", null);
$e56604c1d2a640c8$var$__decorate([
    $aN41m.Override
], $e56604c1d2a640c8$var$LexerSkipAction.prototype, "isPositionDependent", null);
$e56604c1d2a640c8$var$__decorate([
    $aN41m.Override,
    $e56604c1d2a640c8$var$__param(0, $aN41m.NotNull)
], $e56604c1d2a640c8$var$LexerSkipAction.prototype, "execute", null);
$e56604c1d2a640c8$var$__decorate([
    $aN41m.Override
], $e56604c1d2a640c8$var$LexerSkipAction.prototype, "hashCode", null);
$e56604c1d2a640c8$var$__decorate([
    $aN41m.Override
], $e56604c1d2a640c8$var$LexerSkipAction.prototype, "equals", null);
$e56604c1d2a640c8$var$__decorate([
    $aN41m.Override
], $e56604c1d2a640c8$var$LexerSkipAction.prototype, "toString", null);
module.exports.LexerSkipAction = $e56604c1d2a640c8$var$LexerSkipAction;
(function(LexerSkipAction) {
    /**
     * Provides a singleton instance of this parameterless lexer action.
     */ LexerSkipAction.INSTANCE = new LexerSkipAction();
})($e56604c1d2a640c8$var$LexerSkipAction = module.exports.LexerSkipAction || (module.exports.LexerSkipAction = {}));

});

parcelRegister("345c1", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $23b5c605e8108d72$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $23b5c605e8108d72$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerTypeAction = void 0;

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");
/**
 * Implements the `type` lexer action by setting `Lexer.type`
 * with the assigned type.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $23b5c605e8108d72$var$LexerTypeAction {
    /**
     * Constructs a new `type` action with the specified token type value.
     * @param type The type to assign to the token using `Lexer.type`.
     */ constructor(type){
        this._type = type;
    }
    /**
     * Gets the type to assign to a token created by the lexer.
     * @returns The type to assign to a token created by the lexer.
     */ get type() {
        return this._type;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#TYPE}.
     */ get actionType() {
        return 7 /* TYPE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by setting `Lexer.type` with the
     * value provided by `type`.
     */ execute(lexer) {
        lexer.type = this._type;
    }
    hashCode() {
        let hash = $amQx9.MurmurHash.initialize();
        hash = $amQx9.MurmurHash.update(hash, this.actionType);
        hash = $amQx9.MurmurHash.update(hash, this._type);
        return $amQx9.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $23b5c605e8108d72$var$LexerTypeAction)) return false;
        return this._type === obj._type;
    }
    toString() {
        return `type(${this._type})`;
    }
}
$23b5c605e8108d72$var$__decorate([
    $aN41m.Override
], $23b5c605e8108d72$var$LexerTypeAction.prototype, "actionType", null);
$23b5c605e8108d72$var$__decorate([
    $aN41m.Override
], $23b5c605e8108d72$var$LexerTypeAction.prototype, "isPositionDependent", null);
$23b5c605e8108d72$var$__decorate([
    $aN41m.Override,
    $23b5c605e8108d72$var$__param(0, $aN41m.NotNull)
], $23b5c605e8108d72$var$LexerTypeAction.prototype, "execute", null);
$23b5c605e8108d72$var$__decorate([
    $aN41m.Override
], $23b5c605e8108d72$var$LexerTypeAction.prototype, "hashCode", null);
$23b5c605e8108d72$var$__decorate([
    $aN41m.Override
], $23b5c605e8108d72$var$LexerTypeAction.prototype, "equals", null);
$23b5c605e8108d72$var$__decorate([
    $aN41m.Override
], $23b5c605e8108d72$var$LexerTypeAction.prototype, "toString", null);
module.exports.LexerTypeAction = $23b5c605e8108d72$var$LexerTypeAction;

});

parcelRegister("fFNPu", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $b6915673a04edde3$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoopEndState = void 0;

var $dv9vN = parcelRequire("dv9vN");

var $fZESB = parcelRequire("fZESB");

var $aN41m = parcelRequire("aN41m");
/** Mark the end of a * or + loop. */ class $b6915673a04edde3$var$LoopEndState extends $dv9vN.ATNState {
    get stateType() {
        return $fZESB.ATNStateType.LOOP_END;
    }
}
$b6915673a04edde3$var$__decorate([
    $aN41m.Override
], $b6915673a04edde3$var$LoopEndState.prototype, "stateType", null);
module.exports.LoopEndState = $b6915673a04edde3$var$LoopEndState;

});

parcelRegister("gzbPK", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c0f91822940cc2ea$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $c0f91822940cc2ea$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParserATNSimulator = void 0;

var $hu8W9 = parcelRequire("hu8W9");

var $dNkDA = parcelRequire("dNkDA");

var $fsqYw = parcelRequire("fsqYw");

var $4dKou = parcelRequire("4dKou");

var $eeOLb = parcelRequire("eeOLb");

var $hdFz0 = parcelRequire("hdFz0");

var $2SGHL = parcelRequire("2SGHL");

var $ceQRA = parcelRequire("ceQRA");

var $fZESB = parcelRequire("fZESB");

var $kXmw5 = parcelRequire("kXmw5");

var $8WIez = parcelRequire("8WIez");

var $bPdk6 = parcelRequire("bPdk6");

var $42ptv = parcelRequire("42ptv");

var $6P9ap = parcelRequire("6P9ap");

var $eRSlM = parcelRequire("eRSlM");

var $l8y5T = parcelRequire("l8y5T");

var $ldi9e = parcelRequire("ldi9e");

var $aN41m = parcelRequire("aN41m");

var $gFTdY = parcelRequire("gFTdY");

var $iAlWg = parcelRequire("iAlWg");

var $9eW9B = parcelRequire("9eW9B");

var $2pDMz = parcelRequire("2pDMz");

var $jaUCz = parcelRequire("jaUCz");

var $4BvNW = parcelRequire("4BvNW");

var $hwoBE = parcelRequire("hwoBE");

var $jWsYN = parcelRequire("jWsYN");

var $lmhna = parcelRequire("lmhna");

var $3JS45 = parcelRequire("3JS45");

var $5EcBU = parcelRequire("5EcBU");

var $eDtKk = parcelRequire("eDtKk");

var $eKXi4 = parcelRequire("eKXi4");

var $hBnE1 = parcelRequire("hBnE1");

var $fomfP = parcelRequire("fomfP");
const $c0f91822940cc2ea$var$MAX_SHORT_VALUE = 0xFFFF;
const $c0f91822940cc2ea$var$MIN_INTEGER_VALUE = -2147483648;
/**
 * The embodiment of the adaptive LL(*), ALL(*), parsing strategy.
 *
 * The basic complexity of the adaptive strategy makes it harder to understand.
 * We begin with ATN simulation to build paths in a DFA. Subsequent prediction
 * requests go through the DFA first. If they reach a state without an edge for
 * the current symbol, the algorithm fails over to the ATN simulation to
 * complete the DFA path for the current input (until it finds a conflict state
 * or uniquely predicting state).
 *
 * All of that is done without using the outer context because we want to create
 * a DFA that is not dependent upon the rule invocation stack when we do a
 * prediction. One DFA works in all contexts. We avoid using context not
 * necessarily because it's slower, although it can be, but because of the DFA
 * caching problem. The closure routine only considers the rule invocation stack
 * created during prediction beginning in the decision rule. For example, if
 * prediction occurs without invoking another rule's ATN, there are no context
 * stacks in the configurations. When lack of context leads to a conflict, we
 * don't know if it's an ambiguity or a weakness in the strong LL(*) parsing
 * strategy (versus full LL(*)).
 *
 * When SLL yields a configuration set with conflict, we rewind the input and
 * retry the ATN simulation, this time using full outer context without adding
 * to the DFA. Configuration context stacks will be the full invocation stacks
 * from the start rule. If we get a conflict using full context, then we can
 * definitively say we have a true ambiguity for that input sequence. If we
 * don't get a conflict, it implies that the decision is sensitive to the outer
 * context. (It is not context-sensitive in the sense of context-sensitive
 * grammars.)
 *
 * The next time we reach this DFA state with an SLL conflict, through DFA
 * simulation, we will again retry the ATN simulation using full context mode.
 * This is slow because we can't save the results and have to "interpret" the
 * ATN each time we get that input.
 *
 * **CACHING FULL CONTEXT PREDICTIONS**
 *
 * We could cache results from full context to predicted alternative easily and
 * that saves a lot of time but doesn't work in presence of predicates. The set
 * of visible predicates from the ATN start state changes depending on the
 * context, because closure can fall off the end of a rule. I tried to cache
 * tuples (stack context, semantic context, predicted alt) but it was slower
 * than interpreting and much more complicated. Also required a huge amount of
 * memory. The goal is not to create the world's fastest parser anyway. I'd like
 * to keep this algorithm simple. By launching multiple threads, we can improve
 * the speed of parsing across a large number of files.
 *
 * There is no strict ordering between the amount of input used by SLL vs LL,
 * which makes it really hard to build a cache for full context. Let's say that
 * we have input A B C that leads to an SLL conflict with full context X. That
 * implies that using X we might only use A B but we could also use A B C D to
 * resolve conflict. Input A B C D could predict alternative 1 in one position
 * in the input and A B C E could predict alternative 2 in another position in
 * input. The conflicting SLL configurations could still be non-unique in the
 * full context prediction, which would lead us to requiring more input than the
 * original A B C.	To make a	prediction cache work, we have to track	the exact
 * input	used during the previous prediction. That amounts to a cache that maps
 * X to a specific DFA for that context.
 *
 * Something should be done for left-recursive expression predictions. They are
 * likely LL(1) + pred eval. Easier to do the whole SLL unless error and retry
 * with full LL thing Sam does.
 *
 * **AVOIDING FULL CONTEXT PREDICTION**
 *
 * We avoid doing full context retry when the outer context is empty, we did not
 * dip into the outer context by falling off the end of the decision state rule,
 * or when we force SLL mode.
 *
 * As an example of the not dip into outer context case, consider as super
 * constructor calls versus function calls. One grammar might look like
 * this:
 *
 * ```antlr
 * ctorBody
 *   : '{' superCall? stat* '}'
 *   ;
 * ```
 *
 * Or, you might see something like
 *
 * ```antlr
 * stat
 *   : superCall ';'
 *   | expression ';'
 *   | ...
 *   ;
 * ```
 *
 * In both cases I believe that no closure operations will dip into the outer
 * context. In the first case ctorBody in the worst case will stop at the '}'.
 * In the 2nd case it should stop at the ';'. Both cases should stay within the
 * entry rule and not dip into the outer context.
 *
 * **PREDICATES**
 *
 * Predicates are always evaluated if present in either SLL or LL both. SLL and
 * LL simulation deals with predicates differently. SLL collects predicates as
 * it performs closure operations like ANTLR v3 did. It delays predicate
 * evaluation until it reaches and accept state. This allows us to cache the SLL
 * ATN simulation whereas, if we had evaluated predicates on-the-fly during
 * closure, the DFA state configuration sets would be different and we couldn't
 * build up a suitable DFA.
 *
 * When building a DFA accept state during ATN simulation, we evaluate any
 * predicates and return the sole semantically valid alternative. If there is
 * more than 1 alternative, we report an ambiguity. If there are 0 alternatives,
 * we throw an exception. Alternatives without predicates act like they have
 * true predicates. The simple way to think about it is to strip away all
 * alternatives with false predicates and choose the minimum alternative that
 * remains.
 *
 * When we start in the DFA and reach an accept state that's predicated, we test
 * those and return the minimum semantically viable alternative. If no
 * alternatives are viable, we throw an exception.
 *
 * During full LL ATN simulation, closure always evaluates predicates and
 * on-the-fly. This is crucial to reducing the configuration set size during
 * closure. It hits a landmine when parsing with the Java grammar, for example,
 * without this on-the-fly evaluation.
 *
 * **SHARING DFA**
 *
 * All instances of the same parser share the same decision DFAs through a
 * static field. Each instance gets its own ATN simulator but they share the
 * same {@link ATN#decisionToDFA} field. They also share a
 * {@link PredictionContextCache} object that makes sure that all
 * {@link PredictionContext} objects are shared among the DFA states. This makes
 * a big size difference.
 *
 * **THREAD SAFETY**
 *
 * The {@link ParserATNSimulator} locks on the {@link ATN#decisionToDFA} field when
 * it adds a new DFA object to that array. {@link #addDFAEdge}
 * locks on the DFA for the current decision when setting the
 * {@link DFAState#edges} field. {@link #addDFAState} locks on
 * the DFA for the current decision when looking up a DFA state to see if it
 * already exists. We must make sure that all requests to add DFA states that
 * are equivalent result in the same shared DFA object. This is because lots of
 * threads will be trying to update the DFA at once. The
 * {@link #addDFAState} method also locks inside the DFA lock
 * but this time on the shared context cache when it rebuilds the
 * configurations' {@link PredictionContext} objects using cached
 * subgraphs/nodes. No other locking occurs, even during DFA simulation. This is
 * safe as long as we can guarantee that all threads referencing
 * `s.edge[t]` get the same physical target {@link DFAState}, or
 * `undefined`. Once into the DFA, the DFA simulation does not reference the
 * {@link DFA#states} map. It follows the {@link DFAState#edges} field to new
 * targets. The DFA simulator will either find {@link DFAState#edges} to be
 * `undefined`, to be non-`undefined` and `dfa.edges[t]` undefined, or
 * `dfa.edges[t]` to be non-undefined. The
 * {@link #addDFAEdge} method could be racing to set the field
 * but in either case the DFA simulator works; if `undefined`, and requests ATN
 * simulation. It could also race trying to get `dfa.edges[t]`, but either
 * way it will work because it's not doing a test and set operation.
 *
 * **Starting with SLL then failing to combined SLL/LL (Two-Stage
 * Parsing)**
 *
 * Sam pointed out that if SLL does not give a syntax error, then there is no
 * point in doing full LL, which is slower. We only have to try LL if we get a
 * syntax error. For maximum speed, Sam starts the parser set to pure SLL
 * mode with the {@link BailErrorStrategy}:
 *
 * ```
 * parser.interpreter.{@link #setPredictionMode setPredictionMode}`(`{@link PredictionMode#SLL}`)`;
 * parser.{@link Parser#setErrorHandler setErrorHandler}(new {@link BailErrorStrategy}());
 * ```
 *
 * If it does not get a syntax error, then we're done. If it does get a syntax
 * error, we need to retry with the combined SLL/LL strategy.
 *
 * The reason this works is as follows. If there are no SLL conflicts, then the
 * grammar is SLL (at least for that input set). If there is an SLL conflict,
 * the full LL analysis must yield a set of viable alternatives which is a
 * subset of the alternatives reported by SLL. If the LL set is a singleton,
 * then the grammar is LL but not SLL. If the LL set is the same size as the SLL
 * set, the decision is SLL. If the LL set has size &gt; 1, then that decision
 * is truly ambiguous on the current input. If the LL set is smaller, then the
 * SLL conflict resolution might choose an alternative that the full LL would
 * rule out as a possibility based upon better context information. If that's
 * the case, then the SLL parse will definitely get an error because the full LL
 * analysis says it's not viable. If SLL conflict resolution chooses an
 * alternative within the LL set, them both SLL and LL would choose the same
 * alternative because they both choose the minimum of multiple conflicting
 * alternatives.
 *
 * Let's say we have a set of SLL conflicting alternatives `{1, 2, 3}` and
 * a smaller LL set called *s*. If *s* is `{2, 3}`, then SLL
 * parsing will get an error because SLL will pursue alternative 1. If
 * *s* is `{1, 2}` or `{1, 3}` then both SLL and LL will
 * choose the same alternative because alternative one is the minimum of either
 * set. If *s* is `{2}` or `{3}` then SLL will get a syntax
 * error. If *s* is `{1}` then SLL will succeed.
 *
 * Of course, if the input is invalid, then we will get an error for sure in
 * both SLL and LL parsing. Erroneous input will therefore require 2 passes over
 * the input.
 */ let $c0f91822940cc2ea$var$ParserATNSimulator = class ParserATNSimulator extends $ceQRA.ATNSimulator {
    constructor(atn, parser){
        super(atn);
        this.predictionMode = $hwoBE.PredictionMode.LL;
        this.force_global_context = false;
        this.always_try_local_context = true;
        /**
         * Determines whether the DFA is used for full-context predictions. When
         * `true`, the DFA stores transition information for both full-context
         * and SLL parsing; otherwise, the DFA only stores SLL transition
         * information.
         *
         * For some grammars, enabling the full-context DFA can result in a
         * substantial performance improvement. However, this improvement typically
         * comes at the expense of memory used for storing the cached DFA states,
         * configuration sets, and prediction contexts.
         *
         * The default value is `false`.
         */ this.enable_global_context_dfa = false;
        this.optimize_unique_closure = true;
        this.optimize_ll1 = true;
        this.optimize_tail_calls = true;
        this.tail_call_preserves_sll = true;
        this.treat_sllk1_conflict_as_ambiguity = false;
        /**
         * When `true`, ambiguous alternatives are reported when they are
         * encountered within {@link #execATN}. When `false`, these messages
         * are suppressed. The default is `false`.
         *
         * When messages about ambiguous alternatives are not required, setting this
         * to `false` enables additional internal optimizations which may lose
         * this information.
         */ this.reportAmbiguities = false;
        /** By default we do full context-sensitive LL(*) parsing not
         *  Strong LL(*) parsing. If we fail with Strong LL(*) we
         *  try full LL(*). That means we rewind and use context information
         *  when closure operations fall off the end of the rule that
         *  holds the decision were evaluating.
         */ this.userWantsCtxSensitive = true;
        this._parser = parser;
    }
    getPredictionMode() {
        return this.predictionMode;
    }
    setPredictionMode(predictionMode) {
        this.predictionMode = predictionMode;
    }
    reset() {
    // intentionally empty
    }
    adaptivePredict(input, decision, outerContext, useContext) {
        if (useContext === undefined) useContext = false;
        let dfa = this.atn.decisionToDFA[decision];
        $fomfP(dfa != null);
        if (this.optimize_ll1 && !dfa.isPrecedenceDfa && !dfa.isEmpty) {
            let ll_1 = input.LA(1);
            if (ll_1 >= 0 && ll_1 <= 0xFFFF) {
                let key = (decision << 16 >>> 0) + ll_1;
                let alt = this.atn.LL1Table.get(key);
                if (alt != null) return alt;
            }
        }
        this.dfa = dfa;
        if (this.force_global_context) useContext = true;
        else if (!this.always_try_local_context) useContext = useContext || dfa.isContextSensitive;
        this.userWantsCtxSensitive = useContext || this.predictionMode !== $hwoBE.PredictionMode.SLL && outerContext != null && !this.atn.decisionToState[decision].sll;
        if (outerContext == null) outerContext = $2pDMz.ParserRuleContext.emptyContext();
        let state;
        if (!dfa.isEmpty) state = this.getStartState(dfa, input, outerContext, useContext);
        if (state == null) {
            if (outerContext == null) outerContext = $2pDMz.ParserRuleContext.emptyContext();
            if (ParserATNSimulator.debug) console.log("ATN decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input) + ", outerContext=" + outerContext.toString(this._parser));
            state = this.computeStartState(dfa, outerContext, useContext);
        }
        let m = input.mark();
        let index = input.index;
        try {
            let alt = this.execDFA(dfa, input, index, state);
            if (ParserATNSimulator.debug) console.log("DFA after predictATN: " + dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
            return alt;
        } finally{
            this.dfa = undefined;
            input.seek(index);
            input.release(m);
        }
    }
    getStartState(dfa, input, outerContext, useContext) {
        if (!useContext) {
            if (dfa.isPrecedenceDfa) {
                // the start state for a precedence DFA depends on the current
                // parser precedence, and is provided by a DFA method.
                let state = dfa.getPrecedenceStartState(this._parser.precedence, false);
                if (state == null) return undefined;
                return new $eDtKk.SimulatorState(outerContext, state, false, outerContext);
            } else {
                if (dfa.s0 == null) return undefined;
                return new $eDtKk.SimulatorState(outerContext, dfa.s0, false, outerContext);
            }
        }
        if (!this.enable_global_context_dfa) return undefined;
        let remainingContext = outerContext;
        $fomfP(outerContext != null);
        let s0;
        if (dfa.isPrecedenceDfa) s0 = dfa.getPrecedenceStartState(this._parser.precedence, true);
        else s0 = dfa.s0full;
        while(remainingContext != null && s0 != null && s0.isContextSensitive){
            remainingContext = this.skipTailCalls(remainingContext);
            s0 = s0.getContextTarget(this.getReturnState(remainingContext));
            if (remainingContext.isEmpty) $fomfP(s0 == null || !s0.isContextSensitive);
            else remainingContext = remainingContext.parent;
        }
        if (s0 == null) return undefined;
        return new $eDtKk.SimulatorState(outerContext, s0, useContext, remainingContext);
    }
    execDFA(dfa, input, startIndex, state) {
        let outerContext = state.outerContext;
        if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input) + ", outerContext=" + outerContext.toString(this._parser));
        if (ParserATNSimulator.dfa_debug) console.log(dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
        let s = state.s0;
        let t = input.LA(1);
        let remainingOuterContext = state.remainingOuterContext;
        while(true){
            if (ParserATNSimulator.dfa_debug) console.log("DFA state " + s.stateNumber + " LA(1)==" + this.getLookaheadName(input));
            if (state.useContext) while(s.isContextSymbol(t)){
                let next;
                if (remainingOuterContext != null) {
                    remainingOuterContext = this.skipTailCalls(remainingOuterContext);
                    next = s.getContextTarget(this.getReturnState(remainingOuterContext));
                }
                if (next == null) {
                    // fail over to ATN
                    let initialState = new $eDtKk.SimulatorState(state.outerContext, s, state.useContext, remainingOuterContext);
                    return this.execATN(dfa, input, startIndex, initialState);
                }
                $fomfP(remainingOuterContext != null);
                remainingOuterContext = remainingOuterContext.parent;
                s = next;
            }
            if (this.isAcceptState(s, state.useContext)) {
                if (s.predicates != null) {
                    if (ParserATNSimulator.dfa_debug) console.log("accept " + s);
                } else if (ParserATNSimulator.dfa_debug) console.log("accept; predict " + s.prediction + " in state " + s.stateNumber);
                break;
            }
            // t is not updated if one of these states is reached
            $fomfP(!this.isAcceptState(s, state.useContext));
            // if no edge, pop over to ATN interpreter, update DFA and return
            let target = this.getExistingTargetState(s, t);
            if (target == null) {
                if (ParserATNSimulator.dfa_debug && t >= 0) console.log("no edge for " + this._parser.vocabulary.getDisplayName(t));
                let alt;
                if (ParserATNSimulator.dfa_debug) {
                    let interval = $l8y5T.Interval.of(startIndex, this._parser.inputStream.index);
                    console.log("ATN exec upon " + this._parser.inputStream.getText(interval) + " at DFA state " + s.stateNumber);
                }
                let initialState = new $eDtKk.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                alt = this.execATN(dfa, input, startIndex, initialState);
                if (ParserATNSimulator.dfa_debug) console.log("back from DFA update, alt=" + alt + ", dfa=\n" + dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
                // action already executed
                if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " predicts " + alt);
                return alt; // we've updated DFA, exec'd action, and have our deepest answer
            } else if (target === $ceQRA.ATNSimulator.ERROR) {
                let errorState = new $eDtKk.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                return this.handleNoViableAlt(input, startIndex, errorState);
            }
            s = target;
            if (!this.isAcceptState(s, state.useContext) && t !== $ldi9e.IntStream.EOF) {
                input.consume();
                t = input.LA(1);
            }
        }
        //		if ( acceptState==null ) {
        //			if ( debug ) System.out.println("!!! no viable alt in dfa");
        //			return -1;
        //		}
        if (!state.useContext && s.configs.conflictInfo != null) {
            if (dfa.atnStartState instanceof $42ptv.DecisionState) {
                if (!this.userWantsCtxSensitive || !s.configs.dipsIntoOuterContext && s.configs.isExactConflict || this.treat_sllk1_conflict_as_ambiguity && input.index === startIndex) ;
                else {
                    $fomfP(!state.useContext);
                    // Before attempting full context prediction, check to see if there are
                    // disambiguating or validating predicates to evaluate which allow an
                    // immediate decision
                    let conflictingAlts;
                    let predicates = s.predicates;
                    if (predicates != null) {
                        let conflictIndex = input.index;
                        if (conflictIndex !== startIndex) input.seek(startIndex);
                        conflictingAlts = this.evalSemanticContext(predicates, outerContext, true);
                        if (conflictingAlts.cardinality() === 1) return conflictingAlts.nextSetBit(0);
                        if (conflictIndex !== startIndex) // restore the index so reporting the fallback to full
                        // context occurs with the index at the correct spot
                        input.seek(conflictIndex);
                    }
                    if (this.reportAmbiguities) {
                        let conflictState = new $eDtKk.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                        this.reportAttemptingFullContext(dfa, conflictingAlts, conflictState, startIndex, input.index);
                    }
                    input.seek(startIndex);
                    return this.adaptivePredict(input, dfa.decision, outerContext, true);
                }
            }
        }
        // Before jumping to prediction, check to see if there are
        // disambiguating or validating predicates to evaluate
        let predicates = s.predicates;
        if (predicates != null) {
            let stopIndex = input.index;
            if (startIndex !== stopIndex) input.seek(startIndex);
            let alts = this.evalSemanticContext(predicates, outerContext, this.reportAmbiguities && this.predictionMode === $hwoBE.PredictionMode.LL_EXACT_AMBIG_DETECTION);
            switch(alts.cardinality()){
                case 0:
                    throw this.noViableAlt(input, outerContext, s.configs, startIndex);
                case 1:
                    return alts.nextSetBit(0);
                default:
                    // report ambiguity after predicate evaluation to make sure the correct
                    // set of ambig alts is reported.
                    if (startIndex !== stopIndex) input.seek(stopIndex);
                    this.reportAmbiguity(dfa, s, startIndex, stopIndex, s.configs.isExactConflict, alts, s.configs);
                    return alts.nextSetBit(0);
            }
        }
        if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " predicts " + s.prediction);
        return s.prediction;
    }
    /**
     * Determines if a particular DFA state should be treated as an accept state
     * for the current prediction mode. In addition to the `useContext`
     * parameter, the {@link #getPredictionMode()} method provides the
     * prediction mode controlling the prediction algorithm as a whole.
     *
     * The default implementation simply returns the value of
     * `DFAState.isAcceptState` except for conflict states when
     * `useContext` is `true` and {@link #getPredictionMode()} is
     * {@link PredictionMode#LL_EXACT_AMBIG_DETECTION}. In that case, only
     * conflict states where {@link ATNConfigSet#isExactConflict} is
     * `true` are considered accept states.
     *
     * @param state The DFA state to check.
     * @param useContext `true` if the prediction algorithm is currently
     * considering the full parser context; otherwise, `false` if the
     * algorithm is currently performing a local context prediction.
     *
     * @returns `true` if the specified `state` is an accept state;
     * otherwise, `false`.
     */ isAcceptState(state, useContext) {
        if (!state.isAcceptState) return false;
        if (state.configs.conflictingAlts == null) // unambiguous
        return true;
        // More picky when we need exact conflicts
        if (useContext && this.predictionMode === $hwoBE.PredictionMode.LL_EXACT_AMBIG_DETECTION) return state.configs.isExactConflict;
        return true;
    }
    /** Performs ATN simulation to compute a predicted alternative based
     *  upon the remaining input, but also updates the DFA cache to avoid
     *  having to traverse the ATN again for the same input sequence.
     *
     * There are some key conditions we're looking for after computing a new
     * set of ATN configs (proposed DFA state):
     *
     * * if the set is empty, there is no viable alternative for current symbol
     * * does the state uniquely predict an alternative?
     * * does the state have a conflict that would prevent us from
     *   putting it on the work list?
     * * if in non-greedy decision is there a config at a rule stop state?
     *
     * We also have some key operations to do:
     *
     * * add an edge from previous DFA state to potentially new DFA state, D,
     *   upon current symbol but only if adding to work list, which means in all
     *   cases except no viable alternative (and possibly non-greedy decisions?)
     * * collecting predicates and adding semantic context to DFA accept states
     * * adding rule context to context-sensitive DFA accept states
     * * consuming an input symbol
     * * reporting a conflict
     * * reporting an ambiguity
     * * reporting a context sensitivity
     * * reporting insufficient predicates
     *
     * We should isolate those operations, which are side-effecting, to the
     * main work loop. We can isolate lots of code into other functions, but
     * they should be side effect free. They can return package that
     * indicates whether we should report something, whether we need to add a
     * DFA edge, whether we need to augment accept state with semantic
     * context or rule invocation context. Actually, it seems like we always
     * add predicates if they exist, so that can simply be done in the main
     * loop for any accept state creation or modification request.
     *
     * cover these cases:
     *   dead end
     *   single alt
     *   single alt + preds
     *   conflict
     *   conflict + preds
     *
     * TODO: greedy + those
     */ execATN(dfa, input, startIndex, initialState) {
        if (ParserATNSimulator.debug) console.log("execATN decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input));
        let outerContext = initialState.outerContext;
        let useContext = initialState.useContext;
        let t = input.LA(1);
        let previous = initialState;
        let contextCache = new $4BvNW.PredictionContextCache();
        while(true){
            let nextState = this.computeReachSet(dfa, previous, t, contextCache);
            if (nextState == null) {
                this.setDFAEdge(previous.s0, input.LA(1), $ceQRA.ATNSimulator.ERROR);
                return this.handleNoViableAlt(input, startIndex, previous);
            }
            let D = nextState.s0;
            // predicted alt => accept state
            $fomfP(D.isAcceptState || D.prediction === $eeOLb.ATN.INVALID_ALT_NUMBER);
            // conflicted => accept state
            $fomfP(D.isAcceptState || D.configs.conflictInfo == null);
            if (this.isAcceptState(D, useContext)) {
                let conflictingAlts = D.configs.conflictingAlts;
                let predictedAlt = conflictingAlts == null ? D.prediction : $eeOLb.ATN.INVALID_ALT_NUMBER;
                if (predictedAlt !== $eeOLb.ATN.INVALID_ALT_NUMBER) {
                    if (this.optimize_ll1 && input.index === startIndex && !dfa.isPrecedenceDfa && nextState.outerContext === nextState.remainingOuterContext && dfa.decision >= 0 && !D.configs.hasSemanticContext) {
                        if (t >= 0 && t <= $c0f91822940cc2ea$var$MAX_SHORT_VALUE) {
                            let key = (dfa.decision << 16 >>> 0) + t;
                            this.atn.LL1Table.set(key, predictedAlt);
                        }
                    }
                    if (useContext && this.always_try_local_context) this.reportContextSensitivity(dfa, predictedAlt, nextState, startIndex, input.index);
                }
                predictedAlt = D.prediction;
                //				int k = input.index - startIndex + 1; // how much input we used
                //				System.out.println("used k="+k);
                let attemptFullContext = conflictingAlts != null && this.userWantsCtxSensitive;
                if (attemptFullContext) // Only exact conflicts are known to be ambiguous when local
                // prediction does not step out of the decision rule.
                attemptFullContext = !useContext && (D.configs.dipsIntoOuterContext || !D.configs.isExactConflict) && (!this.treat_sllk1_conflict_as_ambiguity || input.index !== startIndex);
                if (D.configs.hasSemanticContext) {
                    let predPredictions = D.predicates;
                    if (predPredictions != null) {
                        let conflictIndex = input.index;
                        if (conflictIndex !== startIndex) input.seek(startIndex);
                        // use complete evaluation here if we'll want to retry with full context if still ambiguous
                        conflictingAlts = this.evalSemanticContext(predPredictions, outerContext, attemptFullContext || this.reportAmbiguities);
                        switch(conflictingAlts.cardinality()){
                            case 0:
                                throw this.noViableAlt(input, outerContext, D.configs, startIndex);
                            case 1:
                                return conflictingAlts.nextSetBit(0);
                            default:
                                break;
                        }
                        if (conflictIndex !== startIndex) // restore the index so reporting the fallback to full
                        // context occurs with the index at the correct spot
                        input.seek(conflictIndex);
                    }
                }
                if (!attemptFullContext) {
                    if (conflictingAlts != null) {
                        if (this.reportAmbiguities && conflictingAlts.cardinality() > 1) this.reportAmbiguity(dfa, D, startIndex, input.index, D.configs.isExactConflict, conflictingAlts, D.configs);
                        predictedAlt = conflictingAlts.nextSetBit(0);
                    }
                    return predictedAlt;
                } else {
                    $fomfP(!useContext);
                    $fomfP(this.isAcceptState(D, false));
                    if (ParserATNSimulator.debug) console.log("RETRY with outerContext=" + outerContext);
                    let fullContextState = this.computeStartState(dfa, outerContext, true);
                    if (this.reportAmbiguities) this.reportAttemptingFullContext(dfa, conflictingAlts, nextState, startIndex, input.index);
                    input.seek(startIndex);
                    return this.execATN(dfa, input, startIndex, fullContextState);
                }
            }
            previous = nextState;
            if (t !== $ldi9e.IntStream.EOF) {
                input.consume();
                t = input.LA(1);
            }
        }
    }
    /**
     * This method is used to improve the localization of error messages by
     * choosing an alternative rather than throwing a
     * {@link NoViableAltException} in particular prediction scenarios where the
     * {@link #ERROR} state was reached during ATN simulation.
     *
     * The default implementation of this method uses the following
     * algorithm to identify an ATN configuration which successfully parsed the
     * decision entry rule. Choosing such an alternative ensures that the
     * {@link ParserRuleContext} returned by the calling rule will be complete
     * and valid, and the syntax error will be reported later at a more
     * localized location.
     *
     * * If no configuration in `configs` reached the end of the
     *   decision rule, return {@link ATN#INVALID_ALT_NUMBER}.
     * * If all configurations in `configs` which reached the end of the
     *   decision rule predict the same alternative, return that alternative.
     * * If the configurations in `configs` which reached the end of the
     *   decision rule predict multiple alternatives (call this *S*),
     *   choose an alternative in the following order.
     *
     *     1. Filter the configurations in `configs` to only those
     *        configurations which remain viable after evaluating semantic predicates.
     *        If the set of these filtered configurations which also reached the end of
     *        the decision rule is not empty, return the minimum alternative
     *        represented in this set.
     *     1. Otherwise, choose the minimum alternative in *S*.
     *
     * In some scenarios, the algorithm described above could predict an
     * alternative which will result in a {@link FailedPredicateException} in
     * parser. Specifically, this could occur if the *only* configuration
     * capable of successfully parsing to the end of the decision rule is
     * blocked by a semantic predicate. By choosing this alternative within
     * {@link #adaptivePredict} instead of throwing a
     * {@link NoViableAltException}, the resulting
     * {@link FailedPredicateException} in the parser will identify the specific
     * predicate which is preventing the parser from successfully parsing the
     * decision rule, which helps developers identify and correct logic errors
     * in semantic predicates.
     *
     * @param input The input {@link TokenStream}
     * @param startIndex The start index for the current prediction, which is
     * the input index where any semantic context in `configs` should be
     * evaluated
     * @param previous The ATN simulation state immediately before the
     * {@link #ERROR} state was reached
     *
     * @returns The value to return from {@link #adaptivePredict}, or
     * {@link ATN#INVALID_ALT_NUMBER} if a suitable alternative was not
     * identified and {@link #adaptivePredict} should report an error instead.
     */ handleNoViableAlt(input, startIndex, previous) {
        if (previous.s0 != null) {
            let alts = new $8WIez.BitSet();
            let maxAlt = 0;
            for (let config of previous.s0.configs)if (config.reachesIntoOuterContext || config.state instanceof $jWsYN.RuleStopState) {
                alts.set(config.alt);
                maxAlt = Math.max(maxAlt, config.alt);
            }
            switch(alts.cardinality()){
                case 0:
                    break;
                case 1:
                    return alts.nextSetBit(0);
                default:
                    if (!previous.s0.configs.hasSemanticContext) // configs doesn't contain any predicates, so the predicate
                    // filtering code below would be pointless
                    return alts.nextSetBit(0);
                    /*
                     * Try to find a configuration set that not only dipped into the outer
                     * context, but also isn't eliminated by a predicate.
                     */ let filteredConfigs = new $2SGHL.ATNConfigSet();
                    for (let config of previous.s0.configs)if (config.reachesIntoOuterContext || config.state instanceof $jWsYN.RuleStopState) filteredConfigs.add(config);
                    /* The following code blocks are adapted from predicateDFAState with
                     * the following key changes.
                     *
                     *  1. The code operates on an ATNConfigSet rather than a DFAState.
                     *  2. Predicates are collected for all alternatives represented in
                     *     filteredConfigs, rather than restricting the evaluation to
                     *     conflicting and/or unique configurations.
                     */ let altToPred = this.getPredsForAmbigAlts(alts, filteredConfigs, maxAlt);
                    if (altToPred != null) {
                        let predicates = this.getPredicatePredictions(alts, altToPred);
                        if (predicates != null) {
                            let stopIndex = input.index;
                            try {
                                input.seek(startIndex);
                                let filteredAlts = this.evalSemanticContext(predicates, previous.outerContext, false);
                                if (!filteredAlts.isEmpty) return filteredAlts.nextSetBit(0);
                            } finally{
                                input.seek(stopIndex);
                            }
                        }
                    }
                    return alts.nextSetBit(0);
            }
        }
        throw this.noViableAlt(input, previous.outerContext, previous.s0.configs, startIndex);
    }
    computeReachSet(dfa, previous, t, contextCache) {
        let useContext = previous.useContext;
        let remainingGlobalContext = previous.remainingOuterContext;
        let s = previous.s0;
        if (useContext) while(s.isContextSymbol(t)){
            let next;
            if (remainingGlobalContext != null) {
                remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                next = s.getContextTarget(this.getReturnState(remainingGlobalContext));
            }
            if (next == null) break;
            $fomfP(remainingGlobalContext != null);
            remainingGlobalContext = remainingGlobalContext.parent;
            s = next;
        }
        $fomfP(!this.isAcceptState(s, useContext));
        if (this.isAcceptState(s, useContext)) return new $eDtKk.SimulatorState(previous.outerContext, s, useContext, remainingGlobalContext);
        let s0 = s;
        let target = this.getExistingTargetState(s0, t);
        if (target == null) {
            let result = this.computeTargetState(dfa, s0, remainingGlobalContext, t, useContext, contextCache);
            target = result[0];
            remainingGlobalContext = result[1];
        }
        if (target === $ceQRA.ATNSimulator.ERROR) return undefined;
        $fomfP(!useContext || !target.configs.dipsIntoOuterContext);
        return new $eDtKk.SimulatorState(previous.outerContext, target, useContext, remainingGlobalContext);
    }
    /**
     * Get an existing target state for an edge in the DFA. If the target state
     * for the edge has not yet been computed or is otherwise not available,
     * this method returns `undefined`.
     *
     * @param s The current DFA state
     * @param t The next input symbol
     * @returns The existing target DFA state for the given input symbol
     * `t`, or `undefined` if the target state for this edge is not
     * already cached
     */ getExistingTargetState(s, t) {
        return s.getTarget(t);
    }
    /**
     * Compute a target state for an edge in the DFA, and attempt to add the
     * computed state and corresponding edge to the DFA.
     *
     * @param dfa
     * @param s The current DFA state
     * @param remainingGlobalContext
     * @param t The next input symbol
     * @param useContext
     * @param contextCache
     *
     * @returns The computed target DFA state for the given input symbol
     * `t`. If `t` does not lead to a valid DFA state, this method
     * returns {@link #ERROR}.
     */ computeTargetState(dfa, s, remainingGlobalContext, t, useContext, contextCache) {
        let closureConfigs = s.configs.toArray();
        let contextElements;
        let reach = new $2SGHL.ATNConfigSet();
        let stepIntoGlobal;
        do {
            let hasMoreContext = !useContext || remainingGlobalContext != null;
            if (!hasMoreContext) reach.isOutermostConfigSet = true;
            let reachIntermediate = new $2SGHL.ATNConfigSet();
            /* Configurations already in a rule stop state indicate reaching the end
             * of the decision rule (local context) or end of the start rule (full
             * context). Once reached, these configurations are never updated by a
             * closure operation, so they are handled separately for the performance
             * advantage of having a smaller intermediate set when calling closure.
             *
             * For full-context reach operations, separate handling is required to
             * ensure that the alternative matching the longest overall sequence is
             * chosen when multiple such configurations can match the input.
             */ let skippedStopStates;
            for (let c of closureConfigs){
                if (ParserATNSimulator.debug) console.log("testing " + this.getTokenName(t) + " at " + c.toString());
                if (c.state instanceof $jWsYN.RuleStopState) {
                    $fomfP(c.context.isEmpty);
                    if (useContext && !c.reachesIntoOuterContext || t === $ldi9e.IntStream.EOF) {
                        if (skippedStopStates == null) skippedStopStates = [];
                        skippedStopStates.push(c);
                    }
                    continue;
                }
                let n = c.state.numberOfOptimizedTransitions;
                for(let ti = 0; ti < n; ti++){
                    let trans = c.state.getOptimizedTransition(ti);
                    let target = this.getReachableTarget(c, trans, t);
                    if (target != null) reachIntermediate.add(c.transform(target, false), contextCache);
                }
            }
            /* This block optimizes the reach operation for intermediate sets which
             * trivially indicate a termination state for the overall
             * adaptivePredict operation.
             *
             * The conditions assume that intermediate
             * contains all configurations relevant to the reach set, but this
             * condition is not true when one or more configurations have been
             * withheld in skippedStopStates, or when the current symbol is EOF.
             */ if (this.optimize_unique_closure && skippedStopStates == null && t !== $eKXi4.Token.EOF && reachIntermediate.uniqueAlt !== $eeOLb.ATN.INVALID_ALT_NUMBER) {
                reachIntermediate.isOutermostConfigSet = reach.isOutermostConfigSet;
                reach = reachIntermediate;
                break;
            }
            /* If the reach set could not be trivially determined, perform a closure
             * operation on the intermediate set to compute its initial value.
             */ let collectPredicates = false;
            let treatEofAsEpsilon = t === $eKXi4.Token.EOF;
            this.closure(reachIntermediate, reach, collectPredicates, hasMoreContext, contextCache, treatEofAsEpsilon);
            stepIntoGlobal = reach.dipsIntoOuterContext;
            if (t === $ldi9e.IntStream.EOF) /* After consuming EOF no additional input is possible, so we are
                 * only interested in configurations which reached the end of the
                 * decision rule (local context) or end of the start rule (full
                 * context). Update reach to contain only these configurations. This
                 * handles both explicit EOF transitions in the grammar and implicit
                 * EOF transitions following the end of the decision or start rule.
                 *
                 * This is handled before the configurations in skippedStopStates,
                 * because any configurations potentially added from that list are
                 * already guaranteed to meet this condition whether or not it's
                 * required.
                 */ reach = this.removeAllConfigsNotInRuleStopState(reach, contextCache);
            /* If skippedStopStates is not undefined, then it contains at least one
             * configuration. For full-context reach operations, these
             * configurations reached the end of the start rule, in which case we
             * only add them back to reach if no configuration during the current
             * closure operation reached such a state. This ensures adaptivePredict
             * chooses an alternative matching the longest overall sequence when
             * multiple alternatives are viable.
             */ if (skippedStopStates != null && (!useContext || !$hwoBE.PredictionMode.hasConfigInRuleStopState(reach))) {
                $fomfP(skippedStopStates.length > 0);
                for (let c of skippedStopStates)reach.add(c, contextCache);
            }
            if (useContext && stepIntoGlobal) {
                reach.clear();
                // We know remainingGlobalContext is not undefined at this point (why?)
                remainingGlobalContext;
                remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                let nextContextElement = this.getReturnState(remainingGlobalContext);
                if (contextElements == null) contextElements = new $eRSlM.IntegerList();
                if (remainingGlobalContext.isEmpty) remainingGlobalContext = undefined;
                else remainingGlobalContext = remainingGlobalContext.parent;
                contextElements.add(nextContextElement);
                if (nextContextElement !== $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY) for(let i = 0; i < closureConfigs.length; i++)closureConfigs[i] = closureConfigs[i].appendContext(nextContextElement, contextCache);
            }
        }while (useContext && stepIntoGlobal);
        if (reach.isEmpty) {
            this.setDFAEdge(s, t, $ceQRA.ATNSimulator.ERROR);
            return [
                $ceQRA.ATNSimulator.ERROR,
                remainingGlobalContext
            ];
        }
        let result = this.addDFAEdge(dfa, s, t, contextElements, reach, contextCache);
        return [
            result,
            remainingGlobalContext
        ];
    }
    /**
     * Return a configuration set containing only the configurations from
     * `configs` which are in a {@link RuleStopState}. If all
     * configurations in `configs` are already in a rule stop state, this
     * method simply returns `configs`.
     *
     * @param configs the configuration set to update
     * @param contextCache the {@link PredictionContext} cache
     *
     * @returns `configs` if all configurations in `configs` are in a
     * rule stop state, otherwise return a new configuration set containing only
     * the configurations from `configs` which are in a rule stop state
     */ removeAllConfigsNotInRuleStopState(configs, contextCache) {
        if ($hwoBE.PredictionMode.allConfigsInRuleStopStates(configs)) return configs;
        let result = new $2SGHL.ATNConfigSet();
        for (let config of configs){
            if (!(config.state instanceof $jWsYN.RuleStopState)) continue;
            result.add(config, contextCache);
        }
        return result;
    }
    computeStartState(dfa, globalContext, useContext) {
        let s0 = dfa.isPrecedenceDfa ? dfa.getPrecedenceStartState(this._parser.precedence, useContext) : useContext ? dfa.s0full : dfa.s0;
        if (s0 != null) {
            if (!useContext) return new $eDtKk.SimulatorState(globalContext, s0, useContext, globalContext);
            s0.setContextSensitive(this.atn);
        }
        let decision = dfa.decision;
        // @NotNull
        let p = dfa.atnStartState;
        let previousContext = 0;
        let remainingGlobalContext = globalContext;
        let initialContext = useContext ? $jaUCz.PredictionContext.EMPTY_FULL : $jaUCz.PredictionContext.EMPTY_LOCAL; // always at least the implicit call to start rule
        let contextCache = new $4BvNW.PredictionContextCache();
        if (useContext) {
            if (!this.enable_global_context_dfa) {
                while(remainingGlobalContext != null)if (remainingGlobalContext.isEmpty) {
                    previousContext = $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY;
                    remainingGlobalContext = undefined;
                } else {
                    previousContext = this.getReturnState(remainingGlobalContext);
                    initialContext = initialContext.appendSingleContext(previousContext, contextCache);
                    remainingGlobalContext = remainingGlobalContext.parent;
                }
            }
            while(s0 != null && s0.isContextSensitive && remainingGlobalContext != null){
                let next;
                remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                if (remainingGlobalContext.isEmpty) {
                    next = s0.getContextTarget($jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY);
                    previousContext = $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY;
                    remainingGlobalContext = undefined;
                } else {
                    previousContext = this.getReturnState(remainingGlobalContext);
                    next = s0.getContextTarget(previousContext);
                    initialContext = initialContext.appendSingleContext(previousContext, contextCache);
                    remainingGlobalContext = remainingGlobalContext.parent;
                }
                if (next == null) break;
                s0 = next;
            }
        }
        if (s0 != null && !s0.isContextSensitive) return new $eDtKk.SimulatorState(globalContext, s0, useContext, remainingGlobalContext);
        let configs = new $2SGHL.ATNConfigSet();
        while(true){
            let reachIntermediate = new $2SGHL.ATNConfigSet();
            let n = p.numberOfTransitions;
            for(let ti = 0; ti < n; ti++){
                // for each transition
                let target = p.transition(ti).target;
                reachIntermediate.add($hdFz0.ATNConfig.create(target, ti + 1, initialContext));
            }
            let hasMoreContext = remainingGlobalContext != null;
            if (!hasMoreContext) configs.isOutermostConfigSet = true;
            let collectPredicates = true;
            this.closure(reachIntermediate, configs, collectPredicates, hasMoreContext, contextCache, false);
            let stepIntoGlobal = configs.dipsIntoOuterContext;
            let next;
            if (useContext && !this.enable_global_context_dfa) {
                s0 = this.addDFAState(dfa, configs, contextCache);
                break;
            } else if (s0 == null) {
                if (!dfa.isPrecedenceDfa) {
                    next = this.addDFAState(dfa, configs, contextCache);
                    if (useContext) {
                        if (!dfa.s0full) dfa.s0full = next;
                        else next = dfa.s0full;
                    } else if (!dfa.s0) dfa.s0 = next;
                    else next = dfa.s0;
                } else {
                    /* If this is a precedence DFA, we use applyPrecedenceFilter
                     * to convert the computed start state to a precedence start
                     * state. We then use DFA.setPrecedenceStartState to set the
                     * appropriate start state for the precedence level rather
                     * than simply setting DFA.s0.
                     */ configs = this.applyPrecedenceFilter(configs, globalContext, contextCache);
                    next = this.addDFAState(dfa, configs, contextCache);
                    dfa.setPrecedenceStartState(this._parser.precedence, useContext, next);
                }
            } else {
                if (dfa.isPrecedenceDfa) configs = this.applyPrecedenceFilter(configs, globalContext, contextCache);
                next = this.addDFAState(dfa, configs, contextCache);
                s0.setContextTarget(previousContext, next);
            }
            s0 = next;
            if (!useContext || !stepIntoGlobal) break;
            // TODO: make sure it distinguishes empty stack states
            next.setContextSensitive(this.atn);
            // We know remainingGlobalContext is not undefined at this point (why?)
            remainingGlobalContext;
            configs.clear();
            remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
            let nextContextElement = this.getReturnState(remainingGlobalContext);
            if (remainingGlobalContext.isEmpty) remainingGlobalContext = undefined;
            else remainingGlobalContext = remainingGlobalContext.parent;
            if (nextContextElement !== $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY) initialContext = initialContext.appendSingleContext(nextContextElement, contextCache);
            previousContext = nextContextElement;
        }
        return new $eDtKk.SimulatorState(globalContext, s0, useContext, remainingGlobalContext);
    }
    /**
     * This method transforms the start state computed by
     * {@link #computeStartState} to the special start state used by a
     * precedence DFA for a particular precedence value. The transformation
     * process applies the following changes to the start state's configuration
     * set.
     *
     * 1. Evaluate the precedence predicates for each configuration using
     *    {@link SemanticContext#evalPrecedence}.
     * 1. When {@link ATNConfig#isPrecedenceFilterSuppressed} is `false`,
     *    remove all configurations which predict an alternative greater than 1,
     *    for which another configuration that predicts alternative 1 is in the
     *    same ATN state with the same prediction context. This transformation is
     *    valid for the following reasons:
     *
     *     * The closure block cannot contain any epsilon transitions which bypass
     *       the body of the closure, so all states reachable via alternative 1 are
     *       part of the precedence alternatives of the transformed left-recursive
     *       rule.
     *     * The "primary" portion of a left recursive rule cannot contain an
     *       epsilon transition, so the only way an alternative other than 1 can exist
     *       in a state that is also reachable via alternative 1 is by nesting calls
     *       to the left-recursive rule, with the outer calls not being at the
     *       preferred precedence level. The
     *       {@link ATNConfig#isPrecedenceFilterSuppressed} property marks ATN
     *       configurations which do not meet this condition, and therefore are not
     *       eligible for elimination during the filtering process.
     *
     * The prediction context must be considered by this filter to address
     * situations like the following.
     *
     * ```antlr
     * grammar TA;
     * prog: statement* EOF;
     * statement: letterA | statement letterA 'b' ;
     * letterA: 'a';
     * ```
     *
     * If the above grammar, the ATN state immediately before the token
     * reference `'a'` in `letterA` is reachable from the left edge
     * of both the primary and closure blocks of the left-recursive rule
     * `statement`. The prediction context associated with each of these
     * configurations distinguishes between them, and prevents the alternative
     * which stepped out to `prog` (and then back in to `statement`
     * from being eliminated by the filter.
     *
     * @param configs The configuration set computed by
     * {@link #computeStartState} as the start state for the DFA.
     * @returns The transformed configuration set representing the start state
     * for a precedence DFA at a particular precedence level (determined by
     * calling {@link Parser#getPrecedence}).
     */ applyPrecedenceFilter(configs, globalContext, contextCache) {
        let statesFromAlt1 = new Map();
        let configSet = new $2SGHL.ATNConfigSet();
        for (let config of configs){
            // handle alt 1 first
            if (config.alt !== 1) continue;
            let updatedContext = config.semanticContext.evalPrecedence(this._parser, globalContext);
            if (updatedContext == null) continue;
            statesFromAlt1.set(config.state.stateNumber, config.context);
            if (updatedContext !== config.semanticContext) configSet.add(config.transform(config.state, false, updatedContext), contextCache);
            else configSet.add(config, contextCache);
        }
        for (let config of configs){
            if (config.alt === 1) continue;
            if (!config.isPrecedenceFilterSuppressed) {
                /* In the future, this elimination step could be updated to also
                 * filter the prediction context for alternatives predicting alt>1
                 * (basically a graph subtraction algorithm).
                 */ let context = statesFromAlt1.get(config.state.stateNumber);
                if (context != null && context.equals(config.context)) continue;
            }
            configSet.add(config, contextCache);
        }
        return configSet;
    }
    getReachableTarget(source, trans, ttype) {
        if (trans.matches(ttype, 0, this.atn.maxTokenType)) return trans.target;
        return undefined;
    }
    /** collect and set D's semantic context */ predicateDFAState(D, configs, nalts) {
        let conflictingAlts = this.getConflictingAltsFromConfigSet(configs);
        if (!conflictingAlts) throw new Error("This unhandled scenario is intended to be unreachable, but I'm currently not sure of why we know that's the case.");
        if (ParserATNSimulator.debug) console.log("predicateDFAState " + D);
        let altToPred = this.getPredsForAmbigAlts(conflictingAlts, configs, nalts);
        // altToPred[uniqueAlt] is now our validating predicate (if any)
        let predPredictions;
        if (altToPred != null) {
            // we have a validating predicate; test it
            // Update DFA so reach becomes accept state with predicate
            predPredictions = this.getPredicatePredictions(conflictingAlts, altToPred);
            D.predicates = predPredictions;
        }
        return predPredictions;
    }
    getPredsForAmbigAlts(ambigAlts, configs, nalts) {
        // REACH=[1|1|[]|0:0, 1|2|[]|0:1]
        /* altToPred starts as an array of all undefined contexts. The entry at index i
         * corresponds to alternative i. altToPred[i] may have one of three values:
         *   1. undefined: no ATNConfig c is found such that c.alt===i
         *   2. SemanticContext.NONE: At least one ATNConfig c exists such that
         *      c.alt===i and c.semanticContext===SemanticContext.NONE. In other words,
         *      alt i has at least one unpredicated config.
         *   3. Non-NONE Semantic Context: There exists at least one, and for all
         *      ATNConfig c such that c.alt===i, c.semanticContext!==SemanticContext.NONE.
         *
         * From this, it is clear that NONE||anything==NONE.
         */ let altToPred = new Array(nalts + 1);
        let n = altToPred.length;
        for (let c of configs)if (ambigAlts.get(c.alt)) altToPred[c.alt] = $3JS45.SemanticContext.or(altToPred[c.alt], c.semanticContext);
        let nPredAlts = 0;
        for(let i = 0; i < n; i++){
            if (altToPred[i] == null) altToPred[i] = $3JS45.SemanticContext.NONE;
            else if (altToPred[i] !== $3JS45.SemanticContext.NONE) nPredAlts++;
        }
        // At this point we know `altToPred` doesn't contain any undefined entries
        let result = altToPred;
        // nonambig alts are undefined in result
        if (nPredAlts === 0) result = undefined;
        if (ParserATNSimulator.debug) console.log("getPredsForAmbigAlts result " + (result ? $4dKou.Arrays.toString(result) : "undefined"));
        return result;
    }
    getPredicatePredictions(ambigAlts, altToPred) {
        let pairs = [];
        let containsPredicate = false;
        for(let i = 1; i < altToPred.length; i++){
            let pred = altToPred[i];
            // unpredicated is indicated by SemanticContext.NONE
            $fomfP(pred != null);
            // find first unpredicated but ambig alternative, if any.
            // Only ambiguous alternatives will have SemanticContext.NONE.
            // Any unambig alts or ambig naked alts after first ambig naked are ignored
            // (undefined, i) means alt i is the default prediction
            // if no (undefined, i), then no default prediction.
            if (ambigAlts != null && ambigAlts.get(i) && pred === $3JS45.SemanticContext.NONE) pairs.push(new $6P9ap.DFAState.PredPrediction(pred, i));
            else if (pred !== $3JS45.SemanticContext.NONE) {
                containsPredicate = true;
                pairs.push(new $6P9ap.DFAState.PredPrediction(pred, i));
            }
        }
        if (!containsPredicate) return undefined;
        //		System.out.println(Arrays.toString(altToPred)+"->"+pairs);
        return pairs;
    }
    /** Look through a list of predicate/alt pairs, returning alts for the
     *  pairs that win. An `undefined` predicate indicates an alt containing an
     *  unpredicated config which behaves as "always true."
     */ evalSemanticContext(predPredictions, outerContext, complete) {
        let predictions = new $8WIez.BitSet();
        for (let pair of predPredictions){
            if (pair.pred === $3JS45.SemanticContext.NONE) {
                predictions.set(pair.alt);
                if (!complete) break;
                continue;
            }
            let evaluatedResult = this.evalSemanticContextImpl(pair.pred, outerContext, pair.alt);
            if (ParserATNSimulator.debug || ParserATNSimulator.dfa_debug) console.log("eval pred " + pair + "=" + evaluatedResult);
            if (evaluatedResult) {
                if (ParserATNSimulator.debug || ParserATNSimulator.dfa_debug) console.log("PREDICT " + pair.alt);
                predictions.set(pair.alt);
                if (!complete) break;
            }
        }
        return predictions;
    }
    /**
     * Evaluate a semantic context within a specific parser context.
     *
     * This method might not be called for every semantic context evaluated
     * during the prediction process. In particular, we currently do not
     * evaluate the following but it may change in the future:
     *
     * * Precedence predicates (represented by
     *   {@link SemanticContext.PrecedencePredicate}) are not currently evaluated
     *   through this method.
     * * Operator predicates (represented by {@link SemanticContext.AND} and
     *   {@link SemanticContext.OR}) are evaluated as a single semantic
     *   context, rather than evaluating the operands individually.
     *   Implementations which require evaluation results from individual
     *   predicates should override this method to explicitly handle evaluation of
     *   the operands within operator predicates.
     *
     * @param pred The semantic context to evaluate
     * @param parserCallStack The parser context in which to evaluate the
     * semantic context
     * @param alt The alternative which is guarded by `pred`
     *
     * @since 4.3
     */ evalSemanticContextImpl(pred, parserCallStack, alt) {
        return pred.eval(this._parser, parserCallStack);
    }
    /* TODO: If we are doing predicates, there is no point in pursuing
         closure operations if we reach a DFA state that uniquely predicts
         alternative. We will not be caching that DFA state and it is a
         waste to pursue the closure. Might have to advance when we do
         ambig detection thought :(
          */ closure(sourceConfigs, configs, collectPredicates, hasMoreContext, contextCache, treatEofAsEpsilon) {
        if (contextCache == null) contextCache = $4BvNW.PredictionContextCache.UNCACHED;
        let currentConfigs = sourceConfigs;
        let closureBusy = new $fsqYw.Array2DHashSet($9eW9B.ObjectEqualityComparator.INSTANCE);
        while(currentConfigs.size > 0){
            let intermediate = new $2SGHL.ATNConfigSet();
            for (let config of currentConfigs)this.closureImpl(config, configs, intermediate, closureBusy, collectPredicates, hasMoreContext, contextCache, 0, treatEofAsEpsilon);
            currentConfigs = intermediate;
        }
    }
    closureImpl(config, configs, intermediate, closureBusy, collectPredicates, hasMoreContexts, contextCache, depth, treatEofAsEpsilon) {
        if (ParserATNSimulator.debug) console.log("closure(" + config.toString(this._parser, true) + ")");
        if (config.state instanceof $jWsYN.RuleStopState) {
            // We hit rule end. If we have context info, use it
            if (!config.context.isEmpty) {
                let hasEmpty = config.context.hasEmpty;
                let nonEmptySize = config.context.size - (hasEmpty ? 1 : 0);
                for(let i = 0; i < nonEmptySize; i++){
                    let newContext = config.context.getParent(i); // "pop" return state
                    let returnState = this.atn.states[config.context.getReturnState(i)];
                    let c = $hdFz0.ATNConfig.create(returnState, config.alt, newContext, config.semanticContext);
                    // While we have context to pop back from, we may have
                    // gotten that context AFTER having fallen off a rule.
                    // Make sure we track that we are now out of context.
                    c.outerContextDepth = config.outerContextDepth;
                    c.isPrecedenceFilterSuppressed = config.isPrecedenceFilterSuppressed;
                    $fomfP(depth > $c0f91822940cc2ea$var$MIN_INTEGER_VALUE);
                    this.closureImpl(c, configs, intermediate, closureBusy, collectPredicates, hasMoreContexts, contextCache, depth - 1, treatEofAsEpsilon);
                }
                if (!hasEmpty || !hasMoreContexts) return;
                config = config.transform(config.state, false, $jaUCz.PredictionContext.EMPTY_LOCAL);
            } else if (!hasMoreContexts) {
                configs.add(config, contextCache);
                return;
            } else {
                // else if we have no context info, just chase follow links (if greedy)
                if (ParserATNSimulator.debug) console.log("FALLING off rule " + this.getRuleName(config.state.ruleIndex));
                if (config.context === $jaUCz.PredictionContext.EMPTY_FULL) // no need to keep full context overhead when we step out
                config = config.transform(config.state, false, $jaUCz.PredictionContext.EMPTY_LOCAL);
                else if (!config.reachesIntoOuterContext && $jaUCz.PredictionContext.isEmptyLocal(config.context)) // add stop state when leaving decision rule for the first time
                configs.add(config, contextCache);
            }
        }
        let p = config.state;
        // optimization
        if (!p.onlyHasEpsilonTransitions) {
            configs.add(config, contextCache);
            // make sure to not return here, because EOF transitions can act as
            // both epsilon transitions and non-epsilon transitions.
            if (ParserATNSimulator.debug) console.log("added config " + configs);
        }
        for(let i = 0; i < p.numberOfOptimizedTransitions; i++){
            // This block implements first-edge elimination of ambiguous LR
            // alternatives as part of dynamic disambiguation during prediction.
            // See antlr/antlr4#1398.
            if (i === 0 && p.stateType === $fZESB.ATNStateType.STAR_LOOP_ENTRY && p.precedenceRuleDecision && !config.context.hasEmpty) {
                let precedenceDecision = p;
                // When suppress is true, it means the outgoing edge i==0 is
                // ambiguous with the outgoing edge i==1, and thus the closure
                // operation can dynamically disambiguate by suppressing this
                // edge during the closure operation.
                let suppress = true;
                for(let j = 0; j < config.context.size; j++)if (!precedenceDecision.precedenceLoopbackStates.get(config.context.getReturnState(j))) {
                    suppress = false;
                    break;
                }
                if (suppress) continue;
            }
            let t = p.getOptimizedTransition(i);
            let continueCollecting = !(t instanceof $dNkDA.ActionTransition) && collectPredicates;
            let c = this.getEpsilonTarget(config, t, continueCollecting, depth === 0, contextCache, treatEofAsEpsilon);
            if (c != null) {
                if (t instanceof $lmhna.RuleTransition) {
                    if (intermediate != null && !collectPredicates) {
                        intermediate.add(c, contextCache);
                        continue;
                    }
                }
                let newDepth = depth;
                if (config.state instanceof $jWsYN.RuleStopState) {
                    // target fell off end of rule; mark resulting c as having dipped into outer context
                    // We can't get here if incoming config was rule stop and we had context
                    // track how far we dip into outer context.  Might
                    // come in handy and we avoid evaluating context dependent
                    // preds if this is > 0.
                    if (this.dfa != null && this.dfa.isPrecedenceDfa) {
                        let outermostPrecedenceReturn = t.outermostPrecedenceReturn;
                        if (outermostPrecedenceReturn === this.dfa.atnStartState.ruleIndex) c.isPrecedenceFilterSuppressed = true;
                    }
                    c.outerContextDepth = c.outerContextDepth + 1;
                    if (!closureBusy.add(c)) continue;
                    $fomfP(newDepth > $c0f91822940cc2ea$var$MIN_INTEGER_VALUE);
                    newDepth--;
                    if (ParserATNSimulator.debug) console.log("dips into outer ctx: " + c);
                } else if (t instanceof $lmhna.RuleTransition) {
                    if (this.optimize_tail_calls && t.optimizedTailCall && (!this.tail_call_preserves_sll || !$jaUCz.PredictionContext.isEmptyLocal(config.context))) {
                        $fomfP(c.context === config.context);
                        if (newDepth === 0) {
                            // the pop/push of a tail call would keep the depth
                            // constant, except we latch if it goes negative
                            newDepth--;
                            if (!this.tail_call_preserves_sll && $jaUCz.PredictionContext.isEmptyLocal(config.context)) // make sure the SLL config "dips into the outer context" or prediction may not fall back to LL on conflict
                            c.outerContextDepth = c.outerContextDepth + 1;
                        }
                    } else // latch when newDepth goes negative - once we step out of the entry context we can't return
                    if (newDepth >= 0) newDepth++;
                } else {
                    if (!t.isEpsilon && !closureBusy.add(c)) continue;
                }
                this.closureImpl(c, configs, intermediate, closureBusy, continueCollecting, hasMoreContexts, contextCache, newDepth, treatEofAsEpsilon);
            }
        }
    }
    getRuleName(index) {
        if (this._parser != null && index >= 0) return this._parser.ruleNames[index];
        return "<rule " + index + ">";
    }
    getEpsilonTarget(config, t, collectPredicates, inContext, contextCache, treatEofAsEpsilon) {
        switch(t.serializationType){
            case 3 /* RULE */ :
                return this.ruleTransition(config, t, contextCache);
            case 10 /* PRECEDENCE */ :
                return this.precedenceTransition(config, t, collectPredicates, inContext);
            case 4 /* PREDICATE */ :
                return this.predTransition(config, t, collectPredicates, inContext);
            case 6 /* ACTION */ :
                return this.actionTransition(config, t);
            case 1 /* EPSILON */ :
                return config.transform(t.target, false);
            case 5 /* ATOM */ :
            case 2 /* RANGE */ :
            case 7 /* SET */ :
                // EOF transitions act like epsilon transitions after the first EOF
                // transition is traversed
                if (treatEofAsEpsilon) {
                    if (t.matches($eKXi4.Token.EOF, 0, 1)) return config.transform(t.target, false);
                }
                return undefined;
            default:
                return undefined;
        }
    }
    actionTransition(config, t) {
        if (ParserATNSimulator.debug) console.log("ACTION edge " + t.ruleIndex + ":" + t.actionIndex);
        return config.transform(t.target, false);
    }
    precedenceTransition(config, pt, collectPredicates, inContext) {
        if (ParserATNSimulator.debug) {
            console.log("PRED (collectPredicates=" + collectPredicates + ") " + pt.precedence + ">=_p" + ", ctx dependent=true");
            if (this._parser != null) console.log("context surrounding pred is " + this._parser.getRuleInvocationStack());
        }
        let c;
        if (collectPredicates && inContext) {
            let newSemCtx = $3JS45.SemanticContext.and(config.semanticContext, pt.predicate);
            c = config.transform(pt.target, false, newSemCtx);
        } else c = config.transform(pt.target, false);
        if (ParserATNSimulator.debug) console.log("config from pred transition=" + c);
        return c;
    }
    predTransition(config, pt, collectPredicates, inContext) {
        if (ParserATNSimulator.debug) {
            console.log("PRED (collectPredicates=" + collectPredicates + ") " + pt.ruleIndex + ":" + pt.predIndex + ", ctx dependent=" + pt.isCtxDependent);
            if (this._parser != null) console.log("context surrounding pred is " + this._parser.getRuleInvocationStack());
        }
        let c;
        if (collectPredicates && (!pt.isCtxDependent || pt.isCtxDependent && inContext)) {
            let newSemCtx = $3JS45.SemanticContext.and(config.semanticContext, pt.predicate);
            c = config.transform(pt.target, false, newSemCtx);
        } else c = config.transform(pt.target, false);
        if (ParserATNSimulator.debug) console.log("config from pred transition=" + c);
        return c;
    }
    ruleTransition(config, t, contextCache) {
        if (ParserATNSimulator.debug) console.log("CALL rule " + this.getRuleName(t.target.ruleIndex) + ", ctx=" + config.context);
        let returnState = t.followState;
        let newContext;
        if (this.optimize_tail_calls && t.optimizedTailCall && (!this.tail_call_preserves_sll || !$jaUCz.PredictionContext.isEmptyLocal(config.context))) newContext = config.context;
        else if (contextCache != null) newContext = contextCache.getChild(config.context, returnState.stateNumber);
        else newContext = config.context.getChild(returnState.stateNumber);
        return config.transform(t.target, false, newContext);
    }
    isConflicted(configset, contextCache) {
        if (configset.uniqueAlt !== $eeOLb.ATN.INVALID_ALT_NUMBER || configset.size <= 1) return undefined;
        let configs = configset.toArray();
        configs.sort(ParserATNSimulator.STATE_ALT_SORT_COMPARATOR);
        let exact = !configset.dipsIntoOuterContext;
        let alts = new $8WIez.BitSet();
        let minAlt = configs[0].alt;
        alts.set(minAlt);
        /* Quick checks come first (single pass, no context joining):
         *  1. Make sure first config in the sorted list predicts the minimum
         *     represented alternative.
         *  2. Make sure every represented state has at least one configuration
         *     which predicts the minimum represented alternative.
         *  3. (exact only) make sure every represented state has at least one
         *     configuration which predicts each represented alternative.
         */ // quick check 1 & 2 => if we assume #1 holds and check #2 against the
        // minAlt from the first state, #2 will fail if the assumption was
        // incorrect
        let currentState = configs[0].state.nonStopStateNumber;
        for (let config of configs){
            let stateNumber = config.state.nonStopStateNumber;
            if (stateNumber !== currentState) {
                if (config.alt !== minAlt) return undefined;
                currentState = stateNumber;
            }
        }
        let representedAlts;
        if (exact) {
            currentState = configs[0].state.nonStopStateNumber;
            // get the represented alternatives of the first state
            representedAlts = new $8WIez.BitSet();
            let maxAlt = minAlt;
            for (let config of configs){
                if (config.state.nonStopStateNumber !== currentState) break;
                let alt = config.alt;
                representedAlts.set(alt);
                maxAlt = alt;
            }
            // quick check #3:
            currentState = configs[0].state.nonStopStateNumber;
            let currentAlt = minAlt;
            for (let config of configs){
                let stateNumber = config.state.nonStopStateNumber;
                let alt = config.alt;
                if (stateNumber !== currentState) {
                    if (currentAlt !== maxAlt) {
                        exact = false;
                        break;
                    }
                    currentState = stateNumber;
                    currentAlt = minAlt;
                } else if (alt !== currentAlt) {
                    if (alt !== representedAlts.nextSetBit(currentAlt + 1)) {
                        exact = false;
                        break;
                    }
                    currentAlt = alt;
                }
            }
        }
        currentState = configs[0].state.nonStopStateNumber;
        let firstIndexCurrentState = 0;
        let lastIndexCurrentStateMinAlt = 0;
        let joinedCheckContext = configs[0].context;
        for(let i = 1; i < configs.length; i++){
            let config = configs[i];
            if (config.alt !== minAlt) break;
            if (config.state.nonStopStateNumber !== currentState) break;
            lastIndexCurrentStateMinAlt = i;
            joinedCheckContext = contextCache.join(joinedCheckContext, configs[i].context);
        }
        for(let i = lastIndexCurrentStateMinAlt + 1; i < configs.length; i++){
            let config = configs[i];
            let state = config.state;
            alts.set(config.alt);
            if (state.nonStopStateNumber !== currentState) {
                currentState = state.nonStopStateNumber;
                firstIndexCurrentState = i;
                lastIndexCurrentStateMinAlt = i;
                joinedCheckContext = config.context;
                for(let j = firstIndexCurrentState + 1; j < configs.length; j++){
                    let config2 = configs[j];
                    if (config2.alt !== minAlt) break;
                    if (config2.state.nonStopStateNumber !== currentState) break;
                    lastIndexCurrentStateMinAlt = j;
                    joinedCheckContext = contextCache.join(joinedCheckContext, config2.context);
                }
                i = lastIndexCurrentStateMinAlt;
                continue;
            }
            let joinedCheckContext2 = config.context;
            let currentAlt = config.alt;
            let lastIndexCurrentStateCurrentAlt = i;
            for(let j = lastIndexCurrentStateCurrentAlt + 1; j < configs.length; j++){
                let config2 = configs[j];
                if (config2.alt !== currentAlt) break;
                if (config2.state.nonStopStateNumber !== currentState) break;
                lastIndexCurrentStateCurrentAlt = j;
                joinedCheckContext2 = contextCache.join(joinedCheckContext2, config2.context);
            }
            i = lastIndexCurrentStateCurrentAlt;
            let check = contextCache.join(joinedCheckContext, joinedCheckContext2);
            if (!joinedCheckContext.equals(check)) return undefined;
            // update exact if necessary
            exact = exact && joinedCheckContext.equals(joinedCheckContext2);
        }
        return new $bPdk6.ConflictInfo(alts, exact);
    }
    getConflictingAltsFromConfigSet(configs) {
        let conflictingAlts = configs.conflictingAlts;
        if (conflictingAlts == null && configs.uniqueAlt !== $eeOLb.ATN.INVALID_ALT_NUMBER) {
            conflictingAlts = new $8WIez.BitSet();
            conflictingAlts.set(configs.uniqueAlt);
        }
        return conflictingAlts;
    }
    getTokenName(t) {
        if (t === $eKXi4.Token.EOF) return "EOF";
        let vocabulary = this._parser != null ? this._parser.vocabulary : $hBnE1.VocabularyImpl.EMPTY_VOCABULARY;
        let displayName = vocabulary.getDisplayName(t);
        if (displayName === String(t)) return displayName;
        return displayName + "<" + t + ">";
    }
    getLookaheadName(input) {
        return this.getTokenName(input.LA(1));
    }
    dumpDeadEndConfigs(nvae) {
        console.log("dead end configs: ");
        let deadEndConfigs = nvae.deadEndConfigs;
        if (!deadEndConfigs) return;
        for (let c of deadEndConfigs){
            let trans = "no edges";
            if (c.state.numberOfOptimizedTransitions > 0) {
                let t = c.state.getOptimizedTransition(0);
                if (t instanceof $kXmw5.AtomTransition) trans = "Atom " + this.getTokenName(t._label);
                else if (t instanceof $5EcBU.SetTransition) {
                    let not = t instanceof $gFTdY.NotSetTransition;
                    trans = (not ? "~" : "") + "Set " + t.set.toString();
                }
            }
            console.log(c.toString(this._parser, true) + ":" + trans);
        }
    }
    noViableAlt(input, outerContext, configs, startIndex) {
        return new $iAlWg.NoViableAltException(this._parser, input, input.get(startIndex), input.LT(1), configs, outerContext);
    }
    getUniqueAlt(configs) {
        let alt = $eeOLb.ATN.INVALID_ALT_NUMBER;
        for (let c of configs){
            if (alt === $eeOLb.ATN.INVALID_ALT_NUMBER) alt = c.alt; // found first alt
            else if (c.alt !== alt) return $eeOLb.ATN.INVALID_ALT_NUMBER;
        }
        return alt;
    }
    configWithAltAtStopState(configs, alt) {
        for (let c of configs)if (c.alt === alt) {
            if (c.state instanceof $jWsYN.RuleStopState) return true;
        }
        return false;
    }
    addDFAEdge(dfa, fromState, t, contextTransitions, toConfigs, contextCache) {
        $fomfP(contextTransitions == null || contextTransitions.isEmpty || dfa.isContextSensitive);
        let from = fromState;
        let to = this.addDFAState(dfa, toConfigs, contextCache);
        if (contextTransitions != null) for (let context of contextTransitions.toArray()){
            if (context === $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY) {
                if (from.configs.isOutermostConfigSet) continue;
            }
            from.setContextSensitive(this.atn);
            from.setContextSymbol(t);
            let next = from.getContextTarget(context);
            if (next != null) {
                from = next;
                continue;
            }
            next = this.addDFAContextState(dfa, from.configs, context, contextCache);
            $fomfP(context !== $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY || next.configs.isOutermostConfigSet);
            from.setContextTarget(context, next);
            from = next;
        }
        if (ParserATNSimulator.debug) console.log("EDGE " + from + " -> " + to + " upon " + this.getTokenName(t));
        this.setDFAEdge(from, t, to);
        if (ParserATNSimulator.debug) console.log("DFA=\n" + dfa.toString(this._parser != null ? this._parser.vocabulary : $hBnE1.VocabularyImpl.EMPTY_VOCABULARY, this._parser != null ? this._parser.ruleNames : undefined));
        return to;
    }
    setDFAEdge(p, t, q) {
        if (p != null) p.setTarget(t, q);
    }
    /** See comment on LexerInterpreter.addDFAState. */ addDFAContextState(dfa, configs, returnContext, contextCache) {
        if (returnContext !== $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY) {
            let contextConfigs = new $2SGHL.ATNConfigSet();
            for (let config of configs)contextConfigs.add(config.appendContext(returnContext, contextCache));
            return this.addDFAState(dfa, contextConfigs, contextCache);
        } else {
            $fomfP(!configs.isOutermostConfigSet, "Shouldn't be adding a duplicate edge.");
            configs = configs.clone(true);
            configs.isOutermostConfigSet = true;
            return this.addDFAState(dfa, configs, contextCache);
        }
    }
    /** See comment on LexerInterpreter.addDFAState. */ addDFAState(dfa, configs, contextCache) {
        let enableDfa = this.enable_global_context_dfa || !configs.isOutermostConfigSet;
        if (enableDfa) {
            if (!configs.isReadOnly) configs.optimizeConfigs(this);
            let proposed = this.createDFAState(dfa, configs);
            let existing = dfa.states.get(proposed);
            if (existing != null) return existing;
        }
        if (!configs.isReadOnly) {
            if (configs.conflictInfo == null) configs.conflictInfo = this.isConflicted(configs, contextCache);
        }
        let newState = this.createDFAState(dfa, configs.clone(true));
        // getDecisionState won't return undefined when we request a known valid decision
        let decisionState = this.atn.getDecisionState(dfa.decision);
        let predictedAlt = this.getUniqueAlt(configs);
        if (predictedAlt !== $eeOLb.ATN.INVALID_ALT_NUMBER) newState.acceptStateInfo = new $hu8W9.AcceptStateInfo(predictedAlt);
        else if (configs.conflictingAlts != null) {
            let conflictingAlts = configs.conflictingAlts;
            if (conflictingAlts) newState.acceptStateInfo = new $hu8W9.AcceptStateInfo(conflictingAlts.nextSetBit(0));
        }
        if (newState.isAcceptState && configs.hasSemanticContext) this.predicateDFAState(newState, configs, decisionState.numberOfTransitions);
        if (!enableDfa) return newState;
        let added = dfa.addState(newState);
        if (ParserATNSimulator.debug && added === newState) console.log("adding new DFA state: " + newState);
        return added;
    }
    createDFAState(dfa, configs) {
        return new $6P9ap.DFAState(configs);
    }
    reportAttemptingFullContext(dfa, conflictingAlts, conflictState, startIndex, stopIndex) {
        if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
            let interval = $l8y5T.Interval.of(startIndex, stopIndex);
            console.log("reportAttemptingFullContext decision=" + dfa.decision + ":" + conflictState.s0.configs + ", input=" + this._parser.inputStream.getText(interval));
        }
        if (this._parser != null) {
            let listener = this._parser.getErrorListenerDispatch();
            if (listener.reportAttemptingFullContext) listener.reportAttemptingFullContext(this._parser, dfa, startIndex, stopIndex, conflictingAlts, conflictState);
        }
    }
    reportContextSensitivity(dfa, prediction, acceptState, startIndex, stopIndex) {
        if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
            let interval = $l8y5T.Interval.of(startIndex, stopIndex);
            console.log("reportContextSensitivity decision=" + dfa.decision + ":" + acceptState.s0.configs + ", input=" + this._parser.inputStream.getText(interval));
        }
        if (this._parser != null) {
            let listener = this._parser.getErrorListenerDispatch();
            if (listener.reportContextSensitivity) listener.reportContextSensitivity(this._parser, dfa, startIndex, stopIndex, prediction, acceptState);
        }
    }
    /** If context sensitive parsing, we know it's ambiguity not conflict */ reportAmbiguity(dfa, D, startIndex, stopIndex, exact, ambigAlts, configs) {
        if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
            let interval = $l8y5T.Interval.of(startIndex, stopIndex);
            console.log("reportAmbiguity " + ambigAlts + ":" + configs + ", input=" + this._parser.inputStream.getText(interval));
        }
        if (this._parser != null) {
            let listener = this._parser.getErrorListenerDispatch();
            if (listener.reportAmbiguity) listener.reportAmbiguity(this._parser, dfa, startIndex, stopIndex, exact, ambigAlts, configs);
        }
    }
    getReturnState(context) {
        if (context.isEmpty) return $jaUCz.PredictionContext.EMPTY_FULL_STATE_KEY;
        let state = this.atn.states[context.invokingState];
        let transition = state.transition(0);
        return transition.followState.stateNumber;
    }
    skipTailCalls(context) {
        if (!this.optimize_tail_calls) return context;
        while(!context.isEmpty){
            let state = this.atn.states[context.invokingState];
            $fomfP(state.numberOfTransitions === 1 && state.transition(0).serializationType === 3 /* RULE */ );
            let transition = state.transition(0);
            if (!transition.tailCall) break;
            // This method requires that the root ancestor of the ParserRuleContext be empty. If we make it to this
            // line, we know the current node is not empty, which means it does have a parent.
            context = context.parent;
        }
        return context;
    }
    /**
     * @since 4.3
     */ get parser() {
        return this._parser;
    }
};
$c0f91822940cc2ea$var$ParserATNSimulator.debug = false;
$c0f91822940cc2ea$var$ParserATNSimulator.dfa_debug = false;
$c0f91822940cc2ea$var$ParserATNSimulator.retry_debug = false;
$c0f91822940cc2ea$var$ParserATNSimulator.STATE_ALT_SORT_COMPARATOR = (o1, o2)=>{
    let diff = o1.state.nonStopStateNumber - o2.state.nonStopStateNumber;
    if (diff !== 0) return diff;
    diff = o1.alt - o2.alt;
    if (diff !== 0) return diff;
    return 0;
};
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "predictionMode", void 0);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "getPredictionMode", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "setPredictionMode", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.Override
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "reset", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "adaptivePredict", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(2, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "getStartState", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(3, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "execDFA", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(3, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "execATN", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(2, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "handleNoViableAlt", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "getExistingTargetState", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull,
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "computeTargetState", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull,
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "removeAllConfigsNotInRuleStopState", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "computeStartState", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull,
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "applyPrecedenceFilter", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "getReachableTarget", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "getPredsForAmbigAlts", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "evalSemanticContext", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "evalSemanticContextImpl", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(4, $aN41m.Nullable)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "closure", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(2, $aN41m.Nullable),
    $c0f91822940cc2ea$var$__param(3, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(6, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "closureImpl", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "getRuleName", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "getEpsilonTarget", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull,
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "actionTransition", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.Nullable,
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "precedenceTransition", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.Nullable,
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "predTransition", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull,
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(2, $aN41m.Nullable)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "ruleTransition", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "isConflicted", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "getTokenName", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "dumpDeadEndConfigs", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull,
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(2, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "noViableAlt", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "getUniqueAlt", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "configWithAltAtStopState", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull,
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(4, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "addDFAEdge", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.Nullable),
    $c0f91822940cc2ea$var$__param(2, $aN41m.Nullable)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "setDFAEdge", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull,
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "addDFAContextState", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull,
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "addDFAState", null);
$c0f91822940cc2ea$var$__decorate([
    $aN41m.NotNull,
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(1, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "createDFAState", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(2, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "reportAttemptingFullContext", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(2, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "reportContextSensitivity", null);
$c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(5, $aN41m.NotNull),
    $c0f91822940cc2ea$var$__param(6, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator.prototype, "reportAmbiguity", null);
$c0f91822940cc2ea$var$ParserATNSimulator = $c0f91822940cc2ea$var$__decorate([
    $c0f91822940cc2ea$var$__param(0, $aN41m.NotNull)
], $c0f91822940cc2ea$var$ParserATNSimulator);
module.exports.ParserATNSimulator = $c0f91822940cc2ea$var$ParserATNSimulator;

});
parcelRegister("bPdk6", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $89becade1f0ea245$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConflictInfo = void 0;

var $aN41m = parcelRequire("aN41m");

var $62Uvn = parcelRequire("62Uvn");
/**
 * This class stores information about a configuration conflict.
 *
 * @author Sam Harwell
 */ class $89becade1f0ea245$var$ConflictInfo {
    constructor(conflictedAlts, exact){
        this._conflictedAlts = conflictedAlts;
        this.exact = exact;
    }
    /**
     * Gets the set of conflicting alternatives for the configuration set.
     */ get conflictedAlts() {
        return this._conflictedAlts;
    }
    /**
     * Gets whether or not the configuration conflict is an exact conflict.
     * An exact conflict occurs when the prediction algorithm determines that
     * the represented alternatives for a particular configuration set cannot be
     * further reduced by consuming additional input. After reaching an exact
     * conflict during an SLL prediction, only switch to full-context prediction
     * could reduce the set of viable alternatives. In LL prediction, an exact
     * conflict indicates a true ambiguity in the input.
     *
     * For the {@link PredictionMode#LL_EXACT_AMBIG_DETECTION} prediction mode,
     * accept states are conflicting but not exact are treated as non-accept
     * states.
     */ get isExact() {
        return this.exact;
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $89becade1f0ea245$var$ConflictInfo)) return false;
        return this.isExact === obj.isExact && $62Uvn.equals(this.conflictedAlts, obj.conflictedAlts);
    }
    hashCode() {
        return this.conflictedAlts.hashCode();
    }
}
$89becade1f0ea245$var$__decorate([
    $aN41m.Override
], $89becade1f0ea245$var$ConflictInfo.prototype, "equals", null);
$89becade1f0ea245$var$__decorate([
    $aN41m.Override
], $89becade1f0ea245$var$ConflictInfo.prototype, "hashCode", null);
module.exports.ConflictInfo = $89becade1f0ea245$var$ConflictInfo;

});

parcelRegister("2pDMz", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $1c1cc68451022b8b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParserRuleContext = void 0;

var $co9Xk = parcelRequire("co9Xk");

var $l8y5T = parcelRequire("l8y5T");

var $aN41m = parcelRequire("aN41m");

var $1xO0Q = parcelRequire("1xO0Q");

var $2IN61 = parcelRequire("2IN61");
/** A rule invocation record for parsing.
 *
 *  Contains all of the information about the current rule not stored in the
 *  RuleContext. It handles parse tree children list, Any ATN state
 *  tracing, and the default values available for rule invocations:
 *  start, stop, rule index, current alt number.
 *
 *  Subclasses made for each rule and grammar track the parameters,
 *  return values, locals, and labels specific to that rule. These
 *  are the objects that are returned from rules.
 *
 *  Note text is not an actual field of a rule return value; it is computed
 *  from start and stop using the input stream's toString() method.  I
 *  could add a ctor to this so that we can pass in and store the input
 *  stream, but I'm not sure we want to do that.  It would seem to be undefined
 *  to get the .text property anyway if the rule matches tokens from multiple
 *  input streams.
 *
 *  I do not use getters for fields of objects that are used simply to
 *  group values such as this aggregate.  The getters/setters are there to
 *  satisfy the superclass interface.
 */ class $1c1cc68451022b8b$var$ParserRuleContext extends $1xO0Q.RuleContext {
    constructor(parent, invokingStateNumber){
        if (invokingStateNumber == null) super();
        else super(parent, invokingStateNumber);
    }
    static emptyContext() {
        return $1c1cc68451022b8b$var$ParserRuleContext.EMPTY;
    }
    /**
     * COPY a ctx (I'm deliberately not using copy constructor) to avoid
     * confusion with creating node with parent. Does not copy children
     * (except error leaves).
     *
     * This is used in the generated parser code to flip a generic XContext
     * node for rule X to a YContext for alt label Y. In that sense, it is not
     * really a generic copy function.
     *
     * If we do an error sync() at start of a rule, we might add error nodes
     * to the generic XContext so this function must copy those nodes to the
     * YContext as well else they are lost!
     */ copyFrom(ctx) {
        this._parent = ctx._parent;
        this.invokingState = ctx.invokingState;
        this._start = ctx._start;
        this._stop = ctx._stop;
        // copy any error nodes to alt label node
        if (ctx.children) {
            this.children = [];
            // reset parent pointer for any error nodes
            for (let child of ctx.children)if (child instanceof $co9Xk.ErrorNode) this.addChild(child);
        }
    }
    // Double dispatch methods for listeners
    enterRule(listener) {
    // intentionally empty
    }
    exitRule(listener) {
    // intentionally empty
    }
    /** Add a parse tree node to this as a child.  Works for
     *  internal and leaf nodes. Does not set parent link;
     *  other add methods must do that. Other addChild methods
     *  call this.
     *
     *  We cannot set the parent pointer of the incoming node
     *  because the existing interfaces do not have a setParent()
     *  method and I don't want to break backward compatibility for this.
     *
     *  @since 4.7
     */ addAnyChild(t) {
        if (!this.children) this.children = [
            t
        ];
        else this.children.push(t);
        return t;
    }
    addChild(t) {
        let result;
        if (t instanceof $2IN61.TerminalNode) {
            t.setParent(this);
            this.addAnyChild(t);
            return;
        } else if (t instanceof $1xO0Q.RuleContext) {
            // Does not set parent link
            this.addAnyChild(t);
            return;
        } else {
            // Deprecated code path
            t = new $2IN61.TerminalNode(t);
            this.addAnyChild(t);
            t.setParent(this);
            return t;
        }
    }
    addErrorNode(node) {
        if (node instanceof $co9Xk.ErrorNode) {
            const errorNode = node;
            errorNode.setParent(this);
            return this.addAnyChild(errorNode);
        } else {
            // deprecated path
            const badToken = node;
            let t = new $co9Xk.ErrorNode(badToken);
            this.addAnyChild(t);
            t.setParent(this);
            return t;
        }
    }
    //	public void trace(int s) {
    //		if ( states==null ) states = new ArrayList<Integer>();
    //		states.add(s);
    //	}
    /** Used by enterOuterAlt to toss out a RuleContext previously added as
     *  we entered a rule. If we have # label, we will need to remove
     *  generic ruleContext object.
     */ removeLastChild() {
        if (this.children) this.children.pop();
    }
    get parent() {
        let parent = super.parent;
        if (parent === undefined || parent instanceof $1c1cc68451022b8b$var$ParserRuleContext) return parent;
        throw new TypeError("Invalid parent type for ParserRuleContext");
    }
    // Note: in TypeScript, order or arguments reversed
    getChild(i, ctxType) {
        if (!this.children || i < 0 || i >= this.children.length) throw new RangeError("index parameter must be between >= 0 and <= number of children.");
        if (ctxType == null) return this.children[i];
        let result = this.tryGetChild(i, ctxType);
        if (result === undefined) throw new Error("The specified node does not exist");
        return result;
    }
    tryGetChild(i, ctxType) {
        if (!this.children || i < 0 || i >= this.children.length) return undefined;
        let j = -1; // what node with ctxType have we found?
        for (let o of this.children)if (o instanceof ctxType) {
            j++;
            if (j === i) return o;
        }
        return undefined;
    }
    getToken(ttype, i) {
        let result = this.tryGetToken(ttype, i);
        if (result === undefined) throw new Error("The specified token does not exist");
        return result;
    }
    tryGetToken(ttype, i) {
        if (!this.children || i < 0 || i >= this.children.length) return undefined;
        let j = -1; // what token with ttype have we found?
        for (let o of this.children)if (o instanceof $2IN61.TerminalNode) {
            let symbol = o.symbol;
            if (symbol.type === ttype) {
                j++;
                if (j === i) return o;
            }
        }
        return undefined;
    }
    getTokens(ttype) {
        let tokens = [];
        if (!this.children) return tokens;
        for (let o of this.children)if (o instanceof $2IN61.TerminalNode) {
            let symbol = o.symbol;
            if (symbol.type === ttype) tokens.push(o);
        }
        return tokens;
    }
    get ruleContext() {
        return this;
    }
    // NOTE: argument order change from Java version
    getRuleContext(i, ctxType) {
        return this.getChild(i, ctxType);
    }
    tryGetRuleContext(i, ctxType) {
        return this.tryGetChild(i, ctxType);
    }
    getRuleContexts(ctxType) {
        let contexts = [];
        if (!this.children) return contexts;
        for (let o of this.children)if (o instanceof ctxType) contexts.push(o);
        return contexts;
    }
    get childCount() {
        return this.children ? this.children.length : 0;
    }
    get sourceInterval() {
        if (!this._start) return $l8y5T.Interval.INVALID;
        if (!this._stop || this._stop.tokenIndex < this._start.tokenIndex) return $l8y5T.Interval.of(this._start.tokenIndex, this._start.tokenIndex - 1); // empty
        return $l8y5T.Interval.of(this._start.tokenIndex, this._stop.tokenIndex);
    }
    /**
     * Get the initial token in this context.
     * Note that the range from start to stop is inclusive, so for rules that do not consume anything
     * (for example, zero length or error productions) this token may exceed stop.
     */ get start() {
        return this._start;
    }
    /**
     * Get the final token in this context.
     * Note that the range from start to stop is inclusive, so for rules that do not consume anything
     * (for example, zero length or error productions) this token may precede start.
     */ get stop() {
        return this._stop;
    }
    /** Used for rule context info debugging during parse-time, not so much for ATN debugging */ toInfoString(recognizer) {
        let rules = recognizer.getRuleInvocationStack(this).reverse();
        return "ParserRuleContext" + rules + "{" + "start=" + this._start + ", stop=" + this._stop + "}";
    }
}
$1c1cc68451022b8b$var$ParserRuleContext.EMPTY = new $1c1cc68451022b8b$var$ParserRuleContext();
$1c1cc68451022b8b$var$__decorate([
    $aN41m.Override
], $1c1cc68451022b8b$var$ParserRuleContext.prototype, "parent", null);
$1c1cc68451022b8b$var$__decorate([
    $aN41m.Override
], $1c1cc68451022b8b$var$ParserRuleContext.prototype, "childCount", null);
$1c1cc68451022b8b$var$__decorate([
    $aN41m.Override
], $1c1cc68451022b8b$var$ParserRuleContext.prototype, "sourceInterval", null);
module.exports.ParserRuleContext = $1c1cc68451022b8b$var$ParserRuleContext;

});
parcelRegister("co9Xk", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $904f72f292ced1ea$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorNode = void 0;

var $aN41m = parcelRequire("aN41m");

var $2IN61 = parcelRequire("2IN61");
/** Represents a token that was consumed during resynchronization
 *  rather than during a valid match operation. For example,
 *  we will create this kind of a node during single token insertion
 *  and deletion as well as during "consume until error recovery set"
 *  upon no viable alternative exceptions.
 */ class $904f72f292ced1ea$var$ErrorNode extends $2IN61.TerminalNode {
    constructor(token){
        super(token);
    }
    accept(visitor) {
        return visitor.visitErrorNode(this);
    }
}
$904f72f292ced1ea$var$__decorate([
    $aN41m.Override
], $904f72f292ced1ea$var$ErrorNode.prototype, "accept", null);
module.exports.ErrorNode = $904f72f292ced1ea$var$ErrorNode;

});
parcelRegister("2IN61", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $1fb5c64751fbd583$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TerminalNode = void 0;

var $l8y5T = parcelRequire("l8y5T");

var $aN41m = parcelRequire("aN41m");

var $eKXi4 = parcelRequire("eKXi4");
class $1fb5c64751fbd583$var$TerminalNode {
    constructor(symbol){
        this._symbol = symbol;
    }
    getChild(i) {
        throw new RangeError("Terminal Node has no children.");
    }
    get symbol() {
        return this._symbol;
    }
    get parent() {
        return this._parent;
    }
    setParent(parent) {
        this._parent = parent;
    }
    get payload() {
        return this._symbol;
    }
    get sourceInterval() {
        let tokenIndex = this._symbol.tokenIndex;
        return new $l8y5T.Interval(tokenIndex, tokenIndex);
    }
    get childCount() {
        return 0;
    }
    accept(visitor) {
        return visitor.visitTerminal(this);
    }
    get text() {
        return this._symbol.text || "";
    }
    toStringTree(parser) {
        return this.toString();
    }
    toString() {
        if (this._symbol.type === $eKXi4.Token.EOF) return "<EOF>";
        return this._symbol.text || "";
    }
}
$1fb5c64751fbd583$var$__decorate([
    $aN41m.Override
], $1fb5c64751fbd583$var$TerminalNode.prototype, "getChild", null);
$1fb5c64751fbd583$var$__decorate([
    $aN41m.Override
], $1fb5c64751fbd583$var$TerminalNode.prototype, "parent", null);
$1fb5c64751fbd583$var$__decorate([
    $aN41m.Override
], $1fb5c64751fbd583$var$TerminalNode.prototype, "setParent", null);
$1fb5c64751fbd583$var$__decorate([
    $aN41m.Override
], $1fb5c64751fbd583$var$TerminalNode.prototype, "payload", null);
$1fb5c64751fbd583$var$__decorate([
    $aN41m.Override
], $1fb5c64751fbd583$var$TerminalNode.prototype, "sourceInterval", null);
$1fb5c64751fbd583$var$__decorate([
    $aN41m.Override
], $1fb5c64751fbd583$var$TerminalNode.prototype, "childCount", null);
$1fb5c64751fbd583$var$__decorate([
    $aN41m.Override
], $1fb5c64751fbd583$var$TerminalNode.prototype, "accept", null);
$1fb5c64751fbd583$var$__decorate([
    $aN41m.Override
], $1fb5c64751fbd583$var$TerminalNode.prototype, "text", null);
$1fb5c64751fbd583$var$__decorate([
    $aN41m.Override
], $1fb5c64751fbd583$var$TerminalNode.prototype, "toStringTree", null);
$1fb5c64751fbd583$var$__decorate([
    $aN41m.Override
], $1fb5c64751fbd583$var$TerminalNode.prototype, "toString", null);
module.exports.TerminalNode = $1fb5c64751fbd583$var$TerminalNode;

});


parcelRegister("1xO0Q", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $11ffaafc1554cb2d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleContext = void 0;

var $eeOLb = parcelRequire("eeOLb");

var $dwftT = parcelRequire("dwftT");

var $UzGvw = parcelRequire("UzGvw");

var $l8y5T = parcelRequire("l8y5T");

var $aN41m = parcelRequire("aN41m");

var $iEJpM = parcelRequire("iEJpM");

var $2pDMz = parcelRequire("2pDMz");
/** A rule context is a record of a single rule invocation.
 *
 *  We form a stack of these context objects using the parent
 *  pointer. A parent pointer of `undefined` indicates that the current
 *  context is the bottom of the stack. The ParserRuleContext subclass
 *  as a children list so that we can turn this data structure into a
 *  tree.
 *
 *  The root node always has a `undefined` pointer and invokingState of -1.
 *
 *  Upon entry to parsing, the first invoked rule function creates a
 *  context object (a subclass specialized for that rule such as
 *  SContext) and makes it the root of a parse tree, recorded by field
 *  Parser._ctx.
 *
 *  public final SContext s() throws RecognitionException {
 *      SContext _localctx = new SContext(_ctx, state); <-- create new node
 *      enterRule(_localctx, 0, RULE_s);                     <-- push it
 *      ...
 *      exitRule();                                          <-- pop back to _localctx
 *      return _localctx;
 *  }
 *
 *  A subsequent rule invocation of r from the start rule s pushes a
 *  new context object for r whose parent points at s and use invoking
 *  state is the state with r emanating as edge label.
 *
 *  The invokingState fields from a context object to the root
 *  together form a stack of rule indication states where the root
 *  (bottom of the stack) has a -1 sentinel value. If we invoke start
 *  symbol s then call r1, which calls r2, the  would look like
 *  this:
 *
 *     SContext[-1]   <- root node (bottom of the stack)
 *     R1Context[p]   <- p in rule s called r1
 *     R2Context[q]   <- q in rule r1 called r2
 *
 *  So the top of the stack, _ctx, represents a call to the current
 *  rule and it holds the return address from another rule that invoke
 *  to this rule. To invoke a rule, we must always have a current context.
 *
 *  The parent contexts are useful for computing lookahead sets and
 *  getting error information.
 *
 *  These objects are used during parsing and prediction.
 *  For the special case of parsers, we use the subclass
 *  ParserRuleContext.
 *
 *  @see ParserRuleContext
 */ class $11ffaafc1554cb2d$var$RuleContext extends $UzGvw.RuleNode {
    constructor(parent, invokingState){
        super();
        this._parent = parent;
        this.invokingState = invokingState != null ? invokingState : -1;
    }
    static getChildContext(parent, invokingState) {
        return new $11ffaafc1554cb2d$var$RuleContext(parent, invokingState);
    }
    depth() {
        let n = 0;
        let p = this;
        while(p){
            p = p._parent;
            n++;
        }
        return n;
    }
    /** A context is empty if there is no invoking state; meaning nobody called
     *  current context.
     */ get isEmpty() {
        return this.invokingState === -1;
    }
    // satisfy the ParseTree / SyntaxTree interface
    get sourceInterval() {
        return $l8y5T.Interval.INVALID;
    }
    get ruleContext() {
        return this;
    }
    get parent() {
        return this._parent;
    }
    /** @since 4.7. {@see ParseTree#setParent} comment */ setParent(parent) {
        this._parent = parent;
    }
    get payload() {
        return this;
    }
    /** Return the combined text of all child nodes. This method only considers
     *  tokens which have been added to the parse tree.
     *
     *  Since tokens on hidden channels (e.g. whitespace or comments) are not
     *  added to the parse trees, they will not appear in the output of this
     *  method.
     */ get text() {
        if (this.childCount === 0) return "";
        let builder = "";
        for(let i = 0; i < this.childCount; i++)builder += this.getChild(i).text;
        return builder.toString();
    }
    get ruleIndex() {
        return -1;
    }
    /** For rule associated with this parse tree internal node, return
     *  the outer alternative number used to match the input. Default
     *  implementation does not compute nor store this alt num. Create
     *  a subclass of ParserRuleContext with backing field and set
     *  option contextSuperClass.
     *  to set it.
     *
     *  @since 4.5.3
     */ get altNumber() {
        return $eeOLb.ATN.INVALID_ALT_NUMBER;
    }
    /** Set the outer alternative number for this context node. Default
     *  implementation does nothing to avoid backing field overhead for
     *  trees that don't need it.  Create
     *  a subclass of ParserRuleContext with backing field and set
     *  option contextSuperClass.
     *
     *  @since 4.5.3
     */ set altNumber(altNumber) {
    // intentionally ignored by the base implementation
    }
    getChild(i) {
        throw new RangeError("i must be greater than or equal to 0 and less than childCount");
    }
    get childCount() {
        return 0;
    }
    accept(visitor) {
        return visitor.visitChildren(this);
    }
    toStringTree(recog) {
        return $iEJpM.Trees.toStringTree(this, recog);
    }
    toString(arg1, stop) {
        const ruleNames = arg1 instanceof $dwftT.Recognizer ? arg1.ruleNames : arg1;
        stop = stop || $2pDMz.ParserRuleContext.emptyContext();
        let buf = "";
        let p = this;
        buf += "[";
        while(p && p !== stop){
            if (!ruleNames) {
                if (!p.isEmpty) buf += p.invokingState;
            } else {
                let ruleIndex = p.ruleIndex;
                let ruleName = ruleIndex >= 0 && ruleIndex < ruleNames.length ? ruleNames[ruleIndex] : ruleIndex.toString();
                buf += ruleName;
            }
            if (p._parent && (ruleNames || !p._parent.isEmpty)) buf += " ";
            p = p._parent;
        }
        buf += "]";
        return buf.toString();
    }
}
$11ffaafc1554cb2d$var$__decorate([
    $aN41m.Override
], $11ffaafc1554cb2d$var$RuleContext.prototype, "sourceInterval", null);
$11ffaafc1554cb2d$var$__decorate([
    $aN41m.Override
], $11ffaafc1554cb2d$var$RuleContext.prototype, "ruleContext", null);
$11ffaafc1554cb2d$var$__decorate([
    $aN41m.Override
], $11ffaafc1554cb2d$var$RuleContext.prototype, "parent", null);
$11ffaafc1554cb2d$var$__decorate([
    $aN41m.Override
], $11ffaafc1554cb2d$var$RuleContext.prototype, "setParent", null);
$11ffaafc1554cb2d$var$__decorate([
    $aN41m.Override
], $11ffaafc1554cb2d$var$RuleContext.prototype, "payload", null);
$11ffaafc1554cb2d$var$__decorate([
    $aN41m.Override
], $11ffaafc1554cb2d$var$RuleContext.prototype, "text", null);
$11ffaafc1554cb2d$var$__decorate([
    $aN41m.Override
], $11ffaafc1554cb2d$var$RuleContext.prototype, "getChild", null);
$11ffaafc1554cb2d$var$__decorate([
    $aN41m.Override
], $11ffaafc1554cb2d$var$RuleContext.prototype, "childCount", null);
$11ffaafc1554cb2d$var$__decorate([
    $aN41m.Override
], $11ffaafc1554cb2d$var$RuleContext.prototype, "accept", null);
$11ffaafc1554cb2d$var$__decorate([
    $aN41m.Override
], $11ffaafc1554cb2d$var$RuleContext.prototype, "toStringTree", null);
module.exports.RuleContext = $11ffaafc1554cb2d$var$RuleContext;

});
parcelRegister("UzGvw", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleNode = void 0;
class $0aa0e94bd9481018$var$RuleNode {
}
module.exports.RuleNode = $0aa0e94bd9481018$var$RuleNode;

});

parcelRegister("iEJpM", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d94f30dcc5121681$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d94f30dcc5121681$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Trees = void 0;

var $eeOLb = parcelRequire("eeOLb");

var $exlin = parcelRequire("exlin");

var $co9Xk = parcelRequire("co9Xk");

var $aN41m = parcelRequire("aN41m");

var $c9Sjf = parcelRequire("c9Sjf");

var $2pDMz = parcelRequire("2pDMz");

var $UzGvw = parcelRequire("UzGvw");

var $2IN61 = parcelRequire("2IN61");

var $eKXi4 = parcelRequire("eKXi4");

var $62Uvn = parcelRequire("62Uvn");
/** A set of utility routines useful for all kinds of ANTLR trees. */ class $d94f30dcc5121681$var$Trees {
    static toStringTree(t, arg2) {
        let ruleNames;
        if (arg2 instanceof $c9Sjf.Parser) ruleNames = arg2.ruleNames;
        else ruleNames = arg2;
        let s = $62Uvn.escapeWhitespace(this.getNodeText(t, ruleNames), false);
        if (t.childCount === 0) return s;
        let buf = "";
        buf += "(";
        s = $62Uvn.escapeWhitespace(this.getNodeText(t, ruleNames), false);
        buf += s;
        buf += " ";
        for(let i = 0; i < t.childCount; i++){
            if (i > 0) buf += " ";
            buf += this.toStringTree(t.getChild(i), ruleNames);
        }
        buf += ")";
        return buf;
    }
    static getNodeText(t, arg2) {
        let ruleNames;
        if (arg2 instanceof $c9Sjf.Parser) ruleNames = arg2.ruleNames;
        else if (arg2) ruleNames = arg2;
        else {
            // no recog or rule names
            let payload = t.payload;
            if (typeof payload.text === "string") return payload.text;
            return t.payload.toString();
        }
        if (t instanceof $UzGvw.RuleNode) {
            let ruleContext = t.ruleContext;
            let ruleIndex = ruleContext.ruleIndex;
            let ruleName = ruleNames[ruleIndex];
            let altNumber = ruleContext.altNumber;
            if (altNumber !== $eeOLb.ATN.INVALID_ALT_NUMBER) return ruleName + ":" + altNumber;
            return ruleName;
        } else if (t instanceof $co9Xk.ErrorNode) return t.toString();
        else if (t instanceof $2IN61.TerminalNode) {
            let symbol = t.symbol;
            return symbol.text || "";
        }
        throw new TypeError("Unexpected node type");
    }
    static getChildren(t) {
        let kids = [];
        for(let i = 0; i < t.childCount; i++)kids.push(t.getChild(i));
        return kids;
    }
    static getAncestors(t) {
        let ancestors = [];
        let p = t.parent;
        while(p){
            ancestors.unshift(p); // insert at start
            p = p.parent;
        }
        return ancestors;
    }
    /** Return true if t is u's parent or a node on path to root from u.
     *  Use === not equals().
     *
     *  @since 4.5.1
     */ static isAncestorOf(t, u) {
        if (!t || !u || !t.parent) return false;
        let p = u.parent;
        while(p){
            if (t === p) return true;
            p = p.parent;
        }
        return false;
    }
    static findAllTokenNodes(t, ttype) {
        return $d94f30dcc5121681$var$Trees.findAllNodes(t, ttype, true);
    }
    static findAllRuleNodes(t, ruleIndex) {
        return $d94f30dcc5121681$var$Trees.findAllNodes(t, ruleIndex, false);
    }
    static findAllNodes(t, index, findTokens) {
        let nodes = [];
        $d94f30dcc5121681$var$Trees._findAllNodes(t, index, findTokens, nodes);
        return nodes;
    }
    static _findAllNodes(t, index, findTokens, nodes) {
        // check this node (the root) first
        if (findTokens && t instanceof $2IN61.TerminalNode) {
            if (t.symbol.type === index) nodes.push(t);
        } else if (!findTokens && t instanceof $2pDMz.ParserRuleContext) {
            if (t.ruleIndex === index) nodes.push(t);
        }
        // check children
        for(let i = 0; i < t.childCount; i++)$d94f30dcc5121681$var$Trees._findAllNodes(t.getChild(i), index, findTokens, nodes);
    }
    /** Get all descendents; includes t itself.
     *
     * @since 4.5.1
     */ static getDescendants(t) {
        let nodes = [];
        function recurse(e) {
            nodes.push(e);
            const n = e.childCount;
            for(let i = 0; i < n; i++)recurse(e.getChild(i));
        }
        recurse(t);
        return nodes;
    }
    /** Find smallest subtree of t enclosing range startTokenIndex..stopTokenIndex
     *  inclusively using postorder traversal.  Recursive depth-first-search.
     *
     *  @since 4.5
     */ static getRootOfSubtreeEnclosingRegion(t, startTokenIndex, stopTokenIndex) {
        let n = t.childCount;
        for(let i = 0; i < n; i++){
            let child = t.getChild(i);
            let r = $d94f30dcc5121681$var$Trees.getRootOfSubtreeEnclosingRegion(child, startTokenIndex, stopTokenIndex);
            if (r) return r;
        }
        if (t instanceof $2pDMz.ParserRuleContext) {
            let stopToken = t.stop;
            if (startTokenIndex >= t.start.tokenIndex && // is range fully contained in t?
            (stopToken == null || stopTokenIndex <= stopToken.tokenIndex)) // note: r.stop==null likely implies that we bailed out of parser and there's nothing to the right
            return t;
        }
        return undefined;
    }
    /** Replace any subtree siblings of root that are completely to left
     *  or right of lookahead range with a CommonToken(Token.INVALID_TYPE,"...")
     *  node. The source interval for t is not altered to suit smaller range!
     *
     *  WARNING: destructive to t.
     *
     *  @since 4.5.1
     */ static stripChildrenOutOfRange(t, root, startIndex, stopIndex) {
        if (!t) return;
        let count = t.childCount;
        for(let i = 0; i < count; i++){
            let child = t.getChild(i);
            let range = child.sourceInterval;
            if (child instanceof $2pDMz.ParserRuleContext && (range.b < startIndex || range.a > stopIndex)) {
                if ($d94f30dcc5121681$var$Trees.isAncestorOf(child, root)) {
                    let abbrev = new $exlin.CommonToken($eKXi4.Token.INVALID_TYPE, "...");
                    t.children[i] = new $2IN61.TerminalNode(abbrev); // HACK access to private
                }
            }
        }
    }
    static findNodeSuchThat(t, pred) {
        // No type check needed as long as users only use one of the available overloads
        if (pred(t)) return t;
        let n = t.childCount;
        for(let i = 0; i < n; i++){
            let u = $d94f30dcc5121681$var$Trees.findNodeSuchThat(t.getChild(i), pred);
            if (u !== undefined) return u;
        }
        return undefined;
    }
}
$d94f30dcc5121681$var$__decorate([
    $d94f30dcc5121681$var$__param(0, $aN41m.NotNull)
], $d94f30dcc5121681$var$Trees, "toStringTree", null);
$d94f30dcc5121681$var$__decorate([
    $aN41m.NotNull,
    $d94f30dcc5121681$var$__param(0, $aN41m.NotNull)
], $d94f30dcc5121681$var$Trees, "getAncestors", null);
$d94f30dcc5121681$var$__decorate([
    $d94f30dcc5121681$var$__param(0, $aN41m.NotNull)
], $d94f30dcc5121681$var$Trees, "getRootOfSubtreeEnclosingRegion", null);
module.exports.Trees = $d94f30dcc5121681$var$Trees;

});



parcelRegister("hwoBE", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $cc18831aaf00aa66$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PredictionMode = void 0;

var $jRlcM = parcelRequire("jRlcM");

var $amQx9 = parcelRequire("amQx9");

var $aN41m = parcelRequire("aN41m");

var $jWsYN = parcelRequire("jWsYN");
/**
 * This enumeration defines the prediction modes available in ANTLR 4 along with
 * utility methods for analyzing configuration sets for conflicts and/or
 * ambiguities.
 */ var $cc18831aaf00aa66$var$PredictionMode;
(function(PredictionMode) {
    /**
     * The SLL(*) prediction mode. This prediction mode ignores the current
     * parser context when making predictions. This is the fastest prediction
     * mode, and provides correct results for many grammars. This prediction
     * mode is more powerful than the prediction mode provided by ANTLR 3, but
     * may result in syntax errors for grammar and input combinations which are
     * not SLL.
     *
     * When using this prediction mode, the parser will either return a correct
     * parse tree (i.e. the same parse tree that would be returned with the
     * {@link #LL} prediction mode), or it will report a syntax error. If a
     * syntax error is encountered when using the {@link #SLL} prediction mode,
     * it may be due to either an actual syntax error in the input or indicate
     * that the particular combination of grammar and input requires the more
     * powerful {@link #LL} prediction abilities to complete successfully.
     *
     * This prediction mode does not provide any guarantees for prediction
     * behavior for syntactically-incorrect inputs.
     */ PredictionMode[PredictionMode["SLL"] = 0] = "SLL";
    /**
     * The LL(*) prediction mode. This prediction mode allows the current parser
     * context to be used for resolving SLL conflicts that occur during
     * prediction. This is the fastest prediction mode that guarantees correct
     * parse results for all combinations of grammars with syntactically correct
     * inputs.
     *
     * When using this prediction mode, the parser will make correct decisions
     * for all syntactically-correct grammar and input combinations. However, in
     * cases where the grammar is truly ambiguous this prediction mode might not
     * report a precise answer for *exactly which* alternatives are
     * ambiguous.
     *
     * This prediction mode does not provide any guarantees for prediction
     * behavior for syntactically-incorrect inputs.
     */ PredictionMode[PredictionMode["LL"] = 1] = "LL";
    /**
     * The LL(*) prediction mode with exact ambiguity detection. In addition to
     * the correctness guarantees provided by the {@link #LL} prediction mode,
     * this prediction mode instructs the prediction algorithm to determine the
     * complete and exact set of ambiguous alternatives for every ambiguous
     * decision encountered while parsing.
     *
     * This prediction mode may be used for diagnosing ambiguities during
     * grammar development. Due to the performance overhead of calculating sets
     * of ambiguous alternatives, this prediction mode should be avoided when
     * the exact results are not necessary.
     *
     * This prediction mode does not provide any guarantees for prediction
     * behavior for syntactically-incorrect inputs.
     */ PredictionMode[PredictionMode["LL_EXACT_AMBIG_DETECTION"] = 2] = "LL_EXACT_AMBIG_DETECTION";
})($cc18831aaf00aa66$var$PredictionMode = module.exports.PredictionMode || (module.exports.PredictionMode = {}));
(function(PredictionMode) {
    /** A Map that uses just the state and the stack context as the key. */ // NOTE: Base type used to be FlexibleHashMap<ATNConfig, BitSet>
    class AltAndContextMap extends $jRlcM.Array2DHashMap {
        constructor(){
            super(AltAndContextConfigEqualityComparator.INSTANCE);
        }
    }
    class AltAndContextConfigEqualityComparator {
        AltAndContextConfigEqualityComparator() {
        // intentionally empty
        }
        /**
         * The hash code is only a function of the {@link ATNState#stateNumber}
         * and {@link ATNConfig#context}.
         */ hashCode(o) {
            let hashCode = $amQx9.MurmurHash.initialize(7);
            hashCode = $amQx9.MurmurHash.update(hashCode, o.state.stateNumber);
            hashCode = $amQx9.MurmurHash.update(hashCode, o.context);
            hashCode = $amQx9.MurmurHash.finish(hashCode, 2);
            return hashCode;
        }
        equals(a, b) {
            if (a === b) return true;
            if (a == null || b == null) return false;
            return a.state.stateNumber === b.state.stateNumber && a.context.equals(b.context);
        }
    }
    AltAndContextConfigEqualityComparator.INSTANCE = new AltAndContextConfigEqualityComparator();
    $cc18831aaf00aa66$var$__decorate([
        $aN41m.Override
    ], AltAndContextConfigEqualityComparator.prototype, "hashCode", null);
    $cc18831aaf00aa66$var$__decorate([
        $aN41m.Override
    ], AltAndContextConfigEqualityComparator.prototype, "equals", null);
    /**
     * Checks if any configuration in `configs` is in a
     * {@link RuleStopState}. Configurations meeting this condition have reached
     * the end of the decision rule (local context) or end of start rule (full
     * context).
     *
     * @param configs the configuration set to test
     * @returns `true` if any configuration in `configs` is in a
     * {@link RuleStopState}, otherwise `false`
     */ function hasConfigInRuleStopState(configs) {
        for (let c of configs){
            if (c.state instanceof $jWsYN.RuleStopState) return true;
        }
        return false;
    }
    PredictionMode.hasConfigInRuleStopState = hasConfigInRuleStopState;
    /**
     * Checks if all configurations in `configs` are in a
     * {@link RuleStopState}. Configurations meeting this condition have reached
     * the end of the decision rule (local context) or end of start rule (full
     * context).
     *
     * @param configs the configuration set to test
     * @returns `true` if all configurations in `configs` are in a
     * {@link RuleStopState}, otherwise `false`
     */ function allConfigsInRuleStopStates(/*@NotNull*/ configs) {
        for (let config of configs){
            if (!(config.state instanceof $jWsYN.RuleStopState)) return false;
        }
        return true;
    }
    PredictionMode.allConfigsInRuleStopStates = allConfigsInRuleStopStates;
})($cc18831aaf00aa66$var$PredictionMode = module.exports.PredictionMode || (module.exports.PredictionMode = {}));

});

parcelRegister("eDtKk", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $aa7bc8301b4366a9$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $aa7bc8301b4366a9$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SimulatorState = void 0;

var $aN41m = parcelRequire("aN41m");

var $2pDMz = parcelRequire("2pDMz");
/**
 *
 * @author Sam Harwell
 */ let $aa7bc8301b4366a9$var$SimulatorState = class SimulatorState {
    constructor(outerContext, s0, useContext, remainingOuterContext){
        this.outerContext = outerContext != null ? outerContext : $2pDMz.ParserRuleContext.emptyContext();
        this.s0 = s0;
        this.useContext = useContext;
        this.remainingOuterContext = remainingOuterContext;
    }
};
$aa7bc8301b4366a9$var$SimulatorState = $aa7bc8301b4366a9$var$__decorate([
    $aa7bc8301b4366a9$var$__param(1, $aN41m.NotNull)
], $aa7bc8301b4366a9$var$SimulatorState);
module.exports.SimulatorState = $aa7bc8301b4366a9$var$SimulatorState;

});


parcelRegister("pC9Ki", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $04cfeef02e935189$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PlusBlockStartState = void 0;

var $fZESB = parcelRequire("fZESB");

var $jizfq = parcelRequire("jizfq");

var $aN41m = parcelRequire("aN41m");
/** Start of `(A|B|...)+` loop. Technically a decision state, but
 *  we don't use for code generation; somebody might need it, so I'm defining
 *  it for completeness. In reality, the {@link PlusLoopbackState} node is the
 *  real decision-making note for `A+`.
 */ class $04cfeef02e935189$var$PlusBlockStartState extends $jizfq.BlockStartState {
    get stateType() {
        return $fZESB.ATNStateType.PLUS_BLOCK_START;
    }
}
$04cfeef02e935189$var$__decorate([
    $aN41m.Override
], $04cfeef02e935189$var$PlusBlockStartState.prototype, "stateType", null);
module.exports.PlusBlockStartState = $04cfeef02e935189$var$PlusBlockStartState;

});

parcelRegister("a84wo", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $75fe289bbbae0de7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PlusLoopbackState = void 0;

var $fZESB = parcelRequire("fZESB");

var $42ptv = parcelRequire("42ptv");

var $aN41m = parcelRequire("aN41m");
/** Decision state for `A+` and `(A|B)+`.  It has two transitions:
 *  one to the loop back to start of the block and one to exit.
 */ class $75fe289bbbae0de7$var$PlusLoopbackState extends $42ptv.DecisionState {
    get stateType() {
        return $fZESB.ATNStateType.PLUS_LOOP_BACK;
    }
}
$75fe289bbbae0de7$var$__decorate([
    $aN41m.Override
], $75fe289bbbae0de7$var$PlusLoopbackState.prototype, "stateType", null);
module.exports.PlusLoopbackState = $75fe289bbbae0de7$var$PlusLoopbackState;

});

parcelRegister("kIrC4", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f14d5618acbd1a12$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f14d5618acbd1a12$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PrecedencePredicateTransition = void 0;

var $kvmNv = parcelRequire("kvmNv");

var $aN41m = parcelRequire("aN41m");

var $3JS45 = parcelRequire("3JS45");
/**
 *
 * @author Sam Harwell
 */ let $f14d5618acbd1a12$var$PrecedencePredicateTransition = class PrecedencePredicateTransition extends $kvmNv.AbstractPredicateTransition {
    constructor(target, precedence){
        super(target);
        this.precedence = precedence;
    }
    get serializationType() {
        return 10 /* PRECEDENCE */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    get predicate() {
        return new $3JS45.SemanticContext.PrecedencePredicate(this.precedence);
    }
    toString() {
        return this.precedence + " >= _p";
    }
};
$f14d5618acbd1a12$var$__decorate([
    $aN41m.Override
], $f14d5618acbd1a12$var$PrecedencePredicateTransition.prototype, "serializationType", null);
$f14d5618acbd1a12$var$__decorate([
    $aN41m.Override
], $f14d5618acbd1a12$var$PrecedencePredicateTransition.prototype, "isEpsilon", null);
$f14d5618acbd1a12$var$__decorate([
    $aN41m.Override
], $f14d5618acbd1a12$var$PrecedencePredicateTransition.prototype, "matches", null);
$f14d5618acbd1a12$var$__decorate([
    $aN41m.Override
], $f14d5618acbd1a12$var$PrecedencePredicateTransition.prototype, "toString", null);
$f14d5618acbd1a12$var$PrecedencePredicateTransition = $f14d5618acbd1a12$var$__decorate([
    $f14d5618acbd1a12$var$__param(0, $aN41m.NotNull)
], $f14d5618acbd1a12$var$PrecedencePredicateTransition);
module.exports.PrecedencePredicateTransition = $f14d5618acbd1a12$var$PrecedencePredicateTransition;

});

parcelRegister("6WqDl", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $50dcd1b7595942de$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $50dcd1b7595942de$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RangeTransition = void 0;

var $6kdz0 = parcelRequire("6kdz0");

var $aN41m = parcelRequire("aN41m");

var $5NWCj = parcelRequire("5NWCj");
let $50dcd1b7595942de$var$RangeTransition = class RangeTransition extends $5NWCj.Transition {
    constructor(target, from, to){
        super(target);
        this.from = from;
        this.to = to;
    }
    get serializationType() {
        return 2 /* RANGE */ ;
    }
    get label() {
        return $6kdz0.IntervalSet.of(this.from, this.to);
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return symbol >= this.from && symbol <= this.to;
    }
    toString() {
        return "'" + String.fromCodePoint(this.from) + "'..'" + String.fromCodePoint(this.to) + "'";
    }
};
$50dcd1b7595942de$var$__decorate([
    $aN41m.Override
], $50dcd1b7595942de$var$RangeTransition.prototype, "serializationType", null);
$50dcd1b7595942de$var$__decorate([
    $aN41m.Override,
    $aN41m.NotNull
], $50dcd1b7595942de$var$RangeTransition.prototype, "label", null);
$50dcd1b7595942de$var$__decorate([
    $aN41m.Override
], $50dcd1b7595942de$var$RangeTransition.prototype, "matches", null);
$50dcd1b7595942de$var$__decorate([
    $aN41m.Override,
    $aN41m.NotNull
], $50dcd1b7595942de$var$RangeTransition.prototype, "toString", null);
$50dcd1b7595942de$var$RangeTransition = $50dcd1b7595942de$var$__decorate([
    $50dcd1b7595942de$var$__param(0, $aN41m.NotNull)
], $50dcd1b7595942de$var$RangeTransition);
module.exports.RangeTransition = $50dcd1b7595942de$var$RangeTransition;

});

parcelRegister("UvARH", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $0a9dbce885ceff1c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleStartState = void 0;

var $dv9vN = parcelRequire("dv9vN");

var $fZESB = parcelRequire("fZESB");

var $aN41m = parcelRequire("aN41m");
class $0a9dbce885ceff1c$var$RuleStartState extends $dv9vN.ATNState {
    constructor(){
        super(...arguments);
        this.isPrecedenceRule = false;
        this.leftFactored = false;
    }
    get stateType() {
        return $fZESB.ATNStateType.RULE_START;
    }
}
$0a9dbce885ceff1c$var$__decorate([
    $aN41m.Override
], $0a9dbce885ceff1c$var$RuleStartState.prototype, "stateType", null);
module.exports.RuleStartState = $0a9dbce885ceff1c$var$RuleStartState;

});

parcelRegister("ferBg", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $b16d929992a0672d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StarBlockStartState = void 0;

var $fZESB = parcelRequire("fZESB");

var $jizfq = parcelRequire("jizfq");

var $aN41m = parcelRequire("aN41m");
/** The block that begins a closure loop. */ class $b16d929992a0672d$var$StarBlockStartState extends $jizfq.BlockStartState {
    get stateType() {
        return $fZESB.ATNStateType.STAR_BLOCK_START;
    }
}
$b16d929992a0672d$var$__decorate([
    $aN41m.Override
], $b16d929992a0672d$var$StarBlockStartState.prototype, "stateType", null);
module.exports.StarBlockStartState = $b16d929992a0672d$var$StarBlockStartState;

});

parcelRegister("9kZdU", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $6cc579002aad9995$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StarLoopbackState = void 0;

var $dv9vN = parcelRequire("dv9vN");

var $fZESB = parcelRequire("fZESB");

var $aN41m = parcelRequire("aN41m");
class $6cc579002aad9995$var$StarLoopbackState extends $dv9vN.ATNState {
    get loopEntryState() {
        return this.transition(0).target;
    }
    get stateType() {
        return $fZESB.ATNStateType.STAR_LOOP_BACK;
    }
}
$6cc579002aad9995$var$__decorate([
    $aN41m.Override
], $6cc579002aad9995$var$StarLoopbackState.prototype, "stateType", null);
module.exports.StarLoopbackState = $6cc579002aad9995$var$StarLoopbackState;

});

parcelRegister("J9RdB", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $087bd98cf80f5dfc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TokensStartState = void 0;

var $fZESB = parcelRequire("fZESB");

var $42ptv = parcelRequire("42ptv");

var $aN41m = parcelRequire("aN41m");
/** The Tokens rule start state linking to each lexer rule start state */ class $087bd98cf80f5dfc$var$TokensStartState extends $42ptv.DecisionState {
    get stateType() {
        return $fZESB.ATNStateType.TOKEN_START;
    }
}
$087bd98cf80f5dfc$var$__decorate([
    $aN41m.Override
], $087bd98cf80f5dfc$var$TokensStartState.prototype, "stateType", null);
module.exports.TokensStartState = $087bd98cf80f5dfc$var$TokensStartState;

});

parcelRegister("f0PQ3", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UUID = void 0;

var $amQx9 = parcelRequire("amQx9");
class $02d20ca9e1d240ed$var$UUID {
    constructor(mostSigBits, moreSigBits, lessSigBits, leastSigBits){
        this.data = new Uint32Array(4);
        this.data[0] = mostSigBits;
        this.data[1] = moreSigBits;
        this.data[2] = lessSigBits;
        this.data[3] = leastSigBits;
    }
    static fromString(data) {
        if (!/^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/.test(data)) throw new Error("Incorrectly formatted UUID");
        let segments = data.split("-");
        let mostSigBits = parseInt(segments[0], 16);
        let moreSigBits = (parseInt(segments[1], 16) << 16 >>> 0) + parseInt(segments[2], 16);
        let lessSigBits = (parseInt(segments[3], 16) << 16 >>> 0) + parseInt(segments[4].substr(0, 4), 16);
        let leastSigBits = parseInt(segments[4].substr(-8), 16);
        return new $02d20ca9e1d240ed$var$UUID(mostSigBits, moreSigBits, lessSigBits, leastSigBits);
    }
    hashCode() {
        return $amQx9.MurmurHash.hashCode([
            this.data[0],
            this.data[1],
            this.data[2],
            this.data[3]
        ]);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $02d20ca9e1d240ed$var$UUID)) return false;
        return this.data[0] === obj.data[0] && this.data[1] === obj.data[1] && this.data[2] === obj.data[2] && this.data[3] === obj.data[3];
    }
    toString() {
        return ("00000000" + this.data[0].toString(16)).substr(-8) + "-" + ("0000" + (this.data[1] >>> 16).toString(16)).substr(-4) + "-" + ("0000" + this.data[1].toString(16)).substr(-4) + "-" + ("0000" + (this.data[2] >>> 16).toString(16)).substr(-4) + "-" + ("0000" + this.data[2].toString(16)).substr(-4) + ("00000000" + this.data[3].toString(16)).substr(-8);
    }
}
module.exports.UUID = $02d20ca9e1d240ed$var$UUID;

});


parcelRegister("8EOCV", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $64d95490c532b14b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $64d95490c532b14b$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParseInfo = void 0;

var $aN41m = parcelRequire("aN41m");
/**
 * This class provides access to specific and aggregate statistics gathered
 * during profiling of a parser.
 *
 * @since 4.3
 */ let $64d95490c532b14b$var$ParseInfo = class ParseInfo {
    constructor(atnSimulator){
        this.atnSimulator = atnSimulator;
    }
    /**
     * Gets an array of {@link DecisionInfo} instances containing the profiling
     * information gathered for each decision in the ATN.
     *
     * @returns An array of {@link DecisionInfo} instances, indexed by decision
     * number.
     */ getDecisionInfo() {
        return this.atnSimulator.getDecisionInfo();
    }
    /**
     * Gets the decision numbers for decisions that required one or more
     * full-context predictions during parsing. These are decisions for which
     * {@link DecisionInfo#LL_Fallback} is non-zero.
     *
     * @returns A list of decision numbers which required one or more
     * full-context predictions during parsing.
     */ getLLDecisions() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let LL = [];
        for(let i = 0; i < decisions.length; i++){
            let fallBack = decisions[i].LL_Fallback;
            if (fallBack > 0) LL.push(i);
        }
        return LL;
    }
    /**
     * Gets the total time spent during prediction across all decisions made
     * during parsing. This value is the sum of
     * {@link DecisionInfo#timeInPrediction} for all decisions.
     */ getTotalTimeInPrediction() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let t = 0;
        for (let decision of decisions)t += decision.timeInPrediction;
        return t;
    }
    /**
     * Gets the total number of SLL lookahead operations across all decisions
     * made during parsing. This value is the sum of
     * {@link DecisionInfo#SLL_TotalLook} for all decisions.
     */ getTotalSLLLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.SLL_TotalLook;
        return k;
    }
    /**
     * Gets the total number of LL lookahead operations across all decisions
     * made during parsing. This value is the sum of
     * {@link DecisionInfo#LL_TotalLook} for all decisions.
     */ getTotalLLLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.LL_TotalLook;
        return k;
    }
    /**
     * Gets the total number of ATN lookahead operations for SLL prediction
     * across all decisions made during parsing.
     */ getTotalSLLATNLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.SLL_ATNTransitions;
        return k;
    }
    /**
     * Gets the total number of ATN lookahead operations for LL prediction
     * across all decisions made during parsing.
     */ getTotalLLATNLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.LL_ATNTransitions;
        return k;
    }
    /**
     * Gets the total number of ATN lookahead operations for SLL and LL
     * prediction across all decisions made during parsing.
     *
     * This value is the sum of {@link #getTotalSLLATNLookaheadOps} and
     * {@link #getTotalLLATNLookaheadOps}.
     */ getTotalATNLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions){
            k += decision.SLL_ATNTransitions;
            k += decision.LL_ATNTransitions;
        }
        return k;
    }
    getDFASize(decision) {
        if (decision) {
            let decisionToDFA = this.atnSimulator.atn.decisionToDFA[decision];
            return decisionToDFA.states.size;
        } else {
            let n = 0;
            let decisionToDFA = this.atnSimulator.atn.decisionToDFA;
            for(let i = 0; i < decisionToDFA.length; i++)n += this.getDFASize(i);
            return n;
        }
    }
};
$64d95490c532b14b$var$__decorate([
    $aN41m.NotNull
], $64d95490c532b14b$var$ParseInfo.prototype, "getDecisionInfo", null);
$64d95490c532b14b$var$__decorate([
    $aN41m.NotNull
], $64d95490c532b14b$var$ParseInfo.prototype, "getLLDecisions", null);
$64d95490c532b14b$var$ParseInfo = $64d95490c532b14b$var$__decorate([
    $64d95490c532b14b$var$__param(0, $aN41m.NotNull)
], $64d95490c532b14b$var$ParseInfo);
module.exports.ParseInfo = $64d95490c532b14b$var$ParseInfo;

});

parcelRegister("jdbdJ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $dfc7ef60d4f1d1dc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProxyParserErrorListener = void 0;

var $3Wiwr = parcelRequire("3Wiwr");

var $aN41m = parcelRequire("aN41m");
/**
 * @author Sam Harwell
 */ class $dfc7ef60d4f1d1dc$var$ProxyParserErrorListener extends $3Wiwr.ProxyErrorListener {
    constructor(delegates){
        super(delegates);
    }
    reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs) {
        this.getDelegates().forEach((listener)=>{
            if (listener.reportAmbiguity) listener.reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs);
        });
    }
    reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState) {
        this.getDelegates().forEach((listener)=>{
            if (listener.reportAttemptingFullContext) listener.reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState);
        });
    }
    reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState) {
        this.getDelegates().forEach((listener)=>{
            if (listener.reportContextSensitivity) listener.reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState);
        });
    }
}
$dfc7ef60d4f1d1dc$var$__decorate([
    $aN41m.Override
], $dfc7ef60d4f1d1dc$var$ProxyParserErrorListener.prototype, "reportAmbiguity", null);
$dfc7ef60d4f1d1dc$var$__decorate([
    $aN41m.Override
], $dfc7ef60d4f1d1dc$var$ProxyParserErrorListener.prototype, "reportAttemptingFullContext", null);
$dfc7ef60d4f1d1dc$var$__decorate([
    $aN41m.Override
], $dfc7ef60d4f1d1dc$var$ProxyParserErrorListener.prototype, "reportContextSensitivity", null);
module.exports.ProxyParserErrorListener = $dfc7ef60d4f1d1dc$var$ProxyParserErrorListener;

});

parcelRegister("3O23h", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('iWnPX');
        const value = parcelRequire('kU89k');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("iWnPX").then(()=>parcelRequire('kU89k'));
}

});

parcelRegister("fEJhT", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('6JQOE');
        const value = parcelRequire('aVl0f');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("6JQOE").then(()=>parcelRequire('aVl0f'));
}

});




parcelRegister("hXb5J", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParseCancellationException = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:42.5447085-07:00
/**
 * This exception is thrown to cancel a parsing operation. This exception does
 * not extend {@link RecognitionException}, allowing it to bypass the standard
 * error recovery mechanisms. {@link BailErrorStrategy} throws this exception in
 * response to a parse error.
 *
 * @author Sam Harwell
 */ class $d1208ce2fa370cab$var$ParseCancellationException extends Error {
    constructor(cause){
        super(cause.message);
        this.cause = cause;
        this.stack = cause.stack;
    }
    getCause() {
        return this.cause;
    }
}
module.exports.ParseCancellationException = $d1208ce2fa370cab$var$ParseCancellationException;

});


parcelRegister("doEv1", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9c0cee8efd4f75ec$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $9c0cee8efd4f75ec$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BufferedTokenStream = void 0;

var $fomfP = parcelRequire("fomfP");

var $exlin = parcelRequire("exlin");

var $l8y5T = parcelRequire("l8y5T");

var $h7Q3L = parcelRequire("h7Q3L");

var $aN41m = parcelRequire("aN41m");

var $eKXi4 = parcelRequire("eKXi4");
/**
 * This implementation of {@link TokenStream} loads tokens from a
 * {@link TokenSource} on-demand, and places the tokens in a buffer to provide
 * access to any previous token by index.
 *
 * This token stream ignores the value of {@link Token#getChannel}. If your
 * parser requires the token stream filter tokens to only those on a particular
 * channel, such as {@link Token#DEFAULT_CHANNEL} or
 * {@link Token#HIDDEN_CHANNEL}, use a filtering token stream such a
 * {@link CommonTokenStream}.
 */ let $9c0cee8efd4f75ec$var$BufferedTokenStream = class BufferedTokenStream {
    constructor(tokenSource){
        /**
         * A collection of all tokens fetched from the token source. The list is
         * considered a complete view of the input once {@link #fetchedEOF} is set
         * to `true`.
         */ this.tokens = [];
        /**
         * The index into {@link #tokens} of the current token (next token to
         * {@link #consume}). {@link #tokens}`[`{@link #p}`]` should be
         * {@link #LT LT(1)}.
         *
         * This field is set to -1 when the stream is first constructed or when
         * {@link #setTokenSource} is called, indicating that the first token has
         * not yet been fetched from the token source. For additional information,
         * see the documentation of {@link IntStream} for a description of
         * Initializing Methods.
         */ this.p = -1;
        /**
         * Indicates whether the {@link Token#EOF} token has been fetched from
         * {@link #tokenSource} and added to {@link #tokens}. This field improves
         * performance for the following cases:
         *
         * * {@link #consume}: The lookahead check in {@link #consume} to prevent
         *   consuming the EOF symbol is optimized by checking the values of
         *   {@link #fetchedEOF} and {@link #p} instead of calling {@link #LA}.
         * * {@link #fetch}: The check to prevent adding multiple EOF symbols into
         *   {@link #tokens} is trivial with this field.
         */ this.fetchedEOF = false;
        if (tokenSource == null) throw new Error("tokenSource cannot be null");
        this._tokenSource = tokenSource;
    }
    get tokenSource() {
        return this._tokenSource;
    }
    /** Reset this token stream by setting its token source. */ set tokenSource(tokenSource) {
        this._tokenSource = tokenSource;
        this.tokens.length = 0;
        this.p = -1;
        this.fetchedEOF = false;
    }
    get index() {
        return this.p;
    }
    mark() {
        return 0;
    }
    release(marker) {
    // no resources to release
    }
    seek(index) {
        this.lazyInit();
        this.p = this.adjustSeekIndex(index);
    }
    get size() {
        return this.tokens.length;
    }
    consume() {
        let skipEofCheck;
        if (this.p >= 0) {
            if (this.fetchedEOF) // the last token in tokens is EOF. skip check if p indexes any
            // fetched token except the last.
            skipEofCheck = this.p < this.tokens.length - 1;
            else // no EOF token in tokens. skip check if p indexes a fetched token.
            skipEofCheck = this.p < this.tokens.length;
        } else // not yet initialized
        skipEofCheck = false;
        if (!skipEofCheck && this.LA(1) === $eKXi4.Token.EOF) throw new Error("cannot consume EOF");
        if (this.sync(this.p + 1)) this.p = this.adjustSeekIndex(this.p + 1);
    }
    /** Make sure index `i` in tokens has a token.
     *
     * @returns `true` if a token is located at index `i`, otherwise
     *    `false`.
     * @see #get(int i)
     */ sync(i) {
        $fomfP(i >= 0);
        let n = i - this.tokens.length + 1; // how many more elements we need?
        //System.out.println("sync("+i+") needs "+n);
        if (n > 0) {
            let fetched = this.fetch(n);
            return fetched >= n;
        }
        return true;
    }
    /** Add `n` elements to buffer.
     *
     * @returns The actual number of elements added to the buffer.
     */ fetch(n) {
        if (this.fetchedEOF) return 0;
        for(let i = 0; i < n; i++){
            let t = this.tokenSource.nextToken();
            if (this.isWritableToken(t)) t.tokenIndex = this.tokens.length;
            this.tokens.push(t);
            if (t.type === $eKXi4.Token.EOF) {
                this.fetchedEOF = true;
                return i + 1;
            }
        }
        return n;
    }
    get(i) {
        if (i < 0 || i >= this.tokens.length) throw new RangeError("token index " + i + " out of range 0.." + (this.tokens.length - 1));
        return this.tokens[i];
    }
    /** Get all tokens from start..stop inclusively. */ getRange(start, stop) {
        if (start < 0 || stop < 0) return [];
        this.lazyInit();
        let subset = new Array();
        if (stop >= this.tokens.length) stop = this.tokens.length - 1;
        for(let i = start; i <= stop; i++){
            let t = this.tokens[i];
            if (t.type === $eKXi4.Token.EOF) break;
            subset.push(t);
        }
        return subset;
    }
    LA(i) {
        let token = this.LT(i);
        if (!token) return $eKXi4.Token.INVALID_TYPE;
        return token.type;
    }
    tryLB(k) {
        if (this.p - k < 0) return undefined;
        return this.tokens[this.p - k];
    }
    LT(k) {
        let result = this.tryLT(k);
        if (result === undefined) throw new RangeError("requested lookback index out of range");
        return result;
    }
    tryLT(k) {
        this.lazyInit();
        if (k === 0) throw new RangeError("0 is not a valid lookahead index");
        if (k < 0) return this.tryLB(-k);
        let i = this.p + k - 1;
        this.sync(i);
        if (i >= this.tokens.length) // return EOF token
        // EOF must be last token
        return this.tokens[this.tokens.length - 1];
        //		if ( i>range ) range = i;
        return this.tokens[i];
    }
    /**
     * Allowed derived classes to modify the behavior of operations which change
     * the current stream position by adjusting the target token index of a seek
     * operation. The default implementation simply returns `i`. If an
     * exception is thrown in this method, the current stream index should not be
     * changed.
     *
     * For example, {@link CommonTokenStream} overrides this method to ensure that
     * the seek target is always an on-channel token.
     *
     * @param i The target token index.
     * @returns The adjusted target token index.
     */ adjustSeekIndex(i) {
        return i;
    }
    lazyInit() {
        if (this.p === -1) this.setup();
    }
    setup() {
        this.sync(0);
        this.p = this.adjustSeekIndex(0);
    }
    /** Given a start and stop index, return a `List` of all tokens in
     *  the token type `BitSet`.  Return an empty array if no tokens were found.  This
     *  method looks at both on and off channel tokens.
     */ getTokens(start, stop, types) {
        this.lazyInit();
        if (start === undefined) {
            $fomfP(stop === undefined && types === undefined);
            return this.tokens;
        } else if (stop === undefined) stop = this.tokens.length - 1;
        if (start < 0 || stop >= this.tokens.length || stop < 0 || start >= this.tokens.length) throw new RangeError("start " + start + " or stop " + stop + " not in 0.." + (this.tokens.length - 1));
        if (start > stop) return [];
        if (types === undefined) return this.tokens.slice(start, stop + 1);
        else if (typeof types === "number") types = new Set().add(types);
        let typesSet = types;
        // list = tokens[start:stop]:{T t, t.type in types}
        let filteredTokens = this.tokens.slice(start, stop + 1);
        filteredTokens = filteredTokens.filter((value)=>typesSet.has(value.type));
        return filteredTokens;
    }
    /**
     * Given a starting index, return the index of the next token on channel.
     * Return `i` if `tokens[i]` is on channel. Return the index of
     * the EOF token if there are no tokens on channel between `i` and
     * EOF.
     */ nextTokenOnChannel(i, channel) {
        this.sync(i);
        if (i >= this.size) return this.size - 1;
        let token = this.tokens[i];
        while(token.channel !== channel){
            if (token.type === $eKXi4.Token.EOF) return i;
            i++;
            this.sync(i);
            token = this.tokens[i];
        }
        return i;
    }
    /**
     * Given a starting index, return the index of the previous token on
     * channel. Return `i` if `tokens[i]` is on channel. Return -1
     * if there are no tokens on channel between `i` and 0.
     *
     * If `i` specifies an index at or after the EOF token, the EOF token
     * index is returned. This is due to the fact that the EOF token is treated
     * as though it were on every channel.
     */ previousTokenOnChannel(i, channel) {
        this.sync(i);
        if (i >= this.size) // the EOF token is on every channel
        return this.size - 1;
        while(i >= 0){
            let token = this.tokens[i];
            if (token.type === $eKXi4.Token.EOF || token.channel === channel) return i;
            i--;
        }
        return i;
    }
    /** Collect all tokens on specified channel to the right of
     *  the current token up until we see a token on {@link Lexer#DEFAULT_TOKEN_CHANNEL} or
     *  EOF. If `channel` is `-1`, find any non default channel token.
     */ getHiddenTokensToRight(tokenIndex, channel = -1) {
        this.lazyInit();
        if (tokenIndex < 0 || tokenIndex >= this.tokens.length) throw new RangeError(tokenIndex + " not in 0.." + (this.tokens.length - 1));
        let nextOnChannel = this.nextTokenOnChannel(tokenIndex + 1, $h7Q3L.Lexer.DEFAULT_TOKEN_CHANNEL);
        let to;
        let from = tokenIndex + 1;
        // if none onchannel to right, nextOnChannel=-1 so set to = last token
        if (nextOnChannel === -1) to = this.size - 1;
        else to = nextOnChannel;
        return this.filterForChannel(from, to, channel);
    }
    /** Collect all tokens on specified channel to the left of
     *  the current token up until we see a token on {@link Lexer#DEFAULT_TOKEN_CHANNEL}.
     *  If `channel` is `-1`, find any non default channel token.
     */ getHiddenTokensToLeft(tokenIndex, channel = -1) {
        this.lazyInit();
        if (tokenIndex < 0 || tokenIndex >= this.tokens.length) throw new RangeError(tokenIndex + " not in 0.." + (this.tokens.length - 1));
        if (tokenIndex === 0) // obviously no tokens can appear before the first token
        return [];
        let prevOnChannel = this.previousTokenOnChannel(tokenIndex - 1, $h7Q3L.Lexer.DEFAULT_TOKEN_CHANNEL);
        if (prevOnChannel === tokenIndex - 1) return [];
        // if none onchannel to left, prevOnChannel=-1 then from=0
        let from = prevOnChannel + 1;
        let to = tokenIndex - 1;
        return this.filterForChannel(from, to, channel);
    }
    filterForChannel(from, to, channel) {
        let hidden = new Array();
        for(let i = from; i <= to; i++){
            let t = this.tokens[i];
            if (channel === -1) {
                if (t.channel !== $h7Q3L.Lexer.DEFAULT_TOKEN_CHANNEL) hidden.push(t);
            } else if (t.channel === channel) hidden.push(t);
        }
        return hidden;
    }
    get sourceName() {
        return this.tokenSource.sourceName;
    }
    getText(interval) {
        if (interval === undefined) interval = $l8y5T.Interval.of(0, this.size - 1);
        else if (!(interval instanceof $l8y5T.Interval)) // Note: the more obvious check for 'instanceof RuleContext' results in a circular dependency problem
        interval = interval.sourceInterval;
        let start = interval.a;
        let stop = interval.b;
        if (start < 0 || stop < 0) return "";
        this.fill();
        if (stop >= this.tokens.length) stop = this.tokens.length - 1;
        let buf = "";
        for(let i = start; i <= stop; i++){
            let t = this.tokens[i];
            if (t.type === $eKXi4.Token.EOF) break;
            buf += t.text;
        }
        return buf.toString();
    }
    getTextFromRange(start, stop) {
        if (this.isToken(start) && this.isToken(stop)) return this.getText($l8y5T.Interval.of(start.tokenIndex, stop.tokenIndex));
        return "";
    }
    /** Get all tokens from lexer until EOF. */ fill() {
        this.lazyInit();
        const blockSize = 1000;
        while(true){
            let fetched = this.fetch(blockSize);
            if (fetched < blockSize) return;
        }
    }
    // TODO: Figure out a way to make this more flexible?
    isWritableToken(t) {
        return t instanceof $exlin.CommonToken;
    }
    // TODO: Figure out a way to make this more flexible?
    isToken(t) {
        return t instanceof $exlin.CommonToken;
    }
};
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.NotNull
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "_tokenSource", void 0);
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.Override
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "tokenSource", null);
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.Override
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "index", null);
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.Override
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "mark", null);
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.Override
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "release", null);
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.Override
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "seek", null);
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.Override
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "size", null);
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.Override
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "consume", null);
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.Override
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "get", null);
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.Override
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "LA", null);
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.NotNull,
    $aN41m.Override
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "LT", null);
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.Override
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "sourceName", null);
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.NotNull,
    $aN41m.Override
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "getText", null);
$9c0cee8efd4f75ec$var$__decorate([
    $aN41m.NotNull,
    $aN41m.Override
], $9c0cee8efd4f75ec$var$BufferedTokenStream.prototype, "getTextFromRange", null);
$9c0cee8efd4f75ec$var$BufferedTokenStream = $9c0cee8efd4f75ec$var$__decorate([
    $9c0cee8efd4f75ec$var$__param(0, $aN41m.NotNull)
], $9c0cee8efd4f75ec$var$BufferedTokenStream);
module.exports.BufferedTokenStream = $9c0cee8efd4f75ec$var$BufferedTokenStream;

});

parcelRegister("aUhGF", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("8tY30", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CharStreams = void 0;

var $cNEtm = parcelRequire("cNEtm");

var $1EXcP = parcelRequire("1EXcP");

var $ldi9e = parcelRequire("ldi9e");
// const DEFAULT_BUFFER_SIZE: number = 4096;
/** This class represents the primary interface for creating {@link CharStream}s
 *  from a variety of sources as of 4.7.  The motivation was to support
 *  Unicode code points > U+FFFF.  {@link ANTLRInputStream} and
 *  {@link ANTLRFileStream} are now deprecated in favor of the streams created
 *  by this interface.
 *
 *  DEPRECATED: {@code new ANTLRFileStream("myinputfile")}
 *  NEW:        {@code CharStreams.fromFileName("myinputfile")}
 *
 *  WARNING: If you use both the deprecated and the new streams, you will see
 *  a nontrivial performance degradation. This speed hit is because the
 *  {@link Lexer}'s internal code goes from a monomorphic to megamorphic
 *  dynamic dispatch to get characters from the input stream. Java's
 *  on-the-fly compiler (JIT) is unable to perform the same optimizations
 *  so stick with either the old or the new streams, if performance is
 *  a primary concern. See the extreme debugging and spelunking
 *  needed to identify this issue in our timing rig:
 *
 *      https://github.com/antlr/antlr4/pull/1781
 *
 *  The ANTLR character streams still buffer all the input when you create
 *  the stream, as they have done for ~20 years. If you need unbuffered
 *  access, please note that it becomes challenging to create
 *  parse trees. The parse tree has to point to tokens which will either
 *  point into a stale location in an unbuffered stream or you have to copy
 *  the characters out of the buffer into the token. That defeats the purpose
 *  of unbuffered input. Per the ANTLR book, unbuffered streams are primarily
 *  useful for processing infinite streams *during the parse.*
 *
 *  The new streams also use 8-bit buffers when possible so this new
 *  interface supports character streams that use half as much memory
 *  as the old {@link ANTLRFileStream}, which assumed 16-bit characters.
 *
 *  A big shout out to Ben Hamilton (github bhamiltoncx) for his superhuman
 *  efforts across all targets to get true Unicode 3.1 support for U+10FFFF.
 *
 *  @since 4.7
 */ var $62cf9c5e285e940f$var$CharStreams;
(function(CharStreams) {
    // /**
    //  * Creates a {@link CharStream} given a path to a UTF-8
    //  * encoded file on disk.
    //  *
    //  * Reads the entire contents of the file into the result before returning.
    //  */
    // export function fromFile(file: File): CharStream;
    // export function fromFile(file: File, charset: Charset): CharStream;
    // export function fromFile(file: File, charset?: Charset): CharStream {
    // 	if (charset === undefined) {
    // 		charset = Charset.forName("UTF-8");
    // 	}
    function fromString(s, sourceName) {
        if (sourceName === undefined || sourceName.length === 0) sourceName = $ldi9e.IntStream.UNKNOWN_SOURCE_NAME;
        // Initial guess assumes no code points > U+FFFF: one code
        // point for each code unit in the string
        let codePointBufferBuilder = $cNEtm.CodePointBuffer.builder(s.length);
        // TODO: CharBuffer.wrap(String) rightfully returns a read-only buffer
        // which doesn't expose its array, so we make a copy.
        let cb = new Uint16Array(s.length);
        for(let i = 0; i < s.length; i++)cb[i] = s.charCodeAt(i);
        codePointBufferBuilder.append(cb);
        return $1EXcP.CodePointCharStream.fromBuffer(codePointBufferBuilder.build(), sourceName);
    }
    CharStreams.fromString = fromString;
// export function bufferFromChannel(
// 	channel: ReadableByteChannel,
// 	charset: Charset,
// 	bufferSize: number,
// 	decodingErrorAction: CodingErrorAction,
// 	inputSize: number): CodePointBuffer {
// 	try {
// 		let utf8BytesIn: Uint8Array = new Uint8Array(bufferSize);
// 		let utf16CodeUnitsOut: Uint16Array = new Uint16Array(bufferSize);
// 		if (inputSize === -1) {
// 			inputSize = bufferSize;
// 		} else if (inputSize > Integer.MAX_VALUE) {
// 			// ByteBuffer et al don't support long sizes
// 			throw new RangeError(`inputSize ${inputSize} larger than max ${Integer.MAX_VALUE}`);
// 		}
// 		let codePointBufferBuilder: CodePointBuffer.Builder = CodePointBuffer.builder(inputSize);
// 		let decoder: CharsetDecoder = charset
// 				.newDecoder()
// 				.onMalformedInput(decodingErrorAction)
// 				.onUnmappableCharacter(decodingErrorAction);
// 		let endOfInput: boolean = false;
// 		while (!endOfInput) {
// 			let bytesRead: number = channel.read(utf8BytesIn);
// 			endOfInput = (bytesRead === -1);
// 			utf8BytesIn.flip();
// 			let result: CoderResult = decoder.decode(
// 				utf8BytesIn,
// 				utf16CodeUnitsOut,
// 				endOfInput);
// 			if (result.isError() && decodingErrorAction === CodingErrorAction.REPORT) {
// 				result.throwException();
// 			}
// 			utf16CodeUnitsOut.flip();
// 			codePointBufferBuilder.append(utf16CodeUnitsOut);
// 			utf8BytesIn.compact();
// 			utf16CodeUnitsOut.compact();
// 		}
// 		// Handle any bytes at the end of the file which need to
// 		// be represented as errors or substitution characters.
// 		let flushResult: CoderResult = decoder.flush(utf16CodeUnitsOut);
// 		if (flushResult.isError() && decodingErrorAction === CodingErrorAction.REPORT) {
// 			flushResult.throwException();
// 		}
// 		utf16CodeUnitsOut.flip();
// 		codePointBufferBuilder.append(utf16CodeUnitsOut);
// 		return codePointBufferBuilder.build();
// 	}
// 	finally {
// 		channel.close();
// 	}
// }
})($62cf9c5e285e940f$var$CharStreams = module.exports.CharStreams || (module.exports.CharStreams = {}));

});
parcelRegister("cNEtm", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CodePointBuffer = void 0;

var $fomfP = parcelRequire("fomfP");

var $2ImFx = parcelRequire("2ImFx");
/**
 * Wrapper for `Uint8Array` / `Uint16Array` / `Int32Array`.
 */ class $951974a04eabf1bc$var$CodePointBuffer {
    constructor(buffer, size){
        this.buffer = buffer;
        this._position = 0;
        this._size = size;
    }
    static withArray(buffer) {
        return new $951974a04eabf1bc$var$CodePointBuffer(buffer, buffer.length);
    }
    get position() {
        return this._position;
    }
    set position(newPosition) {
        if (newPosition < 0 || newPosition > this._size) throw new RangeError();
        this._position = newPosition;
    }
    get remaining() {
        return this._size - this.position;
    }
    get(offset) {
        return this.buffer[offset];
    }
    array() {
        return this.buffer.slice(0, this._size);
    }
    static builder(initialBufferSize) {
        return new $951974a04eabf1bc$var$CodePointBuffer.Builder(initialBufferSize);
    }
}
module.exports.CodePointBuffer = $951974a04eabf1bc$var$CodePointBuffer;
(function(CodePointBuffer) {
    let Type;
    (function(Type) {
        Type[Type["BYTE"] = 0] = "BYTE";
        Type[Type["CHAR"] = 1] = "CHAR";
        Type[Type["INT"] = 2] = "INT";
    })(Type || (Type = {}));
    class Builder {
        constructor(initialBufferSize){
            this.type = 0 /* BYTE */ ;
            this.buffer = new Uint8Array(initialBufferSize);
            this.prevHighSurrogate = -1;
            this.position = 0;
        }
        build() {
            return new CodePointBuffer(this.buffer, this.position);
        }
        static roundUpToNextPowerOfTwo(i) {
            let nextPowerOfTwo = 32 - Math.clz32(i - 1);
            return Math.pow(2, nextPowerOfTwo);
        }
        ensureRemaining(remainingNeeded) {
            switch(this.type){
                case 0 /* BYTE */ :
                    if (this.buffer.length - this.position < remainingNeeded) {
                        let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                        let newBuffer = new Uint8Array(newCapacity);
                        newBuffer.set(this.buffer.subarray(0, this.position), 0);
                        this.buffer = newBuffer;
                    }
                    break;
                case 1 /* CHAR */ :
                    if (this.buffer.length - this.position < remainingNeeded) {
                        let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                        let newBuffer = new Uint16Array(newCapacity);
                        newBuffer.set(this.buffer.subarray(0, this.position), 0);
                        this.buffer = newBuffer;
                    }
                    break;
                case 2 /* INT */ :
                    if (this.buffer.length - this.position < remainingNeeded) {
                        let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                        let newBuffer = new Int32Array(newCapacity);
                        newBuffer.set(this.buffer.subarray(0, this.position), 0);
                        this.buffer = newBuffer;
                    }
                    break;
            }
        }
        append(utf16In) {
            this.ensureRemaining(utf16In.length);
            this.appendArray(utf16In);
        }
        appendArray(utf16In) {
            switch(this.type){
                case 0 /* BYTE */ :
                    this.appendArrayByte(utf16In);
                    break;
                case 1 /* CHAR */ :
                    this.appendArrayChar(utf16In);
                    break;
                case 2 /* INT */ :
                    this.appendArrayInt(utf16In);
                    break;
            }
        }
        appendArrayByte(utf16In) {
            $fomfP(this.prevHighSurrogate === -1);
            let input = utf16In;
            let inOffset = 0;
            let inLimit = utf16In.length;
            let outByte = this.buffer;
            let outOffset = this.position;
            while(inOffset < inLimit){
                let c = input[inOffset];
                if (c <= 0xFF) outByte[outOffset] = c;
                else {
                    utf16In = utf16In.subarray(inOffset, inLimit);
                    this.position = outOffset;
                    if (!$2ImFx.isHighSurrogate(c)) {
                        this.byteToCharBuffer(utf16In.length);
                        this.appendArrayChar(utf16In);
                        return;
                    } else {
                        this.byteToIntBuffer(utf16In.length);
                        this.appendArrayInt(utf16In);
                        return;
                    }
                }
                inOffset++;
                outOffset++;
            }
            this.position = outOffset;
        }
        appendArrayChar(utf16In) {
            $fomfP(this.prevHighSurrogate === -1);
            let input = utf16In;
            let inOffset = 0;
            let inLimit = utf16In.length;
            let outChar = this.buffer;
            let outOffset = this.position;
            while(inOffset < inLimit){
                let c = input[inOffset];
                if (!$2ImFx.isHighSurrogate(c)) outChar[outOffset] = c;
                else {
                    utf16In = utf16In.subarray(inOffset, inLimit);
                    this.position = outOffset;
                    this.charToIntBuffer(utf16In.length);
                    this.appendArrayInt(utf16In);
                    return;
                }
                inOffset++;
                outOffset++;
            }
            this.position = outOffset;
        }
        appendArrayInt(utf16In) {
            let input = utf16In;
            let inOffset = 0;
            let inLimit = utf16In.length;
            let outInt = this.buffer;
            let outOffset = this.position;
            while(inOffset < inLimit){
                let c = input[inOffset];
                inOffset++;
                if (this.prevHighSurrogate !== -1) {
                    if ($2ImFx.isLowSurrogate(c)) {
                        outInt[outOffset] = String.fromCharCode(this.prevHighSurrogate, c).codePointAt(0);
                        outOffset++;
                        this.prevHighSurrogate = -1;
                    } else {
                        // Dangling high surrogate
                        outInt[outOffset] = this.prevHighSurrogate;
                        outOffset++;
                        if ($2ImFx.isHighSurrogate(c)) this.prevHighSurrogate = c;
                        else {
                            outInt[outOffset] = c;
                            outOffset++;
                            this.prevHighSurrogate = -1;
                        }
                    }
                } else if ($2ImFx.isHighSurrogate(c)) this.prevHighSurrogate = c;
                else {
                    outInt[outOffset] = c;
                    outOffset++;
                }
            }
            if (this.prevHighSurrogate !== -1) {
                // Dangling high surrogate
                outInt[outOffset] = this.prevHighSurrogate;
                outOffset++;
            }
            this.position = outOffset;
        }
        byteToCharBuffer(toAppend) {
            // CharBuffers hold twice as much per unit as ByteBuffers, so start with half the capacity.
            let newBuffer = new Uint16Array(Math.max(this.position + toAppend, this.buffer.length >> 1));
            newBuffer.set(this.buffer.subarray(0, this.position), 0);
            this.type = 1 /* CHAR */ ;
            this.buffer = newBuffer;
        }
        byteToIntBuffer(toAppend) {
            // IntBuffers hold four times as much per unit as ByteBuffers, so start with one quarter the capacity.
            let newBuffer = new Int32Array(Math.max(this.position + toAppend, this.buffer.length >> 2));
            newBuffer.set(this.buffer.subarray(0, this.position), 0);
            this.type = 2 /* INT */ ;
            this.buffer = newBuffer;
        }
        charToIntBuffer(toAppend) {
            // IntBuffers hold two times as much per unit as ByteBuffers, so start with one half the capacity.
            let newBuffer = new Int32Array(Math.max(this.position + toAppend, this.buffer.length >> 1));
            newBuffer.set(this.buffer.subarray(0, this.position), 0);
            this.type = 2 /* INT */ ;
            this.buffer = newBuffer;
        }
    }
    CodePointBuffer.Builder = Builder;
})($951974a04eabf1bc$var$CodePointBuffer = module.exports.CodePointBuffer || (module.exports.CodePointBuffer = {}));

});
parcelRegister("2ImFx", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isSupplementaryCodePoint = module.exports.isLowSurrogate = module.exports.isHighSurrogate = void 0;
function $1fa1466b3c6105b0$var$isHighSurrogate(ch) {
    return ch >= 0xD800 && ch <= 0xDBFF;
}
module.exports.isHighSurrogate = $1fa1466b3c6105b0$var$isHighSurrogate;
function $1fa1466b3c6105b0$var$isLowSurrogate(ch) {
    return ch >= 0xDC00 && ch <= 0xDFFF;
}
module.exports.isLowSurrogate = $1fa1466b3c6105b0$var$isLowSurrogate;
function $1fa1466b3c6105b0$var$isSupplementaryCodePoint(ch) {
    return ch >= 0x10000;
}
module.exports.isSupplementaryCodePoint = $1fa1466b3c6105b0$var$isSupplementaryCodePoint;

});


parcelRegister("1EXcP", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $135773ef6fd5bbbc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CodePointCharStream = void 0;

var $fomfP = parcelRequire("fomfP");

var $ldi9e = parcelRequire("ldi9e");

var $l8y5T = parcelRequire("l8y5T");

var $aN41m = parcelRequire("aN41m");
/**
 * Alternative to {@link ANTLRInputStream} which treats the input
 * as a series of Unicode code points, instead of a series of UTF-16
 * code units.
 *
 * Use this if you need to parse input which potentially contains
 * Unicode values > U+FFFF.
 */ class $135773ef6fd5bbbc$var$CodePointCharStream {
    // Use the factory method {@link #fromBuffer(CodePointBuffer)} to
    // construct instances of this type.
    constructor(array, position, remaining, name){
        // TODO
        $fomfP(position === 0);
        this._array = array;
        this._size = remaining;
        this._name = name;
        this._position = 0;
    }
    get internalStorage() {
        return this._array;
    }
    static fromBuffer(codePointBuffer, name) {
        if (name === undefined || name.length === 0) name = $ldi9e.IntStream.UNKNOWN_SOURCE_NAME;
        // Java lacks generics on primitive types.
        //
        // To avoid lots of calls to virtual methods in the
        // very hot codepath of LA() below, we construct one
        // of three concrete subclasses.
        //
        // The concrete subclasses directly access the code
        // points stored in the underlying array (byte[],
        // char[], or int[]), so we can avoid lots of virtual
        // method calls to ByteBuffer.get(offset).
        return new $135773ef6fd5bbbc$var$CodePointCharStream(codePointBuffer.array(), codePointBuffer.position, codePointBuffer.remaining, name);
    }
    consume() {
        if (this._size - this._position === 0) {
            $fomfP(this.LA(1) === $ldi9e.IntStream.EOF);
            throw new RangeError("cannot consume EOF");
        }
        this._position++;
    }
    get index() {
        return this._position;
    }
    get size() {
        return this._size;
    }
    /** mark/release do nothing; we have entire buffer */ mark() {
        return -1;
    }
    release(marker) {
    // No default implementation since this stream buffers the entire input
    }
    seek(index) {
        this._position = index;
    }
    get sourceName() {
        return this._name;
    }
    toString() {
        return this.getText($l8y5T.Interval.of(0, this.size - 1));
    }
    LA(i) {
        let offset;
        switch(Math.sign(i)){
            case -1:
                offset = this.index + i;
                if (offset < 0) return $ldi9e.IntStream.EOF;
                return this._array[offset];
            case 0:
                // Undefined
                return 0;
            case 1:
                offset = this.index + i - 1;
                if (offset >= this.size) return $ldi9e.IntStream.EOF;
                return this._array[offset];
        }
        throw new RangeError("Not reached");
    }
    /** Return the UTF-16 encoded string for the given interval */ getText(interval) {
        const startIdx = Math.min(interval.a, this.size);
        const len = Math.min(interval.b - interval.a + 1, this.size - startIdx);
        if (this._array instanceof Int32Array) return String.fromCodePoint(...Array.from(this._array.subarray(startIdx, startIdx + len)));
        else return String.fromCharCode(...Array.from(this._array.subarray(startIdx, startIdx + len)));
    }
}
$135773ef6fd5bbbc$var$__decorate([
    $aN41m.Override
], $135773ef6fd5bbbc$var$CodePointCharStream.prototype, "consume", null);
$135773ef6fd5bbbc$var$__decorate([
    $aN41m.Override
], $135773ef6fd5bbbc$var$CodePointCharStream.prototype, "index", null);
$135773ef6fd5bbbc$var$__decorate([
    $aN41m.Override
], $135773ef6fd5bbbc$var$CodePointCharStream.prototype, "size", null);
$135773ef6fd5bbbc$var$__decorate([
    $aN41m.Override
], $135773ef6fd5bbbc$var$CodePointCharStream.prototype, "mark", null);
$135773ef6fd5bbbc$var$__decorate([
    $aN41m.Override
], $135773ef6fd5bbbc$var$CodePointCharStream.prototype, "release", null);
$135773ef6fd5bbbc$var$__decorate([
    $aN41m.Override
], $135773ef6fd5bbbc$var$CodePointCharStream.prototype, "seek", null);
$135773ef6fd5bbbc$var$__decorate([
    $aN41m.Override
], $135773ef6fd5bbbc$var$CodePointCharStream.prototype, "sourceName", null);
$135773ef6fd5bbbc$var$__decorate([
    $aN41m.Override
], $135773ef6fd5bbbc$var$CodePointCharStream.prototype, "toString", null);
$135773ef6fd5bbbc$var$__decorate([
    $aN41m.Override
], $135773ef6fd5bbbc$var$CodePointCharStream.prototype, "LA", null);
$135773ef6fd5bbbc$var$__decorate([
    $aN41m.Override
], $135773ef6fd5bbbc$var$CodePointCharStream.prototype, "getText", null);
module.exports.CodePointCharStream = $135773ef6fd5bbbc$var$CodePointCharStream;

});


parcelRegister("eCP5Y", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $aa5c3fc2017da3f2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $aa5c3fc2017da3f2$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommonTokenStream = void 0;

var $doEv1 = parcelRequire("doEv1");

var $aN41m = parcelRequire("aN41m");

var $eKXi4 = parcelRequire("eKXi4");
/**
 * This class extends {@link BufferedTokenStream} with functionality to filter
 * token streams to tokens on a particular channel (tokens where
 * {@link Token#getChannel} returns a particular value).
 *
 * This token stream provides access to all tokens by index or when calling
 * methods like {@link #getText}. The channel filtering is only used for code
 * accessing tokens via the lookahead methods {@link #LA}, {@link #LT}, and
 * {@link #LB}.
 *
 * By default, tokens are placed on the default channel
 * ({@link Token#DEFAULT_CHANNEL}), but may be reassigned by using the
 * `->channel(HIDDEN)` lexer command, or by using an embedded action to
 * call {@link Lexer#setChannel}.
 *
 * Note: lexer rules which use the `->skip` lexer command or call
 * {@link Lexer#skip} do not produce tokens at all, so input text matched by
 * such a rule will not be available as part of the token stream, regardless of
 * channel.
 */ let $aa5c3fc2017da3f2$var$CommonTokenStream = class CommonTokenStream extends $doEv1.BufferedTokenStream {
    /**
     * Constructs a new {@link CommonTokenStream} using the specified token
     * source and filtering tokens to the specified channel. Only tokens whose
     * {@link Token#getChannel} matches `channel` or have the
     * `Token.type` equal to {@link Token#EOF} will be returned by the
     * token stream lookahead methods.
     *
     * @param tokenSource The token source.
     * @param channel The channel to use for filtering tokens.
     */ constructor(tokenSource, channel = $eKXi4.Token.DEFAULT_CHANNEL){
        super(tokenSource);
        this.channel = channel;
    }
    adjustSeekIndex(i) {
        return this.nextTokenOnChannel(i, this.channel);
    }
    tryLB(k) {
        if (this.p - k < 0) return undefined;
        let i = this.p;
        let n = 1;
        // find k good tokens looking backwards
        while(n <= k && i > 0){
            // skip off-channel tokens
            i = this.previousTokenOnChannel(i - 1, this.channel);
            n++;
        }
        if (i < 0) return undefined;
        return this.tokens[i];
    }
    tryLT(k) {
        //System.out.println("enter LT("+k+")");
        this.lazyInit();
        if (k === 0) throw new RangeError("0 is not a valid lookahead index");
        if (k < 0) return this.tryLB(-k);
        let i = this.p;
        let n = 1; // we know tokens[p] is a good one
        // find k good tokens
        while(n < k){
            // skip off-channel tokens, but make sure to not look past EOF
            if (this.sync(i + 1)) i = this.nextTokenOnChannel(i + 1, this.channel);
            n++;
        }
        //		if ( i>range ) range = i;
        return this.tokens[i];
    }
    /** Count EOF just once. */ getNumberOfOnChannelTokens() {
        let n = 0;
        this.fill();
        for (let t of this.tokens){
            if (t.channel === this.channel) n++;
            if (t.type === $eKXi4.Token.EOF) break;
        }
        return n;
    }
};
$aa5c3fc2017da3f2$var$__decorate([
    $aN41m.Override
], $aa5c3fc2017da3f2$var$CommonTokenStream.prototype, "adjustSeekIndex", null);
$aa5c3fc2017da3f2$var$__decorate([
    $aN41m.Override
], $aa5c3fc2017da3f2$var$CommonTokenStream.prototype, "tryLB", null);
$aa5c3fc2017da3f2$var$__decorate([
    $aN41m.Override
], $aa5c3fc2017da3f2$var$CommonTokenStream.prototype, "tryLT", null);
$aa5c3fc2017da3f2$var$CommonTokenStream = $aa5c3fc2017da3f2$var$__decorate([
    $aa5c3fc2017da3f2$var$__param(0, $aN41m.NotNull)
], $aa5c3fc2017da3f2$var$CommonTokenStream);
module.exports.CommonTokenStream = $aa5c3fc2017da3f2$var$CommonTokenStream;

});

parcelRegister("9xPUt", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Dependents = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:51.1349829-07:00
/**
 *
 * @author Sam Harwell
 */ var $6f2f765ae75dbe26$var$Dependents;
(function(Dependents) {
    /**
     * The element is dependent upon the specified rule.
     */ Dependents[Dependents["SELF"] = 0] = "SELF";
    /**
     * The element is dependent upon the set of the specified rule's parents
     * (rules which directly reference it).
     */ Dependents[Dependents["PARENTS"] = 1] = "PARENTS";
    /**
     * The element is dependent upon the set of the specified rule's children
     * (rules which it directly references).
     */ Dependents[Dependents["CHILDREN"] = 2] = "CHILDREN";
    /**
     * The element is dependent upon the set of the specified rule's ancestors
     * (the transitive closure of `PARENTS` rules).
     */ Dependents[Dependents["ANCESTORS"] = 3] = "ANCESTORS";
    /**
     * The element is dependent upon the set of the specified rule's descendants
     * (the transitive closure of `CHILDREN` rules).
     */ Dependents[Dependents["DESCENDANTS"] = 4] = "DESCENDANTS";
    /**
     * The element is dependent upon the set of the specified rule's siblings
     * (the union of `CHILDREN` of its `PARENTS`).
     */ Dependents[Dependents["SIBLINGS"] = 5] = "SIBLINGS";
    /**
     * The element is dependent upon the set of the specified rule's preceeding
     * siblings (the union of `CHILDREN` of its `PARENTS` which
     * appear before a reference to the rule).
     */ Dependents[Dependents["PRECEEDING_SIBLINGS"] = 6] = "PRECEEDING_SIBLINGS";
    /**
     * The element is dependent upon the set of the specified rule's following
     * siblings (the union of `CHILDREN` of its `PARENTS` which
     * appear after a reference to the rule).
     */ Dependents[Dependents["FOLLOWING_SIBLINGS"] = 7] = "FOLLOWING_SIBLINGS";
    /**
     * The element is dependent upon the set of the specified rule's preceeding
     * elements (rules which might end before the start of the specified rule
     * while parsing). This is calculated by taking the
     * `PRECEEDING_SIBLINGS` of the rule and each of its
     * `ANCESTORS`, along with the `DESCENDANTS` of those
     * elements.
     */ Dependents[Dependents["PRECEEDING"] = 8] = "PRECEEDING";
    /**
     * The element is dependent upon the set of the specified rule's following
     * elements (rules which might start after the end of the specified rule
     * while parsing). This is calculated by taking the
     * `FOLLOWING_SIBLINGS` of the rule and each of its
     * `ANCESTORS`, along with the `DESCENDANTS` of those
     * elements.
     */ Dependents[Dependents["FOLLOWING"] = 9] = "FOLLOWING";
})($6f2f765ae75dbe26$var$Dependents = module.exports.Dependents || (module.exports.Dependents = {}));

});

parcelRegister("67k7F", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $4743017423787884$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $4743017423787884$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DiagnosticErrorListener = void 0;

var $8WIez = parcelRequire("8WIez");

var $aN41m = parcelRequire("aN41m");

var $l8y5T = parcelRequire("l8y5T");
/**
 * This implementation of {@link ANTLRErrorListener} can be used to identify
 * certain potential correctness and performance problems in grammars. "Reports"
 * are made by calling {@link Parser#notifyErrorListeners} with the appropriate
 * message.
 *
 * * **Ambiguities**: These are cases where more than one path through the
 *   grammar can match the input.
 * * **Weak context sensitivity**: These are cases where full-context
 *   prediction resolved an SLL conflict to a unique alternative which equaled the
 *   minimum alternative of the SLL conflict.
 * * **Strong (forced) context sensitivity**: These are cases where the
 *   full-context prediction resolved an SLL conflict to a unique alternative,
 *   *and* the minimum alternative of the SLL conflict was found to not be
 *   a truly viable alternative. Two-stage parsing cannot be used for inputs where
 *   this situation occurs.
 *
 * @author Sam Harwell
 */ class $4743017423787884$var$DiagnosticErrorListener {
    /**
     * Initializes a new instance of {@link DiagnosticErrorListener}, specifying
     * whether all ambiguities or only exact ambiguities are reported.
     *
     * @param exactOnly `true` to report only exact ambiguities, otherwise
     * `false` to report all ambiguities.  Defaults to true.
     */ constructor(exactOnly = true){
        this.exactOnly = exactOnly;
        this.exactOnly = exactOnly;
    }
    syntaxError(/*@NotNull*/ recognizer, offendingSymbol, line, charPositionInLine, /*@NotNull*/ msg, e) {
    // intentionally empty
    }
    reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs) {
        if (this.exactOnly && !exact) return;
        let decision = this.getDecisionDescription(recognizer, dfa);
        let conflictingAlts = this.getConflictingAlts(ambigAlts, configs);
        let text = recognizer.inputStream.getText($l8y5T.Interval.of(startIndex, stopIndex));
        let message = `reportAmbiguity d=${decision}: ambigAlts=${conflictingAlts}, input='${text}'`;
        recognizer.notifyErrorListeners(message);
    }
    reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState) {
        let format = "reportAttemptingFullContext d=%s, input='%s'";
        let decision = this.getDecisionDescription(recognizer, dfa);
        let text = recognizer.inputStream.getText($l8y5T.Interval.of(startIndex, stopIndex));
        let message = `reportAttemptingFullContext d=${decision}, input='${text}'`;
        recognizer.notifyErrorListeners(message);
    }
    reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState) {
        let format = "reportContextSensitivity d=%s, input='%s'";
        let decision = this.getDecisionDescription(recognizer, dfa);
        let text = recognizer.inputStream.getText($l8y5T.Interval.of(startIndex, stopIndex));
        let message = `reportContextSensitivity d=${decision}, input='${text}'`;
        recognizer.notifyErrorListeners(message);
    }
    getDecisionDescription(recognizer, dfa) {
        let decision = dfa.decision;
        let ruleIndex = dfa.atnStartState.ruleIndex;
        let ruleNames = recognizer.ruleNames;
        if (ruleIndex < 0 || ruleIndex >= ruleNames.length) return decision.toString();
        let ruleName = ruleNames[ruleIndex];
        if (!ruleName) return decision.toString();
        return `${decision} (${ruleName})`;
    }
    /**
     * Computes the set of conflicting or ambiguous alternatives from a
     * configuration set, if that information was not already provided by the
     * parser.
     *
     * @param reportedAlts The set of conflicting or ambiguous alternatives, as
     * reported by the parser.
     * @param configs The conflicting or ambiguous configuration set.
     * @returns Returns `reportedAlts` if it is not `undefined`, otherwise
     * returns the set of alternatives represented in `configs`.
     */ getConflictingAlts(reportedAlts, configs) {
        if (reportedAlts != null) return reportedAlts;
        let result = new $8WIez.BitSet();
        for (let config of configs)result.set(config.alt);
        return result;
    }
}
$4743017423787884$var$__decorate([
    $aN41m.Override
], $4743017423787884$var$DiagnosticErrorListener.prototype, "syntaxError", null);
$4743017423787884$var$__decorate([
    $aN41m.Override,
    $4743017423787884$var$__param(0, $aN41m.NotNull),
    $4743017423787884$var$__param(1, $aN41m.NotNull),
    $4743017423787884$var$__param(6, $aN41m.NotNull)
], $4743017423787884$var$DiagnosticErrorListener.prototype, "reportAmbiguity", null);
$4743017423787884$var$__decorate([
    $aN41m.Override,
    $4743017423787884$var$__param(0, $aN41m.NotNull),
    $4743017423787884$var$__param(1, $aN41m.NotNull),
    $4743017423787884$var$__param(5, $aN41m.NotNull)
], $4743017423787884$var$DiagnosticErrorListener.prototype, "reportAttemptingFullContext", null);
$4743017423787884$var$__decorate([
    $aN41m.Override,
    $4743017423787884$var$__param(0, $aN41m.NotNull),
    $4743017423787884$var$__param(1, $aN41m.NotNull),
    $4743017423787884$var$__param(5, $aN41m.NotNull)
], $4743017423787884$var$DiagnosticErrorListener.prototype, "reportContextSensitivity", null);
$4743017423787884$var$__decorate([
    $4743017423787884$var$__param(0, $aN41m.NotNull),
    $4743017423787884$var$__param(1, $aN41m.NotNull)
], $4743017423787884$var$DiagnosticErrorListener.prototype, "getDecisionDescription", null);
$4743017423787884$var$__decorate([
    $aN41m.NotNull,
    $4743017423787884$var$__param(1, $aN41m.NotNull)
], $4743017423787884$var$DiagnosticErrorListener.prototype, "getConflictingAlts", null);
module.exports.DiagnosticErrorListener = $4743017423787884$var$DiagnosticErrorListener;

});

parcelRegister("jo2Zj", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $e1d2938a086e1390$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InterpreterRuleContext = void 0;

var $aN41m = parcelRequire("aN41m");

var $2pDMz = parcelRequire("2pDMz");
/**
 * This class extends {@link ParserRuleContext} by allowing the value of
 * {@link #getRuleIndex} to be explicitly set for the context.
 *
 * {@link ParserRuleContext} does not include field storage for the rule index
 * since the context classes created by the code generator override the
 * {@link #getRuleIndex} method to return the correct value for that context.
 * Since the parser interpreter does not use the context classes generated for a
 * parser, this class (with slightly more memory overhead per node) is used to
 * provide equivalent functionality.
 */ class $e1d2938a086e1390$var$InterpreterRuleContext extends $2pDMz.ParserRuleContext {
    constructor(ruleIndex, parent, invokingStateNumber){
        if (invokingStateNumber !== undefined) super(parent, invokingStateNumber);
        else super();
        this._ruleIndex = ruleIndex;
    }
    get ruleIndex() {
        return this._ruleIndex;
    }
}
$e1d2938a086e1390$var$__decorate([
    $aN41m.Override
], $e1d2938a086e1390$var$InterpreterRuleContext.prototype, "ruleIndex", null);
module.exports.InterpreterRuleContext = $e1d2938a086e1390$var$InterpreterRuleContext;

});

parcelRegister("hVliW", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d0c8492ceb048178$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d0c8492ceb048178$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerInterpreter = void 0;

var $h7Q3L = parcelRequire("h7Q3L");

var $2160U = parcelRequire("2160U");

var $aN41m = parcelRequire("aN41m");

var $aN41m = parcelRequire("aN41m");
let $d0c8492ceb048178$var$LexerInterpreter = class LexerInterpreter extends $h7Q3L.Lexer {
    constructor(grammarFileName, vocabulary, ruleNames, channelNames, modeNames, atn, input){
        super(input);
        if (atn.grammarType !== 0 /* LEXER */ ) throw new Error("IllegalArgumentException: The ATN must be a lexer ATN.");
        this._grammarFileName = grammarFileName;
        this._atn = atn;
        this._ruleNames = ruleNames.slice(0);
        this._channelNames = channelNames.slice(0);
        this._modeNames = modeNames.slice(0);
        this._vocabulary = vocabulary;
        this._interp = new $2160U.LexerATNSimulator(atn, this);
    }
    get atn() {
        return this._atn;
    }
    get grammarFileName() {
        return this._grammarFileName;
    }
    get ruleNames() {
        return this._ruleNames;
    }
    get channelNames() {
        return this._channelNames;
    }
    get modeNames() {
        return this._modeNames;
    }
    get vocabulary() {
        return this._vocabulary;
    }
};
$d0c8492ceb048178$var$__decorate([
    $aN41m.NotNull
], $d0c8492ceb048178$var$LexerInterpreter.prototype, "_vocabulary", void 0);
$d0c8492ceb048178$var$__decorate([
    $aN41m.Override
], $d0c8492ceb048178$var$LexerInterpreter.prototype, "atn", null);
$d0c8492ceb048178$var$__decorate([
    $aN41m.Override
], $d0c8492ceb048178$var$LexerInterpreter.prototype, "grammarFileName", null);
$d0c8492ceb048178$var$__decorate([
    $aN41m.Override
], $d0c8492ceb048178$var$LexerInterpreter.prototype, "ruleNames", null);
$d0c8492ceb048178$var$__decorate([
    $aN41m.Override
], $d0c8492ceb048178$var$LexerInterpreter.prototype, "channelNames", null);
$d0c8492ceb048178$var$__decorate([
    $aN41m.Override
], $d0c8492ceb048178$var$LexerInterpreter.prototype, "modeNames", null);
$d0c8492ceb048178$var$__decorate([
    $aN41m.Override
], $d0c8492ceb048178$var$LexerInterpreter.prototype, "vocabulary", null);
$d0c8492ceb048178$var$LexerInterpreter = $d0c8492ceb048178$var$__decorate([
    $d0c8492ceb048178$var$__param(1, $aN41m.NotNull)
], $d0c8492ceb048178$var$LexerInterpreter);
module.exports.LexerInterpreter = $d0c8492ceb048178$var$LexerInterpreter;

});

parcelRegister("c8NTK", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $8d6cf020aadeeb48$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $8d6cf020aadeeb48$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ListTokenSource = void 0;

var $9hrXh = parcelRequire("9hrXh");

var $aN41m = parcelRequire("aN41m");

var $eKXi4 = parcelRequire("eKXi4");
/**
 * Provides an implementation of {@link TokenSource} as a wrapper around a list
 * of {@link Token} objects.
 *
 * If the final token in the list is an {@link Token#EOF} token, it will be used
 * as the EOF token for every call to {@link #nextToken} after the end of the
 * list is reached. Otherwise, an EOF token will be created.
 */ let $8d6cf020aadeeb48$var$ListTokenSource = class ListTokenSource {
    /**
     * Constructs a new {@link ListTokenSource} instance from the specified
     * collection of {@link Token} objects and source name.
     *
     * @param tokens The collection of {@link Token} objects to provide as a
     * {@link TokenSource}.
     * @param sourceName The name of the {@link TokenSource}. If this value is
     * `undefined`, {@link #getSourceName} will attempt to infer the name from
     * the next {@link Token} (or the previous token if the end of the input has
     * been reached).
     *
     * @exception NullPointerException if `tokens` is `undefined`
     */ constructor(tokens, sourceName){
        /**
         * The index into {@link #tokens} of token to return by the next call to
         * {@link #nextToken}. The end of the input is indicated by this value
         * being greater than or equal to the number of items in {@link #tokens}.
         */ this.i = 0;
        /**
         * This is the backing field for {@link #getTokenFactory} and
         * {@link setTokenFactory}.
         */ this._factory = $9hrXh.CommonTokenFactory.DEFAULT;
        if (tokens == null) throw new Error("tokens cannot be null");
        this.tokens = tokens;
        this._sourceName = sourceName;
    }
    /**
     * {@inheritDoc}
     */ get charPositionInLine() {
        if (this.i < this.tokens.length) return this.tokens[this.i].charPositionInLine;
        else if (this.eofToken != null) return this.eofToken.charPositionInLine;
        else if (this.tokens.length > 0) {
            // have to calculate the result from the line/column of the previous
            // token, along with the text of the token.
            let lastToken = this.tokens[this.tokens.length - 1];
            let tokenText = lastToken.text;
            if (tokenText != null) {
                let lastNewLine = tokenText.lastIndexOf("\n");
                if (lastNewLine >= 0) return tokenText.length - lastNewLine - 1;
            }
            return lastToken.charPositionInLine + lastToken.stopIndex - lastToken.startIndex + 1;
        }
        // only reach this if tokens is empty, meaning EOF occurs at the first
        // position in the input
        return 0;
    }
    /**
     * {@inheritDoc}
     */ nextToken() {
        if (this.i >= this.tokens.length) {
            if (this.eofToken == null) {
                let start = -1;
                if (this.tokens.length > 0) {
                    let previousStop = this.tokens[this.tokens.length - 1].stopIndex;
                    if (previousStop !== -1) start = previousStop + 1;
                }
                let stop = Math.max(-1, start - 1);
                this.eofToken = this._factory.create({
                    source: this,
                    stream: this.inputStream
                }, $eKXi4.Token.EOF, "EOF", $eKXi4.Token.DEFAULT_CHANNEL, start, stop, this.line, this.charPositionInLine);
            }
            return this.eofToken;
        }
        let t = this.tokens[this.i];
        if (this.i === this.tokens.length - 1 && t.type === $eKXi4.Token.EOF) this.eofToken = t;
        this.i++;
        return t;
    }
    /**
     * {@inheritDoc}
     */ get line() {
        if (this.i < this.tokens.length) return this.tokens[this.i].line;
        else if (this.eofToken != null) return this.eofToken.line;
        else if (this.tokens.length > 0) {
            // have to calculate the result from the line/column of the previous
            // token, along with the text of the token.
            let lastToken = this.tokens[this.tokens.length - 1];
            let line = lastToken.line;
            let tokenText = lastToken.text;
            if (tokenText != null) {
                for(let i = 0; i < tokenText.length; i++)if (tokenText.charAt(i) === "\n") line++;
            }
            // if no text is available, assume the token did not contain any newline characters.
            return line;
        }
        // only reach this if tokens is empty, meaning EOF occurs at the first
        // position in the input
        return 1;
    }
    /**
     * {@inheritDoc}
     */ get inputStream() {
        if (this.i < this.tokens.length) return this.tokens[this.i].inputStream;
        else if (this.eofToken != null) return this.eofToken.inputStream;
        else if (this.tokens.length > 0) return this.tokens[this.tokens.length - 1].inputStream;
        // no input stream information is available
        return undefined;
    }
    /**
     * {@inheritDoc}
     */ get sourceName() {
        if (this._sourceName) return this._sourceName;
        let inputStream = this.inputStream;
        if (inputStream != null) return inputStream.sourceName;
        return "List";
    }
    /**
     * {@inheritDoc}
     */ // @Override
    set tokenFactory(factory) {
        this._factory = factory;
    }
    /**
     * {@inheritDoc}
     */ get tokenFactory() {
        return this._factory;
    }
};
$8d6cf020aadeeb48$var$__decorate([
    $aN41m.Override
], $8d6cf020aadeeb48$var$ListTokenSource.prototype, "charPositionInLine", null);
$8d6cf020aadeeb48$var$__decorate([
    $aN41m.Override
], $8d6cf020aadeeb48$var$ListTokenSource.prototype, "nextToken", null);
$8d6cf020aadeeb48$var$__decorate([
    $aN41m.Override
], $8d6cf020aadeeb48$var$ListTokenSource.prototype, "line", null);
$8d6cf020aadeeb48$var$__decorate([
    $aN41m.Override
], $8d6cf020aadeeb48$var$ListTokenSource.prototype, "inputStream", null);
$8d6cf020aadeeb48$var$__decorate([
    $aN41m.Override
], $8d6cf020aadeeb48$var$ListTokenSource.prototype, "sourceName", null);
$8d6cf020aadeeb48$var$__decorate([
    $aN41m.Override,
    $aN41m.NotNull,
    $8d6cf020aadeeb48$var$__param(0, $aN41m.NotNull)
], $8d6cf020aadeeb48$var$ListTokenSource.prototype, "tokenFactory", null);
$8d6cf020aadeeb48$var$ListTokenSource = $8d6cf020aadeeb48$var$__decorate([
    $8d6cf020aadeeb48$var$__param(0, $aN41m.NotNull)
], $8d6cf020aadeeb48$var$ListTokenSource);
module.exports.ListTokenSource = $8d6cf020aadeeb48$var$ListTokenSource;

});

parcelRegister("5n08Y", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("8rZl7", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $62706d1c6fe2cac4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $62706d1c6fe2cac4$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParserInterpreter = void 0;

var $dv9vN = parcelRequire("dv9vN");

var $fZESB = parcelRequire("fZESB");

var $8WIez = parcelRequire("8WIez");

var $2quiJ = parcelRequire("2quiJ");

var $5jZSY = parcelRequire("5jZSY");

var $jo2Zj = parcelRequire("jo2Zj");

var $fFNPu = parcelRequire("fFNPu");

var $aN41m = parcelRequire("aN41m");

var $aN41m = parcelRequire("aN41m");

var $c9Sjf = parcelRequire("c9Sjf");

var $gzbPK = parcelRequire("gzbPK");

var $b7PPe = parcelRequire("b7PPe");

var $e0pjt = parcelRequire("e0pjt");

var $eKXi4 = parcelRequire("eKXi4");
/** A parser simulator that mimics what ANTLR's generated
 *  parser code does. A ParserATNSimulator is used to make
 *  predictions via adaptivePredict but this class moves a pointer through the
 *  ATN to simulate parsing. ParserATNSimulator just
 *  makes us efficient rather than having to backtrack, for example.
 *
 *  This properly creates parse trees even for left recursive rules.
 *
 *  We rely on the left recursive rule invocation and special predicate
 *  transitions to make left recursive rules work.
 *
 *  See TestParserInterpreter for examples.
 */ let $62706d1c6fe2cac4$var$ParserInterpreter = class ParserInterpreter extends $c9Sjf.Parser {
    constructor(grammarFileName, vocabulary, ruleNames, atn, input){
        super(grammarFileName instanceof ParserInterpreter ? grammarFileName.inputStream : input);
        /** This stack corresponds to the _parentctx, _parentState pair of locals
         *  that would exist on call stack frames with a recursive descent parser;
         *  in the generated function for a left-recursive rule you'd see:
         *
         *  private EContext e(int _p) {
         *      ParserRuleContext _parentctx = _ctx;    // Pair.a
         *      int _parentState = state;          // Pair.b
         *      ...
         *  }
         *
         *  Those values are used to create new recursive rule invocation contexts
         *  associated with left operand of an alt like "expr '*' expr".
         */ this._parentContextStack = [];
        /** We need a map from (decision,inputIndex)->forced alt for computing ambiguous
         *  parse trees. For now, we allow exactly one override.
         */ this.overrideDecision = -1;
        this.overrideDecisionInputIndex = -1;
        this.overrideDecisionAlt = -1;
        this.overrideDecisionReached = false; // latch and only override once; error might trigger infinite loop
        /** What is the current context when we override a decisions?  This tells
         *  us what the root of the parse tree is when using override
         *  for an ambiguity/lookahead check.
         */ this._overrideDecisionRoot = undefined;
        if (grammarFileName instanceof ParserInterpreter) {
            let old = grammarFileName;
            this._grammarFileName = old._grammarFileName;
            this._atn = old._atn;
            this.pushRecursionContextStates = old.pushRecursionContextStates;
            this._ruleNames = old._ruleNames;
            this._vocabulary = old._vocabulary;
            this.interpreter = new $gzbPK.ParserATNSimulator(this._atn, this);
        } else {
            // The second constructor requires non-null arguments
            vocabulary;
            ruleNames;
            atn;
            this._grammarFileName = grammarFileName;
            this._atn = atn;
            this._ruleNames = ruleNames.slice(0);
            this._vocabulary = vocabulary;
            // identify the ATN states where pushNewRecursionContext() must be called
            this.pushRecursionContextStates = new $8WIez.BitSet(atn.states.length);
            for (let state of atn.states){
                if (!(state instanceof $e0pjt.StarLoopEntryState)) continue;
                if (state.precedenceRuleDecision) this.pushRecursionContextStates.set(state.stateNumber);
            }
            // get atn simulator that knows how to do predictions
            this.interpreter = new $gzbPK.ParserATNSimulator(atn, this);
        }
    }
    reset(resetInput) {
        if (resetInput === undefined) super.reset();
        else super.reset(resetInput);
        this.overrideDecisionReached = false;
        this._overrideDecisionRoot = undefined;
    }
    get atn() {
        return this._atn;
    }
    get vocabulary() {
        return this._vocabulary;
    }
    get ruleNames() {
        return this._ruleNames;
    }
    get grammarFileName() {
        return this._grammarFileName;
    }
    /** Begin parsing at startRuleIndex */ parse(startRuleIndex) {
        let startRuleStartState = this._atn.ruleToStartState[startRuleIndex];
        this._rootContext = this.createInterpreterRuleContext(undefined, $dv9vN.ATNState.INVALID_STATE_NUMBER, startRuleIndex);
        if (startRuleStartState.isPrecedenceRule) this.enterRecursionRule(this._rootContext, startRuleStartState.stateNumber, startRuleIndex, 0);
        else this.enterRule(this._rootContext, startRuleStartState.stateNumber, startRuleIndex);
        while(true){
            let p = this.atnState;
            switch(p.stateType){
                case $fZESB.ATNStateType.RULE_STOP:
                    // pop; return from rule
                    if (this._ctx.isEmpty) {
                        if (startRuleStartState.isPrecedenceRule) {
                            let result = this._ctx;
                            let parentContext = this._parentContextStack.pop();
                            this.unrollRecursionContexts(parentContext[0]);
                            return result;
                        } else {
                            this.exitRule();
                            return this._rootContext;
                        }
                    }
                    this.visitRuleStopState(p);
                    break;
                default:
                    try {
                        this.visitState(p);
                    } catch (e) {
                        if (e instanceof $b7PPe.RecognitionException) {
                            this.state = this._atn.ruleToStopState[p.ruleIndex].stateNumber;
                            this.context.exception = e;
                            this.errorHandler.reportError(this, e);
                            this.recover(e);
                        } else throw e;
                    }
                    break;
            }
        }
    }
    enterRecursionRule(localctx, state, ruleIndex, precedence) {
        this._parentContextStack.push([
            this._ctx,
            localctx.invokingState
        ]);
        super.enterRecursionRule(localctx, state, ruleIndex, precedence);
    }
    get atnState() {
        return this._atn.states[this.state];
    }
    visitState(p) {
        let predictedAlt = 1;
        if (p.numberOfTransitions > 1) predictedAlt = this.visitDecisionState(p);
        let transition = p.transition(predictedAlt - 1);
        switch(transition.serializationType){
            case 1 /* EPSILON */ :
                if (this.pushRecursionContextStates.get(p.stateNumber) && !(transition.target instanceof $fFNPu.LoopEndState)) {
                    // We are at the start of a left recursive rule's (...)* loop
                    // and we're not taking the exit branch of loop.
                    let parentContext = this._parentContextStack[this._parentContextStack.length - 1];
                    let localctx = this.createInterpreterRuleContext(parentContext[0], parentContext[1], this._ctx.ruleIndex);
                    this.pushNewRecursionContext(localctx, this._atn.ruleToStartState[p.ruleIndex].stateNumber, this._ctx.ruleIndex);
                }
                break;
            case 5 /* ATOM */ :
                this.match(transition._label);
                break;
            case 2 /* RANGE */ :
            case 7 /* SET */ :
            case 8 /* NOT_SET */ :
                if (!transition.matches(this._input.LA(1), $eKXi4.Token.MIN_USER_TOKEN_TYPE, 65535)) this.recoverInline();
                this.matchWildcard();
                break;
            case 9 /* WILDCARD */ :
                this.matchWildcard();
                break;
            case 3 /* RULE */ :
                let ruleStartState = transition.target;
                let ruleIndex = ruleStartState.ruleIndex;
                let newctx = this.createInterpreterRuleContext(this._ctx, p.stateNumber, ruleIndex);
                if (ruleStartState.isPrecedenceRule) this.enterRecursionRule(newctx, ruleStartState.stateNumber, ruleIndex, transition.precedence);
                else this.enterRule(newctx, transition.target.stateNumber, ruleIndex);
                break;
            case 4 /* PREDICATE */ :
                let predicateTransition = transition;
                if (!this.sempred(this._ctx, predicateTransition.ruleIndex, predicateTransition.predIndex)) throw new $2quiJ.FailedPredicateException(this);
                break;
            case 6 /* ACTION */ :
                let actionTransition = transition;
                this.action(this._ctx, actionTransition.ruleIndex, actionTransition.actionIndex);
                break;
            case 10 /* PRECEDENCE */ :
                if (!this.precpred(this._ctx, transition.precedence)) {
                    let precedence = transition.precedence;
                    throw new $2quiJ.FailedPredicateException(this, `precpred(_ctx, ${precedence})`);
                }
                break;
            default:
                throw new Error("UnsupportedOperationException: Unrecognized ATN transition type.");
        }
        this.state = transition.target.stateNumber;
    }
    /** Method visitDecisionState() is called when the interpreter reaches
     *  a decision state (instance of DecisionState). It gives an opportunity
     *  for subclasses to track interesting things.
     */ visitDecisionState(p) {
        let predictedAlt;
        this.errorHandler.sync(this);
        let decision = p.decision;
        if (decision === this.overrideDecision && this._input.index === this.overrideDecisionInputIndex && !this.overrideDecisionReached) {
            predictedAlt = this.overrideDecisionAlt;
            this.overrideDecisionReached = true;
        } else predictedAlt = this.interpreter.adaptivePredict(this._input, decision, this._ctx);
        return predictedAlt;
    }
    /** Provide simple "factory" for InterpreterRuleContext's.
     *  @since 4.5.1
     */ createInterpreterRuleContext(parent, invokingStateNumber, ruleIndex) {
        return new $jo2Zj.InterpreterRuleContext(ruleIndex, parent, invokingStateNumber);
    }
    visitRuleStopState(p) {
        let ruleStartState = this._atn.ruleToStartState[p.ruleIndex];
        if (ruleStartState.isPrecedenceRule) {
            let parentContext = this._parentContextStack.pop();
            this.unrollRecursionContexts(parentContext[0]);
            this.state = parentContext[1];
        } else this.exitRule();
        let ruleTransition = this._atn.states[this.state].transition(0);
        this.state = ruleTransition.followState.stateNumber;
    }
    /** Override this parser interpreters normal decision-making process
     *  at a particular decision and input token index. Instead of
     *  allowing the adaptive prediction mechanism to choose the
     *  first alternative within a block that leads to a successful parse,
     *  force it to take the alternative, 1..n for n alternatives.
     *
     *  As an implementation limitation right now, you can only specify one
     *  override. This is sufficient to allow construction of different
     *  parse trees for ambiguous input. It means re-parsing the entire input
     *  in general because you're never sure where an ambiguous sequence would
     *  live in the various parse trees. For example, in one interpretation,
     *  an ambiguous input sequence would be matched completely in expression
     *  but in another it could match all the way back to the root.
     *
     *  s : e '!'? ;
     *  e : ID
     *    | ID '!'
     *    ;
     *
     *  Here, x! can be matched as (s (e ID) !) or (s (e ID !)). In the first
     *  case, the ambiguous sequence is fully contained only by the root.
     *  In the second case, the ambiguous sequences fully contained within just
     *  e, as in: (e ID !).
     *
     *  Rather than trying to optimize this and make
     *  some intelligent decisions for optimization purposes, I settled on
     *  just re-parsing the whole input and then using
     *  {link Trees#getRootOfSubtreeEnclosingRegion} to find the minimal
     *  subtree that contains the ambiguous sequence. I originally tried to
     *  record the call stack at the point the parser detected and ambiguity but
     *  left recursive rules create a parse tree stack that does not reflect
     *  the actual call stack. That impedance mismatch was enough to make
     *  it it challenging to restart the parser at a deeply nested rule
     *  invocation.
     *
     *  Only parser interpreters can override decisions so as to avoid inserting
     *  override checking code in the critical ALL(*) prediction execution path.
     *
     *  @since 4.5
     */ addDecisionOverride(decision, tokenIndex, forcedAlt) {
        this.overrideDecision = decision;
        this.overrideDecisionInputIndex = tokenIndex;
        this.overrideDecisionAlt = forcedAlt;
    }
    get overrideDecisionRoot() {
        return this._overrideDecisionRoot;
    }
    /** Rely on the error handler for this parser but, if no tokens are consumed
     *  to recover, add an error node. Otherwise, nothing is seen in the parse
     *  tree.
     */ recover(e) {
        let i = this._input.index;
        this.errorHandler.recover(this, e);
        if (this._input.index === i) {
            // no input consumed, better add an error node
            let tok = e.getOffendingToken();
            if (!tok) throw new Error("Expected exception to have an offending token");
            let source = tok.tokenSource;
            let stream = source !== undefined ? source.inputStream : undefined;
            let sourcePair = {
                source: source,
                stream: stream
            };
            if (e instanceof $5jZSY.InputMismatchException) {
                let expectedTokens = e.expectedTokens;
                if (expectedTokens === undefined) throw new Error("Expected the exception to provide expected tokens");
                let expectedTokenType = $eKXi4.Token.INVALID_TYPE;
                if (!expectedTokens.isNil) // get any element
                expectedTokenType = expectedTokens.minElement;
                let errToken = this.tokenFactory.create(sourcePair, expectedTokenType, tok.text, $eKXi4.Token.DEFAULT_CHANNEL, -1, -1, tok.line, tok.charPositionInLine);
                this._ctx.addErrorNode(this.createErrorNode(this._ctx, errToken));
            } else {
                let source = tok.tokenSource;
                let errToken = this.tokenFactory.create(sourcePair, $eKXi4.Token.INVALID_TYPE, tok.text, $eKXi4.Token.DEFAULT_CHANNEL, -1, -1, tok.line, tok.charPositionInLine);
                this._ctx.addErrorNode(this.createErrorNode(this._ctx, errToken));
            }
        }
    }
    recoverInline() {
        return this._errHandler.recoverInline(this);
    }
    /** Return the root of the parse, which can be useful if the parser
     *  bails out. You still can access the top node. Note that,
     *  because of the way left recursive rules add children, it's possible
     *  that the root will not have any children if the start rule immediately
     *  called and left recursive rule that fails.
     *
     * @since 4.5.1
     */ get rootContext() {
        return this._rootContext;
    }
};
$62706d1c6fe2cac4$var$__decorate([
    $aN41m.NotNull
], $62706d1c6fe2cac4$var$ParserInterpreter.prototype, "_vocabulary", void 0);
$62706d1c6fe2cac4$var$__decorate([
    $aN41m.Override
], $62706d1c6fe2cac4$var$ParserInterpreter.prototype, "reset", null);
$62706d1c6fe2cac4$var$__decorate([
    $aN41m.Override
], $62706d1c6fe2cac4$var$ParserInterpreter.prototype, "atn", null);
$62706d1c6fe2cac4$var$__decorate([
    $aN41m.Override
], $62706d1c6fe2cac4$var$ParserInterpreter.prototype, "vocabulary", null);
$62706d1c6fe2cac4$var$__decorate([
    $aN41m.Override
], $62706d1c6fe2cac4$var$ParserInterpreter.prototype, "ruleNames", null);
$62706d1c6fe2cac4$var$__decorate([
    $aN41m.Override
], $62706d1c6fe2cac4$var$ParserInterpreter.prototype, "grammarFileName", null);
$62706d1c6fe2cac4$var$__decorate([
    $aN41m.Override
], $62706d1c6fe2cac4$var$ParserInterpreter.prototype, "enterRecursionRule", null);
$62706d1c6fe2cac4$var$ParserInterpreter = $62706d1c6fe2cac4$var$__decorate([
    $62706d1c6fe2cac4$var$__param(1, $aN41m.NotNull)
], $62706d1c6fe2cac4$var$ParserInterpreter);
module.exports.ParserInterpreter = $62706d1c6fe2cac4$var$ParserInterpreter;

});

parcelRegister("atcwe", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $79f652cad683467f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleContextWithAltNum = void 0;

var $eeOLb = parcelRequire("eeOLb");

var $aN41m = parcelRequire("aN41m");

var $2pDMz = parcelRequire("2pDMz");
/** A handy class for use with
 *
 *  options {contextSuperClass=org.antlr.v4.runtime.RuleContextWithAltNum;}
 *
 *  that provides a backing field / impl for the outer alternative number
 *  matched for an internal parse tree node.
 *
 *  I'm only putting into Java runtime as I'm certain I'm the only one that
 *  will really every use this.
 */ class $79f652cad683467f$var$RuleContextWithAltNum extends $2pDMz.ParserRuleContext {
    constructor(parent, invokingStateNumber){
        if (invokingStateNumber !== undefined) super(parent, invokingStateNumber);
        else super();
        this._altNumber = $eeOLb.ATN.INVALID_ALT_NUMBER;
    }
    get altNumber() {
        return this._altNumber;
    }
    // @Override
    set altNumber(altNum) {
        this._altNumber = altNum;
    }
}
$79f652cad683467f$var$__decorate([
    $aN41m.Override
], $79f652cad683467f$var$RuleContextWithAltNum.prototype, "altNumber", null);
module.exports.RuleContextWithAltNum = $79f652cad683467f$var$RuleContextWithAltNum;

});

parcelRegister("3d5Fu", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleDependency = void 0;
/**
 * Declares a dependency upon a grammar rule, along with a set of zero or more dependent rules.
 *
 * Version numbers within a grammar should be assigned on a monotonically increasing basis to allow for accurate
 * tracking of dependent rules.
 *
 * @author Sam Harwell
 */ function $2566fb8eb3eb638e$var$RuleDependency(dependency) {
    return (target, propertyKey, propertyDescriptor)=>{
    // intentionally empty
    };
}
module.exports.RuleDependency = $2566fb8eb3eb638e$var$RuleDependency;

});

parcelRegister("hHHux", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleVersion = void 0;
/**
 *
 * @author Sam Harwell
 */ function $ce3830527f1ccb0d$var$RuleVersion(version) {
    return (target, propertyKey, propertyDescriptor)=>{
    // intentionally empty
    };
}
module.exports.RuleVersion = $ce3830527f1ccb0d$var$RuleVersion;

});

parcelRegister("lL3Js", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("03lZa", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("b3QEj", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("hwMU6", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $cc2b5c1f9eca6d60$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RewriteOperation = module.exports.TokenStreamRewriter = void 0;

var $l8y5T = parcelRequire("l8y5T");

var $aN41m = parcelRequire("aN41m");

var $eKXi4 = parcelRequire("eKXi4");
/**
 * Useful for rewriting out a buffered input token stream after doing some
 * augmentation or other manipulations on it.
 *
 * You can insert stuff, replace, and delete chunks. Note that the operations
 * are done lazily--only if you convert the buffer to a {@link String} with
 * {@link TokenStream#getText()}. This is very efficient because you are not
 * moving data around all the time. As the buffer of tokens is converted to
 * strings, the {@link #getText()} method(s) scan the input token stream and
 * check to see if there is an operation at the current index. If so, the
 * operation is done and then normal {@link String} rendering continues on the
 * buffer. This is like having multiple Turing machine instruction streams
 * (programs) operating on a single input tape. :)
 *
 * This rewriter makes no modifications to the token stream. It does not ask the
 * stream to fill itself up nor does it advance the input cursor. The token
 * stream `TokenStream.index` will return the same value before and
 * after any {@link #getText()} call.
 *
 * The rewriter only works on tokens that you have in the buffer and ignores the
 * current input cursor. If you are buffering tokens on-demand, calling
 * {@link #getText()} halfway through the input will only do rewrites for those
 * tokens in the first half of the file.
 *
 * Since the operations are done lazily at {@link #getText}-time, operations do
 * not screw up the token index values. That is, an insert operation at token
 * index `i` does not change the index values for tokens
 * `i`+1..n-1.
 *
 * Because operations never actually alter the buffer, you may always get the
 * original token stream back without undoing anything. Since the instructions
 * are queued up, you can easily simulate transactions and roll back any changes
 * if there is an error just by removing instructions. For example,
 *
 * ```
 * CharStream input = new ANTLRFileStream("input");
 * TLexer lex = new TLexer(input);
 * CommonTokenStream tokens = new CommonTokenStream(lex);
 * T parser = new T(tokens);
 * TokenStreamRewriter rewriter = new TokenStreamRewriter(tokens);
 * parser.startRule();
 * ```
 *
 * Then in the rules, you can execute (assuming rewriter is visible):
 *
 * ```
 * Token t,u;
 * ...
 * rewriter.insertAfter(t, "text to put after t");}
 * rewriter.insertAfter(u, "text after u");}
 * System.out.println(rewriter.getText());
 * ```
 *
 * You can also have multiple "instruction streams" and get multiple rewrites
 * from a single pass over the input. Just name the instruction streams and use
 * that name again when printing the buffer. This could be useful for generating
 * a C file and also its header file--all from the same buffer:
 *
 * ```
 * rewriter.insertAfter("pass1", t, "text to put after t");}
 * rewriter.insertAfter("pass2", u, "text after u");}
 * System.out.println(rewriter.getText("pass1"));
 * System.out.println(rewriter.getText("pass2"));
 * ```
 *
 * If you don't use named rewrite streams, a "default" stream is used as the
 * first example shows.
 */ class $cc2b5c1f9eca6d60$var$TokenStreamRewriter {
    constructor(tokens){
        this.tokens = tokens;
        this.programs = new Map();
        this.programs.set($cc2b5c1f9eca6d60$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME, []);
        this.lastRewriteTokenIndexes = new Map();
    }
    getTokenStream() {
        return this.tokens;
    }
    rollback(instructionIndex, programName = $cc2b5c1f9eca6d60$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let is = this.programs.get(programName);
        if (is != null) this.programs.set(programName, is.slice($cc2b5c1f9eca6d60$var$TokenStreamRewriter.MIN_TOKEN_INDEX, instructionIndex));
    }
    deleteProgram(programName = $cc2b5c1f9eca6d60$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        this.rollback($cc2b5c1f9eca6d60$var$TokenStreamRewriter.MIN_TOKEN_INDEX, programName);
    }
    insertAfter(tokenOrIndex, text, programName = $cc2b5c1f9eca6d60$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let index;
        if (typeof tokenOrIndex === "number") index = tokenOrIndex;
        else index = tokenOrIndex.tokenIndex;
        // to insert after, just insert before next index (even if past end)
        let rewrites = this.getProgram(programName);
        let op = new $cc2b5c1f9eca6d60$var$InsertAfterOp(this.tokens, index, rewrites.length, text);
        rewrites.push(op);
    }
    insertBefore(tokenOrIndex, text, programName = $cc2b5c1f9eca6d60$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let index;
        if (typeof tokenOrIndex === "number") index = tokenOrIndex;
        else index = tokenOrIndex.tokenIndex;
        let rewrites = this.getProgram(programName);
        let op = new $cc2b5c1f9eca6d60$var$InsertBeforeOp(this.tokens, index, rewrites.length, text);
        rewrites.push(op);
    }
    replaceSingle(index, text) {
        if (typeof index === "number") this.replace(index, index, text);
        else this.replace(index, index, text);
    }
    replace(from, to, text, programName = $cc2b5c1f9eca6d60$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        if (typeof from !== "number") from = from.tokenIndex;
        if (typeof to !== "number") to = to.tokenIndex;
        if (from > to || from < 0 || to < 0 || to >= this.tokens.size) throw new RangeError(`replace: range invalid: ${from}..${to}(size=${this.tokens.size})`);
        let rewrites = this.getProgram(programName);
        let op = new $cc2b5c1f9eca6d60$var$ReplaceOp(this.tokens, from, to, rewrites.length, text);
        rewrites.push(op);
    }
    delete(from, to, programName = $cc2b5c1f9eca6d60$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        if (to === undefined) to = from;
        if (typeof from === "number") this.replace(from, to, "", programName);
        else this.replace(from, to, "", programName);
    }
    getLastRewriteTokenIndex(programName = $cc2b5c1f9eca6d60$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let I = this.lastRewriteTokenIndexes.get(programName);
        if (I == null) return -1;
        return I;
    }
    setLastRewriteTokenIndex(programName, i) {
        this.lastRewriteTokenIndexes.set(programName, i);
    }
    getProgram(name) {
        let is = this.programs.get(name);
        if (is == null) is = this.initializeProgram(name);
        return is;
    }
    initializeProgram(name) {
        let is = [];
        this.programs.set(name, is);
        return is;
    }
    getText(intervalOrProgram, programName = $cc2b5c1f9eca6d60$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let interval;
        if (intervalOrProgram instanceof $l8y5T.Interval) interval = intervalOrProgram;
        else interval = $l8y5T.Interval.of(0, this.tokens.size - 1);
        if (typeof intervalOrProgram === "string") programName = intervalOrProgram;
        let rewrites = this.programs.get(programName);
        let start = interval.a;
        let stop = interval.b;
        // ensure start/end are in range
        if (stop > this.tokens.size - 1) stop = this.tokens.size - 1;
        if (start < 0) start = 0;
        if (rewrites == null || rewrites.length === 0) return this.tokens.getText(interval); // no instructions to execute
        let buf = [];
        // First, optimize instruction stream
        let indexToOp = this.reduceToSingleOperationPerIndex(rewrites);
        // Walk buffer, executing instructions and emitting tokens
        let i = start;
        while(i <= stop && i < this.tokens.size){
            let op = indexToOp.get(i);
            indexToOp.delete(i); // remove so any left have index size-1
            let t = this.tokens.get(i);
            if (op == null) {
                // no operation at that index, just dump token
                if (t.type !== $eKXi4.Token.EOF) buf.push(String(t.text));
                i++; // move to next token
            } else i = op.execute(buf); // execute operation and skip
        }
        // include stuff after end if it's last index in buffer
        // So, if they did an insertAfter(lastValidIndex, "foo"), include
        // foo if end==lastValidIndex.
        if (stop === this.tokens.size - 1) {
            // Scan any remaining operations after last token
            // should be included (they will be inserts).
            for (let op of indexToOp.values())if (op.index >= this.tokens.size - 1) buf.push(op.text.toString());
        }
        return buf.join("");
    }
    /** We need to combine operations and report invalid operations (like
     *  overlapping replaces that are not completed nested). Inserts to
     *  same index need to be combined etc...  Here are the cases:
     *
     *  I.i.u I.j.v								leave alone, nonoverlapping
     *  I.i.u I.i.v								combine: Iivu
     *
     *  R.i-j.u R.x-y.v	| i-j in x-y			delete first R
     *  R.i-j.u R.i-j.v							delete first R
     *  R.i-j.u R.x-y.v	| x-y in i-j			ERROR
     *  R.i-j.u R.x-y.v	| boundaries overlap	ERROR
     *
     *  Delete special case of replace (text==undefined):
     *  D.i-j.u D.x-y.v	| boundaries overlap	combine to max(min)..max(right)
     *
     *  I.i.u R.x-y.v | i in (x+1)-y			delete I (since insert before
     * 											we're not deleting i)
     *  I.i.u R.x-y.v | i not in (x+1)-y		leave alone, nonoverlapping
     *  R.x-y.v I.i.u | i in x-y				ERROR
     *  R.x-y.v I.x.u 							R.x-y.uv (combine, delete I)
     *  R.x-y.v I.i.u | i not in x-y			leave alone, nonoverlapping
     *
     *  I.i.u = insert u before op @ index i
     *  R.x-y.u = replace x-y indexed tokens with u
     *
     *  First we need to examine replaces. For any replace op:
     *
     * 		1. wipe out any insertions before op within that range.
     * 		2. Drop any replace op before that is contained completely within
     * 	 that range.
     * 		3. Throw exception upon boundary overlap with any previous replace.
     *
     *  Then we can deal with inserts:
     *
     * 		1. for any inserts to same index, combine even if not adjacent.
     * 		2. for any prior replace with same left boundary, combine this
     * 	 insert with replace and delete this replace.
     * 		3. throw exception if index in same range as previous replace
     *
     *  Don't actually delete; make op undefined in list. Easier to walk list.
     *  Later we can throw as we add to index &rarr; op map.
     *
     *  Note that I.2 R.2-2 will wipe out I.2 even though, technically, the
     *  inserted stuff would be before the replace range. But, if you
     *  add tokens in front of a method body '{' and then delete the method
     *  body, I think the stuff before the '{' you added should disappear too.
     *
     *  Return a map from token index to operation.
     */ reduceToSingleOperationPerIndex(rewrites) {
        // console.log(`rewrites=[${Utils.join(rewrites, ", ")}]`);
        // WALK REPLACES
        for(let i = 0; i < rewrites.length; i++){
            let op = rewrites[i];
            if (op == null) continue;
            if (!(op instanceof $cc2b5c1f9eca6d60$var$ReplaceOp)) continue;
            let rop = op;
            // Wipe prior inserts within range
            let inserts = this.getKindOfOps(rewrites, $cc2b5c1f9eca6d60$var$InsertBeforeOp, i);
            for (let iop of inserts){
                if (iop.index === rop.index) {
                    // E.g., insert before 2, delete 2..2; update replace
                    // text to include insert before, kill insert
                    rewrites[iop.instructionIndex] = undefined;
                    rop.text = iop.text.toString() + (rop.text != null ? rop.text.toString() : "");
                } else if (iop.index > rop.index && iop.index <= rop.lastIndex) // delete insert as it's a no-op.
                rewrites[iop.instructionIndex] = undefined;
            }
            // Drop any prior replaces contained within
            let prevReplaces = this.getKindOfOps(rewrites, $cc2b5c1f9eca6d60$var$ReplaceOp, i);
            for (let prevRop of prevReplaces){
                if (prevRop.index >= rop.index && prevRop.lastIndex <= rop.lastIndex) {
                    // delete replace as it's a no-op.
                    rewrites[prevRop.instructionIndex] = undefined;
                    continue;
                }
                // throw exception unless disjoint or identical
                let disjoint = prevRop.lastIndex < rop.index || prevRop.index > rop.lastIndex;
                // Delete special case of replace (text==null):
                // D.i-j.u D.x-y.v	| boundaries overlap	combine to max(min)..max(right)
                if (prevRop.text == null && rop.text == null && !disjoint) {
                    // console.log(`overlapping deletes: ${prevRop}, ${rop}`);
                    rewrites[prevRop.instructionIndex] = undefined; // kill first delete
                    rop.index = Math.min(prevRop.index, rop.index);
                    rop.lastIndex = Math.max(prevRop.lastIndex, rop.lastIndex);
                // console.log(`new rop ${rop}`);
                } else if (!disjoint) throw new Error(`replace op boundaries of ${rop} overlap with previous ${prevRop}`);
            }
        }
        // WALK INSERTS
        for(let i = 0; i < rewrites.length; i++){
            let op = rewrites[i];
            if (op == null) continue;
            if (!(op instanceof $cc2b5c1f9eca6d60$var$InsertBeforeOp)) continue;
            let iop = op;
            // combine current insert with prior if any at same index
            let prevInserts = this.getKindOfOps(rewrites, $cc2b5c1f9eca6d60$var$InsertBeforeOp, i);
            for (let prevIop of prevInserts)if (prevIop.index === iop.index) {
                if (prevIop instanceof $cc2b5c1f9eca6d60$var$InsertAfterOp) {
                    iop.text = this.catOpText(prevIop.text, iop.text);
                    rewrites[prevIop.instructionIndex] = undefined;
                } else if (prevIop instanceof $cc2b5c1f9eca6d60$var$InsertBeforeOp) {
                    // convert to strings...we're in process of toString'ing
                    // whole token buffer so no lazy eval issue with any templates
                    iop.text = this.catOpText(iop.text, prevIop.text);
                    // delete redundant prior insert
                    rewrites[prevIop.instructionIndex] = undefined;
                }
            }
            // look for replaces where iop.index is in range; error
            let prevReplaces = this.getKindOfOps(rewrites, $cc2b5c1f9eca6d60$var$ReplaceOp, i);
            for (let rop of prevReplaces){
                if (iop.index === rop.index) {
                    rop.text = this.catOpText(iop.text, rop.text);
                    rewrites[i] = undefined; // delete current insert
                    continue;
                }
                if (iop.index >= rop.index && iop.index <= rop.lastIndex) throw new Error(`insert op ${iop} within boundaries of previous ${rop}`);
            }
        }
        // console.log(`rewrites after=[${Utils.join(rewrites, ", ")}]`);
        let m = new Map();
        for (let op of rewrites){
            if (op == null) continue;
            if (m.get(op.index) != null) throw new Error("should only be one op per index");
            m.set(op.index, op);
        }
        // console.log(`index to op: ${m}`);
        return m;
    }
    catOpText(a, b) {
        let x = "";
        let y = "";
        if (a != null) x = a.toString();
        if (b != null) y = b.toString();
        return x + y;
    }
    /** Get all operations before an index of a particular kind */ getKindOfOps(rewrites, kind, before) {
        let ops = [];
        for(let i = 0; i < before && i < rewrites.length; i++){
            let op = rewrites[i];
            if (op == null) continue;
            if (op instanceof kind) ops.push(op);
        }
        return ops;
    }
}
module.exports.TokenStreamRewriter = $cc2b5c1f9eca6d60$var$TokenStreamRewriter;
$cc2b5c1f9eca6d60$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME = "default";
$cc2b5c1f9eca6d60$var$TokenStreamRewriter.PROGRAM_INIT_SIZE = 100;
$cc2b5c1f9eca6d60$var$TokenStreamRewriter.MIN_TOKEN_INDEX = 0;
// Define the rewrite operation hierarchy
class $cc2b5c1f9eca6d60$var$RewriteOperation {
    constructor(tokens, index, instructionIndex, text){
        this.tokens = tokens;
        this.instructionIndex = instructionIndex;
        this.index = index;
        this.text = text === undefined ? "" : text;
    }
    /** Execute the rewrite operation by possibly adding to the buffer.
     *  Return the index of the next token to operate on.
     */ execute(buf) {
        return this.index;
    }
    toString() {
        let opName = this.constructor.name;
        let $index = opName.indexOf("$");
        opName = opName.substring($index + 1, opName.length);
        return "<" + opName + "@" + this.tokens.get(this.index) + ":\"" + this.text + "\">";
    }
}
$cc2b5c1f9eca6d60$var$__decorate([
    $aN41m.Override
], $cc2b5c1f9eca6d60$var$RewriteOperation.prototype, "toString", null);
module.exports.RewriteOperation = $cc2b5c1f9eca6d60$var$RewriteOperation;
class $cc2b5c1f9eca6d60$var$InsertBeforeOp extends $cc2b5c1f9eca6d60$var$RewriteOperation {
    constructor(tokens, index, instructionIndex, text){
        super(tokens, index, instructionIndex, text);
    }
    execute(buf) {
        buf.push(this.text.toString());
        if (this.tokens.get(this.index).type !== $eKXi4.Token.EOF) buf.push(String(this.tokens.get(this.index).text));
        return this.index + 1;
    }
}
$cc2b5c1f9eca6d60$var$__decorate([
    $aN41m.Override
], $cc2b5c1f9eca6d60$var$InsertBeforeOp.prototype, "execute", null);
/** Distinguish between insert after/before to do the "insert afters"
 *  first and then the "insert befores" at same index. Implementation
 *  of "insert after" is "insert before index+1".
 */ class $cc2b5c1f9eca6d60$var$InsertAfterOp extends $cc2b5c1f9eca6d60$var$InsertBeforeOp {
    constructor(tokens, index, instructionIndex, text){
        super(tokens, index + 1, instructionIndex, text); // insert after is insert before index+1
    }
}
/** I'm going to try replacing range from x..y with (y-x)+1 ReplaceOp
 *  instructions.
 */ class $cc2b5c1f9eca6d60$var$ReplaceOp extends $cc2b5c1f9eca6d60$var$RewriteOperation {
    constructor(tokens, from, to, instructionIndex, text){
        super(tokens, from, instructionIndex, text);
        this.lastIndex = to;
    }
    execute(buf) {
        if (this.text != null) buf.push(this.text.toString());
        return this.lastIndex + 1;
    }
    toString() {
        if (this.text == null) return "<DeleteOp@" + this.tokens.get(this.index) + ".." + this.tokens.get(this.lastIndex) + ">";
        return "<ReplaceOp@" + this.tokens.get(this.index) + ".." + this.tokens.get(this.lastIndex) + ":\"" + this.text + "\">";
    }
}
$cc2b5c1f9eca6d60$var$__decorate([
    $aN41m.Override
], $cc2b5c1f9eca6d60$var$ReplaceOp.prototype, "execute", null);
$cc2b5c1f9eca6d60$var$__decorate([
    $aN41m.Override
], $cc2b5c1f9eca6d60$var$ReplaceOp.prototype, "toString", null);

});

parcelRegister("2YAkU", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("edl4x", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("8YcxO", function(module, exports) {

$parcel$export(module.exports, "JQLLexer", () => $80306ddcd52cd923$export$375c79404cc64c7f);
/* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// Generated from JQLLexer.g4 by ANTLR 4.7.3-SNAPSHOT

var $1ztRl = parcelRequire("1ztRl");

var $h7Q3L = parcelRequire("h7Q3L");

var $2160U = parcelRequire("2160U");

var $hBnE1 = parcelRequire("hBnE1");

var $62Uvn = parcelRequire("62Uvn");
class $80306ddcd52cd923$export$375c79404cc64c7f extends (0, $h7Q3L.Lexer) {
    static{
        this.LPAREN = 1;
    }
    static{
        this.RPAREN = 2;
    }
    static{
        this.COMMA = 3;
    }
    static{
        this.LBRACKET = 4;
    }
    static{
        this.RBRACKET = 5;
    }
    static{
        this.BANG = 6;
    }
    static{
        this.LT = 7;
    }
    static{
        this.GT = 8;
    }
    static{
        this.GTEQ = 9;
    }
    static{
        this.LTEQ = 10;
    }
    static{
        this.EQUALS = 11;
    }
    static{
        this.NOT_EQUALS = 12;
    }
    static{
        this.LIKE = 13;
    }
    static{
        this.NOT_LIKE = 14;
    }
    static{
        this.IN = 15;
    }
    static{
        this.IS = 16;
    }
    static{
        this.AND = 17;
    }
    static{
        this.OR = 18;
    }
    static{
        this.NOT = 19;
    }
    static{
        this.EMPTY = 20;
    }
    static{
        this.WAS = 21;
    }
    static{
        this.CHANGED = 22;
    }
    static{
        this.BEFORE = 23;
    }
    static{
        this.AFTER = 24;
    }
    static{
        this.FROM = 25;
    }
    static{
        this.TO = 26;
    }
    static{
        this.ON = 27;
    }
    static{
        this.DURING = 28;
    }
    static{
        this.ORDER = 29;
    }
    static{
        this.BY = 30;
    }
    static{
        this.ASC = 31;
    }
    static{
        this.DESC = 32;
    }
    static{
        this.POSNUMBER = 33;
    }
    static{
        this.NEGNUMBER = 34;
    }
    static{
        this.CUSTOMFIELD = 35;
    }
    static{
        this.RESERVED_WORD = 36;
    }
    static{
        this.STRING = 37;
    }
    static{
        this.MATCHWS = 38;
    }
    static{
        this.ERROR_RESERVED = 39;
    }
    static{
        this.ERRORCHAR = 40;
    }
    static{
        this.QUOTE_STRING = 41;
    }
    static{
        this.UNCLOSED_QUOTE_STRING = 42;
    }
    static{
        this.INVALID_QUOTE_STRING = 43;
    }
    static{
        this.SQUOTE_STRING = 44;
    }
    static{
        this.UNCLOSED_SQUOTE_STRING = 45;
    }
    static{
        this.INVALID_SQUOTE_STRING = 46;
    }
    static{
        this.QUOTED_STR = 1;
    }
    static{
        this.SQUOTED_STR = 2;
    }
    static{
        // tslint:disable:no-trailing-whitespace
        this.channelNames = [
            'DEFAULT_TOKEN_CHANNEL',
            'HIDDEN'
        ];
    }
    static{
        // tslint:disable:no-trailing-whitespace
        this.modeNames = [
            'DEFAULT_MODE',
            'QUOTED_STR',
            'SQUOTED_STR'
        ];
    }
    static{
        this.ruleNames = [
            'LPAREN',
            'RPAREN',
            'COMMA',
            'LBRACKET',
            'RBRACKET',
            'LQUOTE',
            'LSQUOTE',
            'BANG',
            'LT',
            'GT',
            'GTEQ',
            'LTEQ',
            'EQUALS',
            'NOT_EQUALS',
            'LIKE',
            'NOT_LIKE',
            'IN',
            'IS',
            'AND',
            'OR',
            'NOT',
            'EMPTY',
            'WAS',
            'CHANGED',
            'BEFORE',
            'AFTER',
            'FROM',
            'TO',
            'ON',
            'DURING',
            'ORDER',
            'BY',
            'ASC',
            'DESC',
            'POSNUMBER',
            'NEGNUMBER',
            'CUSTOMFIELD',
            'RESERVED_WORD',
            'STRING',
            'MATCHWS',
            'ERROR_RESERVED',
            'ERRORCHAR',
            'QUOTE_STRING',
            'QUOTED_CONTENT',
            'UNCLOSED_QUOTE_STRING',
            'INVALID_QUOTE_STRING',
            'SQUOTE_STRING',
            'SQUOTED_CONTENT',
            'UNCLOSED_SQUOTE_STRING',
            'INVALID_SQUOTE_STRING',
            'VALID_UNQUOTED_CHARS',
            'VALID_QUOTED_CHARS',
            'VALID_SQUOTED_CHARS',
            'RESERVED_CHARS',
            'QUOTE',
            'SQUOTE',
            'BSLASH',
            'NL',
            'CR',
            'SPACE',
            'AMPER',
            'AMPER_AMPER',
            'PIPE',
            'PIPE_PIPE',
            'ESCAPE',
            'NEWLINE',
            'HEXDIGIT',
            'WS',
            'MINUS',
            'DIGIT',
            'A',
            'B',
            'C',
            'D',
            'E',
            'F',
            'G',
            'H',
            'I',
            'J',
            'K',
            'L',
            'M',
            'N',
            'O',
            'P',
            'Q',
            'R',
            'S',
            'T',
            'U',
            'V',
            'W',
            'X',
            'Y',
            'Z'
        ];
    }
    static{
        this._LITERAL_NAMES = [
            undefined,
            "'('",
            "')'",
            "','",
            "'['",
            "']'",
            "'!'",
            "'<'",
            "'>'",
            "'>='",
            "'<='",
            "'='",
            "'!='",
            "'~'",
            "'!~'"
        ];
    }
    static{
        this._SYMBOLIC_NAMES = [
            undefined,
            'LPAREN',
            'RPAREN',
            'COMMA',
            'LBRACKET',
            'RBRACKET',
            'BANG',
            'LT',
            'GT',
            'GTEQ',
            'LTEQ',
            'EQUALS',
            'NOT_EQUALS',
            'LIKE',
            'NOT_LIKE',
            'IN',
            'IS',
            'AND',
            'OR',
            'NOT',
            'EMPTY',
            'WAS',
            'CHANGED',
            'BEFORE',
            'AFTER',
            'FROM',
            'TO',
            'ON',
            'DURING',
            'ORDER',
            'BY',
            'ASC',
            'DESC',
            'POSNUMBER',
            'NEGNUMBER',
            'CUSTOMFIELD',
            'RESERVED_WORD',
            'STRING',
            'MATCHWS',
            'ERROR_RESERVED',
            'ERRORCHAR',
            'QUOTE_STRING',
            'UNCLOSED_QUOTE_STRING',
            'INVALID_QUOTE_STRING',
            'SQUOTE_STRING',
            'UNCLOSED_SQUOTE_STRING',
            'INVALID_SQUOTE_STRING'
        ];
    }
    static{
        this.VOCABULARY = new (0, $hBnE1.VocabularyImpl)($80306ddcd52cd923$export$375c79404cc64c7f._LITERAL_NAMES, $80306ddcd52cd923$export$375c79404cc64c7f._SYMBOLIC_NAMES, []);
    }
    // @Override
    // @NotNull
    get vocabulary() {
        return $80306ddcd52cd923$export$375c79404cc64c7f.VOCABULARY;
    }
    // tslint:enable:no-trailing-whitespace
    constructor(input){
        super(input);
        this._interp = new (0, $2160U.LexerATNSimulator)($80306ddcd52cd923$export$375c79404cc64c7f._ATN, this);
    }
    // @Override
    get grammarFileName() {
        return 'JQLLexer.g4';
    }
    // @Override
    get ruleNames() {
        return $80306ddcd52cd923$export$375c79404cc64c7f.ruleNames;
    }
    // @Override
    get serializedATN() {
        return $80306ddcd52cd923$export$375c79404cc64c7f._serializedATN;
    }
    // @Override
    get channelNames() {
        return $80306ddcd52cd923$export$375c79404cc64c7f.channelNames;
    }
    // @Override
    get modeNames() {
        return $80306ddcd52cd923$export$375c79404cc64c7f.modeNames;
    }
    static{
        this._serializedATNSegments = 3;
    }
    static{
        this._serializedATNSegment0 = "\x03\uC91D\uCABA\u058D\uAFBA\u4F53\u0607\uEA8B\uC241\x020\u062E\b\x01\b\x01\b\x01\x04\x02	\x02\x04\x03	\x03\x04\x04	\x04\x04\x05	\x05\x04\x06	\x06\x04\x07	\x07\x04\b	\b\x04			\x04\n	\n\x04\v	\v\x04\f	\f\x04\r	\r\x04\x0e	\x0e\x04\x0f	\x0f\x04\x10	\x10\x04\x11	\x11\x04\x12	\x12\x04\x13	\x13\x04\x14	\x14\x04\x15	\x15\x04\x16	\x16\x04\x17	\x17\x04\x18	\x18\x04\x19	\x19\x04\x1a	\x1a\x04\x1b	\x1b\x04\x1c	\x1c\x04\x1d	\x1d\x04\x1e	\x1e\x04\x1f	\x1f\x04 	 \x04!	!\x04\"	\"\x04#	#\x04$	$\x04%	%\x04&	&\x04'	'\x04(	(\x04)	)\x04*	*\x04+	+\x04,	,\x04-	-\x04.	.\x04/	/\x040	0\x041	1\x042	2\x043	3\x044	4\x045	5\x046	6\x047	7\x048	8\x049	9\x04:	:\x04;	;\x04<	<\x04=	=\x04>	>\x04?	?\x04@	@\x04A	A\x04B	B\x04C	C\x04D	D\x04E	E\x04F	F\x04G	G\x04H	H\x04I	I\x04J	J\x04K	K\x04L	L\x04M	M\x04N	N\x04O	O\x04P	P\x04Q	Q\x04R	R\x04S	S\x04T	T\x04U	U\x04V	V\x04W	W\x04X	X\x04Y	Y\x04Z	Z\x04[	[\x04\\	\\\x04]	]\x04^	^\x04_	_\x04`	`\x04a	a\x03\x02\x03\x02\x03\x03\x03\x03\x03\x04\x03\x04\x03\x05\x03\x05\x03\x06\x03\x06\x03\x07\x03\x07\x03\x07\x03\x07\x03\x07\x03\b\x03\b\x03\b\x03\b\x03\b\x03	\x03	\x03\n\x03\n\x03\v\x03\v\x03\f\x03\f\x03\f\x03\r\x03\r\x03\r\x03\x0e\x03\x0e\x03\x0f\x03\x0f\x03\x0f\x03\x10\x03\x10\x03\x11\x03\x11\x03\x11\x03\x12\x03\x12\x03\x12\x03\x13\x03\x13\x03\x13\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x05\x14\xfc\n\x14\x03\x15\x03\x15\x03\x15\x03\x15\x03\x15\x05\x15\u0103\n\x15\x03\x16\x03\x16\x03\x16\x03\x16\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x05\x17\u0114\n\x17\x03\x18\x03\x18\x03\x18\x03\x18\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1c\x03\x1c\x03\x1c\x03\x1c\x03\x1c\x03\x1d\x03\x1d\x03\x1d\x03\x1e\x03\x1e\x03\x1e\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03 \x03 \x03 \x03 \x03 \x03 \x03!\x03!\x03!\x03\"\x03\"\x03\"\x03\"\x03#\x03#\x03#\x03#\x03#\x03$\x06$\u0154\n$\r$\x0e$\u0155\x03%\x03%\x06%\u015A\n%\r%\x0e%\u015B\x03&\x03&\x03&\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x05'\u0582\n'\x03(\x03(\x06(\u0586\n(\r(\x0e(\u0587\x03)\x06)\u058B\n)\r)\x0e)\u058C\x03)\x03)\x03*\x03*\x03+\x03+\x03,\x03,\x03,\x03,\x03-\x03-\x05-\u059B\n-\x03-\x03-\x03.\x03.\x03.\x03.\x03/\x03/\x03/\x03/\x030\x030\x030\x030\x031\x031\x051\u05AD\n1\x031\x031\x032\x032\x032\x032\x033\x033\x033\x033\x034\x034\x035\x035\x036\x036\x037\x037\x038\x038\x039\x039\x03:\x03:\x03;\x03;\x03<\x03<\x03=\x03=\x03>\x03>\x03?\x03?\x03?\x03@\x03@\x03A\x03A\x03A\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x05B\u05E3\nB\x03C\x03C\x05C\u05E7\nC\x03D\x03D\x03D\x03D\x03D\x03D\x03D\x05D\u05F0\nD\x03E\x03E\x03E\x05E\u05F5\nE\x03F\x03F\x03G\x03G\x03H\x03H\x03I\x03I\x03J\x03J\x03K\x03K\x03L\x03L\x03M\x03M\x03N\x03N\x03O\x03O\x03P\x03P\x03Q\x03Q\x03R\x03R\x03S\x03S\x03T\x03T\x03U\x03U\x03V\x03V\x03W\x03W\x03X\x03X\x03Y\x03Y\x03Z\x03Z\x03[\x03[\x03\\\x03\\\x03]\x03]\x03^\x03^\x03_\x03_\x03`\x03`\x03a\x03a\x02\x02\x02b\x05\x02\x03\x07\x02\x04	\x02\x05\v\x02\x06\r\x02\x07\x0f\x02\x02\x11\x02\x02\x13\x02\b\x15\x02	\x17\x02\n\x19\x02\v\x1b\x02\f\x1d\x02\r\x1f\x02\x0e!\x02\x0f#\x02\x10%\x02\x11'\x02\x12)\x02\x13+\x02\x14-\x02\x15/\x02\x161\x02\x173\x02\x185\x02\x197\x02\x1a9\x02\x1b;\x02\x1c=\x02\x1d?\x02\x1eA\x02\x1fC\x02 E\x02!G\x02\"I\x02#K\x02$M\x02%O\x02&Q\x02'S\x02(U\x02)W\x02*Y\x02+[\x02\x02]\x02,_\x02-a\x02.c\x02\x02e\x02/g\x020i\x02\x02k\x02\x02m\x02\x02o\x02\x02q\x02\x02s\x02\x02u\x02\x02w\x02\x02y\x02\x02{\x02\x02}\x02\x02\x7f\x02\x02\x81\x02\x02\x83\x02\x02\x85\x02\x02\x87\x02\x02\x89\x02\x02\x8b\x02\x02\x8d\x02\x02\x8f\x02\x02\x91\x02\x02\x93\x02\x02\x95\x02\x02\x97\x02\x02\x99\x02\x02\x9b\x02\x02\x9d\x02\x02\x9f\x02\x02\xa1\x02\x02\xa3\x02\x02\xa5\x02\x02\xa7\x02\x02\xa9\x02\x02\xab\x02\x02\xad\x02\x02\xaf\x02\x02\xb1\x02\x02\xb3\x02\x02\xb5\x02\x02\xb7\x02\x02\xb9\x02\x02\xbb\x02\x02\xbd\x02\x02\xbf\x02\x02\xc1\x02\x02\xc3\x02\x02\x05\x02\x03\x04\"	\x02\x02.11=B]`}\xa1\uFDD2\uFDF1\0\x01\n\x02\x02\v\r\x0e\x10!$$^^\x81\xa1\uFDD2\uFDF1\0\x01\n\x02\x02\v\r\x0e\x10!))^^\x81\xa1\uFDD2\uFDF1\0\x01\n\x02%',-11==AB``}}\x7f\x7f\x05\x02ppttvv\x03\x022;\x04\x02CCcc\x04\x02DDdd\x04\x02EEee\x04\x02FFff\x04\x02GGgg\x04\x02HHhh\x04\x02IIii\x04\x02JJjj\x04\x02KKkk\x04\x02LLll\x04\x02MMmm\x04\x02NNnn\x04\x02OOoo\x04\x02PPpp\x04\x02QQqq\x04\x02RRrr\x04\x02SSss\x04\x02TTtt\x04\x02UUuu\x04\x02VVvv\x04\x02WWww\x04\x02XXxx\x04\x02YYyy\x04\x02ZZzz\x04\x02[[{{\x04\x02\\\\||\x02\u06B5\x02\x05\x03\x02\x02\x02\x02\x07\x03\x02\x02\x02\x02	\x03\x02\x02\x02\x02\v\x03\x02\x02\x02\x02\r\x03\x02\x02\x02\x02\x0f\x03\x02\x02\x02\x02\x11\x03\x02\x02\x02\x02\x13\x03\x02\x02\x02\x02\x15\x03\x02\x02\x02\x02\x17\x03\x02\x02\x02\x02\x19\x03\x02\x02\x02\x02\x1b\x03\x02\x02\x02\x02\x1d\x03\x02\x02\x02\x02\x1f\x03\x02\x02\x02\x02!\x03\x02\x02\x02\x02#\x03\x02\x02\x02\x02%\x03\x02\x02\x02\x02'\x03\x02\x02\x02\x02)\x03\x02\x02\x02\x02+\x03\x02\x02\x02\x02-\x03\x02\x02\x02\x02/\x03\x02\x02\x02\x021\x03\x02\x02\x02\x023\x03\x02\x02\x02\x025\x03\x02\x02\x02\x027\x03\x02\x02\x02\x029\x03\x02\x02\x02\x02;\x03\x02\x02\x02\x02=\x03\x02\x02\x02\x02?\x03\x02\x02\x02\x02A\x03\x02\x02\x02\x02C\x03\x02\x02\x02\x02E\x03\x02\x02\x02\x02G\x03\x02\x02\x02\x02I\x03\x02\x02\x02\x02K\x03\x02\x02\x02\x02M\x03\x02\x02\x02\x02O\x03\x02\x02\x02\x02Q\x03\x02\x02\x02\x02S\x03\x02\x02\x02\x02U\x03\x02\x02\x02\x02W\x03\x02\x02\x02\x03Y\x03\x02\x02\x02\x03[\x03\x02\x02\x02\x03]\x03\x02\x02\x02\x03_\x03\x02\x02\x02\x04a\x03\x02\x02\x02\x04c\x03\x02\x02\x02\x04e\x03\x02\x02\x02\x04g\x03\x02\x02\x02\x05\xc5\x03\x02\x02\x02\x07\xc7\x03\x02\x02\x02	\xc9\x03\x02\x02\x02\v\xcb\x03\x02\x02\x02\r\xcd\x03\x02\x02\x02\x0f\xcf\x03\x02\x02\x02\x11\xd4\x03\x02\x02\x02\x13\xd9\x03\x02\x02\x02\x15\xdb\x03\x02\x02\x02\x17\xdd\x03\x02\x02\x02\x19\xdf\x03\x02\x02\x02\x1b\xe2\x03\x02\x02\x02\x1d\xe5\x03\x02\x02\x02\x1f\xe7\x03\x02\x02\x02!\xea\x03\x02\x02\x02#\xec\x03\x02\x02\x02%\xef\x03\x02\x02\x02'\xf2\x03\x02\x02\x02)\xfb\x03\x02\x02\x02+\u0102\x03\x02\x02\x02-\u0104\x03\x02\x02\x02/\u0113\x03\x02\x02\x021\u0115\x03\x02\x02\x023\u0119\x03\x02\x02\x025\u0121\x03\x02\x02\x027\u0128\x03\x02\x02\x029\u012E\x03\x02\x02\x02;\u0133\x03\x02\x02\x02=\u0136\x03\x02\x02\x02?\u0139\x03\x02\x02\x02A\u0140\x03\x02\x02\x02C\u0146\x03\x02\x02\x02E\u0149\x03\x02\x02\x02G\u014D\x03\x02\x02\x02I\u0153\x03\x02\x02\x02K\u0157\x03\x02\x02\x02M\u015D\x03\x02\x02\x02O\u0581\x03\x02\x02\x02Q\u0585\x03\x02\x02\x02S\u058A\x03\x02\x02\x02U\u0590\x03\x02\x02\x02W\u0592\x03\x02\x02\x02Y\u0594\x03\x02\x02\x02[\u059A\x03\x02\x02\x02]\u059E\x03\x02\x02\x02_\u05A2\x03\x02\x02\x02a\u05A6\x03\x02\x02\x02c\u05AC\x03\x02\x02\x02e\u05B0\x03\x02\x02\x02g\u05B4\x03\x02\x02\x02i\u05B8\x03\x02\x02\x02k\u05BA\x03\x02\x02\x02m\u05BC\x03\x02\x02\x02o\u05BE\x03\x02\x02\x02q\u05C0\x03\x02\x02\x02s\u05C2\x03\x02\x02\x02u\u05C4\x03\x02\x02\x02w\u05C6\x03\x02\x02\x02y\u05C8\x03\x02\x02\x02{\u05CA\x03\x02\x02\x02}\u05CC\x03\x02\x02\x02\x7f\u05CE\x03\x02\x02\x02\x81\u05D1\x03\x02\x02\x02\x83\u05D3\x03\x02\x02\x02\x85\u05D6\x03\x02\x02\x02\x87\u05E6\x03\x02\x02\x02\x89\u05EF\x03\x02\x02\x02\x8b\u05F4\x03\x02\x02\x02\x8d\u05F6\x03\x02\x02\x02\x8f\u05F8\x03\x02\x02\x02\x91\u05FA\x03\x02\x02\x02\x93\u05FC\x03\x02\x02\x02\x95\u05FE\x03\x02\x02\x02\x97\u0600\x03\x02\x02\x02\x99\u0602\x03\x02\x02\x02\x9b\u0604\x03\x02\x02\x02\x9d\u0606\x03\x02\x02\x02\x9f\u0608\x03\x02\x02\x02\xa1\u060A\x03\x02\x02\x02\xa3\u060C\x03\x02\x02\x02\xa5\u060E\x03\x02\x02\x02\xa7\u0610\x03\x02\x02\x02\xa9\u0612\x03\x02\x02\x02\xab\u0614\x03\x02\x02\x02\xad\u0616\x03\x02\x02\x02\xaf\u0618\x03\x02\x02\x02\xb1\u061A\x03\x02\x02\x02\xb3\u061C\x03\x02\x02\x02\xb5\u061E\x03\x02\x02\x02\xb7\u0620\x03\x02\x02\x02\xb9\u0622\x03\x02\x02\x02\xbb\u0624\x03\x02\x02\x02\xbd\u0626\x03\x02\x02\x02\xbf\u0628\x03\x02\x02\x02\xc1\u062A\x03\x02\x02\x02\xc3\u062C\x03\x02\x02\x02\xc5\xc6\x07*\x02\x02\xc6\x06\x03\x02\x02\x02\xc7\xc8\x07+\x02\x02\xc8\b\x03\x02\x02\x02\xc9\xca\x07.\x02\x02\xca\n\x03\x02\x02\x02\xcb\xcc\x07]\x02\x02\xcc\f\x03\x02\x02\x02\xcd\xce\x07_\x02\x02\xce\x0e\x03\x02\x02\x02\xcf\xd0\x05q8\x02\xd0\xd1\x03\x02\x02\x02\xd1\xd2\b\x07\x02\x02\xd2\xd3\b\x07\x03\x02\xd3\x10\x03\x02\x02\x02\xd4\xd5\x05s9\x02\xd5\xd6\x03\x02\x02\x02\xd6\xd7\b\b\x02\x02\xd7\xd8\b\b\x04\x02\xd8\x12\x03\x02\x02\x02\xd9\xda\x07#\x02\x02\xda\x14\x03\x02\x02\x02\xdb\xdc\x07>\x02\x02\xdc\x16\x03\x02\x02\x02\xdd\xde\x07@\x02\x02\xde\x18\x03\x02\x02\x02\xdf\xe0\x07@\x02\x02\xe0\xe1\x07?\x02\x02\xe1\x1a\x03\x02\x02\x02\xe2\xe3\x07>\x02\x02\xe3\xe4\x07?\x02\x02\xe4\x1c\x03\x02\x02\x02\xe5\xe6\x07?\x02\x02\xe6\x1e\x03\x02\x02\x02\xe7\xe8\x07#\x02\x02\xe8\xe9\x07?\x02\x02\xe9 \x03\x02\x02\x02\xea\xeb\x07\x80\x02\x02\xeb\"\x03\x02\x02\x02\xec\xed\x07#\x02\x02\xed\xee\x07\x80\x02\x02\xee$\x03\x02\x02\x02\xef\xf0\x05\xa1P\x02\xf0\xf1\x05\xabU\x02\xf1&\x03\x02\x02\x02\xf2\xf3\x05\xa1P\x02\xf3\xf4\x05\xb5Z\x02\xf4(\x03\x02\x02\x02\xf5\xf6\x05\x91H\x02\xf6\xf7\x05\xabU\x02\xf7\xf8\x05\x97K\x02\xf8\xfc\x03\x02\x02\x02\xf9\xfc\x05}>\x02\xfa\xfc\x05\x7f?\x02\xfb\xf5\x03\x02\x02\x02\xfb\xf9\x03\x02\x02\x02\xfb\xfa\x03\x02\x02\x02\xfc*\x03\x02\x02\x02\xfd\xfe\x05\xadV\x02\xfe\xff\x05\xb3Y\x02\xff\u0103\x03\x02\x02\x02\u0100\u0103\x05\x81@\x02\u0101\u0103\x05\x83A\x02\u0102\xfd\x03\x02\x02\x02\u0102\u0100\x03\x02\x02\x02\u0102\u0101\x03\x02\x02\x02\u0103";
    }
    static{
        this._serializedATNSegment1 = ",\x03\x02\x02\x02\u0104\u0105\x05\xabU\x02\u0105\u0106\x05\xadV\x02\u0106\u0107\x05\xb7[\x02\u0107.\x03\x02\x02\x02\u0108\u0109\x05\x99L\x02\u0109\u010A\x05\xa9T\x02\u010A\u010B\x05\xafW\x02\u010B\u010C\x05\xb7[\x02\u010C\u010D\x05\xc1`\x02\u010D\u0114\x03\x02\x02\x02\u010E\u010F\x05\xabU\x02\u010F\u0110\x05\xb9\\\x02\u0110\u0111\x05\xa7S\x02\u0111\u0112\x05\xa7S\x02\u0112\u0114\x03\x02\x02\x02\u0113\u0108\x03\x02\x02\x02\u0113\u010E\x03\x02\x02\x02\u01140\x03\x02\x02\x02\u0115\u0116\x05\xbd^\x02\u0116\u0117\x05\x91H\x02\u0117\u0118\x05\xb5Z\x02\u01182\x03\x02\x02\x02\u0119\u011A\x05\x95J\x02\u011A\u011B\x05\x9fO\x02\u011B\u011C\x05\x91H\x02\u011C\u011D\x05\xabU\x02\u011D\u011E\x05\x9dN\x02\u011E\u011F\x05\x99L\x02\u011F\u0120\x05\x97K\x02\u01204\x03\x02\x02\x02\u0121\u0122\x05\x93I\x02\u0122\u0123\x05\x99L\x02\u0123\u0124\x05\x9bM\x02\u0124\u0125\x05\xadV\x02\u0125\u0126\x05\xb3Y\x02\u0126\u0127\x05\x99L\x02\u01276\x03\x02\x02\x02\u0128\u0129\x05\x91H\x02\u0129\u012A\x05\x9bM\x02\u012A\u012B\x05\xb7[\x02\u012B\u012C\x05\x99L\x02\u012C\u012D\x05\xb3Y\x02\u012D8\x03\x02\x02\x02\u012E\u012F\x05\x9bM\x02\u012F\u0130\x05\xb3Y\x02\u0130\u0131\x05\xadV\x02\u0131\u0132\x05\xa9T\x02\u0132:\x03\x02\x02\x02\u0133\u0134\x05\xb7[\x02\u0134\u0135\x05\xadV\x02\u0135<\x03\x02\x02\x02\u0136\u0137\x05\xadV\x02\u0137\u0138\x05\xabU\x02\u0138>\x03\x02\x02\x02\u0139\u013A\x05\x97K\x02\u013A\u013B\x05\xb9\\\x02\u013B\u013C\x05\xb3Y\x02\u013C\u013D\x05\xa1P\x02\u013D\u013E\x05\xabU\x02\u013E\u013F\x05\x9dN\x02\u013F@\x03\x02\x02\x02\u0140\u0141\x05\xadV\x02\u0141\u0142\x05\xb3Y\x02\u0142\u0143\x05\x97K\x02\u0143\u0144\x05\x99L\x02\u0144\u0145\x05\xb3Y\x02\u0145B\x03\x02\x02\x02\u0146\u0147\x05\x93I\x02\u0147\u0148\x05\xc1`\x02\u0148D\x03\x02\x02\x02\u0149\u014A\x05\x91H\x02\u014A\u014B\x05\xb5Z\x02\u014B\u014C\x05\x95J\x02\u014CF\x03\x02\x02\x02\u014D\u014E\x05\x97K\x02\u014E\u014F\x05\x99L\x02\u014F\u0150\x05\xb5Z\x02\u0150\u0151\x05\x95J\x02\u0151H\x03\x02\x02\x02\u0152\u0154\x05\x8fG\x02\u0153\u0152\x03\x02\x02\x02\u0154\u0155\x03\x02\x02\x02\u0155\u0153\x03\x02\x02\x02\u0155\u0156\x03\x02\x02\x02\u0156J\x03\x02\x02\x02\u0157\u0159\x05\x8dF\x02\u0158\u015A\x05\x8fG\x02\u0159\u0158\x03\x02\x02\x02\u015A\u015B\x03\x02\x02\x02\u015B\u0159\x03\x02\x02\x02\u015B\u015C\x03\x02\x02\x02\u015CL\x03\x02\x02\x02\u015D\u015E\x05\x95J\x02\u015E\u015F\x05\x9bM\x02\u015FN\x03\x02\x02\x02\u0160\u0161\x05\x91H\x02\u0161\u0162\x05\x93I\x02\u0162\u0163\x05\xadV\x02\u0163\u0164\x05\xb3Y\x02\u0164\u0165\x05\xb7[\x02\u0165\u0582\x03\x02\x02\x02\u0166\u0167\x05\x91H\x02\u0167\u0168\x05\x95J\x02\u0168\u0169\x05\x95J\x02\u0169\u016A\x05\x99L\x02\u016A\u016B\x05\xb5Z\x02\u016B\u016C\x05\xb5Z\x02\u016C\u0582\x03\x02\x02\x02\u016D\u016E\x05\x91H\x02\u016E\u016F\x05\x97K\x02\u016F\u0170\x05\x97K\x02\u0170\u0582\x03\x02\x02\x02\u0171\u0172\x05\x91H\x02\u0172\u0173\x05\xa7S\x02\u0173\u0174\x05\xa1P\x02\u0174\u0175\x05\x91H\x02\u0175\u0176\x05\xb5Z\x02\u0176\u0582\x03\x02\x02\x02\u0177\u0178\x05\x91H\x02\u0178\u0179\x05\xa7S\x02\u0179\u017A\x05\xb7[\x02\u017A\u017B\x05\x99L\x02\u017B\u017C\x05\xb3Y\x02\u017C\u0582\x03\x02\x02\x02\u017D\u017E\x05\x91H\x02\u017E\u017F\x05\xabU\x02\u017F\u0180\x05\xc1`\x02\u0180\u0582\x03\x02\x02\x02\u0181\u0182\x05\x91H\x02\u0182\u0183\x05\xb5Z\x02\u0183\u0582\x03\x02\x02\x02\u0184\u0185\x05\x91H\x02\u0185\u0186\x05\xb9\\\x02\u0186\u0187\x05\x97K\x02\u0187\u0188\x05\xa1P\x02\u0188\u0189\x05\xb7[\x02\u0189\u0582\x03\x02\x02\x02\u018A\u018B\x05\x91H\x02\u018B\u018C\x05\xbb]\x02\u018C\u018D\x05\x9dN\x02\u018D\u0582\x03\x02\x02\x02\u018E\u018F\x05\x93I\x02\u018F\u0190\x05\x99L\x02\u0190\u0191\x05\x9dN\x02\u0191\u0192\x05\xa1P\x02\u0192\u0193\x05\xabU\x02\u0193\u0582\x03\x02\x02\x02\u0194\u0195\x05\x93I\x02\u0195\u0196\x05\x99L\x02\u0196\u0197\x05\xb7[\x02\u0197\u0198\x05\xbd^\x02\u0198\u0199\x05\x99L\x02\u0199\u019A\x05\x99L\x02\u019A\u019B\x05\xabU\x02\u019B\u0582\x03\x02\x02\x02\u019C\u019D\x05\x93I\x02\u019D\u019E\x05\xadV\x02\u019E\u019F\x05\xadV\x02\u019F\u01A0\x05\xa7S\x02\u01A0\u01A1\x05\x99L\x02\u01A1\u01A2\x05\x91H\x02\u01A2\u01A3\x05\xabU\x02\u01A3\u0582\x03\x02\x02\x02\u01A4\u01A5\x05\x93I\x02\u01A5\u01A6\x05\xb3Y\x02\u01A6\u01A7\x05\x99L\x02\u01A7\u01A8\x05\x91H\x02\u01A8\u01A9\x05\xa5R\x02\u01A9\u0582\x03\x02\x02\x02\u01AA\u01AB\x05\x93I\x02\u01AB\u01AC\x05\xc1`\x02\u01AC\u01AD\x05\xb7[\x02\u01AD\u01AE\x05\x99L\x02\u01AE\u0582\x03\x02\x02\x02\u01AF\u01B0\x05\x95J\x02\u01B0\u01B1\x05\x91H\x02\u01B1\u01B2\x05\xb7[\x02\u01B2\u01B3\x05\x95J\x02\u01B3\u01B4\x05\x9fO\x02\u01B4\u0582\x03\x02\x02\x02\u01B5\u01B6\x05\x95J\x02\u01B6\u01B7\x05\x9fO\x02\u01B7\u01B8\x05\x91H\x02\u01B8\u01B9\x05\xb3Y\x02\u01B9\u0582\x03\x02\x02\x02\u01BA\u01BB\x05\x95J\x02\u01BB\u01BC\x05\x9fO\x02\u01BC\u01BD\x05\x91H\x02\u01BD\u01BE\x05\xb3Y\x02\u01BE\u01BF\x05\x91H\x02\u01BF\u01C0\x05\x95J\x02\u01C0\u01C1\x05\xb7[\x02\u01C1\u01C2\x05\x99L\x02\u01C2\u01C3\x05\xb3Y\x02\u01C3\u0582\x03\x02\x02\x02\u01C4\u01C5\x05\x95J\x02\u01C5\u01C6\x05\x9fO\x02\u01C6\u01C7\x05\x99L\x02\u01C7\u01C8\x05\x95J\x02\u01C8\u01C9\x05\xa5R\x02\u01C9\u0582\x03\x02\x02\x02\u01CA\u01CB\x05\x95J\x02\u01CB\u01CC\x05\x9fO\x02\u01CC\u01CD\x05\x99L\x02\u01CD\u01CE\x05\x95J\x02\u01CE\u01CF\x05\xa5R\x02\u01CF\u01D0\x05\xafW\x02\u01D0\u01D1\x05\xadV\x02\u01D1\u01D2\x05\xa1P\x02\u01D2\u01D3\x05\xabU\x02\u01D3\u01D4\x05\xb7[\x02\u01D4\u0582\x03\x02\x02\x02\u01D5\u01D6\x05\x95J\x02\u01D6\u01D7\x05\xadV\x02\u01D7\u01D8\x05\xa7S\x02\u01D8\u01D9\x05\xa7S\x02\u01D9\u01DA\x05\x91H\x02\u01DA\u01DB\x05\xb7[\x02\u01DB\u01DC\x05\x99L\x02\u01DC\u0582\x03\x02\x02\x02\u01DD\u01DE\x05\x95J\x02\u01DE\u01DF\x05\xadV\x02\u01DF\u01E0\x05\xa7S\x02\u01E0\u01E1\x05\xa7S\x02\u01E1\u01E2\x05\x91H\x02\u01E2\u01E3\x05\xb7[\x02\u01E3\u01E4\x05\xa1P\x02\u01E4\u01E5\x05\xadV\x02\u01E5\u01E6\x05\xabU\x02\u01E6\u0582\x03\x02\x02\x02\u01E7\u01E8\x05\x95J\x02\u01E8\u01E9\x05\xadV\x02\u01E9\u01EA\x05\xa7S\x02\u01EA\u01EB\x05\xb9\\\x02\u01EB\u01EC\x05\xa9T\x02\u01EC\u01ED\x05\xabU\x02\u01ED\u0582\x03\x02\x02\x02\u01EE\u01EF\x05\x95J\x02\u01EF\u01F0\x05\xadV\x02\u01F0\u01F1\x05\xa9T\x02\u01F1\u01F2\x05\xa9T\x02\u01F2\u01F3\x05\xa1P\x02\u01F3\u01F4\x05\xb7[\x02\u01F4\u0582\x03\x02\x02\x02\u01F5\u01F6\x05\x95J\x02\u01F6\u01F7\x05\xadV\x02\u01F7\u01F8\x05\xabU\x02\u01F8\u01F9\x05\xabU\x02\u01F9\u01FA\x05\x99L\x02\u01FA\u01FB\x05\x95J\x02\u01FB\u01FC\x05\xb7[\x02\u01FC\u0582\x03\x02\x02\x02\u01FD\u01FE\x05\x95J\x02\u01FE\u01FF\x05\xadV\x02\u01FF\u0200\x05\xabU\x02\u0200\u0201\x05\xb7[\x02\u0201\u0202\x05\xa1P\x02\u0202\u0203\x05\xabU\x02\u0203\u0204\x05\xb9\\\x02\u0204\u0205\x05\x99L\x02\u0205\u0582\x03\x02\x02\x02\u0206\u0207\x05\x95J\x02\u0207\u0208\x05\xadV\x02\u0208\u0209\x05\xb9\\\x02\u0209\u020A\x05\xabU\x02\u020A\u020B\x05\xb7[\x02\u020B\u0582\x03\x02\x02\x02\u020C\u020D\x05\x95J\x02\u020D\u020E\x05\xb3Y\x02\u020E\u020F\x05\x99L\x02\u020F\u0210\x05\x91H\x02\u0210\u0211\x05\xb7[\x02\u0211\u0212\x05\x99L\x02\u0212\u0582\x03\x02\x02\x02\u0213\u0214\x05\x95J\x02\u0214\u0215\x05\xb9\\\x02\u0215\u0216\x05\xb3Y\x02\u0216\u0217\x05\xb3Y\x02\u0217\u0218\x05\x99L\x02\u0218\u0219\x05\xabU\x02\u0219\u021A\x05\xb7[\x02\u021A\u0582\x03\x02\x02\x02\u021B\u021C\x05\x97K\x02\u021C\u021D\x05\x91H\x02\u021D\u021E\x05\xb7[\x02\u021E\u021F\x05\x99L\x02\u021F\u0582\x03\x02\x02\x02\u0220\u0221\x05\x97K\x02\u0221\u0222\x05\x99L\x02\u0222\u0223\x05\x95J\x02\u0223\u0224\x05\xa1P\x02\u0224\u0225\x05\xa9T\x02\u0225\u0226\x05\x91H\x02\u0226\u0227\x05\xa7S\x02\u0227\u0582\x03\x02\x02\x02\u0228\u0229\x05\x97K\x02\u0229\u022A\x05\x99L\x02\u022A\u022B\x05\x95J\x02\u022B\u022C\x05\xa7S\x02\u022C\u022D\x05\x91H\x02\u022D\u022E\x05\xb3Y\x02\u022E\u022F\x05\x99L\x02\u022F\u0582\x03\x02\x02\x02\u0230\u0231\x05\x97K\x02\u0231\u0232\x05\x99L\x02\u0232\u0233\x05\x95J\x02\u0233\u0234\x05\xb3Y\x02\u0234\u0235\x05\x99L\x02\u0235\u0236\x05\xa9T\x02\u0236\u0237\x05\x99L\x02\u0237\u0238\x05\xabU\x02\u0238\u0239\x05\xb7[\x02\u0239\u0582\x03\x02\x02\x02\u023A\u023B\x05\x97K\x02\u023B\u023C\x05\x99L\x02\u023C\u023D\x05\x9bM\x02\u023D\u023E\x05\x91H\x02\u023E\u023F\x05\xb9\\\x02\u023F\u0240\x05\xa7S\x02\u0240\u0241\x05\xb7[\x02\u0241\u0582\x03\x02\x02\x02\u0242\u0243\x05\x97K\x02\u0243\u0244\x05\x99L\x02\u0244\u0245\x05\x9bM\x02\u0245\u0246\x05\x91H\x02\u0246\u0247\x05\xb9\\\x02\u0247\u0248\x05\xa7S\x02\u0248\u0249\x05\xb7[\x02\u0249\u024A\x05\xb5Z\x02\u024A\u0582\x03\x02\x02\x02\u024B\u024C\x05\x97K\x02\u024C\u024D\x05\x99L\x02\u024D\u024E\x05\x9bM\x02\u024E\u024F\x05\xa1P\x02\u024F\u0250\x05\xabU\x02\u0250\u0251\x05\x99L\x02\u0251\u0582\x03\x02\x02\x02\u0252\u0253\x05\x97K\x02\u0253\u0254\x05\x99L\x02\u0254\u0255\x05\xa7S\x02\u0255\u0256\x05\x99L\x02\u0256\u0257\x05\xb7[\x02\u0257\u0258\x05\x99L\x02\u0258\u0582\x03\x02\x02\x02\u0259\u025A\x05\x97K\x02\u025A\u025B\x05\x99L\x02\u025B\u025C\x05\xa7S\x02\u025C\u025D\x05\xa1P\x02\u025D\u025E\x05\xa9T\x02\u025E\u025F\x05\xa1P\x02\u025F\u0260\x05\xb7[\x02\u0260\u0261\x05\x99L\x02\u0261\u0262\x05\xb3Y\x02\u0262\u0582\x03\x02\x02\x02\u0263\u0264\x05\x97K\x02\u0264\u0265\x05\xa1P\x02\u0265\u0266\x05\x9bM\x02\u0266\u0267\x05\x9bM\x02\u0267\u0268\x05\x99L\x02\u0268\u0269\x05\xb3Y\x02\u0269\u026A\x05\x99L\x02\u026A\u026B\x05\xabU\x02\u026B\u026C\x05\x95J\x02\u026C\u026D\x05\x99L\x02\u026D\u0582\x03\x02\x02\x02\u026E\u026F\x05\x97K\x02\u026F\u0270\x05\xa1P\x02\u0270\u0271\x05\xb5Z\x02\u0271\u0272\x05\xb7[\x02\u0272\u0273\x05\xa1P\x02\u0273\u0274\x05\xabU\x02\u0274\u0275\x05\x95J\x02\u0275\u0276\x05\xb7[\x02\u0276\u0582\x03\x02\x02\x02\u0277\u0278\x05\x97K\x02\u0278\u0279\x05\xa1P\x02\u0279\u027A\x05\xbb]\x02\u027A\u027B\x05\xa1P\x02\u027B\u027C\x05\x97K\x02\u027C\u027D\x05\x99L\x02\u027D\u0582\x03\x02\x02\x02\u027E\u027F\x05\x97K\x02\u027F\u0280\x05\xadV\x02\u0280\u0582\x03\x02\x02\x02\u0281\u0282\x05\x97K\x02\u0282\u0283\x05\xadV\x02\u0283\u0284\x05\xb9\\\x02\u0284\u0285\x05\x93I\x02\u0285\u0286\x05\xa7S\x02\u0286\u0287\x05\x99L\x02\u0287\u0582\x03\x02\x02\x02\u0288\u0289\x05\x97K\x02\u0289\u028A\x05\xb3Y\x02\u028A\u028B\x05\xadV\x02\u028B\u028C\x05\xafW\x02\u028C\u0582\x03\x02\x02\x02\u028D\u028E\x05\x99L\x02\u028E\u028F\x05\xa7S\x02\u028F\u0290\x05\xb5Z\x02\u0290\u0291\x05\x99L\x02\u0291\u0582\x03\x02\x02\x02\u0292\u0293\x05\x99L\x02\u0293\u0294\x05\xabU\x02\u0294\u0295\x05\x95J\x02\u0295\u0296\x05\xadV\x02\u0296\u0297\x05\x97K\x02\u0297\u0298\x05\xa1P\x02\u0298\u0299\x05\xabU\x02\u0299\u029A\x05\x9dN\x02\u029A\u0582\x03\x02\x02\x02\u029B\u029C\x05\x99L\x02\u029C\u029D\x05\xabU\x02\u029D\u029E\x05\x97K\x02\u029E\u0582\x03\x02\x02\x02\u029F\u02A0\x05\x99L\x02\u02A0\u02A1\x05\xb1X\x02\u02A1\u02A2\x05\xb9\\\x02\u02A2\u02A3\x05\x91H\x02\u02A3\u02A4\x05\xa7S\x02\u02A4\u02A5\x05\xb5Z\x02\u02A5\u0582\x03\x02\x02\x02\u02A6\u02A7\x05\x99L\x02\u02A7\u02A8\x05\xb5Z\x02\u02A8\u02A9\x05\x95J\x02\u02A9\u02AA\x05\x91H\x02\u02AA\u02AB\x05\xafW\x02\u02AB\u02AC\x05\x99L\x02\u02AC\u0582\x03\x02\x02\x02\u02AD\u02AE\x05\x99L\x02\u02AE\u02AF\x05\xbf_\x02\u02AF\u02B0\x05\x95J\x02\u02B0\u02B1\x05\xa7S\x02\u02B1\u02B2\x05\xb9\\\x02\u02B2\u02B3\x05\xb5Z\x02\u02B3\u02B4\x05\xa1P\x02\u02B4\u02B5\x05\xbb]\x02\u02B5\u02B6\x05\x99L\x02\u02B6\u0582\x03\x02\x02\x02\u02B7\u02B8\x05\x99L\x02\u02B8\u02B9\x05\xbf_\x02\u02B9\u02BA\x05\x99L\x02\u02BA\u02BB\x05\x95J\x02\u02BB\u0582\x03\x02\x02\x02\u02BC\u02BD\x05\x99L\x02\u02BD\u02BE\x05\xbf_\x02\u02BE\u02BF\x05\x99L\x02\u02BF\u02C0\x05\x95J\x02\u02C0\u02C1\x05\xb9\\\x02\u02C1\u02C2\x05\xb7[\x02\u02C2\u02C3\x05\x99L\x02\u02C3\u0582\x03\x02\x02\x02\u02C4\u02C5\x05\x99L\x02\u02C5\u02C6\x05\xbf_\x02\u02C6\u02C7\x05\xa1P\x02\u02C7\u02C8\x05\xb5Z\x02\u02C8\u02C9\x05\xb7[\x02\u02C9\u02CA\x05\xb5Z\x02\u02CA\u0582\x03\x02\x02\x02\u02CB\u02CC\x05\x99L\x02\u02CC\u02CD\x05\xbf_\x02\u02CD\u02CE\x05\xafW\x02\u02CE\u02CF\x05\xa7S\x02\u02CF\u02D0\x05\x91H\x02\u02D0\u02D1\x05\xa1P\x02\u02D1\u02D2\x05\xabU\x02\u02D2\u0582\x03\x02\x02\x02\u02D3\u02D4\x05\x9bM\x02\u02D4\u02D5\x05\x91H\x02\u02D5\u02D6\x05\xa7S\x02\u02D6\u02D7\x05\xb5Z\x02\u02D7\u02D8\x05\x99L\x02\u02D8\u0582\x03\x02\x02\x02\u02D9\u02DA\x05\x9bM\x02\u02DA\u02DB\x05\x99L\x02\u02DB\u02DC\x05\xb7[\x02\u02DC\u02DD\x05\x95J\x02\u02DD\u02DE\x05\x9fO\x02\u02DE\u0582\x03\x02\x02\x02\u02DF\u02E0\x05\x9bM\x02\u02E0\u02E1\x05\xa1P\x02\u02E1\u02E2\x05\xa7S\x02\u02E2\u02E3\x05\x99L\x02\u02E3\u0582\x03\x02\x02\x02\u02E4\u02E5\x05\x9bM\x02\u02E5\u02E6\x05\xa1P\x02\u02E6\u02E7\x05\x99L\x02\u02E7\u02E8\x05\xa7S\x02\u02E8\u02E9\x05\x97K\x02\u02E9\u0582\x03\x02\x02\x02\u02EA\u02EB\x05\x9bM\x02\u02EB\u02EC\x05\xa1P\x02\u02EC\u02ED\x05\xb3Y\x02\u02ED\u02EE\x05\xb5Z\x02\u02EE\u02EF\x05\xb7[\x02\u02EF\u0582\x03\x02\x02\x02\u02F0\u02F1\x05\x9bM\x02\u02F1\u02F2\x05\xa7S\x02\u02F2\u02F3\x05\xadV\x02\u02F3\u02F4\x05\x91H\x02\u02F4\u02F5\x05\xb7[\x02\u02F5\u0582\x03\x02\x02\x02\u02F6\u02F7\x05\x9bM\x02\u02F7\u02F8\x05\xadV\x02\u02F8\u02F9\x05\xb3Y\x02\u02F9\u0582\x03\x02\x02\x02\u02FA\u02FB\x05\x9bM\x02\u02FB\u02FC\x05\xb9\\\x02\u02FC\u02FD\x05\xabU\x02\u02FD\u02FE\x05\x95J\x02\u02FE\u02FF\x05\xb7[\x02\u02FF\u0300\x05\xa1P\x02\u0300\u0301\x05\xadV\x02\u0301\u0302\x05\xabU\x02\u0302\u0582\x03\x02\x02\x02\u0303\u0304\x05\x9dN\x02\u0304\u0305\x05\xadV\x02\u0305\u0582\x03\x02\x02\x02\u0306\u0307\x05\x9dN\x02\u0307\u0308\x05\xadV\x02\u0308\u0309\x05\xb7[\x02\u0309\u030A\x05\xadV\x02\u030A\u0582\x03\x02\x02\x02\u030B\u030C\x05\x9dN\x02\u030C\u030D\x05\xb3Y\x02\u030D\u030E\x05\x91H\x02\u030E\u030F\x05\xabU\x02\u030F\u0310\x05\xb7[\x02\u0310\u0582\x03\x02\x02\x02\u0311\u0312\x05\x9dN\x02\u0312\u0313\x05\xb3Y\x02\u0313\u0314\x05\x99L\x02\u0314\u0315\x05\x91H\x02\u0315\u0316\x05\xb7[\x02\u0316\u0317\x05\x99L\x02\u0317\u0318\x05\xb3Y\x02\u0318\u0582\x03\x02\x02\x02\u0319\u031A\x05\x9dN\x02\u031A\u031B\x05\xb3Y\x02\u031B\u031C\x05\xadV\x02\u031C\u031D\x05\xb9\\\x02\u031D\u031E\x05\xafW\x02\u031E\u0582\x03\x02\x02\x02\u031F\u0320\x05\x9fO\x02\u0320\u0321\x05\x91H\x02\u0321\u0322\x05\xbb]\x02\u0322\u0323\x05\xa1P\x02\u0323\u0324\x05\xabU\x02\u0324\u0325\x05\x9dN\x02\u0325\u0582\x03\x02\x02\x02\u0326\u0327\x05\xa1P\x02\u0327\u0328\x05\x97K\x02\u0328\u0329\x05\x99L\x02\u0329\u032A\x05\xabU\x02\u032A\u032B\x05\xb7[\x02\u032B\u032C\x05\xa1P\x02\u032C\u032D\x05\x9bM\x02\u032D\u032E\x05\xa1P\x02\u032E\u032F\x05\x99L\x02\u032F\u0330\x05\x97K\x02\u0330\u0582\x03\x02\x02\x02\u0331\u0332\x05\xa1P\x02\u0332\u0333\x05\x9bM\x02\u0333\u0582\x03\x02\x02\x02\u0334\u0335\x05\xa1P\x02\u0335\u0336\x05\xa9T\x02\u0336\u0337\x05\xa9T\x02\u0337\u0338\x05\x99L\x02\u0338\u0339\x05\x97K\x02\u0339\u033A\x05\xa1P\x02\u033A\u033B\x05\x91H\x02\u033B\u033C\x05\xb7[\x02\u033C\u033D\x05\x99L\x02\u033D\u0582\x03\x02\x02\x02\u033E\u033F\x05\xa1P\x02\u033F\u0340\x05\xabU\x02\u0340\u0341\x05\x95J\x02\u0341\u0342\x05\xb3Y\x02\u0342\u0343\x05\x99L\x02\u0343\u0344\x05\xa9T\x02\u0344\u0345\x05\x99L\x02\u0345\u0346\x05\xabU\x02\u0346\u0347\x05\xb7[\x02\u0347\u0582\x03\x02\x02\x02\u0348\u0349\x05\xa1P\x02\u0349\u034A\x05\xabU\x02\u034A\u034B\x05\x97K\x02\u034B\u034C\x05\x99L\x02\u034C\u034D\x05\xbf_\x02\u034D\u0582\x03\x02\x02\x02\u034E\u034F\x05\xa1P\x02\u034F\u0350\x05\xabU\x02\u0350\u0351\x05\xa1P\x02\u0351\u0352\x05\xb7[\x02\u0352\u0353\x05\xa1P\x02\u0353\u0354\x05\x91H\x02\u0354\u0355\x05\xa7S\x02\u0355\u0582\x03\x02\x02\x02\u0356\u0357\x05\xa1P\x02\u0357\u0358\x05\xabU\x02\u0358\u0359\x05\xabU\x02\u0359\u035A\x05\x99L\x02\u035A\u035B\x05\xb3Y\x02\u035B\u0582\x03\x02\x02\x02\u035C\u035D\x05\xa1P\x02\u035D\u035E\x05\xabU\x02\u035E\u035F\x05\xadV\x02\u035F\u0360\x05\xb9\\\x02\u0360\u0361\x05\xb7[\x02\u0361\u0582\x03\x02\x02\x02\u0362\u0363\x05\xa1P\x02\u0363\u0364\x05\xabU\x02\u0364\u0365\x05\xafW\x02\u0365\u0366\x05\xb9\\\x02\u0366\u0367\x05\xb7[\x02\u0367\u0582\x03\x02\x02\x02\u0368\u0369\x05\xa1P\x02\u0369\u036A\x05\xabU\x02\u036A\u036B\x05\xb5Z\x02\u036B\u036C\x05\x99L\x02\u036C\u036D\x05\xb3Y\x02\u036D\u036E\x05\xb7[\x02\u036E\u0582\x03\x02\x02\x02\u036F\u0370\x05\xa1P\x02\u0370\u0371\x05\xabU\x02\u0371\u0372\x05\xb7[\x02\u0372\u0582\x03\x02\x02\x02\u0373\u0374\x05\xa1P\x02\u0374\u0375\x05\xabU\x02\u0375\u0376\x05\xb7[\x02\u0376\u0377\x05\x99L\x02\u0377\u0378\x05\x9dN\x02\u0378\u0379\x05\x99L\x02\u0379\u037A\x05\xb3Y\x02\u037A\u0582\x03\x02\x02\x02\u037B\u037C\x05\xa1P\x02\u037C\u037D\x05\xabU\x02\u037D\u037E\x05\xb7[\x02\u037E\u037F\x05\x99L\x02\u037F\u0380\x05\xb3Y\x02\u0380\u0381\x05\xb5Z\x02\u0381\u0382\x05\x99L\x02\u0382\u0383\x05\x95J\x02\u0383\u0384\x05\xb7[\x02\u0384\u0582\x03\x02\x02\x02\u0385\u0386\x05\xa1P\x02\u0386\u0387\x05\xabU\x02\u0387\u0388\x05\xb7[\x02\u0388\u0389\x05\x99L\x02\u0389\u038A\x05\xb3Y\x02\u038A\u038B\x05\xb5Z\x02\u038B\u038C\x05\x99L\x02\u038C\u038D\x05\x95J\x02\u038D\u038E\x05\xb7[\x02\u038E\u038F\x05\xa1P\x02\u038F\u0390\x05\xadV\x02\u0390\u0391\x05\xabU\x02\u0391\u0582\x03\x02\x02\x02\u0392\u0393\x05\xa1P\x02\u0393\u0394\x05\xabU\x02\u0394\u0395\x05\xb7[\x02\u0395\u0396\x05\xadV\x02\u0396\u0582\x03\x02\x02\x02\u0397\u0398\x05\xa1P\x02\u0398\u0399\x05\xb5Z\x02\u0399\u039A\x05\x99L\x02\u039A\u039B\x05\xa9T\x02\u039B\u039C\x05\xafW\x02\u039C\u039D\x05\xb7[\x02\u039D\u039E\x05\xc1`\x02\u039E\u0582\x03\x02\x02\x02\u039F\u03A0\x05\xa1P\x02\u03A0\u03A1\x05\xb5Z\x02\u03A1\u03A2\x05\xabU\x02\u03A2\u03A3\x05\xb9\\\x02\u03A3\u03A4\x05\xa7S\x02\u03A4\u03A5\x05\xa7S\x02\u03A5\u0582\x03\x02\x02\x02\u03A6\u03A7\x05\xa3Q\x02\u03A7\u03A8\x05\xadV\x02\u03A8\u03A9\x05\xa1P\x02\u03A9\u03AA\x05\xabU\x02\u03AA\u0582\x03\x02\x02\x02\u03AB\u03AC\x05\xa7S\x02\u03AC\u03AD\x05\x91H\x02\u03AD\u03AE\x05\xb5Z\x02\u03AE\u03AF\x05\xb7[\x02\u03AF\u0582\x03\x02\x02\x02\u03B0\u03B1\x05\xa7S\x02\u03B1\u03B2\x05\x99L\x02\u03B2\u03B3\x05\x9bM\x02\u03B3\u03B4\x05\xb7[\x02\u03B4\u0582\x03\x02\x02\x02\u03B5\u03B6\x05\xa7S\x02\u03B6\u03B7\x05\x99L\x02\u03B7\u03B8\x05\xb5Z\x02\u03B8\u03B9\x05\xb5Z\x02\u03B9\u0582\x03\x02\x02\x02\u03BA\u03BB\x05\xa7S\x02\u03BB\u03BC\x05\xa1P\x02\u03BC\u03BD\x05\xa5R\x02\u03BD\u03BE\x05\x99L\x02\u03BE\u0582\x03\x02\x02\x02\u03BF\u03C0\x05\xa7S\x02\u03C0\u03C1\x05\xa1P\x02\u03C1\u03C2\x05\xa9T\x02\u03C2\u03C3\x05\xa1P\x02\u03C3\u03C4\x05\xb7[\x02\u03C4\u0582\x03\x02\x02\x02\u03C5\u03C6\x05\xa7S\x02\u03C6\u03C7\x05\xadV\x02\u03C7\u03C8\x05\x95J\x02\u03C8\u03C9\x05\xa5R\x02\u03C9\u0582\x03\x02\x02\x02\u03CA\u03CB\x05\xa7S\x02\u03CB\u03CC\x05\xadV\x02\u03CC\u03CD\x05\xabU\x02\u03CD\u03CE\x05\x9dN\x02\u03CE\u0582\x03\x02\x02\x02\u03CF\u03D0\x05\xa9T\x02\u03D0\u03D1\x05\x91H\x02\u03D1\u03D2\x05\xbf_\x02\u03D2\u0582\x03\x02\x02\x02\u03D3\u03D4\x05\xa9T\x02\u03D4\u03D5\x05\xa1P\x02\u03D5\u03D6\x05\xabU\x02\u03D6\u0582\x03\x02\x02\x02\u03D7\u03D8\x05\xa9T\x02\u03D8\u03D9\x05\xa1P\x02\u03D9\u03DA\x05\xabU\x02\u03DA\u03DB\x05\xb9\\\x02\u03DB\u03DC\x05\xb5Z\x02\u03DC\u0582\x03\x02\x02\x02\u03DD\u03DE\x05\xa9T\x02\u03DE\u03DF\x05\xadV\x02\u03DF\u03E0\x05\x97K\x02\u03E0\u03E1\x05\x99L\x02\u03E1\u0582\x03\x02\x02\x02\u03E2\u03E3\x05\xa9T\x02\u03E3\u03E4\x05\xadV\x02\u03E4\u03E5\x05\x97K\x02\u03E5\u03E6\x05\xa1P\x02\u03E6\u03E7\x05\x9bM\x02\u03E7\u03E8\x05\xc1`\x02\u03E8\u0582\x03\x02\x02\x02\u03E9\u03EA\x05\xa9T\x02\u03EA\u03EB\x05\xadV\x02\u03EB\u03EC\x05\x97K\x02\u03EC\u03ED\x05\xb9\\\x02\u03ED\u03EE\x05\xa7S\x02\u03EE\u03EF\x05\xadV\x02\u03EF\u0582\x03\x02\x02\x02\u03F0\u03F1\x05\xa9T\x02\u03F1\u03F2\x05\xadV\x02\u03F2\u03F3\x05\xb3Y\x02\u03F3\u03F4\x05\x99L\x02\u03F4\u0582\x03\x02\x02\x02\u03F5\u03F6\x05\xa9T\x02\u03F6\u03F7\x05\xb9\\\x02\u03F7\u03F8\x05\xa7S\x02\u03F8\u03F9\x05\xb7[\x02\u03F9\u03FA\x05\xa1P\x02\u03FA\u03FB\x05\xafW\x02\u03FB\u03FC\x05\xa7S\x02\u03FC\u03FD\x05\xc1`\x02\u03FD\u0582\x03\x02\x02\x02\u03FE\u03FF\x05\xabU\x02\u03FF\u0400\x05\x99L\x02\u0400\u0401\x05\xbf_\x02\u0401\u0402\x05\xb7[\x02\u0402\u0582\x03\x02\x02\x02\u0403\u0404\x05\xabU\x02\u0404\u0405\x05\xadV\x02\u0405\u0406\x05\x91H\x02\u0406\u0407\x05\xb9\\\x02\u0407\u0408\x05\x97K\x02\u0408\u0409\x05\xa1P\x02\u0409\u040A\x05\xb7[\x02\u040A\u0582\x03\x02\x02\x02\u040B\u040C\x05\xabU\x02\u040C\u040D\x05\xadV\x02\u040D\u040E\x05\xb7[\x02\u040E\u040F\x05\xa1P\x02\u040F\u0410\x05\xabU\x02\u0410\u0582\x03\x02\x02\x02\u0411\u0412\x05\xabU\x02\u0412\u0413\x05\xadV\x02\u0413\u0414\x05\xbd^\x02\u0414\u0415\x05\x91H\x02\u0415\u0416\x05\xa1P\x02\u0416\u0417\x05\xb7[\x02\u0417\u0582\x03\x02\x02\x02\u0418\u0419\x05\xabU\x02\u0419\u041A\x05\xb9\\\x02\u041A\u041B\x05\xa9T\x02\u041B\u041C\x05\x93I\x02\u041C\u041D\x05\x99L\x02\u041D\u041E\x05\xb3Y\x02\u041E\u0582\x03\x02\x02\x02\u041F\u0420\x05\xadV\x02\u0420\u0421\x05\x93I\x02\u0421\u0422\x05\xa3Q\x02\u0422\u0423\x05\x99L\x02\u0423\u0424\x05\x95J\x02\u0424\u0425\x05\xb7[\x02\u0425\u0582\x03\x02\x02\x02\u0426\u0427\x05\xadV\x02\u0427\u0428\x05\x9bM\x02\u0428\u0582\x03\x02\x02\x02\u0429\u042A\x05\xadV\x02\u042A\u042B\x05\xafW\x02\u042B\u042C\x05\xb7[\x02\u042C\u042D\x05\xa1P\x02\u042D\u042E\x05\xadV\x02\u042E\u042F\x05\xabU\x02\u042F\u0582\x03\x02\x02\x02\u0430\u0431\x05\xadV\x02\u0431\u0432\x05\xb9\\\x02\u0432\u0433\x05\xb7[\x02\u0433\u0434\x05\x99L\x02\u0434\u0435\x05\xb3Y\x02\u0435\u0582\x03\x02\x02\x02\u0436\u0437\x05\xadV\x02\u0437\u0438\x05\xb9\\\x02\u0438\u0439\x05\xb7[\x02\u0439\u043A\x05\xafW\x02\u043A\u043B\x05\xb9\\\x02\u043B\u043C\x05\xb7[\x02\u043C\u0582\x03\x02\x02\x02\u043D\u043E\x05\xafW\x02\u043E\u043F\x05\xadV\x02\u043F\u0440\x05\xbd^\x02\u0440\u0441\x05\x99L\x02\u0441\u0442\x05";
    }
    static{
        this._serializedATNSegment2 = '\xb3Y\x02\u0442\u0582\x03\x02\x02\x02\u0443\u0444\x05\xafW\x02\u0444\u0445\x05\xb3Y\x02\u0445\u0446\x05\x99L\x02\u0446\u0447\x05\xbb]\x02\u0447\u0448\x05\xa1P\x02\u0448\u0449\x05\xadV\x02\u0449\u044A\x05\xb9\\\x02\u044A\u044B\x05\xb5Z\x02\u044B\u0582\x03\x02\x02\x02\u044C\u044D\x05\xafW\x02\u044D\u044E\x05\xb3Y\x02\u044E\u044F\x05\xa1P\x02\u044F\u0450\x05\xadV\x02\u0450\u0451\x05\xb3Y\x02\u0451\u0582\x03\x02\x02\x02\u0452\u0453\x05\xafW\x02\u0453\u0454\x05\xb3Y\x02\u0454\u0455\x05\xa1P\x02\u0455\u0456\x05\xbb]\x02\u0456\u0457\x05\xa1P\x02\u0457\u0458\x05\xa7S\x02\u0458\u0459\x05\x99L\x02\u0459\u045A\x05\x9dN\x02\u045A\u045B\x05\x99L\x02\u045B\u045C\x05\xb5Z\x02\u045C\u0582\x03\x02\x02\x02\u045D\u045E\x05\xafW\x02\u045E\u045F\x05\xb9\\\x02\u045F\u0460\x05\x93I\x02\u0460\u0461\x05\xa7S\x02\u0461\u0462\x05\xa1P\x02\u0462\u0463\x05\x95J\x02\u0463\u0582\x03\x02\x02\x02\u0464\u0465\x05\xb3Y\x02\u0465\u0466\x05\x91H\x02\u0466\u0467\x05\xa1P\x02\u0467\u0468\x05\xb5Z\x02\u0468\u0469\x05\x99L\x02\u0469\u0582\x03\x02\x02\x02\u046A\u046B\x05\xb3Y\x02\u046B\u046C\x05\x91H\x02\u046C\u046D\x05\xbd^\x02\u046D\u0582\x03\x02\x02\x02\u046E\u046F\x05\xb3Y\x02\u046F\u0470\x05\x99L\x02\u0470\u0471\x05\xa9T\x02\u0471\u0472\x05\x91H\x02\u0472\u0473\x05\xa1P\x02\u0473\u0474\x05\xabU\x02\u0474\u0475\x05\x97K\x02\u0475\u0476\x05\x99L\x02\u0476\u0477\x05\xb3Y\x02\u0477\u0582\x03\x02\x02\x02\u0478\u0479\x05\xb3Y\x02\u0479\u047A\x05\x99L\x02\u047A\u047B\x05\xabU\x02\u047B\u047C\x05\x91H\x02\u047C\u047D\x05\xa9T\x02\u047D\u047E\x05\x99L\x02\u047E\u0582\x03\x02\x02\x02\u047F\u0480\x05\xb3Y\x02\u0480\u0481\x05\x99L\x02\u0481\u0482\x05\xb5Z\x02\u0482\u0483\x05\xadV\x02\u0483\u0484\x05\xb9\\\x02\u0484\u0485\x05\xb3Y\x02\u0485\u0486\x05\x95J\x02\u0486\u0487\x05\x99L\x02\u0487\u0582\x03\x02\x02\x02\u0488\u0489\x05\xb3Y\x02\u0489\u048A\x05\x99L\x02\u048A\u048B\x05\xb7[\x02\u048B\u048C\x05\xb9\\\x02\u048C\u048D\x05\xb3Y\x02\u048D\u048E\x05\xabU\x02\u048E\u0582\x03\x02\x02\x02\u048F\u0490\x05\xb3Y\x02\u0490\u0491\x05\x99L\x02\u0491\u0492\x05\xb7[\x02\u0492\u0493\x05\xb9\\\x02\u0493\u0494\x05\xb3Y\x02\u0494\u0495\x05\xabU\x02\u0495\u0496\x05\xb5Z\x02\u0496\u0582\x03\x02\x02\x02\u0497\u0498\x05\xb3Y\x02\u0498\u0499\x05\x99L\x02\u0499\u049A\x05\xbb]\x02\u049A\u049B\x05\xadV\x02\u049B\u049C\x05\xa5R\x02\u049C\u049D\x05\x99L\x02\u049D\u0582\x03\x02\x02\x02\u049E\u049F\x05\xb3Y\x02\u049F\u04A0\x05\xa1P\x02\u04A0\u04A1\x05\x9dN\x02\u04A1\u04A2\x05\x9fO\x02\u04A2\u04A3\x05\xb7[\x02\u04A3\u0582\x03\x02\x02\x02\u04A4\u04A5\x05\xb3Y\x02\u04A5\u04A6\x05\xadV\x02\u04A6\u04A7\x05\xbd^\x02\u04A7\u0582\x03\x02\x02\x02\u04A8\u04A9\x05\xb3Y\x02\u04A9\u04AA\x05\xadV\x02\u04AA\u04AB\x05\xbd^\x02\u04AB\u04AC\x05\xa1P\x02\u04AC\u04AD\x05\x97K\x02\u04AD\u0582\x03\x02\x02\x02\u04AE\u04AF\x05\xb3Y\x02\u04AF\u04B0\x05\xadV\x02\u04B0\u04B1\x05\xbd^\x02\u04B1\u04B2\x05\xabU\x02\u04B2\u04B3\x05\xb9\\\x02\u04B3\u04B4\x05\xa9T\x02\u04B4\u0582\x03\x02\x02\x02\u04B5\u04B6\x05\xb3Y\x02\u04B6\u04B7\x05\xadV\x02\u04B7\u04B8\x05\xbd^\x02\u04B8\u04B9\x05\xb5Z\x02\u04B9\u0582\x03\x02\x02\x02\u04BA\u04BB\x05\xb5Z\x02\u04BB\u04BC\x05\x99L\x02\u04BC\u04BD\x05\xa7S\x02\u04BD\u04BE\x05\x99L\x02\u04BE\u04BF\x05\x95J\x02\u04BF\u04C0\x05\xb7[\x02\u04C0\u0582\x03\x02\x02\x02\u04C1\u04C2\x05\xb5Z\x02\u04C2\u04C3\x05\x99L\x02\u04C3\u04C4\x05\xb5Z\x02\u04C4\u04C5\x05\xb5Z\x02\u04C5\u04C6\x05\xa1P\x02\u04C6\u04C7\x05\xadV\x02\u04C7\u04C8\x05\xabU\x02\u04C8\u0582\x03\x02\x02\x02\u04C9\u04CA\x05\xb5Z\x02\u04CA\u04CB\x05\x99L\x02\u04CB\u04CC\x05\xb7[\x02\u04CC\u0582\x03\x02\x02\x02\u04CD\u04CE\x05\xb5Z\x02\u04CE\u04CF\x05\x9fO\x02\u04CF\u04D0\x05\x91H\x02\u04D0\u04D1\x05\xb3Y\x02\u04D1\u04D2\x05\x99L\x02\u04D2\u0582\x03\x02\x02\x02\u04D3\u04D4\x05\xb5Z\x02\u04D4\u04D5\x05\xa1P\x02\u04D5\u04D6\x05\xc3a\x02\u04D6\u04D7\x05\x99L\x02\u04D7\u0582\x03\x02\x02\x02\u04D8\u04D9\x05\xb5Z\x02\u04D9\u04DA\x05\xb1X\x02\u04DA\u04DB\x05\xb3Y\x02\u04DB\u04DC\x05\xb7[\x02\u04DC\u0582\x03\x02\x02\x02\u04DD\u04DE\x05\xb5Z\x02\u04DE\u04DF\x05\xb7[\x02\u04DF\u04E0\x05\x91H\x02\u04E0\u04E1\x05\xb3Y\x02\u04E1\u04E2\x05\xb7[\x02\u04E2\u0582\x03\x02\x02\x02\u04E3\u04E4\x05\xb5Z\x02\u04E4\u04E5\x05\xb7[\x02\u04E5\u04E6\x05\xb3Y\x02\u04E6\u04E7\x05\xa1P\x02\u04E7\u04E8\x05\x95J\x02\u04E8\u04E9\x05\xb7[\x02\u04E9\u0582\x03\x02\x02\x02\u04EA\u04EB\x05\xb5Z\x02\u04EB\u04EC\x05\xb7[\x02\u04EC\u04ED\x05\xb3Y\x02\u04ED\u04EE\x05\xa1P\x02\u04EE\u04EF\x05\xabU\x02\u04EF\u04F0\x05\x9dN\x02\u04F0\u0582\x03\x02\x02\x02\u04F1\u04F2\x05\xb5Z\x02\u04F2\u04F3\x05\xb9\\\x02\u04F3\u04F4\x05\x93I\x02\u04F4\u04F5\x05\xb7[\x02\u04F5\u04F6\x05\xb3Y\x02\u04F6\u04F7\x05\x91H\x02\u04F7\u04F8\x05\x95J\x02\u04F8\u04F9\x05\xb7[\x02\u04F9\u0582\x03\x02\x02\x02\u04FA\u04FB\x05\xb5Z\x02\u04FB\u04FC\x05\xb9\\\x02\u04FC\u04FD\x05\xa9T\x02\u04FD\u0582\x03\x02\x02\x02\u04FE\u04FF\x05\xb5Z\x02\u04FF\u0500\x05\xc1`\x02\u0500\u0501\x05\xabU\x02\u0501\u0502\x05\xadV\x02\u0502\u0503\x05\xabU\x02\u0503\u0504\x05\xc1`\x02\u0504\u0505\x05\xa9T\x02\u0505\u0582\x03\x02\x02\x02\u0506\u0507\x05\xb7[\x02\u0507\u0508\x05\x91H\x02\u0508\u0509\x05\x93I\x02\u0509\u050A\x05\xa7S\x02\u050A\u050B\x05\x99L\x02\u050B\u0582\x03\x02\x02\x02\u050C\u050D\x05\xb7[\x02\u050D\u050E\x05\x9fO\x02\u050E\u050F\x05\x99L\x02\u050F\u0510\x05\xabU\x02\u0510\u0582\x03\x02\x02\x02\u0511\u0512\x05\xb7[\x02\u0512\u0513\x05\xb3Y\x02\u0513\u0514\x05\x91H\x02\u0514\u0515\x05\xabU\x02\u0515\u0516\x05\xb5Z\x02\u0516\u0582\x03\x02\x02\x02\u0517\u0518\x05\xb7[\x02\u0518\u0519\x05\xb3Y\x02\u0519\u051A\x05\x91H\x02\u051A\u051B\x05\xabU\x02\u051B\u051C\x05\xb5Z\x02\u051C\u051D\x05\x91H\x02\u051D\u051E\x05\x95J\x02\u051E\u051F\x05\xb7[\x02\u051F\u0520\x05\xa1P\x02\u0520\u0521\x05\xadV\x02\u0521\u0522\x05\xabU\x02\u0522\u0582\x03\x02\x02\x02\u0523\u0524\x05\xb7[\x02\u0524\u0525\x05\xb3Y\x02\u0525\u0526\x05\xa1P\x02\u0526\u0527\x05\x9dN\x02\u0527\u0528\x05\x9dN\x02\u0528\u0529\x05\x99L\x02\u0529\u052A\x05\xb3Y\x02\u052A\u0582\x03\x02\x02\x02\u052B\u052C\x05\xb7[\x02\u052C\u052D\x05\xb3Y\x02\u052D\u052E\x05\xb9\\\x02\u052E\u052F\x05\x99L\x02\u052F\u0582\x03\x02\x02\x02\u0530\u0531\x05\xb9\\\x02\u0531\u0532\x05\xa1P\x02\u0532\u0533\x05\x97K\x02\u0533\u0582\x03\x02\x02\x02\u0534\u0535\x05\xb9\\\x02\u0535\u0536\x05\xabU\x02\u0536\u0537\x05\xa1P\x02\u0537\u0538\x05\xadV\x02\u0538\u0539\x05\xabU\x02\u0539\u0582\x03\x02\x02\x02\u053A\u053B\x05\xb9\\\x02\u053B\u053C\x05\xabU\x02\u053C\u053D\x05\xa1P\x02\u053D\u053E\x05\xb1X\x02\u053E\u053F\x05\xb9\\\x02\u053F\u0540\x05\x99L\x02\u0540\u0582\x03\x02\x02\x02\u0541\u0542\x05\xb9\\\x02\u0542\u0543\x05\xafW\x02\u0543\u0544\x05\x97K\x02\u0544\u0545\x05\x91H\x02\u0545\u0546\x05\xb7[\x02\u0546\u0547\x05\x99L\x02\u0547\u0582\x03\x02\x02\x02\u0548\u0549\x05\xb9\\\x02\u0549\u054A\x05\xb5Z\x02\u054A\u054B\x05\x99L\x02\u054B\u054C\x05\xb3Y\x02\u054C\u0582\x03\x02\x02\x02\u054D\u054E\x05\xbb]\x02\u054E\u054F\x05\x91H\x02\u054F\u0550\x05\xa7S\x02\u0550\u0551\x05\xa1P\x02\u0551\u0552\x05\x97K\x02\u0552\u0553\x05\x91H\x02\u0553\u0554\x05\xb7[\x02\u0554\u0555\x05\x99L\x02\u0555\u0582\x03\x02\x02\x02\u0556\u0557\x05\xbb]\x02\u0557\u0558\x05\x91H\x02\u0558\u0559\x05\xa7S\x02\u0559\u055A\x05\xb9\\\x02\u055A\u055B\x05\x99L\x02\u055B\u055C\x05\xb5Z\x02\u055C\u0582\x03\x02\x02\x02\u055D\u055E\x05\xbb]\x02\u055E\u055F\x05\xa1P\x02\u055F\u0560\x05\x99L\x02\u0560\u0561\x05\xbd^\x02\u0561\u0582\x03\x02\x02\x02\u0562\u0563\x05\xbd^\x02\u0563\u0564\x05\x9fO\x02\u0564\u0565\x05\x99L\x02\u0565\u0566\x05\xabU\x02\u0566\u0582\x03\x02\x02\x02\u0567\u0568\x05\xbd^\x02\u0568\u0569\x05\x9fO\x02\u0569\u056A\x05\x99L\x02\u056A\u056B\x05\xabU\x02\u056B\u056C\x05\x99L\x02\u056C\u056D\x05\xbb]\x02\u056D\u056E\x05\x99L\x02\u056E\u056F\x05\xb3Y\x02\u056F\u0582\x03\x02\x02\x02\u0570\u0571\x05\xbd^\x02\u0571\u0572\x05\x9fO\x02\u0572\u0573\x05\x99L\x02\u0573\u0574\x05\xb3Y\x02\u0574\u0575\x05\x99L\x02\u0575\u0582\x03\x02\x02\x02\u0576\u0577\x05\xbd^\x02\u0577\u0578\x05\x9fO\x02\u0578\u0579\x05\xa1P\x02\u0579\u057A\x05\xa7S\x02\u057A\u057B\x05\x99L\x02\u057B\u0582\x03\x02\x02\x02\u057C\u057D\x05\xbd^\x02\u057D\u057E\x05\xa1P\x02\u057E\u057F\x05\xb7[\x02\u057F\u0580\x05\x9fO\x02\u0580\u0582\x03\x02\x02\x02\u0581\u0160\x03\x02\x02\x02\u0581\u0166\x03\x02\x02\x02\u0581\u016D\x03\x02\x02\x02\u0581\u0171\x03\x02\x02\x02\u0581\u0177\x03\x02\x02\x02\u0581\u017D\x03\x02\x02\x02\u0581\u0181\x03\x02\x02\x02\u0581\u0184\x03\x02\x02\x02\u0581\u018A\x03\x02\x02\x02\u0581\u018E\x03\x02\x02\x02\u0581\u0194\x03\x02\x02\x02\u0581\u019C\x03\x02\x02\x02\u0581\u01A4\x03\x02\x02\x02\u0581\u01AA\x03\x02\x02\x02\u0581\u01AF\x03\x02\x02\x02\u0581\u01B5\x03\x02\x02\x02\u0581\u01BA\x03\x02\x02\x02\u0581\u01C4\x03\x02\x02\x02\u0581\u01CA\x03\x02\x02\x02\u0581\u01D5\x03\x02\x02\x02\u0581\u01DD\x03\x02\x02\x02\u0581\u01E7\x03\x02\x02\x02\u0581\u01EE\x03\x02\x02\x02\u0581\u01F5\x03\x02\x02\x02\u0581\u01FD\x03\x02\x02\x02\u0581\u0206\x03\x02\x02\x02\u0581\u020C\x03\x02\x02\x02\u0581\u0213\x03\x02\x02\x02\u0581\u021B\x03\x02\x02\x02\u0581\u0220\x03\x02\x02\x02\u0581\u0228\x03\x02\x02\x02\u0581\u0230\x03\x02\x02\x02\u0581\u023A\x03\x02\x02\x02\u0581\u0242\x03\x02\x02\x02\u0581\u024B\x03\x02\x02\x02\u0581\u0252\x03\x02\x02\x02\u0581\u0259\x03\x02\x02\x02\u0581\u0263\x03\x02\x02\x02\u0581\u026E\x03\x02\x02\x02\u0581\u0277\x03\x02\x02\x02\u0581\u027E\x03\x02\x02\x02\u0581\u0281\x03\x02\x02\x02\u0581\u0288\x03\x02\x02\x02\u0581\u028D\x03\x02\x02\x02\u0581\u0292\x03\x02\x02\x02\u0581\u029B\x03\x02\x02\x02\u0581\u029F\x03\x02\x02\x02\u0581\u02A6\x03\x02\x02\x02\u0581\u02AD\x03\x02\x02\x02\u0581\u02B7\x03\x02\x02\x02\u0581\u02BC\x03\x02\x02\x02\u0581\u02C4\x03\x02\x02\x02\u0581\u02CB\x03\x02\x02\x02\u0581\u02D3\x03\x02\x02\x02\u0581\u02D9\x03\x02\x02\x02\u0581\u02DF\x03\x02\x02\x02\u0581\u02E4\x03\x02\x02\x02\u0581\u02EA\x03\x02\x02\x02\u0581\u02F0\x03\x02\x02\x02\u0581\u02F6\x03\x02\x02\x02\u0581\u02FA\x03\x02\x02\x02\u0581\u0303\x03\x02\x02\x02\u0581\u0306\x03\x02\x02\x02\u0581\u030B\x03\x02\x02\x02\u0581\u0311\x03\x02\x02\x02\u0581\u0319\x03\x02\x02\x02\u0581\u031F\x03\x02\x02\x02\u0581\u0326\x03\x02\x02\x02\u0581\u0331\x03\x02\x02\x02\u0581\u0334\x03\x02\x02\x02\u0581\u033E\x03\x02\x02\x02\u0581\u0348\x03\x02\x02\x02\u0581\u034E\x03\x02\x02\x02\u0581\u0356\x03\x02\x02\x02\u0581\u035C\x03\x02\x02\x02\u0581\u0362\x03\x02\x02\x02\u0581\u0368\x03\x02\x02\x02\u0581\u036F\x03\x02\x02\x02\u0581\u0373\x03\x02\x02\x02\u0581\u037B\x03\x02\x02\x02\u0581\u0385\x03\x02\x02\x02\u0581\u0392\x03\x02\x02\x02\u0581\u0397\x03\x02\x02\x02\u0581\u039F\x03\x02\x02\x02\u0581\u03A6\x03\x02\x02\x02\u0581\u03AB\x03\x02\x02\x02\u0581\u03B0\x03\x02\x02\x02\u0581\u03B5\x03\x02\x02\x02\u0581\u03BA\x03\x02\x02\x02\u0581\u03BF\x03\x02\x02\x02\u0581\u03C5\x03\x02\x02\x02\u0581\u03CA\x03\x02\x02\x02\u0581\u03CF\x03\x02\x02\x02\u0581\u03D3\x03\x02\x02\x02\u0581\u03D7\x03\x02\x02\x02\u0581\u03DD\x03\x02\x02\x02\u0581\u03E2\x03\x02\x02\x02\u0581\u03E9\x03\x02\x02\x02\u0581\u03F0\x03\x02\x02\x02\u0581\u03F5\x03\x02\x02\x02\u0581\u03FE\x03\x02\x02\x02\u0581\u0403\x03\x02\x02\x02\u0581\u040B\x03\x02\x02\x02\u0581\u0411\x03\x02\x02\x02\u0581\u0418\x03\x02\x02\x02\u0581\u041F\x03\x02\x02\x02\u0581\u0426\x03\x02\x02\x02\u0581\u0429\x03\x02\x02\x02\u0581\u0430\x03\x02\x02\x02\u0581\u0436\x03\x02\x02\x02\u0581\u043D\x03\x02\x02\x02\u0581\u0443\x03\x02\x02\x02\u0581\u044C\x03\x02\x02\x02\u0581\u0452\x03\x02\x02\x02\u0581\u045D\x03\x02\x02\x02\u0581\u0464\x03\x02\x02\x02\u0581\u046A\x03\x02\x02\x02\u0581\u046E\x03\x02\x02\x02\u0581\u0478\x03\x02\x02\x02\u0581\u047F\x03\x02\x02\x02\u0581\u0488\x03\x02\x02\x02\u0581\u048F\x03\x02\x02\x02\u0581\u0497\x03\x02\x02\x02\u0581\u049E\x03\x02\x02\x02\u0581\u04A4\x03\x02\x02\x02\u0581\u04A8\x03\x02\x02\x02\u0581\u04AE\x03\x02\x02\x02\u0581\u04B5\x03\x02\x02\x02\u0581\u04BA\x03\x02\x02\x02\u0581\u04C1\x03\x02\x02\x02\u0581\u04C9\x03\x02\x02\x02\u0581\u04CD\x03\x02\x02\x02\u0581\u04D3\x03\x02\x02\x02\u0581\u04D8\x03\x02\x02\x02\u0581\u04DD\x03\x02\x02\x02\u0581\u04E3\x03\x02\x02\x02\u0581\u04EA\x03\x02\x02\x02\u0581\u04F1\x03\x02\x02\x02\u0581\u04FA\x03\x02\x02\x02\u0581\u04FE\x03\x02\x02\x02\u0581\u0506\x03\x02\x02\x02\u0581\u050C\x03\x02\x02\x02\u0581\u0511\x03\x02\x02\x02\u0581\u0517\x03\x02\x02\x02\u0581\u0523\x03\x02\x02\x02\u0581\u052B\x03\x02\x02\x02\u0581\u0530\x03\x02\x02\x02\u0581\u0534\x03\x02\x02\x02\u0581\u053A\x03\x02\x02\x02\u0581\u0541\x03\x02\x02\x02\u0581\u0548\x03\x02\x02\x02\u0581\u054D\x03\x02\x02\x02\u0581\u0556\x03\x02\x02\x02\u0581\u055D\x03\x02\x02\x02\u0581\u0562\x03\x02\x02\x02\u0581\u0567\x03\x02\x02\x02\u0581\u0570\x03\x02\x02\x02\u0581\u0576\x03\x02\x02\x02\u0581\u057C\x03\x02\x02\x02\u0582P\x03\x02\x02\x02\u0583\u0586\x05\x85B\x02\u0584\u0586\x05i4\x02\u0585\u0583\x03\x02\x02\x02\u0585\u0584\x03\x02\x02\x02\u0586\u0587\x03\x02\x02\x02\u0587\u0585\x03\x02\x02\x02\u0587\u0588\x03\x02\x02\x02\u0588R\x03\x02\x02\x02\u0589\u058B\x05\x8bE\x02\u058A\u0589\x03\x02\x02\x02\u058B\u058C\x03\x02\x02\x02\u058C\u058A\x03\x02\x02\x02\u058C\u058D\x03\x02\x02\x02\u058D\u058E\x03\x02\x02\x02\u058E\u058F\b)\x05\x02\u058FT\x03\x02\x02\x02\u0590\u0591\x05o7\x02\u0591V\x03\x02\x02\x02\u0592\u0593\v\x02\x02\x02\u0593X\x03\x02\x02\x02\u0594\u0595\x05q8\x02\u0595\u0596\x03\x02\x02\x02\u0596\u0597\b,\x06\x02\u0597Z\x03\x02\x02\x02\u0598\u059B\x05\x85B\x02\u0599\u059B\x05k5\x02\u059A\u0598\x03\x02\x02\x02\u059A\u0599\x03\x02\x02\x02\u059B\u059C\x03\x02\x02\x02\u059C\u059D\b-\x02\x02\u059D\\\x03\x02\x02\x02\u059E\u059F\x07\x02\x02\x03\u059F\u05A0\x03\x02\x02\x02\u05A0\u05A1\b.\x06\x02\u05A1^\x03\x02\x02\x02\u05A2\u05A3\v\x02\x02\x02\u05A3\u05A4\x03\x02\x02\x02\u05A4\u05A5\b/\x06\x02\u05A5`\x03\x02\x02\x02\u05A6\u05A7\x05s9\x02\u05A7\u05A8\x03\x02\x02\x02\u05A8\u05A9\b0\x06\x02\u05A9b\x03\x02\x02\x02\u05AA\u05AD\x05\x85B\x02\u05AB\u05AD\x05m6\x02\u05AC\u05AA\x03\x02\x02\x02\u05AC\u05AB\x03\x02\x02\x02\u05AD\u05AE\x03\x02\x02\x02\u05AE\u05AF\b1\x02\x02\u05AFd\x03\x02\x02\x02\u05B0\u05B1\x07\x02\x02\x03\u05B1\u05B2\x03\x02\x02\x02\u05B2\u05B3\b2\x06\x02\u05B3f\x03\x02\x02\x02\u05B4\u05B5\v\x02\x02\x02\u05B5\u05B6\x03\x02\x02\x02\u05B6\u05B7\b3\x06\x02\u05B7h\x03\x02\x02\x02\u05B8\u05B9\n\x02\x02\x02\u05B9j\x03\x02\x02\x02\u05BA\u05BB\n\x03\x02\x02\u05BBl\x03\x02\x02\x02\u05BC\u05BD\n\x04\x02\x02\u05BDn\x03\x02\x02\x02\u05BE\u05BF	\x05\x02\x02\u05BFp\x03\x02\x02\x02\u05C0\u05C1\x07$\x02\x02\u05C1r\x03\x02\x02\x02\u05C2\u05C3\x07)\x02\x02\u05C3t\x03\x02\x02\x02\u05C4\u05C5\x07^\x02\x02\u05C5v\x03\x02\x02\x02\u05C6\u05C7\x07\x0f\x02\x02\u05C7x\x03\x02\x02\x02\u05C8\u05C9\x07\f\x02\x02\u05C9z\x03\x02\x02\x02\u05CA\u05CB\x07"\x02\x02\u05CB|\x03\x02\x02\x02\u05CC\u05CD\x07(\x02\x02\u05CD~\x03\x02\x02\x02\u05CE\u05CF\x07(\x02\x02\u05CF\u05D0\x07(\x02\x02\u05D0\x80\x03\x02\x02\x02\u05D1\u05D2\x07~\x02\x02\u05D2\x82\x03\x02\x02\x02\u05D3\u05D4\x07~\x02\x02\u05D4\u05D5\x07~\x02\x02\u05D5\x84\x03\x02\x02\x02\u05D6\u05E2\x05u:\x02\u05D7\u05E3	\x06\x02\x02\u05D8\u05E3\x05q8\x02\u05D9\u05E3\x05s9\x02\u05DA\u05E3\x05u:\x02\u05DB\u05E3\x05{=\x02\u05DC\u05DD\x07w\x02\x02\u05DD\u05DE\x05\x89D\x02\u05DE\u05DF\x05\x89D\x02\u05DF\u05E0\x05\x89D\x02\u05E0\u05E1\x05\x89D\x02\u05E1\u05E3\x03\x02\x02\x02\u05E2\u05D7\x03\x02\x02\x02\u05E2\u05D8\x03\x02\x02\x02\u05E2\u05D9\x03\x02\x02\x02\u05E2\u05DA\x03\x02\x02\x02\u05E2\u05DB\x03\x02\x02\x02\u05E2\u05DC\x03\x02\x02\x02\u05E3\x86\x03\x02\x02\x02\u05E4\u05E7\x05w;\x02\u05E5\u05E7\x05y<\x02\u05E6\u05E4\x03\x02\x02\x02\u05E6\u05E5\x03\x02\x02\x02\u05E7\x88\x03\x02\x02\x02\u05E8\u05F0\x05\x8fG\x02\u05E9\u05F0\x05\x91H\x02\u05EA\u05F0\x05\x93I\x02\u05EB\u05F0\x05\x95J\x02\u05EC\u05F0\x05\x97K\x02\u05ED\u05F0\x05\x99L\x02\u05EE\u05F0\x05\x9bM\x02\u05EF\u05E8\x03\x02\x02\x02\u05EF\u05E9\x03\x02\x02\x02\u05EF\u05EA\x03\x02\x02\x02\u05EF\u05EB\x03\x02\x02\x02\u05EF\u05EC\x03\x02\x02\x02\u05EF\u05ED\x03\x02\x02\x02\u05EF\u05EE\x03\x02\x02\x02\u05F0\x8a\x03\x02\x02\x02\u05F1\u05F5\x05{=\x02\u05F2\u05F5\x07\v\x02\x02\u05F3\u05F5\x05\x87C\x02\u05F4\u05F1\x03\x02\x02\x02\u05F4\u05F2\x03\x02\x02\x02\u05F4\u05F3\x03\x02\x02\x02\u05F5\x8c\x03\x02\x02\x02\u05F6\u05F7\x07/\x02\x02\u05F7\x8e\x03\x02\x02\x02\u05F8\u05F9	\x07\x02\x02\u05F9\x90\x03\x02\x02\x02\u05FA\u05FB	\b\x02\x02\u05FB\x92\x03\x02\x02\x02\u05FC\u05FD		\x02\x02\u05FD\x94\x03\x02\x02\x02\u05FE\u05FF	\n\x02\x02\u05FF\x96\x03\x02\x02\x02\u0600\u0601	\v\x02\x02\u0601\x98\x03\x02\x02\x02\u0602\u0603	\f\x02\x02\u0603\x9a\x03\x02\x02\x02\u0604\u0605	\r\x02\x02\u0605\x9c\x03\x02\x02\x02\u0606\u0607	\x0e\x02\x02\u0607\x9e\x03\x02\x02\x02\u0608\u0609	\x0f\x02\x02\u0609\xa0\x03\x02\x02\x02\u060A\u060B	\x10\x02\x02\u060B\xa2\x03\x02\x02\x02\u060C\u060D	\x11\x02\x02\u060D\xa4\x03\x02\x02\x02\u060E\u060F	\x12\x02\x02\u060F\xa6\x03\x02\x02\x02\u0610\u0611	\x13\x02\x02\u0611\xa8\x03\x02\x02\x02\u0612\u0613	\x14\x02\x02\u0613\xaa\x03\x02\x02\x02\u0614\u0615	\x15\x02\x02\u0615\xac\x03\x02\x02\x02\u0616\u0617	\x16\x02\x02\u0617\xae\x03\x02\x02\x02\u0618\u0619	\x17\x02\x02\u0619\xb0\x03\x02\x02\x02\u061A\u061B	\x18\x02\x02\u061B\xb2\x03\x02\x02\x02\u061C\u061D	\x19\x02\x02\u061D\xb4\x03\x02\x02\x02\u061E\u061F	\x1a\x02\x02\u061F\xb6\x03\x02\x02\x02\u0620\u0621	\x1b\x02\x02\u0621\xb8\x03\x02\x02\x02\u0622\u0623	\x1c\x02\x02\u0623\xba\x03\x02\x02\x02\u0624\u0625	\x1d\x02\x02\u0625\xbc\x03\x02\x02\x02\u0626\u0627	\x1e\x02\x02\u0627\xbe\x03\x02\x02\x02\u0628\u0629	\x1f\x02\x02\u0629\xc0\x03\x02\x02\x02\u062A\u062B	 \x02\x02\u062B\xc2\x03\x02\x02\x02\u062C\u062D	!\x02\x02\u062D\xc4\x03\x02\x02\x02\x14\x02\x03\x04\xfb\u0102\u0113\u0155\u015B\u0581\u0585\u0587\u058C\u059A\u05AC\u05E2\u05E6\u05EF\u05F4\x07\x05\x02\x02\x04\x03\x02\x04\x04\x02\x02\x03\x02\x04\x02\x02';
    }
    static{
        this._serializedATN = $62Uvn.join([
            $80306ddcd52cd923$export$375c79404cc64c7f._serializedATNSegment0,
            $80306ddcd52cd923$export$375c79404cc64c7f._serializedATNSegment1,
            $80306ddcd52cd923$export$375c79404cc64c7f._serializedATNSegment2
        ], '');
    }
    static get _ATN() {
        if (!$80306ddcd52cd923$export$375c79404cc64c7f.__ATN) $80306ddcd52cd923$export$375c79404cc64c7f.__ATN = new (0, $1ztRl.ATNDeserializer)().deserialize($62Uvn.toCharArray($80306ddcd52cd923$export$375c79404cc64c7f._serializedATN));
        return $80306ddcd52cd923$export$375c79404cc64c7f.__ATN;
    }
}

});

parcelRegister("c35D3", function(module, exports) {

$parcel$export(module.exports, "JQLParser", () => $2ede3a572bfd1706$export$9c4772e191bdb810);
/* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// Generated from JQLParser.g4 by ANTLR 4.7.3-SNAPSHOT

var $1ztRl = parcelRequire("1ztRl");

var $iAlWg = parcelRequire("iAlWg");

var $c9Sjf = parcelRequire("c9Sjf");

var $2pDMz = parcelRequire("2pDMz");

var $gzbPK = parcelRequire("gzbPK");

var $b7PPe = parcelRequire("b7PPe");

var $eKXi4 = parcelRequire("eKXi4");

var $hBnE1 = parcelRequire("hBnE1");

var $62Uvn = parcelRequire("62Uvn");
class $2ede3a572bfd1706$export$9c4772e191bdb810 extends (0, $c9Sjf.Parser) {
    static{
        this.LPAREN = 1;
    }
    static{
        this.RPAREN = 2;
    }
    static{
        this.COMMA = 3;
    }
    static{
        this.LBRACKET = 4;
    }
    static{
        this.RBRACKET = 5;
    }
    static{
        this.BANG = 6;
    }
    static{
        this.LT = 7;
    }
    static{
        this.GT = 8;
    }
    static{
        this.GTEQ = 9;
    }
    static{
        this.LTEQ = 10;
    }
    static{
        this.EQUALS = 11;
    }
    static{
        this.NOT_EQUALS = 12;
    }
    static{
        this.LIKE = 13;
    }
    static{
        this.NOT_LIKE = 14;
    }
    static{
        this.IN = 15;
    }
    static{
        this.IS = 16;
    }
    static{
        this.AND = 17;
    }
    static{
        this.OR = 18;
    }
    static{
        this.NOT = 19;
    }
    static{
        this.EMPTY = 20;
    }
    static{
        this.WAS = 21;
    }
    static{
        this.CHANGED = 22;
    }
    static{
        this.BEFORE = 23;
    }
    static{
        this.AFTER = 24;
    }
    static{
        this.FROM = 25;
    }
    static{
        this.TO = 26;
    }
    static{
        this.ON = 27;
    }
    static{
        this.DURING = 28;
    }
    static{
        this.ORDER = 29;
    }
    static{
        this.BY = 30;
    }
    static{
        this.ASC = 31;
    }
    static{
        this.DESC = 32;
    }
    static{
        this.POSNUMBER = 33;
    }
    static{
        this.NEGNUMBER = 34;
    }
    static{
        this.CUSTOMFIELD = 35;
    }
    static{
        this.RESERVED_WORD = 36;
    }
    static{
        this.STRING = 37;
    }
    static{
        this.MATCHWS = 38;
    }
    static{
        this.ERROR_RESERVED = 39;
    }
    static{
        this.ERRORCHAR = 40;
    }
    static{
        this.QUOTE_STRING = 41;
    }
    static{
        this.UNCLOSED_QUOTE_STRING = 42;
    }
    static{
        this.INVALID_QUOTE_STRING = 43;
    }
    static{
        this.SQUOTE_STRING = 44;
    }
    static{
        this.UNCLOSED_SQUOTE_STRING = 45;
    }
    static{
        this.INVALID_SQUOTE_STRING = 46;
    }
    static{
        this.RULE_jqlQuery = 0;
    }
    static{
        this.RULE_jqlWhere = 1;
    }
    static{
        this.RULE_jqlOrClause = 2;
    }
    static{
        this.RULE_jqlAndClause = 3;
    }
    static{
        this.RULE_jqlNotClause = 4;
    }
    static{
        this.RULE_jqlSubClause = 5;
    }
    static{
        this.RULE_jqlTerminalClause = 6;
    }
    static{
        this.RULE_jqlTerminalClauseRhs = 7;
    }
    static{
        this.RULE_jqlEqualsOperator = 8;
    }
    static{
        this.RULE_jqlLikeOperator = 9;
    }
    static{
        this.RULE_jqlComparisonOperator = 10;
    }
    static{
        this.RULE_jqlInOperator = 11;
    }
    static{
        this.RULE_jqlIsOperator = 12;
    }
    static{
        this.RULE_jqlWasOperator = 13;
    }
    static{
        this.RULE_jqlWasInOperator = 14;
    }
    static{
        this.RULE_jqlChangedOperator = 15;
    }
    static{
        this.RULE_jqlField = 16;
    }
    static{
        this.RULE_jqlFieldProperty = 17;
    }
    static{
        this.RULE_jqlCustomField = 18;
    }
    static{
        this.RULE_jqlString = 19;
    }
    static{
        this.RULE_jqlNumber = 20;
    }
    static{
        this.RULE_jqlOperand = 21;
    }
    static{
        this.RULE_jqlEmpty = 22;
    }
    static{
        this.RULE_jqlValue = 23;
    }
    static{
        this.RULE_jqlFunction = 24;
    }
    static{
        this.RULE_jqlFunctionName = 25;
    }
    static{
        this.RULE_jqlArgumentList = 26;
    }
    static{
        this.RULE_jqlList = 27;
    }
    static{
        this.RULE_jqlListStart = 28;
    }
    static{
        this.RULE_jqlListEnd = 29;
    }
    static{
        this.RULE_jqlPropertyArgument = 30;
    }
    static{
        this.RULE_jqlArgument = 31;
    }
    static{
        this.RULE_jqlWasPredicate = 32;
    }
    static{
        this.RULE_jqlChangedPredicate = 33;
    }
    static{
        this.RULE_jqlDatePredicateOperator = 34;
    }
    static{
        this.RULE_jqlDateRangePredicateOperator = 35;
    }
    static{
        this.RULE_jqlUserPredicateOperator = 36;
    }
    static{
        this.RULE_jqlValuePredicateOperator = 37;
    }
    static{
        this.RULE_jqlPredicateOperand = 38;
    }
    static{
        this.RULE_jqlOrderBy = 39;
    }
    static{
        this.RULE_jqlSearchSort = 40;
    }
    static{
        // tslint:disable:no-trailing-whitespace
        this.ruleNames = [
            'jqlQuery',
            'jqlWhere',
            'jqlOrClause',
            'jqlAndClause',
            'jqlNotClause',
            'jqlSubClause',
            'jqlTerminalClause',
            'jqlTerminalClauseRhs',
            'jqlEqualsOperator',
            'jqlLikeOperator',
            'jqlComparisonOperator',
            'jqlInOperator',
            'jqlIsOperator',
            'jqlWasOperator',
            'jqlWasInOperator',
            'jqlChangedOperator',
            'jqlField',
            'jqlFieldProperty',
            'jqlCustomField',
            'jqlString',
            'jqlNumber',
            'jqlOperand',
            'jqlEmpty',
            'jqlValue',
            'jqlFunction',
            'jqlFunctionName',
            'jqlArgumentList',
            'jqlList',
            'jqlListStart',
            'jqlListEnd',
            'jqlPropertyArgument',
            'jqlArgument',
            'jqlWasPredicate',
            'jqlChangedPredicate',
            'jqlDatePredicateOperator',
            'jqlDateRangePredicateOperator',
            'jqlUserPredicateOperator',
            'jqlValuePredicateOperator',
            'jqlPredicateOperand',
            'jqlOrderBy',
            'jqlSearchSort'
        ];
    }
    static{
        this._LITERAL_NAMES = [
            undefined,
            "'('",
            "')'",
            "','",
            "'['",
            "']'",
            "'!'",
            "'<'",
            "'>'",
            "'>='",
            "'<='",
            "'='",
            "'!='",
            "'~'",
            "'!~'"
        ];
    }
    static{
        this._SYMBOLIC_NAMES = [
            undefined,
            'LPAREN',
            'RPAREN',
            'COMMA',
            'LBRACKET',
            'RBRACKET',
            'BANG',
            'LT',
            'GT',
            'GTEQ',
            'LTEQ',
            'EQUALS',
            'NOT_EQUALS',
            'LIKE',
            'NOT_LIKE',
            'IN',
            'IS',
            'AND',
            'OR',
            'NOT',
            'EMPTY',
            'WAS',
            'CHANGED',
            'BEFORE',
            'AFTER',
            'FROM',
            'TO',
            'ON',
            'DURING',
            'ORDER',
            'BY',
            'ASC',
            'DESC',
            'POSNUMBER',
            'NEGNUMBER',
            'CUSTOMFIELD',
            'RESERVED_WORD',
            'STRING',
            'MATCHWS',
            'ERROR_RESERVED',
            'ERRORCHAR',
            'QUOTE_STRING',
            'UNCLOSED_QUOTE_STRING',
            'INVALID_QUOTE_STRING',
            'SQUOTE_STRING',
            'UNCLOSED_SQUOTE_STRING',
            'INVALID_SQUOTE_STRING'
        ];
    }
    static{
        this.VOCABULARY = new (0, $hBnE1.VocabularyImpl)($2ede3a572bfd1706$export$9c4772e191bdb810._LITERAL_NAMES, $2ede3a572bfd1706$export$9c4772e191bdb810._SYMBOLIC_NAMES, []);
    }
    // @Override
    // @NotNull
    get vocabulary() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.VOCABULARY;
    }
    // tslint:enable:no-trailing-whitespace
    // @Override
    get grammarFileName() {
        return 'JQLParser.g4';
    }
    // @Override
    get ruleNames() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.ruleNames;
    }
    // @Override
    get serializedATN() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810._serializedATN;
    }
    constructor(input){
        super(input);
        this._interp = new (0, $gzbPK.ParserATNSimulator)($2ede3a572bfd1706$export$9c4772e191bdb810._ATN, this);
    }
    // @RuleVersion(0)
    jqlQuery() {
        let _localctx = new $2ede3a572bfd1706$export$ff413535b9575c8(this._ctx, this.state);
        this.enterRule(_localctx, 0, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlQuery);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 83;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if ((_la & -32) === 0 && (1 << _la & (1 << $2ede3a572bfd1706$export$9c4772e191bdb810.LPAREN | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.BANG | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.NOT)) !== 0 || (_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $2ede3a572bfd1706$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.CUSTOMFIELD - 33 | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.STRING - 33 | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0) {
                this.state = 82;
                this.jqlWhere();
            }
            this.state = 86;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if (_la === $2ede3a572bfd1706$export$9c4772e191bdb810.ORDER) {
                this.state = 85;
                this.jqlOrderBy();
            }
            this.state = 88;
            this.match($2ede3a572bfd1706$export$9c4772e191bdb810.EOF);
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWhere() {
        let _localctx = new $2ede3a572bfd1706$export$4148a879cab28017(this._ctx, this.state);
        this.enterRule(_localctx, 2, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlWhere);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 90;
            this.jqlOrClause();
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlOrClause() {
        let _localctx = new $2ede3a572bfd1706$export$d69831d387793480(this._ctx, this.state);
        this.enterRule(_localctx, 4, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlOrClause);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 92;
            this.jqlAndClause();
            this.state = 97;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $2ede3a572bfd1706$export$9c4772e191bdb810.OR){
                this.state = 93;
                this.match($2ede3a572bfd1706$export$9c4772e191bdb810.OR);
                this.state = 94;
                this.jqlAndClause();
                this.state = 99;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlAndClause() {
        let _localctx = new $2ede3a572bfd1706$export$f16819001158b9e(this._ctx, this.state);
        this.enterRule(_localctx, 6, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlAndClause);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 100;
            this.jqlNotClause();
            this.state = 105;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $2ede3a572bfd1706$export$9c4772e191bdb810.AND){
                this.state = 101;
                this.match($2ede3a572bfd1706$export$9c4772e191bdb810.AND);
                this.state = 102;
                this.jqlNotClause();
                this.state = 107;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlNotClause() {
        let _localctx = new $2ede3a572bfd1706$export$5e9146f8d5cf1330(this._ctx, this.state);
        this.enterRule(_localctx, 8, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlNotClause);
        let _la;
        try {
            this.state = 112;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $2ede3a572bfd1706$export$9c4772e191bdb810.BANG:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.NOT:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 108;
                    _la = this._input.LA(1);
                    if (!(_la === $2ede3a572bfd1706$export$9c4772e191bdb810.BANG || _la === $2ede3a572bfd1706$export$9c4772e191bdb810.NOT)) this._errHandler.recoverInline(this);
                    else {
                        if (this._input.LA(1) === (0, $eKXi4.Token).EOF) this.matchedEOF = true;
                        this._errHandler.reportMatch(this);
                        this.consume();
                    }
                    this.state = 109;
                    this.jqlNotClause();
                    break;
                case $2ede3a572bfd1706$export$9c4772e191bdb810.LPAREN:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 110;
                    this.jqlSubClause();
                    break;
                case $2ede3a572bfd1706$export$9c4772e191bdb810.POSNUMBER:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.NEGNUMBER:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.CUSTOMFIELD:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.STRING:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.QUOTE_STRING:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 3);
                    this.state = 111;
                    this.jqlTerminalClause();
                    break;
                default:
                    throw new (0, $iAlWg.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlSubClause() {
        let _localctx = new $2ede3a572bfd1706$export$a136a0e9655bfb04(this._ctx, this.state);
        this.enterRule(_localctx, 10, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlSubClause);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 114;
            this.match($2ede3a572bfd1706$export$9c4772e191bdb810.LPAREN);
            this.state = 115;
            this.jqlOrClause();
            this.state = 116;
            this.match($2ede3a572bfd1706$export$9c4772e191bdb810.RPAREN);
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlTerminalClause() {
        let _localctx = new $2ede3a572bfd1706$export$23486a2f2ddd5bcd(this._ctx, this.state);
        this.enterRule(_localctx, 12, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlTerminalClause);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 118;
            this.jqlField();
            this.state = 119;
            this.jqlTerminalClauseRhs();
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlTerminalClauseRhs() {
        let _localctx = new $2ede3a572bfd1706$export$93924a205c12d32c(this._ctx, this.state);
        this.enterRule(_localctx, 14, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlTerminalClauseRhs);
        let _la;
        try {
            this.state = 176;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 14, this._ctx)){
                case 1:
                    _localctx = new $2ede3a572bfd1706$export$c428f709a58396e5(_localctx);
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 121;
                    this.jqlEqualsOperator();
                    this.state = 125;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 5, this._ctx)){
                        case 1:
                            this.state = 122;
                            this.jqlEmpty();
                            break;
                        case 2:
                            this.state = 123;
                            this.jqlValue();
                            break;
                        case 3:
                            this.state = 124;
                            this.jqlFunction();
                            break;
                    }
                    break;
                case 2:
                    _localctx = new $2ede3a572bfd1706$export$1b131204ef9fa33d(_localctx);
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 127;
                    this.jqlLikeOperator();
                    this.state = 131;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 6, this._ctx)){
                        case 1:
                            this.state = 128;
                            this.jqlEmpty();
                            break;
                        case 2:
                            this.state = 129;
                            this.jqlValue();
                            break;
                        case 3:
                            this.state = 130;
                            this.jqlFunction();
                            break;
                    }
                    break;
                case 3:
                    _localctx = new $2ede3a572bfd1706$export$d83706ee80a9852a(_localctx);
                    this.enterOuterAlt(_localctx, 3);
                    this.state = 133;
                    this.jqlComparisonOperator();
                    this.state = 136;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 7, this._ctx)){
                        case 1:
                            this.state = 134;
                            this.jqlValue();
                            break;
                        case 2:
                            this.state = 135;
                            this.jqlFunction();
                            break;
                    }
                    break;
                case 4:
                    _localctx = new $2ede3a572bfd1706$export$2934b8ff22fddd2d(_localctx);
                    this.enterOuterAlt(_localctx, 4);
                    this.state = 138;
                    this.jqlInOperator();
                    this.state = 141;
                    this._errHandler.sync(this);
                    switch(this._input.LA(1)){
                        case $2ede3a572bfd1706$export$9c4772e191bdb810.LPAREN:
                            this.state = 139;
                            this.jqlList();
                            break;
                        case $2ede3a572bfd1706$export$9c4772e191bdb810.POSNUMBER:
                        case $2ede3a572bfd1706$export$9c4772e191bdb810.NEGNUMBER:
                        case $2ede3a572bfd1706$export$9c4772e191bdb810.STRING:
                        case $2ede3a572bfd1706$export$9c4772e191bdb810.QUOTE_STRING:
                        case $2ede3a572bfd1706$export$9c4772e191bdb810.SQUOTE_STRING:
                            this.state = 140;
                            this.jqlFunction();
                            break;
                        default:
                            throw new (0, $iAlWg.NoViableAltException)(this);
                    }
                    break;
                case 5:
                    _localctx = new $2ede3a572bfd1706$export$8b84310182afcf93(_localctx);
                    this.enterOuterAlt(_localctx, 5);
                    this.state = 143;
                    this.jqlIsOperator();
                    this.state = 144;
                    this.jqlEmpty();
                    break;
                case 6:
                    _localctx = new $2ede3a572bfd1706$export$5df295dc7a2cac7c(_localctx);
                    this.enterOuterAlt(_localctx, 6);
                    this.state = 146;
                    this.jqlWasOperator();
                    this.state = 150;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 9, this._ctx)){
                        case 1:
                            this.state = 147;
                            this.jqlEmpty();
                            break;
                        case 2:
                            this.state = 148;
                            this.jqlValue();
                            break;
                        case 3:
                            this.state = 149;
                            this.jqlFunction();
                            break;
                    }
                    this.state = 155;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while((_la & -32) === 0 && (1 << _la & (1 << $2ede3a572bfd1706$export$9c4772e191bdb810.BEFORE | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.AFTER | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.ON | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.DURING | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.BY)) !== 0){
                        this.state = 152;
                        this.jqlWasPredicate();
                        this.state = 157;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
                case 7:
                    _localctx = new $2ede3a572bfd1706$export$9ac3367aee261b32(_localctx);
                    this.enterOuterAlt(_localctx, 7);
                    this.state = 158;
                    this.jqlWasInOperator();
                    this.state = 161;
                    this._errHandler.sync(this);
                    switch(this._input.LA(1)){
                        case $2ede3a572bfd1706$export$9c4772e191bdb810.LPAREN:
                            this.state = 159;
                            this.jqlList();
                            break;
                        case $2ede3a572bfd1706$export$9c4772e191bdb810.POSNUMBER:
                        case $2ede3a572bfd1706$export$9c4772e191bdb810.NEGNUMBER:
                        case $2ede3a572bfd1706$export$9c4772e191bdb810.STRING:
                        case $2ede3a572bfd1706$export$9c4772e191bdb810.QUOTE_STRING:
                        case $2ede3a572bfd1706$export$9c4772e191bdb810.SQUOTE_STRING:
                            this.state = 160;
                            this.jqlFunction();
                            break;
                        default:
                            throw new (0, $iAlWg.NoViableAltException)(this);
                    }
                    this.state = 166;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while((_la & -32) === 0 && (1 << _la & (1 << $2ede3a572bfd1706$export$9c4772e191bdb810.BEFORE | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.AFTER | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.ON | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.DURING | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.BY)) !== 0){
                        this.state = 163;
                        this.jqlWasPredicate();
                        this.state = 168;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
                case 8:
                    _localctx = new $2ede3a572bfd1706$export$7a7defca8628a13c(_localctx);
                    this.enterOuterAlt(_localctx, 8);
                    this.state = 169;
                    this.jqlChangedOperator();
                    this.state = 173;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while((_la & -32) === 0 && (1 << _la & (1 << $2ede3a572bfd1706$export$9c4772e191bdb810.BEFORE | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.AFTER | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.FROM | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.TO | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.ON | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.DURING | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.BY)) !== 0){
                        this.state = 170;
                        this.jqlChangedPredicate();
                        this.state = 175;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlEqualsOperator() {
        let _localctx = new $2ede3a572bfd1706$export$41e475fc1988e413(this._ctx, this.state);
        this.enterRule(_localctx, 16, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlEqualsOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 178;
            _la = this._input.LA(1);
            if (!(_la === $2ede3a572bfd1706$export$9c4772e191bdb810.EQUALS || _la === $2ede3a572bfd1706$export$9c4772e191bdb810.NOT_EQUALS)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $eKXi4.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlLikeOperator() {
        let _localctx = new $2ede3a572bfd1706$export$b76fe5387fdd7efd(this._ctx, this.state);
        this.enterRule(_localctx, 18, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlLikeOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 180;
            _la = this._input.LA(1);
            if (!(_la === $2ede3a572bfd1706$export$9c4772e191bdb810.LIKE || _la === $2ede3a572bfd1706$export$9c4772e191bdb810.NOT_LIKE)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $eKXi4.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlComparisonOperator() {
        let _localctx = new $2ede3a572bfd1706$export$d821da0716b3ec95(this._ctx, this.state);
        this.enterRule(_localctx, 20, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlComparisonOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 182;
            _la = this._input.LA(1);
            if (!((_la & -32) === 0 && (1 << _la & (1 << $2ede3a572bfd1706$export$9c4772e191bdb810.LT | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.GT | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.GTEQ | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.LTEQ)) !== 0)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $eKXi4.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlInOperator() {
        let _localctx = new $2ede3a572bfd1706$export$178478bfa8292f72(this._ctx, this.state);
        this.enterRule(_localctx, 22, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlInOperator);
        try {
            this.state = 187;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $2ede3a572bfd1706$export$9c4772e191bdb810.IN:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 184;
                    this.match($2ede3a572bfd1706$export$9c4772e191bdb810.IN);
                    break;
                case $2ede3a572bfd1706$export$9c4772e191bdb810.NOT:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 185;
                    this.match($2ede3a572bfd1706$export$9c4772e191bdb810.NOT);
                    this.state = 186;
                    this.match($2ede3a572bfd1706$export$9c4772e191bdb810.IN);
                    break;
                default:
                    throw new (0, $iAlWg.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlIsOperator() {
        let _localctx = new $2ede3a572bfd1706$export$e64c31d2830b66e4(this._ctx, this.state);
        this.enterRule(_localctx, 24, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlIsOperator);
        try {
            this.state = 192;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 16, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 189;
                    this.match($2ede3a572bfd1706$export$9c4772e191bdb810.IS);
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 190;
                    this.match($2ede3a572bfd1706$export$9c4772e191bdb810.IS);
                    this.state = 191;
                    this.match($2ede3a572bfd1706$export$9c4772e191bdb810.NOT);
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWasOperator() {
        let _localctx = new $2ede3a572bfd1706$export$7e283636700e4a6c(this._ctx, this.state);
        this.enterRule(_localctx, 26, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlWasOperator);
        try {
            this.state = 197;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 17, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 194;
                    this.match($2ede3a572bfd1706$export$9c4772e191bdb810.WAS);
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 195;
                    this.match($2ede3a572bfd1706$export$9c4772e191bdb810.WAS);
                    this.state = 196;
                    this.match($2ede3a572bfd1706$export$9c4772e191bdb810.NOT);
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWasInOperator() {
        let _localctx = new $2ede3a572bfd1706$export$b9118b1ed9a78d66(this._ctx, this.state);
        this.enterRule(_localctx, 28, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlWasInOperator);
        try {
            this.state = 204;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 18, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 199;
                    this.match($2ede3a572bfd1706$export$9c4772e191bdb810.WAS);
                    this.state = 200;
                    this.match($2ede3a572bfd1706$export$9c4772e191bdb810.IN);
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 201;
                    this.match($2ede3a572bfd1706$export$9c4772e191bdb810.WAS);
                    this.state = 202;
                    this.match($2ede3a572bfd1706$export$9c4772e191bdb810.NOT);
                    this.state = 203;
                    this.match($2ede3a572bfd1706$export$9c4772e191bdb810.IN);
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlChangedOperator() {
        let _localctx = new $2ede3a572bfd1706$export$493d626ed78ca66(this._ctx, this.state);
        this.enterRule(_localctx, 30, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlChangedOperator);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 206;
            this.match($2ede3a572bfd1706$export$9c4772e191bdb810.CHANGED);
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlField() {
        let _localctx = new $2ede3a572bfd1706$export$b33300c3d916229a(this._ctx, this.state);
        this.enterRule(_localctx, 32, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlField);
        let _la;
        try {
            this.state = 219;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $2ede3a572bfd1706$export$9c4772e191bdb810.POSNUMBER:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.NEGNUMBER:
                    _localctx = new $2ede3a572bfd1706$export$11fec15307d2e17b(_localctx);
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 208;
                    this.jqlNumber();
                    break;
                case $2ede3a572bfd1706$export$9c4772e191bdb810.CUSTOMFIELD:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.STRING:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.QUOTE_STRING:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.SQUOTE_STRING:
                    _localctx = new $2ede3a572bfd1706$export$b8b24f99f985ebb3(_localctx);
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 211;
                    this._errHandler.sync(this);
                    switch(this._input.LA(1)){
                        case $2ede3a572bfd1706$export$9c4772e191bdb810.STRING:
                        case $2ede3a572bfd1706$export$9c4772e191bdb810.QUOTE_STRING:
                        case $2ede3a572bfd1706$export$9c4772e191bdb810.SQUOTE_STRING:
                            this.state = 209;
                            this.jqlString();
                            break;
                        case $2ede3a572bfd1706$export$9c4772e191bdb810.CUSTOMFIELD:
                            this.state = 210;
                            this.jqlCustomField();
                            break;
                        default:
                            throw new (0, $iAlWg.NoViableAltException)(this);
                    }
                    this.state = 216;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while(_la === $2ede3a572bfd1706$export$9c4772e191bdb810.LBRACKET){
                        this.state = 213;
                        this.jqlFieldProperty();
                        this.state = 218;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
                default:
                    throw new (0, $iAlWg.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlFieldProperty() {
        let _localctx = new $2ede3a572bfd1706$export$b02d0b6637ce0593(this._ctx, this.state);
        this.enterRule(_localctx, 34, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlFieldProperty);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 221;
            this.match($2ede3a572bfd1706$export$9c4772e191bdb810.LBRACKET);
            this.state = 222;
            this.jqlArgument();
            this.state = 223;
            this.match($2ede3a572bfd1706$export$9c4772e191bdb810.RBRACKET);
            this.state = 228;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while((_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $2ede3a572bfd1706$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.STRING - 33 | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0){
                this.state = 225;
                this.jqlPropertyArgument();
                this.state = 230;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlCustomField() {
        let _localctx = new $2ede3a572bfd1706$export$401a038855cc5b15(this._ctx, this.state);
        this.enterRule(_localctx, 36, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlCustomField);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 231;
            this.match($2ede3a572bfd1706$export$9c4772e191bdb810.CUSTOMFIELD);
            this.state = 232;
            this.match($2ede3a572bfd1706$export$9c4772e191bdb810.LBRACKET);
            this.state = 233;
            this.match($2ede3a572bfd1706$export$9c4772e191bdb810.POSNUMBER);
            this.state = 234;
            this.match($2ede3a572bfd1706$export$9c4772e191bdb810.RBRACKET);
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlString() {
        let _localctx = new $2ede3a572bfd1706$export$bde73d8ad7c8b71e(this._ctx, this.state);
        this.enterRule(_localctx, 38, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlString);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 236;
            _la = this._input.LA(1);
            if (!((_la - 37 & -32) === 0 && (1 << _la - 37 & (1 << $2ede3a572bfd1706$export$9c4772e191bdb810.STRING - 37 | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.QUOTE_STRING - 37 | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.SQUOTE_STRING - 37)) !== 0)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $eKXi4.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlNumber() {
        let _localctx = new $2ede3a572bfd1706$export$8737d94a1880e8b3(this._ctx, this.state);
        this.enterRule(_localctx, 40, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlNumber);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 238;
            _localctx._jqlNum = this._input.LT(1);
            _la = this._input.LA(1);
            if (!(_la === $2ede3a572bfd1706$export$9c4772e191bdb810.POSNUMBER || _la === $2ede3a572bfd1706$export$9c4772e191bdb810.NEGNUMBER)) _localctx._jqlNum = this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $eKXi4.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlOperand() {
        let _localctx = new $2ede3a572bfd1706$export$2eaac5a9828bf647(this._ctx, this.state);
        this.enterRule(_localctx, 42, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlOperand);
        try {
            this.state = 244;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 23, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 240;
                    this.jqlEmpty();
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 241;
                    this.jqlValue();
                    break;
                case 3:
                    this.enterOuterAlt(_localctx, 3);
                    this.state = 242;
                    this.jqlFunction();
                    break;
                case 4:
                    this.enterOuterAlt(_localctx, 4);
                    this.state = 243;
                    this.jqlList();
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlEmpty() {
        let _localctx = new $2ede3a572bfd1706$export$d85a062f90025e5c(this._ctx, this.state);
        this.enterRule(_localctx, 44, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlEmpty);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 246;
            this.match($2ede3a572bfd1706$export$9c4772e191bdb810.EMPTY);
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlValue() {
        let _localctx = new $2ede3a572bfd1706$export$2e17d457b0933bec(this._ctx, this.state);
        this.enterRule(_localctx, 46, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlValue);
        try {
            this.state = 250;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $2ede3a572bfd1706$export$9c4772e191bdb810.STRING:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.QUOTE_STRING:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 248;
                    this.jqlString();
                    break;
                case $2ede3a572bfd1706$export$9c4772e191bdb810.POSNUMBER:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.NEGNUMBER:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 249;
                    this.jqlNumber();
                    break;
                default:
                    throw new (0, $iAlWg.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlFunction() {
        let _localctx = new $2ede3a572bfd1706$export$ebf0cc785e9ee41a(this._ctx, this.state);
        this.enterRule(_localctx, 48, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlFunction);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 252;
            this.jqlFunctionName();
            this.state = 253;
            this.match($2ede3a572bfd1706$export$9c4772e191bdb810.LPAREN);
            this.state = 255;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if ((_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $2ede3a572bfd1706$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.STRING - 33 | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0) {
                this.state = 254;
                this.jqlArgumentList();
            }
            this.state = 257;
            this.match($2ede3a572bfd1706$export$9c4772e191bdb810.RPAREN);
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlFunctionName() {
        let _localctx = new $2ede3a572bfd1706$export$1f5f7ac816788f44(this._ctx, this.state);
        this.enterRule(_localctx, 50, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlFunctionName);
        try {
            this.state = 261;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $2ede3a572bfd1706$export$9c4772e191bdb810.STRING:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.QUOTE_STRING:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 259;
                    this.jqlString();
                    break;
                case $2ede3a572bfd1706$export$9c4772e191bdb810.POSNUMBER:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.NEGNUMBER:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 260;
                    this.jqlNumber();
                    break;
                default:
                    throw new (0, $iAlWg.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlArgumentList() {
        let _localctx = new $2ede3a572bfd1706$export$83d7c13849b931c3(this._ctx, this.state);
        this.enterRule(_localctx, 52, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlArgumentList);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 263;
            this.jqlArgument();
            this.state = 268;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $2ede3a572bfd1706$export$9c4772e191bdb810.COMMA){
                this.state = 264;
                this.match($2ede3a572bfd1706$export$9c4772e191bdb810.COMMA);
                this.state = 265;
                this.jqlArgument();
                this.state = 270;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlList() {
        let _localctx = new $2ede3a572bfd1706$export$9cb97a63f2be4864(this._ctx, this.state);
        this.enterRule(_localctx, 54, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlList);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 271;
            this.jqlListStart();
            this.state = 272;
            this.jqlOperand();
            this.state = 277;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $2ede3a572bfd1706$export$9c4772e191bdb810.COMMA){
                this.state = 273;
                this.match($2ede3a572bfd1706$export$9c4772e191bdb810.COMMA);
                this.state = 274;
                this.jqlOperand();
                this.state = 279;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
            this.state = 280;
            this.jqlListEnd();
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlListStart() {
        let _localctx = new $2ede3a572bfd1706$export$c419f717bfc46a5d(this._ctx, this.state);
        this.enterRule(_localctx, 56, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlListStart);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 282;
            this.match($2ede3a572bfd1706$export$9c4772e191bdb810.LPAREN);
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlListEnd() {
        let _localctx = new $2ede3a572bfd1706$export$f6cd3e372f5ab120(this._ctx, this.state);
        this.enterRule(_localctx, 58, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlListEnd);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 284;
            this.match($2ede3a572bfd1706$export$9c4772e191bdb810.RPAREN);
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlPropertyArgument() {
        let _localctx = new $2ede3a572bfd1706$export$e20ce4a2ed16372c(this._ctx, this.state);
        this.enterRule(_localctx, 60, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlPropertyArgument);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 286;
            this.jqlArgument();
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlArgument() {
        let _localctx = new $2ede3a572bfd1706$export$a95583953c237f88(this._ctx, this.state);
        this.enterRule(_localctx, 62, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlArgument);
        try {
            this.state = 290;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $2ede3a572bfd1706$export$9c4772e191bdb810.STRING:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.QUOTE_STRING:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 288;
                    this.jqlString();
                    break;
                case $2ede3a572bfd1706$export$9c4772e191bdb810.POSNUMBER:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.NEGNUMBER:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 289;
                    this.jqlNumber();
                    break;
                default:
                    throw new (0, $iAlWg.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWasPredicate() {
        let _localctx = new $2ede3a572bfd1706$export$9fa1e4d63f31b911(this._ctx, this.state);
        this.enterRule(_localctx, 64, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlWasPredicate);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 295;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $2ede3a572bfd1706$export$9c4772e191bdb810.BEFORE:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.AFTER:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.ON:
                    this.state = 292;
                    this.jqlDatePredicateOperator();
                    break;
                case $2ede3a572bfd1706$export$9c4772e191bdb810.DURING:
                    this.state = 293;
                    this.jqlDateRangePredicateOperator();
                    break;
                case $2ede3a572bfd1706$export$9c4772e191bdb810.BY:
                    this.state = 294;
                    this.jqlUserPredicateOperator();
                    break;
                default:
                    throw new (0, $iAlWg.NoViableAltException)(this);
            }
            this.state = 297;
            this.jqlPredicateOperand();
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlChangedPredicate() {
        let _localctx = new $2ede3a572bfd1706$export$e77e479a48133015(this._ctx, this.state);
        this.enterRule(_localctx, 66, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlChangedPredicate);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 303;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $2ede3a572bfd1706$export$9c4772e191bdb810.BEFORE:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.AFTER:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.ON:
                    this.state = 299;
                    this.jqlDatePredicateOperator();
                    break;
                case $2ede3a572bfd1706$export$9c4772e191bdb810.DURING:
                    this.state = 300;
                    this.jqlDateRangePredicateOperator();
                    break;
                case $2ede3a572bfd1706$export$9c4772e191bdb810.BY:
                    this.state = 301;
                    this.jqlUserPredicateOperator();
                    break;
                case $2ede3a572bfd1706$export$9c4772e191bdb810.FROM:
                case $2ede3a572bfd1706$export$9c4772e191bdb810.TO:
                    this.state = 302;
                    this.jqlValuePredicateOperator();
                    break;
                default:
                    throw new (0, $iAlWg.NoViableAltException)(this);
            }
            this.state = 305;
            this.jqlPredicateOperand();
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlDatePredicateOperator() {
        let _localctx = new $2ede3a572bfd1706$export$dc01290aee731418(this._ctx, this.state);
        this.enterRule(_localctx, 68, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlDatePredicateOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 307;
            _la = this._input.LA(1);
            if (!((_la & -32) === 0 && (1 << _la & (1 << $2ede3a572bfd1706$export$9c4772e191bdb810.BEFORE | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.AFTER | 1 << $2ede3a572bfd1706$export$9c4772e191bdb810.ON)) !== 0)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $eKXi4.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlDateRangePredicateOperator() {
        let _localctx = new $2ede3a572bfd1706$export$75412b8b6a6442e1(this._ctx, this.state);
        this.enterRule(_localctx, 70, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlDateRangePredicateOperator);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 309;
            this.match($2ede3a572bfd1706$export$9c4772e191bdb810.DURING);
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlUserPredicateOperator() {
        let _localctx = new $2ede3a572bfd1706$export$ad402332075c8656(this._ctx, this.state);
        this.enterRule(_localctx, 72, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlUserPredicateOperator);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 311;
            this.match($2ede3a572bfd1706$export$9c4772e191bdb810.BY);
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlValuePredicateOperator() {
        let _localctx = new $2ede3a572bfd1706$export$4239d7c0fbafd3f1(this._ctx, this.state);
        this.enterRule(_localctx, 74, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlValuePredicateOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 313;
            _la = this._input.LA(1);
            if (!(_la === $2ede3a572bfd1706$export$9c4772e191bdb810.FROM || _la === $2ede3a572bfd1706$export$9c4772e191bdb810.TO)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $eKXi4.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlPredicateOperand() {
        let _localctx = new $2ede3a572bfd1706$export$6b796c5a4b8c18e(this._ctx, this.state);
        this.enterRule(_localctx, 76, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlPredicateOperand);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 315;
            this.jqlOperand();
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlOrderBy() {
        let _localctx = new $2ede3a572bfd1706$export$534469b9c8f44139(this._ctx, this.state);
        this.enterRule(_localctx, 78, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlOrderBy);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 317;
            this.match($2ede3a572bfd1706$export$9c4772e191bdb810.ORDER);
            this.state = 318;
            this.match($2ede3a572bfd1706$export$9c4772e191bdb810.BY);
            this.state = 319;
            this.jqlSearchSort();
            this.state = 324;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $2ede3a572bfd1706$export$9c4772e191bdb810.COMMA){
                this.state = 320;
                this.match($2ede3a572bfd1706$export$9c4772e191bdb810.COMMA);
                this.state = 321;
                this.jqlSearchSort();
                this.state = 326;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlSearchSort() {
        let _localctx = new $2ede3a572bfd1706$export$c7d8f03f36952a46(this._ctx, this.state);
        this.enterRule(_localctx, 80, $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlSearchSort);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 327;
            this.jqlField();
            this.state = 329;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if (_la === $2ede3a572bfd1706$export$9c4772e191bdb810.ASC || _la === $2ede3a572bfd1706$export$9c4772e191bdb810.DESC) {
                this.state = 328;
                _la = this._input.LA(1);
                if (!(_la === $2ede3a572bfd1706$export$9c4772e191bdb810.ASC || _la === $2ede3a572bfd1706$export$9c4772e191bdb810.DESC)) this._errHandler.recoverInline(this);
                else {
                    if (this._input.LA(1) === (0, $eKXi4.Token).EOF) this.matchedEOF = true;
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        } catch (re) {
            if (re instanceof (0, $b7PPe.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    static{
        this._serializedATN = '\x03\uC91D\uCABA\u058D\uAFBA\u4F53\u0607\uEA8B\uC241\x030\u014E\x04\x02	\x02\x04\x03	\x03\x04\x04	\x04\x04\x05	\x05\x04\x06	\x06\x04\x07	\x07\x04\b	\b\x04			\x04\n	\n\x04\v	\v\x04\f	\f\x04\r	\r\x04\x0e	\x0e\x04\x0f	\x0f\x04\x10	\x10\x04\x11	\x11\x04\x12	\x12\x04\x13	\x13\x04\x14	\x14\x04\x15	\x15\x04\x16	\x16\x04\x17	\x17\x04\x18	\x18\x04\x19	\x19\x04\x1a	\x1a\x04\x1b	\x1b\x04\x1c	\x1c\x04\x1d	\x1d\x04\x1e	\x1e\x04\x1f	\x1f\x04 	 \x04!	!\x04"	"\x04#	#\x04$	$\x04%	%\x04&	&\x04\'	\'\x04(	(\x04)	)\x04*	*\x03\x02\x05\x02V\n\x02\x03\x02\x05\x02Y\n\x02\x03\x02\x03\x02\x03\x03\x03\x03\x03\x04\x03\x04\x03\x04\x07\x04b\n\x04\f\x04\x0e\x04e\v\x04\x03\x05\x03\x05\x03\x05\x07\x05j\n\x05\f\x05\x0e\x05m\v\x05\x03\x06\x03\x06\x03\x06\x03\x06\x05\x06s\n\x06\x03\x07\x03\x07\x03\x07\x03\x07\x03\b\x03\b\x03\b\x03	\x03	\x03	\x03	\x05	\x80\n	\x03	\x03	\x03	\x03	\x05	\x86\n	\x03	\x03	\x03	\x05	\x8b\n	\x03	\x03	\x03	\x05	\x90\n	\x03	\x03	\x03	\x03	\x03	\x03	\x03	\x05	\x99\n	\x03	\x07	\x9c\n	\f	\x0e	\x9f\v	\x03	\x03	\x03	\x05	\xa4\n	\x03	\x07	\xa7\n	\f	\x0e	\xaa\v	\x03	\x03	\x07	\xae\n	\f	\x0e	\xb1\v	\x05	\xb3\n	\x03\n\x03\n\x03\v\x03\v\x03\f\x03\f\x03\r\x03\r\x03\r\x05\r\xbe\n\r\x03\x0e\x03\x0e\x03\x0e\x05\x0e\xc3\n\x0e\x03\x0f\x03\x0f\x03\x0f\x05\x0f\xc8\n\x0f\x03\x10\x03\x10\x03\x10\x03\x10\x03\x10\x05\x10\xcf\n\x10\x03\x11\x03\x11\x03\x12\x03\x12\x03\x12\x05\x12\xd6\n\x12\x03\x12\x07\x12\xd9\n\x12\f\x12\x0e\x12\xdc\v\x12\x05\x12\xde\n\x12\x03\x13\x03\x13\x03\x13\x03\x13\x03\x13\x07\x13\xe5\n\x13\f\x13\x0e\x13\xe8\v\x13\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x03\x15\x03\x15\x03\x16\x03\x16\x03\x17\x03\x17\x03\x17\x03\x17\x05\x17\xf7\n\x17\x03\x18\x03\x18\x03\x19\x03\x19\x05\x19\xfd\n\x19\x03\x1a\x03\x1a\x03\x1a\x05\x1a\u0102\n\x1a\x03\x1a\x03\x1a\x03\x1b\x03\x1b\x05\x1b\u0108\n\x1b\x03\x1c\x03\x1c\x03\x1c\x07\x1c\u010D\n\x1c\f\x1c\x0e\x1c\u0110\v\x1c\x03\x1d\x03\x1d\x03\x1d\x03\x1d\x07\x1d\u0116\n\x1d\f\x1d\x0e\x1d\u0119\v\x1d\x03\x1d\x03\x1d\x03\x1e\x03\x1e\x03\x1f\x03\x1f\x03 \x03 \x03!\x03!\x05!\u0125\n!\x03"\x03"\x03"\x05"\u012A\n"\x03"\x03"\x03#\x03#\x03#\x03#\x05#\u0132\n#\x03#\x03#\x03$\x03$\x03%\x03%\x03&\x03&\x03\'\x03\'\x03(\x03(\x03)\x03)\x03)\x03)\x03)\x07)\u0145\n)\f)\x0e)\u0148\v)\x03*\x03*\x05*\u014C\n*\x03*\x02\x02\x02+\x02\x02\x04\x02\x06\x02\b\x02\n\x02\f\x02\x0e\x02\x10\x02\x12\x02\x14\x02\x16\x02\x18\x02\x1a\x02\x1c\x02\x1e\x02 \x02"\x02$\x02&\x02(\x02*\x02,\x02.\x020\x022\x024\x026\x028\x02:\x02<\x02>\x02@\x02B\x02D\x02F\x02H\x02J\x02L\x02N\x02P\x02R\x02\x02\v\x04\x02\b\b\x15\x15\x03\x02\r\x0e\x03\x02\x0f\x10\x03\x02	\f\x05\x02\'\'++..\x03\x02#$\x04\x02\x19\x1a\x1d\x1d\x03\x02\x1b\x1c\x03\x02!"\x02\u0155\x02U\x03\x02\x02\x02\x04\\\x03\x02\x02\x02\x06^\x03\x02\x02\x02\bf\x03\x02\x02\x02\nr\x03\x02\x02\x02\ft\x03\x02\x02\x02\x0ex\x03\x02\x02\x02\x10\xb2\x03\x02\x02\x02\x12\xb4\x03\x02\x02\x02\x14\xb6\x03\x02\x02\x02\x16\xb8\x03\x02\x02\x02\x18\xbd\x03\x02\x02\x02\x1a\xc2\x03\x02\x02\x02\x1c\xc7\x03\x02\x02\x02\x1e\xce\x03\x02\x02\x02 \xd0\x03\x02\x02\x02"\xdd\x03\x02\x02\x02$\xdf\x03\x02\x02\x02&\xe9\x03\x02\x02\x02(\xee\x03\x02\x02\x02*\xf0\x03\x02\x02\x02,\xf6\x03\x02\x02\x02.\xf8\x03\x02\x02\x020\xfc\x03\x02\x02\x022\xfe\x03\x02\x02\x024\u0107\x03\x02\x02\x026\u0109\x03\x02\x02\x028\u0111\x03\x02\x02\x02:\u011C\x03\x02\x02\x02<\u011E\x03\x02\x02\x02>\u0120\x03\x02\x02\x02@\u0124\x03\x02\x02\x02B\u0129\x03\x02\x02\x02D\u0131\x03\x02\x02\x02F\u0135\x03\x02\x02\x02H\u0137\x03\x02\x02\x02J\u0139\x03\x02\x02\x02L\u013B\x03\x02\x02\x02N\u013D\x03\x02\x02\x02P\u013F\x03\x02\x02\x02R\u0149\x03\x02\x02\x02TV\x05\x04\x03\x02UT\x03\x02\x02\x02UV\x03\x02\x02\x02VX\x03\x02\x02\x02WY\x05P)\x02XW\x03\x02\x02\x02XY\x03\x02\x02\x02YZ\x03\x02\x02\x02Z[\x07\x02\x02\x03[\x03\x03\x02\x02\x02\\]\x05\x06\x04\x02]\x05\x03\x02\x02\x02^c\x05\b\x05\x02_`\x07\x14\x02\x02`b\x05\b\x05\x02a_\x03\x02\x02\x02be\x03\x02\x02\x02ca\x03\x02\x02\x02cd\x03\x02\x02\x02d\x07\x03\x02\x02\x02ec\x03\x02\x02\x02fk\x05\n\x06\x02gh\x07\x13\x02\x02hj\x05\n\x06\x02ig\x03\x02\x02\x02jm\x03\x02\x02\x02ki\x03\x02\x02\x02kl\x03\x02\x02\x02l	\x03\x02\x02\x02mk\x03\x02\x02\x02no	\x02\x02\x02os\x05\n\x06\x02ps\x05\f\x07\x02qs\x05\x0e\b\x02rn\x03\x02\x02\x02rp\x03\x02\x02\x02rq\x03\x02\x02\x02s\v\x03\x02\x02\x02tu\x07\x03\x02\x02uv\x05\x06\x04\x02vw\x07\x04\x02\x02w\r\x03\x02\x02\x02xy\x05"\x12\x02yz\x05\x10	\x02z\x0f\x03\x02\x02\x02{\x7f\x05\x12\n\x02|\x80\x05.\x18\x02}\x80\x050\x19\x02~\x80\x052\x1a\x02\x7f|\x03\x02\x02\x02\x7f}\x03\x02\x02\x02\x7f~\x03\x02\x02\x02\x80\xb3\x03\x02\x02\x02\x81\x85\x05\x14\v\x02\x82\x86\x05.\x18\x02\x83\x86\x050\x19\x02\x84\x86\x052\x1a\x02\x85\x82\x03\x02\x02\x02\x85\x83\x03\x02\x02\x02\x85\x84\x03\x02\x02\x02\x86\xb3\x03\x02\x02\x02\x87\x8a\x05\x16\f\x02\x88\x8b\x050\x19\x02\x89\x8b\x052\x1a\x02\x8a\x88\x03\x02\x02\x02\x8a\x89\x03\x02\x02\x02\x8b\xb3\x03\x02\x02\x02\x8c\x8f\x05\x18\r\x02\x8d\x90\x058\x1d\x02\x8e\x90\x052\x1a\x02\x8f\x8d\x03\x02\x02\x02\x8f\x8e\x03\x02\x02\x02\x90\xb3\x03\x02\x02\x02\x91\x92\x05\x1a\x0e\x02\x92\x93\x05.\x18\x02\x93\xb3\x03\x02\x02\x02\x94\x98\x05\x1c\x0f\x02\x95\x99\x05.\x18\x02\x96\x99\x050\x19\x02\x97\x99\x052\x1a\x02\x98\x95\x03\x02\x02\x02\x98\x96\x03\x02\x02\x02\x98\x97\x03\x02\x02\x02\x99\x9d\x03\x02\x02\x02\x9a\x9c\x05B"\x02\x9b\x9a\x03\x02\x02\x02\x9c\x9f\x03\x02\x02\x02\x9d\x9b\x03\x02\x02\x02\x9d\x9e\x03\x02\x02\x02\x9e\xb3\x03\x02\x02\x02\x9f\x9d\x03\x02\x02\x02\xa0\xa3\x05\x1e\x10\x02\xa1\xa4\x058\x1d\x02\xa2\xa4\x052\x1a\x02\xa3\xa1\x03\x02\x02\x02\xa3\xa2\x03\x02\x02\x02\xa4\xa8\x03\x02\x02\x02\xa5\xa7\x05B"\x02\xa6\xa5\x03\x02\x02\x02\xa7\xaa\x03\x02\x02\x02\xa8\xa6\x03\x02\x02\x02\xa8\xa9\x03\x02\x02\x02\xa9\xb3\x03\x02\x02\x02\xaa\xa8\x03\x02\x02\x02\xab\xaf\x05 \x11\x02\xac\xae\x05D#\x02\xad\xac\x03\x02\x02\x02\xae\xb1\x03\x02\x02\x02\xaf\xad\x03\x02\x02\x02\xaf\xb0\x03\x02\x02\x02\xb0\xb3\x03\x02\x02\x02\xb1\xaf\x03\x02\x02\x02\xb2{\x03\x02\x02\x02\xb2\x81\x03\x02\x02\x02\xb2\x87\x03\x02\x02\x02\xb2\x8c\x03\x02\x02\x02\xb2\x91\x03\x02\x02\x02\xb2\x94\x03\x02\x02\x02\xb2\xa0\x03\x02\x02\x02\xb2\xab\x03\x02\x02\x02\xb3\x11\x03\x02\x02\x02\xb4\xb5	\x03\x02\x02\xb5\x13\x03\x02\x02\x02\xb6\xb7	\x04\x02\x02\xb7\x15\x03\x02\x02\x02\xb8\xb9	\x05\x02\x02\xb9\x17\x03\x02\x02\x02\xba\xbe\x07\x11\x02\x02\xbb\xbc\x07\x15\x02\x02\xbc\xbe\x07\x11\x02\x02\xbd\xba\x03\x02\x02\x02\xbd\xbb\x03\x02\x02\x02\xbe\x19\x03\x02\x02\x02\xbf\xc3\x07\x12\x02\x02\xc0\xc1\x07\x12\x02\x02\xc1\xc3\x07\x15\x02\x02\xc2\xbf\x03\x02\x02\x02\xc2\xc0\x03\x02\x02\x02\xc3\x1b\x03\x02\x02\x02\xc4\xc8\x07\x17\x02\x02\xc5\xc6\x07\x17\x02\x02\xc6\xc8\x07\x15\x02\x02\xc7\xc4\x03\x02\x02\x02\xc7\xc5\x03\x02\x02\x02\xc8\x1d\x03\x02\x02\x02\xc9\xca\x07\x17\x02\x02\xca\xcf\x07\x11\x02\x02\xcb\xcc\x07\x17\x02\x02\xcc\xcd\x07\x15\x02\x02\xcd\xcf\x07\x11\x02\x02\xce\xc9\x03\x02\x02\x02\xce\xcb\x03\x02\x02\x02\xcf\x1f\x03\x02\x02\x02\xd0\xd1\x07\x18\x02\x02\xd1!\x03\x02\x02\x02\xd2\xde\x05*\x16\x02\xd3\xd6\x05(\x15\x02\xd4\xd6\x05&\x14\x02\xd5\xd3\x03\x02\x02\x02\xd5\xd4\x03\x02\x02\x02\xd6\xda\x03\x02\x02\x02\xd7\xd9\x05$\x13\x02\xd8\xd7\x03\x02\x02\x02\xd9\xdc\x03\x02\x02\x02\xda\xd8\x03\x02\x02\x02\xda\xdb\x03\x02\x02\x02\xdb\xde\x03\x02\x02\x02\xdc\xda\x03\x02\x02\x02\xdd\xd2\x03\x02\x02\x02\xdd\xd5\x03\x02\x02\x02\xde#\x03\x02\x02\x02\xdf\xe0\x07\x06\x02\x02\xe0\xe1\x05@!\x02\xe1\xe2\x07\x07\x02\x02\xe2\xe6\x03\x02\x02\x02\xe3\xe5\x05> \x02\xe4\xe3\x03\x02\x02\x02\xe5\xe8\x03\x02\x02\x02\xe6\xe4\x03\x02\x02\x02\xe6\xe7\x03\x02\x02\x02\xe7%\x03\x02\x02\x02\xe8\xe6\x03\x02\x02\x02\xe9\xea\x07%\x02\x02\xea\xeb\x07\x06\x02\x02\xeb\xec\x07#\x02\x02\xec\xed\x07\x07\x02\x02\xed\'\x03\x02\x02\x02\xee\xef	\x06\x02\x02\xef)\x03\x02\x02\x02\xf0\xf1	\x07\x02\x02\xf1+\x03\x02\x02\x02\xf2\xf7\x05.\x18\x02\xf3\xf7\x050\x19\x02\xf4\xf7\x052\x1a\x02\xf5\xf7\x058\x1d\x02\xf6\xf2\x03\x02\x02\x02\xf6\xf3\x03\x02\x02\x02\xf6\xf4\x03\x02\x02\x02\xf6\xf5\x03\x02\x02\x02\xf7-\x03\x02\x02\x02\xf8\xf9\x07\x16\x02\x02\xf9/\x03\x02\x02\x02\xfa\xfd\x05(\x15\x02\xfb\xfd\x05*\x16\x02\xfc\xfa\x03\x02\x02\x02\xfc\xfb\x03\x02\x02\x02\xfd1\x03\x02\x02\x02\xfe\xff\x054\x1b\x02\xff\u0101\x07\x03\x02\x02\u0100\u0102\x056\x1c\x02\u0101\u0100\x03\x02\x02\x02\u0101\u0102\x03\x02\x02\x02\u0102\u0103\x03\x02\x02\x02\u0103\u0104\x07\x04\x02\x02\u01043\x03\x02\x02\x02\u0105\u0108\x05(\x15\x02\u0106\u0108\x05*\x16\x02\u0107\u0105\x03\x02\x02\x02\u0107\u0106\x03\x02\x02\x02\u01085\x03\x02\x02\x02\u0109\u010E\x05@!\x02\u010A\u010B\x07\x05\x02\x02\u010B\u010D\x05@!\x02\u010C\u010A\x03\x02\x02\x02\u010D\u0110\x03\x02\x02\x02\u010E\u010C\x03\x02\x02\x02\u010E\u010F\x03\x02\x02\x02\u010F7\x03\x02\x02\x02\u0110\u010E\x03\x02\x02\x02\u0111\u0112\x05:\x1e\x02\u0112\u0117\x05,\x17\x02\u0113\u0114\x07\x05\x02\x02\u0114\u0116\x05,\x17\x02\u0115\u0113\x03\x02\x02\x02\u0116\u0119\x03\x02\x02\x02\u0117\u0115\x03\x02\x02\x02\u0117\u0118\x03\x02\x02\x02\u0118\u011A\x03\x02\x02\x02\u0119\u0117\x03\x02\x02\x02\u011A\u011B\x05<\x1f\x02\u011B9\x03\x02\x02\x02\u011C\u011D\x07\x03\x02\x02\u011D;\x03\x02\x02\x02\u011E\u011F\x07\x04\x02\x02\u011F=\x03\x02\x02\x02\u0120\u0121\x05@!\x02\u0121?\x03\x02\x02\x02\u0122\u0125\x05(\x15\x02\u0123\u0125\x05*\x16\x02\u0124\u0122\x03\x02\x02\x02\u0124\u0123\x03\x02\x02\x02\u0125A\x03\x02\x02\x02\u0126\u012A\x05F$\x02\u0127\u012A\x05H%\x02\u0128\u012A\x05J&\x02\u0129\u0126\x03\x02\x02\x02\u0129\u0127\x03\x02\x02\x02\u0129\u0128\x03\x02\x02\x02\u012A\u012B\x03\x02\x02\x02\u012B\u012C\x05N(\x02\u012CC\x03\x02\x02\x02\u012D\u0132\x05F$\x02\u012E\u0132\x05H%\x02\u012F\u0132\x05J&\x02\u0130\u0132\x05L\'\x02\u0131\u012D\x03\x02\x02\x02\u0131\u012E\x03\x02\x02\x02\u0131\u012F\x03\x02\x02\x02\u0131\u0130\x03\x02\x02\x02\u0132\u0133\x03\x02\x02\x02\u0133\u0134\x05N(\x02\u0134E\x03\x02\x02\x02\u0135\u0136	\b\x02\x02\u0136G\x03\x02\x02\x02\u0137\u0138\x07\x1e\x02\x02\u0138I\x03\x02\x02\x02\u0139\u013A\x07 \x02\x02\u013AK\x03\x02\x02\x02\u013B\u013C		\x02\x02\u013CM\x03\x02\x02\x02\u013D\u013E\x05,\x17\x02\u013EO\x03\x02\x02\x02\u013F\u0140\x07\x1f\x02\x02\u0140\u0141\x07 \x02\x02\u0141\u0146\x05R*\x02\u0142\u0143\x07\x05\x02\x02\u0143\u0145\x05R*\x02\u0144\u0142\x03\x02\x02\x02\u0145\u0148\x03\x02\x02\x02\u0146\u0144\x03\x02\x02\x02\u0146\u0147\x03\x02\x02\x02\u0147Q\x03\x02\x02\x02\u0148\u0146\x03\x02\x02\x02\u0149\u014B\x05"\x12\x02\u014A\u014C	\n\x02\x02\u014B\u014A\x03\x02\x02\x02\u014B\u014C\x03\x02\x02\x02\u014CS\x03\x02\x02\x02$UXckr\x7f\x85\x8a\x8f\x98\x9d\xa3\xa8\xaf\xb2\xbd\xc2\xc7\xce\xd5\xda\xdd\xe6\xf6\xfc\u0101\u0107\u010E\u0117\u0124\u0129\u0131\u0146\u014B';
    }
    static get _ATN() {
        if (!$2ede3a572bfd1706$export$9c4772e191bdb810.__ATN) $2ede3a572bfd1706$export$9c4772e191bdb810.__ATN = new (0, $1ztRl.ATNDeserializer)().deserialize($62Uvn.toCharArray($2ede3a572bfd1706$export$9c4772e191bdb810._serializedATN));
        return $2ede3a572bfd1706$export$9c4772e191bdb810.__ATN;
    }
}
class $2ede3a572bfd1706$export$ff413535b9575c8 extends (0, $2pDMz.ParserRuleContext) {
    EOF() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.EOF, 0);
    }
    jqlWhere() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$4148a879cab28017);
    }
    jqlOrderBy() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$534469b9c8f44139);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlQuery;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlQuery) listener.enterJqlQuery(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlQuery) listener.exitJqlQuery(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlQuery) return visitor.visitJqlQuery(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$4148a879cab28017 extends (0, $2pDMz.ParserRuleContext) {
    jqlOrClause() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$d69831d387793480);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlWhere;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWhere) listener.enterJqlWhere(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWhere) listener.exitJqlWhere(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWhere) return visitor.visitJqlWhere(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$d69831d387793480 extends (0, $2pDMz.ParserRuleContext) {
    jqlAndClause(i) {
        if (i === undefined) return this.getRuleContexts($2ede3a572bfd1706$export$f16819001158b9e);
        else return this.getRuleContext(i, $2ede3a572bfd1706$export$f16819001158b9e);
    }
    OR(i) {
        if (i === undefined) return this.getTokens($2ede3a572bfd1706$export$9c4772e191bdb810.OR);
        else return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.OR, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlOrClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlOrClause) listener.enterJqlOrClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlOrClause) listener.exitJqlOrClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlOrClause) return visitor.visitJqlOrClause(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$f16819001158b9e extends (0, $2pDMz.ParserRuleContext) {
    jqlNotClause(i) {
        if (i === undefined) return this.getRuleContexts($2ede3a572bfd1706$export$5e9146f8d5cf1330);
        else return this.getRuleContext(i, $2ede3a572bfd1706$export$5e9146f8d5cf1330);
    }
    AND(i) {
        if (i === undefined) return this.getTokens($2ede3a572bfd1706$export$9c4772e191bdb810.AND);
        else return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.AND, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlAndClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlAndClause) listener.enterJqlAndClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlAndClause) listener.exitJqlAndClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlAndClause) return visitor.visitJqlAndClause(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$5e9146f8d5cf1330 extends (0, $2pDMz.ParserRuleContext) {
    jqlNotClause() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$5e9146f8d5cf1330);
    }
    NOT() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.NOT, 0);
    }
    BANG() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.BANG, 0);
    }
    jqlSubClause() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$a136a0e9655bfb04);
    }
    jqlTerminalClause() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$23486a2f2ddd5bcd);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlNotClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNotClause) listener.enterJqlNotClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNotClause) listener.exitJqlNotClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNotClause) return visitor.visitJqlNotClause(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$a136a0e9655bfb04 extends (0, $2pDMz.ParserRuleContext) {
    LPAREN() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.LPAREN, 0);
    }
    jqlOrClause() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$d69831d387793480);
    }
    RPAREN() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.RPAREN, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlSubClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlSubClause) listener.enterJqlSubClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlSubClause) listener.exitJqlSubClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlSubClause) return visitor.visitJqlSubClause(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$23486a2f2ddd5bcd extends (0, $2pDMz.ParserRuleContext) {
    jqlField() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$b33300c3d916229a);
    }
    jqlTerminalClauseRhs() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$93924a205c12d32c);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlTerminalClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlTerminalClause) listener.enterJqlTerminalClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlTerminalClause) listener.exitJqlTerminalClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlTerminalClause) return visitor.visitJqlTerminalClause(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$93924a205c12d32c extends (0, $2pDMz.ParserRuleContext) {
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlTerminalClauseRhs;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
}
class $2ede3a572bfd1706$export$c428f709a58396e5 extends $2ede3a572bfd1706$export$93924a205c12d32c {
    jqlEqualsOperator() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$41e475fc1988e413);
    }
    jqlEmpty() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$ebf0cc785e9ee41a);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlEqualsClause) listener.enterJqlEqualsClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlEqualsClause) listener.exitJqlEqualsClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlEqualsClause) return visitor.visitJqlEqualsClause(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$1b131204ef9fa33d extends $2ede3a572bfd1706$export$93924a205c12d32c {
    jqlLikeOperator() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$b76fe5387fdd7efd);
    }
    jqlEmpty() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$ebf0cc785e9ee41a);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlLikeClause) listener.enterJqlLikeClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlLikeClause) listener.exitJqlLikeClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlLikeClause) return visitor.visitJqlLikeClause(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$d83706ee80a9852a extends $2ede3a572bfd1706$export$93924a205c12d32c {
    jqlComparisonOperator() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$d821da0716b3ec95);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$ebf0cc785e9ee41a);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlComparisonClause) listener.enterJqlComparisonClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlComparisonClause) listener.exitJqlComparisonClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlComparisonClause) return visitor.visitJqlComparisonClause(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$2934b8ff22fddd2d extends $2ede3a572bfd1706$export$93924a205c12d32c {
    jqlInOperator() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$178478bfa8292f72);
    }
    jqlList() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$9cb97a63f2be4864);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$ebf0cc785e9ee41a);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlInClause) listener.enterJqlInClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlInClause) listener.exitJqlInClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlInClause) return visitor.visitJqlInClause(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$8b84310182afcf93 extends $2ede3a572bfd1706$export$93924a205c12d32c {
    jqlIsOperator() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$e64c31d2830b66e4);
    }
    jqlEmpty() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$d85a062f90025e5c);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlIsClause) listener.enterJqlIsClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlIsClause) listener.exitJqlIsClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlIsClause) return visitor.visitJqlIsClause(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$5df295dc7a2cac7c extends $2ede3a572bfd1706$export$93924a205c12d32c {
    jqlWasOperator() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$7e283636700e4a6c);
    }
    jqlEmpty() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$ebf0cc785e9ee41a);
    }
    jqlWasPredicate(i) {
        if (i === undefined) return this.getRuleContexts($2ede3a572bfd1706$export$9fa1e4d63f31b911);
        else return this.getRuleContext(i, $2ede3a572bfd1706$export$9fa1e4d63f31b911);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasClause) listener.enterJqlWasClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasClause) listener.exitJqlWasClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasClause) return visitor.visitJqlWasClause(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$9ac3367aee261b32 extends $2ede3a572bfd1706$export$93924a205c12d32c {
    jqlWasInOperator() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$b9118b1ed9a78d66);
    }
    jqlList() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$9cb97a63f2be4864);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$ebf0cc785e9ee41a);
    }
    jqlWasPredicate(i) {
        if (i === undefined) return this.getRuleContexts($2ede3a572bfd1706$export$9fa1e4d63f31b911);
        else return this.getRuleContext(i, $2ede3a572bfd1706$export$9fa1e4d63f31b911);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasInClause) listener.enterJqlWasInClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasInClause) listener.exitJqlWasInClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasInClause) return visitor.visitJqlWasInClause(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$7a7defca8628a13c extends $2ede3a572bfd1706$export$93924a205c12d32c {
    jqlChangedOperator() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$493d626ed78ca66);
    }
    jqlChangedPredicate(i) {
        if (i === undefined) return this.getRuleContexts($2ede3a572bfd1706$export$e77e479a48133015);
        else return this.getRuleContext(i, $2ede3a572bfd1706$export$e77e479a48133015);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlChangedClause) listener.enterJqlChangedClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlChangedClause) listener.exitJqlChangedClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlChangedClause) return visitor.visitJqlChangedClause(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$41e475fc1988e413 extends (0, $2pDMz.ParserRuleContext) {
    EQUALS() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.EQUALS, 0);
    }
    NOT_EQUALS() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.NOT_EQUALS, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlEqualsOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlEqualsOperator) listener.enterJqlEqualsOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlEqualsOperator) listener.exitJqlEqualsOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlEqualsOperator) return visitor.visitJqlEqualsOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$b76fe5387fdd7efd extends (0, $2pDMz.ParserRuleContext) {
    LIKE() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.LIKE, 0);
    }
    NOT_LIKE() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.NOT_LIKE, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlLikeOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlLikeOperator) listener.enterJqlLikeOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlLikeOperator) listener.exitJqlLikeOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlLikeOperator) return visitor.visitJqlLikeOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$d821da0716b3ec95 extends (0, $2pDMz.ParserRuleContext) {
    LT() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.LT, 0);
    }
    GT() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.GT, 0);
    }
    LTEQ() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.LTEQ, 0);
    }
    GTEQ() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.GTEQ, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlComparisonOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlComparisonOperator) listener.enterJqlComparisonOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlComparisonOperator) listener.exitJqlComparisonOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlComparisonOperator) return visitor.visitJqlComparisonOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$178478bfa8292f72 extends (0, $2pDMz.ParserRuleContext) {
    IN() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.IN, 0);
    }
    NOT() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.NOT, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlInOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlInOperator) listener.enterJqlInOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlInOperator) listener.exitJqlInOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlInOperator) return visitor.visitJqlInOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$e64c31d2830b66e4 extends (0, $2pDMz.ParserRuleContext) {
    IS() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.IS, 0);
    }
    NOT() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.NOT, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlIsOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlIsOperator) listener.enterJqlIsOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlIsOperator) listener.exitJqlIsOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlIsOperator) return visitor.visitJqlIsOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$7e283636700e4a6c extends (0, $2pDMz.ParserRuleContext) {
    WAS() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.WAS, 0);
    }
    NOT() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.NOT, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlWasOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasOperator) listener.enterJqlWasOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasOperator) listener.exitJqlWasOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasOperator) return visitor.visitJqlWasOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$b9118b1ed9a78d66 extends (0, $2pDMz.ParserRuleContext) {
    WAS() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.WAS, 0);
    }
    IN() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.IN, 0);
    }
    NOT() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.NOT, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlWasInOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasInOperator) listener.enterJqlWasInOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasInOperator) listener.exitJqlWasInOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasInOperator) return visitor.visitJqlWasInOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$493d626ed78ca66 extends (0, $2pDMz.ParserRuleContext) {
    CHANGED() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.CHANGED, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlChangedOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlChangedOperator) listener.enterJqlChangedOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlChangedOperator) listener.exitJqlChangedOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlChangedOperator) return visitor.visitJqlChangedOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$b33300c3d916229a extends (0, $2pDMz.ParserRuleContext) {
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlField;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
}
class $2ede3a572bfd1706$export$11fec15307d2e17b extends $2ede3a572bfd1706$export$b33300c3d916229a {
    jqlNumber() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$8737d94a1880e8b3);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNumberField) listener.enterJqlNumberField(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNumberField) listener.exitJqlNumberField(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNumberField) return visitor.visitJqlNumberField(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$b8b24f99f985ebb3 extends $2ede3a572bfd1706$export$b33300c3d916229a {
    jqlString() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$bde73d8ad7c8b71e);
    }
    jqlCustomField() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$401a038855cc5b15);
    }
    jqlFieldProperty(i) {
        if (i === undefined) return this.getRuleContexts($2ede3a572bfd1706$export$b02d0b6637ce0593);
        else return this.getRuleContext(i, $2ede3a572bfd1706$export$b02d0b6637ce0593);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNonNumberField) listener.enterJqlNonNumberField(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNonNumberField) listener.exitJqlNonNumberField(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNonNumberField) return visitor.visitJqlNonNumberField(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$b02d0b6637ce0593 extends (0, $2pDMz.ParserRuleContext) {
    LBRACKET() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.LBRACKET, 0);
    }
    RBRACKET() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.RBRACKET, 0);
    }
    jqlPropertyArgument(i) {
        if (i === undefined) return this.getRuleContexts($2ede3a572bfd1706$export$e20ce4a2ed16372c);
        else return this.getRuleContext(i, $2ede3a572bfd1706$export$e20ce4a2ed16372c);
    }
    jqlArgument() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$a95583953c237f88);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlFieldProperty;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlFieldProperty) listener.enterJqlFieldProperty(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlFieldProperty) listener.exitJqlFieldProperty(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlFieldProperty) return visitor.visitJqlFieldProperty(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$401a038855cc5b15 extends (0, $2pDMz.ParserRuleContext) {
    CUSTOMFIELD() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.CUSTOMFIELD, 0);
    }
    LBRACKET() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.LBRACKET, 0);
    }
    POSNUMBER() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.POSNUMBER, 0);
    }
    RBRACKET() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.RBRACKET, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlCustomField;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlCustomField) listener.enterJqlCustomField(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlCustomField) listener.exitJqlCustomField(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlCustomField) return visitor.visitJqlCustomField(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$bde73d8ad7c8b71e extends (0, $2pDMz.ParserRuleContext) {
    STRING() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.STRING, 0);
    }
    QUOTE_STRING() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.QUOTE_STRING, 0);
    }
    SQUOTE_STRING() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.SQUOTE_STRING, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlString;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlString) listener.enterJqlString(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlString) listener.exitJqlString(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlString) return visitor.visitJqlString(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$8737d94a1880e8b3 extends (0, $2pDMz.ParserRuleContext) {
    POSNUMBER() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.POSNUMBER, 0);
    }
    NEGNUMBER() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.NEGNUMBER, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlNumber;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNumber) listener.enterJqlNumber(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNumber) listener.exitJqlNumber(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNumber) return visitor.visitJqlNumber(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$2eaac5a9828bf647 extends (0, $2pDMz.ParserRuleContext) {
    jqlEmpty() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$ebf0cc785e9ee41a);
    }
    jqlList() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$9cb97a63f2be4864);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlOperand;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlOperand) listener.enterJqlOperand(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlOperand) listener.exitJqlOperand(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlOperand) return visitor.visitJqlOperand(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$d85a062f90025e5c extends (0, $2pDMz.ParserRuleContext) {
    EMPTY() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.EMPTY, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlEmpty;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlEmpty) listener.enterJqlEmpty(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlEmpty) listener.exitJqlEmpty(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlEmpty) return visitor.visitJqlEmpty(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$2e17d457b0933bec extends (0, $2pDMz.ParserRuleContext) {
    jqlString() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$bde73d8ad7c8b71e);
    }
    jqlNumber() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$8737d94a1880e8b3);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlValue;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlValue) listener.enterJqlValue(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlValue) listener.exitJqlValue(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlValue) return visitor.visitJqlValue(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$ebf0cc785e9ee41a extends (0, $2pDMz.ParserRuleContext) {
    jqlFunctionName() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$1f5f7ac816788f44);
    }
    LPAREN() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.LPAREN, 0);
    }
    RPAREN() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.RPAREN, 0);
    }
    jqlArgumentList() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$83d7c13849b931c3);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlFunction;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlFunction) listener.enterJqlFunction(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlFunction) listener.exitJqlFunction(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlFunction) return visitor.visitJqlFunction(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$1f5f7ac816788f44 extends (0, $2pDMz.ParserRuleContext) {
    jqlString() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$bde73d8ad7c8b71e);
    }
    jqlNumber() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$8737d94a1880e8b3);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlFunctionName;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlFunctionName) listener.enterJqlFunctionName(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlFunctionName) listener.exitJqlFunctionName(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlFunctionName) return visitor.visitJqlFunctionName(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$83d7c13849b931c3 extends (0, $2pDMz.ParserRuleContext) {
    jqlArgument(i) {
        if (i === undefined) return this.getRuleContexts($2ede3a572bfd1706$export$a95583953c237f88);
        else return this.getRuleContext(i, $2ede3a572bfd1706$export$a95583953c237f88);
    }
    COMMA(i) {
        if (i === undefined) return this.getTokens($2ede3a572bfd1706$export$9c4772e191bdb810.COMMA);
        else return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.COMMA, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlArgumentList;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlArgumentList) listener.enterJqlArgumentList(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlArgumentList) listener.exitJqlArgumentList(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlArgumentList) return visitor.visitJqlArgumentList(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$9cb97a63f2be4864 extends (0, $2pDMz.ParserRuleContext) {
    jqlListStart() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$c419f717bfc46a5d);
    }
    jqlOperand(i) {
        if (i === undefined) return this.getRuleContexts($2ede3a572bfd1706$export$2eaac5a9828bf647);
        else return this.getRuleContext(i, $2ede3a572bfd1706$export$2eaac5a9828bf647);
    }
    jqlListEnd() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$f6cd3e372f5ab120);
    }
    COMMA(i) {
        if (i === undefined) return this.getTokens($2ede3a572bfd1706$export$9c4772e191bdb810.COMMA);
        else return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.COMMA, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlList;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlList) listener.enterJqlList(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlList) listener.exitJqlList(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlList) return visitor.visitJqlList(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$c419f717bfc46a5d extends (0, $2pDMz.ParserRuleContext) {
    LPAREN() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.LPAREN, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlListStart;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlListStart) listener.enterJqlListStart(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlListStart) listener.exitJqlListStart(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlListStart) return visitor.visitJqlListStart(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$f6cd3e372f5ab120 extends (0, $2pDMz.ParserRuleContext) {
    RPAREN() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.RPAREN, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlListEnd;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlListEnd) listener.enterJqlListEnd(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlListEnd) listener.exitJqlListEnd(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlListEnd) return visitor.visitJqlListEnd(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$e20ce4a2ed16372c extends (0, $2pDMz.ParserRuleContext) {
    jqlArgument() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$a95583953c237f88);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlPropertyArgument;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlPropertyArgument) listener.enterJqlPropertyArgument(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlPropertyArgument) listener.exitJqlPropertyArgument(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlPropertyArgument) return visitor.visitJqlPropertyArgument(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$a95583953c237f88 extends (0, $2pDMz.ParserRuleContext) {
    jqlString() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$bde73d8ad7c8b71e);
    }
    jqlNumber() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$8737d94a1880e8b3);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlArgument;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlArgument) listener.enterJqlArgument(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlArgument) listener.exitJqlArgument(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlArgument) return visitor.visitJqlArgument(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$9fa1e4d63f31b911 extends (0, $2pDMz.ParserRuleContext) {
    jqlPredicateOperand() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$6b796c5a4b8c18e);
    }
    jqlDatePredicateOperator() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$dc01290aee731418);
    }
    jqlDateRangePredicateOperator() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$75412b8b6a6442e1);
    }
    jqlUserPredicateOperator() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$ad402332075c8656);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlWasPredicate;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasPredicate) listener.enterJqlWasPredicate(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasPredicate) listener.exitJqlWasPredicate(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasPredicate) return visitor.visitJqlWasPredicate(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$e77e479a48133015 extends (0, $2pDMz.ParserRuleContext) {
    jqlPredicateOperand() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$6b796c5a4b8c18e);
    }
    jqlDatePredicateOperator() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$dc01290aee731418);
    }
    jqlDateRangePredicateOperator() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$75412b8b6a6442e1);
    }
    jqlUserPredicateOperator() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$ad402332075c8656);
    }
    jqlValuePredicateOperator() {
        return this.tryGetRuleContext(0, $2ede3a572bfd1706$export$4239d7c0fbafd3f1);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlChangedPredicate;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlChangedPredicate) listener.enterJqlChangedPredicate(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlChangedPredicate) listener.exitJqlChangedPredicate(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlChangedPredicate) return visitor.visitJqlChangedPredicate(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$dc01290aee731418 extends (0, $2pDMz.ParserRuleContext) {
    AFTER() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.AFTER, 0);
    }
    BEFORE() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.BEFORE, 0);
    }
    ON() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.ON, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlDatePredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlDatePredicateOperator) listener.enterJqlDatePredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlDatePredicateOperator) listener.exitJqlDatePredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlDatePredicateOperator) return visitor.visitJqlDatePredicateOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$75412b8b6a6442e1 extends (0, $2pDMz.ParserRuleContext) {
    DURING() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.DURING, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlDateRangePredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlDateRangePredicateOperator) listener.enterJqlDateRangePredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlDateRangePredicateOperator) listener.exitJqlDateRangePredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlDateRangePredicateOperator) return visitor.visitJqlDateRangePredicateOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$ad402332075c8656 extends (0, $2pDMz.ParserRuleContext) {
    BY() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.BY, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlUserPredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlUserPredicateOperator) listener.enterJqlUserPredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlUserPredicateOperator) listener.exitJqlUserPredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlUserPredicateOperator) return visitor.visitJqlUserPredicateOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$4239d7c0fbafd3f1 extends (0, $2pDMz.ParserRuleContext) {
    FROM() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.FROM, 0);
    }
    TO() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.TO, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlValuePredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlValuePredicateOperator) listener.enterJqlValuePredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlValuePredicateOperator) listener.exitJqlValuePredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlValuePredicateOperator) return visitor.visitJqlValuePredicateOperator(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$6b796c5a4b8c18e extends (0, $2pDMz.ParserRuleContext) {
    jqlOperand() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$2eaac5a9828bf647);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlPredicateOperand;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlPredicateOperand) listener.enterJqlPredicateOperand(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlPredicateOperand) listener.exitJqlPredicateOperand(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlPredicateOperand) return visitor.visitJqlPredicateOperand(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$534469b9c8f44139 extends (0, $2pDMz.ParserRuleContext) {
    ORDER() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.ORDER, 0);
    }
    BY() {
        return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.BY, 0);
    }
    jqlSearchSort(i) {
        if (i === undefined) return this.getRuleContexts($2ede3a572bfd1706$export$c7d8f03f36952a46);
        else return this.getRuleContext(i, $2ede3a572bfd1706$export$c7d8f03f36952a46);
    }
    COMMA(i) {
        if (i === undefined) return this.getTokens($2ede3a572bfd1706$export$9c4772e191bdb810.COMMA);
        else return this.getToken($2ede3a572bfd1706$export$9c4772e191bdb810.COMMA, i);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlOrderBy;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlOrderBy) listener.enterJqlOrderBy(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlOrderBy) listener.exitJqlOrderBy(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlOrderBy) return visitor.visitJqlOrderBy(this);
        else return visitor.visitChildren(this);
    }
}
class $2ede3a572bfd1706$export$c7d8f03f36952a46 extends (0, $2pDMz.ParserRuleContext) {
    jqlField() {
        return this.getRuleContext(0, $2ede3a572bfd1706$export$b33300c3d916229a);
    }
    DESC() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.DESC, 0);
    }
    ASC() {
        return this.tryGetToken($2ede3a572bfd1706$export$9c4772e191bdb810.ASC, 0);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return $2ede3a572bfd1706$export$9c4772e191bdb810.RULE_jqlSearchSort;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlSearchSort) listener.enterJqlSearchSort(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlSearchSort) listener.exitJqlSearchSort(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlSearchSort) return visitor.visitJqlSearchSort(this);
        else return visitor.visitChildren(this);
    }
}

});

parcelRegister("ehDeP", function(module, exports) {

$parcel$export(module.exports, "internalCreators", () => $b9828d20df20ab04$export$64d991963cfb5532);
$parcel$export(module.exports, "default", () => $b9828d20df20ab04$export$2e2bcd8739ae039);

var $bdxrq = parcelRequire("bdxrq");

var $6PZUx = parcelRequire("6PZUx");

var $1tKLQ = parcelRequire("1tKLQ");

var $1l80e = parcelRequire("1l80e");

var $2H3zB = parcelRequire("2H3zB");

var $kDZbK = parcelRequire("kDZbK");

var $dnbob = parcelRequire("dnbob");

var $bfn5R = parcelRequire("bfn5R");

var $eD0Hy = parcelRequire("eD0Hy");

var $1uxra = parcelRequire("1uxra");

var $5eoHT = parcelRequire("5eoHT");

var $3T5iU = parcelRequire("3T5iU");

var $8Tr0t = parcelRequire("8Tr0t");

var $1R1xk = parcelRequire("1R1xk");

var $eHzms = parcelRequire("eHzms");

var $i2yZF = parcelRequire("i2yZF");

var $3fSGD = parcelRequire("3fSGD");

var $jvsC0 = parcelRequire("jvsC0");

var $bdP2p = parcelRequire("bdP2p");

var $1Rz9E = parcelRequire("1Rz9E");

var $5o1cq = parcelRequire("5o1cq");

var $4VxAa = parcelRequire("4VxAa");
const $b9828d20df20ab04$export$64d991963cfb5532 = {
    query: (0, $1Rz9E.queryInternal),
    compoundClause: (0, $6PZUx.compoundClauseInternal),
    compoundOperator: (0, $1tKLQ.compoundOperatorInternal),
    terminalClause: (0, $5o1cq.terminalClauseInternal),
    notClause: (0, $1uxra.notClauseInternal),
    notClauseOperator: (0, $5eoHT.notClauseOperatorInternal),
    predicate: (0, $3fSGD.predicateInternal),
    predicateOperator: (0, $jvsC0.predicateOperatorInternal),
    field: (0, $1l80e.fieldInternal),
    property: (0, $bdP2p.propertyInternal),
    operator: (0, $3T5iU.operatorInternal),
    valueOperand: (0, $4VxAa.valueOperandInternal),
    keywordOperand: (0, $bfn5R.keywordOperandInternal),
    functionOperand: (0, $2H3zB.functionOperandInternal),
    functionString: (0, $kDZbK.functionStringInternal),
    argument: (0, $bdxrq.argumentInternal),
    listOperand: (0, $eD0Hy.listOperandInternal),
    orderBy: (0, $8Tr0t.orderByInternal),
    orderByOperator: (0, $i2yZF.orderByOperatorInternal),
    orderByField: (0, $eHzms.orderByFieldInternal),
    orderByDirection: (0, $1R1xk.orderByDirectionInternal)
};
var $b9828d20df20ab04$export$2e2bcd8739ae039 = {
    jast: $dnbob.jast,
    query: $1Rz9E.query,
    compoundClause: $6PZUx.compoundClause,
    compoundOperator: $1tKLQ.compoundOperator,
    terminalClause: $5o1cq.terminalClause,
    notClause: $1uxra.notClause,
    notClauseOperator: $5eoHT.notClauseOperator,
    predicate: $3fSGD.predicate,
    predicateOperator: $jvsC0.predicateOperator,
    field: $1l80e.field,
    property: $bdP2p.property,
    operator: $3T5iU.operator,
    valueOperand: $4VxAa.valueOperand,
    keywordOperand: $bfn5R.keywordOperand,
    functionOperand: $2H3zB.functionOperand,
    functionString: $kDZbK.functionString,
    argument: $bdxrq.argument,
    listOperand: $eD0Hy.listOperand,
    orderBy: $8Tr0t.orderBy,
    orderByOperator: $i2yZF.orderByOperator,
    orderByField: $eHzms.orderByField,
    orderByDirection: $1R1xk.orderByDirection,
    byText: {
        argument: (0, $bdxrq.argumentByText),
        valueOperand: (0, $4VxAa.valueOperandByText)
    }
};

});
parcelRegister("bdxrq", function(module, exports) {

$parcel$export(module.exports, "argument", () => $07ff9cf8710db9a9$export$6ea29ee575e3f5ff);
$parcel$export(module.exports, "argumentInternal", () => $07ff9cf8710db9a9$export$5b341d50fa5bcdd5);
$parcel$export(module.exports, "argumentByText", () => $07ff9cf8710db9a9$export$84c43d23f51170cb);

var $g2nfy = parcelRequire("g2nfy");
var $tI64Y = parcelRequire("tI64Y");

var $8vd0B = parcelRequire("8vd0B");
function $07ff9cf8710db9a9$var$acceptArgument(visitor) {
    return visitor.visitArgument ? visitor.visitArgument(this) : visitor.visitChildren(this);
}
function $07ff9cf8710db9a9$var$enterNode(listener) {
    listener.enterArgument && listener.enterArgument(this);
}
function $07ff9cf8710db9a9$var$exitNode(listener) {
    listener.exitArgument && listener.exitArgument(this);
}
const $07ff9cf8710db9a9$export$6ea29ee575e3f5ff = (value)=>$07ff9cf8710db9a9$export$5b341d50fa5bcdd5(value, (0, $tI64Y.sanitiseJqlString)(value));
const $07ff9cf8710db9a9$export$84c43d23f51170cb = (text)=>$07ff9cf8710db9a9$export$5b341d50fa5bcdd5((0, $g2nfy.normaliseJqlString)(text), text);
const $07ff9cf8710db9a9$export$5b341d50fa5bcdd5 = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $07ff9cf8710db9a9$var$acceptArgument,
        enterNode: $07ff9cf8710db9a9$var$enterNode,
        exitNode: $07ff9cf8710db9a9$var$exitNode,
        getChildren: (0, $8vd0B.noChildren),
        parent: null
    });

});
parcelRegister("g2nfy", function(module, exports) {

$parcel$export(module.exports, "normaliseJqlString", () => $33fc07f8fcdc6596$export$cecf78a779acc0ff);
const $33fc07f8fcdc6596$export$7a0b99b892e0dda8 = (maybeQuotedString)=>{
    if (maybeQuotedString.length < 2) return false;
    return maybeQuotedString[0] === "'" && maybeQuotedString[maybeQuotedString.length - 1] === "'" && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
};
const $33fc07f8fcdc6596$export$d5efd6512db694fd = (maybeQuotedString)=>{
    if (maybeQuotedString.length < 2) return false;
    return maybeQuotedString[0] === '"' && maybeQuotedString[maybeQuotedString.length - 1] === '"' && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
};
const $33fc07f8fcdc6596$export$b86601123607fee5 = (maybeQuotedString)=>$33fc07f8fcdc6596$export$7a0b99b892e0dda8(maybeQuotedString) || $33fc07f8fcdc6596$export$d5efd6512db694fd(maybeQuotedString);
const $33fc07f8fcdc6596$export$cecf78a779acc0ff = (maybeQuotedString)=>{
    if ($33fc07f8fcdc6596$export$b86601123607fee5(maybeQuotedString)) return maybeQuotedString.slice(1, -1).replace(/(?:\\(.))/g, '$1');
    if (maybeQuotedString.startsWith('"') || maybeQuotedString.startsWith("'")) return maybeQuotedString.slice(1).replace(/(?:\\(.))/g, '$1');
    return maybeQuotedString;
};

});

parcelRegister("tI64Y", function(module, exports) {

$parcel$export(module.exports, "sanitiseJqlString", () => $67c602023b602b57$export$3eb9033c48208278);

var $e1vfz = parcelRequire("e1vfz");
// Derived from JQLLexer#VALID_UNQUOTED_CHARS
const $67c602023b602b57$var$CHARS_TO_QUOTE = new RegExp(`[\\s${(0, (/*@__PURE__*/$parcel$interopDefault($e1vfz)))(`"'=!<>()~,[]|&{}*/%+^$#@?;`)}]`);
const $67c602023b602b57$export$3eb9033c48208278 = (jqlString)=>{
    if ($67c602023b602b57$var$CHARS_TO_QUOTE.test(jqlString)) return `"${jqlString.replace(/"/g, '\\"')}"`;
    return jqlString;
};

});
parcelRegister("e1vfz", function(module, exports) {

var $1uqnh = parcelRequire("1uqnh");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $a359664a3c663e8b$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g, $a359664a3c663e8b$var$reHasRegExpChar = RegExp($a359664a3c663e8b$var$reRegExpChar.source);
/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */ function $a359664a3c663e8b$var$escapeRegExp(string) {
    string = $1uqnh(string);
    return string && $a359664a3c663e8b$var$reHasRegExpChar.test(string) ? string.replace($a359664a3c663e8b$var$reRegExpChar, '\\$&') : string;
}
module.exports = $a359664a3c663e8b$var$escapeRegExp;

});


parcelRegister("8vd0B", function(module, exports) {

$parcel$export(module.exports, "noChildren", () => $bdd25090ea4701e8$export$470bef71e654b804);
$parcel$export(module.exports, "assignParent", () => $bdd25090ea4701e8$export$a4685923af2913a);
const $bdd25090ea4701e8$export$470bef71e654b804 = ()=>[];
const $bdd25090ea4701e8$export$a4685923af2913a = (node)=>{
    node.getChildren().forEach((child)=>{
        child.parent = node;
    });
};

});


parcelRegister("6PZUx", function(module, exports) {

$parcel$export(module.exports, "compoundClause", () => $21944f207531c2fe$export$ab714e56a32c25f2);
$parcel$export(module.exports, "compoundClauseInternal", () => $21944f207531c2fe$export$cd65eed8c10b0911);


var $6Ijjg = parcelRequire("6Ijjg");

var $8vd0B = parcelRequire("8vd0B");
function $21944f207531c2fe$var$acceptCompoundClause(visitor) {
    return visitor.visitCompoundClause ? visitor.visitCompoundClause(this) : visitor.visitChildren(this);
}
function $21944f207531c2fe$var$enterNode(listener) {
    listener.enterCompoundClause && listener.enterCompoundClause(this);
}
function $21944f207531c2fe$var$exitNode(listener) {
    listener.exitCompoundClause && listener.exitCompoundClause(this);
}
function $21944f207531c2fe$var$getChildren() {
    return [
        this.operator,
        ...this.clauses
    ];
}
const $21944f207531c2fe$export$ab714e56a32c25f2 = (operator, clauses)=>{
    return $21944f207531c2fe$export$cd65eed8c10b0911(operator, clauses);
};
const $21944f207531c2fe$export$cd65eed8c10b0911 = (operator, clauses, position = null)=>{
    const node = {
        type: (0, $4dac9dd1966bb7dd$export$2d205682cc545947),
        clauseType: (0, $35634e4e5a46f5ae$export$7a58b23488ea076b),
        operator: operator,
        clauses: clauses,
        position: position,
        accept: $21944f207531c2fe$var$acceptCompoundClause,
        enterNode: $21944f207531c2fe$var$enterNode,
        exitNode: $21944f207531c2fe$var$exitNode,
        getChildren: $21944f207531c2fe$var$getChildren,
        parent: null,
        appendClause: $6Ijjg.appendClause,
        remove: $6Ijjg.remove,
        removeClause: $6Ijjg.removeClause,
        replace: $6Ijjg.replace,
        replaceClause: $6Ijjg.replaceClause
    };
    (0, $8vd0B.assignParent)(node);
    return node;
};

});
const $4dac9dd1966bb7dd$export$98dda21ec825792 = 'query';
const $4dac9dd1966bb7dd$export$2d205682cc545947 = 'clause';
const $4dac9dd1966bb7dd$export$d2f212d8ddbc8d1d = 'operand';
const $4dac9dd1966bb7dd$export$da0f73edded4a63d = 'order_by';

parcelRegister("6Ijjg", function(module, exports) {

$parcel$export(module.exports, "appendClause", () => appendClause);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "removeClause", () => removeClause);
$parcel$export(module.exports, "replace", () => replace);
$parcel$export(module.exports, "replaceClause", () => replaceClause);


var $8vd0B = parcelRequire("8vd0B");
function appendClause(clause) {
    let clausesToAppend = [
        clause
    ];
    // If the clause to append is compound with a matching operator then we flatten it into the current clause
    if (clause.clauseType === (0, $35634e4e5a46f5ae$export$7a58b23488ea076b) && clause.operator.value === this.operator.value) clausesToAppend = clause.clauses;
    this.clauses.push(...clausesToAppend);
    (0, $8vd0B.assignParent)(this);
}
function remove() {
    if (this.parent) this.parent.removeClause(this);
}
function removeClause(clause) {
    this.clauses = this.clauses.filter((val)=>val !== clause);
    if (this.clauses.length === 1) this.replace(this.clauses[0]);
    else if (this.clauses.length === 0) this.remove();
}
function replace(nextClause) {
    if (this.parent) this.parent.replaceClause(this, nextClause);
}
function replaceClause(clause, nextClause) {
    this.clauses = this.clauses.map((child)=>{
        return child === clause ? nextClause : child;
    });
    (0, $8vd0B.assignParent)(this);
}

});


parcelRegister("1tKLQ", function(module, exports) {

$parcel$export(module.exports, "compoundOperator", () => $41689cae7add497a$export$84bb3ebbba491aee);
$parcel$export(module.exports, "compoundOperatorInternal", () => $41689cae7add497a$export$63c33bc3fe74fee6);

var $8vd0B = parcelRequire("8vd0B");
function $41689cae7add497a$var$acceptCompoundOperator(visitor) {
    return visitor.visitCompoundOperator ? visitor.visitCompoundOperator(this) : visitor.visitChildren(this);
}
function $41689cae7add497a$var$enterNode(listener) {
    listener.enterCompoundOperator && listener.enterCompoundOperator(this);
}
function $41689cae7add497a$var$exitNode(listener) {
    listener.exitCompoundOperator && listener.exitCompoundOperator(this);
}
const $41689cae7add497a$export$84bb3ebbba491aee = (value)=>$41689cae7add497a$export$63c33bc3fe74fee6(value, []);
const $41689cae7add497a$export$63c33bc3fe74fee6 = (value, operatorPositions)=>({
        value: value,
        positions: operatorPositions,
        position: null,
        accept: $41689cae7add497a$var$acceptCompoundOperator,
        enterNode: $41689cae7add497a$var$enterNode,
        exitNode: $41689cae7add497a$var$exitNode,
        getChildren: (0, $8vd0B.noChildren),
        parent: null
    });

});

parcelRegister("1l80e", function(module, exports) {

$parcel$export(module.exports, "field", () => $ca7da08f64c6e9e4$export$e0f35d825088c098);
$parcel$export(module.exports, "fieldInternal", () => $ca7da08f64c6e9e4$export$2193f8c541622b6);

var $tI64Y = parcelRequire("tI64Y");

var $8vd0B = parcelRequire("8vd0B");
function $ca7da08f64c6e9e4$var$acceptField(visitor) {
    return visitor.visitField ? visitor.visitField(this) : visitor.visitChildren(this);
}
function $ca7da08f64c6e9e4$var$enterNode(listener) {
    listener.enterField && listener.enterField(this);
}
function $ca7da08f64c6e9e4$var$exitNode(listener) {
    listener.exitField && listener.exitField(this);
}
function $ca7da08f64c6e9e4$var$getChildren() {
    return this.properties ? [
        ...this.properties
    ] : [];
}
const $ca7da08f64c6e9e4$export$e0f35d825088c098 = (value, properties)=>{
    return $ca7da08f64c6e9e4$export$2193f8c541622b6(value, (0, $tI64Y.sanitiseJqlString)(value), properties);
};
const $ca7da08f64c6e9e4$export$2193f8c541622b6 = (value, text, properties, position = null)=>{
    const node = {
        text: text,
        value: value,
        properties: properties,
        position: position,
        accept: $ca7da08f64c6e9e4$var$acceptField,
        enterNode: $ca7da08f64c6e9e4$var$enterNode,
        exitNode: $ca7da08f64c6e9e4$var$exitNode,
        getChildren: $ca7da08f64c6e9e4$var$getChildren,
        parent: null
    };
    (0, $8vd0B.assignParent)(node);
    return node;
};

});

parcelRegister("2H3zB", function(module, exports) {

$parcel$export(module.exports, "functionOperand", () => $40b2ef8348f4cf32$export$4f981b0e83488ce);
$parcel$export(module.exports, "functionOperandInternal", () => $40b2ef8348f4cf32$export$c1f2ce91dc05872a);


var $8vd0B = parcelRequire("8vd0B");
function $40b2ef8348f4cf32$var$acceptFunctionOperand(visitor) {
    return visitor.visitFunctionOperand ? visitor.visitFunctionOperand(this) : visitor.visitChildren(this);
}
function $40b2ef8348f4cf32$var$enterNode(listener) {
    listener.enterFunctionOperand && listener.enterFunctionOperand(this);
}
function $40b2ef8348f4cf32$var$exitNode(listener) {
    listener.exitFunctionOperand && listener.exitFunctionOperand(this);
}
function $40b2ef8348f4cf32$var$getChildren() {
    return [
        this.function,
        ...this.arguments
    ];
}
const $40b2ef8348f4cf32$export$4f981b0e83488ce = (functionString, args = [])=>$40b2ef8348f4cf32$export$c1f2ce91dc05872a(functionString, args);
const $40b2ef8348f4cf32$export$c1f2ce91dc05872a = (functionString, args, position = null)=>{
    const node = {
        type: (0, $4dac9dd1966bb7dd$export$d2f212d8ddbc8d1d),
        operandType: (0, $807962b43ef03b56$export$19c7c729db381f9d),
        function: functionString,
        arguments: args,
        position: position,
        accept: $40b2ef8348f4cf32$var$acceptFunctionOperand,
        enterNode: $40b2ef8348f4cf32$var$enterNode,
        exitNode: $40b2ef8348f4cf32$var$exitNode,
        getChildren: $40b2ef8348f4cf32$var$getChildren,
        parent: null
    };
    (0, $8vd0B.assignParent)(node);
    return node;
};

});
const $807962b43ef03b56$export$38accfc5a5d1c113 = 'value';
const $807962b43ef03b56$export$f6049126fd97001f = 'keyword';
const $807962b43ef03b56$export$19c7c729db381f9d = 'function';
const $807962b43ef03b56$export$fabec4aebba3f4df = 'list';
const $807962b43ef03b56$export$1c46dca02aac24dd = 'empty';


parcelRegister("kDZbK", function(module, exports) {

$parcel$export(module.exports, "functionString", () => $4a79528e6e143f86$export$4e1bb9a7ff8d0ef9);
$parcel$export(module.exports, "functionStringInternal", () => $4a79528e6e143f86$export$7aa9944588b7a69f);

var $tI64Y = parcelRequire("tI64Y");

var $8vd0B = parcelRequire("8vd0B");
function $4a79528e6e143f86$var$acceptFunctionString(visitor) {
    return visitor.visitFunction ? visitor.visitFunction(this) : visitor.visitChildren(this);
}
function $4a79528e6e143f86$var$enterNode(listener) {
    listener.enterFunction && listener.enterFunction(this);
}
function $4a79528e6e143f86$var$exitNode(listener) {
    listener.exitFunction && listener.exitFunction(this);
}
const $4a79528e6e143f86$export$4e1bb9a7ff8d0ef9 = (value)=>$4a79528e6e143f86$export$7aa9944588b7a69f(value, (0, $tI64Y.sanitiseJqlString)(value));
const $4a79528e6e143f86$export$7aa9944588b7a69f = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $4a79528e6e143f86$var$acceptFunctionString,
        enterNode: $4a79528e6e143f86$var$enterNode,
        exitNode: $4a79528e6e143f86$var$exitNode,
        getChildren: (0, $8vd0B.noChildren),
        parent: null
    });

});

parcelRegister("dnbob", function(module, exports) {

$parcel$export(module.exports, "jast", () => $b5aa2ed089d54434$export$b9e70a00f479ff43);
const $b5aa2ed089d54434$export$b9e70a00f479ff43 = (query, represents = '', errors = [])=>({
        query: query,
        represents: represents,
        errors: errors
    });

});

parcelRegister("bfn5R", function(module, exports) {

$parcel$export(module.exports, "keywordOperand", () => $33ccff7643df2fc3$export$2edd4971ed69f2ce);
$parcel$export(module.exports, "keywordOperandInternal", () => $33ccff7643df2fc3$export$7cc55480b054047b);


var $8vd0B = parcelRequire("8vd0B");
function $33ccff7643df2fc3$var$acceptKeywordOperand(visitor) {
    return visitor.visitKeywordOperand ? visitor.visitKeywordOperand(this) : visitor.visitChildren(this);
}
function $33ccff7643df2fc3$var$enterNode(listener) {
    listener.enterKeywordOperand && listener.enterKeywordOperand(this);
}
function $33ccff7643df2fc3$var$exitNode(listener) {
    listener.exitKeywordOperand && listener.exitKeywordOperand(this);
}
const $33ccff7643df2fc3$export$2edd4971ed69f2ce = ()=>$33ccff7643df2fc3$export$7cc55480b054047b((0, $807962b43ef03b56$export$1c46dca02aac24dd));
const $33ccff7643df2fc3$export$7cc55480b054047b = (value, position = null)=>({
        type: (0, $4dac9dd1966bb7dd$export$d2f212d8ddbc8d1d),
        operandType: (0, $807962b43ef03b56$export$f6049126fd97001f),
        value: value,
        position: position,
        accept: $33ccff7643df2fc3$var$acceptKeywordOperand,
        enterNode: $33ccff7643df2fc3$var$enterNode,
        exitNode: $33ccff7643df2fc3$var$exitNode,
        getChildren: (0, $8vd0B.noChildren),
        parent: null
    });

});

parcelRegister("eD0Hy", function(module, exports) {

$parcel$export(module.exports, "listOperand", () => $c8986a6d4d679671$export$769866c3e9d41d50);
$parcel$export(module.exports, "listOperandInternal", () => $c8986a6d4d679671$export$663c7831528c984b);


var $7IFnF = parcelRequire("7IFnF");

var $8vd0B = parcelRequire("8vd0B");
function $c8986a6d4d679671$var$acceptListOperand(visitor) {
    return visitor.visitListOperand ? visitor.visitListOperand(this) : visitor.visitChildren(this);
}
function $c8986a6d4d679671$var$enterNode(listener) {
    listener.enterListOperand && listener.enterListOperand(this);
}
function $c8986a6d4d679671$var$exitNode(listener) {
    listener.exitListOperand && listener.exitListOperand(this);
}
function $c8986a6d4d679671$var$getChildren() {
    return [
        ...this.values
    ];
}
const $c8986a6d4d679671$export$769866c3e9d41d50 = (values)=>$c8986a6d4d679671$export$663c7831528c984b(values);
const $c8986a6d4d679671$export$663c7831528c984b = (values, position = null)=>{
    const node = {
        type: (0, $4dac9dd1966bb7dd$export$d2f212d8ddbc8d1d),
        operandType: (0, $807962b43ef03b56$export$fabec4aebba3f4df),
        values: values,
        position: position,
        accept: $c8986a6d4d679671$var$acceptListOperand,
        enterNode: $c8986a6d4d679671$var$enterNode,
        exitNode: $c8986a6d4d679671$var$exitNode,
        getChildren: $c8986a6d4d679671$var$getChildren,
        parent: null,
        appendOperand: $7IFnF.appendOperand
    };
    (0, $8vd0B.assignParent)(node);
    return node;
};

});
parcelRegister("7IFnF", function(module, exports) {

$parcel$export(module.exports, "appendOperand", () => $f8f36eb1e6c645ee$export$d94c54f1aee177c4);


var $8vd0B = parcelRequire("8vd0B");
function $f8f36eb1e6c645ee$export$d94c54f1aee177c4(operand) {
    this.values.push(...operand.operandType === (0, $807962b43ef03b56$export$fabec4aebba3f4df) ? operand.values : [
        operand
    ]);
    (0, $8vd0B.assignParent)(this);
}

});


parcelRegister("1uxra", function(module, exports) {

$parcel$export(module.exports, "notClause", () => $1553b96d0b936df5$export$b4734a9fedb4d44e);
$parcel$export(module.exports, "notClauseInternal", () => $1553b96d0b936df5$export$b25621824fea4548);


var $3nho4 = parcelRequire("3nho4");

var $8vd0B = parcelRequire("8vd0B");

var $5eoHT = parcelRequire("5eoHT");
function $1553b96d0b936df5$var$acceptNotClause(visitor) {
    return visitor.visitNotClause ? visitor.visitNotClause(this) : visitor.visitChildren(this);
}
function $1553b96d0b936df5$var$enterNode(listener) {
    listener.enterNotClause && listener.enterNotClause(this);
}
function $1553b96d0b936df5$var$exitNode(listener) {
    listener.exitNotClause && listener.exitNotClause(this);
}
function $1553b96d0b936df5$var$getChildren() {
    return [
        this.operator,
        this.clause
    ];
}
const $1553b96d0b936df5$export$b4734a9fedb4d44e = (clause)=>{
    return $1553b96d0b936df5$export$b25621824fea4548(clause, (0, $5eoHT.notClauseOperator)());
};
const $1553b96d0b936df5$export$b25621824fea4548 = (clause, operator, position = null)=>{
    const node = {
        type: (0, $4dac9dd1966bb7dd$export$2d205682cc545947),
        clauseType: (0, $35634e4e5a46f5ae$export$e356b89f8c8d2fcb),
        clause: clause,
        operator: operator,
        position: position,
        accept: $1553b96d0b936df5$var$acceptNotClause,
        enterNode: $1553b96d0b936df5$var$enterNode,
        exitNode: $1553b96d0b936df5$var$exitNode,
        getChildren: $1553b96d0b936df5$var$getChildren,
        parent: null,
        remove: $3nho4.remove,
        removeClause: $3nho4.removeClause,
        replace: $3nho4.replace,
        replaceClause: $3nho4.replaceClause
    };
    (0, $8vd0B.assignParent)(node);
    return node;
};

});
parcelRegister("3nho4", function(module, exports) {

$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "removeClause", () => removeClause);
$parcel$export(module.exports, "replace", () => replace);
$parcel$export(module.exports, "replaceClause", () => replaceClause);

var $8vd0B = parcelRequire("8vd0B");
function remove() {
    if (this.parent) this.parent.removeClause(this);
}
function removeClause(clause) {
    if (this.clause === clause) this.remove();
}
function replace(nextClause) {
    if (this.parent) this.parent.replaceClause(this, nextClause);
}
function replaceClause(clause, nextClause) {
    if (this.clause === clause) {
        this.clause = nextClause;
        (0, $8vd0B.assignParent)(this);
    }
}

});

parcelRegister("5eoHT", function(module, exports) {

$parcel$export(module.exports, "notClauseOperator", () => $f538dc12d855c47e$export$d2cd8239f99c13d3);
$parcel$export(module.exports, "notClauseOperatorInternal", () => $f538dc12d855c47e$export$1b15a32bb57b9020);

var $k85ht = parcelRequire("k85ht");

var $8vd0B = parcelRequire("8vd0B");
function $f538dc12d855c47e$var$acceptNotClauseOperator(visitor) {
    return visitor.visitNotClauseOperator ? visitor.visitNotClauseOperator(this) : visitor.visitChildren(this);
}
function $f538dc12d855c47e$var$enterNode(listener) {
    listener.enterNotClauseOperator && listener.enterNotClauseOperator(this);
}
function $f538dc12d855c47e$var$exitNode(listener) {
    listener.exitNotClauseOperator && listener.exitNotClauseOperator(this);
}
const $f538dc12d855c47e$export$d2cd8239f99c13d3 = ()=>$f538dc12d855c47e$export$1b15a32bb57b9020();
const $f538dc12d855c47e$export$1b15a32bb57b9020 = (position = null)=>({
        value: (0, $k85ht.CLAUSE_OPERATOR_NOT),
        position: position,
        accept: $f538dc12d855c47e$var$acceptNotClauseOperator,
        enterNode: $f538dc12d855c47e$var$enterNode,
        exitNode: $f538dc12d855c47e$var$exitNode,
        getChildren: (0, $8vd0B.noChildren),
        parent: null
    });

});
parcelRegister("k85ht", function(module, exports) {

$parcel$export(module.exports, "CLAUSE_OPERATOR_NOT", () => $e007b5b5543cc378$export$c6c71ceedb15cda9);
$parcel$export(module.exports, "OPERATOR_EQUALS", () => $e007b5b5543cc378$export$466517a888d00195);
$parcel$export(module.exports, "OPERATOR_NOT_EQUALS", () => $e007b5b5543cc378$export$6d0d8810623974a5);
$parcel$export(module.exports, "OPERATOR_GT", () => $e007b5b5543cc378$export$bcbb090ab3c498b3);
$parcel$export(module.exports, "OPERATOR_LT", () => $e007b5b5543cc378$export$4bf1a4aa659c6ea4);
$parcel$export(module.exports, "OPERATOR_GT_EQUALS", () => $e007b5b5543cc378$export$83ce674214a54b2a);
$parcel$export(module.exports, "OPERATOR_LT_EQUALS", () => $e007b5b5543cc378$export$9629fd1727ef62ee);
$parcel$export(module.exports, "OPERATOR_IN", () => $e007b5b5543cc378$export$c4e3fb55e320e979);
$parcel$export(module.exports, "OPERATOR_NOT_IN", () => $e007b5b5543cc378$export$f9857532eaa24ddc);
$parcel$export(module.exports, "OPERATOR_LIKE", () => $e007b5b5543cc378$export$221595834b8766ab);
$parcel$export(module.exports, "OPERATOR_NOT_LIKE", () => $e007b5b5543cc378$export$fcefabf94a9bffbf);
$parcel$export(module.exports, "OPERATOR_IS", () => $e007b5b5543cc378$export$4feeb3f4ff56bcef);
$parcel$export(module.exports, "OPERATOR_IS_NOT", () => $e007b5b5543cc378$export$d08d969a0da27188);
$parcel$export(module.exports, "OPERATOR_WAS", () => $e007b5b5543cc378$export$8f907e179985256d);
$parcel$export(module.exports, "OPERATOR_WAS_IN", () => $e007b5b5543cc378$export$cc7b9d0b3ee23193);
$parcel$export(module.exports, "OPERATOR_WAS_NOT_IN", () => $e007b5b5543cc378$export$585d3c004af078bb);
$parcel$export(module.exports, "OPERATOR_WAS_NOT", () => $e007b5b5543cc378$export$123eaa9ccc2d9445);
$parcel$export(module.exports, "OPERATOR_CHANGED", () => $e007b5b5543cc378$export$15f5b446ba8c941e);
$parcel$export(module.exports, "EQUALS_OPERATORS", () => $e007b5b5543cc378$export$643c6101f3fc8547);
$parcel$export(module.exports, "LIKE_OPERATORS", () => $e007b5b5543cc378$export$329664c9cf18cca6);
$parcel$export(module.exports, "COMPARISON_OPERATORS", () => $e007b5b5543cc378$export$1b167a3705885a8b);
$parcel$export(module.exports, "IN_OPERATORS", () => $e007b5b5543cc378$export$f25cf16c2270312f);
$parcel$export(module.exports, "IS_OPERATORS", () => $e007b5b5543cc378$export$eb58cfffe4a6b805);
$parcel$export(module.exports, "WAS_OPERATORS", () => $e007b5b5543cc378$export$c22a981f581de218);
$parcel$export(module.exports, "WAS_IN_OPERATORS", () => $e007b5b5543cc378$export$6d08c4699bb75284);
$parcel$export(module.exports, "CHANGED_OPERATORS", () => $e007b5b5543cc378$export$b7dc214eef214c1c);
$parcel$export(module.exports, "OPERATORS", () => $e007b5b5543cc378$export$184799fc79ccac89);
$parcel$export(module.exports, "LIST_OPERATORS", () => $e007b5b5543cc378$export$77c793736847e030);
const $e007b5b5543cc378$export$c6c71ceedb15cda9 = 'not';
const $e007b5b5543cc378$export$466517a888d00195 = '=';
const $e007b5b5543cc378$export$6d0d8810623974a5 = '!=';
const $e007b5b5543cc378$export$bcbb090ab3c498b3 = '>';
const $e007b5b5543cc378$export$4bf1a4aa659c6ea4 = '<';
const $e007b5b5543cc378$export$83ce674214a54b2a = '>=';
const $e007b5b5543cc378$export$9629fd1727ef62ee = '<=';
const $e007b5b5543cc378$export$c4e3fb55e320e979 = 'in';
const $e007b5b5543cc378$export$f9857532eaa24ddc = 'not in';
const $e007b5b5543cc378$export$221595834b8766ab = '~';
const $e007b5b5543cc378$export$fcefabf94a9bffbf = '!~';
const $e007b5b5543cc378$export$4feeb3f4ff56bcef = 'is';
const $e007b5b5543cc378$export$d08d969a0da27188 = 'is not';
const $e007b5b5543cc378$export$8f907e179985256d = 'was';
const $e007b5b5543cc378$export$cc7b9d0b3ee23193 = 'was in';
const $e007b5b5543cc378$export$585d3c004af078bb = 'was not in';
const $e007b5b5543cc378$export$123eaa9ccc2d9445 = 'was not';
const $e007b5b5543cc378$export$15f5b446ba8c941e = 'changed';
const $e007b5b5543cc378$export$643c6101f3fc8547 = [
    $e007b5b5543cc378$export$466517a888d00195,
    $e007b5b5543cc378$export$6d0d8810623974a5
];
const $e007b5b5543cc378$export$329664c9cf18cca6 = [
    $e007b5b5543cc378$export$221595834b8766ab,
    $e007b5b5543cc378$export$fcefabf94a9bffbf
];
const $e007b5b5543cc378$export$1b167a3705885a8b = [
    $e007b5b5543cc378$export$4bf1a4aa659c6ea4,
    $e007b5b5543cc378$export$bcbb090ab3c498b3,
    $e007b5b5543cc378$export$9629fd1727ef62ee,
    $e007b5b5543cc378$export$83ce674214a54b2a
];
const $e007b5b5543cc378$export$f25cf16c2270312f = [
    $e007b5b5543cc378$export$c4e3fb55e320e979,
    $e007b5b5543cc378$export$f9857532eaa24ddc
];
const $e007b5b5543cc378$export$eb58cfffe4a6b805 = [
    $e007b5b5543cc378$export$4feeb3f4ff56bcef,
    $e007b5b5543cc378$export$d08d969a0da27188
];
const $e007b5b5543cc378$export$c22a981f581de218 = [
    $e007b5b5543cc378$export$8f907e179985256d,
    $e007b5b5543cc378$export$123eaa9ccc2d9445
];
const $e007b5b5543cc378$export$6d08c4699bb75284 = [
    $e007b5b5543cc378$export$cc7b9d0b3ee23193,
    $e007b5b5543cc378$export$585d3c004af078bb
];
const $e007b5b5543cc378$export$b7dc214eef214c1c = [
    $e007b5b5543cc378$export$15f5b446ba8c941e
];
const $e007b5b5543cc378$export$184799fc79ccac89 = [
    ...$e007b5b5543cc378$export$643c6101f3fc8547,
    ...$e007b5b5543cc378$export$329664c9cf18cca6,
    ...$e007b5b5543cc378$export$1b167a3705885a8b,
    ...$e007b5b5543cc378$export$f25cf16c2270312f,
    ...$e007b5b5543cc378$export$eb58cfffe4a6b805,
    ...$e007b5b5543cc378$export$c22a981f581de218,
    ...$e007b5b5543cc378$export$6d08c4699bb75284,
    ...$e007b5b5543cc378$export$b7dc214eef214c1c
];
const $e007b5b5543cc378$export$77c793736847e030 = [
    $e007b5b5543cc378$export$c4e3fb55e320e979,
    $e007b5b5543cc378$export$f9857532eaa24ddc,
    $e007b5b5543cc378$export$cc7b9d0b3ee23193,
    $e007b5b5543cc378$export$585d3c004af078bb
];

});



parcelRegister("3T5iU", function(module, exports) {

$parcel$export(module.exports, "operator", () => $7c07e8aa040a847b$export$dbd72860f701d4f3);
$parcel$export(module.exports, "operatorInternal", () => $7c07e8aa040a847b$export$649025bc60ab9c3b);

var $8vd0B = parcelRequire("8vd0B");
function $7c07e8aa040a847b$var$acceptOperator(visitor) {
    return visitor.visitOperator ? visitor.visitOperator(this) : visitor.visitChildren(this);
}
function $7c07e8aa040a847b$var$enterNode(listener) {
    listener.enterOperator && listener.enterOperator(this);
}
function $7c07e8aa040a847b$var$exitNode(listener) {
    listener.exitOperator && listener.exitOperator(this);
}
const $7c07e8aa040a847b$export$dbd72860f701d4f3 = (value)=>$7c07e8aa040a847b$export$649025bc60ab9c3b(value, value);
const $7c07e8aa040a847b$export$649025bc60ab9c3b = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $7c07e8aa040a847b$var$acceptOperator,
        enterNode: $7c07e8aa040a847b$var$enterNode,
        exitNode: $7c07e8aa040a847b$var$exitNode,
        getChildren: (0, $8vd0B.noChildren),
        parent: null
    });

});

parcelRegister("8Tr0t", function(module, exports) {

$parcel$export(module.exports, "orderBy", () => $c827a275c8f59b6f$export$f18af21d6f4dafd8);
$parcel$export(module.exports, "orderByInternal", () => $c827a275c8f59b6f$export$e4eb1fa6bc8465c1);


var $1lC8l = parcelRequire("1lC8l");

var $8vd0B = parcelRequire("8vd0B");

var $i2yZF = parcelRequire("i2yZF");
function $c827a275c8f59b6f$var$acceptOrderBy(visitor) {
    return visitor.visitOrderBy ? visitor.visitOrderBy(this) : visitor.visitChildren(this);
}
function $c827a275c8f59b6f$var$enterNode(listener) {
    listener.enterOrderBy && listener.enterOrderBy(this);
}
function $c827a275c8f59b6f$var$exitNode(listener) {
    listener.exitOrderBy && listener.exitOrderBy(this);
}
function $c827a275c8f59b6f$var$getChildren() {
    return [
        this.operator,
        ...this.fields
    ];
}
const $c827a275c8f59b6f$export$f18af21d6f4dafd8 = (fields)=>{
    return $c827a275c8f59b6f$export$e4eb1fa6bc8465c1(fields, (0, $i2yZF.orderByOperator)());
};
const $c827a275c8f59b6f$export$e4eb1fa6bc8465c1 = (fields, operator, position = null)=>{
    const node = {
        type: (0, $4dac9dd1966bb7dd$export$da0f73edded4a63d),
        operator: operator,
        fields: fields,
        position: position,
        accept: $c827a275c8f59b6f$var$acceptOrderBy,
        enterNode: $c827a275c8f59b6f$var$enterNode,
        exitNode: $c827a275c8f59b6f$var$exitNode,
        getChildren: $c827a275c8f59b6f$var$getChildren,
        parent: null,
        prependOrderField: $1lC8l.prependOrderField,
        setOrderDirection: $1lC8l.setOrderDirection,
        replace: $1lC8l.replace,
        replaceOrderField: $1lC8l.replaceOrderField,
        remove: $1lC8l.remove,
        removeOrderField: $1lC8l.removeOrderField
    };
    (0, $8vd0B.assignParent)(node);
    return node;
};

});
parcelRegister("1lC8l", function(module, exports) {

$parcel$export(module.exports, "prependOrderField", () => prependOrderField);
$parcel$export(module.exports, "setOrderDirection", () => setOrderDirection);
$parcel$export(module.exports, "replace", () => replace);
$parcel$export(module.exports, "replaceOrderField", () => replaceOrderField);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "removeOrderField", () => removeOrderField);

var $8vd0B = parcelRequire("8vd0B");
function prependOrderField(orderField) {
    this.fields.unshift(orderField);
    (0, $8vd0B.assignParent)(this);
}
function setOrderDirection(orderDirection) {
    if (this.fields.length > 0) this.fields[0].setOrderDirection(orderDirection);
}
function replace(nextOrderBy) {
    if (this.parent) this.parent.replaceOrderBy(nextOrderBy);
}
function replaceOrderField(orderByField, nextOrderByField) {
    this.fields = this.fields.map((child)=>{
        return child === orderByField ? nextOrderByField : child;
    });
    (0, $8vd0B.assignParent)(this);
}
function remove() {
    if (this.parent) this.parent.removeOrderBy();
}
function removeOrderField(orderByField) {
    this.fields = this.fields.filter((field)=>field !== orderByField);
    if (this.fields.length === 0) this.remove();
}

});

parcelRegister("i2yZF", function(module, exports) {

$parcel$export(module.exports, "orderByOperator", () => $fa7d19490b4ecf54$export$c7307b67924c61ea);
$parcel$export(module.exports, "orderByOperatorInternal", () => $fa7d19490b4ecf54$export$739e30af23a08da0);


var $8vd0B = parcelRequire("8vd0B");
function $fa7d19490b4ecf54$var$acceptOrderByOperator(visitor) {
    return visitor.visitOrderByOperator ? visitor.visitOrderByOperator(this) : visitor.visitChildren(this);
}
function $fa7d19490b4ecf54$var$enterNode(listener) {
    listener.enterOrderByOperator && listener.enterOrderByOperator(this);
}
function $fa7d19490b4ecf54$var$exitNode(listener) {
    listener.exitOrderByOperator && listener.exitOrderByOperator(this);
}
const $fa7d19490b4ecf54$export$c7307b67924c61ea = ()=>$fa7d19490b4ecf54$export$739e30af23a08da0();
const $fa7d19490b4ecf54$export$739e30af23a08da0 = (position = null)=>({
        value: (0, $e28fa7cc527af49f$export$ca51f5fd60a74517),
        position: position,
        accept: $fa7d19490b4ecf54$var$acceptOrderByOperator,
        enterNode: $fa7d19490b4ecf54$var$enterNode,
        exitNode: $fa7d19490b4ecf54$var$exitNode,
        getChildren: (0, $8vd0B.noChildren),
        parent: null
    });

});
const $e28fa7cc527af49f$export$ca51f5fd60a74517 = 'ORDER BY';
const $e28fa7cc527af49f$export$6d60017b9e092e73 = 'ASC';
const $e28fa7cc527af49f$export$2ea27ea5f2121899 = 'DESC';



parcelRegister("1R1xk", function(module, exports) {

$parcel$export(module.exports, "orderByDirection", () => $21aa5b2783962a5d$export$864d934efed3ccaa);
$parcel$export(module.exports, "orderByDirectionInternal", () => $21aa5b2783962a5d$export$8c65cac1a7852d1f);

var $8vd0B = parcelRequire("8vd0B");
function $21aa5b2783962a5d$var$acceptOrderByDirection(visitor) {
    return visitor.visitOrderByDirection ? visitor.visitOrderByDirection(this) : visitor.visitChildren(this);
}
function $21aa5b2783962a5d$var$enterNode(listener) {
    listener.enterOrderByDirection && listener.enterOrderByDirection(this);
}
function $21aa5b2783962a5d$var$exitNode(listener) {
    listener.exitOrderByDirection && listener.exitOrderByDirection(this);
}
const $21aa5b2783962a5d$export$864d934efed3ccaa = (value)=>$21aa5b2783962a5d$export$8c65cac1a7852d1f(value);
const $21aa5b2783962a5d$export$8c65cac1a7852d1f = (value, position = null)=>({
        value: value,
        position: position,
        accept: $21aa5b2783962a5d$var$acceptOrderByDirection,
        enterNode: $21aa5b2783962a5d$var$enterNode,
        exitNode: $21aa5b2783962a5d$var$exitNode,
        getChildren: (0, $8vd0B.noChildren),
        parent: null
    });

});

parcelRegister("eHzms", function(module, exports) {

$parcel$export(module.exports, "orderByField", () => $d06d39ae8044bfe9$export$942df63e5e3d3899);
$parcel$export(module.exports, "orderByFieldInternal", () => $d06d39ae8044bfe9$export$661a7786e3d15926);

var $7dx7z = parcelRequire("7dx7z");

var $8vd0B = parcelRequire("8vd0B");
function $d06d39ae8044bfe9$var$acceptOrderByField(visitor) {
    return visitor.visitOrderByField ? visitor.visitOrderByField(this) : visitor.visitChildren(this);
}
function $d06d39ae8044bfe9$var$enterNode(listener) {
    listener.enterOrderByField && listener.enterOrderByField(this);
}
function $d06d39ae8044bfe9$var$exitNode(listener) {
    listener.exitOrderByField && listener.exitOrderByField(this);
}
function $d06d39ae8044bfe9$var$getChildren() {
    const children = [
        this.field
    ];
    if (this.direction) children.push(this.direction);
    return children;
}
const $d06d39ae8044bfe9$export$942df63e5e3d3899 = (field, direction)=>$d06d39ae8044bfe9$export$661a7786e3d15926(field, direction);
const $d06d39ae8044bfe9$export$661a7786e3d15926 = (field, direction, position = null)=>{
    const node = {
        field: field,
        direction: direction,
        position: position,
        accept: $d06d39ae8044bfe9$var$acceptOrderByField,
        enterNode: $d06d39ae8044bfe9$var$enterNode,
        exitNode: $d06d39ae8044bfe9$var$exitNode,
        getChildren: $d06d39ae8044bfe9$var$getChildren,
        parent: null,
        setOrderDirection: $7dx7z.setOrderDirection,
        replace: $7dx7z.replace,
        remove: $7dx7z.remove
    };
    (0, $8vd0B.assignParent)(node);
    return node;
};

});
parcelRegister("7dx7z", function(module, exports) {

$parcel$export(module.exports, "setOrderDirection", () => $6807a3abf64eb81e$export$b596730931a09703);
$parcel$export(module.exports, "replace", () => $6807a3abf64eb81e$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "remove", () => $6807a3abf64eb81e$export$cd7f480d6b8286c3);

var $8vd0B = parcelRequire("8vd0B");
function $6807a3abf64eb81e$export$b596730931a09703(orderDirection) {
    this.direction = orderDirection;
    (0, $8vd0B.assignParent)(this);
}
function $6807a3abf64eb81e$export$77ad94ebf1c2b9ed(orderByField) {
    if (this.parent) this.parent.replaceOrderField(this, orderByField);
}
function $6807a3abf64eb81e$export$cd7f480d6b8286c3() {
    if (this.parent) this.parent.removeOrderField(this);
}

});


parcelRegister("3fSGD", function(module, exports) {

$parcel$export(module.exports, "predicate", () => $462e396b7fd5655b$export$5fc51e445ce24faf);
$parcel$export(module.exports, "predicateInternal", () => $462e396b7fd5655b$export$a767a27ad05a38a2);

var $8vd0B = parcelRequire("8vd0B");
function $462e396b7fd5655b$var$acceptPredicate(visitor) {
    return visitor.visitPredicate ? visitor.visitPredicate(this) : visitor.visitChildren(this);
}
function $462e396b7fd5655b$var$enterNode(listener) {
    listener.enterPredicate && listener.enterPredicate(this);
}
function $462e396b7fd5655b$var$exitNode(listener) {
    listener.exitPredicate && listener.exitPredicate(this);
}
function $462e396b7fd5655b$var$getChildren() {
    const children = [
        this.operator
    ];
    if (this.operand) children.push(this.operand);
    return children;
}
const $462e396b7fd5655b$export$5fc51e445ce24faf = (operator, operand)=>$462e396b7fd5655b$export$a767a27ad05a38a2(operator, operand);
const $462e396b7fd5655b$export$a767a27ad05a38a2 = (operator, operand, position = null)=>{
    const node = {
        operator: operator,
        operand: operand,
        position: position,
        accept: $462e396b7fd5655b$var$acceptPredicate,
        enterNode: $462e396b7fd5655b$var$enterNode,
        exitNode: $462e396b7fd5655b$var$exitNode,
        getChildren: $462e396b7fd5655b$var$getChildren,
        parent: null
    };
    (0, $8vd0B.assignParent)(node);
    return node;
};

});

parcelRegister("jvsC0", function(module, exports) {

$parcel$export(module.exports, "predicateOperator", () => $887e537fbec545f7$export$5419b7f16910ea62);
$parcel$export(module.exports, "predicateOperatorInternal", () => $887e537fbec545f7$export$c69d893689716768);

var $8vd0B = parcelRequire("8vd0B");
function $887e537fbec545f7$var$acceptPredicateOperator(visitor) {
    return visitor.visitPredicateOperator ? visitor.visitPredicateOperator(this) : visitor.visitChildren(this);
}
function $887e537fbec545f7$var$enterNode(listener) {
    listener.enterPredicateOperator && listener.enterPredicateOperator(this);
}
function $887e537fbec545f7$var$exitNode(listener) {
    listener.exitPredicateOperator && listener.exitPredicateOperator(this);
}
const $887e537fbec545f7$export$5419b7f16910ea62 = (value)=>$887e537fbec545f7$export$c69d893689716768(value, value);
const $887e537fbec545f7$export$c69d893689716768 = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $887e537fbec545f7$var$acceptPredicateOperator,
        enterNode: $887e537fbec545f7$var$enterNode,
        exitNode: $887e537fbec545f7$var$exitNode,
        getChildren: (0, $8vd0B.noChildren),
        parent: null
    });

});

parcelRegister("bdP2p", function(module, exports) {

$parcel$export(module.exports, "property", () => $f08fc38c9f10e3ce$export$d541bacb2bda4494);
$parcel$export(module.exports, "propertyInternal", () => $f08fc38c9f10e3ce$export$1cbd90994fef1fad);

var $8vd0B = parcelRequire("8vd0B");
function $f08fc38c9f10e3ce$var$acceptProperty(visitor) {
    return visitor.visitProperty ? visitor.visitProperty(this) : visitor.visitChildren(this);
}
function $f08fc38c9f10e3ce$var$enterNode(listener) {
    listener.enterProperty && listener.enterProperty(this);
}
function $f08fc38c9f10e3ce$var$exitNode(listener) {
    listener.exitProperty && listener.exitProperty(this);
}
function $f08fc38c9f10e3ce$var$getChildren() {
    const children = [];
    if (this.key) children.push(this.key);
    if (this.path) return children.concat(this.path);
    return children;
}
const $f08fc38c9f10e3ce$export$d541bacb2bda4494 = (key, path = [])=>$f08fc38c9f10e3ce$export$1cbd90994fef1fad(key, path);
const $f08fc38c9f10e3ce$export$1cbd90994fef1fad = (key, path, position = null)=>{
    const node = {
        key: key,
        path: path,
        position: position,
        accept: $f08fc38c9f10e3ce$var$acceptProperty,
        enterNode: $f08fc38c9f10e3ce$var$enterNode,
        exitNode: $f08fc38c9f10e3ce$var$exitNode,
        getChildren: $f08fc38c9f10e3ce$var$getChildren,
        parent: null
    };
    (0, $8vd0B.assignParent)(node);
    return node;
};

});

parcelRegister("1Rz9E", function(module, exports) {

$parcel$export(module.exports, "query", () => $107f0c7ef22c6060$export$2fa187e846a241c4);
$parcel$export(module.exports, "queryInternal", () => $107f0c7ef22c6060$export$bc2d6e2e1fd9014);


var $kqYul = parcelRequire("kqYul");

var $8vd0B = parcelRequire("8vd0B");
/**
 * AstNode accept functions. We define them outside of the creator function so the same function reference is returned
 * when a creator is invoked multiple times (which is helpful when testing for equality of AST objects).
 */ function $107f0c7ef22c6060$var$acceptQuery(visitor) {
    return visitor.visitQuery ? visitor.visitQuery(this) : visitor.visitChildren(this);
}
function $107f0c7ef22c6060$var$enterNode(listener) {
    listener.enterQuery && listener.enterQuery(this);
}
function $107f0c7ef22c6060$var$exitNode(listener) {
    listener.exitQuery && listener.exitQuery(this);
}
function $107f0c7ef22c6060$var$getChildren() {
    const children = [];
    if (this.where) children.push(this.where);
    if (this.orderBy) children.push(this.orderBy);
    return children;
}
const $107f0c7ef22c6060$export$2fa187e846a241c4 = (where, orderBy)=>$107f0c7ef22c6060$export$bc2d6e2e1fd9014(where, orderBy);
const $107f0c7ef22c6060$export$bc2d6e2e1fd9014 = (where, orderBy, position = null)=>{
    const node = {
        type: (0, $4dac9dd1966bb7dd$export$98dda21ec825792),
        where: where,
        orderBy: orderBy,
        position: position,
        accept: $107f0c7ef22c6060$var$acceptQuery,
        enterNode: $107f0c7ef22c6060$var$enterNode,
        exitNode: $107f0c7ef22c6060$var$exitNode,
        getChildren: $107f0c7ef22c6060$var$getChildren,
        parent: null,
        appendClause: $kqYul.appendClause,
        prependOrderField: $kqYul.prependOrderField,
        setOrderDirection: $kqYul.setOrderDirection,
        removeClause: $kqYul.removeClause,
        replaceClause: $kqYul.replaceClause,
        replaceOrderBy: $kqYul.replaceOrderBy,
        removeOrderBy: $kqYul.removeOrderBy
    };
    (0, $8vd0B.assignParent)(node);
    return node;
};

});
parcelRegister("kqYul", function(module, exports) {

$parcel$export(module.exports, "appendClause", () => appendClause);
$parcel$export(module.exports, "prependOrderField", () => prependOrderField);
$parcel$export(module.exports, "setOrderDirection", () => setOrderDirection);
$parcel$export(module.exports, "removeClause", () => removeClause);
$parcel$export(module.exports, "replaceOrderBy", () => replaceOrderBy);
$parcel$export(module.exports, "replaceClause", () => replaceClause);
$parcel$export(module.exports, "removeOrderBy", () => removeOrderBy);

var $ehDeP = parcelRequire("ehDeP");

var $8vd0B = parcelRequire("8vd0B");
function appendClause(clause, compoundOperatorValue) {
    if (!this.where) this.where = clause;
    else {
        const nextCompoundOperator = (0, $ehDeP.default).compoundOperator(compoundOperatorValue);
        const nextClause = (0, $ehDeP.default).compoundClause(nextCompoundOperator, []);
        // Append previous and new clause which will flatten compound clauses with matching operators.
        nextClause.appendClause(this.where);
        nextClause.appendClause(clause);
        this.where = nextClause;
    }
    (0, $8vd0B.assignParent)(this);
}
function prependOrderField(orderField) {
    if (!this.orderBy) {
        this.orderBy = (0, $ehDeP.default).orderBy([
            orderField
        ]);
        (0, $8vd0B.assignParent)(this);
    } else this.orderBy.prependOrderField(orderField);
}
function setOrderDirection(orderDirection) {
    if (this.orderBy) this.orderBy.setOrderDirection(orderDirection);
}
function removeClause(clause) {
    if (this.where === clause) this.where = undefined;
}
function replaceOrderBy(orderBy) {
    if (orderBy && orderBy.fields.length === 0) this.removeOrderBy();
    else {
        this.orderBy = orderBy;
        (0, $8vd0B.assignParent)(this);
    }
}
function replaceClause(clause, nextClause) {
    if (this.where === clause) {
        this.where = nextClause;
        (0, $8vd0B.assignParent)(this);
    }
}
function removeOrderBy() {
    this.orderBy = undefined;
}

});


parcelRegister("5o1cq", function(module, exports) {

$parcel$export(module.exports, "terminalClause", () => $ca791fbc90fc759d$export$2627cbe08dd86b00);
$parcel$export(module.exports, "terminalClauseInternal", () => $ca791fbc90fc759d$export$cc08e43598d091fc);


var $iKO2u = parcelRequire("iKO2u");

var $8vd0B = parcelRequire("8vd0B");
function $ca791fbc90fc759d$var$acceptTerminalClause(visitor) {
    return visitor.visitTerminalClause ? visitor.visitTerminalClause(this) : visitor.visitChildren(this);
}
function $ca791fbc90fc759d$var$enterNode(listener) {
    listener.enterTerminalClause && listener.enterTerminalClause(this);
}
function $ca791fbc90fc759d$var$exitNode(listener) {
    listener.exitTerminalClause && listener.exitTerminalClause(this);
}
function $ca791fbc90fc759d$var$getChildren() {
    const children = [
        this.field
    ];
    if (this.operator) children.push(this.operator);
    if (this.operand) children.push(this.operand);
    return children.concat(this.predicates);
}
const $ca791fbc90fc759d$export$2627cbe08dd86b00 = (field, operator, operand, predicates = [])=>{
    return $ca791fbc90fc759d$export$cc08e43598d091fc(field, operator, operand, predicates);
};
const $ca791fbc90fc759d$export$cc08e43598d091fc = (field, operator, operand, predicates, position = null)=>{
    const node = {
        type: (0, $4dac9dd1966bb7dd$export$2d205682cc545947),
        clauseType: (0, $35634e4e5a46f5ae$export$ae56b4ef248a2b6a),
        field: field,
        operator: operator,
        operand: operand,
        predicates: predicates,
        position: position,
        accept: $ca791fbc90fc759d$var$acceptTerminalClause,
        enterNode: $ca791fbc90fc759d$var$enterNode,
        exitNode: $ca791fbc90fc759d$var$exitNode,
        getChildren: $ca791fbc90fc759d$var$getChildren,
        parent: null,
        setOperator: $iKO2u.setOperator,
        setOperand: $iKO2u.setOperand,
        appendOperand: $iKO2u.appendOperand,
        remove: $iKO2u.remove,
        replace: $iKO2u.replace
    };
    (0, $8vd0B.assignParent)(node);
    return node;
};

});
parcelRegister("iKO2u", function(module, exports) {

$parcel$export(module.exports, "setOperator", () => setOperator);
$parcel$export(module.exports, "setOperand", () => setOperand);
$parcel$export(module.exports, "appendOperand", () => appendOperand);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "replace", () => replace);


var $ehDeP = parcelRequire("ehDeP");

var $8vd0B = parcelRequire("8vd0B");
function setOperator(operator) {
    this.operator = operator;
    (0, $8vd0B.assignParent)(this);
}
function setOperand(operand) {
    this.operand = operand;
    (0, $8vd0B.assignParent)(this);
}
function appendOperand(operand) {
    if (this.operand) {
        if (this.operand.operandType === (0, $807962b43ef03b56$export$fabec4aebba3f4df)) this.operand.appendOperand(operand);
        else this.setOperand((0, $ehDeP.default).listOperand([
            this.operand,
            ...operand.operandType === (0, $807962b43ef03b56$export$fabec4aebba3f4df) ? operand.values : [
                operand
            ]
        ]));
    } else this.setOperand(operand);
}
function remove() {
    if (this.parent) this.parent.removeClause(this);
}
function replace(nextClause) {
    if (this.parent) this.parent.replaceClause(this, nextClause);
}

});


parcelRegister("4VxAa", function(module, exports) {

$parcel$export(module.exports, "valueOperand", () => $097471b9dc7f0edf$export$2b6e4d2ed8d53bf3);
$parcel$export(module.exports, "valueOperandInternal", () => $097471b9dc7f0edf$export$79c37d97caac8627);
$parcel$export(module.exports, "valueOperandByText", () => $097471b9dc7f0edf$export$3ac9155bde56a45f);


var $g2nfy = parcelRequire("g2nfy");
var $tI64Y = parcelRequire("tI64Y");

var $8vd0B = parcelRequire("8vd0B");
function $097471b9dc7f0edf$var$acceptValueOperand(visitor) {
    return visitor.visitValueOperand ? visitor.visitValueOperand(this) : visitor.visitChildren(this);
}
function $097471b9dc7f0edf$var$enterNode(listener) {
    listener.enterValueOperand && listener.enterValueOperand(this);
}
function $097471b9dc7f0edf$var$exitNode(listener) {
    listener.exitValueOperand && listener.exitValueOperand(this);
}
const $097471b9dc7f0edf$export$2b6e4d2ed8d53bf3 = (value)=>$097471b9dc7f0edf$export$79c37d97caac8627(value, (0, $tI64Y.sanitiseJqlString)(value));
const $097471b9dc7f0edf$export$3ac9155bde56a45f = (text)=>$097471b9dc7f0edf$export$79c37d97caac8627((0, $g2nfy.normaliseJqlString)(text), text);
const $097471b9dc7f0edf$export$79c37d97caac8627 = (value, text, position = null)=>({
        type: (0, $4dac9dd1966bb7dd$export$d2f212d8ddbc8d1d),
        operandType: (0, $807962b43ef03b56$export$38accfc5a5d1c113),
        text: text,
        value: value,
        position: position,
        accept: $097471b9dc7f0edf$var$acceptValueOperand,
        enterNode: $097471b9dc7f0edf$var$enterNode,
        exitNode: $097471b9dc7f0edf$var$exitNode,
        getChildren: (0, $8vd0B.noChildren),
        parent: null
    });

});


parcelRegister("9I5Iz", function(module, exports) {

$parcel$export(module.exports, "JastBuilderErrorListener", () => $147ceb631043e3b3$export$d0857f60ff1f385);

var $16oBX = parcelRequire("16oBX");

var $8Y1dw = parcelRequire("8Y1dw");
class $147ceb631043e3b3$export$d0857f60ff1f385 {
    constructor(){
        this.errors = [];
        this.syntaxError = (recognizer, offendingSymbol, line, charPositionInLine, msg)=>{
            if (offendingSymbol === undefined) this.errors.push(new (0, $16oBX.JQLParseError)(msg));
            else this.errors.push(new (0, $8Y1dw.JQLSyntaxError)(msg, offendingSymbol.startIndex, offendingSymbol.stopIndex + 1, line, charPositionInLine));
        };
    }
}

});
parcelRegister("16oBX", function(module, exports) {

$parcel$export(module.exports, "JQLParseError", () => $7628b77a425707f8$export$e8cfe2b2c93fbd4b);
/**
 * Represents a error occurring when trying to parse JQL into a Jast.
 */ class $7628b77a425707f8$export$e8cfe2b2c93fbd4b extends Error {
    constructor(message, cause){
        super(message);
        this.name = 'JQLParseError';
        this.cause = cause;
        this.description = message;
    }
}

});

parcelRegister("8Y1dw", function(module, exports) {

$parcel$export(module.exports, "JQLSyntaxError", () => $df64d3ec2083227e$export$3276184116160c41);

var $16oBX = parcelRequire("16oBX");
class $df64d3ec2083227e$export$3276184116160c41 extends (0, $16oBX.JQLParseError) {
    constructor(message, start, stop, line, charPositionInLine){
        super(message);
        this.name = 'JQLSyntaxError';
        this.start = start;
        this.stop = stop;
        this.line = line;
        this.charPositionInLine = charPositionInLine;
    }
}

});


parcelRegister("icZEp", function(module, exports) {

$parcel$export(module.exports, "QueryVisitor", () => $27df4a640b532afb$export$418003b930734805);

var $ehDeP = parcelRequire("ehDeP");

var $3VUhG = parcelRequire("3VUhG");

var $7kD9l = parcelRequire("7kD9l");

var $9W3D9 = parcelRequire("9W3D9");
class $27df4a640b532afb$export$418003b930734805 extends (0, $3VUhG.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.whereVisitor = new (0, $9W3D9.WhereVisitor)(this.tokens);
        this.orderByVisitor = new (0, $7kD9l.OrderByVisitor)(this.tokens);
        this.visitJqlQuery = (ctx)=>{
            const whereContext = ctx.jqlWhere();
            const orderByContext = ctx.jqlOrderBy();
            return (0, $ehDeP.internalCreators).query(whereContext && whereContext.accept(this.whereVisitor), orderByContext && orderByContext.accept(this.orderByVisitor), (0, $3VUhG.getPositionFromContext)(ctx));
        };
    }
}

});
parcelRegister("3VUhG", function(module, exports) {

$parcel$export(module.exports, "JastBuildingVisitor", () => $50292ad2e95b079d$export$d3c14d7188b09387);
$parcel$export(module.exports, "getPositionFromToken", () => $50292ad2e95b079d$export$85a4e6d858dbc6fb);
$parcel$export(module.exports, "getPositionFromContext", () => $50292ad2e95b079d$export$264629d4cd3cad3f);
$parcel$export(module.exports, "getPositionsFromTerminalNodes", () => $50292ad2e95b079d$export$30d51184879cbaa8);
$parcel$export(module.exports, "normalizeText", () => $50292ad2e95b079d$export$7c2714a5250b9239);
class $50292ad2e95b079d$export$d3c14d7188b09387 {
    constructor(tokens){
        this.tokens = tokens;
    }
    visit(tree) {
        throw new Error('Unsupported operation visit(ParseTree)');
    }
    visitChildren(node) {
        throw new Error('Unsupported operation visitChildren(RuleNode)');
    }
    visitErrorNode(node) {
        throw new Error('Unsupported operation visitErrorNode(ErrorNode)');
    }
    visitTerminal(node) {
        throw new Error('Unsupported operation visitTerminal(TerminalNode)');
    }
}
const $50292ad2e95b079d$export$85a4e6d858dbc6fb = (startToken, stopToken)=>[
        startToken.startIndex,
        (stopToken || startToken).stopIndex + 1
    ];
const $50292ad2e95b079d$export$264629d4cd3cad3f = (ctx)=>[
        ctx.start.startIndex,
        ctx.stop ? ctx.stop.stopIndex + 1 : ctx.start.stopIndex
    ];
const $50292ad2e95b079d$export$30d51184879cbaa8 = (terminalNodes)=>terminalNodes.map((node)=>$50292ad2e95b079d$export$85a4e6d858dbc6fb(node.payload));
const $50292ad2e95b079d$export$7c2714a5250b9239 = (text)=>text.toLowerCase().replace(/\s+/g, ' ');

});

parcelRegister("7kD9l", function(module, exports) {

$parcel$export(module.exports, "OrderByVisitor", () => $e74a275e878565f8$export$2774b71b99734811);


var $ehDeP = parcelRequire("ehDeP");

var $kBQaV = parcelRequire("kBQaV");

var $3VUhG = parcelRequire("3VUhG");

var $cH74S = parcelRequire("cH74S");
class $e74a275e878565f8$export$2774b71b99734811 extends (0, $3VUhG.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.searchSortVisitor = new $e74a275e878565f8$var$SearchSortVisitor(this.tokens);
        this.visitJqlOrderBy = (ctx)=>{
            // If this rule returned due to an exception then the order by operator is incomplete so we should exit early,
            // e.g. 'order '.
            if (ctx.exception) return undefined;
            const operator = (0, $ehDeP.internalCreators).orderByOperator((0, $3VUhG.getPositionFromToken)(ctx.ORDER().payload, ctx.BY().payload));
            const fields = ctx.jqlSearchSort().map((searchSortCtx)=>searchSortCtx.accept(this.searchSortVisitor)).filter((0, $kBQaV.notUndefined));
            return (0, $ehDeP.internalCreators).orderBy(fields, operator, (0, $3VUhG.getPositionFromContext)(ctx));
        };
    }
}
class $e74a275e878565f8$var$SearchSortVisitor extends (0, $3VUhG.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.fieldVisitor = new (0, $cH74S.FieldVisitor)(this.tokens);
        this.visitJqlSearchSort = (ctx)=>{
            const fieldCtx = ctx.jqlField();
            // If the field rule is returned due to an exception then we should ignore this search search rule. This happens
            // when there are no fields following and order by clause, e.g. 'order by '
            if (fieldCtx.exception) return undefined;
            let direction;
            const desc = ctx.DESC();
            const asc = ctx.ASC();
            if (desc !== undefined) direction = (0, $ehDeP.internalCreators).orderByDirection((0, $e28fa7cc527af49f$export$2ea27ea5f2121899), (0, $3VUhG.getPositionFromToken)(desc.payload));
            else if (asc !== undefined) direction = (0, $ehDeP.internalCreators).orderByDirection((0, $e28fa7cc527af49f$export$6d60017b9e092e73), (0, $3VUhG.getPositionFromToken)(asc.payload));
            return (0, $ehDeP.internalCreators).orderByField(ctx.jqlField().accept(this.fieldVisitor), direction, (0, $3VUhG.getPositionFromContext)(ctx));
        };
    }
}

});
parcelRegister("kBQaV", function(module, exports) {

$parcel$export(module.exports, "notUndefined", () => $e16d232ad106654d$export$9a1adf421b69c6a);
/**
 * Type predicate to assert an argument is not undefined.
 */ function $e16d232ad106654d$export$9a1adf421b69c6a(x) {
    return x !== undefined;
}

});

parcelRegister("cH74S", function(module, exports) {

$parcel$export(module.exports, "FieldVisitor", () => $53018f1de7e676aa$export$c6a85c4c3bf2317d);

var $ehDeP = parcelRequire("ehDeP");

var $9ACk0 = parcelRequire("9ACk0");

var $3VUhG = parcelRequire("3VUhG");

var $hnBFP = parcelRequire("hnBFP");
class $53018f1de7e676aa$export$c6a85c4c3bf2317d extends (0, $3VUhG.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.stringVisitor = new (0, $hnBFP.StringVisitor)(this.tokens);
        this.fieldPropertyVisitor = new $53018f1de7e676aa$var$FieldPropertyVisitor(this.tokens);
        this.visitJqlNumberField = (ctx)=>{
            const text = this.tokens.getText(ctx);
            return (0, $ehDeP.internalCreators).field(text, text, undefined, (0, $3VUhG.getPositionFromContext)(ctx));
        };
        this.visitJqlNonNumberField = (ctx)=>{
            const stringContext = ctx.jqlString();
            const properties = ctx.jqlFieldProperty().map((context)=>context.accept(this.fieldPropertyVisitor));
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $ehDeP.internalCreators).field(stringValue.value, stringValue.text, properties, (0, $3VUhG.getPositionFromContext)(ctx));
            }
            const text = this.tokens.getText(ctx);
            return (0, $ehDeP.internalCreators).field(text, text, properties, (0, $3VUhG.getPositionFromContext)(ctx));
        };
    }
}
class $53018f1de7e676aa$var$FieldPropertyVisitor extends (0, $3VUhG.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.argumentVisitor = new (0, $9ACk0.ArgumentVisitor)(this.tokens);
        this.propertyArgumentVisitor = new $53018f1de7e676aa$var$PropertyArgumentVisitor(this.tokens);
        this.visitJqlFieldProperty = (ctx)=>{
            const argumentContext = ctx.jqlArgument();
            const propertyArgumentContext = ctx.jqlPropertyArgument();
            const path = propertyArgumentContext.map((context)=>context.accept(this.propertyArgumentVisitor));
            return (0, $ehDeP.internalCreators).property(argumentContext && argumentContext.accept(this.argumentVisitor), path, (0, $3VUhG.getPositionFromContext)(ctx));
        };
    }
}
class $53018f1de7e676aa$var$PropertyArgumentVisitor extends (0, $3VUhG.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.argumentVisitor = new (0, $9ACk0.ArgumentVisitor)(this.tokens);
        this.visitJqlPropertyArgument = (ctx)=>{
            return ctx.jqlArgument().accept(this.argumentVisitor);
        };
    }
}

});
parcelRegister("9ACk0", function(module, exports) {

$parcel$export(module.exports, "ArgumentVisitor", () => $0fa34e4f753b0d1e$export$46b5a1f6d962d533);

var $ehDeP = parcelRequire("ehDeP");

var $3VUhG = parcelRequire("3VUhG");

var $hnBFP = parcelRequire("hnBFP");
class $0fa34e4f753b0d1e$export$46b5a1f6d962d533 extends (0, $3VUhG.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.stringVisitor = new (0, $hnBFP.StringVisitor)(this.tokens);
        this.visitJqlArgument = (ctx)=>{
            const stringContext = ctx.jqlString();
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $ehDeP.internalCreators).argument(stringValue.value, stringValue.text, stringValue.position);
            } else {
                const text = this.tokens.getText(ctx);
                return (0, $ehDeP.internalCreators).argument(text, text, (0, $3VUhG.getPositionFromContext)(ctx));
            }
        };
    }
}

});
parcelRegister("hnBFP", function(module, exports) {

$parcel$export(module.exports, "StringVisitor", () => $4c8c01f6757ee5f1$export$617850cb96304515);

var $3VUhG = parcelRequire("3VUhG");
class $4c8c01f6757ee5f1$export$617850cb96304515 extends (0, $3VUhG.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.visitJqlString = (ctx)=>{
            const text = this.tokens.getText(ctx);
            const position = (0, $3VUhG.getPositionFromContext)(ctx);
            let value;
            if (ctx.QUOTE_STRING()) value = text.replace(/^"|"$/g, '').replace(/(?:\\(.))/g, '$1');
            else if (ctx.SQUOTE_STRING()) value = text.replace(/^'|'$/g, '').replace(/(?:\\(.))/g, '$1');
            else // unquoted string
            value = text;
            return {
                text: text,
                value: value,
                position: position
            };
        };
    }
}

});




parcelRegister("9W3D9", function(module, exports) {

$parcel$export(module.exports, "WhereVisitor", () => $722507e47fe53ea9$export$c573472f1d20e15d);


var $ehDeP = parcelRequire("ehDeP");

var $kBQaV = parcelRequire("kBQaV");

var $3VUhG = parcelRequire("3VUhG");

var $4wtao = parcelRequire("4wtao");
class $722507e47fe53ea9$export$c573472f1d20e15d extends (0, $3VUhG.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.terminalClauseVisitor = new (0, $4wtao.TerminalClauseVisitor)(this.tokens);
        this.visitJqlWhere = (ctx)=>{
            return this.visitJqlOrClause(ctx.jqlOrClause());
        };
        this.visitJqlOrClause = (ctx)=>{
            const clauses = ctx.jqlAndClause().map((andClauseContext)=>andClauseContext.accept(this)).filter((0, $kBQaV.notUndefined));
            if (clauses.length > 1) {
                const operator = (0, $ehDeP.internalCreators).compoundOperator((0, $e5bc650799ce4838$export$7b8f0a728d79a753), (0, $3VUhG.getPositionsFromTerminalNodes)(ctx.OR()));
                return (0, $ehDeP.internalCreators).compoundClause(operator, clauses, (0, $3VUhG.getPositionFromContext)(ctx));
            }
            return clauses.length === 0 ? undefined : clauses[0];
        };
        this.visitJqlAndClause = (ctx)=>{
            const clauses = ctx.jqlNotClause().map((notClauseContext)=>notClauseContext.accept(this)).filter((0, $kBQaV.notUndefined));
            if (clauses.length > 1) {
                const operator = (0, $ehDeP.internalCreators).compoundOperator((0, $e5bc650799ce4838$export$6d6d48d210d3ca97), (0, $3VUhG.getPositionsFromTerminalNodes)(ctx.AND()));
                return (0, $ehDeP.internalCreators).compoundClause(operator, clauses, (0, $3VUhG.getPositionFromContext)(ctx));
            }
            return clauses.length === 0 ? undefined : clauses[0];
        };
        this.visitJqlNotClause = (ctx)=>{
            const notClauseContext = ctx.jqlNotClause();
            const subClauseContext = ctx.jqlSubClause();
            const terminalClauseContext = ctx.jqlTerminalClause();
            let clause;
            if (notClauseContext !== undefined) clause = notClauseContext.accept(this) || undefined;
            else if (subClauseContext !== undefined) clause = subClauseContext.accept(this) || undefined;
            else if (terminalClauseContext !== undefined) clause = terminalClauseContext.accept(this.terminalClauseVisitor);
            // Our token can be either NOT or !
            let notToken = ctx.NOT();
            notToken = notToken === undefined ? ctx.BANG() : notToken;
            if (notToken && clause) return (0, $ehDeP.internalCreators).notClause(clause, (0, $ehDeP.internalCreators).notClauseOperator((0, $3VUhG.getPositionFromToken)(notToken.payload)), (0, $3VUhG.getPositionFromContext)(ctx));
            return clause;
        };
        this.visitJqlSubClause = (ctx)=>{
            return this.visitJqlOrClause(ctx.jqlOrClause());
        };
    }
}

});
const $e5bc650799ce4838$export$6d6d48d210d3ca97 = 'and';
const $e5bc650799ce4838$export$7b8f0a728d79a753 = 'or';

parcelRegister("4wtao", function(module, exports) {

$parcel$export(module.exports, "TerminalClauseVisitor", () => $6b978e460b5b79f7$export$14576ae5bd1874a9);

var $ehDeP = parcelRequire("ehDeP");

var $kBQaV = parcelRequire("kBQaV");

var $3VUhG = parcelRequire("3VUhG");

var $cH74S = parcelRequire("cH74S");

var $6z1Wi = parcelRequire("6z1Wi");

var $lLwbI = parcelRequire("lLwbI");

var $kBz8X = parcelRequire("kBz8X");
class $6b978e460b5b79f7$export$14576ae5bd1874a9 extends (0, $3VUhG.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.fieldVisitor = new (0, $cH74S.FieldVisitor)(this.tokens);
        this.terminalClauseRhsVisitor = new $6b978e460b5b79f7$var$TerminalClauseRhsVisitor(this.tokens);
        this.visitJqlTerminalClause = (ctx)=>{
            const field = ctx.jqlField().accept(this.fieldVisitor);
            const { operator: operator, operand: operand, predicates: predicates } = ctx.jqlTerminalClauseRhs().accept(this.terminalClauseRhsVisitor);
            const position = (0, $3VUhG.getPositionFromContext)(ctx);
            return (0, $ehDeP.internalCreators).terminalClause(field, operator, operand, predicates, position);
        };
    }
}
class $6b978e460b5b79f7$var$TerminalClauseRhsVisitor extends (0, $3VUhG.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.operatorVisitor = new (0, $lLwbI.OperatorVisitor)(this.tokens);
        this.terminalClauseOperandVisitor = new $6b978e460b5b79f7$var$TerminalClauseOperandVisitor(this.tokens);
        this.predicateVisitor = new (0, $kBz8X.PredicateVisitor)(this.tokens);
        this.visitJqlEqualsClause = (ctx)=>{
            const operator = ctx.jqlEqualsOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        };
        this.visitJqlLikeClause = (ctx)=>{
            const operator = ctx.jqlLikeOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        };
        this.visitJqlComparisonClause = (ctx)=>{
            const operator = ctx.jqlComparisonOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        };
        this.visitJqlInClause = (ctx)=>{
            const operator = ctx.jqlInOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        };
        this.visitJqlIsClause = (ctx)=>{
            const operator = ctx.jqlIsOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        };
        this.visitJqlWasClause = (ctx)=>{
            const operator = ctx.jqlWasOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            const predicates = ctx.jqlWasPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, $kBQaV.notUndefined));
            return {
                operator: operator,
                operand: operand,
                predicates: predicates
            };
        };
        this.visitJqlWasInClause = (ctx)=>{
            const operator = ctx.jqlWasInOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            const predicates = ctx.jqlWasPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, $kBQaV.notUndefined));
            return {
                operator: operator,
                operand: operand,
                predicates: predicates
            };
        };
        this.visitJqlChangedClause = (ctx)=>{
            const operator = ctx.jqlChangedOperator().accept(this.operatorVisitor);
            const predicates = ctx.jqlChangedPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, $kBQaV.notUndefined));
            return {
                operator: operator,
                operand: undefined,
                predicates: predicates
            };
        };
        // Recover from clause type ambiguities, e.g. "issuetype was " (which can be a WAS or WAS IN clause)
        this.visitChildren = (node)=>{
            const operator = node.accept(this.operatorVisitor);
            return {
                operator: operator,
                operand: undefined,
                predicates: []
            };
        };
    }
}
class $6b978e460b5b79f7$var$TerminalClauseOperandVisitor extends (0, $3VUhG.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.operandVisitor = new (0, $6z1Wi.OperandVisitor)(this.tokens);
        this.visitJqlEqualsClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        };
        this.visitJqlLikeClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        };
        this.visitJqlComparisonClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        };
        this.visitJqlInClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlList(),
                ctx.jqlFunction()
            ]);
        };
        this.visitJqlIsClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty()
            ]);
        };
        this.visitJqlWasClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        };
        this.visitJqlWasInClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlList(),
                ctx.jqlFunction()
            ]);
        };
        this.getOperandForContexts = (contexts)=>{
            const operandContext = contexts.find((0, $kBQaV.notUndefined));
            return operandContext?.accept(this.operandVisitor);
        };
    }
}

});
parcelRegister("6z1Wi", function(module, exports) {

$parcel$export(module.exports, "OperandVisitor", () => $81f4193fbe0decad$export$ef8ae1aa15d9c9af);


var $ehDeP = parcelRequire("ehDeP");

var $kBQaV = parcelRequire("kBQaV");

var $9ACk0 = parcelRequire("9ACk0");

var $3VUhG = parcelRequire("3VUhG");

var $g32gk = parcelRequire("g32gk");

var $hnBFP = parcelRequire("hnBFP");
class $81f4193fbe0decad$export$ef8ae1aa15d9c9af extends (0, $3VUhG.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.stringVisitor = new (0, $hnBFP.StringVisitor)(this.tokens);
        this.numberVisitor = new (0, $g32gk.NumberVisitor)(this.tokens);
        this.functionNameVisitor = new $81f4193fbe0decad$var$FunctionNameVisitor(this.tokens);
        this.argumentListVisitor = new $81f4193fbe0decad$var$ArgumentListVisitor(this.tokens);
        this.visitJqlOperand = (ctx)=>{
            const operandContext = [
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlList(),
                ctx.jqlFunction()
            ].find((0, $kBQaV.notUndefined));
            return operandContext?.accept(this);
        };
        this.visitJqlEmpty = (ctx)=>{
            // ANTLR will optimistically create a jqlEmpty node in some situations where user input doesn't match the EMPTY
            // token, e.g. when using value operands in IS clauses ("field is value"), where EMPTY is the only valid operand.
            if (ctx.exception) return undefined;
            return (0, $ehDeP.internalCreators).keywordOperand((0, $807962b43ef03b56$export$1c46dca02aac24dd), (0, $3VUhG.getPositionFromToken)(ctx.EMPTY().payload));
        };
        this.visitJqlValue = (ctx)=>{
            const stringContext = ctx.jqlString();
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $ehDeP.internalCreators).valueOperand(stringValue.value, stringValue.text, stringValue.position);
            }
            const numberContext = ctx.jqlNumber();
            if (numberContext !== undefined) return numberContext.accept(this.numberVisitor);
        };
        this.visitJqlList = (ctx)=>{
            const values = ctx.jqlOperand().map((operandCtx)=>operandCtx.accept(this)).filter((0, $kBQaV.notUndefined));
            return (0, $ehDeP.internalCreators).listOperand(values, (0, $3VUhG.getPositionFromContext)(ctx));
        };
        this.visitJqlFunction = (ctx)=>{
            const argumentListContext = ctx.jqlArgumentList();
            return (0, $ehDeP.internalCreators).functionOperand(ctx.jqlFunctionName().accept(this.functionNameVisitor), argumentListContext === undefined ? [] : argumentListContext.accept(this.argumentListVisitor), (0, $3VUhG.getPositionFromContext)(ctx));
        };
    }
}
class $81f4193fbe0decad$var$FunctionNameVisitor extends (0, $3VUhG.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.stringVisitor = new (0, $hnBFP.StringVisitor)(this.tokens);
        this.visitJqlFunctionName = (ctx)=>{
            const stringContext = ctx.jqlString();
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $ehDeP.internalCreators).functionString(stringValue.value, stringValue.text, stringValue.position);
            } else {
                const text = this.tokens.getText(ctx);
                return (0, $ehDeP.internalCreators).functionString(text, text, (0, $3VUhG.getPositionFromContext)(ctx));
            }
        };
    }
}
class $81f4193fbe0decad$var$ArgumentListVisitor extends (0, $3VUhG.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.argumentVisitor = new (0, $9ACk0.ArgumentVisitor)(this.tokens);
        this.visitJqlArgumentList = (ctx)=>{
            return ctx.jqlArgument().map((argumentCtx)=>argumentCtx.accept(this.argumentVisitor));
        };
    }
}

});
parcelRegister("g32gk", function(module, exports) {

$parcel$export(module.exports, "NumberVisitor", () => $8c2072821d46bf7b$export$a55432f0884633e4);

var $ehDeP = parcelRequire("ehDeP");

var $3VUhG = parcelRequire("3VUhG");
class $8c2072821d46bf7b$export$a55432f0884633e4 extends (0, $3VUhG.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.visitJqlNumber = (ctx)=>{
            const text = this.tokens.getText(ctx);
            return (0, $ehDeP.internalCreators).valueOperand(text, text, (0, $3VUhG.getPositionFromContext)(ctx));
        };
    }
}

});


parcelRegister("lLwbI", function(module, exports) {

$parcel$export(module.exports, "OperatorVisitor", () => $56193d3bee1d14fd$export$e56f89ba95b51d2a);

var $ehDeP = parcelRequire("ehDeP");

var $ktjOC = parcelRequire("ktjOC");

var $3VUhG = parcelRequire("3VUhG");
class $56193d3bee1d14fd$export$e56f89ba95b51d2a extends (0, $3VUhG.JastBuildingVisitor) {
    visitJqlEqualsOperator(ctx) {
        const text = this.tokens.getText(ctx);
        if (!(0, $ktjOC.isEqualsOperator)(text)) throw new Error(`'${text}' does not match any of the recognised equals operators`);
        return (0, $ehDeP.internalCreators).operator(text, text, (0, $3VUhG.getPositionFromContext)(ctx));
    }
    visitJqlLikeOperator(ctx) {
        const text = this.tokens.getText(ctx);
        if (!(0, $ktjOC.isLikeOperator)(text)) throw new Error(`'${text}' does not match any of the recognised like operators`);
        return (0, $ehDeP.internalCreators).operator(text, text, (0, $3VUhG.getPositionFromContext)(ctx));
    }
    visitJqlComparisonOperator(ctx) {
        const text = this.tokens.getText(ctx);
        if (!(0, $ktjOC.isComparisonOperator)(text)) throw new Error(`'${text}' does not match any of the recognised comparison operators`);
        return (0, $ehDeP.internalCreators).operator(text, text, (0, $3VUhG.getPositionFromContext)(ctx));
    }
    visitJqlInOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $3VUhG.normalizeText)(text);
        if (!(0, $ktjOC.isInOperator)(value)) // This can happen if an incomplete operator is used, e.g. `status not open`.
        return undefined;
        return (0, $ehDeP.internalCreators).operator(value, text, (0, $3VUhG.getPositionFromContext)(ctx));
    }
    visitJqlIsOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $3VUhG.normalizeText)(text);
        if (!(0, $ktjOC.isIsOperator)(value)) throw new Error(`'${text}' does not match any of the recognised is operators`);
        return (0, $ehDeP.internalCreators).operator(value, text, (0, $3VUhG.getPositionFromContext)(ctx));
    }
    visitJqlWasOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $3VUhG.normalizeText)(text);
        if (!(0, $ktjOC.isWasOperator)(value)) throw new Error(`'${text}' does not match any of the recognised was operators`);
        return (0, $ehDeP.internalCreators).operator(value, text, (0, $3VUhG.getPositionFromContext)(ctx));
    }
    visitJqlWasInOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $3VUhG.normalizeText)(text);
        if (!(0, $ktjOC.isWasInOperator)(value)) throw new Error(`'${text}' does not match any of the recognised was in operators`);
        return (0, $ehDeP.internalCreators).operator(value, text, (0, $3VUhG.getPositionFromContext)(ctx));
    }
    visitJqlChangedOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $3VUhG.normalizeText)(text);
        if (!(0, $ktjOC.isChangedOperator)(value)) throw new Error(`'${text}' does not match any of the recognised changed operators`);
        return (0, $ehDeP.internalCreators).operator(value, text, (0, $3VUhG.getPositionFromContext)(ctx));
    }
    constructor(...args){
        super(...args);
        // Recover from clause type ambiguities, e.g. "issuetype was " (which can be a WAS or WAS IN clause)
        this.visitChildren = (node)=>{
            const { sourceInterval: sourceInterval } = node;
            const text = this.tokens.getText(sourceInterval);
            if (text) {
                const value = (0, $3VUhG.normalizeText)(text);
                const { a: startIndex, b: stopIndex } = sourceInterval;
                const startToken = this.tokens.get(startIndex);
                const stopToken = this.tokens.get(stopIndex);
                const position = (0, $3VUhG.getPositionFromToken)(startToken, stopToken);
                if ((0, $ktjOC.isOperator)(value)) return (0, $ehDeP.internalCreators).operator(value, text, position);
            }
        };
    }
}

});
parcelRegister("ktjOC", function(module, exports) {

$parcel$export(module.exports, "isOperator", () => $198d8c737341c34e$export$4e40859592ee7ac2);
$parcel$export(module.exports, "isEqualsOperator", () => $198d8c737341c34e$export$6d0fc196fa8a1673);
$parcel$export(module.exports, "isLikeOperator", () => $198d8c737341c34e$export$ad91b6d6a89cb64e);
$parcel$export(module.exports, "isComparisonOperator", () => $198d8c737341c34e$export$4477c442bd5c2a6d);
$parcel$export(module.exports, "isInOperator", () => $198d8c737341c34e$export$c5e1cdef30e30bff);
$parcel$export(module.exports, "isIsOperator", () => $198d8c737341c34e$export$ccc3334744e395c7);
$parcel$export(module.exports, "isWasOperator", () => $198d8c737341c34e$export$2b1c5d7e7856f91d);
$parcel$export(module.exports, "isWasInOperator", () => $198d8c737341c34e$export$55d8c9b20d99509f);
$parcel$export(module.exports, "isChangedOperator", () => $198d8c737341c34e$export$b65d23d23ade534b);
$parcel$export(module.exports, "isListOperator", () => $198d8c737341c34e$export$b09522e4061bbdd6);

var $k85ht = parcelRequire("k85ht");
const $198d8c737341c34e$export$4e40859592ee7ac2 = (operator)=>(0, $k85ht.OPERATORS).includes(operator);
const $198d8c737341c34e$export$6d0fc196fa8a1673 = (operator)=>(0, $k85ht.EQUALS_OPERATORS).includes(operator);
const $198d8c737341c34e$export$ad91b6d6a89cb64e = (operator)=>(0, $k85ht.LIKE_OPERATORS).includes(operator);
const $198d8c737341c34e$export$4477c442bd5c2a6d = (operator)=>(0, $k85ht.COMPARISON_OPERATORS).includes(operator);
const $198d8c737341c34e$export$c5e1cdef30e30bff = (operator)=>(0, $k85ht.IN_OPERATORS).includes(operator);
const $198d8c737341c34e$export$ccc3334744e395c7 = (operator)=>(0, $k85ht.IS_OPERATORS).includes(operator);
const $198d8c737341c34e$export$2b1c5d7e7856f91d = (operator)=>(0, $k85ht.WAS_OPERATORS).includes(operator);
const $198d8c737341c34e$export$55d8c9b20d99509f = (operator)=>(0, $k85ht.WAS_IN_OPERATORS).includes(operator);
const $198d8c737341c34e$export$b65d23d23ade534b = (operator)=>(0, $k85ht.CHANGED_OPERATORS).includes(operator);
const $198d8c737341c34e$export$b09522e4061bbdd6 = (operator)=>(0, $k85ht.LIST_OPERATORS).includes(operator);

});


parcelRegister("kBz8X", function(module, exports) {

$parcel$export(module.exports, "PredicateVisitor", () => $12650a35f2520092$export$33bb52a35c693109);

var $ehDeP = parcelRequire("ehDeP");

var $4Mvgs = parcelRequire("4Mvgs");

var $kBQaV = parcelRequire("kBQaV");

var $3VUhG = parcelRequire("3VUhG");

var $6z1Wi = parcelRequire("6z1Wi");
class $12650a35f2520092$export$33bb52a35c693109 extends (0, $3VUhG.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.predicateOperatorVisitor = new $12650a35f2520092$var$PredicateOperatorVisitor(this.tokens);
        this.predicateOperandVisitor = new $12650a35f2520092$var$PredicateOperandVisitor(this.tokens);
        this.visitJqlWasPredicate = (ctx)=>{
            const operator = this.getOperatorForContexts([
                ctx.jqlDatePredicateOperator(),
                ctx.jqlDateRangePredicateOperator(),
                ctx.jqlUserPredicateOperator()
            ]);
            const operand = ctx.jqlPredicateOperand().accept(this.predicateOperandVisitor);
            const position = (0, $3VUhG.getPositionFromContext)(ctx);
            return (0, $ehDeP.internalCreators).predicate(operator, operand, position);
        };
        this.visitJqlChangedPredicate = (ctx)=>{
            const operator = this.getOperatorForContexts([
                ctx.jqlDatePredicateOperator(),
                ctx.jqlDateRangePredicateOperator(),
                ctx.jqlUserPredicateOperator(),
                ctx.jqlValuePredicateOperator()
            ]);
            const operand = ctx.jqlPredicateOperand().accept(this.predicateOperandVisitor);
            const position = (0, $3VUhG.getPositionFromContext)(ctx);
            return (0, $ehDeP.internalCreators).predicate(operator, operand, position);
        };
        this.getOperatorForContexts = (contexts)=>{
            const operatorContext = contexts.find((0, $kBQaV.notUndefined));
            if (operatorContext !== undefined) return operatorContext.accept(this.predicateOperatorVisitor);
            else throw new Error('Undefined predicate operator context');
        };
    }
}
class $12650a35f2520092$var$PredicateOperatorVisitor extends (0, $3VUhG.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.visitJqlDatePredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        };
        this.visitJqlDateRangePredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        };
        this.visitJqlUserPredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        };
        this.visitJqlValuePredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        };
        this.getPredicateOperator = (ctx)=>{
            const text = this.tokens.getText(ctx);
            // Replace consecutive whitespace chars with single space
            const value = text.toLowerCase().replace(/\s+/g, ' ');
            if (!(0, $4Mvgs.isPredicateOperator)(value)) throw new Error(`Found a history predicate operator which does not map to a changed time predicate operator in the ast: ${text}`);
            return (0, $ehDeP.internalCreators).predicateOperator(value, text, (0, $3VUhG.getPositionFromContext)(ctx));
        };
    }
}
class $12650a35f2520092$var$PredicateOperandVisitor extends (0, $3VUhG.JastBuildingVisitor) {
    constructor(...args){
        super(...args);
        this.operandVisitor = new (0, $6z1Wi.OperandVisitor)(this.tokens);
        this.visitJqlPredicateOperand = (ctx)=>{
            return ctx.jqlOperand().accept(this.operandVisitor);
        };
    }
}

});
parcelRegister("4Mvgs", function(module, exports) {

$parcel$export(module.exports, "isPredicateOperator", () => $8d2d30ba6207a521$export$188978ad94919403);

var $gjMYw = parcelRequire("gjMYw");
const $8d2d30ba6207a521$export$188978ad94919403 = (operator)=>(0, $gjMYw.PREDICATE_OPERATORS).includes(operator);

});
parcelRegister("gjMYw", function(module, exports) {

$parcel$export(module.exports, "PREDICATE_OPERATORS", () => $07443215caf672cb$export$e200440af9f1d9f);
const $07443215caf672cb$export$3d56e2ae1b4bbbf9 = 'after';
const $07443215caf672cb$export$f0a816341603bb63 = 'before';
const $07443215caf672cb$export$cdc81c84f768d513 = 'by';
const $07443215caf672cb$export$8a5280c65e704c3d = 'during';
const $07443215caf672cb$export$71f882dcac65f97a = 'from';
const $07443215caf672cb$export$5685a35c6b0a7ee8 = 'on';
const $07443215caf672cb$export$5a83c4789e531a = 'to';
const $07443215caf672cb$export$e200440af9f1d9f = [
    $07443215caf672cb$export$3d56e2ae1b4bbbf9,
    $07443215caf672cb$export$f0a816341603bb63,
    $07443215caf672cb$export$cdc81c84f768d513,
    $07443215caf672cb$export$8a5280c65e704c3d,
    $07443215caf672cb$export$71f882dcac65f97a,
    $07443215caf672cb$export$5685a35c6b0a7ee8,
    $07443215caf672cb$export$5a83c4789e531a
];

});







parcelRegister("lNvVH", function(module, exports) {

$parcel$export(module.exports, "getOrderBy", () => $cd337f038adc0626$export$128f09144c413f07);

var $ekfiD = parcelRequire("ekfiD");
const $cd337f038adc0626$export$128f09144c413f07 = (jast)=>{
    const jqlString = jast.represents;
    const orderBy = jast.query?.orderBy;
    if (orderBy && orderBy.position) return (0, $ekfiD.substring)(jqlString, orderBy.position[0], orderBy.position[1]);
    return undefined;
};

});
parcelRegister("ekfiD", function(module, exports) {

$parcel$export(module.exports, "substring", () => $3c53ad6f00103379$export$662d3818631fba36);
/**
 * Returns the substring at the specified location within a String object while supporting Emojis.
 *
 * This method is to be used instead of String.substring. String.substring does not handle emojis correctly as they can be multi-char length.
 *
 * @param start — The zero-based index number indicating the beginning of the substring.
 * @param end Zero-based index number indicating the end of the substring. The substring includes the characters up to, but not including, the character indicated by end. If end is omitted, the characters from start through the end of the original string are returned.
 */ const $3c53ad6f00103379$export$662d3818631fba36 = (str, start, end)=>[
        ...str
    ].slice(start, end).join('');

});


parcelRegister("Z76ZO", function(module, exports) {

$parcel$export(module.exports, "getPrimarySortDirection", () => $41da40727cfc3bf7$export$ede1a70fd138682b);
const $41da40727cfc3bf7$export$ede1a70fd138682b = (jast)=>jast.query?.orderBy?.fields[0]?.direction?.value;

});

parcelRegister("37dsC", function(module, exports) {

$parcel$export(module.exports, "getPrimarySortField", () => $4b02fbf678f6d44c$export$2281286922a00968);

var $ekfiD = parcelRequire("ekfiD");
const $4b02fbf678f6d44c$export$2281286922a00968 = (jast)=>{
    const primarySortField = jast.query?.orderBy?.fields[0];
    return primarySortField?.field.properties && primarySortField?.field?.position ? (0, $ekfiD.substring)(jast.represents, primarySortField?.field?.position[0], primarySortField?.field?.position[1]) : primarySortField?.field.value;
};

});

parcelRegister("9Ye3T", function(module, exports) {

$parcel$export(module.exports, "setPrimarySortDirection", () => $e03ca2999d589773$export$aec8b488d3f81589);

var $ekfiD = parcelRequire("ekfiD");
const $e03ca2999d589773$export$aec8b488d3f81589 = (sortOrder, jast)=>{
    const jql = jast.represents;
    const orderBy = jast.query?.orderBy;
    if (typeof jql !== 'string') return '';
    if (!orderBy || !orderBy.fields.length) return jql;
    const { direction: direction } = orderBy.fields[0];
    if (!direction && orderBy.fields.length > 1) {
        const { field: field } = orderBy.fields[0];
        if (!field.position) return jql;
        const [, end] = field.position;
        return `${(0, $ekfiD.substring)(jql, 0, end)} ${sortOrder}${(0, $ekfiD.substring)(jql, end)}`;
    }
    if (!direction) return `${jql} ${sortOrder}`;
    if (!direction.position) return jql;
    const [start, end] = direction.position;
    return `${(0, $ekfiD.substring)(jql, 0, start)}${sortOrder}${(0, $ekfiD.substring)(jql, end)}`;
};

});

parcelRegister("2yQ0D", function(module, exports) {

$parcel$export(module.exports, "setPrimarySortField", () => $4d6d252bc09fc4ee$export$e66898f5eaced7d6);


var $1ybV0 = parcelRequire("1ybV0");

var $ekfiD = parcelRequire("ekfiD");

var $9olch = parcelRequire("9olch");
const $4d6d252bc09fc4ee$export$e66898f5eaced7d6 = (jast, sortField, sortDirection = (0, $e28fa7cc527af49f$export$2ea27ea5f2121899), aliases)=>{
    const orderBy = jast.query?.orderBy;
    const jql = jast.represents;
    if (!orderBy || !orderBy.fields.length) return `${jql} ORDER BY ${sortField}${(0, $1ybV0.ff)('endeavour.nin.fix-jqlutils-setprimarysortfield-bug') && sortDirection ? ` ${sortDirection}` : ''}`;
    const includedFields = new Set([
        sortField,
        ...aliases
    ]);
    const sanitizedSortField = (0, $9olch.sanitizeClauseName)(sortField);
    const orderByFields = orderBy.fields;
    const fieldsJql = orderByFields// filter duplicates
    .filter((field)=>{
        const { position: position } = field.field;
        const fieldValue = field.field.properties && position ? (0, $ekfiD.substring)(jql, position[0], position[1]) : field.field.value;
        if (includedFields.has(fieldValue)) return false;
        includedFields.add(fieldValue);
        return true;
    })// convert fields to jql
    .reduce((acc, field)=>{
        const { position: position } = field;
        // acc.push(`${field.field.value} ${field.direction?.value || ''}`);
        if (position) acc.push((0, $ekfiD.substring)(jql, position[0], position[1]));
        return acc;
    }, [
        `${sanitizedSortField} ${sortDirection}`
    ]).join(', ');
    const startPosition = orderBy.fields[0].position;
    if (startPosition) {
        const start = startPosition[0];
        return `${(0, $ekfiD.substring)(jql, 0, start)}${fieldsJql}`;
    }
    return jql;
};

});
parcelRegister("9olch", function(module, exports) {

$parcel$export(module.exports, "sanitizeClauseName", () => $1fea32b05fcff15b$export$5f3b8bbb2bff9817);

var $7SI4l = parcelRequire("7SI4l");
// Check if string have inner spaces
const $1fea32b05fcff15b$var$haveSpaces = (s)=>/\s/g.test(s.trim());
const $1fea32b05fcff15b$export$5f3b8bbb2bff9817 = (clauseName)=>{
    if ($1fea32b05fcff15b$var$haveSpaces(clauseName)) return (0, $7SI4l.quoteString)(clauseName);
    return clauseName;
};

});
parcelRegister("7SI4l", function(module, exports) {

$parcel$export(module.exports, "quoteString", () => $51c7e56c8d32693d$export$2c4c4d2119dc396f);
/**
 * Wrap the provided string in double quotes and escape and double quote characters present in the string.
 */ const $51c7e56c8d32693d$export$2c4c4d2119dc396f = (str)=>`"${str.replace(/"/g, '\\"')}"`;

});




parcelRegister("9kcYg", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d055daec1f88b72$export$2e2bcd8739ae039);


var $ekfiD = parcelRequire("ekfiD");

var $9ibSd = parcelRequire("9ibSd");
const $4d055daec1f88b72$var$removeFieldClauseFromJql = (ast, clauseToRemove)=>{
    const jqlString = ast.represents;
    let previousClause;
    let nextClause;
    const where = ast.query?.where;
    if (where && where.clauseType === (0, $35634e4e5a46f5ae$export$7a58b23488ea076b)) for(let index = 0; index < where.clauses.length; index += 1){
        const clause = where.clauses[index];
        const clausePosition = clause.position;
        const clauseToRemovePosition = clauseToRemove.position;
        // Early exit if position data is unavailable for our clause
        if (!clausePosition || !clauseToRemovePosition) return jqlString;
        if (clausePosition[0] === clauseToRemovePosition[0] && clausePosition[1] === clauseToRemovePosition[1]) {
            previousClause = where.clauses[index - 1];
            nextClause = where.clauses[index + 1];
        }
    }
    const clauseToRemovePosition = (0, $9ibSd.getClausePosition)(jqlString, clauseToRemove);
    // Early exit if position data is unavailable for our clause
    if (!clauseToRemovePosition) return jqlString;
    const [clauseToRemoveStart, clauseToRemoveEnd] = clauseToRemovePosition;
    if (previousClause) {
        // preserve AND inbetween
        if (nextClause) {
            const nextClausePosition = (0, $9ibSd.getClausePosition)(jqlString, nextClause);
            // Early exit if position data is unavailable for our clause
            if (!nextClausePosition) return jqlString;
            return (0, $ekfiD.substring)(jqlString, 0, clauseToRemoveStart) + (0, $ekfiD.substring)(jqlString, nextClausePosition[0]);
        }
        const previousClausePosition = (0, $9ibSd.getClausePosition)(jqlString, previousClause);
        // Early exit if position data is unavailable for our clause
        if (!previousClausePosition) return jqlString;
        return (0, $ekfiD.substring)(jqlString, 0, previousClausePosition[1]) + (0, $ekfiD.substring)(jqlString, clauseToRemoveEnd);
    }
    if (!previousClause) {
        if (nextClause) {
            const nextClausePosition = (0, $9ibSd.getClausePosition)(jqlString, nextClause);
            // Early exit if position data is unavailable for our clause
            if (!nextClausePosition) return jqlString;
            return (0, $ekfiD.substring)(jqlString, 0, clauseToRemoveStart) + (0, $ekfiD.substring)(jqlString, nextClausePosition[0]);
        }
        return (0, $ekfiD.substring)(jqlString, 0, clauseToRemoveStart) + (0, $ekfiD.substring)(jqlString, clauseToRemoveEnd);
    }
    return jqlString;
};
var $4d055daec1f88b72$export$2e2bcd8739ae039 = $4d055daec1f88b72$var$removeFieldClauseFromJql;

});
parcelRegister("9ibSd", function(module, exports) {

$parcel$export(module.exports, "getClausePosition", () => $3b42225169e235e4$export$9a8cf65f444b696f);
const $3b42225169e235e4$var$whiteSpaceRegex = /\s/;
const $3b42225169e235e4$export$9a8cf65f444b696f = (jql, clause)=>{
    if (!clause.position) return null;
    let [start, end] = [
        undefined,
        undefined
    ];
    // Spreading the jql will account for multi-char unicode characters
    const jqlSymbols = [
        ...jql
    ];
    // Start
    for(let i = clause.position[0] - 1; i >= 0; i -= 1){
        const symbol = jqlSymbols[i];
        if (symbol === '(') {
            start = i;
            break;
        }
        // The use of continue here to check for
        if (!$3b42225169e235e4$var$whiteSpaceRegex.test(symbol)) break;
    }
    // short circuit here if no '(' is found
    if (start === undefined) return clause.position;
    // End
    for(let i = clause.position[1]; i <= jqlSymbols.length; i += 1){
        const symbol = jqlSymbols[i];
        if (symbol === ')') {
            end = i + 1;
            break;
        }
        if (!$3b42225169e235e4$var$whiteSpaceRegex.test(symbol)) break;
    }
    return start !== undefined && end !== undefined ? [
        start,
        end
    ] : clause.position;
};

});


parcelRegister("a4IeB", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $842e422340bc7efd$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $842e422340bc7efd$export$d57b6b390e78d90f);
$parcel$export(module.exports, "SORT_ASC", () => $842e422340bc7efd$export$88956207daf9a17e);
$parcel$export(module.exports, "SORT_DESC", () => $842e422340bc7efd$export$bc14f97913aaf2a);
$parcel$export(module.exports, "SORT_NONE", () => $842e422340bc7efd$export$9c424bf3e8ffe64e);
$parcel$export(module.exports, "MODIFY_COLUMNS", () => $842e422340bc7efd$export$1f921c78ce6d243c);
$parcel$export(module.exports, "REORDER_COLUMNS", () => $842e422340bc7efd$export$83371d6c41a974aa);
$parcel$export(module.exports, "MOVE_COLUMN_FIRST", () => $842e422340bc7efd$export$957d455bb65919d8);
$parcel$export(module.exports, "MOVE_COLUMN_LEFT", () => $842e422340bc7efd$export$2082861c970802b0);
$parcel$export(module.exports, "MOVE_COLUMN_RIGHT", () => $842e422340bc7efd$export$21847d308b0769ad);
$parcel$export(module.exports, "MOVE_COLUMN_LAST", () => $842e422340bc7efd$export$c32913bc261af82d);
$parcel$export(module.exports, "BORDER_WIDTH", () => $842e422340bc7efd$export$e2bd4c1faded7921);
$parcel$export(module.exports, "getDragIconSize", () => $842e422340bc7efd$export$d5120333bf67ced2);
$parcel$export(module.exports, "getMarginBetweenHeaders", () => $842e422340bc7efd$export$a3c854b50595c804);
$parcel$export(module.exports, "COLUMN_ID_MEATBALL_MENU", () => $842e422340bc7efd$export$de4c02b525d877fa);
$parcel$export(module.exports, "MAX_COLUMNS", () => $842e422340bc7efd$export$7ec4af037f372df4);
$parcel$export(module.exports, "KNOWN_COLUMN_TYPES", () => $842e422340bc7efd$export$bbc2e8c301f97f97);
$parcel$export(module.exports, "COLUMN_TYPE_PARENT_LINK", () => $842e422340bc7efd$export$1adf7afff96bbf16);
$parcel$export(module.exports, "MINIMUM_COLUMN_WIDTH", () => $842e422340bc7efd$export$5575b9e0ed3ff59f);
$parcel$export(module.exports, "DEFAULT_COLUMN_WIDTH", () => $842e422340bc7efd$export$7c3f559e2ca95fa);
$parcel$export(module.exports, "MAXIMUM_COLUMN_WIDTH", () => $842e422340bc7efd$export$e1a42c2fefb5af25);
$parcel$export(module.exports, "COLUMN_WIDTH_TEXT_LONG", () => $842e422340bc7efd$export$bfe09a9186b98f8f);
$parcel$export(module.exports, "COLUMN_WIDTH_TEXT_SHORT", () => $842e422340bc7efd$export$f2540f34b796306d);
$parcel$export(module.exports, "COLUMN_WIDTH_TEXT_SUMMARY", () => $842e422340bc7efd$export$954afb0fcf5a326);
$parcel$export(module.exports, "COLUMN_OPERATION_REORDER", () => $842e422340bc7efd$export$93758649595b2d58);
$parcel$export(module.exports, "COLUMN_OPERATION_RESIZE", () => $842e422340bc7efd$export$cad8c6a0b6e78898);
$parcel$export(module.exports, "COLUMN_RESIZE_HANDLE_FULL_HEIGHT", () => $842e422340bc7efd$export$754b76ac8fa63350);
$parcel$export(module.exports, "COLUMN_RESIZE_HANDLE_HEADER_ONLY", () => $842e422340bc7efd$export$fa5c7dad7ee16383);
const $842e422340bc7efd$export$b8b9d90f9e5bd72b = 'jiraNativeIssueTable';
const $842e422340bc7efd$export$d57b6b390e78d90f = 'empanada';
const $842e422340bc7efd$export$88956207daf9a17e = 'ASC';
const $842e422340bc7efd$export$bc14f97913aaf2a = 'DESC';
const $842e422340bc7efd$export$9c424bf3e8ffe64e = 'NONE';
const $842e422340bc7efd$export$1f921c78ce6d243c = 'MODIFY_COLUMNS';
const $842e422340bc7efd$export$83371d6c41a974aa = 'REORDER_COLUMNS';
const $842e422340bc7efd$export$957d455bb65919d8 = 'MOVE_COLUMN_FIRST';
const $842e422340bc7efd$export$2082861c970802b0 = 'MOVE_COLUMN_LEFT';
const $842e422340bc7efd$export$21847d308b0769ad = 'MOVE_COLUMN_RIGHT';
const $842e422340bc7efd$export$c32913bc261af82d = 'MOVE_COLUMN_LAST';
const $842e422340bc7efd$export$e2bd4c1faded7921 = '1px';
const $842e422340bc7efd$export$cdb7fd9d999c7168 = 40;
const $842e422340bc7efd$export$88e6c5bab2ff80e8 = 40;
const $842e422340bc7efd$export$d5120333bf67ced2 = ()=>"var(--ds-space-300, 24px)";
const $842e422340bc7efd$export$a3c854b50595c804 = ()=>"var(--ds-space-050, 4px)";
const $842e422340bc7efd$export$de4c02b525d877fa = '__issuetable_internal_meatball';
const $842e422340bc7efd$export$7ec4af037f372df4 = 500;
const $842e422340bc7efd$export$bbc2e8c301f97f97 = {
    ASSIGNEE: 'assignee',
    DESCRIPTION: 'description',
    ENVIRONMENT: 'environment',
    ISSUE_KEY: 'issuekey',
    ISSUE_OPERATIONS: '__issuetable_internal_meatball',
    STATUS: 'status',
    SUMMARY: 'summary',
    ISSUE_TYPE: 'issuetype',
    RESOLUTION: 'resolution',
    PARENT: 'parent',
    LABELS: 'labels',
    COMPONENTS: 'components',
    FIX_VERSIONS: 'fixVersions',
    STATUS_CATEGORY: 'statusCategory',
    PROJECT: 'project',
    READ_ONLY: 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield',
    SPRINT: 'com.pyxis.greenhopper.jira:gh-sprint',
    TEXT: 'com.atlassian.jira.plugin.system.customfieldtypes:textfield',
    EPIC_LINK: 'com.pyxis.greenhopper.jira:gh-epic-link',
    CREATED: 'created',
    RESOLUTION_DATE: 'resolutiondate',
    TEXT_AREA: 'com.atlassian.jira.plugin.system.customfieldtypes:textarea',
    UPDATED: 'updated',
    DUE_DATE: 'duedate',
    REPORTER: 'reporter',
    CREATOR: 'creator',
    PRIORITY: 'priority',
    AFFECTS_VERSIONS: 'versions',
    REQUEST_TYPE: 'com.atlassian.servicedesk:vp-origin'
};
const $842e422340bc7efd$export$ce9e2d7c178a9557 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $842e422340bc7efd$export$1adf7afff96bbf16 = 'com.atlassian.jpo:jpo-custom-field-parent';
const $842e422340bc7efd$export$55628b4c44d1522a = 'NATURAL_LANGUAGE_TO_JQL';
const $842e422340bc7efd$export$5575b9e0ed3ff59f = 69; // 2 x 8px cell padding + 2 x 24px icon size + 4px gap + 1px border
const $842e422340bc7efd$export$7c3f559e2ca95fa = 170;
const $842e422340bc7efd$export$e1a42c2fefb5af25 = 999;
const $842e422340bc7efd$export$bfe09a9186b98f8f = 400;
const $842e422340bc7efd$export$f2540f34b796306d = 300;
const $842e422340bc7efd$export$954afb0fcf5a326 = 450;
const $842e422340bc7efd$export$93758649595b2d58 = 'reorder';
const $842e422340bc7efd$export$cad8c6a0b6e78898 = 'resize';
const $842e422340bc7efd$export$754b76ac8fa63350 = 'FULL_HEIGHT';
const $842e422340bc7efd$export$fa5c7dad7ee16383 = 'HEADER_ONLY';

});

parcelRegister("kUSK3", function(module, exports) {

$parcel$export(module.exports, "convertFieldToJqlTerm", () => $7db5cc76eb07592b$export$29f734dc2c61ea9d);
const $7db5cc76eb07592b$export$29f734dc2c61ea9d = (fieldName)=>{
    // custom fields are indexed by their ids and only work with JQL when referenced as such `cf[id]`.
    // fieldName match regex for customfield_<number> exactly
    // legacy gadget may have it stored as customfield_<number> in user prefs
    if (/^customfield_\d+$/.test(fieldName)) {
        const customFieldId = fieldName.split('customfield_')[1];
        return `cf[${customFieldId}]`;
    }
    return fieldName;
};

});

parcelRegister("23KAk", function(module, exports) {

$parcel$export(module.exports, "getAliasesForField", () => $10e5615908db763b$export$94d69942fbe58a01);
const $10e5615908db763b$export$94d69942fbe58a01 = (field, fieldToJqlTermMap)=>{
    // provided field could be a field id, name, an alias, or a jql term
    let term = fieldToJqlTermMap.get(field);
    if (term === undefined) {
        // it may be a jql term itself
        // filter is still an experiment feature in Iterator so we do old school looping
        for (const keyValuePair of fieldToJqlTermMap.entries())if (keyValuePair[1] === field) {
            term = keyValuePair[1];
            break;
        }
    }
    if (term === undefined) return [];
    // we do a reverse look-up to find any other keys of this jql term, they can all be used in a jql
    const set = new Set();
    set.add(term);
    for (const keyValuePair of fieldToJqlTermMap.entries())if (keyValuePair[1] === term) set.add(keyValuePair[0]);
    return Array.from(set);
};

});

parcelRegister("c4HBH", function(module, exports) {

$parcel$export(module.exports, "getSortFieldAndDirection", () => $569edb8b74cacfd6$export$e535bb2dfaa4d10b);
const $569edb8b74cacfd6$export$e535bb2dfaa4d10b = (sortByFromUserPrefs)=>{
    const [sortField, sortDirection] = typeof sortByFromUserPrefs === 'string' ? sortByFromUserPrefs.split(':') : [];
    if (!sortField || sortDirection !== 'ASC' && sortDirection !== 'DESC') return {};
    return {
        sortField: sortField,
        sortDirection: sortDirection
    };
};

});




parcelRegister("5GpvS", function(module, exports) {

$parcel$export(module.exports, "default", () => $329818d7d3f5cc40$export$2e2bcd8739ae039);

var $30HoF = parcelRequire("30HoF");
var $dP4wK = parcelRequire("dP4wK");

var $bMIjq = parcelRequire("bMIjq");
const $329818d7d3f5cc40$var$PROJECTS_DEFINITION = {
    componentView: (0, $30HoF.ProjectsGadgetView),
    componentEdit: (0, $dP4wK.ProjectsGadgetEdit),
    getInitialState: $bMIjq.default,
    preload: $30HoF.preload
};
var $329818d7d3f5cc40$export$2e2bcd8739ae039 = $329818d7d3f5cc40$var$PROJECTS_DEFINITION;

});
parcelRegister("30HoF", function(module, exports) {

$parcel$export(module.exports, "ProjectsGadgetView", () => $a81da7b7d863579b$export$502f0dbb2f2b8d55);
$parcel$export(module.exports, "preload", () => $a81da7b7d863579b$export$513ccb98c53b8039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $k1LnB = parcelRequire("k1LnB");

const $a81da7b7d863579b$var$LazyProjectsGadgetView = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("6FZxn")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/projects-gadget/src/ui/view/main.tsx"
});
const $a81da7b7d863579b$export$502f0dbb2f2b8d55 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "projects-gadget-view",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k1LnB.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a81da7b7d863579b$var$LazyProjectsGadgetView, props));
const { preload: $a81da7b7d863579b$export$513ccb98c53b8039 } = $a81da7b7d863579b$var$LazyProjectsGadgetView;

});
parcelRegister("k1LnB", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $15c356460c85a946$export$8f31e4c4a37b8e9c);

var $eUqFw = parcelRequire("eUqFw");
const $15c356460c85a946$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, "Loading Skeleton");

});

parcelRegister("6FZxn", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('OzN4p')
        ]);
        const value = parcelRequire('gOKvp');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("OzN4p")
    ]).then(()=>parcelRequire('gOKvp'));
}

});


parcelRegister("dP4wK", function(module, exports) {

$parcel$export(module.exports, "ProjectsGadgetEdit", () => $6f14e70b9dd01c2c$export$cc7b6494f64a7b36);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $dx2W9 = parcelRequire("dx2W9");

const $6f14e70b9dd01c2c$export$bac1991ea1aae2f9 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("fH7uR")), {
    moduleId: "./src/packages/global-pages/dashboard/react-gadgets/projects-gadget/src/ui/edit/main.tsx"
});
const $6f14e70b9dd01c2c$export$cc7b6494f64a7b36 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "projects-gadget-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dx2W9.Skeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6f14e70b9dd01c2c$export$bac1991ea1aae2f9, props));

});
parcelRegister("dx2W9", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $2a9f51d8bb10a5ae$export$8f31e4c4a37b8e9c);

var $eUqFw = parcelRequire("eUqFw");
const $2a9f51d8bb10a5ae$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, "Loading Skeleton");

});

parcelRegister("fH7uR", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('4MWYw');
        const value = parcelRequire('2Mu4k');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("4MWYw").then(()=>parcelRequire('2Mu4k'));
}

});


parcelRegister("bMIjq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3167267642f3c24$export$2e2bcd8739ae039);


var $exFVv = parcelRequire("exFVv");
const $d3167267642f3c24$var$getInitialState = (_, projectsGadgetPreferences)=>(0, $exFVv.getProjects)(projectsGadgetPreferences, (0, $6d63ea74347217af$export$cc473923ec12cea6));
var $d3167267642f3c24$export$2e2bcd8739ae039 = $d3167267642f3c24$var$getInitialState;

});
const $6d63ea74347217af$export$8ec3d08588d2eeda = 10;
const $6d63ea74347217af$export$cc473923ec12cea6 = 0;

parcelRegister("exFVv", function(module, exports) {

$parcel$export(module.exports, "validateConfigData", () => $c1e6138e2daf6704$export$4971fde37ed8a104);
$parcel$export(module.exports, "getConfigData", () => $c1e6138e2daf6704$export$257da993075af2c3);
$parcel$export(module.exports, "getProjects", () => $c1e6138e2daf6704$export$b00a271f69f3d728);

var $53ciZ = parcelRequire("53ciZ");

var $lRmyA = parcelRequire("lRmyA");
const $c1e6138e2daf6704$export$4971fde37ed8a104 = async ({ projectsOrCategories: projectsOrCategories, viewType: viewType, cols: cols, maxResults: maxResults, refresh: refresh })=>(0, $lRmyA.performGetRequest)(`/rest/gadget/1.0/project/validateConfiguration?projectsOrCategories=${projectsOrCategories}&viewType=${viewType}&cols=${cols}&maxResults=${maxResults}&refresh=${refresh}`);
const $c1e6138e2daf6704$export$257da993075af2c3 = async ()=>(0, $lRmyA.performGetRequest)('/rest/gadget/1.0/projectsAndProjectCategories');
const $c1e6138e2daf6704$export$b00a271f69f3d728 = async (prefs, startAt)=>{
    const initialValue = {
        startAt: `${startAt}`,
        maxResults: '10',
        projectsOrCategories: 'allprojects',
        showStats: 'false'
    };
    const params = prefs.reduce((acc, userPref)=>{
        let paramName = userPref.name;
        let paramVal = userPref.value;
        if (userPref.name === 'viewType') {
            paramName = 'showStats';
            paramVal = paramVal === 'detailed' ? 'true' : 'false';
        }
        acc[paramName] = `${paramVal}`;
        return acc;
    }, initialValue);
    const urlSearchParams = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(params);
    return (0, $lRmyA.performGetRequest)(`/rest/gadget/1.0/project/generate?${urlSearchParams}`);
};

});



parcelRegister("4j3xD", function(module, exports) {

$parcel$export(module.exports, "REACT_KEY", () => $b0ef36983599a46e$export$e0e89108956f58f6);
// React gadget keys
const $b0ef36983599a46e$export$79f5389fa312a669 = 'react/projects';
const $b0ef36983599a46e$export$8f00b8c7edc21688 = 'react/heatmap';
const $b0ef36983599a46e$export$c8ae0b83405368ed = 'react/filter-results';
const $b0ef36983599a46e$export$d473668bb8826dfe = 'react/assigned-to-me';
const $b0ef36983599a46e$export$e079ced6d62149e8 = 'react/issues-in-progress';
const $b0ef36983599a46e$export$28c72363adc3f53a = 'react/voted-issues';
const $b0ef36983599a46e$export$99faee4082b644a = 'react/watched-issues';
const $b0ef36983599a46e$export$25f168992476ecb5 = 'react/custom-report';
const $b0ef36983599a46e$export$e0e89108956f58f6 = {
    PROJECTS: $b0ef36983599a46e$export$79f5389fa312a669,
    HEATMAP: $b0ef36983599a46e$export$8f00b8c7edc21688,
    FILTER_RESULTS: $b0ef36983599a46e$export$c8ae0b83405368ed,
    ASSIGNED_TO_ME: $b0ef36983599a46e$export$d473668bb8826dfe,
    ISSUES_IN_PROGRESS: $b0ef36983599a46e$export$e079ced6d62149e8,
    VOTED_ISSUES: $b0ef36983599a46e$export$28c72363adc3f53a,
    WATCHED_ISSUES: $b0ef36983599a46e$export$99faee4082b644a,
    CUSTOM_REPORT: $b0ef36983599a46e$export$25f168992476ecb5
};

});




parcelRegister("6wpNP", function(module, exports) {

$parcel$export(module.exports, "default", () => $149a9fbe364280c9$export$2e2bcd8739ae039);

var $lRmyA = parcelRequire("lRmyA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$149a9fbe364280c9$export$2e2bcd8739ae039 = async ()=>(0, $lRmyA.performGetRequest)('/rest/config/1.0/directoryitems.json');

});

parcelRegister("dnvBi", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad61352d29e96931$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $9hXa4 = parcelRequire("9hXa4");

var $iFHrw = parcelRequire("iFHrw");

var $8b1AQ = parcelRequire("8b1AQ");

var $OHYBb = parcelRequire("OHYBb");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ad61352d29e96931$export$2e2bcd8739ae039 = (maybePrevData, sharedValue)=>({ isPrefetch: isPrefetch }, spaContext)=>{
        if (!sharedValue || sharedValue instanceof Error) throw new (0, $8b1AQ.SharedValueAggregateError)({
            sharedValue: sharedValue,
            isPrefetch: isPrefetch,
            name: 'AMD modules resource'
        });
        return (async ()=>{
            const { reactGadgets: nextGadgets } = sharedValue;
            const prev = maybePrevData != null && !(maybePrevData instanceof Error) && maybePrevData.reactGadgetsState || {};
            const persistedGadgets = nextGadgets.filter(({ id: id })=>!!prev[id]);
            const gadgetsToLoad = nextGadgets.filter((gadget)=>{
                // componentEdit will be optional in the future, although currently types say that it's required
                const isConfigurable = !!(0, $iFHrw.default)[gadget.reactKey].componentEdit;
                const isUnconfigured = isConfigurable && !(0, $9hXa4.isGadgetConfigured)(gadget.userPrefs);
                return !prev[gadget.id] && !isUnconfigured;
            });
            const skippedGadgets = nextGadgets.filter((gadget)=>!prev[gadget.id] && !gadgetsToLoad.some(({ id: id })=>id === gadget.id));
            const reactGadgetsState = {
                ...Object.fromEntries(persistedGadgets.map(({ id: id })=>[
                        id,
                        prev[id]
                    ])),
                ...Object.fromEntries(skippedGadgets.map(({ id: id })=>[
                        id,
                        {}
                    ])),
                ...await (0, $OHYBb.loadReactGadgets)(gadgetsToLoad, spaContext)
            };
            return {
                sharedValue: sharedValue,
                reactGadgetsState: reactGadgetsState
            };
        })();
    };

});
parcelRegister("9hXa4", function(module, exports) {

$parcel$export(module.exports, "isGadgetConfigured", () => $63675416148f4e61$export$b625fae487818738);
const $63675416148f4e61$export$b625fae487818738 = (userPrefs)=>userPrefs?.fields.some(({ name: name, value: value })=>name === 'isConfigured' && value === 'true') ?? false;

});

parcelRegister("OHYBb", function(module, exports) {

$parcel$export(module.exports, "loadReactGadgets", () => $187d896eff766e2c$export$7e1a3455761184a2);
// eslint-disable-next-line jira/import-whitelist

var $iFHrw = parcelRequire("iFHrw");
const $187d896eff766e2c$var$preloadGadgetBundles = (reactKeys)=>reactKeys.forEach((reactKey)=>{
        (0, $iFHrw.default)[reactKey].preload();
    });
const $187d896eff766e2c$export$7e1a3455761184a2 = async (gadgets, spaContext)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const distinctReactKeys = [
        ...new Set(gadgets.map((gadget)=>gadget.reactKey))
    ];
    $187d896eff766e2c$var$preloadGadgetBundles(distinctReactKeys);
    return Object.fromEntries(await Promise.all(gadgets.map(({ id: id, reactKey: reactKey, userPrefs: userPrefs })=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $iFHrw.default)[reactKey]?.getInitialState(spaContext, userPrefs?.fields || []).then((state)=>[
                id,
                state
            ], (error)=>[
                id,
                error
            ]))));
};

});



parcelRegister("lMin2", function(module, exports) {

$parcel$export(module.exports, "AVPDashboardRoute", () => $9167559284392d0a$export$7b0006eda2c37dc5);
$parcel$export(module.exports, "dashboardRoute", () => $9167559284392d0a$export$3bf0ecb39349b6ef);
$parcel$export(module.exports, "selectedDashboardRoute", () => $9167559284392d0a$export$b32070ee9554c3fb);
$parcel$export(module.exports, "dashboardEditRoute", () => $9167559284392d0a$export$b6e00d2cd7369fbd);
$parcel$export(module.exports, "dashboardWallboardRoute", () => $9167559284392d0a$export$eaa33c953ab9ca63);
$parcel$export(module.exports, "dashboardViewRoute", () => $9167559284392d0a$export$24f1b2ff97b9d3e6);
$parcel$export(module.exports, "dashboardViewEmbedRoute", () => $9167559284392d0a$export$258b5e3f294617d2);
$parcel$export(module.exports, "systemDashboardEditRoute", () => $9167559284392d0a$export$7367fb465296c7dd);

var $exb0h = parcelRequire("exb0h");
const $9167559284392d0a$export$7b0006eda2c37dc5 = {
    group: (0, $exb0h.ROUTE_GROUPS).DASHBOARD,
    name: (0, $exb0h.ROUTE_NAMES).AVP_DASHBOARDS,
    path: '/jira/avp-dashboards/:dashboardId',
    exact: true
};
const $9167559284392d0a$export$3bf0ecb39349b6ef = {
    group: (0, $exb0h.ROUTE_GROUPS).DASHBOARD,
    name: (0, $exb0h.ROUTE_NAMES).DASHBOARD,
    path: '/secure/Dashboard.jspa'
};
const $9167559284392d0a$export$b32070ee9554c3fb = {
    group: (0, $exb0h.ROUTE_GROUPS).DASHBOARD,
    name: (0, $exb0h.ROUTE_NAMES).DASHBOARD_SELECTED,
    path: '/secure/Dashboard.jspa',
    query: [
        'selectPageId'
    ]
};
const $9167559284392d0a$export$b6e00d2cd7369fbd = {
    group: (0, $exb0h.ROUTE_GROUPS).DASHBOARD,
    name: (0, $exb0h.ROUTE_NAMES).DASHBOARD_EDIT,
    path: '/jira/dashboards/:dashboardId(\\d+)/edit',
    query: [
        'maximized?'
    ],
    exact: true
};
const $9167559284392d0a$export$eaa33c953ab9ca63 = {
    group: (0, $exb0h.ROUTE_GROUPS).DASHBOARD,
    name: (0, $exb0h.ROUTE_NAMES).DASHBOARD_WALLBOARD,
    path: '/jira/dashboards/wallboard',
    query: [
        'dashboardId',
        'cyclePeriod?',
        'transitionFx?',
        'random?'
    ],
    exact: true
};
const $9167559284392d0a$export$24f1b2ff97b9d3e6 = {
    group: (0, $exb0h.ROUTE_GROUPS).DASHBOARD,
    name: (0, $exb0h.ROUTE_NAMES).DASHBOARD_VIEW,
    path: '/jira/dashboards/:dashboardId(\\d+|last-visited)',
    query: [
        'maximized?'
    ],
    exact: true
};
const $9167559284392d0a$export$258b5e3f294617d2 = {
    group: (0, $exb0h.ROUTE_GROUPS).DASHBOARD,
    name: (0, $exb0h.ROUTE_NAMES).DASHBOARD_VIEW_EMBED,
    path: '/jira/dashboards/:dashboardId(\\d+)/embed',
    query: [],
    exact: true
};
const $9167559284392d0a$export$7367fb465296c7dd = {
    group: (0, $exb0h.ROUTE_GROUPS).DASHBOARD,
    name: (0, $exb0h.ROUTE_NAMES).SYSTEM_DASHBOARD_EDIT,
    path: '/secure/admin/EditDefaultDashboard(!default)?.jspa',
    query: [
        'maximized?'
    ]
};

});

parcelRegister("4zrAT", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('dp9cf')
        ]);
        const value = parcelRequire('e1lGQ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("dp9cf")
    ]).then(()=>parcelRequire('e1lGQ'));
}

});

parcelRegister("6hcuv", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('fCdFg')
        ]);
        const value = parcelRequire('bII8J');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("fCdFg")
    ]).then(()=>parcelRequire('bII8J'));
}

});

parcelRegister("btYOv", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('gsMYl')
        ]);
        const value = parcelRequire('4ZoEg');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("gsMYl")
    ]).then(()=>parcelRequire('4ZoEg'));
}

});

parcelRegister("bCVfn", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('70Gv0')
        ]);
        const value = parcelRequire('6R8w9');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("70Gv0")
    ]).then(()=>parcelRequire('6R8w9'));
}

});

parcelRegister("jWcDi", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('ag43H')
        ]);
        const value = parcelRequire('jPbUk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("ag43H")
    ]).then(()=>parcelRequire('jPbUk'));
}

});

parcelRegister("eJuaR", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('VKRg1');
        const value = parcelRequire('fQ2vH');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("VKRg1").then(()=>parcelRequire('fQ2vH'));
}

});

parcelRegister("8lNqP", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('1YjZ5')
        ]);
        const value = parcelRequire('ergSS');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("1YjZ5")
    ]).then(()=>parcelRequire('ergSS'));
}

});

parcelRegister("9qTfJ", function(module, exports) {

$parcel$export(module.exports, "boardsDirectoryResource", () => $d24d57124b25e6ba$export$2646f173fa2c14f2);

var $3HCkE = parcelRequire("3HCkE");

var $6qExu = parcelRequire("6qExu");


const $d24d57124b25e6ba$export$2646f173fa2c14f2 = (0, $3HCkE.createResource)({
    type: (0, $4a3afbc9eff76883$export$87526c4bd9c78abc),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("jCH8u")),
    maxAge: (0, $6qExu.MIN_MAX_AGE)
});

});
const $4a3afbc9eff76883$export$87526c4bd9c78abc = 'BOARDS_DIRECTORY';

parcelRegister("jCH8u", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('cHXPU');
        const value = parcelRequire('a4OMj');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("cHXPU").then(()=>parcelRequire('a4OMj'));
}

});


parcelRegister("6JBWS", function(module, exports) {

$parcel$export(module.exports, "boardsDirectoryRoute", () => $13f76266b580a881$export$f0fc6f4e8be87e85);
$parcel$export(module.exports, "boardsDirectoryRedirectRoute", () => $13f76266b580a881$export$a4fba1ebd6ba91ee);

var $exb0h = parcelRequire("exb0h");
const $13f76266b580a881$export$f0fc6f4e8be87e85 = {
    group: (0, $exb0h.ROUTE_GROUPS).DIRECTORIES,
    name: (0, $exb0h.ROUTE_NAMES).BOARDS_DIRECTORY,
    path: '/jira/boards'
};
const $13f76266b580a881$export$a4fba1ebd6ba91ee = {
    group: (0, $exb0h.ROUTE_GROUPS).DIRECTORIES,
    name: `${(0, $exb0h.ROUTE_NAMES).BOARDS_DIRECTORY}-redirect`,
    path: '/secure/ManageRapidViews.jspa'
};

});

parcelRegister("1usDU", function(module, exports) {

$parcel$export(module.exports, "BoardsDirectorySkeleton", () => $3b79aee5955c0bc4$export$8194d6e87709f042);
$parcel$export(module.exports, "DashboardsDirectorySkeleton", () => $3b79aee5955c0bc4$export$75ef2bfed3801fb1);
$parcel$export(module.exports, "FiltersDirectorySkeleton", () => $3b79aee5955c0bc4$export$e76f94817327da1);
$parcel$export(module.exports, "ProjectsDirectorySkeleton", () => $3b79aee5955c0bc4$export$d94befb0e231760c);
$parcel$export(module.exports, "PlansDirectorySkeleton", () => $3b79aee5955c0bc4$export$6cd26a09efd6d158);

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");

var $34RO7 = parcelRequire("34RO7");

var $1V6NM = parcelRequire("1V6NM");

var $1GvFC = parcelRequire("1GvFC");

var $bcAHP = parcelRequire("bcAHP");
const $3b79aee5955c0bc4$export$8194d6e87709f042 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($34RO7)))
    });
const $3b79aee5955c0bc4$export$75ef2bfed3801fb1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1V6NM)))
    });
const $3b79aee5955c0bc4$export$e76f94817327da1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1GvFC)))
    });
const $3b79aee5955c0bc4$export$d94befb0e231760c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bcAHP)))
    });
const $3b79aee5955c0bc4$export$6cd26a09efd6d158 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bcAHP)))
    });

});
parcelRegister("34RO7", function(module, exports) {
module.exports = new URL("boards-directory-app-skeleton.tpl.e4de30a4.svg", import.meta.url).toString();

});

parcelRegister("1V6NM", function(module, exports) {
module.exports = new URL("dashboards-directory-app-skeleton.tpl.eb730072.svg", import.meta.url).toString();

});

parcelRegister("1GvFC", function(module, exports) {
module.exports = new URL("filters-directory-app-skeleton.tpl.6583ea61.svg", import.meta.url).toString();

});

parcelRegister("bcAHP", function(module, exports) {
module.exports = new URL("projects-directory-app-skeleton.tpl.a21368f6.svg", import.meta.url).toString();

});


parcelRegister("hu1bz", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('7cgo9')
        ]);
        const value = parcelRequire('fHBlZ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("7cgo9")
    ]).then(()=>parcelRequire('fHBlZ'));
}

});

parcelRegister("iREws", function(module, exports) {

$parcel$export(module.exports, "dashboardsDirectoryResource", () => $2052c360610b9396$export$1cf6c7815471c2a2);

var $3HCkE = parcelRequire("3HCkE");

var $6qExu = parcelRequire("6qExu");
const $2052c360610b9396$var$RESOURCE_TYPE_DASHBOARDS_DIRECTORY = 'DASHBOARDS_DIRECTORY';

const $2052c360610b9396$export$1cf6c7815471c2a2 = (0, $3HCkE.createResource)({
    type: $2052c360610b9396$var$RESOURCE_TYPE_DASHBOARDS_DIRECTORY,
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("1RB5T")),
    maxAge: (0, $6qExu.MIN_MAX_AGE)
});

});
parcelRegister("1RB5T", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('2dVaf');
        const value = parcelRequire('1k3Sw');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("2dVaf").then(()=>parcelRequire('1k3Sw'));
}

});


parcelRegister("bLGeo", function(module, exports) {

$parcel$export(module.exports, "dashboardsDirectoryRoute", () => $f1b3b12941e660c6$export$41bba408475cab16);
$parcel$export(module.exports, "dashboardsDirectoryRedirectRoute", () => $f1b3b12941e660c6$export$b96f6fb3c35a6fe5);

var $exb0h = parcelRequire("exb0h");
const $f1b3b12941e660c6$export$41bba408475cab16 = {
    group: (0, $exb0h.ROUTE_GROUPS).DIRECTORIES,
    name: (0, $exb0h.ROUTE_NAMES).DASHBOARDS_DIRECTORY,
    path: '/jira/dashboards'
};
const $f1b3b12941e660c6$export$b96f6fb3c35a6fe5 = {
    group: (0, $exb0h.ROUTE_GROUPS).DIRECTORIES,
    name: (0, $exb0h.ROUTE_NAMES).DASHBOARDS_DIRECTORY_SECURE,
    path: '/secure/ConfigurePortalPages(!default.jspa|.jspa)'
};

});

parcelRegister("kTcEH", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('1XdOR')
        ]);
        const value = parcelRequire('33gr1');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("1XdOR")
    ]).then(()=>parcelRequire('33gr1'));
}

});

parcelRegister("iDevf", function(module, exports) {

$parcel$export(module.exports, "filtersDirectoryResource", () => $84436203ffbd14dd$export$53f99086c62225b6);

var $3HCkE = parcelRequire("3HCkE");

var $6qExu = parcelRequire("6qExu");


const $84436203ffbd14dd$export$53f99086c62225b6 = (0, $3HCkE.createResource)({
    type: (0, $8dba0204efdc0c28$export$79e191bf6cb15284),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("fkDHj")),
    maxAge: (0, $6qExu.MIN_MAX_AGE)
});

});
const $8dba0204efdc0c28$export$79e191bf6cb15284 = 'FILTERS_DIRECTORY';

parcelRegister("fkDHj", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('6bzCP');
        const value = parcelRequire('d7GHs');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("6bzCP").then(()=>parcelRequire('d7GHs'));
}

});


parcelRegister("1cmFR", function(module, exports) {

$parcel$export(module.exports, "filtersDirectoryRoute", () => $c5d476788b048c23$export$6350f52c8b40042d);
$parcel$export(module.exports, "filtersDirectoryRedirectRoute", () => $c5d476788b048c23$export$f4f86e1ddc30a625);
$parcel$export(module.exports, "secureFiltersDirectoryRedirectRoute", () => $c5d476788b048c23$export$50796f2aecd63181);

var $exb0h = parcelRequire("exb0h");
const $c5d476788b048c23$export$6350f52c8b40042d = {
    group: (0, $exb0h.ROUTE_GROUPS).DIRECTORIES,
    name: (0, $exb0h.ROUTE_NAMES).FILTERS_DIRECTORY,
    path: '/jira/filters'
};
const $c5d476788b048c23$export$f4f86e1ddc30a625 = {
    group: (0, $exb0h.ROUTE_GROUPS).DIRECTORIES,
    name: `${(0, $exb0h.ROUTE_NAMES).FILTERS_DIRECTORY}-redirect`,
    path: '/ManageFilters.jspa'
};
const $c5d476788b048c23$export$50796f2aecd63181 = {
    group: (0, $exb0h.ROUTE_GROUPS).DIRECTORIES,
    name: `${(0, $exb0h.ROUTE_NAMES).FILTERS_DIRECTORY_SECURE}-redirect`,
    path: '/secure/ManageFilters.jspa'
};

});

parcelRegister("cezjz", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('dsiAd'),
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('3q9eL')
        ]);
        const value = parcelRequire('gIH1G');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("dsiAd"),
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("3q9eL")
    ]).then(()=>parcelRequire('gIH1G'));
}

});

parcelRegister("jsQSa", function(module, exports) {

$parcel$export(module.exports, "plansDirectoryRoute", () => $31385c3fefa30f13$export$143b4a1ef2ffc051);

var $exb0h = parcelRequire("exb0h");
const $31385c3fefa30f13$export$143b4a1ef2ffc051 = {
    group: (0, $exb0h.ROUTE_GROUPS).DIRECTORIES,
    name: (0, $exb0h.ROUTE_NAMES).PLANS_DIRECTORY,
    path: '/jira/plans'
};

});

parcelRegister("dfmD0", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('f80cy')
        ]);
        const value = parcelRequire('9iDly');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("f80cy")
    ]).then(()=>parcelRequire('9iDly'));
}

});

parcelRegister("dtQ1T", function(module, exports) {

$parcel$export(module.exports, "JiraProjectsTemplateListRightPanel", () => $6f8e08a801c32f02$export$521a9a721c9dad20);
$parcel$export(module.exports, "PANEL_ID", () => (parcelRequire("fvFzs")).PANEL_ID);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $bUi2Q = parcelRequire("bUi2Q");

var $6Rjvl = parcelRequire("6Rjvl");

var $fvFzs = parcelRequire("fvFzs");

var $9ZLvc = parcelRequire("9ZLvc");
const $6f8e08a801c32f02$var$JiraProjectsTemplateListRightPanel = ()=>{
    const rightSidebarCurrentState = (0, $bUi2Q.useActiveRightSidebarState)();
    const { closeRightSidebar: closeRightSidebar } = (0, $bUi2Q.useRightSidebarController)();
    const [localPanelId, setLocalPanelId] = (0, $eUqFw.useState)();
    const prevPanelIdRef = (0, $eUqFw.useRef)();
    const delayRef = (0, $eUqFw.useRef)(undefined);
    const panelId = rightSidebarCurrentState?.panelId;
    /**
	 * This use effect is used to add (when is necessary) a delay
	 * in the panelId => localPanelId syncing
	 */ (0, $eUqFw.useEffect)(()=>{
        clearTimeout(delayRef.current);
        if (prevPanelIdRef.current === (0, $fvFzs.PANEL_ID)) {
            /**
			 * The right-sidebar is showing the templates panel...
			 */ if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) /**
				 * and is open, not collapsed and we want to show a panel
				 * with an ID !== PANEL_ID
				 */ setLocalPanelId(panelId);
            else /**
				 * and we want to close it
				 */ delayRef.current = setTimeout(()=>{
                setLocalPanelId(panelId);
            }, 310);
        } else /**
			 * If the right sidebar is not showing the templates panel,
			 * we just keep localPanelId in sync with panelId
			 */ setLocalPanelId(panelId);
        prevPanelIdRef.current = panelId;
        return ()=>clearTimeout(delayRef.current);
    }, [
        panelId,
        rightSidebarCurrentState
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            closeRightSidebar((0, $fvFzs.PANEL_ID));
        }, [
        closeRightSidebar
    ]);
    if (localPanelId !== (0, $fvFzs.PANEL_ID)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Rjvl.AsyncRightPanel), null);
};
const $6f8e08a801c32f02$export$521a9a721c9dad20 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-sidebar-layout-component",
        packageName: "jiraGrowthRecommendationsInProjectList"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6f8e08a801c32f02$var$JiraProjectsTemplateListRightPanel, null));

});
parcelRegister("6Rjvl", function(module, exports) {

$parcel$export(module.exports, "AsyncRightPanel", () => $992ee0356fdc90ae$export$7ef72c7d51d7de1e);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $2uiE3 = parcelRequire("2uiE3");

var $dWLk9 = parcelRequire("dWLk9");

var $fGZlD = parcelRequire("fGZlD");
const $992ee0356fdc90ae$var$runtimeProps = {};
const $992ee0356fdc90ae$export$7ef72c7d51d7de1e = ()=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $fGZlD.asyncSidebar), {
        cloudId: cloudId
    });
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "right-side-panel",
        packageName: "jiraGrowthRecommendationsInProjectList",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: $992ee0356fdc90ae$var$runtimeProps,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2uiE3.ProjectListSidebarSkeleton), null)
    });
};
var $992ee0356fdc90ae$export$2e2bcd8739ae039 = $992ee0356fdc90ae$export$7ef72c7d51d7de1e;

});
parcelRegister("2uiE3", function(module, exports) {

$parcel$export(module.exports, "ProjectListSidebarSkeleton", () => $7cd5cfa2bb5d5ee4$export$808c25bcc6102427);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");

var $jaZSd = parcelRequire("jaZSd");
const $7cd5cfa2bb5d5ee4$var$customCssStyles = null;
const $7cd5cfa2bb5d5ee4$var$sidebarCssStyles = null;
const $7cd5cfa2bb5d5ee4$export$808c25bcc6102427 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_4t3i1osq _1bsb1gwv _1yt41ejb _1kl71hdd _1h6db5v6 _bfhkvuon _vchhusvi"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jaZSd))),
        className: (0, $7JEyt.default)([
            "_t6vdidpf _hr4jidpf"
        ])
    }));

});
parcelRegister("jaZSd", function(module, exports) {
module.exports = new URL("project-list-sidebar-app-skeleton.tpl.35da4e26.svg", import.meta.url).toString();

});


parcelRegister("fGZlD", function(module, exports) {

$parcel$export(module.exports, "asyncSidebar", () => $e1ca44d7c1cebf1a$export$a9552895baaa7b3b);

var $19XDu = parcelRequire("19XDu");

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $e1ca44d7c1cebf1a$export$a9552895baaa7b3b = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("mileU")), {
        moduleId: "6a9110b2"
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                templatesQueryRef: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $19XDu.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("19XDu", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cdac7441a902a1f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<11dbbfed9a327ddac5983cd37d92a519>>
 * @relayHash c76a04f0efb197379ec3148bdabb1e59
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 24ab56e8e7fea324eaf211464d7582474c267a1fc0077769d24babce145cd574
const $2cdac7441a902a1f$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "24ab56e8e7fea324eaf211464d7582474c267a1fc0077769d24babce145cd574",
        "metadata": {},
        "name": "ui_growthRecommendationsInProjectList_RecommendationsInProjectListQuery",
        "operationKind": "query",
        "text": null
    }
};
var $2cdac7441a902a1f$export$2e2bcd8739ae039 = $2cdac7441a902a1f$var$node;

});

parcelRegister("mileU", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('9DTTg')
        ]);
        const value = parcelRequire('4UUrD');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("9DTTg")
    ]).then(()=>parcelRequire('4UUrD'));
}

});



parcelRegister("fvFzs", function(module, exports) {

$parcel$export(module.exports, "SIDEBAR_WIDTH", () => $6981d6dbe7d33e2d$export$780035d9fe48eb32);
$parcel$export(module.exports, "PANEL_ID", () => $6981d6dbe7d33e2d$export$e1d562d81d0e502d);
$parcel$export(module.exports, "PROJECT_CREATE_SOURCE", () => $6981d6dbe7d33e2d$export$280536374592bda3);
$parcel$export(module.exports, "PROJECT_TYPE_TARGETS_MAP", () => $6981d6dbe7d33e2d$export$990484f4e8c06c90);
$parcel$export(module.exports, "getProductTypeCcpReferenceIdMapForEnv", () => $6981d6dbe7d33e2d$export$29629758934356a6);

var $fbeIa = parcelRequire("fbeIa");

var $8fAH0 = parcelRequire("8fAH0");
const $6981d6dbe7d33e2d$export$780035d9fe48eb32 = 360;
const $6981d6dbe7d33e2d$export$e1d562d81d0e502d = 'recommendationsInProjectList';
const $6981d6dbe7d33e2d$export$675d6d49067be942 = 'recommendationsInProjectListHoverAnchor';
const $6981d6dbe7d33e2d$export$280536374592bda3 = 'recommendationsInProjectList';
const $6981d6dbe7d33e2d$export$990484f4e8c06c90 = {
    BUSINESS: (0, $fbeIa.Targets).JIRA_CORE,
    SOFTWARE: (0, $fbeIa.Targets).JIRA_SOFTWARE,
    SERVICE_DESK: (0, $fbeIa.Targets).JIRA_SERVICE_DESK,
    PRODUCT_DISCOVERY: (0, $fbeIa.Targets).JIRA_PRODUCT_DISCOVERY
};
const $6981d6dbe7d33e2d$export$29629758934356a6 = (environment)=>{
    const env = environment === 'prod' ? 'prod' : 'staging';
    return {
        BUSINESS: (0, $8fAH0.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_work_management_cloud,
        SOFTWARE: (0, $8fAH0.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_software_cloud,
        SERVICE_DESK: (0, $8fAH0.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_service_management_cloud,
        PRODUCT_DISCOVERY: (0, $8fAH0.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_product_discovery
    };
};

});

parcelRegister("9ZLvc", function(module, exports) {

$parcel$export(module.exports, "useSetProjectListRightPanelState", () => $45e01b16e8e32362$export$f7872413c3847449);

var $3agfp = parcelRequire("3agfp");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $guiFP = parcelRequire("guiFP");

var $dWLk9 = parcelRequire("dWLk9");
const $45e01b16e8e32362$var$PROJECT_LIST_RIGHT_PANEL_STATE = 'projectListRightPanelState';
const $45e01b16e8e32362$var$relayStoreUpdater = (store, userPreferencesRefId, state)=>{
    if (typeof userPreferencesRefId === 'string') {
        const record = store.get(userPreferencesRefId);
        record?.setValue(state, $45e01b16e8e32362$var$PROJECT_LIST_RIGHT_PANEL_STATE);
    }
};
const $45e01b16e8e32362$export$f7872413c3847449 = (userPreferencesRefId)=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const [commit] = (0, $iWLL0.useMutation)((0, $3agfp.default));
    const setRightPanelState = (0, $eUqFw.useCallback)((state)=>{
        commit({
            variables: {
                cloudId: cloudId,
                state: state
            },
            optimisticUpdater: (store)=>$45e01b16e8e32362$var$relayStoreUpdater(store, userPreferencesRefId, state),
            updater: (store, { // @ts-expect-error TS-2339 - Property 'jira' does not exist on type 'setRightPanelState_jiraGrowthRecommendationsInProjectList_Mutation$data | null | undefined'.
            jira: { userPreferences: { setProjectListRightPanelState: { projectListRightPanelState: projectListRightPanelState } } } })=>$45e01b16e8e32362$var$relayStoreUpdater(store, userPreferencesRefId, projectListRightPanelState ?? state),
            onCompleted: ({ jira: { // @ts-expect-error(Suppressed for relay bump) - Property 'userPreferences' does not exist on type '{ readonly userPreferences: { readonly setProjectListRightPanelState: { readonly errors: readonly { readonly extensions: { readonly statusCode: number | null | undefined; } | null | undefined; readonly message: string | null | undefined; }[] | null | undefined; readonly projectListRightPanelState: JiraProjectListRig...'.
            userPreferences: { setProjectListRightPanelState: { success: success, errors: errors } } } })=>{
                const error = (errors ?? [])[0];
                if (!success || error) {
                    const errorMessage = `error on set project list right panel state: ${error.message}`;
                    const statusCode = error.extensions?.statusCode;
                    (0, $guiFP.default)({
                        error: new Error(`status code: ${statusCode ?? 'unknown'}, ${errorMessage}`),
                        meta: {
                            id: 'jiraSetProjectListRightPanelStateError',
                            packageName: 'jiraGrowthRecommendationsInProjectList'
                        }
                    });
                }
            },
            onError: (error)=>{
                (0, $guiFP.default)({
                    error: new Error(`jiraSetProjectListRightPanelStateMutationError with ${error.message}`),
                    meta: {
                        id: 'jiraSetProjectListRightPanelStateMutationError',
                        packageName: 'jiraGrowthRecommendationsInProjectList'
                    }
                });
            }
        });
    }, [
        cloudId,
        commit,
        userPreferencesRefId
    ]);
    return setRightPanelState;
};

});
parcelRegister("3agfp", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed9c7ca4637149ec$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c8924225fbaebda7025f7aa64552136f>>
 * @relayHash 5973af1b2d1563ce911ce146c47dea31
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 10d5ea76c78552819f8d9cf123cfeafc68ca6ec2fff776b982918fe274f13683
const $ed9c7ca4637149ec$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "state"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "state",
            "variableName": "state"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "kind": "ScalarField",
        "name": "projectListRightPanelState"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "setRightPanelState_jiraGrowthRecommendationsInProjectList_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUserPreferencesMutation",
                            "kind": "LinkedField",
                            "name": "userPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraProjectListRightPanelStateMutationPayload",
                                    "kind": "LinkedField",
                                    "name": "setProjectListRightPanelState",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "concreteType": "MutationError",
                                            "kind": "LinkedField",
                                            "name": "errors",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                v5 /*: any*/ 
                                            ]
                                        },
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "setRightPanelState_jiraGrowthRecommendationsInProjectList_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUserPreferencesMutation",
                            "kind": "LinkedField",
                            "name": "userPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraProjectListRightPanelStateMutationPayload",
                                    "kind": "LinkedField",
                                    "name": "setProjectListRightPanelState",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "concreteType": "MutationError",
                                            "kind": "LinkedField",
                                            "name": "errors",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                v5 /*: any*/ 
                                            ]
                                        },
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "10d5ea76c78552819f8d9cf123cfeafc68ca6ec2fff776b982918fe274f13683",
            "metadata": {},
            "name": "setRightPanelState_jiraGrowthRecommendationsInProjectList_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$ed9c7ca4637149ec$var$node.hash = "1cbcdd010c06eb6470327729729fba37";
var $ed9c7ca4637149ec$export$2e2bcd8739ae039 = $ed9c7ca4637149ec$var$node;

});



parcelRegister("610DX", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryPageResource", () => $91523910c17f4c22$export$aabb201a7f7100c5);
/* eslint-disable jira/import-whitelist */ 
var $iWLL0 = parcelRequire("iWLL0");

var $exb0h = parcelRequire("exb0h");

var $79xbN = parcelRequire("79xbN");

var $daNZX = parcelRequire("daNZX");

var $3FXyY = parcelRequire("3FXyY");

var $amu7D = parcelRequire("amu7D");

var $c7ifG = parcelRequire("c7ifG");

var $buJlM = parcelRequire("buJlM");

var $vRTdL = parcelRequire("vRTdL");

var $3HCkE = parcelRequire("3HCkE");

const $91523910c17f4c22$export$aabb201a7f7100c5 = (0, $3HCkE.createResource)({
    type: `${(0, $buJlM.RELAY_RESOURCE_TYPE)}_${(0, $5e9f37eb5f02fe12$export$2150caade62dc875)}`,
    getKey: ()=>'projects-directory-relay',
    // @ts-expect-error - might return null
    getData: async ({ query: query, route: route }, { tenantContext: tenantContext })=>{
        const { cloudId: cloudId, isAnonymous: isAnonymous } = tenantContext;
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should temporally disable anonymous SSR until
        // the underlying auth issues have been fixed. Duplo team will push the real fix later.
        if (false && isAnonymous) return null;
        const queryReference = (0, $iWLL0.loadQuery)((0, $amu7D.default), (0, $vRTdL.default), {
            cloudId: tenantContext.cloudId,
            filter: (0, $3FXyY.mapQueryToFilter)((0, $daNZX.filterInitialState), {
                cloudId: cloudId,
                query: (0, $3FXyY.sanitizeLegacyQuery)(query),
                aliases: (0, $daNZX.filterAliasMap)
            }),
            first: query?.page ? (0, $daNZX.DEFAULT_LIMIT) * (parseInt(query.page, 10) || 1) : (0, $daNZX.DEFAULT_LIMIT),
            last: (0, $daNZX.DEFAULT_LIMIT),
            isAdminSettingsContext: route.name === (0, $exb0h.ROUTE_NAMES).PROJECTS_DIRECTORY_MANAGE,
            isAnonymous: isAnonymous,
            isProjectListSidebarExperimentEnabled: (0, $79xbN.expValEquals)('contextual_bandits_reccs_in_projects_directory', 'cohort', 'variation')
        }, {
            fetchPolicy: 'network-only'
        });
        if (false && queryReference.id != null) await (0, $c7ifG.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    }
});

});
parcelRegister("daNZX", function(module, exports) {

$parcel$export(module.exports, "TableColumnsOld", () => $f73827788bb95cac$export$b678950a832d5515);
$parcel$export(module.exports, "TableColumnsNew", () => $f73827788bb95cac$export$d2f0e4081fed2530);
$parcel$export(module.exports, "SortableColumnsOld", () => $f73827788bb95cac$export$eafcea6473c0d8a6);
$parcel$export(module.exports, "SortableColumnsNew", () => $f73827788bb95cac$export$5fac729dce73ac3a);
$parcel$export(module.exports, "FilterFields", () => $f73827788bb95cac$export$e38c2fbdcbc20613);
$parcel$export(module.exports, "filterAliasMap", () => $f73827788bb95cac$export$5bc0ad9873e5cd89);
$parcel$export(module.exports, "filterInitialState", () => $f73827788bb95cac$export$fcb7b3e474e67781);
$parcel$export(module.exports, "DEFAULT_LIMIT", () => $f73827788bb95cac$export$ebc5ec3267fbcf57);
$parcel$export(module.exports, "PROJECTS_DIRECTORY_EXPERIENCE", () => $f73827788bb95cac$export$7c1bd7128901e2c4);
$parcel$export(module.exports, "MANAGE_PROJECTS_DIRECTORY_EXPERIENCE", () => $f73827788bb95cac$export$72fb94bf1b8ec849);
// eslint-disable-next-line jira/import-whitelist

var $dlza3 = parcelRequire("dlza3");
const $f73827788bb95cac$export$b678950a832d5515 = {
    Favourites: 'favourites',
    Key: 'key',
    Name: 'name',
    Type: 'type',
    Lead: 'lead',
    Category: 'category',
    LastIssueUpdate: 'last_issue_updated_time',
    Url: 'url',
    Action: 'actions'
};
const $f73827788bb95cac$export$d2f0e4081fed2530 = {
    ...$f73827788bb95cac$export$b678950a832d5515,
    Favourites: 'favourite'
};
const $f73827788bb95cac$export$eafcea6473c0d8a6 = [
    $f73827788bb95cac$export$b678950a832d5515.Key,
    $f73827788bb95cac$export$b678950a832d5515.Name,
    $f73827788bb95cac$export$b678950a832d5515.Lead,
    $f73827788bb95cac$export$b678950a832d5515.Category,
    $f73827788bb95cac$export$b678950a832d5515.LastIssueUpdate
];
const $f73827788bb95cac$export$5fac729dce73ac3a = [
    $f73827788bb95cac$export$d2f0e4081fed2530.Favourites,
    $f73827788bb95cac$export$d2f0e4081fed2530.Key,
    $f73827788bb95cac$export$d2f0e4081fed2530.Name,
    $f73827788bb95cac$export$d2f0e4081fed2530.Lead,
    $f73827788bb95cac$export$d2f0e4081fed2530.Category,
    $f73827788bb95cac$export$d2f0e4081fed2530.LastIssueUpdate
];
const $f73827788bb95cac$export$e38c2fbdcbc20613 = {
    Keyword: 'keyword',
    ProjectType: 'types',
    ProjectTypeLabel: 'ProjectTypeLabel',
    ProjectCategoryId: 'projectCategoryId',
    ProjectCategoryLabel: 'projectCategoryLabel',
    ...(0, $dlza3.DefaultFilterFields)
};
const $f73827788bb95cac$export$5bc0ad9873e5cd89 = {
    contains: $f73827788bb95cac$export$e38c2fbdcbc20613.Keyword,
    selectedProjectType: $f73827788bb95cac$export$e38c2fbdcbc20613.ProjectType,
    selectedCategory: $f73827788bb95cac$export$e38c2fbdcbc20613.ProjectCategoryId
};
const $f73827788bb95cac$export$fcb7b3e474e67781 = {
    [$f73827788bb95cac$export$e38c2fbdcbc20613.Keyword]: '',
    [$f73827788bb95cac$export$e38c2fbdcbc20613.ProjectType]: '',
    [$f73827788bb95cac$export$e38c2fbdcbc20613.ProjectTypeLabel]: '',
    [$f73827788bb95cac$export$e38c2fbdcbc20613.ProjectCategoryId]: '',
    [$f73827788bb95cac$export$e38c2fbdcbc20613.ProjectCategoryLabel]: '',
    [$f73827788bb95cac$export$e38c2fbdcbc20613.SortOrder]: 'ASC',
    [$f73827788bb95cac$export$e38c2fbdcbc20613.SortKey]: $f73827788bb95cac$export$d2f0e4081fed2530.Name,
    [$f73827788bb95cac$export$e38c2fbdcbc20613.Page]: '1'
};
const $f73827788bb95cac$export$ebc5ec3267fbcf57 = 25;
const $f73827788bb95cac$export$7c1bd7128901e2c4 = 'viewProjectsDirectoryV3';
const $f73827788bb95cac$export$72fb94bf1b8ec849 = 'viewManageProjectsDirectoryV3';

});
parcelRegister("dlza3", function(module, exports) {

$parcel$export(module.exports, "DefaultFilterFields", () => $e1b4b912fa01d011$export$7ecdd4b6ae40e139);
$parcel$export(module.exports, "createUseFilter", () => $e1b4b912fa01d011$export$ef79d9c1dcb09f8f);

var $53ciZ = parcelRequire("53ciZ");

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $guiFP = parcelRequire("guiFP");
const $e1b4b912fa01d011$export$7ecdd4b6ae40e139 = {
    // sorting
    SortOrder: 'sortOrder',
    SortKey: 'sortKey',
    // pagination
    Page: 'page'
};
const $e1b4b912fa01d011$export$ef79d9c1dcb09f8f = (storeName, { getInitialState: getInitialState })=>{
    const actions = {
        updateFilter: (nameOrFilter, value)=>({ setState: setState, getState: getState }, { onUpdate: onUpdate })=>{
                const newFilter = typeof nameOrFilter === 'object' ? nameOrFilter : {
                    [nameOrFilter]: value
                };
                setState({
                    ...getState(),
                    [$e1b4b912fa01d011$export$7ecdd4b6ae40e139.Page]: 1,
                    ...newFilter
                });
                onUpdate(getState());
            },
        forceUpdate: ()=>({ getState: getState }, { onUpdate: onUpdate })=>onUpdate(getState())
    };
    const Store = (0, $a61MH.createStore)({
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        initialState: {},
        actions: actions,
        name: storeName
    });
    const useFilter = (0, $ggKAj.createHook)(Store);
    const useScopedFilter = (0, $ggKAj.createHook)(Store, {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        selector: (state, name)=>state[name]
    });
    const FilterContainer = (0, $heB5U.createContainer)(Store, {
        onInit: ()=>({ setState: setState })=>{
                try {
                    const routeQuery = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(window.location.search);
                    setState(getInitialState({
                        routeQuery: routeQuery
                    }));
                } catch (error) {
                    (0, $guiFP.default)({
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        error: error,
                        meta: {
                            id: 'createUseFilter',
                            packageName: 'jiraDirectoryBaseV3',
                            teamName: 'jira-cosmos'
                        }
                    });
                }
            },
        // reset initial state on unmount
        onCleanup: ()=>({ setState: setState })=>setState(getInitialState({
                    routeQuery: {}
                }))
    });
    return {
        useFilter: useFilter,
        useScopedFilter: useScopedFilter,
        FilterContainer: FilterContainer
    };
};

});


parcelRegister("3FXyY", function(module, exports) {

$parcel$export(module.exports, "sanitizeLegacyQuery", () => $f0ffb937191aeb5a$export$b6d5141c3209bd35);
$parcel$export(module.exports, "mapQueryToFilter", () => $f0ffb937191aeb5a$export$2274cd5f35844a96);

var $7ZZxN = parcelRequire("7ZZxN");

var $9yLt7 = parcelRequire("9yLt7");

var $1ybV0 = parcelRequire("1ybV0");

var $huI7r = parcelRequire("huI7r");

var $daNZX = parcelRequire("daNZX");
const $f0ffb937191aeb5a$var$LEGACY_ALL_VALUE = 'all';
const $f0ffb937191aeb5a$export$b6d5141c3209bd35 = (query)=>({
        ...query,
        selectedProjectType: query.selectedProjectType === $f0ffb937191aeb5a$var$LEGACY_ALL_VALUE ? (0, $daNZX.filterInitialState)[(0, $daNZX.FilterFields).ProjectType] : query.selectedProjectType,
        selectedCategory: query.selectedCategory === $f0ffb937191aeb5a$var$LEGACY_ALL_VALUE ? (0, $daNZX.filterInitialState)[(0, $daNZX.FilterFields).ProjectCategoryId] : query.selectedCategory
    });
const $f0ffb937191aeb5a$export$2274cd5f35844a96 = (filter, { cloudId: cloudId, query: query, aliases: aliases })=>{
    const variables = {};
    const { [(0, $daNZX.FilterFields).Keyword]: keyword, [(0, $daNZX.FilterFields).ProjectCategoryId]: projectCategoryId, [(0, $daNZX.FilterFields).ProjectType]: types, [(0, $daNZX.FilterFields).SortOrder]: sortOrder, [(0, $daNZX.FilterFields).SortKey]: sortKey } = aliases && query ? (0, $9yLt7.matchAliases)(filter, query, aliases) : filter; // eslint-disable-line @typescript-eslint/consistent-type-assertions
    if (keyword) variables.keyword = keyword;
    if (projectCategoryId) variables.projectCategoryId = (0, $huI7r.isAri)(projectCategoryId) ? projectCategoryId : (0, $huI7r.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'project-category',
        resourceId: projectCategoryId
    });
    if (sortKey || sortOrder) {
        const SortableColumns = (0, $1ybV0.ff)('a11y-jira-team.projects-directory-v3.enable-sorting-by-starred-column') ? (0, $daNZX.SortableColumnsNew) : (0, $daNZX.SortableColumnsOld);
        const sortByValue = sortKey && SortableColumns.includes(sortKey) ? sortKey : (0, $daNZX.filterInitialState)[(0, $daNZX.FilterFields).SortKey];
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        variables.sortBy = {
            order: [
                'ASC',
                'DESC'
            ].includes(sortOrder) ? sortOrder : (0, $daNZX.filterInitialState)[(0, $daNZX.FilterFields).SortOrder],
            sortBy: sortByValue.toUpperCase()
        };
    }
    if (types && typeof types === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    variables.types = types.split(',') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .filter((type)=>(0, $7ZZxN.PROJECT_TYPES).includes(type)).map((type)=>type.toUpperCase());
    return variables;
};

});
parcelRegister("9yLt7", function(module, exports) {

$parcel$export(module.exports, "matchAliases", () => $eb4bb5ada87cd343$export$55f686d7a3507dbe);
$parcel$export(module.exports, "serializeSelectOptions", () => $eb4bb5ada87cd343$export$74a705e0bee1565b);
$parcel$export(module.exports, "serializeSelectOptionsLabel", () => $eb4bb5ada87cd343$export$eed751fcc55ddadd);
$parcel$export(module.exports, "matchValueToSelectOptions", () => $eb4bb5ada87cd343$export$17e142fa55464467);

var $aXGkF = parcelRequire("aXGkF");

var $cnRoI = parcelRequire("cnRoI");
const $eb4bb5ada87cd343$export$55f686d7a3507dbe = (filterState, query, aliases)=>Object.keys(query).reduce((filter, key)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const alias = aliases[key];
        const queryValue = query[key];
        const hasInitialValue = filter[key] !== undefined;
        // override default filter value with query params
        if (hasInitialValue && queryValue) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-param-reassign
            filter[key] = queryValue;
            return filter;
        }
        // if there's no alias and no query param for it return default filter
        if (!alias || !queryValue) return filter;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-param-reassign
        filter[alias] = queryValue;
        return filter;
    }, {
        ...filterState
    });
const $eb4bb5ada87cd343$export$40bf1812f0f07002 = (data, aliases)=>{
    const invertedAliases = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))(aliases);
    return (0, (/*@__PURE__*/$parcel$interopDefault($cnRoI)))(data, (_, key)=>invertedAliases[key] || key);
};
const $eb4bb5ada87cd343$export$74a705e0bee1565b = (options)=>options.map((v)=>v.value).join(',');
const $eb4bb5ada87cd343$export$eed751fcc55ddadd = (options)=>options.map((v)=>v.label).join(',');
const $eb4bb5ada87cd343$export$17e142fa55464467 = (value, options)=>value ? value.split(',').map((val)=>options.find((option)=>option.value === val)).filter(Boolean) : [];

});
parcelRegister("aXGkF", function(module, exports) {

var $CAsD5 = parcelRequire("CAsD5");

var $eQ67w = parcelRequire("eQ67w");

var $3QMTK = parcelRequire("3QMTK");
/** Used for built-in method references. */ var $7fb0405f6a745d75$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $7fb0405f6a745d75$var$nativeObjectToString = $7fb0405f6a745d75$var$objectProto.toString;
/**
 * Creates an object composed of the inverted keys and values of `object`.
 * If `object` contains duplicate values, subsequent values overwrite
 * property assignments of previous values.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Object
 * @param {Object} object The object to invert.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invert(object);
 * // => { '1': 'c', '2': 'b' }
 */ var $7fb0405f6a745d75$var$invert = $eQ67w(function(result, value, key) {
    if (value != null && typeof value.toString != 'function') value = $7fb0405f6a745d75$var$nativeObjectToString.call(value);
    result[value] = key;
}, $CAsD5($3QMTK));
module.exports = $7fb0405f6a745d75$var$invert;

});
parcelRegister("eQ67w", function(module, exports) {

var $im19c = parcelRequire("im19c");
/**
 * Creates a function like `_.invertBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} toIteratee The function to resolve iteratees.
 * @returns {Function} Returns the new inverter function.
 */ function $acdaab61bed7cb96$var$createInverter(setter, toIteratee) {
    return function(object, iteratee) {
        return $im19c(object, setter, toIteratee(iteratee), {});
    };
}
module.exports = $acdaab61bed7cb96$var$createInverter;

});
parcelRegister("im19c", function(module, exports) {

var $piimr = parcelRequire("piimr");
/**
 * The base implementation of `_.invert` and `_.invertBy` which inverts
 * `object` with values transformed by `iteratee` and set by `setter`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform values.
 * @param {Object} accumulator The initial inverted object.
 * @returns {Function} Returns `accumulator`.
 */ function $d5cb2bea9036f464$var$baseInverter(object, setter, iteratee, accumulator) {
    $piimr(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
    });
    return accumulator;
}
module.exports = $d5cb2bea9036f464$var$baseInverter;

});





parcelRegister("vRTdL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5d472e531f33745$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9b4d660fa121106894566a8cee5dc980>>
 * @relayHash 33443d3c71a93e19039c1ddf91e01c8b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 662fd8d1f9c5eb8fd7858db090e25a7b50b561452bb8cf112ce7e305b62eb98f

var $cNy9K = parcelRequire("cNy9K");
const $a5d472e531f33745$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experimentKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isAdminSettingsContext"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isAnonymous"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isProjectListSidebarExperimentEnabled"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v8 = {
        "kind": "Variable",
        "name": "isAnonymous",
        "variableName": "isAnonymous"
    }, v9 = {
        "kind": "Variable",
        "name": "experimentKey",
        "variableName": "experimentKey"
    }, v10 = [
        v8 /*: any*/ 
    ], v11 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v12 = {
        "alias": "canBrowseProjects",
        "args": [
            v11 /*: any*/ ,
            {
                "kind": "Literal",
                "name": "type",
                "value": "BROWSE_PROJECTS"
            }
        ],
        "concreteType": "JiraPermission",
        "kind": "LinkedField",
        "name": "permission",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasPermission"
            }
        ]
    }, v13 = [
        v11 /*: any*/ 
    ], v14 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ], v15 = {
        "kind": "ScalarField",
        "name": "id"
    }, v16 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v17 = {
        "kind": "ScalarField",
        "name": "name"
    }, v18 = {
        "kind": "ScalarField",
        "name": "key"
    }, v19 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v20 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v21 = {
        "kind": "ScalarField",
        "name": "projectListRightPanelState"
    }, v22 = {
        "alias": "sidebarExperimentTemplates",
        "args": [
            v11 /*: any*/ ,
            {
                "kind": "Literal",
                "name": "experimentKey",
                "value": "sidebarExperiment"
            }
        ],
        "concreteType": "JiraProjectListViewTemplateConnection",
        "kind": "LinkedField",
        "name": "projectListViewTemplates",
        "plural": false,
        "selections": [
            v20 /*: any*/ 
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "productKey"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "pageLayout_projectsDirectoryLayout_RootQuery",
            "selections": [
                {
                    "args": [
                        v8 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "isProjectListSidebarExperimentEnabled",
                            "variableName": "isProjectListSidebarExperimentEnabled"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "header_projectsDirectoryV3"
                },
                {
                    "condition": "isProjectListSidebarExperimentEnabled",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": [
                                v9 /*: any*/ ,
                                v8 /*: any*/ 
                            ],
                            "kind": "FragmentSpread",
                            "name": "topTemplatePicker_projectsDirectoryV3"
                        }
                    ]
                },
                {
                    "args": v10 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "refinementBar_projectsDirectoryV3_Filters"
                },
                {
                    "args": v10 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "projectsList_projectsDirectoryV3_rootQueryRef"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isAdminSettingsContext",
                            "variableName": "isAdminSettingsContext"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "pageLayout_projectsDirectoryV3_ProjectDirectoryLayout"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "emptyView_projectsDirectoryV3"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "noPermissionViews_projectsDirectoryV3"
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ 
                    ]
                },
                {
                    "condition": "isProjectListSidebarExperimentEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "condition": "isAnonymous",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "rightPanel_projectsDirectoryV3_ShouldShowRightSidebar"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v7 /*: any*/ ,
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "pageLayout_projectsDirectoryLayout_RootQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "canCreateProject",
                            "args": [
                                v11 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "CREATE_PROJECT"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "canPerform"
                        },
                        {
                            "args": v13 /*: any*/ ,
                            "concreteType": "JiraWorkManagementLicensing",
                            "kind": "LinkedField",
                            "name": "jwmLicensing",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "currentUserSeatEdition"
                                }
                            ]
                        },
                        {
                            "args": [
                                v11 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "filter",
                                    "variableName": "filter"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "first",
                                    "variableName": "first"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "last",
                                    "variableName": "last"
                                }
                            ],
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": "canViewIssue",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "type",
                                                            "value": "VIEW_ISSUES"
                                                        }
                                                    ],
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": v14 /*: any*/ ,
                                                    "storageKey": "action(type:\"VIEW_ISSUES\")"
                                                },
                                                v15 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraFavouriteValue",
                                                    "kind": "LinkedField",
                                                    "name": "favouriteValue",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isFavourite"
                                                        },
                                                        v16 /*: any*/ ,
                                                        v15 /*: any*/ 
                                                    ]
                                                },
                                                v17 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraAvatar",
                                                    "kind": "LinkedField",
                                                    "name": "avatar",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "medium"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectStyle"
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "navigationMetadata",
                                                    "plural": false,
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "boardId"
                                                                },
                                                                v15 /*: any*/ 
                                                            ],
                                                            "type": "JiraSoftwareProjectNavigationMetadata"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "queueId"
                                                                }
                                                            ],
                                                            "type": "JiraServiceManagementProjectNavigationMetadata"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectType"
                                                },
                                                {
                                                    "concreteType": "JiraProjectCategory",
                                                    "kind": "LinkedField",
                                                    "name": "category",
                                                    "plural": false,
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v15 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "lead",
                                                    "plural": false,
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        {
                                                            "kind": "TypeDiscriminator",
                                                            "abstractKey": "__isUser"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "accountId"
                                                        },
                                                        v17 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "picture"
                                                        },
                                                        v15 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "condition": "isAdminSettingsContext",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "alias": "lastUpdatedToolTipDate",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "format",
                                                                    "value": "COMPLETE_DATETIME_FORMAT"
                                                                }
                                                            ],
                                                            "kind": "ScalarField",
                                                            "name": "lastUpdatedFormatted",
                                                            "storageKey": "lastUpdatedFormatted(format:\"COMPLETE_DATETIME_FORMAT\")"
                                                        },
                                                        {
                                                            "alias": "lastUpdatedDisplayDate",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "format",
                                                                    "value": "RELATIVE"
                                                                }
                                                            ],
                                                            "kind": "ScalarField",
                                                            "name": "lastUpdatedFormatted",
                                                            "storageKey": "lastUpdatedFormatted(format:\"RELATIVE\")"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectUrl"
                                                },
                                                {
                                                    "alias": "canEdit",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "type",
                                                            "value": "EDIT_PROJECT_CONFIG"
                                                        }
                                                    ],
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": v14 /*: any*/ ,
                                                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                                },
                                                {
                                                    "alias": "jiraProjectType",
                                                    "kind": "ScalarField",
                                                    "name": "projectType"
                                                },
                                                {
                                                    "alias": "jiraProjectName",
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v20 /*: any*/ ,
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isHasTotal"
                                }
                            ]
                        },
                        {
                            "alias": "canContactAdmin",
                            "args": [
                                v11 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": "jira.show.contact.administrators.form"
                                }
                            ],
                            "concreteType": "JiraApplicationProperty",
                            "kind": "LinkedField",
                            "name": "applicationPropertiesByKey",
                            "plural": true,
                            "selections": [
                                v18 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                },
                                v15 /*: any*/ 
                            ]
                        },
                        v12 /*: any*/ ,
                        {
                            "condition": "isProjectListSidebarExperimentEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "condition": "isAnonymous",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "args": v13 /*: any*/ ,
                                            "concreteType": "JiraUserPreferences",
                                            "kind": "LinkedField",
                                            "name": "userPreferences",
                                            "plural": false,
                                            "selections": [
                                                v21 /*: any*/ ,
                                                v16 /*: any*/ 
                                            ]
                                        },
                                        v22 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isAnonymous",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": v13 /*: any*/ ,
                                    "concreteType": "JiraProjectCategoryConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjectCategories",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectCategoryEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v19 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isAnonymous",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": v13 /*: any*/ ,
                                    "concreteType": "JiraProjectCategoryConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjectCategories",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectCategoryEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v19 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraProjectCategory",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v15 /*: any*/ ,
                                                        v17 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v13 /*: any*/ ,
                            "concreteType": "JiraProjectTypeDetailsConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjectTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectTypeDetailsEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectTypeDetails",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                v15 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isProjectListSidebarExperimentEnabled",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v13 /*: any*/ ,
                                    "concreteType": "JiraUserSegmentation",
                                    "kind": "LinkedField",
                                    "name": "userSegmentation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "teamType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "role"
                                        }
                                    ]
                                },
                                {
                                    "condition": "isAnonymous",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "args": [
                                                v11 /*: any*/ ,
                                                v9 /*: any*/ 
                                            ],
                                            "concreteType": "JiraProjectListViewTemplateConnection",
                                            "kind": "LinkedField",
                                            "name": "projectListViewTemplates",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProjectListViewTemplateItem",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v23 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraProjectListViewTemplateEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraProjectListViewTemplateItem",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v18 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "title"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isLastUsed"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isPremiumOnly"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "iconUrl"
                                                                },
                                                                v23 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isProductLicensed"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isProjectListSidebarExperimentEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "condition": "isAnonymous",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "concreteType": "JiraQuery",
                                    "kind": "LinkedField",
                                    "name": "jira",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v13 /*: any*/ ,
                                            "concreteType": "JiraUserPreferences",
                                            "kind": "LinkedField",
                                            "name": "userPreferences",
                                            "plural": false,
                                            "selections": [
                                                v21 /*: any*/ 
                                            ]
                                        },
                                        v22 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "662fd8d1f9c5eb8fd7858db090e25a7b50b561452bb8cf112ce7e305b62eb98f",
            "metadata": {},
            "name": "pageLayout_projectsDirectoryLayout_RootQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a5d472e531f33745$var$node.hash = "70d8bd88a64189d072b9fdc1ceed863a";
(0, $cNy9K.PreloadableQueryRegistry).set($a5d472e531f33745$var$node.params.id, $a5d472e531f33745$var$node);
var $a5d472e531f33745$export$2e2bcd8739ae039 = $a5d472e531f33745$var$node;

});

const $5e9f37eb5f02fe12$export$2150caade62dc875 = 'PROJECTS_DIRECTORY_RELAY';


parcelRegister("1iihP", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryRoute", () => $24be186849539eb4$export$74114064f06cd71b);
$parcel$export(module.exports, "manageProjectsDirectoryRoute", () => $24be186849539eb4$export$281a4490a0f8fb4c);
$parcel$export(module.exports, "projectsDirectoryRedirectRoute", () => $24be186849539eb4$export$d44f1be3782f0fde);
$parcel$export(module.exports, "projectsDirectoryLegacyPathRedirectRoute", () => $24be186849539eb4$export$c713f57300a82898);
$parcel$export(module.exports, "projectsDirectoryManageRedirectRoute", () => $24be186849539eb4$export$dbd3b6c012e8b6dc);
$parcel$export(module.exports, "projectsDirectoryManageRootRedirectRoute", () => $24be186849539eb4$export$4531e3b2e25fad23);

var $exb0h = parcelRequire("exb0h");
const $24be186849539eb4$export$74114064f06cd71b = {
    group: (0, $exb0h.ROUTE_GROUPS).DIRECTORIES,
    name: (0, $exb0h.ROUTE_NAMES).PROJECTS_DIRECTORY,
    path: '/jira/projects',
    exact: true
};
const $24be186849539eb4$export$281a4490a0f8fb4c = {
    group: (0, $exb0h.ROUTE_GROUPS).DIRECTORIES,
    name: (0, $exb0h.ROUTE_NAMES).PROJECTS_DIRECTORY_MANAGE,
    path: '/jira/settings/projects/manage'
};
const $24be186849539eb4$export$d44f1be3782f0fde = {
    group: (0, $exb0h.ROUTE_GROUPS).DIRECTORIES,
    name: `${(0, $exb0h.ROUTE_NAMES).PROJECTS_DIRECTORY}-redirect`,
    path: '/projects',
    exact: true
};
const $24be186849539eb4$export$c713f57300a82898 = {
    group: (0, $exb0h.ROUTE_GROUPS).DIRECTORIES,
    name: `${(0, $exb0h.ROUTE_NAMES).PROJECTS_DIRECTORY_LEGACY_PATH_SPA}-redirect`,
    path: '/secure/BrowseProjects.jspa'
};
const $24be186849539eb4$export$dbd3b6c012e8b6dc = {
    name: `${(0, $exb0h.ROUTE_NAMES).PROJECTS_DIRECTORY_MANAGE}-redirect`,
    path: '/secure/project/ViewProjects.jspa'
};
const $24be186849539eb4$export$4531e3b2e25fad23 = {
    name: `${(0, $exb0h.ROUTE_NAMES).PROJECTS_DIRECTORY_MANAGE}-root-redirect`,
    path: '/jira/settings/projects',
    exact: true
};

});

parcelRegister("jTDO7", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('7jovu')
        ]);
        const value = parcelRequire('aFSMB');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("7jovu")
    ]).then(()=>parcelRequire('aFSMB'));
}

});

parcelRegister("3a2nq", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('k0ssa')
        ]);
        const value = parcelRequire('7vk58');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("k0ssa")
    ]).then(()=>parcelRequire('7vk58'));
}

});

parcelRegister("lSIIo", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('4twcM')
        ]);
        const value = parcelRequire('eODRa');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("4twcM")
    ]).then(()=>parcelRequire('eODRa'));
}

});

parcelRegister("k2rA6", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('3Zawb');
        const value = parcelRequire('cWSzA');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("3Zawb").then(()=>parcelRequire('cWSzA'));
}

});

parcelRegister("7qhPD", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('4bt51');
        const value = parcelRequire('g8AUr');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("4bt51").then(()=>parcelRequire('g8AUr'));
}

});

parcelRegister("ad7aK", function(module, exports) {

$parcel$export(module.exports, "resources", () => $76f0ae8e9950463c$export$bc99aaabaf7b70a7);

var $lJcHb = parcelRequire("lJcHb");

var $5udCV = parcelRequire("5udCV");
const $76f0ae8e9950463c$export$bc99aaabaf7b70a7 = {
    configuredSyncsResource: $lJcHb.configuredSyncsResource,
    userAccessRightsResource: $5udCV.userAccessRightsResource
};

});
parcelRegister("lJcHb", function(module, exports) {

$parcel$export(module.exports, "configuredSyncsResource", () => $fd17a5fce747f651$export$333c290f4a1ec41c);

var $kJlBc = parcelRequire("kJlBc");

var $fwGZE = parcelRequire("fwGZE");

var $eZrcv = parcelRequire("eZrcv");
const $fd17a5fce747f651$export$333c290f4a1ec41c = (0, $kJlBc.createResource)({
    type: 'configuredSyncsResource',
    getKey: ({ query: query, match: match })=>{
        var _match$params$teamId;
        const teamId = (_match$params$teamId = match.params.teamId) !== null && _match$params$teamId !== void 0 ? _match$params$teamId : query['teamId'];
        const keyword = query['keyword'];
        const type = query['type'];
        const page = query['page'] || '1';
        const status = query['status'];
        return (0, $fwGZE.UrlHelper)('configuredSyncsResource', {
            page: page,
            keyword: keyword,
            type: type,
            status: status,
            teamId: teamId
        });
    },
    getData: (routerContext)=>(0, $eZrcv.default).getSyncs(routerContext.query, routerContext.match.params.teamId),
    maxAge: 300000,
    // 5 mins
    isBrowserOnly: true
});

});
parcelRegister("fwGZE", function(module, exports) {

$parcel$export(module.exports, "UrlHelper", () => $b4db31c27798fd30$export$bacbc496e850c0a4);
const $b4db31c27798fd30$export$bacbc496e850c0a4 = (path, params = {})=>{
    // https://github.com/microsoft/TypeScript/issues/16655
    const q = Object.entries(params).map(([k, v])=>v !== '' && !!v || v === false ? [
            k,
            v.toString()
        ] : undefined).filter((v)=>!!v);
    const qs = new URLSearchParams(q).toString();
    return `${path}${qs ? `?${qs}` : ''}`;
};

});

parcelRegister("eZrcv", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae9bdcb279125202$export$2e2bcd8739ae039);

var $kRdYM = parcelRequire("kRdYM");

var $fwGZE = parcelRequire("fwGZE");

const $ae9bdcb279125202$var$getSyncs = async (query, pathParamTeamId)=>{
    const page = parseInt(query['page']) || 1;
    const offset = (page - 1) * (0, $afc7eeac74e9d195$export$31ecae7225aecec6);
    const queryParams = query ? {
        teamId: pathParamTeamId !== null && pathParamTeamId !== void 0 ? pathParamTeamId : query.teamId,
        type: query.type,
        keyword: query.keyword,
        status: query.status
    } : {};
    return (0, $kRdYM.eocFetch)((0, $fwGZE.UrlHelper)('/v1/entity-sync/unified', {
        ...queryParams,
        offset: offset.toString(),
        // UrlHelper omits 0 as number since it is a falsy value
        limit: (0, $afc7eeac74e9d195$export$31ecae7225aecec6)
    })).then((response)=>({
            data: response.data.integrations,
            pageCount: Math.ceil(response.data.count / (0, $afc7eeac74e9d195$export$31ecae7225aecec6)),
            itemCount: response.data.count
        }));
};
const $ae9bdcb279125202$var$patchSync = async (syncId, syncType, body, teamId)=>(0, $kRdYM.eocFetch)((0, $fwGZE.UrlHelper)(`/v1/entity-sync/unified/${syncId}`, {
        type: syncType,
        teamId: teamId
    }), {
        method: 'PATCH',
        body: body
    }).then((response)=>response.data);
const $ae9bdcb279125202$var$deleteSync = async (syncId, syncType, teamId)=>(0, $kRdYM.eocFetch)((0, $fwGZE.UrlHelper)(`/v1/entity-sync/unified/${syncId}`, {
        type: syncType,
        teamId: teamId
    }), {
        method: 'DELETE',
        responseType: 'headers'
    });
var $ae9bdcb279125202$export$2e2bcd8739ae039 = {
    getSyncs: $ae9bdcb279125202$var$getSyncs,
    patchSync: $ae9bdcb279125202$var$patchSync,
    deleteSync: $ae9bdcb279125202$var$deleteSync
};

});
const $afc7eeac74e9d195$export$31ecae7225aecec6 = 20;



parcelRegister("5udCV", function(module, exports) {

$parcel$export(module.exports, "userAccessRightsResource", () => $3fea531876abf683$export$69ddc7cc64ae9a02);

var $kJlBc = parcelRequire("kJlBc");

var $3RZ72 = parcelRequire("3RZ72");
const $3fea531876abf683$export$69ddc7cc64ae9a02 = (0, $kJlBc.createResource)({
    type: 'userAccessRightsResource',
    getKey: ()=>'userAccessRightsResource',
    getData: (routerContext)=>(0, $3RZ72.getUserRights)(routerContext.match.params.teamId),
    maxAge: 600000,
    // 10 minutes
    isBrowserOnly: true
});

});
parcelRegister("3RZ72", function(module, exports) {

$parcel$export(module.exports, "getUserRights", () => $2d15b9fc11347b3a$export$84e2ed279bc4e64e);

var $kRdYM = parcelRequire("kRdYM");

var $fwGZE = parcelRequire("fwGZE");
const $2d15b9fc11347b3a$export$84e2ed279bc4e64e = (teamId)=>{
    return (0, $kRdYM.eocFetch)((0, $fwGZE.UrlHelper)(`/v1/entity-sync/unified/rights`, {
        teamId: teamId
    })).then((response)=>response.data.userAccessRights);
};

});



parcelRegister("j7qZ1", function(module, exports) {

$parcel$export(module.exports, "teamResource", () => $deb39a18e3d8ed21$export$87453d709b90ccdf);
$parcel$export(module.exports, "sidebarRightsResource", () => $deb39a18e3d8ed21$export$3b3b9a5b0eddde66);
$parcel$export(module.exports, "resources", () => $deb39a18e3d8ed21$export$bc99aaabaf7b70a7);

var $kJlBc = parcelRequire("kJlBc");

var $6nbVQ = parcelRequire("6nbVQ");
var $1bJvm = parcelRequire("1bJvm");

var $dXblD = parcelRequire("dXblD");
const $deb39a18e3d8ed21$export$87453d709b90ccdf = (0, $kJlBc.createResource)({
    type: 'teamResource',
    getKey: (routerContext)=>{
        var _routerContext$match$;
        const teamId = (_routerContext$match$ = routerContext.match.params) === null || _routerContext$match$ === void 0 ? void 0 : _routerContext$match$.teamId;
        return `team-dashboard/${teamId !== null && teamId !== void 0 ? teamId : ''}`;
    },
    getData: async (routerContext)=>{
        var _routerContext$match$2;
        const teamId = (_routerContext$match$2 = routerContext.match.params) === null || _routerContext$match$2 === void 0 ? void 0 : _routerContext$match$2.teamId;
        (0, $6nbVQ.assert)(!!teamId, new (0, $1bJvm.AssertionError)('teamSidebarResource', 'teamId should be set to fetch team-dashboard'));
        return (0, $dXblD.getTeamByIdEndpoint)(teamId);
    },
    maxAge: 300000,
    // refresh it after 5 minutes
    isBrowserOnly: true
});
const $deb39a18e3d8ed21$export$3b3b9a5b0eddde66 = (0, $kJlBc.createResource)({
    type: 'sidebarRightsResource',
    getKey: (routerContext)=>{
        var _routerContext$match$3;
        const teamId = (_routerContext$match$3 = routerContext.match.params) === null || _routerContext$match$3 === void 0 ? void 0 : _routerContext$match$3.teamId;
        return `team-dashboard/${teamId !== null && teamId !== void 0 ? teamId : ''}/sidebar-rights`;
    },
    getData: async (routerContext)=>{
        var _routerContext$match$4;
        const teamId = (_routerContext$match$4 = routerContext.match.params) === null || _routerContext$match$4 === void 0 ? void 0 : _routerContext$match$4.teamId;
        (0, $6nbVQ.assert)(!!teamId, new (0, $1bJvm.AssertionError)('teamSidebarResource', 'teamId should be set to fetch sidebar rights'));
        return (0, $dXblD.getSidebarRightsEndpoint)(teamId);
    },
    isBrowserOnly: true,
    maxAge: Infinity
});
const $deb39a18e3d8ed21$export$bc99aaabaf7b70a7 = [
    $deb39a18e3d8ed21$export$87453d709b90ccdf,
    $deb39a18e3d8ed21$export$3b3b9a5b0eddde66
];

});
parcelRegister("6nbVQ", function(module, exports) {

$parcel$export(module.exports, "assert", () => $d9834c637c2554ee$export$a7a9523472993e97);

var $1bJvm = parcelRequire("1bJvm");
/**
 * Throws when the condition is true
 * @param condition Condition to assert - can use type assertions thanks to ts's "asserts condition"
 * @param err An AssertionError object extending js error object
 */ const $d9834c637c2554ee$export$a7a9523472993e97 = function(condition, err) {
    if (!condition) throw err;
};

});
parcelRegister("1bJvm", function(module, exports) {

$parcel$export(module.exports, "AssertionError", () => $a0c746e7a19d2631$export$7750cdfb4db2c3d);
class $a0c746e7a19d2631$export$7750cdfb4db2c3d extends Error {
    constructor(id, message){
        super(`[${id}] ${message}`);
        this.id = id;
    }
}

});


parcelRegister("dXblD", function(module, exports) {

$parcel$export(module.exports, "getTeamByIdEndpoint", () => $a2899684b5e73363$export$bcb25b347f39b3f3);
$parcel$export(module.exports, "getSidebarRightsEndpoint", () => $a2899684b5e73363$export$6f1f62156c62eb91);

var $kRdYM = parcelRequire("kRdYM");
const $a2899684b5e73363$export$bcb25b347f39b3f3 = (teamId)=>(0, $kRdYM.eocFetch)(`/v1/teams/${teamId}?includeImageUrls=true`);
const $a2899684b5e73363$export$6f1f62156c62eb91 = (teamId)=>{
    return (0, $kRdYM.eocFetch)(`/v1/teams/${teamId}/menu-rights`);
};

});


parcelRegister("2qQKu", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('i9ibT')
        ]);
        const value = parcelRequire('33IMM');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("i9ibT")
    ]).then(()=>parcelRequire('33IMM'));
}

});

parcelRegister("7rqR2", function(module, exports) {

$parcel$export(module.exports, "apiKeysResource", () => $56afe2c6761185d4$export$a98d5421eda11f29);
$parcel$export(module.exports, "resources", () => $56afe2c6761185d4$export$bc99aaabaf7b70a7);

var $kJlBc = parcelRequire("kJlBc");
parcelRequire("fxhI3");
var $czXr2 = parcelRequire("czXr2");

var $dbLpt = parcelRequire("dbLpt");
const $56afe2c6761185d4$export$a98d5421eda11f29 = (0, $kJlBc.createResource)({
    type: 'api-key-management',
    getKey: ()=>'api-key-management',
    getData: async ({ dependencies: dependencies })=>{
        const data = await dependencies[(0, $czXr2.eocUserResource).type].promise;
        return (0, $dbLpt.fetchKeys)(data.accountId);
    },
    isBrowserOnly: true,
    maxCache: 0,
    maxAge: 0,
    depends: [
        (0, $czXr2.eocUserResource).type
    ]
});
const $56afe2c6761185d4$export$bc99aaabaf7b70a7 = [
    (0, $czXr2.eocUserResource),
    $56afe2c6761185d4$export$a98d5421eda11f29
];

});
parcelRegister("fxhI3", function(module, exports) {

$parcel$export(module.exports, "eocUserResource", () => (parcelRequire("czXr2")).eocUserResource);

var $czXr2 = parcelRequire("czXr2");
const $b4f7accf43fe651d$export$8977bbbf2f7167d2 = ()=>[
        (0, $czXr2.eocUserResource)
    ];

});
parcelRegister("czXr2", function(module, exports) {

$parcel$export(module.exports, "eocUserResource", () => $9286db7d773b0041$export$3a08a0bdeef86956);

var $kJlBc = parcelRequire("kJlBc");

var $dROBc = parcelRequire("dROBc");
const $9286db7d773b0041$export$3a08a0bdeef86956 = (0, $kJlBc.createResource)({
    type: 'create-user-resource',
    getKey: ()=>'create-user-resource',
    getData: async ()=>(0, $dROBc.fetchJsmUserInfo)(),
    maxAge: Infinity,
    isBrowserOnly: true
});

});
parcelRegister("dROBc", function(module, exports) {

$parcel$export(module.exports, "fetchJsmUserInfo", () => $a187797b5102ccfe$export$7d750310098b5a7);

var $kRdYM = parcelRequire("kRdYM");
var $3lxlO = parcelRequire("3lxlO");
const $a187797b5102ccfe$var$JSM_BASE_URL = '/rest/api/3/myself';
const $a187797b5102ccfe$export$7d750310098b5a7 = ()=>{
    return (0, $kRdYM.eocFetch)($a187797b5102ccfe$var$JSM_BASE_URL, {
        exactUrl: true,
        errorTransformer: (0, $3lxlO.jsmErrorTransformer)
    });
};

});



parcelRegister("dbLpt", function(module, exports) {

$parcel$export(module.exports, "fetchKeys", () => $99a1140d882d35cb$export$a0d93e1b78b8e70b);
$parcel$export(module.exports, "deleteApiKey", () => $99a1140d882d35cb$export$d2f8649a375a4113);

var $kRdYM = parcelRequire("kRdYM");
const $99a1140d882d35cb$export$a0d93e1b78b8e70b = async (accountId)=>{
    return (0, $kRdYM.eocFetch)('/api-keys/web?accountId=' + accountId);
};
const $99a1140d882d35cb$export$d2f8649a375a4113 = async (key, accountId)=>{
    return (0, $kRdYM.eocFetch)(`/api-keys/web?apiKey=${key}&accountId=${accountId}`, {
        method: 'DELETE'
    });
};

});


parcelRegister("nnFEm", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('ePUZa')
        ]);
        const value = parcelRequire('2Eh7J');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("ePUZa")
    ]).then(()=>parcelRequire('2Eh7J'));
}

});

parcelRegister("lI1Uu", function(module, exports) {

$parcel$export(module.exports, "rolesResource", () => $fcdf305b54e5d437$export$52e29d5915d5f674);
$parcel$export(module.exports, "resources", () => $fcdf305b54e5d437$export$bc99aaabaf7b70a7);

var $kJlBc = parcelRequire("kJlBc");

var $3TBn1 = parcelRequire("3TBn1");
const $fcdf305b54e5d437$export$52e29d5915d5f674 = (0, $kJlBc.createResource)({
    type: 'rolesResource',
    getKey: ()=>'rolesResource',
    getData: (0, $3TBn1.getRolesEndpoint),
    isBrowserOnly: true
});
const $fcdf305b54e5d437$export$bc99aaabaf7b70a7 = [
    $fcdf305b54e5d437$export$52e29d5915d5f674
];

});
parcelRegister("3TBn1", function(module, exports) {

$parcel$export(module.exports, "getUsersEndpoint", () => $2d637f19a52d7507$export$d372f7d69e481dba);
$parcel$export(module.exports, "getFilteredUsersEndpoint", () => $2d637f19a52d7507$export$d8f86d9603f031c0);
$parcel$export(module.exports, "getRolesEndpoint", () => $2d637f19a52d7507$export$7d0bc1a3c689fc74);
$parcel$export(module.exports, "updateRoleOfUserEndpoint", () => $2d637f19a52d7507$export$a0b296dc0259976f);

var $kRdYM = parcelRequire("kRdYM");

var $lLmZj = parcelRequire("lLmZj");
const $2d637f19a52d7507$export$d372f7d69e481dba = ({ lastEvaluatedToken: lastEvaluatedToken, limit: limit, queryKey: queryKey })=>{
    const [_, query] = queryKey;
    let url = new (0, $lLmZj.URLBuilder)(`/v1/users/search`).withQueryParam('limit', limit).withQueryParam('query', query).withQueryParam('cursor', lastEvaluatedToken).build();
    return (0, $kRdYM.eocFetch)(url);
};
const $2d637f19a52d7507$export$d8f86d9603f031c0 = ({ lastEvaluatedToken: lastEvaluatedToken, limit: limit, queryKey: queryKey })=>{
    const [_, ...filters] = queryKey;
    if (filters.length === 0) return Promise.resolve({
        lastEvaluatedToken: '',
        values: []
    });
    return (0, $kRdYM.eocFetch)('/v1/users/roles/filter', {
        method: 'POST',
        body: {
            limit: limit,
            roles: filters,
            offset: lastEvaluatedToken || 0
        }
    });
};
const $2d637f19a52d7507$export$7d0bc1a3c689fc74 = ()=>{
    return (0, $kRdYM.eocFetch)('/v1/users/roles');
};
const $2d637f19a52d7507$export$a0b296dc0259976f = ({ roleId: roleId, accountId: accountId })=>{
    return (0, $kRdYM.eocFetch)(`/v1/users/roles/assign`, {
        method: 'PATCH',
        body: {
            accountId: accountId,
            roleId: roleId
        }
    });
};

});
parcelRegister("lLmZj", function(module, exports) {

$parcel$export(module.exports, "URLBuilder", () => $fd7fd1ae98625355$export$61d2e8db329a11f8);
class $fd7fd1ae98625355$export$61d2e8db329a11f8 {
    constructor(url){
        this.url = url;
        this.params = {};
    }
    withQueryParam(key, value) {
        this.params[key] = value;
        return this;
    }
    build() {
        const filteredParams = Object.entries(this.params).filter(([, value])=>value !== undefined && value !== null && value !== '').map(([key, value])=>[
                key,
                value && value.toString()
            ]);
        const queryInstance = new URLSearchParams(filteredParams);
        const queryParams = queryInstance.toString();
        if (queryParams === '') return `${this.url}`;
        if (queryParams) return `${this.url}?${queryParams}`;
        return this.url;
    }
}

});



parcelRegister("hSvrR", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('iD3Xf')
        ]);
        const value = parcelRequire('dMG0x');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("iD3Xf")
    ]).then(()=>parcelRequire('dMG0x'));
}

});

parcelRegister("gdyB9", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('3SMTO');
        const value = parcelRequire('5c0ul');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("3SMTO").then(()=>parcelRequire('5c0ul'));
}

});

parcelRegister("ehMsm", function(module, exports) {

$parcel$export(module.exports, "customRolesResource", () => $a6683da9357517bf$export$7140716a1b1b8e7a);
$parcel$export(module.exports, "resources", () => $a6683da9357517bf$export$bc99aaabaf7b70a7);

var $kJlBc = parcelRequire("kJlBc");

var $4LSr3 = parcelRequire("4LSr3");
const $a6683da9357517bf$export$7140716a1b1b8e7a = (0, $kJlBc.createResource)({
    type: 'customRolesResource',
    getKey: ()=>'customRolesResource',
    getData: (0, $4LSr3.getCustomRolesListEndpoint),
    isBrowserOnly: true
});
const $a6683da9357517bf$export$bc99aaabaf7b70a7 = [
    $a6683da9357517bf$export$7140716a1b1b8e7a
];

});
parcelRegister("4LSr3", function(module, exports) {

$parcel$export(module.exports, "getPermissionsEndpoint", () => $3795c6ea696d265b$export$f97b589720c51ce1);
$parcel$export(module.exports, "createCustomRoleEndpoint", () => $3795c6ea696d265b$export$5a7187e04c844900);
$parcel$export(module.exports, "editCustomRoleEndpoint", () => $3795c6ea696d265b$export$304735a80b86192e);
$parcel$export(module.exports, "deleteCustomRoleEndpoint", () => $3795c6ea696d265b$export$e12995ccad013f65);
$parcel$export(module.exports, "getCustomRolesListEndpoint", () => $3795c6ea696d265b$export$3619edac53aa59fd);

var $kRdYM = parcelRequire("kRdYM");
const $3795c6ea696d265b$export$f97b589720c51ce1 = ()=>(0, $kRdYM.eocFetch)(`/v1/users/permissions`);
const $3795c6ea696d265b$export$5a7187e04c844900 = (newCustomRole)=>(0, $kRdYM.eocFetch)(`/v1/users/roles`, {
        method: 'POST',
        body: newCustomRole
    });
const $3795c6ea696d265b$export$304735a80b86192e = (updatedCustomRole)=>{
    const { id: id } = updatedCustomRole;
    return (0, $kRdYM.eocFetch)(`/v1/users/roles/${id}`, {
        method: 'PATCH',
        body: updatedCustomRole
    });
};
const $3795c6ea696d265b$export$e12995ccad013f65 = (id)=>{
    return (0, $kRdYM.eocFetch)(`/v1/users/roles/${id}`, {
        method: 'DELETE'
    });
};
const $3795c6ea696d265b$export$3619edac53aa59fd = ()=>(0, $kRdYM.eocFetch)(`/v1/users/roles`);

});


parcelRegister("estMG", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('lGwLm')
        ]);
        const value = parcelRequire('glbcx');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("lGwLm")
    ]).then(()=>parcelRequire('glbcx'));
}

});

parcelRegister("5qcjh", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('hlUW3')
        ]);
        const value = parcelRequire('jdRPc');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("hlUW3")
    ]).then(()=>parcelRequire('jdRPc'));
}

});

parcelRegister("dQHDS", function(module, exports) {

$parcel$export(module.exports, "alertDetailResource", () => $a151fc1a13daf3a6$export$f918335771807ac4);
$parcel$export(module.exports, "logTypesResource", () => $a151fc1a13daf3a6$export$f9c57ab4d5f63686);
$parcel$export(module.exports, "entityRelationTypesResource", () => $a151fc1a13daf3a6$export$a5515392cb45b9f8);
$parcel$export(module.exports, "responderStatesResource", () => $a151fc1a13daf3a6$export$c3b70747662e5932);
$parcel$export(module.exports, "resources", () => $a151fc1a13daf3a6$export$bc99aaabaf7b70a7);

var $kJlBc = parcelRequire("kJlBc");

var $6nbVQ = parcelRequire("6nbVQ");
var $1bJvm = parcelRequire("1bJvm");

var $l96PT = parcelRequire("l96PT");

var $6kxEX = parcelRequire("6kxEX");
const $a151fc1a13daf3a6$export$f918335771807ac4 = (0, $kJlBc.createResource)({
    type: 'alertDetailResource',
    getKey: (routerContext)=>`alertDetailResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        var _routerContext$match$;
        const alertId = (_routerContext$match$ = routerContext.match.params) === null || _routerContext$match$ === void 0 ? void 0 : _routerContext$match$.id;
        (0, $6nbVQ.assert)(!!alertId, new (0, $1bJvm.AssertionError)('alertDetailResource', 'alertId should be set to fetch alert-detail'));
        return (0, $6kxEX.getAlertDetail)(alertId);
    },
    isBrowserOnly: true
});
const $a151fc1a13daf3a6$export$f9c57ab4d5f63686 = (0, $kJlBc.createResource)({
    type: 'logTypesResource',
    getKey: (routerContext)=>`logTypesResource#${routerContext.match.params.id}`,
    getData: async ()=>{
        return (0, $6kxEX.getAlertLogTypesEndpoint)();
    },
    isBrowserOnly: true
});
const $a151fc1a13daf3a6$export$a5515392cb45b9f8 = (0, $kJlBc.createResource)({
    type: 'entityRelationTypesResource',
    getKey: (routerContext)=>`entityRelationTypesResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        var _routerContext$match$2;
        const alertId = (_routerContext$match$2 = routerContext.match.params) === null || _routerContext$match$2 === void 0 ? void 0 : _routerContext$match$2.id;
        (0, $6nbVQ.assert)(!!alertId, new (0, $1bJvm.AssertionError)('alertDetaentityRelationTypesResourceilResource', 'alertId should be set to fetch alert-detail'));
        return (0, $6kxEX.getEntityRelationTypesEndpoint)(alertId);
    },
    isBrowserOnly: true
});
const $a151fc1a13daf3a6$export$c3b70747662e5932 = (0, $kJlBc.createResource)({
    type: 'responderStatesResource',
    getKey: (routerContext)=>`responderStatesResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        var _routerContext$match$3;
        const alertId = (_routerContext$match$3 = routerContext.match.params) === null || _routerContext$match$3 === void 0 ? void 0 : _routerContext$match$3.id;
        (0, $6nbVQ.assert)(!!alertId, new (0, $1bJvm.AssertionError)('responderStatesResource', 'alertId should be set to fetch responder states'));
        return (0, $6kxEX.getResponderStatesEndpoint)(alertId);
    },
    isBrowserOnly: true
});
const $a151fc1a13daf3a6$export$bc99aaabaf7b70a7 = [
    $a151fc1a13daf3a6$export$f918335771807ac4,
    $a151fc1a13daf3a6$export$f9c57ab4d5f63686,
    $a151fc1a13daf3a6$export$c3b70747662e5932,
    $a151fc1a13daf3a6$export$a5515392cb45b9f8,
    ...(0, $l96PT.eocCommonResources)()
];

});
parcelRegister("l96PT", function(module, exports) {

$parcel$export(module.exports, "eocCommonResources", () => $2c2f7e47d538624b$export$8977bbbf2f7167d2);
$parcel$export(module.exports, "eocUserResource", () => (parcelRequire("3liNr")).eocUserResource);

var $3liNr = parcelRequire("3liNr");
const $2c2f7e47d538624b$export$8977bbbf2f7167d2 = ()=>[
        (0, $3liNr.eocUserResource)
    ];

});
parcelRegister("3liNr", function(module, exports) {

$parcel$export(module.exports, "eocUserResource", () => $eb32eba6ed2be6e3$export$3a08a0bdeef86956);

var $kJlBc = parcelRequire("kJlBc");

var $1cezY = parcelRequire("1cezY");
const $eb32eba6ed2be6e3$export$3a08a0bdeef86956 = (0, $kJlBc.createResource)({
    type: 'create-user-resource',
    getKey: ()=>'create-user-resource',
    getData: async ()=>(0, $1cezY.fetchJsmUserInfo)(),
    maxAge: Infinity,
    isBrowserOnly: true
});

});
parcelRegister("1cezY", function(module, exports) {

$parcel$export(module.exports, "fetchJsmUserInfo", () => $e7c198181a929e1f$export$7d750310098b5a7);

var $kRdYM = parcelRequire("kRdYM");
var $3lxlO = parcelRequire("3lxlO");
const $e7c198181a929e1f$var$JSM_BASE_URL = '/rest/api/3/myself';
const $e7c198181a929e1f$export$7d750310098b5a7 = ()=>{
    return (0, $kRdYM.eocFetch)($e7c198181a929e1f$var$JSM_BASE_URL, {
        exactUrl: true,
        errorTransformer: (0, $3lxlO.jsmErrorTransformer)
    });
};

});



parcelRegister("6kxEX", function(module, exports) {

$parcel$export(module.exports, "getAlertDetail", () => $49beb86cafdd279e$export$436b6d88c1865c54);
$parcel$export(module.exports, "getAlertLogTypesEndpoint", () => $49beb86cafdd279e$export$97200f7e7a7d1479);
$parcel$export(module.exports, "getResponderStatesEndpoint", () => $49beb86cafdd279e$export$498d1a9ea659d430);
$parcel$export(module.exports, "getEntityRelationTypesEndpoint", () => $49beb86cafdd279e$export$8f96130abdd7549d);

var $kRdYM = parcelRequire("kRdYM");
const $49beb86cafdd279e$export$436b6d88c1865c54 = (alertId)=>(0, $kRdYM.eocFetch)(`/v1/alerts/${alertId}`);
const $49beb86cafdd279e$export$97200f7e7a7d1479 = ()=>(0, $kRdYM.eocFetch)(`/v1/alerts/logs/types`);
const $49beb86cafdd279e$export$498d1a9ea659d430 = (alertId)=>(0, $kRdYM.eocFetch)(`/v1/alerts/${alertId}/responder-states`);
const $49beb86cafdd279e$export$8f96130abdd7549d = (alertId)=>(0, $kRdYM.eocFetch)(`/v1/alerts/${alertId}/entity-relations/relation-types`).then((res)=>({
            relationTypes: res.relationTypes.sort((a, b)=>a.label.localeCompare(b.label))
        }));

});


parcelRegister("1ZiFa", function(module, exports) {

$parcel$export(module.exports, "alertGroupingStateResource", () => $1729f7075b12b460$export$722cc8285202ce44);

var $kJlBc = parcelRequire("kJlBc");

var $XHGTv = parcelRequire("XHGTv");

var $6skEh = parcelRequire("6skEh");
const $1729f7075b12b460$var$emptyAlertGroupingState = {
    isEnabled: false,
    reason: null
};
const $1729f7075b12b460$export$722cc8285202ce44 = (0, $kJlBc.createResource)({
    type: 'alertGroupingStateResource',
    getKey: ()=>'alertGroupingStateResource',
    getData: async ()=>{
        try {
            if ((0, $XHGTv.getBooleanFF)('platform.aiops-smart-view_yf5qp')) {
                const response = await (0, $6skEh.getGroupFeatureStatus)();
                return response;
            }
            return $1729f7075b12b460$var$emptyAlertGroupingState;
        } catch (e) {
            // Exception handling and to return emptyState
            return $1729f7075b12b460$var$emptyAlertGroupingState;
        }
    },
    maxAge: 300000,
    // 5 minutes
    isBrowserOnly: true
});

});
parcelRegister("6skEh", function(module, exports) {

$parcel$export(module.exports, "getGroupFeatureStatus", () => $4b3560024a94c640$export$48deee62d9dfb365);

var $huTdt = parcelRequire("huTdt");

var $kRdYM = parcelRequire("kRdYM");

var $kdelN = parcelRequire("kdelN");
const $4b3560024a94c640$export$48deee62d9dfb365 = ()=>{
    const url = new (0, $huTdt.URLBuilder)((0, $kdelN.withAIOpsDomainPrefix)('/v1/aiops/feature-state')).withQueryParam('featureName', 'alert-grouping').build();
    return (0, $kRdYM.eocFetch)(url, {
        exactUrl: true
    });
};

});
parcelRegister("huTdt", function(module, exports) {

$parcel$export(module.exports, "URLBuilder", () => $cbd011d3afa0a836$export$61d2e8db329a11f8);
class $cbd011d3afa0a836$export$61d2e8db329a11f8 {
    constructor(url){
        this.url = url;
        this.params = {};
    }
    withQueryParam(key, value) {
        this.params[key] = value;
        return this;
    }
    build() {
        const filteredParams = Object.entries(this.params).filter(([, value])=>value !== undefined && value !== null && value !== '');
        const queryInstance = new URLSearchParams(filteredParams);
        const queryParams = queryInstance.toString();
        if (queryParams) return `${this.url}?${queryParams}`;
        return this.url;
    }
}

});

parcelRegister("kdelN", function(module, exports) {

$parcel$export(module.exports, "validateTimeInput", () => $eb70274a528ca705$export$8880da3ae4274888);
$parcel$export(module.exports, "validateBetweenInput", () => $eb70274a528ca705$export$57c3e855fbf300fa);
$parcel$export(module.exports, "isInvalidDateValue", () => $eb70274a528ca705$export$f18cd4bc58b99a27);
$parcel$export(module.exports, "removeQuotes", () => $eb70274a528ca705$export$dd2bdf5049bf0915);
$parcel$export(module.exports, "withQuote", () => $eb70274a528ca705$export$8708814d32e406db);
$parcel$export(module.exports, "calculateTimes", () => $eb70274a528ca705$export$b362bc6892126b7a);
$parcel$export(module.exports, "getDefaultFilterQuery", () => $eb70274a528ca705$export$16cce822d8159876);
$parcel$export(module.exports, "isResponderAlert", () => $eb70274a528ca705$export$78656db4ffc3ccd8);
$parcel$export(module.exports, "isGroupAlert", () => $eb70274a528ca705$export$be2243d4df51c704);
$parcel$export(module.exports, "withAIOpsDomainPrefix", () => $eb70274a528ca705$export$81c70e0016508593);

var $7ueqz = parcelRequire("7ueqz");

var $3xcI8 = parcelRequire("3xcI8");

var $fiOXn = parcelRequire("fiOXn");

var $XHGTv = parcelRequire("XHGTv");

var $3lxlO = parcelRequire("3lxlO");

var $9fIxr = parcelRequire("9fIxr");
var $4nfSw = parcelRequire("4nfSw");

var $lVLIf = parcelRequire("lVLIf");
const $eb70274a528ca705$export$8880da3ae4274888 = (intl, timeDigits, timeUnit)=>{
    if (!timeDigits) return;
    const timeDigitsNumber = parseInt(timeDigits);
    if (isNaN(timeDigitsNumber)) return intl.formatMessage((0, $lVLIf.default).validNumber);
    if (timeUnit === 'hours' && (timeDigitsNumber < 1 || timeDigitsNumber > 99999)) return intl.formatMessage((0, $lVLIf.default).hoursNotInRange);
    if (timeUnit === 'days' && (timeDigitsNumber < 1 || timeDigitsNumber > 9999)) return intl.formatMessage((0, $lVLIf.default).daysNotInRange);
    if (timeUnit === 'weeks' && (timeDigitsNumber < 1 || timeDigitsNumber > 999)) return intl.formatMessage((0, $lVLIf.default).weeksNotInRange);
    if (timeUnit === 'months' && (timeDigitsNumber < 1 || timeDigitsNumber > 99)) return intl.formatMessage((0, $lVLIf.default).monthsNotInRange);
    if (timeUnit === 'years' && (timeDigitsNumber < 1 || timeDigitsNumber > 9)) return intl.formatMessage((0, $lVLIf.default).yearsNotInRange);
};
const $eb70274a528ca705$export$57c3e855fbf300fa = (intl, value)=>{
    if (value) {
        const { startDate: startDate, endDate: endDate } = value;
        if (!startDate && !endDate) return;
        if (startDate && endDate && new Date(startDate) > new Date(endDate)) return intl.formatMessage((0, $lVLIf.default).validationMessageBeforeGreaterThanAfter);
        if (value && (startDate !== '' && !(0, $7ueqz.default)(new Date(startDate)) || endDate !== '' && !(0, $7ueqz.default)(new Date(endDate)))) return intl.formatMessage((0, $lVLIf.default).validationMessageInvalidDateFormat);
    }
    return;
};
const $eb70274a528ca705$export$f18cd4bc58b99a27 = (value)=>{
    return !(0, $7ueqz.default)((0, $3xcI8.default)(value)) && value !== '';
};
const $eb70274a528ca705$export$dd2bdf5049bf0915 = (value)=>{
    return value.replace(/^"(.*)"$/, '$1');
};
const $eb70274a528ca705$export$d4aae9ad13afd6c = (data)=>{
    return {
        ...data,
        label: data.name,
        value: data.id
    };
};
const $eb70274a528ca705$export$8708814d32e406db = (value)=>{
    if ((0, $9fIxr.hasSpaceRegEx).test(value) || (0, $9fIxr.hasColonRegex).test(value)) return `${0, $4nfSw.STRING_LITERAL_DOUBLE_QUOTE}${value}${0, $4nfSw.STRING_LITERAL_DOUBLE_QUOTE}`;
    else return value;
};
const $eb70274a528ca705$export$b362bc6892126b7a = (time)=>{
    if (!time) return {
        from: undefined,
        to: undefined
    };
    if (time.range === 'all') return {
        from: undefined,
        to: undefined
    };
    if (time.range === 'custom') return {
        from: time.from,
        to: time.to
    };
    const now = new Date();
    const subAmount = {
        [time.range]: time.value
    };
    return {
        from: (0, $fiOXn.default)(now, subAmount).getTime(),
        to: now.getTime()
    };
};
const $eb70274a528ca705$export$16cce822d8159876 = (query, teamId)=>{
    if (teamId) {
        if (query) return `${0, $4nfSw.IDENTIFIER_RESPONDERS}: ${teamId} ${0, $4nfSw.LOGICAL_OPERATOR_AND} ${query}`;
        return `${0, $4nfSw.IDENTIFIER_RESPONDERS}: ${teamId}`;
    }
    return query;
};
const $eb70274a528ca705$export$78656db4ffc3ccd8 = (alert)=>alert && alert.alertType === 'responder';
const $eb70274a528ca705$export$be2243d4df51c704 = (alert)=>alert.entityType === 'group';
const $eb70274a528ca705$export$81c70e0016508593 = (input)=>{
    const cloudId = (0, $3lxlO.getMeta)('ajs-cloud-id');
    if (cloudId) return (0, $XHGTv.getBooleanFF)('platform.aiops-route-prefix-change_qwnpb') ? `/gateway/api/jira/aiops/cloudId/${cloudId}/api` + input : `/gateway/api/jsm/aiops/cloudId/${cloudId}/api` + input;
    return input;
};

});
parcelRegister("9fIxr", function(module, exports) {

$parcel$export(module.exports, "TAB_KEY", () => $6bc810308e665c7f$export$da8c7facc28740b1);
$parcel$export(module.exports, "ENTER_KEY", () => $6bc810308e665c7f$export$4162dbd8c730437);
$parcel$export(module.exports, "ESCAPE_KEY", () => $6bc810308e665c7f$export$728705b4513abbb5);
$parcel$export(module.exports, "SPACE_KEY", () => $6bc810308e665c7f$export$a47625ee19580f99);
$parcel$export(module.exports, "LEFT_KEY", () => $6bc810308e665c7f$export$ba950c21a0561bed);
$parcel$export(module.exports, "UP_KEY", () => $6bc810308e665c7f$export$16859d5882a95fea);
$parcel$export(module.exports, "RIGHT_KEY", () => $6bc810308e665c7f$export$4b96cad863d88376);
$parcel$export(module.exports, "DOWN_KEY", () => $6bc810308e665c7f$export$fc0cf2556509233e);
$parcel$export(module.exports, "SUGGESTION_CARD_Y_POS", () => $6bc810308e665c7f$export$87b2b08fc4c97f78);
$parcel$export(module.exports, "hasSpaceRegEx", () => $6bc810308e665c7f$export$a07ca273fbeffcb8);
$parcel$export(module.exports, "hasStartingQuotesRegex", () => $6bc810308e665c7f$export$a3aaedcec21ac282);
$parcel$export(module.exports, "hasEndingQuotesRegex", () => $6bc810308e665c7f$export$e5ad519d04ef012a);
$parcel$export(module.exports, "hasNewLinesRegex", () => $6bc810308e665c7f$export$7645e556e9948ecd);
$parcel$export(module.exports, "EMAIL_REGEX", () => $6bc810308e665c7f$export$7b7637218245c8a);
$parcel$export(module.exports, "hasColonRegex", () => $6bc810308e665c7f$export$65a2b373cb60e599);
const $6bc810308e665c7f$export$da8c7facc28740b1 = 'Tab';
const $6bc810308e665c7f$export$4162dbd8c730437 = 'Enter';
const $6bc810308e665c7f$export$728705b4513abbb5 = 'Escape';
const $6bc810308e665c7f$export$a47625ee19580f99 = ' ';
const $6bc810308e665c7f$export$ba950c21a0561bed = 'ArrowLeft';
const $6bc810308e665c7f$export$16859d5882a95fea = 'ArrowUp';
const $6bc810308e665c7f$export$4b96cad863d88376 = 'ArrowRight';
const $6bc810308e665c7f$export$fc0cf2556509233e = 'ArrowDown';
const $6bc810308e665c7f$export$87b2b08fc4c97f78 = 28;
const $6bc810308e665c7f$export$a07ca273fbeffcb8 = /\s/;
const $6bc810308e665c7f$export$8866d083cd03ffd7 = /^\s|\s$/;
const $6bc810308e665c7f$export$a3aaedcec21ac282 = /^('|")/;
const $6bc810308e665c7f$export$e5ad519d04ef012a = /('|")$/;
const $6bc810308e665c7f$export$7645e556e9948ecd = /(\r\n|\n|\r)/gm;
const $6bc810308e665c7f$export$7b7637218245c8a = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const $6bc810308e665c7f$export$65a2b373cb60e599 = /:/;

});

parcelRegister("4nfSw", function(module, exports) {

$parcel$export(module.exports, "TOKEN_TYPES", () => $32f5a0897964a2b5$export$e92b897d610f2aba);
$parcel$export(module.exports, "LEFT_PARENTHESIS", () => $32f5a0897964a2b5$export$9ce7f372949a1546);
$parcel$export(module.exports, "RIGHT_PARENTHESIS", () => $32f5a0897964a2b5$export$bbbb3f477a9839e0);
$parcel$export(module.exports, "OPERATOR_EQUAL_TO", () => $32f5a0897964a2b5$export$ea7497008076d6d2);
$parcel$export(module.exports, "OPERATOR_GROUP_FOR_ASSISTANT", () => $32f5a0897964a2b5$export$e75c84803c67e1f4);
$parcel$export(module.exports, "LOGICAL_OPERATOR_AND", () => $32f5a0897964a2b5$export$61308b2610174a70);
$parcel$export(module.exports, "LOGICAL_OPERATOR_OR", () => $32f5a0897964a2b5$export$1de654320eb3e523);
$parcel$export(module.exports, "BOOLEAN_LITERAL_TRUE", () => $32f5a0897964a2b5$export$ff7eed6ac2251302);
$parcel$export(module.exports, "BOOLEAN_LITERAL_FALSE", () => $32f5a0897964a2b5$export$4b436fec6f13b741);
$parcel$export(module.exports, "BOOLEAN_LITERAL_GROUP", () => $32f5a0897964a2b5$export$8cbc171ac4843075);
$parcel$export(module.exports, "STRING_LITERAL_DOUBLE_QUOTE", () => $32f5a0897964a2b5$export$347c7cb6285a1d61);
$parcel$export(module.exports, "STRING_LITERAL_STATUS_OPEN", () => $32f5a0897964a2b5$export$910131ff5cd3d496);
$parcel$export(module.exports, "STRING_LITERAL_STATUS_CLOSED", () => $32f5a0897964a2b5$export$2aa0d26cb4549272);
$parcel$export(module.exports, "STRING_LITERAL_STATUS_ACKED", () => $32f5a0897964a2b5$export$572cec90aa166025);
$parcel$export(module.exports, "STRING_LITERAL_STATUS_SNOOZED", () => $32f5a0897964a2b5$export$f94109650ec67751);
$parcel$export(module.exports, "STRING_LITERAL_STATUS_GROUP", () => $32f5a0897964a2b5$export$3a3a37e9da45a2a4);
$parcel$export(module.exports, "STRING_LITERAL_PRIORITY_GROUP", () => $32f5a0897964a2b5$export$9ef3f42fa10fce44);
$parcel$export(module.exports, "NULL_LITERAL", () => $32f5a0897964a2b5$export$c2b6d31a7a2d40ba);
$parcel$export(module.exports, "IDENTIFIER_ALIAS", () => $32f5a0897964a2b5$export$21c480ed86e9d13);
$parcel$export(module.exports, "IDENTIFIER_CLOSED_BY", () => $32f5a0897964a2b5$export$534c195089710c34);
$parcel$export(module.exports, "IDENTIFIER_DEDUPLICATION", () => $32f5a0897964a2b5$export$4699ad3805947d4d);
$parcel$export(module.exports, "IDENTIFIER_ENTITY", () => $32f5a0897964a2b5$export$2a30b5099ba66c99);
$parcel$export(module.exports, "IDENTIFIER_IS_SEEN", () => $32f5a0897964a2b5$export$7926b4c2836db847);
$parcel$export(module.exports, "IDENTIFIER_MESSAGE", () => $32f5a0897964a2b5$export$5a8895646b1d5248);
$parcel$export(module.exports, "IDENTIFIER_ASSIGNEE", () => $32f5a0897964a2b5$export$4047502bdab1e205);
$parcel$export(module.exports, "IDENTIFIER_PRIORITY", () => $32f5a0897964a2b5$export$5922c06b76ebb57d);
$parcel$export(module.exports, "IDENTIFIER_RESPONDERS", () => $32f5a0897964a2b5$export$44673ddac1790242);
$parcel$export(module.exports, "IDENTIFIER_SOURCE", () => $32f5a0897964a2b5$export$f250d53474e801dc);
$parcel$export(module.exports, "IDENTIFIER_STATUS", () => $32f5a0897964a2b5$export$43181828ba8680e4);
$parcel$export(module.exports, "IDENTIFIER_TAG", () => $32f5a0897964a2b5$export$8242733866920892);
$parcel$export(module.exports, "IDENTIFIER_TINY_ID", () => $32f5a0897964a2b5$export$c833829cf31052f0);
$parcel$export(module.exports, "IDENTIFIER_ACKNOWLEDGED", () => $32f5a0897964a2b5$export$5f1e5c89a704810f);
$parcel$export(module.exports, "IDENTIFIER_ACKNOWLEDGED_BY", () => $32f5a0897964a2b5$export$89d93eb7117999c0);
$parcel$export(module.exports, "IDENTIFIER_TEAMS", () => $32f5a0897964a2b5$export$a79eb1864dd7b745);
$parcel$export(module.exports, "IDENTIFIER_GROUP_ALERT", () => $32f5a0897964a2b5$export$888a9cda49b5e18c);
$parcel$export(module.exports, "IDENTIFIER_BOOLEAN_GROUP", () => $32f5a0897964a2b5$export$60745b712d37edf9);
$parcel$export(module.exports, "IDENTIFIER_GROUP_ALL", () => $32f5a0897964a2b5$export$b38df7dc61d42293);
$parcel$export(module.exports, "splitToTokensRegex", () => $32f5a0897964a2b5$export$28041d1d2a85f002);
$parcel$export(module.exports, "isKeywordRegex", () => $32f5a0897964a2b5$export$290f3472231a2ca1);
$parcel$export(module.exports, "isModifierRegex", () => $32f5a0897964a2b5$export$56079d3966b6b26c);
$parcel$export(module.exports, "isComplexOperatorRegex", () => $32f5a0897964a2b5$export$3f6ac43c2355116b);
$parcel$export(module.exports, "isWSRegex", () => $32f5a0897964a2b5$export$b1b0fc0dc5c83a12);
$parcel$export(module.exports, "isIdentifierRegex", () => $32f5a0897964a2b5$export$218cf3eb73c65394);
$parcel$export(module.exports, "isLogicalOperatorRegex", () => $32f5a0897964a2b5$export$a46484930d6fa80f);
$parcel$export(module.exports, "isOperatorRegex", () => $32f5a0897964a2b5$export$d48805fc5b137dc9);
/**
 * Token types
 */ const $32f5a0897964a2b5$export$e92b897d610f2aba = [
    'WHITE_SPACE',
    'SEPARATOR',
    'IDENTIFIER',
    'MODIFIER',
    'KEYWORD',
    'LOGICAL_OPERATOR',
    'STRING_LITERAL',
    'NUMBER_LITERAL',
    'BOOLEAN_LITERAL',
    'NULL_LITERAL',
    'OPERATOR'
];
const $32f5a0897964a2b5$export$9ce7f372949a1546 = '(';
const $32f5a0897964a2b5$export$bbbb3f477a9839e0 = ')';
const $32f5a0897964a2b5$export$adbc66edc544fda9 = '=';
const $32f5a0897964a2b5$export$fbd271ef020db0c = '!=';
const $32f5a0897964a2b5$export$ea7497008076d6d2 = ':';
const $32f5a0897964a2b5$export$6d44219c9e0c2567 = '!:';
const $32f5a0897964a2b5$export$f8636d23c210043c = '<';
const $32f5a0897964a2b5$export$1892bd0c818db570 = '<=';
const $32f5a0897964a2b5$export$386b1ae18a32d690 = '>';
const $32f5a0897964a2b5$export$44a62afa61d82568 = '>=';
const $32f5a0897964a2b5$export$e75c84803c67e1f4 = [
    $32f5a0897964a2b5$export$adbc66edc544fda9,
    $32f5a0897964a2b5$export$f8636d23c210043c,
    $32f5a0897964a2b5$export$1892bd0c818db570,
    $32f5a0897964a2b5$export$386b1ae18a32d690,
    $32f5a0897964a2b5$export$44a62afa61d82568
];
const $32f5a0897964a2b5$export$61308b2610174a70 = 'AND';
const $32f5a0897964a2b5$export$1de654320eb3e523 = 'OR';
const $32f5a0897964a2b5$export$184522872a5410fc = 'not';
const $32f5a0897964a2b5$export$ff7eed6ac2251302 = 'true';
const $32f5a0897964a2b5$export$4b436fec6f13b741 = 'false';
const $32f5a0897964a2b5$export$8cbc171ac4843075 = [
    $32f5a0897964a2b5$export$ff7eed6ac2251302,
    $32f5a0897964a2b5$export$4b436fec6f13b741
];
const $32f5a0897964a2b5$export$347c7cb6285a1d61 = '"';
const $32f5a0897964a2b5$export$d84ab70dc909b702 = "'";
const $32f5a0897964a2b5$export$910131ff5cd3d496 = `${$32f5a0897964a2b5$export$347c7cb6285a1d61}open${$32f5a0897964a2b5$export$347c7cb6285a1d61}`;
const $32f5a0897964a2b5$export$2aa0d26cb4549272 = `${$32f5a0897964a2b5$export$347c7cb6285a1d61}closed${$32f5a0897964a2b5$export$347c7cb6285a1d61}`;
const $32f5a0897964a2b5$export$572cec90aa166025 = `${$32f5a0897964a2b5$export$347c7cb6285a1d61}acknowledged${$32f5a0897964a2b5$export$347c7cb6285a1d61}`;
const $32f5a0897964a2b5$export$f94109650ec67751 = `${$32f5a0897964a2b5$export$347c7cb6285a1d61}snoozed${$32f5a0897964a2b5$export$347c7cb6285a1d61}`;
const $32f5a0897964a2b5$export$3a3a37e9da45a2a4 = [
    $32f5a0897964a2b5$export$910131ff5cd3d496,
    $32f5a0897964a2b5$export$2aa0d26cb4549272,
    $32f5a0897964a2b5$export$572cec90aa166025,
    $32f5a0897964a2b5$export$f94109650ec67751
];
const $32f5a0897964a2b5$export$928c1edd572e94f0 = 'P1';
const $32f5a0897964a2b5$export$22202070e5f64c55 = 'P2';
const $32f5a0897964a2b5$export$537865d58d2072a3 = 'P3';
const $32f5a0897964a2b5$export$3d5cfea3feefee83 = 'P4';
const $32f5a0897964a2b5$export$fe945cac89cd21a5 = 'P5';
const $32f5a0897964a2b5$export$9ef3f42fa10fce44 = [
    $32f5a0897964a2b5$export$928c1edd572e94f0,
    $32f5a0897964a2b5$export$22202070e5f64c55,
    $32f5a0897964a2b5$export$537865d58d2072a3,
    $32f5a0897964a2b5$export$3d5cfea3feefee83,
    $32f5a0897964a2b5$export$fe945cac89cd21a5
];
const $32f5a0897964a2b5$export$c2b6d31a7a2d40ba = 'null';
const $32f5a0897964a2b5$export$5a484b762b542c13 = 'actions';
const $32f5a0897964a2b5$export$21c480ed86e9d13 = 'alias';
const $32f5a0897964a2b5$export$534c195089710c34 = 'closedBy';
const $32f5a0897964a2b5$export$4699ad3805947d4d = 'count';
const $32f5a0897964a2b5$export$7c3401d7874d69f5 = 'createdAt';
const $32f5a0897964a2b5$export$afffcbd5b444e040 = 'description';
const $32f5a0897964a2b5$export$e1e61c3bf43fff11 = 'details.key';
const $32f5a0897964a2b5$export$aa35da9746edbfe2 = 'details.value';
const $32f5a0897964a2b5$export$b620b7163533b409 = 'detailsPair';
const $32f5a0897964a2b5$export$2a30b5099ba66c99 = 'entity';
const $32f5a0897964a2b5$export$2bfb49435a331d16 = 'integration.name';
const $32f5a0897964a2b5$export$feced558810f4b3e = 'integration.type';
const $32f5a0897964a2b5$export$7926b4c2836db847 = 'isSeen';
const $32f5a0897964a2b5$export$5a8895646b1d5248 = 'message';
const $32f5a0897964a2b5$export$4047502bdab1e205 = 'owner';
const $32f5a0897964a2b5$export$5922c06b76ebb57d = 'priority';
const $32f5a0897964a2b5$export$44673ddac1790242 = 'responders';
const $32f5a0897964a2b5$export$f250d53474e801dc = 'source';
const $32f5a0897964a2b5$export$43181828ba8680e4 = 'status';
const $32f5a0897964a2b5$export$a1959e1b76e880dd = 'sync.name';
const $32f5a0897964a2b5$export$8417ff61f7a57db6 = 'sync.type';
const $32f5a0897964a2b5$export$8242733866920892 = 'tags';
const $32f5a0897964a2b5$export$c833829cf31052f0 = 'tinyId';
const $32f5a0897964a2b5$export$78d4faf48faf13c2 = 'updatedAt';
const $32f5a0897964a2b5$export$5f1e5c89a704810f = 'acknowledged';
const $32f5a0897964a2b5$export$89d93eb7117999c0 = 'acknowledgedBy';
const $32f5a0897964a2b5$export$1ee0ad656333fc23 = 'aggregatorIds';
const $32f5a0897964a2b5$export$d42da2034504d6de = 'alertId';
const $32f5a0897964a2b5$export$8464a15b62fb09bb = 'alertType';
const $32f5a0897964a2b5$export$2f7ba2848fc019c6 = 'encrypted';
const $32f5a0897964a2b5$export$86e4b68c61c8cca5 = 'encryptionId';
const $32f5a0897964a2b5$export$cd9dc7ab4d04d11c = 'lastOccurredAt';
const $32f5a0897964a2b5$export$8508b76d4c14d7e = 'notify';
const $32f5a0897964a2b5$export$e73ddf8d219f28b7 = 'snoozedUntil';
const $32f5a0897964a2b5$export$a79eb1864dd7b745 = 'teams';
const $32f5a0897964a2b5$export$888a9cda49b5e18c = [
    $32f5a0897964a2b5$export$5f1e5c89a704810f,
    $32f5a0897964a2b5$export$89d93eb7117999c0,
    $32f5a0897964a2b5$export$1ee0ad656333fc23,
    $32f5a0897964a2b5$export$d42da2034504d6de,
    $32f5a0897964a2b5$export$8464a15b62fb09bb,
    $32f5a0897964a2b5$export$2f7ba2848fc019c6,
    $32f5a0897964a2b5$export$86e4b68c61c8cca5,
    $32f5a0897964a2b5$export$cd9dc7ab4d04d11c,
    $32f5a0897964a2b5$export$8508b76d4c14d7e,
    $32f5a0897964a2b5$export$e73ddf8d219f28b7,
    $32f5a0897964a2b5$export$a79eb1864dd7b745,
    $32f5a0897964a2b5$export$5a484b762b542c13,
    $32f5a0897964a2b5$export$21c480ed86e9d13,
    $32f5a0897964a2b5$export$534c195089710c34,
    $32f5a0897964a2b5$export$4699ad3805947d4d,
    $32f5a0897964a2b5$export$7c3401d7874d69f5,
    $32f5a0897964a2b5$export$afffcbd5b444e040,
    $32f5a0897964a2b5$export$e1e61c3bf43fff11,
    $32f5a0897964a2b5$export$aa35da9746edbfe2,
    $32f5a0897964a2b5$export$b620b7163533b409,
    $32f5a0897964a2b5$export$2a30b5099ba66c99,
    $32f5a0897964a2b5$export$2bfb49435a331d16,
    $32f5a0897964a2b5$export$feced558810f4b3e,
    $32f5a0897964a2b5$export$7926b4c2836db847,
    $32f5a0897964a2b5$export$5a8895646b1d5248,
    $32f5a0897964a2b5$export$4047502bdab1e205,
    $32f5a0897964a2b5$export$5922c06b76ebb57d,
    $32f5a0897964a2b5$export$44673ddac1790242,
    $32f5a0897964a2b5$export$f250d53474e801dc,
    $32f5a0897964a2b5$export$43181828ba8680e4,
    $32f5a0897964a2b5$export$a1959e1b76e880dd,
    $32f5a0897964a2b5$export$8417ff61f7a57db6,
    $32f5a0897964a2b5$export$8242733866920892,
    $32f5a0897964a2b5$export$c833829cf31052f0,
    $32f5a0897964a2b5$export$78d4faf48faf13c2
];
const $32f5a0897964a2b5$export$60745b712d37edf9 = [
    $32f5a0897964a2b5$export$5f1e5c89a704810f,
    $32f5a0897964a2b5$export$7926b4c2836db847
];
const $32f5a0897964a2b5$export$b38df7dc61d42293 = [
    ...$32f5a0897964a2b5$export$888a9cda49b5e18c
];
/**
 * Regex definitions
 */ // The main regex to split any given query into smaller tokens.
// Please be aware that token order has a meaning here.
const $32f5a0897964a2b5$var$splitToTokensCases = [
    // 1. Split single and double quotes
    ...[
        $32f5a0897964a2b5$export$d84ab70dc909b702,
        $32f5a0897964a2b5$export$347c7cb6285a1d61
    ].map((i)=>`(${i}.*?${i})`),
    ...[
        $32f5a0897964a2b5$export$d84ab70dc909b702,
        $32f5a0897964a2b5$export$347c7cb6285a1d61
    ].map((i)=>`(${i}.*)`),
    // 2. Split operators and separators
    ...[
        $32f5a0897964a2b5$export$9ce7f372949a1546,
        $32f5a0897964a2b5$export$bbbb3f477a9839e0,
        $32f5a0897964a2b5$export$adbc66edc544fda9,
        $32f5a0897964a2b5$export$fbd271ef020db0c,
        $32f5a0897964a2b5$export$ea7497008076d6d2,
        $32f5a0897964a2b5$export$6d44219c9e0c2567,
        $32f5a0897964a2b5$export$44a62afa61d82568,
        $32f5a0897964a2b5$export$386b1ae18a32d690,
        $32f5a0897964a2b5$export$1892bd0c818db570,
        $32f5a0897964a2b5$export$f8636d23c210043c
    ].map((i)=>`(\\${i})`),
    // 3. Split the exact keywords when it's a known literal
    // Known issue: The word boundary in the beginning does not capture letters except latin chars, digits and underscore, i.e. "+and" results to STRING_LITERAL + BOOLEAN_LITERAL
    ...[
        $32f5a0897964a2b5$export$61308b2610174a70,
        $32f5a0897964a2b5$export$1de654320eb3e523,
        $32f5a0897964a2b5$export$ff7eed6ac2251302,
        $32f5a0897964a2b5$export$4b436fec6f13b741,
        $32f5a0897964a2b5$export$184522872a5410fc,
        `is\\s*null`,
        `is\\s*not\\s*null`
    ].map((i)=>`(\\b${i}(?=\\s|$))`),
    // 4. Empty spaces
    '(\\s+)'
];
const $32f5a0897964a2b5$export$28041d1d2a85f002 = new RegExp($32f5a0897964a2b5$var$splitToTokensCases.join('|'), 'gi');
const $32f5a0897964a2b5$export$290f3472231a2ca1 = /^(is(  *)not(  *)null)$|^(is(  *)null)$/i;
const $32f5a0897964a2b5$export$56079d3966b6b26c = /^not$/i;
const $32f5a0897964a2b5$export$3f6ac43c2355116b = /^<=$|^>=$|^!=$|^!:$/;
const $32f5a0897964a2b5$export$b1b0fc0dc5c83a12 = /^\s+$/;
const $32f5a0897964a2b5$export$218cf3eb73c65394 = new RegExp($32f5a0897964a2b5$export$b38df7dc61d42293.map((i)=>`^${i}$`).join('|'));
const $32f5a0897964a2b5$export$a46484930d6fa80f = /^and$|^or$/i;
const $32f5a0897964a2b5$export$d48805fc5b137dc9 = /^[=:<>]$/;

});

parcelRegister("lVLIf", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff73ee9a38c43f18$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $ff73ee9a38c43f18$var$messages = (0, $90IgZ.defineMessages)({
    validationMessageBeforeGreaterThanAfter: {
        id: `eoc.alert-list.common.utils.validation-message-before-greater-than-after.no-translate`,
        defaultMessage: "'Before' field cannot be later than 'After' field.",
        description: 'Message displayed to the user when the Before date used is greater than the after date while specifying dates'
    },
    validationMessageInvalidDateFormat: {
        id: `eoc.alert-list.common.utils.validation-message-invalid-date-format.no-translate`,
        defaultMessage: 'Invalid date format.',
        description: 'Invalid date format.'
    },
    validNumber: {
        id: `eoc.alert-list.common.utils.validation-not-number.no-translate`,
        defaultMessage: 'Enter a valid number.',
        description: 'The error message that shown when user write different chars other than numeric chars.'
    },
    hoursNotInRange: {
        id: `eoc.alert-list.common.utils.validation-message-hours-not-in-range.no-translate`,
        defaultMessage: 'Enter a number between 1-99999.',
        description: 'Message displayed to the user when hours value is not in range'
    },
    daysNotInRange: {
        id: `eoc.alert-list.common.utils.validation-message-days-not-in-range.no-translate`,
        defaultMessage: 'Enter a number between 1-9999.',
        description: 'Message displayed to the user when days value is not in range'
    },
    weeksNotInRange: {
        id: `eoc.alert-list.common.utils.validation-message-weeks-not-in-range.no-translate`,
        defaultMessage: 'Enter a number between 1-999.',
        description: 'Message displayed to the user when weeks value is not in range'
    },
    monthsNotInRange: {
        id: `eoc.alert-list.common.utils.validation-message-months-not-in-range.no-translate`,
        defaultMessage: 'Enter a number between 1-99.',
        description: 'Message displayed to the user when months value is not in range'
    },
    yearsNotInRange: {
        id: `eoc.alert-list.common.utils.validation-message-years-not-in-range.no-translate`,
        defaultMessage: 'Enter a number between 1-9.',
        description: 'Message displayed to the user when years value is not in range'
    }
});
var $ff73ee9a38c43f18$export$2e2bcd8739ae039 = $ff73ee9a38c43f18$var$messages;

});




parcelRegister("l19Qj", function(module, exports) {

$parcel$export(module.exports, "compressionRatioResource", () => $f4d15387347b8961$export$8c912e73f758af2);

var $kJlBc = parcelRequire("kJlBc");

var $XHGTv = parcelRequire("XHGTv");

var $319q6 = parcelRequire("319q6");
const $f4d15387347b8961$var$emptyCompressionBanner = {
    compressionRatio: 0,
    uniqueGroupCount: 0,
    rollingWindow: 0
};
const $f4d15387347b8961$export$8c912e73f758af2 = (0, $kJlBc.createResource)({
    type: 'compressionRatioResource',
    getKey: ()=>'compressionRatioResource',
    getData: async ()=>{
        try {
            if ((0, $XHGTv.getBooleanFF)('platform.aiops-smart-view_yf5qp')) {
                const response = await (0, $319q6.getCompressionRatio)();
                return response;
            } else return $f4d15387347b8961$var$emptyCompressionBanner;
        } catch (e) {
            return $f4d15387347b8961$var$emptyCompressionBanner;
        }
    },
    maxAge: 300000,
    // 5 minutes
    isBrowserOnly: true
});

});
parcelRegister("319q6", function(module, exports) {

$parcel$export(module.exports, "getCompressionRatio", () => $2328c5bba20c1eb3$export$4991457f359db4f7);

var $kRdYM = parcelRequire("kRdYM");

var $kdelN = parcelRequire("kdelN");
const $2328c5bba20c1eb3$export$4991457f359db4f7 = ()=>{
    return (0, $kRdYM.eocFetch)((0, $kdelN.withAIOpsDomainPrefix)('/v1/alert-insights/compression-ratio'), {
        exactUrl: true
    });
};

});


parcelRegister("633Zo", function(module, exports) {

$parcel$export(module.exports, "savedSearchesResource", () => $46761e142a85b5de$export$d915b849e6dd786b);

var $kJlBc = parcelRequire("kJlBc");

var $7175d = parcelRequire("7175d");
const $46761e142a85b5de$export$d915b849e6dd786b = (0, $kJlBc.createResource)({
    type: 'savedSearchesResource',
    getKey: ()=>'savedSearchesResource',
    getData: ()=>(0, $7175d.getSavedSearchesEndpoint)(),
    maxAge: 300000,
    // 5 minutes
    isBrowserOnly: true
});

});
parcelRegister("7175d", function(module, exports) {

$parcel$export(module.exports, "getSavedSearchesEndpoint", () => $51be1ef6b3cd1ef9$export$3b7b44889eb94cd0);
$parcel$export(module.exports, "createSavedSearchEndpoint", () => $51be1ef6b3cd1ef9$export$4976332c0ec66407);
$parcel$export(module.exports, "deleteSearchEndpoint", () => $51be1ef6b3cd1ef9$export$401da4a793944201);

var $kRdYM = parcelRequire("kRdYM");
const $51be1ef6b3cd1ef9$export$3b7b44889eb94cd0 = ()=>{
    return (0, $kRdYM.eocFetch)('/v1/alerts/saved-searches');
};
const $51be1ef6b3cd1ef9$export$4976332c0ec66407 = (data)=>{
    return (0, $kRdYM.eocFetch)('/v1/alerts/saved-searches', {
        method: 'POST',
        body: data
    });
};
const $51be1ef6b3cd1ef9$export$401da4a793944201 = (id)=>{
    return (0, $kRdYM.eocFetch)(`/v1/alerts/saved-searches/${id}`, {
        method: 'DELETE',
        responseType: 'headers'
    });
};

});


parcelRegister("604AA", function(module, exports) {

$parcel$export(module.exports, "uiPreferencesResource", () => $45e64d78e62d324f$export$4e143f0fe4b2e025);

var $kJlBc = parcelRequire("kJlBc");

var $376rc = parcelRequire("376rc");
const $45e64d78e62d324f$export$4e143f0fe4b2e025 = (0, $kJlBc.createResource)({
    type: 'uiPreferencesResource',
    getKey: ()=>'uiPreferencesResource',
    getData: ()=>(0, $376rc.getUiPreferencesEndpoint)(),
    maxAge: 300000,
    // 5 minutes
    isBrowserOnly: true
});

});
parcelRegister("376rc", function(module, exports) {

$parcel$export(module.exports, "getUiPreferencesEndpoint", () => $244704ef53e1ef1c$export$afa4854419ed2fc8);
$parcel$export(module.exports, "updateUiPreferencesEndpoint", () => $244704ef53e1ef1c$export$4990793476d8f783);

var $kRdYM = parcelRequire("kRdYM");
const $244704ef53e1ef1c$export$afa4854419ed2fc8 = ()=>{
    return (0, $kRdYM.eocFetch)('/v1/alerts/ui-preferences');
};
const $244704ef53e1ef1c$export$4990793476d8f783 = (data)=>{
    return (0, $kRdYM.eocFetch)('/v1/alerts/ui-preferences', {
        method: 'PATCH',
        body: data
    });
};

});


parcelRegister("fOu5W", function(module, exports) {

$parcel$export(module.exports, "eocGlobalAlertDetailRoute", () => $94d55917f8391976$export$4c5c22da74ff47b1);
$parcel$export(module.exports, "eocGlobalAlertListRoute", () => $94d55917f8391976$export$29721341dde2ed3d);

var $exb0h = parcelRequire("exb0h");
const $94d55917f8391976$export$4c5c22da74ff47b1 = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_GLOBAL_ALERT_DETAIL,
    path: '/jira/ops/alerts/:id',
    exact: true
};
const $94d55917f8391976$export$29721341dde2ed3d = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_GLOBAL_ALERTS,
    path: '/jira/ops/alerts'
};

});

parcelRegister("8xofD", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('kTdGl')
        ]);
        const value = parcelRequire('dwX96');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("kTdGl")
    ]).then(()=>parcelRequire('dwX96'));
}

});

parcelRegister("334z5", function(module, exports) {

$parcel$export(module.exports, "groupHeaderResource", () => $2385316d296f218a$export$e6ba56f6b67069c8);
$parcel$export(module.exports, "aiSuggestionsResource", () => $2385316d296f218a$export$94675faef1d4568b);
$parcel$export(module.exports, "resources", () => $2385316d296f218a$export$bc99aaabaf7b70a7);

var $kJlBc = parcelRequire("kJlBc");

var $6nbVQ = parcelRequire("6nbVQ");
var $1bJvm = parcelRequire("1bJvm");

var $19Zy4 = parcelRequire("19Zy4");
const $2385316d296f218a$export$e6ba56f6b67069c8 = (0, $kJlBc.createResource)({
    type: 'groupHeaderResource',
    getKey: (routerContext)=>`groupHeaderResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        var _routerContext$match$;
        const groupId = (_routerContext$match$ = routerContext.match.params) === null || _routerContext$match$ === void 0 ? void 0 : _routerContext$match$.id;
        (0, $6nbVQ.assert)(!!groupId, new (0, $1bJvm.AssertionError)('groupHeaderResource', 'groupId should be set to fetch group-detail-header'));
        return (0, $19Zy4.getHeaderDetails)(groupId);
    },
    isBrowserOnly: true
});
const $2385316d296f218a$export$94675faef1d4568b = (0, $kJlBc.createResource)({
    type: 'aiSuggestionsResource',
    getKey: (routerContext)=>`aiSuggestionsResource#${routerContext.match.params.id}`,
    getData: async (routerContext)=>{
        var _routerContext$match$2;
        const groupId = (_routerContext$match$2 = routerContext.match.params) === null || _routerContext$match$2 === void 0 ? void 0 : _routerContext$match$2.id;
        (0, $6nbVQ.assert)(!!groupId, new (0, $1bJvm.AssertionError)('aiSuggestionsResource', 'groupId should be set to fetch ai-suggestions for any group'));
        return (0, $19Zy4.getAISuggestions)(groupId);
    },
    isBrowserOnly: true
});
const $2385316d296f218a$export$bc99aaabaf7b70a7 = [
    $2385316d296f218a$export$e6ba56f6b67069c8,
    $2385316d296f218a$export$94675faef1d4568b
];

});
parcelRegister("19Zy4", function(module, exports) {

$parcel$export(module.exports, "getHeaderDetails", () => $0d865ffb52d847fc$export$c0f2e4bfcbff05d1);
$parcel$export(module.exports, "getAISuggestions", () => $0d865ffb52d847fc$export$34bb7a15a54039a5);
$parcel$export(module.exports, "addGroupAssignee", () => $0d865ffb52d847fc$export$bd5bdebdb6d9abb);
$parcel$export(module.exports, "actionOnGroup", () => $0d865ffb52d847fc$export$5353a5d2604523c0);
$parcel$export(module.exports, "getAlertCountForGroupAction", () => $0d865ffb52d847fc$export$b47efb0a9602f0c8);

var $kRdYM = parcelRequire("kRdYM");

var $1AUoi = parcelRequire("1AUoi");
const $0d865ffb52d847fc$export$c0f2e4bfcbff05d1 = (groupId)=>(0, $kRdYM.eocFetch)((0, $1AUoi.withAIOpsPrefix)(`/v1/group-insights/${groupId}`), {
        exactUrl: true
    });
const $0d865ffb52d847fc$export$34bb7a15a54039a5 = (groupId)=>(0, $kRdYM.eocFetch)((0, $1AUoi.withAIOpsPrefix)(`/v1/group-insights/getSimilar/${groupId}`), {
        exactUrl: true
    });
const $0d865ffb52d847fc$export$bd5bdebdb6d9abb = (groupId, assigneeId)=>(0, $kRdYM.eocFetch)((0, $1AUoi.withAIOpsPrefix)(`/v1/group-insights/${groupId}/add-assignee/${assigneeId}`), {
        method: 'PUT',
        exactUrl: true
    });
const $0d865ffb52d847fc$export$5353a5d2604523c0 = (groupId, action)=>{
    return (0, $kRdYM.eocFetch)((0, $1AUoi.withAIOpsPrefix)(`/v1/alert-insights/bulk-action`), {
        method: 'PUT',
        exactUrl: true,
        body: {
            groupId: groupId,
            actionType: action
        }
    });
};
const $0d865ffb52d847fc$export$b47efb0a9602f0c8 = (groupId, action)=>{
    const urlSearchParams = new URLSearchParams();
    urlSearchParams.set('actionType', action);
    urlSearchParams.set('groupId', groupId);
    return (0, $kRdYM.eocFetch)((0, $1AUoi.withAIOpsPrefix)(`/v1/alert-insights/check-all-action?${urlSearchParams}`), {
        exactUrl: true
    });
};

});
parcelRegister("1AUoi", function(module, exports) {

$parcel$export(module.exports, "withAIOpsPrefix", () => $1294e5490c144c31$export$5ad74397753c99a2);

var $XHGTv = parcelRequire("XHGTv");

var $3lxlO = parcelRequire("3lxlO");
const $1294e5490c144c31$export$5ad74397753c99a2 = (input)=>{
    const cloudId = (0, $3lxlO.getMeta)('ajs-cloud-id');
    if (cloudId) return (0, $XHGTv.getBooleanFF)('platform.aiops-route-prefix-change_qwnpb') ? `/gateway/api/jira/aiops/cloudId/${cloudId}/api` + input : `/gateway/api/jsm/aiops/cloudId/${cloudId}/api` + input;
    return input;
};

});



parcelRegister("8cFeQ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('fVc07')
        ]);
        const value = parcelRequire('8Oy20');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("fVc07")
    ]).then(()=>parcelRequire('8Oy20'));
}

});

parcelRegister("kimHz", function(module, exports) {

$parcel$export(module.exports, "heartbeatsResource", () => $ec67192911a2c296$export$dd38e2aa5cfda9c9);
$parcel$export(module.exports, "heartbeatsUserRightsResource", () => $ec67192911a2c296$export$b5d9a0bcdfa848ce);
$parcel$export(module.exports, "resources", () => $ec67192911a2c296$export$bc99aaabaf7b70a7);

var $kJlBc = parcelRequire("kJlBc");

var $dcHoZ = parcelRequire("dcHoZ");
const $ec67192911a2c296$export$dd38e2aa5cfda9c9 = (0, $kJlBc.createResource)({
    type: 'heartbeatsResource',
    getKey: (routerContext)=>{
        var _routerContext$match$;
        const teamId = (_routerContext$match$ = routerContext.match.params) === null || _routerContext$match$ === void 0 ? void 0 : _routerContext$match$.teamId;
        return `heartbeats/${teamId !== null && teamId !== void 0 ? teamId : ''}`;
    },
    getData: async (routerContext)=>{
        var _routerContext$match$2;
        const teamId = (_routerContext$match$2 = routerContext.match.params) === null || _routerContext$match$2 === void 0 ? void 0 : _routerContext$match$2.teamId;
        if (!teamId) return;
        return (0, $dcHoZ.getHeartbeatsEndpoint)(teamId);
    },
    isBrowserOnly: true
});
const $ec67192911a2c296$export$b5d9a0bcdfa848ce = (0, $kJlBc.createResource)({
    type: 'heartbeatsUserRightsResource',
    getKey: (routerContext)=>{
        var _routerContext$match$3;
        const teamId = (_routerContext$match$3 = routerContext.match.params) === null || _routerContext$match$3 === void 0 ? void 0 : _routerContext$match$3.teamId;
        return `heartbeats-user-rights/${teamId !== null && teamId !== void 0 ? teamId : ''}`;
    },
    getData: async (routerContext)=>{
        var _routerContext$match$4;
        const teamId = (_routerContext$match$4 = routerContext.match.params) === null || _routerContext$match$4 === void 0 ? void 0 : _routerContext$match$4.teamId;
        return (0, $dcHoZ.getHeartbeatsUserRights)(teamId);
    },
    isBrowserOnly: true
});
const $ec67192911a2c296$export$bc99aaabaf7b70a7 = [
    $ec67192911a2c296$export$dd38e2aa5cfda9c9,
    $ec67192911a2c296$export$b5d9a0bcdfa848ce
];

});
parcelRegister("dcHoZ", function(module, exports) {

$parcel$export(module.exports, "getHeartbeatsEndpoint", () => $99ce1013a61b4951$export$c322dad372dcb08b);
$parcel$export(module.exports, "validateHeartbeatNameEndpoint", () => $99ce1013a61b4951$export$676f6aee59f124b0);
$parcel$export(module.exports, "createHeartbeatEndpoint", () => $99ce1013a61b4951$export$891ea85cc6973b32);
$parcel$export(module.exports, "updateHeartbeatEndpoint", () => $99ce1013a61b4951$export$7311481b59e02e06);
$parcel$export(module.exports, "switchHeartbeatEndpoint", () => $99ce1013a61b4951$export$5df993f1c74d7e8e);
$parcel$export(module.exports, "deleteHeartbeatEndpoint", () => $99ce1013a61b4951$export$716e365975fc2cd1);
$parcel$export(module.exports, "getHeartbeatsUserRights", () => $99ce1013a61b4951$export$26eaca11f3b4e506);
$parcel$export(module.exports, "updateAutoCreationEndpoint", () => $99ce1013a61b4951$export$38097aade6a3b234);

var $kRdYM = parcelRequire("kRdYM");
const $99ce1013a61b4951$export$c322dad372dcb08b = (teamId)=>(0, $kRdYM.eocFetch)(`/v1/teams/${teamId}/heartbeats`, {
        method: 'GET'
    });
const $99ce1013a61b4951$export$676f6aee59f124b0 = (teamId, heartbeatName)=>(0, $kRdYM.eocFetch)(`/v1/teams/${teamId}/heartbeats/validateEmail?heartbeatName=${encodeURIComponent(heartbeatName)}`, {
        method: 'GET',
        responseType: 'headers'
    });
const $99ce1013a61b4951$export$891ea85cc6973b32 = (teamId, heartbeat)=>(0, $kRdYM.eocFetch)(`/v1/teams/${teamId}/heartbeats`, {
        method: 'POST',
        body: heartbeat
    });
const $99ce1013a61b4951$export$7311481b59e02e06 = (teamId, heartbeat)=>(0, $kRdYM.eocFetch)(`/v1/teams/${teamId}/heartbeats`, {
        method: 'PUT',
        body: heartbeat
    });
const $99ce1013a61b4951$export$5df993f1c74d7e8e = (teamId, enable, name)=>(0, $kRdYM.eocFetch)(`/v1/teams/${teamId}/heartbeats/enable?enabled=${enable}&name=${encodeURIComponent(name)}`, {
        method: 'PATCH'
    });
const $99ce1013a61b4951$export$716e365975fc2cd1 = (teamId, name)=>(0, $kRdYM.eocFetch)(`/v1/teams/${teamId}/heartbeats?name=${encodeURIComponent(name)}`, {
        method: 'DELETE',
        responseType: 'headers'
    });
const $99ce1013a61b4951$export$26eaca11f3b4e506 = (teamId)=>{
    return (0, $kRdYM.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}heartbeats/rights`);
};
const $99ce1013a61b4951$export$38097aade6a3b234 = (teamId, autoCreateEnabled)=>(0, $kRdYM.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}heartbeats/updateHeartbeatAutoCreation?autoCreateEnabled=${autoCreateEnabled}`, {
        method: 'POST',
        responseType: 'headers'
    });

});


parcelRegister("k2L8t", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('ajR1e')
        ]);
        const value = parcelRequire('9REGk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("ajR1e")
    ]).then(()=>parcelRequire('9REGk'));
}

});

parcelRegister("3sohY", function(module, exports) {

$parcel$export(module.exports, "detailResource", () => $2846d3e9b31430cc$export$13d78d45f8054f1e);

var $kJlBc = parcelRequire("kJlBc");

var $6nbVQ = parcelRequire("6nbVQ");
var $1bJvm = parcelRequire("1bJvm");

var $dk3a7 = parcelRequire("dk3a7");
const $2846d3e9b31430cc$export$13d78d45f8054f1e = (0, $kJlBc.createResource)({
    type: 'getDetailResource',
    getKey: ()=>'getDetailResource',
    getData: async (routerContext)=>{
        var _routerContext$match$;
        const id = (_routerContext$match$ = routerContext.match.params) === null || _routerContext$match$ === void 0 ? void 0 : _routerContext$match$.id;
        (0, $6nbVQ.assert)(!!id, new (0, $1bJvm.AssertionError)('detailResource', 'id should be set to fetch incoming call detail'));
        return (0, $dk3a7.getDetail)(id);
    },
    isBrowserOnly: true
});

});
parcelRegister("dk3a7", function(module, exports) {

$parcel$export(module.exports, "getDetail", () => $9b2f9895507ac053$export$d6c3faeb2ce9d297);

var $kRdYM = parcelRequire("kRdYM");

var $jInF8 = parcelRequire("jInF8");
const $9b2f9895507ac053$export$d6c3faeb2ce9d297 = (id)=>{
    const endpoint = `${(0, $jInF8.urls).incomingCall.detail.url(id)}`;
    return (0, $kRdYM.eocFetch)(endpoint);
};

});
parcelRegister("jInF8", function(module, exports) {

$parcel$export(module.exports, "urls", () => $e5a47b427fd1e0a6$export$bcae9ba627f604b6);
const $e5a47b427fd1e0a6$export$bcae9ba627f604b6 = Object.freeze({
    incomingCall: {
        url: ()=>`/v1/incoming-call`,
        detail: {
            url: (incomingCallId = ':incomingCallId')=>`${$e5a47b427fd1e0a6$export$bcae9ba627f604b6.incomingCall.url()}/${incomingCallId}`
        }
    }
});

});



parcelRegister("8KuNc", function(module, exports) {

$parcel$export(module.exports, "listResource", () => $65ea8159edba1b14$export$5ee018e9baf9d633);

var $j68Wg = parcelRequire("j68Wg");

var $iyyT5 = parcelRequire("iyyT5");
const $65ea8159edba1b14$export$5ee018e9baf9d633 = (0, $j68Wg.createPaginatedResource)({
    type: 'getListResource',
    getKey: ()=>'getListResource',
    getData: ()=>(0, $iyyT5.getList),
    isBrowserOnly: true
});

});
parcelRegister("j68Wg", function(module, exports) {

$parcel$export(module.exports, "createPaginatedResource", () => $48530d7fdafc340c$export$561b032e4d26d1e8);

var $kJlBc = parcelRequire("kJlBc");
const $48530d7fdafc340c$export$561b032e4d26d1e8 = ({ getData: getData, getKey: getKey, ...arg })=>{
    return (0, $kJlBc.createResource)({
        ...arg,
        getKey: (routerContext, customContext)=>{
            const { query: query } = routerContext;
            const page = query['page'] || '1';
            const key = `${getKey(routerContext, customContext)}#${page}`;
            return key;
        },
        getData: (routerContext, customContext)=>{
            const { query: query } = routerContext;
            const page = parseInt(query['page']) || 1;
            return getData(routerContext, customContext)({
                page: page
            });
        }
    });
};

});

parcelRegister("iyyT5", function(module, exports) {

$parcel$export(module.exports, "getList", () => $d82676ecb56daa22$export$73fffd6dda5144e);
$parcel$export(module.exports, "addIncomingCall", () => $d82676ecb56daa22$export$cdae09ff00c893b2);

var $kRdYM = parcelRequire("kRdYM");

var $jInF8 = parcelRequire("jInF8");
const $d82676ecb56daa22$export$73fffd6dda5144e = ({ page: page })=>{
    const limit = 20;
    const offset = (page - 1) * limit;
    const params = new URLSearchParams({
        offset: `${offset}`,
        limit: `${limit}`,
        sortBy: 'name',
        sort: 'asc'
    });
    const endpoint = `${(0, $jInF8.urls).incomingCall.url()}?${params.toString()}`;
    return (0, $kRdYM.eocFetch)(endpoint).then(({ data: data, count: count })=>{
        return {
            data: data,
            count: Math.ceil(count / limit)
        };
    });
};
const $d82676ecb56daa22$export$cdae09ff00c893b2 = (params)=>{
    return (0, $kRdYM.eocFetch)((0, $jInF8.urls).incomingCall.url(), {
        method: 'POST',
        body: params
    });
};

});


parcelRegister("gIEtO", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('3oUGf')
        ]);
        const value = parcelRequire('aZJA1');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("3oUGf")
    ]).then(()=>parcelRequire('aZJA1'));
}

});

parcelRegister("5VwcT", function(module, exports) {

$parcel$export(module.exports, "byokInformationResource", () => $450b42430aa5bbe4$export$c6b84cb74d1ed3b9);

var $kJlBc = parcelRequire("kJlBc");

var $iGHSf = parcelRequire("iGHSf");
const $450b42430aa5bbe4$export$c6b84cb74d1ed3b9 = (0, $kJlBc.createResource)({
    type: 'byok-information-resource',
    getKey: ()=>'byok-information-resource',
    getData: async ()=>(0, $iGHSf.fetchByokInformation)(),
    maxAge: Infinity,
    isBrowserOnly: true
});

});
parcelRegister("iGHSf", function(module, exports) {

$parcel$export(module.exports, "fetchByokInformation", () => $d9ae2eb310bb2809$export$5244b5a582b643da);

var $kRdYM = parcelRequire("kRdYM");
const $d9ae2eb310bb2809$export$5244b5a582b643da = async ()=>{
    return (0, $kRdYM.eocFetch)('/v1/customers/byok-setting');
};

});


parcelRegister("fwrvW", function(module, exports) {

$parcel$export(module.exports, "downloadAuditLogsResource", () => $b4cf2ff069179b9b$export$304da75014b88b78);

var $kJlBc = parcelRequire("kJlBc");

var $6nbVQ = parcelRequire("6nbVQ");
var $1bJvm = parcelRequire("1bJvm");

var $6f1jS = parcelRequire("6f1jS");
const $b4cf2ff069179b9b$export$304da75014b88b78 = (0, $kJlBc.createResource)({
    type: 'download-audit-logs-resource',
    getKey: ()=>'download-audit-logs-resource',
    getData: async (routerContext)=>{
        const uniqueKey = routerContext.match.params.exportUniqueKey;
        (0, $6nbVQ.assert)(!!uniqueKey, new (0, $1bJvm.AssertionError)('downloadAuditLogs resource', 'uniqueKey must be defined'));
        return (0, $6f1jS.fetchDownloadLinkEndpoint)(uniqueKey);
    },
    maxAge: 0,
    isBrowserOnly: true
});

});
parcelRegister("6f1jS", function(module, exports) {

$parcel$export(module.exports, "fetchDownloadLinkEndpoint", () => $48b52ad089528140$export$c8df7e5942ba1d96);

var $kRdYM = parcelRequire("kRdYM");
const $48b52ad089528140$export$c8df7e5942ba1d96 = async (exportUniqueKey)=>{
    return (0, $kRdYM.eocFetch)(`/v1/logs/export/${exportUniqueKey}/download`, {
        responseType: 'text'
    });
};

});


parcelRegister("5duOT", function(module, exports) {

$parcel$export(module.exports, "logsResource", () => $3cc612d216d5cfe9$export$fd88b4310d3f52ff);

var $kJlBc = parcelRequire("kJlBc");

var $ktnoa = parcelRequire("ktnoa");
const $3cc612d216d5cfe9$export$fd88b4310d3f52ff = (0, $kJlBc.createResource)({
    type: 'ui-get-logs',
    getKey: (routerContext)=>{
        const integrationId = routerContext.match.params.integrationId;
        const urlParam = new URLSearchParams();
        Object.entries(routerContext.query).forEach(([key, value])=>{
            if (value) urlParam.set(key, value);
        });
        return !!integrationId ? `integration-${integrationId}-logs#${urlParam.toString()}` : `ui-get-logs#${urlParam.toString()}`;
    },
    getData: async (routerContext)=>{
        var _routerContext$query, _routerContext$query2, _routerContext$query3, _routerContext$query4, _routerContext$query5, _routerContext$query6, _routerContext$query$, _routerContext$query7, _routerContext$query8, _routerContext$query9, _routerContext$query$2, _routerContext$query10;
        return (0, $ktnoa.fetchLogs)({
            fromUnit: (_routerContext$query = routerContext.query) === null || _routerContext$query === void 0 ? void 0 : _routerContext$query.fromUnit,
            fromValue: (_routerContext$query2 = routerContext.query) === null || _routerContext$query2 === void 0 ? void 0 : _routerContext$query2.fromValue,
            startTimestamp: (_routerContext$query3 = routerContext.query) === null || _routerContext$query3 === void 0 ? void 0 : _routerContext$query3.startTimestamp,
            endTimestamp: (_routerContext$query4 = routerContext.query) === null || _routerContext$query4 === void 0 ? void 0 : _routerContext$query4.endTimestamp,
            eventCategories: (_routerContext$query5 = routerContext.query) === null || _routerContext$query5 === void 0 ? void 0 : _routerContext$query5.eventCategories,
            levels: (_routerContext$query6 = routerContext.query) === null || _routerContext$query6 === void 0 ? void 0 : _routerContext$query6.levels,
            size: (_routerContext$query$ = (_routerContext$query7 = routerContext.query) === null || _routerContext$query7 === void 0 ? void 0 : _routerContext$query7.size) !== null && _routerContext$query$ !== void 0 ? _routerContext$query$ : 30,
            insertedAt: (_routerContext$query8 = routerContext.query) === null || _routerContext$query8 === void 0 ? void 0 : _routerContext$query8.insertedAt,
            searchString: (_routerContext$query9 = routerContext.query) === null || _routerContext$query9 === void 0 ? void 0 : _routerContext$query9.searchString,
            pageDirection: (_routerContext$query$2 = (_routerContext$query10 = routerContext.query) === null || _routerContext$query10 === void 0 ? void 0 : _routerContext$query10.pageDirection) !== null && _routerContext$query$2 !== void 0 ? _routerContext$query$2 : 'NEXT',
            integrationId: routerContext.match.params.integrationId
        });
    },
    maxAge: 60000,
    // 1 minutes,
    isBrowserOnly: true
});

});
parcelRegister("ktnoa", function(module, exports) {

$parcel$export(module.exports, "fetchLogs", () => $ee78a89bdf4675d7$export$b9fcc8145a518db4);

var $kRdYM = parcelRequire("kRdYM");

var $iGiCN = parcelRequire("iGiCN");
const $ee78a89bdf4675d7$export$b9fcc8145a518db4 = async (params)=>{
    const urlParams = (0, $iGiCN.generateLogParams)(params);
    return (0, $kRdYM.eocFetch)('/v1/logs/search?' + urlParams.toString()).then((response)=>(0, $iGiCN.postProcessLogsSearch)(urlParams, response));
};

});
parcelRegister("iGiCN", function(module, exports) {

$parcel$export(module.exports, "isValidTimePeriodFormat", () => $d99a98b6700a46ee$export$2214112898027187);
$parcel$export(module.exports, "getBetweenErrorMessage", () => $d99a98b6700a46ee$export$b29a6f1d6d345720);
$parcel$export(module.exports, "isValidBetweenInput", () => $d99a98b6700a46ee$export$7b619dd534dac336);
$parcel$export(module.exports, "isInvalidDateValue", () => $d99a98b6700a46ee$export$f18cd4bc58b99a27);
$parcel$export(module.exports, "parseGroupOptionQuery", () => $d99a98b6700a46ee$export$f344cca10df5ca13);
$parcel$export(module.exports, "parseOptionQuery", () => $d99a98b6700a46ee$export$100c2d7fc380fbfa);
$parcel$export(module.exports, "collectQueryParamsFromOptions", () => $d99a98b6700a46ee$export$4db9080fab1bce85);
$parcel$export(module.exports, "calculateTimeBetween", () => $d99a98b6700a46ee$export$42dac873831f0e2);
$parcel$export(module.exports, "generateLogParams", () => $d99a98b6700a46ee$export$85293a2f3995ddcc);
$parcel$export(module.exports, "fromUnitConverter", () => $d99a98b6700a46ee$export$ae02811946c03a4b);
$parcel$export(module.exports, "createBaseQuery", () => $d99a98b6700a46ee$export$9a8301702bf003c4);
$parcel$export(module.exports, "calculateNewStartAndEndTimestamp", () => $d99a98b6700a46ee$export$b06db0f8b326b929);
$parcel$export(module.exports, "isDetailsSectionEmpty", () => $d99a98b6700a46ee$export$74cb10c4b9924e49);
$parcel$export(module.exports, "generateParamsForOneMonthInterval", () => $d99a98b6700a46ee$export$130612b33e678a37);
$parcel$export(module.exports, "calculateWidthAccordingToLevel", () => $d99a98b6700a46ee$export$e083dc64e00e053b);
$parcel$export(module.exports, "getSourceStringFromUrl", () => $d99a98b6700a46ee$export$c6631e198cf7c0f4);
$parcel$export(module.exports, "makeMarkup", () => $d99a98b6700a46ee$export$59302306c6f78677);
$parcel$export(module.exports, "postProcessLogsSearch", () => $d99a98b6700a46ee$export$9a858fe3837c0be0);

var $eUqFw = parcelRequire("eUqFw");

var $1ewM9 = parcelRequire("1ewM9");

var $5Okns = parcelRequire("5Okns");

var $7ueqz = parcelRequire("7ueqz");

var $3xcI8 = parcelRequire("3xcI8");

var $fiOXn = parcelRequire("fiOXn");

var $8blac = parcelRequire("8blac");

var $ldoFd = parcelRequire("ldoFd");

var $6nbVQ = parcelRequire("6nbVQ");
var $1bJvm = parcelRequire("1bJvm");

var $b7Kac = parcelRequire("b7Kac");

var $7C9Sv = parcelRequire("7C9Sv");

var $j1eAe = parcelRequire("j1eAe");

var $8C8Hn = parcelRequire("8C8Hn");
// jira-frontend/src/packages/jql-builder-basic-datetime/src/ui/utils/time-functions.tsx
const $d99a98b6700a46ee$var$isNumeric = (value)=>/^\d+$/.test(value);
const $d99a98b6700a46ee$export$2214112898027187 = (timeDigits, timeUnit)=>{
    return timeDigits === '' || timeDigits !== undefined && $d99a98b6700a46ee$var$isNumeric(timeDigits) && parseInt(timeDigits, 10) > -1 && (0, $7C9Sv.RANGE_OPTIONS).includes(timeUnit);
};
const $d99a98b6700a46ee$export$b29a6f1d6d345720 = (intl, value)=>{
    if (!(value !== null && value !== void 0 && value.startDate) && !(value !== null && value !== void 0 && value.endDate)) return intl.formatMessage((0, $8C8Hn.default).validationMessageAtLeastOneValue);
    if (value !== null && value !== void 0 && value.startDate && value !== null && value !== void 0 && value.endDate && new Date(value === null || value === void 0 ? void 0 : value.startDate) > new Date(value === null || value === void 0 ? void 0 : value.endDate)) return intl.formatMessage((0, $8C8Hn.default).validationMessageBeforeGreaterThanAfter);
    if (value && ((value === null || value === void 0 ? void 0 : value.startDate) !== '' && !(0, $7ueqz.default)(new Date(value === null || value === void 0 ? void 0 : value.startDate)) || (value === null || value === void 0 ? void 0 : value.endDate) !== '' && !(0, $7ueqz.default)(new Date(value === null || value === void 0 ? void 0 : value.endDate)))) return intl.formatMessage((0, $8C8Hn.default).validationMessageInvalidDateFormat);
    return undefined;
};
const $d99a98b6700a46ee$export$7b619dd534dac336 = (value)=>{
    if (!(value !== null && value !== void 0 && value.startDate) && !(value !== null && value !== void 0 && value.endDate)) return false;
    if (value !== null && value !== void 0 && value.startDate && value !== null && value !== void 0 && value.endDate && new Date(value === null || value === void 0 ? void 0 : value.startDate) > new Date(value === null || value === void 0 ? void 0 : value.endDate)) return false;
    if (value && ((value === null || value === void 0 ? void 0 : value.startDate) !== '' && !(0, $7ueqz.default)(new Date(value === null || value === void 0 ? void 0 : value.startDate)) || (value === null || value === void 0 ? void 0 : value.endDate) !== '' && !(0, $7ueqz.default)(new Date(value === null || value === void 0 ? void 0 : value.endDate)))) return false;
    return true;
};
const $d99a98b6700a46ee$export$f18cd4bc58b99a27 = (value)=>{
    return !(0, $7ueqz.default)((0, $3xcI8.default)(value)) && value !== '';
};
const $d99a98b6700a46ee$export$760bb1b75585fb94 = (value)=>{
    return value.map((event)=>event.value).join(',');
};
const $d99a98b6700a46ee$export$f344cca10df5ca13 = (query, options)=>{
    if (!query) return [];
    const labels = [];
    options.map((option)=>{
        option.options.map((item)=>labels.push(item));
    });
    return labels.filter((label)=>query.includes(label.value.toString()));
};
const $d99a98b6700a46ee$export$100c2d7fc380fbfa = (query, options)=>{
    if (!query) return [];
    return options.filter((label)=>query.includes(label.value.toString()));
};
const $d99a98b6700a46ee$export$422789958d8174dd = (unit)=>(0, $7C9Sv.RANGE_OPTIONS).includes(unit);
const $d99a98b6700a46ee$export$4db9080fab1bce85 = (options)=>{
    return options.map((option)=>option.value).join(',');
};
const $d99a98b6700a46ee$var$isTimeQueryParamsValid = (params)=>{
    if (params.has('startTimestamp') && params.has('endTimestamp')) return true;
    else if (params.has('fromUnit') && params.has('fromValue')) return true;
    return false;
};
const $d99a98b6700a46ee$export$42dac873831f0e2 = (params)=>{
    const now = new Date();
    if (!params.get('startTimestamp') && !params.get('endTimestamp') && params.get('fromUnit') && params.get('fromValue')) {
        var _params$get;
        const parsedFromValue = parseInt((_params$get = params.get('fromValue')) !== null && _params$get !== void 0 ? _params$get : '1');
        switch(params.get('fromUnit')){
            case 'HOUR':
                params.set('endTimestamp', (now.getTime() * (0, $j1eAe.NANOSECONDS_IN_MILLISECOND)).toString());
                params.set('startTimestamp', ((0, $fiOXn.default)(now, {
                    hours: parsedFromValue
                }).getTime() * (0, $j1eAe.NANOSECONDS_IN_MILLISECOND)).toString());
                break;
            case 'DAY':
                params.set('endTimestamp', (now.getTime() * (0, $j1eAe.NANOSECONDS_IN_MILLISECOND)).toString());
                params.set('startTimestamp', ((0, $fiOXn.default)(now, {
                    days: parsedFromValue
                }).getTime() * (0, $j1eAe.NANOSECONDS_IN_MILLISECOND)).toString());
                break;
            case 'WEEK':
                params.set('endTimestamp', (now.getTime() * (0, $j1eAe.NANOSECONDS_IN_MILLISECOND)).toString());
                params.set('startTimestamp', ((0, $fiOXn.default)(now, {
                    weeks: parsedFromValue
                }).getTime() * (0, $j1eAe.NANOSECONDS_IN_MILLISECOND)).toString());
                break;
            case 'MONTH':
                params.set('endTimestamp', (now.getTime() * (0, $j1eAe.NANOSECONDS_IN_MILLISECOND)).toString());
                params.set('startTimestamp', ((0, $fiOXn.default)(now, {
                    months: parsedFromValue
                }).getTime() * (0, $j1eAe.NANOSECONDS_IN_MILLISECOND)).toString());
                break;
        }
        params.delete('fromUnit');
        params.delete('fromValue');
    }
    return params;
};
const $d99a98b6700a46ee$export$85293a2f3995ddcc = (params)=>{
    const urlParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value])=>{
        if (value) urlParams.append(key, decodeURI(value));
    });
    if (!$d99a98b6700a46ee$var$isTimeQueryParamsValid(urlParams)) {
        // Remove time parameters if exists since they were not matched.
        urlParams.delete('fromUnit');
        urlParams.delete('fromValue');
        urlParams.delete('startTimestamp');
        urlParams.delete('endTimestamp');
        urlParams.append('fromUnit', 'DAY');
        urlParams.append('fromValue', '1');
    }
    return $d99a98b6700a46ee$export$42dac873831f0e2(urlParams);
};
const $d99a98b6700a46ee$var$calculateTimeDifference = (startDate, endDate)=>{
    const minutesDiff = (0, $1ewM9.default)(endDate, startDate);
    if (minutesDiff < 60) return {
        hours: 1,
        days: 0,
        weeks: 0,
        months: 0,
        years: 0
    };
    const hoursDiff = minutesDiff / 60;
    const daysDiff = minutesDiff / 60 / 24;
    const weeksDiff = minutesDiff / 60 / 24 / 7;
    const monthsDiff = minutesDiff / 60 / 24 / 7 / 4;
    return {
        hours: hoursDiff > 0 ? Math.floor(hoursDiff) : 0,
        days: daysDiff > 0 ? Math.floor(daysDiff) : 0,
        weeks: weeksDiff > 0 ? Math.floor(weeksDiff) : 0,
        months: monthsDiff > 0 ? Math.floor(monthsDiff) : 0
    };
};
const $d99a98b6700a46ee$export$ae02811946c03a4b = (startDate, endDate)=>{
    const parsedStartDate = (0, $3xcI8.default)(startDate);
    const parsedEndDate = (0, $3xcI8.default)(endDate);
    const timeDifference = $d99a98b6700a46ee$var$calculateTimeDifference(parsedStartDate, parsedEndDate);
    if (timeDifference.months > 0) return {
        timeUnit: 'MONTH',
        timeDigits: timeDifference.months.toString()
    };
    else if (timeDifference.weeks > 0) return {
        timeUnit: 'WEEK',
        timeDigits: timeDifference.weeks.toString()
    };
    else if (timeDifference.days > 0) return {
        timeUnit: 'DAY',
        timeDigits: timeDifference.days.toString()
    };
    else return {
        timeUnit: 'HOUR',
        timeDigits: timeDifference.hours.toString()
    };
};
const $d99a98b6700a46ee$export$9a8301702bf003c4 = (query)=>{
    let searchQuery = {};
    if (query.searchString) searchQuery = {
        ...searchQuery,
        searchString: query.searchString
    };
    if (query.startTimestamp && query.endTimestamp) searchQuery = {
        ...searchQuery,
        startTimestamp: query.startTimestamp,
        endTimestamp: query.endTimestamp
    };
    if (query.timeType) searchQuery = {
        ...searchQuery,
        timeType: query.timeType
    };
    if (query.eventCategories) searchQuery = {
        ...searchQuery,
        eventCategories: query.eventCategories
    };
    if (query.levels) searchQuery = {
        ...searchQuery,
        levels: query.levels
    };
    if (query.size) searchQuery = {
        ...searchQuery,
        size: query.size
    };
    return searchQuery;
};
function $d99a98b6700a46ee$export$b06db0f8b326b929(startTimestamp, endTimestamp) {
    const startDateIntValue = parseInt(startTimestamp) / (0, $j1eAe.NANOSECONDS_IN_MILLISECOND);
    const endDateIntValue = parseInt(endTimestamp) / (0, $j1eAe.NANOSECONDS_IN_MILLISECOND);
    const { timeDigits: fromValue, timeUnit: fromUnit } = $d99a98b6700a46ee$export$ae02811946c03a4b((0, $5Okns.default)(startDateIntValue), (0, $5Okns.default)(endDateIntValue));
    const params = $d99a98b6700a46ee$export$42dac873831f0e2(new URLSearchParams({
        fromValue: fromValue,
        fromUnit: fromUnit
    }));
    const startTimestampParams = params.get('startTimestamp');
    const endTimestampParams = params.get('endTimestamp');
    (0, $6nbVQ.assert)(!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(startTimestampParams) && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(endTimestampParams), new (0, $1bJvm.AssertionError)('calculateNewStartAndEndTimestamp', 'startTimestamp and endTimestamp should not be null'));
    return {
        startTimestamp: startTimestampParams,
        endTimestamp: endTimestampParams
    };
}
const $d99a98b6700a46ee$export$74cb10c4b9924e49 = (importantField, raw, isImportantFieldEmpty)=>{
    if (!importantField || !raw) return true;
    const parsedImportantField = JSON.parse(importantField);
    const parsedRaw = JSON.parse(raw);
    return ((0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(parsedImportantField) || isImportantFieldEmpty === true) && (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(parsedRaw);
};
const $d99a98b6700a46ee$export$130612b33e678a37 = ()=>{
    const params = $d99a98b6700a46ee$export$42dac873831f0e2(new URLSearchParams({
        fromUnit: 'MONTH',
        fromValue: '1'
    }));
    const startDate = params.get('startTimestamp');
    const endDate = params.get('endTimestamp');
    (0, $6nbVQ.assert)(!!startDate && !!endDate, new (0, $1bJvm.AssertionError)('generateParamsForOneMonthInterval', 'startTimestamp and endDate should not be null'));
    return {
        dateTimeValue: {
            startDate: startDate,
            endDate: endDate
        },
        timeType: (0, $b7Kac.TimeRadioOptions).WITHIN_THE_LAST
    };
};
const $d99a98b6700a46ee$export$e083dc64e00e053b = (level)=>{
    const BASE_OFFSET = 18;
    return `${(0, $j1eAe.DETAIL_ITEM_BASE_WIDTH) - level * BASE_OFFSET}px`;
};
const $d99a98b6700a46ee$export$c6631e198cf7c0f4 = (search)=>{
    const splittedSearch = search.split(/source=/i);
    if (splittedSearch.length > 1) return decodeURIComponent(splittedSearch[1]);
    return '';
};
function $d99a98b6700a46ee$export$59302306c6f78677(fragment, key) {
    const { nodeName: nodeName, nodeType: nodeType, childNodes: childNodes, textContent: textContent } = fragment;
    if (nodeType === Node.TEXT_NODE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
        key: key
    }, textContent);
    const children = [];
    childNodes.forEach((childNode, i)=>{
        const markup = $d99a98b6700a46ee$export$59302306c6f78677(childNode, String(i));
        if (markup) children.push(markup);
    });
    switch(nodeName){
        case 'B':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", {
                key: key
            }, children);
        case 'I':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("i", {
                key: key
            }, children);
        case 'STRONG':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", {
                key: key
            }, children);
        case 'EM':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("em", {
                key: key
            }, children);
        case 'CODE':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("code", {
                key: key
            }, children);
    }
    if (children.length === 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
        key: key
    }, children[0]);
    if (children.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        key: key
    }, children);
    return null;
}
const $d99a98b6700a46ee$export$9a858fe3837c0be0 = (urlParams, response)=>{
    if (urlParams.get('startTimestamp') && urlParams.get('endTimestamp')) return {
        ...response,
        data: {
            ...response.data,
            pagination: {
                ...response.data.pagination,
                calcStartDate: urlParams.get('startTimestamp'),
                calcEndDate: urlParams.get('endTimestamp')
            }
        }
    };
    return response;
};

});
parcelRegister("b7Kac", function(module, exports) {

$parcel$export(module.exports, "TimeRadioOptions", () => $8194284998588690$export$ff1338756af30600);
let $8194284998588690$export$ff1338756af30600 = /*#__PURE__*/ function(TimeRadioOptions) {
    TimeRadioOptions["WITHIN_THE_LAST"] = "withinTheLast";
    TimeRadioOptions["BETWEEN"] = "between";
    return TimeRadioOptions;
}({});

});

parcelRegister("7C9Sv", function(module, exports) {

$parcel$export(module.exports, "RANGE_OPTIONS", () => $58b3be94a962b770$export$a0f3448347834e6b);
const $58b3be94a962b770$export$a0f3448347834e6b = [
    'HOUR',
    'DAY',
    'WEEK',
    'MONTH'
];

});

parcelRegister("j1eAe", function(module, exports) {

$parcel$export(module.exports, "PAGE_SIZE_QUERY_PARAM", () => $dd896c4a5621dbe3$export$4b254bc84a71033a);
$parcel$export(module.exports, "NANOSECONDS_IN_MILLISECOND", () => $dd896c4a5621dbe3$export$753f41e31eccb6d7);
$parcel$export(module.exports, "getHeaderWidths", () => $dd896c4a5621dbe3$export$8aa6dbdb947f7df1);
$parcel$export(module.exports, "DETAIL_ITEM_BASE_WIDTH", () => $dd896c4a5621dbe3$export$1220f90483bde21);

var $XHGTv = parcelRequire("XHGTv");
const $dd896c4a5621dbe3$export$4b254bc84a71033a = 'size';
const $dd896c4a5621dbe3$export$753f41e31eccb6d7 = 1000000;
const $dd896c4a5621dbe3$export$8aa6dbdb947f7df1 = (params)=>{
    const { DATE_HEADER_WIDTH: DATE_HEADER_WIDTH, CATEGORY_HEADER_WIDTH: CATEGORY_HEADER_WIDTH, TYPE_HEADER_WIDTH: TYPE_HEADER_WIDTH, ACTOR_HEADER_WIDTH: ACTOR_HEADER_WIDTH } = params.showEventCategoryField ? {
        // Widths for audit logs page
        DATE_HEADER_WIDTH: 16,
        CATEGORY_HEADER_WIDTH: 16,
        TYPE_HEADER_WIDTH: 10,
        ACTOR_HEADER_WIDTH: 16
    } : {
        // Widths for integration-specific log page
        DATE_HEADER_WIDTH: 14,
        CATEGORY_HEADER_WIDTH: 0,
        // This category is not visible in this page
        TYPE_HEADER_WIDTH: 12,
        ACTOR_HEADER_WIDTH: 22
    };
    const columnsToShow = [
        DATE_HEADER_WIDTH,
        CATEGORY_HEADER_WIDTH,
        TYPE_HEADER_WIDTH,
        ...(0, $XHGTv.getBooleanFF)('platform.pun.audit-logs-actor-column_sxmw6') ? [
            ACTOR_HEADER_WIDTH
        ] : []
    ];
    let sum = 0;
    columnsToShow.forEach((width)=>{
        sum += width;
    });
    return {
        DATE_HEADER_WIDTH: `${DATE_HEADER_WIDTH}%`,
        CATEGORY_HEADER_WIDTH: `${CATEGORY_HEADER_WIDTH}%`,
        TYPE_HEADER_WIDTH: `${TYPE_HEADER_WIDTH}%`,
        ACTOR_HEADER_WIDTH: `${ACTOR_HEADER_WIDTH}%`,
        CHANGE_SUMMARY_HEADER_WIDTH: `${100 - sum}%`
    };
};
const $dd896c4a5621dbe3$export$1220f90483bde21 = 250;

});

parcelRegister("8C8Hn", function(module, exports) {

$parcel$export(module.exports, "default", () => $64589eb7468e503c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $64589eb7468e503c$var$messages = (0, $90IgZ.defineMessages)({
    validationMessageBeforeGreaterThanAfter: {
        id: `eoc.customer-logs.common.utils.validation-message-before-greater-than-after.no-translate`,
        defaultMessage: 'Specify a valid time range.',
        description: 'Message displayed to the user when the Before date used is greater than the after date while specifying dates'
    },
    validationMessageInvalidDateFormat: {
        id: `eoc.customer-logs.common.utils.validation-message-invalid-date-format.no-translate`,
        defaultMessage: 'Invalid date format.',
        description: 'Invalid date format.'
    },
    validationMessageAtLeastOneValue: {
        id: `eoc.customer-logs.common.utils.validation-message-at-least-one-value.no-translate`,
        defaultMessage: 'Select at least one value.',
        description: 'Message displayed to the user when there is no selected before and end date together'
    }
});
var $64589eb7468e503c$export$2e2bcd8739ae039 = $64589eb7468e503c$var$messages;

});




parcelRegister("3Vasl", function(module, exports) {

$parcel$export(module.exports, "uiSettingsResource", () => $2daece569d641c5f$export$f2b33518cf31cd40);

var $kJlBc = parcelRequire("kJlBc");

var $bng6h = parcelRequire("bng6h");
const $2daece569d641c5f$export$f2b33518cf31cd40 = (0, $kJlBc.createResource)({
    type: 'ui-settings-resource',
    getKey: ()=>'ui-settings-resource',
    getData: async ()=>(0, $bng6h.fetchUiSettingsEndpoint)(),
    maxAge: Infinity,
    isBrowserOnly: true
});

});
parcelRegister("bng6h", function(module, exports) {

$parcel$export(module.exports, "fetchUiSettingsEndpoint", () => $847e54e313f9196d$export$ea2f12bcbdce2020);

var $kRdYM = parcelRequire("kRdYM");
const $847e54e313f9196d$export$ea2f12bcbdce2020 = async ()=>{
    return (0, $kRdYM.eocFetch)('/v1/logs');
};

});


parcelRegister("feAZB", function(module, exports) {

$parcel$export(module.exports, "resources", () => $b174dbc84baa5f27$export$bc99aaabaf7b70a7);

var $882n3 = parcelRequire("882n3");

var $9Klcf = parcelRequire("9Klcf");

var $a7oew = parcelRequire("a7oew");
const $b174dbc84baa5f27$export$bc99aaabaf7b70a7 = {
    configuredIntegrationsResource: $882n3.configuredIntegrationsResource,
    integrationListResource: $9Klcf.integrationListResource,
    userAccessRightsResource: $a7oew.userAccessRightsResource
};

});
parcelRegister("882n3", function(module, exports) {

$parcel$export(module.exports, "configuredIntegrationsResource", () => $5eb0e8e4f698258f$export$4136019b80be5917);

var $kJlBc = parcelRequire("kJlBc");

var $7B7ri = parcelRequire("7B7ri");

var $dWMl3 = parcelRequire("dWMl3");

const $5eb0e8e4f698258f$export$4136019b80be5917 = (0, $kJlBc.createResource)({
    type: 'configuredIntegrationsResource',
    getKey: ({ query: query, match: match })=>{
        var _match$params$teamId;
        const teamId = (_match$params$teamId = match.params.teamId) !== null && _match$params$teamId !== void 0 ? _match$params$teamId : query['teamId'];
        const group = query['group'];
        const keyword = query['keyword'];
        const status = query['status'];
        const page = query['page'] || '1';
        return (0, $7B7ri.UrlHelper)((0, $172fcd82c85e6d97$export$bc7daa294a7c75e4), {
            [(0, $172fcd82c85e6d97$export$d26137cf824a9e53)]: page,
            [(0, $172fcd82c85e6d97$export$299579ccbdd63cbc)]: keyword,
            [(0, $172fcd82c85e6d97$export$d7415cfdee4bffc8)]: group,
            [(0, $172fcd82c85e6d97$export$ce2c93e90dda8613)]: status,
            [(0, $172fcd82c85e6d97$export$4e0ddb4dc97eb573)]: teamId
        });
    },
    getData: (routerContext)=>(0, $dWMl3.default).getIntegrations(routerContext.query, routerContext.match.params.teamId),
    maxAge: 300000,
    // 5 mins
    isBrowserOnly: true
});

});
parcelRegister("7B7ri", function(module, exports) {

$parcel$export(module.exports, "UrlHelper", () => $5881c25caf58e765$export$bacbc496e850c0a4);
const $5881c25caf58e765$export$bacbc496e850c0a4 = (path, params = {})=>{
    // https://github.com/microsoft/TypeScript/issues/16655
    const q = Object.entries(params).map(([k, v])=>v !== '' && !!v || v === false ? [
            k,
            v.toString()
        ] : undefined).filter((v)=>!!v);
    // Using %2C in URLs causes bugs in AngularJS, so we need to replace it with comma
    const qs = new URLSearchParams(q).toString().replace(/%2C/g, ',');
    return `${path}${qs ? `?${qs}` : ''}`;
};

});

parcelRegister("dWMl3", function(module, exports) {

$parcel$export(module.exports, "default", () => $a276302a61c921fd$export$2e2bcd8739ae039);

var $kRdYM = parcelRequire("kRdYM");

var $7B7ri = parcelRequire("7B7ri");

const $a276302a61c921fd$var$getIntegrations = async (query, pathParamTeamId)=>{
    const page = parseInt(query['page']) || 1;
    const offset = (page - 1) * (0, $48abc7f512db9954$export$31ecae7225aecec6);
    const queryParams = query ? {
        teamId: pathParamTeamId !== null && pathParamTeamId !== void 0 ? pathParamTeamId : query.teamId,
        group: query.group,
        keyword: query.keyword,
        status: query.status
    } : {};
    return (0, $kRdYM.eocFetch)((0, $7B7ri.UrlHelper)('/v3/integrations/unified', {
        ...queryParams,
        offset: offset.toString(),
        // UrlHelper omits 0 as number since it is a falsy value
        limit: (0, $48abc7f512db9954$export$31ecae7225aecec6)
    })).then((response)=>({
            data: response.data.integrations,
            pageCount: Math.ceil(response.data.count / (0, $48abc7f512db9954$export$31ecae7225aecec6)),
            itemCount: response.data.count,
            platformTeamId: response.data.platformTeamId
        }));
};
const $a276302a61c921fd$var$patchIntegration = async (integrationId, integrationType, body, teamId)=>(0, $kRdYM.eocFetch)((0, $7B7ri.UrlHelper)(`/v3/integrations/unified/${integrationId}`, {
        type: integrationType,
        teamId: teamId
    }), {
        method: 'PATCH',
        body: body
    }).then((response)=>response.data);
const $a276302a61c921fd$var$deleteIntegration = async (integrationId, integrationType, teamId)=>(0, $kRdYM.eocFetch)((0, $7B7ri.UrlHelper)(`/v3/integrations/unified/${integrationId}`, {
        type: integrationType,
        teamId: teamId
    }), {
        method: 'DELETE',
        responseType: 'headers'
    });
var $a276302a61c921fd$export$2e2bcd8739ae039 = {
    getIntegrations: $a276302a61c921fd$var$getIntegrations,
    patchIntegration: $a276302a61c921fd$var$patchIntegration,
    deleteIntegration: $a276302a61c921fd$var$deleteIntegration
};

});
const $48abc7f512db9954$export$31ecae7225aecec6 = 20;


const $172fcd82c85e6d97$export$bc7daa294a7c75e4 = 'configuredIntegrationsResource';
const $172fcd82c85e6d97$export$d26137cf824a9e53 = 'page';
const $172fcd82c85e6d97$export$299579ccbdd63cbc = 'keyword';
const $172fcd82c85e6d97$export$d7415cfdee4bffc8 = 'group';
const $172fcd82c85e6d97$export$ce2c93e90dda8613 = 'status';
const $172fcd82c85e6d97$export$4e0ddb4dc97eb573 = 'teamId';


parcelRegister("9Klcf", function(module, exports) {

$parcel$export(module.exports, "integrationListResource", () => $7188da1a5bf264e1$export$f60a40a11a6e0ee4);

var $kJlBc = parcelRequire("kJlBc");

var $4X9cO = parcelRequire("4X9cO");
const $7188da1a5bf264e1$export$f60a40a11a6e0ee4 = (0, $kJlBc.createResource)({
    type: 'integrationListResource',
    getKey: ({ query: query })=>{
        const group = query['group'];
        const keyword = query['keyword'];
        return `integrationListResource?group=${group}&keyword=${keyword}`;
    },
    getData: async (routerContext)=>await (0, $4X9cO.default).getIntegrationList(routerContext.query, routerContext.match.params.teamId),
    maxAge: 300000,
    // 5 minutes
    isBrowserOnly: true
});

});
parcelRegister("4X9cO", function(module, exports) {

$parcel$export(module.exports, "default", () => $39b3d02b08043445$export$2e2bcd8739ae039);

var $kRdYM = parcelRequire("kRdYM");

var $7B7ri = parcelRequire("7B7ri");
const $39b3d02b08043445$var$getIntegrationList = (query, teamId)=>{
    const { keyword: keyword, group: group } = query !== null && query !== void 0 ? query : {};
    return (0, $kRdYM.eocFetch)((0, $7B7ri.UrlHelper)(`/v3/integrations/unified/supported-integrations`, {
        keyword: keyword,
        group: group,
        teamId: teamId
    })).then((response)=>{
        const { labels: labels, availableGroups: availableGroups, allTypes: allTypes, platformTeamId: platformTeamId } = response.data;
        return {
            labels: labels,
            availableGroups: availableGroups,
            allTypes: allTypes,
            platformTeamId: platformTeamId
        };
    });
};
const $39b3d02b08043445$var$getIntegrationTypes = (integrationType, teamId)=>(0, $kRdYM.eocFetch)((0, $7B7ri.UrlHelper)(`/v3/integrations/unified/${integrationType}/types`, {
        teamId: teamId
    })).then((response)=>response.data.map((integrationType)=>({
                ...integrationType,
                value: integrationType.type,
                label: integrationType.displayName
            })));
var $39b3d02b08043445$export$2e2bcd8739ae039 = {
    getIntegrationList: $39b3d02b08043445$var$getIntegrationList,
    getIntegrationTypes: $39b3d02b08043445$var$getIntegrationTypes
};

});


parcelRegister("a7oew", function(module, exports) {

$parcel$export(module.exports, "userAccessRightsResource", () => $75dd5b093fd1d876$export$69ddc7cc64ae9a02);

var $kJlBc = parcelRequire("kJlBc");

var $eNcq7 = parcelRequire("eNcq7");
const $75dd5b093fd1d876$export$69ddc7cc64ae9a02 = (0, $kJlBc.createResource)({
    type: 'userAccessRightsResource',
    getKey: (routerContext)=>{
        const teamId = routerContext.match.params.teamId;
        return `userAccessRightsResource#${!!teamId ? teamId : ''}`;
    },
    getData: (routerContext)=>(0, $eNcq7.getUserRights)(routerContext.match.params.teamId),
    maxAge: 3600000,
    // 1 hour
    isBrowserOnly: true
});

});
parcelRegister("eNcq7", function(module, exports) {

$parcel$export(module.exports, "getUserRights", () => $ac4f46acb2da61e2$export$84e2ed279bc4e64e);

var $kRdYM = parcelRequire("kRdYM");

var $7B7ri = parcelRequire("7B7ri");
const $ac4f46acb2da61e2$export$84e2ed279bc4e64e = (teamId)=>{
    return (0, $kRdYM.eocFetch)((0, $7B7ri.UrlHelper)(`/v3/integrations/unified/rights`, {
        teamId: teamId
    })).then((response)=>response.data);
};

});



parcelRegister("2OmMO", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('ie5fc')
        ]);
        const value = parcelRequire('jvF4C');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("ie5fc")
    ]).then(()=>parcelRequire('jvF4C'));
}

});

parcelRegister("krDiu", function(module, exports) {

$parcel$export(module.exports, "maintenanceResource", () => $ee24cfe08cf1b6fd$export$5486c78261efb2c3);
$parcel$export(module.exports, "maintenanceUserRightsResource", () => $ee24cfe08cf1b6fd$export$e4c92d8948e3625);
$parcel$export(module.exports, "resources", () => $ee24cfe08cf1b6fd$export$bc99aaabaf7b70a7);

var $kJlBc = parcelRequire("kJlBc");

var $l96PT = parcelRequire("l96PT");

var $7ggZM = parcelRequire("7ggZM");
const $ee24cfe08cf1b6fd$export$5486c78261efb2c3 = (0, $kJlBc.createResource)({
    type: 'maintenanceResource',
    getKey: (routerContext)=>{
        var _routerContext$match$;
        const teamId = (_routerContext$match$ = routerContext.match.params) === null || _routerContext$match$ === void 0 ? void 0 : _routerContext$match$.teamId;
        return `maintenance/${teamId !== null && teamId !== void 0 ? teamId : ''}`;
    },
    getData: async (routerContext)=>{
        var _routerContext$match$2;
        const teamId = (_routerContext$match$2 = routerContext.match.params) === null || _routerContext$match$2 === void 0 ? void 0 : _routerContext$match$2.teamId;
        return (0, $7ggZM.getMaintenance)(teamId);
    },
    isBrowserOnly: true
});
const $ee24cfe08cf1b6fd$export$e4c92d8948e3625 = (0, $kJlBc.createResource)({
    type: 'maintenanceUserRightsResource',
    getKey: (routerContext)=>{
        var _routerContext$match$3;
        const teamId = (_routerContext$match$3 = routerContext.match.params) === null || _routerContext$match$3 === void 0 ? void 0 : _routerContext$match$3.teamId;
        return `maintenance-user-rights/${teamId !== null && teamId !== void 0 ? teamId : ''}`;
    },
    getData: async (routerContext)=>{
        var _routerContext$match$4;
        const teamId = (_routerContext$match$4 = routerContext.match.params) === null || _routerContext$match$4 === void 0 ? void 0 : _routerContext$match$4.teamId;
        return (0, $7ggZM.getMaintenanceUserRights)(teamId);
    },
    isBrowserOnly: true
});
const $ee24cfe08cf1b6fd$export$bc99aaabaf7b70a7 = [
    ...(0, $l96PT.eocCommonResources)(),
    $ee24cfe08cf1b6fd$export$5486c78261efb2c3,
    $ee24cfe08cf1b6fd$export$e4c92d8948e3625
];

});
parcelRegister("7ggZM", function(module, exports) {

$parcel$export(module.exports, "getMaintenance", () => $549735f953d2f180$export$9cc878e1852c5ee1);
$parcel$export(module.exports, "deleteMaintenance", () => $549735f953d2f180$export$f64242288df38e86);
$parcel$export(module.exports, "cancelMaintenance", () => $549735f953d2f180$export$2d4a5362bda1b3c1);
$parcel$export(module.exports, "changeDateAndTime", () => $549735f953d2f180$export$2162fcbd04e23a3d);
$parcel$export(module.exports, "getMaintenanceUserRights", () => $549735f953d2f180$export$60048f3b7e7bf9b9);
$parcel$export(module.exports, "createMaintenance", () => $549735f953d2f180$export$602dd976bd963418);
$parcel$export(module.exports, "updateMaintenance", () => $549735f953d2f180$export$fa55cd063e1b15c2);

var $kRdYM = parcelRequire("kRdYM");
const $549735f953d2f180$export$9cc878e1852c5ee1 = (teamId)=>{
    return (0, $kRdYM.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances`);
};
const $549735f953d2f180$export$f64242288df38e86 = (teamId, id)=>{
    return (0, $kRdYM.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/${id}`, {
        method: 'DELETE',
        responseType: 'headers'
    });
};
const $549735f953d2f180$export$2d4a5362bda1b3c1 = (teamId, id)=>{
    return (0, $kRdYM.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/${id}/cancel`, {
        method: 'PATCH'
    });
};
const $549735f953d2f180$export$2162fcbd04e23a3d = (teamId, id, endDate)=>{
    return (0, $kRdYM.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/${id}/updateEndDate`, {
        method: 'PATCH',
        body: {
            endDate: endDate
        }
    });
};
const $549735f953d2f180$export$60048f3b7e7bf9b9 = (teamId)=>{
    return (0, $kRdYM.eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/rights`);
};
const $549735f953d2f180$export$602dd976bd963418 = (payload, teamId)=>{
    const url = teamId ? `/v1/teams/${teamId}/maintenances` : '/v1/maintenances';
    return (0, $kRdYM.eocFetch)(url, {
        method: 'POST',
        body: payload
    });
};
const $549735f953d2f180$export$fa55cd063e1b15c2 = (payload, id, teamId)=>{
    const url = teamId ? `/v1/teams/${teamId}/maintenances/${id}` : `/v1/maintenances/${id}`;
    return (0, $kRdYM.eocFetch)(url, {
        method: 'PUT',
        body: payload
    });
};

});


parcelRegister("cUdAf", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('b1W8G')
        ]);
        const value = parcelRequire('6Gps5');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("b1W8G")
    ]).then(()=>parcelRequire('6Gps5'));
}

});

parcelRegister("3tXdL", function(module, exports) {

$parcel$export(module.exports, "getTeamResource", () => $28920496611c8dc9$export$50271c9e7f21f10e);
$parcel$export(module.exports, "resources", () => $28920496611c8dc9$export$bc99aaabaf7b70a7);

var $kJlBc = parcelRequire("kJlBc");

var $6nbVQ = parcelRequire("6nbVQ");
var $1bJvm = parcelRequire("1bJvm");

var $gBxFN = parcelRequire("gBxFN");

var $2ggRQ = parcelRequire("2ggRQ");

var $kuw5H = parcelRequire("kuw5H");
const $28920496611c8dc9$export$50271c9e7f21f10e = (0, $kJlBc.createResource)({
    type: 'getTeamResource',
    getKey: ()=>'getTeamResource',
    getData: async (routerContext)=>{
        var _routerContext$match$;
        const teamId = (_routerContext$match$ = routerContext.match.params) === null || _routerContext$match$ === void 0 ? void 0 : _routerContext$match$.teamId;
        (0, $6nbVQ.assert)(!!teamId, new (0, $1bJvm.AssertionError)('getTeamResource', 'teamId should be set to fetch on-call'));
        return (0, $kuw5H.getTeam)(teamId);
    },
    isBrowserOnly: true
});
const $28920496611c8dc9$export$bc99aaabaf7b70a7 = [
    ...(0, $2ggRQ.resources),
    (0, $gBxFN.routingRulesResource),
    $28920496611c8dc9$export$50271c9e7f21f10e
];

});
parcelRegister("gBxFN", function(module, exports) {

$parcel$export(module.exports, "routingRulesResource", () => $c16a38d98fdee0f4$export$7f38c73dca88500e);

var $kJlBc = parcelRequire("kJlBc");

var $6nbVQ = parcelRequire("6nbVQ");
var $1bJvm = parcelRequire("1bJvm");

var $g3BxM = parcelRequire("g3BxM");
const $c16a38d98fdee0f4$export$7f38c73dca88500e = (0, $kJlBc.createResource)({
    type: 'routingRulesResource',
    getKey: ()=>'routingRulesResource',
    getData: async (routerContext)=>{
        var _routerContext$match$;
        const teamId = (_routerContext$match$ = routerContext.match.params) === null || _routerContext$match$ === void 0 ? void 0 : _routerContext$match$.teamId;
        (0, $6nbVQ.assert)(!!teamId, new (0, $1bJvm.AssertionError)('routingRulesResource', 'teamId should be set to fetch routing-rules'));
        return (0, $g3BxM.getRoutingRules)(teamId);
    },
    isBrowserOnly: true
});

});
parcelRegister("g3BxM", function(module, exports) {

$parcel$export(module.exports, "getRoutingRules", () => $bb0a0c954d369d49$export$425c24c86196521);

var $kRdYM = parcelRequire("kRdYM");
const $bb0a0c954d369d49$export$425c24c86196521 = (teamId)=>(0, $kRdYM.eocFetch)(`/v1/teams/${teamId}/routing-rules`);

});


parcelRegister("2ggRQ", function(module, exports) {

$parcel$export(module.exports, "getSchedulesResource", () => $1a5a28ecb853800f$export$6b2b3e2a53cc13e2);
$parcel$export(module.exports, "getUiPreferencesResource", () => $1a5a28ecb853800f$export$5c6454d866055bdd);
$parcel$export(module.exports, "getScheduleRightsResource", () => $1a5a28ecb853800f$export$9d9ecb8586783931);
$parcel$export(module.exports, "getScheduleTimeTemplatesResource", () => $1a5a28ecb853800f$export$90251855f07c54b4);
$parcel$export(module.exports, "resources", () => $1a5a28ecb853800f$export$bc99aaabaf7b70a7);

var $kJlBc = parcelRequire("kJlBc");

var $l96PT = parcelRequire("l96PT");

var $33WMu = parcelRequire("33WMu");

var $34S64 = parcelRequire("34S64");

var $jRQME = parcelRequire("jRQME");

var $7nAEZ = parcelRequire("7nAEZ");

var $euQGd = parcelRequire("euQGd");

var $bfa2B = parcelRequire("bfa2B");
const $1a5a28ecb853800f$export$6b2b3e2a53cc13e2 = (0, $kJlBc.createResource)({
    type: 'getSchedulesResource',
    getKey: ()=>'getSchedulesResource',
    isBrowserOnly: true,
    getData: async (routerExtendedContext)=>(0, $7nAEZ.endpoints).getScheduleList((0, $34S64.getTeamIdFromContext)(routerExtendedContext))
});
const $1a5a28ecb853800f$export$5c6454d866055bdd = (0, $kJlBc.createResource)({
    type: 'getSchedulePreferencesResource',
    getKey: ()=>'getSchedulePreferencesResource',
    isBrowserOnly: true,
    getData: async (routerExtendedContext)=>(0, $euQGd.endpoints).getUiPreferences((0, $34S64.getTeamIdFromContext)(routerExtendedContext))
});
const $1a5a28ecb853800f$export$9d9ecb8586783931 = (0, $kJlBc.createResource)({
    type: 'getScheduleRightsResource',
    getKey: ()=>'getScheduleRightsResource',
    isBrowserOnly: true,
    getData: async (routerExtendedContext)=>(0, $bfa2B.endpoints).getScheduleRights((0, $34S64.getTeamIdFromContext)(routerExtendedContext))
});
const $1a5a28ecb853800f$export$90251855f07c54b4 = (0, $kJlBc.createResource)({
    type: 'getScheduleTimeTemplatesResource',
    getKey: ()=>'getScheduleTimeTemplatesResourceurce',
    isBrowserOnly: true,
    getData: async ()=>(0, $jRQME.endpoints).getScheduleTimeTemplates()
});
const $1a5a28ecb853800f$export$bc99aaabaf7b70a7 = [
    $1a5a28ecb853800f$export$6b2b3e2a53cc13e2,
    $1a5a28ecb853800f$export$5c6454d866055bdd,
    $1a5a28ecb853800f$export$9d9ecb8586783931,
    $1a5a28ecb853800f$export$90251855f07c54b4,
    ...(0, $33WMu.resources),
    ...(0, $l96PT.eocCommonResources)()
];

});
parcelRegister("33WMu", function(module, exports) {

$parcel$export(module.exports, "getTimezonesResource", () => $23af3f97cd43c2b1$export$7524ea9fda8149c6);
$parcel$export(module.exports, "resources", () => $23af3f97cd43c2b1$export$bc99aaabaf7b70a7);

var $kJlBc = parcelRequire("kJlBc");

var $4s01U = parcelRequire("4s01U");
const $23af3f97cd43c2b1$export$7524ea9fda8149c6 = (0, $kJlBc.createResource)({
    type: 'getEocTimezonesResource',
    getKey: ()=>'getEocTimezonesResource',
    isBrowserOnly: true,
    getData: async ()=>(0, $4s01U.endpoints).getTimezones()
});
const $23af3f97cd43c2b1$export$bc99aaabaf7b70a7 = [
    $23af3f97cd43c2b1$export$7524ea9fda8149c6
];

});
parcelRegister("4s01U", function(module, exports) {

$parcel$export(module.exports, "endpoints", () => $33d9ccdc0dcef1a4$export$3a2536d80ecc00e7);

var $kRdYM = parcelRequire("kRdYM");

var $iXduF = parcelRequire("iXduF");
const $33d9ccdc0dcef1a4$var$getTimezones = async ()=>{
    const response = await (0, $kRdYM.eocFetch)((0, $iXduF.urls).customers.timezones.url());
    // NOTE: convert offset from minutes to millis
    const adjusted = response.timezones.map((timezone)=>({
            ...timezone,
            offset: timezone.offset * 60000
        }));
    return {
        ...response,
        timezones: adjusted
    };
};
const $33d9ccdc0dcef1a4$export$3a2536d80ecc00e7 = {
    getTimezones: $33d9ccdc0dcef1a4$var$getTimezones
};

});
parcelRegister("iXduF", function(module, exports) {

$parcel$export(module.exports, "urls", () => $dcc83442980a7259$export$bcae9ba627f604b6);
const $dcc83442980a7259$export$bcae9ba627f604b6 = Object.freeze({
    alerts: {
        responders: {
            names: {
                url: ()=>'/v1/alerts/responders/names'
            },
            autoComplete: {
                url: ()=>'/v1/alerts/responders/auto-complete'
            }
        }
    },
    customers: {
        timezones: {
            url: ()=>'/v1/customers/timezones'
        }
    }
});

});



parcelRegister("34S64", function(module, exports) {

$parcel$export(module.exports, "getTeamIdFromContext", () => $23dbb550d17184f8$export$3ea727bebc3792bb);

var $6nbVQ = parcelRequire("6nbVQ");
var $1bJvm = parcelRequire("1bJvm");

var $bnXWt = parcelRequire("bnXWt");
const $23dbb550d17184f8$export$3ea727bebc3792bb = (routerContext)=>{
    const teamId = (0, $bnXWt.getSafe)(()=>routerContext.match.params.teamId, null);
    (0, $6nbVQ.assert)(!(0, $bnXWt.isEmpty)(teamId), new (0, $1bJvm.AssertionError)('eoc-schedule', 'teamId in routerContext is not defined'));
    return teamId;
};

});
parcelRegister("bnXWt", function(module, exports) {

$parcel$export(module.exports, "getSafe", () => $84a056f45843e027$export$fedb900c0ea4e699);
$parcel$export(module.exports, "isEmpty", () => $84a056f45843e027$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "isNullOrUndefined", () => $84a056f45843e027$export$bedb7023a7733221);
$parcel$export(module.exports, "noLeadingOrTrailingSpaces", () => $84a056f45843e027$export$5fc068d42db64a99);

var $1B6Fl = parcelRequire("1B6Fl");
const $84a056f45843e027$export$fedb900c0ea4e699 = (fn, defaultValue)=>{
    try {
        return fn();
    } catch  {
        return defaultValue;
    }
};
const $84a056f45843e027$export$dd1bc94b04021eeb = (input)=>{
    if (input !== 0 && input !== false && !input) return true;
    if (!(input instanceof Date) && typeof input === 'object' && Object.keys(input).length === 0) return true;
    return false;
};
const $84a056f45843e027$export$bedb7023a7733221 = (input)=>{
    return input === null || input === undefined;
};
const $84a056f45843e027$export$5fc068d42db64a99 = (message)=>({ formatMessage: formatMessage })=>(value)=>{
            if (typeof value === 'string' && (value.startsWith(' ') || value.endsWith(' '))) return message !== null && message !== void 0 ? message : formatMessage((0, $1B6Fl.messages).nameSpaceValidationError);
        };

});
parcelRegister("1B6Fl", function(module, exports) {

$parcel$export(module.exports, "messages", () => $129e6adc64eb865f$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $129e6adc64eb865f$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    /*
    Misc common messages
   */ noOne: {
        id: 'eoc-schedule.common.no-one.non-final',
        defaultMessage: 'No one',
        description: 'Name of the user whose type is no-one.'
    },
    error: {
        id: 'eoc-schedule.common.error.non-final',
        defaultMessage: 'Error',
        description: 'Just simple error message.'
    },
    tryAgain: {
        id: 'eoc-schedule.common.try-again.non-final',
        defaultMessage: 'Try again',
        description: 'Try again message when an error occurs.'
    },
    cancel: {
        id: 'eoc-schedule.common.cancel.non-final',
        defaultMessage: 'Cancel',
        description: 'A cancel button.'
    },
    confirm: {
        id: 'eoc-schedule.common.confirm.non-final',
        defaultMessage: 'Confirm',
        description: 'A confirm button.'
    },
    addOverride: {
        id: 'eoc-schedule.common.add-override.non-final',
        defaultMessage: 'Add override',
        description: 'Adding override for a period item.'
    },
    overrideButton: {
        id: 'eoc-schedule.common.override.non-final',
        defaultMessage: 'Override',
        description: 'A override button.'
    },
    saveButton: {
        id: 'eoc-schedule.common.save.non-final',
        defaultMessage: 'Save',
        description: 'A save button.'
    },
    edit: {
        id: 'eoc-schedule.common.edit.non-final',
        defaultMessage: 'Edit',
        description: 'Button for editing schedule.'
    },
    turnOff: {
        id: 'eoc-schedule.common.turn-off.non-final',
        defaultMessage: 'Turn off',
        description: 'Button for turn-offing schedule.'
    },
    turnOn: {
        id: 'eoc-schedule.common.turn-on.non-final',
        defaultMessage: 'Turn on',
        description: 'Button for turn-on schedule.'
    },
    delete: {
        id: 'eoc-schedule.common.delete.non-final',
        defaultMessage: 'Delete',
        description: 'Button for deleting schedule or rotation.'
    },
    duplicate: {
        id: 'eoc-schedule.common.duplicate.non-final',
        defaultMessage: 'Duplicate',
        description: 'Button for duplicating schedule or rotation.'
    },
    remove: {
        id: 'eoc-schedule.common.remove.non-final',
        defaultMessage: 'Remove',
        description: 'Button for removing participant.'
    },
    start: {
        id: 'eoc-schedule.common.start.non-final',
        defaultMessage: 'Start',
        description: 'Label for start time and date.'
    },
    end: {
        id: 'eoc-schedule.common.end.non-final',
        defaultMessage: 'End',
        description: 'Label for end time and date.'
    },
    startTime: {
        id: 'eoc-schedule.common.start-time.non-final',
        defaultMessage: 'Start time',
        description: 'Label for start time and date.'
    },
    endTime: {
        id: 'eoc-schedule.common.end-time.non-final',
        defaultMessage: 'End time',
        description: 'Label for end time and date.'
    },
    startDate: {
        id: 'eoc-schedule.common.start-date.non-final',
        defaultMessage: 'Start date',
        description: 'Label for start time and date.'
    },
    endDate: {
        id: 'eoc-schedule.common.end-date.non-final',
        defaultMessage: 'End date',
        description: 'Label for end time and date.'
    },
    team: {
        id: 'eoc-schedule.common.team.non-final',
        defaultMessage: 'Team',
        description: 'Label that indicates responder is of type: Team'
    },
    escalation: {
        id: 'eoc-schedule.common.escalation.non-final',
        defaultMessage: 'Escalation',
        description: 'Label that indicates responder is of type: Escalation'
    },
    schedule: {
        id: 'eoc-schedule.common.schedule.non-final',
        defaultMessage: 'Schedule',
        description: 'Label that indicates responder is of type: Schedule'
    },
    selectionCount: {
        id: 'eoc-schedule.common.selection-count.non-final',
        defaultMessage: '{count} shifts selected',
        description: 'Indicates how many shifts are selected for override.'
    },
    quickOverrideTitle: {
        id: 'eoc-schedule.common.quick-override-title.non-final',
        defaultMessage: 'OVERRIDE',
        description: 'Title for quick override card.'
    },
    search: {
        id: 'eoc-schedule.common.search.non-final',
        defaultMessage: 'Search',
        description: 'Label of search icon that shown inside search participant field'
    },
    replaceWith: {
        id: 'eoc-schedule.common.replace-with.non-final',
        defaultMessage: 'Replace with',
        description: 'A button for opening popup for replacing a participant.'
    },
    participants: {
        id: 'eoc-schedule.common.participants.non-final',
        defaultMessage: 'Participants',
        description: 'Label for participants.'
    },
    addParticipants: {
        id: 'eoc-schedule.common.add-participants.non-final',
        defaultMessage: 'Add people, teams, and escalation policies',
        description: 'Placeholder text for auto complete field for participants (responders).'
    },
    select: {
        id: 'eoc-schedule.common.select.non-final',
        defaultMessage: 'Select',
        description: 'Label that indicates selecting.'
    },
    teamDeleted: {
        id: 'eoc-schedule.common.team-deleted.non-final',
        defaultMessage: 'Team deleted',
        description: 'Fallback responder name that suggest team is deleted.'
    },
    deletedSchedule: {
        id: 'eoc-schedule.common.deleted-schedule.non-final',
        defaultMessage: 'Deleted schedule',
        description: 'Fallback responder name that suggest schedule is deleted.'
    },
    deletedEscalation: {
        id: 'eoc-schedule.common.deleted-escalation.non-final',
        defaultMessage: 'Deleted escalation',
        description: 'Fallback responder name that suggest escalation is deleted.'
    },
    formerUser: {
        id: 'eoc-schedule.common.former-user.non-final',
        defaultMessage: 'Former user',
        description: 'Fallback responder name that suggest user is deactivated or deleted.'
    },
    discard: {
        id: 'eoc-schedule.common.discard.non-final',
        defaultMessage: 'Discard',
        description: 'Button for discarding.'
    },
    confirmProceed: {
        id: 'eoc-schedule.common.confirm-proceed.non-final',
        defaultMessage: 'Are you sure to proceed?',
        description: 'A confirmation for proceeding.'
    },
    /*
    Common validation related messages
   */ required: {
        id: 'eoc-schedule.common.required.non-final',
        defaultMessage: 'This field is required.',
        description: 'A text that informs users that field should be filled.'
    },
    noSpaceAtEndOrStart: {
        id: 'eoc-schedule.common.no-space-at-end-or-start.non-final',
        defaultMessage: 'Field cannot contain spaces at start or end.',
        description: 'A text that informs users that field cannot start or end with spaces.'
    },
    maxLength: {
        id: 'eoc-schedule.common.max-length.non-final',
        defaultMessage: 'Field cannot be longer than {max} characters.',
        description: 'A text that informs users that field should be shorter than certain length.'
    },
    maxValue: {
        id: 'eoc-schedule.common.max-value.non-final',
        defaultMessage: 'Field should be less than {max}.',
        description: 'A text that informs users that field should be less than certain value.'
    },
    minValue: {
        id: 'eoc-schedule.common.min-value.non-final',
        defaultMessage: 'Enter digit 1 or more.',
        description: 'This sentence instructs the user to input a numeric value of at least 1 digit or greater.'
    },
    timePast: {
        id: 'eoc-schedule.common.time-past.non-final',
        defaultMessage: 'Time should be later than current time.',
        description: 'Validation error that indicates time values is in past.'
    },
    startLaterEnd: {
        id: 'eoc-schedule.common.start-later-end.non-final',
        defaultMessage: 'Start time should be earlier than the end time.',
        description: 'Validation error that indicates start time is later than the end time.'
    },
    endEarlierStart: {
        id: 'eoc-schedule.common.end-earlier-start.non-final',
        defaultMessage: 'End time should be later than the start time.',
        description: 'Validation error that indicates end time is earlier than the start time.'
    },
    startEndSame: {
        id: 'eoc-schedule.common.start-end-same.non-final',
        defaultMessage: 'Start and end time cannot be same.',
        description: 'Validation error that indicates start and end time should be different.'
    },
    thirtyMinuteInterval: {
        id: 'eoc-schedule.common.thirty-minute-intervals.non-final',
        defaultMessage: 'Time should be defined as 30 minute intervals.',
        description: 'Validation error that indicates time can be in 30 minutes intervals.'
    },
    nameSpaceValidationError: {
        id: 'eoc-schedule.common.name-space-validation-error.non-final',
        defaultMessage: 'The name cannot start or end with a space.',
        description: 'Error message for name validation when it starts or ends with a space'
    }
});

});



parcelRegister("jRQME", function(module, exports) {

$parcel$export(module.exports, "endpoints", () => $e76be94dd2ace300$export$3a2536d80ecc00e7);

var $kRdYM = parcelRequire("kRdYM");

var $2PjEm = parcelRequire("2PjEm");
const $e76be94dd2ace300$var$orderRotation = ({ scheduleId: scheduleId, after: after, rotationId: rotationId })=>{
    return (0, $kRdYM.eocFetch)((0, $2PjEm.urls).schedules.scheduleId.rotations.rotationId.order.url({
        rotationId: rotationId,
        scheduleId: scheduleId
    }), {
        method: 'PATCH',
        body: {
            after: after
        }
    });
};
const $e76be94dd2ace300$var$getRotation = ({ scheduleId: scheduleId, rotationId: rotationId })=>{
    return (0, $kRdYM.eocFetch)((0, $2PjEm.urls).schedules.scheduleId.rotations.rotationId.url({
        scheduleId: scheduleId,
        rotationId: rotationId
    }), {
        method: 'GET'
    });
};
const $e76be94dd2ace300$var$deleteRotation = ({ scheduleId: scheduleId, rotationId: rotationId })=>{
    return (0, $kRdYM.eocFetch)((0, $2PjEm.urls).schedules.scheduleId.rotations.rotationId.url({
        scheduleId: scheduleId,
        rotationId: rotationId
    }), {
        method: 'DELETE'
    });
};
const $e76be94dd2ace300$var$addRotation = ({ name: name, startTime: startTime, responders: responders, restrictions: restrictions, rotationType: rotationType, hasEndTime: hasEndTime, rotationPeriod: rotationPeriod, endTime: endTime, scheduleId: scheduleId, timeTemplateId: timeTemplateId, timingType: timingType })=>{
    return (0, $kRdYM.eocFetch)((0, $2PjEm.urls).schedules.scheduleId.rotations.url({
        scheduleId: scheduleId
    }), {
        method: 'POST',
        body: {
            name: name,
            responders: responders,
            restrictions: restrictions,
            rotationType: rotationType,
            timeTemplateId: timeTemplateId,
            timingType: timingType,
            rotationPeriod: rotationPeriod,
            startTime: startTime,
            endTime: endTime,
            hasEndTime: hasEndTime
        }
    });
};
const $e76be94dd2ace300$var$editRotation = ({ id: id, name: name, startTime: startTime, responders: responders, restrictions: restrictions, rotationType: rotationType, rotationPeriod: rotationPeriod, hasEndTime: hasEndTime, timingType: timingType, endTime: endTime, scheduleId: scheduleId, timeTemplateId: timeTemplateId })=>{
    return (0, $kRdYM.eocFetch)((0, $2PjEm.urls).schedules.scheduleId.rotations.rotationId.url({
        scheduleId: scheduleId,
        rotationId: id
    }), {
        method: 'PUT',
        body: {
            id: id,
            name: name,
            responders: responders,
            restrictions: restrictions,
            rotationType: rotationType,
            rotationPeriod: rotationPeriod,
            timeTemplateId: timeTemplateId,
            timingType: timingType,
            startTime: startTime,
            endTime: endTime,
            hasEndTime: hasEndTime
        }
    });
};
const $e76be94dd2ace300$var$getScheduleTimeTemplates = ()=>{
    return (0, $kRdYM.eocFetch)((0, $2PjEm.urls).schedules.timeTemplates.rotation.url(), {
        method: 'GET'
    });
};
const $e76be94dd2ace300$export$3a2536d80ecc00e7 = {
    deleteRotation: $e76be94dd2ace300$var$deleteRotation,
    getRotation: $e76be94dd2ace300$var$getRotation,
    orderRotation: $e76be94dd2ace300$var$orderRotation,
    addRotation: $e76be94dd2ace300$var$addRotation,
    editRotation: $e76be94dd2ace300$var$editRotation,
    getScheduleTimeTemplates: $e76be94dd2ace300$var$getScheduleTimeTemplates
};

});
parcelRegister("2PjEm", function(module, exports) {

$parcel$export(module.exports, "urls", () => $20ef964495783e5b$export$bcae9ba627f604b6);

var $2vzCR = parcelRequire("2vzCR");

var $iXduF = parcelRequire("iXduF");
const $20ef964495783e5b$export$bcae9ba627f604b6 = Object.freeze((0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({
    schedules: {
        url: ()=>`/v1/schedules`,
        scheduleId: {
            url: ({ scheduleId: scheduleId } = {
                scheduleId: ':scheduleId'
            })=>`/v1/schedules/${scheduleId}`,
            clone: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/clone`
            },
            name: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/name`
            },
            timezone: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/timezone`
            },
            enable: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/enable`
            },
            disable: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/disable`
            },
            webCalendarUrl: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/web-calendar-url`
            },
            timeline: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/timeline`
            },
            overrides: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/overrides`,
                alias: {
                    url: ({ scheduleId: scheduleId, alias: alias } = {
                        scheduleId: ':scheduleId',
                        alias: ':alias'
                    })=>`/v1/schedules/${scheduleId}/overrides/${alias}`
                },
                bulk: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/overrides/bulk`
                }
            },
            rotations: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}/rotations`,
                rotationId: {
                    url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                        scheduleId: ':scheduleId',
                        rotationId: ':rotationId'
                    })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}`,
                    order: {
                        url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                            scheduleId: ':scheduleId',
                            rotationId: ':rotationId'
                        })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/order`
                    },
                    name: {
                        url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                            scheduleId: ':scheduleId',
                            rotationId: ':rotationId'
                        })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/name`
                    }
                }
            }
        },
        teams: {
            teamId: {
                url: ({ teamId: teamId } = {
                    teamId: ':teamId'
                })=>`/v1/schedules/teams/${teamId}`,
                rights: {
                    url: ({ teamId: teamId } = {
                        teamId: ':teamId'
                    })=>`/v1/schedules/teams/${teamId}/rights`
                }
            }
        },
        timeTemplates: {
            rotation: {
                url: ()=>'/v1/schedules/time-templates/rotation'
            }
        }
    },
    uiPreference: {
        schedule: {
            team: {
                teamId: {
                    url: ({ teamId: teamId } = {
                        teamId: ':teamId'
                    })=>`/v1/users/ui-preference/schedule/team/${teamId}`
                }
            }
        }
    },
    onboarding: {
        completeTask: {
            url: ()=>'/v1/onboarding/complete-task'
        }
    }
}, (0, $iXduF.urls)));

});


parcelRegister("7nAEZ", function(module, exports) {

$parcel$export(module.exports, "endpoints", () => $55f71e52c458e890$export$3a2536d80ecc00e7);

var $kRdYM = parcelRequire("kRdYM");

var $2PjEm = parcelRequire("2PjEm");
const $55f71e52c458e890$var$getScheduleList = (teamId)=>{
    return (0, $kRdYM.eocFetch)((0, $2PjEm.urls).schedules.teams.teamId.url({
        teamId: teamId
    }));
};
const $55f71e52c458e890$var$updateSchedule = ({ scheduleId: scheduleId, description: description, name: name, enabled: enabled, timezone: timezone })=>{
    return (0, $kRdYM.eocFetch)((0, $2PjEm.urls).schedules.scheduleId.url({
        scheduleId: scheduleId
    }), {
        method: 'PATCH',
        body: {
            description: description,
            name: name,
            enabled: enabled,
            timezone: timezone
        }
    });
};
const $55f71e52c458e890$var$deleteSchedule = ({ scheduleId: scheduleId })=>{
    return (0, $kRdYM.eocFetch)((0, $2PjEm.urls).schedules.scheduleId.url({
        scheduleId: scheduleId
    }), {
        method: 'DELETE'
    });
};
const $55f71e52c458e890$export$3a2536d80ecc00e7 = {
    deleteSchedule: $55f71e52c458e890$var$deleteSchedule,
    getScheduleList: $55f71e52c458e890$var$getScheduleList,
    updateSchedule: $55f71e52c458e890$var$updateSchedule
};

});

parcelRegister("euQGd", function(module, exports) {

$parcel$export(module.exports, "endpoints", () => $a8dcbb25c7b03087$export$3a2536d80ecc00e7);

var $kRdYM = parcelRequire("kRdYM");

var $2PjEm = parcelRequire("2PjEm");
const $a8dcbb25c7b03087$var$getUiPreferences = (teamId)=>{
    return (0, $kRdYM.eocFetch)((0, $2PjEm.urls).uiPreference.schedule.team.teamId.url({
        teamId: teamId
    }));
};
const $a8dcbb25c7b03087$var$updateUiPreferences = ({ teamId: teamId, key: key, value: value })=>{
    return (0, $kRdYM.eocFetch)((0, $2PjEm.urls).uiPreference.schedule.team.teamId.url({
        teamId: teamId
    }), {
        method: 'PATCH',
        body: {
            [key]: value
        }
    });
};
const $a8dcbb25c7b03087$export$3a2536d80ecc00e7 = {
    getUiPreferences: $a8dcbb25c7b03087$var$getUiPreferences,
    updateUiPreferences: $a8dcbb25c7b03087$var$updateUiPreferences
};

});

parcelRegister("bfa2B", function(module, exports) {

$parcel$export(module.exports, "endpoints", () => $82f8e254a559b9e9$export$3a2536d80ecc00e7);

var $kRdYM = parcelRequire("kRdYM");

var $2PjEm = parcelRequire("2PjEm");
const $82f8e254a559b9e9$var$getScheduleRights = (teamId)=>{
    return (0, $kRdYM.eocFetch)((0, $2PjEm.urls).schedules.teams.teamId.rights.url({
        teamId: teamId
    }));
};
const $82f8e254a559b9e9$var$createSchedule = ({ description: description, name: name, teamId: teamId, timezone: timezone })=>{
    return (0, $kRdYM.eocFetch)((0, $2PjEm.urls).schedules.url(), {
        method: 'POST',
        body: {
            description: description,
            name: name,
            teamId: teamId,
            timezone: timezone,
            // Created schedules are enabled by default
            enabled: true
        }
    });
};
const $82f8e254a559b9e9$var$cloneSchedule = ({ description: description, name: name, enabled: enabled, timezone: timezone, teamId: teamId, scheduleId: scheduleId })=>{
    return (0, $kRdYM.eocFetch)((0, $2PjEm.urls).schedules.scheduleId.clone.url({
        scheduleId: scheduleId
    }), {
        method: 'POST',
        body: {
            description: description,
            name: name,
            enabled: enabled,
            timezone: timezone,
            teamId: teamId
        }
    });
};
const $82f8e254a559b9e9$export$3a2536d80ecc00e7 = {
    createSchedule: $82f8e254a559b9e9$var$createSchedule,
    getScheduleRights: $82f8e254a559b9e9$var$getScheduleRights,
    cloneSchedule: $82f8e254a559b9e9$var$cloneSchedule
};

});


parcelRegister("kuw5H", function(module, exports) {

$parcel$export(module.exports, "getTeam", () => $eeaf80978d9c3566$export$491fe77f22ab2b51);

var $kRdYM = parcelRequire("kRdYM");
const $eeaf80978d9c3566$export$491fe77f22ab2b51 = (teamId)=>(0, $kRdYM.eocFetch)(`/v1/alerts/responders/names`, {
        method: 'POST',
        body: {
            responders: [
                {
                    id: teamId,
                    type: 'team'
                }
            ]
        }
    });

});


parcelRegister("iiVjl", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('bqnqx')
        ]);
        const value = parcelRequire('8auXY');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("bqnqx")
    ]).then(()=>parcelRequire('8auXY'));
}

});

parcelRegister("hobYe", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('lI0n7')
        ]);
        const value = parcelRequire('hTj1I');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("lI0n7")
    ]).then(()=>parcelRequire('hTj1I'));
}

});

parcelRegister("14cNX", function(module, exports) {

$parcel$export(module.exports, "memberRolesResource", () => $0c7018eae543f283$export$5c4885c1f1a535b);
$parcel$export(module.exports, "getTeamResource", () => $0c7018eae543f283$export$50271c9e7f21f10e);
$parcel$export(module.exports, "customTeamRolesResource", () => $0c7018eae543f283$export$ed1eb48699cf7893);
$parcel$export(module.exports, "resources", () => $0c7018eae543f283$export$bc99aaabaf7b70a7);

var $kJlBc = parcelRequire("kJlBc");

var $XHGTv = parcelRequire("XHGTv");

var $6nbVQ = parcelRequire("6nbVQ");
var $1bJvm = parcelRequire("1bJvm");

var $01Vcs = parcelRequire("01Vcs");
const $0c7018eae543f283$var$mapStatus = (status, userAccessLevel)=>{
    if (userAccessLevel === 'INTERNAL_INACTIVE') return 'suspended';
    if (status === 'REQUEST_ACCESS' || status === 'DENIED_REQUEST_EXISTS' || status === 'FORBIDDEN' || status === 'DIRECT_ACCESS') return 'invite';
    if (status === 'ACCESS_EXISTS') return 'member';
    if (status === 'PENDING_REQUEST_EXISTS') return 'pending';
    if (status === '' || status === undefined) return 'member';
    return 'invite';
};
const $0c7018eae543f283$export$5c4885c1f1a535b = (0, $kJlBc.createResource)({
    type: 'memberRolesResource',
    getKey: ()=>'memberRolesResource',
    getData: async (routerContext)=>{
        var _routerContext$match$;
        const teamId = (_routerContext$match$ = routerContext.match.params) === null || _routerContext$match$ === void 0 ? void 0 : _routerContext$match$.teamId;
        (0, $6nbVQ.assert)(!!teamId, new (0, $1bJvm.AssertionError)('memberRolesResource', 'teamId should be set to fetch member-roles'));
        const { productOrTeamAdmin: isAuthorizedToSeeMemberRolesPage } = await (0, $01Vcs.getMemberRolesPageAccess)(teamId);
        (0, $6nbVQ.assert)(!!isAuthorizedToSeeMemberRolesPage, new (0, $1bJvm.AssertionError)('Member Role Unauthorized Page Access', 'You have to have product or team admin permissions to see this page.'));
        const gqlResponse = await (0, $01Vcs.getMembers)(teamId);
        let members = [];
        if ((0, $XHGTv.getBooleanFF)('platform.50cent.member-roles-graphql-query-migration_b3hpk')) members = gqlResponse === null || gqlResponse === void 0 ? void 0 : gqlResponse.data.team.teamV2.members.edges.map((edge)=>edge.node.member);
        else members = gqlResponse === null || gqlResponse === void 0 ? void 0 : gqlResponse.data.team.team.members.edges.map((edge)=>edge.node.member);
        const teamMembers = await (0, $01Vcs.getRoleAndJSMLicenseInfoEndpoint)({
            platformTeamId: teamId,
            accountIds: members.map((member)=>member.accountId)
        }).then((res)=>{
            const users = members.map((user)=>{
                const userWithRole = res.teamMembers.find((userWithRole)=>userWithRole.accountId === user.accountId);
                return {
                    ...user,
                    role: (userWithRole === null || userWithRole === void 0 ? void 0 : userWithRole.roleId) || 'user',
                    jsmLicense: (userWithRole === null || userWithRole === void 0 ? void 0 : userWithRole.jsmLicense) || false,
                    jiraAdmin: (userWithRole === null || userWithRole === void 0 ? void 0 : userWithRole.jiraAdmin) || false,
                    invitationStatus: 'member'
                };
            });
            return users;
        });
        const membersWithoutJSMLicense = teamMembers.filter((teamMembers)=>!teamMembers.jsmLicense);
        if (membersWithoutJSMLicense.length > 0) {
            const accountIds = membersWithoutJSMLicense.map((member)=>member.accountId).join(',');
            const membersWithFullInfo = await (0, $01Vcs.getJSMInvitationStatusInfoEndpoint)({
                accountIds: accountIds
            }).then((res)=>{
                const users = teamMembers.map((user)=>{
                    const userWithInvitationStatus = res.embeddedValue.find((userWithInvitationStatus)=>userWithInvitationStatus.accountId === user.accountId);
                    return {
                        ...user,
                        invitationStatus: $0c7018eae543f283$var$mapStatus(userWithInvitationStatus === null || userWithInvitationStatus === void 0 ? void 0 : userWithInvitationStatus.accessMode, userWithInvitationStatus === null || userWithInvitationStatus === void 0 ? void 0 : userWithInvitationStatus.userAccessLevel)
                    };
                });
                return users;
            }).catch((err)=>{
                return teamMembers;
            });
            return membersWithFullInfo;
        }
        return teamMembers;
    },
    isBrowserOnly: true
});
const $0c7018eae543f283$export$50271c9e7f21f10e = (0, $kJlBc.createResource)({
    type: 'getTeamResource',
    getKey: ()=>'getTeamResource',
    getData: async (routerContext)=>{
        var _routerContext$match$2;
        const teamId = (_routerContext$match$2 = routerContext.match.params) === null || _routerContext$match$2 === void 0 ? void 0 : _routerContext$match$2.teamId;
        (0, $6nbVQ.assert)(!!teamId, new (0, $1bJvm.AssertionError)('getTeamResource', 'teamId should be set to fetch team info on member roles'));
        return (0, $01Vcs.getTeam)(teamId);
    },
    isBrowserOnly: true
});
const $0c7018eae543f283$export$ed1eb48699cf7893 = (0, $kJlBc.createResource)({
    type: 'customTeamRolesResource',
    getKey: ()=>'customRolesResource',
    getData: async (routerContext)=>{
        var _routerContext$match$3;
        const teamId = (_routerContext$match$3 = routerContext.match.params) === null || _routerContext$match$3 === void 0 ? void 0 : _routerContext$match$3.teamId;
        (0, $6nbVQ.assert)(!!teamId, new (0, $1bJvm.AssertionError)('customTeamRolesResource', 'teamId should be set to fetch custom-team-roles'));
        return (0, $01Vcs.getCustomTeamRolesEndpoint)(teamId);
    },
    isBrowserOnly: true
});
const $0c7018eae543f283$export$bc99aaabaf7b70a7 = [
    $0c7018eae543f283$export$5c4885c1f1a535b,
    $0c7018eae543f283$export$50271c9e7f21f10e,
    $0c7018eae543f283$export$ed1eb48699cf7893
];

});
parcelRegister("01Vcs", function(module, exports) {

$parcel$export(module.exports, "getMembers", () => $005c76d316303df5$export$f4931e6f9feb30c5);
$parcel$export(module.exports, "getMemberRolesPageAccess", () => $005c76d316303df5$export$95d4c4e762437fdd);
$parcel$export(module.exports, "getRoleAndJSMLicenseInfoEndpoint", () => $005c76d316303df5$export$38ab389cb64a5000);
$parcel$export(module.exports, "getJSMInvitationStatusInfoEndpoint", () => $005c76d316303df5$export$fd43007da8683026);
$parcel$export(module.exports, "getTeam", () => $005c76d316303df5$export$491fe77f22ab2b51);
$parcel$export(module.exports, "getCustomTeamRolesEndpoint", () => $005c76d316303df5$export$ebfa293eb1ef42f5);

var $XHGTv = parcelRequire("XHGTv");

var $kRdYM = parcelRequire("kRdYM");
var $3lxlO = parcelRequire("3lxlO");
const $005c76d316303df5$var$membersQuery = `query memberRolesTeamMembersQuery($teamId: ID!) {
  team {
    team(id: $teamId) {
      id
      members {
        edges {
          cursor
          node {
            member {
              ... on AtlassianAccountUser {
                email
              }
              name
              picture
              accountId
              accountStatus
            }
            state
            role
          }
        }
      }
    }
  }
}
`;
const $005c76d316303df5$var$membersQueryV2 = `query memberRolesTeamMembersQuery($teamId: ID!, $siteId: String!) {
  team {
    teamV2 (id: $teamId, siteId: $siteId) @optIn(to: "Team-v2") {
      id
      members {
        edges {
          cursor
          node {
            member {
              ... on AtlassianAccountUser {
                email
              }
              name
              picture
              accountId
              accountStatus
            }
            state
            role
          }
        }
      }
    }
  }
}
`;
const $005c76d316303df5$var$operationName = 'memberRolesTeamMembersQuery';
const $005c76d316303df5$export$f4931e6f9feb30c5 = (teamId)=>{
    const queryUrl = '/gateway/api/graphql';
    const teamAri = `ari:cloud:identity::team/${teamId}`;
    const siteId = (0, $3lxlO.getMeta)('ajs-cloud-id');
    if ((0, $XHGTv.getBooleanFF)('platform.50cent.member-roles-graphql-query-migration_b3hpk')) return (0, $kRdYM.eocFetch)(queryUrl, {
        method: 'POST',
        body: JSON.stringify({
            operationName: $005c76d316303df5$var$operationName,
            query: $005c76d316303df5$var$membersQueryV2,
            variables: {
                teamId: teamAri,
                siteId: siteId
            }
        }),
        headers: {
            'Content-Type': 'application/json',
            'X-ExperimentalApi': 'teams-beta, team-members-beta'
        },
        exactUrl: true
    });
    return (0, $kRdYM.eocFetch)(queryUrl, {
        method: 'POST',
        body: JSON.stringify({
            operationName: $005c76d316303df5$var$operationName,
            query: $005c76d316303df5$var$membersQuery,
            variables: {
                teamId: teamAri
            }
        }),
        headers: {
            'Content-Type': 'application/json',
            'X-ExperimentalApi': 'teams-beta, team-members-beta'
        },
        exactUrl: true
    });
};
const $005c76d316303df5$export$95d4c4e762437fdd = (teamId)=>(0, $kRdYM.eocFetch)(`/v1/teams/members/member-roles-page-access?platformTeamId=${teamId}`);
const $005c76d316303df5$export$38ab389cb64a5000 = ({ platformTeamId: platformTeamId, accountIds: accountIds })=>(0, $kRdYM.eocFetch)(`/v1/teams/members`, {
        method: 'POST',
        body: {
            platformTeamId: platformTeamId,
            accountIds: accountIds
        }
    });
const $005c76d316303df5$export$fd43007da8683026 = ({ accountIds: accountIds })=>(0, $kRdYM.eocFetch)(`/v1/users/access-request-capabilities?accountIds=${accountIds}`, {
        method: 'GET'
    });
const $005c76d316303df5$export$491fe77f22ab2b51 = (teamId)=>(0, $kRdYM.eocFetch)(`/v1/alerts/responders/names`, {
        method: 'POST',
        body: {
            responders: [
                {
                    id: teamId,
                    type: 'team'
                }
            ]
        }
    });
const $005c76d316303df5$export$ebfa293eb1ef42f5 = (platformTeamId)=>(0, $kRdYM.eocFetch)(`/v1/teams/${platformTeamId}/roles`);

});


parcelRegister("cgjGF", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('koLnI')
        ]);
        const value = parcelRequire('loCVr');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("koLnI")
    ]).then(()=>parcelRequire('loCVr'));
}

});

parcelRegister("jy52b", function(module, exports) {

$parcel$export(module.exports, "teamPolicyResource", () => $e3b518ff99ea9282$export$10d7fa513f08ef83);
$parcel$export(module.exports, "notificationPolicyResource", () => $e3b518ff99ea9282$export$6d5f23d9118ad678);
$parcel$export(module.exports, "globalPolicyResource", () => $e3b518ff99ea9282$export$7aed80da979a5112);
$parcel$export(module.exports, "resources", () => $e3b518ff99ea9282$export$bc99aaabaf7b70a7);

var $kJlBc = parcelRequire("kJlBc");

var $iv8NJ = parcelRequire("iv8NJ");
const $e3b518ff99ea9282$export$10d7fa513f08ef83 = (0, $kJlBc.createResource)({
    type: 'teamPolicyResource',
    getKey: (routerContext)=>{
        var _routerContext$match$;
        const teamId = (_routerContext$match$ = routerContext.match.params) === null || _routerContext$match$ === void 0 ? void 0 : _routerContext$match$.teamId;
        return `team-policy/${teamId !== null && teamId !== void 0 ? teamId : ''}`;
    },
    getData: async (routerContext)=>{
        var _routerContext$match$2;
        const teamId = (_routerContext$match$2 = routerContext.match.params) === null || _routerContext$match$2 === void 0 ? void 0 : _routerContext$match$2.teamId;
        // if there is no teamId, this means that we are on the global policy page.
        // so we can return null directly, instead of sending fetch request.
        if (!teamId) return null;
        return (0, $iv8NJ.getTeamPolicies)(teamId);
    },
    isBrowserOnly: true
});
const $e3b518ff99ea9282$export$6d5f23d9118ad678 = (0, $kJlBc.createResource)({
    type: 'notificationPolicyResource',
    getKey: (routerContext)=>{
        var _routerContext$match$3;
        const teamId = (_routerContext$match$3 = routerContext.match.params) === null || _routerContext$match$3 === void 0 ? void 0 : _routerContext$match$3.teamId;
        return `notification-policy/${teamId}`;
    },
    getData: async (routerContext)=>{
        var _routerContext$match$4;
        const teamId = (_routerContext$match$4 = routerContext.match.params) === null || _routerContext$match$4 === void 0 ? void 0 : _routerContext$match$4.teamId;
        if (!teamId) return;
        return (0, $iv8NJ.getNotificationPolicies)(teamId);
    },
    isBrowserOnly: true
});
const $e3b518ff99ea9282$export$7aed80da979a5112 = (0, $kJlBc.createResource)({
    type: 'globalPolicyResource',
    getKey: (routerContext)=>{
        var _routerContext$match$5;
        const teamId = (_routerContext$match$5 = routerContext.match.params) === null || _routerContext$match$5 === void 0 ? void 0 : _routerContext$match$5.teamId;
        if (teamId) return `global-policy/${teamId}`;
        return 'global-policy';
    },
    getData: async (routerContext)=>{
        var _routerContext$match$6;
        const teamId = (_routerContext$match$6 = routerContext.match.params) === null || _routerContext$match$6 === void 0 ? void 0 : _routerContext$match$6.teamId;
        return (0, $iv8NJ.getGlobalPolicies)(teamId);
    },
    isBrowserOnly: true
});
const $e3b518ff99ea9282$export$4cb385c2db8b1e99 = (0, $kJlBc.createResource)({
    type: 'policyMaintenanceRightsResource',
    getKey: ()=>'policy-maintenance-rights-resource',
    getData: async ()=>{
        return (0, $iv8NJ.getPolicyMaintenanceRights)();
    },
    isBrowserOnly: true
});
const $e3b518ff99ea9282$export$bc99aaabaf7b70a7 = [
    $e3b518ff99ea9282$export$10d7fa513f08ef83,
    $e3b518ff99ea9282$export$7aed80da979a5112,
    $e3b518ff99ea9282$export$4cb385c2db8b1e99,
    $e3b518ff99ea9282$export$6d5f23d9118ad678
];

});
parcelRegister("iv8NJ", function(module, exports) {

$parcel$export(module.exports, "getTeamPolicies", () => $d781f2f93a86cf9e$export$fead0944caa1c797);
$parcel$export(module.exports, "getGlobalPolicies", () => $d781f2f93a86cf9e$export$17fc7fbef061a8c3);
$parcel$export(module.exports, "getNotificationPolicies", () => $d781f2f93a86cf9e$export$342525d9423e55ad);
$parcel$export(module.exports, "getPolicyMaintenanceRights", () => $d781f2f93a86cf9e$export$f630cbf5586dce0a);
$parcel$export(module.exports, "updateUIPreferenceEndpoint", () => $d781f2f93a86cf9e$export$6a437b43ab11275d);
$parcel$export(module.exports, "changePolicyOrderEndpoint", () => $d781f2f93a86cf9e$export$57186d786c96b52a);
$parcel$export(module.exports, "enablePolicyEndpoint", () => $d781f2f93a86cf9e$export$6fecd226d8e55346);
$parcel$export(module.exports, "disablePolicyEndpoint", () => $d781f2f93a86cf9e$export$8c0cd218e00b7d9b);
$parcel$export(module.exports, "deletePolicyEndpoint", () => $d781f2f93a86cf9e$export$f9feac6c1dcc516f);
$parcel$export(module.exports, "createPolicyEndpoint", () => $d781f2f93a86cf9e$export$b0108c51b962e788);
$parcel$export(module.exports, "updatePolicyEndpoint", () => $d781f2f93a86cf9e$export$8eabce250a2dd205);

var $kRdYM = parcelRequire("kRdYM");
const $d781f2f93a86cf9e$export$fead0944caa1c797 = (teamId)=>{
    return (0, $kRdYM.eocFetch)(`/v1/teams/${teamId}/policies?type=alert`);
};
const $d781f2f93a86cf9e$export$17fc7fbef061a8c3 = (teamId)=>{
    if (teamId) return (0, $kRdYM.eocFetch)(`/v1/alerts/policies?preferredUITeamId=${teamId}`);
    return (0, $kRdYM.eocFetch)(`/v1/alerts/policies`);
};
const $d781f2f93a86cf9e$export$342525d9423e55ad = (teamId)=>{
    return (0, $kRdYM.eocFetch)(`/v1/teams/${teamId}/policies?type=notification`);
};
const $d781f2f93a86cf9e$export$f630cbf5586dce0a = ()=>{
    return (0, $kRdYM.eocFetch)(`/v1/alerts/ui-preferences/policy-maintenance-rights`);
};
const $d781f2f93a86cf9e$export$6a437b43ab11275d = ({ teamId: teamId, ...payload })=>{
    let url = `/v1/alerts/ui-preferences/policies`;
    if (teamId) url = `${url}?teamId=${teamId}`;
    return (0, $kRdYM.eocFetch)(url, {
        method: 'PATCH',
        body: payload,
        responseType: 'headers'
    });
};
const $d781f2f93a86cf9e$export$57186d786c96b52a = (payload)=>{
    return (0, $kRdYM.eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}/order`, {
        method: 'PATCH',
        body: {
            after: payload.after
        },
        responseType: 'headers'
    });
};
const $d781f2f93a86cf9e$export$6fecd226d8e55346 = (payload)=>{
    return (0, $kRdYM.eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}/enable`, {
        method: 'POST',
        responseType: 'headers'
    });
};
const $d781f2f93a86cf9e$export$8c0cd218e00b7d9b = (payload)=>{
    return (0, $kRdYM.eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}/disable`, {
        method: 'POST',
        responseType: 'headers'
    });
};
const $d781f2f93a86cf9e$export$f9feac6c1dcc516f = (payload)=>{
    return (0, $kRdYM.eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}`, {
        method: 'DELETE',
        responseType: 'headers'
    });
};
const $d781f2f93a86cf9e$export$b0108c51b962e788 = (payload)=>{
    return (0, $kRdYM.eocFetch)(`/v1/teams/${payload.teamId}/policies`, {
        method: 'POST',
        body: payload
    });
};
const $d781f2f93a86cf9e$export$8eabce250a2dd205 = (payload)=>{
    return (0, $kRdYM.eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}`, {
        method: 'PUT',
        body: payload
    });
};

});


parcelRegister("2c1UM", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('b1nE9')
        ]);
        const value = parcelRequire('1Ckuw');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("b1nE9")
    ]).then(()=>parcelRequire('1Ckuw'));
}

});

parcelRegister("ieLL2", function(module, exports) {

$parcel$export(module.exports, "opsReportsResource", () => $d46e947949eb19c9$export$8498311fc7a4ab48);
$parcel$export(module.exports, "opsReportsPermissionResource", () => $d46e947949eb19c9$export$c432f280d76e2acf);
$parcel$export(module.exports, "resources", () => $d46e947949eb19c9$export$bc99aaabaf7b70a7);

var $kJlBc = parcelRequire("kJlBc");

var $6nbVQ = parcelRequire("6nbVQ");
var $1bJvm = parcelRequire("1bJvm");

var $8kfcr = parcelRequire("8kfcr");

var $3hhpv = parcelRequire("3hhpv");
const $d46e947949eb19c9$export$8498311fc7a4ab48 = (0, $kJlBc.createResource)({
    type: 'opsReportsResource',
    getKey: ()=>'opsReportsResource',
    getData: async ()=>{
        const settings = await (0, $3hhpv.getReportSettings)();
        const api = (0, $3hhpv.getDashboards);
        return {
            settings: settings,
            dashboards: settings.showReportingMaintenance ? null : await api()
        };
    },
    maxAge: Infinity,
    isBrowserOnly: true
});
const $d46e947949eb19c9$export$c432f280d76e2acf = (0, $kJlBc.createResource)({
    type: 'opsReportsPermissionResource',
    getKey: ({ match: match })=>{
        var _match$params;
        return `opsReportsPermissionResource-${(_match$params = match.params) === null || _match$params === void 0 ? void 0 : _match$params.teamId}`;
    },
    getData: async (routerContext)=>{
        var _routerContext$match$;
        const isTeamDashboard = (0, $8kfcr.isTeamReportsUrl)(routerContext.match.url);
        const teamId = (_routerContext$match$ = routerContext.match.params) === null || _routerContext$match$ === void 0 ? void 0 : _routerContext$match$.teamId;
        (0, $6nbVQ.assert)(!isTeamDashboard || !!teamId, new (0, $1bJvm.AssertionError)('opsReportsPermissionResource', 'teamId should be set to fetch reports permissions on TeamDashboard page'));
        return (0, $3hhpv.getReportRights)(teamId);
    },
    isBrowserOnly: true,
    maxAge: Infinity
});
const $d46e947949eb19c9$export$bc99aaabaf7b70a7 = [
    $d46e947949eb19c9$export$8498311fc7a4ab48
];

});
parcelRegister("8kfcr", function(module, exports) {

$parcel$export(module.exports, "withReportingPrefix", () => $60fbfb5270bc3dcf$export$c0f073d636267c44);
$parcel$export(module.exports, "isTeamReportsUrl", () => $60fbfb5270bc3dcf$export$f923ac475871fcad);

var $3lxlO = parcelRequire("3lxlO");
function $60fbfb5270bc3dcf$export$c0f073d636267c44(input) {
    // If current env is not opsgenie, we will add cloud id to base url of request.
    if (window.__OG__) return '/webapi' + input;
    const cloudId = (0, $3lxlO.getMeta)('ajs-cloud-id');
    if (cloudId) return `/gateway/api/jsm/ops/reporting/cloudId/${cloudId}/api` + input;
    return input;
}
const $60fbfb5270bc3dcf$export$f923ac475871fcad = (pathName)=>pathName.startsWith('/jira/ops/teams/');

});

parcelRegister("3hhpv", function(module, exports) {

$parcel$export(module.exports, "getDashboards", () => $263076f9901ac719$export$8e4b6d6c4fec08f3);
$parcel$export(module.exports, "getReportSettings", () => $263076f9901ac719$export$9114b8a872caf5d8);
$parcel$export(module.exports, "getSsoEmbedUrlEndpoint", () => $263076f9901ac719$export$8384a95746267bd8);
$parcel$export(module.exports, "getReportRights", () => $263076f9901ac719$export$f4a61c3c8c619f12);
$parcel$export(module.exports, "getAVPEmbedTokens", () => $263076f9901ac719$export$fb46892f83504a42);

var $kRdYM = parcelRequire("kRdYM");

var $8kfcr = parcelRequire("8kfcr");

var $ctLUb = parcelRequire("ctLUb");
const $263076f9901ac719$export$8e4b6d6c4fec08f3 = ()=>(0, $kRdYM.eocFetch)((0, $8kfcr.withReportingPrefix)('/v5/reports/dashboards'), {
        exactUrl: true,
        errorTransformer: $ctLUb.opsReportsErrorTransformer
    });
const $263076f9901ac719$export$e69121e90ce0231b = ()=>(0, $kRdYM.eocFetch)((0, $8kfcr.withReportingPrefix)('/v3/reports/dashboards'), {
        exactUrl: true,
        errorTransformer: $ctLUb.opsReportsErrorTransformer
    });
const $263076f9901ac719$export$9114b8a872caf5d8 = ()=>(0, $kRdYM.eocFetch)((0, $8kfcr.withReportingPrefix)('/v3/reports/index'), {
        exactUrl: true,
        errorTransformer: $ctLUb.opsReportsErrorTransformer
    });
const $263076f9901ac719$export$8384a95746267bd8 = (isDarkMode, dashboardId, teamId)=>{
    const queryParam = teamId ? {
        theme: isDarkMode ? 'DarkMode' : '',
        dashboardId: dashboardId,
        teamId: teamId,
        // Adding time as queryParam to avoid browser caching
        // Should ideally be handled by "Cache-Control" header from server
        _: Date.now().toString()
    } : {
        theme: isDarkMode ? 'DarkMode' : '',
        dashboardId: dashboardId,
        _: Date.now().toString()
    };
    const url = `/v3/reports/dashboard?${new URLSearchParams(queryParam).toString()}`;
    return (0, $kRdYM.eocFetch)((0, $8kfcr.withReportingPrefix)(url), {
        exactUrl: true,
        errorTransformer: $ctLUb.opsReportsErrorTransformer
    });
};
const $263076f9901ac719$export$f4a61c3c8c619f12 = (teamId)=>{
    let url = '/v3/reports/rights';
    if (teamId) url += `?teamId=${teamId}`;
    return (0, $kRdYM.eocFetch)((0, $8kfcr.withReportingPrefix)(url), {
        exactUrl: true,
        errorTransformer: $ctLUb.opsReportsErrorTransformer
    });
};
const $263076f9901ac719$export$fb46892f83504a42 = (dashboardId, teamId)=>{
    let url = '/v3/reports/embed-token';
    return (0, $kRdYM.eocFetch)((0, $8kfcr.withReportingPrefix)(url), {
        exactUrl: true,
        method: 'POST',
        body: {
            dashboardId: dashboardId,
            teamId: teamId
        },
        errorTransformer: $ctLUb.opsReportsErrorTransformer
    });
};

});
parcelRegister("ctLUb", function(module, exports) {

$parcel$export(module.exports, "opsReportsErrorTransformer", () => $915d5a70cab0baf3$export$b170750bd4489531);

var $7JEKn = parcelRequire("7JEKn");
const $915d5a70cab0baf3$var$mediaTypeRegex = /(^application\/json$)|(^application\/json([\s\t]?;.+?)*([\s\t]?;[\s\t]?charset=(("utf-8")|(utf-8)|("ISO-8859-1")|(ISO-8859-1))))/i;
const $915d5a70cab0baf3$export$b170750bd4489531 = (e)=>{
    if ((0, $7JEKn.isHTTPError)(e)) {
        const contentType = e.response.headers.get('Content-Type');
        // The content type is application/json, and it is highly likely utf-8 encoded
        if (contentType && $915d5a70cab0baf3$var$mediaTypeRegex.test(contentType)) return e.response.json().then((data)=>new (0, $7JEKn.StreamedHTTPError)(e, data, data.message));
        // For anything else, try to interpret it as utf8 text as best effort.
        return e.response.text().then((message)=>new (0, $7JEKn.StreamedHTTPError)(e, message, message));
    }
    return e;
};

});



parcelRegister("9c8ch", function(module, exports) {






if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("egBUa")),
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('fWdRW')
        ]);
        const value = parcelRequire('gznPP');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("egBUa")),
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("fWdRW")
    ]).then(()=>parcelRequire('gznPP'));
}

});

parcelRegister("lxH5M", function(module, exports) {

$parcel$export(module.exports, "roleBasedNotificationsResource", () => $040c1936d0a23c0a$export$9a716bf20d804ec3);
$parcel$export(module.exports, "notificationDetailResource", () => $040c1936d0a23c0a$export$8ad8a0a20fd0ed5a);
$parcel$export(module.exports, "resources", () => $040c1936d0a23c0a$export$bc99aaabaf7b70a7);

var $kJlBc = parcelRequire("kJlBc");

var $6nbVQ = parcelRequire("6nbVQ");
var $1bJvm = parcelRequire("1bJvm");

var $3uZTt = parcelRequire("3uZTt");
const $040c1936d0a23c0a$export$9a716bf20d804ec3 = (0, $kJlBc.createResource)({
    type: 'roleBasedNotificationsResource',
    getKey: ()=>'roleBasedNotificationsResource',
    getData: (0, $3uZTt.getRoleBasedNotificationsEndpoint),
    isBrowserOnly: true,
    maxAge: 300000 // 5 minutes
});
const $040c1936d0a23c0a$export$8ad8a0a20fd0ed5a = (0, $kJlBc.createResource)({
    type: 'notificationDetailResource',
    getKey: ({ match: match })=>{
        const settingId = match.params['id'];
        return `notificationDetailResource-id=${settingId}`;
    },
    getData: ({ match: match })=>{
        const settingId = match.params['id'];
        (0, $6nbVQ.assert)(!!settingId, new (0, $1bJvm.AssertionError)('notificationDetailResource', 'settingId is required'));
        return (0, $3uZTt.getRoleBasedNotificationDetailEndpoint)(settingId);
    },
    isBrowserOnly: true
});
const $040c1936d0a23c0a$export$bc99aaabaf7b70a7 = [
    $040c1936d0a23c0a$export$9a716bf20d804ec3,
    $040c1936d0a23c0a$export$8ad8a0a20fd0ed5a
];

});
parcelRegister("3uZTt", function(module, exports) {

$parcel$export(module.exports, "getRoleBasedNotificationsEndpoint", () => $28c42f3ef131b522$export$db67dfe9fe98cd49);
$parcel$export(module.exports, "getRoleBasedNotificationDetailEndpoint", () => $28c42f3ef131b522$export$5522446e6d3ee73);

var $kRdYM = parcelRequire("kRdYM");
const $28c42f3ef131b522$export$db67dfe9fe98cd49 = ()=>(0, $kRdYM.eocFetch)(`/v1/role-based-notifications`);
const $28c42f3ef131b522$export$5522446e6d3ee73 = (settingId)=>(0, $kRdYM.eocFetch)(`/v1/role-based-notifications/${settingId}`);

});


parcelRegister("f79eX", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('lwvpE')
        ]);
        const value = parcelRequire('8b517');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("lwvpE")
    ]).then(()=>parcelRequire('8b517'));
}

});

parcelRegister("614fg", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('73kyd')
        ]);
        const value = parcelRequire('3rpmT');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("73kyd")
    ]).then(()=>parcelRequire('3rpmT'));
}

});

parcelRegister("fH5cc", function(module, exports) {

$parcel$export(module.exports, "resources", () => $3f0181bf3cd7db3b$export$bc99aaabaf7b70a7);
$parcel$export(module.exports, "transitioningDetailsResource", () => (parcelRequire("ksvzS")).transitioningDetailsResource);

var $ksvzS = parcelRequire("ksvzS");
const $3f0181bf3cd7db3b$export$bc99aaabaf7b70a7 = [
    (0, $ksvzS.transitioningDetailsResource)
];

});
parcelRegister("ksvzS", function(module, exports) {

$parcel$export(module.exports, "transitioningDetailsResource", () => $b7ec7ac728833b3f$export$850d76e0c9ffbdeb);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $3HCkE = parcelRequire("3HCkE");
const $b7ec7ac728833b3f$export$7985153d37586c9a = (cloudId)=>(0, $lRmyA.performGetRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/customers/transitioning-details`).catch((err)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'getTransitioningDetails',
                packageName: 'jiraRouterResourcesEocUnlockOperations',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
const $b7ec7ac728833b3f$export$850d76e0c9ffbdeb = (0, $3HCkE.createResource)({
    type: 'EOC_UNLOCK_OPERATIONS',
    getKey: ()=>'eoc-unlock-operations',
    getData: async (_, { tenantContext: { cloudId: cloudId } })=>$b7ec7ac728833b3f$export$7985153d37586c9a(cloudId),
    maxAge: 0,
    isBrowserOnly: true
});

});


parcelRegister("6Ugqh", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('ha7fI')
        ]);
        const value = parcelRequire('95l0A');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("ha7fI")
    ]).then(()=>parcelRequire('95l0A'));
}

});

parcelRegister("3DMty", function(module, exports) {

$parcel$export(module.exports, "resources", () => $2a6a9de3bdf41aee$export$bc99aaabaf7b70a7);
$parcel$export(module.exports, "widgetResources", () => $2a6a9de3bdf41aee$export$bce3244764eac6e6);
$parcel$export(module.exports, "createMyTeamsResource", () => (parcelRequire("bQtyv")).createMyTeamsResource);
$parcel$export(module.exports, "createStatusResource", () => (parcelRequire("6ByGW")).createStatusResource);
$parcel$export(module.exports, "createUserTimelineResource", () => (parcelRequire("d0p4l")).createUserTimelineResource);
$parcel$export(module.exports, "createSchedulesResource", () => (parcelRequire("kJtj1")).createSchedulesResource);
parcelRequire("l96PT");
var $3liNr = parcelRequire("3liNr");

var $bQtyv = parcelRequire("bQtyv");

var $3L9FR = parcelRequire("3L9FR");

var $kJtj1 = parcelRequire("kJtj1");

var $6ByGW = parcelRequire("6ByGW");

var $d0p4l = parcelRequire("d0p4l");
const $2a6a9de3bdf41aee$export$bc99aaabaf7b70a7 = [
    (0, $3liNr.eocUserResource),
    (0, $bQtyv.createMyTeamsResource)(),
    (0, $6ByGW.createStatusResource)(),
    (0, $3L9FR.createOpsTeamsResource)()
];
const $2a6a9de3bdf41aee$export$bce3244764eac6e6 = [
    ()=>(0, $3liNr.eocUserResource),
    (callback, depends)=>(0, $bQtyv.createMyTeamsResource)(callback, depends),
    (callback, depends)=>(0, $6ByGW.createStatusResource)(callback, depends),
    (callback, depends)=>(0, $d0p4l.createUserTimelineResource)(callback, depends),
    (callback, depends)=>(0, $kJtj1.createSchedulesResource)(callback, depends)
];

});
parcelRegister("bQtyv", function(module, exports) {

$parcel$export(module.exports, "createMyTeamsResource", () => $89fb7a215e0a7892$export$bf86fb90d0661bcb);

var $kJlBc = parcelRequire("kJlBc");

var $7utvH = parcelRequire("7utvH");
const $89fb7a215e0a7892$export$bf86fb90d0661bcb = (checkConsolidationOnRouteDependency, depends)=>(0, $kJlBc.createResource)({
        type: 'myTeamsResource',
        getKey: ()=>'myTeamsResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $7utvH.getMyTeamsEndpoint)();
        },
        isBrowserOnly: true,
        depends: depends
    });

});
parcelRegister("7utvH", function(module, exports) {

$parcel$export(module.exports, "getMyTeamsEndpoint", () => $574239e42c8dd07a$export$abe46da7d1f191a7);

var $kRdYM = parcelRequire("kRdYM");
const $574239e42c8dd07a$export$abe46da7d1f191a7 = ()=>{
    return (0, $kRdYM.eocFetch)(`/v1/alerts/responders/suggested`);
};

});


parcelRegister("3L9FR", function(module, exports) {

$parcel$export(module.exports, "createOpsTeamsResource", () => $2bcd43f513c601c0$export$99505a9d792f516c);

var $kJlBc = parcelRequire("kJlBc");

var $d9ODh = parcelRequire("d9ODh");
const $2bcd43f513c601c0$export$99505a9d792f516c = (checkConsolidationOnRouteDependency, depends)=>(0, $kJlBc.createResource)({
        type: 'opsTeamsResource',
        getKey: ()=>'opsTeamsResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $d9ODh.getOpsTeamsEndpoint)().then((response)=>{
                return response.values;
            });
        },
        isBrowserOnly: true,
        depends: depends
    });

});
parcelRegister("d9ODh", function(module, exports) {

$parcel$export(module.exports, "getOpsTeamsEndpoint", () => $994364300898a132$export$7498ba30158c16cd);

var $kRdYM = parcelRequire("kRdYM");

var $1Ldhu = parcelRequire("1Ldhu");
const $994364300898a132$export$7498ba30158c16cd = ()=>{
    return (0, $kRdYM.eocFetch)((0, $1Ldhu.urls).teams.url());
};

});
parcelRegister("1Ldhu", function(module, exports) {

$parcel$export(module.exports, "urls", () => $14847b8f4e5d0818$export$bcae9ba627f604b6);
$parcel$export(module.exports, "SPOTLIGHT_NAMES", () => $14847b8f4e5d0818$export$a7c923252528b255);
$parcel$export(module.exports, "SPOTLIGHT_TOURS", () => $14847b8f4e5d0818$export$38c46ed7a5bc80a0);
$parcel$export(module.exports, "WHO_IS_ON_CALL_PAGE_URL", () => $14847b8f4e5d0818$export$66c323406b302fa6);
$parcel$export(module.exports, "SEARCH_PEOPLE_AND_TEAM", () => $14847b8f4e5d0818$export$24c06aefdee6a6ca);
const $14847b8f4e5d0818$export$bcae9ba627f604b6 = Object.freeze({
    schedules: {
        url: ()=>`/v1/schedules`,
        user: {
            url: ()=>`${$14847b8f4e5d0818$export$bcae9ba627f604b6.schedules.url()}/user`,
            timeline: {
                url: ()=>`${$14847b8f4e5d0818$export$bcae9ba627f604b6.schedules.user.url()}/timeline`,
                export: {
                    url: ()=>`${$14847b8f4e5d0818$export$bcae9ba627f604b6.schedules.user.timeline.url()}/export`
                }
            },
            userId: {
                url: ({ userId: userId } = {
                    userId: ':userId'
                })=>`${$14847b8f4e5d0818$export$bcae9ba627f604b6.schedules.user.url()}/${userId}`
            }
        },
        onCalls: {
            url: ()=>`${$14847b8f4e5d0818$export$bcae9ba627f604b6.schedules.url()}/on-calls`
        },
        scheduleId: {
            url: ({ scheduleId: scheduleId } = {
                scheduleId: ':scheduleId'
            })=>`${$14847b8f4e5d0818$export$bcae9ba627f604b6.schedules.url()}/${scheduleId}`,
            timeline: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`${$14847b8f4e5d0818$export$bcae9ba627f604b6.schedules.scheduleId.url({
                        scheduleId: scheduleId
                    })}/timeline`
            }
        }
    },
    wioc: {
        status: {
            url: ()=>`${$14847b8f4e5d0818$export$bcae9ba627f604b6.schedules.url()}/user/on-calls`
        }
    },
    teams: {
        url: ()=>`/v1/teams`
    }
});
const $14847b8f4e5d0818$export$a7c923252528b255 = {
    firstOverlappingPeriod: 'eoc-who-is-on-call_first_overlapping_period'
};
const $14847b8f4e5d0818$export$38c46ed7a5bc80a0 = {
    overlappingPeriod: 'eoc-who-is-on-call-overlapping-period'
};
const $14847b8f4e5d0818$export$66c323406b302fa6 = '/jira/ops/who-is-on-call';
const $14847b8f4e5d0818$export$24c06aefdee6a6ca = '/jira/people/search';

});



parcelRegister("kJtj1", function(module, exports) {

$parcel$export(module.exports, "createSchedulesResource", () => $f17ebe294d78648b$export$b5e65ca3f82b01c5);

var $kJlBc = parcelRequire("kJlBc");

var $1P13C = parcelRequire("1P13C");
const $f17ebe294d78648b$export$b5e65ca3f82b01c5 = (checkConsolidationOnRouteDependency, depends)=>(0, $kJlBc.createResource)({
        type: 'schedulesResource',
        getKey: ()=>'schedulesResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $1P13C.getSchedulesEndpoint)();
        },
        isBrowserOnly: true,
        depends: depends
    });

});
parcelRegister("1P13C", function(module, exports) {

$parcel$export(module.exports, "getSchedulesEndpoint", () => $153b5fd456867e32$export$e8e940098db1b988);

var $kRdYM = parcelRequire("kRdYM");

var $1Ldhu = parcelRequire("1Ldhu");
const $153b5fd456867e32$export$e8e940098db1b988 = ()=>{
    return (0, $kRdYM.eocFetch)(`${(0, $1Ldhu.urls).schedules.onCalls.url()}`);
};

});


parcelRegister("6ByGW", function(module, exports) {

$parcel$export(module.exports, "createStatusResource", () => $4cf11bcea77e6af6$export$3d1c353e2693418c);

var $kJlBc = parcelRequire("kJlBc");

var $bNSNH = parcelRequire("bNSNH");

var $9HqW7 = parcelRequire("9HqW7");
const $4cf11bcea77e6af6$export$3d1c353e2693418c = (checkConsolidationOnRouteDependency, depends)=>(0, $kJlBc.createResource)({
        type: 'statusResource',
        getKey: ()=>'statusResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $bNSNH.getStatus)().then((0, $9HqW7.transformStatusResponse));
        },
        isBrowserOnly: true,
        depends: depends
    });

});
parcelRegister("bNSNH", function(module, exports) {

$parcel$export(module.exports, "getStatus", () => $897ec78e736ad287$export$b70265791d2079d4);

var $kRdYM = parcelRequire("kRdYM");

var $1Ldhu = parcelRequire("1Ldhu");
const $897ec78e736ad287$export$b70265791d2079d4 = ()=>{
    return (0, $kRdYM.eocFetch)((0, $1Ldhu.urls).wioc.status.url(), {
        method: 'GET'
    });
};

});

parcelRegister("9HqW7", function(module, exports) {

$parcel$export(module.exports, "transformStatusResponse", () => $70fd063a4b951a1e$export$44a749c89534e42c);
const $70fd063a4b951a1e$export$44a749c89534e42c = ({ currentTimeUtcMillis: currentTimeUtcMillis, onCallUntilUtcMillis: onCallUntilUtcMillis, onCallUntilOffsetMillis: onCallUntilOffsetMillis, isCurrentOnCall: isCurrentOnCall, isParticipantOfAnyRotation: isParticipantOfAnyRotation, nextOnCallEndUtcMillis: nextOnCallEndUtcMillis, nextOnCallEndOffsetMillis: nextOnCallEndOffsetMillis, nextOnCallStartUtcMillis: nextOnCallStartUtcMillis, nextOnCallStartOffsetMillis: nextOnCallStartOffsetMillis })=>{
    return {
        currentDate: currentTimeUtcMillis,
        currentShiftEnd: onCallUntilUtcMillis,
        currentShiftEndOffset: onCallUntilOffsetMillis,
        isOnCall: isCurrentOnCall,
        isParticipantOfAnyRotation: isParticipantOfAnyRotation,
        nextEndDate: nextOnCallEndUtcMillis,
        nextEndOffset: nextOnCallEndOffsetMillis,
        nextStartDate: nextOnCallStartUtcMillis,
        nextStartOffset: nextOnCallStartOffsetMillis
    };
};

});


parcelRegister("d0p4l", function(module, exports) {

$parcel$export(module.exports, "createUserTimelineResource", () => $977eb8aa83f3a5cf$export$a479dcc35c33def1);

var $kJlBc = parcelRequire("kJlBc");
parcelRequire("l96PT");
var $3liNr = parcelRequire("3liNr");

var $3i02b = parcelRequire("3i02b");
const $977eb8aa83f3a5cf$export$a479dcc35c33def1 = (checkConsolidationOnRouteDependency, depends)=>(0, $kJlBc.createResource)({
        type: 'userTimelineResource',
        getKey: ()=>'userTimelineResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            const data = await dependencies[(0, $3liNr.eocUserResource).type].promise;
            // Since depends API types are not exported it's impossible to infer types,
            // thus we have to use casting
            const accountId = data === null || data === void 0 ? void 0 : data.accountId;
            const timezone = data === null || data === void 0 ? void 0 : data.timeZone;
            if (!accountId || !timezone) return null;
            return (0, $3i02b.getWidgetTimeline)(accountId);
        },
        isBrowserOnly: true,
        depends: [
            ...depends ? depends : [],
            (0, $3liNr.eocUserResource).type
        ]
    });

});
parcelRegister("3i02b", function(module, exports) {

$parcel$export(module.exports, "getWidgetTimeline", () => $26531459ae065bd5$export$bd80cae08a85b1f0);

var $j30dR = parcelRequire("j30dR");

var $kRdYM = parcelRequire("kRdYM");

var $1Ldhu = parcelRequire("1Ldhu");

var $ihQ5v = parcelRequire("ihQ5v");
const $26531459ae065bd5$export$bd80cae08a85b1f0 = (accountId)=>{
    const formattedCurrent = (0, $j30dR.default)(new Date(), 'UTC', "yyyy-MM-dd'T'HH:mm:ss.SSSXX");
    const urlParams = new URLSearchParams({
        currentDate: formattedCurrent,
        accountId: accountId,
        mode: 'timeline',
        timelineType: '6'
    });
    return (0, $kRdYM.eocFetch)(`${(0, $1Ldhu.urls).schedules.user.timeline.url()}?${urlParams.toString()}`, {
        method: 'GET'
    }).then((0, $ihQ5v.transformUserTimelineResponse));
};

});
parcelRegister("j30dR", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddde7856d01345fe$export$2e2bcd8739ae039);

var $1WmNj = parcelRequire("1WmNj");

var $bgTXE = parcelRequire("bgTXE");

var $2qvU5 = parcelRequire("2qvU5");
function $ddde7856d01345fe$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1WmNj)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $bgTXE.default)((0, $2qvU5.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("1WmNj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $169ce3b937cd7b12$var$cloneObject;

var $169ce3b937cd7b12$var$_index = $169ce3b937cd7b12$var$_interopRequireDefault((parcelRequire("5aZTm")));
function $169ce3b937cd7b12$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $169ce3b937cd7b12$var$cloneObject(dirtyObject) {
    return (0, $169ce3b937cd7b12$var$_index.default)({}, dirtyObject);
}
module.exports = module.exports.default;

});
parcelRegister("5aZTm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3c4de5622d0e6607$var$assign;
function $3c4de5622d0e6607$var$assign(target, dirtyObject) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    dirtyObject = dirtyObject || {};
    for(var property in dirtyObject)if (Object.prototype.hasOwnProperty.call(dirtyObject, property)) target[property] = dirtyObject[property];
    return target;
}
module.exports = module.exports.default;

});


parcelRegister("bgTXE", function(module, exports) {

$parcel$export(module.exports, "default", () => $834c990b20f251e5$export$2e2bcd8739ae039);

var $Yg8hb = parcelRequire("Yg8hb");

var $bEPO8 = parcelRequire("bEPO8");

var $cvHtJ = parcelRequire("cvHtJ");
var $834c990b20f251e5$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $834c990b20f251e5$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($834c990b20f251e5$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $cvHtJ.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $bEPO8.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($Yg8hb)))(dirtyDate, formatStr, options);
}

});
parcelRegister("Yg8hb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0b521e49771b7554$var$format;

var $0b521e49771b7554$var$_index = $0b521e49771b7554$var$_interopRequireDefault((parcelRequire("ky7sH")));

var $0b521e49771b7554$var$_index2 = $0b521e49771b7554$var$_interopRequireDefault((parcelRequire("1Bbnz")));

var $0b521e49771b7554$var$_index3 = $0b521e49771b7554$var$_interopRequireDefault((parcelRequire("emeRN")));

var $0b521e49771b7554$var$_index4 = $0b521e49771b7554$var$_interopRequireDefault((parcelRequire("8Ab9D")));

var $0b521e49771b7554$var$_index5 = $0b521e49771b7554$var$_interopRequireDefault((parcelRequire("69lef")));

var $0b521e49771b7554$var$_index6 = $0b521e49771b7554$var$_interopRequireDefault((parcelRequire("frLM1")));

var $0b521e49771b7554$var$_index7 = $0b521e49771b7554$var$_interopRequireDefault((parcelRequire("YdpzT")));

var $4ug6M = parcelRequire("4ug6M");

var $0b521e49771b7554$var$_index9 = $0b521e49771b7554$var$_interopRequireDefault((parcelRequire("4Zzm9")));

var $0b521e49771b7554$var$_index10 = $0b521e49771b7554$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $0b521e49771b7554$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $0b521e49771b7554$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $0b521e49771b7554$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $0b521e49771b7554$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $0b521e49771b7554$var$doubleQuoteRegExp = /''/g;
var $0b521e49771b7554$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function $0b521e49771b7554$var$format(dirtyDate, dirtyFormatStr, dirtyOptions) {
    (0, $0b521e49771b7554$var$_index10.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var locale = options.locale || $0b521e49771b7554$var$_index2.default;
    var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $0b521e49771b7554$var$_index9.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $0b521e49771b7554$var$_index9.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $0b521e49771b7554$var$_index9.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $0b521e49771b7554$var$_index9.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $0b521e49771b7554$var$_index4.default)(dirtyDate);
    if (!(0, $0b521e49771b7554$var$_index.default)(originalDate)) throw new RangeError('Invalid time value');
     // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $0b521e49771b7554$var$_index7.default)(originalDate);
    var utcDate = (0, $0b521e49771b7554$var$_index3.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($0b521e49771b7554$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = $0b521e49771b7554$var$_index6.default[firstCharacter];
            return longFormatter(substring, locale.formatLong, formatterOptions);
        }
        return substring;
    }).join('').match($0b521e49771b7554$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $0b521e49771b7554$var$cleanEscapedString(substring);
        var formatter = $0b521e49771b7554$var$_index5.default[firstCharacter];
        if (formatter) {
            if (!options.useAdditionalWeekYearTokens && (0, $4ug6M.isProtectedWeekYearToken)(substring)) (0, $4ug6M.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
            if (!options.useAdditionalDayOfYearTokens && (0, $4ug6M.isProtectedDayOfYearToken)(substring)) (0, $4ug6M.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($0b521e49771b7554$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $0b521e49771b7554$var$cleanEscapedString(input) {
    return input.match($0b521e49771b7554$var$escapedStringRegExp)[1].replace($0b521e49771b7554$var$doubleQuoteRegExp, "'");
}
module.exports = module.exports.default;

});
parcelRegister("ky7sH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ef5cc5628cfb5940$var$isValid;

var $ef5cc5628cfb5940$var$_index = $ef5cc5628cfb5940$var$_interopRequireDefault((parcelRequire("8Ab9D")));

var $ef5cc5628cfb5940$var$_index2 = $ef5cc5628cfb5940$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $ef5cc5628cfb5940$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * var result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */ function $ef5cc5628cfb5940$var$isValid(dirtyDate) {
    (0, $ef5cc5628cfb5940$var$_index2.default)(1, arguments);
    var date = (0, $ef5cc5628cfb5940$var$_index.default)(dirtyDate);
    return !isNaN(date);
}
module.exports = module.exports.default;

});
parcelRegister("8Ab9D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $63fa569256896d17$var$toDate;

var $63fa569256896d17$var$_index = $63fa569256896d17$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $63fa569256896d17$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $63fa569256896d17$var$toDate(argument) {
    (0, $63fa569256896d17$var$_index.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument); // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}
module.exports = module.exports.default;

});
parcelRegister("lLZWw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fd9e094e4a9a8b8d$var$requiredArgs;
function $fd9e094e4a9a8b8d$var$requiredArgs(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}
module.exports = module.exports.default;

});



parcelRegister("1Bbnz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $12a212d2f4ff6049$var$_index = $12a212d2f4ff6049$var$_interopRequireDefault((parcelRequire("dWxGM")));

var $12a212d2f4ff6049$var$_index2 = $12a212d2f4ff6049$var$_interopRequireDefault((parcelRequire("hpyHJ")));

var $12a212d2f4ff6049$var$_index3 = $12a212d2f4ff6049$var$_interopRequireDefault((parcelRequire("loKOy")));

var $12a212d2f4ff6049$var$_index4 = $12a212d2f4ff6049$var$_interopRequireDefault((parcelRequire("2Jhnc")));

var $12a212d2f4ff6049$var$_index5 = $12a212d2f4ff6049$var$_interopRequireDefault((parcelRequire("3BeWb")));
function $12a212d2f4ff6049$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $12a212d2f4ff6049$var$locale = {
    code: 'en-US',
    formatDistance: $12a212d2f4ff6049$var$_index.default,
    formatLong: $12a212d2f4ff6049$var$_index2.default,
    formatRelative: $12a212d2f4ff6049$var$_index3.default,
    localize: $12a212d2f4ff6049$var$_index4.default,
    match: $12a212d2f4ff6049$var$_index5.default,
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
var $12a212d2f4ff6049$var$_default = $12a212d2f4ff6049$var$locale;
module.exports.default = $12a212d2f4ff6049$var$_default;
module.exports = module.exports.default;

});
parcelRegister("dWxGM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a26ad313d3dbf920$var$formatDistance;
var $a26ad313d3dbf920$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
function $a26ad313d3dbf920$var$formatDistance(token, count, options) {
    options = options || {};
    var result;
    if (typeof $a26ad313d3dbf920$var$formatDistanceLocale[token] === 'string') result = $a26ad313d3dbf920$var$formatDistanceLocale[token];
    else if (count === 1) result = $a26ad313d3dbf920$var$formatDistanceLocale[token].one;
    else result = $a26ad313d3dbf920$var$formatDistanceLocale[token].other.replace('{{count}}', count);
    if (options.addSuffix) {
        if (options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
}
module.exports = module.exports.default;

});

parcelRegister("hpyHJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cacfb1041f875450$var$_index = $cacfb1041f875450$var$_interopRequireDefault((parcelRequire("9kdSS")));
function $cacfb1041f875450$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $cacfb1041f875450$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $cacfb1041f875450$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $cacfb1041f875450$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $cacfb1041f875450$var$formatLong = {
    date: (0, $cacfb1041f875450$var$_index.default)({
        formats: $cacfb1041f875450$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $cacfb1041f875450$var$_index.default)({
        formats: $cacfb1041f875450$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $cacfb1041f875450$var$_index.default)({
        formats: $cacfb1041f875450$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $cacfb1041f875450$var$_default = $cacfb1041f875450$var$formatLong;
module.exports.default = $cacfb1041f875450$var$_default;
module.exports = module.exports.default;

});
parcelRegister("9kdSS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6ca0c06639ff0707$var$buildFormatLongFn;
function $6ca0c06639ff0707$var$buildFormatLongFn(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}
module.exports = module.exports.default;

});


parcelRegister("loKOy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f940273ff769021c$var$formatRelative;
var $f940273ff769021c$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
function $f940273ff769021c$var$formatRelative(token, _date, _baseDate, _options) {
    return $f940273ff769021c$var$formatRelativeLocale[token];
}
module.exports = module.exports.default;

});

parcelRegister("2Jhnc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1fcd42ac6af0f70a$var$_index = $1fcd42ac6af0f70a$var$_interopRequireDefault((parcelRequire("aHQcG")));
function $1fcd42ac6af0f70a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $1fcd42ac6af0f70a$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $1fcd42ac6af0f70a$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $1fcd42ac6af0f70a$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $1fcd42ac6af0f70a$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $1fcd42ac6af0f70a$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $1fcd42ac6af0f70a$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
function $1fcd42ac6af0f70a$var$ordinalNumber(dirtyNumber, _dirtyOptions) {
    var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`:
    //
    //   var options = dirtyOptions || {}
    //   var unit = String(options.unit)
    //
    // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
}
var $1fcd42ac6af0f70a$var$localize = {
    ordinalNumber: $1fcd42ac6af0f70a$var$ordinalNumber,
    era: (0, $1fcd42ac6af0f70a$var$_index.default)({
        values: $1fcd42ac6af0f70a$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $1fcd42ac6af0f70a$var$_index.default)({
        values: $1fcd42ac6af0f70a$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $1fcd42ac6af0f70a$var$_index.default)({
        values: $1fcd42ac6af0f70a$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $1fcd42ac6af0f70a$var$_index.default)({
        values: $1fcd42ac6af0f70a$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $1fcd42ac6af0f70a$var$_index.default)({
        values: $1fcd42ac6af0f70a$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $1fcd42ac6af0f70a$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $1fcd42ac6af0f70a$var$_default = $1fcd42ac6af0f70a$var$localize;
module.exports.default = $1fcd42ac6af0f70a$var$_default;
module.exports = module.exports.default;

});
parcelRegister("aHQcG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7cb66a0f1c81e8df$var$buildLocalizeFn;
function $7cb66a0f1c81e8df$var$buildLocalizeFn(args) {
    return function(dirtyIndex, dirtyOptions) {
        var options = dirtyOptions || {};
        var context = options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challange you to try to remove it!
        return valuesArray[index];
    };
}
module.exports = module.exports.default;

});


parcelRegister("3BeWb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $29f06a0f5c74a5cd$var$_index = $29f06a0f5c74a5cd$var$_interopRequireDefault((parcelRequire("bpnBt")));

var $29f06a0f5c74a5cd$var$_index2 = $29f06a0f5c74a5cd$var$_interopRequireDefault((parcelRequire("a2pHz")));
function $29f06a0f5c74a5cd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $29f06a0f5c74a5cd$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $29f06a0f5c74a5cd$var$parseOrdinalNumberPattern = /\d+/i;
var $29f06a0f5c74a5cd$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $29f06a0f5c74a5cd$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $29f06a0f5c74a5cd$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $29f06a0f5c74a5cd$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $29f06a0f5c74a5cd$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $29f06a0f5c74a5cd$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $29f06a0f5c74a5cd$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $29f06a0f5c74a5cd$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $29f06a0f5c74a5cd$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $29f06a0f5c74a5cd$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $29f06a0f5c74a5cd$var$match = {
    ordinalNumber: (0, $29f06a0f5c74a5cd$var$_index.default)({
        matchPattern: $29f06a0f5c74a5cd$var$matchOrdinalNumberPattern,
        parsePattern: $29f06a0f5c74a5cd$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $29f06a0f5c74a5cd$var$_index2.default)({
        matchPatterns: $29f06a0f5c74a5cd$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $29f06a0f5c74a5cd$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $29f06a0f5c74a5cd$var$_index2.default)({
        matchPatterns: $29f06a0f5c74a5cd$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $29f06a0f5c74a5cd$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $29f06a0f5c74a5cd$var$_index2.default)({
        matchPatterns: $29f06a0f5c74a5cd$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $29f06a0f5c74a5cd$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $29f06a0f5c74a5cd$var$_index2.default)({
        matchPatterns: $29f06a0f5c74a5cd$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $29f06a0f5c74a5cd$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $29f06a0f5c74a5cd$var$_index2.default)({
        matchPatterns: $29f06a0f5c74a5cd$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $29f06a0f5c74a5cd$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $29f06a0f5c74a5cd$var$_default = $29f06a0f5c74a5cd$var$match;
module.exports.default = $29f06a0f5c74a5cd$var$_default;
module.exports = module.exports.default;

});
parcelRegister("bpnBt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $84e456a5d66783af$var$buildMatchPatternFn;
function $84e456a5d66783af$var$buildMatchPatternFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
module.exports = module.exports.default;

});

parcelRegister("a2pHz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $74ee071a34dc674f$var$buildMatchFn;
function $74ee071a34dc674f$var$buildMatchFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $74ee071a34dc674f$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $74ee071a34dc674f$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $74ee071a34dc674f$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $74ee071a34dc674f$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}
module.exports = module.exports.default;

});



parcelRegister("emeRN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a73ea6f79e2df726$var$subMilliseconds;

var $a73ea6f79e2df726$var$_index = $a73ea6f79e2df726$var$_interopRequireDefault((parcelRequire("4Zzm9")));

var $a73ea6f79e2df726$var$_index2 = $a73ea6f79e2df726$var$_interopRequireDefault((parcelRequire("ddIDm")));

var $a73ea6f79e2df726$var$_index3 = $a73ea6f79e2df726$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $a73ea6f79e2df726$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */ function $a73ea6f79e2df726$var$subMilliseconds(dirtyDate, dirtyAmount) {
    (0, $a73ea6f79e2df726$var$_index3.default)(2, arguments);
    var amount = (0, $a73ea6f79e2df726$var$_index.default)(dirtyAmount);
    return (0, $a73ea6f79e2df726$var$_index2.default)(dirtyDate, -amount);
}
module.exports = module.exports.default;

});
parcelRegister("4Zzm9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3a2848f4741c5f55$var$toInteger;
function $3a2848f4741c5f55$var$toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}
module.exports = module.exports.default;

});

parcelRegister("ddIDm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $99ff1c97c8892d76$var$addMilliseconds;

var $99ff1c97c8892d76$var$_index = $99ff1c97c8892d76$var$_interopRequireDefault((parcelRequire("4Zzm9")));

var $99ff1c97c8892d76$var$_index2 = $99ff1c97c8892d76$var$_interopRequireDefault((parcelRequire("8Ab9D")));

var $99ff1c97c8892d76$var$_index3 = $99ff1c97c8892d76$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $99ff1c97c8892d76$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ function $99ff1c97c8892d76$var$addMilliseconds(dirtyDate, dirtyAmount) {
    (0, $99ff1c97c8892d76$var$_index3.default)(2, arguments);
    var timestamp = (0, $99ff1c97c8892d76$var$_index2.default)(dirtyDate).getTime();
    var amount = (0, $99ff1c97c8892d76$var$_index.default)(dirtyAmount);
    return new Date(timestamp + amount);
}
module.exports = module.exports.default;

});


parcelRegister("69lef", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $47a40ced54ac5b5e$var$_index = $47a40ced54ac5b5e$var$_interopRequireDefault((parcelRequire("1eXm0")));

var $47a40ced54ac5b5e$var$_index2 = $47a40ced54ac5b5e$var$_interopRequireDefault((parcelRequire("a357h")));

var $47a40ced54ac5b5e$var$_index3 = $47a40ced54ac5b5e$var$_interopRequireDefault((parcelRequire("2NIDC")));

var $47a40ced54ac5b5e$var$_index4 = $47a40ced54ac5b5e$var$_interopRequireDefault((parcelRequire("4IzFf")));

var $47a40ced54ac5b5e$var$_index5 = $47a40ced54ac5b5e$var$_interopRequireDefault((parcelRequire("2jCJh")));

var $47a40ced54ac5b5e$var$_index6 = $47a40ced54ac5b5e$var$_interopRequireDefault((parcelRequire("a4ShE")));

var $47a40ced54ac5b5e$var$_index7 = $47a40ced54ac5b5e$var$_interopRequireDefault((parcelRequire("e1No1")));
function $47a40ced54ac5b5e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $47a40ced54ac5b5e$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $47a40ced54ac5b5e$var$formatters = {
    // Era
    G: function(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return $47a40ced54ac5b5e$var$_index.default.y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        var signedWeekYear = (0, $47a40ced54ac5b5e$var$_index6.default)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $47a40ced54ac5b5e$var$_index7.default)(twoDigitYear, 2);
        } // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
         // Padding
        return (0, $47a40ced54ac5b5e$var$_index7.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        var isoWeekYear = (0, $47a40ced54ac5b5e$var$_index4.default)(date); // Padding
        return (0, $47a40ced54ac5b5e$var$_index7.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        var year = date.getUTCFullYear();
        return (0, $47a40ced54ac5b5e$var$_index7.default)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $47a40ced54ac5b5e$var$_index7.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $47a40ced54ac5b5e$var$_index7.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return $47a40ced54ac5b5e$var$_index.default.M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $47a40ced54ac5b5e$var$_index7.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        var week = (0, $47a40ced54ac5b5e$var$_index5.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $47a40ced54ac5b5e$var$_index7.default)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        var isoWeek = (0, $47a40ced54ac5b5e$var$_index3.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $47a40ced54ac5b5e$var$_index7.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return $47a40ced54ac5b5e$var$_index.default.d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        var dayOfYear = (0, $47a40ced54ac5b5e$var$_index2.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $47a40ced54ac5b5e$var$_index7.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $47a40ced54ac5b5e$var$_index7.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $47a40ced54ac5b5e$var$_index7.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $47a40ced54ac5b5e$var$_index7.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $47a40ced54ac5b5e$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $47a40ced54ac5b5e$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $47a40ced54ac5b5e$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $47a40ced54ac5b5e$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $47a40ced54ac5b5e$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $47a40ced54ac5b5e$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return $47a40ced54ac5b5e$var$_index.default.h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return $47a40ced54ac5b5e$var$_index.default.H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $47a40ced54ac5b5e$var$_index7.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $47a40ced54ac5b5e$var$_index7.default)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return $47a40ced54ac5b5e$var$_index.default.m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return $47a40ced54ac5b5e$var$_index.default.s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return $47a40ced54ac5b5e$var$_index.default.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $47a40ced54ac5b5e$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $47a40ced54ac5b5e$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $47a40ced54ac5b5e$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $47a40ced54ac5b5e$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $47a40ced54ac5b5e$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $47a40ced54ac5b5e$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $47a40ced54ac5b5e$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $47a40ced54ac5b5e$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $47a40ced54ac5b5e$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $47a40ced54ac5b5e$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $47a40ced54ac5b5e$var$_index7.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $47a40ced54ac5b5e$var$_index7.default)(timestamp, token.length);
    }
};
function $47a40ced54ac5b5e$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $47a40ced54ac5b5e$var$_index7.default)(minutes, 2);
}
function $47a40ced54ac5b5e$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $47a40ced54ac5b5e$var$_index7.default)(Math.abs(offset) / 60, 2);
    }
    return $47a40ced54ac5b5e$var$formatTimezone(offset, dirtyDelimiter);
}
function $47a40ced54ac5b5e$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $47a40ced54ac5b5e$var$_index7.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $47a40ced54ac5b5e$var$_index7.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $47a40ced54ac5b5e$var$_default = $47a40ced54ac5b5e$var$formatters;
module.exports.default = $47a40ced54ac5b5e$var$_default;
module.exports = module.exports.default;

});
parcelRegister("1eXm0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0e7523b2f31c3a54$var$_index = $0e7523b2f31c3a54$var$_interopRequireDefault((parcelRequire("e1No1")));
function $0e7523b2f31c3a54$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $0e7523b2f31c3a54$var$formatters = {
    // Year
    y: function(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $0e7523b2f31c3a54$var$_index.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $0e7523b2f31c3a54$var$_index.default)(month + 1, 2);
    },
    // Day of the month
    d: function(date, token) {
        return (0, $0e7523b2f31c3a54$var$_index.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function(date, token) {
        return (0, $0e7523b2f31c3a54$var$_index.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function(date, token) {
        return (0, $0e7523b2f31c3a54$var$_index.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function(date, token) {
        return (0, $0e7523b2f31c3a54$var$_index.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function(date, token) {
        return (0, $0e7523b2f31c3a54$var$_index.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $0e7523b2f31c3a54$var$_index.default)(fractionalSeconds, token.length);
    }
};
var $0e7523b2f31c3a54$var$_default = $0e7523b2f31c3a54$var$formatters;
module.exports.default = $0e7523b2f31c3a54$var$_default;
module.exports = module.exports.default;

});
parcelRegister("e1No1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a36777d041aab5c3$var$addLeadingZeros;
function $a36777d041aab5c3$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
module.exports = module.exports.default;

});


parcelRegister("a357h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $750e273c1140fb1f$var$getUTCDayOfYear;

var $750e273c1140fb1f$var$_index = $750e273c1140fb1f$var$_interopRequireDefault((parcelRequire("8Ab9D")));

var $750e273c1140fb1f$var$_index2 = $750e273c1140fb1f$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $750e273c1140fb1f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $750e273c1140fb1f$var$MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $750e273c1140fb1f$var$getUTCDayOfYear(dirtyDate) {
    (0, $750e273c1140fb1f$var$_index2.default)(1, arguments);
    var date = (0, $750e273c1140fb1f$var$_index.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $750e273c1140fb1f$var$MILLISECONDS_IN_DAY) + 1;
}
module.exports = module.exports.default;

});

parcelRegister("2NIDC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $20a2c88eb21c009b$var$getUTCISOWeek;

var $20a2c88eb21c009b$var$_index = $20a2c88eb21c009b$var$_interopRequireDefault((parcelRequire("8Ab9D")));

var $20a2c88eb21c009b$var$_index2 = $20a2c88eb21c009b$var$_interopRequireDefault((parcelRequire("byKqb")));

var $20a2c88eb21c009b$var$_index3 = $20a2c88eb21c009b$var$_interopRequireDefault((parcelRequire("brY09")));

var $20a2c88eb21c009b$var$_index4 = $20a2c88eb21c009b$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $20a2c88eb21c009b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $20a2c88eb21c009b$var$MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $20a2c88eb21c009b$var$getUTCISOWeek(dirtyDate) {
    (0, $20a2c88eb21c009b$var$_index4.default)(1, arguments);
    var date = (0, $20a2c88eb21c009b$var$_index.default)(dirtyDate);
    var diff = (0, $20a2c88eb21c009b$var$_index2.default)(date).getTime() - (0, $20a2c88eb21c009b$var$_index3.default)(date).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $20a2c88eb21c009b$var$MILLISECONDS_IN_WEEK) + 1;
}
module.exports = module.exports.default;

});
parcelRegister("byKqb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $86a6e0fae70def86$var$startOfUTCISOWeek;

var $86a6e0fae70def86$var$_index = $86a6e0fae70def86$var$_interopRequireDefault((parcelRequire("8Ab9D")));

var $86a6e0fae70def86$var$_index2 = $86a6e0fae70def86$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $86a6e0fae70def86$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $86a6e0fae70def86$var$startOfUTCISOWeek(dirtyDate) {
    (0, $86a6e0fae70def86$var$_index2.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $86a6e0fae70def86$var$_index.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = module.exports.default;

});

parcelRegister("brY09", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8560c262329c0d69$var$startOfUTCISOWeekYear;

var $8560c262329c0d69$var$_index = $8560c262329c0d69$var$_interopRequireDefault((parcelRequire("4IzFf")));

var $8560c262329c0d69$var$_index2 = $8560c262329c0d69$var$_interopRequireDefault((parcelRequire("byKqb")));

var $8560c262329c0d69$var$_index3 = $8560c262329c0d69$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $8560c262329c0d69$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $8560c262329c0d69$var$startOfUTCISOWeekYear(dirtyDate) {
    (0, $8560c262329c0d69$var$_index3.default)(1, arguments);
    var year = (0, $8560c262329c0d69$var$_index.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $8560c262329c0d69$var$_index2.default)(fourthOfJanuary);
    return date;
}
module.exports = module.exports.default;

});
parcelRegister("4IzFf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $36f6efa924cd5b42$var$getUTCISOWeekYear;

var $36f6efa924cd5b42$var$_index = $36f6efa924cd5b42$var$_interopRequireDefault((parcelRequire("8Ab9D")));

var $36f6efa924cd5b42$var$_index2 = $36f6efa924cd5b42$var$_interopRequireDefault((parcelRequire("byKqb")));

var $36f6efa924cd5b42$var$_index3 = $36f6efa924cd5b42$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $36f6efa924cd5b42$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $36f6efa924cd5b42$var$getUTCISOWeekYear(dirtyDate) {
    (0, $36f6efa924cd5b42$var$_index3.default)(1, arguments);
    var date = (0, $36f6efa924cd5b42$var$_index.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $36f6efa924cd5b42$var$_index2.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $36f6efa924cd5b42$var$_index2.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = module.exports.default;

});



parcelRegister("2jCJh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1afb65f8744277f0$var$getUTCWeek;

var $1afb65f8744277f0$var$_index = $1afb65f8744277f0$var$_interopRequireDefault((parcelRequire("8Ab9D")));

var $1afb65f8744277f0$var$_index2 = $1afb65f8744277f0$var$_interopRequireDefault((parcelRequire("cyfBq")));

var $1afb65f8744277f0$var$_index3 = $1afb65f8744277f0$var$_interopRequireDefault((parcelRequire("4CnVl")));

var $1afb65f8744277f0$var$_index4 = $1afb65f8744277f0$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $1afb65f8744277f0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $1afb65f8744277f0$var$MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $1afb65f8744277f0$var$getUTCWeek(dirtyDate, options) {
    (0, $1afb65f8744277f0$var$_index4.default)(1, arguments);
    var date = (0, $1afb65f8744277f0$var$_index.default)(dirtyDate);
    var diff = (0, $1afb65f8744277f0$var$_index2.default)(date, options).getTime() - (0, $1afb65f8744277f0$var$_index3.default)(date, options).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $1afb65f8744277f0$var$MILLISECONDS_IN_WEEK) + 1;
}
module.exports = module.exports.default;

});
parcelRegister("cyfBq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9234c3639838f220$var$startOfUTCWeek;

var $9234c3639838f220$var$_index = $9234c3639838f220$var$_interopRequireDefault((parcelRequire("4Zzm9")));

var $9234c3639838f220$var$_index2 = $9234c3639838f220$var$_interopRequireDefault((parcelRequire("8Ab9D")));

var $9234c3639838f220$var$_index3 = $9234c3639838f220$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $9234c3639838f220$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $9234c3639838f220$var$startOfUTCWeek(dirtyDate, dirtyOptions) {
    (0, $9234c3639838f220$var$_index3.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $9234c3639838f220$var$_index.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $9234c3639838f220$var$_index.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $9234c3639838f220$var$_index2.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = module.exports.default;

});

parcelRegister("4CnVl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $35cd44d4e287df9b$var$startOfUTCWeekYear;

var $35cd44d4e287df9b$var$_index = $35cd44d4e287df9b$var$_interopRequireDefault((parcelRequire("4Zzm9")));

var $35cd44d4e287df9b$var$_index2 = $35cd44d4e287df9b$var$_interopRequireDefault((parcelRequire("a4ShE")));

var $35cd44d4e287df9b$var$_index3 = $35cd44d4e287df9b$var$_interopRequireDefault((parcelRequire("cyfBq")));

var $35cd44d4e287df9b$var$_index4 = $35cd44d4e287df9b$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $35cd44d4e287df9b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $35cd44d4e287df9b$var$startOfUTCWeekYear(dirtyDate, dirtyOptions) {
    (0, $35cd44d4e287df9b$var$_index4.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $35cd44d4e287df9b$var$_index.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $35cd44d4e287df9b$var$_index.default)(options.firstWeekContainsDate);
    var year = (0, $35cd44d4e287df9b$var$_index2.default)(dirtyDate, dirtyOptions);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $35cd44d4e287df9b$var$_index3.default)(firstWeek, dirtyOptions);
    return date;
}
module.exports = module.exports.default;

});
parcelRegister("a4ShE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $756462b7c370905f$var$getUTCWeekYear;

var $756462b7c370905f$var$_index = $756462b7c370905f$var$_interopRequireDefault((parcelRequire("4Zzm9")));

var $756462b7c370905f$var$_index2 = $756462b7c370905f$var$_interopRequireDefault((parcelRequire("8Ab9D")));

var $756462b7c370905f$var$_index3 = $756462b7c370905f$var$_interopRequireDefault((parcelRequire("cyfBq")));

var $756462b7c370905f$var$_index4 = $756462b7c370905f$var$_interopRequireDefault((parcelRequire("lLZWw")));
function $756462b7c370905f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $756462b7c370905f$var$getUTCWeekYear(dirtyDate, dirtyOptions) {
    (0, $756462b7c370905f$var$_index4.default)(1, arguments);
    var date = (0, $756462b7c370905f$var$_index2.default)(dirtyDate, dirtyOptions);
    var year = date.getUTCFullYear();
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $756462b7c370905f$var$_index.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $756462b7c370905f$var$_index.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $756462b7c370905f$var$_index3.default)(firstWeekOfNextYear, dirtyOptions);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $756462b7c370905f$var$_index3.default)(firstWeekOfThisYear, dirtyOptions);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = module.exports.default;

});




parcelRegister("frLM1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $02e6f1480420e419$var$dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
}
function $02e6f1480420e419$var$timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
}
function $02e6f1480420e419$var$dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/);
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $02e6f1480420e419$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $02e6f1480420e419$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $02e6f1480420e419$var$timeLongFormatter(timePattern, formatLong));
}
var $02e6f1480420e419$var$longFormatters = {
    p: $02e6f1480420e419$var$timeLongFormatter,
    P: $02e6f1480420e419$var$dateTimeLongFormatter
};
var $02e6f1480420e419$var$_default = $02e6f1480420e419$var$longFormatters;
module.exports.default = $02e6f1480420e419$var$_default;
module.exports = module.exports.default;

});

parcelRegister("YdpzT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0b5001f709e33659$var$getTimezoneOffsetInMilliseconds;
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $0b5001f709e33659$var$getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}
module.exports = module.exports.default;

});

parcelRegister("4ug6M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isProtectedDayOfYearToken = $34467589fadf6150$var$isProtectedDayOfYearToken;
module.exports.isProtectedWeekYearToken = $34467589fadf6150$var$isProtectedWeekYearToken;
module.exports.throwProtectedError = $34467589fadf6150$var$throwProtectedError;
var $34467589fadf6150$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $34467589fadf6150$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $34467589fadf6150$var$isProtectedDayOfYearToken(token) {
    return $34467589fadf6150$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $34467589fadf6150$var$isProtectedWeekYearToken(token) {
    return $34467589fadf6150$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $34467589fadf6150$var$throwProtectedError(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
}

});


parcelRegister("bEPO8", function(module, exports) {

$parcel$export(module.exports, "default", () => $0230b418f0adab97$export$2e2bcd8739ae039);

var $apCQZ = parcelRequire("apCQZ");

var $jAKec = parcelRequire("jAKec");
var $0230b418f0adab97$var$MILLISECONDS_IN_MINUTE = 60000;
var $0230b418f0adab97$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $0230b418f0adab97$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $0230b418f0adab97$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $0230b418f0adab97$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $0230b418f0adab97$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $0230b418f0adab97$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $0230b418f0adab97$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $0230b418f0adab97$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $0230b418f0adab97$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $0230b418f0adab97$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $0230b418f0adab97$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $0230b418f0adab97$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $apCQZ.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $apCQZ.default)('long', date, options);
        }
    }
};
function $0230b418f0adab97$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $jAKec.default)(timeZone, originalDate, true) / $0230b418f0adab97$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $0230b418f0adab97$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $0230b418f0adab97$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $0230b418f0adab97$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $0230b418f0adab97$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $0230b418f0adab97$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $0230b418f0adab97$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $0230b418f0adab97$var$formatTimezone(offset, dirtyDelimeter);
}
function $0230b418f0adab97$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $0230b418f0adab97$var$addLeadingZeros(minutes, 2);
}
var $0230b418f0adab97$export$2e2bcd8739ae039 = $0230b418f0adab97$var$formatters;

});
parcelRegister("apCQZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $794a60babdc19485$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $794a60babdc19485$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $794a60babdc19485$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $794a60babdc19485$var$partsTimeZone(dtf, date) : $794a60babdc19485$var$hackyTimeZone(dtf, date);
}
function $794a60babdc19485$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $794a60babdc19485$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $794a60babdc19485$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("jAKec", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4353d0eed0f35e0$export$2e2bcd8739ae039);

var $6DsSE = parcelRequire("6DsSE");

var $kyI3M = parcelRequire("kyI3M");
var $e4353d0eed0f35e0$var$MILLISECONDS_IN_HOUR = 3600000;
var $e4353d0eed0f35e0$var$MILLISECONDS_IN_MINUTE = 60000;
var $e4353d0eed0f35e0$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $e4353d0eed0f35e0$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $e4353d0eed0f35e0$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $e4353d0eed0f35e0$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$e4353d0eed0f35e0$var$validateTimezone(hours)) return NaN;
        return -(hours * $e4353d0eed0f35e0$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $e4353d0eed0f35e0$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$e4353d0eed0f35e0$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $e4353d0eed0f35e0$var$MILLISECONDS_IN_HOUR + minutes * $e4353d0eed0f35e0$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($e4353d0eed0f35e0$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $e4353d0eed0f35e0$var$toUtcDate(date);
        var offset = $e4353d0eed0f35e0$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $e4353d0eed0f35e0$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $e4353d0eed0f35e0$var$toUtcDate(date) {
    return (0, $kyI3M.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $e4353d0eed0f35e0$var$calcOffset(date, timezoneString) {
    var tokens = (0, $6DsSE.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $kyI3M.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $e4353d0eed0f35e0$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $e4353d0eed0f35e0$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $e4353d0eed0f35e0$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $e4353d0eed0f35e0$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $e4353d0eed0f35e0$var$validIANATimezoneCache = {};
function $e4353d0eed0f35e0$var$isValidTimezoneIANAString(timeZoneString) {
    if ($e4353d0eed0f35e0$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $e4353d0eed0f35e0$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("6DsSE", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d4cc9a9659aadf4$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $4d4cc9a9659aadf4$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $4d4cc9a9659aadf4$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $4d4cc9a9659aadf4$var$partsOffset(dtf, date) : $4d4cc9a9659aadf4$var$hackyOffset(dtf, date);
}
var $4d4cc9a9659aadf4$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $4d4cc9a9659aadf4$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $4d4cc9a9659aadf4$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $4d4cc9a9659aadf4$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $4d4cc9a9659aadf4$var$dtfCache = {};
function $4d4cc9a9659aadf4$var$getDateTimeFormat(timeZone) {
    if (!$4d4cc9a9659aadf4$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $4d4cc9a9659aadf4$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $4d4cc9a9659aadf4$var$dtfCache[timeZone];
}

});

parcelRegister("kyI3M", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef792908381206ac$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $ef792908381206ac$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("cvHtJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $91ba1b36379442ea$export$2e2bcd8739ae039);

var $4Zzm9 = parcelRequire("4Zzm9");

var $YdpzT = parcelRequire("YdpzT");

var $jAKec = parcelRequire("jAKec");

var $13XHq = parcelRequire("13XHq");
var $91ba1b36379442ea$var$MILLISECONDS_IN_HOUR = 3600000;
var $91ba1b36379442ea$var$MILLISECONDS_IN_MINUTE = 60000;
var $91ba1b36379442ea$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $91ba1b36379442ea$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $13XHq.default)
};
function $91ba1b36379442ea$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $91ba1b36379442ea$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($4Zzm9)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $91ba1b36379442ea$var$splitDateString(argument);
    var parseYearResult = $91ba1b36379442ea$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $91ba1b36379442ea$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $91ba1b36379442ea$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $jAKec.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($YdpzT)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($YdpzT)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $91ba1b36379442ea$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $91ba1b36379442ea$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $91ba1b36379442ea$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $91ba1b36379442ea$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $91ba1b36379442ea$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $91ba1b36379442ea$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $91ba1b36379442ea$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $91ba1b36379442ea$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $91ba1b36379442ea$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $91ba1b36379442ea$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $91ba1b36379442ea$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$91ba1b36379442ea$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $91ba1b36379442ea$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$91ba1b36379442ea$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $91ba1b36379442ea$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$91ba1b36379442ea$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $91ba1b36379442ea$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$91ba1b36379442ea$var$validateWeekDate(year, week)) return new Date(NaN);
        return $91ba1b36379442ea$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $91ba1b36379442ea$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$91ba1b36379442ea$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $91ba1b36379442ea$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $91ba1b36379442ea$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $91ba1b36379442ea$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$91ba1b36379442ea$var$validateTime(hours)) return NaN;
        return hours % 24 * $91ba1b36379442ea$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $91ba1b36379442ea$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$91ba1b36379442ea$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $91ba1b36379442ea$var$MILLISECONDS_IN_HOUR + minutes * $91ba1b36379442ea$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $91ba1b36379442ea$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$91ba1b36379442ea$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $91ba1b36379442ea$var$MILLISECONDS_IN_HOUR + minutes * $91ba1b36379442ea$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $91ba1b36379442ea$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $91ba1b36379442ea$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $91ba1b36379442ea$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $91ba1b36379442ea$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $91ba1b36379442ea$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $91ba1b36379442ea$var$isLeapYearIndex(year);
        if (isLeapYear && date > $91ba1b36379442ea$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $91ba1b36379442ea$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $91ba1b36379442ea$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $91ba1b36379442ea$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $91ba1b36379442ea$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $91ba1b36379442ea$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("13XHq", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c64614e8c475876$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $0c64614e8c475876$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $0c64614e8c475876$export$2e2bcd8739ae039 = $0c64614e8c475876$var$tzPattern;

});



parcelRegister("2qvU5", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c46c1e01abb4027$export$2e2bcd8739ae039);

var $jAKec = parcelRequire("jAKec");

var $cvHtJ = parcelRequire("cvHtJ");
function $1c46c1e01abb4027$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $cvHtJ.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $jAKec.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});


parcelRegister("ihQ5v", function(module, exports) {

$parcel$export(module.exports, "transformUserTimelineResponse", () => $d502380ef4455f84$export$78049913b79774a2);

var $k6Bhh = parcelRequire("k6Bhh");
const $d502380ef4455f84$export$78049913b79774a2 = ({ startTimeUtcMillis: startTimeUtcMillis, endTimeUtcMillis: endTimeUtcMillis, startOffsetMillis: startOffsetMillis, endOffsetMillis: endOffsetMillis, utcTimeOffsetMillis: utcTimeOffsetMillis, currentTime: currentTime, periods: periods, ...data })=>{
    return {
        startEpoch: startTimeUtcMillis,
        endEpoch: endTimeUtcMillis,
        nowEpoch: currentTime,
        startOffset: startOffsetMillis,
        endOffset: endOffsetMillis,
        nowOffset: utcTimeOffsetMillis,
        data: {
            ...data,
            periods: periods.map((0, $k6Bhh.fromMergedPeriodResponseToClusterPeriod))
        }
    };
};

});
parcelRegister("k6Bhh", function(module, exports) {

$parcel$export(module.exports, "fromMergedPeriodResponseToClusterPeriod", () => $ea3148c02d8c94f7$export$9b0bac75f135bd57);
const $ea3148c02d8c94f7$export$9b0bac75f135bd57 = (mergedPeriodResponse)=>{
    const { startTimeUtcMillis: startTimeUtcMillis, endTimeUtcMillis: endTimeUtcMillis, isTrueStartTime: isTrueStartTime, isTrueEndTime: isTrueEndTime, periodStartOffsetMillis: periodStartOffsetMillis, periodEndOffsetMillis: periodEndOffsetMillis, overlappingPeriods: overlappingPeriods } = mergedPeriodResponse;
    const clusterPeriod = {
        id: `${startTimeUtcMillis}-${endTimeUtcMillis}`,
        startEpoch: startTimeUtcMillis,
        endEpoch: endTimeUtcMillis,
        isTrueStartTime: isTrueStartTime,
        isTrueEndTime: isTrueEndTime,
        startOffset: periodStartOffsetMillis,
        endOffset: periodEndOffsetMillis,
        overlaps: overlappingPeriods.map($ea3148c02d8c94f7$var$fromOverlappingPeriodResponseToOverlappingPeriod)
    };
    return clusterPeriod;
};
const $ea3148c02d8c94f7$var$fromOverlappingPeriodResponseToOverlappingPeriod = (overlappingPeriodResponse)=>{
    const { startTimeUtcMillis: startTimeUtcMillis, endTimeUtcMillis: endTimeUtcMillis, periodStartOffsetMillis: periodStartOffsetMillis, periodEndOffsetMillis: periodEndOffsetMillis, overlappingRotations: overlappingRotations, isTrueStartTime: isTrueStartTime, isTrueEndTime: isTrueEndTime } = overlappingPeriodResponse;
    const overlappingPeriod = {
        id: `${startTimeUtcMillis}-${endTimeUtcMillis}`,
        startEpoch: startTimeUtcMillis,
        endEpoch: endTimeUtcMillis,
        startOffset: periodStartOffsetMillis,
        endOffset: periodEndOffsetMillis,
        overlaps: overlappingRotations,
        isTrueStartTime: isTrueStartTime,
        isTrueEndTime: isTrueEndTime
    };
    return overlappingPeriod;
};

});





parcelRegister("79YNf", function(module, exports) {

$parcel$export(module.exports, "whoIsOnCallRoute", () => $3cc2f3cf4079e9df$export$26b06efd7311586b);

var $exb0h = parcelRequire("exb0h");
const $3cc2f3cf4079e9df$export$26b06efd7311586b = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_WHO_IS_ON_CALL,
    path: '/jira/ops/who-is-on-call'
};

});

parcelRegister("dxrca", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('88KgH')
        ]);
        const value = parcelRequire('hOZaR');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("88KgH")
    ]).then(()=>parcelRequire('hOZaR'));
}

});

parcelRegister("4JtEo", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdc85345805b2b6b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $av9ef = parcelRequire("av9ef");

var $9RvDp = parcelRequire("9RvDp");

const $bdc85345805b2b6b$var$LazyGlobalIssuesSettingsSidebar = (0, $7rh0R.lazyAfterPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("l05m5")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-issues/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdc85345805b2b6b$var$GlobalIssuesSettingsSidebar = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "globalIssuesSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bdc85345805b2b6b$var$LazyGlobalIssuesSettingsSidebar, null)));
var $bdc85345805b2b6b$export$2e2bcd8739ae039 = $bdc85345805b2b6b$var$GlobalIssuesSettingsSidebar;

});
parcelRegister("l05m5", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('fSMvu');
        const value = parcelRequire('bSHNx');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("fSMvu").then(()=>parcelRequire('bSHNx'));
}

});


parcelRegister("1L86T", function(module, exports) {

$parcel$export(module.exports, "fieldContextConfigPageResource", () => $1bf4cf7967c593d5$export$686a607053a18611);

var $3HCkE = parcelRequire("3HCkE");


const $1bf4cf7967c593d5$export$686a607053a18611 = (0, $3HCkE.createResource)({
    type: (0, $29db1182a27cfbe1$export$4b80522d38222ad),
    getKey: ()=>'data',
    getDataLoader: ()=>(parcelRequire("8GbUw")),
    maxAge: 5000
});

});
const $29db1182a27cfbe1$export$4b80522d38222ad = 'FORGE_FIELD_CONTEXTUAL_CONFIG';

parcelRegister("8GbUw", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('7gX2e');
        const value = parcelRequire('kHLvz');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("7gX2e").then(()=>parcelRequire('kHLvz'));
}

});


parcelRegister("cdVr3", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('3Zkfk');
        const value = parcelRequire('aJcP3');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("3Zkfk").then(()=>parcelRequire('aJcP3'));
}

});

parcelRegister("8msE0", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('jYVk1');
        const value = parcelRequire('faBoH');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("jYVk1").then(()=>parcelRequire('faBoH'));
}

});

parcelRegister("6qkqy", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('8OqrK');
        const value = parcelRequire('22avx');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("8OqrK").then(()=>parcelRequire('22avx'));
}

});

parcelRegister("d8II2", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('6Chcn');
        const value = parcelRequire('1OBGZ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("6Chcn").then(()=>parcelRequire('1OBGZ'));
}

});

parcelRegister("ftOA1", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('5bQsi');
        const value = parcelRequire('iKl5H');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("5bQsi").then(()=>parcelRequire('iKl5H'));
}

});

parcelRegister("aUSBv", function(module, exports) {

$parcel$export(module.exports, "getBoardId", () => $fde559e96dd48090$export$557c2f222778cea6);
$parcel$export(module.exports, "default", () => $fde559e96dd48090$export$2e2bcd8739ae039);

var $k4nIh = parcelRequire("k4nIh");

var $kdp9J = parcelRequire("kdp9J");

var $hmtwd = parcelRequire("hmtwd");

var $fpsBI = parcelRequire("fpsBI");

var $7l8eu = parcelRequire("7l8eu");
const $fde559e96dd48090$var$projectScopeDataMap = {
    routes: [
        // Query string
        /[&?]projectKey=(\w+)/i,
        // Service desk, business and some software
        /\/projects\/(\w+)/i,
        // Issue page (not root)
        /\/browse\/(\w+)-\d+\??((?!(filter=|jql=)).)*$/i,
        // Project settings
        /\/plugins\/servlet\/project-config\/(\w+)/i,
        // Service Desk project settings
        /\/servicedesk\/admin\/(\w+)/i,
        // Browse project
        /\/browse\/(\w+)\/?(\?.*)?$/i
    ],
    meta: [
        // Software
        'ghx-project-key',
        // Settings
        'projectKey',
        // Reports
        'ajs-project-key'
    ]
};
const $fde559e96dd48090$var$getProjectId = (url)=>{
    const projectIdRoutes = [
        // Query string - reports
        /[&?]selectedProjectId=(\w+)/i,
        // Query string - edit project, delete project
        /[&?]pid=(\w+)/i,
        // Query string - release notes
        /[&?]projectId=(\w+)/i,
        // Query string - connect items
        /[&?]project\.id=(\w+)/i
    ];
    return projectIdRoutes.reduce((foundId, route)=>{
        if (foundId) return foundId;
        const match = url.match(route);
        if (match != null) {
            const [, projectId] = match;
            if (projectId) return projectId;
        }
        return null;
    }, null);
};
/**
 * Extracts certain data out of the URL that is required by other data providers.
 */ const $fde559e96dd48090$var$getProjectKey = (url, getMeta)=>{
    let projectKey = null;
    $fde559e96dd48090$var$projectScopeDataMap.meta.forEach((tagName)=>{
        const value = getMeta(tagName);
        if (value && projectKey == null) projectKey = value;
    });
    $fde559e96dd48090$var$projectScopeDataMap.routes.forEach((route)=>{
        const match = url.match(route);
        if (match != null && projectKey == null) [, projectKey] = match;
    });
    return projectKey || undefined;
};
const $fde559e96dd48090$export$557c2f222778cea6 = (url)=>{
    try {
        const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($k4nIh)))(url, true);
        let boardId = parsed.query ? parsed.query.rapidView : null;
        if (boardId == null) {
            const match = url.match(/\/boards\/(\d+)/i);
            boardId = match ? match[1] : null;
        }
        return boardId;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        return null;
    }
};
const $fde559e96dd48090$var$isProjectSettingsConnectRoute = ({ getMeta: getMeta, url: url })=>getMeta('ajs-in-admin-mode') === 'true' && (0, $hmtwd.default).some((regex)=>regex.test(url)) || (0, $7l8eu.default).some((regex)=>regex.test(url));
const $fde559e96dd48090$var$isProjectPage = ({ getMeta: getMeta, projectId: projectId, projectKey: projectKey, url: url })=>{
    // Project routes that have a project id in the URL
    const isProject = ()=>{
        const routes = [
            /\/secure\/ConfigureReport(!default)?\.jspa.+selectedProjectId/i,
            /\/secure\/project\/(DeleteProject|EditProject)!default\.jspa.+pid/i,
            /\/secure\/ReleaseNote.jspa.+projectId/i,
            /\/secure\/ConfigureReleaseNote.jspa.+projectId/i
        ];
        return $fde559e96dd48090$var$isProjectSettingsConnectRoute({
            getMeta: getMeta,
            url: url
        }) || routes.some((regex)=>regex.test(url));
    };
    return projectKey || projectId && isProject();
};
const $fde559e96dd48090$var$isProjectSettingsPage = ({ getMeta: getMeta, url: url })=>(0, $fpsBI.default).some((route)=>url.match(route)) || $fde559e96dd48090$var$isProjectSettingsConnectRoute({
        getMeta: getMeta,
        url: url
    });
const $fde559e96dd48090$var$getProjectPageType = (getMeta, url)=>{
    if ($fde559e96dd48090$var$isProjectSettingsPage({
        getMeta: getMeta,
        url: url
    })) return 'settings';
    const decorator = getMeta('decorator');
    const isSettings = getMeta('is-settings-page') === 'true';
    return decorator === 'admin' || decorator === 'atl.admin' || isSettings ? 'settings' : undefined;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fde559e96dd48090$export$2e2bcd8739ae039 = (url, getMeta)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const extractedData = {};
    const boardId = $fde559e96dd48090$export$557c2f222778cea6(url);
    if (boardId) extractedData.boardId = boardId;
    const projectKey = url.includes('/plugins/servlet/ac/') || url.includes('/settings/projects/') ? undefined : $fde559e96dd48090$var$getProjectKey(url, getMeta);
    if (projectKey) extractedData.projectKey = projectKey;
    const projectId = $fde559e96dd48090$var$getProjectId(url);
    if (projectId) extractedData.projectId = projectId;
    const isProject = $fde559e96dd48090$var$isProjectPage({
        getMeta: getMeta,
        projectId: projectId,
        projectKey: projectKey,
        url: url
    });
    extractedData.pageType = isProject ? $fde559e96dd48090$var$getProjectPageType(getMeta, url) : undefined;
    const identifier = (0, $kdp9J.getScopeIdentifier)({
        boardId: boardId,
        projectKey: projectKey,
        projectId: isProject ? projectId : null
    });
    // This gets around a flow inexact type error
    return {
        ...extractedData,
        ...identifier
    };
};

});
parcelRegister("hmtwd", function(module, exports) {

$parcel$export(module.exports, "default", () => $be3da143f23d41f2$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $be3da143f23d41f2$export$2e2bcd8739ae039 = [
    // Regex groups: addonKey, pageKey
    /\/plugins\/servlet\/ac\/(.+)\/([^?\s]+)/i
];

});

parcelRegister("fpsBI", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac811ac050e5d76c$export$2e2bcd8739ae039);

var $7l8eu = parcelRequire("7l8eu");
const $ac811ac050e5d76c$var$commonClassicProjectSettingsRoutes = [
    /\/plugins\/servlet\/project-config/i,
    /\/jira\/software\/c\/projects\/.+\/settings\/code/i,
    /\/jira\/software\/c\/projects\/.+\/settings\/deployments/i,
    /\/plugins\/servlet\/project-config\/.+\/administer-components/i,
    /\/plugins\/servlet\/project-config\/.+\/administer-versions/i,
    /\/plugins\/servlet\/project-config\/.+\/fields/i,
    /\/plugins\/servlet\/project-config\/.+\/issuesecurity/i,
    /\/plugins\/servlet\/project-config\/.+\/issuetypes/i,
    /\/plugins\/servlet\/project-config\/.+\/notifications/i,
    /\/plugins\/servlet\/project-config\/.+\/permissions/i,
    /\/plugins\/servlet\/project-config\/.+\/screens/i,
    /\/plugins\/servlet\/project-config\/.+\/workflows/i,
    /\/project\/DeleteProject!default\.jspa/i,
    /\/secure\/project\/EditProject!default\.jspa/i,
    // Collectors
    /\/secure\/AddCollector/i,
    /\/secure\/InsertCollectorHelp/i,
    /\/ViewCollector!default\.jspa\?projectKey=/i,
    /\/ViewCollectors!default\.jspa\?projectKey=/i,
    // Development tools
    /\/secure\/ConfigureDevStatus.jspa\?projectKey=/i,
    // Hipchat
    /\/InstallHipChat\.jspa\?projectKey=/i,
    /\/secure\/ConfigureHipChat\.jspa\?projectKey=(.+)/i,
    // Forge
    /\/jira\/software\/c\/projects\/.+\/settings\/apps\/([a-z0-9-]+)\/([a-z0-9-]+)(\/*)?/i
];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ac811ac050e5d76c$export$2e2bcd8739ae039 = [
    ...$ac811ac050e5d76c$var$commonClassicProjectSettingsRoutes,
    /\/plugins\/servlet\/project-config\/.+\/issuelayout/i,
    ...(0, $7l8eu.default),
    // Service Desk project settings
    /\/servicedesk\/admin\/(\w+)/i,
    // SPA settings
    /\/projects\/\w+\/settings(\/\w+)*/i
];

});
parcelRegister("7l8eu", function(module, exports) {

$parcel$export(module.exports, "default", () => $840bada481eacc3a$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $840bada481eacc3a$export$2e2bcd8739ae039 = [
    /\/plugins\/servlet\/ac\/com\.xpandit\.plugins\.jiraxporter\/jira-xporter-manage-project/i,
    /\/plugins\/servlet\/ac\/com\.xpandit\.plugins\.xray\/xray-project-settings-all/i
];

});



parcelRegister("5oIBC", function(module, exports) {

$parcel$export(module.exports, "default", () => $43f0696c76a3faa9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $k8Qyf = parcelRequire("k8Qyf");
const $43f0696c76a3faa9$var$withFlagService = (WrappedComponent)=>{
    return (props)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ...props,
            flagService: (0, $k8Qyf.flagService)
        });
};
var $43f0696c76a3faa9$export$2e2bcd8739ae039 = $43f0696c76a3faa9$var$withFlagService;

});

parcelRegister("1rAsT", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('4yFId')
        ]);
        const value = parcelRequire('ji9l1');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("4yFId")
    ]).then(()=>parcelRequire('ji9l1'));
}

});

parcelRegister("7pdDu", function(module, exports) {

$parcel$export(module.exports, "customFieldsDirectoryResource", () => $fa0cf43fa184c179$export$3d783f106e15b01a);

var $3HCkE = parcelRequire("3HCkE");


const $fa0cf43fa184c179$export$3d783f106e15b01a = (0, $3HCkE.createResource)({
    type: (0, $f08d1d49f60463bc$export$f237bae095c310e7),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("foPYY"))
});

});
const $f08d1d49f60463bc$export$f237bae095c310e7 = 'CUSTOM_FIELDS_DIRECTORY';

parcelRegister("foPYY", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('68gp0');
        const value = parcelRequire('fb7JO');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("68gp0").then(()=>parcelRequire('fb7JO'));
}

});


parcelRegister("3H8mz", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('dvqZm')
        ]);
        const value = parcelRequire('O4z2X');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("dvqZm")
    ]).then(()=>parcelRequire('O4z2X'));
}

});

parcelRegister("bhwgQ", function(module, exports) {

$parcel$export(module.exports, "checkAuthentication", () => $d30306c96e1f2888$export$b8dbb7d6029c5413);
$parcel$export(module.exports, "AuthenticationCheck", () => $d30306c96e1f2888$export$e9b9096e887386fe);

var $eUqFw = parcelRequire("eUqFw");

var $gd0Sp = parcelRequire("gd0Sp");

var $iPDOm = parcelRequire("iPDOm");
const $d30306c96e1f2888$export$b8dbb7d6029c5413 = (tenantContext)=>Boolean(tenantContext.atlassianAccountId);
const $d30306c96e1f2888$export$e9b9096e887386fe = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        if ($d30306c96e1f2888$export$b8dbb7d6029c5413(tenantContext)) return children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iPDOm.RedirectToLoginPage), null);
    });

});

parcelRegister("lY2KV", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('ekVbM'),
            load('hPzOn'),
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('kLhuh')
        ]);
        const value = parcelRequire('8qc1w');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("ekVbM"),
        load("hPzOn"),
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("kLhuh")
    ]).then(()=>parcelRequire('8qc1w'));
}

});

parcelRegister("sFzm1", function(module, exports) {

$parcel$export(module.exports, "EmbedModeContext", () => $8c69a6d02011f63a$export$5eb07b3c7c0b0771);
$parcel$export(module.exports, "EmbedModeProvider", () => $8c69a6d02011f63a$export$9daaf42d62e1c430);

var $eUqFw = parcelRequire("eUqFw");
const $8c69a6d02011f63a$export$5eb07b3c7c0b0771 = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
const { Provider: $8c69a6d02011f63a$var$Provider } = $8c69a6d02011f63a$export$5eb07b3c7c0b0771;
const $8c69a6d02011f63a$var$handleEmbedLinkClick = (e)=>{
    const eventTarget = e.target;
    if (eventTarget && eventTarget instanceof HTMLAnchorElement && eventTarget.target !== '_blank') // link
    eventTarget.target = '_blank';
};
// When issue view is loaded within an iframe, it needs to follow the proper
// element elevation principles, found here: https://hello.atlassian.net/wiki/spaces/~460573267/pages/2355983526/Jira+Dark+Mode+-+UI+Guidelines#Element-elevation-basics
// Unfortunately the current elevation is set in the global-container, which is loaded before this Provider so
// we have to override the overrider to ensure that the proper elevation is set
const $8c69a6d02011f63a$var$DarkModeMonolithStyleOverride = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("style", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `
                    #jira-frontend {
                        background: ${"var(--ds-surface-overlay, white)"};
                    }
                `
        }
    });
const $8c69a6d02011f63a$export$9daaf42d62e1c430 = ({ children: children })=>{
    (0, $eUqFw.useEffect)(()=>{
        window.addEventListener('click', $8c69a6d02011f63a$var$handleEmbedLinkClick, true);
        return ()=>{
            window.removeEventListener('click', $8c69a6d02011f63a$var$handleEmbedLinkClick);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8c69a6d02011f63a$var$DarkModeMonolithStyleOverride, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8c69a6d02011f63a$var$Provider, {
        value: true
    }, children));
};

});

parcelRegister("guDlK", function(module, exports) {

$parcel$export(module.exports, "useProjectKey", () => $598d4d607d97d3ec$export$f87be37f8e8be65);
$parcel$export(module.exports, "useProjectContextActions", () => $598d4d607d97d3ec$export$bd73624ca941f105);
$parcel$export(module.exports, "useProjectType", () => $598d4d607d97d3ec$export$6de29d851c914935);
$parcel$export(module.exports, "useProjectContext", () => $598d4d607d97d3ec$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useApplication", () => $598d4d607d97d3ec$export$aaf75bb403fe1fb5);
$parcel$export(module.exports, "useEdition", () => $598d4d607d97d3ec$export$d56c02945cf5a9e5);
$parcel$export(module.exports, "useIsSimplifiedProject", () => $598d4d607d97d3ec$export$524ef4f6102ed540);
$parcel$export(module.exports, "useIsClassicProject", () => $598d4d607d97d3ec$export$e2cf96f40a8867ce);
$parcel$export(module.exports, "useProjectId", () => $598d4d607d97d3ec$export$16d1475ed6c26568);
$parcel$export(module.exports, "useProjectStatus", () => $598d4d607d97d3ec$export$30f16f2782a4113b);
$parcel$export(module.exports, "useProjectConfiguration", () => $598d4d607d97d3ec$export$af19ad68b52fa1a6);
$parcel$export(module.exports, "useProjectIssueTypes", () => $598d4d607d97d3ec$export$80bef597b440cf71);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $3FyZ4 = parcelRequire("3FyZ4");

var $eIp1n = parcelRequire("eIp1n");
var $6WXNs = parcelRequire("6WXNs");
var $6vrw7 = parcelRequire("6vrw7");

var $gd0Sp = parcelRequire("gd0Sp");

var $lbuGg = parcelRequire("lbuGg");

var $9ZB9O = parcelRequire("9ZB9O");
const $598d4d607d97d3ec$export$f87be37f8e8be65 = (issueKey)=>(0, $6vrw7.toProjectKey)(issueKey.split('-')[0]);
const $598d4d607d97d3ec$export$bd73624ca941f105 = ()=>{
    const [, { setProjectContext: setProjectContext, mergeProjectProperty: mergeProjectProperty }] = (0, $lbuGg.useProjectContextActionStore)();
    const actions = (0, $eUqFw.useMemo)(()=>({
            setProjectContext: setProjectContext,
            mergeProjectProperty: mergeProjectProperty
        }), [
        setProjectContext,
        mergeProjectProperty
    ]);
    return [
        null,
        actions
    ];
};
const $598d4d607d97d3ec$export$6de29d851c914935 = (projectKey)=>{
    const [projectType] = (0, $lbuGg.useProjectContextProjectTypeStore)({
        projectKey: projectKey
    });
    return projectType;
};
const $598d4d607d97d3ec$export$8f31c2503e1efa93 = (projectKey)=>{
    const [projectContext] = (0, $lbuGg.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext;
};
const $598d4d607d97d3ec$export$aaf75bb403fe1fb5 = (projectKey, failSafely = false)=>{
    const projectType = $598d4d607d97d3ec$export$6de29d851c914935(projectKey);
    if (projectType === undefined) {
        if ((0, $1ybV0.ff)('ken-432-missing-project-key-log_hr7zv')) (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
            client.getInstance().sendTrackEvent({
                action: 'project-type-investigation',
                attributes: {
                    message: 'projectType was missing inside the hook'
                },
                actionSubject: 'project-context',
                source: 'project-context-service'
            });
        });
        if (failSafely) return undefined;
        throw new Error(`No project type for project key ${projectKey} in Project Context Service`);
    }
    return (0, $eIp1n.getApplicationForProject)(projectType);
};
const $598d4d607d97d3ec$export$d56c02945cf5a9e5 = (projectKey, failSafely = false)=>{
    const { appEditions: appEditions } = (0, $gd0Sp.useTenantContext)();
    const application = $598d4d607d97d3ec$export$aaf75bb403fe1fb5(projectKey, failSafely);
    if (!application) return undefined;
    return (0, $6WXNs.getEdition)(application, appEditions);
};
const $598d4d607d97d3ec$export$524ef4f6102ed540 = (projectKey)=>{
    const [projectContext] = (0, $lbuGg.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.isSimplified || false;
};
const $598d4d607d97d3ec$export$e2cf96f40a8867ce = (projectKey)=>{
    const [projectContext] = (0, $lbuGg.useProjectContextStore)({
        projectKey: projectKey
    });
    return !projectContext?.isSimplified;
};
const $598d4d607d97d3ec$export$16d1475ed6c26568 = (projectKey)=>{
    const [projectContext] = (0, $lbuGg.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.projectId;
};
const $598d4d607d97d3ec$export$30f16f2782a4113b = (projectKey)=>{
    const [projectContext] = (0, $lbuGg.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.projectStatus;
};
const $598d4d607d97d3ec$export$af19ad68b52fa1a6 = (projectKey)=>{
    const projectType = $598d4d607d97d3ec$export$6de29d851c914935(projectKey);
    const isSimplified = $598d4d607d97d3ec$export$524ef4f6102ed540(projectKey);
    return (0, $9ZB9O.getIssueConfiguration)({
        isSimplified: isSimplified,
        projectType: projectType
    });
};
const $598d4d607d97d3ec$export$654dd2c557853fbe = (projectKey)=>{
    const [projectName] = (0, $lbuGg.useProjectContextProjectNameStore)({
        projectKey: projectKey
    });
    return projectName;
};
const $598d4d607d97d3ec$export$80bef597b440cf71 = (projectKey)=>{
    const [issueTypes] = (0, $lbuGg.useProjectContextIssueTypesStore)({
        projectKey: projectKey
    });
    return issueTypes;
};

});
parcelRegister("lbuGg", function(module, exports) {

$parcel$export(module.exports, "useProjectContextActionStore", () => $4715ac6bc4ce2fb7$export$9afb89c1fe103bbe);
$parcel$export(module.exports, "useProjectContextStore", () => $4715ac6bc4ce2fb7$export$8b09478b33186ec);
$parcel$export(module.exports, "useProjectContextProjectTypeStore", () => $4715ac6bc4ce2fb7$export$f2e1ed3b2b4707cb);
$parcel$export(module.exports, "useProjectContextProjectNameStore", () => $4715ac6bc4ce2fb7$export$9469fde70658518);
$parcel$export(module.exports, "useProjectContextIssueTypesStore", () => $4715ac6bc4ce2fb7$export$f73e9904779f6be5);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $bAXOf = parcelRequire("bAXOf");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4715ac6bc4ce2fb7$var$initialState = {};
const $4715ac6bc4ce2fb7$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'project-context',
    initialState: $4715ac6bc4ce2fb7$var$initialState,
    actions: $bAXOf
});
const $4715ac6bc4ce2fb7$export$9afb89c1fe103bbe = (0, $ggKAj.createHook)($4715ac6bc4ce2fb7$export$6f57813fe9f31bf9, {
    selector: null
});
const $4715ac6bc4ce2fb7$var$getProjectContext = (state, { projectKey: projectKey })=>state[projectKey];
const $4715ac6bc4ce2fb7$export$8b09478b33186ec = (0, $ggKAj.createHook)($4715ac6bc4ce2fb7$export$6f57813fe9f31bf9, {
    selector: $4715ac6bc4ce2fb7$var$getProjectContext
});
const $4715ac6bc4ce2fb7$var$getProjectType = (state, { projectKey: projectKey })=>{
    const projectContext = $4715ac6bc4ce2fb7$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.projectType;
};
const $4715ac6bc4ce2fb7$export$f2e1ed3b2b4707cb = (0, $ggKAj.createHook)($4715ac6bc4ce2fb7$export$6f57813fe9f31bf9, {
    selector: $4715ac6bc4ce2fb7$var$getProjectType
});
const $4715ac6bc4ce2fb7$var$getProjectName = (state, { projectKey: projectKey })=>{
    const projectContext = $4715ac6bc4ce2fb7$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.projectName;
};
const $4715ac6bc4ce2fb7$export$9469fde70658518 = (0, $ggKAj.createHook)($4715ac6bc4ce2fb7$export$6f57813fe9f31bf9, {
    selector: $4715ac6bc4ce2fb7$var$getProjectName
});
const $4715ac6bc4ce2fb7$var$getIssueTypes = (state, { projectKey: projectKey })=>{
    const projectContext = $4715ac6bc4ce2fb7$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.issueTypes;
};
const $4715ac6bc4ce2fb7$export$f73e9904779f6be5 = (0, $ggKAj.createHook)($4715ac6bc4ce2fb7$export$6f57813fe9f31bf9, {
    selector: $4715ac6bc4ce2fb7$var$getIssueTypes
});

});
parcelRegister("bAXOf", function(module, exports) {

$parcel$export(module.exports, "setProjectContext", () => $f8fc64b164fe014a$export$d64151aab9ae5f09);
$parcel$export(module.exports, "mergeProjectProperty", () => $f8fc64b164fe014a$export$78f1c6052937615f);
const $f8fc64b164fe014a$export$d64151aab9ae5f09 = (key, projectContext)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [key]: projectContext
        });
    };
const $f8fc64b164fe014a$export$78f1c6052937615f = (key, projectContext)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const currentProjectContext = currentState[key];
        const newProjectContext = {
            ...currentProjectContext,
            ...projectContext
        };
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [key]: newProjectContext
        });
    };

});


parcelRegister("9ZB9O", function(module, exports) {

$parcel$export(module.exports, "getIssueConfiguration", () => $78bf57e6f575c3aa$export$902f6c5cc939598a);

var $2wUFy = parcelRequire("2wUFy");

var $7ZZxN = parcelRequire("7ZZxN");
const $78bf57e6f575c3aa$export$cdbd1eb3b05729e0 = 'flagActions';
const $78bf57e6f575c3aa$export$c161a774ec2e7e56 = 'cardCoverActions';
const $78bf57e6f575c3aa$export$a52507e68e7aeeb = ()=>({
        issueActions: []
    });
const $78bf57e6f575c3aa$export$381ce08838c53afa = ()=>({
        applicationKey: (0, $2wUFy.default).CORE_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $78bf57e6f575c3aa$export$27e0678365e5dcff = ()=>({
        applicationKey: (0, $2wUFy.default).SOFTWARE_ISSUE,
        issueActions: [
            $78bf57e6f575c3aa$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $78bf57e6f575c3aa$export$aebf676dfa727a1c = ()=>({
        applicationKey: (0, $2wUFy.default).SIMPLE_SOFTWARE_BOARD,
        issueActions: [
            $78bf57e6f575c3aa$export$cdbd1eb3b05729e0,
            $78bf57e6f575c3aa$export$c161a774ec2e7e56
        ],
        ecosystemEnabled: true
    });
const $78bf57e6f575c3aa$export$1afca4d3eb6b218b = ()=>({
        applicationKey: (0, $2wUFy.default).STANDARD_ROADMAP_ISSUE,
        issueActions: [
            $78bf57e6f575c3aa$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $78bf57e6f575c3aa$export$8a060ed6f66c43b0 = ()=>({
        applicationKey: (0, $2wUFy.default).BITBUCKET_ISSUE,
        issueActions: []
    });
const $78bf57e6f575c3aa$export$78a2cb921e46f5eb = ()=>({
        applicationKey: (0, $2wUFy.default).MOBILE_ISSUE,
        issueActions: []
    });
const $78bf57e6f575c3aa$export$db1115186532f6d5 = ()=>({
        applicationKey: (0, $2wUFy.default).SERVICE_DESK,
        issueActions: [],
        ecosystemEnabled: true
    });
const $78bf57e6f575c3aa$export$902f6c5cc939598a = (config)=>{
    if (config) switch(config.projectType){
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            if (config.isSimplified) return $78bf57e6f575c3aa$export$aebf676dfa727a1c();
            return $78bf57e6f575c3aa$export$27e0678365e5dcff();
        case 0, $7ZZxN.CORE_PROJECT:
            return $78bf57e6f575c3aa$export$381ce08838c53afa();
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return $78bf57e6f575c3aa$export$db1115186532f6d5();
        default:
            // fallback to sofware config
            return $78bf57e6f575c3aa$export$27e0678365e5dcff();
    }
    return $78bf57e6f575c3aa$export$27e0678365e5dcff();
};

});
parcelRegister("2wUFy", function(module, exports) {

$parcel$export(module.exports, "default", () => $78d48529cb7f139c$export$2e2bcd8739ae039);
const $78d48529cb7f139c$var$keys = {
    CONNECT_ISSUE: 'connect-issue',
    BITBUCKET_ISSUE: 'bitbucket-issue',
    CORE_ISSUE: 'core-issue',
    MOBILE_ISSUE: 'mobile-issue',
    SIMPLE_SOFTWARE_BOARD: 'simple-software-board',
    SOFTWARE_ISSUE: 'software-issue',
    STANDARD_ROADMAP_ISSUE: 'standard-roadmap-issue',
    SERVICE_DESK: 'service-desk',
    EMPTY_APPLICATION_KEY: ''
};
var $78d48529cb7f139c$export$2e2bcd8739ae039 = $78d48529cb7f139c$var$keys;

});



parcelRegister("5kTYh", function(module, exports) {

$parcel$export(module.exports, "issueForgeDataResource", () => $f710e109102bd3b2$export$e28b79684fb81535);

var $3HCkE = parcelRequire("3HCkE");

var $9PXNH = parcelRequire("9PXNH");

var $b8iE0 = parcelRequire("b8iE0");
const $f710e109102bd3b2$export$e28b79684fb81535 = (0, $3HCkE.createResource)({
    type: 'ISSUE_FORGE_DATA',
    getKey: ({ match: match })=>{
        const issueKey = (0, $9PXNH.getIssueKey)(match);
        return issueKey || '';
    },
    getData: (...args)=>(0, $b8iE0.default)(...args),
    isBrowserOnly: true
});

});
parcelRegister("9PXNH", function(module, exports) {

$parcel$export(module.exports, "getIssueKey", () => $e9269e5be910ba89$export$4a030f6192bebe03);
const $e9269e5be910ba89$export$4a030f6192bebe03 = (match)=>{
    const fromMatch = match && match.params && match.params.issueKey !== undefined && match.params.issueKey !== null ? match.params.issueKey : null;
    return fromMatch;
};

});

parcelRegister("b8iE0", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bacedebb064d06c$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $27Eo5 = parcelRequire("27Eo5");

var $1aPBP = parcelRequire("1aPBP");
var $9PXNH = parcelRequire("9PXNH");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3bacedebb064d06c$export$2e2bcd8739ae039 = async ({ match: match }, { tenantContext: tenantContext })=>{
    const issueKey = (0, $9PXNH.getIssueKey)(match);
    if (!issueKey) return null;
    try {
        const { cloudId: cloudId, activationId: activationId } = tenantContext;
        const data = await (0, $27Eo5.fetchIssueForgeData)(cloudId, issueKey, activationId);
        return data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $1aPBP.createResourceError)({
            component: 'spa.view.routes.issue-view.forge.getData',
            message: 'An error was thrown while prefetching issue Forge data',
            name: 'ResourceError'
        }, error);
    }
};

});
parcelRegister("27Eo5", function(module, exports) {

$parcel$export(module.exports, "fetchIssueForgeData", () => $28f36679da26750f$export$44da8345d9ceca61);

var $1ybV0 = parcelRequire("1ybV0");

var $2Rqjr = parcelRequire("2Rqjr");

var $arKaN = parcelRequire("arKaN");

var $cqw2K = parcelRequire("cqw2K");
const $28f36679da26750f$export$7c6ea4184129ef74 = (result, type)=>result.find((extensions)=>extensions.some((extension)=>extension.type === type)) || [];
const $28f36679da26750f$export$44da8345d9ceca61 = async (cloudId, issueKey, activationId)=>{
    const modulesToFetch = [
        (0, $2Rqjr.ISSUE_ACTION_MODULE),
        (0, $2Rqjr.ISSUE_GLANCE_MODULE),
        (0, $2Rqjr.ISSUE_CONTEXT_MODULE),
        (0, $2Rqjr.ISSUE_PANEL_MODULE),
        (0, $2Rqjr.ISSUE_ACTIVITY_MODULE),
        (0, $2Rqjr.CUSTOM_FIELD_MODULE),
        (0, $2Rqjr.CUSTOM_FIELD_TYPE_MODULE),
        (0, $2Rqjr.ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE),
        (0, $2Rqjr.UI_MODIFICATIONS_MODULE)
    ];
    const contextIds = (0, $1ybV0.ff)('arken-1053-jira-forge-extension-changes-for-aegis_aws9x') ? [
        `ari:cloud:jira:${cloudId}:workspace/${activationId}`
    ] : undefined;
    const result = await (0, $arKaN.default)(cloudId, modulesToFetch, {
        issueKey: issueKey
    }, {
        include: {
            scopes: true
        }
    }, (0, $2Rqjr.SOURCE_ISSUE_VIEW), contextIds);
    const { extensions: extensions, accessNarrowedExtensions: accessNarrowedExtensions } = result;
    const mappedResult = {
        issueAction: extensions.jiraIssueAction || [],
        issueGlance: extensions.jiraIssueGlance || [],
        issueContext: extensions.jiraIssueContext || [],
        issuePanel: extensions.jiraIssuePanel || [],
        issueActivity: extensions.jiraIssueActivity || [],
        customField: extensions.jiraCustomField || [],
        customFieldType: extensions.jiraCustomFieldType || [],
        issueViewBackgroundScript: extensions.jiraIssueViewBackgroundScript || [],
        uiModifications: extensions.jiraUiModifications || [],
        blockedExtensions: {
            issueAction: accessNarrowedExtensions.jiraIssueAction || [],
            issueGlance: accessNarrowedExtensions.jiraIssueGlance || [],
            issueContext: accessNarrowedExtensions.jiraIssueContext || [],
            issuePanel: accessNarrowedExtensions.jiraIssuePanel || [],
            issueActivity: accessNarrowedExtensions.jiraIssueActivity || [],
            customField: accessNarrowedExtensions.jiraCustomField || [],
            customFieldType: accessNarrowedExtensions.jiraCustomFieldType || [],
            issueViewBackgroundScript: accessNarrowedExtensions.jiraIssueViewBackgroundScript || [],
            uiModifications: accessNarrowedExtensions.jiraUiModifications || []
        }
    };
    return (0, $cqw2K.dedupeContextAndGlance)(mappedResult);
};

});
parcelRegister("cqw2K", function(module, exports) {

$parcel$export(module.exports, "dedupeContextAndGlance", () => $d64b2f99c2b8c70a$export$17503ba1adfac304);
const $d64b2f99c2b8c70a$export$17503ba1adfac304 = (forgeData)=>{
    const contextInstallationIds = new Set(forgeData.issueContext?.map(({ installationId: installationId })=>installationId));
    const newGlanceItems = forgeData.issueGlance.filter(({ installationId: installationId })=>!contextInstallationIds.has(installationId));
    return {
        ...forgeData,
        issueGlance: newGlanceItems
    };
};

});




parcelRegister("iudJZ", function(module, exports) {

$parcel$export(module.exports, "issueGiraDataResource", () => $10cd2c2c1f752564$export$37badecd288c49f4);

var $3HCkE = parcelRequire("3HCkE");

var $9PXNH = parcelRequire("9PXNH");

var $2skem = parcelRequire("2skem");

var $danRw = parcelRequire("danRw");
const $10cd2c2c1f752564$export$37badecd288c49f4 = (0, $3HCkE.createResource)((0, $2skem.withResourceEarlyData)({
    type: 'ISSUE_GIRA_DATA',
    getKey: ({ match: match })=>{
        const issueKey = (0, $9PXNH.getIssueKey)(match);
        return issueKey || '';
    },
    getData: (...args)=>(0, $danRw.default)(...args),
    isBrowserOnly: true
}));

});
parcelRegister("2skem", function(module, exports) {

$parcel$export(module.exports, "MIN_MAX_AGE", () => $74b0242981e8d241$export$5664a170ac5a9781);
$parcel$export(module.exports, "withResourceEarlyData", () => $74b0242981e8d241$export$22da5fb8c8200986);
const $74b0242981e8d241$export$5664a170ac5a9781 = 5000;
const $74b0242981e8d241$export$22da5fb8c8200986 = ({ type: type, getData: next, getDataLoader: getDataLoader, ...rest })=>{
    const getData = (...args)=>{
        performance.mark(`issueViewEarlyScripts:${type}:withResourceEarlyData:called`);
        if (!false && type in window) {
            // @ts-expect-error - Element implicitly has an 'any' type because index expression is not of type 'number'
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            const promise = window[type];
            // @ts-expect-error - Element implicitly has an 'any' type because index expression is not of type 'number'
            delete window[type];
            getDataLoader && promise.then(getDataLoader);
            return promise;
        }
        if (getDataLoader) return getDataLoader().then(({ default: getDataPromise })=>getDataPromise(...args));
        return next && next(...args);
    };
    return {
        ...rest,
        type: type,
        getData: getData
    };
};

});

parcelRegister("danRw", function(module, exports) {

$parcel$export(module.exports, "default", () => $42978606795502c9$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $3l0Oz = parcelRequire("3l0Oz");

var $1aPBP = parcelRequire("1aPBP");
var $9PXNH = parcelRequire("9PXNH");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$42978606795502c9$export$2e2bcd8739ae039 = async ({ match: match }, { tenantContext: tenantContext })=>{
    const issueKey = (0, $9PXNH.getIssueKey)(match);
    if (!issueKey) return null;
    try {
        const { baseUrl: baseUrl } = tenantContext;
        const data = await (0, $3l0Oz.default)(baseUrl, issueKey);
        return data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $1aPBP.createResourceError)({
            component: 'spa.view.routes.issue-view.gira.getData',
            message: 'An error was thrown while prefetching issue gira data',
            name: 'ResourceError'
        }, error);
    }
};

});
parcelRegister("3l0Oz", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc2ad8759ea4740f$export$2e2bcd8739ae039);

var $lNfG4 = parcelRequire("lNfG4");

var $jBy23 = parcelRequire("jBy23");

var $gIOVj = parcelRequire("gIOVj");

var $a60Hj = parcelRequire("a60Hj");

var $kXzsJ = parcelRequire("kXzsJ");
const $cc2ad8759ea4740f$var$ISSUE_GIRA_DATA = 'issue-gira-data';
const $cc2ad8759ea4740f$var$timeToFetchIssueGiraDataMetric = (0, $lNfG4.metrics).custom({
    key: $cc2ad8759ea4740f$var$ISSUE_GIRA_DATA
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cc2ad8759ea4740f$export$2e2bcd8739ae039 = async (baseUrl, issueKey)=>{
    const projectKey = (0, $jBy23.extractProjectKey)(issueKey);
    const variables = {
        issueKey: issueKey,
        projectKey: projectKey
    };
    const payload = {
        query: (0, $gIOVj.buildIssueQuery)(),
        variables: variables,
        operationName: (0, $gIOVj.ISSUE_VIEW_INTERACTIVE_QUERY)
    };
    if ((0, $a60Hj.isInSample)()) $cc2ad8759ea4740f$var$timeToFetchIssueGiraDataMetric.start();
    try {
        const response = await (0, $kXzsJ.getClient)(baseUrl).query(payload);
        // Best-effort attempt to provide `issueId` and is not guaranteed
        const issueId = response.data?.viewIssue?.issueId;
        $cc2ad8759ea4740f$var$timeToFetchIssueGiraDataMetric.stop({
            customData: issueId ? {
                issueId: issueId
            } : null
        });
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // Cancel the metric and re-throw the error
        $cc2ad8759ea4740f$var$timeToFetchIssueGiraDataMetric.cancel();
        throw error;
    }
};

});
parcelRegister("jBy23", function(module, exports) {

$parcel$export(module.exports, "extractProjectKey", () => $7901038b5997e3c0$export$f1a2e4721b127828);

var $6vrw7 = parcelRequire("6vrw7");
const $7901038b5997e3c0$export$f1a2e4721b127828 = (issueKey)=>(0, $6vrw7.toProjectKey)(issueKey.split('-')[0]);

});

parcelRegister("gIOVj", function(module, exports) {

$parcel$export(module.exports, "ISSUE_VIEW_INTERACTIVE_QUERY", () => $8fd02e0075f962e8$export$1780a132c0453fee);
$parcel$export(module.exports, "getGiraUrl", () => $8fd02e0075f962e8$export$aefb19023b2eda55);
$parcel$export(module.exports, "getJiraQueryEcosystemFirstSeenOnIssueView", () => $8fd02e0075f962e8$export$79eba9bf6dc9960d);
$parcel$export(module.exports, "buildIssueQuery", () => $8fd02e0075f962e8$export$222ae9aca08830f0);
$parcel$export(module.exports, "getGiraRequestOptions", () => $8fd02e0075f962e8$export$e1542dc7ff749de8);
$parcel$export(module.exports, "getContentPanelsQuery", () => (parcelRequire("7IE2L")).getContentPanelsQuery);
$parcel$export(module.exports, "getEcosystemQuery", () => (parcelRequire("gIud4")).getEcosystemQuery);

var $bKxX9 = parcelRequire("bKxX9");

var $k0k8C = parcelRequire("k0k8C");

var $cs6Z7 = parcelRequire("cs6Z7");

var $6wu6G = parcelRequire("6wu6G");

var $h9ZPQ = parcelRequire("h9ZPQ");
var $8b8FO = parcelRequire("8b8FO");
var $iKlzi = parcelRequire("iKlzi");
var $7IE2L = parcelRequire("7IE2L");
var $gIud4 = parcelRequire("gIud4");
var $78jDL = parcelRequire("78jDL");
var $bjRBT = parcelRequire("bjRBT");
var $aEsk2 = parcelRequire("aEsk2");
var $k94eC = parcelRequire("k94eC");
var $9U1Mc = parcelRequire("9U1Mc");
var $1zKic = parcelRequire("1zKic");
var $4825Q = parcelRequire("4825Q");
var $cEBFL = parcelRequire("cEBFL");
const $8fd02e0075f962e8$var$CREATED_ORDER_DESCENDING = '-created';
const $8fd02e0075f962e8$export$1780a132c0453fee = 'issueViewInteractiveQuery';
const $8fd02e0075f962e8$export$aefb19023b2eda55 = (baseUrl, operation)=>`${baseUrl}/rest/gira/1/${(0, $k0k8C.appendOperationQuery)(operation)}`;
const $8fd02e0075f962e8$var$viewIssueQuery = ()=>`
    viewIssue(issueKey: $issueKey) {
        ${(0, $cs6Z7.getIsOldValueRequested)((0, $6wu6G.GIRA_AGG_MIGRATION_ISARCHIVED_FLAG)) ? (0, $78jDL.getIsArchivedQuery)() : ''}
        canCreateSubTask
        ${(0, $6wu6G.isIssueExportControlEnabled)() ? 'canExportIssue' : ''}
        ${/**
					 * Note: When activity sorting feature is enabled, we do not
					 * want to fetch with sort order passed through; we should defer
					 * to the saved sort order in the backend to return the correct
					 * sort order
					 */ (0, $8b8FO.default)({
        maxResults: (0, $cEBFL.NUM_INITIAL_COMMENTS_TO_LOAD),
        startAt: 0,
        orderBy: $8fd02e0075f962e8$var$CREATED_ORDER_DESCENDING,
        commentAmount: Math.floor((0, $cEBFL.NUM_INITIAL_COMMENTS_TO_LOAD))
    })}
        ${/**
					 * Note: When activity sorting feature is enabled, we do not
					 * want to fetch with sort order passed through; we should defer
					 * to the saved sort order in the backend to return the correct
					 * sort order
					 */ (0, $4825Q.default)({
        startAt: 0,
        worklogAmount: Math.floor((0, $cEBFL.NUM_INITIAL_WORKLOGS_TO_LOAD))
    })}
        ${(0, $gIud4.getEcosystemQuery)()}
        ${(0, $7IE2L.getContentPanelsQuery)()}
        ${(0, $bKxX9.ff)('issue-view-remove-glancesfield-from-query_fyj0g') ? (0, $gIud4.getLegacyRightWebPanelsQuery)() : (0, $gIud4.getGlancesQuery)()}
		${// only fetch dead glancesField if it's already removed (using legacyRightWebPanels)
    (0, $bKxX9.ff)('issue-view-remove-glancesfield-from-query_fyj0g') && (0, $bKxX9.ff)('implement-dead-glancesfield-query_f71sc') ? (0, $gIud4.getGlancesQuery)() : ''}
        ${(0, $bKxX9.ff)('issue.details.gira-agg-migration-attachments_ecebe') ? 'totalAttachmentsCount' : (0, $h9ZPQ.default)()}
        ${(0, $iKlzi.getContainersByTypeQuery)()}
        ${(0, $1zKic.getRemoteLinksQuery)()}
    }
`;
const $8fd02e0075f962e8$export$79eba9bf6dc9960d = ()=>`
    jira {
        ecosystemFirstSeenOnIssueView
    }
`;
const $8fd02e0075f962e8$export$58eaa2ae4a5a410a = ()=>`
    jira {
        ecosystemFirstSeenOnIssueView
        hasAdministerPermission: hasGlobalPermission(key: ADMINISTER)
        hasUserPickerPermission: hasGlobalPermission(key: USER_PICKER)
    }
`;
const $8fd02e0075f962e8$export$222ae9aca08830f0 = ()=>`
query ${$8fd02e0075f962e8$export$1780a132c0453fee}($issueKey: String!, $projectKey: String)  {
        ${$8fd02e0075f962e8$export$58eaa2ae4a5a410a()}
        ${(0, $aEsk2.default)()}
        ${$8fd02e0075f962e8$var$viewIssueQuery()}
        ${(0, $bjRBT.getJiraSettingsQuery)()}
        ${(0, $k94eC.default)()}
        ${(0, $9U1Mc.default)()}
    }

`;
const $8fd02e0075f962e8$export$e1542dc7ff749de8 = (issueKey, projectKey)=>{
    const payload = {
        operationName: $8fd02e0075f962e8$export$1780a132c0453fee,
        query: $8fd02e0075f962e8$export$222ae9aca08830f0(),
        variables: {
            issueKey: issueKey,
            projectKey: projectKey
        }
    };
    return {
        method: 'POST',
        body: JSON.stringify(payload)
    };
};

});
parcelRegister("k0k8C", function(module, exports) {

$parcel$export(module.exports, "appendOperationQuery", () => $c7bfdca12e254eb8$export$69694c3add0f6058);
const $c7bfdca12e254eb8$export$69694c3add0f6058 = (operation)=>operation ? `?operation=${operation}` : '';

});

parcelRegister("cs6Z7", function(module, exports) {

$parcel$export(module.exports, "getIsOldValueRequested", () => $712ffcbbea6809c2$export$117d07493a3c1dce);
$parcel$export(module.exports, "getIsNewValueRequested", () => $712ffcbbea6809c2$export$7cdf481ce732d27f);

var $bKxX9 = parcelRequire("bKxX9");
const $712ffcbbea6809c2$var$getConsistencyCheckFeatureFlag = (featureFlagName, defaultValue = 'OLD')=>{
    const possibleValues = [
        'NEW',
        'CHECK_RETURN_NEW',
        'CHECK',
        'OLD'
    ];
    return (0, $bKxX9.getMultivariateFeatureFlag)(featureFlagName, defaultValue, possibleValues);
};
const $712ffcbbea6809c2$export$117d07493a3c1dce = (featureFlagName)=>{
    const featureFlagValue = $712ffcbbea6809c2$var$getConsistencyCheckFeatureFlag(featureFlagName);
    return featureFlagValue === 'OLD' || featureFlagValue === 'CHECK_RETURN_NEW' || featureFlagValue === 'CHECK';
};
const $712ffcbbea6809c2$export$7cdf481ce732d27f = (featureFlagName)=>{
    const featureFlagValue = $712ffcbbea6809c2$var$getConsistencyCheckFeatureFlag(featureFlagName);
    return featureFlagValue === 'NEW' || featureFlagValue === 'CHECK_RETURN_NEW' || featureFlagValue === 'CHECK';
};

});

parcelRegister("6wu6G", function(module, exports) {

$parcel$export(module.exports, "isParentInIssueViewEnabled", () => $54a10774de0b57ab$export$9c7fa56ed1fa2e15);
$parcel$export(module.exports, "isJsmTimelineEnabled", () => $54a10774de0b57ab$export$575e1bf822db15b5);
$parcel$export(module.exports, "GIRA_AGG_MIGRATION_ISARCHIVED_FLAG", () => $54a10774de0b57ab$export$f53cbe8a5052e3e0);
$parcel$export(module.exports, "isIssueExportControlEnabled", () => $54a10774de0b57ab$export$e92cc7310d059d3e);

var $bKxX9 = parcelRequire("bKxX9");
const $54a10774de0b57ab$export$9c7fa56ed1fa2e15 = ()=>(0, $bKxX9.ff)('parent-field-in-issue-view_x4zn4', false);
const $54a10774de0b57ab$export$575e1bf822db15b5 = ()=>(0, $bKxX9.ff)('jsm-timelines-phase-2_70gja', false);
const $54a10774de0b57ab$export$f53cbe8a5052e3e0 = 'issue.details.gira-agg-migration-isarchived';
const $54a10774de0b57ab$export$e92cc7310d059d3e = ()=>(0, $bKxX9.ff)('dlp-gordian-enabled', false); // </gordian>

});

parcelRegister("h9ZPQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c28c20ef01249d5c$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $c28c20ef01249d5c$export$2e2bcd8739ae039 = ()=>`attachments(orderDirection: DESC, orderField: CREATED, maxResults: 12) {
        nodes {
          id
          filename
          mimetype
          mediaApiFileId
          createdDate
          filesize
          parentName
          author {
              accountId
          }
          parentId
          hasRestrictedParent
        }
        totalCount
        deletableCount
      }
`;

});

parcelRegister("8b8FO", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b9fb32e2d7fc8e2$export$2e2bcd8739ae039);

var $8c9rb = parcelRequire("8c9rb");

var $6wu6G = parcelRequire("6wu6G");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7b9fb32e2d7fc8e2$export$2e2bcd8739ae039 = ({ maxResults: maxResults, startAt: startAt, orderBy: orderBy, commentAmount: commentAmount })=>{
    const commentPermalinkId = (0, $8c9rb.getPermalinkId)((0, $8c9rb.COMMENTS));
    const orderByParameter = orderBy !== null && orderBy !== undefined ? `, orderBy: "${orderBy}"` : '';
    const commentParameter = commentPermalinkId !== null && commentPermalinkId !== undefined ? `, commentId: ${commentPermalinkId}` : '';
    const commentAmountParameter = commentParameter !== '' && commentAmount !== null && commentAmount !== undefined ? `, commentAmount: ${commentAmount}` : '';
    const maxResultsParameter = commentParameter === '' && maxResults !== null && maxResults !== undefined ? `, maxResults: ${maxResults}` : '';
    const jiraCommentVisibility = ` jiraCommentVisibility {
    __typename
    ...on JiraRoleVisibility {
      name
    }
    ...on JiraGroupVisibility {
      group {
        groupId
        name
      }
    }
  }`;
    return `
        comments (first: ${startAt}${maxResultsParameter}${orderByParameter}${commentParameter}${commentAmountParameter}) {
            nodes {
                id
                author {
                    accountId
                    displayName
                    avatarUrl
                }
                updateAuthor {
                    accountId
                    displayName
                    avatarUrl
                }
                ${jiraCommentVisibility}
                created
                updated
                jsdPublic
                bodyAdf
                jsdAuthorCanSeeRequest
                ${(0, $6wu6G.isJsmTimelineEnabled)() ? 'eventOccurredAt' : ''}
                ${(0, $6wu6G.isJsmTimelineEnabled)() ? 'jsdIncidentActivityViewHidden' : ''}
            }
            totalCount
            startIndex
        }
    `;
};

});
parcelRegister("8c9rb", function(module, exports) {

$parcel$export(module.exports, "COMMENTS", () => $227761ce6e538457$export$4cab9dfa8fc858f4);
$parcel$export(module.exports, "WORKLOG", () => $227761ce6e538457$export$df36fc05622c402);
$parcel$export(module.exports, "getPermalinkId", () => $227761ce6e538457$export$bf42dbba4c31080e);

var $gUUjF = parcelRequire("gUUjF");
const $227761ce6e538457$export$b18d061fc042df1a = {
    COMMENTS: 'focusedCommentId',
    WORKLOG: 'focusedWorklogId'
};
const $227761ce6e538457$export$4cab9dfa8fc858f4 = 'COMMENTS';
const $227761ce6e538457$export$df36fc05622c402 = 'WORKLOG';
const $227761ce6e538457$var$getAllUrlParams = ()=>{
    // get query string from  window
    let queryString = window.location.search.slice(1);
    // we'll store the parameters here
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const obj = {};
    // if query string exists
    if (queryString) {
        // stuff after # is not part of query string, so get rid of it
        queryString = queryString.split('#')[0];
        // split our query string into its component parts
        const arr = queryString.split('&');
        for(let i = 0; i < arr.length; i += 1){
            // separate the keys and the values
            const a = arr[i].split('=');
            // set parameter name and value (use 'true' if empty)
            const paramName = a[0];
            try {
                const paramValue = typeof a[1] === 'undefined' ? true : decodeURIComponent(a[1]);
                obj[paramName] = paramValue;
            } catch (error) {
                (0, $gUUjF.default).safeErrorWithoutCustomerData('getAllUrlParams', `Malformed value was obtained from the query string for ${paramName}`);
            }
        }
    }
    return obj;
};
const $227761ce6e538457$export$bf42dbba4c31080e = (targetPermalinkType)=>{
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly COMMENTS: "focusedCommentId"; readonly WORKLOG: "focusedWorklogId"; }'.
    if (!$227761ce6e538457$export$b18d061fc042df1a[targetPermalinkType]) return null;
    const urlParams = $227761ce6e538457$var$getAllUrlParams();
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly COMMENTS: "focusedCommentId"; readonly WORKLOG: "focusedWorklogId"; }'.
    return urlParams[$227761ce6e538457$export$b18d061fc042df1a[targetPermalinkType]];
};

});


parcelRegister("iKlzi", function(module, exports) {

$parcel$export(module.exports, "getContainersByTypeQuery", () => $f3b1ff3f54778e3d$export$63131b2831854cc);
const $f3b1ff3f54778e3d$export$63131b2831854cc = ()=>`
containersByType(input:{systemContainerTypes: [CONTENT, PRIMARY, SECONDARY, REQUEST_PORTAL], supportDefaultTab: true}) {
__typename
... on JiraIssueItemContainers {
containers {
  containerType
  items {
    nodes {
      type: __typename
      ... on JiraIssueItemFieldItem {
        fieldItemId        
      }
      ... on JiraIssueItemPanelItem {
        panelItemId
      }
      ... on JiraIssueItemTabContainer {
        name
        tabContainerId              
        items {
          nodes {
            type: __typename
            ... on JiraIssueItemFieldItem {
              fieldItemId
            }
          }
        }
      }
    }
  }
}
}
}
`;

});

parcelRegister("7IE2L", function(module, exports) {

$parcel$export(module.exports, "getContentPanelsQuery", () => $431a6f81d3096fcd$export$e6f14eac549b679d);
const $431a6f81d3096fcd$var$getContentPanelNode = ()=>`
    name
    addonKey
    moduleKey
    options
    iconUrl
    tooltip
    type
    isShownByDefault
    wasManuallyAddedToIssue
`;
const $431a6f81d3096fcd$var$getContentPanelsConnectionQuery = ()=>`
    contentPanels {
        edges {
            node {
                ${$431a6f81d3096fcd$var$getContentPanelNode()}
            }
        }
    }
`;
const $431a6f81d3096fcd$var$getLegacyContentPanelsConnectionQuery = ()=>`
    legacyContentPanels {
        edges {
            node {
                ${$431a6f81d3096fcd$var$getContentPanelNode()}
            }
        }
    }
`;
const $431a6f81d3096fcd$export$e6f14eac549b679d = ()=>`
    ${$431a6f81d3096fcd$var$getContentPanelsConnectionQuery()}
    ${$431a6f81d3096fcd$var$getLegacyContentPanelsConnectionQuery()}
    hasCustomisedContentPanels
`;

});

parcelRegister("gIud4", function(module, exports) {

$parcel$export(module.exports, "getEcosystemQuery", () => $7b5055fce2a30c91$export$edefef8c65e08bd2);
$parcel$export(module.exports, "getGlancesQuery", () => $7b5055fce2a30c91$export$ca7e7bf9f1b931a2);
$parcel$export(module.exports, "getLegacyRightWebPanelsQuery", () => $7b5055fce2a30c91$export$92c9a3dc7076af51);

var $bKxX9 = parcelRequire("bKxX9");
const $7b5055fce2a30c91$var$getForgeQuery = ()=>`forge {
        panels {
          id
          instances {
            id
            collapsed
            added
          }
        }
      }`;
const $7b5055fce2a30c91$export$edefef8c65e08bd2 = ()=>`
    ecosystem {
      ${!(0, $bKxX9.ff)('issue-view-remove-connect-operations-from-critical-fetch_vtk4w') ? `
      operations {
        name
        url: href
        icon {
          url
        }
        tooltip
        styleClass
      }` : ''}
      ${!(0, $bKxX9.ff)('issue-view-remove-activitypanels-from-critical-fetch_43ozj') ? `
      activityPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
      }    
    ` : ''}
      ${!(0, $bKxX9.ff)('issue-view-remove-backgroundscripts-from-critical-fetch_6f6on') ? `
      backgroundScripts {
        iframe {
          addonKey
          moduleKey
          options
        }
        shouldReloadOnRefresh
      }` : ''}
      contextPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
        icon {
          url
        }
        content
        status
        type
      }
      ${$7b5055fce2a30c91$var$getForgeQuery()}
    }
`;
const $7b5055fce2a30c91$export$ca7e7bf9f1b931a2 = ()=>`
        glancesField {
          fieldKey
          value {
            name
            status
            iframe {
              addonKey
              moduleKey
              options
            }
            icon {
              url
            }
            content
            type
          }
        }
      `;
const $7b5055fce2a30c91$export$92c9a3dc7076af51 = ()=>`
        legacyRightWebPanels {
          edges {
            node {
              name
              status
              addonKey
              moduleKey
              options
              content
            }
          }
        }
      `;

});

parcelRegister("78jDL", function(module, exports) {

$parcel$export(module.exports, "getIsArchivedQuery", () => $70934e0e589cd253$export$2b9ee7163e124831);
const $70934e0e589cd253$export$2b9ee7163e124831 = ()=>'isArchived';

});

parcelRegister("bjRBT", function(module, exports) {

$parcel$export(module.exports, "getJiraSettingsQuery", () => $fc5601890f738e54$export$191f50c0f86b85ec);
const $fc5601890f738e54$export$e302502f14e3f203 = ()=>`
          timeTracking {
            isTimeTrackingEnabled
            hoursPerDay
            daysPerWeek
            defaultUnit
            format
          }
    `;
const $fc5601890f738e54$export$65e7d3d1915962da = ()=>`
          subtasks {
            enabled
          }
    `;
const $fc5601890f738e54$export$191f50c0f86b85ec = ()=>`
    jiraSettings {
      newIssueViewTransitionSettings {
        shouldDelayChangeboarding
        newIssueViewTransitionLockingStatus
     }
    }
`;

});

parcelRegister("aEsk2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad384184792593f0$export$2e2bcd8739ae039);

var $hCNRu = parcelRequire("hCNRu");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ad384184792593f0$export$2e2bcd8739ae039 = ()=>`mediaContext(issueKey: $issueKey) {
    userToken {
      token
      id
      issueId
      tokenDurationInMins
    }
    uploadToken {
      __typename
      ... on MediaUploadToken {
        endpointUrl
        token
        targetCollection
        tokenDurationInMins
        clientId
      }
      ... on FailedMediaUploadToken {
        error
      }
    }
    readToken(maxTokenLength: ${(0, $hCNRu.getMaxTokenLength)()}) {
      clientId
      endpointUrl
      tokensWithFiles {
        files {
          issueId
          attachmentId
          attachmentMediaApiId
        }
        token
      }
      tokenLifespanInSeconds
    }
  }`;

});
parcelRegister("hCNRu", function(module, exports) {

$parcel$export(module.exports, "getMaxTokenLength", () => $64be2f4b2ff25f7a$export$e40f2acaf1a50b00);
// Low enough such that it shouldn't cause problems for non-IE11 browsers, and high
// enough such that it shouldn't be encountered in practice very often.
const $64be2f4b2ff25f7a$var$nonIE11MaxTokenLength = 2 ** 16;
const $64be2f4b2ff25f7a$export$e40f2acaf1a50b00 = ()=>$64be2f4b2ff25f7a$var$nonIE11MaxTokenLength;

});


parcelRegister("k94eC", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2892695ccbce2fe$export$2e2bcd8739ae039);
// A list of all keys of permissions that this transformer supports.
const $c2892695ccbce2fe$export$9fc40cb6f3529ef = ()=>[
        'ADMINISTER_PROJECTS',
        'ASSIGN_ISSUES',
        'EDIT_ISSUES',
        'SCHEDULE_ISSUES',
        'ADD_COMMENTS',
        'DELETE_ALL_COMMENTS',
        'DELETE_OWN_COMMENTS',
        'EDIT_ALL_COMMENTS',
        'EDIT_OWN_COMMENTS',
        'CREATE_ISSUES',
        'DELETE_ISSUES',
        'MOVE_ISSUES',
        'MODIFY_REPORTER',
        'CREATE_ATTACHMENTS',
        'DELETE_ALL_ATTACHMENTS',
        'DELETE_OWN_ATTACHMENTS',
        'WORK_ON_ISSUES',
        'ASSIGNABLE_USER',
        'LINK_ISSUES',
        'VIEW_VOTERS_AND_WATCHERS',
        'MANAGE_WATCHERS',
        'EDIT_ALL_WORKLOGS',
        'EDIT_OWN_WORKLOGS',
        'DELETE_ALL_WORKLOGS',
        'DELETE_OWN_WORKLOGS',
        'VIEW_DEV_TOOLS',
        'SERVICEDESK_AGENT',
        'RESOLVE_ISSUES',
        'CLONE_ISSUE'
    ];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c2892695ccbce2fe$export$2e2bcd8739ae039 = ()=>`
    permissions(issueKey:$issueKey, keys:["${$c2892695ccbce2fe$export$9fc40cb6f3529ef().join('","')}"]) {
        key
        havePermission
    }
`;

});

parcelRegister("9U1Mc", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4c00732e1b938da$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $a4c00732e1b938da$export$2e2bcd8739ae039 = ()=>`
    project(projectKey: $projectKey) {
        id
        newIssueViewLockedIn
        issueTypes {
            id
            name
            iconUrl
            subtask
        }
    }
`;

});

parcelRegister("1zKic", function(module, exports) {

$parcel$export(module.exports, "getRemoteLinksQuery", () => $785a81b5a18b3dbb$export$6bbc6b72b0b57f25);
const $785a81b5a18b3dbb$export$6bbc6b72b0b57f25 = ()=>`
    remoteLinks {
        isLinkingEnabled
        remoteLinkedIssues {
            preview {
                id
                issueId
                globalId
                href
                applicationType
                applicationName
                relationship
                title
            }
        }
    }            
`;

});

parcelRegister("4825Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a565ae6a7a72917$export$2e2bcd8739ae039);

var $8c9rb = parcelRequire("8c9rb");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7a565ae6a7a72917$export$2e2bcd8739ae039 = ({ startAt: startAt, orderBy: orderBy, worklogAmount: worklogAmount })=>{
    const orderByParameter = orderBy !== null && orderBy !== undefined ? `, orderBy: "${orderBy}"` : '';
    const worklogPermalinkId = (0, $8c9rb.getPermalinkId)((0, $8c9rb.WORKLOG));
    if (worklogPermalinkId === null || worklogPermalinkId === undefined) return '';
    const worklogParameter = `, worklogId: ${worklogPermalinkId}`;
    const worklogAmountParameter = worklogAmount !== null && worklogAmount !== undefined ? `, worklogAmount: ${worklogAmount}` : '';
    return `
        worklogs (startAt: ${startAt}${orderByParameter}${worklogParameter}${worklogAmountParameter}) {
            nodes {
                id
                author {
                    accountId
                    displayName
                    avatarUrl
                }
                updateAuthor {
                    accountId
                    displayName
                    avatarUrl
                }
                created
                started
                updated
                comment
                timeSpent
                timeSpentSeconds
            }
            totalCount
            startIndex
        }
    `;
};

});

parcelRegister("cEBFL", function(module, exports) {

$parcel$export(module.exports, "NUM_INITIAL_COMMENTS_TO_LOAD", () => $918a33e666c5e78d$export$c46d621c29194aa4);
$parcel$export(module.exports, "NUM_INITIAL_WORKLOGS_TO_LOAD", () => $918a33e666c5e78d$export$b2e398ce246f55b3);
$parcel$export(module.exports, "gqlTagGira", () => $918a33e666c5e78d$export$aeae6fc40846cf9f);

var $7IE2L = parcelRequire("7IE2L");

var $gIud4 = parcelRequire("gIud4");

var $78jDL = parcelRequire("78jDL");


var $h9ZPQ = parcelRequire("h9ZPQ");

var $8b8FO = parcelRequire("8b8FO");

var $4825Q = parcelRequire("4825Q");

var $bjRBT = parcelRequire("bjRBT");

var $aEsk2 = parcelRequire("aEsk2");

var $k94eC = parcelRequire("k94eC");

var $9U1Mc = parcelRequire("9U1Mc");

var $iKlzi = parcelRequire("iKlzi");

var $1zKic = parcelRequire("1zKic");

const $918a33e666c5e78d$export$c46d621c29194aa4 = 5;
const $918a33e666c5e78d$export$304a6c004edb30d8 = '-created';
const $918a33e666c5e78d$export$b2e398ce246f55b3 = 5;
const $918a33e666c5e78d$export$1c36ecc9afd61c73 = '-started';
const $918a33e666c5e78d$export$aeae6fc40846cf9f = (literals, ...substitutions)=>{
    let result = '';
    // run the loop only for the substitution count
    substitutions.forEach((key, i)=>{
        result += literals[i];
        result += key.toString();
    });
    // add the last literal
    result += literals[literals.length - 1];
    return result;
};

});


parcelRegister("a60Hj", function(module, exports) {

$parcel$export(module.exports, "isInSample", () => $433b34397a9756c8$export$a994c91d08ead5ff);

const $433b34397a9756c8$export$a994c91d08ead5ff = (sampleRate = (0, $3e173c13cba9c734$export$9fc1f2d681a9e609))=>Math.random() <= 1 / sampleRate;

});
/**
 * Sample rates are defined as the inverse.
 * e.g. a sample rate of 100 = 1 in 100 events are sent.
 */ const $3e173c13cba9c734$export$9fc1f2d681a9e609 = 100; // 1%


parcelRegister("kXzsJ", function(module, exports) {

$parcel$export(module.exports, "getClient", () => $04aa819d4030995f$export$6bb76d6eba7e258c);

var $2OdyW = parcelRequire("2OdyW");

var $gIOVj = parcelRequire("gIOVj");
const $04aa819d4030995f$var$makeFetchClient = (baseUrl)=>({
        query: ({ query: query, variables: variables, signal: signal, operationName: operationName })=>(0, $2OdyW.default)((0, $gIOVj.getGiraUrl)(baseUrl, operationName), {
                method: 'POST',
                body: JSON.stringify({
                    query: query,
                    variables: variables,
                    operationName: operationName
                }),
                signal: signal
            })
    });
let $04aa819d4030995f$var$client;
const $04aa819d4030995f$export$6bb76d6eba7e258c = (baseUrl)=>{
    if (!$04aa819d4030995f$var$client) $04aa819d4030995f$var$client = $04aa819d4030995f$var$makeFetchClient(baseUrl);
    return $04aa819d4030995f$var$client;
};

});




parcelRegister("kSgnh", function(module, exports) {

$parcel$export(module.exports, "issueGiraNonCriticalDataResource", () => $d12a144daa5dfc13$export$2d81f7bddf10f49e);

var $3HCkE = parcelRequire("3HCkE");

var $9PXNH = parcelRequire("9PXNH");

var $2skem = parcelRequire("2skem");

var $tPTRS = parcelRequire("tPTRS");
const $d12a144daa5dfc13$export$2d81f7bddf10f49e = (0, $3HCkE.createResource)((0, $2skem.withResourceEarlyData)({
    type: 'ISSUE_GIRA_NON_CRITICAL_DATA',
    getKey: ({ match: match })=>{
        const issueKey = (0, $9PXNH.getIssueKey)(match);
        return issueKey || '';
    },
    getData: (...args)=>(0, $tPTRS.default)(...args),
    isBrowserOnly: true
}));

});
parcelRegister("tPTRS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e93b0b54749e5eeb$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $lwu0A = parcelRequire("lwu0A");

var $1aPBP = parcelRequire("1aPBP");
var $9PXNH = parcelRequire("9PXNH");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e93b0b54749e5eeb$export$2e2bcd8739ae039 = async ({ match: match }, _)=>{
    const issueKey = (0, $9PXNH.getIssueKey)(match);
    if (!issueKey) return null;
    try {
        const data = await (0, $lwu0A.fetchIssueGiraNonCriticalData)(issueKey);
        return data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $1aPBP.createResourceError)({
            component: 'spa.view.routes.issue-view.gira-non-critical.getData',
            message: 'An error was thrown while prefetching issue gira non critical data',
            name: 'ResourceError'
        }, error);
    }
};

});
parcelRegister("lwu0A", function(module, exports) {

$parcel$export(module.exports, "nonCriticalGiraQueryExperienceTracking", () => $aea8e6a6bf82674d$export$f382deefb24f95ae);
$parcel$export(module.exports, "fetchIssueGiraNonCriticalData", () => $aea8e6a6bf82674d$export$58a9221a6c5306db);

var $1ybV0 = parcelRequire("1ybV0");

var $7EhAs = parcelRequire("7EhAs");

var $ieUuV = parcelRequire("ieUuV");

var $4ceCM = parcelRequire("4ceCM");

var $kXzsJ = parcelRequire("kXzsJ");
const $aea8e6a6bf82674d$var$nonCriticalGiraQueryExperienceDescription = ({ wasExperienceSuccessful: wasExperienceSuccessful, errorMessage: errorMessage, traceId: traceId, isEarlyFetch: isEarlyFetch })=>{
    const errorMessageItem = errorMessage != null ? {
        errorMessage: errorMessage
    } : {};
    const traceIdItem = traceId != null ? {
        traceId: traceId
    } : {};
    return {
        experience: isEarlyFetch ? 'issueEarlyFetchNonCriticalGiraQuery' : 'issueNonCriticalGiraQuery',
        wasExperienceSuccesful: wasExperienceSuccessful,
        analyticsSource: `Issue View ${isEarlyFetch ? 'Early Fetch ' : ''}Non Critical Gira Query`,
        additionalAttributes: {
            method: 'GET',
            ...errorMessageItem,
            ...traceIdItem
        },
        application: null,
        edition: null
    };
};
const $aea8e6a6bf82674d$export$f382deefb24f95ae = ({ wasExperienceSuccessful: wasExperienceSuccessful, isEarlyFetch: isEarlyFetch, error: error })=>{
    (0, $4ceCM.sendExperienceAnalytics)($aea8e6a6bf82674d$var$nonCriticalGiraQueryExperienceDescription({
        wasExperienceSuccessful: wasExperienceSuccessful,
        ...error instanceof (0, $7EhAs.default) && error.message != null ? {
            errorMessage: error.message
        } : {},
        ...error instanceof (0, $7EhAs.default) && error.traceId != null ? {
            traceId: error.traceId
        } : {},
        isEarlyFetch: isEarlyFetch
    }));
};
const $aea8e6a6bf82674d$var$isNonCriticalGiraQueryExperienceTrackingEnabled = ()=>(0, $1ybV0.ff)('issue.details.non-critical-gira-query-experience-tracking', false);
const $aea8e6a6bf82674d$export$58a9221a6c5306db = async (issueKey)=>{
    const variables = {
        issueKey: issueKey
    };
    const payload = {
        query: (0, $ieUuV.buildNonCriticalGiraQuery)(),
        variables: variables,
        operationName: (0, $ieUuV.ISSUE_VIEW_NON_CRITICAL_GIRA_QUERY)
    };
    if (!$aea8e6a6bf82674d$var$isNonCriticalGiraQueryExperienceTrackingEnabled()) {
        const response = await (0, $kXzsJ.getClient)('').query(payload);
        return response;
    }
    try {
        const response = await (0, $kXzsJ.getClient)('').query(payload);
        $aea8e6a6bf82674d$export$f382deefb24f95ae({
            wasExperienceSuccessful: true,
            isEarlyFetch: false
        });
        return response;
    } catch (error) {
        $aea8e6a6bf82674d$export$f382deefb24f95ae({
            wasExperienceSuccessful: false,
            isEarlyFetch: false,
            error: error instanceof (0, $7EhAs.default) ? error : undefined
        });
        throw error;
    }
};

});
parcelRegister("ieUuV", function(module, exports) {

$parcel$export(module.exports, "ISSUE_VIEW_NON_CRITICAL_GIRA_QUERY", () => $62451518e89bf947$export$857f1602ca5b9d99);
$parcel$export(module.exports, "buildNonCriticalGiraQuery", () => $62451518e89bf947$export$df3c3aa9d6d3f431);
$parcel$export(module.exports, "getNonCriticalGiraQueryRequestOptions", () => $62451518e89bf947$export$555194bfc9159fa3);

var $bKxX9 = parcelRequire("bKxX9");

var $knMkV = parcelRequire("knMkV");
const $62451518e89bf947$export$857f1602ca5b9d99 = 'issueViewNonCriticalGiraQuery';
const $62451518e89bf947$export$df3c3aa9d6d3f431 = ()=>`
query ${$62451518e89bf947$export$857f1602ca5b9d99}($issueKey: String!) {
    viewIssue(issueKey: $issueKey) {
        ${(0, $knMkV.getEcosystemQuery)()}
        ${(0, $bKxX9.ff)('issue.details.gira-agg-migration-attachments_ecebe') ? 'deletableAttachmentsCount' : ''}
    }
}`;
const $62451518e89bf947$export$555194bfc9159fa3 = (issueKey)=>({
        method: 'POST',
        body: JSON.stringify({
            operationName: $62451518e89bf947$export$857f1602ca5b9d99,
            query: $62451518e89bf947$export$df3c3aa9d6d3f431(),
            variables: {
                issueKey: issueKey
            }
        })
    });

});
parcelRegister("knMkV", function(module, exports) {

$parcel$export(module.exports, "getEcosystemQuery", () => $039ea2834e0e4840$export$edefef8c65e08bd2);

var $bKxX9 = parcelRequire("bKxX9");
const $039ea2834e0e4840$export$edefef8c65e08bd2 = ()=>`
  ecosystem {
    operations {
      name
      url: href
      tooltip
      styleClass
    }
    ${(0, $bKxX9.ff)('issue-view-remove-backgroundscripts-from-critical-fetch_6f6on') ? `
    backgroundScripts {
      iframe {
        addonKey
        moduleKey
        options
      }
      shouldReloadOnRefresh
    }` : ''}
    ${(0, $bKxX9.ff)('issue-view-remove-activitypanels-from-critical-fetch_43ozj') ? `
    activityPanels {
      name
      iframe {
        addonKey
        moduleKey
        options
      }
    }
  ` : ''}
  }
`;

});


parcelRegister("4ceCM", function(module, exports) {

$parcel$export(module.exports, "sendExperienceAnalytics", () => $bd135bf39efe6af3$export$4a95ada1b8228562);

var $2vzCR = parcelRequire("2vzCR");

var $9lmTX = parcelRequire("9lmTX");

var $bKxX9 = parcelRequire("bKxX9");

var $6rW04 = parcelRequire("6rW04");

var $3WQZN = parcelRequire("3WQZN");
const $bd135bf39efe6af3$var$isSynthetic = ()=>(0, $6rW04.default)('ajs-is-synthetic') === 'true';
function $bd135bf39efe6af3$export$4a95ada1b8228562(experienceDescription) {
    const additionalContext = {};
    if ((0, $bKxX9.ff)('issue.details.shard-and-region-to-slo-analytics')) {
        const shard = (0, $6rW04.default)('ajs-shard');
        const region = (0, $6rW04.default)('ajs-region');
        Object.assign(additionalContext, {
            shard: shard,
            region: region
        });
    }
    if ((0, $bKxX9.ff)('issue.details.feature-flags-to-slo-analytics')) {
        const enabledFeatureFlags = Object.fromEntries([
            ...(0, $3WQZN.allFeatureFlagsAccessed)
        ].filter(([, value])=>value));
        Object.assign(additionalContext, {
            enabledFeatureFlags: enabledFeatureFlags
        });
    }
    const synthetics = {
        additionalAttributes: {
            synthetic: $bd135bf39efe6af3$var$isSynthetic(),
            ...additionalContext
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(experienceDescription, synthetics);
    (0, $9lmTX.default)(experienceDescription);
}

});




parcelRegister("dvBSb", function(module, exports) {

$parcel$export(module.exports, "issueViewRelayResource", () => $e26b3f39fd0cc4df$export$55131006e6699c0a);
$parcel$export(module.exports, "useIssueViewRelayRouteResource", () => $e26b3f39fd0cc4df$export$252bdba8c8e5f066);

var $1ybV0 = parcelRequire("1ybV0");

var $jBy23 = parcelRequire("jBy23");
var $2mP8r = parcelRequire("2mP8r");

var $buJlM = parcelRequire("buJlM");

var $lW5gg = parcelRequire("lW5gg");

var $3HCkE = parcelRequire("3HCkE");

var $9PXNH = parcelRequire("9PXNH");

var $2skem = parcelRequire("2skem");

const $e26b3f39fd0cc4df$var$getDataLoader = ()=>(parcelRequire("jDleI"));
const $e26b3f39fd0cc4df$var$shouldCaptureTraceIds = ()=>false ? false : (0, $1ybV0.ff)('issue.view-add-traceids-to-issue-view-relay-errors_vm8h2');
const $e26b3f39fd0cc4df$export$5ce473a762cc813e = (0, $3HCkE.createResource)((0, $2skem.withResourceEarlyData)({
    type: 'ISSUE_AGG_DATA',
    getKey: ({ match: match })=>{
        const issueKey = (0, $9PXNH.getIssueKey)(match);
        return issueKey || '';
    },
    getDataLoader: $e26b3f39fd0cc4df$var$getDataLoader,
    maxAge: (0, $2skem.MIN_MAX_AGE),
    isBrowserOnly: true
}));
const $e26b3f39fd0cc4df$export$55131006e6699c0a = (0, $buJlM.createRelayResource)({
    type: 'ISSUE_RELAY_DATA',
    isBrowserOnly: true,
    captureErrors: true,
    captureTraceIds: $e26b3f39fd0cc4df$var$shouldCaptureTraceIds(),
    getQuery: (routerContext, { tenantContext: { cloudId: cloudId } })=>{
        const { match: match } = routerContext;
        const issueKey = (0, $9PXNH.getIssueKey)(match);
        const projectKey = issueKey ? (0, $jBy23.extractProjectKey)(issueKey) : '';
        return {
            parameters: (0, $lW5gg.default),
            variables: {
                cloudId: cloudId,
                issueKey: issueKey || '',
                projectKey: projectKey,
                ...(0, $2mP8r.getMainIssueViewAggQueryFeatureFlagVariables)()
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    }
});
const $e26b3f39fd0cc4df$export$252bdba8c8e5f066 = (options)=>(0, $buJlM.useRelayResource)($e26b3f39fd0cc4df$export$55131006e6699c0a, options);

});
parcelRegister("2mP8r", function(module, exports) {

$parcel$export(module.exports, "getMainIssueViewAggQueryFeatureFlagVariables", () => $ad8d90d6e49d6bf3$export$3dd406718c5846c6);

var $bKxX9 = parcelRequire("bKxX9");

var $cs6Z7 = parcelRequire("cs6Z7");

var $6wu6G = parcelRequire("6wu6G");
const $ad8d90d6e49d6bf3$export$3dd406718c5846c6 = ()=>({
        issueViewRelayCascadingSelectFlag: (0, $bKxX9.ff)('issue.details.relay-cascading-select-field-issue-view-layout-integration'),
        giraAGGMigrationIsArchivedFlag: (0, $cs6Z7.getIsNewValueRequested)((0, $6wu6G.GIRA_AGG_MIGRATION_ISARCHIVED_FLAG)),
        parentInIssueViewFlag: (0, $6wu6G.isParentInIssueViewEnabled)(),
        isCompassComponentsEnabled: (0, $bKxX9.ff)('compass-components-in-jira-components_xw42u', false),
        giraAGGMigrationAttachmentsFlag: (0, $bKxX9.ff)('issue.details.gira-agg-migration-attachments_ecebe'),
        isRelayReleaseVersionFieldIssueViewIntegrationEnabled: (0, $bKxX9.ff)('issue.details.relay-release-version-field-issue-view-integration'),
        issueViewRelayGoalsFlag: (0, $bKxX9.ff)('hrz-716-integrate-goal-picker-into-issue-view', false),
        isCMDBAttributeIdRemoved: (0, $bKxX9.ff)('assets-rearch-deprecate-attribute-value-id_ykukg', false),
        jsmSentimentCustomFieldFlag: (0, $bKxX9.ff)('sentiment-custom-field', false),
        isJPDPanelEnabled: (0, $bKxX9.ff)('polaris.jpd-panel-in-issue-view', false)
    });

});

parcelRegister("lW5gg", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f29749e4a66b033$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bb182e7afa6b53c7cb4a37e1327cd70b>>
 * @relayHash 0052e35cbfb1580b9efb5483189d22df
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 872ed8b624808067a74da03585209a3f18a899ed7f117c065aed543c45c4d484
const $8f29749e4a66b033$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "872ed8b624808067a74da03585209a3f18a899ed7f117c065aed543c45c4d484",
        "metadata": {},
        "name": "mainIssueAggQuery",
        "operationKind": "query",
        "text": null
    }
};
var $8f29749e4a66b033$export$2e2bcd8739ae039 = $8f29749e4a66b033$var$node;

});

parcelRegister("jDleI", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hJsnC');
        const value = parcelRequire('hNY4a');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hJsnC").then(()=>parcelRequire('hNY4a'));
}

});


parcelRegister("aBAel", function(module, exports) {

$parcel$export(module.exports, "fetchFeatureDataResource", () => $a5c0402ab53043be$export$ec991c565cf31550);
$parcel$export(module.exports, "getOfferingCatalogueFeaturesResource", () => $a5c0402ab53043be$export$d08a9fee651d30b2);

var $1ybV0 = parcelRequire("1ybV0");

var $3HCkE = parcelRequire("3HCkE");

var $jwzNs = parcelRequire("jwzNs");


const $a5c0402ab53043be$var$getDataLoader = ()=>(parcelRequire("5JHUB"));
const $a5c0402ab53043be$export$ec991c565cf31550 = (0, $3HCkE.createResource)({
    type: (0, $18238e3ab68c08a3$export$23978b67a6b2068f),
    getKey: ()=>'state',
    getDataLoader: $a5c0402ab53043be$var$getDataLoader,
    maxAge: 1800000
});
const $a5c0402ab53043be$export$d08a9fee651d30b2 = ()=>[
        (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('offeringcataloguefeatures-resource-layer-in-frontend_o5pnu'), $a5c0402ab53043be$export$ec991c565cf31550)
    ];

});
const $18238e3ab68c08a3$export$23978b67a6b2068f = 'RESOURCE_TYPE_OFFERING_CATALOGUE_FEATURES';

parcelRegister("5JHUB", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('ehV6l');
        const value = parcelRequire('ThDek');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("ehV6l").then(()=>parcelRequire('ThDek'));
}

});


parcelRegister("3JUND", function(module, exports) {

$parcel$export(module.exports, "browseIssueRoute", () => $6238162818d2e039$export$2c9c7e50a88e588b);
$parcel$export(module.exports, "browseIssueEmbedRoute", () => $6238162818d2e039$export$240aeec71c480594);

var $exb0h = parcelRequire("exb0h");

var $bmKiO = parcelRequire("bmKiO");
const $6238162818d2e039$export$2c9c7e50a88e588b = {
    group: (0, $exb0h.ROUTE_GROUPS).ISSUE,
    name: (0, $exb0h.ROUTE_NAMES).ISSUE,
    path: '/browse/:issueKey(\\w+-\\d+)(.*)?',
    query: [
        'filter?!=(.*)',
        'jql?!=(.*)'
    ],
    preloadOptions: {
        earlyChunks: [
            'issue-app-early-entry'
        ]
    },
    earlyAssets: (0, $bmKiO.NORMAL_EARLY_ASSET_STRATEGY)
};
const $6238162818d2e039$export$240aeec71c480594 = {
    group: (0, $exb0h.ROUTE_GROUPS).ISSUE,
    name: (0, $exb0h.ROUTE_NAMES).ISSUE_EMBED,
    path: '/browse/:issueKey(\\w+-\\d+)/embed',
    preloadOptions: {
        earlyChunks: [
            'issue-app-early-entry'
        ]
    },
    earlyAssets: (0, $bmKiO.NORMAL_EARLY_ASSET_STRATEGY)
};

});

parcelRegister("c4qEZ", function(module, exports) {

$parcel$export(module.exports, "IssueViewSkeleton", () => $d58942287640a101$export$49addbcdecb6e6ff);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $kB5wN = parcelRequire("kB5wN");

var $8ICxF = parcelRequire("8ICxF");

var $brt18 = parcelRequire("brt18");
const $d58942287640a101$var$fullpageStyles = null;
const $d58942287640a101$var$modalStyles = null;
const $d58942287640a101$var$customSpacingStyles = null;
const $d58942287640a101$export$49addbcdecb6e6ff = ({ isEmbedView: isEmbedView, isModalView: isModalView })=>{
    // same as getIssueContainerMaxWidth
    const customCss = [
        $d58942287640a101$var$customSpacingStyles,
        isEmbedView !== true && isModalView !== true ? $d58942287640a101$var$fullpageStyles : null,
        isModalView === true ? $d58942287640a101$var$modalStyles : null
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kB5wN.CompactModeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($brt18))),
        className: (0, $7JEyt.default)([
            "_p12f1ypn _18s85ogf _t6vdxy5q _hr4jxy5q _11y7uu9g _l82tpxbi _j7o0pxbi",
            isEmbedView !== true && isModalView !== true && "_uwhk1ejb",
            isModalView === true && "_19pk10j7"
        ])
    }));
};

});
parcelRegister("kB5wN", function(module, exports) {

$parcel$export(module.exports, "CompactModeContext", () => $628d22027b8eaf89$export$37eeac5cc5245b18);
$parcel$export(module.exports, "CompactModeProvider", () => $628d22027b8eaf89$export$10cf42790e523b8e);
$parcel$export(module.exports, "CompactModeConsumer", () => $628d22027b8eaf89$export$20feb77b5b617e44);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $6mgGK = parcelRequire("6mgGK");

var $kJlBc = parcelRequire("kJlBc");

var $fruGB = parcelRequire("fruGB");
const $628d22027b8eaf89$export$37eeac5cc5245b18 = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
const { Provider: $628d22027b8eaf89$var$Provider, Consumer: $628d22027b8eaf89$var$Consumer } = $628d22027b8eaf89$export$37eeac5cc5245b18;
const $628d22027b8eaf89$export$55a90a8e865a39b5 = 700;
const $628d22027b8eaf89$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY = `(max-width: ${$628d22027b8eaf89$export$55a90a8e865a39b5}px)`;
/**
 * A utility hook which returns a key based on the route
 */ function $628d22027b8eaf89$var$useRouteKey() {
    const [routeState] = (0, $kJlBc.useRouter)();
    const { match: { path: path, params: params } } = routeState;
    // handle case where JSM doesn't have an issueKey on their route
    const hasIssueKey = params?.issueKey !== undefined;
    return `${path}${hasIssueKey ? '/hasIssueKey' : ''}`;
}
const $628d22027b8eaf89$export$10cf42790e523b8e = ({ children: children })=>{
    const key = $628d22027b8eaf89$var$useRouteKey();
    (0, $fruGB.invalidateCacheIfRouteChanged)(key);
    let defaultState = (0, $fruGB.getCachedIsCompactValue)(key);
    // in case there is no state change triggered
    if (defaultState === undefined) {
        defaultState = (0, $ebe79147dfe00ff9$export$ee15e0cd1efafcb4);
        (0, $fruGB.setCachedIsCompactValue)(defaultState, key);
    }
    const [isCompact, setIsCompact] = (0, $eUqFw.useState)(defaultState);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($628d22027b8eaf89$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6mgGK.ContainerQueryObserver), {
        query: $628d22027b8eaf89$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY,
        onChange: (state)=>{
            (0, $fruGB.setCachedIsCompactValue)(state, key);
            setIsCompact(state);
        },
        defaultState: defaultState
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($628d22027b8eaf89$var$Provider, {
        value: isCompact
    }, children));
};
const $628d22027b8eaf89$export$20feb77b5b617e44 = $628d22027b8eaf89$var$Consumer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $628d22027b8eaf89$var$StyledWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6mgGK", function(module, exports) {

$parcel$export(module.exports, "ContainerQueryObserver", () => $2f0f372a50da62d9$export$e9574287678b8467);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

const $2f0f372a50da62d9$var$QueryContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
let $2f0f372a50da62d9$var$currentIdSeed = 0;
function $2f0f372a50da62d9$var$generateAttributeValue() {
    return `indicator-span-${$2f0f372a50da62d9$var$currentIdSeed++}`;
}
function $2f0f372a50da62d9$export$e9574287678b8467({ children: children, query: query, onChange: onChange, defaultState: defaultState = (0, $ebe79147dfe00ff9$export$ee15e0cd1efafcb4) }) {
    const [active, setActive] = (0, $eUqFw.useState)(defaultState);
    const handleQueryStatusChange = (0, $eUqFw.useCallback)((isContainerQueryActive)=>{
        onChange?.(isContainerQueryActive);
        setActive(isContainerQueryActive);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2f0f372a50da62d9$var$QueryContext.Provider, {
        value: active
    }, !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2f0f372a50da62d9$var$IntersectionIndicator, {
        query: query,
        notifyIntersectionStatusChanged: handleQueryStatusChange
    }), children);
}
function $2f0f372a50da62d9$export$b66a67697973e01() {
    const currentState = (0, $eUqFw.useContext)($2f0f372a50da62d9$var$QueryContext);
    if (currentState === undefined) throw new Error('The component must be wrapped in a ContainerQueryObserver to use useContainerQueryState');
    return currentState;
}
function $2f0f372a50da62d9$var$IntersectionIndicator({ notifyIntersectionStatusChanged: handleChange, query: query }) {
    const attributeValue = (0, $eUqFw.useMemo)(()=>$2f0f372a50da62d9$var$generateAttributeValue(), []);
    const spanRef = (0, $eUqFw.useRef)(null);
    const containerRef = (0, $eUqFw.useRef)(null);
    const currentState = $2f0f372a50da62d9$export$b66a67697973e01();
    (0, $eUqFw.useLayoutEffect)(()=>{
        const queryStatusChangedCallback = (entries)=>{
            // This means that the parent container is either empty or loading, we should not notify of any change in this case.
            if (!containerRef.current || containerRef.current.clientWidth === 0) return;
            if (entries.length > 0) {
                // only ever going to be one entry max
                const isContainerQueryActive = entries[0].isIntersecting;
                if (isContainerQueryActive !== currentState) handleChange(isContainerQueryActive);
            }
        };
        const intersectionObserver = new IntersectionObserver(queryStatusChangedCallback);
        const spanElement = spanRef.current;
        spanElement && intersectionObserver.observe(spanElement);
        return ()=>{
            spanElement && intersectionObserver.unobserve(spanElement);
            intersectionObserver.disconnect();
        };
    }, [
        currentState,
        handleChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2f0f372a50da62d9$var$ContainerToBeQueried, {
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("style", {
        type: "text/css"
    }, `
                    [data-container-query-indicator-id="${attributeValue}"] {
                        display: none;
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100vh; 
                        pointer-events: none;
                    }
                    @container ${query} {
                        [data-container-query-indicator-id="${attributeValue}"] {
                            display: inherit;
                        }
                    }`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        ref: spanRef,
        "data-container-query-indicator-id": attributeValue
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2f0f372a50da62d9$var$ContainerToBeQueried = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqsw1if8 _lcxvglyw _154iidpf _7ccakre2",
            __cmplp.className
        ])
    });
});

});
const $ebe79147dfe00ff9$export$ee15e0cd1efafcb4 = false;


parcelRegister("fruGB", function(module, exports) {

$parcel$export(module.exports, "getCachedIsCompactValue", () => $592157d792cf61e1$export$c47621d55d10906c);
$parcel$export(module.exports, "setCachedIsCompactValue", () => $592157d792cf61e1$export$568b2dd75c2027b4);
$parcel$export(module.exports, "invalidateCacheIfRouteChanged", () => $592157d792cf61e1$export$a81477a3594bcaab);
// Cleared on window refresh, unique to each window
const $592157d792cf61e1$var$cachedIsCompactValues = {};
let $592157d792cf61e1$var$previousRouteKey;
function $592157d792cf61e1$export$c47621d55d10906c(key) {
    return $592157d792cf61e1$var$cachedIsCompactValues[key];
}
function $592157d792cf61e1$export$568b2dd75c2027b4(isCompactValue, key) {
    $592157d792cf61e1$var$cachedIsCompactValues[key] = isCompactValue;
}
function $592157d792cf61e1$export$a81477a3594bcaab(currentRouteKey) {
    // If we navigate away from the route we can't assume that the cached value will stay valid when we come back
    if (currentRouteKey !== $592157d792cf61e1$var$previousRouteKey) {
        $592157d792cf61e1$var$previousRouteKey = currentRouteKey;
        delete $592157d792cf61e1$var$cachedIsCompactValues[$592157d792cf61e1$var$previousRouteKey];
    }
}

});


parcelRegister("brt18", function(module, exports) {
module.exports = new URL("issue-app-skeleton.tpl.31d538db.svg", import.meta.url).toString();

});


parcelRegister("lw0Lc", function(module, exports) {

$parcel$export(module.exports, "sidebarFiltersGlobalResource", () => $956252207e550497$export$7e0b804085f0470d);
// eslint-disable-next-line jira/restricted/@atlassian+jira-relay-utils

var $buJlM = parcelRequire("buJlM");

var $dRbI6 = parcelRequire("dRbI6");

var $lY2yG = parcelRequire("lY2yG");
const $956252207e550497$export$7e0b804085f0470d = (0, $lY2yG.withGiraAggAnonSsrFix)((0, $buJlM.createRelayResource)({
    type: 'NAVIGATION_SIDEBAR_FILTERS_GLOBAL',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $dRbI6.default),
            variables: {
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
}));

});
parcelRegister("dRbI6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d44c58f47ce4dc16$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ec2895c263a0bc866c147eac067ab3d3>>
 * @relayHash 8b92a92d7973bf2a60fc85271761fceb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0fc7dfdbeee4792faa92449e364dd4b9b51f2ed2fc3bd618160e27885c980a88
const $d44c58f47ce4dc16$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v5 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            }
        ],
        "type": "JiraCustomFilter"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "menuNavigationAppsSidebarFiltersGlobalScopeQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "starredFiltersList_navigationAppsSidebarCommon"
                            },
                            {
                                "args": v2 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "systemFilters_navigationAppsSidebarFilters_SystemFiltersSection"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "menuNavigationAppsSidebarFiltersGlobalScopeQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraFilterConnection",
                            "kind": "LinkedField",
                            "name": "favouriteFilters",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraFilterEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isJiraFilter"
                                                },
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "isFavourite",
                                    "value": false
                                }
                            ],
                            "concreteType": "JiraSystemFilterConnection",
                            "kind": "LinkedField",
                            "name": "systemFilters",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSystemFilterEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSystemFilter",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ 
                                                    ],
                                                    "type": "JiraFilter",
                                                    "abstractKey": "__isJiraFilter"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0fc7dfdbeee4792faa92449e364dd4b9b51f2ed2fc3bd618160e27885c980a88",
            "metadata": {},
            "name": "menuNavigationAppsSidebarFiltersGlobalScopeQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d44c58f47ce4dc16$var$node.hash = "b5467e25277d67ce676aa25dd3a16377";
var $d44c58f47ce4dc16$export$2e2bcd8739ae039 = $d44c58f47ce4dc16$var$node;

});

parcelRegister("lY2yG", function(module, exports) {

$parcel$export(module.exports, "withGiraAggAnonSsrFix", () => $db78da6c364437f8$export$f4b29e78f4c0a526);
const $db78da6c364437f8$export$f4b29e78f4c0a526 = (resource)=>{
    if (!resource || !resource.getData) return resource;
    const originalGetData = resource.getData;
    // @ts-expect-error types in the relay resource don't allow null, but the react-resource-router types do
    // eslint-disable-next-line no-param-reassign
    resource.getData = (routerContext, customContext)=>{
        if (false && customContext.tenantContext.isAnonymous) return Promise.resolve(null);
        return originalGetData(routerContext, customContext);
    };
    return resource;
};

});


parcelRegister("62ZdZ", function(module, exports) {

$parcel$export(module.exports, "sidebarProjectIssuesResource", () => $67f901853f9a37f2$export$be31dd7adcfd2297);
// eslint-disable-next-line jira/restricted/@atlassian+jira-relay-utils

var $buJlM = parcelRequire("buJlM");

var $dV4cd = parcelRequire("dV4cd");

var $lY2yG = parcelRequire("lY2yG");
const $67f901853f9a37f2$export$be31dd7adcfd2297 = (0, $lY2yG.withGiraAggAnonSsrFix)((0, $buJlM.createRelayResource)({
    type: 'NAVIGATION_SIDEBAR_STARRED_FILTERS',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $dV4cd.default),
            variables: {
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
}));

});
parcelRegister("dV4cd", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f0180673d49314d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f9654d948e0d21eca1746252fbb0b581>>
 * @relayHash 62d616b47f1dfc22a4c3e97140061306
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1063ffb01e7d9700d29f2ab69b528826f756e1e7c6a83a44336b83304ee1aa8e
const $0f0180673d49314d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "starredFiltersList_navigationAppsSidebarCommon"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraFilterConnection",
                            "kind": "LinkedField",
                            "name": "favouriteFilters",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraFilterEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "filterId"
                                                },
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isJiraFilter"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "jql"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isEditable"
                                                        }
                                                    ],
                                                    "type": "JiraCustomFilter"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1063ffb01e7d9700d29f2ab69b528826f756e1e7c6a83a44336b83304ee1aa8e",
            "metadata": {},
            "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0f0180673d49314d$var$node.hash = "86a313b9769c9a6a731e02bed044f4d2";
var $0f0180673d49314d$export$2e2bcd8739ae039 = $0f0180673d49314d$var$node;

});


parcelRegister("51qRF", function(module, exports) {

$parcel$export(module.exports, "staticSidebarDefaultPINFiltersResource", () => $9a0146f4bac170ac$export$d3efe54a881807bf);
// eslint-disable-next-line jira/restricted/@atlassian/jira-router

var $3HCkE = parcelRequire("3HCkE");

var $9zYls = parcelRequire("9zYls");

var $kOqDJ = parcelRequire("kOqDJ");
const $9a0146f4bac170ac$export$d3efe54a881807bf = (0, $3HCkE.createResource)({
    type: 'JIRA_PROJECT_DEFAULT_PIN_FILTERS_NAV_DATA',
    getKey: ({ match: match, query: query })=>{
        const { projectKey: projectKey } = (0, $9zYls.getProjectKeyId)(match, query);
        return projectKey || 'none';
    },
    getData: async ({ match: match, query: query })=>{
        const { projectKey: projectKey } = (0, $9zYls.getProjectKeyId)(match, query);
        if (projectKey == null) return null;
        return (0, $kOqDJ.fetchDefaultPINFiltersNavData)(projectKey);
    },
    maxAge: 300000
});

});
parcelRegister("kOqDJ", function(module, exports) {

$parcel$export(module.exports, "fetchDefaultPINFiltersNavData", () => $367b2d3283f133ce$export$268c1bcb44a0ddd3);

var $lRmyA = parcelRequire("lRmyA");
const $367b2d3283f133ce$var$extractNavIds = (result)=>new Set((result['com.atlassian.jira.jira-projects-issue-navigator:generic-filters'] || []).map((filterNavItem)=>filterNavItem.id));
const $367b2d3283f133ce$export$268c1bcb44a0ddd3 = async (projectKey)=>{
    if (projectKey == null) throw new Error('invalid project id or key');
    const result = await (0, $lRmyA.performGetRequest)(`/rest/filters/1.0/filters?projectKey=${projectKey}`);
    const filterNavIds = $367b2d3283f133ce$var$extractNavIds(result);
    return {
        hasMyOpenIssues: filterNavIds.has('myopenissues'),
        hasReportedByMe: filterNavIds.has('reportedbyme'),
        hasAllIssues: filterNavIds.has('allissues'),
        hasAllOpenIssues: filterNavIds.has('allopenissues'),
        hasDoneIssues: filterNavIds.has('doneissues'),
        hasViewedRecently: filterNavIds.has('recentlyviewed'),
        hasCreatedRecently: filterNavIds.has('addedrecently'),
        hasResolvedRecently: filterNavIds.has('resolvedrecently'),
        hasUpdatedRecently: filterNavIds.has('updatedrecently')
    };
};

});


parcelRegister("fxlTA", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b0c9af883eccf10$export$2e2bcd8739ae039);
$parcel$export(module.exports, "AsyncSidebarFiltersGlobal", () => $2b0c9af883eccf10$export$1af88ebe65f50e73);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $av9ef = parcelRequire("av9ef");

var $9RvDp = parcelRequire("9RvDp");

// Legacy GIN Sidebar
const $2b0c9af883eccf10$var$LazySidebarFiltersLegacy = (0, $7rh0R.lazyAfterPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("dSPWO")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/filters/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2b0c9af883eccf10$var$AsyncSidebarFiltersLegacy = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "filters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2b0c9af883eccf10$var$LazySidebarFiltersLegacy, null)));
var $2b0c9af883eccf10$export$2e2bcd8739ae039 = $2b0c9af883eccf10$var$AsyncSidebarFiltersLegacy;

// Global-scope NIN sidebar
const $2b0c9af883eccf10$var$LazySidebarFiltersGlobal = (0, $7rh0R.lazyAfterPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    // using direct path instead of `index` because webpack will combine multiple chunks from same file
    return (parcelRequire("dYjYv")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle.SidebarFiltersGlobal;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/filters/src/ui/global-scope/index.tsx"
});
const $2b0c9af883eccf10$export$1af88ebe65f50e73 = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "filters-global"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2b0c9af883eccf10$var$LazySidebarFiltersGlobal, null)));

});
parcelRegister("dSPWO", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('dsiAd'),
            load('2hmUs'),
            load('bCeK4'),
            load('jaWtQ')
        ]);
        const value = parcelRequire('lS5FJ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("dsiAd"),
        load("2hmUs"),
        load("bCeK4"),
        load("jaWtQ")
    ]).then(()=>parcelRequire('lS5FJ'));
}

});

parcelRegister("dYjYv", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('g3Or4')
        ]);
        const value = parcelRequire('j1wPf');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("g3Or4")
    ]).then(()=>parcelRequire('j1wPf'));
}

});


parcelRegister("cINNO", function(module, exports) {

$parcel$export(module.exports, "isNinGlobalScopeEnrolmentEnabledResource", () => $ae6e202da237abde$export$3f6390b4131d761b);

var $3HCkE = parcelRequire("3HCkE");

const $ae6e202da237abde$var$getDataLoader = ()=>(parcelRequire("4boWd"));
const $ae6e202da237abde$export$3f6390b4131d761b = (0, $3HCkE.createResource)({
    type: 'NIN_GLOBAL_SCOPE_ENROLMENT_RESOURCE',
    getKey: ()=>'ninGlobalScopeEnrolment',
    getDataLoader: $ae6e202da237abde$var$getDataLoader
});

});
parcelRegister("4boWd", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hdytc');
        const value = parcelRequire('3AaIE');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hdytc").then(()=>parcelRequire('3AaIE'));
}

});


parcelRegister("cWgoa", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorRelayResource", () => $7120e1887f5518bb$export$b4096f516fb93159);
$parcel$export(module.exports, "issueNavigatorFilterRelayResource", () => $7120e1887f5518bb$export$44ca3a0b25f38d83);
/* eslint-disable jira/import-whitelist */ 
var $iWLL0 = parcelRequire("iWLL0");

var $5as0a = parcelRequire("5as0a");

var $jccNB = parcelRequire("jccNB");

var $huI7r = parcelRequire("huI7r");

var $amu7D = parcelRequire("amu7D");

var $c7ifG = parcelRequire("c7ifG");

var $buJlM = parcelRequire("buJlM");

var $k7wca = parcelRequire("k7wca");

var $1zgpM = parcelRequire("1zgpM");

var $3HCkE = parcelRequire("3HCkE");

var $dX3ro = parcelRequire("dX3ro");

var $cCQm1 = parcelRequire("cCQm1");
const $7120e1887f5518bb$export$b4096f516fb93159 = (0, $3HCkE.createResource)({
    type: `${(0, $buJlM.RELAY_RESOURCE_TYPE)}_${(0, $dX3ro.RESOURCE_TYPE_ISSUE_NAVIGATOR_RELAY)}`,
    getKey: ()=>'issue-navigator-relay',
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
        if (false && tenantContext.isAnonymous) return null;
        const { projectKey: projectKey, issueKey: issueKey, jql: jqlParam, defaultJql: defaultJql, filter: filter } = (0, $cCQm1.getParams)(routerContext);
        const jqlOrFilterId = (0, $cCQm1.getJqlOrFilterId)(defaultJql, jqlParam, filter, projectKey);
        const maxIssuesPerPage = (0, $jccNB.getMaxIssuesPerPage)();
        const variables = {
            cloudId: tenantContext.cloudId,
            first: issueKey == null ? maxIssuesPerPage : null,
            issueSearchInput: jqlOrFilterId,
            namespace: (0, $jccNB.ISSUE_SEARCH_NAMESPACE),
            after: null,
            options: {
                issueKey: issueKey
            },
            fieldSetIds: [],
            shouldQueryFieldSetsById: false,
            filterId: Boolean(filter) && (0, $5as0a.isCustomFilter)(filter) ? filter : null,
            amountOfColumns: (0, $jccNB.MAX_AMOUNT_OF_COLUMNS),
            atlassianIntelligenceProductFeature: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $jccNB.NATURAL_LANGUAGE_TO_JQL)
        };
        const queryReference = (0, $iWLL0.loadQuery)((0, $amu7D.default), (0, $1zgpM.default), variables, {
            fetchPolicy: 'network-only',
            networkCacheConfig: {
                metadata: {
                    META_SLOW_ENDPOINT: true
                }
            }
        });
        if (false && queryReference.id != null) await (0, $c7ifG.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});
const $7120e1887f5518bb$export$44ca3a0b25f38d83 = (0, $3HCkE.createResource)({
    type: `${(0, $buJlM.RELAY_RESOURCE_TYPE)}_${(0, $dX3ro.RESOURCE_TYPE_ISSUE_NAVIGATOR_FILTER_RELAY)}`,
    getKey: ()=>'issue-navigator-filter-relay',
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
        if (false && tenantContext.isAnonymous) return null;
        const { filter: filter } = (0, $cCQm1.getParams)(routerContext);
        const includeFilter = Boolean(filter) && (0, $5as0a.isFilterId)(filter);
        const variables = {
            includeFilter: includeFilter,
            filterAri: includeFilter ? (0, $huI7r.createAri)({
                resourceOwner: 'jira',
                cloudId: tenantContext.cloudId,
                resourceType: 'filter',
                resourceId: filter,
                activationId: tenantContext.activationId
            }) : ''
        };
        const options = {
            fetchPolicy: includeFilter ? 'network-only' : 'store-only'
        };
        const queryReference = (0, $iWLL0.loadQuery)((0, $amu7D.default), (0, $k7wca.default), variables, options);
        if (false && queryReference.id != null) await (0, $c7ifG.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});

});
parcelRegister("5as0a", function(module, exports) {

$parcel$export(module.exports, "isCustomFilter", () => $14b81d6e722f4096$export$31180e7f1db565e5);
$parcel$export(module.exports, "isFilterId", () => $14b81d6e722f4096$export$23be85030bd58047);
const $14b81d6e722f4096$export$31180e7f1db565e5 = (filterId)=>/^\d+$/.test(filterId);
const $14b81d6e722f4096$export$887fa95a5a5cf197 = (filterId)=>/^-\d+$/.test(filterId);
const $14b81d6e722f4096$export$23be85030bd58047 = (value)=>value !== undefined && /^-?\d+$/.test(value);

});

parcelRegister("jccNB", function(module, exports) {

$parcel$export(module.exports, "sortDirections", () => $33b57811e830f7a0$export$73034536b9adc928);
$parcel$export(module.exports, "FilterTypes", () => $33b57811e830f7a0$export$ad2e3f13451a5d44);
$parcel$export(module.exports, "SearchInputTypes", () => $33b57811e830f7a0$export$75a31bc7c097ba4b);
$parcel$export(module.exports, "views", () => $33b57811e830f7a0$export$d0079916fe6800ac);
$parcel$export(module.exports, "defaultOrderFields", () => $33b57811e830f7a0$export$2bd49f8f262d7cbb);
$parcel$export(module.exports, "ISSUE_SEARCH_NAMESPACE", () => $33b57811e830f7a0$export$de2495608df10495);
$parcel$export(module.exports, "DEFAULT_ORDER_FIELD", () => $33b57811e830f7a0$export$393cb330f31d305c);
$parcel$export(module.exports, "DEFAULT_SORT_DIRECTION", () => $33b57811e830f7a0$export$8ea18fa9e35fdf25);
$parcel$export(module.exports, "DEFAULT_VIEW_ID", () => $33b57811e830f7a0$export$500b5c379b5c7f2e);
$parcel$export(module.exports, "MAX_ISSUES_PER_PAGE", () => $33b57811e830f7a0$export$f88f58d1a4b2078b);
$parcel$export(module.exports, "getMaxIssuesPerPage", () => $33b57811e830f7a0$export$8c67ad1f64ab5a9c);
$parcel$export(module.exports, "ANALYTICS_SOURCE", () => $33b57811e830f7a0$export$f7109619a5e9e0d6);
$parcel$export(module.exports, "PACKAGE_NAME", () => $33b57811e830f7a0$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $33b57811e830f7a0$export$d57b6b390e78d90f);
$parcel$export(module.exports, "EXPERIENCE_NAME", () => $33b57811e830f7a0$export$52919046b94109dc);
$parcel$export(module.exports, "ANALYTICS_LIST_VIEW_SOURCE_NAME", () => $33b57811e830f7a0$export$81d9767bc5c1549e);
$parcel$export(module.exports, "ANALYTICS_DETAIL_VIEW_SOURCE_NAME", () => $33b57811e830f7a0$export$524ae4278a57eea2);
$parcel$export(module.exports, "LIST_VIEW_ID", () => $33b57811e830f7a0$export$af225181779390f4);
$parcel$export(module.exports, "MAX_AMOUNT_OF_COLUMNS", () => $33b57811e830f7a0$export$608eeb3a32afef02);
$parcel$export(module.exports, "COLUMN_TYPE_EPIC_LINK", () => $33b57811e830f7a0$export$ce9e2d7c178a9557);
$parcel$export(module.exports, "COLUMN_TYPE_PARENT_LINK", () => $33b57811e830f7a0$export$1adf7afff96bbf16);
$parcel$export(module.exports, "NATURAL_LANGUAGE_TO_JQL", () => $33b57811e830f7a0$export$55628b4c44d1522a);
$parcel$export(module.exports, "supportedOrderFields", () => $33b57811e830f7a0$export$3630aa1c4c69277f);
$parcel$export(module.exports, "getSupportedFieldForAlias", () => $33b57811e830f7a0$export$eaadab3243bf458);

var $1NJeM = parcelRequire("1NJeM");

var $a4IeB = parcelRequire("a4IeB");
const $33b57811e830f7a0$export$73034536b9adc928 = {
    ASC: 'ASC',
    DESC: 'DESC',
    NONE: 'NONE'
};
const $33b57811e830f7a0$export$3f42f49c284d5b58 = {
    TODO: 2,
    COMPLETE: 3,
    IN_PROGRESS: 4
};
const $33b57811e830f7a0$export$ad2e3f13451a5d44 = {
    ID: 'filterId',
    JQL: 'filterJql'
};
const $33b57811e830f7a0$export$75a31bc7c097ba4b = {
    JQL: 'jql',
    FILTER: 'filter',
    FILTER_AND_JQL: 'filterAndJql'
};
const $33b57811e830f7a0$export$d0079916fe6800ac = {
    list: 'list-view',
    detail: 'split-view'
};
const $33b57811e830f7a0$export$2bd49f8f262d7cbb = {
    created: 'created',
    lastviewed: 'lastviewed',
    updated: 'updated'
};
const $33b57811e830f7a0$export$92a576f896a9bf72 = {
    myopenissues: Symbol('myopenissues'),
    reportedbyme: Symbol('reportedbyme'),
    allopenissues: Symbol('allopenissues'),
    doneissues: Symbol('doneissues'),
    recentlyviewed: Symbol('recentlyviewed'),
    resolvedrecently: Symbol('resolvedrecently'),
    updatedrecently: Symbol('updatedrecently'),
    allissues: Symbol('allissues')
};
const $33b57811e830f7a0$export$de2495608df10495 = 'ISSUE_NAVIGATOR';
const $33b57811e830f7a0$export$66816805c55e43b7 = 'jira.issues.preferred.layout.key';
const $33b57811e830f7a0$export$393cb330f31d305c = $33b57811e830f7a0$export$2bd49f8f262d7cbb.created;
const $33b57811e830f7a0$export$8ea18fa9e35fdf25 = $33b57811e830f7a0$export$73034536b9adc928.DESC;
const $33b57811e830f7a0$export$500b5c379b5c7f2e = 'list_default';
const $33b57811e830f7a0$export$f88f58d1a4b2078b = 50;
const $33b57811e830f7a0$export$8c67ad1f64ab5a9c = ()=>$33b57811e830f7a0$export$f88f58d1a4b2078b;
const $33b57811e830f7a0$export$9d7b852b1c962aa3 = 1000;
const $33b57811e830f7a0$export$f7109619a5e9e0d6 = 'issue-navigator-next';
const $33b57811e830f7a0$export$b8b9d90f9e5bd72b = 'jiraIssueNavigator';
const $33b57811e830f7a0$export$d57b6b390e78d90f = 'empanada';
const $33b57811e830f7a0$export$52919046b94109dc = 'showPinIssueList';
const $33b57811e830f7a0$export$81d9767bc5c1549e = 'issueNavigatorListView';
const $33b57811e830f7a0$export$524ae4278a57eea2 = 'issueNavigatorDetailView';
const $33b57811e830f7a0$export$af478702fa9b9a17 = 'user.search.mode';
const $33b57811e830f7a0$export$84f45d3374492a7c = 'BLANK';
const $33b57811e830f7a0$export$e1eb2ddab803c5ec = (0, $1NJeM.SEARCH_MODE_BASIC);
const $33b57811e830f7a0$export$af225181779390f4 = 'list_default';
const $33b57811e830f7a0$export$608eeb3a32afef02 = (0, $a4IeB.MAX_COLUMNS);
const $33b57811e830f7a0$export$ce9e2d7c178a9557 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $33b57811e830f7a0$export$1adf7afff96bbf16 = 'com.atlassian.jpo:jpo-custom-field-parent';
const $33b57811e830f7a0$export$55628b4c44d1522a = 'NATURAL_LANGUAGE_TO_JQL';
const $33b57811e830f7a0$export$3630aa1c4c69277f = {
    created: {
        jqlTerm: 'created',
        fieldType: 'created',
        aliases: []
    },
    key: {
        jqlTerm: 'key',
        fieldType: 'issuekey',
        aliases: [
            'issuekey'
        ]
    },
    lastviewed: {
        jqlTerm: 'lastviewed',
        fieldType: 'lastviewed',
        aliases: []
    },
    priority: {
        jqlTerm: 'priority',
        fieldType: 'priority',
        aliases: []
    },
    resolved: {
        jqlTerm: 'resolved',
        fieldType: 'resolutiondate',
        aliases: []
    },
    status: {
        jqlTerm: 'status',
        fieldType: 'status',
        aliases: []
    },
    updated: {
        jqlTerm: 'updated',
        fieldType: 'updated',
        aliases: []
    },
    issuetype: {
        jqlTerm: 'issuetype',
        fieldType: 'issuetype',
        aliases: [
            'type'
        ]
    },
    assignee: {
        jqlTerm: 'assignee',
        fieldType: 'assignee',
        aliases: []
    },
    duedate: {
        jqlTerm: 'duedate',
        fieldType: 'duedate',
        aliases: []
    },
    reporter: {
        jqlTerm: 'reporter',
        fieldType: 'reporter',
        aliases: []
    },
    summary: {
        jqlTerm: 'summary',
        fieldType: 'summary',
        aliases: []
    }
};
const $33b57811e830f7a0$export$eaadab3243bf458 = (alias)=>Object.keys($33b57811e830f7a0$export$3630aa1c4c69277f).find((key)=>$33b57811e830f7a0$export$3630aa1c4c69277f[key]?.aliases.includes(alias));

});
parcelRegister("1NJeM", function(module, exports) {

$parcel$export(module.exports, "SEARCH_MODE_BASIC", () => $79ecc7e1457ed2bf$export$f963d14b266e4d2e);
$parcel$export(module.exports, "SEARCH_MODE_ADVANCED", () => $79ecc7e1457ed2bf$export$aad1d9eb9b751555);
$parcel$export(module.exports, "SERVER_SEARCH_MODE_BASIC", () => $79ecc7e1457ed2bf$export$87c41a6b3123c00f);
$parcel$export(module.exports, "SERVER_SEARCH_MODE_ADVANCED", () => $79ecc7e1457ed2bf$export$a7a000706ebc3ba8);
$parcel$export(module.exports, "DEFAULT_SEARCH_MODE", () => $79ecc7e1457ed2bf$export$e1eb2ddab803c5ec);
$parcel$export(module.exports, "mapSearchModeToAnalyticAtribute", () => $79ecc7e1457ed2bf$export$70c8f980e4a50682);
$parcel$export(module.exports, "SEARCH_MODE_SWITCHER_LEFT_LOCATION", () => $79ecc7e1457ed2bf$export$4dab29e715a4e6fb);
$parcel$export(module.exports, "SEARCH_MODE_SWITCHER_RIGHT_LOCATION", () => $79ecc7e1457ed2bf$export$59848395da0b4bcb);
$parcel$export(module.exports, "PACKAGE_NAME", () => $79ecc7e1457ed2bf$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $79ecc7e1457ed2bf$export$d57b6b390e78d90f);
const $79ecc7e1457ed2bf$export$f963d14b266e4d2e = 'basic';
const $79ecc7e1457ed2bf$export$aad1d9eb9b751555 = 'advanced';
const $79ecc7e1457ed2bf$export$87c41a6b3123c00f = 'BASIC';
const $79ecc7e1457ed2bf$export$a7a000706ebc3ba8 = 'ADVANCED';
const $79ecc7e1457ed2bf$export$e1eb2ddab803c5ec = $79ecc7e1457ed2bf$export$f963d14b266e4d2e;
const $79ecc7e1457ed2bf$export$70c8f980e4a50682 = {
    [$79ecc7e1457ed2bf$export$f963d14b266e4d2e]: $79ecc7e1457ed2bf$export$f963d14b266e4d2e,
    [$79ecc7e1457ed2bf$export$aad1d9eb9b751555]: 'JQL'
};
const $79ecc7e1457ed2bf$export$4dab29e715a4e6fb = 'Left';
const $79ecc7e1457ed2bf$export$59848395da0b4bcb = 'Right';
const $79ecc7e1457ed2bf$export$b8b9d90f9e5bd72b = 'jiraJqlBuilder';
const $79ecc7e1457ed2bf$export$d57b6b390e78d90f = 'empanada';

});


parcelRegister("k7wca", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd2c7ab8e2e91ec6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1c0dc4a342f4ce5786fbe069292419e8>>
 * @relayHash 4722fbdc72716192181bb0830d738d17
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b9373e4d70177ba3d0d672c65e67a2165b4a0d774802f56dbef66239dd52c8e5
const $dd2c7ab8e2e91ec6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeFilter"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "main_FilterQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_IssueNavigator_filterQuery"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "main_FilterQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "includeFilter",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "filterAri"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isJiraFilter"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isEditable"
                                                }
                                            ],
                                            "type": "JiraCustomFilter"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "filterId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isFavourite"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b9373e4d70177ba3d0d672c65e67a2165b4a0d774802f56dbef66239dd52c8e5",
            "metadata": {},
            "name": "main_FilterQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$dd2c7ab8e2e91ec6$var$node.hash = "181bb07a6bafd05a2033750384a06766";
var $dd2c7ab8e2e91ec6$export$2e2bcd8739ae039 = $dd2c7ab8e2e91ec6$var$node;

});

parcelRegister("1zgpM", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b76afc79df7f5e5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<83c53b7c5ef3aa7e173ed12d9eab4c89>>
 * @relayHash c58456b3cd0eb880f3cbf5c5a16897cc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bcb490e1f1539e7dc1aebceca61c6cb51f4381a25d138013a9e9ef3bb954cceb

var $dbXJb = parcelRequire("dbXJb");

var $alD35 = parcelRequire("alD35");

var $lWCGp = parcelRequire("lWCGp");

var $kpHqV = parcelRequire("kpHqV");

var $fY4Nv = parcelRequire("fY4Nv");
const $5b76afc79df7f5e5$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "atlassianIntelligenceProductFeature"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterId"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "options"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryFieldSetsById"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v14 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v15 = [
        v14 /*: any*/ 
    ], v16 = {
        "kind": "ScalarField",
        "name": "key"
    }, v17 = {
        "kind": "ScalarField",
        "name": "id"
    }, v18 = {
        "kind": "Variable",
        "name": "filterId",
        "variableName": "filterId"
    }, v19 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "amountOfColumns"
    }, v20 = {
        "kind": "Variable",
        "name": "namespace",
        "variableName": "namespace"
    }, v21 = {
        "kind": "Variable",
        "name": "viewId",
        "variableName": "viewId"
    }, v22 = [
        v18 /*: any*/ ,
        v19 /*: any*/ ,
        v20 /*: any*/ ,
        v21 /*: any*/ 
    ], v23 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v24 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v25 = {
        "kind": "ScalarField",
        "name": "name"
    }, v26 = {
        "kind": "ScalarField",
        "name": "text"
    }, v27 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v28 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v29 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v30 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v29 /*: any*/ ,
            v17 /*: any*/ 
        ]
    }, v31 = {
        "kind": "ScalarField",
        "name": "type"
    }, v32 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v33 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isJiraIssueField"
    }, v34 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraAffectedServiceConnection",
                "kind": "LinkedField",
                "name": "selectedAffectedServicesConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraAffectedServiceEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraAffectedService",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "serviceId"
                                    },
                                    v25 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraAffectedServicesField"
    }, v35 = {
        "kind": "ScalarField",
        "name": "message"
    }, v36 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraCmdbObjectConnection",
                "kind": "LinkedField",
                "name": "selectedCmdbObjectsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraCmdbObjectEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraCmdbObject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "objectId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "label"
                                    },
                                    {
                                        "concreteType": "JiraCmdbAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "url48"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": [
                            v35 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "type": "JiraCMDBField"
    }, v37 = [
        v25 /*: any*/ ,
        v17 /*: any*/ 
    ], v38 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraComponentConnection",
                "kind": "LinkedField",
                "name": "selectedComponentsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraComponentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraComponent",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v37 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraComponentsField"
    }, v39 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v40 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "lazyIsEditableInIssueView"
            }
        ]
    }, v41 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "date"
            },
            v25 /*: any*/ ,
            v39 /*: any*/ ,
            v40 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v42 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "dateTime"
            }
        ],
        "type": "JiraDateTimePickerField"
    }, v43 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraEpic",
                "kind": "LinkedField",
                "name": "epic",
                "plural": false,
                "selections": [
                    v16 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "summary"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    },
                    v17 /*: any*/ 
                ]
            }
        ],
        "type": "JiraEpicLinkField"
    }, v44 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "renderedFieldHtml"
            }
        ],
        "type": "JiraFallbackField"
    }, v45 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v25 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "statusId"
                    },
                    v30 /*: any*/ ,
                    v17 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v46 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v47 = [
        v25 /*: any*/ 
    ], v48 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v49 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": v46 /*: any*/ ,
                "concreteType": "JiraLabelConnection",
                "kind": "LinkedField",
                "name": "selectedLabelsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraLabelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v47 /*: any*/ 
                            }
                        ]
                    },
                    v48 /*: any*/ 
                ],
                "storageKey": "selectedLabelsConnection(first:1000)"
            },
            v25 /*: any*/ ,
            v40 /*: any*/ 
        ],
        "type": "JiraLabelsField"
    }, v50 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v28 /*: any*/ ,
                    v25 /*: any*/ ,
                    v17 /*: any*/ 
                ]
            }
        ],
        "type": "JiraIssueTypeField"
    }, v51 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v26 /*: any*/ ,
            v17 /*: any*/ 
        ]
    }, v52 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v53 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "parentIssue",
                "plural": false,
                "selections": [
                    v16 /*: any*/ ,
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcparentfromissueviewrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            v51 /*: any*/ 
                        ]
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcparentfromissueviewrelayprovider",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "ids",
                                        "value": [
                                            "issuetype",
                                            "summary"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fieldsById",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v23 /*: any*/ ,
                                                    v24 /*: any*/ ,
                                                    v50 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v26 /*: any*/ 
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                    },
                                                    v17 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "storageKey": "fieldsById(ids:[\"issuetype\",\"summary\"])"
                            }
                        ]
                    },
                    v17 /*: any*/ 
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcparentfromissueviewrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "parentIssue",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraColorField",
                                "kind": "LinkedField",
                                "name": "issueColorField",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraColor",
                                        "kind": "LinkedField",
                                        "name": "color",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "colorKey"
                                            },
                                            v17 /*: any*/ 
                                        ]
                                    },
                                    v17 /*: any*/ 
                                ]
                            },
                            {
                                "concreteType": "JiraIssueTypeField",
                                "kind": "LinkedField",
                                "name": "issueTypeField",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueType",
                                        "kind": "LinkedField",
                                        "name": "issueType",
                                        "plural": false,
                                        "selections": [
                                            v52 /*: any*/ ,
                                            v25 /*: any*/ ,
                                            v17 /*: any*/ 
                                        ]
                                    },
                                    v17 /*: any*/ 
                                ]
                            },
                            v51 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "type": "JiraParentIssueField"
    }, v54 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraPriority",
                "kind": "LinkedField",
                "name": "priority",
                "plural": false,
                "selections": [
                    v25 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "iconUrl"
                    },
                    v17 /*: any*/ 
                ]
            },
            v25 /*: any*/ ,
            v40 /*: any*/ 
        ],
        "type": "JiraPriorityField"
    }, v55 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    v25 /*: any*/ ,
                    v16 /*: any*/ ,
                    {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "large"
                            }
                        ]
                    },
                    v17 /*: any*/ 
                ]
            }
        ],
        "type": "JiraProjectField"
    }, v56 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraResolution",
                "kind": "LinkedField",
                "name": "resolution",
                "plural": false,
                "selections": v37 /*: any*/ 
            }
        ],
        "type": "JiraResolutionField"
    }, v57 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraSprintConnection",
                "kind": "LinkedField",
                "name": "selectedSprintsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraSprintEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v17 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "sprintId"
                                    },
                                    v25 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "state"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "endDate"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            v25 /*: any*/ ,
            v40 /*: any*/ 
        ],
        "type": "JiraSprintField"
    }, v58 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v59 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v60 = {
        "kind": "InlineFragment",
        "selections": [
            v25 /*: any*/ ,
            {
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "selectedVersionsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraVersionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v37 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraMultipleVersionPickerField"
    }, v61 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraRichText",
                "kind": "LinkedField",
                "name": "richText",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraADF",
                        "kind": "LinkedField",
                        "name": "adfValue",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraAdfToConvertedPlainText",
                                "kind": "LinkedField",
                                "name": "convertedPlainText",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "plainText"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraRichTextField"
    }, v62 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraServiceManagementRequestType",
                "kind": "LinkedField",
                "name": "requestType",
                "plural": false,
                "selections": [
                    v25 /*: any*/ ,
                    v52 /*: any*/ ,
                    v17 /*: any*/ 
                ]
            }
        ],
        "type": "JiraServiceManagementRequestTypeField"
    }, v63 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": v46 /*: any*/ ,
                "concreteType": "JiraIssueLinkConnection",
                "kind": "LinkedField",
                "name": "issueLinkConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                            }
                        ]
                    },
                    {
                        "concreteType": "JiraIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "issue",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "webUrl"
                                            },
                                            v16 /*: any*/ ,
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Literal",
                                                        "name": "ids",
                                                        "value": [
                                                            "statusCategory"
                                                        ]
                                                    }
                                                ],
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldsById",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueFieldEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v23 /*: any*/ ,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v30 /*: any*/ 
                                                                        ],
                                                                        "type": "JiraStatusCategoryField"
                                                                    },
                                                                    v17 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                            },
                                            v17 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "relationName"
                                    },
                                    v17 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "issueLinkConnection(first:1000)"
            }
        ],
        "type": "JiraIssueLinkField"
    }, v64 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v65 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v66 = {
        "kind": "ScalarField",
        "name": "isCurrent"
    }, v67 = {
        "kind": "ScalarField",
        "name": "pageNumber"
    }, v68 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "feature",
                    "variableName": "atlassianIntelligenceProductFeature"
                }
            ],
            "kind": "ObjectValue",
            "name": "atlassianIntelligenceProductFeatureInput"
        },
        v14 /*: any*/ 
    ], v69 = [
        v14 /*: any*/ ,
        v18 /*: any*/ ,
        v20 /*: any*/ ,
        v21 /*: any*/ 
    ], v70 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v71 = [
        {
            "kind": "ScalarField",
            "name": "viewId"
        },
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                        "fieldSetSelectedState": "SELECTED"
                    }
                },
                v19 /*: any*/ 
            ],
            "concreteType": "JiraIssueSearchFieldSetConnection",
            "kind": "LinkedField",
            "name": "fieldSets",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueSearchFieldSetEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraIssueSearchFieldSet",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                v32 /*: any*/ ,
                                v31 /*: any*/ ,
                                v70 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "jqlTerm"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isSortable"
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninresizablecolumnsrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFieldSetPreferences",
                                            "kind": "LinkedField",
                                            "name": "fieldSetPreferences",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "width"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraFieldType",
                                    "kind": "LinkedField",
                                    "name": "fieldType",
                                    "plural": false,
                                    "selections": [
                                        v70 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v48 /*: any*/ ,
                v64 /*: any*/ 
            ]
        },
        v17 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "hasDefaultFieldSets"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "main_IssueNavigatorQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_IssueNavigator_issueQuery"
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v15 /*: any*/ ,
                            "concreteType": "JiraUserPreferences",
                            "kind": "LinkedField",
                            "name": "userPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "main_issueNavigator_IssueNavigator_userPreferences"
                                }
                            ]
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_IssueNavigator_jira"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v8 /*: any*/ ,
                v7 /*: any*/ ,
                v9 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v10 /*: any*/ ,
                v13 /*: any*/ ,
                v11 /*: any*/ ,
                v6 /*: any*/ ,
                v5 /*: any*/ ,
                v12 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissuesearchviewresultrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcstatusinlineeditrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcparentfromissueviewrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninresizablecolumnsrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "main_IssueNavigatorQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "after",
                                    "variableName": "after"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "before",
                                    "variableName": "before"
                                },
                                v14 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "first",
                                    "variableName": "first"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "issueSearchInput",
                                    "variableName": "issueSearchInput"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "last",
                                    "variableName": "last"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "options",
                                    "variableName": "options"
                                }
                            ],
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearchStable",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "issueId"
                                                },
                                                {
                                                    "args": v22 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSetsForIssueSearchView",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v23 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v24 /*: any*/ ,
                                                                                                        v25 /*: any*/ ,
                                                                                                        v26 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v24 /*: any*/ ,
                                                                                                        v25 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "user",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v23 /*: any*/ ,
                                                                                                                v25 /*: any*/ ,
                                                                                                                v27 /*: any*/ ,
                                                                                                                v17 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v24 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v25 /*: any*/ ,
                                                                                                                v28 /*: any*/ ,
                                                                                                                v17 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v24 /*: any*/ ,
                                                                                                        v30 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                },
                                                                                                v17 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "shouldQueryFieldSetsById",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Variable",
                                                                    "name": "fieldSetIds",
                                                                    "variableName": "fieldSetIds"
                                                                },
                                                                v19 /*: any*/ 
                                                            ],
                                                            "concreteType": "JiraIssueFieldSetConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldSetsById",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldSet",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v31 /*: any*/ ,
                                                                                v32 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fields",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v23 /*: any*/ ,
                                                                                                        v24 /*: any*/ ,
                                                                                                        v31 /*: any*/ ,
                                                                                                        v33 /*: any*/ ,
                                                                                                        v17 /*: any*/ ,
                                                                                                        v34 /*: any*/ ,
                                                                                                        v36 /*: any*/ ,
                                                                                                        v38 /*: any*/ ,
                                                                                                        v41 /*: any*/ ,
                                                                                                        v42 /*: any*/ ,
                                                                                                        v43 /*: any*/ ,
                                                                                                        v44 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v26 /*: any*/ ,
                                                                                                                v25 /*: any*/ ,
                                                                                                                v40 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraSingleLineTextField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "statusCategory",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v25 /*: any*/ ,
                                                                                                                        v29 /*: any*/ ,
                                                                                                                        v17 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraStatusCategoryField"
                                                                                                        },
                                                                                                        v45 /*: any*/ ,
                                                                                                        v49 /*: any*/ ,
                                                                                                        v50 /*: any*/ ,
                                                                                                        v53 /*: any*/ ,
                                                                                                        v54 /*: any*/ ,
                                                                                                        v55 /*: any*/ ,
                                                                                                        v56 /*: any*/ ,
                                                                                                        v57 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "user",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v23 /*: any*/ ,
                                                                                                                        v58 /*: any*/ ,
                                                                                                                        v27 /*: any*/ ,
                                                                                                                        v25 /*: any*/ ,
                                                                                                                        v17 /*: any*/ ,
                                                                                                                        v59 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v25 /*: any*/ ,
                                                                                                                v39 /*: any*/ ,
                                                                                                                v40 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                                                        },
                                                                                                        v60 /*: any*/ ,
                                                                                                        v61 /*: any*/ ,
                                                                                                        v62 /*: any*/ ,
                                                                                                        v63 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "shouldQueryFieldSetsById",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "args": v22 /*: any*/ ,
                                                            "concreteType": "JiraIssueFieldSetConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldSetsForIssueSearchView",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldSet",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v31 /*: any*/ ,
                                                                                v32 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fields",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v24 /*: any*/ ,
                                                                                                        v31 /*: any*/ ,
                                                                                                        v33 /*: any*/ ,
                                                                                                        v34 /*: any*/ ,
                                                                                                        v36 /*: any*/ ,
                                                                                                        v38 /*: any*/ ,
                                                                                                        v41 /*: any*/ ,
                                                                                                        v42 /*: any*/ ,
                                                                                                        v43 /*: any*/ ,
                                                                                                        v44 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v40 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraSingleLineTextField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "statusCategory",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v47 /*: any*/ 
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraStatusCategoryField"
                                                                                                        },
                                                                                                        v45 /*: any*/ ,
                                                                                                        v49 /*: any*/ ,
                                                                                                        v53 /*: any*/ ,
                                                                                                        v54 /*: any*/ ,
                                                                                                        v55 /*: any*/ ,
                                                                                                        v56 /*: any*/ ,
                                                                                                        v57 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v31 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "user",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v58 /*: any*/ ,
                                                                                                                        v59 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v39 /*: any*/ ,
                                                                                                                v40 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                                                        },
                                                                                                        v60 /*: any*/ ,
                                                                                                        v61 /*: any*/ ,
                                                                                                        v62 /*: any*/ ,
                                                                                                        v63 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "childIssues",
                                                            "plural": false,
                                                            "selections": [
                                                                v23 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "activeProjectsOnly",
                                                                                    "value": true
                                                                                },
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "first",
                                                                                    "value": 10
                                                                                }
                                                                            ],
                                                                            "concreteType": "JiraIssueConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "issues",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v48 /*: any*/ 
                                                                            ],
                                                                            "storageKey": "issues(activeProjectsOnly:true,first:10)"
                                                                        }
                                                                    ],
                                                                    "type": "JiraChildIssuesWithinLimit"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v23 /*: any*/ ,
                                        v64 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "totalIssueSearchResultCount"
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "maxCursors",
                                            "value": 7
                                        }
                                    ],
                                    "concreteType": "JiraPageCursors",
                                    "kind": "LinkedField",
                                    "name": "pageCursors",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "around",
                                            "plural": true,
                                            "selections": [
                                                v65 /*: any*/ ,
                                                v66 /*: any*/ ,
                                                v67 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "last",
                                            "plural": false,
                                            "selections": [
                                                v67 /*: any*/ ,
                                                v65 /*: any*/ ,
                                                v66 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "first",
                                            "plural": false,
                                            "selections": [
                                                v65 /*: any*/ ,
                                                v67 /*: any*/ ,
                                                v66 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "storageKey": "pageCursors(maxCursors:7)"
                                },
                                {
                                    "concreteType": "JiraIssueNavigatorPageInfo",
                                    "kind": "LinkedField",
                                    "name": "issueNavigatorPageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "firstIssuePosition"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "lastIssuePosition"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "firstIssueKeyFromNextPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "lastIssueKeyFromPreviousPage"
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "issueSearchError",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "messages"
                                                }
                                            ],
                                            "type": "JiraInvalidJqlError"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v35 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "errorType"
                                                }
                                            ],
                                            "type": "JiraInvalidSyntaxError"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isCappingIssueSearchResult"
                                },
                                v64 /*: any*/ 
                            ]
                        },
                        {
                            "args": v15 /*: any*/ ,
                            "concreteType": "JiraUserPreferences",
                            "kind": "LinkedField",
                            "name": "userPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "jqlBuilderSearchMode"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isNaturalLanguageSpotlightTourEnabled"
                                },
                                v64 /*: any*/ 
                            ]
                        },
                        {
                            "args": v68 /*: any*/ ,
                            "kind": "ScalarField",
                            "name": "shouldShowAtlassianIntelligence"
                        },
                        {
                            "args": v68 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "atlassianIntelligenceAction",
                            "plural": false,
                            "selections": [
                                v23 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isAccessible"
                                        }
                                    ],
                                    "type": "JiraAccessAtlassianIntelligenceFeature"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "link"
                                        }
                                    ],
                                    "type": "JiraEnableAtlassianIntelligenceDeepLink"
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissuesearchviewresultrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": v69 /*: any*/ ,
                                    "concreteType": "JiraIssueSearchView",
                                    "kind": "LinkedField",
                                    "name": "issueSearchViewByNamespaceAndViewId",
                                    "plural": false,
                                    "selections": v71 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissuesearchviewresultrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v69 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "issueSearchViewResult",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isJiraIssueSearchViewResult"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v71 /*: any*/ ,
                                            "type": "JiraIssueSearchView"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v35 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        v23 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "statusCode"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "QueryError"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v17 /*: any*/ 
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "bcb490e1f1539e7dc1aebceca61c6cb51f4381a25d138013a9e9ef3bb954cceb",
            "metadata": {},
            "name": "main_IssueNavigatorQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcissuesearchviewresultrelayprovider": (0, $alD35.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider": (0, $dbXJb.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcstatusinlineeditrelayprovider": (0, $fY4Nv.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcparentfromissueviewrelayprovider": (0, $kpHqV.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninresizablecolumnsrelayprovider": (0, $lWCGp.default)
            }
        }
    };
}();
$5b76afc79df7f5e5$var$node.hash = "b8ab28e0b22a890c7a614848d03f9816";
var $5b76afc79df7f5e5$export$2e2bcd8739ae039 = $5b76afc79df7f5e5$var$node;

});
parcelRegister("alD35", function(module, exports) {

$parcel$export(module.exports, "default", () => $854e928d58bfc4fe$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$854e928d58bfc4fe$export$2e2bcd8739ae039 = {
    get () {
        return (0, $1ybV0.ff)('handle-404-filter-errors-gracefully-in-the-ui-by-showing-filter-not-found-view_t3d2m');
    }
};

});

parcelRegister("lWCGp", function(module, exports) {

$parcel$export(module.exports, "default", () => $23174161c15c93a4$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$23174161c15c93a4$export$2e2bcd8739ae039 = {
    get () {
        return (0, $1ybV0.ff)('nin-resizable-columns_8z4eo');
    }
};

});


parcelRegister("dX3ro", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_NAVIGATOR_RELAY", () => $fe8f646394bc81e3$export$c300d3b7f3dc697d);
$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_NAVIGATOR_FILTER_RELAY", () => $fe8f646394bc81e3$export$b99d8b4e19091835);
$parcel$export(module.exports, "defaultOrderFields", () => $fe8f646394bc81e3$export$2bd49f8f262d7cbb);
$parcel$export(module.exports, "sortDirections", () => $fe8f646394bc81e3$export$73034536b9adc928);
const $fe8f646394bc81e3$export$c300d3b7f3dc697d = 'ISSUE_NAVIGATOR_RELAY';
const $fe8f646394bc81e3$export$b99d8b4e19091835 = 'ISSUE_NAVIGATOR_FILTER_RELAY';
const $fe8f646394bc81e3$export$2bd49f8f262d7cbb = {
    created: 'created',
    lastviewed: 'lastviewed',
    updated: 'updated'
};
const $fe8f646394bc81e3$export$73034536b9adc928 = {
    ASC: 'ASC',
    DESC: 'DESC',
    NONE: 'NONE'
};

});

parcelRegister("cCQm1", function(module, exports) {

$parcel$export(module.exports, "getDefaultJqlGin", () => $a09739cd165c6ebd$export$8780b1523384f42d);
$parcel$export(module.exports, "getParams", () => $a09739cd165c6ebd$export$ec161d740909e39d);
$parcel$export(module.exports, "getJqlOrFilterId", () => $a09739cd165c6ebd$export$b968a035fc2aa57b);
/* eslint-disable jira/import-whitelist */ 
var $5as0a = parcelRequire("5as0a");

var $6vrw7 = parcelRequire("6vrw7");

var $f6ie2 = parcelRequire("f6ie2");

var $dX3ro = parcelRequire("dX3ro");
const $a09739cd165c6ebd$export$8780b1523384f42d = ()=>`ORDER BY ${(0, $dX3ro.defaultOrderFields).created} ${(0, $dX3ro.sortDirections).DESC}`;
const $a09739cd165c6ebd$export$ec161d740909e39d = ({ match: { params: params }, query: query })=>{
    const { projectKey: projectKey, issueKey: issueKey } = params;
    const { filter: filter, jql: jql } = query;
    // Default JQL when no relevant query parameter is set
    const defaultJql = projectKey !== null && projectKey !== undefined ? (0, $f6ie2.getDefaultJql)((0, $6vrw7.toProjectKey)(projectKey)) : $a09739cd165c6ebd$export$8780b1523384f42d();
    return {
        page: 1,
        jql: jql,
        issueKey: issueKey,
        projectKey: projectKey,
        filter: filter,
        defaultJql: defaultJql
    };
};
const $a09739cd165c6ebd$export$b968a035fc2aa57b = (defaultJql, jqlParam, filter, projectKey)=>{
    // If JQL param has been defined (even if it's empty) we should use it
    if (typeof jqlParam === 'string') return {
        jql: jqlParam
    };
    // If filter is non-empty then use the filter parameter
    if (typeof filter === 'string' && filter !== '') {
        if ((0, $5as0a.isFilterId)(filter)) return {
            filterId: filter
        };
        const filterJql = projectKey !== null && projectKey !== undefined ? (0, $f6ie2.mapFilterToJql)(projectKey, filter) : undefined;
        if (filterJql !== undefined) return {
            jql: filterJql
        };
    }
    // Fallback to the default JQL if neither JQL or valid filter parameters have been provided.
    return {
        jql: defaultJql
    };
};

});
parcelRegister("f6ie2", function(module, exports) {

$parcel$export(module.exports, "isFilterKey", () => $2a14197d875c29d0$export$2cad587bb603edda);
$parcel$export(module.exports, "mapFilterToJql", () => $2a14197d875c29d0$export$1d71dda738f608f);
$parcel$export(module.exports, "getDefaultJql", () => $2a14197d875c29d0$export$346d50fe8350b1d0);
$parcel$export(module.exports, "getUrlPrefix", () => $2a14197d875c29d0$export$821d4141d135e0d0);

var $53ciZ = parcelRequire("53ciZ");

var $jccNB = parcelRequire("jccNB");

var $fci12 = parcelRequire("fci12");
const $2a14197d875c29d0$export$2cad587bb603edda = (filter)=>typeof filter === 'string' && filter in (0, $fci12.Filters);
const $2a14197d875c29d0$export$1d71dda738f608f = (projectKey, filter)=>{
    if (!$2a14197d875c29d0$export$2cad587bb603edda(filter)) return undefined;
    const clauses = [
        `project = "${projectKey}"`
    ];
    let order = (0, $jccNB.DEFAULT_ORDER_FIELD);
    const direction = (0, $jccNB.DEFAULT_SORT_DIRECTION);
    switch((0, $fci12.Filters)[filter]){
        case (0, $fci12.Filters).myopenissues:
            clauses.push('assignee IN (currentUser())');
            clauses.push(`statusCategory IN (${(0, $fci12.StatusCategoryValues).TO_DO}, ${(0, $fci12.StatusCategoryValues).IN_PROGRESS})`);
            break;
        case (0, $fci12.Filters).reportedbyme:
            clauses.push('reporter IN (currentUser())');
            break;
        case (0, $fci12.Filters).allopenissues:
            clauses.push(`statusCategory IN (${(0, $fci12.StatusCategoryValues).TO_DO}, ${(0, $fci12.StatusCategoryValues).IN_PROGRESS})`);
            order = (0, $jccNB.defaultOrderFields).updated;
            break;
        case (0, $fci12.Filters).doneissues:
            clauses.push(`statusCategory = ${(0, $fci12.StatusCategoryValues).DONE}`);
            break;
        case (0, $fci12.Filters).recentlyviewed:
            order = (0, $jccNB.defaultOrderFields).lastviewed;
            break;
        case (0, $fci12.Filters).resolvedrecently:
            clauses.push('resolved >= -1w');
            order = (0, $jccNB.defaultOrderFields).updated;
            break;
        case (0, $fci12.Filters).updatedrecently:
            order = (0, $jccNB.defaultOrderFields).updated;
            break;
        case (0, $fci12.Filters).allissues:
            order = (0, $jccNB.defaultOrderFields).created;
            break;
        default:
    }
    return `${clauses.join(' AND ')} ORDER BY ${order} ${direction}`.trim();
};
const $2a14197d875c29d0$export$346d50fe8350b1d0 = (projectKey)=>`project = "${projectKey}" ORDER BY ${0, $jccNB.DEFAULT_ORDER_FIELD} ${0, $jccNB.DEFAULT_SORT_DIRECTION}`;
const $2a14197d875c29d0$export$e5b4f9d05e643346 = (search, match)=>({
        ...(0, $53ciZ.parse)(search),
        ...match && match.params
    });
const $2a14197d875c29d0$export$821d4141d135e0d0 = (url)=>{
    const match = url.match(/^(.*)\/projects.*$/);
    return (match && match[1]) ?? '';
};

});
parcelRegister("fci12", function(module, exports) {

$parcel$export(module.exports, "Filters", () => $c4e7918aa985330a$export$92a576f896a9bf72);
$parcel$export(module.exports, "StatusCategoryValues", () => $c4e7918aa985330a$export$72d6e2acce8f36fd);
const $c4e7918aa985330a$export$92a576f896a9bf72 = {
    myopenissues: Symbol('myopenissues'),
    reportedbyme: Symbol('reportedbyme'),
    allopenissues: Symbol('allopenissues'),
    doneissues: Symbol('doneissues'),
    recentlyviewed: Symbol('recentlyviewed'),
    resolvedrecently: Symbol('resolvedrecently'),
    updatedrecently: Symbol('updatedrecently'),
    allissues: Symbol('allissues')
};
const $c4e7918aa985330a$export$72d6e2acce8f36fd = {
    TO_DO: '"To Do"',
    DONE: '"Done"',
    IN_PROGRESS: '"In Progress"'
};

});




parcelRegister("1tmBn", function(module, exports) {

$parcel$export(module.exports, "projectIssueNavigatorRoute", () => $cc4d4072d8ba1cc4$export$126b16ec65343bf);
$parcel$export(module.exports, "softwareIssueNavigatorRoute", () => $cc4d4072d8ba1cc4$export$ccfb6c4a189316bc);
$parcel$export(module.exports, "projectIssueNavigatorClassicRoute", () => $cc4d4072d8ba1cc4$export$fa71d22b1c44463b);
$parcel$export(module.exports, "servicedeskIssuesRoute", () => $cc4d4072d8ba1cc4$export$4be84a96ac761ab0);
$parcel$export(module.exports, "projectIssueNavigatorCoreRoute", () => $cc4d4072d8ba1cc4$export$e961cccd2405cdd0);
$parcel$export(module.exports, "globalIssueNavigatorRoute", () => $cc4d4072d8ba1cc4$export$f4c8e8bc55cd2008);
$parcel$export(module.exports, "globalIssueNavigator1Route", () => $cc4d4072d8ba1cc4$export$2dfbbe89ed354013);
$parcel$export(module.exports, "globalIssueNavigatorBrowseIssueRedirectRoute", () => $cc4d4072d8ba1cc4$export$34695dccebecc6bc);

var $exb0h = parcelRequire("exb0h");
const $cc4d4072d8ba1cc4$export$126b16ec65343bf = {
    group: (0, $exb0h.ROUTE_GROUPS).ISSUE_NAVIGATOR,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_ISSUE_NAVIGATOR,
    path: '/projects/:projectKey/issues/:issueKey?'
};
const $cc4d4072d8ba1cc4$export$ccfb6c4a189316bc = {
    group: (0, $exb0h.ROUTE_GROUPS).ISSUE_NAVIGATOR,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_ISSUE_NAVIGATOR,
    path: '/jira/software/projects/:projectKey/issues/:issueKey?'
};
const $cc4d4072d8ba1cc4$export$fa71d22b1c44463b = {
    group: (0, $exb0h.ROUTE_GROUPS).ISSUE_NAVIGATOR,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_ISSUE_NAVIGATOR_CLASSIC,
    path: '/jira/software/c/projects/:projectKey/issues/:issueKey?'
};
const $cc4d4072d8ba1cc4$export$4be84a96ac761ab0 = {
    group: (0, $exb0h.ROUTE_GROUPS).ISSUE_NAVIGATOR,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_ISSUES,
    path: '/jira/servicedesk/projects/:projectKey/issues/:issueKey?'
};
const $cc4d4072d8ba1cc4$export$e961cccd2405cdd0 = {
    group: (0, $exb0h.ROUTE_GROUPS).ISSUE_NAVIGATOR,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_ISSUE_NAVIGATOR_CORE,
    path: '/jira/core/projects/:projectKey/issues/:issueKey?'
};
const $cc4d4072d8ba1cc4$export$f4c8e8bc55cd2008 = {
    group: (0, $exb0h.ROUTE_GROUPS).ISSUE_NAVIGATOR,
    name: (0, $exb0h.ROUTE_NAMES).GLOBAL_ISSUE_NAVIGATOR,
    path: '/issues/:issueKey?'
};
const $cc4d4072d8ba1cc4$export$2dfbbe89ed354013 = {
    group: (0, $exb0h.ROUTE_GROUPS).ISSUE_NAVIGATOR,
    name: (0, $exb0h.ROUTE_NAMES).GLOBAL_ISSUE_NAVIGATOR,
    path: '/jira/issues/:issueKey?'
};
const $cc4d4072d8ba1cc4$export$34695dccebecc6bc = {
    group: (0, $exb0h.ROUTE_GROUPS).ISSUE_NAVIGATOR,
    name: (0, $exb0h.ROUTE_NAMES).GLOBAL_ISSUE_NAVIGATOR_BROWSE_ISSUE_REDIRECT,
    path: '/browse/:issueKey?',
    query: [
        'jql|filter'
    ]
};

});

parcelRegister("kKpAY", function(module, exports) {

$parcel$export(module.exports, "GlobalIssueNavigatorSkeleton", () => $c110d4f59d91f08b$export$51681996374b2585);
/* global-app.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");

var $cIoqn = parcelRequire("cIoqn");
const $c110d4f59d91f08b$var$customCssStyles = null;
const $c110d4f59d91f08b$export$51681996374b2585 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cIoqn))),
        className: (0, $7JEyt.default)([
            "_2zz1zwfg _slt8zwfg _1od57vkz"
        ])
    });

});
parcelRegister("cIoqn", function(module, exports) {
module.exports = new URL("global-issue-navigator-skeleton.tpl.b1bf4b99.svg", import.meta.url).toString();

});


parcelRegister("iPtkN", function(module, exports) {

$parcel$export(module.exports, "ProjectIssueNavigatorSkeleton", () => $a457d53ab258e792$export$112138f5f732a994);
/* project-app.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");

var $esL3v = parcelRequire("esL3v");
const $a457d53ab258e792$var$customCssStyles = null;
const $a457d53ab258e792$export$112138f5f732a994 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($esL3v))),
        className: (0, $7JEyt.default)([
            "_2zz1zwfg _slt8zwfg _1od57vkz"
        ])
    });

});
parcelRegister("esL3v", function(module, exports) {
module.exports = new URL("project-issue-navigator-skeleton.tpl.2a1718d8.svg", import.meta.url).toString();

});


parcelRegister("eMdFV", function(module, exports) {

$parcel$export(module.exports, "useGlobalScopeOptOutFlow", () => $316ead5ad3eb0883$export$f39dd0211cb78bcf);
$parcel$export(module.exports, "useGlobalScopeEnrolmentEnable", () => $316ead5ad3eb0883$export$f45d1a4e873cac44);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $k8Qyf = parcelRequire("k8Qyf");

var $1h6H8 = parcelRequire("1h6H8");
var $4D6hU = parcelRequire("4D6hU");

var $3HCkE = parcelRequire("3HCkE");

var $cINNO = parcelRequire("cINNO");

var $78d1w = parcelRequire("78d1w");

var $6yplV = parcelRequire("6yplV");

var $4ngas = parcelRequire("4ngas");

var $jsA3E = parcelRequire("jsA3E");
const $316ead5ad3eb0883$export$f39dd0211cb78bcf = (href)=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    const redirectToGin = (0, $eUqFw.useCallback)(()=>{
        if (href) window.location.assign(href);
        else window.location.reload();
    }, [
        href
    ]);
    const { renderFeedbackDialog: renderFeedbackDialog } = (0, $4ngas.default)({
        onClose: redirectToGin,
        isAdminSettingsModal: false
    });
    /**
	 * globalScopeOptOut
	 * Triggers the NIN Global Scope opt-out process, including all UI orchestration of feedback.
	 *
	 * The caller should handle "default" behaviour for when the user is already not enrolled,
	 * unless the `preventDefault` callback has been called. This allows for easy usage with links,
	 * where the onClick event's `preventDefault` can be passed.
	 *
	 * If using an event's `preventDefault`, remember to bind the event!
	 * ex: `globalScopeOptOut(event.preventDefault.bind(event));`
	 *
	 * @param {Function} preventDefault
	 */ return (0, $eUqFw.useCallback)(async (preventDefault)=>{
        // If the user has already opt-out, just allow the caller to handle the click
        if (!(0, $1ybV0.ff)('nin.global-scope_aqec8') || !(0, $1h6H8.getIsGlobalScopeEnrolmentEnabledFromLocalStorage)()) return;
        // Otherwise, take over the interaction
        preventDefault && preventDefault();
        try {
            // Update user preference and local storage
            !isAnonymous && await (0, $4D6hU.setIsGlobalScopeEnrolmentEnabledUserPreference)(false);
            (0, $1h6H8.setIsGlobalScopeEnrolmentEnabledInLocalStorage)(false);
            renderFeedbackDialog();
            sessionStorage.setItem('showGinOptOutFlag', 'true');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            showFlag({
                type: 'error',
                title: (0, $jsA3E.default).errorOptOutTitle,
                description: (0, $jsA3E.default).errorOptOutDesc,
                testId: 'issue-navigator-action-meatball-menu.ui.error-flag'
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'optOutOfNin',
                    packageName: 'jiraIssueNavigatorChangeboarding',
                    teamName: 'empanada'
                },
                sendToPrivacyUnsafeSplunk: true,
                error: error
            });
        }
    }, [
        isAnonymous,
        renderFeedbackDialog,
        showFlag
    ]);
};
const $316ead5ad3eb0883$export$f45d1a4e873cac44 = ()=>{
    // We store localStorageData as state so that it's not recalculated during subsequent renders. We want that as a
    // guarantee, not just as a performance optimisation, so we're using useState rather than useMemo.
    //
    // The reason we want to guarantee it's only fetched during the initial render is that we want
    // isNinGlobalScopeEnrolmentEnabled to be stable if there's localStorageData. This can prevent a bug where fetch
    // true from localStorage, we render NIN, the resource returns false, we update local storage to false, and then
    // GinRedirect is rendered again by a parent component and localStorage now returns false and we redirect later
    // than we should.
    const [localStorageData] = (0, $eUqFw.useState)((0, $1h6H8.getIsGlobalScopeEnrolmentEnabledFromLocalStorage));
    const { data: resourceData } = (0, $3HCkE.useResource)((0, $cINNO.isNinGlobalScopeEnrolmentEnabledResource));
    const [{ isInitialRender: isInitialRender }] = (0, $78d1w.useSpaStateTransition)();
    // We assume NIN global scope is enabled if this is an initial render, otherwise we rely on localStorageData if it
    // exists, otherwise we use resourceData. resourceData is async, and can block for a long time, so we optimise for
    // speed rather than correctness by trusting localStorageData.
    let isNinGlobalScopeEnrolmentEnabled;
    if (isInitialRender) isNinGlobalScopeEnrolmentEnabled = true;
    else if (localStorageData !== null && localStorageData !== undefined) isNinGlobalScopeEnrolmentEnabled = localStorageData;
    else isNinGlobalScopeEnrolmentEnabled = resourceData;
    return [
        isNinGlobalScopeEnrolmentEnabled,
        resourceData
    ];
};

});
parcelRegister("1h6H8", function(module, exports) {

$parcel$export(module.exports, "getIsGlobalScopeEnrolmentEnabledFromLocalStorage", () => $c81bcd3cd8865351$export$55632339cd4dae9c);
$parcel$export(module.exports, "getIsGlobalScopeForcedOptOutGinFlagDisabledLocalStorage", () => $c81bcd3cd8865351$export$7b78bfe0a111cecf);
$parcel$export(module.exports, "setIsGlobalScopeEnrolmentEnabledInLocalStorage", () => $c81bcd3cd8865351$export$82b2633cf7498c5e);
$parcel$export(module.exports, "setGlobalScopeForcedOptOutGinFlagEnabledInLocalStorage", () => $c81bcd3cd8865351$export$458eda2352a1e223);

var $aZaPn = parcelRequire("aZaPn");

var $gUUjF = parcelRequire("gUUjF");
const $c81bcd3cd8865351$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY = 'jira.nin.global.scope.enrolment';
const $c81bcd3cd8865351$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY = 'jira.user.nin.global.scope.enrolment.flag.disabled';
const $c81bcd3cd8865351$var$ninGlobalScopeEnrolmentLocalStorage = (0, $aZaPn.createLocalStorageProvider)('nin-changeboarding');
const $c81bcd3cd8865351$export$34434fbbe40a8047 = ()=>$c81bcd3cd8865351$var$ninGlobalScopeEnrolmentLocalStorage.remove($c81bcd3cd8865351$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY);
const $c81bcd3cd8865351$export$55632339cd4dae9c = ()=>$c81bcd3cd8865351$var$ninGlobalScopeEnrolmentLocalStorage.get($c81bcd3cd8865351$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY);
const $c81bcd3cd8865351$export$7b78bfe0a111cecf = ()=>$c81bcd3cd8865351$var$ninGlobalScopeEnrolmentLocalStorage.get($c81bcd3cd8865351$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY);
const $c81bcd3cd8865351$export$82b2633cf7498c5e = (isNINEnrolmentEnabled)=>{
    // In practice this is very unlikely to fail, as our local storage library checks that local storage is working
    // during initialisation. However in order to be robust we will catch any errors and recover by simply deleting the
    // existing local storage value (it's just a cache, so deleting it and delegating to the server will work fine)
    try {
        $c81bcd3cd8865351$var$ninGlobalScopeEnrolmentLocalStorage.set($c81bcd3cd8865351$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY, isNINEnrolmentEnabled);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $gUUjF.default).safeWarnWithoutCustomerData('nin.global.scope.enrolment', 'Failed to set local storage value, removing instead');
        $c81bcd3cd8865351$export$34434fbbe40a8047();
    }
};
const $c81bcd3cd8865351$export$458eda2352a1e223 = ()=>{
    try {
        $c81bcd3cd8865351$var$ninGlobalScopeEnrolmentLocalStorage.set($c81bcd3cd8865351$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY, false);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $gUUjF.default).safeWarnWithoutCustomerData('nin.global.scope.enrolment', 'Failed to set local storage flag value');
    }
};

});

parcelRegister("4D6hU", function(module, exports) {

$parcel$export(module.exports, "setIsGlobalScopeEnrolmentEnabledUserPreference", () => $569980ae425bc2f7$export$2fc59b10f256dbee);
$parcel$export(module.exports, "resetGlobalScopeForcedOptOutGinFlag", () => $569980ae425bc2f7$export$89f09c81b642e3c7);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $569980ae425bc2f7$var$SET_GLOBAL_SCOPE_USER_PREFERENCE_MUTATION = `
    mutation SetGlobalScopeUserPreferenceMutation($input: SetMyPreferenceInput!) {
        setMyPreference(input: $input) {
            success
        }
    }
`;
const $569980ae425bc2f7$var$setGlobalScopeUserPreference = async (input)=>{
    const result = await (0, $lRmyA.performPostRequest)('/rest/gira/1/', {
        body: JSON.stringify({
            query: $569980ae425bc2f7$var$SET_GLOBAL_SCOPE_USER_PREFERENCE_MUTATION,
            variables: {
                input: input
            }
        })
    });
    if (result.data.setMyPreference.success !== true) throw new Error(`Error setting user preference: ${input.key}`, {
        cause: result.errors?.[0]
    });
};
const $569980ae425bc2f7$export$2fc59b10f256dbee = async (value)=>$569980ae425bc2f7$var$setGlobalScopeUserPreference({
        key: 'jira.user.nin.global.scope.enrolment',
        value: value ? 'nin' : 'gin'
    });
const $569980ae425bc2f7$export$89f09c81b642e3c7 = async ()=>$569980ae425bc2f7$var$setGlobalScopeUserPreference({
        key: 'jira.user.nin.global.scope.enrolment.flag.disabled',
        value: false
    }).catch((error)=>(0, $guiFP.default)({
            meta: {
                id: 'resetGlobalScopeGinFlag',
                packageName: 'jiraIssueNavigatorGlobalScopeEnrolment',
                teamName: 'empanada'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        }));

});

parcelRegister("4ngas", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7ca921dab456dbd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");

var $1c02D = parcelRequire("1c02D");
var $irg9D = parcelRequire("irg9D");

var $5JgJ2 = parcelRequire("5JgJ2");

var $10fdS = parcelRequire("10fdS");

var $9Anw5 = parcelRequire("9Anw5");

var $SEaoU = parcelRequire("SEaoU");

var $gd0Sp = parcelRequire("gd0Sp");

var $iXLwW = parcelRequire("iXLwW");
const $b7ca921dab456dbd$export$3fe286306fb8ddfb = 'global-scope-issue-navigator-opt-out';
const $b7ca921dab456dbd$var$unknownAttributeValue = 'unknown';
const $b7ca921dab456dbd$export$b028e515f8f652e0 = ({ isSiteAdmin: isSiteAdmin, routeName: routeName, routeGroup: routeGroup, projectType: projectType, isProjectSimplified: isProjectSimplified, cloudId: cloudId })=>[
        {
            id: (0, $1c02D.EntryKeys).LOCATION,
            value: (0, $9Anw5.default)(window.location.href)
        },
        {
            id: (0, $1c02D.EntryKeys).REFERER,
            value: document.referrer ? (0, $9Anw5.default)(document.referrer) : ''
        },
        {
            id: (0, $1c02D.EntryKeys).USER_AGENT,
            value: navigator.userAgent
        },
        {
            id: (0, $1c02D.EntryKeys).SCREEN_RESOLUTION,
            value: `${window.screen.width} x ${window.screen.height}`
        },
        {
            id: (0, $1c02D.EntryKeys).ROUTE_NAME,
            value: routeName
        },
        {
            id: (0, $1c02D.EntryKeys).ROUTE_GROUP,
            value: routeGroup
        },
        {
            id: (0, $1c02D.EntryKeys).IS_SIMPLIFIED_PROJECT,
            value: isProjectSimplified.toString()
        },
        {
            id: (0, $1c02D.EntryKeys).IS_ADMIN,
            value: isSiteAdmin.toString()
        },
        {
            id: (0, $1c02D.EntryKeys).PROJECT_TYPE,
            value: projectType
        },
        {
            id: 'cloud-id',
            value: cloudId
        },
        {
            id: 'spreadsheet-redesign',
            value: (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf').toString()
        }
    ];
const $b7ca921dab456dbd$export$3a73a4e2115ebf73 = ({ isAdminSettingsModal: isAdminSettingsModal = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const titleDetails = isAdminSettingsModal ? formatMessage((0, $iXLwW.default).titleDetailsAdmin) : formatMessage((0, $iXLwW.default).titleDetailsUser);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $b7ca921dab456dbd$var$feedbackTitleDetailsContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, titleDetails));
};
const $b7ca921dab456dbd$var$useFeedbackDialog = ({ isAdminSettingsModal: isAdminSettingsModal = false, onClose: onClose = ()=>undefined })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $irg9D.useFeedbackCollectorActions)();
    const route = (0, $10fdS.useCurrentRoute)();
    const [{ data: projectData }] = (0, $SEaoU.useContainerContext)();
    const { cloudId: cloudId, isSiteAdmin: isSiteAdmin } = (0, $gd0Sp.useTenantContext)();
    const routeGroup = route.group ?? $b7ca921dab456dbd$var$unknownAttributeValue;
    const routeName = route.name ?? $b7ca921dab456dbd$var$unknownAttributeValue;
    let projectType = $b7ca921dab456dbd$var$unknownAttributeValue;
    let isProjectSimplified = false;
    if (projectData && 'project' in projectData && projectData.project) {
        projectType = projectData.project.type;
        isProjectSimplified = projectData.project.isSimplified;
    }
    const renderFeedbackDialog = (0, $eUqFw.useCallback)(()=>{
        openFeedbackCollector({
            feedbackGroupId: $b7ca921dab456dbd$export$3fe286306fb8ddfb,
            entrypointId: (0, $1c02D.ENTRYPOINT_ID_JIRA_ISSUE_NAVIGATOR),
            onClose: onClose,
            feedbackContext: $b7ca921dab456dbd$export$b028e515f8f652e0({
                isSiteAdmin: isSiteAdmin,
                cloudId: cloudId,
                routeGroup: routeGroup,
                routeName: routeName,
                projectType: projectType,
                isProjectSimplified: isProjectSimplified
            }),
            feedbackTitle: formatMessage((0, $iXLwW.default).title),
            feedbackTitleDetails: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7ca921dab456dbd$export$3a73a4e2115ebf73, {
                isAdminSettingsModal: isAdminSettingsModal
            }),
            selectLabel: formatMessage((0, $iXLwW.default).reasonTitle),
            // Intentional whitespace to clear the placeholder
            // (eluding feedback dialog's empty check for this prop, which includes empty string)
            summaryPlaceholder: ' ',
            submitButtonLabel: formatMessage((0, $iXLwW.default).submitCaption),
            cancelButtonLabel: formatMessage((0, $iXLwW.default).cancelCaption),
            feedbackGroupLabels: {
                empty: {
                    selectOptionLabel: formatMessage((0, $iXLwW.default).reasonPlaceholder)
                },
                bug: {
                    fieldLabel: formatMessage((0, $iXLwW.default).reasonQuestion),
                    selectOptionLabel: formatMessage((0, $iXLwW.default).reasonBug)
                },
                comment: {
                    fieldLabel: formatMessage((0, $iXLwW.default).reasonQuestion),
                    selectOptionLabel: formatMessage((0, $iXLwW.default).reasonSpeed)
                },
                suggestion: {
                    fieldLabel: formatMessage((0, $iXLwW.default).reasonQuestion),
                    selectOptionLabel: formatMessage((0, $iXLwW.default).reasonOthers)
                },
                question: {
                    fieldLabel: formatMessage((0, $iXLwW.default).reasonQuestion),
                    selectOptionLabel: formatMessage((0, $iXLwW.default).reasonParity)
                }
            }
        });
    }, [
        openFeedbackCollector,
        onClose,
        isSiteAdmin,
        cloudId,
        routeGroup,
        routeName,
        projectType,
        isProjectSimplified,
        formatMessage,
        isAdminSettingsModal
    ]);
    return {
        renderFeedbackDialog: renderFeedbackDialog
    };
};
var $b7ca921dab456dbd$export$2e2bcd8739ae039 = $b7ca921dab456dbd$var$useFeedbackDialog;
const $b7ca921dab456dbd$var$feedbackTitleDetailsContainerStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.050'
});

});
parcelRegister("1c02D", function(module, exports) {

$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PLATFORM", () => $ccbba0a7f0f3304b$export$baea5c8192e79adc);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT", () => $ccbba0a7f0f3304b$export$4eda1e3a4a311d13);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PRODUCT_DISCOVERY", () => $ccbba0a7f0f3304b$export$5fb38521eb7ad63c);
$parcel$export(module.exports, "ENTRYPOINT_ID_THEME_JSM_INSIGHT_CMDB", () => $ccbba0a7f0f3304b$export$345c45dd28f28a32);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_COMMAND_PALETTE", () => $ccbba0a7f0f3304b$export$8962f2e618411469);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_VIEW", () => $ccbba0a7f0f3304b$export$7d7f2319141db3c5);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_NAVIGATOR", () => $ccbba0a7f0f3304b$export$4725635e6fe1907a);
$parcel$export(module.exports, "ENTRY_POINT_ID_GENERATIVE_AI", () => $ccbba0a7f0f3304b$export$3a50f2efd6cfd6f3);
$parcel$export(module.exports, "ENTRY_POINT_ID_COMPASS", () => $ccbba0a7f0f3304b$export$b4de0744c1fd450d);
$parcel$export(module.exports, "ENTRY_POINT_ID_JSM_ASSETS_REPORTING", () => $ccbba0a7f0f3304b$export$1a7c42187130faf9);
$parcel$export(module.exports, "ENTRY_POINT_ID_JSM_VIRTUAL_AGENT", () => $ccbba0a7f0f3304b$export$e84c34a7e1dbcf78);
$parcel$export(module.exports, "EntryKeys", () => $ccbba0a7f0f3304b$export$12d01b6c311a909a);
// Jira platform project feedback JSD widget configuration
// https://customerfeedback.atlassian.net/jira/servicedesk/projects/JGF/queues/custom/448
const $ccbba0a7f0f3304b$export$baea5c8192e79adc = '1ff0a150-1d4f-4225-8e7b-3577fb9d9764';
const $ccbba0a7f0f3304b$export$4eda1e3a4a311d13 = 'f60db8bd-1904-4af4-a0ef-f140598ebada';
const $ccbba0a7f0f3304b$export$5fb38521eb7ad63c = '3508b77a-0aa1-4ad5-a397-621bd308c828';
const $ccbba0a7f0f3304b$export$4a288e389131b3de = 'b6176efc-e703-426b-b4f8-3e43ce4aa0db';
const $ccbba0a7f0f3304b$export$345c45dd28f28a32 = 'cdb5199a-4c4e-4692-b006-4e2628ed4771';
const $ccbba0a7f0f3304b$export$8962f2e618411469 = '3d204590-d14a-419f-a042-f0b1a92e005b';
const $ccbba0a7f0f3304b$export$7d7f2319141db3c5 = 'af9ace2f-61a9-45ac-8e67-b54f74246b94';
const $ccbba0a7f0f3304b$export$4725635e6fe1907a = 'cd375e0e-ae56-4a2f-bad8-6114c617bf2f';
const $ccbba0a7f0f3304b$export$3a50f2efd6cfd6f3 = '73cf1eae-42a3-418a-a7ac-976ba0b5735d';
const $ccbba0a7f0f3304b$export$b4de0744c1fd450d = 'e6321572-aa72-47b3-b261-e142b81ad4b2';
const $ccbba0a7f0f3304b$export$1a7c42187130faf9 = 'b4ac51f3-c235-4f9e-97d0-d450e76aa13a';
const $ccbba0a7f0f3304b$export$e84c34a7e1dbcf78 = '1b1c9a31-ebef-44b4-9eaa-4ee884672259';
const $ccbba0a7f0f3304b$export$12d01b6c311a909a = Object.freeze({
    CLOUD_ID: 'cloud-id',
    OPT_OUT: 'Opt-out',
    REASON: 'reason',
    FEELING: 'feeling',
    IS_ADMIN: 'is-admin',
    IS_SITE_ADMIN: 'is-site-admin',
    IS_PROJECT_SETTINGS: 'is-project-settings',
    INLINE_FEEDBACK_ID: 'inlineFeedbackId',
    IS_JSD_EVALUATOR: 'is-jsd-evaluator',
    IS_SIMPLIFIED_PROJECT: 'is-simplified-project',
    SUPPORTED_PROJECT_TYPES: 'supported-project-types',
    FEEDBACK_COLLECTOR_LOCATION: 'feedback-collector-location',
    FEEDBACK_COLLECTOR_ID: 'feedback-collector-id',
    FEEDBACK_EMBEDDABLE_KEY: 'feedback-embeddable-key',
    LOCATION: 'Location',
    PROJECT_TYPE: 'project-type',
    BOARD_TYPE: 'board-type',
    REFERER: 'Referer',
    ROUTE_GROUP: 'route-group',
    ROUTE_NAME: 'route-name',
    USER_AGENT: 'User-Agent',
    SCREEN_RESOLUTION: 'Screen Resolution',
    SOURCE: 'Source',
    SUB_PRODUCT: 'Sub-product',
    JSM_REQUEST_TYPE_CHANGE_WORKFLOW: 'jsm-request-type-change-workflow',
    JSD_REQUEST_TYPE_REDESIGN: 'jsd-request-type-redesign',
    DEPLOYMENT_PROVIDERS: 'deployment-providers',
    JSM_QUEUES_SIDE_BAR: 'jsm-queue-side-bar',
    VERSION_CONTROL_PROVIDERS: 'version-control-providers',
    DEV_DETAILS_DIALOG_TAB: 'dev-details-dialog-tab',
    CODE_IN_JIRA_PROVIDERS: 'code-in-jira-providers',
    SECURITY_IN_JIRA_PROVIDERS: 'security-in-jira-providers',
    INCIDENTS_IN_JIRA_PROVIDERS: 'incidents-in-jira-providers',
    IS_ATLASKIT_FEEDBACK_COMPONENT: 'is-atlaskit-feedback-component',
    FEEDBACK_GROUP_ID: 'feedback-group-id',
    EDITION: 'edition',
    ENV: 'environment'
});

});

parcelRegister("irg9D", function(module, exports) {

$parcel$export(module.exports, "useFeedbackCollector", () => $8d3d8a971c5329dd$export$4be696be8a3bff13);
$parcel$export(module.exports, "useFeedbackCollectorActions", () => $8d3d8a971c5329dd$export$dfb2ee2d9e73fa48);
$parcel$export(module.exports, "FeedbackActionsSubscriber", () => $8d3d8a971c5329dd$export$c35dbf16ebe9df04);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");
const $8d3d8a971c5329dd$export$d4c72bab9d6cc13a = {
    isFeedbackCollectorOpen: false,
    entrypointId: undefined,
    email: undefined,
    additionalFields: undefined,
    feedbackTitle: undefined,
    feedbackContext: undefined,
    feedbackCollectorId: undefined,
    // default value of this prop is true so making sure inititally it is true
    showTypeField: true,
    submitButtonLabel: undefined,
    canBeContactedLabel: undefined,
    summaryPlaceholder: undefined,
    feedbackGroupLabels: undefined,
    onClose: undefined,
    feedbackTitleDetails: undefined,
    triggerRef: undefined,
    renderCustomContent: undefined
};
const $8d3d8a971c5329dd$export$e324594224ef24da = {
    openFeedbackCollector: (feedbackCollectorProps)=>({ setState: setState, dispatch: dispatch })=>{
            // Reset to initial state to clear any leftover state
            dispatch($8d3d8a971c5329dd$export$e324594224ef24da.resetFeedbackCollectorState());
            setState({
                ...feedbackCollectorProps,
                isFeedbackCollectorOpen: true
            });
        },
    closeFeedbackCollector: ()=>({ getState: getState, setState: setState })=>{
            const { triggerRef: triggerRef } = getState();
            if (triggerRef) // Unfortunately we need a setTimeout here to delay the execution cycle because modal is yet to be closed
            setTimeout(()=>triggerRef.current?.focus(), 50);
            setState({
                isFeedbackCollectorOpen: false,
                triggerRef: undefined
            });
        },
    resetFeedbackCollectorState: ()=>({ setState: setState })=>{
            setState({
                ...$8d3d8a971c5329dd$export$d4c72bab9d6cc13a
            });
        },
    updateCustomRenderComponent: (updatedCustomRenderContent)=>({ setState: setState })=>{
            setState({
                renderCustomContent: updatedCustomRenderContent
            });
        },
    updateAdditionalFields: (updatedAdditionalFields)=>({ setState: setState })=>{
            setState({
                additionalFields: updatedAdditionalFields
            });
        }
};
const $8d3d8a971c5329dd$var$Store = (0, $a61MH.createStore)({
    name: 'feedback-collector',
    initialState: $8d3d8a971c5329dd$export$d4c72bab9d6cc13a,
    actions: $8d3d8a971c5329dd$export$e324594224ef24da
});
const $8d3d8a971c5329dd$export$4be696be8a3bff13 = (0, $ggKAj.createHook)($8d3d8a971c5329dd$var$Store);
const $8d3d8a971c5329dd$export$dfb2ee2d9e73fa48 = (0, $ggKAj.createActionsHook)($8d3d8a971c5329dd$var$Store);
const $8d3d8a971c5329dd$export$c35dbf16ebe9df04 = (0, $dYfll.createSubscriber)($8d3d8a971c5329dd$var$Store, {
    selector: null
});

});

parcelRegister("iXLwW", function(module, exports) {

$parcel$export(module.exports, "default", () => $05b46a68a4098ad8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $05b46a68a4098ad8$var$messages = (0, $90IgZ.defineMessages)({
    title: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.title",
        "defaultMessage": "Let us know why you're moving"
    },
    titleDetailsAdmin: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.title-details-admin",
        "defaultMessage": "You and your users will be able to use the old issue search temporarily."
    },
    titleDetailsUser: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.title-details-user",
        "defaultMessage": "You'll be able to use the old issue search temporarily."
    },
    submitCaption: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.submit-caption",
        "defaultMessage": "Send feedback"
    },
    cancelCaption: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.cancel-caption",
        "defaultMessage": "Skip"
    },
    reasonTitle: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-title",
        "defaultMessage": "What is your reason to go back to the old issue search?"
    },
    reasonPlaceholder: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-placeholder",
        "defaultMessage": "Select an option"
    },
    reasonParity: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-parity",
        "defaultMessage": "Features are missing"
    },
    reasonSpeed: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-speed",
        "defaultMessage": "It's slow"
    },
    reasonBug: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-bug",
        "defaultMessage": "There's a bug"
    },
    reasonOthers: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-others",
        "defaultMessage": "Others"
    },
    reasonQuestion: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-question",
        "defaultMessage": "Can you provide more details? It'll help make search better for everyone."
    }
});
var $05b46a68a4098ad8$export$2e2bcd8739ae039 = $05b46a68a4098ad8$var$messages;

});


parcelRegister("jsA3E", function(module, exports) {

$parcel$export(module.exports, "default", () => $88e8eca017b28da3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $88e8eca017b28da3$var$messages = (0, $90IgZ.defineMessages)({
    errorOptOutTitle: {
        "id": "issue-navigator-changeboarding.controllers.global-scope-enrolment-flow.error-opt-out-title",
        "defaultMessage": "We couldn't switch to the old issue search"
    },
    errorOptOutDesc: {
        "id": "issue-navigator-changeboarding.controllers.global-scope-enrolment-flow.error-opt-out-desc",
        "defaultMessage": "Refresh and try again."
    }
});
var $88e8eca017b28da3$export$2e2bcd8739ae039 = $88e8eca017b28da3$var$messages;

});


parcelRegister("a1hH7", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('5gExw')
        ]);
        const value = parcelRequire('abz2K');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("5gExw")
    ]).then(()=>parcelRequire('abz2K'));
}

});

parcelRegister("ai4sb", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('ffMHq')
        ]);
        const value = parcelRequire('alfJ7');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("ffMHq")
    ]).then(()=>parcelRequire('alfJ7'));
}

});

parcelRegister("7QB2o", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('3MGwA')
        ]);
        const value = parcelRequire('bHUYl');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("3MGwA")
    ]).then(()=>parcelRequire('bHUYl'));
}

});

parcelRegister("7z3So", function(module, exports) {

$parcel$export(module.exports, "jiraHomePageRightSidePanelResource", () => $2036c20e2fee6b44$export$9cba342d9ec5384d);
// eslint-disable-next-line jira/restricted/@atlassian+jira-relay-utils

var $buJlM = parcelRequire("buJlM");

var $2rkVF = parcelRequire("2rkVF");

var $bKT2R = parcelRequire("bKT2R");
const $2036c20e2fee6b44$var$isBroadcastWidgetEnabled = ()=>false;
const $2036c20e2fee6b44$export$9cba342d9ec5384d = (0, $buJlM.createRelayResource)({
    type: (0, $bKT2R.JIRA_HOME_PAGE_RIGHT_SIDE_PANEL),
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $2rkVF.default),
            variables: {
                cloudId: tenantContext.cloudId,
                broadcastWidgetEnabled: $2036c20e2fee6b44$var$isBroadcastWidgetEnabled()
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("2rkVF", function(module, exports) {

$parcel$export(module.exports, "default", () => $71560e2826585aec$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3d73a7099a9295c02951eb57579b7d93>>
 * @relayHash a7e48eaea1f1087c0622f1648327271d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d1e74aae483d14f57577f9505f3c4efaab555f7aa6ddfb379804496ec3f405f1
const $71560e2826585aec$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "broadcastWidgetEnabled"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "main_rightSidePanel_RootQuery",
            "selections": [
                {
                    "condition": "broadcastWidgetEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "main_homeBroadcastWidget_Widget"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "main_rightSidePanel_RootQuery",
            "selections": [
                {
                    "condition": "broadcastWidgetEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "cloudId",
                                            "variableName": "cloudId"
                                        }
                                    ],
                                    "concreteType": "JiraUserBroadcastMessageConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraUserBroadcastMessages",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraUserBroadcastMessageEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraUserBroadcastMessage",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "shouldDisplay"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d1e74aae483d14f57577f9505f3c4efaab555f7aa6ddfb379804496ec3f405f1",
            "metadata": {},
            "name": "main_rightSidePanel_RootQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$71560e2826585aec$var$node.hash = "174d1e9e3edb60b5684e0806b3d7342e";
var $71560e2826585aec$export$2e2bcd8739ae039 = $71560e2826585aec$var$node;

});

parcelRegister("bKT2R", function(module, exports) {

$parcel$export(module.exports, "RIGHT_PANEL_WIDTH", () => $824b6e53dd9ad3a1$export$750459958906793);
$parcel$export(module.exports, "RIGHT_SIDE_PANEL_EXPERIENCE", () => $824b6e53dd9ad3a1$export$2eb41e47cfa429b7);
$parcel$export(module.exports, "JIRA_HOME_PAGE_RIGHT_SIDE_PANEL", () => $824b6e53dd9ad3a1$export$6c783d91630ece21);
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles

var $c9TLT = parcelRequire("c9TLT");
const $824b6e53dd9ad3a1$export$750459958906793 = (0, $c9TLT.gridSize) * 49;
const $824b6e53dd9ad3a1$export$2eb41e47cfa429b7 = {
    experience: 'jiraHomeRightSidePanel',
    experienceId: undefined,
    analyticsSource: 'jira-home'
};
const $824b6e53dd9ad3a1$export$6c783d91630ece21 = 'JIRA_HOME_PAGE_RIGHT_SIDE_PANEL';

});


parcelRegister("2BbQD", function(module, exports) {

$parcel$export(module.exports, "jiraHomeResourceWithCache", () => $d13e94b7c51e7401$export$1da15dc2d924240c);

var $3HCkE = parcelRequire("3HCkE");


const $d13e94b7c51e7401$export$1da15dc2d924240c = (0, $3HCkE.createResource)({
    type: (0, $2165c8924c400a29$export$e79da7e0d9d1c1f2),
    getKey: ()=>'jira-home',
    getDataLoader: ()=>(parcelRequire("iZwJN")),
    maxAge: Infinity
});

});
const $2165c8924c400a29$export$e79da7e0d9d1c1f2 = 'JIRA_HOME';

parcelRegister("iZwJN", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('a3H0T')
        ]);
        const value = parcelRequire('jYBS9');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("a3H0T")
    ]).then(()=>parcelRequire('jYBS9'));
}

});


parcelRegister("3yBpr", function(module, exports) {

$parcel$export(module.exports, "YourWorkSkeleton", () => $c10a5f28a6c5fd8d$export$62cf62fa23284b71);
$parcel$export(module.exports, "YourWorkItemListSkeleton", () => $c10a5f28a6c5fd8d$export$31cebe1052db844);

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");

var $9gncO = parcelRequire("9gncO");

var $96i9c = parcelRequire("96i9c");
const $c10a5f28a6c5fd8d$export$62cf62fa23284b71 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9gncO)))
    });
const $c10a5f28a6c5fd8d$export$31cebe1052db844 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($96i9c))),
        containerStyles: {
            maxHeight: '30em'
        }
    });

});
parcelRegister("9gncO", function(module, exports) {
module.exports = new URL("your-work-app-skeleton.tpl.14d150b5.svg", import.meta.url).toString();

});

parcelRegister("96i9c", function(module, exports) {
module.exports = new URL("your-work-itemlist-skeleton.tpl.e9027f83.svg", import.meta.url).toString();

});


parcelRegister("6GquE", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('fIsGv')
        ]);
        const value = parcelRequire('786QV');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("fIsGv")
    ]).then(()=>parcelRequire('786QV'));
}

});

parcelRegister("g8fhn", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('7ROUp');
        const value = parcelRequire('gqQSP');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("7ROUp").then(()=>parcelRequire('gqQSP'));
}

});

parcelRegister("6ighq", function(module, exports) {

$parcel$export(module.exports, "findAppsRoute", () => $756f1f926c86d910$export$e264ef643451c60a);
$parcel$export(module.exports, "appRequestRoute", () => $756f1f926c86d910$export$e5429b8cad3b4991);
$parcel$export(module.exports, "promotionsRoute", () => $756f1f926c86d910$export$45df65bfacbf9a2a);

var $exb0h = parcelRequire("exb0h");
const $756f1f926c86d910$export$e264ef643451c60a = {
    group: (0, $exb0h.ROUTE_GROUPS).MARKETPLACE,
    name: (0, $exb0h.ROUTE_NAMES).MARKETPLACE_INDEX,
    path: '/jira/marketplace'
};
const $756f1f926c86d910$export$e5429b8cad3b4991 = {
    group: (0, $exb0h.ROUTE_GROUPS).MARKETPLACE,
    name: (0, $exb0h.ROUTE_NAMES).MARKETPLACE_APP_REQUESTS,
    path: '/jira/marketplace/manage/app-requests'
};
const $756f1f926c86d910$export$45df65bfacbf9a2a = {
    group: (0, $exb0h.ROUTE_GROUPS).MARKETPLACE,
    name: (0, $exb0h.ROUTE_NAMES).MARKETPLACE_PROMOTIONS,
    path: '/jira/marketplace/manage/promotions'
};

});

parcelRegister("1zqfj", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('eNmuD'),
            load('hPzOn'),
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('aS29e')
        ]);
        const value = parcelRequire('2D4FF');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("eNmuD"),
        load("hPzOn"),
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("aS29e")
    ]).then(()=>parcelRequire('2D4FF'));
}

});

parcelRegister("bc7vB", function(module, exports) {

$parcel$export(module.exports, "backlogRelayResource", () => $2b408255f969730a$export$ad514b81f9e160d0);
$parcel$export(module.exports, "conditionalBacklogRelayResource", () => $2b408255f969730a$export$4a013be7938fa775);

var $1ybV0 = parcelRequire("1ybV0");

var $huI7r = parcelRequire("huI7r");

var $buJlM = parcelRequire("buJlM");

var $3mjFf = parcelRequire("3mjFf");

var $jwzNs = parcelRequire("jwzNs");

const $2b408255f969730a$export$ad514b81f9e160d0 = (0, $jwzNs.browserOnlyResourceWithCondition)(()=>false, (0, $buJlM.createRelayResource)({
    type: (0, $52b7f081c10f9d47$export$463905a04a9a75ce),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $3mjFf.default),
            variables: {
                boardId: (0, $huI7r.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                }),
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        }),
    captureErrors: true
}));
const $2b408255f969730a$export$4a013be7938fa775 = (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('jsw.perf.critical-backlog-with-relay'), $2b408255f969730a$export$ad514b81f9e160d0);

});
parcelRegister("3mjFf", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d41a02f4836bc39$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<af1752aeeac5a38b86a8d5cf173d18fb>>
 * @relayHash 010bb7cdad917d68ac7773a1dcb4ec01
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f0265750b202c0ceda593f31130e4808462f54c3702123d91fff9c415016144e
const $6d41a02f4836bc39$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "state",
            "value": [
                "ACTIVE",
                "FUTURE"
            ]
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "kind": "ScalarField",
        "name": "goal"
    }, v6 = {
        "kind": "ScalarField",
        "name": "startDate"
    }, v7 = {
        "kind": "ScalarField",
        "name": "endDate"
    }, v8 = {
        "kind": "ScalarField",
        "name": "daysRemaining"
    }, v9 = {
        "kind": "ScalarField",
        "name": "key"
    }, v10 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v11 = {
        "kind": "ScalarField",
        "name": "labels"
    }, v12 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v13 = {
        "kind": "ScalarField",
        "name": "category"
    }, v14 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v15 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v16 = {
        "kind": "ScalarField",
        "name": "flagged"
    }, v17 = {
        "kind": "ScalarField",
        "name": "done"
    }, v18 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v19 = {
        "kind": "ScalarField",
        "name": "storyPoints"
    }, v20 = {
        "kind": "ScalarField",
        "name": "value"
    }, v21 = {
        "kind": "ScalarField",
        "name": "valueAsText"
    }, v22 = {
        "kind": "ScalarField",
        "name": "dueDate"
    }, v23 = {
        "kind": "ScalarField",
        "name": "complete"
    }, v24 = {
        "kind": "ScalarField",
        "name": "total"
    }, v25 = {
        "kind": "ScalarField",
        "name": "fixVersionsIds"
    }, v26 = {
        "kind": "ScalarField",
        "name": "sprintState"
    }, v27 = {
        "kind": "ScalarField",
        "name": "boardIssueListKey"
    }, v28 = {
        "kind": "ScalarField",
        "name": "requestColumnMigration"
    }, v29 = {
        "kind": "ScalarField",
        "name": "rankCustomFieldId"
    }, v30 = {
        "kind": "ScalarField",
        "name": "color"
    }, v31 = {
        "kind": "ScalarField",
        "name": "permissions"
    }, v32 = {
        "kind": "ScalarField",
        "name": "hierarchyLevelType"
    }, v33 = {
        "kind": "ScalarField",
        "name": "hasRequiredFields"
    }, v34 = {
        "kind": "ScalarField",
        "name": "status"
    }, v35 = {
        "concreteType": "CurrentEstimation",
        "kind": "LinkedField",
        "name": "current",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "customFieldId"
            }
        ]
    }, v36 = {
        "kind": "ScalarField",
        "name": "statisticFieldId"
    }, v37 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v38 = {
        "kind": "ScalarField",
        "name": "defaultUnit"
    }, v39 = {
        "kind": "ScalarField",
        "name": "workingDaysPerWeek"
    }, v40 = {
        "kind": "ScalarField",
        "name": "workingHoursPerDay"
    }, v41 = {
        "kind": "ScalarField",
        "name": "defaultFormat"
    }, v42 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        v12 /*: any*/ 
    ], v43 = {
        "concreteType": "SoftwareCard",
        "kind": "LinkedField",
        "name": "cards",
        "plural": true,
        "selections": [
            v3 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            v11 /*: any*/ ,
            {
                "concreteType": "CardType",
                "kind": "LinkedField",
                "name": "type",
                "plural": false,
                "selections": v42 /*: any*/ 
            },
            {
                "concreteType": "CardStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v3 /*: any*/ ,
                    v4 /*: any*/ ,
                    v13 /*: any*/ 
                ]
            },
            {
                "kind": "LinkedField",
                "name": "assignee",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    },
                    v14 /*: any*/ ,
                    v4 /*: any*/ ,
                    v15 /*: any*/ ,
                    v3 /*: any*/ 
                ]
            },
            v16 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            {
                "concreteType": "Estimate",
                "kind": "LinkedField",
                "name": "estimate",
                "plural": false,
                "selections": [
                    v19 /*: any*/ ,
                    {
                        "concreteType": "OriginalEstimate",
                        "kind": "LinkedField",
                        "name": "originalEstimate",
                        "plural": false,
                        "selections": [
                            v20 /*: any*/ ,
                            v21 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "concreteType": "CardPriority",
                "kind": "LinkedField",
                "name": "priority",
                "plural": false,
                "selections": [
                    v4 /*: any*/ ,
                    v12 /*: any*/ 
                ]
            },
            v22 /*: any*/ ,
            {
                "concreteType": "ChildCardsMetadata",
                "kind": "LinkedField",
                "name": "childCardsMetadata",
                "plural": false,
                "selections": [
                    v23 /*: any*/ ,
                    v24 /*: any*/ 
                ]
            },
            v25 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "aggBacklogDataQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "Sprint",
                                    "kind": "LinkedField",
                                    "name": "sprints",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v3 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.sprints.id"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v4 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.sprints.name"
                                        },
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        {
                                            "concreteType": "SoftwareCard",
                                            "kind": "LinkedField",
                                            "name": "cards",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v3 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.sprints.cards.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v9 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.sprints.cards.key"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v10 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.sprints.cards.summary"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v11 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.sprints.cards.labels"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "CardType",
                                                        "kind": "LinkedField",
                                                        "name": "type",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v3 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.sprints.cards.type.id"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v4 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.sprints.cards.type.name"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v12 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.sprints.cards.type.iconUrl"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "boardScope.sprints.cards.type"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "CardStatus",
                                                        "kind": "LinkedField",
                                                        "name": "status",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v3 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.sprints.cards.status.id"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v4 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.sprints.cards.status.name"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v13 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.sprints.cards.status.category"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "boardScope.sprints.cards.status"
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "assignee",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v14 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "boardScope.sprints.cards.assignee.accountId"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v4 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "boardScope.sprints.cards.assignee.name"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v15 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "boardScope.sprints.cards.assignee.picture"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v16 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.sprints.cards.flagged"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v17 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.sprints.cards.done"
                                                },
                                                v18 /*: any*/ ,
                                                {
                                                    "concreteType": "Estimate",
                                                    "kind": "LinkedField",
                                                    "name": "estimate",
                                                    "plural": false,
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        {
                                                            "concreteType": "OriginalEstimate",
                                                            "kind": "LinkedField",
                                                            "name": "originalEstimate",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v20 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.sprints.cards.estimate.originalEstimate.value"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v21 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.sprints.cards.estimate.originalEstimate.valueAsText"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "CardPriority",
                                                    "kind": "LinkedField",
                                                    "name": "priority",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v4 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "boardScope.sprints.cards.priority.name"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v12 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "boardScope.sprints.cards.priority.iconUrl"
                                                        }
                                                    ]
                                                },
                                                v22 /*: any*/ ,
                                                {
                                                    "concreteType": "ChildCardsMetadata",
                                                    "kind": "LinkedField",
                                                    "name": "childCardsMetadata",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v23 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "boardScope.sprints.cards.childCardsMetadata.complete"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v24 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "boardScope.sprints.cards.childCardsMetadata.total"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v25 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.sprints.cards.fixVersionsIds"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v26 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.sprints.sprintState"
                                        }
                                    ],
                                    "storageKey": "sprints(state:[\"ACTIVE\",\"FUTURE\"])"
                                },
                                "action": "THROW",
                                "path": "boardScope.sprints"
                            },
                            {
                                "concreteType": "Backlog",
                                "kind": "LinkedField",
                                "name": "backlog",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": v27 /*: any*/ ,
                                        "action": "THROW",
                                        "path": "boardScope.backlog.boardIssueListKey"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": v28 /*: any*/ ,
                                        "action": "THROW",
                                        "path": "boardScope.backlog.requestColumnMigration"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "SoftwareCard",
                                            "kind": "LinkedField",
                                            "name": "cards",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v3 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.backlog.cards.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v9 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.backlog.cards.key"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v10 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.backlog.cards.summary"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v11 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.backlog.cards.labels"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "CardType",
                                                        "kind": "LinkedField",
                                                        "name": "type",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v3 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.backlog.cards.type.id"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v4 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.backlog.cards.type.name"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v12 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.backlog.cards.type.iconUrl"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "boardScope.backlog.cards.type"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "CardStatus",
                                                        "kind": "LinkedField",
                                                        "name": "status",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v3 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.backlog.cards.status.id"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v4 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.backlog.cards.status.name"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v13 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.backlog.cards.status.category"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "boardScope.backlog.cards.status"
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "assignee",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v14 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "boardScope.backlog.cards.assignee.accountId"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v4 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "boardScope.backlog.cards.assignee.name"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v15 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "boardScope.backlog.cards.assignee.picture"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v16 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.backlog.cards.flagged"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v17 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.backlog.cards.done"
                                                },
                                                v18 /*: any*/ ,
                                                {
                                                    "concreteType": "Estimate",
                                                    "kind": "LinkedField",
                                                    "name": "estimate",
                                                    "plural": false,
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        {
                                                            "concreteType": "OriginalEstimate",
                                                            "kind": "LinkedField",
                                                            "name": "originalEstimate",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v20 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.backlog.cards.estimate.originalEstimate.value"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v21 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.backlog.cards.estimate.originalEstimate.valueAsText"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "CardPriority",
                                                    "kind": "LinkedField",
                                                    "name": "priority",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v4 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "boardScope.backlog.cards.priority.name"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v12 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "boardScope.backlog.cards.priority.iconUrl"
                                                        }
                                                    ]
                                                },
                                                v22 /*: any*/ ,
                                                {
                                                    "concreteType": "ChildCardsMetadata",
                                                    "kind": "LinkedField",
                                                    "name": "childCardsMetadata",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v23 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "boardScope.backlog.cards.childCardsMetadata.complete"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v24 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "boardScope.backlog.cards.childCardsMetadata.total"
                                                        }
                                                    ]
                                                },
                                                v25 /*: any*/ 
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "boardScope.backlog.cards"
                                    }
                                ]
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "SoftwareBoard",
                                    "kind": "LinkedField",
                                    "name": "board",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "SoftwareCard",
                                                "kind": "LinkedField",
                                                "name": "cards",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v3 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cards.id"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v9 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cards.key"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v10 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cards.summary"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v11 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cards.labels"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "CardType",
                                                            "kind": "LinkedField",
                                                            "name": "type",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v3 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.cards.type.id"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v4 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.cards.type.name"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v12 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.cards.type.iconUrl"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cards.type"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "CardStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v3 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.cards.status.id"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v4 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.cards.status.name"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v13 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.cards.status.category"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cards.status"
                                                    },
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "assignee",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v14 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.board.cards.assignee.accountId"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v4 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.board.cards.assignee.name"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v15 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.board.cards.assignee.picture"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v16 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cards.flagged"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v17 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cards.done"
                                                    },
                                                    v18 /*: any*/ ,
                                                    {
                                                        "concreteType": "Estimate",
                                                        "kind": "LinkedField",
                                                        "name": "estimate",
                                                        "plural": false,
                                                        "selections": [
                                                            v19 /*: any*/ ,
                                                            {
                                                                "concreteType": "OriginalEstimate",
                                                                "kind": "LinkedField",
                                                                "name": "originalEstimate",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v20 /*: any*/ ,
                                                                        "action": "THROW",
                                                                        "path": "boardScope.board.cards.estimate.originalEstimate.value"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v21 /*: any*/ ,
                                                                        "action": "THROW",
                                                                        "path": "boardScope.board.cards.estimate.originalEstimate.valueAsText"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "CardPriority",
                                                        "kind": "LinkedField",
                                                        "name": "priority",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v4 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.board.cards.priority.name"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v12 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.board.cards.priority.iconUrl"
                                                            }
                                                        ]
                                                    },
                                                    v22 /*: any*/ ,
                                                    {
                                                        "concreteType": "ChildCardsMetadata",
                                                        "kind": "LinkedField",
                                                        "name": "childCardsMetadata",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v23 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.board.cards.childCardsMetadata.complete"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v24 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.board.cards.childCardsMetadata.total"
                                                            }
                                                        ]
                                                    },
                                                    v25 /*: any*/ 
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.board.cards"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v29 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.board.rankCustomFieldId"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.board"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "CardParent",
                                    "kind": "LinkedField",
                                    "name": "cardParents",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v3 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.cardParents.id"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v9 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.cardParents.key"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v10 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.cardParents.summary"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "CardType",
                                                "kind": "LinkedField",
                                                "name": "cardType",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v3 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.cardParents.cardType.id"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v4 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.cardParents.cardType.name"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v12 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.cardParents.cardType.iconUrl"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.cardParents.cardType"
                                        },
                                        v30 /*: any*/ 
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.cardParents"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "CurrentUser",
                                    "kind": "LinkedField",
                                    "name": "currentUser",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v31 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.currentUser.permissions"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.currentUser"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "SoftwareProject",
                                    "kind": "LinkedField",
                                    "name": "projectLocation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v3 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.projectLocation.id"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v9 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.projectLocation.key"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v4 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.projectLocation.name"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "CardType",
                                                "kind": "LinkedField",
                                                "name": "cardTypes",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v3 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.projectLocation.cardTypes.id"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v4 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.projectLocation.cardTypes.name"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v12 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.projectLocation.cardTypes.iconUrl"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v32 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.projectLocation.cardTypes.hierarchyLevelType"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v33 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.projectLocation.cardTypes.hasRequiredFields"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.projectLocation.cardTypes"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.projectLocation"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "BoardFeature",
                                    "kind": "LinkedField",
                                    "name": "features",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v9 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.features.key"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v34 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.features.status"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.features"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "EstimationConfig",
                                    "kind": "LinkedField",
                                    "name": "estimation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v35 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.estimation.current"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "AvailableEstimations",
                                                "kind": "LinkedField",
                                                "name": "available",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v36 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.estimation.available.statisticFieldId"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.estimation.available"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.estimation"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "boardScope"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v37 /*: any*/ ,
                                    "concreteType": "JiraTimeTrackingSettings",
                                    "kind": "LinkedField",
                                    "name": "globalTimeTrackingSettings",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v38 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.globalTimeTrackingSettings.defaultUnit"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v39 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.globalTimeTrackingSettings.workingDaysPerWeek"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v40 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.globalTimeTrackingSettings.workingHoursPerDay"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v41 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.globalTimeTrackingSettings.defaultFormat"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.globalTimeTrackingSettings"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "aggBacklogDataQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "Sprint",
                            "kind": "LinkedField",
                            "name": "sprints",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v43 /*: any*/ ,
                                v26 /*: any*/ 
                            ],
                            "storageKey": "sprints(state:[\"ACTIVE\",\"FUTURE\"])"
                        },
                        {
                            "concreteType": "Backlog",
                            "kind": "LinkedField",
                            "name": "backlog",
                            "plural": false,
                            "selections": [
                                v27 /*: any*/ ,
                                v28 /*: any*/ ,
                                v43 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "SoftwareBoard",
                            "kind": "LinkedField",
                            "name": "board",
                            "plural": false,
                            "selections": [
                                v43 /*: any*/ ,
                                v29 /*: any*/ ,
                                v3 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "CardParent",
                            "kind": "LinkedField",
                            "name": "cardParents",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "concreteType": "CardType",
                                    "kind": "LinkedField",
                                    "name": "cardType",
                                    "plural": false,
                                    "selections": v42 /*: any*/ 
                                },
                                v30 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "CurrentUser",
                            "kind": "LinkedField",
                            "name": "currentUser",
                            "plural": false,
                            "selections": [
                                v31 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "SoftwareProject",
                            "kind": "LinkedField",
                            "name": "projectLocation",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v9 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "CardType",
                                    "kind": "LinkedField",
                                    "name": "cardTypes",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        v32 /*: any*/ ,
                                        v33 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "BoardFeature",
                            "kind": "LinkedField",
                            "name": "features",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v34 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "EstimationConfig",
                            "kind": "LinkedField",
                            "name": "estimation",
                            "plural": false,
                            "selections": [
                                v35 /*: any*/ ,
                                {
                                    "concreteType": "AvailableEstimations",
                                    "kind": "LinkedField",
                                    "name": "available",
                                    "plural": true,
                                    "selections": [
                                        v36 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v37 /*: any*/ ,
                            "concreteType": "JiraTimeTrackingSettings",
                            "kind": "LinkedField",
                            "name": "globalTimeTrackingSettings",
                            "plural": false,
                            "selections": [
                                v38 /*: any*/ ,
                                v39 /*: any*/ ,
                                v40 /*: any*/ ,
                                v41 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f0265750b202c0ceda593f31130e4808462f54c3702123d91fff9c415016144e",
            "metadata": {},
            "name": "aggBacklogDataQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6d41a02f4836bc39$var$node.hash = "5066bdc9703e345e9762320044e879c8";
var $6d41a02f4836bc39$export$2e2bcd8739ae039 = $6d41a02f4836bc39$var$node;

});

const $52b7f081c10f9d47$export$faa68b3df5415bcb = 'NEXTGEN_BACKLOG_CUSTOM_FILTERS';
const $52b7f081c10f9d47$export$a0ef589381533a7c = 'NEXTGEN_BACKLOG';
const $52b7f081c10f9d47$export$463905a04a9a75ce = 'NEXTGEN_BACKLOG_RELAY';


parcelRegister("gmVN5", function(module, exports) {

$parcel$export(module.exports, "backlogResource", () => $940828cbe6572373$export$31d171ba71468137);
$parcel$export(module.exports, "conditionalBacklogResource", () => $940828cbe6572373$export$c77659376558c168);

var $1ybV0 = parcelRequire("1ybV0");

var $3HCkE = parcelRequire("3HCkE");

var $jwzNs = parcelRequire("jwzNs");


const $940828cbe6572373$export$31d171ba71468137 = (0, $jwzNs.browserOnlyResourceWithCondition)(()=>false, (0, $3HCkE.createResource)({
    type: (0, $52b7f081c10f9d47$export$a0ef589381533a7c),
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>(parcelRequire("8U0i8")),
    // SSR doesn't care about this and we can't check FFs here because its not in the render path
    maxAge: 3600000
}));
const $940828cbe6572373$export$c77659376558c168 = (0, $jwzNs.resourceWithCondition2)(()=>!(0, $1ybV0.ff)('jsw.perf.critical-backlog-with-relay'), $940828cbe6572373$export$31d171ba71468137);

});
parcelRegister("8U0i8", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('c9taI');
        const value = parcelRequire('k5z0l');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("c9taI").then(()=>parcelRequire('k5z0l'));
}

});


parcelRegister("59z8J", function(module, exports) {

$parcel$export(module.exports, "customFiltersResource", () => $95f320c7eb1343f4$export$3e390340716755de);

var $huI7r = parcelRequire("huI7r");

var $buJlM = parcelRequire("buJlM");

var $gH3Un = parcelRequire("gH3Un");

var $jwzNs = parcelRequire("jwzNs");

const $95f320c7eb1343f4$export$3e390340716755de = (0, $jwzNs.browserOnlyResourceWithCondition)(()=>false, (0, $buJlM.createRelayResource)({
    type: (0, $52b7f081c10f9d47$export$faa68b3df5415bcb),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $gH3Un.default),
            variables: {
                boardId: (0, $huI7r.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    captureErrors: true
}));

});
parcelRegister("gH3Un", function(module, exports) {

$parcel$export(module.exports, "default", () => $3764437b0e4e7969$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<066895e3c0e872466470887b4350609b>>
 * @relayHash 8bb4d5e3e502ca70e90f4e1bb2f1614f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 494a9992c544e6be8f44d8b97ba70f29edc0d248b0153079b00cda817f4f7082
const $3764437b0e4e7969$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "viewBacklogCustomFiltersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "customFilter_softwareFilters_CustomFilterRelay"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "viewBacklogCustomFiltersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "CustomFilter",
                            "kind": "LinkedField",
                            "name": "customFilters",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        },
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "494a9992c544e6be8f44d8b97ba70f29edc0d248b0153079b00cda817f4f7082",
            "metadata": {},
            "name": "viewBacklogCustomFiltersQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3764437b0e4e7969$var$node.hash = "071c255f9696fe84a9c3982d42cfa5c0";
var $3764437b0e4e7969$export$2e2bcd8739ae039 = $3764437b0e4e7969$var$node;

});


parcelRegister("chAei", function(module, exports) {

$parcel$export(module.exports, "boardResource", () => $b59dcfcbfdcea858$export$286b76e0f2661cfb);
$parcel$export(module.exports, "customFiltersResource", () => $b59dcfcbfdcea858$export$3e390340716755de);
$parcel$export(module.exports, "boardRelayResource", () => $b59dcfcbfdcea858$export$81ac23db76b1f935);

var $huI7r = parcelRequire("huI7r");

var $buJlM = parcelRequire("buJlM");

var $itb5b = parcelRequire("itb5b");

var $3JKpj = parcelRequire("3JKpj");

var $3HCkE = parcelRequire("3HCkE");

var $jwzNs = parcelRequire("jwzNs");


const $b59dcfcbfdcea858$export$286b76e0f2661cfb = (0, $jwzNs.browserOnlyResourceWithCondition)(()=>false, (0, $3HCkE.createResource)({
    type: (0, $77a7d82b9fcd593e$export$a38ac7339e3f31db),
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>(parcelRequire("hr2tX")),
    // SSR doesn't care about this and we can't check FFs here because its not in the render path
    maxAge: 3600000
}));
const $b59dcfcbfdcea858$export$3e390340716755de = (0, $jwzNs.browserOnlyResourceWithCondition)(()=>false, (0, $buJlM.createRelayResource)({
    type: (0, $77a7d82b9fcd593e$export$b48bcc76a0105016),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $3JKpj.default),
            variables: {
                boardId: (0, $huI7r.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
}));
const $b59dcfcbfdcea858$export$81ac23db76b1f935 = (0, $jwzNs.browserOnlyResourceWithCondition)(()=>false, (0, $buJlM.createRelayResource)({
    type: (0, $77a7d82b9fcd593e$export$5cef388780439aec),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $itb5b.default),
            variables: {
                boardId: (0, $huI7r.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
}));

});
parcelRegister("itb5b", function(module, exports) {

$parcel$export(module.exports, "default", () => $cebd4baafafd2802$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2fff64862218a59c7c9cc3968830f25e>>
 * @relayHash 1b45667561f9430ea4e961757485983b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ab366f74068bb048193650cda464a839daec6f71dd9d1e7ee8874e9f9959ba67
const $cebd4baafafd2802$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "userSwimlaneStrategy"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "swimlaneStrategy"
    }, v5 = {
        "kind": "ScalarField",
        "name": "hasClearedCards"
    }, v6 = {
        "kind": "ScalarField",
        "name": "rankCustomFieldId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "maxCardCount"
    }, v11 = {
        "kind": "ScalarField",
        "name": "category"
    }, v12 = {
        "kind": "ScalarField",
        "name": "transitionId"
    }, v13 = {
        "kind": "ScalarField",
        "name": "isGlobal"
    }, v14 = {
        "kind": "ScalarField",
        "name": "isInitial"
    }, v15 = {
        "kind": "ScalarField",
        "name": "hasConditions"
    }, v16 = {
        "kind": "ScalarField",
        "name": "isDone"
    }, v17 = {
        "kind": "ScalarField",
        "name": "flagged"
    }, v18 = {
        "kind": "ScalarField",
        "name": "done"
    }, v19 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v20 = {
        "kind": "ScalarField",
        "name": "storyPoints"
    }, v21 = {
        "kind": "ScalarField",
        "name": "value"
    }, v22 = {
        "kind": "ScalarField",
        "name": "valueAsText"
    }, v23 = {
        "kind": "ScalarField",
        "name": "key"
    }, v24 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v25 = {
        "kind": "ScalarField",
        "name": "labels"
    }, v26 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v27 = {
        "kind": "ScalarField",
        "name": "dueDate"
    }, v28 = {
        "kind": "ScalarField",
        "name": "complete"
    }, v29 = {
        "kind": "ScalarField",
        "name": "total"
    }, v30 = {
        "kind": "ScalarField",
        "name": "hierarchyLevelType"
    }, v31 = {
        "kind": "ScalarField",
        "name": "enabled"
    }, v32 = [
        {
            "kind": "Literal",
            "name": "state",
            "value": [
                "ACTIVE"
            ]
        }
    ], v33 = {
        "kind": "ScalarField",
        "name": "goal"
    }, v34 = {
        "kind": "ScalarField",
        "name": "startDate"
    }, v35 = {
        "kind": "ScalarField",
        "name": "endDate"
    }, v36 = {
        "kind": "ScalarField",
        "name": "daysRemaining"
    }, v37 = {
        "kind": "ScalarField",
        "name": "status"
    }, v38 = {
        "kind": "ScalarField",
        "name": "toggle"
    }, v39 = {
        "kind": "ScalarField",
        "name": "color"
    }, v40 = {
        "kind": "ScalarField",
        "name": "permissions"
    }, v41 = {
        "concreteType": "EstimationConfig",
        "kind": "LinkedField",
        "name": "estimation",
        "plural": false,
        "selections": [
            {
                "concreteType": "CurrentEstimation",
                "kind": "LinkedField",
                "name": "current",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "customFieldId"
                    }
                ]
            }
        ]
    }, v42 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v43 = [
        v42 /*: any*/ ,
        v7 /*: any*/ ,
        v3 /*: any*/ ,
        v8 /*: any*/ ,
        v9 /*: any*/ 
    ], v44 = {
        "concreteType": "CardStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v9 /*: any*/ ,
            v3 /*: any*/ ,
            v11 /*: any*/ 
        ]
    }, v45 = [
        v9 /*: any*/ 
    ], v46 = {
        "concreteType": "CardStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": v45 /*: any*/ 
    }, v47 = {
        "concreteType": "Estimate",
        "kind": "LinkedField",
        "name": "estimate",
        "plural": false,
        "selections": [
            v20 /*: any*/ ,
            {
                "concreteType": "OriginalEstimate",
                "kind": "LinkedField",
                "name": "originalEstimate",
                "plural": false,
                "selections": [
                    v21 /*: any*/ ,
                    v22 /*: any*/ 
                ]
            }
        ]
    }, v48 = [
        v9 /*: any*/ ,
        v3 /*: any*/ ,
        v26 /*: any*/ 
    ], v49 = {
        "concreteType": "CardType",
        "kind": "LinkedField",
        "name": "type",
        "plural": false,
        "selections": v48 /*: any*/ 
    }, v50 = {
        "concreteType": "CardPriority",
        "kind": "LinkedField",
        "name": "priority",
        "plural": false,
        "selections": [
            v3 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v51 = {
        "concreteType": "CardType",
        "kind": "LinkedField",
        "name": "cardTypes",
        "plural": true,
        "selections": [
            v9 /*: any*/ ,
            v3 /*: any*/ ,
            v26 /*: any*/ ,
            v30 /*: any*/ 
        ]
    }, v52 = [
        v31 /*: any*/ 
    ], v53 = {
        "concreteType": "InlineCardCreateConfig",
        "kind": "LinkedField",
        "name": "inlineCardCreate",
        "plural": false,
        "selections": v52 /*: any*/ 
    }, v54 = {
        "concreteType": "SoftwareCard",
        "kind": "LinkedField",
        "name": "cards",
        "plural": true,
        "selections": v45 /*: any*/ 
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "boardWithRouterRelayQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            v2 /*: any*/ ,
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "SoftwareBoard",
                                    "kind": "LinkedField",
                                    "name": "board",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v3 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.board.name"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v4 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.board.swimlaneStrategy"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v5 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.board.hasClearedCards"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v6 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.board.rankCustomFieldId"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "kind": "LinkedField",
                                                "name": "assignees",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v7 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.assignees.accountId"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v3 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.assignees.name"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v8 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.assignees.picture"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.board.assignees"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "Column",
                                                "kind": "LinkedField",
                                                "name": "columns",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v9 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.columns.id"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v3 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.columns.name"
                                                    },
                                                    v10 /*: any*/ ,
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "ColumnStatus",
                                                            "kind": "LinkedField",
                                                            "name": "columnStatus",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "CardStatus",
                                                                        "kind": "LinkedField",
                                                                        "name": "status",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v9 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.columnStatus.status.id"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v3 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.columnStatus.status.name"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v11 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.columnStatus.status.category"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.columns.columnStatus.status"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "SoftwareCardTypeTransition",
                                                                        "kind": "LinkedField",
                                                                        "name": "cardTypeTransitions",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v12 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.columnStatus.cardTypeTransitions.transitionId"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v3 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.columnStatus.cardTypeTransitions.name"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": {
                                                                                    "concreteType": "CardStatus",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "status",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "RequiredField",
                                                                                            "field": v9 /*: any*/ ,
                                                                                            "action": "THROW",
                                                                                            "path": "boardScope.board.columns.columnStatus.cardTypeTransitions.status.id"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.columnStatus.cardTypeTransitions.status"
                                                                            },
                                                                            {
                                                                                "concreteType": "CardStatus",
                                                                                "kind": "LinkedField",
                                                                                "name": "originStatus",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v9 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "boardScope.board.columns.columnStatus.cardTypeTransitions.originStatus.id"
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": {
                                                                                    "concreteType": "CardType",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "cardType",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "RequiredField",
                                                                                            "field": v9 /*: any*/ ,
                                                                                            "action": "THROW",
                                                                                            "path": "boardScope.board.columns.columnStatus.cardTypeTransitions.cardType.id"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.columnStatus.cardTypeTransitions.cardType"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v13 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.columnStatus.cardTypeTransitions.isGlobal"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v14 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.columnStatus.cardTypeTransitions.isInitial"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v15 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.columnStatus.cardTypeTransitions.hasConditions"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.columns.columnStatus.cardTypeTransitions"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "boardScope.board.columns.columnStatus"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v16 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.columns.isDone"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v14 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.columns.isInitial"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "SoftwareCard",
                                                            "kind": "LinkedField",
                                                            "name": "cards",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v9 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.columns.cards.id"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v17 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.columns.cards.flagged"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v18 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.columns.cards.done"
                                                                },
                                                                v19 /*: any*/ ,
                                                                {
                                                                    "concreteType": "Sprint",
                                                                    "kind": "LinkedField",
                                                                    "name": "activeSprint",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v9 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "boardScope.board.columns.cards.activeSprint.id"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "Estimate",
                                                                    "kind": "LinkedField",
                                                                    "name": "estimate",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v20 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "OriginalEstimate",
                                                                            "kind": "LinkedField",
                                                                            "name": "originalEstimate",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v21 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "boardScope.board.columns.cards.estimate.originalEstimate.value"
                                                                                },
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v22 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "boardScope.board.columns.cards.estimate.originalEstimate.valueAsText"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v23 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.columns.cards.key"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v24 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.columns.cards.summary"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v25 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.columns.cards.labels"
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "assignee",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v7 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "boardScope.board.columns.cards.assignee.accountId"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "CardType",
                                                                        "kind": "LinkedField",
                                                                        "name": "type",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v9 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.cards.type.id"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v3 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.cards.type.name"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v26 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.cards.type.iconUrl"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.columns.cards.type"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "CardStatus",
                                                                        "kind": "LinkedField",
                                                                        "name": "status",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v9 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.cards.status.id"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.columns.cards.status"
                                                                },
                                                                {
                                                                    "concreteType": "CardPriority",
                                                                    "kind": "LinkedField",
                                                                    "name": "priority",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v3 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "boardScope.board.columns.cards.priority.name"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v26 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "boardScope.board.columns.cards.priority.iconUrl"
                                                                        }
                                                                    ]
                                                                },
                                                                v27 /*: any*/ ,
                                                                {
                                                                    "concreteType": "ChildCardsMetadata",
                                                                    "kind": "LinkedField",
                                                                    "name": "childCardsMetadata",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v28 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "boardScope.board.columns.cards.childCardsMetadata.complete"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v29 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "boardScope.board.columns.cards.childCardsMetadata.total"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "boardScope.board.columns.cards"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.board.columns"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "CardType",
                                                "kind": "LinkedField",
                                                "name": "cardTypes",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v9 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cardTypes.id"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v3 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cardTypes.name"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v26 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cardTypes.iconUrl"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v30 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cardTypes.hierarchyLevelType"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.board.cardTypes"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "InlineCardCreateConfig",
                                                "kind": "LinkedField",
                                                "name": "inlineCardCreate",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v31 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.inlineCardCreate.enabled"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.board.inlineCardCreate"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "SoftwareCard",
                                                "kind": "LinkedField",
                                                "name": "cardChildren",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v9 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cardChildren.id"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v17 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cardChildren.flagged"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v18 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cardChildren.done"
                                                    },
                                                    v19 /*: any*/ ,
                                                    {
                                                        "concreteType": "Estimate",
                                                        "kind": "LinkedField",
                                                        "name": "estimate",
                                                        "plural": false,
                                                        "selections": [
                                                            v20 /*: any*/ ,
                                                            {
                                                                "concreteType": "OriginalEstimate",
                                                                "kind": "LinkedField",
                                                                "name": "originalEstimate",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v21 /*: any*/ ,
                                                                        "action": "THROW",
                                                                        "path": "boardScope.board.cardChildren.estimate.originalEstimate.value"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v22 /*: any*/ ,
                                                                        "action": "THROW",
                                                                        "path": "boardScope.board.cardChildren.estimate.originalEstimate.valueAsText"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v23 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cardChildren.key"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v24 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cardChildren.summary"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v25 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cardChildren.labels"
                                                    },
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "assignee",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v7 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.board.cardChildren.assignee.accountId"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v3 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.board.cardChildren.assignee.name"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v8 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.board.cardChildren.assignee.picture"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "CardType",
                                                            "kind": "LinkedField",
                                                            "name": "type",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v9 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.cardChildren.type.id"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v3 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.cardChildren.type.name"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v26 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.cardChildren.type.iconUrl"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cardChildren.type"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "CardStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v9 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.cardChildren.status.id"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cardChildren.status"
                                                    },
                                                    {
                                                        "concreteType": "CardPriority",
                                                        "kind": "LinkedField",
                                                        "name": "priority",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v3 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.board.cardChildren.priority.name"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v26 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.board.cardChildren.priority.iconUrl"
                                                            }
                                                        ]
                                                    },
                                                    v27 /*: any*/ 
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.board.cardChildren"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "SoftwareCard",
                                                "kind": "LinkedField",
                                                "name": "cards",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v9 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cards.id"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.board.cards"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "BoardEditConfig",
                                                "kind": "LinkedField",
                                                "name": "editConfig",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "InlineColumnEditConfig",
                                                            "kind": "LinkedField",
                                                            "name": "inlineColumnEdit",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v31 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.editConfig.inlineColumnEdit.enabled"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "boardScope.board.editConfig.inlineColumnEdit"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "InlineCardCreateConfig",
                                                            "kind": "LinkedField",
                                                            "name": "inlineCardCreate",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v31 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.editConfig.inlineCardCreate.enabled"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "boardScope.board.editConfig.inlineCardCreate"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.board.editConfig"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.board"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v32 /*: any*/ ,
                                    "concreteType": "Sprint",
                                    "kind": "LinkedField",
                                    "name": "sprints",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v9 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.sprints.id"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v3 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.sprints.name"
                                        },
                                        v33 /*: any*/ ,
                                        {
                                            "kind": "RequiredField",
                                            "field": v34 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.sprints.startDate"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v35 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.sprints.endDate"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v36 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.sprints.daysRemaining"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "SoftwareCard",
                                                "kind": "LinkedField",
                                                "name": "cards",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v9 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.sprints.cards.id"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.sprints.cards"
                                        }
                                    ],
                                    "storageKey": "sprints(state:[\"ACTIVE\"])"
                                },
                                "action": "THROW",
                                "path": "boardScope.sprints"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "BoardFeature",
                                    "kind": "LinkedField",
                                    "name": "features",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v23 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.features.key"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v37 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.features.status"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v38 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.features.toggle"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v11 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.features.category"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.features"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "SoftwareProject",
                                    "kind": "LinkedField",
                                    "name": "projectLocation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v9 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.projectLocation.id"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v23 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.projectLocation.key"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v3 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.projectLocation.name"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "CardType",
                                                "kind": "LinkedField",
                                                "name": "cardTypes",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v9 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.projectLocation.cardTypes.id"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v3 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.projectLocation.cardTypes.name"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v26 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.projectLocation.cardTypes.iconUrl"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v30 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.projectLocation.cardTypes.hierarchyLevelType"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.projectLocation.cardTypes"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.projectLocation"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "CardParent",
                                    "kind": "LinkedField",
                                    "name": "cardParents",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v9 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.cardParents.id"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v23 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.cardParents.key"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v24 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.cardParents.summary"
                                        },
                                        {
                                            "concreteType": "CardStatus",
                                            "kind": "LinkedField",
                                            "name": "status",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v9 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.cardParents.status.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v3 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.cardParents.status.name"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v11 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.cardParents.status.category"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "CardType",
                                                "kind": "LinkedField",
                                                "name": "cardType",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v9 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.cardParents.cardType.id"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v3 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.cardParents.cardType.name"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v26 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.cardParents.cardType.iconUrl"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.cardParents.cardType"
                                        },
                                        v39 /*: any*/ 
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.cardParents"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "CurrentUser",
                                    "kind": "LinkedField",
                                    "name": "currentUser",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v40 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.currentUser.permissions"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.currentUser"
                            },
                            v41 /*: any*/ 
                        ]
                    },
                    "action": "THROW",
                    "path": "boardScope"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "boardWithRouterRelayQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "SoftwareBoard",
                            "kind": "LinkedField",
                            "name": "board",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "assignees",
                                    "plural": true,
                                    "selections": v43 /*: any*/ 
                                },
                                {
                                    "concreteType": "Column",
                                    "kind": "LinkedField",
                                    "name": "columns",
                                    "plural": true,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "concreteType": "ColumnStatus",
                                            "kind": "LinkedField",
                                            "name": "columnStatus",
                                            "plural": true,
                                            "selections": [
                                                v44 /*: any*/ ,
                                                {
                                                    "concreteType": "SoftwareCardTypeTransition",
                                                    "kind": "LinkedField",
                                                    "name": "cardTypeTransitions",
                                                    "plural": true,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v46 /*: any*/ ,
                                                        {
                                                            "concreteType": "CardStatus",
                                                            "kind": "LinkedField",
                                                            "name": "originStatus",
                                                            "plural": false,
                                                            "selections": v45 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "CardType",
                                                            "kind": "LinkedField",
                                                            "name": "cardType",
                                                            "plural": false,
                                                            "selections": v45 /*: any*/ 
                                                        },
                                                        v13 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        v15 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v16 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        {
                                            "concreteType": "SoftwareCard",
                                            "kind": "LinkedField",
                                            "name": "cards",
                                            "plural": true,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                {
                                                    "concreteType": "Sprint",
                                                    "kind": "LinkedField",
                                                    "name": "activeSprint",
                                                    "plural": false,
                                                    "selections": v45 /*: any*/ 
                                                },
                                                v47 /*: any*/ ,
                                                v23 /*: any*/ ,
                                                v24 /*: any*/ ,
                                                v25 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "assignee",
                                                    "plural": false,
                                                    "selections": [
                                                        v42 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ]
                                                },
                                                v49 /*: any*/ ,
                                                v46 /*: any*/ ,
                                                v50 /*: any*/ ,
                                                v27 /*: any*/ ,
                                                {
                                                    "concreteType": "ChildCardsMetadata",
                                                    "kind": "LinkedField",
                                                    "name": "childCardsMetadata",
                                                    "plural": false,
                                                    "selections": [
                                                        v28 /*: any*/ ,
                                                        v29 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v51 /*: any*/ ,
                                v53 /*: any*/ ,
                                {
                                    "concreteType": "SoftwareCard",
                                    "kind": "LinkedField",
                                    "name": "cardChildren",
                                    "plural": true,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v47 /*: any*/ ,
                                        v23 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "assignee",
                                            "plural": false,
                                            "selections": v43 /*: any*/ 
                                        },
                                        v49 /*: any*/ ,
                                        v46 /*: any*/ ,
                                        v50 /*: any*/ ,
                                        v27 /*: any*/ 
                                    ]
                                },
                                v54 /*: any*/ ,
                                {
                                    "concreteType": "BoardEditConfig",
                                    "kind": "LinkedField",
                                    "name": "editConfig",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "InlineColumnEditConfig",
                                            "kind": "LinkedField",
                                            "name": "inlineColumnEdit",
                                            "plural": false,
                                            "selections": v52 /*: any*/ 
                                        },
                                        v53 /*: any*/ 
                                    ]
                                },
                                v9 /*: any*/ 
                            ]
                        },
                        {
                            "args": v32 /*: any*/ ,
                            "concreteType": "Sprint",
                            "kind": "LinkedField",
                            "name": "sprints",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v3 /*: any*/ ,
                                v33 /*: any*/ ,
                                v34 /*: any*/ ,
                                v35 /*: any*/ ,
                                v36 /*: any*/ ,
                                v54 /*: any*/ 
                            ],
                            "storageKey": "sprints(state:[\"ACTIVE\"])"
                        },
                        {
                            "concreteType": "BoardFeature",
                            "kind": "LinkedField",
                            "name": "features",
                            "plural": true,
                            "selections": [
                                v23 /*: any*/ ,
                                v37 /*: any*/ ,
                                v38 /*: any*/ ,
                                v11 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "SoftwareProject",
                            "kind": "LinkedField",
                            "name": "projectLocation",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                v23 /*: any*/ ,
                                v3 /*: any*/ ,
                                v51 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "CardParent",
                            "kind": "LinkedField",
                            "name": "cardParents",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v44 /*: any*/ ,
                                {
                                    "concreteType": "CardType",
                                    "kind": "LinkedField",
                                    "name": "cardType",
                                    "plural": false,
                                    "selections": v48 /*: any*/ 
                                },
                                v39 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "CurrentUser",
                            "kind": "LinkedField",
                            "name": "currentUser",
                            "plural": false,
                            "selections": [
                                v40 /*: any*/ 
                            ]
                        },
                        v41 /*: any*/ ,
                        v9 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "ab366f74068bb048193650cda464a839daec6f71dd9d1e7ee8874e9f9959ba67",
            "metadata": {},
            "name": "boardWithRouterRelayQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$cebd4baafafd2802$var$node.hash = "9b97e0f648b4ea09d8b5addc94a66e17";
var $cebd4baafafd2802$export$2e2bcd8739ae039 = $cebd4baafafd2802$var$node;

});

parcelRegister("3JKpj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a5f64fd6240f4af$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4aa06633d1d961e7d2544815b9d5cd2a>>
 * @relayHash fa277d121f8f09e75035802d7ede6889
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a079984b25df71d288de249187cdd59463b205124f1a0a13756db6b3207ef56b
const $3a5f64fd6240f4af$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "viewBoardCustomFiltersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "customFilter_softwareFilters_CustomFilterRelay"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "viewBoardCustomFiltersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "CustomFilter",
                            "kind": "LinkedField",
                            "name": "customFilters",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        },
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "a079984b25df71d288de249187cdd59463b205124f1a0a13756db6b3207ef56b",
            "metadata": {},
            "name": "viewBoardCustomFiltersQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3a5f64fd6240f4af$var$node.hash = "6e864c81bd5b9bb4747b14a9f2cd5746";
var $3a5f64fd6240f4af$export$2e2bcd8739ae039 = $3a5f64fd6240f4af$var$node;

});

const $77a7d82b9fcd593e$export$a38ac7339e3f31db = 'NEXTGEN_BOARD';
const $77a7d82b9fcd593e$export$b48bcc76a0105016 = 'NEXTGEN_BOARD_CUSTOM_FILTERS';
const $77a7d82b9fcd593e$export$5cef388780439aec = 'NEXTGEN_BOARD_RELAY';

parcelRegister("hr2tX", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('7RdTy');
        const value = parcelRequire('gJf6D');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("7RdTy").then(()=>parcelRequire('gJf6D'));
}

});


parcelRegister("7yAHk", function(module, exports) {

$parcel$export(module.exports, "softwareBoardRoute", () => $650519e8b83fa4a8$export$9ae2c0a566d4e0f6);

var $exb0h = parcelRequire("exb0h");
const $650519e8b83fa4a8$export$9ae2c0a566d4e0f6 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_BOARDS,
    exact: true,
    path: '/jira/software/projects/:projectKey/boards/:boardId'
};

});

parcelRegister("j7Vfn", function(module, exports) {

$parcel$export(module.exports, "NextGenBoardSkeleton", () => $971b5b15648111a5$export$25a9d0fbcb127c90);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");

var $fztmb = parcelRequire("fztmb");
const $971b5b15648111a5$var$customCssStyles = null;
const $971b5b15648111a5$export$25a9d0fbcb127c90 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fztmb))),
        className: (0, $7JEyt.default)([
            "_2zz1idpf"
        ])
    });

});
parcelRegister("fztmb", function(module, exports) {
module.exports = new URL("next-gen-board-app-skeleton.tpl.d10f8ca5.svg", import.meta.url).toString();

});


parcelRegister("1Iui1", function(module, exports) {

$parcel$export(module.exports, "COHORT", () => $1524157debf2fd00$export$3d370c33621572df);
$parcel$export(module.exports, "NOT_ENROLLED", () => $1524157debf2fd00$export$5b7423264d48ab04);
$parcel$export(module.exports, "CONTROL", () => $1524157debf2fd00$export$43f367b3e957f219);
$parcel$export(module.exports, "EXPERIMENT", () => $1524157debf2fd00$export$9ba2bc3b1bdc1519);
$parcel$export(module.exports, "VARIATION", () => $1524157debf2fd00$export$fa04ad826acc90da);
$parcel$export(module.exports, "VAR1", () => $1524157debf2fd00$export$6486974e39493fa6);
$parcel$export(module.exports, "VAR2", () => $1524157debf2fd00$export$7d994996134ad562);

var $1ybV0 = parcelRequire("1ybV0");
const $1524157debf2fd00$export$3d370c33621572df = 'cohort';
const $1524157debf2fd00$export$5b7423264d48ab04 = 'not-enrolled';
const $1524157debf2fd00$export$43f367b3e957f219 = 'control';
const $1524157debf2fd00$export$9ba2bc3b1bdc1519 = 'experiment';
const $1524157debf2fd00$export$fa04ad826acc90da = 'variation';
const $1524157debf2fd00$export$6486974e39493fa6 = 'variation-1';
const $1524157debf2fd00$export$7d994996134ad562 = 'variation-2';
const $1524157debf2fd00$export$795e7d69b248dcd0 = 'variation-3';
const $1524157debf2fd00$export$c9c947c57470b787 = 'variation-4';
const $1524157debf2fd00$var$DEFAULT_VALID_EXPERIMENT_GROUPS = [
    $1524157debf2fd00$export$5b7423264d48ab04,
    $1524157debf2fd00$export$43f367b3e957f219,
    $1524157debf2fd00$export$9ba2bc3b1bdc1519,
    $1524157debf2fd00$export$fa04ad826acc90da,
    $1524157debf2fd00$export$6486974e39493fa6,
    $1524157debf2fd00$export$7d994996134ad562,
    $1524157debf2fd00$export$795e7d69b248dcd0,
    $1524157debf2fd00$export$c9c947c57470b787
];
var // Use optionalValidExperimentGroups to further restrict the list of cohorts
// eslint-disable-next-line jira/import/no-anonymous-default-export
$1524157debf2fd00$export$2e2bcd8739ae039 = (experimentFeatureFlag, validExperimentGroups = $1524157debf2fd00$var$DEFAULT_VALID_EXPERIMENT_GROUPS)=>(0, $1ybV0.getMultivariateFeatureFlag)(experimentFeatureFlag, $1524157debf2fd00$export$5b7423264d48ab04, validExperimentGroups);

});

parcelRegister("hv7Ay", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('46tFu')
        ]);
        const value = parcelRequire('6fTlz');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("46tFu")
    ]).then(()=>parcelRequire('6fTlz'));
}

});

parcelRegister("8hvlU", function(module, exports) {

$parcel$export(module.exports, "issueNavigatorRelayResource", () => $32e9eef2b1613b8f$export$b4096f516fb93159);
$parcel$export(module.exports, "issueNavigatorFilterRelayResource", () => $32e9eef2b1613b8f$export$44ca3a0b25f38d83);
/* eslint-disable jira/import-whitelist */ 
var $iWLL0 = parcelRequire("iWLL0");

var $5as0a = parcelRequire("5as0a");

var $jccNB = parcelRequire("jccNB");

var $huI7r = parcelRequire("huI7r");

var $amu7D = parcelRequire("amu7D");

var $c7ifG = parcelRequire("c7ifG");

var $buJlM = parcelRequire("buJlM");

var $k7wca = parcelRequire("k7wca");

var $1zgpM = parcelRequire("1zgpM");

var $3HCkE = parcelRequire("3HCkE");

var $jK0NH = parcelRequire("jK0NH");

var $cWHXY = parcelRequire("cWHXY");
const $32e9eef2b1613b8f$var$RESOURCE_TYPE_REQUEST_TAB_ISSUE_NAVIGATOR_FILTER_RELAY = 'REQUEST_TAB_ISSUE_NAVIGATOR_FILTER_RELAY';
const $32e9eef2b1613b8f$var$RESOURCE_TYPE_REQUEST_TAB_ISSUE_NAVIGATOR_RELAY = 'REQUEST_TAB_ISSUE_NAVIGATOR_RELAY';
const $32e9eef2b1613b8f$export$b4096f516fb93159 = (0, $3HCkE.createResource)({
    type: `${(0, $buJlM.RELAY_RESOURCE_TYPE)}_${$32e9eef2b1613b8f$var$RESOURCE_TYPE_REQUEST_TAB_ISSUE_NAVIGATOR_RELAY}`,
    getKey: ()=>'request-tab-issue-navigator-relay',
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
        if (false && tenantContext.isAnonymous) return null;
        let projectKey = '';
        // TO-DO handle the error throw here
        try {
            const response = await (0, $cWHXY.getLatestJSMProjectRequest)();
            projectKey = response?.values?.[0]?.key;
        } catch (error) {
            /* eslint-disable no-console */ console.log(error);
        }
        const { issueKey: issueKey, jql: jqlParam, defaultJql: defaultJql, filter: filter } = (0, $jK0NH.getParams)(routerContext, projectKey);
        const jqlOrFilterId = (0, $jK0NH.getJqlOrFilterId)(projectKey, defaultJql, jqlParam, filter);
        const maxIssuesPerPage = (0, $jccNB.getMaxIssuesPerPage)();
        const variables = {
            cloudId: tenantContext.cloudId,
            first: issueKey == null ? maxIssuesPerPage : null,
            issueSearchInput: jqlOrFilterId,
            namespace: (0, $jccNB.ISSUE_SEARCH_NAMESPACE),
            after: null,
            options: {
                issueKey: issueKey
            },
            fieldSetIds: [],
            shouldQueryFieldSetsById: false,
            viewId: (0, $jccNB.LIST_VIEW_ID),
            amountOfColumns: (0, $jccNB.MAX_AMOUNT_OF_COLUMNS),
            atlassianIntelligenceProductFeature: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $jccNB.NATURAL_LANGUAGE_TO_JQL)
        };
        const queryReference = (0, $iWLL0.loadQuery)((0, $amu7D.default), (0, $1zgpM.default), variables, {
            fetchPolicy: 'network-only',
            networkCacheConfig: {
                metadata: {
                    META_SLOW_ENDPOINT: true
                }
            }
        });
        if (false && queryReference.id != null) await (0, $c7ifG.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});
const $32e9eef2b1613b8f$export$44ca3a0b25f38d83 = (0, $3HCkE.createResource)({
    type: `${(0, $buJlM.RELAY_RESOURCE_TYPE)}_${$32e9eef2b1613b8f$var$RESOURCE_TYPE_REQUEST_TAB_ISSUE_NAVIGATOR_FILTER_RELAY}`,
    getKey: ()=>'request-tab-issue-navigator-filter-relay',
    // @ts-expect-error - might return null
    getData: async (routerContext, { tenantContext: tenantContext })=>{
        // SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
        // the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
        if (false && tenantContext.isAnonymous) return null;
        let projectKey = '';
        // TO-DO handle the error throw here
        try {
            const response = await (0, $cWHXY.getLatestJSMProjectRequest)();
            projectKey = response?.values?.[0]?.key;
        } catch (error) {
            /* eslint-disable no-console */ console.log(error);
        }
        const { filter: filter } = (0, $jK0NH.getParams)(routerContext, projectKey);
        const includeFilter = Boolean(filter) && (0, $5as0a.isFilterId)(filter);
        const variables = {
            includeFilter: includeFilter,
            filterAri: includeFilter ? (0, $huI7r.createAri)({
                resourceOwner: 'jira',
                cloudId: tenantContext.cloudId,
                resourceType: 'filter',
                resourceId: filter,
                activationId: tenantContext.activationId
            }) : ''
        };
        const options = {
            fetchPolicy: includeFilter ? 'network-only' : 'store-only'
        };
        const queryReference = (0, $iWLL0.loadQuery)((0, $amu7D.default), (0, $k7wca.default), variables, options);
        if (false && queryReference.id != null) await (0, $c7ifG.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});

});
parcelRegister("jK0NH", function(module, exports) {

$parcel$export(module.exports, "getParams", () => $428dd4030ad3e04b$export$ec161d740909e39d);
$parcel$export(module.exports, "getJqlOrFilterId", () => $428dd4030ad3e04b$export$b968a035fc2aa57b);
// eslint-disable-next-line jira/import-whitelist

var $5as0a = parcelRequire("5as0a");

var $6vrw7 = parcelRequire("6vrw7");

var $f6ie2 = parcelRequire("f6ie2");
const $428dd4030ad3e04b$export$ec161d740909e39d = ({ match: { params: params }, query: query }, projectKey)=>{
    const { issueKey: issueKey } = params;
    const { filter: filter, jql: jql } = query;
    // Default JQL when no relevant query parameter is set
    const defaultJql = (0, $f6ie2.getDefaultJql)((0, $6vrw7.toProjectKey)(projectKey));
    return {
        page: 1,
        jql: jql,
        issueKey: issueKey,
        projectKey: projectKey,
        filter: filter,
        defaultJql: defaultJql
    };
};
const $428dd4030ad3e04b$export$b968a035fc2aa57b = (projectKey, defaultJql, jqlParam, filter)=>{
    // If JQL param has been defined (even if it's empty) we should use it
    if (typeof jqlParam === 'string') return {
        jql: jqlParam
    };
    // If filter is non-empty then use the filter parameter
    if (typeof filter === 'string' && filter !== '') {
        if ((0, $5as0a.isFilterId)(filter)) return {
            filterId: filter
        };
        const filterJql = (0, $f6ie2.mapFilterToJql)(projectKey, filter);
        if (filterJql !== undefined) return {
            jql: filterJql
        };
    }
    // Fallback to the default JQL if neither JQL or valid filter parameters have been provided.
    return {
        jql: defaultJql
    };
};

});

parcelRegister("cWHXY", function(module, exports) {

$parcel$export(module.exports, "getLatestJSMProjectRequest", () => $55c7a9f62022262f$export$9cbf5320d7abb785);
// eslint-disable-next-line jira/import-whitelist

var $53ciZ = parcelRequire("53ciZ");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $55c7a9f62022262f$export$9cbf5320d7abb785 = async ()=>{
    try {
        const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify({
            maxResults: '1',
            orderBy: 'lastIssueUpdatedTime',
            typeKey: 'service_desk'
        });
        const response = await (0, $lRmyA.performGetRequestWithRetry)(`/rest/api/3/project/search?${queryParams}`);
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // TO-DO rename the package name and get confirmation with @mantripat about error events
        (0, $guiFP.default)({
            meta: {
                id: 'getLatestJSMProjectRequest',
                packageName: 'jiraRouterResourcesSoftwareRequests'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});


parcelRegister("gCNEV", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('xCpYa')
        ]);
        const value = parcelRequire('fk9VJ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("xCpYa")
    ]).then(()=>parcelRequire('fk9VJ'));
}

});

parcelRegister("bU6C3", function(module, exports) {

$parcel$export(module.exports, "nextGenRoadmapResource", () => $ccc72973dcc1f122$export$2750f87d68dfb02a);

var $3HCkE = parcelRequire("3HCkE");


const $ccc72973dcc1f122$export$2750f87d68dfb02a = (0, $3HCkE.createResource)({
    type: (0, $1eef2c9e2260305d$export$75dfa03544a19422),
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>(parcelRequire("gpyhi")),
    // SSR doesn't care about this and we can't check FFs here because its not in the render path
    maxAge: 3600000,
    isBrowserOnly: true
});

});
parcelRegister("gpyhi", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('49NAr');
        const value = parcelRequire('1Ojjf');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("49NAr").then(()=>parcelRequire('1Ojjf'));
}

});


parcelRegister("gElxv", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('6mWL9')
        ]);
        const value = parcelRequire('3UDh4');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("6mWL9")
    ]).then(()=>parcelRequire('3UDh4'));
}

});

parcelRegister("llMVF", function(module, exports) {

$parcel$export(module.exports, "versionDetailsRelayResourceCustom", () => $560cab3ebfc1480f$export$c56c5b19da4d0fd1);
/* eslint-disable jira/import-whitelist */ 
var $iWLL0 = parcelRequire("iWLL0");

var $1ybV0 = parcelRequire("1ybV0");

var $huI7r = parcelRequire("huI7r");

var $amu7D = parcelRequire("amu7D");

var $c7ifG = parcelRequire("c7ifG");

var $buJlM = parcelRequire("buJlM");

var $cos6r = parcelRequire("cos6r");

var $3HCkE = parcelRequire("3HCkE");

var $yyqSx = parcelRequire("yyqSx");

var $ephMr = parcelRequire("ephMr");

var $bhwgQ = parcelRequire("bhwgQ");

const $560cab3ebfc1480f$export$c56c5b19da4d0fd1 = (0, $3HCkE.createResource)({
    type: `${(0, $buJlM.RELAY_RESOURCE_TYPE)}_${(0, $11142c5c2c8d869a$export$9fe575a15a87a796)}`,
    // Deliberately returning the static key, not to rerun query by resource, as different key returns null queryReference shortly while the query is running, when filter query parameter is changed,
    // which is believed to be a bug in react-resource-router part, but we don't know the reason yet.
    // Context: https://atlassian.slack.com/archives/CFLN3FEF8/p1680495188086669
    // Due to the same bug, issue navigator team is doing the similar technique: src/packages/routes/src/ui/spa/issue-navigator/resources/index.tsx
    getKey: ({ match: match })=>{
        const { versionId: versionId } = match.params;
        const parsedVersionId = String(versionId ?? '').replace(/\D/g, '');
        return `jsw-releases-version-details-main-query-relay-${parsedVersionId}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const { versionId: versionId } = match.params;
        const { filters: filters, sortBy: sortBy } = (0, $ephMr.toVersionIssuesGraphQLVariables)(query);
        const parsedVersionId = String(versionId ?? '').replace(/\D/g, '');
        const variables = {
            cloudAri: (0, $huI7r.createAri)({
                resourceOwner: 'jira',
                resourceType: 'site',
                resourceId: tenantContext.cloudId
            }),
            versionAri: (0, $huI7r.createAri)({
                resourceOwner: 'jira',
                cloudId: tenantContext.cloudId,
                resourceType: 'version/activation',
                resourceId: String(`${tenantContext.activationId}/${parsedVersionId}`)
            }),
            sortBy: sortBy,
            filters: filters,
            skip: !(0, $bhwgQ.checkAuthentication)(tenantContext) || parsedVersionId.length === 0,
            isDevopsFeatureDisabledInFedRamp: (0, $yyqSx.isDevopsFeatureDisabledInFedRamp)(),
            isRichTextSectionEnabled: (0, $1ybV0.ff)('enable-rich-text-editing-for-release-description_pc1b3')
        };
        const queryReference = (0, $iWLL0.loadQuery)((0, $amu7D.default), (0, $cos6r.default), variables, {
            fetchPolicy: 'store-or-network'
        });
        if (false && queryReference.id != null) await (0, $c7ifG.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});

});
parcelRegister("cos6r", function(module, exports) {

$parcel$export(module.exports, "default", () => $92e804c99683d4bc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4ea782e82cd464453c874585df99876d>>
 * @relayHash 22346a72666d0b2cf3aa9045576e503d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 800b7c81d8cdd57eeb185896a2dcadecd7f4647988840bdd0ddfbabcae088ce8
const $92e804c99683d4bc$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filters"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDevopsFeatureDisabledInFedRamp"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isRichTextSectionEnabled"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skip"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortBy"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionAri"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "versionAri"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "status"
    }, v11 = {
        "kind": "ScalarField",
        "name": "id"
    }, v12 = [
        v8 /*: any*/ ,
        v11 /*: any*/ 
    ], v13 = {
        "kind": "ScalarField",
        "name": "collapsedUis"
    }, v14 = {
        "kind": "Literal",
        "name": "filter",
        "value": "ALL"
    }, v15 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v16 = [
        v15 /*: any*/ 
    ], v17 = {
        "kind": "ScalarField",
        "name": "canEdit"
    }, v18 = {
        "kind": "ScalarField",
        "name": "key"
    }, v19 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v20 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v21 = {
        "kind": "ScalarField",
        "name": "description"
    }, v22 = [
        v14 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "filters",
            "variableName": "filters"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        },
        {
            "kind": "Variable",
            "name": "sortBy",
            "variableName": "sortBy"
        }
    ], v23 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v24 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "statusCategoryId"
            },
            v11 /*: any*/ 
        ]
    }, v25 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            v20 /*: any*/ ,
            v9 /*: any*/ ,
            v11 /*: any*/ 
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "count"
    }, v27 = {
        "kind": "ScalarField",
        "name": "category"
    }, v28 = {
        "kind": "ScalarField",
        "name": "state"
    }, v29 = [
        v26 /*: any*/ 
    ], v30 = {
        "kind": "ScalarField",
        "name": "title"
    }, v31 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v32 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v33 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 100
        }
    ], v34 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "AtlassianAccountUserExtendedProfile",
                "kind": "LinkedField",
                "name": "extendedProfile",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jobTitle"
                    }
                ]
            }
        ],
        "type": "AtlassianAccountUser"
    }, v35 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v36 = {
        "kind": "ClientExtension",
        "selections": [
            v35 /*: any*/ 
        ]
    }, v37 = {
        "kind": "ScalarField",
        "name": "url"
    }, v38 = {
        "kind": "ScalarField",
        "name": "relatedWorkId"
    }, v39 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "issue",
        "plural": false,
        "selections": [
            v18 /*: any*/ ,
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "ids",
                        "value": [
                            "assignee",
                            "status"
                        ]
                    }
                ],
                "concreteType": "JiraIssueFieldConnection",
                "kind": "LinkedField",
                "name": "fieldsById",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v8 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v23 /*: any*/ ,
                                            {
                                                "concreteType": "JiraStatus",
                                                "kind": "LinkedField",
                                                "name": "status",
                                                "plural": false,
                                                "selections": [
                                                    v9 /*: any*/ ,
                                                    v24 /*: any*/ ,
                                                    v11 /*: any*/ 
                                                ]
                                            }
                                        ],
                                        "type": "JiraStatusField"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v23 /*: any*/ ,
                                            v25 /*: any*/ 
                                        ],
                                        "type": "JiraSingleSelectUserPickerField"
                                    },
                                    v11 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "fieldsById(ids:[\"assignee\",\"status\"])"
            }
        ]
    }, v40 = {
        "kind": "ClientExtension",
        "selections": [
            v35 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "isSaving"
            }
        ]
    }, v41 = {
        "kind": "InlineFragment",
        "selections": [
            v36 /*: any*/ 
        ],
        "type": "JiraVersionRelatedWorkConfluenceReleaseNotes"
    }, v42 = {
        "kind": "InlineFragment",
        "selections": [
            v39 /*: any*/ ,
            v41 /*: any*/ ,
            v40 /*: any*/ 
        ],
        "type": "JiraVersionRelatedWorkV2",
        "abstractKey": "__isJiraVersionRelatedWorkV2"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "uiVersionDetailsQuery",
            "selections": [
                {
                    "concreteType": "DevOps",
                    "kind": "LinkedField",
                    "name": "devOps",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "ui_softwareReleasesVersionDetail_VersionDetailInner_devOps"
                        }
                    ]
                },
                {
                    "condition": "skip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v7 /*: any*/ ,
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "ui_softwareReleasesVersionDetail_VersionDetailInner_jiraVersion"
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "accessCheck_softwareReleasesVersionDetail"
                                                        }
                                                    ],
                                                    "type": "JiraVersion"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.version"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v6 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "uiVersionDetailsQuery",
            "selections": [
                {
                    "concreteType": "DevOps",
                    "kind": "LinkedField",
                    "name": "devOps",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isDevopsFeatureDisabledInFedRamp",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "cloudAri"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "providerTypes",
                                            "value": [
                                                "DESIGN"
                                            ]
                                        }
                                    ],
                                    "concreteType": "DevOpsProviders",
                                    "kind": "LinkedField",
                                    "name": "providers",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "DevOpsDesignProvider",
                                            "kind": "LinkedField",
                                            "name": "designProviders",
                                            "plural": true,
                                            "selections": v12 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "skip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v7 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canAddAndRemoveIssues"
                                                },
                                                v13 /*: any*/ ,
                                                {
                                                    "alias": "allIssues",
                                                    "args": [
                                                        v14 /*: any*/ 
                                                    ],
                                                    "concreteType": "JiraIssueConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issues",
                                                    "plural": false,
                                                    "selections": v16 /*: any*/ ,
                                                    "storageKey": "issues(filter:\"ALL\")"
                                                },
                                                v17 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "startDate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "releaseDate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "versionId"
                                                },
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "project",
                                                    "plural": false,
                                                    "selections": [
                                                        v18 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cloudId"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraVersionDriverResult",
                                                    "kind": "LinkedField",
                                                    "name": "driverData",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "driver",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                v19 /*: any*/ ,
                                                                v9 /*: any*/ ,
                                                                v20 /*: any*/ ,
                                                                v11 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "QueryError",
                                                            "kind": "LinkedField",
                                                            "name": "queryError",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "message"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v21 /*: any*/ ,
                                                v13 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraVersionWarningConfig",
                                                    "kind": "LinkedField",
                                                    "name": "warningConfig",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "openPullRequest"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "openReview"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "unreviewedCode"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "failingBuild"
                                                        },
                                                        v17 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraVersionConnectAddonIframeData",
                                                    "kind": "LinkedField",
                                                    "name": "connectAddonIframeData",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "appKey"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "moduleKey"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "appName"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "location"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "options"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "alias": "doneIssuesRedesignTemp",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "filters",
                                                            "value": {
                                                                "statusCategories": [
                                                                    "DONE"
                                                                ]
                                                            }
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issues",
                                                    "plural": false,
                                                    "selections": v16 /*: any*/ ,
                                                    "storageKey": "issues(filters:{\"statusCategories\":[\"DONE\"]})"
                                                },
                                                {
                                                    "alias": "inProgressIssuesRedesignTemp",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "filters",
                                                            "value": {
                                                                "statusCategories": [
                                                                    "IN_PROGRESS"
                                                                ]
                                                            }
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issues",
                                                    "plural": false,
                                                    "selections": v16 /*: any*/ ,
                                                    "storageKey": "issues(filters:{\"statusCategories\":[\"IN_PROGRESS\"]})"
                                                },
                                                {
                                                    "alias": "todoIssuesRedesignTemp",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "filters",
                                                            "value": {
                                                                "statusCategories": [
                                                                    "TODO"
                                                                ]
                                                            }
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issues",
                                                    "plural": false,
                                                    "selections": v16 /*: any*/ ,
                                                    "storageKey": "issues(filters:{\"statusCategories\":[\"TODO\"]})"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "warningsCount"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canViewDevTools"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "versionIssueTableHiddenColumns"
                                                },
                                                {
                                                    "alias": "issuesForList",
                                                    "args": v22 /*: any*/ ,
                                                    "concreteType": "JiraIssueConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issues",
                                                    "plural": false,
                                                    "selections": [
                                                        v15 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "jql"
                                                        },
                                                        {
                                                            "concreteType": "JiraIssueEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v18 /*: any*/ ,
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "ids",
                                                                                    "value": [
                                                                                        "priority",
                                                                                        "summary",
                                                                                        "assignee",
                                                                                        "status",
                                                                                        "issuetype"
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldsById",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v8 /*: any*/ ,
                                                                                                v23 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraStatus",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "status",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v24 /*: any*/ ,
                                                                                                                v11 /*: any*/ ,
                                                                                                                v9 /*: any*/ ,
                                                                                                                v21 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraStatusField"
                                                                                                },
                                                                                                v11 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "text"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v9 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraAvatar",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "avatar",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "xsmall"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v11 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraPriority",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "priority",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v9 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "iconUrl"
                                                                                                                },
                                                                                                                v11 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraPriorityField"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "issueId"
                                                                        },
                                                                        v8 /*: any*/ ,
                                                                        {
                                                                            "condition": "isDevopsFeatureDisabledInFedRamp",
                                                                            "kind": "Condition",
                                                                            "passingValue": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "DevOpsSummarisedEntities",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "devOpsSummarisedEntities",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "DevOpsSummarisedDeployments",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "summarisedDeployments",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v26 /*: any*/ ,
                                                                                                v11 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "DevOpsEnvironment",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "deploymentEnvironment",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "deploymentState"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "DevOpsSummarisedBuilds",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "summarisedBuilds",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v26 /*: any*/ ,
                                                                                                v11 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "DevOpsSummarisedBuildState",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "buildStates",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        v26 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "DevOpsSummarisedFeatureFlags",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "summarisedFeatureFlags",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v15 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "mostRelevantDisplayName"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "mostRelevantEnabled"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "mostRelevantRolloutPercentage"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraIssueDevSummaryResult",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "devSummaryCache",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "devSummary",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "pullrequest",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssuePullRequestDevSummary",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "overall",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v26 /*: any*/ ,
                                                                                                                v28 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraIssueBranchDevSummaryContainer",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "branch",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueBranchDevSummary",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "overall",
                                                                                                            "plural": false,
                                                                                                            "selections": v29 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "review",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueReviewDevSummary",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "overall",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v26 /*: any*/ ,
                                                                                                                v28 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "lastUpdated"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "stateCount"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueDevSummaryByProvider",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "summaryByProvider",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "providerId"
                                                                                                                },
                                                                                                                v9 /*: any*/ ,
                                                                                                                v26 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "commit",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueCommitDevSummary",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "overall",
                                                                                                            "plural": false,
                                                                                                            "selections": v29 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "build",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueBuildDevSummary",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "overall",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v26 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "failedBuildCount"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "successfulBuildCount"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "unknownBuildCount"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "deploymentEnvironments",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "overall",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueDeploymentEnvironment",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "topEnvironments",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        v10 /*: any*/ ,
                                                                                                                        v30 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v31 /*: any*/ 
                                                            ]
                                                        },
                                                        v32 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "alias": "issuesForList",
                                                    "args": v22 /*: any*/ ,
                                                    "filters": [
                                                        "filter",
                                                        "sortBy",
                                                        "filters"
                                                    ],
                                                    "handle": "connection",
                                                    "key": "ListVersion_issuesForList",
                                                    "kind": "LinkedHandle",
                                                    "name": "issues"
                                                },
                                                {
                                                    "alias": "allIssuesRedesignTemp",
                                                    "concreteType": "JiraIssueConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issues",
                                                    "plural": false,
                                                    "selections": v16 /*: any*/ 
                                                },
                                                {
                                                    "args": v33 /*: any*/ ,
                                                    "concreteType": "JiraVersionApproverConnection",
                                                    "kind": "LinkedField",
                                                    "name": "approvers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraVersionApproverEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraVersionApprover",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "user",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                v9 /*: any*/ ,
                                                                                v20 /*: any*/ ,
                                                                                v34 /*: any*/ ,
                                                                                v11 /*: any*/ ,
                                                                                v19 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v10 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "declineReason"
                                                                        },
                                                                        v21 /*: any*/ ,
                                                                        v36 /*: any*/ ,
                                                                        v8 /*: any*/ 
                                                                    ]
                                                                },
                                                                v31 /*: any*/ 
                                                            ]
                                                        },
                                                        v32 /*: any*/ 
                                                    ],
                                                    "storageKey": "approvers(first:100)"
                                                },
                                                {
                                                    "args": v33 /*: any*/ ,
                                                    "handle": "connection",
                                                    "key": "version_approvers",
                                                    "kind": "LinkedHandle",
                                                    "name": "approvers"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canViewVersionDetailsPage"
                                                },
                                                {
                                                    "condition": "isDevopsFeatureDisabledInFedRamp",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraProject",
                                                            "kind": "LinkedField",
                                                            "name": "project",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasReleaseNote"
                                                        },
                                                        {
                                                            "concreteType": "JiraVersionContributorConnection",
                                                            "kind": "LinkedField",
                                                            "name": "contributors",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraVersionContributorEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                v11 /*: any*/ ,
                                                                                v9 /*: any*/ ,
                                                                                v20 /*: any*/ ,
                                                                                v34 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "args": v33 /*: any*/ ,
                                                            "concreteType": "JiraVersionRelatedWorkV2Connection",
                                                            "kind": "LinkedField",
                                                            "name": "relatedWorkV2",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraVersionRelatedWorkV2Edge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v8 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                {
                                                                                    "kind": "TypeDiscriminator",
                                                                                    "abstractKey": "__isJiraVersionRelatedWorkV2"
                                                                                },
                                                                                v27 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraIssue",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issue",
                                                                                    "plural": false,
                                                                                    "selections": v12 /*: any*/ 
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v37 /*: any*/ ,
                                                                                        v38 /*: any*/ ,
                                                                                        v30 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v39 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v40 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraVersionRelatedWorkV2",
                                                                                                            "abstractKey": "__isJiraVersionRelatedWorkV2"
                                                                                                        },
                                                                                                        v36 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraVersionRelatedWorkGenericLink"
                                                                                                },
                                                                                                v41 /*: any*/ ,
                                                                                                v40 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraVersionRelatedWorkV2",
                                                                                            "abstractKey": "__isJiraVersionRelatedWorkV2"
                                                                                        },
                                                                                        v36 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraVersionRelatedWorkGenericLink"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v38 /*: any*/ ,
                                                                                        v37 /*: any*/ ,
                                                                                        v30 /*: any*/ ,
                                                                                        v42 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraVersionRelatedWorkConfluenceReleaseNotes"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v30 /*: any*/ ,
                                                                                        v42 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraVersionRelatedWorkNativeReleaseNotes"
                                                                                },
                                                                                v36 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v31 /*: any*/ 
                                                                    ]
                                                                },
                                                                v32 /*: any*/ 
                                                            ],
                                                            "storageKey": "relatedWorkV2(first:100)"
                                                        },
                                                        {
                                                            "args": v33 /*: any*/ ,
                                                            "handle": "connection",
                                                            "key": "version_relatedWorkV2",
                                                            "kind": "LinkedHandle",
                                                            "name": "relatedWorkV2"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "canEditRelatedWork"
                                                        },
                                                        {
                                                            "concreteType": "DevOpsSummarisedEntities",
                                                            "kind": "LinkedField",
                                                            "name": "devOpsSummarisedEntities",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "DevOpsProviders",
                                                                    "kind": "LinkedField",
                                                                    "name": "providers",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "DevOpsFeatureFlagProvider",
                                                                            "kind": "LinkedField",
                                                                            "name": "featureFlagProviders",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                v11 /*: any*/ ,
                                                                                v9 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "createFeatureFlagTemplateUrl"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "connectFeatureFlagTemplateUrl"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "logoUrl"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v36 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "condition": "isRichTextSectionEnabled",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraVersionRichTextSection",
                                                            "kind": "LinkedField",
                                                            "name": "richTextSection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraADF",
                                                                    "kind": "LinkedField",
                                                                    "name": "content",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "json"
                                                                        }
                                                                    ]
                                                                },
                                                                v30 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v36 /*: any*/ 
                                            ],
                                            "type": "JiraVersion"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v11 /*: any*/ 
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "800b7c81d8cdd57eeb185896a2dcadecd7f4647988840bdd0ddfbabcae088ce8",
            "metadata": {},
            "name": "uiVersionDetailsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$92e804c99683d4bc$var$node.hash = "9cc52a8217769e3e972feba3d6b023c5";
var $92e804c99683d4bc$export$2e2bcd8739ae039 = $92e804c99683d4bc$var$node;

});

parcelRegister("ephMr", function(module, exports) {

$parcel$export(module.exports, "toVersionIssuesGraphQLVariables", () => $1d70d3310ffc0569$export$72df1c7780b3e8e2);
$parcel$export(module.exports, "useVersionIssuesGraphQLVariables", () => $1d70d3310ffc0569$export$3d12d3ffbce57135);

var $iclz4 = parcelRequire("iclz4");


var $lzE4a = parcelRequire("lzE4a");

var $hTGN1 = parcelRequire("hTGN1");
const $1d70d3310ffc0569$var$accountIdToAriStr = (accountIds)=>{
    if (accountIds == null) return null;
    return accountIds.map((accountId)=>accountId === 'UNASSIGNED' ? null : `ari:cloud:identity::user/${accountId}`);
};
const $1d70d3310ffc0569$export$72df1c7780b3e8e2 = (queryParams)=>{
    const parsedQueryParams = (0, $hTGN1.parseQueryParams)(queryParams);
    return {
        filters: {
            searchStr: parsedQueryParams[0, $d7c1ea1e2a683c50$export$e39925d10cebc0b] ?? null,
            epicIds: parsedQueryParams[0, $d7c1ea1e2a683c50$export$b98a7875ddbefaac] ?? null,
            statusCategories: parsedQueryParams[0, $d7c1ea1e2a683c50$export$c307007520232013] != null ? parsedQueryParams[0, $d7c1ea1e2a683c50$export$c307007520232013].filter((0, $lzE4a.isVersionStatusCategory)) : null,
            warningCategories: parsedQueryParams[0, $d7c1ea1e2a683c50$export$2552faed9df6a2cd] ?? null,
            assigneeAccountIds: $1d70d3310ffc0569$var$accountIdToAriStr(parsedQueryParams[0, $d7c1ea1e2a683c50$export$f78d8c81fcad32a2])
        },
        sortBy: {
            sortByField: parsedQueryParams[0, $d7c1ea1e2a683c50$export$13d5b2891ca65cd6] ?? 'CREATED',
            order: parsedQueryParams[0, $d7c1ea1e2a683c50$export$810a1f7ed2facfcb] ?? 'ASC'
        }
    };
};
const $1d70d3310ffc0569$export$3d12d3ffbce57135 = ()=>{
    const [queryParams] = (0, $iclz4.useQueryParams)((0, $d7c1ea1e2a683c50$export$e39925d10cebc0b), (0, $d7c1ea1e2a683c50$export$b98a7875ddbefaac), (0, $d7c1ea1e2a683c50$export$c307007520232013), (0, $d7c1ea1e2a683c50$export$2552faed9df6a2cd), (0, $d7c1ea1e2a683c50$export$f78d8c81fcad32a2), (0, $d7c1ea1e2a683c50$export$13d5b2891ca65cd6), (0, $d7c1ea1e2a683c50$export$810a1f7ed2facfcb));
    return $1d70d3310ffc0569$export$72df1c7780b3e8e2(queryParams);
};

});
parcelRegister("iclz4", function(module, exports) {

$parcel$export(module.exports, "useQueryParams", () => $88391ae3fc882e87$export$b37ee0d76c6d2fbc);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $ldoFd = parcelRequire("ldoFd");

var $i7Fym = parcelRequire("i7Fym");

var $53ciZ = parcelRequire("53ciZ");

var $kJlBc = parcelRequire("kJlBc");
const $88391ae3fc882e87$export$b37ee0d76c6d2fbc = (...queryParamsToWatch)=>{
    const [{ location: { pathname: pathname }, query: query }, { push: push, replace: replace }] = (0, $kJlBc.useRouter)();
    const queryParamsRef = (0, $eUqFw.useRef)({});
    const parsedQueryParams = (0, $eUqFw.useMemo)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newQueryParams = queryParamsToWatch.reduce((accumulator, currentValue)=>{
            accumulator[currentValue] = query[currentValue] || undefined;
            return accumulator;
        }, {});
        // update cache only when one of requested params actually changed
        // otherwise return cached value to avoid changing return object reference
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(queryParamsRef.current, newQueryParams)) queryParamsRef.current = newQueryParams;
        return queryParamsRef.current;
    }, [
        query,
        queryParamsToWatch
    ]);
    const setQueryParams = (0, $eUqFw.useCallback)((newQueryParams, options)=>{
        const parsedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($i7Fym)))({
            ...query,
            ...newQueryParams
        }, (value)=>(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(value));
        const { updateType: updateType, ...stringifyOptions } = options ?? {};
        // @ts-expect-error - TS2559 - Type '{ sort?: false | ((a: string, b: string) => number) | undefined; }' has no properties in common with type 'StringifyOptions'.
        const strSearch = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(parsedSearch, stringifyOptions);
        const url = pathname + (strSearch !== '' ? `?${strSearch}` : '');
        updateType === 'replace' ? replace(url) : push(url);
    }, [
        pathname,
        push,
        replace,
        query
    ]);
    return [
        parsedQueryParams,
        setQueryParams
    ];
};

});

const $d7c1ea1e2a683c50$export$e39925d10cebc0b = 'text';
const $d7c1ea1e2a683c50$export$b98a7875ddbefaac = 'epics';
const $d7c1ea1e2a683c50$export$c307007520232013 = 'statusCategory';
const $d7c1ea1e2a683c50$export$2552faed9df6a2cd = 'warnings';
const $d7c1ea1e2a683c50$export$f78d8c81fcad32a2 = 'assignee';
const $d7c1ea1e2a683c50$export$13d5b2891ca65cd6 = 'sortBy';
const $d7c1ea1e2a683c50$export$810a1f7ed2facfcb = 'sortOrder';

parcelRegister("lzE4a", function(module, exports) {

$parcel$export(module.exports, "isWarningsFilterValue", () => $43d67a39ab52f8bc$export$5c25bcf27380084);
$parcel$export(module.exports, "toWarningsFilterValue", () => $43d67a39ab52f8bc$export$ac3017cd78edb8a1);
$parcel$export(module.exports, "isVersionStatusCategory", () => $43d67a39ab52f8bc$export$3af93bbba0d4241a);
$parcel$export(module.exports, "isSortBy", () => $43d67a39ab52f8bc$export$472650e4cbd40b70);
$parcel$export(module.exports, "isSortOrder", () => $43d67a39ab52f8bc$export$dfece8cb679d32a3);

var $8Qd0L = parcelRequire("8Qd0L");
const $43d67a39ab52f8bc$export$5c25bcf27380084 = (val)=>val === 'OPEN_PULL_REQUEST' || val === 'UNREVIEWED_CODE' || val === 'FAILING_BUILD' || val === 'OPEN_REVIEW';
const $43d67a39ab52f8bc$export$ac3017cd78edb8a1 = (statusCategoryFromQueryParam)=>statusCategoryFromQueryParam.filter($43d67a39ab52f8bc$export$5c25bcf27380084);
const $43d67a39ab52f8bc$export$3af93bbba0d4241a = (val)=>val === (0, $8Qd0L.TODO) || val === (0, $8Qd0L.IN_PROGRESS) || val === (0, $8Qd0L.DONE);
const $43d67a39ab52f8bc$export$472650e4cbd40b70 = (val)=>val === 'ASSIGNEE' || val === 'CREATED' || val === 'KEY' || val === 'PRIORITY' || val === 'STATUS' || val === 'TYPE';
const $43d67a39ab52f8bc$export$dfece8cb679d32a3 = (val)=>val === 'ASC' || val === 'DESC';

});
parcelRegister("8Qd0L", function(module, exports) {

$parcel$export(module.exports, "UNDEFINED", () => $e7c4cf297fb3917f$export$6db089fe7b26f5b6);
$parcel$export(module.exports, "TODO", () => $e7c4cf297fb3917f$export$aa456a5030160740);
$parcel$export(module.exports, "IN_PROGRESS", () => $e7c4cf297fb3917f$export$5a9ac66c2785cc13);
$parcel$export(module.exports, "DONE", () => $e7c4cf297fb3917f$export$71efb3495f6084f2);
$parcel$export(module.exports, "STATUS_CATEGORIES", () => $e7c4cf297fb3917f$export$d9119300f9d9a815);
$parcel$export(module.exports, "StatusCategoryTypes", () => $e7c4cf297fb3917f$export$5d42a08d46cffe7);
$parcel$export(module.exports, "StatusCategoryIds", () => $e7c4cf297fb3917f$export$3f42f49c284d5b58);
$parcel$export(module.exports, "statusCategoryKeys", () => $e7c4cf297fb3917f$export$f3f919dc0f56d9eb);
$parcel$export(module.exports, "statusCategoryForId", () => $e7c4cf297fb3917f$export$3e9e3002956ff4fb);
$parcel$export(module.exports, "categoryIdForStatusCategory", () => $e7c4cf297fb3917f$export$7b16b0022aac2d46);
$parcel$export(module.exports, "isValidStatusCategoryKey", () => $e7c4cf297fb3917f$export$d928f247c903643a);
const $e7c4cf297fb3917f$export$6db089fe7b26f5b6 = 'UNDEFINED';
const $e7c4cf297fb3917f$export$aa456a5030160740 = 'TODO';
const $e7c4cf297fb3917f$export$5a9ac66c2785cc13 = 'IN_PROGRESS';
const $e7c4cf297fb3917f$export$71efb3495f6084f2 = 'DONE';
const $e7c4cf297fb3917f$export$d9119300f9d9a815 = [
    $e7c4cf297fb3917f$export$6db089fe7b26f5b6,
    $e7c4cf297fb3917f$export$aa456a5030160740,
    $e7c4cf297fb3917f$export$5a9ac66c2785cc13,
    $e7c4cf297fb3917f$export$71efb3495f6084f2
];
const $e7c4cf297fb3917f$var$statusCategories = [
    {
        id: '1',
        statusCategory: $e7c4cf297fb3917f$export$6db089fe7b26f5b6
    },
    {
        id: '2',
        statusCategory: $e7c4cf297fb3917f$export$aa456a5030160740
    },
    {
        id: '4',
        statusCategory: $e7c4cf297fb3917f$export$5a9ac66c2785cc13
    },
    {
        id: '3',
        statusCategory: $e7c4cf297fb3917f$export$71efb3495f6084f2
    }
];
const $e7c4cf297fb3917f$export$5d42a08d46cffe7 = Object.freeze({
    NEW: 'new',
    INDETERMINATE: 'indeterminate',
    DONE: 'done',
    UNDEFINED: 'undefined'
});
const $e7c4cf297fb3917f$export$3f42f49c284d5b58 = Object.freeze({
    [$e7c4cf297fb3917f$export$5d42a08d46cffe7.UNDEFINED]: 1,
    [$e7c4cf297fb3917f$export$5d42a08d46cffe7.NEW]: 2,
    [$e7c4cf297fb3917f$export$5d42a08d46cffe7.DONE]: 3,
    [$e7c4cf297fb3917f$export$5d42a08d46cffe7.INDETERMINATE]: 4
});
const $e7c4cf297fb3917f$export$f3f919dc0f56d9eb = Object.values($e7c4cf297fb3917f$export$5d42a08d46cffe7);
const $e7c4cf297fb3917f$export$3e9e3002956ff4fb = (statusCategoryId)=>{
    const value = $e7c4cf297fb3917f$var$statusCategories.find((sc)=>sc.id === String(statusCategoryId));
    return value ? value.statusCategory : $e7c4cf297fb3917f$export$6db089fe7b26f5b6;
};
const $e7c4cf297fb3917f$export$7b16b0022aac2d46 = (statusCategory)=>{
    const value = $e7c4cf297fb3917f$var$statusCategories.find((sc)=>sc.statusCategory === statusCategory);
    return Number(value ? value.id : '1');
};
const $e7c4cf297fb3917f$export$d928f247c903643a = (key)=>$e7c4cf297fb3917f$export$f3f919dc0f56d9eb.some((statusCategoryKey)=>statusCategoryKey === key);

});


parcelRegister("hTGN1", function(module, exports) {

$parcel$export(module.exports, "isAnyFilterApplied", () => $22cfabd4be67fcf4$export$e6b3ec1d09429da8);
$parcel$export(module.exports, "parseQueryParams", () => $22cfabd4be67fcf4$export$67c4cee80a3410cd);

var $6vrw7 = parcelRequire("6vrw7");


var $lzE4a = parcelRequire("lzE4a");
const $22cfabd4be67fcf4$export$e6b3ec1d09429da8 = (parsedQueryParams)=>parsedQueryParams[0, $d7c1ea1e2a683c50$export$e39925d10cebc0b] != null && parsedQueryParams[0, $d7c1ea1e2a683c50$export$e39925d10cebc0b].length > 0 || parsedQueryParams[0, $d7c1ea1e2a683c50$export$b98a7875ddbefaac] != null && parsedQueryParams[0, $d7c1ea1e2a683c50$export$b98a7875ddbefaac].length > 0 || parsedQueryParams[0, $d7c1ea1e2a683c50$export$c307007520232013] != null && parsedQueryParams[0, $d7c1ea1e2a683c50$export$c307007520232013].length > 0 || parsedQueryParams[0, $d7c1ea1e2a683c50$export$2552faed9df6a2cd] != null && parsedQueryParams[0, $d7c1ea1e2a683c50$export$2552faed9df6a2cd].length > 0 || parsedQueryParams[0, $d7c1ea1e2a683c50$export$f78d8c81fcad32a2] != null && parsedQueryParams[0, $d7c1ea1e2a683c50$export$f78d8c81fcad32a2].length > 0;
const $22cfabd4be67fcf4$export$2a2e94972ab280d4 = (paramValue)=>paramValue == null ? undefined : paramValue.split(',').map((str)=>str.trim()).map((0, $6vrw7.toIssueId));
const $22cfabd4be67fcf4$export$fb136b568c6d78b5 = (paramValue)=>paramValue == null ? undefined : paramValue.split(',').map((str)=>str.trim()).filter((0, $lzE4a.isVersionStatusCategory));
const $22cfabd4be67fcf4$export$5cb324c621ca24e8 = (paramValue)=>paramValue == null ? undefined : (0, $lzE4a.toWarningsFilterValue)(paramValue.split(',').map((str)=>str.trim()));
const $22cfabd4be67fcf4$export$6c8eda0352c7cf5 = (paramValue)=>paramValue == null ? undefined : paramValue.split(',').map((str)=>(0, $6vrw7.toAccountId)(str.trim()));
const $22cfabd4be67fcf4$export$67c4cee80a3410cd = (paramsRaw)=>{
    const result = {};
    result[0, $d7c1ea1e2a683c50$export$e39925d10cebc0b] = paramsRaw[0, $d7c1ea1e2a683c50$export$e39925d10cebc0b];
    result[0, $d7c1ea1e2a683c50$export$b98a7875ddbefaac] = $22cfabd4be67fcf4$export$2a2e94972ab280d4(paramsRaw[0, $d7c1ea1e2a683c50$export$b98a7875ddbefaac]);
    result[0, $d7c1ea1e2a683c50$export$c307007520232013] = $22cfabd4be67fcf4$export$fb136b568c6d78b5(paramsRaw[0, $d7c1ea1e2a683c50$export$c307007520232013]);
    result[0, $d7c1ea1e2a683c50$export$2552faed9df6a2cd] = $22cfabd4be67fcf4$export$5cb324c621ca24e8(paramsRaw[0, $d7c1ea1e2a683c50$export$2552faed9df6a2cd]);
    result[0, $d7c1ea1e2a683c50$export$f78d8c81fcad32a2] = $22cfabd4be67fcf4$export$6c8eda0352c7cf5(paramsRaw[0, $d7c1ea1e2a683c50$export$f78d8c81fcad32a2]);
    result[0, $d7c1ea1e2a683c50$export$13d5b2891ca65cd6] = paramsRaw[0, $d7c1ea1e2a683c50$export$13d5b2891ca65cd6] && (0, $lzE4a.isSortBy)(paramsRaw[0, $d7c1ea1e2a683c50$export$13d5b2891ca65cd6]) ? paramsRaw[0, $d7c1ea1e2a683c50$export$13d5b2891ca65cd6] : 'CREATED';
    result[0, $d7c1ea1e2a683c50$export$810a1f7ed2facfcb] = paramsRaw[0, $d7c1ea1e2a683c50$export$810a1f7ed2facfcb] && (0, $lzE4a.isSortOrder)(paramsRaw[0, $d7c1ea1e2a683c50$export$810a1f7ed2facfcb]) ? paramsRaw[0, $d7c1ea1e2a683c50$export$810a1f7ed2facfcb] : 'ASC';
    return result;
};

});


const $11142c5c2c8d869a$export$9fe575a15a87a796 = 'PROJECTS_VERSION_DETAILS';


parcelRegister("73beW", function(module, exports) {

$parcel$export(module.exports, "softwareVersionDetailRoute", () => $53dd1741f2bcaed6$export$eb3633614d0521b0);

var $exb0h = parcelRequire("exb0h");
const $53dd1741f2bcaed6$export$eb3633614d0521b0 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_VERSION_DETAIL,
    path: '/projects/:projectKey/versions/:versionId/tab/:tab',
    ufoName: 'software.version-details-page'
};
const $53dd1741f2bcaed6$export$f22288f2d2f1b9ea = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_VERSION_DETAIL_NO_TAB_PATH,
    path: '/projects/:projectKey/versions/:versionId'
};
const $53dd1741f2bcaed6$export$3fc8dbcec208bca0 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_VERSION_DETAIL_LEGACY_REDIRECT,
    path: '/browse/:projectKey/fixforversion/:versionId'
};

});

parcelRegister("5Stjx", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('dHRnN')
        ]);
        const value = parcelRequire('ko4Vl');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("dHRnN")
    ]).then(()=>parcelRequire('ko4Vl'));
}

});

parcelRegister("c561s", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('a71wv');
        const value = parcelRequire('gEz89');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("a71wv").then(()=>parcelRequire('gEz89'));
}

});

parcelRegister("cZKjw", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('3VVKz');
        const value = parcelRequire('1x6xR');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("3VVKz").then(()=>parcelRequire('1x6xR'));
}

});

parcelRegister("9zMbV", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('iYWpJ');
        const value = parcelRequire('9899P');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("iYWpJ").then(()=>parcelRequire('9899P'));
}

});

parcelRegister("RkzV7", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('4jfTg');
        const value = parcelRequire('dU9l0');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("4jfTg").then(()=>parcelRequire('dU9l0'));
}

});

parcelRegister("4ISF0", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('aLvWz');
        const value = parcelRequire('hq0yf');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("aLvWz").then(()=>parcelRequire('hq0yf'));
}

});

parcelRegister("63C48", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('dmiTz')
        ]);
        const value = parcelRequire('d6Su9');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("dmiTz")
    ]).then(()=>parcelRequire('d6Su9'));
}

});

parcelRegister("1TkEB", function(module, exports) {

$parcel$export(module.exports, "peopleProfilesRoute", () => $f2e324964119b6ad$export$1338132568be849);

var $exb0h = parcelRequire("exb0h");
const $f2e324964119b6ad$export$1338132568be849 = {
    group: (0, $exb0h.ROUTE_GROUPS).PEOPLE_PROFILES,
    name: (0, $exb0h.ROUTE_NAMES).PEOPLE_INDEX,
    path: '/jira/people/:subPath?'
};

});

parcelRegister("6KjXB", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('eNmuD'),
            load('2Lfdl'),
            load('2hmUs'),
            load('bCeK4'),
            load('2lkBM')
        ]);
        const value = parcelRequire('gGjAb');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("eNmuD"),
        load("2Lfdl"),
        load("2hmUs"),
        load("bCeK4"),
        load("2lkBM")
    ]).then(()=>parcelRequire('gGjAb'));
}

});

parcelRegister("l8FCk", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('6Sbbc')
        ]);
        const value = parcelRequire('eV7kw');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("6Sbbc")
    ]).then(()=>parcelRequire('eV7kw'));
}

});

parcelRegister("iJPUk", function(module, exports) {

$parcel$export(module.exports, "LEGACY_PERSONAL_SETTINGS_PATH", () => $97f48d3f13d5b88e$export$b468ccdb67523656);
$parcel$export(module.exports, "GENERAL_PERSONAL_SETTINGS_PATH", () => $97f48d3f13d5b88e$export$693b70d1bcef8627);
$parcel$export(module.exports, "NOTIFICATIONS_PERSONAL_SETTINGS_PATH", () => $97f48d3f13d5b88e$export$21946ea4c58fd4c9);
$parcel$export(module.exports, "OPS_NOTIFICATIONS_PERSONAL_SETTINGS_PATH", () => $97f48d3f13d5b88e$export$2321c59d517801c8);
$parcel$export(module.exports, "getGeneralPersonalSettingsPath", () => $97f48d3f13d5b88e$export$db9e3ccc1e5e3317);
$parcel$export(module.exports, "getNotificationsPersonalSettingsPath", () => $97f48d3f13d5b88e$export$64a672523a583594);

var $1ybV0 = parcelRequire("1ybV0");
const $97f48d3f13d5b88e$export$b468ccdb67523656 = '/secure/ViewPersonalSettings.jspa';
const $97f48d3f13d5b88e$export$a974f4af282a75ba = '/jira/settings/personal';
const $97f48d3f13d5b88e$export$693b70d1bcef8627 = `${$97f48d3f13d5b88e$export$a974f4af282a75ba}/general`;
const $97f48d3f13d5b88e$export$21946ea4c58fd4c9 = `${$97f48d3f13d5b88e$export$a974f4af282a75ba}/notifications`;
const $97f48d3f13d5b88e$export$2321c59d517801c8 = `${$97f48d3f13d5b88e$export$a974f4af282a75ba}/alert-notifications`;
function $97f48d3f13d5b88e$export$db9e3ccc1e5e3317() {
    return (0, $1ybV0.ff)('sea-1973-personal-settings-sidebar') ? $97f48d3f13d5b88e$export$693b70d1bcef8627 : $97f48d3f13d5b88e$export$b468ccdb67523656;
}
function $97f48d3f13d5b88e$export$88a45ae8c4b1c664() {
    return (0, $1ybV0.ff)('sea-1973-personal-settings-sidebar') ? $97f48d3f13d5b88e$export$2321c59d517801c8 : $97f48d3f13d5b88e$export$b468ccdb67523656;
}
function $97f48d3f13d5b88e$export$64a672523a583594() {
    if ((0, $1ybV0.ff)('sea-1973-personal-settings-sidebar')) {
        if ((0, $1ybV0.ff)('sea-1973-notifications-hub')) return $97f48d3f13d5b88e$export$21946ea4c58fd4c9;
        return $97f48d3f13d5b88e$export$693b70d1bcef8627;
    }
    return $97f48d3f13d5b88e$export$b468ccdb67523656;
}

});

parcelRegister("34eH5", function(module, exports) {

$parcel$export(module.exports, "createNotificationPreferencesResource", () => $23bd24bebc496589$export$731980bd233a4797);
$parcel$export(module.exports, "createContactsResource", () => $23bd24bebc496589$export$b9ca444b0be3df97);
$parcel$export(module.exports, "createMuteResource", () => $23bd24bebc496589$export$c849cfac68bc6e80);
$parcel$export(module.exports, "createQuietHoursResource", () => $23bd24bebc496589$export$efc5e8690061f9cc);
$parcel$export(module.exports, "createForwardingRulesResource", () => $23bd24bebc496589$export$5314dca65b4e5888);

var $kJlBc = parcelRequire("kJlBc");
parcelRequire("l96PT");
var $3liNr = parcelRequire("3liNr");

var $avYc3 = parcelRequire("avYc3");
// Redefined here since it is not exported from RRR.
const $23bd24bebc496589$export$731980bd233a4797 = (checkConsolidationOnRouteDependency, depends)=>(0, $kJlBc.createResource)({
        type: 'notificationPreferencesResource',
        getKey: ()=>'notificationPreferencesResource',
        getData: ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $avYc3.getNotificationPreferences)();
        },
        isBrowserOnly: true,
        depends: depends
    });
const $23bd24bebc496589$export$b9ca444b0be3df97 = (checkConsolidationOnRouteDependency, depends)=>(0, $kJlBc.createResource)({
        type: 'contactsResource',
        getKey: ()=>'contactsResource',
        getData: async ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            const data = await (0, $avYc3.getContact)();
            return data.contacts;
        },
        isBrowserOnly: true,
        depends: depends
    });
const $23bd24bebc496589$export$c849cfac68bc6e80 = (checkConsolidationOnRouteDependency, depends)=>(0, $kJlBc.createResource)({
        type: 'muteResource',
        getKey: ()=>'muteResource',
        getData: ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $avYc3.getMuteDetail)();
        },
        isBrowserOnly: true,
        depends: depends
    });
const $23bd24bebc496589$export$efc5e8690061f9cc = (checkConsolidationOnRouteDependency, depends)=>(0, $kJlBc.createResource)({
        type: 'quietHoursResource',
        getKey: ()=>'quietHoursResource',
        getData: ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $avYc3.getQuietHoursDetail)();
        },
        isBrowserOnly: true,
        depends: depends
    });
const $23bd24bebc496589$export$5314dca65b4e5888 = (checkConsolidationOnRouteDependency, depends)=>(0, $kJlBc.createResource)({
        type: 'forwardingRulesResource',
        getKey: ()=>'forwardingRulesResource',
        getData: ({ dependencies: dependencies })=>{
            const isConsolidated = checkConsolidationOnRouteDependency ? checkConsolidationOnRouteDependency(dependencies) : true;
            if (!isConsolidated) return null;
            return (0, $avYc3.getForwardingRules)().then(({ values: values })=>values);
        },
        isBrowserOnly: true,
        depends: depends
    });

});
parcelRegister("avYc3", function(module, exports) {

$parcel$export(module.exports, "getNotificationPreferences", () => $7a7b7dc9e11d9275$export$60e139c3026f21bc);
$parcel$export(module.exports, "getContact", () => $7a7b7dc9e11d9275$export$52411745da118fc8);
$parcel$export(module.exports, "getMuteDetail", () => $7a7b7dc9e11d9275$export$80a4e62998a806a6);
$parcel$export(module.exports, "getQuietHoursDetail", () => $7a7b7dc9e11d9275$export$44a94c74f358d02f);
$parcel$export(module.exports, "getForwardingRules", () => $7a7b7dc9e11d9275$export$2161af98e3d645a5);

var $kRdYM = parcelRequire("kRdYM");
const $7a7b7dc9e11d9275$export$60e139c3026f21bc = ()=>(0, $kRdYM.eocFetch)(`/v1/users/notification-preferences`);
const $7a7b7dc9e11d9275$export$52411745da118fc8 = ()=>(0, $kRdYM.eocFetch)(`/v1/users/contact`);
const $7a7b7dc9e11d9275$export$80a4e62998a806a6 = ()=>(0, $kRdYM.eocFetch)(`/v1/users/notifications/mute`);
const $7a7b7dc9e11d9275$export$44a94c74f358d02f = ()=>(0, $kRdYM.eocFetch)(`/v1/users/quiet-hours/details`);
const $7a7b7dc9e11d9275$export$2161af98e3d645a5 = ()=>(0, $kRdYM.eocFetch)(`/v1/alerts/notifications/forwarding-rules`);

});


parcelRegister("7lcEz", function(module, exports) {

$parcel$export(module.exports, "legacyPersonalSettingsRoute", () => $e67c038bcafcb183$export$dd556eb586bb36b8);
$parcel$export(module.exports, "generalPersonalSettingsRoute", () => $e67c038bcafcb183$export$7a6c9715a86f906b);
$parcel$export(module.exports, "notificationsPersonalSettingsRoute", () => $e67c038bcafcb183$export$55ab09b9d6beb8be);
$parcel$export(module.exports, "opsNotificationsPersonalSettingsRoute", () => $e67c038bcafcb183$export$68ebdd4eccb7b383);
$parcel$export(module.exports, "getGeneralPersonalSettingsRouteForLink", () => $e67c038bcafcb183$export$cbf079e07fb96768);
$parcel$export(module.exports, "getNotificationsPersonalSettingsRouteForLink", () => $e67c038bcafcb183$export$9b4c78a3c84b549f);

var $exb0h = parcelRequire("exb0h");

var $1ybV0 = parcelRequire("1ybV0");

var $iJPUk = parcelRequire("iJPUk");

var $kZJn3 = parcelRequire("kZJn3");
const $e67c038bcafcb183$export$dd556eb586bb36b8 = {
    group: (0, $exb0h.ROUTE_GROUPS).PERSONAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).PERSONAL_SETTINGS,
    path: (0, $iJPUk.LEGACY_PERSONAL_SETTINGS_PATH)
};
const $e67c038bcafcb183$export$7a6c9715a86f906b = {
    group: (0, $exb0h.ROUTE_GROUPS).PERSONAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).PERSONAL_SETTINGS_GENERAL,
    path: (0, $iJPUk.GENERAL_PERSONAL_SETTINGS_PATH)
};
const $e67c038bcafcb183$export$55ab09b9d6beb8be = {
    group: (0, $exb0h.ROUTE_GROUPS).PERSONAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).PERSONAL_SETTINGS_NOTIFICATIONS,
    path: (0, $iJPUk.NOTIFICATIONS_PERSONAL_SETTINGS_PATH),
    skeleton: (0, $kZJn3.PersonalSettingsNotificationsAppSkeleton)
};
const $e67c038bcafcb183$export$68ebdd4eccb7b383 = {
    group: (0, $exb0h.ROUTE_GROUPS).PERSONAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).PERSONAL_SETTINGS_OPS_NOTIFICATIONS,
    path: (0, $iJPUk.OPS_NOTIFICATIONS_PERSONAL_SETTINGS_PATH)
};
const $e67c038bcafcb183$export$cbf079e07fb96768 = ()=>{
    if ((0, $1ybV0.ff)('sea-1973-personal-settings-sidebar')) return $e67c038bcafcb183$export$7a6c9715a86f906b;
    return $e67c038bcafcb183$export$dd556eb586bb36b8;
};
const $e67c038bcafcb183$export$9b4c78a3c84b549f = ()=>{
    if ((0, $1ybV0.ff)('sea-1973-personal-settings-sidebar')) {
        if ((0, $1ybV0.ff)('sea-1973-notifications-hub')) return $e67c038bcafcb183$export$55ab09b9d6beb8be;
        return $e67c038bcafcb183$export$7a6c9715a86f906b;
    }
    return $e67c038bcafcb183$export$dd556eb586bb36b8;
};

});
parcelRegister("kZJn3", function(module, exports) {

$parcel$export(module.exports, "PersonalSettingsNotificationsAppSkeleton", () => $0cfb08a5fcfb6db6$export$b542eb2d3193b983);
$parcel$export(module.exports, "PersonalSettingsNotificationsGlobalTableSkeleton", () => $0cfb08a5fcfb6db6$export$d58f6bbbc1838cb2);
$parcel$export(module.exports, "MimetypeSelectSkeleton", () => $0cfb08a5fcfb6db6$export$46fc11a564484c9c);
$parcel$export(module.exports, "ProjectNotificationAccordionSkeleton", () => $0cfb08a5fcfb6db6$export$8cb773cb6fc17338);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8ICxF = parcelRequire("8ICxF");

var $hAiPI = parcelRequire("hAiPI");

var $4CM8l = parcelRequire("4CM8l");

var $2Cyw6 = parcelRequire("2Cyw6");

var $iWhcn = parcelRequire("iWhcn");
const $0cfb08a5fcfb6db6$var$maxWidthCssStyles = null;
const $0cfb08a5fcfb6db6$var$customCssStyles = null;
const $0cfb08a5fcfb6db6$export$b542eb2d3193b983 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2Cyw6))),
        className: (0, $7JEyt.default)([
            "_p12f8stt _19pkidpf _2hwx1wug _otyridpf _18u01wug"
        ])
    });
const $0cfb08a5fcfb6db6$export$d58f6bbbc1838cb2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0cfb08a5fcfb6db6$var$SkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hAiPI))),
        className: (0, $7JEyt.default)([
            "_1wgmglyw"
        ])
    }));
const $0cfb08a5fcfb6db6$export$46fc11a564484c9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0cfb08a5fcfb6db6$var$SkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4CM8l))),
        className: (0, $7JEyt.default)([
            "_1wgmglyw"
        ])
    }));
const $0cfb08a5fcfb6db6$export$8cb773cb6fc17338 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0cfb08a5fcfb6db6$var$SkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iWhcn))),
        className: (0, $7JEyt.default)([
            "_1wgmglyw"
        ])
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0cfb08a5fcfb6db6$var$SkeletonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_c71ldgin _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hAiPI", function(module, exports) {
module.exports = new URL("global-table-skeleton-with-projects.tpl.5a5d24b9.svg", import.meta.url).toString();

});

parcelRegister("4CM8l", function(module, exports) {
module.exports = new URL("mimetype-skeleton.tpl.8b750352.svg", import.meta.url).toString();

});

parcelRegister("2Cyw6", function(module, exports) {
module.exports = new URL("personal-settings-notifications-app-skeleton-with-projects.tpl.d18b3c58.svg", import.meta.url).toString();

});

parcelRegister("iWhcn", function(module, exports) {
module.exports = new URL("project-accordion-skeleton.tpl.cee2df62.svg", import.meta.url).toString();

});



parcelRegister("kkmGZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $555435cd813e0645$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3e3e1703a525d86dcc2e19d53184ce08>>
 * @relayHash 6bbf2c57b214609f54849cda2ea129e2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9188457835dc841e15ae89ec4c1f078e2fa85d15cb55923db043827ef5491e95

var $PhJzU = parcelRequire("PhJzU");

var $5440E = parcelRequire("5440E");
const $555435cd813e0645$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = [
        v1 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        v4 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "xsmall"
                }
            ]
        }
    ], v6 = [
        {
            "kind": "ScalarField",
            "name": "channel"
        },
        {
            "kind": "ScalarField",
            "name": "isEnabled"
        },
        {
            "kind": "ScalarField",
            "name": "isEditable"
        }
    ], v7 = [
        v4 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "concreteType": "JiraNotificationChannel",
            "kind": "LinkedField",
            "name": "emailChannel",
            "plural": false,
            "selections": v6 /*: any*/ 
        },
        {
            "concreteType": "JiraNotificationChannel",
            "kind": "LinkedField",
            "name": "inProductChannel",
            "plural": false,
            "selections": v6 /*: any*/ 
        },
        {
            "kind": "ScalarField",
            "name": "category"
        }
    ], v8 = {
        "concreteType": "JiraNotificationPreferences",
        "kind": "LinkedField",
        "name": "preferences",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "issueAssigned",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "issueUpdated",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "issueDeleted",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "commentCreated",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "commentEdited",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "commentDeleted",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "issueCreated",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "issueMoved",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "mentionsCombined",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "worklogCombined",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "JiraNotificationPreference",
                "kind": "LinkedField",
                "name": "miscellaneousIssueEventCombined",
                "plural": false,
                "selections": v7 /*: any*/ 
            }
        ]
    }, v9 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ui_NotificationsPageAndProjectQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "projectNotificationsConfig_personalSettingsNotificationsConfigTable_projects"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraNotificationGlobalPreference",
                                    "kind": "LinkedField",
                                    "name": "notificationGlobalPreference",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "globalNotificationsConfigTable_personalSettingsNotificationsConfigTable_GlobalNotificationConfigTable_allPreferencesData"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "globalNotificationsConfigTable_personalSettingsNotificationsConfigTable_GlobalNotificationConfigTableNew_allPreferencesData"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraNotificationOptions",
                                                "kind": "LinkedField",
                                                "name": "options",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "mimeType_personalSettingsPreferenceFields_MimeTypePreferenceField"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "emailEnabled_personalSettingsPreferenceFields_EmailEnabledPreferenceField"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "notifyOwnChanges_personalSettingsPreferenceFields_NotifyOwnChangesPreferenceField"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "notificationPreferencesOptionsWrapper_personalSettingsPreferenceFields_NotificationPreferencesOptions"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.notificationGlobalPreference.options"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.notificationGlobalPreference"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneousissueeventscombinedtyperelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "ui_NotificationsPageAndProjectQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraNotificationProjectPreferenceConnection",
                            "kind": "LinkedField",
                            "name": "allNotificationProjectPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectNotificationPreferenceEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNotificationProjectPreferences",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "project",
                                                    "plural": false,
                                                    "selections": v5 /*: any*/ 
                                                },
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "totalCount"
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                v9 /*: any*/ 
                            ]
                        },
                        {
                            "args": v3 /*: any*/ ,
                            "filters": [
                                "cloudId"
                            ],
                            "handle": "connection",
                            "key": "projects_allNotificationProjectPreferences",
                            "kind": "LinkedHandle",
                            "name": "allNotificationProjectPreferences"
                        },
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraNotificationGlobalPreference",
                            "kind": "LinkedField",
                            "name": "notificationGlobalPreference",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraNotificationOptions",
                                    "kind": "LinkedField",
                                    "name": "options",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEmailNotificationEnabled"
                                        },
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "emailMimeType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEmailMimeTypeEditable"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "notifyOwnChangesEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "notifyWhenRoleAssigneeEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "notifyWhenRoleReporterEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "batchWindow"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "dailyBatchLocalTime"
                                        }
                                    ]
                                },
                                v8 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "allJiraProjectsForModal",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                        "notificationConfigurationState": "DEFAULT",
                                        "sortBy": {
                                            "sortBy": "NAME"
                                        }
                                    }
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 5
                                }
                            ],
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9188457835dc841e15ae89ec4c1f078e2fa85d15cb55923db043827ef5491e95",
            "metadata": {},
            "name": "ui_NotificationsPageAndProjectQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider": (0, $PhJzU.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneousissueeventscombinedtyperelayprovider": (0, $5440E.default)
            }
        }
    };
}();
$555435cd813e0645$var$node.hash = "95b25e8050d0f39dbcfbefb15e7d633b";
var $555435cd813e0645$export$2e2bcd8739ae039 = $555435cd813e0645$var$node;

});
parcelRegister("PhJzU", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0178f2cde148a91$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e0178f2cde148a91$export$2e2bcd8739ae039 = {
    get () {
        return (0, $1ybV0.ff)('jlovep-1048-add-other-issue-events-combined-notification');
    }
};

});

parcelRegister("5440E", function(module, exports) {

$parcel$export(module.exports, "default", () => $0986ce961f8838d7$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0986ce961f8838d7$export$2e2bcd8739ae039 = {
    get () {
        return (0, $1ybV0.ff)('jlovep-1048-add-other-issue-events-combined-notification');
    }
};

});


parcelRegister("lWrPO", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('kQloL')
        ]);
        const value = parcelRequire('dTASr');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("kQloL")
    ]).then(()=>parcelRequire('dTASr'));
}

});

parcelRegister("i4uLB", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('38uxt')
        ]);
        const value = parcelRequire('lH4ou');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("38uxt")
    ]).then(()=>parcelRequire('lH4ou'));
}

});

parcelRegister("3TfM2", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('6Yg0K')
        ]);
        const value = parcelRequire('ixGLB');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("6Yg0K")
    ]).then(()=>parcelRequire('ixGLB'));
}

});

parcelRegister("cnKPy", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('605nj')
        ]);
        const value = parcelRequire('8bATJ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("605nj")
    ]).then(()=>parcelRequire('8bATJ'));
}

});

parcelRegister("fTgIJ", function(module, exports) {

$parcel$export(module.exports, "useIsViewPermissionsEnabled", () => $2943e3921ea7f7ba$export$a94405ffcb20c356);
$parcel$export(module.exports, "useIsCrossProjectViewsEnabled", () => $2943e3921ea7f7ba$export$34d097b1cd6f89c1);

var $1ybV0 = parcelRequire("1ybV0");

var $6WXNs = parcelRequire("6WXNs");
var $eIp1n = parcelRequire("eIp1n");

var $gd0Sp = parcelRequire("gd0Sp");
const $2943e3921ea7f7ba$export$8aa8a7878fd61770 = ()=>{
    const { appEditions: appEditions } = (0, $gd0Sp.useTenantContext)();
    const jpdEdition = (0, $6WXNs.getEdition)((0, $eIp1n.JIRA_PRODUCT_DISCOVERY), appEditions);
    // TODO: POL-10089 use entitlements instead of the edition when it will be available
    return jpdEdition === (0, $6WXNs.toEdition)((0, $6WXNs.PREMIUM_EDITION));
};
const $2943e3921ea7f7ba$export$a94405ffcb20c356 = ()=>{
    const isPremium = $2943e3921ea7f7ba$export$8aa8a7878fd61770();
    return isPremium && (0, $1ybV0.ff)('polaris.view-permissions_plaoi');
};
const $2943e3921ea7f7ba$export$34d097b1cd6f89c1 = ()=>{
    const isPremium = $2943e3921ea7f7ba$export$8aa8a7878fd61770();
    return isPremium && (0, $1ybV0.ff)('cross-projects-views-m1');
};

});

parcelRegister("llB5o", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('bKLuN')
        ]);
        const value = parcelRequire('4rJuD');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("bKLuN")
    ]).then(()=>parcelRequire('4rJuD'));
}

});

parcelRegister("jRQMT", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('buIif')
        ]);
        const value = parcelRequire('kXUas');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("buIif")
    ]).then(()=>parcelRequire('kXUas'));
}

});

parcelRegister("5m8gr", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('kbSjk')
        ]);
        const value = parcelRequire('jPNkt');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("kbSjk")
    ]).then(()=>parcelRequire('jPNkt'));
}

});

parcelRegister("bVTNW", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('38tVF');
        const value = parcelRequire('8amB0');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("38tVF").then(()=>parcelRequire('8amB0'));
}

});

parcelRegister("bDEox", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('jze87')
        ]);
        const value = parcelRequire('3IAbi');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("jze87")
    ]).then(()=>parcelRequire('3IAbi'));
}

});

parcelRegister("5383Q", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('9m3Bu')
        ]);
        const value = parcelRequire('2skXt');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("9m3Bu")
    ]).then(()=>parcelRequire('2skXt'));
}

});

parcelRegister("eYPZR", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('jd6xQ')
        ]);
        const value = parcelRequire('jRARI');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("jd6xQ")
    ]).then(()=>parcelRequire('jRARI'));
}

});

parcelRegister("8gTmZ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('8wHq1')
        ]);
        const value = parcelRequire('fJvZ5');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("8wHq1")
    ]).then(()=>parcelRequire('fJvZ5'));
}

});

parcelRegister("afOc7", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('bhAaX')
        ]);
        const value = parcelRequire('dG5lO');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("bhAaX")
    ]).then(()=>parcelRequire('dG5lO'));
}

});

parcelRegister("4kviK", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('dCs6C')
        ]);
        const value = parcelRequire('lNgh6');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("dCs6C")
    ]).then(()=>parcelRequire('lNgh6'));
}

});

parcelRegister("3JCWT", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('bbm3G')
        ]);
        const value = parcelRequire('1D9RR');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("bbm3G")
    ]).then(()=>parcelRequire('1D9RR'));
}

});

parcelRegister("5wVLE", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('7PrMM')
        ]);
        const value = parcelRequire('leJqv');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("7PrMM")
    ]).then(()=>parcelRequire('leJqv'));
}

});

parcelRegister("3pkSn", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('luL9e');
        const value = parcelRequire('g04UT');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("luL9e").then(()=>parcelRequire('g04UT'));
}

});

parcelRegister("b1sy2", function(module, exports) {

$parcel$export(module.exports, "jsmEmailDomainsListResource", () => $56bbd55fb215fc9d$export$8e956348e5d47a3c);

var $3HCkE = parcelRequire("3HCkE");


const $56bbd55fb215fc9d$export$8e956348e5d47a3c = (0, $3HCkE.createResource)({
    type: (0, $c700c70f47ef39d0$export$2bde433b962efbdd),
    getKey: ()=>'email-domains-list',
    isBrowserOnly: true,
    getDataLoader: ()=>(parcelRequire("i3mLl"))
});

});
const $c700c70f47ef39d0$export$2bde433b962efbdd = 'JSM_EMAIL_DOMAINS_LIST';

parcelRegister("i3mLl", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('42GtE');
        const value = parcelRequire('7x8Oe');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("42GtE").then(()=>parcelRequire('7x8Oe'));
}

});


parcelRegister("bU9Sz", function(module, exports) {

$parcel$export(module.exports, "productsJsmOrganizationDetailsResource", () => $9581a5bd69ea081a$export$ccda79811a15bf5);

var $3HCkE = parcelRequire("3HCkE");


const $9581a5bd69ea081a$export$ccda79811a15bf5 = (0, $3HCkE.createResource)({
    type: (0, $933183352119debb$export$52408f1a0f23569a),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("eJCYw"))
});

});
const $933183352119debb$export$52408f1a0f23569a = 'RESOURCE_TYPE_PRODUCT_JSM_ORGANIZATION_DETAILS';

parcelRegister("eJCYw", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('ebcP2');
        const value = parcelRequire('f5Sa8');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("ebcP2").then(()=>parcelRequire('f5Sa8'));
}

});


parcelRegister("6Oo0P", function(module, exports) {

$parcel$export(module.exports, "productsJsmOrganizationMembersResource", () => $50ffd00cad93b35a$export$65c7941bd3e14d00);

var $1ybV0 = parcelRequire("1ybV0");

var $3HCkE = parcelRequire("3HCkE");

var $jwzNs = parcelRequire("jwzNs");

const $50ffd00cad93b35a$var$TEN_SECONDS_IN_MILLIS = 10000;

const $50ffd00cad93b35a$export$26c19cf6607d250e = (0, $3HCkE.createResource)({
    type: (0, $fd311a1f9f2cab74$export$c153c183bdc8cfd1),
    getKey: (routerContext)=>`${routerContext.query.page}-${routerContext.query.query}`,
    getDataLoader: ()=>(parcelRequire("golLl"))
});

const $50ffd00cad93b35a$export$2ec37ea3dffc8aeb = (0, $3HCkE.createResource)({
    type: (0, $fd311a1f9f2cab74$export$d3eec3e4b4eac6ac),
    getKey: (routerContext)=>`OrganizationMembers-${routerContext.match.params.organizationId}-${routerContext.query.page}-${routerContext.query.query}`,
    getDataLoader: ()=>(parcelRequire("golLl")),
    maxAge: $50ffd00cad93b35a$var$TEN_SECONDS_IN_MILLIS
});
const $50ffd00cad93b35a$export$65c7941bd3e14d00 = (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('jsm-fission-move-customer-organizations-source-of-truth-ui'), $50ffd00cad93b35a$export$2ec37ea3dffc8aeb, $50ffd00cad93b35a$export$26c19cf6607d250e);

});
const $fd311a1f9f2cab74$export$c153c183bdc8cfd1 = 'PRODUCT_JSM_ORGANIZATION_MEMBERS_LEGACY';
const $fd311a1f9f2cab74$export$d3eec3e4b4eac6ac = 'PRODUCT_JSM_ORGANIZATION_MEMBERS';

parcelRegister("golLl", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('4l0fp');
        const value = parcelRequire('3EkFo');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("4l0fp").then(()=>parcelRequire('3EkFo'));
}

});


parcelRegister("kCBYY", function(module, exports) {

$parcel$export(module.exports, "productsJsmOrganizationListResource", () => $c57a41c47b9114ea$export$3e38a27ad406d7f7);

var $1ybV0 = parcelRequire("1ybV0");

var $3HCkE = parcelRequire("3HCkE");

var $jwzNs = parcelRequire("jwzNs");

const $c57a41c47b9114ea$var$TEN_SECONDS_IN_MILLIS = 10000;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c57a41c47b9114ea$var$productsJsmOrganizationListResourceLegacy = (0, $3HCkE.createResource)({
    type: (0, $20a34f52808bc16a$export$27676104f3192a88),
    getKey: (routerContext)=>routerContext.query.page,
    getDataLoader: ()=>(parcelRequire("eP1hx"))
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c57a41c47b9114ea$var$productsJsmOrganizationListResourceNew = (0, $3HCkE.createResource)({
    type: (0, $20a34f52808bc16a$export$50de2841b08b875f),
    getKey: (routerContext)=>routerContext.query.page,
    getDataLoader: ()=>(parcelRequire("eP1hx")),
    maxAge: $c57a41c47b9114ea$var$TEN_SECONDS_IN_MILLIS
});
const $c57a41c47b9114ea$export$3e38a27ad406d7f7 = (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('jsm-fission-optimistic-update-in-product-admin-organization-page_2jltb'), $c57a41c47b9114ea$var$productsJsmOrganizationListResourceNew, $c57a41c47b9114ea$var$productsJsmOrganizationListResourceLegacy);

});
const $20a34f52808bc16a$export$27676104f3192a88 = 'RESOURCE_TYPE_PRODUCT_JSM_ORGANIZATION_LIST_LEGACY';
const $20a34f52808bc16a$export$50de2841b08b875f = 'RESOURCE_TYPE_PRODUCT_JSM_ORGANIZATION_LIST';

parcelRegister("eP1hx", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hBqy1');
        const value = parcelRequire('1soSi');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hBqy1").then(()=>parcelRequire('1soSi'));
}

});


parcelRegister("kCEdS", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('fLCfl')
        ]);
        const value = parcelRequire('jtc6t');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("fLCfl")
    ]).then(()=>parcelRequire('jtc6t'));
}

});

parcelRegister("1vtAI", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('gR0Id')
        ]);
        const value = parcelRequire('eHcFy');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("gR0Id")
    ]).then(()=>parcelRequire('eHcFy'));
}

});

parcelRegister("8vc2n", function(module, exports) {

$parcel$export(module.exports, "productsJswConfigurationResource", () => $d725289bc895b59f$export$b6a5741c2b47fb17);

var $3HCkE = parcelRequire("3HCkE");


const $d725289bc895b59f$export$b6a5741c2b47fb17 = (0, $3HCkE.createResource)({
    type: (0, $c05838a6b75aba60$export$73be8e1edd21e2d),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("jbR0o"))
});

});
const $c05838a6b75aba60$export$73be8e1edd21e2d = 'RESOURCE_TYPE_PRODUCT_JSW_CONFIGURATION';

parcelRegister("jbR0o", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('586Gy');
        const value = parcelRequire('onrSG');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("586Gy").then(()=>parcelRequire('onrSG'));
}

});


parcelRegister("esxKW", function(module, exports) {

$parcel$export(module.exports, "productsJswStorageManagementResource", () => $9197cd72b798fc1f$export$2cd668845b3478bd);

var $3HCkE = parcelRequire("3HCkE");


const $9197cd72b798fc1f$export$2cd668845b3478bd = (0, $3HCkE.createResource)({
    type: (0, $edf0bd800804270e$export$1ac222647be3baf8),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("3H4IC"))
});

});
const $edf0bd800804270e$export$1ac222647be3baf8 = 'RESOURCE_TYPE_PRODUCT_JSW_STORAGE_MANAGEMENT';

parcelRegister("3H4IC", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('1FgFN');
        const value = parcelRequire('9Zmdk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("1FgFN").then(()=>parcelRequire('9Zmdk'));
}

});


parcelRegister("i51fR", function(module, exports) {

$parcel$export(module.exports, "productsJswConfigurationRoute", () => $1a461460fc9ead25$export$decdad53ba9b97af);
$parcel$export(module.exports, "productsJswConfigurationStorageManagementRoute", () => $1a461460fc9ead25$export$6e126b0e7eabff82);

var $exb0h = parcelRequire("exb0h");
const $1a461460fc9ead25$export$decdad53ba9b97af = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).PRODUCTS_JSW_CONFIGURATION,
    path: '/jira/settings/products/jira-software-configuration',
    exact: true
};
const $1a461460fc9ead25$export$6e126b0e7eabff82 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).PRODUCTS_JSW_STORAGE_MANAGEMENT,
    path: '/jira/settings/products/jira-software-configuration/storage-management',
    exact: true
};

});

parcelRegister("cIyxN", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('ik0oR')
        ]);
        const value = parcelRequire('ftUY6');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("ik0oR")
    ]).then(()=>parcelRequire('ftUY6'));
}

});

parcelRegister("60khL", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('gPtOf')
        ]);
        const value = parcelRequire('iDcUZ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("gPtOf")
    ]).then(()=>parcelRequire('iDcUZ'));
}

});

parcelRegister("efT8A", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('KQwx0')
        ]);
        const value = parcelRequire('kmkOd');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("KQwx0")
    ]).then(()=>parcelRequire('kmkOd'));
}

});

parcelRegister("f0k5n", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('cSdRg')
        ]);
        const value = parcelRequire('3sQmF');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("cSdRg")
    ]).then(()=>parcelRequire('3sQmF'));
}

});

parcelRegister("8r1Yz", function(module, exports) {

$parcel$export(module.exports, "projectsComponentsResource", () => $45ab863d1e016743$export$557cc3eff8939b3);

var $3HCkE = parcelRequire("3HCkE");

var $6qExu = parcelRequire("6qExu");


const $45ab863d1e016743$export$557cc3eff8939b3 = (0, $3HCkE.createResource)({
    type: (0, $95baeea28c37707a$export$ae1b86a8daeb387d),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("gk8Th")),
    maxAge: (0, $6qExu.MIN_MAX_AGE)
});

});
const $95baeea28c37707a$export$ae1b86a8daeb387d = 'PROJECTS_COMPONENTS';

parcelRegister("gk8Th", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('5MKFz');
        const value = parcelRequire('lwwcn');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("5MKFz").then(()=>parcelRequire('lwwcn'));
}

});


parcelRegister("epRpT", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('cSfRL')
        ]);
        const value = parcelRequire('3Ht4z');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("cSfRL")
    ]).then(()=>parcelRequire('3Ht4z'));
}

});

parcelRegister("lNorK", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('1eIJb')
        ]);
        const value = parcelRequire('6lIZU');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("1eIJb")
    ]).then(()=>parcelRequire('6lIZU'));
}

});

parcelRegister("gVIF2", function(module, exports) {

$parcel$export(module.exports, "projectVersionsRelayResource", () => $9245e1e3cc78b4c6$export$7e8aa1360f86345c);
/* eslint-disable jira/import-whitelist */ 
var $iWLL0 = parcelRequire("iWLL0");

var $i5Gzt = parcelRequire("i5Gzt");

var $amu7D = parcelRequire("amu7D");

var $c7ifG = parcelRequire("c7ifG");

var $buJlM = parcelRequire("buJlM");

var $lURnk = parcelRequire("lURnk");

var $3HCkE = parcelRequire("3HCkE");

const $9245e1e3cc78b4c6$export$7e8aa1360f86345c = (0, $3HCkE.createResource)({
    type: `${(0, $buJlM.RELAY_RESOURCE_TYPE)}_${(0, $80ebda0937fcaf2d$export$59aa73792ad9507a)}`,
    getKey: ({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        return `project-version-query-relay-${projectKey}`;
    },
    // @ts-expect-error - might return null
    getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const variables = {
            initialLoadCount: 20,
            cloudId: tenantContext.cloudId,
            projectKey: match.params.projectKey,
            filter: (0, $i5Gzt.transformStatusFromParam)(query[0, $53fd6cfbd5095c80$export$3e8168848b996f7]),
            searchString: query[0, $53fd6cfbd5095c80$export$a181206198b7f50c] || '',
            sortBy: {
                sortByField: (0, $i5Gzt.transformSortFieldFromParam)(query[0, $53fd6cfbd5095c80$export$a3482d3a8df0e725]),
                order: (0, $i5Gzt.transformSortOrderFromParam)(query[0, $53fd6cfbd5095c80$export$71089821f361e881])
            }
        };
        const queryReference = (0, $iWLL0.loadQuery)((0, $amu7D.default), (0, $lURnk.default), variables, {
            fetchPolicy: 'store-or-network'
        });
        if (false && queryReference.id != null) await (0, $c7ifG.QueryPromisesMap).get(queryReference.id);
        return queryReference;
    },
    maxAge: 0
});

});
const $53fd6cfbd5095c80$export$a181206198b7f50c = 'contains';
const $53fd6cfbd5095c80$export$3e8168848b996f7 = 'status';
const $53fd6cfbd5095c80$export$71089821f361e881 = 'orderDirection';
const $53fd6cfbd5095c80$export$a3482d3a8df0e725 = 'orderField';
const $53fd6cfbd5095c80$export$3c5e605ca7ade9f2 = 'NAME';
const $53fd6cfbd5095c80$export$50241fe906e4f94e = 'RELEASE_DATE';
const $53fd6cfbd5095c80$export$99a467bcc22b8df9 = 'START_DATE';
const $53fd6cfbd5095c80$export$d44826c816b5619b = 'DESCRIPTION';
const $53fd6cfbd5095c80$export$34694f8d8b23ee2a = 'SEQUENCE';
const $53fd6cfbd5095c80$export$cb638d1fae624fbf = 20;
const $53fd6cfbd5095c80$export$bbcbc202f2dfa28c = 3;
const $53fd6cfbd5095c80$export$b983f2cb1f658a55 = 'RELEASED';
const $53fd6cfbd5095c80$export$cb459d726a8530a5 = 'UNRELEASED';
const $53fd6cfbd5095c80$export$c936349447a77fe0 = 'ARCHIVED';
const $53fd6cfbd5095c80$export$c5ed97509d0e2aaf = 'projectVersions';

parcelRegister("i5Gzt", function(module, exports) {

$parcel$export(module.exports, "transformStatusFromParam", () => $eb6da8f0caf0e86e$export$5760f9690301cdb);
$parcel$export(module.exports, "transformStatusToParam", () => $eb6da8f0caf0e86e$export$46595832dd863016);
$parcel$export(module.exports, "transformSortOrderFromParam", () => $eb6da8f0caf0e86e$export$1945e6d2f31e09e6);
$parcel$export(module.exports, "transformSortFieldFromParam", () => $eb6da8f0caf0e86e$export$f842a0d1846d319d);
$parcel$export(module.exports, "transformStatusToDropdownSelection", () => $eb6da8f0caf0e86e$export$7dad705635760cfe);
$parcel$export(module.exports, "getUpdatedDisplayedStatuses", () => $eb6da8f0caf0e86e$export$ce4c948ba1d53df4);
$parcel$export(module.exports, "getFormattedVersionDate", () => $eb6da8f0caf0e86e$export$5a6eeb16be7dd21d);


var $2W8po = parcelRequire("2W8po");

var $8TSnQ = parcelRequire("8TSnQ");

const $eb6da8f0caf0e86e$export$5760f9690301cdb = (input)=>{
    switch(input){
        case 'no-filter':
            return [
                (0, $8TSnQ.RELEASED),
                (0, $8TSnQ.UNRELEASED),
                (0, $8TSnQ.ARCHIVED)
            ];
        case 'all':
            return [
                (0, $8TSnQ.RELEASED),
                (0, $8TSnQ.UNRELEASED),
                (0, $8TSnQ.ARCHIVED)
            ];
        default:
            {
                const params = (input || '').split('-');
                const result = [
                    ...params.includes('released') ? [
                        (0, $8TSnQ.RELEASED)
                    ] : [],
                    ...params.includes('unreleased') ? [
                        (0, $8TSnQ.UNRELEASED)
                    ] : [],
                    ...params.includes('archived') ? [
                        (0, $8TSnQ.ARCHIVED)
                    ] : []
                ];
                return result.length ? result : [
                    (0, $8TSnQ.UNRELEASED)
                ];
            }
    }
};
const $eb6da8f0caf0e86e$export$46595832dd863016 = (input)=>{
    if (input) {
        if (input.length === 0) return 'no-filter';
        if (input.length > 2) return 'all';
        return [
            input.includes((0, $8TSnQ.RELEASED)) && [
                'released'
            ],
            input.includes((0, $8TSnQ.UNRELEASED)) && [
                'unreleased'
            ],
            input.includes((0, $8TSnQ.ARCHIVED)) && [
                'archived'
            ]
        ].filter(Boolean).join('-');
    }
    return undefined;
};
const $eb6da8f0caf0e86e$export$1945e6d2f31e09e6 = (input)=>{
    switch(input){
        case 'ASC':
            return 0, $44cab0426b6cf0d7$export$1dee026a19752d6b;
        case 'DESC':
            return 0, $44cab0426b6cf0d7$export$b6abcf7fa1d94f65;
        default:
            return 0, $44cab0426b6cf0d7$export$b6abcf7fa1d94f65;
    }
};
const $eb6da8f0caf0e86e$export$f842a0d1846d319d = (input)=>{
    switch(input){
        case 'NAME':
            return 0, $53fd6cfbd5095c80$export$3c5e605ca7ade9f2;
        case 'RELEASEDATE':
            return 0, $53fd6cfbd5095c80$export$50241fe906e4f94e;
        case 'STARTDATE':
            return 0, $53fd6cfbd5095c80$export$99a467bcc22b8df9;
        case 'DESCRIPTION':
            return 0, $53fd6cfbd5095c80$export$d44826c816b5619b;
        case 'SEQUENCE':
            return 0, $53fd6cfbd5095c80$export$34694f8d8b23ee2a;
        default:
            return 0, $53fd6cfbd5095c80$export$34694f8d8b23ee2a;
    }
};
const $eb6da8f0caf0e86e$export$7dad705635760cfe = (input)=>{
    switch(input){
        case 'no-filter':
            return [];
        case 'all':
            return [
                (0, $8TSnQ.RELEASED),
                (0, $8TSnQ.UNRELEASED),
                (0, $8TSnQ.ARCHIVED)
            ];
        default:
            {
                const params = (input || '').split('-');
                const result = [
                    ...params.includes('released') ? [
                        (0, $8TSnQ.RELEASED)
                    ] : [],
                    ...params.includes('unreleased') ? [
                        (0, $8TSnQ.UNRELEASED)
                    ] : [],
                    ...params.includes('archived') ? [
                        (0, $8TSnQ.ARCHIVED)
                    ] : []
                ];
                return result.length ? result : [
                    (0, $8TSnQ.UNRELEASED)
                ];
            }
    }
};
const $eb6da8f0caf0e86e$export$ce4c948ba1d53df4 = (displayedStatuses, selectedStatuses, newStatus)=>{
    // Handle the case when a status is selected after deselection of all in dropdown where versions in all statuses are displayed despite empty selection & deselecting a status from a full selection.
    if (displayedStatuses.length === (0, $53fd6cfbd5095c80$export$bbcbc202f2dfa28c)) {
        if (!selectedStatuses.length) return [
            newStatus
        ];
        return displayedStatuses.filter((status)=>status !== newStatus);
    }
    return displayedStatuses.includes(newStatus) ? displayedStatuses.filter((item)=>item !== newStatus) : [
        ...displayedStatuses,
        newStatus
    ];
};
const $eb6da8f0caf0e86e$export$5a6eeb16be7dd21d = (versionDate, formatDate)=>versionDate != null ? formatDate(new Date(versionDate), {
        timeZone: (0, $2W8po.VERSION_DATE_FORMAT_OPTION).timeZone,
        dateStyle: 'long'
    }) : '';

});
const $44cab0426b6cf0d7$export$1dee026a19752d6b = 'ASC';
const $44cab0426b6cf0d7$export$b6abcf7fa1d94f65 = 'DESC';

parcelRegister("2W8po", function(module, exports) {

$parcel$export(module.exports, "VERSION_DATE_FORMAT_OPTION", () => $fa8c105e2e5bf251$export$d54c0d576c2caef5);
// Used to format date string from the server to display version start date and release date
// Server only stores date without any time information such as 2023-12-31
// Use this WHENEVER displaying version start date and release date.
// If you respect local timezone without this constant, there will be a bug that will display one day early date in negative timezones.
// https://jira.atlassian.com/browse/JSWCLOUD-22316
const $fa8c105e2e5bf251$export$d54c0d576c2caef5 = {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC'
};

});

parcelRegister("8TSnQ", function(module, exports) {

$parcel$export(module.exports, "RELEASED", () => $28c4a9b02ba65731$export$b983f2cb1f658a55);
$parcel$export(module.exports, "UNRELEASED", () => $28c4a9b02ba65731$export$cb459d726a8530a5);
$parcel$export(module.exports, "ARCHIVED", () => $28c4a9b02ba65731$export$c936349447a77fe0);
$parcel$export(module.exports, "default", () => $28c4a9b02ba65731$export$2e2bcd8739ae039);
const $28c4a9b02ba65731$export$b983f2cb1f658a55 = 'RELEASED';
const $28c4a9b02ba65731$export$cb459d726a8530a5 = 'UNRELEASED';
const $28c4a9b02ba65731$export$c936349447a77fe0 = 'ARCHIVED';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$28c4a9b02ba65731$export$2e2bcd8739ae039 = [
    $28c4a9b02ba65731$export$b983f2cb1f658a55,
    $28c4a9b02ba65731$export$cb459d726a8530a5,
    $28c4a9b02ba65731$export$c936349447a77fe0
];

});


parcelRegister("lURnk", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e018c9cd98fb548$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fd7f2506520c61996289201acfe2d40a>>
 * @relayHash 5db959bf0a939ed80fba352ae388f0e3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 36bc2fc319728c22ee4d8b6c09fd795713f59dc760252cfcd48aa96dbc645a88
const $3e018c9cd98fb548$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "initialLoadCount"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchString"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortBy"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "name"
    }, v9 = {
        "kind": "ScalarField",
        "name": "key"
    }, v10 = {
        "alias": "jiraProjectType",
        "kind": "ScalarField",
        "name": "projectType"
    }, v11 = {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
    }, v12 = {
        "kind": "Variable",
        "name": "searchString",
        "variableName": "searchString"
    }, v13 = {
        "kind": "Variable",
        "name": "sortBy",
        "variableName": "sortBy"
    }, v14 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v15 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v16 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v17 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v18 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v19 = [
        v11 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "initialLoadCount"
        },
        v12 /*: any*/ ,
        v13 /*: any*/ 
    ], v20 = {
        "kind": "ScalarField",
        "name": "id"
    }, v21 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v22 = [
        v21 /*: any*/ 
    ], v23 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": "DONE"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "uiProjectVersionsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v7 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.projectId"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v8 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.name"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v9 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.key"
                                        },
                                        v10 /*: any*/ ,
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "alias": "versions",
                                                "args": [
                                                    v11 /*: any*/ ,
                                                    v12 /*: any*/ ,
                                                    v13 /*: any*/ 
                                                ],
                                                "concreteType": "JiraVersionConnection",
                                                "kind": "LinkedField",
                                                "name": "__uiProject__versions_connection",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraVersionEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            v14 /*: any*/ ,
                                                            v15 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraVersion",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v14 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "QueryError",
                                                        "kind": "LinkedField",
                                                        "name": "errors",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "extensions",
                                                                "plural": true,
                                                                "selections": [
                                                                    v16 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    v17 /*: any*/ ,
                                                    v18 /*: any*/ 
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.versions"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProjectByKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                },
                {
                    "args": v19 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "table_projectVersions"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "uiProjectVersionsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "args": v19 /*: any*/ ,
                                    "concreteType": "JiraVersionConnection",
                                    "kind": "LinkedField",
                                    "name": "versions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraVersionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                v15 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraVersion",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v14 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "status"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "startDate"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "releaseDate"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "overdue"
                                                        },
                                                        {
                                                            "alias": "allIssues",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "filter",
                                                                    "value": "ALL"
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v22 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"ALL\")"
                                                        },
                                                        {
                                                            "alias": "doneIssues",
                                                            "args": v23 /*: any*/ ,
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v22 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"DONE\")"
                                                        },
                                                        {
                                                            "alias": "done",
                                                            "args": v23 /*: any*/ ,
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v22 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"DONE\")"
                                                        },
                                                        {
                                                            "alias": "inProgress",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "filter",
                                                                    "value": "IN_PROGRESS"
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v22 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"IN_PROGRESS\")"
                                                        },
                                                        {
                                                            "alias": "toDo",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "filter",
                                                                    "value": "TODO"
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v22 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"TODO\")"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "versionId"
                                                        },
                                                        v8 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasReleaseNote"
                                                        },
                                                        v18 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "QueryError",
                                            "kind": "LinkedField",
                                            "name": "errors",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        v14 /*: any*/ ,
                                                        v16 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v21 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v19 /*: any*/ ,
                                    "filters": [
                                        "filter",
                                        "searchString",
                                        "sortBy"
                                    ],
                                    "handle": "connection",
                                    "key": "uiProject__versions",
                                    "kind": "LinkedHandle",
                                    "name": "versions"
                                },
                                v20 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "36bc2fc319728c22ee4d8b6c09fd795713f59dc760252cfcd48aa96dbc645a88",
            "metadata": {
                "connection": [
                    {
                        "count": "initialLoadCount",
                        "cursor": null,
                        "direction": "forward",
                        "path": [
                            "jira",
                            "jiraProjectByKey",
                            "versions"
                        ]
                    }
                ]
            },
            "name": "uiProjectVersionsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3e018c9cd98fb548$var$node.hash = "3bed4070fd244faac23cfc6a62e64f6c";
var $3e018c9cd98fb548$export$2e2bcd8739ae039 = $3e018c9cd98fb548$var$node;

});

const $80ebda0937fcaf2d$export$59aa73792ad9507a = 'PROJECT_VERSIONS';


parcelRegister("6YxH4", function(module, exports) {

$parcel$export(module.exports, "projectsVersionsResource", () => $89627653a86ef5a8$export$ba8a9b98a45e298f);

var $3HCkE = parcelRequire("3HCkE");


const $89627653a86ef5a8$export$ba8a9b98a45e298f = (0, $3HCkE.createResource)({
    type: (0, $1b6f27885812cab2$export$56d62fade79bf5b5),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("55krg"))
});

});
const $1b6f27885812cab2$export$56d62fade79bf5b5 = 'PROJECTS_VERSIONS';

parcelRegister("55krg", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('5gj1E');
        const value = parcelRequire('cm6Su');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("5gj1E").then(()=>parcelRequire('cm6Su'));
}

});


parcelRegister("axbhE", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('5RXIq')
        ]);
        const value = parcelRequire('36oPt');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("5RXIq")
    ]).then(()=>parcelRequire('36oPt'));
}

});

parcelRegister("8LZ8X", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('kYwWe')
        ]);
        const value = parcelRequire('c5Ddm');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("kYwWe")
    ]).then(()=>parcelRequire('c5Ddm'));
}

});

parcelRegister("6CNdU", function(module, exports) {

$parcel$export(module.exports, "componentFilterResource", () => $dba947cf9bed32c4$export$306e389909032632);
$parcel$export(module.exports, "useComponentFilterResource", () => $dba947cf9bed32c4$export$e13868d6ab2288af);

var $3HCkE = parcelRequire("3HCkE");

var $8hg3R = parcelRequire("8hg3R");

const $dba947cf9bed32c4$var$getDataLoader = ()=>(parcelRequire("3J5Vw"));
const $dba947cf9bed32c4$export$306e389909032632 = (0, $3HCkE.createResource)({
    type: 'ESCALATIONS_COMPONENT_FILTER_RESOURCE',
    getKey: ({ match: match })=>(0, $8hg3R.getProjectKeyOrId)(match),
    getDataLoader: $dba947cf9bed32c4$var$getDataLoader
});
const $dba947cf9bed32c4$export$e13868d6ab2288af = ()=>(0, $3HCkE.useResource)($dba947cf9bed32c4$export$306e389909032632);

});
parcelRegister("3J5Vw", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('4EN5w');
        const value = parcelRequire('arQnn');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("4EN5w").then(()=>parcelRequire('arQnn'));
}

});


parcelRegister("d4Gv0", function(module, exports) {

$parcel$export(module.exports, "priorityFilterResource", () => $d225d78d34bde743$export$ca03c5f9fc44703e);
$parcel$export(module.exports, "usePriorityFilterResource", () => $d225d78d34bde743$export$3654f46b6bb12558);

var $3HCkE = parcelRequire("3HCkE");

var $8hg3R = parcelRequire("8hg3R");

const $d225d78d34bde743$var$getDataLoader = ()=>(parcelRequire("75qdd"));
const $d225d78d34bde743$export$ca03c5f9fc44703e = (0, $3HCkE.createResource)({
    type: 'ESCALATIONS_PRIORITY_FILTER_RESOURCE',
    getKey: ({ match: match })=>(0, $8hg3R.getProjectKeyOrId)(match),
    getDataLoader: $d225d78d34bde743$var$getDataLoader
});
const $d225d78d34bde743$export$3654f46b6bb12558 = ()=>(0, $3HCkE.useResource)((0, $3HCkE.createResource)({
        type: 'ESCALATIONS_PRIORITY_FILTER_RESOURCE',
        getKey: ({ match: match })=>(0, $8hg3R.getProjectKeyOrId)(match),
        getDataLoader: $d225d78d34bde743$var$getDataLoader
    }));

});
parcelRegister("75qdd", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('6CNud');
        const value = parcelRequire('eAhxK');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("6CNud").then(()=>parcelRequire('eAhxK'));
}

});


parcelRegister("1ODui", function(module, exports) {

$parcel$export(module.exports, "escalationsRoute", () => $62f3dcc5b0c1c22d$export$3d91b36833b7ddb9);

var $exb0h = parcelRequire("exb0h");
const $62f3dcc5b0c1c22d$export$3d91b36833b7ddb9 = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_CUSTOMER_SERVICE_ESCALATIONS,
    path: '/jira/servicedesk/projects/:projectKey/escalations',
    exact: true
};

});

parcelRegister("frZnw", function(module, exports) {

$parcel$export(module.exports, "APP_NAMES", () => $02625cb43b98ccea$export$4116f3d0d9d6bed7);
$parcel$export(module.exports, "toPackageName", () => $02625cb43b98ccea$export$f31a652635bd75fe);
const $02625cb43b98ccea$export$4116f3d0d9d6bed7 = {
    ACCOUNTS: 'servicedesk.accounts',
    APP_DISCOVERY: 'servicedesk.app-discovery',
    ATLASSIAN_ANALYTICS: 'servicedesk.atlassian-analytics',
    AUTOMATION_EDIT_RULE: 'servicedesk.automation.edit-rule',
    AUTOMATION_SUMMARY: 'servicedesk.automation.summary',
    AUTOMATION_VIEW_LOG: 'servicedesk.automation.view-log',
    BOARD: 'servicedesk.board',
    BOARD_SETTINGS: 'servicedesk.board-settings',
    CALENDAR: 'servicedesk.calendar',
    CHANGE_CALENDAR: 'servicedesk.change-calendar',
    CHANGE_MANAGEMENT_SETTINGS: 'servicedesk.change-management.settings',
    CREATE_PROJECT: 'servicedesk.create-project',
    CSAT_CONFIG: 'servicedesk.csat-configuration',
    CUSTOMER_PERMISSIONS: 'servicedesk.customer-permissions',
    CONTACTS: 'servicedesk.contacts',
    CUSTOMERS: 'servicedesk.customers',
    CUSTOMER_DETAILS: 'servicedesk.customer-details',
    CUSTOMER_SERVICE_ESCALATIONS: 'servicedesk.customer-service-escalations',
    CUSTOMER_SERVICE_PRODUCTS: 'servicedesk.customer-service-products',
    INVITE_TEAM_DIALOG: 'servicedesk.invite-team-dialog',
    ISSUE_SCHEDULE_CHANGE: 'servicedesk.issue.schedule-change',
    ITSM_FEATURES_SETTINGS: 'servicedesk.itsm-features.settings',
    ITSM_SAMPLE_SPACE: 'servicedesk.itsm-sample-space',
    GETTING_STARTED_PAGE: 'servicedesk.getting-started-page',
    KB_BROWSE_ARTICLES: 'servicedesk.knowledge-base.browse-articles',
    KB_CATEGORY: 'servicedesk.knowledge-base.category',
    KB_DRAFTS: 'servicedesk.knowledge-base.drafts',
    KB_BROWSE_CATEGORIES: 'servicedesk.knowledge-base.browse-categories',
    KB_SUGGESTED_ARTICLES: 'servicedesk.knowledge-base.suggested-articles',
    KB_EMBED_EDITOR: 'servicedesk.knowledge-article.embed-editor',
    KB_LANDING: 'servicedesk.knowledge-base.landing',
    KB_REPORTS_REQUESTS: 'servicedesk.kb-requests.reports',
    KB_SEARCH: 'servicedesk.knowledge-base.search',
    KB_SETTINGS: 'servicedesk.knowledge.settings',
    KB_SETUP: 'servicedesk.knowledge-base.setup',
    KB_VIEW_ARTICLE: 'servicedesk.knowledge-base.view-article',
    ORGANIZATION: 'servicedesk.organization',
    ORGANIZATIONS: 'servicedesk.organizations',
    ORGANIZATION_DETAILS: 'servicedesk.organization-details',
    PORTAL_SETTINGS: 'servicedesk.portal-settings',
    QUEUES_AGENT_VIEW: 'servicedesk.queues.agent-view',
    QUEUES_EDIT_VIEW: 'servicedesk.queues.edit-view',
    QUEUES_MAIN: 'servicedesk.queues.main',
    REPORTS_CUSTOM: 'servicedesk.reports.custom',
    REPORTS_CUSTOM_CREATE: 'servicedesk.reports.custom-create',
    REPORTS_CUSTOM_EDIT: 'servicedesk.reports.custom-edit',
    REPORTS_SATISFACTION: 'servicedesk.reports.satisfaction',
    REPORTS_WORKLOAD: 'servicedesk.reports.workload',
    REQUEST_TYPES_CONFIG: 'servicedesk.request-types-config',
    REQUEST_TYPE_FIELDS: 'servicedesk.request-type-fields',
    SLA_SETTINGS: 'servicedesk.sla-settings',
    VIRTUAL_AGENT_BROWSE_CONVERSATIONS: 'servicedesk.virtual-agent.browse-conversations',
    VIRTUAL_AGENT_BROWSE_INTENTS: 'servicedesk.virtual-agent.browse-intents',
    VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS: 'servicedesk.virtual-agent.browse-standard-flows',
    VIRTUAL_AGENT_LANDING: 'servicedesk.virtual-agent.landing',
    VIRTUAL_AGENT_SETTINGS: 'servicedesk.virtual-agent.settings',
    VIRTUAL_AGENT_VIEW_INTENT: 'servicedesk.virtual-agent.view-intent',
    VIRTUAL_AGENT_VIEW_STANDARD_FLOW: 'servicedesk.virtual-agent.view-standard-flow',
    PRACTICE_CONFIG_MODULE: 'servicedesk.practice-config-module',
    CREATE_SERVICE_MODAL: 'servicedesk.create-service-modal',
    UPDATE_SERVICE_MODAL: 'servicedesk.update-service-modal',
    LANGUAGE_SETTINGS: 'servicedesk.language-settings',
    LINKED_ALERTS_MODAL: 'servicedesk.link-alerts-modal',
    INSIGHT_ASSETS_REPORTS: 'servicedesk.insight-cmdb-assets_reports',
    INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT: 'servicedesk.insight-cmdb-assets_reports_default_redirect',
    INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE: 'servicedesk.insight-cmdb-assets_reports_unsubscribe',
    INSIGHT_OBJECT_VIEW: 'servicedesk.insight-cmdb-object',
    INSIGHT_OBJECT_SCHEMA: 'servicedesk.insight-cmdb-object-schema',
    INSIGHT_OBJECT_SCHEMA_CONFIGURATION: 'servicedesk.insight-cmdb-object-schema-configuration',
    INSIGHT_OBJECT_TYPE_CONFIGURATION: 'servicedesk.insight-object-type-configuration',
    INSIGHT_GLOBAL_CONFIGURATION: 'servicedesk.insight-cmdb-global-configuration',
    INSIGHT_LANDING_PAGE: 'servicedesk.insight-cmdb-landing-page',
    CUSTOMER_NOTIFICATIONS_MAIN_VIEW: 'servicedesk.customer-notifications-settings.main-view',
    CUSTOMER_NOTIFICATIONS_INVITE_CUSTOMER_VIEW: 'servicedesk.customer-notifications-settings.invite-customer-view',
    CUSTOMER_NOTIFICATIONS_RULE_VIEW: 'servicedesk.customer-notifications-settings.rule-view',
    CUSTOMER_NOTIFICATIONS_TEMPLATE_VIEW: 'servicedesk.customer-notifications-settings.template-view',
    CUSTOMER_NOTIFICATIONS_UNKNOWN_VIEW: 'servicedesk.customer-notifications-settings.unknown-view',
    SERVICES_WITHOUT_PROJECT_VIEW: 'servicedesk.services-without-project-view',
    SERVICE_DETAIL_WITHOUT_PROJECT_VIEW: 'servicedesk.service-detail-without-project-view',
    WIDGET_SETTINGS: 'servicedesk.widget-settings'
};
// To match the FE error analytics pipeline convention
const $02625cb43b98ccea$var$ANALYTICS_PACKAGE_NAMES = {
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.ACCOUNTS]: 'servicedeskAccounts',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.APP_DISCOVERY]: 'serviceDeskAppDiscovery',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.ATLASSIAN_ANALYTICS]: 'serviceDeskAtlassianAnalytics',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.AUTOMATION_EDIT_RULE]: 'servicedeskAutomationEditView',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.AUTOMATION_SUMMARY]: 'servicedeskAutomationEditRule',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.AUTOMATION_VIEW_LOG]: 'servicedeskAutomationViewLog',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.BOARD]: 'servicedeskBoard',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.BOARD_SETTINGS]: 'servicedeskBoardSettings',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.CALENDAR]: 'servicedeskCalendar',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.CHANGE_CALENDAR]: 'servicedeskChangeCalendar',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.CHANGE_MANAGEMENT_SETTINGS]: 'servicedeskChangeManagementSettings',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.CREATE_PROJECT]: 'servicedeskCreateProject',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.CSAT_CONFIG]: 'servicedeskCsatConfig',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.CONTACTS]: 'servicedeskContacts',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.CUSTOMER_PERMISSIONS]: 'servicedeskCustomerPermissions',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.CUSTOMERS]: 'servicedeskCustomers',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.CUSTOMER_DETAILS]: 'servicedeskCustomerDetails',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.CUSTOMER_SERVICE_ESCALATIONS]: 'servicedeskCustomerServiceEscalations',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.CUSTOMER_SERVICE_PRODUCTS]: 'servicedeskCustomerServiceProducts',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.INVITE_TEAM_DIALOG]: 'servicedeskInviteTeamDialog',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.ISSUE_SCHEDULE_CHANGE]: 'servicedeskIssueScheduleChange',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.ITSM_FEATURES_SETTINGS]: 'servicedeskItsmFeaturesSettings',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.ITSM_SAMPLE_SPACE]: 'servicedeskItsmSampleSpace',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.KB_BROWSE_ARTICLES]: 'servicedeskKnowledgeBaseBrowseArticles',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.KB_BROWSE_CATEGORIES]: 'servicedeskKnowledgeBaseBrowseCategories',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.KB_CATEGORY]: 'servicedeskKnowledgeBaseCategory',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.KB_DRAFTS]: 'servicedeskKnowledgeBaseDrafts',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.KB_SUGGESTED_ARTICLES]: 'servicedeskKnowledgeBaseSuggestedArticles',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.KB_EMBED_EDITOR]: 'servicedeskKnowledgeBaseEmbedEditor',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.KB_LANDING]: 'servicedeskKnowledgeBaseLanding',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.KB_REPORTS_REQUESTS]: 'servicedeskKbRequestsReports',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.KB_SEARCH]: 'servicedeskKnowledgeBaseSearch',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.KB_SETTINGS]: 'servicedeskKnowledgeSettings',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.KB_SETUP]: 'servicedeskKnowledgeBaseSetup',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.KB_VIEW_ARTICLE]: 'servicedeskKnowledgeBaseViewArticle',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.LANGUAGE_SETTINGS]: 'servicedeskLanguageSettingsTranslations',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.ORGANIZATION]: 'servicedeskOrganization',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.ORGANIZATIONS]: 'servicedeskOrganizations',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.ORGANIZATION_DETAILS]: 'servicedeskOrganizationDetails',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.PORTAL_SETTINGS]: 'servicedeskPortalSettings',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.QUEUES_AGENT_VIEW]: 'servicedeskQueuesAgentView',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.QUEUES_EDIT_VIEW]: 'servicedeskQueuesEditView',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.QUEUES_MAIN]: 'servicedeskQueuesMain',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.REPORTS_CUSTOM]: 'servicedeskReportsCustom',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.REPORTS_CUSTOM_CREATE]: 'servicedeskReportsCustomCreate',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.REPORTS_CUSTOM_EDIT]: 'servicedeskReportsCustomEdit',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.REPORTS_SATISFACTION]: 'servicedeskReportsSatisfaction',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.REPORTS_WORKLOAD]: 'servicedeskReportsWorkload',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.REQUEST_TYPES_CONFIG]: 'servicedeskRequestTypesConfig',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.REQUEST_TYPE_FIELDS]: 'servicedeskRequestTypeFields',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.SLA_SETTINGS]: 'servicedeskSlaSettings',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_BROWSE_CONVERSATIONS]: 'servicedeskVirtualAgentBrowseConversations',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_BROWSE_INTENTS]: 'servicedeskVirtualAgentBrowseIntents',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS]: 'servicedeskVirtualAgentBrowseStandardFlows',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_LANDING]: 'servicedeskVirtualAgentLanding',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_SETTINGS]: 'servicedeskVirtualAgentSettings',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_VIEW_INTENT]: 'servicedeskVirtualAgentViewIntent',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_VIEW_STANDARD_FLOW]: 'servicedeskVirtualAgentViewStandardFlow',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.PRACTICE_CONFIG_MODULE]: 'servicedeskPracticeConfigModule',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.CREATE_SERVICE_MODAL]: 'servicedeskCreateServiceModal',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.UPDATE_SERVICE_MODAL]: 'servicedeskUpdateServiceModal',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.LINKED_ALERTS_MODAL]: 'servicedeskLinkAlertsModal',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.INSIGHT_ASSETS_REPORTS]: 'servicedeskAssetsReports',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT]: 'servicedeskAssetsReportsDefaultRedirect',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE]: 'servicedeskAssetsReportsUnsubscribe',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_VIEW]: 'servicedeskObjectView',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_SCHEMA]: 'servicedeskObjectSchema',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_SCHEMA_CONFIGURATION]: 'servicedeskObjectSchemaConfiguration',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_TYPE_CONFIGURATION]: 'servicedeskObjectTypeConfiguration',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.INSIGHT_GLOBAL_CONFIGURATION]: 'servicedeskInsightGlobalConfiguration',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.INSIGHT_LANDING_PAGE]: 'servicedeskInsightLandingPage',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_MAIN_VIEW]: 'servicedeskCustomerNotificationsMainView',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_INVITE_CUSTOMER_VIEW]: 'servicedeskCustomerNotificationsInviteCustomerView',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_RULE_VIEW]: 'servicedeskCustomerNotificationsRuleView',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_TEMPLATE_VIEW]: 'servicedeskCustomerNotificationsTemplateView',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_UNKNOWN_VIEW]: 'servicedeskCustomerNotificationsUnknownView',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.GETTING_STARTED_PAGE]: 'servicedeskGettingStartedPage',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.SERVICES_WITHOUT_PROJECT_VIEW]: 'servicedeskServicesWithoutProjectView',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.SERVICE_DETAIL_WITHOUT_PROJECT_VIEW]: 'servicedeskServiceDetailWithoutProjectView',
    [$02625cb43b98ccea$export$4116f3d0d9d6bed7.WIDGET_SETTINGS]: 'servicedeskWidgetSettings'
};
const $02625cb43b98ccea$export$f31a652635bd75fe = (appName)=>$02625cb43b98ccea$var$ANALYTICS_PACKAGE_NAMES[appName];

});

parcelRegister("g3ItN", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('iyCXq')
        ]);
        const value = parcelRequire('cmyuu');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("iyCXq")
    ]).then(()=>parcelRequire('cmyuu'));
}

});

parcelRegister("aP2Ra", function(module, exports) {

$parcel$export(module.exports, "PRODUCTS_PAGE_SIZE", () => $2282441d52088402$export$9e59a0b3e9d74a99);
$parcel$export(module.exports, "customerServiceProductsQueryResource", () => $2282441d52088402$export$f9257217f5333b1a);

var $buJlM = parcelRequire("buJlM");

var $f7zQj = parcelRequire("f7zQj");
const $2282441d52088402$export$9e59a0b3e9d74a99 = 50;
const $2282441d52088402$export$f9257217f5333b1a = (0, $buJlM.createRelayResource)({
    type: 'CUSTOMER_SERVICE_PRODUCTS_QUERY',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $f7zQj.default),
            variables: {
                cloudId: tenantContext.cloudId,
                first: $2282441d52088402$export$9e59a0b3e9d74a99
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("f7zQj", function(module, exports) {

$parcel$export(module.exports, "default", () => $f62540f89b850398$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4df781c51f5dfbc32b76735c59bb33af>>
 * @relayHash 081a2dfa9c4407c84bf8d024899e92b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bb8d4ae9602322e43ac61cf45c886f9ecad88afb1aaa237fd8615ea59abb7c16
const $f62540f89b850398$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v3 = [
        v2 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "srcCustomerServiceProductsQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "productsPage_servicedeskCustomerServiceProducts"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "srcCustomerServiceProductsQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ 
                    ],
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "CustomerServiceProductConnection",
                            "kind": "LinkedField",
                            "name": "productConnections",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CustomerServiceProductEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "CustomerServiceProduct",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "entitlementsCount"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ClientExtension",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__id"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v3 /*: any*/ ,
                            "handle": "connection",
                            "key": "customerServiceProducts_productConnections",
                            "kind": "LinkedHandle",
                            "name": "productConnections"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "bb8d4ae9602322e43ac61cf45c886f9ecad88afb1aaa237fd8615ea59abb7c16",
            "metadata": {},
            "name": "srcCustomerServiceProductsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f62540f89b850398$var$node.hash = "3c49696a6cdc337af280ec80f957ea89";
var $f62540f89b850398$export$2e2bcd8739ae039 = $f62540f89b850398$var$node;

});


parcelRegister("f7Fx7", function(module, exports) {

$parcel$export(module.exports, "productsRoute", () => $7da75ffe8cccffc0$export$7d9d0206a326c6b5);

var $exb0h = parcelRequire("exb0h");
const $7da75ffe8cccffc0$export$7d9d0206a326c6b5 = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_CUSTOMER_SERVICE_PRODUCTS,
    path: '/jira/servicedesk/projects/:projectKey/products',
    exact: true
};

});

parcelRegister("amK0o", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('5ZIOS')
        ]);
        const value = parcelRequire('12sLP');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("5ZIOS")
    ]).then(()=>parcelRequire('12sLP'));
}

});

parcelRegister("hmkBf", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hLLv8');
        const value = parcelRequire('6M5jd');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hLLv8").then(()=>parcelRequire('6M5jd'));
}

});

parcelRegister("8ghfS", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('6IRlF');
        const value = parcelRequire('jBv2v');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("6IRlF").then(()=>parcelRequire('jBv2v'));
}

});

parcelRegister("3nZzB", function(module, exports) {

$parcel$export(module.exports, "adminOauthCredentialsResource", () => $c81d15515b138f45$export$870d7919c1ca4482);

var $3HCkE = parcelRequire("3HCkE");
const $c81d15515b138f45$var$RESOURCE_TYPE_ADMIN_OAUTH_CREDENTIALS = 'ADMIN_OAUTH_CREDENTIALS';

const $c81d15515b138f45$export$870d7919c1ca4482 = (0, $3HCkE.createResource)({
    type: $c81d15515b138f45$var$RESOURCE_TYPE_ADMIN_OAUTH_CREDENTIALS,
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("a6OWd"))
});

});
parcelRegister("a6OWd", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('1zuvJ');
        const value = parcelRequire('3n5Fx');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("1zuvJ").then(()=>parcelRequire('3n5Fx'));
}

});


parcelRegister("9xasj", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2qaNh')
        ]);
        const value = parcelRequire('cW7qg');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2qaNh")
    ]).then(()=>parcelRequire('cW7qg'));
}

});

parcelRegister("9HzdP", function(module, exports) {

$parcel$export(module.exports, "jswOnboardingResource", () => $82498fffce6b410d$export$be21a2d8a350a80);
$parcel$export(module.exports, "useJswOnboardingResource", () => $82498fffce6b410d$export$83f546a45ad58d0a);

var $3HCkE = parcelRequire("3HCkE");


const $82498fffce6b410d$export$be21a2d8a350a80 = (0, $3HCkE.createResource)({
    type: (0, $e5669fbcf13e968c$export$692203fca66f4d77),
    getKey: ()=>'jsw_onboarding',
    getDataLoader: ()=>(parcelRequire("DJO9Z"))
});
const $82498fffce6b410d$export$83f546a45ad58d0a = ()=>(0, $3HCkE.useResource)($82498fffce6b410d$export$be21a2d8a350a80);

});
const $e5669fbcf13e968c$export$692203fca66f4d77 = 'RESOURCE_TYPE_SOFTWARE_ONBOARDING';

parcelRegister("DJO9Z", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('a9drC');
        const value = parcelRequire('4AxaM');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("a9drC").then(()=>parcelRequire('4AxaM'));
}

});


parcelRegister("gAPTT", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('dsiAd'),
            load('hPzOn'),
            load('2hmUs'),
            load('bCeK4'),
            load('5sMYF')
        ]);
        const value = parcelRequire('5do0f');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("dsiAd"),
        load("hPzOn"),
        load("2hmUs"),
        load("bCeK4"),
        load("5sMYF")
    ]).then(()=>parcelRequire('5do0f'));
}

});

parcelRegister("fKkwe", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('ajBt7')
        ]);
        const value = parcelRequire('iTk1o');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("ajBt7")
    ]).then(()=>parcelRequire('iTk1o'));
}

});

parcelRegister("c8Srg", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('2on6y');
        const value = parcelRequire('5CZ3R');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("2on6y").then(()=>parcelRequire('5CZ3R'));
}

});

parcelRegister("87SmV", function(module, exports) {

$parcel$export(module.exports, "systemConfigurationGeneralResource", () => $78dab43018269962$export$b622f7400bfafd0d);

var $3HCkE = parcelRequire("3HCkE");


const $78dab43018269962$export$b622f7400bfafd0d = (0, $3HCkE.createResource)({
    type: (0, $975047949307b186$export$e780b172f774b673),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("8CrzA"))
});

});
const $975047949307b186$export$e780b172f774b673 = 'RESOURCE_TYPE_SYSTEM_CONFIGURATION_GENERAL';

parcelRegister("8CrzA", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('62oBo');
        const value = parcelRequire('d2VQC');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("62oBo").then(()=>parcelRequire('d2VQC'));
}

});


parcelRegister("8p4LD", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('9A8Wk')
        ]);
        const value = parcelRequire('8B7hX');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("9A8Wk")
    ]).then(()=>parcelRequire('8B7hX'));
}

});

parcelRegister("3eQtr", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('djwjs')
        ]);
        const value = parcelRequire('aSKSY');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("djwjs")
    ]).then(()=>parcelRequire('aSKSY'));
}

});

parcelRegister("8jcNY", function(module, exports) {

$parcel$export(module.exports, "globalPermissionsResource", () => $7590aa3190e12e2e$export$9a5d1bc1ff678482);

var $buJlM = parcelRequire("buJlM");

var $dyg99 = parcelRequire("dyg99");
const $7590aa3190e12e2e$var$RESOURCE_TYPE_GLOBAL_PERMISSIONS = 'GLOBAL_PERMISSIONS';
const $7590aa3190e12e2e$export$9a5d1bc1ff678482 = (0, $buJlM.createRelayResource)({
    type: $7590aa3190e12e2e$var$RESOURCE_TYPE_GLOBAL_PERMISSIONS,
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $dyg99.default),
            variables: {
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("dyg99", function(module, exports) {

$parcel$export(module.exports, "default", () => $c24c05ce0027868a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5f014b4044459efb94c4edb99f926dd1>>
 * @relayHash 402a674bdd82767605c36953e2732f07
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5b2ad70438dbcc77ff45c7608ecd4e7382a18aa895a82fd26e83279a282b7ab6
const $c24c05ce0027868a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "main_globalPermissionsAndGrantsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "globalPermissionsAndGrants",
                                    "args": v1 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "getGlobalPermissionsAndGrants",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "globalPermissionsTable_globalPermissions"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "grantPermissionDialog_globalPermissions"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.globalPermissionsAndGrants"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "main_globalPermissionsAndGrantsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "globalPermissionsAndGrants",
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "getGlobalPermissionsAndGrants",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "JiraGlobalPermissionGrants",
                                            "kind": "LinkedField",
                                            "name": "globalPermissionGrants",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraGlobalPermission",
                                                    "kind": "LinkedField",
                                                    "name": "permission",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isManagedByJira"
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraGroup",
                                                    "kind": "LinkedField",
                                                    "name": "groups",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "groupId"
                                                        },
                                                        v2 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraGlobalPermissionGrantsList"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5b2ad70438dbcc77ff45c7608ecd4e7382a18aa895a82fd26e83279a282b7ab6",
            "metadata": {},
            "name": "main_globalPermissionsAndGrantsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c24c05ce0027868a$var$node.hash = "9f1b7eb98b606c41655e4fa1f200a351";
var $c24c05ce0027868a$export$2e2bcd8739ae039 = $c24c05ce0027868a$var$node;

});


parcelRegister("epY1x", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('jKdpJ')
        ]);
        const value = parcelRequire('1rKQL');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("jKdpJ")
    ]).then(()=>parcelRequire('1rKQL'));
}

});

parcelRegister("8K5zM", function(module, exports) {

$parcel$export(module.exports, "default", () => $6af7a3459aa6a0d6$export$2e2bcd8739ae039);

var $53ciZ = parcelRequire("53ciZ");

var $3HCkE = parcelRequire("3HCkE");

var $8LN4D = parcelRequire("8LN4D");

const $6af7a3459aa6a0d6$var$issueTypeSchemeResource = (0, $3HCkE.createResource)({
    type: (0, $664c19c2d14162db$export$1d678052bb5ae54d),
    getKey: ({ query: query })=>`${0, $664c19c2d14162db$export$41cf50ee50d5da20}-${(0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(query)}`,
    maxAge: 0,
    getData: async ({ query: query })=>(0, $8LN4D.getIssueTypeSchemes)((0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(query))
});
var $6af7a3459aa6a0d6$export$2e2bcd8739ae039 = $6af7a3459aa6a0d6$var$issueTypeSchemeResource;

});
parcelRegister("8LN4D", function(module, exports) {

$parcel$export(module.exports, "getIssueTypeSchemes", () => $ae9b50e78849f06a$export$2844cac611eecaa7);

var $53ciZ = parcelRequire("53ciZ");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $63t1V = parcelRequire("63t1V");

var $4CFHb = parcelRequire("4CFHb");
const $ae9b50e78849f06a$export$2844cac611eecaa7 = async (qs)=>{
    const filter = (0, $4CFHb.fromUrlTransformer)((0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(qs));
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify((0, $4CFHb.toApiUrlTransformer)(filter));
    try {
        return await (0, $lRmyA.performGetRequest)(`/rest/api/3/issuetypescheme?${query}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'getIssueTypesRequest',
                packageName: (0, $63t1V.PACKAGE_NAME),
                teamName: 'morphinecake'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});
parcelRegister("63t1V", function(module, exports) {

$parcel$export(module.exports, "SOURCE_NAME", () => $7cd5ecc17d70b2b1$export$a3821bc63538b210);
$parcel$export(module.exports, "ISSUE_TYPE_SCHEMES_TABLE", () => $7cd5ecc17d70b2b1$export$91570d508c93485d);
$parcel$export(module.exports, "ORDER", () => $7cd5ecc17d70b2b1$export$11e75bce9f7ea886);
$parcel$export(module.exports, "MAX_RESULTS", () => $7cd5ecc17d70b2b1$export$f6b2881bc1090cea);
$parcel$export(module.exports, "defaultIssueTypeSchemesFilter", () => $7cd5ecc17d70b2b1$export$625de46796f967ae);
$parcel$export(module.exports, "EMPTY_PROJECTS_PAGE", () => $7cd5ecc17d70b2b1$export$81a0343467d0e9a9);
$parcel$export(module.exports, "PACKAGE_NAME", () => $7cd5ecc17d70b2b1$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "FILTER_CHANGE_ANALYTICS", () => $7cd5ecc17d70b2b1$export$9ac56b2484c2d4e9);
// analytics constants

const $7cd5ecc17d70b2b1$export$a3821bc63538b210 = 'issueTypeSchemeDirectory';
const $7cd5ecc17d70b2b1$export$91570d508c93485d = 'issueTypeSchemesTable';
const $7cd5ecc17d70b2b1$export$11e75bce9f7ea886 = Object.freeze({
    ASC: 'asc',
    DESC: 'desc'
});
const $7cd5ecc17d70b2b1$export$f6b2881bc1090cea = 10;
const $7cd5ecc17d70b2b1$export$625de46796f967ae = {
    pageNumber: 1,
    pageSize: $7cd5ecc17d70b2b1$export$f6b2881bc1090cea,
    expand: [
        'projects',
        'issueTypes'
    ],
    orderBy: 'name',
    sortDirection: (0, $44cab0426b6cf0d7$export$b6abcf7fa1d94f65)
};
const $7cd5ecc17d70b2b1$export$52adcbea6a93900f = {
    startAt: 0,
    maxResults: $7cd5ecc17d70b2b1$export$f6b2881bc1090cea,
    values: [],
    total: 0,
    isLast: true
};
const $7cd5ecc17d70b2b1$export$81a0343467d0e9a9 = {
    startAt: 0,
    maxResults: 10,
    values: [],
    total: 0,
    isLast: true
};
const $7cd5ecc17d70b2b1$export$b8b9d90f9e5bd72b = 'jiraAdminPagesIssueTypeSchemesDirectory';
const $7cd5ecc17d70b2b1$export$9ac56b2484c2d4e9 = Object.freeze({
    ACTION: 'changed',
    ACTION_SUBJECT: 'filterSearch'
});

});

parcelRegister("4CFHb", function(module, exports) {

$parcel$export(module.exports, "toUrlTransformer", () => $f7ec44fa76e56068$export$5b9f8ed2c34be88a);
$parcel$export(module.exports, "fromUrlTransformer", () => $f7ec44fa76e56068$export$bec67ef860c0d0e1);
$parcel$export(module.exports, "toApiUrlTransformer", () => $f7ec44fa76e56068$export$fb15afa686993f11);

var $4QA2B = parcelRequire("4QA2B");

var $4qDVh = parcelRequire("4qDVh");

var $63t1V = parcelRequire("63t1V");

var $2ftkx = parcelRequire("2ftkx");
const $f7ec44fa76e56068$export$5b9f8ed2c34be88a = (filter)=>{
    const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy } = filter || {};
    return {
        pageNumber: pageNumber,
        searchFilter: searchFilter,
        orderBy: orderBy
    };
};
const $f7ec44fa76e56068$export$bec67ef860c0d0e1 = (params)=>{
    const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy } = params;
    const parsedNumber = Number.isNaN((0, $4qDVh.number).parse(pageNumber)) ? (0, $63t1V.defaultIssueTypeSchemesFilter).pageNumber : (0, $4qDVh.number).parse(pageNumber);
    const parsedOrderBy = orderBy === 'name' || orderBy === '-name' ? orderBy : undefined;
    return {
        ...(0, $63t1V.defaultIssueTypeSchemesFilter),
        pageNumber: parsedNumber != null ? Number(parsedNumber) : undefined,
        searchFilter: searchFilter,
        orderBy: parsedOrderBy
    };
};
const $f7ec44fa76e56068$export$fb15afa686993f11 = (filter)=>{
    const fullFilter = (0, (/*@__PURE__*/$parcel$interopDefault($4QA2B)))({}, filter, (0, $63t1V.defaultIssueTypeSchemesFilter));
    let requestParams = {
        maxResults: (0, $63t1V.MAX_RESULTS),
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        startAt: (fullFilter.pageNumber - 1) * (0, $63t1V.MAX_RESULTS),
        orderBy: fullFilter.orderBy,
        queryString: (0, $2ftkx.trimSearchFilter)(fullFilter.searchFilter)
    };
    if (fullFilter.expand != null) // @ts-expect-error - TS2322 - Type '{ expand: string; maxResults: number; startAt: number; orderBy: IssueTypeOrderBy | undefined; queryString: string | undefined; }' is not assignable to type '{ maxResults: number; startAt: number; orderBy: IssueTypeOrderBy | undefined; queryString: string | undefined; }'.
    requestParams = {
        ...requestParams,
        expand: fullFilter.expand.join(',')
    };
    return requestParams;
};

});
parcelRegister("4QA2B", function(module, exports) {

var $9eFtX = parcelRequire("9eFtX");

var $k4hoH = parcelRequire("k4hoH");

var $3P7i5 = parcelRequire("3P7i5");

var $5ovM8 = parcelRequire("5ovM8");
/** Used for built-in method references. */ var $3877f9c0b9ba6b7b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3877f9c0b9ba6b7b$var$hasOwnProperty = $3877f9c0b9ba6b7b$var$objectProto.hasOwnProperty;
/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */ var $3877f9c0b9ba6b7b$var$defaults = $9eFtX(function(object, sources) {
    object = Object(object);
    var index = -1;
    var length = sources.length;
    var guard = length > 2 ? sources[2] : undefined;
    if (guard && $3P7i5(sources[0], sources[1], guard)) length = 1;
    while(++index < length){
        var source = sources[index];
        var props = $5ovM8(source);
        var propsIndex = -1;
        var propsLength = props.length;
        while(++propsIndex < propsLength){
            var key = props[propsIndex];
            var value = object[key];
            if (value === undefined || $k4hoH(value, $3877f9c0b9ba6b7b$var$objectProto[key]) && !$3877f9c0b9ba6b7b$var$hasOwnProperty.call(object, key)) object[key] = source[key];
        }
    }
    return object;
});
module.exports = $3877f9c0b9ba6b7b$var$defaults;

});

parcelRegister("4qDVh", function(module, exports) {

$parcel$export(module.exports, "string", () => $ef46bfb1383e180b$export$22b082955e083ec3);
$parcel$export(module.exports, "bool", () => $ef46bfb1383e180b$export$87b259aa03e3d267);
$parcel$export(module.exports, "array", () => $ef46bfb1383e180b$export$2f23118c22fb2630);
$parcel$export(module.exports, "multiple", () => $ef46bfb1383e180b$export$939ddaa3205df08e);
$parcel$export(module.exports, "number", () => $ef46bfb1383e180b$export$98e628dec113755e);

var $3QMTK = parcelRequire("3QMTK");
const $ef46bfb1383e180b$export$22b082955e083ec3 = {
    stringify: (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK))),
    parse: (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK)))
};
const $ef46bfb1383e180b$export$87b259aa03e3d267 = {
    stringify: (value)=>String(value),
    parse: (value)=>{
        if (value === 'true') return true;
        if (value === 'false') return false;
        return undefined;
    }
};
const $ef46bfb1383e180b$export$2f23118c22fb2630 = {
    stringify: (value)=>value && Array.isArray(value) ? value.join(',') : undefined,
    parse: (value)=>typeof value === 'string' ? value?.split(',') : undefined
};
const $ef46bfb1383e180b$export$939ddaa3205df08e = {
    stringify: (value)=>{
        if (!value || !Array.isArray(value)) return undefined;
        return value.length === 1 ? value[0] : value;
    },
    parse: (value)=>value && Array.isArray(value) ? value : [
            String(value)
        ]
};
const $ef46bfb1383e180b$export$98e628dec113755e = {
    stringify: (value)=>`${value}`,
    parse: (value)=>Number(value)
};

});

parcelRegister("2ftkx", function(module, exports) {

$parcel$export(module.exports, "trimSearchFilter", () => $8183583e9a63ddca$export$ed1722f41c23aaaf);
const $8183583e9a63ddca$export$7341f299e7b93e87 = (field)=>field !== undefined ? field.toLowerCase() : undefined;
const $8183583e9a63ddca$export$c876451e094c0060 = (map, param)=>map[param] !== undefined ? map[param] : undefined;
const $8183583e9a63ddca$export$ed1722f41c23aaaf = (searchFilter)=>{
    if (searchFilter === undefined) return undefined;
    return searchFilter.trim() || undefined;
};

});



const $664c19c2d14162db$export$1d678052bb5ae54d = 'ISSUE_TYPE_SCHEME_TABLE';
const $664c19c2d14162db$export$41cf50ee50d5da20 = 'ISSUE_TYPE_SCHEME_TABLE_KEY';


parcelRegister("eDggO", function(module, exports) {

$parcel$export(module.exports, "issueTypesResource", () => $2ec648873c6084df$export$614e9d897c1ef917);

var $53ciZ = parcelRequire("53ciZ");

var $3HCkE = parcelRequire("3HCkE");

var $KqypM = parcelRequire("KqypM");
const $2ec648873c6084df$export$614e9d897c1ef917 = (0, $3HCkE.createResource)({
    type: 'GLOBAL_ADMIN_ISSUE_TYPES_DIRECTORY',
    getKey: ()=>'issue types',
    getData: async ({ query: query })=>(0, $KqypM.getIssueTypes)((0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(query))
});

});
parcelRegister("KqypM", function(module, exports) {

$parcel$export(module.exports, "getIssueTypes", () => $66311c7490a085e2$export$4cf4b24b88599615);

var $53ciZ = parcelRequire("53ciZ");

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");


var $9j32Z = parcelRequire("9j32Z");
const $66311c7490a085e2$export$4cf4b24b88599615 = async (qs)=>{
    const filter = (0, $9j32Z.fromUrlTransformer)((0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(qs));
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify((0, $9j32Z.toApiUrlTransformer)(filter));
    try {
        return await (0, $2OdyW.default)(`/rest/internal/3/issuetype/search?${query}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'getIssueTypesRequest',
                packageName: (0, $6a48a5e8f88398a3$export$4adfbb237b083187),
                teamName: 'morphinecake'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});
const $6a48a5e8f88398a3$export$4adfbb237b083187 = 'jiraAdminPagesIssueTypesResources';

parcelRegister("9j32Z", function(module, exports) {

$parcel$export(module.exports, "toUrlTransformer", () => $6176d2dbe39feadc$export$5b9f8ed2c34be88a);
$parcel$export(module.exports, "fromUrlTransformer", () => $6176d2dbe39feadc$export$bec67ef860c0d0e1);
$parcel$export(module.exports, "toSearchFilterQsTransformer", () => $6176d2dbe39feadc$export$bcd1ab210547e2f5);
$parcel$export(module.exports, "toSortFieldFilterQsTransformer", () => $6176d2dbe39feadc$export$c114848fa733e5c4);
$parcel$export(module.exports, "toSortDirectionFilterQsTransformer", () => $6176d2dbe39feadc$export$c5d2609f8b4048d3);
$parcel$export(module.exports, "toApiUrlTransformer", () => $6176d2dbe39feadc$export$fb15afa686993f11);

var $4QA2B = parcelRequire("4QA2B");

var $53ciZ = parcelRequire("53ciZ");



var $4qDVh = parcelRequire("4qDVh");

var $jr29U = parcelRequire("jr29U");

var $64igz = parcelRequire("64igz");
const $6176d2dbe39feadc$var$sortDirectionMap = {
    [(0, $44cab0426b6cf0d7$export$1dee026a19752d6b).toLowerCase()]: (0, $44cab0426b6cf0d7$export$1dee026a19752d6b),
    [(0, $44cab0426b6cf0d7$export$b6abcf7fa1d94f65).toLowerCase()]: (0, $44cab0426b6cf0d7$export$b6abcf7fa1d94f65)
};
const $6176d2dbe39feadc$var$sortFieldMap = {
    [(0, $1043f6e43a4e5fe8$export$3c5e605ca7ade9f2).toLowerCase()]: (0, $1043f6e43a4e5fe8$export$3c5e605ca7ade9f2),
    [(0, $1043f6e43a4e5fe8$export$7673664bdc3ae979).toLowerCase()]: (0, $1043f6e43a4e5fe8$export$7673664bdc3ae979)
};
const $6176d2dbe39feadc$export$5b9f8ed2c34be88a = (filter)=>filter ? {
        page: filter.page !== undefined && filter.page >= 1 ? String(filter.page) : undefined,
        sortDirection: (0, $jr29U.fieldToParam)(filter.sortDirection),
        sortField: (0, $jr29U.fieldToParam)(filter.sortField),
        searchFilter: (0, $jr29U.trimSearchFilter)(filter.searchFilter)
    } : {};
const $6176d2dbe39feadc$export$bec67ef860c0d0e1 = (params)=>({
        page: Math.floor(Number((0, $4qDVh.number).parse(params.page))) || undefined,
        searchFilter: (0, $jr29U.trimSearchFilter)(params.searchFilter),
        sortDirection: (0, $jr29U.fieldFromParam)($6176d2dbe39feadc$var$sortDirectionMap, params.sortDirection),
        sortField: (0, $jr29U.fieldFromParam)($6176d2dbe39feadc$var$sortFieldMap, params.sortField)
    });
const $6176d2dbe39feadc$export$bcd1ab210547e2f5 = (qs)=>{
    const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(qs);
    return parsed.searchFilter ? parsed.searchFilter : '';
};
const $6176d2dbe39feadc$export$c114848fa733e5c4 = (qs)=>{
    const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(qs);
    return parsed.sortField && parsed.sortField === 'name' ? (0, $1043f6e43a4e5fe8$export$3c5e605ca7ade9f2) : (0, $1043f6e43a4e5fe8$export$7673664bdc3ae979);
};
const $6176d2dbe39feadc$export$c5d2609f8b4048d3 = (qs)=>{
    const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(qs);
    return parsed.sortDirection && parsed.sortDirection === 'asc' ? (0, $44cab0426b6cf0d7$export$1dee026a19752d6b) : (0, $44cab0426b6cf0d7$export$b6abcf7fa1d94f65);
};
const $6176d2dbe39feadc$var$apiSortByMap = {
    [(0, $44cab0426b6cf0d7$export$1dee026a19752d6b)]: '',
    [(0, $44cab0426b6cf0d7$export$b6abcf7fa1d94f65)]: '-'
};
const $6176d2dbe39feadc$export$fb15afa686993f11 = (filter)=>{
    const fullFilter = (0, (/*@__PURE__*/$parcel$interopDefault($4QA2B)))({}, filter, (0, $64igz.DEFAULT_FILTER));
    // this additional mapping here is needed because the BE issue type search API already supports sorting by hierarchy level using the "type" parameter. It was decided to add mapping on frontend. More details here https://atlassian.slack.com/archives/C02HN05MC8K/p1680683395059279
    const sortFieldMapping = fullFilter.sortField === 'hierarchy-level' ? 'type' : fullFilter.sortField;
    return {
        maxResults: (0, $64igz.MAX_RESULTS),
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        startAt: (fullFilter.page - 1) * (0, $64igz.MAX_RESULTS),
        query: (0, $jr29U.trimSearchFilter)(fullFilter.searchFilter),
        // @ts-expect-error - TS2538 - Type 'undefined' cannot be used as an index type.
        orderBy: `${$6176d2dbe39feadc$var$apiSortByMap[fullFilter.sortDirection]}${sortFieldMapping}`
    };
};

});
// data field names
const $1043f6e43a4e5fe8$export$3c5e605ca7ade9f2 = 'name';
const $1043f6e43a4e5fe8$export$d44826c816b5619b = 'description';
const $1043f6e43a4e5fe8$export$b87f371cbc396fcf = 'type';
const $1043f6e43a4e5fe8$export$7673664bdc3ae979 = 'hierarchy-level';
const $1043f6e43a4e5fe8$export$68e97ee499f7c743 = 'related-schemes';
const $1043f6e43a4e5fe8$export$92a1a3b7554e9387 = 'actions';
const $1043f6e43a4e5fe8$export$23ba45d5f8d54fed = 'level-number';
const $1043f6e43a4e5fe8$export$1dc71bc9f1a3749a = 'arrow';
const $1043f6e43a4e5fe8$export$8be5a31a21d0c723 = 'level-name';
const $1043f6e43a4e5fe8$export$6ad51af4785d6548 = 'jira-issue-types';
const $1043f6e43a4e5fe8$export$20068afc6f8c1737 = 'label-space';

parcelRegister("jr29U", function(module, exports) {

$parcel$export(module.exports, "fieldToParam", () => $5811ba891269dc6c$export$7341f299e7b93e87);
$parcel$export(module.exports, "fieldFromParam", () => $5811ba891269dc6c$export$c876451e094c0060);
$parcel$export(module.exports, "trimSearchFilter", () => $5811ba891269dc6c$export$ed1722f41c23aaaf);
const $5811ba891269dc6c$export$7341f299e7b93e87 = (field)=>field !== undefined ? field.toLowerCase() : undefined;
const $5811ba891269dc6c$export$c876451e094c0060 = (map, param)=>map[param] !== undefined ? map[param] : undefined;
const $5811ba891269dc6c$export$ed1722f41c23aaaf = (searchFilter)=>{
    if (searchFilter === undefined) return undefined;
    return searchFilter.trim() || undefined;
};

});

parcelRegister("64igz", function(module, exports) {

$parcel$export(module.exports, "MAX_RESULTS", () => $907956bc954ce14c$export$f6b2881bc1090cea);
$parcel$export(module.exports, "DEFAULT_FILTER", () => $907956bc954ce14c$export$6deee0e4f2fb784e);


const $907956bc954ce14c$export$f6b2881bc1090cea = 15;
const $907956bc954ce14c$export$6deee0e4f2fb784e = {
    page: 1,
    sortDirection: (0, $44cab0426b6cf0d7$export$b6abcf7fa1d94f65),
    sortField: (0, $1043f6e43a4e5fe8$export$7673664bdc3ae979)
};

});




parcelRegister("1MAZH", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueHierarchyRoute", () => $ff5f16d5cafe9306$export$2c220ed11ae62e14);
$parcel$export(module.exports, "globalSettingsIssueHierarchyRedirectRoute", () => $ff5f16d5cafe9306$export$6236a41e09bb858a);
$parcel$export(module.exports, "globalSettingsIssueTypesRoute", () => $ff5f16d5cafe9306$export$7358263a3bbb38b1);
$parcel$export(module.exports, "globalSettingsIssueTypesSchemesRoute", () => $ff5f16d5cafe9306$export$2aba97aa663f43b3);

var $exb0h = parcelRequire("exb0h");
const $ff5f16d5cafe9306$export$2c220ed11ae62e14 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_ISSUE_HIERARCHY,
    path: '/jira/settings/issues/issue-hierarchy'
};
const $ff5f16d5cafe9306$export$6236a41e09bb858a = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_ISSUE_HIERARCHY_REDIRECT,
    path: '/secure/PortfolioHierarchy.jspa'
};
const $ff5f16d5cafe9306$export$7358263a3bbb38b1 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_ISSUE_TYPES,
    path: '/jira/settings/issues/issue-types'
};
const $ff5f16d5cafe9306$export$2aba97aa663f43b3 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES,
    path: '/jira/settings/issues/issue-type-schemes'
};

});

parcelRegister("jYdf8", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('bRQFd')
        ]);
        const value = parcelRequire('7pWWX');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("bRQFd")
    ]).then(()=>parcelRequire('7pWWX'));
}

});

parcelRegister("5H2v7", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('id5xb');
        const value = parcelRequire('btdQZ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("id5xb").then(()=>parcelRequire('btdQZ'));
}

});

parcelRegister("7asbG", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('kumT4')
        ]);
        const value = parcelRequire('dPzqG');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("kumT4")
    ]).then(()=>parcelRequire('dPzqG'));
}

});

parcelRegister("d2cDI", function(module, exports) {

$parcel$export(module.exports, "jsmCustomerAuthenticationSettingsResource", () => $09315850a4e6ad93$export$73134c05a3c27bd);

var $3HCkE = parcelRequire("3HCkE");

var $8UVuC = parcelRequire("8UVuC");

const $09315850a4e6ad93$export$73134c05a3c27bd = (0, $3HCkE.createResource)({
    type: (0, $8UVuC.RESOURCE_TYPE_JSM_CUSTOMER_AUTHENTICATION_SETTINGS),
    getKey: ()=>'settings',
    getDataLoader: ()=>(parcelRequire("aNdTt")),
    maxAge: (0, $8UVuC.ONE_DAY_IN_MILLIS)
});

});
parcelRegister("8UVuC", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_JSM_CUSTOMER_AUTHENTICATION_SETTINGS", () => $e77c90d49905626d$export$6a2799d78d98b915);
$parcel$export(module.exports, "ONE_DAY_IN_MILLIS", () => $e77c90d49905626d$export$5a00268156ea5027);
const $e77c90d49905626d$export$6a2799d78d98b915 = 'JSM_CUSTOMER_AUTHENTICATION_SETTINGS';
const $e77c90d49905626d$export$5a00268156ea5027 = 86400000;

});

parcelRegister("aNdTt", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('8fkhS');
        const value = parcelRequire('2y6vw');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("8fkhS").then(()=>parcelRequire('2y6vw'));
}

});


parcelRegister("7QODe", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('9UD2y')
        ]);
        const value = parcelRequire('d8cx9');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("9UD2y")
    ]).then(()=>parcelRequire('d8cx9'));
}

});

parcelRegister("eUcUT", function(module, exports) {

$parcel$export(module.exports, "jsmGlobalCustomerAccessAffectedProjectsResource", () => $06e49f10ff6a602f$export$f27acbd4701f5dfe);

var $3HCkE = parcelRequire("3HCkE");

const $06e49f10ff6a602f$var$ONE_DAY_IN_MILLIS = 86400000;

const $06e49f10ff6a602f$export$f27acbd4701f5dfe = (0, $3HCkE.createResource)({
    type: (0, $9ba0002b4c368082$export$341f26dde034af5b),
    getKey: ()=>'affected-projects',
    getDataLoader: ()=>(parcelRequire("fFOPd")),
    maxAge: $06e49f10ff6a602f$var$ONE_DAY_IN_MILLIS
});

});
const $9ba0002b4c368082$export$341f26dde034af5b = 'JSM_CUSTOMER_ACCESS_AFFECTED_PROJECTS';
const $9ba0002b4c368082$export$eb7818fb178a80b4 = 'JSM_GLOBAL_CUSTOMER_ACCESS_SETTINGS';

parcelRegister("fFOPd", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('65rCi');
        const value = parcelRequire('euCWi');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("65rCi").then(()=>parcelRequire('euCWi'));
}

});


parcelRegister("fdikA", function(module, exports) {

$parcel$export(module.exports, "jsmGlobalCustomerAccessSettingsResource", () => $ebb62170859aa532$export$b1a50ad717b4ca61);

var $3HCkE = parcelRequire("3HCkE");

const $ebb62170859aa532$var$ONE_DAY_IN_MILLIS = 86400000;

const $ebb62170859aa532$export$b1a50ad717b4ca61 = (0, $3HCkE.createResource)({
    type: (0, $9ba0002b4c368082$export$eb7818fb178a80b4),
    getKey: ()=>'settings',
    getDataLoader: ()=>(parcelRequire("9a0IS")),
    maxAge: $ebb62170859aa532$var$ONE_DAY_IN_MILLIS
});

});
parcelRegister("9a0IS", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('l09R5');
        const value = parcelRequire('6kJQl');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("l09R5").then(()=>parcelRequire('6kJQl'));
}

});


parcelRegister("3ZIr5", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('dCfiZ')
        ]);
        const value = parcelRequire('2pFj4');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("dCfiZ")
    ]).then(()=>parcelRequire('2pFj4'));
}

});

parcelRegister("djTwl", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('hHwgH')
        ]);
        const value = parcelRequire('7xeN1');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("hHwgH")
    ]).then(()=>parcelRequire('7xeN1'));
}

});

parcelRegister("leDf8", function(module, exports) {

$parcel$export(module.exports, "SidebarGlobalSettingsSystem", () => $bac2e68fb50bbd0f$export$52af3150b9f64726);

var $eUqFw = parcelRequire("eUqFw");

var $4Ti3v = parcelRequire("4Ti3v");
var $u0mbR = parcelRequire("u0mbR");

var $jlT0W = parcelRequire("jlT0W");
const $bac2e68fb50bbd0f$export$52af3150b9f64726 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $u0mbR.SidebarRenderStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jlT0W.Menu), null), !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $u0mbR.SidebarReady), {
        id: (0, $4Ti3v.SIDEBAR_ID).GLOBAL_SETTINGS_SYSTEM
    }));

});
parcelRegister("4Ti3v", function(module, exports) {

$parcel$export(module.exports, "SIDEBAR_ID", () => $7a89ae81cc6f8c6c$export$adf978edbdfaf080);
const $7a89ae81cc6f8c6c$export$adf978edbdfaf080 = {
    CONNECT: 'CONNECT',
    CORE: 'CORE',
    FILTERS: 'FILTERS',
    FILTERS_GLOBAL: 'FILTERS_GLOBAL',
    FORGE_GLOBAL_PAGE: 'FORGE_GLOBAL_PAGE',
    GLOBAL_SETTINGS_APPS: 'GLOBAL_SETTINGS_APPS',
    GLOBAL_SETTINGS_ISSUES: 'GLOBAL_SETTINGS_ISSUES',
    GLOBAL_SETTINGS_PRODUCTS: 'GLOBAL_SETTINGS_PRODUCTS',
    GLOBAL_SETTINGS_PROJECTS: 'GLOBAL_SETTINGS_PROJECTS',
    GLOBAL_SETTINGS_SYSTEM: 'GLOBAL_SETTINGS_SYSTEM',
    JSM: 'JSM',
    JSW_CLASSIC: 'JSW_CLASSIC',
    JSW_NEXT_GEN: 'JSW_NEXT_GEN',
    PERSONAL_SETTINGS: 'PERSONAL_SETTINGS',
    EOC_OPERATIONS: 'EOC_OPERATIONS',
    POLARIS: 'POLARIS',
    USER: 'USER'
};

});

parcelRegister("jlT0W", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $fd0713a46401c6f7$export$d9b273488cd8ce6f);

var $eUqFw = parcelRequire("eUqFw");

var $8ZwXC = parcelRequire("8ZwXC");
var $gxMC2 = parcelRequire("gxMC2");
var $8N3rk = parcelRequire("8N3rk");
var $20Dml = parcelRequire("20Dml");
var $gLn5u = parcelRequire("gLn5u");

var $exb0h = parcelRequire("exb0h");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hzZWH = parcelRequire("hzZWH");
var $iaHqR = parcelRequire("iaHqR");
var $bS2FN = parcelRequire("bS2FN");
var $1UelU = parcelRequire("1UelU");
var $9kVcv = parcelRequire("9kVcv");

var $aWYQ8 = parcelRequire("aWYQ8");

var $10fdS = parcelRequire("10fdS");

var $edsEA = parcelRequire("edsEA");

var $cvu76 = parcelRequire("cvu76");

var $hrMrK = parcelRequire("hrMrK");

var $gS9Pi = parcelRequire("gS9Pi");

var $4VoIp = parcelRequire("4VoIp");

var $ii4v1 = parcelRequire("ii4v1");

var $lLbUm = parcelRequire("lLbUm");

var $gzoho = parcelRequire("gzoho");

var $dL8Xn = parcelRequire("dL8Xn");

var $7NvRo = parcelRequire("7NvRo");

var $kdz1U = parcelRequire("kdz1U");

var $3I29L = parcelRequire("3I29L");

var $7SUOK = parcelRequire("7SUOK");
// @ts-expect-error - TS7006 - Parameter 'route' implicitly has an 'any' type.
const $fd0713a46401c6f7$var$calculateStack = (route)=>{
    const routeName = route && route.name || '';
    if ([
        (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_MIGRATIONS_DASHBOARD,
        (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_MIGRATIONS_HOME,
        (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_MIGRATIONS_FOCUS_PAGE
    ].includes(routeName)) return [
        (0, $edsEA.SECTION_ID).MIGRATE_TO_CLOUD_SITE
    ];
    if ([
        (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_PERFORMANCE_METRIC_DETAIL,
        (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_PERFORMANCE_OVERVIEW,
        (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_PERFORMANCE_PROJECT_CLEANUP,
        (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_PERFORMANCE_PROJECT_ROLE_ACTOR,
        (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_PERFORMANCE_CUSTOM_FIELD,
        (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_PERFORMANCE_ISSUE
    ].includes(routeName)) return [
        (0, $edsEA.SECTION_ID).PERFORMANCE_AND_SCALE
    ];
    return [];
};
const $fd0713a46401c6f7$export$d9b273488cd8ce6f = ()=>{
    const { data: features } = (0, $cvu76.useFeatures)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const route = (0, $10fdS.useCurrentRoute)();
    const { data: connectItems } = (0, $cvu76.useGlobalSettingsSystemConnectItems)();
    const [stack, setStack] = (0, $eUqFw.useState)($fd0713a46401c6f7$var$calculateStack(route));
    (0, $eUqFw.useEffect)(()=>{
        setStack($fd0713a46401c6f7$var$calculateStack(route));
    }, [
        route
    ]);
    const navigationPath = (0, $eUqFw.useMemo)(()=>(0, $iaHqR.getSystemNavigationPaths)(), []);
    const generalConfigurationPath = navigationPath.generalConfiguration;
    if (features == null || connectItems == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null);
    const navigationContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, features.hasGeneralConfiguration && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'general-configuration'
        },
        href: generalConfigurationPath,
        selectedOn: (0, $7SUOK.isGeneralConfigurationSelected)
    }, formatMessage((0, $gzoho.default).generalConfiguration)), features.hasDarkFeatures && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'dark-features'
        },
        href: navigationPath.darkFeatures,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $gzoho.default).darkFeatures)), features.hasTroubleshootingAndSupportSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kdz1U.TroubleshootingAndSupportSection), null), features.hasSecuritySection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dL8Xn.SecuritySection), null), features.hasCollectors && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'collectors'
        },
        href: navigationPath.issueCollectors,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $gzoho.default).issueCollectors)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4VoIp.AutomationSection), null), features.hasUserInterfaceSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3I29L.UserInterfaceSection), null), features.hasImportExportSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ii4v1.ImportExportSection), {
        stack: stack
    }), features.hasMailSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLbUm.MailSection), null), features.hasAdminHelperSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hrMrK.AdminHelperSection), null), features.hasSharedSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7NvRo.SharedSection), null), features.hasAdvancedSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gS9Pi.AdvancedSection), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aWYQ8.ConnectMenu), {
        items: connectItems,
        overrides: {
            BackMenuItem: {
                href: '/jira/settings/system/general-configuration',
                title: formatMessage((0, $gzoho.default).systemGroup)
            }
        }
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hzZWH.ContextualAnalyticsData), {
        menuId: "global-settings/system",
        stack: stack
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $20Dml.default), {
        label: ""
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gxMC2.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9kVcv.TitleHeader), null, formatMessage((0, $gzoho.default).systemGroup))), (0, $1ybV0.ff)('jira-system-settings-cloud-to-cloud-migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8N3rk.default), {
        stack: stack,
        onChange: setStack
    }, navigationContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ZwXC.default), null, navigationContent)));
};

});
parcelRegister("8ZwXC", function(module, exports) {

$parcel$export(module.exports, "default", () => $79677661d4a83719$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $dxAkq = parcelRequire("dxAkq");

var $cgrgx = parcelRequire("cgrgx");

var $3KfxB = parcelRequire("3KfxB");
/**
 * __Navigation content__
 *
 * A navigation content is used as the container for navigation items.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#content)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $79677661d4a83719$var$NavigationContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { showTopScrollIndicator: showTopScrollIndicator, children: children, testId: testId } = props;
    const { shouldRender: shouldRender } = (0, $cgrgx.useShouldNestedElementRender)();
    const scrollbar = (0, $dxAkq.default)();
    if (!shouldRender) return children;
    const typedRef = ref;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: typedRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $3KfxB.outerContainerCSS)({
            showTopScrollIndicator: showTopScrollIndicator,
            scrollbarWidth: scrollbar.width
        }),
        "data-testid": testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: scrollbar.ref,
        css: (0, $3KfxB.innerContainerCSS)({
            showTopScrollIndicator: showTopScrollIndicator
        })
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: (0, $3KfxB.containerCSS)({
            showTopScrollIndicator: showTopScrollIndicator
        })
    }, children)));
});
var $79677661d4a83719$export$2e2bcd8739ae039 = $79677661d4a83719$var$NavigationContent;

});
parcelRegister("dxAkq", function(module, exports) {

$parcel$export(module.exports, "default", () => $61bf491fcf88b5a3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $61bf491fcf88b5a3$export$2e2bcd8739ae039() {
    const [scrollbarWidth, setScrollbarWidth] = (0, $eUqFw.useState)(0);
    const elementRef = (0, $eUqFw.useRef)(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eUqFw.useEffect)(()=>{
        if (!elementRef.current) return;
        const width = elementRef.current.offsetWidth - elementRef.current.scrollWidth;
        if (width === scrollbarWidth) return;
        setScrollbarWidth(width);
    });
    return {
        width: scrollbarWidth,
        ref: elementRef
    };
}

});

parcelRegister("3KfxB", function(module, exports) {

$parcel$export(module.exports, "outerContainerCSS", () => $cbf9fac083377857$export$3ff462c0176a504f);
$parcel$export(module.exports, "innerContainerCSS", () => $cbf9fac083377857$export$4d1aec15cfcfc2a4);
$parcel$export(module.exports, "containerCSS", () => $cbf9fac083377857$export$949392aeaf7d2e3a);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $PdmhA = parcelRequire("PdmhA");

var $4lTFP = parcelRequire("4lTFP");

const $cbf9fac083377857$var$scrollIndicatorMaskZIndex = 2;
const $cbf9fac083377857$var$scrollIndicatorZIndex = 1;
const $cbf9fac083377857$var$scrollIndicatorHeight = 2;
const $cbf9fac083377857$var$scrollIndicatorBorderRadius = '1px';
const $cbf9fac083377857$var$containerPadding = 8;
const $cbf9fac083377857$var$itemHeadingContentHeight = (0, $4lTFP.headingSizes).h100.lineHeight;
const $cbf9fac083377857$var$skeletonHeadingHeight = $cbf9fac083377857$var$containerPadding;
const $cbf9fac083377857$var$skeletonHeadingMarginOffset = 3;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
const $cbf9fac083377857$var$skeletonHeadingTopMargin = $cbf9fac083377857$var$containerPadding * 2.5 + ($cbf9fac083377857$var$itemHeadingContentHeight - $cbf9fac083377857$var$skeletonHeadingHeight) - $cbf9fac083377857$var$skeletonHeadingMarginOffset;
// We want to move the entire body up by 3px without affecting the height of the skeleton container.
const $cbf9fac083377857$var$skeletonHeadingBottomMargin = $cbf9fac083377857$var$containerPadding * 0.75 + $cbf9fac083377857$var$skeletonHeadingMarginOffset;
const $cbf9fac083377857$export$3ff462c0176a504f = (opts)=>({
        // Flex is needed to ensure the overflow indicators are positioned correctly.
        display: 'flex',
        height: '100%',
        overflow: 'hidden',
        position: 'relative',
        '&::before': {
            content: "''",
            display: 'block',
            left: "var(--ds-space-100, 8px)",
            right: $cbf9fac083377857$var$containerPadding + opts.scrollbarWidth,
            height: $cbf9fac083377857$var$scrollIndicatorHeight,
            borderRadius: `var(--ds-border-radius-050, ${$cbf9fac083377857$var$scrollIndicatorBorderRadius})`,
            backgroundColor: `var(${0, $653c080b5250656d$export$e8e7f51e033d4cb2}, ${`var(--ds-border, ${0, $PdmhA.N30})`})`,
            position: 'absolute',
            zIndex: $cbf9fac083377857$var$scrollIndicatorZIndex
        },
        '&::after': {
            content: "''",
            position: 'absolute',
            display: 'block',
            borderRadius: `var(--ds-border-radius-050, ${$cbf9fac083377857$var$scrollIndicatorBorderRadius})`,
            flexShrink: 0,
            height: $cbf9fac083377857$var$scrollIndicatorHeight,
            left: "var(--ds-space-100, 8px)",
            right: $cbf9fac083377857$var$containerPadding + opts.scrollbarWidth,
            bottom: 0,
            zIndex: $cbf9fac083377857$var$scrollIndicatorZIndex,
            backgroundColor: `var(${0, $653c080b5250656d$export$e8e7f51e033d4cb2}, ${`var(--ds-border, ${0, $PdmhA.N30})`})`
        }
    });
const $cbf9fac083377857$export$4d1aec15cfcfc2a4 = (opts)=>({
        display: 'flex',
        overflow: 'auto',
        width: '100%',
        position: 'relative',
        boxSizing: 'border-box',
        flexDirection: 'column',
        // This before pseudo element is works by being positioned at the top of this scrolling
        // container - so when you scroll down it stops "masking" the actual scroll indicator.
        ...!opts.showTopScrollIndicator && {
            '&::before': {
                borderRadius: `var(--ds-border-radius-050, ${$cbf9fac083377857$var$scrollIndicatorBorderRadius})`,
                content: "''",
                left: 0,
                right: 0,
                height: $cbf9fac083377857$var$scrollIndicatorHeight,
                backgroundColor: `var(${0, $653c080b5250656d$export$49e4dd5760b312e0}, ${`var(--ds-surface, ${0, $PdmhA.N10})`})`,
                position: 'absolute',
                display: 'block',
                zIndex: $cbf9fac083377857$var$scrollIndicatorMaskZIndex
            }
        },
        // This after pseudo element abuses being a flex child and pushes itself down to the
        // very bottom of the container - doing so ends up "masking" the actual scroll indicator.
        '&::after': {
            borderRadius: `var(--ds-border-radius-050, ${$cbf9fac083377857$var$scrollIndicatorBorderRadius})`,
            content: "''",
            display: 'block',
            flexShrink: 0,
            height: $cbf9fac083377857$var$scrollIndicatorHeight,
            // This is used to "push" the element to the bottom of the flex container.
            marginTop: 'auto',
            position: 'relative',
            zIndex: $cbf9fac083377857$var$scrollIndicatorMaskZIndex,
            backgroundColor: `var(${0, $653c080b5250656d$export$49e4dd5760b312e0}, ${`var(--ds-surface, ${0, $PdmhA.N10})`})`
        }
    });
const $cbf9fac083377857$export$949392aeaf7d2e3a = (opts)=>({
        // When the scroll indicator is always shown we need to add some padding
        // so the spacing between matches what it would be if the indicator was a "block" element.
        // We use margin here so any child absolutely positioned elements are positioned correctly.
        marginTop: opts.showTopScrollIndicator ? $cbf9fac083377857$var$scrollIndicatorHeight : 0,
        marginLeft: "var(--ds-space-100, 8px)",
        marginRight: "var(--ds-space-100, 8px)",
        // Enables child absolutely positioned elements to be positioned relative to this element.
        position: 'relative',
        '& [data-ds--menu--heading-item]': {
            marginBottom: "var(--ds-space-075, 6px)",
            marginTop: "var(--ds-space-200, 16px)"
        },
        '& [data-ds--menu--skeleton-heading-item]': {
            marginTop: $cbf9fac083377857$var$skeletonHeadingTopMargin,
            marginBottom: $cbf9fac083377857$var$skeletonHeadingBottomMargin
        }
    });

});
const $653c080b5250656d$export$e8e7f51e033d4cb2 = '--ds-menu-seperator-color';
const $653c080b5250656d$export$49e4dd5760b312e0 = '--ds-menu-scroll-indicator-color';



parcelRegister("gxMC2", function(module, exports) {

$parcel$export(module.exports, "default", () => $65b445d0e74737f3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $65b445d0e74737f3$var$navigationFooterStyles = (0, $1ZAYh.xcss)({
    display: 'block',
    padding: 'space.100',
    paddingBlockStart: 'space.300'
});
/**
 * __Navigation header__
 *
 * Allows for customisation of the header.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $65b445d0e74737f3$var$NavigationHeader = (props)=>{
    const { children: children } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $65b445d0e74737f3$var$navigationFooterStyles,
        "data-navheader": true
    }, children);
};
var $65b445d0e74737f3$export$2e2bcd8739ae039 = $65b445d0e74737f3$var$NavigationHeader;

});

parcelRegister("8N3rk", function(module, exports) {

$parcel$export(module.exports, "ROOT_ID", () => $cc821c64d466644f$export$ec71a3379b43ae5c);
$parcel$export(module.exports, "default", () => $cc821c64d466644f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lSV8Z = parcelRequire("lSV8Z");

var $bM0x9 = parcelRequire("bM0x9");

var $9iAqW = parcelRequire("9iAqW");

var $1Z5iN = parcelRequire("1Z5iN");

var $cgrgx = parcelRequire("cgrgx");

var $C037h = parcelRequire("C037h");
function $cc821c64d466644f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $cc821c64d466644f$export$ec71a3379b43ae5c = 'ATLASKIT_NESTED_ROOT';
const $cc821c64d466644f$var$nestableNavigationContentStyles = {
    name: "hxjswn",
    styles: "height:100%;position:relative;outline:none"
};
const $cc821c64d466644f$var$nestingRootStyles = {
    name: "1klp5xc",
    styles: "display:flex;width:100%;height:100%;position:absolute;flex-direction:column"
};
/**
 * __Nestable navigation content__
 *
 * The container for navigation items with nested views
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#nested-navigation)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $cc821c64d466644f$var$NestableNavigationContent = (props)=>{
    const containerRef = (0, $eUqFw.useRef)(null);
    const { children: children, testId: testId, overrides: overrides, initialStack: initialStack, onChange: onChange, onUnknownNest: onUnknownNest, stack: stack, showTopScrollIndicator: showTopScrollIndicator } = props;
    const [committedStack, setCommittedStack] = (0, $eUqFw.useState)(stack || initialStack || []);
    const controlledStack = stack || undefined;
    const currentStackId = committedStack[committedStack.length - 1] || $cc821c64d466644f$export$ec71a3379b43ae5c;
    const [transition, setTransition] = (0, $eUqFw.useState)('nesting');
    const backTestId = testId && `${testId}--go-back-item`;
    const renderGoBackItem = overrides && overrides.GoBackItem && overrides.GoBackItem.render ? overrides.GoBackItem.render : (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $bM0x9.default), props, "Go back");
    const { childIdsRef: childIdsRef } = (0, $1Z5iN.useChildIds)(currentStackId, committedStack, onUnknownNest);
    const onNestHandler = (0, $eUqFw.useCallback)((layerId)=>{
        onChange && onChange(committedStack.concat(layerId));
        if (controlledStack) // We are in controlled mode - ignore the steps.
        return;
        // We need to split the state update into to parts.
        // First: Updating the direction of the motions.
        // Second: Actually updating the stack (which will cause elements to enter & leave).
        setTransition('nesting');
        requestAnimationFrame(()=>{
            setCommittedStack((prev)=>{
                const newStack = prev.concat(layerId);
                return newStack;
            });
        });
    }, [
        controlledStack,
        onChange,
        committedStack
    ]);
    const onUnNestHandler = (0, $eUqFw.useCallback)(()=>{
        onChange && onChange(committedStack.slice(0, committedStack.length - 1));
        if (controlledStack) // We are in controlled mode - ignore the steps.
        return;
        // We need to split the state update into to parts.
        // First: Updating the direction of the motions.
        // Second: Actually updating the stack (which will cause elements to enter & leave).
        setTransition('unnesting');
        requestAnimationFrame(()=>{
            setCommittedStack((prev)=>{
                const newStack = prev.slice(0, prev.length - 1);
                return newStack;
            });
        });
    }, [
        controlledStack,
        onChange,
        committedStack
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!controlledStack) // We aren't in controlled mode - bail out.
        return;
        if (JSON.stringify(committedStack) === JSON.stringify(controlledStack)) // stacks are equal - do nothing!
        return;
        // Controlled prop updated, let's figure out if we're nesting or unnesting.
        if (controlledStack.length < committedStack.length) // We are unnesting (removing from the stack)
        setTransition('unnesting');
        else // We are nesting (adding to the stack)
        setTransition('nesting');
        requestAnimationFrame(()=>{
            setCommittedStack(controlledStack);
        });
    }, [
        committedStack,
        controlledStack
    ]);
    const backButton = renderGoBackItem({
        onClick: onUnNestHandler,
        testId: backTestId
    });
    const context = (0, $eUqFw.useMemo)(()=>({
            currentStackId: currentStackId,
            backButton: backButton,
            stack: committedStack,
            onNest: onNestHandler,
            onUnNest: onUnNestHandler,
            parentId: $cc821c64d466644f$export$ec71a3379b43ae5c,
            childIds: childIdsRef,
            forceShowTopScrollIndicator: showTopScrollIndicator
        }), [
        currentStackId,
        backButton,
        committedStack,
        onNestHandler,
        onUnNestHandler,
        childIdsRef,
        showTopScrollIndicator
    ]);
    const manageFocus = (event)=>{
        const triggeredByKeyboard = event.nativeEvent.detail === 0;
        if (triggeredByKeyboard) containerRef.current && containerRef.current.focus();
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        css: $cc821c64d466644f$var$nestableNavigationContentStyles,
        ref: containerRef,
        tabIndex: -1,
        onClick: manageFocus
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $lSV8Z.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $C037h.NestingMotion), {
        // Key is needed to have a unique react instance per stack name.
        // This enables us to easily animate it in & out with exiting persistence.
        key: currentStackId,
        enterFrom: transition === 'nesting' ? 'right' : 'left',
        exitTo: transition === 'nesting' ? 'left' : 'right',
        testId: testId && `${testId}-anim`
    }, (motion)=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $cc821c64d466644f$var$nestingRootStyles,
            ...motion
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $cgrgx.NestedContext).Provider, {
            // This provider is inside the NestingMotion to ensure it keeps a stale
            // reference to the previous value.
            value: context
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9iAqW.default), {
            title: "",
            id: $cc821c64d466644f$export$ec71a3379b43ae5c
        }, children)))))));
};
var $cc821c64d466644f$export$2e2bcd8739ae039 = $cc821c64d466644f$var$NestableNavigationContent;

});
parcelRegister("bM0x9", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f212f85e4c65f98$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fyp42 = parcelRequire("fyp42");

var $PdmhA = parcelRequire("PdmhA");

var $iaRDX = parcelRequire("iaRDX");
/**
 * __Go back item__
 *
 * A go back item is used to provide a customized "go back" button in nested
 * navigations.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#go-back-item)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $4f212f85e4c65f98$var$GoBackItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ cssFn: cssFn, iconBefore: iconBefore = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fyp42))), {
    secondaryColor: `var(--ds-surface, ${(0, $PdmhA.N10)})`,
    label: ""
}), onClick: onClick, isSelected: isSelected, ...rest }, ref)=>{
    const [isInteracted, setIsInteracted] = (0, $eUqFw.useState)(false);
    const onClickHandler = (0, $eUqFw.useCallback)((e)=>{
        if (isInteracted) return;
        setIsInteracted(true);
        onClick && onClick(e);
    }, [
        onClick,
        isInteracted
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iaRDX.default), {
        isSelected: isSelected,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        cssFn: cssFn,
        iconBefore: iconBefore,
        onClick: onClickHandler,
        ref: ref,
        ...rest
    });
});
var $4f212f85e4c65f98$export$2e2bcd8739ae039 = $4f212f85e4c65f98$var$GoBackItem;

});
parcelRegister("fyp42", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b52d792fd039ccff$var$_react = $b52d792fd039ccff$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $b52d792fd039ccff$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $b52d792fd039ccff$var$ArrowLeftCircleIcon = (props)=>/*#__PURE__*/ $b52d792fd039ccff$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><circle fill="currentColor" cx="12" cy="12" r="10"/><path d="M16 10.995h-5.586l1.272-1.279a1.01 1.01 0 000-1.421.996.996 0 00-1.415 0l-2.978 2.994a1.01 1.01 0 000 1.423l2.978 2.993a.999.999 0 001.415 0 1.01 1.01 0 000-1.421l-1.272-1.279H16c.552 0 1-.45 1-1.005 0-.555-.448-1.005-1-1.005" fill="inherit"/></svg>`
    }, props));
$b52d792fd039ccff$var$ArrowLeftCircleIcon.displayName = 'ArrowLeftCircleIcon';
var $b52d792fd039ccff$var$_default = $b52d792fd039ccff$var$ArrowLeftCircleIcon;
module.exports.default = $b52d792fd039ccff$var$_default;

});

parcelRegister("iaRDX", function(module, exports) {

$parcel$export(module.exports, "default", () => $214046ccd34b0757$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bULPy = parcelRequire("bULPy");

var $jvM56 = parcelRequire("jvM56");

var $cgrgx = parcelRequire("cgrgx");
/**
 * __Button item__
 *
 * A button item renders an item wrapped in a button tag, used primarily when an
 * action does something other than changing routes.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#button-item)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $214046ccd34b0757$var$ButtonItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(// Type needed on props to extract types with extract react types.
({ cssFn: cssFn, ...rest }, ref)=>{
    const { shouldRender: shouldRender } = (0, $cgrgx.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    const cssOverride = (0, $jvM56.overrideStyleFunction)((0, $jvM56.baseSideNavItemStyle), cssFn);
    // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis, @repo/internal/react/no-unsafe-overrides
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        ref: ref,
        cssFn: cssOverride,
        ...rest
    });
});
var $214046ccd34b0757$export$2e2bcd8739ae039 = $214046ccd34b0757$var$ButtonItem;

});


parcelRegister("9iAqW", function(module, exports) {

$parcel$export(module.exports, "default", () => $56cec1d16683bfce$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $k4jc8 = parcelRequire("k4jc8");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $jvM56 = parcelRequire("jvM56");

var $iaRDX = parcelRequire("iaRDX");
var $gMdj1 = parcelRequire("gMdj1");
var $8ZwXC = parcelRequire("8ZwXC");

var $8N3rk = parcelRequire("8N3rk");

var $cgrgx = parcelRequire("cgrgx");

var $1Z5iN = parcelRequire("1Z5iN");

var $kJUBw = parcelRequire("kJUBw");
const $56cec1d16683bfce$var$iconContainerStyles = (0, $1ZAYh.xcss)({
    display: 'inline'
});
/**
 * NestingItem will render itself differently depending in what context it is rendered in.
 * When not open - it will render itself as an item.
 * When open - it will render its children.
 */ const $56cec1d16683bfce$var$NestingItem = (props)=>{
    const { children: children, iconAfter: iconAfter, title: title, onClick: onClick, cssFn: cssFn, isSelected: isSelected, id: id, component: component, testId: testId, ...rest } = props;
    const { currentStackId: currentStackId, onNest: onNest, onUnNest: onUnNest, backButton: contextualBackButton, stack: stack, childIds: childIds, forceShowTopScrollIndicator: forceShowTopScrollIndicator } = (0, $cgrgx.useNestedContext)();
    const mergedStyles = (0, $jvM56.overrideStyleFunction)((0, $kJUBw.nestingItemStyle), cssFn);
    const [isInteracted, setIsInteracted] = (0, $eUqFw.useState)(false);
    const backButton = props.overrides && props.overrides.GoBackItem && props.overrides.GoBackItem.render && props.overrides.GoBackItem.render({
        onClick: onUnNest,
        testId: testId && `${testId}--go-back-item`
    }) || contextualBackButton;
    const context = (0, $eUqFw.useMemo)(()=>({
            stack: stack,
            currentStackId: currentStackId,
            onNest: onNest,
            onUnNest: onUnNest,
            backButton: backButton,
            parentId: id,
            childIds: childIds,
            forceShowTopScrollIndicator: forceShowTopScrollIndicator
        }), [
        stack,
        currentStackId,
        onNest,
        onUnNest,
        backButton,
        id,
        childIds,
        forceShowTopScrollIndicator
    ]);
    (0, $1Z5iN.useChildIdsEffect)(childIds, id);
    const isNormalClick = (e)=>!(e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
    /**
   * We want both the on nest handler and the onclick handler to be called.
   * We create a wrapper function to call both.
   */ const onClickHandler = (0, $eUqFw.useCallback)((e)=>{
        if (isInteracted) // We return early if this has been interacted with because its assumed
        // this will be already exiting - so we don't want to double up the click.
        return;
        // Avoid a nesting transition if a modifier key is detected during click.
        // @ts-expect-error - Argument of type 'MouseEvent<Element, MouseEvent> | KeyboardEvent<Element>' is not assignable to parameter of type 'MouseEvent'
        if (isNormalClick(e)) {
            setIsInteracted(true);
            onNest(id);
        }
        onClick && onClick(e);
    }, [
        isInteracted,
        onClick,
        onNest,
        id
    ]);
    if (currentStackId === id) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $cgrgx.NestedContext).Provider, {
        value: context
    }, stack.length >= 1 && /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        paddingBlock: "space.075",
        paddingInline: "space.100"
    }, backButton), /*#__PURE__*/ (0, $byn9U.jsx)((0, $8ZwXC.default), {
        testId: testId,
        showTopScrollIndicator: forceShowTopScrollIndicator || stack.length >= 1
    }, children));
    if ([
        (0, $8N3rk.ROOT_ID),
        ...stack
    ].includes(id)) return children;
    const componentProps = {
        iconAfter: /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, iconAfter ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
            xcss: $56cec1d16683bfce$var$iconContainerStyles,
            "data-custom-icon": true,
            as: "span"
        }, iconAfter) : null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
            "data-right-arrow": true,
            xcss: $56cec1d16683bfce$var$iconContainerStyles,
            as: "span"
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k4jc8))), {
            testId: testId && `${testId}--item--right-arrow`,
            secondaryColor: `var(--ds-surface, ${(0, $PdmhA.N10)})`,
            label: ""
        }))),
        onClick: onClickHandler,
        isSelected: isSelected,
        testId: testId && `${testId}--item`,
        ...rest,
        children: title,
        cssFn: mergedStyles
    };
    if (component) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $gMdj1.default), {
        ...componentProps,
        //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
        component: component
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $iaRDX.default), componentProps);
};
var $56cec1d16683bfce$export$2e2bcd8739ae039 = $56cec1d16683bfce$var$NestingItem;

});
parcelRegister("k4jc8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e9c31206c0c7e54b$var$_react = $e9c31206c0c7e54b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $e9c31206c0c7e54b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e9c31206c0c7e54b$var$ArrowRightCircleIcon = (props)=>/*#__PURE__*/ $e9c31206c0c7e54b$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" fill-rule="nonzero" cx="12" cy="12" r="10"/><path d="M12.314 8.294a1.01 1.01 0 000 1.422l1.271 1.279H8c-.553 0-1.001.45-1.001 1.005 0 .555.448 1.005 1.001 1.005h5.585l-1.271 1.279a1.01 1.01 0 000 1.422 1.001 1.001 0 001.415 0l2.978-2.995a1.01 1.01 0 000-1.422l-2.978-2.995a.998.998 0 00-1.415 0z" fill="inherit"/></g></svg>`
    }, props));
$e9c31206c0c7e54b$var$ArrowRightCircleIcon.displayName = 'ArrowRightCircleIcon';
var $e9c31206c0c7e54b$var$_default = $e9c31206c0c7e54b$var$ArrowRightCircleIcon;
module.exports.default = $e9c31206c0c7e54b$var$_default;

});

parcelRegister("gMdj1", function(module, exports) {

$parcel$export(module.exports, "default", () => $5254fde102c89aa1$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-overrides */ 
var $eUqFw = parcelRequire("eUqFw");

var $e7PSD = parcelRequire("e7PSD");

var $jvM56 = parcelRequire("jvM56");

var $cgrgx = parcelRequire("cgrgx");
/**
 * Used to support any custom items needed by products alongside the Header and Footer patterns.
 * Specific implementation of headers and footers are provided in the examples folder.
 */ const $5254fde102c89aa1$var$CustomItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(// Type needed on props to extract types with extract react types.
({ cssFn: cssFn, ...rest }, ref)=>{
    const { shouldRender: shouldRender } = (0, $cgrgx.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    const cssOverride = (0, $jvM56.overrideStyleFunction)((0, $jvM56.baseSideNavItemStyle), cssFn);
    // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7PSD.default), {
        ref: ref,
        cssFn: cssOverride,
        ...rest
    });
});
var $5254fde102c89aa1$export$2e2bcd8739ae039 = $5254fde102c89aa1$var$CustomItem;

});

parcelRegister("1Z5iN", function(module, exports) {

$parcel$export(module.exports, "useChildIds", () => $757bdf2b7228d1ef$export$61b3ef4f009a9474);
$parcel$export(module.exports, "useChildIdsEffect", () => $757bdf2b7228d1ef$export$ea18c2b5f0e24612);

var $eUqFw = parcelRequire("eUqFw");

var $8N3rk = parcelRequire("8N3rk");
const $757bdf2b7228d1ef$export$61b3ef4f009a9474 = (currentStackId, committedStack, onUnknownNest)=>{
    const childIdsRef = (0, $eUqFw.useRef)(new Set());
    (0, $eUqFw.useEffect)(()=>{
        // we are holding navigation item IDs in childIdsRef
        // check if the current displayed nav item (currentStackId) is in childIdsRef. if it's not, this means it's undefined
        if (currentStackId === (0, $8N3rk.ROOT_ID) || !childIdsRef.current.size || childIdsRef.current.has(currentStackId) || !onUnknownNest) return;
        onUnknownNest(committedStack || [
            currentStackId
        ]);
    }, [
        currentStackId,
        committedStack,
        onUnknownNest
    ]);
    return {
        childIdsRef: childIdsRef
    };
};
const $757bdf2b7228d1ef$export$ea18c2b5f0e24612 = (childIds, id)=>{
    (0, $eUqFw.useEffect)(()=>{
        if (!childIds || !childIds.current) return;
        if (!childIds.current.has(id)) childIds.current.add(id);
        return ()=>{
            // eslint-disable-next-line react-hooks/exhaustive-deps
            childIds.current.delete(id);
        };
    // childIds shouldn't change as it's a ref
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        id
    ]);
};

});

parcelRegister("kJUBw", function(module, exports) {

$parcel$export(module.exports, "nestingItemStyle", () => $a9d327ba12673c0a$export$38e770f85519b259);
const $a9d327ba12673c0a$export$4c36b5b1b67ee1e8 = {
    ['&:hover [data-custom-icon]']: {
        display: 'none'
    },
    ['&:active [data-custom-icon]']: {
        display: 'none'
    },
    ['&:focus [data-custom-icon]']: {
        display: 'none'
    },
    ['& [data-custom-icon]']: {
        display: 'inherit'
    },
    ['&:hover [data-right-arrow]']: {
        display: 'inherit'
    },
    ['&:active [data-right-arrow]']: {
        display: 'inherit'
    },
    ['&:focus [data-right-arrow]']: {
        display: 'inherit'
    },
    ['& [data-right-arrow]']: {
        display: 'none'
    }
};
const $a9d327ba12673c0a$var$disabledCSS = {
    ['[data-item-elem-after]']: {
        opacity: 0
    },
    ['& [data-right-arrow]']: {
        display: 'none'
    }
};
const $a9d327ba12673c0a$export$38e770f85519b259 = (state)=>{
    return {
        ...state.isDisabled ? $a9d327ba12673c0a$var$disabledCSS : $a9d327ba12673c0a$export$4c36b5b1b67ee1e8
    };
};

});


parcelRegister("C037h", function(module, exports) {

$parcel$export(module.exports, "NestingMotion", () => $dec7f8f6c7da8f0e$export$9e743a8c2a6b450e);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $2EVgw = parcelRequire("2EVgw");
const $dec7f8f6c7da8f0e$export$9e743a8c2a6b450e = (props)=>{
    const { children: children, enterFrom: enterFrom, exitTo: exitTo, testId: testId } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $2EVgw.default), {
        exitTo: exitTo,
        enterFrom: enterFrom,
        animationTimingFunction: (_)=>(0, $d58b680a02f4d6a4$export$57636bb43b1ccbb0)
    }, (innerProps, direction)=>children({
            'data-enter-from': enterFrom,
            'data-exit-to': exitTo,
            'data-testid': testId && `${testId}-${direction}`,
            ...innerProps
        }));
};

});


parcelRegister("20Dml", function(module, exports) {

$parcel$export(module.exports, "default", () => $52d1dc06fce7952b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8jcoK = parcelRequire("8jcoK");

var $PdmhA = parcelRequire("PdmhA");
const $52d1dc06fce7952b$var$sidebarMinWidth = '240px';
const $52d1dc06fce7952b$var$sideNavStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    width: '100%',
    minWidth: $52d1dc06fce7952b$var$sidebarMinWidth,
    height: '100%',
    position: 'relative',
    flexDirection: 'column',
    backgroundColor: `var(--ds-surface, ${(0, $PdmhA.N10)})`,
    color: `var(--ds-text-subtle, ${(0, $PdmhA.N500)})`,
    overflow: 'hidden'
});
/**
 * __Side navigation__
 *
 * A highly composable side navigation component that supports nested views.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 * - [Usage](https://atlassian.design/components/side-navigation/usage)
 */ const $52d1dc06fce7952b$var$SideNavigation = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, label: label } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("nav", {
        ref: ref,
        "data-testid": testId,
        "aria-label": label,
        css: $52d1dc06fce7952b$var$sideNavStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8jcoK.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "notch"
    }, children));
});
var $52d1dc06fce7952b$export$2e2bcd8739ae039 = $52d1dc06fce7952b$var$SideNavigation;

});

parcelRegister("hzZWH", function(module, exports) {

$parcel$export(module.exports, "ContextualAnalyticsData", () => $9c9a74070e1186f3$export$198470770171c65);
$parcel$export(module.exports, "IssuesContextualAnalyticsData", () => $9c9a74070e1186f3$export$bc7f6eebc16e6127);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $8WuJm = parcelRequire("8WuJm");

var $cPEpP = parcelRequire("cPEpP");

var $eEZvV = parcelRequire("eEZvV");
const $9c9a74070e1186f3$export$198470770171c65 = ({ attributes: attributes, menuId: menuId, stack: stack = [], ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        ...rest,
        attributes: {
            ...attributes,
            viewId: (0, $eEZvV.generateViewId)(menuId, ...stack),
            navVersion: '3',
            navigationLayer: 'container'
        }
    });
const $9c9a74070e1186f3$export$bc7f6eebc16e6127 = ({ attributes: attributes, navigatorScope: navigatorScope, useProject: useProject = (0, $cPEpP.useProject), ...rest })=>{
    const { data: project } = useProject();
    const projectConfig = (project?.isSimplified ? (0, $7ZZxN.ProjectStyle).NEXT_GEN : (0, $7ZZxN.ProjectStyle).CLASSIC) || undefined;
    const projectType = project?.type || undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        ...rest,
        attributes: {
            ...attributes,
            projectConfig: projectConfig,
            projectType: projectType,
            navigatorScope: navigatorScope
        }
    });
};

});
parcelRegister("eEZvV", function(module, exports) {

$parcel$export(module.exports, "generateViewId", () => $ff2c3a925d418d98$export$5b5545ed894dc47a);
const $ff2c3a925d418d98$export$5b5545ed894dc47a = (...ids)=>ids.join('/');

});


parcelRegister("iaHqR", function(module, exports) {

$parcel$export(module.exports, "getSystemNavigationPaths", () => $d1f3b12800e4309b$export$76c5f80c8d9bdb0e);

var $1ybV0 = parcelRequire("1ybV0");
const $d1f3b12800e4309b$export$76c5f80c8d9bdb0e = ()=>({
        generalConfiguration: '/jira/settings/system/general-configuration',
        darkFeatures: '/secure/admin/SiteDarkFeatures!default.jspa',
        issueCollectors: '/secure/admin/ViewGlobalCollectors!default.jspa',
        globalAutomation: '/jira/settings/automation',
        // troubleshooting
        troubleshootingAuditLog: '/auditing/view',
        troubleshootingPluginViewer: '/plugins/servlet/depview/plugins',
        troubleshootingModulesViewer: '/plugins/servlet/depview/modules',
        troubleshootingSystemInfo: '/secure/admin/ViewSystemInfo.jspa',
        troubleshootingIntegrityChecker: '/secure/admin/IntegrityChecker!default.jspa',
        troubleshootingLoggingProfiling: '/secure/admin/ViewLogging.jspa',
        troubleshootingSchedulerDetails: '/secure/admin/SchedulerAdmin.jspa',
        troubleshootingPerformanceAndScale: '/jira/settings/system/performance/overview',
        // security
        securityProjectRoles: '/secure/project/ViewProjectRoles.jspa',
        securityGlobalPermissions: (0, $1ybV0.ff)('everest-global-permissions-fe-modernisation_vvy6j') ? '/secure/admin/global-permissions' : '/secure/admin/GlobalPermissions!default.jspa',
        // user interface
        userInterfacesUserDefaults: '/secure/admin/ViewUserDefaultSettings.jspa',
        userInterfacesEditDefaultDashboard: '/secure/admin/EditDefaultDashboard!default.jspa',
        userInterfacesLookAndFeel: '/secure/admin/LookAndFeel!default.jspa',
        userInterfacesPasAdmin: '/plugins/servlet/pas/admin',
        userInterfacesSiteAdmin: '/jira/settings/system/ui/announcement-banner',
        // import and export
        importSectionBackupManager: '/secure/admin/CloudExport.jspa',
        importSectionExternalImport: '/secure/admin/ExternalImport1.jspa',
        importSectionExternalImportNew: '/jira/settings/system/external-import',
        importSectionCloudImport: '/secure/admin/CloudImport!start.jspa?source=import_cloud',
        importSectionServerImport: '/secure/admin/CloudImport!start.jspa?source=import_server',
        importSectionMigrateCloud: '/jira/settings/system/migration/home',
        // mail
        mailSectionGlobalMailSettings: '/secure/admin/GlobalMailSettings.jspa',
        mailSectionOutgoingMail: '/secure/admin/OutgoingMailServers.jspa',
        mailSectionIncomingMail: '/secure/admin/IncomingMailServers.jspa',
        mailSectionSendMail: '/secure/admin/SendBulkMail!default.jspa',
        // admin
        adminHelperPermissionHelper: '/secure/admin/PermissionHelperAdmin.jspa',
        adminHelperNotificationHelper: '/secure/admin/NotificationHelperAdmin.jspa',
        adminHelperEmailNotificationsLogHelper: '/jira/settings/system/notification-logs',
        // shared
        sharedSectionManageFilters: '/secure/admin/filters/ViewSharedFilters.jspa',
        sharedManageDashboards: '/secure/admin/dashboards/ViewSharedDashboards.jspa',
        // advanced
        advancedSectionAttachments: '/secure/admin/ViewAttachmentSettings.jspa',
        advancedSectionEvents: '/secure/admin/ListEventTypes.jspa',
        advancedSectionWebHooks: '/plugins/servlet/webhooks',
        advancedSectionServices: '/secure/admin/ViewServices!default.jspa',
        advancedLexoRankManagement: '/secure/GHLexoRankManage.jspa?decorator=admin'
    });

});

parcelRegister("bS2FN", function(module, exports) {

$parcel$export(module.exports, "matchUrlPathname", () => $efb2bb2763c0ed39$export$6bfcf8859d3bc51c);
$parcel$export(module.exports, "matchPartialUrlPathname", () => $efb2bb2763c0ed39$export$9870a2fa97808ed7);
$parcel$export(module.exports, "matchUrlExact", () => $efb2bb2763c0ed39$export$422d2a799c6e30b8);
$parcel$export(module.exports, "matchUrlParams", () => $efb2bb2763c0ed39$export$63fdecce99465869);

var $046kq = parcelRequire("046kq");
// Jira url paths are messy, so we have to try to clean them to avoid missing matches
// - pages urls sometimes have /secure, sometimes they don't
// - jspa pages urls sometimes have !action, sometimes they don't
const $efb2bb2763c0ed39$var$cleanPath = (path)=>path.replace('/secure/', '/').replace(/!\w+\.jspa/, '.jspa');
const $efb2bb2763c0ed39$export$6bfcf8859d3bc51c = ()=>(currentLocation, itemLocation)=>$efb2bb2763c0ed39$var$cleanPath(currentLocation.pathname) === $efb2bb2763c0ed39$var$cleanPath(itemLocation.pathname);
const $efb2bb2763c0ed39$export$9870a2fa97808ed7 = ()=>(currentLocation, itemLocation)=>currentLocation.pathname.includes(itemLocation.pathname);
const $efb2bb2763c0ed39$export$422d2a799c6e30b8 = ()=>(currentLocation, itemLocation)=>$efb2bb2763c0ed39$export$6bfcf8859d3bc51c()(currentLocation, itemLocation) && (0, (/*@__PURE__*/$parcel$interopDefault($046kq)))(currentLocation.query, itemLocation.query);
const $efb2bb2763c0ed39$export$63fdecce99465869 = (withParams, withPathname = true)=>(currentLocation, itemLocation)=>(!withPathname || $efb2bb2763c0ed39$export$6bfcf8859d3bc51c()(currentLocation, itemLocation)) && withParams.every((p)=>currentLocation.query[p] && currentLocation.query[p] === itemLocation.query[p]);

});

parcelRegister("1UelU", function(module, exports) {

$parcel$export(module.exports, "MenuItem", () => $df864800942e4b9a$export$2ce376c2cc3355c8);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $k4nIh = parcelRequire("k4nIh");

var $gMdj1 = parcelRequire("gMdj1");

var $PdmhA = parcelRequire("PdmhA");

var $kJlBc = parcelRequire("kJlBc");

var $8n4Bi = parcelRequire("8n4Bi");

var $lPCnq = parcelRequire("lPCnq");
var $foHkv = parcelRequire("foHkv");
const $df864800942e4b9a$var$WrapperComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, className: className, legacyClassName: legacyClassName, href: href, to: to, target: target, useButtonLink: // @ts-expect-error - TS2339 - Property 'useButtonLink' does not exist on type 'CustomItemComponentProps & AnchorHTMLAttributes<HTMLAnchorElement> & { children: ReactNode; ... 10 more ...; prefetch?: false | ... 2 more ... | undefined; } & { ...; }'.
useButtonLink, ...props }, ref)=>{
    const commonProps = {
        ...props,
        children: children,
        className: `${className ?? ''} ${legacyClassName ?? ''}`
    };
    return href != null || to != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Link), {
        ...commonProps,
        href: href,
        to: to,
        target: target,
        ref: ref,
        type: useButtonLink ? 'button' : 'a'
    }) : // @ts-expect-error Type 'HTMLAnchorElement | HTMLButtonElement | null' is not assignable to type 'HTMLButtonElement | null'
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($df864800942e4b9a$var$ButtonItem, {
        ...commonProps,
        type: "button",
        ref: ref
    });
});
const $df864800942e4b9a$var$customCssFn = (currentState = {})=>({
        '[data-item-title]': {
            lineHeight: 1.2
        },
        /* fixes CSS leaking from the monolith */ ...currentState.isSelected && {
            '& [data-item-title]': {
                color: "var(--ds-text-selected, rgb(12, 102, 228))"
            }
        },
        /* fixes CSS leaking from the monolith */ '&:focus, &:visited, &:active': {
            textDecoration: 'inherit',
            outline: 0
        },
        /* fixes CSS leaking from the monolith */ '&:active': {
            backgroundColor: "var(--ds-background-selected-pressed, #85B8FF)",
            boxShadow: "var(--ds-shadow-overlay, transparent)",
            '& [data-item-title]': {
                color: "var(--ds-text, rgb(66, 82, 110))"
            }
        },
        '&:focus': {
            boxShadow: `${`var(--ds-border-focused, ${0, $PdmhA.B200})`} 0 0 0 2px inset`
        },
        /* fixes CSS for react-beautiful-dnd */ '&[data-rbd-draggable-id]': {
            cursor: 'pointer'
        }
    });
const $df864800942e4b9a$export$2ce376c2cc3355c8 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ analytics: analytics, href: href, onClick: onClick, overrides: overrides, selectedOn: selectedOn, cssFn: outsideCssFn, useButtonLink: useButtonLink = false, ...rest }, ref)=>{
    const onClickHandler = (0, $foHkv.useOnClick)({
        onClick: onClick,
        analytics: analytics
    });
    const [{ route: route, query: query, location: location }] = (0, $kJlBc.useRouter)();
    let isSelected;
    // Currently, because the CMP project settings are not part of the SPA, the whole sidebar reloads everytime a menu item
    // is clicked -> As part of the Lunar Project Settings improvements, we're scrolling selected items into view once the
    // page reloads.
    //
    // We're setting a timeout to wait for the event loop to complete prior to scrolling.
    (0, $eUqFw.useEffect)(()=>{
        // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
        if (isSelected && ref?.current != null) setTimeout(()=>{
            // using ref?.current doesn't seem to work specifically here
            // Flow complianed about this part here specifically :/
            ref && // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
            ref.current != null && // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
            ref.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        });
    }, [
        selectedOn,
        ref,
        // @ts-expect-error - Variable 'isSelected' is used before being assigned.
        isSelected
    ]);
    if (typeof selectedOn === 'function') isSelected = route != null && // @ts-expect-error - Property 'search' is missing in type 'URLParse' but required in type 'MatcherLocation'.
    selectedOn({
        ...location,
        query: query
    }, (0, (/*@__PURE__*/$parcel$interopDefault($k4nIh)))(href || '/', true));
    else isSelected = Boolean(selectedOn) && route != null && selectedOn != null && selectedOn.includes(route.name);
    const theme = (0, $8n4Bi.useSidebarTheme)();
    const cssFn = (0, $eUqFw.useCallback)((currentState)=>({
            ...outsideCssFn && outsideCssFn(currentState),
            ...$df864800942e4b9a$var$customCssFn(currentState),
            ...(0, $lPCnq.getCustomThemeCss)(theme)
        }), [
        theme,
        outsideCssFn
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const customProps = {
        ...rest,
        component: $df864800942e4b9a$var$WrapperComponent,
        cssFn: cssFn,
        href: href,
        isSelected: isSelected,
        onClick: onClickHandler,
        overrides: overrides,
        ref: ref,
        useButtonLink: useButtonLink,
        'aria-current': isSelected ? 'page' : undefined
    };
    return overrides?.CustomItem?.render(customProps) || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gMdj1.default), customProps);
});
// this should be same as ButtonItem in '@atlaskit/menu'
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df864800942e4b9a$var$ButtonItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhk18uv _19itidpf _12ji1r31 _1qu2glyw _12y3idpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8n4Bi", function(module, exports) {

$parcel$export(module.exports, "SidebarThemeProvider", () => $3f50a441bbce6f7c$export$92cd68117b68bf5f);
$parcel$export(module.exports, "useSidebarTheme", () => $3f50a441bbce6f7c$export$b1a81b4626bc52c3);

var $eUqFw = parcelRequire("eUqFw");
const $3f50a441bbce6f7c$var$ThemeContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $3f50a441bbce6f7c$export$92cd68117b68bf5f = ({ theme: theme, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3f50a441bbce6f7c$var$ThemeContext.Provider, {
        value: theme
    }, children);
const $3f50a441bbce6f7c$export$b1a81b4626bc52c3 = ()=>(0, $eUqFw.useContext)($3f50a441bbce6f7c$var$ThemeContext);

});

parcelRegister("lPCnq", function(module, exports) {

$parcel$export(module.exports, "getCustomThemeCss", () => $6275288bde4e93f8$export$cc5a98b66b3e9306);
const $6275288bde4e93f8$export$cc5a98b66b3e9306 = (theme)=>{
    if (theme?.navigation) {
        const { navigation: { item: item, icon: icon } } = theme;
        return {
            backgroundColor: item?.background?.default ?? undefined,
            color: item?.color?.default ?? undefined,
            '& [data-item-title]': {
                color: item?.color?.default ?? undefined
            },
            '&:hover': {
                color: item?.color?.hover ?? undefined,
                backgroundColor: item?.background?.hover ?? undefined
            },
            /* fixes CSS leaking from the monolith */ '&:focus, &:visited': {
                color: item?.color?.default
            },
            '&:active': {
                color: item?.color?.active ?? undefined,
                backgroundColor: item?.background?.active ?? undefined
            },
            '&:active [data-item-title]': {
                color: item?.color?.active ?? undefined
            },
            '&:active [data-item-elem-before]': {
                color: item?.color?.active ?? undefined
            },
            '&:focus': {
                boxShadow: item?.color?.active != null ? `${item?.color?.active} 0 0 0 2px inset` : undefined
            },
            '&[aria-current="page"]': {
                position: 'relative',
                backgroundColor: item?.background?.active ?? undefined,
                color: item?.color?.active ?? undefined
            },
            '&[aria-current="page"]:before': {
                background: item?.color?.active ?? undefined
            },
            '& [data-item-elem-after]': {
                color: icon?.secondary?.color?.hover ?? undefined
            }
        };
    }
    return {};
};

});

parcelRegister("foHkv", function(module, exports) {

$parcel$export(module.exports, "useOnClick", () => $0b0be38cfe8462be$export$a81c45382e7253ac);

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $0b0be38cfe8462be$export$a81c45382e7253ac = ({ analytics: analytics, onClick: onClick } = {})=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        });
        if (analytics) (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'sidebar', analytics);
        else (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'sidebar');
        onClick && onClick(event);
    };
};

});


parcelRegister("9kVcv", function(module, exports) {

$parcel$export(module.exports, "TitleHeader", () => $097fe38bc39869b0$export$de3705f3d2162955);

var $eUqFw = parcelRequire("eUqFw");

var $c8Guq = parcelRequire("c8Guq");

var $8SnT0 = parcelRequire("8SnT0");

var $8n4Bi = parcelRequire("8n4Bi");

var $dHQr5 = parcelRequire("dHQr5");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $097fe38bc39869b0$var$overrideStyles = (currentStyles)=>({
        ...currentStyles,
        '[data-item-title]': {
            ...currentStyles['[data-item-title]'],
            whiteSpace: 'normal',
            lineHeight: 'initial'
        }
    });
const $097fe38bc39869b0$export$de3705f3d2162955 = ({ children: children })=>{
    const theme = (0, $8n4Bi.useSidebarTheme)();
    const cssFn = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))([
            (0, $dHQr5.generateCustomThemeCssFn)(theme),
            $097fe38bc39869b0$var$overrideStyles
        ]), [
        theme
    ]);
    // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8SnT0.default), {
        cssFn: cssFn
    }, children);
};

});
parcelRegister("8SnT0", function(module, exports) {

$parcel$export(module.exports, "Container", () => $caa339108b3c8ef1$export$42a852a2b6b56249);
$parcel$export(module.exports, "default", () => $caa339108b3c8ef1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $PdmhA = parcelRequire("PdmhA");

var $jvM56 = parcelRequire("jvM56");

var $gMdj1 = parcelRequire("gMdj1");
function $caa339108b3c8ef1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $caa339108b3c8ef1$var$containerStyles = {
    name: "4bgdod",
    styles: "display:block;position:relative"
};
const $caa339108b3c8ef1$export$42a852a2b6b56249 = ({ children: children, 'data-testid': testId, ...props })=>{
    // https://stackoverflow.com/a/39333479
    const safeProps = (({ className: className, onClick: onClick, onMouseDown: onMouseDown, onDragStart: onDragStart, draggable: draggable, ref: ref, tabIndex: tabIndex, disabled: disabled })=>({
            className: className,
            onClick: onClick,
            onMouseDown: onMouseDown,
            onDragStart: onDragStart,
            draggable: draggable,
            ref: ref,
            tabIndex: tabIndex,
            disabled: disabled
        }))(props);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        css: $caa339108b3c8ef1$var$containerStyles,
        ...safeProps
    }, children);
};
/**
 * __Header__
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $caa339108b3c8ef1$var$Header = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const cssFn = (0, $jvM56.overrideStyleFunction)(()=>({
            userSelect: 'auto',
            ['[data-item-title]']: {
                ...(0, $XHGTv.getBooleanFF)('platform.design-system-team.side-navigation-tokenised-typography-styles') ? {
                    font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
                } : {
                    fontSize: '0.875rem',
                    letterSpacing: '-0.003em',
                    fontWeight: "var(--ds-font-weight-semibold, 600)"
                },
                color: `var(--ds-text, ${0, $PdmhA.N500})`
            },
            // Will look interactive if the `component` is anything other than a div.
            'div&:hover': {
                backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
                cursor: 'default'
            },
            'div&:active': {
                backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
                color: `var(--ds-text, ${0, $PdmhA.N500})`
            }
        }), props.cssFn);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $gMdj1.default), {
        ...props,
        ref: ref,
        component: props.component || $caa339108b3c8ef1$export$42a852a2b6b56249,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        cssFn: cssFn,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: {
            Title: {
                render: (_, { children: children, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)("h2", props, children)
            }
        }
    });
});
var $caa339108b3c8ef1$export$2e2bcd8739ae039 = $caa339108b3c8ef1$var$Header;

});

parcelRegister("dHQr5", function(module, exports) {

$parcel$export(module.exports, "generateCustomThemeCssFn", () => $4df067d0bbc9b88e$export$5ae7d20da3003de);

var $2vzCR = parcelRequire("2vzCR");

var $5vmRt = parcelRequire("5vmRt");
const $4df067d0bbc9b88e$export$5ae7d20da3003de = (theme)=>(0, $5vmRt.castRealCSSFnToWronglyTypedCSSFn)((currentStyles)=>{
        if (theme?.navigation) {
            const { navigation: { item: item } } = theme;
            const themeStyles = {
                backgroundColor: item?.background?.default ?? undefined,
                color: item?.color?.default ?? undefined,
                '&:hover': {
                    color: item?.color?.hover ?? undefined,
                    backgroundColor: item?.background?.hover ?? undefined
                },
                '[data-item-title]': {
                    color: item?.color?.default ?? undefined
                }
            };
            return (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(currentStyles, themeStyles);
        }
        return currentStyles;
    });

});
parcelRegister("5vmRt", function(module, exports) {

$parcel$export(module.exports, "castRealCSSFnToWronglyTypedCSSFn", () => $a9f42b05cf11af4c$export$3f662b014fa1806e);
function $a9f42b05cf11af4c$export$3f662b014fa1806e(fn) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
    return fn;
}
function $a9f42b05cf11af4c$export$17f32e2573d62daa(fn) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
    return fn;
}
const $a9f42b05cf11af4c$export$91011a0a572ef910 = {
    CONNECTED: 'CONNECTED',
    INCOMPLETE: 'INCOMPLETE',
    INITIAL: 'INITIAL',
    SEEN: 'SEEN',
    UNCONNECTED: 'UNCONNECTED'
};

});



parcelRegister("aWYQ8", function(module, exports) {

$parcel$export(module.exports, "ConnectMenu", () => $449294194ac94025$export$19d0925d424b864a);

var $eUqFw = parcelRequire("eUqFw");

var $9ui8T = parcelRequire("9ui8T");

var $fDNHa = parcelRequire("fDNHa");
const $449294194ac94025$export$19d0925d424b864a = ({ items: items, overrides: overrides, showIcons: showIcons = false, shouldFilter: shouldFilter = true, submenuId: submenuId = '' })=>{
    const filteredItems = (0, $9ui8T.useFilteredItems)(items || null, shouldFilter);
    if (filteredItems == null || !filteredItems.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, filteredItems.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fDNHa.ConnectItem), {
            item: item,
            key: item.id,
            index: index,
            overrides: overrides,
            showIcons: showIcons,
            submenuId: submenuId
        })));
};

});
parcelRegister("9ui8T", function(module, exports) {

$parcel$export(module.exports, "useFilteredItems", () => $e919628f42726628$export$79762159776e61da);

var $eUqFw = parcelRequire("eUqFw");

var $bgNoL = parcelRequire("bgNoL");
const $e919628f42726628$export$79762159776e61da = (items, shouldFilter = true)=>(0, $eUqFw.useMemo)(()=>{
        if (!shouldFilter) return items || [];
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"services" | "collectors" | "attachments" | "eventtypes" | "webhooks-admin" | "greenhopper-lexorank-manage" | "admin-helper-admin-section" | "advanced_section" | "dark_features" | ... 74 more ... | "com.codebarrel.addons.automation__cb-automation"'.
        return items?.filter((item)=>!(0, $bgNoL.staticLegacyIds).includes(item.id)) || [];
    }, [
        items,
        shouldFilter
    ]);

});

parcelRegister("fDNHa", function(module, exports) {

$parcel$export(module.exports, "ConnectItem", () => $689f0217773f024d$export$8bb4bcea44a3c9ea);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iFXD5 = parcelRequire("iFXD5");

var $7eyVf = parcelRequire("7eyVf");

var $aqZcy = parcelRequire("aqZcy");
var $5RTd0 = parcelRequire("5RTd0");

var $422mK = parcelRequire("422mK");

var $bS2FN = parcelRequire("bS2FN");
var $1UelU = parcelRequire("1UelU");
var $aDEKA = parcelRequire("aDEKA");
var $2DHQu = parcelRequire("2DHQu");
var $9kVcv = parcelRequire("9kVcv");
const $689f0217773f024d$export$8bb4bcea44a3c9ea = ({ index: index, item: item, overrides: overrides, showIcons: showIcons, submenuId: submenuId = '', isNested: isNested = false })=>{
    const { addNew: addNew } = (0, $422mK.useConnectItemClickHistory)();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const BackMenuItem = {
        ...overrides.BackMenuItem,
        onClick: (ev)=>{
            // Due to CMP project settings not being part to the SPA, we have to set / get the state of the
            // Expandable menu items from cookies - this is because the page does a complete refresh upon clicking a menuitem link.
            // This is to satisfy a requirement for open expandable menus to remain open
            // when users return to the project settings menu
            if (submenuId != null) {
                const cookieData = (0, $aqZcy.getCookie)(`jira.navigation.expandableMenuStates.${submenuId}`);
                let parsedCookieData = null;
                try {
                    // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
                    parsedCookieData = JSON.parse(cookieData);
                } catch  {
                    // Rather than throw an error - just set the default state
                    parsedCookieData = {
                        submenuActive: false,
                        expanded: false
                    };
                }
                const newCookieData = {
                    ...parsedCookieData,
                    submenuActive: false
                };
                (0, $5RTd0.setStrictlyNecessaryCookie)(`jira.navigation.expandableMenuStates.${submenuId}`, JSON.stringify(newCookieData));
            }
            // Setting navigateOnBackMenuItemClick to true will allow backToProject link to take user to the default project page
            if (overrides?.navigateOnBackMenuItemClick !== true) ev.preventDefault();
            overrides.BackMenuItem?.onClick?.(ev);
        }
    };
    const icon = (0, $eUqFw.useMemo)(()=>{
        if (showIcons !== true) return null;
        return item.iconUrl != null && item.iconUrl.trim().length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($689f0217773f024d$var$ConnectIcon, {
            src: item.iconUrl,
            alt: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iFXD5))), {
            label: ""
        });
    }, [
        showIcons,
        item.iconUrl
    ]);
    const onItemClick = (0, $eUqFw.useCallback)((event)=>{
        // We need to check we're clicking an item inside a nested menu for a connect item.
        // if we are deep linking to a nested connect item -> we need to maintain the hiding of nav-modules
        // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        if (overrides?.ParentMenuItem?.onClick && isNested) // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        overrides.ParentMenuItem.onClick(event);
        item.url != null && addNew(item.url);
    }, [
        addNew,
        isNested,
        item.url,
        overrides
    ]);
    const onNestedMenuItemClick = (0, $eUqFw.useCallback)((event)=>{
        // Due to CMP project settings not being part to the SPA, we have to set / get the state of the
        // Expandable menu items from cookies - this is because the page does a complete refresh upon clicking a menuitem link.
        // This is to satisfy a requirement for open expandable menus to remain open
        // when users return to the project settings menu
        if (submenuId != null) {
            const cookieData = (0, $aqZcy.getCookie)(`jira.navigation.expandableMenuStates.${submenuId}`);
            if (cookieData != null) (0, $5RTd0.setStrictlyNecessaryCookie)(`jira.navigation.expandableMenuStates.${submenuId}`, JSON.stringify({
                ...JSON.parse(cookieData),
                submenuActive: true
            }));
        }
        // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        if (overrides?.ParentMenuItem?.onClick) // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        overrides.ParentMenuItem.onClick(event);
        return ()=>null;
    }, [
        overrides,
        submenuId
    ]);
    if (item.section === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        title: item.name,
        hasSeparator: Boolean(index)
    }, (item.items || []).map((si, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($689f0217773f024d$export$8bb4bcea44a3c9ea, {
            key: si.id,
            item: si,
            overrides: {
                ...overrides,
                BackMenuItem: BackMenuItem
            },
            index: idx,
            isNested: isNested
        })));
    if (item.items) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2DHQu.NestingMenuItem), {
        id: item.id,
        analytics: {
            itemId: item.id
        },
        iconBefore: icon,
        overrides: {
            ...overrides,
            BackMenuItem: BackMenuItem
        },
        title: item.name,
        onClick: onNestedMenuItemClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aDEKA.NavigationContentWrapper), {
        submenuActive: true,
        nestedMenuOpen: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9kVcv.TitleHeader), null, item.name), (item.items || []).map((si, nestIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($689f0217773f024d$export$8bb4bcea44a3c9ea, {
            key: si.id,
            item: si,
            index: nestIndex,
            overrides: {
                ...overrides,
                BackMenuItem: {
                    href: item.url,
                    title: si.name,
                    onClick: (ev)=>ev.preventDefault()
                }
            },
            isNested: true
        })))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: item.id
        },
        selectedOn: (0, $bS2FN.matchUrlExact)(),
        iconBefore: icon,
        href: item.url,
        legacyClassName: item.styleClass,
        onClick: onItemClick,
        ref: /*#__PURE__*/ (0, $eUqFw.createRef)()
    }, item.name);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $689f0217773f024d$var$ConnectIcon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbgktf _4t3igktf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5RTd0", function(module, exports) {

$parcel$export(module.exports, "setStrictlyNecessaryCookie", () => $c190ea8c356dcf3d$export$93509ff9a62ee022);

var $fT6gI = parcelRequire("fT6gI");
const $c190ea8c356dcf3d$export$93509ff9a62ee022 = (key, value, attributes)=>{
    (0, $fT6gI.setStrictlyNecessaryCookie)(key, value, attributes);
};

});

parcelRegister("422mK", function(module, exports) {

$parcel$export(module.exports, "useConnectItemClickHistory", () => $e1e0c0027f44f3f6$export$c251e3fda1cce4a3);

var $eUqFw = parcelRequire("eUqFw");
// A single instance for the entire SPA session
const $e1e0c0027f44f3f6$var$history = {
    unique: []
};
const $e1e0c0027f44f3f6$export$c251e3fda1cce4a3 = ()=>{
    const addNew = (0, $eUqFw.useCallback)((historyItem)=>{
        // Here we want to store only unique items. For example, if the add-on updates Jira hash
        // and user clicks the same navigation link we consider it as a unique navigation action
        // so we can use this info later on to rerender the iframe
        if (window.location.href.endsWith(historyItem) === false) // @ts-expect-error - TS2339 - Property 'push' does not exist on type 'readonly []'.
        $e1e0c0027f44f3f6$var$history.unique.push(historyItem);
    }, []);
    return (0, $eUqFw.useMemo)(()=>({
            history: $e1e0c0027f44f3f6$var$history,
            addNew: addNew
        }), [
        addNew
    ]);
};
const $e1e0c0027f44f3f6$export$ef04cd58bebb0345 = ()=>{
    // @ts-expect-error TS2540: Cannot assign to 'length' because it is a read-only property.
    $e1e0c0027f44f3f6$var$history.unique.length = 0;
};

});

parcelRegister("aDEKA", function(module, exports) {

$parcel$export(module.exports, "NavigationHeaderWrapper", () => $94d555cec3b0ee42$export$bae9b35e967353d5);
$parcel$export(module.exports, "NavigationExpandableContentWrapper", () => $94d555cec3b0ee42$export$4e88508e6904469e);
$parcel$export(module.exports, "NavigationContentWrapper", () => $94d555cec3b0ee42$export$e7d691a5a9258e1b);
$parcel$export(module.exports, "NextGenIssueTypesWrapper", () => $94d555cec3b0ee42$export$f094f7aad76e4268);
$parcel$export(module.exports, "ExpandableProjectSettingsWrapper", () => $94d555cec3b0ee42$export$e38bb288d890ec2f);
$parcel$export(module.exports, "ShortCutsAndAppsWrapper", () => $94d555cec3b0ee42$export$337add4342ee7986);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $c9TLT = parcelRequire("c9TLT");
const $94d555cec3b0ee42$export$bae9b35e967353d5 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($94d555cec3b0ee42$var$NavigationHeaderWrapperContainer, null, props.children);
const $94d555cec3b0ee42$export$4e88508e6904469e = (props)=>{
    const { nestedAppOpen: nestedAppOpen, submenuActive: submenuActive, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($94d555cec3b0ee42$var$NavigationExpandableContentWrapperContainer, {
        nestedAppOpen: nestedAppOpen,
        submenuActive: submenuActive
    }, children);
};
const $94d555cec3b0ee42$export$e7d691a5a9258e1b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($94d555cec3b0ee42$var$NavigationContentWrapperContainer, {
        // @ts-expect-error - TS2322 - Type '{ children: ReactNode; navModuleLabelsHidden: boolean | undefined; nestedAppOpen: boolean | undefined; context: string | undefined; submenuActive: boolean | undefined; nestedMenuOpen: boolean | undefined; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<Component<ThemedOuterStyledProps<ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & { ...; }, any>, any, any>> & Readonly<...> & Readonly<...>'.
        navModuleLabelsHidden: props.navModuleLabelsHidden,
        nestedAppOpen: props.nestedAppOpen,
        context: props.context,
        submenuActive: props.submenuActive,
        nestedMenuOpen: props.nestedMenuOpen,
        "data-component-selector": "NavigationContentWrapperContainer"
    }, props.children);
const $94d555cec3b0ee42$export$f094f7aad76e4268 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($94d555cec3b0ee42$var$NextGenIssueTypesWrapperContainer, null, props.children);
const $94d555cec3b0ee42$export$e38bb288d890ec2f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($94d555cec3b0ee42$var$ExpandableProjectContainer, null, props.children);
const $94d555cec3b0ee42$export$337add4342ee7986 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($94d555cec3b0ee42$var$ShortCutsAndAppsContainer, null, props.children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $94d555cec3b0ee42$var$NavigationHeaderWrapperContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc _1s541012 _1lfu1012",
            __cmplp.className
        ])
    });
});
const $94d555cec3b0ee42$var$NavigationExpandableContentWrapperContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { submenuActive: submenuActive, nestedAppOpen: nestedAppOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ykp9lh": (0, $9t7rW.default)(__cmplp.nestedAppOpen ? 'auto' : '100%'),
            "--_1qrlsbv": (0, $9t7rW.default)(Math.round((0, $c9TLT.borderRadius) * 1.333), "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc _1q1o54a6 _1dul54a6 _ofxb54a6 _179m54a6 _vnu9l52n _19iyl52n _t6kll52n _shi3l52n _15sk1v6z _178k1v6z _18pc1v6z _1bc71v6z _yugv5oil _83u65oil _1ern5oil _rjkj5oil",
            __cmplp.submenuActive && "_4t3i1qw7",
            __cmplp.submenuActive ? "_bq2uyjp0 _1n80yjp0 _di7gyjp0 _1lozyjp0" : "_bq2u1d7o _1n801d7o _di7g1d7o _1loz1d7o",
            __cmplp.className
        ])
    });
});
const $94d555cec3b0ee42$var$NavigationContentWrapperContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { submenuActive: submenuActive, nestedMenuOpen: nestedMenuOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_6w8gix": (0, $9t7rW.default)(__cmplp.nestedMenuOpen ? 0 : 7.5 * (0, $c9TLT.gridSize), "px"),
            "--_1qrlsbv": (0, $9t7rW.default)(Math.round((0, $c9TLT.borderRadius) * 1.333), "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_yugv5oil _83u65oil _1ern5oil _rjkj5oil",
            __cmplp.submenuActive ? "_4t3iu4z3" : "_4t3i1wug",
            __cmplp.submenuActive ? "_vnu91tcg _19iy1tcg _t6kl1tcg _shi31tcg" : "_vnu9l52n _19iyl52n _t6kll52n _shi3l52n",
            __cmplp.nestedMenuOpen && "_1reo1wug _18m91wug _14tk183y",
            __cmplp.className
        ])
    });
});
const $94d555cec3b0ee42$var$NextGenIssueTypesWrapperContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _vpnr1ejb _14tk72c6 _cb62utpp _1wtp1txs _l9o61txs _f6zi1txs",
            __cmplp.className
        ])
    });
});
const $94d555cec3b0ee42$var$ExpandableProjectContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wtppxbi _df5vpxbi",
            __cmplp.className
        ])
    });
});
const $94d555cec3b0ee42$var$ShortCutsAndAppsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _14tk72c6 _t3zc183y _1so4jjyb _1thc1skh _a6avqslr _dnyv1skh",
            __cmplp.className
        ])
    });
});

});

parcelRegister("2DHQu", function(module, exports) {

$parcel$export(module.exports, "NestingMenuItem", () => $caee9921c40abec1$export$4c594f24f8e4128a);

var $eUqFw = parcelRequire("eUqFw");

var $c8Guq = parcelRequire("c8Guq");

var $2vzCR = parcelRequire("2vzCR");

var $fyp42 = parcelRequire("fyp42");

var $9iAqW = parcelRequire("9iAqW");

var $4C6RK = parcelRequire("4C6RK");

var $1UelU = parcelRequire("1UelU");

var $k4ysj = parcelRequire("k4ysj");
var $cFBmm = parcelRequire("cFBmm");

var $8n4Bi = parcelRequire("8n4Bi");

var $5vmRt = parcelRequire("5vmRt");

var $hLkCn = parcelRequire("hLkCn");
const $caee9921c40abec1$var$customCssFn = (0, $5vmRt.castRealCSSFnToWronglyTypedCSSFn)((currentStateAndStyles)=>{
    const activeColor = typeof currentStateAndStyles['&:active'] === 'object' ? `${currentStateAndStyles['&:active'].color} !important` : 'inherit';
    const baseColor = typeof currentStateAndStyles['&:hover'] === 'object' ? currentStateAndStyles['&:hover'].color : 'inherit';
    const newStyle = {
        ...(0, $cFBmm.cssFn)(currentStateAndStyles),
        /* fixes CSS leaking from the monolith */ '&:visited, &:focus, &:active': {
            textDecoration: 'inherit',
            outline: 0
        },
        /* fixes CSS leaking from the monolith */ '&:active': {
            color: activeColor
        },
        /* fixes CSS leaking from the monolith */ '&:visited, &:focus': {
            color: baseColor
        },
        '& [data-item-title]': {
            color: baseColor
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(currentStateAndStyles, newStyle);
});
const $caee9921c40abec1$var$WrappingLinkComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", props, props.children);
const $caee9921c40abec1$export$4c594f24f8e4128a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, id: id, reloadOnNavigationToNesting: reloadOnNavigationToNesting, overrides: overrides = {}, title: title, ...rest }, ref)=>{
    const theme = (0, $8n4Bi.useSidebarTheme)();
    const backButtonCssFn = (0, $k4ysj.generateBackButtonCssFn)(theme);
    const { BackMenuItem: BackMenuItem = {} } = overrides;
    const { title: backTitle = 'Back', wrapper: WrapperComponent = (0, $eUqFw.Fragment), ...backItemProps } = BackMenuItem; // eslint-disable-line @typescript-eslint/consistent-type-assertions
    const renderBackItem = (0, $eUqFw.useCallback)(({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrapperComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
            ...backItemProps,
            analytics: {
                itemId: 'back'
            },
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fyp42))), {
                label: ""
            }),
            onClick: (ev)=>{
                if ((0, $hLkCn.isNormalClick)(ev)) {
                    onClick();
                    backItemProps.onClick?.(ev);
                }
            },
            cssFn: backButtonCssFn
        }, backTitle)), [
        WrapperComponent,
        backItemProps,
        backButtonCssFn,
        backTitle
    ]);
    const renderCustomItem = (0, $eUqFw.useCallback)(({ children: itemTitle, onClick: onClick, cssFn: customItemCssFn, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9iAqW.default), {
            ...props,
            id: id,
            component: reloadOnNavigationToNesting ? $caee9921c40abec1$var$WrappingLinkComponent : props.component,
            onClick: (ev)=>{
                // if nesting item already selected do not trigger route change
                if (props.isSelected === true) ev.preventDefault();
                onClick && onClick(ev);
            },
            // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
            overrides: {
                GoBackItem: {
                    render: renderBackItem
                }
            },
            title: itemTitle,
            // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
            cssFn: customItemCssFn ? (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))([
                customItemCssFn,
                $caee9921c40abec1$var$customCssFn
            ]) : $caee9921c40abec1$var$customCssFn
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4C6RK.SidebarErrorBoundary), {
            id: `${id}Nesting`,
            packageName: "jiraSpaAppsSidebarCommon"
        }, children)), [
        children,
        id,
        reloadOnNavigationToNesting,
        renderBackItem
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        ...rest,
        ref: ref,
        overrides: {
            CustomItem: {
                render: renderCustomItem
            }
        }
    }, title);
});

});
parcelRegister("k4ysj", function(module, exports) {

$parcel$export(module.exports, "generateBackButtonCssFn", () => $3713137157573d1a$export$56644251c3f2ea82);
const $3713137157573d1a$export$56644251c3f2ea82 = (theme)=>()=>{
        if (theme?.navigation) {
            const { icon: icon } = theme.navigation;
            return {
                '& [data-item-elem-before], &:active span[data-item-elem-before]': {
                    color: icon?.secondary?.color?.active ?? undefined
                }
            };
        }
        return {};
    };

});

parcelRegister("cFBmm", function(module, exports) {

$parcel$export(module.exports, "cssFn", () => $3a6f1f8fdf334108$export$d722961e96b459c5);

var $2vzCR = parcelRequire("2vzCR");

var $c9TLT = parcelRequire("c9TLT");

var $5vmRt = parcelRequire("5vmRt");
const $3a6f1f8fdf334108$export$d722961e96b459c5 = (0, $5vmRt.castRealCSSFnToWronglyTypedCSSFn)((currentStyles)=>{
    const newStyle = {
        '[data-item-elem-after] [data-right-arrow]': {
            display: 'none'
        },
        '&:hover [data-item-elem-after]': {
            '& > :not([data-right-arrow])': {
                display: 'none'
            },
            '& [data-right-arrow]': {
                display: 'flex'
            }
        },
        height: `${(0, $c9TLT.gridSize) * 5.5}px`
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(currentStyles, newStyle);
});

});

parcelRegister("hLkCn", function(module, exports) {

$parcel$export(module.exports, "isNormalClick", () => $82cbad75889ad869$export$729f3684d5c2b9b9);
const $82cbad75889ad869$export$729f3684d5c2b9b9 = (e)=>!('button' in e && e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);

});




parcelRegister("edsEA", function(module, exports) {

$parcel$export(module.exports, "SECTION_ID", () => $c6ce6d648439ff85$export$501955bd67991a25);
const $c6ce6d648439ff85$export$501955bd67991a25 = {
    MIGRATE_TO_CLOUD_SITE: 'migrate-to-cloud-site',
    PERFORMANCE_AND_SCALE: 'performance-and-scale'
};

});

parcelRegister("cvu76", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $a1011f522d4f3baa$export$4a39035bacc4ed76);
$parcel$export(module.exports, "useGlobalSettingsSystemConnectItems", () => $a1011f522d4f3baa$export$f601efaceb0636f4);

var $eUqFw = parcelRequire("eUqFw");

var $2z5XU = parcelRequire("2z5XU");

var $kIUmN = parcelRequire("kIUmN");

var $1ykEC = parcelRequire("1ykEC");

var $gd0Sp = parcelRequire("gd0Sp");

var $9Zvye = parcelRequire("9Zvye");
const $a1011f522d4f3baa$export$4a39035bacc4ed76 = (0, $kIUmN.withThrowOnError)(()=>{
    const { data: data, loading: loading, error: error } = (0, $2z5XU.useNavigationGlobalResource)();
    const { isDevMode: isDevMode, isAdmin: isAdmin, isSiteAdmin: isSiteAdmin } = (0, $gd0Sp.useTenantContext)();
    const extractedData = (0, $eUqFw.useMemo)(()=>data && (0, $9Zvye.extractData)(data, isDevMode, isAdmin, isSiteAdmin), [
        data,
        isDevMode,
        isAdmin,
        isSiteAdmin
    ]);
    return {
        data: extractedData,
        loading: loading,
        error: error
    };
});
const $a1011f522d4f3baa$export$f601efaceb0636f4 = (0, $kIUmN.withThrowOnError)((0, $1ykEC.useGlobalSettingsSystemConnectItems));

});
parcelRegister("kIUmN", function(module, exports) {

$parcel$export(module.exports, "withThrowOnError", () => $f76cf1e1bf710aa4$export$a018832f2ec4dc91);
/* eslint-disable jira/react-magnetic-di/no-unneeded */ 
var $asu8X = parcelRequire("asu8X");
const $f76cf1e1bf710aa4$var$isDataEmpty = (data)=>data == null;
function $f76cf1e1bf710aa4$export$a018832f2ec4dc91(theHook) {
    return (...args)=>{
        // tests like src/packages/navigation-apps/horizontal-nav/tabs/board-scoped-tab/src/test.tsx do not work without this line
        (0, $asu8X.di)(theHook);
        const result = theHook(...args);
        // escalate .error if condition is met (by throwing a runtime exception from it; to be caught and logged by the nearest ErrorBoundary for example).
        if (!false && $f76cf1e1bf710aa4$var$isDataEmpty(result.data) && !result.loading && result.error) throw result.error;
        return result;
    };
}

});

parcelRegister("9Zvye", function(module, exports) {

$parcel$export(module.exports, "extractData", () => $c73123b712e8456e$export$9df5fa0a366163d2);

var $1ybV0 = parcelRequire("1ybV0");

var $lDq4g = parcelRequire("lDq4g");
const $c73123b712e8456e$export$9df5fa0a366163d2 = (data, isDevMode, isAdmin, isSiteAdmin)=>({
        hasGeneralConfiguration: isAdmin,
        hasDarkFeatures: (0, $lDq4g.hasItemInSidebar)(data, 'dark_features'),
        hasTroubleshootingAndSupportSection: isAdmin,
        hasViewAuditing: isAdmin,
        hasPluginViewer: isDevMode && isAdmin,
        hasModulesViewer: isDevMode && isAdmin,
        hasSystemInfo: (0, $lDq4g.hasItemInSidebar)(data, 'system_info'),
        hasIntegrityChecker: (0, $lDq4g.hasItemInSidebar)(data, 'integrity_checker'),
        hasLoggingProfiling: (0, $lDq4g.hasItemInSidebar)(data, 'logging_profiling'),
        hasSchedulerDetails: (0, $lDq4g.hasItemInSidebar)(data, 'scheduler_details'),
        hasSecuritySection: isAdmin,
        hasProjectRoles: isAdmin,
        hasGlobalPermissions: isAdmin,
        hasCollectors: isAdmin,
        hasUserInterfaceSection: isAdmin,
        hasUserDefaults: isAdmin,
        hasEditDefaultDashboard: isAdmin,
        hasLookAndFeel: isAdmin,
        hasPasAdmin: (0, $lDq4g.hasItemInSidebar)(data, 'com.atlassian.pas:pas-admin-link-jira'),
        hasImportExportSection: isAdmin,
        hasBackupManager: isAdmin,
        hasExternalImport: isAdmin,
        hasRestoreSystem: (0, $lDq4g.hasItemInSidebar)(data, 'vertigo_import'),
        hasCloudImport: (0, $lDq4g.hasItemInSidebar)(data, 'vertigo_import_jira_cloud'),
        hasServerImport: (0, $lDq4g.hasItemInSidebar)(data, 'vertigo_import_jira_server'),
        hasC2CMigration: isSiteAdmin && (0, $1ybV0.ff)('jira-system-settings-cloud-to-cloud-migration'),
        hasMailSection: isAdmin,
        hasGlobalMailSettings: isAdmin,
        hasOutgoingMail: isAdmin,
        hasIncomingMail: isAdmin,
        hasSendMail: isAdmin,
        hasAdminHelperSection: isAdmin,
        hasPermissionHelper: isAdmin,
        hasNotificationHelper: isAdmin && !(0, $1ybV0.ff)('sea-1973-notifications-hub'),
        hasSharedSection: isAdmin,
        hasManageDashboards: isAdmin,
        hasManageFilters: isAdmin,
        hasEmailNotificationsLogHelper: (0, $1ybV0.ff)('platform.jlove-pulsar.jlovep-423-jsw-notification-logs-ui'),
        // advanced
        hasAdvancedSection: isAdmin,
        hasAttachments: isAdmin,
        hasEvents: isAdmin,
        hasWebHooks: isAdmin,
        hasServices: isAdmin,
        hasLexoRankManagement: (0, $lDq4g.hasItemInSidebar)(data, 'greenhopper-lexorank-manage')
    });

});


parcelRegister("hrMrK", function(module, exports) {

$parcel$export(module.exports, "AdminHelperSection", () => $3ec3bce980ffe719$export$4855b2d78f0d666a);

var $eUqFw = parcelRequire("eUqFw");

var $aBT3I = parcelRequire("aBT3I");

var $ffiyv = parcelRequire("ffiyv");

var $ltfxy = parcelRequire("ltfxy");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $7eyVf = parcelRequire("7eyVf");
var $gLn5u = parcelRequire("gLn5u");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $iaHqR = parcelRequire("iaHqR");
var $bS2FN = parcelRequire("bS2FN");
var $1UelU = parcelRequire("1UelU");

var $cvu76 = parcelRequire("cvu76");

var $3aA4Y = parcelRequire("3aA4Y");
const $3ec3bce980ffe719$var$BLOCKING_INVITATIONS_LOG_SPOTLIGHT_KEY = 'blocking-invitations-log-spotlight';
const $3ec3bce980ffe719$export$4855b2d78f0d666a = ()=>{
    const { data: features } = (0, $cvu76.useFeatures)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const navigationPath = (0, $eUqFw.useMemo)(()=>(0, $iaHqR.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        title: formatMessage((0, $3aA4Y.default).adminHelper)
    }, features.hasPermissionHelper && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'permission-helper'
        },
        href: navigationPath.adminHelperPermissionHelper,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $3aA4Y.default).permissionHelper)), features.hasNotificationHelper && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'notification-helper'
        },
        href: navigationPath.adminHelperNotificationHelper,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $3aA4Y.default).notificationHelper)), features.hasEmailNotificationsLogHelper && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
        name: $3ec3bce980ffe719$var$BLOCKING_INVITATIONS_LOG_SPOTLIGHT_KEY
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'email-notifications-log'
        },
        href: navigationPath.adminHelperEmailNotificationsLogHelper,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $3ec3bce980ffe719$var$emailNotificationsLogContainerStyles
    }, formatMessage((0, $3aA4Y.default).emailNotificationsLog), !(0, $1ybV0.ff)('platform.jlove-pulsar.jlovep-1472-remove-unblock-user-invites-new-lozenge_7ig5k') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: "new"
    }, formatMessage((0, $3aA4Y.default).newLozenge)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aBT3I.EngagementSpotlight), {
        engagementId: $3ec3bce980ffe719$var$BLOCKING_INVITATIONS_LOG_SPOTLIGHT_KEY
    })));
};
const $3ec3bce980ffe719$var$emailNotificationsLogContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    justifyContent: 'space-between'
});

});
parcelRegister("3aA4Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $06605f0f5bf60fbb$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $06605f0f5bf60fbb$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    adminHelper: {
        "id": "spa-apps-sidebar-global-settings-system.menu.admin-helper.admin-helper",
        "defaultMessage": "Admin helper"
    },
    permissionHelper: {
        "id": "spa-apps-sidebar-global-settings-system.menu.admin-helper.permission-helper",
        "defaultMessage": "Permission helper"
    },
    notificationHelper: {
        "id": "spa-apps-sidebar-global-settings-system.menu.admin-helper.notification-helper",
        "defaultMessage": "Notification helper"
    },
    emailNotificationsLog: {
        "id": "spa-apps-sidebar-global-settings-system.menu.admin-helper.email-notifications-log",
        "defaultMessage": "Unblock user invites"
    },
    newLozenge: {
        "id": "spa-apps-sidebar-global-settings-system.menu.admin-helper.new-lozenge",
        "defaultMessage": "New"
    }
});

});


parcelRegister("gS9Pi", function(module, exports) {

$parcel$export(module.exports, "AdvancedSection", () => $03a8f2bdc5bb78e2$export$32bea920eaad7efb);

var $eUqFw = parcelRequire("eUqFw");

var $7eyVf = parcelRequire("7eyVf");
var $gLn5u = parcelRequire("gLn5u");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $iaHqR = parcelRequire("iaHqR");
var $bS2FN = parcelRequire("bS2FN");
var $1UelU = parcelRequire("1UelU");

var $cvu76 = parcelRequire("cvu76");

var $ks7eZ = parcelRequire("ks7eZ");
const $03a8f2bdc5bb78e2$export$32bea920eaad7efb = ()=>{
    const { data: features } = (0, $cvu76.useFeatures)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const navigationPath = (0, $eUqFw.useMemo)(()=>(0, $iaHqR.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        title: formatMessage((0, $ks7eZ.default).advanced)
    }, features.hasAttachments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'attachments'
        },
        href: navigationPath.advancedSectionAttachments,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $ks7eZ.default).attachments)), features.hasEvents && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'events'
        },
        href: navigationPath.advancedSectionEvents,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $ks7eZ.default).events)), features.hasWebHooks && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'webhooks'
        },
        href: navigationPath.advancedSectionWebHooks,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $ks7eZ.default).webhooks)), features.hasServices && !(0, $1ybV0.ff)('delete-services-page_g96jv') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'services'
        },
        href: navigationPath.advancedSectionServices,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $ks7eZ.default).services)), features.hasLexoRankManagement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'lexorank-management'
        },
        href: navigationPath.advancedLexoRankManagement,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $ks7eZ.default).lexorankManagement)));
};

});
parcelRegister("ks7eZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0af7d60d7973990$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d0af7d60d7973990$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    advanced: {
        "id": "spa-apps-sidebar-global-settings-system.menu.advanced.advanced",
        "defaultMessage": "Advanced"
    },
    attachments: {
        "id": "spa-apps-sidebar-global-settings-system.menu.advanced.attachments",
        "defaultMessage": "Attachments"
    },
    events: {
        "id": "spa-apps-sidebar-global-settings-system.menu.advanced.events",
        "defaultMessage": "Events"
    },
    webhooks: {
        "id": "spa-apps-sidebar-global-settings-system.menu.advanced.webhooks",
        "defaultMessage": "WebHooks"
    },
    services: {
        "id": "spa-apps-sidebar-global-settings-system.menu.advanced.services",
        "defaultMessage": "Services"
    },
    lexorankManagement: {
        "id": "spa-apps-sidebar-global-settings-system.menu.advanced.lexorank-management",
        "defaultMessage": "LexoRank management"
    }
});

});


parcelRegister("4VoIp", function(module, exports) {

$parcel$export(module.exports, "AutomationSection", () => $7c3e343d2e37ccc1$export$5fa01e4d25d8e6ec);

var $eUqFw = parcelRequire("eUqFw");

var $7eyVf = parcelRequire("7eyVf");

var $exb0h = parcelRequire("exb0h");

var $5JgJ2 = parcelRequire("5JgJ2");

var $iaHqR = parcelRequire("iaHqR");
var $1UelU = parcelRequire("1UelU");

var $BRrlJ = parcelRequire("BRrlJ");
const $7c3e343d2e37ccc1$export$5fa01e4d25d8e6ec = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const navigationPath = (0, $eUqFw.useMemo)(()=>(0, $iaHqR.getSystemNavigationPaths)(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        title: formatMessage((0, $BRrlJ.default).automationGroup)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'automation'
        },
        href: navigationPath.globalAutomation,
        selectedOn: [
            (0, $exb0h.ROUTE_NAMES).SETTINGS_AUTOMATION
        ]
    }, formatMessage((0, $BRrlJ.default).globalAutomation)));
};

});
parcelRegister("BRrlJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4343ac41ac6d948d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4343ac41ac6d948d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    automationGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.automation.automation-group",
        "defaultMessage": "Automation"
    },
    globalAutomation: {
        "id": "spa-apps-sidebar-global-settings-system.menu.automation.global-automation",
        "defaultMessage": "Global automation"
    }
});

});


parcelRegister("ii4v1", function(module, exports) {

$parcel$export(module.exports, "ImportExportSection", () => $3aa2c3bcc356e542$export$2e4cb1dc5b398447);

var $eUqFw = parcelRequire("eUqFw");

var $7eyVf = parcelRequire("7eyVf");
var $gLn5u = parcelRequire("gLn5u");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $iaHqR = parcelRequire("iaHqR");
var $bS2FN = parcelRequire("bS2FN");
var $1UelU = parcelRequire("1UelU");
var $b7Flp = parcelRequire("b7Flp");

var $gd0Sp = parcelRequire("gd0Sp");

var $edsEA = parcelRequire("edsEA");

var $cvu76 = parcelRequire("cvu76");

var $dAlSQ = parcelRequire("dAlSQ");

var $dcV52 = parcelRequire("dcV52");
const $3aa2c3bcc356e542$export$2e4cb1dc5b398447 = ({ stack: stack })=>{
    const { data: features } = (0, $cvu76.useFeatures)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { isSiteAdmin: isSiteAdmin, isAdmin: isAdmin } = (0, $gd0Sp.useTenantContext)();
    const navigationPath = (0, $eUqFw.useMemo)(()=>(0, $iaHqR.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null);
    const showNewExternalImport = (isSiteAdmin || !isAdmin || (0, $1ybV0.ff)('enable-product-admin-for-x2c-migration_zmlsv')) && (0, $1ybV0.ff)('x2c-jim-home-screen-replacement_eikwe');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        title: formatMessage((0, $dAlSQ.default).importExportGroup)
    }, features.hasBackupManager && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'cloud-export'
        },
        href: navigationPath.importSectionBackupManager,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $dAlSQ.default).backupManager)), features.hasExternalImport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'external-import'
        },
        href: showNewExternalImport ? navigationPath.importSectionExternalImportNew : navigationPath.importSectionExternalImport,
        selectedOn: (currentLocation, itemLocation)=>(0, $bS2FN.matchUrlExact)()(currentLocation, itemLocation) || showNewExternalImport && currentLocation.pathname.includes(navigationPath.importSectionExternalImport)
    }, formatMessage((0, $dAlSQ.default).externalImport)), features.hasCloudImport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'cloud-import'
        },
        href: navigationPath.importSectionCloudImport,
        selectedOn: (0, $bS2FN.matchUrlExact)()
    }, formatMessage((0, $dAlSQ.default).importJiraCloud)), features.hasServerImport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'server-import'
        },
        href: navigationPath.importSectionServerImport,
        selectedOn: (0, $bS2FN.matchUrlExact)()
    }, formatMessage((0, $dAlSQ.default).importJiraServer)), (0, $b7Flp.shouldRenderNesting)(features.hasC2CMigration, stack, (0, $edsEA.SECTION_ID).MIGRATE_TO_CLOUD_SITE) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dcV52.MigrateCloudSiteMenuItem), null));
};

});
parcelRegister("b7Flp", function(module, exports) {

$parcel$export(module.exports, "shouldRenderNesting", () => $29014c8ea6c9a7cc$export$a35baff1c4efd3da);
const $29014c8ea6c9a7cc$export$a35baff1c4efd3da = (condition, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
stack, nestingId)=>condition === true || Boolean(stack && stack.includes(nestingId));

});

parcelRegister("dAlSQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $41e1809db484a615$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $41e1809db484a615$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    importExportGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.import-export-group",
        "defaultMessage": "Import and export"
    },
    backupManager: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.backup-manager",
        "defaultMessage": "Backup manager"
    },
    externalImport: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.external-import",
        "defaultMessage": "External System Import"
    },
    restoreSystem: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.restore-system",
        "defaultMessage": "Restore system"
    },
    importJiraCloud: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.import-jira-cloud",
        "defaultMessage": "Import Jira Cloud"
    },
    importJiraServer: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.import-jira-server",
        "defaultMessage": "Import Jira Server"
    }
});

});

parcelRegister("dcV52", function(module, exports) {

$parcel$export(module.exports, "MigrateCloudSiteMenuItem", () => $cf5c12f4e57bb341$export$48e579c481d74aac);

var $eUqFw = parcelRequire("eUqFw");

var $ffiyv = parcelRequire("ffiyv");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $iaHqR = parcelRequire("iaHqR");
var $2DHQu = parcelRequire("2DHQu");

var $edsEA = parcelRequire("edsEA");

var $bvI0E = parcelRequire("bvI0E");

var $bs5KZ = parcelRequire("bs5KZ");

var $48t98 = parcelRequire("48t98");
const $cf5c12f4e57bb341$export$48e579c481d74aac = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { release: release } = (0, $bvI0E.useReleaseVersion)();
    const BackMenuItem = {
        href: '/jira/settings/system/general-configuration',
        title: formatMessage((0, $bs5KZ.messages).itemBack)
    };
    const isBeta = (0, $1ybV0.ff)('jira-frontend-c2c-migrations-ga-release') ? release === 'BETA' : true;
    const navigationPath = (0, $eUqFw.useMemo)(()=>(0, $iaHqR.getSystemNavigationPaths)(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2DHQu.NestingMenuItem), {
        analytics: {
            itemId: 'migrate-to-cloud-site'
        },
        href: navigationPath.importSectionMigrateCloud,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatMessage((0, $bs5KZ.messages).migration), ' ', isBeta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
            appearance: "new"
        }, formatMessage((0, $bs5KZ.messages).migrationBetaLabel))),
        overrides: {
            BackMenuItem: BackMenuItem
        },
        id: (0, $edsEA.SECTION_ID).MIGRATE_TO_CLOUD_SITE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $48t98.MigrationsMenu), null));
};

});
parcelRegister("bvI0E", function(module, exports) {

$parcel$export(module.exports, "useReleaseVersion", () => $e879e74c96d015a5$export$4ea0c46c431d5d34);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $e879e74c96d015a5$export$1a5772dc2221d2a5 = ()=>(0, $lRmyA.performGetRequest)('/rest/migration/c2c_rollout_phase');
const $e879e74c96d015a5$export$4ea0c46c431d5d34 = ()=>{
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const [release, setRelease] = (0, $eUqFw.useState)('GA');
    const [error, setError] = (0, $eUqFw.useState)();
    const fetch = async ()=>{
        try {
            setLoading(true);
            setError(undefined);
            const data = await $e879e74c96d015a5$export$1a5772dc2221d2a5();
            setRelease(data.release);
            setLoading(false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (apiError) {
            setLoading(false);
            setError(apiError);
            (0, $guiFP.default)({
                error: apiError,
                meta: {
                    id: 'useReleaseVersion',
                    packageName: 'jiraNavigationAppsSidebarGlobalSettingsSystem',
                    teamName: 'navigation'
                }
            });
        }
    };
    (0, $eUqFw.useEffect)(()=>{
        fetch();
    }, []);
    return {
        loading: loading,
        release: release,
        error: error
    };
};

});

parcelRegister("bs5KZ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $08fa4fd7be2d477d$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $08fa4fd7be2d477d$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    migration: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.migrate-to-cloud-site.migration",
        "defaultMessage": "Migrate cloud site"
    },
    migrationBetaLabel: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.migrate-to-cloud-site.migration-beta-label",
        "defaultMessage": "Beta"
    },
    itemBack: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.migrate-to-cloud-site.item-back",
        "defaultMessage": "Back to system"
    }
});

});

parcelRegister("48t98", function(module, exports) {

$parcel$export(module.exports, "MigrationsMenu", () => $9d93503f54347e9a$export$9a2d2cb9bbe36e75);

var $eUqFw = parcelRequire("eUqFw");

var $23NQ5 = parcelRequire("23NQ5");

var $7eyVf = parcelRequire("7eyVf");

var $cswzZ = parcelRequire("cswzZ");

var $bKxX9 = parcelRequire("bKxX9");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bS2FN = parcelRequire("bS2FN");
var $1UelU = parcelRequire("1UelU");
var $9kVcv = parcelRequire("9kVcv");

var $dWLk9 = parcelRequire("dWLk9");

var $7K0sS = parcelRequire("7K0sS");
const $9d93503f54347e9a$export$9a2d2cb9bbe36e75 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const [{ data: data }, { fetchCohortDetails: fetchCohortDetails }] = (0, $cswzZ.useCohortDetails)();
    const baseMigrateCloudUrl = '/jira/settings/system/migration';
    const isCohort4Enabled = (0, $bKxX9.ff)('change-management-cohort-4-ff_4bpld');
    (0, $eUqFw.useEffect)(()=>{
        fetchCohortDetails(cloudId);
    }, [
        fetchCohortDetails,
        cloudId
    ]);
    if (data?.isCohortEnabled && (data?.cohortType === 'NEVER_USED_C2C_JIRA' || data?.cohortType === 'NOT_USED_C2C_JIRA_IN_3_MONTHS' || data?.hasOptedIn || data?.status === 'IN_PROGRESS' || data?.status === 'FAILED' || isCohort4Enabled)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'migration-home'
        },
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        href: `${baseMigrateCloudUrl}/home`
    }, formatMessage((0, $7K0sS.messages).title));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9kVcv.TitleHeader), null, formatMessage((0, $7K0sS.messages).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'migration-home'
        },
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        href: `${baseMigrateCloudUrl}/home`
    }, formatMessage((0, $7K0sS.messages).migrationOverview)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'plan-your-migration'
        },
        href: "https://support.atlassian.com/migration/docs/cloud-to-cloud-migration/",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
            size: "small",
            label: ""
        }),
        target: "_blank"
    }, formatMessage((0, $7K0sS.messages).planYourMigration)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'manage-migrations'
        },
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        href: `${baseMigrateCloudUrl}/dashboard`
    }, formatMessage((0, $7K0sS.messages).manageMigrations))));
};

});
parcelRegister("cswzZ", function(module, exports) {

$parcel$export(module.exports, "useCohortDetails", () => $2b04160c8585f0d7$export$79c60a355eee7756);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $8iS2S = parcelRequire("8iS2S");

var $dvjB8 = parcelRequire("dvjB8");
const $2b04160c8585f0d7$var$Store = (0, $a61MH.createStore)({
    initialState: (0, $dvjB8.COHORT_DETAILS_DEFAULT_STATE),
    actions: $8iS2S.default,
    name: 'Migrations - Cohort details'
});
const $2b04160c8585f0d7$export$79c60a355eee7756 = (0, $ggKAj.createHook)($2b04160c8585f0d7$var$Store);

});
parcelRegister("8iS2S", function(module, exports) {

$parcel$export(module.exports, "default", () => $c800949abf1df23a$export$2e2bcd8739ae039);
/* eslint-disable arrow-body-style */ 
var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $dvjB8 = parcelRequire("dvjB8");

var $6UAFb = parcelRequire("6UAFb");
const $c800949abf1df23a$export$343d10549fb4d411 = async (cloudId)=>{
    const fetchUrl = (0, $6UAFb.getCohortStatusUrl)(cloudId);
    return (0, $lRmyA.performGetRequest)(fetchUrl).catch((error)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'fetchCohortDetails',
                packageName: 'jiraC2CMigrationsCommonUtils',
                teamName: 'jira-c2c-migration'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    });
};
const $c800949abf1df23a$export$c9cf692e1e990743 = (cloudId)=>{
    // @ts-expect-error - TS2322 - Type '({ setState }: StoreActionApi<MigrationDetailsState>) => Promise<{ data: MigrationAPIData; siteContainerSelections: readonly ["USERS"] | readonly [...]; } | undefined>' is not assignable to type 'Action<MigrationDetailsState, void, void | Promise<void>>'.
    return async ({ setState: setState, getState: getState })=>{
        const showOptInButton = (0, $6UAFb.getOptInModalStatus)();
        setState({
            showOptInButton: showOptInButton
        });
        if (getState().data || getState().loading) return undefined;
        try {
            setState({
                loading: true
            });
            const data = await $c800949abf1df23a$export$343d10549fb4d411(cloudId);
            const derivedOptInButtonStatus = !data.hasOptedIn && data.status !== 'NEVER' || showOptInButton;
            (0, $6UAFb.setOptInModalStatus)(derivedOptInButtonStatus);
            setState({
                data: data,
                loading: false,
                showOptInButton: derivedOptInButtonStatus
            });
            return {
                data: data
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                error: error,
                loading: false
            });
            return undefined;
        }
    };
};
const $c800949abf1df23a$export$e64b646bfdf4078e = (showOptInButton)=>({ setState: setState })=>{
        (0, $6UAFb.setOptInModalStatus)(showOptInButton);
        setState({
            showOptInButton: showOptInButton
        });
    };
const $c800949abf1df23a$export$aad8462122ac592b = ()=>({ setState: setState })=>{
        setState({
            ...(0, $dvjB8.COHORT_DETAILS_DEFAULT_STATE),
            data: undefined,
            error: undefined
        });
    };
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c800949abf1df23a$export$2e2bcd8739ae039 = {
    fetchCohortDetails: $c800949abf1df23a$export$c9cf692e1e990743,
    updateShowOptInButton: $c800949abf1df23a$export$e64b646bfdf4078e,
    reset: $c800949abf1df23a$export$aad8462122ac592b
};

});
parcelRegister("dvjB8", function(module, exports) {

$parcel$export(module.exports, "COHORT_DETAILS_DEFAULT_STATE", () => $5829510d72ed2015$export$7108825eea599cbc);
$parcel$export(module.exports, "SESSION_STORAGE_KEY", () => $5829510d72ed2015$export$5200514808277ba7);
const $5829510d72ed2015$export$7108825eea599cbc = {
    loading: false,
    showOptInButton: false
};
const $5829510d72ed2015$export$5200514808277ba7 = 'C2C.MIGRATION.ADMIN.HUB.OPT.IN.BUTTON';

});

parcelRegister("6UAFb", function(module, exports) {

$parcel$export(module.exports, "getOptInModalStatus", () => $7e8dbe6bbb8ebc19$export$e69da0941df3caa9);
$parcel$export(module.exports, "setOptInModalStatus", () => $7e8dbe6bbb8ebc19$export$687080e399c5c65f);
$parcel$export(module.exports, "getCohortStatusUrl", () => $7e8dbe6bbb8ebc19$export$66a62d4e6369f93e);

var $dvjB8 = parcelRequire("dvjB8");
const $7e8dbe6bbb8ebc19$export$e69da0941df3caa9 = ()=>JSON.parse(sessionStorage.getItem((0, $dvjB8.SESSION_STORAGE_KEY)) || 'false');
const $7e8dbe6bbb8ebc19$export$687080e399c5c65f = (value)=>sessionStorage.setItem((0, $dvjB8.SESSION_STORAGE_KEY), String(value));
const $7e8dbe6bbb8ebc19$export$66a62d4e6369f93e = (cloudId)=>`/gateway/api/migrations/c2c/v1/change-management/cloud-id/${cloudId}/status`;

});



parcelRegister("7K0sS", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a2dad742e1ba6e60$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $a2dad742e1ba6e60$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.migrate-to-cloud-site.migrate-to-cloud-site-menu.title",
        "defaultMessage": "Migrate cloud site"
    },
    migrationOverview: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.migrate-to-cloud-site.migrate-to-cloud-site-menu.migration-overview",
        "defaultMessage": "Migration overview"
    },
    manageMigrations: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.migrate-to-cloud-site.migrate-to-cloud-site-menu.manage-migrations",
        "defaultMessage": "Migration dashboard"
    },
    planYourMigration: {
        "id": "spa-apps-sidebar-global-settings-system.menu.import-export.migrate-to-cloud-site.migrate-to-cloud-site-menu.plan-your-migration",
        "defaultMessage": "Plan your migration"
    }
});

});




parcelRegister("lLbUm", function(module, exports) {

$parcel$export(module.exports, "MailSection", () => $4b850ae4133842e3$export$6e0cda39522c0aa7);

var $eUqFw = parcelRequire("eUqFw");

var $7eyVf = parcelRequire("7eyVf");
var $gLn5u = parcelRequire("gLn5u");

var $5JgJ2 = parcelRequire("5JgJ2");

var $iaHqR = parcelRequire("iaHqR");
var $bS2FN = parcelRequire("bS2FN");
var $1UelU = parcelRequire("1UelU");

var $cvu76 = parcelRequire("cvu76");

var $iHYBT = parcelRequire("iHYBT");

var $8VG5B = parcelRequire("8VG5B");
const $4b850ae4133842e3$export$6e0cda39522c0aa7 = ()=>{
    const { data: features } = (0, $cvu76.useFeatures)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const navigationPath = (0, $eUqFw.useMemo)(()=>(0, $iaHqR.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        title: formatMessage((0, $iHYBT.default).mailGroup)
    }, features.hasGlobalMailSettings && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'global-mail-settings'
        },
        href: navigationPath.mailSectionGlobalMailSettings,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $iHYBT.default).globalMailSettings)), features.hasOutgoingMail && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'outgoing-mail'
        },
        href: navigationPath.mailSectionOutgoingMail,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $iHYBT.default).outgoingMail)), features.hasIncomingMail && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'incoming-mail'
        },
        href: navigationPath.mailSectionIncomingMail,
        selectedOn: (0, $8VG5B.isIncomingMailSelected)
    }, formatMessage((0, $iHYBT.default).incomingMail)), features.hasSendMail && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'send-email'
        },
        href: navigationPath.mailSectionSendMail,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $iHYBT.default).sendEmail)));
};

});
parcelRegister("iHYBT", function(module, exports) {

$parcel$export(module.exports, "default", () => $7634283c8e8b9c35$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7634283c8e8b9c35$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    mailGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.mail.mail-group",
        "defaultMessage": "Mail"
    },
    globalMailSettings: {
        "id": "spa-apps-sidebar-global-settings-system.menu.mail.global-mail-settings",
        "defaultMessage": "Global Mail Settings"
    },
    outgoingMail: {
        "id": "spa-apps-sidebar-global-settings-system.menu.mail.outgoing-mail",
        "defaultMessage": "Outgoing Mail"
    },
    incomingMail: {
        "id": "spa-apps-sidebar-global-settings-system.menu.mail.incoming-mail",
        "defaultMessage": "Incoming Mail"
    },
    sendEmail: {
        "id": "spa-apps-sidebar-global-settings-system.menu.mail.send-email",
        "defaultMessage": "Send email"
    }
});

});

parcelRegister("8VG5B", function(module, exports) {

$parcel$export(module.exports, "isIncomingMailSelected", () => $935706991ebeee78$export$3f53f72603975cb0);

var $bS2FN = parcelRequire("bS2FN");
const $935706991ebeee78$var$INCOMING_MAIL_PATH_REGEXP = /\/admin\/(\w+)Pop(Mail)?Server/i;
const $935706991ebeee78$export$3f53f72603975cb0 = (currentLocation, itemLocation)=>(0, $bS2FN.matchUrlExact)()(currentLocation, itemLocation) || $935706991ebeee78$var$INCOMING_MAIL_PATH_REGEXP.test(currentLocation.pathname);

});


parcelRegister("gzoho", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8e2230353ff9d9c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f8e2230353ff9d9c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    systemGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.system-group",
        "defaultMessage": "System"
    },
    generalConfiguration: {
        "id": "spa-apps-sidebar-global-settings-system.menu.general-configuration",
        "defaultMessage": "General configuration"
    },
    darkFeatures: {
        "id": "spa-apps-sidebar-global-settings-system.menu.dark-features",
        "defaultMessage": "Dark features"
    },
    issueCollectors: {
        "id": "spa-apps-sidebar-global-settings-system.menu.issue-collectors",
        "defaultMessage": "Issue collectors"
    }
});

});

parcelRegister("dL8Xn", function(module, exports) {

$parcel$export(module.exports, "SecuritySection", () => $eb924df18a7c6010$export$4f16aec1633bed7d);

var $eUqFw = parcelRequire("eUqFw");

var $7eyVf = parcelRequire("7eyVf");
var $gLn5u = parcelRequire("gLn5u");

var $5JgJ2 = parcelRequire("5JgJ2");

var $iaHqR = parcelRequire("iaHqR");
var $bS2FN = parcelRequire("bS2FN");
var $1UelU = parcelRequire("1UelU");

var $cvu76 = parcelRequire("cvu76");

var $dSsSw = parcelRequire("dSsSw");

var $gvZ8X = parcelRequire("gvZ8X");
const $eb924df18a7c6010$export$4f16aec1633bed7d = ()=>{
    const { data: features } = (0, $cvu76.useFeatures)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const navigationPath = (0, $eUqFw.useMemo)(()=>(0, $iaHqR.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null);
    const globalPermissionsPath = navigationPath.securityGlobalPermissions;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        title: formatMessage((0, $dSsSw.default).securityGroup)
    }, features.hasProjectRoles && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'project-roles'
        },
        href: navigationPath.securityProjectRoles,
        selectedOn: (0, $gvZ8X.isProjectRolesSelected)
    }, formatMessage((0, $dSsSw.default).projectRoles)), features.hasGlobalPermissions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'global-permissions'
        },
        href: globalPermissionsPath,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $dSsSw.default).globalPermissions)));
};

});
parcelRegister("dSsSw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec3b061d4e12a99b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ec3b061d4e12a99b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    securityGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.security.security-group",
        "defaultMessage": "Security"
    },
    projectRoles: {
        "id": "spa-apps-sidebar-global-settings-system.menu.security.project-roles",
        "defaultMessage": "Project roles"
    },
    globalPermissions: {
        "id": "spa-apps-sidebar-global-settings-system.menu.security.global-permissions",
        "defaultMessage": "Global permissions"
    }
});

});

parcelRegister("gvZ8X", function(module, exports) {

$parcel$export(module.exports, "isProjectRolesSelected", () => $04b6f104889e683f$export$ca9501e7fedfce90);

var $bS2FN = parcelRequire("bS2FN");
const $04b6f104889e683f$var$PROJECT_ROLES_PATH_REGEXP = /\/project\/(\w+)ProjectRole/i;
const $04b6f104889e683f$export$ca9501e7fedfce90 = (currentLocation, itemLocation)=>(0, $bS2FN.matchUrlExact)()(currentLocation, itemLocation) || $04b6f104889e683f$var$PROJECT_ROLES_PATH_REGEXP.test(currentLocation.pathname);

});


parcelRegister("7NvRo", function(module, exports) {

$parcel$export(module.exports, "SharedSection", () => $3b965d50f8cd4528$export$230e518497f06fdc);

var $eUqFw = parcelRequire("eUqFw");

var $7eyVf = parcelRequire("7eyVf");
var $gLn5u = parcelRequire("gLn5u");

var $5JgJ2 = parcelRequire("5JgJ2");

var $iaHqR = parcelRequire("iaHqR");
var $bS2FN = parcelRequire("bS2FN");
var $1UelU = parcelRequire("1UelU");

var $cvu76 = parcelRequire("cvu76");

var $lwwO0 = parcelRequire("lwwO0");
const $3b965d50f8cd4528$export$230e518497f06fdc = ()=>{
    const { data: features } = (0, $cvu76.useFeatures)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const navigationPath = (0, $eUqFw.useMemo)(()=>(0, $iaHqR.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        title: formatMessage((0, $lwwO0.default).sharedItems)
    }, features.hasManageFilters && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'manage-filters'
        },
        href: navigationPath.sharedSectionManageFilters,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $lwwO0.default).filters)), features.hasManageDashboards && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'manage-dashboards'
        },
        href: navigationPath.sharedManageDashboards,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $lwwO0.default).dashboards)));
};

});
parcelRegister("lwwO0", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c7097381edc8287$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0c7097381edc8287$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    sharedItems: {
        "id": "spa-apps-sidebar-global-settings-system.menu.shared.shared-items",
        "defaultMessage": "Shared Items"
    },
    sharedFilters: {
        "id": "spa-apps-sidebar-global-settings-system.menu.shared.shared-filters",
        "defaultMessage": "Shared filters"
    },
    sharedDashboards: {
        "id": "spa-apps-sidebar-global-settings-system.menu.shared.shared-dashboards",
        "defaultMessage": "Shared dashboards"
    },
    filters: {
        "id": "spa-apps-sidebar-global-settings-system.menu.shared.filters",
        "defaultMessage": "Filters"
    },
    dashboards: {
        "id": "spa-apps-sidebar-global-settings-system.menu.shared.dashboards",
        "defaultMessage": "Dashboards"
    }
});

});


parcelRegister("kdz1U", function(module, exports) {

$parcel$export(module.exports, "TroubleshootingAndSupportSection", () => $71e9461820402186$export$dad01649916e6a2d);

var $eUqFw = parcelRequire("eUqFw");

var $7eyVf = parcelRequire("7eyVf");
var $gLn5u = parcelRequire("gLn5u");

var $5JgJ2 = parcelRequire("5JgJ2");

var $iaHqR = parcelRequire("iaHqR");
var $bS2FN = parcelRequire("bS2FN");
var $1UelU = parcelRequire("1UelU");

var $15MfS = parcelRequire("15MfS");

var $cvu76 = parcelRequire("cvu76");

var $9yHg3 = parcelRequire("9yHg3");

var $i8TI3 = parcelRequire("i8TI3");

var $jp7a0 = parcelRequire("jp7a0");
const $71e9461820402186$export$dad01649916e6a2d = ()=>{
    const { data: features } = (0, $cvu76.useFeatures)();
    const { hasSiteOptimizerEntitlement: hasSiteOptimizerEntitlement } = (0, $15MfS.useSiteOptimizerCheck)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const navigationPath = (0, $eUqFw.useMemo)(()=>(0, $iaHqR.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        title: formatMessage((0, $9yHg3.default).troubleshootingGroup)
    }, features.hasViewAuditing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'view-auditing'
        },
        href: navigationPath.troubleshootingAuditLog,
        selectedOn: (0, $jp7a0.isViewAuditingSelected)
    }, formatMessage((0, $9yHg3.default).auditLog)), features.hasPluginViewer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'plugin-viewer'
        },
        href: navigationPath.troubleshootingPluginViewer,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $9yHg3.default).pluginViewer)), features.hasModulesViewer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'modules-viewer'
        },
        href: navigationPath.troubleshootingModulesViewer,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $9yHg3.default).modulesViewer)), features.hasSystemInfo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'system-info'
        },
        href: navigationPath.troubleshootingSystemInfo,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $9yHg3.default).systemInfo)), features.hasIntegrityChecker && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'integrity-checker'
        },
        href: navigationPath.troubleshootingIntegrityChecker,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $9yHg3.default).integrityChecker)), features.hasLoggingProfiling && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'logging-profiling'
        },
        href: navigationPath.troubleshootingLoggingProfiling,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $9yHg3.default).loggingProfiling)), features.hasSchedulerDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'scheduler-details'
        },
        href: navigationPath.troubleshootingSchedulerDetails,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $9yHg3.default).schedulerDetails)), hasSiteOptimizerEntitlement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i8TI3.PerformanceMenuItem), null));
};

});
parcelRegister("15MfS", function(module, exports) {

$parcel$export(module.exports, "useSiteOptimizerCheck", () => $818da71bb0bbfb92$export$7df80afc329cd61);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $lRmyA = parcelRequire("lRmyA");
const $818da71bb0bbfb92$export$e9921a980669184 = ()=>(0, $lRmyA.performGetRequest)('/rest/internal/psi/latest/licence/check');
const $818da71bb0bbfb92$export$7df80afc329cd61 = ()=>{
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const [hasEntitlement, setHasEntitlement] = (0, $eUqFw.useState)(false);
    const [error, setError] = (0, $eUqFw.useState)();
    const fetch = async ()=>{
        try {
            setLoading(true);
            setError(undefined);
            if ((0, $1ybV0.ff)('override-enable-performance-and-scale-admin-menu')) setHasEntitlement(true);
            else {
                const data = await $818da71bb0bbfb92$export$e9921a980669184();
                setHasEntitlement(data?.isVisible ?? false);
            }
            setLoading(false);
        } catch (apiError) {
            setLoading(false);
            setError(apiError);
        }
    };
    (0, $eUqFw.useEffect)(()=>{
        fetch();
    }, []);
    return {
        loading: loading,
        hasSiteOptimizerEntitlement: hasEntitlement,
        error: error
    };
};

});

parcelRegister("9yHg3", function(module, exports) {

$parcel$export(module.exports, "default", () => $d15a1298c551d31f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d15a1298c551d31f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    troubleshootingGroup: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.troubleshooting-group",
        "defaultMessage": "Troubleshooting and Support"
    },
    auditLog: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.audit-log",
        "defaultMessage": "Audit Log"
    },
    pluginViewer: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.plugin-viewer",
        "defaultMessage": "Plugin Viewer"
    },
    modulesViewer: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.modules-viewer",
        "defaultMessage": "Modules Viewer"
    },
    systemInfo: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.system-info",
        "defaultMessage": "System info"
    },
    integrityChecker: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.integrity-checker",
        "defaultMessage": "Integrity checker"
    },
    loggingProfiling: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.logging-profiling",
        "defaultMessage": "Logging profiling"
    },
    schedulerDetails: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.scheduler-details",
        "defaultMessage": "Scheduler details"
    }
});

});

parcelRegister("i8TI3", function(module, exports) {

$parcel$export(module.exports, "PerformanceMenuItem", () => $6f8ee83e9e372c3f$export$b4e98631ff0b3fb5);

var $eUqFw = parcelRequire("eUqFw");

var $ffiyv = parcelRequire("ffiyv");

var $hJJD2 = parcelRequire("hJJD2");
var $aOINP = parcelRequire("aOINP");
var $ltfxy = parcelRequire("ltfxy");
var $7zpSo = parcelRequire("7zpSo");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");

var $PdmhA = parcelRequire("PdmhA");

var $5JgJ2 = parcelRequire("5JgJ2");

var $iaHqR = parcelRequire("iaHqR");
var $2DHQu = parcelRequire("2DHQu");

var $jMP2a = parcelRequire("jMP2a");

var $dxcfv = parcelRequire("dxcfv");

var $edsEA = parcelRequire("edsEA");

var $76jM0 = parcelRequire("76jM0");

var $eTVkQ = parcelRequire("eTVkQ");

var $gX1Xl = parcelRequire("gX1Xl");
const $6f8ee83e9e372c3f$export$b4e98631ff0b3fb5 = ()=>{
    const accountId = (0, $dxcfv.useAccountId)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isOptimiserSpotlightActive, setIsOptimiserSpotlightActive] = (0, $eUqFw.useState)(false);
    const navigationPath = (0, $eUqFw.useMemo)(()=>(0, $iaHqR.getSystemNavigationPaths)(), []);
    const BackMenuItem = {
        href: '/jira/settings/system/general-configuration',
        title: formatMessage((0, $76jM0.default).itemBack)
    };
    const fetchSpotlightState = (0, $eUqFw.useCallback)(async ()=>{
        if (accountId != null) {
            const response = await (0, $gX1Xl.hasSeenSiteOptimiserSpotlight)(accountId);
            setIsOptimiserSpotlightActive(!response);
        }
    }, [
        accountId
    ]);
    (0, $eUqFw.useEffect)(()=>{
        fetchSpotlightState();
    }, [
        fetchSpotlightState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOINP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
        name: "site-optimiser-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2DHQu.NestingMenuItem), {
        analytics: {
            itemId: 'performance-and-scale'
        },
        href: navigationPath.troubleshootingPerformanceAndScale,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
            gap: "space.050",
            justifyContent: "start",
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, formatMessage((0, $76jM0.default).performanceAndScale)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
            appearance: "new"
        }, formatMessage((0, $76jM0.default).beta))),
        overrides: {
            BackMenuItem: BackMenuItem
        },
        id: (0, $edsEA.SECTION_ID).PERFORMANCE_AND_SCALE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eTVkQ.PerformanceAndScaleMenu), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7zpSo.default), null, isOptimiserSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJJD2.default), {
        actions: [
            {
                onClick: (_, analyticsEvent)=>{
                    setIsOptimiserSpotlightActive(false);
                    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'performanceMenuItemSpotlightComplete');
                },
                text: formatMessage((0, $76jM0.default).spotlightAction)
            }
        ],
        heading: formatMessage((0, $76jM0.default).spotlightHeading),
        target: "site-optimiser-spotlight",
        key: "site-optimiser-spotlight",
        targetRadius: 3,
        targetBgColor: `var(--ds-surface, ${(0, $PdmhA.N0)})`,
        dialogPlacement: "right top"
    }, formatMessage((0, $76jM0.default).spotlightBody))));
};

});
parcelRegister("76jM0", function(module, exports) {

$parcel$export(module.exports, "default", () => $594471997def5449$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $594471997def5449$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    performanceAndScale: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale",
        "defaultMessage": "Site optimizer"
    },
    itemBack: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.item-back",
        "defaultMessage": "Back to system"
    },
    spotlightHeading: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.spotlight-heading",
        "defaultMessage": "Clean up your site"
    },
    spotlightBody: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.spotlight-body",
        "defaultMessage": "Remove old data that might be slowing down your site in a few clicks."
    },
    spotlightAction: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.spotlight-action",
        "defaultMessage": "Ok"
    },
    beta: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.beta",
        "defaultMessage": "Beta"
    }
});

});

parcelRegister("eTVkQ", function(module, exports) {

$parcel$export(module.exports, "PerformanceAndScaleMenu", () => $263e832452d2566c$export$442d4ccb0d25fc50);

var $eUqFw = parcelRequire("eUqFw");

var $7eyVf = parcelRequire("7eyVf");

var $lBOVe = parcelRequire("lBOVe");

var $8WG7k = parcelRequire("8WG7k");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bS2FN = parcelRequire("bS2FN");
var $1UelU = parcelRequire("1UelU");
var $9kVcv = parcelRequire("9kVcv");

var $g0nB0 = parcelRequire("g0nB0");
const $263e832452d2566c$export$442d4ccb0d25fc50 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const basePerformanceUrl = '/jira/settings/system/performance';
    const allVisibleMetrics = (0, $lBOVe.getAllVisibleMetrics)();
    // On clean up of ff, return `${basePerformanceUrl}/metrics/${metric.key}` and remove this function
    const getUrl = (metric)=>{
        if ((0, $1ybV0.ff)('split-metric-detail-routes-from-1-to-3_9hlcc') || metric.key === (0, $8WG7k.PROJECT_CLEANUP_KEY)) return `${basePerformanceUrl}/metrics/${metric.key}`;
        return `${basePerformanceUrl}/metric/${metric.key}`;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9kVcv.TitleHeader), null, formatMessage((0, $g0nB0.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'performance-overview'
        },
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        href: `${basePerformanceUrl}/overview`
    }, formatMessage((0, $g0nB0.default).overview))), allVisibleMetrics.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        title: formatMessage((0, $g0nB0.default).allReports)
    }, allVisibleMetrics.map((metric)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
            analytics: {
                itemId: `performance-metric-${metric.key}`
            },
            href: getUrl(metric),
            selectedOn: (0, $bS2FN.matchUrlPathname)(),
            key: metric.key
        }, formatMessage(metric.name)))));
};

});
parcelRegister("lBOVe", function(module, exports) {

$parcel$export(module.exports, "getAllVisibleMetrics", () => $93d909cef4928ba1$export$e6140fda06493d18);
$parcel$export(module.exports, "getMetric", () => $93d909cef4928ba1$export$ed0dc1178a679c67);
$parcel$export(module.exports, "getAllVisibleMetricKeys", () => $93d909cef4928ba1$export$1f2abf3e170d35d2);
$parcel$export(module.exports, "assertNever", () => $93d909cef4928ba1$export$cbadc5a7223772a8);

var $eI5EY = parcelRequire("eI5EY");

var $7sw6U = parcelRequire("7sw6U");
var $29cWe = parcelRequire("29cWe");
var $8WG7k = parcelRequire("8WG7k");
var $dvpny = parcelRequire("dvpny");

var $4zgfm = parcelRequire("4zgfm");
class $93d909cef4928ba1$export$9419457073a1750 {
    constructor(metrics){
        this.metrics = metrics;
    }
    getMetric(key) {
        return this.metrics.find((m)=>m.key === key);
    }
    getAllVisibleMetrics() {
        return this.metrics.filter((metric)=>metric.visible && $93d909cef4928ba1$export$898df584445641cf(metric.key));
    }
    getAllVisibleMetricsKeys() {
        return $93d909cef4928ba1$export$e6140fda06493d18().map((m)=>m.key);
    }
}
/**
 * Metric registry singleton. We should not be creating another registry.
 */ const $93d909cef4928ba1$var$REGISTRY = new $93d909cef4928ba1$export$9419457073a1750((0, $4zgfm.METRICS));
const $93d909cef4928ba1$export$ed0dc1178a679c67 = $93d909cef4928ba1$var$REGISTRY.getMetric.bind($93d909cef4928ba1$var$REGISTRY);
const $93d909cef4928ba1$export$e6140fda06493d18 = $93d909cef4928ba1$var$REGISTRY.getAllVisibleMetrics.bind($93d909cef4928ba1$var$REGISTRY);
const $93d909cef4928ba1$export$1f2abf3e170d35d2 = $93d909cef4928ba1$var$REGISTRY.getAllVisibleMetricsKeys.bind($93d909cef4928ba1$var$REGISTRY);
const $93d909cef4928ba1$export$898df584445641cf = (metricKey)=>{
    switch(metricKey){
        case 0, $8WG7k.PROJECT_CLEANUP_KEY:
            return (0, $eI5EY.fg)('site-optimizer-project-cleanup');
        case 0, $dvpny.PROJECT_ROLE_ACTOR_KEY:
        case 0, $7sw6U.CUSTOM_FIELDS_KEY:
        case 0, $29cWe.ISSUE_KEY:
            return true;
        default:
            return false;
    }
};
const $93d909cef4928ba1$export$cbadc5a7223772a8 = (_, message)=>{
    throw new Error(message);
};

});
parcelRegister("7sw6U", function(module, exports) {

$parcel$export(module.exports, "CUSTOM_FIELDS_KEY", () => $31622d93f2040b73$export$d214286a7039b004);
$parcel$export(module.exports, "CUSTOM_FIELDS", () => $31622d93f2040b73$export$459112111ad5b136);

var $k1e0Z = parcelRequire("k1e0Z");
const $31622d93f2040b73$export$d214286a7039b004 = 'customField';
const $31622d93f2040b73$export$459112111ad5b136 = {
    key: $31622d93f2040b73$export$d214286a7039b004,
    visible: true,
    name: (0, $k1e0Z.default).name,
    description: (0, $k1e0Z.default).description,
    tabLabels: [
        (0, $k1e0Z.default).chart,
        (0, $k1e0Z.default).reviewAndAnalyze
    ],
    warningMessage: (0, $k1e0Z.default).warning,
    exceededMessage: (0, $k1e0Z.default).exceeded,
    risks: [
        (0, $k1e0Z.default).risk1
    ],
    mitigations: [],
    currentValueLabel: (0, $k1e0Z.default).currentValueLabel,
    currentValueAriaLabel: (0, $k1e0Z.default).currentValueAriaLabel,
    thresholdValueLabel: (0, $k1e0Z.default).thresholdValueLabel,
    thresholdValueAriaLabel: (0, $k1e0Z.default).thresholdValueAriaLabel,
    recommendationUrl: 'https://support.atlassian.com/jira-cloud-administration/docs/optimize-your-custom-fields/',
    recommendationUrlText: (0, $k1e0Z.default).recommendationUrlText,
    graphHeader: (0, $k1e0Z.default).graphHeader
};

});
parcelRegister("k1e0Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3104a008db7c7b9$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
// The following are the description for the translators for the different text that we need translating.
// Unfortunately, this needs to copied to individual files because the i18n text extraction tool needs
// to be able to resolve variables statically. This duplication is OK.
const $a3104a008db7c7b9$var$NAME_DESC = 'Name of the site optimizer metric that will be used as the title on the page and menu item.';
const $a3104a008db7c7b9$var$DESCRIPTON_DESC = 'Description of the site optimizer metric.';
const $a3104a008db7c7b9$var$CHART_DESC = 'A tab label of Custom Field Tabs, to show custom fields chart';
const $a3104a008db7c7b9$var$REVIEW_AND_ANALYZE_DESC = 'A tab label of Custom Field Tabs, to show custom fields review and analyze';
const $a3104a008db7c7b9$var$WARNING_DESC = 'Warning message if metric are getting close to the threshold.';
const $a3104a008db7c7b9$var$EXCEEDED_DESC = 'Message to show to the user if metric has exceeded the threshold.';
const $a3104a008db7c7b9$var$RISK_DESC = 'One of the risks when this metric exceeded the threshold.';
const $a3104a008db7c7b9$var$MITIGATION_DESC = 'One of the mitigation options when this metric exceeded the threshold.';
const $a3104a008db7c7b9$var$CURRENT_VALUE_LABEL_DESC = 'Label to be shown next to the current value of the metric.';
const $a3104a008db7c7b9$var$THRESHOLD_VALUE_LABEL_DESC = 'Label to be shown next to the threshold value of the metric.';
const $a3104a008db7c7b9$var$RECOMMENDATION_URL_TEXT_DESC = 'Text to be shown on the hypertext link to additional documentation.';
const $a3104a008db7c7b9$var$GRAPH_HEADER_DESC = 'Text to be shown on the header of the metric graph.';
var $a3104a008db7c7b9$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    name: {
        "id": "admin-pages-performance.common.assets.custom-fields.name",
        "defaultMessage": "Custom fields"
    },
    description: {
        "id": "admin-pages-performance.common.assets.custom-fields.description",
        "defaultMessage": "Here are the custom fields in your site, including ones we think can be removed because they\u2019re not used. Removing unused fields could improve site performance and stability."
    },
    chart: {
        "id": "admin-pages-performance.common.assets.custom-fields.chart",
        "defaultMessage": "Overview"
    },
    reviewAndAnalyze: {
        "id": "admin-pages-performance.common.assets.custom-fields.review-and-analyze",
        "defaultMessage": "Analysis"
    },
    warning: {
        "id": "admin-pages-performance.common.assets.custom-fields.warning",
        "defaultMessage": "The number of custom fields is nearing our recommended threshold."
    },
    exceeded: {
        "id": "admin-pages-performance.common.assets.custom-fields.exceeded",
        "defaultMessage": "There are more custom fields than our recommended threshold."
    },
    risk1: {
        "id": "admin-pages-performance.common.assets.custom-fields.risk-1",
        "defaultMessage": "Custom fields can make searching for issues (JQL and boards) and creating issues slow."
    },
    mitigation1: {
        "id": "admin-pages-performance.common.assets.custom-fields.mitigation-1",
        "defaultMessage": "Edit the context for the custom field to make it visible only for specific projects."
    },
    mitigation2: {
        "id": "admin-pages-performance.common.assets.custom-fields.mitigation-2",
        "defaultMessage": "Limit the number of custom fields across all projects and use the same custom field in multiple projects."
    },
    currentValueLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.current-value-label",
        "defaultMessage": "Custom fields in your site"
    },
    thresholdValueLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.threshold-value-label",
        "defaultMessage": "Recommended maximum number of custom fields"
    },
    currentValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.current-value-aria-label",
        "defaultMessage": "{number} custom fields in your site"
    },
    thresholdValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.custom-fields.threshold-value-aria-label",
        "defaultMessage": "{number} recommended maximum number of custom fields"
    },
    recommendationUrlText: {
        "id": "admin-pages-performance.common.assets.custom-fields.recommendation-url-text",
        "defaultMessage": "Learn how we identify these fields."
    },
    graphHeader: {
        "id": "admin-pages-performance.common.assets.custom-fields.graph-header",
        "defaultMessage": "Custom fields over time"
    }
});

});


parcelRegister("29cWe", function(module, exports) {

$parcel$export(module.exports, "ISSUE_KEY", () => $63a6bddb6870ae94$export$5daa28d10e23592);
$parcel$export(module.exports, "ISSUE", () => $63a6bddb6870ae94$export$76a449e52fa0e1e8);

var $gh3p2 = parcelRequire("gh3p2");
const $63a6bddb6870ae94$export$5daa28d10e23592 = 'issue';
const $63a6bddb6870ae94$export$76a449e52fa0e1e8 = {
    key: $63a6bddb6870ae94$export$5daa28d10e23592,
    visible: true,
    name: (0, $gh3p2.default).name,
    description: (0, $gh3p2.default).description,
    tabLabels: [
        (0, $gh3p2.default).reviewAndAnalyze,
        (0, $gh3p2.default).activityLog
    ],
    warningMessage: (0, $gh3p2.default).warning,
    exceededMessage: (0, $gh3p2.default).exceeded,
    risks: [
        (0, $gh3p2.default).risk1
    ],
    mitigations: [
        (0, $gh3p2.default).mitigation1,
        (0, $gh3p2.default).mitigation2,
        (0, $gh3p2.default).mitigation3
    ],
    currentValueLabel: (0, $gh3p2.default).currentValueLabel,
    currentValueAriaLabel: (0, $gh3p2.default).currentValueAriaLabel,
    thresholdValueLabel: (0, $gh3p2.default).thresholdValueLabel,
    thresholdValueAriaLabel: (0, $gh3p2.default).thresholdValueAriaLabel,
    graphHeader: (0, $gh3p2.default).graphHeader
};

});
parcelRegister("gh3p2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d85bbb4fb87b5b3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
// The following are the description for the translators for the different text that we need translating.
// Unfortunately, this needs to copied to individual files because the i18n text extraction tool needs
// to be able to resolve variables statically. This duplication is OK.
const $9d85bbb4fb87b5b3$var$NAME_DESC = 'Name of the site optimizer metric that will be used as the title on the page and menu item.';
const $9d85bbb4fb87b5b3$var$DESCRIPTON_DESC = 'Description of the site optimizer metric.';
const $9d85bbb4fb87b5b3$var$CHART_DESC = 'A tab label of Issue Tabs, to show Issue chart';
const $9d85bbb4fb87b5b3$var$REVIEW_AND_ANALYZE_DESC = 'A tab label of Issue Tabs, to show issue review and analyze';
const $9d85bbb4fb87b5b3$var$WARNING_DESC = 'Warning message if metric are getting close to the threshold.';
const $9d85bbb4fb87b5b3$var$EXCEEDED_DESC = 'Message to show to the user if metric has exceeded the threshold.';
const $9d85bbb4fb87b5b3$var$RISK_DESC = 'One of the risks when this metric exceeded the threshold.';
const $9d85bbb4fb87b5b3$var$MITIGATION_DESC = 'One of the mitigation options when this metric exceeded the threshold.';
const $9d85bbb4fb87b5b3$var$CURRENT_VALUE_LABEL_DESC = 'Label to be shown next to the current value of the metric.';
const $9d85bbb4fb87b5b3$var$THRESHOLD_VALUE_LABEL_DESC = 'Label to be shown next to the threshold value of the metric.';
const $9d85bbb4fb87b5b3$var$ACTIVITY_LOG_DESC = 'A tab label of Activity Log Tabs, to show Issue Archival past operations';
const $9d85bbb4fb87b5b3$var$GRAPH_HEADER_DESC = 'Text to be shown on the header of the metric graph.';
var $9d85bbb4fb87b5b3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    name: {
        "id": "admin-pages-performance.common.assets.issue.name",
        "defaultMessage": "Issues"
    },
    description: {
        "id": "admin-pages-performance.common.assets.issue.description",
        "defaultMessage": "Here\u2019s a quick snapshot of the total number of issues in your site, including some that we think can be archived. Archiving unused issues can improve performance and stability of your site."
    },
    chart: {
        "id": "admin-pages-performance.common.assets.issue.chart",
        "defaultMessage": "Overview"
    },
    reviewAndAnalyze: {
        "id": "admin-pages-performance.common.assets.issue.review-and-analyze",
        "defaultMessage": "Analysis"
    },
    activityLog: {
        "id": "admin-pages-performance.common.assets.issue.activity-log",
        "defaultMessage": "Activity log"
    },
    warning: {
        "id": "admin-pages-performance.common.assets.issue.warning",
        "defaultMessage": "The number of issues in the system is nearing our recommended threshold."
    },
    exceeded: {
        "id": "admin-pages-performance.common.assets.issue.exceeded",
        "defaultMessage": "There are more issues in the system than our recommended threshold."
    },
    risk1: {
        "id": "admin-pages-performance.common.assets.issue.risk-1",
        "defaultMessage": "If you have too many issues you may find searches, automations, and workflow rules are slower than usual."
    },
    mitigation1: {
        "id": "admin-pages-performance.common.assets.issue.mitigation-1",
        "defaultMessage": "Delete any projects that are no longer required."
    },
    mitigation2: {
        "id": "admin-pages-performance.common.assets.issue.mitigation-2",
        "defaultMessage": "Disable Jira integrations that create issues you don't need."
    },
    mitigation3: {
        "id": "admin-pages-performance.common.assets.issue.mitigation-3",
        "defaultMessage": "Delete old issues that are no longer required. Use a JQL query to find issues older than a year (\u201Ccreated < -365d order by created DESC\u201C)."
    },
    currentValueLabel: {
        "id": "admin-pages-performance.common.assets.issue.current-value-label",
        "defaultMessage": "Total current issues in your site"
    },
    thresholdValueLabel: {
        "id": "admin-pages-performance.common.assets.issue.threshold-value-label",
        "defaultMessage": "Recommended maximum number of issues"
    },
    currentValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.issue.current-value-aria-label",
        "defaultMessage": "{number} total current issues in your site"
    },
    thresholdValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.issue.threshold-value-aria-label",
        "defaultMessage": "{number} recommended maximum number of issues"
    },
    graphHeader: {
        "id": "admin-pages-performance.common.assets.issue.graph-header",
        "defaultMessage": "Issues over time"
    }
});

});


parcelRegister("8WG7k", function(module, exports) {

$parcel$export(module.exports, "PROJECT_CLEANUP_KEY", () => $75960bfe165caecf$export$4e9bf1d386c2f0c);
$parcel$export(module.exports, "PROJECT_CLEANUP", () => $75960bfe165caecf$export$761acf34bef3a717);

var $cPhgq = parcelRequire("cPhgq");
const $75960bfe165caecf$export$4e9bf1d386c2f0c = 'projectcleanup';
const $75960bfe165caecf$export$761acf34bef3a717 = {
    key: $75960bfe165caecf$export$4e9bf1d386c2f0c,
    visible: true,
    name: (0, $cPhgq.default).nameNonFinal,
    description: (0, $cPhgq.default).descriptionNonFinal,
    tabLabels: [
        (0, $cPhgq.default).analysisNonFinal,
        (0, $cPhgq.default).activityLogNonFinal
    ],
    warningMessage: (0, $cPhgq.default).warningNonFinal,
    exceededMessage: (0, $cPhgq.default).exceededNonFinal,
    risks: [],
    mitigations: [],
    currentValueLabel: (0, $cPhgq.default).currentValueLabel,
    cleanupValueLabel: (0, $cPhgq.default).cleanupValueLabel
};

});
parcelRegister("cPhgq", function(module, exports) {

$parcel$export(module.exports, "default", () => $415a350c7923b11b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
// The following are the description for the translators for the different text that we need translating.
// Unfortunately, this needs to copied to individual files because the i18n text extraction tool needs
// to be able to resolve variables statically. This duplication is OK.
const $415a350c7923b11b$var$NAME_DESC = 'Name of the site optimizer metric that will be used as the title on the page and menu item.';
const $415a350c7923b11b$var$DESCRIPTION_DESC = 'Description of the site optimizer metric.';
const $415a350c7923b11b$var$WARNING_DESC = 'Warning message if metric are getting close to the threshold.';
const $415a350c7923b11b$var$EXCEEDED_DESC = 'Message to show to the user if metric has exceeded the threshold.';
const $415a350c7923b11b$var$CURRENT_VALUE_LABEL_DESC = 'Label to be shown next to the current value of the metric.';
const $415a350c7923b11b$var$CLEANUP_VALUE_LABEL_DESC = 'Label to be shown next to the cleanup value of the metric.';
var $415a350c7923b11b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    nameNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.name-non-final",
        "defaultMessage": "Projects"
    },
    descriptionNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.description-non-final",
        "defaultMessage": "Here are the projects from both company-managed and team-managed projects in your site, including ones we think can be archived because they don't have any issues. Archiving these projects could improve site performance and stability."
    },
    analysisNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.analysis-non-final",
        "defaultMessage": "Analysis"
    },
    activityLogNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.activity-log-non-final",
        "defaultMessage": "Activity log"
    },
    // Since we don't have a threshold, these messages below will be unused - keeping them purely to satisfy the Metric type
    // We should make this type more flexible in the future
    warningNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.warning-non-final",
        "defaultMessage": "The number of projects is nearing our recommended threshold."
    },
    exceededNonFinal: {
        "id": "admin-pages-performance.common.assets.project-cleanup.exceeded-non-final",
        "defaultMessage": "There are some project..."
    },
    currentValueLabel: {
        "id": "admin-pages-performance.common.assets.project-cleanup.current-value-label",
        "defaultMessage": "Projects in your site"
    },
    cleanupValueLabel: {
        "id": "admin-pages-performance.common.assets.project-cleanup.cleanup-value-label",
        "defaultMessage": "Recommended for cleanup"
    }
});

});


parcelRegister("dvpny", function(module, exports) {

$parcel$export(module.exports, "PROJECT_ROLE_ACTOR_KEY", () => $12bf835619f662e5$export$a570ca3f6cc5e280);
$parcel$export(module.exports, "PROJECT_ROLE_ACTOR", () => $12bf835619f662e5$export$fc3d2ee6c3fb3908);

var $k8SA5 = parcelRequire("k8SA5");
const $12bf835619f662e5$export$a570ca3f6cc5e280 = 'projectroleactor';
const $12bf835619f662e5$export$fc3d2ee6c3fb3908 = {
    key: $12bf835619f662e5$export$a570ca3f6cc5e280,
    visible: true,
    name: (0, $k8SA5.default).name,
    description: (0, $k8SA5.default).description,
    tabLabels: [
        (0, $k8SA5.default).analysis,
        (0, $k8SA5.default).activityLog
    ],
    warningMessage: (0, $k8SA5.default).warning,
    exceededMessage: (0, $k8SA5.default).exceeded,
    risks: [
        (0, $k8SA5.default).risk1
    ],
    mitigations: [
        (0, $k8SA5.default).mitigation1,
        (0, $k8SA5.default).mitigation2,
        (0, $k8SA5.default).mitigation3
    ],
    currentValueLabel: (0, $k8SA5.default).currentValueLabel,
    currentValueAriaLabel: (0, $k8SA5.default).currentValueAriaLabel,
    thresholdValueLabel: (0, $k8SA5.default).thresholdValueLabel,
    thresholdValueAriaLabel: (0, $k8SA5.default).thresholdValueAriaLabel,
    recommendationUrl: 'https://support.atlassian.com/jira-cloud-administration/docs/optimize-your-number-of-project-role-memberships/',
    recommendationUrlText: (0, $k8SA5.default).recommendationUrlText,
    graphHeader: (0, $k8SA5.default).graphHeader
};

});
parcelRegister("k8SA5", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfa528fdefb2c376$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
// The following are the description for the translators for the different text that we need translating.
// Unfortunately, this needs to copied to individual files because the i18n text extraction tool needs
// to be able to resolve variables statically.
const $dfa528fdefb2c376$var$NAME_DESC = 'Name of the site optimizer metric that will be used as the title on the page and menu item.';
const $dfa528fdefb2c376$var$DESCRIPTON_DESC = 'Description of the site optimizer metric.';
const $dfa528fdefb2c376$var$WARNING_DESC = 'Warning message if metric are getting close to the threshold.';
const $dfa528fdefb2c376$var$EXCEEDED_DESC = 'Message to show to the user if metric has exceeded the threshold.';
const $dfa528fdefb2c376$var$RISK_DESC = 'One of the risks when this metric exceeded the threshold.';
const $dfa528fdefb2c376$var$MITIGATION_DESC = 'One of the mitigation options when this metric exceeded the threshold.';
const $dfa528fdefb2c376$var$CURRENT_VALUE_LABEL_DESC = 'Label to be shown next to the current value of the metric.';
const $dfa528fdefb2c376$var$THRESHOLD_VALUE_LABEL_DESC = 'Label to be shown next to the threshold value of the metric.';
const $dfa528fdefb2c376$var$RECOMMENDATION_URL_TEXT_DESC = 'Text to be shown on the hypertext link to additional documentation.';
const $dfa528fdefb2c376$var$GRAPH_HEADER_DESC = 'Text to be shown on the header of the metric graph.';
var $dfa528fdefb2c376$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    name: {
        "id": "admin-pages-performance.common.assets.project-role-actor.name",
        "defaultMessage": "Project role permissions"
    },
    description: {
        "id": "admin-pages-performance.common.assets.project-role-actor.description",
        "defaultMessage": "Here's a quick snapshot of the total number of project role permissions across your site."
    },
    analysis: {
        "id": "admin-pages-performance.common.assets.project-role-actor.analysis",
        "defaultMessage": "Analysis"
    },
    activityLog: {
        "id": "admin-pages-performance.common.assets.project-role-actor.activity-log",
        "defaultMessage": "Activity log"
    },
    warning: {
        "id": "admin-pages-performance.common.assets.project-role-actor.warning",
        "defaultMessage": "Your number of project role memberships is nearing the recommended threshold."
    },
    exceeded: {
        "id": "admin-pages-performance.common.assets.project-role-actor.exceeded",
        "defaultMessage": "Your number of project role memberships is over the recommended threshold."
    },
    risk1: {
        "id": "admin-pages-performance.common.assets.project-role-actor.risk-1",
        "defaultMessage": "When the number of project role memberships (users or groups) increases, viewing, searching, and creating issues becomes slower."
    },
    mitigation1: {
        "id": "admin-pages-performance.common.assets.project-role-actor.mitigation-1",
        "defaultMessage": "Remove users who no longer need access to your site rather than only suspending them. Suspending users removes their permission but not their project role membership."
    },
    mitigation2: {
        "id": "admin-pages-performance.common.assets.project-role-actor.mitigation-2",
        "defaultMessage": "Give memberships to groups of users instead of individual users. Granting membership to a group of 50 users count as 1 membership whereas granting memberships to 50 single users counts as 50 memberships."
    },
    mitigation3: {
        "id": "admin-pages-performance.common.assets.project-role-actor.mitigation-3",
        "defaultMessage": "Use the default project role members in your permission scheme."
    },
    currentValueLabel: {
        "id": "admin-pages-performance.common.assets.project-role-actor.current-value-label",
        "defaultMessage": "Current project role permissions in your site"
    },
    thresholdValueLabel: {
        "id": "admin-pages-performance.common.assets.project-role-actor.threshold-value-label",
        "defaultMessage": "Recommended maximum number of permissions"
    },
    currentValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.project-role-actor.current-value-aria-label",
        "defaultMessage": "{number} current project role permissions in your site"
    },
    thresholdValueAriaLabel: {
        "id": "admin-pages-performance.common.assets.project-role-actor.threshold-value-aria-label",
        "defaultMessage": "{number} recommended maximum number of permissions"
    },
    recommendationUrlText: {
        "id": "admin-pages-performance.common.assets.project-role-actor.recommendation-url-text",
        "defaultMessage": "Learn more about optimizing your project role memberships."
    },
    graphHeader: {
        "id": "admin-pages-performance.common.assets.project-role-actor.graph-header",
        "defaultMessage": "Project role permissions over time"
    }
});

});


parcelRegister("4zgfm", function(module, exports) {

$parcel$export(module.exports, "METRICS", () => $62ab28a8db68210b$export$3f0e99ae6e0ec541);
$parcel$export(module.exports, "RUN_ANALYSIS", () => $62ab28a8db68210b$export$769b1a9477352cf9);
$parcel$export(module.exports, "DELETE_RECOMMENDATIONS", () => $62ab28a8db68210b$export$e7e31b14c32e055a);
$parcel$export(module.exports, "DELETE_RECOMMENDATIONS_DROPDOWN", () => $62ab28a8db68210b$export$d96fe00ff2b38bae);
$parcel$export(module.exports, "DELETE_RECOMMENDATIONS_CONFIRM", () => $62ab28a8db68210b$export$3d4bb5f187c6844e);
$parcel$export(module.exports, "DELETE_RECOMMENDATIONS_CANCEL", () => $62ab28a8db68210b$export$5c1079e323f5d5bd);
$parcel$export(module.exports, "TAB_CLICKED", () => $62ab28a8db68210b$export$d358fc12daa9f606);
$parcel$export(module.exports, "RECOMMENDATIONS_LOADED", () => $62ab28a8db68210b$export$60cc0c61c99a5b81);
$parcel$export(module.exports, "METRIC_CARD_CLICKED", () => $62ab28a8db68210b$export$71794f4d197278dc);
$parcel$export(module.exports, "PROJECT_ROLE_ACTOR_FILTER_BY_PROJECT", () => $62ab28a8db68210b$export$9e34afbf86922b4a);
$parcel$export(module.exports, "projectRoleActorAttributes", () => $62ab28a8db68210b$export$d6761557c91eea50);
$parcel$export(module.exports, "ARCHIVE_ISSUES_CONFIRM", () => $62ab28a8db68210b$export$4e4b9391f7936ba2);
$parcel$export(module.exports, "RESTORE_ARCHIVE_ISSUES", () => $62ab28a8db68210b$export$70525d18051240f4);
$parcel$export(module.exports, "RESTORE_ARCHIVE_ISSUES_CANCEL", () => $62ab28a8db68210b$export$4951e0e034b50b9c);
$parcel$export(module.exports, "RESTORE_ARCHIVE_ISSUES_TRY_AGAIN", () => $62ab28a8db68210b$export$108288df7758f60c);
$parcel$export(module.exports, "VIEW_ISSUES", () => $62ab28a8db68210b$export$972d5a8da0d9f4c3);
$parcel$export(module.exports, "STOP_ISSUE_ARCHIVAL", () => $62ab28a8db68210b$export$b920363d50bcf753);
$parcel$export(module.exports, "ISSUE_UNARCHIVAL_COMPLETED", () => $62ab28a8db68210b$export$a84a5210fbad774);
$parcel$export(module.exports, "JQL_SEARCH", () => $62ab28a8db68210b$export$5c2df36fdd8476f7);
$parcel$export(module.exports, "DEFAULT_QUERY_SELECTED", () => $62ab28a8db68210b$export$77f23f1b921d5321);
$parcel$export(module.exports, "issueAnalyticsAttributes", () => $62ab28a8db68210b$export$c62a52f3f7d80ec3);
$parcel$export(module.exports, "CUSTOM_FIELD_MOVE_TO_TRASH", () => $62ab28a8db68210b$export$8daffc99348bf555);
$parcel$export(module.exports, "CUSTOM_FIELD_MOVE_TO_TRASH_CONFIRM", () => $62ab28a8db68210b$export$20f13a04bc3e5d74);
$parcel$export(module.exports, "CUSTOM_FIELD_MOVE_TO_TRASH_CANCEL", () => $62ab28a8db68210b$export$ed285e0e924b673c);
$parcel$export(module.exports, "CUSTOM_FIELD_MOVE_TO_SUCCEEDED", () => $62ab28a8db68210b$export$26f5d7eae10db511);
$parcel$export(module.exports, "customFieldAttributes", () => $62ab28a8db68210b$export$33989f74b6ba0674);
$parcel$export(module.exports, "METRICS_SPOTLIGHT_STARTED", () => $62ab28a8db68210b$export$d39b24a650c6c79d);
$parcel$export(module.exports, "METRICS_SPOTLIGHT_DISMISSED", () => $62ab28a8db68210b$export$eca4028936acf763);
$parcel$export(module.exports, "METRICS_SPOTLIGHT_COMPLETED", () => $62ab28a8db68210b$export$9ba0a5caedb0ff37);
$parcel$export(module.exports, "RESTORE_ACTIVITY_LOG", () => $62ab28a8db68210b$export$7b6bf63452d40db8);
$parcel$export(module.exports, "DOWNLOAD_CSV", () => $62ab28a8db68210b$export$efdb93c7210090d1);

var $7sw6U = parcelRequire("7sw6U");
var $29cWe = parcelRequire("29cWe");
var $8WG7k = parcelRequire("8WG7k");
var $dvpny = parcelRequire("dvpny");
const $62ab28a8db68210b$export$3f0e99ae6e0ec541 = [
    // Inclusion of issues in metrics is dependent on improving mitigation strategies for issues.
    // Inclusion of issue links in metrics is dependent on improving mitigation strategies for issue links.
    // ISSUE_LINKS,
    // CUSTOM_FIELD_OPTIONS,
    (0, $7sw6U.CUSTOM_FIELDS),
    (0, $29cWe.ISSUE),
    (0, $dvpny.PROJECT_ROLE_ACTOR),
    // Inclusion of file attachments in metrics is dependent on improving mitigation strategies for file attachments.
    // FILE_ATTACHMENTS,
    (0, $8WG7k.PROJECT_CLEANUP)
];
const $62ab28a8db68210b$export$769b1a9477352cf9 = 'runAnalysis';
const $62ab28a8db68210b$export$e7e31b14c32e055a = 'deleteRecommendations';
const $62ab28a8db68210b$export$d96fe00ff2b38bae = 'deleteRecommendationsDropdown';
const $62ab28a8db68210b$export$3d4bb5f187c6844e = 'deleteRecommendationsConfirm';
const $62ab28a8db68210b$export$5c1079e323f5d5bd = 'deleteRecommendationsCancel';
const $62ab28a8db68210b$export$d358fc12daa9f606 = 'psiTab';
const $62ab28a8db68210b$export$60cc0c61c99a5b81 = 'recommendations loaded';
const $62ab28a8db68210b$export$71794f4d197278dc = 'mitigationMetricCard';
const $62ab28a8db68210b$export$9e34afbf86922b4a = 'projectRoleActorFilterByProject';
const $62ab28a8db68210b$export$d6761557c91eea50 = {
    metric: (0, $dvpny.PROJECT_ROLE_ACTOR_KEY)
};
const $62ab28a8db68210b$export$4e4b9391f7936ba2 = 'archiveIssuesConfirm';
const $62ab28a8db68210b$export$70525d18051240f4 = 'restoreIssueArchival';
const $62ab28a8db68210b$export$4951e0e034b50b9c = 'restoreIssueCancel';
const $62ab28a8db68210b$export$108288df7758f60c = 'restoreIssueTryAgain';
const $62ab28a8db68210b$export$972d5a8da0d9f4c3 = 'viewIssues';
const $62ab28a8db68210b$export$b920363d50bcf753 = 'stopIssueArchival';
const $62ab28a8db68210b$export$a84a5210fbad774 = 'restoreIssueArchival completed';
const $62ab28a8db68210b$export$5c2df36fdd8476f7 = 'jqlSearch';
const $62ab28a8db68210b$export$77f23f1b921d5321 = 'defaultQuerySelected';
const $62ab28a8db68210b$export$c62a52f3f7d80ec3 = {
    metric: (0, $29cWe.ISSUE_KEY)
};
const $62ab28a8db68210b$export$8daffc99348bf555 = 'customFieldMoveToTrash';
const $62ab28a8db68210b$export$20f13a04bc3e5d74 = 'customFieldMoveToTrashConfirm';
const $62ab28a8db68210b$export$ed285e0e924b673c = 'customFieldMoveToTrashCancel';
const $62ab28a8db68210b$export$26f5d7eae10db511 = 'customFieldMoveToTrash succeeded';
const $62ab28a8db68210b$export$33989f74b6ba0674 = {
    metric: (0, $7sw6U.CUSTOM_FIELDS).key
};
const $62ab28a8db68210b$export$d39b24a650c6c79d = 'metricPerformanceSpotlight started';
const $62ab28a8db68210b$export$eca4028936acf763 = 'metricPerformanceSpotlightDismissed';
const $62ab28a8db68210b$export$9ba0a5caedb0ff37 = 'metricPerformanceSpotlight completed';
const $62ab28a8db68210b$export$7b6bf63452d40db8 = 'restoreActivityLog';
const $62ab28a8db68210b$export$efdb93c7210090d1 = 'downloadActivityLogCsv';

});


parcelRegister("g0nB0", function(module, exports) {

$parcel$export(module.exports, "default", () => $e86ca693ecf70061$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e86ca693ecf70061$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.title",
        "defaultMessage": "Site optimizer"
    },
    overview: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.overview",
        "defaultMessage": "Overview"
    },
    allReports: {
        "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.all-reports",
        "defaultMessage": "All reports"
    }
});

});


parcelRegister("gX1Xl", function(module, exports) {

$parcel$export(module.exports, "hasSeenSiteOptimiserSpotlight", () => $4ae32bdb5f090bc9$export$3ed4e8541d8ba40);

var $9PoYP = parcelRequire("9PoYP");
const $4ae32bdb5f090bc9$var$PROPERTY_KEY = 'jira.user.settings.system.site-optimizer-spotlight';
const $4ae32bdb5f090bc9$export$3ed4e8541d8ba40 = async (accountId)=>{
    const response = await (0, $9PoYP.getUserProperty)({
        accountId: accountId,
        propertyKey: $4ae32bdb5f090bc9$var$PROPERTY_KEY,
        defaultValue: false
    });
    // If they have not seen the spotlight, return true and mark as shown
    if (!response.value) {
        await (0, $9PoYP.setUserProperty)({
            accountId: accountId,
            propertyKey: $4ae32bdb5f090bc9$var$PROPERTY_KEY,
            propertyValue: true
        });
        return false;
    }
    return true;
};

});
parcelRegister("9PoYP", function(module, exports) {

$parcel$export(module.exports, "getUserProperty", () => $955a15fece231eda$export$b3126db2ef6e34ed);
$parcel$export(module.exports, "setUserProperty", () => $955a15fece231eda$export$ba821ce5e177c7ef);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $955a15fece231eda$var$getUserUrl = (accountId, propertyKey)=>`/rest/api/3/user/properties/${propertyKey}?accountId=${accountId}`;
const $955a15fece231eda$export$b3126db2ef6e34ed = async ({ accountId: accountId, propertyKey: propertyKey, defaultValue: defaultValue })=>{
    const url = $955a15fece231eda$var$getUserUrl(accountId, propertyKey);
    try {
        const response = await fetch(url, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        // The API deliberately returns 404 if user property is not found - we will return default value
        if (response.status === 404) return {
            key: propertyKey,
            value: defaultValue
        };
        if (response.ok) return await response.json();
        throw new Error(`Fetching ${propertyKey} user property failed.`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'getUserProperty',
                packageName: 'jiraAdminPagesPerformance',
                teamName: 'cherenkov'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            key: propertyKey,
            value: defaultValue
        };
    }
};
const $955a15fece231eda$export$ba821ce5e177c7ef = async ({ accountId: accountId, propertyKey: propertyKey, propertyValue: propertyValue })=>{
    const url = $955a15fece231eda$var$getUserUrl(accountId, propertyKey);
    try {
        await (0, $lRmyA.performPutRequest)(url, {
            body: JSON.stringify(propertyValue)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'setUserProperty',
                packageName: 'jiraAdminPagesPerformance',
                teamName: 'cherenkov'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});



parcelRegister("jp7a0", function(module, exports) {

$parcel$export(module.exports, "isViewAuditingSelected", () => $03f18fc8092e748a$export$6da8ca04904513f9);

var $bS2FN = parcelRequire("bS2FN");
const $03f18fc8092e748a$var$VIEW_AUDITING_PATH_REGEXP = /\/auditing\/(\w+)/i;
const $03f18fc8092e748a$export$6da8ca04904513f9 = (currentLocation, itemLocation)=>(0, $bS2FN.matchUrlExact)()(currentLocation, itemLocation) || $03f18fc8092e748a$var$VIEW_AUDITING_PATH_REGEXP.test(currentLocation.pathname);

});


parcelRegister("3I29L", function(module, exports) {

$parcel$export(module.exports, "UserInterfaceSection", () => $d9f4a282c7cbc7cf$export$c4128359313d3f58);

var $eUqFw = parcelRequire("eUqFw");

var $7eyVf = parcelRequire("7eyVf");
var $gLn5u = parcelRequire("gLn5u");

var $exb0h = parcelRequire("exb0h");

var $5JgJ2 = parcelRequire("5JgJ2");

var $iaHqR = parcelRequire("iaHqR");
var $bS2FN = parcelRequire("bS2FN");
var $1UelU = parcelRequire("1UelU");

var $c7H0g = parcelRequire("c7H0g");

var $cvu76 = parcelRequire("cvu76");

var $1AipL = parcelRequire("1AipL");
const $d9f4a282c7cbc7cf$export$c4128359313d3f58 = ()=>{
    const isJiraAdmin = (0, $c7H0g.useIsAdmin)();
    const { data: features } = (0, $cvu76.useFeatures)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const navigationPath = (0, $eUqFw.useMemo)(()=>(0, $iaHqR.getSystemNavigationPaths)(), []);
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        title: formatMessage((0, $1AipL.default).userInterface)
    }, features.hasUserDefaults && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'user-defaults'
        },
        href: navigationPath.userInterfacesUserDefaults,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $1AipL.default).userDefaults)), features.hasEditDefaultDashboard && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'edit-default-dashboard'
        },
        href: navigationPath.userInterfacesEditDefaultDashboard,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $1AipL.default).systemDashboard)), features.hasLookAndFeel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'look-and-feel'
        },
        href: navigationPath.userInterfacesLookAndFeel,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $1AipL.default).lookAndFeel)), features.hasPasAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'pas-admin-link-jira'
        },
        href: navigationPath.userInterfacesPasAdmin,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $1AipL.default).pasAdmin)), isJiraAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'announcement-banner'
        },
        href: navigationPath.userInterfacesSiteAdmin,
        selectedOn: [
            (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_SYSTEM_UI_ANNOUNCEMENT_BANNER
        ]
    }, formatMessage((0, $1AipL.default).announcementBanner)));
};

});
parcelRegister("1AipL", function(module, exports) {

$parcel$export(module.exports, "default", () => $34e717096f7a10af$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $34e717096f7a10af$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    userInterface: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.user-interface",
        "defaultMessage": "User Interface"
    },
    userDefaults: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.user-defaults",
        "defaultMessage": "Default user preferences"
    },
    systemDashboard: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.system-dashboard",
        "defaultMessage": "Default dashboard"
    },
    lookAndFeel: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.look-and-feel",
        "defaultMessage": "Look and feel"
    },
    pasAdmin: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.pas-admin",
        "defaultMessage": "Public Announcement Service"
    },
    announcementBanner: {
        "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.announcement-banner",
        "defaultMessage": "Announcement banner"
    }
});

});


parcelRegister("7SUOK", function(module, exports) {

$parcel$export(module.exports, "isGeneralConfigurationSelected", () => $15dfca461865397f$export$ba31cfa97c56eefd);

var $bS2FN = parcelRequire("bS2FN");
const $15dfca461865397f$var$APPLICATION_PROPERTIES_PATH_REGEXP = /\/admin\/(\w+)ApplicationProperties/i;
const $15dfca461865397f$export$ba31cfa97c56eefd = (currentLocation, itemLocation)=>(0, $bS2FN.matchUrlExact)()(currentLocation, itemLocation) || $15dfca461865397f$var$APPLICATION_PROPERTIES_PATH_REGEXP.test(currentLocation.pathname);

});



parcelRegister("55Ivd", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('ade3E');
        const value = parcelRequire('5Qoxh');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("ade3E").then(()=>parcelRequire('5Qoxh'));
}

});

parcelRegister("fI7ei", function(module, exports) {

$parcel$export(module.exports, "metricsOverviewPageResource", () => $c3c647546ebd6586$export$ac0b4ef4ec4987ae);

var $buJlM = parcelRequire("buJlM");

var $38Uom = parcelRequire("38Uom");
const $c3c647546ebd6586$export$ac0b4ef4ec4987ae = (0, $buJlM.createRelayResource)({
    type: 'ADMIN_PAGES_PERFORMANCE_OVERVIEW',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $38Uom.default),
            variables: {
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("38Uom", function(module, exports) {

$parcel$export(module.exports, "default", () => $e90d0e4e68a4767b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<67453a3e8d1ad82b31633d3df4853176>>
 * @relayHash d7a09c1a09b57c4675b8c2439ee0bd6e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d2fe73ca0b47245563666951f775b77a3a261da2aeb574c289b15d04a8a13008
const $e90d0e4e68a4767b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "main_adminPagesPerformance_Overview_Query",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraResourceUsageMetricConnection",
                                    "kind": "LinkedField",
                                    "name": "resourceUsageMetrics",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "main_adminPagesPerformance_OverviewPage"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.resourceUsageMetrics"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "main_adminPagesPerformance_Overview_Query",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraResourceUsageMetricConnection",
                            "kind": "LinkedField",
                            "name": "resourceUsageMetrics",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraResourceUsageMetric",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "currentValue"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "warningValue"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "thresholdValue"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cleanupValue"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d2fe73ca0b47245563666951f775b77a3a261da2aeb574c289b15d04a8a13008",
            "metadata": {},
            "name": "main_adminPagesPerformance_Overview_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e90d0e4e68a4767b$var$node.hash = "65285ab59e67a0f62edb54671f986ddd";
var $e90d0e4e68a4767b$export$2e2bcd8739ae039 = $e90d0e4e68a4767b$var$node;

});


parcelRegister("aI3ha", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('gq3Qp')
        ]);
        const value = parcelRequire('dFsKj');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("gq3Qp")
    ]).then(()=>parcelRequire('dFsKj'));
}

});

parcelRegister("18rXi", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('lJQsr')
        ]);
        const value = parcelRequire('m5Wpm');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("lJQsr")
    ]).then(()=>parcelRequire('m5Wpm'));
}

});

parcelRegister("hesaP", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('f6Pe2')
        ]);
        const value = parcelRequire('9N1Sg');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("f6Pe2")
    ]).then(()=>parcelRequire('9N1Sg'));
}

});

parcelRegister("6CDcO", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('ddZe9')
        ]);
        const value = parcelRequire('ecfTq');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("ddZe9")
    ]).then(()=>parcelRequire('ecfTq'));
}

});

parcelRegister("dAw2T", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('azCgO')
        ]);
        const value = parcelRequire('g953z');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("azCgO")
    ]).then(()=>parcelRequire('g953z'));
}

});

parcelRegister("jSVJ3", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('jc7P6');
        const value = parcelRequire('7s4sD');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("jc7P6").then(()=>parcelRequire('7s4sD'));
}

});

parcelRegister("bWR2E", function(module, exports) {

$parcel$export(module.exports, "editPermissionSchemePageResource", () => $e9611696d488b3c2$export$2b6bb2f543863b53);

var $buJlM = parcelRequire("buJlM");

var $j2ZJ1 = parcelRequire("j2ZJ1");
const $e9611696d488b3c2$var$RESOURCE_TYPE_EDIT_PERMISSION_SCHEME_PAGE = 'EDIT_PERMISSION_SCHEME_PAGE';
const $e9611696d488b3c2$export$2b6bb2f543863b53 = (0, $buJlM.createRelayResource)({
    type: $e9611696d488b3c2$var$RESOURCE_TYPE_EDIT_PERMISSION_SCHEME_PAGE,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $j2ZJ1.default),
            variables: {
                // To Do: use ari-typescript library once it is approved
                // https://hello.atlassian.net/wiki/spaces/TGR/pages/1374189554/Dependency+review+atlassian+ari
                schemeId: `ari:cloud:jira:${tenantContext.cloudId}:permission-scheme/activation/${tenantContext.activationId}/${String(match.params.schemeId)}`,
                first: 50
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("j2ZJ1", function(module, exports) {

$parcel$export(module.exports, "default", () => $271566d438978665$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3e6d2609b22da674852d0d8a556caee0>>
 * @relayHash a8302edc7839549073bdffce737596f9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8c97cc5e281ea579c44e87ac7f80e5f399b27b3ac304b7267d4210b282a7a4b1
const $271566d438978665$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "schemeId"
    }, v2 = {
        "kind": "Variable",
        "name": "schemeId",
        "variableName": "schemeId"
    }, v3 = [
        v2 /*: any*/ 
    ], v4 = {
        "kind": "ScalarField",
        "name": "isEditable"
    }, v5 = {
        "concreteType": "JiraPermissionSchemeConfiguration",
        "kind": "LinkedField",
        "name": "configuration",
        "plural": false,
        "selections": [
            v4 /*: any*/ 
        ]
    }, v6 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v2 /*: any*/ 
    ], v7 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "key"
    }, v11 = {
        "kind": "ScalarField",
        "name": "description"
    }, v12 = {
        "kind": "ScalarField",
        "name": "text"
    }, v13 = {
        "kind": "ScalarField",
        "name": "id"
    }, v14 = [
        v8 /*: any*/ ,
        v9 /*: any*/ ,
        v13 /*: any*/ 
    ], v15 = [
        v9 /*: any*/ ,
        v13 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainJiraEditPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v3 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "viewPermissionScheme",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "PermissionCategories"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "header_editPermissionScheme"
                                            },
                                            v5 /*: any*/ 
                                        ],
                                        "type": "JiraPermissionSchemeView"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.viewPermissionScheme"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v6 /*: any*/ ,
                                "concreteType": "JiraProjectConnection",
                                "kind": "LinkedField",
                                "name": "getProjectsByPermissionScheme",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "JiraProjectEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "JiraProject",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v7 /*: any*/ ,
                                                                "action": "LOG",
                                                                "path": "jira.getProjectsByPermissionScheme.edges.node.projectId"
                                                            }
                                                        ]
                                                    },
                                                    "action": "LOG",
                                                    "path": "jira.getProjectsByPermissionScheme.edges.node"
                                                }
                                            ]
                                        },
                                        "action": "LOG",
                                        "path": "jira.getProjectsByPermissionScheme.edges"
                                    }
                                ]
                            },
                            "action": "LOG",
                            "path": "jira.getProjectsByPermissionScheme"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainJiraEditPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "viewPermissionScheme",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "JiraPermissionSchemeGrantGroup",
                                            "kind": "LinkedField",
                                            "name": "grantGroups",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProjectPermissionCategory",
                                                    "kind": "LinkedField",
                                                    "name": "category",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraPermissionGrantHolder",
                                                    "kind": "LinkedField",
                                                    "name": "grantHolders",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraProjectPermission",
                                                            "kind": "LinkedField",
                                                            "name": "permission",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                v11 /*: any*/ ,
                                                                v10 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraPermissionConfiguration",
                                                            "kind": "LinkedField",
                                                            "name": "configuration",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "tag"
                                                                },
                                                                {
                                                                    "concreteType": "JiraPermissionMessageExtension",
                                                                    "kind": "LinkedField",
                                                                    "name": "message",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "type"
                                                                        },
                                                                        v12 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraPermissionDocumentationExtension",
                                                                    "kind": "LinkedField",
                                                                    "name": "documentation",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v12 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ]
                                                                },
                                                                v4 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraPermissionGrants",
                                                            "kind": "LinkedField",
                                                            "name": "grants",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraGrantTypeKey",
                                                                    "kind": "LinkedField",
                                                                    "name": "grantType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v10 /*: any*/ ,
                                                                        v9 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraPermissionGrantValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "grantValues",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "value",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v9 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraDefaultGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "user",
                                                                                            "plural": false,
                                                                                            "selections": v14 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraUserGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraGroup",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "group",
                                                                                            "plural": false,
                                                                                            "selections": v15 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraGroupGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraRole",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "role",
                                                                                            "plural": false,
                                                                                            "selections": v15 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraProjectRoleGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "field",
                                                                                            "plural": false,
                                                                                            "selections": v14 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraIssueFieldGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v13 /*: any*/ 
                                                                                    ],
                                                                                    "type": "Node",
                                                                                    "abstractKey": "__isNode"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v13 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "totalCount"
                                                                },
                                                                v8 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__id"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraPermissionScheme",
                                            "kind": "LinkedField",
                                            "name": "scheme",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                v13 /*: any*/ 
                                            ]
                                        },
                                        v5 /*: any*/ 
                                    ],
                                    "type": "JiraPermissionSchemeView"
                                }
                            ]
                        },
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "getProjectsByPermissionScheme",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v13 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8c97cc5e281ea579c44e87ac7f80e5f399b27b3ac304b7267d4210b282a7a4b1",
            "metadata": {},
            "name": "mainJiraEditPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$271566d438978665$var$node.hash = "9e1e7326d79aae057f4943753d3cd309";
var $271566d438978665$export$2e2bcd8739ae039 = $271566d438978665$var$node;

});


parcelRegister("i4OkI", function(module, exports) {

$parcel$export(module.exports, "permissionSchemePageResource", () => $16a6a6fc1d9bc0eb$export$58d9013f694fc9d0);

var $buJlM = parcelRequire("buJlM");

var $fxGo9 = parcelRequire("fxGo9");
const $16a6a6fc1d9bc0eb$var$RESOURCE_TYPE_PERMISSION_SCHEME_PAGE = 'PERMISSION_SCHEME_PAGE';
const $16a6a6fc1d9bc0eb$export$58d9013f694fc9d0 = (0, $buJlM.createRelayResource)({
    type: $16a6a6fc1d9bc0eb$var$RESOURCE_TYPE_PERMISSION_SCHEME_PAGE,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $fxGo9.default),
            variables: {
                // To Do: use ari-typescript library once it is approved
                // https://hello.atlassian.net/wiki/spaces/TGR/pages/1374189554/Dependency+review+atlassian+ari
                schemeId: `ari:cloud:jira:${tenantContext.cloudId}:permission-scheme/activation/${tenantContext.activationId}/${String(match.params.schemeId)}`
            },
            options: {
                fetchPolicy: 'network-only'
            }
        })
});

});
parcelRegister("fxGo9", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b1d4615581b3ab8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bf59478679f84bf44b49fd41a2544ee4>>
 * @relayHash 0250f6408e8d8064d7cc97a77e2f5386
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5642572e212db64091380e916543cde0402cdfaa01db716befcdd494efd5feb
const $0b1d4615581b3ab8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "schemeId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "schemeId",
            "variableName": "schemeId"
        }
    ], v2 = {
        "concreteType": "JiraPermissionSchemeConfiguration",
        "kind": "LinkedField",
        "name": "configuration",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            }
        ]
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "kind": "ScalarField",
        "name": "description"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "key"
    }, v8 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        v6 /*: any*/ 
    ], v9 = [
        v4 /*: any*/ ,
        v6 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v1 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "viewPermissionScheme",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "header_permissionScheme"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "PermissionsTable"
                                            },
                                            v2 /*: any*/ 
                                        ],
                                        "type": "JiraPermissionSchemeView"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.viewPermissionScheme"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "viewPermissionScheme",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "JiraPermissionScheme",
                                            "kind": "LinkedField",
                                            "name": "scheme",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraPermissionSchemeGrantGroup",
                                            "kind": "LinkedField",
                                            "name": "grantGroups",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProjectPermissionCategory",
                                                    "kind": "LinkedField",
                                                    "name": "category",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraPermissionGrantHolder",
                                                    "kind": "LinkedField",
                                                    "name": "grantHolders",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraProjectPermission",
                                                            "kind": "LinkedField",
                                                            "name": "permission",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                v4 /*: any*/ ,
                                                                v5 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraPermissionGrants",
                                                            "kind": "LinkedField",
                                                            "name": "grants",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraGrantTypeKey",
                                                                    "kind": "LinkedField",
                                                                    "name": "grantType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        v4 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraPermissionGrantValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "grantValues",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "value",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v3 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        v4 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraDefaultGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "user",
                                                                                            "plural": false,
                                                                                            "selections": v8 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraUserGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraGroup",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "group",
                                                                                            "plural": false,
                                                                                            "selections": v9 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraGroupGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "field",
                                                                                            "plural": false,
                                                                                            "selections": v8 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraIssueFieldGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraRole",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "role",
                                                                                            "plural": false,
                                                                                            "selections": v9 /*: any*/ 
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraProjectRoleGrantTypeValue"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v6 /*: any*/ 
                                                                                    ],
                                                                                    "type": "Node",
                                                                                    "abstractKey": "__isNode"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v6 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v2 /*: any*/ 
                                    ],
                                    "type": "JiraPermissionSchemeView"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b5642572e212db64091380e916543cde0402cdfaa01db716befcdd494efd5feb",
            "metadata": {},
            "name": "mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0b1d4615581b3ab8$var$node.hash = "41dd09a71a35c8ed416631b02fa73316";
var $0b1d4615581b3ab8$export$2e2bcd8739ae039 = $0b1d4615581b3ab8$var$node;

});


parcelRegister("7NwT6", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('diQgD')
        ]);
        const value = parcelRequire('5ZojE');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("diQgD")
    ]).then(()=>parcelRequire('5ZojE'));
}

});

parcelRegister("fiAjY", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('ii2fE')
        ]);
        const value = parcelRequire('3u8K8');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("ii2fE")
    ]).then(()=>parcelRequire('3u8K8'));
}

});

parcelRegister("415HX", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritySchemesRoute", () => $80c6d5cab0238cba$export$185af30f53271c10);
$parcel$export(module.exports, "globalSettingsIssuesPrioritiesRoute", () => $80c6d5cab0238cba$export$518516cdf6b7cd83);

var $exb0h = parcelRequire("exb0h");
const $80c6d5cab0238cba$export$185af30f53271c10 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_ISSUES_PRIORITY_SCHEMES,
    path: '/jira/settings/issues/priority-schemes'
};
const $80c6d5cab0238cba$export$518516cdf6b7cd83 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_ISSUES_PRIORITIES,
    path: '/jira/settings/issues/priorities'
};

});

parcelRegister("8LAAS", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('7KECY')
        ]);
        const value = parcelRequire('2aiJy');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("7KECY")
    ]).then(()=>parcelRequire('2aiJy'));
}

});

parcelRegister("wDgHY", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('fJM6W')
        ]);
        const value = parcelRequire('5w2OB');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("fJM6W")
    ]).then(()=>parcelRequire('5w2OB'));
}

});

parcelRegister("kyDk6", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('iUIHQ')
        ]);
        const value = parcelRequire('5x7Pe');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("iUIHQ")
    ]).then(()=>parcelRequire('5x7Pe'));
}

});

parcelRegister("7Eg2g", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('jfQue')
        ]);
        const value = parcelRequire('ck4Nt');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("jfQue")
    ]).then(()=>parcelRequire('ck4Nt'));
}

});

parcelRegister("7g4KV", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('7hEhi')
        ]);
        const value = parcelRequire('lBHs5');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("7hEhi")
    ]).then(()=>parcelRequire('lBHs5'));
}

});

parcelRegister("9P8cz", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('6hJju')
        ]);
        const value = parcelRequire('hqQxd');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("6hJju")
    ]).then(()=>parcelRequire('hqQxd'));
}

});

parcelRegister("kcaE4", function(module, exports) {

$parcel$export(module.exports, "systemConfigurationRoute", () => $67e4c12bd9924041$export$6823cb5626e61bc7);
$parcel$export(module.exports, "routeNamesSystemConfigurationRedirectRoute", () => $67e4c12bd9924041$export$23418d655258dbfa);

var $exb0h = parcelRequire("exb0h");
const $67e4c12bd9924041$export$6823cb5626e61bc7 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).SYSTEM_CONFIGURATION,
    path: '/jira/settings/system/general-configuration',
    exact: true
};
const $67e4c12bd9924041$export$23418d655258dbfa = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: `${(0, $exb0h.ROUTE_NAMES).SYSTEM_CONFIGURATION}-redirect`,
    path: '/secure/admin/ViewApplicationProperties.jspa',
    exact: true
};

});

parcelRegister("7WDU5", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('e8Khf')
        ]);
        const value = parcelRequire('chrxL');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("e8Khf")
    ]).then(()=>parcelRequire('chrxL'));
}

});

parcelRegister("hWz10", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('adoZ8')
        ]);
        const value = parcelRequire('4t3gm');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("adoZ8")
    ]).then(()=>parcelRequire('4t3gm'));
}

});

parcelRegister("cV7Hm", function(module, exports) {

$parcel$export(module.exports, "default", () => $4386b43da954e2d2$export$2e2bcd8739ae039);

var $53ciZ = parcelRequire("53ciZ");

var $3HCkE = parcelRequire("3HCkE");

var $jnVHr = parcelRequire("jnVHr");

const $4386b43da954e2d2$var$workFlowsResource = (0, $3HCkE.createResource)({
    type: (0, $810245ed2edcd973$export$b11854972ecaecc7),
    getKey: ({ query: query })=>`${0, $810245ed2edcd973$export$6602c5404301813f}-${(0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(query)}`,
    maxAge: 0,
    getData: async ({ query: query })=>(0, $jnVHr.getListWorkFlows)((0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(query))
});
var $4386b43da954e2d2$export$2e2bcd8739ae039 = $4386b43da954e2d2$var$workFlowsResource;

});
parcelRegister("jnVHr", function(module, exports) {

$parcel$export(module.exports, "getListWorkFlows", () => $419e001999630a80$export$952f5d693c3c0d4e);

var $53ciZ = parcelRequire("53ciZ");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $cagHD = parcelRequire("cagHD");

var $gU71n = parcelRequire("gU71n");
const $419e001999630a80$export$952f5d693c3c0d4e = async (qs)=>{
    const filter = (0, $gU71n.fromUrlTransformer)((0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(qs));
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify((0, $gU71n.toApiUrlTransformer)(filter));
    try {
        return await (0, $lRmyA.performGetRequest)(`/rest/api/3/workflow/search?${query}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'getWorkflowsSearchAPI',
                packageName: (0, $cagHD.PACKAGE_NAME),
                teamName: 'helix'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});
parcelRegister("cagHD", function(module, exports) {

$parcel$export(module.exports, "SOURCE_NAME", () => $ebbc8a790944f941$export$a3821bc63538b210);
$parcel$export(module.exports, "WORKFLOW_NAME", () => $ebbc8a790944f941$export$a69699c3acbd94ca);
$parcel$export(module.exports, "PACKAGE_NAME", () => $ebbc8a790944f941$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "WORKFLOWS_ACTIONS", () => $ebbc8a790944f941$export$f3ab46ae5f3c01ad);
$parcel$export(module.exports, "WORKFLOWS_SCHEME", () => $ebbc8a790944f941$export$81c9aaf617cb2f01);
$parcel$export(module.exports, "SYSTEM_WORKFLOW_JIRA_NAME", () => $ebbc8a790944f941$export$615f1d8b29794ae);
$parcel$export(module.exports, "SYSTEM_WORKFLOW_BUILDS_WORKFLOWS_NAME", () => $ebbc8a790944f941$export$fccd4c1ce5f0896f);
$parcel$export(module.exports, "DEFAULT_PAGE_SIZE", () => $ebbc8a790944f941$export$5716e8bcb003888d);
$parcel$export(module.exports, "defaultListWorkFlowsFilter", () => $ebbc8a790944f941$export$dc5aae53031515c);
$parcel$export(module.exports, "ORDER", () => $ebbc8a790944f941$export$11e75bce9f7ea886);
$parcel$export(module.exports, "FILTER_CHANGE_ANALYTICS", () => $ebbc8a790944f941$export$9ac56b2484c2d4e9);
$parcel$export(module.exports, "PAGE_SIZE_CHANGE_ANALYTICS", () => $ebbc8a790944f941$export$e6613a3c77896936);
$parcel$export(module.exports, "API_PREFIX", () => $ebbc8a790944f941$export$a3f6840410eb0571);

const $ebbc8a790944f941$export$a3821bc63538b210 = 'listWorkflows';
const $ebbc8a790944f941$export$a69699c3acbd94ca = 'workflowName';
const $ebbc8a790944f941$export$b8b9d90f9e5bd72b = 'jira-admin-pages-list-workflows';
const $ebbc8a790944f941$export$f3ab46ae5f3c01ad = 'workflowsActions';
const $ebbc8a790944f941$export$81c9aaf617cb2f01 = 'workflowScheme';
const $ebbc8a790944f941$export$615f1d8b29794ae = 'jira';
const $ebbc8a790944f941$export$fccd4c1ce5f0896f = 'Builds Workflow';
const $ebbc8a790944f941$export$5716e8bcb003888d = 10;
const $ebbc8a790944f941$export$f6e7f4d903fd7165 = 'ADD_WORKFLOWS';
const $ebbc8a790944f941$export$dc5aae53031515c = {
    pageNumber: 1,
    pageSize: $ebbc8a790944f941$export$5716e8bcb003888d,
    expand: [
        'default',
        'hasDraftWorkflow',
        'schemes',
        'operations',
        'projects'
    ],
    orderBy: 'name',
    sortDirection: (0, $44cab0426b6cf0d7$export$1dee026a19752d6b),
    isActive: true
};
const $ebbc8a790944f941$export$11e75bce9f7ea886 = Object.freeze({
    ASC: 'asc',
    DESC: 'desc'
});
const $ebbc8a790944f941$export$3c5e605ca7ade9f2 = 'NAME';
const $ebbc8a790944f941$export$b87f371cbc396fcf = 'TYPE';
const $ebbc8a790944f941$export$9ac56b2484c2d4e9 = Object.freeze({
    ACTION: 'changed',
    ACTION_SUBJECT: 'filterSearch'
});
const $ebbc8a790944f941$export$e6613a3c77896936 = Object.freeze({
    ACTION: 'changed',
    ACTION_SUBJECT: 'pageSize'
});
const $ebbc8a790944f941$export$a3f6840410eb0571 = 'gateway/api/jira/project-configuration';

});

parcelRegister("gU71n", function(module, exports) {

$parcel$export(module.exports, "toUrlTransformer", () => $59fd86c236a165ea$export$5b9f8ed2c34be88a);
$parcel$export(module.exports, "fromUrlTransformer", () => $59fd86c236a165ea$export$bec67ef860c0d0e1);
$parcel$export(module.exports, "toApiUrlTransformer", () => $59fd86c236a165ea$export$fb15afa686993f11);

var $4qDVh = parcelRequire("4qDVh");

var $cagHD = parcelRequire("cagHD");

var $ldklr = parcelRequire("ldklr");
const $59fd86c236a165ea$export$5b9f8ed2c34be88a = (filter)=>{
    const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy, isActive: isActive, pageSize: pageSize } = filter || {};
    return {
        pageNumber: pageNumber,
        searchFilter: searchFilter,
        orderBy: orderBy,
        isActive: isActive,
        pageSize: pageSize
    };
};
const $59fd86c236a165ea$export$bec67ef860c0d0e1 = (params)=>{
    const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy, isActive: isActive, pageSize: pageSize } = params;
    const parsedNumber = Number.isNaN((0, $4qDVh.number).parse(pageNumber)) ? (0, $cagHD.defaultListWorkFlowsFilter).pageNumber : (0, $4qDVh.number).parse(pageNumber);
    const parsedSize = Number.isNaN((0, $4qDVh.number).parse(pageSize)) ? (0, $cagHD.defaultListWorkFlowsFilter).pageSize : (0, $4qDVh.number).parse(pageSize);
    const parsedOrderBy = orderBy === 'name' || orderBy === '-name' || orderBy === 'updated' || orderBy === '-updated' ? orderBy : undefined;
    const isActiveFinal = isActive != null ? isActive === 'true' : (0, $cagHD.defaultListWorkFlowsFilter).isActive;
    return {
        ...(0, $cagHD.defaultListWorkFlowsFilter),
        pageNumber: parsedNumber != null ? Number(parsedNumber) : undefined,
        pageSize: parsedSize != null ? Number(parsedSize) : undefined,
        searchFilter: searchFilter,
        orderBy: parsedOrderBy,
        isActive: isActiveFinal
    };
};
const $59fd86c236a165ea$export$fb15afa686993f11 = (filter)=>{
    const fullFilter = {
        ...(0, $cagHD.defaultListWorkFlowsFilter),
        ...filter
    };
    const { pageNumber: pageNumber = 1, pageSize: pageSize = (0, $cagHD.DEFAULT_PAGE_SIZE) } = fullFilter;
    let requestParams = {
        maxResults: pageSize,
        startAt: (pageNumber - 1) * pageSize,
        orderBy: fullFilter.orderBy,
        queryString: (0, $ldklr.trimSearchFilter)(fullFilter.searchFilter),
        isActive: fullFilter.isActive
    };
    if (fullFilter.expand != null) // @ts-expect-error - TS2322 - Type '{ expand: string; maxResults: number; startAt: number; orderBy: WorkflowOrderBy | undefined; queryString: string | undefined; isActive: boolean; }' is not assignable to type '{ maxResults: number; startAt: number; orderBy: WorkflowOrderBy | undefined; queryString: string | undefined; isActive: boolean; }'.
    requestParams = {
        ...requestParams,
        expand: fullFilter.expand.join(',')
    };
    return requestParams;
};

});
parcelRegister("ldklr", function(module, exports) {

$parcel$export(module.exports, "trimSearchFilter", () => $50287bb8c06d17c2$export$ed1722f41c23aaaf);
const $50287bb8c06d17c2$export$7341f299e7b93e87 = (field)=>field !== undefined ? field.toLowerCase() : undefined;
const $50287bb8c06d17c2$export$c876451e094c0060 = (map, param)=>map[param] !== undefined ? map[param] : undefined;
const $50287bb8c06d17c2$export$ed1722f41c23aaaf = (searchFilter)=>{
    if (searchFilter === undefined) return undefined;
    return searchFilter.trim() || undefined;
};

});



const $810245ed2edcd973$export$b11854972ecaecc7 = 'WORKFLOWS_TABLE';
const $810245ed2edcd973$export$6602c5404301813f = 'WORKFLOWS_TABLE_KEY';


parcelRegister("lbi7V", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('9HG9Z')
        ]);
        const value = parcelRequire('7s4ac');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("9HG9Z")
    ]).then(()=>parcelRequire('7s4ac'));
}

});

parcelRegister("12Iu6", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('idgZe');
        const value = parcelRequire('7QYqA');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("idgZe").then(()=>parcelRequire('7QYqA'));
}

});

parcelRegister("9urUx", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f3d9fe15c0dae80$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4Ti3v = parcelRequire("4Ti3v");
var $u0mbR = parcelRequire("u0mbR");

var $agcDm = parcelRequire("agcDm");

var $emcAw = parcelRequire("emcAw");
const $5f3d9fe15c0dae80$var$MultiProjectSidebarCore = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $u0mbR.SidebarRenderStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $agcDm.PerformanceMark), {
        id: (0, $agcDm.RENDER_START_MARK)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $emcAw.default), null), !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $u0mbR.SidebarReady), {
        id: (0, $4Ti3v.SIDEBAR_ID).CORE
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $agcDm.PerformanceMark), {
        id: (0, $agcDm.RENDER_END_MARK)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $agcDm.PerformanceReport), null)));
var $5f3d9fe15c0dae80$export$2e2bcd8739ae039 = $5f3d9fe15c0dae80$var$MultiProjectSidebarCore;

});
parcelRegister("agcDm", function(module, exports) {

$parcel$export(module.exports, "RENDER_START_MARK", () => $2c9144edaf673b4b$export$8f8203e04f80aed);
$parcel$export(module.exports, "RENDER_END_MARK", () => $2c9144edaf673b4b$export$dc795f9b21e2778a);
$parcel$export(module.exports, "PerformanceMark", () => $2c9144edaf673b4b$export$b8228db3a01d9a76);
$parcel$export(module.exports, "PerformanceReport", () => $2c9144edaf673b4b$export$c97ab321326d29f7);

var $eUqFw = parcelRequire("eUqFw");

var $lNfG4 = parcelRequire("lNfG4");
const $2c9144edaf673b4b$var$JWM_SIDEBAR_SEGMENT_NAME = 'jwm.sidebar';
const $2c9144edaf673b4b$export$8f8203e04f80aed = `${$2c9144edaf673b4b$var$JWM_SIDEBAR_SEGMENT_NAME}.render.start`;
const $2c9144edaf673b4b$export$dc795f9b21e2778a = `${$2c9144edaf673b4b$var$JWM_SIDEBAR_SEGMENT_NAME}.render.end`;
const $2c9144edaf673b4b$var$segment = (0, $lNfG4.metrics).pageSegmentLoad({
    key: $2c9144edaf673b4b$var$JWM_SIDEBAR_SEGMENT_NAME,
    timings: [
        {
            key: 'tti',
            endMark: $2c9144edaf673b4b$export$dc795f9b21e2778a
        }
    ]
});
const $2c9144edaf673b4b$export$b8228db3a01d9a76 = ({ id: id })=>{
    const startedRef = (0, $eUqFw.useRef)(false);
    if (!false && !startedRef.current) {
        $2c9144edaf673b4b$var$segment.startFromPageLoad();
        startedRef.current = true;
    }
    (0, $eUqFw.useEffect)(()=>$2c9144edaf673b4b$var$segment.mark(id), [
        id
    ]);
    return null;
};
const $2c9144edaf673b4b$export$c97ab321326d29f7 = ()=>{
    (0, $eUqFw.useEffect)(()=>{
        $2c9144edaf673b4b$var$segment.stop();
    }, []);
    return null;
};

});

parcelRegister("emcAw", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7cfc64baafae021$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $41WOo = parcelRequire("41WOo");

var $gP3W1 = parcelRequire("gP3W1");

var $bWsAc = parcelRequire("bWsAc");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5cLMB = parcelRequire("5cLMB");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");

var $f26dB = parcelRequire("f26dB");

var $6yplV = parcelRequire("6yplV");

var $57SqH = parcelRequire("57SqH");

var $lym21 = parcelRequire("lym21");
var $fUoOQ = parcelRequire("fUoOQ");

var $gTasH = parcelRequire("gTasH");

var $8l70H = parcelRequire("8l70H");

var $4h0Ly = parcelRequire("4h0Ly");

var $9QtHd = parcelRequire("9QtHd");

var $439fx = parcelRequire("439fx");
// eslint-disable-next-line complexity
const $b7cfc64baafae021$var$MultiProjectMenu = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { currentProject: currentProject, recents: recents, favorites: favorites, hasMoreFavorite: hasMoreFavorite, onFavoriteToggle: onFavoriteToggle, overviews: overviews, overviewsError: overviewsError, shouldHideOverviews: shouldHideOverviews, loading: loading } = (0, $57SqH.useSidebarData)();
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    const isPremiumUserSeat = (0, $f26dB.useIsPremiumUserSeat)();
    const [projectState] = (0, $5cLMB.useProjectState)();
    const [{ route: route, match: { params: { projectKey: projectKey } } }] = (0, $kJlBc.useRouter)();
    (0, $eUqFw.useEffect)(()=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'sidebar viewed', {
            starredProjectsCount: favorites.length,
            recentProjectsCount: recents.length,
            overviewsCount: overviews.length
        });
    // only run once on component mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // the currentProject data gets loaded async and thus it is null while
    // transitioning between projects. To allow expanding the right current
    // project when the data has not been resolved yet, we use the project
    // key from the URL instead.
    const currentProjectKey = projectKey ?? currentProject?.key;
    const shouldDisplayOverviews = isPremiumUserSeat && !isAnonymous && !shouldHideOverviews;
    const projectsContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("section", null, favorites.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9QtHd.default), {
        sectionId: "starred",
        projects: favorites,
        onFavoriteToggle: onFavoriteToggle,
        currentProjectKey: currentProjectKey,
        currentRoute: route,
        showViewAllProjects: hasMoreFavorite,
        viewAllProjectsLabel: formatMessage((0, $8l70H.default).viewAllStarred)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9QtHd.default), {
        sectionId: "recent",
        projects: recents,
        onFavoriteToggle: onFavoriteToggle,
        currentProjectKey: currentProjectKey,
        currentRoute: route,
        showViewAllProjects: true
    }));
    const callToActionType = (0, $eI5EY.fg)('jwm_create_project_from_sample') ? (0, $lym21.getCallToActionType)(projectState?.isSampleProject) : (0, $lym21.CallToActionType).NONE;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$SidebarWrapper, {
        "aria-label": formatMessage((0, $8l70H.default).navigationLabel),
        isCrossProjectView: true
    }, shouldDisplayOverviews && (loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$OverviewsSkeleton, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("section", {
        "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.overviews"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4h0Ly.default), {
        overviews: overviews,
        hasError: Boolean(overviewsError)
    }))), loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$ProjectsSkeleton, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("section", {
        "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.projects"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $439fx.default), null), projectsContent), (0, $eI5EY.fg)('jwm_create_project_from_sample') && !loading && callToActionType === (0, $lym21.CallToActionType).CREATE_PROJECT_BUTTON && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fUoOQ.CreateProjectCta), null)), (0, $eI5EY.fg)('jwm_mobile_discovery') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gP3W1.AsyncMobileDownloadPrompt), null), (0, $eI5EY.fg)('jwm_create_project_from_sample') && (callToActionType === (0, $lym21.CallToActionType).CREATE_PROJECT_BANNER || callToActionType === (0, $lym21.CallToActionType).CREATE_PROJECT_NONE) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fUoOQ.CreateProjectCta), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$Footer, {
        hasMargin: true
    }, currentProject != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$Type, {
        "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.project-type"
    }, currentProject.isSimplified ? formatMessage((0, $8l70H.default).teamManagedProject) : formatMessage((0, $8l70H.default).companyManagedProject)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gTasH.default), null)), (0, $eI5EY.fg)('jwm_create_project_from_sample') ? callToActionType === (0, $lym21.CallToActionType).TRIAL_BANNER && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bWsAc.TrialBannerExperiment), {
        isProjectSimplified: !!currentProject?.isSimplified
    }) : (0, $41WOo.isJwmMonetizationExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bWsAc.TrialBannerExperiment), {
        isProjectSimplified: !!currentProject?.isSimplified
    }));
};
const $b7cfc64baafae021$var$ItemSkeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$ItemSkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$ItemAvatarSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$SkeletonBase, null));
const $b7cfc64baafae021$var$OverviewsSkeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$SkeletonSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$SectionHeaderSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$ItemSkeleton, null));
const $b7cfc64baafae021$var$ProjectsSkeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$SkeletonSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$SectionHeaderSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$CollapsibleHeaderSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$CollapsibleHeaderSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$ItemSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7cfc64baafae021$var$ItemSkeleton, null)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b7cfc64baafae021$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _11q7vuon",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b7cfc64baafae021$var$SidebarWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "nav", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCrossProjectView: isCrossProjectView, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_n3tdpxbi _19bvpxbi _u5f3pxbi _19pkr5cr _otyridpf _18u0idpf _2hwxidpf _1reo1wug _18m91wug _16jlkb7n _1o9zkb7n _i0dlf1ug _11q71mi8 _12vemgnk _1lrwy1fe _qmxj4ebz _qjkj6grs _azbnu2gc",
            __cmplp.isCrossProjectView ? "_ca0qpxbi" : "_ca0q1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b7cfc64baafae021$var$SkeletonBase = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11q7iw92 _4t3i1crf _1bsbqkoa _2rko1y44 _otyrutpp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b7cfc64baafae021$var$SkeletonSection = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b7cfc64baafae021$var$SectionHeaderSkeleton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $b7cfc64baafae021$var$SkeletonBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb68cl _4t3i7vkz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b7cfc64baafae021$var$ItemSkeletonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b7cfc64baafae021$var$ItemAvatarSkeleton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $b7cfc64baafae021$var$SkeletonBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1tcg _4t3i1tcg _18u0utpp _2hwxutpp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b7cfc64baafae021$var$CollapsibleHeaderSkeleton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $b7cfc64baafae021$var$SkeletonBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbys9h _18u0u2gc _19pkutpp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b7cfc64baafae021$var$Footer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasMargin: hasMargin, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o",
            __cmplp.hasMargin && "_18s8u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b7cfc64baafae021$var$Type = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81vlj _y3gn1h6o _18s8swc3 _1tke7vkz _syaz1rc1",
            __cmplp.className
        ])
    });
});
var $b7cfc64baafae021$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($b7cfc64baafae021$var$MultiProjectMenu);

});
parcelRegister("41WOo", function(module, exports) {

$parcel$export(module.exports, "isJwmMonetizationExperimentEnabled", () => $2d43a89fd1224d6e$export$10ae23b90fb69a2a);
$parcel$export(module.exports, "isVariationOnJwmMonetizationExperiment", () => $2d43a89fd1224d6e$export$157c21c92e1418f2);
$parcel$export(module.exports, "isJwmInlineFieldCreateEnabled", () => $2d43a89fd1224d6e$export$fb2108971c4de07a);
$parcel$export(module.exports, "getJwmInlineFieldCreateCohort", () => $2d43a89fd1224d6e$export$bd44a7b81fbc9090);
$parcel$export(module.exports, "isInAutomationDiscoveryOnBoardColumnsExperimentVariationCohort", () => $2d43a89fd1224d6e$export$7b2cbb525cd1479e);
$parcel$export(module.exports, "isAutomationDiscoveryOnBoardColumnsExperimentEnabled", () => $2d43a89fd1224d6e$export$926c1115b4c28620);
$parcel$export(module.exports, "isJwmTemplateBundlesEnabled", () => $2d43a89fd1224d6e$export$b9595e1ee168b117);
$parcel$export(module.exports, "isLinkedIssuesEnabledInJwmBoardCards", () => $2d43a89fd1224d6e$export$144ea04c193e7769);
$parcel$export(module.exports, "getJwmHelpSampleUsersCreateProjectsCtaType", () => $2d43a89fd1224d6e$export$6df5130e98d74ad2);
$parcel$export(module.exports, "isOnboardingForLinkedIssuesEnabledInJwmBoard", () => $2d43a89fd1224d6e$export$21f160f3ad728081);
$parcel$export(module.exports, "isJwmReduceNoiseOnSignupEnabled", () => $2d43a89fd1224d6e$export$dc89692c53fbc1);

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");
const $2d43a89fd1224d6e$export$10ae23b90fb69a2a = ()=>!(0, $79xbN.expValEquals)('jwm_implicit_user_monetization_experiment', 'cohort', null);
const $2d43a89fd1224d6e$export$157c21c92e1418f2 = ()=>(0, $79xbN.expValEquals)('jwm_implicit_user_monetization_experiment', 'cohort', 'variation');
const $2d43a89fd1224d6e$export$fb2108971c4de07a = ()=>(0, $79xbN.expValEquals)('jwm_inline_field_create', 'cohort', 'variation');
const $2d43a89fd1224d6e$export$bd44a7b81fbc9090 = ()=>(0, $79xbN.expVal)('jwm_inline_field_create', 'cohort', 'not-enrolled');
const $2d43a89fd1224d6e$export$7b2cbb525cd1479e = ()=>{
    // Intentionally not firing exposure here because the user is not yet determined to be eligible.
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jwm_moon_automation_discovery_v2');
    return expConfig.get('cohort', 'not-enrolled') === 'variation';
};
const $2d43a89fd1224d6e$export$926c1115b4c28620 = ()=>{
    // Intentionally not firing exposure here because the user is not yet determined to be eligible.
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jwm_moon_automation_discovery_v2');
    return expConfig.get('cohort', 'not-enrolled') !== 'not-enrolled';
};
const $2d43a89fd1224d6e$export$b9595e1ee168b117 = ()=>(0, $79xbN.expValEquals)('jwm_template_bundles_experiment', 'cohort', 'variation');
const $2d43a89fd1224d6e$export$144ea04c193e7769 = ()=>(0, $79xbN.expValEquals)('jwm_linked_issues_on_the_board_milestone_1', 'cohort', 'variation');
const $2d43a89fd1224d6e$export$6df5130e98d74ad2 = ()=>{
    // Intentionally not firing exposure here because it is yet to be determined whether the engagement platform message has started.
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jwm_help_sample_users_create_projects');
    return expConfig.get('ctaType', 'none');
};
const $2d43a89fd1224d6e$export$21f160f3ad728081 = ()=>// eslint-disable-next-line jira/ff/no-preconditioning -- Need this preconditioning to make sure can independently control onboarding
    (0, $eI5EY.fg)('jwm_linked_issues_on_the_board_onboarding') && (0, $79xbN.expVal)('jwm_linked_issues_on_the_board_milestone_1', 'isJWMBoardLinkedIssuesEnabled', false);
const $2d43a89fd1224d6e$export$dc89692c53fbc1 = ()=>(0, $79xbN.expValEquals)('jwm_reduce_noise_on_signup', 'cohort', 'variation');

});

parcelRegister("gP3W1", function(module, exports) {

$parcel$export(module.exports, "AsyncMobileDownloadPrompt", () => $67b3342293e0228e$export$64ca7d64bb703770);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");


var $ldsZq = parcelRequire("ldsZq");
const $67b3342293e0228e$var$runtimeProps = {};
const $67b3342293e0228e$var$entryPointParams = {};
const $67b3342293e0228e$export$64ca7d64bb703770 = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $ldsZq.downloadMobilePromptEntryPoint), $67b3342293e0228e$var$entryPointParams);
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "jiraBusinessDownloadMobilePrompt",
        packageName: (0, $eed20802841d894c$export$b8b9d90f9e5bd72b),
        teamName: "frontier",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: $67b3342293e0228e$var$runtimeProps,
        errorFallback: "unmount"
    });
};

});
const $eed20802841d894c$export$b8b9d90f9e5bd72b = 'jiraBusinessMobileDownloadPrompt';

parcelRegister("ldsZq", function(module, exports) {

$parcel$export(module.exports, "downloadMobilePromptEntryPoint", () => $c626ef33a70c140f$export$66f4c5613c7e964);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $c626ef33a70c140f$export$66f4c5613c7e964 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("k5xr3")), {
        moduleId: "c94481ab"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("k5xr3", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('bApOA');
        const value = parcelRequire('cGSJA');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("bApOA").then(()=>parcelRequire('cGSJA'));
}

});



parcelRegister("bWsAc", function(module, exports) {

$parcel$export(module.exports, "TrialBannerExperiment", () => $5bbfbbbb7a700c1d$export$c54011d73ccea97b);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");


var $kyg8p = parcelRequire("kyg8p");
const $5bbfbbbb7a700c1d$var$entryPointParams = {};
const $5bbfbbbb7a700c1d$export$c54011d73ccea97b = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $kyg8p.trialBannerEntryPoint), $5bbfbbbb7a700c1d$var$entryPointParams);
    (0, $eUqFw.useEffect)(()=>{
        // Preloads data for the onboarding modal on mount
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "jiraBusinessMonetizationTrialBanner",
        packageName: (0, $ebba456e6ace08b3$export$b8b9d90f9e5bd72b),
        teamName: "program-moon",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: {
            isProjectSimplified: props.isProjectSimplified
        },
        errorFallback: "unmount"
    });
};

});
const $ebba456e6ace08b3$export$2fa4e95d1c6e7b0f = 'jira_workmanagement_ui_jwmmonetisationbannerdismiss_clicked_last';
const $ebba456e6ace08b3$export$b8b9d90f9e5bd72b = 'jiraBusinessProgramMoonTrialBanner';
const $ebba456e6ace08b3$export$5200514808277ba7 = 'showJWMPremiumUpgradeSuccessFlag';

parcelRegister("kyg8p", function(module, exports) {

$parcel$export(module.exports, "trialBannerEntryPoint", () => $d331199b87144c91$export$ee321d3cb6d82261);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $d331199b87144c91$export$ee321d3cb6d82261 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("fiNxT")), {
        moduleId: "61fe650e"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("fiNxT", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('7OoSx')
        ]);
        const value = parcelRequire('jdZ9N');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("7OoSx")
    ]).then(()=>parcelRequire('jdZ9N'));
}

});



parcelRegister("5cLMB", function(module, exports) {

$parcel$export(module.exports, "JswOnboardingSubscriber", () => $502e2dc73b97f226$export$1cbc60d8dd921852);
$parcel$export(module.exports, "useJswOnboarding", () => $502e2dc73b97f226$export$7d91c0af4772787a);
$parcel$export(module.exports, "useOpenTask", () => $502e2dc73b97f226$export$594f006fa6a1b2e5);
$parcel$export(module.exports, "useNudgeStep", () => $502e2dc73b97f226$export$c5e63e44ad178ae8);
$parcel$export(module.exports, "useQuickstartActions", () => $502e2dc73b97f226$export$2c3cd14fff9d6e43);
$parcel$export(module.exports, "useShouldShowNudge", () => $502e2dc73b97f226$export$b0db7e46e369e1d9);
$parcel$export(module.exports, "useShouldShowOpenMenuItem", () => $502e2dc73b97f226$export$d994ff8c0341aba1);
$parcel$export(module.exports, "useInviteToProject", () => $502e2dc73b97f226$export$71de79653346a1ea);
$parcel$export(module.exports, "useShowVideoCards", () => $502e2dc73b97f226$export$61185a9266f1f57a);
$parcel$export(module.exports, "useProjectState", () => $502e2dc73b97f226$export$ef4747ba36826d6a);
$parcel$export(module.exports, "useQuickstartUiStatus", () => $502e2dc73b97f226$export$522993b46d9f8266);
$parcel$export(module.exports, "useIsLoaded", () => $502e2dc73b97f226$export$aa4ba29241532382);
$parcel$export(module.exports, "useIsFocusedOn", () => $502e2dc73b97f226$export$ed5c755b733bf2b1);
$parcel$export(module.exports, "useIsDismissed", () => $502e2dc73b97f226$export$35fe0366802512dd);
$parcel$export(module.exports, "useCompletedTaskList", () => $502e2dc73b97f226$export$a41ee0d3b6938099);
$parcel$export(module.exports, "useAllTasksCompleted", () => $502e2dc73b97f226$export$4ae7b465b076be9);
$parcel$export(module.exports, "useMountedNudges", () => $502e2dc73b97f226$export$bf6e646c0476acad);
$parcel$export(module.exports, "useHasEverSeen", () => $502e2dc73b97f226$export$6b706bff94798d11);
$parcel$export(module.exports, "useRoadmapState", () => $502e2dc73b97f226$export$c98db656edc5b3e1);
$parcel$export(module.exports, "useShouldShowScrumOnboardingExperience", () => $502e2dc73b97f226$export$a823278ac9d1112b);
$parcel$export(module.exports, "useShouldShowOnboardingKanbanTour", () => $502e2dc73b97f226$export$cb9e0e8fe4df8490);
$parcel$export(module.exports, "useHasNudgeActive", () => $502e2dc73b97f226$export$521909e3dc7ab811);
$parcel$export(module.exports, "useSelectedProjectTemplateKeyFromOnboarding", () => $502e2dc73b97f226$export$f4a2be940259bf95);
$parcel$export(module.exports, "usePersonaExperience", () => $502e2dc73b97f226$export$8e98a1e4d2dbf1b9);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS", () => (parcelRequire("7dRgX")).QUICKSTART_UI_STATUS);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");

var $9CmwD = parcelRequire("9CmwD");

var $79xbN = parcelRequire("79xbN");

var $7dRgX = parcelRequire("7dRgX");

var $c8ave = parcelRequire("c8ave");

var $lCsoa = parcelRequire("lCsoa");

var $fricC = parcelRequire("fricC");

var $5OjXh = parcelRequire("5OjXh");

var $7AH2S = parcelRequire("7AH2S");
const $502e2dc73b97f226$export$390f32400eaf98c9 = (0, $a61MH.createStore)({
    name: 'jsw-onboarding-quickstart',
    initialState: $lCsoa.initialState,
    actions: $c8ave
});
const $502e2dc73b97f226$export$1cbc60d8dd921852 = (0, $dYfll.createSubscriber)($502e2dc73b97f226$export$390f32400eaf98c9);
const $502e2dc73b97f226$export$7d91c0af4772787a = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9);
const $502e2dc73b97f226$export$638bfcfce1254bb8 = (0, $heB5U.createContainer)($502e2dc73b97f226$export$390f32400eaf98c9, {});
const $502e2dc73b97f226$export$9d731f44f82af09f = (state, { itemNames: itemNames })=>{
    const commonConditionsToShowNudge = state.shouldRenderComponent && ((0, $79xbN.expValEquals)('jsm_business_quickstart', 'cohort', 'experiment') ? state.visibility[(0, $5OjXh.getQuickstartTypeSelector)(state)] === (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN : state.isOpen && !state.isDismissed) && // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
    itemNames.includes(state.openTask);
    return commonConditionsToShowNudge && state.hasNudgeActive;
};
const $502e2dc73b97f226$export$ea14030920a5d8e6 = (state)=>state.openTask;
const $502e2dc73b97f226$export$594f006fa6a1b2e5 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: $502e2dc73b97f226$export$ea14030920a5d8e6
});
const $502e2dc73b97f226$export$a943afa434e9487a = (state)=>state.nudgeStep;
const $502e2dc73b97f226$export$c5e63e44ad178ae8 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: $502e2dc73b97f226$export$a943afa434e9487a
});
const $502e2dc73b97f226$export$2c3cd14fff9d6e43 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: null
});
const $502e2dc73b97f226$export$b0db7e46e369e1d9 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: $502e2dc73b97f226$export$9d731f44f82af09f
});
// TODO: KURO-1678, delete
const $502e2dc73b97f226$var$useShouldShowOpenMenuItemHook = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>{
        if ((0, $79xbN.expValEquals)('jsm_business_quickstart', 'cohort', 'experiment')) return state.shouldRenderComponent && state.visibility[(0, $5OjXh.getQuickstartTypeSelector)(state)] === (0, $7dRgX.QUICKSTART_UI_STATUS).DISMISSED;
        return state.shouldRenderComponent && state.isDismissed;
    }
});
const $502e2dc73b97f226$export$d994ff8c0341aba1 = ()=>{
    const [shouldShow, { nextSetChecklistIsDismissed: nextSetChecklistIsDismissed }] = $502e2dc73b97f226$var$useShouldShowOpenMenuItemHook();
    return {
        shouldShow: shouldShow,
        setIsDismissed: nextSetChecklistIsDismissed
    };
};
const $502e2dc73b97f226$export$71de79653346a1ea = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.projectState && state.projectState.canInvitePeopleToProject)
});
const $502e2dc73b97f226$export$61185a9266f1f57a = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>{
        if (!state.projectState) return false;
        const { isNextGen: isNextGen, userRole: userRole, isProjectAdmin: isProjectAdmin } = state.projectState;
        return Boolean(isNextGen && (userRole === (0, $fricC.USER_ROLE).JIRA_ADMIN || userRole === (0, $fricC.USER_ROLE).SITE_ADMIN || isProjectAdmin));
    }
});
const $502e2dc73b97f226$export$ef4747ba36826d6a = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.projectState
});
const $502e2dc73b97f226$export$522993b46d9f8266 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>{
        if (state.shouldRenderComponent === false) return (0, $7dRgX.QUICKSTART_UI_STATUS).NOT_LOADED;
        const quickstartType = (0, $5OjXh.getQuickstartTypeSelector)(state);
        if ((0, $79xbN.expValEquals)('jsm_business_quickstart', 'cohort', 'experiment')) return state.visibility[quickstartType];
        if (state.isDismissed) return (0, $7dRgX.QUICKSTART_UI_STATUS).DISMISSED;
        if (state.isOpen) return (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN;
        return (0, $7dRgX.QUICKSTART_UI_STATUS).MINIMIZED;
    }
});
const $502e2dc73b97f226$export$aa4ba29241532382 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.isQuickstartLoaded
});
const $502e2dc73b97f226$export$ed5c755b733bf2b1 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.isFocusedOn
});
const $502e2dc73b97f226$export$35fe0366802512dd = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>{
        if ((0, $79xbN.expValEquals)('jsm_business_quickstart', 'cohort', 'experiment')) return state.visibility[(0, $5OjXh.getQuickstartTypeSelector)(state)] === (0, $7dRgX.QUICKSTART_UI_STATUS).DISMISSED;
        return state.isDismissed;
    }
});
const $502e2dc73b97f226$export$a41ee0d3b6938099 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.completedTaskList
});
const $502e2dc73b97f226$export$4ae7b465b076be9 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>{
        if (!state.tasks) return null;
        return state.tasks.items.every((task)=>state.completedTaskList.includes(task));
    }
});
const $502e2dc73b97f226$export$bf6e646c0476acad = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.mountedNudges
});
const $502e2dc73b97f226$export$6b706bff94798d11 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.hasEverSeenRoute
});
const $502e2dc73b97f226$export$c98db656edc5b3e1 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>({
            roadmapIsCreateEnabled: state.roadmapIsCreateEnabled,
            roadmapIsListEmpty: state.roadmapIsListEmpty
        })
});
const $502e2dc73b97f226$export$a823278ac9d1112b = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.isQuickstartLoaded && !state.isDevOpsProject && state.selectedProjectTemplateKeyFromOnboarding === (0, $9CmwD.SCRUM_TEAM_MANAGED_KEY) && state.projectState?.userRole === (0, $fricC.USER_ROLE).SITE_ADMIN)
});
const $502e2dc73b97f226$export$cb9e0e8fe4df8490 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.isQuickstartLoaded && !state.isDevOpsProject && state.selectedProjectTemplateKeyFromOnboarding === (0, $9CmwD.KANBAN_TEAM_MANAGED_KEY) && state.projectState?.userRole === (0, $fricC.USER_ROLE).SITE_ADMIN && // edge case - if e.g. welcome modal failed to load, and user completed task by themself, then the welcome modal should be skipped on subsequent page loads.
        !state.completedTaskList.includes((0, $7dRgX.KANBAN_ONBOARDING_TASK)))
});
const $502e2dc73b97f226$export$521909e3dc7ab811 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.hasNudgeActive
});
const $502e2dc73b97f226$export$f4a2be940259bf95 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.selectedProjectTemplateKeyFromOnboarding
});
const $502e2dc73b97f226$export$8e98a1e4d2dbf1b9 = (0, $ggKAj.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.personaExperience
});

});
parcelRegister("7dRgX", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $3913ca223572f8d7$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "PACKAGE_TEAM_NAME", () => $3913ca223572f8d7$export$2b3151a089bc8780);
$parcel$export(module.exports, "DEFAULT_NUDGE_WIDTH", () => $3913ca223572f8d7$export$6826d33e9a2c0119);
$parcel$export(module.exports, "ROOT_TASK", () => $3913ca223572f8d7$export$b580da85daad7757);
$parcel$export(module.exports, "REVERSE_TRIAL_ROOT_TASK", () => $3913ca223572f8d7$export$5eef19b26a4bbe70);
$parcel$export(module.exports, "QUICKSTART_TYPE", () => $3913ca223572f8d7$export$c57d251ae83aff51);
$parcel$export(module.exports, "getBackendVisibilityKey", () => $3913ca223572f8d7$export$d9df7fd23ab00c49);
$parcel$export(module.exports, "KEY_OPEN", () => $3913ca223572f8d7$export$93a67c1026e8cb7c);
$parcel$export(module.exports, "KEY_DISMISSED", () => $3913ca223572f8d7$export$a7dcb0b5013e932b);
$parcel$export(module.exports, "KEY_TASK_GROUP", () => $3913ca223572f8d7$export$f962b14e410d598f);
$parcel$export(module.exports, "KEY_OPEN_TASK", () => $3913ca223572f8d7$export$21e8355b28449456);
$parcel$export(module.exports, "KEY_HAS_EVER_SEEN_ROUTE", () => $3913ca223572f8d7$export$536a90031123e004);
$parcel$export(module.exports, "KEY_PREMIUM_TRIAL_REOPENED", () => $3913ca223572f8d7$export$3ccd291a1a3a4f6d);
$parcel$export(module.exports, "KEY_IS_DEVOPS_PROJECT", () => $3913ca223572f8d7$export$e5b557e3bbb7ec52);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $3913ca223572f8d7$export$9957974f8b4d8f74);
$parcel$export(module.exports, "SOURCE", () => $3913ca223572f8d7$export$83c8d7110915321e);
$parcel$export(module.exports, "KEY_JSW_ONBOARDING", () => $3913ca223572f8d7$export$8b9bd2a9275b0187);
$parcel$export(module.exports, "convertToHaveSeenItTask", () => $3913ca223572f8d7$export$ec43e7bf5973b10f);
$parcel$export(module.exports, "ADD_COLUMNS_TASK", () => $3913ca223572f8d7$export$cbeb719208f32c8a);
$parcel$export(module.exports, "CREATE_PROJECT_TASK", () => $3913ca223572f8d7$export$88c918f2cfaff86);
$parcel$export(module.exports, "CREATE_ISSUE_TASK", () => $3913ca223572f8d7$export$abbbea7c37c93cb5);
$parcel$export(module.exports, "CREATE_ISSUE_TASK_SIMPLIFIED", () => $3913ca223572f8d7$export$2a0253cb20f48a8);
$parcel$export(module.exports, "INVITE_TEAMMATES_TASK", () => $3913ca223572f8d7$export$f97428bb4b1991ec);
$parcel$export(module.exports, "INVITE_TEAMMATES_VIDEO_TASK", () => $3913ca223572f8d7$export$45eaf4204fcc7);
$parcel$export(module.exports, "CAPTURE_INTEGRATIONS_TASK", () => $3913ca223572f8d7$export$af57685e201438e8);
$parcel$export(module.exports, "FIND_HELP_TASK", () => $3913ca223572f8d7$export$d6c67e9aab4e2b26);
$parcel$export(module.exports, "SET_UP_BOARD_TASK", () => $3913ca223572f8d7$export$3de8c242d2b82f26);
$parcel$export(module.exports, "GET_MOBILE_APP_TASK", () => $3913ca223572f8d7$export$a01fa44f793dbfac);
$parcel$export(module.exports, "MAP_OUT_YOUR_PROJECT_GOALS_TASK", () => $3913ca223572f8d7$export$6a4507e462fd41da);
$parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK", () => $3913ca223572f8d7$export$e64c1dced6ac4458);
$parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_KANBAN_TASK", () => $3913ca223572f8d7$export$63b0e55f9c6454ac);
$parcel$export(module.exports, "MONITOR_MANAGE_RISK_TASK", () => $3913ca223572f8d7$export$c1effb1c8979fe22);
$parcel$export(module.exports, "PREMIUM_REVERSE_TRIAL_TASK", () => $3913ca223572f8d7$export$d97d31d934dbb194);
$parcel$export(module.exports, "PREMIUM_EDITION_OVERVIEW_TASK", () => $3913ca223572f8d7$export$cafb5bd13b02056b);
$parcel$export(module.exports, "PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN", () => $3913ca223572f8d7$export$e55c18b809946e72);
$parcel$export(module.exports, "STANDARD_EDITION_OVERVIEW_TASK", () => $3913ca223572f8d7$export$de5640b9ae8140a7);
$parcel$export(module.exports, "ADVANCED_ROADMAPS_TASK", () => $3913ca223572f8d7$export$540b5c3c4b6ce459);
$parcel$export(module.exports, "CHANGE_CONTROL_TASK", () => $3913ca223572f8d7$export$6f71dff531ff592);
$parcel$export(module.exports, "AUTOMATIONS_TASK", () => $3913ca223572f8d7$export$83255ab79e45f34f);
$parcel$export(module.exports, "SITE_ADMINISTRATIONS_TASK", () => $3913ca223572f8d7$export$b57d172af9ad7647);
$parcel$export(module.exports, "USER_MANAGEMENT_TASK", () => $3913ca223572f8d7$export$ff4c933c1fe90b68);
$parcel$export(module.exports, "SCRUM_ONBOARDING_TASK", () => $3913ca223572f8d7$export$3e2776d61f3662dc);
$parcel$export(module.exports, "CUSTOMIZE_SITE_NAME_TASK", () => $3913ca223572f8d7$export$9048315f2c03fd9d);
$parcel$export(module.exports, "GET_TO_KNOW_YOUR_TEMPLATE_TASK", () => $3913ca223572f8d7$export$a333714599f14a6);
$parcel$export(module.exports, "CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK", () => $3913ca223572f8d7$export$4145c2cec2da6f9b);
$parcel$export(module.exports, "TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK", () => $3913ca223572f8d7$export$4957a1ad203cf6dd);
$parcel$export(module.exports, "CALENDAR_VIEW_TASK", () => $3913ca223572f8d7$export$190b5dd0a1322552);
$parcel$export(module.exports, "JWM_PROJECT_SUMMARY_TASK", () => $3913ca223572f8d7$export$501166b25f254aab);
$parcel$export(module.exports, "JWM_CREATE_SAMPLE_PROJECT_TASK", () => $3913ca223572f8d7$export$94ad6507a703f4eb);
$parcel$export(module.exports, "JWM_GET_STARTED_LIST_TASK", () => $3913ca223572f8d7$export$6fbd9800a4c54752);
$parcel$export(module.exports, "JWM_BACKGROUND_COLOR_TASK", () => $3913ca223572f8d7$export$be1c522400a1bd7c);
$parcel$export(module.exports, "JWM_CALENDAR_TASK", () => $3913ca223572f8d7$export$2aa6e7b6e24a04f5);
$parcel$export(module.exports, "JWM_TIMELINE_TASK", () => $3913ca223572f8d7$export$f3b53199b07af2a1);
$parcel$export(module.exports, "JWM_BUILD_FORM_TASK", () => $3913ca223572f8d7$export$d37415ffddcf2142);
$parcel$export(module.exports, "JWM_FEEDBACK_TASK", () => $3913ca223572f8d7$export$2ae00586da7cb606);
$parcel$export(module.exports, "JWM_FEEDBACK_SAMPLE_PROJECT_TASK", () => $3913ca223572f8d7$export$b86266e6594a97bb);
$parcel$export(module.exports, "JWM_CREATE_YOUR_OWN_PROJECT_TASK", () => $3913ca223572f8d7$export$20bc3dc137ac1c38);
$parcel$export(module.exports, "JWM_CREATE_PROJECT_TASK", () => $3913ca223572f8d7$export$77071b77e2801b18);
$parcel$export(module.exports, "JWM_SHARE_PROJECT_TASK", () => $3913ca223572f8d7$export$9c89f946f05d884a);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_IMPORT", () => $3913ca223572f8d7$export$b52a7c936684cfc5);
$parcel$export(module.exports, "JWM_SUMMARY_AND_REPORTS_TASK", () => $3913ca223572f8d7$export$b5555f24061f9fb);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK", () => $3913ca223572f8d7$export$ff25449f34b8abf);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES", () => $3913ca223572f8d7$export$3380e677209260fe);
$parcel$export(module.exports, "GET_STARTED_LIST_TASK", () => $3913ca223572f8d7$export$7a2fcaad1564e6b7);
$parcel$export(module.exports, "JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK", () => $3913ca223572f8d7$export$99b0e09ff6f00490);
$parcel$export(module.exports, "JSM_REVIEW_YOUR_CHANNELS_TASK", () => $3913ca223572f8d7$export$2a82344eb273eeff);
$parcel$export(module.exports, "JSM_INVITE_YOUR_TEAM_TASK", () => $3913ca223572f8d7$export$1de5766b7e640d6b);
$parcel$export(module.exports, "DEVOPS_WELCOME_TO_YOUR_PROJECT_TASK", () => $3913ca223572f8d7$export$8ab0859f5b30b013);
$parcel$export(module.exports, "DEVOPS_GET_TO_KNOW_JIRA_TASK", () => $3913ca223572f8d7$export$d1f6d18c6698104c);
$parcel$export(module.exports, "DEVOPS_NAVIGATE_YOUR_TOOLS_TASK", () => $3913ca223572f8d7$export$e6ee159eee7adc1c);
$parcel$export(module.exports, "DEVOPS_CAPTURE_INTEGRATIONS_TASK", () => $3913ca223572f8d7$export$dd267ca1e3cd3bad);
$parcel$export(module.exports, "DEVOPS_CREATE_AUTOMATION_RULES_TASK", () => $3913ca223572f8d7$export$f14c8bffc35200d3);
$parcel$export(module.exports, "DEVOPS_INVITE_TEAMMATES_TASK", () => $3913ca223572f8d7$export$36cc22c9997d92a);
$parcel$export(module.exports, "DEVOPS_FIND_HELP_TASK", () => $3913ca223572f8d7$export$d651cc94a46ff383);
$parcel$export(module.exports, "KEY_HAS_NAVIGATED_FROM_LINK", () => $3913ca223572f8d7$export$11c0696d49e68c93);
$parcel$export(module.exports, "ACCOUNT_ID", () => $3913ca223572f8d7$export$c8ab6996f562d0db);
$parcel$export(module.exports, "KANBAN_ONBOARDING_TASK", () => $3913ca223572f8d7$export$2b5f951ad8e70cfe);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS", () => $3913ca223572f8d7$export$5703447487aaccdf);
$parcel$export(module.exports, "BACKLOG_CREATE_SPRINT_NUDGE_ID", () => $3913ca223572f8d7$export$e0197e09cccd4e50);
$parcel$export(module.exports, "PROJECT_SETTING_PAGES", () => $3913ca223572f8d7$export$f779bbfe667acddc);
$parcel$export(module.exports, "JSM_BUSINESS_TASKS", () => $3913ca223572f8d7$export$38fbac7a5bf4aa33);
$parcel$export(module.exports, "JWM_BOARD_TASK", () => $3913ca223572f8d7$export$42a8341e3c94a2be);
$parcel$export(module.exports, "JWM_SUMMARY_TASK", () => $3913ca223572f8d7$export$e29c6a916affb308);
$parcel$export(module.exports, "JWM_INVITE_TEAM_TASK", () => $3913ca223572f8d7$export$bc193be3ff1dd519);
$parcel$export(module.exports, "JWM_PAGES_TASK", () => $3913ca223572f8d7$export$73a289f194001f88);

var $exb0h = parcelRequire("exb0h");

var $6vrw7 = parcelRequire("6vrw7");
const $3913ca223572f8d7$var$completeJwmTaskName = (taskId)=>`jwm-onboarding-checklist.${taskId}`;
const $3913ca223572f8d7$var$completeJswTaskName = (taskId)=>`jsw-onboarding-checklist.${taskId}`;
const $3913ca223572f8d7$var$completeJsmTaskName = (taskId)=>`jsm-onboarding-checklist.${taskId}`;
const $3913ca223572f8d7$var$completeDevopsTaskName = (taskId)=>`devops-onboarding-checklist.${taskId}`;
const $3913ca223572f8d7$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingQuickstart';
const $3913ca223572f8d7$export$2b3151a089bc8780 = 'jlove-makkuro';
const $3913ca223572f8d7$export$6826d33e9a2c0119 = 320;
const $3913ca223572f8d7$export$b580da85daad7757 = 'root';
const $3913ca223572f8d7$export$5eef19b26a4bbe70 = 'reverseTrialRoot';
const $3913ca223572f8d7$export$c57d251ae83aff51 = {
    JSM_BUSINESS_QUICKSTART_KEY: 'jsm-business-checklist',
    OLD_GLOBAL_QUICKSTART_KEY: 'jsw-onboarding-checklist'
};
const $3913ca223572f8d7$export$d9df7fd23ab00c49 = (type)=>`${type}.visibility`;
const $3913ca223572f8d7$export$93a67c1026e8cb7c = 'jsw-onboarding-checklist.open';
const $3913ca223572f8d7$export$a7dcb0b5013e932b = 'jsw-onboarding-checklist.dismissed';
const $3913ca223572f8d7$export$f962b14e410d598f = 'jsw-onboarding-checklist.task-group';
const $3913ca223572f8d7$export$21e8355b28449456 = 'jsw-onboarding-checklist.open-task';
const $3913ca223572f8d7$export$536a90031123e004 = 'jsw-onboarding-checklist.has-ever-seen-route';
const $3913ca223572f8d7$export$3ccd291a1a3a4f6d = 'jsw-onboarding-checklist.reopened-on-premium-trial';
const $3913ca223572f8d7$export$e5b557e3bbb7ec52 = 'isDevopsProject';
const $3913ca223572f8d7$export$9957974f8b4d8f74 = 'nuxOnboardingQuickstart';
const $3913ca223572f8d7$export$83c8d7110915321e = 'nuxOnboardingQuickstart';
const $3913ca223572f8d7$export$8b9bd2a9275b0187 = 'jsw.onboarding';
const $3913ca223572f8d7$export$ec43e7bf5973b10f = (taskId)=>`${taskId}.have-seenit`;
const $3913ca223572f8d7$export$cbeb719208f32c8a = $3913ca223572f8d7$var$completeJswTaskName('add-columns-task');
const $3913ca223572f8d7$export$88c918f2cfaff86 = $3913ca223572f8d7$var$completeJswTaskName('create-project-task');
const $3913ca223572f8d7$export$abbbea7c37c93cb5 = $3913ca223572f8d7$var$completeJswTaskName('create-issue-task');
const $3913ca223572f8d7$export$2a0253cb20f48a8 = $3913ca223572f8d7$var$completeJswTaskName('create-issue-task-simplified');
const $3913ca223572f8d7$export$f97428bb4b1991ec = $3913ca223572f8d7$var$completeJswTaskName('invite-teammates-task');
const $3913ca223572f8d7$export$45eaf4204fcc7 = $3913ca223572f8d7$var$completeJswTaskName('invite-teammates-video-task');
const $3913ca223572f8d7$export$af57685e201438e8 = $3913ca223572f8d7$var$completeJswTaskName('capture-integrations-task');
const $3913ca223572f8d7$export$d6c67e9aab4e2b26 = $3913ca223572f8d7$var$completeJswTaskName('find-help-task');
const $3913ca223572f8d7$export$3de8c242d2b82f26 = $3913ca223572f8d7$var$completeJswTaskName('set-up-board-task');
const $3913ca223572f8d7$export$a01fa44f793dbfac = $3913ca223572f8d7$var$completeJswTaskName('get-mobile-app-task');
const $3913ca223572f8d7$export$6a4507e462fd41da = $3913ca223572f8d7$var$completeJswTaskName('map-out-your-project-goals');
const $3913ca223572f8d7$export$e64c1dced6ac4458 = $3913ca223572f8d7$var$completeJswTaskName('identify-small-chunks-of-work');
const $3913ca223572f8d7$export$63b0e55f9c6454ac = $3913ca223572f8d7$var$completeJswTaskName('identify-small-chunks-of-work-kanban');
const $3913ca223572f8d7$export$c1effb1c8979fe22 = $3913ca223572f8d7$var$completeJswTaskName('monitor-manage-risk');
const $3913ca223572f8d7$export$d97d31d934dbb194 = $3913ca223572f8d7$var$completeJswTaskName('premium-reverse-trial-task');
const $3913ca223572f8d7$export$cafb5bd13b02056b = $3913ca223572f8d7$var$completeJswTaskName('premium-edition-overview-task');
const $3913ca223572f8d7$export$e55c18b809946e72 = $3913ca223572f8d7$var$completeJswTaskName('premium-edition-overview-task-non-admin');
const $3913ca223572f8d7$export$de5640b9ae8140a7 = $3913ca223572f8d7$var$completeJswTaskName('standard-edition-overview-task');
const $3913ca223572f8d7$export$540b5c3c4b6ce459 = $3913ca223572f8d7$var$completeJswTaskName('advanced-roadmaps-task');
const $3913ca223572f8d7$export$6f71dff531ff592 = $3913ca223572f8d7$var$completeJswTaskName('change-control-task');
const $3913ca223572f8d7$export$83255ab79e45f34f = $3913ca223572f8d7$var$completeJswTaskName('automations-task');
const $3913ca223572f8d7$export$b57d172af9ad7647 = $3913ca223572f8d7$var$completeJswTaskName('site-administrations-task');
const $3913ca223572f8d7$export$ff4c933c1fe90b68 = $3913ca223572f8d7$var$completeJswTaskName('user-management-task');
const $3913ca223572f8d7$export$3e2776d61f3662dc = $3913ca223572f8d7$var$completeJswTaskName('scrum-onboarding-task');
const $3913ca223572f8d7$export$9048315f2c03fd9d = $3913ca223572f8d7$var$completeJswTaskName('customize-site-name-task');
const $3913ca223572f8d7$export$a333714599f14a6 = $3913ca223572f8d7$var$completeJswTaskName('get-to-know-your-template-task');
const $3913ca223572f8d7$export$4145c2cec2da6f9b = $3913ca223572f8d7$var$completeJswTaskName('create-business-project-from-jsw-quickstart-task');
const $3913ca223572f8d7$export$4957a1ad203cf6dd = $3913ca223572f8d7$var$completeJswTaskName('try-atlassian-university-task');
const $3913ca223572f8d7$export$190b5dd0a1322552 = $3913ca223572f8d7$var$completeJswTaskName('calendar-view-task');
const $3913ca223572f8d7$export$501166b25f254aab = $3913ca223572f8d7$var$completeJwmTaskName('jwm-project-summary-task');
const $3913ca223572f8d7$export$94ad6507a703f4eb = $3913ca223572f8d7$var$completeJwmTaskName('jwm-create-sample-project-task');
const $3913ca223572f8d7$export$6fbd9800a4c54752 = $3913ca223572f8d7$var$completeJwmTaskName('get-started-list-task'); // TODO: remove JWM_GET_STARTED_LIST_TASK and use GET_STARTED_LIST_TASK when clean up ff jwm.list-platformisation-m1
const $3913ca223572f8d7$export$be1c522400a1bd7c = $3913ca223572f8d7$var$completeJwmTaskName('background-color-task');
const $3913ca223572f8d7$export$2aa6e7b6e24a04f5 = $3913ca223572f8d7$var$completeJwmTaskName('calendar-task');
const $3913ca223572f8d7$export$f3b53199b07af2a1 = $3913ca223572f8d7$var$completeJwmTaskName('timeline-task');
const $3913ca223572f8d7$export$d37415ffddcf2142 = $3913ca223572f8d7$var$completeJwmTaskName('build-form-task');
const $3913ca223572f8d7$export$2ae00586da7cb606 = $3913ca223572f8d7$var$completeJwmTaskName('feedback-task');
const $3913ca223572f8d7$export$b86266e6594a97bb = $3913ca223572f8d7$var$completeJwmTaskName('feedback-sample-project-task');
const $3913ca223572f8d7$export$20bc3dc137ac1c38 = $3913ca223572f8d7$var$completeJwmTaskName('create-your-own-project-task');
const $3913ca223572f8d7$export$77071b77e2801b18 = $3913ca223572f8d7$var$completeJwmTaskName('jwm-create-project-task');
const $3913ca223572f8d7$export$9c89f946f05d884a = $3913ca223572f8d7$var$completeJwmTaskName('share-project-task');
const $3913ca223572f8d7$export$ce8b25442735839a = $3913ca223572f8d7$var$completeJwmTaskName('trello-crossflow-boards');
const $3913ca223572f8d7$export$31015cf4e430c94d = $3913ca223572f8d7$var$completeJwmTaskName('trello-crossflow-cards');
const $3913ca223572f8d7$export$b52a7c936684cfc5 = $3913ca223572f8d7$var$completeJwmTaskName('trello-crossflow-import');
const $3913ca223572f8d7$export$b5555f24061f9fb = $3913ca223572f8d7$var$completeJwmTaskName('summary-and-reports-task');
const $3913ca223572f8d7$export$ff25449f34b8abf = $3913ca223572f8d7$var$completeJwmTaskName('trello-crossflow-calendar-and-timeline');
const $3913ca223572f8d7$export$3380e677209260fe = $3913ca223572f8d7$var$completeJwmTaskName('trello-crossflow-key-differences');
const $3913ca223572f8d7$export$7a2fcaad1564e6b7 = $3913ca223572f8d7$var$completeJwmTaskName('get-started-list-task');
const $3913ca223572f8d7$export$99b0e09ff6f00490 = $3913ca223572f8d7$var$completeJsmTaskName('customize-your-request-types-task');
const $3913ca223572f8d7$export$2a82344eb273eeff = $3913ca223572f8d7$var$completeJsmTaskName('review-your-channels-task');
const $3913ca223572f8d7$export$1de5766b7e640d6b = $3913ca223572f8d7$var$completeJsmTaskName('invite-your-team-task');
const $3913ca223572f8d7$export$8ab0859f5b30b013 = $3913ca223572f8d7$var$completeDevopsTaskName('welcome-to-your-project-task');
const $3913ca223572f8d7$export$d1f6d18c6698104c = $3913ca223572f8d7$var$completeDevopsTaskName('get-to-know-jira-task');
const $3913ca223572f8d7$export$e6ee159eee7adc1c = $3913ca223572f8d7$var$completeDevopsTaskName('navigate-your-tools-task');
const $3913ca223572f8d7$export$dd267ca1e3cd3bad = $3913ca223572f8d7$var$completeDevopsTaskName('capture-integrations-task');
const $3913ca223572f8d7$export$f14c8bffc35200d3 = $3913ca223572f8d7$var$completeDevopsTaskName('create-automation-rules-task');
const $3913ca223572f8d7$export$36cc22c9997d92a = $3913ca223572f8d7$var$completeDevopsTaskName('invite-teammates-task');
const $3913ca223572f8d7$export$d651cc94a46ff383 = $3913ca223572f8d7$var$completeDevopsTaskName('find-help-task');
const $3913ca223572f8d7$export$11c0696d49e68c93 = 'jsw-onboarding-checklist.has.navigated.from.link';
const $3913ca223572f8d7$export$c8ab6996f562d0db = (0, $6vrw7.toAccountId)('accountId');
const $3913ca223572f8d7$export$2b5f951ad8e70cfe = $3913ca223572f8d7$var$completeJswTaskName('kanban-onboarding-task');
const $3913ca223572f8d7$export$5703447487aaccdf = {
    NOT_LOADED: 'NOT_LOADED',
    OPEN: 'OPEN',
    MINIMIZED: 'MINIMIZED',
    DISMISSED: 'DISMISSED'
};
const $3913ca223572f8d7$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $3913ca223572f8d7$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $3913ca223572f8d7$export$f779bbfe667acddc = [
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_PEOPLE,
    (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_SOFTWARE_ACCESS
];
const $3913ca223572f8d7$export$38fbac7a5bf4aa33 = [
    $3913ca223572f8d7$export$2a82344eb273eeff,
    $3913ca223572f8d7$export$99b0e09ff6f00490,
    $3913ca223572f8d7$export$1de5766b7e640d6b
];
const $3913ca223572f8d7$export$42a8341e3c94a2be = $3913ca223572f8d7$var$completeJwmTaskName('jwm-board-task');
const $3913ca223572f8d7$export$e29c6a916affb308 = $3913ca223572f8d7$var$completeJwmTaskName('jwm-summary-task');
const $3913ca223572f8d7$export$bc193be3ff1dd519 = $3913ca223572f8d7$var$completeJwmTaskName('jwm-invite-team-task');
const $3913ca223572f8d7$export$73a289f194001f88 = $3913ca223572f8d7$var$completeJwmTaskName('jwm-pages-task');

});

parcelRegister("c8ave", function(module, exports) {

$parcel$export(module.exports, "changeTaskGroupParent", () => (parcelRequire("ah9g7")).nextChangeTaskGroupParent);
$parcel$export(module.exports, "goBackToPreviousTaskGroup", () => (parcelRequire("ah9g7")).nextGoBackToPreviousTaskGroup);
$parcel$export(module.exports, "setIsOpen", () => (parcelRequire("3TtLb")).setIsOpen);
$parcel$export(module.exports, "refreshAppState", () => (parcelRequire("agwlB")).refreshAppState);
$parcel$export(module.exports, "setNudgeStep", () => (parcelRequire("aI5eR")).setNudgeStep);
$parcel$export(module.exports, "addMountedNudge", () => (parcelRequire("1jaP6")).addMountedNudge);
$parcel$export(module.exports, "removeMountedNudge", () => (parcelRequire("1jaP6")).removeMountedNudge);
$parcel$export(module.exports, "setShouldRenderComponent", () => (parcelRequire("lCKeP")).setShouldRenderComponent);
$parcel$export(module.exports, "setProjectState", () => (parcelRequire("9FTSc")).setProjectState);
$parcel$export(module.exports, "setHasNudgeActive", () => (parcelRequire("iq74h")).setHasNudgeActive);
$parcel$export(module.exports, "forceHideNudge", () => (parcelRequire("cKB0H")).forceHideNudge);
$parcel$export(module.exports, "setHasEverSeenRoute", () => (parcelRequire("8n1zQ")).setHasEverSeenRoute);
$parcel$export(module.exports, "setRoadmapIsCreateEnabled", () => (parcelRequire("ioWKV")).setRoadmapIsCreateEnabled);
$parcel$export(module.exports, "setRoadmapIsListEmpty", () => (parcelRequire("ioWKV")).setRoadmapIsListEmpty);
$parcel$export(module.exports, "openNextTask", () => (parcelRequire("P9NN5")).openNextTask);
$parcel$export(module.exports, "resetIsQuickstartLoaded", () => (parcelRequire("6GDwI")).resetIsQuickstartLoaded);
$parcel$export(module.exports, "nextMarkAsCompletedTask", () => (parcelRequire("g1Zgk")).nextMarkAsCompletedTask);
$parcel$export(module.exports, "nextSetChecklistItemSeen", () => (parcelRequire("dn2YB")).nextSetChecklistItemSeen);
$parcel$export(module.exports, "nextSetChecklistIsDismissed", () => (parcelRequire("jssF8")).nextSetChecklistIsDismissed);
$parcel$export(module.exports, "nextSetChecklistIsOpen", () => (parcelRequire("ahbtR")).nextSetChecklistIsOpen);
$parcel$export(module.exports, "nextOpenTask", () => (parcelRequire("gn07r")).nextOpenTask);
$parcel$export(module.exports, "nextAutoExpand", () => (parcelRequire("7I9OF")).nextAutoExpand);
$parcel$export(module.exports, "nextShouldShowNudgeAfterNavigation", () => (parcelRequire("cDYe7")).nextShouldShowNudgeAfterNavigation);
$parcel$export(module.exports, "nextGetTasks", () => (parcelRequire("kDmv4")).nextGetTasks);

var $ah9g7 = parcelRequire("ah9g7");

var $3TtLb = parcelRequire("3TtLb");

var $agwlB = parcelRequire("agwlB");

var $aI5eR = parcelRequire("aI5eR");

var $1jaP6 = parcelRequire("1jaP6");

var $lCKeP = parcelRequire("lCKeP");

var $9FTSc = parcelRequire("9FTSc");

var $iq74h = parcelRequire("iq74h");

var $cKB0H = parcelRequire("cKB0H");

var $8n1zQ = parcelRequire("8n1zQ");

var $ioWKV = parcelRequire("ioWKV");

var $P9NN5 = parcelRequire("P9NN5");

var $6GDwI = parcelRequire("6GDwI");

var $g1Zgk = parcelRequire("g1Zgk");

var $dn2YB = parcelRequire("dn2YB");

var $jssF8 = parcelRequire("jssF8");

var $ahbtR = parcelRequire("ahbtR");

var $gn07r = parcelRequire("gn07r");

var $7I9OF = parcelRequire("7I9OF");

var $cDYe7 = parcelRequire("cDYe7");

var $kDmv4 = parcelRequire("kDmv4");

});
parcelRegister("ah9g7", function(module, exports) {

$parcel$export(module.exports, "nextChangeTaskGroupParent", () => $2484e60819053729$export$76708cce5888039a);
$parcel$export(module.exports, "nextGoBackToPreviousTaskGroup", () => $2484e60819053729$export$57534cbc400a434c);

var $7dRgX = parcelRequire("7dRgX");

var $8ppHd = parcelRequire("8ppHd");
const $2484e60819053729$var$setTaskGroup = (taskGroup)=>({ setState: setState })=>{
        setState({
            ...taskGroup,
            openTask: ''
        });
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.KEY_TASK_GROUP),
            value: {
                taskGroup: taskGroup
            }
        });
    };
const $2484e60819053729$export$76708cce5888039a = (newCurrentTaskGroupParent)=>({ getState: getState, dispatch: dispatch })=>{
        const { previousTaskGroupParents: previousTaskGroupParents, currentTaskGroupParent: currentTaskGroupParent } = getState();
        if (previousTaskGroupParents.includes(newCurrentTaskGroupParent)) // prevent infinite loop nesting
        return;
        previousTaskGroupParents.push(currentTaskGroupParent);
        const taskGroup = {
            previousTaskGroupParents: previousTaskGroupParents,
            currentTaskGroupParent: newCurrentTaskGroupParent
        };
        dispatch($2484e60819053729$var$setTaskGroup(taskGroup));
    };
const $2484e60819053729$export$57534cbc400a434c = ()=>({ dispatch: dispatch, getState: getState })=>{
        const { previousTaskGroupParents: previousTaskGroupParents } = getState();
        const newTaskGroupParent = previousTaskGroupParents.length === 0 ? (0, $7dRgX.ROOT_TASK) : previousTaskGroupParents.pop();
        const taskGroup = {
            previousTaskGroupParents: previousTaskGroupParents,
            currentTaskGroupParent: newTaskGroupParent
        };
        // @ts-expect-error - TS2345 - Argument of type '{ previousTaskGroupParents: string[]; currentTaskGroupParent: string | undefined; }' is not assignable to parameter of type 'TaskGroup'.
        dispatch($2484e60819053729$var$setTaskGroup(taskGroup));
    };

});
parcelRegister("8ppHd", function(module, exports) {

$parcel$export(module.exports, "pushToBackend", () => $1733f663faa18bb1$export$583b2d2422a6757f);

var $48bs8 = parcelRequire("48bs8");

var $e91YZ = parcelRequire("e91YZ");

var $guiFP = parcelRequire("guiFP");

var $7EhAs = parcelRequire("7EhAs");

var $6vrw7 = parcelRequire("6vrw7");
const $1733f663faa18bb1$var$getAccountId = ()=>{
    const { atlassianAccountId: atlassianAccountId } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    if (atlassianAccountId === null) throw new Error('Atlassian Account Id is empty');
    return atlassianAccountId;
};
const $1733f663faa18bb1$var$setRemoteUserProperties = async ({ key: key, value: value })=>(0, $48bs8.setUserProperties)((0, $6vrw7.toBaseUrl)(''), $1733f663faa18bb1$var$getAccountId(), key, JSON.stringify(value)).then((response)=>{
        if (!response.ok) throw new (0, $7EhAs.default)(response.status, response.statusText);
    });
const $1733f663faa18bb1$var$trySetUserProperties = async (props, attemptCount)=>{
    try {
        await $1733f663faa18bb1$var$setRemoteUserProperties(props);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'pushToBackend',
                packageName: 'jiraOnboardingQuickstartCore',
                teamName: 'jlove-makkuro'
            },
            attributes: {
                action: 'pushToBackend',
                actionSubject: 'jiraOnboardingChecklistCore',
                attemptCount: attemptCount,
                key: props.key,
                reason: error && error.message
            },
            error: error
        });
        return false;
    }
    return true;
};
const $1733f663faa18bb1$export$583b2d2422a6757f = async (props)=>{
    const success = await $1733f663faa18bb1$var$trySetUserProperties(props, 1);
    if (!success) // On failure retry - if retry fails data is lost.
    await $1733f663faa18bb1$var$trySetUserProperties(props, 2);
};

});


parcelRegister("3TtLb", function(module, exports) {

$parcel$export(module.exports, "setIsOpen", () => $e2436d4b85647276$export$dcf23146e0a40195);

var $79xbN = parcelRequire("79xbN");

var $7dRgX = parcelRequire("7dRgX");

var $8ppHd = parcelRequire("8ppHd");

var $5OjXh = parcelRequire("5OjXh");
const $e2436d4b85647276$export$dcf23146e0a40195 = (isOpen)=>({ getState: getState, setState: setState })=>{
        if ((0, $79xbN.expValEquals)('jsm_business_quickstart', 'cohort', 'experiment')) {
            const state = getState();
            const quickstartType = (0, $5OjXh.getQuickstartTypeSelector)(state);
            const currentIsOpen = state.visibility[quickstartType] === (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN;
            if (isOpen === currentIsOpen) // if state has not been updated we just return
            return;
            const quickstartStatus = isOpen ? (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN : (0, $7dRgX.QUICKSTART_UI_STATUS).MINIMIZED;
            setState({
                visibility: {
                    ...state.visibility,
                    [quickstartType]: quickstartStatus
                }
            });
            (0, $8ppHd.pushToBackend)({
                key: (0, $7dRgX.getBackendVisibilityKey)(quickstartType),
                value: quickstartStatus
            });
            // Maintain backwards compatibility with old global quickstart in case we need to turn the feature off
            // Delete code below when cleaning up
            (0, $8ppHd.pushToBackend)({
                key: (0, $7dRgX.KEY_OPEN),
                value: isOpen
            });
            return;
        }
        /* Grab current state of is isOpen */ const { isOpen: currentIsOpen } = getState();
        if (isOpen === currentIsOpen) // if state has not been updated we just return
        return;
        setState({
            isOpen: isOpen
        });
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.KEY_OPEN),
            value: isOpen
        });
    };
var $e2436d4b85647276$export$2e2bcd8739ae039 = $e2436d4b85647276$export$dcf23146e0a40195;

});
parcelRegister("5OjXh", function(module, exports) {

$parcel$export(module.exports, "getQuickstartTypeSelector", () => $6278fa6778740945$export$eae834ce0286017a);

var $7ZZxN = parcelRequire("7ZZxN");

var $7dRgX = parcelRequire("7dRgX");
const $6278fa6778740945$export$6f17f2cb816105eb = (state)=>state.projectState?.projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT);
const $6278fa6778740945$export$eae834ce0286017a = (state)=>{
    if ($6278fa6778740945$export$6f17f2cb816105eb(state)) return (0, $7dRgX.QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY;
    return (0, $7dRgX.QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY;
};

});


parcelRegister("agwlB", function(module, exports) {

$parcel$export(module.exports, "refreshAppState", () => $8d23b98670e25122$export$797c35e2e1d0d014);

var $7ZZxN = parcelRequire("7ZZxN");

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");

var $9z6Oy = parcelRequire("9z6Oy");


var $jRj3P = parcelRequire("jRj3P");

var $jMP2a = parcelRequire("jMP2a");

var $4sxuP = parcelRequire("4sxuP");

var $6WXNs = parcelRequire("6WXNs");

var $7dRgX = parcelRequire("7dRgX");

var $6kCnW = parcelRequire("6kCnW");
var $8ppHd = parcelRequire("8ppHd");

var $hFK9U = parcelRequire("hFK9U");

var $lIoQU = parcelRequire("lIoQU");

var $kL6gJ = parcelRequire("kL6gJ");

var $74z6M = parcelRequire("74z6M");

var $4vWp2 = parcelRequire("4vWp2");

var $9vuWT = parcelRequire("9vuWT");

var $jssF8 = parcelRequire("jssF8");

var $ahbtR = parcelRequire("ahbtR");

var $g1Zgk = parcelRequire("g1Zgk");

var $ah9g7 = parcelRequire("ah9g7");

var $fzDyP = parcelRequire("fzDyP");
// Right now we list all the available tasks manually.
const $8d23b98670e25122$var$allTasksExcludingJSMBusinessTasks = [
    (0, $7dRgX.CREATE_PROJECT_TASK),
    (0, $7dRgX.MAP_OUT_YOUR_PROJECT_GOALS_TASK),
    (0, $7dRgX.IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK),
    (0, $7dRgX.IDENTIFY_SMALL_CHUNKS_OF_WORK_KANBAN_TASK),
    (0, $7dRgX.MONITOR_MANAGE_RISK_TASK),
    (0, $7dRgX.ADD_COLUMNS_TASK),
    (0, $7dRgX.CREATE_ISSUE_TASK),
    (0, $7dRgX.CREATE_ISSUE_TASK_SIMPLIFIED),
    (0, $7dRgX.INVITE_TEAMMATES_TASK),
    (0, $7dRgX.FIND_HELP_TASK),
    (0, $7dRgX.SET_UP_BOARD_TASK),
    (0, $7dRgX.GET_MOBILE_APP_TASK),
    (0, $7dRgX.INVITE_TEAMMATES_VIDEO_TASK),
    (0, $7dRgX.CAPTURE_INTEGRATIONS_TASK),
    (0, $7dRgX.PREMIUM_REVERSE_TRIAL_TASK),
    (0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK),
    (0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN),
    (0, $7dRgX.STANDARD_EDITION_OVERVIEW_TASK),
    (0, $7dRgX.ADVANCED_ROADMAPS_TASK),
    (0, $7dRgX.CHANGE_CONTROL_TASK),
    (0, $7dRgX.AUTOMATIONS_TASK),
    (0, $7dRgX.SITE_ADMINISTRATIONS_TASK),
    (0, $7dRgX.USER_MANAGEMENT_TASK),
    (0, $7dRgX.JWM_CREATE_PROJECT_TASK),
    (0, $7dRgX.JWM_CREATE_SAMPLE_PROJECT_TASK),
    (0, $7dRgX.JWM_PROJECT_SUMMARY_TASK),
    (0, $7dRgX.JWM_GET_STARTED_LIST_TASK),
    (0, $7dRgX.JWM_BACKGROUND_COLOR_TASK),
    (0, $7dRgX.JWM_CALENDAR_TASK),
    (0, $7dRgX.JWM_TIMELINE_TASK),
    (0, $7dRgX.JWM_BUILD_FORM_TASK),
    (0, $7dRgX.JWM_FEEDBACK_TASK),
    (0, $7dRgX.JWM_SHARE_PROJECT_TASK),
    (0, $7dRgX.JWM_CREATE_YOUR_OWN_PROJECT_TASK),
    (0, $7dRgX.JWM_TRELLO_CROSSFLOW_TASK_IMPORT),
    (0, $7dRgX.JWM_SUMMARY_AND_REPORTS_TASK),
    (0, $7dRgX.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK),
    (0, $7dRgX.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES),
    (0, $7dRgX.JWM_FEEDBACK_SAMPLE_PROJECT_TASK),
    (0, $7dRgX.DEVOPS_WELCOME_TO_YOUR_PROJECT_TASK),
    (0, $7dRgX.DEVOPS_GET_TO_KNOW_JIRA_TASK),
    (0, $7dRgX.DEVOPS_NAVIGATE_YOUR_TOOLS_TASK),
    (0, $7dRgX.DEVOPS_CAPTURE_INTEGRATIONS_TASK),
    (0, $7dRgX.DEVOPS_CREATE_AUTOMATION_RULES_TASK),
    (0, $7dRgX.DEVOPS_INVITE_TEAMMATES_TASK),
    (0, $7dRgX.DEVOPS_FIND_HELP_TASK),
    (0, $7dRgX.SCRUM_ONBOARDING_TASK),
    (0, $7dRgX.KANBAN_ONBOARDING_TASK),
    (0, $7dRgX.CUSTOMIZE_SITE_NAME_TASK),
    (0, $7dRgX.GET_TO_KNOW_YOUR_TEMPLATE_TASK),
    (0, $7dRgX.CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK),
    (0, $7dRgX.TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK),
    (0, $7dRgX.GET_STARTED_LIST_TASK),
    (0, $7dRgX.JWM_BOARD_TASK),
    (0, $7dRgX.JWM_SUMMARY_TASK),
    (0, $7dRgX.JWM_INVITE_TEAM_TASK),
    (0, $7dRgX.JWM_PAGES_TASK),
    (0, $7dRgX.CALENDAR_VIEW_TASK)
];
const $8d23b98670e25122$var$allTasks = [
    ...$8d23b98670e25122$var$allTasksExcludingJSMBusinessTasks,
    ...(0, $7dRgX.JSM_BUSINESS_TASKS)
];
const $8d23b98670e25122$export$797c35e2e1d0d014 = ({ atlassianAccountId: atlassianAccountId, cloudId: cloudId, appEditions: appEditions, isAdmin: isAdmin, canEditPlans: canEditPlans, isAdvancedRoadmapsTrial: isAdvancedRoadmapsTrial, isTargetedForReverseTrials: isTargetedForReverseTrials, createAnalyticsEvent: createAnalyticsEvent, projectType: projectType })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        // Need to check to see if there is anything in the backend to take that as source of truth
        // If there is nothing then use defaults
        // Check backend for flags that are marked as completed (true)
        // Carry over state from previous actions
        // Create Completed Actions
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedState = {};
        const hasSeenTasks = [
            (0, $7dRgX.convertToHaveSeenItTask)((0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK)),
            (0, $7dRgX.convertToHaveSeenItTask)((0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)),
            (0, $7dRgX.convertToHaveSeenItTask)((0, $7dRgX.STANDARD_EDITION_OVERVIEW_TASK))
        ];
        const { projectState: projectState = null } = getState();
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.isOpen = true;
        updatedState.isDismissed = false;
        let backendVisibilityKeys = [];
        let jsmTaskProjectKeys = [];
        if ((0, $79xbN.expValEquals)('jsm_business_quickstart', 'cohort', 'experiment')) {
            // Open QS Checklist as default state if state cannot be determined from the backend
            updatedState.visibility = Object.values((0, $7dRgX.QUICKSTART_TYPE)).reduce((acc, type)=>{
                acc[type] = (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN;
                return acc;
            }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            {});
            backendVisibilityKeys = Object.values((0, $7dRgX.QUICKSTART_TYPE)).map((type)=>(0, $7dRgX.getBackendVisibilityKey)(type));
            if (projectState?.projectId) jsmTaskProjectKeys = (0, $7dRgX.JSM_BUSINESS_TASKS).map((task)=>`${task}.${projectState?.projectId}`);
        }
        const backendState = await (0, $6kCnW.pollBackend)({
            keys: [
                (0, $7dRgX.KEY_OPEN),
                (0, $7dRgX.KEY_DISMISSED),
                (0, $7dRgX.KEY_OPEN_TASK),
                (0, $7dRgX.KEY_TASK_GROUP),
                (0, $7dRgX.KEY_HAS_EVER_SEEN_ROUTE),
                (0, $7dRgX.KEY_JSW_ONBOARDING),
                (0, $7dRgX.KEY_PREMIUM_TRIAL_REOPENED),
                ...$8d23b98670e25122$var$allTasks,
                ...hasSeenTasks,
                ...backendVisibilityKeys,
                ...jsmTaskProjectKeys
            ]
        });
        if (projectState && projectState.projectKey) updatedState.isDevOpsProject = await (0, $74z6M.getIsDevOpsProject)(projectState.projectKey);
        const backendStateExists = backendState !== undefined && Object.keys(backendState).length > 0;
        if (backendStateExists) {
            updatedState.completedTaskList = (0, $79xbN.expValEquals)('jsm_business_quickstart', 'cohort', 'experiment') ? Object.keys(backendState).filter((key)=>[
                    ...$8d23b98670e25122$var$allTasksExcludingJSMBusinessTasks,
                    ...jsmTaskProjectKeys
                ].includes(key) && backendState[key] === true) : Object.keys(backendState).filter((key)=>$8d23b98670e25122$var$allTasks.includes(key) && backendState[key] === true);
            updatedState.hasSeenTasks = hasSeenTasks.filter((key)=>backendState[key] === true);
            if ((0, $79xbN.expValEquals)('jsm_business_quickstart', 'cohort', 'experiment')) Object.values((0, $7dRgX.QUICKSTART_TYPE)).forEach((type)=>{
                // use new state if possible
                if ((0, $7dRgX.getBackendVisibilityKey)(type) in backendState) updatedState.visibility[type] = backendState[(0, $7dRgX.getBackendVisibilityKey)(type)];
                else if ((0, $7dRgX.KEY_DISMISSED) in backendState && backendState[0, $7dRgX.KEY_DISMISSED]) updatedState.visibility[type] = (0, $7dRgX.QUICKSTART_UI_STATUS).DISMISSED;
                else if ((0, $7dRgX.KEY_OPEN) in backendState) updatedState.visibility[type] = backendState[0, $7dRgX.KEY_OPEN] ? (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN : (0, $7dRgX.QUICKSTART_UI_STATUS).MINIMIZED;
            });
            if ((0, $7dRgX.KEY_DISMISSED) in backendState) updatedState.isDismissed = backendState[0, $7dRgX.KEY_DISMISSED];
            if ((0, $7dRgX.KEY_OPEN) in backendState) updatedState.isOpen = backendState[0, $7dRgX.KEY_OPEN];
            if ((0, $7dRgX.KEY_OPEN_TASK) in backendState) updatedState.openTask = backendState[0, $7dRgX.KEY_OPEN_TASK];
            if ((0, $7dRgX.KEY_HAS_EVER_SEEN_ROUTE) in backendState) updatedState.hasEverSeenRoute = backendState[0, $7dRgX.KEY_HAS_EVER_SEEN_ROUTE];
            if ((0, $7dRgX.KEY_TASK_GROUP) in backendState) {
                updatedState.currentTaskGroupParent = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $7dRgX.KEY_TASK_GROUP].taskGroup.currentTaskGroupParent;
                updatedState.previousTaskGroupParents = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $7dRgX.KEY_TASK_GROUP].taskGroup.previousTaskGroupParents;
            }
            if ((0, $7dRgX.KEY_JSW_ONBOARDING) in backendState) {
                if (typeof backendState[0, $7dRgX.KEY_JSW_ONBOARDING] === 'object' && backendState[0, $7dRgX.KEY_JSW_ONBOARDING] !== null && (0, $8379f5d78bf6fb5a$export$8a00ecf6498ee2fe) in backendState[0, $7dRgX.KEY_JSW_ONBOARDING]) updatedState.selectedProjectTemplateKeyFromOnboarding = backendState[0, $7dRgX.KEY_JSW_ONBOARDING][0, $8379f5d78bf6fb5a$export$8a00ecf6498ee2fe];
            }
        }
        if (atlassianAccountId && projectType === (0, $7ZZxN.CORE_PROJECT) && (0, $hFK9U.isUserEnrolledInTailoredOnboardingExperiment)()) try {
            const userTraits = await (0, $jRj3P.memoizedFetchSiteUserPersonalization)({
                cloudId: cloudId,
                userId: atlassianAccountId
            });
            const userTraitsPersona = userTraits?.find((trait)=>trait.name === (0, $4vWp2.PERSONA_TRAIT_NAME));
            const personaExperience = (0, $fzDyP.mapPersonaTraitsToExperience)(userTraitsPersona);
            const analyticsEvent = createAnalyticsEvent({});
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'refreshAppState settingPersonaExperienceFromTraits', {
                personaExperience: personaExperience,
                persona: userTraitsPersona?.value,
                tailoredOnboardingExperiment1: (0, $hFK9U.getTailoredOnboardingExperimentCohort)()
            });
            if (personaExperience) updatedState.personaExperience = personaExperience;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $lIoQU.fireAPIErrorAnalytics)(error, 'fetchSiteUserPersonalization');
        }
        // Important that this call is before the dismiss migration logic and the premium card permission migration, otherwise it would
        // override the dismiss and currentTaskGroupParent
        setState(updatedState);
        // Bit of a migration
        // Handles case where non-admin premium users have a premium card child open which they can no longer access as we added more permission checks
        // Or, if a user was on a premium trial and saw premium content but is now free,
        // We take them to the root instead
        if ((updatedState.currentTaskGroupParent === (0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN) || updatedState.currentTaskGroupParent === (0, $7dRgX.PREMIUM_REVERSE_TRIAL_TASK)) && !canEditPlans || (updatedState.currentTaskGroupParent === (0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK) || updatedState.currentTaskGroupParent === (0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN) || updatedState.currentTaskGroupParent === (0, $7dRgX.PREMIUM_REVERSE_TRIAL_TASK)) && appEditions.software !== (0, $6WXNs.PREMIUM_EDITION)) {
            dispatch((0, $ah9g7.nextGoBackToPreviousTaskGroup)());
            const analyticsEvent = createAnalyticsEvent({});
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'refreshAppState premiumCardPermissionsRevoked');
        }
        if (!(backendStateExists && (0, $7dRgX.KEY_OPEN) in backendState)) try {
            const skipApplicationProperty = await (0, $9vuWT.getOnboardingSkipApplicationProperty)();
            if (skipApplicationProperty.quickstart) dispatch((0, $jssF8.nextSetChecklistIsDismissed)(true));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $lIoQU.fireAPIErrorAnalytics)(error, 'skipOnboarding');
        }
        const jswTrackDeferSitenameSiteTrait = await (0, $9z6Oy.getJswTrackDeferSitenameSiteTrait)(cloudId, {
            packageName: (0, $7dRgX.PACKAGE_NAME),
            teamName: (0, $7dRgX.PACKAGE_TEAM_NAME)
        });
        setState({
            isEligibleToUpdateSitename: jswTrackDeferSitenameSiteTrait?.value === 'experiment-generated-site-name'
        });
        const setPremiumCardAudienceTrait = async (accountId)=>{
            if (accountId === null) return;
            const trait = await (0, $kL6gJ.getCrossProjectBoardTrait)(createAnalyticsEvent, cloudId, accountId);
            setState({
                isCrossProjectBoardToPlanUpsell: trait?.value === true || false
            });
        };
        // We only want to check if a non-admin user has the CPB trait if they are in a
        // premium evaluation of jira software (i.e. they have access to Advanced Roadmaps)
        if (appEditions.software === (0, $6WXNs.PREMIUM_EDITION) && !isAdmin) await setPremiumCardAudienceTrait(atlassianAccountId);
        const { isCrossProjectBoardToPlanUpsell: isCrossProjectBoardToPlanUpsell } = getState();
        // If the user is on a JSW Premium instance, perform a fetch to check that they signed up with a Premium Reverse Trial.
        let isReverseTrialForJSW;
        if (isTargetedForReverseTrials && (0, $eI5EY.fg)('jsw_reverse_trials_feature_gate')) {
            const isOnboardingPremiumTrial = await (0, $4sxuP.getOnboardingPremiumTrial)();
            isReverseTrialForJSW = isOnboardingPremiumTrial?.premiumTrialOnSignup;
        }
        /**
		 * Re-open QS for:
		 *  - admins on an AdvancedRoadmaps trial who haven't had it re-opened for them yet
		 *  - non-admins on an AdvancedRoadmaps trial with isCrossProjectBoardToPlanUpsell trait
		 */ // eslint-disable-next-line jira/ff/unsafe-no-exposure
        const [simplifyKanbanQsExpConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_simplify_kanban_qs');
        // eslint-disable-next-line jira/ff/unsafe-no-exposure
        const [disableAutoNudgeTour] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_disable_auto_nudge_tours');
        // eslint-disable-next-line jira/ff/unsafe-no-exposure
        const [simplifyKanbanQsForAllExpConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_simplify_kanban_qs_all_users');
        const shouldSimplifyKanbanQs = simplifyKanbanQsForAllExpConfig.get('isEnabled', false) || disableAutoNudgeTour.get('isDisabled', false) && simplifyKanbanQsExpConfig.get('cohort', 'not-enrolled') === 'variation';
        if (!shouldSimplifyKanbanQs && !isReverseTrialForJSW && appEditions.software === (0, $6WXNs.PREMIUM_EDITION) && isAdvancedRoadmapsTrial && (isAdmin || isCrossProjectBoardToPlanUpsell) && atlassianAccountId != null && !backendState[0, $7dRgX.KEY_PREMIUM_TRIAL_REOPENED]) {
            // Re-open QS if not already opened
            dispatch((0, $ahbtR.nextSetChecklistIsOpen)(true));
            dispatch((0, $jssF8.nextSetChecklistIsDismissed)(false));
            const taskToDispatch = isAdmin ? (0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK) : (0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN);
            // Go to advanced roadmaps task
            dispatch((0, $g1Zgk.nextMarkAsCompletedTask)(taskToDispatch));
            dispatch((0, $ah9g7.nextChangeTaskGroupParent)(taskToDispatch));
            await (0, $8ppHd.pushToBackend)({
                key: (0, $7dRgX.KEY_PREMIUM_TRIAL_REOPENED),
                value: true
            });
            const analyticsEvent = createAnalyticsEvent({});
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'advancedRoadmapsTask reopened', {
                isAdmin: isAdmin
            });
        }
        setState({
            canEditPlans: canEditPlans
        });
        setState({
            isQuickstartLoaded: true
        });
    };

});
parcelRegister("9z6Oy", function(module, exports) {

$parcel$export(module.exports, "getSignupTrackDeferSitenameUserTrait", () => $d04aec276ef38a16$export$686752df505238be);
$parcel$export(module.exports, "getJswTrackDeferSitenameSiteTrait", () => $d04aec276ef38a16$export$6da79f996c267010);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $d04aec276ef38a16$var$PERSONALIZATION_ENDPOINT = '/gateway/api/tap-delivery/api/v3/personalization';
const $d04aec276ef38a16$var$SITE_PERSONALIZATION_ENDPOINT = `${$d04aec276ef38a16$var$PERSONALIZATION_ENDPOINT}/site/`;
const $d04aec276ef38a16$var$USER_PERSONALIZATION_ENDPOINT = `${$d04aec276ef38a16$var$PERSONALIZATION_ENDPOINT}/user/`;
const $d04aec276ef38a16$var$SIGNUP_TRACK_DEFER_SITENAME_USER_TRAIT = 'marketing-signup_track_deferred-sitename_signup_server_enrollment';
const $d04aec276ef38a16$var$JSW_TRACK_DEFER_SITENAME_TRAIT = 'jira_track_instance_created_server_defer_site_rename_cohort';
const $d04aec276ef38a16$var$fetchPersonalization = (endpoint, subject)=>async (id, meta)=>{
        try {
            const url = endpoint + id;
            return await (0, $lRmyA.performGetRequest)(url);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'onboarding',
                    teamName: 'jlove-makkuro',
                    ...meta
                },
                attributes: {
                    subject: subject
                },
                error: error
            });
            return undefined;
        }
    };
const $d04aec276ef38a16$var$getTraits = (fetch, traitName)=>async (id, meta)=>{
        const personalization = await fetch(id, meta);
        return personalization?.attributes.find((att)=>att.name === traitName);
    };
const $d04aec276ef38a16$export$686752df505238be = $d04aec276ef38a16$var$getTraits($d04aec276ef38a16$var$fetchPersonalization($d04aec276ef38a16$var$USER_PERSONALIZATION_ENDPOINT, 'fetchUserPersonalization'), $d04aec276ef38a16$var$SIGNUP_TRACK_DEFER_SITENAME_USER_TRAIT);
const $d04aec276ef38a16$export$6da79f996c267010 = $d04aec276ef38a16$var$getTraits($d04aec276ef38a16$var$fetchPersonalization($d04aec276ef38a16$var$SITE_PERSONALIZATION_ENDPOINT, 'fetchSitePersonalization'), $d04aec276ef38a16$var$JSW_TRACK_DEFER_SITENAME_TRAIT);

});

// Session storage constants used between going through initial onboarding screens
// and landing in JIRA
// Note this key used to be 'should-show-scrum-modal' but was changed to prevent a bug where experienced users
// Could see the modal if they were previously enrolled into ISO
const $8379f5d78bf6fb5a$export$67abe0a3b8dfe03f = 'should-show-scrum-modal-v2';
const $8379f5d78bf6fb5a$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $8379f5d78bf6fb5a$export$e3884212029f7bef = 'should-show-welcome-modal';
const $8379f5d78bf6fb5a$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $8379f5d78bf6fb5a$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $8379f5d78bf6fb5a$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $8379f5d78bf6fb5a$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $8379f5d78bf6fb5a$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $8379f5d78bf6fb5a$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $8379f5d78bf6fb5a$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $8379f5d78bf6fb5a$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $8379f5d78bf6fb5a$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $8379f5d78bf6fb5a$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $8379f5d78bf6fb5a$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $8379f5d78bf6fb5a$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $8379f5d78bf6fb5a$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $8379f5d78bf6fb5a$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $8379f5d78bf6fb5a$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $8379f5d78bf6fb5a$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $8379f5d78bf6fb5a$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $8379f5d78bf6fb5a$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $8379f5d78bf6fb5a$export$468488291ccd988 = 'timelineAddItemNudge';
const $8379f5d78bf6fb5a$export$7a33548109ac931d = 'createFormNudge';
const $8379f5d78bf6fb5a$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $8379f5d78bf6fb5a$export$594d3436316492be = 'summaryViewNudge';
const $8379f5d78bf6fb5a$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $8379f5d78bf6fb5a$export$73278890f736ee6f = 'manageProjectsNudge';

parcelRegister("jRj3P", function(module, exports) {

$parcel$export(module.exports, "memoizedFetchSiteUserPersonalization", () => $4441cad18cc93774$export$de93ec54b11be450);
$parcel$export(module.exports, "useSiteUserPersonalization", () => $4441cad18cc93774$export$8dc79ff315095801);

var $5iWql = parcelRequire("5iWql");

var $eEzyV = parcelRequire("eEzyV");

var $2OdyW = parcelRequire("2OdyW");
const $4441cad18cc93774$var$getPersonalizationSiteUserTraitsUrl = (cloudId, userId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`;
const $4441cad18cc93774$export$8f40704723ec6690 = async ({ cloudId: cloudId, userId: userId })=>{
    if (!cloudId) throw new Error('empty cloudId');
    if (!userId) throw new Error('empty userId');
    const { attributes: attributes } = await (0, $2OdyW.default)($4441cad18cc93774$var$getPersonalizationSiteUserTraitsUrl(cloudId, userId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-mau-ignore': 'true'
        }
    });
    return attributes;
};
const $4441cad18cc93774$export$de93ec54b11be450 = (0, $5iWql.default)($4441cad18cc93774$export$8f40704723ec6690, ([{ cloudId: newCloudId, userId: newUserId }], [{ cloudId: lastCloudId, userId: lastUserId }])=>newCloudId === lastCloudId && newUserId === lastUserId);
const $4441cad18cc93774$export$8dc79ff315095801 = ()=>(0, $eEzyV.useService)($4441cad18cc93774$export$de93ec54b11be450);

});
parcelRegister("eEzyV", function(module, exports) {

$parcel$export(module.exports, "useService", () => $cbb15d4da2e9ab10$export$6de4685a6c88b4e9);
$parcel$export(module.exports, "useLoadingStatusService", () => $cbb15d4da2e9ab10$export$c963713a27525aaf);

var $eUqFw = parcelRequire("eUqFw");
const $cbb15d4da2e9ab10$export$6de4685a6c88b4e9 = (request, initialState = {})=>{
    const [state, setState] = (0, $eUqFw.useState)({
        loading: false,
        data: undefined,
        error: undefined,
        ...initialState
    });
    const fetch = (0, $eUqFw.useCallback)(async (requestData)=>{
        setState({
            loading: true,
            error: undefined,
            data: undefined
        });
        try {
            const data = await request(requestData);
            setState({
                loading: false,
                error: undefined,
                data: data
            });
            return data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                loading: false,
                error: error,
                data: undefined
            });
            return undefined;
        }
    }, [
        request
    ]);
    return {
        ...state,
        fetch: fetch
    };
};
const $cbb15d4da2e9ab10$export$c963713a27525aaf = (request, initialState = {})=>{
    const [loadingStatus, setLoadingStatus] = (0, $eUqFw.useState)('idle');
    const { data: data, loading: loading, error: error, fetch: fetch } = $cbb15d4da2e9ab10$export$6de4685a6c88b4e9(request, initialState);
    (0, $eUqFw.useEffect)(()=>{
        if (loading) setLoadingStatus('started');
        else if (error) setLoadingStatus('error');
        else if (data) setLoadingStatus('success');
    }, [
        data,
        loading,
        error
    ]);
    return {
        data: data,
        loadingStatus: loadingStatus,
        error: error,
        fetch: fetch
    };
};

});


parcelRegister("4sxuP", function(module, exports) {

$parcel$export(module.exports, "getOnboardingPremiumTrialWithRethrow", () => $1907cbeebd30077d$export$d9a9dd6206da5bef);
$parcel$export(module.exports, "getOnboardingPremiumTrial", () => $1907cbeebd30077d$export$ef676f7f369f74fe);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $1lUvF = parcelRequire("1lUvF");
const $1907cbeebd30077d$var$endpoint = '/rest/onboarding/1.0/premium-trial';
const $1907cbeebd30077d$export$d9a9dd6206da5bef = async ()=>{
    try {
        // Attempt to get from localStorage
        const localStorageOnboardingPremiumTrial = (0, $1lUvF.localStorageGetOnboardingPremiumTrial)();
        const localStorageOnboardingPremiumTrialCohort = (0, $1lUvF.localStorageGetOnboardingPremiumTrialCohort)();
        if (typeof localStorageOnboardingPremiumTrial === 'boolean' && typeof localStorageOnboardingPremiumTrialCohort === 'string') return {
            premiumTrialOnSignup: localStorageOnboardingPremiumTrial,
            reverseTrialCohort: localStorageOnboardingPremiumTrialCohort
        };
        const response = await (0, $lRmyA.performGetRequestWithRetry)($1907cbeebd30077d$var$endpoint);
        const premiumTrialOnSignup = response?.premiumTrialOnSignup;
        const reverseTrialCohort = response?.reverseTrialCohort;
        if (typeof premiumTrialOnSignup === 'boolean' && typeof reverseTrialCohort === 'string') {
            // Set into localStorage
            (0, $1lUvF.localStorageSetOnboardingPremiumTrial)(premiumTrialOnSignup);
            (0, $1lUvF.localStorageSetOnboardingPremiumTrialCohort)(reverseTrialCohort);
            return {
                premiumTrialOnSignup: premiumTrialOnSignup,
                reverseTrialCohort: reverseTrialCohort
            };
        }
        throw new Error('response?.premiumTrialOnSignup or response?.reverseTrialCohort is undefined');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'getOnboardingPremiumTrialWithRethrow',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $1907cbeebd30077d$export$ef676f7f369f74fe = async ()=>{
    try {
        return await $1907cbeebd30077d$export$d9a9dd6206da5bef();
    } catch (e) {
    // ignored
    }
};

});
parcelRegister("1lUvF", function(module, exports) {

$parcel$export(module.exports, "localStorageGetOnboardingPremiumTrial", () => $d5d23c94342aad01$export$782df5489e5cfd1e);
$parcel$export(module.exports, "localStorageGetOnboardingPremiumTrialCohort", () => $d5d23c94342aad01$export$c3378895d06b5528);
$parcel$export(module.exports, "localStorageSetOnboardingPremiumTrial", () => $d5d23c94342aad01$export$f83a7a49524e74ad);
$parcel$export(module.exports, "localStorageSetOnboardingPremiumTrialCohort", () => $d5d23c94342aad01$export$f389f8ca168b4a3a);

var $aZaPn = parcelRequire("aZaPn");

var $guiFP = parcelRequire("guiFP");
const $d5d23c94342aad01$export$3538ee3f5c6c8b5c = 'premiumTrialOnSignup';
const $d5d23c94342aad01$export$2f93fdc3330233dc = 'reverseTrialCohort';
const $d5d23c94342aad01$var$localStorage = (0, $aZaPn.createLocalStorageProvider)('jsw-onboarding-premium-reverse-trial');
const $d5d23c94342aad01$export$782df5489e5cfd1e = ()=>{
    try {
        const value = $d5d23c94342aad01$var$localStorage.get($d5d23c94342aad01$export$3538ee3f5c6c8b5c);
        // localStorage.get is able to return proper booleans and not stringified booleans like "true"/"false"
        return value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'localStorageGetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        // note: unlike window.localStorage, the get method returns undefined instead of null. Thus this also returns undefined.
        return undefined;
    }
};
const $d5d23c94342aad01$export$c3378895d06b5528 = ()=>{
    try {
        const value = $d5d23c94342aad01$var$localStorage.get($d5d23c94342aad01$export$2f93fdc3330233dc);
        return value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'localStorageGetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        // note: unlike window.localStorage, the get method returns undefined instead of null. Thus this also returns undefined.
        return undefined;
    }
};
const $d5d23c94342aad01$export$f83a7a49524e74ad = (premiumTrialOnSignup)=>{
    try {
        $d5d23c94342aad01$var$localStorage.set($d5d23c94342aad01$export$3538ee3f5c6c8b5c, premiumTrialOnSignup);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'localStorageSetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};
const $d5d23c94342aad01$export$f389f8ca168b4a3a = (reverseTrialCohort)=>{
    try {
        $d5d23c94342aad01$var$localStorage.set($d5d23c94342aad01$export$2f93fdc3330233dc, reverseTrialCohort);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'localStorageSetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});


parcelRegister("6kCnW", function(module, exports) {

$parcel$export(module.exports, "pollBackend", () => $72b53773fb858e3c$export$8420ef0cee98de);

var $95f8K = parcelRequire("95f8K");

var $6vrw7 = parcelRequire("6vrw7");

var $7dRgX = parcelRequire("7dRgX");
const $72b53773fb858e3c$export$8420ef0cee98de = async ({ keys: keys })=>{
    const { user: user } = await (0, $95f8K.get)((0, $6vrw7.toBaseUrl)(''), {
        userProperties: keys,
        consumerMeta: {
            id: 'fetchUserProperties',
            packageName: (0, $7dRgX.PACKAGE_NAME),
            teamName: (0, $7dRgX.PACKAGE_TEAM_NAME)
        }
    });
    return user;
};

});
parcelRegister("95f8K", function(module, exports) {

$parcel$export(module.exports, "get", () => $4b3de6acfae5f7c4$export$3988ae62b71be9a3);

var $fUTZC = parcelRequire("fUTZC");

var $4vTMF = parcelRequire("4vTMF");

var $guiFP = parcelRequire("guiFP");

var $JRB5w = parcelRequire("JRB5w");
var $lRmyA = parcelRequire("lRmyA");

var $3FyZ4 = parcelRequire("3FyZ4");

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
let $4b3de6acfae5f7c4$var$ufoExperiencesMap = {};
const $4b3de6acfae5f7c4$var$getUfoExperience = (key)=>{
    if (!$4b3de6acfae5f7c4$var$ufoExperiencesMap[key]) $4b3de6acfae5f7c4$var$ufoExperiencesMap[key] = new (0, $kDfSL.UFOExperience)(key, {
        type: (0, $12kyE.ExperienceTypes).Operation,
        performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom
    });
    return $4b3de6acfae5f7c4$var$ufoExperiencesMap[key];
};
const $4b3de6acfae5f7c4$export$c907f169d33b2e25 = ()=>{
    $4b3de6acfae5f7c4$var$ufoExperiencesMap = {};
};
const $4b3de6acfae5f7c4$export$a5b7a8c3b1c6e775 = (baseUrl, { userProperties: userProperties, projectId: projectId, projectProperties: projectProperties, instanceProperties: instanceProperties })=>{
    const params = new URLSearchParams();
    userProperties && params.append('user', userProperties.join(','));
    projectId !== undefined && params.append('projectId', projectId);
    projectProperties && params.append('project', projectProperties.join(','));
    instanceProperties && params.append('instance', instanceProperties.join(','));
    return `/rest/internal/latest/frontendconfig/properties?${params.toString()}`;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4b3de6acfae5f7c4$var$patchProperties = (response, propertiesPath)=>(0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(response[propertiesPath], (value, prop)=>{
        try {
            response[propertiesPath][prop] = JSON.parse(value);
        } catch (error) {
            // TODO: Endpoint should ideally only return stringified values
            if (prop === 'initial.project.template.name') response[propertiesPath][prop] = value;
            else throw error;
        }
    });
const $4b3de6acfae5f7c4$export$3988ae62b71be9a3 = async (baseUrl, options)=>{
    const ufoExperience = $4b3de6acfae5f7c4$var$getUfoExperience(`${(0, (/*@__PURE__*/$parcel$interopDefault($4vTMF)))(options.consumerMeta.packageName)}.${(0, (/*@__PURE__*/$parcel$interopDefault($4vTMF)))(options.consumerMeta.id)}`);
    try {
        ufoExperience?.start();
        const url = $4b3de6acfae5f7c4$export$a5b7a8c3b1c6e775(baseUrl, options);
        const response = await (0, $lRmyA.performGetRequest)(url);
        $4b3de6acfae5f7c4$var$patchProperties(response, 'user');
        $4b3de6acfae5f7c4$var$patchProperties(response, 'instance');
        $4b3de6acfae5f7c4$var$patchProperties(response, 'project');
        const { consumerMeta: consumerMeta } = options;
        (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                source: 'frontendConfigProperties',
                action: 'success',
                actionSubject: `${consumerMeta.packageName}.${consumerMeta.id}`
            };
            client.getInstance().sendOperationalEvent(payload);
        });
        ufoExperience?.success();
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const { consumerMeta: consumerMeta } = options;
        !(0, $JRB5w.isClientFetchError)(error) && (0, $guiFP.default)({
            error: error,
            meta: {
                id: consumerMeta.id,
                packageName: consumerMeta.packageName,
                teamName: consumerMeta.teamName
            },
            sendToPrivacyUnsafeSplunk: true
        });
        ufoExperience?.failure();
        throw error;
    }
};

});


parcelRegister("hFK9U", function(module, exports) {

$parcel$export(module.exports, "getTailoredOnboardingExperimentCohort", () => $7643a0c0824fb12c$export$fcb264347c366122);
$parcel$export(module.exports, "isUserEnrolledInTailoredOnboardingExperiment", () => $7643a0c0824fb12c$export$7b8159a372d92686);
$parcel$export(module.exports, "isTailoredQuickstartEnabled", () => $7643a0c0824fb12c$export$65a9481ea376f1be);

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");

var $4vWp2 = parcelRequire("4vWp2");
const $7643a0c0824fb12c$export$fcb264347c366122 = ()=>{
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jwm_tailored_onboarding');
    return expConfig.get('cohort', 'not-enrolled');
};
const $7643a0c0824fb12c$export$7b8159a372d92686 = ()=>{
    if ((0, $eI5EY.fg)('jwm_tailored_onboarding_gate')) {
        const userCohort = $7643a0c0824fb12c$export$fcb264347c366122();
        return userCohort !== 'not-enrolled';
    }
    return false;
};
const $7643a0c0824fb12c$export$65a9481ea376f1be = (personaExperience)=>Boolean(personaExperience && (0, $4vWp2.SUPPORTED_PERSONA_EXPERIENCES).includes(personaExperience) && (0, $79xbN.expValEquals)('jwm_tailored_onboarding', 'cohort', 'variation'));

});
parcelRegister("4vWp2", function(module, exports) {

$parcel$export(module.exports, "EXPERIENCE_TYPE", () => $9d1a089e61b3d8e4$export$19cb56bee281315d);
$parcel$export(module.exports, "PERSONA_TYPE", () => $9d1a089e61b3d8e4$export$4fea3380347f1b0);
$parcel$export(module.exports, "PERSONA_TRAIT_NAME", () => $9d1a089e61b3d8e4$export$8cfac46d1cf13d0d);
$parcel$export(module.exports, "SUPPORTED_PERSONA_EXPERIENCES", () => $9d1a089e61b3d8e4$export$cbc64427de2881a9);
const $9d1a089e61b3d8e4$export$19cb56bee281315d = {
    MARKETER_LEAD: 'Campaign Management Marketing Lead',
    MARKETER_PROJECT: 'Project Management Marketing Lead',
    MARKETER_CONTENT: 'Content Management Content Marketer',
    MARKETER_PMM: 'Project Management PMM'
};
const $9d1a089e61b3d8e4$export$4fea3380347f1b0 = {
    MARKETING_GENERIC: 'Marketing Generic',
    PROJECT_MARKETING_LEAD: 'Project Management Marketing Lead',
    CAMPAIGN_MARKETING_LEAD: 'Campaign Management Marketing Lead',
    CONTENT_MARKETING_LEAD: 'Content Management Content Marketer',
    PMM: 'Project Management PMM'
};
const $9d1a089e61b3d8e4$export$8cfac46d1cf13d0d = 'marketing_track_tailored_onboarding_initialized_wacprovisioningscreen_changed';
const $9d1a089e61b3d8e4$export$cbc64427de2881a9 = [
    $9d1a089e61b3d8e4$export$19cb56bee281315d.MARKETER_LEAD,
    $9d1a089e61b3d8e4$export$19cb56bee281315d.MARKETER_PROJECT,
    $9d1a089e61b3d8e4$export$19cb56bee281315d.MARKETER_CONTENT,
    $9d1a089e61b3d8e4$export$19cb56bee281315d.MARKETER_PMM
];

});


parcelRegister("lIoQU", function(module, exports) {

$parcel$export(module.exports, "fireAnalyticsOnQuickstartClose", () => $d6df15178ffe1f85$export$c98a6ee6aadb8055);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartDismiss", () => $d6df15178ffe1f85$export$45d8c76e0490b3ec);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartBack", () => $d6df15178ffe1f85$export$b1be4ae35a43115d);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartExperienceComplete", () => $d6df15178ffe1f85$export$fa4f266bd2444d14);
$parcel$export(module.exports, "fireAnalyticsOnChecklistItemCompleted", () => $d6df15178ffe1f85$export$a68a2e5a69c8cd74);
$parcel$export(module.exports, "fireAPIErrorAnalytics", () => $d6df15178ffe1f85$export$a4d7f1a52677d339);
$parcel$export(module.exports, "fireAnalyticsOnOpenRightHandSidebar", () => $d6df15178ffe1f85$export$160bb78a3b11a5a9);
$parcel$export(module.exports, "fireAnalyticsOnMinimiseRightHandSidebar", () => $d6df15178ffe1f85$export$6ccbe54cd3a5a12);
$parcel$export(module.exports, "fireAnalyticsOnCloseRightHandSidebar", () => $d6df15178ffe1f85$export$6c39ca65ca354e59);

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");

var $7dRgX = parcelRequire("7dRgX");
parcelRequire("bnszi");
var $eVkIs = parcelRequire("eVkIs");
const $d6df15178ffe1f85$export$c98a6ee6aadb8055 = (analyticsEvent, attributes)=>{
    analyticsEvent.update({
        action: 'closed',
        actionSubject: 'button'
    });
    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'button closed', (0, $7dRgX.ACTION_SUBJECT_ID), attributes);
};
const $d6df15178ffe1f85$export$45d8c76e0490b3ec = (analyticsEvent, attributes, source)=>{
    if (source === 'button') (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstartButton', attributes);
    else if (source === 'checklist') (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstart', attributes);
};
const $d6df15178ffe1f85$export$b1be4ae35a43115d = (analyticsEvent)=>{
    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'button clicked', 'backButton');
};
const $d6df15178ffe1f85$export$fa4f266bd2444d14 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'experience completed', (0, $7dRgX.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $d6df15178ffe1f85$export$a68a2e5a69c8cd74 = (createAnalyticsEvent, completedTaskId)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'checklistItem completed', (0, $eVkIs.convertTaskIdToActionSubjectId)(completedTaskId), {
        taskId: completedTaskId
    });
};
const $d6df15178ffe1f85$export$a4d7f1a52677d339 = (error, endpointSource)=>{
    (0, $guiFP.default)({
        error: error,
        meta: {
            id: 'quickstartApiError',
            packageName: 'jiraOnboardingQuickstartCore',
            teamName: 'jlove-makkuro'
        },
        attributes: {
            error: error.message,
            endpointSource: endpointSource
        }
    });
};
const $d6df15178ffe1f85$export$160bb78a3b11a5a9 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart openRightSidebar', (0, $7dRgX.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $d6df15178ffe1f85$export$6ccbe54cd3a5a12 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart minimiseRightSidebar', (0, $7dRgX.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $d6df15178ffe1f85$export$6c39ca65ca354e59 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart closeRightSidebar', (0, $7dRgX.ACTION_SUBJECT_ID), {
        ...attributes
    });
};

});
parcelRegister("bnszi", function(module, exports) {

$parcel$export(module.exports, "getTaskIndex", () => $1a376c852d3b72fa$export$9ba3adcb1954c00);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForShowMe", () => $1a376c852d3b72fa$export$9711f11998d5795c);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForLink", () => $1a376c852d3b72fa$export$995248f3b43d8505);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForCta", () => $1a376c852d3b72fa$export$293f6b2affa6ea5a);
$parcel$export(module.exports, "convertTaskIdToActionSubjectId", () => (parcelRequire("eVkIs")).convertTaskIdToActionSubjectId);

var $eVkIs = parcelRequire("eVkIs");

var $8ppHd = parcelRequire("8ppHd");

var $6kCnW = parcelRequire("6kCnW");

var $cY793 = parcelRequire("cY793");

var $jTgI9 = parcelRequire("jTgI9");

var $6JZfU = parcelRequire("6JZfU");

var $iZV3I = parcelRequire("iZV3I");
const $1a376c852d3b72fa$export$9ba3adcb1954c00 = (taskList, taskId)=>{
    if (!taskList || taskId === null) return -1;
    return taskList.indexOf(taskId) + 1;
};
const $1a376c852d3b72fa$export$9711f11998d5795c = (taskId)=>`${(0, $eVkIs.convertTaskIdToActionSubjectId)(taskId)}ShowMe`;
const $1a376c852d3b72fa$export$995248f3b43d8505 = (taskId)=>`${(0, $eVkIs.convertTaskIdToActionSubjectId)(taskId)}Link`;
const $1a376c852d3b72fa$export$293f6b2affa6ea5a = (taskId)=>`${(0, $eVkIs.convertTaskIdToActionSubjectId)(taskId)}Cta`;

});
parcelRegister("eVkIs", function(module, exports) {

$parcel$export(module.exports, "getProductType", () => $0947b77be3ed825c$export$27e53caf66bae1d);
$parcel$export(module.exports, "convertTaskIdToActionSubjectId", () => $0947b77be3ed825c$export$3b914201960fa7a6);

var $jh2R9 = parcelRequire("jh2R9");

var $7ZZxN = parcelRequire("7ZZxN");
const $0947b77be3ed825c$export$d64a7dd8c7cd80e0 = {
    [(0, $7ZZxN.CORE_PROJECT)]: 'workManagement',
    [(0, $7ZZxN.SOFTWARE_PROJECT)]: 'software',
    [(0, $7ZZxN.SERVICE_DESK_PROJECT)]: 'serviceManagement'
};
const $0947b77be3ed825c$export$27e53caf66bae1d = (projectType)=>{
    if (projectType) return $0947b77be3ed825c$export$d64a7dd8c7cd80e0[projectType] || (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(projectType);
    return null;
};
const $0947b77be3ed825c$export$3b914201960fa7a6 = (taskId)=>{
    if (!taskId) return '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(taskId.split('.').pop());
};

});

parcelRegister("cY793", function(module, exports) {

$parcel$export(module.exports, "localStorageProvider", () => $f403f41047806be6$export$aa821bfb3308a1f5);
$parcel$export(module.exports, "setLocalStorageHasNavigatedFromLink", () => $f403f41047806be6$export$f2666fae743fa5f);

var $89bO2 = parcelRequire("89bO2");

var $guiFP = parcelRequire("guiFP");

var $7dRgX = parcelRequire("7dRgX");
const $f403f41047806be6$var$DAYS_BEFORE_EXPIRY = 1;
const $f403f41047806be6$var$DAY = 86400000;
const $f403f41047806be6$var$getKey = ({ accountId: accountId, key: key })=>`${accountId}.${key}`;
const $f403f41047806be6$var$getExpiryTime = ()=>{
    const now = Date.now();
    return now + $f403f41047806be6$var$DAYS_BEFORE_EXPIRY * $f403f41047806be6$var$DAY;
};
let $f403f41047806be6$var$localStorage;
const $f403f41047806be6$export$aa821bfb3308a1f5 = ()=>{
    if ($f403f41047806be6$var$localStorage) return $f403f41047806be6$var$localStorage;
    const provider = (0, $89bO2.createSessionExpirableStorageProvider)('jsw-onboarding-checklist');
    try {
        provider.removeExpiredKeys();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $guiFP.default)({
            meta: {
                id: 'localStorageProviderKeyRemoval',
                packageName: 'jiraOnboardingQuickstartCore'
            },
            error: e
        });
    }
    const get = ({ accountId: accountId, key: key })=>provider.get($f403f41047806be6$var$getKey({
            accountId: accountId,
            key: key
        }));
    const set = ({ accountId: accountId, key: key, value: value })=>provider.set($f403f41047806be6$var$getKey({
            accountId: accountId,
            key: key
        }), value, $f403f41047806be6$var$getExpiryTime());
    const remove = ({ accountId: accountId, key: key })=>provider.remove($f403f41047806be6$var$getKey({
            accountId: accountId,
            key: key
        }));
    $f403f41047806be6$var$localStorage = {
        provider: provider,
        remove: remove,
        get: get,
        set: set
    };
    return $f403f41047806be6$var$localStorage;
};
const $f403f41047806be6$export$f2666fae743fa5f = (value)=>{
    $f403f41047806be6$export$aa821bfb3308a1f5().set({
        accountId: (0, $7dRgX.ACCOUNT_ID),
        key: (0, $7dRgX.KEY_HAS_NAVIGATED_FROM_LINK),
        value: value
    });
};

});

parcelRegister("jTgI9", function(module, exports) {

$parcel$export(module.exports, "isRoadmapRoute", () => $2e4ffaed7bae8e69$export$d1fa67c1ffb68871);

var $exb0h = parcelRequire("exb0h");
const $2e4ffaed7bae8e69$export$d1fa67c1ffb68871 = (routeName)=>{
    if (routeName === undefined) return false;
    return routeName === (0, $exb0h.ROUTE_NAMES).SOFTWARE_TIMELINE || routeName === (0, $exb0h.ROUTE_NAMES).SOFTWARE_TIMELINE_CLASSIC;
};

});

parcelRegister("6JZfU", function(module, exports) {

$parcel$export(module.exports, "getAdminHubUrl", () => $962b8ae814600457$export$631ba87ff5b9e288);

var $bW292 = parcelRequire("bW292");
const $962b8ae814600457$export$631ba87ff5b9e288 = ({ suffix: suffix, cloudId: cloudId, orgId: orgId })=>{
    const instanceUrl = (0, $bW292.getATLContextUrl)('admin');
    if (orgId !== undefined && orgId !== '') return `${instanceUrl}/o/${orgId}/${suffix}`;
    if (cloudId) return `${instanceUrl}/s/${cloudId}/${suffix}`;
    return `${instanceUrl}/${suffix}`;
};

});

parcelRegister("iZV3I", function(module, exports) {

$parcel$export(module.exports, "getConnectActionLinkProps", () => $71c2f501f2f8e99c$export$8a467272e65de2b7);

var $jxzG5 = parcelRequire("jxzG5");

var $jMP2a = parcelRequire("jMP2a");
const $71c2f501f2f8e99c$export$8a467272e65de2b7 = (integrationKey, linkActionSubjectId, message)=>{
    // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 2.
    const link = (0, $jxzG5.getEmceeAppListingLink)(integrationKey, {
        source: 'quickstart',
        installDialogOpen: true
    });
    return {
        message: message,
        onClick: (event, analyticsEvent)=>{
            event.stopPropagation();
            const eventName = `${linkActionSubjectId}ConnectApp`;
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, eventName, {
                link: link,
                integration: integrationKey
            });
        },
        link: link
    };
};

});
parcelRegister("jxzG5", function(module, exports) {

$parcel$export(module.exports, "getEmceeDiscoverLink", () => $20f94d12e4a0a9d7$export$f26dabf284aefb17);
$parcel$export(module.exports, "getEmceeAppListingLink", () => $20f94d12e4a0a9d7$export$eb09695b9e9f6a3);
$parcel$export(module.exports, "getAppRequestsLink", () => $20f94d12e4a0a9d7$export$7ab8c48f9081e976);
$parcel$export(module.exports, "getManagePromotionsLink", () => $20f94d12e4a0a9d7$export$350ca33eed6a2742);

var $1ybV0 = parcelRequire("1ybV0");
const $20f94d12e4a0a9d7$var$sanitiseParams = (params)=>params ? Object.entries(params).reduce((res, [key, value])=>{
        if (value) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'EmceeQueryParams | JiraQueryParams'.
        res[key] = params[key];
        return res;
    }, {}) : {};
const $20f94d12e4a0a9d7$var$addQueryParamsToLink = (params, link)=>{
    // @ts-expect-error - TS2345 - Argument of type 'EmceeQueryParams | JiraQueryParams | null | undefined' is not assignable to parameter of type 'EmceeQueryParams | JiraQueryParams | undefined'.
    const queryParams = $20f94d12e4a0a9d7$var$sanitiseParams(params);
    const queryString = new URLSearchParams(queryParams).toString();
    return queryString ? `${link}?${queryString}` : link;
};
const $20f94d12e4a0a9d7$var$resolveConnectDiscoverUrl = (connectUrlDiscoverVariant = 'ENDUSER_DISCOVER', jiraQueryParams)=>{
    let connectDiscoverUrl = `/plugins/servlet/ac/com.atlassian.jira.emcee/${connectUrlDiscoverVariant === 'DISCOVER' ? 'discover' : 'enduser-discover'}`;
    if (jiraQueryParams) connectDiscoverUrl = $20f94d12e4a0a9d7$var$addQueryParamsToLink(jiraQueryParams, connectDiscoverUrl);
    return connectDiscoverUrl;
};
const $20f94d12e4a0a9d7$export$f26dabf284aefb17 = (params, connectUrlDiscoverVariant = 'ENDUSER_DISCOVER')=>{
    const link = (0, $1ybV0.ff)('marketplace.emcee.native.spa.enable') ? '/jira/marketplace/discover' : $20f94d12e4a0a9d7$var$resolveConnectDiscoverUrl(connectUrlDiscoverVariant);
    return $20f94d12e4a0a9d7$var$addQueryParamsToLink(params, link);
};
const $20f94d12e4a0a9d7$export$eb09695b9e9f6a3 = (appKey, params, jiraQueryParams, connectUrlDiscoverVariant = 'ENDUSER_DISCOVER')=>(0, $1ybV0.ff)('marketplace.emcee.native.spa.enable') ? $20f94d12e4a0a9d7$var$addQueryParamsToLink({
        ...jiraQueryParams,
        ...params
    }, `/jira/marketplace/discover/app/${appKey}`) : $20f94d12e4a0a9d7$var$addQueryParamsToLink(params, `${$20f94d12e4a0a9d7$var$resolveConnectDiscoverUrl(connectUrlDiscoverVariant, // @ts-expect-error - TS2345 - Argument of type 'JiraQueryParams | null | undefined' is not assignable to parameter of type 'JiraQueryParams | undefined'.
    jiraQueryParams)}#!/discover/app/${appKey}`);
const $20f94d12e4a0a9d7$export$7ab8c48f9081e976 = (params)=>{
    const link = (0, $1ybV0.ff)('marketplace.emcee.native.spa.enable') ? '/jira/marketplace/manage/app-requests' : '/plugins/servlet/ac/com.atlassian.jira.emcee/app-requests';
    return $20f94d12e4a0a9d7$var$addQueryParamsToLink(params, link);
};
const $20f94d12e4a0a9d7$export$350ca33eed6a2742 = (params)=>{
    const link = (0, $1ybV0.ff)('marketplace.emcee.native.spa.enable') ? '/jira/marketplace/manage/promotions' : '/plugins/servlet/ac/com.atlassian.jira.emcee/promotions';
    return $20f94d12e4a0a9d7$var$addQueryParamsToLink(params, link);
};

});




parcelRegister("kL6gJ", function(module, exports) {

$parcel$export(module.exports, "getCrossProjectBoardTrait", () => $2a787116be621779$export$7f2186c37a3d095d);

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $lRmyA = parcelRequire("lRmyA");

var $jMP2a = parcelRequire("jMP2a");

var $7dRgX = parcelRequire("7dRgX");

var $lmEST = parcelRequire("lmEST");
const $2a787116be621779$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT = 'segment_jsw_cross_project_board_trait_siteuser';
const $2a787116be621779$var$TAP_DELIVERY_PROXY_ENDPOINT = '/gateway/api/tap-delivery/api/v3/personalization';
const $2a787116be621779$var$ONE_DAY = 86400000;
const $2a787116be621779$export$88f2f25e1418caf1 = async (createAnalyticsEvent, siteId, userId)=>{
    try {
        const url = `${$2a787116be621779$var$TAP_DELIVERY_PROXY_ENDPOINT}/site/${siteId}/user/${userId}`;
        const result = await (0, $lRmyA.performGetRequest)(url);
        const analyticsEvent = createAnalyticsEvent({});
        (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait personalizationApi', {
            synthetic: (0, $1ybV0.ff)('jsw.pollinator.tenants')
        });
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'quickstartApiError',
                packageName: (0, $7dRgX.PACKAGE_NAME),
                teamName: (0, $7dRgX.PACKAGE_TEAM_NAME)
            },
            attributes: {
                error: error.message,
                endpointSource: 'getJSWCrossProjectBoardTrait',
                synthetic: (0, $1ybV0.ff)('jsw.pollinator.tenants')
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            attributes: []
        };
    }
};
const $2a787116be621779$export$7f2186c37a3d095d = async (createAnalyticsEvent, siteId, userId)=>{
    const { get: get, persist: persist } = (0, $lmEST.crossProjectBoardTraitSessionStorageProvider)();
    // Check session storage
    const sessionStorage = get();
    if (sessionStorage && userId === sessionStorage.userId && siteId === sessionStorage.siteId && Date.now() - sessionStorage.date < $2a787116be621779$var$ONE_DAY) {
        const analyticsEvent = createAnalyticsEvent({});
        (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait sessionStorage', {
            synthetic: (0, $1ybV0.ff)('jsw.pollinator.tenants')
        });
        return sessionStorage.attribute;
    }
    // Fetch from personalization
    const personalization = await $2a787116be621779$export$88f2f25e1418caf1(createAnalyticsEvent, siteId, userId);
    const attribute = personalization.attributes.find((att)=>att.name === $2a787116be621779$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT);
    if (attribute !== undefined) persist({
        attribute: attribute,
        date: Date.now(),
        userId: userId,
        siteId: siteId
    });
    return attribute;
};

});
parcelRegister("lmEST", function(module, exports) {

$parcel$export(module.exports, "crossProjectBoardTraitSessionStorageProvider", () => $6d7ad5c5e3880914$export$99f3e48748c2a8c3);

var $89bO2 = parcelRequire("89bO2");

const $6d7ad5c5e3880914$var$crossProjectBoardTraitSessionProvider = (0, $89bO2.createSessionExpirableStorageProvider)((0, $e2fa640244aa9949$export$fac14ff24e5b1e7a));
const $6d7ad5c5e3880914$export$99f3e48748c2a8c3 = ()=>{
    const persist = (toPersist)=>{
        $6d7ad5c5e3880914$var$crossProjectBoardTraitSessionProvider.set((0, $e2fa640244aa9949$export$fac14ff24e5b1e7a), toPersist);
    };
    const get = ()=>$6d7ad5c5e3880914$var$crossProjectBoardTraitSessionProvider.get((0, $e2fa640244aa9949$export$fac14ff24e5b1e7a));
    return {
        get: get,
        persist: persist
    };
};

});
const $e2fa640244aa9949$export$fac14ff24e5b1e7a = 'jira-user-cross-project-board-trait';



parcelRegister("74z6M", function(module, exports) {

$parcel$export(module.exports, "getIsDevOpsProject", () => $22fff37650eaf366$export$88ee873472aa9bb7);

var $7dRgX = parcelRequire("7dRgX");
const $22fff37650eaf366$var$projectPropertyUrl = (projectKey)=>`/rest/api/2/project/${projectKey}/properties/${0, $7dRgX.KEY_IS_DEVOPS_PROJECT}`;
const $22fff37650eaf366$export$88ee873472aa9bb7 = async (projectKey)=>{
    const url = $22fff37650eaf366$var$projectPropertyUrl(projectKey);
    const response = await fetch(url);
    if (response.ok) {
        const result = await response.json();
        return result.value;
    }
    return false;
};

});

parcelRegister("9vuWT", function(module, exports) {

$parcel$export(module.exports, "getOnboardingSkipApplicationProperty", () => $c73311db2e118d57$export$980c26b6f100081d);

var $lRmyA = parcelRequire("lRmyA");
const $c73311db2e118d57$export$980c26b6f100081d = ()=>(0, $lRmyA.performGetRequest)('/rest/onboarding/1.0/skip');

});

parcelRegister("jssF8", function(module, exports) {

$parcel$export(module.exports, "nextSetChecklistIsDismissed", () => $ad333f190549603d$export$f24c05f83b880547);

var $79xbN = parcelRequire("79xbN");

var $7dRgX = parcelRequire("7dRgX");

var $8ppHd = parcelRequire("8ppHd");

var $5OjXh = parcelRequire("5OjXh");

var $ahbtR = parcelRequire("ahbtR");
const $ad333f190549603d$export$f24c05f83b880547 = (isDismissed)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        if ((0, $79xbN.expValEquals)('jsm_business_quickstart', 'cohort', 'experiment')) {
            const state = getState();
            const quickstartType = (0, $5OjXh.getQuickstartTypeSelector)(state);
            const currentIsDismissed = state.visibility[quickstartType] === (0, $7dRgX.QUICKSTART_UI_STATUS).DISMISSED;
            if (isDismissed === currentIsDismissed) // if state has not been updated we just return
            return;
            const quickstartStatus = isDismissed ? (0, $7dRgX.QUICKSTART_UI_STATUS).DISMISSED : (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN;
            setState({
                visibility: {
                    ...state.visibility,
                    [quickstartType]: quickstartStatus
                },
                isFocusedOn: !isDismissed
            });
            (0, $8ppHd.pushToBackend)({
                key: (0, $7dRgX.getBackendVisibilityKey)(quickstartType),
                value: quickstartStatus
            });
            // Maintain backwards compatibility with Quickstart in case we need to turn the feature off
            // Delete code below when cleaning up
            if (isDismissed === false) // When setting IsDismissed to false, also setting QS status to OPEN so checklist appears in open state
            (0, $8ppHd.pushToBackend)({
                key: (0, $7dRgX.KEY_OPEN),
                value: true
            });
            else // When setting IsDismissed, also toggle the open state of the checklist to match.
            (0, $8ppHd.pushToBackend)({
                key: (0, $7dRgX.KEY_OPEN),
                value: false
            });
            (0, $8ppHd.pushToBackend)({
                key: (0, $7dRgX.KEY_DISMISSED),
                value: isDismissed
            });
            return;
        }
        /* Grab current state of is isDismissed */ const { isDismissed: currentIsDismissed } = getState();
        if (isDismissed === currentIsDismissed) // if state has not been updated we just return
        return;
        setState({
            isDismissed: isDismissed
        });
        if (isDismissed === false) // When setting IsDismissed to false, also setting QS status to OPEN so checklist appears in open state
        dispatch((0, $ahbtR.nextSetChecklistIsOpen)(true));
        else // When setting IsDismissed, also toggle the open state of the checklist to match.
        dispatch((0, $ahbtR.nextSetChecklistIsOpen)(false));
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.KEY_DISMISSED),
            value: isDismissed
        });
    };

});
parcelRegister("ahbtR", function(module, exports) {

$parcel$export(module.exports, "nextSetChecklistIsOpen", () => $42c7858c3f713220$export$4249eabbb34e2e69);

var $79xbN = parcelRequire("79xbN");

var $7dRgX = parcelRequire("7dRgX");

var $8ppHd = parcelRequire("8ppHd");

var $5OjXh = parcelRequire("5OjXh");
const $42c7858c3f713220$export$4249eabbb34e2e69 = (isOpen)=>({ getState: getState, setState: setState })=>{
        if ((0, $79xbN.expValEquals)('jsm_business_quickstart', 'cohort', 'experiment')) {
            const state = getState();
            const quickstartType = (0, $5OjXh.getQuickstartTypeSelector)(state);
            const currentIsOpen = state.visibility[quickstartType] === (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN;
            const currentIsMinimised = state.visibility[quickstartType] === (0, $7dRgX.QUICKSTART_UI_STATUS).MINIMIZED;
            if (currentIsOpen && isOpen || currentIsMinimised && !isOpen) // if state has not been updated we just return
            return;
            const quickstartStatus = isOpen ? (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN : (0, $7dRgX.QUICKSTART_UI_STATUS).MINIMIZED;
            setState({
                visibility: {
                    ...state.visibility,
                    [quickstartType]: quickstartStatus
                },
                hasNudgeActive: false,
                isFocusedOn: isOpen
            });
            (0, $8ppHd.pushToBackend)({
                key: (0, $7dRgX.getBackendVisibilityKey)(quickstartType),
                value: quickstartStatus
            });
            // Maintain backwards compatibility with old global quickstart in case we need to turn the feature off
            // Delete code below when cleaning up
            (0, $8ppHd.pushToBackend)({
                key: (0, $7dRgX.KEY_OPEN),
                value: isOpen
            });
            return;
        }
        /* Grab current state of is isOpen */ const { isOpen: currentIsOpen } = getState();
        if (isOpen === currentIsOpen) // if state has not been updated we just return
        return;
        setState({
            isOpen: isOpen,
            hasNudgeActive: false,
            isFocusedOn: isOpen
        });
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.KEY_OPEN),
            value: isOpen
        });
    };

});


parcelRegister("g1Zgk", function(module, exports) {

$parcel$export(module.exports, "nextMarkAsCompletedTask", () => $13a2c09b85cecff0$export$d6628d41a3bec42d);

var $8ppHd = parcelRequire("8ppHd");
const $13a2c09b85cecff0$export$d6628d41a3bec42d = (taskId)=>({ getState: getState, setState: setState })=>{
        // When a task is complete:
        // Check to see if the task is complete in the completedKeys already
        // update the checklist dict (maybe should be at a different point or use setState)
        const { completedTaskList: completedTaskList } = getState();
        if (completedTaskList.includes(taskId)) return;
        // update the backend with the KEY and true
        (0, $8ppHd.pushToBackend)({
            key: taskId,
            value: true
        });
        // update itemsList to reflect checked status. clone -> update -> override
        setState({
            completedTaskList: [
                ...completedTaskList,
                taskId
            ]
        });
    };

});

parcelRegister("fzDyP", function(module, exports) {

$parcel$export(module.exports, "mapPersonaTraitsToExperience", () => $b7c30df71a7183dd$export$54560e73c5a0e8ff);

var $4vWp2 = parcelRequire("4vWp2");
const $b7c30df71a7183dd$export$54560e73c5a0e8ff = (userTraitsPersona)=>{
    switch(userTraitsPersona?.value){
        case (0, $4vWp2.PERSONA_TYPE).MARKETING_GENERIC:
        case (0, $4vWp2.PERSONA_TYPE).CAMPAIGN_MARKETING_LEAD:
            return (0, $4vWp2.EXPERIENCE_TYPE).MARKETER_LEAD;
        case (0, $4vWp2.PERSONA_TYPE).PROJECT_MARKETING_LEAD:
            return (0, $4vWp2.EXPERIENCE_TYPE).MARKETER_PROJECT;
        case (0, $4vWp2.PERSONA_TYPE).CONTENT_MARKETING_LEAD:
            return (0, $4vWp2.EXPERIENCE_TYPE).MARKETER_CONTENT;
        case (0, $4vWp2.PERSONA_TYPE).PMM:
            return (0, $4vWp2.EXPERIENCE_TYPE).MARKETER_PMM;
        default:
            return undefined;
    }
};

});


parcelRegister("aI5eR", function(module, exports) {

$parcel$export(module.exports, "setNudgeStep", () => $970ae6c28ea9ba56$export$4debc323813b6997);
const $970ae6c28ea9ba56$export$4debc323813b6997 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { nudgeStep: nudgeStep } = getState();
        if (nudge === nudgeStep) return;
        setState({
            nudgeStep: nudge
        });
    };
var $970ae6c28ea9ba56$export$2e2bcd8739ae039 = $970ae6c28ea9ba56$export$4debc323813b6997;

});

parcelRegister("1jaP6", function(module, exports) {

$parcel$export(module.exports, "addMountedNudge", () => $d76ba5c46e283800$export$92a89c32d0ea3943);
$parcel$export(module.exports, "removeMountedNudge", () => $d76ba5c46e283800$export$748f4cda8ab98c91);
const $d76ba5c46e283800$export$92a89c32d0ea3943 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { mountedNudges: mountedNudges } = getState();
        // skip store update if this nudge is already added
        if (mountedNudges.includes(nudge)) return;
        setState({
            mountedNudges: [
                ...mountedNudges,
                nudge
            ]
        });
    };
const $d76ba5c46e283800$export$748f4cda8ab98c91 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { mountedNudges: mountedNudges } = getState();
        // skip store update if this nudge is already removed
        if (!mountedNudges.includes(nudge)) return;
        setState({
            mountedNudges: mountedNudges.filter((mountedNudge)=>mountedNudge !== nudge)
        });
    };

});

parcelRegister("lCKeP", function(module, exports) {

$parcel$export(module.exports, "setShouldRenderComponent", () => $3e69fb4a25487c6b$export$1f9c6770ed938b6e);
const $3e69fb4a25487c6b$export$1f9c6770ed938b6e = (shouldRenderComponent)=>({ getState: getState, setState: setState })=>{
        /* Grab current state of is shouldRenderComponent */ const { shouldRenderComponent: currentShouldRenderComponent } = getState();
        if (shouldRenderComponent === currentShouldRenderComponent) // if state has not been updated we just return
        return;
        setState({
            shouldRenderComponent: shouldRenderComponent
        });
    };
var $3e69fb4a25487c6b$export$2e2bcd8739ae039 = $3e69fb4a25487c6b$export$1f9c6770ed938b6e;

});

parcelRegister("9FTSc", function(module, exports) {

$parcel$export(module.exports, "setProjectState", () => $e8f28a5d91b40a98$export$1ba498e440c0a1e4);
const $e8f28a5d91b40a98$export$1ba498e440c0a1e4 = (projectState)=>({ setState: setState })=>{
        setState({
            projectState: projectState
        });
    };
var $e8f28a5d91b40a98$export$2e2bcd8739ae039 = $e8f28a5d91b40a98$export$1ba498e440c0a1e4;

});

parcelRegister("iq74h", function(module, exports) {

$parcel$export(module.exports, "setHasNudgeActive", () => $d5d9f3bbfe59a243$export$497c281e6eb0786e);
const $d5d9f3bbfe59a243$export$497c281e6eb0786e = (hasNudgeActive, itemName = '')=>({ getState: getState, setState: setState })=>{
        /* Grab current state of is currentHasNudgeActive */ const { hasNudgeActive: currentHasNudgeActive, openTask: openTask } = getState();
        if (hasNudgeActive === currentHasNudgeActive) // if state has not been updated we just return
        return;
        if (hasNudgeActive === false && itemName !== openTask) // do not update a nudge if the current open task is different than the one we called the function with
        return;
        setState({
            hasNudgeActive: hasNudgeActive
        });
    };
var $d5d9f3bbfe59a243$export$2e2bcd8739ae039 = $d5d9f3bbfe59a243$export$497c281e6eb0786e;

});

parcelRegister("cKB0H", function(module, exports) {

$parcel$export(module.exports, "forceHideNudge", () => $395e6590b72e7adc$export$6d1ed97b83a62e8e);
// We use this action in cases where we want to hide the nudge no matter what.
const $395e6590b72e7adc$export$6d1ed97b83a62e8e = ()=>({ setState: setState })=>{
        setState({
            hasNudgeActive: false
        });
    };

});

parcelRegister("8n1zQ", function(module, exports) {

$parcel$export(module.exports, "setHasEverSeenRoute", () => $9526def4b4979224$export$28e0a4314a1ce52f);

var $7dRgX = parcelRequire("7dRgX");

var $8ppHd = parcelRequire("8ppHd");
const $9526def4b4979224$export$28e0a4314a1ce52f = (update)=>({ getState: getState, setState: setState })=>{
        const { hasEverSeenRoute: currentHasEverSeenRoute } = getState();
        const somethingHasBeenUpdated = Object.keys(update).some(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<"jsw.onboarding.experiment.personalised.onboarding.ntkw.onboarding.it2.roadmap", boolean>>'.
        (key)=>update[key] !== currentHasEverSeenRoute[key]);
        if (!somethingHasBeenUpdated) return;
        const newHasEverSeenRoute = {
            ...currentHasEverSeenRoute,
            ...update
        };
        setState({
            hasEverSeenRoute: newHasEverSeenRoute
        });
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.KEY_HAS_EVER_SEEN_ROUTE),
            value: newHasEverSeenRoute
        });
    };
var $9526def4b4979224$export$2e2bcd8739ae039 = $9526def4b4979224$export$28e0a4314a1ce52f;

});

parcelRegister("ioWKV", function(module, exports) {

$parcel$export(module.exports, "setRoadmapIsCreateEnabled", () => $3aa7d72125406d8f$export$35ea35d1a8e07307);
$parcel$export(module.exports, "setRoadmapIsListEmpty", () => $3aa7d72125406d8f$export$932967764e7a0b31);
const $3aa7d72125406d8f$export$35ea35d1a8e07307 = (roadmapIsCreateEnabled)=>({ getState: getState, setState: setState })=>{
        const { roadmapIsCreateEnabled: currentRoadmapIsCreateEnabled } = getState();
        // skip store update if no state change
        if (currentRoadmapIsCreateEnabled === roadmapIsCreateEnabled) return;
        setState({
            roadmapIsCreateEnabled: roadmapIsCreateEnabled
        });
    };
const $3aa7d72125406d8f$export$932967764e7a0b31 = (roadmapIsListEmpty)=>({ getState: getState, setState: setState })=>{
        const { roadmapIsListEmpty: currentRoadmapIsListEmpty } = getState();
        // skip store update if no state change
        if (currentRoadmapIsListEmpty === roadmapIsListEmpty) return;
        setState({
            roadmapIsListEmpty: roadmapIsListEmpty
        });
    };

});

parcelRegister("P9NN5", function(module, exports) {

$parcel$export(module.exports, "openNextTask", () => $cc1aff9593d14250$export$867dbb6d61569ae9);

var $egHFE = parcelRequire("egHFE");

var $gn07r = parcelRequire("gn07r");
const $cc1aff9593d14250$export$867dbb6d61569ae9 = ()=>({ getState: getState, dispatch: dispatch })=>{
        const { openTask: openTask, tasks: tasks } = getState();
        if (!tasks) return;
        const { items: items } = tasks;
        const taskIdToExpand = (0, $egHFE.getNextTask)(items, openTask);
        if (taskIdToExpand === null) return;
        dispatch((0, $gn07r.nextOpenTask)(taskIdToExpand));
    };

});
parcelRegister("egHFE", function(module, exports) {

$parcel$export(module.exports, "getNextNonCompleteTask", () => $e5132247b337604d$export$b61dc70e2ed3fae3);
$parcel$export(module.exports, "getNextTask", () => $e5132247b337604d$export$404421ce8f3cbf9a);

var $bnszi = parcelRequire("bnszi");
const $e5132247b337604d$export$b61dc70e2ed3fae3 = (tasks, completed, openTask)=>{
    const taskPosition = (0, $bnszi.getTaskIndex)(tasks, openTask);
    // if the task does not exist(-1), we want to start at 0
    // if it exists we want to start at array index + 1 (taskPosition is already index+1)
    const start = taskPosition === -1 ? 0 : taskPosition;
    const len = tasks.length;
    // This loop:
    // 1) searches for non completed items from the start index to last index of the array
    // 2) searches from 0 until start if nothing was found during 1)
    for(let i = start; i < start + len; i += 1){
        const ind = i % len;
        if (!completed.includes(tasks[ind])) return tasks[ind];
    }
    // nothing was found there is no task to open
    return null;
};
const $e5132247b337604d$export$404421ce8f3cbf9a = (tasks, openTask)=>{
    const taskPosition = (0, $bnszi.getTaskIndex)(tasks, openTask);
    // if the task does not exist(-1), we want to start at 0
    // if it exists we want to start at array index + 1 (taskPosition is already index+1)
    const ind = taskPosition === -1 ? 0 : taskPosition;
    return tasks[ind] ? tasks[ind] : null;
};

});

parcelRegister("gn07r", function(module, exports) {

$parcel$export(module.exports, "nextOpenTask", () => $4f8f6eacc80982cf$export$5deb889489d2f989);
$parcel$export(module.exports, "nextAutoOpenTask", () => $4f8f6eacc80982cf$export$cc5f3544a6cb2922);

var $79xbN = parcelRequire("79xbN");


var $7dRgX = parcelRequire("7dRgX");

var $8ppHd = parcelRequire("8ppHd");

var $aI5eR = parcelRequire("aI5eR");

var $iq74h = parcelRequire("iq74h");
const $4f8f6eacc80982cf$var$openTask = (taskId)=>({ setState: setState })=>{
        setState({
            openTask: taskId
        });
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.KEY_OPEN_TASK),
            value: taskId
        });
    };
const $4f8f6eacc80982cf$export$5deb889489d2f989 = (taskId, { closeNudge: closeNudge } = {})=>({ dispatch: dispatch, getState: getState })=>{
        dispatch($4f8f6eacc80982cf$var$openTask(taskId));
        const { completedTaskList: completedTaskList } = getState();
        // eslint-disable-next-line jira/ff/unsafe-no-exposure
        const [simplifyKanbanQsExpConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_simplify_kanban_qs');
        // eslint-disable-next-line jira/ff/unsafe-no-exposure
        const [disableAutoNudgeTour] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_disable_auto_nudge_tours');
        // eslint-disable-next-line jira/ff/unsafe-no-exposure
        const [simplifyKanbanQsForAllExpConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_simplify_kanban_qs_all_users');
        const shouldSimplifyKanbanQs = simplifyKanbanQsForAllExpConfig.get('isEnabled', false) || disableAutoNudgeTour.get('isDisabled', false) && simplifyKanbanQsExpConfig.get('cohort', 'not-enrolled') === 'variation';
        const taskIsCompleted = completedTaskList.includes(taskId);
        const taskIdExistsAndIsNotCompleted = !(taskId === '' || taskId === null) && !taskIsCompleted;
        if (closeNudge) dispatch((0, $iq74h.setHasNudgeActive)(false, taskId));
        else dispatch((0, $iq74h.setHasNudgeActive)(taskIdExistsAndIsNotCompleted, taskId));
        // This is a temporary solution for Scrum Onboarding.
        // See https://hello.atlassian.net/wiki/spaces/agile/pages/1321008806/Draft+Quickstart+Nudge+Interaction for details
        if (taskIdExistsAndIsNotCompleted && taskId === (0, $7dRgX.SCRUM_ONBOARDING_TASK)) dispatch((0, $aI5eR.setNudgeStep)((0, $8379f5d78bf6fb5a$export$b1a6ab17737f33e)));
        else if (taskIdExistsAndIsNotCompleted && taskId === (0, $7dRgX.KANBAN_ONBOARDING_TASK)) dispatch((0, $aI5eR.setNudgeStep)((0, $8379f5d78bf6fb5a$export$3366ddefe77d5112)));
        else if (shouldSimplifyKanbanQs && taskIdExistsAndIsNotCompleted && taskId === (0, $7dRgX.ADD_COLUMNS_TASK)) dispatch((0, $aI5eR.setNudgeStep)((0, $8379f5d78bf6fb5a$export$3366ddefe77d5112)));
        else dispatch((0, $aI5eR.setNudgeStep)(''));
    };
const $4f8f6eacc80982cf$export$cc5f3544a6cb2922 = (taskId)=>({ dispatch: dispatch })=>{
        dispatch($4f8f6eacc80982cf$var$openTask(taskId));
        dispatch((0, $iq74h.setHasNudgeActive)(false, taskId));
        dispatch((0, $aI5eR.setNudgeStep)(''));
    };

});


parcelRegister("6GDwI", function(module, exports) {

$parcel$export(module.exports, "resetIsQuickstartLoaded", () => $cf59d5b51193e99b$export$bda085a823763e5a);

var $7dRgX = parcelRequire("7dRgX");

var $5OjXh = parcelRequire("5OjXh");
const $cf59d5b51193e99b$export$bda085a823763e5a = ()=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $5OjXh.getQuickstartTypeSelector)(state);
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: (0, $7dRgX.QUICKSTART_UI_STATUS).NOT_LOADED
            },
            hasNudgeActive: false,
            isQuickstartLoaded: false
        });
    };

});

parcelRegister("dn2YB", function(module, exports) {

$parcel$export(module.exports, "nextSetChecklistItemSeen", () => $ae4dc9d92cd110b5$export$4eac017dcde0be8f);

var $79xbN = parcelRequire("79xbN");

var $7dRgX = parcelRequire("7dRgX");

var $8ppHd = parcelRequire("8ppHd");

var $gn07r = parcelRequire("gn07r");
const $ae4dc9d92cd110b5$export$4eac017dcde0be8f = (taskId)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const hasSeenTaskId = (0, $7dRgX.convertToHaveSeenItTask)(taskId);
        const { hasSeenTasks: hasSeenTasks } = getState();
        if (hasSeenTasks.includes(hasSeenTaskId)) return;
        setState({
            hasSeenTasks: [
                ...hasSeenTasks,
                hasSeenTaskId
            ]
        });
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.convertToHaveSeenItTask)(taskId),
            value: true
        });
        // This will prioritise expanding this current taskId as the next card to expand.
        // For simplify kanban QS we don't want to expand hasSeen cards first
        // eslint-disable-next-line jira/ff/unsafe-no-exposure
        const [simplifyKanbanQsExpConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_simplify_kanban_qs');
        // eslint-disable-next-line jira/ff/unsafe-no-exposure
        const [disableAutoNudgeTour] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_disable_auto_nudge_tours');
        // eslint-disable-next-line jira/ff/unsafe-no-exposure
        const [simplifyKanbanQsForAllExpConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_simplify_kanban_qs_all_users');
        const shouldSimplifyKanbanQs = simplifyKanbanQsForAllExpConfig.get('isEnabled', false) || disableAutoNudgeTour.get('isDisabled', false) && simplifyKanbanQsExpConfig.get('cohort', 'not-enrolled') === 'variation';
        if (shouldSimplifyKanbanQs === false) dispatch((0, $gn07r.nextOpenTask)(taskId));
    };

});

parcelRegister("7I9OF", function(module, exports) {

$parcel$export(module.exports, "nextAutoExpand", () => $8c8cecc90fef13d0$export$3d24e97d30cfd09e);

var $7dRgX = parcelRequire("7dRgX");

var $cY793 = parcelRequire("cY793");

var $egHFE = parcelRequire("egHFE");

var $gn07r = parcelRequire("gn07r");
const $8c8cecc90fef13d0$export$3d24e97d30cfd09e = ()=>({ getState: getState, dispatch: dispatch })=>{
        const hasNudgeToShowAfterNavigation = (0, $cY793.localStorageProvider)().get({
            accountId: (0, $7dRgX.ACCOUNT_ID),
            key: (0, $7dRgX.KEY_HAS_NAVIGATED_FROM_LINK)
        });
        if (hasNudgeToShowAfterNavigation) return;
        const { openTask: openTask, completedTaskList: completedTaskList, tasks: tasks } = getState();
        if (!tasks) return;
        const { items: items } = tasks;
        if (// @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        items.includes(openTask) && // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        !completedTaskList.includes(openTask)) return;
        const taskIdToExpand = (0, $egHFE.getNextNonCompleteTask)(items, completedTaskList, openTask);
        if (taskIdToExpand === null) return;
        dispatch((0, $gn07r.nextAutoOpenTask)(taskIdToExpand));
    };

});

parcelRegister("cDYe7", function(module, exports) {

$parcel$export(module.exports, "nextShouldShowNudgeAfterNavigation", () => $3949917718560fd8$export$6f336ccb6432fcd0);
// Special case for nudges that need to show after a navigation.

var $7dRgX = parcelRequire("7dRgX");

var $cY793 = parcelRequire("cY793");

var $iq74h = parcelRequire("iq74h");
const $3949917718560fd8$export$6f336ccb6432fcd0 = (taskId)=>({ dispatch: dispatch })=>{
        const nudgeToShowAfterNavigationKeyPair = {
            accountId: (0, $7dRgX.ACCOUNT_ID),
            key: (0, $7dRgX.KEY_HAS_NAVIGATED_FROM_LINK)
        };
        const shouldShowNudge = (0, $cY793.localStorageProvider)().get(nudgeToShowAfterNavigationKeyPair) === taskId;
        if (shouldShowNudge) {
            dispatch((0, $iq74h.setHasNudgeActive)(true));
            (0, $cY793.localStorageProvider)().remove(nudgeToShowAfterNavigationKeyPair);
        }
    };

});

parcelRegister("kDmv4", function(module, exports) {

$parcel$export(module.exports, "nextGetTasks", () => $2cffb9be55c6d345$export$15d877e1f3abf489);

var $a0vMn = parcelRequire("a0vMn");
const $2cffb9be55c6d345$export$15d877e1f3abf489 = (props)=>({ setState: setState })=>{
        const tasks = (0, $a0vMn.getAllTasks)(props);
        setState({
            tasks: tasks
        });
    };

});
parcelRegister("a0vMn", function(module, exports) {

$parcel$export(module.exports, "getAllTasks", () => $62ef3d093ab58a52$export$d1f442602a91e7cc);

var $dfBCt = parcelRequire("dfBCt");

var $exb0h = parcelRequire("exb0h");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");


var $6WXNs = parcelRequire("6WXNs");

var $7dRgX = parcelRequire("7dRgX");

var $jTgI9 = parcelRequire("jTgI9");

var $hFK9U = parcelRequire("hFK9U");

var $fricC = parcelRequire("fricC");

var $4vWp2 = parcelRequire("4vWp2");

var $kxycg = parcelRequire("kxycg");
var $3sCLn = parcelRequire("3sCLn");
var $2UWYK = parcelRequire("2UWYK");
var $c2fmF = parcelRequire("c2fmF");

var $2hhuw = parcelRequire("2hhuw");

var $5f5jN = parcelRequire("5f5jN");
const $62ef3d093ab58a52$var$getTaskListItem = ({ variants: variants, taskVariants: taskVariants, taskList: taskList, taskGroupParent: taskGroupParent })=>{
    if (variants.includes((0, $2UWYK.JSW).experiment.jswReverseTrial)) {
        const { title: title, items: items } = taskList[taskGroupParent === (0, $7dRgX.ROOT_TASK) ? (0, $7dRgX.REVERSE_TRIAL_ROOT_TASK) : taskGroupParent] ?? taskList[0, $7dRgX.REVERSE_TRIAL_ROOT_TASK];
        return {
            title: title,
            items: (0, $2hhuw.getTasks)(variants, taskVariants, items)
        };
    }
    const { title: title, items: items } = taskList[taskGroupParent] ?? taskList[0, $7dRgX.ROOT_TASK];
    return {
        title: title,
        items: (0, $2hhuw.getTasks)(variants, taskVariants, items)
    };
};
const $62ef3d093ab58a52$var$createJswTasks = (projectState, taskGroupParent, routeName, shouldShowScrumOnboardingExperience, mountedNudges, canCreateProject, isEligibleToUpdateSitename, isCustomerTemplateProject, isCrossProjectBoardToPlanUpsell, canEditPlans, premiumTrialOnSignup)=>{
    const variants = new Set();
    const isTmpScrumWithSprintPermission = mountedNudges.includes((0, $7dRgX.BACKLOG_CREATE_SPRINT_NUDGE_ID));
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [simplifyKanbanQsExpConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_simplify_kanban_qs');
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [disableAutoNudgeTour] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_disable_auto_nudge_tours');
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [simplifyKanbanQsForAllExpConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_simplify_kanban_qs_all_users');
    const shouldSimplifyKanbanQs = simplifyKanbanQsForAllExpConfig.get('isEnabled', false) || disableAutoNudgeTour.get('isDisabled', false) && simplifyKanbanQsExpConfig.get('cohort', 'not-enrolled') === 'variation';
    const isEligibleForKanbanTour = mountedNudges.includes((0, $8379f5d78bf6fb5a$export$3366ddefe77d5112));
    if ((0, $dfBCt.isFedRamp)()) variants.add((0, $2UWYK.JSW).experience.fedRamp);
    if (premiumTrialOnSignup && (0, $eI5EY.fg)('jsw_reverse_trials_feature_gate')) variants.add((0, $2UWYK.JSW).experiment.jswReverseTrial);
    if ((0, $1ybV0.ff)('jsw.onboarding.rollout.kuro-2250') && isCustomerTemplateProject) variants.add((0, $2UWYK.JSW).projectProperties.isCreatedFromCustomerTemplate);
    if (shouldShowScrumOnboardingExperience && isTmpScrumWithSprintPermission) variants.add((0, $2UWYK.JSW).experiment.scrumOnboarding);
    if (isCrossProjectBoardToPlanUpsell) variants.add((0, $2UWYK.JSW).trait.crossProjectBoardToPlanUpsell);
    if (canEditPlans) variants.add((0, $2UWYK.JSW).permissions.hasPlanEditPermissions);
    if (isEligibleForKanbanTour || routeName !== (0, $exb0h.ROUTE_NAMES).SOFTWARE_BOARDS) variants.add((0, $2UWYK.JSW).experience.kanbanOnboarding);
    if (shouldSimplifyKanbanQs) variants.add((0, $2UWYK.JSW).experiment.simplifyKanbanQS);
    if (canCreateProject === false) variants.add((0, $2UWYK.JSW).permissions.notCanCreateProject);
    if (projectState?.isNextGen) variants.add((0, $2UWYK.JSW).projectStyle.teamManaged);
    else variants.add((0, $2UWYK.JSW).projectStyle.companyManaged);
    if (projectState?.isProjectAdmin) variants.add((0, $2UWYK.JSW).userRole.projectAdmin);
    if (projectState?.userRole === (0, $fricC.USER_ROLE).JIRA_ADMIN) {
        variants.add((0, $2UWYK.JSW).userRole.jiraAdmin);
        variants.add((0, $2UWYK.JSW).userRole.admin);
    }
    if (projectState?.userRole === (0, $fricC.USER_ROLE).SITE_ADMIN) {
        variants.add((0, $2UWYK.JSW).userRole.siteAdmin);
        variants.add((0, $2UWYK.JSW).userRole.admin);
    }
    if (projectState?.edition === (0, $6WXNs.FREE_EDITION)) variants.add((0, $2UWYK.JSW).edition.free);
    else if (projectState?.edition === (0, $6WXNs.STANDARD_EDITION)) variants.add((0, $2UWYK.JSW).edition.standard);
    else if (projectState?.edition === (0, $6WXNs.PREMIUM_EDITION)) variants.add((0, $2UWYK.JSW).edition.premium);
    if ((0, $jTgI9.isRoadmapRoute)(routeName)) variants.add((0, $2UWYK.JSW).route.softwareRoadmap);
    else if (routeName === (0, $exb0h.ROUTE_NAMES).SOFTWARE_BACKLOG) variants.add((0, $2UWYK.JSW).route.softwareBacklog);
    else if (routeName === (0, $exb0h.ROUTE_NAMES).SOFTWARE_BOARDS) variants.add((0, $2UWYK.JSW).route.softwareBoard);
    else if (routeName === (0, $exb0h.ROUTE_NAMES).SOFTWARE_LIST || routeName === (0, $exb0h.ROUTE_NAMES).SOFTWARE_LIST_CLASSIC) variants.add((0, $2UWYK.JSW).route.softwareList);
    else if (routeName === (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_SOFTWARE_ACCESS) variants.add((0, $2UWYK.JSW).route.projectSettingsSoftwareAccess);
    else if (routeName === (0, $exb0h.ROUTE_NAMES).ISSUE) variants.add((0, $2UWYK.JSW).route.issue);
    else if ((0, $1ybV0.ff)('jsw-calendar-view-onboarding_q3bvy') && (routeName === (0, $exb0h.ROUTE_NAMES).SOFTWARE_CALENDAR || routeName === (0, $exb0h.ROUTE_NAMES).SOFTWARE_CALENDAR_CLASSIC)) variants.add((0, $2UWYK.JSW).route.softwareCalendar);
    if (isEligibleToUpdateSitename) variants.add((0, $2UWYK.JSW).experiment.customizeSiteName);
    return $62ef3d093ab58a52$var$getTaskListItem({
        variants: Array.from(variants.values()),
        taskVariants: (0, $2UWYK.JSW).taskVariants,
        taskList: (0, $2UWYK.JSW).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $62ef3d093ab58a52$var$createJwmTasks = (projectState, taskGroupParent, personaExperience)=>{
    const variants = [];
    variants.push((0, $c2fmF.JWM).experiments.projectTheming);
    if (projectState?.isProjectAdmin) variants.push((0, $c2fmF.JWM).userRole.projectAdmin);
    if (projectState?.userRole === (0, $fricC.USER_ROLE).JIRA_ADMIN) variants.push((0, $c2fmF.JWM).userRole.jiraAdmin);
    if (projectState?.userRole === (0, $fricC.USER_ROLE).SITE_ADMIN) variants.push((0, $c2fmF.JWM).userRole.siteAdmin);
    if (projectState?.isSampleProject) variants.push((0, $c2fmF.JWM).experiments.isSampleProject);
    else variants.push((0, $c2fmF.JWM).experiments.isNotSampleProject);
    if (projectState?.isTrelloCrossflow) variants.push((0, $c2fmF.JWM).experiments.trelloCrossflow);
    if ((0, $hFK9U.isTailoredQuickstartEnabled)(personaExperience)) {
        variants.push((0, $c2fmF.JWM).experiments.personalizedExperience);
        switch(personaExperience){
            case (0, $4vWp2.EXPERIENCE_TYPE).MARKETER_LEAD:
                variants.push((0, $c2fmF.JWM).personalizedExperienceExperiments.marketingLeader);
                break;
            case (0, $4vWp2.EXPERIENCE_TYPE).MARKETER_PROJECT:
                variants.push((0, $c2fmF.JWM).personalizedExperienceExperiments.projectMarketer);
                break;
            case (0, $4vWp2.EXPERIENCE_TYPE).MARKETER_CONTENT:
                variants.push((0, $c2fmF.JWM).personalizedExperienceExperiments.contentMarketer);
                break;
            case (0, $4vWp2.EXPERIENCE_TYPE).MARKETER_PMM:
                variants.push((0, $c2fmF.JWM).personalizedExperienceExperiments.productMarketingManager);
                break;
            default:
                break;
        }
    }
    return $62ef3d093ab58a52$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $c2fmF.JWM).taskVariants,
        taskList: (0, $c2fmF.JWM).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $62ef3d093ab58a52$var$createJsmTasks = (projectState, taskGroupParent)=>{
    const variants = [];
    variants.push((0, $3sCLn.JSM).experiments.projectTheming);
    if (projectState?.isProjectAdmin) variants.push((0, $3sCLn.JSM).userRole.projectAdmin);
    if (projectState?.userRole === (0, $fricC.USER_ROLE).JIRA_ADMIN) variants.push((0, $3sCLn.JSM).userRole.jiraAdmin);
    if (projectState?.userRole === (0, $fricC.USER_ROLE).SITE_ADMIN) variants.push((0, $3sCLn.JSM).userRole.siteAdmin);
    return $62ef3d093ab58a52$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $3sCLn.JSM).taskVariants,
        taskList: (0, $3sCLn.JSM).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $62ef3d093ab58a52$var$createDevopsTasks = (taskGroupParent)=>{
    const variants = [];
    return $62ef3d093ab58a52$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $kxycg.DEVOPS).taskVariants,
        taskList: (0, $kxycg.DEVOPS).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $62ef3d093ab58a52$export$d1f442602a91e7cc = ({ projectState: projectState, isDevOpsProject: isDevOpsProject, taskGroupParent: taskGroupParent, routeName: routeName, shouldShowScrumOnboardingExperience: shouldShowScrumOnboardingExperience, mountedNudges: mountedNudges, canCreateProject: canCreateProject, isEligibleToUpdateSitename: isEligibleToUpdateSitename, isCustomerTemplateProject: isCustomerTemplateProject, isCrossProjectBoardToPlanUpsell: isCrossProjectBoardToPlanUpsell, canEditPlans: canEditPlans, premiumTrialOnSignup: premiumTrialOnSignup, personaExperience: personaExperience })=>{
    if ((0, $5f5jN.isJwmProject)(projectState)) return $62ef3d093ab58a52$var$createJwmTasks(projectState, taskGroupParent, personaExperience);
    if ((0, $5f5jN.isJsmProject)(projectState)) return $62ef3d093ab58a52$var$createJsmTasks(projectState, taskGroupParent);
    if (isDevOpsProject) return $62ef3d093ab58a52$var$createDevopsTasks(taskGroupParent);
    return $62ef3d093ab58a52$var$createJswTasks(projectState, taskGroupParent, routeName, shouldShowScrumOnboardingExperience, mountedNudges, canCreateProject, isEligibleToUpdateSitename, isCustomerTemplateProject, isCrossProjectBoardToPlanUpsell, canEditPlans, premiumTrialOnSignup);
};

});
parcelRegister("fricC", function(module, exports) {

$parcel$export(module.exports, "USER_ROLE", () => $3def7289adf5e608$export$8eeb199b23203523);
const $3def7289adf5e608$export$8eeb199b23203523 = {
    END_USER: 'end-user',
    SITE_ADMIN: 'site-admin',
    JIRA_ADMIN: 'jira-admin'
};

});

parcelRegister("kxycg", function(module, exports) {

$parcel$export(module.exports, "DEVOPS", () => $503385b7e39437c3$export$bb75b6064c92010c);

var $bxltp = parcelRequire("bxltp");
const $503385b7e39437c3$export$bb75b6064c92010c = {
    taskList: (0, $bxltp.TASK_LIST),
    taskVariants: (0, $bxltp.TASK_VARIANTS),
    experiment: (0, $bxltp.Experiment)
};

});
parcelRegister("bxltp", function(module, exports) {

$parcel$export(module.exports, "Experiment", () => $7cc3b723e4b7a76f$export$4e0ab25c8a7e4009);
$parcel$export(module.exports, "TASK_LIST", () => $7cc3b723e4b7a76f$export$601c8c0f45aeb0a0);
$parcel$export(module.exports, "TASK_VARIANTS", () => $7cc3b723e4b7a76f$export$36f4d47dfe11b613);

var $7dRgX = parcelRequire("7dRgX");

var $ePWG3 = parcelRequire("ePWG3");
const $7cc3b723e4b7a76f$export$4e0ab25c8a7e4009 = {};
const $7cc3b723e4b7a76f$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: (0, $ePWG3.messages).rootTitle,
        items: [
            (0, $7dRgX.DEVOPS_WELCOME_TO_YOUR_PROJECT_TASK),
            (0, $7dRgX.DEVOPS_GET_TO_KNOW_JIRA_TASK),
            (0, $7dRgX.DEVOPS_NAVIGATE_YOUR_TOOLS_TASK),
            (0, $7dRgX.DEVOPS_CAPTURE_INTEGRATIONS_TASK),
            (0, $7dRgX.DEVOPS_CREATE_AUTOMATION_RULES_TASK),
            (0, $7dRgX.DEVOPS_INVITE_TEAMMATES_TASK),
            (0, $7dRgX.DEVOPS_FIND_HELP_TASK)
        ]
    }
});
const $7cc3b723e4b7a76f$export$36f4d47dfe11b613 = {
    [(0, $7dRgX.DEVOPS_WELCOME_TO_YOUR_PROJECT_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true
        }
    },
    [(0, $7dRgX.DEVOPS_GET_TO_KNOW_JIRA_TASK)]: {
        position: {
            default: 100
        },
        visibility: {
            default: true
        }
    },
    [(0, $7dRgX.DEVOPS_NAVIGATE_YOUR_TOOLS_TASK)]: {
        position: {
            default: 200
        },
        visibility: {
            default: true
        }
    },
    [(0, $7dRgX.DEVOPS_CAPTURE_INTEGRATIONS_TASK)]: {
        position: {
            default: 300
        },
        visibility: {
            default: true
        }
    },
    [(0, $7dRgX.DEVOPS_CREATE_AUTOMATION_RULES_TASK)]: {
        position: {
            default: 400
        },
        visibility: {
            default: true
        }
    },
    [(0, $7dRgX.DEVOPS_INVITE_TEAMMATES_TASK)]: {
        position: {
            default: 500
        },
        visibility: {
            default: true
        }
    },
    [(0, $7dRgX.DEVOPS_FIND_HELP_TASK)]: {
        position: {
            default: 600
        },
        visibility: {
            default: true
        }
    }
};

});
parcelRegister("ePWG3", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8c9ac3fc1eb167f1$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $8c9ac3fc1eb167f1$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.devops.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});



parcelRegister("3sCLn", function(module, exports) {

$parcel$export(module.exports, "JSM", () => $9ce9aa4e7fe0438e$export$63f289f2da861d35);

var $4Euci = parcelRequire("4Euci");
const $9ce9aa4e7fe0438e$export$63f289f2da861d35 = {
    taskList: (0, $4Euci.JSM_TASK_LIST),
    taskVariants: (0, $4Euci.JSM_TASK_VARIANTS),
    userRole: (0, $4Euci.UserRole),
    experiments: (0, $4Euci.Experiments)
};

});
parcelRegister("4Euci", function(module, exports) {

$parcel$export(module.exports, "JSM_TASK_LIST", () => $fb74ace10b289ae1$export$6c6c561944d49bcb);
$parcel$export(module.exports, "Experiments", () => $fb74ace10b289ae1$export$c8d6ffd15214553a);
$parcel$export(module.exports, "UserRole", () => $fb74ace10b289ae1$export$eb3485a690c2f0b8);
$parcel$export(module.exports, "JSM_TASK_VARIANTS", () => $fb74ace10b289ae1$export$5b68aef408c932d9);

var $7dRgX = parcelRequire("7dRgX");

var $aC2eo = parcelRequire("aC2eo");
const $fb74ace10b289ae1$export$6c6c561944d49bcb = Object.freeze({
    root: {
        title: (0, $aC2eo.messages).rootTitle,
        items: [
            (0, $7dRgX.JSM_REVIEW_YOUR_CHANNELS_TASK),
            (0, $7dRgX.JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK),
            (0, $7dRgX.JSM_INVITE_YOUR_TEAM_TASK)
        ]
    }
});
const $fb74ace10b289ae1$export$c8d6ffd15214553a = {
    projectTheming: 'projectTheming'
};
const $fb74ace10b289ae1$export$eb3485a690c2f0b8 = {
    projectAdmin: 'projectAdmin',
    jiraAdmin: 'jiraAdmin',
    siteAdmin: 'siteAdmin'
};
const $fb74ace10b289ae1$export$5b68aef408c932d9 = {
    [(0, $7dRgX.JSM_REVIEW_YOUR_CHANNELS_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true
        }
    },
    [(0, $7dRgX.JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK)]: {
        position: {
            default: 1
        },
        visibility: {
            default: true
        }
    },
    [(0, $7dRgX.JSM_INVITE_YOUR_TEAM_TASK)]: {
        position: {
            default: 2
        },
        visibility: {
            default: true
        }
    }
};

});
parcelRegister("aC2eo", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c73088a9cd2645bf$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $c73088a9cd2645bf$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jsm.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});



parcelRegister("2UWYK", function(module, exports) {

$parcel$export(module.exports, "JSW", () => $bddfc54f60451b1f$export$4cfe6e52f2e72a54);

var $8nR1z = parcelRequire("8nR1z");
const $bddfc54f60451b1f$export$4cfe6e52f2e72a54 = {
    taskList: (0, $8nR1z.TASK_LIST),
    taskVariants: (0, $8nR1z.TASK_VARIANTS),
    experiment: (0, $8nR1z.Experiment),
    experience: (0, $8nR1z.Experience),
    projectStyle: (0, $8nR1z.ProjectStyle),
    projectProperties: (0, $8nR1z.ProjectProperties),
    userRole: (0, $8nR1z.UserRole),
    edition: (0, $8nR1z.Edition),
    route: (0, $8nR1z.Route),
    permissions: (0, $8nR1z.Permissions),
    trait: (0, $8nR1z.Trait)
};

});
parcelRegister("8nR1z", function(module, exports) {

$parcel$export(module.exports, "Experiment", () => $7a9145b1fc208f16$export$4e0ab25c8a7e4009);
$parcel$export(module.exports, "Experience", () => $7a9145b1fc208f16$export$c90b54e658fc4d7c);
$parcel$export(module.exports, "ProjectStyle", () => $7a9145b1fc208f16$export$1f66f9f05afa05a8);
$parcel$export(module.exports, "ProjectProperties", () => $7a9145b1fc208f16$export$543c19ee8dba9252);
$parcel$export(module.exports, "UserRole", () => $7a9145b1fc208f16$export$eb3485a690c2f0b8);
$parcel$export(module.exports, "Edition", () => $7a9145b1fc208f16$export$6f4a0f769e61929);
$parcel$export(module.exports, "Route", () => $7a9145b1fc208f16$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "Permissions", () => $7a9145b1fc208f16$export$2d41982586bbb6be);
$parcel$export(module.exports, "Trait", () => $7a9145b1fc208f16$export$2d08cfa40d69142e);
$parcel$export(module.exports, "TASK_LIST", () => $7a9145b1fc208f16$export$601c8c0f45aeb0a0);
$parcel$export(module.exports, "TASK_VARIANTS", () => $7a9145b1fc208f16$export$36f4d47dfe11b613);

var $7dRgX = parcelRequire("7dRgX");

var $inMFY = parcelRequire("inMFY");
const $7a9145b1fc208f16$export$4e0ab25c8a7e4009 = {
    scrumOnboarding: 'experiment.scrumOnboarding',
    customizeSiteName: 'experiment.customizeSiteName',
    jswReverseTrial: 'experiment.jswReverseTrial',
    simplifyKanbanQS: 'experiment.simplifyKanbanQS'
};
const $7a9145b1fc208f16$export$c90b54e658fc4d7c = {
    kanbanOnboarding: 'experience.kanbanOnboarding',
    fedRamp: 'experience.fedRamp'
};
const $7a9145b1fc208f16$export$1f66f9f05afa05a8 = {
    teamManaged: 'projectStyle.teamManaged',
    companyManaged: 'projectStyle.companyManaged'
};
const $7a9145b1fc208f16$export$543c19ee8dba9252 = {
    isCreatedFromCustomerTemplate: 'projectProperties.isCreatedFromCustomerTemplate'
};
const $7a9145b1fc208f16$export$eb3485a690c2f0b8 = {
    siteAdmin: 'userRole.siteAdmin',
    jiraAdmin: 'userRole.jiraAdmin',
    admin: 'userRole.admin',
    projectAdmin: 'userRole.projectAdmin'
};
const $7a9145b1fc208f16$export$6f4a0f769e61929 = {
    free: 'productEdition.free',
    standard: 'productEdition.standard',
    premium: 'productEdition.premium'
};
const $7a9145b1fc208f16$export$e7b0ac011bb776c6 = {
    softwareRoadmap: 'route.softwareRoadmap',
    softwareBacklog: 'route.softwareBacklog',
    softwareBoard: 'route.softwareBoard',
    softwareList: 'route.softwareList',
    projectSettingsSoftwareAccess: 'route.projectSettingsSoftwareAccess',
    issue: 'route.issue',
    softwareCalendar: 'route.softwareCalendar'
};
const $7a9145b1fc208f16$export$2d41982586bbb6be = {
    notCanCreateProject: 'permissions.notCanCreateProject',
    hasPlanEditPermissions: 'permissions.hasPlanEditPermissions'
};
const $7a9145b1fc208f16$export$2d08cfa40d69142e = {
    crossProjectBoardToPlanUpsell: 'trait.crossProjectBoardToPlanUpsell'
};
const $7a9145b1fc208f16$var$DEFAULT_TASK_LIST = [
    (0, $7dRgX.ADD_COLUMNS_TASK),
    (0, $7dRgX.CREATE_PROJECT_TASK),
    (0, $7dRgX.CREATE_ISSUE_TASK),
    (0, $7dRgX.CREATE_ISSUE_TASK_SIMPLIFIED),
    (0, $7dRgX.TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK),
    (0, $7dRgX.INVITE_TEAMMATES_TASK),
    (0, $7dRgX.INVITE_TEAMMATES_VIDEO_TASK),
    (0, $7dRgX.CAPTURE_INTEGRATIONS_TASK),
    (0, $7dRgX.FIND_HELP_TASK),
    (0, $7dRgX.SET_UP_BOARD_TASK),
    (0, $7dRgX.GET_MOBILE_APP_TASK),
    (0, $7dRgX.PREMIUM_REVERSE_TRIAL_TASK),
    (0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK),
    (0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN),
    (0, $7dRgX.STANDARD_EDITION_OVERVIEW_TASK),
    (0, $7dRgX.MAP_OUT_YOUR_PROJECT_GOALS_TASK),
    (0, $7dRgX.IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK),
    (0, $7dRgX.IDENTIFY_SMALL_CHUNKS_OF_WORK_KANBAN_TASK),
    (0, $7dRgX.MONITOR_MANAGE_RISK_TASK),
    (0, $7dRgX.SCRUM_ONBOARDING_TASK),
    (0, $7dRgX.KANBAN_ONBOARDING_TASK),
    (0, $7dRgX.CUSTOMIZE_SITE_NAME_TASK),
    (0, $7dRgX.GET_TO_KNOW_YOUR_TEMPLATE_TASK),
    (0, $7dRgX.CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK),
    (0, $7dRgX.GET_STARTED_LIST_TASK),
    (0, $7dRgX.CALENDAR_VIEW_TASK)
];
const $7a9145b1fc208f16$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: (0, $inMFY.messages).rootTitle,
        items: $7a9145b1fc208f16$var$DEFAULT_TASK_LIST
    },
    reverseTrialRoot: {
        title: (0, $inMFY.messages).reverseTrialRootTitle,
        items: $7a9145b1fc208f16$var$DEFAULT_TASK_LIST
    },
    [(0, $7dRgX.PREMIUM_REVERSE_TRIAL_TASK)]: {
        title: (0, $inMFY.messages).reverseTrialCardTitle,
        items: [
            (0, $7dRgX.ADVANCED_ROADMAPS_TASK),
            (0, $7dRgX.CHANGE_CONTROL_TASK),
            (0, $7dRgX.AUTOMATIONS_TASK),
            (0, $7dRgX.SITE_ADMINISTRATIONS_TASK),
            (0, $7dRgX.USER_MANAGEMENT_TASK)
        ]
    },
    [(0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK)]: {
        title: (0, $inMFY.messages).premiumPlanTitle,
        items: [
            (0, $7dRgX.ADVANCED_ROADMAPS_TASK),
            (0, $7dRgX.CHANGE_CONTROL_TASK),
            (0, $7dRgX.AUTOMATIONS_TASK),
            (0, $7dRgX.SITE_ADMINISTRATIONS_TASK),
            (0, $7dRgX.USER_MANAGEMENT_TASK)
        ]
    },
    [(0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)]: {
        title: (0, $inMFY.messages).premiumPlanTitle,
        items: [
            (0, $7dRgX.ADVANCED_ROADMAPS_TASK),
            (0, $7dRgX.AUTOMATIONS_TASK)
        ]
    },
    [(0, $7dRgX.STANDARD_EDITION_OVERVIEW_TASK)]: {
        title: (0, $inMFY.messages).standardPlanTitle,
        items: [
            (0, $7dRgX.AUTOMATIONS_TASK),
            (0, $7dRgX.USER_MANAGEMENT_TASK),
            (0, $7dRgX.SITE_ADMINISTRATIONS_TASK)
        ]
    }
});
const $7a9145b1fc208f16$var$PLAN_ONBOARDING_TASKS = {
    [(0, $7dRgX.PREMIUM_REVERSE_TRIAL_TASK)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.jswReverseTrial,
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK)]: {
        position: {
            default: 100,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyKanbanQS
                    ],
                    value: 900
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.jswReverseTrial,
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)]: {
        position: {
            default: 100,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyKanbanQS
                    ],
                    value: 900
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    // This condition needs to be the opposite condition to PREMIUM_EDITION_OVERVIEW_TASK
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.jswReverseTrial,
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $7a9145b1fc208f16$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.STANDARD_EDITION_OVERVIEW_TASK)]: {
        position: {
            default: 100,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyKanbanQS
                    ],
                    value: 900
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.standard,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.ADVANCED_ROADMAPS_TASK)]: {
        position: {
            default: 105
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $7a9145b1fc208f16$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.AUTOMATIONS_TASK)]: {
        position: {
            default: 110
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $7a9145b1fc208f16$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.standard,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.USER_MANAGEMENT_TASK)]: {
        position: {
            default: 115
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.standard,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.CHANGE_CONTROL_TASK)]: {
        position: {
            default: 120
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.SITE_ADMINISTRATIONS_TASK)]: {
        position: {
            default: 125
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.standard,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                }
            ]
        }
    }
};
const $7a9145b1fc208f16$var$CUSTOMER_TEMPLATE_ONBOARDING_TASKS = {
    [(0, $7dRgX.GET_TO_KNOW_YOUR_TEMPLATE_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$543c19ee8dba9252.isCreatedFromCustomerTemplate,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                }
            ]
        }
    }
};
const $7a9145b1fc208f16$export$36f4d47dfe11b613 = {
    ...$7a9145b1fc208f16$var$PLAN_ONBOARDING_TASKS,
    ...$7a9145b1fc208f16$var$CUSTOMER_TEMPLATE_ONBOARDING_TASKS,
    [(0, $7dRgX.CREATE_PROJECT_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$2d41982586bbb6be.notCanCreateProject
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$543c19ee8dba9252.isCreatedFromCustomerTemplate
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.CUSTOMIZE_SITE_NAME_TASK)]: {
        position: {
            default: 50
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.siteAdmin,
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.customizeSiteName
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.CALENDAR_VIEW_TASK)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    value: true,
                    condition: [
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareCalendar
                    ]
                }
            ]
        }
    },
    [(0, $7dRgX.SCRUM_ONBOARDING_TASK)]: {
        position: {
            default: 150
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.siteAdmin,
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.scrumOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBacklog
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.KANBAN_ONBOARDING_TASK)]: {
        position: {
            default: 150
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyKanbanQS
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.MAP_OUT_YOUR_PROJECT_GOALS_TASK)]: {
        position: {
            default: 150
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK)]: {
        position: {
            default: 151
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.IDENTIFY_SMALL_CHUNKS_OF_WORK_KANBAN_TASK)]: {
        position: {
            default: 151
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyKanbanQS,
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.MONITOR_MANAGE_RISK_TASK)]: {
        position: {
            default: 152
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.SET_UP_BOARD_TASK)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyKanbanQS,
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.projectAdmin,
                        $7a9145b1fc208f16$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.CREATE_ISSUE_TASK)]: {
        position: {
            default: 300
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.CREATE_ISSUE_TASK_SIMPLIFIED)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyKanbanQS,
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.ADD_COLUMNS_TASK)]: {
        position: {
            default: 310
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyKanbanQS,
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.GET_STARTED_LIST_TASK)]: {
        position: {
            default: 320
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK)]: {
        position: {
            default: 350
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyKanbanQS,
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.INVITE_TEAMMATES_TASK)]: {
        position: {
            default: 400
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.projectAdmin,
                        $7a9145b1fc208f16$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin,
                        $7a9145b1fc208f16$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.INVITE_TEAMMATES_VIDEO_TASK)]: {
        position: {
            default: 400,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyKanbanQS,
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: 600
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.projectAdmin,
                        $7a9145b1fc208f16$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin,
                        $7a9145b1fc208f16$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.CAPTURE_INTEGRATIONS_TASK)]: {
        position: {
            default: 500
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.fedRamp
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.GET_MOBILE_APP_TASK)]: {
        position: {
            default: 600
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.fedRamp
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyKanbanQS,
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.FIND_HELP_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyKanbanQS,
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK)]: {
        position: {
            default: 800
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$2d41982586bbb6be.notCanCreateProject
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.simplifyKanbanQS,
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                }
            ]
        }
    }
};

});
parcelRegister("inMFY", function(module, exports) {

$parcel$export(module.exports, "messages", () => $52d99860e7a60493$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $52d99860e7a60493$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jsw.root-title.no-translate",
        "defaultMessage": "Quickstart"
    },
    premiumPlanTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.premium-plan-title",
        "defaultMessage": "Included in your Premium plan"
    },
    standardPlanTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.standard-plan-title",
        "defaultMessage": "Your Standard plan"
    },
    reverseTrialRootTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.reverse-trial-root-title",
        "defaultMessage": "Your 30-day Premium trial"
    },
    reverseTrialCardTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.reverse-trial-card-title",
        "defaultMessage": "Included in your Premium trial"
    }
});

});



parcelRegister("c2fmF", function(module, exports) {

$parcel$export(module.exports, "JWM", () => $562f552a719c049d$export$3ff26c80cb588e12);

var $l40o4 = parcelRequire("l40o4");

var $hBhFD = parcelRequire("hBhFD");

var $kN5DK = parcelRequire("kN5DK");
const $562f552a719c049d$export$3ff26c80cb588e12 = {
    taskList: (0, $l40o4.TASK_LIST),
    taskVariants: (0, $l40o4.TASK_VARIANTS),
    userRole: (0, $kN5DK.UserRole),
    experiments: (0, $hBhFD.Experiments),
    personalizedExperienceExperiments: (0, $hBhFD.PersonalizedExperienceExperiments)
};

});
parcelRegister("l40o4", function(module, exports) {

$parcel$export(module.exports, "TASK_LIST", () => $0a485b7af0b81750$export$601c8c0f45aeb0a0);
$parcel$export(module.exports, "TASK_VARIANTS", () => $0a485b7af0b81750$export$36f4d47dfe11b613);

var $7dRgX = parcelRequire("7dRgX");

var $hBhFD = parcelRequire("hBhFD");

var $1deRh = parcelRequire("1deRh");

var $kN5DK = parcelRequire("kN5DK");
const $0a485b7af0b81750$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: (0, $1deRh.messages).rootTitle,
        items: [
            (0, $7dRgX.JWM_CREATE_PROJECT_TASK),
            (0, $7dRgX.JWM_TRELLO_CROSSFLOW_TASK_IMPORT),
            (0, $7dRgX.JWM_SUMMARY_AND_REPORTS_TASK),
            (0, $7dRgX.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK),
            (0, $7dRgX.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES),
            (0, $7dRgX.JWM_CREATE_SAMPLE_PROJECT_TASK),
            (0, $7dRgX.JWM_PROJECT_SUMMARY_TASK),
            (0, $7dRgX.JWM_GET_STARTED_LIST_TASK),
            (0, $7dRgX.JWM_CALENDAR_TASK),
            (0, $7dRgX.JWM_BOARD_TASK),
            (0, $7dRgX.JWM_TIMELINE_TASK),
            (0, $7dRgX.JWM_BUILD_FORM_TASK),
            (0, $7dRgX.JWM_BACKGROUND_COLOR_TASK),
            (0, $7dRgX.JWM_FEEDBACK_TASK),
            (0, $7dRgX.JWM_FEEDBACK_SAMPLE_PROJECT_TASK),
            (0, $7dRgX.JWM_SHARE_PROJECT_TASK),
            (0, $7dRgX.JWM_CREATE_YOUR_OWN_PROJECT_TASK),
            (0, $7dRgX.JWM_SUMMARY_TASK),
            (0, $7dRgX.JWM_INVITE_TEAM_TASK),
            (0, $7dRgX.JWM_PAGES_TASK)
        ]
    }
});
const $0a485b7af0b81750$export$36f4d47dfe11b613 = {
    [(0, $7dRgX.JWM_CREATE_PROJECT_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES)]: {
        position: {
            default: 15
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isNotSampleProject,
                        (0, $hBhFD.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_CREATE_SAMPLE_PROJECT_TASK)]: {
        position: {
            default: 40
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_PROJECT_SUMMARY_TASK)]: {
        position: {
            default: 50
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_GET_STARTED_LIST_TASK)]: {
        position: {
            default: 100
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_CALENDAR_TASK)]: {
        position: {
            default: 200,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience,
                        (0, $hBhFD.PersonalizedExperienceExperiments).contentMarketer
                    ],
                    value: 60
                }
            ]
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience,
                        (0, $hBhFD.PersonalizedExperienceExperiments).projectMarketer
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_BOARD_TASK)]: {
        position: {
            default: 250
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_TIMELINE_TASK)]: {
        position: {
            default: 300
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience,
                        (0, $hBhFD.PersonalizedExperienceExperiments).contentMarketer
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_PAGES_TASK)]: {
        position: {
            default: 375,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience,
                        (0, $hBhFD.PersonalizedExperienceExperiments).projectMarketer
                    ],
                    value: 325
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience,
                        (0, $hBhFD.PersonalizedExperienceExperiments).marketingLeader
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_SUMMARY_TASK)]: {
        position: {
            default: 350
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_BUILD_FORM_TASK)]: {
        position: {
            default: 400
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience,
                        (0, $hBhFD.PersonalizedExperienceExperiments).contentMarketer
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK)]: {
        position: {
            default: 425
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isNotSampleProject,
                        (0, $hBhFD.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_SUMMARY_AND_REPORTS_TASK)]: {
        position: {
            default: 450
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isNotSampleProject,
                        (0, $hBhFD.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_BACKGROUND_COLOR_TASK)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).projectTheming,
                        (0, $kN5DK.UserRole).jiraAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).projectTheming,
                        (0, $kN5DK.UserRole).siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).projectTheming,
                        (0, $kN5DK.UserRole).projectAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_INVITE_TEAM_TASK)]: {
        position: {
            default: 550
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_SHARE_PROJECT_TASK)]: {
        position: {
            default: 600
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_TRELLO_CROSSFLOW_TASK_IMPORT)]: {
        position: {
            default: 650
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isNotSampleProject,
                        (0, $hBhFD.Experiments).trelloCrossflow,
                        (0, $kN5DK.UserRole).siteAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_FEEDBACK_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_FEEDBACK_SAMPLE_PROJECT_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_CREATE_YOUR_OWN_PROJECT_TASK)]: {
        position: {
            default: 800
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject,
                        (0, $kN5DK.UserRole).jiraAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject,
                        (0, $kN5DK.UserRole).siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject,
                        (0, $kN5DK.UserRole).projectAdmin
                    ],
                    value: true
                }
            ]
        }
    }
};

});
parcelRegister("hBhFD", function(module, exports) {

$parcel$export(module.exports, "Experiments", () => $602d627ebd2e1820$export$c8d6ffd15214553a);
$parcel$export(module.exports, "PersonalizedExperienceExperiments", () => $602d627ebd2e1820$export$ce14e6ba2f059143);
const $602d627ebd2e1820$export$c8d6ffd15214553a = {
    projectTheming: 'projectTheming',
    isSampleProject: 'isSampleProject',
    isNotSampleProject: 'isNotSampleProject',
    trelloCrossflow: 'trelloCrossflow',
    personalizedExperience: 'personalizedExperience'
};
const $602d627ebd2e1820$export$ce14e6ba2f059143 = {
    marketingLeader: 'personalizedExperience.marketing-leader',
    contentMarketer: 'personalizedExperience.content-marketer',
    projectMarketer: 'personalizedExperience.project-marketer',
    productMarketingManager: 'personalizedExperience.pmm'
};

});

parcelRegister("1deRh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9c87cc11a21af694$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $9c87cc11a21af694$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jwm.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});

parcelRegister("kN5DK", function(module, exports) {

$parcel$export(module.exports, "UserRole", () => $c7f18eb8f889bc31$export$eb3485a690c2f0b8);
const $c7f18eb8f889bc31$export$eb3485a690c2f0b8 = {
    projectAdmin: 'projectAdmin',
    jiraAdmin: 'jiraAdmin',
    siteAdmin: 'siteAdmin'
};

});



parcelRegister("2hhuw", function(module, exports) {

$parcel$export(module.exports, "getTasks", () => $1a771609d4c77a5c$export$20b82b4a32771893);

var $kfb7k = parcelRequire("kfb7k");
const $1a771609d4c77a5c$var$getTaskVisibility = (variants, visibility)=>visibility !== undefined ? (0, $kfb7k.getConditional)(visibility, variants) : true;
const $1a771609d4c77a5c$var$getTaskPosition = (variants, position)=>(0, $kfb7k.getConditional)(position, variants);
const $1a771609d4c77a5c$export$20b82b4a32771893 = (variants, taskVariants, taskList)=>taskList.filter((task)=>$1a771609d4c77a5c$var$getTaskVisibility(variants, taskVariants[task].visibility)).sort((taskA, taskB)=>$1a771609d4c77a5c$var$getTaskPosition(variants, taskVariants[taskA].position) - $1a771609d4c77a5c$var$getTaskPosition(variants, taskVariants[taskB].position));

});
parcelRegister("kfb7k", function(module, exports) {

$parcel$export(module.exports, "getConditional", () => $75b9324579affeba$export$fe3161cde0106bba);
const $75b9324579affeba$export$fe3161cde0106bba = ({ conditional: conditions, default: defaultValue }, variants)=>{
    if (conditions === undefined) return defaultValue;
    const variantsIncludesCondition = (c)=>variants.includes(c);
    const conditionObj = conditions.find(({ condition: condition })=>condition.every(variantsIncludesCondition));
    return conditionObj ? conditionObj.value : defaultValue;
};

});


parcelRegister("5f5jN", function(module, exports) {

$parcel$export(module.exports, "isJwmProject", () => $4c12cc14f77b8d26$export$ea2e5a5c1a1a6748);
$parcel$export(module.exports, "isJsmProject", () => $4c12cc14f77b8d26$export$a972ed853ed1d469);

var $7ZZxN = parcelRequire("7ZZxN");
const $4c12cc14f77b8d26$export$ea2e5a5c1a1a6748 = (projectState)=>projectState?.projectType === (0, $7ZZxN.CORE_PROJECT);
const $4c12cc14f77b8d26$export$a972ed853ed1d469 = (projectState)=>projectState?.projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT);

});




parcelRegister("lCsoa", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $eba3eaa3fc426760$export$d4c72bab9d6cc13a);

var $7dRgX = parcelRequire("7dRgX");
const $eba3eaa3fc426760$export$d4c72bab9d6cc13a = {
    shouldRenderComponent: false,
    completedTaskList: [],
    hasSeenTasks: [],
    isDismissed: true,
    isOpen: false,
    isFocusedOn: false,
    openTask: '',
    projectState: null,
    hasNudgeActive: false,
    isQuickstartLoaded: false,
    isDevOpsProject: false,
    nudgeStep: '',
    mountedNudges: [],
    hasEverSeenRoute: {
        'jsw.onboarding.experiment.personalised.onboarding.ntkw.onboarding.it2.roadmap': false
    },
    roadmapIsCreateEnabled: false,
    roadmapIsListEmpty: true,
    previousTaskGroupParents: [],
    currentTaskGroupParent: (0, $7dRgX.ROOT_TASK),
    selectedProjectTemplateKeyFromOnboarding: undefined,
    isEligibleToUpdateSitename: false,
    isCrossProjectBoardToPlanUpsell: false,
    canEditPlans: false,
    visibility: {
        [(0, $7dRgX.QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY]: (0, $7dRgX.QUICKSTART_UI_STATUS).NOT_LOADED,
        [(0, $7dRgX.QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY]: (0, $7dRgX.QUICKSTART_UI_STATUS).NOT_LOADED
    }
};

});

parcelRegister("7AH2S", function(module, exports) {

$parcel$export(module.exports, "useOrgId", () => $eea7a281b809b1c9$export$52a03a3207af3687);

var $eUqFw = parcelRequire("eUqFw");

var $dWLk9 = parcelRequire("dWLk9");
var $1R3n5 = parcelRequire("1R3n5");

var $9qoWk = parcelRequire("9qoWk");
const $eea7a281b809b1c9$export$52a03a3207af3687 = ()=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const [{ value: value }, { fetchOrgId: fetchOrgId }] = (0, $9qoWk.useLinkedOrg)();
    (0, $eUqFw.useEffect)(()=>{
        if (isSiteAdmin) fetchOrgId(cloudId);
    }, [
        fetchOrgId,
        isSiteAdmin,
        cloudId
    ]);
    return value;
};

});
parcelRegister("9qoWk", function(module, exports) {

$parcel$export(module.exports, "useLinkedOrg", () => $136457ccda5882c7$export$cefa7c513db62fe3);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $k0YUt = parcelRequire("k0YUt");
const $136457ccda5882c7$var$actions = {
    fetchOrgId: $k0YUt.fetchOrgId
};
const $136457ccda5882c7$var$initialState = {
    isFetching: false,
    wasFetched: false,
    fetchedOnce: false
};
const $136457ccda5882c7$var$Store = (0, $a61MH.createStore)({
    initialState: $136457ccda5882c7$var$initialState,
    actions: $136457ccda5882c7$var$actions,
    name: 'jsw-onboarding-quickstart-linked-org'
});
const $136457ccda5882c7$export$cefa7c513db62fe3 = (0, $ggKAj.createHook)($136457ccda5882c7$var$Store);

});
parcelRegister("k0YUt", function(module, exports) {

$parcel$export(module.exports, "fetchOrgId", () => $1a44f805e278eb93$export$c78d9b18cf152ce8);

var $lIoQU = parcelRequire("lIoQU");

var $5IvqT = parcelRequire("5IvqT");

var $38Uht = parcelRequire("38Uht");
const $1a44f805e278eb93$export$5a762450d50ca901 = async (cloudId)=>{
    try {
        const result = await (0, $38Uht.getLinkedOrg)(cloudId);
        return result.id;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $lIoQU.fireAPIErrorAnalytics)(error, 'getLinkedOrg');
    }
    return null;
};
const $1a44f805e278eb93$export$c78d9b18cf152ce8 = (0, $5IvqT.cachedEndpointCall)($1a44f805e278eb93$export$5a762450d50ca901);

});
parcelRegister("5IvqT", function(module, exports) {

$parcel$export(module.exports, "cachedEndpointCall", () => $a81d42548e97f6e6$export$9ab04ab45a9b99da);
const $a81d42548e97f6e6$export$9ab04ab45a9b99da = (call)=>(props)=>async ({ getState: getState, setState: setState })=>{
            const { isFetching: isFetching, wasFetched: wasFetched, fetchedOnce: fetchedOnce } = getState();
            if (isFetching) return;
            if (wasFetched) return;
            setState({
                isFetching: true
            });
            const value = await call(props);
            if (value !== null) setState({
                value: value,
                isFetching: false,
                wasFetched: true,
                fetchedOnce: true
            });
            else setState({
                isFetching: false,
                wasFetched: fetchedOnce,
                fetchedOnce: true
            });
        };

});

parcelRegister("38Uht", function(module, exports) {

$parcel$export(module.exports, "getLinkedOrg", () => $3ce7ef8e40b0a0d5$export$fee654dbe03c901f);

var $2OdyW = parcelRequire("2OdyW");
const $3ce7ef8e40b0a0d5$export$fee654dbe03c901f = (cloudId)=>(0, $2OdyW.default)(`/gateway/api/adminhub/sites/${cloudId}/linked-org`, {
        method: 'GET'
    });

});





parcelRegister("57SqH", function(module, exports) {

$parcel$export(module.exports, "useSidebarData", () => $d2cfb77d49815540$export$f9257874e114985c);

var $eUqFw = parcelRequire("eUqFw");

var $8blac = parcelRequire("8blac");

var $44GOl = parcelRequire("44GOl");

var $dQZ5c = parcelRequire("dQZ5c");

var $f26dB = parcelRequire("f26dB");

var $3xyNB = parcelRequire("3xyNB");
const $d2cfb77d49815540$export$f9257874e114985c = ()=>{
    const { project: currentProject } = (0, $44GOl.useNavigationProject)();
    const { data: data, update: update, refresh: refresh, loading: loading } = (0, $f26dB.useNavigationResource)();
    const { changeFavourite: changeFavourite, items: { projects: changedItems } } = (0, $dQZ5c.useChangeFavourite)();
    const isRefreshingFavorites = (0, $eUqFw.useRef)(false);
    const hasRefreshedOnce = (0, $eUqFw.useRef)(false);
    const onFavoriteToggle = (0, $eUqFw.useCallback)((project)=>{
        changeFavourite({
            id: String(project.id),
            type: 'projects',
            value: !project.isFavorite
        });
    }, [
        changeFavourite
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(changedItems) && !Object.values(changedItems).some(({ pending: pending })=>pending)) {
            isRefreshingFavorites.current = true;
            refresh();
        }
    }, [
        changedItems,
        refresh
    ]);
    (0, $eUqFw.useEffect)(()=>{
        isRefreshingFavorites.current = false;
    }, [
        data
    ]);
    let recents;
    let favorites;
    let hasMoreFavorite;
    let overviews;
    let overviewsError;
    let isPremiumUserSeat;
    let showPlansOnboarding;
    let shouldHideOverviews;
    if (data == null || data === (0, $02a4cc31089f6443$export$e8958a6508ec5b71)) {
        // if the resource was initially fetched for a not applicable project (i.e. not a business project)
        // on the initial page load, then we have not yet fetched the list of sidebar business projects
        // we thus refresh the resource in the background now that we are in a business project
        if (data === (0, $02a4cc31089f6443$export$e8958a6508ec5b71) && !hasRefreshedOnce.current) {
            hasRefreshedOnce.current = true;
            refresh();
        }
        recents = [];
        favorites = [];
        hasMoreFavorite = false;
        overviews = [];
        overviewsError = null;
        isPremiumUserSeat = false;
        showPlansOnboarding = false;
        shouldHideOverviews = false;
    } else {
        recents = data.recents;
        favorites = data.favorites;
        hasMoreFavorite = data.hasMoreFavorite;
        overviews = data.overviews;
        overviewsError = data.overviewsError;
        isPremiumUserSeat = data.isPremiumUserSeat;
        showPlansOnboarding = data.showPlansOnboarding;
        shouldHideOverviews = data.shouldHideOverviews;
    }
    // if the current is not in either recents or favorites, push it to the top of recents
    if (currentProject != null && !recents.some((project)=>project.id === currentProject.id) && !favorites.some((project)=>project.id === currentProject.id)) {
        recents = (0, $3xyNB.prependProject)(currentProject, recents);
        // make sure that the reference doesn't get overwritten for the resource update below
        const newRecents = recents;
        update(()=>({
                recents: newRecents,
                favorites: favorites,
                hasMoreFavorite: hasMoreFavorite,
                overviews: overviews,
                overviewsError: overviewsError,
                isPremiumUserSeat: isPremiumUserSeat,
                showPlansOnboarding: showPlansOnboarding,
                shouldHideOverviews: shouldHideOverviews
            }));
    }
    // if there are changes to favorites, update projects
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(changedItems)) {
        recents = recents.map((project)=>(0, $3xyNB.mapProjectChanges)(project, changedItems));
        favorites = favorites.map((project)=>(0, $3xyNB.mapProjectChanges)(project, changedItems));
    }
    return {
        currentProject: currentProject,
        recents: recents,
        favorites: favorites,
        hasMoreFavorite: hasMoreFavorite,
        onFavoriteToggle: onFavoriteToggle,
        overviews: overviews,
        overviewsError: overviewsError,
        shouldHideOverviews: shouldHideOverviews,
        loading: loading && !isRefreshingFavorites.current
    };
};

});
parcelRegister("44GOl", function(module, exports) {

$parcel$export(module.exports, "useNavigationProject", () => $8449ba04d8e31c91$export$befd5d7ebc77f264);

var $kJlBc = parcelRequire("kJlBc");

var $f26dB = parcelRequire("f26dB");

var $aeIT6 = parcelRequire("aeIT6");
const $8449ba04d8e31c91$export$befd5d7ebc77f264 = ()=>{
    const { data: currentProject, loading: currentProjectLoading } = (0, $aeIT6.useProject)();
    const { data: navigationData, loading: navigationDataLoading } = (0, $f26dB.useNavigationResource)();
    const [{ match: { params: { projectKey: projectKey } } }] = (0, $kJlBc.useRouter)();
    if (currentProject != null) return {
        project: currentProject,
        loading: currentProjectLoading
    };
    if (projectKey != null && navigationData != null && navigationData !== (0, $02a4cc31089f6443$export$e8958a6508ec5b71)) {
        const project = navigationData.favorites.find((proj)=>proj.key === projectKey) ?? navigationData.recents.find((proj)=>proj.key === projectKey) ?? null;
        return {
            project: project,
            loading: navigationDataLoading
        };
    }
    return {
        project: null,
        loading: currentProjectLoading || navigationDataLoading
    };
};

});

parcelRegister("3xyNB", function(module, exports) {

$parcel$export(module.exports, "prependProject", () => $1f9254ac774c5f12$export$9e33a1a4f95ad56f);
$parcel$export(module.exports, "mapProjectChanges", () => $1f9254ac774c5f12$export$6cb16ed8ac180dfc);

const $1f9254ac774c5f12$export$9e33a1a4f95ad56f = (project, projects)=>[
        project,
        ...projects
    ].slice(0, (0, $02a4cc31089f6443$export$3349219a88ac77cd));
const $1f9254ac774c5f12$export$6cb16ed8ac180dfc = (project, changedItems)=>project.id in changedItems ? {
        ...project,
        isFavorite: changedItems[project.id].value
    } : project;

});


parcelRegister("lym21", function(module, exports) {

$parcel$export(module.exports, "CallToActionType", () => $a66fc9a417117294$export$f6430504236946cc);
$parcel$export(module.exports, "getCallToActionType", () => $a66fc9a417117294$export$2e8902356a23bf22);

var $41WOo = parcelRequire("41WOo");

var $fUoOQ = parcelRequire("fUoOQ");
const $a66fc9a417117294$export$f6430504236946cc = {
    CREATE_PROJECT_BANNER: 'createProjectBanner',
    CREATE_PROJECT_BUTTON: 'createProjectButton',
    CREATE_PROJECT_NONE: 'createProjectNone',
    TRIAL_BANNER: 'trialBanner',
    NONE: 'none'
};
const $a66fc9a417117294$export$2e8902356a23bf22 = (isSampleProject)=>{
    const isProjectStateLoaded = typeof isSampleProject === 'boolean';
    if (isProjectStateLoaded) {
        let createProjectCtaType = 'none';
        if (isSampleProject) {
            // check the cohort, but don't fire the exposure event
            createProjectCtaType = (0, $41WOo.getJwmHelpSampleUsersCreateProjectsCtaType)();
            if (createProjectCtaType === 'button') return $a66fc9a417117294$export$f6430504236946cc.CREATE_PROJECT_BUTTON;
            if (createProjectCtaType === 'banner') return $a66fc9a417117294$export$f6430504236946cc.CREATE_PROJECT_BANNER;
            return $a66fc9a417117294$export$f6430504236946cc.CREATE_PROJECT_NONE;
        }
        if ((0, $41WOo.isJwmMonetizationExperimentEnabled)()) return $a66fc9a417117294$export$f6430504236946cc.TRIAL_BANNER;
    }
    /*
    we should end up here in the following cases:
    - we don't know whether we're in a sample project
    - we're not in a sample project and the monetization experiment is not enabled
    */ return $a66fc9a417117294$export$f6430504236946cc.NONE;
};

});
parcelRegister("fUoOQ", function(module, exports) {

$parcel$export(module.exports, "CreateProjectCta", () => $4c9b0d5298cf5830$export$f49a4235d24dbad0);

var $eUqFw = parcelRequire("eUqFw");

var $j1JdL = parcelRequire("j1JdL");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");
const $4c9b0d5298cf5830$var$runtimeProps = {};
const $4c9b0d5298cf5830$var$entryPointParams = {};
const $4c9b0d5298cf5830$export$f49a4235d24dbad0 = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $j1JdL.createProjectCtaEntryPoint), $4c9b0d5298cf5830$var$entryPointParams);
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "jira-business-create-project-cta-entrypoint",
        packageName: "@atlassian/jira-business-create-project-cta",
        teamName: "A4T-Werewolves",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: $4c9b0d5298cf5830$var$runtimeProps,
        errorFallback: "unmount"
    });
};

});
parcelRegister("j1JdL", function(module, exports) {

$parcel$export(module.exports, "createProjectCtaEntryPoint", () => $20f4d66eaf9284b5$export$7dadecc7d161da03);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $20f4d66eaf9284b5$export$7dadecc7d161da03 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("lwXpd")), {
        moduleId: "0c73c6d1"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("lwXpd", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('gcXnX')
        ]);
        const value = parcelRequire('1kWB8');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("gcXnX")
    ]).then(()=>parcelRequire('1kWB8'));
}

});




parcelRegister("gTasH", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c51ef7ea6f1c863$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $7u4fN = parcelRequire("7u4fN");

var $eFKPp = parcelRequire("eFKPp");

var $5xIu6 = parcelRequire("5xIu6");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1pW4J = parcelRequire("1pW4J");

var $hWTey = parcelRequire("hWTey");

var $3PsZt = parcelRequire("3PsZt");
const $8c51ef7ea6f1c863$var$FEEDBACK_GROUP_ID = 'jbus-feedback';
const $8c51ef7ea6f1c863$var$FeedbackButton = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const openFeedbackModal = (0, $5xIu6.useFeedbackCollector)();
    const buttonRef = (0, $eUqFw.useRef)(null);
    const renderNudgeWrapper = (0, $eUqFw.useCallback)((children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hWTey.FeedbackNudgeAsync), null, children), []);
    const onClick = (0, $eUqFw.useCallback)(()=>{
        openFeedbackModal($8c51ef7ea6f1c863$var$FEEDBACK_GROUP_ID, (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), buttonRef);
    }, [
        openFeedbackModal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1pW4J.QuickstartNudge), {
        renderWrapper: renderNudgeWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        ref: buttonRef,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eFKPp))), {
            label: "",
            size: "small"
        }),
        appearance: "subtle-link",
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8c51ef7ea6f1c863$var$Content, null, formatMessage((0, $3PsZt.default).feedback))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8c51ef7ea6f1c863$var$Content = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyb1crf",
            __cmplp.className
        ])
    });
});
var $8c51ef7ea6f1c863$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($8c51ef7ea6f1c863$var$FeedbackButton);

});
parcelRegister("eFKPp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aae9381df7a9f99a$var$_react = $aae9381df7a9f99a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $aae9381df7a9f99a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $aae9381df7a9f99a$var$EditorFeedbackIcon = (props)=>/*#__PURE__*/ $aae9381df7a9f99a$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M10.922 14.517L5.87 12.68l-.932-.339C4.418 12.151 4 11.552 4 11c0-.556.42-1.153.938-1.341l9.124-3.318c.52-.19.938.105.938.654v8.01c0 .54-.42.842-.938.654l-3.14-1.142zM6 14.227l2 .728V17c0 .552-.405 1.202-.895 1.447l-.21.106C6.4 18.8 6 18.549 6 18.009v-3.782zm11.224-4.78a.5.5 0 11-.448-.894l2-1a.5.5 0 11.448.894l-2 1zm-.448 4a.5.5 0 01.448-.894l2 1a.5.5 0 01-.448.894l-2-1zM17 11.5a.5.5 0 110-1h3a.5.5 0 110 1h-3z" fill="currentColor"/></svg>`
    }, props));
$aae9381df7a9f99a$var$EditorFeedbackIcon.displayName = 'EditorFeedbackIcon';
var $aae9381df7a9f99a$var$_default = $aae9381df7a9f99a$var$EditorFeedbackIcon;
module.exports.default = $aae9381df7a9f99a$var$_default;

});

parcelRegister("5xIu6", function(module, exports) {

$parcel$export(module.exports, "useFeedbackCollector", () => $41c842a9ff9149b0$export$4be696be8a3bff13);

var $eUqFw = parcelRequire("eUqFw");

var $1c02D = parcelRequire("1c02D");
var $irg9D = parcelRequire("irg9D");

var $5JgJ2 = parcelRequire("5JgJ2");

var $10fdS = parcelRequire("10fdS");

var $bNe1g = parcelRequire("bNe1g");

var $c7H0g = parcelRequire("c7H0g");
var $gd0Sp = parcelRequire("gd0Sp");

var $6YoSc = parcelRequire("6YoSc");

var $loHEm = parcelRequire("loHEm");
const $41c842a9ff9149b0$export$698ff856156a88fe = /*#__PURE__*/ (0, $eUqFw.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $6YoSc.default).canContactPrompt), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        href: "https://www.atlassian.com/legal/privacy-policy",
        target: "_blank",
        rel: "noopener noreferrer"
    }, formatMessage((0, $6YoSc.default).canContactPromptLink)));
});
const $41c842a9ff9149b0$export$4f77effad9540593 = /*#__PURE__*/ (0, $eUqFw.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $6YoSc.default).enrollInResearchPrompt, {
        link: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
            href: "https://www.atlassian.com/research-group",
            target: "_blank",
            rel: "noopener noreferrer"
        }, formatMessage((0, $6YoSc.default).enrollInResearchLink))
    }));
});
const $41c842a9ff9149b0$export$4be696be8a3bff13 = ({ projectType: projectType = 'business' } = {})=>{
    const { openFeedbackCollector: openFeedbackCollector } = (0, $irg9D.useFeedbackCollectorActions)();
    const { licensedProducts: licensedProducts } = (0, $gd0Sp.useTenantContext)();
    const route = (0, $10fdS.useCurrentRoute)();
    const { data: project } = (0, $bNe1g.useProjectContext)();
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const getFeedbackContext = (0, $eUqFw.useCallback)((feedbackGroupId)=>{
        const baseFeedbackContext = [
            {
                id: (0, $1c02D.EntryKeys).INLINE_FEEDBACK_ID,
                value: feedbackGroupId
            },
            {
                id: (0, $1c02D.EntryKeys).ROUTE_NAME,
                value: route.name ?? 'unknown'
            },
            {
                id: (0, $1c02D.EntryKeys).ROUTE_GROUP,
                value: route.group ?? 'unknown'
            },
            {
                id: (0, $1c02D.EntryKeys).IS_ADMIN,
                value: isAdmin
            },
            {
                id: (0, $1c02D.EntryKeys).PROJECT_TYPE,
                value: project?.projectType || projectType
            },
            {
                id: (0, $1c02D.EntryKeys).SUPPORTED_PROJECT_TYPES,
                value: (0, $loHEm.licensedProductsToString)(licensedProducts)
            }
        ];
        // Only send project specific information if project is available
        if (project) baseFeedbackContext.push({
            id: (0, $1c02D.EntryKeys).IS_SIMPLIFIED_PROJECT,
            value: project.simplified
        });
        return baseFeedbackContext;
    }, [
        isAdmin,
        licensedProducts,
        project,
        projectType,
        route.group,
        route.name
    ]);
    return (0, $eUqFw.useCallback)((feedbackGroupId, onClose, triggerRef)=>{
        const feedbackContext = getFeedbackContext(feedbackGroupId);
        openFeedbackCollector({
            entrypointId: (0, $1c02D.ENTRYPOINT_ID_JIRA_PLATFORM),
            feedbackGroupId: feedbackGroupId,
            canBeContactedLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($41c842a9ff9149b0$export$698ff856156a88fe, null),
            enrolInResearchLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($41c842a9ff9149b0$export$4f77effad9540593, null),
            feedbackContext: feedbackContext,
            onClose: onClose,
            ...triggerRef != null ? {
                triggerRef: triggerRef
            } : {}
        });
    }, [
        getFeedbackContext,
        openFeedbackCollector
    ]);
};

});
parcelRegister("6YoSc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bddfc6628ca4ec5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7bddfc6628ca4ec5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    canContactPrompt: {
        "id": "business-feedback-collector.can-contact-prompt",
        "defaultMessage": "Atlassian may contact me about this feedback."
    },
    canContactPromptLink: {
        "id": "business-feedback-collector.can-contact-prompt-link",
        "defaultMessage": "Privacy policy"
    },
    enrollInResearchPrompt: {
        "id": "business-feedback-collector.enroll-in-research-prompt",
        "defaultMessage": "I'd like to help improve Atlassian products by joining the {link}"
    },
    enrollInResearchLink: {
        "id": "business-feedback-collector.enroll-in-research-link",
        "defaultMessage": "Atlassian Research Group"
    }
});

});

parcelRegister("loHEm", function(module, exports) {

$parcel$export(module.exports, "licensedProductsToString", () => $7f7875a39a6a39a8$export$f57a7f1d32485807);
const $7f7875a39a6a39a8$export$f57a7f1d32485807 = (licensedProducts)=>Object.keys(licensedProducts).map((productKey)=>licensedProducts[productKey] ? productKey : '').join(', ');

});


parcelRegister("1pW4J", function(module, exports) {

$parcel$export(module.exports, "QuickstartNudge", () => $8dd307db4ae4d7c5$export$bd61ee610c74db6c);

var $eUqFw = parcelRequire("eUqFw");

var $ekN4Q = parcelRequire("ekN4Q");

var $16WDb = parcelRequire("16WDb");
const $8dd307db4ae4d7c5$export$bd61ee610c74db6c = (0, $16WDb.withNestingOptimisation)(({ renderWrapper: renderWrapper, children: children })=>{
    const isFullyExpanded = (0, $ekN4Q.useIsFullyExpanded)();
    return isFullyExpanded ? renderWrapper(children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
});

});
parcelRegister("ekN4Q", function(module, exports) {

$parcel$export(module.exports, "useIsFullyExpanded", () => $b942586713a4c8ae$export$7212b6b01271f5d1);

var $eUqFw = parcelRequire("eUqFw");

var $kpmC0 = parcelRequire("kpmC0");
const $b942586713a4c8ae$var$TIMEOUT = 500;
const $b942586713a4c8ae$export$7212b6b01271f5d1 = ()=>{
    const [ready, setReady] = (0, $eUqFw.useState)(false);
    const { isCollapsed: isCollapsed } = (0, $kpmC0.useLeftSidebarState)();
    (0, $eUqFw.useLayoutEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            setReady(!isCollapsed);
        }, $b942586713a4c8ae$var$TIMEOUT);
        return ()=>clearTimeout(timeoutId);
    }, [
        isCollapsed
    ]);
    return ready && !isCollapsed;
};

});

parcelRegister("16WDb", function(module, exports) {

$parcel$export(module.exports, "withNestingOptimisation", () => $6f4a5382247c5f3b$export$ee1cb2a8280d8710);

var $eUqFw = parcelRequire("eUqFw");

var $cgrgx = parcelRequire("cgrgx");

var $knPb9 = parcelRequire("knPb9");
const $6f4a5382247c5f3b$export$ee1cb2a8280d8710 = (Component)=>{
    const WithNestingOptimisation = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
        const children = // @ts-expect-error - Property 'children' does not exist on type 'Props'.ts(2339)
        typeof props === 'object' && props != null ? props.children : null;
        return (0, $cgrgx.useShouldNestedElementRender)().shouldRender && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
            ...props,
            ref: ref
        }) : children;
    });
    WithNestingOptimisation.displayName = `withNestingOptimisation(${(0, $knPb9.getDisplayName)(Component)})`;
    return WithNestingOptimisation;
};

});


parcelRegister("hWTey", function(module, exports) {

$parcel$export(module.exports, "FeedbackNudgeAsync", () => $0bc9252b272e4d4e$export$be3f2958452e7be9);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ewdMq = parcelRequire("ewdMq");

var $gGtKh = parcelRequire("gGtKh");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0bc9252b272e4d4e$var$FeedbackNudgeLazy = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("hKj93")).then((exportedModule)=>exportedModule.FeedbackNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/jwm-feedback/index.tsx"
});
const $0bc9252b272e4d4e$export$be3f2958452e7be9 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ewdMq.OnboardingNudgeErrorBoundary), {
        id: (0, $99a775c02d636a41$export$e9e47a7ad42e71f5),
        fallback: children,
        attributes: {
            nudgeId: (0, $99a775c02d636a41$export$e9e47a7ad42e71f5)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "feedback-onboarding-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0bc9252b272e4d4e$var$FeedbackNudgeLazy, null, children)));
$0bc9252b272e4d4e$export$be3f2958452e7be9.displayName = 'FeedbackNudgeAsync';

});
parcelRegister("ewdMq", function(module, exports) {

$parcel$export(module.exports, "OnboardingNudgeErrorBoundary", () => $adec59c10c54d3d1$export$3915a8814b99f0b);

var $eUqFw = parcelRequire("eUqFw");

var $kMhLP = parcelRequire("kMhLP");

var $7dRgX = parcelRequire("7dRgX");
const $adec59c10c54d3d1$export$3915a8814b99f0b = (props)=>{
    const { id: id, attributes: attributes, fallback: fallback, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kMhLP.ErrorBoundaryWithChunkErrorLogging), {
        id: id,
        packageName: (0, $7dRgX.PACKAGE_NAME),
        render: ()=>fallback,
        attributes: attributes
    }, children);
};

});
parcelRegister("kMhLP", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundaryWithChunkErrorLogging", () => $5bd50febcd8eec1e$export$9171acf2e93b7d4d);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $7Aqzu = parcelRequire("7Aqzu");
const $5bd50febcd8eec1e$export$9171acf2e93b7d4d = (props)=>{
    const { attributes: attributes, children: children, ...rest } = props;
    const addErrorBoundaryAnalyticsAttributes = (0, $7Aqzu.useAddErrorBoundaryAnalyticsAttributes)(attributes);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        ...rest,
        attributes: addErrorBoundaryAnalyticsAttributes
    }, children);
};

});
parcelRegister("7Aqzu", function(module, exports) {

$parcel$export(module.exports, "addChunkLoadErrorAnalyticsAttribute", () => $eee5ff621608f776$export$94ee0b5fca1e74d2);
$parcel$export(module.exports, "useAddErrorBoundaryAnalyticsAttributes", () => $eee5ff621608f776$export$807be5f3f1ea996);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");
const $eee5ff621608f776$export$94ee0b5fca1e74d2 = (error)=>({
        chunkLoadError: (0, $7rh0R.isLoaderError)(error)
    });
const $eee5ff621608f776$export$807be5f3f1ea996 = (attributes = {})=>(0, $eUqFw.useCallback)((error)=>({
            ...attributes,
            ...$eee5ff621608f776$export$94ee0b5fca1e74d2(error)
        }), [
        attributes
    ]);

});



const $99a775c02d636a41$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $99a775c02d636a41$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $99a775c02d636a41$export$6770a2081a63fc15 = 'backlogStartSprintNudge';
const $99a775c02d636a41$export$63b61f654ce3da3d = 'backlogCompleteSprintNudge';
const $99a775c02d636a41$export$1c7a80b00ad9619 = 'backlogInsightsNudge';
const $99a775c02d636a41$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingNudges';
const $99a775c02d636a41$export$65fb0c4e534f03fc = 'asyncScrumTourNudge';
const $99a775c02d636a41$export$f2fe211acb4aa81a = 'asyncKanbanTourNudge';
const $99a775c02d636a41$export$fb9c6e63a7490968 = 'asyncJWMCalendarTourNudge';
const $99a775c02d636a41$export$df53a339af97f102 = 'asyncJWMCalendarAndTimelineTourNudge';
const $99a775c02d636a41$export$573d4bf1da6d2bc6 = 'asyncJWMBoardTourNudge';
const $99a775c02d636a41$export$501e36925fa10eef = 'asyncJWMListTourNudge';
const $99a775c02d636a41$export$2f06a16c987cc1a2 = 'asyncJWMTimelineTourNudge';
const $99a775c02d636a41$export$226bdcb034c75951 = 'asyncJWMFormTourNudge';
const $99a775c02d636a41$export$b72fce9f4cf11b5c = 'asyncJWMTrelloKeyDifferencesTourNudge';
const $99a775c02d636a41$export$306510c7b1760652 = 'asyncJWMSummaryAndReportsTabNudge';
const $99a775c02d636a41$export$cf1943561be3a3c2 = 'asyncJWMSummaryViewNudge';
const $99a775c02d636a41$export$4d6567e7ee0281bf = 'asyncManageProjectsNudge';
const $99a775c02d636a41$export$f8bf435a6066832c = 'button clicked';
const $99a775c02d636a41$export$3bc551fe07069f89 = 'asyncJWMInviteTeamNudge';
const $99a775c02d636a41$export$4db327e1949c2108 = 'boardInProgressColumnNudge';
const $99a775c02d636a41$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $99a775c02d636a41$export$1e174cd1e0212f3a = 'navigateCalendarNudge';
const $99a775c02d636a41$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $99a775c02d636a41$export$a1398a6ef9526001 = 'inlineEditListNudge';
const $99a775c02d636a41$export$5908fa8acd2c0739 = 'filterListNudge';
const $99a775c02d636a41$export$50192b0fdc9bdacf = 'moreDropdownListNudge';
const $99a775c02d636a41$export$e34e81ed4f255f6e = 'timelineAddDateNudge';
const $99a775c02d636a41$export$aac6e5779d47ef37 = 'timelineAddChildItemNudge';
const $99a775c02d636a41$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $99a775c02d636a41$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $99a775c02d636a41$export$1e0e647cc08bb4d8 = 'trelloKeyDifferencesIssueNudge';
const $99a775c02d636a41$export$762576896c225bd6 = 'trelloKeyDifferencesSummaryNudge';
const $99a775c02d636a41$export$5a96f813312dc7fa = 'trelloKeyDifferencesBoardNudge';
const $99a775c02d636a41$export$ae8eeb04e0b1e9af = 'availableFieldsFormNudge';
const $99a775c02d636a41$export$a54d77300f1dddea = 'changeIssueTypeFormNudge';
const $99a775c02d636a41$export$6afdc7e5f6d2e915 = 'previewSaveFormNudge';
const $99a775c02d636a41$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
const $99a775c02d636a41$export$e9e47a7ad42e71f5 = 'feedbackNudge';
const $99a775c02d636a41$export$791f56b3d78403cc = 'calendarReleasesNudge';
const $99a775c02d636a41$export$a1be34032ee24f78 = 'shareProjectNudge';
const $99a775c02d636a41$export$29fe6611cc093756 = 'summaryTabNudge';
const $99a775c02d636a41$export$f107c06c0830f09d = 'reportsTabNudge';

parcelRegister("hKj93", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('1VDSh');
        const value = parcelRequire('kaG0t');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("1VDSh").then(()=>parcelRequire('kaG0t'));
}

});


parcelRegister("3PsZt", function(module, exports) {

$parcel$export(module.exports, "default", () => $18d43629c675088b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $18d43629c675088b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    feedback: {
        "id": "spa-apps-sidebar-core.multi-project-menu.feedback-button.feedback",
        "defaultMessage": "Give feedback"
    }
});

});


parcelRegister("8l70H", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d7d12471fcc325f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8d7d12471fcc325f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    companyManagedProject: {
        "id": "spa-apps-sidebar-core.multi-project-menu.company-managed-project",
        "defaultMessage": "You're in a company-managed project"
    },
    navigationLabel: {
        "id": "spa-apps-sidebar-core.multi-project-menu.navigation-label",
        "defaultMessage": "Side"
    },
    teamManagedProject: {
        "id": "spa-apps-sidebar-core.multi-project-menu.team-managed-project",
        "defaultMessage": "You're in a team-managed project"
    },
    viewAllStarred: {
        "id": "spa-apps-sidebar-core.multi-project-menu.view-all-starred",
        "defaultMessage": "View all starred projects"
    }
});

});

parcelRegister("4h0Ly", function(module, exports) {

$parcel$export(module.exports, "default", () => $905750f428147679$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $dxopF = parcelRequire("dxopF");

var $fIhju = parcelRequire("fIhju");

var $3236p = parcelRequire("3236p");

var $5qKeD = parcelRequire("5qKeD");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");

var $f26dB = parcelRequire("f26dB");

var $lg3mT = parcelRequire("lg3mT");

var $94rY2 = parcelRequire("94rY2");

var $dSHCZ = parcelRequire("dSHCZ");

var $gmtu6 = parcelRequire("gmtu6");

var $8MaWo = parcelRequire("8MaWo");
const $905750f428147679$var$Overviews = ({ overviews: overviews, hasError: hasError })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const refresh = (0, $eUqFw.useCallback)(()=>window.location.reload(), []);
    const [{ match: match, route: route }] = (0, $kJlBc.useRouter)();
    const routeOverviewId = match.params?.overviewId;
    const [isCreateModalOpen, setIsCreateModalOpen] = (0, $eUqFw.useState)(false);
    const openCreateModal = (0, $eUqFw.useCallback)(()=>{
        setIsCreateModalOpen(true);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'createOverview');
    }, [
        createAnalyticsEvent
    ]);
    const closeCreateModal = (0, $eUqFw.useCallback)(()=>setIsCreateModalOpen(false), []);
    const showOverviewChangeboarding = (0, $f26dB.useTriggerOverviewChangeboarding)();
    if ((0, $1ybV0.ff)('ploverview_overviews_to_plans_migration') && showOverviewChangeboarding) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $94rY2.default), {
        title: formatMessage((0, $gmtu6.default).overviewsHeader)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5qKeD.AsyncMigrationMessage), null));
    let content;
    if (hasError) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($905750f428147679$var$ErrorWrapper, {
        "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.overviews.overviews-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($905750f428147679$var$ErrorMessage, null, formatMessage((0, $gmtu6.default).errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        onClick: refresh
    }, formatMessage((0, $gmtu6.default).refreshPage)));
    else if (overviews.length === 0) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($905750f428147679$var$EmptyState, {
        "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.overviews.empty-state"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle-link",
        onClick: openCreateModal
    }, formatMessage((0, $gmtu6.default).createOverview)));
    else content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($905750f428147679$var$List, {
        "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.overviews.overviews-list"
    }, overviews.map((overview)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", {
            key: overview.id
        }, routeOverviewId === overview.id ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8MaWo.default), {
            overview: overview,
            to: (0, $fIhju.getOverviewUrl)(overview),
            isActive: true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8MaWo.default), {
            overview: overview,
            to: (0, $fIhju.getOverviewUrl)(overview, route)
        }))));
    const hasReachedLimit = overviews?.length >= (0, $lg3mT.OVERVIEW_MAX_LIMIT);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $94rY2.default), {
        title: formatMessage((0, $gmtu6.default).overviewsHeader)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dSHCZ.default), {
        onClick: openCreateModal,
        hasReachedLimit: hasReachedLimit
    })), content, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isCreateModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3236p.default), {
        onClose: closeCreateModal
    })));
};
var $905750f428147679$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($905750f428147679$var$Overviews);
const $905750f428147679$var$EmptyState = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $905750f428147679$var$List = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "ol", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _qtt8glyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $905750f428147679$var$ErrorWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $905750f428147679$var$ErrorMessage = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s85axq _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fIhju", function(module, exports) {

$parcel$export(module.exports, "getOverviewUrl", () => $3ba1ebdf548dd4c6$export$e314405e3f098e61);
$parcel$export(module.exports, "getProjectUrl", () => $3ba1ebdf548dd4c6$export$951b86b8e730b952);

var $exb0h = parcelRequire("exb0h");
const $3ba1ebdf548dd4c6$export$e314405e3f098e61 = (overview, currentRoute)=>{
    switch(currentRoute?.name){
        case (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_OVERVIEW_SUMMARY:
        case (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_SUMMARY:
            return `/jira/core/overviews/${overview.id}/summary`;
        case (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_OVERVIEW_CALENDAR:
        case (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_CALENDAR:
            return `/jira/core/overviews/${overview.id}/calendar`;
        case (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_OVERVIEW_TIMELINE:
        case (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_TIMELINE:
            return `/jira/core/overviews/${overview.id}/timeline`;
        default:
            return `/jira/core/overviews/${overview.id}`;
    }
};
const $3ba1ebdf548dd4c6$export$951b86b8e730b952 = (project, currentRoute)=>{
    switch(currentRoute?.name){
        case (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_OVERVIEW_SUMMARY:
        case (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_SUMMARY:
            return `/jira/core/projects/${project.key}/summary`;
        case (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_BOARD:
            return `/jira/core/projects/${project.key}/board`;
        case (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_LIST:
            return `/jira/core/projects/${project.key}/list`;
        case (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_OVERVIEW_CALENDAR:
        case (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_CALENDAR:
            return `/jira/core/projects/${project.key}/calendar`;
        case (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_OVERVIEW_TIMELINE:
        case (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_TIMELINE:
            return `/jira/core/projects/${project.key}/timeline`;
        case (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_FORM:
        case (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_FORM_BUILDER:
            return `/jira/core/projects/${project.key}/form`;
        case (0, $exb0h.ROUTE_NAMES).PROJECT_PAGES:
            return `/jira/core/projects/${project.key}/pages`;
        case (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_ATTACHMENTS:
            return `/jira/core/projects/${project.key}/attachments`;
        default:
            if (currentRoute?.group === (0, $exb0h.ROUTE_GROUPS).ISSUE_NAVIGATOR) return `/jira/core/projects/${project.key}/issues`;
            return `/jira/core/projects/${project.key}`;
    }
};

});

parcelRegister("3236p", function(module, exports) {

$parcel$export(module.exports, "default", () => $7de253836bffed60$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $4G5xU = parcelRequire("4G5xU");

var $gGtKh = parcelRequire("gGtKh");

var $jXDc6 = parcelRequire("jXDc6");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7de253836bffed60$var$LazyCreateOverviewModal = (0, $7rh0R.lazy)(()=>(parcelRequire("kNQTV")), {
    ssr: false,
    moduleId: "./src/packages/business/entity/overview/src/ui/create-overview-modal/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7de253836bffed60$export$2e2bcd8739ae039 = ({ onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceErrorBoundary), {
        experience: (0, $jXDc6.CREATE_OVERVIEW_EXPERIENCE),
        fallback: "unmount",
        shouldStartExperience: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "overview-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7de253836bffed60$var$LazyCreateOverviewModal, {
        onClose: onClose
    })));

});
parcelRegister("4G5xU", function(module, exports) {

$parcel$export(module.exports, "useExperienceStart", () => $0afb98966ec8ac3d$export$675e0d25df38d426);
$parcel$export(module.exports, "useExperienceAbort", () => $0afb98966ec8ac3d$export$cc92b7ce453f4403);
$parcel$export(module.exports, "useExperienceSuccess", () => $0afb98966ec8ac3d$export$e94f0da4fc0603c6);
$parcel$export(module.exports, "useExperienceFail", () => $0afb98966ec8ac3d$export$606da7704d8eaf06);
$parcel$export(module.exports, "useQueryBasedViewAutomaticTracking", () => $0afb98966ec8ac3d$export$8ca25d6ff1437be3);
$parcel$export(module.exports, "ExperienceStart", () => $0afb98966ec8ac3d$export$f20b867e738a222c);
$parcel$export(module.exports, "ExperienceFailed", () => $0afb98966ec8ac3d$export$ae65a9e09c4516b3);
$parcel$export(module.exports, "ExperienceErrorBoundary", () => $0afb98966ec8ac3d$export$139c4a4ad101c3c5);
$parcel$export(module.exports, "ExperienceSuccess", () => $0afb98966ec8ac3d$export$4962f3898bd5c829);

var $eUqFw = parcelRequire("eUqFw");

var $gCyQH = parcelRequire("gCyQH");

var $0cdA8 = parcelRequire("0cdA8");

var $guiFP = parcelRequire("guiFP");

var $fDZ6r = parcelRequire("fDZ6r");
var $1Fr7E = parcelRequire("1Fr7E");
var $4qhD6 = parcelRequire("4qhD6");
var $bDhRl = parcelRequire("bDhRl");
const $0afb98966ec8ac3d$export$675e0d25df38d426 = ({ experience: experience, experienceId: experienceId, packageName: packageName })=>(0, $bDhRl.useExperienceStart)({
        experience: experience,
        experienceId: experienceId,
        analyticsSource: packageName
    });
const $0afb98966ec8ac3d$export$cc92b7ce453f4403 = ({ experience: experience }, attributes)=>(0, $1Fr7E.useExperienceAbort)({
        experience: experience,
        attributes: attributes
    });
const $0afb98966ec8ac3d$export$e94f0da4fc0603c6 = ({ experience: experience })=>(0, $fDZ6r.useExperienceSuccess)({
        experience: experience
    });
const $0afb98966ec8ac3d$export$606da7704d8eaf06 = ({ experience: experience, experienceId: experienceId, packageName: packageName, teamName: teamName })=>{
    const onExperienceFail = (0, $4qhD6.useExperienceFail)({
        experience: experience
    });
    const onFail = (0, $eUqFw.useCallback)((location, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error, extraAttributes)=>{
        const relevantError = error?.networkError ?? error;
        extraAttributes !== undefined ? onExperienceFail(location, relevantError, extraAttributes) : onExperienceFail(location, relevantError);
        (0, $guiFP.default)({
            meta: {
                id: `experience-tracker-${experienceId ?? experience}`,
                packageName: packageName,
                teamName: teamName
            },
            attributes: {
                location: location
            },
            error: relevantError,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        onExperienceFail,
        experienceId,
        experience,
        packageName,
        teamName
    ]);
    return onFail;
};
const $0afb98966ec8ac3d$export$8ca25d6ff1437be3 = (experience, { loading: loading, error: error, shouldStartExperience: shouldStartExperience })=>{
    const [hasStarted, setHasStarted] = (0, $eUqFw.useState)(loading);
    const [hasCompleted, setHasCompleted] = (0, $eUqFw.useState)(false);
    const [hasExperienceBeenTracked, setHasExperienceBeenTracked] = (0, $eUqFw.useState)(false);
    const startExperience = $0afb98966ec8ac3d$export$675e0d25df38d426(experience);
    const onFail = $0afb98966ec8ac3d$export$606da7704d8eaf06(experience);
    const onSuccess = $0afb98966ec8ac3d$export$e94f0da4fc0603c6(experience);
    (0, $eUqFw.useEffect)(()=>{
        if (shouldStartExperience === true) startExperience();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        shouldStartExperience
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (hasStarted === false && loading === true) setHasStarted(true);
        if (hasStarted === true && loading === false) {
            setHasCompleted(true);
            setHasExperienceBeenTracked(false);
        }
    }, [
        hasStarted,
        loading
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (hasCompleted && !hasExperienceBeenTracked) {
            // make sure experience is tracked once despite re-rendering of the view
            setHasExperienceBeenTracked(true);
            if (typeof error !== 'undefined') {
                onFail(`${experience.experience} ${experience.experienceId || ''} useEffect error handling`, error);
                return;
            }
            onSuccess({
                loaded: true
            });
        }
    }, [
        error,
        experience,
        hasCompleted,
        hasExperienceBeenTracked,
        onFail,
        onSuccess
    ]);
};
const $0afb98966ec8ac3d$export$f20b867e738a222c = /*#__PURE__*/ (0, $eUqFw.memo)(({ experience: experience })=>{
    const start = $0afb98966ec8ac3d$export$675e0d25df38d426(experience);
    (0, $eUqFw.useEffect)(()=>{
        start();
    }, [
        start
    ]);
    return null;
});
const $0afb98966ec8ac3d$export$ae65a9e09c4516b3 = /*#__PURE__*/ (0, $eUqFw.memo)(({ experience: experience, error: error })=>{
    const onFail = $0afb98966ec8ac3d$export$606da7704d8eaf06(experience);
    (0, $eUqFw.useEffect)(()=>{
        onFail(experience.experience, error);
    }, [
        error,
        experience,
        onFail
    ]);
    return null;
});
const $0afb98966ec8ac3d$export$139c4a4ad101c3c5 = ({ experience: experience, shouldStartExperience: shouldStartExperience, fallback: fallback = (0, $gCyQH.ErrorPage), children: children })=>{
    const onFail = $0afb98966ec8ac3d$export$606da7704d8eaf06(experience);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        packageName: experience.packageName,
        teamName: experience.teamName,
        id: experience.experience,
        onError: onFail,
        fallback: fallback
    }, shouldStartExperience === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0afb98966ec8ac3d$export$f20b867e738a222c, {
        experience: experience
    }), children);
};
const $0afb98966ec8ac3d$export$4962f3898bd5c829 = /*#__PURE__*/ (0, $eUqFw.memo)(({ experience: experience })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fDZ6r.ExperienceSuccess), {
        experience: experience.experience,
        attributes: experience.experienceId == null ? undefined : {
            experienceId: experience.experienceId
        }
    }));

});
parcelRegister("gCyQH", function(module, exports) {

$parcel$export(module.exports, "ErrorPage", () => $6c8115aba8656cec$export$c120a0e80fd44ca6);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bEZRh = parcelRequire("bEZRh");
const $6c8115aba8656cec$export$c120a0e80fd44ca6 = ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c8115aba8656cec$var$ErrorWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bEZRh.JSErrorPageAsync), {
        error: error
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6c8115aba8656cec$var$ErrorWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkvuon _syaz1fxt",
            __cmplp.className
        ])
    });
});

});

parcelRegister("1Fr7E", function(module, exports) {

$parcel$export(module.exports, "useExperienceAbort", () => $f0f298b79da53f61$export$cc92b7ce453f4403);

var $eUqFw = parcelRequire("eUqFw");

var $gtrMw = parcelRequire("gtrMw");
const $f0f298b79da53f61$export$cc92b7ce453f4403 = ({ experience: experience, attributes: attributes })=>{
    const experienceTracker = (0, $gtrMw.useExperienceContext)();
    const self = (0, $eUqFw.useRef)({
        name: experience,
        attributes: attributes,
        experienceTracker: experienceTracker
    });
    self.current.name = experience;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    return (0, $eUqFw.useCallback)((reason, extraAttributes = {})=>{
        const { current: current } = self;
        current.experienceTracker.abort({
            name: current.name,
            reason: reason,
            attributes: {
                ...current.attributes,
                ...extraAttributes
            }
        });
    }, [
        self
    ]);
};

});


parcelRegister("jXDc6", function(module, exports) {

$parcel$export(module.exports, "CREATE_OVERVIEW_EXPERIENCE", () => $92a66ffd6a5018dc$export$9b5e8e07ff330ef2);
$parcel$export(module.exports, "EDIT_OVERVIEW_EXPERIENCE", () => $92a66ffd6a5018dc$export$a58227116ceb8b81);
$parcel$export(module.exports, "DELETE_OVERVIEW_EXPERIENCE", () => $92a66ffd6a5018dc$export$e17a11e4247a14f7);
$parcel$export(module.exports, "MODAL_WIDTH", () => $92a66ffd6a5018dc$export$3d931b64f46140b3);

var $c9TLT = parcelRequire("c9TLT");
const $92a66ffd6a5018dc$export$b8b9d90f9e5bd72b = 'jiraBusinessEntityOverview';
const $92a66ffd6a5018dc$export$9b5e8e07ff330ef2 = {
    experience: 'create-overview',
    packageName: $92a66ffd6a5018dc$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $92a66ffd6a5018dc$export$a58227116ceb8b81 = {
    experience: 'edit-overview',
    packageName: $92a66ffd6a5018dc$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $92a66ffd6a5018dc$export$e17a11e4247a14f7 = {
    experience: 'delete-overview',
    packageName: $92a66ffd6a5018dc$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $92a66ffd6a5018dc$export$d03d4e78ea5b909a = (0, $c9TLT.gridSize) * 2;
const $92a66ffd6a5018dc$export$57ee5df6bad94642 = 400;
const $92a66ffd6a5018dc$export$5785b84269e3e763 = 340;
const $92a66ffd6a5018dc$export$7c9c92ba6b198ac4 = (0, $c9TLT.gridSize) * 3;
const $92a66ffd6a5018dc$export$c4232794452dc6e3 = 480;
const $92a66ffd6a5018dc$export$3d931b64f46140b3 = $92a66ffd6a5018dc$export$c4232794452dc6e3 + $92a66ffd6a5018dc$export$57ee5df6bad94642 + $92a66ffd6a5018dc$export$7c9c92ba6b198ac4 * 2 + $92a66ffd6a5018dc$export$d03d4e78ea5b909a * 2;
const $92a66ffd6a5018dc$var$MODAL_DIALOG_MARGIN = 120;
const $92a66ffd6a5018dc$export$68bc124b0fa13de0 = $92a66ffd6a5018dc$export$3d931b64f46140b3 + $92a66ffd6a5018dc$var$MODAL_DIALOG_MARGIN;

});

parcelRegister("kNQTV", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('he5e3')
        ]);
        const value = parcelRequire('jthZP');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("he5e3")
    ]).then(()=>parcelRequire('jthZP'));
}

});


parcelRegister("5qKeD", function(module, exports) {

$parcel$export(module.exports, "AsyncMigrationMessage", () => $20b69e266ccb1e91$export$93794b6cb00009c5);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $fXgkp = parcelRequire("fXgkp");
const $20b69e266ccb1e91$var$runtimeProps = {};
const $20b69e266ccb1e91$var$entryPointParams = {};
const $20b69e266ccb1e91$export$93794b6cb00009c5 = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $fXgkp.migrationMessageEntrypoint), $20b69e266ccb1e91$var$entryPointParams);
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "overviews-plans-onboarding-migration-message",
        packageName: "jiraBusinessOnboarding",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: $20b69e266ccb1e91$var$runtimeProps
    });
};

});
parcelRegister("fXgkp", function(module, exports) {

$parcel$export(module.exports, "migrationMessageEntrypoint", () => $8c5cd663e92125c4$export$2dea5f3fdc0ae86);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $8c5cd663e92125c4$export$2dea5f3fdc0ae86 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("hEPtV")).then((module)=>module.MigrationMessage), {
        moduleId: "cb473cb0"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("hEPtV", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('cyvEN')
        ]);
        const value = parcelRequire('7Sxem');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("cyvEN")
    ]).then(()=>parcelRequire('7Sxem'));
}

});



parcelRegister("lg3mT", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $f1a163edcd3bb430$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "MENU_ID", () => $f1a163edcd3bb430$export$d4cd258d01c03112);
$parcel$export(module.exports, "SECTION_ID", () => $f1a163edcd3bb430$export$501955bd67991a25);
$parcel$export(module.exports, "REPORTS_ROUTES_SET", () => $f1a163edcd3bb430$export$f746f9acd7a66bdb);
$parcel$export(module.exports, "SETTINGS_ROUTES_SET", () => $f1a163edcd3bb430$export$e8d6319ab0eb2a27);
$parcel$export(module.exports, "ISSUES_ROUTES_SET", () => $f1a163edcd3bb430$export$6ca9a18cdf1b5a79);
$parcel$export(module.exports, "FORGE_ROUTES_SET", () => $f1a163edcd3bb430$export$6ad6f0faae6ab404);
$parcel$export(module.exports, "JIRA_AUTOMATION_ADDON_KEY", () => $f1a163edcd3bb430$export$75d31ae45b00712c);
$parcel$export(module.exports, "LOCATION", () => $f1a163edcd3bb430$export$87d0ca22edb7493a);
$parcel$export(module.exports, "OVERVIEW_MAX_LIMIT", () => $f1a163edcd3bb430$export$96f465f51836d3a2);

var $exb0h = parcelRequire("exb0h");

var $c9TLT = parcelRequire("c9TLT");
const $f1a163edcd3bb430$export$b8b9d90f9e5bd72b = 'jira.navigation.sidebar.core';
const $f1a163edcd3bb430$export$d4cd258d01c03112 = 'project/core';
const $f1a163edcd3bb430$export$501955bd67991a25 = {
    ISSUES: 'issues',
    REPORTS: 'reports',
    SETTINGS: 'settings',
    ISSUE_TYPES: 'issuetypes'
};
const $f1a163edcd3bb430$export$f746f9acd7a66bdb = new Set([
    (0, $exb0h.ROUTE_NAMES).LEGACY_ALL_REPORTS,
    (0, $exb0h.ROUTE_NAMES).LEGACY_REPORTS_CONFIG,
    (0, $exb0h.ROUTE_NAMES).LEGACY_REPORTS_AVERAGE_AGE,
    (0, $exb0h.ROUTE_NAMES).LEGACY_REPORTS_CREATED_VS_RESOLVED,
    (0, $exb0h.ROUTE_NAMES).LEGACY_REPORTS_PIE,
    (0, $exb0h.ROUTE_NAMES).LEGACY_REPORTS_RECENTLY_CREATED,
    (0, $exb0h.ROUTE_NAMES).LEGACY_REPORTS_RESOLUTION_TIME,
    (0, $exb0h.ROUTE_NAMES).LEGACY_REPORTS_SINGLE_LEVEL_GROUP_BY,
    (0, $exb0h.ROUTE_NAMES).LEGACY_REPORTS_TIME_SINCE,
    (0, $exb0h.ROUTE_NAMES).LEGACY_REPORTS_TIME_TRACKING_REPORT,
    (0, $exb0h.ROUTE_NAMES).LEGACY_REPORTS_DEVELOPER_WORKLOAD,
    (0, $exb0h.ROUTE_NAMES).LEGACY_REPORTS_VERSION_WORKLOAD,
    (0, $exb0h.ROUTE_NAMES).LEGACY_REPORTS_WORKLOAD_PIE
]);
const $f1a163edcd3bb430$export$e8d6319ab0eb2a27 = new Set([
    (0, $exb0h.ROUTE_NAMES).CLASSIC_PROJECT_SETTINGS_CORE_PROFORMA_FORMS,
    (0, $exb0h.ROUTE_NAMES).CLASSIC_PROJECT_SETTINGS_ISSUE_LAYOUT,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_EDIT,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_CONFIG,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_DATA_CLASSIFICATIONS,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_FIELDS,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_ISSUE_LAYOUT,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_ISSUE_TYPES,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_NOTIFICATIONS,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_OPSGENIE,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_PERMISSIONS,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_SCREENS,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_SUMMARY,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_WORKFLOWS,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_COLLECTORS,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_PEOPLE,
    (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_AUTOMATION,
    (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_VERSIONS,
    (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_COMPONENTS,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_DEV
]);
const $f1a163edcd3bb430$export$6ca9a18cdf1b5a79 = new Set([
    (0, $exb0h.ROUTE_NAMES).LEGACY_PIN,
    (0, $exb0h.ROUTE_NAMES).PROJECT_ISSUE_NAVIGATOR,
    (0, $exb0h.ROUTE_NAMES).PROJECT_ISSUE_NAVIGATOR_CORE
]);
const $f1a163edcd3bb430$export$6ad6f0faae6ab404 = new Set([
    (0, $exb0h.ROUTE_NAMES).FORGE_PROJECT,
    (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_CORE_FORGE_APPS
]);
const $f1a163edcd3bb430$export$75d31ae45b00712c = 'com.codebarrel.addons.automation';
const $f1a163edcd3bb430$export$33abecf3eb4ba30b = (0, $c9TLT.gridSize) * 5;
const $f1a163edcd3bb430$export$76ca6e18b275dcad = 24;
const $f1a163edcd3bb430$export$87d0ca22edb7493a = 'jwmNavigationCreateProject';
const $f1a163edcd3bb430$export$96f465f51836d3a2 = 10;

});

parcelRegister("94rY2", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2cfaa3cc51cd03b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $41WOo = parcelRequire("41WOo");
const $d2cfaa3cc51cd03b$var$SectionHeader = ({ children: children, title: title, elemAfter: elemAfter })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d2cfaa3cc51cd03b$export$960a49cc3d27a090, null, (0, $41WOo.isVariationOnJwmMonetizationExperiment)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d2cfaa3cc51cd03b$var$ElemAfterWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d2cfaa3cc51cd03b$export$8b251419efc915eb, null, title), elemAfter) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d2cfaa3cc51cd03b$export$8b251419efc915eb, null, title), children);
var $d2cfaa3cc51cd03b$export$2e2bcd8739ae039 = $d2cfaa3cc51cd03b$var$SectionHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d2cfaa3cc51cd03b$var$ElemAfterWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _zulpu2gc",
            __cmplp.className
        ])
    });
});
const $d2cfaa3cc51cd03b$export$960a49cc3d27a090 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4zamj _1e0c1txw _1bah1yb4 _zulpu2gc _4cvr1h6o _1tke1tcg _vchhusvi",
            __cmplp.className
        ])
    });
});
const $d2cfaa3cc51cd03b$export$8b251419efc915eb = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1kw7 _19pkidpf _11c81bk4",
            __cmplp.className
        ])
    });
});

});

parcelRegister("dSHCZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $aab9b6c8e2a461a8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3MV1G = parcelRequire("3MV1G");

var $5JgJ2 = parcelRequire("5JgJ2");

var $rRiBz = parcelRequire("rRiBz");

var $hOFzv = parcelRequire("hOFzv");

var $gxlwv = parcelRequire("gxlwv");
const $aab9b6c8e2a461a8$var$CREATE_BUTTON_TEST_ID = 'navigation-apps-sidebar-core.ui.multi-project-menu.overviews.create-overview';
const $aab9b6c8e2a461a8$var$CreateOverview = ({ onClick: onClick, hasReachedLimit: hasReachedLimit })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isWarningOpen, setIsWarningOpen] = (0, $eUqFw.useState)(false);
    if (hasReachedLimit) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        placement: "bottom-start",
        isOpen: isWarningOpen,
        onClose: ()=>setIsWarningOpen(false),
        trigger: ({ ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $rRiBz.default), {
                ...triggerProps,
                onClick: ()=>setIsWarningOpen((isOpen)=>!isOpen),
                label: formatMessage((0, $hOFzv.default).createOverviewLabel),
                testId: $aab9b6c8e2a461a8$var$CREATE_BUTTON_TEST_ID,
                ref: ref
            }),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gxlwv.default), null)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $rRiBz.default), {
        onClick: onClick,
        label: formatMessage((0, $hOFzv.default).createOverviewLabel),
        testId: $aab9b6c8e2a461a8$var$CREATE_BUTTON_TEST_ID
    });
};
var $aab9b6c8e2a461a8$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($aab9b6c8e2a461a8$var$CreateOverview);

});
parcelRegister("rRiBz", function(module, exports) {

$parcel$export(module.exports, "default", () => $76157c9c7cef0bf6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bkIGg = parcelRequire("bkIGg");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $bUVhp = parcelRequire("bUVhp");
const $76157c9c7cef0bf6$var$RoundCreateButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ label: label, onClick: onClick, testId: testId, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: label,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bUVhp.StyledButton), {
        ...props,
        ref: ref,
        testId: testId,
        spacing: "compact",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bkIGg))), {
            label: label,
            primaryColor: `var(--ds-text, ${(0, $PdmhA).N800})`,
            size: "small"
        }),
        onClick: onClick
    })));
var $76157c9c7cef0bf6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($76157c9c7cef0bf6$var$RoundCreateButton);

});
parcelRegister("bUVhp", function(module, exports) {

$parcel$export(module.exports, "StyledButton", () => $b2fbec61fcc14fc7$export$2d5d2ba3c7c8c40b);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");
const $b2fbec61fcc14fc7$export$2d5d2ba3c7c8c40b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1njd _1pbykb7n",
            __cmplp.className
        ])
    });
});

});


parcelRegister("hOFzv", function(module, exports) {

$parcel$export(module.exports, "default", () => $413e172b8c878b47$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $413e172b8c878b47$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createOverviewLabel: {
        "id": "spa-apps-sidebar-core.multi-project-menu.overviews.create-overview.create-overview-label",
        "defaultMessage": "Create overview"
    }
});

});

parcelRegister("gxlwv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0b10dfebf342cc5$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5YsMl = parcelRequire("5YsMl");

var $1Yimi = parcelRequire("1Yimi");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lg3mT = parcelRequire("lg3mT");

var $4VuJA = parcelRequire("4VuJA");
const $f0b10dfebf342cc5$var$OverviewLimitPopup = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f0b10dfebf342cc5$export$e6dfd72ab29f8598, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
        label: "",
        primaryColor: "var(--ds-icon-warning, #ffab00)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), null, formatMessage((0, $4VuJA.default).overviewLimitReached, {
        overviewMaxLimit: (0, $lg3mT.OVERVIEW_MAX_LIMIT)
    })));
};
var $f0b10dfebf342cc5$export$2e2bcd8739ae039 // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
 = /*#__PURE__*/ (0, $eUqFw.memo)($f0b10dfebf342cc5$var$OverviewLimitPopup);
const $f0b10dfebf342cc5$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _zulpu2gc _1yt44ar7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4VuJA", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f6d7d156ba1ad3d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3f6d7d156ba1ad3d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    overviewLimitReached: {
        "id": "spa-apps-sidebar-core.multi-project-menu.overviews.create-overview.overview-limit-popup.overview-limit-reached",
        "defaultMessage": "You've reached the limit of {overviewMaxLimit, plural, one {# overview} other {# overviews}}"
    }
});

});



parcelRegister("gmtu6", function(module, exports) {

$parcel$export(module.exports, "default", () => $c69d68e991d71af7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c69d68e991d71af7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createOverview: {
        "id": "spa-apps-sidebar-core.multi-project-menu.overviews.create-overview",
        "defaultMessage": "Create an overview"
    },
    overviewsHeader: {
        "id": "spa-apps-sidebar-core.multi-project-menu.overviews.overviews-header",
        "defaultMessage": "Overviews"
    },
    errorMessage: {
        "id": "spa-apps-sidebar-core.multi-project-menu.overviews.error-message",
        "defaultMessage": "We couldn't load overviews"
    },
    refreshPage: {
        "id": "spa-apps-sidebar-core.multi-project-menu.overviews.refresh-page",
        "defaultMessage": "Refresh page"
    }
});

});

parcelRegister("8MaWo", function(module, exports) {

$parcel$export(module.exports, "default", () => $85de1c4527c5fda3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $gotST = parcelRequire("gotST");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $7BoX4 = parcelRequire("7BoX4");

var $2Ucfd = parcelRequire("2Ucfd");

var $3YFEG = parcelRequire("3YFEG");
const $85de1c4527c5fda3$var$OverviewLink = ({ overview: overview, to: to, isActive: isActive = false })=>{
    const { name: name, theme: theme } = overview;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3YFEG.default), {
        to: to,
        isActive: isActive,
        prefetch: "hover",
        onClick: ()=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'overviewLink')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($85de1c4527c5fda3$export$399e54fcdf2a48ec, {
        size: "small",
        themeName: theme
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Ucfd.default), null, name));
    return isActive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7BoX4.default), null, content) : content;
};
var $85de1c4527c5fda3$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($85de1c4527c5fda3$var$OverviewLink);
const $85de1c4527c5fda3$export$399e54fcdf2a48ec = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $gotST.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwx1crf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gotST", function(module, exports) {

$parcel$export(module.exports, "default", () => $56ce495d3d442ffd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8tfNS = parcelRequire("8tfNS");

var $kar7l = parcelRequire("kar7l");

var $i4XFs = parcelRequire("i4XFs");
const $56ce495d3d442ffd$var$OverviewIcon = ({ size: size = 'medium', className: className, themeName: themeName })=>{
    const theme = themeName ?? (0, $kar7l.DEFAULT_BACKGROUND_CONFIG).name;
    const Wrapper = (0, $i4XFs.WRAPPER)[size][theme];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Wrapper, {
        // eslint-disable-next-line jira/react/no-classname-attribute, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-testid": "business-entity-overview.common.ui.overview-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tfNS))), {
        label: "",
        size: size
    }));
};
var $56ce495d3d442ffd$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($56ce495d3d442ffd$var$OverviewIcon);

});
parcelRegister("8tfNS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $62ad4a6c20067d20$var$_react = $62ad4a6c20067d20$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $62ad4a6c20067d20$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $62ad4a6c20067d20$var$WorldIcon = (props)=>/*#__PURE__*/ $62ad4a6c20067d20$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 21a9 9 0 100-18 9 9 0 000 18zm-.9-1.863A7.19 7.19 0 014.8 12c0-.558.072-1.089.189-1.611L9.3 14.7v.9c0 .99.81 1.8 1.8 1.8v1.737zm6.21-2.286A1.786 1.786 0 0015.6 15.6h-.9v-2.7c0-.495-.405-.9-.9-.9H8.4v-1.8h1.8c.495 0 .9-.405.9-.9V7.5h1.8c.99 0 1.8-.81 1.8-1.8v-.369c2.637 1.071 4.5 3.654 4.5 6.669 0 1.872-.72 3.573-1.89 4.851z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$62ad4a6c20067d20$var$WorldIcon.displayName = 'WorldIcon';
var $62ad4a6c20067d20$var$_default = $62ad4a6c20067d20$var$WorldIcon;
module.exports.default = $62ad4a6c20067d20$var$_default;

});

parcelRegister("i4XFs", function(module, exports) {

$parcel$export(module.exports, "WRAPPER", () => $4d118138298fb934$export$20b8431be300f03e);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $PdmhA = parcelRequire("PdmhA");

var $c9TLT = parcelRequire("c9TLT");
const $4d118138298fb934$var$iconWrapperStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    borderRadius: `${(0, $c9TLT.borderRadius)}px`,
    border: `1px solid ${`var(--ds-border, ${(0, $PdmhA).N20A})`}`
};
const $4d118138298fb934$var$smallIconWrapperStyles = {
    ...$4d118138298fb934$var$iconWrapperStyles,
    width: '24px',
    height: '24px'
};
const $4d118138298fb934$var$mediumIconWrapperStyles = {
    ...$4d118138298fb934$var$iconWrapperStyles,
    width: '32px',
    height: '32px'
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4d118138298fb934$var$WhiteSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz1d6j _bfhk4zhb",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightPurpleSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazhbpo _bfhk63rr",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightBlueSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazynhg _bfhk1mdm",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightTealSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazig9t _bfhk16io",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightGreenSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz15qz _bfhkuuj7",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightLimeSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazz2ec _bfhktde4",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightYellowSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz13jf _bfhk1v42",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightRedSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz58wa _bfhkr8k0",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightMagentaSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz5ct2 _bfhku2x1",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightOrangeSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazmfbj _bfhkdpo0",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$DarkSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz1d6j _bfhk4zhb",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$PurpleSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz63rr _bfhkhbpo",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$BlueSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz1mdm _bfhkynhg",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$TealSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz16io _bfhkig9t",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$GreenSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazuuj7 _bfhk15qz",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LimeSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaztde4 _bfhkz2ec",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$YellowSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz1v42 _bfhk13jf",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$RedSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazr8k0 _bfhk58wa",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$MagentaSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazu2x1 _bfhk5ct2",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$OrangeSmallIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazdpo0 _bfhkmfbj",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$WhiteMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz1d6j _bfhk4zhb",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightPurpleMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazhbpo _bfhk63rr",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightBlueMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazynhg _bfhk1mdm",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightTealMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazig9t _bfhk16io",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightGreenMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz15qz _bfhkuuj7",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightLimeMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazz2ec _bfhktde4",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightYellowMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz13jf _bfhk1v42",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightRedMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz58wa _bfhkr8k0",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightMagentaMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz5ct2 _bfhku2x1",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LightOrangeMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazmfbj _bfhkdpo0",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$DarkMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz1d6j _bfhk4zhb",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$PurpleMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz63rr _bfhkhbpo",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$BlueMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz1mdm _bfhkynhg",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$TealMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz16io _bfhkig9t",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$GreenMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazuuj7 _bfhk15qz",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$LimeMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaztde4 _bfhkz2ec",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$YellowMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz1v42 _bfhk13jf",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$RedMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazr8k0 _bfhk58wa",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$MagentaMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazu2x1 _bfhk5ct2",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$var$OrangeMediumIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazdpo0 _bfhkmfbj",
            __cmplp.className
        ])
    });
});
const $4d118138298fb934$export$20b8431be300f03e = {
    small: {
        white: $4d118138298fb934$var$WhiteSmallIconWrapper,
        'light-purple': $4d118138298fb934$var$LightPurpleSmallIconWrapper,
        'light-blue': $4d118138298fb934$var$LightBlueSmallIconWrapper,
        'light-teal': $4d118138298fb934$var$LightTealSmallIconWrapper,
        'light-green': $4d118138298fb934$var$LightGreenSmallIconWrapper,
        'light-yellow': $4d118138298fb934$var$LightYellowSmallIconWrapper,
        'light-red': $4d118138298fb934$var$LightRedSmallIconWrapper,
        'light-magenta': $4d118138298fb934$var$LightMagentaSmallIconWrapper,
        'light-orange': $4d118138298fb934$var$LightOrangeSmallIconWrapper,
        dark: $4d118138298fb934$var$DarkSmallIconWrapper,
        purple: $4d118138298fb934$var$PurpleSmallIconWrapper,
        blue: $4d118138298fb934$var$BlueSmallIconWrapper,
        teal: $4d118138298fb934$var$TealSmallIconWrapper,
        green: $4d118138298fb934$var$GreenSmallIconWrapper,
        yellow: $4d118138298fb934$var$YellowSmallIconWrapper,
        red: $4d118138298fb934$var$RedSmallIconWrapper,
        magenta: $4d118138298fb934$var$MagentaSmallIconWrapper,
        orange: $4d118138298fb934$var$OrangeSmallIconWrapper,
        'lightest-gray': $4d118138298fb934$var$WhiteSmallIconWrapper,
        'lightest-purple': $4d118138298fb934$var$LightPurpleSmallIconWrapper,
        'lightest-blue': $4d118138298fb934$var$LightBlueSmallIconWrapper,
        'lightest-teal': $4d118138298fb934$var$LightTealSmallIconWrapper,
        'lightest-green': $4d118138298fb934$var$LightGreenSmallIconWrapper,
        'lightest-lime': $4d118138298fb934$var$LightLimeSmallIconWrapper,
        'lightest-yellow': $4d118138298fb934$var$LightYellowSmallIconWrapper,
        'lightest-orange': $4d118138298fb934$var$LightOrangeSmallIconWrapper,
        'lightest-red': $4d118138298fb934$var$LightRedSmallIconWrapper,
        'lightest-magenta': $4d118138298fb934$var$LightMagentaSmallIconWrapper,
        'lighter-gray': $4d118138298fb934$var$WhiteSmallIconWrapper,
        'lighter-purple': $4d118138298fb934$var$LightPurpleSmallIconWrapper,
        'lighter-blue': $4d118138298fb934$var$LightBlueSmallIconWrapper,
        'lighter-teal': $4d118138298fb934$var$LightTealSmallIconWrapper,
        'lighter-green': $4d118138298fb934$var$LightGreenSmallIconWrapper,
        'lighter-lime': $4d118138298fb934$var$LightLimeSmallIconWrapper,
        'lighter-yellow': $4d118138298fb934$var$LightYellowSmallIconWrapper,
        'lighter-orange': $4d118138298fb934$var$LightOrangeSmallIconWrapper,
        'lighter-red': $4d118138298fb934$var$LightRedSmallIconWrapper,
        'lighter-magenta': $4d118138298fb934$var$LightMagentaSmallIconWrapper,
        'darker-gray': $4d118138298fb934$var$DarkSmallIconWrapper,
        'darker-purple': $4d118138298fb934$var$PurpleSmallIconWrapper,
        'darker-blue': $4d118138298fb934$var$BlueSmallIconWrapper,
        'darker-teal': $4d118138298fb934$var$TealSmallIconWrapper,
        'darker-green': $4d118138298fb934$var$GreenSmallIconWrapper,
        'darker-lime': $4d118138298fb934$var$LimeSmallIconWrapper,
        'darker-yellow': $4d118138298fb934$var$YellowSmallIconWrapper,
        'darker-orange': $4d118138298fb934$var$OrangeSmallIconWrapper,
        'darker-red': $4d118138298fb934$var$RedSmallIconWrapper,
        'darker-magenta': $4d118138298fb934$var$MagentaSmallIconWrapper,
        'darkest-gray': $4d118138298fb934$var$DarkSmallIconWrapper,
        'darkest-purple': $4d118138298fb934$var$PurpleSmallIconWrapper,
        'darkest-blue': $4d118138298fb934$var$BlueSmallIconWrapper,
        'darkest-teal': $4d118138298fb934$var$TealSmallIconWrapper,
        'darkest-green': $4d118138298fb934$var$GreenSmallIconWrapper,
        'darkest-lime': $4d118138298fb934$var$LimeSmallIconWrapper,
        'darkest-yellow': $4d118138298fb934$var$YellowSmallIconWrapper,
        'darkest-orange': $4d118138298fb934$var$OrangeSmallIconWrapper,
        'darkest-red': $4d118138298fb934$var$RedSmallIconWrapper,
        'darkest-magenta': $4d118138298fb934$var$MagentaSmallIconWrapper,
        'no-background': $4d118138298fb934$var$WhiteSmallIconWrapper
    },
    medium: {
        white: $4d118138298fb934$var$WhiteMediumIconWrapper,
        'light-purple': $4d118138298fb934$var$LightPurpleMediumIconWrapper,
        'light-blue': $4d118138298fb934$var$LightBlueMediumIconWrapper,
        'light-teal': $4d118138298fb934$var$LightTealMediumIconWrapper,
        'light-green': $4d118138298fb934$var$LightGreenMediumIconWrapper,
        'light-yellow': $4d118138298fb934$var$LightYellowMediumIconWrapper,
        'light-red': $4d118138298fb934$var$LightRedMediumIconWrapper,
        'light-magenta': $4d118138298fb934$var$LightMagentaMediumIconWrapper,
        'light-orange': $4d118138298fb934$var$LightOrangeMediumIconWrapper,
        dark: $4d118138298fb934$var$DarkMediumIconWrapper,
        purple: $4d118138298fb934$var$PurpleMediumIconWrapper,
        blue: $4d118138298fb934$var$BlueMediumIconWrapper,
        teal: $4d118138298fb934$var$TealMediumIconWrapper,
        green: $4d118138298fb934$var$GreenMediumIconWrapper,
        yellow: $4d118138298fb934$var$YellowMediumIconWrapper,
        red: $4d118138298fb934$var$RedMediumIconWrapper,
        magenta: $4d118138298fb934$var$MagentaMediumIconWrapper,
        orange: $4d118138298fb934$var$OrangeMediumIconWrapper,
        'lightest-gray': $4d118138298fb934$var$WhiteMediumIconWrapper,
        'lightest-purple': $4d118138298fb934$var$LightPurpleMediumIconWrapper,
        'lightest-blue': $4d118138298fb934$var$LightBlueMediumIconWrapper,
        'lightest-teal': $4d118138298fb934$var$LightTealMediumIconWrapper,
        'lightest-green': $4d118138298fb934$var$LightGreenMediumIconWrapper,
        'lightest-lime': $4d118138298fb934$var$LightLimeMediumIconWrapper,
        'lightest-yellow': $4d118138298fb934$var$LightYellowMediumIconWrapper,
        'lightest-orange': $4d118138298fb934$var$LightOrangeMediumIconWrapper,
        'lightest-red': $4d118138298fb934$var$LightRedMediumIconWrapper,
        'lightest-magenta': $4d118138298fb934$var$LightMagentaMediumIconWrapper,
        'lighter-gray': $4d118138298fb934$var$WhiteMediumIconWrapper,
        'lighter-purple': $4d118138298fb934$var$LightPurpleMediumIconWrapper,
        'lighter-blue': $4d118138298fb934$var$LightBlueMediumIconWrapper,
        'lighter-teal': $4d118138298fb934$var$LightTealMediumIconWrapper,
        'lighter-green': $4d118138298fb934$var$LightGreenMediumIconWrapper,
        'lighter-lime': $4d118138298fb934$var$LightLimeMediumIconWrapper,
        'lighter-yellow': $4d118138298fb934$var$LightYellowMediumIconWrapper,
        'lighter-orange': $4d118138298fb934$var$LightOrangeMediumIconWrapper,
        'lighter-red': $4d118138298fb934$var$LightRedMediumIconWrapper,
        'lighter-magenta': $4d118138298fb934$var$LightMagentaMediumIconWrapper,
        'darker-gray': $4d118138298fb934$var$DarkMediumIconWrapper,
        'darker-purple': $4d118138298fb934$var$PurpleMediumIconWrapper,
        'darker-blue': $4d118138298fb934$var$BlueMediumIconWrapper,
        'darker-teal': $4d118138298fb934$var$TealMediumIconWrapper,
        'darker-green': $4d118138298fb934$var$GreenMediumIconWrapper,
        'darker-lime': $4d118138298fb934$var$LimeMediumIconWrapper,
        'darker-yellow': $4d118138298fb934$var$YellowMediumIconWrapper,
        'darker-orange': $4d118138298fb934$var$OrangeMediumIconWrapper,
        'darker-red': $4d118138298fb934$var$RedMediumIconWrapper,
        'darker-magenta': $4d118138298fb934$var$MagentaMediumIconWrapper,
        'darkest-gray': $4d118138298fb934$var$DarkMediumIconWrapper,
        'darkest-purple': $4d118138298fb934$var$PurpleMediumIconWrapper,
        'darkest-blue': $4d118138298fb934$var$BlueMediumIconWrapper,
        'darkest-teal': $4d118138298fb934$var$TealMediumIconWrapper,
        'darkest-green': $4d118138298fb934$var$GreenMediumIconWrapper,
        'darkest-lime': $4d118138298fb934$var$LimeMediumIconWrapper,
        'darkest-yellow': $4d118138298fb934$var$YellowMediumIconWrapper,
        'darkest-orange': $4d118138298fb934$var$OrangeMediumIconWrapper,
        'darkest-red': $4d118138298fb934$var$RedMediumIconWrapper,
        'darkest-magenta': $4d118138298fb934$var$MagentaMediumIconWrapper,
        'no-background': $4d118138298fb934$var$WhiteMediumIconWrapper
    }
};

});


parcelRegister("7BoX4", function(module, exports) {

$parcel$export(module.exports, "default", () => $87c30ceaf64f4777$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $87c30ceaf64f4777$var$ActiveItem = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($87c30ceaf64f4777$var$ActiveItemWrapper, {
        "data-testid": testId
    }, children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $87c30ceaf64f4777$var$ActiveItemWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1sit _bfhkiw92",
            __cmplp.className
        ])
    });
});
var $87c30ceaf64f4777$export$2e2bcd8739ae039 = $87c30ceaf64f4777$var$ActiveItem;

});

parcelRegister("2Ucfd", function(module, exports) {

$parcel$export(module.exports, "default", () => $f309bbea3103a655$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $f309bbea3103a655$var$LinkLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1e5h _1e0c1ule _o5721q9c _1reo15vq _18m915vq _1bto1l2s _k48pbfng _16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});
var $f309bbea3103a655$export$2e2bcd8739ae039 = $f309bbea3103a655$var$LinkLabel;

});

parcelRegister("3YFEG", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b3c14587c33fc56$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /* eslint-disable jira/react/no-classname-attribute */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $PdmhA = parcelRequire("PdmhA");

var $kJlBc = parcelRequire("kJlBc");
const $1b3c14587c33fc56$var$SidebarLink = ({ children: children, elemAfter: elemAfter, className: className, testId: testId, isActive: isActive = false, ...other })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b3c14587c33fc56$var$Wrapper, {
        isActive: isActive,
        className: className,
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b3c14587c33fc56$var$StyledLink, {
        "aria-current": isActive ? 'page' : undefined,
        ...other
    }, children), elemAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b3c14587c33fc56$var$ElementAfterWrapper, {
        "data-component-selector": "sidebar-link-elem-after"
    }, elemAfter));
const $1b3c14587c33fc56$var$showElementAfter = {
    width: 'inherit !important',
    opacity: 1
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1b3c14587c33fc56$var$ElementAfterWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1bsbgrf3 _tzy4idpf _2hwxu2gc _195pjdj5 _1mygkb7n",
            __cmplp.className
        ])
    });
});
const $1b3c14587c33fc56$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isActive: isActive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1b30gsy": (0, $9t7rW.default)(!__cmplp.isActive && `var(--ds-background-neutral, ${(0, $PdmhA).N20A})`),
            "--_dpi1qg": (0, $9t7rW.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            !__cmplp.isActive && `var(--ds-background-neutral, ${(0, $PdmhA).N20A})`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _2rko1sit _4t3i1ylp _v5649dqc _1bqoyh40 _rhjqnqa1 _boy0v77o _i9oi194a _ylp5tjc1 _irr3tjc1 _7gg8jdj5 _7ih6kb7n _gnguyh40 _1bv6nqa1 _ygb3v77o _1qtp194a _sbojjewh",
            __cmplp.className
        ])
    });
});
const $1b3c14587c33fc56$var$StyledLink = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $kJlBc.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf _1yt4u2gc _1e0c1txw _4cvr1h6o _syazjjyb _1q5t1r31 _nt751r31 _mizu1r31 _1dit1r31 _1ohyglyw _49pcglyw _ra3xglyw _ksodglyw _1r9x1o36 _1hvw1o36 _128m1o36 _4hz81o36 _180dglyw _7ehiglyw _1ejjglyw _1dbzglyw _1nrm18uv _1a3b18uv _vjfr18uv _9oik18uv _c2waglyw _4fprglyw _10xfglyw _1bnxglyw _1iohnqa1 _5goinqa1 _1w0vnqa1 _jf4cnqa1 _9h8h1fxt _f8pj1fxt _v0vw1fxt _30l31fxt",
            __cmplp.className
        ])
    });
});
var $1b3c14587c33fc56$export$2e2bcd8739ae039 = $1b3c14587c33fc56$var$SidebarLink;

});



parcelRegister("9QtHd", function(module, exports) {

$parcel$export(module.exports, "default", () => $7365cd4b1a70e60e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $86Ndv = parcelRequire("86Ndv");

var $PdmhA = parcelRequire("PdmhA");

var $15zK8 = parcelRequire("15zK8");

var $fIhju = parcelRequire("fIhju");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kMUsV = parcelRequire("kMUsV");

var $8RzJd = parcelRequire("8RzJd");

var $bVacK = parcelRequire("bVacK");

var $1nRKu = parcelRequire("1nRKu");
const $7365cd4b1a70e60e$var$PROJECT_LINK_TEST_ID = 'navigation-apps-sidebar-core.ui.multi-project-menu.project-link';
const $7365cd4b1a70e60e$var$getDefaultProjectUrl = (project)=>project.defaultView ? `/jira/core/projects/${project.key}/${project.defaultView}` : `/jira/core/projects/${project.key}`;
const $7365cd4b1a70e60e$var$ProjectGroup = ({ sectionId: sectionId, projects: projects, onFavoriteToggle: onFavoriteToggle, currentProjectKey: currentProjectKey, currentRoute: currentRoute, showViewAllProjects: showViewAllProjects = false, viewAllProjectsLabel: viewAllProjectsLabel })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const title = sectionId === 'starred' ? formatMessage((0, $bVacK.default).favorites) : formatMessage((0, $bVacK.default).recents);
    const [isExpanded, setIsExpanded] = (0, $eUqFw.useState)(true);
    const onToggleExpand = (0, $eUqFw.useCallback)(()=>{
        setIsExpanded(!isExpanded);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'section toggled', 'sidebar', {
            sectionId: sectionId,
            collapse: isExpanded
        });
    }, [
        createAnalyticsEvent,
        isExpanded,
        sectionId
    ]);
    const chevronIcon = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7365cd4b1a70e60e$var$IconWrapper, {
            isExpanded: isExpanded
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
            label: formatMessage(isExpanded ? (0, $bVacK.default).collapseSection : (0, $bVacK.default).expandSection, {
                section: title
            }),
            primaryColor: `var(--ds-text-subtlest, ${(0, $PdmhA).N300})`
        })), [
        formatMessage,
        isExpanded,
        title
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7365cd4b1a70e60e$export$7d436a88869873b5, {
        "data-testid": `navigation-apps-sidebar-core.ui.multi-project-menu.project-group.${sectionId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7365cd4b1a70e60e$export$dca3dbf057c88c5f, {
        "aria-expanded": isExpanded,
        "aria-controls": `multi-project-menu-project-group-${sectionId}`,
        onClick: onToggleExpand,
        "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.project-group.toggle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        spacing: "none",
        iconBefore: chevronIcon
    }), title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $15zK8.Collapsible), {
        id: `multi-project-menu-project-group-${sectionId}`,
        isExpanded: isExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7365cd4b1a70e60e$export$99bffacbdbcb5195, null, projects.map((project)=>project.key === currentProjectKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", {
            key: project.key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8RzJd.default), {
            project: project,
            to: (0, $1ybV0.ff)('jwm.custom-project-navigation') ? $7365cd4b1a70e60e$var$getDefaultProjectUrl(project) : (0, $fIhju.getProjectUrl)(project),
            onFavoriteToggle: ()=>onFavoriteToggle(project)
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", {
            key: project.key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kMUsV.default), {
            project: project,
            to: (0, $1ybV0.ff)('jwm.custom-project-navigation') ? $7365cd4b1a70e60e$var$getDefaultProjectUrl(project) : (0, $fIhju.getProjectUrl)(project, currentRoute),
            onClick: ()=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'jwmProjectLink', {
                    projectId: project.id,
                    starred: project.isFavorite,
                    current: false
                }),
            onFavoriteToggle: ()=>onFavoriteToggle(project),
            prefetch: "hover",
            testId: $7365cd4b1a70e60e$var$PROJECT_LINK_TEST_ID
        }))), showViewAllProjects && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1nRKu.default), {
        label: viewAllProjectsLabel
    })))));
};
var $7365cd4b1a70e60e$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($7365cd4b1a70e60e$var$ProjectGroup);
const $7365cd4b1a70e60e$var$IconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isExpanded: isExpanded, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_v5641b1u _k8m01e03",
            __cmplp.isExpanded ? "_t9ec1ul7" : "_t9ec2i46",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $7365cd4b1a70e60e$export$7d436a88869873b5 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _18s83l1n _onzypxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $7365cd4b1a70e60e$export$dca3dbf057c88c5f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1rc1 _1e0c1txw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1yt4otz2 _4cvr1h6o _80omtlke _1p1dangw _11c816g6 _zulptij8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $7365cd4b1a70e60e$export$99bffacbdbcb5195 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "ol", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41b66 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _qtt8glyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("15zK8", function(module, exports) {

$parcel$export(module.exports, "Collapsible", () => $cd108e84fbd541ee$export$6eb0f7ddcda6131f);

var $eUqFw = parcelRequire("eUqFw");

var $4WrKv = parcelRequire("4WrKv");
const $cd108e84fbd541ee$export$6eb0f7ddcda6131f = ({ children: children, id: id, isExpanded: isExpanded, animationDuration: animationDuration = 250 })=>{
    const didMountRef = (0, $eUqFw.useRef)(false);
    const [containerHeight, setContainerHeight] = (0, $eUqFw.useState)(isExpanded ? null : 0);
    const [isRendered, setIsRendered] = (0, $eUqFw.useState)(isExpanded);
    const wrapperRef = (0, $eUqFw.useRef)(null);
    const contentRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!didMountRef.current) {
            didMountRef.current = true;
            return;
        }
        if (isExpanded) {
            setIsRendered(true);
            requestAnimationFrame(()=>{
                setContainerHeight(contentRef.current?.offsetHeight ?? null);
                Promise.all(wrapperRef.current?.getAnimations().map((animation)=>animation.finished) ?? []).then(()=>{
                    setContainerHeight(null);
                });
            });
        } else {
            setContainerHeight(contentRef.current?.offsetHeight ?? null);
            requestAnimationFrame(()=>{
                setContainerHeight(0);
                Promise.all(wrapperRef.current?.getAnimations().map((animation)=>animation.finished) ?? []).then(()=>{
                    setIsRendered(false);
                });
            });
        }
    }, [
        contentRef,
        isExpanded
    ]);
    if (!isRendered) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4WrKv.CollapsibleWrapper), {
        animationDuration: animationDuration,
        containerHeight: containerHeight,
        id: id,
        ref: wrapperRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: contentRef
    }, children));
};

});
parcelRegister("4WrKv", function(module, exports) {

$parcel$export(module.exports, "CollapsibleWrapper", () => $932f846aacdec0cd$export$417956c58046108f);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $932f846aacdec0cd$export$417956c58046108f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { animationDuration: animationDuration, containerHeight: containerHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_3opy9g": (0, $9t7rW.default)(`max-height ${__cmplp.animationDuration}ms ease-in-out`),
            "--_3k6n1g": (0, $9t7rW.default)(__cmplp.containerHeight, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _v564plo1",
            __cmplp.containerHeight != null ? "_c71ld5na" : "_c71ln7od",
            __cmplp.className
        ])
    });
});

});


parcelRegister("kMUsV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c19644e3c562f1f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /* eslint-disable jira/react/no-classname-attribute */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5JDHd = parcelRequire("5JDHd");

var $3YFEG = parcelRequire("3YFEG");
const $3c19644e3c562f1f$var$ProjectItem = ({ project: project, onClick: onClick, onFavoriteToggle: onFavoriteToggle, to: to, isActive: isActive, className: className, testId: testId, prefetch: prefetch })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3YFEG.default), {
        to: to,
        onClick: onClick,
        isActive: isActive,
        elemAfter: project.permissions.viewIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5JDHd.default), {
            project: project,
            onToggle: onFavoriteToggle
        }),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        testId: testId,
        prefetch: prefetch
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3c19644e3c562f1f$var$Avatar, {
        src: project.avatarUrl,
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3c19644e3c562f1f$var$ProjectName, null, project.name));
var $3c19644e3c562f1f$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($3c19644e3c562f1f$var$ProjectItem);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3c19644e3c562f1f$var$ProjectName = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _y3gn1e5h _1e0c1ule _o5721q9c _1bto1l2s _k48pbfng",
            __cmplp.className
        ])
    });
});
const $3c19644e3c562f1f$var$Avatar = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _vchhusvi _4t3i1tcg _1bsb1tcg _2hwxutpp _2rko1l7b",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5JDHd", function(module, exports) {

$parcel$export(module.exports, "default", () => $e54e45b65655165e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $daM3L = parcelRequire("daM3L");

var $hlWtt = parcelRequire("hlWtt");

var $b5IAe = parcelRequire("b5IAe");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $bJdnT = parcelRequire("bJdnT");

var $fVRXn = parcelRequire("fVRXn");
const $e54e45b65655165e$var$FavoriteButton = ({ project: project, onToggle: onToggle })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const label = project.isFavorite ? formatMessage((0, $bJdnT.default).unstar) : formatMessage((0, $bJdnT.default).star);
    const onClick = (0, $eUqFw.useCallback)(()=>{
        const star = !project.isFavorite;
        onToggle(star);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'project starred', 'sidebar', {
            projectId: project.id,
            star: star
        });
    }, [
        project,
        onToggle,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        padding: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: label,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fVRXn.Button), {
        isFavorite: project.isFavorite ?? false,
        onClick: onClick,
        "data-testid": "navigation-apps-sidebar-core.common.ui.favorite-button"
    }, project.isFavorite ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hlWtt))), {
        label: label
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($daM3L))), {
        label: label
    }))));
};
var $e54e45b65655165e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($e54e45b65655165e$var$FavoriteButton);

});
parcelRegister("bJdnT", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b07613b1e7eec39$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8b07613b1e7eec39$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    star: {
        "id": "spa-apps-sidebar-core.common.favorite-button.star",
        "defaultMessage": "Add to Starred"
    },
    unstar: {
        "id": "spa-apps-sidebar-core.common.favorite-button.unstar",
        "defaultMessage": "Remove from Starred"
    }
});

});

parcelRegister("fVRXn", function(module, exports) {

$parcel$export(module.exports, "Button", () => $2b3f0059348a9897$export$353f5b6fc5456de1);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $2b3f0059348a9897$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4v77o _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $2b3f0059348a9897$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFavorite: isFavorite, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _11q7glyw _80omtlke _2rko1sit _1spjglyw _157zglyw",
            __cmplp.isFavorite ? "_syazkizl" : "_syazjjyb",
            __cmplp.isFavorite ? "_f8pj1ov0 _30l31ov0 _17051ov0" : "_f8pj1wmz _30l31wmz _17051wmz",
            __cmplp.className
        ])
    });
});

});



parcelRegister("8RzJd", function(module, exports) {

$parcel$export(module.exports, "default", () => $37e313fba1125d29$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $7BoX4 = parcelRequire("7BoX4");

var $kMUsV = parcelRequire("kMUsV");

var $4q3vw = parcelRequire("4q3vw");
const $37e313fba1125d29$var$TEST_ID = 'navigation-apps-sidebar-core.ui.multi-project-menu.current-project';
const $37e313fba1125d29$var$ActiveProject = ({ project: project, to: to, onFavoriteToggle: onFavoriteToggle })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onClick = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'jwmProjectLink', {
            projectId: project.id,
            starred: project.isFavorite,
            current: true
        });
    }, [
        createAnalyticsEvent,
        project
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7BoX4.default), {
        testId: $37e313fba1125d29$var$TEST_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kMUsV.default), {
        project: project,
        to: to,
        isActive: true,
        onClick: onClick,
        onFavoriteToggle: onFavoriteToggle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4q3vw.default), null));
};
var $37e313fba1125d29$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($37e313fba1125d29$var$ActiveProject);

});
parcelRegister("4q3vw", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb5df3a65802a7af$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $exb0h = parcelRequire("exb0h");

var $hzZWH = parcelRequire("hzZWH");

var $zMQ0U = parcelRequire("zMQ0U");

var $10fdS = parcelRequire("10fdS");

var $lg3mT = parcelRequire("lg3mT");

var $kFwR2 = parcelRequire("kFwR2");
var $k5Z6m = parcelRequire("k5Z6m");

var $4ZQun = parcelRequire("4ZQun");

var $44AZS = parcelRequire("44AZS");

var $bp2TG = parcelRequire("bp2TG");

var $8Xc28 = parcelRequire("8Xc28");

var $aZ40y = parcelRequire("aZ40y");
const $eb5df3a65802a7af$var$calculateStack = (route, connectStack, forgeStack)=>{
    const routeName = route && route.name || '';
    // should be handled above generic PROJECT_SETTINGS_CORE logic
    if ((0, $lg3mT.FORGE_ROUTES_SET).has(routeName) && forgeStack) return forgeStack;
    if ((0, $exb0h.CONNECT_ROUTES_SET).has(routeName) && connectStack) return connectStack;
    return [];
};
const $eb5df3a65802a7af$var$ProjectMenu = ()=>{
    const route = (0, $10fdS.useCurrentRoute)();
    const { data: project } = (0, $k5Z6m.default)();
    const { data: features, loading: isFeaturesLoading } = (0, $kFwR2.useFeatures)();
    const { stack: connectProjectStack } = (0, $kFwR2.useProjectConnectItems)();
    const { stack: connectReportsStack } = (0, $kFwR2.useProjectReportsConnectItems)();
    const { stack: connectSettingsStack } = (0, $kFwR2.useProjectSettingsConnectItems)();
    const connectStack = connectProjectStack || connectReportsStack || connectSettingsStack;
    const { loading: projectForgeAppsLoading, stack: forgeStack } = (0, $zMQ0U.useProjectForgeApps)((0, $exb0h.ROUTE_NAMES).FORGE_PROJECT);
    const [stack, setStack] = (0, $eUqFw.useState)(()=>$eb5df3a65802a7af$var$calculateStack(route, connectStack, forgeStack));
    (0, $eUqFw.useEffect)(()=>{
        setStack($eb5df3a65802a7af$var$calculateStack(route, connectStack, forgeStack));
    }, [
        route,
        connectStack,
        forgeStack
    ]);
    if (project == null || isFeaturesLoading || features == null || projectForgeAppsLoading) return null;
    let content = null;
    if ((0, $lg3mT.ISSUES_ROUTES_SET).has(route.name)) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bp2TG.default), {
        project: project
    });
    else if ((0, $lg3mT.REPORTS_ROUTES_SET).has(route.name) || connectReportsStack) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Xc28.default), null);
    else if ((0, $lg3mT.SETTINGS_ROUTES_SET).has(route.name) || route?.group === (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_CORE || connectSettingsStack) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aZ40y.default), {
        project: project
    });
    else if ((0, $lg3mT.FORGE_ROUTES_SET).has(route.name) || forgeStack) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $44AZS.default), null);
    else if ((0, $exb0h.CONNECT_ROUTES_SET).has(route.name) || connectProjectStack) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZQun.default), {
        stack: stack,
        onStackChange: setStack,
        project: project
    });
    else return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hzZWH.ContextualAnalyticsData), {
        menuId: (0, $lg3mT.MENU_ID),
        stack: stack
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb5df3a65802a7af$export$42a852a2b6b56249, null, content));
};
const $eb5df3a65802a7af$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _1e0c1txw _2lx21bp4 _fshqh2mm _10p2glyw",
            __cmplp.className
        ])
    });
});
var $eb5df3a65802a7af$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($eb5df3a65802a7af$var$ProjectMenu);

});
parcelRegister("zMQ0U", function(module, exports) {

$parcel$export(module.exports, "useProjectForgeApps", () => $9e96c2833d013144$export$338edd25edcf3648);

var $eUqFw = parcelRequire("eUqFw");

var $fTsDx = parcelRequire("fTsDx");

var $l90Gp = parcelRequire("l90Gp");

var $bNe1g = parcelRequire("bNe1g");

var $iZJHG = parcelRequire("iZJHG");

var $6ibpp = parcelRequire("6ibpp");
const $9e96c2833d013144$export$338edd25edcf3648 = (routeName, projectKey)=>{
    const { data: projectContext } = (0, $bNe1g.useProjectContext)(projectKey ? {
        matchParams: {
            projectKey: projectKey
        }
    } : undefined);
    const { data: data, loading: loading, error: error } = (0, $iZJHG.useResourceWithCustomRouterContext)((0, $l90Gp.forgeProjectModuleResource), projectKey ? {
        matchParams: {
            projectKey: projectKey
        }
    } : undefined);
    const projectData = (0, $eUqFw.useMemo)(()=>data?.extensions || null, [
        data
    ]);
    const accessNarrowedData = (0, $eUqFw.useMemo)(()=>data?.accessNarrowedExtensions || null, [
        data
    ]);
    const stack = (0, $6ibpp.useForgeItemStack)(projectData, routeName);
    // Instead of dumping projectContext as is we'd like to hardcode the context
    // to be sure that correct prop are exposed externally
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const context = projectContext ? {
        projectKey: projectContext.projectKey,
        projectId: projectContext.projectId,
        projectName: projectContext.projectName,
        projectType: projectContext.projectType,
        isProjectAdmin: projectContext.isProjectAdmin,
        isProjectArchived: projectContext.isProjectArchived
    } : {};
    return (0, $eUqFw.useMemo)(()=>({
            data: projectData ? projectData.filter((extension)=>(0, $fTsDx.doesExtensionMeetConditions)(extension, context)) : null,
            accessNarrowedData: accessNarrowedData,
            loading: loading,
            error: error,
            stack: stack
        }), [
        projectData,
        accessNarrowedData,
        loading,
        error,
        stack,
        context
    ]);
};

});
parcelRegister("6ibpp", function(module, exports) {

$parcel$export(module.exports, "useForgeItemStack", () => $f4e8d0de7e963f6a$export$462f82a278743d46);

var $eUqFw = parcelRequire("eUqFw");

var $kJlBc = parcelRequire("kJlBc");

var $eOutC = parcelRequire("eOutC");

var $jMYeN = parcelRequire("jMYeN");
const $f4e8d0de7e963f6a$export$462f82a278743d46 = (modules, routeName, parentStack)=>{
    const [{ match: match, route: route }] = (0, $kJlBc.useRouter)();
    const matchedExtension = (0, $eOutC.useMatchedExtension)({
        modules: modules,
        match: match
    });
    return (0, $eUqFw.useMemo)(()=>{
        if (route.name !== routeName) return null;
        // match nested navigation view
        if (matchedExtension && (0, $jMYeN.toSections)(matchedExtension).length) {
            const stackId = `${matchedExtension.id}-subpages`;
            return parentStack ? [
                ...parentStack,
                stackId
            ] : [
                stackId
            ];
        }
        // match a simple navigation item (a single top-level page is defined in the manifest)
        if (matchedExtension && parentStack) return parentStack;
        // skip
        return null;
    }, [
        matchedExtension,
        parentStack,
        route.name,
        routeName
    ]);
};

});


parcelRegister("kFwR2", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $07989a85c9068e6d$export$4a39035bacc4ed76);
$parcel$export(module.exports, "useProjectConnectItems", () => $07989a85c9068e6d$export$f23d0c24c77d7608);
$parcel$export(module.exports, "useProjectReportsConnectItems", () => $07989a85c9068e6d$export$a1c75c386c088992);
$parcel$export(module.exports, "useProjectSettingsConnectItems", () => $07989a85c9068e6d$export$41a50100db18b578);
$parcel$export(module.exports, "useProjectSettingsForgeItems", () => $07989a85c9068e6d$export$84761bbf25a4f51f);

var $c4mKR = parcelRequire("c4mKR");

var $kIUmN = parcelRequire("kIUmN");

var $2jFgb = parcelRequire("2jFgb");
var $fpWGf = parcelRequire("fpWGf");
var $2RJCt = parcelRequire("2RJCt");

var $j65a5 = parcelRequire("j65a5");

var $bRhBg = parcelRequire("bRhBg");

var $k5Z6m = parcelRequire("k5Z6m");

var $asnZU = parcelRequire("asnZU");
const $07989a85c9068e6d$export$4a39035bacc4ed76 = (0, $kIUmN.withThrowOnError)((0, $bRhBg.useFeatures));
const $07989a85c9068e6d$export$f23d0c24c77d7608 = (0, $kIUmN.withThrowOnError)((0, $2jFgb.useProjectConnectItems));
const $07989a85c9068e6d$export$a1c75c386c088992 = (0, $kIUmN.withThrowOnError)((0, $fpWGf.useProjectReportsConnectItems));
const $07989a85c9068e6d$export$41a50100db18b578 = (0, $kIUmN.withThrowOnError)((0, $2RJCt.useProjectSettingsConnectItems));
const $07989a85c9068e6d$export$84761bbf25a4f51f = (0, $j65a5.useProjectSettingsForgeAppsForMenu);
const $07989a85c9068e6d$export$96e8a0c1f4717705 = (0, $kIUmN.withThrowOnError)((0, $c4mKR.useJiraWorkManagementProjectPagesLink));

});
parcelRegister("c4mKR", function(module, exports) {

$parcel$export(module.exports, "useJiraSoftwareProjectPagesLink", () => $17dbd504b329aecd$export$50628ae0ad1a35f2);
$parcel$export(module.exports, "useJiraWorkManagementProjectPagesLink", () => $17dbd504b329aecd$export$96e8a0c1f4717705);

var $eUqFw = parcelRequire("eUqFw");

var $lRmyA = parcelRequire("lRmyA");

var $2futN = parcelRequire("2futN");
const $17dbd504b329aecd$var$pagesLinkBaseUrl = (baseUrl, projectKey)=>`${baseUrl}/rest/projects/1.0/pageslink/${projectKey}`;
const $17dbd504b329aecd$var$enablePagesLinkUrl = (baseUrl, projectKey)=>`${$17dbd504b329aecd$var$pagesLinkBaseUrl(baseUrl, projectKey)}/enable`;
const $17dbd504b329aecd$var$disablePagesLinkUrl = (baseUrl, projectKey)=>`${$17dbd504b329aecd$var$pagesLinkBaseUrl(baseUrl, projectKey)}/disable`;
const $17dbd504b329aecd$var$setPagesLinkService = ({ baseUrl: baseUrl, projectKey: projectKey, enable: enable })=>enable ? (0, $lRmyA.performPutRequest)($17dbd504b329aecd$var$enablePagesLinkUrl(baseUrl, projectKey)) : (0, $lRmyA.performPutRequest)($17dbd504b329aecd$var$disablePagesLinkUrl(baseUrl, projectKey));
const $17dbd504b329aecd$var$isProjectOrJiraAdmin = (permissionInfo)=>permissionInfo.isAdmin || permissionInfo.projectPermissionsQueried.ADMINISTER_PROJECTS === true;
const $17dbd504b329aecd$export$50628ae0ad1a35f2 = ()=>{
    const { data: data, loading: loading, refresh: refresh, error: error } = (0, $2futN.useJiraSoftwareProjectNavigation)();
    const setPagesLink = (0, $eUqFw.useCallback)(async (...args)=>{
        await $17dbd504b329aecd$var$setPagesLinkService(...args);
        await refresh();
    }, [
        refresh
    ]);
    return {
        data: {
            isEnabled: data?.hasPages === true,
            canEdit: data?.permissionInfo != null && $17dbd504b329aecd$var$isProjectOrJiraAdmin(data.permissionInfo),
            pending: loading,
            setPagesLink: setPagesLink
        },
        loading: loading,
        error: error
    };
};
const $17dbd504b329aecd$export$96e8a0c1f4717705 = ()=>{
    const { loading: loading, refresh: refresh, error: error } = (0, $2futN.useJiraWorkmanagementProjectNavigation)();
    const setPagesLink = (0, $eUqFw.useCallback)(async (...args)=>{
        await $17dbd504b329aecd$var$setPagesLinkService(...args);
        await refresh();
    }, [
        refresh
    ]);
    return {
        data: {
            isEnabled: true,
            canEdit: false,
            pending: loading,
            setPagesLink: setPagesLink
        },
        loading: loading,
        error: error
    };
};

});

parcelRegister("j65a5", function(module, exports) {

$parcel$export(module.exports, "useProjectSettingsForgeApps", () => $952e927805fb78ba$export$bef2e514007d2f07);
$parcel$export(module.exports, "useProjectSettingsForgeAppsForMenu", () => $952e927805fb78ba$export$b741e3e3cfb39b82);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $2Rqjr = parcelRequire("2Rqjr");

var $fTsDx = parcelRequire("fTsDx");

var $70ON1 = parcelRequire("70ON1");

var $l90Gp = parcelRequire("l90Gp");

var $bNe1g = parcelRequire("bNe1g");

var $3HCkE = parcelRequire("3HCkE");

var $gd0Sp = parcelRequire("gd0Sp");

var $jMYeN = parcelRequire("jMYeN");
var $6ibpp = parcelRequire("6ibpp");
const $952e927805fb78ba$export$bef2e514007d2f07 = ()=>{
    const { data: projectContext } = (0, $bNe1g.useProjectContext)();
    const { data: data, loading: loading, error: error } = (0, $3HCkE.useResource)((0, $l90Gp.forgeProjectSettingsModuleResource));
    const projectSettingsData = (0, $eUqFw.useMemo)(()=>data?.extensions || null, [
        data
    ]);
    const accessNarrowedData = (0, $eUqFw.useMemo)(()=>data?.accessNarrowedExtensions || null, [
        data
    ]);
    const { isAdmin: isAdmin, isSiteAdmin: isSiteAdmin } = (0, $gd0Sp.useTenantContext)();
    const hasPermissions = (0, $eUqFw.useMemo)(()=>(projectContext?.isProjectAdmin || isAdmin || isSiteAdmin) === true, [
        isAdmin,
        isSiteAdmin,
        projectContext?.isProjectAdmin
    ]);
    // Instead of dumping projectContext as is we'd like to hardcode the context
    // to be sure that correct prop are exposed externally
    const context = (0, $eUqFw.useMemo)(()=>projectContext ? {
            projectKey: projectContext.projectKey,
            projectId: projectContext.projectId,
            projectName: projectContext.projectName,
            projectType: projectContext.projectType
        } : {}, [
        projectContext
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            data: projectSettingsData ? projectSettingsData.filter((extension)=>hasPermissions && (0, $fTsDx.doesExtensionMeetConditions)(extension, context)) : null,
            accessNarrowedData: accessNarrowedData,
            loading: loading,
            error: error
        }), [
        projectSettingsData,
        accessNarrowedData,
        loading,
        error,
        hasPermissions,
        context
    ]);
};
const $952e927805fb78ba$var$appsProjectTypeRouteMap = {
    tmp: {
        [(0, $7ZZxN.CORE_PROJECT)]: 'core',
        [(0, $7ZZxN.SOFTWARE_PROJECT)]: 'software',
        [(0, $7ZZxN.SERVICE_DESK_PROJECT)]: 'servicedesk',
        // it's genuinely missing Jira Product Discovery and CUSTOMER_SERVICE_PROJECT support
        [(0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)]: undefined,
        [(0, $7ZZxN.CUSTOMER_SERVICE_PROJECT)]: undefined
    },
    cmp: {
        [(0, $7ZZxN.CORE_PROJECT)]: 'core',
        [(0, $7ZZxN.SOFTWARE_PROJECT)]: 'software/c',
        [(0, $7ZZxN.SERVICE_DESK_PROJECT)]: 'servicedesk',
        [(0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)]: undefined,
        [(0, $7ZZxN.CUSTOMER_SERVICE_PROJECT)]: undefined
    }
};
const $952e927805fb78ba$export$ed6342e0e28465a6 = (extension, projectType, projectKey, isSimplified)=>{
    const { appId: appId, envId: envId } = (0, $70ON1.parseExtensionId)(extension.id);
    return `/jira/${$952e927805fb78ba$var$appsProjectTypeRouteMap[isSimplified ? 'tmp' : 'cmp'][projectType]}/projects/${projectKey}/settings/apps/${appId}/${envId}`;
};
const $952e927805fb78ba$export$b741e3e3cfb39b82 = (routeName, parentStack)=>{
    const { data: projectContext } = (0, $bNe1g.useProjectContext)();
    const { data: data, loading: loading, error: error } = $952e927805fb78ba$export$bef2e514007d2f07();
    const stack = (0, $6ibpp.useForgeItemStack)(data, routeName, parentStack);
    const { projectType: projectType, projectKey: projectKey, simplified: isSimplified } = projectContext || {};
    return (0, $eUqFw.useMemo)(()=>({
            data: data ? data.map((extension)=>({
                    id: extension.id,
                    // @ts-expect-error - TS2345 - Argument of type 'ProjectType | undefined' is not assignable to parameter of type 'ProjectType'.
                    url: $952e927805fb78ba$export$ed6342e0e28465a6(extension, projectType, projectKey, isSimplified),
                    name: extension.properties.title,
                    iconUrl: extension.properties.icon,
                    environmentType: extension.environmentType,
                    environmentKey: extension.environmentKey,
                    moduleName: (0, $2Rqjr.PROJECT_SETTINGS_PAGE_MODULE),
                    sections: (0, $jMYeN.toSections)(extension)
                })) : null,
            loading: loading,
            error: error,
            stack: stack
        }), [
        data,
        loading,
        error,
        stack,
        projectType,
        projectKey,
        isSimplified
    ]);
};

});

parcelRegister("bRhBg", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $8d33e1dc80dc383e$export$4a39035bacc4ed76);
$parcel$export(module.exports, "useSettingFeatures", () => $8d33e1dc80dc383e$export$56022a3b83c8ed6a);
$parcel$export(module.exports, "useReportFeatures", () => $8d33e1dc80dc383e$export$4adaea9828b7ff13);

var $eUqFw = parcelRequire("eUqFw");

var $eL2Xo = parcelRequire("eL2Xo");
var $2futN = parcelRequire("2futN");

var $f26dB = parcelRequire("f26dB");

var $fz8wa = parcelRequire("fz8wa");

var $ly8Gh = parcelRequire("ly8Gh");
const $8d33e1dc80dc383e$export$4a39035bacc4ed76 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2futN.useJiraWorkmanagementProjectNavigation)();
    const isPremiumUserSeat = (0, $f26dB.useIsPremiumUserSeat)();
    const transformedData = (0, $eUqFw.useMemo)(()=>data && (0, $ly8Gh.getExtraData)(data, isPremiumUserSeat), [
        data,
        isPremiumUserSeat
    ]);
    return {
        data: transformedData,
        loading: loading,
        error: error
    };
};
const $8d33e1dc80dc383e$export$56022a3b83c8ed6a = ()=>{
    const hasActiveSoftwareAccess = (0, $eL2Xo.useHasActiveSoftwareAccess)();
    const { data: data, loading: loading, error: error } = (0, $2futN.useJiraWorkmanagementProjectNavigation)();
    const transformedData = (0, $eUqFw.useMemo)(()=>data && (0, $ly8Gh.getExtraSettingsData)(data, hasActiveSoftwareAccess), [
        data,
        hasActiveSoftwareAccess
    ]);
    return {
        data: transformedData,
        loading: loading,
        error: error
    };
};
const $8d33e1dc80dc383e$export$4adaea9828b7ff13 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2futN.useJiraWorkmanagementProjectNavigation)();
    const { hasSoftwareAccess: hasSoftwareAccess } = (0, $fz8wa.useApplicationPermissions)();
    const transformedData = (0, $eUqFw.useMemo)(()=>data && (0, $ly8Gh.getExtraReportData)(hasSoftwareAccess), [
        data,
        hasSoftwareAccess
    ]);
    return {
        data: transformedData,
        loading: loading,
        error: error
    };
};

});
parcelRegister("eL2Xo", function(module, exports) {

$parcel$export(module.exports, "useHasActiveSoftwareAccess", () => $154cbdbba7c6a38b$export$895f9b38ce00671e);

var $ab6rA = parcelRequire("ab6rA");
var $fz8wa = parcelRequire("fz8wa");
const $154cbdbba7c6a38b$export$895f9b38ce00671e = ()=>{
    const { software: software } = (0, $ab6rA.useAppEditions)();
    const { hasSoftwareAccess: hasSoftwareAccess } = (0, $fz8wa.useApplicationPermissions)();
    return software !== 'UNLICENSED' && hasSoftwareAccess === true;
};

});

parcelRegister("ly8Gh", function(module, exports) {

$parcel$export(module.exports, "getExtraData", () => $755f4ca371b0583d$export$6c55c6c980ed2046);
$parcel$export(module.exports, "getExtraSettingsData", () => $755f4ca371b0583d$export$b77a5597b7177cfb);
$parcel$export(module.exports, "getExtraReportData", () => $755f4ca371b0583d$export$be58a1e7b06d1d3);
const $755f4ca371b0583d$export$6c55c6c980ed2046 = (data, isPremium)=>{
    const { permissionInfo: permissionInfo, hasComponents: hasComponents = false, project: project } = data;
    const { isAdmin: isAdmin, projectPermissionsQueried: projectPermissionsQueried } = permissionInfo;
    const isProjectOrJiraAdmin = projectPermissionsQueried.ADMINISTER_PROJECTS === true || isAdmin;
    const isSimplifiedProject = project.simplified;
    return {
        hasVersions: true,
        hasSettings: isProjectOrJiraAdmin,
        hasBoard: true,
        hasReports: true,
        hasAddItem: isProjectOrJiraAdmin,
        hasComponents: hasComponents,
        hasIssues: true,
        hasSummary: true,
        hasPages: true,
        hasChangeTheme: isProjectOrJiraAdmin,
        hasApprovals: isSimplifiedProject && (isPremium || isProjectOrJiraAdmin)
    };
};
const $755f4ca371b0583d$export$b77a5597b7177cfb = (data, hasActiveSoftwareAccess)=>{
    const { isAdmin: isAdmin, projectPermissionsQueried: projectPermissionsQueried } = data.permissionInfo;
    const isProjectAdmin = projectPermissionsQueried.ADMINISTER_PROJECTS === true;
    const isProjectOrJiraAdmin = isProjectAdmin || isAdmin;
    const hasDetails = isProjectOrJiraAdmin;
    const hasPeople = isProjectOrJiraAdmin;
    const hasSummary = true;
    const hasIssueTypes = isAdmin;
    const hasWorkflows = true;
    const hasScreens = true;
    const hasFields = true;
    const hasVersions = true;
    const hasComponents = true;
    const hasPermissions = true;
    const hasIssueSecurity = true;
    const hasNotifications = true;
    const hasIssueCollectors = true;
    const hasDevtools = isProjectAdmin && hasActiveSoftwareAccess;
    return {
        hasProjectGroupOneSection: hasDetails || hasPeople || hasSummary,
        hasIssueConfigSection: hasIssueTypes,
        hasProjectGroupTwoSection: hasWorkflows || hasScreens || hasFields,
        hasProjectGroupThreeSection: hasVersions || hasComponents,
        hasProjectGroupFourSection: hasPermissions || hasIssueSecurity || hasNotifications,
        hasgetIssueCollectorSection: hasIssueCollectors,
        hasComponents: hasComponents,
        hasDetails: hasDetails,
        hasFields: hasFields,
        hasIssueCollectors: hasIssueCollectors,
        hasIssueSecurity: hasIssueSecurity,
        hasIssueTypes: hasIssueTypes,
        hasNotifications: hasNotifications,
        hasPeople: hasPeople,
        hasPermissions: hasPermissions,
        hasScreens: hasScreens,
        hasSummary: hasSummary,
        hasVersions: hasVersions,
        hasWorkflows: hasWorkflows,
        hasDevtools: hasDevtools
    };
};
const $755f4ca371b0583d$export$be58a1e7b06d1d3 = (hasSoftwareAccess)=>({
        hasDeveloperWorkload: true,
        hasForcastSection: true,
        hasTimeTracking: true,
        hasVersionWorkloadReport: hasSoftwareAccess
    });

});


parcelRegister("k5Z6m", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f6745ef0d4252c6$export$2e2bcd8739ae039);

var $cPEpP = parcelRequire("cPEpP");

var $kIUmN = parcelRequire("kIUmN");
const $3f6745ef0d4252c6$var$useProject = (0, $kIUmN.withThrowOnError)((0, $cPEpP.useProject));
var $3f6745ef0d4252c6$export$2e2bcd8739ae039 = $3f6745ef0d4252c6$var$useProject;

});

parcelRegister("asnZU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d95c59af01c6e5a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kpmC0 = parcelRequire("kpmC0");
const $7d95c59af01c6e5a$var$useAutoExpandSidebar = ()=>{
    const { expandLeftSidebar: expandLeftSidebar } = (0, $kpmC0.useLeftSidebarController)();
    const { isCollapsed: isCollapsed } = (0, $kpmC0.useLeftSidebarState)();
    const sidebarExpandedRef = (0, $eUqFw.useRef)(!isCollapsed);
    (0, $eUqFw.useEffect)(()=>{
        if (!sidebarExpandedRef.current && isCollapsed) {
            expandLeftSidebar();
            sidebarExpandedRef.current = true;
        }
    }, [
        expandLeftSidebar,
        isCollapsed
    ]);
};
var $7d95c59af01c6e5a$export$2e2bcd8739ae039 = $7d95c59af01c6e5a$var$useAutoExpandSidebar;

});


parcelRegister("4ZQun", function(module, exports) {

$parcel$export(module.exports, "default", () => $812aa24afbef38fd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8N3rk = parcelRequire("8N3rk");
var $7eyVf = parcelRequire("7eyVf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $aWYQ8 = parcelRequire("aWYQ8");
var $2jFgb = parcelRequire("2jFgb");

var $asnZU = parcelRequire("asnZU");

var $6D5Hl = parcelRequire("6D5Hl");
const $812aa24afbef38fd$var$ConnectAppMenu = ({ stack: stack, project: project, onStackChange: onStackChange })=>{
    (0, $asnZU.default)();
    const { data: connectItems, stack: connectStack, selected: selectedConnectApp } = (0, $2jFgb.useProjectConnectItems)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const projectKey = String(project?.key);
    const getBackMenuItem = (0, $eUqFw.useCallback)(()=>({
            href: `/jira/core/projects/${projectKey}`,
            title: formatMessage((0, $6D5Hl.messages).itemBack)
        }), [
        formatMessage,
        projectKey
    ]);
    if (connectStack != null && connectStack.length > 0 && selectedConnectApp != null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8N3rk.default), {
        stack: stack,
        onChange: onStackChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aWYQ8.ConnectMenu), {
        items: connectItems,
        showIcons: true,
        overrides: {
            BackMenuItem: getBackMenuItem(),
            navigateOnBackMenuItemClick: true
        }
    })));
    return null;
};
var $812aa24afbef38fd$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($812aa24afbef38fd$var$ConnectAppMenu);

});
parcelRegister("6D5Hl", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ef8bb497ae7cfecf$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $ef8bb497ae7cfecf$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    itemBack: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.connect-app-menu.item-back",
        "defaultMessage": "Back to project"
    }
});

});


parcelRegister("44AZS", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ffa02dd9401c05b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $exb0h = parcelRequire("exb0h");

var $l90Gp = parcelRequire("l90Gp");

var $hinm7 = parcelRequire("hinm7");
var $zMQ0U = parcelRequire("zMQ0U");

var $dCFoo = parcelRequire("dCFoo");

var $10fdS = parcelRequire("10fdS");

var $3HCkE = parcelRequire("3HCkE");

var $asnZU = parcelRequire("asnZU");
const $5ffa02dd9401c05b$var$ForgeMenu = ()=>{
    (0, $asnZU.default)();
    const route = (0, $10fdS.useCurrentRoute)();
    const { data: forgeResourceData } = (0, $3HCkE.useResource)((0, $l90Gp.forgeProjectModuleResource));
    const projectData = (0, $eUqFw.useMemo)(()=>forgeResourceData?.extensions || null, [
        forgeResourceData
    ]);
    const selectedForgeApp = (0, $dCFoo.useForgeSelectedApp)(projectData, route.name);
    const { stack: forgeStack } = (0, $zMQ0U.useProjectForgeApps)((0, $exb0h.ROUTE_NAMES).FORGE_PROJECT);
    if (selectedForgeApp != null && forgeStack != null && forgeStack.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hinm7.ForgeProjectSection), {
        overrides: {
            showSelectedAppMenuOnly: true,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            selectedApp: selectedForgeApp
        }
    });
    return null;
};
var $5ffa02dd9401c05b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($5ffa02dd9401c05b$var$ForgeMenu);

});
parcelRegister("hinm7", function(module, exports) {

$parcel$export(module.exports, "ForgeProjectSection", () => $db59aca7aa23a0f8$export$fb7da191295a7e22);

var $eUqFw = parcelRequire("eUqFw");

var $7eyVf = parcelRequire("7eyVf");

var $7ZZxN = parcelRequire("7ZZxN");

var $1boRu = parcelRequire("1boRu");

var $5s6kd = parcelRequire("5s6kd");

var $2Rqjr = parcelRequire("2Rqjr");

var $70ON1 = parcelRequire("70ON1");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bNe1g = parcelRequire("bNe1g");

var $l3JmK = parcelRequire("l3JmK");

var $jMYeN = parcelRequire("jMYeN");

var $zMQ0U = parcelRequire("zMQ0U");

var $4Kgsn = parcelRequire("4Kgsn");
// @ts-expect-error - It's genuinely missing Jira Product Discovery.
const $db59aca7aa23a0f8$var$projectTypeRouteMap = {
    [(0, $7ZZxN.CORE_PROJECT)]: 'core',
    [(0, $7ZZxN.SOFTWARE_PROJECT)]: 'software',
    [(0, $7ZZxN.SERVICE_DESK_PROJECT)]: 'servicedesk'
};
const $db59aca7aa23a0f8$export$ed6342e0e28465a6 = (extension, projectType, projectKey)=>{
    const { appId: appId, envId: envId } = (0, $70ON1.parseExtensionId)(extension.id);
    return `/jira/${$db59aca7aa23a0f8$var$projectTypeRouteMap[projectType]}/projects/${projectKey}/apps/${appId}/${envId}`;
};
const $db59aca7aa23a0f8$export$fb7da191295a7e22 = ({ nestedMenuActive: nestedMenuActive, overrides: overrides })=>{
    const { data: data } = (0, $zMQ0U.useProjectForgeApps)();
    const { data: projectContextData } = (0, $bNe1g.useProjectContext)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (!data?.length || !projectContextData) return null;
    const { projectKey: projectKey, projectType: projectType } = projectContextData;
    const filteredForgeAppsData = overrides?.showSelectedAppMenuOnly && overrides?.selectedApp != null ? [
        overrides.selectedApp
    ] : data;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5s6kd.TriggerAnalyticsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        title: overrides?.showSelectedAppMenuOnly ? undefined : formatMessage((0, $4Kgsn.messages).forgeSectionTitle)
    }, filteredForgeAppsData.map((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l3JmK.ForgeItem), {
            key: extension.id,
            id: extension.id,
            environmentType: extension.environmentType,
            environmentKey: extension.environmentKey,
            url: $db59aca7aa23a0f8$export$ed6342e0e28465a6(extension, projectType, projectKey),
            name: extension.properties.title,
            sections: (0, $jMYeN.toSections)(extension),
            moduleName: (0, $2Rqjr.PROJECT_PAGE_MODULE),
            iconUrl: extension.properties.icon,
            showIcon: true,
            nestedMenuActive: nestedMenuActive,
            overrides: overrides
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $2Rqjr.PROJECT_PAGE_MODULE)
        }
    })));
};

});
parcelRegister("1boRu", function(module, exports) {

$parcel$export(module.exports, "ForgeScreenEvent", () => $e499aee6653ef75f$export$92d758d83665314b);
$parcel$export(module.exports, "ForgeOperationaFailedEvent", () => $e499aee6653ef75f$export$a238c3c13f29c134);
$parcel$export(module.exports, "ForgeErrorBoundary", () => $e499aee6653ef75f$export$ac7e7464cefab440);
$parcel$export(module.exports, "ForgeAnalyticsWrapper", () => $e499aee6653ef75f$export$ad2a5d9127152fb8);
$parcel$export(module.exports, "withMetrics", () => $e499aee6653ef75f$export$14e56d7f5d3f917c);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $1ybV0 = parcelRequire("1ybV0");

var $2Rqjr = parcelRequire("2Rqjr");

var $2vJHJ = parcelRequire("2vJHJ");

var $9x02J = parcelRequire("9x02J");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $d6f6c = parcelRequire("d6f6c");
var $2qZHF = parcelRequire("2qZHF");

var $hRcYT = parcelRequire("hRcYT");

var $8XU7c = parcelRequire("8XU7c");

var $bBGpO = parcelRequire("bBGpO");

var $9Z5wa = parcelRequire("9Z5wa");

var $5syGA = parcelRequire("5syGA");

var $d6g7g = parcelRequire("d6g7g");
const $e499aee6653ef75f$export$92d758d83665314b = ({ attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        attributes: (0, $bBGpO.createAttributes)(attributes)
    });
const $e499aee6653ef75f$export$a238c3c13f29c134 = ({ eventId: eventId, attributes: attributes })=>{
    (0, $9Z5wa.fireOperationalFailedEvent)({
        eventId: eventId,
        attributes: attributes
    });
    return null;
};
const $e499aee6653ef75f$export$4c46624a93517c10 = ({ eventId: eventId, action: action, attributes: attributes })=>{
    const hasForgeAccess = (0, $9x02J.useHasForgeAccess)();
    const analyticsAttributes = (0, $bBGpO.createAttributes)({
        ...attributes,
        hasForgeAccess: hasForgeAccess
    });
    const fireEvent = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, (0, $8XU7c.getEventActionName)(eventId, action), analyticsAttributes);
    }, [
        eventId,
        action,
        analyticsAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
        onMount: fireEvent
    });
};
const $e499aee6653ef75f$export$f461e628d5e73fa0 = ({ children: children, eventId: eventId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: `${(0, $hRcYT.PACKAGE_NAME_GASV3)}.${eventId}`
    }, children);
const $e499aee6653ef75f$export$ac7e7464cefab440 = ({ children: children, eventId: eventId, attributes: attributes, onError: onError, errorFallback: errorFallback, resetCaughtError: resetCaughtError })=>{
    const fallback = (0, $eUqFw.useMemo)(()=>errorFallback || 'unmount', [
        errorFallback
    ]);
    const getAttributes = (0, $eUqFw.useCallback)((error)=>(0, $bBGpO.createAttributes)({
            ...attributes,
            error: error
        }), [
        attributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: eventId,
        packageName: (0, $hRcYT.PACKAGE_NAME_GASV3),
        teamName: "smite",
        fallback: fallback,
        attributes: getAttributes,
        onError: onError,
        resetCaughtError: resetCaughtError
    }, children);
};
const $e499aee6653ef75f$export$ad2a5d9127152fb8 = ({ children: children, module: module, entryPoint: entryPoint, attributes: attributes, moduleType: moduleType = (0, $hRcYT.MODULE_TYPE_EXTENSION), errorFallback: errorFallback = 'unmount', shouldFireInitializedEvent: shouldFireInitializedEvent = false, resetCaughtError: resetCaughtError })=>{
    const eventId = (0, $8XU7c.getEventId)({
        module: module,
        moduleType: moduleType,
        entryPoint: entryPoint
    });
    const analyticsAttributes = (0, $eUqFw.useMemo)(()=>(0, $bBGpO.createAttributes)(attributes), [
        attributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e499aee6653ef75f$export$f461e628d5e73fa0, {
        eventId: eventId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e499aee6653ef75f$export$ac7e7464cefab440, {
        eventId: eventId,
        attributes: analyticsAttributes,
        errorFallback: errorFallback,
        resetCaughtError: resetCaughtError
    }, shouldFireInitializedEvent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e499aee6653ef75f$export$4c46624a93517c10, {
        eventId: eventId,
        action: "initialized",
        attributes: analyticsAttributes
    }), children));
};
function $e499aee6653ef75f$var$isExtensionTimeMeasuredFromTriggerClick(extensionModule, entryPoint, attributes) {
    if ((extensionModule === (0, $2Rqjr.CUSTOM_FIELD_MODULE) || extensionModule === (0, $2Rqjr.CUSTOM_FIELD_TYPE_MODULE)) && (entryPoint !== 'edit' || attributes.renderContext === 'issue-create')) return false;
    if (extensionModule === (0, $2Rqjr.ISSUE_PANEL_MODULE) && !attributes?.isNewToIssue) return false;
    return /* eslint-disable @typescript-eslint/consistent-type-assertions */ [
        (0, $2Rqjr.GLOBAL_PAGE_MODULE),
        (0, $2Rqjr.ISSUE_ACTION_MODULE),
        (0, $2Rqjr.ISSUE_ACTIVITY_MODULE),
        (0, $2Rqjr.ISSUE_GLANCE_MODULE),
        (0, $2Rqjr.ISSUE_CONTEXT_MODULE),
        (0, $2Rqjr.ISSUE_PANEL_MODULE),
        (0, $2Rqjr.CUSTOM_FIELD_MODULE),
        (0, $2Rqjr.CUSTOM_FIELD_TYPE_MODULE),
        (0, $2Rqjr.PROJECT_PAGE_MODULE),
        (0, $2Rqjr.ADMIN_PAGE_MODULE),
        (0, $2Rqjr.PROJECT_SETTINGS_PAGE_MODULE)
    ].includes(extensionModule);
}
const $e499aee6653ef75f$export$14e56d7f5d3f917c = (Component)=>(props)=>{
        const startTime = (0, $eUqFw.useRef)(performance.now());
        const isCustomUI = (0, $2vJHJ.isCustomUIExtension)(props.extension, props.entryPoint);
        const [isExtensionRendered, setExtensionRendered] = (0, $eUqFw.useState)(false);
        const { module: module, entryPoint: entryPoint, analyticsAttributes: analyticsAttributes, localId: localId = '', onInitialRender: onInitialRender, onLoad: onLoad, extension: extension } = props;
        const extensionId = props.extension?.id;
        const eventId = (0, $8XU7c.getEventId)({
            module: module,
            entryPoint: entryPoint
        });
        const browserMetricsEventId = (0, $8XU7c.getBrowserMetricsEventId)({
            module: module,
            entryPoint: entryPoint,
            forgeUiType: (0, $2vJHJ.getForgeUIType)(extension, entryPoint)
        });
        const attributes = (0, $eUqFw.useMemo)(()=>({
                ...analyticsAttributes,
                ...(0, $5syGA.getAnalyticsAttributesFromExtension)(extension, entryPoint)
            }), // because extension is an object but we only want extension.id to trigger re-render
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            analyticsAttributes,
            entryPoint,
            extension.id,
            isCustomUI
        ]);
        if ((0, $1ybV0.ff)('fix-forge-extension-metrics_nkeqx')) (0, $eUqFw.useEffect)(()=>{
            if (!$e499aee6653ef75f$var$isExtensionTimeMeasuredFromTriggerClick(extension.type, entryPoint ?? 'view', attributes) && extensionId) (0, $d6g7g.forgeModulesConcurrentLoadTime)(extensionId).start({
                startTime: startTime.current
            });
        }, // We want to run this code only once on mount
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []);
        else !$e499aee6653ef75f$var$isExtensionTimeMeasuredFromTriggerClick(extension.type, entryPoint ?? 'view', attributes) && extensionId && (0, $d6g7g.forgeModulesLoadTime).start({
            startTime: performance.now()
        });
        const onError = (0, $eUqFw.useCallback)(()=>{
            if ((0, $1ybV0.ff)('fix-forge-extension-metrics_nkeqx')) extensionId && (0, $d6g7g.forgeModulesConcurrentLoadTime)(extensionId).cancel();
            else extensionId && (0, $d6g7g.forgeModulesLoadTime).cancel();
        }, [
            extensionId
        ]);
        const onInitialRenderUiKitWithMetrics = (0, $eUqFw.useCallback)((payload)=>{
            onInitialRender && onInitialRender(payload);
            if (payload?.error == null) {
                const stopTimeDeduction = payload?.appTime || 0;
                setExtensionRendered(true);
                if ((0, $1ybV0.ff)('fix-forge-extension-metrics_nkeqx')) extensionId && (0, $d6g7g.forgeModulesConcurrentLoadTime)(extensionId).stop({
                    stopTime: performance.now() - stopTimeDeduction,
                    customData: {
                        eventId: browserMetricsEventId
                    }
                });
                else extensionId && (0, $d6g7g.forgeModulesLoadTime).stop({
                    stopTime: performance.now() - stopTimeDeduction,
                    customData: {
                        eventId: browserMetricsEventId
                    }
                });
            } else {
                onError();
                (0, $9Z5wa.fireOperationalFailedEvent)({
                    eventId: eventId,
                    attributes: {
                        error: new Error(payload.error),
                        ...attributes
                    }
                });
            }
        }, [
            onInitialRender,
            extensionId,
            browserMetricsEventId,
            onError,
            eventId,
            attributes
        ]);
        const onLoadCustomUiWithMetrics = (0, $eUqFw.useCallback)(()=>{
            onLoad && onLoad();
            setExtensionRendered(true);
            if ((0, $1ybV0.ff)('fix-forge-extension-metrics_nkeqx')) extensionId && (0, $d6g7g.forgeModulesConcurrentLoadTime)(extensionId).stop({
                stopTime: performance.now(),
                customData: {
                    eventId: browserMetricsEventId
                }
            });
            else extensionId && (0, $d6g7g.forgeModulesLoadTime).stop({
                stopTime: performance.now(),
                customData: {
                    eventId: browserMetricsEventId
                }
            });
        // SMT-1418
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            analyticsAttributes,
            extensionId,
            localId,
            onLoad
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e499aee6653ef75f$export$f461e628d5e73fa0, {
            eventId: eventId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
            ...props,
            ...isCustomUI ? {
                onLoad: onLoadCustomUiWithMetrics
            } : {
                onInitialRender: onInitialRenderUiKitWithMetrics
            }
        }), isExtensionRendered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e499aee6653ef75f$export$92d758d83665314b, {
            attributes: attributes
        }));
    };

});
parcelRegister("2vJHJ", function(module, exports) {

$parcel$export(module.exports, "getForgeUIType", () => $0071fffa92d48f40$export$aed4d8a86badbf61);
$parcel$export(module.exports, "isCustomUIExtension", () => $0071fffa92d48f40$export$edb00cfe4962b026);
$parcel$export(module.exports, "isNativeUiExtension", () => $0071fffa92d48f40$export$2ecba06e617fea0a);
$parcel$export(module.exports, "overrideExtension", () => $0071fffa92d48f40$export$42b85bc9b386c977);

var $8blac = parcelRequire("8blac");

var $1ybV0 = parcelRequire("1ybV0");
const $0071fffa92d48f40$export$aed4d8a86badbf61 = (extension, entryPoint = '')=>{
    const { render: render, resource: resource } = extension.properties;
    if (!(0, $1ybV0.ff)('fix-forge-ui-type-detection_nmgpj')) {
        if (render != null && render !== 'native') return 'ui-kit';
    }
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'CommonProps | (CommonProps & { label: string; dynamicProperties?: { function: string; } | undefined; icon?: string | undefined; status?: IssueGlanceStatus | undefined; }) | ... 9 more ... | { ...; }'.
    if (entryPoint && extension.properties[entryPoint]) {
        const { resource: entryPointResource, render: entryPointRender } = // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'CommonProps | (CommonProps & { label: string; dynamicProperties?: { function: string; } | undefined; icon?: string | undefined; status?: IssueGlanceStatus | undefined; }) | ... 9 more ... | { ...; }'.
        extension.properties[entryPoint];
        if (entryPointResource == null) return 'ui-kit';
        if (entryPointRender === 'native') return 'native-ui';
        return 'custom-ui';
    }
    if (resource == null) return 'ui-kit';
    if (render === 'native') return 'native-ui';
    return 'custom-ui';
};
const $0071fffa92d48f40$export$edb00cfe4962b026 = (extension, entryPoint = '')=>$0071fffa92d48f40$export$aed4d8a86badbf61(extension, entryPoint) === 'custom-ui';
const $0071fffa92d48f40$export$2ecba06e617fea0a = (extension, entryPoint = '')=>$0071fffa92d48f40$export$aed4d8a86badbf61(extension, entryPoint) === 'native-ui';
const $0071fffa92d48f40$export$42b85bc9b386c977 = (extension, propsToOverride)=>{
    if (extension == null) return extension;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(propsToOverride)) return extension;
    const { resource: resource, requiresUserConsent: requiresUserConsent } = propsToOverride;
    // We must also spread `extension.properties` because JS doesn't deep-copy objects.
    // Only spreading `extension` will result in `resource` on the original `extension`
    // object being modified.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const extensionCopy = {
        ...extension,
        properties: {
            ...extension.properties
        },
        requiresUserConsent: requiresUserConsent
    }; // eslint-disable-line @typescript-eslint/no-explicit-any
    if (resource != null) extensionCopy.properties.resource = resource;
    return extensionCopy;
};

});

parcelRegister("9x02J", function(module, exports) {

$parcel$export(module.exports, "useHasForgeAccess", () => $c88d1eb745d9d2ce$export$fd7f94d3d2bac7f2);

var $6yplV = parcelRequire("6yplV");
const $c88d1eb745d9d2ce$export$fd7f94d3d2bac7f2 = ()=>{
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    return !isAnonymous;
};

});

parcelRegister("2qZHF", function(module, exports) {

$parcel$export(module.exports, "MountEvent", () => $017cfdc2fc017c3b$export$2c6963927dbc68f1);
/**
 * This library is the only place where you'd use raw analytics from atlaskit
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $2jDha = parcelRequire("2jDha");
// eslint-disable-next-line jira/react/no-class-components
class $017cfdc2fc017c3b$var$MountEventComponent extends (0, $eUqFw.Component) {
    componentDidMount() {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'mounted'
        });
        if (this.props.onMount) this.props.onMount(analyticsEvent);
    }
    render() {
        return null;
    }
}
const $017cfdc2fc017c3b$export$2c6963927dbc68f1 = (0, $2jDha.default)()($017cfdc2fc017c3b$var$MountEventComponent);

});

parcelRegister("8XU7c", function(module, exports) {

$parcel$export(module.exports, "getEventId", () => $ea56d020133ed4ec$export$5639f6a927500d9);
$parcel$export(module.exports, "getBrowserMetricsEventId", () => $ea56d020133ed4ec$export$25830fc7d037f0f2);
$parcel$export(module.exports, "getEventActionName", () => $ea56d020133ed4ec$export$644ccb9a67b9a9c1);

var $2Rqjr = parcelRequire("2Rqjr");

var $TrUS5 = parcelRequire("TrUS5");

var $hRcYT = parcelRequire("hRcYT");


var $eTZsp = parcelRequire("eTZsp");

var $d6g7g = parcelRequire("d6g7g");
const $ea56d020133ed4ec$var$capitalizeFirstLetter = (str)=>str != null && str.charAt(0).toUpperCase() + str.slice(1) || '';
const $ea56d020133ed4ec$var$prepareModuleMode = (entryPoint)=>`${$ea56d020133ed4ec$var$capitalizeFirstLetter(entryPoint)}`;
const $ea56d020133ed4ec$export$3e50bc81d8ed2e3f = (moduleName)=>moduleName.replace(/^jira:/, '');
const $ea56d020133ed4ec$var$prepareModuleName = (moduleName)=>(0, $2Rqjr.SUPPORTED_MODULES).includes(moduleName) ? $ea56d020133ed4ec$export$3e50bc81d8ed2e3f(moduleName) : 'unknown';
const $ea56d020133ed4ec$export$5639f6a927500d9 = ({ module: module, moduleType: moduleType = (0, $hRcYT.MODULE_TYPE_EXTENSION), entryPoint: entryPoint })=>{
    const eventNamePostfix = moduleType === 'trigger' ? 'Trigger' : '';
    return (0, $TrUS5.toEventId)(`${$ea56d020133ed4ec$var$prepareModuleName(module)}${$ea56d020133ed4ec$var$prepareModuleMode(entryPoint)}${eventNamePostfix}`);
};
const $ea56d020133ed4ec$export$25830fc7d037f0f2 = ({ module: module, entryPoint: entryPoint, forgeUiType: forgeUiType })=>(0, $TrUS5.toEventId)(`${$ea56d020133ed4ec$var$prepareModuleName(module)}${$ea56d020133ed4ec$var$prepareModuleMode(entryPoint)}-${forgeUiType}`);
const $ea56d020133ed4ec$export$644ccb9a67b9a9c1 = (eventId, action)=>`${0, $hRcYT.PACKAGE_NAME_GASV3}.${eventId} ${action}`;

});

parcelRegister("9Z5wa", function(module, exports) {

$parcel$export(module.exports, "fireOperationalFailedEvent", () => $2660eb080e6928fb$export$add44f896fb31ba3);

var $hRcYT = parcelRequire("hRcYT");

var $cYWDh = parcelRequire("cYWDh");
const $2660eb080e6928fb$export$add44f896fb31ba3 = ({ eventId: eventId, attributes: attributes })=>{
    (0, $cYWDh.fireOperationalEvent)((0, $hRcYT.OPERATIONAL_ACTIONS).FAILED, {
        id: eventId,
        attributes: attributes
    });
};

});

parcelRegister("5syGA", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsAttributesFromExtension", () => $05fce0f798595dcf$export$5d3b06ab08af139e);

var $2vJHJ = parcelRequire("2vJHJ");

var $70ON1 = parcelRequire("70ON1");
const $05fce0f798595dcf$export$5d3b06ab08af139e = (extension, entryPoint)=>{
    const { appId: appId, envId: envId } = (0, $70ON1.parseExtensionId)(extension.id);
    return {
        appId: appId,
        envId: envId,
        forgeType: (0, $2vJHJ.getForgeUIType)(extension, entryPoint),
        envType: extension?.environmentType
    };
};

});


parcelRegister("5s6kd", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $c4eafcc07a5a74f2$export$c794eb4124961145);
$parcel$export(module.exports, "TriggerAnalyticsWrapper", () => $c4eafcc07a5a74f2$export$e1a79e3d472c925a);

var $eUqFw = parcelRequire("eUqFw");

var $2Rqjr = parcelRequire("2Rqjr");

var $1boRu = parcelRequire("1boRu");

var $hRcYT = parcelRequire("hRcYT");
const $c4eafcc07a5a74f2$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.PROJECT_PAGE_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
const $c4eafcc07a5a74f2$export$e1a79e3d472c925a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.PROJECT_PAGE_MODULE),
        moduleType: (0, $hRcYT.MODULE_TYPE_TRIGGER),
        ...props
    });

});

parcelRegister("l3JmK", function(module, exports) {

$parcel$export(module.exports, "ForgeSubpagesView", () => $62555c33c4fca39e$export$9711365f685f75c0);
$parcel$export(module.exports, "ForgeItem", () => $62555c33c4fca39e$export$26a5287439a1d287);

var $eUqFw = parcelRequire("eUqFw");

var $iFXD5 = parcelRequire("iFXD5");

var $7eyVf = parcelRequire("7eyVf");

var $c9TLT = parcelRequire("c9TLT");

var $1ybV0 = parcelRequire("1ybV0");

var $d6g7g = parcelRequire("d6g7g");

var $7eMp1 = parcelRequire("7eMp1");

var $4aKCU = parcelRequire("4aKCU");
var $bS2FN = parcelRequire("bS2FN");
var $1UelU = parcelRequire("1UelU");
var $2DHQu = parcelRequire("2DHQu");
var $5KxOv = parcelRequire("5KxOv");

var $jn9Rf = parcelRequire("jn9Rf");
const $62555c33c4fca39e$export$9ffb311b483a1e2b = (extensionBaseUrl, route)=>route ? `${extensionBaseUrl}/${String(route).trim().replace(/^\/+/, '')}` : extensionBaseUrl;
const $62555c33c4fca39e$export$f04a61298a47a40f = ({ url: url })=>url != null && String(url).trim().length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jn9Rf.ForgeIcon), {
        src: url
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iFXD5))), {
        label: ""
    });
const $62555c33c4fca39e$export$df3259e43d89ee7b = (props)=>{
    const { showIcon: showIcon, id: itemId, iconUrl: iconUrl, environmentType: environmentType, environmentKey: environmentKey, url: url, name: name, moduleName: moduleName, overrides: overrides } = props;
    if (overrides?.showSelectedAppMenuOnly) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        iconBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($62555c33c4fca39e$export$f04a61298a47a40f, {
            url: iconUrl
        }) : null,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eMp1.EnvironmentLozenge), {
            environmentType: environmentType
        }),
        href: url,
        selectedOn: (0, $bS2FN.matchPartialUrlPathname)(),
        analytics: {
            itemId: itemId,
            itemType: 'forge',
            module: moduleName
        },
        onClick: ()=>{
            (0, $1ybV0.ff)('fix-forge-extension-metrics_nkeqx') ? (0, $d6g7g.forgeModulesConcurrentLoadTime)(itemId).start({
                startTime: performance.now()
            }) : (0, $d6g7g.forgeModulesLoadTime).start({
                startTime: performance.now()
            });
        }
    }, (0, $7eMp1.nameWithCustomEnvironment)(name, environmentType, environmentKey));
};
const $62555c33c4fca39e$var$nestedHeaderAlignmentFix = ()=>({
        paddingLeft: `${(0, $c9TLT.gridSize) * 2.625}px`
    });
const $62555c33c4fca39e$export$961eebe0deda9ad3 = ({ ForgePageHeader: ForgePageHeader = (0, $4aKCU.ForgePageHeader), iconUrl: iconUrl, name: name, environmentType: environmentType, environmentKey: environmentKey, nestedMenuActive: nestedMenuActive })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ForgePageHeader, {
        avatarUrl: iconUrl || '',
        name: name,
        environmentType: environmentType,
        environmentKey: environmentKey,
        cssFn: // this to avoid sketchy-null-bool linting issue
        typeof nestedMenuActive === 'boolean' && Boolean(nestedMenuActive) ? $62555c33c4fca39e$var$nestedHeaderAlignmentFix : undefined
    });
const $62555c33c4fca39e$export$9711365f685f75c0 = (props)=>{
    const { showIcon: showIcon, id: itemId, url: url, sections: sections, moduleName: moduleName } = props;
    const selectedOn = (0, $eUqFw.useCallback)((route)=>[
            '',
            '/'
        ].includes(String(route || '').trim()) ? (currentLocation, itemLocation)=>currentLocation.pathname.replace(/\/$/, '') === itemLocation.pathname.replace(/\/$/, '') : (0, $bS2FN.matchPartialUrlPathname)(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jn9Rf.ForgeSubpagesContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($62555c33c4fca39e$export$961eebe0deda9ad3, props), sections?.map((section, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
            key: index
        }, typeof section.header === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5KxOv.SectionHeader), null, section.header) : null, section.pages.map((page)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
                key: page.route,
                iconBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($62555c33c4fca39e$export$f04a61298a47a40f, {
                    url: page.icon
                }) : null,
                href: $62555c33c4fca39e$export$9ffb311b483a1e2b(url, page.route),
                selectedOn: selectedOn(page.route),
                analytics: {
                    itemId: itemId,
                    itemType: 'forge',
                    module: moduleName
                },
                onClick: ()=>{
                    (0, $1ybV0.ff)('fix-forge-extension-metrics_nkeqx') ? (0, $d6g7g.forgeModulesConcurrentLoadTime)(itemId).start({
                        startTime: performance.now()
                    }) : (0, $d6g7g.forgeModulesLoadTime).start({
                        startTime: performance.now()
                    });
                }
            }, page.title)))));
};
const $62555c33c4fca39e$export$26a5287439a1d287 = (props)=>{
    const { showIcon: showIcon, id: itemId, url: url, iconUrl: iconUrl, environmentType: environmentType, environmentKey: environmentKey, name: name, sections: sections, overrides: overrides } = props;
    const selectedOn = (0, $eUqFw.useCallback)((currentLocation)=>currentLocation.pathname.includes(url), [
        url
    ]);
    const onNestedMenuItemClick = (0, $eUqFw.useCallback)((event)=>{
        if (overrides?.ParentMenuItem?.onClick) overrides.ParentMenuItem.onClick(event);
        return ()=>null;
    }, [
        overrides
    ]);
    if (!sections?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($62555c33c4fca39e$export$df3259e43d89ee7b, props);
    if (overrides?.showSelectedAppMenuOnly) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($62555c33c4fca39e$export$9711365f685f75c0, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2DHQu.NestingMenuItem), {
        analytics: {
            itemId: 'subpages'
        },
        id: `${itemId}-subpages`,
        iconBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($62555c33c4fca39e$export$f04a61298a47a40f, {
            url: iconUrl
        }) : null,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eMp1.EnvironmentLozenge), {
            environmentType: environmentType
        }),
        title: (0, $7eMp1.nameWithCustomEnvironment)(name, environmentType, environmentKey),
        selectedOn: selectedOn,
        onClick: onNestedMenuItemClick,
        // @ts-expect-error - overrides types mismatch
        overrides: overrides
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($62555c33c4fca39e$export$9711365f685f75c0, props));
};

});
parcelRegister("7eMp1", function(module, exports) {

$parcel$export(module.exports, "EnvironmentLozenge", () => $cd44a5efa9c7c2f2$export$278f8e01799d0418);
$parcel$export(module.exports, "nameWithCustomEnvironment", () => $cd44a5efa9c7c2f2$export$f9338c21ba7c7334);

var $eUqFw = parcelRequire("eUqFw");

var $ffiyv = parcelRequire("ffiyv");

var $2Rqjr = parcelRequire("2Rqjr");

var $8uD7Y = parcelRequire("8uD7Y");

var $aghg0 = parcelRequire("aghg0");
const $cd44a5efa9c7c2f2$export$50589a87e4fb3dae = (environmentType)=>{
    switch(environmentType){
        case 0, $2Rqjr.DEVELOPMENT_ENVIRONMENT:
            return (0, $aghg0.messages).developmentEnvironmentLozenge;
        case 0, $2Rqjr.STAGING_ENVIRONMENT:
            return (0, $aghg0.messages).stagingEnvironmentLozenge;
        default:
            return null;
    }
};
const $cd44a5efa9c7c2f2$export$278f8e01799d0418 = (props)=>{
    const { environmentType: environmentType } = props;
    const labelKey = $cd44a5efa9c7c2f2$export$50589a87e4fb3dae(environmentType);
    return labelKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        testId: "forge-ui-extension-title.ui.environment-lozenge.lozenge",
        appearance: environmentType === (0, $2Rqjr.DEVELOPMENT_ENVIRONMENT) ? 'default' : 'moved'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), labelKey)) : null;
};
const $cd44a5efa9c7c2f2$export$f9338c21ba7c7334 = (name, environmentType, environmentKey)=>{
    if (environmentType === (0, $2Rqjr.DEVELOPMENT_ENVIRONMENT) && environmentKey && environmentKey !== (0, $2Rqjr.DEFAULT_ENVIRONMENT_KEY)) return `${name} - ${environmentKey}`;
    return name;
};

});
parcelRegister("aghg0", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ea116b14fefa1e63$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $ea116b14fefa1e63$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    developmentEnvironmentLozenge: {
        "id": "forge-ui-extension-title.environment-lozenge.development-environment-lozenge",
        "defaultMessage": "DEV"
    },
    stagingEnvironmentLozenge: {
        "id": "forge-ui-extension-title.environment-lozenge.staging-environment-lozenge",
        "defaultMessage": "STG"
    }
});

});


parcelRegister("4aKCU", function(module, exports) {

$parcel$export(module.exports, "ForgePageHeader", () => $ee80f8e9038197e4$export$a4f83f6df17decd4);

var $eUqFw = parcelRequire("eUqFw");

var $c8Guq = parcelRequire("c8Guq");

var $iJlfe = parcelRequire("iJlfe");

var $iFXD5 = parcelRequire("iFXD5");

var $8SnT0 = parcelRequire("8SnT0");

var $7eMp1 = parcelRequire("7eMp1");

var $8n4Bi = parcelRequire("8n4Bi");

var $hukpV = parcelRequire("hukpV");

var $5jn4M = parcelRequire("5jn4M");
const $ee80f8e9038197e4$export$a4f83f6df17decd4 = ({ Avatar: Avatar = (0, $iJlfe.default), AddonIcon: AddonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($iFXD5))), CssFixContainer: CssFixContainer = (0, $5jn4M.CssFixContainerDI), Header: Header = (0, $8SnT0.default), cssFn: cssFn, EnvironmentLozenge: EnvironmentLozenge = (0, $7eMp1.EnvironmentLozenge), avatarUrl: avatarUrl, environmentType: environmentType, environmentKey: environmentKey, name: name })=>{
    const theme = (0, $8n4Bi.useSidebarTheme)();
    const headerCssFn = (0, $eUqFw.useMemo)(()=>cssFn ? (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))([
            cssFn,
            (0, $hukpV.generateCustomThemeCssFn)(theme)
        ]) : (0, $hukpV.generateCustomThemeCssFn)(theme), [
        cssFn,
        theme
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CssFixContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Header, {
        cssFn: headerCssFn,
        iconBefore: avatarUrl?.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Avatar, {
            appearance: "square",
            borderColor: "transparent",
            size: "small",
            src: `${avatarUrl}?size=xxlarge`
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AddonIcon, {
            label: "",
            size: "medium"
        }),
        // @ts-expect-error - TS2769 - No overload matches this call.
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(EnvironmentLozenge, {
            environmentType: environmentType
        })
    }, (0, $7eMp1.nameWithCustomEnvironment)(name, environmentType, environmentKey)));
};

});
parcelRegister("hukpV", function(module, exports) {

$parcel$export(module.exports, "generateCustomThemeCssFn", () => $a917a148f3dfadbc$export$5ae7d20da3003de);

var $2vzCR = parcelRequire("2vzCR");

var $5vmRt = parcelRequire("5vmRt");
const $a917a148f3dfadbc$export$5ae7d20da3003de = (theme)=>(0, $5vmRt.castRealCSSFnToWronglyTypedCSSFn)((currentStyles)=>{
        if (theme?.navigation) {
            const { navigation: { item: item } } = theme;
            const themeStyles = {
                backgroundColor: item?.background?.default ?? undefined,
                color: item?.color?.default ?? undefined,
                '[data-item-title]': {
                    color: item?.color?.default ?? undefined
                },
                '[data-item-description]': {
                    color: item?.color?.default ?? undefined
                }
            };
            return (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(currentStyles, themeStyles);
        }
        return currentStyles;
    });

});

parcelRegister("5jn4M", function(module, exports) {

$parcel$export(module.exports, "CssFixContainerDI", () => $cf127d0288738b67$export$eee12c3955319ddc);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $cf127d0288738b67$export$eee12c3955319ddc = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1lfu1kw7",
            __cmplp.className
        ])
    });
});

});


parcelRegister("5KxOv", function(module, exports) {

$parcel$export(module.exports, "SectionHeader", () => $f60267b6fe4a2c5d$export$8adb256d999cd5a0);
/** Wrapper around <HeadingItem> adding custom theming
 * @see @atlaskit/side-navigation
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $b4txA = parcelRequire("b4txA");

var $8n4Bi = parcelRequire("8n4Bi");

var $jkEVK = parcelRequire("jkEVK");
const $f60267b6fe4a2c5d$export$8adb256d999cd5a0 = ({ children: children })=>{
    const theme = (0, $8n4Bi.useSidebarTheme)();
    const cssFn = (0, $eUqFw.useMemo)(()=>(0, $jkEVK.generateCustomThemeCssFn)(theme), [
        theme
    ]);
    // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b4txA.default), {
        cssFn: cssFn
    }, children);
};

});
parcelRegister("b4txA", function(module, exports) {

$parcel$export(module.exports, "default", () => $587c53f185e0b1ef$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5wpwq = parcelRequire("5wpwq");

var $jvM56 = parcelRequire("jvM56");

var $cgrgx = parcelRequire("cgrgx");
/**
 * __Heading item__
 *
 * Available for advanced use cases, for most situations providing a `title` to `section` should be enough.
 *
 */ const $587c53f185e0b1ef$var$HeadingItem = (props)=>{
    const { shouldRender: shouldRender } = (0, $cgrgx.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    const cssFn = (0, $jvM56.overrideStyleFunction)((0, $jvM56.sectionHeaderSpacingStyles), props.cssFn);
    // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis, @repo/internal/react/no-unsafe-overrides, @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wpwq.default), {
        ...props,
        cssFn: cssFn
    });
};
var $587c53f185e0b1ef$export$2e2bcd8739ae039 = $587c53f185e0b1ef$var$HeadingItem;

});

parcelRegister("jkEVK", function(module, exports) {

$parcel$export(module.exports, "generateCustomThemeCssFn", () => $0875611379df01fd$export$5ae7d20da3003de);

var $2vzCR = parcelRequire("2vzCR");

var $5vmRt = parcelRequire("5vmRt");
const $0875611379df01fd$export$5ae7d20da3003de = (theme)=>(0, $5vmRt.castRealCSSFnToWronglyTypedCSSFn)((currentStyles)=>{
        if (theme?.navigation) {
            const { navigation: { item: item } } = theme;
            const themeStyles = {
                color: item?.color?.default,
                opacity: item?.opacity
            };
            return (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(currentStyles, themeStyles);
        }
        return currentStyles;
    });

});


parcelRegister("jn9Rf", function(module, exports) {

$parcel$export(module.exports, "ForgeIcon", () => $d734c17ba92feb96$export$fe0464db4dc93ab4);
$parcel$export(module.exports, "ForgeSubpagesContainer", () => $d734c17ba92feb96$export$682ee8eb4890e553);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $d734c17ba92feb96$export$fe0464db4dc93ab4 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbgktf _4t3igktf",
            __cmplp.className
        ])
    });
});
const $d734c17ba92feb96$export$682ee8eb4890e553 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_14tkpxbi _t3zcv47k _1so4jjyb",
            __cmplp.className
        ])
    });
});

});


parcelRegister("4Kgsn", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1af325f867f52a7e$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $1af325f867f52a7e$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    forgeSectionTitle: {
        "id": "navigation-apps-sidebar-forge.project-section.forge-section-title",
        "defaultMessage": "Apps"
    }
});

});


parcelRegister("dCFoo", function(module, exports) {

$parcel$export(module.exports, "useForgeSelectedApp", () => $4f01126c9b52390e$export$e6dee8b777476118);

var $kJlBc = parcelRequire("kJlBc");

var $eOutC = parcelRequire("eOutC");
const $4f01126c9b52390e$export$e6dee8b777476118 = (modules, routeName)=>{
    const [{ match: match, route: route }] = (0, $kJlBc.useRouter)();
    const matchedExtension = (0, $eOutC.useMatchedExtension)({
        modules: modules,
        match: match
    });
    if (route.name !== routeName || matchedExtension == null) return null;
    return matchedExtension;
};

});


parcelRegister("bp2TG", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b8601170973bccc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8N3rk = parcelRequire("8N3rk");
var $7eyVf = parcelRequire("7eyVf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $e00im = parcelRequire("e00im");
var $hzZWH = parcelRequire("hzZWH");

var $asnZU = parcelRequire("asnZU");

var $1V2xJ = parcelRequire("1V2xJ");
const $1b8601170973bccc$var$EMPTY_STACK = [];
const $1b8601170973bccc$var$IssuesMenu = ({ project: project })=>{
    (0, $asnZU.default)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8N3rk.default), {
        initialStack: $1b8601170973bccc$var$EMPTY_STACK
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hzZWH.IssuesContextualAnalyticsData), {
        navigatorScope: "project"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e00im.Issues), {
        projectKey: project.key,
        pinUrl: `/jira/core/projects/${project.key}/issues/?filter=`,
        titleHeaderText: formatMessage((0, $1V2xJ.default).issues)
    }))));
};
var $1b8601170973bccc$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($1b8601170973bccc$var$IssuesMenu);

});
parcelRegister("e00im", function(module, exports) {

$parcel$export(module.exports, "Issues", () => $da22c620e9d06640$export$1cb51167b20548a0);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $53ciZ = parcelRequire("53ciZ");

var $7eyVf = parcelRequire("7eyVf");
var $gLn5u = parcelRequire("gLn5u");

var $2ijRB = parcelRequire("2ijRB");

var $0cdA8 = parcelRequire("0cdA8");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kJlBc = parcelRequire("kJlBc");

var $bgNoL = parcelRequire("bgNoL");

var $1UelU = parcelRequire("1UelU");

var $jvL3n = parcelRequire("jvL3n");

var $1jPif = parcelRequire("1jPif");

var $9kVcv = parcelRequire("9kVcv");

var $J5kh6 = parcelRequire("J5kh6");

var $bS2FN = parcelRequire("bS2FN");

var $auisD = parcelRequire("auisD");

var $41gRk = parcelRequire("41gRk");

var $gs1oK = parcelRequire("gs1oK");

var $8lbgA = parcelRequire("8lbgA");
const $da22c620e9d06640$var$IssuesNew = ({ projectKey: projectKey, pinUrl: pinUrl, titleHeaderText: titleHeaderText })=>{
    const { data: features } = (0, $J5kh6.useDefaultPinFilters)();
    if (features === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null);
    const hasFilters = features.hasAllIssues || features.hasMyOpenIssues;
    const StyleOverrideWrapper = (0, $1ybV0.ff)('nin.global-scope_aqec8') ? $da22c620e9d06640$var$CompiledWrapper : (0, $eUqFw.Fragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StyleOverrideWrapper, {
        renderDividerBefore: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $auisD.DefaultFilters), {
        pinUrl: pinUrl,
        projectKey: projectKey,
        features: features,
        titleHeaderText: titleHeaderText
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary // eslint-disable-next-line jira/js/package-name-enforcer-for-error-boundary
    ), {
        packageName: "jira-navigation-apps-sidebar-common",
        id: "issues.starred-filters-section",
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1jPif.StarredFiltersErrorFallback), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StyleOverrideWrapper, {
        renderDividerAfter: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jvL3n.StarredFiltersContainer), {
        pinUrl: pinUrl,
        projectKey: projectKey
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StyleOverrideWrapper, {
        renderDividerBefore: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gs1oK.FiltersFooter), {
        hasFilters: hasFilters
    })));
};
const $da22c620e9d06640$export$9bf0cad7d37c4925 = ({ projectKey: projectKey, pinUrl: pinUrl, titleHeaderText: titleHeaderText })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ match: match, location: location }] = (0, $kJlBc.useRouter)(); // @ts-expect-error - TS2322 - Type '"comma"' is not assignable to type '"none" | "bracket" | "index" | undefined'.
    const { jql: jql } = (0, $53ciZ.parse)(location.search, {
        arrayFormat: 'comma'
    });
    const { data: features } = (0, $J5kh6.useDefaultPinFilters)();
    if (features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null);
    const isOnLegacyPinRoute = !!match.url.match(/^\/projects.*$/);
    const shouldUseNinLayout = !isOnLegacyPinRoute;
    const pinUrlPrefix = pinUrl === null || pinUrl === undefined || isOnLegacyPinRoute // Force legacy PIN route everywhere if user browsed here themselves
     ? `/projects/${projectKey}/issues/?filter=` : pinUrl;
    const hasSomeFilters = features.hasAllIssues || features.hasMyOpenIssues;
    const allOpenIssuesSelector = !shouldUseNinLayout ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (currentLocation, itemLocation)=>(0, $bS2FN.matchUrlParams)([
            'filter'
        ], false)(currentLocation, itemLocation) || !currentLocation.query.filter && currentLocation.pathname.includes(`/projects/${projectKey}/issues`) : (0, $bS2FN.matchUrlParams)([
        'filter'
    ], false); // NIN appends the corresponding jql to the URL for the selected filter so that it can
    // be read by integrated marketplace apps. So when determining if a MenuItem is selected, the
    // ?jql query param in the URL does not need to be considered (unless this is for legacy PIN)
    // When we can be sure legacy is no longer in use, this const can be deleted.
    const shouldIgnoreJqlUrlParam = shouldUseNinLayout;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9kVcv.TitleHeader), null, isOnLegacyPinRoute || titleHeaderText === null || titleHeaderText === undefined ? formatMessage((0, $8lbgA.messages).issues) : titleHeaderText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), null, shouldUseNinLayout && features.hasAllIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES)}`
        },
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : (...args)=>(0, $41gRk.isInAllFiltersState)(undefined, '') || (!jql ? (0, $bS2FN.matchUrlParams)([
                'filter'
            ], false)(...args) : false),
        href: `${pinUrlPrefix}allissues`
    }, formatMessage((0, $8lbgA.messages).allIssues)), features.hasMyOpenIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES)}`
        },
        selectedOn: // eslint-disable-next-line no-nested-ternary
        shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : !jql ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : ()=>false,
        href: `${pinUrlPrefix}myopenissues`
    }, formatMessage((0, $8lbgA.messages).myOpenIssues)), features.hasReportedByMe && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES)}`
        },
        selectedOn: // eslint-disable-next-line no-nested-ternary
        shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : !jql ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : ()=>false,
        href: `${pinUrlPrefix}reportedbyme`
    }, formatMessage((0, $8lbgA.messages).reportedByMe)), !shouldUseNinLayout && features.hasAllIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES)}`
        },
        selectedOn: !jql ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : ()=>false,
        href: `${pinUrlPrefix}allissues`
    }, formatMessage((0, $8lbgA.messages).allIssues)), features.hasAllOpenIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES)}`
        },
        selectedOn: // eslint-disable-next-line no-nested-ternary
        shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : !jql ? allOpenIssuesSelector : ()=>false,
        href: `${pinUrlPrefix}allopenissues`
    }, formatMessage((0, $8lbgA.messages).allOpenIssues)), features.hasDoneIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES)}`
        },
        selectedOn: // eslint-disable-next-line no-nested-ternary
        shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : !jql ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : ()=>false,
        href: `${pinUrlPrefix}doneissues`
    }, formatMessage((0, $8lbgA.messages).doneIssues)), features.hasViewedRecently && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES)}`
        },
        selectedOn: // eslint-disable-next-line no-nested-ternary
        shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : !jql ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : ()=>false,
        href: `${pinUrlPrefix}recentlyviewed`
    }, formatMessage((0, $8lbgA.messages).viewedRecently)), !shouldUseNinLayout && features.hasCreatedRecently && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES)}`
        },
        selectedOn: !jql ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : ()=>false,
        href: `${pinUrlPrefix}addedrecently`
    }, formatMessage((0, $8lbgA.messages).createdRecently)), features.hasResolvedRecently && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES)}`
        },
        selectedOn: // eslint-disable-next-line no-nested-ternary
        shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : !jql ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : ()=>false,
        href: `${pinUrlPrefix}resolvedrecently`
    }, formatMessage((0, $8lbgA.messages).resolvedRecently)), features.hasUpdatedRecently && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES)}`
        },
        selectedOn: // eslint-disable-next-line no-nested-ternary
        shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : !jql ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : ()=>false,
        href: `${pinUrlPrefix}updatedrecently`
    }, formatMessage((0, $8lbgA.messages).updatedRecently))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        hasSeparator: hasSomeFilters
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'pin-manage-filters'
        },
        selectedOn: !jql ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : ()=>false,
        href: "/secure/ManageFilters.jspa"
    }, formatMessage((0, $8lbgA.messages).viewAllFilters))));
};
const $da22c620e9d06640$export$1cb51167b20548a0 = (0, $2ijRB.default)(()=>(0, $1ybV0.ff)('nin.global-scope_aqec8'), $da22c620e9d06640$var$IssuesNew, $da22c620e9d06640$export$9bf0cad7d37c4925); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $da22c620e9d06640$var$CompiledWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { renderDividerBefore: renderDividerBefore, renderDividerAfter: renderDividerAfter, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1xlv12x7 _1rqn1fxt",
            __cmplp.renderDividerBefore && "_175u1crf",
            __cmplp.renderDividerAfter && "_1we51crf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jvL3n", function(module, exports) {

$parcel$export(module.exports, "StarredFiltersContainer", () => $6b45c28ee62250e5$export$f5b4503a4a7ca418);

var $dV4cd = parcelRequire("dV4cd");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $gLn5u = parcelRequire("gLn5u");

var $1ybV0 = parcelRequire("1ybV0");

var $1h6H8 = parcelRequire("1h6H8");

var $62ZdZ = parcelRequire("62ZdZ");

var $gGtKh = parcelRequire("gGtKh");

var $buJlM = parcelRequire("buJlM");

var $dV4cd = parcelRequire("dV4cd");

var $3HCkE = parcelRequire("3HCkE");

var $cINNO = parcelRequire("cINNO");

var $dWLk9 = parcelRequire("dWLk9");

var $de40W = parcelRequire("de40W");

var $g1pyf = parcelRequire("g1pyf");
const $6b45c28ee62250e5$export$3be6ba2fb4838e7e = ({ onFavouritesChanged: onFavouritesChanged, queryReference: queryReference, projectKey: projectKey, pinUrl: pinUrl })=>{
    // We store localStorageData as state so that it's not recalculated during subsequent renders. We want that as a
    // guarantee, not just as a performance optimisation, so we're using useState rather than useMemo.
    //
    // The reason we want to guarantee it's only fetched during the initial render is that we want
    // isNinGlobalScopeEnrolmentEnabled to be stable if there's localStorageData. This can prevent a bug where fetch
    // true from localStorage, we render NIN, the resource returns false, we update local storage to false, and then
    // GinRedirect is rendered again by a parent component and localStorage now returns false and we redirect later
    // than we should.;
    const [localStorageData] = (0, $eUqFw.useState)((0, $1h6H8.getIsGlobalScopeEnrolmentEnabledFromLocalStorage)());
    const { data: resourceData } = (0, $3HCkE.useResource)((0, $cINNO.isNinGlobalScopeEnrolmentEnabledResource));
    // get value from localStorage if available, get from the resource if this code runs in SSR
    let isNinGlobalScopeEnrolmentEnabled;
    if (localStorageData !== null && localStorageData !== undefined) isNinGlobalScopeEnrolmentEnabled = !!localStorageData;
    else isNinGlobalScopeEnrolmentEnabled = !!resourceData;
    const baseHref = (0, $de40W.getStarredFilterLink)({
        projectKey: projectKey,
        pinUrl: pinUrl,
        shouldStayProjectScope: (0, $1ybV0.ff)('nin.global-scope_aqec8') && isNinGlobalScopeEnrolmentEnabled
    });
    const data = (0, $iWLL0.usePreloadedQuery)((0, $dV4cd.default), queryReference);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g1pyf.StarredFiltersList), {
        baseHref: baseHref,
        jiraQuery: data.jira,
        onFavouritesChanged: onFavouritesChanged
    });
};
const $6b45c28ee62250e5$export$f5b4503a4a7ca418 = ({ projectKey: projectKey, pinUrl: pinUrl })=>{
    const { queryReference: resourceQueryRef } = (0, $buJlM.useRelayResource)((0, $62ZdZ.sidebarProjectIssuesResource));
    const [queryReference, loadQuery] = (0, $iWLL0.useQueryLoader)((0, $dV4cd.default), resourceQueryRef);
    const cloudId = (0, $dWLk9.useCloudId)();
    const loadSidebarData = (0, $eUqFw.useCallback)(()=>{
        loadQuery({
            cloudId: cloudId
        }, {
            fetchPolicy: 'store-and-network'
        });
    }, [
        cloudId,
        loadQuery
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!queryReference) loadSidebarData();
    }, [
        loadSidebarData,
        queryReference
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "starred-filters",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null)
    }, queryReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6b45c28ee62250e5$export$3be6ba2fb4838e7e, {
        queryReference: queryReference,
        onFavouritesChanged: loadSidebarData,
        pinUrl: pinUrl,
        projectKey: projectKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null));
};

});
parcelRegister("de40W", function(module, exports) {

$parcel$export(module.exports, "getStarredFilterLink", () => $58b0dd58f177e334$export$7082c02465d0ecd4);
const $58b0dd58f177e334$export$7082c02465d0ecd4 = ({ projectKey: projectKey, pinUrl: pinUrl, shouldStayProjectScope: shouldStayProjectScope })=>{
    if (!projectKey) throw new Error(`Expected projectKey to be a valid string, got: ${projectKey}`);
    // xxx/issues?filter=123 -> xxx/issues
    const craftedPinUrl = !pinUrl ? `/projects/${projectKey}/issues` : pinUrl.replace(/\?.*$/, '');
    return shouldStayProjectScope ? craftedPinUrl : '/issues/';
};

});

parcelRegister("g1pyf", function(module, exports) {

$parcel$export(module.exports, "StarredFiltersList", () => $35a2047bceaae71b$export$b7f4b26a8737eee0);

var $kwce8 = parcelRequire("kwce8");

var $lz8Mx = parcelRequire("lz8Mx");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $7eyVf = parcelRequire("7eyVf");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hR6B0 = parcelRequire("hR6B0");

var $efIfB = parcelRequire("efIfB");

var $9GCal = parcelRequire("9GCal");
var $35a2047bceaae71b$var$_StyledSection = /*#__PURE__*/ (0, $kwce8.default)((0, $7eyVf.default)).withConfig({
    componentId: "sc-8ugvpc-0"
})`${(p)=>p._css}`;
const $35a2047bceaae71b$export$b7f4b26a8737eee0 = ({ baseHref: baseHref, jiraQuery: jiraQuery, onFavouritesChanged: onFavouritesChanged, sectionCustomCss: sectionCustomCss })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const data = (0, $iWLL0.useFragment)((0, $lz8Mx.default), jiraQuery);
    (0, $hR6B0.useFavouritesChangeEffect)('filters', (hasPendingChanges, previousHasPendingChanges)=>{
        // refresh when transitioning from pending to NOT pending
        if (previousHasPendingChanges && !hasPendingChanges) onFavouritesChanged();
    });
    const starredFilterEdges = data.favouriteFilters?.edges || [];
    if (!starredFilterEdges.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35a2047bceaae71b$var$_StyledSection, {
        title: formatMessage((0, $1ybV0.ff)('nin.global-scope_aqec8') ? (0, $9GCal.messages).newStarredFiltersHeader : (0, $9GCal.messages).starredFiltersHeader),
        _css: sectionCustomCss
    }, starredFilterEdges.map((edge)=>edge?.node ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $efIfB.FilterItem), {
            key: edge.node.filterId,
            baseHref: baseHref,
            filter: edge.node,
            customAnalytics: {
                isStarred: true
            }
        }) : null));
};

});
parcelRegister("lz8Mx", function(module, exports) {

$parcel$export(module.exports, "default", () => $8652eb61facff2a1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6a0ff7cd83606b406c54bd970f933e48>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8652eb61facff2a1$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "starredFiltersList_navigationAppsSidebarCommon",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "JiraFilterConnection",
            "kind": "LinkedField",
            "name": "favouriteFilters",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraFilterEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "filterId"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "filterItem_navigationAppsSidebarCommon"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraQuery"
};
$8652eb61facff2a1$var$node.hash = "a0c4e11d2fa2d823ad4cac3d7e350cb3";
var $8652eb61facff2a1$export$2e2bcd8739ae039 = $8652eb61facff2a1$var$node;

});

parcelRegister("hR6B0", function(module, exports) {

$parcel$export(module.exports, "useFavouritesChangeEffect", () => $2f7c11e5ef943ce8$export$2c710fb0bffad609);

var $eUqFw = parcelRequire("eUqFw");

var $3LiTJ = parcelRequire("3LiTJ");

var $dQZ5c = parcelRequire("dQZ5c");

var $hzcvF = parcelRequire("hzcvF");
const $2f7c11e5ef943ce8$export$2c710fb0bffad609 = (type, effect)=>{
    const { items: items } = (0, $eUqFw.useContext)((0, $dQZ5c.FavouriteChangeContext));
    // @ts-expect-error - TS2322 - Type 'ItemMap | undefined' is not assignable to type 'ItemMap'.
    const typeItems = items[type];
    const pendingChanges = (0, (/*@__PURE__*/$parcel$interopDefault($3LiTJ)))(typeItems, (item)=>item.pending);
    const hasPendingChanges = Boolean(Object.keys(pendingChanges).length);
    const previousHasPendingChanges = (0, $hzcvF.usePreviousWithInitial)(hasPendingChanges);
    (0, $eUqFw.useEffect)(()=>{
        effect(hasPendingChanges, previousHasPendingChanges);
    }, [
        effect,
        hasPendingChanges,
        previousHasPendingChanges
    ]);
};

});

parcelRegister("efIfB", function(module, exports) {

$parcel$export(module.exports, "FilterItem", () => $d52ff21ebba57816$export$3cf161fcd24b6b4f);

var $emcDd = parcelRequire("emcDd");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $1UelU = parcelRequire("1UelU");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d52ff21ebba57816$var$selectedOn = (currentLocation, itemLocation)=>itemLocation.query.filter === (currentLocation.query.filterId || currentLocation.query.filter);
const $d52ff21ebba57816$export$3cf161fcd24b6b4f = ({ baseHref: baseHref, filter: filter, customAnalytics: customAnalytics })=>{
    const { filterId: filterId, name: name } = (0, $iWLL0.useFragment)(/* eslint-disable @atlassian/relay/unused-fields */ (0, $emcDd.default), /* eslint-enable @atlassian/relay/unused-fields */ filter);
    const analyticsAttributes = (0, $eUqFw.useMemo)(()=>({
            ...customAnalytics || {},
            itemId: `filter-${filterId}`
        }), [
        customAnalytics,
        filterId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        key: filterId,
        analytics: analyticsAttributes,
        selectedOn: $d52ff21ebba57816$var$selectedOn,
        href: `${baseHref}?filter=${filterId}`
    }, name);
};

});
parcelRegister("emcDd", function(module, exports) {

$parcel$export(module.exports, "default", () => $316231fa04a38c46$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<331a8e20fbd9d2a81b2d41dfa21f3810>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $316231fa04a38c46$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "filterItem_navigationAppsSidebarCommon",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "filterId"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "jql"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ],
            "type": "JiraCustomFilter"
        }
    ],
    "type": "JiraFilter",
    "abstractKey": "__isJiraFilter"
};
$316231fa04a38c46$var$node.hash = "31464d108113d7084e471c226c3fe0aa";
var $316231fa04a38c46$export$2e2bcd8739ae039 = $316231fa04a38c46$var$node;

});


parcelRegister("9GCal", function(module, exports) {

$parcel$export(module.exports, "messages", () => $298836785675e03a$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $298836785675e03a$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    starredFiltersHeader: {
        "id": "spa-apps-sidebar-common.common.starred-filters-list.starred-filters-header",
        "defaultMessage": "Starred global filters"
    },
    // TODO: cleanup when tidying up FF: nin.global-scope_aqec8
    newStarredFiltersHeader: {
        "id": "spa-apps-sidebar-common.common.starred-filters-list.new-starred-filters-header",
        "defaultMessage": "Starred filters"
    }
});

});



parcelRegister("1jPif", function(module, exports) {

$parcel$export(module.exports, "StarredFiltersErrorFallback", () => $d6c63c3350dd7b8a$export$70765d6359132b82);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $lRvnl = parcelRequire("lRvnl");

var $7eyVf = parcelRequire("7eyVf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $e7DJr = parcelRequire("e7DJr");
const $d6c63c3350dd7b8a$export$70765d6359132b82 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6c63c3350dd7b8a$var$SectionWrapper, {
        // TODO remove SectionWrapper once @atlaskit/section design gets updated
        title: formatMessage((0, $e7DJr.default).starredFiltersHeader)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        appearance: "warning"
    }, formatMessage((0, $e7DJr.default).errorMessage, {
        link: (linkText)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                appearance: "link",
                spacing: "none",
                onClick: ()=>window.location.reload()
            }, linkText)
    })));
};
// TODO remove SectionWrapper once @atlaskit/section design gets updated
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d6c63c3350dd7b8a$var$SectionWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7eyVf.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt3i2wt _euf41fxt _1qdg1crf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lRvnl", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dc3a504e8cabc14$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hI5oG = parcelRequire("hI5oG");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $gf4A3 = parcelRequire("gf4A3");
const $4dc3a504e8cabc14$var$sectionMessageStyles = (0, $1ZAYh.xcss)({
    wordBreak: 'break-word',
    borderRadius: 'border.radius'
});
const $4dc3a504e8cabc14$var$bleedStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    marginBlock: 'space.negative.025'
});
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ const $4dc3a504e8cabc14$var$SectionMessage = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, icon: icon, testId: testId }, ref) {
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $gf4A3.getAppearanceIconStyles)(appearance, icon);
    const actionElements = actions && actions.type === (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment ? actions.props.children : actions;
    const actionsArray = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(actionElements);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "section",
        backgroundColor: $4dc3a504e8cabc14$var$appearanceMap[appearance],
        padding: "space.200",
        testId: testId,
        ref: ref,
        xcss: $4dc3a504e8cabc14$var$sectionMessageStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.200",
        alignBlock: "stretch"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $4dc3a504e8cabc14$var$bleedStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
        size: "medium",
        primaryColor: primaryColor,
        secondaryColor: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100",
        testId: testId && `${testId}--content`
    }, !!title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        level: "h500"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), null, children), actionsArray.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        shouldWrap: true,
        testId: testId && `${testId}--actions`,
        separator: "\xb7",
        space: "space.100",
        rowSpace: "space.0"
    }, actionsArray))));
});
const $4dc3a504e8cabc14$var$appearanceMap = {
    information: 'color.background.information',
    warning: 'color.background.warning',
    error: 'color.background.danger',
    success: 'color.background.success',
    discovery: 'color.background.discovery'
};
$4dc3a504e8cabc14$var$SectionMessage.displayName = 'SectionMessage';
var $4dc3a504e8cabc14$export$2e2bcd8739ae039 = $4dc3a504e8cabc14$var$SectionMessage;

});
parcelRegister("gf4A3", function(module, exports) {

$parcel$export(module.exports, "getAppearanceIconStyles", () => $5e1f1f04e3e69c39$export$e9b82d2e21ac0c1f);

var $eUqFw = parcelRequire("eUqFw");

var $aWvIp = parcelRequire("aWvIp");

var $96IgR = parcelRequire("96IgR");

var $2bv8J = parcelRequire("2bv8J");

var $ioiQ7 = parcelRequire("ioiQ7");

var $5YsMl = parcelRequire("5YsMl");

var $PdmhA = parcelRequire("PdmhA");
const $5e1f1f04e3e69c39$export$faa35441caff5bb6 = {
    information: {
        backgroundColor: `var(--ds-background-information, ${(0, $PdmhA.B50)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($2bv8J))),
        primaryIconColor: `var(--ds-icon-information, ${(0, $PdmhA.B500)})`
    },
    warning: {
        backgroundColor: `var(--ds-background-warning, ${(0, $PdmhA.Y50)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))),
        primaryIconColor: `var(--ds-icon-warning, ${(0, $PdmhA.Y500)})`
    },
    error: {
        backgroundColor: `var(--ds-background-danger, ${(0, $PdmhA.R50)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($96IgR))),
        primaryIconColor: `var(--ds-icon-danger, ${(0, $PdmhA.R500)})`
    },
    success: {
        backgroundColor: `var(--ds-background-success, ${(0, $PdmhA.G50)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))),
        primaryIconColor: `var(--ds-icon-success, ${(0, $PdmhA.G500)})`
    },
    discovery: {
        backgroundColor: `var(--ds-background-discovery, ${(0, $PdmhA.P50)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($ioiQ7))),
        primaryIconColor: `var(--ds-icon-discovery, ${(0, $PdmhA.P500)})`
    }
};
function $5e1f1f04e3e69c39$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $5e1f1f04e3e69c39$export$faa35441caff5bb6[appearance] || $5e1f1f04e3e69c39$export$faa35441caff5bb6.information;
    const AppearanceIcon = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(appearanceIconStyles.Icon, {
            size: size,
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}

});
parcelRegister("aWvIp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f77ec2b05210607$var$_react = $7f77ec2b05210607$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $7f77ec2b05210607$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $7f77ec2b05210607$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $7f77ec2b05210607$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="10"/><path d="M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z" fill="inherit"/></g></svg>`
    }, props));
$7f77ec2b05210607$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $7f77ec2b05210607$var$_default = $7f77ec2b05210607$var$CheckCircleIcon;
module.exports.default = $7f77ec2b05210607$var$_default;

});

parcelRegister("2bv8J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1974c390fcca76c2$var$_react = $1974c390fcca76c2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $1974c390fcca76c2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $1974c390fcca76c2$var$InfoIcon = (props)=>/*#__PURE__*/ $1974c390fcca76c2$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12z" fill="currentColor"/><rect fill="inherit" x="11" y="10" width="2" height="7" rx="1"/><circle fill="inherit" cx="12" cy="8" r="1"/></g></svg>`
    }, props));
$1974c390fcca76c2$var$InfoIcon.displayName = 'InfoIcon';
var $1974c390fcca76c2$var$_default = $1974c390fcca76c2$var$InfoIcon;
module.exports.default = $1974c390fcca76c2$var$_default;

});



parcelRegister("e7DJr", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d36cc3357c6d79c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4d36cc3357c6d79c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorMessage: {
        "id": "spa-apps-sidebar-common.common.starred-filters-error-fallback.error-message",
        "defaultMessage": "We couldn't load your starred filters. <link>Refresh the page</link> to try again."
    },
    starredFiltersHeader: {
        "id": "spa-apps-sidebar-common.common.starred-filters-error-fallback.starred-filters-header",
        "defaultMessage": "Starred filters"
    }
});

});


parcelRegister("J5kh6", function(module, exports) {

$parcel$export(module.exports, "useDefaultPinFilters", () => $35f10d3662b33f51$export$3c69152f8409a017);

var $eUqFw = parcelRequire("eUqFw");

var $51qRF = parcelRequire("51qRF");

var $3HCkE = parcelRequire("3HCkE");
const $35f10d3662b33f51$export$3c69152f8409a017 = ()=>{
    const { data: data, loading: loading, refresh: refresh, error: error } = (0, $3HCkE.useResource)((0, $51qRF.staticSidebarDefaultPINFiltersResource));
    (0, $eUqFw.useEffect)(()=>{
        if (data == null && error == null && loading === false) refresh();
    }, [
        data,
        error,
        loading,
        refresh
    ]);
    return {
        data: data,
        loading: loading
    };
};

});

parcelRegister("auisD", function(module, exports) {

$parcel$export(module.exports, "DefaultFilters", () => $755cdea7fe43675a$export$5df36bcfaa4d1f9d);

var $eUqFw = parcelRequire("eUqFw");

var $53ciZ = parcelRequire("53ciZ");

var $7eyVf = parcelRequire("7eyVf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kJlBc = parcelRequire("kJlBc");

var $1UelU = parcelRequire("1UelU");

var $bS2FN = parcelRequire("bS2FN");

var $3Cmcu = parcelRequire("3Cmcu");

var $41gRk = parcelRequire("41gRk");
const $755cdea7fe43675a$export$5df36bcfaa4d1f9d = ({ features: features, projectKey: projectKey, pinUrl: pinUrl, titleHeaderText: titleHeaderText })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ match: match, location: location }] = (0, $kJlBc.useRouter)();
    // @ts-expect-error - TS2322 - Type '"comma"' is not assignable to type '"none" | "bracket" | "index" | undefined'.
    const { jql: jql } = (0, $53ciZ.parse)(location.search, {
        arrayFormat: 'comma'
    });
    const isOnLegacyPinRoute = !!match.url.match(/^\/projects.*$/);
    const shouldUseNinLayout = !isOnLegacyPinRoute;
    const pinUrlPrefix = pinUrl === null || pinUrl === undefined || isOnLegacyPinRoute // Force legacy PIN route everywhere if user browsed here themselves
     ? `/projects/${projectKey}/issues/?filter=` : pinUrl;
    const title = isOnLegacyPinRoute || titleHeaderText == null ? formatMessage((0, $3Cmcu.messages).issues) : titleHeaderText;
    const allOpenIssuesSelector = !shouldUseNinLayout ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (currentLocation, itemLocation)=>(0, $bS2FN.matchUrlParams)([
            'filter'
        ], false)(currentLocation, itemLocation) || !currentLocation.query.filter && currentLocation.pathname.includes(`/projects/${projectKey}/issues`) : (0, $bS2FN.matchUrlParams)([
        'filter'
    ], false);
    // NIN appends the corresponding jql to the URL for the selected filter so that it can
    // be read by integrated marketplace apps. So when determining if a MenuItem is selected, the
    // ?jql query URL param should be ignored unless this is for legacy PIN.
    // When we can be sure legacy is no longer in use, this const can be deleted.
    const shouldIgnoreJqlUrlParam = shouldUseNinLayout;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        title: title
    }, shouldUseNinLayout && features.hasAllIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: (0, $41gRk.itemMap).ninLayoutAllIssues.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : (0, $41gRk.itemMap).ninLayoutAllIssues.selectedOn(jql),
        href: `${pinUrlPrefix}allissues`
    }, formatMessage((0, $3Cmcu.messages).allIssues)), features.hasMyOpenIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: (0, $41gRk.itemMap).myOpenIssues.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : (0, $41gRk.itemMap).myOpenIssues.selectedOn(jql),
        href: `${pinUrlPrefix}myopenissues`
    }, formatMessage((0, $3Cmcu.messages).myOpenIssues)), features.hasReportedByMe && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: (0, $41gRk.itemMap).reportedByMe.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : (0, $41gRk.itemMap).reportedByMe.selectedOn(jql),
        href: `${pinUrlPrefix}reportedbyme`
    }, formatMessage((0, $3Cmcu.messages).reportedByMe)), !shouldUseNinLayout && features.hasAllIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: (0, $41gRk.itemMap).notNinLayoutAllIssues.analytics,
        selectedOn: (0, $41gRk.itemMap).notNinLayoutAllIssues.selectedOn(jql),
        href: `${pinUrlPrefix}allissues`
    }, formatMessage((0, $3Cmcu.messages).allIssues)), features.hasAllOpenIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: (0, $41gRk.itemMap).allOpenIssues.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : (0, $41gRk.itemMap).allOpenIssues.selectedOn(jql, allOpenIssuesSelector),
        href: `${pinUrlPrefix}allopenissues`
    }, formatMessage((0, $3Cmcu.messages).allOpenIssues)), features.hasDoneIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: (0, $41gRk.itemMap).doneIssues.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : (0, $41gRk.itemMap).doneIssues.selectedOn(jql),
        href: `${pinUrlPrefix}doneissues`
    }, formatMessage((0, $3Cmcu.messages).doneIssues)), features.hasViewedRecently && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: (0, $41gRk.itemMap).viewedRecently.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : (0, $41gRk.itemMap).viewedRecently.selectedOn(jql),
        href: `${pinUrlPrefix}recentlyviewed`
    }, formatMessage((0, $3Cmcu.messages).viewedRecently)), !shouldUseNinLayout && features.hasCreatedRecently && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: (0, $41gRk.itemMap).createdRecently.analytics,
        selectedOn: (0, $41gRk.itemMap).createdRecently.selectedOn(jql),
        href: `${pinUrlPrefix}addedrecently`
    }, formatMessage((0, $3Cmcu.messages).createdRecently)), features.hasResolvedRecently && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: (0, $41gRk.itemMap).resolvedRecently.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : (0, $41gRk.itemMap).resolvedRecently.selectedOn(jql),
        href: `${pinUrlPrefix}resolvedrecently`
    }, formatMessage((0, $3Cmcu.messages).resolvedRecently)), features.hasUpdatedRecently && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: (0, $41gRk.itemMap).updatedRecently.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $bS2FN.matchUrlParams)([
            'filter'
        ], false) : (0, $41gRk.itemMap).updatedRecently.selectedOn(jql),
        href: `${pinUrlPrefix}updatedrecently`
    }, formatMessage((0, $3Cmcu.messages).updatedRecently)));
};

});
parcelRegister("3Cmcu", function(module, exports) {

$parcel$export(module.exports, "messages", () => $27be2807b2a35477$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $27be2807b2a35477$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    issues: {
        "id": "spa-apps-sidebar-common.issues.default-filters.issues",
        "defaultMessage": "Issues and filters"
    },
    issuesFilters: {
        "id": "spa-apps-sidebar-common.issues.default-filters.issues-filters",
        "defaultMessage": "Issues and Filters"
    },
    myOpenIssues: {
        "id": "spa-apps-sidebar-common.issues.default-filters.my-open-issues",
        "defaultMessage": "My open issues"
    },
    reportedByMe: {
        "id": "spa-apps-sidebar-common.issues.default-filters.reported-by-me",
        "defaultMessage": "Reported by me"
    },
    allIssues: {
        "id": "spa-apps-sidebar-common.issues.default-filters.all-issues",
        "defaultMessage": "All issues"
    },
    allOpenIssues: {
        "id": "spa-apps-sidebar-common.issues.default-filters.all-open-issues",
        "defaultMessage": "Open issues"
    },
    doneIssues: {
        "id": "spa-apps-sidebar-common.issues.default-filters.done-issues",
        "defaultMessage": "Done issues"
    },
    viewedRecently: {
        "id": "spa-apps-sidebar-common.issues.default-filters.viewed-recently",
        "defaultMessage": "Viewed recently"
    },
    createdRecently: {
        "id": "spa-apps-sidebar-common.issues.default-filters.created-recently",
        "defaultMessage": "Created recently"
    },
    resolvedRecently: {
        "id": "spa-apps-sidebar-common.issues.default-filters.resolved-recently",
        "defaultMessage": "Resolved recently"
    },
    updatedRecently: {
        "id": "spa-apps-sidebar-common.issues.default-filters.updated-recently",
        "defaultMessage": "Updated recently"
    }
});

});

parcelRegister("41gRk", function(module, exports) {

$parcel$export(module.exports, "isInAllFiltersState", () => $4de8f16c2cebce90$export$1596c397510d46b1);
$parcel$export(module.exports, "itemMap", () => $4de8f16c2cebce90$export$1072457701b9918d);

var $bgNoL = parcelRequire("bgNoL");

var $bS2FN = parcelRequire("bS2FN");
const $4de8f16c2cebce90$export$1596c397510d46b1 = (filter, jql)=>{
    // Initial load
    if ((typeof filter === 'undefined' || !filter.length) && typeof jql === 'undefined') return true;
    if (filter != null && filter !== 'allissues') return false;
    if (typeof jql === 'string' && jql.match(/^project = ".*" ORDER BY created (?:DESC|ASC)$/)) return true;
    return false;
};
const $4de8f16c2cebce90$export$1072457701b9918d = {
    ninLayoutAllIssues: {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES)}`
        },
        selectedOn: (jql)=>(...args)=>$4de8f16c2cebce90$export$1596c397510d46b1(undefined, '') || (!jql ? (0, $bS2FN.matchUrlParams)([
                    'filter'
                ], false)(...args) : false)
    },
    myOpenIssues: {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $bS2FN.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    reportedByMe: {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $bS2FN.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    notNinLayoutAllIssues: {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $bS2FN.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    allOpenIssues: {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES)}`
        },
        selectedOn: (jql, allOpenIssuesSelector)=>!jql && allOpenIssuesSelector ? allOpenIssuesSelector : ()=>false
    },
    doneIssues: {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $bS2FN.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    viewedRecently: {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $bS2FN.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    createdRecently: {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $bS2FN.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    resolvedRecently: {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $bS2FN.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    updatedRecently: {
        analytics: {
            itemId: `pin-${(0, $bgNoL.PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $bS2FN.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    }
};

});


parcelRegister("gs1oK", function(module, exports) {

$parcel$export(module.exports, "FiltersFooter", () => $b725eee24cc929f3$export$c131ccfc44bcd85c);

var $eUqFw = parcelRequire("eUqFw");

var $7eyVf = parcelRequire("7eyVf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1UelU = parcelRequire("1UelU");

var $fPhxv = parcelRequire("fPhxv");
const $b725eee24cc929f3$var$analyticsPayload = {
    itemId: 'pin-manage-filters'
};
const $b725eee24cc929f3$export$c131ccfc44bcd85c = ({ hasFilters: hasFilters })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        hasSeparator: hasFilters
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: $b725eee24cc929f3$var$analyticsPayload,
        href: "/jira/filters"
    }, formatMessage((0, $fPhxv.messages).viewAllFilters)));
};

});
parcelRegister("fPhxv", function(module, exports) {

$parcel$export(module.exports, "messages", () => $bd606415b82d3454$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $bd606415b82d3454$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    viewAllFilters: {
        "id": "spa-apps-sidebar-common.issues.filters-footer.view-all-filters",
        "defaultMessage": "View all filters"
    }
});

});


parcelRegister("8lbgA", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a62695030ba4b800$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $a62695030ba4b800$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    issues: {
        "id": "spa-apps-sidebar-common.issues.issues",
        "defaultMessage": "Issues and filters"
    },
    issuesFilters: {
        "id": "spa-apps-sidebar-common.issues.issues-filters",
        "defaultMessage": "Issues and Filters"
    },
    myOpenIssues: {
        "id": "spa-apps-sidebar-common.issues.my-open-issues",
        "defaultMessage": "My open issues"
    },
    reportedByMe: {
        "id": "spa-apps-sidebar-common.issues.reported-by-me",
        "defaultMessage": "Reported by me"
    },
    allIssues: {
        "id": "spa-apps-sidebar-common.issues.all-issues",
        "defaultMessage": "All issues"
    },
    allOpenIssues: {
        "id": "spa-apps-sidebar-common.issues.all-open-issues",
        "defaultMessage": "Open issues"
    },
    doneIssues: {
        "id": "spa-apps-sidebar-common.issues.done-issues",
        "defaultMessage": "Done issues"
    },
    viewedRecently: {
        "id": "spa-apps-sidebar-common.issues.viewed-recently",
        "defaultMessage": "Viewed recently"
    },
    createdRecently: {
        "id": "spa-apps-sidebar-common.issues.created-recently",
        "defaultMessage": "Created recently"
    },
    resolvedRecently: {
        "id": "spa-apps-sidebar-common.issues.resolved-recently",
        "defaultMessage": "Resolved recently"
    },
    updatedRecently: {
        "id": "spa-apps-sidebar-common.issues.updated-recently",
        "defaultMessage": "Updated recently"
    },
    viewAllFilters: {
        "id": "spa-apps-sidebar-common.issues.view-all-filters",
        "defaultMessage": "View all filters"
    }
});

});


parcelRegister("1V2xJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff74a8dacf24a66b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $ff74a8dacf24a66b$var$messages = (0, $90IgZ.defineMessages)({
    issues: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.issues-menu.issues",
        "defaultMessage": "Issues"
    }
});
var $ff74a8dacf24a66b$export$2e2bcd8739ae039 = $ff74a8dacf24a66b$var$messages;

});


parcelRegister("8Xc28", function(module, exports) {

$parcel$export(module.exports, "default", () => $bebf29b281f05c6a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8N3rk = parcelRequire("8N3rk");
var $7eyVf = parcelRequire("7eyVf");

var $exb0h = parcelRequire("exb0h");

var $10fdS = parcelRequire("10fdS");

var $lg3mT = parcelRequire("lg3mT");

var $asnZU = parcelRequire("asnZU");
var $kFwR2 = parcelRequire("kFwR2");

var $1gKca = parcelRequire("1gKca");
const $bebf29b281f05c6a$var$calculateStack = (route, connectStack)=>{
    if ((0, $exb0h.CONNECT_ROUTES_SET).has(route.name) && connectStack) {
        const [first, ...other] = connectStack;
        // omit the reports nesting level as we render the reports menu
        // as a top level menu in business projects
        if ((0, $lg3mT.SECTION_ID).REPORTS === first) return other;
        return connectStack;
    }
    return [];
};
const $bebf29b281f05c6a$var$ReportsMenu = ()=>{
    (0, $asnZU.default)();
    const route = (0, $10fdS.useCurrentRoute)();
    const { data: connectItems, stack: connectStack } = (0, $kFwR2.useProjectReportsConnectItems)();
    const [stack, setStack] = (0, $eUqFw.useState)(()=>$bebf29b281f05c6a$var$calculateStack(route, connectStack));
    (0, $eUqFw.useEffect)(()=>{
        setStack($bebf29b281f05c6a$var$calculateStack(route, connectStack));
    }, [
        route,
        connectStack
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8N3rk.default), {
        stack: stack,
        onChange: setStack
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1gKca.Reports), {
        connectItems: connectItems
    })));
};
var $bebf29b281f05c6a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($bebf29b281f05c6a$var$ReportsMenu);

});
parcelRegister("1gKca", function(module, exports) {

$parcel$export(module.exports, "Reports", () => $c5c469348dcea9ef$export$883262dc952d8f59);

var $eUqFw = parcelRequire("eUqFw");

var $7eyVf = parcelRequire("7eyVf");
var $gLn5u = parcelRequire("gLn5u");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bS2FN = parcelRequire("bS2FN");
var $1UelU = parcelRequire("1UelU");
var $5KxOv = parcelRequire("5KxOv");
var $cPEpP = parcelRequire("cPEpP");

var $kIUmN = parcelRequire("kIUmN");

var $aWYQ8 = parcelRequire("aWYQ8");

var $hX9N3 = parcelRequire("hX9N3");

var $aJGiK = parcelRequire("aJGiK");

var $bRhBg = parcelRequire("bRhBg");

var $lmMuP = parcelRequire("lmMuP");
const $c5c469348dcea9ef$var$useThrowDefaultReportItemsDI = (0, $kIUmN.withThrowOnError)((0, $aJGiK.useDefaultReportItems));
const $c5c469348dcea9ef$var$useThrowProjectDI = (0, $kIUmN.withThrowOnError)((0, $cPEpP.useProject));
const $c5c469348dcea9ef$var$useThrowReportFeaturesDI = (0, $kIUmN.withThrowOnError)((0, $bRhBg.useReportFeatures));
const $c5c469348dcea9ef$export$883262dc952d8f59 = ({ ConnectMenu: ConnectMenu = (0, $aWYQ8.ConnectMenu), MenuItem: MenuItem = (0, $1UelU.MenuItem), Section: Section = (0, $7eyVf.default), SkeletonItem: SkeletonItem = (0, $gLn5u.default), connectItems: connectItems, SectionHeader: SectionHeader = (0, $5KxOv.SectionHeader), matchUrlParams: matchUrlParams = (0, $bS2FN.matchUrlParams), useDefaultReportItems: useDefaultReportItems = $c5c469348dcea9ef$var$useThrowDefaultReportItemsDI, useIntl: useIntl = (0, $5JgJ2.default), useProject: useProject = $c5c469348dcea9ef$var$useThrowProjectDI, useReportFeatures: useReportFeatures = $c5c469348dcea9ef$var$useThrowReportFeaturesDI })=>{
    const baseUrl = '';
    const { data: defaultItems } = useDefaultReportItems();
    const { data: features } = useReportFeatures();
    const { formatMessage: formatMessage } = useIntl();
    const { data: project } = useProject();
    if (project == null || features == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SkeletonItem, null);
    const createReportUrl = (0, $hX9N3.createReportUrlFunc)({
        baseUrl: baseUrl,
        project: project
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, defaultItems && defaultItems.items.length > 0 && // @ts-expect-error - TS2769 - No overload matches this call.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Section, {
        id: defaultItems.id,
        key: defaultItems.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SectionHeader, null, defaultItems.name), defaultItems.items && defaultItems.items.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MenuItem, {
            key: item.id,
            analytics: {
                itemId: item.id
            },
            selectedOn: matchUrlParams([
                'reportKey'
            ]),
            href: item.url
        }, item.name != null ? item.name : null))), features && features.hasForcastSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Section, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SectionHeader, null, formatMessage((0, $lmMuP.default).forecastAndManagement)), features.hasTimeTracking && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MenuItem, {
        analytics: {
            itemId: 'time-tracking'
        },
        href: createReportUrl('com.atlassian.jira.plugin.system.reports:time-tracking'),
        selectedOn: matchUrlParams([
            'reportKey'
        ])
    }, formatMessage((0, $lmMuP.default).timeTracking)), features.hasDeveloperWorkload && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MenuItem, {
        analytics: {
            itemId: 'developer-workload'
        },
        href: createReportUrl('com.atlassian.jira.plugin.system.reports:developer-workload'),
        selectedOn: matchUrlParams([
            'reportKey'
        ])
    }, formatMessage((0, $lmMuP.default).userWorkload)), features.hasVersionWorkloadReport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MenuItem, {
        analytics: {
            itemId: 'version-workload'
        },
        href: createReportUrl('com.atlassian.jira.plugins.jira-software-plugin:version-workload-report'),
        selectedOn: matchUrlParams([
            'reportKey'
        ])
    }, formatMessage((0, $lmMuP.default).versionWorkload))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Section, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SectionHeader, null, formatMessage((0, $lmMuP.default).other)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MenuItem, {
        analytics: {
            itemId: 'workloadpie'
        },
        href: createReportUrl('com.atlassian.jira.ext.charting:workloadpie-report'),
        selectedOn: matchUrlParams([
            'reportKey'
        ])
    }, formatMessage((0, $lmMuP.default).workloadPieChart)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ConnectMenu, {
        items: connectItems,
        overrides: {
            BackMenuItem: {
                href: `/projects/${project.key}?selectedItem=com.atlassian.jira.jira-projects-plugin:report-page`,
                title: formatMessage((0, $lmMuP.default).itemBack)
            }
        }
    })));
};

});
parcelRegister("hX9N3", function(module, exports) {

$parcel$export(module.exports, "createReportUrlFunc", () => $aaeaad86945af36f$export$fe91ad5e718e4335);
const $aaeaad86945af36f$export$fe91ad5e718e4335 = ({ baseUrl: baseUrl, project: project })=>(reportKey)=>`${baseUrl}/secure/ConfigureReport!default.jspa?selectedProjectId=${project.id}&projectOrFilterId=project-${project.id}&projectOrFilterName=${project.name}&reportKey=${reportKey}`;

});

parcelRegister("aJGiK", function(module, exports) {

$parcel$export(module.exports, "useDefaultReportItems", () => $803b0b72c024ff00$export$ab2e8832e8916e83);

var $5JgJ2 = parcelRequire("5JgJ2");

var $cPEpP = parcelRequire("cPEpP");

var $hX9N3 = parcelRequire("hX9N3");

var $93Xzy = parcelRequire("93Xzy");
const $803b0b72c024ff00$export$ab2e8832e8916e83 = ()=>{
    const baseUrl = '';
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { data: project, loading: loading, error: error } = (0, $cPEpP.useProject)();
    let defaultIssueAnalysisSection = null;
    if (project) {
        const createReportUrl = (0, $hX9N3.createReportUrlFunc)({
            baseUrl: baseUrl,
            project: project
        });
        defaultIssueAnalysisSection = {
            name: formatMessage((0, $93Xzy.default).issueAnalysis),
            id: 'issue-analysis-sidebar-links',
            items: [
                {
                    id: 'averageage-report',
                    url: createReportUrl('com.atlassian.jira.plugin.system.reports:averageage-report'),
                    name: formatMessage((0, $93Xzy.default).averageAgeReport)
                },
                {
                    id: 'createdvsresolved-report',
                    url: createReportUrl('com.atlassian.jira.plugin.system.reports:createdvsresolved-report'),
                    name: formatMessage((0, $93Xzy.default).createdResolvedIssuesReport)
                },
                {
                    id: 'pie-report',
                    url: createReportUrl('com.atlassian.jira.plugin.system.reports:pie-report'),
                    name: formatMessage((0, $93Xzy.default).pieChart)
                },
                {
                    id: 'recentlycreated-report',
                    url: createReportUrl('com.atlassian.jira.plugin.system.reports:recentlycreated-report'),
                    name: formatMessage((0, $93Xzy.default).recentlyCreatedIssues)
                },
                {
                    id: 'resolutiontime-report',
                    url: createReportUrl('com.atlassian.jira.plugin.system.reports:resolutiontime-report'),
                    name: formatMessage((0, $93Xzy.default).resolutionTime)
                },
                {
                    id: 'singlelevelgroupby',
                    url: createReportUrl('com.atlassian.jira.plugin.system.reports:singlelevelgroupby'),
                    name: formatMessage((0, $93Xzy.default).singleLevelGroup)
                },
                {
                    id: 'timesince-report',
                    url: createReportUrl('com.atlassian.jira.plugin.system.reports:timesince-report'),
                    name: formatMessage((0, $93Xzy.default).timeSinceIssues)
                }
            ]
        };
    }
    return {
        data: defaultIssueAnalysisSection,
        loading: loading,
        error: error
    };
};

});
parcelRegister("93Xzy", function(module, exports) {

$parcel$export(module.exports, "default", () => $af7783a38d48407a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $af7783a38d48407a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issueAnalysis: {
        "id": "spa-apps-sidebar-core.controllers.default-report-items.issue-analysis",
        "defaultMessage": "Issue analysis"
    },
    averageAgeReport: {
        "id": "spa-apps-sidebar-core.controllers.default-report-items.average-age-report",
        "defaultMessage": "Average Age Report"
    },
    createdResolvedIssuesReport: {
        "id": "spa-apps-sidebar-core.controllers.default-report-items.created-resolved-issues-report",
        "defaultMessage": "Created vs Resolved Issues Report"
    },
    pieChart: {
        "id": "spa-apps-sidebar-core.controllers.default-report-items.pie-chart",
        "defaultMessage": "Pie Chart Report"
    },
    recentlyCreatedIssues: {
        "id": "spa-apps-sidebar-core.controllers.default-report-items.recently-created-issues",
        "defaultMessage": "Recently Created Issues Report"
    },
    resolutionTime: {
        "id": "spa-apps-sidebar-core.controllers.default-report-items.resolution-time",
        "defaultMessage": "Resolution Time Report"
    },
    singleLevelGroup: {
        "id": "spa-apps-sidebar-core.controllers.default-report-items.single-level-group",
        "defaultMessage": "Single Level Group By Report"
    },
    timeSinceIssues: {
        "id": "spa-apps-sidebar-core.controllers.default-report-items.time-since-issues",
        "defaultMessage": "Time Since Issues Report"
    }
});

});


parcelRegister("lmMuP", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d0b546a275ef68c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7d0b546a275ef68c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    forecastAndManagement: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.forecast-and-management",
        "defaultMessage": "Forecast & management"
    },
    timeTracking: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.time-tracking",
        "defaultMessage": "Time Tracking Report"
    },
    userWorkload: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.user-workload",
        "defaultMessage": "User Workload Report"
    },
    versionWorkload: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.version-workload",
        "defaultMessage": "Version Workload Report"
    },
    workloadPieChart: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.workload-pie-chart",
        "defaultMessage": "Workload Pie Chart Report"
    },
    other: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.other",
        "defaultMessage": "Other"
    },
    itemBack: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.item-back",
        "defaultMessage": "Back to reports"
    }
});

});



parcelRegister("aZ40y", function(module, exports) {

$parcel$export(module.exports, "default", () => $578dbaa7eba68868$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8N3rk = parcelRequire("8N3rk");
var $7eyVf = parcelRequire("7eyVf");

var $exb0h = parcelRequire("exb0h");

var $10fdS = parcelRequire("10fdS");

var $lg3mT = parcelRequire("lg3mT");

var $asnZU = parcelRequire("asnZU");
var $kFwR2 = parcelRequire("kFwR2");

var $1m2Xn = parcelRequire("1m2Xn");

var $eiI3i = parcelRequire("eiI3i");
const $578dbaa7eba68868$var$EMPTY_STACK = [];
const $578dbaa7eba68868$var$adjustAppStack = (appStack)=>{
    const [first, ...other] = appStack;
    // omit the settings nesting level as we render the settings menu
    // as a top level menu in business projects
    if ((0, $lg3mT.SECTION_ID).SETTINGS === first) return other;
    return appStack;
};
const $578dbaa7eba68868$var$calculateStack = (route, connectStack, forgeStack)=>{
    // should be handled above generic PROJECT_SETTINGS_CORE logic
    if ((0, $lg3mT.FORGE_ROUTES_SET).has(route.name) && forgeStack) return $578dbaa7eba68868$var$adjustAppStack(forgeStack);
    if (route.name.includes((0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_CORE)) {
        // this is the same logic as the one in src/packages/navigation-apps/sidebar/next-gen/src/ui/menu/main.js
        const [view] = route.name.replace(`${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_CORE}-`, '').split('-');
        return view === 'issuetypes' ? [
            view
        ] : $578dbaa7eba68868$var$EMPTY_STACK;
    }
    if ((0, $exb0h.CONNECT_ROUTES_SET).has(route.name) && connectStack) return $578dbaa7eba68868$var$adjustAppStack(connectStack);
    return $578dbaa7eba68868$var$EMPTY_STACK;
};
const $578dbaa7eba68868$var$SettingsMenu = ({ project: project })=>{
    (0, $asnZU.default)();
    const route = (0, $10fdS.useCurrentRoute)();
    const { data: connectItems, stack: connectStack } = (0, $kFwR2.useProjectSettingsConnectItems)();
    const { data: forgeItems, stack: forgeStack } = (0, $kFwR2.useProjectSettingsForgeItems)((0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_CORE_FORGE_APPS, $578dbaa7eba68868$var$EMPTY_STACK);
    const ecosystemItems = (0, $eUqFw.useMemo)(()=>({
            forge: forgeItems,
            connect: connectItems
        }), [
        forgeItems,
        connectItems
    ]);
    const [stack, setStack] = (0, $eUqFw.useState)(()=>$578dbaa7eba68868$var$calculateStack(route, connectStack, forgeStack));
    (0, $eUqFw.useEffect)(()=>{
        setStack($578dbaa7eba68868$var$calculateStack(route, connectStack, forgeStack));
    }, [
        route,
        connectStack,
        forgeStack
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8N3rk.default), {
        stack: stack,
        onChange: setStack
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), null, project.isSimplified ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eiI3i.SettingsMenu), {
        stack: stack
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1m2Xn.Settings), {
        ecosystemItems: ecosystemItems
    }))));
};
var $578dbaa7eba68868$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($578dbaa7eba68868$var$SettingsMenu);

});
parcelRegister("1m2Xn", function(module, exports) {

$parcel$export(module.exports, "Settings", () => $f542bb55240ab7c0$export$c72f6eaae7b9adff);
/* eslint-disable complexity */ 
var $eUqFw = parcelRequire("eUqFw");

var $7eyVf = parcelRequire("7eyVf");
var $gLn5u = parcelRequire("gLn5u");

var $lwZcK = parcelRequire("lwZcK");

var $7ZZxN = parcelRequire("7ZZxN");

var $exb0h = parcelRequire("exb0h");

var $1ybV0 = parcelRequire("1ybV0");

var $2Rqjr = parcelRequire("2Rqjr");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fR9xM = parcelRequire("fR9xM");
var $gFuN0 = parcelRequire("gFuN0");
var $bS2FN = parcelRequire("bS2FN");
var $1UelU = parcelRequire("1UelU");
var $jFPBh = parcelRequire("jFPBh");
var $9kVcv = parcelRequire("9kVcv");
var $cPEpP = parcelRequire("cPEpP");

var $kIUmN = parcelRequire("kIUmN");

var $atb9c = parcelRequire("atb9c");

var $gF5SK = parcelRequire("gF5SK");

var $6vrw7 = parcelRequire("6vrw7");

var $8yhrX = parcelRequire("8yhrX");

var $bRhBg = parcelRequire("bRhBg");

var $7eeF2 = parcelRequire("7eeF2");
const $f542bb55240ab7c0$export$a4007dc4843ca7f6 = (0, $kIUmN.withThrowOnError)((0, $cPEpP.useProject));
const $f542bb55240ab7c0$export$154ecbb867fd48f0 = (0, $kIUmN.withThrowOnError)((0, $bRhBg.useSettingFeatures));
const $f542bb55240ab7c0$export$17eaab3b8c213998 = (0, $kIUmN.withThrowOnError)((0, $gF5SK.useNewIssueViewLockedInStatus));
const $f542bb55240ab7c0$var$NOTIFICATIONS_ROUTE_NAMES = [
    (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_CORE_NOTIFICATIONS,
    (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_CORE_NOTIFICATION_EMAIL,
    (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_NOTIFICATIONS
];
const $f542bb55240ab7c0$export$c72f6eaae7b9adff = ({ ecosystemItems: ecosystemItems })=>{
    const { data: features } = $f542bb55240ab7c0$export$154ecbb867fd48f0();
    const { data: status } = $f542bb55240ab7c0$export$17eaab3b8c213998();
    const isNewIssueViewLockedIn = status?.newIssueViewTransitionLockingStatus !== (0, $gF5SK.DEFAULT_TO_OLD_ISSUE_VIEW);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { data: project } = $f542bb55240ab7c0$export$a4007dc4843ca7f6();
    const hasDlpEnabled = (0, $8yhrX.useDlpEntitlement)();
    if (features == null || project == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9kVcv.TitleHeader), null, formatMessage((0, $7eeF2.default).projectSettings)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), null, features.hasDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'details'
        },
        selectedOn: [
            (0, $1ybV0.ff)('hix-4818-adopt-modern-project-details-page-across-all-products_3zvy1') ? (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_CORE_DETAILS : (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_EDIT
        ],
        href: (0, $1ybV0.ff)('hix-4818-adopt-modern-project-details-page-across-all-products_3zvy1') ? `/jira/core/projects/${project.key}/settings/details` : `/secure/project/EditProject!default.jspa?pid=${project.id}`
    }, formatMessage((0, $7eeF2.default).details)), features.hasPeople && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'people'
        },
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        href: `/plugins/servlet/project-config/${project.key}/people`
    }, formatMessage((0, $7eeF2.default).people)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jFPBh.SpotlightTarget), {
        name: "spotlight-sidebar-project-automation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'automation'
        },
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        href: (0, $lwZcK.getBaseAutomationUrl)({
            isSimplified: project.isSimplified,
            projectKey: (0, $6vrw7.toProjectKey)(project.key),
            projectType: (0, $7ZZxN.CORE_PROJECT)
        })
    }, formatMessage((0, $7eeF2.default).automation))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fR9xM.EngagementSpotlight), {
        engagementId: "spotlight-sidebar-project-automation"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gFuN0.FireUiAnalytics), {
        actionSubject: "automationNavigationItem",
        action: "viewed"
    })), features.hasSummary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'summary'
        },
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        href: `/plugins/servlet/project-config/${project.key}/summary`
    }, formatMessage((0, $7eeF2.default).summary))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        hasSeparator: features.hasIssueConfigSection || isNewIssueViewLockedIn || (0, $1ybV0.ff)('proforma-mvp-jwm-project-settings_5edja')
    }, features.hasIssueTypes && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        analytics: {
            itemId: 'issue-types'
        },
        href: `/plugins/servlet/project-config/${project.key}/issuetypes`
    }, formatMessage((0, $7eeF2.default).issueTypes)), isNewIssueViewLockedIn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        analytics: {
            itemId: 'issue-layout'
        },
        href: `/plugins/servlet/project-config/${project.key}/issuelayout`
    }, formatMessage((0, $7eeF2.default).issueLayout)), (0, $1ybV0.ff)('proforma-mvp-jwm-project-settings_5edja') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'proforma-forms'
        },
        href: `/jira/core/projects/${project.key}/settings/forms`,
        selectedOn: [
            (0, $exb0h.ROUTE_NAMES).CLASSIC_PROJECT_SETTINGS_CORE_PROFORMA_FORMS
        ]
    }, formatMessage((0, $7eeF2.default).forms))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        hasSeparator: features.hasProjectGroupTwoSection
    }, features.hasWorkflows && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        analytics: {
            itemId: 'workflows'
        },
        href: `/plugins/servlet/project-config/${project.key}/workflows`
    }, formatMessage((0, $7eeF2.default).workflows)), features.hasScreens && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        analytics: {
            itemId: 'screens'
        },
        href: `/plugins/servlet/project-config/${project.key}/screens`
    }, formatMessage((0, $7eeF2.default).screens)), features.hasFields && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        analytics: {
            itemId: 'fields'
        },
        href: `/plugins/servlet/project-config/${project.key}/fields`
    }, formatMessage((0, $7eeF2.default).fields))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        hasSeparator: features.hasProjectGroupThreeSection
    }, features.hasVersions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        selectedOn: [
            (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_VERSIONS
        ],
        analytics: {
            itemId: 'versions'
        },
        href: `/plugins/servlet/project-config/${project.key}/administer-versions`
    }, formatMessage((0, $7eeF2.default).versions)), features.hasComponents && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        selectedOn: [
            (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_COMPONENTS
        ],
        analytics: {
            itemId: 'components'
        },
        href: `/plugins/servlet/project-config/${project.key}/administer-components`
    }, formatMessage((0, $7eeF2.default).components))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        hasSeparator: features.hasProjectGroupFourSection
    }, features.hasPermissions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        analytics: {
            itemId: 'permissions'
        },
        href: `/plugins/servlet/project-config/${project.key}/permissions`
    }, formatMessage((0, $7eeF2.default).permissions)), features.hasIssueSecurity && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        analytics: {
            itemId: 'issue-security'
        },
        href: `/plugins/servlet/project-config/${project.key}/issuesecurity`
    }, formatMessage((0, $7eeF2.default).issueSecurity)), features.hasNotifications && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        selectedOn: $f542bb55240ab7c0$var$NOTIFICATIONS_ROUTE_NAMES,
        analytics: {
            itemId: 'notifications'
        },
        href: `/plugins/servlet/project-config/${project.key}/notifications`
    }, formatMessage((0, $7eeF2.default).notifications)), features.hasDevtools && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        analytics: {
            itemId: 'devtools'
        },
        href: `/secure/ConfigureDevStatus.jspa?projectKey=${project.key}`
    }, formatMessage((0, $7eeF2.default).devtools))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        hasSeparator: features.hasgetIssueCollectorSection
    }, features.hasIssueCollectors && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        selectedOn: [
            (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_SETTINGS_COLLECTORS
        ],
        analytics: {
            itemId: 'issue-collectors'
        },
        href: `/secure/ViewCollectors!default.jspa?projectKey=${project.key}`
    }, formatMessage((0, $7eeF2.default).issueCollectors))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atb9c.default), {
        hasSeparator: true,
        items: ecosystemItems,
        forgeModule: (0, $2Rqjr.PROJECT_SETTINGS_PAGE_MODULE),
        overrides: {
            BackMenuItem: {
                href: `/plugins/servlet/project-config/${project.key}`,
                title: formatMessage((0, $7eeF2.default).itemBack)
            }
        }
    }), hasDlpEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'data-classifications'
        },
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        href: `/plugins/servlet/project-config/${project.key}/data-classifications`
    }, formatMessage((0, $7eeF2.default).dataClassificationsNonFinal))));
};

});
parcelRegister("lwZcK", function(module, exports) {

$parcel$export(module.exports, "getBaseAutomationUrl", () => $c220e0172ef405d3$export$8e479e490e1e69bc);
const $c220e0172ef405d3$export$8e479e490e1e69bc = ({ projectKey: projectKey, projectType: projectType, isSimplified: isSimplified })=>{
    /**
	 * Confusing mapping of urls here.
	 * Classic Projects - always under /automate
	 * Next Gen Projects - under /automation for all project types except JSD
	 */ if (projectType === 'service_desk') return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
    if (projectType === 'business') return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
};

});

parcelRegister("fR9xM", function(module, exports) {

$parcel$export(module.exports, "EngagementSpotlight", () => $56d259c5c8dc2f0b$export$f14689466e4eca7a);

var $eUqFw = parcelRequire("eUqFw");

var $aBT3I = parcelRequire("aBT3I");

var $ekN4Q = parcelRequire("ekN4Q");

var $16WDb = parcelRequire("16WDb");
const $56d259c5c8dc2f0b$export$f14689466e4eca7a = (0, $16WDb.withNestingOptimisation)(({ engagementId: engagementId })=>{
    const isFullyExpanded = (0, $ekN4Q.useIsFullyExpanded)();
    return isFullyExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aBT3I.EngagementSpotlight), {
        engagementId: engagementId
    });
});

});

parcelRegister("gFuN0", function(module, exports) {

$parcel$export(module.exports, "FireUiAnalytics", () => $e57e9331bc8bc1d3$export$5a67e7291fd4569e);

var $d6f6c = parcelRequire("d6f6c");

var $16WDb = parcelRequire("16WDb");
const $e57e9331bc8bc1d3$export$5a67e7291fd4569e = (0, $16WDb.withNestingOptimisation)((0, $d6f6c.FireUiAnalytics));

});

parcelRegister("jFPBh", function(module, exports) {

$parcel$export(module.exports, "SpotlightTarget", () => $022d6d24d0c2da0b$export$e29577842f211e22);

var $eUqFw = parcelRequire("eUqFw");

var $ltfxy = parcelRequire("ltfxy");

var $16WDb = parcelRequire("16WDb");
const $022d6d24d0c2da0b$var$SpotlightTargetWrapper = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-test-id": `ak-spotlight-target-${props.name}`
    }, children));
const $022d6d24d0c2da0b$export$e29577842f211e22 = (0, $16WDb.withNestingOptimisation)($022d6d24d0c2da0b$var$SpotlightTargetWrapper);

});

parcelRegister("atb9c", function(module, exports) {

$parcel$export(module.exports, "default", () => $21ea6e374e29cd9c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1boRu = parcelRequire("1boRu");

var $1boRu = parcelRequire("1boRu");

var $hRcYT = parcelRequire("hRcYT");

var $9ui8T = parcelRequire("9ui8T");

var $fDNHa = parcelRequire("fDNHa");

var $l3JmK = parcelRequire("l3JmK");
const $21ea6e374e29cd9c$export$66569e9b4a285b16 = ({ items: items, overrides: overrides, showIcons: showIcons = false, shouldFilter: shouldFilter = true, submenuId: submenuId = '', nestedMenuActive: nestedMenuActive = true })=>{
    const forgeItems = (0, $eUqFw.useMemo)(()=>items.forge || [], [
        items.forge
    ]);
    const connectItems = (0, $9ui8T.useFilteredItems)(items.connect, shouldFilter);
    const sortedItems = (0, $eUqFw.useMemo)(()=>[
            ...forgeItems.map((item)=>({
                    type: 'forge',
                    item: item
                })),
            ...connectItems.map((item)=>({
                    type: 'connect',
                    item: item
                }))
        ].sort((a, b)=>a.item.name.localeCompare(b.item.name)), [
        connectItems,
        forgeItems
    ]);
    if (!sortedItems.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, sortedItems.map(({ type: type, item: item }, index)=>{
        if (type === 'forge') {
            // @ts-expect-error - TS2322 - Type 'ConnectDataItem | ForgeItemProps' is not assignable to type 'ForgeProjectSettingsItem'.
            const forgeItem = item;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l3JmK.ForgeItem), {
                key: forgeItem.id,
                ...forgeItem,
                overrides: overrides,
                showIcon: showIcons,
                nestedMenuActive: nestedMenuActive
            });
        }
        const connectItem = item;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fDNHa.ConnectItem), {
            item: connectItem,
            key: connectItem.id,
            index: index,
            overrides: overrides,
            showIcons: showIcons,
            submenuId: submenuId
        });
    }), forgeItems.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeScreenEvent), null) : null);
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$21ea6e374e29cd9c$export$2e2bcd8739ae039 = ({ forgeModule: forgeModule, ...restProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: forgeModule,
        moduleType: (0, $hRcYT.MODULE_TYPE_TRIGGER)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($21ea6e374e29cd9c$export$66569e9b4a285b16, restProps));

});

parcelRegister("8yhrX", function(module, exports) {

$parcel$export(module.exports, "useDlpEntitlement", () => $e16f91d64a0cd31a$export$4472465702535e7);

var $gd0Sp = parcelRequire("gd0Sp");
const $e16f91d64a0cd31a$export$4472465702535e7 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.hasDlpEnabled || false;
};

});

parcelRegister("7eeF2", function(module, exports) {

$parcel$export(module.exports, "default", () => $3728eeca46b17d68$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3728eeca46b17d68$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    projectSettings: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.project-settings",
        "defaultMessage": "Project settings"
    },
    details: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.details",
        "defaultMessage": "Details"
    },
    people: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.people",
        "defaultMessage": "People"
    },
    summary: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.summary",
        "defaultMessage": "Summary"
    },
    deleteProject: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.delete-project",
        "defaultMessage": "Delete project"
    },
    issueTypes: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.issue-types",
        "defaultMessage": "Issue types"
    },
    issueLayout: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.issue-layout",
        "defaultMessage": "Issue layout"
    },
    workflows: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.workflows",
        "defaultMessage": "Workflows"
    },
    screens: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.screens",
        "defaultMessage": "Screens"
    },
    fields: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.fields",
        "defaultMessage": "Fields"
    },
    versions: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.versions",
        "defaultMessage": "Versions"
    },
    components: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.components",
        "defaultMessage": "Components"
    },
    permissions: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.permissions",
        "defaultMessage": "Permissions"
    },
    issueSecurity: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.issue-security",
        "defaultMessage": "Issue security"
    },
    notifications: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.notifications",
        "defaultMessage": "Notifications"
    },
    notificationsEmail: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.notifications-email",
        "defaultMessage": "Notification email"
    },
    hipChat: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.hip-chat",
        "defaultMessage": "HipChat integration"
    },
    issueCollectors: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.issue-collectors",
        "defaultMessage": "Issue collectors"
    },
    new: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.new",
        "defaultMessage": "New"
    },
    itemBack: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.item-back",
        "defaultMessage": "Back to project settings"
    },
    automation: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.automation",
        "defaultMessage": "Automation"
    },
    devtools: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.devtools",
        "defaultMessage": "Development tools"
    },
    forms: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.forms",
        "defaultMessage": "Advanced Forms"
    },
    dataClassificationsNonFinal: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.data-classifications-non-final",
        "defaultMessage": "Data classification"
    }
});

});


parcelRegister("eiI3i", function(module, exports) {

$parcel$export(module.exports, "SettingsMenu", () => $c096d087fddf630b$export$1d7840d5cdc861d5);

var $eUqFw = parcelRequire("eUqFw");

var $7eyVf = parcelRequire("7eyVf");
var $gLn5u = parcelRequire("gLn5u");

var $7ZZxN = parcelRequire("7ZZxN");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3SvNA = parcelRequire("3SvNA");
var $bS2FN = parcelRequire("bS2FN");
var $1UelU = parcelRequire("1UelU");
var $2DHQu = parcelRequire("2DHQu");
var $b7Flp = parcelRequire("b7Flp");
var $9kVcv = parcelRequire("9kVcv");
var $cPEpP = parcelRequire("cPEpP");

var $kIUmN = parcelRequire("kIUmN");

var $cqJw8 = parcelRequire("cqJw8");

var $7czSC = parcelRequire("7czSC");

var $f26dB = parcelRequire("f26dB");

var $fz8wa = parcelRequire("fz8wa");
var $8yhrX = parcelRequire("8yhrX");

var $lg3mT = parcelRequire("lg3mT");

var $g7sKB = parcelRequire("g7sKB");
var $eqBMI = parcelRequire("eqBMI");

var $7ugdf = parcelRequire("7ugdf");

var $f4Fss = parcelRequire("f4Fss");
const $c096d087fddf630b$export$a4007dc4843ca7f6 = (0, $kIUmN.withThrowOnError)((0, $cPEpP.useProject));
const $c096d087fddf630b$export$c72f6eaae7b9adff = ({ stack: stack })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { data: project } = $c096d087fddf630b$export$a4007dc4843ca7f6();
    const { hasCoreAccess: hasCoreAccess } = (0, $fz8wa.useApplicationPermissions)();
    const hasDlpEnabled = (0, $8yhrX.useDlpEntitlement)();
    const isPremiumUserSeat = (0, $f26dB.useIsPremiumUserSeat)();
    const [{ data: connectAppsData }, { fetch: fetchConnectApps }] = (0, $7czSC.useConnectApps)();
    // to remove on isAppControlsEnabled() cleanup
    (0, $eUqFw.useEffect)(()=>{
        if (project && !connectAppsData) fetchConnectApps(project.key);
    }, [
        connectAppsData,
        fetchConnectApps,
        project
    ]);
    if (project == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null);
    const baseSettingsUrl = (0, $cqJw8.getNextgenSettingsUrl)((0, $7ZZxN.CORE_PROJECT), project.key);
    const showCoreForms = (0, $1ybV0.ff)('proforma-mvp-jwm-project-settings_5edja') && hasCoreAccess;
    const BackMenuItem = {
        href: baseSettingsUrl,
        title: formatMessage((0, $f4Fss.messages).title)
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9kVcv.TitleHeader), null, formatMessage((0, $f4Fss.messages).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'details'
        },
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        href: `${baseSettingsUrl}/details`
    }, formatMessage((0, $f4Fss.messages).itemDetails)), hasCoreAccess && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'access'
        },
        href: `${baseSettingsUrl}/access`,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $f4Fss.messages).itemAccess)), hasCoreAccess && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'notifications'
        },
        href: `${baseSettingsUrl}/notifications`,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $f4Fss.messages).itemNotifications)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'automation'
        },
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        href: `${baseSettingsUrl}/automation`
    }, formatMessage((0, $f4Fss.messages).automation)), (0, $b7Flp.shouldRenderNesting)(hasCoreAccess, stack, (0, $lg3mT.SECTION_ID).ISSUE_TYPES) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2DHQu.NestingMenuItem), {
        analytics: {
            itemId: 'issuetypes'
        },
        href: `${baseSettingsUrl}/issuetypes`,
        id: (0, $lg3mT.SECTION_ID).ISSUE_TYPES,
        overrides: {
            BackMenuItem: BackMenuItem
        },
        title: formatMessage((0, $f4Fss.messages).itemIssueTypes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ugdf.IssueTypes), null)), isPremiumUserSeat && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'approvals'
        },
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        href: `${baseSettingsUrl}/approvals`
    }, formatMessage((0, $f4Fss.messages).itemApprovals)), showCoreForms && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'proforma-forms'
        },
        selectedOn: (0, $bS2FN.matchUrlPathname)(),
        href: `${baseSettingsUrl}/forms`
    }, formatMessage((0, $f4Fss.messages).itemAdvancedForms)), (0, $b7Flp.shouldRenderNesting)(hasCoreAccess, stack, 'apps') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3SvNA.ExpandableSubmenuItem), {
        analytics: {
            itemId: 'apps'
        },
        menuItemLabel: formatMessage((0, $eqBMI.messages).apps),
        forceExpand: true,
        submenuId: "nextgen-apps-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g7sKB.EcosystemAppsMenu), null)), hasDlpEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'data-classification'
        },
        href: `${baseSettingsUrl}/data-classifications`,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $f4Fss.messages).dataClassificationNonFinal))));
};
const $c096d087fddf630b$export$1d7840d5cdc861d5 = (props)=>{
    const { data: project } = $c096d087fddf630b$export$a4007dc4843ca7f6();
    if (project == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null);
    return(// to remove on isAppControlsEnabled() cleanup
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7czSC.ConnectAppsContainer), {
        baseUrl: "",
        onError: undefined,
        scope: project.key
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c096d087fddf630b$export$c72f6eaae7b9adff, props)));
};

});
parcelRegister("3SvNA", function(module, exports) {

$parcel$export(module.exports, "ExpandableSubmenuItem", () => $df73afd5d0671194$export$16ba9a3b96f3ac6d);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $aqZcy = parcelRequire("aqZcy");
var $5RTd0 = parcelRequire("5RTd0");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $aipcc = parcelRequire("aipcc");

var $1UelU = parcelRequire("1UelU");
const $df73afd5d0671194$var$defaultExpandMenuState = {
    submenuActive: false,
    expanded: false
};
const $df73afd5d0671194$var$useExpandableMenuStates = ()=>{
    const getExpandableState = (submenuId)=>{
        const cookieData = (0, $aqZcy.getCookie)(`jira.navigation.expandableMenuStates.${submenuId}`);
        let parsedCookieData = null;
        try {
            // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
            parsedCookieData = JSON.parse(cookieData);
        } catch  {
            // Rather than throw an error - just set the default state
            parsedCookieData = $df73afd5d0671194$var$defaultExpandMenuState;
        }
        return parsedCookieData;
    };
    const setExpandedState = (submenuId, newExpandedState)=>{
        if (submenuId != null) (0, $5RTd0.setStrictlyNecessaryCookie)(`jira.navigation.expandableMenuStates.${submenuId}`, JSON.stringify(newExpandedState));
    };
    return {
        getExpandableState: getExpandableState,
        setExpandedState: setExpandedState
    };
};
const $df73afd5d0671194$export$16ba9a3b96f3ac6d = ({ children: children, analytics: analytics, iconBefore: iconBefore = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null), menuItemLabel: menuItemLabel, expandButtonLabel: expandButtonLabel = 'expand', href: href, useButtonLink: useButtonLink = false, forceExpand: forceExpand = false, forceCollapse: forceCollapse = false, noListStyle: noListStyle = false, submenuId: submenuId = '', testId: testId = '' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { getExpandableState: getExpandableState, setExpandedState: setExpandedState } = $df73afd5d0671194$var$useExpandableMenuStates();
    const [subMenuActive, setSubMenuActive] = (0, $eUqFw.useState)(false);
    const [currentCookieData] = (0, $eUqFw.useState)(getExpandableState(submenuId));
    const expandButtonId = menuItemLabel.replace(/ /g, '-').toLowerCase();
    const [expanded, setExpanded] = (0, $eUqFw.useState)(currentCookieData?.expanded || false);
    const expandableMenuItemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (forceExpand) setExpanded(true);
        if (forceCollapse) setExpanded(false);
    }, [
        forceExpand,
        forceCollapse
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (currentCookieData?.expanded) {
            setExpanded(currentCookieData.expanded);
            setSubMenuActive(currentCookieData.submenuActive);
        }
    }, [
        currentCookieData
    ]);
    const onClick = (0, $eUqFw.useCallback)(()=>{
        if (submenuId != null) setExpandedState(submenuId, {
            submenuActive: false,
            expanded: !expanded
        });
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'expandButton changed', 'projectSettings', {
            expandMenuId: analytics?.itemId,
            expanded: !expanded
        });
        setExpanded(!expanded);
        requestAnimationFrame(()=>{
            expandableMenuItemRef?.current?.focus();
        });
    }, [
        analytics,
        createAnalyticsEvent,
        expanded,
        setExpandedState,
        submenuId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($df73afd5d0671194$var$ExpandableSubmenuWrapper, {
        isExpanded: subMenuActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: analytics,
        href: href,
        useButtonLink: useButtonLink,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aipcc.ExpandButton), {
            id: expandButtonId,
            label: expandButtonLabel,
            isActive: true,
            isExpanded: expanded,
            size: "medium"
        }), iconBefore),
        onClick: onClick,
        "data-test-id": testId,
        ref: expandableMenuItemRef,
        tabIndex: -1
    }, menuItemLabel), expanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($df73afd5d0671194$var$ExpandableSubmenuItemWrapper, {
        noListStyle: noListStyle
    }, children));
};
// Buttons inside the Expandable Menu indicate sub-expandable menus,
// these are styled differently that top level expandable menu items so the aligment look ok
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df73afd5d0671194$var$ExpandableSubmenuWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isExpanded: isExpanded, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_hstcidpf _11lvidpf _44p6idpf _l7mvidpf _1gid5cnj _1t1q5cnj _qmbb5cnj _130y5cnj _cyds5cnj _wpy85cnj _da5j5cnj _14p45cnj _r3xj5cnj _1p1m5cnj _12kz5cnj _67om5cnj _1gw75cnj _1rnb5cnj _vxqc5cnj _1ve95cnj _1qslpxbi _16khpxbi _ek7jpxbi _1mdfpxbi _1mp8pxbi _40k9pxbi _15e4pxbi _3hrxpxbi _erbmpxbi _5vm1pxbi _1e43pxbi _f4s1pxbi _1fabpxbi _da52pxbi _1aolpxbi _qdxopxbi _zyjmqslr _4rtsqslr _1bb1qslr _gis0qslr _19ixqslr _qbnnqslr _ii9vqslr _176zqslr _qylaqslr _1xqvqslr _uzbcqslr _1ifwqslr _i6ubqslr _1u1wqslr _1ks5qslr _329dqslr _fe5pidpf _kywyt94y",
            __cmplp.isExpanded && "_4t3i1osq",
            __cmplp.className
        ])
    });
});
const $df73afd5d0671194$var$ExpandableSubmenuItemWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _18u0r5cr _ujmh1osq _1nx0u2gc _hstcidpf _fgl3wgn3 _fl8b12x7 _9b588aae _14tk72c6 _1u1didpf _1thcforw _19as19el _kk3x126e _14o4107n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aipcc", function(module, exports) {

$parcel$export(module.exports, "ExpandButton", () => $654b7872966b947d$export$5663c8f5aeb8c1c4);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $86Ndv = parcelRequire("86Ndv");

var $dtaN9 = parcelRequire("dtaN9");

var $PdmhA = parcelRequire("PdmhA");
const $654b7872966b947d$export$5663c8f5aeb8c1c4 = ({ id: id, label: label, isActive: isActive, isExpanded: isExpanded, onClick: onClick = ()=>null, size: size, isVisible: isVisible = true, removeCaret: removeCaret = false, tabIndex: // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'number'.
tabIndex = null })=>{
    const Chevron = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))) : (0, (/*@__PURE__*/$parcel$interopDefault($dtaN9)));
    const onKeydown = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type.
    (event)=>{
        // Space bar or enter (Button A11y rules) triggers click of expand button
        if ([
            13,
            32
        ].includes(event.keyCode)) {
            event.preventDefault();
            onClick();
        }
    }, [
        onClick
    ]);
    const chevronElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Chevron, {
        testId: `sidebar.expand-button.container-${id}`,
        primaryColor: `var(--ds-icon, ${(0, $PdmhA.N500)})`,
        label: label,
        size: size
    });
    // Performance optimisation - only render interactive button upon proxy interactions
    if (!isActive) return chevronElement;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($654b7872966b947d$var$Container, {
        role: "button",
        "aria-expanded": isExpanded,
        onClick: onClick,
        onKeyDown: onKeydown,
        isVisible: isVisible,
        removeCaret: removeCaret,
        size: size,
        tabIndex: tabIndex
    }, chevronElement);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $654b7872966b947d$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisible: isVisible, removeCaret: removeCaret, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _4t3i1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itglyw _bfhk18uv _80omtlke _16jlidpf _1o9zidpf _i0dl1wug _12ji1r31 _1qu2glyw _12y31o36 _v5641mqx _1spjglyw _1ejj12vo _19lvkb7n",
            __cmplp.size === 'medium' ? "_154imyb0" : "_154iidpf",
            __cmplp.isVisible ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.removeCaret ? "_1e0cglyw" : "_1e0c1txw",
            __cmplp.className
        ])
    });
});

});


parcelRegister("7czSC", function(module, exports) {

$parcel$export(module.exports, "ConnectAppsSubscriber", () => $e3deff51daf35120$export$2646f920b0e2e4de);
$parcel$export(module.exports, "useConnectApps", () => $e3deff51daf35120$export$4864478dcab77643);
$parcel$export(module.exports, "ConnectAppsContainer", () => $e3deff51daf35120$export$ac845603c8c91acd);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $dYfll = parcelRequire("dYfll");

var $687k4 = parcelRequire("687k4");
const $e3deff51daf35120$export$2646f920b0e2e4de = (0, $dYfll.createSubscriber)((0, $687k4.default), {
    displayName: 'ConnectAppsSubscriber'
});
const $e3deff51daf35120$export$4864478dcab77643 = (0, $ggKAj.createHook)((0, $687k4.default));
const $e3deff51daf35120$export$ac845603c8c91acd = (0, $heB5U.createContainer)((0, $687k4.default));

});
parcelRegister("687k4", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c48d4b6f412e815$export$2e2bcd8739ae039);

var $a61MH = parcelRequire("a61MH");

var $h3kcT = parcelRequire("h3kcT");
const $6c48d4b6f412e815$export$d4c72bab9d6cc13a = {
    data: null,
    loading: false,
    error: null,
    hasFirstError: false
};
var $6c48d4b6f412e815$export$2e2bcd8739ae039 = (0, $a61MH.createStore)({
    name: 'connect-apps',
    initialState: $6c48d4b6f412e815$export$d4c72bab9d6cc13a,
    actions: $h3kcT.actions
});

});
parcelRegister("h3kcT", function(module, exports) {

$parcel$export(module.exports, "actions", () => $fda0cfe4b5bc8c12$export$e324594224ef24da);

var $cxnOv = parcelRequire("cxnOv");
const $fda0cfe4b5bc8c12$export$e324594224ef24da = {
    fetch: $cxnOv.default
};

});
parcelRegister("cxnOv", function(module, exports) {

$parcel$export(module.exports, "default", () => $128f0df4723431a5$export$2e2bcd8739ae039);

var $kjsaR = parcelRequire("kjsaR");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$128f0df4723431a5$export$2e2bcd8739ae039 = (projectKey)=>async ({ setState: setState, getState: getState }, { baseUrl: baseUrl, onError: onError })=>{
        const currentState = getState();
        if (!projectKey || currentState.loading) return;
        setState({
            loading: true,
            error: null
        });
        try {
            const data = await (0, $kjsaR.default)(baseUrl, projectKey);
            setState({
                data: data,
                loading: false,
                error: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            const { hasFirstError: hasFirstError, data: data } = getState();
            // It's the first error if it does not already have a first error and there is no data currently in state
            const isFirstError = !hasFirstError && data === null;
            setState({
                error: err,
                loading: false,
                hasFirstError: hasFirstError || isFirstError
            });
            if (onError) onError(isFirstError);
        }
    };

});
parcelRegister("kjsaR", function(module, exports) {

$parcel$export(module.exports, "default", () => $597ccf12213f1d63$export$2e2bcd8739ae039);

var $2OdyW = parcelRequire("2OdyW");

var $6ZTsa = parcelRequire("6ZTsa");

var $ft7kU = parcelRequire("ft7kU");

var $6Dpx1 = parcelRequire("6Dpx1");
const $597ccf12213f1d63$export$43bc37ac3360968f = (baseUrl, projectKey)=>`${baseUrl}/rest/internal/2/connectprojectconfig/${projectKey}`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$597ccf12213f1d63$export$2e2bcd8739ae039 = (baseUrl, projectKey)=>{
    const fetchPromise = (0, $ft7kU.famaCatchAndLogFetchError)((0, $2OdyW.default)($597ccf12213f1d63$export$43bc37ac3360968f(baseUrl, projectKey)), (0, $6Dpx1.PACKAGE_NAME), (0, $6ZTsa.toErrorId)('getConnectApps'), (0, $6ZTsa.toErrorMessage)('Failed to fetch connect apps for a project'));
    return fetchPromise.then((response)=>response.map((app)=>{
            // Server returns JSON as a string inside JSON as a string inside JSON as a string because reasons.
            // Let's parse it here
            const options = JSON.parse(app.iframe.options);
            const myApp = {
                title: app.title,
                id: options.uniqueKey,
                connectIframeProps: {
                    addon_key: app.iframe.addonKey,
                    key: app.iframe.moduleKey,
                    url: options.url,
                    options: {
                        ...options,
                        productContext: JSON.parse(options.productCtx),
                        structuredContext: JSON.parse(options.structuredContext),
                        user: {
                            uid: options.uid,
                            ukey: options.ukey,
                            timeZone: options.timeZone
                        }
                    }
                }
            };
            return myApp;
        }));
};

});
parcelRegister("ft7kU", function(module, exports) {

$parcel$export(module.exports, "famaCatchAndLogFetchError", () => $9e0e185518348035$export$c3948fffb56ff7bb);
$parcel$export(module.exports, "default", () => $9e0e185518348035$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $7byHA = parcelRequire("7byHA");

var $avawr = parcelRequire("avawr");
const $9e0e185518348035$var$HTTP_LOCATION = 'project-settings-apps.http.catch-and-log-fetch-error';
const $9e0e185518348035$var$getStatusCodeGroup = (error)=>{
    if (error instanceof (0, $7byHA.default)) {
        const { statusCode: statusCode } = error;
        if (statusCode >= 100 && statusCode <= 199) return '1xx';
        if (statusCode >= 300 && statusCode <= 399) return '3xx';
        if (statusCode >= 400 && statusCode <= 499) return '4xx';
        if (statusCode >= 500 && statusCode <= 599) return '5xx';
    }
    if (error instanceof (0, $7byHA.ValidationError)) return '4xx';
    return 'unknown';
};
/**
 * All fetch calls made in project-settings should be wrapped by this method to ensure HTTP related errors can be
 * separated from JS errors in Splunk. The promise provided to this method MUST NOT perform any logic beside making
 * the fetch call (i.e. transforming responses). The caught error will be rethrown so any downstream methods can perform
 * their own error handling.
 *
 * @param promise Promise to wrap so any errors are caught and logged.
 * @param message Message to include in the log. This should provide context as to what action the user was taking.
 */ const $9e0e185518348035$var$catchAndLogFetchError = (promise, message)=>promise.catch((error)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData($9e0e185518348035$var$HTTP_LOCATION, message, error);
        throw error;
    });
const $9e0e185518348035$export$c3948fffb56ff7bb = (promise, packageName, errorId, message)=>promise.catch((error)=>{
        const statusCodeGroup = $9e0e185518348035$var$getStatusCodeGroup(error);
        (0, $avawr.logError)(packageName, errorId, message, error, {
            http: true,
            statusCodeGroup: statusCodeGroup
        });
        throw error;
    });
var $9e0e185518348035$export$2e2bcd8739ae039 = $9e0e185518348035$var$catchAndLogFetchError;

});

parcelRegister("6Dpx1", function(module, exports) {

$parcel$export(module.exports, "APP_ID", () => $f767aa89c33c344c$export$d76071d5de2774fc);
$parcel$export(module.exports, "PACKAGE_NAME", () => $f767aa89c33c344c$export$b8b9d90f9e5bd72b);

var $6bYiA = parcelRequire("6bYiA");
const $f767aa89c33c344c$export$d76071d5de2774fc = 'project-settings/connect-apps';
const $f767aa89c33c344c$export$b8b9d90f9e5bd72b = (0, $6bYiA.toPackageName)('jiraProjectSettingsAppsConnectApps');

});






parcelRegister("g7sKB", function(module, exports) {

$parcel$export(module.exports, "EcosystemAppsMenu", () => $bc220bff2b37181b$export$e583660e6ee09caf);

var $eUqFw = parcelRequire("eUqFw");

var $gLn5u = parcelRequire("gLn5u");

var $7ZZxN = parcelRequire("7ZZxN");

var $1boRu = parcelRequire("1boRu");

var $7Xoh5 = parcelRequire("7Xoh5");

var $2Rqjr = parcelRequire("2Rqjr");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bS2FN = parcelRequire("bS2FN");
var $1UelU = parcelRequire("1UelU");
var $cPEpP = parcelRequire("cPEpP");

var $l3JmK = parcelRequire("l3JmK");

var $j65a5 = parcelRequire("j65a5");

var $cqJw8 = parcelRequire("cqJw8");

var $7czSC = parcelRequire("7czSC");

var $lg3mT = parcelRequire("lg3mT");

var $eqBMI = parcelRequire("eqBMI");
const $bc220bff2b37181b$export$c62cfdba33f43c7e = ({ baseSettingsUrl: baseSettingsUrl = '', projectKey: projectKey })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ data: connectAppsData, loading: connectLoading }] = (0, $7czSC.useConnectApps)();
    const { data: forgeApps, loading: forgeLoading } = (0, $j65a5.useProjectSettingsForgeAppsForMenu)();
    const filteredConnectAppsData = (0, $eUqFw.useMemo)(()=>connectAppsData?.filter((app)=>app?.connectIframeProps?.addon_key !== (0, $lg3mT.JIRA_AUTOMATION_ADDON_KEY)), [
        connectAppsData
    ]);
    const sortedApps = (0, $eUqFw.useMemo)(()=>[
            ...(forgeApps || []).map((app)=>({
                    type: 'forge',
                    name: app.name,
                    app: app
                })),
            ...(filteredConnectAppsData || []).map((app)=>({
                    type: 'connect',
                    name: app.title,
                    app: app
                }))
        ].sort((a, b)=>a.name.localeCompare(b.name)), [
        forgeApps,
        filteredConnectAppsData
    ]);
    const overrides = (0, $eUqFw.useMemo)(()=>({
            BackMenuItem: {
                href: `/jira/core/projects/${projectKey}/settings`,
                title: formatMessage((0, $eqBMI.messages).backItem),
                onClick: (ev)=>ev.preventDefault()
            }
        }), [
        projectKey,
        formatMessage
    ]);
    if (connectLoading || forgeLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLn5u.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
        analytics: {
            itemId: 'app-fields'
        },
        href: `${baseSettingsUrl}/apps/app-fields`,
        selectedOn: (0, $bS2FN.matchUrlPathname)()
    }, formatMessage((0, $eqBMI.messages).appFields)), sortedApps.map((ecosystemItem)=>{
        const { type: type, app: app } = ecosystemItem;
        if (type === 'forge') {
            const item = app;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l3JmK.ForgeItem), {
                key: item.id,
                ...item,
                showIcon: false,
                overrides: overrides
            });
        }
        const connectApp = app;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
            analytics: {
                itemId: connectApp.id
            },
            key: connectApp.id,
            href: `${baseSettingsUrl}/apps/${connectApp.id}`,
            selectedOn: (0, $bS2FN.matchUrlPathname)()
        }, connectApp.title);
    }), forgeApps?.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $2Rqjr.PROJECT_SETTINGS_PAGE_MODULE)
        }
    }) : null);
};
const $bc220bff2b37181b$export$e583660e6ee09caf = (props)=>{
    const { children: children } = props;
    const { data: project } = (0, $cPEpP.useProject)();
    const projectKey = project && project.key || ''; // flow
    const baseSettingsUrl = (0, $cqJw8.getNextgenSettingsUrl)((0, $7ZZxN.CORE_PROJECT), projectKey);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Xoh5.TriggerAnalyticsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7czSC.ConnectAppsContainer), {
        baseUrl: "",
        onError: undefined,
        scope: projectKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bc220bff2b37181b$export$c62cfdba33f43c7e, {
        baseSettingsUrl: baseSettingsUrl,
        projectKey: projectKey
    }), children != null && children));
};

});
parcelRegister("7Xoh5", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $8ad441f9c3783975$export$c794eb4124961145);
$parcel$export(module.exports, "TriggerAnalyticsWrapper", () => $8ad441f9c3783975$export$e1a79e3d472c925a);

var $eUqFw = parcelRequire("eUqFw");

var $2Rqjr = parcelRequire("2Rqjr");

var $1boRu = parcelRequire("1boRu");

var $hRcYT = parcelRequire("hRcYT");
const $8ad441f9c3783975$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.PROJECT_SETTINGS_PAGE_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
const $8ad441f9c3783975$export$e1a79e3d472c925a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.PROJECT_SETTINGS_PAGE_MODULE),
        moduleType: (0, $hRcYT.MODULE_TYPE_TRIGGER),
        ...props
    });

});

parcelRegister("eqBMI", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3a385b1f82c0fdb0$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $3a385b1f82c0fdb0$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    apps: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.ecosystem-apps.apps",
        "defaultMessage": "Apps"
    },
    appFields: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.ecosystem-apps.app-fields",
        "defaultMessage": "App fields"
    },
    backItem: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.ecosystem-apps.back-item",
        "defaultMessage": "Back"
    }
});

});


parcelRegister("7ugdf", function(module, exports) {

$parcel$export(module.exports, "IssueTypes", () => $56d96fd9dd5cb0bb$export$15fef796fc6acc30);

var $eUqFw = parcelRequire("eUqFw");

var $gO9Xw = parcelRequire("gO9Xw");

var $7eyVf = parcelRequire("7eyVf");

var $8cU5f = parcelRequire("8cU5f");

var $7ZZxN = parcelRequire("7ZZxN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1UelU = parcelRequire("1UelU");
var $9kVcv = parcelRequire("9kVcv");
var $cPEpP = parcelRequire("cPEpP");

var $1BKP5 = parcelRequire("1BKP5");

var $7Fu43 = parcelRequire("7Fu43");

var $kIUmN = parcelRequire("kIUmN");

var $4UslI = parcelRequire("4UslI");

var $cqJw8 = parcelRequire("cqJw8");

var $hnvmL = parcelRequire("hnvmL");

var $ecloj = parcelRequire("ecloj");
const $56d96fd9dd5cb0bb$export$a4007dc4843ca7f6 = (0, $kIUmN.withThrowOnError)((0, $cPEpP.useProject));
const $56d96fd9dd5cb0bb$export$15fef796fc6acc30 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ asyncState: asyncState, topLevel: topLevel, baseLevel: baseLevel, bottomLevel: bottomLevel, addIssueTypeTooltip: addIssueTypeTooltip, isAddIssueTypeDisabled: isAddIssueTypeDisabled }] = (0, $hnvmL.useIssueTypesNavigationItems)();
    const [, addIssueTypesContextActions] = (0, $4UslI.useAddIssueTypeContext)();
    const { data: project } = $56d96fd9dd5cb0bb$export$a4007dc4843ca7f6();
    let baseSettingsUrl = '';
    if (project !== null) baseSettingsUrl = (0, $cqJw8.getNextgenSettingsUrl)((0, $7ZZxN.CORE_PROJECT), project.key);
    const hasAnyIssueTypes = topLevel.length > 0 || baseLevel.length > 0 || bottomLevel.length > 0;
    const isReady = asyncState === 'SUCCESS' || hasAnyIssueTypes;
    if (!project || !isReady) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Fu43.Skeleton), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9kVcv.TitleHeader), null, formatMessage((0, $ecloj.default).issueTypes)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1BKP5.IssueTypesGroup), {
        baseSettingsUrl: baseSettingsUrl,
        hasSeparator: false,
        navigationItems: topLevel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1BKP5.IssueTypesGroup), {
        baseSettingsUrl: baseSettingsUrl,
        hasSeparator: true,
        navigationItems: baseLevel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1BKP5.IssueTypesGroup), {
        baseSettingsUrl: baseSettingsUrl,
        hasSeparator: true,
        navigationItems: bottomLevel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), null, (()=>{
        const addItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1UelU.MenuItem), {
            analytics: {
                itemId: 'add-issue-type'
            },
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
                label: formatMessage((0, $ecloj.default).addIssueType)
            }),
            isDisabled: isAddIssueTypeDisabled,
            onClick: isAddIssueTypeDisabled ? undefined : addIssueTypesContextActions.openAddIssueTypeModal
        }, formatMessage((0, $ecloj.default).addIssueType));
        return addIssueTypeTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: addIssueTypeTooltip
        }, addItem) : addItem;
    })()));
};

});
parcelRegister("gO9Xw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3c90a7e02e55e7e$var$_react = $c3c90a7e02e55e7e$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $c3c90a7e02e55e7e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c3c90a7e02e55e7e$var$AddIcon = (props)=>/*#__PURE__*/ $c3c90a7e02e55e7e$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M13 11V3.993A.997.997 0 0012 3c-.556 0-1 .445-1 .993V11H3.993A.997.997 0 003 12c0 .557.445 1 .993 1H11v7.007c0 .548.448.993 1 .993.556 0 1-.445 1-.993V13h7.007A.997.997 0 0021 12c0-.556-.445-1-.993-1H13z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$c3c90a7e02e55e7e$var$AddIcon.displayName = 'AddIcon';
var $c3c90a7e02e55e7e$var$_default = $c3c90a7e02e55e7e$var$AddIcon;
module.exports.default = $c3c90a7e02e55e7e$var$_default;

});

parcelRegister("1BKP5", function(module, exports) {

$parcel$export(module.exports, "IssueTypesGroup", () => $21c5f892146ad62a$export$5bc39a07c26525ad);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $7eyVf = parcelRequire("7eyVf");

var $1UelU = parcelRequire("1UelU");

var $bS2FN = parcelRequire("bS2FN");
const $21c5f892146ad62a$export$5bc39a07c26525ad = ({ MenuItem: MenuItem = (0, $1UelU.MenuItem), Section: Section = (0, $7eyVf.default), baseSettingsUrl: baseSettingsUrl, hasSeparator: hasSeparator, navigationItems: navigationItems })=>{
    if (!navigationItems.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Section, {
        hasSeparator: hasSeparator
    }, navigationItems.map((issueType)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MenuItem, {
            key: String(issueType.id),
            analytics: {
                itemId: String(issueType.id)
            },
            selectedOn: (0, $bS2FN.matchUrlPathname)(),
            href: `${baseSettingsUrl}/issuetypes/${issueType.id}`,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
                appearance: "square",
                size: "small",
                src: issueType.icon,
                borderColor: "transparent"
            })
        }, issueType.name)));
};

});

parcelRegister("4UslI", function(module, exports) {

$parcel$export(module.exports, "useAddIssueTypeContext", () => $6b794ec5bab5ffc3$export$40493c3e9059110a);
$parcel$export(module.exports, "useAddIssueTypeContextUpdateStoreReference", () => $6b794ec5bab5ffc3$export$f1a20ca23c90093e);
$parcel$export(module.exports, "addIssueTypeModalActions", () => $6b794ec5bab5ffc3$export$605f542240ea8e19);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");
const $6b794ec5bab5ffc3$var$initialState = {
    isActive: false
};
const $6b794ec5bab5ffc3$var$openAddIssueTypeModal = ()=>({ setState: setState })=>{
        setState({
            isActive: true
        });
    };
const $6b794ec5bab5ffc3$var$closeAddIssueTypeModal = ()=>({ setState: setState })=>{
        setState({
            isActive: false
        });
    };
const $6b794ec5bab5ffc3$var$actions = {
    openAddIssueTypeModal: $6b794ec5bab5ffc3$var$openAddIssueTypeModal,
    closeAddIssueTypeModal: $6b794ec5bab5ffc3$var$closeAddIssueTypeModal
};
const $6b794ec5bab5ffc3$var$STORE_NAME = 'jira-project-settings-apps-add-issue-type-context';
const $6b794ec5bab5ffc3$var$Store = (0, $a61MH.createStore)({
    name: $6b794ec5bab5ffc3$var$STORE_NAME,
    initialState: $6b794ec5bab5ffc3$var$initialState,
    actions: $6b794ec5bab5ffc3$var$actions
});
const $6b794ec5bab5ffc3$export$40493c3e9059110a = (0, $ggKAj.createHook)($6b794ec5bab5ffc3$var$Store);
const $6b794ec5bab5ffc3$export$a0f296f941567e3d = (0, $dYfll.createSubscriber)($6b794ec5bab5ffc3$var$Store);
// instead of utilisling defaultRegistry, we will grab it from the render tree to have this singleton
// call useStoreReference in render tree before accessing the store instance
// https://github.com/atlassian/react-sweet-state/issues/139#issuecomment-890439621
const $6b794ec5bab5ffc3$var$storeInstance = {
    state: $6b794ec5bab5ffc3$var$initialState,
    actions: null
};
const $6b794ec5bab5ffc3$export$f1a20ca23c90093e = ()=>{
    const [issueTypeContextState, issueTypeContextActions] = $6b794ec5bab5ffc3$export$40493c3e9059110a();
    $6b794ec5bab5ffc3$var$storeInstance.state = issueTypeContextState;
    $6b794ec5bab5ffc3$var$storeInstance.actions = issueTypeContextActions;
    return null;
};
const $6b794ec5bab5ffc3$export$605f542240ea8e19 = ()=>$6b794ec5bab5ffc3$var$storeInstance.actions;

});

parcelRegister("hnvmL", function(module, exports) {

$parcel$export(module.exports, "useIssueTypesNavigationItems", () => $50b7672a8696556a$export$8facf5695da03580);
$parcel$export(module.exports, "useIssueTypesNavigationItemsActions", () => $50b7672a8696556a$export$502d4d04702890ce);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");

var $71ZqG = parcelRequire("71ZqG");

var $jEt1i = parcelRequire("jEt1i");

var $kcW9s = parcelRequire("kcW9s");
const $50b7672a8696556a$export$d4c72bab9d6cc13a = {
    projectId: null,
    asyncState: (0, $71ZqG.INIT),
    data: {
        limitPerProject: null,
        issueTypes: []
    },
    addIssueTypeTooltipMessage: ''
};
const $50b7672a8696556a$var$load = (projectId, productFeatures, intl)=>async ({ setState: setState, getState: getState })=>{
        try {
            const currentState = getState();
            if (currentState.asyncState === (0, $71ZqG.LOADING) && projectId === currentState.projectId) return;
            setState({
                ...projectId === currentState.projectId ? currentState : $50b7672a8696556a$export$d4c72bab9d6cc13a,
                projectId: projectId,
                asyncState: (0, $71ZqG.LOADING)
            });
            const result = await (0, $jEt1i.queryIssueTypesNavigationItems)(projectId, productFeatures);
            if (getState().projectId !== projectId) return;
            const { limitPerProject: limitPerProject, data: data } = result.data.simplifiedProject.issueTypeCollection;
            setState({
                projectId: projectId,
                asyncState: (0, $71ZqG.SUCCESS),
                data: {
                    limitPerProject: limitPerProject,
                    issueTypes: data
                },
                addIssueTypeTooltipMessage: intl.formatMessage(productFeatures.navigationMessages.addIssueTypeDisabledTooltip, {
                    limit: limitPerProject
                })
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                asyncState: (0, $71ZqG.FAILURE)
            });
        }
    };
const $50b7672a8696556a$var$remove = (issueTypeId)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        if (state.asyncState !== (0, $71ZqG.SUCCESS)) return;
        setState({
            ...state,
            data: {
                ...state.data,
                issueTypes: state.data.issueTypes.filter(({ id: id })=>id !== issueTypeId)
            }
        });
    };
const $50b7672a8696556a$var$update = (layoutOwners)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        if (state.asyncState !== (0, $71ZqG.SUCCESS)) return;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newDataById = {};
        for(let i = 0; i < layoutOwners.length; i += 1){
            const { data: data } = layoutOwners[i];
            newDataById[data.id] = {
                name: data.name,
                avatarId: data.avatarId,
                icon: data.iconUrl
            };
        }
        const issueTypes = state.data.issueTypes.map((issueType)=>{
            if (!newDataById[issueType.id]) return issueType;
            const { name: name, avatarId: avatarId } = newDataById[issueType.id];
            return {
                ...issueType,
                name: name,
                avatarId: avatarId || issueType.avatarId
            };
        });
        setState({
            ...state,
            data: {
                ...state.data,
                issueTypes: issueTypes
            }
        });
    };
const $50b7672a8696556a$export$e324594224ef24da = {
    load: $50b7672a8696556a$var$load,
    remove: $50b7672a8696556a$var$remove,
    update: $50b7672a8696556a$var$update
};
const $50b7672a8696556a$export$94d3eea6047656ad = ({ projectId: projectId, asyncState: asyncState, data: data, addIssueTypeTooltipMessage: addIssueTypeTooltipMessage })=>{
    const { issueTypes: issueTypes, limitPerProject: limitPerProject } = data;
    const { topLevel: topLevel, baseLevel: baseLevel, bottomLevel: bottomLevel } = (0, $kcW9s.getIssueTypeNavigationItemsLevels)(issueTypes);
    const isIssueTypeLimitReached = (0, $kcW9s.getIsIssueTypeLimitReached)(limitPerProject, issueTypes.length);
    const addIssueTypeTooltip = isIssueTypeLimitReached ? addIssueTypeTooltipMessage : '';
    return {
        asyncState: asyncState,
        projectId: projectId,
        isAddIssueTypeDisabled: asyncState !== (0, $71ZqG.SUCCESS) || isIssueTypeLimitReached,
        addIssueTypeTooltip: addIssueTypeTooltip,
        topLevel: topLevel,
        baseLevel: baseLevel,
        bottomLevel: bottomLevel
    };
};
// Made it const for visibility. Apparently, store name must be unique or it breaks the library
const $50b7672a8696556a$var$STORE_NAME = 'issue-type-page-navigation-items-new';
const $50b7672a8696556a$var$Store = (0, $a61MH.createStore)({
    name: $50b7672a8696556a$var$STORE_NAME,
    initialState: $50b7672a8696556a$export$d4c72bab9d6cc13a,
    actions: $50b7672a8696556a$export$e324594224ef24da
});
const $50b7672a8696556a$export$8facf5695da03580 = (0, $ggKAj.createHook)($50b7672a8696556a$var$Store, {
    selector: $50b7672a8696556a$export$94d3eea6047656ad
});
// @ts-expect-error - TS2322 - Type 'HookActionsFunction<BoundActions<State, { readonly load: (projectId: number, productFeatures: Readonly<{ issueTypeHierarchy: boolean; addIssueTypeMessages: AddIssueTypeMessages | undefined; issueTypeTemplates: TemplateIntl[]; ... 43 more ...; countOfDisabledAppsEnabled: boolean; }>, intl: IntlShape) => Action<...>...' is not assignable to type 'HookActionsFunction<{ readonly load: (projectId: number, productFeatures: Readonly<{ issueTypeHierarchy: boolean; addIssueTypeMessages: AddIssueTypeMessages | undefined; issueTypeTemplates: TemplateIntl[]; ... 43 more ...; countOfDisabledAppsEnabled: boolean; }>, intl: IntlShape) => Action<...>; readonly remove: (...'.
const $50b7672a8696556a$export$502d4d04702890ce = (0, $ggKAj.createActionsHook)($50b7672a8696556a$var$Store);
const $50b7672a8696556a$export$313f907c8e339d1b = (0, $dYfll.createSubscriber)($50b7672a8696556a$var$Store, {
    selector: $50b7672a8696556a$export$94d3eea6047656ad
});

});
parcelRegister("71ZqG", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $1d604ab09c97d0b8$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "INACTIVE_LIST", () => $1d604ab09c97d0b8$export$d7fec05af6b928f7);
$parcel$export(module.exports, "FIELD_TYPE_LIST", () => $1d604ab09c97d0b8$export$de26d0d1ef96d0ed);
$parcel$export(module.exports, "DELETE_DROPPABLE_ID", () => $1d604ab09c97d0b8$export$a155cb9d82798d65);
$parcel$export(module.exports, "IGNORE_CLICK_OUTSIDE_CLASS_NAME", () => $1d604ab09c97d0b8$export$8191ccc97ff9885c);
$parcel$export(module.exports, "DO_NOT_ANIMATE_WIDTH", () => $1d604ab09c97d0b8$export$c77ecc59e9e91e60);
$parcel$export(module.exports, "JSD_FIELD_HELPTEXT", () => $1d604ab09c97d0b8$export$663476c4863d5014);
$parcel$export(module.exports, "ID_REQUEST_OWNER_PROPERTY_KEY", () => $1d604ab09c97d0b8$export$9be9f574874c9a2f);
$parcel$export(module.exports, "NAME_REQUEST_OWNER_PROPERTY_KEY", () => $1d604ab09c97d0b8$export$b320c6b352dcb101);
$parcel$export(module.exports, "SUGGESTED_GROUP", () => $1d604ab09c97d0b8$export$e66b34cc29932bbf);
$parcel$export(module.exports, "ASSETS_GROUP", () => $1d604ab09c97d0b8$export$c87c7df18254969e);
$parcel$export(module.exports, "DATES_GROUP", () => $1d604ab09c97d0b8$export$fa8c310a8ac47d47);
$parcel$export(module.exports, "LABELS_GROUP", () => $1d604ab09c97d0b8$export$5b2dd1b457037e13);
$parcel$export(module.exports, "NUMBER_GROUP", () => $1d604ab09c97d0b8$export$2c2f344ca2ba1c03);
$parcel$export(module.exports, "PEOPLE_GROUP", () => $1d604ab09c97d0b8$export$1441c9d524a8c0f2);
$parcel$export(module.exports, "SELECT_GROUP", () => $1d604ab09c97d0b8$export$d3e4788fc90e5f8f);
$parcel$export(module.exports, "SYSTEM_GROUP", () => $1d604ab09c97d0b8$export$724e0d23ac7e9b03);
$parcel$export(module.exports, "TEXT_GROUP", () => $1d604ab09c97d0b8$export$bd76d204d15f4c6a);
$parcel$export(module.exports, "VERSION_GROUP", () => $1d604ab09c97d0b8$export$33d3fa5e989ba460);
$parcel$export(module.exports, "ADVANCED_GROUP", () => $1d604ab09c97d0b8$export$c58a10f3e3456974);
$parcel$export(module.exports, "OTHER_GROUP", () => $1d604ab09c97d0b8$export$591e195d295fd27e);
$parcel$export(module.exports, "RESTRICTED_GROUP", () => $1d604ab09c97d0b8$export$14785d7afcf55619);
$parcel$export(module.exports, "AI_SUGGESTED_GROUP", () => $1d604ab09c97d0b8$export$df593ebd3e7c9c2d);
$parcel$export(module.exports, "INIT", () => $1d604ab09c97d0b8$export$d788bc089976c004);
$parcel$export(module.exports, "LOADING", () => $1d604ab09c97d0b8$export$26d55645375ca9a);
$parcel$export(module.exports, "SUCCESS", () => $1d604ab09c97d0b8$export$638cc6e36b2a737a);
$parcel$export(module.exports, "FAILURE", () => $1d604ab09c97d0b8$export$5b1e245d5eac107);
$parcel$export(module.exports, "classicFieldTypesMap", () => $1d604ab09c97d0b8$export$369c1f8ac37104ce);
$parcel$export(module.exports, "ngFieldTypesMap", () => $1d604ab09c97d0b8$export$b361664c16c2ea91);
$parcel$export(module.exports, "SWIFT_VERSION_M2", () => $1d604ab09c97d0b8$export$527472231e0f6045);

var $lO4Or = parcelRequire("lO4Or");

var $6bYiA = parcelRequire("6bYiA");
const $1d604ab09c97d0b8$export$b8b9d90f9e5bd72b = (0, $6bYiA.toPackageName)('jiraProjectSettingsAppsIssueTypePageProductFeatures');
const $1d604ab09c97d0b8$export$d7fec05af6b928f7 = 'inactive-list';
const $1d604ab09c97d0b8$export$de26d0d1ef96d0ed = 'field-type-list';
const $1d604ab09c97d0b8$export$a155cb9d82798d65 = 'delete-droppable-id';
const $1d604ab09c97d0b8$export$8191ccc97ff9885c = '9|.^=*D(riA_=lUv787iQ7hwW5HIz=}t/OdJy%q';
const $1d604ab09c97d0b8$export$c77ecc59e9e91e60 = 'DO_NOT_ANIMATE_WIDTH';
const $1d604ab09c97d0b8$export$88ecd73c50643906 = 'swift_searchPreviouslyCreatedFields';
const $1d604ab09c97d0b8$export$663476c4863d5014 = 'jsd.field.helpText';
const $1d604ab09c97d0b8$export$aefba859678f04a = 'jsm.issue.type.associated.screen.id';
const $1d604ab09c97d0b8$export$9be9f574874c9a2f = 'jsm.issue.type.id';
const $1d604ab09c97d0b8$export$b320c6b352dcb101 = 'jsm.issue.type.name';
const $1d604ab09c97d0b8$export$97bca9c51480133e = 'jsm.issue.type.icon.id';
const $1d604ab09c97d0b8$export$b540ee71bad36b8b = 'jsm.issue.type.icon.url';
const $1d604ab09c97d0b8$export$27366eb417850f7c = [
    $1d604ab09c97d0b8$export$aefba859678f04a,
    $1d604ab09c97d0b8$export$b320c6b352dcb101,
    $1d604ab09c97d0b8$export$97bca9c51480133e,
    $1d604ab09c97d0b8$export$b540ee71bad36b8b
];
const $1d604ab09c97d0b8$export$e66b34cc29932bbf = 'suggestedGroup';
const $1d604ab09c97d0b8$export$c87c7df18254969e = 'assetsGroup';
const $1d604ab09c97d0b8$export$fa8c310a8ac47d47 = 'datesGroup';
const $1d604ab09c97d0b8$export$5b2dd1b457037e13 = 'labelsGroup';
const $1d604ab09c97d0b8$export$2c2f344ca2ba1c03 = 'numberGroup';
const $1d604ab09c97d0b8$export$1441c9d524a8c0f2 = 'peopleGroup';
const $1d604ab09c97d0b8$export$d3e4788fc90e5f8f = 'selectGroup';
const $1d604ab09c97d0b8$export$724e0d23ac7e9b03 = 'systemGroup';
const $1d604ab09c97d0b8$export$bd76d204d15f4c6a = 'textGroup';
const $1d604ab09c97d0b8$export$33d3fa5e989ba460 = 'versionGroup';
const $1d604ab09c97d0b8$export$c58a10f3e3456974 = 'advancedGroup';
const $1d604ab09c97d0b8$export$591e195d295fd27e = 'otherGroup';
const $1d604ab09c97d0b8$export$14785d7afcf55619 = 'restrictedGroup';
const $1d604ab09c97d0b8$export$df593ebd3e7c9c2d = 'aiSuggestedGroup';
const $1d604ab09c97d0b8$export$d788bc089976c004 = 'INIT';
const $1d604ab09c97d0b8$export$26d55645375ca9a = 'LOADING';
const $1d604ab09c97d0b8$export$638cc6e36b2a737a = 'SUCCESS';
const $1d604ab09c97d0b8$export$5b1e245d5eac107 = 'FAILURE';
const $1d604ab09c97d0b8$export$369c1f8ac37104ce = {
    assetspicker: $1d604ab09c97d0b8$export$c58a10f3e3456974,
    date: $1d604ab09c97d0b8$export$fa8c310a8ac47d47,
    datetime: $1d604ab09c97d0b8$export$fa8c310a8ac47d47,
    labelpicker: $1d604ab09c97d0b8$export$5b2dd1b457037e13,
    number: $1d604ab09c97d0b8$export$2c2f344ca2ba1c03,
    multiuserpicker: $1d604ab09c97d0b8$export$1441c9d524a8c0f2,
    userpicker: $1d604ab09c97d0b8$export$1441c9d524a8c0f2,
    checkbox: $1d604ab09c97d0b8$export$d3e4788fc90e5f8f,
    radio: $1d604ab09c97d0b8$export$d3e4788fc90e5f8f,
    cascadingselect: $1d604ab09c97d0b8$export$d3e4788fc90e5f8f,
    multiselect: $1d604ab09c97d0b8$export$d3e4788fc90e5f8f,
    select: $1d604ab09c97d0b8$export$d3e4788fc90e5f8f,
    attachment: $1d604ab09c97d0b8$export$724e0d23ac7e9b03,
    text: $1d604ab09c97d0b8$export$bd76d204d15f4c6a,
    textarea: $1d604ab09c97d0b8$export$bd76d204d15f4c6a
};
const $1d604ab09c97d0b8$export$b361664c16c2ea91 = {
    [(0, $lO4Or.ASSETS_CF_TYPE)]: $1d604ab09c97d0b8$export$c58a10f3e3456974,
    [(0, $lO4Or.DATE_CF_TYPE)]: $1d604ab09c97d0b8$export$fa8c310a8ac47d47,
    [(0, $lO4Or.DATETIME_CF_TYPE)]: $1d604ab09c97d0b8$export$fa8c310a8ac47d47,
    [(0, $lO4Or.LABELS_CF_TYPE)]: $1d604ab09c97d0b8$export$5b2dd1b457037e13,
    [(0, $lO4Or.NUMBER_CF_TYPE)]: $1d604ab09c97d0b8$export$2c2f344ca2ba1c03,
    people: $1d604ab09c97d0b8$export$1441c9d524a8c0f2,
    [(0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)]: $1d604ab09c97d0b8$export$d3e4788fc90e5f8f,
    [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: $1d604ab09c97d0b8$export$d3e4788fc90e5f8f,
    [(0, $lO4Or.SELECT_CF_TYPE)]: $1d604ab09c97d0b8$export$d3e4788fc90e5f8f,
    [(0, $lO4Or.ATTACHMENT_TYPE)]: $1d604ab09c97d0b8$export$724e0d23ac7e9b03,
    [(0, $lO4Or.TEXT_CF_TYPE)]: $1d604ab09c97d0b8$export$bd76d204d15f4c6a,
    [(0, $lO4Or.TEXT_AREA_CF_TYPE)]: $1d604ab09c97d0b8$export$bd76d204d15f4c6a,
    text: $1d604ab09c97d0b8$export$bd76d204d15f4c6a,
    [(0, $lO4Or.MULTI_VERSION_CF_TYPE)]: $1d604ab09c97d0b8$export$c58a10f3e3456974,
    [(0, $lO4Or.VERSION_CF_TYPE)]: $1d604ab09c97d0b8$export$c58a10f3e3456974,
    [(0, $lO4Or.SUMMARY_TYPE)]: $1d604ab09c97d0b8$export$724e0d23ac7e9b03,
    [(0, $lO4Or.DESCRIPTION_TYPE)]: $1d604ab09c97d0b8$export$724e0d23ac7e9b03,
    [(0, $lO4Or.LABELS_TYPE)]: $1d604ab09c97d0b8$export$724e0d23ac7e9b03,
    [(0, $lO4Or.PEOPLE_CF_TYPE)]: $1d604ab09c97d0b8$export$1441c9d524a8c0f2,
    [(0, $lO4Or.PRIORITY_TYPE)]: $1d604ab09c97d0b8$export$724e0d23ac7e9b03,
    [(0, $lO4Or.DUE_DATE_TYPE)]: $1d604ab09c97d0b8$export$724e0d23ac7e9b03,
    [(0, $lO4Or.TIME_ESTIMATE_TYPE)]: $1d604ab09c97d0b8$export$724e0d23ac7e9b03,
    [(0, $lO4Or.REPORTER_TYPE)]: $1d604ab09c97d0b8$export$724e0d23ac7e9b03,
    [(0, $lO4Or.ASSIGNEE_TYPE)]: $1d604ab09c97d0b8$export$724e0d23ac7e9b03
};
const $1d604ab09c97d0b8$export$8e333612d4b83b0e = 'M1';
const $1d604ab09c97d0b8$export$527472231e0f6045 = 'M2';

});

parcelRegister("jEt1i", function(module, exports) {

$parcel$export(module.exports, "queryIssueTypesNavigationItems", () => $e2b7fcab9d715067$export$d7f9b965a8cdf6ce);

var $2OdyW = parcelRequire("2OdyW");

var $6JubH = parcelRequire("6JubH");
const $e2b7fcab9d715067$var$getIssueTypesNavigationItemsQuery = (projectId)=>`query IssueTypesNavigationItems {
    simplifiedProject(projectId: ${projectId}) {
        issueTypeCollection {
            limitPerProject
            data {
                id
                name
                avatarId
                hierarchyLevel
                operations {
                    deletable
                    editable
                }                                
            }
        }            
    }
  }`;
const $e2b7fcab9d715067$var$getIssueTypesNavigationItemsWithPropertiesQuery = (projectId, keys)=>`query IssueTypesNavigationItemsWithProperties {
    simplifiedProject(projectId: ${projectId}) {
        issueTypeCollection {
            limitPerProject
            data {
                id
                name
                avatarId
                hierarchyLevel
                operations {
                    deletable
                    editable
                }                
                properties(keys: ${JSON.stringify(keys)})
            }
        }            
    }
  }`;
const $e2b7fcab9d715067$export$d7f9b965a8cdf6ce = (projectId, productFeatures)=>{
    const propertyKeys = (0, $6JubH.getAllPropertiesKeys)(productFeatures);
    const query = propertyKeys.length ? $e2b7fcab9d715067$var$getIssueTypesNavigationItemsWithPropertiesQuery(projectId, propertyKeys) : $e2b7fcab9d715067$var$getIssueTypesNavigationItemsQuery(projectId);
    return (0, $2OdyW.default)('/rest/gira/latest/?issue-type-page-navigation', {
        method: 'POST',
        body: JSON.stringify({
            query: query
        })
    });
};

});
parcelRegister("6JubH", function(module, exports) {

$parcel$export(module.exports, "getAllPropertiesKeys", () => $cda94d5835810025$export$481a21941383de83);

const $cda94d5835810025$export$481a21941383de83 = (features)=>{
    const { issueTypeHelpText: issueTypeHelpText } = features;
    const allPropertiesKeys = [
        (0, $71863708d1e76c0d$export$97806a3c861a8076),
        (0, $71863708d1e76c0d$export$5a53542e76b69730)
    ];
    return issueTypeHelpText ? allPropertiesKeys : [];
};

});
const $71863708d1e76c0d$export$5a53542e76b69730 = 'jsd.simplified.issue.type.helpText';
const $71863708d1e76c0d$export$97806a3c861a8076 = 'jsd.simplified.issue.type.isEmail';
const $71863708d1e76c0d$export$ffd77ce47de6d72c = 'jsd.field.displayName';
const $71863708d1e76c0d$export$663476c4863d5014 = 'jsd.field.helpText';
const $71863708d1e76c0d$export$dc7a7283bd7cd216 = 'jsd.field.approval.config';
const $71863708d1e76c0d$export$79bc253bc6964b1 = 'jsd.field.approval.all.configs';



parcelRegister("kcW9s", function(module, exports) {

$parcel$export(module.exports, "getIssueTypeNavigationItemsLevels", () => $381ebc40076882e7$export$fcf99cb11372431f);
$parcel$export(module.exports, "getIsIssueTypeLimitReached", () => $381ebc40076882e7$export$f9ef03d331bca3e6);

var $3l6tm = parcelRequire("3l6tm");

var $fPLIA = parcelRequire("fPLIA");
const $381ebc40076882e7$var$JSD_IS_EMAIL_REQUEST_TYPE = 'jsd.simplified.issue.type.isEmail';
const $381ebc40076882e7$export$fcf99cb11372431f = (issueTypes)=>issueTypes.reduce((acc, issueType)=>{
        const { id: id, avatarId: avatarId, name: name, hierarchyLevel: hierarchyLevel, properties: properties, operations: operations } = issueType;
        const issueTypeNavigationItem = {
            id: id,
            name: name,
            avatarId: avatarId,
            operations: operations,
            icon: (0, $fPLIA.getProjectAvatarUrl)(avatarId)
        };
        if ((0, $3l6tm.isEpicHierarchyLevel)(hierarchyLevel) || properties && properties[$381ebc40076882e7$var$JSD_IS_EMAIL_REQUEST_TYPE]) acc.topLevel.push(issueTypeNavigationItem);
        else if ((0, $3l6tm.isBaseHierarchyLevel)(hierarchyLevel)) acc.baseLevel.push(issueTypeNavigationItem);
        else if ((0, $3l6tm.isSubtaskHierarchyLevel)(hierarchyLevel)) acc.bottomLevel.push(issueTypeNavigationItem);
        return acc;
    }, {
        topLevel: [],
        baseLevel: [],
        bottomLevel: []
    });
const $381ebc40076882e7$export$f9ef03d331bca3e6 = (limitPerProject, numberOfIssueTypes)=>limitPerProject !== null && limitPerProject > 0 && numberOfIssueTypes >= limitPerProject;

});
parcelRegister("3l6tm", function(module, exports) {

$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_GOAL", () => $493876d3567385f4$export$2294cfc7730248df);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_STRATEGY", () => $493876d3567385f4$export$961a1d6da881600c);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_INITIATIVE", () => $493876d3567385f4$export$e11dea67b88ee556);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_EPIC", () => $493876d3567385f4$export$9ad20e435294162a);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_BASE", () => $493876d3567385f4$export$a454b3474c5ee5f5);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_SUBTASK", () => $493876d3567385f4$export$b69c1b48ce8f83de);
$parcel$export(module.exports, "BASE_HIERARCHY_TYPE", () => $493876d3567385f4$export$ba7c785763a2a58f);
$parcel$export(module.exports, "CHILD_HIERARCHY_TYPE", () => $493876d3567385f4$export$e09d07f2dcff2603);
$parcel$export(module.exports, "PARENT_HIERARCHY_TYPE", () => $493876d3567385f4$export$1165245f61159842);
$parcel$export(module.exports, "EPIC_PARENT_HIERARCHY_TYPE", () => $493876d3567385f4$export$8a96a83b3f957e58);
$parcel$export(module.exports, "toHierarchyLevel", () => $493876d3567385f4$export$c0c893ca5ccae9dd);
$parcel$export(module.exports, "isBaseHierarchyLevel", () => $493876d3567385f4$export$bcf91a9d8c5b0f58);
$parcel$export(module.exports, "isEpicHierarchyLevel", () => $493876d3567385f4$export$e415cf60723c7aae);
$parcel$export(module.exports, "isSubtaskHierarchyLevel", () => $493876d3567385f4$export$41f00a40e2ebd6e8);
$parcel$export(module.exports, "getHierarchyLevelType", () => $493876d3567385f4$export$556b686fea6fb229);
$parcel$export(module.exports, "getHierarchyLevelTypeSplitEpicFromCustom", () => $493876d3567385f4$export$638ac52227e67c8);
const $493876d3567385f4$export$2294cfc7730248df = 4;
const $493876d3567385f4$export$961a1d6da881600c = 3;
const $493876d3567385f4$export$e11dea67b88ee556 = 2;
const $493876d3567385f4$export$9ad20e435294162a = 1;
const $493876d3567385f4$export$a454b3474c5ee5f5 = 0;
const $493876d3567385f4$export$b69c1b48ce8f83de = -1;
const $493876d3567385f4$export$ba7c785763a2a58f = 'BASE';
const $493876d3567385f4$export$e09d07f2dcff2603 = 'CHILD';
const $493876d3567385f4$export$1165245f61159842 = 'PARENT';
const $493876d3567385f4$export$8a96a83b3f957e58 = 'EPIC';
const $493876d3567385f4$export$c0c893ca5ccae9dd = (level)=>level;
const $493876d3567385f4$export$bcf91a9d8c5b0f58 = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return true;
    return numericLevel === $493876d3567385f4$export$a454b3474c5ee5f5;
};
const $493876d3567385f4$export$e415cf60723c7aae = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return false;
    return numericLevel === $493876d3567385f4$export$9ad20e435294162a;
};
const $493876d3567385f4$export$41f00a40e2ebd6e8 = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return false;
    return numericLevel === $493876d3567385f4$export$b69c1b48ce8f83de;
};
const $493876d3567385f4$export$556b686fea6fb229 = (hierarchyLevel)=>{
    if (Number(hierarchyLevel) > 0) return $493876d3567385f4$export$1165245f61159842;
    if (Number(hierarchyLevel) < 0) return $493876d3567385f4$export$e09d07f2dcff2603;
    return $493876d3567385f4$export$ba7c785763a2a58f;
};
const $493876d3567385f4$export$638ac52227e67c8 = (hierarchyLevel)=>{
    if (Number(hierarchyLevel) === 1) return $493876d3567385f4$export$8a96a83b3f957e58;
    if (Number(hierarchyLevel) > 1) return $493876d3567385f4$export$1165245f61159842;
    if (Number(hierarchyLevel) < 0) return $493876d3567385f4$export$e09d07f2dcff2603;
    return $493876d3567385f4$export$ba7c785763a2a58f;
};

});

parcelRegister("fPLIA", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ca2223257c6a5a8$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getProjectAvatarUrl", () => $2ca2223257c6a5a8$export$65a50dd1fe88e116);
$parcel$export(module.exports, "normaliseSavedAvatar", () => $2ca2223257c6a5a8$export$b11f6166803b3fff);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2ca2223257c6a5a8$export$2e2bcd8739ae039 = (rawAvatars)=>rawAvatars.system.concat(rawAvatars.custom).map((raw)=>({
            id: Number(raw.id),
            uri: raw.urls['48x48'],
            fileName: raw.fileName
        }));
const $2ca2223257c6a5a8$export$65a50dd1fe88e116 = (avatarId)=>`/secure/viewavatar?avatarId=${avatarId}&avatarType=issuetype`;
const $2ca2223257c6a5a8$export$b11f6166803b3fff = (avatar)=>({
        id: parseInt(avatar.id, 10),
        uri: $2ca2223257c6a5a8$export$65a50dd1fe88e116(parseInt(avatar.id, 10)),
        fileName: avatar.fileName
    });

});



parcelRegister("ecloj", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ef69dab8435bf50$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9ef69dab8435bf50$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issueTypes: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.issue-types.issue-types",
        "defaultMessage": "Issue types"
    },
    addIssueType: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.issue-types.add-issue-type",
        "defaultMessage": "Add issue type"
    }
});

});


parcelRegister("f4Fss", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b38fe1c4155e2b35$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $b38fe1c4155e2b35$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.title",
        "defaultMessage": "Project settings"
    },
    itemDetails: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-details",
        "defaultMessage": "Details"
    },
    itemAccess: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-access",
        "defaultMessage": "Access"
    },
    itemIssueTypes: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-issue-types",
        "defaultMessage": "Issue types"
    },
    itemAdvancedForms: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-advanced-forms",
        "defaultMessage": "Advanced Forms"
    },
    newLozenge: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.new-lozenge",
        "defaultMessage": "New"
    },
    automation: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.automation",
        "defaultMessage": "Automation"
    },
    itemNotifications: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-notifications",
        "defaultMessage": "Notifications"
    },
    itemApprovals: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-approvals",
        "defaultMessage": "Approvals"
    },
    dataClassificationNonFinal: {
        "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.data-classification-non-final",
        "defaultMessage": "Data classification"
    }
});

});





parcelRegister("bVacK", function(module, exports) {

$parcel$export(module.exports, "default", () => $13b69d7e9bc0f0ef$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $13b69d7e9bc0f0ef$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    favorites: {
        "id": "spa-apps-sidebar-core.multi-project-menu.project-group.favorites",
        "defaultMessage": "Starred"
    },
    recents: {
        "id": "spa-apps-sidebar-core.multi-project-menu.project-group.recents",
        "defaultMessage": "Recent"
    },
    expandSection: {
        "id": "spa-apps-sidebar-core.multi-project-menu.project-group.expand-section",
        "defaultMessage": "Expand {section} projects"
    },
    collapseSection: {
        "id": "spa-apps-sidebar-core.multi-project-menu.project-group.collapse-section",
        "defaultMessage": "Collapse {section} projects"
    }
});

});

parcelRegister("1nRKu", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8307479266abafd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $3YFEG = parcelRequire("3YFEG");

var $kCTcl = parcelRequire("kCTcl");
const $e8307479266abafd$var$TEST_ID = 'navigation-apps-sidebar-core.ui.multi-project-menu.view-all-projects';
const $e8307479266abafd$var$ViewAllProjects = ({ label: label })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3YFEG.default), {
        href: "/jira/projects?selectedProjectType=business",
        testId: $e8307479266abafd$var$TEST_ID,
        onClick: ()=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'jwmViewAllProjectsLink')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e8307479266abafd$var$Content, null, label ?? formatMessage((0, $kCTcl.messages).viewAllProjectsLabel)));
};
var $e8307479266abafd$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($e8307479266abafd$var$ViewAllProjects);
const $e8307479266abafd$var$Content = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5721q9c _1reo15vq _18m915vq _1bto1l2s _k48p1nn1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kCTcl", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a83bdf732a2f08ae$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $a83bdf732a2f08ae$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    viewAllProjectsLabel: {
        "id": "spa-apps-sidebar-core.multi-project-menu.project-group.view-all-projects.view-all-projects-label",
        "defaultMessage": "View all projects"
    }
});

});



parcelRegister("439fx", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b2bfd1ec3623003$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lbttE = parcelRequire("lbttE");

var $2JncP = parcelRequire("2JncP");

var $94rY2 = parcelRequire("94rY2");

var $7LPMB = parcelRequire("7LPMB");

var $46qxU = parcelRequire("46qxU");
const $5b2bfd1ec3623003$var$ProjectsHeader = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { data: data } = (0, $2JncP.useProjectCreatePermissionsResource)();
    const canCreateProject = Boolean(data?.canCreateProject);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $94rY2.default), {
        title: formatMessage((0, $7LPMB.messages).projectsHeader)
    }, canCreateProject && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lbttE.ProjectCreateDrawerConsumer), null, ({ methods: { open: open } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $46qxU.default), {
            openProjectCreateDrawer: open
        })));
};
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$5b2bfd1ec3623003$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($5b2bfd1ec3623003$var$ProjectsHeader);

});
parcelRegister("7LPMB", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1677fc3cc494a9e0$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $1677fc3cc494a9e0$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    projectsHeader: {
        "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.projects-header",
        "defaultMessage": "Projects"
    }
});

});

parcelRegister("46qxU", function(module, exports) {

$parcel$export(module.exports, "default", () => $afa00e86d64bf3cb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $5RHM4 = parcelRequire("5RHM4");

var $eJ4Al = parcelRequire("eJ4Al");

const $afa00e86d64bf3cb$export$ef99f99721eacc0f = (0, $7rh0R.lazy)(()=>Promise.resolve((parcelRequire("eJ4Al"))), {
    ssr: false,
    moduleId: "./src/packages/business/navigation/sidebar/src/ui/multi-project-menu/projects-header/one-click-project/template-picker/index.tsx"
});
const $afa00e86d64bf3cb$var$OneClickProject = ({ openProjectCreateDrawer: openProjectCreateDrawer })=>{
    const renderContent = (0, $eUqFw.useCallback)((data, loading)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "sidebar-template-picker",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eJ4Al.TemplatePickerFallback), null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($afa00e86d64bf3cb$export$ef99f99721eacc0f, {
            data: data,
            loading: loading,
            openProjectCreateDrawer: openProjectCreateDrawer
        })), [
        openProjectCreateDrawer
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5RHM4.default), {
        renderContent: renderContent,
        openProjectCreateDrawer: openProjectCreateDrawer
    });
};
var $afa00e86d64bf3cb$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($afa00e86d64bf3cb$var$OneClickProject);

});
parcelRegister("5RHM4", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2f62e632270fd1e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3MV1G = parcelRequire("3MV1G");

var $ctuRV = parcelRequire("ctuRV");

var $kpmC0 = parcelRequire("kpmC0");

var $lg3mT = parcelRequire("lg3mT");

var $jPQKl = parcelRequire("jPQKl");

var $43dkR = parcelRequire("43dkR");
const $d2f62e632270fd1e$var$OneClickProjectButton = ({ renderContent: renderContent, openProjectCreateDrawer: openProjectCreateDrawer })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const { data: data, loading: loading, error: error, fetch: fetchJwmTemplates } = (0, $jPQKl.useProjectTemplates)();
    const { isCollapsed: isLeftSidebarCollapsed } = (0, $kpmC0.useLeftSidebarState)();
    const wasFetched = data != null || loading || error != null;
    const onClose = (0, $eUqFw.useCallback)(()=>setIsOpen(false), []);
    (0, $eUqFw.useEffect)(()=>{
        if (isOpen && !wasFetched) fetchJwmTemplates();
    }, [
        isOpen,
        wasFetched,
        fetchJwmTemplates
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (isLeftSidebarCollapsed && isOpen) onClose();
    }, [
        isLeftSidebarCollapsed,
        isOpen,
        onClose
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (error && isOpen) {
            openProjectCreateDrawer((0, $ctuRV.getJwmCreateProjectDrawerOptions)((0, $lg3mT.LOCATION)));
            setIsOpen(false);
        }
    }, [
        error,
        isOpen,
        openProjectCreateDrawer
    ]);
    const content = (0, $eUqFw.useCallback)(()=>renderContent(data, loading), [
        renderContent,
        data,
        loading
    ]);
    const trigger = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'triggerProps' implicitly has an 'any' type.
    (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", triggerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $43dkR.default), {
            onClick: ()=>setIsOpen(!isOpen)
        })), [
        isOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        placement: "right-start",
        onClose: onClose,
        content: content,
        trigger: trigger
    });
};
var $d2f62e632270fd1e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($d2f62e632270fd1e$var$OneClickProjectButton);

});
parcelRegister("ctuRV", function(module, exports) {

$parcel$export(module.exports, "getJwmCreateProjectDrawerOptions", () => $98e3a17d6f2eb763$export$c1785414279ee192);

var $7ZZxN = parcelRequire("7ZZxN");
const $98e3a17d6f2eb763$var$TEMPLATE_BLANK_PROJECT_TEAM_MANAGED = 'com.atlassian.jira-core-project-templates:jira-work-management-blank-project-team-managed';
const $98e3a17d6f2eb763$export$c1785414279ee192 = (source)=>({
        isNextGen: true,
        selectedProjectType: (0, $7ZZxN.CORE_PROJECT),
        showExperienceSelection: false,
        defaultSelectedTemplateKey: $98e3a17d6f2eb763$var$TEMPLATE_BLANK_PROJECT_TEAM_MANAGED,
        recommendedTemplate: {
            templateKey: $98e3a17d6f2eb763$var$TEMPLATE_BLANK_PROJECT_TEAM_MANAGED,
            isSimplified: false
        },
        source: source
    });

});

parcelRegister("jPQKl", function(module, exports) {

$parcel$export(module.exports, "useProjectTemplates", () => $fd9a9d07d5b37dc7$export$45e810e42086790f);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");

var $lg3mT = parcelRequire("lg3mT");

var $8Rrw0 = parcelRequire("8Rrw0");
const $fd9a9d07d5b37dc7$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $fd9a9d07d5b37dc7$export$45e810e42086790f = ()=>{
    const [{ loading: loading, data: data, error: error }, setState] = (0, $eUqFw.useState)($fd9a9d07d5b37dc7$var$initialState);
    const fetch = (0, $eUqFw.useCallback)(async ()=>{
        setState({
            data: null,
            loading: true,
            error: null
        });
        try {
            const response = await (0, $2OdyW.default)('/rest/simplified/2.0/project-templates?recommendations');
            const jwmTemplates = (0, $8Rrw0.getFilteredTemplates)(response);
            setState({
                data: jwmTemplates,
                loading: false,
                error: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $guiFP.default)({
                meta: {
                    id: 'useProjectTemplates',
                    packageName: (0, $lg3mT.PACKAGE_NAME),
                    teamName: 'jira-warepil'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            setState({
                data: null,
                loading: false,
                error: err
            });
        }
    }, []);
    return {
        data: data,
        loading: loading,
        error: error,
        fetch: fetch
    };
};

});
parcelRegister("8Rrw0", function(module, exports) {

$parcel$export(module.exports, "getFilteredTemplates", () => $aefab5fdd7f61066$export$e9643d22c03c3a30);
const $aefab5fdd7f61066$var$NUM_TEMPLATES_TO_DISPLAY = 4;
const $aefab5fdd7f61066$var$MADE_FOR_YOU_CATEGORY = 'made-for-you-category';
// note: these 4 templates are hardcoded for the time being
const $aefab5fdd7f61066$var$TEMPLATE_KEYS = new Set([
    'jwm.blank-project',
    'jwm.project-management',
    'jwm.personal-task-planner',
    'jwm.task-tracking'
]);
const $aefab5fdd7f61066$export$e9643d22c03c3a30 = (response)=>{
    const { templates: templates, lastUsedTemplate: lastUsedTemplateKey, recommendedTemplate: recommendedTemplateKey } = response;
    const lastUsedTemplates = [];
    const recommendedTemplates = [];
    const additionalTemplates = [];
    templates.forEach((template)=>{
        const { projectTypeTemplates: projectTypeTemplates, key: key, categoryTypes: categoryTypes } = template;
        if (lastUsedTemplateKey != null && (projectTypeTemplates?.teamManaged?.key === lastUsedTemplateKey || projectTypeTemplates?.companyManaged?.key === lastUsedTemplateKey)) lastUsedTemplates.push({
            ...template,
            isLastUsed: true
        });
        else if (recommendedTemplateKey != null && (projectTypeTemplates?.teamManaged?.key === recommendedTemplateKey || projectTypeTemplates?.companyManaged?.key === recommendedTemplateKey || categoryTypes.includes($aefab5fdd7f61066$var$MADE_FOR_YOU_CATEGORY))) recommendedTemplates.push({
            ...template,
            isRecommended: true
        });
        else if ($aefab5fdd7f61066$var$TEMPLATE_KEYS.has(key)) additionalTemplates.push(template);
    });
    // templates are sorted in order of last used, recommended and fallback.
    // only use the first 4 templates
    const filteredTemplates = [
        ...lastUsedTemplates,
        ...recommendedTemplates,
        ...additionalTemplates
    ].slice(0, $aefab5fdd7f61066$var$NUM_TEMPLATES_TO_DISPLAY);
    return filteredTemplates;
};

});


parcelRegister("43dkR", function(module, exports) {

$parcel$export(module.exports, "default", () => $c15f45e40c9348dc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $lg3mT = parcelRequire("lg3mT");

var $rRiBz = parcelRequire("rRiBz");

var $bvh6n = parcelRequire("bvh6n");
const $c15f45e40c9348dc$var$TEST_ID = 'navigation-apps-sidebar-core.ui.multi-project-menu.projects-header.create-project-button';
const $c15f45e40c9348dc$var$CreateProjectButton = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $rRiBz.default), {
        label: formatMessage((0, $bvh6n.default).createProjectLabel),
        testId: $c15f45e40c9348dc$var$TEST_ID,
        onClick: (_, analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, (0, $lg3mT.LOCATION));
            onClick();
        }
    });
};
var $c15f45e40c9348dc$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($c15f45e40c9348dc$var$CreateProjectButton);

});
parcelRegister("bvh6n", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4df5be60050e5cd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e4df5be60050e5cd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createProjectLabel: {
        "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.create-project-button.create-project-label",
        "defaultMessage": "Create project"
    }
});

});



parcelRegister("eJ4Al", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "TemplatePickerFallback", () => $ada0eacffac0a44d$export$675ac63e0637d34d);
$parcel$export(module.exports, "default", () => $ada0eacffac0a44d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $ffiyv = parcelRequire("ffiyv");

var $bULPy = parcelRequire("bULPy");
var $eMD3i = parcelRequire("eMD3i");
var $8BKky = parcelRequire("8BKky");

var $4Bees = parcelRequire("4Bees");

var $dfBCt = parcelRequire("dfBCt");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $c7H0g = parcelRequire("c7H0g");
var $1R3n5 = parcelRequire("1R3n5");

var $lg3mT = parcelRequire("lg3mT");

var $9euug = parcelRequire("9euug");
const $ada0eacffac0a44d$var$POPUP_WIDTH = 272;
const $ada0eacffac0a44d$export$675ac63e0637d34d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ada0eacffac0a44d$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "medium"
    }));
const $ada0eacffac0a44d$var$TemplatePicker = ({ data: data, loading: loading, openProjectCreateDrawer: openProjectCreateDrawer })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const handleTemplateClick = (0, $eUqFw.useCallback)((projectTypeTemplates, isLastUsed, isRecommended)=>()=>{
            openProjectCreateDrawer({
                isNextGen: true,
                selectedProjectType: 'business',
                showExperienceSelection: false,
                defaultSelectedTemplateKey: projectTypeTemplates?.teamManaged?.key || projectTypeTemplates?.companyManaged?.key,
                source: (0, $lg3mT.LOCATION)
            });
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'leftNavOneClickProjectCreateTemplate', {
                selectedTemplateKey: projectTypeTemplates?.teamManaged?.key || projectTypeTemplates?.companyManaged?.key,
                isLastUsed: isLastUsed,
                isRecommended: isRecommended
            });
        }, [
        createAnalyticsEvent,
        openProjectCreateDrawer
    ]);
    const handleMoreTemplatesClick = (0, $eUqFw.useCallback)(()=>{
        openProjectCreateDrawer({
            isNextGen: true,
            showExperienceSelection: false,
            source: (0, $lg3mT.LOCATION)
        });
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'leftNavOneClickProjectCreateMoreTemplates');
    }, [
        createAnalyticsEvent,
        openProjectCreateDrawer
    ]);
    const handleImportButtonClick = (0, $eUqFw.useCallback)(()=>{
        openProjectCreateDrawer({
            isNextGen: true,
            showExperienceSelection: false,
            source: (0, $lg3mT.LOCATION),
            isImportProjectOpenInitially: true
        });
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'leftNavOneClickProjectCreateImport');
    }, [
        createAnalyticsEvent,
        openProjectCreateDrawer
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eMD3i.default), {
        minWidth: $ada0eacffac0a44d$var$POPUP_WIDTH,
        testId: "navigation-apps-sidebar-core.ui.multi-project-menu.projects-header.one-click-project.template-picker.popup-menu-group"
    }, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ada0eacffac0a44d$export$675ac63e0637d34d, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        title: formatMessage((0, $9euug.default).sectionTitle)
    }, Array.isArray(data) && data.map(({ iconUrl: iconUrl, key: key, projectTypeTemplates: projectTypeTemplates, title: title, isLastUsed: isLastUsed = false, isRecommended: isRecommended = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
            testId: "navigation-apps-sidebar-core.ui.multi-project-menu.projects-header.one-click-project.template-picker.button-item",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ada0eacffac0a44d$var$StyledImage, {
                src: iconUrl,
                alt: `${title.label} icon`
            }),
            key: key,
            onClick: handleTemplateClick(projectTypeTemplates, isLastUsed, isRecommended)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ada0eacffac0a44d$var$ButtonText, null, title.label), isLastUsed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, formatMessage((0, $9euug.default).lastCreated))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.projects-header.one-click-project.template-picker.more-templates-button",
        onClick: handleMoreTemplatesClick
    }, formatMessage((0, $9euug.default).moreTemplatesButtonText)), (isSiteAdmin || isAdmin && (0, $1ybV0.ff)('enable-product-admin-for-x2c-migration_zmlsv') || !isAdmin && (0, $1ybV0.ff)('gun-2207-non-admin-support-in-tmp-migration_k7z9p')) && !(0, $dfBCt.isFedRamp)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.projects-header.one-click-project.template-picker.import-button",
        onClick: handleImportButtonClick
    }, formatMessage((0, $9euug.default).importButtonText)))));
};
var $ada0eacffac0a44d$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($ada0eacffac0a44d$var$TemplatePicker);
const $ada0eacffac0a44d$var$StyledImage = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1tcg _1bsbzwfg _5ral1dfr",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ada0eacffac0a44d$var$SpinnerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbclpc _1e0c1txw _4cvr1h6o _1bah1h6o _1yt4zu5n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ada0eacffac0a44d$var$ButtonText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxutpp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eMD3i", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d4de9f5740e2589$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $8PFhw = parcelRequire("8PFhw");
/**
 * @deprecated refer to MenuGroup, explicitly set maxWidth and minWidth
 */ const $6d4de9f5740e2589$var$PopupMenuGroup = ({ maxWidth: maxWidth = 800, minWidth: minWidth = 320, ...rest })=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        maxWidth: maxWidth,
        minWidth: minWidth,
        ...rest
    });
var $6d4de9f5740e2589$export$2e2bcd8739ae039 = $6d4de9f5740e2589$var$PopupMenuGroup;

});

parcelRegister("9euug", function(module, exports) {

$parcel$export(module.exports, "default", () => $2faf631161ec9357$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2faf631161ec9357$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    sectionTitle: {
        "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.one-click-project.template-picker.section-title",
        "defaultMessage": "Start a new project"
    },
    moreTemplatesButtonText: {
        "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.one-click-project.template-picker.more-templates-button-text",
        "defaultMessage": "More templates"
    },
    importButtonText: {
        "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.one-click-project.template-picker.import-button-text",
        "defaultMessage": "Import"
    },
    lastCreated: {
        "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.one-click-project.template-picker.last-created",
        "defaultMessage": "Last created"
    }
});

});






parcelRegister("gUycq", function(module, exports) {

$parcel$export(module.exports, "projectSettingsCoreDefaultRedirectRoute", () => $094dbb09a8724f35$export$322fe16ec991f12);
$parcel$export(module.exports, "projectSettingsCoreIssueTypesRoute", () => $094dbb09a8724f35$export$c3a32433c580b9ff);
$parcel$export(module.exports, "projectSettingsCoreIssueTypesWorkflowRoute", () => $094dbb09a8724f35$export$9e79ee307216071b);
$parcel$export(module.exports, "projectSettingsCoreAppsRoute", () => $094dbb09a8724f35$export$c7ac65fb0bbe767f);
$parcel$export(module.exports, "projectSettingsCoreAppsFieldsRoute", () => $094dbb09a8724f35$export$1c7e75ffaa491922);
$parcel$export(module.exports, "projectSettingsCoreDetailsRoute", () => $094dbb09a8724f35$export$14535b40530c8690);
$parcel$export(module.exports, "projectSettingsCoreAccessRoute", () => $094dbb09a8724f35$export$fe93051d5b7385a1);
$parcel$export(module.exports, "projectSettingsCoreAccessRedirectRoute", () => $094dbb09a8724f35$export$59e3323ba0cc224a);
$parcel$export(module.exports, "projectSettingsCoreProformaProjectFormsRoute", () => $094dbb09a8724f35$export$57fe8c5107a9c0de);
$parcel$export(module.exports, "projectSettingsCoreProformaJiraFormBuilderRoute", () => $094dbb09a8724f35$export$4e7ce7e6ced0f291);
$parcel$export(module.exports, "projectSettingsCoreAutomationRoute", () => $094dbb09a8724f35$export$65a4d727336c49f4);
$parcel$export(module.exports, "projectSettingsCoreAutomationV2Route", () => $094dbb09a8724f35$export$5437af2650f645e0);
$parcel$export(module.exports, "projectSettingsCoreDataClassificationsRoute", () => $094dbb09a8724f35$export$7aae1006c82a79c0);
$parcel$export(module.exports, "projectSettingsCoreNotificationsRoute", () => $094dbb09a8724f35$export$a1ee80066685b98d);
$parcel$export(module.exports, "projectSettingsCoreNotificationsEmailRoute", () => $094dbb09a8724f35$export$b546589f1b048dc);
$parcel$export(module.exports, "projectSettingsCoreForgeAppsRoute", () => $094dbb09a8724f35$export$b34160f55b6104e9);
$parcel$export(module.exports, "projectSettingsCoreApprovalsRoute", () => $094dbb09a8724f35$export$ba11c8f378a2c121);

var $exb0h = parcelRequire("exb0h");
const $094dbb09a8724f35$export$322fe16ec991f12 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_CORE,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_CORE_DEFAULT_REDIRECT,
    path: '/jira/core/projects/:projectKey/settings'
};
const $094dbb09a8724f35$export$c3a32433c580b9ff = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_CORE,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_CORE_ISSUE_TYPES,
    path: '/jira/core/projects/:projectKey/settings/issuetypes/:issueTypeId?'
};
const $094dbb09a8724f35$export$9e79ee307216071b = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_CORE,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_CORE_ISSUE_TYPES_WORKFLOW,
    path: '/jira/core/projects/:projectKey/settings/issuetypes/:issueTypeId/:initialSection(workflow)'
};
const $094dbb09a8724f35$export$c7ac65fb0bbe767f = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_CORE,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_CORE_APPS,
    path: '/jira/core/projects/:projectKey/settings/apps/:appId?'
};
const $094dbb09a8724f35$export$1c7e75ffaa491922 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_CORE,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_CORE_APPS_FIELDS,
    path: '/jira/core/projects/:projectKey/settings/apps/app-fields'
};
const $094dbb09a8724f35$export$14535b40530c8690 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_CORE,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_CORE_DETAILS,
    path: '/jira/core/projects/:projectKey/settings/details'
};
const $094dbb09a8724f35$export$fe93051d5b7385a1 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_CORE,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_CORE_ACCESS,
    path: '/jira/core/projects/:projectKey/settings/access'
};
const $094dbb09a8724f35$export$59e3323ba0cc224a = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_CORE,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_CORE_ACCESS_REDIRECT,
    path: '/jira/core/projects/:projectKey/settings/people'
};
const $094dbb09a8724f35$export$57fe8c5107a9c0de = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_CORE,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_CORE_PROFORMA_PROJECT_FORMS,
    path: '/jira/core/projects/:projectKey/settings/forms'
};
const $094dbb09a8724f35$export$4e7ce7e6ced0f291 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_CORE,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_CORE_PROFORMA_JIRA_FORM_BUILDER,
    path: '/jira/core/projects/:projectKey/settings/forms/form/:templateFormId/edit'
};
const $094dbb09a8724f35$export$65a4d727336c49f4 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_CORE,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_CORE_AUTOMATION,
    path: '/jira/core/projects/:projectKey/settings/automation'
};
const $094dbb09a8724f35$export$5437af2650f645e0 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_CORE,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_CORE_AUTOMATION,
    path: '/jira/core/projects/:projectKey/settings/automate'
};
const $094dbb09a8724f35$export$7aae1006c82a79c0 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_CORE,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_CORE_DATA_CLASSIFICATIONS,
    path: '/jira/core/projects/:projectKey/settings/data-classifications'
};
const $094dbb09a8724f35$export$a1ee80066685b98d = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_CORE,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_CORE_NOTIFICATIONS,
    path: '/jira/core/projects/:projectKey/settings/notifications'
};
const $094dbb09a8724f35$export$b546589f1b048dc = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_CORE,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_CORE_AUTOMATION,
    path: '/jira/core/projects/:projectKey/settings/notifications/notification-email'
};
const $094dbb09a8724f35$export$b34160f55b6104e9 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_CORE,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_CORE_FORGE_APPS,
    path: '/jira/core/projects/:projectKey/settings/apps/:appId/:envId/:route?'
};
const $094dbb09a8724f35$export$ba11c8f378a2c121 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_CORE,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_CORE_APPROVALS,
    path: '/jira/core/projects/:projectKey/settings/approvals'
};

});

parcelRegister("aHr8P", function(module, exports) {

$parcel$export(module.exports, "ProjectSettingsAccessSkeleton", () => $4baa3ff9a8a11662$export$e6cc5ccd52c7fd63);
$parcel$export(module.exports, "ProjectSettingsDetailsSkeleton", () => $4baa3ff9a8a11662$export$bd7fd4005b84aec9);
$parcel$export(module.exports, "ProjectSettingsFeaturesSkeleton", () => $4baa3ff9a8a11662$export$ec1cdd0c8335373c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");

var $cah49 = parcelRequire("cah49");

var $e3dMr = parcelRequire("e3dMr");

var $jTT1Q = parcelRequire("jTT1Q");
const $4baa3ff9a8a11662$var$customCssStyles = null;
const $4baa3ff9a8a11662$var$listOnlyStyles = null;
const $4baa3ff9a8a11662$export$e6cc5ccd52c7fd63 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cah49))),
        className: (0, $7JEyt.default)([
            "_18s85ogf _p12f1qe4 _11y7oza4"
        ])
    });
const $4baa3ff9a8a11662$export$bd7fd4005b84aec9 = ({ isListOnly: isListOnly = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($e3dMr))),
        className: (0, $7JEyt.default)([
            isListOnly ? "_1wgmglyw _rcuj1bdq" : "_18s85ogf _p12f1qe4 _11y7oza4"
        ])
    });
const $4baa3ff9a8a11662$export$ec1cdd0c8335373c = ({ isListOnly: isListOnly = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jTT1Q))),
        className: (0, $7JEyt.default)([
            isListOnly ? "_1wgmglyw _rcuj1bdq" : "_18s85ogf _p12f1qe4 _11y7oza4"
        ])
    });

});
parcelRegister("cah49", function(module, exports) {
module.exports = new URL("project-settings-access-app-skeleton.tpl.21bb94b1.svg", import.meta.url).toString();

});

parcelRegister("e3dMr", function(module, exports) {
module.exports = new URL("project-settings-details-app-skeleton.tpl.c4ebc2fd.svg", import.meta.url).toString();

});

parcelRegister("jTT1Q", function(module, exports) {
module.exports = new URL("project-settings-features-app-skeleton.tpl.b8e7f249.svg", import.meta.url).toString();

});


parcelRegister("cNd0M", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('eaxuB')
        ]);
        const value = parcelRequire('k0LLD');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("eaxuB")
    ]).then(()=>parcelRequire('k0LLD'));
}

});

parcelRegister("fOSDf", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('7kRau')
        ]);
        const value = parcelRequire('ary41');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("7kRau")
    ]).then(()=>parcelRequire('ary41'));
}

});

parcelRegister("9Jszy", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('d2csC');
        const value = parcelRequire('3rBlh');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("d2csC").then(()=>parcelRequire('3rBlh'));
}

});

parcelRegister("ipeZB", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('gkVK0')
        ]);
        const value = parcelRequire('iWHRQ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("gkVK0")
    ]).then(()=>parcelRequire('iWHRQ'));
}

});

parcelRegister("kF9mA", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('dsiAd'),
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('9l2fw')
        ]);
        const value = parcelRequire('5KeHo');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("dsiAd"),
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("9l2fw")
    ]).then(()=>parcelRequire('5KeHo'));
}

});

parcelRegister("jDthY", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('8zAor')
        ]);
        const value = parcelRequire('crJZY');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("8zAor")
    ]).then(()=>parcelRequire('crJZY'));
}

});

parcelRegister("7w1w9", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('kjKl7')
        ]);
        const value = parcelRequire('9WUwc');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("kjKl7")
    ]).then(()=>parcelRequire('9WUwc'));
}

});

parcelRegister("gBOWH", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('3Nm6L')
        ]);
        const value = parcelRequire('jaama');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("3Nm6L")
    ]).then(()=>parcelRequire('jaama'));
}

});

parcelRegister("lVOgJ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('dE1tw');
        const value = parcelRequire('1Pa6a');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("dE1tw").then(()=>parcelRequire('1Pa6a'));
}

});

parcelRegister("1ZzTg", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('fnPO9')
        ]);
        const value = parcelRequire('5CBZ5');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("fnPO9")
    ]).then(()=>parcelRequire('5CBZ5'));
}

});

parcelRegister("gcJQi", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('jBbTa')
        ]);
        const value = parcelRequire('2vBQX');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("jBbTa")
    ]).then(()=>parcelRequire('2vBQX'));
}

});

parcelRegister("51l6H", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('4xGYF');
        const value = parcelRequire('48O9T');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("4xGYF").then(()=>parcelRequire('48O9T'));
}

});

parcelRegister("k82mP", function(module, exports) {

$parcel$export(module.exports, "customerPermissionsPageDataResource", () => $f1d9ad56edd9ae35$export$ae3446385906310c);

var $3HCkE = parcelRequire("3HCkE");


const $f1d9ad56edd9ae35$export$ae3446385906310c = (0, $3HCkE.createResource)({
    type: (0, $e71a72bed0222680$export$34a89f9aaa677bb5),
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: ()=>(parcelRequire("hMfWQ")),
    maxAge: Infinity
});

});
const $e71a72bed0222680$export$34a89f9aaa677bb5 = 'CUSTOMER_PERMISSIONS';

parcelRegister("hMfWQ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('6M06z');
        const value = parcelRequire('cl5I5');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("6M06z").then(()=>parcelRequire('cl5I5'));
}

});


parcelRegister("3BZ46", function(module, exports) {

$parcel$export(module.exports, "portalSettingsContextResource", () => $e7c6da4ab4bcbc67$export$4a3e29f235f3320c);

var $3HCkE = parcelRequire("3HCkE");
const $e7c6da4ab4bcbc67$var$RESOURCE_TYPE_PORTAL_SETTINGS_CONTEXT = 'PORTAL_SETTINGS_CONTEXT';

const $e7c6da4ab4bcbc67$export$4a3e29f235f3320c = (0, $3HCkE.createResource)({
    type: $e7c6da4ab4bcbc67$var$RESOURCE_TYPE_PORTAL_SETTINGS_CONTEXT,
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("3QL0n"))
});

});
parcelRegister("3QL0n", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('eMmNt');
        const value = parcelRequire('amrnA');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("eMmNt").then(()=>parcelRequire('amrnA'));
}

});


parcelRegister("EFSBh", function(module, exports) {

$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskIssuetypesRoute", () => $47655043d641f00b$export$666cdeccf1f430a6);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskIssuetypesWorkflowRoute", () => $47655043d641f00b$export$5ed718db41f9c966);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskAppsFieldsRoute", () => $47655043d641f00b$export$e382068c2b8a7b9f);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskApps1Route", () => $47655043d641f00b$export$7ae67c73ac5367a8);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskDetailsRoute", () => $47655043d641f00b$export$b237f4f6820b26e9);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskAccessRoute", () => $47655043d641f00b$export$f7e149bf217bbb2c);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskAccessRedirectRoute", () => $47655043d641f00b$export$eb1177fbc6c41b97);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskProformaProjectFormsRoute", () => $47655043d641f00b$export$f919d82b98f9257a);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskProformaJiraFormBuilderRoute", () => $47655043d641f00b$export$ce59d5cb98345f8e);
$parcel$export(module.exports, "projectSettingsServicedeskAutomationRoute", () => $47655043d641f00b$export$1a2228d5e07202a0);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskDataClassificationsRoute", () => $47655043d641f00b$export$1596046a0b047934);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskClassicAppsRoute", () => $47655043d641f00b$export$3ab501c22b91462b);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskItsmFeaturesRoute", () => $47655043d641f00b$export$324e5a618f1ac5a1);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskNotificationsInternalNotificationsRoute", () => $47655043d641f00b$export$e6f711e47860f891);
$parcel$export(module.exports, "projectSettingsServicedeskNotificationsNotificationEmailRoute", () => $47655043d641f00b$export$40539cb16771014e);
$parcel$export(module.exports, "projectSettingsServicedeskNotifications1Route", () => $47655043d641f00b$export$18c6f3890d9fd8b8);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskLanguageKeyRoute", () => $47655043d641f00b$export$d195c572a6155c05);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskLanguage1Route", () => $47655043d641f00b$export$8152b460f5961d94);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannelsPermissionsNextGenRoute", () => $47655043d641f00b$export$e184fa302b6981b6);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskPermissionsClassicRoute", () => $47655043d641f00b$export$c320f6b30edb662a);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannelsEmailNextGenRoute", () => $47655043d641f00b$export$b03f0a1a580a902f);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskEmailClassicRoute", () => $47655043d641f00b$export$95c2f91492782444);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskPortalSettingsRoute", () => $47655043d641f00b$export$e856498dc02e46e8);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannelsPortalRoute", () => $47655043d641f00b$export$394d5ca6ce9e5949);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskExternalLinksRoute", () => $47655043d641f00b$export$d0198d2da30de212);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannelsWidgetRoute", () => $47655043d641f00b$export$fe54e02c94ff5613);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskWidgetRoute", () => $47655043d641f00b$export$164572fb58075291);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChangeManagementRoute", () => $47655043d641f00b$export$10089d339d8e30d1);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskIncidentManagementRoute", () => $47655043d641f00b$export$ff20eaee6cf19401);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannelsChatRoute", () => $47655043d641f00b$export$8e2543080acfc7c2);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChatRoute", () => $47655043d641f00b$export$3a3e70b8651d8d57);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannels5Route", () => $47655043d641f00b$export$77d19d35e71558b3);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskNotifications1Route", () => $47655043d641f00b$export$dbf7296f2946082);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskFeedbackRoute", () => $47655043d641f00b$export$cd46cad965f517e2);
$parcel$export(module.exports, "projectSettingsServicedeskForgeAppsRoute", () => $47655043d641f00b$export$10bafd1256118bb8);
$parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskRedirectRoute", () => $47655043d641f00b$export$43b5b901d4988763);

var $exb0h = parcelRequire("exb0h");
const $47655043d641f00b$var$SERVICE_DESK_PRODUCT = 'servicedesk';
const $47655043d641f00b$var$getProjectSettingsUrl = (product, projectKey)=>`/jira/${product}/projects/${projectKey || ':projectKey'}/settings`;
const $47655043d641f00b$export$b7cec47cdf9c76f1 = (projectKey)=>$47655043d641f00b$var$getProjectSettingsUrl($47655043d641f00b$var$SERVICE_DESK_PRODUCT, projectKey);
const $47655043d641f00b$export$666cdeccf1f430a6 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-issuetypes`,
    path: `${$47655043d641f00b$var$getProjectSettingsUrl($47655043d641f00b$var$SERVICE_DESK_PRODUCT)}/issuetypes/:issueTypeId?`,
    exact: true
};
const $47655043d641f00b$export$5ed718db41f9c966 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-issuetypes-workflow`,
    path: `${$47655043d641f00b$var$getProjectSettingsUrl($47655043d641f00b$var$SERVICE_DESK_PRODUCT)}/issuetypes/:issueTypeId/:initialSection(workflow)`,
    exact: true
};
const $47655043d641f00b$export$e382068c2b8a7b9f = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-apps-fields`,
    path: `${$47655043d641f00b$var$getProjectSettingsUrl($47655043d641f00b$var$SERVICE_DESK_PRODUCT)}/apps/app-fields`,
    exact: true
};
const $47655043d641f00b$export$7ae67c73ac5367a8 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-apps`,
    path: `${$47655043d641f00b$var$getProjectSettingsUrl($47655043d641f00b$var$SERVICE_DESK_PRODUCT)}/apps/:appId?`,
    exact: true
};
const $47655043d641f00b$export$b237f4f6820b26e9 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_SERVICEDESK_DETAILS,
    // /settings/details
    path: `${$47655043d641f00b$var$getProjectSettingsUrl($47655043d641f00b$var$SERVICE_DESK_PRODUCT)}/details`,
    exact: true
};
const $47655043d641f00b$export$f7e149bf217bbb2c = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-access`,
    path: `${$47655043d641f00b$var$getProjectSettingsUrl($47655043d641f00b$var$SERVICE_DESK_PRODUCT)}/access`,
    exact: true
};
const $47655043d641f00b$export$eb1177fbc6c41b97 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-access-redirect`,
    path: `${$47655043d641f00b$var$getProjectSettingsUrl($47655043d641f00b$var$SERVICE_DESK_PRODUCT)}/people`,
    exact: true
};
const $47655043d641f00b$export$f919d82b98f9257a = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-proforma-project-forms`,
    path: `${$47655043d641f00b$var$getProjectSettingsUrl($47655043d641f00b$var$SERVICE_DESK_PRODUCT)}/forms`,
    exact: true
};
const $47655043d641f00b$export$ce59d5cb98345f8e = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-proforma-jira-form-builder`,
    path: `${$47655043d641f00b$var$getProjectSettingsUrl($47655043d641f00b$var$SERVICE_DESK_PRODUCT)}/forms/form/:templateFormId/edit`,
    exact: true
};
const $47655043d641f00b$export$1a2228d5e07202a0 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_AUTOMATION,
    path: `${$47655043d641f00b$var$getProjectSettingsUrl($47655043d641f00b$var$SERVICE_DESK_PRODUCT)}/automate`
};
const $47655043d641f00b$export$1596046a0b047934 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-data-classifications`,
    path: `${$47655043d641f00b$var$getProjectSettingsUrl($47655043d641f00b$var$SERVICE_DESK_PRODUCT)}/data-classifications`,
    exact: true
};
const $47655043d641f00b$export$3ab501c22b91462b = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-classic-apps`,
    path: `${$47655043d641f00b$var$getProjectSettingsUrl($47655043d641f00b$var$SERVICE_DESK_PRODUCT)}/apps`,
    exact: true
};
const $47655043d641f00b$export$324e5a618f1ac5a1 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-itsm-features`,
    path: `${$47655043d641f00b$var$getProjectSettingsUrl($47655043d641f00b$var$SERVICE_DESK_PRODUCT)}/itsm-features`,
    exact: true
};
const $47655043d641f00b$export$e6f711e47860f891 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-notifications-internal-notifications`,
    path: `${$47655043d641f00b$var$getProjectSettingsUrl($47655043d641f00b$var$SERVICE_DESK_PRODUCT)}/notifications/internal-notifications`
};
const $47655043d641f00b$export$40539cb16771014e = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_SERVICEDESK_NOTIFICATIONS_NOTIFICATION_EMAIL,
    path: `${$47655043d641f00b$var$getProjectSettingsUrl($47655043d641f00b$var$SERVICE_DESK_PRODUCT)}/notifications/notification-email`,
    exact: true
};
const $47655043d641f00b$export$18c6f3890d9fd8b8 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_SERVICEDESK_NOTIFICATIONS,
    path: `${$47655043d641f00b$var$getProjectSettingsUrl($47655043d641f00b$var$SERVICE_DESK_PRODUCT)}/notifications`,
    exact: true
};
const $47655043d641f00b$export$d195c572a6155c05 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-language-key`,
    path: `${$47655043d641f00b$var$getProjectSettingsUrl($47655043d641f00b$var$SERVICE_DESK_PRODUCT)}/language/:languageKey/:sidebarItemKey?`
};
const $47655043d641f00b$export$8152b460f5961d94 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-language`,
    path: `${$47655043d641f00b$var$getProjectSettingsUrl($47655043d641f00b$var$SERVICE_DESK_PRODUCT)}/language`,
    exact: true
};
const $47655043d641f00b$export$e184fa302b6981b6 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-channels-permissions-next-gen`,
    path: `${$47655043d641f00b$var$getProjectSettingsUrl($47655043d641f00b$var$SERVICE_DESK_PRODUCT)}/channels/customer-permissions`,
    exact: true
};
const $47655043d641f00b$export$c320f6b30edb662a = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-permissions-classic`,
    path: `${$47655043d641f00b$var$getProjectSettingsUrl($47655043d641f00b$var$SERVICE_DESK_PRODUCT)}/customer-permissions`,
    exact: true
};
const $47655043d641f00b$export$b03f0a1a580a902f = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-channels-email-next-gen`,
    path: `${$47655043d641f00b$var$getProjectSettingsUrl($47655043d641f00b$var$SERVICE_DESK_PRODUCT)}/channels/email`,
    exact: true
};
const $47655043d641f00b$export$95c2f91492782444 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-email-classic`,
    path: `${$47655043d641f00b$var$getProjectSettingsUrl($47655043d641f00b$var$SERVICE_DESK_PRODUCT)}/email`,
    exact: true
};
const $47655043d641f00b$export$e856498dc02e46e8 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-portal-settings`,
    path: `${$47655043d641f00b$var$getProjectSettingsUrl($47655043d641f00b$var$SERVICE_DESK_PRODUCT)}/portal-settings/:subPath(portal-groups)?`,
    exact: true
};
const $47655043d641f00b$export$394d5ca6ce9e5949 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-channels-portal`,
    path: `${$47655043d641f00b$var$getProjectSettingsUrl($47655043d641f00b$var$SERVICE_DESK_PRODUCT)}/channels/portal-settings`,
    exact: true
};
const $47655043d641f00b$export$d0198d2da30de212 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-external-links`,
    path: `${$47655043d641f00b$var$getProjectSettingsUrl($47655043d641f00b$var$SERVICE_DESK_PRODUCT)}/external-links`,
    exact: true
};
const $47655043d641f00b$export$fe54e02c94ff5613 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-channels-widget`,
    path: `${$47655043d641f00b$var$getProjectSettingsUrl($47655043d641f00b$var$SERVICE_DESK_PRODUCT)}/channels/widget`,
    exact: true
};
const $47655043d641f00b$export$164572fb58075291 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-widget`,
    path: `${$47655043d641f00b$var$getProjectSettingsUrl($47655043d641f00b$var$SERVICE_DESK_PRODUCT)}/widget`,
    exact: true
};
const $47655043d641f00b$export$10089d339d8e30d1 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-change-management`,
    path: `${$47655043d641f00b$var$getProjectSettingsUrl($47655043d641f00b$var$SERVICE_DESK_PRODUCT)}/change-management`,
    exact: true
};
const $47655043d641f00b$export$ff20eaee6cf19401 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-incident-management`,
    path: `${$47655043d641f00b$var$getProjectSettingsUrl($47655043d641f00b$var$SERVICE_DESK_PRODUCT)}/incident-management`,
    exact: true
};
const $47655043d641f00b$export$8e2543080acfc7c2 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-channels-chat`,
    path: `${$47655043d641f00b$var$getProjectSettingsUrl($47655043d641f00b$var$SERVICE_DESK_PRODUCT)}/channels/chat`,
    exact: true
};
const $47655043d641f00b$export$3a3e70b8651d8d57 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-chat`,
    path: `${$47655043d641f00b$var$getProjectSettingsUrl($47655043d641f00b$var$SERVICE_DESK_PRODUCT)}/chat`,
    exact: true
};
const $47655043d641f00b$export$77d19d35e71558b3 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-channels`,
    path: `${$47655043d641f00b$var$getProjectSettingsUrl($47655043d641f00b$var$SERVICE_DESK_PRODUCT)}/channels`,
    exact: true
};
const $47655043d641f00b$export$dbf7296f2946082 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-notifications`,
    path: `${$47655043d641f00b$var$getProjectSettingsUrl($47655043d641f00b$var$SERVICE_DESK_PRODUCT)}/customer-notifications`
};
const $47655043d641f00b$export$cd46cad965f517e2 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-feedback`,
    path: `${$47655043d641f00b$var$getProjectSettingsUrl($47655043d641f00b$var$SERVICE_DESK_PRODUCT)}/feedback-settings`
};
const $47655043d641f00b$export$10bafd1256118bb8 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_SERVICEDESK_FORGE_APPS,
    path: `${$47655043d641f00b$var$getProjectSettingsUrl($47655043d641f00b$var$SERVICE_DESK_PRODUCT)}/apps/:appId/:envId/:route?`
};
const $47655043d641f00b$export$43b5b901d4988763 = {
    // the following route should be non-exact, it will handle "index" and "404" cases
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-redirect`,
    path: `/jira/${$47655043d641f00b$var$SERVICE_DESK_PRODUCT}/projects/:projectKey/settings`
};

});

parcelRegister("9dMiG", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('dGs7u')
        ]);
        const value = parcelRequire('jKdac');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("dGs7u")
    ]).then(()=>parcelRequire('jKdac'));
}

});

parcelRegister("fo5Z8", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('jxM3K')
        ]);
        const value = parcelRequire('9wlAo');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("jxM3K")
    ]).then(()=>parcelRequire('9wlAo'));
}

});

parcelRegister("a27VQ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('52HQq')
        ]);
        const value = parcelRequire('dzeZc');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("52HQq")
    ]).then(()=>parcelRequire('dzeZc'));
}

});

parcelRegister("dyMhG", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('2QuJS')
        ]);
        const value = parcelRequire('3UTwM');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("2QuJS")
    ]).then(()=>parcelRequire('3UTwM'));
}

});

parcelRegister("7ukZ5", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('4tEwS')
        ]);
        const value = parcelRequire('gO1WW');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("4tEwS")
    ]).then(()=>parcelRequire('gO1WW'));
}

});

parcelRegister("cT94E", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hB0FT');
        const value = parcelRequire('b6r6l');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hB0FT").then(()=>parcelRequire('b6r6l'));
}

});

parcelRegister("jWtVL", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('8Sm6g')
        ]);
        const value = parcelRequire('7kngu');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("8Sm6g")
    ]).then(()=>parcelRequire('7kngu'));
}

});

parcelRegister("bnruX", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('a7huj')
        ]);
        const value = parcelRequire('ev6Eb');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("a7huj")
    ]).then(()=>parcelRequire('ev6Eb'));
}

});

parcelRegister("g2JMk", function(module, exports) {

$parcel$export(module.exports, "slaMetricsDataResource", () => $add69932c0c4ef8d$export$6cdfca3e816e9661);

var $3HCkE = parcelRequire("3HCkE");
const $add69932c0c4ef8d$export$c5fa03c9ad8df0e2 = 'SLA_METRICS';

const $add69932c0c4ef8d$export$6cdfca3e816e9661 = (0, $3HCkE.createResource)({
    type: $add69932c0c4ef8d$export$c5fa03c9ad8df0e2,
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: ()=>(parcelRequire("85NpU")),
    maxAge: Infinity
});

});
parcelRegister("85NpU", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('1VMb9');
        const value = parcelRequire('c7jir');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("1VMb9").then(()=>parcelRequire('c7jir'));
}

});


parcelRegister("82IHe", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('et2J9')
        ]);
        const value = parcelRequire('iT5dz');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("et2J9")
    ]).then(()=>parcelRequire('iT5dz'));
}

});

parcelRegister("crL4s", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('65eqK')
        ]);
        const value = parcelRequire('ajwbB');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("65eqK")
    ]).then(()=>parcelRequire('ajwbB'));
}

});

parcelRegister("47r3J", function(module, exports) {

$parcel$export(module.exports, "servicedeskIssueTypesResource", () => $9e5555754d0080d2$export$191ce50629f40dbe);

var $3HCkE = parcelRequire("3HCkE");


const $9e5555754d0080d2$var$getDataLoader = ()=>(parcelRequire("9qXB9"));
const $9e5555754d0080d2$export$191ce50629f40dbe = (0, $3HCkE.createResource)({
    type: (0, $63f82a515eeafde8$export$1ed713fe52212251),
    getKey: ({ match: { params: params } })=>params.projectKey || '',
    getDataLoader: $9e5555754d0080d2$var$getDataLoader
});

});
const $63f82a515eeafde8$export$1ed713fe52212251 = 'SERVICEDESK_ISSUE_TYPES';

parcelRegister("9qXB9", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('dTE5Q');
        const value = parcelRequire('gCRzh');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("dTE5Q").then(()=>parcelRequire('gCRzh'));
}

});


parcelRegister("6RfAJ", function(module, exports) {

$parcel$export(module.exports, "servicedeskPortalGroupsResource", () => $66f115839490fc3c$export$c7fb28234b909b2f);

var $3HCkE = parcelRequire("3HCkE");


const $66f115839490fc3c$var$getDataLoader = ()=>(parcelRequire("dMqXV"));
const $66f115839490fc3c$var$ONE_DAY_IN_MILLIS = 86400000;
const $66f115839490fc3c$export$c7fb28234b909b2f = (0, $3HCkE.createResource)({
    type: (0, $c46e3647a9aeab0e$export$4160f2c498fcd32e),
    getKey: ({ match: { params: params } })=>params.projectKey || '',
    getDataLoader: $66f115839490fc3c$var$getDataLoader,
    maxAge: $66f115839490fc3c$var$ONE_DAY_IN_MILLIS
});

});
const $c46e3647a9aeab0e$export$4160f2c498fcd32e = 'SERVICEDESK_PORTAL_GROUPS';

parcelRegister("dMqXV", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('ali6S');
        const value = parcelRequire('8vud6');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("ali6S").then(()=>parcelRequire('8vud6'));
}

});


parcelRegister("1lKRo", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('cEX9n')
        ]);
        const value = parcelRequire('caYq6');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("cEX9n")
    ]).then(()=>parcelRequire('caYq6'));
}

});

parcelRegister("g5qNM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $71a694d82228487c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "SideBarWrapper", () => $71a694d82228487c$export$74e1920fc26cafb6);

var $13cum = parcelRequire("13cum");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $bUi2Q = parcelRequire("bUi2Q");

var $1GeZ8 = parcelRequire("1GeZ8");

var $bNe1g = parcelRequire("bNe1g");

var $bqI0R = parcelRequire("bqI0R");

var $iScjA = parcelRequire("iScjA");
function $71a694d82228487c$export$2e2bcd8739ae039({ queries: { intentTemplateQueryReference: intentTemplateQueryReference } }) {
    const projectKey = (0, $bNe1g.useProjectContext)().data?.projectKey;
    const intentTemplatesData = (0, $iWLL0.usePreloadedQuery)((0, $13cum.default), intentTemplateQueryReference);
    const intentTemplatesDataRef = intentTemplatesData.jira.jiraProjectByKey;
    const virtualAgentFeaturesRef = intentTemplatesData.virtualAgent.virtualAgentEntitlements;
    const rightSidebarCurrentState = (0, $bUi2Q.useActiveRightSidebarState)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1GeZ8.RightSidebar), {
        testId: "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.ui.right-sidebar",
        width: rightSidebarCurrentState && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised ? rightSidebarCurrentState.width : 0,
        isFixed: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($71a694d82228487c$export$74e1920fc26cafb6, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bqI0R.IntentTemplateContainer), {
        scope: `intent_template_${projectKey}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iScjA.SidebarContent), {
        intentTemplatesDataRef: intentTemplatesDataRef,
        virtualAgentFeaturesRef: virtualAgentFeaturesRef
    }))));
}
const $71a694d82228487c$export$74e1920fc26cafb6 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1kl7wsm2 _11q71bhr _vchhusvi _1p57u2gc _4t3i1osq _18m91wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("13cum", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed68b012cb06ca5c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9ec83e209ccb6d8e63bc43df1dfef792>>
 * @relayHash 15d7acad258757e4608b0a07a6bde204
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8789ab3f986d4f369f91bdc4d71ace921807eaec7638f0e5dde21bdca1c34e17

var $cNy9K = parcelRequire("cNy9K");
const $ed68b012cb06ca5c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDiscoveredTemplatesTimestampEnabled"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isGateIntentTemplatesBehindAiToggleEnabled"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "key"
    }, v4 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v5 = [
        v4 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "key"
        }
    ], v6 = [
        v4 /*: any*/ 
    ], v7 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "uiVirtualAgentIntentTemplatesQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "isDiscoveredTemplatesTimestampEnabled",
                                                    "variableName": "isDiscoveredTemplatesTimestampEnabled"
                                                }
                                            ],
                                            "kind": "FragmentSpread",
                                            "name": "content_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar_SidebarContent_intentTemplatesDataRef"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProjectByKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "VirtualAgentQueryApi",
                        "kind": "LinkedField",
                        "name": "virtualAgent",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "VirtualAgentFeatures",
                                    "kind": "LinkedField",
                                    "name": "virtualAgentEntitlements",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "isGateIntentTemplatesBehindAiToggleEnabled",
                                                    "variableName": "isGateIntentTemplatesBehindAiToggleEnabled"
                                                }
                                            ],
                                            "kind": "FragmentSpread",
                                            "name": "content_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar_SidebarContent_virtualAgentFeaturesRef"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "virtualAgent.virtualAgentEntitlements"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "virtualAgent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "uiVirtualAgentIntentTemplatesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v7 /*: any*/ ,
                                    "concreteType": "VirtualAgentIntentTemplatesConnection",
                                    "kind": "LinkedField",
                                    "name": "intentTemplates",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "condition": "isGateIntentTemplatesBehindAiToggleEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasDiscoveredTemplates"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isDiscoveredTemplatesTimestampEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "lastDiscoveredTemplatesGenerationTime"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "VirtualAgentIntentTemplateEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "VirtualAgentIntentTemplate",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "type"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "noOfQuestions"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "intentTemplates(first:20)"
                                },
                                {
                                    "args": v7 /*: any*/ ,
                                    "handle": "connection",
                                    "key": "content_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar_SidebarContent_intentTemplates",
                                    "kind": "LinkedHandle",
                                    "name": "intentTemplates"
                                },
                                v8 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "VirtualAgentQueryApi",
                    "kind": "LinkedField",
                    "name": "virtualAgent",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "VirtualAgentFeatures",
                            "kind": "LinkedField",
                            "name": "virtualAgentEntitlements",
                            "plural": false,
                            "selections": [
                                {
                                    "condition": "isGateIntentTemplatesBehindAiToggleEnabled",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isAiEnabledInAdminHub"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8789ab3f986d4f369f91bdc4d71ace921807eaec7638f0e5dde21bdca1c34e17",
            "metadata": {},
            "name": "uiVirtualAgentIntentTemplatesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ed68b012cb06ca5c$var$node.hash = "78ecd07324c304fbf388410adf2d2c40";
(0, $cNy9K.PreloadableQueryRegistry).set($ed68b012cb06ca5c$var$node.params.id, $ed68b012cb06ca5c$var$node);
var $ed68b012cb06ca5c$export$2e2bcd8739ae039 = $ed68b012cb06ca5c$var$node;

});

parcelRegister("bqI0R", function(module, exports) {

$parcel$export(module.exports, "IntentTemplateContainer", () => $162bfe9ca355a444$export$60f14058592718f0);
$parcel$export(module.exports, "useIntentTemplateStoreState", () => $162bfe9ca355a444$export$66586f6134b5e602);
$parcel$export(module.exports, "useIntentTemplateStoreActions", () => $162bfe9ca355a444$export$3744fd84e3f2a78);
$parcel$export(module.exports, "useIsFetchingQuestions", () => $162bfe9ca355a444$export$27bfffb34bccf54e);

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");
const $162bfe9ca355a444$var$initialState = {
    id: undefined,
    name: undefined,
    description: undefined,
    questions: undefined,
    type: undefined,
    isDirty: undefined,
    cancelQuestionsRequest: null
};
const $162bfe9ca355a444$var$doCancelQuestionsRequest = (state)=>state.cancelQuestionsRequest && state.cancelQuestionsRequest();
const $162bfe9ca355a444$var$actions = {
    setIntentTemplate: (template)=>({ setState: setState })=>{
            setState({
                ...template,
                isDirty: false
            });
        },
    setQuestions: (questions)=>({ setState: setState })=>{
            setState({
                questions: questions
            });
        },
    setDirty: ()=>({ setState: setState })=>{
            setState({
                isDirty: true
            });
        },
    clearIntentTemplate: ()=>({ setState: setState, getState: getState })=>{
            $162bfe9ca355a444$var$doCancelQuestionsRequest(getState());
            setState({
                ...$162bfe9ca355a444$var$initialState,
                isDirty: false
            });
        },
    clearQuestions: ()=>({ setState: setState })=>{
            setState({
                questions: undefined
            });
        },
    setCancelQuestionsRequest: (cancelQuestionsRequest)=>({ setState: setState, getState: getState })=>{
            $162bfe9ca355a444$var$doCancelQuestionsRequest(getState());
            setState({
                cancelQuestionsRequest: cancelQuestionsRequest
            });
        }
};
const $162bfe9ca355a444$var$store = (0, $a61MH.createStore)({
    initialState: $162bfe9ca355a444$var$initialState,
    actions: $162bfe9ca355a444$var$actions,
    name: 'JSMVirtualAgentIntentTemplateStore'
});
const $162bfe9ca355a444$export$60f14058592718f0 = (0, $heB5U.createContainer)($162bfe9ca355a444$var$store);
const $162bfe9ca355a444$export$66586f6134b5e602 = (0, $ggKAj.createStateHook)($162bfe9ca355a444$var$store);
const $162bfe9ca355a444$export$3744fd84e3f2a78 = (0, $ggKAj.createActionsHook)($162bfe9ca355a444$var$store);
const $162bfe9ca355a444$export$27bfffb34bccf54e = (0, $ggKAj.createHook)($162bfe9ca355a444$var$store, {
    selector: (state)=>state.cancelQuestionsRequest !== null
});

});

parcelRegister("iScjA", function(module, exports) {

$parcel$export(module.exports, "SidebarContent", () => $ab40ba7131215262$export$49e8f7b58a4df4ea);

var $e45Yh = parcelRequire("e45Yh");

var $kEjl7 = parcelRequire("kEjl7");

var $9gDyp = parcelRequire("9gDyp");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $7u4fN = parcelRequire("7u4fN");
var $7opLA = parcelRequire("7opLA");

var $hI5oG = parcelRequire("hI5oG");

var $je5kZ = parcelRequire("je5kZ");

var $lRvnl = parcelRequire("lRvnl");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bUi2Q = parcelRequire("bUi2Q");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $d6f6c = parcelRequire("d6f6c");
var $bFzGY = parcelRequire("bFzGY");

var $bqI0R = parcelRequire("bqI0R");

var $jIMNW = parcelRequire("jIMNW");

var $8SkMa = parcelRequire("8SkMa");

var $1rZRo = parcelRequire("1rZRo");

var $gGoYb = parcelRequire("gGoYb");
const $ab40ba7131215262$var$PAGINATION_COUNT = 20;
const $ab40ba7131215262$export$49e8f7b58a4df4ea = ({ intentTemplatesDataRef: intentTemplatesDataRef, virtualAgentFeaturesRef: virtualAgentFeaturesRef })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { closeRightSidebar: closeRightSidebar } = (0, $bUi2Q.useRightSidebarController)();
    const { setQuestions: setQuestions, clearQuestions: clearQuestions, setCancelQuestionsRequest: setCancelQuestionsRequest } = (0, $bqI0R.useIntentTemplateStoreActions)();
    const relayEnvironment = (0, $iWLL0.useRelayEnvironment)();
    const adminHubData = (0, $iWLL0.useFragment)((0, $9gDyp.default), virtualAgentFeaturesRef);
    const handleFetchQuestionsError = (0, $eUqFw.useCallback)((error)=>{
        showFlag({
            title: formatMessage((0, $gGoYb.default).errorFlagTitleQuestions),
            description: formatMessage((0, $gGoYb.default).errorFlagDescriptionQuestions),
            type: 'error'
        }); // https://data-portal.internal.atlassian.com/analytics/registry/55493
        (0, $guiFP.default)({
            meta: {
                id: 'fetchIntentTemplateQuestions',
                teamName: 'jsd-flux-capacitors',
                packageName: 'jiraServicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar'
            },
            error: error
        });
    }, [
        formatMessage,
        showFlag
    ]);
    const fetchQuestions = (0, $eUqFw.useCallback)((templateId)=>{
        (0, $iWLL0.fetchQuery)(relayEnvironment, (0, $kEjl7.default), {
            id: templateId
        }).subscribe({
            start (subscription) {
                setCancelQuestionsRequest(()=>subscription.unsubscribe());
                clearQuestions();
            },
            next (data) {
                if (data && data.node.__typename === 'VirtualAgentIntentTemplate') setQuestions(data.node.questions);
                else handleFetchQuestionsError();
            },
            error (err) {
                setCancelQuestionsRequest(null);
                handleFetchQuestionsError(err);
            },
            complete () {
                setCancelQuestionsRequest(null);
            }
        });
    }, [
        relayEnvironment,
        setCancelQuestionsRequest,
        clearQuestions,
        setQuestions,
        handleFetchQuestionsError
    ]);
    const onCloseButtonClick = ()=>{
        closeRightSidebar('intentTemplate');
    };
    const { data: data, loadNext: loadNext, hasNext: hasNext, isLoadingNext: isLoadingNext, refetch: refetch } = (0, $iWLL0.usePaginationFragment)((0, $e45Yh.default), intentTemplatesDataRef);
    const loadMoreTemplates = ()=>{
        loadNext($ab40ba7131215262$var$PAGINATION_COUNT, {
            onComplete: (requestError)=>{
                if (requestError) {
                    showFlag({
                        title: (0, $gGoYb.default).errorFlagTitle,
                        description: (0, $gGoYb.default).errorFlagDescription,
                        type: 'error'
                    }); // https://data-portal.internal.atlassian.com/analytics/registry/53592
                    (0, $guiFP.default)({
                        meta: {
                            id: 'loadMoreIntentTemplates',
                            teamName: 'jsd-flux-capacitors',
                            packageName: 'jiraServicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar'
                        },
                        error: requestError
                    });
                } else // https://data-portal.internal.atlassian.com/analytics/registry/53593
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'intentsTemplates loaded');
            }
        });
    };
    const analyticsAttributes = {
        discoveredTemplatesDisplayed: data.intentTemplates?.hasDiscoveredTemplates
    };
    return data == null || data.intentTemplates == null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jIMNW.ErrorDisplay), {
        refetch: ()=>refetch({})
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$9d2de6eebf7462b5),
        sourceName: "servicedeskVirtualAgentCreateIntentTemplatesSidebar",
        attributes: analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ab40ba7131215262$var$SidebarContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ab40ba7131215262$var$HeadingContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "medium"
    }, formatMessage((0, $gGoYb.default).panelHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        "aria-label": formatMessage((0, $gGoYb.default).closeIconLabel),
        appearance: "subtle",
        spacing: "none",
        onClick: onCloseButtonClick,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($je5kZ))), {
            label: ""
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $gGoYb.default).panelDescription)), (0, $1ybV0.ff)('activate-ai-toggle-message-in-intent-templates-sidebar_9dhqx') && !adminHubData.isAiEnabledInAdminHub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        title: formatMessage((0, $gGoYb.default).activateAiSectionMessageTitle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $gGoYb.default).activateAiSectionMessageDescription, {
        link: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                appearance: "link",
                spacing: "none",
                href: "https://support.atlassian.com/organization-administration/docs/activate-atlassian-intelligence-for-products/",
                rel: "noopener noreferrer",
                target: "_blank"
            }, chunks)
    }))), (0, $1ybV0.ff)('activate-ai-toggle-message-in-intent-templates-sidebar_9dhqx') && adminHubData.isAiEnabledInAdminHub && data.intentTemplates.hasDiscoveredTemplates === false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        title: formatMessage((0, $gGoYb.default).loadingTemplatesSectionMessageTitle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $gGoYb.default).loadingTemplatesSectionMessageDescriptionOne, {
        b: (...parts)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, parts)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $gGoYb.default).loadingTemplatesSectionMessageDescriptionTwo, {
        link: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                appearance: "link",
                spacing: "none",
                href: "https://support.atlassian.com/contact/#/",
                rel: "noopener noreferrer",
                target: "_blank"
            }, chunks)
    }))), (0, $1ybV0.ff)('add-last-updated-timestamp-for-intent-templates_tgonx') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1rZRo.LastUpdatedTimestamp), {
        intentTemplatesDataRef: data.intentTemplates
    }), data?.intentTemplates?.edges && data?.intentTemplates?.edges.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ab40ba7131215262$var$IntentTemplatesContainer, null, data.intentTemplates.edges.map((edge)=>edge.node && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8SkMa.IntentTemplate), {
            key: edge.node.id,
            intentTemplateDataRef: edge.node,
            onSelect: ()=>edge.node && fetchQuestions(edge.node.id)
        }))), hasNext && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ab40ba7131215262$var$ButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        isLoading: isLoadingNext,
        onClick: loadMoreTemplates
    }, formatMessage((0, $gGoYb.default).loadMoreTemplatesButton)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ab40ba7131215262$var$SidebarContentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1bsb1osq _1bah1yb4 _19bv1ejb _u5f31ejb _ca0q1ejb _vchhusvi _1p57pxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ab40ba7131215262$var$IntentTemplatesContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ab40ba7131215262$var$ButtonContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _1yt410cz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ab40ba7131215262$var$HeadingContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1bah1yb4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("e45Yh", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e708e1c6d7b6992$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<86d903b1e8367fb3c6d855cd41b08d20>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $7aUov = parcelRequire("7aUov");
const $8e708e1c6d7b6992$var$node = function() {
    var v0 = [
        "intentTemplates"
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": 20,
                "kind": "LocalArgument",
                "name": "count"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cursor"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isDiscoveredTemplatesTimestampEnabled"
            },
            {
                "kind": "RootArgument",
                "name": "isGateIntentTemplatesBehindAiToggleEnabled"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "count",
                    "cursor": "cursor",
                    "direction": "forward",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "count",
                        "cursor": "cursor"
                    },
                    "backward": null,
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [
                    "node"
                ],
                "operation": (0, $7aUov.default),
                "identifierInfo": {
                    "identifierField": "id",
                    "identifierQueryVariableName": "id"
                }
            }
        },
        "name": "content_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar_SidebarContent_intentTemplatesDataRef",
        "selections": [
            {
                "alias": "intentTemplates",
                "concreteType": "VirtualAgentIntentTemplatesConnection",
                "kind": "LinkedField",
                "name": "__content_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar_SidebarContent_intentTemplates_connection",
                "plural": false,
                "selections": [
                    {
                        "condition": "isGateIntentTemplatesBehindAiToggleEnabled",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "hasDiscoveredTemplates"
                            }
                        ]
                    },
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "isDiscoveredTemplatesTimestampEnabled",
                                "variableName": "isDiscoveredTemplatesTimestampEnabled"
                            }
                        ],
                        "kind": "FragmentSpread",
                        "name": "lastUpdatedTimestamp_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar"
                    },
                    {
                        "concreteType": "VirtualAgentIntentTemplateEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "VirtualAgentIntentTemplate",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "intentTemplate_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    }
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "cursor"
                            }
                        ]
                    },
                    {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "endCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                            }
                        ]
                    }
                ]
            },
            v1 /*: any*/ 
        ],
        "type": "JiraProject"
    };
}();
$8e708e1c6d7b6992$var$node.hash = "915031d521ef1e657922ee1b44339a0d";
var $8e708e1c6d7b6992$export$2e2bcd8739ae039 = $8e708e1c6d7b6992$var$node;

});
parcelRegister("7aUov", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5b9945200138ed6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9cc9618dd4feacd3b4de7ec0470c917d>>
 * @relayHash 945ac47061c6b64e32334809f19e8801
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e2d4e3f42ad032b92771d1c2a11a69e144dcf3f4fc43bab0bc30af20300bcbe6
const $f5b9945200138ed6$var$node = function() {
    var v0 = {
        "defaultValue": 20,
        "kind": "LocalArgument",
        "name": "count"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cursor"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDiscoveredTemplatesTimestampEnabled"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isGateIntentTemplatesBehindAiToggleEnabled"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "cursor"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "content_servicedeskSettingsVirtualAgentCreateIntents_PaginatedIntentTemplatesQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "count",
                                    "variableName": "count"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "cursor",
                                    "variableName": "cursor"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "isDiscoveredTemplatesTimestampEnabled",
                                    "variableName": "isDiscoveredTemplatesTimestampEnabled"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "content_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar_SidebarContent_intentTemplatesDataRef"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "content_servicedeskSettingsVirtualAgentCreateIntents_PaginatedIntentTemplatesQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v8 /*: any*/ ,
                                    "concreteType": "VirtualAgentIntentTemplatesConnection",
                                    "kind": "LinkedField",
                                    "name": "intentTemplates",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "condition": "isGateIntentTemplatesBehindAiToggleEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasDiscoveredTemplates"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isDiscoveredTemplatesTimestampEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "lastDiscoveredTemplatesGenerationTime"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "VirtualAgentIntentTemplateEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "VirtualAgentIntentTemplate",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "type"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "noOfQuestions"
                                                        },
                                                        v6 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v8 /*: any*/ ,
                                    "handle": "connection",
                                    "key": "content_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar_SidebarContent_intentTemplates",
                                    "kind": "LinkedHandle",
                                    "name": "intentTemplates"
                                }
                            ],
                            "type": "JiraProject"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e2d4e3f42ad032b92771d1c2a11a69e144dcf3f4fc43bab0bc30af20300bcbe6",
            "metadata": {},
            "name": "content_servicedeskSettingsVirtualAgentCreateIntents_PaginatedIntentTemplatesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f5b9945200138ed6$var$node.hash = "915031d521ef1e657922ee1b44339a0d";
var $f5b9945200138ed6$export$2e2bcd8739ae039 = $f5b9945200138ed6$var$node;

});


parcelRegister("kEjl7", function(module, exports) {

$parcel$export(module.exports, "default", () => $27405e4187ec1783$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b59e064f1871e78e0bc744afc58a156f>>
 * @relayHash 3825ba996936fa9c23361c1c82392471
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f793d40604e7707d238c22072458bd4c7fbc6cb312122202bf6f362d128eb623
const $27405e4187ec1783$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "questions"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "content_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar_QuestionsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v2 /*: any*/ ,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": v3 /*: any*/ ,
                                        "action": "THROW",
                                        "path": "node.questions"
                                    }
                                ],
                                "type": "VirtualAgentIntentTemplate"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "node"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "content_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar_QuestionsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v3 /*: any*/ 
                            ],
                            "type": "VirtualAgentIntentTemplate"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f793d40604e7707d238c22072458bd4c7fbc6cb312122202bf6f362d128eb623",
            "metadata": {},
            "name": "content_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar_QuestionsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$27405e4187ec1783$var$node.hash = "1d2f7549a67fbbe26722b4edc31dd65f";
var $27405e4187ec1783$export$2e2bcd8739ae039 = $27405e4187ec1783$var$node;

});

parcelRegister("9gDyp", function(module, exports) {

$parcel$export(module.exports, "default", () => $681963eecf84ccf9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<07c2084963d0ce9650a78f4d95b3448e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $681963eecf84ccf9$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isGateIntentTemplatesBehindAiToggleEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "content_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar_SidebarContent_virtualAgentFeaturesRef",
    "selections": [
        {
            "condition": "isGateIntentTemplatesBehindAiToggleEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isAiEnabledInAdminHub"
                }
            ]
        }
    ],
    "type": "VirtualAgentFeatures"
};
$681963eecf84ccf9$var$node.hash = "048c3ca8b9ef27d75ebbd4a504d5718c";
var $681963eecf84ccf9$export$2e2bcd8739ae039 = $681963eecf84ccf9$var$node;

});

parcelRegister("je5kZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dff3771012ed2785$var$_react = $dff3771012ed2785$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $dff3771012ed2785$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $dff3771012ed2785$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $dff3771012ed2785$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M15.185 7.4l-3.184 3.185-3.186-3.186a.507.507 0 00-.712.003l-.7.701a.496.496 0 00-.004.712l3.185 3.184L7.4 15.185a.507.507 0 00.004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 00.712-.004l.701-.7a.496.496 0 00.003-.712l-3.186-3.186 3.186-3.184a.507.507 0 00-.003-.712l-.7-.7a.508.508 0 00-.36-.153.5.5 0 00-.353.15z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$dff3771012ed2785$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $dff3771012ed2785$var$_default = $dff3771012ed2785$var$EditorCloseIcon;
module.exports.default = $dff3771012ed2785$var$_default;

});

parcelRegister("jIMNW", function(module, exports) {

$parcel$export(module.exports, "ErrorDisplay", () => $c1a21cced81113cb$export$d56b0569bceb92ae);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $220ac = parcelRequire("220ac");

var $4Es8k = parcelRequire("4Es8k");

var $ijwdS = parcelRequire("ijwdS");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bFpyz = parcelRequire("bFpyz");
const $c1a21cced81113cb$export$d56b0569bceb92ae = ({ refetch: refetch })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        header: formatMessage((0, $bFpyz.default).errorDisplayHeading),
        description: formatMessage((0, $bFpyz.default).errorDisplayDescription),
        renderImage: (0, $4Es8k.getAkEmptyStateRenderImageFn)((0, $ijwdS.default)),
        imageWidth: 160,
        maxImageHeight: 220,
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            onClick: refetch,
            appearance: "link"
        }, formatMessage((0, $bFpyz.default).reloadNowButtonText))
    });
};

});
parcelRegister("4Es8k", function(module, exports) {

$parcel$export(module.exports, "getAkEmptyStateRenderImageFn", () => $5b95caa215479c6b$export$ebf64b9217c1b2a3);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $gyaWd = parcelRequire("gyaWd");
function $5b95caa215479c6b$export$ebf64b9217c1b2a3(JiraIllustration = (0, $gyaWd.default)) {
    return ({ maxImageWidth: // we strictly follow EmptyState's defaults
    maxImageWidth = 160, maxImageHeight: maxImageHeight = 160, imageWidth: imageWidth, imageHeight: imageHeight })=>{
        // This wrapper emulates EmptyState's private "HeaderImage" styling
        // @see platform/packages/design-system/empty-state/src/empty-state.tsx
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
        const Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
                ...__cmplp,
                style: {
                    ...__cmpls,
                    "--_yv3y2x": (0, $9t7rW.default)(maxImageWidth, "px"),
                    "--_nq7wev": (0, $9t7rW.default)(maxImageHeight, "px")
                },
                ref: __cmplr,
                className: (0, $7JEyt.default)([
                    "_1e0c1ule _p12f1x6a _c71lc3ce _18s81ixx",
                    __cmplp.className
                ])
            });
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(JiraIllustration, {
            alt: "",
            role: "presentation",
            width: imageWidth || 'auto',
            height: imageHeight || 'auto'
        }));
    };
}

});
parcelRegister("gyaWd", function(module, exports) {

$parcel$export(module.exports, "default", () => $f352d69c1b682860$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = tgxxcm73mk6phg9ttfj3rvpf
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/tgxxcm73mk6phg9ttfj3rvpf

var $9TZf5 = parcelRequire("9TZf5");

var $7XfGh = parcelRequire("7XfGh");

var $5deuu = parcelRequire("5deuu");
const $f352d69c1b682860$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($5deuu)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($7XfGh))
});
var $f352d69c1b682860$export$2e2bcd8739ae039 = $f352d69c1b682860$var$Illustration;
// for advanced use only
const $f352d69c1b682860$export$a179c88182cb9d56 = [
    0,
    0,
    235,
    210
];

});
parcelRegister("9TZf5", function(module, exports) {

$parcel$export(module.exports, "Illustration", () => $a7efac7c92ef32a3$export$d43c2e2ca9b2c105);
$parcel$export(module.exports, "createIllustration", () => $a7efac7c92ef32a3$export$4d00e7be716a0093);

var $eUqFw = parcelRequire("eUqFw");

var $evtC7 = parcelRequire("evtC7");
function $a7efac7c92ef32a3$export$d43c2e2ca9b2c105({ embedAs: embedAs, ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $evtC7.AsImg), props);
}
function $a7efac7c92ef32a3$export$4d00e7be716a0093({ srcLight: srcLight, srcDark: srcDark, autoDark: autoDark }) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a7efac7c92ef32a3$export$d43c2e2ca9b2c105, {
            srcLight: srcLight,
            srcDark: srcDark,
            autoDark: autoDark,
            ...props
        });
}

});
parcelRegister("evtC7", function(module, exports) {

$parcel$export(module.exports, "AsImg", () => $e7036c28dfac32f8$export$75e378065cb7d6c0);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // This is an INTENTIONAL FORK of @atlaskit/image
// copied 2023-11-09 v1.1.6
// with permission from @DDC from Design System,
// in order to refine the API and use cases.
// Will be back-ported to @atlaskit/image https://hello.atlassian.net/browse/ERAI-1660

var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");
// suggested defaults, the consumer is free to override
const $e7036c28dfac32f8$var$defaultStyles = null;
const $e7036c28dfac32f8$var$fillStyles = null;
const $e7036c28dfac32f8$var$autoDarkModeStyles = null;
function $e7036c28dfac32f8$export$75e378065cb7d6c0({ srcLight: srcLight, srcDark: srcDark = srcLight, autoDark: autoDark = true, alt: alt, fill: fill = false, testId: testId, ...imgProps }) {
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        src: colorMode === 'dark' ? srcDark : srcLight,
        alt: alt,
        "data-testid": testId,
        ...imgProps,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _tvdr18uv _p12f1osq _4t3i1wug _5ral1f51 _rsuf1h6o",
            fill && "_kqswstnw _1r04idpf _1bsb1osq _4t3i1osq",
            colorMode === 'dark' && srcDark === srcLight && autoDark && "_kdam1ato"
        ])
    });
}

});


parcelRegister("7XfGh", function(module, exports) {
module.exports = new URL("generic-empty-state-darkmode.27f5dcf1.svg", import.meta.url).toString();

});

parcelRegister("5deuu", function(module, exports) {
module.exports = new URL("generic-empty-state.1b007192.svg", import.meta.url).toString();

});



parcelRegister("ijwdS", function(module, exports) {

$parcel$export(module.exports, "default", () => $d511833b787fbc99$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("hBxSu")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("5m2zy")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = jx8k5z4r4cbqfnn3t56t46v9
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/jx8k5z4r4cbqfnn3t56t46v9

var $9TZf5 = parcelRequire("9TZf5");

var $5m2zy = parcelRequire("5m2zy");

var $hBxSu = parcelRequire("hBxSu");
const $d511833b787fbc99$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($hBxSu)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($5m2zy))
});
var $d511833b787fbc99$export$2e2bcd8739ae039 = $d511833b787fbc99$var$Illustration;
// for advanced use only
const $d511833b787fbc99$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    212
];

});
parcelRegister("5m2zy", function(module, exports) {
module.exports = new URL("generic-error-darkmode.3646797f.svg", import.meta.url).toString();

});

parcelRegister("hBxSu", function(module, exports) {
module.exports = new URL("generic-error.f200ded6.svg", import.meta.url).toString();

});


parcelRegister("bFpyz", function(module, exports) {

$parcel$export(module.exports, "default", () => $dff82db7f47ee099$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $dff82db7f47ee099$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorDisplayHeading: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-display.error-display-heading",
        "defaultMessage": "We couldn\u2019t load intent templates"
    },
    errorDisplayDescription: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-display.error-display-description",
        "defaultMessage": "Wait a moment and then try reloading."
    },
    reloadNowButtonText: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-display.reload-now-button-text",
        "defaultMessage": "Reload"
    }
});

});


parcelRegister("8SkMa", function(module, exports) {

$parcel$export(module.exports, "IntentTemplate", () => $4ca8b58be7293c09$export$8329670d476b829b);

var $k5F8o = parcelRequire("k5F8o");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $hI5oG = parcelRequire("hI5oG");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");
var $g3tFP = parcelRequire("g3tFP");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gRU2D = parcelRequire("gRU2D");

var $awC7q = parcelRequire("awC7q");

var $jB8CQ = parcelRequire("jB8CQ");

var $5FGvS = parcelRequire("5FGvS");

var $bqI0R = parcelRequire("bqI0R");

var $fzqYv = parcelRequire("fzqYv");

var $e0CRo = parcelRequire("e0CRo");
const $4ca8b58be7293c09$export$9f95857259638e76 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4ca8b58be7293c09$var$TooltipContainer, {
        ...props,
        ref: ref
    }));
const $4ca8b58be7293c09$export$8329670d476b829b = ({ intentTemplateDataRef: intentTemplateDataRef, onSelect: onSelect })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const intentTemplateData = (0, $iWLL0.useFragment)((0, $k5F8o.default), intentTemplateDataRef);
    const { id: selectedTemplateId, isDirty: isDirty } = (0, $bqI0R.useIntentTemplateStoreState)();
    const { setIntentTemplate: setIntentTemplate } = (0, $bqI0R.useIntentTemplateStoreActions)();
    const [isModalOpen, setIsModalOpen] = (0, $eUqFw.useState)(false);
    const openModal = (0, $eUqFw.useCallback)(()=>setIsModalOpen(true), []);
    const closeModal = (0, $eUqFw.useCallback)(()=>setIsModalOpen(false), []);
    const { id: id, type: type, name: name, description: description } = intentTemplateData; // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const templateType = type in (0, $gRU2D.INTENT_TEMPLATE_TYPES) ? type : undefined;
    const onSubmit = (0, $eUqFw.useCallback)(()=>{
        // immediately set the already available props
        setIntentTemplate({
            id: id,
            name: name,
            type: templateType,
            description: description
        });
        closeModal();
        onSelect();
    }, [
        closeModal,
        description,
        id,
        name,
        onSelect,
        setIntentTemplate,
        templateType
    ]);
    const onClick = (0, $eUqFw.useCallback)(()=>{
        if (isDirty && selectedTemplateId) openModal();
        else onSubmit();
    }, [
        isDirty,
        selectedTemplateId,
        openModal,
        onSubmit
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        component: $4ca8b58be7293c09$export$9f95857259638e76,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e0CRo.TemplateDialog), {
            intentTemplateDataRef: intentTemplateData
        }),
        position: "left",
        testId: "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.ui.content.intent-template.tooltip"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4ca8b58be7293c09$var$IntentTemplateContainer, {
            role: "button",
            tabIndex: 0,
            ...tooltipProps,
            onClick: onClick,
            selected: selectedTemplateId === intentTemplateData.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jB8CQ.TemplateIcon), {
            type: templateType
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4ca8b58be7293c09$var$ContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4ca8b58be7293c09$var$HeadingContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
            size: "xsmall"
        }, intentTemplateData.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5FGvS.TemplateLozenge), {
            type: templateType
        })), intentTemplateData.description != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4ca8b58be7293c09$var$DescriptionText, null, intentTemplateData.description)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $awC7q.TemplateChangeModal), {
        isOpen: isModalOpen,
        onClose: closeModal,
        onSubmit: onSubmit,
        title: formatMessage((0, $fzqYv.default).changeTemplateModalTitle),
        buttonText: formatMessage((0, $fzqYv.default).changeTemplateModalConfirmButtonText)
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4ca8b58be7293c09$var$IntentTemplateContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_ighexv": (0, $9t7rW.default)(__cmplp.selected && `var(--ds-background-selected, ${(0, $PdmhA).B50})`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1yt4l4ej _80omtlke _2rkoiti9 _1dqonqa1 _bfhkn3m1 _zulputpp _irr31dko",
            __cmplp.selected ? "_1h6d6qac" : "_1h6d3acm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4ca8b58be7293c09$var$ContentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4ca8b58be7293c09$var$HeadingContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _zulpu2gc _4cvr1q9y",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4ca8b58be7293c09$var$DescriptionText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz6prz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4ca8b58be7293c09$var$TooltipContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $g3tFP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11q71bhr _2rkosqtm _16qs10em _vchh18uv _1bsb1kdj",
            __cmplp.className
        ])
    });
});

});
parcelRegister("k5F8o", function(module, exports) {

$parcel$export(module.exports, "default", () => $83f5bada12cf5988$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1c50082d49d4fa43e50f23d89248bc32>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $83f5bada12cf5988$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "intentTemplate_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "FragmentSpread",
            "name": "templateDialog_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar"
        }
    ],
    "type": "VirtualAgentIntentTemplate"
};
$83f5bada12cf5988$var$node.hash = "f5eec250ceff0cf077da9b8d4b794c86";
var $83f5bada12cf5988$export$2e2bcd8739ae039 = $83f5bada12cf5988$var$node;

});

parcelRegister("gRU2D", function(module, exports) {

$parcel$export(module.exports, "INTENT_TEMPLATE_TYPES", () => $54c3195c5a54529a$export$64fe49285ae28e61);
const $54c3195c5a54529a$export$64fe49285ae28e61 = {
    DISCOVERED: 'DISCOVERED',
    SHARED: 'SHARED',
    STANDARD: 'STANDARD'
};

});

parcelRegister("awC7q", function(module, exports) {

$parcel$export(module.exports, "TemplateChangeModal", () => $86e73043d4540b2d$export$fd4bb742498d4aec);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $dxopF = parcelRequire("dxopF");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dXJtm = parcelRequire("dXJtm");
const $86e73043d4540b2d$export$fd4bb742498d4aec = ({ isOpen: isOpen, onClose: onClose, onSubmit: onSubmit, title: title, buttonText: buttonText })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, formatMessage((0, $dXJtm.default).changeTemplateModalDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        onClick: onClose
    }, formatMessage((0, $dXJtm.default).changeTemplateModalCancelButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "primary",
        onClick: onSubmit
    }, buttonText))));
};

});
parcelRegister("dXJtm", function(module, exports) {

$parcel$export(module.exports, "default", () => $113db7e6c44b9a3d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $113db7e6c44b9a3d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    changeTemplateModalCancelButtonText: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.common.template-change-modal.change-template-modal-cancel-button-text",
        "defaultMessage": "Cancel"
    },
    changeTemplateModalDescription: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.common.template-change-modal.change-template-modal-description",
        "defaultMessage": "This will replace all settings and training phrases."
    }
});

});


parcelRegister("jB8CQ", function(module, exports) {

$parcel$export(module.exports, "TemplateIcon", () => $d5ae3abcdcbc0ede$export$17f8b5fdc0dde895);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $a1RbQ = parcelRequire("a1RbQ");

var $29Y8f = parcelRequire("29Y8f");

var $PdmhA = parcelRequire("PdmhA");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gRU2D = parcelRequire("gRU2D");

var $h7IZ6 = parcelRequire("h7IZ6");
const $d5ae3abcdcbc0ede$export$17f8b5fdc0dde895 = ({ type: type })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return type === (0, $gRU2D.INTENT_TEMPLATE_TYPES).DISCOVERED ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a1RbQ))), {
        label: formatMessage((0, $h7IZ6.default).discoveredIconLabel)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d5ae3abcdcbc0ede$var$FileIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($29Y8f))), {
        label: formatMessage((0, $h7IZ6.default).standardIconLabel),
        primaryColor: `var(--ds-icon-inverse, ${(0, $PdmhA).N0})`
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d5ae3abcdcbc0ede$var$FileIconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1ejb _4t3i1ejb _bfhkcmb5 _2rkoiti9 _1o9zidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("a1RbQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $74d341d502fed701$var$_react = $74d341d502fed701$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $74d341d502fed701$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $74d341d502fed701$var$Epic24Icon = (props)=>/*#__PURE__*/ $74d341d502fed701$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#6554C0" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm15.188 9.4h-3.063V4.8a1.807 1.807 0 00-3.16-1.192l-.197.21c-.095.114-.095.114-.324.397a678.151 678.151 0 00-2.976 3.699l-.093.117C5.188 12.03 5 12.274 5 12.8c0 1.01.819 1.599 1.77 1.76l.168.014h2.937V19.2c0 .997.815 1.8 1.813 1.8.43 0 .963-.236 1.52-.793l.073-.083.28-.35a1306.403 1306.403 0 002.973-3.744l.049-.061a403.17 403.17 0 002.21-2.815c.315-.407.562-.729.734-.96.095-.127.169-.229.223-.306.042-.062.042-.062.085-.13.05-.046.05-.046.165-.558 0-.997-.815-1.8-1.813-1.8zm-5.063 2V5.317a357.977 357.977 0 00-.863 1.066 626.68 626.68 0 00-2.23 2.778l-.047.058-.046.059c-1.573 1.973-2.217 2.788-2.596 3.296h4.532v6.106l.122-.154a1304.666 1304.666 0 002.969-3.736l.048-.061A400.017 400.017 0 0017.62 11.4h-4.495z"/></svg>`
    }, props, {
        size: "medium"
    }));
$74d341d502fed701$var$Epic24Icon.displayName = 'Epic24Icon';
var $74d341d502fed701$var$_default = $74d341d502fed701$var$Epic24Icon;
module.exports.default = $74d341d502fed701$var$_default;

});

parcelRegister("29Y8f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $192b110733c90331$var$_react = $192b110733c90331$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $192b110733c90331$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $192b110733c90331$var$FileIcon = (props)=>/*#__PURE__*/ $192b110733c90331$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M17 10.005V19H7V5h5.99v2.49a1.5 1.5 0 001.5 1.5h4.5v-.522c0-.297-.132-.578-.359-.768l-5.074-4.236c-.36-.3-.813-.464-1.282-.464H7a2 2 0 00-2 2v14a2 2 0 002 2h10a2 2 0 002-2v-8.995h-2z"/><rect x="8" y="12" width="8" height="2" rx="1"/><rect x="8" y="15" width="4" height="2" rx="1"/></g></svg>`
    }, props));
$192b110733c90331$var$FileIcon.displayName = 'FileIcon';
var $192b110733c90331$var$_default = $192b110733c90331$var$FileIcon;
module.exports.default = $192b110733c90331$var$_default;

});

parcelRegister("h7IZ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea295b14f3b1106c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ea295b14f3b1106c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    discoveredIconLabel: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.common.template-icon.discovered-icon-label",
        "defaultMessage": "This template is from your data."
    },
    standardIconLabel: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.common.template-icon.standard-icon-label",
        "defaultMessage": "This template was created from the most commonly used intents."
    }
});

});


parcelRegister("5FGvS", function(module, exports) {

$parcel$export(module.exports, "TemplateLozenge", () => $ebb4c97ada033a3c$export$7800957dec643880);

var $eUqFw = parcelRequire("eUqFw");

var $ffiyv = parcelRequire("ffiyv");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gRU2D = parcelRequire("gRU2D");

var $kMIjS = parcelRequire("kMIjS");
const $ebb4c97ada033a3c$export$7800957dec643880 = ({ type: type })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    switch(type){
        case (0, $gRU2D.INTENT_TEMPLATE_TYPES).DISCOVERED:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
                appearance: "new"
            }, formatMessage((0, $kMIjS.default).yourData)));
        case (0, $gRU2D.INTENT_TEMPLATE_TYPES).SHARED:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
                appearance: "success"
            }, formatMessage((0, $kMIjS.default).catalog)));
        default:
            return null;
    }
};

});
parcelRegister("kMIjS", function(module, exports) {

$parcel$export(module.exports, "default", () => $0efefbaa40dd934a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0efefbaa40dd934a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    yourData: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.common.template-lozenge.your-data",
        "defaultMessage": "Your data"
    },
    catalog: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.common.template-lozenge.catalog",
        "defaultMessage": "Catalog"
    }
});

});


parcelRegister("fzqYv", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d2ff4f62eea4621$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1d2ff4f62eea4621$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    changeTemplateModalTitle: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.intent-template.change-template-modal-title",
        "defaultMessage": "Change template?"
    },
    changeTemplateModalConfirmButtonText: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.intent-template.change-template-modal-confirm-button-text",
        "defaultMessage": "Change template"
    }
});

});

parcelRegister("e0CRo", function(module, exports) {

$parcel$export(module.exports, "TemplateDialog", () => $7c9d1195117a73e5$export$30e83372864e7d5a);

var $7xgow = parcelRequire("7xgow");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $hI5oG = parcelRequire("hI5oG");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gRU2D = parcelRequire("gRU2D");

var $jB8CQ = parcelRequire("jB8CQ");

var $5FGvS = parcelRequire("5FGvS");

var $hA8XL = parcelRequire("hA8XL");
const $7c9d1195117a73e5$var$templateTypeDescriptions = {
    DISCOVERED: (0, $hA8XL.default).fromYourDataDescription,
    SHARED: (0, $hA8XL.default).catalogTemplateDescription,
    STANDARD: (0, $hA8XL.default).catalogTemplateDescription
};
const $7c9d1195117a73e5$export$30e83372864e7d5a = ({ intentTemplateDataRef: intentTemplateDataRef })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const intentTemplateData = (0, $iWLL0.useFragment)((0, $7xgow.default), intentTemplateDataRef);
    const templateType = intentTemplateData.type in (0, $gRU2D.INTENT_TEMPLATE_TYPES) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    intentTemplateData.type : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7c9d1195117a73e5$var$HeadingContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jB8CQ.TemplateIcon), {
        type: templateType
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xsmall"
    }, intentTemplateData.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7c9d1195117a73e5$var$ContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7c9d1195117a73e5$var$SectionContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5FGvS.TemplateLozenge), {
        type: templateType
    }), templateType != null && formatMessage($7c9d1195117a73e5$var$templateTypeDescriptions[templateType])), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7c9d1195117a73e5$var$SectionContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        level: "h200"
    }, formatMessage((0, $hA8XL.default).descriptionLabel)), intentTemplateData.description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7c9d1195117a73e5$var$SectionContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        level: "h200"
    }, formatMessage((0, $hA8XL.default).summaryLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7c9d1195117a73e5$var$TrainingPhrasesContainer, null, formatMessage((0, $hA8XL.default).trainingPhrasesLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $hA8XL.default).trainingPhrasesNumber, {
        numberOfTrainingPhrases: intentTemplateData.noOfQuestions
    }))))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c9d1195117a73e5$var$HeadingContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt44ar7 _n7zlh6cr _1e0c1txw _zulputpp _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c9d1195117a73e5$var$ContentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt44ar7 _1e0c1txw _zulppxbi _2lx21bp4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c9d1195117a73e5$var$SectionContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _zulpu2gc",
            __cmplp.className
        ])
    });
});
const $7c9d1195117a73e5$var$TrainingPhrasesContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4 _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7xgow", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c2aeb8de4a6048b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e4d714792b8316262634de7a7fdee91a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1c2aeb8de4a6048b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "templateDialog_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "ScalarField",
            "name": "noOfQuestions"
        }
    ],
    "type": "VirtualAgentIntentTemplate"
};
$1c2aeb8de4a6048b$var$node.hash = "e3dbc52c4dc7e3bfd6c7e6a0e51a5090";
var $1c2aeb8de4a6048b$export$2e2bcd8739ae039 = $1c2aeb8de4a6048b$var$node;

});

parcelRegister("hA8XL", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e61ab46b287009e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0e61ab46b287009e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    fromYourDataDescription: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.intent-template.template-dialog.from-your-data-description",
        "defaultMessage": "Automatically created using recent data from this project\u2019s issues."
    },
    catalogTemplateDescription: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.intent-template.template-dialog.catalog-template-description",
        "defaultMessage": "We created this template based on the most common intents and issue categories used by IT teams."
    },
    summaryLabel: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.intent-template.template-dialog.summary-label",
        "defaultMessage": "Summary"
    },
    descriptionLabel: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.intent-template.template-dialog.description-label",
        "defaultMessage": "Description"
    },
    trainingPhrasesLabel: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.intent-template.template-dialog.training-phrases-label",
        "defaultMessage": "Training phrases"
    },
    trainingPhrasesNumber: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.intent-template.template-dialog.training-phrases-number",
        "defaultMessage": "{numberOfTrainingPhrases, plural, one {# phrase} other {# phrases}}"
    }
});

});



parcelRegister("1rZRo", function(module, exports) {

$parcel$export(module.exports, "LastUpdatedTimestamp", () => $36afb8347679f7ee$export$947ce57f79e430f5);

var $1AXwI = parcelRequire("1AXwI");

var $eUqFw = parcelRequire("eUqFw");

var $9KU0P = parcelRequire("9KU0P");

var $iWLL0 = parcelRequire("iWLL0");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $8M1qS = parcelRequire("8M1qS");
var $5JgJ2 = parcelRequire("5JgJ2");

var $iNL1K = parcelRequire("iNL1K");
const $36afb8347679f7ee$export$947ce57f79e430f5 = ({ intentTemplatesDataRef: intentTemplatesDataRef })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const intentTemplateData = (0, $iWLL0.useFragment)((0, $1AXwI.default), intentTemplatesDataRef);
    if (intentTemplateData.lastDiscoveredTemplatesGenerationTime == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $36afb8347679f7ee$var$textStyles
    }, formatMessage((0, $iNL1K.default).lastUpdatedTimeText, {
        timestampMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8M1qS.default), (0, $9KU0P.selectUnit)(new Date(intentTemplateData.lastDiscoveredTemplatesGenerationTime)))
    }));
};
const $36afb8347679f7ee$var$textStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.accent.gray'
});

});
parcelRegister("1AXwI", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d183556406c5309$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9781535bcf019c60403f0c560fa2d421>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6d183556406c5309$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDiscoveredTemplatesTimestampEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "lastUpdatedTimestamp_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar",
    "selections": [
        {
            "condition": "isDiscoveredTemplatesTimestampEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "lastDiscoveredTemplatesGenerationTime"
                }
            ]
        }
    ],
    "type": "VirtualAgentIntentTemplatesConnection"
};
$6d183556406c5309$var$node.hash = "e7960cb68368107f210dc45906451028";
var $6d183556406c5309$export$2e2bcd8739ae039 = $6d183556406c5309$var$node;

});

parcelRegister("iNL1K", function(module, exports) {

$parcel$export(module.exports, "default", () => $c23cd898b7b201da$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c23cd898b7b201da$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    lastUpdatedTimeText: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.last-updated-timestamp.last-updated-time-text",
        "defaultMessage": "Updated {timestampMessage}"
    }
});

});


parcelRegister("gGoYb", function(module, exports) {

$parcel$export(module.exports, "default", () => $3eb9aba23315190b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3eb9aba23315190b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    panelHeading: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.panel-heading",
        "defaultMessage": "Templates"
    },
    panelDescription: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.panel-description",
        "defaultMessage": "Select a pre-made template from our catalog, or a template automatically generated using your data."
    },
    infoIconLabel: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.info-icon-label",
        "defaultMessage": "More information about intent templates"
    },
    loadMoreTemplatesButton: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.load-more-templates-button",
        "defaultMessage": "Load more templates"
    },
    errorFlagTitle: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-flag-title",
        "defaultMessage": "We couldn't load intent templates"
    },
    errorFlagTitleQuestions: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-flag-title-questions",
        "defaultMessage": "We couldn\u2019t generate training phrases for this template"
    },
    errorFlagDescriptionQuestions: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-flag-description-questions",
        "defaultMessage": "Enter training phrases manually, or try using this template later. Intent templates are refreshed every week."
    },
    errorFlagDescription: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-flag-description",
        "defaultMessage": "Wait a moment and then try again."
    },
    closeIconLabel: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.close-icon-label",
        "defaultMessage": "Close intent templates sidebar"
    },
    activateAiSectionMessageTitle: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.activate-ai-section-message-title",
        "defaultMessage": "Activate Atlassian Intelligence to use custom templates"
    },
    activateAiSectionMessageDescription: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.activate-ai-section-message-description",
        "defaultMessage": "To use templates generated using your project\u2019s data, your organization admin needs to <link>activate Atlassian Intelligence</link>."
    },
    loadingTemplatesSectionMessageTitle: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.loading-templates-section-message-title",
        "defaultMessage": "We\u2019re loading your custom templates"
    },
    loadingTemplatesSectionMessageDescriptionOne: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.loading-templates-section-message-description-one",
        "defaultMessage": "When they\u2019re ready, you\u2019ll see <b>Your data</b> templates below."
    },
    loadingTemplatesSectionMessageDescriptionTwo: {
        "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.loading-templates-section-message-description-two",
        "defaultMessage": "If this message persists for more than 24 hours, you may not have enough data to generate templates (or there may be a technical problem). For help, <link>contact Support</link>."
    }
});

});



parcelRegister("aDZUE", function(module, exports) {

$parcel$export(module.exports, "VirtualAgentBrowseIntentsSkeleton", () => $2107e9b992980109$export$444026e4d4f156e4);
$parcel$export(module.exports, "VirtualAgentIntentsTableSkeleton", () => $2107e9b992980109$export$9dca41144a6398d2);
$parcel$export(module.exports, "VirtualAgentStatisticsSkeleton", () => $2107e9b992980109$export$538762e63d6466fe);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");

var $dQANa = parcelRequire("dQANa");

var $8c02P = parcelRequire("8c02P");

var $9jEIq = parcelRequire("9jEIq");
const $2107e9b992980109$var$customCssStyles = null;
const $2107e9b992980109$export$444026e4d4f156e4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dQANa))),
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });
const $2107e9b992980109$export$9dca41144a6398d2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8c02P))),
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });
const $2107e9b992980109$export$538762e63d6466fe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9jEIq))),
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

});
parcelRegister("dQANa", function(module, exports) {
module.exports = new URL("virtual-agent-browse-intents-app-skeleton.tpl.1eeb33c1.svg", import.meta.url).toString();

});

parcelRegister("8c02P", function(module, exports) {
module.exports = new URL("virtual-agent-intents-table-app-skeleton.tpl.e28c55f7.svg", import.meta.url).toString();

});

parcelRegister("9jEIq", function(module, exports) {
module.exports = new URL("virtual-agent-virtual-agent-statistics-app-skeleton.tpl.19ee5056.svg", import.meta.url).toString();

});


parcelRegister("89or4", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('fZcmC')
        ]);
        const value = parcelRequire('el3hk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("fZcmC")
    ]).then(()=>parcelRequire('el3hk'));
}

});

parcelRegister("8jrRa", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('20sq1')
        ]);
        const value = parcelRequire('fgxZN');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("20sq1")
    ]).then(()=>parcelRequire('fgxZN'));
}

});

parcelRegister("6n2CO", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('etJLF')
        ]);
        const value = parcelRequire('hOWr3');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("etJLF")
    ]).then(()=>parcelRequire('hOWr3'));
}

});

parcelRegister("lRSP3", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('bYLIe')
        ]);
        const value = parcelRequire('ibVof');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("bYLIe")
    ]).then(()=>parcelRequire('ibVof'));
}

});

parcelRegister("iHQVc", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('eYXxG')
        ]);
        const value = parcelRequire('2I6K7');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("eYXxG")
    ]).then(()=>parcelRequire('2I6K7'));
}

});

parcelRegister("ldLd9", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('cWESH')
        ]);
        const value = parcelRequire('fs5SN');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("cWESH")
    ]).then(()=>parcelRequire('fs5SN'));
}

});

parcelRegister("9BEdE", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('lAPNY')
        ]);
        const value = parcelRequire('5Aoxl');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("lAPNY")
    ]).then(()=>parcelRequire('5Aoxl'));
}

});

parcelRegister("fD4Jx", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h5Mpb')
        ]);
        const value = parcelRequire('5gCgJ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h5Mpb")
    ]).then(()=>parcelRequire('5gCgJ'));
}

});

parcelRegister("aje9D", function(module, exports) {

$parcel$export(module.exports, "changeManagementAssetConfigurationStatusResource", () => $2b5424021ed4802a$export$7570280d22ac9424);
// eslint-disable-next-line jira/restricted/@atlassian/jira-router

var $3HCkE = parcelRequire("3HCkE");
const $2b5424021ed4802a$export$4f27975b8a363797 = 'CHANGE_MANAGEMENT_ASSET_CONFIGURATION_STATUS';

const $2b5424021ed4802a$var$getDataLoader = ()=>(parcelRequire("aKcEN"));
const $2b5424021ed4802a$var$getKey = ({ match: match })=>typeof match.params.projectKey === 'string' ? match.params.projectKey : '';
const $2b5424021ed4802a$export$7570280d22ac9424 = (0, $3HCkE.createResource)({
    type: $2b5424021ed4802a$export$4f27975b8a363797,
    getKey: $2b5424021ed4802a$var$getKey,
    getDataLoader: $2b5424021ed4802a$var$getDataLoader,
    maxAge: Infinity
});

});
parcelRegister("aKcEN", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('6C3D2');
        const value = parcelRequire('hGYFw');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("6C3D2").then(()=>parcelRequire('hGYFw'));
}

});


parcelRegister("6ebW2", function(module, exports) {

$parcel$export(module.exports, "changeManagementSettingsProjectConfigurationResource", () => $61b06a43a204901d$export$2413ba18ec38282d);
// eslint-disable-next-line jira/restricted/@atlassian/jira-router

var $3HCkE = parcelRequire("3HCkE");
const $61b06a43a204901d$export$c0636b6062501e0b = 'CHANGE_MANAGEMENT_SETTINGS_PROJECT_CONFIG';

const $61b06a43a204901d$var$getDataLoader = ()=>(parcelRequire("C2zWY"));
const $61b06a43a204901d$var$getKey = ({ match: match })=>typeof match.params.projectKey === 'string' ? match.params.projectKey : '';
const $61b06a43a204901d$export$2413ba18ec38282d = (0, $3HCkE.createResource)({
    type: $61b06a43a204901d$export$c0636b6062501e0b,
    getKey: $61b06a43a204901d$var$getKey,
    getDataLoader: $61b06a43a204901d$var$getDataLoader,
    maxAge: Infinity
});

});
parcelRegister("C2zWY", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('aQwu1');
        const value = parcelRequire('bmyab');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("aQwu1").then(()=>parcelRequire('bmyab'));
}

});


parcelRegister("9oI9i", function(module, exports) {

$parcel$export(module.exports, "LoadingComponent", () => $cfb8808f819670e5$export$7db30d367db7d20a);
$parcel$export(module.exports, "LazyCsatSettingsPage", () => $cfb8808f819670e5$export$32eb62914bae0e84);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $4Bees = parcelRequire("4Bees");

var $4FWw6 = parcelRequire("4FWw6");
const $cfb8808f819670e5$export$7db30d367db7d20a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4FWw6.SpinnerContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "large"
    }));

const $cfb8808f819670e5$export$32eb62914bae0e84 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("1AftA")), {
    moduleId: "./src/packages/servicedesk/csat/src/index.tsx"
});

});
parcelRegister("4FWw6", function(module, exports) {

$parcel$export(module.exports, "SpinnerContainer", () => $7c2f7d4275f8833f$export$a5e06607a5ac6158);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $7c2f7d4275f8833f$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i68cl",
            __cmplp.className
        ])
    });
});

});

parcelRegister("1AftA", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('jBy3n');
        const value = parcelRequire('cH6gV');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("jBy3n").then(()=>parcelRequire('cH6gV'));
}

});


parcelRegister("lq02o", function(module, exports) {

$parcel$export(module.exports, "languageTranslationsResource", () => $056c0fb95de7914f$export$f51887e33895eab9);
$parcel$export(module.exports, "outgoingEmailStateModelResource", () => $056c0fb95de7914f$export$c460156a7e6b85b2);

var $3HCkE = parcelRequire("3HCkE");
const $056c0fb95de7914f$export$9f529be3aeae01ea = 'JSM Language Translations';
const $056c0fb95de7914f$export$ecd381e388e8c56f = "Language Support Customer Notification's Outgoing Email State";

const $056c0fb95de7914f$export$f51887e33895eab9 = (0, $3HCkE.createResource)({
    type: 'Language Translations',
    getKey: ({ match: { params: { projectKey: projectKey, languageKey: languageKey } } })=>`${$056c0fb95de7914f$export$9f529be3aeae01ea}-${projectKey}-${languageKey}`,
    getDataLoader: ()=>(parcelRequire("d9vkQ")),
    maxAge: Infinity
});

const $056c0fb95de7914f$export$c460156a7e6b85b2 = (0, $3HCkE.createResource)({
    type: 'Outgoing Email State Model',
    getKey: ()=>`${$056c0fb95de7914f$export$ecd381e388e8c56f}`,
    getDataLoader: ()=>(parcelRequire("4S93k")),
    maxAge: Infinity
});

});
parcelRegister("d9vkQ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('apMEE');
        const value = parcelRequire('bNtxL');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("apMEE").then(()=>parcelRequire('bNtxL'));
}

});

parcelRegister("4S93k", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('6jXt5');
        const value = parcelRequire('1aqBc');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("6jXt5").then(()=>parcelRequire('1aqBc'));
}

});


parcelRegister("ecIZv", function(module, exports) {

$parcel$export(module.exports, "LazyInternalNotificationSettingsPage", () => $6254efdc43440b61$export$501979bd6d492c43);

var $7rh0R = parcelRequire("7rh0R");

const $6254efdc43440b61$export$501979bd6d492c43 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("bc5hz")), {
    moduleId: "./src/packages/servicedesk/notification-internal/src/index.tsx"
});

});
parcelRegister("bc5hz", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('lIPYs')
        ]);
        const value = parcelRequire('6UnvP');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("lIPYs")
    ]).then(()=>parcelRequire('6UnvP'));
}

});


parcelRegister("1on9e", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('eNmuD'),
            load('h2MrD'),
            load('bYT2S'),
            load('b2AAQ')
        ]);
        const value = parcelRequire('iCpeT');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("eNmuD"),
        load("h2MrD"),
        load("bYT2S"),
        load("b2AAQ")
    ]).then(()=>parcelRequire('iCpeT'));
}

});

parcelRegister("UR9i3", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('eSQjy')
        ]);
        const value = parcelRequire('jnJkb');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("eSQjy")
    ]).then(()=>parcelRequire('jnJkb'));
}

});

parcelRegister("eKpI0", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('9P7jz')
        ]);
        const value = parcelRequire('1NzGW');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("9P7jz")
    ]).then(()=>parcelRequire('1NzGW'));
}

});

parcelRegister("gwVN3", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('f4Ghb')
        ]);
        const value = parcelRequire('5Y1oO');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("f4Ghb")
    ]).then(()=>parcelRequire('5Y1oO'));
}

});

parcelRegister("mrKpq", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('d69y3')
        ]);
        const value = parcelRequire('b7PAf');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("d69y3")
    ]).then(()=>parcelRequire('b7PAf'));
}

});

parcelRegister("gRiYm", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('gwFc6')
        ]);
        const value = parcelRequire('6shol');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("gwFc6")
    ]).then(()=>parcelRequire('6shol'));
}

});

parcelRegister("Y8hnW", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('2piQf')
        ]);
        const value = parcelRequire('h6ySE');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("2piQf")
    ]).then(()=>parcelRequire('h6ySE'));
}

});

parcelRegister("6uz22", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('8T0Ei');
        const value = parcelRequire('iDchO');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("8T0Ei").then(()=>parcelRequire('iDchO'));
}

});

parcelRegister("82cAp", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('f9VUQ')
        ]);
        const value = parcelRequire('n7EmG');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("f9VUQ")
    ]).then(()=>parcelRequire('n7EmG'));
}

});

parcelRegister("bD008", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('4PXFL');
        const value = parcelRequire('hWMFm');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("4PXFL").then(()=>parcelRequire('hWMFm'));
}

});

parcelRegister("gIQrA", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('h6c0y')
        ]);
        const value = parcelRequire('5Aqtw');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("h6c0y")
    ]).then(()=>parcelRequire('5Aqtw'));
}

});

parcelRegister("2UGOi", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('bdRgO');
        const value = parcelRequire('1XDmP');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("bdRgO").then(()=>parcelRequire('1XDmP'));
}

});

parcelRegister("lGn5M", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('4OxdX')
        ]);
        const value = parcelRequire('kiCAd');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("4OxdX")
    ]).then(()=>parcelRequire('kiCAd'));
}

});

parcelRegister("d0VAC", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('lOWsg')
        ]);
        const value = parcelRequire('84yQh');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("lOWsg")
    ]).then(()=>parcelRequire('84yQh'));
}

});

parcelRegister("8AOQk", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('65l4O')
        ]);
        const value = parcelRequire('fFAfT');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("65l4O")
    ]).then(()=>parcelRequire('fFAfT'));
}

});

parcelRegister("hbnZD", function(module, exports) {

$parcel$export(module.exports, "cardCoverImageResource", () => $0e21b8c7adec73cf$export$f37f52e28126ce75);

var $huI7r = parcelRequire("huI7r");

var $buJlM = parcelRequire("buJlM");

var $hYLcu = parcelRequire("hYLcu");

const $0e21b8c7adec73cf$export$f37f52e28126ce75 = (0, $buJlM.createRelayResource)({
    type: (0, $97128dcae00d9767$export$d9d248919fbd0611),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $hYLcu.default),
            variables: {
                boardId: (0, $huI7r.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("hYLcu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8da62d3ce09b83f2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<18030b1362ffffdd2f24b83852b88efd>>
 * @relayHash b790d69589aa0ef2a06a10dc57fc6bfc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4216a4fc24eb7ed0390f1effcdb5558af09a70f95660a0c572ae4b531ddc98fc
const $8da62d3ce09b83f2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "cardCoverSettingsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "SoftwareBoard",
                                    "kind": "LinkedField",
                                    "name": "board",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "toggle_boardSettingsCard_CardCoverToggle"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "cardPreview_boardSettingsCard"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.board"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "boardScope"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "cardCoverSettingsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SoftwareBoard",
                            "kind": "LinkedField",
                            "name": "board",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CardMediaConfig",
                                    "kind": "LinkedField",
                                    "name": "cardMedia",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "enabled"
                                        }
                                    ]
                                },
                                v2 /*: any*/ 
                            ]
                        },
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "4216a4fc24eb7ed0390f1effcdb5558af09a70f95660a0c572ae4b531ddc98fc",
            "metadata": {},
            "name": "cardCoverSettingsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8da62d3ce09b83f2$var$node.hash = "eb3068eeffbe9ec2fb99186c54005ea6";
var $8da62d3ce09b83f2$export$2e2bcd8739ae039 = $8da62d3ce09b83f2$var$node;

});

const $97128dcae00d9767$export$d9d248919fbd0611 = 'BOARD_CONTEXT_CARD_COVER_SETTINGS';


parcelRegister("a0UvO", function(module, exports) {

$parcel$export(module.exports, "customFiltersResource", () => $f5c0157e9c9bc2c1$export$3e390340716755de);

var $huI7r = parcelRequire("huI7r");

var $buJlM = parcelRequire("buJlM");

var $KeWba = parcelRequire("KeWba");

const $f5c0157e9c9bc2c1$export$3e390340716755de = (0, $buJlM.createRelayResource)({
    type: (0, $95ba5feea0d7365a$export$5917fd27c14066cd),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $KeWba.default),
            variables: {
                boardId: (0, $huI7r.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("KeWba", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a849caa59de39c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6c655bf5d42bc04990088e48dc6b757f>>
 * @relayHash 82ae1b9c2b4e7b31e211094a4e3f4f3f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c990befb5021511de9b1550aa7300067f8d87644e0d370c3754283355de50686
const $95a849caa59de39c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "customFiltersQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "CustomFilter",
                                    "kind": "LinkedField",
                                    "name": "customFilters",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "card_projectSettingsCustomFilters_customFilterFragmentRef"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.customFilters"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "card_projectSettingsCustomFilters_boardScopeFragmentRef"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "expandedCard_projectSettingsCustomFilters_boardScopeFragmentRef"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "boardScope"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "customFiltersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "CustomFilter",
                            "kind": "LinkedField",
                            "name": "customFilters",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "description"
                                },
                                {
                                    "concreteType": "FilterQuery",
                                    "kind": "LinkedField",
                                    "name": "filterQuery",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "sanitisedJql"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "errors"
                                        }
                                    ]
                                },
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        },
                        v3 /*: any*/ ,
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "c990befb5021511de9b1550aa7300067f8d87644e0d370c3754283355de50686",
            "metadata": {},
            "name": "customFiltersQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$95a849caa59de39c$var$node.hash = "2c5c0d030a87f3820766a2a896d71275";
var $95a849caa59de39c$export$2e2bcd8739ae039 = $95a849caa59de39c$var$node;

});

const $95ba5feea0d7365a$export$5917fd27c14066cd = 'NEXTGEN_PROJECT_SETTINGS_CUSTOM_FILTERS';


parcelRegister("3BLIV", function(module, exports) {

$parcel$export(module.exports, "projectSettingsToolchainResource", () => $4ca6c346e423908a$export$182dfe2bc7c28567);

var $1ybV0 = parcelRequire("1ybV0");

var $buJlM = parcelRequire("buJlM");

var $gKd1x = parcelRequire("gKd1x");

var $jwzNs = parcelRequire("jwzNs");
const $4ca6c346e423908a$export$b8927fea69d9f414 = 'PROJECT_SETTINGS_TOOLCHAIN';
const $4ca6c346e423908a$export$182dfe2bc7c28567 = (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('simplified-toolchain-page_g5582'), (0, $buJlM.createRelayResource)({
    type: $4ca6c346e423908a$export$b8927fea69d9f414,
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $gKd1x.default),
            variables: {
                cloudId: tenantContext?.cloudId || ''
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
}));

});
parcelRegister("gKd1x", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a36fb8785d94a5c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a2c9dc099d3b7d79cd74bd591996a945>>
 * @relayHash f5bf042c501578b47d326c7288427026
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2fc1f152f5ebcdcb577d22b928c317e308c8daf161c302627c4f00951b909409
const $8a36fb8785d94a5c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "concreteType": "DvcsQuery",
            "kind": "LinkedField",
            "name": "dvcs",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Literal",
                            "name": "first",
                            "value": 1
                        }
                    ],
                    "concreteType": "DvcsBitbucketWorkspaceConnection",
                    "kind": "LinkedField",
                    "name": "bitbucketWorkspacesLinkedToSite",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "DvcsBitbucketWorkspaceEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ui_projectSettingsToolchainQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ui_projectSettingsToolchainQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "2fc1f152f5ebcdcb577d22b928c317e308c8daf161c302627c4f00951b909409",
            "metadata": {},
            "name": "ui_projectSettingsToolchainQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8a36fb8785d94a5c$var$node.hash = "190735208b3c7baafbfc3c1808fa801b";
var $8a36fb8785d94a5c$export$2e2bcd8739ae039 = $8a36fb8785d94a5c$var$node;

});


parcelRegister("a3WTo", function(module, exports) {

$parcel$export(module.exports, "roadmapSettingsResource", () => $025d96f79795e52a$export$7901a008bd73bf46);

var $huI7r = parcelRequire("huI7r");

var $buJlM = parcelRequire("buJlM");

var $bAFgb = parcelRequire("bAFgb");

const $025d96f79795e52a$export$7901a008bd73bf46 = (0, $buJlM.createRelayResource)({
    type: (0, $1eef2c9e2260305d$export$e905b9170ecbb599),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>{
        const { cloudId: cloudId } = tenantContext;
        return {
            parameters: (0, $bAFgb.default),
            variables: {
                sourceAri: (0, $huI7r.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                }),
                locationAri: undefined
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    }
});

});
parcelRegister("bAFgb", function(module, exports) {

$parcel$export(module.exports, "default", () => $284ffc3ab370ce43$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<549802b43e67112dd5fba3309099c2de>>
 * @relayHash 19ad9a547bce255c35adc444386a03af
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6603bfc1272bd596fb67b3022210270e42d5bfb54ab2cf66470e7e5a8934ba80
const $284ffc3ab370ce43$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locationAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sourceAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "locationARI",
            "variableName": "locationAri"
        },
        {
            "kind": "Variable",
            "name": "sourceARI",
            "variableName": "sourceAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "isSprintsFeatureEnabled"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "roadmapSettingsQuery",
            "selections": [
                {
                    "concreteType": "RoadmapsQuery",
                    "kind": "LinkedField",
                    "name": "roadmaps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "RoadmapDetails",
                            "kind": "LinkedField",
                            "name": "roadmapForSource",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "RoadmapConfiguration",
                                        "kind": "LinkedField",
                                        "name": "roadmapConfiguration",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "RoadmapBoardConfiguration",
                                                    "kind": "LinkedField",
                                                    "name": "boardConfiguration",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "childIssuesSchedulingToggle_boardSettingsRoadmap"
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "childIssuesSchedulingPreview_boardSettingsRoadmap"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "roadmaps.roadmapForSource.roadmapConfiguration.boardConfiguration"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "roadmaps.roadmapForSource.roadmapConfiguration"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "roadmapSettingsQuery",
            "selections": [
                {
                    "concreteType": "RoadmapsQuery",
                    "kind": "LinkedField",
                    "name": "roadmaps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "RoadmapDetails",
                            "kind": "LinkedField",
                            "name": "roadmapForSource",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "RoadmapConfiguration",
                                    "kind": "LinkedField",
                                    "name": "roadmapConfiguration",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "RoadmapBoardConfiguration",
                                            "kind": "LinkedField",
                                            "name": "boardConfiguration",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isChildIssuePlanningEnabled"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "childIssuePlanningMode"
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6603bfc1272bd596fb67b3022210270e42d5bfb54ab2cf66470e7e5a8934ba80",
            "metadata": {},
            "name": "roadmapSettingsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$284ffc3ab370ce43$var$node.hash = "31c20159daaa03716587a1ccbe27ab14";
var $284ffc3ab370ce43$export$2e2bcd8739ae039 = $284ffc3ab370ce43$var$node;

});


parcelRegister("i6Rk2", function(module, exports) {

$parcel$export(module.exports, "connectionsPermissionsResource", () => $958eed3a7f5e0a11$export$6d43d6060bda7dc1);
// eslint-disable-next-line jira/restricted/@atlassian/jira-router

var $3HCkE = parcelRequire("3HCkE");
const $958eed3a7f5e0a11$export$9e2915b62c15ee5e = 'RESOURCE_TYPE_DEVOPS_CONNECTIONS_PERMISSIONS';

const $958eed3a7f5e0a11$export$6d43d6060bda7dc1 = (0, $3HCkE.createResource)({
    type: $958eed3a7f5e0a11$export$9e2915b62c15ee5e,
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: ()=>(parcelRequire("34Qg2")),
    isBrowserOnly: true,
    maxAge: 1800000
});

});
parcelRegister("34Qg2", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('eD0IB');
        const value = parcelRequire('hBAmi');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("eD0IB").then(()=>parcelRequire('hBAmi'));
}

});


parcelRegister("fLOYS", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('eNmuD'),
            load('h2MrD'),
            load('bYT2S'),
            load('l03hF')
        ]);
        const value = parcelRequire('ap7ak');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("eNmuD"),
        load("h2MrD"),
        load("bYT2S"),
        load("l03hF")
    ]).then(()=>parcelRequire('ap7ak'));
}

});

parcelRegister("cZXTd", function(module, exports) {

$parcel$export(module.exports, "devopsConnectionsResource", () => $f5a9e4b540693d5f$export$af9d0f45255fa705);

var $1ybV0 = parcelRequire("1ybV0");

var $huI7r = parcelRequire("huI7r");

var $buJlM = parcelRequire("buJlM");

var $lrb7h = parcelRequire("lrb7h");

var $jwzNs = parcelRequire("jwzNs");
const $f5a9e4b540693d5f$var$RESOURCE_TYPE_DEVOPS_CONNECTIONS = 'RESOURCE_TYPE_DEVOPS_CONNECTIONS';
const $f5a9e4b540693d5f$var$toolchainOverviewResource = (0, $jwzNs.resourceWithCondition2)(()=>!(0, $1ybV0.ff)('simplified-toolchain-page_g5582'), (0, $buJlM.createRelayResource)({
    type: $f5a9e4b540693d5f$var$RESOURCE_TYPE_DEVOPS_CONNECTIONS,
    isBrowserOnly: true,
    getQuery: (routerContext, { tenantContext: tenantContext })=>{
        const { query: query } = routerContext;
        return {
            parameters: (0, $lrb7h.default),
            variables: {
                siteAri: (0, $huI7r.createAri)({
                    resourceOwner: 'jira',
                    resourceType: 'site',
                    resourceId: tenantContext.cloudId
                }),
                projectId: (0, $huI7r.createAri)({
                    resourceOwner: 'jira',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'project',
                    resourceId: String(query.projectId)
                }),
                cloudId: tenantContext.cloudId,
                groupId: query.groupId,
                devOpsToolRelationshipsFilter: query.groupId ? {
                    hasPropertyEqualTo: {
                        key: 'groupId',
                        value: query.groupId
                    }
                } : null
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    }
}));
const $f5a9e4b540693d5f$export$af9d0f45255fa705 = $f5a9e4b540693d5f$var$toolchainOverviewResource;

});
parcelRegister("lrb7h", function(module, exports) {

$parcel$export(module.exports, "default", () => $60459d29d6966dcf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c51f4353e39b2cde20d18af1fdeadc33>>
 * @relayHash 9ac17eed8ccf78d01d97aa65df347b63
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ee7ee8fbc307b79c96c86825e8d17313c703e2d68aac3fb8040af5665a1b248b
const $60459d29d6966dcf$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "devOpsToolRelationshipsFilter"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "siteAri"
    }, v3 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "groupId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    }, v8 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "projectId"
    }, v9 = {
        "kind": "Literal",
        "name": "limit",
        "value": 100
    }, v10 = [
        v6 /*: any*/ 
    ], v11 = {
        "kind": "ScalarField",
        "name": "productKey"
    }, v12 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "siteAri"
    }, v13 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isDevOpsDataProvider"
    }, v14 = {
        "kind": "ScalarField",
        "name": "providerType"
    }, v15 = [
        v5 /*: any*/ ,
        v6 /*: any*/ 
    ], v16 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v17 = {
        "kind": "Variable",
        "name": "from",
        "variableName": "projectId"
    }, v18 = {
        "kind": "InlineFragment",
        "selections": v10 /*: any*/ ,
        "type": "ConfluenceSpace"
    }, v19 = {
        "kind": "InlineFragment",
        "selections": v10 /*: any*/ ,
        "type": "ConfluencePage"
    }, v20 = {
        "kind": "InlineFragment",
        "selections": v10 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v21 = {
        "kind": "InlineFragment",
        "selections": v10 /*: any*/ ,
        "type": "DevOpsFeatureFlag"
    }, v22 = {
        "kind": "InlineFragment",
        "selections": v10 /*: any*/ ,
        "type": "DevOpsOperationsComponentDetails"
    }, v23 = {
        "kind": "InlineFragment",
        "selections": v10 /*: any*/ ,
        "type": "DevOpsOperationsIncidentDetails"
    }, v24 = {
        "kind": "InlineFragment",
        "selections": v10 /*: any*/ ,
        "type": "DevOpsOperationsPostIncidentReviewDetails"
    }, v25 = {
        "kind": "InlineFragment",
        "selections": v10 /*: any*/ ,
        "type": "DevOpsPullRequestDetails"
    }, v26 = {
        "kind": "InlineFragment",
        "selections": v10 /*: any*/ ,
        "type": "DevOpsRepository"
    }, v27 = {
        "kind": "InlineFragment",
        "selections": v10 /*: any*/ ,
        "type": "DevOpsSecurityVulnerabilityDetails"
    }, v28 = {
        "kind": "InlineFragment",
        "selections": v10 /*: any*/ ,
        "type": "JiraConfluenceRemoteIssueLink"
    }, v29 = {
        "kind": "InlineFragment",
        "selections": v10 /*: any*/ ,
        "type": "JiraCustomRemoteIssueLink"
    }, v30 = {
        "kind": "InlineFragment",
        "selections": v10 /*: any*/ ,
        "type": "JiraIssueRemoteIssueLink"
    }, v31 = {
        "kind": "InlineFragment",
        "selections": v10 /*: any*/ ,
        "type": "JiraWebRemoteIssueLink"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "main_softwareProjectSettingsDevopsConnections_ToolchainOverviewQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_softwareProjectSettingsDevopsConnections_SideBar_groupRef"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "main_softwareProjectSettingsDevopsConnections_ToolchainOverviewAppCounts_data"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "main_softwareProjectSettingsDevopsConnections_ToolchainOverview_data"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "main_softwareProjectSettingsDevopsConnections_ToolchainOverviewQuery",
            "selections": [
                {
                    "concreteType": "DevOpsTools",
                    "kind": "LinkedField",
                    "name": "devOpsTools",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "DevOpsToolGroupConnection",
                            "kind": "LinkedField",
                            "name": "groups",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "DevOpsToolGroupEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "DevOpsToolGroup",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "groupName"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "concreteType": "DevOpsToolCategoryConnection",
                                                    "kind": "LinkedField",
                                                    "name": "categories",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "DevOpsToolCategoryEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "DevOpsToolCategory",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        v7 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "groups(first:20)"
                        },
                        {
                            "args": v3 /*: any*/ ,
                            "handle": "connection",
                            "key": "List_groups",
                            "kind": "LinkedHandle",
                            "name": "groups"
                        }
                    ]
                },
                {
                    "alias": "countDevOpsToolRelationships",
                    "args": [
                        v8 /*: any*/ ,
                        v9 /*: any*/ 
                    ],
                    "concreteType": "JiraProjectAndDevOpsToolRelationshipConnection",
                    "kind": "LinkedField",
                    "name": "devOpsToolRelationshipsForJiraProject",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraProjectAndDevOpsToolRelationshipEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectAndDevOpsToolRelationship",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "keys",
                                                    "value": [
                                                        "groupId"
                                                    ]
                                                }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "properties",
                                            "storageKey": "properties(keys:[\"groupId\"])"
                                        },
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                v8 /*: any*/ 
                            ],
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProject",
                            "plural": false,
                            "selections": v10 /*: any*/ 
                        }
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "filter",
                            "variableName": "devOpsToolRelationshipsFilter"
                        },
                        v8 /*: any*/ ,
                        v9 /*: any*/ 
                    ],
                    "concreteType": "JiraProjectAndDevOpsToolRelationshipConnection",
                    "kind": "LinkedField",
                    "name": "devOpsToolRelationshipsForJiraProject",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraProjectAndDevOpsToolRelationshipEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectAndDevOpsToolRelationship",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "concreteType": "DevOpsTool",
                                            "kind": "LinkedField",
                                            "name": "devOpsTool",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "supportsContainers"
                                                },
                                                v7 /*: any*/ ,
                                                {
                                                    "alias": "devInfoProvider",
                                                    "args": [
                                                        v12 /*: any*/ ,
                                                        {
                                                            "kind": "Literal",
                                                            "name": "providerTypes",
                                                            "value": [
                                                                "DEV_INFO"
                                                            ]
                                                        }
                                                    ],
                                                    "kind": "LinkedField",
                                                    "name": "provider",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v13 /*: any*/ ,
                                                        v14 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "alias": "documentationProvider",
                                                    "args": [
                                                        v12 /*: any*/ ,
                                                        {
                                                            "kind": "Literal",
                                                            "name": "providerTypes",
                                                            "value": [
                                                                "DOCUMENTATION"
                                                            ]
                                                        }
                                                    ],
                                                    "kind": "LinkedField",
                                                    "name": "provider",
                                                    "plural": false,
                                                    "selections": v15 /*: any*/ 
                                                },
                                                {
                                                    "alias": "securityProvider",
                                                    "args": [
                                                        v12 /*: any*/ ,
                                                        {
                                                            "kind": "Literal",
                                                            "name": "providerTypes",
                                                            "value": [
                                                                "SECURITY"
                                                            ]
                                                        }
                                                    ],
                                                    "kind": "LinkedField",
                                                    "name": "provider",
                                                    "plural": false,
                                                    "selections": v15 /*: any*/ 
                                                },
                                                {
                                                    "alias": "operationsProvider",
                                                    "args": [
                                                        v12 /*: any*/ ,
                                                        {
                                                            "kind": "Literal",
                                                            "name": "providerTypes",
                                                            "value": [
                                                                "OPERATIONS"
                                                            ]
                                                        }
                                                    ],
                                                    "kind": "LinkedField",
                                                    "name": "provider",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v13 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v14 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "DevOpsToolCategory",
                                                    "kind": "LinkedField",
                                                    "name": "category",
                                                    "plural": false,
                                                    "selections": v10 /*: any*/ 
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "integration",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        {
                                                            "kind": "TypeDiscriminator",
                                                            "abstractKey": "__isDevOpsToolIntegration"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "iconUrl"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "appKey"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "appName"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "marketplaceType"
                                                                },
                                                                {
                                                                    "concreteType": "DevOpsToolAppLinks",
                                                                    "kind": "LinkedField",
                                                                    "name": "links",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "configure"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "getStarted"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "support"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "DevOpsToolIntegrationApp"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v11 /*: any*/ 
                                                            ],
                                                            "type": "DevOpsToolIntegrationProduct"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "DevOpsToolGroup",
                                                    "kind": "LinkedField",
                                                    "name": "group",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "installed"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "containerRelationshipType"
                                                },
                                                v16 /*: any*/ 
                                            ]
                                        },
                                        v16 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v16 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "DevOps",
                    "kind": "LinkedField",
                    "name": "devOps",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "AriGraph",
                            "kind": "LinkedField",
                            "name": "ariGraph",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "documentationRelationships",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 1
                                        },
                                        v17 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "project-documentation-entity"
                                        }
                                    ],
                                    "concreteType": "AriGraphRelationshipConnection",
                                    "kind": "LinkedField",
                                    "name": "relationships",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "AriGraphRelationshipEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "AriGraphRelationship",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AriGraphRelationshipNode",
                                                            "kind": "LinkedField",
                                                            "name": "to",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": "confluenceEntity",
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v19 /*: any*/ ,
                                                                        v20 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v23 /*: any*/ ,
                                                                        v24 /*: any*/ ,
                                                                        v25 /*: any*/ ,
                                                                        v26 /*: any*/ ,
                                                                        v27 /*: any*/ ,
                                                                        v28 /*: any*/ ,
                                                                        v29 /*: any*/ ,
                                                                        v30 /*: any*/ ,
                                                                        v31 /*: any*/ 
                                                                    ]
                                                                },
                                                                v6 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "alias": "teamRelationships",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 5
                                        },
                                        v17 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "project-associated-opsgenie-team"
                                        }
                                    ],
                                    "concreteType": "AriGraphRelationshipConnection",
                                    "kind": "LinkedField",
                                    "name": "relationships",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "AriGraphRelationshipEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "AriGraphRelationship",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AriGraphRelationshipNode",
                                                            "kind": "LinkedField",
                                                            "name": "to",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": "opsgenieTeam",
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v10 /*: any*/ ,
                                                                            "type": "OpsgenieTeam"
                                                                        },
                                                                        v20 /*: any*/ ,
                                                                        v19 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v23 /*: any*/ ,
                                                                        v24 /*: any*/ ,
                                                                        v25 /*: any*/ ,
                                                                        v26 /*: any*/ ,
                                                                        v27 /*: any*/ ,
                                                                        v28 /*: any*/ ,
                                                                        v29 /*: any*/ ,
                                                                        v30 /*: any*/ ,
                                                                        v31 /*: any*/ 
                                                                    ]
                                                                },
                                                                v6 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ee7ee8fbc307b79c96c86825e8d17313c703e2d68aac3fb8040af5665a1b248b",
            "metadata": {},
            "name": "main_softwareProjectSettingsDevopsConnections_ToolchainOverviewQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$60459d29d6966dcf$var$node.hash = "80f3858d17ef63e42f4dab5d764e8b59";
var $60459d29d6966dcf$export$2e2bcd8739ae039 = $60459d29d6966dcf$var$node;

});


parcelRegister("1EHlZ", function(module, exports) {






if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("dlJ5e")),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('3vBNG')
        ]);
        const value = parcelRequire('anuF9');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("dlJ5e")),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("3vBNG")
    ]).then(()=>parcelRequire('anuF9'));
}

});

parcelRegister("bfwmf", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('7igMR')
        ]);
        const value = parcelRequire('4Org5');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("7igMR")
    ]).then(()=>parcelRequire('4Org5'));
}

});

parcelRegister("iCrPt", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('7LTGd')
        ]);
        const value = parcelRequire('azOrC');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("7LTGd")
    ]).then(()=>parcelRequire('azOrC'));
}

});

parcelRegister("8ZhXM", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('l1KCV')
        ]);
        const value = parcelRequire('1g8fI');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("l1KCV")
    ]).then(()=>parcelRequire('1g8fI'));
}

});

parcelRegister("8SpQk", function(module, exports) {






if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("79uJ5")),
            load('h2MrD'),
            load('bYT2S'),
            load('zWKyr')
        ]);
        const value = parcelRequire('9Ahcr');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("79uJ5")),
        load("h2MrD"),
        load("bYT2S"),
        load("zWKyr")
    ]).then(()=>parcelRequire('9Ahcr'));
}

});

parcelRegister("c1opB", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('1Wl62')
        ]);
        const value = parcelRequire('j3tbx');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("1Wl62")
    ]).then(()=>parcelRequire('j3tbx'));
}

});

parcelRegister("QK9gT", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('03UdH');
        const value = parcelRequire('61eeP');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("03UdH").then(()=>parcelRequire('61eeP'));
}

});

parcelRegister("e6KiRe", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('qUF2T')
        ]);
        const value = parcelRequire('7onSv');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("qUF2T")
    ]).then(()=>parcelRequire('7onSv'));
}

});

parcelRegister("7dQ41", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('2vPGy')
        ]);
        const value = parcelRequire('1Pujx');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("2vPGy")
    ]).then(()=>parcelRequire('1Pujx'));
}

});

parcelRegister("gcXWF", function(module, exports) {

$parcel$export(module.exports, "jsmBoardRoute", () => $2bd2ada1d304a75f$export$a192088aab559fa1);

var $exb0h = parcelRequire("exb0h");
const $2bd2ada1d304a75f$export$a192088aab559fa1 = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    path: '/jira/servicedesk/projects/:projectKey/boards/:boardId',
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_BOARDS
};

});

parcelRegister("gP7iL", function(module, exports) {






if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("7SZy3")),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('dATFB')
        ]);
        const value = parcelRequire('fTb4A');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("7SZy3")),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("dATFB")
    ]).then(()=>parcelRequire('fTb4A'));
}

});

parcelRegister("53aZi", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('a9oNj')
        ]);
        const value = parcelRequire('iLnp2');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("a9oNj")
    ]).then(()=>parcelRequire('iLnp2'));
}

});

parcelRegister("fILpt", function(module, exports) {

$parcel$export(module.exports, "getCalendarFilterFieldsResource", () => $770b70483961ea68$export$5f02bf5f04197ed7);
$parcel$export(module.exports, "useCalendarFilterResource", () => $770b70483961ea68$export$70361b748d216408);

var $JRB5w = parcelRequire("JRB5w");
var $lRmyA = parcelRequire("lRmyA");

var $3HCkE = parcelRequire("3HCkE");

var $9zYls = parcelRequire("9zYls");

var $a8V3L = parcelRequire("a8V3L");


var $jaKS8 = parcelRequire("jaKS8");
const $770b70483961ea68$var$fetchFilterFields = async (cloudId, jqlContext)=>{
    try {
        const response = await (0, $lRmyA.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $fbdb8beb1b8cc007$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId,
                    contextFieldsFilter: {
                        searchString: (0, $a8V3L.REQUEST_TYPE_FILTER)
                    },
                    jqlContext: jqlContext
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'JiraJqlBuilder'
            }
        });
        return (0, $jaKS8.transformAndReport)(response);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!(0, $JRB5w.isHttpClientErrorResponse)(error)) (0, $jaKS8.reportError)(error);
        return 0, $a8V3L.DEFAULT_CALENDAR_FILTER_FIELDS;
    }
};
const $770b70483961ea68$var$filterFieldsResource = (0, $3HCkE.createResource)({
    type: (0, $a8V3L.RESOURCE_TYPE_FILTER_FIELD),
    getKey: ()=>(0, $a8V3L.RESOURCE_TYPE_FILTER_FIELD),
    getData: ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
        const projectIdOrKey = projectKey || projectId;
        const jqlContext = `project = '${projectIdOrKey}'`;
        return $770b70483961ea68$var$fetchFilterFields(cloudId, jqlContext);
    },
    maxAge: Infinity
});
const $770b70483961ea68$export$5f02bf5f04197ed7 = ()=>$770b70483961ea68$var$filterFieldsResource;
const $770b70483961ea68$export$70361b748d216408 = ()=>(0, $3HCkE.useResource)($770b70483961ea68$var$filterFieldsResource);

});
parcelRegister("a8V3L", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_NAME", () => $996bfa2502238e2c$export$186e93e8ef3f9358);
$parcel$export(module.exports, "PACKAGE_NAME", () => $996bfa2502238e2c$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $996bfa2502238e2c$export$d57b6b390e78d90f);
$parcel$export(module.exports, "REQUEST_TYPE_FILTER", () => $996bfa2502238e2c$export$2c388650eabddf5e);
$parcel$export(module.exports, "RESOURCE_TYPE_FILTER_FIELD", () => $996bfa2502238e2c$export$2019de80301f1da);
$parcel$export(module.exports, "DEFAULT_CALENDAR_FILTER_FIELDS", () => $996bfa2502238e2c$export$2912f30d4328fc00);
const $996bfa2502238e2c$export$186e93e8ef3f9358 = 'calendarFilterFieldResource';
const $996bfa2502238e2c$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesServicedeskCalendar';
const $996bfa2502238e2c$export$d57b6b390e78d90f = 'jsd-shield';
const $996bfa2502238e2c$export$2c388650eabddf5e = 'request type';
const $996bfa2502238e2c$export$2019de80301f1da = 'RESOURCE_TYPE_FILTER_FIELD';
const $996bfa2502238e2c$export$2912f30d4328fc00 = [
    'status',
    'assignee'
];

});

const $fbdb8beb1b8cc007$export$2b91517d6d5b4365 = `
query findRequestTypeCustomFieldQuery($cloudId: ID!, $contextFieldsFilter: JiraJQLContextFieldsFilter!, $jqlContext: String!) {
  jira {
    jqlBuilder(cloudId: $cloudId) {
        fields(jqlContextFieldsFilter: $contextFieldsFilter, jqlContext: $jqlContext) {
          ... on JiraJqlFieldConnection {
            __typename
            edges {
              node {
                jqlTerm
                displayName
                type
                searchTemplate {
                  key
                }
                operators
              }
            }
          }
          ... on QueryError {
            __typename
          }
        }
      }
  }
}
`;

parcelRegister("jaKS8", function(module, exports) {

$parcel$export(module.exports, "reportError", () => $1da546145946fa4b$export$b33b857ad1d9900e);
$parcel$export(module.exports, "transformAndReport", () => $1da546145946fa4b$export$af2aa11c88c551af);

var $guiFP = parcelRequire("guiFP");

var $a8V3L = parcelRequire("a8V3L");
const $1da546145946fa4b$var$TARGET_FILTER_TYPE = 'com.atlassian.servicedesk:vp-origin';
const $1da546145946fa4b$var$TARGET_FILTER_SEARCH_TEMPLATE = 'com.atlassian.servicedesk:vp-origin-searcher';
const $1da546145946fa4b$export$b33b857ad1d9900e = (error)=>{
    (0, $guiFP.default)({
        error: error,
        sendToPrivacyUnsafeSplunk: true,
        meta: {
            id: (0, $a8V3L.RESOURCE_TYPE_NAME),
            packageName: (0, $a8V3L.PACKAGE_NAME),
            teamName: (0, $a8V3L.TEAM_NAME)
        }
    });
};
const $1da546145946fa4b$export$af2aa11c88c551af = (response)=>{
    const edges = response.data?.jira?.jqlBuilder?.fields?.edges;
    // There may be ambigious custom fields with same name, so find the correct one and pass to JQLBuilder
    const requestType = edges?.find((edge)=>edge?.node?.type === $1da546145946fa4b$var$TARGET_FILTER_TYPE && edge?.node?.searchTemplate?.key === $1da546145946fa4b$var$TARGET_FILTER_SEARCH_TEMPLATE)?.node;
    if (!requestType) $1da546145946fa4b$export$b33b857ad1d9900e(new Error('Unable to prefetch request type'));
    // if requestType field found, add it to existing default calendar filter fields
    return requestType ? [
        {
            ...requestType,
            searchTemplate: requestType.searchTemplate.key,
            fieldType: requestType.type
        },
        ...(0, $a8V3L.DEFAULT_CALENDAR_FILTER_FIELDS)
    ] : (0, $a8V3L.DEFAULT_CALENDAR_FILTER_FIELDS);
};

});


parcelRegister("iYkTm", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('i6ssL')
        ]);
        const value = parcelRequire('2MHsR');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("i6ssL")
    ]).then(()=>parcelRequire('2MHsR'));
}

});

parcelRegister("dKd0o", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('b1WAv')
        ]);
        const value = parcelRequire('2vUTH');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("b1WAv")
    ]).then(()=>parcelRequire('2vUTH'));
}

});

parcelRegister("k0e1o", function(module, exports) {

$parcel$export(module.exports, "servicedeskChangeCalendarRoute", () => $c97df291f3cf4bc4$export$3dbc16ae422c469);

var $exb0h = parcelRequire("exb0h");
const $c97df291f3cf4bc4$export$3dbc16ae422c469 = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_CHANGE_CALENDAR,
    path: '/jira/servicedesk/projects/:projectKey/change-calendar',
    exact: true
};

});

parcelRegister("bi6Rj", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('jFTOZ')
        ]);
        const value = parcelRequire('7V0JL');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("jFTOZ")
    ]).then(()=>parcelRequire('7V0JL'));
}

});

parcelRegister("fbNJV", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('3lcly');
        const value = parcelRequire('d4Bvf');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("3lcly").then(()=>parcelRequire('d4Bvf'));
}

});

parcelRegister("c4Cxp", function(module, exports) {

$parcel$export(module.exports, "serviceDeskAssetsImportTypeForgeDataResource", () => $8aecdcc7d552ca0e$export$58d2462746e91c7d);

var $3HCkE = parcelRequire("3HCkE");

const $8aecdcc7d552ca0e$var$getDataLoader = ()=>(parcelRequire("fE3MN"));
const $8aecdcc7d552ca0e$export$58d2462746e91c7d = (0, $3HCkE.createResource)({
    type: 'ASSETS_IMPORT_TYPE_FORGE_DATA',
    getKey: ()=>'extensions',
    getDataLoader: $8aecdcc7d552ca0e$var$getDataLoader,
    maxAge: Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});

});
parcelRegister("fE3MN", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('lGAOb');
        const value = parcelRequire('9tDIa');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("lGAOb").then(()=>parcelRequire('9tDIa'));
}

});


parcelRegister("2R39g", function(module, exports) {

$parcel$export(module.exports, "insightObjectResource", () => $6dcb08a484c7adbd$export$215464c8085c5e35);

var $3HCkE = parcelRequire("3HCkE");

var $gY2Nz = parcelRequire("gY2Nz");
const $6dcb08a484c7adbd$var$RESOURCE_TYPE_SERVICEDESK_INSIGHT_OBJECT = 'SERVICEDESK_INSIGHT_OBJECT';
const $6dcb08a484c7adbd$export$215464c8085c5e35 = (0, $3HCkE.createResource)({
    type: $6dcb08a484c7adbd$var$RESOURCE_TYPE_SERVICEDESK_INSIGHT_OBJECT,
    getKey: ({ match: match })=>match.params.objectId || '',
    getData: $gY2Nz.default,
    isBrowserOnly: true
});

});
parcelRegister("gY2Nz", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fc074aaa670fd4e$export$2e2bcd8739ae039);

var $6iz4v = parcelRequire("6iz4v");

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");

var $5yh8X = parcelRequire("5yh8X");

var $eEeZ0 = parcelRequire("eEeZ0");

var $aeCba = parcelRequire("aeCba");

var $bhwgQ = parcelRequire("bhwgQ");
const $9fc074aaa670fd4e$var$fetchInsightObjectDetails = async (routeDataContext, routerContext)=>{
    try {
        const { match: { params: params } } = routeDataContext;
        const { objectId: objectId } = params;
        if (objectId == null) return null;
        const workspaceId = await (0, $aeCba.default)(routeDataContext, routerContext);
        if (workspaceId == null) return null;
        const data = await (0, $2OdyW.default)((0, $eEeZ0.getCmdbObjectByIdUrl)(workspaceId, objectId));
        (0, $6iz4v.setMark)((0, $5yh8X.prefetchApiReadyMark));
        return data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('jiraServicedeskInsightObjectResource', error);
        (0, $guiFP.default)({
            meta: {
                id: 'jiraServicedeskInsightObjectResource',
                packageName: 'jiraSpa'
            },
            error: error
        });
        throw error;
    }
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9fc074aaa670fd4e$export$2e2bcd8739ae039 = async (routeDataContext, routerContext)=>{
    const { tenantContext: tenantContext } = routerContext;
    // Early exit on these cases and return a valid response. We don't want to flood sentry.
    if (!(0, $bhwgQ.checkAuthentication)(tenantContext)) return null;
    return $9fc074aaa670fd4e$var$fetchInsightObjectDetails(routeDataContext, routerContext);
};

});
parcelRegister("eEeZ0", function(module, exports) {

$parcel$export(module.exports, "getCmdbObjectByIdUrl", () => $9c6f81b5e0e0cf6b$export$d33c3e25476d091d);
$parcel$export(module.exports, "getCmdbObjectByIdUrlWithoutQueryParams", () => $9c6f81b5e0e0cf6b$export$6ef8997552257871);
$parcel$export(module.exports, "getCmdbObjectByIdActivityUrl", () => $9c6f81b5e0e0cf6b$export$20c207abffb62450);
$parcel$export(module.exports, "getCmdbObjectByIdAvatarUrl", () => $9c6f81b5e0e0cf6b$export$31df868d16d545f8);
$parcel$export(module.exports, "getCmdbObjectByIdReferenceInfoUrl", () => $9c6f81b5e0e0cf6b$export$5044a1e9fc201773);
$parcel$export(module.exports, "getCmdbObjectCloneByIdUrl", () => $9c6f81b5e0e0cf6b$export$d7f6dc1d4f622458);
$parcel$export(module.exports, "getCmdbObjectCreateUrl", () => $9c6f81b5e0e0cf6b$export$9cdc19e8944d38cf);
$parcel$export(module.exports, "getCmdbObjectNavlistUrl", () => $9c6f81b5e0e0cf6b$export$bf9c534c2cd21829);
$parcel$export(module.exports, "getCmdbObjectNavlistQueryLanguageUrl", () => $9c6f81b5e0e0cf6b$export$b35334340ee827fa);
$parcel$export(module.exports, "getCmdbObjectRecentUrl", () => $9c6f81b5e0e0cf6b$export$a0a7c6f22bebdef0);
$parcel$export(module.exports, "getCmdbObjectQueryLanguageTotalCountUrl", () => $9c6f81b5e0e0cf6b$export$ee74f95a469c4433);

var $53ciZ = parcelRequire("53ciZ");

var $bKxX9 = parcelRequire("bKxX9");

var $cPk3F = parcelRequire("cPk3F");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/object
 */ const $9c6f81b5e0e0cf6b$var$getCmdbObjectUrl = (workspaceId)=>`${(0, $cPk3F.getCmdbRestBaseUrl)(workspaceId)}/object`;
const $9c6f81b5e0e0cf6b$export$d33c3e25476d091d = (workspaceId, objectId, includeExtendedInfo = false)=>{
    const path = $9c6f81b5e0e0cf6b$export$6ef8997552257871(workspaceId, objectId);
    if ((0, $bKxX9.ff)('fly-2135-get-object-exclude-extendedinfo_h42nd') && !includeExtendedInfo) return `${path}?${(0, $53ciZ.stringify)({
        includeExtendedInfo: includeExtendedInfo
    })}`;
    return path;
};
const $9c6f81b5e0e0cf6b$export$6ef8997552257871 = (workspaceId, objectId)=>`${$9c6f81b5e0e0cf6b$var$getCmdbObjectUrl(workspaceId)}/${objectId}`;
const $9c6f81b5e0e0cf6b$export$20c207abffb62450 = (workspaceId, objectId, queryParams)=>`${$9c6f81b5e0e0cf6b$export$6ef8997552257871(workspaceId, objectId)}/activity?${(0, $53ciZ.stringify)(queryParams)}`;
const $9c6f81b5e0e0cf6b$export$31df868d16d545f8 = (workspaceId, objectId)=>`${$9c6f81b5e0e0cf6b$export$6ef8997552257871(workspaceId, objectId)}/avatar`;
const $9c6f81b5e0e0cf6b$export$5044a1e9fc201773 = (workspaceId, objectId)=>`${$9c6f81b5e0e0cf6b$export$6ef8997552257871(workspaceId, objectId)}/referenceinfo`;
const $9c6f81b5e0e0cf6b$export$d7f6dc1d4f622458 = (workspaceId, objectId)=>`${$9c6f81b5e0e0cf6b$var$getCmdbObjectUrl(workspaceId)}/clone/${objectId}`;
const $9c6f81b5e0e0cf6b$export$9cdc19e8944d38cf = (workspaceId)=>`${$9c6f81b5e0e0cf6b$var$getCmdbObjectUrl(workspaceId)}/create`;
const $9c6f81b5e0e0cf6b$export$bf9c534c2cd21829 = (workspaceId)=>`${$9c6f81b5e0e0cf6b$var$getCmdbObjectUrl(workspaceId)}/navlist`;
const $9c6f81b5e0e0cf6b$export$b35334340ee827fa = (workspaceId)=>`${$9c6f81b5e0e0cf6b$export$bf9c534c2cd21829(workspaceId)}/aql`;
const $9c6f81b5e0e0cf6b$export$a0a7c6f22bebdef0 = (workspaceId, queryParams)=>`${$9c6f81b5e0e0cf6b$var$getCmdbObjectUrl(workspaceId)}/recent?${(0, $53ciZ.stringify)(queryParams)}`;
const $9c6f81b5e0e0cf6b$export$ee74f95a469c4433 = (workspaceId)=>`${$9c6f81b5e0e0cf6b$var$getCmdbObjectUrl(workspaceId)}/aql/totalcount`;

});
parcelRegister("cPk3F", function(module, exports) {

$parcel$export(module.exports, "getCmdbRestBaseUrl", () => $a20c166f3eb000cf$export$28b6c003daedf1c2);
const $a20c166f3eb000cf$export$28b6c003daedf1c2 = (workspaceId)=>`/gateway/api/jsm/assets/workspace/${workspaceId}/v1`;

});




parcelRegister("272oI", function(module, exports) {

$parcel$export(module.exports, "ASSETS_ROUTE_PREFIX", () => $1ee561ab017acd59$export$c90f45511b7ccc85);
$parcel$export(module.exports, "INSIGHT_ROUTE_PREFIX", () => $1ee561ab017acd59$export$6d7574dbda22cf7);
$parcel$export(module.exports, "isInsightRoute", () => $1ee561ab017acd59$export$296d80f3ce129968);
$parcel$export(module.exports, "getCreateServiceUrl", () => $1ee561ab017acd59$export$1f9b8b558a361aaf);
$parcel$export(module.exports, "getRootPath", () => $1ee561ab017acd59$export$5413f45d031c7806);
$parcel$export(module.exports, "getLandingPageUrl", () => $1ee561ab017acd59$export$9366da5a373815e5);
$parcel$export(module.exports, "getGlobalConfigUrl", () => $1ee561ab017acd59$export$20fd4a0aec335970);
$parcel$export(module.exports, "getDataManagerUrl", () => $1ee561ab017acd59$export$c9b27b0d2e19d52f);
$parcel$export(module.exports, "getDataManagerAdaptersUrl", () => $1ee561ab017acd59$export$cd6b35373ba077a);
$parcel$export(module.exports, "getAssetsReportsUrl", () => $1ee561ab017acd59$export$c1909404b7ea317f);
$parcel$export(module.exports, "createObjectSchemasUrl", () => $1ee561ab017acd59$export$c48ea1282c74411e);
$parcel$export(module.exports, "createObjectSchemaUrl", () => $1ee561ab017acd59$export$3a0332e980fe56cf);
$parcel$export(module.exports, "createObjectTypeUrl", () => $1ee561ab017acd59$export$cfefb90cfb86b528);
$parcel$export(module.exports, "createObjectSchemaConfigUrl", () => $1ee561ab017acd59$export$f02479149ce3cac7);
$parcel$export(module.exports, "createObjectDetailUrl", () => $1ee561ab017acd59$export$51e4229f2c7d3866);
$parcel$export(module.exports, "createObjectTypeSettingsUrl", () => $1ee561ab017acd59$export$4b4b7d2c3df4fa58);
$parcel$export(module.exports, "createObjectTypeListWithObjectSelectedUrl", () => $1ee561ab017acd59$export$c1790fa8f0d8e89a);
$parcel$export(module.exports, "getFeatureUsagePageUrl", () => $1ee561ab017acd59$export$5ba89eed0cf60033);
$parcel$export(module.exports, "SCHEMA_PAGE_QUERY_PARAMS", () => (parcelRequire("7lEPK")).SCHEMA_PAGE_QUERY_PARAMS);

var $7lEPK = parcelRequire("7lEPK");
const $1ee561ab017acd59$export$ee637ecb2dfa4f6a = '/jira/servicedesk/service-modal';
const $1ee561ab017acd59$export$c90f45511b7ccc85 = '/jira/servicedesk/assets';
const $1ee561ab017acd59$export$6d7574dbda22cf7 = '/jira/servicedesk/insight';
const $1ee561ab017acd59$export$296d80f3ce129968 = (pathname)=>pathname.includes($1ee561ab017acd59$export$6d7574dbda22cf7);
const $1ee561ab017acd59$export$1f9b8b558a361aaf = ()=>$1ee561ab017acd59$export$ee637ecb2dfa4f6a;
const $1ee561ab017acd59$export$5413f45d031c7806 = ()=>$1ee561ab017acd59$export$c90f45511b7ccc85;
const $1ee561ab017acd59$export$9366da5a373815e5 = ()=>$1ee561ab017acd59$export$5413f45d031c7806();
const $1ee561ab017acd59$export$20fd4a0aec335970 = ()=>`${$1ee561ab017acd59$export$5413f45d031c7806()}/configure/global`;
const $1ee561ab017acd59$export$c9b27b0d2e19d52f = ()=>`${$1ee561ab017acd59$export$5413f45d031c7806()}/data-manager/`;
const $1ee561ab017acd59$export$cd6b35373ba077a = ()=>`${$1ee561ab017acd59$export$5413f45d031c7806()}/data-manager/adapters/`;
const $1ee561ab017acd59$export$c1909404b7ea317f = ()=>`${$1ee561ab017acd59$export$5413f45d031c7806()}/reports`;
const $1ee561ab017acd59$export$c48ea1282c74411e = ()=>`${$1ee561ab017acd59$export$5413f45d031c7806()}/object-schemas`;
const $1ee561ab017acd59$export$3a0332e980fe56cf = (objectSchemaId)=>`${$1ee561ab017acd59$export$5413f45d031c7806()}/object-schema/${objectSchemaId}`;
const $1ee561ab017acd59$export$cfefb90cfb86b528 = (objectSchemaId, objectTypeId)=>`${$1ee561ab017acd59$export$3a0332e980fe56cf(objectSchemaId)}?${(0, $7lEPK.SCHEMA_PAGE_QUERY_PARAMS).objectTypeId}=${objectTypeId}`;
const $1ee561ab017acd59$export$f02479149ce3cac7 = (objectSchemaId)=>`${$1ee561ab017acd59$export$5413f45d031c7806()}/configure/object-schema/${objectSchemaId}`;
const $1ee561ab017acd59$export$51e4229f2c7d3866 = (objectId)=>`${$1ee561ab017acd59$export$c90f45511b7ccc85}/object/${objectId}`;
const $1ee561ab017acd59$export$4b4b7d2c3df4fa58 = (objectTypeId)=>`${$1ee561ab017acd59$export$5413f45d031c7806()}/configure/object-type/${objectTypeId}`;
const $1ee561ab017acd59$export$c1790fa8f0d8e89a = (objectSchemaId, objectTypeId, objectId)=>`${$1ee561ab017acd59$export$cfefb90cfb86b528(objectSchemaId, objectTypeId)}&view=list&objectId=${objectId}`;
const $1ee561ab017acd59$export$5ba89eed0cf60033 = ()=>'/jira/settings/products/servicedesk/feature-usage';

});
parcelRegister("7lEPK", function(module, exports) {

$parcel$export(module.exports, "SCHEMA_PAGE_QUERY_PARAMS", () => $77a5b92f13f64b9e$export$a73deb42718b5c4);
$parcel$export(module.exports, "useUpdateQueryParams", () => $77a5b92f13f64b9e$export$e66acc5f4583ce1c);
$parcel$export(module.exports, "useObjectTypeIdQueryParam", () => $77a5b92f13f64b9e$export$f5a33d51dd6de08);
$parcel$export(module.exports, "useObjectIdQueryParam", () => $77a5b92f13f64b9e$export$a6e3187c87554a1e);
$parcel$export(module.exports, "useSchemaViewModeQueryParam", () => $77a5b92f13f64b9e$export$6abda0ad26022eff);
$parcel$export(module.exports, "useObjectViewModeQueryParam", () => $77a5b92f13f64b9e$export$1927b50f7d074492);

var $eUqFw = parcelRequire("eUqFw");

var $53ciZ = parcelRequire("53ciZ");

var $kJlBc = parcelRequire("kJlBc");

var $aSJew = parcelRequire("aSJew");
const $77a5b92f13f64b9e$export$a73deb42718b5c4 = {
    // Values are 'object' or 'attribute'
    schemaMode: 'mode',
    // Values are 'list' or undefined
    objectViewMode: 'view',
    // Both of these params are supported to set the object type ID. 'typeId' is preferred and is the one that is updated.
    // 'objecttypeid' is only used on initial load to support customers who have bookmarked this URL.
    objectTypeId: 'typeId',
    fallbackObjectTypeId: 'objecttypeid',
    objectId: 'objectId'
};
const $77a5b92f13f64b9e$export$e66acc5f4583ce1c = ()=>{
    const { push: push } = (0, $kJlBc.useRouterActions)();
    const [{ location: location }] = (0, $kJlBc.useRouter)();
    const updateQueryParams = (0, $eUqFw.useCallback)((queryParams = {})=>{
        const { pathname: pathname, search: search } = location;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedQueryParams = {};
        Object.keys(queryParams).forEach((key)=>{
            updatedQueryParams[key] = queryParams[key] ?? undefined;
        });
        return `${pathname}?${(0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify({
            ...(0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(search),
            ...updatedQueryParams
        })}`;
    }, [
        location
    ]);
    const pushRouterAction = (0, $eUqFw.useCallback)((path)=>{
        push(path);
    }, [
        push
    ]);
    return [
        {
            updateQueryParams: updateQueryParams,
            pushRouterAction: pushRouterAction
        }
    ];
};
const $77a5b92f13f64b9e$export$f5a33d51dd6de08 = ()=>{
    const [objectTypeId, setObjectTypeId] = (0, $kJlBc.useQueryParam)($77a5b92f13f64b9e$export$a73deb42718b5c4.objectTypeId);
    const [fallbackObjectTypeId, setFallbackObjectTypeId] = (0, $kJlBc.useQueryParam)($77a5b92f13f64b9e$export$a73deb42718b5c4.fallbackObjectTypeId);
    (0, $eUqFw.useEffect)(()=>{
        if (fallbackObjectTypeId !== undefined) {
            setObjectTypeId((0, $aSJew.toCmdbObjectTypeId)(fallbackObjectTypeId), 'replace');
            setFallbackObjectTypeId(undefined, 'replace');
        }
    }, [
        fallbackObjectTypeId,
        setObjectTypeId,
        setFallbackObjectTypeId
    ]);
    const nullableMain = objectTypeId !== undefined ? (0, $aSJew.toCmdbObjectTypeId)(objectTypeId) : null;
    const nullableFallback = fallbackObjectTypeId !== undefined ? (0, $aSJew.toCmdbObjectTypeId)(fallbackObjectTypeId) : null;
    const setter = (newObjectTypeId, updateType)=>{
        setObjectTypeId(newObjectTypeId !== null ? newObjectTypeId : undefined, updateType);
    };
    return [
        nullableMain !== null ? nullableMain : nullableFallback,
        setter
    ];
};
const $77a5b92f13f64b9e$export$a6e3187c87554a1e = ()=>{
    const [objectId, setObjectId] = (0, $kJlBc.useQueryParam)($77a5b92f13f64b9e$export$a73deb42718b5c4.objectId);
    const nullableObjectId = objectId !== undefined ? (0, $aSJew.toCmdbObjectId)(objectId) : null;
    const setter = (newObjectId, updateType)=>{
        setObjectId(newObjectId !== null ? newObjectId : undefined, updateType);
    };
    return [
        nullableObjectId,
        setter
    ];
};
const $77a5b92f13f64b9e$export$6abda0ad26022eff = ()=>{
    const [rawParamValue, setSchemaMode] = (0, $kJlBc.useQueryParam)($77a5b92f13f64b9e$export$a73deb42718b5c4.schemaMode);
    const schemaMode = rawParamValue === 'attribute' ? 'attribute' : 'object';
    return [
        schemaMode,
        setSchemaMode
    ];
};
const $77a5b92f13f64b9e$export$1927b50f7d074492 = ()=>{
    const [rawParamValue, setObjectViewMode] = (0, $kJlBc.useQueryParam)($77a5b92f13f64b9e$export$a73deb42718b5c4.objectViewMode);
    const objectViewMode = rawParamValue === 'list' ? 'list' : 'details';
    const setter = (newValue, updateMode)=>{
        setObjectViewMode(newValue === 'list' ? 'list' : undefined, updateMode);
    };
    return [
        objectViewMode,
        setter
    ];
};

});


parcelRegister("dnpHo", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('6MVV2');
        const value = parcelRequire('ob5Eg');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("6MVV2").then(()=>parcelRequire('ob5Eg'));
}

});

parcelRegister("aYi6Q", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('1XhbT')
        ]);
        const value = parcelRequire('SFMYO');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("1XhbT")
    ]).then(()=>parcelRequire('SFMYO'));
}

});

parcelRegister("fLw3s", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('fluxa')
        ]);
        const value = parcelRequire('hAUgK');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("fluxa")
    ]).then(()=>parcelRequire('hAUgK'));
}

});

parcelRegister("eHhZD", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('2ozyE')
        ]);
        const value = parcelRequire('69gCp');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("2ozyE")
    ]).then(()=>parcelRequire('69gCp'));
}

});

parcelRegister("eSEog", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('aruzd')
        ]);
        const value = parcelRequire('lmYMe');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("aruzd")
    ]).then(()=>parcelRequire('lmYMe'));
}

});

parcelRegister("3lVe9", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('2EWfN')
        ]);
        const value = parcelRequire('14WKF');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("2EWfN")
    ]).then(()=>parcelRequire('14WKF'));
}

});

parcelRegister("cjrCp", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('gR50v')
        ]);
        const value = parcelRequire('inhGb');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("gR50v")
    ]).then(()=>parcelRequire('inhGb'));
}

});

parcelRegister("8JmcU", function(module, exports) {






if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("lfjBo")),
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('9ZqB6')
        ]);
        const value = parcelRequire('1zf9p');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("lfjBo")),
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("9ZqB6")
    ]).then(()=>parcelRequire('1zf9p'));
}

});

parcelRegister("amrg7", function(module, exports) {






if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("7130r")),
            load('5pyDL')
        ]);
        const value = parcelRequire('lQfg3');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("7130r")),
        load("5pyDL")
    ]).then(()=>parcelRequire('lQfg3'));
}

});

parcelRegister("1tqnI", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('7Ij2K');
        const value = parcelRequire('9Q1at');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("7Ij2K").then(()=>parcelRequire('9Q1at'));
}

});

parcelRegister("cgHBu", function(module, exports) {

$parcel$export(module.exports, "entitlementsCustomerQueryResource", () => $c91d400cbfcc7da5$export$78737979422d6907);

var $buJlM = parcelRequire("buJlM");

var $dxWcW = parcelRequire("dxWcW");
const $c91d400cbfcc7da5$export$78737979422d6907 = (0, $buJlM.createRelayResource)({
    type: 'ENTITLEMENTS_CUSTOMER_QUERY',
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $dxWcW.default),
            variables: {
                accountId: String(match.params.customerId),
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("dxWcW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f2062bc7e23061a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2d711ace41d650be975013cf5a90d182>>
 * @relayHash 2d56ae07e9224712e6cbeb1d40c0d517
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b6e68492e4403956991e93b2bec1552e11424884520f6d91d362bfb3f950af38
const $5f2062bc7e23061a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v3 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "accountId"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v9 = [
        v7 /*: any*/ ,
        v6 /*: any*/ 
    ], v10 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "entitlementsCustomerQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v2 /*: any*/ ,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "CustomerServiceProductConnection",
                                    "kind": "LinkedField",
                                    "name": "productConnections",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "CustomerServiceProductEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "CustomerServiceProduct",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v4 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "customerService.productConnections.edges"
                                        }
                                    ],
                                    "storageKey": "productConnections(first:1)"
                                },
                                "action": "THROW",
                                "path": "customerService.productConnections"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v5 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "individualByAccountId",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v7 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "customerService.individualByAccountId.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "CustomerServiceEntitlement",
                                                        "kind": "LinkedField",
                                                        "name": "entitlementList",
                                                        "plural": true,
                                                        "selections": [
                                                            v7 /*: any*/ ,
                                                            {
                                                                "args": [
                                                                    {
                                                                        "kind": "Literal",
                                                                        "name": "includeEntityTypeName",
                                                                        "value": true
                                                                    }
                                                                ],
                                                                "kind": "FragmentSpread",
                                                                "name": "entitlement_servicedeskCustomerServiceEntitlementsCard"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "customerService.individualByAccountId.entitlementList"
                                                },
                                                v8 /*: any*/ 
                                            ],
                                            "type": "CustomerServiceIndividual"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "throwOnQueryError_servicedeskCustomerServiceCommon"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "customerService.individualByAccountId"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "customerService"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "entitlementsCustomerQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "CustomerServiceProductConnection",
                            "kind": "LinkedField",
                            "name": "productConnections",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CustomerServiceProductEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "CustomerServiceProduct",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "productConnections(first:1)"
                        },
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "individualByAccountId",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "concreteType": "CustomerServiceEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlementList",
                                            "plural": true,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "concreteType": "CustomerServiceProduct",
                                                    "kind": "LinkedField",
                                                    "name": "product",
                                                    "plural": false,
                                                    "selections": v9 /*: any*/ 
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "entity",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v9 /*: any*/ ,
                                                            "type": "CustomerServiceOrganization"
                                                        },
                                                        v10 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ],
                                    "type": "CustomerServiceIndividual"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "identifier"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "statusCode"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "errorType"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                v10 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b6e68492e4403956991e93b2bec1552e11424884520f6d91d362bfb3f950af38",
            "metadata": {},
            "name": "entitlementsCustomerQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5f2062bc7e23061a$var$node.hash = "52b18fa6e520ef1142f20ddded30f5ba";
var $5f2062bc7e23061a$export$2e2bcd8739ae039 = $5f2062bc7e23061a$var$node;

});


parcelRegister("77XtT", function(module, exports) {

$parcel$export(module.exports, "uiCustomerDetailsPageQueryResource", () => $e26739e95b236549$export$d766b4bd7ad23814);

var $1ybV0 = parcelRequire("1ybV0");

var $buJlM = parcelRequire("buJlM");

var $by9Fs = parcelRequire("by9Fs");
const $e26739e95b236549$export$d766b4bd7ad23814 = (0, $buJlM.createRelayResource)({
    type: 'UI_CUSTOMER_DETAILS_PAGE_QUERY',
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $by9Fs.default),
            variables: {
                accountId: String(match.params.customerId),
                cloudId: tenantContext.cloudId,
                includePlatformValue: (0, $1ybV0.ff)('csm-shipit-58-user-custom-detail-type_be1zw')
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("by9Fs", function(module, exports) {

$parcel$export(module.exports, "default", () => $472b02353c9240be$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4ff5330c791580d4725bfbf473bfdc7c>>
 * @relayHash 226dd80e8f692fcea07019db756cdf92
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3abab2ca3ed03087b939047432f3b1fcfa21be84241b52a2d86ab8b01756e299
const $472b02353c9240be$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includePlatformValue"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "accountId"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "identifier"
            },
            {
                "kind": "ScalarField",
                "name": "message"
            },
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "statusCode"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "errorType"
                    }
                ]
            }
        ],
        "type": "QueryError"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "uiCustomerDetailsPageQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v3 /*: any*/ ,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v4 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "individualByAccountId",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "organizations_servicedeskCustomerDetails"
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "details",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Variable",
                                                                    "name": "includePlatformValue",
                                                                    "variableName": "includePlatformValue"
                                                                }
                                                            ],
                                                            "kind": "FragmentSpread",
                                                            "name": "customDetailsSidebar_servicedeskCustomerServiceCustomDetailsSidebar_Inner"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "CustomerServiceOrganization",
                                                    "kind": "LinkedField",
                                                    "name": "organizations",
                                                    "plural": true,
                                                    "selections": [
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "CustomerServiceIndividual"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "throwOnQueryError_servicedeskCustomerServiceCommon"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "customerService.individualByAccountId"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "customerService"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "uiCustomerDetailsPageQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "individualByAccountId",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "concreteType": "CustomerServiceOrganization",
                                            "kind": "LinkedField",
                                            "name": "organizations",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "details",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isCustomerServiceCustomDetailValuesQueryResult"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "CustomerServiceCustomDetailValue",
                                                            "kind": "LinkedField",
                                                            "name": "results",
                                                            "plural": true,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "values"
                                                                },
                                                                {
                                                                    "concreteType": "CustomerServiceCustomDetailType",
                                                                    "kind": "LinkedField",
                                                                    "name": "type",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "options"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "CustomerServiceCustomDetailConfigMetadata",
                                                                    "kind": "LinkedField",
                                                                    "name": "config",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "CustomerServiceCustomAttributeStyleConfiguration",
                                                                            "kind": "LinkedField",
                                                                            "name": "styleConfiguration",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "CustomerServiceCustomAttributeOptionsStyleConfiguration",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "options",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "optionValue"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "CustomerServiceCustomAttributeOptionStyle",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "style",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "backgroundColour"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "includePlatformValue",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "platformValue",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v5 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "accountId"
                                                                                        },
                                                                                        v7 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "avatarUrl"
                                                                                        }
                                                                                    ],
                                                                                    "type": "CustomerServiceUserDetailValue"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "CustomerServiceCustomDetailValues"
                                                },
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "CustomerServiceIndividual"
                                },
                                v8 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3abab2ca3ed03087b939047432f3b1fcfa21be84241b52a2d86ab8b01756e299",
            "metadata": {},
            "name": "uiCustomerDetailsPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$472b02353c9240be$var$node.hash = "984bf9ee443ecf803605044a14728802";
var $472b02353c9240be$export$2e2bcd8739ae039 = $472b02353c9240be$var$node;

});


parcelRegister("fjxAH", function(module, exports) {

$parcel$export(module.exports, "servicedeskCustomersV2Route", () => $6be329edd302ba66$export$89e9e350610ee31e);
$parcel$export(module.exports, "servicedeskCustomerDetailsRoute", () => $6be329edd302ba66$export$42c0f04d04ecd1f8);

var $exb0h = parcelRequire("exb0h");
const $6be329edd302ba66$export$89e9e350610ee31e = {
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_CUSTOMERS_V2,
    path: '/jira/servicedesk/projects/:projectKey/customers'
};
const $6be329edd302ba66$export$42c0f04d04ecd1f8 = {
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_CUSTOMER_DETAILS,
    path: '/jira/servicedesk/projects/:projectKey/customers/:customerId'
};

});

parcelRegister("lwS9x", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('a2bnB')
        ]);
        const value = parcelRequire('2TEqc');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("a2bnB")
    ]).then(()=>parcelRequire('2TEqc'));
}

});

parcelRegister("wY4W8", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('7iYSs')
        ]);
        const value = parcelRequire('2OQhU');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("7iYSs")
    ]).then(()=>parcelRequire('2OQhU'));
}

});

parcelRegister("1a6Wh", function(module, exports) {

$parcel$export(module.exports, "projectServiceDeskRoute", () => $48d1c095208636aa$export$1cfc858068dd8718);

var $exb0h = parcelRequire("exb0h");
const $48d1c095208636aa$export$1cfc858068dd8718 = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_REDIRECT,
    path: '/jira/servicedesk/projects/:projectKey'
};

});

parcelRegister("kOAof", function(module, exports) {

$parcel$export(module.exports, "gspPageRoute", () => $d21189e3ca632108$export$23f42abb017854bb);

var $exb0h = parcelRequire("exb0h");
const $d21189e3ca632108$export$23f42abb017854bb = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_GETTING_STARTED_PAGE,
    path: '/jira/servicedesk/projects/:projectKey/getting-started'
};

});

parcelRegister("8jb44", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('dqX8Z')
        ]);
        const value = parcelRequire('bfpCl');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("dqX8Z")
    ]).then(()=>parcelRequire('bfpCl'));
}

});

parcelRegister("dsgwg", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('3ekWX');
        const value = parcelRequire('fTzcE');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("3ekWX").then(()=>parcelRequire('fTzcE'));
}

});

parcelRegister("fsmKq", function(module, exports) {

$parcel$export(module.exports, "getKnowledgeHubBaseUrl", () => $81fe88a10c85f36f$export$1fe78c01c9fe0ebd);
$parcel$export(module.exports, "knowledgeHubLandingRoute", () => $81fe88a10c85f36f$export$239eaf6a202e0f54);
$parcel$export(module.exports, "knowledgeHubBrowseAllArticlesRoute", () => $81fe88a10c85f36f$export$c8e99e3434791c0e);
$parcel$export(module.exports, "knowledgeHubDraftsRoute", () => $81fe88a10c85f36f$export$670f3b59aa55b7ae);
$parcel$export(module.exports, "knowledgeHubBrowseAllCategoriesRoute", () => $81fe88a10c85f36f$export$256f841794b3f077);
$parcel$export(module.exports, "knowledgeHubSuggestedArticlesRoute", () => $81fe88a10c85f36f$export$54edf5cef1c6b21b);
$parcel$export(module.exports, "knowledgeHubBrowseViewArticleRoute", () => $81fe88a10c85f36f$export$ef8a9ec2979d1b10);
$parcel$export(module.exports, "knowledgeHubArticleEmbedEditorRoute", () => $81fe88a10c85f36f$export$bd512c426b095693);
$parcel$export(module.exports, "knowledgeHubAllArticlesRoute", () => $81fe88a10c85f36f$export$20e57a83f181da7b);
$parcel$export(module.exports, "knowledgeHubArticleInCategoryRoute", () => $81fe88a10c85f36f$export$3afe8482ce820835);
$parcel$export(module.exports, "knowledgeHubCategoryPageRoute", () => $81fe88a10c85f36f$export$79fb48a07e43639a);
$parcel$export(module.exports, "knowledgeHubCategoryRoute", () => $81fe88a10c85f36f$export$69ed5b0214ea6ee5);
$parcel$export(module.exports, "knowledgeHubSearchRoute", () => $81fe88a10c85f36f$export$a47c36fb081b544d);
$parcel$export(module.exports, "knowledgeHubSetupRoute", () => $81fe88a10c85f36f$export$f20770545704547d);

var $exb0h = parcelRequire("exb0h");
const $81fe88a10c85f36f$export$1fe78c01c9fe0ebd = (projectKey)=>`/jira/servicedesk/projects/${projectKey}/knowledge`;
const $81fe88a10c85f36f$export$239eaf6a202e0f54 = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).KNOWLEDGE_HUB_LANDING,
    path: '/jira/servicedesk/projects/:projectKey/knowledge',
    exact: true
};
const $81fe88a10c85f36f$export$c8e99e3434791c0e = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).KNOWLEDGE_HUB_BROWSE_ALL_ARTICLES,
    path: '/jira/servicedesk/projects/:projectKey/knowledge/articles',
    exact: true
};
const $81fe88a10c85f36f$export$670f3b59aa55b7ae = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).KNOWLEDGE_HUB_DRAFTS,
    path: '/jira/servicedesk/projects/:projectKey/knowledge/drafts',
    exact: true
};
const $81fe88a10c85f36f$export$256f841794b3f077 = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).KNOWLEDGE_HUB_BROWSE_ALL_CATEGORIES,
    path: '/jira/servicedesk/projects/:projectKey/knowledge/categories',
    exact: true
};
const $81fe88a10c85f36f$export$54edf5cef1c6b21b = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).KNOWLEDGE_HUB_SUGGESTED_ARTICLES,
    path: '/jira/servicedesk/projects/:projectKey/knowledge/suggested-articles',
    exact: true
};
const $81fe88a10c85f36f$export$ef8a9ec2979d1b10 = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).KNOWLEDGE_HUB_BROWSE_VIEW_ARTICLE,
    path: '/jira/servicedesk/projects/:projectKey/knowledge/articles/:articleId'
};
const $81fe88a10c85f36f$export$bd512c426b095693 = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).KNOWLEDGE_HUB_ARTICLE_EMBED_EDITOR,
    path: '/jira/servicedesk/projects/:projectKey/knowledge/space/:spaceKey/articles/:articleId/edit',
    query: [
        'draftShareId?'
    ]
};
const $81fe88a10c85f36f$export$20e57a83f181da7b = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).KNOWLEDGE_HUB_ALL_ARTICLES,
    path: '/jira/servicedesk/projects/:projectKey/knowledge/browse/page/:pageId'
};
const $81fe88a10c85f36f$export$3afe8482ce820835 = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).KNOWLEDGE_HUB_ARTICLE_IN_CATEGORY,
    path: '/jira/servicedesk/projects/:projectKey/knowledge/categories/:categoryId/articles/:articleId'
};
const $81fe88a10c85f36f$export$79fb48a07e43639a = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).KNOWLEDGE_HUB_CATEGORY_PAGE,
    path: '/jira/servicedesk/projects/:projectKey/knowledge/categories/:categoryId/browse/page/:pageId'
};
const $81fe88a10c85f36f$export$69ed5b0214ea6ee5 = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).KNOWLEDGE_HUB_CATEGORY,
    path: '/jira/servicedesk/projects/:projectKey/knowledge/categories/:categoryId'
};
const $81fe88a10c85f36f$export$a47c36fb081b544d = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).KNOWLEDGE_HUB_SEARCH,
    path: '/jira/servicedesk/projects/:projectKey/knowledge/search/articles/:articleId'
};
const $81fe88a10c85f36f$export$f20770545704547d = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).KNOWLEDGE_HUB_SETUP,
    path: '/jira/servicedesk/projects/:projectKey/knowledge/setup'
};

});

parcelRegister("k9xav", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('2q6S9')
        ]);
        const value = parcelRequire('fxVjP');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("2q6S9")
    ]).then(()=>parcelRequire('fxVjP'));
}

});

parcelRegister("fVB0r", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('iBwJJ');
        const value = parcelRequire('1UxKS');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("iBwJJ").then(()=>parcelRequire('1UxKS'));
}

});

parcelRegister("elNJh", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('klS1f');
        const value = parcelRequire('eleJt');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("klS1f").then(()=>parcelRequire('eleJt'));
}

});

parcelRegister("fhtv7", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('lNQM3')
        ]);
        const value = parcelRequire('gJBdY');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("lNQM3")
    ]).then(()=>parcelRequire('gJBdY'));
}

});

parcelRegister("9L9Xq", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('in1ah')
        ]);
        const value = parcelRequire('fYSeu');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("in1ah")
    ]).then(()=>parcelRequire('fYSeu'));
}

});

parcelRegister("eHbq2", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('2dMRf')
        ]);
        const value = parcelRequire('ccFSM');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("2dMRf")
    ]).then(()=>parcelRequire('ccFSM'));
}

});

parcelRegister("6m9Ef", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('4stfa')
        ]);
        const value = parcelRequire('gTFlF');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("4stfa")
    ]).then(()=>parcelRequire('gTFlF'));
}

});

parcelRegister("d7pHu", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('9as6I');
        const value = parcelRequire('azbAe');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("9as6I").then(()=>parcelRequire('azbAe'));
}

});

parcelRegister("jbFqF", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('82hO7')
        ]);
        const value = parcelRequire('3rmG2');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("82hO7")
    ]).then(()=>parcelRequire('3rmG2'));
}

});

parcelRegister("5Z6fS", function(module, exports) {

$parcel$export(module.exports, "notificationLogsRoute", () => $d910838a3fbf59ae$export$c947c80f138bc137);

var $exb0h = parcelRequire("exb0h");
const $d910838a3fbf59ae$export$c947c80f138bc137 = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).NOTIFICATION_LOGS,
    path: '/jira/servicedesk/projects/:projectKey/notification-logs',
    exact: true
};

});

parcelRegister("eUjPI", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('1CuF8')
        ]);
        const value = parcelRequire('5kwAW');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("1CuF8")
    ]).then(()=>parcelRequire('5kwAW'));
}

});

parcelRegister("giKK2", function(module, exports) {

$parcel$export(module.exports, "servicedeskOncallScheduleRoute", () => $6347bb2f6d40dbe7$export$740e6e5e982b48a9);

var $exb0h = parcelRequire("exb0h");
const $6347bb2f6d40dbe7$export$e05c5e9dacfbd89d = '/jira/servicedesk/projects/:projectKey';
const $6347bb2f6d40dbe7$export$740e6e5e982b48a9 = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_ONCALL_SCHEDULE,
    path: `${$6347bb2f6d40dbe7$export$e05c5e9dacfbd89d}/on-call-schedule`,
    exact: true
};

});

parcelRegister("a2XkH", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('50rQJ')
        ]);
        const value = parcelRequire('3Gs2y');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("50rQJ")
    ]).then(()=>parcelRequire('3Gs2y'));
}

});

parcelRegister("9LviW", function(module, exports) {

$parcel$export(module.exports, "serviceDeskOrganizationPanelForgeDataResource", () => $422aa623eb5a3ab0$export$f3c46a19f3594363);

var $3HCkE = parcelRequire("3HCkE");


const $422aa623eb5a3ab0$var$getDataLoader = ()=>(parcelRequire("dWK9z"));
const $422aa623eb5a3ab0$export$f3c46a19f3594363 = (0, $3HCkE.createResource)({
    type: (0, $3f32b6d9d9e0b2f0$export$66d6e1e05866ee2f),
    getKey: ({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        return `extension-${projectKey}`;
    },
    getDataLoader: $422aa623eb5a3ab0$var$getDataLoader,
    maxAge: Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});

});
const $3f32b6d9d9e0b2f0$export$66d6e1e05866ee2f = 'ORGANIZATION_PANEL_FORGE_DATA';

parcelRegister("dWK9z", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('5BykT');
        const value = parcelRequire('8STZb');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("5BykT").then(()=>parcelRequire('8STZb'));
}

});


parcelRegister("lKl3G", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('k3pSH')
        ]);
        const value = parcelRequire('6cwa1');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("k3pSH")
    ]).then(()=>parcelRequire('6cwa1'));
}

});

parcelRegister("a5AeJ", function(module, exports) {

$parcel$export(module.exports, "entitlementsOrganizationQueryResource", () => $a524c85d18fc84ca$export$fead08d66d56688e);

var $buJlM = parcelRequire("buJlM");

var $bNYVo = parcelRequire("bNYVo");
const $a524c85d18fc84ca$export$fead08d66d56688e = (0, $buJlM.createRelayResource)({
    type: 'ENTITLEMENTS_ORGANIZATION_QUERY',
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $bNYVo.default),
            variables: {
                organizationId: String(match.params.organizationId),
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("bNYVo", function(module, exports) {

$parcel$export(module.exports, "default", () => $c04cf6e2bd324ba6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5505d7bd1e485943d52683e3e287125b>>
 * @relayHash 4fd7c02cf85ce43ff1f3b2c2885428f1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 01a04225033d1c240e60c2831c34cc958b17cd0c6be52ce6b65c5484adb41a6f
const $c04cf6e2bd324ba6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "organizationId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "organizationId",
            "variableName": "organizationId"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entitlementsOrganizationQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "CustomerServiceProductConnection",
                                    "kind": "LinkedField",
                                    "name": "productConnections",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "CustomerServiceProductEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "CustomerServiceProduct",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v3 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "customerService.productConnections.edges"
                                        }
                                    ],
                                    "storageKey": "productConnections(first:1)"
                                },
                                "action": "THROW",
                                "path": "customerService.productConnections"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v4 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "organizationByOrganizationId",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v6 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "customerService.organizationByOrganizationId.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "CustomerServiceEntitlement",
                                                        "kind": "LinkedField",
                                                        "name": "entitlementList",
                                                        "plural": true,
                                                        "selections": [
                                                            v6 /*: any*/ ,
                                                            {
                                                                "args": [
                                                                    {
                                                                        "kind": "Literal",
                                                                        "name": "includeEntityTypeName",
                                                                        "value": false
                                                                    }
                                                                ],
                                                                "kind": "FragmentSpread",
                                                                "name": "entitlement_servicedeskCustomerServiceEntitlementsCard"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "customerService.organizationByOrganizationId.entitlementList"
                                                },
                                                v7 /*: any*/ 
                                            ],
                                            "type": "CustomerServiceOrganization"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "throwOnQueryError_servicedeskCustomerServiceCommon"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "customerService.organizationByOrganizationId"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "customerService"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entitlementsOrganizationQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "CustomerServiceProductConnection",
                            "kind": "LinkedField",
                            "name": "productConnections",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "CustomerServiceProductEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "CustomerServiceProduct",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "productConnections(first:1)"
                        },
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "organizationByOrganizationId",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "concreteType": "CustomerServiceEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlementList",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "concreteType": "CustomerServiceProduct",
                                                    "kind": "LinkedField",
                                                    "name": "product",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v7 /*: any*/ 
                                    ],
                                    "type": "CustomerServiceOrganization"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "identifier"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "statusCode"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "errorType"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "01a04225033d1c240e60c2831c34cc958b17cd0c6be52ce6b65c5484adb41a6f",
            "metadata": {},
            "name": "entitlementsOrganizationQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c04cf6e2bd324ba6$var$node.hash = "c2dbf2a99cb38657b66de75f23707712";
var $c04cf6e2bd324ba6$export$2e2bcd8739ae039 = $c04cf6e2bd324ba6$var$node;

});


parcelRegister("eJxBd", function(module, exports) {

$parcel$export(module.exports, "uiOrganizationDetailsPageQueryResource", () => $cb3bd8377436ecce$export$ab65064827d1831d);

var $1ybV0 = parcelRequire("1ybV0");

var $buJlM = parcelRequire("buJlM");

var $anC01 = parcelRequire("anC01");
const $cb3bd8377436ecce$export$ab65064827d1831d = (0, $buJlM.createRelayResource)({
    type: 'UI_ORGANIZATION_DETAILS_PAGE_QUERY',
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $anC01.default),
            variables: {
                organizationId: String(match.params.organizationId),
                cloudId: tenantContext.cloudId,
                includePlatformValue: (0, $1ybV0.ff)('csm-shipit-58-user-custom-detail-type_be1zw')
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("anC01", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b0b5acef3133ac7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dfce2b06b0c830a8f6523142f2756a59>>
 * @relayHash 1fb0e2c154f9b455382ba8244b677096
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d58194e75192e81acfb275cd490a11b48ce7af40547d0f7def2fde2b5f42a740
const $0b0b5acef3133ac7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includePlatformValue"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "organizationId"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "organizationId",
            "variableName": "organizationId"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "identifier"
            },
            {
                "kind": "ScalarField",
                "name": "message"
            },
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "statusCode"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "errorType"
                    }
                ]
            }
        ],
        "type": "QueryError"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "uiOrganizationDetailsPageQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v3 /*: any*/ ,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v4 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "organizationByOrganizationId",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "details",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Variable",
                                                                    "name": "includePlatformValue",
                                                                    "variableName": "includePlatformValue"
                                                                }
                                                            ],
                                                            "kind": "FragmentSpread",
                                                            "name": "customDetailsSidebar_servicedeskCustomerServiceCustomDetailsSidebar_Inner"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "CustomerServiceOrganization"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "throwOnQueryError_servicedeskCustomerServiceCommon"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "customerService.organizationByOrganizationId"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "customerService"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "uiOrganizationDetailsPageQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "organizationByOrganizationId",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "details",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isCustomerServiceCustomDetailValuesQueryResult"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "CustomerServiceCustomDetailValue",
                                                            "kind": "LinkedField",
                                                            "name": "results",
                                                            "plural": true,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "values"
                                                                },
                                                                {
                                                                    "concreteType": "CustomerServiceCustomDetailType",
                                                                    "kind": "LinkedField",
                                                                    "name": "type",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "options"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "CustomerServiceCustomDetailConfigMetadata",
                                                                    "kind": "LinkedField",
                                                                    "name": "config",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "CustomerServiceCustomAttributeStyleConfiguration",
                                                                            "kind": "LinkedField",
                                                                            "name": "styleConfiguration",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "CustomerServiceCustomAttributeOptionsStyleConfiguration",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "options",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "optionValue"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "CustomerServiceCustomAttributeOptionStyle",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "style",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "backgroundColour"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "includePlatformValue",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "platformValue",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v5 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "accountId"
                                                                                        },
                                                                                        v7 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "avatarUrl"
                                                                                        }
                                                                                    ],
                                                                                    "type": "CustomerServiceUserDetailValue"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "CustomerServiceCustomDetailValues"
                                                },
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "CustomerServiceOrganization"
                                },
                                v8 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d58194e75192e81acfb275cd490a11b48ce7af40547d0f7def2fde2b5f42a740",
            "metadata": {},
            "name": "uiOrganizationDetailsPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0b0b5acef3133ac7$var$node.hash = "147efcaabd31b4ad00faf6a31f721232";
var $0b0b5acef3133ac7$export$2e2bcd8739ae039 = $0b0b5acef3133ac7$var$node;

});


parcelRegister("7FYcB", function(module, exports) {

$parcel$export(module.exports, "servicedeskOrganizationsRoute", () => $cef85bb01340f590$export$d4a712c5bc3c3434);
$parcel$export(module.exports, "servicedeskOrganizationDetailsRoute", () => $cef85bb01340f590$export$eacc4723293cbc36);

var $exb0h = parcelRequire("exb0h");
const $cef85bb01340f590$export$d4a712c5bc3c3434 = {
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_ORGANIZATIONS,
    path: '/jira/servicedesk/projects/:projectKey/organizations'
};
const $cef85bb01340f590$export$eacc4723293cbc36 = {
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_ORGANIZATION_DETAILS,
    path: '/jira/servicedesk/projects/:projectKey/organizations/:organizationId'
};

});

parcelRegister("309WT", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('9ly9D')
        ]);
        const value = parcelRequire('5UWIV');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("9ly9D")
    ]).then(()=>parcelRequire('5UWIV'));
}

});

parcelRegister("2ue3R", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('eGahy')
        ]);
        const value = parcelRequire('cztsT');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("eGahy")
    ]).then(()=>parcelRequire('cztsT'));
}

});

parcelRegister("7JKBZ", function(module, exports) {

$parcel$export(module.exports, "newIssueViewLockInStatusResource", () => $e26e405609d1afdf$export$647de7516d081bd8);
$parcel$export(module.exports, "useNewIssueViewLockInStatus", () => $e26e405609d1afdf$export$d8ba398930f2f5f);

var $3HCkE = parcelRequire("3HCkE");

var $4abw7 = parcelRequire("4abw7");

const $e26e405609d1afdf$export$647de7516d081bd8 = (0, $3HCkE.createResource)({
    type: (0, $4abw7.RESOURCE_TYPE_PROJECT_NEW_ISSUE_VIEW_LOCK_IN_STATUS),
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: ()=>(parcelRequire("2LcF7")),
    maxAge: Number.MAX_VALUE
});
const $e26e405609d1afdf$export$d8ba398930f2f5f = ()=>{
    const { data: data, loading: loading, error: error } = (0, $3HCkE.useResource)($e26e405609d1afdf$export$647de7516d081bd8);
    return {
        loading: loading,
        error: error,
        newIssueViewLockedIn: data && data.newIssueViewLockedIn
    };
};

});
parcelRegister("2LcF7", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('7k3aJ');
        const value = parcelRequire('fU01i');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("7k3aJ").then(()=>parcelRequire('fU01i'));
}

});


parcelRegister("eD2UT", function(module, exports) {

$parcel$export(module.exports, "customQueueRoute", () => $4782d0a5c5a44372$export$e1fac82ca0b0d637);
$parcel$export(module.exports, "customPracticeQueueRoute", () => $4782d0a5c5a44372$export$59d0bd42aa07faad);

var $exb0h = parcelRequire("exb0h");
const $4782d0a5c5a44372$export$e1fac82ca0b0d637 = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_QUEUES_CUSTOM_AND_ISSUE,
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/:issueKey?'
};
const $4782d0a5c5a44372$export$59d0bd42aa07faad = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_PRACTICE_CUSTOM_AND_ISSUE,
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/:issueKey?'
};

});

parcelRegister("c5Ngx", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('8xeQK')
        ]);
        const value = parcelRequire('7tq7f');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("8xeQK")
    ]).then(()=>parcelRequire('7tq7f'));
}

});

parcelRegister("keS35", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('6wERg')
        ]);
        const value = parcelRequire('kB9Uz');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("6wERg")
    ]).then(()=>parcelRequire('kB9Uz'));
}

});

parcelRegister("ejpwM", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('eEZ3I')
        ]);
        const value = parcelRequire('4eVVM');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("eEZ3I")
    ]).then(()=>parcelRequire('4eVVM'));
}

});

parcelRegister("if5lM", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('eq2Qr')
        ]);
        const value = parcelRequire('9u77E');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("eq2Qr")
    ]).then(()=>parcelRequire('9u77E'));
}

});

parcelRegister("fZleD", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('lae99')
        ]);
        const value = parcelRequire('dDXUI');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("lae99")
    ]).then(()=>parcelRequire('dDXUI'));
}

});

parcelRegister("wVpFN", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('ivWme')
        ]);
        const value = parcelRequire('dKCU6');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("ivWme")
    ]).then(()=>parcelRequire('dKCU6'));
}

});

parcelRegister("fJDd6", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('h5wtr')
        ]);
        const value = parcelRequire('1dAi7');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("h5wtr")
    ]).then(()=>parcelRequire('1dAi7'));
}

});

parcelRegister("e8Xy9", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('aU83l');
        const value = parcelRequire('74KcA');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("aU83l").then(()=>parcelRequire('74KcA'));
}

});

parcelRegister("1iICl", function(module, exports) {

$parcel$export(module.exports, "servicedeskAtlassianAnalyticsResource", () => $b43093f7acf3e3e2$export$eb2deca89cf3fb61);

var $3HCkE = parcelRequire("3HCkE");


const $b43093f7acf3e3e2$var$getDataLoader = ()=>(parcelRequire("77vtz"));
const $b43093f7acf3e3e2$export$eb2deca89cf3fb61 = (0, $3HCkE.createResource)({
    type: (0, $eb4e443cee49ddd3$export$73cf43fb073ce577),
    getKey: ()=>'atlassian analytics',
    getDataLoader: $b43093f7acf3e3e2$var$getDataLoader,
    isBrowserOnly: true
});

});
const $eb4e443cee49ddd3$export$73cf43fb073ce577 = 'SERVICEDESK_ATLASSIAN_ANALYTICS';

parcelRegister("77vtz", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('4FH3Q');
        const value = parcelRequire('kk3KD');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("4FH3Q").then(()=>parcelRequire('kk3KD'));
}

});


parcelRegister("5VjfX", function(module, exports) {

$parcel$export(module.exports, "servicedeskReportsSummaryRoute", () => $a924b54989ebf010$export$44647b0fd2271ddb);
$parcel$export(module.exports, "servicedeskReports1Route", () => $a924b54989ebf010$export$f5adfd681a4e85ad);
$parcel$export(module.exports, "servicedeskAtlassianAnalyticsRoute", () => $a924b54989ebf010$export$399ef3a2d4288bba);
$parcel$export(module.exports, "servicedeskReportsWorkloadRoute", () => $a924b54989ebf010$export$ce9b409ccf53e93c);
$parcel$export(module.exports, "servicedeskReportsSatisfactionIssueRoute", () => $a924b54989ebf010$export$da606765550c7e7);
$parcel$export(module.exports, "servicedeskReportsSatisfactionTimeScaleRoute", () => $a924b54989ebf010$export$64ae70b2d6b34c4e);
$parcel$export(module.exports, "servicedeskReportsSatisfaction2Route", () => $a924b54989ebf010$export$22fd25b495033fdf);
$parcel$export(module.exports, "servicedeskKbRequestsReportsIssueRoute", () => $a924b54989ebf010$export$296aa46068d40f43);
$parcel$export(module.exports, "servicedeskKbRequestsReportsTimeScaleRoute", () => $a924b54989ebf010$export$1585b6f8f1838e19);
$parcel$export(module.exports, "servicedeskKbRequestsReports2Route", () => $a924b54989ebf010$export$276e2ed89304d21c);
$parcel$export(module.exports, "servicedeskReportsCustomEditRoute", () => $a924b54989ebf010$export$3b6b3105a9ef9b83);
$parcel$export(module.exports, "servicedeskReportsCustomCreateRoute", () => $a924b54989ebf010$export$333e623d5eb41af0);
$parcel$export(module.exports, "servicedeskReportsCustomIssueRoute", () => $a924b54989ebf010$export$1cfe539c854438e8);
$parcel$export(module.exports, "servicedeskReportsCustomTimeScaleRoute", () => $a924b54989ebf010$export$eae9a65fe3f035ef);
$parcel$export(module.exports, "servicedeskReportsCustom4Route", () => $a924b54989ebf010$export$39325072940fb58c);
$parcel$export(module.exports, "servicedeskReportsTypeRoute", () => $a924b54989ebf010$export$b955ac7f09c5dbb);

var $exb0h = parcelRequire("exb0h");
const $a924b54989ebf010$var$SERVICE_DESK_ROUTE_PREFIX = '/jira/servicedesk/projects/:projectKey';
const $a924b54989ebf010$var$WORKLOAD_ROUTE_SUFFIX = '/reports/workload';
const $a924b54989ebf010$var$ATLASSIAN_ANALYTICS_ROUTE_SUFFIX = '/reports/atlassian-analytics';
const $a924b54989ebf010$var$CUSTOM_ROUTE_SUFFIX = '/reports/custom/:reportId';
const $a924b54989ebf010$var$REQUESTS_ROUTE_SUFFIX = '/reports/:reportId(kb-requests-resolved|kb-requests-deflected)';
const $a924b54989ebf010$var$TIME_SCALE = '/timescale/:timescaleId';
const $a924b54989ebf010$var$SATISFACTION_ROUTE_SUFFIX = '/reports/all-rating';
const $a924b54989ebf010$var$ISSUE_KEY = '/:issueKey';
const $a924b54989ebf010$export$44647b0fd2271ddb = {
    // HACK - the reports backbone code tries to refresh the page
    // in order to re-render the view. This route allows us to replicate that
    // behaviour in React.
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_REPORTS_SUMMARY,
    path: '(/jira/servicedesk/projects/[^/]+/reports/.+)/summary',
    exact: true
};
const $a924b54989ebf010$export$f5adfd681a4e85ad = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_REPORTS,
    path: `${$a924b54989ebf010$var$SERVICE_DESK_ROUTE_PREFIX}/reports`,
    exact: true
};
const $a924b54989ebf010$export$399ef3a2d4288bba = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_ATLASSIAN_ANALYTICS,
    path: `${$a924b54989ebf010$var$SERVICE_DESK_ROUTE_PREFIX}${$a924b54989ebf010$var$ATLASSIAN_ANALYTICS_ROUTE_SUFFIX}`,
    exact: true
};
const $a924b54989ebf010$export$ce9b409ccf53e93c = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_REPORTS_WORKLOAD,
    path: `${$a924b54989ebf010$var$SERVICE_DESK_ROUTE_PREFIX}${$a924b54989ebf010$var$WORKLOAD_ROUTE_SUFFIX}`,
    exact: true
};
const $a924b54989ebf010$export$da606765550c7e7 = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_REPORTS_SATISFACTION_ISSUE,
    path: `${$a924b54989ebf010$var$SERVICE_DESK_ROUTE_PREFIX}${$a924b54989ebf010$var$SATISFACTION_ROUTE_SUFFIX}${$a924b54989ebf010$var$TIME_SCALE}${$a924b54989ebf010$var$ISSUE_KEY}`,
    query: [
        'oldIssueView?'
    ],
    exact: true
};
const $a924b54989ebf010$export$64ae70b2d6b34c4e = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_REPORTS_SATISFACTION_TIME_SCALE,
    path: `${$a924b54989ebf010$var$SERVICE_DESK_ROUTE_PREFIX}${$a924b54989ebf010$var$SATISFACTION_ROUTE_SUFFIX}${$a924b54989ebf010$var$TIME_SCALE}`
};
const $a924b54989ebf010$export$22fd25b495033fdf = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_REPORTS_SATISFACTION,
    path: `${$a924b54989ebf010$var$SERVICE_DESK_ROUTE_PREFIX}${$a924b54989ebf010$var$SATISFACTION_ROUTE_SUFFIX}`
};
const $a924b54989ebf010$export$296aa46068d40f43 = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_KB_REQUESTS_REPORTS_ISSUE,
    path: `${$a924b54989ebf010$var$SERVICE_DESK_ROUTE_PREFIX}${$a924b54989ebf010$var$REQUESTS_ROUTE_SUFFIX}${$a924b54989ebf010$var$TIME_SCALE}${$a924b54989ebf010$var$ISSUE_KEY}`,
    query: [
        'oldIssueView?'
    ],
    exact: true
};
const $a924b54989ebf010$export$1585b6f8f1838e19 = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_KB_REQUESTS_REPORTS_TIME_SCALE,
    path: `${$a924b54989ebf010$var$SERVICE_DESK_ROUTE_PREFIX}${$a924b54989ebf010$var$REQUESTS_ROUTE_SUFFIX}${$a924b54989ebf010$var$TIME_SCALE}`
};
const $a924b54989ebf010$export$276e2ed89304d21c = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_KB_REQUESTS_REPORTS,
    path: `${$a924b54989ebf010$var$SERVICE_DESK_ROUTE_PREFIX}${$a924b54989ebf010$var$REQUESTS_ROUTE_SUFFIX}`
};
const $a924b54989ebf010$export$3b6b3105a9ef9b83 = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_REPORTS_CUSTOM_EDIT,
    path: `${$a924b54989ebf010$var$SERVICE_DESK_ROUTE_PREFIX}${$a924b54989ebf010$var$CUSTOM_ROUTE_SUFFIX}/edit`
};
const $a924b54989ebf010$export$333e623d5eb41af0 = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_REPORTS_CUSTOM_CREATE,
    path: `${$a924b54989ebf010$var$SERVICE_DESK_ROUTE_PREFIX}/reports/custom/new`
};
const $a924b54989ebf010$export$1cfe539c854438e8 = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_REPORTS_CUSTOM_ISSUE,
    path: `${$a924b54989ebf010$var$SERVICE_DESK_ROUTE_PREFIX}${$a924b54989ebf010$var$CUSTOM_ROUTE_SUFFIX}${$a924b54989ebf010$var$TIME_SCALE}${$a924b54989ebf010$var$ISSUE_KEY}`,
    query: [
        'oldIssueView?'
    ],
    exact: true
};
const $a924b54989ebf010$export$eae9a65fe3f035ef = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_REPORTS_CUSTOM_TIME_SCALE,
    path: `${$a924b54989ebf010$var$SERVICE_DESK_ROUTE_PREFIX}${$a924b54989ebf010$var$CUSTOM_ROUTE_SUFFIX}${$a924b54989ebf010$var$TIME_SCALE}`
};
const $a924b54989ebf010$export$39325072940fb58c = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_REPORTS_CUSTOM,
    path: `${$a924b54989ebf010$var$SERVICE_DESK_ROUTE_PREFIX}${$a924b54989ebf010$var$CUSTOM_ROUTE_SUFFIX}`
};
const $a924b54989ebf010$export$b955ac7f09c5dbb = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_REPORTS_TYPE,
    path: `${$a924b54989ebf010$var$SERVICE_DESK_ROUTE_PREFIX}/reports/:reportType/:reportId?/:reportsAction?/:timescaleId?/:issueKey?`,
    query: [
        'oldIssueView?'
    ]
};

});

parcelRegister("hxKw9", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('2hmUs'),
            load('bCeK4'),
            load('ehjSH')
        ]);
        const value = parcelRequire('aYPxW');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("2hmUs"),
        load("bCeK4"),
        load("ehjSH")
    ]).then(()=>parcelRequire('aYPxW'));
}

});

parcelRegister("chTri", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('8rDHO')
        ]);
        const value = parcelRequire('29RNo');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("8rDHO")
    ]).then(()=>parcelRequire('29RNo'));
}

});

parcelRegister("6ga5r", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('cXOmQ')
        ]);
        const value = parcelRequire('86VyB');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("cXOmQ")
    ]).then(()=>parcelRequire('86VyB'));
}

});

parcelRegister("3gf8S", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('1HIlH')
        ]);
        const value = parcelRequire('aRYrF');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("1HIlH")
    ]).then(()=>parcelRequire('aRYrF'));
}

});

parcelRegister("flQ0B", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('8gVpS')
        ]);
        const value = parcelRequire('a3ocp');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("8gVpS")
    ]).then(()=>parcelRequire('a3ocp'));
}

});

parcelRegister("bPFtz", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('fUZPR')
        ]);
        const value = parcelRequire('hYS2a');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("fUZPR")
    ]).then(()=>parcelRequire('hYS2a'));
}

});

parcelRegister("3QjNh", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('6f7ti')
        ]);
        const value = parcelRequire('k9U6H');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("6f7ti")
    ]).then(()=>parcelRequire('k9U6H'));
}

});

parcelRegister("cYGRe", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('hcgRy')
        ]);
        const value = parcelRequire('hWny6');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("hcgRy")
    ]).then(()=>parcelRequire('hWny6'));
}

});

parcelRegister("e5bIK", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('eOWRL')
        ]);
        const value = parcelRequire('2jUxe');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("eOWRL")
    ]).then(()=>parcelRequire('2jUxe'));
}

});

parcelRegister("7OtSy", function(module, exports) {

$parcel$export(module.exports, "servicedeskServicesRoute", () => $89fe13db81497c0b$export$4a800381bda6d53c);
$parcel$export(module.exports, "servicedeskServiceDetailsRoute", () => $89fe13db81497c0b$export$fe5fe00b6d5eab87);
$parcel$export(module.exports, "servicedeskServiceModalNewRoute", () => $89fe13db81497c0b$export$5b5ea97286af2784);
$parcel$export(module.exports, "servicedeskServiceModalEditRoute", () => $89fe13db81497c0b$export$319fbbab5eb49cbf);
$parcel$export(module.exports, "serviceDeskServicesWithoutProjectRoute", () => $89fe13db81497c0b$export$3210e7c54c21be97);
$parcel$export(module.exports, "serviceDeskServiceDetailsWithoutProjectRoute", () => $89fe13db81497c0b$export$25e1d58db18a7c8b);

var $exb0h = parcelRequire("exb0h");
const $89fe13db81497c0b$var$SERVICE_DESK_ROUTE_PREFIX = '/jira/servicedesk/projects/:projectKey';
const $89fe13db81497c0b$var$SERVICE_DESK_ROUTE_PREFIX_WITHOUT_PROJECT = '/jira/servicedesk';
const $89fe13db81497c0b$var$SERVICE_HASHED_ARI = '/:serviceAri';
const $89fe13db81497c0b$var$SERVICES_ROUTE_SUFFIX = '/services';
const $89fe13db81497c0b$var$SERVICE_MODAL_ROUTE_SUFFIX = '/service-modal';
const $89fe13db81497c0b$export$4a800381bda6d53c = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_SERVICES,
    path: `${$89fe13db81497c0b$var$SERVICE_DESK_ROUTE_PREFIX}${$89fe13db81497c0b$var$SERVICES_ROUTE_SUFFIX}`,
    exact: true
};
const $89fe13db81497c0b$export$fe5fe00b6d5eab87 = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_SERVICE_DETAILS,
    path: `${$89fe13db81497c0b$var$SERVICE_DESK_ROUTE_PREFIX}${$89fe13db81497c0b$var$SERVICES_ROUTE_SUFFIX}${$89fe13db81497c0b$var$SERVICE_HASHED_ARI}`
};
const $89fe13db81497c0b$export$5b5ea97286af2784 = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_SERVICE_MODAL_NEW,
    path: `${$89fe13db81497c0b$var$SERVICE_DESK_ROUTE_PREFIX_WITHOUT_PROJECT}${$89fe13db81497c0b$var$SERVICE_MODAL_ROUTE_SUFFIX}`,
    exact: true
};
const $89fe13db81497c0b$export$319fbbab5eb49cbf = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_SERVICE_MODAL_EDIT,
    path: `${$89fe13db81497c0b$var$SERVICE_DESK_ROUTE_PREFIX_WITHOUT_PROJECT}${$89fe13db81497c0b$var$SERVICE_MODAL_ROUTE_SUFFIX}${$89fe13db81497c0b$var$SERVICE_HASHED_ARI}`
};
const $89fe13db81497c0b$export$3210e7c54c21be97 = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_SERVICES_WITHOUT_PROJECT,
    path: `${$89fe13db81497c0b$var$SERVICE_DESK_ROUTE_PREFIX_WITHOUT_PROJECT}${$89fe13db81497c0b$var$SERVICES_ROUTE_SUFFIX}`,
    exact: true,
    meta: {
        reporting: {
            id: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_SERVICES_WITHOUT_PROJECT,
            packageName: 'jiraSpaAppsServicedeskServicesWithoutProjectContext"',
            teamName: 'Falcons'
        }
    }
};
const $89fe13db81497c0b$export$25e1d58db18a7c8b = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_SERVICE_DETAILS_WITHOUT_PROJECT,
    path: `${$89fe13db81497c0b$var$SERVICE_DESK_ROUTE_PREFIX_WITHOUT_PROJECT}${$89fe13db81497c0b$var$SERVICES_ROUTE_SUFFIX}${$89fe13db81497c0b$var$SERVICE_HASHED_ARI}`,
    meta: {
        reporting: {
            id: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_SERVICE_DETAILS_WITHOUT_PROJECT,
            packageName: 'jiraSpaAppsServicedeskServiceDetailsWithoutProjectContext"',
            teamName: 'Falcons'
        }
    }
};

});

parcelRegister("11The", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('dJcDS');
        const value = parcelRequire('hOdgF');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("dJcDS").then(()=>parcelRequire('hOdgF'));
}

});

parcelRegister("1hd0H", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('5KHj0')
        ]);
        const value = parcelRequire('sBnk2');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("5KHj0")
    ]).then(()=>parcelRequire('sBnk2'));
}

});

parcelRegister("c25FR", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('egGuO')
        ]);
        const value = parcelRequire('aIz0v');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("egGuO")
    ]).then(()=>parcelRequire('aIz0v'));
}

});

parcelRegister("cqDek", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('lAQnM');
        const value = parcelRequire('7NpH8');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("lAQnM").then(()=>parcelRequire('7NpH8'));
}

});

parcelRegister("f8m28", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('bjoOq')
        ]);
        const value = parcelRequire('47wbX');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("bjoOq")
    ]).then(()=>parcelRequire('47wbX'));
}

});

parcelRegister("jEo1H", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('dpITv')
        ]);
        const value = parcelRequire('dZkiU');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("dpITv")
    ]).then(()=>parcelRequire('dZkiU'));
}

});

parcelRegister("ieRGA", function(module, exports) {

$parcel$export(module.exports, "default", () => $209cb7ee89940e6b$export$2e2bcd8739ae039);

var $78Ywx = parcelRequire("78Ywx");

var $kFGm5 = parcelRequire("kFGm5");
var /**
 * Use to remove query params from url without reload or change history
 * One use case is to remove any tracking id from the url to avoid problems in copy & paste urls or sharing links between users
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$209cb7ee89940e6b$export$2e2bcd8739ae039 = (paramsToStrip)=>{
    try {
        const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($78Ywx))).parse(window.location.href, true);
        const strippedQuery = (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(parsedUrl.query || {}, paramsToStrip);
        let strippedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($78Ywx))).format({
            ...parsedUrl,
            search: undefined,
            query: strippedQuery
        });
        // we don't want to encode : to %3A in connect project pages
        const isConnect = /\?|&selectedItem=com.atlassian.plugins.atlassian-connect-plugin:/.test(window.location.search);
        if (isConnect) strippedUrl = strippedUrl.replace(/selectedItem=com.atlassian.plugins.atlassian-connect-plugin%3A/g, (match)=>match.replace(/%3A/i, ':'));
        window.history.replaceState({}, '', strippedUrl);
    } catch (e) {
    /* uri might be malformed */ }
};

});

parcelRegister("7BDEW", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fe7d84710661a6d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $c8Guq = parcelRequire("c8Guq");

var $hFmdR = parcelRequire("hFmdR");

var $5BRby = parcelRequire("5BRby");


var $5CH2F = parcelRequire("5CH2F");
const $9fe7d84710661a6d$var$defaultSource = 'dwellComponent';
const $9fe7d84710661a6d$var$defaultActionSubject = 'dwellComponent';
const $9fe7d84710661a6d$var$getDwellComponent = (source, actionSubject)=>(0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $hFmdR.AnalyticsSubject)(actionSubject || $9fe7d84710661a6d$var$defaultActionSubject), (0, $hFmdR.AnalyticsSource)(source || $9fe7d84710661a6d$var$defaultSource, (0, $41ea3621645e2acc$export$f636b5b56f1d624a)))((0, $5CH2F.default));
class $9fe7d84710661a6d$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static getDerivedStateFromProps(props) {
        const { data: data } = props;
        return {
            DwellTimeComponent: $9fe7d84710661a6d$var$getDwellComponent(data.source, data.actionSubject)
        };
    }
    constructor(props){
        super(props);
        this.state = {
            DwellTimeComponent: null
        };
    }
    render() {
        const { sessionId: sessionId, data: data } = this.props;
        const { DwellTimeComponent: DwellTimeComponent } = this.state;
        const enrichedData = {
            ...data,
            source: data && data.source || $9fe7d84710661a6d$var$defaultSource,
            actionSubject: data && data.actionSubject || $9fe7d84710661a6d$var$defaultActionSubject
        };
        if (sessionId && DwellTimeComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DwellTimeComponent, {
            sessionId: sessionId,
            data: enrichedData
        }));
        return null;
    }
}

});
parcelRegister("5CH2F", function(module, exports) {

$parcel$export(module.exports, "default", () => $6def25be35218960$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9BA6k = parcelRequire("9BA6k");

var $eGI9v = parcelRequire("eGI9v");
var $jUhyG = parcelRequire("jUhyG");
class $6def25be35218960$export$1c7ccff61c195c75 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { data: data, sessionId: sessionId } = this.props;
        // @ts-expect-error - TS2741 - Property 'prototype' is missing in type 'DwellTimeHelper' but required in type 'typeof DwellTimeHelper'.
        this.dwellHelper = new (0, $9BA6k.default)(this.sendDwellEvent, data, sessionId);
        // @ts-expect-error - TS2339 - Property 'start' does not exist on type 'typeof DwellTimeHelper'.
        this.dwellHelper.start();
    }
    componentDidUpdate(oldProps) {
        if (oldProps.sessionId !== this.props.sessionId && this.dwellHelper !== null) // @ts-expect-error - TS2339 - Property 'newPage' does not exist on type 'typeof DwellTimeHelper'.
        this.dwellHelper.newPage(this.props.data, this.props.sessionId);
    }
    componentWillUnmount() {
        if (this.dwellHelper) {
            // @ts-expect-error - TS2339 - Property 'stop' does not exist on type 'typeof DwellTimeHelper'.
            this.dwellHelper.stop();
            // @ts-expect-error - TS2339 - Property 'destroy' does not exist on type 'typeof DwellTimeHelper'.
            this.dwellHelper.destroy();
        }
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, this.props.children);
    }
    constructor(...args){
        super(...args);
        this.sendDwellEvent = (payload)=>(0, $jUhyG.fireTrackAnalytics)(this.props.createAnalyticsEvent(), payload);
    }
}
var $6def25be35218960$export$2e2bcd8739ae039 = (0, $eGI9v.default)('dwellTime', {
    onDwell: 'dwelled'
})($6def25be35218960$export$1c7ccff61c195c75);

});
parcelRegister("jUhyG", function(module, exports) {

$parcel$export(module.exports, "fireTrackAnalytics", () => $5b05bd1f53288b4a$export$13990ad4625571ed);

var $3LiTJ = parcelRequire("3LiTJ");

var $etqm0 = parcelRequire("etqm0");

var $klunD = parcelRequire("klunD");
const $5b05bd1f53288b4a$var$isNotUndefined = (a)=>a !== undefined;
const $5b05bd1f53288b4a$var$mapPayload = (payload)=>{
    const context = (0, $klunD.default)(payload);
    const { action: action, actionSubjectId: actionSubjectId } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($3LiTJ)))({
        ...context,
        ...context.attributes,
        attributes: undefined,
        action: action,
        actionSubjectId: actionSubjectId
    }, $5b05bd1f53288b4a$var$isNotUndefined);
};
const $5b05bd1f53288b4a$export$13990ad4625571ed = (event, payload)=>{
    event.update({
        ...$5b05bd1f53288b4a$var$mapPayload(payload),
        analyticsType: (0, $etqm0.TRACK_EVENT_TYPE)
    }).fire();
};

});



parcelRegister("cprue", function(module, exports) {

$parcel$export(module.exports, "CLEAR_SEARCH_SESSION", () => $994d5244595fd50a$export$b669eaa3e4786d5c);
$parcel$export(module.exports, "skipClearSessionURLs", () => $994d5244595fd50a$export$c092460ed33e0e35);
const $994d5244595fd50a$export$b669eaa3e4786d5c = 'CLEAR_SEARCH_SESSION';
const $994d5244595fd50a$export$c092460ed33e0e35 = [
    /.*RapidBoard.jspa.*/,
    /\/jira\/software\/c\/projects\/[^/]*\/boards\/.*/,
    /\/jira\/people\/.*\/boards\/.*/
];

});

parcelRegister("4ea83", function(module, exports) {

$parcel$export(module.exports, "setPrefetchStartMark", () => $e69acff038046e8f$export$405fde3eab8e39f6);
$parcel$export(module.exports, "getPrefetchStartMark", () => $e69acff038046e8f$export$cbaceb7ffa84279);
$parcel$export(module.exports, "clearPrefetchStartMarks", () => $e69acff038046e8f$export$d6b0928f07bafe57);
const $e69acff038046e8f$var$prefetchTiming = new Map();
const $e69acff038046e8f$export$405fde3eab8e39f6 = (match)=>{
    const currentMatch = JSON.stringify(match);
    if (!$e69acff038046e8f$var$prefetchTiming.has(currentMatch)) $e69acff038046e8f$var$prefetchTiming.set(currentMatch, {
        startPrefetchTime: Date.now()
    });
};
const $e69acff038046e8f$export$cbaceb7ffa84279 = (match)=>{
    const currentMatch = JSON.stringify(match);
    const { startPrefetchTime: startPrefetchTime } = $e69acff038046e8f$var$prefetchTiming.get(currentMatch) || {
        startPrefetchTime: null
    };
    return startPrefetchTime;
};
const $e69acff038046e8f$export$d6b0928f07bafe57 = (match)=>{
    if (!$e69acff038046e8f$var$prefetchTiming || !$e69acff038046e8f$var$prefetchTiming.keys) return;
    const currentMatch = JSON.stringify(match);
    const keys = Array.from($e69acff038046e8f$var$prefetchTiming.keys());
    keys.forEach((mark)=>{
        if (mark !== currentMatch && $e69acff038046e8f$var$prefetchTiming.has(mark)) $e69acff038046e8f$var$prefetchTiming.delete(mark);
    });
};

});

parcelRegister("fGHk2", function(module, exports) {

$parcel$export(module.exports, "getSpaRouterContext", () => $4819b6a0bbaf9e3c$export$1f61c5e3f6410afa);
const $4819b6a0bbaf9e3c$export$1f61c5e3f6410afa = ({ tenantContext: tenantContext })=>({
        tenantContext: tenantContext
    });

});

parcelRegister("iE8ll", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a219f83d1047607$export$2e2bcd8739ae039);

var $7rh0R = parcelRequire("7rh0R");

var $1ybV0 = parcelRequire("1ybV0");

var $6rW04 = parcelRequire("6rW04");

var $6ZwQ5 = parcelRequire("6ZwQ5");

var $iWimt = parcelRequire("iWimt");

var $48rGI = parcelRequire("48rGI");

var $fVaJL = parcelRequire("fVaJL");

var $2rCPX = parcelRequire("2rCPX");

var $bSFmz = parcelRequire("bSFmz");
var $gLcQl = parcelRequire("gLcQl");

var $jinpL = parcelRequire("jinpL");

var $kvBcO = parcelRequire("kvBcO");

var $8NQa5 = parcelRequire("8NQa5");

var $g62MK = parcelRequire("g62MK");
const $3a219f83d1047607$var$getUFOConfigFromFF = ()=>(0, $1ybV0.getFeatureFlagValue)('ufo.config', {});
function $3a219f83d1047607$var$getAdditionalJiraFields(interaction) {
    try {
        return {
            jira: (0, $iWimt.getJiraCustomData)(interaction)
        };
    } catch (error) {
        return {};
    }
}

function $3a219f83d1047607$var$loadJiraAnalyticsWebClient() {
    return Promise.resolve((parcelRequire("3FyZ4")));
}
function $3a219f83d1047607$export$2e2bcd8739ae039() {
    const ufoConfigFromFF = $3a219f83d1047607$var$getUFOConfigFromFF();
    const enableTTVC = (0, $1ybV0.ff)('uip.vc');
    (0, $6ZwQ5.retrieveAndSetPageLoadTrace)((0, $6rW04.default));
    (0, $bSFmz.configure)((0, $8NQa5.jiraResourceTimingsConfig));
    (0, $gLcQl.startResourceTimingBuffer)();
    (0, $48rGI.configure)((0, $kvBcO.jiraBundleEvalTimingsConfig));
    (0, $jinpL.configure)((0, $g62MK.jiraSsrConfig));
    (0, $7rh0R.GlobalReactLooselyLazyProfiler).current = (0, $fVaJL.ModuleLoadingProfiler);
    (0, $2rCPX.init)($3a219f83d1047607$var$loadJiraAnalyticsWebClient(), {
        ...ufoConfigFromFF,
        enableTTVC: enableTTVC,
        product: 'jira',
        region: (0, $6rW04.default)('ajs-region') || 'unknown',
        additionalPayloadData: $3a219f83d1047607$var$getAdditionalJiraFields,
        vc: {
            enabled: (0, $1ybV0.ff)('uip.vc.partial', false),
            heatmapSize: (0, $1ybV0.getFeatureFlagValue)('uip.vc.size', 200),
            oldDomUpdates: (0, $1ybV0.ff)('uip.vc.old-dom', false),
            devToolsEnabled: (0, $1ybV0.ff)('uip.vc.devtools', false),
            selectorConfig: {
                id: true,
                role: true,
                className: true,
                testId: (0, $1ybV0.ff)('uip.vc.testid', false)
            }
        },
        enableBetterPageVisibilityApi: (0, $1ybV0.ff)('uip.vc.better-page-visibility', false)
    });
}

});
parcelRegister("6ZwQ5", function(module, exports) {

$parcel$export(module.exports, "retrieveAndSetPageLoadTrace", () => $1ac20787271a9005$export$1a71d2bbe236de99);

var $1qnta = parcelRequire("1qnta");
let $1ac20787271a9005$var$alreadySet = false;
const $1ac20787271a9005$export$1a71d2bbe236de99 = (getMeta)=>{
    if (false || $1ac20787271a9005$var$alreadySet) return;
    const traceId = getMeta('X-B3-TraceId') || '';
    const spanId = traceId?.substring(traceId.length - 16) || ''; // set root span ID by convention
    $1ac20787271a9005$var$alreadySet = true;
    (0, $1qnta.setActiveTrace)(traceId, spanId, 'page_load');
};

});

parcelRegister("iWimt", function(module, exports) {

$parcel$export(module.exports, "getJiraCustomData", () => $6e5e02981879d50b$export$abf5e20822fa925);

var $eUqFw = parcelRequire("eUqFw");

var $6rW04 = parcelRequire("6rW04");

var $beHKQ = parcelRequire("beHKQ");

var $dwuRd = parcelRequire("dwuRd");

var $kqUgM = parcelRequire("kqUgM");

var $8eEfr = parcelRequire("8eEfr");

var $aHzNY = parcelRequire("aHzNY");

var $5asE8 = parcelRequire("5asE8");

var $3J8Ab = parcelRequire("3J8Ab");

var $jRw2l = parcelRequire("jRw2l");

var $8Icn5 = parcelRequire("8Icn5");

var $byQ0F = parcelRequire("byQ0F");
function $6e5e02981879d50b$export$abf5e20822fa925(interaction) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let customData = {};
    const shard = (0, $6rW04.default)('ajs-shard');
    if (shard !== null && shard !== '') customData.shard = shard;
    customData['network:assetEncoding'] = (0, $beHKQ.getAssetEncoding)();
    const buildVariant = window.BUILD_VARIANT;
    if (buildVariant) customData['app:buildVariant'] = buildVariant;
    const bundlerVersion = window.BUNDLER_VERSION;
    if (bundlerVersion) customData['app:bundlerVersion'] = bundlerVersion;
    const useBifrostGateway = window.USE_BIFROST_GATEWAY;
    if (useBifrostGateway) customData['app:useBifrostGateway'] = useBifrostGateway;
    customData.httpProtocol = performance.getEntriesByType('resource')// @ts-expect-error - TS2339  - Property 'nextHopProtocol' does not exist on type 'PerformanceEntry'. | TS2339 - Property 'nextHopProtocol' does not exist on type 'PerformanceEntry'.
    .find(({ nextHopProtocol: nextHopProtocol })=>!!nextHopProtocol)?.nextHopProtocol ?? 'unknown';
    const { start: start, end: end, apdex: apdex } = interaction;
    const stop = apdex?.[0]?.stopTime ?? end;
    customData.memory = (0, $5asE8.getMemoryUsageReport)({
        start: start,
        stop: stop
    });
    const lightHouseMetrics = (0, $8eEfr.getLighthouseMetrics)({
        start: start,
        stop: stop
    });
    customData = {
        ...customData,
        ...lightHouseMetrics
    };
    if (interaction.type === 'page_load') customData = {
        ...customData,
        ...(0, $aHzNY.getMarks)({
            start: start
        }),
        ...(0, $3J8Ab.getPageSizeMetrics)(),
        ...(0, $3J8Ab.getExtraNavigationTimings)(),
        ...(0, $8Icn5.getServerDurationMetrics)(),
        ...(0, $jRw2l.getRouterResourceMetrics)(),
        ...(0, $byQ0F.getWRMStats)(),
        ...(0, $3J8Ab.getPageSizeInfo)({
            start: start,
            stop: stop
        }),
        ...(0, $dwuRd.getCacheHitRatio)({
            start: start
        }),
        ...(0, $kqUgM.getCHRInfo)({
            start: start
        }),
        'app:version:web': window.BUILD_KEY,
        'app:version:ssr': window.SSR_BUILD_KEY,
        'app:framework:name': 'react',
        'app:framework:version': (0, $eUqFw.version)
    };
    return customData;
}

});
parcelRegister("beHKQ", function(module, exports) {

$parcel$export(module.exports, "getAssetEncoding", () => $ddd7bcb16f8788d2$export$fd12d8f45e126585);
function $ddd7bcb16f8788d2$export$fd12d8f45e126585() {
    const assetEncodings = Array.prototype.map.call(document.querySelectorAll('script[data-encoding], link[data-encoding]'), (i)=>i.getAttribute('data-encoding')) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((acc, i)=>{
        // @ts-expect-error - TS2538 - Type 'unknown' cannot be used as an index type.
        acc[i] = true;
        return acc;
    }, {});
    const uniqueEncodings = Object.keys(assetEncodings).sort();
    let result = 'unknown';
    if (uniqueEncodings.length === 1) [result] = uniqueEncodings;
    if (uniqueEncodings.length > 1) result = `mixed: ${uniqueEncodings.toString()}`;
    return result;
}

});

parcelRegister("dwuRd", function(module, exports) {

$parcel$export(module.exports, "getCacheHitRatio", () => $a8062b19e2d539f7$export$e8a9322c3d9da8a6);

var $8uNQc = parcelRequire("8uNQc");
/* Borrowed from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/performance/browser-metrics/src/plugins/timings/resource.ts */ const $a8062b19e2d539f7$var$cacheableTypes = [
    'script',
    'link'
];
const $a8062b19e2d539f7$var$CACHE_NETWORK = 'network';
const $a8062b19e2d539f7$var$CACHE_MEMORY = 'memory';
const $a8062b19e2d539f7$var$CACHE_DISK = 'disk';
const $a8062b19e2d539f7$var$calculateTransferType = (type, duration, size)=>{
    if (!$a8062b19e2d539f7$var$cacheableTypes.includes(type)) return $a8062b19e2d539f7$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $a8062b19e2d539f7$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $a8062b19e2d539f7$var$CACHE_DISK;
    if (size === undefined) return null;
    return $a8062b19e2d539f7$var$CACHE_NETWORK;
};
const $a8062b19e2d539f7$export$e8a9322c3d9da8a6 = ({ start: start })=>{
    let fromCache = 0;
    let preloadFromCache = 0;
    let total = 0;
    let totalPreload = 0;
    // initial load only
    if (start !== 0) return {};
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        for (const entry of (0, $8uNQc.default).getEntriesByType('resource')){
            // The BM3 resource timing collector checks for whether the timing information is available,
            // but we can make the assumption that it is for this Jira specific collector.
            const transferType = $a8062b19e2d539f7$var$calculateTransferType(entry.initiatorType, entry.duration, entry.transferSize);
            const isPreload = entry.initiatorType === 'link';
            if (transferType === 'disk' || transferType === 'memory') {
                fromCache += 1;
                if (isPreload) preloadFromCache += 1;
            }
            if (transferType !== null) {
                total += 1;
                if (isPreload) totalPreload += 1;
            }
        }
        const result = {};
        if (total > 0) result.cacheHitRatio = fromCache / total;
        if (totalPreload > 0) result.preloadCacheHitRatio = preloadFromCache / totalPreload;
        return result;
    } catch (e) {
        return {};
    }
};

});

parcelRegister("kqUgM", function(module, exports) {

$parcel$export(module.exports, "getCHRInfo", () => $a49f9fd15e6ffe2a$export$9e005e111be93521);

var $8uNQc = parcelRequire("8uNQc");
var $6iz4v = parcelRequire("6iz4v");

var $3nE1C = parcelRequire("3nE1C");
const $a49f9fd15e6ffe2a$var$SPA_SSR_RENDERED = 'ssr.spa.rendered';
const $a49f9fd15e6ffe2a$export$1faf7d001841a41c = ()=>(0, $6iz4v.getMark)($a49f9fd15e6ffe2a$var$SPA_SSR_RENDERED)?.startTime || null;
const $a49f9fd15e6ffe2a$export$9e005e111be93521 = ({ start: start })=>{
    // initial load only
    if (start !== 0) return {};
    const ssrMark = $a49f9fd15e6ffe2a$export$1faf7d001841a41c();
    const reporter = new (0, $3nE1C.CHRReporter)(ssrMark);
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        for (const entry of (0, $8uNQc.default).getEntriesByType('resource'))reporter.add(entry);
        const chr = reporter.get();
        return chr === null ? {} : {
            chr: chr
        };
    } catch (e) {
        return {};
    }
};

});
parcelRegister("3nE1C", function(module, exports) {

$parcel$export(module.exports, "CHRReporter", () => $1c95c343c16ecaf5$export$7d0d4cfb6455ffa5);

var $80Pke = parcelRequire("80Pke");

var $eUF4z = parcelRequire("eUF4z");
class $1c95c343c16ecaf5$export$7d0d4cfb6455ffa5 {
    constructor(ssrMark){
        this.preloaded = new (0, $eUF4z.CHRSummary)();
        this.all = new (0, $eUF4z.CHRSummary)();
        this.ssrMark = null;
        this.ssrMark = ssrMark;
    }
    add(item) {
        if (item.encodedBodySize === 0) return;
        if (item.initiatorType === 'link' && (0, $80Pke.cacheableTypes).includes(item.initiatorType) && (this.ssrMark === null || item.startTime < this.ssrMark)) this.preloaded.add(item);
        this.all.add(item);
    }
    static round(n) {
        return Math.round(n * 10000) / 10000;
    }
    makePayload(summary) {
        const bundlesLoadType = {
            mem: $1c95c343c16ecaf5$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $eUF4z.CHRSummary).MEMORY_KEY] / summary.bundlesCount),
            disk: $1c95c343c16ecaf5$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $eUF4z.CHRSummary).DISK_KEY] / summary.bundlesCount),
            net: $1c95c343c16ecaf5$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $eUF4z.CHRSummary).NETWORK_KEY] / summary.bundlesCount)
        };
        const bundlesRatio = $1c95c343c16ecaf5$export$7d0d4cfb6455ffa5.round((summary.bundles[(0, $eUF4z.CHRSummary).MEMORY_KEY] + summary.bundles[(0, $eUF4z.CHRSummary).DISK_KEY]) / summary.bundlesCount);
        const sizeLoadType = {
            mem: $1c95c343c16ecaf5$export$7d0d4cfb6455ffa5.round(summary.size[(0, $eUF4z.CHRSummary).MEMORY_KEY] / summary.sizeTotal),
            disk: $1c95c343c16ecaf5$export$7d0d4cfb6455ffa5.round(summary.size[(0, $eUF4z.CHRSummary).DISK_KEY] / summary.sizeTotal),
            net: $1c95c343c16ecaf5$export$7d0d4cfb6455ffa5.round(summary.size[(0, $eUF4z.CHRSummary).NETWORK_KEY] / summary.sizeTotal)
        };
        const sizeRatio = $1c95c343c16ecaf5$export$7d0d4cfb6455ffa5.round((summary.size[(0, $eUF4z.CHRSummary).MEMORY_KEY] + summary.size[(0, $eUF4z.CHRSummary).DISK_KEY]) / summary.sizeTotal);
        return {
            bundles: {
                ratio: bundlesRatio,
                count: summary.bundlesCount,
                loadType: bundlesLoadType
            },
            size: {
                ratio: sizeRatio,
                total: summary.sizeTotal,
                loadType: sizeLoadType
            }
        };
    }
    get() {
        if (this.all.bundlesCount === 0) return null;
        return {
            preloaded: this.makePayload(this.preloaded),
            all: this.makePayload(this.all)
        };
    }
}

});
parcelRegister("80Pke", function(module, exports) {

$parcel$export(module.exports, "cacheableTypes", () => $b8a696433745e025$export$5e1aa91d6932ddaa);
/* Borrowed from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/performance/browser-metrics/src/plugins/timings/resource.ts */ const $b8a696433745e025$export$5e1aa91d6932ddaa = [
    'script',
    'link'
];

});

parcelRegister("eUF4z", function(module, exports) {

$parcel$export(module.exports, "CHRSummary", () => $d4108de44c777dc2$export$783d6618ee601ba);

var $80Pke = parcelRequire("80Pke");
const $d4108de44c777dc2$var$calculateTransferType = (type, duration, size)=>{
    if (!(0, $80Pke.cacheableTypes).includes(type)) return null;
    if ((size === undefined || size === 0) && duration === 0) return $d4108de44c777dc2$export$783d6618ee601ba.MEMORY_KEY;
    if (size === 0 && duration > 0) return $d4108de44c777dc2$export$783d6618ee601ba.DISK_KEY;
    if (size === undefined) return null;
    return $d4108de44c777dc2$export$783d6618ee601ba.NETWORK_KEY;
};
class $d4108de44c777dc2$export$783d6618ee601ba {
    static{
        this.MEMORY_KEY = 'mem';
    }
    static{
        this.DISK_KEY = 'disk';
    }
    static{
        this.NETWORK_KEY = 'net';
    }
    add(item) {
        const type = $d4108de44c777dc2$var$calculateTransferType(item.initiatorType, item.duration, item.transferSize);
        if (type === null) return;
        this.bundles[type] += 1;
        this.bundlesCount += 1;
        this.size[type] += item.encodedBodySize;
        this.sizeTotal += item.encodedBodySize;
    }
    constructor(){
        this.bundles = {
            [$d4108de44c777dc2$export$783d6618ee601ba.MEMORY_KEY]: 0,
            [$d4108de44c777dc2$export$783d6618ee601ba.DISK_KEY]: 0,
            [$d4108de44c777dc2$export$783d6618ee601ba.NETWORK_KEY]: 0
        };
        this.bundlesCount = 0;
        this.size = {
            [$d4108de44c777dc2$export$783d6618ee601ba.MEMORY_KEY]: 0,
            [$d4108de44c777dc2$export$783d6618ee601ba.DISK_KEY]: 0,
            [$d4108de44c777dc2$export$783d6618ee601ba.NETWORK_KEY]: 0
        };
        this.sizeTotal = 0;
    }
}

});



parcelRegister("8eEfr", function(module, exports) {

$parcel$export(module.exports, "getLighthouseMetrics", () => $c429933143d93b08$export$b46cecdf698e4bb5);

var $6yB0H = parcelRequire("6yB0H");

var $fU1DZ = parcelRequire("fU1DZ");

var $ki7im = parcelRequire("ki7im");

var $HvJRS = parcelRequire("HvJRS");

var $iv3lO = parcelRequire("iv3lO");
function $c429933143d93b08$export$5ecf2aafafee3e0() {
    (0, $iv3lO.startLSObserver)();
    (0, $iv3lO.startLTObserver)();
}
const $c429933143d93b08$export$b46cecdf698e4bb5 = ({ start: start, stop: stop })=>{
    const tbt = (0, $ki7im.getTBT)(start, stop, (0, $HvJRS.EntriesBuffer)[(0, $fU1DZ.PerformanceObserverEntryTypes).LongTask]);
    // no round as CLS is usually 0-1
    const cls = (0, $6yB0H.getCLS)(start, stop, (0, $HvJRS.EntriesBuffer)[(0, $fU1DZ.PerformanceObserverEntryTypes).LayoutShift]);
    return {
        'metric:tbt': Math.round(tbt.total),
        'metric:tbt:observed': Math.round(tbt.observed),
        'metric:cls': cls
    };
};

});
parcelRegister("6yB0H", function(module, exports) {

$parcel$export(module.exports, "getCLS", () => $d45da93e3b9b262f$export$fc6227831ee7c7);
const $d45da93e3b9b262f$export$fc6227831ee7c7 = (start, stop, buffer)=>{
    const layoutShifts = buffer.getAll().filter((entry)=>entry.startTime >= start && entry.startTime <= stop);
    const sessionWindows = [];
    let currentWindow = null;
    // Group layout shifts into session windows
    for (const shift of layoutShifts){
        const { startTime: startTime } = shift;
        const endTime = shift.startTime + shift.duration;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const score = shift.value;
        if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
            // Start a new session window
            currentWindow = {
                startTime: startTime,
                endTime: endTime,
                score: score
            };
            sessionWindows.push(currentWindow);
        } else {
            // Add layout shift to current session window
            currentWindow.endTime = endTime;
            currentWindow.score += score;
        }
    }
    // Find session window with highest cumulative score
    const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
    // Return score of largest burst as CLS metric
    return Math.round(maxScore * 10000) / 10000;
};

});

parcelRegister("fU1DZ", function(module, exports) {

$parcel$export(module.exports, "PerformanceObserverEntryTypes", () => $234a057f27dc569a$export$a4def92db6fc8e17);
const $234a057f27dc569a$export$a4def92db6fc8e17 = {
    LayoutShift: 'layout-shift',
    LongTask: 'longtask'
};

});

parcelRegister("ki7im", function(module, exports) {

$parcel$export(module.exports, "getTBT", () => $69d3b5006a881dee$export$2d6e933b35bd3407);
const $69d3b5006a881dee$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
const $69d3b5006a881dee$export$2d6e933b35bd3407 = (start, stop, buffer)=>buffer.getAll().filter((entry)=>entry.startTime <= stop && entry.duration > $69d3b5006a881dee$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
        const longTaskStop = entry.startTime + entry.duration;
        const intersectStart = Math.max(entry.startTime + $69d3b5006a881dee$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        const intersectStop = Math.min(longTaskStop, stop);
        const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $69d3b5006a881dee$var$MAX_ACCEPTABLE_TASK_DURATION;
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });

});

parcelRegister("HvJRS", function(module, exports) {

$parcel$export(module.exports, "EntriesBuffer", () => $726140cc85f82002$export$f7dc16cbd16f7bbe);

var $fU1DZ = parcelRequire("fU1DZ");
class $726140cc85f82002$export$2c6e86519c9e8188 {
    constructor(maxLength = 1000){
        this.buffer = [];
        this.full = false;
        this.maxLength = maxLength;
    }
    push(item) {
        if (this.full || this.maxLength === this.buffer.length) {
            this.full = true;
            this.buffer.shift();
        }
        this.buffer.push(item);
    }
    getAll() {
        return this.buffer;
    }
}
const $726140cc85f82002$export$f7dc16cbd16f7bbe = {
    [(0, $fU1DZ.PerformanceObserverEntryTypes).LongTask]: new $726140cc85f82002$export$2c6e86519c9e8188(),
    [(0, $fU1DZ.PerformanceObserverEntryTypes).LayoutShift]: new $726140cc85f82002$export$2c6e86519c9e8188()
};

});

parcelRegister("iv3lO", function(module, exports) {

$parcel$export(module.exports, "startLSObserver", () => $dba5609f3cb4bc6f$export$768ccc3ab7bac3ea);
$parcel$export(module.exports, "startLTObserver", () => $dba5609f3cb4bc6f$export$54fb8b6aaf70ec9c);

var $fU1DZ = parcelRequire("fU1DZ");

var $HvJRS = parcelRequire("HvJRS");
let $dba5609f3cb4bc6f$var$pe = null;
const $dba5609f3cb4bc6f$var$getObserver = ()=>{
    if ($dba5609f3cb4bc6f$var$pe !== null) return $dba5609f3cb4bc6f$var$pe;
    $dba5609f3cb4bc6f$var$pe = new PerformanceObserver((list)=>{
        list.getEntries().forEach((entry)=>{
            if (entry.entryType === (0, $fU1DZ.PerformanceObserverEntryTypes).LayoutShift) (0, $HvJRS.EntriesBuffer)[(0, $fU1DZ.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, $fU1DZ.PerformanceObserverEntryTypes).LongTask) (0, $HvJRS.EntriesBuffer)[(0, $fU1DZ.PerformanceObserverEntryTypes).LongTask].push(entry);
        });
    });
    return $dba5609f3cb4bc6f$var$pe;
};
const $dba5609f3cb4bc6f$export$768ccc3ab7bac3ea = ()=>{
    $dba5609f3cb4bc6f$var$getObserver().observe({
        type: (0, $fU1DZ.PerformanceObserverEntryTypes).LayoutShift,
        buffered: true
    });
};
const $dba5609f3cb4bc6f$export$54fb8b6aaf70ec9c = ()=>{
    $dba5609f3cb4bc6f$var$getObserver().observe({
        type: (0, $fU1DZ.PerformanceObserverEntryTypes).LongTask,
        buffered: true
    });
};

});


parcelRegister("aHzNY", function(module, exports) {

$parcel$export(module.exports, "getMarks", () => $060b26259ca6e3b9$export$9d952633c9c2237b);

var $llxpa = parcelRequire("llxpa");

var $hknOo = parcelRequire("hknOo");
const $060b26259ca6e3b9$export$9d952633c9c2237b = (data)=>{
    const userTiming = (0, $llxpa.getUserTiming)();
    if (userTiming === null) return null;
    const sanitizeName = (name)=>name.replace(/[\W_]+/g, '_');
    // @ts-expect-error - TS7031 - Binding element 'baseName' implicitly has an 'any' type. | TS7031 - Binding element 'collection' implicitly has an 'any' type.
    const getNextAvailableName = ({ baseName: baseName, collection: collection })=>{
        let candidateName = baseName;
        // If <name> is taken, we'll try <name>_2 and increment from there
        let counter = 2;
        let validName;
        while(!validName)if (candidateName in collection) {
            candidateName = `${baseName}_${counter}`;
            counter += 1;
        } else validName = candidateName;
        return validName;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const marks = {};
    // Excludes mark starting with '_'. This allows marks to opt-out from the report.
    userTiming.filter(// @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
    (item)=>item.type === 'mark' && !item.name.startsWith('_') && !item.name.endsWith((0, $hknOo.JS_EVAL_START)) && !item.name.endsWith((0, $hknOo.JS_EVAL_STOP)) && item.startTime >= data.start)// @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
    .forEach((item)=>{
        const name = getNextAvailableName({
            baseName: `mark__${sanitizeName(item.name)}`,
            collection: marks
        });
        marks[name] = Math.round(item.startTime - data.start);
    });
    return marks;
};

});

parcelRegister("5asE8", function(module, exports) {

$parcel$export(module.exports, "getMemoryUsageReport", () => $94ae843e3148994a$export$e5bd2d61c7c80651);
/**
 * Memory usage report.
 *
 * In the future may be extended to contain `performance.measureUserAgentSpecificMemory` if Jira
 * front-end uses cross-origin isolation.
 */ const $94ae843e3148994a$export$e5bd2d61c7c80651 = ({ start: start, stop: stop })=>{
    // @ts-expect-error - TS2339 - Property 'memory' does not exist on type 'Performance'.
    if (typeof performance === 'undefined' || performance?.memory == null) return null;
    const sessionTime = Math.round(stop - start);
    // @ts-expect-error - TS2339 - Property 'memory' does not exist on type 'Performance'.
    const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = performance.memory;
    return {
        sessionTime: sessionTime,
        performanceMemoryEntry: {
            jsHeapSizeLimit: jsHeapSizeLimit,
            totalJSHeapSize: totalJSHeapSize,
            usedJSHeapSize: usedJSHeapSize
        }
    };
};

});

parcelRegister("3J8Ab", function(module, exports) {

$parcel$export(module.exports, "getPageSizeMetrics", () => $3c810a8de2a9a285$export$84e3d676f1564c75);
$parcel$export(module.exports, "getExtraNavigationTimings", () => $3c810a8de2a9a285$export$b37a70af06e58097);
$parcel$export(module.exports, "getPageSizeInfo", () => $3c810a8de2a9a285$export$b72e035af6568be7);

var $8uNQc = parcelRequire("8uNQc");
const $3c810a8de2a9a285$export$84e3d676f1564c75 = ()=>{
    let maxDepth = -1;
    let maxWidth = -1;
    let numElements = 0;
    // As described in the lighthouse DOM audit - https://web.dev/dom-size/
    const calculateDOMsizeAndDepth = (el = document.body, depth = 1)=>{
        if (!el) return;
        if (depth > maxDepth) maxDepth = depth;
        if (el.children.length > maxWidth) maxWidth = el.children.length;
        let child = el.firstElementChild;
        while(child){
            // @ts-expect-error - TS2345 - Argument of type 'Element' is not assignable to parameter of type 'HTMLElement'.
            calculateDOMsizeAndDepth(child, depth + 1);
            // If element has shadow dom, traverse into that tree.
            if (child.shadowRoot) // @ts-expect-error - TS2345 - Argument of type 'ShadowRoot' is not assignable to parameter of type 'HTMLElement'.
            calculateDOMsizeAndDepth(child.shadowRoot, depth + 1);
            child = child.nextElementSibling;
            numElements += 1;
        }
    };
    calculateDOMsizeAndDepth();
    return {
        totalBodyElements: numElements,
        maxNestedLevels: maxDepth,
        maxChildElements: maxWidth
    };
};
const $3c810a8de2a9a285$export$b37a70af06e58097 = ()=>{
    if (!(0, $8uNQc.default)) return {};
    const navigation = (0, $8uNQc.default).getEntriesByType('navigation')[0];
    if (!navigation) return {};
    return {
        // From https://www.w3.org/TR/navigation-timing-2/
        // @ts-expect-error - TS2339 - Property 'decodedBodySize' does not exist on type 'PerformanceEntry'.
        decodedBodySize: navigation.decodedBodySize,
        // @ts-expect-error - TS2339 - Property 'encodedBodySize' does not exist on type 'PerformanceEntry'.
        encodedBodySize: navigation.encodedBodySize,
        // @ts-expect-error - TS2339 - Property 'transferSize' does not exist on type 'PerformanceEntry'.
        transferSize: navigation.transferSize
    };
};
const $3c810a8de2a9a285$var$assetsTypes = [
    'script',
    'link'
];
const $3c810a8de2a9a285$export$b72e035af6568be7 = ({ start: start, stop: stop })=>{
    const pageSize = $3c810a8de2a9a285$export$b37a70af06e58097();
    if (!pageSize || Object.keys(pageSize).length === 0 || pageSize.decodedBodySize === 0 || start > 0) return {};
    const decoded = {
        total: pageSize.decodedBodySize,
        pageSize: pageSize.decodedBodySize,
        assets: 0,
        endpoints: 0
    };
    const encoded = {
        total: pageSize.encodedBodySize,
        pageSize: pageSize.encodedBodySize,
        assets: 0,
        endpoints: 0
    };
    const net = {
        total: pageSize.transferSize,
        assets: 0,
        endpoints: 0
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    for (const entry of (0, $8uNQc.default).getEntriesByType('resource')){
        if (entry.startTime > stop) continue;
        if ($3c810a8de2a9a285$var$assetsTypes.includes(entry.initiatorType)) {
            decoded.total += entry.decodedBodySize;
            decoded.assets += entry.decodedBodySize;
            encoded.total += entry.encodedBodySize;
            encoded.assets += entry.encodedBodySize;
            net.total += entry.transferSize;
            net.assets += entry.transferSize;
        } else {
            decoded.total += entry.decodedBodySize;
            decoded.endpoints += entry.decodedBodySize;
            encoded.total += entry.encodedBodySize;
            encoded.endpoints += entry.encodedBodySize;
            net.total += entry.transferSize;
            net.endpoints += entry.transferSize;
        }
    }
    const returnValue = {};
    Object.keys(decoded).forEach((key)=>{
        returnValue[`size:decoded:${key}`] = decoded[key];
    });
    Object.keys(encoded).forEach((key)=>{
        returnValue[`size:encoded:${key}`] = encoded[key];
    });
    Object.keys(net).forEach((key)=>{
        returnValue[`size:net:${key}`] = net[key];
    });
    return returnValue;
};

});

parcelRegister("jRw2l", function(module, exports) {

$parcel$export(module.exports, "getRouterResourceMetrics", () => $408d5049c0fbe74b$export$e703af446a67c7f4);
const $408d5049c0fbe74b$export$e703af446a67c7f4 = ()=>{
    const ssrRouterResourceTimeouts = window.SPA_STATE ? Object.keys(window.SPA_STATE).filter((key)=>{
        if (key !== key.toUpperCase()) return false;
        const resource = window.SPA_STATE[key];
        if (typeof resource !== 'object') return false;
        const resourceResponse = resource[Object.keys(resource)[0]];
        return resourceResponse?.error?.name === 'TimeoutError';
    }) : [];
    return {
        ssrRouterResourceTimeouts: ssrRouterResourceTimeouts
    };
};

});

parcelRegister("8Icn5", function(module, exports) {

$parcel$export(module.exports, "getServerDurationMetrics", () => $812c01dc8d4942e0$export$efd8b60b870e5282);
const $812c01dc8d4942e0$export$efd8b60b870e5282 = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const metrics = {};
    try {
        // server duration metric is buried in a hidden form near end of </body>
        const serverDurationElem = document.querySelector('#jira_request_timing_info [title="jira.request.server.time"]');
        if (serverDurationElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverDuration = Number(serverDurationElem.value);
            if (serverDuration > 0) metrics.serverDuration = Math.round(serverDuration);
        }
        const serverTraceIdElem = document.querySelector('#jira_request_timing_info [title="jira.request.trace.id"]');
        if (serverTraceIdElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverRequestTraceId = serverTraceIdElem.value;
            metrics.serverRequestTraceId = serverRequestTraceId;
        }
        const serverTraceSampledElem = document.querySelector('#jira_request_timing_info [title="jira.request.sampled"]');
        if (serverTraceSampledElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverRequestTraceSampled = serverTraceSampledElem.value;
            switch(serverRequestTraceSampled){
                case 'true':
                    metrics.serverRequestTraceSampled = true;
                    break;
                case 'false':
                    metrics.serverRequestTraceSampled = false;
                    break;
                default:
                    metrics.serverRequestTraceSampled = null;
                    break;
            }
        }
        const concurrentRequestsElem = document.querySelector('#jira_request_timing_info [name="jira.request.concurrent.requests"]');
        if (concurrentRequestsElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const concurrentRequests = concurrentRequestsElem.value;
            metrics.concurrentRequests = concurrentRequests;
        }
        const serverRequestStartTimeElem = document.querySelector('#jira_request_timing_info [name="jira.request.start.millis"]');
        if (serverRequestStartTimeElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverRequestStartTime = serverRequestStartTimeElem.value;
            metrics.serverRequestStartTime = serverRequestStartTime;
        }
        const frontendFlushStartTimeElem = document.querySelector('#jira_request_timing_info [name="jira.request.frontend.flush.start"]');
        if (frontendFlushStartTimeElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const frontendFlushStartTime = frontendFlushStartTimeElem.value;
            metrics.frontendFlushStartTime = frontendFlushStartTime;
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (ignored) {
    /* noop */ }
    return metrics;
};

});

parcelRegister("byQ0F", function(module, exports) {

$parcel$export(module.exports, "getWRMStats", () => $3a9718319a9f67d8$export$d2d916ddd03b82bc);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3a9718319a9f67d8$export$d2d916ddd03b82bc = ()=>{
    const wrmStats = window.__WRM_INTERNAL_STATS__ ?? {};
    return {
        wrmStats: wrmStats
    };
};

});


parcelRegister("48rGI", function(module, exports) {

$parcel$export(module.exports, "configure", () => $b025e4ca26c12c31$export$8d21e34596265fa2);
$parcel$export(module.exports, "getBundleEvalTimings", () => $b025e4ca26c12c31$export$2eda1519e91a4386);

var $gCixD = parcelRequire("gCixD");
let $b025e4ca26c12c31$var$config = null;
function $b025e4ca26c12c31$export$8d21e34596265fa2(bundleEvalTimingConfiguration) {
    $b025e4ca26c12c31$var$config = bundleEvalTimingConfiguration;
}
const $b025e4ca26c12c31$var$getPerformanceObject = ()=>(window ?? {}).performance;
function $b025e4ca26c12c31$export$2eda1519e91a4386(interactionStartTime) {
    if ($b025e4ca26c12c31$var$config == null) return {};
    const started = {};
    const timings = {};
    const cachedConfig = $b025e4ca26c12c31$var$config;
    const performance = $b025e4ca26c12c31$var$getPerformanceObject();
    performance?.getEntriesByType('mark').forEach((mark)=>{
        const result = cachedConfig.mapPerformanceMark(mark.name);
        if (!result) return;
        const { type: type, name: name } = result;
        if (type === 'start' && mark.startTime >= interactionStartTime) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: (0, $gCixD.roundEpsilon)(started[name].startTime - interactionStartTime),
                duration: (0, $gCixD.roundEpsilon)(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (Object.keys(timings).length === 0) return {};
    return timings;
}

});
parcelRegister("gCixD", function(module, exports) {

$parcel$export(module.exports, "roundEpsilon", () => $851a328956679561$export$56014375de40214b);
const $851a328956679561$export$56014375de40214b = (num, places = 3)=>{
    const factor = Math.pow(10, places);
    return Math.round((num + Number.EPSILON) * factor) / factor;
};

});


parcelRegister("2rCPX", function(module, exports) {

$parcel$export(module.exports, "init", () => $54c23dde33a1e5d1$export$2cd8252107eb640b);

var $9oL1R = parcelRequire("9oL1R");

var $llthr = parcelRequire("llthr");

var $4vWWq = parcelRequire("4vWWq");

var $cd3ip = parcelRequire("cd3ip");

var $6OpDQ = parcelRequire("6OpDQ");

var $fVaJL = parcelRequire("fVaJL");

var $5TiXm = parcelRequire("5TiXm");
let $54c23dde33a1e5d1$var$initialized = false;
function $54c23dde33a1e5d1$var$sinkInteraction(instance, payloadPackage) {
    (0, $fVaJL.sinkInteractionHandler)((interactionId, interaction)=>{
        (0, $9oL1R.unstable_scheduleCallback)((0, $9oL1R.unstable_IdlePriority), ()=>{
            const payloads = payloadPackage.createPayloads(interactionId, interaction);
            payloads?.forEach((payload)=>{
                instance.sendOperationalEvent(payload);
            });
        });
    });
}

const $54c23dde33a1e5d1$export$2cd8252107eb640b = (analyticsWebClientAsync, config)=>{
    if ($54c23dde33a1e5d1$var$initialized) return;
    (0, $4vWWq.setUFOConfig)(config);
    if (config.enableTTVC) (0, $cd3ip.initTTVC)();
    if (config.vc?.enabled) (0, $5TiXm.getVCObserver)({
        heatmapSize: config.vc.heatmapSize,
        oldDomUpdates: config.vc.oldDomUpdates,
        devToolsEnabled: config.vc.devToolsEnabled,
        selectorConfig: config.vc.selectorConfig
    }).start({
        startTime: 0
    });
    (0, $6OpDQ.setupHiddenTimingCapture)();
    (0, $llthr.startLighthouseObserver)();
    $54c23dde33a1e5d1$var$initialized = true;
    Promise.all([
        analyticsWebClientAsync,
        // eslint-disable-next-line import/dynamic-import-chunkname
        (parcelRequire("hLidf"))
    ]).then(([awc, payloadPackage])=>{
        if (awc.getAnalyticsWebClientPromise) awc.getAnalyticsWebClientPromise().then((client)=>{
            const instance = client.getInstance();
            $54c23dde33a1e5d1$var$sinkInteraction(instance, payloadPackage);
        });
        else if (awc.sendOperationalEvent) $54c23dde33a1e5d1$var$sinkInteraction(awc, payloadPackage);
    });
};

});
parcelRegister("llthr", function(module, exports) {

$parcel$export(module.exports, "startLighthouseObserver", () => $a334799c2848744c$export$5ecf2aafafee3e0);
$parcel$export(module.exports, "getLighthouseMetrics", () => $a334799c2848744c$export$b46cecdf698e4bb5);

var $gGW6i = parcelRequire("gGW6i");

var $bvrsg = parcelRequire("bvrsg");

var $6OS1U = parcelRequire("6OS1U");

var $j60Q5 = parcelRequire("j60Q5");

var $5Xyeo = parcelRequire("5Xyeo");
function $a334799c2848744c$export$5ecf2aafafee3e0() {
    (0, $5Xyeo.startLSObserver)();
    (0, $5Xyeo.startLTObserver)();
}
const $a334799c2848744c$export$b46cecdf698e4bb5 = ({ start: start, stop: stop })=>{
    const tbt = (0, $6OS1U.getTBT)(start, stop, (0, $j60Q5.EntriesBuffer)[(0, $bvrsg.PerformanceObserverEntryTypes).LongTask]);
    // no round as CLS is usually 0-1
    const cls = (0, $gGW6i.getCLS)(start, stop, (0, $j60Q5.EntriesBuffer)[(0, $bvrsg.PerformanceObserverEntryTypes).LayoutShift]);
    return {
        'metric:tbt': Math.round(tbt.total),
        'metric:tbt:observed': Math.round(tbt.observed),
        'metric:cls': cls
    };
};

});
parcelRegister("gGW6i", function(module, exports) {

$parcel$export(module.exports, "getCLS", () => $93736c041de848a7$export$fc6227831ee7c7);
const $93736c041de848a7$export$fc6227831ee7c7 = (start, stop, buffer)=>{
    const layoutShifts = buffer.getAll().filter((entry)=>entry.startTime >= start && entry.startTime <= stop);
    const sessionWindows = [];
    let currentWindow = null;
    // Group layout shifts into session windows
    for (const shift of layoutShifts){
        const { startTime: startTime } = shift;
        const endTime = shift.startTime + shift.duration;
        const score = shift.value;
        if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
            // Start a new session window
            currentWindow = {
                startTime: startTime,
                endTime: endTime,
                score: score
            };
            sessionWindows.push(currentWindow);
        } else {
            // Add layout shift to current session window
            currentWindow.endTime = endTime;
            currentWindow.score += score;
        }
    }
    // Find session window with highest cumulative score
    const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
    // Return score of largest burst as CLS metric
    return Math.round(maxScore * 10000) / 10000;
};

});

parcelRegister("bvrsg", function(module, exports) {

$parcel$export(module.exports, "PerformanceObserverEntryTypes", () => $e72fe025eeec1b10$export$a4def92db6fc8e17);
const $e72fe025eeec1b10$export$a4def92db6fc8e17 = {
    LayoutShift: 'layout-shift',
    LongTask: 'longtask'
};

});

parcelRegister("6OS1U", function(module, exports) {

$parcel$export(module.exports, "getTBT", () => $d1508b90afa67f4b$export$2d6e933b35bd3407);
const $d1508b90afa67f4b$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
const $d1508b90afa67f4b$export$2d6e933b35bd3407 = (start, stop, buffer)=>buffer.getAll().filter((entry)=>entry.startTime <= stop && entry.duration > $d1508b90afa67f4b$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
        const longTaskStop = entry.startTime + entry.duration;
        const intersectStart = Math.max(entry.startTime + $d1508b90afa67f4b$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        const intersectStop = Math.min(longTaskStop, stop);
        const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $d1508b90afa67f4b$var$MAX_ACCEPTABLE_TASK_DURATION;
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });

});

parcelRegister("j60Q5", function(module, exports) {

$parcel$export(module.exports, "EntriesBuffer", () => $28a32ee326320eda$export$f7dc16cbd16f7bbe);

var $bvrsg = parcelRequire("bvrsg");
class $28a32ee326320eda$export$2c6e86519c9e8188 {
    constructor(maxLength = 1000){
        this.buffer = [];
        this.full = false;
        this.maxLength = maxLength;
    }
    push(item) {
        if (this.full || this.maxLength === this.buffer.length) {
            this.full = true;
            this.buffer.shift();
        }
        this.buffer.push(item);
    }
    getAll() {
        return this.buffer;
    }
}
const $28a32ee326320eda$export$f7dc16cbd16f7bbe = {
    [(0, $bvrsg.PerformanceObserverEntryTypes).LongTask]: new $28a32ee326320eda$export$2c6e86519c9e8188(),
    [(0, $bvrsg.PerformanceObserverEntryTypes).LayoutShift]: new $28a32ee326320eda$export$2c6e86519c9e8188()
};

});

parcelRegister("5Xyeo", function(module, exports) {

$parcel$export(module.exports, "startLSObserver", () => $1234018db208e69c$export$768ccc3ab7bac3ea);
$parcel$export(module.exports, "startLTObserver", () => $1234018db208e69c$export$54fb8b6aaf70ec9c);

var $bvrsg = parcelRequire("bvrsg");

var $j60Q5 = parcelRequire("j60Q5");
let $1234018db208e69c$var$pe = null;
const $1234018db208e69c$var$getObserver = ()=>{
    if ($1234018db208e69c$var$pe !== null) return $1234018db208e69c$var$pe;
    $1234018db208e69c$var$pe = new PerformanceObserver((list)=>{
        list.getEntries().forEach((entry)=>{
            if (entry.entryType === (0, $bvrsg.PerformanceObserverEntryTypes).LayoutShift) (0, $j60Q5.EntriesBuffer)[(0, $bvrsg.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, $bvrsg.PerformanceObserverEntryTypes).LongTask) (0, $j60Q5.EntriesBuffer)[(0, $bvrsg.PerformanceObserverEntryTypes).LongTask].push(entry);
        });
    });
    return $1234018db208e69c$var$pe;
};
const $1234018db208e69c$export$768ccc3ab7bac3ea = ()=>{
    $1234018db208e69c$var$getObserver().observe({
        type: (0, $bvrsg.PerformanceObserverEntryTypes).LayoutShift,
        buffered: true
    });
};
const $1234018db208e69c$export$54fb8b6aaf70ec9c = ()=>{
    $1234018db208e69c$var$getObserver().observe({
        type: (0, $bvrsg.PerformanceObserverEntryTypes).LongTask,
        buffered: true
    });
};

});


parcelRegister("6OpDQ", function(module, exports) {

$parcel$export(module.exports, "setupHiddenTimingCapture", () => $3deff2cc88aa5ba1$export$554cefe0f0373da4);
$parcel$export(module.exports, "getPageVisibilityState", () => $3deff2cc88aa5ba1$export$768b2008623433e1);

var $74BVL = parcelRequire("74BVL");
const $3deff2cc88aa5ba1$var$timings = [];
let $3deff2cc88aa5ba1$var$wasHiddenFlag;
let $3deff2cc88aa5ba1$var$setupFlag = false;
function $3deff2cc88aa5ba1$var$isPageHidden() {
    if ('visibilityState' in document) return document.visibilityState === 'hidden';
    else // @ts-expect-error - Property 'hidden' does not exist on type 'never'.
    return document.hidden;
}
const $3deff2cc88aa5ba1$var$SIZE = 50;
let $3deff2cc88aa5ba1$var$insertIndex = 0;
function $3deff2cc88aa5ba1$var$pushHidden(isPageHiddenFlag, time) {
    $3deff2cc88aa5ba1$var$timings[$3deff2cc88aa5ba1$var$insertIndex] = {
        time: time ?? performance.now(),
        hidden: isPageHiddenFlag
    };
    $3deff2cc88aa5ba1$var$insertIndex = ($3deff2cc88aa5ba1$var$insertIndex + 1) % $3deff2cc88aa5ba1$var$SIZE;
    $3deff2cc88aa5ba1$var$wasHiddenFlag = isPageHiddenFlag;
}
function $3deff2cc88aa5ba1$var$handleChange() {
    const isPageHiddenFlag = $3deff2cc88aa5ba1$var$isPageHidden();
    if (isPageHiddenFlag) {
        if (!$3deff2cc88aa5ba1$var$wasHiddenFlag) $3deff2cc88aa5ba1$var$pushHidden(isPageHiddenFlag);
        $3deff2cc88aa5ba1$var$wasHiddenFlag = true;
    } else {
        if ($3deff2cc88aa5ba1$var$wasHiddenFlag) $3deff2cc88aa5ba1$var$pushHidden(isPageHiddenFlag);
        $3deff2cc88aa5ba1$var$wasHiddenFlag = false;
    }
}
function $3deff2cc88aa5ba1$var$setup() {
    (0, $74BVL.bind)(window, {
        type: 'pageshow',
        listener: $3deff2cc88aa5ba1$var$handleChange
    });
    (0, $74BVL.bind)(window, {
        type: 'pagehide',
        listener: $3deff2cc88aa5ba1$var$handleChange
    });
    (0, $74BVL.bind)(document, {
        type: 'visibilitychange',
        listener: $3deff2cc88aa5ba1$var$handleChange
    });
}
function $3deff2cc88aa5ba1$export$554cefe0f0373da4() {
    if (!$3deff2cc88aa5ba1$var$setupFlag) {
        const isPageHiddenFlag = $3deff2cc88aa5ba1$var$isPageHidden();
        $3deff2cc88aa5ba1$var$pushHidden(isPageHiddenFlag, 0);
        $3deff2cc88aa5ba1$var$setup();
        $3deff2cc88aa5ba1$var$setupFlag = true;
    }
}
function $3deff2cc88aa5ba1$export$768b2008623433e1(start, end) {
    // Desirable default value is visible
    if ($3deff2cc88aa5ba1$var$timings.length === 0) return 'visible';
    const currentSize = $3deff2cc88aa5ba1$var$timings.length;
    let hiddenState = 'mixed';
    let startIdx = $3deff2cc88aa5ba1$var$insertIndex;
    let endIdx = $3deff2cc88aa5ba1$var$insertIndex;
    // currentSize is capped at SIZE.
    for(let i = 0; i < currentSize; i++){
        const tmpIdx = ($3deff2cc88aa5ba1$var$insertIndex + i) % currentSize;
        if ($3deff2cc88aa5ba1$var$timings[tmpIdx].time <= end) {
            endIdx = tmpIdx;
            if ($3deff2cc88aa5ba1$var$timings[tmpIdx].time <= start) startIdx = tmpIdx;
        }
    }
    if (endIdx - startIdx === 0) {
        if ($3deff2cc88aa5ba1$var$timings[startIdx].hidden) hiddenState = 'hidden';
        else hiddenState = 'visible';
    }
    return hiddenState;
}

});

parcelRegister("hLidf", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('1Rqlj');
        const value = parcelRequire('hbPvy');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("1Rqlj").then(()=>parcelRequire('hbPvy'));
}

});


parcelRegister("bSFmz", function(module, exports) {

$parcel$export(module.exports, "configure", () => $b9df9448f0be7ffb$export$8d21e34596265fa2);
$parcel$export(module.exports, "getConfig", () => $b9df9448f0be7ffb$export$44487a86467333c3);

var $4vWWq = parcelRequire("4vWWq");
const $b9df9448f0be7ffb$var$defaultAllowedParams = [
    'operationName',
    'operation',
    'q'
];
const $b9df9448f0be7ffb$var$getAllowedParams = ()=>{
    const config = (0, $4vWWq.getConfig)();
    return config?.allowedResourcesParams || $b9df9448f0be7ffb$var$defaultAllowedParams;
};
const $b9df9448f0be7ffb$var$handleQueryParams = (urlString)=>{
    try {
        if (typeof urlString !== 'string') return urlString;
        const url = new URL(urlString);
        const params = new URLSearchParams(url.search);
        const allowedParams = $b9df9448f0be7ffb$var$getAllowedParams();
        for (const [key] of params)if (!allowedParams.includes(key)) url.searchParams.delete(key);
        return url.toString();
    } catch (e) {
        return urlString;
    }
};
let $b9df9448f0be7ffb$var$config = {
    mapResources: (url)=>url,
    sanitiseEndpoints: (url)=>{
        return $b9df9448f0be7ffb$var$handleQueryParams(url);
    }
};
function $b9df9448f0be7ffb$export$8d21e34596265fa2(resourceTimingConfig) {
    const newConfig = {
        mapResources: resourceTimingConfig.mapResources,
        sanitiseEndpoints: (url)=>{
            const sanitised = resourceTimingConfig.sanitiseEndpoints(url);
            if (sanitised) return $b9df9448f0be7ffb$var$handleQueryParams(sanitised);
            return sanitised;
        }
    };
    $b9df9448f0be7ffb$var$config = newConfig;
}
const $b9df9448f0be7ffb$export$44487a86467333c3 = ()=>$b9df9448f0be7ffb$var$config;

});

parcelRegister("gLcQl", function(module, exports) {

$parcel$export(module.exports, "startResourceTimingBuffer", () => $45a865a94b554c6a$export$a311cb1baa7d2d62);

var $9d7I6 = parcelRequire("9d7I6");
function $45a865a94b554c6a$export$a311cb1baa7d2d62() {
    (0, $9d7I6.resourceTimingBuffer).start();
}

});
parcelRegister("9d7I6", function(module, exports) {

$parcel$export(module.exports, "resourceTimingBuffer", () => $0acaafb8801eaffa$export$bea963256235a63e);
$parcel$export(module.exports, "filterResourceTimings", () => $0acaafb8801eaffa$export$4138a729ef1db028);

var $gCixD = parcelRequire("gCixD");
const $0acaafb8801eaffa$var$getPerformanceObject = ()=>(window ?? {}).performance;
const $0acaafb8801eaffa$var$getPerformanceObserverObject = ()=>(window ?? {}).PerformanceObserver;
const $0acaafb8801eaffa$export$bea963256235a63e = {
    timings: [],
    maxSize: 1000,
    observer: null,
    transformResource: (entry)=>{
        const duration = (0, $gCixD.roundEpsilon)(entry.duration);
        const totalBackendTimeEntry = entry.serverTiming?.find(// timing name should come from per-product config in the future
        (timing)=>timing.name === 'total' || timing.name === 'filter-request-papi');
        const serverTime = totalBackendTimeEntry ? (0, $gCixD.roundEpsilon)(totalBackendTimeEntry.duration) : undefined;
        const networkTime = serverTime ? duration - serverTime : undefined;
        return {
            name: entry.name,
            initiatorType: entry.initiatorType,
            transferSize: entry.transferSize,
            startTime: (0, $gCixD.roundEpsilon)(entry.startTime),
            duration: (0, $gCixD.roundEpsilon)(entry.duration),
            fetchStart: (0, $gCixD.roundEpsilon)(entry.fetchStart || 0),
            workerStart: (0, $gCixD.roundEpsilon)(entry.workerStart || 0),
            responseStart: (0, $gCixD.roundEpsilon)(entry.responseStart || 0),
            serverTime: serverTime,
            networkTime: networkTime
        };
    },
    start: ()=>{
        const performance = $0acaafb8801eaffa$var$getPerformanceObject();
        const PerformanceObserver = $0acaafb8801eaffa$var$getPerformanceObserverObject();
        if (!PerformanceObserver || !performance || typeof PerformanceObserver === 'undefined') return;
        if ($0acaafb8801eaffa$export$bea963256235a63e.observer) return;
        const resources = performance.getEntriesByType?.('resource');
        if (resources) $0acaafb8801eaffa$export$bea963256235a63e.timings = resources.map((resource)=>$0acaafb8801eaffa$export$bea963256235a63e.transformResource(resource));
        $0acaafb8801eaffa$export$bea963256235a63e.observer = new PerformanceObserver($0acaafb8801eaffa$export$bea963256235a63e.addTimings);
        $0acaafb8801eaffa$export$bea963256235a63e.observer.observe({
            entryTypes: [
                'resource'
            ]
        });
    },
    stop: ()=>{
        if ($0acaafb8801eaffa$export$bea963256235a63e.observer) {
            $0acaafb8801eaffa$export$bea963256235a63e.observer.disconnect();
            $0acaafb8801eaffa$export$bea963256235a63e.observer = null;
        }
        $0acaafb8801eaffa$export$bea963256235a63e.timings = [];
    },
    addTimings: (list)=>{
        const entries = list.getEntries().map((entry)=>$0acaafb8801eaffa$export$bea963256235a63e.transformResource(entry));
        const overflow = $0acaafb8801eaffa$export$bea963256235a63e.timings.length + entries.length;
        if (overflow > $0acaafb8801eaffa$export$bea963256235a63e.maxSize) {
            const fieldsToRemove = overflow - $0acaafb8801eaffa$export$bea963256235a63e.maxSize;
            $0acaafb8801eaffa$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
        }
        $0acaafb8801eaffa$export$bea963256235a63e.timings.push(...entries);
    }
};
const $0acaafb8801eaffa$var$isValidTiming = (timing, startTime, endTime)=>timing.startTime >= startTime && timing.startTime + timing.duration <= endTime;
const $0acaafb8801eaffa$export$4138a729ef1db028 = (startTime, endTime)=>{
    const performance = $0acaafb8801eaffa$var$getPerformanceObject();
    const PerformanceObserver = $0acaafb8801eaffa$var$getPerformanceObserverObject();
    if (!PerformanceObserver || !$0acaafb8801eaffa$export$bea963256235a63e.observer) {
        const resources = performance?.getEntriesByType('resource');
        if (resources) return resources.filter((timing)=>$0acaafb8801eaffa$var$isValidTiming(timing, startTime, endTime));
        return null;
    }
    return $0acaafb8801eaffa$export$bea963256235a63e.timings.filter((timing)=>$0acaafb8801eaffa$var$isValidTiming(timing, startTime, endTime));
};

});


parcelRegister("jinpL", function(module, exports) {

$parcel$export(module.exports, "configure", () => $43895fbe048e8715$export$8d21e34596265fa2);
$parcel$export(module.exports, "getSSRTimings", () => $43895fbe048e8715$export$bf7408e83532dcd0);
$parcel$export(module.exports, "getSSRSuccess", () => $43895fbe048e8715$export$c7ad864055e75537);
$parcel$export(module.exports, "getSSRDoneTime", () => $43895fbe048e8715$export$3def7672244bab0c);
$parcel$export(module.exports, "getSSRFeatureFlags", () => $43895fbe048e8715$export$1c4a9b5e6e22393d);
const $43895fbe048e8715$var$NESTED_METRIC_SEPARATOR = '/';
const $43895fbe048e8715$var$filterEntry = (entry)=>!(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
const $43895fbe048e8715$var$mapEntry = (entry)=>({
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    });
const $43895fbe048e8715$var$SSR_PREFIX = 'ssr';
const $43895fbe048e8715$var$mapKey = (key)=>{
    if (key === 'total') return $43895fbe048e8715$var$SSR_PREFIX;
    return `${$43895fbe048e8715$var$SSR_PREFIX}${$43895fbe048e8715$var$NESTED_METRIC_SEPARATOR}${key}`;
};
let $43895fbe048e8715$var$config;
function $43895fbe048e8715$export$8d21e34596265fa2(ssrConfig) {
    $43895fbe048e8715$var$config = ssrConfig;
}
function $43895fbe048e8715$export$bf7408e83532dcd0() {
    if (!$43895fbe048e8715$var$config?.getTimings) return {};
    const timings = $43895fbe048e8715$var$config.getTimings();
    if (!timings) return {};
    const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
        if ($43895fbe048e8715$var$filterEntry(entry[1])) acc[$43895fbe048e8715$var$mapKey(entry[0])] = $43895fbe048e8715$var$mapEntry(entry[1]);
        return acc;
    }, {});
    return ssrTimings;
}
function $43895fbe048e8715$export$c7ad864055e75537() {
    return !!$43895fbe048e8715$var$config?.getDoneMark();
}
function $43895fbe048e8715$export$3def7672244bab0c() {
    return $43895fbe048e8715$var$config?.getDoneMark() ?? undefined;
}
function $43895fbe048e8715$export$1c4a9b5e6e22393d() {
    if (!$43895fbe048e8715$var$config?.getFeatureFlags) return undefined;
    try {
        return $43895fbe048e8715$var$config.getFeatureFlags() ?? undefined;
    // eslint-disable-next-line no-empty
    } catch (e) {}
    return undefined;
}

});

parcelRegister("kvBcO", function(module, exports) {

$parcel$export(module.exports, "jiraBundleEvalTimingsConfig", () => $90678e6868a8e976$export$791b8c0cbd574ea9);

var $hknOo = parcelRequire("hknOo");
const $90678e6868a8e976$export$791b8c0cbd574ea9 = {
    mapPerformanceMark: (mark)=>{
        if (mark.endsWith((0, $hknOo.JS_EVAL_START))) return {
            name: mark.substring(0, mark.indexOf((0, $hknOo.JS_EVAL_START))),
            type: 'start'
        };
        if (mark.endsWith((0, $hknOo.JS_EVAL_STOP))) return {
            name: mark.substring(0, mark.indexOf((0, $hknOo.JS_EVAL_STOP))),
            type: 'end'
        };
        return null;
    }
};

});

parcelRegister("8NQa5", function(module, exports) {

$parcel$export(module.exports, "jiraResourceTimingsConfig", () => $0beb836a724a435f$export$8fa71550bcdc2104);

var $k4nIh = parcelRequire("k4nIh");

var $lCenZ = parcelRequire("lCenZ");
const $0beb836a724a435f$var$isWRMResource = (url)=>url.includes('/batch.js') || url.includes('/batch.css');
const $0beb836a724a435f$var$getWRMAssetName = (url)=>{
    const [, resources] = /\/([\w.\-,:]*?)(?:,-|\/batch\.)/.exec(url) || [];
    const assetName = (0, $lCenZ.sanitiseAssetName)(false)(url);
    if (!resources) return assetName;
    return `wrm/${resources}/${assetName}`;
};
const $0beb836a724a435f$var$getFileName = (url)=>$0beb836a724a435f$var$isWRMResource(url) ? $0beb836a724a435f$var$getWRMAssetName(url) : (0, $lCenZ.sanitiseAssetName)(false)(url);
const $0beb836a724a435f$var$sanitiseEndpoints = (url)=>{
    const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($k4nIh)))(url, true);
    /**
	 * For endpoints with operation or operationName queryParam we will shorten the url
	 * as ufo pipeline will only get the `operation` query param for aggregation
	 */ const { operation: operation, operationName: operationName } = parsedUrl.query;
    const operationNameOverride = operation ?? operationName;
    if (operationNameOverride) return `/${operation}?operation=${operation}`;
    const fileName = parsedUrl.pathname.replace(/\/(project|agent)(-config|s)?\/([A-Z0-9]+)/g, '/$1$2/<project-key>').replace(/\/(servicedesk)(-data)?\/([A-Z0-9]+)/g, '/$1$2/<project-key>').replace(/\/(browse|automation|pagination|permissions|async|dialog|itsm)\/([A-Z0-9]+)/g, '/$1/<project-key>').replace(/\/(board)(s)?\/([0-9]+)/g, '/$1$2/<board-id>').replace(/\/(\w+)-(\d+)\//i, '/<issue-key>/').replace(/\/pq\/[a-fA-F0-9]+/i, '/pq/<id>') // persisted queries
    .replace(/\/user\/[a-fA-F0-9\-:]+/i, '/user/<user-id>') // engage targeting
    .replace(/[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12}/i, '<uuid>').replace(/\/\d+$/i, '/<id>');
    return fileName;
};
const $0beb836a724a435f$export$8fa71550bcdc2104 = {
    sanitiseEndpoints: $0beb836a724a435f$var$sanitiseEndpoints,
    mapResources: $0beb836a724a435f$var$getFileName,
    hasTimingHeaders: (url)=>url.includes('jira-frontend-static') || url.includes('jira-frontend-branch') || url.includes('jira-frontend-bifrost') || $0beb836a724a435f$var$isWRMResource(url),
    // @ts-expect-error - TS7006 - Parameter 'url' implicitly has an 'any' type.
    xhrFilter: (url)=>url.includes('/rest/greenhopper/')
};

});

parcelRegister("g62MK", function(module, exports) {

$parcel$export(module.exports, "jiraSsrConfig", () => $0781fcdae6ae9d6a$export$7bcf91e323db67dd);

var $kd0cS = parcelRequire("kd0cS");

var $6iz4v = parcelRequire("6iz4v");

var $6rW04 = parcelRequire("6rW04");

function $0781fcdae6ae9d6a$var$getTimings() {
    if (!window.SPA_STATE) return null;
    const detailRenderTrace = window.SPA_STATE['ssr/detail_render_trace'];
    const detailRequestTrace = window.SPA_STATE['ssr/detail_request_trace'];
    const highLevelMetrics = window.SPA_STATE['ssr/metrics'];
    const timings = (0, (/*@__PURE__*/$parcel$interopDefault($kd0cS)))(detailRenderTrace?.data?.traces) || {};
    if (highLevelMetrics?.data) {
        if ('ssrTotal' in highLevelMetrics.data) timings.total = {
            startTime: 0,
            duration: highLevelMetrics.data.ssrTotal
        };
        if ('ssrGetStyle' in highLevelMetrics.data) timings.styles = {
            startTime: highLevelMetrics.data.ssrGetStyle - highLevelMetrics.data.ssrGetStyle,
            duration: highLevelMetrics.data.ssrGetStyle
        };
        if ('ssrPrefetch' in highLevelMetrics.data) {
            const prefetchStartTime = Object.values(detailRenderTrace?.data?.traces || {}).reduce((min, { startTime: startTime })=>min === -1 || min > startTime ? startTime : min, -1);
            timings.prefetch = {
                startTime: prefetchStartTime,
                duration: highLevelMetrics.data.ssrPrefetch
            };
        }
    }
    if (detailRequestTrace?.data) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries(detailRequestTrace.data).forEach(([key, value])=>{
        timings[`prefetch/${key}`] = value;
    });
    return timings;
}
const $0781fcdae6ae9d6a$var$SSR_FF_META_TAG = 'spa-service-flags';
let $0781fcdae6ae9d6a$var$ffCache;
let $0781fcdae6ae9d6a$var$ffCacheInitialiser = ()=>{
    try {
        const metaTagValue = (0, $6rW04.default)($0781fcdae6ae9d6a$var$SSR_FF_META_TAG);
        if (metaTagValue === null) return null;
        $0781fcdae6ae9d6a$var$ffCache = JSON.parse(metaTagValue) || null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        $0781fcdae6ae9d6a$var$ffCache = null;
    }
    $0781fcdae6ae9d6a$var$ffCacheInitialiser = null;
};
function $0781fcdae6ae9d6a$var$getFeatureFlags() {
    if ($0781fcdae6ae9d6a$var$ffCacheInitialiser != null) $0781fcdae6ae9d6a$var$ffCacheInitialiser();
    return $0781fcdae6ae9d6a$var$ffCache;
}
const $0781fcdae6ae9d6a$export$7bcf91e323db67dd = {
    getDoneMark: ()=>(0, $6iz4v.getMark)((0, $37f655a4e4d5690e$export$135c96ab5afee429))?.startTime || null,
    getTimings: $0781fcdae6ae9d6a$var$getTimings,
    getFeatureFlags: $0781fcdae6ae9d6a$var$getFeatureFlags
};

});


parcelRegister("3F0y8", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f025ff4e6bfb344$export$2e2bcd8739ae039);

var $hompL = parcelRequire("hompL");

var $dZdw5 = parcelRequire("dZdw5");

var $4vWWq = parcelRequire("4vWWq");

var $1qnta = parcelRequire("1qnta");

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");

var $7sbhX = parcelRequire("7sbhX");
const $4f025ff4e6bfb344$var$AWAITING_PAGELOAD_NAME = 'awaiting_pageload_name';
function $4f025ff4e6bfb344$export$2e2bcd8739ae039(ufoName, routeName = ufoName) {
    const activeInteraction = (0, $fVaJL.getActiveInteraction)();
    if (activeInteraction && !ufoName) return;
    (0, $7sbhX.default).current = routeName || null;
    const rate = ufoName ? (0, $4vWWq.getInteractionRate)(ufoName, 'page_load') : 1;
    const enabledBySamplingRate = (0, $dZdw5.default)(rate);
    if (enabledBySamplingRate && !activeInteraction) {
        const newId = (0, $hompL.v4)();
        (0, $gnIbC.DefaultInteractionID).current = newId;
        (0, $fVaJL.addNewInteraction)(newId, ufoName || '', 'page_load', 0, rate, null, routeName, (0, $1qnta.getActiveTrace)());
        if (!ufoName) // if no name is provided we add a hold to the interaction, it is removed if the name is provided while the interaction is holding
        (0, $fVaJL.addHoldByID)(newId, [], $4f025ff4e6bfb344$var$AWAITING_PAGELOAD_NAME, $4f025ff4e6bfb344$var$AWAITING_PAGELOAD_NAME, true);
    } else if (!enabledBySamplingRate && activeInteraction && activeInteraction.type === 'page_load') // if there is an active interaction it will be aborted without initialising a new one because the coinflip returned false
    (0, $fVaJL.abort)(activeInteraction.id, 'excluded_by_sampling');
    else if (ufoName && activeInteraction && !activeInteraction.ufoName && activeInteraction.type === 'page_load') {
        (0, $fVaJL.updatePageLoadInteractionName)(ufoName, routeName);
        (0, $fVaJL.removeHoldByID)(activeInteraction.id, $4f025ff4e6bfb344$var$AWAITING_PAGELOAD_NAME);
    }
}
function $4f025ff4e6bfb344$export$d0f99433cd4f4028(ufoName, routeName = ufoName) {
    const interaction = (0, $fVaJL.getActiveInteraction)();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    if (ufoName) {
        const rate = (0, $4vWWq.getInteractionRate)(ufoName, 'page_load');
        (0, $fVaJL.updatePageLoadInteractionName)(ufoName, routeName);
        if ((0, $dZdw5.default)(rate)) (0, $7sbhX.default).current = ufoName;
        else (0, $fVaJL.abort)(interaction.id, 'excluded_by_sampling');
    }
    (0, $fVaJL.removeHoldByID)(interaction.id, $4f025ff4e6bfb344$var$AWAITING_PAGELOAD_NAME);
}

});

parcelRegister("foPCo", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3caef8d053fb2a2$export$2e2bcd8739ae039);

var $kFGm5 = parcelRequire("kFGm5");

var $ieRGA = parcelRequire("ieRGA");

var $1ybV0 = parcelRequire("1ybV0");

var $6rW04 = parcelRequire("6rW04");

var $2aRps = parcelRequire("2aRps");

var $1Fe9v = parcelRequire("1Fe9v");
// eslint-disable-next-line jira/ff/inline-usage
const $d3caef8d053fb2a2$var$isHeartbeatEnabled = ()=>(0, $1ybV0.ff)('jfp.heartbeat_vfp2h', false);

const $d3caef8d053fb2a2$var$renderEngagementMessages = ()=>{
    (parcelRequire("jO1SS"));
};

const $d3caef8d053fb2a2$var$renderProfileCardNextLegacy = ()=>{
    (parcelRequire("a5kyI"));
};

const $d3caef8d053fb2a2$var$renderHeartbeat = ()=>{
    (parcelRequire("6RmPe"));
};

const $d3caef8d053fb2a2$var$loadUpFlowAPI = ()=>(parcelRequire("hNcAl"));

const $d3caef8d053fb2a2$var$installConnectModules = ()=>(parcelRequire("bkILS"));
const $d3caef8d053fb2a2$var$markSafeForAnalytics = (str)=>str || null;
const $d3caef8d053fb2a2$var$renderSearchDwellTimeComponent = ()=>{
    const searchSessionId = (0, $6rW04.default)('ajs-search-session-id');
    const containerId = (0, $6rW04.default)('ajs-search-container-id');
    const objectId = (0, $6rW04.default)('ajs-search-object-id');
    const objectType = (0, $6rW04.default)('ajs-search-content-type');
    (0, $ieRGA.default)([
        'searchSessionId',
        'searchObjectId',
        'searchContainerId',
        'searchContentType'
    ]);
    (0, $1Fe9v.default)('search-dwell-time', $d3caef8d053fb2a2$var$markSafeForAnalytics(searchSessionId), {
        containerId: $d3caef8d053fb2a2$var$markSafeForAnalytics(containerId),
        objectId: $d3caef8d053fb2a2$var$markSafeForAnalytics(objectId),
        objectType: $d3caef8d053fb2a2$var$markSafeForAnalytics(objectType),
        actionSubject: $d3caef8d053fb2a2$var$markSafeForAnalytics(objectType),
        source: $d3caef8d053fb2a2$var$markSafeForAnalytics(objectType)
    });
};
const $d3caef8d053fb2a2$var$installHighPriorityApps = (args)=>{
    // @ts-expect-error - TS2304 - Cannot find name 'JiraContextContainer'.
    const priorityApps = [];
    if (args.flags) priorityApps.push((0, $2aRps.renderFlags)());
    if (args.navigation) priorityApps.push(args.renderNavigation());
    return priorityApps;
};
const $d3caef8d053fb2a2$var$installLowPriorityApps = (args)=>{
    if (args.upflow) $d3caef8d053fb2a2$var$loadUpFlowAPI();
    if (args.profileCardNextLegacy) $d3caef8d053fb2a2$var$renderProfileCardNextLegacy();
    if (args.connectModules) $d3caef8d053fb2a2$var$installConnectModules();
    if (args.engagementMessages) $d3caef8d053fb2a2$var$renderEngagementMessages();
    if (args.heartbeat) $d3caef8d053fb2a2$var$renderHeartbeat();
    if (args.searchDwellTimeComponent) $d3caef8d053fb2a2$var$renderSearchDwellTimeComponent();
};
const $d3caef8d053fb2a2$var$installAppsWithPriorityOrder = async (args)=>{
    await Promise.all($d3caef8d053fb2a2$var$installHighPriorityApps({
        flags: args.flags,
        navigation: args.navigation,
        renderNavigation: args.renderNavigation
    }));
    $d3caef8d053fb2a2$var$installLowPriorityApps((0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(args, [
        'flags',
        'navigation',
        'renderNavigation'
    ]));
};
const $d3caef8d053fb2a2$var$defaultArgs = {
    flags: true,
    navigation: true,
    upflow: true,
    profileCardNextLegacy: true,
    heartbeat: $d3caef8d053fb2a2$var$isHeartbeatEnabled(),
    connectModules: true,
    engagementMessages: true,
    searchDwellTimeComponent: true,
    renderNavigation: ()=>null
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d3caef8d053fb2a2$export$2e2bcd8739ae039 = {
    install: (args)=>{
        const argsWithDefaults = {
            ...$d3caef8d053fb2a2$var$defaultArgs,
            ...args
        };
        // @ts-expect-error - TS2345 - Argument of type '{ flags: boolean; navigation: boolean; renderNavigation: (() => any) | (() => null); upflow: boolean; heartbeat: boolean; profileCardNextLegacy: boolean; connectModules: boolean; originTracing?: boolean | undefined; engagementMessages: boolean; searchDwellTimeComponent: boolean; }' is not assignable to parameter of type 'GlobalArgs'.
        $d3caef8d053fb2a2$var$installAppsWithPriorityOrder(argsWithDefaults);
    },
    installHighPriorityApps: (args)=>{
        const { flags: flags, navigation: navigation, renderNavigation: renderNavigation } = {
            ...$d3caef8d053fb2a2$var$defaultArgs,
            ...args
        };
        $d3caef8d053fb2a2$var$installHighPriorityApps({
            flags: flags,
            navigation: navigation,
            renderNavigation: renderNavigation
        });
    },
    installLowPriorityApps: (args)=>{
        const installArgs = (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))({
            ...$d3caef8d053fb2a2$var$defaultArgs,
            ...args
        }, [
            'flags',
            'navigation',
            'renderNavigation'
        ]);
        $d3caef8d053fb2a2$var$installLowPriorityApps(installArgs);
    }
};

});
parcelRegister("2aRps", function(module, exports) {

$parcel$export(module.exports, "renderFlags", () => $6ef677b08ff57190$export$b6228dc14c5adf51);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $7rh0R = parcelRequire("7rh0R");

var $gUUjF = parcelRequire("gUUjF");

var $49235 = parcelRequire("49235");

var $5L0Jp = parcelRequire("5L0Jp");

var $geFaw = parcelRequire("geFaw");
const $6ef677b08ff57190$var$throwError = (message)=>{
    const error = new Error(message);
    (0, $gUUjF.default).safeErrorWithoutCustomerData('flags.entry', message, error);
    throw error;
};
const $6ef677b08ff57190$var$getContainer = ()=>{
    let container = document.getElementById('flags');
    if (container == null) {
        container = document.createElement('div');
        container.id = 'flags';
        if (document.body) document.body.appendChild(container);
        else $6ef677b08ff57190$var$throwError('document.body was not found whilst trying to create the flags container');
    }
    return container;
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $6ef677b08ff57190$var$Flags = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("3YCPN")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flag-app/src/main.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $6ef677b08ff57190$var$AfterPaintFlags = (0, $7rh0R.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("3YCPN")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flag-app/src/main.tsx"
});
const $6ef677b08ff57190$export$b6228dc14c5adf51 = ()=>(0, $lEfVV.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $geFaw.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $49235.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: "flags-entry"
    }, __SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ef677b08ff57190$var$AfterPaintFlags, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ef677b08ff57190$var$Flags, null)))), $6ef677b08ff57190$var$getContainer());

});
parcelRegister("49235", function(module, exports) {

$parcel$export(module.exports, "JiraContextContainer", () => $237d6228af360b7c$export$6f7845cc5e693f16);

var $eUqFw = parcelRequire("eUqFw");

var $3fQGY = parcelRequire("3fQGY");

var $ao0hp = parcelRequire("ao0hp");

var $fb5Sn = parcelRequire("fb5Sn");

var $eX2O4 = parcelRequire("eX2O4");

var $6rW04 = parcelRequire("6rW04");

var $7LFzI = parcelRequire("7LFzI");

var $jvfW6 = parcelRequire("jvfW6");

var $gXEQH = parcelRequire("gXEQH");

var $8WuJm = parcelRequire("8WuJm");

var $ln3W8 = parcelRequire("ln3W8");

var $jD3pk = parcelRequire("jD3pk");

var $gd0Sp = parcelRequire("gd0Sp");

var $4yYQo = parcelRequire("4yYQo");
const $237d6228af360b7c$var$ContextualAnalyticsDataFeatureFlagged = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: (0, $gXEQH.routeAnalyticsAttributes)
    }, children);

const $237d6228af360b7c$export$6f7845cc5e693f16 = (props)=>{
    const state = {
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        messages: (parcelRequire("7KGHt"))
    };
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($237d6228af360b7c$var$ContextualAnalyticsDataFeatureFlagged, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextContainer), {
        isGlobal: true,
        getMeta: (0, $6rW04.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7LFzI.IntlProvider), {
            messages: state.messages,
            locale: (0, $ao0hp.standardizeLocale)(tenantContext.locale)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3fQGY.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fb5Sn.default), {
            orgId: orgId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eX2O4.ExperienceTrackerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ln3W8.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jvfW6.ModalContextProvider), null, props.children)))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4yYQo.LoadingPhaseManager), null));
};

});
parcelRegister("4yYQo", function(module, exports) {

$parcel$export(module.exports, "LoadingPhaseManager", () => $01b326d4a0314926$export$6e4bfef9e80c7eb0);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");
const $01b326d4a0314926$export$6e4bfef9e80c7eb0 = ()=>{
    const { startNextPhase: startNextPhase } = (0, $7rh0R.useLazyPhase)();
    (0, $eUqFw.useEffect)(()=>{
        /**
     * Only start next phase if we are not in the SPA, because there is a second
     * LoadingPhaseManager specifically for the SPA, and we want it to transition at the correct time.
     * If we start this here inside the SPA, we will start RLL next phase and get lazyAfterPaint
     * bundles too early.
     */ if (__SPA__) return;
        /* Outside the SPA, we don't currently have a good proxy for page loads.
     * So for now we start the "after paint" phase a few seconds after mounting.
     */ setTimeout(()=>{
            performance.mark('rll-after-paint-phase');
            startNextPhase();
        }, 2000);
    }, [
        startNextPhase
    ]);
    return null;
};

});

parcelRegister("7KGHt", function(module, exports) {
module.exports = __LANG;

});


parcelRegister("5L0Jp", function(module, exports) {

$parcel$export(module.exports, "FlagsBoundary", () => $3e0b01ebb413784c$export$8b4a0fffcddd96f4);

var $eUqFw = parcelRequire("eUqFw");

var $5GxEP = parcelRequire("5GxEP");

var $gGtKh = parcelRequire("gGtKh");
const $3e0b01ebb413784c$export$8b4a0fffcddd96f4 = ({ children: children, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "flags",
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "flags-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, children));

});

parcelRegister("3YCPN", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('dsiAd'),
            load('3WeJg')
        ]);
        const value = parcelRequire('dKe2f');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("dsiAd"),
        load("3WeJg")
    ]).then(()=>parcelRequire('dKe2f'));
}

});


parcelRegister("1Fe9v", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab81d3bccac6ed19$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $geFaw = parcelRequire("geFaw");

var $7BDEW = parcelRequire("7BDEW");
const $ab81d3bccac6ed19$var$getPlaceholder = (placeholderId)=>{
    const existingPlaceholder = document.getElementById(placeholderId);
    if (existingPlaceholder) return existingPlaceholder;
    const div = document.createElement('div');
    div.id = placeholderId;
    if (document.body) document.body.appendChild(div);
    else throw new Error('document.body was not found whilst trying to create the dwell component placeholder.');
    return div;
};
const $ab81d3bccac6ed19$var$renderDwellTimeComponent = (placeholder, sessionId, data = {})=>{
    if (placeholder && sessionId) (0, $lEfVV.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $geFaw.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7BDEW.default), {
        sessionId: sessionId,
        data: data
    })), $ab81d3bccac6ed19$var$getPlaceholder(placeholder));
};
var $ab81d3bccac6ed19$export$2e2bcd8739ae039 = $ab81d3bccac6ed19$var$renderDwellTimeComponent;

});

parcelRegister("jO1SS", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('53zvZ')
        ]);
        const value = parcelRequire('jqtYH');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("53zvZ")
    ]).then(()=>parcelRequire('jqtYH'));
}

});

parcelRegister("a5kyI", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('dsiAd'),
            load('2hmUs'),
            load('bCeK4'),
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('fF7Ru')
        ]);
        const value = parcelRequire('9h92o');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("dsiAd"),
        load("2hmUs"),
        load("bCeK4"),
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("fF7Ru")
    ]).then(()=>parcelRequire('9h92o'));
}

});

parcelRegister("6RmPe", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('cBElD');
        const value = parcelRequire('bq09U');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("cBElD").then(()=>parcelRequire('bq09U'));
}

});

parcelRegister("hNcAl", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('iexSq'),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('ekVbM'),
            load('92sUi'),
            load('i5RRW'),
            load('561Jq'),
            load('1QYl5'),
            load('2Lfdl'),
            load('hPzOn'),
            load('dsiAd'),
            load('eNmuD'),
            load('8Ny04')
        ]);
        const value = parcelRequire('gibLG');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("iexSq"),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("ekVbM"),
        load("92sUi"),
        load("i5RRW"),
        load("561Jq"),
        load("1QYl5"),
        load("2Lfdl"),
        load("hPzOn"),
        load("dsiAd"),
        load("eNmuD"),
        load("8Ny04")
    ]).then(()=>parcelRequire('gibLG'));
}

});

parcelRegister("bkILS", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('ihXca')
        ]);
        const value = parcelRequire('cfAPv');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("ihXca")
    ]).then(()=>parcelRequire('cfAPv'));
}

});


$parcel$global.rwr("bz9bg", () => { parcelRequire("7QpAw");
parcelRequire("2EvGI");

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $kFGm5 = parcelRequire("kFGm5");

var $8dloj = parcelRequire("8dloj");

var $gpO36 = parcelRequire("gpO36");

var $7rh0R = parcelRequire("7rh0R");

var $acbV3 = parcelRequire("acbV3");

var $dfiLi = parcelRequire("dfiLi");

var $9lmTX = parcelRequire("9lmTX");

var $zcJ0y = parcelRequire("zcJ0y");

var $e91YZ = parcelRequire("e91YZ");

var $guiFP = parcelRequire("guiFP");


var $gXEQH = parcelRequire("gXEQH");
const $0507482b123635a1$export$649804097de83b3b = [
    // https://jplat.jira.atlassian.cloud/browse/MAGMA-2440
    {
        browser: 'Chrome',
        browserVersion: '116.0.0',
        errorMessage: /Cannot read properties of undefined \(reading 'target'\)/
    }
];
const $0507482b123635a1$var$checkBrowserCondition = (error, filterCriteria)=>filterCriteria.browser != null ? (0, $zcJ0y.getBrowser)().name === filterCriteria.browser : true;
const $0507482b123635a1$var$checkBrowserVersionCondition = (error, filterCriteria)=>filterCriteria.browserVersion != null ? (0, $zcJ0y.getBrowser)().version === filterCriteria.browserVersion : true;
const $0507482b123635a1$var$checkErrorMessageCondition = (error, filterCriteria)=>filterCriteria.errorMessage != null ? error.message.match(filterCriteria.errorMessage) : true;
const $0507482b123635a1$export$a66ce4bea8340820 = (error, errorFilteringCriterias)=>{
    try {
        // condition checkers must return true if they don't apply, so an empty filterCriteria will match (and block) ALL errors
        const conditionCheckers = [
            $0507482b123635a1$var$checkBrowserCondition,
            $0507482b123635a1$var$checkBrowserVersionCondition,
            $0507482b123635a1$var$checkErrorMessageCondition
        ];
        // Should send analytics if no filtering conditions are met
        return !errorFilteringCriterias.some((filterCriteria)=>conditionCheckers.every((conditionChecker)=>conditionChecker(error, filterCriteria)));
    } catch (e) {
        // If any error occurs during filtering, experience analytics should still be sent
        return true;
    }
};
const $0507482b123635a1$export$a5c16644a2d3c205 = async (error)=>{
    const tenantContextData = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    // We probably already have analytics initialised but we could have failed earlier than it
    (0, $dfiLi.default)(tenantContextData);
    // Experience analytics should only be sent if it is not filtered
    if ($0507482b123635a1$export$a66ce4bea8340820(error, $0507482b123635a1$export$649804097de83b3b)) (0, $9lmTX.default)({
        analyticsSource: (0, $7688150c048b38d1$export$c9e16a15d65437),
        experience: (0, $7688150c048b38d1$export$b1534bc11f201efd),
        wasExperienceSuccesful: false,
        location: (0, $7688150c048b38d1$export$7dfef0177e883b05),
        application: (0, $7688150c048b38d1$export$aa6008fe0169b864),
        edition: (0, $7688150c048b38d1$export$39418a21fbb51487),
        additionalAttributes: (0, $gXEQH.routeAnalyticsAttributes)
    });
    (0, $guiFP.default)({
        meta: {
            packageName: 'jiraBootstrapSlaReporter',
            id: 'bootstrap-failure',
            teamName: 'magma'
        },
        error: error,
        attributes: (0, $gXEQH.routeAnalyticsAttributes)
    });
    throw error;
};



var $a5pCl = parcelRequire("a5pCl");
const $d07297a4af13004b$export$ef94a84e2990361c = 'ISSUE_VIEW';
const $d07297a4af13004b$export$fc5f182fc9019b1c = 'CLASSIC_BOARD';
const $d07297a4af13004b$export$664edf77d4c76110 = 'COMPANY_MANAGED_BOARD';
const $d07297a4af13004b$export$f364828958cffad0 = 'TEAM_MANAGED_BOARD';
const $d07297a4af13004b$export$93104dc4eba58ba4 = 'CLASSIC_BACKLOG';
const $d07297a4af13004b$export$571692eec8a399e1 = 'COMPANY_MANAGED_BACKLOG';
const $d07297a4af13004b$export$c17f34c425972af1 = 'TEAM_MANAGED_BACKLOG';
const $d07297a4af13004b$export$6d592df97fba16ca = 'GIN_GLOBAL_ISSUE_NAVIGATOR';
const $d07297a4af13004b$export$d0ad1160bb95ce50 = 'NIN_NEW_ISSUE_NAVIGATOR';
const $d07297a4af13004b$export$4695c1a423ffe431 = 'DASHBOARD';
const $d07297a4af13004b$export$4ce203fc8c0eb2d1 = 'ISSUE_MOVE';
const $d07297a4af13004b$export$49d57bef9ac2550b = 'GLOBAL_ISSUE_CREATE';
const $d07297a4af13004b$export$9a80695e72849f84 = 'X-Atlassian-Capability';


var $gXgRp = parcelRequire("gXgRp");
parcelRequire("80E03");

var $6iz4v = parcelRequire("6iz4v");

var $e91YZ = parcelRequire("e91YZ");

var $8R80x = parcelRequire("8R80x");

var $0cdA8 = parcelRequire("0cdA8");

var $1ybV0 = parcelRequire("1ybV0");
var $XHGTv = parcelRequire("XHGTv");

var $eI5EY = parcelRequire("eI5EY");

var $1ybV0 = parcelRequire("1ybV0");
const $00f2fa4abeba3937$export$2d291317456ada16 = ()=>{
    if ((0, $1ybV0.ff)('fix_jira_ssr_platform_ff_oxim4')) (0, $XHGTv.setBooleanFeatureFlagResolver)((flagKey)=>(0, $eI5EY.fg)(flagKey) || (0, $1ybV0.ff)(flagKey));
};



var $6U1dF = parcelRequire("6U1dF");

var $eUqFw = parcelRequire("eUqFw");

var $h97Af = parcelRequire("h97Af");


var $2B87Z = parcelRequire("2B87Z");

var $ibSOG = parcelRequire("ibSOG");

var $eUqFw = parcelRequire("eUqFw");

var $cEX90 = parcelRequire("cEX90");
var $6WwlF = parcelRequire("6WwlF");

var $0cdA8 = parcelRequire("0cdA8");

var $1ybV0 = parcelRequire("1ybV0");

var $bAQOb = parcelRequire("bAQOb");

var $7Ps9l = parcelRequire("7Ps9l");

var $eUqFw = parcelRequire("eUqFw");

var $aYtGv = parcelRequire("aYtGv");
const $2fec3262065a5aa8$export$2fcd4100c556a49e = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("style", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `[data-ds--page-layout--slot="main"] { height: calc(100vh - ${(0, $aYtGv.PAGE_LAYOUT_OFFSET_TOP)}) }`
        }
    });



var $1GeZ8 = parcelRequire("1GeZ8");

var $inC6u = parcelRequire("inC6u");

var $eUqFw = parcelRequire("eUqFw");

var $5BRby = parcelRequire("5BRby");

var $h97Af = parcelRequire("h97Af");

var $2B87Z = parcelRequire("2B87Z");

var $eUqFw = parcelRequire("eUqFw");

var $Iptgu = parcelRequire("Iptgu");

var $1n0H8 = parcelRequire("1n0H8");

var $6iz4v = parcelRequire("6iz4v");

var $0cdA8 = parcelRequire("0cdA8");

var $1ybV0 = parcelRequire("1ybV0");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");

var $2B87Z = parcelRequire("2B87Z");

var $hTLlD = parcelRequire("hTLlD");

var $exb0h = parcelRequire("exb0h");

var $3oscM = parcelRequire("3oscM");
const $a8644990a56a3865$var$isReplaceActionAndPIN = (action, route)=>action === 'REPLACE' && route.group === (0, $exb0h.ROUTE_NAMES).PROJECT_ISSUE_NAVIGATOR;
const $a8644990a56a3865$export$ffb8c03de895ae3 = ()=>{
    let rapidBoardPaths = [];
    return ({ currentMatch: currentMatch, currentRoute: currentRoute, nextMatch: nextMatch, nextRoute: nextRoute, action: action })=>{
        let shouldReset = true;
        if ($a8644990a56a3865$var$isReplaceActionAndPIN(action, nextRoute) || currentRoute.isRedirect === true) shouldReset = false;
        else {
            const cleanMatch = (0, $3oscM.getApdexMatchObject)(currentMatch, currentRoute);
            const cleanNextMatch = (0, $3oscM.getApdexMatchObject)(nextMatch, nextRoute);
            shouldReset = !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(cleanMatch, cleanNextMatch) && shouldReset;
            if (shouldReset) {
                // RapidboardPaths is being persisted here.
                // resetDone boolean is calculated in the util function.
                const [paths, resetBoolean] = (0, $3oscM.calcRapidBoardResetStateV2)(rapidBoardPaths, nextRoute.name, !!nextMatch.query.useStoredSettings);
                rapidBoardPaths = paths;
                if ((0, $3oscM.isValidRoute)(nextRoute) || nextRoute.group === (0, $exb0h.ROUTE_GROUPS).CLASSIC_SOFTWARE) shouldReset = !resetBoolean;
            }
        }
        return shouldReset;
    };
};


var $lcJyp = parcelRequire("lcJyp");

var $idiDE = parcelRequire("idiDE");

var $eUqFw = parcelRequire("eUqFw");

var $gdW04 = parcelRequire("gdW04");
const $9aa509e99b18f723$export$f2b2f5ef0b498d26 = 5000;
const $9aa509e99b18f723$export$f2c0b74311ada874 = 3;
const $9aa509e99b18f723$export$af2ff676951003fe = 60000;
const $9aa509e99b18f723$export$388bd7a7ebb11e7 = 'atlassian-remote-actions-v1';


const $3afa8d6b9633d6ac$export$50dbcb44bba3aa5c = 60;
const $3afa8d6b9633d6ac$export$b21f5a6e7051e2c2 = (actionMetas)=>{
    const now = Date.now();
    const timeDiff = now - actionMetas.lastPerformAttemptedAt;
    return timeDiff > $3afa8d6b9633d6ac$export$50dbcb44bba3aa5c * 1000;
};
const $3afa8d6b9633d6ac$export$6c7cf2cb7d75fad3 = (actionMetas)=>actionMetas.attemptCounts < (0, $9aa509e99b18f723$export$f2c0b74311ada874);
const $3afa8d6b9633d6ac$export$6e0db227c9674096 = (action, metas)=>{
    const actionMetas = metas[action.id];
    if (!actionMetas) // No meta, we have not attempted to perform this action yet.
    return true;
    if (!$3afa8d6b9633d6ac$export$6c7cf2cb7d75fad3(actionMetas)) // TODO: send a "cancelled analytics event ?"
    return false;
    if (!$3afa8d6b9633d6ac$export$b21f5a6e7051e2c2(actionMetas)) return false;
    // All the conditions are satisfied, we can perform the action.
    return true;
};


const $f14ad3a187e7256b$export$1bfa74483a8ca772 = ({ actionName: actionName })=>{
    const metas = (0, $gdW04.useMeta)();
    const remoteActions = (0, $gdW04.useRemoteActionsData)();
    const { saveActionPerformedAttempt: saveActionPerformedAttempt } = (0, $gdW04.useRemoteActionsStoreActions)();
    const [actionToPerform, setActionToPerform] = (0, $eUqFw.useState)();
    const [shouldPerformAction, setShouldPerformAction] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        // Check whether or not the action (actionName) should be performed:
        // - when the remote actions available list changes
        // - when the metas for the actions change
        const matchedAction = Object.values(remoteActions).find((action)=>{
            if (action.name !== actionName) return false;
            return true;
        });
        if (!matchedAction) return;
        setActionToPerform(matchedAction);
        setShouldPerformAction((0, $3afa8d6b9633d6ac$export$6e0db227c9674096)(matchedAction, metas));
    }, [
        actionName,
        remoteActions,
        metas
    ]);
    const performAction = (onSuccess, onCancel)=>{
        if (!actionToPerform) // just in case someone calls the function and don't check if they should before
        // maybe throw an error?
        return;
        const metaForAnalytics = {
            attempts: metas[actionToPerform.id]?.attemptCounts ?? 0,
            lastAttemptedAt: metas[actionToPerform.id]?.lastPerformAttemptedAt
        };
        if (shouldPerformAction) // For now, the onSuccess will handle:
        // * create analytics event
        // * fire the event
        onSuccess(actionToPerform, metaForAnalytics);
        else // For now, the onCancel will handle:
        // * create analytics event
        // * fire the event
        onCancel(actionToPerform, metaForAnalytics);
        saveActionPerformedAttempt(actionToPerform.id);
        // We just attempted to perfom the action, reset.
        setShouldPerformAction(false);
    };
    return {
        shouldPerformAction: shouldPerformAction,
        performAction: performAction
    };
};



var $4nnPJ = parcelRequire("4nnPJ");
function $b54f7e90dd5ce65f$export$2e2bcd8739ae039(route) {
    if (route.ufoName != null) return route.ufoName;
    return route.name;
}



var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");

var $7sbhX = parcelRequire("7sbhX");
function $d0c86189ac2a9559$export$2e2bcd8739ae039(fromUfoName, nextUfoName, nextRouteName, time) {
    (0, $7sbhX.default).current = nextUfoName;
    const interactionId = (0, $gnIbC.DefaultInteractionID).current;
    if (interactionId) (0, $fVaJL.addRedirect)(interactionId, fromUfoName, nextUfoName, nextRouteName, time);
}



var $hTLlD = parcelRequire("hTLlD");

var $8q0kG = parcelRequire("8q0kG");
/**
 * Determines the feasibility of transitioning between routes in a SPA, considering initial loads,
 * user agent constraints, and predefined route conditions. Ensures seamless navigation by
 * evaluating route matches and permissions.
 */ const $036a05a78c408a0c$var$transitionValidator = (currentMatch, nextMatch)=>{
    // if we load SPA on a redirect route, we transition immediately skipping the checks
    if (!currentMatch) return true;
    // if next route missing (should not happen as we have a catch all route) or mobile, trigger reload
    if (!nextMatch || (0, $8q0kG.default)()) return false;
    // If we are still on same route and same match params, skip transition checks
    const isSameRoute = currentMatch.route === nextMatch.route;
    const isSameMatch = (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(currentMatch.match, nextMatch.match);
    if (isSameRoute && isSameMatch) return true;
    // check we can transition into next route
    // @ts-expect-error - TS2339 - Property 'canTransitionIn' does not exist on type 'Route'.
    const canDoNext = nextMatch.route.canTransitionIn?.(currentMatch, nextMatch) ?? true;
    if (canDoNext) return true;
    return false;
};
var $036a05a78c408a0c$export$2e2bcd8739ae039 = $036a05a78c408a0c$var$transitionValidator;



var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $gUUjF = parcelRequire("gUUjF");

var $1FAd1 = parcelRequire("1FAd1");


var $8R80x = parcelRequire("8R80x");

var $3dxBh = parcelRequire("3dxBh");

var $iJHZm = parcelRequire("iJHZm");
const $ee11b761aa04a6e7$var$LOCATION = 'route-entry-point-container';
const $ee11b761aa04a6e7$export$fb85bbdbfb3e6869 = ()=>null;
const $ee11b761aa04a6e7$export$3e4cdfb894377bc9 = ({ location: location, route: route, match: match, action: action, query: query })=>{
    const entryPoint = (0, $eUqFw.useMemo)(()=>route.entryPoint?.(), [
        route
    ]);
    const entryPointReference = (0, $1FAd1.usePageLayoutEntryPoint)((0, $d619e185f38e9ae8$export$900ddb492c628f48));
    // in order to show a spinner while page loading -> `route.skeleton=Spinner`
    const Skeleton = route.skeleton || $ee11b761aa04a6e7$export$fb85bbdbfb3e6869;
    (0, $eUqFw.useEffect)(()=>{
        if (route.isRedirect) (0, $gUUjF.default).safeWarnWithoutCustomerData($ee11b761aa04a6e7$var$LOCATION, `EntryPoint was used inside a redirect component: ${route.name}`);
    }, [
        route.isRedirect,
        route.name
    ]);
    if (!entryPointReference || !entryPoint) return null;
    let pageId = route.name;
    if (route.pageId) {
        if (typeof route.pageId === 'function') pageId = route.pageId({
            route: route,
            action: action,
            location: location,
            match: match,
            query: query
        });
        else pageId = route.pageId;
    }
    return route.isRedirect ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8R80x.EntryPointPlaceholder), {
        // @ts-expect-error - TS2339 - entryPoint does not exist on the Route type, this will be fixed later
        entryPoint: entryPoint,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Skeleton, null),
        name: "route_entry_point_redirect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iWLL0.EntryPointContainer), {
        entryPointReference: entryPointReference,
        props: {}
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dxBh.default), {
        pageId: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStateContainer), {
        isGlobal: true,
        appId: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStateAppStartWithMatchCheck), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8R80x.EntryPointPlaceholder), {
        // @ts-expect-error - TS2339 - entryPoint does not exist on the Route type, this will be fixed later
        entryPoint: entryPoint,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Skeleton, null),
        name: "route_entry_point"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iWLL0.EntryPointContainer), {
        entryPointReference: entryPointReference,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        props: {}
    }))));
};


const $5ce39a2e342c0202$var$getRemoteActionsRolloutStage = ()=>(0, $1ybV0.getMultivariateFeatureFlag)('jsw.roadmap.remote-actions-rollout', 'OFF', [
        'OFF',
        'MEASURE',
        'PERFORM'
    ]);
const $5ce39a2e342c0202$var$REMOTE_ACTIONS_OFF = 'OFF';
const $5ce39a2e342c0202$var$REMOTE_ACTIONS_PERFORM = 'PERFORM';
const $5ce39a2e342c0202$var$useRouterLocation = (0, $kJlBc.createRouterSelector)((state)=>state.location);
const $5ce39a2e342c0202$var$useRouterAction = (0, $kJlBc.createRouterSelector)((state)=>state.action);
const $5ce39a2e342c0202$var$useRouterQuery = (0, $kJlBc.createRouterSelector)((state)=>state.query);
const $5ce39a2e342c0202$var$useRouterRoute = (0, $kJlBc.createRouterSelector)((state)=>state.route);
const $5ce39a2e342c0202$var$useRouterMatch = (0, $kJlBc.createRouterSelector)((state)=>state.match);
let $5ce39a2e342c0202$var$hasPendingForceReloadAction = false;
const $5ce39a2e342c0202$export$88fe66870dd8f843 = (value)=>{
    $5ce39a2e342c0202$var$hasPendingForceReloadAction = value;
};
const $5ce39a2e342c0202$export$39e8f9fc07dd3395 = ()=>$5ce39a2e342c0202$var$hasPendingForceReloadAction;
const $5ce39a2e342c0202$var$fireRemoteActionAnalytics = (analyticsEvent, eventAction, remoteAction, currentRoute, targetRoute, attempts, lastAttemptedAt)=>(0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, `remoteAction ${eventAction}`, {
        source: 'transitionBlocker',
        actionId: remoteAction != null && remoteAction.id != null ? String(remoteAction.id) : '',
        frontendVersion: window.BUILD_KEY,
        currentRouteName: currentRoute?.route.name || '',
        targetRouteName: targetRoute?.route.name || '',
        remoteActionsRolloutStage: $5ce39a2e342c0202$var$getRemoteActionsRolloutStage(),
        attempts: attempts,
        lastAttemptedAt: lastAttemptedAt
    });
const $5ce39a2e342c0202$var$updateSentryBreadcrumb = (route, nextRoute)=>{
    const from = route.path + (route.query ? `?${route.query.join('&')}` : '');
    const to = nextRoute?.path + (nextRoute?.query ? `?${nextRoute.query.join('&')}` : '');
    $Iptgu.addBreadcrumb({
        type: 'navigation',
        data: {
            from: from,
            to: to
        }
    });
};
/**
 * Manages the routing, analytics, and remote actions within a single-page application (SPA).
 * This component sets up initial routes, enables analytics tracking, and handles SPA transitions.
 * It incorporates custom logic for page reloading or redirection under certain conditions
 * and ensures safe rendering of route components within an error boundary context.
 */ const $5ce39a2e342c0202$var$Spa = ({ routes: routes, initRoute: initRoute = null })=>{
    (0, $eUqFw.useMemo)(()=>{
        (0, $6iz4v.setMark)('jira-spa/view.start');
    }, []);
    const checkShouldResetPage = (0, $eUqFw.useMemo)(()=>(0, $a8644990a56a3865$export$ffb8c03de895ae3)(), []);
    const currentMatchObjectRef = (0, $eUqFw.useRef)(initRoute);
    (0, $eUqFw.useEffect)(()=>{
        (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/view', 'jira-spa/view.start', true);
    }, []);
    const { registerBlock: registerBlock } = (0, $kJlBc.useRouterActions)();
    const location = $5ce39a2e342c0202$var$useRouterLocation();
    const action = $5ce39a2e342c0202$var$useRouterAction();
    const query = $5ce39a2e342c0202$var$useRouterQuery();
    const route = $5ce39a2e342c0202$var$useRouterRoute();
    const match = $5ce39a2e342c0202$var$useRouterMatch();
    const { shouldPerformAction: shouldPerformAction, performAction: performAction } = $5ce39a2e342c0202$var$getRemoteActionsRolloutStage() !== $5ce39a2e342c0202$var$REMOTE_ACTIONS_OFF ? (0, $f14ad3a187e7256b$export$1bfa74483a8ca772)({
        actionName: 'forceReload'
    }) : {
        shouldPerformAction: false,
        performAction: ()=>({})
    };
    const { createAnalyticsEvent: createAnalyticsEvent } = $5ce39a2e342c0202$var$getRemoteActionsRolloutStage() !== $5ce39a2e342c0202$var$REMOTE_ACTIONS_OFF ? (0, $bFzGY.useAnalyticsEvents)() : {
        createAnalyticsEvent: null
    };
    /* We update currentMatch only if it's not a redirect. So in canTransitionIn we can compare
	 * actual routes instead of comparing against the redirect one */ if (route.isRedirect !== true) currentMatchObjectRef.current = {
        route: route,
        match: match
    };
    const [, { resetCurrentPage: resetCurrentPage }] = (0, $lcJyp.useSpaStateActions)();
    /* We regiser the blocker on every render to be sure that it gets added as first item
	 * even when the route changes (so it gets called last). It will be added only once anyway.
	 * This is our custom block() API that accepts promises.
	 * This code allows us to disable an SPA transition and trigger a full page reload
	 * in case the route we are moving out (or in) needs it. */ const transitionBlocker = (0, $eUqFw.useCallback)((nextLocation, nextAction)=>{
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'Query | undefined'.
        const nextMatch = (0, $kJlBc.matchRoute)(routes, nextLocation.pathname, nextLocation.search);
        const canDo = (0, $036a05a78c408a0c$export$2e2bcd8739ae039)(currentMatchObjectRef.current, nextMatch);
        if (!canDo) {
            const windowAction = nextAction === 'REPLACE' ? 'replace' : 'assign';
            window.location[windowAction]((0, $1n0H8.createPath)(nextLocation));
        }
        const remoteActionsRolloutStage = $5ce39a2e342c0202$var$getRemoteActionsRolloutStage();
        if (remoteActionsRolloutStage !== $5ce39a2e342c0202$var$REMOTE_ACTIONS_OFF && createAnalyticsEvent !== null) {
            const currentMatch = currentMatchObjectRef.current;
            if (canDo && currentMatch?.route.name !== nextMatch?.route.name && shouldPerformAction && $5ce39a2e342c0202$var$hasPendingForceReloadAction === false) {
                $5ce39a2e342c0202$var$hasPendingForceReloadAction = true;
                const windowAction = nextAction === 'REPLACE' ? 'replace' : 'assign';
                performAction((remoteAction, { attempts: attempts, lastAttemptedAt: lastAttemptedAt })=>{
                    $5ce39a2e342c0202$var$fireRemoteActionAnalytics(createAnalyticsEvent({}), 'performed', remoteAction, currentMatch, nextMatch, attempts, lastAttemptedAt);
                    if (remoteActionsRolloutStage === $5ce39a2e342c0202$var$REMOTE_ACTIONS_PERFORM) window.location[windowAction]((0, $1n0H8.createPath)(nextLocation));
                }, (remoteAction, { attempts: attempts, lastAttemptedAt: lastAttemptedAt })=>{
                    $5ce39a2e342c0202$var$fireRemoteActionAnalytics(createAnalyticsEvent({}), 'cancelled', remoteAction, currentMatch, nextMatch, attempts, lastAttemptedAt);
                });
            }
        }
        return canDo;
    }, [
        performAction,
        routes,
        shouldPerformAction,
        createAnalyticsEvent
    ]);
    const resetCurrentPageBeforeRouteChangeBlocker = (0, $eUqFw.useCallback)((nextLocation, nextAction)=>{
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'Query | undefined'.
        const nextMatchObject = (0, $kJlBc.matchRoute)(routes, nextLocation.pathname, nextLocation.search);
        if (nextMatchObject && match && route) {
            const { match: nextMatch, route: nextRoute } = nextMatchObject;
            const shouldReset = checkShouldResetPage({
                nextMatch: nextMatch,
                nextRoute: nextRoute,
                currentMatch: match,
                currentRoute: route,
                action: nextAction
            });
            const nextRouteUfoName = (0, $b54f7e90dd5ce65f$export$2e2bcd8739ae039)(nextRoute);
            if (shouldReset) {
                resetCurrentPage(nextRouteUfoName, nextRoute.name);
                (0, $4nnPJ.GlobalPageLoadExperience).setPageLoadId(nextRoute.perfMetricKey || 'UNKNOWN');
            }
            const isCurrentRouteRedirecting = route.isRedirect === true;
            if (isCurrentRouteRedirecting) {
                const currentRouteName = (0, $b54f7e90dd5ce65f$export$2e2bcd8739ae039)(route);
                (0, $d0c86189ac2a9559$export$2e2bcd8739ae039)(currentRouteName, nextRouteUfoName, nextRoute.name, performance.now());
            }
        }
        $5ce39a2e342c0202$var$updateSentryBreadcrumb(route, nextMatchObject?.route);
        return true;
    }, [
        checkShouldResetPage,
        match,
        resetCurrentPage,
        route,
        routes
    ]);
    registerBlock(transitionBlocker);
    registerBlock(resetCurrentPageBeforeRouteChangeBlocker);
    if (!(route && match)) return null;
    const { component: RouteComponent, meta: meta } = route;
    const entryPoint = route.entryPoint?.();
    const { reporting: reporting } = meta || {};
    /* Render a <Route> component instead of the page directly so the match prop can be
	 * propagated down to components wrapped with the withRouter HOC. Unfortunately, this
	 * means we forfeit the right to access query params via match is provided by <Route>
	 * rather than our custom matchRoute function. */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $idiDE.default), {
        name: "route-component"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        // explicitly coerce undefined to string to make flow happy
        id: `routeApp.${String(route.name)}`,
        packageName: "jiraSpa",
        extraEventData: {
            routeGroup: route.group ?? '',
            isSSR: false
        },
        fallback: "page",
        sendToPrivacyUnsafeSplunk: Boolean(reporting),
        ...reporting
    }, entryPoint ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ee11b761aa04a6e7$export$3e4cdfb894377bc9), {
        location: location,
        route: route,
        match: match,
        action: action,
        query: query
    }) : RouteComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(RouteComponent, {
        location: location,
        route: route,
        match: match,
        action: action,
        query: query
    })));
};
var $5ce39a2e342c0202$export$2e2bcd8739ae039 = $5ce39a2e342c0202$var$Spa;


const $08a5aa665e71bebd$var$onSpaShellReady = ()=>{
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa/spa-shell/core', '_jira-spa/spa-shell.start', 'JIRA_SPA_SHELL_READY');
};
const $08a5aa665e71bebd$var$Spa = ({ initRoute: initRoute = null, routes: routes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), {
        hasErrorBoundary: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: "JIRA_SPA_SHELL_READY",
        onSet: $08a5aa665e71bebd$var$onSpaShellReady
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ce39a2e342c0202$export$2e2bcd8739ae039), {
        initRoute: initRoute,
        routes: routes
    }));
var $08a5aa665e71bebd$export$2e2bcd8739ae039 = $08a5aa665e71bebd$var$Spa;



var $ghXjN = parcelRequire("ghXjN");
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $95616b66187196af$export$712225703044cda = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1bgi _2d3f16n6 _iu1g1fl4",
            __cmplp.className
        ])
    });
});


/* IMPORTANT:
 * When making any changes to the OLD component, please ensure that you also make the same changes to the
 * NEW component. The feature flag used is part of the Navigation Refresh work and we need to ensure that
 * we do not introduce tech debt for the roll-out by only updating the current component that is due to be
 * removed.
 *
 * If you have any concerns or questions please reach out to the #jira-navigation channel. Thanks!
 */ const $b1974ec03c2a5bd2$var$SPA_TRACE_KEY = 'spa';
const $b1974ec03c2a5bd2$var$NewContent = (props)=>{
    const { isSharedBusinessRoute: isSharedBusinessRoute, showProjectViewNavigation: showProjectViewNavigation } = (0, $6WwlF.useBusinessLookAndFeel)();
    const renderContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "mainContentSkipLink",
        packageName: "jiraPageContainer",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ghXjN.MainContentSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $inC6u.RenderTracerMark), {
        traceKey: $b1974ec03c2a5bd2$var$SPA_TRACE_KEY,
        type: "start"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $08a5aa665e71bebd$export$2e2bcd8739ae039), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $inC6u.RenderTracerMark), {
        traceKey: $b1974ec03c2a5bd2$var$SPA_TRACE_KEY,
        type: "end"
    }));
    if (showProjectViewNavigation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cEX90.ThemedContentLayout), {
        appearance: isSharedBusinessRoute ? 'inset' : 'default'
    }, renderContent);
    return renderContent;
};
const $b1974ec03c2a5bd2$var$OldContent = (props)=>{
    const { isSharedBusinessRoute: isSharedBusinessRoute, showProjectViewNavigation: showProjectViewNavigation } = (0, $6WwlF.useBusinessLookAndFeel)();
    const isJSMKnowledgeBaseRoute = (0, $7Ps9l.useIsKBRouteWithHorizontalNav)();
    const isHeightFixDisabled = (0, $1ybV0.ff)('jsm-kb-nav-refresh-changes-enabled') && isJSMKnowledgeBaseRoute;
    const renderContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, !isHeightFixDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2fec3262065a5aa8$export$2fcd4100c556a49e), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "mainContentSkipLink",
        packageName: "jiraPageContainer",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ghXjN.MainContentSkipLink), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1GeZ8.Main), {
        id: "ak-main-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $inC6u.RenderTracerMark), {
        traceKey: $b1974ec03c2a5bd2$var$SPA_TRACE_KEY,
        type: "start"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $08a5aa665e71bebd$export$2e2bcd8739ae039), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $inC6u.RenderTracerMark), {
        traceKey: $b1974ec03c2a5bd2$var$SPA_TRACE_KEY,
        type: "end"
    })));
    if (showProjectViewNavigation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cEX90.BusinessWrapper), {
        withWhiteBackground: isSharedBusinessRoute
    }, renderContent);
    return (0, $1ybV0.ff)('iph.enabled') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $95616b66187196af$export$712225703044cda), null, renderContent) : renderContent;
};
const $b1974ec03c2a5bd2$export$7c6e2c02157bb7d2 = (0, $bAQOb.componentWithFF)('platform.atlassian.griffin-new-page-layout', $b1974ec03c2a5bd2$var$NewContent, $b1974ec03c2a5bd2$var$OldContent);


const $37f6df81ea368cad$export$6d4069f4b64f7492 = ({ baseUrl: baseUrl, locale: locale, messages: messages, isPrewarming: isPrewarming = false, Router: Router, routes: routes, routerLinkComponent: routerLinkComponent, initRoute: initRoute })=>{
    const pageContainerPerformanceTiming = (0, $eUqFw.useCallback)(()=>{
        (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)((0, $7688150c048b38d1$export$21473105c510aacc), (0, $7688150c048b38d1$export$59f83d43fe209319), (0, $7688150c048b38d1$export$7114284ca03133ee), true, true);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ibSOG.PageContainer), {
        baseUrl: baseUrl,
        id: false ? 'jira.entry.ssr' : 'spa',
        locale: locale,
        messages: messages,
        Router: Router,
        routerLinkComponent: routerLinkComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: (0, $7688150c048b38d1$export$7114284ca03133ee),
        onSet: pageContainerPerformanceTiming
    }), isPrewarming !== true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b1974ec03c2a5bd2$export$7c6e2c02157bb7d2), {
        initRoute: initRoute,
        routes: routes
    }));
};



var $keguF = parcelRequire("keguF");
var $10fdS = parcelRequire("10fdS");
try {
    self["workbox:window:6.1.5"] && _();
} catch (n) {}
function $fc8a438e1c855511$export$3a89f7c6642e8f16(n, t) {
    return new Promise(function(r) {
        var e = new MessageChannel;
        e.port1.onmessage = function(n) {
            r(n.data);
        }, n.postMessage(t, [
            e.port2
        ]);
    });
}
function $fc8a438e1c855511$var$t(n, t) {
    for(var r = 0; r < t.length; r++){
        var e = t[r];
        e.enumerable = e.enumerable || !1, e.configurable = !0, "value" in e && (e.writable = !0), Object.defineProperty(n, e.key, e);
    }
}
function $fc8a438e1c855511$var$r(n, t) {
    (null == t || t > n.length) && (t = n.length);
    for(var r = 0, e = new Array(t); r < t; r++)e[r] = n[r];
    return e;
}
function $fc8a438e1c855511$var$e(n, t) {
    var e;
    if ("undefined" == typeof Symbol || null == n[Symbol.iterator]) {
        if (Array.isArray(n) || (e = function(n, t) {
            if (n) {
                if ("string" == typeof n) return $fc8a438e1c855511$var$r(n, t);
                var e = Object.prototype.toString.call(n).slice(8, -1);
                return "Object" === e && n.constructor && (e = n.constructor.name), "Map" === e || "Set" === e ? Array.from(n) : "Arguments" === e || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e) ? $fc8a438e1c855511$var$r(n, t) : void 0;
            }
        }(n)) || t && n && "number" == typeof n.length) {
            e && (n = e);
            var i = 0;
            return function() {
                return i >= n.length ? {
                    done: !0
                } : {
                    done: !1,
                    value: n[i++]
                };
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    return (e = n[Symbol.iterator]()).next.bind(e);
}
try {
    self["workbox:core:6.1.5"] && _();
} catch (n) {}
var $fc8a438e1c855511$var$i = function() {
    var n = this;
    this.promise = new Promise(function(t, r) {
        n.resolve = t, n.reject = r;
    });
};
function $fc8a438e1c855511$var$o(n, t) {
    var r = location.href;
    return new URL(n, r).href === new URL(t, r).href;
}
var $fc8a438e1c855511$var$u = function(n, t) {
    this.type = n, Object.assign(this, t);
};
function $fc8a438e1c855511$var$a(n, t, r) {
    return r ? t ? t(n) : n : (n && n.then || (n = Promise.resolve(n)), t ? n.then(t) : n);
}
function $fc8a438e1c855511$var$c() {}
var $fc8a438e1c855511$var$f = {
    type: "SKIP_WAITING"
};
function $fc8a438e1c855511$var$s(n, t) {
    if (!t) return n && n.then ? n.then($fc8a438e1c855511$var$c) : Promise.resolve();
}
var $fc8a438e1c855511$export$7e2ffb4f33d5ddf0 = function(r) {
    var e, c;
    function v(n, t) {
        var e, c;
        return void 0 === t && (t = {}), (e = r.call(this) || this).nn = {}, e.tn = 0, e.rn = new $fc8a438e1c855511$var$i, e.en = new $fc8a438e1c855511$var$i, e.on = new $fc8a438e1c855511$var$i, e.un = 0, e.an = new Set, e.cn = function() {
            var n = e.fn, t = n.installing;
            e.tn > 0 || !$fc8a438e1c855511$var$o(t.scriptURL, e.sn) || performance.now() > e.un + 6e4 ? (e.vn = t, n.removeEventListener("updatefound", e.cn)) : (e.hn = t, e.an.add(t), e.rn.resolve(t)), ++e.tn, t.addEventListener("statechange", e.ln);
        }, e.ln = function(n) {
            var t = e.fn, r = n.target, i = r.state, o = r === e.vn, a = {
                sw: r,
                isExternal: o,
                originalEvent: n
            };
            !o && e.mn && (a.isUpdate = !0), e.dispatchEvent(new $fc8a438e1c855511$var$u(i, a)), "installed" === i ? e.wn = self.setTimeout(function() {
                "installed" === i && t.waiting === r && e.dispatchEvent(new $fc8a438e1c855511$var$u("waiting", a));
            }, 200) : "activating" === i && (clearTimeout(e.wn), o || e.en.resolve(r));
        }, e.dn = function(n) {
            var t = e.hn, r = t !== navigator.serviceWorker.controller;
            e.dispatchEvent(new $fc8a438e1c855511$var$u("controlling", {
                isExternal: r,
                originalEvent: n,
                sw: t,
                isUpdate: e.mn
            })), r || e.on.resolve(t);
        }, e.gn = (c = function(n) {
            var t = n.data, r = n.source;
            return $fc8a438e1c855511$var$a(e.getSW(), function() {
                e.an.has(r) && e.dispatchEvent(new $fc8a438e1c855511$var$u("message", {
                    data: t,
                    sw: r,
                    originalEvent: n
                }));
            });
        }, function() {
            for(var n = [], t = 0; t < arguments.length; t++)n[t] = arguments[t];
            try {
                return Promise.resolve(c.apply(this, n));
            } catch (n) {
                return Promise.reject(n);
            }
        }), e.sn = n, e.nn = t, navigator.serviceWorker.addEventListener("message", e.gn), e;
    }
    c = r, (e = v).prototype = Object.create(c.prototype), e.prototype.constructor = e, e.__proto__ = c;
    var h, l, m, w = v.prototype;
    return w.register = function(n) {
        var t = (void 0 === n ? {} : n).immediate, r = void 0 !== t && t;
        try {
            var e = this;
            return function(n, t) {
                var r = n();
                if (r && r.then) return r.then(t);
                return t(r);
            }(function() {
                if (!r && "complete" !== document.readyState) return $fc8a438e1c855511$var$s(new Promise(function(n) {
                    return window.addEventListener("load", n);
                }));
            }, function() {
                return e.mn = Boolean(navigator.serviceWorker.controller), e.yn = e.pn(), $fc8a438e1c855511$var$a(e.bn(), function(n) {
                    e.fn = n, e.yn && (e.hn = e.yn, e.en.resolve(e.yn), e.on.resolve(e.yn), e.yn.addEventListener("statechange", e.ln, {
                        once: !0
                    }));
                    var t = e.fn.waiting;
                    return t && $fc8a438e1c855511$var$o(t.scriptURL, e.sn) && (e.hn = t, Promise.resolve().then(function() {
                        e.dispatchEvent(new $fc8a438e1c855511$var$u("waiting", {
                            sw: t,
                            wasWaitingBeforeRegister: !0
                        }));
                    }).then(function() {})), e.hn && (e.rn.resolve(e.hn), e.an.add(e.hn)), e.fn.addEventListener("updatefound", e.cn), navigator.serviceWorker.addEventListener("controllerchange", e.dn, {
                        once: !0
                    }), e.fn;
                });
            });
        } catch (n) {
            return Promise.reject(n);
        }
    }, w.update = function() {
        try {
            return this.fn ? $fc8a438e1c855511$var$s(this.fn.update()) : void 0;
        } catch (n) {
            return Promise.reject(n);
        }
    }, w.getSW = function() {
        return void 0 !== this.hn ? Promise.resolve(this.hn) : this.rn.promise;
    }, w.messageSW = function(t) {
        try {
            return $fc8a438e1c855511$var$a(this.getSW(), function(r) {
                return $fc8a438e1c855511$export$3a89f7c6642e8f16(r, t);
            });
        } catch (n) {
            return Promise.reject(n);
        }
    }, w.messageSkipWaiting = function() {
        this.fn && this.fn.waiting && $fc8a438e1c855511$export$3a89f7c6642e8f16(this.fn.waiting, $fc8a438e1c855511$var$f);
    }, w.pn = function() {
        var n = navigator.serviceWorker.controller;
        return n && $fc8a438e1c855511$var$o(n.scriptURL, this.sn) ? n : void 0;
    }, w.bn = function() {
        try {
            var n = this;
            return function(n, t) {
                try {
                    var r = n();
                } catch (n) {
                    return t(n);
                }
                if (r && r.then) return r.then(void 0, t);
                return r;
            }(function() {
                return $fc8a438e1c855511$var$a(navigator.serviceWorker.register(n.sn, n.nn), function(t) {
                    return n.un = performance.now(), t;
                });
            }, function(n) {
                throw n;
            });
        } catch (n) {
            return Promise.reject(n);
        }
    }, h = v, l = [
        {
            key: "active",
            get: function() {
                return this.en.promise;
            }
        },
        {
            key: "controlling",
            get: function() {
                return this.on.promise;
            }
        }
    ], $fc8a438e1c855511$var$t(h.prototype, l), m && $fc8a438e1c855511$var$t(h, m), v;
}(function() {
    function n() {
        this.Pn = new Map;
    }
    var t = n.prototype;
    return t.addEventListener = function(n, t) {
        this.Sn(n).add(t);
    }, t.removeEventListener = function(n, t) {
        this.Sn(n).delete(t);
    }, t.dispatchEvent = function(n) {
        n.target = this;
        for(var t, r = $fc8a438e1c855511$var$e(this.Sn(n.type)); !(t = r()).done;)(0, t.value)(n);
    }, t.Sn = function(n) {
        return this.Pn.has(n) || this.Pn.set(n, new Set), this.Pn.get(n);
    }, n;
}());



var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");
/**
 * Location added to logs
 */ const $e22dc2ccddf1fa90$export$7ec1427613e4cea = 'jira.platform.serviceworker.window';
const $e22dc2ccddf1fa90$export$a4560f8311abd25c = '/rest/greenhopper/1.0/frontend/service-worker.js';
const $e22dc2ccddf1fa90$export$5f5d64d0b634b7ff = '/jira/software/projects/';


// @ts-expect-error - TS2305 - Module '"workbox-window"' has no exported member 'WorkboxEvent'.


var $gUUjF = parcelRequire("gUUjF");


var $3FyZ4 = parcelRequire("3FyZ4");
const $90eddb7d7feaeedc$export$3f9c0360a271b1b1 = async ()=>{
    const analyticsWebClient = await (0, $3FyZ4.getAnalyticsWebClientPromise)();
    return analyticsWebClient.getInstance();
};



var $aZaPn = parcelRequire("aZaPn");
const $bbc94ff5229258bc$var$storage = (0, $aZaPn.createLocalStorageProvider)('jira-platform-service-worker-window');
const $bbc94ff5229258bc$export$fbd9b57a66480737 = ()=>$bbc94ff5229258bc$var$storage;
const $bbc94ff5229258bc$export$a86190deb5c4a8d0 = ()=>new Date().getTime();


const $885eed1c002f5394$export$26fba1a1e74c40e8 = 'service-worker-registration-requests';
/**
 * Get this tab's BUILD_KEY
 */ const $885eed1c002f5394$var$getBuildKey = ()=>typeof window !== 'undefined' ? window.BUILD_KEY : 'UNKNOWN';
/**
 * Send a SERVICE_WORKER_INFO message to a worker and return a promise to its response.
 */ const $885eed1c002f5394$var$getServiceWorkerInfo = (currentWorker)=>(0, $fc8a438e1c855511$export$3a89f7c6642e8f16)(currentWorker, {
        type: 'SERVICE_WORKER_INFO'
    });
/**
 * Send a message into a worker to get its version and type.
 */ const $885eed1c002f5394$var$getWorkerInfo = async (currentWorker)=>{
    const start = performance.now();
    const response = await $885eed1c002f5394$var$getServiceWorkerInfo(currentWorker);
    const latency = performance.now() - start;
    return {
        version: response.version,
        workerType: response.serviceWorker,
        latency: latency,
        numberOfControlledClients: response.numberOfControlledClients,
        numberOfClients: response.numberOfClients,
        hasMultipleTabs: response.hasMultipleTabs
    };
};
const $885eed1c002f5394$export$99d02f605be190b4 = async (worker)=>{
    const now = performance.now();
    const controller = navigator.serviceWorker?.controller;
    const hasController = controller != null;
    const isController = worker === controller;
    const hasWorker = worker != null;
    const pageVersion = $885eed1c002f5394$var$getBuildKey();
    const controllerInfo = controller != null ? await $885eed1c002f5394$var$getWorkerInfo(controller) : null;
    const workerInfo = worker != null ? await $885eed1c002f5394$var$getWorkerInfo(worker) : null;
    return {
        now: now,
        pageVersion: pageVersion,
        hasController: hasController,
        isController: isController,
        hasWorker: hasWorker,
        controllerInfo: controllerInfo,
        workerInfo: workerInfo
    };
};
const $885eed1c002f5394$export$115ae4546a14d782 = ()=>{
    try {
        const storage = (0, $bbc94ff5229258bc$export$fbd9b57a66480737)();
        const item = storage.get($885eed1c002f5394$export$26fba1a1e74c40e8);
        const currentTime = (0, $bbc94ff5229258bc$export$a86190deb5c4a8d0)();
        const registrationData = item ?? {
            createdAt: currentTime,
            updatedAt: null,
            registrations: {
                previous: null,
                current: null
            }
        };
        registrationData.updatedAt = (0, $bbc94ff5229258bc$export$a86190deb5c4a8d0)();
        registrationData.registrations.previous = registrationData.registrations.current;
        registrationData.registrations.current = {
            time: currentTime,
            version: $885eed1c002f5394$var$getBuildKey()
        };
        storage.set($885eed1c002f5394$export$26fba1a1e74c40e8, registrationData);
        return registrationData;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData((0, $e22dc2ccddf1fa90$export$7ec1427613e4cea), err);
        return null;
    }
};
const $885eed1c002f5394$export$dfe3b5ada8f424bd = async (startTime, isInScope)=>{
    const query = await $885eed1c002f5394$export$99d02f605be190b4(navigator.serviceWorker?.controller ?? null);
    const client = await (0, $90eddb7d7feaeedc$export$3f9c0360a271b1b1)();
    const registrationData = $885eed1c002f5394$export$115ae4546a14d782();
    client.sendOperationalEvent({
        action: 'entered',
        actionSubject: 'serviceWorker',
        source: (0, $e22dc2ccddf1fa90$export$7ec1427613e4cea),
        attributes: {
            startTime: startTime,
            isInScope: isInScope,
            ...query,
            registrationData: registrationData ? {
                previous: registrationData.registrations.previous
            } : null
        }
    });
};
const $885eed1c002f5394$export$790afa7fb21c0789 = (event, startTime)=>{
    const run = async ()=>{
        if (event.type === 'message') return;
        const query = await $885eed1c002f5394$export$99d02f605be190b4(event.sw);
        const client = await (0, $90eddb7d7feaeedc$export$3f9c0360a271b1b1)();
        const analyticsEvent = {
            action: event.type,
            actionSubject: 'serviceWorker',
            source: (0, $e22dc2ccddf1fa90$export$7ec1427613e4cea),
            attributes: {
                startTime: startTime,
                ...query,
                isUpdate: event.isUpdate != null ? event.isUpdate : null,
                isExternal: event.isExternal != null ? event.isExternal : null,
                wasWaitingBeforeRegister: event.wasWaitingBeforeRegister != null ? event.wasWaitingBeforeRegister : null,
                registrationData: null
            }
        };
        client.sendOperationalEvent(analyticsEvent);
    };
    return run().catch((err)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData((0, $e22dc2ccddf1fa90$export$7ec1427613e4cea), 'Failed to fire ServiceWorker lifecycle analytics', err);
    });
};
const $885eed1c002f5394$export$6c98efc640fc1a05 = (workbox, startTime)=>{
    workbox.addEventListener('activated', (event)=>{
        $885eed1c002f5394$export$790afa7fb21c0789(event, startTime);
    });
    workbox.addEventListener('waiting', (event)=>{
        $885eed1c002f5394$export$790afa7fb21c0789(event, startTime);
    });
    workbox.addEventListener('installed', (event)=>{
        $885eed1c002f5394$export$790afa7fb21c0789(event, startTime);
    });
    workbox.addEventListener('controlling', (event)=>{
        $885eed1c002f5394$export$790afa7fb21c0789(event, startTime);
    });
    workbox.addEventListener('redundant', (event)=>{
        $885eed1c002f5394$export$790afa7fb21c0789(event, startTime);
    });
};



var $gUUjF = parcelRequire("gUUjF");

const $c8a575299f3c83ff$export$d420eb1fe8655863 = async ()=>{
    try {
        const serviceWorkerContainer = typeof navigator !== 'undefined' && navigator.serviceWorker ? navigator.serviceWorker : null;
        if (!serviceWorkerContainer || false) return;
        const registrations = await serviceWorkerContainer.getRegistrations();
        const softwareServiceWorkers = Array.from(registrations).filter((registration)=>registration.scope.endsWith((0, $e22dc2ccddf1fa90$export$5f5d64d0b634b7ff)));
        const results = softwareServiceWorkers.map((registration)=>registration.unregister());
        const successCount = (await Promise.all(results)).filter((unregisterSuccessful)=>unregisterSuccessful).length;
        if (successCount !== softwareServiceWorkers.length) (0, $gUUjF.default).safeWarnWithoutCustomerData((0, $e22dc2ccddf1fa90$export$7ec1427613e4cea), `ServiceWorker unregister cleared ${successCount} of ${softwareServiceWorkers.length} registrations`);
        else if (successCount > 0) (0, $gUUjF.default).safeInfoWithoutCustomerData((0, $e22dc2ccddf1fa90$export$7ec1427613e4cea), 'ServiceWorker unregistered successfully');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData((0, $e22dc2ccddf1fa90$export$7ec1427613e4cea), 'ServiceWorker unregister error', err);
    }
};


const $c6cfe50664bfd937$export$b829272b1dcc6798 = ()=>document.location.pathname;


let $3e9543de6b0f3240$var$serviceWorker = null;
const $3e9543de6b0f3240$export$5c10cbeef76d9c2c = ()=>$3e9543de6b0f3240$var$serviceWorker;
const $3e9543de6b0f3240$export$ebe5d78a82459178 = async ()=>{
    const isInScope = (0, $c6cfe50664bfd937$export$b829272b1dcc6798)().startsWith((0, $e22dc2ccddf1fa90$export$5f5d64d0b634b7ff));
    const startTime = performance.now();
    await (0, $885eed1c002f5394$export$dfe3b5ada8f424bd)(startTime, isInScope);
    if (!isInScope) return;
    const workbox = new (0, $fc8a438e1c855511$export$7e2ffb4f33d5ddf0)((0, $e22dc2ccddf1fa90$export$a4560f8311abd25c), {
        scope: (0, $e22dc2ccddf1fa90$export$5f5d64d0b634b7ff)
    });
    (0, $885eed1c002f5394$export$6c98efc640fc1a05)(workbox, startTime);
    $3e9543de6b0f3240$var$serviceWorker = workbox;
    await workbox.register({
        immediate: true
    });
};
const $3e9543de6b0f3240$var$startServiceWorker = ()=>{
    try {
        if (typeof navigator !== 'undefined' && !false && 'serviceWorker' in navigator && (0, $1ybV0.ff)('jsw.perf.install-jira-service-worker')) {
            $3e9543de6b0f3240$export$ebe5d78a82459178().catch((err)=>{
                (0, $gUUjF.default).safeErrorWithoutCustomerData((0, $e22dc2ccddf1fa90$export$7ec1427613e4cea), err);
            });
            return;
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData((0, $e22dc2ccddf1fa90$export$7ec1427613e4cea), err);
    }
    (0, $c8a575299f3c83ff$export$d420eb1fe8655863)();
};
var $3e9543de6b0f3240$export$2e2bcd8739ae039 = $3e9543de6b0f3240$var$startServiceWorker;



var $geFaw = parcelRequire("geFaw");

var $kJlBc = parcelRequire("kJlBc");
var $e9XeX = parcelRequire("e9XeX");
var $MIkHq = parcelRequire("MIkHq");

var $cernH = parcelRequire("cernH");

var $1ybV0 = parcelRequire("1ybV0");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $exb0h = parcelRequire("exb0h");
const $f0262204957799b7$export$12b9979f5c1ed5a4 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_MIGRATIONS_HOME,
    path: '/jira/settings/system/migration/home'
};
const $f0262204957799b7$export$b48d38ab4363f197 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_MIGRATIONS_DASHBOARD,
    path: '/jira/settings/system/migration/dashboard'
};
const $f0262204957799b7$export$50ae42a441766ba5 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_MIGRATIONS_FOCUS_PAGE,
    path: '/jira/settings/system/migration/:step(how-it-works|plan-configuration|choose-projects|choose-group-membership|select-customer|check-for-errors|review|view-details)/:migrationId?'
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $6852d43bda4b6a44$export$422086745f2d10c4 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("l8Yj1"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/migrations/migrations-dashboard/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6852d43bda4b6a44$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $6852d43bda4b6a44$export$422086745f2d10c4,
        pageId: "system-c2c-migrations-dashboard",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $f2e7b5aca30ed911$export$e0c09a0ffb780ae2 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("41B23"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/migrations/migrations-focus-page/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f2e7b5aca30ed911$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $f2e7b5aca30ed911$export$e0c09a0ffb780ae2,
        pageId: "system-c2c-migrations-focus-page",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $e8ff9e4cef16c1d5$export$b78d99112db11162 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("5tL16"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/migrations/migrations-home/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e8ff9e4cef16c1d5$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e8ff9e4cef16c1d5$export$b78d99112db11162,
        pageId: "system-migrations-home",
        shouldShowSpinner: true
    });


const $799769b2797678db$export$debd9f352e8a3e70 = [
    (0, $apqRF.createEntry)((0, $f0262204957799b7$export$12b9979f5c1ed5a4), {
        ufoName: 'admin.c2c-migrations.home',
        canTransitionIn: ()=>(0, $1ybV0.ff)('jira-system-settings-cloud-to-cloud-migration'),
        component: (0, $e8ff9e4cef16c1d5$export$2e2bcd8739ae039),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $bt7QT.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $e8ff9e4cef16c1d5$export$b78d99112db11162)
        ]
    }),
    (0, $apqRF.createEntry)((0, $f0262204957799b7$export$b48d38ab4363f197), {
        ufoName: 'admin.c2c-migrations.dashboard',
        canTransitionIn: ()=>(0, $1ybV0.ff)('jira-system-settings-cloud-to-cloud-migration'),
        component: (0, $6852d43bda4b6a44$export$2e2bcd8739ae039),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $bt7QT.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $6852d43bda4b6a44$export$422086745f2d10c4)
        ]
    }),
    (0, $apqRF.createEntry)((0, $f0262204957799b7$export$50ae42a441766ba5), {
        canTransitionIn: ()=>(0, $1ybV0.ff)('jira-system-settings-cloud-to-cloud-migration'),
        component: (0, $f2e7b5aca30ed911$export$2e2bcd8739ae039),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $bt7QT.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $f2e7b5aca30ed911$export$e0c09a0ffb780ae2)
        ]
    })
];



var $eUqFw = parcelRequire("eUqFw");

var $cernH = parcelRequire("cernH");

var $1ybV0 = parcelRequire("1ybV0");

var $dVvIP = parcelRequire("dVvIP");

var $kLSws = parcelRequire("kLSws");

var $7vTKl = parcelRequire("7vTKl");

var $29Nmz = parcelRequire("29Nmz");

var $7rh0R = parcelRequire("7rh0R");

var $isbb2 = parcelRequire("isbb2");

const $81a924b88389d294$export$b6292b5f7e5b5fad = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("5irXx")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/jira-plan-layout/src/ui/resources-invalidate/index.tsx"
});
const $81a924b88389d294$export$94e1d79bf65579e2 = (0, $isbb2.createLayout)({
    globalComponents: [
        $81a924b88389d294$export$b6292b5f7e5b5fad
    ]
});



var $isbb2 = parcelRequire("isbb2");

var $apqRF = parcelRequire("apqRF");

var $drCAA = parcelRequire("drCAA");
parcelRequire("gkTS0");
var $2nflD = parcelRequire("2nflD");

var $hHrVM = parcelRequire("hHrVM");

var $jwzNs = parcelRequire("jwzNs");

var $exb0h = parcelRequire("exb0h");

var $exb0h = parcelRequire("exb0h");
const $52eda9e1a201d846$export$d0986e4bd9568b30 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_PLAN_INCREMENTS,
    path: '/jira/plans/:planId/scenarios/:scenarioId/program'
};
const $52eda9e1a201d846$export$ef33a75556fde209 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_PLAN_INCREMENT,
    path: '/jira/plans/:planId/scenarios/:scenarioId/program/:incrementId'
};
const $52eda9e1a201d846$export$29647353386ad146 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).ARCHIVED_PLANS_DIRECTORY,
    path: '/jira/plans/settings/archive'
};
const $52eda9e1a201d846$export$b1d2299a57fca83a = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).TRASH_PLANS_DIRECTORY,
    path: '/jira/plans/settings/trash'
};
const $52eda9e1a201d846$export$1a9edb72cd49ca79 = {
    group: (0, $exb0h.ROUTE_GROUPS).ERRORS,
    name: (0, $exb0h.ROUTE_NAMES).TRASHED_PLAN_DIRECT_LINK,
    path: '/jira/plans/plan-trashed',
    exact: true
};
const $52eda9e1a201d846$export$7208300f00a36a5f = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_ARJ_SETTINGS_FINANCIAL_YEAR,
    path: '/jira/plans/settings/financial-year'
};



var $exb0h = parcelRequire("exb0h");
const $f4d7ea4ec84815d2$export$e657c8aeaaf0932c = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_ARJ_SETTINGS_DEPENDENCIES,
    path: '/jira/plans/settings/dependencies'
};
const $f4d7ea4ec84815d2$export$b55de156ac5f7c1b = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_ARJ_SETTINGS_DEPENDENCIES_REDIRECT,
    path: '/secure/PortfolioDependencySettings.jspa'
};
const $f4d7ea4ec84815d2$export$21eaa019c724fc9a = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_ARJ_SETTINGS_LOADING_LIMITS,
    path: '/jira/plans/settings/loading-limits'
};
const $f4d7ea4ec84815d2$export$c72a1b9971af07d9 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_ARJ_SETTINGS_LOADING_LIMITS_REDIRECT,
    path: '/secure/PortfolioLoadingLimits.jspa'
};
const $f4d7ea4ec84815d2$export$6372897c47d731c0 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_ARJ_SETTINGS_PERMISSIONS,
    path: '/jira/plans/settings/permissions'
};
const $f4d7ea4ec84815d2$export$4523847db2f1a42e = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_ARJ_SETTINGS_PERMISSIONS_REDIRECT,
    path: '/secure/PortfolioPermissions.jspa'
};


const $d88229dbc347aa09$export$21d57208bfbf7e92 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_ADVANCED_ROADMAPS,
    path: '/jira/plans/:planId/scenarios/:scenarioId'
};
const $d88229dbc347aa09$export$ad8296aa5394f696 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_PLAN_DEPENDENCIES,
    path: '/jira/plans/:planId/scenarios/:scenarioId/dependencies'
};
const $d88229dbc347aa09$export$25a8cf27557a612d = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_PLAN_SUMMARY,
    path: '/jira/plans/:planId/scenarios/:scenarioId/summary'
};
const $d88229dbc347aa09$export$ca4c39d60ec156a2 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_PLAN_CALENDAR,
    path: '/jira/plans/:planId/scenarios/:scenarioId/calendar'
};
const $d88229dbc347aa09$export$850236b64b0aa28b = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_PLAN_RELEASES,
    path: '/jira/plans/:planId/scenarios/:scenarioId/releases'
};
const $d88229dbc347aa09$export$61abeb6a03d23dd3 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_PLAN_TIMELINE,
    path: '/jira/plans/:planId/scenarios/:scenarioId/timeline'
};
const $d88229dbc347aa09$export$6734c29372722a5e = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_PLAN_SETTINGS_PERMISSIONS,
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/permissions'
};
const $d88229dbc347aa09$export$a0fec30f475e8756 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_PLAN_SETTINGS_SAVED_VIEWS,
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/saved-views'
};
const $d88229dbc347aa09$export$3d54c48a91a178c0 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_PLAN_SETTINGS_PROGRAM_BOARDS,
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/program-boards'
};
const $d88229dbc347aa09$export$76e6bdc959f6fa97 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_PLAN_SETTINGS_PLAN_INFO,
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/plan-info'
};
const $d88229dbc347aa09$export$a215ef374dd2a8a9 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_PLAN_SETTINGS_SCHEDULING,
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/scheduling'
};
const $d88229dbc347aa09$export$d32efeefb944c6b7 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_PLAN_SETTINGS_SCENARIOS,
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/scenarios'
};
const $d88229dbc347aa09$export$e44088b2cc0206cf = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_PLAN_SETTINGS_AUTO_SCHEDULER,
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/auto-scheduler'
};
const $d88229dbc347aa09$export$2634cd63c73f7a35 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_PLAN_SETTINGS_CUSTOM_FIELDS,
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/custom-fields'
};
const $d88229dbc347aa09$export$358b0ca69a4bd731 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_PLAN_SETTINGS_EXCLUSION_RULES,
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/exclusion-rules'
};
const $d88229dbc347aa09$export$fa18324265e4400c = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_PLAN_SETTINGS_ISSUE_SOURCES,
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/issue-sources'
};
const $d88229dbc347aa09$export$ab61883f74eb27c2 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_PLAN_SETTINGS_FIND_YOUR_ISSUE,
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/find-your-issue'
};
const $d88229dbc347aa09$export$8b77532ba9798e64 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_PLAN_SETTINGS_REMOVED_ISSUES,
    path: '/jira/plans/:planId/scenarios/:scenarioId/settings/removed-issues'
};
const $d88229dbc347aa09$export$fc66f5c0de18ddc7 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_PLAN_TEAMS,
    path: '/jira/plans/:planId/scenarios/:scenarioId/teams'
};
const $d88229dbc347aa09$export$a3686c51bf984ef9 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_ADVANCED_ROADMAPS,
    path: '/jira/plans/:planId(\\d+)'
};
const $d88229dbc347aa09$export$cc2401df741549fe = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_ADVANCED_ROADMAPS_REDIRECT,
    path: '/secure/PortfolioPlanView.jspa'
};
const $d88229dbc347aa09$export$bd0ed90cfd1c0a55 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_ADVANCED_ROADMAPS,
    path: '/jira/plans/reports/:reportId'
};
const $d88229dbc347aa09$export$264157b237e791ea = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_ADVANCED_ROADMAPS_REDIRECT,
    path: '/secure/PortfolioReportView.jspa'
};
const $d88229dbc347aa09$export$158bfed3a17a3f80 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_ADVANCED_ROADMAPS,
    path: '/jira/plans/:planId/scenarios/:scenarioId/export'
};
const $d88229dbc347aa09$export$442daaf7ae9abf13 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_ADVANCED_ROADMAPS_SETUP,
    path: '/jira/plans/:planId/setup'
};
const $d88229dbc347aa09$export$38c76ea9ddc85b3 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_ADVANCED_ROADMAPS_GETTING_STARTED_REDIRECT,
    path: '/secure/PortfolioGettingStarted.jspa'
};



var $atRHQ = parcelRequire("atRHQ");

var $7u7sK = parcelRequire("7u7sK");

var $59o4i = parcelRequire("59o4i");

var $eUqFw = parcelRequire("eUqFw");

var $ae4LH = parcelRequire("ae4LH");

var $3HCkE = parcelRequire("3HCkE");
var $kJlBc = parcelRequire("kJlBc");

var $drCAA = parcelRequire("drCAA");

var $atRHQ = parcelRequire("atRHQ");

var $kY36r = parcelRequire("kY36r");
const $b1a6b20b73816189$var$PERSIST_SEARCH_PARAMS = [
    'search'
];
const $b1a6b20b73816189$var$RedirectLegacyPlanPageWithoutScenarioId = ()=>{
    const [{ query: query }] = (0, $kJlBc.useRouter)();
    const { data: data, loading: loading } = (0, $3HCkE.useResource)((0, $drCAA.advancedRoadmapsScenarioIdResource));
    if (loading || data === null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
        to: `/jira/plans/${query.id}/scenarios/${data.scenarioId}`,
        persistSearchParams: $b1a6b20b73816189$var$PERSIST_SEARCH_PARAMS
    });
};
const $b1a6b20b73816189$export$c3e4fda2290a52bf = ()=>{
    const [{ query: query }] = (0, $kJlBc.useRouter)();
    const { id: id, sid: sid } = query;
    if (Number.isNaN(Number.parseFloat(sid))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b1a6b20b73816189$var$RedirectLegacyPlanPageWithoutScenarioId, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
        to: `/jira/plans/${id}/scenarios/${sid}`,
        persistSearchParams: $b1a6b20b73816189$var$PERSIST_SEARCH_PARAMS
    });
};
const $b1a6b20b73816189$export$ff420400c9900835 = ()=>{
    const [{ match: match }] = (0, $kJlBc.useRouter)();
    const { planId: planId } = match.params;
    if (planId === null || planId === undefined || Number.isNaN(Number.parseFloat(planId))) throw new Error('Plan cannot be loaded without planId');
    const { data: data, loading: loading } = (0, $3HCkE.useResource)((0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource));
    if (loading || data === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ae4LH.default), null);
    if (!data.success) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kY36r.ErrorScreen), {
        errorMessage: data.errorMessage
    });
    if (data.scenarioId === null || data.scenarioId === undefined || typeof data.scenarioId === 'string' && Number.isNaN(Number.parseFloat(data.scenarioId))) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
        to: `/jira/plans/${planId}/scenarios/${data.scenarioId}`,
        persistSearchParams: $b1a6b20b73816189$var$PERSIST_SEARCH_PARAMS
    });
};



var $eUqFw = parcelRequire("eUqFw");

var $kJlBc = parcelRequire("kJlBc");

var $atRHQ = parcelRequire("atRHQ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$23beffab57eac402$export$2e2bcd8739ae039 = ()=>{
    const [{ query: query }] = (0, $kJlBc.useRouter)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
        to: `/jira/plans/reports/${query.r}`,
        persistSearchParams: false
    });
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7okz2 = parcelRequire("7okz2");

var $apqRF = parcelRequire("apqRF");

var $2hHs5 = parcelRequire("2hHs5");

var $hHrVM = parcelRequire("hHrVM");


var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

var $eUqFw = parcelRequire("eUqFw");

var $atRHQ = parcelRequire("atRHQ");
const $5f079d10cc40bf07$export$9090339aecaa99f2 = (CurrentComponent, redirectUrl, redirectCondition)=>()=>{
        if (redirectCondition()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
            to: redirectUrl
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CurrentComponent, null);
    };
const $5f079d10cc40bf07$export$2d47ce6f15e624e5 = (redirectUrl)=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
            to: redirectUrl
        });



const $757441de7a03322f$export$4fcc3c0f6e792efc = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("7XGBt"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/settings/dependencies/index.tsx"
});
const $757441de7a03322f$export$d6f045c7c1aaff50 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $757441de7a03322f$export$4fcc3c0f6e792efc,
        pageId: "arj-settings-dependencies",
        shouldShowSpinner: true
    });
const $757441de7a03322f$export$70386609aff5ba12 = (0, $apqRF.createEntry)((0, $f4d7ea4ec84815d2$export$e657c8aeaaf0932c), {
    component: $757441de7a03322f$export$d6f045c7c1aaff50,
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        (0, $2hHs5.issueLinkInformationResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $757441de7a03322f$export$4fcc3c0f6e792efc
    ]
});
const $757441de7a03322f$export$804f2d81dfbdd5c9 = (0, $apqRF.createEntry)((0, $f4d7ea4ec84815d2$export$b55de156ac5f7c1b), {
    component: (0, $5f079d10cc40bf07$export$2d47ce6f15e624e5)('/jira/plans/settings/dependencies'),
    isRedirect: true,
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        (0, $2hHs5.issueLinkInformationResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $757441de7a03322f$export$4fcc3c0f6e792efc
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7okz2 = parcelRequire("7okz2");

var $apqRF = parcelRequire("apqRF");

var $gubiX = parcelRequire("gubiX");

var $hHrVM = parcelRequire("hHrVM");


var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");


const $bac19dc5faaa37c5$export$64761ea1912fdcd9 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("2kw2s"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/settings/loading-limits/index.tsx"
});
const $bac19dc5faaa37c5$export$7bb4c0f22b467385 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $bac19dc5faaa37c5$export$64761ea1912fdcd9,
        pageId: "arj-settings-loading-limits",
        shouldShowSpinner: true
    });
const $bac19dc5faaa37c5$export$6786257309f86d8c = (0, $apqRF.createEntry)((0, $f4d7ea4ec84815d2$export$21eaa019c724fc9a), {
    component: $bac19dc5faaa37c5$export$7bb4c0f22b467385,
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        (0, $gubiX.arjSettingsLoadingLimitsResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $bac19dc5faaa37c5$export$64761ea1912fdcd9
    ]
});
const $bac19dc5faaa37c5$export$9f80102c0f64ad9b = (0, $apqRF.createEntry)((0, $f4d7ea4ec84815d2$export$c72a1b9971af07d9), {
    component: (0, $5f079d10cc40bf07$export$2d47ce6f15e624e5)('/jira/plans/settings/loading-limits'),
    isRedirect: true,
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $bac19dc5faaa37c5$export$64761ea1912fdcd9
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7okz2 = parcelRequire("7okz2");

var $apqRF = parcelRequire("apqRF");

var $bFKDs = parcelRequire("bFKDs");

var $hHrVM = parcelRequire("hHrVM");


var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");


const $8fbf7c2c548ced9d$export$edb4ae7e85c7908d = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("77CB1"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/settings/permissions/index.tsx"
});
const $8fbf7c2c548ced9d$export$fa852ea42b98d3de = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $8fbf7c2c548ced9d$export$edb4ae7e85c7908d,
        pageId: "arj-settings-permissions",
        shouldShowSpinner: true
    });
const $8fbf7c2c548ced9d$export$4e97658a5cc15eaa = (0, $apqRF.createEntry)((0, $f4d7ea4ec84815d2$export$6372897c47d731c0), {
    component: $8fbf7c2c548ced9d$export$fa852ea42b98d3de,
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        ...(0, $bFKDs.getGlobalPermissionPageResources)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $8fbf7c2c548ced9d$export$edb4ae7e85c7908d
    ]
});
const $8fbf7c2c548ced9d$export$949c8177281fcc39 = (0, $apqRF.createEntry)((0, $f4d7ea4ec84815d2$export$4523847db2f1a42e), {
    component: (0, $5f079d10cc40bf07$export$2d47ce6f15e624e5)('/jira/plans/settings/permissions'),
    isRedirect: true,
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        ...(0, $bFKDs.getGlobalPermissionPageResources)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $8fbf7c2c548ced9d$export$edb4ae7e85c7908d
    ]
});


const $4b93a6a883195715$export$87af7d91a16be1cf = [
    (0, $757441de7a03322f$export$70386609aff5ba12),
    (0, $757441de7a03322f$export$804f2d81dfbdd5c9),
    (0, $bac19dc5faaa37c5$export$6786257309f86d8c),
    (0, $bac19dc5faaa37c5$export$9f80102c0f64ad9b),
    (0, $8fbf7c2c548ced9d$export$4e97658a5cc15eaa),
    (0, $8fbf7c2c548ced9d$export$949c8177281fcc39)
];



var $cernH = parcelRequire("cernH");

var $1ybV0 = parcelRequire("1ybV0");

var $bAQOb = parcelRequire("bAQOb");

var $dVvIP = parcelRequire("dVvIP");

var $efFTI = parcelRequire("efFTI");

var $kLSws = parcelRequire("kLSws");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $29Nmz = parcelRequire("29Nmz");


var $isbb2 = parcelRequire("isbb2");

var $apqRF = parcelRequire("apqRF");

var $drCAA = parcelRequire("drCAA");

var $1IXLY = parcelRequire("1IXLY");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $jwzNs = parcelRequire("jwzNs");


var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $24b1fd4bb94b112f$export$cf676f47aba10db8 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("fgcXI")).then((module)=>module.ArchivedPlans)), {
    moduleId: "./src/packages/spa-apps/admin-pages/archived-plans/src/index.tsx"
});
const $24b1fd4bb94b112f$export$ed59bbc59461c00f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $24b1fd4bb94b112f$export$cf676f47aba10db8,
        pageId: "archived-plans",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $3999e44dd6fe3f68$export$e7b9f83d442bac51 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("5jZUn"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-increment/index.tsx"
});
const $3999e44dd6fe3f68$export$5e1035d0876d64db = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $3999e44dd6fe3f68$export$e7b9f83d442bac51,
        pageId: "plan-increment",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $c6a4e34745e373d9$export$fcf33bee71726f6c = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("jgO4O"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-increments/index.tsx"
});
const $c6a4e34745e373d9$export$35c60884562df827 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $c6a4e34745e373d9$export$fcf33bee71726f6c,
        pageId: "plan-increments",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $7388e9bc82df2f72$export$9da4d4d5c4d7f749 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("ksN5x"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-program/index.tsx"
});
const $7388e9bc82df2f72$export$fb30c2b19a4f5d59 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7388e9bc82df2f72$export$9da4d4d5c4d7f749,
        pageId: "plan-program",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $bd3c4867adaafb7f$export$6ac18b311b7e51a1 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("6oPFD")).then((module)=>module.TrashedPlans)), {
    moduleId: "./src/packages/spa-apps/admin-pages/trashed-plans/src/index.tsx"
});
const $bd3c4867adaafb7f$export$b145fa65818ff157 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $bd3c4867adaafb7f$export$6ac18b311b7e51a1,
        pageId: "trashed-plans",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $de7246821d535f93$export$dd67c2f01a58231e = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("hgBVx")).then((module)=>module.ArjSettingsFinancialYear)), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/settings/financial-year/index.tsx"
});
const $de7246821d535f93$export$785180185eba7ed9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $de7246821d535f93$export$dd67c2f01a58231e,
        pageId: "arj-settings-financial-year",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $0fec3bea6f800248$export$20a71ac28e6a3c8f = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("6ooLx"))), {
    moduleId: "./src/packages/portfolio-3/plan-trashed-direct-link/src/index.tsx"
});
const $0fec3bea6f800248$export$38f3a061bb1fceee = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $0fec3bea6f800248$export$20a71ac28e6a3c8f,
        pageId: "trashed-plan-direct-link",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $9XeW0 = parcelRequire("9XeW0");

var $kJlBc = parcelRequire("kJlBc");

var $atRHQ = parcelRequire("atRHQ");
function $4bb2b4782688a1bd$export$2c9e4550ef8bdea9(Component, { to: to, redirectCondition: redirectCondition }) {
    return ()=>{
        const { isSidebarVisible: isSidebarVisible } = (0, $9XeW0.useSidebarVisibility)();
        const [{ match: match }] = (0, $kJlBc.useRouter)();
        if (match == null || match.params == null || match.params.planId == null || match.params.scenarioId == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
            to: "/jira/plans"
        });
        if (!redirectCondition(isSidebarVisible)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
            to: `/jira/plans/${match.params.planId}/scenarios/${match.params.scenarioId}${to}`
        });
    };
}


const $4aaa9ca7f7e53447$export$f7abc47036ff7dd9 = (0, $apqRF.createEntry)((0, $52eda9e1a201d846$export$d0986e4bd9568b30), {
    // delete this redirection when removing the FF isIncrementPlanningEnabled i.e.
    component: (0, $4bb2b4782688a1bd$export$2c9e4550ef8bdea9)((0, $bAQOb.componentWithFF)('com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1', (0, $7388e9bc82df2f72$export$fb30c2b19a4f5d59), (0, $c6a4e34745e373d9$export$35c60884562df827)), {
        to: '',
        redirectCondition: ()=>!(0, $1ybV0.ff)('com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1')
    }),
    exact: true,
    layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PLANS,
        sidebar: (0, $29Nmz.default),
        horizontal: (0, $kLSws.AsyncHorizontalNavPlans),
        horizontalFeatureFlag: 'jet-plans-nav-refresh_f9025'
    },
    preloadOptions: {
        earlyChunks: [
            'advanced-roadmaps-early-entry'
        ]
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
        (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
        (0, $drCAA.advancedRoadmapsReduxStoreStateResource),
        (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1'), (0, $drCAA.advancedRoadmapsLastVisitedProgramBoardIdResource))
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $7388e9bc82df2f72$export$9da4d4d5c4d7f749)
    ]
});
const $4aaa9ca7f7e53447$export$a26fa5cabff8bc7c = (0, $apqRF.createEntry)((0, $52eda9e1a201d846$export$ef33a75556fde209), {
    // delete this redirection when removing the FF isIncrementPlanningEnabled i.e.
    // component: PlanIncrement,
    component: (0, $4bb2b4782688a1bd$export$2c9e4550ef8bdea9)((0, $3999e44dd6fe3f68$export$5e1035d0876d64db), {
        to: '',
        redirectCondition: ()=>!(0, $1ybV0.ff)('com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1')
    }),
    exact: true,
    layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PLANS,
        sidebar: (0, $29Nmz.default),
        horizontal: (0, $kLSws.AsyncHorizontalNavPlans),
        horizontalFeatureFlag: 'jet-plans-nav-refresh_f9025'
    },
    preloadOptions: {
        earlyChunks: [
            'advanced-roadmaps-early-entry'
        ]
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
        (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
        (0, $drCAA.advancedRoadmapsReduxStoreStateResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $3999e44dd6fe3f68$export$e7b9f83d442bac51)
    ]
});
const $4aaa9ca7f7e53447$export$b9921058a8a65710 = (0, $apqRF.createEntry)((0, $52eda9e1a201d846$export$29647353386ad146), {
    exact: true,
    component: (0, $24b1fd4bb94b112f$export$ed59bbc59461c00f),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $24b1fd4bb94b112f$export$cf676f47aba10db8)
    ]
});
const $4aaa9ca7f7e53447$export$eabcbe4dd6fc9f1f = (0, $apqRF.createEntry)((0, $52eda9e1a201d846$export$b1d2299a57fca83a), {
    exact: true,
    component: (0, $bd3c4867adaafb7f$export$b145fa65818ff157),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $bd3c4867adaafb7f$export$6ac18b311b7e51a1)
    ]
});
const $4aaa9ca7f7e53447$export$dbcd0bd16f12397d = (0, $apqRF.createEntry)((0, $52eda9e1a201d846$export$1a9edb72cd49ca79), {
    component: (0, $0fec3bea6f800248$export$38f3a061bb1fceee),
    layout: (0, $dVvIP.globalLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $0fec3bea6f800248$export$20a71ac28e6a3c8f)
    ],
    ufoName: 'plan-trashed'
});
const $4aaa9ca7f7e53447$export$3907721420f39680 = (0, $apqRF.createEntry)((0, $52eda9e1a201d846$export$7208300f00a36a5f), {
    exact: true,
    component: (0, $de7246821d535f93$export$785180185eba7ed9),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $9CFDS.navigationSidebarGlobalResource),
        (0, $1IXLY.arjSettingsFinancialYearResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $de7246821d535f93$export$dd67c2f01a58231e)
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gC7XG = parcelRequire("gC7XG");

const $bf010c1b73a0efa7$export$56ea489e9d4bfa04 = (page)=>({
        root: page.main.root,
        getPreloadProps: (entryPointParams)=>({
                entryPoints: {
                    [(0, $d619e185f38e9ae8$export$900ddb492c628f48)]: {
                        entryPoint: page.main,
                        entryPointParams: entryPointParams
                    }
                }
            }),
        toString: ()=>'ChromelessEntryPoint'
    });
const $bf010c1b73a0efa7$export$955a7619d2679b4c = (page)=>({
        root: page.main.root,
        getPreloadProps: (entryPointParams)=>({
                entryPoints: {
                    [(0, $d619e185f38e9ae8$export$900ddb492c628f48)]: {
                        entryPoint: page.main,
                        entryPointParams: entryPointParams
                    },
                    [(0, $d619e185f38e9ae8$export$bec6dca2e63de4ae)]: {
                        entryPoint: (0, $gC7XG.topNavigationEntryPoint),
                        entryPointParams: {
                            menuId: page.topNavigationMenuId
                        }
                    },
                    ...page.horizontalNavigation ? {
                        [(0, $d619e185f38e9ae8$export$948d4d345566aed3)]: {
                            entryPoint: page.horizontalNavigation,
                            entryPointParams: {}
                        }
                    } : undefined
                }
            }),
        toString: ()=>'PageEntryPoint'
    });



var $7vTKl = parcelRequire("7vTKl");

var $1ybV0 = parcelRequire("1ybV0");
/**
 * @generated SignedSource<<fabab3d3edd3d9f572732a97f864ca15>>
 * @relayHash 28f888dbec306fbacfd21d0432ea0a34
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6a64af9bcb3b0f6a95442ba53118ca740ad59465a60174124814a176d24aa2f7
const $ae4d1c21cb10f5ab$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "6a64af9bcb3b0f6a95442ba53118ca740ad59465a60174124814a176d24aa2f7",
        "metadata": {},
        "name": "ui_jiraCalendarQuery",
        "operationKind": "query",
        "text": null
    }
};
var $ae4d1c21cb10f5ab$export$2e2bcd8739ae039 = $ae4d1c21cb10f5ab$var$node;



var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");
function $3cdffbe977956bc3$var$toPlanScenarioAri({ siteId: siteId, activationId: activationId, planId: planId, scenarioId: scenarioId }) {
    return `ari:cloud:jira:${siteId}:plan-scenario/activation/${activationId}/${planId}/scenario/${scenarioId}`;
}
function $3cdffbe977956bc3$var$toBoardAri({ siteId: siteId, boardId: boardId }) {
    return `ari:cloud:jira-software:${siteId}:board/${boardId}`;
}
function $3cdffbe977956bc3$var$getStorageKeyFromScope(context) {
    const { match: { params: { planId: planId, scenarioId: scenarioId } } } = context;
    const LOCALSTORAGE_KEY_PREFIX = 'persist:calendar';
    return `${LOCALSTORAGE_KEY_PREFIX}/plan/${planId}/scenario/${scenarioId}`;
}
function $3cdffbe977956bc3$var$getStorageValueFromScope(key) {
    const storedData = localStorage.getItem(key) || '';
    return storedData;
}
function $3cdffbe977956bc3$var$toMidnightUTCString(date) {
    const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    return new Date(utcMilliseconds).toISOString();
}
function $3cdffbe977956bc3$var$toDate(date) {
    if (!date) return new Date();
    try {
        const _date = new Date(date);
        return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
    } catch (e) {
        return new Date();
    }
}
function $3cdffbe977956bc3$var$createScope({ context: context, tenantContext: tenantContext }) {
    const { match: { params: { planId: planId, scenarioId: scenarioId } } } = context;
    const { cloudId: cloudId, activationId: activationId } = tenantContext;
    const planScenarioAri = $3cdffbe977956bc3$var$toPlanScenarioAri({
        siteId: cloudId,
        activationId: activationId,
        planId: String(planId),
        scenarioId: String(scenarioId)
    });
    return {
        type: 'plan',
        ids: [
            planScenarioAri
        ]
    };
}
function $3cdffbe977956bc3$var$buildScopeInput(scope) {
    return {
        ids: scope.ids
    };
}
function $3cdffbe977956bc3$var$toViewMode(mode) {
    switch(mode){
        case 'week':
            return 'WEEK';
        case 'day':
            return 'DAY';
        default:
            return 'MONTH';
    }
}
function $3cdffbe977956bc3$var$toWeekStart(weekStart) {
    switch(weekStart){
        case 'monday':
            return 'MONDAY';
        case 'saturday':
            return 'SATURDAY';
        default:
            return 'SUNDAY';
    }
}
function $3cdffbe977956bc3$var$buildConfigurationInput({ selectedDate: selectedDate, viewMode: viewMode, weekStartsOn: weekStartsOn, startDateField: startDateField, endDateField: endDateField }) {
    return {
        date: $3cdffbe977956bc3$var$toMidnightUTCString(selectedDate),
        mode: $3cdffbe977956bc3$var$toViewMode(viewMode),
        weekStart: $3cdffbe977956bc3$var$toWeekStart(weekStartsOn),
        startDateField: startDateField,
        endDateField: endDateField
    };
}
function $3cdffbe977956bc3$var$buildIssuesSearchInput(storageKey) {
    return {
        additionalFilterQuery: $3cdffbe977956bc3$var$getStorageValueFromScope(storageKey)
    };
}
function $3cdffbe977956bc3$var$buildUnscheduledIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}
function $3cdffbe977956bc3$var$buildVersionsSearchInput() {
    return {
        versionStatuses: [
            'RELEASED',
            'UNRELEASED'
        ]
    };
}
function $3cdffbe977956bc3$var$buildSprintsSearchInput() {
    return {
        sprintStates: [
            'ACTIVE',
            'FUTURE',
            'CLOSED'
        ]
    };
}

const $3cdffbe977956bc3$export$19cf4b398f638dc6 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("bgHcd")), {
        moduleId: "53aec496"
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
        const { cloudId: cloudId } = tenantContext;
        const scope = $3cdffbe977956bc3$var$createScope(entryPointRouteParams);
        const scopeInput = $3cdffbe977956bc3$var$buildScopeInput(scope);
        const { date: date } = context.query;
        const selectedDate = $3cdffbe977956bc3$var$toDate(date);
        const viewMode = 'month';
        const weekStartsOn = 'sunday';
        const startDateField = 'startdate';
        const endDateField = 'duedate';
        const issueEventFields = {
            startDateField: startDateField,
            endDateField: endDateField
        };
        const storageKey = $3cdffbe977956bc3$var$getStorageKeyFromScope(context);
        return {
            queries: {
                calendarData: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $ae4d1c21cb10f5ab$export$2e2bcd8739ae039,
                    variables: {
                        cloudId: cloudId,
                        // @deprecated to be clean up via jsw-adopt-schedule-calendar-issue-mutation_9u2rq feature flag
                        projectKey: '',
                        boardAri: $3cdffbe977956bc3$var$toBoardAri({
                            siteId: cloudId,
                            // TODO this is just for the calendar to render until base component is changed
                            boardId: '0'
                        }),
                        scopeInput: scopeInput,
                        configurationInput: $3cdffbe977956bc3$var$buildConfigurationInput({
                            selectedDate: selectedDate,
                            viewMode: viewMode,
                            weekStartsOn: weekStartsOn,
                            startDateField: startDateField,
                            endDateField: endDateField
                        }),
                        issuesSearchInput: $3cdffbe977956bc3$var$buildIssuesSearchInput(storageKey),
                        unscheduledIssuesSearchInput: $3cdffbe977956bc3$var$buildUnscheduledIssuesSearchInput(),
                        versionsSearchInput: $3cdffbe977956bc3$var$buildVersionsSearchInput(),
                        sprintsSearchInput: $3cdffbe977956bc3$var$buildSprintsSearchInput(),
                        skipSprintSearch: false,
                        skipVersionSearch: false,
                        skipPanelIssueSearch: true,
                        jswmoonSsdReleaseFlyoutUpdateEnabled: (0, $1ybV0.ff)('jswmoon_ssd_release_flyout_update')
                    }
                }
            },
            entryPoints: {},
            extraProps: {
                scope: scope,
                selectedDate: selectedDate,
                viewMode: viewMode,
                weekStartsOn: weekStartsOn,
                issueEventFields: issueEventFields,
                storageKey: storageKey
            }
        };
    }
});



var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $52e36f27e7c3f239$export$3b1de511e34cdb8f = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("5t5Yk"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-calendar/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$52e36f27e7c3f239$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $52e36f27e7c3f239$export$3b1de511e34cdb8f,
        pageId: "plan-calendar",
        shouldShowSpinner: true
    });
const $52e36f27e7c3f239$export$21806ebf23f23060 = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $3cdffbe977956bc3$export$19cf4b398f638dc6),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PLANS
});



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $183ee29229724a27$export$d4669c7a2f17c261 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("jxxS2"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-dependencies-report/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$183ee29229724a27$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $183ee29229724a27$export$d4669c7a2f17c261,
        pageId: "plan-dependencies-report",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $def3284302c0ab74$export$749f5d2513e04ec0 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("iWCsF"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-releases/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$def3284302c0ab74$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $def3284302c0ab74$export$749f5d2513e04ec0,
        pageId: "plan-releases",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $9XeW0 = parcelRequire("9XeW0");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $937e8f491e6cccea$export$81591fb347c2e0ac = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("6E8OP"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$937e8f491e6cccea$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $937e8f491e6cccea$export$81591fb347c2e0ac,
        pageId: "advanced-roadmaps-plan",
        shouldShowSpinner: true
    });


/**
 * Classic Report Page
 */ const $b1aff7950ef934d8$var$ReportPageComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $937e8f491e6cccea$export$81591fb347c2e0ac), {
        viewType: "report"
    });

/**
 * New Report page
 */ // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $b1aff7950ef934d8$var$LazyPlanReport = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("G0uWI"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-report/index.tsx"
});
const $b1aff7950ef934d8$var$PlanReport = ()=>{
    const { isSidebarVisible: isSidebarVisible } = (0, $9XeW0.useSidebarVisibility)();
    return isSidebarVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $b1aff7950ef934d8$var$LazyPlanReport,
        pageId: "plan-report",
        shouldShowSpinner: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $b1aff7950ef934d8$var$ReportPageComponent,
        pageId: "advanced-roadmap",
        shouldShowSpinner: true
    });
};
var $b1aff7950ef934d8$export$2e2bcd8739ae039 = $b1aff7950ef934d8$var$PlanReport;




var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $cf2d4b7160b080e2$export$8bcf7155849993f5 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("bEwnA"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/auto-scheduler/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cf2d4b7160b080e2$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $cf2d4b7160b080e2$export$8bcf7155849993f5,
        pageId: "plan-settings-auto-scheduler",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $6ea35b9284d75d26$export$72bf44dbae2383e5 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("bwqq9"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/custom-fields/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6ea35b9284d75d26$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $6ea35b9284d75d26$export$72bf44dbae2383e5,
        pageId: "plan-settings-custom-fields",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $9ada19f5a506fdb5$export$78f61b03c267e6d9 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("6fMSz"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/exclusion-rules/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9ada19f5a506fdb5$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $9ada19f5a506fdb5$export$78f61b03c267e6d9,
        pageId: "plan-settings-exclusion-rules",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $8400d45983020bda$export$731998664b7d5e72 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("56upb"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/find-your-issue/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8400d45983020bda$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $8400d45983020bda$export$731998664b7d5e72,
        pageId: "plan-settings-find-your-issue",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $9bb397f6e922a17b$export$7ba4b487efcedeb3 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("3TT6a"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/issue-sources/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9bb397f6e922a17b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $9bb397f6e922a17b$export$7ba4b487efcedeb3,
        pageId: "plan-settings-issue-sources",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $6c9093541b145644$export$49f5b76ad5c06a42 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("lwLYs"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/permissions/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6c9093541b145644$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $6c9093541b145644$export$49f5b76ad5c06a42,
        pageId: "plan-settings-permissions",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $254c61850a622af9$export$c1344fd7d24991b3 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("9gTeT"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/plan-info/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$254c61850a622af9$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $254c61850a622af9$export$c1344fd7d24991b3,
        pageId: "plan-settings-plan-info",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $670b0c2817d02362$export$ffdec728a47c437c = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("b8yEP"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/program-boards/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$670b0c2817d02362$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $670b0c2817d02362$export$ffdec728a47c437c,
        pageId: "plan-settings-program-boards",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $3b91f4401c9b80db$export$759df6301ec72119 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("1gTbW"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/removed-issues/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3b91f4401c9b80db$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $3b91f4401c9b80db$export$759df6301ec72119,
        pageId: "plan-settings-removed-issues",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $2b8c1d6440963d9b$export$a5398542699d356a = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("ddqVC"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/saved-views/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2b8c1d6440963d9b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $2b8c1d6440963d9b$export$a5398542699d356a,
        pageId: "plan-settings-saved-views",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $7b43b2a67bea7871$export$94104fcc1a6f460f = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("dZ2N4"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/scenarios/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7b43b2a67bea7871$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7b43b2a67bea7871$export$94104fcc1a6f460f,
        pageId: "plan-settings-scenarios",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $4c88e6ccbbf6384f$export$3bf11db1bbeae73e = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("1NAsW"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/scheduling/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4c88e6ccbbf6384f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $4c88e6ccbbf6384f$export$3bf11db1bbeae73e,
        pageId: "plan-settings-scheduling",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $42e79934d9e30f0d$export$c717f0d9d7f11b49 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("5lrtf"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-summary/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$42e79934d9e30f0d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $42e79934d9e30f0d$export$c717f0d9d7f11b49,
        pageId: "plan-summary",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $f4897c15aa4b2194$export$f85952f98f28fed0 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("9wxkI"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-teams/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f4897c15aa4b2194$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $f4897c15aa4b2194$export$f85952f98f28fed0,
        pageId: "plan-teams",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $6b3ef2a0f2f0280b$export$bf48e5f1529ddaeb = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("lMn31"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-timeline/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6b3ef2a0f2f0280b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $6b3ef2a0f2f0280b$export$bf48e5f1529ddaeb,
        pageId: "plan-timeline",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $0751981f2e92b798$export$46bb3a1779d7815b = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("84X8A"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/advanced-roadmaps/setup/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0751981f2e92b798$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $0751981f2e92b798$export$46bb3a1779d7815b,
        pageId: "advanced-roadmaps-setup",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $9XeW0 = parcelRequire("9XeW0");

var $kJlBc = parcelRequire("kJlBc");

var $atRHQ = parcelRequire("atRHQ");
function $d7c72efb8546f936$export$2e2bcd8739ae039(Component, { to: to, redirectCondition: redirectCondition }) {
    return ()=>{
        const { isSidebarVisible: isSidebarVisible } = (0, $9XeW0.useSidebarVisibility)();
        const [{ match: match }] = (0, $kJlBc.useRouter)();
        if (match == null || match.params == null || match.params.planId == null || match.params.scenarioId == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
            to: "/jira/plans"
        });
        if (!redirectCondition(isSidebarVisible)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
            to: `/jira/plans/${match.params.planId}/scenarios/${match.params.scenarioId}${to}`
        });
    };
}


const $8ca12770b5795d94$export$f43cc215b47dd576 = [
    (0, $4aaa9ca7f7e53447$export$b9921058a8a65710),
    (0, $4aaa9ca7f7e53447$export$eabcbe4dd6fc9f1f),
    (0, $4aaa9ca7f7e53447$export$dbcd0bd16f12397d),
    (0, $4aaa9ca7f7e53447$export$3907721420f39680),
    (0, $4aaa9ca7f7e53447$export$a26fa5cabff8bc7c),
    (0, $4aaa9ca7f7e53447$export$f7abc47036ff7dd9)
];
// Move advancedRoadmapsLastVisitedProgramBoardIdResource back into the resources array on clean up
const $8ca12770b5795d94$var$lastVisitedProgramBoardResource = (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1'), (0, $drCAA.advancedRoadmapsLastVisitedProgramBoardIdResource));
const $8ca12770b5795d94$export$f85a75f1604118ff = (0, $apqRF.createEntry)((0, $d88229dbc347aa09$export$21d57208bfbf7e92), {
    ufoName: 'software-advanced-roadmaps-scenario',
    component: (0, $d7c72efb8546f936$export$2e2bcd8739ae039)((0, $937e8f491e6cccea$export$2e2bcd8739ae039), {
        to: '/timeline',
        redirectCondition: (isSidebarVisible)=>isSidebarVisible
    }),
    layout: (0, $dVvIP.globalLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
        (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
        (0, $drCAA.advancedRoadmapsReduxStoreStateResource),
        $8ca12770b5795d94$var$lastVisitedProgramBoardResource
    ],
    preloadOptions: {
        earlyChunks: [
            'advanced-roadmaps-early-entry'
        ]
    },
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PLANS
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $937e8f491e6cccea$export$81591fb347c2e0ac)
    ]
});
const $8ca12770b5795d94$export$189ae5546a081577 = [
    ...(0, $4b93a6a883195715$export$87af7d91a16be1cf),
    (0, $apqRF.createEntry)((0, $d88229dbc347aa09$export$ad8296aa5394f696), {
        component: (0, $d7c72efb8546f936$export$2e2bcd8739ae039)((0, $183ee29229724a27$export$2e2bcd8739ae039), {
            to: '',
            redirectCondition: (isSidebarVisible)=>!isSidebarVisible
        }),
        layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
            (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $drCAA.advancedRoadmapsReduxStoreStateResource),
            $8ca12770b5795d94$var$lastVisitedProgramBoardResource
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PLANS,
            sidebar: (0, $29Nmz.default),
            horizontal: (0, $kLSws.AsyncHorizontalNavPlans),
            horizontalFeatureFlag: 'jet-plans-nav-refresh_f9025'
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $183ee29229724a27$export$d4669c7a2f17c261)
        ]
    }),
    (0, $apqRF.createEntry)((0, $d88229dbc347aa09$export$25a8cf27557a612d), {
        ufoName: 'software-advanced-roadmaps-summary',
        component: (0, $d7c72efb8546f936$export$2e2bcd8739ae039)((0, $42e79934d9e30f0d$export$2e2bcd8739ae039), {
            to: '',
            redirectCondition: (isSidebarVisible)=>!isSidebarVisible
        }),
        layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
            (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $2nflD.advancedRoadmapsSummaryDataResource),
            $8ca12770b5795d94$var$lastVisitedProgramBoardResource
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PLANS,
            sidebar: (0, $29Nmz.default),
            horizontal: (0, $kLSws.AsyncHorizontalNavPlans),
            horizontalFeatureFlag: 'jet-plans-nav-refresh_f9025'
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $42e79934d9e30f0d$export$c717f0d9d7f11b49)
        ]
    }),
    (0, $apqRF.createEntry)((0, $d88229dbc347aa09$export$ca4c39d60ec156a2), {
        ufoName: 'software-advanced-roadmaps-calendar',
        component: (0, $d7c72efb8546f936$export$2e2bcd8739ae039)((0, $52e36f27e7c3f239$export$2e2bcd8739ae039), {
            to: '',
            redirectCondition: (isSidebarVisible)=>!isSidebarVisible
        }),
        skeleton: ()=>(0, $1ybV0.ff)('platform-calendar-adoption-in-plans') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u7sK.CalendarSkeleton), null) : undefined,
        entryPoint () {
            return (0, $1ybV0.ff)('platform-calendar-adoption-in-plans') ? (0, $52e36f27e7c3f239$export$21806ebf23f23060) : undefined;
        },
        layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
            (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $drCAA.advancedRoadmapsReduxStoreStateResource),
            $8ca12770b5795d94$var$lastVisitedProgramBoardResource
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PLANS,
            sidebar: (0, $29Nmz.default),
            horizontal: (0, $kLSws.AsyncHorizontalNavPlans),
            horizontalFeatureFlag: 'jet-plans-nav-refresh_f9025'
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $52e36f27e7c3f239$export$3b1de511e34cdb8f)
        ]
    }),
    (0, $apqRF.createEntry)((0, $d88229dbc347aa09$export$850236b64b0aa28b), {
        component: (0, $d7c72efb8546f936$export$2e2bcd8739ae039)((0, $def3284302c0ab74$export$2e2bcd8739ae039), {
            to: '',
            redirectCondition: (isSidebarVisible)=>!isSidebarVisible
        }),
        layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
            (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $drCAA.advancedRoadmapsReduxStoreStateResource),
            $8ca12770b5795d94$var$lastVisitedProgramBoardResource
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PLANS,
            sidebar: (0, $29Nmz.default),
            horizontal: (0, $kLSws.AsyncHorizontalNavPlans),
            horizontalFeatureFlag: 'jet-plans-nav-refresh_f9025'
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $def3284302c0ab74$export$749f5d2513e04ec0)
        ]
    }),
    (0, $apqRF.createEntry)((0, $d88229dbc347aa09$export$61abeb6a03d23dd3), {
        component: (0, $d7c72efb8546f936$export$2e2bcd8739ae039)((0, $6b3ef2a0f2f0280b$export$2e2bcd8739ae039), {
            to: '',
            redirectCondition: (isSidebarVisible)=>!isSidebarVisible
        }),
        layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
            (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $drCAA.advancedRoadmapsReduxStoreStateResource),
            $8ca12770b5795d94$var$lastVisitedProgramBoardResource
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PLANS,
            sidebar: (0, $29Nmz.default),
            horizontal: (0, $kLSws.AsyncHorizontalNavPlans),
            horizontalFeatureFlag: 'jet-plans-nav-refresh_f9025'
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $6b3ef2a0f2f0280b$export$bf48e5f1529ddaeb)
        ]
    }),
    (0, $apqRF.createEntry)((0, $d88229dbc347aa09$export$6734c29372722a5e), {
        component: (0, $d7c72efb8546f936$export$2e2bcd8739ae039)((0, $6c9093541b145644$export$2e2bcd8739ae039), {
            to: '',
            redirectCondition: (isSidebarVisible)=>!isSidebarVisible
        }),
        layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
            (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $drCAA.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PLANS,
            sidebar: (0, $29Nmz.default)
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $6c9093541b145644$export$49f5b76ad5c06a42)
        ]
    }),
    (0, $apqRF.createEntry)((0, $d88229dbc347aa09$export$a0fec30f475e8756), {
        component: (0, $d7c72efb8546f936$export$2e2bcd8739ae039)((0, $2b8c1d6440963d9b$export$2e2bcd8739ae039), {
            to: '',
            redirectCondition: (isSidebarVisible)=>!isSidebarVisible
        }),
        layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
            (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $drCAA.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PLANS,
            sidebar: (0, $29Nmz.default)
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $2b8c1d6440963d9b$export$a5398542699d356a)
        ]
    }),
    (0, $apqRF.createEntry)((0, $d88229dbc347aa09$export$76e6bdc959f6fa97), {
        component: (0, $d7c72efb8546f936$export$2e2bcd8739ae039)((0, $254c61850a622af9$export$2e2bcd8739ae039), {
            to: '',
            redirectCondition: (isSidebarVisible)=>!isSidebarVisible
        }),
        layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
            (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $drCAA.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PLANS,
            sidebar: (0, $29Nmz.default)
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $254c61850a622af9$export$c1344fd7d24991b3)
        ]
    }),
    (0, $apqRF.createEntry)((0, $d88229dbc347aa09$export$3d54c48a91a178c0), {
        component: (0, $d7c72efb8546f936$export$2e2bcd8739ae039)((0, $670b0c2817d02362$export$2e2bcd8739ae039), {
            to: '',
            redirectCondition: (isSidebarVisible)=>!isSidebarVisible || !(0, $1ybV0.ff)('com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1')
        }),
        layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
            (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $drCAA.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PLANS,
            sidebar: (0, $29Nmz.default)
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $670b0c2817d02362$export$ffdec728a47c437c)
        ]
    }),
    (0, $apqRF.createEntry)((0, $d88229dbc347aa09$export$a215ef374dd2a8a9), {
        component: (0, $d7c72efb8546f936$export$2e2bcd8739ae039)((0, $4c88e6ccbbf6384f$export$2e2bcd8739ae039), {
            to: '',
            redirectCondition: (isSidebarVisible)=>!isSidebarVisible
        }),
        layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
            (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $drCAA.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PLANS,
            sidebar: (0, $29Nmz.default)
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $4c88e6ccbbf6384f$export$3bf11db1bbeae73e)
        ]
    }),
    (0, $apqRF.createEntry)((0, $d88229dbc347aa09$export$d32efeefb944c6b7), {
        component: (0, $d7c72efb8546f936$export$2e2bcd8739ae039)((0, $7b43b2a67bea7871$export$2e2bcd8739ae039), {
            to: '',
            redirectCondition: (isSidebarVisible)=>!isSidebarVisible
        }),
        layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
            (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $drCAA.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PLANS,
            sidebar: (0, $29Nmz.default)
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7b43b2a67bea7871$export$94104fcc1a6f460f)
        ]
    }),
    (0, $apqRF.createEntry)((0, $d88229dbc347aa09$export$e44088b2cc0206cf), {
        component: (0, $d7c72efb8546f936$export$2e2bcd8739ae039)((0, $cf2d4b7160b080e2$export$2e2bcd8739ae039), {
            to: '',
            redirectCondition: (isSidebarVisible)=>!isSidebarVisible
        }),
        layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
            (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $drCAA.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PLANS,
            sidebar: (0, $29Nmz.default)
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $cf2d4b7160b080e2$export$8bcf7155849993f5)
        ]
    }),
    (0, $apqRF.createEntry)((0, $d88229dbc347aa09$export$2634cd63c73f7a35), {
        component: (0, $d7c72efb8546f936$export$2e2bcd8739ae039)((0, $6ea35b9284d75d26$export$2e2bcd8739ae039), {
            to: '',
            redirectCondition: (isSidebarVisible)=>!isSidebarVisible
        }),
        layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
            (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $drCAA.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PLANS,
            sidebar: (0, $29Nmz.default)
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $6ea35b9284d75d26$export$72bf44dbae2383e5)
        ]
    }),
    (0, $apqRF.createEntry)((0, $d88229dbc347aa09$export$358b0ca69a4bd731), {
        component: (0, $d7c72efb8546f936$export$2e2bcd8739ae039)((0, $9ada19f5a506fdb5$export$2e2bcd8739ae039), {
            to: '',
            redirectCondition: (isSidebarVisible)=>!isSidebarVisible
        }),
        layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
            (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $drCAA.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PLANS,
            sidebar: (0, $29Nmz.default)
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $9ada19f5a506fdb5$export$78f61b03c267e6d9)
        ]
    }),
    (0, $apqRF.createEntry)((0, $d88229dbc347aa09$export$fa18324265e4400c), {
        component: (0, $d7c72efb8546f936$export$2e2bcd8739ae039)((0, $9bb397f6e922a17b$export$2e2bcd8739ae039), {
            to: '',
            redirectCondition: (isSidebarVisible)=>!isSidebarVisible
        }),
        layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
            (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $drCAA.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PLANS,
            sidebar: (0, $29Nmz.default)
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $9bb397f6e922a17b$export$7ba4b487efcedeb3)
        ]
    }),
    (0, $apqRF.createEntry)((0, $d88229dbc347aa09$export$ab61883f74eb27c2), {
        component: (0, $d7c72efb8546f936$export$2e2bcd8739ae039)((0, $8400d45983020bda$export$2e2bcd8739ae039), {
            to: '',
            redirectCondition: (isSidebarVisible)=>!isSidebarVisible
        }),
        layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
            (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $drCAA.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PLANS,
            sidebar: (0, $29Nmz.default)
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $8400d45983020bda$export$731998664b7d5e72)
        ]
    }),
    (0, $apqRF.createEntry)((0, $d88229dbc347aa09$export$8b77532ba9798e64), {
        component: (0, $d7c72efb8546f936$export$2e2bcd8739ae039)((0, $3b91f4401c9b80db$export$2e2bcd8739ae039), {
            to: '',
            redirectCondition: (isSidebarVisible)=>!isSidebarVisible
        }),
        layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
            (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $drCAA.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PLANS,
            sidebar: (0, $29Nmz.default)
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $3b91f4401c9b80db$export$759df6301ec72119)
        ]
    }),
    (0, $apqRF.createEntry)((0, $d88229dbc347aa09$export$fc66f5c0de18ddc7), {
        component: (0, $d7c72efb8546f936$export$2e2bcd8739ae039)((0, $f4897c15aa4b2194$export$2e2bcd8739ae039), {
            to: '',
            redirectCondition: (isSidebarVisible)=>!isSidebarVisible
        }),
        layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
            (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource),
            (0, $drCAA.advancedRoadmapsReduxStoreStateResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'advanced-roadmaps-early-entry'
            ]
        },
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PLANS,
            sidebar: (0, $29Nmz.default),
            horizontal: (0, $kLSws.AsyncHorizontalNavPlans),
            horizontalFeatureFlag: 'jet-plans-nav-refresh_f9025'
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $f4897c15aa4b2194$export$f85952f98f28fed0)
        ]
    }),
    (0, $apqRF.createEntry)((0, $d88229dbc347aa09$export$38c76ea9ddc85b3), {
        component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
                to: "/jira/plans?create-sample-plan=true"
            }),
        isRedirect: true,
        layout: (0, $dVvIP.globalLayout),
        resources: [
            ...(0, $hHrVM.getNavigationResources)()
        ],
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PLANS
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $937e8f491e6cccea$export$81591fb347c2e0ac)
        ]
    })
];
const $8ca12770b5795d94$export$9cbef73b51558ef = (0, $apqRF.createEntry)((0, $d88229dbc347aa09$export$a3686c51bf984ef9), {
    ufoName: 'software-advanced-roadmaps-plan',
    component: (0, $b1a6b20b73816189$export$ff420400c9900835),
    layout: (0, $dVvIP.globalLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarPlanResources)(),
        (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource)
    ],
    preloadOptions: {
        earlyChunks: [
            'advanced-roadmaps-early-entry'
        ]
    },
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PLANS
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $937e8f491e6cccea$export$81591fb347c2e0ac)
    ]
});
const $8ca12770b5795d94$export$e9cfdb950d40e917 = (0, $apqRF.createEntry)((0, $d88229dbc347aa09$export$cc2401df741549fe), {
    component: (0, $b1a6b20b73816189$export$c3e4fda2290a52bf),
    isRedirect: true,
    layout: (0, $dVvIP.globalLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $drCAA.advancedRoadmapsScenarioIdResource)
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PLANS
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $937e8f491e6cccea$export$81591fb347c2e0ac)
    ]
});
const $8ca12770b5795d94$export$e71031acce6d7e47 = (0, $apqRF.createEntry)((0, $d88229dbc347aa09$export$bd0ed90cfd1c0a55), {
    ufoName: 'software-advanced-roadmaps-report',
    component: (0, $b1aff7950ef934d8$export$2e2bcd8739ae039),
    layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $81a924b88389d294$export$94e1d79bf65579e2)),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $drCAA.advancedRoadmapsPlanReportPageInitialChecksResource),
        (0, $drCAA.advancedRoadmapsReduxStoreStateResource),
        $8ca12770b5795d94$var$lastVisitedProgramBoardResource
    ],
    preloadOptions: {
        earlyChunks: [
            'advanced-roadmaps-early-entry'
        ]
    },
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PLANS
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $937e8f491e6cccea$export$81591fb347c2e0ac)
    ]
});
const $8ca12770b5795d94$export$c2a4c5c6576a704c = (0, $apqRF.createEntry)((0, $d88229dbc347aa09$export$264157b237e791ea), {
    component: (0, $23beffab57eac402$export$2e2bcd8739ae039),
    isRedirect: true,
    layout: (0, $dVvIP.globalLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)()
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PLANS
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $937e8f491e6cccea$export$81591fb347c2e0ac)
    ]
});
/**
 * Export Page
 */ const $8ca12770b5795d94$var$ExportPageComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $937e8f491e6cccea$export$81591fb347c2e0ac), {
        viewType: "export"
    });
const $8ca12770b5795d94$var$ExportPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $8ca12770b5795d94$var$ExportPageComponent,
        pageId: "advanced-roadmap",
        shouldShowSpinner: true
    });
const $8ca12770b5795d94$export$d751e3552b21c604 = (0, $apqRF.createEntry)((0, $d88229dbc347aa09$export$158bfed3a17a3f80), {
    ufoName: 'software-advanced-roadmaps-scenario-export',
    component: $8ca12770b5795d94$var$ExportPage,
    layout: {
        isChromeless: true,
        globalComponents: [],
        rightSidebars: []
    },
    resources: [
        (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource)
    ],
    forPaint: [
        (0, $937e8f491e6cccea$export$81591fb347c2e0ac)
    ]
});
const $8ca12770b5795d94$export$2a24acea4e628148 = (0, $apqRF.createEntry)((0, $d88229dbc347aa09$export$442daaf7ae9abf13), {
    component: (0, $0751981f2e92b798$export$2e2bcd8739ae039),
    layout: (0, $dVvIP.globalLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $0751981f2e92b798$export$46bb3a1779d7815b)
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $cernH = parcelRequire("cernH");

var $dVvIP = parcelRequire("dVvIP");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $9f7d0d5c14b9d6eb$export$cd3fc26cf9f696e6 = {
    group: (0, $exb0h.ROUTE_GROUPS).ERRORS,
    name: (0, $exb0h.ROUTE_NAMES).ARCHIVED_PROJECT_DIRECT_LINK,
    path: '/jira/errors/project-archived',
    exact: true
};



var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $6c41e52c48634921$export$bcbb38b3c86dba1f = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("g3V3V"))), {
    moduleId: "./src/packages/project-pages/project-archive/project-archived-direct-link/src/index.tsx"
});
const $6c41e52c48634921$export$2e0968e4c0408481 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $6c41e52c48634921$export$bcbb38b3c86dba1f,
        pageId: "archived-project-direct-link",
        shouldShowSpinner: false
    });
const $6c41e52c48634921$export$45e68d450757a753 = (0, $apqRF.createEntry)((0, $9f7d0d5c14b9d6eb$export$cd3fc26cf9f696e6), {
    component: $6c41e52c48634921$export$2e0968e4c0408481,
    layout: (0, $dVvIP.globalLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $6c41e52c48634921$export$bcbb38b3c86dba1f
    ],
    ufoName: 'project-archived'
});



var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7hF3Y = parcelRequire("7hF3Y");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $exb0h = parcelRequire("exb0h");
const $2b15d28b70731665$export$b60634d0fa43f719 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).ARCHIVED_PROJECTS_DIRECTORY,
    path: '/jira/settings/projects/archive',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $8c252442fd261df5$export$b220ffb582ee39aa = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("fvgG5"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/archived-projects/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8c252442fd261df5$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $8c252442fd261df5$export$b220ffb582ee39aa,
        pageId: "archived-projects",
        shouldShowSpinner: true
    });


const $ec5f66b3062a483b$export$dc5f9e3c3931cc36 = (0, $apqRF.createEntry)((0, $2b15d28b70731665$export$b60634d0fa43f719), {
    component: (0, $8c252442fd261df5$export$2e2bcd8739ae039),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7hF3Y.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $8c252442fd261df5$export$b220ffb582ee39aa)
    ],
    ufoName: 'admin.archived-projects'
});



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $cernH = parcelRequire("cernH");

var $bAQOb = parcelRequire("bAQOb");

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");

var $iOOlt = parcelRequire("iOOlt");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $14ec04bccc11883f$export$1bfee70ca366d995 = {
    group: (0, $exb0h.ROUTE_GROUPS).ARCHIVE_ISSUES,
    name: (0, $exb0h.ROUTE_NAMES).ARCHIVED_ISSUES_DIRECTORY,
    path: '/jira/issues/archive',
    exact: true
};



var $dgH3j = parcelRequire("dgH3j");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $26cd51f541672008$export$5cb97f431a00807d = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("ElQSF")).then(({ JiraIssuesArchive: JiraIssuesArchive })=>JiraIssuesArchive)), {
    moduleId: "./src/packages/spa-apps/archives/src/index.tsx"
});
const $26cd51f541672008$export$b8f3c7276fe36123 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $26cd51f541672008$export$5cb97f431a00807d,
        pageId: "spa-apps/archives",
        shouldShowSpinner: true
    });
const $26cd51f541672008$export$f7d3667678a21360 = (0, $apqRF.createEntry)((0, $14ec04bccc11883f$export$1bfee70ca366d995), {
    component: (0, $bAQOb.componentWithFF)('issues-archive-route_a4t84', $26cd51f541672008$export$b8f3c7276fe36123, (0, $dgH3j.default)),
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iOOlt.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $26cd51f541672008$export$5cb97f431a00807d
    ]
});



var $cernH = parcelRequire("cernH");

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $l90Gp = parcelRequire("l90Gp");
var $cbmC6 = parcelRequire("cbmC6");
var $kXWpU = parcelRequire("kXWpU");
var $eJCK9 = parcelRequire("eJCK9");

var $5w4hM = parcelRequire("5w4hM");

var $apqRF = parcelRequire("apqRF");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $ixwgj = parcelRequire("ixwgj");

var $hRe6W = parcelRequire("hRe6W");

var $fXKgc = parcelRequire("fXKgc");

var $4mBNF = parcelRequire("4mBNF");
const $4adee587f623ba77$export$c4cf7264f95bae78 = ()=>[
        (0, $ixwgj.projectContextResource),
        (0, $l90Gp.forgeProjectModuleResource),
        (0, $eJCK9.staticSidebarShortcutsResource),
        (0, $kXWpU.staticProjectSidebarNavigationResource),
        (0, $cbmC6.staticProjectSidebarConnectAddonsNavigationResource)
    ];
const $4adee587f623ba77$export$f9891419b34ab305 = (0, $apqRF.createEntry)((0, $fXKgc.browseProjectRedirectRoute), {
    component: (0, $4mBNF.RedirectToLastVisitedProjectPage),
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationResources)(),
        ...$4adee587f623ba77$export$c4cf7264f95bae78(),
        (0, $hRe6W.queuesNavigationItems),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation)
    ]
});



var $cernH = parcelRequire("cernH");

var $b3nmi = parcelRequire("b3nmi");

var $7rh0R = parcelRequire("7rh0R");

var $7ZZxN = parcelRequire("7ZZxN");

var $8QAGR = parcelRequire("8QAGR");

var $isbb2 = parcelRequire("isbb2");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5261aeeed823e572$var$Onboarding = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("8xpnS")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/business-project-layout/src/ui/onboarding/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5261aeeed823e572$var$withAnyBusinessProjectContext = (Component)=>(0, $isbb2.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $7ZZxN.CORE_PROJECT)
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5261aeeed823e572$var$RightSidebars = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("cHLvR")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/business-project-layout/src/ui/right-sidebars/index.tsx"
});
const $5261aeeed823e572$var$BusinessOnboarding = $5261aeeed823e572$var$withAnyBusinessProjectContext($5261aeeed823e572$var$Onboarding);
const $5261aeeed823e572$var$nonSettingsRightSidebars = [
    $5261aeeed823e572$var$withAnyBusinessProjectContext($5261aeeed823e572$var$RightSidebars)
];
const $5261aeeed823e572$var$sharedBusinessProjectLayout = (0, $isbb2.composeLayouts)((0, $8QAGR.projectLayout));
const $5261aeeed823e572$export$dfb0c3e0348f4429 = (0, $isbb2.composeLayouts)($5261aeeed823e572$var$sharedBusinessProjectLayout, {
    rightSidebars: $5261aeeed823e572$var$nonSettingsRightSidebars,
    globalComponents: [
        $5261aeeed823e572$var$BusinessOnboarding
    ]
});



var $7IBv4 = parcelRequire("7IBv4");

var $isbb2 = parcelRequire("isbb2");
const $eaa6d448b27830ba$export$17e73ed8c35891cb = (0, $isbb2.createLayout)({
    isChromeless: true
});



var $1ybV0 = parcelRequire("1ybV0");

var $dVvIP = parcelRequire("dVvIP");

var $7vTKl = parcelRequire("7vTKl");

var $buaC1 = parcelRequire("buaC1");

var $apqRF = parcelRequire("apqRF");

var $cOkcY = parcelRequire("cOkcY");

var $4qvmP = parcelRequire("4qvmP");

var $XJw0F = parcelRequire("XJw0F");

var $dIJG1 = parcelRequire("dIJG1");

var $hHrVM = parcelRequire("hHrVM");

var $ixwgj = parcelRequire("ixwgj");

var $cernH = parcelRequire("cernH");

var $b3nmi = parcelRequire("b3nmi");


var $7IBv4 = parcelRequire("7IBv4");

var $7rh0R = parcelRequire("7rh0R");

var $isbb2 = parcelRequire("isbb2");

var $kJlBc = parcelRequire("kJlBc");var $24f5ba83790d3f65$exports = {};
"use strict";

var $dtAl9 = parcelRequire("dtAl9");
Object.defineProperty($24f5ba83790d3f65$exports, "__esModule", {
    value: true
});
$24f5ba83790d3f65$exports["default"] = void 0;

var $24f5ba83790d3f65$var$_defineProperty2 = $dtAl9((parcelRequire("1D56o")));

var $24f5ba83790d3f65$var$_slicedToArray2 = $dtAl9((parcelRequire("6NwXI")));
function $24f5ba83790d3f65$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $24f5ba83790d3f65$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $24f5ba83790d3f65$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $24f5ba83790d3f65$var$_defineProperty2["default"])(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $24f5ba83790d3f65$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * Matches `queryStr` against config stored in `queryConfig`.
 *
 * Returns `pathMatch` with an additional query prop with query params if the match succeeds,
 * otherwise returns null.
 *
 */ function $24f5ba83790d3f65$var$matchQuery(queryConfig, queryParams, pathMatch) {
    var queryMatch = {};
    var isMatchingQuery = queryConfig.every(function(query) {
        // eslint-disable-next-line prefer-const
        var _query$split = query.split('='), _query$split2 = (0, $24f5ba83790d3f65$var$_slicedToArray2["default"])(_query$split, 2), names = _query$split2[0], value = _query$split2[1];
        var negation = false;
        /* Check if negative matching query param (eg 'foo!=1') */ if (query.includes('!=')) {
            names = names.substring(0, names.length - 1);
            negation = true;
        }
        /* Allow alternate query params presence (eg 'foo|bar') */ var matched = names.split('|').map(function(name) {
            var isOptional = false;
            /* Check if optional query param (eg 'foo?') */ if (name.includes('?')) {
                // eslint-disable-next-line no-param-reassign
                name = name.substring(0, name.length - 1);
                isOptional = true;
            }
            /* First check if queryParams contains the relevant param */ var match = Object.prototype.hasOwnProperty.call(queryParams, name);
            /* Save actual value so we expose it as part of match object */ if (match) queryMatch[name] = queryParams[name] || '';
            /* If no value matching required or it is optional and the param is missing */ if (!value || isOptional && !match) return isOptional || match;
            if (value.startsWith('(')) /* Handle value being a regexp eg 's=(\\d+)' */ match = new RegExp("^".concat(value, "$")).test(queryParams[name] || '');
            else /* Handle value exact matching eg 's=123' */ match = queryParams[name] === value;
            return negation ? !match : match;
        });
        /* If at least one of alternate query params matches then it is a match */ return matched.includes(true);
    });
    return isMatchingQuery ? $24f5ba83790d3f65$var$_objectSpread($24f5ba83790d3f65$var$_objectSpread({}, pathMatch), {}, {
        query: queryMatch
    }) : null;
}
var $24f5ba83790d3f65$var$_default = $24f5ba83790d3f65$var$matchQuery;
$24f5ba83790d3f65$exports["default"] = $24f5ba83790d3f65$var$_default;



var $dY715 = parcelRequire("dY715");


const $71b4a5d883bcbfff$var$imports = {
    fullPage: ()=>(0, $dY715.markAsBentoBundleReady)((parcelRequire("kpDPI"))),
    embedded: ()=>(0, $dY715.markAsBentoBundleReady)((parcelRequire("f4xMV")))
};

const $71b4a5d883bcbfff$var$PrefetchCBBResourcesComponent = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("lDWhn")), {
    moduleId: "./src/packages/router-resources/classic-projects/src/services/prefetch-wrm-bundle/index.tsx"
});
// We can start the evaluation at module level if we ran the component in SSR
// This needs to be an empty string because the router breaks if it's null or undefined
let $71b4a5d883bcbfff$var$serverIssuePreloadIdentifier = '';
if (!false && window.SPA_STATE?.serverIssuePreload) {
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly fullPage: () => Promise<typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/spa-apps/issue/src/index")>; readonly embedded: () => Promise<...>; }'.
    const importSupplier = $71b4a5d883bcbfff$var$imports[window.SPA_STATE.serverIssuePreload];
    importSupplier && importSupplier();
}
const $71b4a5d883bcbfff$var$ISSUE_PRELOAD_COMPONENT_MARK = 'IssuePreloadComponent:rendered';
const $71b4a5d883bcbfff$var$useParamsSelector = (0, $kJlBc.createRouterSelector)((state)=>({
        query: state.query,
        params: state.match.params
    }));
const $71b4a5d883bcbfff$var$IssuePreloadComponentBuilder = // @ts-expect-error - TS7006 - Parameter 'preloadSupplier' implicitly has an 'any' type.
(identifier, preloadSupplier, preloadContract)=>()=>{
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { query: query, params: params } = $71b4a5d883bcbfff$var$useParamsSelector();
        if (// If we have an undefined contract, assume we want to preload
        !preloadContract || // Preload if we match the contract
        preloadContract.some((preloadingMatch)=>// Match query with router function
            // @ts-expect-error - TS2554 - Expected 3 arguments, but got 2.
            (!preloadingMatch.query || (0, (/*@__PURE__*/$parcel$interopDefault($24f5ba83790d3f65$exports)))(preloadingMatch.query, query)) && // Match path params with simple object structure, where if value is undefined
            // we assume we match all values
            (!preloadingMatch.params || preloadingMatch.params.every(({ key: key, value: value })=>params && params[key] !== undefined && (value === undefined || params[key] === value))))) {
            if (!false) preloadSupplier();
            if (false) $71b4a5d883bcbfff$var$serverIssuePreloadIdentifier = identifier;
            else performance.mark($71b4a5d883bcbfff$var$ISSUE_PRELOAD_COMPONENT_MARK);
        }
        return null;
    };
const $71b4a5d883bcbfff$export$f55e6973062dc859 = ()=>$71b4a5d883bcbfff$var$serverIssuePreloadIdentifier;
const $71b4a5d883bcbfff$var$FullPageIssuePreloadComponent = $71b4a5d883bcbfff$var$IssuePreloadComponentBuilder('fullPage', $71b4a5d883bcbfff$var$imports.fullPage);
// @ts-expect-error - TS2339 - Property 'displayName' does not exist on type '() => null'.
$71b4a5d883bcbfff$var$FullPageIssuePreloadComponent.displayName = 'FullPageIssuePreloadComponent';
const $71b4a5d883bcbfff$export$98e337c40eb151da = (0, $isbb2.createLayout)({
    globalComponents: [
        $71b4a5d883bcbfff$var$FullPageIssuePreloadComponent,
        $71b4a5d883bcbfff$var$PrefetchCBBResourcesComponent
    ]
});
const $71b4a5d883bcbfff$export$7b113174a456921a = (preloadContract)=>{
    const EmbeddedIssuePreloadComponent = $71b4a5d883bcbfff$var$IssuePreloadComponentBuilder('embedded', $71b4a5d883bcbfff$var$imports.embedded, preloadContract);
    // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type '() => null'.
    EmbeddedIssuePreloadComponent.displayName = 'EmbeddedIssuePreloadComponent';
    return (0, $isbb2.createLayout)({
        globalComponents: [
            EmbeddedIssuePreloadComponent
        ]
    });
};



var $7vTKl = parcelRequire("7vTKl");

var $buaC1 = parcelRequire("buaC1");

var $isbb2 = parcelRequire("isbb2");

var $apqRF = parcelRequire("apqRF");

var $cOkcY = parcelRequire("cOkcY");

var $4qvmP = parcelRequire("4qvmP");

var $exb0h = parcelRequire("exb0h");
const $fe478ca0578dbdc3$export$14a5cbbd7e1e2dc2 = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_BUSINESS,
    name: (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_BOARD,
    ufoName: 'jwm.jwm-board',
    exact: true,
    path: '/jira/core/projects/:projectKey/board',
    query: [
        'issue-key?'
    ]
};



var $7rh0R = parcelRequire("7rh0R");

const $56906cb72fe2b2c4$export$8c70dcc4643464f8 = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("f4xMV")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $b4e22da15c12b0bc$export$d663c6b2156921dd = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("iVTCY")), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/business/board/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b4e22da15c12b0bc$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $b4e22da15c12b0bc$export$d663c6b2156921dd,
        pageId: "async-business-board",
        shouldShowSpinner: true
    });


const $b07feb5e6e1164ae$export$c7fe0dd4417407a0 = (0, $apqRF.createEntry)((0, $fe478ca0578dbdc3$export$14a5cbbd7e1e2dc2), {
    component: (0, $b4e22da15c12b0bc$export$2e2bcd8739ae039),
    layout: (0, $isbb2.composeLayouts)((0, $5261aeeed823e572$export$dfb0c3e0348f4429), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
        {
            query: [
                'issue-key'
            ]
        }
    ])),
    skeleton: (0, $7IBv4.ThemedLazySkeleton),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $buaC1.default),
        horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
    },
    resources: [
        ...(0, $4qvmP.getProjectViewResources)(),
        (0, $cOkcY.workflowIssuesResourceWithCondition),
        (0, $cOkcY.workflowIssuesResourceEarlyFetchWithCondition)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $b4e22da15c12b0bc$export$d663c6b2156921dd)
    ],
    afterPaint: [
        (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
    ],
    preloadOptions: {
        earlyChunks: [
            'business-board-early-entry'
        ]
    }
});



var $cernH = parcelRequire("cernH");

var $b3nmi = parcelRequire("b3nmi");


var $7vTKl = parcelRequire("7vTKl");

var $buaC1 = parcelRequire("buaC1");

var $apqRF = parcelRequire("apqRF");

var $4qvmP = parcelRequire("4qvmP");

var $6wsEw = parcelRequire("6wsEw");

var $4mBNF = parcelRequire("4mBNF");

var $eUqFw = parcelRequire("eUqFw");

var $kJlBc = parcelRequire("kJlBc");

var $atRHQ = parcelRequire("atRHQ");
const $17f93ffb3c053efc$var$OverviewRedirect = ()=>{
    const [overviewId] = (0, $kJlBc.usePathParam)('overviewId');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
        to: `/jira/core/overviews/${overviewId}/summary`
    });
};
var $17f93ffb3c053efc$export$2e2bcd8739ae039 = $17f93ffb3c053efc$var$OverviewRedirect;


const $946b535f25881faf$export$766e305da4c78de5 = (0, $apqRF.createEntry)((0, $6wsEw.jiraBusinessProjectRedirectRoute), {
    component: (0, $4mBNF.RedirectToLastVisitedProjectPage),
    layout: (0, $5261aeeed823e572$export$dfb0c3e0348f4429),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $buaC1.default),
        horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
    },
    resources: (0, $4qvmP.getProjectViewResources)(),
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation)
    ]
});
const $946b535f25881faf$export$3aa9116f715693e1 = (0, $apqRF.createEntry)((0, $6wsEw.jiraBusinessOverviewRedirectRoute), {
    component: (0, $17f93ffb3c053efc$export$2e2bcd8739ae039),
    layout: (0, $5261aeeed823e572$export$dfb0c3e0348f4429),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $buaC1.default),
        horizontal: (0, $b3nmi.AsyncHorizontalOverviewNav)
    },
    resources: (0, $4qvmP.getOverviewViewResources)(),
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation)
    ]
});



var $exb0h = parcelRequire("exb0h");
const $6bd52bd1c3447829$export$3008bdf5c6ced894 = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_BUSINESS,
    name: (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_SUMMARY,
    path: '/jira/core/projects/:projectKey/summary',
    exact: true
};
const $6bd52bd1c3447829$export$ba1373c12ea65b4c = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_BUSINESS,
    name: (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_CALENDAR,
    path: '/jira/core/projects/:projectKey/calendar',
    exact: true
};
const $6bd52bd1c3447829$export$2dd4e8a37d8ac978 = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_BUSINESS,
    name: (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_SHORTCUT,
    path: '/jira/core/projects/:projectKey/shortcuts',
    exact: true
};
const $6bd52bd1c3447829$export$f1e14ce95022c93a = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_BUSINESS,
    name: (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_LIST,
    path: '/jira/core/projects/:projectKey/list',
    exact: true
};
const $6bd52bd1c3447829$export$e98776bdf96c88ac = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_BUSINESS,
    name: (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_FORM,
    path: '/jira/core/projects/:projectKey/form',
    exact: true
};
const $6bd52bd1c3447829$export$3cd93ff55b29f07f = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_BUSINESS,
    name: (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT,
    path: '/jira/core/projects/:projectKey/form/:formId',
    exact: true
};
const $6bd52bd1c3447829$export$5f684808e671de5 = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_BUSINESS,
    name: (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_FORM_BUILDER,
    path: '/jira/core/projects/:projectKey/form/:formId/builder',
    exact: true
};
const $6bd52bd1c3447829$export$4301c67fd317894a = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_BUSINESS,
    name: (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_TIMELINE,
    path: '/jira/core/projects/:projectKey/timeline',
    exact: true
};
const $6bd52bd1c3447829$export$3109a183a442a02d = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_BUSINESS,
    name: (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_APPROVALS,
    path: '/jira/core/projects/:projectKey/approvals',
    exact: true
};
const $6bd52bd1c3447829$export$54a218ca6d1c056a = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_BUSINESS,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_PAGES,
    path: '/jira/core/projects/:projectKey/pages'
};
const $6bd52bd1c3447829$export$2d0c5d5ce5a00c = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_BUSINESS,
    name: (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_ATTACHMENTS,
    path: '/jira/core/projects/:projectKey/attachments'
};
const $6bd52bd1c3447829$export$fb814f9911fc766e = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_BUSINESS,
    name: (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_TIMELINE_EMBED,
    path: '/jira/core/projects/:projectKey/timeline/embed',
    exact: true
};
const $6bd52bd1c3447829$export$e237859f2fc7cc7 = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_BUSINESS,
    name: (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_CALENDAR_EMBED,
    path: '/jira/core/projects/:projectKey/calendar/embed',
    exact: true
};
const $6bd52bd1c3447829$export$f0d33cf104c15274 = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_BUSINESS,
    name: (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_LIST_EMBED,
    path: '/jira/core/projects/:projectKey/list/embed',
    exact: true
};
const $6bd52bd1c3447829$export$7d6a91d85236417 = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_BUSINESS,
    name: (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_BOARD_EMBED,
    path: '/jira/core/projects/:projectKey/board/embed',
    exact: true
};
const $6bd52bd1c3447829$export$7e8fd15fdfa29385 = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_BUSINESS,
    name: (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT_EMBED,
    path: '/jira/core/projects/:projectKey/form/:formId/embed',
    exact: true
};
const $6bd52bd1c3447829$export$13164dbb379620e2 = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_BUSINESS,
    name: (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_SUMMARY_EMBED,
    path: '/jira/core/projects/:projectKey/summary/embed',
    exact: true
};
const $6bd52bd1c3447829$export$cd9c218d7c968d2d = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_BUSINESS,
    name: (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_SAMPLE_ONBOARDING,
    path: '/jira/core/sample/onboarding/:taskId',
    exact: true
};
const $6bd52bd1c3447829$export$13f0c823ff3059c2 = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_BUSINESS,
    name: (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_OVERVIEW_TIMELINE,
    path: '/jira/core/overviews/:overviewId/timeline',
    exact: true
};
const $6bd52bd1c3447829$export$61383e5418d2ffe3 = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_BUSINESS,
    name: (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_OVERVIEW_CALENDAR,
    path: '/jira/core/overviews/:overviewId/calendar',
    exact: true
};
const $6bd52bd1c3447829$export$4a86e6b12ce49af9 = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_BUSINESS,
    name: (0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_OVERVIEW_SUMMARY,
    path: '/jira/core/overviews/:overviewId/summary',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $4132dbcc62d1b4af$export$70abf918dfb890e = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("aK25G")), {
    moduleId: "./src/packages/spa-apps/business/approvals/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4132dbcc62d1b4af$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $4132dbcc62d1b4af$export$70abf918dfb890e,
        pageId: "async-business-approvals",
        shouldShowSpinner: true
    });




var $7vTKl = parcelRequire("7vTKl");

var $1ybV0 = parcelRequire("1ybV0");

var $hI8Vl = parcelRequire("hI8Vl");

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $ec31f7e83335bf8b$export$d94bafd9d893ec98 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("btM71")), {
        moduleId: "26a1d436"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        // This entry point should only load in this route
        // once overview is supported by backend, we should have a different entry point for it
        const { projectKey: projectKey } = context.match.params;
        if (!projectKey) throw new Error('projectKey is required');
        return {
            queries: {
                jwmAttachmentsQuery: {
                    parameters: $hI8Vl.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: [
                            projectKey
                        ],
                        issueSearchInput: {
                            jql: `attachments IS NOT NULL AND project = '${projectKey}' ORDER BY Rank ASC`
                        },
                        filters: {
                            fileName: '',
                            authorIds: [],
                            mimeTypes: [],
                            dateRange: {
                                before: undefined,
                                after: undefined
                            }
                        },
                        durationInSeconds: 900,
                        maxTokenLength: 65534,
                        count: 20,
                        attachmentCount: 100,
                        isAttachmentsM2Enabled: (0, $1ybV0.ff)('jwm-attachments-m2')
                    },
                    options: {
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        fetchPolicy: 'network-only'
                    }
                }
            },
            entryPoints: {},
            extraProps: {}
        };
    }
});


const $f1e3ab5e6207f9e3$export$d2dbce06a31f0f47 = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $ec31f7e83335bf8b$export$d94bafd9d893ec98),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $bf03a688d4ae0a15$export$a21a9228b9e68b40 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("kI9SR")), {
    moduleId: "./src/packages/spa-apps/business/board-embed/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bf03a688d4ae0a15$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $bf03a688d4ae0a15$export$a21a9228b9e68b40,
        pageId: "async-business-board-embed",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");


var $7vTKl = parcelRequire("7vTKl");

var $1ybV0 = parcelRequire("1ybV0");


var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");
function $248baf63f84828c0$var$toMidnightUTCString(date) {
    const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    return new Date(utcMilliseconds).toISOString();
}
function $248baf63f84828c0$var$toDate(date) {
    if (!date) return new Date();
    try {
        const _date = new Date(date);
        return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
    } catch (e) {
        return new Date();
    }
}
function $248baf63f84828c0$var$createScope({ context: context }) {
    return {
        type: 'project',
        projectKeys: [
            String(context.match.params.projectKey)
        ]
    };
}
function $248baf63f84828c0$var$buildScopeInput({ tenantContext: tenantContext }, scope) {
    const { cloudId: cloudId } = tenantContext;
    return {
        projectKeys: {
            cloudId: cloudId,
            keys: scope.projectKeys
        }
    };
}
function $248baf63f84828c0$var$toViewMode(mode) {
    switch(mode){
        case 'week':
            return 'WEEK';
        case 'day':
            return 'DAY';
        default:
            return 'MONTH';
    }
}
function $248baf63f84828c0$var$toWeekStart(weekStart) {
    switch(weekStart){
        case 'monday':
            return 'MONDAY';
        case 'saturday':
            return 'SATURDAY';
        default:
            return 'SUNDAY';
    }
}
function $248baf63f84828c0$var$buildConfigurationInput({ selectedDate: selectedDate, viewMode: viewMode, weekStartsOn: weekStartsOn, startDateField: startDateField, endDateField: endDateField }) {
    return {
        date: $248baf63f84828c0$var$toMidnightUTCString(selectedDate),
        mode: $248baf63f84828c0$var$toViewMode(viewMode),
        weekStart: $248baf63f84828c0$var$toWeekStart(weekStartsOn),
        startDateField: startDateField,
        endDateField: endDateField
    };
}
function $248baf63f84828c0$var$buildIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}
function $248baf63f84828c0$var$buildUnscheduledIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}

const $248baf63f84828c0$export$19cf4b398f638dc6 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("aziM1")), {
        moduleId: "70b39bf1"
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
        const { cloudId: cloudId } = tenantContext;
        const scope = $248baf63f84828c0$var$createScope(entryPointRouteParams);
        const { date: date } = context.query;
        const selectedDate = $248baf63f84828c0$var$toDate(date);
        const projectKey = String(context.match.params.projectKey);
        const viewMode = 'month';
        const weekStartsOn = 'sunday';
        const startDateField = 'startdate';
        const endDateField = 'duedate';
        const issueEventFields = {
            startDateField: startDateField,
            endDateField: endDateField
        };
        return {
            queries: {
                calendarData: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $ae4d1c21cb10f5ab$export$2e2bcd8739ae039,
                    variables: {
                        cloudId: cloudId,
                        projectKey: // @deprecated to be clean up via jsw-adopt-schedule-calendar-issue-mutation_9u2rq feature flag
                        projectKey,
                        boardAri: '',
                        scopeInput: $248baf63f84828c0$var$buildScopeInput(entryPointRouteParams, scope),
                        configurationInput: $248baf63f84828c0$var$buildConfigurationInput({
                            selectedDate: selectedDate,
                            viewMode: viewMode,
                            weekStartsOn: weekStartsOn,
                            startDateField: startDateField,
                            endDateField: endDateField
                        }),
                        issuesSearchInput: $248baf63f84828c0$var$buildIssuesSearchInput(),
                        unscheduledIssuesSearchInput: $248baf63f84828c0$var$buildUnscheduledIssuesSearchInput(),
                        versionsSearchInput: null,
                        sprintsSearchInput: null,
                        skipSprintSearch: true,
                        skipVersionSearch: true,
                        jswmoonSsdReleaseFlyoutUpdateEnabled: (0, $1ybV0.ff)('jswmoon_ssd_release_flyout_update')
                    }
                }
            },
            entryPoints: {},
            extraProps: {
                scope: scope,
                selectedDate: selectedDate,
                viewMode: viewMode,
                weekStartsOn: weekStartsOn,
                issueEventFields: issueEventFields,
                projectKey: projectKey
            }
        };
    }
});



var $59o4i = parcelRequire("59o4i");
const $1dfd46eba238fb8d$export$a3db41da3fd3ff21 = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $248baf63f84828c0$export$19cf4b398f638dc6),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});

const $1dfd46eba238fb8d$export$ebca96bcc4698ee2 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("jj3FZ")), {
    moduleId: "./src/packages/spa-apps/business/calendar/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1dfd46eba238fb8d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $1dfd46eba238fb8d$export$ebca96bcc4698ee2,
        pageId: "async-business-calendar",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");



var $59o4i = parcelRequire("59o4i");
const $02b84759ee5d4ba1$export$146b7e01aca9816a = (0, $bf010c1b73a0efa7$export$56ea489e9d4bfa04)({
    main: (0, $248baf63f84828c0$export$19cf4b398f638dc6)
});

const $02b84759ee5d4ba1$export$152b9e0029b084e8 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("28Vhs")), {
    moduleId: "./src/packages/spa-apps/business/calendar-embed/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$02b84759ee5d4ba1$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $02b84759ee5d4ba1$export$152b9e0029b084e8,
        pageId: "async-business-calendar-embed",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $a1f16c40e224e100$export$240a58749ebba091 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("9H20x")), {
    moduleId: "./src/packages/spa-apps/business/form/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a1f16c40e224e100$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $a1f16c40e224e100$export$240a58749ebba091,
        pageId: "async-business-form",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $426c8094dec08e01$export$2076234d7fde1717 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("03eMy")), {
    moduleId: "./src/packages/spa-apps/business/form-builder/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$426c8094dec08e01$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $426c8094dec08e01$export$2076234d7fde1717,
        pageId: "async-business-form-builder",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $acbeef93bd66459b$export$258fcd204933dd75 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("lBxZN")), {
    moduleId: "./src/packages/spa-apps/business/form-submit/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$acbeef93bd66459b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $acbeef93bd66459b$export$258fcd204933dd75,
        pageId: "async-business-form-submit",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $97f2610e0a5d3593$export$4d2f42d18d020964 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("vHoGQ")), {
    moduleId: "./src/packages/spa-apps/business/form-submit-embed/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$97f2610e0a5d3593$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $97f2610e0a5d3593$export$4d2f42d18d020964,
        pageId: "async-business-form-submit-embed",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $569b2a77b8dc04fe$export$4bfa19c758c39608 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("4N0Mz")), {
    moduleId: "./src/packages/spa-apps/business/list/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$569b2a77b8dc04fe$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $569b2a77b8dc04fe$export$4bfa19c758c39608,
        pageId: "async-business-list",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $eb4cc28210026408$export$55704f3c7b8c3364 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("ks5p8")), {
    moduleId: "./src/packages/spa-apps/business/list-embed/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$eb4cc28210026408$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $eb4cc28210026408$export$55704f3c7b8c3364,
        pageId: "async-business-list-embed",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $9642da6d5fe405a8$export$5b8a69e38f82df6c = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("8mEC5")), {
    moduleId: "./src/packages/spa-apps/business/overview-calendar/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9642da6d5fe405a8$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $9642da6d5fe405a8$export$5b8a69e38f82df6c,
        pageId: "async-business-overview-calendar",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $3f0884381628f57d$export$125428653f4abe07 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("2VCTb")), {
    moduleId: "./src/packages/spa-apps/business/overview-summary/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3f0884381628f57d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $3f0884381628f57d$export$125428653f4abe07,
        pageId: "async-business-overview-summary",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $000469bfe10be32c$export$bfea8be13da0d217 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("h1FS4")), {
    moduleId: "./src/packages/spa-apps/business/overview-timeline/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$000469bfe10be32c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $000469bfe10be32c$export$bfea8be13da0d217,
        pageId: "async-business-overview-timeline",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");
var $3HCkE = parcelRequire("3HCkE");

var $ixwgj = parcelRequire("ixwgj");

var $78d1w = parcelRequire("78d1w");
const $ca2e025803a80923$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $kJlBc.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $jMP2a.fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, $bFzGY.useAnalyticsEvents), useResource: useResource = (0, $3HCkE.useResource), useRouter: useRouter = (0, $kJlBc.useRouter), useSpaStateTransition: useSpaStateTransition = (0, $78d1w.useSpaStateTransition) })=>{
    const [{ match: match, query: query, route: route }] = useRouter();
    const { data: data } = useResource((0, $ixwgj.projectContextResource));
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $eUqFw.useRef)(createAnalyticsEvent({}));
    (0, $eUqFw.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $7ZZxN.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $7ZZxN.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};



const $e0839b7a0543fee8$export$c2115a649411f570 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("hZKR7"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/business/pages/src/index.tsx"
});
const $e0839b7a0543fee8$export$7c3b1828ada63555 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ca2e025803a80923$export$8a3df560509448b8), {
        page: "/pages"
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e0839b7a0543fee8$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e0839b7a0543fee8$export$c2115a649411f570,
        pageId: "async-business-pages",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $5e139ca1bb32ee03$export$e39375ab6521f3ef = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("hUgt3")), {
    moduleId: "./src/packages/spa-apps/business/sample-onboarding/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5e139ca1bb32ee03$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $5e139ca1bb32ee03$export$e39375ab6521f3ef,
        pageId: "async-business-sample-onboarding",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $91b86a7bc97ab47f$export$dfbcb99b55c05486 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("a5x9l")), {
    moduleId: "./src/packages/spa-apps/business/shortcut/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$91b86a7bc97ab47f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $91b86a7bc97ab47f$export$dfbcb99b55c05486,
        pageId: "async-business-shortcuts",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $7577dd410884db12$export$68c09444cc6f2843 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("intl4")), {
    moduleId: "./src/packages/spa-apps/business/summary/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7577dd410884db12$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7577dd410884db12$export$68c09444cc6f2843,
        pageId: "async-business-summary",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $2f2c03b70635264e$export$a860d403525d69a5 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("7iHNh")), {
    moduleId: "./src/packages/spa-apps/business/summary-embed/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2f2c03b70635264e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $2f2c03b70635264e$export$a860d403525d69a5,
        pageId: "async-business-summary-embed",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $219dcd90129280be$export$5ae50f261c16f52a = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("bFA4H")), {
    moduleId: "./src/packages/spa-apps/business/timeline/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$219dcd90129280be$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $219dcd90129280be$export$5ae50f261c16f52a,
        pageId: "async-business-timeline",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $2ad32d4b4510de44$export$49e7774ce1be17a4 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("5jdjj")), {
    moduleId: "./src/packages/spa-apps/business/timeline-embed/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2ad32d4b4510de44$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $2ad32d4b4510de44$export$49e7774ce1be17a4,
        pageId: "async-business-timeline-embed",
        shouldShowSpinner: true
    });


const $eb281330981e8e67$export$fb2091db9e7f9102 = [
    (0, $apqRF.createEntry)((0, $6bd52bd1c3447829$export$3008bdf5c6ced894), {
        ufoName: 'jwm.summary-view',
        component: (0, $7577dd410884db12$export$2e2bcd8739ae039),
        layout: (0, $5261aeeed823e572$export$dfb0c3e0348f4429),
        skeleton: (0, $7IBv4.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $buaC1.default),
            horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
        },
        resources: [
            ...(0, $4qvmP.getProjectViewResources)(),
            (0, $dIJG1.summaryDataResource),
            (0, $XJw0F.activityFeedResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7577dd410884db12$export$68c09444cc6f2843)
        ]
    }),
    (0, $b07feb5e6e1164ae$export$c7fe0dd4417407a0),
    (0, $apqRF.createEntry)((0, $6bd52bd1c3447829$export$e237859f2fc7cc7), {
        ufoName: 'jwm.calendar-embed-view',
        component: (0, $02b84759ee5d4ba1$export$2e2bcd8739ae039),
        entryPoint () {
            return (0, $1ybV0.ff)('jwm.calendar-view-entry-point') ? (0, $02b84759ee5d4ba1$export$146b7e01aca9816a) : undefined;
        },
        layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
        skeleton: (0, $7IBv4.ThemedLazySkeleton),
        resources: (0, $4qvmP.getProjectViewResources)(),
        forPaint: [
            (0, $02b84759ee5d4ba1$export$152b9e0029b084e8)
        ]
    }),
    (0, $apqRF.createEntry)((0, $6bd52bd1c3447829$export$ba1373c12ea65b4c), {
        ufoName: 'jwm.calendar-view',
        component: (0, $1dfd46eba238fb8d$export$2e2bcd8739ae039),
        entryPoint () {
            return (0, $1ybV0.ff)('jwm.calendar-view-entry-point') ? (0, $1dfd46eba238fb8d$export$a3db41da3fd3ff21) : undefined;
        },
        layout: (0, $5261aeeed823e572$export$dfb0c3e0348f4429),
        skeleton: (0, $7IBv4.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $buaC1.default),
            horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
        },
        resources: (0, $4qvmP.getProjectViewResources)(),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $1dfd46eba238fb8d$export$ebca96bcc4698ee2)
        ]
    }),
    (0, $apqRF.createEntry)((0, $6bd52bd1c3447829$export$2dd4e8a37d8ac978), {
        component: (0, $91b86a7bc97ab47f$export$2e2bcd8739ae039),
        layout: (0, $5261aeeed823e572$export$dfb0c3e0348f4429),
        skeleton: (0, $7IBv4.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $buaC1.default),
            horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
        },
        resources: (0, $4qvmP.getProjectViewResources)(),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $91b86a7bc97ab47f$export$dfbcb99b55c05486)
        ]
    }),
    (0, $apqRF.createEntry)((0, $6bd52bd1c3447829$export$f1e14ce95022c93a), {
        ufoName: 'jwm.list-view',
        component: (0, $569b2a77b8dc04fe$export$2e2bcd8739ae039),
        layout: (0, $5261aeeed823e572$export$dfb0c3e0348f4429),
        skeleton: (0, $7IBv4.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $buaC1.default),
            horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
        },
        resources: (0, $4qvmP.getProjectViewResources)(),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $569b2a77b8dc04fe$export$4bfa19c758c39608)
        ]
    }),
    (0, $apqRF.createEntry)((0, $6bd52bd1c3447829$export$e98776bdf96c88ac), {
        ufoName: 'jwm.form-directory-view',
        component: (0, $a1f16c40e224e100$export$2e2bcd8739ae039),
        layout: (0, $5261aeeed823e572$export$dfb0c3e0348f4429),
        skeleton: (0, $7IBv4.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $buaC1.default),
            horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
        },
        resources: (0, $4qvmP.getProjectViewResources)(),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $a1f16c40e224e100$export$240a58749ebba091)
        ]
    }),
    (0, $apqRF.createEntry)((0, $6bd52bd1c3447829$export$3cd93ff55b29f07f), {
        ufoName: 'jwm.form-submit-view',
        component: (0, $acbeef93bd66459b$export$2e2bcd8739ae039),
        layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $buaC1.default),
            horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
        },
        resources: (0, $4qvmP.getProjectViewResources)(),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $acbeef93bd66459b$export$258fcd204933dd75)
        ]
    }),
    (0, $apqRF.createEntry)((0, $6bd52bd1c3447829$export$5f684808e671de5), {
        ufoName: 'jwm.form-view',
        component: (0, $426c8094dec08e01$export$2e2bcd8739ae039),
        layout: (0, $5261aeeed823e572$export$dfb0c3e0348f4429),
        skeleton: (0, $7IBv4.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $buaC1.default),
            horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
        },
        resources: (0, $4qvmP.getProjectViewResources)(),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $426c8094dec08e01$export$2076234d7fde1717)
        ]
    }),
    (0, $apqRF.createEntry)((0, $6bd52bd1c3447829$export$4301c67fd317894a), {
        ufoName: 'jwm.timeline-view',
        component: (0, $219dcd90129280be$export$2e2bcd8739ae039),
        layout: (0, $5261aeeed823e572$export$dfb0c3e0348f4429),
        skeleton: (0, $7IBv4.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $buaC1.default),
            horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
        },
        resources: (0, $4qvmP.getProjectViewResources)(),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $219dcd90129280be$export$5ae50f261c16f52a)
        ]
    }),
    (0, $apqRF.createEntry)((0, $6bd52bd1c3447829$export$3109a183a442a02d), {
        ufoName: 'jwm.approvals-view',
        component: (0, $4132dbcc62d1b4af$export$2e2bcd8739ae039),
        layout: (0, $5261aeeed823e572$export$dfb0c3e0348f4429),
        skeleton: (0, $7IBv4.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $buaC1.default),
            horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
        },
        resources: (0, $4qvmP.getProjectViewResources)(),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $4132dbcc62d1b4af$export$70abf918dfb890e)
        ]
    }),
    (0, $apqRF.createEntry)((0, $6bd52bd1c3447829$export$54a218ca6d1c056a), {
        resources: [
            ...(0, $4qvmP.getBusinessProjectResources)(),
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            (0, $ixwgj.projectContextResource)
        ],
        component: (0, $e0839b7a0543fee8$export$2e2bcd8739ae039),
        layout: (0, $5261aeeed823e572$export$dfb0c3e0348f4429),
        skeleton: (0, $7IBv4.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $buaC1.default),
            horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $e0839b7a0543fee8$export$c2115a649411f570)
        ],
        ufoName: 'jwm.jwm-pages'
    }),
    (0, $apqRF.createEntry)((0, $6bd52bd1c3447829$export$2d0c5d5ce5a00c), {
        ufoName: 'jwm.attachments-view',
        layout: (0, $5261aeeed823e572$export$dfb0c3e0348f4429),
        skeleton: (0, $7IBv4.ThemedLazySkeleton),
        entryPoint: ()=>(0, $f1e3ab5e6207f9e3$export$d2dbce06a31f0f47),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $buaC1.default),
            horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
        },
        resources: (0, $4qvmP.getProjectViewResources)()
    }),
    (0, $apqRF.createEntry)((0, $6bd52bd1c3447829$export$fb814f9911fc766e), {
        ufoName: 'jwm.timeline-embed-view',
        component: (0, $2ad32d4b4510de44$export$2e2bcd8739ae039),
        layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
        skeleton: (0, $7IBv4.ThemedLazySkeleton),
        resources: (0, $4qvmP.getProjectViewResources)(),
        forPaint: [
            (0, $2ad32d4b4510de44$export$49e7774ce1be17a4)
        ]
    }),
    (0, $apqRF.createEntry)((0, $6bd52bd1c3447829$export$f0d33cf104c15274), {
        ufoName: 'jwm.list-embed-view',
        component: (0, $eb4cc28210026408$export$2e2bcd8739ae039),
        layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
        skeleton: (0, $7IBv4.ThemedLazySkeleton),
        resources: (0, $4qvmP.getProjectViewResources)(),
        forPaint: [
            (0, $eb4cc28210026408$export$55704f3c7b8c3364)
        ]
    }),
    (0, $apqRF.createEntry)((0, $6bd52bd1c3447829$export$7d6a91d85236417), {
        ufoName: 'jwm.jwm-board-embed',
        component: (0, $bf03a688d4ae0a15$export$2e2bcd8739ae039),
        layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
        skeleton: (0, $7IBv4.ThemedLazySkeleton),
        resources: [
            ...(0, $4qvmP.getProjectViewResources)(),
            (0, $cOkcY.workflowIssuesResourceWithCondition),
            (0, $cOkcY.workflowIssuesResourceEarlyFetchWithCondition)
        ],
        forPaint: [
            (0, $bf03a688d4ae0a15$export$a21a9228b9e68b40)
        ]
    }),
    (0, $apqRF.createEntry)((0, $6bd52bd1c3447829$export$7e8fd15fdfa29385), {
        ufoName: 'jwm.form-submit-embed-view',
        component: (0, $97f2610e0a5d3593$export$2e2bcd8739ae039),
        layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
        skeleton: (0, $7IBv4.ThemedLazySkeleton),
        resources: (0, $4qvmP.getProjectViewResources)(),
        forPaint: [
            (0, $97f2610e0a5d3593$export$4d2f42d18d020964)
        ]
    }),
    (0, $apqRF.createEntry)((0, $6bd52bd1c3447829$export$13164dbb379620e2), {
        ufoName: 'jwm.summary-view-embed',
        component: (0, $2f2c03b70635264e$export$2e2bcd8739ae039),
        layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
        skeleton: (0, $7IBv4.ThemedLazySkeleton),
        resources: [
            ...(0, $4qvmP.getProjectViewResources)(),
            (0, $dIJG1.summaryDataResource),
            (0, $XJw0F.activityFeedResource)
        ],
        forPaint: [
            (0, $2f2c03b70635264e$export$a860d403525d69a5)
        ]
    }),
    (0, $apqRF.createEntry)((0, $6bd52bd1c3447829$export$cd9c218d7c968d2d), {
        component: (0, $5e139ca1bb32ee03$export$2e2bcd8739ae039),
        layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
        skeleton: (0, $7IBv4.ThemedLazySkeleton),
        resources: (0, $hHrVM.getNavigationResources)(),
        forPaint: [
            (0, $5e139ca1bb32ee03$export$e39375ab6521f3ef)
        ]
    }),
    (0, $apqRF.createEntry)((0, $6bd52bd1c3447829$export$13f0c823ff3059c2), {
        component: (0, $000469bfe10be32c$export$2e2bcd8739ae039),
        layout: (0, $dVvIP.globalLayout),
        skeleton: (0, $7IBv4.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $buaC1.default),
            horizontal: (0, $b3nmi.AsyncHorizontalOverviewNav)
        },
        resources: (0, $4qvmP.getOverviewViewResources)(),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $000469bfe10be32c$export$bfea8be13da0d217)
        ]
    }),
    (0, $apqRF.createEntry)((0, $6bd52bd1c3447829$export$61383e5418d2ffe3), {
        component: (0, $9642da6d5fe405a8$export$2e2bcd8739ae039),
        layout: (0, $dVvIP.globalLayout),
        skeleton: (0, $7IBv4.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $buaC1.default),
            horizontal: (0, $b3nmi.AsyncHorizontalOverviewNav)
        },
        resources: (0, $4qvmP.getOverviewViewResources)(),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $9642da6d5fe405a8$export$5b8a69e38f82df6c)
        ]
    }),
    (0, $apqRF.createEntry)((0, $6bd52bd1c3447829$export$4a86e6b12ce49af9), {
        component: (0, $3f0884381628f57d$export$2e2bcd8739ae039),
        layout: (0, $dVvIP.globalLayout),
        skeleton: (0, $7IBv4.ThemedLazySkeleton),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $buaC1.default),
            horizontal: (0, $b3nmi.AsyncHorizontalOverviewNav)
        },
        resources: (0, $4qvmP.getOverviewViewResources)(),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $3f0884381628f57d$export$125428653f4abe07)
        ]
    }),
    (0, $946b535f25881faf$export$766e305da4c78de5),
    (0, $946b535f25881faf$export$3aa9116f715693e1)
];



var $cernH = parcelRequire("cernH");

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $apqRF = parcelRequire("apqRF");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $65fd74c1895e469d$export$952eefa1907e877a = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_CLASSIC,
    name: (0, $exb0h.ROUTE_NAMES).CLASSIC_PROJECT_SETTINGS_DATA_CLASSIFICATIONS,
    path: '/plugins/servlet/project-config/:projectKey/data-classifications',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $82b5373c7482f6aa$export$b8abcf8aa8f4df56 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("kSdpO"))), {
    moduleId: "./src/packages/spa-apps/project-settings/data-classifications/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$82b5373c7482f6aa$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $82b5373c7482f6aa$export$b8abcf8aa8f4df56,
        pageId: "project-settings-data-classifications",
        shouldShowSpinner: false
    });


const $cec0a7d4441930b4$export$5b0670f37204a43d = (0, $apqRF.createEntry)((0, $65fd74c1895e469d$export$952eefa1907e877a), {
    component: (0, $82b5373c7482f6aa$export$2e2bcd8739ae039),
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $82b5373c7482f6aa$export$b8abcf8aa8f4df56)
    ]
});



var $cernH = parcelRequire("cernH");

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $apqRF = parcelRequire("apqRF");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $67a90f29888309ea$export$c593179674352d0 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_CLASSIC,
    name: (0, $exb0h.ROUTE_NAMES).CLASSIC_PROJECT_SETTINGS_ISSUE_LAYOUT,
    path: '/plugins/servlet/project-config/:projectKey/issuelayout',
    query: [
        'screenId'
    ],
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $aa1f52b15b58fdc3$export$36dcfb52d47cb93a = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("aK8GH"))), {
    moduleId: "./src/packages/spa-apps/project-settings/issue-type/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$aa1f52b15b58fdc3$export$2e2bcd8739ae039 = ({ match: match })=>{
    const { issueTypeId: issueTypeId } = match.params;
    // unique pageId need to be set so that ApdexProvider would properly reset all the performance marks when switching between issue types
    const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $aa1f52b15b58fdc3$export$36dcfb52d47cb93a,
        pageId: pageId,
        shouldShowSpinner: false
    });
};


const $5d62d367f9442e26$export$47b3bdf88a7d176b = (0, $apqRF.createEntry)((0, $67a90f29888309ea$export$c593179674352d0), {
    ufoName: 'project-settings.issue-type.jsw-cmp',
    component: (0, $aa1f52b15b58fdc3$export$2e2bcd8739ae039),
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $aa1f52b15b58fdc3$export$36dcfb52d47cb93a)
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $jh2R9 = parcelRequire("jh2R9");

var $7rh0R = parcelRequire("7rh0R");

var $cernH = parcelRequire("cernH");



var $exb0h = parcelRequire("exb0h");

var $bmKiO = parcelRequire("bmKiO");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");

var $d1szd = parcelRequire("d1szd");

var $dVvIP = parcelRequire("dVvIP");


var $7vTKl = parcelRequire("7vTKl");

var $5w4hM = parcelRequire("5w4hM");

var $2Fzrk = parcelRequire("2Fzrk");

var $isbb2 = parcelRequire("isbb2");

var $apqRF = parcelRequire("apqRF");

var $4qvmP = parcelRequire("4qvmP");

var $a5edq = parcelRequire("a5edq");

var $gar3N = parcelRequire("gar3N");

var $hHrVM = parcelRequire("hHrVM");

var $ixwgj = parcelRequire("ixwgj");

var $lY9wZ = parcelRequire("lY9wZ");

var $5GEOG = parcelRequire("5GEOG");

var $3MEW8 = parcelRequire("3MEW8");

var $exb0h = parcelRequire("exb0h");
const $3c28aedf6dc41886$var$jiraIssueFormCreateEndpoint = 'projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?'; // the 1 query param is "requestTypeId"
const $3c28aedf6dc41886$export$79089e2853f04197 = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_ROADMAP_CLASSIC,
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/roadmap'
};
const $3c28aedf6dc41886$export$ce5173f7e8fa932b = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_TIMELINE_CLASSIC,
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/timeline'
};
const $3c28aedf6dc41886$export$f2c3b99639d54eb8 = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_CALENDAR_CLASSIC,
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/calendar',
    queries: [
        'date?'
    ]
};
const $3c28aedf6dc41886$export$ced2612fe5124ff8 = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_CALENDAR_CLASSIC_EMBED,
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/calendar/embed',
    queries: [
        'date?'
    ]
};
const $3c28aedf6dc41886$export$1bf758507ca6b2 = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_LIST_CLASSIC,
    path: '/jira/software/c/projects/:projectKey/list'
};
const $3c28aedf6dc41886$export$de5fcecec40b3c98 = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_LIST_CLASSIC_EMBED,
    path: '/jira/software/c/projects/:projectKey/list/embed'
};
const $3c28aedf6dc41886$export$d12f3924cf53b545 = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_GOALS_CLASSIC,
    path: '/jira/software/c/projects/:projectKey/goals'
};
const $3c28aedf6dc41886$export$9e1d275c8078512e = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_BACKLOG,
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/backlog'
};
const $3c28aedf6dc41886$export$d37f637b09fb9fda = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_REPORT,
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/:chartView'
};
const $3c28aedf6dc41886$export$1e5e610e11119ea7 = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_REPORTS_CYCLE_TIME_CLASSIC,
    path: '/jira/software/c/projects/:projectKey/reports/cycle-time'
};
const $3c28aedf6dc41886$export$92f34907c6bf7007 = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_CLASSIC_PROFORMA_ISSUE_FORMS_DIRECT,
    path: `/jira/software/c/${$3c28aedf6dc41886$var$jiraIssueFormCreateEndpoint}`,
    exact: true
};
const $3c28aedf6dc41886$export$16987cdd084cceba = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_CLASSIC_PROFORMA_ISSUE_FORMS_DIRECT_EMBED,
    path: `/jira/software/c/${$3c28aedf6dc41886$var$jiraIssueFormCreateEndpoint}/embed`,
    exact: true
};
const $3c28aedf6dc41886$export$312c410cb3b49afe = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY_CLASSIC,
    path: '/jira/software/c/projects/:projectKey/reports/deployment-frequency'
};
const $3c28aedf6dc41886$export$79c2d9718e914f91 = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_USER_BACKLOG,
    path: '/jira/people/:accountId/boards/:boardId/backlog'
};
const $3c28aedf6dc41886$export$7b85bca17717def6 = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_USER_REPORT,
    path: '/jira/people/:accountId/boards/:boardId/reports/:chartView'
};
const $3c28aedf6dc41886$export$ff874528b0b33a61 = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_BACKLOG,
    path: '/secure/RapidBoard.jspa',
    query: [
        'rapidView',
        'view=(planning|planning.nodetail)'
    ]
};
const $3c28aedf6dc41886$export$d27f9ad2fc277ff9 = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_REPORT,
    path: '/secure/RapidBoard.jspa',
    query: [
        'rapidView',
        'view=reporting',
        'chart'
    ]
};
const $3c28aedf6dc41886$export$d92cd77785d00ff = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_CODE_CLASSIC,
    path: '/jira/software/c/projects/:projectKey/code'
};
const $3c28aedf6dc41886$export$991b1be164057e91 = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_LAST_VISITED_PROJECT_REDIRECT,
    path: '/secure/RapidBoard.jspa',
    query: [
        'projectKey'
    ]
};
const $3c28aedf6dc41886$export$3913c8bee519225c = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_DIRECTORY_REDIRECT,
    path: '/secure/RapidBoard.jspa'
};



var $dgH3j = parcelRequire("dgH3j");
var $4mBNF = parcelRequire("4mBNF");

var $jh2R9 = parcelRequire("jh2R9");

var $exb0h = parcelRequire("exb0h");


var $1ybV0 = parcelRequire("1ybV0");

var $7vTKl = parcelRequire("7vTKl");

var $iOOlt = parcelRequire("iOOlt");

var $2Fzrk = parcelRequire("2Fzrk");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $ixwgj = parcelRequire("ixwgj");

var $3vlQh = parcelRequire("3vlQh");

var $exb0h = parcelRequire("exb0h");
const $2ab19c36cf374220$export$12e1ca6c7cfdfd49 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_INCIDENTS,
    path: '/jira/software/projects/:projectKey/incidents'
};
const $2ab19c36cf374220$export$3356a7870a2717f4 = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_INCIDENTS_CLASSIC,
    path: '/jira/software/c/projects/:projectKey/incidents'
};



var $1hTYf = parcelRequire("1hTYf");

var $bEe6y = parcelRequire("bEe6y");
/**
 * @generated SignedSource<<642f4ac62154bddf4b2f4e9d7776bddd>>
 * @relayHash 31ce6078aa04dd287acc44b9c9417f47
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c3b1c8d98edcfbf446d19e7604e225820f9c27c834e844fde6d552c5ef3cbd77
const $5b808c300e9a0435$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "c3b1c8d98edcfbf446d19e7604e225820f9c27c834e844fde6d552c5ef3cbd77",
        "metadata": {
            "connection": [
                {
                    "count": "servicePageSize",
                    "cursor": "after",
                    "direction": "forward",
                    "path": [
                        "jira",
                        "jiraProjectByKey",
                        "linkedOperationsComponentsByProject"
                    ]
                }
            ]
        },
        "name": "srcIncidentsPageInternalQuery",
        "operationKind": "query",
        "text": null
    }
};
var $5b808c300e9a0435$export$2e2bcd8739ae039 = $5b808c300e9a0435$var$node;



var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");
const $8893b993517b1a81$var$AriGraphSortOrderInput = {
    ASC: 'ASC',
    DESC: 'DESC'
};
const $8893b993517b1a81$var$QUERY_PARAM_SEARCH = 'search';
const $8893b993517b1a81$var$QUERY_PARAM_PRIORITY = 'priority';
const $8893b993517b1a81$var$QUERY_PARAM_AFFECTED_SERVICE = 'affected-service';
const $8893b993517b1a81$var$QUERY_PARAM_STATUS = 'status';
const $8893b993517b1a81$var$QUERY_PARAM_SORT_BY = 'sortBy';
const $8893b993517b1a81$var$QUERY_PARAM_SORT_ORDER = 'sortOrder';
const $8893b993517b1a81$var$STATUS_SORT_KEY = 'status';
const $8893b993517b1a81$var$CREATED_SORT_KEY = 'created';
const $8893b993517b1a81$var$PRIORITY_SORT_KEY = 'priority';
const $8893b993517b1a81$var$SUMMARY_SORT_KEY = 'key';
const $8893b993517b1a81$var$ASC_SORT_KEY = 'ASC';
const $8893b993517b1a81$var$DESC_SORT_KEY = 'DESC';
function $8893b993517b1a81$var$notEmpty(value) {
    return Boolean(value);
}
const $8893b993517b1a81$var$isPriority = $8893b993517b1a81$var$notEmpty;
const $8893b993517b1a81$var$isStatus = (val)=>val === 'resolved' || val === 'open';
const $8893b993517b1a81$var$isSortBy = (val)=>val === $8893b993517b1a81$var$STATUS_SORT_KEY || val === $8893b993517b1a81$var$CREATED_SORT_KEY || val === $8893b993517b1a81$var$PRIORITY_SORT_KEY || val === $8893b993517b1a81$var$SUMMARY_SORT_KEY;
const $8893b993517b1a81$var$isSortOrder = (val)=>val === $8893b993517b1a81$var$ASC_SORT_KEY || val === $8893b993517b1a81$var$DESC_SORT_KEY;
const $8893b993517b1a81$var$isAffectedService = $8893b993517b1a81$var$notEmpty;
function $8893b993517b1a81$var$parseParameter(parameter, parameterValidationFn) {
    return parameter == null ? undefined : parameter.split(',').map((str)=>str.trim()).filter(parameterValidationFn);
}
const $8893b993517b1a81$var$parseQueryParams = (paramsRaw)=>{
    const result = {
        [$8893b993517b1a81$var$QUERY_PARAM_SORT_BY]: paramsRaw[$8893b993517b1a81$var$QUERY_PARAM_SORT_BY] && $8893b993517b1a81$var$isSortBy(paramsRaw[$8893b993517b1a81$var$QUERY_PARAM_SORT_BY]) ? paramsRaw[$8893b993517b1a81$var$QUERY_PARAM_SORT_BY] : $8893b993517b1a81$var$CREATED_SORT_KEY,
        [$8893b993517b1a81$var$QUERY_PARAM_SORT_ORDER]: paramsRaw[$8893b993517b1a81$var$QUERY_PARAM_SORT_ORDER] && $8893b993517b1a81$var$isSortOrder(paramsRaw[$8893b993517b1a81$var$QUERY_PARAM_SORT_ORDER]) ? paramsRaw[$8893b993517b1a81$var$QUERY_PARAM_SORT_ORDER] : $8893b993517b1a81$var$DESC_SORT_KEY
    };
    result[$8893b993517b1a81$var$QUERY_PARAM_AFFECTED_SERVICE] = $8893b993517b1a81$var$parseParameter(paramsRaw[$8893b993517b1a81$var$QUERY_PARAM_AFFECTED_SERVICE], $8893b993517b1a81$var$isAffectedService);
    result[$8893b993517b1a81$var$QUERY_PARAM_STATUS] = $8893b993517b1a81$var$parseParameter(paramsRaw[$8893b993517b1a81$var$QUERY_PARAM_STATUS], $8893b993517b1a81$var$isStatus);
    result[$8893b993517b1a81$var$QUERY_PARAM_SEARCH] = paramsRaw[$8893b993517b1a81$var$QUERY_PARAM_SEARCH] ?? undefined;
    result[$8893b993517b1a81$var$QUERY_PARAM_PRIORITY] = $8893b993517b1a81$var$parseParameter(paramsRaw[$8893b993517b1a81$var$QUERY_PARAM_PRIORITY], $8893b993517b1a81$var$isPriority);
    return result;
};
const $8893b993517b1a81$var$getFilterValue = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
values)=>({
        ...values.length > 0 ? {
            is: values
        } : {}
    });
const $8893b993517b1a81$var$parseStatusToFilterValues = (status)=>status.flatMap((stat)=>{
        switch(stat){
            case 'open':
                return [
                    'NEW',
                    'INDETERMINATE'
                ];
            case 'resolved':
                return [
                    'DONE'
                ];
            default:
                return [
                    'UNDEFINED'
                ];
        }
    });
const $8893b993517b1a81$var$getGqlFiltersFromQueryParams = (parsedQueryParams)=>({
        and: [
            {
                to_status: $8893b993517b1a81$var$getFilterValue($8893b993517b1a81$var$parseStatusToFilterValues(parsedQueryParams[$8893b993517b1a81$var$QUERY_PARAM_STATUS] ?? [])),
                to_priority: $8893b993517b1a81$var$getFilterValue(parsedQueryParams[$8893b993517b1a81$var$QUERY_PARAM_PRIORITY] ?? []),
                to_affectedServiceAris: $8893b993517b1a81$var$getFilterValue(parsedQueryParams[$8893b993517b1a81$var$QUERY_PARAM_AFFECTED_SERVICE] ?? [])
            }
        ]
    });
const $8893b993517b1a81$var$parseSortDirection = (maybeDirection, defaultValue)=>{
    switch(maybeDirection?.toUpperCase()){
        case $8893b993517b1a81$var$AriGraphSortOrderInput.ASC.toUpperCase():
            return $8893b993517b1a81$var$AriGraphSortOrderInput.ASC;
        case $8893b993517b1a81$var$AriGraphSortOrderInput.DESC.toUpperCase():
            return $8893b993517b1a81$var$AriGraphSortOrderInput.DESC;
        default:
            return defaultValue;
    }
};
const $8893b993517b1a81$var$getSortValue = (sortOrder)=>({
        priority: 2,
        direction: $8893b993517b1a81$var$parseSortDirection(sortOrder, $8893b993517b1a81$var$AriGraphSortOrderInput.DESC)
    });
// Added Inverse sort fn as data in AGS is indexed in reverse order for priority
const $8893b993517b1a81$var$parseInverseSortDirection = (maybeDirection, defaultValue)=>{
    switch(maybeDirection?.toUpperCase()){
        case $8893b993517b1a81$var$AriGraphSortOrderInput.ASC.toUpperCase():
            return $8893b993517b1a81$var$AriGraphSortOrderInput.DESC;
        case $8893b993517b1a81$var$AriGraphSortOrderInput.DESC.toUpperCase():
            return $8893b993517b1a81$var$AriGraphSortOrderInput.ASC;
        default:
            return defaultValue;
    }
};
const $8893b993517b1a81$var$getInverseSortValue = (sortOrder)=>({
        priority: 2,
        direction: $8893b993517b1a81$var$parseInverseSortDirection(sortOrder, $8893b993517b1a81$var$AriGraphSortOrderInput.ASC)
    });
const $8893b993517b1a81$var$getGraphStoreSortFromQueryParams = (parsedQueryParams)=>({
        lastModified: {
            priority: 1,
            direction: $8893b993517b1a81$var$AriGraphSortOrderInput.DESC
        },
        ...$8893b993517b1a81$var$STATUS_SORT_KEY === parsedQueryParams[$8893b993517b1a81$var$QUERY_PARAM_SORT_BY] ? {
            to_status: $8893b993517b1a81$var$getSortValue(parsedQueryParams[$8893b993517b1a81$var$QUERY_PARAM_SORT_ORDER])
        } : {},
        ...$8893b993517b1a81$var$PRIORITY_SORT_KEY === parsedQueryParams[$8893b993517b1a81$var$QUERY_PARAM_SORT_BY] ? {
            to_priority: $8893b993517b1a81$var$getInverseSortValue(parsedQueryParams[$8893b993517b1a81$var$QUERY_PARAM_SORT_ORDER])
        } : {},
        ...$8893b993517b1a81$var$CREATED_SORT_KEY === parsedQueryParams[$8893b993517b1a81$var$QUERY_PARAM_SORT_BY] ? {
            createdAt: $8893b993517b1a81$var$getSortValue(parsedQueryParams[$8893b993517b1a81$var$QUERY_PARAM_SORT_ORDER])
        } : {}
    });

const $8893b993517b1a81$export$a59477eea6e8cd7f = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("dy6xq")).then((mod)=>mod.IncidentsPageWrapper), {
        moduleId: "5b8b4ff7"
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId }, context: context })=>({
            queries: {
                incidentPageData: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $5b808c300e9a0435$export$2e2bcd8739ae039,
                    variables: {
                        incidentPageSize: 30,
                        servicePageSize: 30,
                        cloudId: cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        filter: $8893b993517b1a81$var$getGqlFiltersFromQueryParams($8893b993517b1a81$var$parseQueryParams(context.query)),
                        sort: $8893b993517b1a81$var$getGraphStoreSortFromQueryParams($8893b993517b1a81$var$parseQueryParams(context.query)),
                        siteAri: `ari:cloud:jira::site/${cloudId}`
                    }
                }
            }
        })
});


/**
 * @generated SignedSource<<7699704d0995bbdc63133dc84290d5de>>
 * @relayHash bf929c95e6738104436e6a3b1e6f48cd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8822ca061f1e1e9e11103925231d8d61251ca06c569e9da069f1b3faa1183aaf
const $415b79d5341f9d0c$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "8822ca061f1e1e9e11103925231d8d61251ca06c569e9da069f1b3faa1183aaf",
        "metadata": {
            "connection": [
                {
                    "count": "first",
                    "cursor": "after",
                    "direction": "forward",
                    "path": [
                        "jira",
                        "jiraProjectByKey",
                        "associatedComponents"
                    ]
                }
            ]
        },
        "name": "srcIncidentsLinkedServicesQuery",
        "operationKind": "query",
        "text": null
    }
};
var $415b79d5341f9d0c$export$2e2bcd8739ae039 = $415b79d5341f9d0c$var$node;



var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $4c5fd999dd41f067$export$a59477eea6e8cd7f = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("awSy7")).then((mod)=>mod.IncidentsPageLinkedServicesWrapper), {
        moduleId: "d6132459"
    }),
    getPreloadProps: ({ tenantContext: { cloudId: cloudId }, context: context })=>({
            queries: {
                incidentPageData: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $415b79d5341f9d0c$export$2e2bcd8739ae039,
                    variables: {
                        cloudId: cloudId,
                        projectKey: context.match.params.projectKey ?? ''
                    }
                }
            }
        })
});



var $soOXK = parcelRequire("soOXK");
const $f7ee2b416e224377$var$entryPointDeprecated = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $4c5fd999dd41f067$export$a59477eea6e8cd7f),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});
const $f7ee2b416e224377$var$entryPoint = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $8893b993517b1a81$export$a59477eea6e8cd7f),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});
const $f7ee2b416e224377$export$fd29243dbe4103 = (0, $apqRF.createEntry)((0, $2ab19c36cf374220$export$12e1ca6c7cfdfd49), {
    entryPoint () {
        return (0, $1ybV0.ff)('corex-operandi-incidents-page-in-jira_5ebja') ? $f7ee2b416e224377$var$entryPoint : $f7ee2b416e224377$var$entryPointDeprecated;
    },
    layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
    skeleton: (0, $1hTYf.IncidentsPageSkeleton),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iOOlt.default),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $ixwgj.projectContextResource),
        (0, $3vlQh.incidentsInitialPageChecksResource),
        (0, $3vlQh.incidentsCustomFieldIdResource)
    ],
    meta: {
        reporting: {
            id: (0, $exb0h.ROUTE_NAMES).SOFTWARE_INCIDENTS,
            packageName: (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))((0, $exb0h.ROUTE_NAMES).SOFTWARE_INCIDENTS),
            teamName: 'operandi'
        }
    },
    ufoName: 'software-incidents'
});
const $f7ee2b416e224377$export$c7d98bfe75274932 = (0, $apqRF.createEntry)((0, $2ab19c36cf374220$export$3356a7870a2717f4), {
    entryPoint () {
        return (0, $1ybV0.ff)('corex-operandi-incidents-page-in-jira_5ebja') ? $f7ee2b416e224377$var$entryPoint : $f7ee2b416e224377$var$entryPointDeprecated;
    },
    layout: (0, $soOXK.classicSoftwareProjectLayout),
    skeleton: (0, $1hTYf.IncidentsPageSkeleton),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $2Fzrk.default),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $ixwgj.projectContextResource),
        (0, $3vlQh.incidentsInitialPageChecksResource),
        (0, $3vlQh.incidentsCustomFieldIdResource)
    ],
    meta: {
        reporting: {
            id: (0, $exb0h.ROUTE_NAMES).SOFTWARE_INCIDENTS_CLASSIC,
            packageName: (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))((0, $exb0h.ROUTE_NAMES).SOFTWARE_INCIDENTS_CLASSIC),
            teamName: 'operandi'
        }
    },
    ufoName: 'software-incidents'
});



var $dfBCt = parcelRequire("dfBCt");

var $cernH = parcelRequire("cernH");


var $bmKiO = parcelRequire("bmKiO");

var $d1szd = parcelRequire("d1szd");


var $7vTKl = parcelRequire("7vTKl");

var $5w4hM = parcelRequire("5w4hM");

var $isbb2 = parcelRequire("isbb2");

var $apqRF = parcelRequire("apqRF");

var $a5edq = parcelRequire("a5edq");
var $ioEMP = parcelRequire("ioEMP");

var $hHrVM = parcelRequire("hHrVM");

var $gyys9 = parcelRequire("gyys9");

var $jwzNs = parcelRequire("jwzNs");


var $4PVYj = parcelRequire("4PVYj");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $exb0h = parcelRequire("exb0h");

var $1ybV0 = parcelRequire("1ybV0");

var $eUqFw = parcelRequire("eUqFw");

var $ddT06 = parcelRequire("ddT06");
var $kJlBc = parcelRequire("kJlBc");

var $ck59k = parcelRequire("ck59k");
var $1fF9e = parcelRequire("1fF9e");
const $526f0d4401bba6e8$export$1f830ccec49c6c48 = ({ configParam: configParam })=>{
    const [, setConfigParam] = (0, $kJlBc.useQueryParam)('config');
    const { getSelectedConfigTab: getSelectedConfigTab, setSelectedConfigTab: setSelectedConfigTab } = (0, $1fF9e.useSelectedConfigTab)();
    const isUserLocatedBoard = (0, $ck59k.useIsUserLocatedBoard)();
    // Pages that should only be shown for project-located boards, need to redirect for user-located boards
    const projectOnlyTabs = [
        'timelineConfig',
        'insightsConfig'
    ];
    const defaultTab = 'filter';
    const selectedTab = getSelectedConfigTab();
    const lastOpenedTab = selectedTab ? JSON.parse(selectedTab) : defaultTab;
    if (isUserLocatedBoard && projectOnlyTabs.includes(configParam) && projectOnlyTabs.includes(lastOpenedTab)) {
        setConfigParam(defaultTab);
        setSelectedConfigTab(defaultTab);
    } else setConfigParam(lastOpenedTab);
    return null;
};


var $ck59k = parcelRequire("ck59k");

var $eUqFw = parcelRequire("eUqFw");

var $eUqFw = parcelRequire("eUqFw");

var $jDNSq = parcelRequire("jDNSq");

var $7agTL = parcelRequire("7agTL");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $11mDi = parcelRequire("11mDi");

var $dWLk9 = parcelRequire("dWLk9");

var $5oh7s = parcelRequire("5oh7s");

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $b2d04b5266116776$export$5b0fa8e71f60c86a = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("72rNe")).then((module)=>module.CardColorsSettingPageContent), {
        moduleId: "eef7b753"
    }),
    getPreloadProps: ({ boardId: boardId })=>({
            queries: {
                queryReference: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $5oh7s.default,
                    variables: {
                        boardId: boardId
                    }
                }
            }
        })
});


const $32c8d2dbce9a3381$export$f15aa4a3d26adae1 = ()=>{
    const boardId = (0, $7agTL.useBoardId)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const boardAri = (0, $jDNSq.JiraSoftwareBoardAri).create({
        siteId: cloudId,
        boardId: String(boardId)
    }).toString();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $b2d04b5266116776$export$5b0fa8e71f60c86a), {
        boardId: boardAri
    });
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
        return ()=>{
            entryPointActions.unload();
        };
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "jira-card-colors-setting-page",
        packageName: "cardColorsSettings",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: {},
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $11mDi.BoardSettingsCardColorsSkeleton), null)
    });
};



var $1C4oQ = parcelRequire("1C4oQ");
const $e313be0009eab929$var$LazyCardColoursSettingsSpa = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1C4oQ.SettingsContainer), {
        packageId: "jira-board-settings.card-colour-route"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $32c8d2dbce9a3381$export$f15aa4a3d26adae1), null));
var $e313be0009eab929$export$2e2bcd8739ae039 = $e313be0009eab929$var$LazyCardColoursSettingsSpa;



var $eUqFw = parcelRequire("eUqFw");

var $eUqFw = parcelRequire("eUqFw");

var $jDNSq = parcelRequire("jDNSq");

var $7agTL = parcelRequire("7agTL");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $11mDi = parcelRequire("11mDi");

var $dWLk9 = parcelRequire("dWLk9");

var $dMKsY = parcelRequire("dMKsY");

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $288849212f8b4341$export$79221250a4fa21f2 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("8lR27")).then((module)=>module.CardLayoutSettingPageContent), {
        moduleId: "8cac6a79"
    }),
    getPreloadProps: ({ boardId: boardId })=>({
            queries: {
                queryReference: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $dMKsY.default,
                    variables: {
                        boardId: boardId
                    }
                }
            }
        })
});


const $b6c55ed61a4f9cfc$export$d315baec07eca828 = ()=>{
    const boardId = (0, $7agTL.useBoardId)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const boardAri = (0, $jDNSq.JiraSoftwareBoardAri).create({
        siteId: cloudId,
        boardId: String(boardId)
    }).toString();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $288849212f8b4341$export$79221250a4fa21f2), {
        boardId: boardAri
    });
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
        return ()=>{
            entryPointActions.unload();
        };
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "jira-card-layout-setting-page",
        packageName: "cardLayoutSettings",
        teamName: "a4t-pandora",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: {},
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $11mDi.BoardSettingsCardLayoutSkeleton), null)
    });
};



var $1C4oQ = parcelRequire("1C4oQ");
const $6094e5cd4bd53b45$var$LazyCardLayoutSettingsSpa = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1C4oQ.SettingsContainer), {
        packageId: "jira-board-settings.card-layout-route"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b6c55ed61a4f9cfc$export$d315baec07eca828), null));
var $6094e5cd4bd53b45$export$2e2bcd8739ae039 = $6094e5cd4bd53b45$var$LazyCardLayoutSettingsSpa;



var $eUqFw = parcelRequire("eUqFw");

var $eUqFw = parcelRequire("eUqFw");

var $jDNSq = parcelRequire("jDNSq");

var $7agTL = parcelRequire("7agTL");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $dWLk9 = parcelRequire("dWLk9");

var $d6l6w = parcelRequire("d6l6w");

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $63684622b97b6915$export$eeb080e75ce687a6 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("dT5Tp")).then((module)=>module.ColumnsSettingPageContent), {
        moduleId: "17583f2e"
    }),
    getPreloadProps: ({ boardId: boardId, cloudId: cloudId })=>({
            queries: {
                queryReference: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $d6l6w.default,
                    variables: {
                        boardId: boardId,
                        cloudId: cloudId
                    }
                }
            }
        })
});


const $c62b1d7c07dd7fe3$export$a27195d3df0763d0 = ()=>{
    const boardId = (0, $7agTL.useBoardId)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const boardAri = (0, $jDNSq.JiraSoftwareBoardAri).create({
        siteId: cloudId,
        boardId: String(boardId)
    }).toString();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $63684622b97b6915$export$eeb080e75ce687a6), {
        boardId: boardAri,
        cloudId: cloudId
    });
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
        return ()=>{
            entryPointActions.unload();
        };
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "jira-columns-setting-page",
        packageName: "columnsSettings",
        teamName: "a4t-pandora",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: {},
        fallback: null
    });
};



var $1C4oQ = parcelRequire("1C4oQ");
const $235141e39a322f9c$var$LazyColumnsSettingsSpa = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1C4oQ.SettingsContainer), {
        packageId: "jira-board-settings.columns-route"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c62b1d7c07dd7fe3$export$a27195d3df0763d0), null));
var $235141e39a322f9c$export$2e2bcd8739ae039 = $235141e39a322f9c$var$LazyColumnsSettingsSpa;



var $eUqFw = parcelRequire("eUqFw");

var $eUqFw = parcelRequire("eUqFw");

var $jDNSq = parcelRequire("jDNSq");

var $7agTL = parcelRequire("7agTL");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $11mDi = parcelRequire("11mDi");

var $dWLk9 = parcelRequire("dWLk9");

var $e3kq2 = parcelRequire("e3kq2");

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $96e4fcc3a5c9d23c$export$33e6269c993354cb = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("049Kc")).then((module)=>module.EstimationSettingPageContent), {
        moduleId: "73862dcd"
    }),
    getPreloadProps: ({ boardId: boardId, cloudId: cloudId })=>({
            queries: {
                queryReference: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $e3kq2.default,
                    variables: {
                        boardId: boardId,
                        cloudId: cloudId
                    }
                }
            }
        })
});


const $22c7dcc6031129f0$export$28b63be0af0c2ff1 = ()=>{
    const boardId = (0, $7agTL.useBoardId)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const boardAri = (0, $jDNSq.JiraSoftwareBoardAri).create({
        siteId: cloudId,
        boardId: String(boardId)
    }).toString();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $96e4fcc3a5c9d23c$export$33e6269c993354cb), {
        boardId: boardAri,
        cloudId: cloudId
    });
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
        return ()=>{
            entryPointActions.unload();
        };
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "jira-estimation-setting-page",
        packageName: "estimationSettings",
        teamName: "a4t-pandora",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: {},
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $11mDi.BoardSettingsEstimatesSkeleton), null)
    });
};



var $1C4oQ = parcelRequire("1C4oQ");
const $5a6a81e95457bf6a$export$531ec113b3488e6d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1C4oQ.SettingsContainer), {
        packageId: "jira-board-settings.estimation-settings-route"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $22c7dcc6031129f0$export$28b63be0af0c2ff1), null));
var $5a6a81e95457bf6a$export$2e2bcd8739ae039 = $5a6a81e95457bf6a$export$531ec113b3488e6d;



var $eUqFw = parcelRequire("eUqFw");

var $eUqFw = parcelRequire("eUqFw");

var $jDNSq = parcelRequire("jDNSq");

var $7agTL = parcelRequire("7agTL");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $11mDi = parcelRequire("11mDi");

var $dWLk9 = parcelRequire("dWLk9");
const $9712090c04c68b15$export$2cea7f14750b8c19 = 'general-settings';
const $9712090c04c68b15$export$a5a8ee89d936ca29 = 'a4t-pandora';
const $9712090c04c68b15$export$5b64efebea6469a2 = 'generalSettings';
const $9712090c04c68b15$export$28433837afed532c = 'viewGeneralSettings';



var $aaUCg = parcelRequire("aaUCg");

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $50042df067fd62a3$export$7e7a3bfeb46e1058 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("1tNLY")).then((module)=>module.GeneralSettingPageContent), {
        moduleId: "571671f1"
    }),
    getPreloadProps: ({ boardId: boardId, cloudId: cloudId })=>({
            queries: {
                queryReference: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $aaUCg.default,
                    variables: {
                        boardId: boardId,
                        cloudId: cloudId
                    }
                }
            }
        })
});


const $a401cdf9077d1296$export$d63250d50212d4b4 = ()=>{
    const boardId = (0, $7agTL.useBoardId)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const boardAri = (0, $jDNSq.JiraSoftwareBoardAri).create({
        siteId: cloudId,
        boardId: String(boardId)
    }).toString();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $50042df067fd62a3$export$7e7a3bfeb46e1058), {
        boardId: boardAri,
        cloudId: cloudId
    });
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
        return ()=>{
            entryPointActions.unload();
        };
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "jira-general-setting-page",
        packageName: (0, $9712090c04c68b15$export$5b64efebea6469a2),
        teamName: (0, $9712090c04c68b15$export$a5a8ee89d936ca29),
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: {},
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $11mDi.BoardSettingsGeneralSettingsSkeleton), null)
    });
};
var $a401cdf9077d1296$export$2e2bcd8739ae039 = $a401cdf9077d1296$export$d63250d50212d4b4;



var $1C4oQ = parcelRequire("1C4oQ");
const $6e0ea2a26ed60ba9$export$aa372e50516b2a17 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1C4oQ.SettingsContainer), {
        packageId: "jira-board-settings.general-settings-route"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a401cdf9077d1296$export$d63250d50212d4b4), null));
var $6e0ea2a26ed60ba9$export$2e2bcd8739ae039 = $6e0ea2a26ed60ba9$export$aa372e50516b2a17;



var $eUqFw = parcelRequire("eUqFw");

var $eUqFw = parcelRequire("eUqFw");

var $jDNSq = parcelRequire("jDNSq");

var $7agTL = parcelRequire("7agTL");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $11mDi = parcelRequire("11mDi");

var $dWLk9 = parcelRequire("dWLk9");

var $hsUE5 = parcelRequire("hsUE5");

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $1242529be8be36c0$export$a2d23542315dc56c = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("epkFs")).then((module)=>module.QuickFiltersSpa), {
        moduleId: "4631211d"
    }),
    getPreloadProps: ({ boardId: boardId })=>({
            queries: {
                queryReference: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $hsUE5.default,
                    variables: {
                        boardId: boardId,
                        isCMP: true
                    }
                }
            }
        })
});


const $32ca758179bc0b8e$export$57a697c00babcaa3 = ()=>{
    const boardId = (0, $7agTL.useBoardId)();
    const cloudId = (0, $dWLk9.useCloudId)();
    if (!boardId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($32ca758179bc0b8e$var$QuickFiltersSettingsContent, {
        boardId: boardId,
        cloudId: cloudId
    });
};
const $32ca758179bc0b8e$var$QuickFiltersSettingsContent = ({ boardId: boardId, cloudId: cloudId })=>{
    const boardAri = (0, $jDNSq.JiraSoftwareBoardAri).create({
        siteId: cloudId,
        boardId: String(boardId)
    }).toString();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $1242529be8be36c0$export$a2d23542315dc56c), {
        boardId: boardAri
    });
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
        return ()=>{
            entryPointActions.unload();
        };
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "jira-quick-filters-setting-page",
        packageName: "quickFiltersSettings",
        teamName: "a4t-pandora",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: {
            rapidViewId: boardId
        },
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $11mDi.BoardSettingsQuickFiltersSkeleton), null)
    });
};
var $32ca758179bc0b8e$export$2e2bcd8739ae039 = $32ca758179bc0b8e$export$57a697c00babcaa3;



var $1C4oQ = parcelRequire("1C4oQ");
const $51bff9495a80e03a$export$da489fb7f9202a2e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1C4oQ.SettingsContainer), {
        packageId: "jira-board-settings.quick-filters-settings-route"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $32ca758179bc0b8e$export$57a697c00babcaa3), null));
var $51bff9495a80e03a$export$2e2bcd8739ae039 = $51bff9495a80e03a$export$da489fb7f9202a2e;



var $eUqFw = parcelRequire("eUqFw");

var $1C4oQ = parcelRequire("1C4oQ");

var $eUqFw = parcelRequire("eUqFw");

var $jDNSq = parcelRequire("jDNSq");

var $7agTL = parcelRequire("7agTL");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $11mDi = parcelRequire("11mDi");

var $dWLk9 = parcelRequire("dWLk9");

var $evb1S = parcelRequire("evb1S");

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $d11ff25637f6ebfa$export$cfbf2ec4e98b6bf7 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("9vxg7")).then((module)=>module.SwimlanesSettingPageContent), {
        moduleId: "1d907e73"
    }),
    getPreloadProps: ({ boardId: boardId, cloudId: cloudId })=>({
            queries: {
                queryReference: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $evb1S.default,
                    variables: {
                        boardId: boardId,
                        cloudId: cloudId
                    }
                }
            }
        })
});


const $a99182a7d20142b9$export$7131ed150c75e734 = ()=>{
    const boardId = (0, $7agTL.useBoardId)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const boardAri = (0, $jDNSq.JiraSoftwareBoardAri).create({
        siteId: cloudId,
        boardId: String(boardId)
    }).toString();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $d11ff25637f6ebfa$export$cfbf2ec4e98b6bf7), {
        boardId: boardAri,
        cloudId: cloudId
    });
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
        return ()=>{
            entryPointActions.unload();
        };
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "jira-swimlanes-setting-page",
        packageName: "swimlanesSettings",
        teamName: "a4t-pandora",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: {},
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $11mDi.BoardSettingsSwimlanesSkeleton), null)
    });
};


const $f38e8ea18d4c9177$export$853574f45de1760e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1C4oQ.SettingsContainer), {
        packageId: "jira-board-settings.swimlanes-settings-route"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a99182a7d20142b9$export$7131ed150c75e734), null));
var $f38e8ea18d4c9177$export$2e2bcd8739ae039 = $f38e8ea18d4c9177$export$853574f45de1760e;



var $eUqFw = parcelRequire("eUqFw");

var $1C4oQ = parcelRequire("1C4oQ");

var $eUqFw = parcelRequire("eUqFw");

var $jDNSq = parcelRequire("jDNSq");

var $7agTL = parcelRequire("7agTL");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $11mDi = parcelRequire("11mDi");

var $dWLk9 = parcelRequire("dWLk9");

var $c6GI1 = parcelRequire("c6GI1");

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $2a8ff5da5270e02a$export$c4acb9ada25634f3 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("ebWbd")).then((module)=>module.TimelineSettingPageContent), {
        moduleId: "0e288e25"
    }),
    getPreloadProps: ({ boardId: boardId })=>({
            queries: {
                queryReference: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $c6GI1.default,
                    variables: {
                        boardId: boardId
                    }
                }
            }
        })
});


const $be41b4ff1ce596d8$export$6268ab25fd884424 = ()=>{
    const boardId = (0, $7agTL.useBoardId)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const boardAri = (0, $jDNSq.JiraSoftwareBoardAri).create({
        siteId: cloudId,
        boardId: String(boardId)
    }).toString();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $2a8ff5da5270e02a$export$c4acb9ada25634f3), {
        boardId: boardAri
    });
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
        return ()=>{
            entryPointActions.unload();
        };
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "jira-timeline-setting-page",
        packageName: "timelineSettings",
        teamName: "a4t-pandora",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: {},
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $11mDi.BoardSettingsTimelineSkeleton), null)
    });
};


const $d91a078c514dc9a6$export$89986df2493373ff = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1C4oQ.SettingsContainer), {
        packageId: "jira-board-settings.timeline-settings-route"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $be41b4ff1ce596d8$export$6268ab25fd884424), null));
var $d91a078c514dc9a6$export$2e2bcd8739ae039 = $d91a078c514dc9a6$export$89986df2493373ff;



var $eUqFw = parcelRequire("eUqFw");

var $1C4oQ = parcelRequire("1C4oQ");

var $eUqFw = parcelRequire("eUqFw");

var $jDNSq = parcelRequire("jDNSq");

var $7agTL = parcelRequire("7agTL");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $dWLk9 = parcelRequire("dWLk9");

var $dIfyy = parcelRequire("dIfyy");

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $62a6f11fa628d403$export$335c435f36a886d3 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("eLoQ8")).then((module)=>module.WorkingDaysSettingPageContent), {
        moduleId: "8eb986dc"
    }),
    getPreloadProps: ({ boardId: boardId })=>({
            queries: {
                queryReference: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $dIfyy.default,
                    variables: {
                        boardId: boardId
                    }
                }
            }
        })
});


const $b1272cb2a83f86b6$export$f448a896f1fdd951 = ()=>{
    const boardId = (0, $7agTL.useBoardId)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const boardAri = (0, $jDNSq.JiraSoftwareBoardAri).create({
        siteId: cloudId,
        boardId: String(boardId)
    }).toString();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $62a6f11fa628d403$export$335c435f36a886d3), {
        boardId: boardAri
    });
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
        return ()=>{
            entryPointActions.unload();
        };
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "jira-working-days-setting-page",
        packageName: "workingDaysSettings",
        teamName: "a4t-pandora",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: {},
        fallback: null
    });
};


const $881cc958ecbb609d$export$538a687b5af87eb3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1C4oQ.SettingsContainer), {
        packageId: "jira-board-settings.working-days-settings-route"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b1272cb2a83f86b6$export$f448a896f1fdd951), null));
var $881cc958ecbb609d$export$2e2bcd8739ae039 = $881cc958ecbb609d$export$538a687b5af87eb3;


const $3bd90556e9e8a99b$export$c134956018f6f022 = ({ query: query })=>{
    const isUserLocatedBoard = (0, $ck59k.useIsUserLocatedBoard)();
    const configToPageMap = (0, $eUqFw.useMemo)(()=>({
            [(0, $ddT06.boardSettingsQueryConfigParamValues).general]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6e0ea2a26ed60ba9$export$2e2bcd8739ae039), null),
            [(0, $ddT06.boardSettingsQueryConfigParamValues).columns]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $235141e39a322f9c$export$2e2bcd8739ae039), null),
            [(0, $ddT06.boardSettingsQueryConfigParamValues).swimlanes]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f38e8ea18d4c9177$export$2e2bcd8739ae039), null),
            [(0, $ddT06.boardSettingsQueryConfigParamValues).quickFilters]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $51bff9495a80e03a$export$2e2bcd8739ae039), null),
            [(0, $ddT06.boardSettingsQueryConfigParamValues).cardColors]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e313be0009eab929$export$2e2bcd8739ae039), null),
            [(0, $ddT06.boardSettingsQueryConfigParamValues).cardLayout]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6094e5cd4bd53b45$export$2e2bcd8739ae039), null),
            [(0, $ddT06.boardSettingsQueryConfigParamValues).estimation]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5a6a81e95457bf6a$export$2e2bcd8739ae039), null),
            [(0, $ddT06.boardSettingsQueryConfigParamValues).workingDays]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $881cc958ecbb609d$export$2e2bcd8739ae039), null),
            ...!isUserLocatedBoard && {
                [(0, $ddT06.boardSettingsQueryConfigParamValues).timeline]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d91a078c514dc9a6$export$2e2bcd8739ae039), null)
            }
        }), [
        isUserLocatedBoard
    ]);
    return configToPageMap[query.config] || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $526f0d4401bba6e8$export$1f830ccec49c6c48), {
        configParam: query.config
    });
};



var $59o4i = parcelRequire("59o4i");

const $7ba63b5e616f6f5c$export$2164de18d39af313 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("cPcEF")), {
    moduleId: "./src/packages/spa-apps/next-gen-board/src/index.tsx"
});

const $7ba63b5e616f6f5c$export$bcc6315cf211edab = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("1F5sC")), {
    moduleId: "./src/packages/spa-apps/next-gen-backlog/src/index.tsx"
});
const $7ba63b5e616f6f5c$export$4ceb6cf2934825b2 = (props)=>{
    const { route: route, query: query, match: match } = props;
    const basePageId = route && route.name || 'rapid-board';
    const chartParam = query.chart ? `-${query.chart}` : '';
    const boardId = query.rapidView ?? match.params.boardId;
    const pageId = `${basePageId}-${boardId}${chartParam}`;
    if (// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    [
        (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_BOARD,
        (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_USER_BOARD
    ].includes(route.name) && !query.config) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7ba63b5e616f6f5c$export$2164de18d39af313,
        pageId: pageId,
        shouldShowSpinner: false
    });
    if (// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    [
        (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_BACKLOG,
        (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_USER_BACKLOG
    ].includes(route.name) && !query.config) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7ba63b5e616f6f5c$export$bcc6315cf211edab,
        pageId: pageId,
        shouldShowSpinner: false
    });
    if ((0, $1ybV0.ff)('simplified-boards-milestone-2_07hbk') && [
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_BACKLOG,
        (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_USER_BACKLOG,
        (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_BOARD,
        (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_USER_BOARD
    ].includes(route.name) && query.config) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3bd90556e9e8a99b$export$c134956018f6f022), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7ba63b5e616f6f5c$export$9de09057ba255cc4,
        pageId: pageId,
        shouldShowSpinner: false
    });
};

const $7ba63b5e616f6f5c$export$9de09057ba255cc4 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("4DUTj")), {
    moduleId: "./src/packages/spa-apps/rapid-board/src/index.tsx"
});

const $7ba63b5e616f6f5c$export$bcb5bb6438a46dcb = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("hW8vP")), {
    moduleId: "./src/packages/router-resources/classic-projects/src/services/wrm-bundle/get-data/index.tsx"
});

const $7ba63b5e616f6f5c$export$d4640ceb9bdd4b4 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("bozaw")), {
    moduleId: "./src/packages/router-resources/classic-projects/src/services/data-api/get-data/index.tsx"
});

const $7ba63b5e616f6f5c$export$c96c36c0cbfb2c16 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("2NVpl")), {
    moduleId: "./src/packages/router-resources/classic-projects/src/services/config-api/get-data/index.tsx"
});

const $7ba63b5e616f6f5c$export$2ad64ed8eb98d9e = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("jM9sA")), {
    moduleId: "./src/packages/router-resources/classic-projects/src/services/rapidboard-resource/get-data/index.tsx"
});

const $7ba63b5e616f6f5c$export$4a8825f3e310b97 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("6jZVr")), {
    moduleId: "./src/packages/entry-rapid-board-wrm-apps/src/index.tsx"
});


/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");
var $4f33c3cc33e4e07d$exports = {};
$4f33c3cc33e4e07d$exports = new URL("classic-board-app-skeleton.tpl.bf1c26f5.svg", import.meta.url).toString();


const $e97d2ead64a3cd9f$var$customCssStyles = null;
const $e97d2ead64a3cd9f$export$631611c5fdf027d5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4f33c3cc33e4e07d$exports))),
        className: (0, $7JEyt.default)([
            "_2zz1idpf"
        ])
    });



var $bEe6y = parcelRequire("bEe6y");
/**
 * Ordinarily it would be inadvisable to evaluate something like this in
 * a static route, as this could lead to inconsistent behaviour between
 * the server and the browser.
 *
 * In this case it is necessary and safe because:
 * 1) There are two versions of the board that share the same route
 *    and we can only tell them apart at runtime. When the old version
 *    is eventually removed, this should be cleaned up.
 * 2) No requests for board data are made on the server, so even
 *    if the value is incorrect on the server it won't be utilised
 * */ const $e679ac321a72d2f6$var$classicBoardCapability = !false ? (0, $d07297a4af13004b$export$664edf77d4c76110) : (0, $d07297a4af13004b$export$fc5f182fc9019b1c);
const $e679ac321a72d2f6$export$f2cd114cf8ab53aa = (0, $apqRF.createEntry)((0, $4PVYj.classicSoftwareBoardRoute), {
    component: (0, $7ba63b5e616f6f5c$export$4ceb6cf2934825b2),
    skeleton: (0, $e97d2ead64a3cd9f$export$631611c5fdf027d5),
    layout: (0, $isbb2.composeLayouts)((0, $d1szd.genericProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
        {
            query: [
                'selectedIssue',
                'view=detail'
            ]
        },
        {
            query: [
                'selectedIssue',
                'modal=detail'
            ]
        }
    ])),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.classicBoardSidebars),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $a5edq.getRapidboardResources)(),
        (0, $a5edq.getRapidBoardDataResource)(),
        (0, $jwzNs.resourceWithCondition2)((0, $a5edq.shouldLoadUIFBoardResources), (0, $ioEMP.uifBoardResource)),
        // Load the NBT resource if we opt-in UIF, not fedRamp is enabled
        (0, $jwzNs.resourceWithCondition2)(()=>(0, $a5edq.shouldLoadUIFBoardResources)() && !(0, $dfBCt.isFedRamp)(), (0, $gyys9.nextBestTaskFeatureResource))
    ],
    afterPaint: [
        (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $7ba63b5e616f6f5c$export$2164de18d39af313)
    ],
    preloadOptions: {
        earlyChunks: [
            'rapidboard-early-entry'
        ]
    },
    meta: {
        capability: $e679ac321a72d2f6$var$classicBoardCapability
    },
    earlyAssets: (0, $bmKiO.AGGRESSIVE_EARLY_ASSET_STRATEGY)
});



var $k4wVH = parcelRequire("k4wVH");

var $cernH = parcelRequire("cernH");

var $dCvLw = parcelRequire("dCvLw");


var $bmKiO = parcelRequire("bmKiO");

var $bAQOb = parcelRequire("bAQOb");

var $d1szd = parcelRequire("d1szd");


var $7vTKl = parcelRequire("7vTKl");

var $5w4hM = parcelRequire("5w4hM");

var $isbb2 = parcelRequire("isbb2");

var $apqRF = parcelRequire("apqRF");

var $a5edq = parcelRequire("a5edq");

var $hHrVM = parcelRequire("hHrVM");


var $exb0h = parcelRequire("exb0h");
const $c88d39e9a52c0785$export$9e1d275c8078512e = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_BACKLOG,
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/backlog',
    query: [
        'config=insightsConfig'
    ]
};
const $c88d39e9a52c0785$export$8163d70aae333a78 = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_BOARD,
    path: '/jira/software/c/projects/:projectKey/boards/:boardId',
    query: [
        'config=insightsConfig'
    ]
};




var $7msR2 = parcelRequire("7msR2");

var $bEe6y = parcelRequire("bEe6y");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $4c35f34b12fea73f$export$810ecaba1eb55cad = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("kth1i")).then((module)=>module.InsightsSettingsCMPPageLoader), {
    moduleId: "./src/packages/spa-apps/project-settings/classic-board-settings/insights/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4c35f34b12fea73f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $4c35f34b12fea73f$export$810ecaba1eb55cad,
        pageId: "classic-board-settings-insights",
        shouldShowSpinner: false
    });


const $519a2e4aeaff06bf$export$4bab4a9393eceb86 = [
    (0, $apqRF.createEntry)((0, $c88d39e9a52c0785$export$9e1d275c8078512e), {
        ufoName: 'rapidboard-backlog-insights',
        component: (0, $bAQOb.componentWithFF)('simplified-boards-milestone-2_07hbk', (0, $4c35f34b12fea73f$export$2e2bcd8739ae039), (0, $7ba63b5e616f6f5c$export$4ceb6cf2934825b2)),
        skeleton: (0, $7msR2.NextGenBacklogSkeleton),
        layout: (0, $isbb2.composeLayouts)((0, $d1szd.genericProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
            {
                query: [
                    'selectedIssue',
                    'view=planning'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $5w4hM.classicBoardSidebars),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $a5edq.getRapidboardResources)(),
            (0, $a5edq.getRapidBoardDataResource)(),
            (0, $dCvLw.insightsBoardSettingsResource),
            (0, $k4wVH.issueHierarchyPageResource)
        ],
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7ba63b5e616f6f5c$export$9de09057ba255cc4),
            (0, $7ba63b5e616f6f5c$export$4a8825f3e310b97),
            (0, $7ba63b5e616f6f5c$export$d4640ceb9bdd4b4),
            (0, $7ba63b5e616f6f5c$export$c96c36c0cbfb2c16),
            (0, $7ba63b5e616f6f5c$export$bcb5bb6438a46dcb),
            (0, $7ba63b5e616f6f5c$export$2ad64ed8eb98d9e)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            capability: (0, $d07297a4af13004b$export$93104dc4eba58ba4)
        },
        earlyAssets: (0, $bmKiO.AGGRESSIVE_EARLY_ASSET_STRATEGY)
    }),
    (0, $apqRF.createEntry)((0, $c88d39e9a52c0785$export$8163d70aae333a78), {
        ufoName: 'rapidboard-board-insights',
        component: (0, $bAQOb.componentWithFF)('simplified-boards-milestone-2_07hbk', (0, $4c35f34b12fea73f$export$2e2bcd8739ae039), (0, $7ba63b5e616f6f5c$export$4ceb6cf2934825b2)),
        skeleton: (0, $e97d2ead64a3cd9f$export$631611c5fdf027d5),
        layout: (0, $isbb2.composeLayouts)((0, $d1szd.genericProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
            {
                query: [
                    'selectedIssue',
                    'view=detail'
                ]
            },
            {
                query: [
                    'selectedIssue',
                    'modal=detail'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $5w4hM.classicBoardSidebars),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $a5edq.getRapidboardResources)(),
            (0, $a5edq.getRapidBoardDataResource)(),
            (0, $dCvLw.insightsBoardSettingsResource),
            (0, $k4wVH.issueHierarchyPageResource)
        ],
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7ba63b5e616f6f5c$export$9de09057ba255cc4),
            (0, $7ba63b5e616f6f5c$export$4a8825f3e310b97),
            (0, $7ba63b5e616f6f5c$export$d4640ceb9bdd4b4),
            (0, $7ba63b5e616f6f5c$export$c96c36c0cbfb2c16),
            (0, $7ba63b5e616f6f5c$export$bcb5bb6438a46dcb),
            (0, $7ba63b5e616f6f5c$export$2ad64ed8eb98d9e)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            capability: (0, $d07297a4af13004b$export$fc5f182fc9019b1c)
        },
        earlyAssets: (0, $bmKiO.AGGRESSIVE_EARLY_ASSET_STRATEGY)
    })
];



var $cernH = parcelRequire("cernH");


var $bmKiO = parcelRequire("bmKiO");

var $d1szd = parcelRequire("d1szd");


var $7vTKl = parcelRequire("7vTKl");

var $5w4hM = parcelRequire("5w4hM");

var $isbb2 = parcelRequire("isbb2");

var $apqRF = parcelRequire("apqRF");

var $a5edq = parcelRequire("a5edq");

var $hHrVM = parcelRequire("hHrVM");


var $exb0h = parcelRequire("exb0h");
const $60358381106e6884$export$8163d70aae333a78 = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_BOARD,
    path: '/secure/RapidBoard.jspa',
    query: [
        'rapidView'
    ]
};





var $bEe6y = parcelRequire("bEe6y");
const $8bf5c03d336a3972$export$4a5b9e48e40676ad = (0, $apqRF.createEntry)((0, $60358381106e6884$export$8163d70aae333a78), {
    ufoName: 'classic-board',
    component: (0, $7ba63b5e616f6f5c$export$4ceb6cf2934825b2),
    skeleton: (0, $e97d2ead64a3cd9f$export$631611c5fdf027d5),
    layout: (0, $isbb2.composeLayouts)((0, $d1szd.genericProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
        {
            query: [
                'selectedIssue',
                'view=detail'
            ]
        },
        {
            query: [
                'selectedIssue',
                'modal=detail'
            ]
        }
    ])),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.classicBoardSidebars),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $a5edq.getRapidboardResources)(),
        (0, $a5edq.getRapidBoardDataResource)(),
        ...(0, $hHrVM.getUserBoardNavigationResources)()
    ],
    afterPaint: [
        (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $7ba63b5e616f6f5c$export$9de09057ba255cc4),
        (0, $7ba63b5e616f6f5c$export$4a8825f3e310b97)
    ],
    preloadOptions: {
        earlyChunks: [
            'rapidboard-early-entry'
        ]
    },
    meta: {
        capability: (0, $d07297a4af13004b$export$fc5f182fc9019b1c)
    },
    earlyAssets: (0, $bmKiO.AGGRESSIVE_EARLY_ASSET_STRATEGY)
});



var $eUqFw = parcelRequire("eUqFw");

var $jh2R9 = parcelRequire("jh2R9");

var $7rh0R = parcelRequire("7rh0R");

var $cernH = parcelRequire("cernH");

var $exb0h = parcelRequire("exb0h");

var $9zysr = parcelRequire("9zysr");

var $7vTKl = parcelRequire("7vTKl");

var $iOOlt = parcelRequire("iOOlt");

var $2Fzrk = parcelRequire("2Fzrk");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $ixwgj = parcelRequire("ixwgj");

var $ezjOd = parcelRequire("ezjOd");

var $dgH3j = parcelRequire("dgH3j");

var $exb0h = parcelRequire("exb0h");
const $00ae6a6eca65f558$export$3ba8dd9a7886e7d = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_DEPLOYMENTS,
    path: '/jira/software/projects/:projectKey/deployments'
};
const $00ae6a6eca65f558$export$485e4a7b82f29d70 = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_DEPLOYMENTS_CLASSIC,
    path: '/jira/software/c/projects/:projectKey/deployments'
};



var $yyqSx = parcelRequire("yyqSx");

var $bEe6y = parcelRequire("bEe6y");

var $soOXK = parcelRequire("soOXK");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $e7eb7b8d4a88bad8$export$ed6d152d5551715c = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("gA4Ar"))), {
    moduleId: "./src/packages/spa-apps/deployments/src/index.tsx"
});
const $e7eb7b8d4a88bad8$export$35822a21682c5ed8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e7eb7b8d4a88bad8$export$ed6d152d5551715c,
        pageId: "deploymentsNextGen",
        shouldShowSpinner: true
    });
const $e7eb7b8d4a88bad8$export$7361c0feb3154afe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e7eb7b8d4a88bad8$export$ed6d152d5551715c,
        pageId: "deploymentsClassic",
        shouldShowSpinner: true
    });
const $e7eb7b8d4a88bad8$export$7e5ccb20ad8e1612 = (0, $apqRF.createEntry)((0, $00ae6a6eca65f558$export$3ba8dd9a7886e7d), {
    component: (0, $9zysr.componentWithCondition)((0, $yyqSx.isDevopsFeatureDisabledInFedRamp), (0, $dgH3j.default), $e7eb7b8d4a88bad8$export$35822a21682c5ed8),
    layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iOOlt.default),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $ezjOd.deploymentPreconditionRelayResource),
        (0, $ixwgj.projectContextResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $e7eb7b8d4a88bad8$export$ed6d152d5551715c
    ],
    meta: {
        reporting: {
            id: (0, $exb0h.ROUTE_NAMES).SOFTWARE_DEPLOYMENTS,
            packageName: (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))((0, $exb0h.ROUTE_NAMES).SOFTWARE_DEPLOYMENTS),
            teamName: 'fusion-solaris'
        }
    }
});
const $e7eb7b8d4a88bad8$export$dcf1f9ba660dedf6 = (0, $apqRF.createEntry)((0, $00ae6a6eca65f558$export$485e4a7b82f29d70), {
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $ezjOd.deploymentPreconditionRelayResource),
        (0, $ixwgj.projectContextResource)
    ],
    component: (0, $9zysr.componentWithCondition)((0, $yyqSx.isDevopsFeatureDisabledInFedRamp), (0, $dgH3j.default), $e7eb7b8d4a88bad8$export$7361c0feb3154afe),
    layout: (0, $soOXK.classicSoftwareProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $2Fzrk.default),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $e7eb7b8d4a88bad8$export$ed6d152d5551715c
    ],
    meta: {
        reporting: {
            id: (0, $exb0h.ROUTE_NAMES).SOFTWARE_DEPLOYMENTS_CLASSIC,
            packageName: (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))((0, $exb0h.ROUTE_NAMES).SOFTWARE_DEPLOYMENTS_CLASSIC),
            teamName: 'fusion-solaris'
        }
    }
});



var $eUqFw = parcelRequire("eUqFw");

var $jh2R9 = parcelRequire("jh2R9");

var $7rh0R = parcelRequire("7rh0R");

var $dfBCt = parcelRequire("dfBCt");

var $cernH = parcelRequire("cernH");

var $exb0h = parcelRequire("exb0h");

var $9zysr = parcelRequire("9zysr");

var $7vTKl = parcelRequire("7vTKl");

var $iOOlt = parcelRequire("iOOlt");

var $2Fzrk = parcelRequire("2Fzrk");

var $iHeQd = parcelRequire("iHeQd");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $ixwgj = parcelRequire("ixwgj");

var $dgH3j = parcelRequire("dgH3j");

var $exb0h = parcelRequire("exb0h");
const $f052054c3d32cff3$export$7e7b18da5d3ceba0 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_PERISCOPE,
    path: '/jira/software/projects/:projectKey/periscope'
};
const $f052054c3d32cff3$export$cb5cec74f302b3c6 = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_PERISCOPE_CLASSIC,
    path: '/jira/software/c/projects/:projectKey/periscope'
};



var $bEe6y = parcelRequire("bEe6y");

var $soOXK = parcelRequire("soOXK");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $aefe7ae0a443cf30$export$9c25b4571a88e1f = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("98h24"))), {
    moduleId: "./src/packages/spa-apps/periscope/src/index.tsx"
});
const $aefe7ae0a443cf30$export$d86ed8d2756a4d4d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $aefe7ae0a443cf30$export$9c25b4571a88e1f,
        pageId: "softwarePeriscopeNextGen",
        shouldShowSpinner: true
    });
const $aefe7ae0a443cf30$export$fd5920cadc24919d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $aefe7ae0a443cf30$export$9c25b4571a88e1f,
        pageId: "softwarePeriscopeClassic",
        shouldShowSpinner: true
    });
const $aefe7ae0a443cf30$export$7db4d910357a4d89 = (0, $apqRF.createEntry)((0, $f052054c3d32cff3$export$7e7b18da5d3ceba0), {
    component: (0, $9zysr.componentWithCondition)((0, $dfBCt.isFedRamp), (0, $dgH3j.default), $aefe7ae0a443cf30$export$d86ed8d2756a4d4d),
    skeleton: (0, $iHeQd.Skeleton),
    layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iOOlt.default),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $ixwgj.projectContextResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $aefe7ae0a443cf30$export$9c25b4571a88e1f
    ],
    meta: {
        reporting: {
            id: (0, $exb0h.ROUTE_NAMES).SOFTWARE_PERISCOPE,
            packageName: (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))((0, $exb0h.ROUTE_NAMES).SOFTWARE_PERISCOPE),
            teamName: 'nova'
        }
    }
});
const $aefe7ae0a443cf30$export$d7d49c1a51b3c0a9 = (0, $apqRF.createEntry)((0, $f052054c3d32cff3$export$cb5cec74f302b3c6), {
    skeleton: (0, $iHeQd.Skeleton),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $ixwgj.projectContextResource)
    ],
    component: (0, $9zysr.componentWithCondition)((0, $dfBCt.isFedRamp), (0, $dgH3j.default), $aefe7ae0a443cf30$export$fd5920cadc24919d),
    layout: (0, $soOXK.classicSoftwareProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $2Fzrk.default),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $aefe7ae0a443cf30$export$9c25b4571a88e1f
    ],
    meta: {
        reporting: {
            id: (0, $exb0h.ROUTE_NAMES).SOFTWARE_PERISCOPE_CLASSIC,
            packageName: (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))((0, $exb0h.ROUTE_NAMES).SOFTWARE_PERISCOPE_CLASSIC),
            teamName: 'nova'
        }
    }
});



var $eUqFw = parcelRequire("eUqFw");

var $jh2R9 = parcelRequire("jh2R9");

var $7rh0R = parcelRequire("7rh0R");

var $cernH = parcelRequire("cernH");

var $exb0h = parcelRequire("exb0h");

var $2ijRB = parcelRequire("2ijRB");

var $1ybV0 = parcelRequire("1ybV0");

var $7vTKl = parcelRequire("7vTKl");

var $iOOlt = parcelRequire("iOOlt");

var $2Fzrk = parcelRequire("2Fzrk");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $ixwgj = parcelRequire("ixwgj");

var $drG7D = parcelRequire("drG7D");

var $dgH3j = parcelRequire("dgH3j");

var $exb0h = parcelRequire("exb0h");
const $41e02700420f2857$export$3a4d4ecb82e1bfc8 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_SECURITY,
    path: '/jira/software/projects/:projectKey/security'
};
const $41e02700420f2857$export$b7285748f1151353 = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_SECURITY_CLASSIC,
    path: '/jira/software/c/projects/:projectKey/security'
};



var $yyqSx = parcelRequire("yyqSx");

var $bEe6y = parcelRequire("bEe6y");

var $soOXK = parcelRequire("soOXK");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");
const $c13ea8e6d002db74$var$isSecurityPageEnabled = ()=>(0, $1ybV0.ff)('corex-isotopes-security-page-in-jira_h0ex9') && !(0, $yyqSx.isDevopsFeatureDisabledInFedRamp)();

const $c13ea8e6d002db74$export$30c10c4b0cb1d8e3 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("lX3B2"))), {
    moduleId: "./src/packages/spa-apps/security/src/index.tsx"
});
const $c13ea8e6d002db74$export$c6cc344ea309349a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $c13ea8e6d002db74$export$30c10c4b0cb1d8e3,
        pageId: "securityNextGen",
        shouldShowSpinner: true
    });
const $c13ea8e6d002db74$export$b4dc9ba40afbdd9f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $c13ea8e6d002db74$export$30c10c4b0cb1d8e3,
        pageId: "securityClassic",
        shouldShowSpinner: true
    });
const $c13ea8e6d002db74$export$a8dcfae475505e7a = (0, $apqRF.createEntry)((0, $41e02700420f2857$export$3a4d4ecb82e1bfc8), {
    component: (0, $2ijRB.default)($c13ea8e6d002db74$var$isSecurityPageEnabled, $c13ea8e6d002db74$export$c6cc344ea309349a, (0, $dgH3j.default)),
    layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
    ufoName: 'software-security-combined',
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iOOlt.default),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $ixwgj.projectContextResource),
        (0, $drG7D.securityPageResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $c13ea8e6d002db74$export$30c10c4b0cb1d8e3
    ],
    meta: {
        reporting: {
            id: (0, $exb0h.ROUTE_NAMES).SOFTWARE_SECURITY,
            packageName: (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))((0, $exb0h.ROUTE_NAMES).SOFTWARE_SECURITY),
            teamName: 'fusion-isotopes'
        }
    }
});
const $c13ea8e6d002db74$export$8acfebad16c9d6f2 = (0, $apqRF.createEntry)((0, $41e02700420f2857$export$b7285748f1151353), {
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $ixwgj.projectContextResource),
        (0, $drG7D.securityPageResource)
    ],
    ufoName: 'software-security-combined',
    component: (0, $2ijRB.default)($c13ea8e6d002db74$var$isSecurityPageEnabled, $c13ea8e6d002db74$export$b4dc9ba40afbdd9f, (0, $dgH3j.default)),
    layout: (0, $soOXK.classicSoftwareProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $2Fzrk.default),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $c13ea8e6d002db74$export$30c10c4b0cb1d8e3
    ],
    meta: {
        reporting: {
            id: (0, $exb0h.ROUTE_NAMES).SOFTWARE_SECURITY_CLASSIC,
            packageName: (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))((0, $exb0h.ROUTE_NAMES).SOFTWARE_SECURITY_CLASSIC),
            teamName: 'fusion-isotopes'
        }
    }
});



var $cernH = parcelRequire("cernH");

var $d1szd = parcelRequire("d1szd");


var $7vTKl = parcelRequire("7vTKl");

var $5w4hM = parcelRequire("5w4hM");

var $isbb2 = parcelRequire("isbb2");

var $apqRF = parcelRequire("apqRF");

var $a5edq = parcelRequire("a5edq");
var $ioEMP = parcelRequire("ioEMP");

var $hHrVM = parcelRequire("hHrVM");

var $jwzNs = parcelRequire("jwzNs");


var $eaP1H = parcelRequire("eaP1H");


var $bEe6y = parcelRequire("bEe6y");

const $f5c4f93889a21dcb$export$cde4dacc737dc0f1 = (0, $apqRF.createEntry)((0, $eaP1H.userBoardRoute), {
    component: (0, $7ba63b5e616f6f5c$export$4ceb6cf2934825b2),
    skeleton: (0, $e97d2ead64a3cd9f$export$631611c5fdf027d5),
    layout: (0, $isbb2.composeLayouts)((0, $d1szd.genericProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
        {
            query: [
                'selectedIssue',
                'view=detail'
            ]
        },
        {
            query: [
                'selectedIssue',
                'modal=detail'
            ]
        }
    ])),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.classicBoardSidebars),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $a5edq.getRapidboardResources)(),
        (0, $a5edq.getRapidBoardDataResource)(),
        ...(0, $hHrVM.getUserBoardNavigationResources)(),
        (0, $jwzNs.resourceWithCondition2)((0, $a5edq.shouldLoadUIFBoardResources), (0, $ioEMP.uifBoardResource))
    ],
    afterPaint: [
        (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $7ba63b5e616f6f5c$export$9de09057ba255cc4),
        (0, $7ba63b5e616f6f5c$export$4a8825f3e310b97),
        (0, $7ba63b5e616f6f5c$export$d4640ceb9bdd4b4),
        (0, $7ba63b5e616f6f5c$export$c96c36c0cbfb2c16),
        (0, $7ba63b5e616f6f5c$export$bcb5bb6438a46dcb),
        (0, $7ba63b5e616f6f5c$export$2ad64ed8eb98d9e)
    ]
});




var $atRHQ = parcelRequire("atRHQ");

var $7u7sK = parcelRequire("7u7sK");
var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");
var $a759c3df40bb76dc$exports = {};
$a759c3df40bb76dc$exports = new URL("classic-report-app-skeleton.tpl.1daae66d.svg", import.meta.url).toString();


const $5d6daf8364cb9d2d$export$d7667341f4db3b8d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($a759c3df40bb76dc$exports)))
    });


var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");
var $f59e7e980ceec11d$exports = {};
$f59e7e980ceec11d$exports = new URL("list-app-skeleton.tpl.82508714.svg", import.meta.url).toString();


var $a02a4de7e6da5d92$exports = {};
$a02a4de7e6da5d92$exports = new URL("list-embed-app-skeleton.tpl.de94c811.svg", import.meta.url).toString();


const $f1174c8234e7b02e$export$cbc3335f7a517046 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($f59e7e980ceec11d$exports)))
    });
const $f1174c8234e7b02e$export$2638f1c98fe91c13 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($a02a4de7e6da5d92$exports)))
    });


var $7msR2 = parcelRequire("7msR2");
var $841Zr = parcelRequire("841Zr");

var $yyqSx = parcelRequire("yyqSx");

var $bEe6y = parcelRequire("bEe6y");

var $soOXK = parcelRequire("soOXK");

var $8H1MT = parcelRequire("8H1MT");

var $eUqFw = parcelRequire("eUqFw");

var $kJlBc = parcelRequire("kJlBc");
const $2ab85918e3df7951$export$c70b8d9ef0c891b2 = ()=>{
    const [{ query: query, match: match }] = (0, $kJlBc.useRouter)();
    const queryParams = new URLSearchParams(query).toString();
    const { projectKey: projectKey, boardId: boardId } = match.params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
        to: {
            pathname: `/jira/software/c/projects/${String(projectKey)}/boards/${String(boardId)}/timeline`,
            hash: '',
            search: queryParams
        }
    });
};



var $kKeF6 = parcelRequire("kKeF6");
var $GuBa2 = parcelRequire("GuBa2");

var $5fOZm = parcelRequire("5fOZm");
const $d32f691d614fbc79$export$8cb713295e6b7204 = ()=>[
        (0, $5fOZm.devOpsReportPreconditionResource),
        (0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $d32f691d614fbc79$export$f234446c23dc22a = ()=>[
        (0, $5fOZm.devOpsReportPreconditionResource),
        (0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $GuBa2.staticSidebarJSWReportsResource)
    ];



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $25bdd577c53f4e0d$export$cabb458181f7566e = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("ghn1W"))), {
    moduleId: "./src/packages/spa-apps/goals/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$25bdd577c53f4e0d$export$2e2bcd8739ae039 = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $25bdd577c53f4e0d$export$cabb458181f7566e,
        pageId: `classic-atlas-goals-${match.params.boardId || ''}`,
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $e4bfa5aef8b74e4b$export$a0f04dd35569e11 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("uFfwG")), {
    moduleId: "./src/packages/spa-apps/proforma-issue-forms-direct/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e4bfa5aef8b74e4b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e4bfa5aef8b74e4b$export$a0f04dd35569e11,
        pageId: "proforma-issue-forms-direct",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $0422b48ebd76799e$export$22681210aaeb910f = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("dFSQC")), {
    moduleId: "./src/packages/spa-apps/proforma-issue-forms-direct-embed/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0422b48ebd76799e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $0422b48ebd76799e$export$22681210aaeb910f,
        pageId: "proforma-issue-forms-direct-embed",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $f236dbf41d815051$export$84165bb08bf42eef = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("hMw1o"))), {
    moduleId: "./src/packages/spa-apps/roadmap/src/view/classic/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f236dbf41d815051$export$2e2bcd8739ae039 = ({ match: match })=>{
    const { boardId: boardId } = match.params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $f236dbf41d815051$export$84165bb08bf42eef,
        pageId: `classic-roadmap-${boardId || ''}`,
        shouldShowSpinner: false
    });
};




var $7vTKl = parcelRequire("7vTKl");

var $1ybV0 = parcelRequire("1ybV0");


var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");
function $f6122116660bea23$var$toBoardAri({ siteId: siteId, boardId: boardId }) {
    return `ari:cloud:jira-software:${siteId}:board/${boardId}`;
}
function $f6122116660bea23$var$toMidnightUTCString(date) {
    const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    return new Date(utcMilliseconds).toISOString();
}
function $f6122116660bea23$var$toDate(date) {
    if (!date) return new Date();
    try {
        const _date = new Date(date);
        return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
    } catch (e) {
        return new Date();
    }
}
function $f6122116660bea23$var$createScope({ context: context, tenantContext: tenantContext }) {
    const { cloudId: cloudId } = tenantContext;
    return {
        type: 'board',
        boardId: $f6122116660bea23$var$toBoardAri({
            siteId: cloudId,
            boardId: String(context.match.params.boardId)
        }),
        projectKeys: [
            String(context.match.params.projectKey)
        ]
    };
}
function $f6122116660bea23$var$buildScopeInput({ tenantContext: tenantContext }, scope) {
    const { cloudId: cloudId } = tenantContext;
    return {
        ids: [
            scope.boardId
        ],
        projectKeys: {
            cloudId: cloudId,
            keys: scope.projectKeys
        }
    };
}
function $f6122116660bea23$var$toViewMode(mode) {
    switch(mode){
        case 'week':
            return 'WEEK';
        case 'day':
            return 'DAY';
        default:
            return 'MONTH';
    }
}
function $f6122116660bea23$var$toWeekStart(weekStart) {
    switch(weekStart){
        case 'monday':
            return 'MONDAY';
        case 'saturday':
            return 'SATURDAY';
        default:
            return 'SUNDAY';
    }
}
function $f6122116660bea23$var$buildConfigurationInput({ selectedDate: selectedDate, viewMode: viewMode, weekStartsOn: weekStartsOn, startDateField: startDateField, endDateField: endDateField }) {
    return {
        date: $f6122116660bea23$var$toMidnightUTCString(selectedDate),
        mode: $f6122116660bea23$var$toViewMode(viewMode),
        weekStart: $f6122116660bea23$var$toWeekStart(weekStartsOn),
        startDateField: startDateField,
        endDateField: endDateField
    };
}
function $f6122116660bea23$var$buildIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}
function $f6122116660bea23$var$buildUnscheduledIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}
function $f6122116660bea23$var$buildVersionsSearchInput() {
    return {
        versionStatuses: [
            'RELEASED',
            'UNRELEASED'
        ]
    };
}
function $f6122116660bea23$var$buildSprintsSearchInput() {
    return {
        sprintStates: [
            'ACTIVE',
            'FUTURE',
            'CLOSED'
        ]
    };
}

const $f6122116660bea23$export$19cf4b398f638dc6 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("8be6R")), {
        moduleId: "57ee20a5"
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
        const { cloudId: cloudId } = tenantContext;
        const scope = $f6122116660bea23$var$createScope(entryPointRouteParams);
        const { date: date } = context.query;
        const selectedDate = $f6122116660bea23$var$toDate(date);
        const projectKey = String(context.match.params.projectKey);
        const boardId = String(context.match.params.boardId);
        const boardAri = $f6122116660bea23$var$toBoardAri({
            siteId: cloudId,
            boardId: String(context.match.params.boardId)
        });
        const viewMode = 'month';
        const weekStartsOn = 'sunday';
        const startDateField = 'startdate';
        const endDateField = 'duedate';
        const issueEventFields = {
            startDateField: startDateField,
            endDateField: endDateField
        };
        return {
            queries: {
                calendarData: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $ae4d1c21cb10f5ab$export$2e2bcd8739ae039,
                    variables: {
                        cloudId: cloudId,
                        projectKey: // @deprecated to be clean up via jsw-adopt-schedule-calendar-issue-mutation_9u2rq feature flag
                        projectKey,
                        boardAri: boardAri,
                        scopeInput: $f6122116660bea23$var$buildScopeInput(entryPointRouteParams, scope),
                        configurationInput: $f6122116660bea23$var$buildConfigurationInput({
                            selectedDate: selectedDate,
                            viewMode: viewMode,
                            weekStartsOn: weekStartsOn,
                            startDateField: startDateField,
                            endDateField: endDateField
                        }),
                        issuesSearchInput: $f6122116660bea23$var$buildIssuesSearchInput(),
                        unscheduledIssuesSearchInput: $f6122116660bea23$var$buildUnscheduledIssuesSearchInput(),
                        versionsSearchInput: $f6122116660bea23$var$buildVersionsSearchInput(),
                        sprintsSearchInput: $f6122116660bea23$var$buildSprintsSearchInput(),
                        skipSprintSearch: false,
                        skipVersionSearch: false,
                        jswmoonSsdReleaseFlyoutUpdateEnabled: (0, $1ybV0.ff)('jswmoon_ssd_release_flyout_update'),
                        sprintPermissionsEnabled: (0, $1ybV0.ff)('jira-calendar-sprint-permissions_h4c1u')
                    }
                }
            },
            entryPoints: {},
            extraProps: {
                scope: scope,
                selectedDate: selectedDate,
                viewMode: viewMode,
                weekStartsOn: weekStartsOn,
                issueEventFields: issueEventFields,
                projectKey: projectKey,
                boardId: boardId
            }
        };
    }
});


const $9365a5bd739debe9$export$83b1b9036cc7961a = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $f6122116660bea23$export$19cf4b398f638dc6),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

var $53ciZ = parcelRequire("53ciZ");
const $7c06835a2dbad5f3$export$557c2f222778cea6 = ({ location: location, match: match })=>{
    if (match && match.params.boardId) return match.params.boardId;
    const { rapidView: rapidView } = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(location.search);
    return rapidView;
};



const $034dff1bd145500a$export$4beafd9dbad29bff = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("cZ7T2"))), {
    moduleId: "./src/packages/spa-apps/code/src/index.tsx"
});

const $034dff1bd145500a$export$faa081cb222383ac = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("bLPIE")), {
    moduleId: "./src/packages/spa-apps/business/jsw-list/src/index.tsx"
});

const $034dff1bd145500a$export$ce40123d7c2e29e7 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("f0z5c")), {
    moduleId: "./src/packages/spa-apps/business/jsw-list-embed/src/index.tsx"
});
const $034dff1bd145500a$export$d9e8184332f86b53 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $034dff1bd145500a$export$4beafd9dbad29bff,
        pageId: `next-gen-code-${(0, $7c06835a2dbad5f3$export$557c2f222778cea6)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });
const $034dff1bd145500a$export$95e2389b7ca7ccf2 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $034dff1bd145500a$export$4beafd9dbad29bff,
        pageId: `classic-code-${(0, $7c06835a2dbad5f3$export$557c2f222778cea6)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });
const $034dff1bd145500a$export$422a3a028ae77ad3 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $034dff1bd145500a$export$faa081cb222383ac,
        pageId: `software-${(0, $7c06835a2dbad5f3$export$557c2f222778cea6)({
            location: location,
            match: match
        })}-list`,
        shouldShowSpinner: true
    });
const $034dff1bd145500a$export$4a0539d19a2e2694 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $034dff1bd145500a$export$ce40123d7c2e29e7,
        pageId: `software-${(0, $7c06835a2dbad5f3$export$557c2f222778cea6)({
            location: location,
            match: match
        })}-list-embed`,
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $ec8985514c6b606d$export$956f830ed027f1fb = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("glXm4")), {
    moduleId: "./src/packages/spa-apps/cycle-time-report/src/index.tsx"
});
const $ec8985514c6b606d$export$e16ce0656a74a015 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $ec8985514c6b606d$export$956f830ed027f1fb,
        pageId: "cycleTimeReportNextGen",
        shouldShowSpinner: true
    });
const $ec8985514c6b606d$export$237924ba64065cc3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $ec8985514c6b606d$export$956f830ed027f1fb,
        pageId: "cycleTimeReportClassic",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $04403e5f90f4354e$export$5113b2b19ec1fb53 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("heI8s")), {
    moduleId: "./src/packages/spa-apps/deployment-frequency-report/src/index.tsx"
});
const $04403e5f90f4354e$export$e2db9c7426cdb53 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $04403e5f90f4354e$export$5113b2b19ec1fb53,
        pageId: "deploymentFrequencyReportNextGen",
        shouldShowSpinner: true
    });
const $04403e5f90f4354e$export$655707e8ae1053d3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $04403e5f90f4354e$export$5113b2b19ec1fb53,
        pageId: "deploymentFrequencyReportClassic",
        shouldShowSpinner: true
    });



const $20af5c394dfc25a4$export$edb4b8cf67d7d767 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("1F5sC"))), {
    moduleId: "./src/packages/spa-apps/next-gen-backlog/src/index.tsx"
});
const $20af5c394dfc25a4$var$ProjectsDirectoryRedirect = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
        to: "/jira/projects"
    });
/**
 * Ordinarily it would be inadvisable to evaluate something like this in
 * a static route, as this could lead to inconsistent behaviour between
 * the server and the browser.
 *
 * In this case it is necessary and safe because:
 * 1) There are two versions of the backlog that share the same route
 *    and we can only tell them apart at runtime. When the old version
 *    is eventually removed, this should be cleaned up.
 * 2) No requests for backlog data are made on the server, so even
 *    if the value is incorrect on the server it won't be utilised
 * */ const $20af5c394dfc25a4$var$classicBacklogCapability = !false ? (0, $d07297a4af13004b$export$571692eec8a399e1) : (0, $d07297a4af13004b$export$93104dc4eba58ba4);
const $20af5c394dfc25a4$export$5b4e616b6b4b672a = [
    (0, $apqRF.createEntry)((0, $3c28aedf6dc41886$export$79089e2853f04197), {
        component: (0, $2ab85918e3df7951$export$c70b8d9ef0c891b2),
        skeleton: (0, $841Zr.RoadmapSkeleton),
        layout: (0, $isbb2.composeLayouts)((0, $soOXK.classicSoftwareProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $2Fzrk.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            (0, $lY9wZ.classicRoadmapResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-roadmap-early-entry'
            ]
        },
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $f236dbf41d815051$export$84165bb08bf42eef)
        ],
        ufoName: 'classic-roadmap'
    }),
    (0, $apqRF.createEntry)((0, $3c28aedf6dc41886$export$ce5173f7e8fa932b), {
        component: (0, $f236dbf41d815051$export$2e2bcd8739ae039),
        skeleton: (0, $841Zr.RoadmapSkeleton),
        layout: (0, $isbb2.composeLayouts)((0, $soOXK.classicSoftwareProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $2Fzrk.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            (0, $lY9wZ.classicRoadmapResource)
        ],
        preloadOptions: {
            earlyChunks: [
                'software-roadmap-early-entry'
            ]
        },
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $f236dbf41d815051$export$84165bb08bf42eef)
        ],
        ufoName: 'classic-roadmap'
    }),
    // This route need to be before backlog and board route
    ...(0, $519a2e4aeaff06bf$export$4bab4a9393eceb86),
    (0, $apqRF.createEntry)((0, $3c28aedf6dc41886$export$9e1d275c8078512e), {
        ufoName: 'classic-backlog',
        component: (0, $7ba63b5e616f6f5c$export$4ceb6cf2934825b2),
        skeleton: (0, $7msR2.NextGenBacklogSkeleton),
        layout: (0, $isbb2.composeLayouts)((0, $d1szd.genericProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
            {
                query: [
                    'selectedIssue',
                    'view=planning'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $5w4hM.classicBoardSidebars),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $a5edq.getUIFBacklogDataResource)(),
            ...(0, $a5edq.getRapidboardResources)(),
            (0, $a5edq.getRapidBoardDataResource)()
        ],
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            $20af5c394dfc25a4$export$edb4b8cf67d7d767
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            capability: $20af5c394dfc25a4$var$classicBacklogCapability
        },
        earlyAssets: (0, $bmKiO.AGGRESSIVE_EARLY_ASSET_STRATEGY)
    }),
    (0, $apqRF.createEntry)((0, $3c28aedf6dc41886$export$ced2612fe5124ff8), {
        skeleton: (0, $7u7sK.CalendarEmbedSkeleton),
        component: (0, $9zysr.componentWithCondition)(()=>(0, $1ybV0.ff)('jsw.perf.calendar-disable-ssr_z5p6p'), (0, $7u7sK.CalendarEmbedSkeleton), (0, $dgH3j.default)),
        entryPoint () {
            if ((0, $1ybV0.ff)('jsw.perf.calendar-disable-ssr_z5p6p') && false) return undefined;
            return (0, $1ybV0.ff)('jsw-calendar-view') ? (0, $9365a5bd739debe9$export$83b1b9036cc7961a) : undefined;
        },
        layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
        resources: [
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            (0, $3MEW8.themePreferenceResource)
        ],
        ufoName: 'classic-calendar-embed'
    }),
    (0, $apqRF.createEntry)((0, $3c28aedf6dc41886$export$f2c3b99639d54eb8), {
        skeleton: (0, $7u7sK.CalendarSkeleton),
        component: (0, $9zysr.componentWithCondition)(()=>(0, $1ybV0.ff)('jsw.perf.calendar-disable-ssr_z5p6p'), (0, $7u7sK.CalendarSkeleton), (0, $dgH3j.default)),
        entryPoint () {
            if ((0, $1ybV0.ff)('jsw.perf.calendar-disable-ssr_z5p6p') && false) return undefined;
            return (0, $1ybV0.ff)('jsw-calendar-view') ? (0, $9365a5bd739debe9$export$83b1b9036cc7961a) : undefined;
        },
        layout: (0, $isbb2.composeLayouts)((0, $soOXK.classicSoftwareProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $2Fzrk.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)()
        ],
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation)
        ],
        ufoName: 'classic-calendar'
    }),
    // This route is owned by JWM Keystone team
    (0, $apqRF.createEntry)((0, $3c28aedf6dc41886$export$de5fcecec40b3c98), {
        component: (0, $9zysr.componentWithCondition)(()=>(0, $79xbN.expValEquals)('jsw_list_view', 'cohort', 'variation'), (0, $034dff1bd145500a$export$4a0539d19a2e2694), (0, $dgH3j.default)),
        skeleton: (0, $f1174c8234e7b02e$export$2638f1c98fe91c13),
        layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
        resources: (0, $4qvmP.getProjectViewResources)(),
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ],
        forPaint: [
            (0, $034dff1bd145500a$export$ce40123d7c2e29e7)
        ],
        ufoName: 'classic-list-embed'
    }),
    // This route is owned by JWM Keystone team
    (0, $apqRF.createEntry)((0, $3c28aedf6dc41886$export$1bf758507ca6b2), {
        component: (0, $9zysr.componentWithCondition)(()=>(0, $79xbN.expValEquals)('jsw_list_view', 'cohort', 'variation'), (0, $034dff1bd145500a$export$422a3a028ae77ad3), (0, $dgH3j.default)),
        skeleton: (0, $f1174c8234e7b02e$export$cbc3335f7a517046),
        layout: (0, $isbb2.composeLayouts)((0, $soOXK.classicSoftwareProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $2Fzrk.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        resources: (0, $4qvmP.getProjectViewResources)(),
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $034dff1bd145500a$export$faa081cb222383ac)
        ],
        ufoName: 'classic-list'
    }),
    (0, $apqRF.createEntry)((0, $3c28aedf6dc41886$export$d37f637b09fb9fda), {
        component: (0, $7ba63b5e616f6f5c$export$4ceb6cf2934825b2),
        skeleton: (0, $5d6daf8364cb9d2d$export$d7667341f4db3b8d),
        layout: (0, $d1szd.genericProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $5w4hM.classicBoardSidebars),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $a5edq.getRapidboardResources)(),
            ...(0, $d32f691d614fbc79$export$8cb713295e6b7204)()
        ],
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7ba63b5e616f6f5c$export$9de09057ba255cc4),
            (0, $7ba63b5e616f6f5c$export$4a8825f3e310b97)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        earlyAssets: (0, $bmKiO.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        ufoName: 'classic-report'
    }),
    (0, $apqRF.createEntry)((0, $3c28aedf6dc41886$export$1e5e610e11119ea7), {
        component: (0, $9zysr.componentWithCondition)((0, $yyqSx.isDevopsFeatureDisabledInFedRamp), (0, $dgH3j.default), (0, $ec8985514c6b606d$export$237924ba64065cc3)),
        layout: (0, $d1szd.genericProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $5w4hM.classicBoardSidebars),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $d32f691d614fbc79$export$8cb713295e6b7204)(),
            (0, $gar3N.devOpsProviderResource)
        ],
        afterPaint: [
            (0, $ec8985514c6b606d$export$956f830ed027f1fb)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $ec8985514c6b606d$export$956f830ed027f1fb)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            reporting: {
                id: (0, $exb0h.ROUTE_NAMES).SOFTWARE_REPORTS_CYCLE_TIME_CLASSIC,
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))((0, $exb0h.ROUTE_NAMES).SOFTWARE_REPORTS_CYCLE_TIME_CLASSIC),
                teamName: 'fusion-solaris'
            }
        }
    }),
    (0, $apqRF.createEntry)((0, $3c28aedf6dc41886$export$d12f3924cf53b545), {
        component: (0, $25bdd577c53f4e0d$export$2e2bcd8739ae039),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $2Fzrk.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)()
        ]
    }),
    (0, $apqRF.createEntry)((0, $3c28aedf6dc41886$export$92f34907c6bf7007), {
        component: (0, $e4bfa5aef8b74e4b$export$2e2bcd8739ae039),
        layout: (0, $soOXK.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS
        },
        resources: [
            (0, $ixwgj.projectContextResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $e4bfa5aef8b74e4b$export$a0f04dd35569e11)
        ],
        perfMetricKey: 'issue-forms-direct'
    }),
    (0, $apqRF.createEntry)((0, $3c28aedf6dc41886$export$16987cdd084cceba), {
        component: (0, $0422b48ebd76799e$export$2e2bcd8739ae039),
        layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
        resources: [
            (0, $ixwgj.projectContextResource)
        ],
        forPaint: [
            (0, $0422b48ebd76799e$export$22681210aaeb910f)
        ],
        perfMetricKey: 'issue-forms-direct-embed'
    }),
    (0, $apqRF.createEntry)((0, $3c28aedf6dc41886$export$312c410cb3b49afe), {
        component: (0, $9zysr.componentWithCondition)((0, $yyqSx.isDevopsFeatureDisabledInFedRamp), (0, $dgH3j.default), (0, $04403e5f90f4354e$export$655707e8ae1053d3)),
        layout: (0, $d1szd.genericProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $5w4hM.classicBoardSidebars),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $d32f691d614fbc79$export$8cb713295e6b7204)(),
            (0, $gar3N.devOpsProviderResource)
        ],
        afterPaint: [
            (0, $04403e5f90f4354e$export$5113b2b19ec1fb53)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $04403e5f90f4354e$export$5113b2b19ec1fb53)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            reporting: {
                id: (0, $exb0h.ROUTE_NAMES).SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY_CLASSIC,
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))((0, $exb0h.ROUTE_NAMES).SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY_CLASSIC),
                teamName: 'fusion-solaris'
            }
        }
    }),
    (0, $e679ac321a72d2f6$export$f2cd114cf8ab53aa),
    (0, $apqRF.createEntry)((0, $3c28aedf6dc41886$export$79c2d9718e914f91), {
        component: (0, $7ba63b5e616f6f5c$export$4ceb6cf2934825b2),
        skeleton: (0, $7msR2.NextGenBacklogSkeleton),
        layout: (0, $isbb2.composeLayouts)((0, $d1szd.genericProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
            {
                query: [
                    'selectedIssue'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $5w4hM.classicBoardSidebars),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $a5edq.getUIFBacklogDataResource)(),
            ...(0, $a5edq.getRapidboardResources)(),
            (0, $a5edq.getRapidBoardDataResource)(),
            ...(0, $hHrVM.getUserBoardNavigationResources)()
        ],
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            $20af5c394dfc25a4$export$edb4b8cf67d7d767
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            capability: $20af5c394dfc25a4$var$classicBacklogCapability
        },
        earlyAssets: (0, $bmKiO.AGGRESSIVE_EARLY_ASSET_STRATEGY)
    }),
    (0, $apqRF.createEntry)((0, $3c28aedf6dc41886$export$7b85bca17717def6), {
        component: (0, $7ba63b5e616f6f5c$export$4ceb6cf2934825b2),
        skeleton: (0, $5d6daf8364cb9d2d$export$d7667341f4db3b8d),
        layout: (0, $d1szd.genericProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $5w4hM.classicBoardSidebars),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $a5edq.getRapidboardResources)(),
            ...(0, $d32f691d614fbc79$export$8cb713295e6b7204)(),
            ...(0, $hHrVM.getUserBoardNavigationResources)()
        ],
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7ba63b5e616f6f5c$export$9de09057ba255cc4),
            (0, $7ba63b5e616f6f5c$export$4a8825f3e310b97)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        earlyAssets: (0, $bmKiO.AGGRESSIVE_EARLY_ASSET_STRATEGY)
    }),
    (0, $f5c4f93889a21dcb$export$cde4dacc737dc0f1),
    (0, $apqRF.createEntry)((0, $3c28aedf6dc41886$export$ff874528b0b33a61), {
        ufoName: 'classic-backlog',
        component: (0, $7ba63b5e616f6f5c$export$4ceb6cf2934825b2),
        skeleton: (0, $7msR2.NextGenBacklogSkeleton),
        layout: (0, $isbb2.composeLayouts)((0, $d1szd.genericProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
            {
                query: [
                    'selectedIssue',
                    'view=planning'
                ]
            }
        ])),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $5w4hM.classicBoardSidebars),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $a5edq.getRapidboardResources)(),
            (0, $a5edq.getRapidBoardDataResource)(),
            ...(0, $hHrVM.getUserBoardNavigationResources)()
        ],
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7ba63b5e616f6f5c$export$9de09057ba255cc4),
            (0, $7ba63b5e616f6f5c$export$4a8825f3e310b97)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        meta: {
            capability: (0, $d07297a4af13004b$export$93104dc4eba58ba4)
        },
        earlyAssets: (0, $bmKiO.AGGRESSIVE_EARLY_ASSET_STRATEGY)
    }),
    (0, $apqRF.createEntry)((0, $3c28aedf6dc41886$export$d27f9ad2fc277ff9), {
        component: (0, $7ba63b5e616f6f5c$export$4ceb6cf2934825b2),
        skeleton: (0, $5d6daf8364cb9d2d$export$d7667341f4db3b8d),
        layout: (0, $d1szd.genericProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $5w4hM.classicBoardSidebars),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $a5edq.getRapidboardResources)(),
            ...(0, $d32f691d614fbc79$export$8cb713295e6b7204)(),
            ...(0, $hHrVM.getUserBoardNavigationResources)()
        ],
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7ba63b5e616f6f5c$export$9de09057ba255cc4),
            (0, $7ba63b5e616f6f5c$export$4a8825f3e310b97)
        ],
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        earlyAssets: (0, $bmKiO.AGGRESSIVE_EARLY_ASSET_STRATEGY),
        ufoName: 'classic-report'
    }),
    (0, $8bf5c03d336a3972$export$4a5b9e48e40676ad),
    (0, $apqRF.createEntry)((0, $3c28aedf6dc41886$export$d92cd77785d00ff), {
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            (0, $5GEOG.codePageResource)
        ],
        component: (0, $9zysr.componentWithCondition)((0, $yyqSx.isDevopsFeatureDisabledInFedRamp), (0, $dgH3j.default), (0, $034dff1bd145500a$export$95e2389b7ca7ccf2)),
        layout: (0, $soOXK.classicSoftwareProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $2Fzrk.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $034dff1bd145500a$export$4beafd9dbad29bff)
        ]
    }),
    (0, $c13ea8e6d002db74$export$8acfebad16c9d6f2),
    (0, $e7eb7b8d4a88bad8$export$dcf1f9ba660dedf6),
    (0, $aefe7ae0a443cf30$export$d7d49c1a51b3c0a9),
    (0, $apqRF.createEntry)((0, $3c28aedf6dc41886$export$991b1be164057e91), {
        component: (0, $4mBNF.RedirectToLastVisitedProjectPage),
        layout: (0, $d1szd.genericProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $5w4hM.classicBoardSidebars),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        isRedirect: true,
        resources: [
            ...(0, $hHrVM.getNavigationResources)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation)
        ]
    }),
    (0, $apqRF.createEntry)((0, $3c28aedf6dc41886$export$3913c8bee519225c), {
        component: $20af5c394dfc25a4$var$ProjectsDirectoryRedirect,
        layout: (0, $dVvIP.globalLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS
        },
        isRedirect: true,
        resources: [
            ...(0, $hHrVM.getNavigationResources)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation)
        ]
    }),
    (0, $f7ee2b416e224377$export$c7d98bfe75274932)
];



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $apqRF = parcelRequire("apqRF");

var $dr1qL = parcelRequire("dr1qL");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $bdf17f7c0239b677$export$48d633ce1d0d2a0e = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).COMPASS_PRODUCT_SETTINGS,
    path: '/jira/settings/products/compass',
    exact: true
};



var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $e9de4186004550fb$var$LazyCompassProductSettingsPage = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("iUVLT"))), {
    moduleId: "./src/packages/spa-apps/compass-product-settings/src/index.tsx"
});
const $e9de4186004550fb$export$cf9d12ec1710006a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e9de4186004550fb$var$LazyCompassProductSettingsPage,
        pageId: "async-compass-product-settings",
        shouldShowSpinner: true
    });
const $e9de4186004550fb$export$703b5090da478c9c = (0, $apqRF.createEntry)((0, $bdf17f7c0239b677$export$48d633ce1d0d2a0e), {
    component: $e9de4186004550fb$export$cf9d12ec1710006a,
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        (0, $dr1qL.compassProductSettingsResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $e9de4186004550fb$var$LazyCompassProductSettingsPage
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $cernH = parcelRequire("cernH");

var $bAQOb = parcelRequire("bAQOb");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $dgH3j = parcelRequire("dgH3j");

var $exb0h = parcelRequire("exb0h");
const $49f2190082d643ec$export$7b2b015fe316fc5d = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).CONFLUENCE_PRODUCT_SETTINGS,
    path: '/jira/settings/products/confluence',
    exact: true
};



var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $ff06b8de8295ef68$var$LazyConfluenceProductSettingsPage = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("aPd1D"))), {
    moduleId: "./src/packages/spa-apps/confluence-product-settings/src/index.tsx"
});
const $ff06b8de8295ef68$export$a094475e0d3636f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $ff06b8de8295ef68$var$LazyConfluenceProductSettingsPage,
        pageId: "async-confluence-product-settings",
        shouldShowSpinner: true
    });
const $ff06b8de8295ef68$export$415552b116808717 = (0, $apqRF.createEntry)((0, $49f2190082d643ec$export$7b2b015fe316fc5d), {
    component: (0, $bAQOb.componentWithFF)('confluence-admin-product-controls', $ff06b8de8295ef68$export$a094475e0d3636f, (0, $dgH3j.default)),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $ff06b8de8295ef68$var$LazyConfluenceProductSettingsPage
    ]
});



var $cernH = parcelRequire("cernH");
// must be in sync with com.atlassian.jira.web.filters.frontend.ConnectGeneralPagesFrontendRoute::matchesRequest
const $ae865171245ba4a0$export$2fdb05fdbf78d595 = [
    'mobile?!=true',
    'includeWebResources?!=true',
    'classifier?!=json'
];



var $exb0h = parcelRequire("exb0h");

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $l90Gp = parcelRequire("l90Gp");

var $5w4hM = parcelRequire("5w4hM");

var $isbb2 = parcelRequire("isbb2");

var $apqRF = parcelRequire("apqRF");

var $4qvmP = parcelRequire("4qvmP");

var $aoOGZ = parcelRequire("aoOGZ");

var $bzNVg = parcelRequire("bzNVg");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $kbHFR = parcelRequire("kbHFR");
const $358ce19a1e550c84$export$9bb839aee83bf4d8 = [
    'selectedItem=(^com.atlassian.plugins.atlassian-connect-plugin.*)'
];



var $exb0h = parcelRequire("exb0h");
const $f088409542fd5ed5$export$1fda4850b6314ff0 = {
    name: (0, $exb0h.ROUTE_NAMES).CONNECT_GENERAL,
    path: '/plugins/servlet/ac/:addonKey/:moduleKey'
};
const $f088409542fd5ed5$export$486ffffd0a2797a5 = {
    name: (0, $exb0h.ROUTE_NAMES).CONNECT_GENERAL_INVALID,
    path: '/plugins/servlet/ac/:addonKey//:moduleKey'
};
const $f088409542fd5ed5$export$e8a58aee75961b55 = {
    name: (0, $exb0h.ROUTE_NAMES).CONNECT_GENERAL_SERVICE_DESK_PROJECT,
    path: '/plugins/servlet/ac/:addonKey/:moduleKey',
    query: [
        'project.key',
        'servicedesk.serviceDeskId'
    ]
};
const $f088409542fd5ed5$export$27e7531864dfb704 = {
    group: (0, $exb0h.ROUTE_GROUPS).CONNECT,
    name: (0, $exb0h.ROUTE_NAMES).CONNECT_PROJECT,
    path: '/projects/:projectKey',
    query: (0, $358ce19a1e550c84$export$9bb839aee83bf4d8)
};
const $f088409542fd5ed5$export$148fcbe26061b2c9 = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_CONNECT_PROJECT,
    path: '/jira/servicedesk/projects/:projectKey',
    query: (0, $358ce19a1e550c84$export$9bb839aee83bf4d8),
    exact: true
};



var $csLgO = parcelRequire("csLgO");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $f0f661eabf62574e$export$c33275abe6c1e577 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("iuR14"))), {
    moduleId: "./src/packages/spa-apps/jira-connect/general-pages/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f0f661eabf62574e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $f0f661eabf62574e$export$c33275abe6c1e577,
        pageId: "connect",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $40ca80f236752c2c$export$3dadc93ff144628f = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("eFDDo"))), {
    moduleId: "./src/packages/spa-apps/jira-connect/project-pages/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$40ca80f236752c2c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $40ca80f236752c2c$export$3dadc93ff144628f,
        pageId: "connect-projects",
        shouldShowSpinner: true
    });


const $d9c2a0c15a2b974b$export$4c06110e7d14ab3c = ()=>[
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $bzNVg.connectProjectResources)
    ];
const $d9c2a0c15a2b974b$export$42d81a9df7aca3f8 = {
    component: (0, $40ca80f236752c2c$export$2e2bcd8739ae039),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $40ca80f236752c2c$export$3dadc93ff144628f)
    ],
    layout: (0, $d1szd.genericProjectLayout),
    ufoName: 'jira-connect'
};
const $d9c2a0c15a2b974b$var$getGeneralConnectRouteResources = ()=>[
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $9CFDS.navigationSidebarGlobalResource),
        ...(0, $l90Gp.getNavigationSidebarGlobalSettingsResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $aoOGZ.connectGeneralResources),
        (0, $dAKwA.getConsolidationStateResource)()
    ];
const $d9c2a0c15a2b974b$var$generalConnectRouteEntry = {
    layout: (0, $isbb2.createLayout)(),
    group: (0, $exb0h.ROUTE_GROUPS).CONNECT,
    query: (0, $ae865171245ba4a0$export$2fdb05fdbf78d595),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).ADDONS,
        sidebar: (0, $5w4hM.genericConnectSidebars)
    },
    component: (0, $f0f661eabf62574e$export$2e2bcd8739ae039),
    resources: $d9c2a0c15a2b974b$var$getGeneralConnectRouteResources(),
    canTransitionIn: (current, next)=>{
        const { query: query } = next.match;
        // must be in sync with com.atlassian.jira.web.filters.frontend.ConnectGeneralPagesFrontendRoute::matchesRequest
        // block transitions to mobile version
        if (query.mobile === 'true' || query.includeWebResources === 'true' || query.classifier === 'json') return false;
        // block transitions to marketplace app as it requires specialised Connect API -
        const emceeKeyRegex = /com\.atlassian\.(jira|confluence)\.emcee($|\.local|\.staging|\.development\..*)/g;
        const addonKey = next.match.params.addonKey || '';
        if (emceeKeyRegex.test(addonKey)) return false;
        return true;
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $f0f661eabf62574e$export$c33275abe6c1e577)
    ],
    ufoName: 'jira-connect'
};
const $d9c2a0c15a2b974b$export$b069a1c4b0240172 = [
    (0, $apqRF.createEntry)((0, $f088409542fd5ed5$export$e8a58aee75961b55), {
        ...$d9c2a0c15a2b974b$var$generalConnectRouteEntry,
        query: [
            ...(0, $ae865171245ba4a0$export$2fdb05fdbf78d595),
            ...(0, $f088409542fd5ed5$export$e8a58aee75961b55).query
        ],
        resources: [
            ...$d9c2a0c15a2b974b$var$getGeneralConnectRouteResources(),
            ...(0, $kbHFR.getServiceDeskNavigationSingleResources)()
        ]
    }),
    (0, $apqRF.createEntry)((0, $f088409542fd5ed5$export$1fda4850b6314ff0), {
        ...$d9c2a0c15a2b974b$var$generalConnectRouteEntry
    }),
    (0, $apqRF.createEntry)((0, $f088409542fd5ed5$export$486ffffd0a2797a5), {
        ...$d9c2a0c15a2b974b$var$generalConnectRouteEntry
    }),
    (0, $apqRF.createEntry)((0, $f088409542fd5ed5$export$27e7531864dfb704), {
        ...$d9c2a0c15a2b974b$export$42d81a9df7aca3f8,
        // Match resources that are fetched for legacyConnectProjectRouteEntry
        // See src/packages/router-routes/legacy/connect-project/entries/src/index.tsx
        resources: [
            ...$d9c2a0c15a2b974b$export$4c06110e7d14ab3c(),
            ...(0, $kbHFR.getServiceDeskSharedNavigationSingleResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ]
    })
];
const $d9c2a0c15a2b974b$export$72138a83eeba68eb = (0, $apqRF.createEntry)((0, $f088409542fd5ed5$export$148fcbe26061b2c9), {
    ...$d9c2a0c15a2b974b$export$42d81a9df7aca3f8,
    layout: (0, $csLgO.serviceProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS
    },
    resources: [
        ...$d9c2a0c15a2b974b$export$4c06110e7d14ab3c(),
        ...(0, $kbHFR.getServiceDeskNavigationResources)(),
        ...(0, $kbHFR.getServicedeskPageContextResources)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $cernH = parcelRequire("cernH");

var $d1szd = parcelRequire("d1szd");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $5c1fd3f0f3f9772c$export$5ce9108542315ac8 = {
    group: (0, $exb0h.ROUTE_GROUPS).COMPONENTS,
    name: (0, $exb0h.ROUTE_NAMES).CREATE_PROJECT,
    path: '/jira/create-project',
    exact: true
};



var $59o4i = parcelRequire("59o4i");

const $5a5a40256ffd86b1$export$5c005d1ab6cfe623 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("jdmp1")), {
    moduleId: "./src/packages/spa-apps/create-project/src/index.tsx"
});
const $5a5a40256ffd86b1$export$43b852e2e1a047e8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $5a5a40256ffd86b1$export$5c005d1ab6cfe623,
        pageId: "spa-apps/create-project",
        shouldShowSpinner: true
    });
const $5a5a40256ffd86b1$export$28887e2da22c839a = (0, $apqRF.createEntry)((0, $5c1fd3f0f3f9772c$export$5ce9108542315ac8), {
    component: $5a5a40256ffd86b1$export$43b852e2e1a047e8,
    layout: (0, $d1szd.genericProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $5a5a40256ffd86b1$export$5c005d1ab6cfe623
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $cernH = parcelRequire("cernH");

var $isbb2 = parcelRequire("isbb2");

var $7rh0R = parcelRequire("7rh0R");

const $5c266ca3d9a01d3f$export$d4768112536c9dc9 = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("eDgQi")), {
    ssr: false,
    moduleId: "./src/packages/global-pages/dashboard/background-scripts/src/ui/index.tsx"
});


const $f26607abd0625889$export$4095842bb2e8d712 = (0, $5c266ca3d9a01d3f$export$d4768112536c9dc9);
$f26607abd0625889$export$4095842bb2e8d712.displayName = 'ConditionalDashboardBackgroundScripts';


const $1255c3ac4b25146e$export$f0a12e66953aa38a = (0, $isbb2.createLayout)({
    globalComponents: [
        (0, $f26607abd0625889$export$4095842bb2e8d712)
    ]
});




var $bmKiO = parcelRequire("bmKiO");

var $1ybV0 = parcelRequire("1ybV0");

var $bAQOb = parcelRequire("bAQOb");

var $dVvIP = parcelRequire("dVvIP");

var $efFTI = parcelRequire("efFTI");

var $7rh0R = parcelRequire("7rh0R");

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");

var $isbb2 = parcelRequire("isbb2");

const $20a3759955606206$export$cb38f5a820347580 = (0, $9zysr.componentWithCondition)(()=>(0, $1ybV0.ff)('opsgenie-consolidation-transitioning-state_d7vm9'), // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("7M10U")).then((module)=>module.TransitionHomeRenderer), {
    ssr: false,
    moduleId: "./src/packages/eoc/changeboarding/src/index.tsx"
}), ()=>null);
$20a3759955606206$export$cb38f5a820347580.displayName = 'AsyncTransitionHomeRenderer';

const $20a3759955606206$export$9cda67d6c86d7b98 = (0, $9zysr.componentWithCondition)(()=>(0, $1ybV0.ff)('opsgenie-consolidation-transitioning-state_d7vm9'), // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("7M10U")).then((module)=>module.WelcomeModalRenderer), {
    ssr: false,
    moduleId: "./src/packages/eoc/changeboarding/src/index.tsx"
}), ()=>null);
$20a3759955606206$export$9cda67d6c86d7b98.displayName = 'AsyncWelcomeModalRenderer';
const $20a3759955606206$export$b8fa7ac7019001bb = (0, $isbb2.createLayout)({
    get globalComponents () {
        return [
            $20a3759955606206$export$cb38f5a820347580,
            $20a3759955606206$export$9cda67d6c86d7b98
        ];
    }
});



var $dVvIP = parcelRequire("dVvIP");

var $isbb2 = parcelRequire("isbb2");
const $f7d46703104602dd$export$5b7fb151d60504c = (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), {
    // both of the components are wrapped with componentWithCondition
    globalComponents: [
        (0, $20a3759955606206$export$cb38f5a820347580),
        (0, $20a3759955606206$export$9cda67d6c86d7b98)
    ]
});



var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $isbb2 = parcelRequire("isbb2");

var $apqRF = parcelRequire("apqRF");

var $01Qi5 = parcelRequire("01Qi5");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $3MEW8 = parcelRequire("3MEW8");

var $jwzNs = parcelRequire("jwzNs");

var $dgH3j = parcelRequire("dgH3j");

var $lMin2 = parcelRequire("lMin2");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

var $eUqFw = parcelRequire("eUqFw");

var $exb0h = parcelRequire("exb0h");

var $10fdS = parcelRequire("10fdS");

var $kJlBc = parcelRequire("kJlBc");

var $atRHQ = parcelRequire("atRHQ");
const $26050f43d4d16eb6$export$da833ddcffcc38ba = ()=>{
    const [{ query: query, location: { hash: hash } }] = (0, $kJlBc.useRouter)();
    const { path: path } = (0, $10fdS.useRouteByName)((0, $exb0h.ROUTE_NAMES).DASHBOARD_VIEW) ?? {};
    if (path == null) throw new Error('Dashboard view route not found');
    const { selectPageId: id } = query;
    const idParam = /^\d+$/.test(id) ? id : 'last-visited';
    const generatedPath = (0, $kJlBc.generatePath)(path, {
        dashboardId: idParam
    });
    const maximizedId = hash.match(/.*\/(?<id>\d+)/)?.groups?.id ?? null;
    const pathWithQuery = maximizedId !== null ? `${generatedPath}?maximized=${maximizedId}` : generatedPath;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
        to: pathWithQuery,
        persistSearchParams: false
    });
};


const $0307822c295b051f$var$dashboardResources = [
    (0, $01Qi5.dashboardConfigAndWRMResource),
    (0, $01Qi5.dashboardAMDModulesResource),
    (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('endeavour.dashboard.support-react-gadgets'), (0, $01Qi5.dashboardReactGadgetsResource)),
    (0, $01Qi5.dashboardForgeResource)
];

const $0307822c295b051f$var$LazyDashboardView = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("4zrAT"))), {
    moduleId: "./src/packages/global-pages/dashboard/view/src/index.tsx"
});

const $0307822c295b051f$var$LazyDashboardViewEmbed = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("6hcuv"))), {
    moduleId: "./src/packages/global-pages/dashboard/view-embed/src/index.tsx"
});

const $0307822c295b051f$var$LazyDashboardWallboard = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("btYOv"))), {
    moduleId: "./src/packages/global-pages/dashboard/wallboard/src/index.tsx"
});

const $0307822c295b051f$var$LazyDashboardEdit = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("bCVfn"))), {
    moduleId: "./src/packages/global-pages/dashboard/edit/src/index.tsx"
});

const $0307822c295b051f$export$c8d59d34c3e8f345 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("jWcDi"))), {
    moduleId: "./src/packages/spa-apps/dashboard/system-dashboard-edit/src/index.tsx"
});

const $0307822c295b051f$export$73396fefc3777e2 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("eJuaR"))), {
    moduleId: "./src/packages/global-pages/dashboard/avp/src/index.tsx"
});
const $0307822c295b051f$export$8d692f4ffba40a2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $0307822c295b051f$var$LazyDashboardView,
        pageId: "dashboard",
        shouldShowSpinner: false
    });
const $0307822c295b051f$export$86d9f777f9d4e312 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $0307822c295b051f$var$LazyDashboardViewEmbed,
        pageId: "dashboard",
        shouldShowSpinner: true
    });
const $0307822c295b051f$export$419b9eec5ed9880d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $0307822c295b051f$var$LazyDashboardWallboard,
        pageId: "dashboard",
        shouldShowSpinner: true
    });
const $0307822c295b051f$export$fb2c0a1de056b738 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $0307822c295b051f$var$LazyDashboardEdit,
        pageId: "dashboard",
        shouldShowSpinner: false
    });
const $0307822c295b051f$export$ae9e46edeb59d61c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $0307822c295b051f$export$73396fefc3777e2,
        pageId: "dashboard",
        shouldShowSpinner: false
    });
const $0307822c295b051f$export$dcd19a888f8c85c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $0307822c295b051f$export$c8d59d34c3e8f345,
        pageId: "system-dashboard-edit",
        shouldShowSpinner: false
    });
const $0307822c295b051f$export$8018993ac33c65f3 = (0, $apqRF.createEntry)((0, $lMin2.AVPDashboardRoute), {
    canTransitionIn: ()=>(0, $1ybV0.ff)('endeavour.dashboard.avp-dashboard-route'),
    component: (0, $bAQOb.componentWithFF)('endeavour.dashboard.avp-dashboard-route', $0307822c295b051f$export$ae9e46edeb59d61c, (0, $dgH3j.default)),
    layout: (0, $dVvIP.globalLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).DASHBOARDS
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $01Qi5.avpDashboardResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $0307822c295b051f$export$73396fefc3777e2
    ],
    isRedirect: false,
    earlyAssets: (0, $bmKiO.NORMAL_EARLY_ASSET_STRATEGY)
});
const $0307822c295b051f$export$9fbbaafb58999ac3 = (0, $apqRF.createEntry)((0, $lMin2.dashboardRoute), {
    component: (0, $26050f43d4d16eb6$export$da833ddcffcc38ba),
    layout: (0, $f7d46703104602dd$export$5b7fb151d60504c),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$0307822c295b051f$var$dashboardResources
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $0307822c295b051f$var$LazyDashboardView
    ],
    meta: {
        capability: (0, $d07297a4af13004b$export$4695c1a423ffe431)
    },
    isRedirect: true,
    earlyAssets: (0, $bmKiO.NORMAL_EARLY_ASSET_STRATEGY)
});
const $0307822c295b051f$export$ac09a8d3ecbafc5 = (0, $apqRF.createEntry)((0, $lMin2.selectedDashboardRoute), {
    component: (0, $26050f43d4d16eb6$export$da833ddcffcc38ba),
    layout: (0, $dVvIP.globalLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).DASHBOARDS
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$0307822c295b051f$var$dashboardResources
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $0307822c295b051f$var$LazyDashboardView
    ],
    meta: {
        capability: (0, $d07297a4af13004b$export$4695c1a423ffe431)
    },
    isRedirect: true,
    earlyAssets: (0, $bmKiO.NORMAL_EARLY_ASSET_STRATEGY)
});
const $0307822c295b051f$export$9b0fdfd6a51a17de = (0, $apqRF.createEntry)((0, $lMin2.dashboardEditRoute), {
    component: $0307822c295b051f$export$fb2c0a1de056b738,
    layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $1255c3ac4b25146e$export$f0a12e66953aa38a)),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).DASHBOARDS
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$0307822c295b051f$var$dashboardResources,
        (0, $01Qi5.gadgetDirectoryResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $0307822c295b051f$var$LazyDashboardEdit
    ],
    meta: {
        capability: (0, $d07297a4af13004b$export$4695c1a423ffe431)
    },
    earlyAssets: (0, $bmKiO.NORMAL_EARLY_ASSET_STRATEGY)
});
const $0307822c295b051f$export$6009dd8e88f1a7de = (0, $apqRF.createEntry)((0, $lMin2.dashboardWallboardRoute), {
    component: $0307822c295b051f$export$419b9eec5ed9880d,
    layout: (0, $isbb2.createLayout)({
        globalComponents: [
            (0, $f26607abd0625889$export$4095842bb2e8d712)
        ],
        // we don't want nav bar and right panel etc to appear in wallboard, so we use chromeless mode
        isChromeless: true
    }),
    resources: [
        (0, $3MEW8.themePreferenceResource),
        ...$0307822c295b051f$var$dashboardResources
    ],
    forPaint: [
        $0307822c295b051f$var$LazyDashboardWallboard
    ],
    meta: {
        capability: (0, $d07297a4af13004b$export$4695c1a423ffe431)
    },
    earlyAssets: (0, $bmKiO.NORMAL_EARLY_ASSET_STRATEGY)
});
const $0307822c295b051f$export$18226b6422149926 = (0, $apqRF.createEntry)((0, $lMin2.dashboardViewRoute), {
    component: $0307822c295b051f$export$8d692f4ffba40a2,
    layout: (0, $isbb2.composeLayouts)((0, $dVvIP.globalLayout), (0, $1255c3ac4b25146e$export$f0a12e66953aa38a)),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).DASHBOARDS
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$0307822c295b051f$var$dashboardResources
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $0307822c295b051f$var$LazyDashboardView
    ],
    meta: {
        capability: (0, $d07297a4af13004b$export$4695c1a423ffe431)
    },
    earlyAssets: (0, $bmKiO.NORMAL_EARLY_ASSET_STRATEGY),
    ufoName: 'dashboard'
});
const $0307822c295b051f$export$73a377380ff671af = (0, $apqRF.createEntry)((0, $lMin2.dashboardViewEmbedRoute), {
    component: $0307822c295b051f$export$86d9f777f9d4e312,
    layout: (0, $isbb2.createLayout)({
        globalComponents: [
            (0, $f26607abd0625889$export$4095842bb2e8d712)
        ],
        isChromeless: true
    }),
    resources: [
        (0, $3MEW8.themePreferenceResource),
        ...$0307822c295b051f$var$dashboardResources
    ],
    forPaint: [
        $0307822c295b051f$var$LazyDashboardViewEmbed
    ],
    meta: {
        capability: (0, $d07297a4af13004b$export$4695c1a423ffe431)
    },
    earlyAssets: (0, $bmKiO.NORMAL_EARLY_ASSET_STRATEGY)
});
const $0307822c295b051f$export$15f76f1b0d2d671 = (0, $apqRF.createEntry)((0, $lMin2.systemDashboardEditRoute), {
    component: $0307822c295b051f$export$dcd19a888f8c85c,
    layout: (0, $isbb2.composeLayouts)((0, $efFTI.globalSettingsLayout), (0, $1255c3ac4b25146e$export$f0a12e66953aa38a)),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $9CFDS.navigationSidebarGlobalResource),
        // IMPORTANT - SSR requires wrm resource must come first
        ...$0307822c295b051f$var$dashboardResources,
        (0, $01Qi5.gadgetDirectoryResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $0307822c295b051f$export$c8d59d34c3e8f345
    ],
    earlyAssets: (0, $bmKiO.NORMAL_EARLY_ASSET_STRATEGY)
});



var $cernH = parcelRequire("cernH");


var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $96cc6f4542e3daac$export$91257312631802bc = {
    group: (0, $exb0h.ROUTE_GROUPS).DEVOPS,
    name: (0, $exb0h.ROUTE_NAMES).DEVOPS_CONNECTED_PROJECT,
    path: '/jira/devops/connected-project'
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $99cde9418829e17b$export$dcd3d20b0038b35c = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("8lNqP"))), {
    moduleId: "./src/packages/spa-apps/devops-connected-project/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$99cde9418829e17b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $99cde9418829e17b$export$dcd3d20b0038b35c,
        pageId: "devops-connected-project",
        shouldShowSpinner: true
    });


const $7dbb3a67a6ba5746$export$ae258fb8ec2c1f86 = (0, $apqRF.createEntry)((0, $96cc6f4542e3daac$export$91257312631802bc), {
    ufoName: 'devops.connected-project',
    component: (0, $99cde9418829e17b$export$2e2bcd8739ae039),
    layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
    resources: [
        ...(0, $hHrVM.getNavigationResources)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $99cde9418829e17b$export$dcd3d20b0038b35c)
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $cernH = parcelRequire("cernH");

var $dVvIP = parcelRequire("dVvIP");

var $7vTKl = parcelRequire("7vTKl");

var $apqRF = parcelRequire("apqRF");

var $9qTfJ = parcelRequire("9qTfJ");

var $hHrVM = parcelRequire("hHrVM");

var $6JBWS = parcelRequire("6JBWS");

var $atRHQ = parcelRequire("atRHQ");

var $1usDU = parcelRequire("1usDU");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");
const $b5ce9d61d78c0c07$var$BoardsDirectoryRedirect = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
        to: "/jira/boards"
    });

const $b5ce9d61d78c0c07$var$LazyBoardsDirectory = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("hu1bz"))), {
    moduleId: "./src/packages/spa-apps/directories/boards/src/index.tsx"
});
const $b5ce9d61d78c0c07$export$3184a385d45edd0d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $b5ce9d61d78c0c07$var$LazyBoardsDirectory,
        pageId: "boards-directory",
        shouldShowSpinner: false
    });
const $b5ce9d61d78c0c07$export$e78b34c999194638 = (0, $apqRF.createEntry)((0, $6JBWS.boardsDirectoryRoute), {
    component: $b5ce9d61d78c0c07$export$3184a385d45edd0d,
    skeleton: (0, $1usDU.BoardsDirectorySkeleton),
    layout: (0, $dVvIP.globalLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $9qTfJ.boardsDirectoryResource)
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $b5ce9d61d78c0c07$var$LazyBoardsDirectory
    ]
});
const $b5ce9d61d78c0c07$export$2a34d21ecf479c40 = (0, $apqRF.createEntry)((0, $6JBWS.boardsDirectoryRedirectRoute), {
    component: $b5ce9d61d78c0c07$var$BoardsDirectoryRedirect,
    skeleton: (0, $1usDU.BoardsDirectorySkeleton),
    layout: (0, $dVvIP.globalLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $9qTfJ.boardsDirectoryResource)
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $b5ce9d61d78c0c07$var$LazyBoardsDirectory
    ],
    isRedirect: true
});


var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $cernH = parcelRequire("cernH");

var $dVvIP = parcelRequire("dVvIP");

var $7vTKl = parcelRequire("7vTKl");

var $apqRF = parcelRequire("apqRF");

var $iREws = parcelRequire("iREws");

var $hHrVM = parcelRequire("hHrVM");

var $bLGeo = parcelRequire("bLGeo");

var $atRHQ = parcelRequire("atRHQ");

var $1usDU = parcelRequire("1usDU");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");
const $de6e961a6ca28e92$var$DashboardsDirectoryRedirect = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
        to: "/jira/dashboards"
    });

const $de6e961a6ca28e92$var$LazyDashboardsDirectory = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("kTcEH"))), {
    moduleId: "./src/packages/spa-apps/directories/dashboards/src/index.tsx"
});
const $de6e961a6ca28e92$export$1cc6cc01050e1215 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $de6e961a6ca28e92$var$LazyDashboardsDirectory,
        pageId: "dashboards-directory",
        shouldShowSpinner: false
    });
const $de6e961a6ca28e92$export$748e329bd0c282a = (0, $apqRF.createEntry)((0, $bLGeo.dashboardsDirectoryRoute), {
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $iREws.dashboardsDirectoryResource)
    ],
    component: $de6e961a6ca28e92$export$1cc6cc01050e1215,
    skeleton: (0, $1usDU.DashboardsDirectorySkeleton),
    layout: (0, $dVvIP.globalLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).DASHBOARDS
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $de6e961a6ca28e92$var$LazyDashboardsDirectory
    ]
});
const $de6e961a6ca28e92$export$8dae8091f8e43b97 = (0, $apqRF.createEntry)((0, $bLGeo.dashboardsDirectoryRedirectRoute), {
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $iREws.dashboardsDirectoryResource)
    ],
    component: !false ? $de6e961a6ca28e92$var$DashboardsDirectoryRedirect : $de6e961a6ca28e92$export$1cc6cc01050e1215,
    skeleton: (0, $1usDU.DashboardsDirectorySkeleton),
    layout: (0, $dVvIP.globalLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).DASHBOARDS
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $de6e961a6ca28e92$var$LazyDashboardsDirectory
    ],
    isRedirect: true
});


var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $cernH = parcelRequire("cernH");

var $dVvIP = parcelRequire("dVvIP");

var $7vTKl = parcelRequire("7vTKl");

var $apqRF = parcelRequire("apqRF");

var $iDevf = parcelRequire("iDevf");

var $hHrVM = parcelRequire("hHrVM");

var $1cmFR = parcelRequire("1cmFR");

var $atRHQ = parcelRequire("atRHQ");

var $1usDU = parcelRequire("1usDU");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");
const $042c6b2255f2865a$export$c56e739d3bb1fe19 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
        to: "/jira/filters"
    });

const $042c6b2255f2865a$var$LazyFiltersDirectory = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("cezjz"))), {
    moduleId: "./src/packages/spa-apps/directories/filters/src/index.tsx"
});
const $042c6b2255f2865a$export$e5d735e83dacb7c7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $042c6b2255f2865a$var$LazyFiltersDirectory,
        pageId: "filters-directory",
        shouldShowSpinner: false
    });
const $042c6b2255f2865a$export$ca77bc660994f51f = (0, $apqRF.createEntry)((0, $1cmFR.filtersDirectoryRoute), {
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $iDevf.filtersDirectoryResource)
    ],
    component: $042c6b2255f2865a$export$e5d735e83dacb7c7,
    skeleton: (0, $1usDU.FiltersDirectorySkeleton),
    layout: (0, $dVvIP.globalLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).FILTERS
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $042c6b2255f2865a$var$LazyFiltersDirectory
    ]
});
const $042c6b2255f2865a$export$41fb3f2a3e68c7c3 = (0, $apqRF.createEntry)((0, $1cmFR.filtersDirectoryRedirectRoute), {
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $iDevf.filtersDirectoryResource)
    ],
    component: !false ? $042c6b2255f2865a$export$c56e739d3bb1fe19 : $042c6b2255f2865a$export$e5d735e83dacb7c7,
    skeleton: (0, $1usDU.FiltersDirectorySkeleton),
    layout: (0, $dVvIP.globalLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).FILTERS
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $042c6b2255f2865a$var$LazyFiltersDirectory
    ],
    isRedirect: true
});
const $042c6b2255f2865a$export$c2ec350ee9e78717 = (0, $apqRF.createEntry)((0, $1cmFR.secureFiltersDirectoryRedirectRoute), {
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $iDevf.filtersDirectoryResource)
    ],
    component: !false ? $042c6b2255f2865a$export$c56e739d3bb1fe19 : $042c6b2255f2865a$export$e5d735e83dacb7c7,
    skeleton: (0, $1usDU.FiltersDirectorySkeleton),
    layout: (0, $dVvIP.globalLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).FILTERS
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $042c6b2255f2865a$var$LazyFiltersDirectory
    ],
    isRedirect: true
});


var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $cernH = parcelRequire("cernH");

var $dVvIP = parcelRequire("dVvIP");

var $7vTKl = parcelRequire("7vTKl");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $jsQSa = parcelRequire("jsQSa");

var $1usDU = parcelRequire("1usDU");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $0437c5d740028c1f$var$LazyPlansDirectory = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("dfmD0"))), {
    moduleId: "./src/packages/spa-apps/directories/plans/src/index.tsx"
});
const $0437c5d740028c1f$export$8f357abd0af482a2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $0437c5d740028c1f$var$LazyPlansDirectory,
        pageId: "plans-directory",
        shouldShowSpinner: false
    });
const $0437c5d740028c1f$export$4f9df77811fbdc1f = (0, $apqRF.createEntry)((0, $jsQSa.plansDirectoryRoute), {
    component: $0437c5d740028c1f$export$8f357abd0af482a2,
    skeleton: (0, $1usDU.PlansDirectorySkeleton),
    layout: (0, $dVvIP.globalLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)()
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PLANS
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $0437c5d740028c1f$var$LazyPlansDirectory
    ]
});


var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $cernH = parcelRequire("cernH");


var $79xbN = parcelRequire("79xbN");

var $efFTI = parcelRequire("efFTI");

var $dtQ1T = parcelRequire("dtQ1T");


var $7vTKl = parcelRequire("7vTKl");

var $7hF3Y = parcelRequire("7hF3Y");

var $isbb2 = parcelRequire("isbb2");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $610DX = parcelRequire("610DX");

var $1iihP = parcelRequire("1iihP");

var $atRHQ = parcelRequire("atRHQ");

var $1usDU = parcelRequire("1usDU");

var $79xbN = parcelRequire("79xbN");

var $huI7r = parcelRequire("huI7r");
/**
 * @generated SignedSource<<e3bbb27bd6dc09ebb517466e1084d5d8>>
 * @relayHash 33443d3c71a93e19039c1ddf91e01c8b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 662fd8d1f9c5eb8fd7858db090e25a7b50b561452bb8cf112ce7e305b62eb98f
const $1edfe7973f92fd6b$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "662fd8d1f9c5eb8fd7858db090e25a7b50b561452bb8cf112ce7e305b62eb98f",
        "metadata": {},
        "name": "pageLayout_projectsDirectoryLayout_RootQuery",
        "operationKind": "query",
        "text": null
    }
};
var $1edfe7973f92fd6b$export$2e2bcd8739ae039 = $1edfe7973f92fd6b$var$node;



var $49WjJ = parcelRequire("49WjJ");

var $gNjcN = parcelRequire("gNjcN");

var $cFcvW = parcelRequire("cFcvW");
const $56cd2298ea4ccb6d$var$cache = (0, $49WjJ.createCache)(new Map());
function $56cd2298ea4ccb6d$export$58f934f3d33a84b6(loader, opts) {
    return $56cd2298ea4ccb6d$var$cache.get(opts.moduleId, ()=>(0, $gNjcN.PreloadableJSResource)(()=>(0, $cFcvW.postTask)(loader, {
                priority: 'user-blocking'
            }), opts));
}



var $7QhYz = parcelRequire("7QhYz");
const $10e750a37e6b8440$var$DEFAULT_LIMIT = 25;
const $10e750a37e6b8440$var$PROJECTS_DIRECTORY_MANAGE = 'projects-directory-manage';
const $10e750a37e6b8440$var$DefaultFilterFields = {
    // sorting
    SortOrder: 'sortOrder',
    SortKey: 'sortKey',
    // pagination
    Page: 'page'
};
var $10e750a37e6b8440$var$TableColumns;
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
(function(TableColumns) {
    TableColumns["Favourites"] = "favourites";
    TableColumns["Key"] = "key";
    TableColumns["Name"] = "name";
    TableColumns["Type"] = "type";
    TableColumns["Lead"] = "lead";
    TableColumns["Category"] = "category";
    TableColumns["LastIssueUpdate"] = "last_issue_updated_time";
    TableColumns["Url"] = "url";
    TableColumns["Action"] = "actions";
})($10e750a37e6b8440$var$TableColumns || ($10e750a37e6b8440$var$TableColumns = {}));
const $10e750a37e6b8440$var$SortableColumns = [
    "key",
    "name",
    "lead",
    "category",
    "last_issue_updated_time"
];
const $10e750a37e6b8440$var$FilterFields = {
    Keyword: 'keyword',
    ProjectType: 'types',
    ProjectCategoryId: 'projectCategoryId',
    ...$10e750a37e6b8440$var$DefaultFilterFields
};
const $10e750a37e6b8440$var$filterAliasMap = {
    contains: $10e750a37e6b8440$var$FilterFields.Keyword,
    selectedProjectType: $10e750a37e6b8440$var$FilterFields.ProjectType,
    selectedCategory: $10e750a37e6b8440$var$FilterFields.ProjectCategoryId
};
const $10e750a37e6b8440$var$filterInitialState = {
    [$10e750a37e6b8440$var$FilterFields.Keyword]: '',
    [$10e750a37e6b8440$var$FilterFields.ProjectType]: '',
    [$10e750a37e6b8440$var$FilterFields.ProjectCategoryId]: '',
    [$10e750a37e6b8440$var$FilterFields.SortOrder]: 'ASC',
    [$10e750a37e6b8440$var$FilterFields.SortKey]: "name",
    [$10e750a37e6b8440$var$FilterFields.Page]: '1'
};
const $10e750a37e6b8440$var$LEGACY_ALL_VALUE = 'all';
const $10e750a37e6b8440$var$sanitizeLegacyQuery = (query = {})=>({
        ...query,
        selectedProjectType: query.selectedProjectType === $10e750a37e6b8440$var$LEGACY_ALL_VALUE ? $10e750a37e6b8440$var$filterInitialState[$10e750a37e6b8440$var$FilterFields.ProjectType] : query.selectedProjectType,
        selectedCategory: query.selectedCategory === $10e750a37e6b8440$var$LEGACY_ALL_VALUE ? $10e750a37e6b8440$var$filterInitialState[$10e750a37e6b8440$var$FilterFields.ProjectCategoryId] : query.selectedCategory
    });
const $10e750a37e6b8440$var$matchAliases = (filterState, query, aliases)=>Object.keys(query).reduce((filter, key)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const alias = aliases[key];
        const queryValue = query[key];
        const hasInitialValue = filter[key] !== undefined;
        // override default filter value with query params
        if (hasInitialValue && queryValue) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-param-reassign
            filter[key] = queryValue;
            return filter;
        }
        // if there's no alias and no query param for it return default filter
        if (!alias || !queryValue) return filter;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-param-reassign
        filter[alias] = queryValue;
        return filter;
    }, {
        ...filterState
    });
const $10e750a37e6b8440$var$CORE_PROJECT = 'business';
const $10e750a37e6b8440$var$SOFTWARE_PROJECT = 'software';
const $10e750a37e6b8440$var$SERVICE_DESK_PROJECT = 'service_desk';
const $10e750a37e6b8440$var$PRODUCT_DISCOVERY_PROJECT = 'product_discovery';
const $10e750a37e6b8440$var$PROJECT_TYPES = [
    $10e750a37e6b8440$var$CORE_PROJECT,
    $10e750a37e6b8440$var$SOFTWARE_PROJECT,
    $10e750a37e6b8440$var$SERVICE_DESK_PROJECT,
    $10e750a37e6b8440$var$PRODUCT_DISCOVERY_PROJECT
];
const $10e750a37e6b8440$var$mapQueryToFilter = (filter, { cloudId: cloudId, query: query, aliases: aliases })=>{
    const variables = {};
    const { [$10e750a37e6b8440$var$FilterFields.Keyword]: keyword, [$10e750a37e6b8440$var$FilterFields.ProjectCategoryId]: projectCategoryId, [$10e750a37e6b8440$var$FilterFields.ProjectType]: types, [$10e750a37e6b8440$var$FilterFields.SortOrder]: sortOrder, [$10e750a37e6b8440$var$FilterFields.SortKey]: sortKey } = aliases && query ? $10e750a37e6b8440$var$matchAliases(filter, query, aliases) : filter;
    if (keyword) variables.keyword = keyword;
    if (projectCategoryId) variables.projectCategoryId = (0, $huI7r.isAri)(projectCategoryId) ? projectCategoryId : (0, $huI7r.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'project-category',
        resourceId: projectCategoryId
    });
    if (sortKey || sortOrder) {
        const sortByValue = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        sortKey && $10e750a37e6b8440$var$SortableColumns.includes(sortKey) ? sortKey : $10e750a37e6b8440$var$filterInitialState[$10e750a37e6b8440$var$FilterFields.SortKey];
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        variables.sortBy = {
            order: [
                'ASC',
                'DESC'
            ].includes(sortOrder) ? sortOrder : $10e750a37e6b8440$var$filterInitialState[$10e750a37e6b8440$var$FilterFields.SortOrder],
            sortBy: sortByValue.toUpperCase()
        };
    }
    if (types && typeof types === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    variables.types = types.split(',') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .filter((type)=>$10e750a37e6b8440$var$PROJECT_TYPES.includes(type)).map((type)=>type.toUpperCase());
    return variables;
};

const $10e750a37e6b8440$export$80225215a10b2688 = (0, $7QhYz.createEntryPoint)({
    root: (0, $56cd2298ea4ccb6d$export$58f934f3d33a84b6)(()=>(parcelRequire("jTDO7")), {
        moduleId: "b77224b3"
    }),
    getPreloadProps ({ context: { query: query, route: route }, tenantContext: tenantContext }) {
        const { cloudId: cloudId, isAnonymous: isAnonymous } = tenantContext;
        const extraProps = {
            isAdminProjectDirectoryRoute: route.name === $10e750a37e6b8440$var$PROJECTS_DIRECTORY_MANAGE
        };
        if (false && isAnonymous) return {
            extraProps: extraProps
        };
        return {
            queries: {
                projectsDirectoryPage: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: (0, $1edfe7973f92fd6b$export$2e2bcd8739ae039),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        filter: $10e750a37e6b8440$var$mapQueryToFilter($10e750a37e6b8440$var$filterInitialState, {
                            cloudId: cloudId,
                            query: $10e750a37e6b8440$var$sanitizeLegacyQuery(query),
                            aliases: $10e750a37e6b8440$var$filterAliasMap
                        }),
                        first: query?.page ? $10e750a37e6b8440$var$DEFAULT_LIMIT * (parseInt(query.page, 10) || 1) : $10e750a37e6b8440$var$DEFAULT_LIMIT,
                        last: $10e750a37e6b8440$var$DEFAULT_LIMIT,
                        isAdminSettingsContext: route.name === $10e750a37e6b8440$var$PROJECTS_DIRECTORY_MANAGE,
                        isAnonymous: isAnonymous,
                        isProjectListSidebarExperimentEnabled: (0, $79xbN.expValEquals)('contextual_bandits_reccs_in_projects_directory', 'cohort', 'variation')
                    }
                }
            },
            extraProps: extraProps
        };
    }
});



var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");
const $f0febcd6986df40f$export$b68dd6112a931c10 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
        to: "/jira/projects"
    });
const $f0febcd6986df40f$export$74316a0a4963952b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
        to: "/jira/settings/projects/manage"
    });

const $f0febcd6986df40f$var$LazyProjectsDirectory = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("3a2nq"))), {
    moduleId: "./src/packages/spa-apps/directories/projects-v3/src/index.tsx"
});
const $f0febcd6986df40f$var$LazyAdminProjectsDirectory = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f0febcd6986df40f$var$LazyProjectsDirectory, {
        isAdminProjectDirectoryRoute: true
    });
const $f0febcd6986df40f$export$ba9ef00f25a4745e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $f0febcd6986df40f$var$LazyAdminProjectsDirectory,
        pageId: "projects-directory-manage-v3",
        shouldShowSpinner: false
    });
const $f0febcd6986df40f$var$rightSidebars = ()=>{
    if (!false) return (0, $79xbN.expValEquals)('contextual_bandits_reccs_in_projects_directory', 'cohort', 'variation') ? [
        (0, $dtQ1T.JiraProjectsTemplateListRightPanel)
    ] : [];
    return [];
};
const $f0febcd6986df40f$var$projectsDirectoryHomepageLayout = ()=>(0, $isbb2.composeLayouts)((0, $f7d46703104602dd$export$5b7fb151d60504c), {
        rightSidebars: $f0febcd6986df40f$var$rightSidebars()
    });
const $f0febcd6986df40f$var$projectsDirectorySettingsLayout = ()=>(0, $isbb2.composeLayouts)((0, $efFTI.globalSettingsLayout), {
        rightSidebars: $f0febcd6986df40f$var$rightSidebars()
    });
const $f0febcd6986df40f$export$95eb2991dd9e4bc3 = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $10e750a37e6b8440$export$80225215a10b2688),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});
const $f0febcd6986df40f$export$79292a834772288c = (0, $apqRF.createEntry)((0, $1iihP.projectsDirectoryRoute), {
    entryPoint () {
        return $f0febcd6986df40f$export$95eb2991dd9e4bc3;
    },
    skeleton: (0, $1usDU.ProjectsDirectorySkeleton),
    layout: $f0febcd6986df40f$var$projectsDirectoryHomepageLayout(),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)()
    ],
    ufoName: 'projects-directory-v3'
});
const $f0febcd6986df40f$var$adminProjectDirectoryResources = [
    (0, $9CFDS.navigationSidebarGlobalResource),
    (0, $610DX.projectsDirectoryPageResource)
];
const $f0febcd6986df40f$export$d5b1a46987369ee4 = (0, $apqRF.createEntry)((0, $1iihP.manageProjectsDirectoryRoute), {
    component: $f0febcd6986df40f$export$ba9ef00f25a4745e,
    skeleton: (0, $1usDU.ProjectsDirectorySkeleton),
    layout: $f0febcd6986df40f$var$projectsDirectorySettingsLayout(),
    navigation: {
        sidebar: (0, $7hF3Y.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$f0febcd6986df40f$var$adminProjectDirectoryResources
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $f0febcd6986df40f$var$LazyProjectsDirectory
    ],
    ufoName: 'projects-directory-v3-manage'
});
const $f0febcd6986df40f$export$445f7414e382a69c = [
    (0, $apqRF.createEntry)((0, $1iihP.projectsDirectoryRedirectRoute), {
        component: $f0febcd6986df40f$export$b68dd6112a931c10,
        skeleton: (0, $1usDU.ProjectsDirectorySkeleton),
        isRedirect: true,
        layout: $f0febcd6986df40f$var$projectsDirectoryHomepageLayout(),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $610DX.projectsDirectoryPageResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            $f0febcd6986df40f$var$LazyProjectsDirectory
        ]
    }),
    (0, $apqRF.createEntry)((0, $1iihP.projectsDirectoryLegacyPathRedirectRoute), {
        component: $f0febcd6986df40f$export$b68dd6112a931c10,
        skeleton: (0, $1usDU.ProjectsDirectorySkeleton),
        isRedirect: true,
        layout: $f0febcd6986df40f$var$projectsDirectoryHomepageLayout(),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $610DX.projectsDirectoryPageResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            $f0febcd6986df40f$var$LazyProjectsDirectory
        ]
    }),
    $f0febcd6986df40f$export$79292a834772288c,
    (0, $apqRF.createEntry)((0, $1iihP.projectsDirectoryManageRedirectRoute), {
        component: $f0febcd6986df40f$export$74316a0a4963952b,
        skeleton: (0, $1usDU.ProjectsDirectorySkeleton),
        isRedirect: true,
        layout: $f0febcd6986df40f$var$projectsDirectorySettingsLayout(),
        navigation: {
            sidebar: (0, $7hF3Y.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...$f0febcd6986df40f$var$adminProjectDirectoryResources
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            $f0febcd6986df40f$var$LazyProjectsDirectory
        ]
    }),
    $f0febcd6986df40f$export$d5b1a46987369ee4,
    (0, $apqRF.createEntry)((0, $1iihP.projectsDirectoryManageRootRedirectRoute), {
        component: $f0febcd6986df40f$export$74316a0a4963952b,
        skeleton: (0, $1usDU.ProjectsDirectorySkeleton),
        isRedirect: true,
        layout: $f0febcd6986df40f$var$projectsDirectorySettingsLayout(),
        navigation: {
            sidebar: (0, $7hF3Y.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...$f0febcd6986df40f$var$adminProjectDirectoryResources
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            $f0febcd6986df40f$var$LazyProjectsDirectory
        ]
    })
];



var $eUqFw = parcelRequire("eUqFw");

var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $av9ef = parcelRequire("av9ef");

var $9RvDp = parcelRequire("9RvDp");

const $e7d9de3b8f852c57$export$a1b7c53ff39475a6 = (0, $7rh0R.lazyForPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("lSIIo")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/eoc-team-dashboard/src/index.tsx"
});
const $e7d9de3b8f852c57$var$TeamDashboardSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "eocTeamDashboard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e7d9de3b8f852c57$export$a1b7c53ff39475a6, null));
$e7d9de3b8f852c57$var$TeamDashboardSidebar.displayName = 'TeamDashboardSidebar';
var $e7d9de3b8f852c57$export$2e2bcd8739ae039 = $e7d9de3b8f852c57$var$TeamDashboardSidebar;



var $7okz2 = parcelRequire("7okz2");

var $7rh0R = parcelRequire("7rh0R");

var $isbb2 = parcelRequire("isbb2");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ecb9d07fa6a7199c$var$RightSidebars = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("k2rA6")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/ops-team-layout/src/ui/right-sidebars/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ecb9d07fa6a7199c$var$Onboarding = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("7qhPD")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/ops-team-layout/src/ui/onboarding/index.tsx"
});
const $ecb9d07fa6a7199c$export$53dd27149810df73 = (0, $isbb2.createLayout)({
    get globalComponents () {
        return [
            $ecb9d07fa6a7199c$var$Onboarding
        ];
    },
    rightSidebars: [
        $ecb9d07fa6a7199c$var$RightSidebars
    ]
});



var $apqRF = parcelRequire("apqRF");

var $ad7aK = parcelRequire("ad7aK");

var $j7qZ1 = parcelRequire("j7qZ1");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $86a7d9ee7fc180be$export$73d6a0dc298aae15 = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_ALERT_ISSUE_SYNCING,
    path: '/jira/settings/products/ops/syncs'
};
const $86a7d9ee7fc180be$export$f271eef5f9ec6602 = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_ALERT_ISSUE_SYNCING_CREATE,
    path: '/jira/settings/products/ops/syncs/create'
};
const $86a7d9ee7fc180be$export$f1b4093ef603b98d = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_ALERT_ISSUE_SYNCING_DETAIL,
    path: '/jira/settings/products/ops/syncs/:syncId'
};
const $86a7d9ee7fc180be$export$37ea7624561cbb89 = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_TEAM_ALERT_ISSUE_SYNCING,
    path: '/jira/ops/teams/:teamId/syncs'
};
const $86a7d9ee7fc180be$export$915ef1948fe4650a = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_TEAM_ALERT_ISSUE_SYNCING_CREATE,
    path: '/jira/ops/teams/:teamId/syncs/create'
};
const $86a7d9ee7fc180be$export$e91535fc2137c3b = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_TEAM_ALERT_ISSUE_SYNCING_DETAIL,
    path: '/jira/ops/teams/:teamId/syncs/:syncId'
};



var $59o4i = parcelRequire("59o4i");

var $7rh0R = parcelRequire("7rh0R");

const $f47ef9a3a328c7b7$export$dbbcce89c7be1e71 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("2qQKu")).then((module)=>module.AlertIssueSync), {
    moduleId: "./src/packages/eoc/eoc-alert-issue-syncing/src/index.tsx"
});

const $f47ef9a3a328c7b7$export$ff3e9ed7471eebce = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("2qQKu")).then((module)=>module.AlertIssueSyncCreate), {
    moduleId: "./src/packages/eoc/eoc-alert-issue-syncing/src/index.tsx"
});

const $f47ef9a3a328c7b7$export$75137a2a583918e2 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("2qQKu")).then((module)=>module.AlertIssueSyncDetail), {
    moduleId: "./src/packages/eoc/eoc-alert-issue-syncing/src/index.tsx"
});


const $ff5a93f464a3dafa$export$5a4922ba79d730f4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: (0, $f47ef9a3a328c7b7$export$dbbcce89c7be1e71),
        pageId: "async-jira-eoc-alert-issue-syncing",
        shouldShowSpinner: true
    });
const $ff5a93f464a3dafa$export$c21f2a7e1aa801a7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: (0, $f47ef9a3a328c7b7$export$75137a2a583918e2),
        pageId: "async-jira-eoc-alert-issue-syncing",
        shouldShowSpinner: true
    });
const $ff5a93f464a3dafa$export$a26f24c49385cf3a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: (0, $f47ef9a3a328c7b7$export$ff3e9ed7471eebce),
        pageId: "async-jira-eoc-alert-issue-syncing",
        shouldShowSpinner: true
    });
const $ff5a93f464a3dafa$export$c63d0942ec0f93c = (0, $apqRF.createEntry)((0, $86a7d9ee7fc180be$export$73d6a0dc298aae15), {
    component: $ff5a93f464a3dafa$export$5a4922ba79d730f4,
    // @ts-expect-error - 'slot' and 'basePath' do not exist in type Route
    slot: null,
    basePath: '/jira/settings/products/ops',
    exact: true,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        (0, $ad7aK.resources).configuredSyncsResource,
        (0, $ad7aK.resources).userAccessRightsResource
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $f47ef9a3a328c7b7$export$dbbcce89c7be1e71)
    ]
});
const $ff5a93f464a3dafa$export$7e604b22ae6e7c1e = (0, $apqRF.createEntry)((0, $86a7d9ee7fc180be$export$f1b4093ef603b98d), {
    component: $ff5a93f464a3dafa$export$5a4922ba79d730f4,
    // @ts-expect-error - 'slot' and 'basePath' do not exist in type Route
    slot: $ff5a93f464a3dafa$export$c21f2a7e1aa801a7,
    basePath: '/jira/settings/products/ops',
    exact: true,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        (0, $ad7aK.resources).configuredSyncsResource,
        (0, $ad7aK.resources).userAccessRightsResource
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $f47ef9a3a328c7b7$export$dbbcce89c7be1e71)
    ]
});
const $ff5a93f464a3dafa$export$92f4b6644eb6cb88 = (0, $apqRF.createEntry)((0, $86a7d9ee7fc180be$export$f271eef5f9ec6602), {
    component: $ff5a93f464a3dafa$export$5a4922ba79d730f4,
    // @ts-expect-error - 'slot' and 'basePath' do not exist in type Route
    slot: $ff5a93f464a3dafa$export$a26f24c49385cf3a,
    basePath: '/jira/settings/products/ops',
    exact: true,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        (0, $ad7aK.resources).configuredSyncsResource,
        (0, $ad7aK.resources).userAccessRightsResource
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $f47ef9a3a328c7b7$export$dbbcce89c7be1e71)
    ]
});
const $ff5a93f464a3dafa$export$be342a3401146aae = (0, $apqRF.createEntry)((0, $86a7d9ee7fc180be$export$37ea7624561cbb89), {
    component: $ff5a93f464a3dafa$export$5a4922ba79d730f4,
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    // @ts-expect-error - 'slot' and 'basePath' do not exist in type Route
    slot: null,
    basePath: '/jira/ops/teams',
    exact: true,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $j7qZ1.resources),
        (0, $dAKwA.getConsolidationStateResource)(),
        (0, $ad7aK.resources).configuredSyncsResource,
        (0, $ad7aK.resources).userAccessRightsResource
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE,
        sidebar: (0, $e7d9de3b8f852c57$export$2e2bcd8739ae039)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $f47ef9a3a328c7b7$export$dbbcce89c7be1e71),
        (0, $e7d9de3b8f852c57$export$a1b7c53ff39475a6)
    ]
});
const $ff5a93f464a3dafa$export$6298ff494c460e75 = (0, $apqRF.createEntry)((0, $86a7d9ee7fc180be$export$e91535fc2137c3b), {
    component: $ff5a93f464a3dafa$export$5a4922ba79d730f4,
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    // @ts-expect-error - 'slot' and 'basePath' do not exist in type Route
    slot: $ff5a93f464a3dafa$export$c21f2a7e1aa801a7,
    basePath: '/jira/ops/teams',
    exact: true,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $j7qZ1.resources),
        (0, $dAKwA.getConsolidationStateResource)(),
        (0, $ad7aK.resources).configuredSyncsResource,
        (0, $ad7aK.resources).userAccessRightsResource
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE,
        sidebar: (0, $e7d9de3b8f852c57$export$2e2bcd8739ae039)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $f47ef9a3a328c7b7$export$dbbcce89c7be1e71),
        (0, $e7d9de3b8f852c57$export$a1b7c53ff39475a6)
    ]
});
const $ff5a93f464a3dafa$export$8c07dc381591dc69 = (0, $apqRF.createEntry)((0, $86a7d9ee7fc180be$export$915ef1948fe4650a), {
    component: $ff5a93f464a3dafa$export$5a4922ba79d730f4,
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    // @ts-expect-error - 'slot' and 'basePath' do not exist in type Route
    slot: $ff5a93f464a3dafa$export$a26f24c49385cf3a,
    basePath: '/jira/ops/teams',
    exact: true,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $j7qZ1.resources),
        (0, $dAKwA.getConsolidationStateResource)(),
        (0, $ad7aK.resources).configuredSyncsResource,
        (0, $ad7aK.resources).userAccessRightsResource
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE,
        sidebar: (0, $e7d9de3b8f852c57$export$2e2bcd8739ae039)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $f47ef9a3a328c7b7$export$dbbcce89c7be1e71),
        (0, $e7d9de3b8f852c57$export$a1b7c53ff39475a6)
    ]
});
const $ff5a93f464a3dafa$export$cf5b5978205b681 = [
    $ff5a93f464a3dafa$export$be342a3401146aae,
    $ff5a93f464a3dafa$export$8c07dc381591dc69,
    $ff5a93f464a3dafa$export$6298ff494c460e75,
    $ff5a93f464a3dafa$export$c63d0942ec0f93c,
    $ff5a93f464a3dafa$export$92f4b6644eb6cb88,
    $ff5a93f464a3dafa$export$7e604b22ae6e7c1e
];



var $7rqR2 = parcelRequire("7rqR2");

var $cernH = parcelRequire("cernH");

var $bAQOb = parcelRequire("bAQOb");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $dgH3j = parcelRequire("dgH3j");

var $exb0h = parcelRequire("exb0h");
const $4f0ea76b81d9faaf$export$84985159d5695f4d = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_API_KEY_MANAGEMENT,
    path: '/jira/settings/products/ops/api-key-management',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $2c4b41528d011ed4$export$6ae4b26c31b1b0d2 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("nnFEm")), {
    moduleId: "./src/packages/eoc/api-key-management/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2c4b41528d011ed4$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $2c4b41528d011ed4$export$6ae4b26c31b1b0d2,
        pageId: "async-jira-eoc-api-key-management",
        shouldShowSpinner: false
    });


const $5f3f0c448e8043d7$export$e18a6be3d2ffad71 = (0, $apqRF.createEntry)((0, $4f0ea76b81d9faaf$export$84985159d5695f4d), {
    component: (0, $bAQOb.componentWithFF)('eoc-api-key-management-feature-jira_8ox4z', (0, $2c4b41528d011ed4$export$2e2bcd8739ae039), (0, $dgH3j.default)),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        ...(0, $7rqR2.resources)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $2c4b41528d011ed4$export$6ae4b26c31b1b0d2)
    ]
});



var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $apqRF = parcelRequire("apqRF");

var $lI1Uu = parcelRequire("lI1Uu");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $exb0h = parcelRequire("exb0h");
const $e890e68c22b0e26c$export$79c37191a61ac94b = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_ASSIGN_CUSTOM_ROLES,
    path: '/jira/settings/products/ops/role-assignment',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $0abde6eadfb27723$export$fb6bafef9453a357 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("hSvrR")), {
    moduleId: "./src/packages/eoc/assign-custom-roles/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0abde6eadfb27723$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $0abde6eadfb27723$export$fb6bafef9453a357,
        pageId: "async-eoc-assign-custom-roles",
        shouldShowSpinner: false
    });


const $836b69bb0e37d149$export$c51a4ee3e3f1b270 = (0, $apqRF.createEntry)((0, $e890e68c22b0e26c$export$79c37191a61ac94b), {
    component: (0, $0abde6eadfb27723$export$2e2bcd8739ae039),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $lI1Uu.resources),
        (0, $dAKwA.getConsolidationStateResource)(),
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $0abde6eadfb27723$export$fb6bafef9453a357)
    ]
});



var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");



var $apqRF = parcelRequire("apqRF");

var $j7qZ1 = parcelRequire("j7qZ1");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $81df91959959d55f$export$4a84eb4d8d37c9d4 = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_AUTOMATIONS,
    path: '/jira/ops/teams/:teamId/automations',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $4b364006ac7300d8$export$903a0a44cc0933c5 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("gdyB9")), {
    moduleId: "./src/packages/spa-apps/ops-team-scope-automation/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4b364006ac7300d8$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $4b364006ac7300d8$export$903a0a44cc0933c5,
        pageId: "ops-team-automation",
        shouldShowSpinner: true
    });


const $56a8577e9ca176db$export$6ff606556e19e12 = (0, $apqRF.createEntry)((0, $81df91959959d55f$export$4a84eb4d8d37c9d4), {
    component: (0, $4b364006ac7300d8$export$2e2bcd8739ae039),
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $j7qZ1.resources),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE,
        sidebar: (0, $e7d9de3b8f852c57$export$2e2bcd8739ae039)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $4b364006ac7300d8$export$903a0a44cc0933c5),
        (0, $e7d9de3b8f852c57$export$a1b7c53ff39475a6)
    ]
});



var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $apqRF = parcelRequire("apqRF");

var $ehMsm = parcelRequire("ehMsm");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $exb0h = parcelRequire("exb0h");
const $5ffd604d51686cd6$export$3213a7325ca9911 = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_CUSTOM_ROLES,
    path: '/jira/settings/products/ops/roles',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $70bbb4b7a9db4433$export$78ed54710f55f948 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("estMG")), {
    moduleId: "./src/packages/eoc/custom-roles/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$70bbb4b7a9db4433$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $70bbb4b7a9db4433$export$78ed54710f55f948,
        pageId: "async-eoc-custom-roles",
        shouldShowSpinner: false
    });


const $497df763957e5b2d$export$9c9bab95d425eb6f = (0, $apqRF.createEntry)((0, $5ffd604d51686cd6$export$3213a7325ca9911), {
    component: (0, $70bbb4b7a9db4433$export$2e2bcd8739ae039),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $ehMsm.resources),
        (0, $dAKwA.getConsolidationStateResource)(),
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $70bbb4b7a9db4433$export$78ed54710f55f948)
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $cernH = parcelRequire("cernH");


var $7vTKl = parcelRequire("7vTKl");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $9RvDp = parcelRequire("9RvDp");

const $cb1b672dbf28422d$export$674fd99c08c90491 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("5qcjh")).then((bundle)=>bundle), {
    moduleId: "./src/packages/navigation-apps/sidebar/eoc-global-alerts/src/index.tsx"
});
const $cb1b672dbf28422d$export$a1c034c1031e8711 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "eocGlobalAlerts"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cb1b672dbf28422d$export$674fd99c08c90491, null));



var $apqRF = parcelRequire("apqRF");

var $dQHDS = parcelRequire("dQHDS");

var $l96PT = parcelRequire("l96PT");

var $1ZiFa = parcelRequire("1ZiFa");

var $l19Qj = parcelRequire("l19Qj");

var $633Zo = parcelRequire("633Zo");

var $604AA = parcelRequire("604AA");
const $c239ad117e0fe0f0$export$bc99aaabaf7b70a7 = [
    (0, $604AA.uiPreferencesResource),
    (0, $633Zo.savedSearchesResource),
    (0, $l19Qj.compressionRatioResource),
    (0, $1ZiFa.alertGroupingStateResource),
    ...(0, $l96PT.eocCommonResources)()
];



var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $fOu5W = parcelRequire("fOu5W");

var $59o4i = parcelRequire("59o4i");

const $723988f9339967b5$export$f4aafff31d950b6c = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("8xofD")), {
    moduleId: "./src/packages/eoc/alert-list/src/index.tsx"
});
const $723988f9339967b5$export$9333bfa567c9c31 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $723988f9339967b5$export$f4aafff31d950b6c,
        pageId: "async-jira-eoc-alert-list",
        shouldShowSpinner: false
    });
const $723988f9339967b5$export$851a659e50436cff = (0, $apqRF.createEntry)((0, $fOu5W.eocGlobalAlertListRoute), {
    component: $723988f9339967b5$export$9333bfa567c9c31,
    layout: (0, $20a3759955606206$export$b8fa7ac7019001bb),
    exact: true,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $c239ad117e0fe0f0$export$bc99aaabaf7b70a7),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).HOME,
        sidebar: (0, $cb1b672dbf28422d$export$a1c034c1031e8711)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $723988f9339967b5$export$f4aafff31d950b6c,
        (0, $cb1b672dbf28422d$export$674fd99c08c90491)
    ]
});
const $723988f9339967b5$export$bcb93d8198d511b9 = (0, $apqRF.createEntry)((0, $fOu5W.eocGlobalAlertDetailRoute), {
    component: $723988f9339967b5$export$9333bfa567c9c31,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $c239ad117e0fe0f0$export$bc99aaabaf7b70a7),
        ...(0, $dQHDS.resources),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).HOME,
        sidebar: (0, $cb1b672dbf28422d$export$a1c034c1031e8711)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $723988f9339967b5$export$f4aafff31d950b6c,
        (0, $cb1b672dbf28422d$export$674fd99c08c90491)
    ]
});
const $723988f9339967b5$export$283761ff41b53cba = [
    $723988f9339967b5$export$851a659e50436cff,
    $723988f9339967b5$export$bcb93d8198d511b9
];



var $cernH = parcelRequire("cernH");

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");

var $7vTKl = parcelRequire("7vTKl");




var $apqRF = parcelRequire("apqRF");


var $334z5 = parcelRequire("334z5");

var $j7qZ1 = parcelRequire("j7qZ1");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $dgH3j = parcelRequire("dgH3j");

var $exb0h = parcelRequire("exb0h");
const $45158a8fc0365467$export$e6569aff8dfd4c1d = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_GLOBAL_GROUP_DETAIL,
    path: '/jira/ops/group-detail/:id',
    exact: true
};
const $45158a8fc0365467$export$aa8cf61e94739f21 = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_TEAM_GROUP_DETAIL,
    path: '/jira/ops/teams/:teamId/group-detail/:id',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $e8aa2f68dc64c9ba$export$8d4b3992eb19d436 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("8cFeQ")), {
    moduleId: "./src/packages/eoc/group-detail/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e8aa2f68dc64c9ba$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e8aa2f68dc64c9ba$export$8d4b3992eb19d436,
        pageId: "async-jira-eoc-group-detail",
        shouldShowSpinner: false
    });


const $c7e50fdddf86bc76$export$66928ab349190059 = (0, $apqRF.createEntry)((0, $45158a8fc0365467$export$e6569aff8dfd4c1d), {
    component: (0, $9zysr.componentWithCondition)(()=>(0, $1ybV0.ff)('platform.aiops-smart-view_yf5qp'), (0, $e8aa2f68dc64c9ba$export$2e2bcd8739ae039), (0, $dgH3j.default)),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $334z5.resources),
        (0, $dAKwA.getConsolidationStateResource)(),
        ...(0, $c239ad117e0fe0f0$export$bc99aaabaf7b70a7)
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).HOME,
        sidebar: (0, $cb1b672dbf28422d$export$a1c034c1031e8711)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $e8aa2f68dc64c9ba$export$8d4b3992eb19d436),
        (0, $cb1b672dbf28422d$export$674fd99c08c90491)
    ]
});
const $c7e50fdddf86bc76$export$2b25520e20820251 = (0, $apqRF.createEntry)((0, $45158a8fc0365467$export$aa8cf61e94739f21), {
    component: (0, $9zysr.componentWithCondition)(()=>(0, $1ybV0.ff)('platform.aiops-smart-view_yf5qp'), (0, $e8aa2f68dc64c9ba$export$2e2bcd8739ae039), (0, $dgH3j.default)),
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $j7qZ1.resources),
        ...(0, $334z5.resources),
        (0, $dAKwA.getConsolidationStateResource)(),
        ...(0, $c239ad117e0fe0f0$export$bc99aaabaf7b70a7)
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE,
        sidebar: (0, $e7d9de3b8f852c57$export$2e2bcd8739ae039)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $e8aa2f68dc64c9ba$export$8d4b3992eb19d436),
        (0, $e7d9de3b8f852c57$export$a1b7c53ff39475a6)
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");



var $apqRF = parcelRequire("apqRF");

var $kimHz = parcelRequire("kimHz");

var $j7qZ1 = parcelRequire("j7qZ1");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $73a3755e2adcdefa$export$e935ec688da4c447 = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_HEARTBEATS,
    path: '/jira/ops/teams/:teamId/heartbeats'
};



var $59o4i = parcelRequire("59o4i");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e24a5dc60e9548ab$var$LazyHeartbeats = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("k2L8t")), {
    moduleId: "./src/packages/eoc/heartbeats/src/index.tsx"
});
const $e24a5dc60e9548ab$var$HeartbeatsComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e24a5dc60e9548ab$var$LazyHeartbeats,
        pageId: "async-jira-eoc-heartbeats",
        shouldShowSpinner: false
    });
const $e24a5dc60e9548ab$export$2c2d6115c4280a08 = (0, $apqRF.createEntry)((0, $73a3755e2adcdefa$export$e935ec688da4c447), {
    exact: true,
    component: $e24a5dc60e9548ab$var$HeartbeatsComponent,
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $kimHz.resources),
        ...(0, $j7qZ1.resources),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE,
        sidebar: (0, $e7d9de3b8f852c57$export$2e2bcd8739ae039)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $e24a5dc60e9548ab$var$LazyHeartbeats,
        (0, $e7d9de3b8f852c57$export$a1b7c53ff39475a6)
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $apqRF = parcelRequire("apqRF");

var $3sohY = parcelRequire("3sohY");

var $8KuNc = parcelRequire("8KuNc");
const $c32eca581f357969$export$c83d9fd41123ab31 = [
    (0, $8KuNc.listResource)
];
const $c32eca581f357969$export$63630293105c0f4e = [
    (0, $3sohY.detailResource)
];



var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $3327a57d6229c9c0$export$8dd2e8adca05d8a3 = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_INCOMING_CALL,
    path: '/jira/settings/products/ops/incoming-call'
};
const $3327a57d6229c9c0$export$10f19333da6ac52c = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_INCOMING_CALL_DETAIL,
    path: '/jira/settings/products/ops/incoming-call/:id'
};



var $59o4i = parcelRequire("59o4i");

var $7rh0R = parcelRequire("7rh0R");

const $7f90b06af83f4670$export$d76e6607b7e88a7b = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("gIEtO")).then((module)=>module.IncomingCallPage), {
    moduleId: "./src/packages/eoc/incoming-call/src/index.tsx"
});

const $7f90b06af83f4670$export$1c56f2b1fdd5d724 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("gIEtO")).then((module)=>module.IncomingCallDetailPage), {
    moduleId: "./src/packages/eoc/incoming-call/src/index.tsx"
});


const $2424a38c91d6dd07$export$742ca8be503e0313 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: (0, $7f90b06af83f4670$export$d76e6607b7e88a7b),
        pageId: "async-jira-eoc-incoming-call",
        shouldShowSpinner: false
    });
const $2424a38c91d6dd07$export$6ec51edee1972588 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: (0, $7f90b06af83f4670$export$1c56f2b1fdd5d724),
        pageId: "async-jira-eoc-incoming-call-detail",
        shouldShowSpinner: false
    });
const $2424a38c91d6dd07$export$bf8ccc758901febd = (0, $apqRF.createEntry)((0, $3327a57d6229c9c0$export$8dd2e8adca05d8a3), {
    exact: true,
    component: $2424a38c91d6dd07$export$742ca8be503e0313,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        ...(0, $c32eca581f357969$export$c83d9fd41123ab31)
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $7f90b06af83f4670$export$d76e6607b7e88a7b)
    ]
});
const $2424a38c91d6dd07$export$39f40714591c98c0 = (0, $apqRF.createEntry)((0, $3327a57d6229c9c0$export$10f19333da6ac52c), {
    exact: true,
    component: $2424a38c91d6dd07$export$6ec51edee1972588,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        ...(0, $c32eca581f357969$export$63630293105c0f4e)
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $7f90b06af83f4670$export$d76e6607b7e88a7b)
    ]
});
const $2424a38c91d6dd07$export$5d3c7bc3dee8745d = [
    $2424a38c91d6dd07$export$bf8ccc758901febd,
    $2424a38c91d6dd07$export$39f40714591c98c0
];



var $eUqFw = parcelRequire("eUqFw");

var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");


var $7okz2 = parcelRequire("7okz2");


var $apqRF = parcelRequire("apqRF");

var $l96PT = parcelRequire("l96PT");

var $5VwcT = parcelRequire("5VwcT");

var $fwrvW = parcelRequire("fwrvW");

var $5duOT = parcelRequire("5duOT");

var $3Vasl = parcelRequire("3Vasl");
const $c218c297dcbb4ebe$export$bc99aaabaf7b70a7 = [
    (0, $3Vasl.uiSettingsResource),
    (0, $5duOT.logsResource),
    (0, $5VwcT.byokInformationResource),
    ...(0, $l96PT.eocCommonResources)()
];
const $c218c297dcbb4ebe$export$8571305c82629fe4 = [
    (0, $fwrvW.downloadAuditLogsResource),
    ...(0, $l96PT.eocCommonResources)()
];



var $feAZB = parcelRequire("feAZB");

var $j7qZ1 = parcelRequire("j7qZ1");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $eb65b0a90865591f$export$400ead354c81dee3 = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_TEAM_INTEGRATIONS,
    path: '/jira/ops/teams/:teamId/integrations'
};
const $eb65b0a90865591f$export$b8218f375778e6d7 = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_TEAM_INTEGRATION_LIST,
    path: '/jira/ops/teams/:teamId/integrations/list'
};
const $eb65b0a90865591f$export$a2ec7da6c43acbbf = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_TEAM_INTEGRATION_CREATE,
    path: '/jira/ops/teams/:teamId/integrations/create/:type'
};
const $eb65b0a90865591f$export$72169399df792b7c = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_TEAM_INTEGRATION_DETAIL,
    path: '/jira/ops/teams/:teamId/integrations/:type/:integrationId'
};
const $eb65b0a90865591f$export$ca02d7b2c7df3d60 = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_TEAM_INTEGRATION_LOG,
    path: '/jira/ops/teams/:teamId/integrations/:type/:integrationId/logs'
};
const $eb65b0a90865591f$export$e196ff2390a1ec56 = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_INTEGRATIONS,
    path: '/jira/settings/products/ops/integrations'
};
const $eb65b0a90865591f$export$270e16f240db883b = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_INTEGRATION_LIST,
    path: '/jira/settings/products/ops/integrations/list'
};
const $eb65b0a90865591f$export$bb272d36e3c3b7c1 = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_INTEGRATION_CREATE,
    path: '/jira/settings/products/ops/integrations/create/:type'
};
const $eb65b0a90865591f$export$f826f15073eda98 = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_INTEGRATION_DETAIL,
    path: '/jira/settings/products/ops/integrations/:type/:integrationId'
};
const $eb65b0a90865591f$export$71884dc820e415fc = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_INTEGRATION_LOG,
    path: '/jira/settings/products/ops/integrations/:type/:integrationId/logs'
};



var $59o4i = parcelRequire("59o4i");

var $7rh0R = parcelRequire("7rh0R");

const $47d50c35ad481237$export$68c40afda0287b61 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("2OmMO")).then((module)=>module.IntegrationAutomation), {
    moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
});

const $47d50c35ad481237$export$fd7f60e3df94c902 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("2OmMO")).then((module)=>module.IntegrationDetail), {
    moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
});

const $47d50c35ad481237$export$aa9358ade7cb53ee = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("2OmMO")).then((module)=>module.IntegrationCreate), {
    moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
});

const $47d50c35ad481237$export$993132b847f26efa = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("2OmMO")).then((module)=>module.IntegrationList), {
    moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
});

const $47d50c35ad481237$export$b02ef932401d95fc = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("2OmMO")).then((module)=>module.IntegrationLog), {
    moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
});


const $0e57ebaaa2758857$export$434c3e2269913ac0 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: (0, $47d50c35ad481237$export$68c40afda0287b61),
        pageId: "async-jira-eoc-integration-automation",
        shouldShowSpinner: true
    });
const $0e57ebaaa2758857$export$8bb99f196e0be5b6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: (0, $47d50c35ad481237$export$fd7f60e3df94c902),
        pageId: "async-jira-eoc-integration-automation",
        shouldShowSpinner: true
    });
const $0e57ebaaa2758857$export$5cb14595364f02c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: (0, $47d50c35ad481237$export$aa9358ade7cb53ee),
        pageId: "async-jira-eoc-integration-automation",
        shouldShowSpinner: true
    });
const $0e57ebaaa2758857$export$955768269b79c203 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: (0, $47d50c35ad481237$export$993132b847f26efa),
        pageId: "async-jira-eoc-integration-automation",
        shouldShowSpinner: true
    });
const $0e57ebaaa2758857$export$b545b4a4c4cee016 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: (0, $47d50c35ad481237$export$b02ef932401d95fc),
        pageId: "async-jira-eoc-integration-automation",
        shouldShowSpinner: true
    });
const $0e57ebaaa2758857$export$ded9494f81dd2a4d = (0, $apqRF.createEntry)((0, $eb65b0a90865591f$export$400ead354c81dee3), {
    // @ts-expect-error - 'slot' and 'basePath' do not exist in type Route
    basePath: '/jira/ops/teams',
    exact: true,
    component: $0e57ebaaa2758857$export$434c3e2269913ac0,
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    slot: null,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $j7qZ1.resources),
        (0, $dAKwA.getConsolidationStateResource)(),
        (0, $feAZB.resources).configuredIntegrationsResource,
        (0, $feAZB.resources).userAccessRightsResource
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE,
        sidebar: (0, $e7d9de3b8f852c57$export$2e2bcd8739ae039)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $47d50c35ad481237$export$68c40afda0287b61),
        (0, $e7d9de3b8f852c57$export$a1b7c53ff39475a6)
    ]
});
const $0e57ebaaa2758857$export$52ee366e7b51f38d = (0, $apqRF.createEntry)((0, $eb65b0a90865591f$export$b8218f375778e6d7), {
    // @ts-expect-error - 'slot' and 'basePath' do not exist in type Route
    basePath: '/jira/ops/teams',
    exact: true,
    component: $0e57ebaaa2758857$export$434c3e2269913ac0,
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    slot: $0e57ebaaa2758857$export$955768269b79c203,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $j7qZ1.resources),
        (0, $dAKwA.getConsolidationStateResource)(),
        (0, $feAZB.resources).integrationListResource,
        (0, $feAZB.resources).userAccessRightsResource
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE,
        sidebar: (0, $e7d9de3b8f852c57$export$2e2bcd8739ae039)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $47d50c35ad481237$export$68c40afda0287b61),
        (0, $e7d9de3b8f852c57$export$a1b7c53ff39475a6)
    ]
});
const $0e57ebaaa2758857$export$83aea99d18750f08 = (0, $apqRF.createEntry)((0, $eb65b0a90865591f$export$a2ec7da6c43acbbf), {
    // @ts-expect-error - 'slot' and 'basePath' do not exist in type Route
    basePath: '/jira/ops/teams',
    exact: true,
    component: $0e57ebaaa2758857$export$434c3e2269913ac0,
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    slot: $0e57ebaaa2758857$export$5cb14595364f02c,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $j7qZ1.resources),
        (0, $dAKwA.getConsolidationStateResource)(),
        (0, $feAZB.resources).configuredIntegrationsResource,
        (0, $feAZB.resources).integrationListResource,
        (0, $feAZB.resources).userAccessRightsResource
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE,
        sidebar: (0, $e7d9de3b8f852c57$export$2e2bcd8739ae039)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $47d50c35ad481237$export$68c40afda0287b61),
        (0, $e7d9de3b8f852c57$export$a1b7c53ff39475a6)
    ]
});
const $0e57ebaaa2758857$export$7e0b6b79953422c1 = (0, $apqRF.createEntry)((0, $eb65b0a90865591f$export$72169399df792b7c), {
    // @ts-expect-error - 'slot' and 'basePath' do not exist in type Route
    basePath: '/jira/ops/teams',
    exact: true,
    component: $0e57ebaaa2758857$export$434c3e2269913ac0,
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    slot: $0e57ebaaa2758857$export$8bb99f196e0be5b6,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $j7qZ1.resources),
        (0, $dAKwA.getConsolidationStateResource)(),
        (0, $feAZB.resources).configuredIntegrationsResource,
        (0, $feAZB.resources).userAccessRightsResource
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE,
        sidebar: (0, $e7d9de3b8f852c57$export$2e2bcd8739ae039)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $47d50c35ad481237$export$68c40afda0287b61),
        (0, $e7d9de3b8f852c57$export$a1b7c53ff39475a6)
    ]
});
const $0e57ebaaa2758857$export$d5e169223d2a5d1d = (0, $apqRF.createEntry)((0, $eb65b0a90865591f$export$ca02d7b2c7df3d60), {
    // @ts-expect-error - 'slot' and 'basePath' do not exist in type Route
    basePath: '/jira/ops/teams',
    component: $0e57ebaaa2758857$export$434c3e2269913ac0,
    slot: $0e57ebaaa2758857$export$b545b4a4c4cee016,
    exact: true,
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $j7qZ1.resources),
        ...(0, $c218c297dcbb4ebe$export$bc99aaabaf7b70a7),
        (0, $dAKwA.getConsolidationStateResource)(),
        (0, $feAZB.resources).configuredIntegrationsResource,
        (0, $feAZB.resources).userAccessRightsResource
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE,
        sidebar: (0, $e7d9de3b8f852c57$export$2e2bcd8739ae039)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $47d50c35ad481237$export$68c40afda0287b61),
        (0, $e7d9de3b8f852c57$export$a1b7c53ff39475a6)
    ]
});
const $0e57ebaaa2758857$export$6e5cd6656076550f = (0, $apqRF.createEntry)((0, $eb65b0a90865591f$export$e196ff2390a1ec56), {
    // @ts-expect-error - 'slot' and 'basePath' do not exist in type Route
    basePath: '/jira/settings/products/ops',
    exact: true,
    component: $0e57ebaaa2758857$export$434c3e2269913ac0,
    slot: null,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        (0, $feAZB.resources).configuredIntegrationsResource,
        (0, $feAZB.resources).userAccessRightsResource
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $47d50c35ad481237$export$68c40afda0287b61)
    ]
});
const $0e57ebaaa2758857$export$790602da39f8af00 = (0, $apqRF.createEntry)((0, $eb65b0a90865591f$export$270e16f240db883b), {
    // @ts-expect-error - 'slot' and 'basePath' do not exist in type Route
    basePath: '/jira/settings/products/ops',
    exact: true,
    component: $0e57ebaaa2758857$export$434c3e2269913ac0,
    slot: $0e57ebaaa2758857$export$955768269b79c203,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        (0, $feAZB.resources).integrationListResource,
        (0, $feAZB.resources).userAccessRightsResource
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $47d50c35ad481237$export$68c40afda0287b61)
    ]
});
const $0e57ebaaa2758857$export$62eef9a2917f041f = (0, $apqRF.createEntry)((0, $eb65b0a90865591f$export$bb272d36e3c3b7c1), {
    // @ts-expect-error - 'slot' and 'basePath' do not exist in type Route
    basePath: '/jira/settings/products/ops',
    exact: true,
    component: $0e57ebaaa2758857$export$434c3e2269913ac0,
    slot: $0e57ebaaa2758857$export$5cb14595364f02c,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        (0, $feAZB.resources).configuredIntegrationsResource,
        (0, $feAZB.resources).integrationListResource,
        (0, $feAZB.resources).userAccessRightsResource
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $47d50c35ad481237$export$68c40afda0287b61)
    ]
});
const $0e57ebaaa2758857$export$b66abbccbf93e9ad = (0, $apqRF.createEntry)((0, $eb65b0a90865591f$export$f826f15073eda98), {
    // @ts-expect-error - 'slot' and 'basePath' do not exist in type Route
    basePath: '/jira/settings/products/ops',
    exact: true,
    component: $0e57ebaaa2758857$export$434c3e2269913ac0,
    slot: $0e57ebaaa2758857$export$8bb99f196e0be5b6,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        (0, $feAZB.resources).configuredIntegrationsResource,
        (0, $feAZB.resources).userAccessRightsResource
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $47d50c35ad481237$export$68c40afda0287b61)
    ]
});
const $0e57ebaaa2758857$export$d30f51d0f351bd8a = (0, $apqRF.createEntry)((0, $eb65b0a90865591f$export$71884dc820e415fc), {
    // @ts-expect-error - 'slot' and 'basePath' do not exist in type Route
    basePath: '/jira/settings/products/ops',
    component: $0e57ebaaa2758857$export$434c3e2269913ac0,
    slot: $0e57ebaaa2758857$export$b545b4a4c4cee016,
    exact: true,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        ...(0, $c218c297dcbb4ebe$export$bc99aaabaf7b70a7),
        (0, $feAZB.resources).configuredIntegrationsResource,
        (0, $feAZB.resources).userAccessRightsResource
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $47d50c35ad481237$export$68c40afda0287b61)
    ]
});
const $0e57ebaaa2758857$export$de0b5a5b87cf45f3 = [
    $0e57ebaaa2758857$export$ded9494f81dd2a4d,
    $0e57ebaaa2758857$export$52ee366e7b51f38d,
    $0e57ebaaa2758857$export$83aea99d18750f08,
    $0e57ebaaa2758857$export$7e0b6b79953422c1,
    $0e57ebaaa2758857$export$d5e169223d2a5d1d,
    $0e57ebaaa2758857$export$6e5cd6656076550f,
    $0e57ebaaa2758857$export$790602da39f8af00,
    $0e57ebaaa2758857$export$62eef9a2917f041f,
    $0e57ebaaa2758857$export$b66abbccbf93e9ad,
    $0e57ebaaa2758857$export$d30f51d0f351bd8a
];



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");


var $7okz2 = parcelRequire("7okz2");


var $apqRF = parcelRequire("apqRF");

var $krDiu = parcelRequire("krDiu");

var $j7qZ1 = parcelRequire("j7qZ1");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $d578ddb3405fb9b8$export$b997369a5c2dab54 = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_MAINTENANCE,
    path: '/jira/ops/teams/:teamId/maintenance'
};
const $d578ddb3405fb9b8$export$9d65c6548c3b50e4 = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_GLOBAL_MAINTENANCE,
    path: '/jira/settings/products/ops/maintenance'
};



var $59o4i = parcelRequire("59o4i");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2ee957ede87673df$var$LazyMaintenance = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("cUdAf")), {
    moduleId: "./src/packages/eoc/maintenance/src/index.tsx"
});
const $2ee957ede87673df$var$MaintenanceComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $2ee957ede87673df$var$LazyMaintenance,
        pageId: "async-jira-eoc-maintenance",
        shouldShowSpinner: false
    });
const $2ee957ede87673df$var$eocMaintenanceRouteEntry = (0, $apqRF.createEntry)((0, $d578ddb3405fb9b8$export$b997369a5c2dab54), {
    exact: true,
    component: $2ee957ede87673df$var$MaintenanceComponent,
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $krDiu.resources),
        ...(0, $j7qZ1.resources),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE,
        sidebar: (0, $e7d9de3b8f852c57$export$2e2bcd8739ae039)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $2ee957ede87673df$var$LazyMaintenance,
        (0, $e7d9de3b8f852c57$export$a1b7c53ff39475a6)
    ]
});
const $2ee957ede87673df$var$eocGlobalMaintenanceRouteEntry = (0, $apqRF.createEntry)((0, $d578ddb3405fb9b8$export$9d65c6548c3b50e4), {
    exact: true,
    component: $2ee957ede87673df$var$MaintenanceComponent,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        ...(0, $krDiu.resources)
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $2ee957ede87673df$var$LazyMaintenance
    ]
});
const $2ee957ede87673df$export$ed40a3967b4f2617 = [
    $2ee957ede87673df$var$eocMaintenanceRouteEntry,
    $2ee957ede87673df$var$eocGlobalMaintenanceRouteEntry
];



var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");



var $apqRF = parcelRequire("apqRF");

var $3tXdL = parcelRequire("3tXdL");

var $j7qZ1 = parcelRequire("j7qZ1");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $4cdf55d595c85e35$export$18cec3860c46aaf2 = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: `${(0, $exb0h.ROUTE_NAMES).EOC_ON_CALL}-redirect`,
    path: '/jira/ops/teams/:teamId',
    exact: true
};
const $4cdf55d595c85e35$export$5eaa466ae8a4d7d3 = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_ON_CALL,
    path: '/jira/ops/teams/:teamId/on-call',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $kJlBc = parcelRequire("kJlBc");

var $59o4i = parcelRequire("59o4i");
const $6f9c82d4fbdfb1c3$export$659b7ce11c160b32 = ()=>{
    const [routeContext] = (0, $kJlBc.useRouter)();
    const redirectionUrl = `${routeContext.location.pathname}/on-call`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
        to: redirectionUrl
    });
};

const $6f9c82d4fbdfb1c3$export$772095aa22362f73 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("iiVjl")), {
    moduleId: "./src/packages/eoc/on-call/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6f9c82d4fbdfb1c3$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $6f9c82d4fbdfb1c3$export$772095aa22362f73,
        pageId: "async-jira-eoc-on-call",
        shouldShowSpinner: false
    });


const $d6dfbe2316b32236$export$ac245212b12db871 = (0, $apqRF.createEntry)((0, $4cdf55d595c85e35$export$18cec3860c46aaf2), {
    component: (0, $6f9c82d4fbdfb1c3$export$659b7ce11c160b32),
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $j7qZ1.resources)
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE,
        sidebar: (0, $e7d9de3b8f852c57$export$2e2bcd8739ae039)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $e7d9de3b8f852c57$export$a1b7c53ff39475a6)
    ],
    isRedirect: true
});
const $d6dfbe2316b32236$export$8657ca08ca5cbfc6 = (0, $apqRF.createEntry)((0, $4cdf55d595c85e35$export$5eaa466ae8a4d7d3), {
    component: (0, $6f9c82d4fbdfb1c3$export$2e2bcd8739ae039),
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $j7qZ1.resources),
        ...(0, $3tXdL.resources),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE,
        sidebar: (0, $e7d9de3b8f852c57$export$2e2bcd8739ae039)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $6f9c82d4fbdfb1c3$export$772095aa22362f73),
        (0, $e7d9de3b8f852c57$export$a1b7c53ff39475a6)
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");

var $apqRF = parcelRequire("apqRF");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $fda413a2ca3a89c5$export$cb929d46451a5c12 = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_OVERVIEW,
    path: '/jira/ops/overview'
};



var $59o4i = parcelRequire("59o4i");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e108d633ec33a0c8$var$LazyOverviewPage = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("hobYe")).then((m)=>m.OverviewPage), {
    moduleId: "./src/packages/eoc/overview/src/index.tsx"
});
const $e108d633ec33a0c8$var$EocOverviewComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e108d633ec33a0c8$var$LazyOverviewPage,
        pageId: "async-jira-eoc-alert-overview",
        shouldShowSpinner: false
    });
const $e108d633ec33a0c8$export$f1a859c727c30be4 = (0, $apqRF.createEntry)((0, $fda413a2ca3a89c5$export$cb929d46451a5c12), {
    exact: true,
    component: $e108d633ec33a0c8$var$EocOverviewComponent,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).HOME
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation)
    ]
});



var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");



var $apqRF = parcelRequire("apqRF");

var $14cNX = parcelRequire("14cNX");

var $j7qZ1 = parcelRequire("j7qZ1");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $387f3f7779158766$export$8e6afd724de3be6e = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_PERMISSIONS,
    path: '/jira/ops/teams/:teamId/settings',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $786c0202514ba385$export$27b4fb95241ab47 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("cgjGF")), {
    moduleId: "./src/packages/eoc/member-roles/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$786c0202514ba385$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $786c0202514ba385$export$27b4fb95241ab47,
        pageId: "async-jira-eoc-member-roles",
        shouldShowSpinner: false
    });


const $ae796711ad3c7e93$export$c2ced436a30c60dc = (0, $apqRF.createEntry)((0, $387f3f7779158766$export$8e6afd724de3be6e), {
    component: (0, $786c0202514ba385$export$2e2bcd8739ae039),
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $14cNX.resources),
        ...(0, $j7qZ1.resources),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE,
        sidebar: (0, $e7d9de3b8f852c57$export$2e2bcd8739ae039)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $786c0202514ba385$export$27b4fb95241ab47),
        (0, $e7d9de3b8f852c57$export$a1b7c53ff39475a6)
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");


var $7okz2 = parcelRequire("7okz2");


var $apqRF = parcelRequire("apqRF");

var $jy52b = parcelRequire("jy52b");

var $j7qZ1 = parcelRequire("j7qZ1");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $4a150a7c155d6075$export$eab7ea9e54b67f16 = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_TEAM_POLICIES,
    path: '/jira/ops/teams/:teamId/policies'
};
const $4a150a7c155d6075$export$4eb24a8e860a3df7 = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_POLICIES,
    path: '/jira/settings/products/ops/policies'
};



var $59o4i = parcelRequire("59o4i");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2be3fd10da5a8d41$var$LazyAlertPolicies = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("2c1UM")), {
    moduleId: "./src/packages/eoc/policies/src/index.tsx"
});
const $2be3fd10da5a8d41$var$AlertPoliciesComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $2be3fd10da5a8d41$var$LazyAlertPolicies,
        pageId: "async-jira-eoc-alert-policies",
        shouldShowSpinner: false
    });
const $2be3fd10da5a8d41$export$eb1e2324ca2031e2 = (0, $apqRF.createEntry)((0, $4a150a7c155d6075$export$eab7ea9e54b67f16), {
    exact: true,
    component: $2be3fd10da5a8d41$var$AlertPoliciesComponent,
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $jy52b.resources),
        ...(0, $j7qZ1.resources),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE,
        sidebar: (0, $e7d9de3b8f852c57$export$2e2bcd8739ae039)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $2be3fd10da5a8d41$var$LazyAlertPolicies,
        (0, $e7d9de3b8f852c57$export$a1b7c53ff39475a6)
    ]
});
const $2be3fd10da5a8d41$export$2ee2f43d380cc210 = (0, $apqRF.createEntry)((0, $4a150a7c155d6075$export$4eb24a8e860a3df7), {
    exact: true,
    component: $2be3fd10da5a8d41$var$AlertPoliciesComponent,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        ...(0, $jy52b.resources)
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $2be3fd10da5a8d41$var$LazyAlertPolicies
    ]
});
const $2be3fd10da5a8d41$export$3a28949e52d2d60f = [
    $2be3fd10da5a8d41$export$eb1e2324ca2031e2,
    $2be3fd10da5a8d41$export$2ee2f43d380cc210
];



var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");



var $apqRF = parcelRequire("apqRF");

var $ieLL2 = parcelRequire("ieLL2");

var $j7qZ1 = parcelRequire("j7qZ1");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $6bded2ea1ecf081d$export$e3124ff5345907f6 = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_REPORTS,
    path: '/jira/ops/teams/:teamId/reports',
    exact: true
};
const $6bded2ea1ecf081d$export$72cde899ee974e6e = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_REPORTS_UNSUBSCRIBE,
    path: '/jira/ops/reports/unsubscribe/:templateId/:subscriptionId',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $a40f85b59bd30935$export$2404f0e35deca592 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("9c8ch")), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $a40f85b59bd30935$export$d33ea1a773b744e = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("9c8ch")).then((exportedMembers)=>exportedMembers.OpsReportsRedirect), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $a40f85b59bd30935$export$66850ec5549adba6 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("9c8ch")).then((exportedMembers)=>exportedMembers.GlobalOpsReports), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $a40f85b59bd30935$export$5fd77c3bbfb22cbd = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("9c8ch")).then((exportedMembers)=>exportedMembers.OpsReportsUnsubscribe), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});
const $a40f85b59bd30935$export$22253dbadb46d0cf = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $a40f85b59bd30935$export$d33ea1a773b744e,
        pageId: "async-jira-eoc-ops-reports-redirect",
        shouldShowSpinner: false
    });
const $a40f85b59bd30935$export$648ddf2d1f8b1c3f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $a40f85b59bd30935$export$66850ec5549adba6,
        pageId: "async-jira-eoc-global-ops-reports",
        shouldShowSpinner: false
    });
const $a40f85b59bd30935$export$87e6a54b4f5dc91e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $a40f85b59bd30935$export$2404f0e35deca592,
        pageId: "async-jira-eoc-ops-reports",
        shouldShowSpinner: false
    });
const $a40f85b59bd30935$export$7f366d77015c286f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $a40f85b59bd30935$export$5fd77c3bbfb22cbd,
        pageId: "async-jira-eoc-ops-reports-unsubscribe",
        shouldShowSpinner: false
    });


const $662505a58c71f074$export$26f787e3a6e38e4a = (0, $apqRF.createEntry)((0, $6bded2ea1ecf081d$export$e3124ff5345907f6), {
    component: (0, $a40f85b59bd30935$export$22253dbadb46d0cf),
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $j7qZ1.resources),
        ...(0, $ieLL2.resources),
        (0, $ieLL2.opsReportsPermissionResource),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE,
        sidebar: (0, $e7d9de3b8f852c57$export$2e2bcd8739ae039)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $a40f85b59bd30935$export$d33ea1a773b744e),
        (0, $e7d9de3b8f852c57$export$a1b7c53ff39475a6)
    ]
});
const $662505a58c71f074$export$df0202187c23a21d = (0, $apqRF.createEntry)((0, $6bded2ea1ecf081d$export$72cde899ee974e6e), {
    component: (0, $a40f85b59bd30935$export$7f366d77015c286f),
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    resources: [
        ...(0, $hHrVM.getNavigationResources)()
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $a40f85b59bd30935$export$5fd77c3bbfb22cbd)
    ]
});
const $662505a58c71f074$export$1d5f1cc699ecefa3 = [
    (0, $6bded2ea1ecf081d$export$e3124ff5345907f6),
    (0, $6bded2ea1ecf081d$export$72cde899ee974e6e)
];



var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");



var $apqRF = parcelRequire("apqRF");

var $ieLL2 = parcelRequire("ieLL2");

var $j7qZ1 = parcelRequire("j7qZ1");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $1921ae52e285534f$export$c9e0796615c034f3 = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_REPORTS_TEAM,
    path: '/jira/ops/teams/:teamId/reports/:dashboardId',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $e3a38d44404b7c55$export$2404f0e35deca592 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("9c8ch")), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $e3a38d44404b7c55$export$d33ea1a773b744e = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("9c8ch")).then((exportedMembers)=>exportedMembers.OpsReportsRedirect), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $e3a38d44404b7c55$export$66850ec5549adba6 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("9c8ch")).then((exportedMembers)=>exportedMembers.GlobalOpsReports), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});
const $e3a38d44404b7c55$export$22253dbadb46d0cf = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e3a38d44404b7c55$export$d33ea1a773b744e,
        pageId: "async-jira-eoc-ops-reports-redirect",
        shouldShowSpinner: false
    });
const $e3a38d44404b7c55$export$648ddf2d1f8b1c3f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e3a38d44404b7c55$export$66850ec5549adba6,
        pageId: "async-jira-eoc-global-ops-reports",
        shouldShowSpinner: false
    });
const $e3a38d44404b7c55$export$87e6a54b4f5dc91e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e3a38d44404b7c55$export$2404f0e35deca592,
        pageId: "async-jira-eoc-ops-reports",
        shouldShowSpinner: false
    });


const $146ce87c451e4c99$export$cd1c1a81e516fec5 = (0, $apqRF.createEntry)((0, $1921ae52e285534f$export$c9e0796615c034f3), {
    component: (0, $e3a38d44404b7c55$export$87e6a54b4f5dc91e),
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $j7qZ1.resources),
        ...(0, $ieLL2.resources),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE,
        sidebar: (0, $e7d9de3b8f852c57$export$2e2bcd8739ae039)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $e3a38d44404b7c55$export$2404f0e35deca592),
        (0, $e7d9de3b8f852c57$export$a1b7c53ff39475a6)
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $apqRF = parcelRequire("apqRF");

var $lxH5M = parcelRequire("lxH5M");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $exb0h = parcelRequire("exb0h");
const $5fd5c73d8d7e66bb$export$5a10092825ee32e4 = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_ROLE_BASED_NOTIFICATIONS,
    path: '/jira/settings/products/ops/role-based-notifications'
};
const $5fd5c73d8d7e66bb$export$659aa6d7cd021e4b = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_ROLE_BASED_NOTIFICATIONS_DETAIL,
    path: '/jira/settings/products/ops/role-based-notifications/:id'
};



var $59o4i = parcelRequire("59o4i");

const $a21bbc0ffd429ece$export$15a244aba8f3b406 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("f79eX")).then((module)=>module.RoleBasedNotificationsPage), {
    moduleId: "./src/packages/eoc/role-based-notifications/src/index.tsx"
});

const $a21bbc0ffd429ece$export$5211e5a7ed694f98 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("f79eX")).then((module)=>module.RoleBasedNotificationDetail), {
    moduleId: "./src/packages/eoc/role-based-notifications/src/index.tsx"
});
const $a21bbc0ffd429ece$export$8994be6f8ad6a04a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $a21bbc0ffd429ece$export$15a244aba8f3b406,
        pageId: "async-jira-eoc-role-based-notifications",
        shouldShowSpinner: false
    });
const $a21bbc0ffd429ece$export$445112c3a1089cc5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $a21bbc0ffd429ece$export$5211e5a7ed694f98,
        pageId: "async-jira-eoc-role-based-notifications",
        shouldShowSpinner: false
    });
const $a21bbc0ffd429ece$export$60de9875bb8ef1d6 = (0, $apqRF.createEntry)((0, $5fd5c73d8d7e66bb$export$5a10092825ee32e4), {
    component: $a21bbc0ffd429ece$export$8994be6f8ad6a04a,
    exact: true,
    layout: (0, $efFTI.globalSettingsLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $lxH5M.resources)[0],
        (0, $dAKwA.getConsolidationStateResource)(),
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $a21bbc0ffd429ece$export$15a244aba8f3b406
    ]
});
const $a21bbc0ffd429ece$export$565325825b04cec6 = (0, $apqRF.createEntry)((0, $5fd5c73d8d7e66bb$export$659aa6d7cd021e4b), {
    exact: true,
    component: $a21bbc0ffd429ece$export$8994be6f8ad6a04a,
    layout: (0, $efFTI.globalSettingsLayout),
    // @ts-expect-error: 'slot' should be expected because it is being used inside platform package to show the slot inside a drawer
    slot: $a21bbc0ffd429ece$export$445112c3a1089cc5,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $lxH5M.resources)[0],
        (0, $lxH5M.resources)[1],
        (0, $dAKwA.getConsolidationStateResource)(),
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $a21bbc0ffd429ece$export$15a244aba8f3b406
    ]
});
const $a21bbc0ffd429ece$export$80002c8e4483fef1 = [
    $a21bbc0ffd429ece$export$60de9875bb8ef1d6,
    $a21bbc0ffd429ece$export$565325825b04cec6
];



var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");



var $apqRF = parcelRequire("apqRF");

var $dQHDS = parcelRequire("dQHDS");


var $j7qZ1 = parcelRequire("j7qZ1");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $3f8aaf8df2315fa7$export$94efd60f23d97aa5 = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_TEAM_ALERTS,
    path: '/jira/ops/teams/:teamId/alerts',
    exact: true
};
const $3f8aaf8df2315fa7$export$ac102dc13a0f4aff = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_TEAM_ALERT_DETAILS,
    path: '/jira/ops/teams/:teamId/alerts/:id',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $ccd3d4fdd976cfb4$export$f4aafff31d950b6c = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("8xofD")), {
    moduleId: "./src/packages/eoc/alert-list/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ccd3d4fdd976cfb4$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $ccd3d4fdd976cfb4$export$f4aafff31d950b6c,
        pageId: "async-jira-eoc-alert-list",
        shouldShowSpinner: false
    });


const $24ddbaaaf46634ea$export$de37dab3b3ed8e5c = (0, $apqRF.createEntry)((0, $3f8aaf8df2315fa7$export$94efd60f23d97aa5), {
    component: (0, $ccd3d4fdd976cfb4$export$2e2bcd8739ae039),
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $j7qZ1.resources),
        ...(0, $c239ad117e0fe0f0$export$bc99aaabaf7b70a7),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE,
        sidebar: (0, $e7d9de3b8f852c57$export$2e2bcd8739ae039)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $ccd3d4fdd976cfb4$export$f4aafff31d950b6c),
        (0, $e7d9de3b8f852c57$export$a1b7c53ff39475a6)
    ]
});
const $24ddbaaaf46634ea$export$94aaa7006da9d63a = (0, $apqRF.createEntry)((0, $3f8aaf8df2315fa7$export$ac102dc13a0f4aff), {
    component: (0, $ccd3d4fdd976cfb4$export$2e2bcd8739ae039),
    layout: (0, $ecb9d07fa6a7199c$export$53dd27149810df73),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $j7qZ1.resources),
        ...(0, $c239ad117e0fe0f0$export$bc99aaabaf7b70a7),
        ...(0, $dQHDS.resources),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE,
        sidebar: (0, $e7d9de3b8f852c57$export$2e2bcd8739ae039)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $ccd3d4fdd976cfb4$export$f4aafff31d950b6c),
        (0, $e7d9de3b8f852c57$export$a1b7c53ff39475a6)
    ]
});
const $24ddbaaaf46634ea$export$a727cbd3cbcc2153 = [
    $24ddbaaaf46634ea$export$de37dab3b3ed8e5c,
    $24ddbaaaf46634ea$export$94aaa7006da9d63a
];



var $cernH = parcelRequire("cernH");

var $bAQOb = parcelRequire("bAQOb");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $apqRF = parcelRequire("apqRF");


var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $dgH3j = parcelRequire("dgH3j");

var $exb0h = parcelRequire("exb0h");
const $93552086e1f9a014$export$4b517044f5f7830d = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_TEAM_CUSTOMER_LOGS,
    path: '/jira/settings/products/ops/jira-service-management-audit-logs',
    exact: true
};
const $93552086e1f9a014$export$678856ccddc0bc05 = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_TEAM_CUSTOMER_LOGS_DOWNLOAD,
    path: '/jira/settings/products/ops/jira-service-management-audit-logs/download/:exportUniqueKey',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $84c32483c994d926$export$6e30e25faf4f6dce = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("614fg")), {
    moduleId: "./src/packages/eoc/customer-logs/src/index.tsx"
});

const $84c32483c994d926$export$898c7cb3b28a6104 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("614fg")).then(({ CustomerLogsDownloadPage: CustomerLogsDownloadPage })=>CustomerLogsDownloadPage), {
    moduleId: "./src/packages/eoc/customer-logs/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$84c32483c994d926$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $84c32483c994d926$export$6e30e25faf4f6dce,
        pageId: "async-jira-eoc-customer-logs",
        shouldShowSpinner: false
    });
const $84c32483c994d926$export$a5786cf859b7b457 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $84c32483c994d926$export$898c7cb3b28a6104,
        pageId: "async-jira-eoc-customer-logs-download",
        shouldShowSpinner: false
    });


const $d04302cded51ff20$export$42ca979ec2919b23 = (0, $apqRF.createEntry)((0, $93552086e1f9a014$export$4b517044f5f7830d), {
    component: (0, $84c32483c994d926$export$2e2bcd8739ae039),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        ...(0, $c218c297dcbb4ebe$export$bc99aaabaf7b70a7)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $84c32483c994d926$export$6e30e25faf4f6dce)
    ]
});
const $d04302cded51ff20$export$d2ce6f09ef8aa840 = (0, $apqRF.createEntry)((0, $93552086e1f9a014$export$678856ccddc0bc05), {
    component: (0, $bAQOb.componentWithFF)('platform.pun.audit-logs-export-log-release_dvp2f', (0, $84c32483c994d926$export$a5786cf859b7b457), (0, $dgH3j.default)),
    layout: (0, $efFTI.globalSettingsLayout),
    resources: [
        (0, $dAKwA.getConsolidationStateResource)(),
        ...(0, $c218c297dcbb4ebe$export$8571305c82629fe4)
    ],
    forPaint: [
        (0, $84c32483c994d926$export$898c7cb3b28a6104)
    ]
});



var $cernH = parcelRequire("cernH");


var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $apqRF = parcelRequire("apqRF");

var $fH5cc = parcelRequire("fH5cc");

var $hHrVM = parcelRequire("hHrVM");

var $dgH3j = parcelRequire("dgH3j");

var $exb0h = parcelRequire("exb0h");
const $6bb87644c3ee7ae2$export$30306de7e00bc5a2 = {
    group: (0, $exb0h.ROUTE_GROUPS).EOC,
    name: (0, $exb0h.ROUTE_NAMES).EOC_UNLOCK_OPERATIONS,
    path: '/jira/settings/products/ops/unlock'
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $9a9c3733894cd7fd$export$55e4754d556d072 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("6Ugqh")), {
    moduleId: "./src/packages/eoc/unlock-operations/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9a9c3733894cd7fd$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $9a9c3733894cd7fd$export$55e4754d556d072,
        pageId: "eoc-products-unlock-operations",
        shouldShowSpinner: false
    });


const $ef6b20ae22882fd6$export$c058f4d1c0667ce1 = (0, $apqRF.createEntry)((0, $6bb87644c3ee7ae2$export$30306de7e00bc5a2), {
    exact: true,
    layout: (0, $20a3759955606206$export$b8fa7ac7019001bb),
    component: (0, $9zysr.componentWithCondition)(()=>(0, $1ybV0.ff)('opsgenie-consolidation-transitioning-state_d7vm9'), (0, $9a9c3733894cd7fd$export$2e2bcd8739ae039), (0, $dgH3j.default)),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        ...(0, $fH5cc.resources)
    ],
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $9a9c3733894cd7fd$export$55e4754d556d072)
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $cernH = parcelRequire("cernH");


var $apqRF = parcelRequire("apqRF");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $3DMty = parcelRequire("3DMty");

var $79YNf = parcelRequire("79YNf");

var $59o4i = parcelRequire("59o4i");

const $413a11b1b14313fe$export$7b03e7437c5d4f77 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("dxrca")), {
    moduleId: "./src/packages/eoc/who-is-on-call/src/index.tsx"
});
const $413a11b1b14313fe$export$51430a0cf6ef3c09 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $413a11b1b14313fe$export$7b03e7437c5d4f77,
        pageId: "async-jira-eoc-who-is-on-call",
        shouldShowSpinner: false
    });
const $413a11b1b14313fe$export$fee33ca9661e49dd = (0, $apqRF.createEntry)((0, $79YNf.whoIsOnCallRoute), {
    exact: true,
    layout: (0, $20a3759955606206$export$b8fa7ac7019001bb),
    component: $413a11b1b14313fe$export$51430a0cf6ef3c09,
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $dAKwA.getConsolidationStateResource)(),
        ...(0, $3DMty.resources)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $413a11b1b14313fe$export$7b03e7437c5d4f77
    ]
});



var $cernH = parcelRequire("cernH");

var $dVvIP = parcelRequire("dVvIP");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $dgH3j = parcelRequire("dgH3j");

var $exb0h = parcelRequire("exb0h");
const $6d9982f10bd9204a$export$465fa01c0f3a0551 = {
    group: (0, $exb0h.ROUTE_GROUPS).ERRORS,
    name: (0, $exb0h.ROUTE_NAMES).ERRORS_NOT_FOUND,
    path: '/jira/:projectType(software|servicedesk|core)'
};


const $70b0ad18f4a8155d$export$c4c012a49b465e94 = (0, $apqRF.createEntry)((0, $6d9982f10bd9204a$export$465fa01c0f3a0551), {
    component: (0, $dgH3j.default),
    layout: (0, $dVvIP.globalLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $dgH3j.LazyNotFoundErrorPage)
    ]
});



var $cernH = parcelRequire("cernH");

var $d1szd = parcelRequire("d1szd");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");


var $l90Gp = parcelRequire("l90Gp");

var $6cIOm = parcelRequire("6cIOm");

var $5w4hM = parcelRequire("5w4hM");

var $hUM03 = parcelRequire("hUM03");

var $4JtEo = parcelRequire("4JtEo");

var $iTYGl = parcelRequire("iTYGl");

var $isbb2 = parcelRequire("isbb2");

var $apqRF = parcelRequire("apqRF");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $1L86T = parcelRequire("1L86T");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $ixwgj = parcelRequire("ixwgj");

var $kbHFR = parcelRequire("kbHFR");

var $exb0h = parcelRequire("exb0h");
const $1070ef74b890835d$export$392534a80a0b9b11 = {
    name: (0, $exb0h.ROUTE_NAMES).FORGE_ADMIN_SETTINGS,
    path: '/jira/settings/apps/:settingsType(configure|get-started)/:appId/:envId/:route?'
};
const $1070ef74b890835d$export$157f97e6454c2a9f = {
    name: (0, $exb0h.ROUTE_NAMES).FORGE_ADMIN,
    path: '/jira/settings/apps/:appId/:envId/:route?'
};
const $1070ef74b890835d$export$998d01fc8f4c3224 = {
    name: (0, $exb0h.ROUTE_NAMES).FORGE_PROJECT,
    path: '/jira/:projectType(software|software/c|servicedesk|core)/projects/:projectKey/apps/:appId/:envId/:route?'
};
const $1070ef74b890835d$export$b77275b989ab42a6 = {
    name: (0, $exb0h.ROUTE_NAMES).FORGE_SERVICEDESK_QUEUE,
    path: '/jira/servicedesk/projects/:projectKey/queues/apps/:appId/:envId/:route?'
};
const $1070ef74b890835d$export$2ee4468dd8e9636f = {
    name: (0, $exb0h.ROUTE_NAMES).FORGE_FIELD_CONTEXTUAL_CONFIGURATION,
    path: '/jira/settings/issues/field/:fieldId/context/:contextId/configure/app'
};
const $1070ef74b890835d$export$4146dba061d1c72d = {
    name: (0, $exb0h.ROUTE_NAMES).FORGE_GLOBAL,
    path: '/jira/apps/:appId/:envId'
};



var $csLgO = parcelRequire("csLgO");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $b34bb9dfafeb551e$export$66ee65dcd4a6458d = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("cdVr3")), {
    moduleId: "./src/packages/spa-apps/forge/admin/src/index.tsx"
});
const $b34bb9dfafeb551e$export$c9e5f500ef472147 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $b34bb9dfafeb551e$export$66ee65dcd4a6458d,
        pageId: "forge-spa-admin",
        shouldShowSpinner: true
    });
var $b34bb9dfafeb551e$export$2e2bcd8739ae039 = $b34bb9dfafeb551e$export$c9e5f500ef472147;



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $7c029b413050cf74$export$c53e206c7fd6fb76 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("8msE0")), {
    moduleId: "./src/packages/spa-apps/forge/field-contextual-config/src/index.tsx"
});
const $7c029b413050cf74$export$50bd0baee0b2f946 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7c029b413050cf74$export$c53e206c7fd6fb76,
        pageId: "forge-spa-field-context-config",
        shouldShowSpinner: true
    });
var $7c029b413050cf74$export$2e2bcd8739ae039 = $7c029b413050cf74$export$50bd0baee0b2f946;



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $d550fe7a86f223e9$export$332293feb5cffd72 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("6qkqy")), {
    moduleId: "./src/packages/spa-apps/forge/global/src/index.tsx"
});
const $d550fe7a86f223e9$export$4c36a7b018e5e5cc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $d550fe7a86f223e9$export$332293feb5cffd72,
        pageId: "forge-spa-global",
        shouldShowSpinner: true
    });
var $d550fe7a86f223e9$export$2e2bcd8739ae039 = $d550fe7a86f223e9$export$4c36a7b018e5e5cc;



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $fa7f1adbdad82c38$export$27b0c9e982208d7e = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("d8II2")), {
    moduleId: "./src/packages/spa-apps/forge/project/src/index.tsx"
});
const $fa7f1adbdad82c38$export$99737a64be9f5f1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $fa7f1adbdad82c38$export$27b0c9e982208d7e,
        pageId: "forge-spa-project",
        shouldShowSpinner: true
    });
var $fa7f1adbdad82c38$export$2e2bcd8739ae039 = $fa7f1adbdad82c38$export$99737a64be9f5f1;



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $ee4c92d972c01d87$export$62e1bcb9c27c99b5 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("ftOA1")), {
    moduleId: "./src/packages/spa-apps/forge/servicedesk-queue/src/index.tsx"
});
const $ee4c92d972c01d87$export$e83b7c5b466e791a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $ee4c92d972c01d87$export$62e1bcb9c27c99b5,
        pageId: "forge-spa-servicedesk-queue",
        shouldShowSpinner: true
    });
var $ee4c92d972c01d87$export$2e2bcd8739ae039 = $ee4c92d972c01d87$export$e83b7c5b466e791a;


const $be75b82ac5d10c81$export$80b2f91dabb3dd65 = ()=>[
        (0, $l90Gp.forgeGlobalModuleResource)
    ];
const $be75b82ac5d10c81$export$fc82fa1ad8302441 = ()=>({
        component: (0, $b34bb9dfafeb551e$export$2e2bcd8739ae039),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $hUM03.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $l90Gp.getNavigationSidebarGlobalSettingsResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $b34bb9dfafeb551e$export$66ee65dcd4a6458d)
        ]
    });
const $be75b82ac5d10c81$export$1c55fbe0ae1da308 = ()=>({
        component: (0, $fa7f1adbdad82c38$export$2e2bcd8739ae039),
        layout: (0, $d1szd.genericProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $5w4hM.genericProjectSidebars),
            horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $4qvmP.getBusinessProjectResources)(),
            ...(0, $kbHFR.getServiceDeskSharedNavigationSingleResources)(),
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            (0, $l90Gp.forgeProjectModuleResource),
            (0, $ixwgj.projectContextResourceWithCache),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $fa7f1adbdad82c38$export$27b0c9e982208d7e)
        ]
    });
const $be75b82ac5d10c81$export$95c93c3fcfde8901 = ()=>({
        component: (0, $7c029b413050cf74$export$2e2bcd8739ae039),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $4JtEo.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $l90Gp.forgeCustomFieldTypeResource),
            (0, $1L86T.fieldContextConfigPageResource),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7c029b413050cf74$export$c53e206c7fd6fb76)
        ]
    });
const $be75b82ac5d10c81$export$a2f53aa48e785c7 = ()=>({
        component: (0, $ee4c92d972c01d87$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $ee4c92d972c01d87$export$62e1bcb9c27c99b5)
        ]
    });
const $be75b82ac5d10c81$export$dbdc27694c56b868 = ()=>({
        component: (0, $d550fe7a86f223e9$export$2e2bcd8739ae039),
        layout: (0, $isbb2.createLayout)(),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).ADDONS,
            sidebar: (0, $6cIOm.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...$be75b82ac5d10c81$export$80b2f91dabb3dd65()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $d550fe7a86f223e9$export$332293feb5cffd72)
        ]
    });
const $be75b82ac5d10c81$export$b1d92ac5cda62e7e = [
    (0, $apqRF.createEntry)((0, $1070ef74b890835d$export$392534a80a0b9b11), $be75b82ac5d10c81$export$fc82fa1ad8302441()),
    (0, $apqRF.createEntry)((0, $1070ef74b890835d$export$157f97e6454c2a9f), $be75b82ac5d10c81$export$fc82fa1ad8302441()),
    (0, $apqRF.createEntry)((0, $1070ef74b890835d$export$998d01fc8f4c3224), $be75b82ac5d10c81$export$1c55fbe0ae1da308()),
    (0, $apqRF.createEntry)((0, $1070ef74b890835d$export$b77275b989ab42a6), $be75b82ac5d10c81$export$a2f53aa48e785c7()),
    (0, $apqRF.createEntry)((0, $1070ef74b890835d$export$2ee4468dd8e9636f), $be75b82ac5d10c81$export$95c93c3fcfde8901()),
    (0, $apqRF.createEntry)((0, $1070ef74b890835d$export$4146dba061d1c72d), $be75b82ac5d10c81$export$dbdc27694c56b868())
];



var $cernH = parcelRequire("cernH");

var $2ijRB = parcelRequire("2ijRB");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $exb0h = parcelRequire("exb0h");
const $c7a08da0e4520818$export$e69b84daf70501b3 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).GLOBAL_MAIL_SETTINGS,
    path: '/secure/admin/global-mail-settings',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $eUqFw = parcelRequire("eUqFw");

var $2jDha = parcelRequire("2jDha");

var $aUSBv = parcelRequire("aUSBv");

var $gUUjF = parcelRequire("gUUjF");

var $5oIBC = parcelRequire("5oIBC");

var $6rW04 = parcelRequire("6rW04");

var $jMP2a = parcelRequire("jMP2a");

var $kJlBc = parcelRequire("kJlBc");

var $90IgZ = parcelRequire("90IgZ");
const $cdf3eb6145229a81$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        "id": "redirect.legacy-routing.flags.error.title",
        "defaultMessage": "We can't find the page you're looking for"
    },
    description: {
        "id": "redirect.legacy-routing.flags.error.description",
        "defaultMessage": "Check your spelling in the address bar. Or, try opening this site's home page to search or browse for the content."
    },
    goHome: {
        "id": "redirect.legacy-routing.flags.error.go-home",
        "defaultMessage": "Go to the homepage"
    }
});


const $71d40e54e45bfb05$export$b9a7f1ebeaa76953 = ()=>({
        type: 'error',
        title: (0, $cdf3eb6145229a81$export$defe85febe8b728c).title,
        description: (0, $cdf3eb6145229a81$export$defe85febe8b728c).description,
        actions: [
            {
                content: (0, $cdf3eb6145229a81$export$defe85febe8b728c).goHome,
                onClick: ()=>window.location.assign('/')
            }
        ]
    });


const $9f087e464fef57a9$var$THRESHOLD = 30000;
const $9f087e464fef57a9$var$getScopeType = (scope)=>{
    switch(scope.identifierType){
        case 'boardId':
            return 'board';
        case 'projectId':
        case 'projectKey':
            return scope.pageType === 'settings' ? 'projectSettings' : 'project';
        default:
            return '';
    }
};
class $9f087e464fef57a9$export$836fe1ef2cfde075 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { location: { pathname: pathname, search: search }, flagService: flagService, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        const redirectPathname = pathname.startsWith('//') ? pathname.substr(1) : pathname;
        const lastRedirectTime = Number(sessionStorage.getItem(redirectPathname));
        if (!lastRedirectTime) sessionStorage.setItem(redirectPathname, Date.now().toString());
        else if (Date.now() - lastRedirectTime < $9f087e464fef57a9$var$THRESHOLD) {
            const scopeData = (0, $aUSBv.default)(window.location.href, (0, $6rW04.default));
            const scope = $9f087e464fef57a9$var$getScopeType(scopeData);
            (0, $gUUjF.default).safeErrorWithoutCustomerData('redirect-loop.error', 'Redirect error caused by invalid url', {
                scope: scope
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({
                action: 'entered'
            }), 'redirect-loop entered', 'endeavour.spa.redirect-loop', {
                scope: scope
            });
            flagService.showFlag((0, $71d40e54e45bfb05$export$b9a7f1ebeaa76953)());
            sessionStorage.removeItem(redirectPathname);
            return;
        } else sessionStorage.removeItem(redirectPathname);
        window.location.assign(redirectPathname + search);
    }
    render() {
        return null;
    }
}
var // @ts-expect-error - TS2345 - Argument of type 'ForwardRefExoticComponent<Pick<WithAnalyticsEventsProps, never> & RefAttributes<any>>' is not assignable to parameter of type 'ComponentType<{ flagService: FlagService; }>'. | TS2345 - Argument of type 'typeof RedirectToLegacyRouting' is not assignable to parameter of type '(((props: WithAnalyticsEventsProps) => ReactElement<any, string | ((props: any) => ReactElement<any, any> | null) | (new (props: any) => Component<any, any, any>)> | null) & typeof RedirectToLegacyRouting) | ((new (props: WithAnalyticsEventsProps) => Component<...>) & typeof RedirectToLegacyRouting)'.
$9f087e464fef57a9$export$2e2bcd8739ae039 = (0, $kJlBc.withRouter)((0, $5oIBC.default)((0, $2jDha.default)()($9f087e464fef57a9$export$836fe1ef2cfde075)));


var /** This exists to be used as a route since the redirect as a route and redirect as a component
 * have different props, and flow complains. */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$291599ef708fe49c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9f087e464fef57a9$export$2e2bcd8739ae039), null);



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $ddbf83b09ae1ab4d$export$a133d90b2004a90e = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("1rAsT"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/global-mail-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ddbf83b09ae1ab4d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $ddbf83b09ae1ab4d$export$a133d90b2004a90e,
        pageId: "global-mail-settings",
        shouldShowSpinner: false
    });


const $f7decf7961ae87b9$export$5e1236665a530df4 = (0, $apqRF.createEntry)((0, $c7a08da0e4520818$export$e69b84daf70501b3), {
    ufoName: 'admin.global-mail-settings',
    component: (0, $2ijRB.default)(()=>true, (0, $ddbf83b09ae1ab4d$export$2e2bcd8739ae039), (0, $291599ef708fe49c$export$2e2bcd8739ae039)),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $ddbf83b09ae1ab4d$export$a133d90b2004a90e)
    ]
});



var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $apqRF = parcelRequire("apqRF");

var $7pdDu = parcelRequire("7pdDu");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $exb0h = parcelRequire("exb0h");
const $190982ff9321149d$export$45e7d93edcc9507f = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_CUSTOM_FIELDS,
    path: '/secure/admin/ViewCustomFields(!default)?.jspa'
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $fafd69dd154a006a$export$55a5c16f39a046af = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("3H8mz"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/custom-fields-directory/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fafd69dd154a006a$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $fafd69dd154a006a$export$55a5c16f39a046af,
        pageId: "admin-pages-custom-fields-directory",
        shouldShowSpinner: true
    });


const $4cae923e7c81fee6$export$d83c2e469d070766 = (0, $apqRF.createEntry)((0, $190982ff9321149d$export$45e7d93edcc9507f), {
    ufoName: 'admin.custom-fields-directory',
    component: (0, $fafd69dd154a006a$export$2e2bcd8739ae039),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $9CFDS.navigationSidebarGlobalResource),
        (0, $7pdDu.customFieldsDirectoryResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $fafd69dd154a006a$export$55a5c16f39a046af)
    ]
});



var $cernH = parcelRequire("cernH");

var $dVvIP = parcelRequire("dVvIP");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $6611056fd52921ab$export$2eaffde3ad991b33 = {
    group: (0, $exb0h.ROUTE_GROUPS).HOME,
    name: (0, $exb0h.ROUTE_NAMES).HOME_ONBOARDING_REDIRECT,
    path: '/jira/your-work-onboarding',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $d6f6c = parcelRequire("d6f6c");

var $kJlBc = parcelRequire("kJlBc");
/**
 * This component will cause an SPA transition (and overwrite of current history) to Your work or the Projects directory
 * depending on whether nav-v3, Your work's deep dive cards, and the JSW onboarding flows in Your work are enabled.
 */ const $1dff71694523fcab$var$JiraHomeOnboardingRedirect = ()=>{
    const { replace: replace } = (0, $kJlBc.useRouterActions)();
    replace('/jira/your-work');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireOperationalAnalytics), {
        eventName: "JiraHomeOnboardingRedirect loaded",
        componentName: "JiraHomeOnboardingRedirect",
        attributes: {
            isRedirectionEnabled: true
        }
    });
};
var $1dff71694523fcab$export$2e2bcd8739ae039 = $1dff71694523fcab$var$JiraHomeOnboardingRedirect;


const $c21644fb8a992f95$export$2740cfaa979353b9 = (0, $apqRF.createEntry)((0, $6611056fd52921ab$export$2eaffde3ad991b33), {
    component: (0, $1dff71694523fcab$export$2e2bcd8739ae039),
    layout: (0, $dVvIP.globalLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)()
    ],
    isRedirect: true,
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation)
    ]
});



var $cernH = parcelRequire("cernH");

var $dVvIP = parcelRequire("dVvIP");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $f073503a37a4d67a$export$f7a252c9d61f8f94 = {
    group: (0, $exb0h.ROUTE_GROUPS).HOME,
    name: (0, $exb0h.ROUTE_NAMES).HOME_REDIRECT,
    path: '/jira',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $kJlBc = parcelRequire("kJlBc");
var $3HCkE = parcelRequire("3HCkE");

var $4uxD3 = parcelRequire("4uxD3");
const $4b4ea64722ce8937$export$25a759e49d5049db = 'spa-apps.common.redirect.jira-base-routing';


const $69d3cca6c637e03e$var$JiraBaseRedirectWrapper = ()=>{
    const { data: data, loading: loading } = (0, $3HCkE.useResource)((0, $4uxD3.userHomepageResource));
    (0, $eUqFw.useEffect)(()=>{
        if (!loading && data == null) (0, $gUUjF.default).safeInfoWithoutCustomerData((0, $4b4ea64722ce8937$export$25a759e49d5049db), 'userHomepage data is null');
    }, [
        loading,
        data
    ]);
    if (loading) return null;
    // redirect to monolith to handle "/jira" route if homepageData is null (should not happen)
    if (data == null) {
        window.location.replace('/jira');
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
        to: data.homepagePreference
    });
};
var $69d3cca6c637e03e$export$2e2bcd8739ae039 = $69d3cca6c637e03e$var$JiraBaseRedirectWrapper;


var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2a2e93d2ac19a203$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $69d3cca6c637e03e$export$2e2bcd8739ae039), null);


const $5e7adb561c10220c$export$5379c026da4201e6 = (0, $apqRF.createEntry)((0, $f073503a37a4d67a$export$f7a252c9d61f8f94), {
    component: (0, $2a2e93d2ac19a203$export$2e2bcd8739ae039),
    layout: (0, $dVvIP.globalLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)()
    ],
    isRedirect: true,
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation)
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");


var $apqRF = parcelRequire("apqRF");

var $3MEW8 = parcelRequire("3MEW8");

var $exb0h = parcelRequire("exb0h");
const $909f2c4044c0d832$export$c155f4de16b62110 = {
    group: (0, $exb0h.ROUTE_GROUPS).ERRORS,
    name: (0, $exb0h.ROUTE_NAMES).ISSUE_CREATE_EMBED,
    path: '/jira/issues/create/embed'
};



var $bhwgQ = parcelRequire("bhwgQ");

var $59o4i = parcelRequire("59o4i");
const $b3df52e8783e1d6e$var$handleEmbedLinkClick = (e)=>{
    const eventTarget = e.target;
    // this is used for handling all the button clicks inside the iframe to open the new link in a new tab
    // as this view is mainly used an embed view inside an iframe.
    if (eventTarget && eventTarget instanceof HTMLAnchorElement && eventTarget.target !== '_blank') // link
    eventTarget.target = '_blank';
};

const $b3df52e8783e1d6e$export$980ea815ec2d0180 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("lY2KV")), {
    ssr: false,
    moduleId: "./src/packages/issue-create/issue-create-embed/src/index.tsx"
});
const $b3df52e8783e1d6e$export$87fa8eff34eb030a = ()=>{
    (0, $eUqFw.useEffect)(()=>{
        window.addEventListener('click', $b3df52e8783e1d6e$var$handleEmbedLinkClick, true);
        return ()=>{
            window.removeEventListener('click', $b3df52e8783e1d6e$var$handleEmbedLinkClick);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bhwgQ.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $b3df52e8783e1d6e$export$980ea815ec2d0180,
        pageId: "spa-apps/issue-create-embed",
        shouldShowSpinner: true
    }));
};
const $b3df52e8783e1d6e$export$abd0bbe95839baf7 = (0, $apqRF.createEntry)((0, $909f2c4044c0d832$export$c155f4de16b62110), {
    component: $b3df52e8783e1d6e$export$87fa8eff34eb030a,
    resources: [
        (0, $3MEW8.themePreferenceResource)
    ],
    layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
    forPaint: [
        $b3df52e8783e1d6e$export$980ea815ec2d0180
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $cernH = parcelRequire("cernH");



var $7ZZxN = parcelRequire("7ZZxN");

var $1ybV0 = parcelRequire("1ybV0");

var $d1szd = parcelRequire("d1szd");


var $sFzm1 = parcelRequire("sFzm1");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $kJlBc = parcelRequire("kJlBc");

var $guDlK = parcelRequire("guDlK");

var $bNe1g = parcelRequire("bNe1g");

var $isbb2 = parcelRequire("isbb2");

var $apqRF = parcelRequire("apqRF");
var $kJlBc = parcelRequire("kJlBc");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $5kTYh = parcelRequire("5kTYh");
var $iudJZ = parcelRequire("iudJZ");
var $kSgnh = parcelRequire("kSgnh");
var $3HCkE = parcelRequire("3HCkE");

var $2skem = parcelRequire("2skem");
const $8d305223106bbf32$export$3b5744f70b49a5c4 = (0, $3HCkE.createResource)((0, $2skem.withResourceEarlyData)({
    type: 'ISSUE_MEDIA_READ_PERM',
    getKey: ({ match: match })=>match && match.params && match.params.issueKey !== undefined && match.params.issueKey !== null ? match.params.issueKey : '',
    getData: ()=>null,
    isBrowserOnly: true
}));


var $3HCkE = parcelRequire("3HCkE");

var $9PXNH = parcelRequire("9PXNH");

var $2skem = parcelRequire("2skem");
const $fffb40acdfdf7acd$export$80c2a5c658bd9e1e = (0, $3HCkE.createResource)((0, $2skem.withResourceEarlyData)({
    type: 'ISSUE_MEDIA_UPLOAD_PERM',
    getKey: ({ match: match })=>{
        const issueKey = (0, $9PXNH.getIssueKey)(match);
        return issueKey || '';
    },
    getData: ()=>null,
    isBrowserOnly: true
}));


var $3HCkE = parcelRequire("3HCkE");

var $9PXNH = parcelRequire("9PXNH");

var $2skem = parcelRequire("2skem");
const $8751cd044263fd79$export$48db4eb29e9be72c = (0, $3HCkE.createResource)((0, $2skem.withResourceEarlyData)({
    type: 'ISSUE_MEDIA_USER_AUTH',
    getKey: ({ match: match })=>{
        const issueKey = (0, $9PXNH.getIssueKey)(match);
        return issueKey || '';
    },
    getData: ()=>null,
    isBrowserOnly: true
}));


var $dvBSb = parcelRequire("dvBSb");

var $hHrVM = parcelRequire("hHrVM");

var $aBAel = parcelRequire("aBAel");

var $hRe6W = parcelRequire("hRe6W");

var $3MEW8 = parcelRequire("3MEW8");

var $jwzNs = parcelRequire("jwzNs");

var $3JUND = parcelRequire("3JUND");

var $cV47S = parcelRequire("cV47S");

var $c4qEZ = parcelRequire("c4qEZ");

var $dY715 = parcelRequire("dY715");

var $59o4i = parcelRequire("59o4i");
const $f020c38e81fdeaa8$var$pageId = 'spa-issue';
const $f020c38e81fdeaa8$var$conditionalIssueGiraNonCriticalDataResource = (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('issue-view-remove-connect-operations-from-critical-fetch_vtk4w'), (0, $kSgnh.issueGiraNonCriticalDataResource));

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f020c38e81fdeaa8$var$LazyIssuePage = (0, $7rh0R.lazyForPaint)(()=>(0, $dY715.markAsBentoBundleReady)((parcelRequire("kpDPI"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/issue/src/index.tsx"
});
const $f020c38e81fdeaa8$export$c1a868ace2f38803 = ()=>{
    const { data: data } = (0, $bNe1g.useProjectContext)();
    const [issueKey] = (0, $kJlBc.usePathParam)('issueKey');
    const [projectKey, issueSuffix] = issueKey !== undefined ? issueKey.split('-') : [];
    let actualIssueKey = issueKey;
    if (data?.projectKey && data.projectKey !== projectKey) actualIssueKey = `${data.projectKey}-${issueSuffix}`;
    // special handling for product discovery (=== Polaris) project issues. During the experimental phase of
    // the polaris idea view (product-specific issue view), we will redirect to a polaris-specific issue view
    // page here instead of bento.
    // this will only happen for issues of this specific project type, and only if the switchover FF is enabled
    if (!false && data?.projectType === (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT) && data?.projectKey !== undefined && actualIssueKey !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
        to: `/jira/polaris/projects/${data.projectKey}/ideas?selectedIssue=${actualIssueKey}`
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $f020c38e81fdeaa8$var$LazyIssuePage,
        pageId: $f020c38e81fdeaa8$var$pageId,
        shouldShowSpinner: false
    });
};
const $f020c38e81fdeaa8$export$ef02bcc0eb1d9ded = ()=>{
    const [issueKey] = (0, $kJlBc.usePathParam)('issueKey');
    const projectKey = (0, $guDlK.useProjectKey)(issueKey || '');
    const projectType = (0, $guDlK.useProjectType)(projectKey);
    const projectId = (0, $guDlK.useProjectId)(projectKey);
    // Special handling for product discovery (=== Polaris) project issues in embed mode.
    // We have to redirect to Polaris issue embed view instead of loading Jira issue view.
    if (projectType === (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT) && projectKey !== undefined && projectId !== undefined && issueKey !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
        to: `/secure/JiraProductDiscoveryEmbedded.jspa?projectId=${projectId}&projectKey=${projectKey}&issueKey=${issueKey}`
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $sFzm1.EmbedModeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f020c38e81fdeaa8$export$c1a868ace2f38803, null));
};
const $f020c38e81fdeaa8$export$cef770e7c16cfcc = (0, $apqRF.createEntry)((0, $3JUND.browseIssueRoute), {
    component: $f020c38e81fdeaa8$export$c1a868ace2f38803,
    skeleton: (0, $c4qEZ.IssueViewSkeleton),
    layout: (0, $isbb2.composeLayouts)((0, $d1szd.genericProjectLayout), (0, $71b4a5d883bcbfff$export$98e337c40eb151da)),
    navigation: {
        sidebar: (0, $5w4hM.genericProjectSidebars),
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $aBAel.getOfferingCatalogueFeaturesResource)(),
        (0, $8d305223106bbf32$export$3b5744f70b49a5c4),
        (0, $8751cd044263fd79$export$48db4eb29e9be72c),
        (0, $iudJZ.issueGiraDataResource),
        $f020c38e81fdeaa8$var$conditionalIssueGiraNonCriticalDataResource,
        (0, $fffb40acdfdf7acd$export$80c2a5c658bd9e1e),
        (0, $5kTYh.issueForgeDataResource),
        (0, $dvBSb.issueViewRelayResource),
        (0, $hRe6W.queuesNavigationItems),
        (0, $cV47S.workspaceResource),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $f020c38e81fdeaa8$var$LazyIssuePage
    ],
    ufoName: 'issue-view',
    meta: {
        capability: (0, $d07297a4af13004b$export$ef94a84e2990361c)
    }
});
const $f020c38e81fdeaa8$export$e275b3ca0c6ccb5e = (0, $apqRF.createEntry)((0, $3JUND.browseIssueEmbedRoute), {
    component: $f020c38e81fdeaa8$export$ef02bcc0eb1d9ded,
    skeleton: (0, $c4qEZ.IssueViewSkeleton),
    layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getModernIssueTransitionResources)(),
        (0, $8d305223106bbf32$export$3b5744f70b49a5c4),
        (0, $8751cd044263fd79$export$48db4eb29e9be72c),
        (0, $iudJZ.issueGiraDataResource),
        $f020c38e81fdeaa8$var$conditionalIssueGiraNonCriticalDataResource,
        (0, $fffb40acdfdf7acd$export$80c2a5c658bd9e1e),
        (0, $5kTYh.issueForgeDataResource),
        (0, $dvBSb.issueViewRelayResource),
        (0, $hRe6W.queuesNavigationItems),
        (0, $cV47S.workspaceResource),
        (0, $3MEW8.themePreferenceResource)
    ],
    forPaint: [
        $f020c38e81fdeaa8$var$LazyIssuePage
    ],
    ufoName: 'issue-view-embed',
    meta: {
        capability: (0, $d07297a4af13004b$export$ef94a84e2990361c)
    }
});



var $jh2R9 = parcelRequire("jh2R9");

var $cernH = parcelRequire("cernH");

var $b3nmi = parcelRequire("b3nmi");


var $exb0h = parcelRequire("exb0h");

var $1ybV0 = parcelRequire("1ybV0");

var $d1szd = parcelRequire("d1szd");

var $dVvIP = parcelRequire("dVvIP");

var $7vTKl = parcelRequire("7vTKl");


var $lw0Lc = parcelRequire("lw0Lc");
var $62ZdZ = parcelRequire("62ZdZ");
var $51qRF = parcelRequire("51qRF");

var $buaC1 = parcelRequire("buaC1");

var $fxlTA = parcelRequire("fxlTA");

var $5w4hM = parcelRequire("5w4hM");

var $iOOlt = parcelRequire("iOOlt");

var $iTYGl = parcelRequire("iTYGl");

var $2Fzrk = parcelRequire("2Fzrk");

var $isbb2 = parcelRequire("isbb2");

var $apqRF = parcelRequire("apqRF");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $cINNO = parcelRequire("cINNO");

var $cWgoa = parcelRequire("cWgoa");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $hRe6W = parcelRequire("hRe6W");

var $jwzNs = parcelRequire("jwzNs");


var $1tmBn = parcelRequire("1tmBn");

var $csLgO = parcelRequire("csLgO");

var $kKpAY = parcelRequire("kKpAY");
var $iPtkN = parcelRequire("iPtkN");

var $bEe6y = parcelRequire("bEe6y");

var $soOXK = parcelRequire("soOXK");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $eMdFV = parcelRequire("eMdFV");

var $1h6H8 = parcelRequire("1h6H8");
var $4D6hU = parcelRequire("4D6hU");

var $kKpAY = parcelRequire("kKpAY");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

var $6yplV = parcelRequire("6yplV");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$46cfd36e45863fc5$export$2e2bcd8739ae039 = ({ params: params }, { filter: filter, orderby: orderby, keyword: keyword })=>{
    const { projectKey: projectKey, issueKey: issueKey } = params;
    const pageIdPrefix = 'new-issue-navigator';
    let pageId = '';
    try {
        pageId = `${pageIdPrefix}${(projectKey !== null && projectKey !== undefined ? `-${projectKey}` : '') + (issueKey !== null && issueKey !== undefined ? `-${issueKey}` : '') + (filter !== undefined ? `-${filter}` : '') + (orderby !== undefined ? `-${orderby}` : '') + (keyword !== undefined ? `-${keyword}` : '')}`;
    } catch  {
        pageId = pageIdPrefix;
    }
    return pageId;
};



const $7f18d9588e93cd1d$export$5fcc10c40c224fbc = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("a1hH7"))), {
    moduleId: "./src/packages/spa-apps/project-issue-navigator/src/index.tsx"
});
const $7f18d9588e93cd1d$export$2de79bdf33dbf27c = ({ match: match, query: query })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7f18d9588e93cd1d$export$5fcc10c40c224fbc,
        pageId: (0, $46cfd36e45863fc5$export$2e2bcd8739ae039)(match, query),
        shouldShowSpinner: false
    });

const $7f18d9588e93cd1d$export$8ff267588532c2ce = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("ai4sb")), {
    moduleId: "./src/packages/spa-apps/global-issue-navigator/src/index.tsx"
});
const $7f18d9588e93cd1d$export$4bd5bc3fa8a52567 = ({ match: match, query: query })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7f18d9588e93cd1d$export$8ff267588532c2ce,
        pageId: (0, $46cfd36e45863fc5$export$2e2bcd8739ae039)(match, query),
        shouldShowSpinner: false
    });
const $7f18d9588e93cd1d$export$3b4f172f4310bbc = (props)=>{
    const [isNinGlobalScopeEnrolmentEnabled, resourceData] = (0, $eMdFV.useGlobalScopeEnrolmentEnable)();
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    // Regardless of the existing localStorageData value, we update the localStorage value once we get resourceData so
    // that future renders are fast and accurate.
    (0, $eUqFw.useEffect)(()=>{
        if (resourceData !== null && resourceData !== undefined) (0, $1h6H8.setIsGlobalScopeEnrolmentEnabledInLocalStorage)(resourceData);
    }, [
        resourceData
    ]);
    // If NIN in global scope is not enabled then we redirect to legacy GIN by performing a reload
    (0, $eUqFw.useEffect)(()=>{
        if (isNinGlobalScopeEnrolmentEnabled === false) window.location.reload();
    }, [
        isNinGlobalScopeEnrolmentEnabled
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (isNinGlobalScopeEnrolmentEnabled) {
            // If we are in global scope nin then reset/enable the forced opt out flag for GIN if we haven't done it already
            const globalGINFlagDisabled = (0, $1h6H8.getIsGlobalScopeForcedOptOutGinFlagDisabledLocalStorage)();
            if (globalGINFlagDisabled !== false) {
                !isAnonymous && (0, $4D6hU.resetGlobalScopeForcedOptOutGinFlag)();
                (0, $1h6H8.setGlobalScopeForcedOptOutGinFlagEnabledInLocalStorage)();
            }
        }
    }, [
        isAnonymous,
        isNinGlobalScopeEnrolmentEnabled
    ]);
    // If NIN in global scope is enabled then we render it. If NIN in global scope is not enabled, or we're blocked
    // waiting on the resource to load then we render GlobalIssueNavigatorSkeleton.
    return isNinGlobalScopeEnrolmentEnabled === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7f18d9588e93cd1d$export$4bd5bc3fa8a52567, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKpAY.GlobalIssueNavigatorSkeleton), null);
};



var $eUqFw = parcelRequire("eUqFw");

var $kJlBc = parcelRequire("kJlBc");

var $atRHQ = parcelRequire("atRHQ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$74828a2871cc60ec$export$2e2bcd8739ae039 = ()=>{
    const [{ match: match }] = (0, $kJlBc.useRouter)();
    const issueKey = match.params.issueKey ?? '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
        to: `/issues/${issueKey}`
    });
};



var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $guiFP = parcelRequire("guiFP");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $kJlBc = parcelRequire("kJlBc");
var $3HCkE = parcelRequire("3HCkE");

var $ixwgj = parcelRequire("ixwgj");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a96138dd0c605115$export$2e2bcd8739ae039 = ()=>{
    const [{ match: match, query: query }] = (0, $kJlBc.useRouter)();
    const { data: data, error: error, loading: loading } = (0, $3HCkE.useResource)((0, $ixwgj.projectContextResource));
    (0, $eUqFw.useEffect)(()=>{
        if (error) (0, $guiFP.default)({
            meta: {
                id: 'useResourceProjectContext',
                packageName: 'jiraRouterRoutesIssueNavigatorEntries'
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        error
    ]);
    if (!data && !loading || error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "pinRedirectFailed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null));
    if (!data) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $7ZZxN.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $7ZZxN.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const issueKey = match.params.issueKey ?? '';
    const queryParams = new URLSearchParams(query).toString();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "pinRedirect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
        to: `/jira/${type}/projects/${projectKey}/issues/${issueKey}?${queryParams}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null));
};


const $81a426de012c30b2$var$common = {
    apdexIgnoreParams: [
        'issueKey'
    ],
    meta: {
        capability: (0, $d07297a4af13004b$export$d0ad1160bb95ce50),
        reporting: {
            id: (0, $exb0h.ROUTE_GROUPS).ISSUE_NAVIGATOR,
            packageName: (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))((0, $exb0h.ROUTE_GROUPS).ISSUE_NAVIGATOR),
            teamName: 'empanada'
        }
    }
};
const $81a426de012c30b2$var$getCommonProjectResources = ()=>[
        (0, $cWgoa.issueNavigatorRelayResource),
        (0, $cWgoa.issueNavigatorFilterRelayResource),
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $4qvmP.getBusinessProjectResources)(),
        (0, $jwzNs.resourceWithCondition)(()=>(0, $1ybV0.ff)('nin.global-scope_aqec8'), (0, $62ZdZ.sidebarProjectIssuesResource)),
        (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('nin.global-scope_aqec8'), (0, $cINNO.isNinGlobalScopeEnrolmentEnabledResource)),
        (0, $51qRF.staticSidebarDefaultPINFiltersResource)
    ];
const $81a426de012c30b2$var$getCommonProject = ()=>({
        component: (0, $7f18d9588e93cd1d$export$2de79bdf33dbf27c),
        skeleton: (0, $iPtkN.ProjectIssueNavigatorSkeleton),
        resources: [
            ...$81a426de012c30b2$var$getCommonProjectResources()
        ],
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ]
    });
const $81a426de012c30b2$var$getCommonProjectLayout = ()=>(0, $isbb2.createLayout)((0, $d1szd.genericProjectLayout));
const $81a426de012c30b2$var$getCommonGlobal = ()=>({
        component: (0, $7f18d9588e93cd1d$export$3b4f172f4310bbc),
        skeleton: (0, $kKpAY.GlobalIssueNavigatorSkeleton),
        layout: (0, $dVvIP.globalLayout),
        canTransitionIn: ()=>(0, $1ybV0.ff)('nin.global-scope_aqec8'),
        resources: [
            (0, $cWgoa.issueNavigatorRelayResource),
            (0, $cWgoa.issueNavigatorFilterRelayResource),
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource),
            (0, $cINNO.isNinGlobalScopeEnrolmentEnabledResource),
            (0, $lw0Lc.sidebarFiltersGlobalResource)
        ],
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).FILTERS,
            sidebar: (0, $fxlTA.AsyncSidebarFiltersGlobal)
        }
    });
const $81a426de012c30b2$export$f9a1f59ec7d1f215 = [
    (0, $apqRF.createEntry)((0, $1tmBn.projectIssueNavigatorRoute), {
        ...$81a426de012c30b2$var$getCommonProject(),
        ...$81a426de012c30b2$var$common,
        component: (0, $a96138dd0c605115$export$2e2bcd8739ae039),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7f18d9588e93cd1d$export$5fcc10c40c224fbc)
        ],
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $5w4hM.genericProjectSidebars),
            horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
        },
        resources: [
            ...$81a426de012c30b2$var$getCommonProject().resources,
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        layout: $81a426de012c30b2$var$getCommonProjectLayout()
    }),
    (0, $apqRF.createEntry)((0, $1tmBn.softwareIssueNavigatorRoute), {
        ...$81a426de012c30b2$var$getCommonProject(),
        ...$81a426de012c30b2$var$common,
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7f18d9588e93cd1d$export$5fcc10c40c224fbc)
        ],
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        layout: (0, $isbb2.createLayout)((0, $soOXK.softwareProjectLayoutNoOnboarding))
    }),
    (0, $apqRF.createEntry)((0, $1tmBn.projectIssueNavigatorClassicRoute), {
        ...$81a426de012c30b2$var$getCommonProject(),
        ...$81a426de012c30b2$var$common,
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7f18d9588e93cd1d$export$5fcc10c40c224fbc)
        ],
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $2Fzrk.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        layout: $81a426de012c30b2$var$getCommonProjectLayout()
    }),
    (0, $apqRF.createEntry)((0, $1tmBn.servicedeskIssuesRoute), {
        ...$81a426de012c30b2$var$getCommonProject(),
        ...$81a426de012c30b2$var$common,
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7f18d9588e93cd1d$export$5fcc10c40c224fbc)
        ],
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...$81a426de012c30b2$var$getCommonProjectResources(),
            (0, $hRe6W.queuesNavigationItems),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        layout: (0, $csLgO.serviceProjectLayout)
    }),
    (0, $apqRF.createEntry)((0, $1tmBn.projectIssueNavigatorCoreRoute), {
        ...$81a426de012c30b2$var$getCommonProject(),
        ...$81a426de012c30b2$var$common,
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7f18d9588e93cd1d$export$5fcc10c40c224fbc)
        ],
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $buaC1.default),
            horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
        },
        layout: $81a426de012c30b2$var$getCommonProjectLayout()
    }),
    (0, $apqRF.createEntry)((0, $1tmBn.globalIssueNavigatorRoute), {
        ...$81a426de012c30b2$var$getCommonGlobal(),
        ...$81a426de012c30b2$var$common,
        ufoName: 'global-issue-navigator-jfe',
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7f18d9588e93cd1d$export$8ff267588532c2ce)
        ]
    }),
    (0, $apqRF.createEntry)((0, $1tmBn.globalIssueNavigator1Route), {
        ...$81a426de012c30b2$var$getCommonGlobal(),
        ...$81a426de012c30b2$var$common,
        ufoName: 'global-issue-navigator-jfe',
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7f18d9588e93cd1d$export$8ff267588532c2ce)
        ]
    }),
    (0, $apqRF.createEntry)((0, $1tmBn.globalIssueNavigatorBrowseIssueRedirectRoute), {
        ...$81a426de012c30b2$var$getCommonGlobal(),
        ...$81a426de012c30b2$var$common,
        component: (0, $74828a2871cc60ec$export$2e2bcd8739ae039),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7f18d9588e93cd1d$export$8ff267588532c2ce)
        ]
    })
];



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $cernH = parcelRequire("cernH");

var $bAQOb = parcelRequire("bAQOb");

var $dVvIP = parcelRequire("dVvIP");

var $7vTKl = parcelRequire("7vTKl");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $dgH3j = parcelRequire("dgH3j");

var $exb0h = parcelRequire("exb0h");
const $afbafc5a4e5ea06c$export$384f4e88744c8073 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).JIRA_CONFIGURATOR,
    path: '/jira/configurator',
    exact: true
};



var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $d068bdb5ccbe979b$var$LazyJiraConfiguratorPage = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("7QB2o"))), {
    moduleId: "./src/packages/spa-apps/jira-configurator/src/index.tsx"
});
const $d068bdb5ccbe979b$export$69a8d35aeadf3060 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $d068bdb5ccbe979b$var$LazyJiraConfiguratorPage,
        pageId: "async-jira-configurator",
        shouldShowSpinner: false
    });
const $d068bdb5ccbe979b$export$769980c222432579 = (0, $apqRF.createEntry)((0, $afbafc5a4e5ea06c$export$384f4e88744c8073), {
    component: (0, $bAQOb.componentWithFF)('com.atlassian.rm.jpo.jsw-configurator-mvp_kd5ha', $d068bdb5ccbe979b$export$69a8d35aeadf3060, (0, $dgH3j.default)),
    layout: (0, $dVvIP.globalLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PLANS
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $d068bdb5ccbe979b$var$LazyJiraConfiguratorPage
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $cernH = parcelRequire("cernH");

var $jf8p7 = parcelRequire("jf8p7");

var $7z3So = parcelRequire("7z3So");


var $7vTKl = parcelRequire("7vTKl");

var $apqRF = parcelRequire("apqRF");

var $dAKwA = parcelRequire("dAKwA");

var $2BbQD = parcelRequire("2BbQD");

var $hHrVM = parcelRequire("hHrVM");

var $3DMty = parcelRequire("3DMty");

var $g08Zs = parcelRequire("g08Zs");

var $3yBpr = parcelRequire("3yBpr");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $4f31ccd2cefdb1fe$var$LazyJiraHomePage = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("6GquE"))), {
    moduleId: "./src/packages/spa-apps/jira-home/src/index.tsx"
});
const $4f31ccd2cefdb1fe$var$checkConsolidationOnRouteDependency = async (dependencies)=>{
    const data = await dependencies[0, $02315c431173f662$export$25ee35b01de9d734].promise;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $jf8p7.checkShouldUseJSM)(data);
};
const $4f31ccd2cefdb1fe$export$fe7946d7dc386f9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $4f31ccd2cefdb1fe$var$LazyJiraHomePage,
        pageId: "jira-home",
        shouldShowSpinner: false
    });
const $4f31ccd2cefdb1fe$export$578dcb61ac3cb57a = (0, $apqRF.createEntry)((0, $g08Zs.jiraHomeRoute), {
    ufoName: 'jira-home',
    component: $4f31ccd2cefdb1fe$export$fe7946d7dc386f9c,
    skeleton: (0, $3yBpr.YourWorkSkeleton),
    layout: (0, $f7d46703104602dd$export$5b7fb151d60504c),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).HOME
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $2BbQD.jiraHomeResourceWithCache),
        (0, $7z3So.jiraHomePageRightSidePanelResource),
        (0, $dAKwA.getConsolidationStateResource)(),
        ...(0, $3DMty.widgetResources).map((resourceCreator)=>resourceCreator($4f31ccd2cefdb1fe$var$checkConsolidationOnRouteDependency, [
                (0, $02315c431173f662$export$25ee35b01de9d734)
            ]))
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $4f31ccd2cefdb1fe$var$LazyJiraHomePage
    ]
});



var $cernH = parcelRequire("cernH");

var $dVvIP = parcelRequire("dVvIP");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $7c351d9ec6c74c7c$export$a3a93dcf611b611a = {
    group: (0, $exb0h.ROUTE_GROUPS).REDIRECTS,
    name: (0, $exb0h.ROUTE_NAMES).JIRA_SEARCH,
    path: '/jira/search',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $kJlBc = parcelRequire("kJlBc");
var $3HCkE = parcelRequire("3HCkE");

var $c4qEZ = parcelRequire("c4qEZ");

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $10fdS = parcelRequire("10fdS");
var $kJlBc = parcelRequire("kJlBc");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");
const $a301dcdfb79d4ff5$export$968c2900ae111000 = ({ Redirect: Redirect = (0, $kJlBc.Redirect), fireScreenAnalytics: fireScreenAnalytics = (0, $jMP2a.fireScreenAnalytics), useAnalyticsEvents: useAnalyticsEvents = (0, $bFzGY.useAnalyticsEvents), useCurrentRoute: useCurrentRoute = (0, $10fdS.useCurrentRoute), useQueryParam: useQueryParam = (0, $kJlBc.useQueryParam) })=>{
    const route = useCurrentRoute();
    const [searchString] = useQueryParam('searchString');
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    (0, $eUqFw.useEffect)(()=>{
        if (!route) return;
        const screenEvent = createAnalyticsEvent({
            screenName: 'quickSearchRedirect',
            attributes: {
                type: route.name
            }
        });
        fireScreenAnalytics(screenEvent);
    }, [
        createAnalyticsEvent,
        fireScreenAnalytics,
        route
    ]);
    let jql;
    if ((0, $1ybV0.ff)('nin_expose_text_option_jql_builder_4kwzo')) jql = searchString != null ? `summary ~ "${searchString}" OR description ~ "${searchString}" ORDER BY created DESC` : 'ORDER BY created DESC';
    else jql = searchString != null ? `text ~ "${searchString}"` : 'order by created DESC';
    const redirectUrl = `/issues/?jql=${encodeURIComponent(jql)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Redirect, {
        to: redirectUrl
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a301dcdfb79d4ff5$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a301dcdfb79d4ff5$export$968c2900ae111000, null);



var $53ciZ = parcelRequire("53ciZ");

var $2OdyW = parcelRequire("2OdyW");

var $3HCkE = parcelRequire("3HCkE");
const $264f0048e7ca8a95$export$486bd66a4d919be7 = 'RESOURCE_TYPE_JIRA_SEARCH';
const $264f0048e7ca8a95$export$d23832be0ebf8a93 = (0, $3HCkE.createResource)({
    type: $264f0048e7ca8a95$export$486bd66a4d919be7,
    getKey: ()=>'search',
    getData: ({ query: query }, { tenantContext: tenantContext })=>{
        const { atlassianAccountId: atlassianAccountId } = tenantContext;
        if (!atlassianAccountId || !query?.searchString) return null;
        const queryStr = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify({
            searchString: query.searchString
        });
        return (0, $2OdyW.default)(`/rest/navigation/4/quicksearch?${queryStr}`);
    },
    isBrowserOnly: true
});


const $33847b51b7819bfd$export$ee180957879b33ac = ()=>{
    const { data: data, loading: loading, error: error } = (0, $3HCkE.useResource)((0, $264f0048e7ca8a95$export$d23832be0ebf8a93));
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c4qEZ.IssueViewSkeleton), null);
    if (error || !data?.url) // handle api error state
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a301dcdfb79d4ff5$export$968c2900ae111000), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
        to: data.url,
        push: false
    });
};



const $13903430967d785b$export$76b74d5744e69817 = (0, $apqRF.createEntry)((0, $7c351d9ec6c74c7c$export$a3a93dcf611b611a), {
    component: (0, $33847b51b7819bfd$export$ee180957879b33ac),
    isRedirect: true,
    layout: (0, $dVvIP.globalLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $264f0048e7ca8a95$export$d23832be0ebf8a93)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation)
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $cernH = parcelRequire("cernH");

var $dVvIP = parcelRequire("dVvIP");

var $apqRF = parcelRequire("apqRF");

var $exb0h = parcelRequire("exb0h");
const $8e4b0143fd4c66be$export$176ff76c3ba7c4ce = {
    name: (0, $exb0h.ROUTE_NAMES).LEGACY_REDIRECT
};



const $aa194b628782eb2f$var$RedirectComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9f087e464fef57a9$export$2e2bcd8739ae039), null);
const $aa194b628782eb2f$export$27f123cb9320355 = (0, $apqRF.createEntry)((0, $8e4b0143fd4c66be$export$176ff76c3ba7c4ce), {
    component: $aa194b628782eb2f$var$RedirectComponent,
    layout: (0, $dVvIP.globalLayout),
    resources: [],
    isRedirect: true,
    canTransitionIn: ()=>false,
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation)
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");


var $apqRF = parcelRequire("apqRF");

var $exb0h = parcelRequire("exb0h");
const $bd51edcd838bda29$export$9efae7a8e8e69866 = {
    group: (0, $exb0h.ROUTE_GROUPS).ERRORS,
    name: (0, $exb0h.ROUTE_NAMES).LOGIN_EMBED,
    path: '/jira-login/embed'
};



var $59o4i = parcelRequire("59o4i");

const $4edc8bb5aeebf389$export$53d5d548e4e9b86 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("g8fhn")), {
    moduleId: "./src/packages/spa-apps/login-embed/src/index.tsx"
});
const $4edc8bb5aeebf389$export$2a94dc6e96350c82 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $4edc8bb5aeebf389$export$53d5d548e4e9b86,
        pageId: "spa-apps/login-embed",
        shouldShowSpinner: true
    });
const $4edc8bb5aeebf389$export$faa46f8c5e1f06d3 = (0, $apqRF.createEntry)((0, $bd51edcd838bda29$export$9efae7a8e8e69866), {
    component: $4edc8bb5aeebf389$export$2a94dc6e96350c82,
    layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb)
});



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $cernH = parcelRequire("cernH");

var $dVvIP = parcelRequire("dVvIP");

var $7vTKl = parcelRequire("7vTKl");

var $l90Gp = parcelRequire("l90Gp");

var $hUM03 = parcelRequire("hUM03");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $6ighq = parcelRequire("6ighq");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9556f709fc2a14de$var$LazyMarketplace = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("1zqfj"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/marketplace/src/index.tsx"
});
const $9556f709fc2a14de$var$MarketplaceComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $9556f709fc2a14de$var$LazyMarketplace,
        pageId: "marketplace",
        shouldShowSpinner: true
    });
const $9556f709fc2a14de$var$findAppsRouteEntry = (0, $apqRF.createEntry)((0, $6ighq.findAppsRoute), {
    component: $9556f709fc2a14de$var$MarketplaceComponent,
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).ADDONS,
        sidebar: (0, $hUM03.default)
    },
    layout: (0, $dVvIP.globalLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $l90Gp.getNavigationSidebarGlobalSettingsResources)(),
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $9556f709fc2a14de$var$LazyMarketplace
    ],
    ufoName: 'embedded-marketplace'
});
const $9556f709fc2a14de$export$423a1c80bb2f8b9a = (0, $apqRF.createEntry)((0, $6ighq.appRequestRoute), {
    component: $9556f709fc2a14de$var$MarketplaceComponent,
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).ADDONS,
        sidebar: (0, $hUM03.default)
    },
    layout: (0, $dVvIP.globalLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $l90Gp.getNavigationSidebarGlobalSettingsResources)(),
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $9556f709fc2a14de$var$LazyMarketplace
    ]
});
const $9556f709fc2a14de$export$875d88a44b1ff74c = (0, $apqRF.createEntry)((0, $6ighq.promotionsRoute), {
    component: $9556f709fc2a14de$var$MarketplaceComponent,
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).ADDONS,
        sidebar: (0, $hUM03.default)
    },
    layout: (0, $dVvIP.globalLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $l90Gp.getNavigationSidebarGlobalSettingsResources)(),
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $9556f709fc2a14de$var$LazyMarketplace
    ]
});
const $9556f709fc2a14de$export$fd3c71e3bfb4df9e = ()=>[
        $9556f709fc2a14de$var$findAppsRouteEntry,
        $9556f709fc2a14de$export$423a1c80bb2f8b9a,
        $9556f709fc2a14de$export$875d88a44b1ff74c
    ];



var $eUqFw = parcelRequire("eUqFw");

var $jh2R9 = parcelRequire("jh2R9");

var $53ciZ = parcelRequire("53ciZ");

var $cernH = parcelRequire("cernH");

var $exb0h = parcelRequire("exb0h");

var $2ijRB = parcelRequire("2ijRB");

var $7vTKl = parcelRequire("7vTKl");

var $iOOlt = parcelRequire("iOOlt");

var $apqRF = parcelRequire("apqRF");
var $kJlBc = parcelRequire("kJlBc");

var $gar3N = parcelRequire("gar3N");

var $hHrVM = parcelRequire("hHrVM");

var $5GEOG = parcelRequire("5GEOG");

var $dgH3j = parcelRequire("dgH3j");


var $exb0h = parcelRequire("exb0h");
const $a9abc802715eecc6$export$5b818a6914ca8376 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_REPORTS_BURNUP,
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/burnup'
};
const $a9abc802715eecc6$export$cde83a6497756848 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_REPORTS_VELOCITY,
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/velocity'
};
const $a9abc802715eecc6$export$3c48ddd40d00b0d2 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_REPORTS_CUMULATIVE,
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/cumulative'
};
const $a9abc802715eecc6$export$e0d8c26cb1430ae4 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_REPORTS_BURNDOWN,
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/burndown'
};
const $a9abc802715eecc6$export$c777bb8f2591081 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_REPORTS_CYCLE_TIME,
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/cycle-time'
};
const $a9abc802715eecc6$export$bbf45ab0423b990 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY,
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports/deployment-frequency'
};
const $a9abc802715eecc6$export$5bf75a5d8c554930 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_REPORTS,
    path: '/jira/software/projects/:projectKey/boards/:boardId/reports'
};
const $a9abc802715eecc6$export$6072946fe7f2d45a = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_NEXTGEN_REDIRECT,
    path: '/secure/NextGen.jspa'
};
const $a9abc802715eecc6$export$9d24fc75b0f1d9a0 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_CODE,
    path: '/jira/software/projects/:projectKey/code'
};
const $a9abc802715eecc6$export$866215abd09c0f4d = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_ROADMAP_REDIRECT,
    path: '/secure/Roadmap.jspa'
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $cernH = parcelRequire("cernH");



var $7vTKl = parcelRequire("7vTKl");

var $iOOlt = parcelRequire("iOOlt");

var $isbb2 = parcelRequire("isbb2");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $bc7vB = parcelRequire("bc7vB");
var $gmVN5 = parcelRequire("gmVN5");
var $59z8J = parcelRequire("59z8J");


var $exb0h = parcelRequire("exb0h");
const $9d771d6904eb20db$export$fb454ec14936c0ab = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_BACKLOG,
    path: '/jira/software/projects/:projectKey/boards/:boardId/backlog'
};



var $7msR2 = parcelRequire("7msR2");

var $bEe6y = parcelRequire("bEe6y");

var $soOXK = parcelRequire("soOXK");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

var $53ciZ = parcelRequire("53ciZ");
const $8fed448e8726ed96$export$557c2f222778cea6 = ({ location: location, match: match })=>{
    if (match && match.params.boardId) return match.params.boardId;
    const { rapidView: rapidView } = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(location.search);
    return rapidView;
};



const $afa4ca373a35f9b7$export$edb4b8cf67d7d767 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("1F5sC"))), {
    moduleId: "./src/packages/spa-apps/next-gen-backlog/src/index.tsx"
});
const $afa4ca373a35f9b7$var$BacklogPage = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $afa4ca373a35f9b7$export$edb4b8cf67d7d767,
        pageId: `next-gen-backlog-${(0, $8fed448e8726ed96$export$557c2f222778cea6)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });
const $afa4ca373a35f9b7$export$a5f8ba02d2755510 = (0, $apqRF.createEntry)((0, $9d771d6904eb20db$export$fb454ec14936c0ab), {
    component: $afa4ca373a35f9b7$var$BacklogPage,
    skeleton: (0, $7msR2.NextGenBacklogSkeleton),
    layout: (0, $isbb2.composeLayouts)((0, $soOXK.softwareProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
        {
            query: [
                'selectedIssue'
            ]
        }
    ])),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iOOlt.default),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $gmVN5.conditionalBacklogResource),
        (0, $bc7vB.conditionalBacklogRelayResource),
        (0, $59z8J.customFiltersResource)
    ],
    preloadOptions: {
        earlyChunks: [
            'software-backlog-early-entry'
        ]
    },
    afterPaint: [
        (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $afa4ca373a35f9b7$export$edb4b8cf67d7d767
    ],
    ufoName: 'next-gen-backlog',
    meta: {
        capability: (0, $d07297a4af13004b$export$c17f34c425972af1)
    }
});
var $afa4ca373a35f9b7$export$2e2bcd8739ae039 = $afa4ca373a35f9b7$var$BacklogPage;



var $eUqFw = parcelRequire("eUqFw");

var $53ciZ = parcelRequire("53ciZ");

var $7rh0R = parcelRequire("7rh0R");

var $dfBCt = parcelRequire("dfBCt");

var $cernH = parcelRequire("cernH");


var $1ybV0 = parcelRequire("1ybV0");


var $7vTKl = parcelRequire("7vTKl");

var $iOOlt = parcelRequire("iOOlt");

var $isbb2 = parcelRequire("isbb2");

var $apqRF = parcelRequire("apqRF");

var $chAei = parcelRequire("chAei");

var $hHrVM = parcelRequire("hHrVM");

var $gyys9 = parcelRequire("gyys9");

var $jwzNs = parcelRequire("jwzNs");


var $7yAHk = parcelRequire("7yAHk");

var $j7Vfn = parcelRequire("j7Vfn");

var $bEe6y = parcelRequire("bEe6y");

var $soOXK = parcelRequire("soOXK");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $9f5dd2b7ff8af740$export$bd9ede4ec384f41d = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("cPcEF"))), {
    moduleId: "./src/packages/spa-apps/next-gen-board/src/index.tsx"
});
const $9f5dd2b7ff8af740$var$getBoardId = ({ location: location, match: match })=>{
    if (match && match.params.boardId) return match.params.boardId;
    const { rapidView: rapidView } = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(location.search);
    return rapidView;
};
const $9f5dd2b7ff8af740$export$78e6ebf73d7f732b = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $9f5dd2b7ff8af740$export$bd9ede4ec384f41d,
        pageId: `next-gen-board-${$9f5dd2b7ff8af740$var$getBoardId({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });
const $9f5dd2b7ff8af740$var$conditionalBoardResource = (0, $jwzNs.resourceWithCondition)(()=>!(0, $1ybV0.ff)('jsw.perf.critical-board-with-relay'), (0, $chAei.boardResource));
const $9f5dd2b7ff8af740$var$conditionalBoardRelayResource = (0, $jwzNs.resourceWithCondition)(()=>(0, $1ybV0.ff)('jsw.perf.critical-board-with-relay'), (0, $chAei.boardRelayResource));
const $9f5dd2b7ff8af740$var$conditionalBoardNBTOptInResource = (0, $jwzNs.resourceWithCondition2)(()=>!(0, $dfBCt.isFedRamp)(), (0, $gyys9.nextBestTaskFeatureResource));
const $9f5dd2b7ff8af740$export$2964ea1cdd5afa39 = (0, $apqRF.createEntry)((0, $7yAHk.softwareBoardRoute), {
    component: $9f5dd2b7ff8af740$export$78e6ebf73d7f732b,
    skeleton: (0, $j7Vfn.NextGenBoardSkeleton),
    layout: (0, $isbb2.composeLayouts)((0, $soOXK.softwareProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
        {
            query: [
                'selectedIssue'
            ]
        }
    ])),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iOOlt.default),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        $9f5dd2b7ff8af740$var$conditionalBoardResource,
        (0, $chAei.customFiltersResource),
        $9f5dd2b7ff8af740$var$conditionalBoardRelayResource,
        $9f5dd2b7ff8af740$var$conditionalBoardNBTOptInResource
    ],
    preloadOptions: {
        earlyChunks: [
            'software-board-early-entry'
        ]
    },
    afterPaint: [
        (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $9f5dd2b7ff8af740$export$bd9ede4ec384f41d
    ],
    ufoName: 'next-gen-board',
    meta: {
        capability: (0, $d07297a4af13004b$export$f364828958cffad0)
    }
});



var $cernH = parcelRequire("cernH");



var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");


var $7vTKl = parcelRequire("7vTKl");

var $iOOlt = parcelRequire("iOOlt");

var $isbb2 = parcelRequire("isbb2");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $3MEW8 = parcelRequire("3MEW8");

var $dgH3j = parcelRequire("dgH3j");

var $exb0h = parcelRequire("exb0h");
const $71f996d450635d54$export$d6730f103a4ad844 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_CALENDAR,
    path: '/jira/software/projects/:projectKey/boards/:boardId/calendar',
    queries: [
        'date?'
    ]
};
const $71f996d450635d54$export$b55c4d4efb097c1c = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_CALENDAR_EMBED,
    path: '/jira/software/projects/:projectKey/boards/:boardId/calendar/embed',
    queries: [
        'date?'
    ]
};



var $7u7sK = parcelRequire("7u7sK");

var $bEe6y = parcelRequire("bEe6y");

var $soOXK = parcelRequire("soOXK");

const $bf82d83bb632614e$export$24fc07c22f0d06 = (0, $apqRF.createEntry)((0, $71f996d450635d54$export$b55c4d4efb097c1c), {
    skeleton: (0, $7u7sK.CalendarEmbedSkeleton),
    component: (0, $9zysr.componentWithCondition)(()=>(0, $1ybV0.ff)('jsw.perf.calendar-disable-ssr_z5p6p'), (0, $7u7sK.CalendarEmbedSkeleton), (0, $dgH3j.default)),
    entryPoint () {
        if ((0, $1ybV0.ff)('jsw.perf.calendar-disable-ssr_z5p6p') && false) return undefined;
        return (0, $1ybV0.ff)('jsw-calendar-view') ? $bf82d83bb632614e$export$d154630e8966be91 : undefined;
    },
    layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
    resources: [
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $3MEW8.themePreferenceResource)
    ],
    ufoName: 'next-gen-calendar-embed'
});
const $bf82d83bb632614e$export$d154630e8966be91 = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $f6122116660bea23$export$19cf4b398f638dc6),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});
const $bf82d83bb632614e$export$83b1b9036cc7961a = (0, $apqRF.createEntry)((0, $71f996d450635d54$export$d6730f103a4ad844), {
    skeleton: (0, $7u7sK.CalendarSkeleton),
    component: (0, $9zysr.componentWithCondition)(()=>(0, $1ybV0.ff)('jsw.perf.calendar-disable-ssr_z5p6p'), (0, $7u7sK.CalendarSkeleton), (0, $dgH3j.default)),
    entryPoint () {
        if ((0, $1ybV0.ff)('jsw.perf.calendar-disable-ssr_z5p6p') && false) return undefined;
        return (0, $1ybV0.ff)('jsw-calendar-view') ? $bf82d83bb632614e$export$d154630e8966be91 : undefined;
    },
    layout: (0, $isbb2.composeLayouts)((0, $soOXK.softwareProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
        {
            query: [
                'selectedIssue'
            ]
        }
    ])),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iOOlt.default),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)()
    ],
    afterPaint: [
        (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation)
    ],
    ufoName: 'next-gen-calendar'
});




var $7vTKl = parcelRequire("7vTKl");

var $iOOlt = parcelRequire("iOOlt");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $122398eee18b185f$export$2328fed7ebee3cce = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_GOALS,
    exact: true,
    path: '/jira/software/projects/:projectKey/goals'
};



var $bEe6y = parcelRequire("bEe6y");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $c4359f5b4095d323$export$69b07a7049b7beab = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("ghn1W"))), {
    moduleId: "./src/packages/spa-apps/goals/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c4359f5b4095d323$export$2e2bcd8739ae039 = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $c4359f5b4095d323$export$69b07a7049b7beab,
        pageId: `atlas-goals-${match.params.boardId || ''}`,
        shouldShowSpinner: false
    });


const $716a6814b23ca11c$export$d3fcc412edfa2068 = (0, $apqRF.createEntry)((0, $122398eee18b185f$export$2328fed7ebee3cce), {
    component: (0, $c4359f5b4095d323$export$2e2bcd8739ae039),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iOOlt.default),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)()
    ]
});



var $cernH = parcelRequire("cernH");


var $79xbN = parcelRequire("79xbN");

var $9zysr = parcelRequire("9zysr");


var $7vTKl = parcelRequire("7vTKl");

var $iOOlt = parcelRequire("iOOlt");

var $isbb2 = parcelRequire("isbb2");

var $apqRF = parcelRequire("apqRF");

var $fD1Hq = parcelRequire("fD1Hq");

var $kMmsu = parcelRequire("kMmsu");

var $f26dB = parcelRequire("f26dB");

var $aeIT6 = parcelRequire("aeIT6");

var $hHrVM = parcelRequire("hHrVM");

var $2JncP = parcelRequire("2JncP");

var $dgH3j = parcelRequire("dgH3j");

var $exb0h = parcelRequire("exb0h");
const $3a594ac4ee6eb737$export$f3a5b1b732315e13 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_LIST,
    path: '/jira/software/projects/:projectKey/list'
};
const $3a594ac4ee6eb737$export$70dd8df584442004 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_LIST_EMBED,
    path: '/jira/software/projects/:projectKey/list/embed'
};




var $bEe6y = parcelRequire("bEe6y");

var $soOXK = parcelRequire("soOXK");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $23852dc93c7d3399$export$26b97a235767fc3c = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("bLPIE"))), {
    moduleId: "./src/packages/spa-apps/business/jsw-list/src/index.tsx"
});

const $23852dc93c7d3399$export$8c61f5f5c58f351f = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("f0z5c"))), {
    moduleId: "./src/packages/spa-apps/business/jsw-list-embed/src/index.tsx"
});
const $23852dc93c7d3399$export$422a3a028ae77ad3 = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $23852dc93c7d3399$export$26b97a235767fc3c,
        pageId: `next-gen-list-${match.params.boardId || ''}`,
        shouldShowSpinner: false
    });
const $23852dc93c7d3399$export$4a0539d19a2e2694 = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $23852dc93c7d3399$export$8c61f5f5c58f351f,
        pageId: `next-gen-list-${match.params.boardId || ''}-embed`,
        shouldShowSpinner: false
    });


const $2df1207b13a402cc$var$getListProjectResources = ()=>[
        (0, $2JncP.projectCreatePermissionsResource),
        (0, $f26dB.navigationResource),
        (0, $aeIT6.projectDetailsResource),
        (0, $fD1Hq.configurationResource),
        (0, $kMmsu.fieldsResource)
    ];
const $2df1207b13a402cc$export$f30a66efa682bf2d = (0, $apqRF.createEntry)((0, $3a594ac4ee6eb737$export$f3a5b1b732315e13), {
    component: (0, $9zysr.componentWithCondition)(()=>(0, $79xbN.expValEquals)('jsw_list_view', 'cohort', 'variation'), (0, $23852dc93c7d3399$export$422a3a028ae77ad3), (0, $dgH3j.default)),
    skeleton: (0, $f1174c8234e7b02e$export$cbc3335f7a517046),
    layout: (0, $isbb2.composeLayouts)((0, $soOXK.softwareProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
        {
            query: [
                'selectedIssue'
            ]
        }
    ])),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iOOlt.default),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...$2df1207b13a402cc$var$getListProjectResources()
    ],
    afterPaint: [
        (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $23852dc93c7d3399$export$26b97a235767fc3c)
    ],
    ufoName: 'next-gen-list'
});
const $2df1207b13a402cc$export$1099e0e49394fa9a = (0, $apqRF.createEntry)((0, $3a594ac4ee6eb737$export$70dd8df584442004), {
    component: (0, $9zysr.componentWithCondition)(()=>(0, $79xbN.expValEquals)('jsw_list_view', 'cohort', 'variation'), (0, $23852dc93c7d3399$export$4a0539d19a2e2694), (0, $dgH3j.default)),
    skeleton: (0, $f1174c8234e7b02e$export$2638f1c98fe91c13),
    layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$2df1207b13a402cc$var$getListProjectResources()
    ],
    forPaint: [
        (0, $23852dc93c7d3399$export$8c61f5f5c58f351f)
    ],
    ufoName: 'next-gen-list-embed'
});





var $1Iui1 = parcelRequire("1Iui1");

var $79xbN = parcelRequire("79xbN");

var $9zysr = parcelRequire("9zysr");

var $eI5EY = parcelRequire("eI5EY");

var $apqRF = parcelRequire("apqRF");

var $3MEW8 = parcelRequire("3MEW8");

var $dgH3j = parcelRequire("dgH3j");

var $exb0h = parcelRequire("exb0h");
const $f04885cb083d2490$export$9f9c6c613d93c0e5 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_PRESENTATION_TOOLKIT_REPORT,
    path: '/jira/software/presentation-toolkit-report',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $ff4fb309e93ebd4d$export$d95295446c03a00c = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("hv7Ay"))), {
    moduleId: "./src/packages/spa-apps/software/presentation-toolkit-report/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ff4fb309e93ebd4d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $ff4fb309e93ebd4d$export$d95295446c03a00c,
        pageId: "jira-software-presentation-toolkit-report",
        shouldShowSpinner: true
    });


const $490b95a631ece100$var$getIsEnrolledInExperiment = ()=>{
    // Do not want to log exposure, because there are more conditions that will be checked when the component is rendered
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_presentation_toolkit_experiment');
    const isPassedGate = (0, $eI5EY.fg)('jsw_presentation_toolkit_gate');
    return expConfig.get('cohort', (0, $1Iui1.NOT_ENROLLED)) !== (0, $1Iui1.NOT_ENROLLED) && isPassedGate;
};
const $490b95a631ece100$export$60cf591eccf54b03 = (0, $apqRF.createEntry)((0, $f04885cb083d2490$export$9f9c6c613d93c0e5), {
    component: (0, $9zysr.componentWithCondition)($490b95a631ece100$var$getIsEnrolledInExperiment, (0, $ff4fb309e93ebd4d$export$2e2bcd8739ae039), (0, $dgH3j.default)),
    layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
    resources: [
        (0, $3MEW8.themePreferenceResource)
    ],
    forPaint: [
        (0, $ff4fb309e93ebd4d$export$d95295446c03a00c)
    ]
});



var $cernH = parcelRequire("cernH");

var $1ybV0 = parcelRequire("1ybV0");

var $7vTKl = parcelRequire("7vTKl");

var $62ZdZ = parcelRequire("62ZdZ");
var $51qRF = parcelRequire("51qRF");

var $iOOlt = parcelRequire("iOOlt");

var $2Fzrk = parcelRequire("2Fzrk");

var $isbb2 = parcelRequire("isbb2");

var $apqRF = parcelRequire("apqRF");

var $4qvmP = parcelRequire("4qvmP");

var $cINNO = parcelRequire("cINNO");

var $hHrVM = parcelRequire("hHrVM");

var $8hvlU = parcelRequire("8hvlU");

var $jwzNs = parcelRequire("jwzNs");


var $exb0h = parcelRequire("exb0h");
const $7a57dca132bd422e$export$5a84dbc6e86abbed = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_REQUESTS,
    path: '/jira/software/projects/:projectKey/requests'
};
const $7a57dca132bd422e$export$e45e557c8c37bcea = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_REQUESTS_CLASSIC,
    path: '/jira/software/c/projects/:projectKey/requests'
};



var $iPtkN = parcelRequire("iPtkN");

var $bEe6y = parcelRequire("bEe6y");

var $soOXK = parcelRequire("soOXK");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");
var /**
 * Generates a unique identifier for pages based on various criteria to support features such as caching or analytics, ensuring each page is distinctly recognizable.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$40e3d86990ee0839$export$2e2bcd8739ae039 = (pageIdPrefix, { params: params }, { filter: filter, orderby: orderby, keyword: keyword })=>{
    const { projectKey: projectKey, issueKey: issueKey } = params;
    let pageId = '';
    try {
        pageId = `${pageIdPrefix}${(projectKey !== null && projectKey !== undefined ? `-${projectKey}` : '') + (issueKey !== null && issueKey !== undefined ? `-${issueKey}` : '') + (filter !== undefined ? `-${filter}` : '') + (orderby !== undefined ? `-${orderby}` : '') + (keyword !== undefined ? `-${keyword}` : '')}`;
    } catch  {
        pageId = pageIdPrefix;
    }
    return pageId;
};



const $a43b25670d5fe7c8$export$3b235a8105f91b2b = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("gCNEV"))), {
    moduleId: "./src/packages/software/requests/requests-page/src/index.tsx"
});
const $a43b25670d5fe7c8$export$b357b5f614f36f9a = ({ match: match, query: query })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $a43b25670d5fe7c8$export$3b235a8105f91b2b,
        pageId: (0, $40e3d86990ee0839$export$2e2bcd8739ae039)('next-gen-requests', match, query),
        shouldShowSpinner: false
    });
const $a43b25670d5fe7c8$export$f6b20eb362411299 = ({ match: match, query: query })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $a43b25670d5fe7c8$export$3b235a8105f91b2b,
        pageId: (0, $40e3d86990ee0839$export$2e2bcd8739ae039)('classic-requests', match, query),
        shouldShowSpinner: false
    });


const $a14d5efc9298d717$var$getCommonProjectResources = ()=>[
        (0, $8hvlU.issueNavigatorRelayResource),
        (0, $8hvlU.issueNavigatorFilterRelayResource),
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $4qvmP.getBusinessProjectResources)(),
        // TODO: create skeleton for requests
        (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('nin.global-scope_aqec8'), (0, $62ZdZ.sidebarProjectIssuesResource)),
        (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('nin.global-scope_aqec8'), (0, $cINNO.isNinGlobalScopeEnrolmentEnabledResource)),
        (0, $51qRF.staticSidebarDefaultPINFiltersResource)
    ];
const $a14d5efc9298d717$var$getCommonProject = ()=>({
        apdexIgnoreParams: [
            'issueKey'
        ],
        // TO-DO change this to Request page skelton after creating skeleton for Request page
        skeleton: (0, $iPtkN.ProjectIssueNavigatorSkeleton),
        resources: [
            ...$a14d5efc9298d717$var$getCommonProjectResources()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $a43b25670d5fe7c8$export$3b235a8105f91b2b)
        ],
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ]
    });
const $a14d5efc9298d717$export$fe880b76c2e8d7cf = (0, $apqRF.createEntry)((0, $7a57dca132bd422e$export$5a84dbc6e86abbed), {
    ...$a14d5efc9298d717$var$getCommonProject(),
    component: (0, $a43b25670d5fe7c8$export$b357b5f614f36f9a),
    layout: (0, $isbb2.composeLayouts)((0, $soOXK.softwareProjectLayout)),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iOOlt.default),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
    },
    ufoName: 'next-gen-requests'
});
const $a14d5efc9298d717$export$db399ba51c2e38a6 = (0, $apqRF.createEntry)((0, $7a57dca132bd422e$export$e45e557c8c37bcea), {
    ...$a14d5efc9298d717$var$getCommonProject(),
    component: (0, $a43b25670d5fe7c8$export$f6b20eb362411299),
    layout: (0, $isbb2.composeLayouts)((0, $soOXK.softwareProjectLayout)),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $2Fzrk.default),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
    },
    ufoName: 'classic-requests'
});



var $eUqFw = parcelRequire("eUqFw");

var $cernH = parcelRequire("cernH");


var $7vTKl = parcelRequire("7vTKl");

var $iOOlt = parcelRequire("iOOlt");

var $isbb2 = parcelRequire("isbb2");

var $apqRF = parcelRequire("apqRF");
var $kJlBc = parcelRequire("kJlBc");

var $hHrVM = parcelRequire("hHrVM");

var $bU6C3 = parcelRequire("bU6C3");


var $exb0h = parcelRequire("exb0h");
const $fbae1e99819ee1b3$export$a4a573c36fc75b30 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_ROADMAP,
    path: '/jira/software/projects/:projectKey/boards/:boardId/roadmap'
};



var $841Zr = parcelRequire("841Zr");

var $bEe6y = parcelRequire("bEe6y");

var $soOXK = parcelRequire("soOXK");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $c7da89307acb6c95$export$1339c847cf4ab57 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("gElxv"))), {
    moduleId: "./src/packages/spa-apps/roadmap/src/view/next-gen/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c7da89307acb6c95$export$2e2bcd8739ae039 = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $c7da89307acb6c95$export$1339c847cf4ab57,
        pageId: `next-gen-roadmap-${match.params.boardId || ''}`,
        shouldShowSpinner: false
    });


const $3e4b1429136330d9$export$dd8650bb193f860b = ({ match: { params: { projectKey: projectKey, boardId: boardId } }, query: query })=>{
    const queryParams = new URLSearchParams(query).toString();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
        to: {
            pathname: `/jira/software/projects/${String(projectKey)}/boards/${String(boardId)}/timeline`,
            hash: '',
            search: queryParams
        }
    });
};
const $3e4b1429136330d9$export$c1d875e34d537389 = (0, $apqRF.createEntry)((0, $fbae1e99819ee1b3$export$a4a573c36fc75b30), {
    component: $3e4b1429136330d9$export$dd8650bb193f860b,
    skeleton: (0, $841Zr.RoadmapSkeleton),
    layout: (0, $isbb2.composeLayouts)((0, $soOXK.softwareProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
        {
            query: [
                'selectedIssue'
            ]
        }
    ])),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iOOlt.default),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $bU6C3.nextGenRoadmapResource)
    ],
    preloadOptions: {
        earlyChunks: [
            'software-roadmap-early-entry'
        ]
    },
    afterPaint: [
        (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $c7da89307acb6c95$export$1339c847cf4ab57)
    ],
    ufoName: 'next-gen-roadmap'
});




var $cernH = parcelRequire("cernH");


var $7vTKl = parcelRequire("7vTKl");

var $iOOlt = parcelRequire("iOOlt");

var $isbb2 = parcelRequire("isbb2");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $bU6C3 = parcelRequire("bU6C3");


var $exb0h = parcelRequire("exb0h");
const $7542badf59123bb8$export$d25dafcda96d5af9 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_TIMELINE,
    path: '/jira/software/projects/:projectKey/boards/:boardId/timeline'
};



var $841Zr = parcelRequire("841Zr");

var $bEe6y = parcelRequire("bEe6y");

var $soOXK = parcelRequire("soOXK");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $f9cc26c53407a06d$export$1339c847cf4ab57 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("gElxv"))), {
    moduleId: "./src/packages/spa-apps/roadmap/src/view/next-gen/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f9cc26c53407a06d$export$2e2bcd8739ae039 = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $f9cc26c53407a06d$export$1339c847cf4ab57,
        pageId: `next-gen-roadmap-${match.params.boardId || ''}`,
        shouldShowSpinner: false
    });


const $712bd1e16f3f7c0a$export$ace6a996c7e99f3 = (0, $apqRF.createEntry)((0, $7542badf59123bb8$export$d25dafcda96d5af9), {
    component: (0, $f9cc26c53407a06d$export$2e2bcd8739ae039),
    skeleton: (0, $841Zr.RoadmapSkeleton),
    layout: (0, $isbb2.composeLayouts)((0, $soOXK.softwareProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
        {
            query: [
                'selectedIssue'
            ]
        }
    ])),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iOOlt.default),
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $bU6C3.nextGenRoadmapResource)
    ],
    preloadOptions: {
        earlyChunks: [
            'software-roadmap-early-entry'
        ]
    },
    afterPaint: [
        (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $f9cc26c53407a06d$export$1339c847cf4ab57)
    ],
    ufoName: 'next-gen-roadmap'
});



var $eUqFw = parcelRequire("eUqFw");

var $jh2R9 = parcelRequire("jh2R9");

var $cernH = parcelRequire("cernH");

var $exb0h = parcelRequire("exb0h");

var $7vTKl = parcelRequire("7vTKl");

var $iOOlt = parcelRequire("iOOlt");

var $2Fzrk = parcelRequire("2Fzrk");

var $apqRF = parcelRequire("apqRF");
var $kJlBc = parcelRequire("kJlBc");

var $hHrVM = parcelRequire("hHrVM");

var $ixwgj = parcelRequire("ixwgj");

var $llMVF = parcelRequire("llMVF");

var $73beW = parcelRequire("73beW");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");
var $387336265a8af451$exports = {};
$387336265a8af451$exports = new URL("version-detail-skeleton.tpl.c4c4fc18.svg", import.meta.url).toString();


const $95cf873da74edc11$export$b3661a594ba34350 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($387336265a8af451$exports)))
    });



var $bEe6y = parcelRequire("bEe6y");

var $soOXK = parcelRequire("soOXK");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $c80c2dd31bfa329e$export$2d31f5f47e6584e0 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("5Stjx"))), {
    moduleId: "./src/packages/spa-apps/version-detail/src/index.tsx"
});
const $c80c2dd31bfa329e$export$231cc5186b991031 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $c80c2dd31bfa329e$export$2d31f5f47e6584e0,
        pageId: "version-detail",
        shouldShowSpinner: false
    });


const $02ebad1b1697b652$var$VersionDetailPageLegacyRedirect = ({ match: { params: { projectKey: projectKey, versionId: versionId, tab: tab } } })=>{
    // This should never happen as if it wasn't matched, this won't be rendered unless someone re-used this component in a wrong route.
    if (projectKey == null || versionId == null) throw Error('projectKey or versionId not found in match object of RouteContext');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
        to: `/projects/${projectKey}/versions/${versionId}/tab/${tab != null ? tab : 'release-report-all-issues'}`
    });
};
const $02ebad1b1697b652$export$c97dabcfe9d495fa = (0, $apqRF.createEntry)((0, $73beW.softwareVersionDetailRoute), {
    component: (0, $c80c2dd31bfa329e$export$231cc5186b991031),
    skeleton: (0, $95cf873da74edc11$export$b3661a594ba34350),
    canTransitionIn: ()=>true,
    layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: [
            (0, $iOOlt.default),
            (0, $2Fzrk.default)
        ],
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $llMVF.versionDetailsRelayResourceCustom),
        (0, $ixwgj.projectContextResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $c80c2dd31bfa329e$export$2d31f5f47e6584e0)
    ],
    meta: {
        reporting: {
            id: (0, $exb0h.ROUTE_NAMES).SOFTWARE_VERSION_DETAIL,
            packageName: (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))((0, $exb0h.ROUTE_NAMES).SOFTWARE_VERSION_DETAIL),
            teamName: 'fusion-solaris'
        }
    }
});
const $02ebad1b1697b652$export$28d16aae32969765 = (0, $apqRF.createEntry)({
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_VERSION_DETAIL_NO_TAB_PATH,
    path: '/projects/:projectKey/versions/:versionId'
}, {
    component: $02ebad1b1697b652$var$VersionDetailPageLegacyRedirect,
    canTransitionIn: ()=>true,
    layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: [
            (0, $iOOlt.default),
            (0, $2Fzrk.default)
        ],
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $c80c2dd31bfa329e$export$2d31f5f47e6584e0)
    ]
});
const $02ebad1b1697b652$export$f29aafdff734071c = (0, $apqRF.createEntry)({
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_VERSION_DETAIL_LEGACY_REDIRECT,
    path: '/browse/:projectKey/fixforversion/:versionId'
}, {
    component: $02ebad1b1697b652$var$VersionDetailPageLegacyRedirect,
    canTransitionIn: ()=>true,
    layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: [
            (0, $iOOlt.default),
            (0, $2Fzrk.default)
        ],
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $c80c2dd31bfa329e$export$2d31f5f47e6584e0)
    ]
});



var $yyqSx = parcelRequire("yyqSx");

var $bEe6y = parcelRequire("bEe6y");

var $soOXK = parcelRequire("soOXK");

var $kKeF6 = parcelRequire("kKeF6");
var $GuBa2 = parcelRequire("GuBa2");

var $5fOZm = parcelRequire("5fOZm");
const $d87005bb78f4244b$export$8cb713295e6b7204 = ()=>[
        (0, $5fOZm.devOpsReportPreconditionResource),
        (0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $d87005bb78f4244b$export$f234446c23dc22a = ()=>[
        (0, $5fOZm.devOpsReportPreconditionResource),
        (0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $GuBa2.staticSidebarJSWReportsResource)
    ];



var $53ciZ = parcelRequire("53ciZ");
const $5341544e238d5d38$var$PLAN = 'planning';
const $5341544e238d5d38$var$REPORTING = 'reporting';
const $5341544e238d5d38$var$REPORTS = 'reports';
const $5341544e238d5d38$var$constructUrlForView = (url, view, searchResult)=>{
    if (view.startsWith($5341544e238d5d38$var$PLAN)) return `${url}/backlog`;
    if (view.startsWith($5341544e238d5d38$var$REPORTING) || view.startsWith($5341544e238d5d38$var$REPORTS)) {
        if (searchResult.report) return `${url}/reports/${searchResult.report}`;
        return `${url}/reports`;
    }
    return url;
};
const $5341544e238d5d38$var$KNOWN_KEYS = [
    'rapidView',
    'projectKey',
    'view',
    'report'
];
const $5341544e238d5d38$var$forwardUnknownQueryParams = (url, queryParams)=>{
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(Object.entries(queryParams).filter(([k])=>!$5341544e238d5d38$var$KNOWN_KEYS.includes(k)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((result, [k, v])=>({
            [k]: v,
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result
        }), {}));
    if (query) return `${url}?${query}`;
    return url;
};
const $5341544e238d5d38$export$8c47088cd9b527ba = (location)=>{
    const searchResult = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(location.search);
    const url = `/jira/software/projects/${searchResult.projectKey}/boards/${searchResult.rapidView}`;
    if (searchResult.view) return $5341544e238d5d38$var$forwardUnknownQueryParams($5341544e238d5d38$var$constructUrlForView(url, searchResult.view, searchResult), searchResult);
    return $5341544e238d5d38$var$forwardUnknownQueryParams(url, searchResult);
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $1ac1fc409b478241$export$1339c847cf4ab57 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("gElxv"))), {
    moduleId: "./src/packages/spa-apps/roadmap/src/view/next-gen/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1ac1fc409b478241$export$2e2bcd8739ae039 = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $1ac1fc409b478241$export$1339c847cf4ab57,
        pageId: `next-gen-roadmap-${match.params.boardId || ''}`,
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

var $53ciZ = parcelRequire("53ciZ");
const $1bf79051fed80f7f$export$557c2f222778cea6 = ({ location: location, match: match })=>{
    if (match && match.params.boardId) return match.params.boardId;
    const { rapidView: rapidView } = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(location.search);
    return rapidView;
};



const $5cd97f20ee6e4d57$export$4beafd9dbad29bff = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("cZ7T2"))), {
    moduleId: "./src/packages/spa-apps/code/src/index.tsx"
});
const $5cd97f20ee6e4d57$export$d9e8184332f86b53 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $5cd97f20ee6e4d57$export$4beafd9dbad29bff,
        pageId: `next-gen-code-${(0, $1bf79051fed80f7f$export$557c2f222778cea6)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });
const $5cd97f20ee6e4d57$export$95e2389b7ca7ccf2 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $5cd97f20ee6e4d57$export$4beafd9dbad29bff,
        pageId: `classic-code-${(0, $1bf79051fed80f7f$export$557c2f222778cea6)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");


const $60a4eae38aab8e0b$export$10cd1e761434952 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("c561s"))), {
    moduleId: "./src/packages/spa-apps/next-gen-reports/burndown/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$60a4eae38aab8e0b$export$2e2bcd8739ae039 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $60a4eae38aab8e0b$export$10cd1e761434952,
        pageId: `next-gen-reports-burndown-${(0, $1bf79051fed80f7f$export$557c2f222778cea6)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");


const $3e4a1cc841187c61$export$2ae7ab3b633c1d15 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("cZKjw"))), {
    moduleId: "./src/packages/spa-apps/next-gen-reports/burnup/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3e4a1cc841187c61$export$2e2bcd8739ae039 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $3e4a1cc841187c61$export$2ae7ab3b633c1d15,
        pageId: `next-gen-reports-burnup-${(0, $1bf79051fed80f7f$export$557c2f222778cea6)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");


const $4c67b3a1ed32bba6$export$c588973e5bd18a8d = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("9zMbV"))), {
    moduleId: "./src/packages/spa-apps/next-gen-reports/cumulative/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4c67b3a1ed32bba6$export$2e2bcd8739ae039 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $4c67b3a1ed32bba6$export$c588973e5bd18a8d,
        pageId: `next-gen-reports-cumulative-${(0, $1bf79051fed80f7f$export$557c2f222778cea6)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $5f6e3fe4d9f53d04$export$956f830ed027f1fb = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("glXm4")), {
    moduleId: "./src/packages/spa-apps/cycle-time-report/src/index.tsx"
});
const $5f6e3fe4d9f53d04$export$e16ce0656a74a015 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $5f6e3fe4d9f53d04$export$956f830ed027f1fb,
        pageId: "cycleTimeReportNextGen",
        shouldShowSpinner: true
    });
const $5f6e3fe4d9f53d04$export$237924ba64065cc3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $5f6e3fe4d9f53d04$export$956f830ed027f1fb,
        pageId: "cycleTimeReportClassic",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $8ab0e4f8eec61b65$export$5113b2b19ec1fb53 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("heI8s")), {
    moduleId: "./src/packages/spa-apps/deployment-frequency-report/src/index.tsx"
});
const $8ab0e4f8eec61b65$export$e2db9c7426cdb53 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $8ab0e4f8eec61b65$export$5113b2b19ec1fb53,
        pageId: "deploymentFrequencyReportNextGen",
        shouldShowSpinner: true
    });
const $8ab0e4f8eec61b65$export$655707e8ae1053d3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $8ab0e4f8eec61b65$export$5113b2b19ec1fb53,
        pageId: "deploymentFrequencyReportClassic",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");


const $fd39322616372e6e$export$dbd12c5c20c26961 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("RkzV7"))), {
    moduleId: "./src/packages/spa-apps/next-gen-reports/overview/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fd39322616372e6e$export$2e2bcd8739ae039 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $fd39322616372e6e$export$dbd12c5c20c26961,
        pageId: `next-gen-reports-overview-${(0, $1bf79051fed80f7f$export$557c2f222778cea6)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");


const $679605082ab30589$export$a2ca519c668b2f72 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("4ISF0"))), {
    moduleId: "./src/packages/spa-apps/next-gen-reports/velocity/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$679605082ab30589$export$2e2bcd8739ae039 = ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $679605082ab30589$export$a2ca519c668b2f72,
        pageId: `next-gen-reports-velocity-${(0, $1bf79051fed80f7f$export$557c2f222778cea6)({
            location: location,
            match: match
        })}`,
        shouldShowSpinner: false
    });


const $f730f07a676cc8e2$var$SoftwareNextgenRedirectComponent = ({ location: location })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
        to: (0, $5341544e238d5d38$export$8c47088cd9b527ba)(location)
    });
const $f730f07a676cc8e2$var$SoftwareTimelineLegacyRedirect = ({ query: query })=>{
    const { projectKey: projectKey, rapidView: rapidView, ...restQuery } = query;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
        to: {
            pathname: `/jira/software/projects/${projectKey}/boards/${rapidView}/timeline`,
            hash: '',
            search: (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(restQuery)
        }
    });
};
const $f730f07a676cc8e2$export$688b56fcbc2637ac = [
    (0, $9f5dd2b7ff8af740$export$2964ea1cdd5afa39),
    (0, $afa4ca373a35f9b7$export$a5f8ba02d2755510),
    (0, $716a6814b23ca11c$export$d3fcc412edfa2068),
    (0, $apqRF.createEntry)((0, $a9abc802715eecc6$export$5b818a6914ca8376), {
        ufoName: 'software-reports.burnup-chart',
        component: (0, $3e4a1cc841187c61$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $d87005bb78f4244b$export$f234446c23dc22a)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $3e4a1cc841187c61$export$2ae7ab3b633c1d15)
        ]
    }),
    (0, $apqRF.createEntry)((0, $a9abc802715eecc6$export$cde83a6497756848), {
        ufoName: 'software-reports.velocity-report',
        component: (0, $679605082ab30589$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $d87005bb78f4244b$export$f234446c23dc22a)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $679605082ab30589$export$a2ca519c668b2f72)
        ]
    }),
    (0, $apqRF.createEntry)((0, $a9abc802715eecc6$export$3c48ddd40d00b0d2), {
        ufoName: 'software-reports.cumulative-flow-diagram',
        component: (0, $4c67b3a1ed32bba6$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $d87005bb78f4244b$export$f234446c23dc22a)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $4c67b3a1ed32bba6$export$c588973e5bd18a8d)
        ]
    }),
    (0, $apqRF.createEntry)((0, $a9abc802715eecc6$export$e0d8c26cb1430ae4), {
        ufoName: 'software-reports.burndown-chart',
        component: (0, $60a4eae38aab8e0b$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $d87005bb78f4244b$export$f234446c23dc22a)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $60a4eae38aab8e0b$export$10cd1e761434952)
        ]
    }),
    (0, $apqRF.createEntry)((0, $a9abc802715eecc6$export$c777bb8f2591081), {
        component: (0, $2ijRB.default)((0, $yyqSx.isDevopsFeatureDisabledInFedRamp), (0, $dgH3j.default), (0, $5f6e3fe4d9f53d04$export$e16ce0656a74a015)),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $d87005bb78f4244b$export$f234446c23dc22a)(),
            (0, $gar3N.devOpsProviderResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $5f6e3fe4d9f53d04$export$956f830ed027f1fb)
        ],
        meta: {
            reporting: {
                id: (0, $exb0h.ROUTE_NAMES).SOFTWARE_REPORTS_CYCLE_TIME,
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))((0, $exb0h.ROUTE_NAMES).SOFTWARE_REPORTS_CYCLE_TIME),
                teamName: 'fusion-solaris'
            }
        }
    }),
    (0, $apqRF.createEntry)((0, $a9abc802715eecc6$export$bbf45ab0423b990), {
        component: (0, $2ijRB.default)((0, $yyqSx.isDevopsFeatureDisabledInFedRamp), (0, $dgH3j.default), (0, $8ab0e4f8eec61b65$export$e2db9c7426cdb53)),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $d87005bb78f4244b$export$f234446c23dc22a)(),
            (0, $gar3N.devOpsProviderResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $8ab0e4f8eec61b65$export$5113b2b19ec1fb53)
        ],
        meta: {
            reporting: {
                id: (0, $exb0h.ROUTE_NAMES).SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY,
                packageName: (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))((0, $exb0h.ROUTE_NAMES).SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY),
                teamName: 'fusion-solaris'
            }
        }
    }),
    (0, $apqRF.createEntry)((0, $a9abc802715eecc6$export$5bf75a5d8c554930), {
        component: (0, $fd39322616372e6e$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $d87005bb78f4244b$export$f234446c23dc22a)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $fd39322616372e6e$export$dbd12c5c20c26961)
        ],
        ufoName: 'software-reports.overview'
    }),
    (0, $apqRF.createEntry)((0, $a9abc802715eecc6$export$6072946fe7f2d45a), {
        component: $f730f07a676cc8e2$var$SoftwareNextgenRedirectComponent,
        layout: (0, $soOXK.softwareProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)()
        ],
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $9f5dd2b7ff8af740$export$bd9ede4ec384f41d)
        ]
    }),
    (0, $apqRF.createEntry)((0, $a9abc802715eecc6$export$9d24fc75b0f1d9a0), {
        component: (0, $2ijRB.default)((0, $yyqSx.isDevopsFeatureDisabledInFedRamp), (0, $dgH3j.default), (0, $5cd97f20ee6e4d57$export$d9e8184332f86b53)),
        layout: (0, $soOXK.softwareProjectLayoutCode),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            (0, $5GEOG.codePageResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $5cd97f20ee6e4d57$export$4beafd9dbad29bff)
        ],
        ufoName: 'next-gen-code'
    }),
    (0, $c13ea8e6d002db74$export$a8dcfae475505e7a),
    (0, $e7eb7b8d4a88bad8$export$7e5ccb20ad8e1612),
    (0, $aefe7ae0a443cf30$export$7db4d910357a4d89),
    (0, $02ebad1b1697b652$export$c97dabcfe9d495fa),
    (0, $02ebad1b1697b652$export$28d16aae32969765),
    (0, $02ebad1b1697b652$export$f29aafdff734071c),
    (0, $a14d5efc9298d717$export$fe880b76c2e8d7cf),
    (0, $a14d5efc9298d717$export$db399ba51c2e38a6),
    (0, $712bd1e16f3f7c0a$export$ace6a996c7e99f3),
    (0, $3e4b1429136330d9$export$c1d875e34d537389),
    (0, $bf82d83bb632614e$export$24fc07c22f0d06),
    (0, $bf82d83bb632614e$export$83b1b9036cc7961a),
    (0, $2df1207b13a402cc$export$1099e0e49394fa9a),
    (0, $2df1207b13a402cc$export$f30a66efa682bf2d),
    (0, $apqRF.createEntry)((0, $a9abc802715eecc6$export$866215abd09c0f4d), {
        component: $f730f07a676cc8e2$var$SoftwareTimelineLegacyRedirect,
        layout: (0, $soOXK.softwareProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)()
        ],
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $1ac1fc409b478241$export$1339c847cf4ab57)
        ]
    }),
    (0, $f7ee2b416e224377$export$fd29243dbe4103),
    (0, $490b95a631ece100$export$60cf591eccf54b03)
];



var $jh2R9 = parcelRequire("jh2R9");

var $cernH = parcelRequire("cernH");

var $exb0h = parcelRequire("exb0h");

var $9zysr = parcelRequire("9zysr");

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $iOOlt = parcelRequire("iOOlt");

var $2Fzrk = parcelRequire("2Fzrk");

var $apqRF = parcelRequire("apqRF");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $ixwgj = parcelRequire("ixwgj");

var $dgH3j = parcelRequire("dgH3j");

var $exb0h = parcelRequire("exb0h");
const $7e733baddd3da8de$export$830cd0c207772936 = {
    group: (0, $exb0h.ROUTE_GROUPS).COMPONENTS,
    name: `${(0, $exb0h.ROUTE_NAMES).OPSGENIE_SCHEDULE}-redirect`,
    path: '/projects/:projectKey',
    query: [
        'selectedItem=com.atlassian.jira.jira-projects-plugin:opsgenie-schedule-page'
    ]
};
const $7e733baddd3da8de$export$534a7ac096cb1da2 = {
    group: (0, $exb0h.ROUTE_GROUPS).COMPONENTS,
    name: (0, $exb0h.ROUTE_NAMES).OPSGENIE_SCHEDULE,
    path: '/jira/:projectType(software|software/c)/projects/:projectKey/on-call-schedule'
};



var $yyqSx = parcelRequire("yyqSx");

var $bEe6y = parcelRequire("bEe6y");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");
var $3HCkE = parcelRequire("3HCkE");

var $ixwgj = parcelRequire("ixwgj");

var $78d1w = parcelRequire("78d1w");
const $7fdd7a8ecac65120$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $kJlBc.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $jMP2a.fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, $bFzGY.useAnalyticsEvents), useResource: useResource = (0, $3HCkE.useResource), useRouter: useRouter = (0, $kJlBc.useRouter), useSpaStateTransition: useSpaStateTransition = (0, $78d1w.useSpaStateTransition) })=>{
    const [{ match: match, query: query, route: route }] = useRouter();
    const { data: data } = useResource((0, $ixwgj.projectContextResource));
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $eUqFw.useRef)(createAnalyticsEvent({}));
    (0, $eUqFw.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $7ZZxN.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $7ZZxN.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};



const $8a0093a20afc4089$export$3a9c3ff70731bdd6 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("63C48"))), {
    moduleId: "./src/packages/spa-apps/project/opsgenie-schedule/src/index.tsx"
});
const $8a0093a20afc4089$export$6ffd640c3062d976 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7fdd7a8ecac65120$export$8a3df560509448b8), {
        page: "/on-call-schedule"
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8a0093a20afc4089$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $8a0093a20afc4089$export$3a9c3ff70731bdd6,
        pageId: "opsgenie-schedule",
        shouldShowSpinner: true
    });


const $2dcde5e112eb5768$export$f128c1c4a1f0d631 = (0, $apqRF.createEntry)((0, $7e733baddd3da8de$export$830cd0c207772936), {
    component: !false ? (0, $8a0093a20afc4089$export$6ffd640c3062d976) : (0, $8a0093a20afc4089$export$2e2bcd8739ae039),
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $ixwgj.projectContextResource),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $8a0093a20afc4089$export$3a9c3ff70731bdd6)
    ],
    isRedirect: true
});
const $2dcde5e112eb5768$export$924db6cf10ba8696 = (0, $apqRF.createEntry)((0, $7e733baddd3da8de$export$534a7ac096cb1da2), {
    ufoName: 'project-opsgenie-schedule',
    component: (0, $9zysr.componentWithCondition)((0, $yyqSx.isDevopsFeatureDisabledInFedRamp), (0, $dgH3j.default), (0, $8a0093a20afc4089$export$2e2bcd8739ae039)),
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: [
            (0, $iOOlt.default),
            (0, $2Fzrk.default)
        ],
        horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
        horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $ixwgj.projectContextResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $8a0093a20afc4089$export$3a9c3ff70731bdd6)
    ],
    meta: {
        reporting: {
            id: (0, $exb0h.ROUTE_NAMES).OPSGENIE_SCHEDULE,
            packageName: (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))((0, $exb0h.ROUTE_NAMES).OPSGENIE_SCHEDULE),
            teamName: 'fusion-solaris'
        }
    }
});



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $cernH = parcelRequire("cernH");

var $79xbN = parcelRequire("79xbN");

var $dVvIP = parcelRequire("dVvIP");

var $7vTKl = parcelRequire("7vTKl");

var $jiReJ = parcelRequire("jiReJ");

var $apqRF = parcelRequire("apqRF");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $1TkEB = parcelRequire("1TkEB");

var $csLgO = parcelRequire("csLgO");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $621de40b0dd72f71$var$LazyPeopleProfiles = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("6KjXB"))), {
    // becasue `@atlassian/ptc-embeddable-directory` package is not ready for SSR
    ssr: false,
    moduleId: "./src/packages/spa-apps/people-profiles/src/index.tsx"
});
const $621de40b0dd72f71$export$9e44232fa48ba2ee = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $621de40b0dd72f71$var$LazyPeopleProfiles,
        pageId: "people-profiles",
        shouldShowSpinner: true
    });
const $621de40b0dd72f71$export$219b6cc00b2f91a0 = (0, $apqRF.createEntry)((0, $1TkEB.peopleProfilesRoute), {
    component: $621de40b0dd72f71$export$9e44232fa48ba2ee,
    layout: (0, $jiReJ.layoutWithCondition)(()=>(0, $79xbN.expValEquals)('jsm_getting_started_page_for_nple_exp', 'cohort', 'variation'), (0, $csLgO.rightSidebarsLayout), (0, $dVvIP.globalLayout)),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PEOPLE
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $621de40b0dd72f71$var$LazyPeopleProfiles
    ],
    ufoName: 'people-profiles'
});



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $dfBCt = parcelRequire("dfBCt");

var $cernH = parcelRequire("cernH");


var $jf8p7 = parcelRequire("jf8p7");

var $1ybV0 = parcelRequire("1ybV0");

var $bAQOb = parcelRequire("bAQOb");

var $dVvIP = parcelRequire("dVvIP");

var $7vTKl = parcelRequire("7vTKl");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $av9ef = parcelRequire("av9ef");

var $9RvDp = parcelRequire("9RvDp");

const $b629e75643c51b94$var$LazyPersonalSettingsSidebar = (0, $7rh0R.lazyAfterPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("l8FCk")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/personal-settings/src/index.tsx"
});
const $b629e75643c51b94$var$PersonalSettingsSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "personalSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b629e75643c51b94$var$LazyPersonalSettingsSidebar, null));
var $b629e75643c51b94$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($b629e75643c51b94$var$PersonalSettingsSidebar);



var $iJPUk = parcelRequire("iJPUk");

var $apqRF = parcelRequire("apqRF");

var $34eH5 = parcelRequire("34eH5");parcelRequire("l96PT");
var $3liNr = parcelRequire("3liNr");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $gF5SK = parcelRequire("gF5SK");

var $gyys9 = parcelRequire("gyys9");

var $jwzNs = parcelRequire("jwzNs");

var $7lcEz = parcelRequire("7lcEz");

var $atRHQ = parcelRequire("atRHQ");

var $kkmGZ = parcelRequire("kkmGZ");

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $3628ae735fbebea2$export$44d710abd316d1f1 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("lWrPO")), {
        moduleId: "fe0c927e"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            // Queries your async component uses
            queries: {
                pageAndProject: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $kkmGZ.default,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectIds: context.query?.projectIds ? context.query.projectIds.split(',') : []
                    }
                }
            },
            // Optional - Anything extra you wish to pass to your component
            // Something from `EntryPointParams` for example
            extraProps: {
                accountId: tenantContext.atlassianAccountId
            }
        })
});



var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $624e6e140f752e29$var$LazyLegacyPersonalSettings = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("i4uLB"))), {
    moduleId: "./src/packages/spa-apps/personal-settings-legacy/src/index.tsx"
});
const $624e6e140f752e29$var$personalSettingsNotificationsEntryPointPage = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $3628ae735fbebea2$export$44d710abd316d1f1),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).NOTIFICATIONS
});

const $624e6e140f752e29$var$LazyGeneralPersonalSettings = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("3TfM2"))), {
    moduleId: "./src/packages/spa-apps/personal-settings/general/src/index.tsx"
});

const $624e6e140f752e29$var$LazyOpsNotificationsPersonalSettings = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("cnKPy"))), {
    moduleId: "./src/packages/spa-apps/personal-settings/ops-notifications/src/index.tsx"
});
const $624e6e140f752e29$var$checkConsolidationOnRouteDependency = (dependencies)=>{
    const { data: data } = dependencies[0, $02315c431173f662$export$25ee35b01de9d734];
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $jf8p7.checkShouldUseJSM)(data);
};
const $624e6e140f752e29$export$31dadfd5bc64c9c9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $624e6e140f752e29$var$LazyLegacyPersonalSettings,
        pageId: "personal-settings",
        shouldShowSpinner: true
    });
const $624e6e140f752e29$export$81bedf006ef32751 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $624e6e140f752e29$var$LazyGeneralPersonalSettings,
        pageId: "personal-settings-general",
        shouldShowSpinner: true
    });
const $624e6e140f752e29$export$e30af76ba1def364 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $624e6e140f752e29$var$LazyOpsNotificationsPersonalSettings,
        pageId: "personal-settings-notifications",
        shouldShowSpinner: true
    });
const $624e6e140f752e29$var$getLabsResources = ()=>[
        (0, $gF5SK.newIssueViewTransitionLockInStatusResource),
        (0, $jwzNs.resourceWithCondition2)(()=>!(0, $dfBCt.isFedRamp)(), (0, $gyys9.nextBestTaskFeatureResource))
    ];
const $624e6e140f752e29$export$89646e32fa7698db = (0, $apqRF.createEntry)((0, $7lcEz.legacyPersonalSettingsRoute), {
    component: (0, $bAQOb.componentWithFF)('sea-1973-personal-settings-sidebar', ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
            to: (0, $iJPUk.GENERAL_PERSONAL_SETTINGS_PATH)
        }), $624e6e140f752e29$export$31dadfd5bc64c9c9),
    layout: (0, $dVvIP.globalLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROFILE
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $dAKwA.getConsolidationStateResource)(),
        (0, $34eH5.createContactsResource)($624e6e140f752e29$var$checkConsolidationOnRouteDependency, [
            (0, $02315c431173f662$export$25ee35b01de9d734)
        ]),
        (0, $34eH5.createNotificationPreferencesResource)($624e6e140f752e29$var$checkConsolidationOnRouteDependency, [
            (0, $02315c431173f662$export$25ee35b01de9d734)
        ]),
        (0, $3liNr.eocUserResource),
        (0, $34eH5.createMuteResource)($624e6e140f752e29$var$checkConsolidationOnRouteDependency, [
            (0, $02315c431173f662$export$25ee35b01de9d734)
        ]),
        (0, $34eH5.createQuietHoursResource)($624e6e140f752e29$var$checkConsolidationOnRouteDependency, [
            (0, $02315c431173f662$export$25ee35b01de9d734)
        ]),
        (0, $34eH5.createForwardingRulesResource)($624e6e140f752e29$var$checkConsolidationOnRouteDependency, [
            (0, $02315c431173f662$export$25ee35b01de9d734)
        ]),
        ...$624e6e140f752e29$var$getLabsResources()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $624e6e140f752e29$var$LazyLegacyPersonalSettings
    ]
});
const $624e6e140f752e29$export$e8b7e9281fc3db35 = (0, $apqRF.createEntry)((0, $7lcEz.generalPersonalSettingsRoute), {
    component: (0, $bAQOb.componentWithFF)('sea-1973-personal-settings-sidebar', $624e6e140f752e29$export$81bedf006ef32751, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
            to: (0, $iJPUk.LEGACY_PERSONAL_SETTINGS_PATH)
        })),
    layout: (0, $dVvIP.globalLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROFILE,
        sidebar: (0, $b629e75643c51b94$export$2e2bcd8739ae039)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $dAKwA.getConsolidationStateResource)(),
        ...$624e6e140f752e29$var$getLabsResources()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $624e6e140f752e29$var$LazyGeneralPersonalSettings
    ]
});
const $624e6e140f752e29$export$640c1b3b96c9032e = (0, $apqRF.createEntry)((0, $7lcEz.notificationsPersonalSettingsRoute), {
    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
            to: (0, $iJPUk.getNotificationsPersonalSettingsPath)()
        }),
    layout: (0, $dVvIP.globalLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROFILE,
        sidebar: (0, $b629e75643c51b94$export$2e2bcd8739ae039)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    pageId: 'personal-settings-notifications',
    entryPoint () {
        return (0, $1ybV0.ff)('sea-1973-notifications-hub') ? $624e6e140f752e29$var$personalSettingsNotificationsEntryPointPage : undefined;
    }
});
const $624e6e140f752e29$export$d604d3ad2662a845 = [
    $624e6e140f752e29$export$89646e32fa7698db,
    $624e6e140f752e29$export$e8b7e9281fc3db35,
    $624e6e140f752e29$export$640c1b3b96c9032e,
    (0, $apqRF.createEntry)((0, $7lcEz.opsNotificationsPersonalSettingsRoute), {
        component: (0, $bAQOb.componentWithFF)('sea-1973-personal-settings-sidebar', $624e6e140f752e29$export$e30af76ba1def364, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
                to: (0, $iJPUk.LEGACY_PERSONAL_SETTINGS_PATH)
            })),
        layout: (0, $dVvIP.globalLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROFILE,
            sidebar: (0, $b629e75643c51b94$export$2e2bcd8739ae039)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $dAKwA.getConsolidationStateResource)(),
            (0, $34eH5.createContactsResource)(),
            (0, $34eH5.createNotificationPreferencesResource)(),
            (0, $3liNr.eocUserResource),
            (0, $34eH5.createMuteResource)(),
            (0, $34eH5.createQuietHoursResource)(),
            (0, $34eH5.createForwardingRulesResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            $624e6e140f752e29$var$LazyOpsNotificationsPersonalSettings
        ]
    })
];



var $cernH = parcelRequire("cernH");

var $1ybV0 = parcelRequire("1ybV0");

var $dVvIP = parcelRequire("dVvIP");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $8QAGR = parcelRequire("8QAGR");

var $isbb2 = parcelRequire("isbb2");
const $0d7e476d9154aa28$export$d5273c1a2e2fe212 = (0, $isbb2.composeLayouts)((0, $8QAGR.projectLayout));



var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $2JncP = parcelRequire("2JncP");

var $exb0h = parcelRequire("exb0h");
const $74541ef9f6eca715$export$54c333cd4ed2d70e = {
    group: (0, $exb0h.ROUTE_GROUPS).POLARIS,
    name: (0, $exb0h.ROUTE_NAMES).POLARIS_IDEAS,
    path: '/jira/polaris/projects/:projectKey/ideas/:section?/:resource?',
    exact: true
};
const $74541ef9f6eca715$export$d415b74f78a5f159 = {
    group: (0, $exb0h.ROUTE_GROUPS).POLARIS,
    name: (0, $exb0h.ROUTE_NAMES).POLARIS_COLLECTIONS,
    path: '/jira/polaris/collections/:collectionId?/:section?/:resource?',
    exact: true
};
const $74541ef9f6eca715$export$6696e9deb45fe980 = {
    group: (0, $exb0h.ROUTE_GROUPS).POLARIS,
    name: (0, $exb0h.ROUTE_NAMES).POLARIS_ONBOARDING,
    path: '/welcome/discovery',
    exact: true
};
const $74541ef9f6eca715$export$bfdcdf76e802d67d = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).POLARIS_SETTINGS_ACCESS,
    path: '/jira/settings/products/jira-product-discovery/access',
    exact: true
};
const $74541ef9f6eca715$export$d1d77b6a84982ab8 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).POLARIS_SETTINGS_GLOBAL_FIELDS,
    path: '/jira/settings/products/jira-product-discovery/global-fields',
    exact: true
};
const $74541ef9f6eca715$export$32b1bc71501d2751 = {
    group: (0, $exb0h.ROUTE_GROUPS).POLARIS,
    name: (0, $exb0h.ROUTE_NAMES).POLARIS_UNLICENSED,
    path: '/jira/polaris/unlicensed',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $fTgIJ = parcelRequire("fTgIJ");

var $kJlBc = parcelRequire("kJlBc");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

var $gd0Sp = parcelRequire("gd0Sp");

const $b934a3aee34dfece$export$f7960e7dbd7e5265 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("llB5o"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/polaris/collections/src/index.tsx"
});
const $b934a3aee34dfece$var$useJpdLicensed = ()=>{
    const context = (0, $gd0Sp.useTenantContext)();
    return context.licensedProducts['jira-product-discovery'];
};
const $b934a3aee34dfece$export$3bba33442c4150b1 = ()=>{
    const jpdLicensed = $b934a3aee34dfece$var$useJpdLicensed();
    const crossProjectViewsEnabled = (0, $fTgIJ.useIsCrossProjectViewsEnabled)();
    if (!jpdLicensed) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
        to: "/jira/polaris/unlicensed"
    });
    if (!crossProjectViewsEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
        to: "/jira"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $b934a3aee34dfece$export$f7960e7dbd7e5265,
        pageId: "async-polaris-collections",
        shouldShowSpinner: false
    });
};
var $b934a3aee34dfece$export$2e2bcd8739ae039 = $b934a3aee34dfece$export$3bba33442c4150b1;



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $kJlBc = parcelRequire("kJlBc");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

var $gd0Sp = parcelRequire("gd0Sp");

const $02e9517a92a29b91$export$3fd7cf4494189548 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("jRQMT"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/polaris/ideas/src/index.tsx"
});
const $02e9517a92a29b91$var$useJpdLicensed = ()=>{
    const context = (0, $gd0Sp.useTenantContext)();
    return context.licensedProducts['jira-product-discovery'];
};
const $02e9517a92a29b91$export$8e495e768b5bbae5 = ()=>{
    const jpdLicensed = $02e9517a92a29b91$var$useJpdLicensed();
    if (!jpdLicensed) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
        to: "/jira/polaris/unlicensed"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $02e9517a92a29b91$export$3fd7cf4494189548,
        pageId: "async-polaris-ideas",
        shouldShowSpinner: false
    });
};
var $02e9517a92a29b91$export$2e2bcd8739ae039 = $02e9517a92a29b91$export$8e495e768b5bbae5;



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $eb26f02dfaf5ae08$export$13889cc3ce0d5a93 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("5m8gr"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/polaris/onboarding/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$eb26f02dfaf5ae08$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $eb26f02dfaf5ae08$export$13889cc3ce0d5a93,
        pageId: "async-polaris-onboarding",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $1491cb3188cdfe45$export$b66ea0dcd38af7f0 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("bVTNW"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/polaris/settings-access/src/index.tsx"
});
const $1491cb3188cdfe45$export$d46497fe68b0853c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $1491cb3188cdfe45$export$b66ea0dcd38af7f0,
        pageId: "async-polaris-settings-access",
        shouldShowSpinner: false
    });



var $7vTKl = parcelRequire("7vTKl");

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $cdb873a799c32a16$export$f2f24531058bc251 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("bDEox")), {
        moduleId: "fead11bc"
    }),
    getPreloadProps: ()=>({})
});


const $13542dcb8c0b0569$export$c682ebcd2290352f = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $cdb873a799c32a16$export$f2f24531058bc251),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).SETTINGS
});



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $15fc721dd8245473$export$394984ca86b38b8f = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("5383Q"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/polaris/unlicensed/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$15fc721dd8245473$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $15fc721dd8245473$export$394984ca86b38b8f,
        pageId: "async-polaris-unlicensed",
        shouldShowSpinner: false
    });


const $8605a99074da660f$var$commonResources = [
    (0, $2JncP.projectCreatePermissionsResource)
];
const $8605a99074da660f$var$getPolarisProjectPermissionsResource = ()=>[
        ...$8605a99074da660f$var$commonResources
    ];
const $8605a99074da660f$export$44e0cb320cb148ed = [
    (0, $apqRF.createEntry)((0, $74541ef9f6eca715$export$54c333cd4ed2d70e), {
        ufoName: 'jpd.project',
        component: (0, $02e9517a92a29b91$export$2e2bcd8739ae039),
        layout: (0, $0d7e476d9154aa28$export$d5273c1a2e2fe212),
        canTransitionIn: (current, next)=>{
            if ((0, $1ybV0.ff)('polaris.sidebar-v4') && current?.match?.params?.projectKey && next?.match?.params?.projectKey && current.match.params.projectKey !== next.match.params.projectKey) return false;
            return true;
        },
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $02e9517a92a29b91$export$3fd7cf4494189548)
        ]
    }),
    (0, $apqRF.createEntry)((0, $74541ef9f6eca715$export$d415b74f78a5f159), {
        ufoName: 'jpd.collections',
        component: (0, $b934a3aee34dfece$export$2e2bcd8739ae039),
        layout: (0, $dVvIP.globalLayout),
        canTransitionIn: ()=>true,
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $b934a3aee34dfece$export$f7960e7dbd7e5265)
        ]
    }),
    (0, $apqRF.createEntry)((0, $74541ef9f6eca715$export$6696e9deb45fe980), {
        component: (0, $eb26f02dfaf5ae08$export$2e2bcd8739ae039),
        layout: (0, $dVvIP.globalLayout),
        canTransitionIn: ()=>true,
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...$8605a99074da660f$var$getPolarisProjectPermissionsResource()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $eb26f02dfaf5ae08$export$13889cc3ce0d5a93)
        ]
    }),
    (0, $apqRF.createEntry)((0, $74541ef9f6eca715$export$bfdcdf76e802d67d), {
        component: (0, $1491cb3188cdfe45$export$d46497fe68b0853c),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $7okz2.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $1491cb3188cdfe45$export$b66ea0dcd38af7f0)
        ]
    }),
    (0, $apqRF.createEntry)((0, $74541ef9f6eca715$export$d1d77b6a84982ab8), {
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $7okz2.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)()
        ],
        entryPoint () {
            return 0, $13542dcb8c0b0569$export$c682ebcd2290352f;
        }
    }),
    (0, $apqRF.createEntry)((0, $74541ef9f6eca715$export$32b1bc71501d2751), {
        component: (0, $15fc721dd8245473$export$2e2bcd8739ae039),
        layout: (0, $dVvIP.globalLayout),
        canTransitionIn: ()=>true,
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...$8605a99074da660f$var$getPolarisProjectPermissionsResource()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $15fc721dd8245473$export$394984ca86b38b8f)
        ]
    })
];



var $dfBCt = parcelRequire("dfBCt");

var $cernH = parcelRequire("cernH");

var $9zysr = parcelRequire("9zysr");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $dgH3j = parcelRequire("dgH3j");

var $exb0h = parcelRequire("exb0h");
const $04cb986a314f8d60$export$7c663ddc097df1e8 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).PRODUCTS_JSM_CHATOPS_AND_VIDEOS_TOOLS,
    path: '/jira/settings/products/ops/jira-service-management-chatops-and-video-tools',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $6dfb390f0b3cf43c$export$1b7f55251df02fe9 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("eYPZR"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-chatops-and-video-tools/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6dfb390f0b3cf43c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $6dfb390f0b3cf43c$export$1b7f55251df02fe9,
        pageId: "products-jsm-chatops-and-video-tools",
        shouldShowSpinner: false
    });


const $c0323c6c8a564bae$export$8b55e723205ec5f3 = (0, $apqRF.createEntry)((0, $04cb986a314f8d60$export$7c663ddc097df1e8), {
    component: (0, $9zysr.componentWithCondition)((0, $dfBCt.isFedRamp), (0, $dgH3j.default), (0, $6dfb390f0b3cf43c$export$2e2bcd8739ae039)),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $6dfb390f0b3cf43c$export$1b7f55251df02fe9)
    ]
});



var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $70db59821f14819f$export$6196bf08f64419da = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).PRODUCTS_JSM_COMPLIANCE,
    path: '/jira/settings/products/jira-service-management-compliance',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $538dcf8f8fb3317d$export$159d8c0e1862cd2b = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("8gTmZ"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-compliance/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$538dcf8f8fb3317d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $538dcf8f8fb3317d$export$159d8c0e1862cd2b,
        pageId: "products-jsm-compliance",
        shouldShowSpinner: false
    });


const $5c45641d0f476bbd$export$9cc9423a3967333b = (0, $apqRF.createEntry)((0, $70db59821f14819f$export$6196bf08f64419da), {
    component: (0, $538dcf8f8fb3317d$export$2e2bcd8739ae039),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $538dcf8f8fb3317d$export$159d8c0e1862cd2b)
    ],
    ufoName: 'admin.jsm-compliance'
});



var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $27df22921068d77e$export$2ad48fbde4743a97 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).PRODUCTS_JSM_CONFIGURATION,
    path: '/jira/settings/products/jira-service-management-configuration',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $db26d475d8796f34$export$aa3f3d5ca376f305 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("afOc7"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-configuration/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$db26d475d8796f34$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $db26d475d8796f34$export$aa3f3d5ca376f305,
        pageId: "products-jsm-configuration",
        shouldShowSpinner: false
    });


const $858ab70ef0ef29ff$export$461f2b06a7a914db = (0, $apqRF.createEntry)((0, $27df22921068d77e$export$2ad48fbde4743a97), {
    ufoName: 'admin.jsm-configuration',
    component: (0, $db26d475d8796f34$export$2e2bcd8739ae039),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $db26d475d8796f34$export$aa3f3d5ca376f305)
    ]
});



var $cernH = parcelRequire("cernH");

var $bAQOb = parcelRequire("bAQOb");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $585a2ff10242e3e9$export$6288bb6ea42acf0c = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).PRODUCTS_JSM_EMAIL_REQUESTS,
    path: '/jira/settings/products/jira-service-management-email-requests',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var /** This exists to be used as a route since the redirect as a route and redirect as a component
 * have different props, and flow complains. */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$3c8a79d14172157f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9f087e464fef57a9$export$2e2bcd8739ae039), null);



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $3ece24aab4506b3d$export$4c9d90d0caf04d67 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("4kviK"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/product-jsm-email-requests/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3ece24aab4506b3d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $3ece24aab4506b3d$export$4c9d90d0caf04d67,
        pageId: "products-jsm-email-requests",
        shouldShowSpinner: false
    });


const $ef3b2e76e978001d$export$3f8d7424a47f4dd = (0, $apqRF.createEntry)((0, $585a2ff10242e3e9$export$6288bb6ea42acf0c), {
    ufoName: 'admin.jsm-email-requests',
    component: (0, $bAQOb.componentWithFF)('migrate-jsm-email-requests-settings-page_xbqbk', (0, $3ece24aab4506b3d$export$2e2bcd8739ae039), (0, $3c8a79d14172157f$export$2e2bcd8739ae039)),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $3ece24aab4506b3d$export$4c9d90d0caf04d67)
    ]
});



var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $8aef35f9ad78b811$export$f98dec539fffaa15 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).PRODUCTS_JSM_FEATURE_USAGE,
    path: '/jira/settings/products/servicedesk/feature-usage',
    exact: true
};



var $cV47S = parcelRequire("cV47S");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $e9a8e42a27174b2e$export$5ad1c1e822bd5d34 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("3JCWT"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-feature-usage/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e9a8e42a27174b2e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e9a8e42a27174b2e$export$5ad1c1e822bd5d34,
        pageId: "products-jsm-feature-usage",
        shouldShowSpinner: false
    });


const $d9a72e5e6bfe851d$export$80a3e4dda2dcd1a4 = (0, $apqRF.createEntry)((0, $8aef35f9ad78b811$export$f98dec539fffaa15), {
    component: (0, $e9a8e42a27174b2e$export$2e2bcd8739ae039),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        (0, $cV47S.workspaceResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $e9a8e42a27174b2e$export$5ad1c1e822bd5d34)
    ]
});



var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $apqRF = parcelRequire("apqRF");

var $ieLL2 = parcelRequire("ieLL2");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $d35b0cd5d9c27edc$export$d92d66762943b115 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).PRODUCTS_JSM_GLOBAL_OPS_REPORTS,
    path: '/jira/settings/products/ops/reports/:dashboardId',
    exact: true
};
const $d35b0cd5d9c27edc$export$6b3539e7e6bf13e8 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).PRODUCTS_JSM_GLOBAL_OPS_REPORTS,
    path: '/jira/settings/products/ops/reports',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $7475ccb852e24c87$export$2404f0e35deca592 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("9c8ch")), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $7475ccb852e24c87$export$d33ea1a773b744e = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("9c8ch")).then((exportedMembers)=>exportedMembers.OpsReportsRedirect), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});

const $7475ccb852e24c87$export$66850ec5549adba6 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("9c8ch")).then((exportedMembers)=>exportedMembers.GlobalOpsReports), {
    moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
});
const $7475ccb852e24c87$export$22253dbadb46d0cf = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7475ccb852e24c87$export$d33ea1a773b744e,
        pageId: "async-jira-eoc-ops-reports-redirect",
        shouldShowSpinner: false
    });
const $7475ccb852e24c87$export$648ddf2d1f8b1c3f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7475ccb852e24c87$export$66850ec5549adba6,
        pageId: "async-jira-eoc-global-ops-reports",
        shouldShowSpinner: false
    });
const $7475ccb852e24c87$export$87e6a54b4f5dc91e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7475ccb852e24c87$export$2404f0e35deca592,
        pageId: "async-jira-eoc-ops-reports",
        shouldShowSpinner: false
    });


const $1052eb222a330200$export$6a7fc41fb2523290 = (0, $apqRF.createEntry)((0, $d35b0cd5d9c27edc$export$d92d66762943b115), {
    component: (0, $7475ccb852e24c87$export$648ddf2d1f8b1c3f),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        ...(0, $ieLL2.resources),
        (0, $ieLL2.opsReportsPermissionResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $7475ccb852e24c87$export$d33ea1a773b744e)
    ]
});
const $1052eb222a330200$export$6d6efd297963f785 = (0, $apqRF.createEntry)((0, $d35b0cd5d9c27edc$export$6b3539e7e6bf13e8), {
    component: (0, $7475ccb852e24c87$export$22253dbadb46d0cf),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        ...(0, $ieLL2.resources),
        (0, $ieLL2.opsReportsPermissionResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $7475ccb852e24c87$export$66850ec5549adba6)
    ]
});



var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $05eaec877d080121$export$da6d538ddabade32 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).PRODUCTS_JSM_INCIDENT_MANAGEMENT_TOOLS,
    path: '/jira/settings/products/jira-service-management-incident-management-tools',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $17cfae62994fe651$export$f541eb9b8f00bfaf = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("5wVLE"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-incident-management-tools/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$17cfae62994fe651$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $17cfae62994fe651$export$f541eb9b8f00bfaf,
        pageId: "products-jsm-incident-management-tools",
        shouldShowSpinner: false
    });


const $20efdafd05df2f3a$export$773f8e3318be1dd5 = (0, $apqRF.createEntry)((0, $05eaec877d080121$export$da6d538ddabade32), {
    component: (0, $17cfae62994fe651$export$2e2bcd8739ae039),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $17cfae62994fe651$export$f541eb9b8f00bfaf)
    ]
});



var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $bb7dfdd2f8577352$export$339486410c7a783f = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).PRODUCTS_JSM_KB_PERMISSIONS,
    path: '/jira/settings/products/jira-service-management-knowledge-base-permissions',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $d37cbf2e11433c0e$export$a3e7bdc5dbf2d47e = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("3pkSn"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/product-jsm-kb-permissions/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d37cbf2e11433c0e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $d37cbf2e11433c0e$export$a3e7bdc5dbf2d47e,
        pageId: "products-jsm-kb-permissions",
        shouldShowSpinner: false
    });


const $706ea00b80585533$export$717e134eb971b450 = (0, $apqRF.createEntry)((0, $bb7dfdd2f8577352$export$339486410c7a783f), {
    component: (0, $d37cbf2e11433c0e$export$2e2bcd8739ae039),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $d37cbf2e11433c0e$export$a3e7bdc5dbf2d47e)
    ]
});



var $cernH = parcelRequire("cernH");

var $bAQOb = parcelRequire("bAQOb");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $apqRF = parcelRequire("apqRF");

var $b1sy2 = parcelRequire("b1sy2");

var $bU9Sz = parcelRequire("bU9Sz");

var $6Oo0P = parcelRequire("6Oo0P");

var $kCBYY = parcelRequire("kCBYY");

var $hHrVM = parcelRequire("hHrVM");

var $dgH3j = parcelRequire("dgH3j");

var $exb0h = parcelRequire("exb0h");
const $b5130b545f640c4b$export$512fa30726e0049d = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).PRODUCTS_JSM_ORGANIZATIONS,
    path: '/jira/settings/products/servicedesk/organizations',
    exact: true
};
const $b5130b545f640c4b$export$3ae664dd3f8b73dc = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).PRODUCTS_JSM_ORGANIZATIONS,
    path: '/jira/settings/products/servicedesk/organizations/:organizationId',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $7e6711a4573576b1$export$ff149ceefa65ab70 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("kCEdS"))), {
    moduleId: "./src/packages/admin-pages/products-jsm-organization-details/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7e6711a4573576b1$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7e6711a4573576b1$export$ff149ceefa65ab70,
        pageId: "products-jsm-organization-details",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $3264d0db5bce9a61$export$410bec6e06fd4723 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("1vtAI"))), {
    moduleId: "./src/packages/admin-pages/products-jsm-organizations-list/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3264d0db5bce9a61$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $3264d0db5bce9a61$export$410bec6e06fd4723,
        pageId: "products-jsm-organizations-list",
        shouldShowSpinner: true
    });


const $7b162697914d48c2$export$34d843946d3894aa = (0, $apqRF.createEntry)((0, $b5130b545f640c4b$export$512fa30726e0049d), {
    ufoName: 'admin.jsm-organization-page-list',
    isRedirect: false,
    component: (0, $3264d0db5bce9a61$export$2e2bcd8739ae039),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        (0, $kCBYY.productsJsmOrganizationListResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $3264d0db5bce9a61$export$410bec6e06fd4723)
    ]
});
const $7b162697914d48c2$export$6d18fd46547afb8e = (0, $apqRF.createEntry)((0, $b5130b545f640c4b$export$3ae664dd3f8b73dc), {
    ufoName: 'admin.jsm-organization-page-list',
    isRedirect: false,
    component: (0, $bAQOb.componentWithFF)('organisation-domains-organisation-detail-page_j5f14', (0, $7e6711a4573576b1$export$2e2bcd8739ae039), (0, $dgH3j.default)),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        (0, $bU9Sz.productsJsmOrganizationDetailsResource),
        (0, $6Oo0P.productsJsmOrganizationMembersResource),
        (0, $kCBYY.productsJsmOrganizationListResource),
        (0, $b1sy2.jsmEmailDomainsListResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $7e6711a4573576b1$export$ff149ceefa65ab70)
    ]
});



var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $8vc2n = parcelRequire("8vc2n");

var $esxKW = parcelRequire("esxKW");

var $i51fR = parcelRequire("i51fR");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $49352938dbf7be05$export$f9a32397033f9ced = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("cIyxN"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsw-configuration/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$49352938dbf7be05$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $49352938dbf7be05$export$f9a32397033f9ced,
        pageId: "products-jsw-configuration",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $c4b843d79941daa9$export$a4f5e12ce817cbb8 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("60khL"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/products-jsw-storage-management/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c4b843d79941daa9$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $c4b843d79941daa9$export$a4f5e12ce817cbb8,
        pageId: "products-jsw-storage-management",
        shouldShowSpinner: true
    });


const $4497ae40fde48600$export$2f65b1ec4ed05f91 = (0, $apqRF.createEntry)((0, $i51fR.productsJswConfigurationRoute), {
    ufoName: 'admin.jsw-configuration',
    component: (0, $49352938dbf7be05$export$2e2bcd8739ae039),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        (0, $8vc2n.productsJswConfigurationResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $49352938dbf7be05$export$f9a32397033f9ced)
    ]
});
const $4497ae40fde48600$export$c62ca2d3fcc552a5 = (0, $apqRF.createEntry)((0, $i51fR.productsJswConfigurationStorageManagementRoute), {
    ufoName: 'admin.jsw-configuration.storage-management',
    component: (0, $c4b843d79941daa9$export$2e2bcd8739ae039),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7okz2.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
        (0, $esxKW.productsJswStorageManagementResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $c4b843d79941daa9$export$a4f5e12ce817cbb8)
    ]
});



var $cernH = parcelRequire("cernH");


var $iZnNg = parcelRequire("iZnNg");

var $dVvIP = parcelRequire("dVvIP");

var $7vTKl = parcelRequire("7vTKl");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $ixwgj = parcelRequire("ixwgj");

var $exb0h = parcelRequire("exb0h");
const $7ccbe961b49f6771$var$CORE_PRODUCT = 'core';
const $7ccbe961b49f6771$var$SOFTWARE_PRODUCT = 'software';
const $7ccbe961b49f6771$var$SERVICE_DESK_PRODUCT = 'servicedesk';
const $7ccbe961b49f6771$var$jiraIssueFormCreateEndpoint = 'projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?'; // the 1 query param is "requestTypeId"
const $7ccbe961b49f6771$var$EXPORT_URL = '/jira/forms/export';
const $7ccbe961b49f6771$var$ISSUE_FORMS_GENERAL_URL = '/jira/forms/create';
const $7ccbe961b49f6771$export$158441d4f5c68fb9 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROFORMA,
    name: `${(0, $exb0h.ROUTE_GROUPS).SERVICEDESK}-${(0, $exb0h.ROUTE_NAMES).PROFORMA_EXPORT}`,
    path: $7ccbe961b49f6771$var$EXPORT_URL,
    exact: true
};
const $7ccbe961b49f6771$export$416ac492f873673a = {
    group: (0, $exb0h.ROUTE_GROUPS).PROFORMA,
    name: `${(0, $exb0h.ROUTE_GROUPS).SERVICEDESK}-${(0, $exb0h.ROUTE_NAMES).PROFORMA_ISSUE_FORMS_GENERAL}`,
    path: $7ccbe961b49f6771$var$ISSUE_FORMS_GENERAL_URL,
    exact: true
};
const $7ccbe961b49f6771$export$574435c4e2f6a27e = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).SERVICEDESK}-${(0, $exb0h.ROUTE_NAMES).PROFORMA_ISSUE_FORMS_DIRECT}`,
    path: `/jira/${$7ccbe961b49f6771$var$SERVICE_DESK_PRODUCT}/${$7ccbe961b49f6771$var$jiraIssueFormCreateEndpoint}`,
    exact: true
};
const $7ccbe961b49f6771$export$d48be9e2caaca83d = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).SERVICEDESK}-${(0, $exb0h.ROUTE_NAMES).PROFORMA_ISSUE_FORMS_DIRECT_EMBED}`,
    path: `/jira/${$7ccbe961b49f6771$var$SERVICE_DESK_PRODUCT}/${$7ccbe961b49f6771$var$jiraIssueFormCreateEndpoint}/embed`,
    exact: true
};
const $7ccbe961b49f6771$export$fb73a18f932b2c15 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROFORMA,
    name: `${(0, $exb0h.ROUTE_GROUPS).CLASSIC_BUSINESS}-${(0, $exb0h.ROUTE_NAMES).PROFORMA_EXPORT}`,
    path: $7ccbe961b49f6771$var$EXPORT_URL,
    exact: true
};
const $7ccbe961b49f6771$export$ec7e58425379b5d0 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROFORMA,
    name: `${(0, $exb0h.ROUTE_GROUPS).CLASSIC_BUSINESS}-${(0, $exb0h.ROUTE_NAMES).PROFORMA_ISSUE_FORMS_GENERAL}`,
    path: $7ccbe961b49f6771$var$ISSUE_FORMS_GENERAL_URL,
    exact: true
};
const $7ccbe961b49f6771$export$76ab9f3014b2e370 = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_BUSINESS,
    name: `${(0, $exb0h.ROUTE_GROUPS).CLASSIC_BUSINESS}-${(0, $exb0h.ROUTE_NAMES).PROFORMA_ISSUE_FORMS_DIRECT}`,
    path: `/jira/${$7ccbe961b49f6771$var$CORE_PRODUCT}/${$7ccbe961b49f6771$var$jiraIssueFormCreateEndpoint}`,
    exact: true
};
const $7ccbe961b49f6771$export$55ce393dc053bec4 = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_BUSINESS,
    name: `${(0, $exb0h.ROUTE_GROUPS).CLASSIC_BUSINESS}-${(0, $exb0h.ROUTE_NAMES).PROFORMA_ISSUE_FORMS_DIRECT_EMBED}`,
    path: `/jira/${$7ccbe961b49f6771$var$CORE_PRODUCT}/${$7ccbe961b49f6771$var$jiraIssueFormCreateEndpoint}/embed`,
    exact: true
};
const $7ccbe961b49f6771$export$4c5d46fe4c460ef9 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROFORMA,
    name: `${(0, $exb0h.ROUTE_GROUPS).SOFTWARE}-${(0, $exb0h.ROUTE_NAMES).PROFORMA_EXPORT}`,
    path: $7ccbe961b49f6771$var$EXPORT_URL,
    exact: true
};
const $7ccbe961b49f6771$export$7de22a6665b73706 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROFORMA,
    name: `${(0, $exb0h.ROUTE_GROUPS).SOFTWARE}-${(0, $exb0h.ROUTE_NAMES).PROFORMA_ISSUE_FORMS_GENERAL}`,
    path: $7ccbe961b49f6771$var$ISSUE_FORMS_GENERAL_URL,
    exact: true
};
const $7ccbe961b49f6771$export$c02a5b8ecf73713e = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: `${(0, $exb0h.ROUTE_GROUPS).SOFTWARE}-${(0, $exb0h.ROUTE_NAMES).PROFORMA_ISSUE_FORMS_DIRECT}`,
    path: `/jira/${$7ccbe961b49f6771$var$SOFTWARE_PRODUCT}/${$7ccbe961b49f6771$var$jiraIssueFormCreateEndpoint}`,
    exact: true
};
const $7ccbe961b49f6771$export$cd0e54104fd6e37c = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: `${(0, $exb0h.ROUTE_GROUPS).SOFTWARE}-${(0, $exb0h.ROUTE_NAMES).PROFORMA_ISSUE_FORMS_DIRECT_EMBED}`,
    path: `/jira/${$7ccbe961b49f6771$var$SOFTWARE_PRODUCT}/${$7ccbe961b49f6771$var$jiraIssueFormCreateEndpoint}/embed`,
    exact: true
};



var $csLgO = parcelRequire("csLgO");

var $soOXK = parcelRequire("soOXK");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $7715e223327779be$export$5e0d802a5d865352 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("efT8A")), {
    moduleId: "./src/packages/spa-apps/proforma-export/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7715e223327779be$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7715e223327779be$export$5e0d802a5d865352,
        pageId: "proforma-export",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $5f94abb64b62ae5b$export$a0f04dd35569e11 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("uFfwG")), {
    moduleId: "./src/packages/spa-apps/proforma-issue-forms-direct/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5f94abb64b62ae5b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $5f94abb64b62ae5b$export$a0f04dd35569e11,
        pageId: "proforma-issue-forms-direct",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $89fa0a59411ddd45$export$22681210aaeb910f = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("dFSQC")), {
    moduleId: "./src/packages/spa-apps/proforma-issue-forms-direct-embed/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$89fa0a59411ddd45$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $89fa0a59411ddd45$export$22681210aaeb910f,
        pageId: "proforma-issue-forms-direct-embed",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $357e75320b6357c0$export$7c16b09eb95f1c5d = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("f0k5n")), {
    moduleId: "./src/packages/spa-apps/proforma-issue-forms-general/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$357e75320b6357c0$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $357e75320b6357c0$export$7c16b09eb95f1c5d,
        pageId: "proforma-issue-forms-general",
        shouldShowSpinner: true
    });


const $2719ac30f4e07b26$export$786e5a0c86be676a = [
    (0, $apqRF.createEntry)((0, $7ccbe961b49f6771$export$158441d4f5c68fb9), {
        layout: (0, $dVvIP.globalLayout),
        resources: [
            ...(0, $hHrVM.getNavigationResources)()
        ],
        component: (0, $7715e223327779be$export$2e2bcd8739ae039),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7715e223327779be$export$5e0d802a5d865352)
        ]
    }),
    (0, $apqRF.createEntry)((0, $7ccbe961b49f6771$export$416ac492f873673a), {
        layout: (0, $dVvIP.globalLayout),
        resources: [
            ...(0, $hHrVM.getNavigationResources)()
        ],
        component: (0, $357e75320b6357c0$export$2e2bcd8739ae039),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $357e75320b6357c0$export$7c16b09eb95f1c5d)
        ],
        perfMetricKey: 'issue-forms-general'
    }),
    (0, $apqRF.createEntry)((0, $7ccbe961b49f6771$export$574435c4e2f6a27e), {
        layout: (0, $csLgO.serviceProjectLayout),
        resources: [
            (0, $ixwgj.projectContextResource)
        ],
        component: (0, $5f94abb64b62ae5b$export$2e2bcd8739ae039),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS
        },
        forPaint: [
            (0, $5f94abb64b62ae5b$export$a0f04dd35569e11)
        ],
        perfMetricKey: 'issue-forms-direct'
    }),
    (0, $apqRF.createEntry)((0, $7ccbe961b49f6771$export$d48be9e2caaca83d), {
        layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
        resources: [
            (0, $ixwgj.projectContextResource)
        ],
        component: (0, $89fa0a59411ddd45$export$2e2bcd8739ae039),
        forPaint: [
            (0, $89fa0a59411ddd45$export$22681210aaeb910f)
        ],
        perfMetricKey: 'issue-forms-direct-embed'
    })
];
const $2719ac30f4e07b26$export$c4313dd46c85e3d3 = [
    (0, $apqRF.createEntry)((0, $7ccbe961b49f6771$export$fb73a18f932b2c15), {
        layout: (0, $dVvIP.globalLayout),
        resources: [
            ...(0, $hHrVM.getNavigationResources)()
        ],
        component: (0, $7715e223327779be$export$2e2bcd8739ae039),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7715e223327779be$export$5e0d802a5d865352)
        ]
    }),
    (0, $apqRF.createEntry)((0, $7ccbe961b49f6771$export$ec7e58425379b5d0), {
        layout: (0, $dVvIP.globalLayout),
        resources: [
            ...(0, $hHrVM.getNavigationResources)()
        ],
        component: (0, $357e75320b6357c0$export$2e2bcd8739ae039),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $357e75320b6357c0$export$7c16b09eb95f1c5d)
        ],
        perfMetricKey: 'issue-forms-general'
    }),
    (0, $apqRF.createEntry)((0, $7ccbe961b49f6771$export$76ab9f3014b2e370), {
        layout: (0, $iZnNg.coreProjectLayout),
        resources: [
            (0, $ixwgj.projectContextResource)
        ],
        component: (0, $5f94abb64b62ae5b$export$2e2bcd8739ae039),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS
        },
        forPaint: [
            (0, $5f94abb64b62ae5b$export$a0f04dd35569e11)
        ],
        perfMetricKey: 'issue-forms-direct'
    }),
    (0, $apqRF.createEntry)((0, $7ccbe961b49f6771$export$55ce393dc053bec4), {
        layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
        resources: [
            (0, $ixwgj.projectContextResource)
        ],
        component: (0, $89fa0a59411ddd45$export$2e2bcd8739ae039),
        forPaint: [
            (0, $89fa0a59411ddd45$export$22681210aaeb910f)
        ],
        perfMetricKey: 'issue-forms-direct-embed'
    })
];
const $2719ac30f4e07b26$export$2e672712b21297b8 = [
    (0, $apqRF.createEntry)((0, $7ccbe961b49f6771$export$4c5d46fe4c460ef9), {
        layout: (0, $dVvIP.globalLayout),
        resources: [
            ...(0, $hHrVM.getNavigationResources)()
        ],
        component: (0, $7715e223327779be$export$2e2bcd8739ae039),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7715e223327779be$export$5e0d802a5d865352)
        ]
    }),
    (0, $apqRF.createEntry)((0, $7ccbe961b49f6771$export$7de22a6665b73706), {
        layout: (0, $dVvIP.globalLayout),
        resources: [
            ...(0, $hHrVM.getNavigationResources)()
        ],
        component: (0, $357e75320b6357c0$export$2e2bcd8739ae039),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $357e75320b6357c0$export$7c16b09eb95f1c5d)
        ],
        perfMetricKey: 'issue-forms-general'
    }),
    (0, $apqRF.createEntry)((0, $7ccbe961b49f6771$export$c02a5b8ecf73713e), {
        layout: (0, $soOXK.softwareProjectLayout),
        resources: [
            (0, $ixwgj.projectContextResource)
        ],
        component: (0, $5f94abb64b62ae5b$export$2e2bcd8739ae039),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS
        },
        forPaint: [
            (0, $5f94abb64b62ae5b$export$a0f04dd35569e11)
        ],
        perfMetricKey: 'issue-forms-direct'
    }),
    (0, $apqRF.createEntry)((0, $7ccbe961b49f6771$export$cd0e54104fd6e37c), {
        layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
        resources: [
            (0, $ixwgj.projectContextResource)
        ],
        component: (0, $89fa0a59411ddd45$export$2e2bcd8739ae039),
        forPaint: [
            (0, $89fa0a59411ddd45$export$22681210aaeb910f)
        ],
        perfMetricKey: 'issue-forms-direct-embed'
    })
];
const $2719ac30f4e07b26$export$2763334cca1560d7 = [
    ...$2719ac30f4e07b26$export$786e5a0c86be676a,
    ...$2719ac30f4e07b26$export$c4313dd46c85e3d3,
    ...$2719ac30f4e07b26$export$2e672712b21297b8
];



var $cernH = parcelRequire("cernH");

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $apqRF = parcelRequire("apqRF");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $8r1Yz = parcelRequire("8r1Yz");

var $ixwgj = parcelRequire("ixwgj");
const $c3b27776d577c96d$export$1d7a0c194c3e83f2 = [
    'selectedItem=com.atlassian.jira.jira-projects-plugin:components-page'
];



var $exb0h = parcelRequire("exb0h");
const $f7c9990bca772508$export$d370abe25253fa1b = {
    group: (0, $exb0h.ROUTE_GROUPS).COMPONENTS,
    name: `${(0, $exb0h.ROUTE_NAMES).PROJECT_COMPONENTS}-redirect`,
    path: '/projects/:projectKey',
    query: (0, $c3b27776d577c96d$export$1d7a0c194c3e83f2)
};
const $f7c9990bca772508$export$f76189bea494b0b8 = {
    group: (0, $exb0h.ROUTE_GROUPS).COMPONENTS,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_COMPONENTS,
    path: '/jira/:projectType(software|software/c|servicedesk|core)/projects/:projectKey/components'
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $k4nIh = parcelRequire("k4nIh");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");
var $3HCkE = parcelRequire("3HCkE");

var $ixwgj = parcelRequire("ixwgj");

var $78d1w = parcelRequire("78d1w");
const $f8aad89894949912$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $kJlBc.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $jMP2a.fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, $bFzGY.useAnalyticsEvents), useResource: useResource = (0, $3HCkE.useResource), useRouter: useRouter = (0, $kJlBc.useRouter), useSpaStateTransition: useSpaStateTransition = (0, $78d1w.useSpaStateTransition) })=>{
    const [{ match: match, query: query, route: route }] = useRouter();
    const { data: data } = useResource((0, $ixwgj.projectContextResource));
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $eUqFw.useRef)(createAnalyticsEvent({}));
    (0, $eUqFw.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $7ZZxN.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $7ZZxN.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};



const $2d1a09ddaa7fa887$export$f32c20cfbc84532c = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("epRpT"))), {
    moduleId: "./src/packages/spa-apps/project/components/src/index.tsx"
});
const $2d1a09ddaa7fa887$export$9cf9ae84482ff18e = ()=>{
    const page = (_, { selectedItem: selectedItem, ...rest })=>{
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
        const querystring = (0, $k4nIh.qs).stringify(rest, true);
        return `/components${querystring}`;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f8aad89894949912$export$8a3df560509448b8), {
        page: page
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2d1a09ddaa7fa887$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $2d1a09ddaa7fa887$export$f32c20cfbc84532c,
        pageId: "project-components",
        shouldShowSpinner: false
    });


const $3637efef4b0c5bc2$export$e60f53ff5ae626cd = (0, $apqRF.createEntry)((0, $f7c9990bca772508$export$d370abe25253fa1b), {
    component: !false ? (0, $2d1a09ddaa7fa887$export$9cf9ae84482ff18e) : (0, $2d1a09ddaa7fa887$export$2e2bcd8739ae039),
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $ixwgj.projectContextResource),
        (0, $8r1Yz.projectsComponentsResource),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $2d1a09ddaa7fa887$export$f32c20cfbc84532c)
    ],
    isRedirect: true
});
const $3637efef4b0c5bc2$export$25cf284456caeeef = (0, $apqRF.createEntry)((0, $f7c9990bca772508$export$f76189bea494b0b8), {
    ufoName: 'project-components-view',
    component: (0, $2d1a09ddaa7fa887$export$2e2bcd8739ae039),
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $ixwgj.projectContextResource),
        (0, $8r1Yz.projectsComponentsResource),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $2d1a09ddaa7fa887$export$f32c20cfbc84532c)
    ]
});



var $cernH = parcelRequire("cernH");

var $9zysr = parcelRequire("9zysr");

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $apqRF = parcelRequire("apqRF");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $ixwgj = parcelRequire("ixwgj");

var $dgH3j = parcelRequire("dgH3j");

var $exb0h = parcelRequire("exb0h");
const $07bae85033f836a2$export$2d09da22e737849e = {
    group: (0, $exb0h.ROUTE_GROUPS).COMPONENTS,
    name: `${(0, $exb0h.ROUTE_NAMES).PROJECT_PAGES}-legacy`,
    path: '/projects/:projectKey',
    query: [
        'selectedItem=com.atlassian.jira.jira-projects-plugin:project-pages-page'
    ]
};
const $07bae85033f836a2$export$54a218ca6d1c056a = {
    group: (0, $exb0h.ROUTE_GROUPS).COMPONENTS,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_PAGES,
    path: '/jira/:projectType(software|software/c|servicedesk)/projects/:projectKey/pages'
};



var $yyqSx = parcelRequire("yyqSx");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");
var $3HCkE = parcelRequire("3HCkE");

var $ixwgj = parcelRequire("ixwgj");

var $78d1w = parcelRequire("78d1w");
const $0b738748b4c83495$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $kJlBc.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $jMP2a.fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, $bFzGY.useAnalyticsEvents), useResource: useResource = (0, $3HCkE.useResource), useRouter: useRouter = (0, $kJlBc.useRouter), useSpaStateTransition: useSpaStateTransition = (0, $78d1w.useSpaStateTransition) })=>{
    const [{ match: match, query: query, route: route }] = useRouter();
    const { data: data } = useResource((0, $ixwgj.projectContextResource));
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $eUqFw.useRef)(createAnalyticsEvent({}));
    (0, $eUqFw.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $7ZZxN.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $7ZZxN.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};



const $6da5e9c3e963df27$export$c2115a649411f570 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("lNorK"))), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/project/pages/src/index.tsx"
});
const $6da5e9c3e963df27$export$7c3b1828ada63555 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0b738748b4c83495$export$8a3df560509448b8), {
        page: "/pages"
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6da5e9c3e963df27$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $6da5e9c3e963df27$export$c2115a649411f570,
        pageId: "project-pages",
        shouldShowSpinner: false
    });


const $ffed543118f23d13$export$babf32528ef518e9 = (0, $apqRF.createEntry)((0, $07bae85033f836a2$export$2d09da22e737849e), {
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $ixwgj.projectContextResource),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    component: !false ? (0, $6da5e9c3e963df27$export$7c3b1828ada63555) : (0, $6da5e9c3e963df27$export$2e2bcd8739ae039),
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $6da5e9c3e963df27$export$c2115a649411f570)
    ],
    isRedirect: true
});
const $ffed543118f23d13$export$6e8865417e6a38c = (0, $apqRF.createEntry)((0, $07bae85033f836a2$export$54a218ca6d1c056a), {
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $ixwgj.projectContextResource),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    component: (0, $9zysr.componentWithCondition)((0, $yyqSx.isDevopsFeatureDisabledInFedRamp), (0, $dgH3j.default), (0, $6da5e9c3e963df27$export$2e2bcd8739ae039)),
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $6da5e9c3e963df27$export$c2115a649411f570)
    ]
});



var $cernH = parcelRequire("cernH");

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $apqRF = parcelRequire("apqRF");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $8r1Yz = parcelRequire("8r1Yz");

var $ixwgj = parcelRequire("ixwgj");

var $exb0h = parcelRequire("exb0h");
const $4bf4aa65cd709577$export$79cbce13eeecd53 = {
    group: (0, $exb0h.ROUTE_GROUPS).COMPONENTS,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_COMPONENTS,
    path: '/plugins/servlet/project-config/:projectKey/administer-components'
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $k4nIh = parcelRequire("k4nIh");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");
var $3HCkE = parcelRequire("3HCkE");

var $ixwgj = parcelRequire("ixwgj");

var $78d1w = parcelRequire("78d1w");
const $e702f5143f2f0fb4$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $kJlBc.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $jMP2a.fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, $bFzGY.useAnalyticsEvents), useResource: useResource = (0, $3HCkE.useResource), useRouter: useRouter = (0, $kJlBc.useRouter), useSpaStateTransition: useSpaStateTransition = (0, $78d1w.useSpaStateTransition) })=>{
    const [{ match: match, query: query, route: route }] = useRouter();
    const { data: data } = useResource((0, $ixwgj.projectContextResource));
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $eUqFw.useRef)(createAnalyticsEvent({}));
    (0, $eUqFw.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $7ZZxN.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $7ZZxN.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};



const $d206bd5dee47a41e$export$bb69d8c36391123 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("epRpT"))), {
    moduleId: "./src/packages/spa-apps/project/components/src/index.tsx"
});
const $d206bd5dee47a41e$export$60cfbcd781a48d01 = ()=>{
    const page = (_, { selectedItem: selectedItem, ...rest })=>{
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
        const querystring = (0, $k4nIh.qs).stringify(rest, true);
        return `/settings/components${querystring}`;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e702f5143f2f0fb4$export$8a3df560509448b8), {
        page: page
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d206bd5dee47a41e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $d206bd5dee47a41e$export$bb69d8c36391123,
        pageId: "project-settings-components",
        shouldShowSpinner: true
    });


const $dba4682a95e5bab0$export$72497f4e39dd0df4 = (0, $apqRF.createEntry)((0, $4bf4aa65cd709577$export$79cbce13eeecd53), {
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $ixwgj.projectContextResource),
        (0, $8r1Yz.projectsComponentsResource),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    component: (0, $d206bd5dee47a41e$export$2e2bcd8739ae039),
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $d206bd5dee47a41e$export$bb69d8c36391123)
    ]
});



var $cernH = parcelRequire("cernH");

var $1ybV0 = parcelRequire("1ybV0");

var $bAQOb = parcelRequire("bAQOb");

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $apqRF = parcelRequire("apqRF");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $ixwgj = parcelRequire("ixwgj");

var $gVIF2 = parcelRequire("gVIF2");

var $6YxH4 = parcelRequire("6YxH4");

var $jwzNs = parcelRequire("jwzNs");

var $exb0h = parcelRequire("exb0h");
const $8ebe884284523590$export$cc9450e5d7579b99 = {
    group: (0, $exb0h.ROUTE_GROUPS).COMPONENTS,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_VERSIONS,
    path: '/plugins/servlet/project-config/:projectKey/administer-versions'
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $b5d8285e4e4394db$export$9036da4fa9f7a66f = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("axbhE"))), {
    moduleId: "./src/packages/spa-apps/project/relay-versions/src/index.tsx"
});

const $b5d8285e4e4394db$export$5db9222235a9cec3 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("8LZ8X")), {
    moduleId: "./src/packages/spa-apps/project/versions/src/index.tsx"
});
const $b5d8285e4e4394db$export$9aff7dab80671d9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $b5d8285e4e4394db$export$9036da4fa9f7a66f,
        pageId: "relay-project-versions",
        shouldShowSpinner: false
    });
const $b5d8285e4e4394db$export$4893a37082435e75 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $b5d8285e4e4394db$export$5db9222235a9cec3,
        pageId: "project-settings-versions",
        shouldShowSpinner: true
    });


const $00c9b0281306dc31$export$4791201b4877aa5d = (0, $apqRF.createEntry)((0, $8ebe884284523590$export$cc9450e5d7579b99), {
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        (0, $ixwgj.projectContextResource),
        (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('modernise-project-versions_w698h'), (0, $gVIF2.projectVersionsRelayResource), (0, $6YxH4.projectsVersionsResource)),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    component: (0, $bAQOb.componentWithFF)('modernise-project-versions_w698h', (0, $b5d8285e4e4394db$export$9aff7dab80671d9), (0, $b5d8285e4e4394db$export$4893a37082435e75)),
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $b5d8285e4e4394db$export$5db9222235a9cec3)
    ]
});



var $cernH = parcelRequire("cernH");

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $apqRF = parcelRequire("apqRF");

var $4qvmP = parcelRequire("4qvmP");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $4mBNF = parcelRequire("4mBNF");

var $exb0h = parcelRequire("exb0h");
const $8bdddd1cfa5b4bd9$export$e6bc3ea427ddafb8 = {
    group: (0, $exb0h.ROUTE_GROUPS).REDIRECTS,
    name: (0, $exb0h.ROUTE_NAMES).PROJECTS_REDIRECT,
    path: '/projects/:projectKey',
    query: [
        'selectedItem!=(.+)'
    ],
    exact: true
};


const $3dfca2b5a9cb36ce$export$56f9921db324f30 = (0, $apqRF.createEntry)((0, $8bdddd1cfa5b4bd9$export$e6bc3ea427ddafb8), {
    isRedirect: true,
    component: (0, $4mBNF.RedirectToLastVisitedProjectPage),
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation)
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $cernH = parcelRequire("cernH");

var $1ybV0 = parcelRequire("1ybV0");

var $bAQOb = parcelRequire("bAQOb");

var $d1szd = parcelRequire("d1szd");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $apqRF = parcelRequire("apqRF");

var $4qvmP = parcelRequire("4qvmP");

var $hHrVM = parcelRequire("hHrVM");

var $ixwgj = parcelRequire("ixwgj");

var $gVIF2 = parcelRequire("gVIF2");

var $6YxH4 = parcelRequire("6YxH4");

var $jwzNs = parcelRequire("jwzNs");
const $98900ab4c6b6a9b7$export$ad46185437bb571a = [
    'selectedItem=com.atlassian.jira.jira-projects-plugin:release-page'
];



var $exb0h = parcelRequire("exb0h");
const $6108f51b191ada48$export$fb5516756c3eba40 = {
    group: (0, $exb0h.ROUTE_GROUPS).COMPONENTS,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_VERSIONS,
    path: '/projects/:projectKey',
    query: (0, $98900ab4c6b6a9b7$export$ad46185437bb571a)
};



var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $3a69954879d67a4b$export$b10f4339e94acddc = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("8LZ8X"))), {
    moduleId: "./src/packages/spa-apps/project/versions/src/index.tsx"
});

const $3a69954879d67a4b$export$9036da4fa9f7a66f = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("axbhE"))), {
    moduleId: "./src/packages/spa-apps/project/relay-versions/src/index.tsx"
});
const $3a69954879d67a4b$export$4893a37082435e75 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $3a69954879d67a4b$export$b10f4339e94acddc,
        pageId: "project-versions",
        shouldShowSpinner: false
    });
const $3a69954879d67a4b$export$9aff7dab80671d9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $3a69954879d67a4b$export$9036da4fa9f7a66f,
        pageId: "relay-project-versions",
        shouldShowSpinner: false
    });
const $3a69954879d67a4b$export$982bc443ef89cc3f = (0, $apqRF.createEntry)((0, $6108f51b191ada48$export$fb5516756c3eba40), {
    resources: [
        ...(0, $4qvmP.getBusinessProjectResources)(),
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        (0, $ixwgj.projectContextResource),
        (0, $jwzNs.resourceWithCondition2)(()=>(0, $1ybV0.ff)('modernise-project-versions_w698h'), (0, $gVIF2.projectVersionsRelayResource), (0, $6YxH4.projectsVersionsResource))
    ],
    component: (0, $bAQOb.componentWithFF)('modernise-project-versions_w698h', $3a69954879d67a4b$export$9aff7dab80671d9, $3a69954879d67a4b$export$4893a37082435e75),
    layout: (0, $d1szd.genericProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $5w4hM.genericProjectSidebars),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $3a69954879d67a4b$export$b10f4339e94acddc
    ]
});



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $apqRF = parcelRequire("apqRF");

var $dAKwA = parcelRequire("dAKwA");

var $kbHFR = parcelRequire("kbHFR");

var $6CNdU = parcelRequire("6CNdU");
var $d4Gv0 = parcelRequire("d4Gv0");

var $1ODui = parcelRequire("1ODui");

var $csLgO = parcelRequire("csLgO");

var $frZnw = parcelRequire("frZnw");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $0e750e81870ad8bd$var$LazyServicedeskCustomerServiceEscalations = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("g3ItN"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/customer-service-escalations/src/index.tsx"
});
const $0e750e81870ad8bd$export$1a08682f4847bb2f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $0e750e81870ad8bd$var$LazyServicedeskCustomerServiceEscalations,
        pageId: "spa-apps/servicedesk/customer-service-escalations",
        shouldShowSpinner: true
    });
const $0e750e81870ad8bd$export$36a7c374f4474cc1 = (0, $apqRF.createEntry)((0, $1ODui.escalationsRoute), {
    layout: (0, $csLgO.serviceProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iTYGl.default)
    },
    resources: [
        ...(0, $kbHFR.getServiceDeskNavigationResources)(),
        ...(0, $kbHFR.getServicedeskPageContextResources)(),
        (0, $dAKwA.getConsolidationStateResource)(),
        (0, $6CNdU.componentFilterResource),
        (0, $d4Gv0.priorityFilterResource)
    ],
    component: $0e750e81870ad8bd$export$1a08682f4847bb2f,
    perfMetricKey: 'jsm-customer-service-escalations-component-load',
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $0e750e81870ad8bd$var$LazyServicedeskCustomerServiceEscalations
    ],
    meta: {
        reporting: {
            id: (0, $frZnw.APP_NAMES).CUSTOMER_SERVICE_ESCALATIONS,
            packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).CUSTOMER_SERVICE_ESCALATIONS),
            teamName: 'boysenberry'
        }
    }
});



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $apqRF = parcelRequire("apqRF");

var $kbHFR = parcelRequire("kbHFR");

var $aP2Ra = parcelRequire("aP2Ra");

var $f7Fx7 = parcelRequire("f7Fx7");

var $csLgO = parcelRequire("csLgO");

var $frZnw = parcelRequire("frZnw");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $e14bffeebd141c9d$var$LazyServicedeskCustomerServiceProducts = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("amK0o"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/customer-service-products/src/index.tsx"
});
const $e14bffeebd141c9d$export$46ba99069f037d90 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e14bffeebd141c9d$var$LazyServicedeskCustomerServiceProducts,
        pageId: "spa-apps/servicedesk/customer-service-products",
        shouldShowSpinner: true
    });
const $e14bffeebd141c9d$export$8e015e39dbc90d0b = (0, $apqRF.createEntry)((0, $f7Fx7.productsRoute), {
    layout: (0, $csLgO.serviceProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iTYGl.default)
    },
    resources: [
        ...(0, $kbHFR.getServiceDeskNavigationResources)(),
        ...(0, $kbHFR.getServicedeskPageContextResources)(),
        (0, $aP2Ra.customerServiceProductsQueryResource)
    ],
    component: $e14bffeebd141c9d$export$46ba99069f037d90,
    perfMetricKey: 'jsm-customer-service-products-component-load',
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $e14bffeebd141c9d$var$LazyServicedeskCustomerServiceProducts
    ],
    meta: {
        reporting: {
            id: (0, $frZnw.APP_NAMES).CUSTOMER_SERVICE_PRODUCTS,
            packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).CUSTOMER_SERVICE_PRODUCTS),
            teamName: 'boysenberry'
        }
    }
});



var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $exb0h = parcelRequire("exb0h");
const $e7f4080e2acdf189$export$b314ab31b2da625b = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).SETTINGS_AUTOMATION,
    path: '/jira/settings/automation',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $k4nIh = parcelRequire("k4nIh");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");
var $3HCkE = parcelRequire("3HCkE");

var $ixwgj = parcelRequire("ixwgj");

var $78d1w = parcelRequire("78d1w");
const $8c98e397e7108d42$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $kJlBc.Redirect), fireUIAnalytics: fireUIAnalytics = (0, $jMP2a.fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, $bFzGY.useAnalyticsEvents), useResource: useResource = (0, $3HCkE.useResource), useRouter: useRouter = (0, $kJlBc.useRouter), useSpaStateTransition: useSpaStateTransition = (0, $78d1w.useSpaStateTransition) })=>{
    const [{ match: match, query: query, route: route }] = useRouter();
    const { data: data } = useResource((0, $ixwgj.projectContextResource));
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const [{ isInitialRender: isInitial }] = useSpaStateTransition();
    const eventRef = (0, $eUqFw.useRef)(createAnalyticsEvent({}));
    (0, $eUqFw.useEffect)(()=>{
        if (!data || !route || !eventRef.current) return;
        fireUIAnalytics(eventRef.current, 'route redirected', {
            isInitial: isInitial,
            routeName: route.name
        });
        // @ts-expect-error - Type 'null' is not assignable to type 'UIAnalyticsEvent'.
        eventRef.current = null;
    }, [
        data,
        fireUIAnalytics,
        isInitial,
        route
    ]);
    if (!data || !route) return null;
    const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
    let type;
    switch(projectType){
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            type = 'servicedesk';
            break;
        case 0, $7ZZxN.CORE_PROJECT:
            type = 'core';
            break;
        case 0, $7ZZxN.SOFTWARE_PROJECT:
        default:
            type = `software${simplified ? '' : '/c'}`;
    }
    const returnPage = typeof page === 'string' ? page : page(match, query);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Redirect, {
        to: `/jira/${type}/projects/${projectKey}${returnPage}`
    });
};



const $1f271376b40d6837$export$4189991a2992b828 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("hmkBf"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/automation/src/index.tsx"
});
const $1f271376b40d6837$export$7c85ddcd4f0a813f = ()=>{
    const page = (_, { selectedItem: selectedItem, ...rest })=>{
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
        const querystring = (0, $k4nIh.qs).stringify(rest, true);
        return `/automation${querystring}`;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8c98e397e7108d42$export$8a3df560509448b8), {
        page: page
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1f271376b40d6837$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $1f271376b40d6837$export$4189991a2992b828,
        pageId: "global-automation",
        shouldShowSpinner: false
    });


const $cbfac00f5b372876$export$4df9f9dcaf8565c9 = (0, $apqRF.createEntry)((0, $e7f4080e2acdf189$export$b314ab31b2da625b), {
    component: (0, $1f271376b40d6837$export$2e2bcd8739ae039),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $bt7QT.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $1f271376b40d6837$export$4189991a2992b828)
    ]
});



var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $exb0h = parcelRequire("exb0h");
const $d48e699701a023d4$export$5097bfaa68f86ca6 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).SETTINGS_CMDB_FIELD_CONFIG,
    path: '/secure/admin/CmdbObjectFieldConfiguration'
};



var $cV47S = parcelRequire("cV47S");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $a4363cd77e921691$export$ccc6da5137e23637 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("8ghfS"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/cmdb-field-config/src/index.tsx"
});
const $a4363cd77e921691$export$8dfbe255f554ebab = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $a4363cd77e921691$export$ccc6da5137e23637,
        pageId: "admin-pages-cmdb-field-config",
        shouldShowSpinner: true
    });


const $31538ea633950fb6$export$c68a412f25295511 = (0, $apqRF.createEntry)((0, $d48e699701a023d4$export$5097bfaa68f86ca6), {
    ufoName: 'admin.cmdb-field-config',
    component: (0, $a4363cd77e921691$export$8dfbe255f554ebab),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $4JtEo.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $9CFDS.navigationSidebarGlobalResource),
        (0, $cV47S.workspaceResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $a4363cd77e921691$export$ccc6da5137e23637)
    ]
});



var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $l90Gp = parcelRequire("l90Gp");

var $hUM03 = parcelRequire("hUM03");

var $apqRF = parcelRequire("apqRF");

var $3nZzB = parcelRequire("3nZzB");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $exb0h = parcelRequire("exb0h");
const $db93091f8ec8ae56$export$c0ee28def7ef8783 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).SETTINGS_OAUTH_CREDENTIALS,
    path: '/secure/admin/oauth-credentials'
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $e643f050bed13082$export$101baa25055633e8 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("9xasj"))), {
    moduleId: "./src/packages/spa-apps/admin-oauth-credentials/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e643f050bed13082$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e643f050bed13082$export$101baa25055633e8,
        pageId: "admin-oauth-credentials",
        shouldShowSpinner: true
    });


const $5c5c328d1a0c046c$export$d1c67ceb7c5e2d6a = (0, $apqRF.createEntry)((0, $db93091f8ec8ae56$export$c0ee28def7ef8783), {
    component: (0, $e643f050bed13082$export$2e2bcd8739ae039),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $hUM03.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $l90Gp.getNavigationSidebarGlobalSettingsResources)(),
        (0, $9CFDS.navigationSidebarGlobalResource),
        (0, $3nZzB.adminOauthCredentialsResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $e643f050bed13082$export$101baa25055633e8)
    ],
    ufoName: 'admin.oauth-credentials'
});



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");


var $apqRF = parcelRequire("apqRF");

var $9HzdP = parcelRequire("9HzdP");

var $exb0h = parcelRequire("exb0h");
const $7d81f8438b2c42a7$export$5e6c92d2f34c1e48 = {
    group: (0, $exb0h.ROUTE_GROUPS).SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_ONBOARDING,
    path: '/welcome/software',
    exact: true
};



var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $6fe987b31d848aa1$export$31e9f06d3389e445 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("gAPTT"))), {
    moduleId: "./src/packages/spa-apps/software/onboarding/src/index.tsx"
});
const $6fe987b31d848aa1$export$ee768d69c6e3a8bd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $6fe987b31d848aa1$export$31e9f06d3389e445,
        pageId: "software-onboarding",
        shouldShowSpinner: false
    });
const $6fe987b31d848aa1$export$23e1ab8ae95bd3a8 = [
    (0, $apqRF.createEntry)((0, $7d81f8438b2c42a7$export$5e6c92d2f34c1e48), {
        component: $6fe987b31d848aa1$export$ee768d69c6e3a8bd,
        layout: (0, $eaa6d448b27830ba$export$17e73ed8c35891cb),
        // Note: this route does not load theme settings ressource, this is intentional
        // as JSW onboarding screens do not support dark mode yet.
        resources: [
            (0, $9HzdP.jswOnboardingResource)
        ],
        forPaint: [
            $6fe987b31d848aa1$export$31e9f06d3389e445
        ],
        canTransitionIn: ()=>false
    })
];



var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7hF3Y = parcelRequire("7hF3Y");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $exb0h = parcelRequire("exb0h");
const $1160f58455475cf7$export$74ec9fecd42fa96e = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).TRASH_PROJECTS_DIRECTORY,
    path: '/secure/projects/trash',
    exact: true
};
const $1160f58455475cf7$export$a788f0ca96b92194 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).TRASH_PROJECTS_DIRECTORY,
    path: '/jira/settings/projects/trash',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $kJlBc = parcelRequire("kJlBc");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d7a6521eda4880f6$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "projectsTrashRedirect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
        to: "/jira/settings/projects/trash"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null));



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $0a22d45a48ec33de$export$dd65a8ee0a9ac24f = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("fKkwe"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/trashed-projects/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0a22d45a48ec33de$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $0a22d45a48ec33de$export$dd65a8ee0a9ac24f,
        pageId: "trashed-projects",
        shouldShowSpinner: true
    });


const $6700056f9681aaf5$export$27d1f352c2f7acae = (0, $apqRF.createEntry)((0, $1160f58455475cf7$export$74ec9fecd42fa96e), {
    ufoName: 'admin.trashed-projects',
    component: (0, $d7a6521eda4880f6$export$2e2bcd8739ae039),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7hF3Y.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $0a22d45a48ec33de$export$dd65a8ee0a9ac24f)
    ],
    isRedirect: true
});
const $6700056f9681aaf5$export$f52136d9a0848792 = (0, $apqRF.createEntry)((0, $1160f58455475cf7$export$a788f0ca96b92194), {
    ufoName: 'admin.trashed-projects',
    component: (0, $0a22d45a48ec33de$export$2e2bcd8739ae039),
    layout: (0, $efFTI.globalSettingsLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).SETTINGS,
        sidebar: (0, $7hF3Y.default)
    },
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        (0, $9CFDS.navigationSidebarGlobalResource)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $0a22d45a48ec33de$export$dd65a8ee0a9ac24f)
    ]
});



var $cernH = parcelRequire("cernH");

var $dVvIP = parcelRequire("dVvIP");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $b632b27b4ab3e384$export$146910ddc36bf151 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_CONTACT_ADMINISTRATOR,
    path: '/jira/contact-administrator'
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $ecd8ccfd623c2340$export$bf75747a931b9a2b = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("c8Srg"))), {
    moduleId: "./src/packages/admin-pages/contact-administrator/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ecd8ccfd623c2340$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $ecd8ccfd623c2340$export$bf75747a931b9a2b,
        pageId: "jira-admin-pages-contact-administrator",
        shouldShowSpinner: true
    });


const $021c609a71aef057$export$1ca91576d82f7098 = [
    (0, $apqRF.createEntry)((0, $b632b27b4ab3e384$export$146910ddc36bf151), {
        ufoName: 'admin.contact-administrator',
        component: (0, $ecd8ccfd623c2340$export$2e2bcd8739ae039),
        layout: (0, $dVvIP.globalLayout),
        resources: [
            ...(0, $hHrVM.getNavigationResources)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $ecd8ccfd623c2340$export$bf75747a931b9a2b)
        ]
    })
];



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $cernH = parcelRequire("cernH");


var $1ybV0 = parcelRequire("1ybV0");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $87SmV = parcelRequire("87SmV");

var $exb0h = parcelRequire("exb0h");
const $7989cf88f1843569$export$aed294a4a292b909 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).GLOBAL_ADMIN_HELPER_EMAIL_NOTIFICATIONS_LOG,
    path: '/jira/settings/system/notification-logs',
    exact: true
};


/**
 * @generated SignedSource<<48242a043723a47c0507b317aa640a69>>
 * @relayHash f9bb43f6abe4afa1efe38b263fecef29
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4f2f975f48898f550217e6f70f97d058bae26f3b82201365111f6938e585dcde
const $1d6732545ac2165f$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "4f2f975f48898f550217e6f70f97d058bae26f3b82201365111f6938e585dcde",
        "metadata": {},
        "name": "notificationTableQuery",
        "operationKind": "query",
        "text": null
    }
};
var $1d6732545ac2165f$export$2e2bcd8739ae039 = $1d6732545ac2165f$var$node;



var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $a1ea5eaf508d0c55$export$818d841e00bb3749 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("8p4LD")), {
        moduleId: "d533cc53"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                notificationLogs: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $1d6732545ac2165f$export$2e2bcd8739ae039,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectIds: context?.query?.projectId,
                        notificationType: 'INTERNAL_NOTIFICATION',
                        notificationActionType: 'USER_INVITE',
                        recipientId: ''
                    }
                }
            },
            extraProps: {
                accountId: tenantContext.atlassianAccountId
            }
        })
});



var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");
const $fc291bfad8a02cf2$var$emailNotificationsLogEntryPointPage = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $a1ea5eaf508d0c55$export$818d841e00bb3749),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).SETTINGS
});

const $fc291bfad8a02cf2$export$b2f1a46be2e3ed3f = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("8p4LD"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/notification-logs/src/index.tsx"
});
const $fc291bfad8a02cf2$var$NotificationLogs = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $fc291bfad8a02cf2$export$b2f1a46be2e3ed3f,
        pageId: "Notification Logs",
        shouldShowSpinner: false
    });
const $fc291bfad8a02cf2$export$e3943daecc3985cb = [
    (0, $apqRF.createEntry)((0, $7989cf88f1843569$export$aed294a4a292b909), {
        component: $fc291bfad8a02cf2$var$NotificationLogs,
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $bt7QT.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource),
            (0, $87SmV.systemConfigurationGeneralResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            $fc291bfad8a02cf2$export$b2f1a46be2e3ed3f
        ],
        pageId: 'admin-settings-email-notifications-log',
        entryPoint () {
            return (0, $1ybV0.ff)('platform.jlove-pulsar.jlovep-423-jsw-notification-logs-ui') ? $fc291bfad8a02cf2$var$emailNotificationsLogEntryPointPage : undefined;
        }
    })
];



var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $exb0h = parcelRequire("exb0h");
const $782cc9d158b3be78$export$17c79100fc4c65a1 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).EXTERNAL_IMPORT,
    path: '/jira/settings/system/external-import'
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9b16e61bd30e0322$var$LazyExternalImport = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("3eQtr")), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/admin-pages/external-import/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9b16e61bd30e0322$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $9b16e61bd30e0322$var$LazyExternalImport,
        pageId: "external-import-general",
        shouldShowSpinner: false
    });


const $56d0c84c95c21918$export$c535ef4656da2cd9 = [
    (0, $apqRF.createEntry)((0, $782cc9d158b3be78$export$17c79100fc4c65a1), {
        component: (0, $9b16e61bd30e0322$export$2e2bcd8739ae039),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $bt7QT.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation)
        ]
    })
];



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $cernH = parcelRequire("cernH");

var $1ybV0 = parcelRequire("1ybV0");

var $bAQOb = parcelRequire("bAQOb");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $apqRF = parcelRequire("apqRF");

var $8jcNY = parcelRequire("8jcNY");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $exb0h = parcelRequire("exb0h");
const $8228560afc8f1e0f$export$236ce89eb737f752 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_GLOBAL_PERMISSIONS,
    path: '/secure/admin/global-permissions'
};



var $dgH3j = parcelRequire("dgH3j");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $bb9b0d3ef4010bcb$export$a97b1349c011eb4 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("epY1x"))), {
    moduleId: "./src/packages/permissions-administration/pages/global-permissions/src/index.tsx"
});
const $bb9b0d3ef4010bcb$export$a8d149dea7df681c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $bb9b0d3ef4010bcb$export$a97b1349c011eb4,
        pageId: "jira-global-permissions",
        shouldShowSpinner: true
    });
const $bb9b0d3ef4010bcb$export$db45b991e5ee3460 = [
    (0, $apqRF.createEntry)((0, $8228560afc8f1e0f$export$236ce89eb737f752), {
        component: (0, $bAQOb.componentWithFF)('everest-global-permissions-fe-modernisation_vvy6j', $bb9b0d3ef4010bcb$export$a8d149dea7df681c, (0, $dgH3j.default)),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $bt7QT.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource),
            (0, $8jcNY.globalPermissionsResource)
        ],
        canTransitionIn: ()=>(0, $1ybV0.ff)('everest-global-permissions-fe-modernisation_vvy6j'),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            $bb9b0d3ef4010bcb$export$a97b1349c011eb4
        ],
        meta: {
            reporting: {
                id: 'GlobalPermissions',
                packageName: 'jiraAdminPagesGlobalPermissions',
                teamName: 'olympus'
            }
        }
    })
];



var $eUqFw = parcelRequire("eUqFw");

var $k4wVH = parcelRequire("k4wVH");

var $8K5zM = parcelRequire("8K5zM");

var $eDggO = parcelRequire("eDggO");

var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $1MAZH = parcelRequire("1MAZH");

var $atRHQ = parcelRequire("atRHQ");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $de1ad3ad20337085$export$1ff7255ab4f7a2dd = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("jYdf8"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/issue-types/issue-hierarchy-directory/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$de1ad3ad20337085$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $de1ad3ad20337085$export$1ff7255ab4f7a2dd,
        pageId: "jira-admin-pages-issue-hierarchy-directory",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $767c3e340ddbb52b$export$611728a54ba37830 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("5H2v7"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/issue-types/issue-type-schemes-directory/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$767c3e340ddbb52b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $767c3e340ddbb52b$export$611728a54ba37830,
        pageId: "jira-admin-pages-issue-type-schemes-directory",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $518e347d6dbe1cf4$export$661e1bf38bb82270 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("7asbG"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/issue-types/issue-types-directory/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$518e347d6dbe1cf4$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $518e347d6dbe1cf4$export$661e1bf38bb82270,
        pageId: "jira-admin-pages-issue-types-directory",
        shouldShowSpinner: true
    });


const $653716d20d53efbb$export$84bb32992a534053 = [
    (0, $apqRF.createEntry)((0, $1MAZH.globalSettingsIssueHierarchyRoute), {
        ufoName: 'global-admin.issues.issue-hierarchy-config',
        component: (0, $de1ad3ad20337085$export$2e2bcd8739ae039),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $4JtEo.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource),
            (0, $k4wVH.issueHierarchyPageResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $de1ad3ad20337085$export$1ff7255ab4f7a2dd)
        ]
    }),
    (0, $apqRF.createEntry)((0, $1MAZH.globalSettingsIssueHierarchyRedirectRoute), {
        component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
                to: "/jira/settings/issues/issue-hierarchy"
            }),
        isRedirect: true,
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $4JtEo.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource),
            (0, $k4wVH.issueHierarchyPageResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $de1ad3ad20337085$export$1ff7255ab4f7a2dd)
        ]
    }),
    (0, $apqRF.createEntry)((0, $1MAZH.globalSettingsIssueTypesRoute), {
        ufoName: 'global-admin.issues.issue-types',
        component: (0, $518e347d6dbe1cf4$export$2e2bcd8739ae039),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $4JtEo.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource),
            (0, $eDggO.issueTypesResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $518e347d6dbe1cf4$export$661e1bf38bb82270)
        ]
    }),
    (0, $apqRF.createEntry)((0, $1MAZH.globalSettingsIssueTypesSchemesRoute), {
        ufoName: 'global-admin.issues.view-issue-type-schemes',
        component: (0, $767c3e340ddbb52b$export$2e2bcd8739ae039),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $4JtEo.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource),
            (0, $8K5zM.default)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $767c3e340ddbb52b$export$611728a54ba37830)
        ]
    })
];



var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $apqRF = parcelRequire("apqRF");

var $d2cDI = parcelRequire("d2cDI");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $864b735c7a57a8e0$export$6395086ce7e72e37 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).PRODUCTS_JSM_AUTHENTICATION_SETTINGS,
    path: '/jira/settings/products/servicedesk/authentication',
    exact: true
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $2d2f0d7c6647391c$export$6cd59b0135f3fe86 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("7QODe"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/product-jsm-authentication-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2d2f0d7c6647391c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $2d2f0d7c6647391c$export$6cd59b0135f3fe86,
        pageId: "spa-apps/admin-pages/jsm-authentication-settings",
        shouldShowSpinner: false
    });


const $6539e688c217108a$export$f2cf147a5850af7e = [
    (0, $apqRF.createEntry)((0, $864b735c7a57a8e0$export$6395086ce7e72e37), {
        ufoName: 'admin.jsm-authentication-settings',
        component: (0, $2d2f0d7c6647391c$export$2e2bcd8739ae039),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $7okz2.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
            (0, $d2cDI.jsmCustomerAuthenticationSettingsResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $2d2f0d7c6647391c$export$6cd59b0135f3fe86)
        ]
    })
];



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $7okz2 = parcelRequire("7okz2");

var $apqRF = parcelRequire("apqRF");

var $eUcUT = parcelRequire("eUcUT");
var $fdikA = parcelRequire("fdikA");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $a4a38d0701c0eb81$export$b97e3b6231be8149 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).PRODUCTS_JSM_CUSTOMER_ACCESS,
    path: '/jira/settings/products/servicedesk/customer-access',
    exact: true
};



var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $975754e951894e46$export$1ae94ce2cc225b3d = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("3ZIr5"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/customer-access/src/index.tsx"
});
const $975754e951894e46$export$fce5e73f94a6878 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $975754e951894e46$export$1ae94ce2cc225b3d,
        pageId: "spa-apps/admin-pages/customer-access",
        shouldShowSpinner: false
    });
const $975754e951894e46$export$15a1d95a862eb682 = [
    (0, $apqRF.createEntry)((0, $a4a38d0701c0eb81$export$b97e3b6231be8149), {
        ufoName: 'admin.jsm-customer-access',
        component: $975754e951894e46$export$fce5e73f94a6878,
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $7okz2.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProductsSettingResource)(),
            (0, $fdikA.jsmGlobalCustomerAccessSettingsResource),
            (0, $eUcUT.jsmGlobalCustomerAccessAffectedProjectsResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            $975754e951894e46$export$1ae94ce2cc225b3d
        ]
    })
];



var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $exb0h = parcelRequire("exb0h");
const $06c176f3dee7edd0$export$774dc60e785b8ae8 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_ISSUES_NEW_ISSUE_SEARCH,
    path: '/jira/settings/issues/new-issue-search-transition'
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $7efc2490c799cfed$export$aa5e318abd957ad = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("djTwl"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/new-issue-search-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7efc2490c799cfed$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7efc2490c799cfed$export$aa5e318abd957ad,
        pageId: "jira-admin-pages-new-issue-search-transition",
        shouldShowSpinner: true
    });


const $0309b5ec06bbad8a$export$8f3854f8ef3c4116 = [
    (0, $apqRF.createEntry)((0, $06c176f3dee7edd0$export$774dc60e785b8ae8), {
        ufoName: 'admin.new-issue-search-transition',
        component: (0, $7efc2490c799cfed$export$2e2bcd8739ae039),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $4JtEo.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7efc2490c799cfed$export$aa5e318abd957ad)
        ],
        canTransitionIn: ()=>true
    })
];



var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $leDf8 = parcelRequire("leDf8");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $aBAel = parcelRequire("aBAel");

var $exb0h = parcelRequire("exb0h");
const $33e8c57e513fab5f$export$2b269dcf51f5a4d3 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_SYSTEM_BULK_MAIL,
    path: '/jira/settings/system/send-email'
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $cf4dc26f651648bb$export$416f8039fbf50bea = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("55Ivd"))), {
    moduleId: "./src/packages/admin-pages/bulk-email/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cf4dc26f651648bb$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $cf4dc26f651648bb$export$416f8039fbf50bea,
        pageId: "jira-admin-pages-bulk-email",
        shouldShowSpinner: true
    });


const $16d73d06eda2fcaa$export$d16163932c3babaa = [
    (0, $apqRF.createEntry)((0, $33e8c57e513fab5f$export$2b269dcf51f5a4d3), {
        component: (0, $cf4dc26f651648bb$export$2e2bcd8739ae039),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $leDf8.SidebarGlobalSettingsSystem)
        },
        layout: (0, $efFTI.globalSettingsLayout),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $aBAel.getOfferingCatalogueFeaturesResource)(),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $cf4dc26f651648bb$export$416f8039fbf50bea)
        ]
    })
];



var $cernH = parcelRequire("cernH");

var $dnJL9 = parcelRequire("dnJL9");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $fI7ei = parcelRequire("fI7ei");

var $exb0h = parcelRequire("exb0h");
const $a6e33a090d141e00$export$677fc3a2086479d2 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_PERFORMANCE_OVERVIEW,
    path: '/jira/settings/system/performance/overview'
};
const $a6e33a090d141e00$export$d4f7a24791f8b506 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_PERFORMANCE_METRIC_DETAIL,
    path: '/jira/settings/system/performance/metric/:metricKey'
};
const $a6e33a090d141e00$export$198b0dea5bcb104d = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_PERFORMANCE_CUSTOM_FIELD,
    path: '/jira/settings/system/performance/metrics/customfield'
};
const $a6e33a090d141e00$export$a615b79ae9fb06e5 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_PERFORMANCE_ISSUE,
    path: '/jira/settings/system/performance/metrics/issue'
};
const $a6e33a090d141e00$export$c81695f590e65a42 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_PERFORMANCE_PROJECT_ROLE_ACTOR,
    path: '/jira/settings/system/performance/metrics/projectroleactor'
};
const $a6e33a090d141e00$export$c0d3487a9dc79ff3 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_PERFORMANCE_PROJECT_CLEANUP,
    path: '/jira/settings/system/performance/metrics/projectCleanup'
};



var $dgH3j = parcelRequire("dgH3j");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $6f7e39a2842f472d$export$18dc438c2920830 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("aI3ha"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/performance/metric-detail/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6f7e39a2842f472d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $6f7e39a2842f472d$export$18dc438c2920830,
        pageId: "system-performance-metric-detail",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $0f93f795403e872a$export$d323aa888b5be0c2 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("18rXi"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/performance/metric-detail-custom-field/src/index.tsx"
});
const $0f93f795403e872a$export$446bf9be075b3cb = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $0f93f795403e872a$export$d323aa888b5be0c2,
        pageId: "system-performance-metric-detail-custom-field",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $771fa191123b7cd0$export$e44cbefb7c57e031 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("hesaP"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/performance/metric-detail-issue/src/index.tsx"
});
const $771fa191123b7cd0$export$30b22d5292fcd86f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $771fa191123b7cd0$export$e44cbefb7c57e031,
        pageId: "system-performance-metric-detail-issue",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $f2c29bc8b35211e8$export$a02cb3bfa11d0dc0 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("6CDcO"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/performance/metric-detail-project-cleanup/src/index.tsx"
});
const $f2c29bc8b35211e8$export$2adb5abd6651c182 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $f2c29bc8b35211e8$export$a02cb3bfa11d0dc0,
        pageId: "system-performance-metric-detail-project-cleanup",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $d736301ecdb5ddd4$export$41ecfa31d3d81e1c = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("dAw2T"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/performance/metric-detail-project-role-actor/src/index.tsx"
});
const $d736301ecdb5ddd4$export$3c58376b89706313 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $d736301ecdb5ddd4$export$41ecfa31d3d81e1c,
        pageId: "system-performance-metric-detail-project-role-actor",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $1ybV0 = parcelRequire("1ybV0");

var $jMP2a = parcelRequire("jMP2a");

var $kJlBc = parcelRequire("kJlBc");

var $atRHQ = parcelRequire("atRHQ");
function $20aecad5f40673b9$export$2e2bcd8739ae039(Component) {
    return ()=>{
        const [{ match: match }] = (0, $kJlBc.useRouter)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
        (0, $eUqFw.useEffect)(()=>{
            // If we have a metric key in the URL, we know the user has accessed the old route
            // and we should fire an operational analytics event.
            // Once the frequency of this event is 0, we can consider removing the redirect.
            if (match?.params?.metricKey) (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'old-metric-detail-route visited', {
                metricKey: match.params.metricKey
            });
        }, [
            match?.params?.metricKey,
            createAnalyticsEvent
        ]);
        if (match == null || match.params == null || match.params.metricKey == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
            to: "/jira/settings/system/performance/overview"
        });
        if ((0, $1ybV0.ff)('split-metric-detail-routes-from-1-to-3_9hlcc')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
            to: `/jira/settings/system/performance/metrics/${match.params.metricKey}`
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, null);
    };
}



var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $atRHQ = parcelRequire("atRHQ");
function $bd2e331ee6330181$export$2e2bcd8739ae039(Component, metricKey) {
    return ()=>{
        if ((0, $1ybV0.ff)('split-metric-detail-routes-from-1-to-3_9hlcc')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
            to: `/jira/settings/system/performance/metric/${metricKey}`
        });
    };
}



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $6e96b35e33f9ab62$export$17b4d4eaede5f445 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("jSVJ3"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/performance/overview/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6e96b35e33f9ab62$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $6e96b35e33f9ab62$export$17b4d4eaede5f445,
        pageId: "system-performance-overview",
        shouldShowSpinner: true
    });


const $e81e98739346c2ae$export$98e757ecbae3f469 = [
    (0, $apqRF.createEntry)((0, $a6e33a090d141e00$export$677fc3a2086479d2), {
        component: (0, $6e96b35e33f9ab62$export$2e2bcd8739ae039),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $bt7QT.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource),
            (0, $fI7ei.metricsOverviewPageResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $6e96b35e33f9ab62$export$17b4d4eaede5f445)
        ]
    }),
    // This is an old route that is not used anymore. It is kept here for backward compatibility.
    (0, $apqRF.createEntry)((0, $a6e33a090d141e00$export$d4f7a24791f8b506), {
        component: (0, $20aecad5f40673b9$export$2e2bcd8739ae039)((0, $6f7e39a2842f472d$export$2e2bcd8739ae039)),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $bt7QT.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $6f7e39a2842f472d$export$18dc438c2920830)
        ]
    }),
    (0, $apqRF.createEntry)((0, $a6e33a090d141e00$export$c0d3487a9dc79ff3), {
        // On FF cleanup of site-optimizer-project-cleanup replace with ProjectCleanupMetricDetail
        component: (0, $dnJL9.componentWithFG)('site-optimizer-project-cleanup', (0, $f2c29bc8b35211e8$export$2adb5abd6651c182), (0, $dgH3j.default)),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $bt7QT.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $f2c29bc8b35211e8$export$a02cb3bfa11d0dc0)
        ]
    }),
    (0, $apqRF.createEntry)((0, $a6e33a090d141e00$export$198b0dea5bcb104d), {
        // On FF cleanup of split-metric-detail-routes-from-1-to-3_9hlcc replace with CustomFieldMetricDetail
        component: (0, $bd2e331ee6330181$export$2e2bcd8739ae039)((0, $0f93f795403e872a$export$446bf9be075b3cb), 'customField'),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $bt7QT.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $0f93f795403e872a$export$d323aa888b5be0c2)
        ]
    }),
    (0, $apqRF.createEntry)((0, $a6e33a090d141e00$export$a615b79ae9fb06e5), {
        // On FF cleanup of split-metric-detail-routes-from-1-to-3_9hlcc replace with IssueMetricDetail
        component: (0, $bd2e331ee6330181$export$2e2bcd8739ae039)((0, $771fa191123b7cd0$export$30b22d5292fcd86f), 'issue'),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $bt7QT.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $771fa191123b7cd0$export$e44cbefb7c57e031)
        ]
    }),
    (0, $apqRF.createEntry)((0, $a6e33a090d141e00$export$c81695f590e65a42), {
        // On FF cleanup of split-metric-detail-routes-from-1-to-3_9hlcc replace with ProjectRoleActorMetricDetail
        component: (0, $bd2e331ee6330181$export$2e2bcd8739ae039)((0, $d736301ecdb5ddd4$export$3c58376b89706313), 'projectroleactor'),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $bt7QT.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $d736301ecdb5ddd4$export$41ecfa31d3d81e1c)
        ]
    })
];



var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $apqRF = parcelRequire("apqRF");

var $bWR2E = parcelRequire("bWR2E");
var $i4OkI = parcelRequire("i4OkI");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $exb0h = parcelRequire("exb0h");
const $c84f82624ae4466a$export$d57f448badd0561f = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_EDIT_PERMISSION_SCHEMES,
    path: '/jira/settings/issues/permission-schemes/:schemeId'
};
const $c84f82624ae4466a$export$ceade8e040291782 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_PERMISSION_SCHEMES,
    path: '/jira/settings/issues/permission-schemes-new/:schemeId'
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $238d4cd8561efc3d$export$4549705b02900c32 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("7NwT6"))), {
    moduleId: "./src/packages/permissions-administration/pages/edit-permission-scheme/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$238d4cd8561efc3d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $238d4cd8561efc3d$export$4549705b02900c32,
        pageId: "jira-edit-permission-scheme",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $61b2c43d81902f10$export$f7fcf8304eb17dda = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("fiAjY"))), {
    moduleId: "./src/packages/permissions-administration/pages/permission-scheme/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$61b2c43d81902f10$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $61b2c43d81902f10$export$f7fcf8304eb17dda,
        pageId: "jira-permission-scheme",
        shouldShowSpinner: true
    });


const $86aa54873b5e4d35$export$ac0fc473d7d21da1 = [
    (0, $apqRF.createEntry)((0, $c84f82624ae4466a$export$d57f448badd0561f), {
        ufoName: 'global-admin.issues.configure-permission-scheme',
        component: (0, $238d4cd8561efc3d$export$2e2bcd8739ae039),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $4JtEo.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource),
            (0, $bWR2E.editPermissionSchemePageResource)
        ],
        canTransitionIn: ()=>true,
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $238d4cd8561efc3d$export$4549705b02900c32)
        ],
        meta: {
            reporting: {
                id: 'EditPermissionScheme',
                packageName: 'jiraAdminPagesEditPermissionScheme',
                teamName: 'olympus'
            }
        }
    }),
    (0, $apqRF.createEntry)((0, $c84f82624ae4466a$export$ceade8e040291782), {
        ufoName: 'global-admin.issues.configure-permission-scheme',
        component: (0, $61b2c43d81902f10$export$2e2bcd8739ae039),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $4JtEo.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource),
            (0, $i4OkI.permissionSchemePageResource)
        ],
        canTransitionIn: ()=>true,
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $61b2c43d81902f10$export$f7fcf8304eb17dda)
        ],
        meta: {
            reporting: {
                id: 'PermissionScheme',
                packageName: 'jiraAdminPagesPermissionScheme',
                teamName: 'olympus'
            }
        }
    })
];



var $bAQOb = parcelRequire("bAQOb");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $415HX = parcelRequire("415HX");

var $dgH3j = parcelRequire("dgH3j");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $75740b050e620f30$export$2b5843205130631c = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("8LAAS"))), {
    moduleId: "./src/packages/admin-pages/priorities/src/index.tsx"
});
const $75740b050e620f30$var$PrioritiesPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $75740b050e620f30$export$2b5843205130631c,
        pageId: "jira-admin-pages-priorities",
        shouldShowSpinner: true
    });
var $75740b050e620f30$export$2e2bcd8739ae039 = $75740b050e620f30$var$PrioritiesPage;



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $a46153459398e263$export$20bb8a3b40a3add4 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("wDgHY"))), {
    moduleId: "./src/packages/admin-pages/priority-schemes/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a46153459398e263$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $a46153459398e263$export$20bb8a3b40a3add4,
        pageId: "jira-admin-pages-priority-schemes",
        shouldShowSpinner: true
    });


const $32e3d440eb88e6f8$export$cd38898806de0f08 = [
    (0, $apqRF.createEntry)((0, $415HX.globalSettingsIssuesPrioritiesRoute), {
        component: (0, $bAQOb.componentWithFF)('priorities.per.project.new-priorities-page', (0, $75740b050e620f30$export$2e2bcd8739ae039), (0, $dgH3j.default)),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $4JtEo.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $75740b050e620f30$export$2b5843205130631c)
        ]
    }),
    (0, $apqRF.createEntry)((0, $415HX.globalSettingsIssuesPrioritySchemesRoute), {
        component: (0, $bAQOb.componentWithFF)('priorities.per.project', (0, $a46153459398e263$export$2e2bcd8739ae039), (0, $dgH3j.default)),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $4JtEo.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $a46153459398e263$export$20bb8a3b40a3add4)
        ]
    })
];



var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $exb0h = parcelRequire("exb0h");
const $3074b8c45ab4668d$export$6633247975d81f28 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_FORM_DATA_CONNECTIONS,
    path: '/jira/settings/forms/data-connections'
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $f5374854697f8a1a$export$a81885366284dc75 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("kyDk6"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/proforma/data-connections/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f5374854697f8a1a$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $f5374854697f8a1a$export$a81885366284dc75,
        pageId: "jira-admin-pages-forms-data-connections",
        shouldShowSpinner: true
    });


const $a7982332a48ff6de$export$2763334cca1560d7 = [
    (0, $apqRF.createEntry)((0, $3074b8c45ab4668d$export$6633247975d81f28), {
        component: (0, $f5374854697f8a1a$export$2e2bcd8739ae039),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $4JtEo.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $f5374854697f8a1a$export$a81885366284dc75)
        ]
    })
];



var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $exb0h = parcelRequire("exb0h");
const $589aed3f66931630$export$197fd5d0ee709ca4 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS,
    path: '/jira/settings/issues/screens'
};
const $589aed3f66931630$export$3c5a0cf6ecc1bdf1 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES,
    path: '/jira/settings/issues/screen-schemes'
};
const $589aed3f66931630$export$df93a4addc359237 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES,
    path: '/jira/settings/issues/issue-type-screen-schemes'
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $50c3458bd150401b$export$350edfb57b335a57 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("7Eg2g"))), {
    moduleId: "./src/packages/admin-pages/screens/issue-type-screen-schemes-page/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$50c3458bd150401b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $50c3458bd150401b$export$350edfb57b335a57,
        pageId: "jira-admin-pages-issue-type-screen-schemes-page",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $65b62be276283c61$export$342ae41503f611f1 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("7g4KV"))), {
    moduleId: "./src/packages/admin-pages/screens/screen-schemes-page/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$65b62be276283c61$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $65b62be276283c61$export$342ae41503f611f1,
        pageId: "jira-admin-pages-screen-schemes-page",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $11214c2fba69fbea$export$f4e6d546d7f2894c = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("9P8cz"))), {
    moduleId: "./src/packages/admin-pages/screens/screens-page/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$11214c2fba69fbea$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $11214c2fba69fbea$export$f4e6d546d7f2894c,
        pageId: "jira-admin-pages-screens-page",
        shouldShowSpinner: true
    });


const $bd05fba4111b1685$export$75afafbdb2230f9 = [
    (0, $apqRF.createEntry)((0, $589aed3f66931630$export$197fd5d0ee709ca4), {
        ufoName: 'global-admin.issues.screens',
        component: (0, $11214c2fba69fbea$export$2e2bcd8739ae039),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $4JtEo.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $11214c2fba69fbea$export$f4e6d546d7f2894c)
        ]
    }),
    (0, $apqRF.createEntry)((0, $589aed3f66931630$export$3c5a0cf6ecc1bdf1), {
        ufoName: 'global-admin.issues.screen-schemes',
        component: (0, $65b62be276283c61$export$2e2bcd8739ae039),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $4JtEo.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $65b62be276283c61$export$342ae41503f611f1)
        ]
    }),
    (0, $apqRF.createEntry)((0, $589aed3f66931630$export$df93a4addc359237), {
        ufoName: 'global-admin.issues.issue-type-screen-schemes',
        component: (0, $50c3458bd150401b$export$2e2bcd8739ae039),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $4JtEo.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $50c3458bd150401b$export$350edfb57b335a57)
        ]
    })
];



var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $87SmV = parcelRequire("87SmV");

var $kcaE4 = parcelRequire("kcaE4");

var $eUqFw = parcelRequire("eUqFw");

var $atRHQ = parcelRequire("atRHQ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e8506fb65690d7c5$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
        to: "/jira/settings/system/general-configuration"
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $d9bedf0f0026de5c$export$c452a8c622781ccd = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("7WDU5"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/system-configuration-general/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d9bedf0f0026de5c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $d9bedf0f0026de5c$export$c452a8c622781ccd,
        pageId: "system-configuration-general",
        shouldShowSpinner: false
    });


const $c3b74d1b43e0bee0$export$e8714add09855505 = [
    (0, $apqRF.createEntry)((0, $kcaE4.systemConfigurationRoute), {
        component: (0, $d9bedf0f0026de5c$export$2e2bcd8739ae039),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $bt7QT.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource),
            (0, $87SmV.systemConfigurationGeneralResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $d9bedf0f0026de5c$export$c452a8c622781ccd)
        ]
    }),
    (0, $apqRF.createEntry)((0, $kcaE4.routeNamesSystemConfigurationRedirectRoute), {
        component: (0, $e8506fb65690d7c5$export$2e2bcd8739ae039),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $bt7QT.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource),
            (0, $87SmV.systemConfigurationGeneralResource)
        ]
    })
];



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $bt7QT = parcelRequire("bt7QT");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $exb0h = parcelRequire("exb0h");
const $8e18691fffc56315$export$20631ff3b13dafc0 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_SYSTEM_UI_ANNOUNCEMENT_BANNER,
    path: '/jira/settings/system/ui/announcement-banner'
};



var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $292b65d10be54418$export$3c41e9fc9ec0d170 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("hWz10"))), {
    moduleId: "./src/packages/spa-apps/admin-pages/system/ui/announcement-banner/src/index.tsx"
});
const $292b65d10be54418$export$eb84257d269db72c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $292b65d10be54418$export$3c41e9fc9ec0d170,
        pageId: "admin-pages-system-ui-announcement-banner",
        shouldShowSpinner: true
    });
const $292b65d10be54418$export$7b7dd85536177527 = [
    (0, $apqRF.createEntry)((0, $8e18691fffc56315$export$20631ff3b13dafc0), {
        ufoName: 'global-admin.system.ui.announcement-banner',
        component: $292b65d10be54418$export$eb84257d269db72c,
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $bt7QT.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            $292b65d10be54418$export$3c41e9fc9ec0d170
        ]
    })
];



var $cV7Hm = parcelRequire("cV7Hm");

var $cernH = parcelRequire("cernH");

var $efFTI = parcelRequire("efFTI");

var $7vTKl = parcelRequire("7vTKl");

var $4JtEo = parcelRequire("4JtEo");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $9CFDS = parcelRequire("9CFDS");

var $exb0h = parcelRequire("exb0h");
const $586860c5637a3c41$export$9d533f08a4447cc = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_ISSUE_WORKFLOW_EDIT,
    path: '/jira/settings/issues/workflows/:workflowId'
};
const $586860c5637a3c41$export$f8f2a617a2f4d53 = {
    group: (0, $exb0h.ROUTE_GROUPS).GLOBAL_SETTINGS,
    name: (0, $exb0h.ROUTE_NAMES).GLOBAL_SETTINGS_ISSUE_WORKFLOW,
    path: '/jira/settings/issues/workflows'
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $d4f17224fb536c43$export$cb79ebb337a95317 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("lbi7V"))), {
    moduleId: "./src/packages/admin-pages/workflows/edit-workflow/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d4f17224fb536c43$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $d4f17224fb536c43$export$cb79ebb337a95317,
        pageId: "jira-admin-pages-edit-workflow",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $b126a36b78f97fb9$export$4c64b4f1ecf22fc8 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("12Iu6"))), {
    moduleId: "./src/packages/admin-pages/workflows/list-workflows/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b126a36b78f97fb9$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $b126a36b78f97fb9$export$4c64b4f1ecf22fc8,
        pageId: "jira-admin-pages-list-workflows",
        shouldShowSpinner: true
    });


const $15f0e9867b3e1aec$export$401ea91784469e3a = [
    (0, $apqRF.createEntry)((0, $586860c5637a3c41$export$9d533f08a4447cc), {
        ufoName: 'global-admin.issues.edit-workflow',
        component: (0, $d4f17224fb536c43$export$2e2bcd8739ae039),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $4JtEo.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $d4f17224fb536c43$export$cb79ebb337a95317)
        ]
    }),
    (0, $apqRF.createEntry)((0, $586860c5637a3c41$export$f8f2a617a2f4d53), {
        ufoName: 'global-admin.issues.view-workflows',
        component: (0, $b126a36b78f97fb9$export$2e2bcd8739ae039),
        layout: (0, $efFTI.globalSettingsLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).SETTINGS,
            sidebar: (0, $4JtEo.default)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $9CFDS.navigationSidebarGlobalResource),
            (0, $cV7Hm.default)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $b126a36b78f97fb9$export$4c64b4f1ecf22fc8)
        ]
    })
];


const $b4bce7e4d8567b3c$export$c9b96dd6f5a7b454 = [
    ...(0, $bd05fba4111b1685$export$75afafbdb2230f9),
    ...(0, $15f0e9867b3e1aec$export$401ea91784469e3a),
    ...(0, $653716d20d53efbb$export$84bb32992a534053),
    ...(0, $021c609a71aef057$export$1ca91576d82f7098),
    ...(0, $292b65d10be54418$export$7b7dd85536177527),
    ...(0, $975754e951894e46$export$15a1d95a862eb682),
    ...(0, $6539e688c217108a$export$f2cf147a5850af7e),
    ...(0, $16d73d06eda2fcaa$export$d16163932c3babaa),
    ...(0, $86aa54873b5e4d35$export$ac0fc473d7d21da1),
    ...(0, $a7982332a48ff6de$export$2763334cca1560d7),
    ...(0, $0309b5ec06bbad8a$export$8f3854f8ef3c4116),
    ...(0, $e81e98739346c2ae$export$98e757ecbae3f469),
    ...(0, $32e3d440eb88e6f8$export$cd38898806de0f08),
    ...(0, $bb9b0d3ef4010bcb$export$db45b991e5ee3460),
    ...(0, $c3b74d1b43e0bee0$export$e8714add09855505),
    ...(0, $56d0c84c95c21918$export$c535ef4656da2cd9),
    ...(0, $fc291bfad8a02cf2$export$e3943daecc3985cb)
];



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $cernH = parcelRequire("cernH");

var $b3nmi = parcelRequire("b3nmi");

var $iZnNg = parcelRequire("iZnNg");


var $7vTKl = parcelRequire("7vTKl");


var $l90Gp = parcelRequire("l90Gp");
var $iivTa = parcelRequire("iivTa");
var $cbmC6 = parcelRequire("cbmC6");
var $kXWpU = parcelRequire("kXWpU");
var $eJCK9 = parcelRequire("eJCK9");

var $9urUx = parcelRequire("9urUx");

var $apqRF = parcelRequire("apqRF");
var $kJlBc = parcelRequire("kJlBc");

var $4qvmP = parcelRequire("4qvmP");

var $hHrVM = parcelRequire("hHrVM");

var $l6RYU = parcelRequire("l6RYU");

var $gF5SK = parcelRequire("gF5SK");

var $ixwgj = parcelRequire("ixwgj");

var $gUycq = parcelRequire("gUycq");

var $aHr8P = parcelRequire("aHr8P");

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $293f4e39ffc7b86c$export$1389a6ddf34f642e = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("cNd0M")), {
        moduleId: "83e2f2c2"
    }),
    getPreloadProps: ()=>({})
});



var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");
const $e3dc9036898dfae5$var$approvalsProjectSettingsPageEntryPoint = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $293f4e39ffc7b86c$export$1389a6ddf34f642e),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});
const $e3dc9036898dfae5$var$getNavigationSidebarProjectResource = ()=>[
        (0, $ixwgj.projectContextResource),
        (0, $l90Gp.forgeProjectModuleResource),
        (0, $eJCK9.staticSidebarShortcutsResource),
        (0, $kXWpU.staticProjectSidebarNavigationResource),
        (0, $cbmC6.staticProjectSidebarConnectAddonsNavigationResource)
    ];
const $e3dc9036898dfae5$var$getNavigationSidebarProjectSettingsResource = ()=>[
        (0, $gF5SK.newIssueViewTransitionLockInStatusResource),
        (0, $l6RYU.navigationSidebarAutomationLegacyEnabledResource),
        (0, $ixwgj.projectContextResourceWithCache),
        (0, $l90Gp.forgeProjectSettingsModuleResource),
        (0, $iivTa.staticProjectSettingsSidebarConnectAddonsNavigationResource)
    ];

const $e3dc9036898dfae5$var$LazyIssueTypeSettings = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("aK8GH"))), {
    moduleId: "./src/packages/spa-apps/project-settings/issue-type/src/index.tsx"
});
const $e3dc9036898dfae5$export$b6450e98f3b2e500 = ({ match: match })=>{
    const { issueTypeId: issueTypeId } = match.params;
    // unique pageId need to be set so that ApdexProvider would properly reset all the performance marks when switching between issue types
    const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e3dc9036898dfae5$var$LazyIssueTypeSettings,
        pageId: pageId,
        shouldShowSpinner: false
    });
};

const $e3dc9036898dfae5$var$LazyWorkflowNavigationSettings = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("fOSDf"))), {
    moduleId: "./src/packages/spa-apps/project-settings/workflow-navigation/src/index.tsx"
});
const $e3dc9036898dfae5$export$2fc344606596921e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e3dc9036898dfae5$var$LazyWorkflowNavigationSettings,
        pageId: "project-settings-workflow-navigation",
        shouldShowSpinner: false
    });

const $e3dc9036898dfae5$var$LazyConnectAppsSettings = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("9Jszy"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-apps/src/index.tsx"
});
const $e3dc9036898dfae5$export$a9e7f90b84deda9f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e3dc9036898dfae5$var$LazyConnectAppsSettings,
        pageId: "project-settings-connect-apps",
        shouldShowSpinner: false
    });

const $e3dc9036898dfae5$var$LazyConnectAppControlsSettings = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("ipeZB"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-app-controls/src/index.tsx"
});
const $e3dc9036898dfae5$export$ceddc4fc7b9c0729 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e3dc9036898dfae5$var$LazyConnectAppControlsSettings,
        pageId: "project-settings-connect-app-controls",
        shouldShowSpinner: false
    });

const $e3dc9036898dfae5$var$LazyDetailsSettings = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("kF9mA"))), {
    moduleId: "./src/packages/spa-apps/project-settings/details/src/index.tsx"
});
const $e3dc9036898dfae5$export$3e8048d3cf2ba3fd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e3dc9036898dfae5$var$LazyDetailsSettings,
        pageId: "project-settings-details",
        shouldShowSpinner: false
    });

const $e3dc9036898dfae5$var$LazyPeopleSettings = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("jDthY"))), {
    moduleId: "./src/packages/spa-apps/project-settings/people/src/index.tsx"
});
const $e3dc9036898dfae5$export$3026e5a52c747d2c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e3dc9036898dfae5$var$LazyPeopleSettings,
        pageId: "project-settings-people",
        shouldShowSpinner: false
    });

const $e3dc9036898dfae5$var$LazyProjectSettingsProformaProjectForms = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("7w1w9")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-project-forms/src/index.tsx"
});
const $e3dc9036898dfae5$export$4963607e49ab309f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e3dc9036898dfae5$var$LazyProjectSettingsProformaProjectForms,
        pageId: "project-settings-proforma-project-forms",
        shouldShowSpinner: true
    });

const $e3dc9036898dfae5$var$LazyProjectSettingsProformaJiraFormBuilder = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("gBOWH")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-jira-form-builder/src/index.tsx"
});
const $e3dc9036898dfae5$export$c32892afcc1da510 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e3dc9036898dfae5$var$LazyProjectSettingsProformaJiraFormBuilder,
        pageId: "project-settings-proforma-jira-form-builder",
        shouldShowSpinner: true
    });

const $e3dc9036898dfae5$var$LazyProjectSettingsJiraAutomation = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("lVOgJ")), {
    moduleId: "./src/packages/spa-apps/project-settings/jira-automation/src/index.tsx"
});
const $e3dc9036898dfae5$export$132a1e91790bf469 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e3dc9036898dfae5$var$LazyProjectSettingsJiraAutomation,
        pageId: "project-settings-jira-automation",
        shouldShowSpinner: true
    });

const $e3dc9036898dfae5$var$LazyDataClassificationsSettings = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("kSdpO"))), {
    moduleId: "./src/packages/spa-apps/project-settings/data-classifications/src/index.tsx"
});
const $e3dc9036898dfae5$export$a325b082c894541b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e3dc9036898dfae5$var$LazyDataClassificationsSettings,
        pageId: "project-settings-data-classifications",
        shouldShowSpinner: false
    });

const $e3dc9036898dfae5$var$LazyNotificationsSettings = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("1ZzTg"))), {
    moduleId: "./src/packages/spa-apps/project-settings/software-notifications/src/index.tsx"
});
const $e3dc9036898dfae5$export$36ba2f559d49a8f6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e3dc9036898dfae5$var$LazyNotificationsSettings,
        pageId: "project-settings-software-notifications",
        shouldShowSpinner: false
    });

const $e3dc9036898dfae5$var$LazyProjectSettingsNotificationEmail = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("gcJQi"))), {
    moduleId: "./src/packages/spa-apps/project-settings/notification-email/src/index.tsx"
});
const $e3dc9036898dfae5$export$90c2f52b54888c20 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e3dc9036898dfae5$var$LazyProjectSettingsNotificationEmail,
        pageId: "project-settings-email-notifications",
        shouldShowSpinner: true
    });

const $e3dc9036898dfae5$var$LazyForgeProjectSettingsPage = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("51l6H")), {
    moduleId: "./src/packages/spa-apps/forge/project-settings/src/index.tsx"
});
const $e3dc9036898dfae5$export$b943f48844c671a5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e3dc9036898dfae5$var$LazyForgeProjectSettingsPage,
        pageId: "forge-spa-project-settings",
        shouldShowSpinner: true
    });
const $e3dc9036898dfae5$export$df1c02c3f28b7a95 = (0, $apqRF.createEntry)((0, $gUycq.projectSettingsCoreDefaultRedirectRoute), {
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $9urUx.default),
        horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
    },
    layout: (0, $iZnNg.coreProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectResource(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectSettingsResource(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ],
    component: ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
            to: `/jira/core/projects/${String(match.params.projectKey)}/settings/details`
        }),
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation)
    ]
});
const $e3dc9036898dfae5$export$95ecbacf0120fcfd = (0, $apqRF.createEntry)((0, $gUycq.projectSettingsCoreIssueTypesRoute), {
    exact: true,
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $9urUx.default),
        horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
    },
    layout: (0, $iZnNg.coreProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectResource(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectSettingsResource(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ],
    component: $e3dc9036898dfae5$export$b6450e98f3b2e500,
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $e3dc9036898dfae5$var$LazyIssueTypeSettings
    ]
});
const $e3dc9036898dfae5$export$1dfd4811b9065dd6 = (0, $apqRF.createEntry)((0, $gUycq.projectSettingsCoreIssueTypesWorkflowRoute), {
    exact: true,
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $9urUx.default),
        horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
    },
    layout: (0, $iZnNg.coreProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectResource(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectSettingsResource(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ],
    component: $e3dc9036898dfae5$export$2fc344606596921e,
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $e3dc9036898dfae5$var$LazyWorkflowNavigationSettings
    ]
});
const $e3dc9036898dfae5$export$c038a2892f34f1a9 = (0, $apqRF.createEntry)((0, $gUycq.projectSettingsCoreAppsRoute), {
    exact: true,
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $9urUx.default),
        horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
    },
    layout: (0, $iZnNg.coreProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectResource(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectSettingsResource(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ],
    component: $e3dc9036898dfae5$export$a9e7f90b84deda9f,
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $e3dc9036898dfae5$var$LazyConnectAppsSettings
    ]
});
const $e3dc9036898dfae5$export$7870a0b1630a504e = (0, $apqRF.createEntry)((0, $gUycq.projectSettingsCoreAppsFieldsRoute), {
    exact: true,
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $9urUx.default),
        horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
    },
    layout: (0, $iZnNg.coreProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectResource(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectSettingsResource(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ],
    component: $e3dc9036898dfae5$export$ceddc4fc7b9c0729,
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $e3dc9036898dfae5$var$LazyConnectAppControlsSettings
    ]
});
const $e3dc9036898dfae5$export$438a330ccc1e7a91 = (0, $apqRF.createEntry)((0, $gUycq.projectSettingsCoreDetailsRoute), {
    exact: true,
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $9urUx.default),
        horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
    },
    layout: (0, $iZnNg.coreProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectResource(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectSettingsResource(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ],
    component: $e3dc9036898dfae5$export$3e8048d3cf2ba3fd,
    skeleton: (0, $aHr8P.ProjectSettingsDetailsSkeleton),
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $e3dc9036898dfae5$var$LazyDetailsSettings
    ]
});
const $e3dc9036898dfae5$export$8188648c76953df0 = (0, $apqRF.createEntry)((0, $gUycq.projectSettingsCoreAccessRoute), {
    exact: true,
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $9urUx.default),
        horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
    },
    layout: (0, $iZnNg.coreProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectResource(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectSettingsResource(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ],
    component: $e3dc9036898dfae5$export$3026e5a52c747d2c,
    skeleton: (0, $aHr8P.ProjectSettingsAccessSkeleton),
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $e3dc9036898dfae5$var$LazyPeopleSettings
    ],
    ufoName: 'project-settings.access'
});
const $e3dc9036898dfae5$export$36e1851c22975fc0 = (0, $apqRF.createEntry)((0, $gUycq.projectSettingsCoreAccessRedirectRoute), {
    exact: true,
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $9urUx.default),
        horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
    },
    layout: (0, $iZnNg.coreProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectResource(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectSettingsResource(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ],
    component: ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
            to: `/jira/core/projects/${String(match.params.projectKey)}/settings/access`,
            push: false
        }),
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $e3dc9036898dfae5$var$LazyPeopleSettings
    ]
});
const $e3dc9036898dfae5$export$5e9e27f116094fdf = (0, $apqRF.createEntry)((0, $gUycq.projectSettingsCoreProformaProjectFormsRoute), {
    exact: true,
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $9urUx.default),
        horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
    },
    layout: (0, $iZnNg.coreProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectResource(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectSettingsResource(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ],
    component: $e3dc9036898dfae5$export$4963607e49ab309f,
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $e3dc9036898dfae5$var$LazyProjectSettingsProformaProjectForms
    ],
    perfMetricKey: 'forms-settings'
});
const $e3dc9036898dfae5$export$46d6b55ebf21ccc = (0, $apqRF.createEntry)((0, $gUycq.projectSettingsCoreProformaJiraFormBuilderRoute), {
    exact: true,
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $9urUx.default),
        horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
    },
    layout: (0, $iZnNg.coreProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectResource(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectSettingsResource(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ],
    component: $e3dc9036898dfae5$export$c32892afcc1da510,
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $e3dc9036898dfae5$var$LazyProjectSettingsProformaJiraFormBuilder
    ],
    perfMetricKey: 'form-builder'
});
const $e3dc9036898dfae5$export$a244870e56f5c9a3 = (0, $apqRF.createEntry)((0, $gUycq.projectSettingsCoreAutomationRoute), {
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $9urUx.default),
        horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
    },
    layout: (0, $iZnNg.coreProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectResource(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectSettingsResource(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ],
    component: $e3dc9036898dfae5$export$132a1e91790bf469,
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $e3dc9036898dfae5$var$LazyProjectSettingsJiraAutomation
    ],
    ufoName: 'project-settings-automation-core'
});
const $e3dc9036898dfae5$export$a2c8a6767edeeaed = (0, $apqRF.createEntry)((0, $gUycq.projectSettingsCoreAutomationV2Route), {
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $9urUx.default),
        horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
    },
    layout: (0, $iZnNg.coreProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectResource(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectSettingsResource(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ],
    component: $e3dc9036898dfae5$export$132a1e91790bf469,
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $e3dc9036898dfae5$var$LazyProjectSettingsJiraAutomation
    ]
});
const $e3dc9036898dfae5$export$cf5194c476e8bcdb = (0, $apqRF.createEntry)((0, $gUycq.projectSettingsCoreDataClassificationsRoute), {
    exact: true,
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $9urUx.default),
        horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
    },
    layout: (0, $iZnNg.coreProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectResource(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectSettingsResource(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ],
    component: $e3dc9036898dfae5$export$a325b082c894541b,
    skeleton: (0, $aHr8P.ProjectSettingsDetailsSkeleton),
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation)
    ]
});
const $e3dc9036898dfae5$export$ed481b03aa858542 = (0, $apqRF.createEntry)((0, $gUycq.projectSettingsCoreNotificationsRoute), {
    exact: true,
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $9urUx.default),
        horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
    },
    layout: (0, $iZnNg.coreProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectResource(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectSettingsResource(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ],
    component: $e3dc9036898dfae5$export$36ba2f559d49a8f6,
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $e3dc9036898dfae5$var$LazyNotificationsSettings
    ]
});
const $e3dc9036898dfae5$export$da36a1671d868927 = (0, $apqRF.createEntry)((0, $gUycq.projectSettingsCoreNotificationsEmailRoute), {
    exact: true,
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $9urUx.default),
        horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
    },
    layout: (0, $iZnNg.coreProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectResource(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectSettingsResource(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ],
    component: $e3dc9036898dfae5$export$90c2f52b54888c20,
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $e3dc9036898dfae5$var$LazyProjectSettingsNotificationEmail
    ]
});
const $e3dc9036898dfae5$export$1006fd9f5f02b1c2 = (0, $apqRF.createEntry)((0, $gUycq.projectSettingsCoreForgeAppsRoute), {
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $9urUx.default),
        horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
    },
    layout: (0, $iZnNg.coreProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectResource(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectSettingsResource(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ],
    component: $e3dc9036898dfae5$export$b943f48844c671a5,
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $e3dc9036898dfae5$var$LazyForgeProjectSettingsPage
    ]
});
const $e3dc9036898dfae5$export$728033a86ab68014 = (0, $apqRF.createEntry)((0, $gUycq.projectSettingsCoreApprovalsRoute), {
    exact: true,
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $9urUx.default),
        horizontal: (0, $b3nmi.AsyncHorizontalProjectNav)
    },
    layout: (0, $iZnNg.coreProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectResource(),
        ...$e3dc9036898dfae5$var$getNavigationSidebarProjectSettingsResource(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ],
    entryPoint () {
        return $e3dc9036898dfae5$var$approvalsProjectSettingsPageEntryPoint;
    }
});
const $e3dc9036898dfae5$export$4bad3905623f839b = [
    $e3dc9036898dfae5$export$95ecbacf0120fcfd,
    $e3dc9036898dfae5$export$1dfd4811b9065dd6,
    $e3dc9036898dfae5$export$7870a0b1630a504e,
    $e3dc9036898dfae5$export$c038a2892f34f1a9,
    $e3dc9036898dfae5$export$438a330ccc1e7a91,
    $e3dc9036898dfae5$export$8188648c76953df0,
    $e3dc9036898dfae5$export$36e1851c22975fc0,
    $e3dc9036898dfae5$export$5e9e27f116094fdf,
    $e3dc9036898dfae5$export$46d6b55ebf21ccc,
    $e3dc9036898dfae5$export$a2c8a6767edeeaed,
    $e3dc9036898dfae5$export$cf5194c476e8bcdb,
    $e3dc9036898dfae5$export$a244870e56f5c9a3,
    $e3dc9036898dfae5$export$ed481b03aa858542,
    $e3dc9036898dfae5$export$da36a1671d868927,
    $e3dc9036898dfae5$export$1006fd9f5f02b1c2,
    $e3dc9036898dfae5$export$728033a86ab68014,
    $e3dc9036898dfae5$export$df1c02c3f28b7a95
];



var $cernH = parcelRequire("cernH");

var $exb0h = parcelRequire("exb0h");

var $7vTKl = parcelRequire("7vTKl");


var $iTYGl = parcelRequire("iTYGl");

var $apqRF = parcelRequire("apqRF");

var $dAKwA = parcelRequire("dAKwA");

var $ixwgj = parcelRequire("ixwgj");

var $ct0sQ = parcelRequire("ct0sQ");

var $k82mP = parcelRequire("k82mP");

var $3BZ46 = parcelRequire("3BZ46");

var $k1AKH = parcelRequire("k1AKH");

var $EFSBh = parcelRequire("EFSBh");

var $cernH = parcelRequire("cernH");

var $exb0h = parcelRequire("exb0h");

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $apqRF = parcelRequire("apqRF");

var $dAKwA = parcelRequire("dAKwA");

var $exb0h = parcelRequire("exb0h");
const $5f6fb6d0ff76930d$export$5575497f0592ee94 = 'servicedesk';
const $5f6fb6d0ff76930d$var$projectSettingsUrl = (product)=>`/jira/${product}/projects/:projectKey/settings`;
const $5f6fb6d0ff76930d$export$c581a12a4f58fa26 = {
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-automation-edit-rule`,
    path: `${$5f6fb6d0ff76930d$var$projectSettingsUrl($5f6fb6d0ff76930d$export$5575497f0592ee94)}/automation/ruleset/:ruleId`
};
const $5f6fb6d0ff76930d$export$5b3aca7bf312c9a3 = {
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-automation-copy-rule`,
    path: `${$5f6fb6d0ff76930d$var$projectSettingsUrl($5f6fb6d0ff76930d$export$5575497f0592ee94)}/automation/copy/:ruleId`
};
const $5f6fb6d0ff76930d$export$3b8691f4e10340a9 = {
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-automation-create`,
    path: `${$5f6fb6d0ff76930d$var$projectSettingsUrl($5f6fb6d0ff76930d$export$5575497f0592ee94)}/automation/blueprint/:blueprintKey`
};
const $5f6fb6d0ff76930d$export$e0ddfe5d87fb5601 = {
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-automation-view-log`,
    path: `${$5f6fb6d0ff76930d$var$projectSettingsUrl($5f6fb6d0ff76930d$export$5575497f0592ee94)}/automation/log/:ruleId`
};
const $5f6fb6d0ff76930d$export$3e9315c24fe609c3 = {
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-automation-summary`,
    path: `${$5f6fb6d0ff76930d$var$projectSettingsUrl($5f6fb6d0ff76930d$export$5575497f0592ee94)}/automation`
};



var $csLgO = parcelRequire("csLgO");

var $eUqFw = parcelRequire("eUqFw");

var $kJlBc = parcelRequire("kJlBc");

var $4qvmP = parcelRequire("4qvmP");

var $hHrVM = parcelRequire("hHrVM");

var $kbHFR = parcelRequire("kbHFR");
const $4767bfb777d542fe$export$b7262fe486f4b412 = 'core';
const $4767bfb777d542fe$export$2954328f6207617a = 'software';
const $4767bfb777d542fe$export$5575497f0592ee94 = 'servicedesk';
const $4767bfb777d542fe$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
const $4767bfb777d542fe$export$586756e5c0542a50 = (product)=>{
    if (product === $4767bfb777d542fe$export$5575497f0592ee94) return (0, $kbHFR.getServiceDeskSettingsResources)();
    if (product === $4767bfb777d542fe$export$b7262fe486f4b412) return [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ];
    return [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)()
    ];
};
const $4767bfb777d542fe$export$c9b0516439c55d7a = (product)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
            to: `/jira/${product}/projects/${String(match.params.projectKey)}/settings/details`
        });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $ac421ac495e59f2a$export$4a3b5f6370555dbc = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("9dMiG")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-copy-rule/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ac421ac495e59f2a$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $ac421ac495e59f2a$export$4a3b5f6370555dbc,
        pageId: "project-settings-automation-copy-rule",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $d848b22474133d3f$export$5b197b51eb5ad982 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("fo5Z8")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-create-rule/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d848b22474133d3f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $d848b22474133d3f$export$5b197b51eb5ad982,
        pageId: "project-settings-automation-create-rule",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $3f204af7fc304fe8$export$c1c9a68738a9ab36 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("a27VQ")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-edit-rule/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3f204af7fc304fe8$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $3f204af7fc304fe8$export$c1c9a68738a9ab36,
        pageId: "project-settings-automation-edit-rule",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $cqJw8 = parcelRequire("cqJw8");

var $kJlBc = parcelRequire("kJlBc");

var $6vrw7 = parcelRequire("6vrw7");
const $e693f5ced85029ff$export$39684840f773be1e = (pageType)=>{
    switch(pageType){
        case 'edit':
            return 'ruleset/:ruleId';
        case 'copy':
            return 'copy/:ruleId';
        case 'create':
            return 'blueprint/:blueprintKey';
        case 'viewlog':
            return 'log/:ruleId';
        default:
            return '';
    }
};
const $e693f5ced85029ff$var$newAutomationUrl = (baseUrl, { match: match }, pageType)=>{
    const { projectKey: projectKey } = match.params;
    if (pageType === 'edit') {
        const { ruleId: ruleId } = match.params;
        return `${(0, $cqJw8.getNextgenSettingsUrl)((0, $7ZZxN.SERVICE_DESK_PROJECT), String(projectKey))}/automation/ruleset/${ruleId || ''}`;
    }
    if (pageType === 'copy') {
        const { ruleId: ruleId } = match.params;
        return `${(0, $cqJw8.getNextgenSettingsUrl)((0, $7ZZxN.SERVICE_DESK_PROJECT), String(projectKey))}/automation/copy/${ruleId || ''}`;
    }
    if (pageType === 'viewlog') {
        const { ruleId: ruleId } = match.params;
        return `${(0, $cqJw8.getNextgenSettingsUrl)((0, $7ZZxN.SERVICE_DESK_PROJECT), String(projectKey))}/automation/log/${ruleId || ''}`;
    }
    if (pageType === 'create') {
        const { blueprintKey: blueprintKey } = match.params;
        return `${(0, $cqJw8.getNextgenSettingsUrl)((0, $7ZZxN.SERVICE_DESK_PROJECT), String(projectKey))}/automation/blueprint/${blueprintKey || ''}`;
    }
    return `${(0, $cqJw8.getNextgenSettingsUrl)((0, $7ZZxN.SERVICE_DESK_PROJECT), String(projectKey))}/automation`;
};
const $e693f5ced85029ff$export$d6674bfa636b8090 = (pageType)=>(routeContext)=>{
        // use empty string instead of actual baseUrl as router redirect handles it internally
        const emptyBaseUrl = (0, $6vrw7.toBaseUrl)('');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
            to: $e693f5ced85029ff$var$newAutomationUrl(emptyBaseUrl, routeContext, pageType),
            push: false
        });
    };



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $4e1bf6178cdce58e$export$2fc8c3fcbb365b89 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("dyMhG")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-summary/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4e1bf6178cdce58e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $4e1bf6178cdce58e$export$2fc8c3fcbb365b89,
        pageId: "project-settings-automation-summary",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $66b5660e6d185dcf$export$db6c5cdbc65b2b4a = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("7ukZ5")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-view-log/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$66b5660e6d185dcf$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $66b5660e6d185dcf$export$db6c5cdbc65b2b4a,
        pageId: "project-settings-automation-view-log",
        shouldShowSpinner: true
    });


const $38d72ec77f663f1e$var$getLegacyAutomationRoutesCommon = ()=>({
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $4767bfb777d542fe$export$586756e5c0542a50)((0, $4767bfb777d542fe$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK
    });
const $38d72ec77f663f1e$var$getOldAutomationRouteRedirectRoute = (pageType)=>({
        ...$38d72ec77f663f1e$var$getLegacyAutomationRoutesCommon(),
        name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-automation-redirect-${pageType}`,
        path: `/projects/:projectKey/settings/automation/${(0, $e693f5ced85029ff$export$39684840f773be1e)(pageType)}`,
        forPaint: [],
        component: (0, $e693f5ced85029ff$export$d6674bfa636b8090)(pageType)
    });
const $38d72ec77f663f1e$export$8521f0867b2d52e4 = [
    (0, $apqRF.createEntry)((0, $5f6fb6d0ff76930d$export$c581a12a4f58fa26), {
        ...$38d72ec77f663f1e$var$getLegacyAutomationRoutesCommon(),
        ufoName: 'service-management.automation.edit-rule',
        component: (0, $3f204af7fc304fe8$export$2e2bcd8739ae039),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $3f204af7fc304fe8$export$c1c9a68738a9ab36)
        ]
    }),
    (0, $apqRF.createEntry)((0, $5f6fb6d0ff76930d$export$5b3aca7bf312c9a3), {
        ...$38d72ec77f663f1e$var$getLegacyAutomationRoutesCommon(),
        ufoName: 'service-management.automation.copy-rule',
        component: (0, $ac421ac495e59f2a$export$2e2bcd8739ae039),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $ac421ac495e59f2a$export$4a3b5f6370555dbc)
        ]
    }),
    (0, $apqRF.createEntry)((0, $5f6fb6d0ff76930d$export$3b8691f4e10340a9), {
        ...$38d72ec77f663f1e$var$getLegacyAutomationRoutesCommon(),
        ufoName: 'service-management.automation.create-rule',
        component: (0, $d848b22474133d3f$export$2e2bcd8739ae039),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $d848b22474133d3f$export$5b197b51eb5ad982)
        ]
    }),
    (0, $apqRF.createEntry)((0, $5f6fb6d0ff76930d$export$e0ddfe5d87fb5601), {
        ...$38d72ec77f663f1e$var$getLegacyAutomationRoutesCommon(),
        ufoName: 'service-management.automation.log',
        component: (0, $66b5660e6d185dcf$export$2e2bcd8739ae039),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $66b5660e6d185dcf$export$db6c5cdbc65b2b4a)
        ]
    }),
    (0, $apqRF.createEntry)((0, $5f6fb6d0ff76930d$export$3e9315c24fe609c3), {
        ...$38d72ec77f663f1e$var$getLegacyAutomationRoutesCommon(),
        ufoName: 'service-management.automation.summary',
        component: (0, $4e1bf6178cdce58e$export$2e2bcd8739ae039),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $4e1bf6178cdce58e$export$2fc8c3fcbb365b89)
        ]
    }),
    /* Old urls.
	 * Do not remove these redirects, ever.
	 * Because customers will have bookmarks and saved links and we need them to keep working forever.
	 */ $38d72ec77f663f1e$var$getOldAutomationRouteRedirectRoute('summary'),
    $38d72ec77f663f1e$var$getOldAutomationRouteRedirectRoute('create'),
    $38d72ec77f663f1e$var$getOldAutomationRouteRedirectRoute('edit'),
    $38d72ec77f663f1e$var$getOldAutomationRouteRedirectRoute('copy'),
    $38d72ec77f663f1e$var$getOldAutomationRouteRedirectRoute('viewlog')
];



var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $apqRF = parcelRequire("apqRF");

var $dAKwA = parcelRequire("dAKwA");

var $exb0h = parcelRequire("exb0h");
const $3cae002c727972f0$export$5575497f0592ee94 = 'servicedesk';
const $3cae002c727972f0$var$projectSettingsUrl = (product)=>`/jira/${product}/projects/:projectKey/settings`;
const $3cae002c727972f0$export$eac46d25b0c772c0 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-customer-notifications-classic`,
    path: `${$3cae002c727972f0$var$projectSettingsUrl($3cae002c727972f0$export$5575497f0592ee94)}/customer-notifications`
};
const $3cae002c727972f0$export$688d2c8abd7b3661 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-notifications-customer-notifications`,
    path: `${$3cae002c727972f0$var$projectSettingsUrl($3cae002c727972f0$export$5575497f0592ee94)}/notifications/customer-notifications`
};



var $csLgO = parcelRequire("csLgO");

var $eUqFw = parcelRequire("eUqFw");

var $kJlBc = parcelRequire("kJlBc");

var $4qvmP = parcelRequire("4qvmP");

var $hHrVM = parcelRequire("hHrVM");

var $kbHFR = parcelRequire("kbHFR");
const $6439df9abef17671$export$b7262fe486f4b412 = 'core';
const $6439df9abef17671$export$2954328f6207617a = 'software';
const $6439df9abef17671$export$5575497f0592ee94 = 'servicedesk';
const $6439df9abef17671$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
const $6439df9abef17671$export$586756e5c0542a50 = (product)=>{
    if (product === $6439df9abef17671$export$5575497f0592ee94) return (0, $kbHFR.getServiceDeskSettingsResources)();
    if (product === $6439df9abef17671$export$b7262fe486f4b412) return [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ];
    return [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)()
    ];
};
const $6439df9abef17671$export$c9b0516439c55d7a = (product)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
            to: `/jira/${product}/projects/${String(match.params.projectKey)}/settings/details`
        });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $da92782cf07ad14e$export$c763ea321ade5f68 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("cT94E")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-customer-notifications/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$da92782cf07ad14e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $da92782cf07ad14e$export$c763ea321ade5f68,
        pageId: "project-settings-customer-notifications",
        shouldShowSpinner: true
    });


const $0b9b4e281f9618b2$export$d6bb339f4d05f5c5 = [
    (0, $apqRF.createEntry)((0, $3cae002c727972f0$export$eac46d25b0c772c0), {
        component: (0, $da92782cf07ad14e$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $6439df9abef17671$export$586756e5c0542a50)((0, $6439df9abef17671$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $da92782cf07ad14e$export$c763ea321ade5f68)
        ]
    }),
    (0, $apqRF.createEntry)((0, $3cae002c727972f0$export$688d2c8abd7b3661), {
        component: (0, $da92782cf07ad14e$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $6439df9abef17671$export$586756e5c0542a50)((0, $6439df9abef17671$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $da92782cf07ad14e$export$c763ea321ade5f68)
        ]
    })
];



var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $apqRF = parcelRequire("apqRF");

var $dAKwA = parcelRequire("dAKwA");

var $kbHFR = parcelRequire("kbHFR");

var $exb0h = parcelRequire("exb0h");
const $33a9059fcebe7f73$export$5575497f0592ee94 = 'servicedesk';
const $33a9059fcebe7f73$var$projectSettingsUrl = (product)=>`/jira/${product}/projects/:projectKey/settings`;
const $33a9059fcebe7f73$export$8855316927afaed1 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-kb`,
    path: `${$33a9059fcebe7f73$var$projectSettingsUrl($33a9059fcebe7f73$export$5575497f0592ee94)}/confluence-kb`,
    exact: true
};



var $csLgO = parcelRequire("csLgO");

var $eUqFw = parcelRequire("eUqFw");

var $kJlBc = parcelRequire("kJlBc");

var $4qvmP = parcelRequire("4qvmP");

var $hHrVM = parcelRequire("hHrVM");

var $kbHFR = parcelRequire("kbHFR");
const $6416cdf21853e6c6$export$b7262fe486f4b412 = 'core';
const $6416cdf21853e6c6$export$2954328f6207617a = 'software';
const $6416cdf21853e6c6$export$5575497f0592ee94 = 'servicedesk';
const $6416cdf21853e6c6$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
const $6416cdf21853e6c6$export$586756e5c0542a50 = (product)=>{
    if (product === $6416cdf21853e6c6$export$5575497f0592ee94) return (0, $kbHFR.getServiceDeskSettingsResources)();
    if (product === $6416cdf21853e6c6$export$b7262fe486f4b412) return [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ];
    return [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)()
    ];
};
const $6416cdf21853e6c6$export$c9b0516439c55d7a = (product)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
            to: `/jira/${product}/projects/${String(match.params.projectKey)}/settings/details`
        });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");
const $5a209557cae2ae10$export$3fac45fa34d00981 = 'project/service-desk/settings/index';
const $5a209557cae2ae10$export$1aa47348ef6dbdda = 'project/service-desk/settings';

const $5a209557cae2ae10$export$583a442626bd3345 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("jWtVL")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-knowledge-base/src/index.tsx"
});

const $5a209557cae2ae10$export$7c7186fdd8c56428 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("bnruX"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-settings/src/index.tsx"
});
const $5a209557cae2ae10$export$6d92735e249274bb = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $5a209557cae2ae10$export$7c7186fdd8c56428,
        pageId: "project-settings-knowledge-base",
        shouldShowSpinner: true
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5a209557cae2ae10$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $5a209557cae2ae10$export$583a442626bd3345,
        pageId: "project-settings-knowledge-base",
        shouldShowSpinner: true
    });


const $86d860750863d795$export$f90c0f16cffd8883 = [
    (0, $apqRF.createEntry)((0, $33a9059fcebe7f73$export$8855316927afaed1), {
        perfMetricKey: 'service-management.kb-settings',
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        component: (0, $5a209557cae2ae10$export$6d92735e249274bb),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $5a209557cae2ae10$export$7c7186fdd8c56428)
        ],
        resources: [
            ...(0, $6416cdf21853e6c6$export$586756e5c0542a50)((0, $6416cdf21853e6c6$export$5575497f0592ee94)),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ]
    })
];



var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $apqRF = parcelRequire("apqRF");

var $dAKwA = parcelRequire("dAKwA");

var $ixwgj = parcelRequire("ixwgj");

var $g2JMk = parcelRequire("g2JMk");

var $exb0h = parcelRequire("exb0h");
const $b7932788ec438e72$export$5575497f0592ee94 = 'servicedesk';
const $b7932788ec438e72$var$projectSettingsUrl = (product)=>`/jira/${product}/projects/:projectKey/settings`;
const $b7932788ec438e72$export$bfbf66468910573e = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_SLA_SETTINGS,
    path: `${$b7932788ec438e72$var$projectSettingsUrl($b7932788ec438e72$export$5575497f0592ee94)}/sla/(custom|new)?/:id?/(edit)?`
};



var $csLgO = parcelRequire("csLgO");

var $frZnw = parcelRequire("frZnw");

var $eUqFw = parcelRequire("eUqFw");

var $kJlBc = parcelRequire("kJlBc");

var $4qvmP = parcelRequire("4qvmP");

var $hHrVM = parcelRequire("hHrVM");

var $kbHFR = parcelRequire("kbHFR");
const $fdb4f440b81f61c9$export$b7262fe486f4b412 = 'core';
const $fdb4f440b81f61c9$export$2954328f6207617a = 'software';
const $fdb4f440b81f61c9$export$5575497f0592ee94 = 'servicedesk';
const $fdb4f440b81f61c9$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
const $fdb4f440b81f61c9$export$586756e5c0542a50 = (product)=>{
    if (product === $fdb4f440b81f61c9$export$5575497f0592ee94) return (0, $kbHFR.getServiceDeskSettingsResources)();
    if (product === $fdb4f440b81f61c9$export$b7262fe486f4b412) return [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ];
    return [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)()
    ];
};
const $fdb4f440b81f61c9$export$c9b0516439c55d7a = (product)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
            to: `/jira/${product}/projects/${String(match.params.projectKey)}/settings/details`
        });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

var $jK1pm = parcelRequire("jK1pm");

const $75e8a1d09660963e$export$a6694c07cb5be8c1 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("82IHe"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-sla-settings/src/index.tsx"
});
const $75e8a1d09660963e$export$c56fde3803c5a1a3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "project-settings-service-desk-sla-settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $75e8a1d09660963e$export$a6694c07cb5be8c1,
        pageId: "project-settings-service-desk-sla-settings",
        shouldShowSpinner: true
    }));


const $792114e6a9cd6c10$export$fd1a58e6255623a = [
    (0, $apqRF.createEntry)((0, $b7932788ec438e72$export$bfbf66468910573e), {
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).SLA_SETTINGS,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).SLA_SETTINGS),
                teamName: 'bumblebee'
            }
        },
        perfMetricKey: 'jsm-sla-settings',
        component: (0, $75e8a1d09660963e$export$c56fde3803c5a1a3),
        resources: [
            ...(0, $fdb4f440b81f61c9$export$586756e5c0542a50)((0, $fdb4f440b81f61c9$export$5575497f0592ee94)),
            (0, $ixwgj.projectContextResource),
            (0, $g2JMk.slaMetricsDataResource),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $75e8a1d09660963e$export$a6694c07cb5be8c1)
        ]
    })
];



var $cernH = parcelRequire("cernH");

var $exb0h = parcelRequire("exb0h");

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $apqRF = parcelRequire("apqRF");

var $dAKwA = parcelRequire("dAKwA");

var $6bQqb = parcelRequire("6bQqb");

var $exb0h = parcelRequire("exb0h");
const $ca4e49b79a8433d9$export$5575497f0592ee94 = 'servicedesk';
const $ca4e49b79a8433d9$export$eeb615fb989a6e4d = {
    exact: true,
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-unassigned-ticket-type-fields`,
    path: `/jira/${$ca4e49b79a8433d9$export$5575497f0592ee94}/projects/:projectKey/settings/request-types/unassigned/request-type/:requestTypeId/:tabKey?`
};
const $ca4e49b79a8433d9$export$50e6baca5c1f7a5b = {
    exact: true,
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-itsm-ticket-type-fields`,
    path: `/jira/${$ca4e49b79a8433d9$export$5575497f0592ee94}/projects/:projectKey/settings/request-types/category/:practice/request-type/:requestTypeId/:tabKey?`
};
const $ca4e49b79a8433d9$export$51c2cd63e9954ab7 = {
    exact: true,
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-ticket-type-fields`,
    path: `/jira/${$ca4e49b79a8433d9$export$5575497f0592ee94}/projects/:projectKey/settings/request-types/request-type/:requestTypeId/:tabKey?`
};



var $csLgO = parcelRequire("csLgO");

var $frZnw = parcelRequire("frZnw");

var $eUqFw = parcelRequire("eUqFw");

var $kJlBc = parcelRequire("kJlBc");

var $4qvmP = parcelRequire("4qvmP");

var $hHrVM = parcelRequire("hHrVM");

var $kbHFR = parcelRequire("kbHFR");
const $37132842683d0af2$export$b7262fe486f4b412 = 'core';
const $37132842683d0af2$export$2954328f6207617a = 'software';
const $37132842683d0af2$export$5575497f0592ee94 = 'servicedesk';
const $37132842683d0af2$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
const $37132842683d0af2$export$586756e5c0542a50 = (product)=>{
    if (product === $37132842683d0af2$export$5575497f0592ee94) return (0, $kbHFR.getServiceDeskSettingsResources)();
    if (product === $37132842683d0af2$export$b7262fe486f4b412) return [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ];
    return [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)()
    ];
};
const $37132842683d0af2$export$c9b0516439c55d7a = (product)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
            to: `/jira/${product}/projects/${String(match.params.projectKey)}/settings/details`
        });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $d19d2d8dc261c55c$export$471040ce01e559fc = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("crL4s")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-ticket-type-fields/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d19d2d8dc261c55c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $d19d2d8dc261c55c$export$471040ce01e559fc,
        pageId: "project-settings-ticket-type-fields",
        shouldShowSpinner: true
    });


const $c85fda19a90ea423$var$getTicketTypeFieldsRoutesCommon = ()=>({
        exact: true,
        group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
        component: (0, $d19d2d8dc261c55c$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $37132842683d0af2$export$586756e5c0542a50)((0, $37132842683d0af2$export$5575497f0592ee94)),
            (0, $6bQqb.servicedeskPracticesResource),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $d19d2d8dc261c55c$export$471040ce01e559fc)
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).REQUEST_TYPE_FIELDS,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).REQUEST_TYPE_FIELDS),
                teamName: 'jsd-shield'
            }
        },
        ufoName: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-ticket-type-fields`
    });
const $c85fda19a90ea423$export$caa50198aadcf21c = [
    (0, $apqRF.createEntry)((0, $ca4e49b79a8433d9$export$eeb615fb989a6e4d), {
        ...$c85fda19a90ea423$var$getTicketTypeFieldsRoutesCommon(),
        component: (0, $d19d2d8dc261c55c$export$2e2bcd8739ae039)
    }),
    (0, $apqRF.createEntry)((0, $ca4e49b79a8433d9$export$50e6baca5c1f7a5b), {
        ...$c85fda19a90ea423$var$getTicketTypeFieldsRoutesCommon()
    }),
    (0, $apqRF.createEntry)((0, $ca4e49b79a8433d9$export$51c2cd63e9954ab7), {
        ...$c85fda19a90ea423$var$getTicketTypeFieldsRoutesCommon()
    })
];



var $cernH = parcelRequire("cernH");

var $exb0h = parcelRequire("exb0h");

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $apqRF = parcelRequire("apqRF");

var $dAKwA = parcelRequire("dAKwA");

var $ixwgj = parcelRequire("ixwgj");

var $47r3J = parcelRequire("47r3J");

var $6RfAJ = parcelRequire("6RfAJ");

var $6bQqb = parcelRequire("6bQqb");

var $exb0h = parcelRequire("exb0h");
const $9ded92290a75756e$export$5575497f0592ee94 = 'servicedesk';
const $9ded92290a75756e$export$cd0f363eecbc2379 = {
    exact: true,
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-unassigned-ticket-types-config`,
    path: `/jira/${$9ded92290a75756e$export$5575497f0592ee94}/projects/:projectKey/settings/request-types/unassigned`
};
const $9ded92290a75756e$export$96fd54e139924473 = {
    exact: true,
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-itsm-ticket-types-config`,
    path: `/jira/${$9ded92290a75756e$export$5575497f0592ee94}/projects/:projectKey/settings/request-types/category/:practice`
};
const $9ded92290a75756e$export$1eebd582a7db1c90 = {
    exact: true,
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-ticket-types-config`,
    path: `/jira/${$9ded92290a75756e$export$5575497f0592ee94}/projects/:projectKey/settings/request-types`
};



var $csLgO = parcelRequire("csLgO");

var $frZnw = parcelRequire("frZnw");

var $eUqFw = parcelRequire("eUqFw");

var $kJlBc = parcelRequire("kJlBc");

var $4qvmP = parcelRequire("4qvmP");

var $hHrVM = parcelRequire("hHrVM");

var $kbHFR = parcelRequire("kbHFR");
const $d32066f9293994b1$export$b7262fe486f4b412 = 'core';
const $d32066f9293994b1$export$2954328f6207617a = 'software';
const $d32066f9293994b1$export$5575497f0592ee94 = 'servicedesk';
const $d32066f9293994b1$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
const $d32066f9293994b1$export$586756e5c0542a50 = (product)=>{
    if (product === $d32066f9293994b1$export$5575497f0592ee94) return (0, $kbHFR.getServiceDeskSettingsResources)();
    if (product === $d32066f9293994b1$export$b7262fe486f4b412) return [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ];
    return [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)()
    ];
};
const $d32066f9293994b1$export$c9b0516439c55d7a = (product)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
            to: `/jira/${product}/projects/${String(match.params.projectKey)}/settings/details`
        });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $646db37ffd41d2e1$export$c26e63f8b7d3b52c = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("1lKRo")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-ticket-types-config/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$646db37ffd41d2e1$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $646db37ffd41d2e1$export$c26e63f8b7d3b52c,
        pageId: "project-settings-ticket-types-config",
        shouldShowSpinner: true
    });


const $39723202b32651a7$var$commonTicketTypesConfigRouteEntry = {
    exact: true,
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    component: (0, $646db37ffd41d2e1$export$2e2bcd8739ae039),
    layout: (0, $csLgO.serviceProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iTYGl.default)
    },
    resources: [
        ...(0, $d32066f9293994b1$export$586756e5c0542a50)((0, $d32066f9293994b1$export$5575497f0592ee94)),
        (0, $ixwgj.projectContextResource),
        (0, $6bQqb.servicedeskPracticesResource),
        (0, $47r3J.servicedeskIssueTypesResource),
        (0, $6RfAJ.servicedeskPortalGroupsResource),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $646db37ffd41d2e1$export$c26e63f8b7d3b52c)
    ],
    meta: {
        reporting: {
            id: (0, $frZnw.APP_NAMES).REQUEST_TYPES_CONFIG,
            packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).REQUEST_TYPES_CONFIG),
            teamName: 'jsd-shield'
        }
    },
    perfMetricKey: 'jsm-request-types-configuration',
    ufoName: 'jsm-request-types-configuration'
};
const $39723202b32651a7$export$fa9d0db1668a0662 = [
    (0, $apqRF.createEntry)((0, $9ded92290a75756e$export$cd0f363eecbc2379), {
        ...$39723202b32651a7$var$commonTicketTypesConfigRouteEntry,
        component: (0, $646db37ffd41d2e1$export$2e2bcd8739ae039)
    }),
    (0, $apqRF.createEntry)((0, $9ded92290a75756e$export$96fd54e139924473), {
        ...$39723202b32651a7$var$commonTicketTypesConfigRouteEntry
    }),
    (0, $apqRF.createEntry)((0, $9ded92290a75756e$export$1eebd582a7db1c90), {
        ...$39723202b32651a7$var$commonTicketTypesConfigRouteEntry
    })
];



var $dfBCt = parcelRequire("dfBCt");


var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $apqRF = parcelRequire("apqRF");

var $dAKwA = parcelRequire("dAKwA");

var $exb0h = parcelRequire("exb0h");
const $ad4e15e96c4bd9a2$export$5575497f0592ee94 = 'servicedesk';
const $ad4e15e96c4bd9a2$var$projectSettingsUrl = (product)=>`/jira/${product}/projects/:projectKey/settings`;
const $ad4e15e96c4bd9a2$export$8c051c399fd812a5 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    // We name this virtualagentonboarding without the "-" as otherwise it would trigger
    // the nesting stack, which we don't want for onboarding
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-virtualagentonboarding`,
    exact: true,
    path: `${$ad4e15e96c4bd9a2$var$projectSettingsUrl($ad4e15e96c4bd9a2$export$5575497f0592ee94)}/virtual-agent`
};
const $ad4e15e96c4bd9a2$export$3e227412713bc57f = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-virtualagent-browse-intents`,
    exact: true,
    path: `${$ad4e15e96c4bd9a2$var$projectSettingsUrl($ad4e15e96c4bd9a2$export$5575497f0592ee94)}/virtual-agent/intents`
};
const $ad4e15e96c4bd9a2$export$bf8131fb060d0e73 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-virtualagent-view-intent`,
    exact: true,
    path: `${$ad4e15e96c4bd9a2$var$projectSettingsUrl($ad4e15e96c4bd9a2$export$5575497f0592ee94)}/virtual-agent/intents/:intentId/:tab(flow|training|settings)?`
};
const $ad4e15e96c4bd9a2$export$fd091ba8fa858397 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-virtualagent-standard-flows`,
    exact: true,
    path: `${$ad4e15e96c4bd9a2$var$projectSettingsUrl($ad4e15e96c4bd9a2$export$5575497f0592ee94)}/virtual-agent/standard-flows`
};
const $ad4e15e96c4bd9a2$export$c74dca8be49046ea = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-virtualagent-view-standard-flow`,
    exact: true,
    path: `${$ad4e15e96c4bd9a2$var$projectSettingsUrl($ad4e15e96c4bd9a2$export$5575497f0592ee94)}/virtual-agent/standard-flows/:flowId/:tab(flow|settings)?`
};
const $ad4e15e96c4bd9a2$export$c8ff4cf64e5540ec = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-virtualagent-browseconversations`,
    exact: true,
    path: `${$ad4e15e96c4bd9a2$var$projectSettingsUrl($ad4e15e96c4bd9a2$export$5575497f0592ee94)}/virtual-agent/conversations`
};
const $ad4e15e96c4bd9a2$export$847a7c378c11c645 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-virtualagent-settings`,
    exact: true,
    path: `${$ad4e15e96c4bd9a2$var$projectSettingsUrl($ad4e15e96c4bd9a2$export$5575497f0592ee94)}/virtual-agent/settings/:tab(basic|channels)?`
};



var $csLgO = parcelRequire("csLgO");

var $frZnw = parcelRequire("frZnw");

var $7ZZxN = parcelRequire("7ZZxN");

var $isbb2 = parcelRequire("isbb2");

var $csLgO = parcelRequire("csLgO");

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $bUi2Q = parcelRequire("bUi2Q");

var $bNe1g = parcelRequire("bNe1g");

var $1ybV0 = parcelRequire("1ybV0");
/**
 * @generated SignedSource<<1bf695f627b91a25ce87882865dc0922>>
 * @relayHash 15d7acad258757e4608b0a07a6bde204
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8789ab3f986d4f369f91bdc4d71ace921807eaec7638f0e5dde21bdca1c34e17
const $f4972c8bde96023f$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "8789ab3f986d4f369f91bdc4d71ace921807eaec7638f0e5dde21bdca1c34e17",
        "metadata": {},
        "name": "uiVirtualAgentIntentTemplatesQuery",
        "operationKind": "query",
        "text": null
    }
};
var $f4972c8bde96023f$export$2e2bcd8739ae039 = $f4972c8bde96023f$var$node;



var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $d7ac566cc37b6154$export$2b1d9dc27ee42f8f = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("g5qNM"))), {
        moduleId: "a4e9afeb"
    }),
    getPreloadProps: ({ cloudId: cloudId, key: key })=>({
            queries: {
                intentTemplateQueryReference: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: (0, $f4972c8bde96023f$export$2e2bcd8739ae039),
                    variables: {
                        cloudId: cloudId,
                        key: key,
                        isGateIntentTemplatesBehindAiToggleEnabled: (0, $1ybV0.ff)('activate-ai-toggle-message-in-intent-templates-sidebar_9dhqx'),
                        isDiscoveredTemplatesTimestampEnabled: (0, $1ybV0.ff)('add-last-updated-timestamp-for-intent-templates_tgonx')
                    }
                }
            },
            entryPoints: {},
            extraProps: {}
        })
});



var $g5qNM = parcelRequire("g5qNM");

var $jIMNW = parcelRequire("jIMNW");
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");
var $f8151e318c4bbdb9$exports = {};
$f8151e318c4bbdb9$exports = new URL("virtual-agent-intent-template-sidebar-app-skeleton.tpl.e2ff8557.svg", import.meta.url).toString();


const $ea48e3a18124b16d$var$customCssStyles = null;
const $ea48e3a18124b16d$export$fa68b26760d5b66f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($f8151e318c4bbdb9$exports))),
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });



var $dWLk9 = parcelRequire("dWLk9");
const $2611ba4a4b9c48ee$var$runtimeProps = {};
const $2611ba4a4b9c48ee$export$36ad24b9ac79bdc8 = ()=>{
    const rightSidebarCurrentState = (0, $bUi2Q.useActiveRightSidebarState)();
    const panelId = rightSidebarCurrentState?.panelId ?? '';
    const cloudId = (0, $dWLk9.useCloudId)();
    const { data: projectContextData } = (0, $bNe1g.useProjectContext)();
    const entryPointParams = (0, $eUqFw.useMemo)(()=>({
            cloudId: cloudId,
            key: projectContextData?.projectKey ?? ''
        }), [
        cloudId,
        projectContextData
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $d7ac566cc37b6154$export$2b1d9dc27ee42f8f), entryPointParams);
    (0, $eUqFw.useEffect)(()=>{
        if (panelId === 'intentTemplate') entryPointActions.load();
        else entryPointActions.unload();
    }, [
        entryPointActions,
        panelId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "createIntentTemplatesSidebar",
        packageName: "jiraServicedeskSettingsVirtualAgentCreateIntentTemplates",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ea48e3a18124b16d$export$fa68b26760d5b66f), null),
        errorFallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g5qNM.SideBarWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jIMNW.ErrorDisplay), {
                refetch: ()=>window.location.reload()
            })),
        runtimeProps: $2611ba4a4b9c48ee$var$runtimeProps
    });
};
var $2611ba4a4b9c48ee$export$2e2bcd8739ae039 = $2611ba4a4b9c48ee$export$36ad24b9ac79bdc8;


// TODO Remove this whenever all service project route paths are no longer ambiguous
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3da6a5b21870784d$var$withServiceProjectContext = (Component)=>(0, $isbb2.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $7ZZxN.SERVICE_DESK_PROJECT)
        }
    });
const $3da6a5b21870784d$export$6659f41b213bad05 = (0, $isbb2.composeLayouts)((0, $csLgO.serviceProjectLayout), {
    rightSidebars: [
        $3da6a5b21870784d$var$withServiceProjectContext((0, $2611ba4a4b9c48ee$export$2e2bcd8739ae039))
    ]
});


/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");
var $985b4f7897628c1d$exports = {};
$985b4f7897628c1d$exports = new URL("virtual-agent-browse-conversations-app-skeleton.tpl.9f030add.svg", import.meta.url).toString();


const $ee9589c148891c91$var$customStyles = null;
const $ee9589c148891c91$export$4a6267fad85ca589 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($985b4f7897628c1d$exports))),
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });


var $aDZUE = parcelRequire("aDZUE");/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");
var $580d2d08513f4e43$exports = {};
$580d2d08513f4e43$exports = new URL("virtual-agent-browse-standard-flows-app-skeleton.tpl.51e6e95a.svg", import.meta.url).toString();


const $5d33c8e57d2ae9fa$var$customCssStyles = null;
const $5d33c8e57d2ae9fa$export$c2bd83dd149452bd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($580d2d08513f4e43$exports))),
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");
var $03841d5c1efffd9b$exports = {};
$03841d5c1efffd9b$exports = new URL("virtual-agent-landing-app-skeleton.tpl.e8a7897b.svg", import.meta.url).toString();


const $7da2e5cae9546ea1$var$customStyles = null;
const $7da2e5cae9546ea1$export$f4b71d7b732df8a7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($03841d5c1efffd9b$exports))),
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");
var $e98c89e4978f8890$exports = {};
$e98c89e4978f8890$exports = new URL("virtual-agent-settings-app-skeleton.tpl.1a9c03fe.svg", import.meta.url).toString();


const $a5f272c37f7018ee$var$customCssStyles = null;
const $a5f272c37f7018ee$export$429c43ddcb09c14c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($e98c89e4978f8890$exports))),
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");
var $ac9b65665cc096b8$exports = {};
$ac9b65665cc096b8$exports = new URL("virtual-agent-view-intent-app-skeleton.tpl.5dd31cbb.svg", import.meta.url).toString();


const $ff6dbd89968fe1c3$var$customCssStyles = null;
const $ff6dbd89968fe1c3$export$72b20c10a0f18a2f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ac9b65665cc096b8$exports))),
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });

/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");
var $b538099dd217ad85$exports = {};
$b538099dd217ad85$exports = new URL("virtual-agent-view-standard-flow-app-skeleton.tpl.ec3b149b.svg", import.meta.url).toString();


const $23c26c95d8e6cc8f$var$customCssStyles = null;
const $23c26c95d8e6cc8f$export$c6d3f04e6931e3f6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($b538099dd217ad85$exports))),
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
        ])
    });



var $1ybV0 = parcelRequire("1ybV0");
/**
 * @generated SignedSource<<2ae0c2a3d75de85d371462f7bda6d3c2>>
 * @relayHash 3b1ad2a90ca74c50737c2302b5bacecd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 35aa850db46b29486ee495b583fa52299c2053d85d00c14f99c4d51a620b6e67
const $ecb0b5ae979718a3$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "35aa850db46b29486ee495b583fa52299c2053d85d00c14f99c4d51a620b6e67",
        "metadata": {},
        "name": "srcVirtualAgentBrowseConversationsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $ecb0b5ae979718a3$export$2e2bcd8739ae039 = $ecb0b5ae979718a3$var$node;



var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");
const $a8f6b56040675aea$var$DEFAULT_RANGE_DAYS = 14;

const $a8f6b56040675aea$export$38549013d5d5a440 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("89or4")), {
        moduleId: "1bf85952"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
        const end = new Date();
        const start = new Date(end);
        start.setDate(start.getDate() - $a8f6b56040675aea$var$DEFAULT_RANGE_DAYS);
        return {
            extraProps: {
                initialDateRange: {
                    start: start,
                    end: end
                }
            },
            queries: {
                page: {
                    parameters: (0, $ecb0b5ae979718a3$export$2e2bcd8739ae039),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        startDate: start.toISOString(),
                        endDate: end.toISOString(),
                        checkForAiEnabledFF: (0, $1ybV0.ff)('check-for-ai-enabling-in-get-premium-banner_oxh6r')
                    }
                }
            }
        };
    }
});



var $1ybV0 = parcelRequire("1ybV0");
/**
 * @generated SignedSource<<305fab7a6461f9fd292289126cecdd6f>>
 * @relayHash 39209fae6b03316b5831f0337cfa59c8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a911bfa308ab38586c38e65c38a450216a3c1f3d329c7b683d9ec41a1dbd4c99
const $68ca769f8ec90236$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "a911bfa308ab38586c38e65c38a450216a3c1f3d329c7b683d9ec41a1dbd4c99",
        "metadata": {},
        "name": "srcVirtualAgentBrowseIntentsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $68ca769f8ec90236$export$2e2bcd8739ae039 = $68ca769f8ec90236$var$node;


/**
 * @generated SignedSource<<8221a0384be3e0c7d78b1bbaa2f66504>>
 * @relayHash 7d72a8e1ec2336ed99383dd817c25c42
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4c5640c21c44dc3835a72f29fecfcb703a916b96913572926485bd4e862b315c
const $18a9373813a736ec$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "4c5640c21c44dc3835a72f29fecfcb703a916b96913572926485bd4e862b315c",
        "metadata": {},
        "name": "srcVirtualAgentBrowseIntentsStatisticsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $18a9373813a736ec$export$2e2bcd8739ae039 = $18a9373813a736ec$var$node;



var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");
// When changing the default time range, make sure to also update jira/src/packages/servicedesk/virtual-agent/intents/browse-intents/src/ui/index.tsx
const $993f655e32e8f76f$var$DEFAULT_TIME_RANGE_MS = 604800000; // 7 days
const $993f655e32e8f76f$var$formatFetchDate = (date)=>date.toISOString().substring(0, 10);

const $993f655e32e8f76f$export$f19c213ae2d7940f = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("8jrRa")), {
        moduleId: "85089c8d"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $68ca769f8ec90236$export$2e2bcd8739ae039),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        checkForAiEnabledFF: (0, $1ybV0.ff)('check-for-ai-enabling-in-get-premium-banner_oxh6r')
                    }
                },
                statistics: {
                    parameters: (0, $18a9373813a736ec$export$2e2bcd8739ae039),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        startDate: $993f655e32e8f76f$var$formatFetchDate(new Date(Date.now() - $993f655e32e8f76f$var$DEFAULT_TIME_RANGE_MS)),
                        endDate: $993f655e32e8f76f$var$formatFetchDate(new Date())
                    }
                }
            }
        })
});



var $1ybV0 = parcelRequire("1ybV0");
/**
 * @generated SignedSource<<739047044a04affb48020f16b589a67b>>
 * @relayHash 3caa9fde75ad61c402696bca56249a4b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8dee2355fbdc129ba049a79fdc979156b50f2dc51a33bc3b2a89b3dc09884f25
const $70a9f1e91c27fff5$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "8dee2355fbdc129ba049a79fdc979156b50f2dc51a33bc3b2a89b3dc09884f25",
        "metadata": {},
        "name": "srcVirtualAgentBrowseStandardFlowsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $70a9f1e91c27fff5$export$2e2bcd8739ae039 = $70a9f1e91c27fff5$var$node;



var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $e66d796291623160$export$f7de8593c7455f1 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("6n2CO")), {
        moduleId: "c2d13204"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $70a9f1e91c27fff5$export$2e2bcd8739ae039),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        checkForAiEnabledFF: (0, $1ybV0.ff)('check-for-ai-enabling-in-get-premium-banner_oxh6r')
                    }
                }
            }
        })
});



var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");
/**
 * @generated SignedSource<<ff95926e7022113cd49dc2068bf42b5b>>
 * @relayHash 1ca562bb5d7e883eaaf1264d05b37876
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 563fe9cb1073575e9dc8babe0ef447ecbabd04641e6a9f889a26808046a1496d
const $2f92e30f6ae3e526$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "563fe9cb1073575e9dc8babe0ef447ecbabd04641e6a9f889a26808046a1496d",
        "metadata": {},
        "name": "srcVirtualAgentLandingQuery",
        "operationKind": "query",
        "text": null
    }
};
var $2f92e30f6ae3e526$export$2e2bcd8739ae039 = $2f92e30f6ae3e526$var$node;



var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $cbf4357801ece501$export$ad927ca7512a3a01 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("lRSP3")), {
        moduleId: "06d84010"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $2f92e30f6ae3e526$export$2e2bcd8739ae039),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        checkForAiEnabledFF: (0, $1ybV0.ff)('check-for-ai-enabling-in-get-premium-banner_oxh6r'),
                        isSettingsDecouplingEnabled: (0, $eI5EY.fg)('va_settings_decoupling_m0')
                    }
                }
            }
        })
});



var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");
/**
 * @generated SignedSource<<1fdcb6662e730122aef756bd081f75b3>>
 * @relayHash ce6af27f9d9b03fa77aadf4099d7cb40
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5b9085520b88cfe6babdffd77a69b0c76692a50a7c4f2b2e9956242b2861bb08
const $412aef0a7481ae16$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "5b9085520b88cfe6babdffd77a69b0c76692a50a7c4f2b2e9956242b2861bb08",
        "metadata": {},
        "name": "srcVirtualAgentSettingsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $412aef0a7481ae16$export$2e2bcd8739ae039 = $412aef0a7481ae16$var$node;



var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $bc6c60221f4cf5b6$export$d34e7816b7ac181a = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("iHQVc")), {
        moduleId: "ed4de71b"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $412aef0a7481ae16$export$2e2bcd8739ae039),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        checkForAiEnabledFF: (0, $1ybV0.ff)('check-for-ai-enabling-in-get-premium-banner_oxh6r'),
                        isSettingsDecouplingEnabled: (0, $eI5EY.fg)('va_settings_decoupling_m0'),
                        isNewJSMChatEnabled: (0, $1ybV0.ff)('va_enable_new_jsmchat_api_jivq8')
                    }
                }
            }
        })
});



var $1ybV0 = parcelRequire("1ybV0");
/**
 * @generated SignedSource<<122633496c89d816800ac0cc7ad197d8>>
 * @relayHash 1fff16012e9e82d351a4809512dd028b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 45bdb9c30dff6291e9de65ae33f52f1c1b2c01aacaf0e50196e285c9c83f41d7
const $6087ec5fc1dbe2d2$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "45bdb9c30dff6291e9de65ae33f52f1c1b2c01aacaf0e50196e285c9c83f41d7",
        "metadata": {},
        "name": "srcVirtualAgentViewIntentQuery",
        "operationKind": "query",
        "text": null
    }
};
var $6087ec5fc1dbe2d2$export$2e2bcd8739ae039 = $6087ec5fc1dbe2d2$var$node;



var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $9bd372a4e39a0dac$export$f51df662bd71ce39 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("ldLd9")), {
        moduleId: "bc04de30"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $6087ec5fc1dbe2d2$export$2e2bcd8739ae039),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        intentId: context.match.params.intentId ?? '',
                        checkForAiEnabledFF: (0, $1ybV0.ff)('check-for-ai-enabling-in-get-premium-banner_oxh6r')
                    }
                }
            }
        })
});



var $1ybV0 = parcelRequire("1ybV0");
/**
 * @generated SignedSource<<78ca456cd6160a4ce6ec83f2e6433d00>>
 * @relayHash aed7569699aee5dd3ad2ebc1c66c6544
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 10c3f4debb1d42f2d9c4150d990a7fa92c6fdae9d8a3ed579a56d5027e1facbd
const $6e4a0a2b14b42bdd$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "10c3f4debb1d42f2d9c4150d990a7fa92c6fdae9d8a3ed579a56d5027e1facbd",
        "metadata": {},
        "name": "srcVirtualAgentViewStandardFlowQuery",
        "operationKind": "query",
        "text": null
    }
};
var $6e4a0a2b14b42bdd$export$2e2bcd8739ae039 = $6e4a0a2b14b42bdd$var$node;



var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $aa4382e1bbcff254$export$4fd7bf09308d4abd = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("9BEdE")), {
        moduleId: "8e1cdfbd"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                page: {
                    parameters: (0, $6e4a0a2b14b42bdd$export$2e2bcd8739ae039),
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectKey: context.match.params.projectKey ?? '',
                        flowId: context.match.params.flowId ?? '',
                        checkForAiEnabledFF: (0, $1ybV0.ff)('check-for-ai-enabling-in-get-premium-banner_oxh6r')
                    }
                }
            }
        })
});



var $eUqFw = parcelRequire("eUqFw");

var $kJlBc = parcelRequire("kJlBc");

var $4qvmP = parcelRequire("4qvmP");

var $hHrVM = parcelRequire("hHrVM");

var $kbHFR = parcelRequire("kbHFR");
const $ad1944adf3170121$export$b7262fe486f4b412 = 'core';
const $ad1944adf3170121$export$2954328f6207617a = 'software';
const $ad1944adf3170121$export$5575497f0592ee94 = 'servicedesk';
const $ad1944adf3170121$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
const $ad1944adf3170121$export$586756e5c0542a50 = (product)=>{
    if (product === $ad1944adf3170121$export$5575497f0592ee94) return (0, $kbHFR.getServiceDeskSettingsResources)();
    if (product === $ad1944adf3170121$export$b7262fe486f4b412) return [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ];
    return [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)()
    ];
};
const $ad1944adf3170121$export$c9b0516439c55d7a = (product)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
            to: `/jira/${product}/projects/${String(match.params.projectKey)}/settings/details`
        });


const $9168fc13fd51b5cc$var$browseConversationsPageEntryPoint = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $a8f6b56040675aea$export$38549013d5d5a440),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});
const $9168fc13fd51b5cc$var$browseIntentsPageEntryPoint = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $993f655e32e8f76f$export$f19c213ae2d7940f),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});
const $9168fc13fd51b5cc$var$browseStandardFlowsPageEntryPoint = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $e66d796291623160$export$f7de8593c7455f1),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});
const $9168fc13fd51b5cc$var$landingPageEntryPoint = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $cbf4357801ece501$export$ad927ca7512a3a01),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});
const $9168fc13fd51b5cc$var$settingsPageEntryPoint = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $bc6c60221f4cf5b6$export$d34e7816b7ac181a),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});
const $9168fc13fd51b5cc$var$viewStandardFlowPageEntryPoint = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $aa4382e1bbcff254$export$4fd7bf09308d4abd),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});
const $9168fc13fd51b5cc$var$viewIntentPageEntryPoint = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $9bd372a4e39a0dac$export$f51df662bd71ce39),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});
const $9168fc13fd51b5cc$var$getVirtualAgentRoutesCommon = ()=>({
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        }
    });
const $9168fc13fd51b5cc$var$FedRAMPFallbackRedirectToProjectSettings = (0, $ad1944adf3170121$export$c9b0516439c55d7a)((0, $ad1944adf3170121$export$5575497f0592ee94));
const $9168fc13fd51b5cc$export$cf02bed1953597cb = [
    (0, $apqRF.createEntry)((0, $ad4e15e96c4bd9a2$export$8c051c399fd812a5), {
        ...$9168fc13fd51b5cc$var$getVirtualAgentRoutesCommon(),
        entryPoint () {
            if ((0, $dfBCt.isFedRamp)()) return undefined;
            return $9168fc13fd51b5cc$var$landingPageEntryPoint;
        },
        component: $9168fc13fd51b5cc$var$FedRAMPFallbackRedirectToProjectSettings,
        skeleton: (0, $7da2e5cae9546ea1$export$f4b71d7b732df8a7),
        resources: [
            ...(0, $ad1944adf3170121$export$586756e5c0542a50)((0, $ad1944adf3170121$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).VIRTUAL_AGENT_SETTINGS,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).VIRTUAL_AGENT_SETTINGS),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }),
    (0, $apqRF.createEntry)((0, $ad4e15e96c4bd9a2$export$3e227412713bc57f), {
        ...$9168fc13fd51b5cc$var$getVirtualAgentRoutesCommon(),
        entryPoint () {
            if ((0, $dfBCt.isFedRamp)()) return undefined;
            return $9168fc13fd51b5cc$var$browseIntentsPageEntryPoint;
        },
        component: $9168fc13fd51b5cc$var$FedRAMPFallbackRedirectToProjectSettings,
        layout: (0, $3da6a5b21870784d$export$6659f41b213bad05),
        skeleton: (0, $aDZUE.VirtualAgentBrowseIntentsSkeleton),
        resources: [
            ...(0, $ad1944adf3170121$export$586756e5c0542a50)((0, $ad1944adf3170121$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).VIRTUAL_AGENT_BROWSE_INTENTS,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).VIRTUAL_AGENT_BROWSE_INTENTS),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }),
    (0, $apqRF.createEntry)((0, $ad4e15e96c4bd9a2$export$bf8131fb060d0e73), {
        ...$9168fc13fd51b5cc$var$getVirtualAgentRoutesCommon(),
        entryPoint () {
            if ((0, $dfBCt.isFedRamp)()) return undefined;
            return $9168fc13fd51b5cc$var$viewIntentPageEntryPoint;
        },
        component: $9168fc13fd51b5cc$var$FedRAMPFallbackRedirectToProjectSettings,
        skeleton: (0, $ff6dbd89968fe1c3$export$72b20c10a0f18a2f),
        resources: [
            ...(0, $ad1944adf3170121$export$586756e5c0542a50)((0, $ad1944adf3170121$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).VIRTUAL_AGENT_VIEW_INTENT,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).VIRTUAL_AGENT_VIEW_INTENT),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }),
    (0, $apqRF.createEntry)((0, $ad4e15e96c4bd9a2$export$fd091ba8fa858397), {
        ...$9168fc13fd51b5cc$var$getVirtualAgentRoutesCommon(),
        entryPoint () {
            if ((0, $dfBCt.isFedRamp)()) return undefined;
            return $9168fc13fd51b5cc$var$browseStandardFlowsPageEntryPoint;
        },
        component: $9168fc13fd51b5cc$var$FedRAMPFallbackRedirectToProjectSettings,
        skeleton: (0, $5d33c8e57d2ae9fa$export$c2bd83dd149452bd),
        resources: [
            ...(0, $ad1944adf3170121$export$586756e5c0542a50)((0, $ad1944adf3170121$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }),
    (0, $apqRF.createEntry)((0, $ad4e15e96c4bd9a2$export$c74dca8be49046ea), {
        ...$9168fc13fd51b5cc$var$getVirtualAgentRoutesCommon(),
        entryPoint () {
            if ((0, $dfBCt.isFedRamp)()) return undefined;
            return $9168fc13fd51b5cc$var$viewStandardFlowPageEntryPoint;
        },
        component: $9168fc13fd51b5cc$var$FedRAMPFallbackRedirectToProjectSettings,
        skeleton: (0, $23c26c95d8e6cc8f$export$c6d3f04e6931e3f6),
        resources: [
            ...(0, $ad1944adf3170121$export$586756e5c0542a50)((0, $ad1944adf3170121$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).VIRTUAL_AGENT_VIEW_STANDARD_FLOW,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).VIRTUAL_AGENT_VIEW_STANDARD_FLOW),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }),
    (0, $apqRF.createEntry)((0, $ad4e15e96c4bd9a2$export$c8ff4cf64e5540ec), {
        ...$9168fc13fd51b5cc$var$getVirtualAgentRoutesCommon(),
        entryPoint () {
            if ((0, $dfBCt.isFedRamp)()) return undefined;
            return $9168fc13fd51b5cc$var$browseConversationsPageEntryPoint;
        },
        component: $9168fc13fd51b5cc$var$FedRAMPFallbackRedirectToProjectSettings,
        skeleton: (0, $ee9589c148891c91$export$4a6267fad85ca589),
        resources: [
            ...(0, $ad1944adf3170121$export$586756e5c0542a50)((0, $ad1944adf3170121$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).VIRTUAL_AGENT_BROWSE_CONVERSATIONS,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).VIRTUAL_AGENT_BROWSE_CONVERSATIONS),
                teamName: 'jsd-flux-capacitors'
            }
        }
    }),
    (0, $apqRF.createEntry)((0, $ad4e15e96c4bd9a2$export$847a7c378c11c645), {
        ...$9168fc13fd51b5cc$var$getVirtualAgentRoutesCommon(),
        entryPoint () {
            if ((0, $dfBCt.isFedRamp)()) return undefined;
            return $9168fc13fd51b5cc$var$settingsPageEntryPoint;
        },
        component: $9168fc13fd51b5cc$var$FedRAMPFallbackRedirectToProjectSettings,
        skeleton: (0, $a5f272c37f7018ee$export$429c43ddcb09c14c),
        resources: [
            ...(0, $ad1944adf3170121$export$586756e5c0542a50)((0, $ad1944adf3170121$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).VIRTUAL_AGENT_SETTINGS,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).VIRTUAL_AGENT_SETTINGS),
                teamName: 'jsd-flux-capacitors'
            }
        }
    })
];




var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $apqRF = parcelRequire("apqRF");

var $4qvmP = parcelRequire("4qvmP");

var $hHrVM = parcelRequire("hHrVM");

var $ixwgj = parcelRequire("ixwgj");

var $kbHFR = parcelRequire("kbHFR");

var $exb0h = parcelRequire("exb0h");
const $dc22772ba6709c2c$export$ad30542ae2fd7196 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-workflow-scheme-config`,
    path: '/jira/servicedesk/projects/:projectKey/settings/workflows',
    exact: true
};



var $csLgO = parcelRequire("csLgO");

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $0ecbe1f8642fe6d6$export$12ccdf1d30de8ac = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("fD4Jx")), {
        moduleId: "6be3e66b"
    }),
    getPreloadProps: ()=>({})
});


const $fc1dda288890f345$var$workflowSchemeConfigPageEntrypoint = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $0ecbe1f8642fe6d6$export$12ccdf1d30de8ac),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});
const $fc1dda288890f345$var$CORE_PRODUCT = 'core';
const $fc1dda288890f345$var$SERVICE_DESK_PRODUCT = 'servicedesk';
const $fc1dda288890f345$export$586756e5c0542a50 = (product)=>{
    if (product === $fc1dda288890f345$var$SERVICE_DESK_PRODUCT) return (0, $kbHFR.getServiceDeskSettingsResources)();
    const resources = [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)()
    ];
    if (product === $fc1dda288890f345$var$CORE_PRODUCT) return [
        ...resources,
        ...(0, $4qvmP.getBusinessProjectResources)()
    ];
    return resources;
};
const $fc1dda288890f345$export$212f7f79630d5adc = (0, $apqRF.createEntry)((0, $dc22772ba6709c2c$export$ad30542ae2fd7196), {
    entryPoint () {
        return $fc1dda288890f345$var$workflowSchemeConfigPageEntrypoint;
    },
    layout: (0, $csLgO.serviceProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iTYGl.default)
    },
    resources: [
        ...$fc1dda288890f345$export$586756e5c0542a50($fc1dda288890f345$var$SERVICE_DESK_PRODUCT),
        (0, $ixwgj.projectContextResource)
    ],
    meta: {
        reporting: {
            id: 'project-settings.workflow-scheme-config',
            packageName: 'projectSettingsWorkflowSchemeConfig',
            teamName: 'jsd-shield'
        }
    },
    ufoName: 'project-settings-workflow-scheme-config'
});



var $csLgO = parcelRequire("csLgO");

var $aje9D = parcelRequire("aje9D");

var $6ebW2 = parcelRequire("6ebW2");

var $frZnw = parcelRequire("frZnw");

var $9oI9i = parcelRequire("9oI9i");

var $lq02o = parcelRequire("lq02o");

var $ecIZv = parcelRequire("ecIZv");

var $aHr8P = parcelRequire("aHr8P");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $7ZZxN = parcelRequire("7ZZxN");

var $bNe1g = parcelRequire("bNe1g");

var $kJlBc = parcelRequire("kJlBc");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $c7e3207268af5ac9$export$fa3bc297af95f169 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("1on9e"))), {
    moduleId: "./src/packages/spa-apps/project-settings/app-discovery-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c7e3207268af5ac9$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $c7e3207268af5ac9$export$fa3bc297af95f169,
        pageId: "project-settings-app-discovery-settings",
        shouldShowSpinner: false
    });



const $580910a7f6b68948$export$246ec9cdadd2a163 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("ipeZB"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-app-controls/src/index.tsx"
});
const $580910a7f6b68948$var$ConnectAppsRedirectInner = ({ match: match, basePath: basePath })=>{
    const { data: projectContext } = (0, $bNe1g.useProjectContext)();
    const shouldRedirect = projectContext != null && projectContext.simplified && projectContext.projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT);
    return shouldRedirect ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
        to: `${basePath}/projects/${String(match.params.projectKey)}/settings/apps/app-fields`,
        push: false
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c7e3207268af5ac9$export$2e2bcd8739ae039), null);
};
const $580910a7f6b68948$export$cc3414a2d9daf70d = (basePath)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($580910a7f6b68948$var$ConnectAppsRedirectInner, {
            match: match,
            basePath: basePath
        });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$580910a7f6b68948$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $580910a7f6b68948$export$246ec9cdadd2a163,
        pageId: "project-settings-connect-app-controls",
        shouldShowSpinner: false
    });




var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $6c45d7b28c7d9a98$export$3633e017e520a1c2 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("9Jszy"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-apps/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6c45d7b28c7d9a98$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $6c45d7b28c7d9a98$export$3633e017e520a1c2,
        pageId: "project-settings-connect-apps",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $07c4b3293ba0b7af$export$b8abcf8aa8f4df56 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("kSdpO"))), {
    moduleId: "./src/packages/spa-apps/project-settings/data-classifications/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$07c4b3293ba0b7af$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $07c4b3293ba0b7af$export$b8abcf8aa8f4df56,
        pageId: "project-settings-data-classifications",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $559cd2af54dee24a$export$6f16b5efddd5c646 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("kF9mA"))), {
    moduleId: "./src/packages/spa-apps/project-settings/details/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$559cd2af54dee24a$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $559cd2af54dee24a$export$6f16b5efddd5c646,
        pageId: "project-settings-details",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $l90Gp = parcelRequire("l90Gp");

var $ixwgj = parcelRequire("ixwgj");

var $59o4i = parcelRequire("59o4i");

const $d047c23f9bddce75$export$ef66d3f49a9953d8 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("51l6H")), {
    moduleId: "./src/packages/spa-apps/forge/project-settings/src/index.tsx"
});
const $d047c23f9bddce75$export$33d85a1b2211b38 = [
    (0, $ixwgj.projectContextResourceWithCache),
    (0, $l90Gp.forgeProjectSettingsModuleResource)
];
const $d047c23f9bddce75$export$b943f48844c671a5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $d047c23f9bddce75$export$ef66d3f49a9953d8,
        pageId: "forge-spa-project-settings",
        shouldShowSpinner: true
    });
var $d047c23f9bddce75$export$2e2bcd8739ae039 = $d047c23f9bddce75$export$b943f48844c671a5;



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $7c62d64db2daccf3$export$36dcfb52d47cb93a = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("aK8GH"))), {
    moduleId: "./src/packages/spa-apps/project-settings/issue-type/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7c62d64db2daccf3$export$2e2bcd8739ae039 = ({ match: match })=>{
    const { issueTypeId: issueTypeId } = match.params;
    // unique pageId need to be set so that ApdexProvider would properly reset all the performance marks when switching between issue types
    const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7c62d64db2daccf3$export$36dcfb52d47cb93a,
        pageId: pageId,
        shouldShowSpinner: false
    });
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $da72a92622b3bdcb$export$dea5ad7e8eac12ae = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("lVOgJ")), {
    moduleId: "./src/packages/spa-apps/project-settings/jira-automation/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$da72a92622b3bdcb$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $da72a92622b3bdcb$export$dea5ad7e8eac12ae,
        pageId: "project-settings-jira-automation",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $f29c792a14c577ec$export$ea7d73c94d9369f4 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("gcJQi"))), {
    moduleId: "./src/packages/spa-apps/project-settings/notification-email/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f29c792a14c577ec$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $f29c792a14c577ec$export$ea7d73c94d9369f4,
        pageId: "project-settings-email-notifications",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $kJlBc = parcelRequire("kJlBc");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $252a239e9d35912c$export$7eee4f97b7a1273 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("jDthY"))), {
    moduleId: "./src/packages/spa-apps/project-settings/people/src/index.tsx"
});
const $252a239e9d35912c$var$PeopleAccessRedirectInner = ({ match: match, basePath: basePath })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
        to: `${basePath}/projects/${String(match.params.projectKey)}/settings/access`,
        push: false
    });
const $252a239e9d35912c$export$45346ed2aa24e3f3 = (basePath)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($252a239e9d35912c$var$PeopleAccessRedirectInner, {
            match: match,
            basePath: basePath
        });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$252a239e9d35912c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $252a239e9d35912c$export$7eee4f97b7a1273,
        pageId: "project-settings-people",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $kJlBc = parcelRequire("kJlBc");

var $4qvmP = parcelRequire("4qvmP");

var $hHrVM = parcelRequire("hHrVM");

var $kbHFR = parcelRequire("kbHFR");
const $8410513c5fe667e7$export$b7262fe486f4b412 = 'core';
const $8410513c5fe667e7$export$2954328f6207617a = 'software';
const $8410513c5fe667e7$export$5575497f0592ee94 = 'servicedesk';
const $8410513c5fe667e7$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
const $8410513c5fe667e7$export$586756e5c0542a50 = (product)=>{
    if (product === $8410513c5fe667e7$export$5575497f0592ee94) return (0, $kbHFR.getServiceDeskSettingsResources)();
    if (product === $8410513c5fe667e7$export$b7262fe486f4b412) return [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ];
    return [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)()
    ];
};
const $8410513c5fe667e7$export$c9b0516439c55d7a = (product)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
            to: `/jira/${product}/projects/${String(match.params.projectKey)}/settings/details`
        });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $47269aa86ef517ac$export$a7d63246a10aedd = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("gBOWH")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-jira-form-builder/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$47269aa86ef517ac$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $47269aa86ef517ac$export$a7d63246a10aedd,
        pageId: "project-settings-proforma-jira-form-builder",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $13ec93ed6e57bb05$export$38414b624a749cec = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("7w1w9")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-project-forms/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$13ec93ed6e57bb05$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $13ec93ed6e57bb05$export$38414b624a749cec,
        pageId: "project-settings-proforma-project-forms",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $b9037e72191a69bf$export$e674d93688e620b3 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("UR9i3"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-change-management-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b9037e72191a69bf$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $b9037e72191a69bf$export$e674d93688e620b3,
        pageId: "project-settings-change-management",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $cqJw8 = parcelRequire("cqJw8");

var $kJlBc = parcelRequire("kJlBc");
const $8fd7e7e53e33ec12$export$c7e6c0ac0abe2336 = (pageUrlFragment)=>({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        const url = `${(0, $cqJw8.getNextgenSettingsUrl)((0, $7ZZxN.SERVICE_DESK_PROJECT), String(projectKey))}/channels/${pageUrlFragment}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
            to: url,
            push: false
        });
    };



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $1a74c443d51d759d$export$971347f9ac02f862 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("eKpI0")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-chat-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1a74c443d51d759d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $1a74c443d51d759d$export$971347f9ac02f862,
        pageId: "project-settings-widget-settings",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $aa4ce00c6b5b5662$export$eb662b618d6247be = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("gwVN3"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-classic-portal-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$aa4ce00c6b5b5662$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $aa4ce00c6b5b5662$export$eb662b618d6247be,
        pageId: "project-settings-classic-portal-settings",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $76108e832f0b5581$export$5367e40a24f0bd54 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("mrKpq"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-customer-permissions/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$76108e832f0b5581$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $76108e832f0b5581$export$5367e40a24f0bd54,
        pageId: "project-settings-customer-permissions",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $7bc7e4ae2435f6fb$export$66d0c668045080de = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("gRiYm")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-email/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7bc7e4ae2435f6fb$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7bc7e4ae2435f6fb$export$66d0c668045080de,
        pageId: "project-settings-email",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $d1e5bcf2bfdaa472$export$28482a53859ec466 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("Y8hnW"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-external-links/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d1e5bcf2bfdaa472$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $d1e5bcf2bfdaa472$export$28482a53859ec466,
        pageId: "project-settings-external-links",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");
const $0214761d0ab209ae$export$3fac45fa34d00981 = 'project/service-desk/settings/index';
const $0214761d0ab209ae$export$1aa47348ef6dbdda = 'project/service-desk/settings';

const $0214761d0ab209ae$export$ff54bec6c7cb7d47 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("6uz22")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-feedback-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0214761d0ab209ae$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $0214761d0ab209ae$export$ff54bec6c7cb7d47,
        pageId: "project-settings-feedback-settings",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $4282547c3530036f$export$7796b6d080b8c187 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("82cAp"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-incident-management-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4282547c3530036f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $4282547c3530036f$export$7796b6d080b8c187,
        pageId: "project-settings-incident-management",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $f72b67be569f8585$export$9c9d293dc6de29d0 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("bD008"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-internal-notifications/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f72b67be569f8585$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $f72b67be569f8585$export$9c9d293dc6de29d0,
        pageId: "project-settings-internal-notifications",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $e3524235223eda09$export$562be1021beb9882 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("gIQrA"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-itsm-features/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e3524235223eda09$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e3524235223eda09$export$562be1021beb9882,
        pageId: "project-settings-itsm-features",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $fa9f364df5e36006$export$213b8279037c9d98 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("2UGOi"))), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-language-support/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fa9f364df5e36006$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $fa9f364df5e36006$export$213b8279037c9d98,
        pageId: "project-settings-language-support",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $fb61fb9e176eaa7e$export$c029d3f514c7b3e0 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("lGn5M")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-language-translations/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fb61fb9e176eaa7e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $fb61fb9e176eaa7e$export$c029d3f514c7b3e0,
        pageId: "project-settings-language-translations",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $cqJw8 = parcelRequire("cqJw8");

var $kJlBc = parcelRequire("kJlBc");
const $72f95138eb01ac65$export$59144dd4441639fa = (pageUrlFragment)=>({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        const url = projectKey !== null && projectKey !== undefined ? `${(0, $cqJw8.getNextgenSettingsUrl)((0, $7ZZxN.SERVICE_DESK_PROJECT), projectKey)}/notifications/${pageUrlFragment}` : `/projects/${String(projectKey)}/settings/notifications/${pageUrlFragment}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
            to: url,
            push: false
        });
    };



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $66b7677e7a3f168d$export$fdbd4b1e5ae0e422 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("d0VAC")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-portal-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$66b7677e7a3f168d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $66b7677e7a3f168d$export$fdbd4b1e5ae0e422,
        pageId: "project-settings-portal-settings",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $f4c945aaafdab002$export$216a049c4d917b0 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("8AOQk")), {
    moduleId: "./src/packages/spa-apps/project-settings/service-desk-widget-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f4c945aaafdab002$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $f4c945aaafdab002$export$216a049c4d917b0,
        pageId: "project-settings-widget-settings",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $f05fb14c94c470fa$export$cb608e3696682e76 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("fOSDf"))), {
    moduleId: "./src/packages/spa-apps/project-settings/workflow-navigation/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f05fb14c94c470fa$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $f05fb14c94c470fa$export$cb608e3696682e76,
        pageId: "project-settings-workflow-navigation",
        shouldShowSpinner: false
    });


const $0ffaa8ee5786ed66$var$ufoNamesMap = {
    'project-settings-software-issuetypes': 'project-settings.issue-type.jsw-tmp',
    'project-settings-servicedesk-issuetypes': 'project-settings.issue-type.jsm-tmp'
};
const $0ffaa8ee5786ed66$var$getUFOName = (name)=>$0ffaa8ee5786ed66$var$ufoNamesMap[name] || name;
const $0ffaa8ee5786ed66$var$commonRouteEntries = [
    (0, $apqRF.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskIssuetypesRoute), {
        ufoName: $0ffaa8ee5786ed66$var$getUFOName(`${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SERVICEDESK}-issuetypes`),
        component: (0, $7c62d64db2daccf3$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7c62d64db2daccf3$export$36dcfb52d47cb93a)
        ]
    }),
    (0, $apqRF.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskIssuetypesWorkflowRoute), {
        component: (0, $f05fb14c94c470fa$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7c62d64db2daccf3$export$36dcfb52d47cb93a)
        ]
    }),
    (0, $apqRF.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskAppsFieldsRoute), {
        component: (0, $580910a7f6b68948$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $580910a7f6b68948$export$246ec9cdadd2a163)
        ]
    }),
    (0, $apqRF.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskApps1Route), {
        component: (0, $6c45d7b28c7d9a98$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $6c45d7b28c7d9a98$export$3633e017e520a1c2)
        ]
    }),
    (0, $apqRF.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskDetailsRoute), {
        component: (0, $559cd2af54dee24a$export$2e2bcd8739ae039),
        skeleton: (0, $aHr8P.ProjectSettingsDetailsSkeleton),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $559cd2af54dee24a$export$6f16b5efddd5c646)
        ]
    }),
    (0, $apqRF.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskAccessRoute), {
        skeleton: (0, $aHr8P.ProjectSettingsAccessSkeleton),
        component: (0, $252a239e9d35912c$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $252a239e9d35912c$export$7eee4f97b7a1273)
        ],
        ufoName: 'project-settings.access'
    }),
    (0, $apqRF.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskAccessRedirectRoute), {
        component: (0, $252a239e9d35912c$export$45346ed2aa24e3f3)(`/jira/${(0, $8410513c5fe667e7$export$5575497f0592ee94)}`),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $252a239e9d35912c$export$7eee4f97b7a1273)
        ]
    }),
    (0, $apqRF.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskProformaProjectFormsRoute), {
        component: (0, $13ec93ed6e57bb05$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $13ec93ed6e57bb05$export$38414b624a749cec)
        ],
        perfMetricKey: 'forms-settings'
    }),
    (0, $apqRF.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskProformaJiraFormBuilderRoute), {
        component: (0, $47269aa86ef517ac$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $47269aa86ef517ac$export$a7d63246a10aedd)
        ],
        perfMetricKey: 'form-builder'
    }),
    (0, $apqRF.createEntry)((0, $EFSBh.projectSettingsServicedeskAutomationRoute), {
        ufoName: `project-settings-automation-${(0, $8410513c5fe667e7$export$5575497f0592ee94)}`,
        component: (0, $da72a92622b3bdcb$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $da72a92622b3bdcb$export$dea5ad7e8eac12ae)
        ]
    }),
    (0, $apqRF.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskDataClassificationsRoute), {
        component: (0, $07c4b3293ba0b7af$export$2e2bcd8739ae039),
        skeleton: (0, $aHr8P.ProjectSettingsDetailsSkeleton),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $07c4b3293ba0b7af$export$b8abcf8aa8f4df56)
        ]
    })
];
const $0ffaa8ee5786ed66$export$37a8204dc4094049 = [
    (0, $apqRF.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskClassicAppsRoute), {
        ufoName: 'service-management.app-discovery',
        component: (0, $580910a7f6b68948$export$cc3414a2d9daf70d)(`/jira/${(0, $8410513c5fe667e7$export$5575497f0592ee94)}`),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        isRedirect: true,
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $c7e3207268af5ac9$export$fa3bc297af95f169)
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).APP_DISCOVERY,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).APP_DISCOVERY),
                teamName: 'it-solutions-hermes'
            }
        }
    }),
    ...$0ffaa8ee5786ed66$var$commonRouteEntries,
    ...(0, $86d860750863d795$export$f90c0f16cffd8883),
    ...(0, $c85fda19a90ea423$export$caa50198aadcf21c),
    ...(0, $39723202b32651a7$export$fa9d0db1668a0662),
    ...(0, $38d72ec77f663f1e$export$8521f0867b2d52e4),
    ...(0, $0b9b4e281f9618b2$export$d6bb339f4d05f5c5),
    ...(0, $9168fc13fd51b5cc$export$cf02bed1953597cb),
    (0, $fc1dda288890f345$export$212f7f79630d5adc),
    (0, $apqRF.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskItsmFeaturesRoute), {
        ufoName: 'jsm-features-settings',
        component: (0, $e3524235223eda09$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $k1AKH.featuresResource),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $e3524235223eda09$export$562be1021beb9882)
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).ITSM_FEATURES_SETTINGS,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).ITSM_FEATURES_SETTINGS),
                teamName: 'jsd-shield'
            }
        },
        perfMetricKey: 'jsm-features-settings'
    }),
    (0, $apqRF.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskNotificationsInternalNotificationsRoute), {
        ufoName: 'service-management.internal-notifications',
        component: (0, $f72b67be569f8585$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $f72b67be569f8585$export$9c9d293dc6de29d0),
            (0, $ecIZv.LazyInternalNotificationSettingsPage)
        ]
    }),
    (0, $apqRF.createEntry)((0, $EFSBh.projectSettingsServicedeskNotificationsNotificationEmailRoute), {
        component: (0, $f29c792a14c577ec$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $f29c792a14c577ec$export$ea7d73c94d9369f4)
        ]
    }),
    (0, $apqRF.createEntry)((0, $EFSBh.projectSettingsServicedeskNotifications1Route), {
        component: (0, $72f95138eb01ac65$export$59144dd4441639fa)('customer-notifications'),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation)
        ]
    }),
    (0, $apqRF.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskLanguageKeyRoute), {
        ufoName: 'service-management.translations',
        component: (0, $fb61fb9e176eaa7e$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)(),
            (0, $lq02o.languageTranslationsResource),
            (0, $lq02o.outgoingEmailStateModelResource)
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).LANGUAGE_SETTINGS,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).LANGUAGE_SETTINGS),
                teamName: 'jsm-fission'
            }
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $fb61fb9e176eaa7e$export$c029d3f514c7b3e0)
        ],
        perfMetricKey: 'jsm-language-translations'
    }),
    (0, $apqRF.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskLanguage1Route), {
        ufoName: 'service-management.languages',
        component: (0, $fa9f364df5e36006$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $fb61fb9e176eaa7e$export$c029d3f514c7b3e0)
        ]
    }),
    (0, $apqRF.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskChannelsPermissionsNextGenRoute), {
        component: (0, $76108e832f0b5581$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $ixwgj.projectContextResource),
            (0, $k82mP.customerPermissionsPageDataResource),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $76108e832f0b5581$export$5367e40a24f0bd54)
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).CUSTOMER_PERMISSIONS,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).CUSTOMER_PERMISSIONS),
                teamName: 'jsd-flux-capacitors'
            }
        },
        perfMetricKey: 'jsm-customer-permissions'
    }),
    (0, $apqRF.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskPermissionsClassicRoute), {
        component: (0, $76108e832f0b5581$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $ixwgj.projectContextResource),
            (0, $k82mP.customerPermissionsPageDataResource),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $76108e832f0b5581$export$5367e40a24f0bd54)
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).CUSTOMER_PERMISSIONS,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).CUSTOMER_PERMISSIONS),
                teamName: 'jsd-flux-capacitors'
            }
        },
        perfMetricKey: 'jsm-customer-permissions'
    }),
    (0, $apqRF.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskChannelsEmailNextGenRoute), {
        component: (0, $7bc7e4ae2435f6fb$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7bc7e4ae2435f6fb$export$66d0c668045080de)
        ]
    }),
    (0, $apqRF.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskEmailClassicRoute), {
        ufoName: 'service-management.settings.email-channels',
        component: (0, $7bc7e4ae2435f6fb$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7bc7e4ae2435f6fb$export$66d0c668045080de)
        ]
    }),
    (0, $apqRF.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskPortalSettingsRoute), {
        component: (0, $aa4ce00c6b5b5662$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $aa4ce00c6b5b5662$export$eb662b618d6247be)
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).PORTAL_SETTINGS,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).PORTAL_SETTINGS),
                teamName: 'jsd-shield'
            }
        }
    }),
    (0, $apqRF.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskChannelsPortalRoute), {
        component: (0, $66b7677e7a3f168d$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $ixwgj.projectContextResource),
            (0, $3BZ46.portalSettingsContextResource),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $66b7677e7a3f168d$export$fdbd4b1e5ae0e422)
        ]
    }),
    (0, $apqRF.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskExternalLinksRoute), {
        component: (0, $d1e5bcf2bfdaa472$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $ixwgj.projectContextResource),
            (0, $k1AKH.featuresResource),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $d1e5bcf2bfdaa472$export$28482a53859ec466)
        ],
        perfMetricKey: 'jsm-external-resources'
    }),
    (0, $apqRF.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskChannelsWidgetRoute), {
        component: (0, $f4c945aaafdab002$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $f4c945aaafdab002$export$216a049c4d917b0)
        ]
    }),
    (0, $apqRF.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskWidgetRoute), {
        component: (0, $f4c945aaafdab002$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $f4c945aaafdab002$export$216a049c4d917b0)
        ]
    }),
    (0, $apqRF.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskChangeManagementRoute), {
        ufoName: 'service-management.change-management-settings',
        component: (0, $b9037e72191a69bf$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $ct0sQ.serviceDeskContextResource),
            (0, $6ebW2.changeManagementSettingsProjectConfigurationResource),
            (0, $aje9D.changeManagementAssetConfigurationStatusResource),
            (0, $k1AKH.featuresResource),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $b9037e72191a69bf$export$e674d93688e620b3)
        ]
    }),
    (0, $apqRF.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskIncidentManagementRoute), {
        component: (0, $4282547c3530036f$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $ct0sQ.serviceDeskContextResource),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $4282547c3530036f$export$7796b6d080b8c187)
        ]
    }),
    (0, $apqRF.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskChannelsChatRoute), {
        component: (0, $1a74c443d51d759d$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $1a74c443d51d759d$export$971347f9ac02f862)
        ]
    }),
    (0, $apqRF.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskChatRoute), {
        component: (0, $1a74c443d51d759d$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $1a74c443d51d759d$export$971347f9ac02f862)
        ]
    }),
    (0, $apqRF.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskChannels5Route), {
        component: (0, $8fd7e7e53e33ec12$export$c7e6c0ac0abe2336)('customer-permissions'),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation)
        ]
    }),
    ...(0, $792114e6a9cd6c10$export$fd1a58e6255623a),
    (0, $apqRF.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskNotifications1Route), {
        component: (0, $72f95138eb01ac65$export$59144dd4441639fa)('customer-notifications'),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation)
        ]
    }),
    (0, $apqRF.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskFeedbackRoute), {
        component: (0, $0214761d0ab209ae$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $0214761d0ab209ae$export$ff54bec6c7cb7d47),
            (0, $9oI9i.LazyCsatSettingsPage)
        ],
        perfMetricKey: 'jsm-feedback-settings',
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).CSAT_CONFIG,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).CSAT_CONFIG),
                teamName: 'jsm-request-intake'
            }
        }
    }),
    (0, $apqRF.createEntry)((0, $EFSBh.projectSettingsServicedeskForgeAppsRoute), {
        component: (0, $d047c23f9bddce75$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            ...(0, $d047c23f9bddce75$export$33d85a1b2211b38),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $d047c23f9bddce75$export$ef66d3f49a9953d8)
        ]
    }),
    (0, $apqRF.createEntry)((0, $EFSBh.routeGroupsProjectSettingsServicedeskRedirectRoute), {
        component: (0, $8410513c5fe667e7$export$c9b0516439c55d7a)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $8410513c5fe667e7$export$586756e5c0542a50)((0, $8410513c5fe667e7$export$5575497f0592ee94)),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation)
        ]
    })
];



var $eUqFw = parcelRequire("eUqFw");

var $53ciZ = parcelRequire("53ciZ");

var $cernH = parcelRequire("cernH");

var $hbnZD = parcelRequire("hbnZD");

var $dCvLw = parcelRequire("dCvLw");

var $exb0h = parcelRequire("exb0h");

var $2ijRB = parcelRequire("2ijRB");

var $1ybV0 = parcelRequire("1ybV0");

var $7vTKl = parcelRequire("7vTKl");


var $5w4hM = parcelRequire("5w4hM");

var $iOOlt = parcelRequire("iOOlt");

var $2Fzrk = parcelRequire("2Fzrk");

var $a0UvO = parcelRequire("a0UvO");

var $apqRF = parcelRequire("apqRF");
var $kJlBc = parcelRequire("kJlBc");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $ixwgj = parcelRequire("ixwgj");
var $guiFP = parcelRequire("guiFP");

var $3HCkE = parcelRequire("3HCkE");

var $ixwgj = parcelRequire("ixwgj");
const $a526b624614fa406$export$899fd1c46031ece8 = (teamName)=>{
    const { data: data, error: resourceError, loading: loading } = (0, $3HCkE.useResource)((0, $ixwgj.projectContextResource));
    if (resourceError && data == null) {
        const isErrorErrorType = resourceError instanceof Error;
        const error = isErrorErrorType ? resourceError : new Error(`projectContextResource returned error resourceError: ${JSON.stringify(resourceError)}, loading: ${loading}, data: null`);
        (0, $guiFP.default)({
            meta: {
                id: 'useResourceProjectContext',
                packageName: 'jiraRouterResourcesProjectContext',
                teamName: teamName ?? 'magma'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            loading: false,
            error: error,
            projectKey: null
        };
    }
    if (loading) return {
        loading: true,
        error: null,
        projectKey: null
    };
    // This case never happens by type definition, which you can't even mock test data for this case due to type definition. But if you don't check this, TS is not happy
    if (data == null) return {
        loading: false,
        error: new Error('projectContextResource returned data=null when loading false'),
        projectKey: null
    };
    return {
        loading: false,
        projectKey: data.projectKey,
        error: null
    };
};



var $3BLIV = parcelRequire("3BLIV");

var $a3WTo = parcelRequire("a3WTo");

var $dgH3j = parcelRequire("dgH3j");

var $exb0h = parcelRequire("exb0h");
const $4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT = 'software';
const $4b91e3ee82bc8bc2$var$projectSettingsUrl = (product)=>`/jira/${product}/projects/:projectKey/settings`;
const $4b91e3ee82bc8bc2$var$boardSettingsUrl = (product)=>`${$4b91e3ee82bc8bc2$var$projectSettingsUrl(product)}/boards/:boardId`;
const $4b91e3ee82bc8bc2$export$dde867834e4a9f47 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE}-issuetypes`,
    path: `${$4b91e3ee82bc8bc2$var$projectSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/issuetypes/:issueTypeId?`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$955e8eef6e3bccfb = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE}-issuetypes-workflow`,
    path: `${$4b91e3ee82bc8bc2$var$projectSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/issuetypes/:issueTypeId/:initialSection(workflow)`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$8ddc76f4b4e66b2b = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE}-apps-fields`,
    path: `${$4b91e3ee82bc8bc2$var$projectSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/apps/app-fields`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$d9dea7be10efa583 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE}-apps`,
    path: `${$4b91e3ee82bc8bc2$var$projectSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/apps/:appId?`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$18624b8612cb673d = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE}-details`,
    path: `${$4b91e3ee82bc8bc2$var$projectSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/details`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$9d5b42fcb82012dd = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE}-access`,
    path: `${$4b91e3ee82bc8bc2$var$projectSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/access`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$d782b5257932a66d = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE}-access-redirect`,
    path: `${$4b91e3ee82bc8bc2$var$projectSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/people`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$396cdbbd6f2abcea = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE}-proforma-project-forms`,
    path: `${$4b91e3ee82bc8bc2$var$projectSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/forms`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$394d8f4806a90d7 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE}-proforma-jira-form-builder`,
    path: `${$4b91e3ee82bc8bc2$var$projectSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/forms/form/:templateFormId/edit`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$4d430aeb28b702f8 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_AUTOMATION,
    path: `${$4b91e3ee82bc8bc2$var$projectSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/automate`
};
const $4b91e3ee82bc8bc2$export$61d54e538063bb07 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE}-data-classifications`,
    path: `${$4b91e3ee82bc8bc2$var$projectSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/data-classifications`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$a598c3fe8cbf0c6c = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE}-next-gen-features`,
    path: `${$4b91e3ee82bc8bc2$var$projectSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/features`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$c1d1892d6c07135a = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS,
    path: `${$4b91e3ee82bc8bc2$var$projectSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/notifications`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$c7039de5a4b78802 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_SOFTWARE_OPSGENIE,
    path: `${$4b91e3ee82bc8bc2$var$projectSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/opsgenie`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$99b695c2b8299b5a = {
    // the following route should be non-exact, it will handle "index" and "404" cases
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE,
    name: `${(0, $exb0h.ROUTE_GROUPS).CLASSIC_SOFTWARE}-redirect`,
    path: `/jira/${$4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT}/c/projects/:projectKey/settings`
};
const $4b91e3ee82bc8bc2$export$37e0dbac44df25b9 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).CLASSIC_PROJECT_SETTINGS_SOFTWARE_DETAILS,
    path: '/jira/software/c/projects/:projectKey/settings/details',
    exact: true
};
const $4b91e3ee82bc8bc2$export$4e4a4b8762b611 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).CLASSIC_PROJECT_SETTINGS_OPSGENIE,
    path: '/jira/software/c/projects/:projectKey/settings/opsgenie',
    exact: true
};
const $4b91e3ee82bc8bc2$export$e3e3877ec9c5e840 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_TOOLCHAIN,
    path: `${$4b91e3ee82bc8bc2$var$projectSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/toolchain`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$7dbc23deac9553d4 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).CLASSIC_PROJECT_SETTINGS_TOOLCHAIN,
    path: '/jira/software/c/projects/:projectKey/settings/toolchain',
    exact: true
};
const $4b91e3ee82bc8bc2$export$d4bf23ba6f4199d7 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).CLASSIC_PROJECT_SETTINGS_FEATURES,
    path: '/jira/software/c/projects/:projectKey/settings/features',
    exact: true
};
const $4b91e3ee82bc8bc2$export$d4ed083331cb6e00 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_SOFTWARE_NOTIFICATION_EMAIL,
    path: '/jira/software/c/projects/:projectKey/settings/notifications/notification-email',
    exact: true
};
const $4b91e3ee82bc8bc2$export$b2e044c3dffeca69 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_SOFTWARE_NOTIFICATION_EMAIL,
    path: '/jira/software/projects/:projectKey/settings/notifications/notification-email',
    exact: true
};
const $4b91e3ee82bc8bc2$export$6ef734887b6da0c8 = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_RELEASES_NOTE,
    path: '/jira/secure/ReleaseNote.jspa',
    query: [
        'projectId',
        'version'
    ]
};
const $4b91e3ee82bc8bc2$export$a9509017cabb1e30 = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).LEGACY_PROJECT_RELEASES_NOTE_CONFIG,
    path: '/secure/ConfigureReleaseNote.jspa',
    query: [
        'projectId',
        'version'
    ]
};
const $4b91e3ee82bc8bc2$export$a0223091962262d4 = {
    group: (0, $exb0h.ROUTE_GROUPS).CLASSIC_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).SOFTWARE_RELEASE_NOTES,
    path: '/secure/ReleaseNote.jspa',
    query: [
        'projectId'
    ]
};
const $4b91e3ee82bc8bc2$export$46e979217c179afd = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE}-automation`,
    path: `${$4b91e3ee82bc8bc2$var$projectSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/automation`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$ff4977f79c273b29 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS_ISSUE_LOGS,
    path: `${$4b91e3ee82bc8bc2$var$projectSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/notifications/issue-logs`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$5e2e0a895d6a14bd = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).CLASSIC_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS_ISSUE_LOGS,
    path: '/jira/software/c/projects/:projectKey/settings/notifications/issue-logs',
    query: [
        'projectId'
    ]
};
const $4b91e3ee82bc8bc2$export$2313ca001d58ab27 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).CLASSIC_PROJECT_SETTINGS_SOFTWARE_PROFORMA_FORMS,
    path: '/jira/software/c/projects/:projectKey/settings/forms',
    exact: true
};
const $4b91e3ee82bc8bc2$export$811ace4fee984f0e = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).CLASSIC_PROJECT_SETTINGS_SOFTWARE_PROFORMA_EDIT_FORMS,
    path: '/jira/software/c/projects/:projectKey/settings/forms/form/:templateFormId/edit',
    exact: true
};
const $4b91e3ee82bc8bc2$export$989ca67485551616 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_SOFTWARE_BOARDS_REDIRECT,
    path: `${$4b91e3ee82bc8bc2$var$boardSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$88e68eb447e3db49 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_SOFTWARE_BOARDS_CSM,
    path: `${$4b91e3ee82bc8bc2$var$boardSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/columns`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$9bc9b345958a301c = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_SOFTWARE_BOARDS_CUSTOM_FILTERS,
    path: `${$4b91e3ee82bc8bc2$var$boardSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/custom-filters`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$d3f185a361401db7 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_SOFTWARE_BOARDS_CARD,
    path: `${$4b91e3ee82bc8bc2$var$boardSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/card`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$17ccdaa366ec26b8 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_SOFTWARE_BOARDS_ROADMAP,
    path: `${$4b91e3ee82bc8bc2$var$boardSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/roadmap`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$e116d6b2a5f71426 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_SOFTWARE_BOARDS_TIMELINE,
    path: `${$4b91e3ee82bc8bc2$var$boardSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/timeline`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$ae89a2a3aaf095ef = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_AUTOMATION,
    path: '/jira/software/c/projects/:projectKey/settings/automate'
};
const $4b91e3ee82bc8bc2$export$f74a0b1be9d5b9f6 = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_FORGE_APPS,
    path: '/jira/software/c/projects/:projectKey/settings/apps/:appId/:envId/:route?'
};
const $4b91e3ee82bc8bc2$export$1a2cbdfba83d21b = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_SOFTWARE_BOARDS_INSIGHTS,
    path: `${$4b91e3ee82bc8bc2$var$boardSettingsUrl($4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT)}/insights/:location`,
    exact: true
};
const $4b91e3ee82bc8bc2$export$8559c4a0b692890e = {
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE,
    name: (0, $exb0h.ROUTE_NAMES).PROJECT_SETTINGS_FORGE_APPS_NEXTGEN,
    path: '/jira/software/projects/:projectKey/settings/apps/:appId/:envId/:route?'
};
const $4b91e3ee82bc8bc2$export$7ce9914683cb1572 = {
    // the following route should be non-exact, it will handle "index" and "404" cases
    group: (0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE,
    name: `${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE}-redirect`,
    path: `/jira/${$4b91e3ee82bc8bc2$var$SOFTWARE_PRODUCT}/projects/:projectKey/settings`
};



var $aHr8P = parcelRequire("aHr8P");

var $yyqSx = parcelRequire("yyqSx");

var $bEe6y = parcelRequire("bEe6y");

var $soOXK = parcelRequire("soOXK");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $7ZZxN = parcelRequire("7ZZxN");

var $bNe1g = parcelRequire("bNe1g");

var $kJlBc = parcelRequire("kJlBc");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $b827a20051659108$export$fa3bc297af95f169 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("1on9e"))), {
    moduleId: "./src/packages/spa-apps/project-settings/app-discovery-settings/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b827a20051659108$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $b827a20051659108$export$fa3bc297af95f169,
        pageId: "project-settings-app-discovery-settings",
        shouldShowSpinner: false
    });



const $dde06fb051adc26f$export$246ec9cdadd2a163 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("ipeZB"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-app-controls/src/index.tsx"
});
const $dde06fb051adc26f$var$ConnectAppsRedirectInner = ({ match: match, basePath: basePath })=>{
    const { data: projectContext } = (0, $bNe1g.useProjectContext)();
    const shouldRedirect = projectContext != null && projectContext.simplified && projectContext.projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT);
    return shouldRedirect ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
        to: `${basePath}/projects/${String(match.params.projectKey)}/settings/apps/app-fields`,
        push: false
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b827a20051659108$export$2e2bcd8739ae039), null);
};
const $dde06fb051adc26f$export$cc3414a2d9daf70d = (basePath)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dde06fb051adc26f$var$ConnectAppsRedirectInner, {
            match: match,
            basePath: basePath
        });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$dde06fb051adc26f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $dde06fb051adc26f$export$246ec9cdadd2a163,
        pageId: "project-settings-connect-app-controls",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $b464c86d98b57f45$export$3633e017e520a1c2 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("9Jszy"))), {
    moduleId: "./src/packages/spa-apps/project-settings/connect-apps/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b464c86d98b57f45$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $b464c86d98b57f45$export$3633e017e520a1c2,
        pageId: "project-settings-connect-apps",
        shouldShowSpinner: false
    });



var $i6Rk2 = parcelRequire("i6Rk2");
var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $8205b3305321c568$export$9d468faf674a5201 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("fLOYS")), {
    moduleId: "./src/packages/spa-apps/project-settings/connections/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8205b3305321c568$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $8205b3305321c568$export$9d468faf674a5201,
        pageId: "devops-connections-settings",
        shouldShowSpinner: false
    });


var $cZXTd = parcelRequire("cZXTd");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $8f41cf732a1fc405$export$de293ea44d0410ca = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("1EHlZ"))), {
    moduleId: "./src/packages/spa-apps/project-settings/csm/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8f41cf732a1fc405$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $8f41cf732a1fc405$export$de293ea44d0410ca,
        pageId: "project-settings-csm",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $ffcfbf688bad1c50$export$7e21d36a9d4548e6 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("bfwmf")), {
    moduleId: "./src/packages/spa-apps/project-settings/custom-filters/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ffcfbf688bad1c50$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $ffcfbf688bad1c50$export$7e21d36a9d4548e6,
        pageId: "project-settings-custom-filters",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $ab8ddffeb833017d$export$b8abcf8aa8f4df56 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("kSdpO"))), {
    moduleId: "./src/packages/spa-apps/project-settings/data-classifications/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ab8ddffeb833017d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $ab8ddffeb833017d$export$b8abcf8aa8f4df56,
        pageId: "project-settings-data-classifications",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $55014e887c6e53d8$export$6f16b5efddd5c646 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("kF9mA"))), {
    moduleId: "./src/packages/spa-apps/project-settings/details/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$55014e887c6e53d8$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $55014e887c6e53d8$export$6f16b5efddd5c646,
        pageId: "project-settings-details",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $l90Gp = parcelRequire("l90Gp");

var $ixwgj = parcelRequire("ixwgj");

var $59o4i = parcelRequire("59o4i");

const $4cf1bb1e3f20f07f$export$ef66d3f49a9953d8 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("51l6H")), {
    moduleId: "./src/packages/spa-apps/forge/project-settings/src/index.tsx"
});
const $4cf1bb1e3f20f07f$export$33d85a1b2211b38 = [
    (0, $ixwgj.projectContextResourceWithCache),
    (0, $l90Gp.forgeProjectSettingsModuleResource)
];
const $4cf1bb1e3f20f07f$export$b943f48844c671a5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $4cf1bb1e3f20f07f$export$ef66d3f49a9953d8,
        pageId: "forge-spa-project-settings",
        shouldShowSpinner: true
    });
var $4cf1bb1e3f20f07f$export$2e2bcd8739ae039 = $4cf1bb1e3f20f07f$export$b943f48844c671a5;



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $a823ae098f41111f$export$36dcfb52d47cb93a = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("aK8GH"))), {
    moduleId: "./src/packages/spa-apps/project-settings/issue-type/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a823ae098f41111f$export$2e2bcd8739ae039 = ({ match: match })=>{
    const { issueTypeId: issueTypeId } = match.params;
    // unique pageId need to be set so that ApdexProvider would properly reset all the performance marks when switching between issue types
    const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $a823ae098f41111f$export$36dcfb52d47cb93a,
        pageId: pageId,
        shouldShowSpinner: false
    });
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $f345a9b98bb36af2$export$dea5ad7e8eac12ae = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("lVOgJ")), {
    moduleId: "./src/packages/spa-apps/project-settings/jira-automation/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f345a9b98bb36af2$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $f345a9b98bb36af2$export$dea5ad7e8eac12ae,
        pageId: "project-settings-jira-automation",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $4d907e26c708a2fe$export$ca5dba69148b337 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("iCrPt")), {
    moduleId: "./src/packages/spa-apps/project-settings/link-opsgenie/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4d907e26c708a2fe$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $4d907e26c708a2fe$export$ca5dba69148b337,
        pageId: "link-opsgenie-page",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $8315385009b2701e$export$da4d608b99858bfc = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("8ZhXM"))), {
    moduleId: "./src/packages/spa-apps/project-settings/next-gen-features/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8315385009b2701e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $8315385009b2701e$export$da4d608b99858bfc,
        pageId: "project-settings-next-gen-features",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $43b053b48a4f88e5$export$ea7d73c94d9369f4 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("gcJQi"))), {
    moduleId: "./src/packages/spa-apps/project-settings/notification-email/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$43b053b48a4f88e5$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $43b053b48a4f88e5$export$ea7d73c94d9369f4,
        pageId: "project-settings-email-notifications",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $kJlBc = parcelRequire("kJlBc");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $370b0b5abce37189$export$7eee4f97b7a1273 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("jDthY"))), {
    moduleId: "./src/packages/spa-apps/project-settings/people/src/index.tsx"
});
const $370b0b5abce37189$var$PeopleAccessRedirectInner = ({ match: match, basePath: basePath })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
        to: `${basePath}/projects/${String(match.params.projectKey)}/settings/access`,
        push: false
    });
const $370b0b5abce37189$export$45346ed2aa24e3f3 = (basePath)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($370b0b5abce37189$var$PeopleAccessRedirectInner, {
            match: match,
            basePath: basePath
        });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$370b0b5abce37189$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $370b0b5abce37189$export$7eee4f97b7a1273,
        pageId: "project-settings-people",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $kJlBc = parcelRequire("kJlBc");

var $4qvmP = parcelRequire("4qvmP");

var $hHrVM = parcelRequire("hHrVM");

var $kbHFR = parcelRequire("kbHFR");
const $d3544903dfb35bb2$export$b7262fe486f4b412 = 'core';
const $d3544903dfb35bb2$export$2954328f6207617a = 'software';
const $d3544903dfb35bb2$export$5575497f0592ee94 = 'servicedesk';
const $d3544903dfb35bb2$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
const $d3544903dfb35bb2$export$586756e5c0542a50 = (product)=>{
    if (product === $d3544903dfb35bb2$export$5575497f0592ee94) return (0, $kbHFR.getServiceDeskSettingsResources)();
    if (product === $d3544903dfb35bb2$export$b7262fe486f4b412) return [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
        ...(0, $4qvmP.getBusinessProjectResources)()
    ];
    return [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
        ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)()
    ];
};
const $d3544903dfb35bb2$export$c9b0516439c55d7a = (product)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
            to: `/jira/${product}/projects/${String(match.params.projectKey)}/settings/details`
        });
const $d3544903dfb35bb2$export$1b42c08460289a89 = (product)=>({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
            to: `/jira/${product}/c/projects/${String(match.params.projectKey)}/settings/details`
        });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $f45b19cba10dde76$export$40ff283c032abbc4 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("8SpQk")), {
    moduleId: "./src/packages/spa-apps/project-settings/board-settings/card/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f45b19cba10dde76$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $f45b19cba10dde76$export$40ff283c032abbc4,
        pageId: "board-settings-card",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $3e4476e542b17ea7$export$810ecaba1eb55cad = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("c1opB")).then((module)=>module.InsightsSettingsPageLoader), {
    moduleId: "./src/packages/spa-apps/project-settings/board-settings/insights/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3e4476e542b17ea7$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $3e4476e542b17ea7$export$810ecaba1eb55cad,
        pageId: "board-settings-insights",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $614d9ce626d4ee80$export$8eca5454e72ee961 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("QK9gT")), {
    moduleId: "./src/packages/spa-apps/project-settings/board-settings/roadmap/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$614d9ce626d4ee80$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $614d9ce626d4ee80$export$8eca5454e72ee961,
        pageId: "board-settings-roadmap",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $11bf8792bea72543$export$a7d63246a10aedd = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("gBOWH")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-jira-form-builder/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$11bf8792bea72543$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $11bf8792bea72543$export$a7d63246a10aedd,
        pageId: "project-settings-proforma-jira-form-builder",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $5188faf12abd07fe$export$38414b624a749cec = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("7w1w9")), {
    moduleId: "./src/packages/spa-apps/project-settings/proforma-project-forms/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5188faf12abd07fe$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $5188faf12abd07fe$export$38414b624a749cec,
        pageId: "project-settings-proforma-project-forms",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $569782473f887794$export$69a64a29d67ca160 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("1ZzTg"))), {
    moduleId: "./src/packages/spa-apps/project-settings/software-notifications/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$569782473f887794$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $569782473f887794$export$69a64a29d67ca160,
        pageId: "project-settings-software-notifications",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");


var $7vTKl = parcelRequire("7vTKl");
/**
 * @generated SignedSource<<427bd68f6b792d96582c89c658e47c5a>>
 * @relayHash baeadbd357501a4d3adc7c68a924b3e2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID aa29d7daadcf203a8564a93335ab40e1bf11e665d9566f5cda2b9b522ffddd98
const $1085b76ab37749ad$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "aa29d7daadcf203a8564a93335ab40e1bf11e665d9566f5cda2b9b522ffddd98",
        "metadata": {},
        "name": "issueNotificationsQuery",
        "operationKind": "query",
        "text": null
    }
};
var $1085b76ab37749ad$export$2e2bcd8739ae039 = $1085b76ab37749ad$var$node;



var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $4e9c2113e71dd730$export$97bbdefcbe0571ac = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("e6KiRe")), {
        moduleId: "b2136a4d"
    }),
    getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
            queries: {
                notificationLogs: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $1085b76ab37749ad$export$2e2bcd8739ae039,
                    variables: {
                        cloudId: tenantContext.cloudId,
                        projectId: Number(context?.query?.projectId ?? 0),
                        notificationType: 'INTERNAL_NOTIFICATION_ISSUE',
                        filterActionable: false
                    }
                }
            },
            extraProps: {
                accountId: tenantContext.atlassianAccountId,
                cloudId: tenantContext.cloudId,
                projectIds: context?.query?.projectId,
                projectKey: context?.match.params.projectKey
            }
        })
});



var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");
const $32a54e7cf7d2fc38$export$cd8964bea0e3c2 = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $4e9c2113e71dd730$export$97bbdefcbe0571ac),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});

const $32a54e7cf7d2fc38$export$6960a46ebd209756 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("e6KiRe"))), {
    moduleId: "./src/packages/spa-apps/project-settings/software-notifications-issue-logs/src/index.tsx"
});
const $32a54e7cf7d2fc38$export$4b75df09cc5b4e8e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $32a54e7cf7d2fc38$export$6960a46ebd209756,
        pageId: "project-settings-software-notifications-issue-logs",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $7f120fdbd168266c$export$cb608e3696682e76 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("fOSDf"))), {
    moduleId: "./src/packages/spa-apps/project-settings/workflow-navigation/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7f120fdbd168266c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7f120fdbd168266c$export$cb608e3696682e76,
        pageId: "project-settings-workflow-navigation",
        shouldShowSpinner: false
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $5b552fe98bc306e0$export$79fe16f960f3d89f = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("7dQ41"))), {
    moduleId: "./src/packages/spa-apps/project-settings/classic-features/src/index.tsx"
});
const $5b552fe98bc306e0$export$8e6f565615e921dd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $5b552fe98bc306e0$export$79fe16f960f3d89f,
        pageId: "classic-features",
        shouldShowSpinner: true
    });


const $fc712355d0e1cea7$var$BoardSettingsRedirectToCSM = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
        to: `/jira/software/projects/${String(match.params.projectKey)}/settings/boards/${String(match.params.boardId)}/columns`,
        push: false
    });
const $fc712355d0e1cea7$var$RoadmapSettingsRedirectToTimelineSettings = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
        to: `/jira/software/projects/${String(match.params.projectKey)}/settings/boards/${String(match.params.boardId)}/timeline`,
        push: false
    });
const $fc712355d0e1cea7$var$SpaReleaseNoteRedirectToVersionDetails = ({ query: query })=>{
    const { version: versionId } = query;
    const { loading: loading, error: error, projectKey: projectKey } = (0, $a526b624614fa406$export$899fd1c46031ece8)();
    if (loading === false && error) return null;
    if (loading) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
        to: {
            pathname: `/projects/${projectKey}/versions/${versionId}/tab/release-report-all-issues`,
            hash: '',
            search: (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify({
                isReleaseNoteModalOpen: true
            })
        }
    });
};
const $fc712355d0e1cea7$var$LegacyFrontendReleaseNoteRedirect = ({ query: query })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
        to: {
            pathname: '/secure/ReleaseNote.jspa',
            hash: '',
            search: (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify({
                ...query,
                isRedirectedFromLegacy: true
            })
        }
    });
const $fc712355d0e1cea7$var$ufoNamesMap = {
    'project-settings-software-issuetypes': 'project-settings.issue-type.jsw-tmp',
    'project-settings-servicedesk-issuetypes': 'project-settings.issue-type.jsm-tmp'
};
const $fc712355d0e1cea7$var$getUFOName = (name)=>$fc712355d0e1cea7$var$ufoNamesMap[name] || name;
const $fc712355d0e1cea7$var$commonRouteEntries = [
    (0, $apqRF.createEntry)((0, $4b91e3ee82bc8bc2$export$dde867834e4a9f47), {
        ufoName: $fc712355d0e1cea7$var$getUFOName(`${(0, $exb0h.ROUTE_GROUPS).PROJECT_SETTINGS_SOFTWARE}-issuetypes`),
        component: (0, $a823ae098f41111f$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $a823ae098f41111f$export$36dcfb52d47cb93a)
        ]
    }),
    (0, $apqRF.createEntry)((0, $4b91e3ee82bc8bc2$export$955e8eef6e3bccfb), {
        component: (0, $7f120fdbd168266c$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $a823ae098f41111f$export$36dcfb52d47cb93a)
        ]
    }),
    (0, $apqRF.createEntry)((0, $4b91e3ee82bc8bc2$export$8ddc76f4b4e66b2b), {
        component: (0, $dde06fb051adc26f$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $dde06fb051adc26f$export$246ec9cdadd2a163)
        ]
    }),
    (0, $apqRF.createEntry)((0, $4b91e3ee82bc8bc2$export$d9dea7be10efa583), {
        component: (0, $b464c86d98b57f45$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $b464c86d98b57f45$export$3633e017e520a1c2)
        ]
    }),
    (0, $apqRF.createEntry)((0, $4b91e3ee82bc8bc2$export$18624b8612cb673d), {
        component: (0, $55014e887c6e53d8$export$2e2bcd8739ae039),
        skeleton: (0, $aHr8P.ProjectSettingsDetailsSkeleton),
        layout: (0, $soOXK.softwareProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $55014e887c6e53d8$export$6f16b5efddd5c646)
        ]
    }),
    (0, $apqRF.createEntry)((0, $4b91e3ee82bc8bc2$export$9d5b42fcb82012dd), {
        skeleton: (0, $aHr8P.ProjectSettingsAccessSkeleton),
        component: (0, $370b0b5abce37189$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $370b0b5abce37189$export$7eee4f97b7a1273)
        ],
        ufoName: 'project-settings.access'
    }),
    (0, $apqRF.createEntry)((0, $4b91e3ee82bc8bc2$export$d782b5257932a66d), {
        component: (0, $370b0b5abce37189$export$45346ed2aa24e3f3)(`/jira/${(0, $d3544903dfb35bb2$export$2954328f6207617a)}`),
        layout: (0, $soOXK.softwareProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $370b0b5abce37189$export$7eee4f97b7a1273)
        ]
    }),
    (0, $apqRF.createEntry)((0, $4b91e3ee82bc8bc2$export$396cdbbd6f2abcea), {
        component: (0, $5188faf12abd07fe$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $5188faf12abd07fe$export$38414b624a749cec)
        ],
        perfMetricKey: 'forms-settings'
    }),
    (0, $apqRF.createEntry)((0, $4b91e3ee82bc8bc2$export$394d8f4806a90d7), {
        component: (0, $11bf8792bea72543$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $11bf8792bea72543$export$a7d63246a10aedd)
        ],
        perfMetricKey: 'form-builder'
    }),
    (0, $apqRF.createEntry)((0, $4b91e3ee82bc8bc2$export$4d430aeb28b702f8), {
        ufoName: `project-settings-automation-${(0, $d3544903dfb35bb2$export$2954328f6207617a)}`,
        component: (0, $f345a9b98bb36af2$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $f345a9b98bb36af2$export$dea5ad7e8eac12ae)
        ]
    }),
    (0, $apqRF.createEntry)((0, $4b91e3ee82bc8bc2$export$61d54e538063bb07), {
        component: (0, $ab8ddffeb833017d$export$2e2bcd8739ae039),
        skeleton: (0, $aHr8P.ProjectSettingsDetailsSkeleton),
        layout: (0, $soOXK.softwareProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $ab8ddffeb833017d$export$b8abcf8aa8f4df56)
        ]
    })
];
const $fc712355d0e1cea7$export$792d387b9973c378 = [
    ...$fc712355d0e1cea7$var$commonRouteEntries,
    (0, $apqRF.createEntry)((0, $4b91e3ee82bc8bc2$export$37e0dbac44df25b9), {
        component: (0, $55014e887c6e53d8$export$2e2bcd8739ae039),
        skeleton: (0, $aHr8P.ProjectSettingsDetailsSkeleton),
        layout: (0, $soOXK.softwareProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $2Fzrk.default),
            horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
            (0, $ixwgj.projectContextResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $55014e887c6e53d8$export$6f16b5efddd5c646)
        ]
    }),
    (0, $apqRF.createEntry)((0, $4b91e3ee82bc8bc2$export$a598c3fe8cbf0c6c), {
        ufoName: 'project-settings.next-gen-features',
        component: (0, $8315385009b2701e$export$2e2bcd8739ae039),
        skeleton: (0, $aHr8P.ProjectSettingsFeaturesSkeleton),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $8315385009b2701e$export$da4d608b99858bfc)
        ]
    }),
    (0, $apqRF.createEntry)((0, $4b91e3ee82bc8bc2$export$c1d1892d6c07135a), {
        ufoName: 'project-settings.software.notifications',
        component: (0, $569782473f887794$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $569782473f887794$export$69a64a29d67ca160)
        ]
    }),
    (0, $apqRF.createEntry)((0, $4b91e3ee82bc8bc2$export$ff4977f79c273b29), {
        ufoName: 'project-settings.software.notifications.issue-logs',
        component: (0, $32a54e7cf7d2fc38$export$4b75df09cc5b4e8e),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $32a54e7cf7d2fc38$export$6960a46ebd209756)
        ],
        entryPoint () {
            return (0, $1ybV0.ff)('jlovep-692-changes-to-project-settings-notifications-page_jqk18') ? (0, $32a54e7cf7d2fc38$export$cd8964bea0e3c2) : undefined;
        }
    }),
    (0, $apqRF.createEntry)((0, $4b91e3ee82bc8bc2$export$c7039de5a4b78802), {
        component: (0, $2ijRB.default)((0, $yyqSx.isDevopsFeatureDisabledInFedRamp), (0, $dgH3j.default), (0, $4d907e26c708a2fe$export$2e2bcd8739ae039)),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $4d907e26c708a2fe$export$ca5dba69148b337)
        ],
        ufoName: 'project-settings.link-opsgenie'
    }),
    (0, $apqRF.createEntry)((0, $4b91e3ee82bc8bc2$export$4e4a4b8762b611), {
        component: (0, $2ijRB.default)((0, $yyqSx.isDevopsFeatureDisabledInFedRamp), (0, $dgH3j.default), (0, $4d907e26c708a2fe$export$2e2bcd8739ae039)),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
            (0, $ixwgj.projectContextResource)
        ],
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $2Fzrk.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $4d907e26c708a2fe$export$ca5dba69148b337)
        ],
        ufoName: 'project-settings.link-opsgenie'
    }),
    (0, $apqRF.createEntry)((0, $4b91e3ee82bc8bc2$export$e3e3877ec9c5e840), {
        component: (0, $2ijRB.default)((0, $yyqSx.isDevopsFeatureDisabledInFedRamp), (0, $dgH3j.default), (0, $8205b3305321c568$export$2e2bcd8739ae039)),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a)),
            (0, $cZXTd.devopsConnectionsResource),
            (0, $3BLIV.projectSettingsToolchainResource),
            (0, $i6Rk2.connectionsPermissionsResource)
        ],
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $8205b3305321c568$export$9d468faf674a5201)
        ],
        ufoName: 'project-settings.devops-connections'
    }),
    (0, $apqRF.createEntry)((0, $4b91e3ee82bc8bc2$export$7dbc23deac9553d4), {
        component: (0, $2ijRB.default)((0, $yyqSx.isDevopsFeatureDisabledInFedRamp), (0, $dgH3j.default), (0, $8205b3305321c568$export$2e2bcd8739ae039)),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
            (0, $ixwgj.projectContextResource),
            (0, $cZXTd.devopsConnectionsResource),
            (0, $3BLIV.projectSettingsToolchainResource),
            (0, $i6Rk2.connectionsPermissionsResource)
        ],
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $2Fzrk.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $8205b3305321c568$export$9d468faf674a5201)
        ],
        ufoName: 'project-settings.devops-connections'
    }),
    (0, $apqRF.createEntry)((0, $4b91e3ee82bc8bc2$export$d4bf23ba6f4199d7), {
        ufoName: 'classic-features-page',
        component: (0, $5b552fe98bc306e0$export$8e6f565615e921dd),
        skeleton: (0, $aHr8P.ProjectSettingsFeaturesSkeleton),
        layout: (0, $soOXK.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $2Fzrk.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
            (0, $ixwgj.projectContextResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $5b552fe98bc306e0$export$79fe16f960f3d89f)
        ]
    }),
    (0, $apqRF.createEntry)((0, $4b91e3ee82bc8bc2$export$5e2e0a895d6a14bd), {
        ufoName: 'project-settings.classic-issue-logs-page',
        component: (0, $32a54e7cf7d2fc38$export$4b75df09cc5b4e8e),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $2Fzrk.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
            (0, $ixwgj.projectContextResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $32a54e7cf7d2fc38$export$6960a46ebd209756)
        ],
        entryPoint () {
            return (0, $1ybV0.ff)('jlovep-692-changes-to-project-settings-notifications-page_jqk18') ? (0, $32a54e7cf7d2fc38$export$cd8964bea0e3c2) : undefined;
        }
    }),
    (0, $apqRF.createEntry)((0, $4b91e3ee82bc8bc2$export$d4ed083331cb6e00), {
        component: (0, $43b053b48a4f88e5$export$2e2bcd8739ae039),
        skeleton: (0, $aHr8P.ProjectSettingsFeaturesSkeleton),
        layout: (0, $soOXK.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $2Fzrk.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
            (0, $ixwgj.projectContextResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $5b552fe98bc306e0$export$79fe16f960f3d89f),
            (0, $43b053b48a4f88e5$export$ea7d73c94d9369f4)
        ]
    }),
    (0, $apqRF.createEntry)((0, $4b91e3ee82bc8bc2$export$b2e044c3dffeca69), {
        component: (0, $d3544903dfb35bb2$export$c9b0516439c55d7a)((0, $d3544903dfb35bb2$export$2954328f6207617a)),
        skeleton: (0, $aHr8P.ProjectSettingsFeaturesSkeleton),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation)
        ]
    }),
    (0, $apqRF.createEntry)((0, $4b91e3ee82bc8bc2$export$6ef734887b6da0c8), {
        resources: [
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        component: $fc712355d0e1cea7$var$LegacyFrontendReleaseNoteRedirect,
        layout: (0, $soOXK.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $5w4hM.genericProjectSidebars),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation)
        ]
    }),
    (0, $apqRF.createEntry)((0, $4b91e3ee82bc8bc2$export$a9509017cabb1e30), {
        resources: [
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        component: $fc712355d0e1cea7$var$LegacyFrontendReleaseNoteRedirect,
        layout: (0, $soOXK.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $5w4hM.genericProjectSidebars),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation)
        ]
    }),
    (0, $apqRF.createEntry)((0, $4b91e3ee82bc8bc2$export$a0223091962262d4), {
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
            (0, $ixwgj.projectContextResource),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        component: $fc712355d0e1cea7$var$SpaReleaseNoteRedirectToVersionDetails,
        layout: (0, $soOXK.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $5w4hM.genericProjectSidebars),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation)
        ]
    }),
    (0, $apqRF.createEntry)((0, $4b91e3ee82bc8bc2$export$46e979217c179afd), {
        component: (0, $f345a9b98bb36af2$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $f345a9b98bb36af2$export$dea5ad7e8eac12ae)
        ]
    }),
    (0, $apqRF.createEntry)((0, $4b91e3ee82bc8bc2$export$2313ca001d58ab27), {
        component: (0, $5188faf12abd07fe$export$2e2bcd8739ae039),
        layout: (0, $soOXK.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $2Fzrk.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $5188faf12abd07fe$export$38414b624a749cec)
        ]
    }),
    (0, $apqRF.createEntry)((0, $4b91e3ee82bc8bc2$export$811ace4fee984f0e), {
        component: (0, $11bf8792bea72543$export$2e2bcd8739ae039),
        layout: (0, $soOXK.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $11bf8792bea72543$export$a7d63246a10aedd)
        ]
    }),
    (0, $apqRF.createEntry)((0, $4b91e3ee82bc8bc2$export$989ca67485551616), {
        component: $fc712355d0e1cea7$var$BoardSettingsRedirectToCSM,
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        isRedirect: true,
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation)
        ]
    }),
    (0, $apqRF.createEntry)((0, $4b91e3ee82bc8bc2$export$88e68eb447e3db49), {
        ufoName: 'software.next-gen.boards.column-status-mapping.page.load',
        component: (0, $8f41cf732a1fc405$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $8f41cf732a1fc405$export$de293ea44d0410ca)
        ]
    }),
    (0, $apqRF.createEntry)((0, $4b91e3ee82bc8bc2$export$9bc9b345958a301c), {
        ufoName: 'project-settings.custom-filters',
        component: (0, $ffcfbf688bad1c50$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a)),
            (0, $a0UvO.customFiltersResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $ffcfbf688bad1c50$export$7e21d36a9d4548e6)
        ]
    }),
    (0, $apqRF.createEntry)((0, $4b91e3ee82bc8bc2$export$d3f185a361401db7), {
        ufoName: 'board-settings-apps.card-cover-settings-page.page.load',
        component: (0, $f45b19cba10dde76$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a)),
            (0, $hbnZD.cardCoverImageResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $f45b19cba10dde76$export$40ff283c032abbc4)
        ]
    }),
    (0, $apqRF.createEntry)((0, $4b91e3ee82bc8bc2$export$17ccdaa366ec26b8), {
        component: $fc712355d0e1cea7$var$RoadmapSettingsRedirectToTimelineSettings,
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a)),
            (0, $a3WTo.roadmapSettingsResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $614d9ce626d4ee80$export$8eca5454e72ee961)
        ]
    }),
    (0, $apqRF.createEntry)((0, $4b91e3ee82bc8bc2$export$e116d6b2a5f71426), {
        ufoName: 'board-settings-apps.roadmap-settings-page.page.load',
        component: (0, $614d9ce626d4ee80$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a)),
            (0, $a3WTo.roadmapSettingsResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $614d9ce626d4ee80$export$8eca5454e72ee961)
        ]
    }),
    (0, $apqRF.createEntry)((0, $4b91e3ee82bc8bc2$export$ae89a2a3aaf095ef), {
        ufoName: 'project-settings-automation-c',
        component: (0, $f345a9b98bb36af2$export$2e2bcd8739ae039),
        layout: (0, $soOXK.classicSoftwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $5w4hM.genericProjectSidebars),
            horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
            (0, $ixwgj.projectContextResource),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $f345a9b98bb36af2$export$dea5ad7e8eac12ae)
        ]
    }),
    (0, $apqRF.createEntry)((0, $4b91e3ee82bc8bc2$export$f74a0b1be9d5b9f6), {
        component: (0, $4cf1bb1e3f20f07f$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $hHrVM.getNavigationSidebarProjectResource)(),
            ...(0, $hHrVM.getNavigationSidebarProjectSettingsResource)(),
            ...(0, $4cf1bb1e3f20f07f$export$33d85a1b2211b38)
        ],
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $2Fzrk.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $4cf1bb1e3f20f07f$export$ef66d3f49a9953d8)
        ]
    }),
    (0, $apqRF.createEntry)((0, $4b91e3ee82bc8bc2$export$1a2cbdfba83d21b), {
        ufoName: 'board-settings-apps.insights-settings-page.page.load',
        component: (0, $3e4476e542b17ea7$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a)),
            (0, $dCvLw.insightsBoardSettingsResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $3e4476e542b17ea7$export$810ecaba1eb55cad)
        ]
    }),
    (0, $apqRF.createEntry)((0, $4b91e3ee82bc8bc2$export$8559c4a0b692890e), {
        component: (0, $4cf1bb1e3f20f07f$export$2e2bcd8739ae039),
        layout: (0, $soOXK.softwareProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $bEe6y.AsyncHorizontalSoftwareProjectNav),
            horizontalFeatureFlag: 'sea-2744-jsw-tabs-nav'
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a)),
            ...(0, $4cf1bb1e3f20f07f$export$33d85a1b2211b38)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $4cf1bb1e3f20f07f$export$ef66d3f49a9953d8)
        ]
    }),
    (0, $apqRF.createEntry)((0, $4b91e3ee82bc8bc2$export$7ce9914683cb1572), {
        component: (0, $d3544903dfb35bb2$export$c9b0516439c55d7a)((0, $d3544903dfb35bb2$export$2954328f6207617a)),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation)
        ]
    }),
    (0, $apqRF.createEntry)((0, $4b91e3ee82bc8bc2$export$99b695c2b8299b5a), {
        component: (0, $d3544903dfb35bb2$export$1b42c08460289a89)((0, $d3544903dfb35bb2$export$2954328f6207617a)),
        layout: (0, $soOXK.softwareProjectLayoutNoOnboarding),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iOOlt.default),
            horizontal: (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $d3544903dfb35bb2$export$586756e5c0542a50)((0, $d3544903dfb35bb2$export$2954328f6207617a))
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation)
        ]
    })
];


const $048cfffd237f6510$export$fd0ef3739cde76c1 = [
    ...(0, $fc712355d0e1cea7$export$792d387b9973c378),
    ...(0, $0ffaa8ee5786ed66$export$37a8204dc4094049),
    ...(0, $e3dc9036898dfae5$export$4bad3905623f839b)
];




var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $apqRF = parcelRequire("apqRF");

var $a5edq = parcelRequire("a5edq");
var $ioEMP = parcelRequire("ioEMP");

var $dAKwA = parcelRequire("dAKwA");

var $ixwgj = parcelRequire("ixwgj");

var $kbHFR = parcelRequire("kbHFR");

var $jwzNs = parcelRequire("jwzNs");

var $gcXWF = parcelRequire("gcXWF");

var $csLgO = parcelRequire("csLgO");


var $eUqFw = parcelRequire("eUqFw");

var $53ciZ = parcelRequire("53ciZ");

var $7rh0R = parcelRequire("7rh0R");

var $exb0h = parcelRequire("exb0h");

var $1ybV0 = parcelRequire("1ybV0");

var $kJlBc = parcelRequire("kJlBc");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $5c8e0d92b8478780$export$bb5ed4e7838cf30c = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("gP7iL"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/board/src/index.tsx"
});

const $5c8e0d92b8478780$export$6828c4b2d0ff0d5d = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("53aZi"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/legacy-board-settings/src/index.tsx"
});
const $5c8e0d92b8478780$export$f058c0d1561d67f3 = (props)=>{
    const { route: route, query: query } = props;
    if (route.name !== (0, $exb0h.ROUTE_NAMES).SERVICEDESK_BOARDS) return null;
    const allowedConfigurations = [
        'columns',
        ...(0, $1ybV0.ff)('jsm-general-board-setting_3f3vq') ? [
            'filter'
        ] : [],
        'quickFilters',
        'swimlanes',
        'cardColors',
        'cardLayout'
    ];
    if (query.config && !allowedConfigurations.includes(query.config)) {
        const { config: config, ...restQuery } = query;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
            to: {
                pathname: props.location.pathname,
                hash: '',
                search: (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify({
                    ...restQuery,
                    config: 'columns'
                })
            }
        });
    }
    return query.config ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $5c8e0d92b8478780$export$6828c4b2d0ff0d5d,
        pageId: "spa-apps/servicedesk/boards/legacy-board-settings",
        shouldShowSpinner: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $5c8e0d92b8478780$export$bb5ed4e7838cf30c,
        pageId: "spa-apps/servicedesk/boards/board",
        shouldShowSpinner: true
    });
};


const $2d3841ea93833e60$export$848a32cf0fcf8a61 = (0, $apqRF.createEntry)((0, $gcXWF.jsmBoardRoute), {
    component: (0, $5c8e0d92b8478780$export$f058c0d1561d67f3),
    layout: (0, $csLgO.serviceProjectLayout),
    skeleton: (0, $e97d2ead64a3cd9f$export$631611c5fdf027d5),
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $5c8e0d92b8478780$export$bb5ed4e7838cf30c),
        (0, $5c8e0d92b8478780$export$6828c4b2d0ff0d5d)
    ],
    perfMetricKey: 'servicedesk-boards-load',
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iTYGl.default)
    },
    exact: true,
    resources: [
        ...(0, $kbHFR.getServiceDeskNavigationResources)(),
        ...(0, $kbHFR.getServicedeskPageContextResources)(),
        (0, $dAKwA.getConsolidationStateResource)(),
        ...(0, $a5edq.getRapidboardResources)(),
        (0, $a5edq.getRapidBoardDataResource)(),
        (0, $jwzNs.resourceWithCondition2)(()=>!false, (0, $ioEMP.uifBoardResource)),
        (0, $ixwgj.projectContextResource)
    ]
});
const $2d3841ea93833e60$export$97cc5f4d7ce032e1 = [
    $2d3841ea93833e60$export$848a32cf0fcf8a61
];



var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");
var $bAQOb = parcelRequire("bAQOb");

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $apqRF = parcelRequire("apqRF");

var $dAKwA = parcelRequire("dAKwA");

var $kbHFR = parcelRequire("kbHFR");

var $fILpt = parcelRequire("fILpt");

var $dgH3j = parcelRequire("dgH3j");

var $exb0h = parcelRequire("exb0h");
const $3e5f137bedbc111a$export$a47f5c93b8a4b678 = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_CALENDAR_EAP,
    path: '/jira/servicedesk/projects/:projectKey/calendar',
    exact: true
};
const $3e5f137bedbc111a$export$28a386a00670c893 = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_CALENDAR,
    path: '/jira/servicedesk/projects/:projectKey/boards/:boardId/calendar',
    exact: true
};



var $csLgO = parcelRequire("csLgO");

var $frZnw = parcelRequire("frZnw");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");
var $b3962be67d2bd367$exports = {};
$b3962be67d2bd367$exports = new URL("classic-calendar-skeleton.tpl.3dcfde16.svg", import.meta.url).toString();


const $293e8909018b8407$export$49d3670908a8d8fe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($b3962be67d2bd367$exports)))
    });




var $7vTKl = parcelRequire("7vTKl");

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $fca2cbe2cad21ee5$export$d55f72843fab18f1 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("iYkTm")), {
        moduleId: "8920c8a8"
    }),
    getPreloadProps: ()=>({})
});



var $1ybV0 = parcelRequire("1ybV0");


var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");
function $0efe2bd1b77b88ef$var$toBoardAri({ siteId: siteId, boardId: boardId }) {
    return `ari:cloud:jira-software:${siteId}:board/${boardId}`;
}
function $0efe2bd1b77b88ef$var$toMidnightUTCString(date) {
    const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    return new Date(utcMilliseconds).toISOString();
}
function $0efe2bd1b77b88ef$var$toDate(date) {
    if (!date) return new Date();
    try {
        const _date = new Date(date);
        return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
    } catch (e) {
        return new Date();
    }
}
function $0efe2bd1b77b88ef$var$createScope({ context: context, tenantContext: tenantContext }) {
    const { cloudId: cloudId } = tenantContext;
    return {
        type: 'board',
        boardId: $0efe2bd1b77b88ef$var$toBoardAri({
            siteId: cloudId,
            boardId: String(context.match.params.boardId)
        }),
        projectKeys: [
            String(context.match.params.projectKey)
        ]
    };
}
function $0efe2bd1b77b88ef$var$buildScopeInput({ tenantContext: tenantContext }, scope) {
    const { cloudId: cloudId } = tenantContext;
    return {
        ids: [
            scope.boardId
        ],
        projectKeys: {
            cloudId: cloudId,
            keys: scope.projectKeys
        }
    };
}
function $0efe2bd1b77b88ef$var$toViewMode(mode) {
    switch(mode){
        case 'week':
            return 'WEEK';
        case 'day':
            return 'DAY';
        default:
            return 'MONTH';
    }
}
function $0efe2bd1b77b88ef$var$toWeekStart(weekStart) {
    switch(weekStart){
        case 'monday':
            return 'MONDAY';
        case 'saturday':
            return 'SATURDAY';
        default:
            return 'SUNDAY';
    }
}
function $0efe2bd1b77b88ef$var$buildConfigurationInput({ selectedDate: selectedDate, viewMode: viewMode, weekStartsOn: weekStartsOn, startDateField: startDateField, endDateField: endDateField }) {
    return {
        date: $0efe2bd1b77b88ef$var$toMidnightUTCString(selectedDate),
        mode: $0efe2bd1b77b88ef$var$toViewMode(viewMode),
        weekStart: $0efe2bd1b77b88ef$var$toWeekStart(weekStartsOn),
        startDateField: startDateField,
        endDateField: endDateField
    };
}
function $0efe2bd1b77b88ef$var$buildIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}
function $0efe2bd1b77b88ef$var$buildUnscheduledIssuesSearchInput() {
    return {
        additionalFilterQuery: ''
    };
}
function $0efe2bd1b77b88ef$var$buildVersionsSearchInput() {
    return {
        versionStatuses: [
            'RELEASED',
            'UNRELEASED'
        ]
    };
}
function $0efe2bd1b77b88ef$var$buildSprintsSearchInput() {
    return {
        sprintStates: [
            'ACTIVE',
            'FUTURE',
            'CLOSED'
        ]
    };
}

const $0efe2bd1b77b88ef$export$19cf4b398f638dc6 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("dKd0o")), {
        moduleId: "7a55ad65"
    }),
    getPreloadProps: (entryPointRouteParams)=>{
        const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
        const { cloudId: cloudId } = tenantContext;
        const { date: date } = context.query;
        const selectedDate = $0efe2bd1b77b88ef$var$toDate(date);
        const { boardId: boardId, projectKey: projectKey } = context.match.params;
        if (!boardId || !projectKey) throw new Error('boardId and projectKey must be provided.');
        const scope = $0efe2bd1b77b88ef$var$createScope(entryPointRouteParams);
        const boardAri = $0efe2bd1b77b88ef$var$toBoardAri({
            siteId: cloudId,
            boardId: boardId
        });
        const viewMode = 'month';
        const weekStartsOn = 'sunday';
        const startDateField = 'startdate';
        const endDateField = 'duedate';
        const issueEventFields = {
            startDateField: startDateField,
            endDateField: endDateField
        };
        return {
            queries: {
                calendarData: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $ae4d1c21cb10f5ab$export$2e2bcd8739ae039,
                    variables: {
                        cloudId: cloudId,
                        projectKey: // @deprecated to be clean up via jsw-adopt-schedule-calendar-issue-mutation_9u2rq feature flag
                        projectKey,
                        boardAri: boardAri,
                        scopeInput: $0efe2bd1b77b88ef$var$buildScopeInput(entryPointRouteParams, scope),
                        configurationInput: $0efe2bd1b77b88ef$var$buildConfigurationInput({
                            selectedDate: selectedDate,
                            viewMode: viewMode,
                            weekStartsOn: weekStartsOn,
                            startDateField: startDateField,
                            endDateField: endDateField
                        }),
                        issuesSearchInput: $0efe2bd1b77b88ef$var$buildIssuesSearchInput(),
                        unscheduledIssuesSearchInput: $0efe2bd1b77b88ef$var$buildUnscheduledIssuesSearchInput(),
                        versionsSearchInput: $0efe2bd1b77b88ef$var$buildVersionsSearchInput(),
                        sprintsSearchInput: $0efe2bd1b77b88ef$var$buildSprintsSearchInput(),
                        skipSprintSearch: false,
                        skipVersionSearch: false,
                        jswmoonSsdReleaseFlyoutUpdateEnabled: (0, $1ybV0.ff)('jswmoon_ssd_release_flyout_update')
                    }
                }
            },
            entryPoints: {},
            extraProps: {
                scope: scope,
                selectedDate: selectedDate,
                viewMode: viewMode,
                weekStartsOn: weekStartsOn,
                issueEventFields: issueEventFields,
                projectKey: projectKey
            }
        };
    }
});


const $c7dc61a1d5caf586$export$3d0fc2d19e97ca21 = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $fca2cbe2cad21ee5$export$d55f72843fab18f1),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});
const $c7dc61a1d5caf586$export$eda0c2fb67f7d7e7 = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $0efe2bd1b77b88ef$export$19cf4b398f638dc6),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});


const $08d75f6faff765b2$export$6e125037f42a1f62 = [
    (0, $apqRF.createEntry)((0, $3e5f137bedbc111a$export$a47f5c93b8a4b678), {
        ufoName: 'jsm.calendar',
        component: (0, $9zysr.componentWithCondition)(()=>(0, $1ybV0.ff)('jsm-calendar-view_bplvu') || (0, $1ybV0.ff)('jsm-calendar-ga_81o9m'), ()=>null, (0, $dgH3j.default)),
        skeleton: (0, $293e8909018b8407$export$49d3670908a8d8fe),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        layout: (0, $csLgO.serviceProjectLayout),
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        entryPoint: ()=>(0, $1ybV0.ff)('jsm-calendar-view_bplvu') || (0, $1ybV0.ff)('jsm-calendar-ga_81o9m') ? (0, $c7dc61a1d5caf586$export$3d0fc2d19e97ca21) : undefined,
        meta: {
            reporting: {
                id: 'calendar',
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).CALENDAR),
                teamName: 'jsd-shield'
            }
        }
    }),
    (0, $apqRF.createEntry)((0, $3e5f137bedbc111a$export$28a386a00670c893), {
        ufoName: 'jsm-calendar',
        component: (0, $bAQOb.componentWithFF)('jsm-calendar-ga_81o9m', ()=>null, (0, $dgH3j.default)),
        skeleton: (0, $293e8909018b8407$export$49d3670908a8d8fe),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        layout: (0, $csLgO.serviceProjectLayout),
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $dAKwA.getConsolidationStateResource)(),
            (0, $fILpt.getCalendarFilterFieldsResource)()
        ],
        entryPoint: ()=>(0, $1ybV0.ff)('jsm-calendar-ga_81o9m') ? (0, $c7dc61a1d5caf586$export$eda0c2fb67f7d7e7) : undefined,
        meta: {
            reporting: {
                id: 'calendar',
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).CALENDAR),
                teamName: 'jsd-shield'
            }
        }
    })
];



var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $apqRF = parcelRequire("apqRF");

var $dAKwA = parcelRequire("dAKwA");

var $kbHFR = parcelRequire("kbHFR");

var $k0e1o = parcelRequire("k0e1o");

var $csLgO = parcelRequire("csLgO");

var $frZnw = parcelRequire("frZnw");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $ff89065b17fb0b7a$export$a6cec2d1c2e631eb = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("bi6Rj"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/change-calendar/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ff89065b17fb0b7a$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $ff89065b17fb0b7a$export$a6cec2d1c2e631eb,
        pageId: "spa-apps/servicedesk/change-calendar",
        shouldShowSpinner: true
    });


const $37ff03730865f0e2$export$38a3aa80b813d565 = [
    (0, $apqRF.createEntry)((0, $k0e1o.servicedeskChangeCalendarRoute), {
        ufoName: 'service-management.change-calendar',
        component: (0, $ff89065b17fb0b7a$export$2e2bcd8739ae039),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        layout: (0, $csLgO.serviceProjectLayout),
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $ff89065b17fb0b7a$export$a6cec2d1c2e631eb)
        ],
        meta: {
            reporting: {
                id: 'changeCalendar',
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).CHANGE_CALENDAR),
                teamName: 'jenga'
            }
        }
    })
];



var $cernH = parcelRequire("cernH");

var $exb0h = parcelRequire("exb0h");

var $bAQOb = parcelRequire("bAQOb");

var $dVvIP = parcelRequire("dVvIP");

var $7vTKl = parcelRequire("7vTKl");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $av9ef = parcelRequire("av9ef");

var $9RvDp = parcelRequire("9RvDp");

const $b745bc543ebd3bd3$export$2260a0528570f8da = (0, $7rh0R.lazyForPaint)(()=>{
    (0, $av9ef.setPerformanceMarkLoadStart)();
    return (parcelRequire("fbNJV")).then((bundle)=>{
        (0, $av9ef.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/assets-reports/src/index.tsx"
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b745bc543ebd3bd3$var$AssetsReportsSidebar = /*#__PURE__*/ (0, $eUqFw.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
        id: "assets-reports-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b745bc543ebd3bd3$export$2260a0528570f8da, null)));
$b745bc543ebd3bd3$var$AssetsReportsSidebar.displayName = 'AssetsReportsSidebar';
var $b745bc543ebd3bd3$export$2e2bcd8739ae039 = $b745bc543ebd3bd3$var$AssetsReportsSidebar;



var $apqRF = parcelRequire("apqRF");

var $c4Cxp = parcelRequire("c4Cxp");

var $hHrVM = parcelRequire("hHrVM");

var $kbHFR = parcelRequire("kbHFR");

var $2R39g = parcelRequire("2R39g");

var $dgH3j = parcelRequire("dgH3j");

var $exb0h = parcelRequire("exb0h");

var $272oI = parcelRequire("272oI");
const $310955c5909c4e4e$export$152b5dead07808bc = {
    name: 'servicedesk-cmdb-assets',
    path: `${(0, $272oI.ASSETS_ROUTE_PREFIX)}`,
    exact: true
};
const $310955c5909c4e4e$export$1efada07b7203f2d = {
    name: 'servicedesk-cmdb-insight',
    path: `${(0, $272oI.INSIGHT_ROUTE_PREFIX)}`,
    exact: true
};
const $310955c5909c4e4e$export$8629431cf690fe39 = {
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_CMDB_ASSETS_REPORTS_DEFAULT_REDIRECT,
    path: `${(0, $272oI.ASSETS_ROUTE_PREFIX)}/reports`,
    exact: true
};
const $310955c5909c4e4e$export$a075d8b7c4c55c41 = {
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_CMDB_ASSETS_REPORTS,
    path: `${(0, $272oI.ASSETS_ROUTE_PREFIX)}/reports/:templateId`,
    exact: true
};
const $310955c5909c4e4e$export$66ab60d374e8e458 = {
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_CMDB_ASSETS_REPORTS_UNSUBSCRIBE,
    path: `${(0, $272oI.ASSETS_ROUTE_PREFIX)}/reports/unsubscribe/:templateId/:subscriptionId`,
    exact: true
};
const $310955c5909c4e4e$export$246ae573df78317e = {
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA,
    path: `${(0, $272oI.ASSETS_ROUTE_PREFIX)}/object-schema/:objectSchemaId`
};
const $310955c5909c4e4e$export$fcde60ded71d4ae6 = {
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA,
    path: `${(0, $272oI.INSIGHT_ROUTE_PREFIX)}/object-schemas/:objectSchemaId`
};
const $310955c5909c4e4e$export$73b901e16d5e5a02 = {
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_CMDB_ASSETS_OBJECT_TYPE_CONFIGURATION,
    path: `${(0, $272oI.ASSETS_ROUTE_PREFIX)}/configure/object-type/:objectTypeId`
};
const $310955c5909c4e4e$export$12e89d5d79d59785 = {
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_CMDB_INSIGHT_OBJECT_TYPE_CONFIGURATION,
    path: `${(0, $272oI.INSIGHT_ROUTE_PREFIX)}/configure/object-type/:objectTypeId`
};
const $310955c5909c4e4e$export$9f6d42997c66cc4b = {
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_CMDB_ASSETS_CONFIGURE,
    path: `${(0, $272oI.ASSETS_ROUTE_PREFIX)}/configure/global`
};
const $310955c5909c4e4e$export$96e5da52356f214c = {
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_CMDB_INSIGHT_CONFIGURE,
    path: `${(0, $272oI.INSIGHT_ROUTE_PREFIX)}/configure/global`
};
const $310955c5909c4e4e$export$b4a150d67181752 = {
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA_CONFIGURATION,
    path: `${(0, $272oI.ASSETS_ROUTE_PREFIX)}/configure/object-schema/:objectSchemaId`
};
const $310955c5909c4e4e$export$f6b688a8729943b3 = {
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA_CONFIGURATION,
    path: `${(0, $272oI.INSIGHT_ROUTE_PREFIX)}/configure/object-schema/:objectSchemaId`
};
const $310955c5909c4e4e$export$e960ab4fcd3e80b6 = {
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_CMDB_INSIGHT_CONFIGURE,
    path: `${(0, $272oI.INSIGHT_ROUTE_PREFIX)}/configure`
};
const $310955c5909c4e4e$export$620f0fb687461e6 = {
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_CMDB_ASSETS_OBJECT,
    path: `${(0, $272oI.ASSETS_ROUTE_PREFIX)}/object/:objectId`
};
const $310955c5909c4e4e$export$223f5bacfd3d39fd = {
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_CMDB_INSIGHT_OBJECT,
    path: `${(0, $272oI.INSIGHT_ROUTE_PREFIX)}/assets/:objectId`
};



var $frZnw = parcelRequire("frZnw");

var $cV47S = parcelRequire("cV47S");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $7fbd4565ada151c8$export$8075d4042713bf6d = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("dnpHo")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-configure/src/index.tsx"
});
const $7fbd4565ada151c8$var$InsightConfigure = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7fbd4565ada151c8$export$8075d4042713bf6d,
        pageId: "spa-apps/servicedesk/insight/cmdb-configure",
        shouldShowSpinner: true
    });
var $7fbd4565ada151c8$export$2e2bcd8739ae039 = $7fbd4565ada151c8$var$InsightConfigure;



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $48483626dba3f677$export$926956539e1f72ba = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("aYi6Q")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-configure-object-type/src/index.tsx"
});
const $48483626dba3f677$var$InsightConfigureObjectType = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $48483626dba3f677$export$926956539e1f72ba,
        pageId: "spa-apps/servicedesk/insight/cmdb-configure-object-type",
        shouldShowSpinner: true
    });
var $48483626dba3f677$export$2e2bcd8739ae039 = $48483626dba3f677$var$InsightConfigureObjectType;



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $f23807fe571bd87e$export$b80bd807bad3fd0a = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("fLw3s")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-configure-v2/src/index.tsx"
});
const $f23807fe571bd87e$var$GlobalConfigure = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $f23807fe571bd87e$export$b80bd807bad3fd0a,
        pageId: "spa-apps/servicedesk/insight/cmdb-configure",
        shouldShowSpinner: true
    });
var $f23807fe571bd87e$export$2e2bcd8739ae039 = $f23807fe571bd87e$var$GlobalConfigure;



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $871b48bcf51415f4$export$f6c79e6ff37913ee = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("eHhZD")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-landing-page/src/index.tsx"
});
const $871b48bcf51415f4$var$LandingPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $871b48bcf51415f4$export$f6c79e6ff37913ee,
        pageId: "spa-apps/servicedesk/insight/cmdb-landing-page",
        shouldShowSpinner: true
    });
var $871b48bcf51415f4$export$2e2bcd8739ae039 = $871b48bcf51415f4$var$LandingPage;



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $06db742a65e6a624$export$411c1981ced22249 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("eSEog")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-object-v2/src/index.tsx"
});
const $06db742a65e6a624$export$3c208f927c6178ee = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $06db742a65e6a624$export$411c1981ced22249,
        pageId: "spa-apps/servicedesk/insight/cmdb-object-v2",
        shouldShowSpinner: true
    });
var $06db742a65e6a624$export$2e2bcd8739ae039 = $06db742a65e6a624$export$3c208f927c6178ee;



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $9f4ca56c5db12e34$export$1e50d5a65ac4f5fc = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("3lVe9")), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-object-schema-v2/src/index.tsx"
});
const $9f4ca56c5db12e34$export$f90a4f33c79fd86e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $9f4ca56c5db12e34$export$1e50d5a65ac4f5fc,
        pageId: "spa-apps/servicedesk/insight/cmdb-object-schema",
        shouldShowSpinner: true
    });
var $9f4ca56c5db12e34$export$2e2bcd8739ae039 = $9f4ca56c5db12e34$export$f90a4f33c79fd86e;



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $dd6bd5053e9cd5f1$export$8305a1bc1c5bee45 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("cjrCp")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-object-schema-configuration/src/index.tsx"
});
const $dd6bd5053e9cd5f1$var$ObjectSchemaConfiguration = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $dd6bd5053e9cd5f1$export$8305a1bc1c5bee45,
        pageId: "spa-apps/servicedesk/insight/cmdb-object-schema-configuration",
        shouldShowSpinner: true
    });
var $dd6bd5053e9cd5f1$export$2e2bcd8739ae039 = $dd6bd5053e9cd5f1$var$ObjectSchemaConfiguration;



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $5b5a57424a20f348$export$9f75cdfdfe8c8aaa = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("8JmcU")).then((exportedMembers)=>exportedMembers.CmdbAssetsReports), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-reports/src/index.tsx"
});

const $5b5a57424a20f348$export$2534c3e9f8e70d0d = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("8JmcU")).then((exportedMembers)=>exportedMembers.CmdbDefaultReportsRedirect), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-reports/src/index.tsx"
});

const $5b5a57424a20f348$export$dec85f15dd805ac4 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("amrg7")), {
    moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-reports-unsubscribe/src/index.tsx"
});
const $5b5a57424a20f348$export$d45b40d40442434 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $5b5a57424a20f348$export$9f75cdfdfe8c8aaa,
        pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports",
        shouldShowSpinner: true
    });
const $5b5a57424a20f348$export$541b39e6d5be07df = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $5b5a57424a20f348$export$dec85f15dd805ac4,
        pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports-unsubscribe",
        shouldShowSpinner: true
    });
const $5b5a57424a20f348$export$4155da54bfeacf74 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $5b5a57424a20f348$export$2534c3e9f8e70d0d,
        pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports-default-redirect",
        shouldShowSpinner: true
    });


const $c14f7e8a0471589a$var$sharedRouteProps = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    layout: (0, $dVvIP.globalLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).INSIGHT
    }
};
const $c14f7e8a0471589a$var$Nullable = null;
const $c14f7e8a0471589a$export$5d38cb53852f589a = [
    (0, $apqRF.createEntry)((0, $310955c5909c4e4e$export$152b5dead07808bc), {
        ...$c14f7e8a0471589a$var$sharedRouteProps,
        component: (0, $871b48bcf51415f4$export$2e2bcd8739ae039),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $cV47S.workspaceResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $871b48bcf51415f4$export$f6c79e6ff37913ee)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-landing-page'
    }),
    (0, $apqRF.createEntry)((0, $310955c5909c4e4e$export$1efada07b7203f2d), {
        ...$c14f7e8a0471589a$var$sharedRouteProps,
        component: (0, $871b48bcf51415f4$export$2e2bcd8739ae039),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $cV47S.workspaceResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $871b48bcf51415f4$export$f6c79e6ff37913ee)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-landing-page'
    }),
    (0, $apqRF.createEntry)((0, $310955c5909c4e4e$export$8629431cf690fe39), {
        ...$c14f7e8a0471589a$var$sharedRouteProps,
        component: (0, $5b5a57424a20f348$export$4155da54bfeacf74),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $cV47S.workspaceResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $5b5a57424a20f348$export$2534c3e9f8e70d0d)
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT),
                teamName: 'ITSM SAGA'
            }
        }
    }),
    (0, $apqRF.createEntry)((0, $310955c5909c4e4e$export$a075d8b7c4c55c41), {
        ...$c14f7e8a0471589a$var$sharedRouteProps,
        component: (0, $bAQOb.componentWithFF)('jsm-assets-reporting_seqk0', (0, $5b5a57424a20f348$export$d45b40d40442434), (0, $dgH3j.default)),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $cV47S.workspaceResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $5b5a57424a20f348$export$9f75cdfdfe8c8aaa)
        ],
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PEOPLE,
            sidebar: (0, $bAQOb.componentWithFF)('jsm-assets-reports-v-1.5_zjgty', (0, $b745bc543ebd3bd3$export$2e2bcd8739ae039), // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            $c14f7e8a0471589a$var$Nullable)
        },
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).INSIGHT_ASSETS_REPORTS,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).INSIGHT_ASSETS_REPORTS),
                teamName: 'ITSM SAGA'
            }
        }
    }),
    (0, $apqRF.createEntry)((0, $310955c5909c4e4e$export$66ab60d374e8e458), {
        ...$c14f7e8a0471589a$var$sharedRouteProps,
        component: (0, $5b5a57424a20f348$export$541b39e6d5be07df),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $cV47S.workspaceResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $5b5a57424a20f348$export$dec85f15dd805ac4)
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE),
                teamName: 'ITSM SAGA'
            }
        }
    }),
    (0, $apqRF.createEntry)((0, $310955c5909c4e4e$export$246ae573df78317e), {
        ...$c14f7e8a0471589a$var$sharedRouteProps,
        component: (0, $9f4ca56c5db12e34$export$f90a4f33c79fd86e),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $cV47S.workspaceResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $9f4ca56c5db12e34$export$1e50d5a65ac4f5fc)
        ],
        perfMetricKey: 'service-management.insight-cmdb.load-schema-page'
    }),
    (0, $apqRF.createEntry)((0, $310955c5909c4e4e$export$fcde60ded71d4ae6), {
        ...$c14f7e8a0471589a$var$sharedRouteProps,
        component: (0, $9f4ca56c5db12e34$export$f90a4f33c79fd86e),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $cV47S.workspaceResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $9f4ca56c5db12e34$export$1e50d5a65ac4f5fc)
        ],
        perfMetricKey: 'service-management.insight-cmdb.load-schema-page'
    }),
    (0, $apqRF.createEntry)((0, $310955c5909c4e4e$export$73b901e16d5e5a02), {
        ...$c14f7e8a0471589a$var$sharedRouteProps,
        component: (0, $48483626dba3f677$export$2e2bcd8739ae039),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $cV47S.workspaceResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $48483626dba3f677$export$926956539e1f72ba)
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION),
                teamName: 'falcons'
            }
        },
        ufoName: 'service-management.insight-cmdb-object-type-configuration'
    }),
    (0, $apqRF.createEntry)((0, $310955c5909c4e4e$export$12e89d5d79d59785), {
        ...$c14f7e8a0471589a$var$sharedRouteProps,
        component: (0, $48483626dba3f677$export$2e2bcd8739ae039),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $cV47S.workspaceResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $48483626dba3f677$export$926956539e1f72ba)
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION),
                teamName: 'falcons'
            }
        }
    }),
    (0, $apqRF.createEntry)((0, $310955c5909c4e4e$export$9f6d42997c66cc4b), {
        ...$c14f7e8a0471589a$var$sharedRouteProps,
        ufoName: 'servicedesk-cmdb-assets-configure',
        component: (0, $f23807fe571bd87e$export$2e2bcd8739ae039),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $cV47S.workspaceResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $f23807fe571bd87e$export$b80bd807bad3fd0a)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-global-config-page',
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION),
                teamName: 'falcons'
            }
        }
    }),
    (0, $apqRF.createEntry)((0, $310955c5909c4e4e$export$96e5da52356f214c), {
        ...$c14f7e8a0471589a$var$sharedRouteProps,
        ufoName: 'servicedesk-cmdb-insight-configure-global',
        component: (0, $f23807fe571bd87e$export$2e2bcd8739ae039),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $cV47S.workspaceResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $f23807fe571bd87e$export$b80bd807bad3fd0a)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-global-config-page',
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION),
                teamName: 'falcons'
            }
        }
    }),
    (0, $apqRF.createEntry)((0, $310955c5909c4e4e$export$b4a150d67181752), {
        ...$c14f7e8a0471589a$var$sharedRouteProps,
        component: (0, $dd6bd5053e9cd5f1$export$2e2bcd8739ae039),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $cV47S.workspaceResource),
            (0, $c4Cxp.serviceDeskAssetsImportTypeForgeDataResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $dd6bd5053e9cd5f1$export$8305a1bc1c5bee45)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-object-schema-config',
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
                teamName: 'krispy-krew'
            }
        }
    }),
    (0, $apqRF.createEntry)((0, $310955c5909c4e4e$export$f6b688a8729943b3), {
        ...$c14f7e8a0471589a$var$sharedRouteProps,
        component: (0, $dd6bd5053e9cd5f1$export$2e2bcd8739ae039),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $cV47S.workspaceResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $dd6bd5053e9cd5f1$export$8305a1bc1c5bee45)
        ],
        perfMetricKey: 'service-management.insight-cmdb.interact-with-object-schema-config',
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
                teamName: 'krispy-krew'
            }
        }
    }),
    (0, $apqRF.createEntry)((0, $310955c5909c4e4e$export$e960ab4fcd3e80b6), {
        ...$c14f7e8a0471589a$var$sharedRouteProps,
        ufoName: 'servicedesk-cmdb-insight-configure',
        component: (0, $7fbd4565ada151c8$export$2e2bcd8739ae039),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $cV47S.workspaceResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7fbd4565ada151c8$export$8075d4042713bf6d)
        ]
    }),
    (0, $apqRF.createEntry)((0, $310955c5909c4e4e$export$620f0fb687461e6), {
        ...$c14f7e8a0471589a$var$sharedRouteProps,
        component: (0, $06db742a65e6a624$export$3c208f927c6178ee),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $cV47S.workspaceResource),
            (0, $2R39g.insightObjectResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $06db742a65e6a624$export$411c1981ced22249)
        ],
        perfMetricKey: 'service-management.insight-cmdb.object-view-page-load',
        ufoName: 'service-management.insight-cmdb.object-view-page-load'
    }),
    (0, $apqRF.createEntry)((0, $310955c5909c4e4e$export$223f5bacfd3d39fd), {
        ...$c14f7e8a0471589a$var$sharedRouteProps,
        component: (0, $06db742a65e6a624$export$3c208f927c6178ee),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $cV47S.workspaceResource),
            (0, $2R39g.insightObjectResource)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $06db742a65e6a624$export$411c1981ced22249)
        ],
        perfMetricKey: 'service-management.insight-cmdb.object-view-page-load',
        ufoName: 'service-management.insight-cmdb.object-view-page-load'
    })
];



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $cernH = parcelRequire("cernH");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $8566d343b6c4211f$export$1f409a894343952a = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_CREATE_PROJECT,
    path: '/jira/servicedesk/create-project',
    exact: true
};



var $csLgO = parcelRequire("csLgO");

var $frZnw = parcelRequire("frZnw");

var $59o4i = parcelRequire("59o4i");

const $2931ee7f95d0e303$export$5004e0d4f1e57790 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("1tqnI")), {
    moduleId: "./src/packages/spa-apps/servicedesk/create-project/src/index.tsx"
});
const $2931ee7f95d0e303$export$ffae8a2776195524 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $2931ee7f95d0e303$export$5004e0d4f1e57790,
        pageId: "spa-apps/servicedesk/create-project",
        shouldShowSpinner: true
    });
const $2931ee7f95d0e303$export$ac25abe07ac3f570 = (0, $apqRF.createEntry)((0, $8566d343b6c4211f$export$1f409a894343952a), {
    isRedirect: true,
    component: $2931ee7f95d0e303$export$ffae8a2776195524,
    layout: (0, $csLgO.serviceProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $2931ee7f95d0e303$export$5004e0d4f1e57790
    ],
    meta: {
        reporting: {
            id: (0, $frZnw.APP_NAMES).CREATE_PROJECT,
            packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).CREATE_PROJECT),
            teamName: 'jsd-shield'
        }
    }
});



var $cernH = parcelRequire("cernH");

var $exb0h = parcelRequire("exb0h");

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $apqRF = parcelRequire("apqRF");

var $dAKwA = parcelRequire("dAKwA");

var $kbHFR = parcelRequire("kbHFR");

var $cgHBu = parcelRequire("cgHBu");
var $77XtT = parcelRequire("77XtT");

var $fjxAH = parcelRequire("fjxAH");

var $csLgO = parcelRequire("csLgO");

var $frZnw = parcelRequire("frZnw");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $1fae4e90433595fb$export$864b519a4059ac6b = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("lwS9x"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/customers-v2/src/index.tsx"
});
const $1fae4e90433595fb$export$ac54d7814cf71dd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $1fae4e90433595fb$export$864b519a4059ac6b,
        pageId: "spa-apps/servicedesk/customers-v2",
        shouldShowSpinner: true
    });

const $1fae4e90433595fb$export$6c5749ec31de847d = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("wY4W8"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/customer-details/src/index.tsx"
});
const $1fae4e90433595fb$export$2412523c0e3657cc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $1fae4e90433595fb$export$6c5749ec31de847d,
        pageId: "spa-apps/servicedesk/customer-details",
        shouldShowSpinner: true
    });


const $b011af7098605060$var$getCustomersRoutesCommon = ()=>({
        group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
        exact: true,
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ]
    });
const $b011af7098605060$export$6811a8ea7ba7651c = [
    (0, $apqRF.createEntry)((0, $fjxAH.servicedeskCustomersV2Route), {
        ...$b011af7098605060$var$getCustomersRoutesCommon(),
        component: (0, $1fae4e90433595fb$export$ac54d7814cf71dd),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $1fae4e90433595fb$export$864b519a4059ac6b)
        ],
        perfMetricKey: 'jsm-customers-component-load',
        ufoName: 'jsm-customers-component-load'
    }),
    (0, $apqRF.createEntry)((0, $fjxAH.servicedeskCustomerDetailsRoute), {
        ...$b011af7098605060$var$getCustomersRoutesCommon(),
        component: (0, $1fae4e90433595fb$export$2412523c0e3657cc),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $1fae4e90433595fb$export$6c5749ec31de847d)
        ],
        perfMetricKey: 'jsm-customer-details-component-load',
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).CUSTOMER_DETAILS,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).CUSTOMER_DETAILS),
                teamName: 'boysenberry'
            }
        },
        resources: [
            ...$b011af7098605060$var$getCustomersRoutesCommon().resources,
            (0, $cgHBu.entitlementsCustomerQueryResource),
            (0, $77XtT.uiCustomerDetailsPageQueryResource)
        ]
    })
];



var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $apqRF = parcelRequire("apqRF");

var $dAKwA = parcelRequire("dAKwA");

var $kbHFR = parcelRequire("kbHFR");

var $4mBNF = parcelRequire("4mBNF");

var $1a6Wh = parcelRequire("1a6Wh");

var $csLgO = parcelRequire("csLgO");
const $f1fa06bfbcc25698$export$8810bfd4f6a0eb22 = (0, $apqRF.createEntry)((0, $1a6Wh.projectServiceDeskRoute), {
    exact: true,
    isRedirect: true,
    component: (0, $4mBNF.RedirectToLastVisitedProjectPage),
    layout: (0, $csLgO.serviceProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iTYGl.default)
    },
    resources: [
        ...(0, $kbHFR.getServiceDeskNavigationResources)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation)
    ]
});



var $1Iui1 = parcelRequire("1Iui1");


var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $7vTKl = parcelRequire("7vTKl");

var $kXWpU = parcelRequire("kXWpU");

var $iTYGl = parcelRequire("iTYGl");

var $apqRF = parcelRequire("apqRF");

var $kbHFR = parcelRequire("kbHFR");

var $47r3J = parcelRequire("47r3J");

var $dgH3j = parcelRequire("dgH3j");

var $kOAof = parcelRequire("kOAof");

var $csLgO = parcelRequire("csLgO");
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");
var $43f187316a9d023e$exports = {};
$43f187316a9d023e$exports = new URL("getting-started-page-app-skeleton.tpl.b9c0d034.svg", import.meta.url).toString();


const $5ed68f414dfe3b03$var$customCssStyles = null;
const $5ed68f414dfe3b03$export$525669daa9599ec = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($43f187316a9d023e$exports))),
        className: (0, $7JEyt.default)([
            "_rcuj1wug _o81c1wug _1l6u1wug _149m1wug _701wukw8 _9qarbrur"
        ])
    });



var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $848d27189a48d1f7$export$a91a58d8bb93ad8e = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("8jb44")), {
        moduleId: "99c912b0"
    }),
    getPreloadProps: ()=>({})
});


const $72b362d5e9f1af01$var$gettingStartedPageEntryPoint = (0, $bf010c1b73a0efa7$export$955a7619d2679b4c)({
    main: (0, $848d27189a48d1f7$export$a91a58d8bb93ad8e),
    topNavigationMenuId: (0, $7vTKl.MENU_ID).PROJECTS
});
const $72b362d5e9f1af01$export$9f5707c751b4b364 = (0, $apqRF.createEntry)((0, $kOAof.gspPageRoute), {
    exact: true,
    layout: (0, $csLgO.serviceProjectLayout),
    perfMetricKey: 'servicedesk-getting-started-page-load',
    skeleton: (0, $5ed68f414dfe3b03$export$525669daa9599ec),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iTYGl.default)
    },
    resources: [
        ...(0, $kbHFR.getServiceDeskNavigationResources)(),
        ...(0, $kbHFR.getServicedeskPageContextResources)(),
        (0, $kXWpU.staticProjectSidebarNavigationResource),
        (0, $47r3J.servicedeskIssueTypesResource)
    ],
    entryPoint () {
        return (0, $1ybV0.ff)('getting_started_page_production_rollout') || [
            (0, $1Iui1.VAR1),
            (0, $1Iui1.VAR2)
        ].includes((0, $79xbN.expVal)('jsm_getting_started_page_fast_follows', 'cohort', 'not-enrolled')) ? $72b362d5e9f1af01$var$gettingStartedPageEntryPoint : undefined;
    },
    component: (0, $dgH3j.default)
});
const $72b362d5e9f1af01$export$abec122151c24b1b = [
    $72b362d5e9f1af01$export$9f5707c751b4b364
];



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $cernH = parcelRequire("cernH");

var $apqRF = parcelRequire("apqRF");

var $hHrVM = parcelRequire("hHrVM");

var $exb0h = parcelRequire("exb0h");
const $af8cbc70a07773c6$export$5bc288fedb880892 = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_ITSM_SAMPLE_SPACE,
    path: '/jira/servicedesk/itsm-sample-space',
    exact: true
};



var $csLgO = parcelRequire("csLgO");

var $frZnw = parcelRequire("frZnw");

var $59o4i = parcelRequire("59o4i");

const $8ae74981a9e1a473$export$c1a5da0c35411fc1 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("dsgwg")), {
    moduleId: "./src/packages/spa-apps/servicedesk/itsm-sample-space/src/index.tsx"
});
const $8ae74981a9e1a473$export$389e7e12a5ae9f5a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $8ae74981a9e1a473$export$c1a5da0c35411fc1,
        pageId: "spa-apps/servicedesk/itsm-sample-space",
        shouldShowSpinner: true
    });
const $8ae74981a9e1a473$export$61ad481262acd4e6 = (0, $apqRF.createEntry)((0, $af8cbc70a07773c6$export$5bc288fedb880892), {
    isRedirect: true,
    component: $8ae74981a9e1a473$export$389e7e12a5ae9f5a,
    layout: (0, $csLgO.serviceProjectLayout),
    resources: [
        ...(0, $hHrVM.getNavigationResources)(),
        ...(0, $hHrVM.getNavigationSidebarProjectResource)()
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $8ae74981a9e1a473$export$c1a5da0c35411fc1
    ],
    perfMetricKey: 'jsm-sample-space-landing-page',
    meta: {
        reporting: {
            id: (0, $frZnw.APP_NAMES).ITSM_SAMPLE_SPACE,
            packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).ITSM_SAMPLE_SPACE),
            teamName: 'jsd-shield'
        }
    }
});



var $cernH = parcelRequire("cernH");

var $1yEMG = parcelRequire("1yEMG");

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $apqRF = parcelRequire("apqRF");

var $bbvOQ = parcelRequire("bbvOQ");

var $dAKwA = parcelRequire("dAKwA");

var $kbHFR = parcelRequire("kbHFR");

var $fsmKq = parcelRequire("fsmKq");

var $csLgO = parcelRequire("csLgO");

var $frZnw = parcelRequire("frZnw");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $5ddbc7aa2f37e5a3$export$c73ba7e80a805fb2 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("k9xav"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-browse-all-articles/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5ddbc7aa2f37e5a3$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $5ddbc7aa2f37e5a3$export$c73ba7e80a805fb2,
        pageId: "spa-apps/servicedesk/knowledge-hub/browse-all-articles",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $b519a0ee4ed17684$export$a488cba75f18ade8 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("fVB0r"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-browse-all-categories/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b519a0ee4ed17684$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $b519a0ee4ed17684$export$a488cba75f18ade8,
        pageId: "spa-apps/servicedesk/knowledge-hub/browse-all-categories",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $6fd84daa3f325c54$export$c01a896b8d33aa9c = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("elNJh"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-category/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6fd84daa3f325c54$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $6fd84daa3f325c54$export$c01a896b8d33aa9c,
        pageId: "spa-apps/servicedesk/knowledge-hub/category",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $1809061a981fe2df$export$53decb9d1eb60aed = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("fhtv7"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-drafts/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1809061a981fe2df$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $1809061a981fe2df$export$53decb9d1eb60aed,
        pageId: "spa-apps/servicedesk/knowledge-hub/drafts",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $1f8dd3006287cca9$export$35c6d2a033ef4c42 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("9L9Xq"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-article-embed-editor/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1f8dd3006287cca9$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $1f8dd3006287cca9$export$35c6d2a033ef4c42,
        pageId: "knowledge-article-embed-editor",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $4e1b5edf2765a2ad$export$f1266a588cfc310b = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("eHbq2")), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-landing/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4e1b5edf2765a2ad$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $4e1b5edf2765a2ad$export$f1266a588cfc310b,
        pageId: "spa-apps/servicedesk/knowledge-hub/landing-page",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $29e85ad8b84aab41$export$6c08040d2dc71e43 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("6m9Ef")), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-setup/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$29e85ad8b84aab41$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $29e85ad8b84aab41$export$6c08040d2dc71e43,
        pageId: "spa-apps/servicedesk/knowledge-hub/setup",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $74cea6e2a2cb8d85$export$aee7d96c2ee4c388 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("d7pHu"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-suggested-articles/src/index.tsx"
});
const $74cea6e2a2cb8d85$export$ee4623542ebd573e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $74cea6e2a2cb8d85$export$aee7d96c2ee4c388,
        pageId: "spa-apps/servicedesk/knowledge-hub/suggested-articles",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $9cedec9347cbc8b6$export$efd0ec49853aa81 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("jbFqF"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-view-article/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9cedec9347cbc8b6$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $9cedec9347cbc8b6$export$efd0ec49853aa81,
        pageId: "spa-apps/servicedesk/knowledge-hub/view-article",
        shouldShowSpinner: true
    });


const $a254fc0ce0bc8828$var$getKnowledgeHubResources = ()=>[
        ...(0, $kbHFR.getServicedeskPageContextResources)(),
        (0, $bbvOQ.kbConfluenceContextResource)
    ];
const $a254fc0ce0bc8828$export$f1453c3517242ca1 = [
    (0, $apqRF.createEntry)((0, $fsmKq.knowledgeHubLandingRoute), {
        component: (0, $4e1b5edf2765a2ad$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            horizontal: (0, $1yEMG.AsyncKbNav),
            horizontalFeatureFlag: 'jsm-kb-nav-refresh-changes-enabled'
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...$a254fc0ce0bc8828$var$getKnowledgeHubResources(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $4e1b5edf2765a2ad$export$f1266a588cfc310b)
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).KB_LANDING,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).KB_LANDING),
                teamName: 'jsm-nebula'
            }
        }
    }),
    (0, $apqRF.createEntry)((0, $fsmKq.knowledgeHubBrowseAllArticlesRoute), {
        component: (0, $5ddbc7aa2f37e5a3$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            horizontal: (0, $1yEMG.AsyncKbNav),
            horizontalFeatureFlag: 'jsm-kb-nav-refresh-changes-enabled'
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...$a254fc0ce0bc8828$var$getKnowledgeHubResources(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $5ddbc7aa2f37e5a3$export$c73ba7e80a805fb2)
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).KB_BROWSE_ARTICLES,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).KB_BROWSE_ARTICLES),
                teamName: 'jsm-nebula'
            }
        }
    }),
    (0, $apqRF.createEntry)((0, $fsmKq.knowledgeHubDraftsRoute), {
        component: (0, $1809061a981fe2df$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            horizontal: (0, $1yEMG.AsyncKbNav),
            horizontalFeatureFlag: 'jsm-kb-nav-refresh-changes-enabled'
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...$a254fc0ce0bc8828$var$getKnowledgeHubResources(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $1809061a981fe2df$export$53decb9d1eb60aed)
        ],
        perfMetricKey: 'service-management.kb-drafts',
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).KB_DRAFTS,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).KB_DRAFTS),
                teamName: 'jsm-nebula'
            }
        }
    }),
    (0, $apqRF.createEntry)((0, $fsmKq.knowledgeHubBrowseAllCategoriesRoute), {
        component: (0, $b519a0ee4ed17684$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            horizontal: (0, $1yEMG.AsyncKbNav),
            horizontalFeatureFlag: 'jsm-kb-nav-refresh-changes-enabled'
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...$a254fc0ce0bc8828$var$getKnowledgeHubResources(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $b519a0ee4ed17684$export$a488cba75f18ade8)
        ],
        perfMetricKey: 'service-management.kb-categories',
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).KB_BROWSE_CATEGORIES,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).KB_BROWSE_CATEGORIES),
                teamName: 'jsm-nebula'
            }
        }
    }),
    (0, $apqRF.createEntry)((0, $fsmKq.knowledgeHubSuggestedArticlesRoute), {
        component: (0, $74cea6e2a2cb8d85$export$ee4623542ebd573e),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            horizontal: (0, $1yEMG.AsyncKbNav),
            horizontalFeatureFlag: 'jsm-kb-nav-refresh-changes-enabled'
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...$a254fc0ce0bc8828$var$getKnowledgeHubResources(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $74cea6e2a2cb8d85$export$aee7d96c2ee4c388)
        ],
        perfMetricKey: 'service-management.kb-suggested-articles',
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).KB_SUGGESTED_ARTICLES,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).KB_SUGGESTED_ARTICLES),
                teamName: 'jsm-nebula'
            }
        }
    }),
    (0, $apqRF.createEntry)((0, $fsmKq.knowledgeHubBrowseViewArticleRoute), {
        perfMetricKey: 'service-management.knowledge.article',
        component: (0, $9cedec9347cbc8b6$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...$a254fc0ce0bc8828$var$getKnowledgeHubResources(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $9cedec9347cbc8b6$export$efd0ec49853aa81)
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).KB_VIEW_ARTICLE,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).KB_VIEW_ARTICLE),
                teamName: 'jsm-nebula'
            }
        }
    }),
    (0, $apqRF.createEntry)((0, $fsmKq.knowledgeHubArticleEmbedEditorRoute), {
        component: (0, $1f8dd3006287cca9$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...$a254fc0ce0bc8828$var$getKnowledgeHubResources()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $1f8dd3006287cca9$export$35c6d2a033ef4c42)
        ],
        perfMetricKey: 'service-management.knowledge.ep-editor'
    }),
    (0, $apqRF.createEntry)((0, $fsmKq.knowledgeHubAllArticlesRoute), {
        component: (0, $5ddbc7aa2f37e5a3$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            horizontal: (0, $1yEMG.AsyncKbNav),
            horizontalFeatureFlag: 'jsm-kb-nav-refresh-changes-enabled'
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...$a254fc0ce0bc8828$var$getKnowledgeHubResources(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $5ddbc7aa2f37e5a3$export$c73ba7e80a805fb2)
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).KB_BROWSE_ARTICLES,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).KB_BROWSE_ARTICLES),
                teamName: 'jsm-nebula'
            }
        }
    }),
    (0, $apqRF.createEntry)((0, $fsmKq.knowledgeHubArticleInCategoryRoute), {
        perfMetricKey: 'service-management.knowledge.article',
        component: (0, $9cedec9347cbc8b6$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...$a254fc0ce0bc8828$var$getKnowledgeHubResources(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $9cedec9347cbc8b6$export$efd0ec49853aa81)
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).KB_VIEW_ARTICLE,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).KB_VIEW_ARTICLE),
                teamName: 'jsm-nebula'
            }
        }
    }),
    (0, $apqRF.createEntry)((0, $fsmKq.knowledgeHubCategoryPageRoute), {
        component: (0, $6fd84daa3f325c54$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...$a254fc0ce0bc8828$var$getKnowledgeHubResources(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $6fd84daa3f325c54$export$c01a896b8d33aa9c)
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).KB_CATEGORY,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).KB_CATEGORY),
                teamName: 'jsm-nebula'
            }
        }
    }),
    (0, $apqRF.createEntry)((0, $fsmKq.knowledgeHubCategoryRoute), {
        ufoName: 'service-management.knowledge.category',
        component: (0, $6fd84daa3f325c54$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...$a254fc0ce0bc8828$var$getKnowledgeHubResources(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $6fd84daa3f325c54$export$c01a896b8d33aa9c)
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).KB_CATEGORY,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).KB_CATEGORY),
                teamName: 'jsm-nebula'
            }
        }
    }),
    (0, $apqRF.createEntry)((0, $fsmKq.knowledgeHubSearchRoute), {
        component: (0, $9cedec9347cbc8b6$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default),
            horizontal: (0, $1yEMG.AsyncKbNav),
            horizontalFeatureFlag: 'jsm-kb-nav-refresh-changes-enabled'
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...$a254fc0ce0bc8828$var$getKnowledgeHubResources(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $9cedec9347cbc8b6$export$efd0ec49853aa81)
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).KB_VIEW_ARTICLE,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).KB_VIEW_ARTICLE),
                teamName: 'jsm-nebula'
            }
        }
    }),
    (0, $apqRF.createEntry)((0, $fsmKq.knowledgeHubSetupRoute), {
        component: (0, $29e85ad8b84aab41$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...$a254fc0ce0bc8828$var$getKnowledgeHubResources(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $29e85ad8b84aab41$export$6c08040d2dc71e43)
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).KB_SETUP,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).KB_SETUP),
                teamName: 'jsm-nebula'
            }
        }
    })
];



var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $apqRF = parcelRequire("apqRF");

var $dAKwA = parcelRequire("dAKwA");

var $kbHFR = parcelRequire("kbHFR");

var $5Z6fS = parcelRequire("5Z6fS");

var $csLgO = parcelRequire("csLgO");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $9607b86898869629$export$69cba5247233f8bc = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("eUjPI"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/notification-logs/src/index.tsx"
});
const $9607b86898869629$export$1139895a5af7252e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $9607b86898869629$export$69cba5247233f8bc,
        pageId: "spa-apps/servicedesk/notification-logs",
        shouldShowSpinner: true
    });


const $18d5247f51aff8ac$export$20ab3a955246df95 = (0, $apqRF.createEntry)((0, $5Z6fS.notificationLogsRoute), {
    layout: (0, $csLgO.serviceProjectLayout),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iTYGl.default)
    },
    resources: [
        ...(0, $kbHFR.getServiceDeskNavigationResources)(),
        ...(0, $kbHFR.getServicedeskPageContextResources)(),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    component: (0, $9607b86898869629$export$1139895a5af7252e),
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        (0, $9607b86898869629$export$69cba5247233f8bc)
    ],
    perfMetricKey: 'jsm-notification-logs-component-load'
});



var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $apqRF = parcelRequire("apqRF");

var $dAKwA = parcelRequire("dAKwA");

var $kbHFR = parcelRequire("kbHFR");

var $giKK2 = parcelRequire("giKK2");

var $csLgO = parcelRequire("csLgO");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $c84e22fc3fbcbc34$export$e8392650fdcd92d5 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("a2XkH")), {
    moduleId: "./src/packages/spa-apps/servicedesk/opsgenie-schedule/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c84e22fc3fbcbc34$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $c84e22fc3fbcbc34$export$e8392650fdcd92d5,
        pageId: "spa-apps/servicedesk/opsgenie-schedule",
        shouldShowSpinner: true
    });


const $897b4311b3dc269c$export$8e210af71fea11c9 = [
    (0, $apqRF.createEntry)((0, $giKK2.servicedeskOncallScheduleRoute), {
        ufoName: 'service-management.on-call-schedule',
        component: (0, $c84e22fc3fbcbc34$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $c84e22fc3fbcbc34$export$e8392650fdcd92d5)
        ]
    })
];



var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $apqRF = parcelRequire("apqRF");

var $dAKwA = parcelRequire("dAKwA");

var $b1sy2 = parcelRequire("b1sy2");

var $bU9Sz = parcelRequire("bU9Sz");

var $kbHFR = parcelRequire("kbHFR");

var $9LviW = parcelRequire("9LviW");

var $exb0h = parcelRequire("exb0h");
const $75f62ade094ca022$export$7f878f9aeac61f1e = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_ORGANIZATION_V2,
    path: '/jira/servicedesk/projects/:projectKey/organization/:organizationId',
    exact: true
};



var $csLgO = parcelRequire("csLgO");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $2e7b4e8e97b4bc53$export$1c7fcdb58f42db03 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("lKl3G"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/organization-v2/src/index.tsx"
});
const $2e7b4e8e97b4bc53$export$5f69663d85db303d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $2e7b4e8e97b4bc53$export$1c7fcdb58f42db03,
        pageId: "spa-apps/servicedesk/organization-v2",
        shouldShowSpinner: true
    });


const $8c3a0add719ffed8$export$f32a63b509fcdb4f = [
    (0, $apqRF.createEntry)((0, $75f62ade094ca022$export$7f878f9aeac61f1e), {
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $9LviW.serviceDeskOrganizationPanelForgeDataResource),
            (0, $dAKwA.getConsolidationStateResource)(),
            (0, $bU9Sz.productsJsmOrganizationDetailsResource),
            (0, $b1sy2.jsmEmailDomainsListResource)
        ],
        component: (0, $2e7b4e8e97b4bc53$export$5f69663d85db303d),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $2e7b4e8e97b4bc53$export$1c7fcdb58f42db03)
        ],
        perfMetricKey: 'jsm-organizations-component-load'
    })
];



var $cernH = parcelRequire("cernH");

var $exb0h = parcelRequire("exb0h");

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $apqRF = parcelRequire("apqRF");

var $dAKwA = parcelRequire("dAKwA");

var $b1sy2 = parcelRequire("b1sy2");

var $bU9Sz = parcelRequire("bU9Sz");

var $kbHFR = parcelRequire("kbHFR");

var $a5AeJ = parcelRequire("a5AeJ");
var $eJxBd = parcelRequire("eJxBd");

var $7FYcB = parcelRequire("7FYcB");

var $csLgO = parcelRequire("csLgO");

var $frZnw = parcelRequire("frZnw");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $40de1bba437701ab$export$b40b4bfa472057b9 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("309WT"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/organizations/src/index.tsx"
});
const $40de1bba437701ab$export$4abec67d7b34dda2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $40de1bba437701ab$export$b40b4bfa472057b9,
        pageId: "spa-apps/servicedesk/organizations",
        shouldShowSpinner: true
    });

const $40de1bba437701ab$export$4a01866152e4a375 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("2ue3R"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/organization-details/src/index.tsx"
});
const $40de1bba437701ab$export$709be875ca0a7ead = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $40de1bba437701ab$export$4a01866152e4a375,
        pageId: "spa-apps/servicedesk/organization-details",
        shouldShowSpinner: true
    });


const $be3c302f353d15b5$var$getOrganizationsRoutesCommon = ()=>({
        group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
        exact: true,
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ]
    });
const $be3c302f353d15b5$export$7dd191d527f3ef6f = [
    (0, $apqRF.createEntry)((0, $7FYcB.servicedeskOrganizationsRoute), {
        ...$be3c302f353d15b5$var$getOrganizationsRoutesCommon(),
        component: (0, $40de1bba437701ab$export$4abec67d7b34dda2),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $40de1bba437701ab$export$b40b4bfa472057b9)
        ],
        perfMetricKey: 'jsm-organizations-component-load',
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).ORGANIZATIONS,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).ORGANIZATIONS),
                teamName: 'boysenberry'
            }
        }
    }),
    (0, $apqRF.createEntry)((0, $7FYcB.servicedeskOrganizationDetailsRoute), {
        ...$be3c302f353d15b5$var$getOrganizationsRoutesCommon(),
        component: (0, $40de1bba437701ab$export$709be875ca0a7ead),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $40de1bba437701ab$export$4a01866152e4a375)
        ],
        perfMetricKey: 'jsm-organization-details-component-load',
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).ORGANIZATION_DETAILS,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).ORGANIZATION_DETAILS),
                teamName: 'boysenberry'
            }
        },
        resources: [
            ...$be3c302f353d15b5$var$getOrganizationsRoutesCommon().resources,
            (0, $a5AeJ.entitlementsOrganizationQueryResource),
            (0, $eJxBd.uiOrganizationDetailsPageQueryResource),
            (0, $bU9Sz.productsJsmOrganizationDetailsResource),
            (0, $b1sy2.jsmEmailDomainsListResource)
        ]
    })
];



var $cernH = parcelRequire("cernH");


var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $isbb2 = parcelRequire("isbb2");

var $apqRF = parcelRequire("apqRF");

var $7JKBZ = parcelRequire("7JKBZ");

var $dAKwA = parcelRequire("dAKwA");

var $kbHFR = parcelRequire("kbHFR");


var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $cernH = parcelRequire("cernH");


var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $isbb2 = parcelRequire("isbb2");

var $apqRF = parcelRequire("apqRF");

var $7JKBZ = parcelRequire("7JKBZ");

var $dAKwA = parcelRequire("dAKwA");

var $kbHFR = parcelRequire("kbHFR");


var $eD2UT = parcelRequire("eD2UT");

var $csLgO = parcelRequire("csLgO");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $6a72616216ae3f5d$var$LazyServicedeskQueuesAgentAndIssueView = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("c5Ngx"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-agent-and-issue-view/src/index.tsx"
});
const $6a72616216ae3f5d$export$59d555419fbaa611 = ({ match: match })=>{
    const queueId = match.params && match.params.queueId || '';
    const issueKey = match.params && match.params.issueKey || '';
    const oldIssueView = `/${match.query && match.query.oldIssueView || ''}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $6a72616216ae3f5d$var$LazyServicedeskQueuesAgentAndIssueView,
        pageId: `spa-apps/servicedesk/queues/${queueId}/${issueKey}/${oldIssueView}`,
        shouldShowSpinner: true
    });
};
const $6a72616216ae3f5d$export$54a295e04e6cea33 = (0, $apqRF.createEntry)((0, $eD2UT.customQueueRoute), {
    query: [
        'oldIssueView?'
    ],
    exact: true,
    component: $6a72616216ae3f5d$export$59d555419fbaa611,
    layout: (0, $isbb2.composeLayouts)((0, $csLgO.serviceProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
        {
            params: [
                {
                    key: 'issueKey'
                }
            ]
        }
    ])),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iTYGl.default)
    },
    resources: [
        ...(0, $kbHFR.getQueuesResources)(),
        ...(0, $kbHFR.getInsightResources)(),
        (0, $7JKBZ.newIssueViewLockInStatusResource),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    afterPaint: [
        (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $6a72616216ae3f5d$var$LazyServicedeskQueuesAgentAndIssueView
    ]
});
const $6a72616216ae3f5d$export$b43128c9b5db2a5e = (0, $apqRF.createEntry)((0, $eD2UT.customPracticeQueueRoute), {
    query: [
        'oldIssueView?'
    ],
    exact: true,
    component: $6a72616216ae3f5d$export$59d555419fbaa611,
    layout: (0, $isbb2.composeLayouts)((0, $csLgO.serviceProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
        {
            params: [
                {
                    key: 'issueKey'
                }
            ]
        }
    ])),
    navigation: {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        sidebar: (0, $iTYGl.default)
    },
    resources: [
        ...(0, $kbHFR.getQueuesResources)(),
        ...(0, $kbHFR.getKnowledgeBaseResources)(),
        ...(0, $kbHFR.getInsightResources)(),
        (0, $7JKBZ.newIssueViewLockInStatusResource),
        (0, $dAKwA.getConsolidationStateResource)()
    ],
    afterPaint: [
        (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
    ],
    forPaint: [
        (0, $cernH.LazyAtlassianNavigation),
        $6a72616216ae3f5d$var$LazyServicedeskQueuesAgentAndIssueView
    ]
});



var $exb0h = parcelRequire("exb0h");
const $519a0f7740a57837$export$e146d4ae5415aa9 = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_ISSUE,
    path: '/jira/servicedesk/projects/:projectKey/issue/:issueKey',
    exact: true
};
const $519a0f7740a57837$export$52b4c044e4929ebc = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_QUEUES_LANDING,
    // Supporting optional /default for legacy backwards compatability
    path: '/jira/servicedesk/projects/:projectKey/queues/(default|custom)?',
    exact: true
};
const $519a0f7740a57837$export$c1908994722d1e73 = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_QUEUES_NEW,
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/new',
    query: [
        'parentId?'
    ],
    exact: true
};
const $519a0f7740a57837$export$f8fd3a1f8c33aff8 = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_QUEUES_EDIT,
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/edit',
    exact: true
};
const $519a0f7740a57837$export$52a24b9cf42d208b = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_QUEUES_ISSUE,
    path: '/jira/servicedesk/projects/:projectKey/queues/issue/:issueKey',
    query: [
        'oldIssueView?'
    ],
    exact: true
};
const $519a0f7740a57837$export$7f30d40b906894c5 = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_QUEUES_MANAGE_VIEW,
    path: '/jira/servicedesk/projects/:projectKey/queues/queue-settings',
    exact: true
};
const $519a0f7740a57837$export$1465f05b88a63f13 = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_QUEUES_ADDON,
    path: '/jira/servicedesk/projects/:projectKey/queues/addon/:addonKey',
    exact: true
};
const $519a0f7740a57837$export$3c859c71be33b36c = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_PRACTICE_LANDING,
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/(custom)?',
    exact: true
};
const $519a0f7740a57837$export$8595a5452f93a1fd = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_PRACTICE_NEW,
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/new',
    query: [
        'parentId?'
    ],
    exact: true
};
const $519a0f7740a57837$export$125e0ab662806584 = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_PRACTICE_MANAGE_VIEW,
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/queue-settings',
    exact: true
};
const $519a0f7740a57837$export$dfaa99f66db1aa2 = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_PRACTICE_EDIT,
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/edit',
    exact: true
};
const $519a0f7740a57837$export$38a6ee0f22e74bf3 = {
    group: (0, $exb0h.ROUTE_GROUPS).SERVICEDESK,
    name: (0, $exb0h.ROUTE_NAMES).SERVICEDESK_PRACTICE_ISSUE,
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/issue/:issueKey',
    exact: true
};



var $csLgO = parcelRequire("csLgO");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $10295f6ff28336b4$export$451a7cce84b6b1e6 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("keS35")), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-addon-view/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$10295f6ff28336b4$export$2e2bcd8739ae039 = ({ match: match })=>{
    const addonKey = match.params && match.params.addonKey || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $10295f6ff28336b4$export$451a7cce84b6b1e6,
        pageId: `spa-apps/servicedesk/queues/addon/${addonKey}`,
        shouldShowSpinner: true
    });
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $a74339164dbab1b0$export$c050b699bf9e3e40 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("ejpwM"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-create-view/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a74339164dbab1b0$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $a74339164dbab1b0$export$c050b699bf9e3e40,
        pageId: "spa-apps/servicedesk/queues/create",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $8e13e6542c859d39$export$5bb02347e0261e6a = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("if5lM"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-edit-view/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8e13e6542c859d39$export$2e2bcd8739ae039 = ({ match: match })=>{
    const queueId = match.params && match.params.queueId || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $8e13e6542c859d39$export$5bb02347e0261e6a,
        pageId: `spa-apps/servicedesk/queues/edit/${queueId}`,
        shouldShowSpinner: true
    });
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $e2dea19c4bd6b26b$export$164f2dfdd8dc056b = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("fZleD")), {
    ssr: false,
    moduleId: "./src/packages/spa-apps/servicedesk/queues-issue-view/src/index.tsx"
});
var /**
 * Constructs a URL path for navigating to a specific issue view within a service desk queue, incorporating optional parameters for issue identification and view customization.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$e2dea19c4bd6b26b$export$2e2bcd8739ae039 = ({ match: match })=>{
    const issueKey = `/${match.params && match.params.issueKey || ''}`;
    const queueId = `/${match.params && match.params.queueId || ''}`;
    const oldIssueView = `/${match.query && match.query.oldIssueView || ''}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $e2dea19c4bd6b26b$export$164f2dfdd8dc056b,
        pageId: `spa-apps/servicedesk/queues/issue${queueId}${issueKey}${oldIssueView}`,
        shouldShowSpinner: true
    });
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $ae55474111205677$export$bdf522692228bb6f = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("wVpFN")), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-landing/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ae55474111205677$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $ae55474111205677$export$bdf522692228bb6f,
        pageId: "spa-apps/servicedesk/queues/landing",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $6884213eeaccf9b5$export$9f1e189198f08c4a = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("fJDd6"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-manage-view/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6884213eeaccf9b5$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $6884213eeaccf9b5$export$9f1e189198f08c4a,
        pageId: "spa-apps/servicedesk/queues/manage",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $0462d312b9b2dd3d$export$52593b5917c5e179 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("e8Xy9")), {
    moduleId: "./src/packages/spa-apps/servicedesk/queues-issue-view-redirect/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0462d312b9b2dd3d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $0462d312b9b2dd3d$export$52593b5917c5e179,
        pageId: "spa-apps/servicedesk/queues/issue-view-redirect",
        shouldShowSpinner: true
    });


const $d0bc8c375af4b440$export$91a360c2f7f83db9 = [
    (0, $apqRF.createEntry)((0, $519a0f7740a57837$export$e146d4ae5415aa9), {
        component: (0, $0462d312b9b2dd3d$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getQueuesResources)(),
            ...(0, $kbHFR.getKnowledgeBaseResources)(),
            ...(0, $kbHFR.getInsightResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $0462d312b9b2dd3d$export$52593b5917c5e179)
        ]
    }),
    (0, $apqRF.createEntry)((0, $519a0f7740a57837$export$52b4c044e4929ebc), {
        isRedirect: true,
        component: (0, $ae55474111205677$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getQueuesResources)(),
            (0, $7JKBZ.newIssueViewLockInStatusResource),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $ae55474111205677$export$bdf522692228bb6f)
        ]
    }),
    (0, $apqRF.createEntry)((0, $519a0f7740a57837$export$c1908994722d1e73), {
        component: (0, $a74339164dbab1b0$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getQueuesResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $a74339164dbab1b0$export$c050b699bf9e3e40)
        ],
        ufoName: 'service-management.queues.new'
    }),
    (0, $apqRF.createEntry)((0, $519a0f7740a57837$export$f8fd3a1f8c33aff8), {
        component: (0, $8e13e6542c859d39$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getQueuesResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $8e13e6542c859d39$export$5bb02347e0261e6a)
        ],
        ufoName: 'service-management.queues.edit'
    }),
    (0, $6a72616216ae3f5d$export$54a295e04e6cea33),
    (0, $apqRF.createEntry)((0, $519a0f7740a57837$export$52a24b9cf42d208b), {
        component: (0, $e2dea19c4bd6b26b$export$2e2bcd8739ae039),
        layout: (0, $isbb2.composeLayouts)((0, $csLgO.serviceProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
            {
                params: [
                    {
                        key: 'issueKey'
                    }
                ]
            }
        ])),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getQueuesResources)(),
            ...(0, $kbHFR.getKnowledgeBaseResources)(),
            ...(0, $kbHFR.getInsightResources)(),
            (0, $7JKBZ.newIssueViewLockInStatusResource),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $e2dea19c4bd6b26b$export$164f2dfdd8dc056b)
        ]
    }),
    (0, $apqRF.createEntry)((0, $519a0f7740a57837$export$7f30d40b906894c5), {
        component: (0, $6884213eeaccf9b5$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: (0, $kbHFR.getQueuesResources)(),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $6884213eeaccf9b5$export$9f1e189198f08c4a)
        ]
    }),
    (0, $apqRF.createEntry)((0, $519a0f7740a57837$export$1465f05b88a63f13), {
        component: (0, $10295f6ff28336b4$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getQueuesResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $10295f6ff28336b4$export$451a7cce84b6b1e6)
        ]
    }),
    (0, $apqRF.createEntry)((0, $519a0f7740a57837$export$3c859c71be33b36c), {
        isRedirect: true,
        component: (0, $ae55474111205677$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getQueuesResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $ae55474111205677$export$bdf522692228bb6f)
        ]
    }),
    (0, $apqRF.createEntry)((0, $519a0f7740a57837$export$8595a5452f93a1fd), {
        component: (0, $a74339164dbab1b0$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getQueuesResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $a74339164dbab1b0$export$c050b699bf9e3e40)
        ]
    }),
    (0, $apqRF.createEntry)((0, $519a0f7740a57837$export$125e0ab662806584), {
        component: (0, $6884213eeaccf9b5$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: (0, $kbHFR.getQueuesResources)(),
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $6884213eeaccf9b5$export$9f1e189198f08c4a)
        ]
    }),
    (0, $apqRF.createEntry)((0, $519a0f7740a57837$export$dfaa99f66db1aa2), {
        component: (0, $8e13e6542c859d39$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getQueuesResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $8e13e6542c859d39$export$5bb02347e0261e6a)
        ]
    }),
    (0, $6a72616216ae3f5d$export$b43128c9b5db2a5e),
    (0, $apqRF.createEntry)((0, $519a0f7740a57837$export$38a6ee0f22e74bf3), {
        component: (0, $e2dea19c4bd6b26b$export$2e2bcd8739ae039),
        layout: (0, $isbb2.composeLayouts)((0, $csLgO.serviceProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)()),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getQueuesResources)(),
            ...(0, $kbHFR.getKnowledgeBaseResources)(),
            ...(0, $kbHFR.getInsightResources)(),
            (0, $7JKBZ.newIssueViewLockInStatusResource),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $e2dea19c4bd6b26b$export$164f2dfdd8dc056b)
        ]
    })
];



var $eUqFw = parcelRequire("eUqFw");

var $cernH = parcelRequire("cernH");


var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $isbb2 = parcelRequire("isbb2");

var $apqRF = parcelRequire("apqRF");
var $kJlBc = parcelRequire("kJlBc");

var $7JKBZ = parcelRequire("7JKBZ");

var $bbvOQ = parcelRequire("bbvOQ");

var $dAKwA = parcelRequire("dAKwA");

var $1iICl = parcelRequire("1iICl");

var $kbHFR = parcelRequire("kbHFR");


var $5VjfX = parcelRequire("5VjfX");

var $csLgO = parcelRequire("csLgO");

var $frZnw = parcelRequire("frZnw");
const $d969dacb8f3e7e46$export$e4c007d05145b8c2 = '/reports/all-rating';
const $d969dacb8f3e7e46$export$5daa28d10e23592 = '/:issueKey';
const $d969dacb8f3e7e46$export$ddc580d759168f88 = '/reports/workload';



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $bcc6627efeceef63$export$75e043cf7a4e3661 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("hxKw9")), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports/src/index.tsx"
});
var /**
 * Dynamically loads the ServicedeskReports component, enhancing user experience by using deferred loading with a visual feedback.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcc6627efeceef63$export$2e2bcd8739ae039 = ({ match: match })=>{
    const oldIssueView = `/${match.query && match.query.oldIssueView || ''}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $bcc6627efeceef63$export$75e043cf7a4e3661,
        pageId: `spa-apps/servicedesk/reports/${match ? match.url : ''}${oldIssueView}`,
        shouldShowSpinner: true
    });
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $2e86ec7ecdee93de$export$78ffe2f6530d45d1 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("chTri"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/atlassian-analytics/src/index.tsx"
});
const $2e86ec7ecdee93de$export$6d23a188bb96b7ab = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $2e86ec7ecdee93de$export$78ffe2f6530d45d1,
        pageId: "spa-apps/servicedesk/atlassian-analytics",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $16827de33e5c7c9a$export$3ec5c3d7729889b9 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("6ga5r"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-custom/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$16827de33e5c7c9a$export$2e2bcd8739ae039 = ({ match: match })=>{
    const reportType = match.params.reportType || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $16827de33e5c7c9a$export$3ec5c3d7729889b9,
        pageId: `spa-apps/servicedesk/reports/${reportType}`,
        shouldShowSpinner: true
    });
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $67cb0c7c9b4371f5$export$821b8201b24f8b7d = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("3gf8S"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-custom-create/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$67cb0c7c9b4371f5$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $67cb0c7c9b4371f5$export$821b8201b24f8b7d,
        pageId: "spa-apps/servicedesk/reports/custom/create",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $ae91bda248b14a12$export$53def03ace9a6c5b = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("flQ0B"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-custom-edit/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ae91bda248b14a12$export$2e2bcd8739ae039 = ({ match: match })=>{
    const { reportId: reportId } = match.params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $ae91bda248b14a12$export$53def03ace9a6c5b,
        pageId: `spa-apps/servicedesk/reports/custom/${reportId || ''}`,
        shouldShowSpinner: true
    });
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $27d48936eba74e39$export$c2f0d3c59c9d3bf3 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("bPFtz")), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-issue-view/src/index.tsx"
});
var /**
 * Dynamically constructs and renders a lazy-loaded page tailored to specific Servicedesk report views. By leveraging URL parameters such as issue key and timescale ID, it enhances user navigation within the Servicedesk environment by directly accommodating varied user inquiries and historical data perspectives.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$27d48936eba74e39$export$2e2bcd8739ae039 = ({ match: match })=>{
    const issueKey = `/${match.params && match.params.issueKey || ''}`;
    const timescaleId = `/${match.params && match.params.timescaleId || ''}`;
    const oldIssueView = `/${match.query && match.query.oldIssueView || ''}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $27d48936eba74e39$export$c2f0d3c59c9d3bf3,
        pageId: `spa-apps/servicedesk/reports/issue${issueKey}${timescaleId}${oldIssueView}`,
        shouldShowSpinner: true
    });
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $f3abba65b98481fb$export$f86e12b111395ad = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("3QjNh"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/kb-requests-reports/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f3abba65b98481fb$export$2e2bcd8739ae039 = ({ match: match })=>{
    const reportType = match.params.reportType || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $f3abba65b98481fb$export$f86e12b111395ad,
        pageId: `spa-apps/servicedesk/reports/${reportType}`,
        shouldShowSpinner: true
    });
};



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");


const $c3fd7ec3189cb801$export$8edc7b9d922cd22f = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("cYGRe"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-satisfaction/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c3fd7ec3189cb801$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $c3fd7ec3189cb801$export$8edc7b9d922cd22f,
        pageId: `spa-apps/servicedesk${(0, $d969dacb8f3e7e46$export$e4c007d05145b8c2)}}`,
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");


const $bf0505c82b3148c5$export$e805fb47fdcd991 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("e5bIK"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/reports-workload/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bf0505c82b3148c5$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $bf0505c82b3148c5$export$e805fb47fdcd991,
        pageId: `spa-apps/servicedesk${(0, $d969dacb8f3e7e46$export$ddc580d759168f88)}}`,
        shouldShowSpinner: true
    });


const $782d56965097df84$var$DefaultReportsRedirect = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
        to: `/jira/servicedesk/projects/${String(match.params.projectKey)}${(0, $d969dacb8f3e7e46$export$ddc580d759168f88)}`
    });
const $782d56965097df84$var$returnToSummary = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Redirect), {
        to: String(match.params['0'])
    });
const $782d56965097df84$var$getReportsWithKbResources = ()=>[
        ...(0, $kbHFR.getServicedeskPageContextResources)(),
        (0, $bbvOQ.kbConfluenceContextResource)
    ];
const $782d56965097df84$export$721a27be140cb34d = [
    (0, $apqRF.createEntry)((0, $5VjfX.servicedeskReportsSummaryRoute), {
        component: $782d56965097df84$var$returnToSummary,
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation)
        ]
    }),
    (0, $apqRF.createEntry)((0, $5VjfX.servicedeskReports1Route), {
        component: $782d56965097df84$var$DefaultReportsRedirect,
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...$782d56965097df84$var$getReportsWithKbResources(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation)
        ]
    }),
    (0, $apqRF.createEntry)((0, $5VjfX.servicedeskAtlassianAnalyticsRoute), {
        component: (0, $2e86ec7ecdee93de$export$6d23a188bb96b7ab),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $1iICl.servicedeskAtlassianAnalyticsResource),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $2e86ec7ecdee93de$export$78ffe2f6530d45d1)
        ],
        meta: {
            reporting: {
                id: (0, $frZnw.APP_NAMES).ATLASSIAN_ANALYTICS,
                packageName: (0, $frZnw.toPackageName)((0, $frZnw.APP_NAMES).ATLASSIAN_ANALYTICS),
                teamName: 'ITSM Saga'
            }
        }
    }),
    (0, $apqRF.createEntry)((0, $5VjfX.servicedeskReportsWorkloadRoute), {
        component: (0, $bf0505c82b3148c5$export$2e2bcd8739ae039),
        perfMetricKey: 'service-management.reports.workload',
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $bf0505c82b3148c5$export$e805fb47fdcd991)
        ]
    }),
    (0, $apqRF.createEntry)((0, $5VjfX.servicedeskReportsSatisfactionIssueRoute), {
        component: (0, $27d48936eba74e39$export$2e2bcd8739ae039),
        layout: (0, $isbb2.composeLayouts)((0, $csLgO.serviceProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)()),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $7JKBZ.newIssueViewLockInStatusResource),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $27d48936eba74e39$export$c2f0d3c59c9d3bf3)
        ],
        ufoName: 'service-management.reports.issue'
    }),
    (0, $apqRF.createEntry)((0, $5VjfX.servicedeskReportsSatisfactionTimeScaleRoute), {
        perfMetricKey: 'service-management.reports.satisfaction',
        component: (0, $c3fd7ec3189cb801$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $c3fd7ec3189cb801$export$8edc7b9d922cd22f)
        ]
    }),
    (0, $apqRF.createEntry)((0, $5VjfX.servicedeskReportsSatisfaction2Route), {
        perfMetricKey: 'service-management.reports.satisfaction',
        component: (0, $c3fd7ec3189cb801$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $c3fd7ec3189cb801$export$8edc7b9d922cd22f)
        ]
    }),
    (0, $apqRF.createEntry)((0, $5VjfX.servicedeskKbRequestsReportsIssueRoute), {
        component: (0, $27d48936eba74e39$export$2e2bcd8739ae039),
        layout: (0, $isbb2.composeLayouts)((0, $csLgO.serviceProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)()),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $7JKBZ.newIssueViewLockInStatusResource),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $27d48936eba74e39$export$c2f0d3c59c9d3bf3)
        ],
        ufoName: 'service-management.reports.issue'
    }),
    (0, $apqRF.createEntry)((0, $5VjfX.servicedeskKbRequestsReportsTimeScaleRoute), {
        perfMetricKey: 'service-management.reports.kb-requests',
        component: (0, $f3abba65b98481fb$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $f3abba65b98481fb$export$f86e12b111395ad)
        ]
    }),
    (0, $apqRF.createEntry)((0, $5VjfX.servicedeskKbRequestsReports2Route), {
        perfMetricKey: 'service-management.reports.kb-requests',
        component: (0, $f3abba65b98481fb$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $f3abba65b98481fb$export$f86e12b111395ad)
        ]
    }),
    (0, $apqRF.createEntry)((0, $5VjfX.servicedeskReportsCustomEditRoute), {
        perfMetricKey: 'service-management.reports.custom-edit-view',
        component: (0, $ae91bda248b14a12$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $ae91bda248b14a12$export$53def03ace9a6c5b)
        ]
    }),
    (0, $apqRF.createEntry)((0, $5VjfX.servicedeskReportsCustomCreateRoute), {
        perfMetricKey: 'service-management.reports.custom-create',
        component: (0, $67cb0c7c9b4371f5$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $67cb0c7c9b4371f5$export$821b8201b24f8b7d)
        ]
    }),
    (0, $apqRF.createEntry)((0, $5VjfX.servicedeskReportsCustomIssueRoute), {
        component: (0, $27d48936eba74e39$export$2e2bcd8739ae039),
        layout: (0, $isbb2.composeLayouts)((0, $csLgO.serviceProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)()),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $7JKBZ.newIssueViewLockInStatusResource),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        afterPaint: [
            (0, $56906cb72fe2b2c4$export$8c70dcc4643464f8)
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $27d48936eba74e39$export$c2f0d3c59c9d3bf3)
        ],
        ufoName: 'service-management.reports.issue'
    }),
    (0, $apqRF.createEntry)((0, $5VjfX.servicedeskReportsCustomTimeScaleRoute), {
        component: (0, $16827de33e5c7c9a$export$2e2bcd8739ae039),
        perfMetricKey: 'service-management.reports.custom',
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $16827de33e5c7c9a$export$3ec5c3d7729889b9)
        ],
        ufoName: 'service-management-custom-reports'
    }),
    (0, $apqRF.createEntry)((0, $5VjfX.servicedeskReportsCustom4Route), {
        component: (0, $16827de33e5c7c9a$export$2e2bcd8739ae039),
        perfMetricKey: 'service-management.reports.custom',
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $16827de33e5c7c9a$export$3ec5c3d7729889b9)
        ],
        ufoName: 'service-management-custom-reports'
    }),
    (0, $apqRF.createEntry)((0, $5VjfX.servicedeskReportsTypeRoute), {
        component: (0, $bcc6627efeceef63$export$2e2bcd8739ae039),
        layout: (0, $isbb2.composeLayouts)((0, $csLgO.serviceProjectLayout), (0, $71b4a5d883bcbfff$export$7b113174a456921a)([
            {
                params: [
                    {
                        key: 'issueKey'
                    }
                ]
            }
        ])),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...$782d56965097df84$var$getReportsWithKbResources(),
            (0, $7JKBZ.newIssueViewLockInStatusResource),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $bcc6627efeceef63$export$75e043cf7a4e3661)
        ]
    })
];
var $782d56965097df84$export$2e2bcd8739ae039 = (0, $bcc6627efeceef63$export$2e2bcd8739ae039);



var $cernH = parcelRequire("cernH");

var $7vTKl = parcelRequire("7vTKl");

var $iTYGl = parcelRequire("iTYGl");

var $apqRF = parcelRequire("apqRF");

var $dAKwA = parcelRequire("dAKwA");

var $hHrVM = parcelRequire("hHrVM");

var $kbHFR = parcelRequire("kbHFR");

var $7OtSy = parcelRequire("7OtSy");

var $csLgO = parcelRequire("csLgO");

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $35677c83952c16f3$export$7f4092c8e7b7d3ec = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("11The")), {
    moduleId: "./src/packages/spa-apps/servicedesk/service-create-modal-without-project-context/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$35677c83952c16f3$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $35677c83952c16f3$export$7f4092c8e7b7d3ec,
        pageId: "spa-apps/servicedesk/service-create-modal",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $9dbecc4d2dc84380$export$b154597f29589502 = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("1hd0H"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/service-details-with-project-context/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9dbecc4d2dc84380$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $9dbecc4d2dc84380$export$b154597f29589502,
        pageId: "spa-apps/servicedesk/service-details",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $8H1MT = parcelRequire("8H1MT");

var $59o4i = parcelRequire("59o4i");

const $405fe5f5e2d70961$export$ba1931edde0ce20c = (0, $7rh0R.lazyForPaint)(()=>(0, $8H1MT.markAsProductBundleReady)((parcelRequire("c25FR"))), {
    moduleId: "./src/packages/spa-apps/servicedesk/service-details-without-project-context/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$405fe5f5e2d70961$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $405fe5f5e2d70961$export$ba1931edde0ce20c,
        pageId: "spa-apps/servicedesk/service-details",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $bbadc13aef817010$export$8984aadca7e15d1 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("cqDek")), {
    moduleId: "./src/packages/spa-apps/servicedesk/service-update-modal-without-project-context/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bbadc13aef817010$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $bbadc13aef817010$export$8984aadca7e15d1,
        pageId: "spa-apps/servicedesk/service-update-modal",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $7619f4f66245ba69$export$4aa60213b3477cf6 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("f8m28")), {
    moduleId: "./src/packages/spa-apps/servicedesk/services-with-project-context/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7619f4f66245ba69$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $7619f4f66245ba69$export$4aa60213b3477cf6,
        pageId: "spa-apps/servicedesk/services",
        shouldShowSpinner: true
    });



var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $59o4i = parcelRequire("59o4i");

const $c30aeed1bf92a640$export$fc385e1392a8e28 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("jEo1H")), {
    moduleId: "./src/packages/spa-apps/servicedesk/services-without-project-context/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c30aeed1bf92a640$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $59o4i.LazyPage), {
        Page: $c30aeed1bf92a640$export$fc385e1392a8e28,
        pageId: "spa-apps/servicedesk/services",
        shouldShowSpinner: true
    });


const $3fde294f25225173$export$837d7aa221731e74 = [
    (0, $apqRF.createEntry)((0, $7OtSy.servicedeskServicesRoute), {
        ufoName: 'service-management.services',
        component: (0, $7619f4f66245ba69$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $7619f4f66245ba69$export$4aa60213b3477cf6)
        ]
    }),
    (0, $apqRF.createEntry)((0, $7OtSy.servicedeskServiceDetailsRoute), {
        ufoName: 'service-management.service-details',
        component: (0, $9dbecc4d2dc84380$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        navigation: {
            menuId: (0, $7vTKl.MENU_ID).PROJECTS,
            sidebar: (0, $iTYGl.default)
        },
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $9dbecc4d2dc84380$export$b154597f29589502)
        ]
    }),
    (0, $apqRF.createEntry)((0, $7OtSy.serviceDeskServicesWithoutProjectRoute), {
        ufoName: 'service-management.services-without-project',
        component: (0, $c30aeed1bf92a640$export$2e2bcd8739ae039),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $c30aeed1bf92a640$export$fc385e1392a8e28)
        ]
    }),
    (0, $apqRF.createEntry)((0, $7OtSy.serviceDeskServiceDetailsWithoutProjectRoute), {
        ufoName: 'service-management.service-details-without-project',
        component: (0, $405fe5f5e2d70961$export$2e2bcd8739ae039),
        resources: [
            ...(0, $hHrVM.getNavigationResources)(),
            (0, $dAKwA.getConsolidationStateResource)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $405fe5f5e2d70961$export$ba1931edde0ce20c)
        ]
    })
];
const $3fde294f25225173$export$27385b29970830e7 = [
    (0, $apqRF.createEntry)((0, $7OtSy.servicedeskServiceModalNewRoute), {
        component: (0, $35677c83952c16f3$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $35677c83952c16f3$export$7f4092c8e7b7d3ec)
        ]
    }),
    (0, $apqRF.createEntry)((0, $7OtSy.servicedeskServiceModalEditRoute), {
        component: (0, $bbadc13aef817010$export$2e2bcd8739ae039),
        layout: (0, $csLgO.serviceProjectLayout),
        resources: [
            ...(0, $kbHFR.getServiceDeskNavigationResources)(),
            ...(0, $kbHFR.getServicedeskPageContextResources)()
        ],
        forPaint: [
            (0, $cernH.LazyAtlassianNavigation),
            (0, $bbadc13aef817010$export$8984aadca7e15d1)
        ]
    })
];
const $3fde294f25225173$export$57d6fec357eb220c = [
    ...$3fde294f25225173$export$837d7aa221731e74,
    ...$3fde294f25225173$export$27385b29970830e7
];



var $7OtSy = parcelRequire("7OtSy");
const $4e5597a91c1b7a52$export$b4944bd787708b82 = [
    ...(0, $a254fc0ce0bc8828$export$f1453c3517242ca1),
    ...(0, $782d56965097df84$export$721a27be140cb34d),
    ...(0, $d0bc8c375af4b440$export$91a360c2f7f83db9),
    ...(0, $2d3841ea93833e60$export$97cc5f4d7ce032e1),
    ...(0, $72b362d5e9f1af01$export$abec122151c24b1b),
    ...(0, $3fde294f25225173$export$57d6fec357eb220c),
    ...(0, $b011af7098605060$export$6811a8ea7ba7651c),
    ...(0, $be3c302f353d15b5$export$7dd191d527f3ef6f),
    ...(0, $8c3a0add719ffed8$export$f32a63b509fcdb4f),
    ...(0, $897b4311b3dc269c$export$8e210af71fea11c9),
    ...(0, $37ff03730865f0e2$export$38a3aa80b813d565),
    ...(0, $08d75f6faff765b2$export$6e125037f42a1f62),
    ...(0, $c14f7e8a0471589a$export$5d38cb53852f589a),
    (0, $18d5247f51aff8ac$export$20ab3a955246df95),
    (0, $d9c2a0c15a2b974b$export$72138a83eeba68eb),
    (0, $f1fa06bfbcc25698$export$8810bfd4f6a0eb22),
    (0, $8ae74981a9e1a473$export$61ad481262acd4e6),
    (0, $2931ee7f95d0e303$export$ac25abe07ac3f570),
    (0, $7OtSy.serviceDeskServicesWithoutProjectRoute),
    (0, $7OtSy.serviceDeskServiceDetailsWithoutProjectRoute)
];


const $2f417e9628081c2f$export$d47aca795954578 = ()=>[
        ...(0, $d9c2a0c15a2b974b$export$b069a1c4b0240172),
        ...(0, $be75b82ac5d10c81$export$b1d92ac5cda62e7e),
        ...(0, $f730f07a676cc8e2$export$688b56fcbc2637ac),
        ...(0, $8605a99074da660f$export$44e0cb320cb148ed),
        ...(0, $6fe987b31d848aa1$export$23e1ab8ae95bd3a8),
        ...(0, $20af5c394dfc25a4$export$5b4e616b6b4b672a),
        ...(0, $048cfffd237f6510$export$fd0ef3739cde76c1),
        ...(0, $799769b2797678db$export$debd9f352e8a3e70),
        ...(0, $eb281330981e8e67$export$fb2091db9e7f9102),
        ...(0, $b4bce7e4d8567b3c$export$c9b96dd6f5a7b454),
        (0, $26cd51f541672008$export$f7d3667678a21360),
        (0, $b3df52e8783e1d6e$export$abd0bbe95839baf7),
        ...(0, $81a426de012c30b2$export$f9a1f59ec7d1f215),
        ...(0, $9556f709fc2a14de$export$fd3c71e3bfb4df9e)(),
        ...(0, $2719ac30f4e07b26$export$2763334cca1560d7),
        (0, $f020c38e81fdeaa8$export$e275b3ca0c6ccb5e),
        (0, $f020c38e81fdeaa8$export$cef770e7c16cfcc),
        (0, $e9de4186004550fb$export$703b5090da478c9c),
        (0, $ff06b8de8295ef68$export$415552b116808717),
        (0, $d068bdb5ccbe979b$export$769980c222432579),
        (0, $4f31ccd2cefdb1fe$export$578dcb61ac3cb57a),
        (0, $13903430967d785b$export$76b74d5744e69817),
        (0, $5e7adb561c10220c$export$5379c026da4201e6),
        (0, $c21644fb8a992f95$export$2740cfaa979353b9),
        (0, $7dbb3a67a6ba5746$export$ae258fb8ec2c1f86),
        (0, $621de40b0dd72f71$export$219b6cc00b2f91a0),
        (0, $6700056f9681aaf5$export$27d1f352c2f7acae),
        (0, $cbfac00f5b372876$export$4df9f9dcaf8565c9),
        (0, $6700056f9681aaf5$export$f52136d9a0848792),
        (0, $ec5f66b3062a483b$export$dc5f9e3c3931cc36),
        ...(0, $f0febcd6986df40f$export$445f7414e382a69c),
        (0, $5d62d367f9442e26$export$47b3bdf88a7d176b),
        (0, $cec0a7d4441930b4$export$5b0670f37204a43d),
        (0, $3637efef4b0c5bc2$export$e60f53ff5ae626cd),
        (0, $3637efef4b0c5bc2$export$25cf284456caeeef),
        (0, $dba4682a95e5bab0$export$72497f4e39dd0df4),
        (0, $3a69954879d67a4b$export$982bc443ef89cc3f),
        (0, $5a5a40256ffd86b1$export$28887e2da22c839a),
        (0, $00c9b0281306dc31$export$4791201b4877aa5d),
        (0, $ffed543118f23d13$export$babf32528ef518e9),
        (0, $ffed543118f23d13$export$6e8865417e6a38c),
        (0, $2dcde5e112eb5768$export$f128c1c4a1f0d631),
        (0, $2dcde5e112eb5768$export$924db6cf10ba8696),
        (0, $0307822c295b051f$export$9b0fdfd6a51a17de),
        (0, $0307822c295b051f$export$6009dd8e88f1a7de),
        (0, $0307822c295b051f$export$18226b6422149926),
        (0, $0307822c295b051f$export$73a377380ff671af),
        (0, $de6e961a6ca28e92$export$8dae8091f8e43b97),
        (0, $de6e961a6ca28e92$export$748e329bd0c282a),
        (0, $b5ce9d61d78c0c07$export$2a34d21ecf479c40),
        (0, $b5ce9d61d78c0c07$export$e78b34c999194638),
        (0, $042c6b2255f2865a$export$41fb3f2a3e68c7c3),
        (0, $042c6b2255f2865a$export$ca77bc660994f51f),
        (0, $042c6b2255f2865a$export$c2ec350ee9e78717),
        ...(0, $624e6e140f752e29$export$d604d3ad2662a845),
        (0, $0e750e81870ad8bd$export$36a7c374f4474cc1),
        (0, $e14bffeebd141c9d$export$8e015e39dbc90d0b),
        ...(0, $8ca12770b5795d94$export$f43cc215b47dd576),
        (0, $4cae923e7c81fee6$export$d83c2e469d070766),
        (0, $31538ea633950fb6$export$c68a412f25295511),
        (0, $5c5c328d1a0c046c$export$d1c67ceb7c5e2d6a),
        (0, $3dfca2b5a9cb36ce$export$56f9921db324f30),
        (0, $4adee587f623ba77$export$f9891419b34ab305),
        (0, $4497ae40fde48600$export$2f65b1ec4ed05f91),
        (0, $4497ae40fde48600$export$c62ca2d3fcc552a5),
        (0, $7b162697914d48c2$export$34d843946d3894aa),
        (0, $7b162697914d48c2$export$6d18fd46547afb8e),
        (0, $858ab70ef0ef29ff$export$461f2b06a7a914db),
        (0, $5c45641d0f476bbd$export$9cc9423a3967333b),
        (0, $706ea00b80585533$export$717e134eb971b450),
        (0, $ef3b2e76e978001d$export$3f8d7424a47f4dd),
        (0, $d04302cded51ff20$export$42ca979ec2919b23),
        (0, $d04302cded51ff20$export$d2ce6f09ef8aa840),
        (0, $5f3f0c448e8043d7$export$e18a6be3d2ffad71),
        (0, $f7decf7961ae87b9$export$5e1236665a530df4),
        (0, $20efdafd05df2f3a$export$773f8e3318be1dd5),
        (0, $d9a72e5e6bfe851d$export$80a3e4dda2dcd1a4),
        ...(0, $4e5597a91c1b7a52$export$b4944bd787708b82),
        (0, $6c41e52c48634921$export$45e68d450757a753),
        (0, $0307822c295b051f$export$ac09a8d3ecbafc5),
        (0, $0307822c295b051f$export$9fbbaafb58999ac3),
        (0, $0307822c295b051f$export$8018993ac33c65f3),
        (0, $0307822c295b051f$export$15f76f1b0d2d671),
        ...(0, $8ca12770b5795d94$export$189ae5546a081577),
        (0, $8ca12770b5795d94$export$2a24acea4e628148),
        (0, $8ca12770b5795d94$export$d751e3552b21c604),
        (0, $8ca12770b5795d94$export$f85a75f1604118ff),
        (0, $8ca12770b5795d94$export$9cbef73b51558ef),
        (0, $8ca12770b5795d94$export$e9cfdb950d40e917),
        (0, $8ca12770b5795d94$export$e71031acce6d7e47),
        (0, $8ca12770b5795d94$export$c2a4c5c6576a704c),
        (0, $0437c5d740028c1f$export$4f9df77811fbdc1f),
        ...(0, $723988f9339967b5$export$283761ff41b53cba),
        ...(0, $24ddbaaaf46634ea$export$a727cbd3cbcc2153),
        (0, $c7e50fdddf86bc76$export$66928ab349190059),
        (0, $c7e50fdddf86bc76$export$2b25520e20820251),
        ...(0, $a21bbc0ffd429ece$export$80002c8e4483fef1),
        ...(0, $2424a38c91d6dd07$export$5d3c7bc3dee8745d),
        (0, $ef6b20ae22882fd6$export$c058f4d1c0667ce1),
        ...(0, $0e57ebaaa2758857$export$de0b5a5b87cf45f3),
        ...(0, $2be3fd10da5a8d41$export$3a28949e52d2d60f),
        (0, $e108d633ec33a0c8$export$f1a859c727c30be4),
        (0, $e24a5dc60e9548ab$export$2c2d6115c4280a08),
        ...(0, $2ee957ede87673df$export$ed40a3967b4f2617),
        (0, $d6dfbe2316b32236$export$ac245212b12db871),
        (0, $d6dfbe2316b32236$export$8657ca08ca5cbfc6),
        (0, $413a11b1b14313fe$export$fee33ca9661e49dd),
        (0, $ae796711ad3c7e93$export$c2ced436a30c60dc),
        (0, $56a8577e9ca176db$export$6ff606556e19e12),
        ...(0, $ff5a93f464a3dafa$export$cf5b5978205b681),
        ...(0, $662505a58c71f074$export$1d5f1cc699ecefa3),
        (0, $146ce87c451e4c99$export$cd1c1a81e516fec5),
        (0, $497df763957e5b2d$export$9c9bab95d425eb6f),
        (0, $836b69bb0e37d149$export$c51a4ee3e3f1b270),
        (0, $1052eb222a330200$export$6a7fc41fb2523290),
        (0, $1052eb222a330200$export$6d6efd297963f785),
        (0, $c0323c6c8a564bae$export$8b55e723205ec5f3),
        (0, $70b0ad18f4a8155d$export$c4c012a49b465e94),
        (0, $4edc8bb5aeebf389$export$faa46f8c5e1f06d3),
        // [WARNING]: This route should be the last route.
        // This route redirects to the monolith for all routes we cannot match.
        // It is purposefully missing a path so it always matches and therefore needs to be last.
        // [WARNING]: Please don't add a new route below this. If you want to add, please contact the package owner team.
        (0, $aa194b628782eb2f$export$27f123cb9320355)
    ];
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $2f417e9628081c2f$var$rawRoutes = $2f417e9628081c2f$export$d47aca795954578();
const $2f417e9628081c2f$export$2f7745f2f5ab3897 = ()=>// filter out possible duplicate resources
    // route properties can be `getter`. Use object.assign instead of object spread to delay retrieving property if it's `getter`.
    $2f417e9628081c2f$var$rawRoutes.map((route)=>{
        const resources = [
            ...new Set(route.resources)
        ];
        return Object.assign(route, {
            resources: resources
        });
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2f417e9628081c2f$var$isPathBasedRoute(route) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Boolean(route.path);
}
const $2f417e9628081c2f$export$6ca4f07048df7206 = ()=>$2f417e9628081c2f$export$d47aca795954578().filter($2f417e9628081c2f$var$isPathBasedRoute) // Required for static routes webpack plugin due to dynamic paths
    .map(({ earlyAssets: earlyAssets, entryPoint: entryPoint, exact: exact, forPaint: forPaint, group: group, meta: meta, name: name, path: path, preloadOptions: preloadOptions, query: query })=>({
            earlyAssets: earlyAssets,
            entryPoint: entryPoint,
            exact: exact,
            forPaint: forPaint,
            group: group,
            meta: meta,
            name: name,
            path: path,
            preloadOptions: preloadOptions,
            query: query
        }));



var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $78Ywx = parcelRequire("78Ywx");

var $8blac = parcelRequire("8blac");

var $ieRGA = parcelRequire("ieRGA");

var $6rW04 = parcelRequire("6rW04");

var $kJlBc = parcelRequire("kJlBc");

var $7BDEW = parcelRequire("7BDEW");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ba619299535bad37$export$c9d44c736471c518 = (name)=>document.querySelector(`meta[name="${name}"]`);
const $ba619299535bad37$var$getHead = ()=>document.head || document.querySelector('head');
const $ba619299535bad37$export$c79fd820617d7f = (name, content)=>{
    if (!name || !content) return;
    const existingMeta = $ba619299535bad37$export$c9d44c736471c518(name);
    const meta = document.createElement('meta');
    meta.name = name;
    meta.content = content;
    if (existingMeta) existingMeta.parentNode?.replaceChild(existingMeta, meta);
    else {
        const head = $ba619299535bad37$var$getHead();
        if (head) head.appendChild(meta);
    }
};
const $ba619299535bad37$export$4267657a25105d9d = (name)=>{
    const meta = $ba619299535bad37$export$c9d44c736471c518(name);
    if (meta) meta.parentNode?.removeChild(meta);
};



var $cprue = parcelRequire("cprue");
const $36d7090ac0dde683$var$sessionQueryParams = [
    'searchSessionId',
    'searchObjectId',
    'searchContainerId',
    'searchContentType'
];
const $36d7090ac0dde683$var$sessionMeta = [
    'ajs-search-session-id',
    'ajs-search-object-id',
    'ajs-search-container-id',
    'ajs-search-content-type'
];
const $36d7090ac0dde683$var$removeDwellComponent = (placeholderId)=>{
    if (placeholderId && document.getElementById(placeholderId)) // @ts-expect-error - TS2345 - Argument of type 'HTMLElement | null' is not assignable to parameter of type 'Element | DocumentFragment'.
    (0, $lEfVV.unmountComponentAtNode)(document.getElementById(placeholderId));
};
const $36d7090ac0dde683$var$removeSessionMeta = ()=>$36d7090ac0dde683$var$sessionMeta.forEach((0, $ba619299535bad37$export$4267657a25105d9d));
// @ts-expect-error - TS7031 - Binding element 'sessionId' implicitly has an 'any' type. | TS7031 - Binding element 'objectId' implicitly has an 'any' type. | TS7031 - Binding element 'containerId' implicitly has an 'any' type. | TS7031 - Binding element 'objectType' implicitly has an 'any' type.
const $36d7090ac0dde683$var$addSessionMeta = ({ sessionId: sessionId, objectId: objectId, containerId: containerId, objectType: objectType })=>{
    const newMeta = {
        'ajs-search-session-id': sessionId,
        'ajs-search-object-id': objectId,
        'ajs-search-container-id': containerId,
        'ajs-search-content-type': objectType
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries(newMeta).forEach(([name, content])=>(0, $ba619299535bad37$export$c79fd820617d7f)(name, content));
};
const $36d7090ac0dde683$var$getPreviousSessionId = ()=>(0, $6rW04.default)('ajs-search-session-id');
class $36d7090ac0dde683$export$f1e582dddb502dd6 extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.onClearSessionEvent = ()=>{
            if (this.state.shouldRemoveSessionBeIgnored) this.setState({
                shouldRemoveSessionBeIgnored: false
            });
        };
        this.onHistoryChange = (location)=>{
            $36d7090ac0dde683$var$removeDwellComponent('search-dwell-time');
            const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($78Ywx))).parse(location.pathname + location.search, true);
            const queryString = parsedUrl.query || {};
            const { searchSessionId: searchSessionId, searchObjectId: searchObjectId, searchContainerId: searchContainerId, searchContentType: searchContentType } = queryString;
            const { path: path } = parsedUrl;
            const previousSessionId = $36d7090ac0dde683$var$getPreviousSessionId();
            const { shouldRemoveSessionBeIgnored: shouldRemoveSessionBeIgnored } = this.state;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(previousSessionId) && !shouldRemoveSessionBeIgnored) $36d7090ac0dde683$var$removeSessionMeta();
            if (searchSessionId) {
                (0, $ieRGA.default)($36d7090ac0dde683$var$sessionQueryParams);
                const newState = {
                    sessionId: searchSessionId,
                    objectId: searchObjectId,
                    objectType: searchContentType,
                    containerId: searchContainerId,
                    previousSessionId: $36d7090ac0dde683$var$getPreviousSessionId()
                };
                $36d7090ac0dde683$var$addSessionMeta(newState);
                const shouldRemoveSession = !!(0, $cprue.skipClearSessionURLs).find((skipUrlRegex)=>!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(path) ? skipUrlRegex.test(path) : false);
                // @ts-expect-error - TS2345 - Argument of type '{ shouldRemoveSessionBeIgnored: boolean; sessionId: string | string[]; objectId: string | string[] | undefined; objectType: string | string[] | undefined; containerId: string | string[] | undefined; previousSessionId: string | null; }' is not assignable to parameter of type 'State | ((prevState: Readonly<State>, props: Readonly<Props>) => State | Pick<State, "containerId" | "objectType" | "objectId" | "sessionId" | "previousSessionId" | "shouldRemoveSessionBeIgnored"> | null) | Pick<...> | null'.
                this.setState({
                    ...newState,
                    shouldRemoveSessionBeIgnored: shouldRemoveSession
                });
            }
        };
        this.props.history.listen(this.onHistoryChange);
        this.state = {
            shouldRemoveSessionBeIgnored: false,
            sessionId: ''
        };
    }
    componentDidMount() {
        window.addEventListener((0, $cprue.CLEAR_SEARCH_SESSION), this.onClearSessionEvent);
    }
    componentWillUnmount() {
        window.removeEventListener((0, $cprue.CLEAR_SEARCH_SESSION), this.onClearSessionEvent);
    }
    render() {
        if (this.state && this.state.sessionId) {
            const { objectId: objectId, containerId: containerId, objectType: objectType, sessionId: sessionId, previousSessionId: previousSessionId } = this.state;
            const data = {
                objectId: objectId,
                containerId: containerId,
                objectType: objectType,
                source: objectType,
                actionSubject: objectType,
                attributes: {
                    previousSessionId: previousSessionId
                }
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7BDEW.default), {
                sessionId: sessionId,
                data: data
            });
        }
        return null;
    }
}
var $36d7090ac0dde683$export$2e2bcd8739ae039 = (0, $kJlBc.withRouter)($36d7090ac0dde683$export$f1e582dddb502dd6);



var $2B87Z = parcelRequire("2B87Z");
const $ce0678b5063705cb$export$ce440b3d0fa0d5ed = ()=>{
    if (false) return;
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('early-flush', 'ssr.spa.early-common-flush:start', 'ssr.spa.early-route-flush:end');
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/common-preload', 'ssr.spa.early-common-flush:start', 'ssr.spa.metatags:start');
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/metatags', 'ssr.spa.metatags:start', 'ssr.spa.metatags:end');
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/feature-flags', 'ssr.spa.feature-flags:start', 'ssr.spa.feature-flags:end');
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/inline-scripts', 'ssr.spa.feature-flags:end', 'ssr.spa.early-common-flush:end');
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/route-preload', 'ssr.spa.early-route-flush:start', 'ssr.spa.early-route-flush:end');
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('css-assets', 'ssr.spa.css-assets:start', 'ssr.spa.css-assets:end');
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('ssr-output', 'ssr.spa.start', 'ssr.spa.state');
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('ssr-output/styles', 'ssr.spa.start', 'ssr.spa.styles');
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('ssr-output/html', 'ssr.spa.styles', 'ssr.spa.html');
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('ssr-output/state', 'ssr.spa.html', 'ssr.spa.state');
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('pre-spa', 'vendor-entry.js:eval-start', 'commons-entry.js:eval-stop');
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('pre-spa/vendor', 'vendor-entry.js:eval-start', 'vendor-entry.js:eval-stop');
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('pre-spa/commons', 'vendor-entry.js:eval-stop', 'commons-entry.js:eval-stop');
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('pre-spa/commons/bundle-ready', 'vendor-entry.js:eval-stop', 'commons-entry.js:eval-start');
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('pre-spa/commons/eval', 'commons-entry.js:eval-start', 'commons-entry.js:eval-stop');
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa/bundle-ready', 'commons-entry.js:eval-stop', 'jira-spa.js:eval-start');
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa/language-pack', 'jira-spa/language-pack.start', 'jira-spa/language-pack.end', true, true);
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
};


var $2B87Z = parcelRequire("2B87Z");

var $4ea83 = parcelRequire("4ea83");
/* eslint-disable no-await-in-loop */ 
var $gUUjF = parcelRequire("gUUjF");

var $kJlBc = parcelRequire("kJlBc");
const $be11b329f399dd87$var$LOCATION = 'spa.create-spa-history';
const $be11b329f399dd87$var$createCustomHistoryBlock = (routeBlockFns, routes, history)=>(blockFn)=>{
        const matchedRoute = (0, $kJlBc.matchRoute)(routes, history.location.pathname, // @ts-expect-error - wrong type of matchRoute (it accepts query param as string)
        history.location.search);
        // This should never be the case as in SPA we have a default route
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        if (!matchedRoute) return ()=>{};
        if (!routeBlockFns.includes(blockFn)) routeBlockFns.push(blockFn);
        // returns an "unregister" block
        return ()=>{
            const idx = routeBlockFns.indexOf(blockFn);
            if (idx !== -1) routeBlockFns.splice(idx, 1);
        };
    };
const $be11b329f399dd87$var$createSpaHistory = (routes)=>{
    const routeBlockFns = [];
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    let blockArgs = [];
    let nextMatchedRoute;
    const history = (0, $kJlBc.createBrowserHistory)({
        /* We abuse this api to allow us to run as many blockers as we want, allowing the transition
		 * to resume only when all return true or bail out as soon as the first one returns false */ getUserConfirmation: async (__, done)=>{
            try {
                const matchedRoute = (0, $kJlBc.matchRoute)(routes, history.location.pathname, // @ts-expect-error - wrong type of matchRoute (it accepts query param as string)
                history.location.search);
                // This should never be the case as in SPA we have a default route
                if (!matchedRoute || !nextMatchedRoute) return done(true);
                /* We reverse loop block functions as we want the ones registered later to run first
				 * (respecing the render tree: Route > Page > Form > ...)
				 * we also do it serially, so if the last registed returns false we do not call the others */ for(let i = routeBlockFns.length - 1; i >= 0; i -= 1){
                    const result = await routeBlockFns[i](...blockArgs);
                    if (result === false) return done(false);
                }
                /* After running we clean up the blockers */ routeBlockFns.length = 0;
                return done(true);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                (0, $gUUjF.default).safeErrorWithoutCustomerData($be11b329f399dd87$var$LOCATION, 'Error with getUserConfirmation', err);
                return done(true);
            }
        }
    });
    /* We set the main "blocker", that is also used enable next location access in getUserConfirmation
	 * (going around getUserConfirmation API limitations) */ history.block((location, action)=>{
        blockArgs = [
            location,
            action
        ];
        nextMatchedRoute = (0, $kJlBc.matchRoute)(routes, location.pathname, // @ts-expect-error - wrong type of matchRoute (it accepts query param as string)
        location.search);
        // Must return a string or getUserConfirmation is not called
        return '';
    });
    // @ts-expect-error - type mismatch with TransitionPromptHook
    history.block = $be11b329f399dd87$var$createCustomHistoryBlock(routeBlockFns, routes, history);
    return history;
};
var /**
 * Monkey patches the push/replace methods of the react router history object to
 * perform a full page refresh instead of history push/replace when a route is not valid
 * (i.e. legacy pages). This is required to fix the browser back button not working correctly
 * after redirecting to a legacy page.
 * JSPA-900
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$be11b329f399dd87$export$2e2bcd8739ae039 = (routes)=>$be11b329f399dd87$var$createSpaHistory(routes);



var $fGHk2 = parcelRequire("fGHk2");

var $iE8ll = parcelRequire("iE8ll");

var $jK1pm = parcelRequire("jK1pm");

var $4nnPJ = parcelRequire("4nnPJ");


var $3F0y8 = parcelRequire("3F0y8");

var $ULuRM = parcelRequire("ULuRM");

var $5TiXm = parcelRequire("5TiXm");

var $foPCo = parcelRequire("foPCo");
const $077123d74a10e7f8$var$isPreprodSlow = ()=>(0, $1ybV0.getFeatureFlagValue)('uip.preprod.slow', 0);
(0, $6iz4v.setMark)('JIRA_SPA_ENTRY_LOADED');
// Set SPA global
window.__SPA__ = true;
(0, $7rh0R.default).init({
    mode: (0, $7rh0R.MODE).RENDER,
    crossOrigin: 'anonymous'
});
const $077123d74a10e7f8$var$tenantContext = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
(0, $6iz4v.setMark)('jira-spa/language-pack.start');

var $7KGHt = parcelRequire("7KGHt");
(0, $6iz4v.setMark)('jira-spa/language-pack.end');
const { locale: $077123d74a10e7f8$var$locale, baseUrl: $077123d74a10e7f8$var$baseUrl } = $077123d74a10e7f8$var$tenantContext;
const $077123d74a10e7f8$var$superbatchInit = ()=>{
    window.DeferScripts = {
        deferState: 'done'
    };
    document.body && document.body.classList.remove('deferred');
};
const $077123d74a10e7f8$var$globalSettingsArgs = {
    navigation: false,
    upflow: false
};
const $077123d74a10e7f8$var$InstallGlobalComponentsOnce = ()=>{
    (0, $eUqFw.useEffect)(()=>{
        (0, $foPCo.default).installLowPriorityApps(// @ts-expect-error - TS2345 - Argument of type 'Partial<{ readonly navigation: false; readonly upflow: false; }>' is not assignable to parameter of type 'LowPriorityAppsArgs'.
        (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))($077123d74a10e7f8$var$globalSettingsArgs, [
            'flags',
            'navigation',
            'renderNavigation'
        ]));
        (0, $6iz4v.setMark)('JIRA_SPA_ENTRY_GLOBAL_INSTALL');
    }, []);
    return null;
};
const $077123d74a10e7f8$var$updateCapability = (capability)=>{
    (0, $gXgRp.setCapability)(capability);
    if (capability === null && window.AJS?.$?.ajaxSettings?.headers?.[0, $d07297a4af13004b$export$9a80695e72849f84]) delete window.AJS.$.ajaxSettings.headers[0, $d07297a4af13004b$export$9a80695e72849f84];
    else window.AJS?.$?.ajaxSetup({
        headers: {
            [(0, $d07297a4af13004b$export$9a80695e72849f84)]: capability
        }
    });
};
// @ts-expect-error - TS7031 - Binding element 'routes' implicitly has an 'any' type.
const $077123d74a10e7f8$var$CapabilityTrackerConnector = ({ routes: routes })=>{
    const { registerBlock: registerBlock } = (0, $kJlBc.useRouterActions)();
    registerBlock((nextLocation)=>{
        const nextMatchObject = (0, $kJlBc.matchRoute)(routes, nextLocation.pathname, // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'Query | undefined'.
        nextLocation.search, $077123d74a10e7f8$var$baseUrl);
        $077123d74a10e7f8$var$updateCapability(nextMatchObject?.route.meta?.capability || null);
        return true;
    });
    const route = (0, $10fdS.useCurrentRoute)();
    $077123d74a10e7f8$var$updateCapability(route.meta?.capability || null);
    return null;
};
const $077123d74a10e7f8$var$main = async ()=>{
    (0, $3e9543de6b0f3240$export$2e2bcd8739ae039)();
    (0, $iE8ll.default)();
    (0, $a5pCl.initBrowserMetrics3)();
    (0, $00f2fa4abeba3937$export$2d291317456ada16)();
    (0, $ce0678b5063705cb$export$ce440b3d0fa0d5ed)();
    (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/init', 'jira-spa.js:eval-start');
    (0, $6iz4v.setMark)('jira-spa/setup.start');
    const routes = (0, $2B87Z.measureInitialPageLoadTiming)('jira-spa/setup/routes', ()=>(0, $2f417e9628081c2f$export$2f7745f2f5ab3897)());
    const history = (0, $2B87Z.measureInitialPageLoadTiming)('jira-spa/setup/history', ()=>(0, $be11b329f399dd87$export$2e2bcd8739ae039)(routes));
    const initRoute = (0, $2B87Z.measureInitialPageLoadTiming)('jira-spa/setup/match-route', ()=>{
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'Query | undefined'.
        const matchedRoute = (0, $kJlBc.matchRoute)(routes, window.location.pathname, window.location.search);
        (0, $keguF.setMatchedRoute)(matchedRoute?.route, matchedRoute?.match);
        return matchedRoute;
    });
    if (initRoute != null) {
        const ufoName = (0, $b54f7e90dd5ce65f$export$2e2bcd8739ae039)(initRoute.route);
        (0, $3F0y8.default)(ufoName, initRoute.route.name);
    }
    const BrowserMetricsConnector = ()=>{
        const route = (0, $10fdS.useCurrentRoute)();
        (0, $acbV3.browserMetrics).setRoute(route.name);
        (0, $ULuRM.useUFOTransitionCompleter)();
        if ((0, $1ybV0.ff)('uip.ufo')) (0, $4nnPJ.GlobalPageLoadExperience).setPageLoadId(route.perfMetricKey || 'UNKNOWN');
        return null;
    };
    if ((0, $1ybV0.ff)('uip.ufo')) (0, $4nnPJ.GlobalPageLoadExperience).startPageLoad('UNKNOWN', true);
    const routerProps = {
        history: history,
        routes: routes,
        basePath: $077123d74a10e7f8$var$baseUrl,
        initialRoute: initRoute?.route,
        resourceData: window.SPA_STATE,
        resourceContext: (0, $fGHk2.getSpaRouterContext)({
            tenantContext: $077123d74a10e7f8$var$tenantContext
        }),
        onPrefetch: ({ route: route, match: match })=>{
            (0, $4ea83.setPrefetchStartMark)(match);
            if (!route.forPaint) return;
            route.forPaint.map((component)=>component.preload && component.preload());
        }
    };
    const SpaClientRouter = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e9XeX.JiraRouter), routerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: "spa-main.client-router",
            packageName: "jiraEntry",
            fallback: "unmount",
            teamName: "delorean-spa"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(BrowserMetricsConnector, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($077123d74a10e7f8$var$CapabilityTrackerConnector, {
            routes: routes
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $36d7090ac0dde683$export$2e2bcd8739ae039), null)), children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6U1dF.NonCritical), {
            id: "spa-main.client-router.non-critical",
            teamName: "delorean-spa"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($077123d74a10e7f8$var$InstallGlobalComponentsOnce, null)));
    const App = ({ placeholders: placeholders })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $geFaw.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
            name: "jira-spa"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8R80x.EntryPointPlaceholderContext).Provider, {
            value: placeholders
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $37f6df81ea368cad$export$6d4069f4b64f7492), {
            baseUrl: $077123d74a10e7f8$var$baseUrl,
            locale: $077123d74a10e7f8$var$locale,
            messages: $7KGHt,
            Router: SpaClientRouter,
            initRoute: initRoute,
            routes: routes,
            routerLinkComponent: (0, $MIkHq.JiraRouterLinkConfiguration)
        }))));
    // This block of code allows the JNR Chrome Extension to call the routerProps.history.push() function.
    if ((0, $1ybV0.ff)('jira-nav-refresh-experimental-router-access-for-issue-blu-2082_7i3kn')) window.addEventListener('message', (event)=>{
        // We only accept messages from ourselves
        if (!(event.source === window && event.data?.source === 'JNRPlugin')) return;
        const href = event.data.data || '';
        if (href.startsWith('/')) routerProps.history.push(href);
        else try {
            const url = new URL(href);
            routerProps.history.push(`${url.pathname}${url.search}${url.hash}`);
        } catch (e) {
        /* invalid url */ }
    }, false);
    window.__NAV_VERSION__ = '3.0.0';
    (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/setup', 'jira-spa/setup.start', true);
    (0, $6iz4v.setMark)('_jira-spa/spa-shell.start');
    const container = document.getElementById('jira-frontend');
    if (container) {
        if ((0, $1ybV0.ff)('uip.vc.partial', false)) {
            (0, $5TiXm.getVCObserver)().setSSRElement(container);
            (0, $5TiXm.getVCObserver)().setReactRootRenderStart();
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    (0, $5TiXm.getVCObserver)().setReactRootRenderStop();
                });
            });
        }
        const placeholders = (0, $8R80x.getPlaceholdersFromHTML)();
        // if the feature flag is false, do not opt into concurrent features
        // if the local env var is not set, or set to false, do not opt into concurrent features
        if (!(0, $1ybV0.ff)('jfp.magma.concurrent-root.jira-spa') && true) (0, $lEfVV.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(App, {
            placeholders: placeholders
        }), container);
        if ((0, $1ybV0.ff)('jfp.magma.concurrent-root.jira-spa')) {
            const root = (0, $gpO36.createRoot)(container);
            root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(App, {
                placeholders: placeholders
            }));
        }
    }
    (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/spa-shell', '_jira-spa/spa-shell.start');
    (0, $6iz4v.setMark)('JIRA_SPA_ENTRY_REACT_DOM_RENDER');
    setTimeout(()=>{
        (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa', 'commons-entry.js:eval-stop', 'jira-spa.js:eval-stop');
    });
    if ($077123d74a10e7f8$var$isPreprodSlow() > 0) {
        (0, $6iz4v.setMark)('slow-start');
        const end = performance.now() + $077123d74a10e7f8$var$isPreprodSlow();
        while(performance.now() < end);
        (0, $6iz4v.setMark)('slow-stop');
    }
    (0, $foPCo.default).installHighPriorityApps(// @ts-expect-error - TS2345 - Argument of type 'Partial<{ readonly navigation: false; readonly upflow: false; }>' is not assignable to parameter of type 'HighPriorityAppsArgs'.
    (0, (/*@__PURE__*/$parcel$interopDefault($8dloj)))($077123d74a10e7f8$var$globalSettingsArgs, [
        'flags',
        'navigation',
        'renderNavigation'
    ]));
    $077123d74a10e7f8$var$superbatchInit();
    return null;
};
$077123d74a10e7f8$var$main().catch((reason)=>(0, $0507482b123635a1$export$a5c16644a2d3c205)(reason));
 }, ["eNmuD","dsiAd","hPzOn","2Lfdl","1QYl5","561Jq","i5RRW","92sUi","ekVbM","bCeK4","2hmUs","bYT2S","h2MrD","lknvU"]);

$parcel$global.rlb("bz9bg")
//# sourceMappingURL=jira-spa.f5a2154a.js.map
